
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired3a3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired3a3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bR5nk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iCUQP"));

});
parcelRegister("iCUQP", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d8f7e006a9b4ef5d$export$ffb0004e005737fa; }, function (v) { return $d8f7e006a9b4ef5d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d8f7e006a9b4ef5d$export$34b9dba7ce09269b; }, function (v) { return $d8f7e006a9b4ef5d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d8f7e006a9b4ef5d$export$25062201e9e25d76; }, function (v) { return $d8f7e006a9b4ef5d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d8f7e006a9b4ef5d$export$ffb0004e005737fa;
var $d8f7e006a9b4ef5d$export$34b9dba7ce09269b;
var $d8f7e006a9b4ef5d$export$25062201e9e25d76;
"use strict";

(function() {
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function jsxDEVImpl(type, config, maybeKey, isStaticChildren, debugStack, debugTask) {
        var children = config.children;
        if (void 0 !== children) {
            if (isStaticChildren) {
                if (isArrayImpl(children)) {
                    for(isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)validateChildKeys(children[isStaticChildren]);
                    Object.freeze && Object.freeze(children);
                } else console.error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            } else validateChildKeys(children);
        }
        if (hasOwnProperty.call(config, "key")) {
            children = getComponentNameFromType(type);
            var keys = Object.keys(config).filter(function(k) {
                return "key" !== k;
            });
            isStaticChildren = 0 < keys.length ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            didWarnAboutKeySpread[children + isStaticChildren] || (keys = 0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}", console.error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', isStaticChildren, children, keys, children), didWarnAboutKeySpread[children + isStaticChildren] = !0);
        }
        children = null;
        void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
        hasValidKey(config) && (checkKeyStringCoercion(config.key), children = "" + config.key);
        if ("key" in config) {
            maybeKey = {};
            for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
        } else maybeKey = config;
        children && defineKeyPropWarningGetter(maybeKey, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        return ReactElement(type, children, maybeKey, getOwner(), debugStack, debugTask);
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React = (parcelRequire("spJKX")), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    React = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React.react_stack_bottom_frame.bind(React, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    $d8f7e006a9b4ef5d$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $d8f7e006a9b4ef5d$export$34b9dba7ce09269b = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        if (trackActualOwner) {
            var previousStackTraceLimit = Error.stackTraceLimit;
            Error.stackTraceLimit = 10;
            var debugStackDEV = Error("react-stack-top-frame");
            Error.stackTraceLimit = previousStackTraceLimit;
        } else debugStackDEV = unknownOwnerDebugStack;
        return jsxDEVImpl(type, config, maybeKey, !1, debugStackDEV, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    $d8f7e006a9b4ef5d$export$25062201e9e25d76 = function(type, config, maybeKey) {
        var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
        if (trackActualOwner) {
            var previousStackTraceLimit = Error.stackTraceLimit;
            Error.stackTraceLimit = 10;
            var debugStackDEV = Error("react-stack-top-frame");
            Error.stackTraceLimit = previousStackTraceLimit;
        } else debugStackDEV = unknownOwnerDebugStack;
        return jsxDEVImpl(type, config, maybeKey, !0, debugStackDEV, trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
})();

});
parcelRegister("spJKX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8i9jX"));

});
parcelRegister("8i9jX", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                console.warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
            }
        });
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function warnNoop(publicInstance, callerName) {
        publicInstance = (publicInstance = publicInstance.constructor) && (publicInstance.displayName || publicInstance.name) || "ReactClass";
        var warningKey = publicInstance + "." + callerName;
        didWarnStateUpdateForUnmountedComponent[warningKey] || (console.error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, publicInstance), didWarnStateUpdateForUnmountedComponent[warningKey] = !0);
    }
    function Component(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function ComponentDummy() {}
    function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context;
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        try {
            testStringCoercion(value);
            var JSCompiler_inline_result = !1;
        } catch (e) {
            JSCompiler_inline_result = !0;
        }
        if (JSCompiler_inline_result) {
            JSCompiler_inline_result = console;
            var JSCompiler_temp_const = JSCompiler_inline_result.error;
            var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
            JSCompiler_temp_const.call(JSCompiler_inline_result, "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", JSCompiler_inline_result$jscomp$0);
            return testStringCoercion(value);
        }
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getTaskName(type) {
        if (type === REACT_FRAGMENT_TYPE) return "<>";
        if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE) return "<...>";
        try {
            var name = getComponentNameFromType(type);
            return name ? "<" + name + ">" : "<...>";
        } catch (x) {
            return "<...>";
        }
    }
    function getOwner() {
        var dispatcher = ReactSharedInternals.A;
        return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
        return Error("react-stack-top-frame");
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return !1;
        }
        return void 0 !== config.key;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        function warnAboutAccessingKey() {
            specialPropKeyWarningShown || (specialPropKeyWarningShown = !0, console.error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)", displayName));
        }
        warnAboutAccessingKey.isReactWarning = !0;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: !0
        });
    }
    function elementRefGetterWithDeprecationWarning() {
        var componentName = getComponentNameFromType(this.type);
        didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = !0, console.error("Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."));
        componentName = this.props.ref;
        return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props, owner, debugStack, debugTask) {
        var refProp = props.ref;
        type = {
            $$typeof: REACT_ELEMENT_TYPE,
            type: type,
            key: key,
            props: props,
            _owner: owner
        };
        null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
            enumerable: !1,
            get: elementRefGetterWithDeprecationWarning
        }) : Object.defineProperty(type, "ref", {
            enumerable: !1,
            value: null
        });
        type._store = {};
        Object.defineProperty(type._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: 0
        });
        Object.defineProperty(type, "_debugInfo", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: null
        });
        Object.defineProperty(type, "_debugStack", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugStack
        });
        Object.defineProperty(type, "_debugTask", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: debugTask
        });
        Object.freeze && (Object.freeze(type.props), Object.freeze(type));
        return type;
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        newKey = ReactElement(oldElement.type, newKey, oldElement.props, oldElement._owner, oldElement._debugStack, oldElement._debugTask);
        oldElement._store && (newKey._store.validated = oldElement._store.validated);
        return newKey;
    }
    function validateChildKeys(node) {
        isValidElement(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement(object) {
        return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function escape(key) {
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        return "$" + key.replace(/[=:]/g, function(match) {
            return escaperLookup[match];
        });
    }
    function getElementKey(element, index) {
        return "object" === typeof element && null !== element && null != element.key ? (checkKeyStringCoercion(element.key), escape("" + element.key)) : index.toString(36);
    }
    function resolveThenable(thenable) {
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenable.reason;
            default:
                switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                    "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
                }, function(error) {
                    "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                })), thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenable.reason;
                }
        }
        throw thenable;
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if ("undefined" === type || "boolean" === type) children = null;
        var invokeCallback = !1;
        if (null === children) invokeCallback = !0;
        else switch(type){
            case "bigint":
            case "string":
            case "number":
                invokeCallback = !0;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = !0;
                        break;
                    case REACT_LAZY_TYPE:
                        return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
                }
        }
        if (invokeCallback) {
            invokeCallback = children;
            callback = callback(invokeCallback);
            var childKey = "" === nameSoFar ? "." + getElementKey(invokeCallback, 0) : nameSoFar;
            isArrayImpl(callback) ? (escapedPrefix = "", null != childKey && (escapedPrefix = childKey.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
                return c;
            })) : null != callback && (isValidElement(callback) && (null != callback.key && (invokeCallback && invokeCallback.key === callback.key || checkKeyStringCoercion(callback.key)), escapedPrefix = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || invokeCallback && invokeCallback.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + childKey), "" !== nameSoFar && null != invokeCallback && isValidElement(invokeCallback) && null == invokeCallback.key && invokeCallback._store && !invokeCallback._store.validated && (escapedPrefix._store.validated = 2), callback = escapedPrefix), array.push(callback));
            return 1;
        }
        invokeCallback = 0;
        childKey = "" === nameSoFar ? "." : nameSoFar + ":";
        if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = childKey + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if (i = getIteratorFn(children), "function" === typeof i) for(i === children.entries && (didWarnAboutMaps || console.warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0), children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = childKey + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
        else if ("object" === type) {
            if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
            array = String(children);
            throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
        }
        return invokeCallback;
    }
    function mapChildren(children, func, context) {
        if (null == children) return children;
        var result = [], count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    function lazyInitializer(payload) {
        if (-1 === payload._status) {
            var resolveDebugValue = null, rejectDebugValue = null, ioInfo = payload._ioInfo;
            null != ioInfo && (ioInfo.start = ioInfo.end = performance.now(), ioInfo.value = new Promise(function(resolve, reject) {
                resolveDebugValue = resolve;
                rejectDebugValue = reject;
            }));
            ioInfo = payload._result;
            var thenable = ioInfo();
            thenable.then(function(moduleObject) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 1;
                    payload._result = moduleObject;
                    var _ioInfo = payload._ioInfo;
                    if (null != _ioInfo) {
                        _ioInfo.end = performance.now();
                        var debugValue = null == moduleObject ? void 0 : moduleObject.default;
                        resolveDebugValue(debugValue);
                        _ioInfo.value.status = "fulfilled";
                        _ioInfo.value.value = debugValue;
                    }
                    void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
                }
            }, function(error) {
                if (0 === payload._status || -1 === payload._status) {
                    payload._status = 2;
                    payload._result = error;
                    var _ioInfo2 = payload._ioInfo;
                    null != _ioInfo2 && (_ioInfo2.end = performance.now(), _ioInfo2.value.then(noop, noop), rejectDebugValue(error), _ioInfo2.value.status = "rejected", _ioInfo2.value.reason = error);
                    void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
                }
            });
            ioInfo = payload._ioInfo;
            if (null != ioInfo) {
                var displayName = thenable.displayName;
                "string" === typeof displayName && (ioInfo.name = displayName);
            }
            -1 === payload._status && (payload._status = 0, payload._result = thenable);
        }
        if (1 === payload._status) return ioInfo = payload._result, void 0 === ioInfo && console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", ioInfo), "default" in ioInfo || console.error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", ioInfo), ioInfo.default;
        throw payload._result;
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(scope) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(noop, reportGlobalError));
        } catch (error) {
            reportGlobalError(error);
        } finally{
            null === prevTransition && currentTransition._updatedFibers && (scope = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < scope && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.")), null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    }
    function addTransitionType(type) {
        var transition = ReactSharedInternals.T;
        if (null !== transition) {
            var transitionTypes = transition.types;
            null === transitionTypes ? transition.types = [
                type
            ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
        } else 0 === ReactSharedInternals.asyncTransitions && console.error("addTransitionType can only be called inside a `startTransition()` callback. It must be associated with a specific Transition."), startTransition(addTransitionType.bind(null, type));
    }
    function enqueueTask(task) {
        if (null === enqueueTaskImpl) try {
            var requireString = ("require" + Math.random()).slice(0, 7);
            enqueueTaskImpl = (module && module[requireString]).call(module, "timers").setImmediate;
        } catch (_err) {
            enqueueTaskImpl = function(callback) {
                !1 === didWarnAboutMessageChannel && (didWarnAboutMessageChannel = !0, "undefined" === typeof MessageChannel && console.error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(void 0);
            };
        }
        return enqueueTaskImpl(task);
    }
    function aggregateErrors(errors) {
        return 1 < errors.length && "function" === typeof AggregateError ? new AggregateError(errors) : errors[0];
    }
    function popActScope(prevActQueue, prevActScopeDepth) {
        prevActScopeDepth !== actScopeDepth - 1 && console.error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactSharedInternals.actQueue;
        if (null !== queue) {
            if (0 !== queue.length) try {
                flushActQueue(queue);
                enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                });
                return;
            } catch (error) {
                ReactSharedInternals.thrownErrors.push(error);
            }
            else ReactSharedInternals.actQueue = null;
        }
        0 < ReactSharedInternals.thrownErrors.length ? (queue = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(queue)) : resolve(returnValue);
    }
    function flushActQueue(queue) {
        if (!isFlushing) {
            isFlushing = !0;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do {
                        ReactSharedInternals.didUsePromise = !1;
                        var continuation = callback(!1);
                        if (null !== continuation) {
                            if (ReactSharedInternals.didUsePromise) {
                                queue[i] = callback;
                                queue.splice(0, i);
                                return;
                            }
                            callback = continuation;
                        } else break;
                    }while (1);
                }
                queue.length = 0;
            } catch (error) {
                queue.splice(0, i + 1), ReactSharedInternals.thrownErrors.push(error);
            } finally{
                isFlushing = !1;
            }
        }
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, didWarnStateUpdateForUnmountedComponent = {}, ReactNoopUpdateQueue = {
        isMounted: function() {
            return !1;
        },
        enqueueForceUpdate: function(publicInstance) {
            warnNoop(publicInstance, "forceUpdate");
        },
        enqueueReplaceState: function(publicInstance) {
            warnNoop(publicInstance, "replaceState");
        },
        enqueueSetState: function(publicInstance) {
            warnNoop(publicInstance, "setState");
        }
    }, assign = Object.assign, emptyObject = {};
    Object.freeze(emptyObject);
    Component.prototype.isReactComponent = {};
    Component.prototype.setState = function(partialState, callback) {
        if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    for(fnName in deprecatedAPIs)deprecatedAPIs.hasOwnProperty(fnName) && defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    ComponentDummy.prototype = Component.prototype;
    deprecatedAPIs = PureComponent.prototype = new ComponentDummy();
    deprecatedAPIs.constructor = PureComponent;
    assign(deprecatedAPIs, Component.prototype);
    deprecatedAPIs.isPureReactComponent = !0;
    var isArrayImpl = Array.isArray, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
    }, hasOwnProperty = Object.prototype.hasOwnProperty, createTask = console.createTask ? console.createTask : function() {
        return null;
    };
    deprecatedAPIs = {
        react_stack_bottom_frame: function(callStackForError) {
            return callStackForError();
        }
    };
    var specialPropKeyWarningShown, didWarnAboutOldJSXRuntime;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = deprecatedAPIs.react_stack_bottom_frame.bind(deprecatedAPIs, UnknownOwner)();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutMaps = !1, userProvidedKeyEscapeRegex = /\/+/g, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, didWarnAboutMessageChannel = !1, enqueueTaskImpl = null, actScopeDepth = 0, didWarnNoAwaitAct = !1, isFlushing = !1, queueSeveralMicrotasks = "function" === typeof queueMicrotask ? function(callback) {
        queueMicrotask(function() {
            return queueMicrotask(callback);
        });
    } : enqueueTask;
    deprecatedAPIs = Object.freeze({
        __proto__: null,
        c: function(size) {
            return resolveDispatcher().useMemoCache(size);
        }
    });
    var fnName = {
        map: mapChildren,
        forEach: function(children, forEachFunc, forEachContext) {
            mapChildren(children, function() {
                forEachFunc.apply(this, arguments);
            }, forEachContext);
        },
        count: function(children) {
            var n = 0;
            mapChildren(children, function() {
                n++;
            });
            return n;
        },
        toArray: function(children) {
            return mapChildren(children, function(child) {
                return child;
            }) || [];
        },
        only: function(children) {
            if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
            return children;
        }
    };
    exports.Activity = REACT_ACTIVITY_TYPE;
    exports.Children = fnName;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.ViewTransition = REACT_VIEW_TRANSITION_TYPE;
    exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
    exports.__COMPILER_RUNTIME = deprecatedAPIs;
    exports.act = function(callback) {
        var prevActQueue = ReactSharedInternals.actQueue, prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        var queue = ReactSharedInternals.actQueue = null !== prevActQueue ? prevActQueue : [], didAwaitActCall = !1;
        try {
            var result = callback();
        } catch (error) {
            ReactSharedInternals.thrownErrors.push(error);
        }
        if (0 < ReactSharedInternals.thrownErrors.length) throw popActScope(prevActQueue, prevActScopeDepth), callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        if (null !== result && "object" === typeof result && "function" === typeof result.then) {
            var thenable = result;
            queueSeveralMicrotasks(function() {
                didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
            });
            return {
                then: function(resolve, reject) {
                    didAwaitActCall = !0;
                    thenable.then(function(returnValue) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        if (0 === prevActScopeDepth) {
                            try {
                                flushActQueue(queue), enqueueTask(function() {
                                    return recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                                });
                            } catch (error$0) {
                                ReactSharedInternals.thrownErrors.push(error$0);
                            }
                            if (0 < ReactSharedInternals.thrownErrors.length) {
                                var _thrownError = aggregateErrors(ReactSharedInternals.thrownErrors);
                                ReactSharedInternals.thrownErrors.length = 0;
                                reject(_thrownError);
                            }
                        } else resolve(returnValue);
                    }, function(error) {
                        popActScope(prevActQueue, prevActScopeDepth);
                        0 < ReactSharedInternals.thrownErrors.length ? (error = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, reject(error)) : reject(error);
                    });
                }
            };
        }
        var returnValue$jscomp$0 = result;
        popActScope(prevActQueue, prevActScopeDepth);
        0 === prevActScopeDepth && (flushActQueue(queue), 0 !== queue.length && queueSeveralMicrotasks(function() {
            didAwaitActCall || didWarnNoAwaitAct || (didWarnNoAwaitAct = !0, console.error("A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"));
        }), ReactSharedInternals.actQueue = null);
        if (0 < ReactSharedInternals.thrownErrors.length) throw callback = aggregateErrors(ReactSharedInternals.thrownErrors), ReactSharedInternals.thrownErrors.length = 0, callback;
        return {
            then: function(resolve, reject) {
                didAwaitActCall = !0;
                0 === prevActScopeDepth ? (ReactSharedInternals.actQueue = queue, enqueueTask(function() {
                    return recursivelyFlushAsyncActWork(returnValue$jscomp$0, resolve, reject);
                })) : resolve(returnValue$jscomp$0);
            }
        };
    };
    exports.addTransitionType = addTransitionType;
    exports.cache = function(fn) {
        return function() {
            return fn.apply(null, arguments);
        };
    };
    exports.cacheSignal = function() {
        return null;
    };
    exports.captureOwnerStack = function() {
        var getCurrentStack = ReactSharedInternals.getCurrentStack;
        return null === getCurrentStack ? null : getCurrentStack();
    };
    exports.cloneElement = function(element, config, children) {
        if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
        var props = assign({}, element.props), key = element.key, owner = element._owner;
        if (null != config) {
            var JSCompiler_inline_result;
            a: {
                if (hasOwnProperty.call(config, "ref") && (JSCompiler_inline_result = Object.getOwnPropertyDescriptor(config, "ref").get) && JSCompiler_inline_result.isReactWarning) {
                    JSCompiler_inline_result = !1;
                    break a;
                }
                JSCompiler_inline_result = void 0 !== config.ref;
            }
            JSCompiler_inline_result && (owner = getOwner());
            hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key);
            for(propName in config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
        }
        var propName = arguments.length - 2;
        if (1 === propName) props.children = children;
        else if (1 < propName) {
            JSCompiler_inline_result = Array(propName);
            for(var i = 0; i < propName; i++)JSCompiler_inline_result[i] = arguments[i + 2];
            props.children = JSCompiler_inline_result;
        }
        props = ReactElement(element.type, key, props, owner, element._debugStack, element._debugTask);
        for(key = 2; key < arguments.length; key++)validateChildKeys(arguments[key]);
        return props;
    };
    exports.createContext = function(defaultValue) {
        defaultValue = {
            $$typeof: REACT_CONTEXT_TYPE,
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
            Provider: null,
            Consumer: null
        };
        defaultValue.Provider = defaultValue;
        defaultValue.Consumer = {
            $$typeof: REACT_CONSUMER_TYPE,
            _context: defaultValue
        };
        defaultValue._currentRenderer = null;
        defaultValue._currentRenderer2 = null;
        return defaultValue;
    };
    exports.createElement = function(type, config, children) {
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i]);
        var propName;
        i = {};
        var key = null;
        if (null != config) for(propName in didWarnAboutOldJSXRuntime || !("__self" in config) || "key" in config || (didWarnAboutOldJSXRuntime = !0, console.warn("Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform")), hasValidKey(config) && (checkKeyStringCoercion(config.key), key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (i[propName] = config[propName]);
        var childrenLength = arguments.length - 2;
        if (1 === childrenLength) i.children = children;
        else if (1 < childrenLength) {
            for(var childArray = Array(childrenLength), _i = 0; _i < childrenLength; _i++)childArray[_i] = arguments[_i + 2];
            Object.freeze && Object.freeze(childArray);
            i.children = childArray;
        }
        if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === i[propName] && (i[propName] = childrenLength[propName]);
        key && defineKeyPropWarningGetter(i, "function" === typeof type ? type.displayName || type.name || "Unknown" : type);
        (propName = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++) ? (childArray = Error.stackTraceLimit, Error.stackTraceLimit = 10, childrenLength = Error("react-stack-top-frame"), Error.stackTraceLimit = childArray) : childrenLength = unknownOwnerDebugStack;
        return ReactElement(type, key, i, getOwner(), childrenLength, propName ? createTask(getTaskName(type)) : unknownOwnerDebugTask);
    };
    exports.createRef = function() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    };
    exports.forwardRef = function(render) {
        null != render && render.$$typeof === REACT_MEMO_TYPE ? console.error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : "function" !== typeof render ? console.error("forwardRef requires a render function but was given %s.", null === render ? "null" : typeof render) : 0 !== render.length && 2 !== render.length && console.error("forwardRef render functions accept exactly two parameters: props and ref. %s", 1 === render.length ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        null != render && null != render.defaultProps && console.error("forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?");
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        }, ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                render.name || render.displayName || (Object.defineProperty(render, "name", {
                    value: name
                }), render.displayName = name);
            }
        });
        return elementType;
    };
    exports.isValidElement = isValidElement;
    exports.lazy = function(ctor) {
        ctor = {
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: ctor,
            _init: lazyInitializer
        }, ioInfo = {
            name: "lazy",
            start: -1,
            end: -1,
            value: null,
            owner: null,
            debugStack: Error("react-stack-top-frame"),
            debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        ctor._ioInfo = ioInfo;
        lazyType._debugInfo = [
            {
                awaited: ioInfo
            }
        ];
        return lazyType;
    };
    exports.memo = function(type, compare) {
        null == type && console.error("memo: The first argument must be a component. Instead received: %s", null === type ? "null" : typeof type);
        compare = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: void 0 === compare ? null : compare
        };
        var ownName;
        Object.defineProperty(compare, "displayName", {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                type.name || type.displayName || (Object.defineProperty(type, "name", {
                    value: name
                }), type.displayName = name);
            }
        });
        return compare;
    };
    exports.startTransition = startTransition;
    exports.unstable_useCacheRefresh = function() {
        return resolveDispatcher().useCacheRefresh();
    };
    exports.use = function(usable) {
        return resolveDispatcher().use(usable);
    };
    exports.useActionState = function(action, initialState, permalink) {
        return resolveDispatcher().useActionState(action, initialState, permalink);
    };
    exports.useCallback = function(callback, deps) {
        return resolveDispatcher().useCallback(callback, deps);
    };
    exports.useContext = function(Context) {
        var dispatcher = resolveDispatcher();
        Context.$$typeof === REACT_CONSUMER_TYPE && console.error("Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?");
        return dispatcher.useContext(Context);
    };
    exports.useDebugValue = function(value, formatterFn) {
        return resolveDispatcher().useDebugValue(value, formatterFn);
    };
    exports.useDeferredValue = function(value, initialValue) {
        return resolveDispatcher().useDeferredValue(value, initialValue);
    };
    exports.useEffect = function(create, deps) {
        null == create && console.warn("React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useEffect(create, deps);
    };
    exports.useEffectEvent = function(callback) {
        return resolveDispatcher().useEffectEvent(callback);
    };
    exports.useId = function() {
        return resolveDispatcher().useId();
    };
    exports.useImperativeHandle = function(ref, create, deps) {
        return resolveDispatcher().useImperativeHandle(ref, create, deps);
    };
    exports.useInsertionEffect = function(create, deps) {
        null == create && console.warn("React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useInsertionEffect(create, deps);
    };
    exports.useLayoutEffect = function(create, deps) {
        null == create && console.warn("React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?");
        return resolveDispatcher().useLayoutEffect(create, deps);
    };
    exports.useMemo = function(create, deps) {
        return resolveDispatcher().useMemo(create, deps);
    };
    exports.useOptimistic = function(passthrough, reducer) {
        return resolveDispatcher().useOptimistic(passthrough, reducer);
    };
    exports.useReducer = function(reducer, initialArg, init) {
        return resolveDispatcher().useReducer(reducer, initialArg, init);
    };
    exports.useRef = function(initialValue) {
        return resolveDispatcher().useRef(initialValue);
    };
    exports.useState = function(initialState) {
        return resolveDispatcher().useState(initialState);
    };
    exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
        return resolveDispatcher().useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    };
    exports.useTransition = function() {
        return resolveDispatcher().useTransition();
    };
    exports.version = "19.3.1";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});




parcelRegister("ae9tk", function(module, exports) {

$parcel$export(module.exports, "AxiosError", function () { return $77228f2167276cb4$export$c1fbed17c2f6a328; });
$parcel$export(module.exports, "isAxiosError", function () { return $77228f2167276cb4$export$fbafdbe06a5b5a9a; });
$parcel$export(module.exports, "HttpStatusCode", function () { return $77228f2167276cb4$export$a972f69c851492b3; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("lCyBC")).default; });

var $lCyBC = parcelRequire("lCyBC");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $77228f2167276cb4$export$1c00760e9e5a4e95, AxiosError: $77228f2167276cb4$export$c1fbed17c2f6a328, CanceledError: $77228f2167276cb4$export$1ab0c6b20d94fa14, isCancel: $77228f2167276cb4$export$3b22524397b493c6, CancelToken: $77228f2167276cb4$export$fd08e3cb425f0d61, VERSION: $77228f2167276cb4$export$a4ad2735b021c132, all: $77228f2167276cb4$export$84bf76cd7afc7469, Cancel: $77228f2167276cb4$export$848c9b7ead0df967, isAxiosError: $77228f2167276cb4$export$fbafdbe06a5b5a9a, spread: $77228f2167276cb4$export$3ae0fd4797ed47c8, toFormData: $77228f2167276cb4$export$10ae0d317ea97f8b, AxiosHeaders: $77228f2167276cb4$export$4e7d6ff0f3e6520, HttpStatusCode: $77228f2167276cb4$export$a972f69c851492b3, formToJSON: $77228f2167276cb4$export$86d7c59254d6a2c9, getAdapter: $77228f2167276cb4$export$17ddc20a97d669e2, mergeConfig: $77228f2167276cb4$export$7ec1ebcfa9d8bd6a, create: $77228f2167276cb4$export$185802fd694ee1f5 } = (0, $lCyBC.default);

});
parcelRegister("lCyBC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbd7fd9717dc9ec0$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $5CtH8 = parcelRequire("5CtH8");

var $1s6oO = parcelRequire("1s6oO");

var $aZNCn = parcelRequire("aZNCn");

var $4hvqU = parcelRequire("4hvqU");

var $CVDVT = parcelRequire("CVDVT");

var $fTjDq = parcelRequire("fTjDq");

var $3sfVr = parcelRequire("3sfVr");

var $ckJjs = parcelRequire("ckJjs");

var $leIjU = parcelRequire("leIjU");

var $7160o = parcelRequire("7160o");

var $3BlWa = parcelRequire("3BlWa");

var $hWCvB = parcelRequire("hWCvB");

var $a1ZvZ = parcelRequire("a1ZvZ");

var $klzwS = parcelRequire("klzwS");

var $c4h6w = parcelRequire("c4h6w");

var $4DC2S = parcelRequire("4DC2S");
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $fbd7fd9717dc9ec0$var$createInstance(defaultConfig) {
    const context = new (0, $1s6oO.default)(defaultConfig);
    const instance = (0, $5CtH8.default)((0, $1s6oO.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $lnoYZ.default).extend(instance, (0, $1s6oO.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $lnoYZ.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $fbd7fd9717dc9ec0$var$createInstance((0, $aZNCn.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $fbd7fd9717dc9ec0$var$axios = $fbd7fd9717dc9ec0$var$createInstance((0, $4hvqU.default));
// Expose Axios class to allow class inheritance
$fbd7fd9717dc9ec0$var$axios.Axios = (0, $1s6oO.default);
// Expose Cancel & CancelToken
$fbd7fd9717dc9ec0$var$axios.CanceledError = (0, $fTjDq.default);
$fbd7fd9717dc9ec0$var$axios.CancelToken = (0, $3sfVr.default);
$fbd7fd9717dc9ec0$var$axios.isCancel = (0, $ckJjs.default);
$fbd7fd9717dc9ec0$var$axios.VERSION = (0, $leIjU.VERSION);
$fbd7fd9717dc9ec0$var$axios.toFormData = (0, $7160o.default);
// Expose AxiosError class
$fbd7fd9717dc9ec0$var$axios.AxiosError = (0, $3BlWa.default);
// alias for CanceledError for backward compatibility
$fbd7fd9717dc9ec0$var$axios.Cancel = $fbd7fd9717dc9ec0$var$axios.CanceledError;
// Expose all/spread
$fbd7fd9717dc9ec0$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$fbd7fd9717dc9ec0$var$axios.spread = (0, $hWCvB.default);
// Expose isAxiosError
$fbd7fd9717dc9ec0$var$axios.isAxiosError = (0, $a1ZvZ.default);
// Expose mergeConfig
$fbd7fd9717dc9ec0$var$axios.mergeConfig = (0, $aZNCn.default);
$fbd7fd9717dc9ec0$var$axios.AxiosHeaders = (0, $klzwS.default);
$fbd7fd9717dc9ec0$var$axios.formToJSON = (thing)=>(0, $CVDVT.default)((0, $lnoYZ.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$fbd7fd9717dc9ec0$var$axios.getAdapter = (0, $c4h6w.default).getAdapter;
$fbd7fd9717dc9ec0$var$axios.HttpStatusCode = (0, $4DC2S.default);
$fbd7fd9717dc9ec0$var$axios.default = $fbd7fd9717dc9ec0$var$axios;
var // this module should only have a default export
$fbd7fd9717dc9ec0$export$2e2bcd8739ae039 = $fbd7fd9717dc9ec0$var$axios;

});
parcelRegister("lnoYZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8ff200145f985aa$export$2e2bcd8739ae039; });

var $5CtH8 = parcelRequire("5CtH8");
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $f8ff200145f985aa$var$toString } = Object.prototype;
const { getPrototypeOf: $f8ff200145f985aa$var$getPrototypeOf } = Object;
const { iterator: $f8ff200145f985aa$var$iterator, toStringTag: $f8ff200145f985aa$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $f8ff200145f985aa$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
const $f8ff200145f985aa$var$isUnsafeObjectKey = (prop)=>typeof prop === 'string' && (prop === '__proto__' || prop === 'constructor' || prop === 'prototype');
/**
 * Determine whether an inherited object must be treated as a shared-prototype
 * boundary. Cross-realm Object.prototype objects cannot be distinguished
 * reliably from application-created null-prototype objects because their
 * properties are mutable, so all inherited terminal prototypes are excluded
 * as a fail-closed boundary. A null-prototype source still keeps its own
 * properties, as produced by mergeConfig and other safe materialization paths.
 *
 * @param {*} obj The object to inspect
 * @param {*} prototype The object's prototype
 * @param {boolean} source Whether obj is the original traversal source
 *
 * @returns {boolean} True when obj is a safe prototype traversal boundary
 */ const $f8ff200145f985aa$var$isPrototypeBoundary = (obj, prototype, source)=>obj === Object.prototype || !source && prototype === null;
/**
 * Determine whether an object can retain its identity through code paths that
 * add, replace, and remove config properties without bypassing unsafe-key
 * filtering. Immutable objects, unsafe-key-bearing objects, and objects with
 * accessor or restricted data properties must be materialized instead.
 *
 * @param {*} obj The object to inspect
 *
 * @returns {boolean} True when every own property is safe and fully mutable
 */ const $f8ff200145f985aa$var$isSafeAndFullyMutable = (obj)=>{
    if (!Object.isExtensible(obj)) return false;
    const props = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(obj));
    return props.every((prop)=>{
        if ($f8ff200145f985aa$var$isUnsafeObjectKey(prop)) return false;
        const descriptor = Object.getOwnPropertyDescriptor(obj, prop);
        return !!descriptor && descriptor.configurable && descriptor.writable === true;
    });
};
/**
 * Walk the prototype chain (excluding the source realm's Object.prototype)
 * looking for an own `prop`. This distinguishes genuine own/inherited members
 * — including class accessors and template prototypes — from members injected
 * via Object.prototype pollution (e.g. `Object.prototype.username = '...'`),
 * which live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $f8ff200145f985aa$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        const prototype = $f8ff200145f985aa$var$getPrototypeOf(obj);
        if ($f8ff200145f985aa$var$isPrototypeBoundary(obj, prototype, obj === thing)) return false;
        if ($f8ff200145f985aa$var$hasOwnProperty(obj, prop)) return true;
        obj = prototype;
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $f8ff200145f985aa$var$getSafeProp = (obj, prop)=>obj != null && $f8ff200145f985aa$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
/**
 * Flatten an object and its application-defined prototype chain into a
 * null-prototype object. Members inherited only from the source realm's
 * Object.prototype are deliberately excluded, while class/template members
 * below that boundary are preserved.
 *
 * @param {*} thing The value to flatten
 *
 * @returns {*} A null-prototype copy, or the original value when it is already
 * structurally safe or is not an object
 */ const $f8ff200145f985aa$var$toSafeFlatObject = (thing)=>{
    if (thing == null || typeof thing !== 'object' && typeof thing !== 'function') return thing;
    const sourcePrototype = $f8ff200145f985aa$var$getPrototypeOf(thing);
    if (sourcePrototype === null && $f8ff200145f985aa$var$isSafeAndFullyMutable(thing)) return thing;
    const result = Object.create(null);
    const merged = Object.create(null);
    const seen = [];
    let current = thing;
    while(current != null){
        if (seen.indexOf(current) !== -1) break;
        seen.push(current);
        const prototype = current === thing ? sourcePrototype : $f8ff200145f985aa$var$getPrototypeOf(current);
        if ($f8ff200145f985aa$var$isPrototypeBoundary(current, prototype, current === thing)) break;
        const props = Object.getOwnPropertyNames(current);
        if (Object.getOwnPropertySymbols) props.push(...Object.getOwnPropertySymbols(current));
        for (const prop of props){
            if ($f8ff200145f985aa$var$isUnsafeObjectKey(prop)) continue;
            if (!$f8ff200145f985aa$var$hasOwnProperty(merged, prop)) {
                result[prop] = thing[prop];
                merged[prop] = true;
            }
        }
        current = prototype;
    }
    return result;
};
const $f8ff200145f985aa$var$kindOf = ((cache)=>(thing)=>{
        const str = $f8ff200145f985aa$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $f8ff200145f985aa$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$f8ff200145f985aa$var$kindOf(thing) === type;
};
const $f8ff200145f985aa$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $f8ff200145f985aa$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $f8ff200145f985aa$var$isUndefined = $f8ff200145f985aa$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $f8ff200145f985aa$var$isBuffer(val) {
    return val !== null && !$f8ff200145f985aa$var$isUndefined(val) && val.constructor !== null && !$f8ff200145f985aa$var$isUndefined(val.constructor) && $f8ff200145f985aa$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $f8ff200145f985aa$var$isArrayBuffer = $f8ff200145f985aa$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $f8ff200145f985aa$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $f8ff200145f985aa$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $f8ff200145f985aa$var$isString = $f8ff200145f985aa$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $f8ff200145f985aa$var$isFunction = $f8ff200145f985aa$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $f8ff200145f985aa$var$isNumber = $f8ff200145f985aa$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $f8ff200145f985aa$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $f8ff200145f985aa$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $f8ff200145f985aa$var$isPlainObject = (val)=>{
    if (!$f8ff200145f985aa$var$isObject(val)) return false;
    const prototype = $f8ff200145f985aa$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $f8ff200145f985aa$var$getPrototypeOf(prototype) === null) && // Treat own Symbol.toStringTag or Symbol.iterator members as evidence the
    // value is tagged/iterable, ignoring members reachable only through shared
    // or terminal prototype boundaries. This is exactly what
    // hasOwnInPrototypeChain(val, prop) computes here: every prototype admitted
    // above (null, Object.prototype, or a terminal null-prototype template) is
    // a boundary, so the walk never inspects anything but `val`'s own members,
    // and stops before even those when `val` is itself the boundary
    // Object.prototype. Checking that inline avoids allocating the walker's
    // `seen` list twice per call on the mergeConfig / merge hot path.
    ($f8ff200145f985aa$var$isPrototypeBoundary(val, prototype, true) || !$f8ff200145f985aa$var$hasOwnProperty(val, $f8ff200145f985aa$var$toStringTag) && !$f8ff200145f985aa$var$hasOwnProperty(val, $f8ff200145f985aa$var$iterator));
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $f8ff200145f985aa$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$f8ff200145f985aa$var$isObject(val) || $f8ff200145f985aa$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $f8ff200145f985aa$var$isDate = $f8ff200145f985aa$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $f8ff200145f985aa$var$isFile = $f8ff200145f985aa$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $f8ff200145f985aa$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $f8ff200145f985aa$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $f8ff200145f985aa$var$isBlob = $f8ff200145f985aa$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $f8ff200145f985aa$var$isFileList = $f8ff200145f985aa$var$kindOfTest('FileList');
const $f8ff200145f985aa$var$isSet = $f8ff200145f985aa$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $f8ff200145f985aa$var$isStream = (val)=>$f8ff200145f985aa$var$isObject(val) && $f8ff200145f985aa$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $f8ff200145f985aa$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $f8ff200145f985aa$var$G = $f8ff200145f985aa$var$getGlobal();
const $f8ff200145f985aa$var$FormDataCtor = typeof $f8ff200145f985aa$var$G.FormData !== 'undefined' ? $f8ff200145f985aa$var$G.FormData : undefined;
const $f8ff200145f985aa$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($f8ff200145f985aa$var$FormDataCtor && thing instanceof $f8ff200145f985aa$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $f8ff200145f985aa$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$f8ff200145f985aa$var$isFunction(thing.append)) return false;
    const kind = $f8ff200145f985aa$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $f8ff200145f985aa$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $f8ff200145f985aa$var$isURLSearchParams = $f8ff200145f985aa$var$kindOfTest('URLSearchParams');
const [$f8ff200145f985aa$var$isReadableStream, $f8ff200145f985aa$var$isRequest, $f8ff200145f985aa$var$isResponse, $f8ff200145f985aa$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($f8ff200145f985aa$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $f8ff200145f985aa$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $f8ff200145f985aa$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($f8ff200145f985aa$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($f8ff200145f985aa$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $f8ff200145f985aa$var$findKey(obj, key) {
    if ($f8ff200145f985aa$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $f8ff200145f985aa$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $f8ff200145f985aa$var$isContextDefined = (context)=>!$f8ff200145f985aa$var$isUndefined(context) && context !== $f8ff200145f985aa$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $f8ff200145f985aa$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $f8ff200145f985aa$var$isContextDefined(this) && this || {};
    const result = {};
    // Caseless lookup only applies to string keys — symbol keys are
    // identity-matched. Every string key that reaches `result` passes through
    // this index first, so it can never hold two case variants of one key and a
    // lowercase -> key map is exactly what findKey(result, key) would rescan
    // Object.keys(result) for on each assignment.
    const lowerCaseKeys = caseless ? Object.create(null) : null;
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        let targetKey = key;
        if (lowerCaseKeys && typeof key === 'string') {
            const lowerKey = key.toLowerCase();
            const knownKey = lowerCaseKeys[lowerKey];
            // A key recorded but absent from `result` was skipped by skipUndefined;
            // the later spelling wins then, as it does for findKey.
            if (knownKey !== undefined && $f8ff200145f985aa$var$hasOwnProperty(result, knownKey)) targetKey = knownKey;
            else lowerCaseKeys[lowerKey] = key;
        }
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $f8ff200145f985aa$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($f8ff200145f985aa$var$isPlainObject(existing) && $f8ff200145f985aa$var$isPlainObject(val)) result[targetKey] = $f8ff200145f985aa$var$merge(existing, val);
        else if ($f8ff200145f985aa$var$isPlainObject(val)) result[targetKey] = $f8ff200145f985aa$var$merge({}, val);
        else if ($f8ff200145f985aa$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$f8ff200145f985aa$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $f8ff200145f985aa$var$isBuffer(source)) continue;
        $f8ff200145f985aa$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $f8ff200145f985aa$var$isArray(source) || !Object.getOwnPropertySymbols) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($f8ff200145f985aa$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $f8ff200145f985aa$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $f8ff200145f985aa$var$forEach(b, (val, key)=>{
        if (thisArg && $f8ff200145f985aa$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $5CtH8.default)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $f8ff200145f985aa$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $f8ff200145f985aa$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $f8ff200145f985aa$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $f8ff200145f985aa$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $f8ff200145f985aa$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $f8ff200145f985aa$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($f8ff200145f985aa$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!Number.isSafeInteger(i) || i < 0 || i > 0xffffffff) return null;
    // Bound the copy by actual indexed properties, including hidden and inherited
    // members of array-like collections, rather than by the declared length alone.
    const indexes = new Set();
    const seen = new Set();
    let source = thing;
    while(source != null && indexes.size < i){
        if (seen.has(source)) return null;
        seen.add(source);
        const prototype = $f8ff200145f985aa$var$getPrototypeOf(source);
        if ($f8ff200145f985aa$var$isPrototypeBoundary(source, prototype, source === thing)) break;
        Object.getOwnPropertyNames(source).forEach((key)=>{
            const index = +key;
            if (Number.isInteger(index) && index >= 0 && index < i && String(index) === key && $f8ff200145f985aa$var$hasOwnProperty(source, key)) indexes.add(index);
        });
        source = prototype;
    }
    if (indexes.size !== i) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $f8ff200145f985aa$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $f8ff200145f985aa$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $f8ff200145f985aa$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$f8ff200145f985aa$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $f8ff200145f985aa$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $f8ff200145f985aa$var$isHTMLForm = $f8ff200145f985aa$var$kindOfTest('HTMLFormElement');
const $f8ff200145f985aa$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $f8ff200145f985aa$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $f8ff200145f985aa$var$isRegExp = $f8ff200145f985aa$var$kindOfTest('RegExp');
const $f8ff200145f985aa$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $f8ff200145f985aa$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $f8ff200145f985aa$var$freezeMethods = (obj)=>{
    $f8ff200145f985aa$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($f8ff200145f985aa$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$f8ff200145f985aa$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $f8ff200145f985aa$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $f8ff200145f985aa$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $f8ff200145f985aa$var$noop = ()=>{};
const $f8ff200145f985aa$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $f8ff200145f985aa$var$isSpecCompliantForm(thing) {
    return !!(thing && $f8ff200145f985aa$var$isFunction(thing.append) && thing[$f8ff200145f985aa$var$toStringTag] === 'FormData' && thing[$f8ff200145f985aa$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $f8ff200145f985aa$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($f8ff200145f985aa$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($f8ff200145f985aa$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($f8ff200145f985aa$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$f8ff200145f985aa$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $f8ff200145f985aa$var$isArray(source) ? [] : {};
                    $f8ff200145f985aa$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$f8ff200145f985aa$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $f8ff200145f985aa$var$isAsyncFn = $f8ff200145f985aa$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $f8ff200145f985aa$var$isThenable = (thing)=>thing && ($f8ff200145f985aa$var$isObject(thing) || $f8ff200145f985aa$var$isFunction(thing)) && $f8ff200145f985aa$var$isFunction(thing.then) && $f8ff200145f985aa$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $f8ff200145f985aa$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $f8ff200145f985aa$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $f8ff200145f985aa$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $f8ff200145f985aa$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $f8ff200145f985aa$var$isFunction($f8ff200145f985aa$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $f8ff200145f985aa$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($f8ff200145f985aa$var$_global) : $f8ff200145f985aa$var$_setImmediate;
// *********************
const $f8ff200145f985aa$var$isIterable = (thing)=>thing != null && $f8ff200145f985aa$var$isFunction(thing[$f8ff200145f985aa$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $f8ff200145f985aa$var$isSafeIterable = (thing)=>thing != null && $f8ff200145f985aa$var$hasOwnInPrototypeChain(thing, $f8ff200145f985aa$var$iterator) && $f8ff200145f985aa$var$isIterable(thing);
var $f8ff200145f985aa$export$2e2bcd8739ae039 = {
    isArray: $f8ff200145f985aa$var$isArray,
    isArrayBuffer: $f8ff200145f985aa$var$isArrayBuffer,
    isBuffer: $f8ff200145f985aa$var$isBuffer,
    isFormData: $f8ff200145f985aa$var$isFormData,
    isArrayBufferView: $f8ff200145f985aa$var$isArrayBufferView,
    isString: $f8ff200145f985aa$var$isString,
    isNumber: $f8ff200145f985aa$var$isNumber,
    isBoolean: $f8ff200145f985aa$var$isBoolean,
    isObject: $f8ff200145f985aa$var$isObject,
    isPlainObject: $f8ff200145f985aa$var$isPlainObject,
    isEmptyObject: $f8ff200145f985aa$var$isEmptyObject,
    isReadableStream: $f8ff200145f985aa$var$isReadableStream,
    isRequest: $f8ff200145f985aa$var$isRequest,
    isResponse: $f8ff200145f985aa$var$isResponse,
    isHeaders: $f8ff200145f985aa$var$isHeaders,
    isUndefined: $f8ff200145f985aa$var$isUndefined,
    isDate: $f8ff200145f985aa$var$isDate,
    isFile: $f8ff200145f985aa$var$isFile,
    isReactNativeBlob: $f8ff200145f985aa$var$isReactNativeBlob,
    isReactNative: $f8ff200145f985aa$var$isReactNative,
    isBlob: $f8ff200145f985aa$var$isBlob,
    isRegExp: $f8ff200145f985aa$var$isRegExp,
    isFunction: $f8ff200145f985aa$var$isFunction,
    isStream: $f8ff200145f985aa$var$isStream,
    isURLSearchParams: $f8ff200145f985aa$var$isURLSearchParams,
    isTypedArray: $f8ff200145f985aa$var$isTypedArray,
    isFileList: $f8ff200145f985aa$var$isFileList,
    forEach: $f8ff200145f985aa$var$forEach,
    merge: $f8ff200145f985aa$var$merge,
    extend: $f8ff200145f985aa$var$extend,
    trim: $f8ff200145f985aa$var$trim,
    stripBOM: $f8ff200145f985aa$var$stripBOM,
    inherits: $f8ff200145f985aa$var$inherits,
    toFlatObject: $f8ff200145f985aa$var$toFlatObject,
    kindOf: $f8ff200145f985aa$var$kindOf,
    kindOfTest: $f8ff200145f985aa$var$kindOfTest,
    endsWith: $f8ff200145f985aa$var$endsWith,
    toArray: $f8ff200145f985aa$var$toArray,
    forEachEntry: $f8ff200145f985aa$var$forEachEntry,
    matchAll: $f8ff200145f985aa$var$matchAll,
    isHTMLForm: $f8ff200145f985aa$var$isHTMLForm,
    hasOwnProperty: $f8ff200145f985aa$var$hasOwnProperty,
    hasOwnProp: $f8ff200145f985aa$var$hasOwnProperty,
    hasOwnInPrototypeChain: $f8ff200145f985aa$var$hasOwnInPrototypeChain,
    getSafeProp: $f8ff200145f985aa$var$getSafeProp,
    toSafeFlatObject: $f8ff200145f985aa$var$toSafeFlatObject,
    reduceDescriptors: $f8ff200145f985aa$var$reduceDescriptors,
    freezeMethods: $f8ff200145f985aa$var$freezeMethods,
    toObjectSet: $f8ff200145f985aa$var$toObjectSet,
    toCamelCase: $f8ff200145f985aa$var$toCamelCase,
    noop: $f8ff200145f985aa$var$noop,
    toFiniteNumber: $f8ff200145f985aa$var$toFiniteNumber,
    findKey: $f8ff200145f985aa$var$findKey,
    global: $f8ff200145f985aa$var$_global,
    isContextDefined: $f8ff200145f985aa$var$isContextDefined,
    isSpecCompliantForm: $f8ff200145f985aa$var$isSpecCompliantForm,
    toJSONObject: $f8ff200145f985aa$var$toJSONObject,
    isAsyncFn: $f8ff200145f985aa$var$isAsyncFn,
    isThenable: $f8ff200145f985aa$var$isThenable,
    setImmediate: $f8ff200145f985aa$var$_setImmediate,
    asap: $f8ff200145f985aa$var$asap,
    isIterable: $f8ff200145f985aa$var$isIterable,
    isSafeIterable: $f8ff200145f985aa$var$isSafeIterable
};

});
parcelRegister("5CtH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41778919f77e4400$export$2e2bcd8739ae039; });
'use strict';
function $41778919f77e4400$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("1s6oO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10ed5eb6ae08b83d$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $4fIXp = parcelRequire("4fIXp");

var $6BXfN = parcelRequire("6BXfN");

var $avznc = parcelRequire("avznc");

var $aZNCn = parcelRequire("aZNCn");

var $4IOn3 = parcelRequire("4IOn3");

var $3uE2d = parcelRequire("3uE2d");

var $7Jvar = parcelRequire("7Jvar");

var $klzwS = parcelRequire("klzwS");

var $eHJJm = parcelRequire("eHJJm");

var $3BlWa = parcelRequire("3BlWa");
'use strict';
const $10ed5eb6ae08b83d$var$validators = (0, $7Jvar.default).validators;
// Recognize header maps without consuming objects intended as literal values.
// AxiosHeaders from other builds share a brand and header-container interface,
// but not constructor identity. A tag and toJSON alone can describe a literal.
const $10ed5eb6ae08b83d$var$isHeadersBucket = (value)=>{
    if (value == null || (0, $lnoYZ.default).isPlainObject(value) || value instanceof (0, $klzwS.default)) return true;
    try {
        return (0, $lnoYZ.default).isObject(value) && (0, $lnoYZ.default).getSafeProp(value, Symbol.toStringTag) === 'AxiosHeaders' && [
            'toJSON',
            'set',
            'get',
            'has',
            'delete',
            'clear',
            'normalize',
            'concat',
            'toString',
            Symbol.iterator
        ].every((method)=>(0, $lnoYZ.default).isFunction((0, $lnoYZ.default).getSafeProp(value, method)));
    } catch (e) {
        // A failed optional brand probe must not prevent literal header serialization.
        return false;
    }
};
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $10ed5eb6ae08b83d$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $6BXfN.default)(),
            response: new (0, $6BXfN.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) try {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                const dummyStack = dummy.stack;
                let stack = '';
                // slice off the Error: ... line
                if (typeof dummyStack === 'string') {
                    const firstNewlineIndex = dummyStack.indexOf('\n');
                    stack = firstNewlineIndex === -1 ? '' : dummyStack.slice(firstNewlineIndex + 1);
                }
                if (!err.stack) err.stack = stack;
                else if (stack) {
                    // Match a common suffix after the 2 top frames when available,
                    // otherwise compare the full reconstructed stack.
                    const firstNewlineIndex = stack.indexOf('\n');
                    const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                    const duplicateCheckSuffix = secondNewlineIndex === -1 ? stack : stack.slice(secondNewlineIndex + 1);
                    // `AxiosError.from()` may have already inlined the wrapped error's
                    // stack under a `Caused by:` marker. Keep the reconstructed caller
                    // frames ahead of that marker so stack-only reporters do not read
                    // them as part of the low-level cause.
                    const currentStack = String(err.stack);
                    const causeIndex = (0, $3BlWa.getCauseStackIndex)(err, currentStack);
                    const stackHead = causeIndex === -1 ? currentStack : currentStack.slice(0, causeIndex);
                    const causeSection = causeIndex === -1 ? '' : currentStack.slice(causeIndex);
                    if (!stackHead.endsWith(duplicateCheckSuffix)) err.stack = stackHead + '\n' + stack + causeSection;
                }
            } catch (e) {
            // Ignore failures from custom stack hooks or un-writable stack properties.
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $aZNCn.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $7Jvar.default).assertOptions(transitional, {
            silentJSONParsing: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            forcedJSONParsing: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            clarifyTimeoutError: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            legacyInterceptorReqResOrdering: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            advertiseZstdAcceptEncoding: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            validateStatusUndefinedResolves: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean),
            encodeBasicAuthUsername: $10ed5eb6ae08b83d$var$validators.transitional($10ed5eb6ae08b83d$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $lnoYZ.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $7Jvar.default).assertOptions(paramsSerializer, {
                encode: $10ed5eb6ae08b83d$var$validators.function,
                serialize: $10ed5eb6ae08b83d$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if ((0, $lnoYZ.default).hasOwnProp(this.defaults, 'allowAbsoluteUrls') && this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $7Jvar.default).assertOptions(config, {
            baseUrl: $10ed5eb6ae08b83d$var$validators.spelling('baseURL'),
            withXsrfToken: $10ed5eb6ae08b83d$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = ((0, $lnoYZ.default).getSafeProp(config, 'method') || (0, $lnoYZ.default).getSafeProp(this.defaults, 'method') || 'get').toLowerCase();
        // Flatten header defaults without consuming literal method-named headers.
        const commonHeaders = (0, $lnoYZ.default).getSafeProp(headers, 'common');
        const methodHeaders = (0, $lnoYZ.default).getSafeProp(headers, config.method);
        const contextHeaders = headers && (0, $lnoYZ.default).merge($10ed5eb6ae08b83d$var$isHeadersBucket(commonHeaders) ? commonHeaders : undefined, $10ed5eb6ae08b83d$var$isHeadersBucket(methodHeaders) ? methodHeaders : undefined);
        headers && (0, $lnoYZ.default).forEach((0, $3uE2d.default).concat('common'), (method)=>{
            if ($10ed5eb6ae08b83d$var$isHeadersBucket((0, $lnoYZ.default).getSafeProp(headers, method))) delete headers[method];
        });
        config.headers = (0, $klzwS.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $eHJJm.default);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $avznc.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $lnoYZ.default).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $avznc.default).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $avznc.default).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $aZNCn.default)(this.defaults, config);
        const fullPath = (0, $4IOn3.default)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $4fIXp.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $lnoYZ.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $10ed5eb6ae08b83d$var$Axios.prototype[method] = async function(url, config) {
        return this.request((0, $aZNCn.default)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $lnoYZ.default).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $lnoYZ.default).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return async function httpMethod(url, data, config) {
            return this.request((0, $aZNCn.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $10ed5eb6ae08b83d$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $10ed5eb6ae08b83d$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $10ed5eb6ae08b83d$export$2e2bcd8739ae039 = $10ed5eb6ae08b83d$var$Axios;

});
parcelRegister("4fIXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $318b6fba1395d95a$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $jW4FZ = parcelRequire("jW4FZ");
'use strict';
function $318b6fba1395d95a$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $318b6fba1395d95a$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $lnoYZ.default).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $lnoYZ.default).getSafeProp(_options, 'encode') || $318b6fba1395d95a$export$c564cdbbe6da493;
    const serializeFn = (0, $lnoYZ.default).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $lnoYZ.default).isURLSearchParams(params) ? params.toString() : new (0, $jW4FZ.default)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

});
parcelRegister("jW4FZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8370fb70807ee2b$export$2e2bcd8739ae039; });

var $7160o = parcelRequire("7160o");
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $e8370fb70807ee2b$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $e8370fb70807ee2b$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $7160o.default)(params, this, options);
}
const $e8370fb70807ee2b$var$prototype = $e8370fb70807ee2b$var$AxiosURLSearchParams.prototype;
$e8370fb70807ee2b$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$e8370fb70807ee2b$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $e8370fb70807ee2b$var$encode) : $e8370fb70807ee2b$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $e8370fb70807ee2b$export$2e2bcd8739ae039 = $e8370fb70807ee2b$var$AxiosURLSearchParams;

});
parcelRegister("7160o", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_FORM_DATA_MAX_DEPTH", function () { return $51bd48f058dd6d0b$export$659081b45d03227d; });
$parcel$export(module.exports, "default", function () { return $51bd48f058dd6d0b$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");

var $fz04f = parcelRequire("fz04f");

var $fz04f = parcelRequire("fz04f");
'use strict';
const $51bd48f058dd6d0b$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $51bd48f058dd6d0b$var$isVisitable(thing) {
    return (0, $lnoYZ.default).isPlainObject(thing) || (0, $lnoYZ.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $51bd48f058dd6d0b$var$removeBrackets(key) {
    return (0, $lnoYZ.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $51bd48f058dd6d0b$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $51bd48f058dd6d0b$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $51bd48f058dd6d0b$var$isFlatArray(arr) {
    return (0, $lnoYZ.default).isArray(arr) && !arr.some($51bd48f058dd6d0b$var$isVisitable);
}
const $51bd48f058dd6d0b$var$predicates = (0, $lnoYZ.default).toFlatObject((0, $lnoYZ.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $51bd48f058dd6d0b$var$toFormData(obj, formData, options) {
    if (!(0, $lnoYZ.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $fz04f.default) || FormData)();
    const option = (name, fallback)=>{
        const value = (0, $lnoYZ.default).getSafeProp(options, name);
        return (0, $lnoYZ.default).isUndefined(value) ? fallback : value;
    };
    const metaTokens = option('metaTokens', true);
    // eslint-disable-next-line no-use-before-define
    const visitor = option('visitor') || defaultVisitor;
    const dots = option('dots', false);
    const indexes = option('indexes', false);
    const _Blob = option('Blob') || typeof Blob !== 'undefined' && Blob;
    const maxDepth = option('maxDepth', $51bd48f058dd6d0b$export$659081b45d03227d);
    const useBlob = _Blob && (0, $lnoYZ.default).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $lnoYZ.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $lnoYZ.default).isDate(value)) return value.toISOString();
        if ((0, $lnoYZ.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $lnoYZ.default).isBlob(value)) throw new (0, $3BlWa.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, $lnoYZ.default).isArrayBuffer(value) || (0, $lnoYZ.default).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $fz04f.default) && (0, $fz04f.default).isBufferAvailable()) return (0, $fz04f.default).from(value);
            throw new (0, $3BlWa.default)('Blob is not supported. Use a Buffer instead.', (0, $3BlWa.default).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $3BlWa.default)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $3BlWa.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $lnoYZ.default).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $lnoYZ.default).isReactNative(formData) && (0, $lnoYZ.default).isReactNativeBlob(value)) {
            formData.append($51bd48f058dd6d0b$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $lnoYZ.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $lnoYZ.default).isArray(value) && $51bd48f058dd6d0b$var$isFlatArray(value) || ((0, $lnoYZ.default).isFileList(value) || (0, $lnoYZ.default).endsWith(key, '[]')) && (arr = (0, $lnoYZ.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $51bd48f058dd6d0b$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $lnoYZ.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $51bd48f058dd6d0b$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($51bd48f058dd6d0b$var$isVisitable(value)) return true;
        formData.append($51bd48f058dd6d0b$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($51bd48f058dd6d0b$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $51bd48f058dd6d0b$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $lnoYZ.default).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $lnoYZ.default).forEach(value, function each(el, key) {
            const result = !((0, $lnoYZ.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $lnoYZ.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $lnoYZ.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $51bd48f058dd6d0b$export$2e2bcd8739ae039 = $51bd48f058dd6d0b$var$toFormData;

});
parcelRegister("3BlWa", function(module, exports) {

$parcel$export(module.exports, "REDACTED", function () { return $29f5d8123cf3f839$export$6acd2efa8ac62a1b; });
$parcel$export(module.exports, "getCauseStackIndex", function () { return $29f5d8123cf3f839$export$ce02d00c43032876; });
$parcel$export(module.exports, "default", function () { return $29f5d8123cf3f839$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $klzwS = parcelRequire("klzwS");
'use strict';
const $29f5d8123cf3f839$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $29f5d8123cf3f839$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $lnoYZ.default).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $lnoYZ.default).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $29f5d8123cf3f839$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $lnoYZ.default).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $klzwS.default)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $lnoYZ.default).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $lnoYZ.default).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $lnoYZ.default).isPlainObject(source) && $29f5d8123cf3f839$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $29f5d8123cf3f839$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $lnoYZ.default).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $29f5d8123cf3f839$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $29f5d8123cf3f839$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $29f5d8123cf3f839$var$stringifySafely(entry.message) : $29f5d8123cf3f839$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
const $29f5d8123cf3f839$export$b601cb805d64c52b = '\nCaused by: ';
const $29f5d8123cf3f839$var$$causeStack = Symbol('causeStack');
function $29f5d8123cf3f839$export$ce02d00c43032876(error, stack) {
    const causeStack = (0, $lnoYZ.default).hasOwnProp(error, $29f5d8123cf3f839$var$$causeStack) && error[$29f5d8123cf3f839$var$$causeStack];
    return causeStack && stack.endsWith(causeStack) ? stack.length - causeStack.length : -1;
}
/**
 * Append the stack of a wrapped error to `target.stack`.
 *
 * `cause` already exposes the original error for tooling that walks the standard
 * cause chain, but many error reporters read `stack` and nothing else. Inlining
 * the wrapped stack there means those reporters surface the underlying failure
 * instead of the axios frames that normalized it (see #6670).
 *
 * Every read is defensive: a custom `Error.prepareStackTrace` hook, a runtime
 * without stack support, or a replaced `stack` property can leave the value
 * missing, non-string, or read-only, and normalizing an error must not throw
 * because of that.
 *
 * @param {Error} target The AxiosError being built.
 * @param {Error} source The error being wrapped.
 *
 * @returns {void}
 */ function $29f5d8123cf3f839$var$appendCauseStack(target, source) {
    try {
        const sourceStack = source && source.stack;
        if (typeof sourceStack !== 'string' || !sourceStack) return;
        const targetStack = target.stack;
        if (typeof targetStack !== 'string' || !targetStack) return;
        // Each call to `from()` creates a fresh target. Re-wrapping includes the
        // previous stack verbatim, adding one cause section per wrap.
        const causeStack = $29f5d8123cf3f839$export$b601cb805d64c52b + sourceStack;
        target.stack = targetStack + causeStack;
        Object.defineProperty(target, $29f5d8123cf3f839$var$$causeStack, {
            __proto__: null,
            value: causeStack
        });
    } catch (e) {
    // Ignore failures from custom stack hooks or un-writable stack properties.
    }
}
class $29f5d8123cf3f839$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $lnoYZ.default).isArray(error.errors) && error.errors.length) message = $29f5d8123cf3f839$var$aggregateErrorMessage(error);
        const axiosError = new $29f5d8123cf3f839$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Inline the wrapped stack for reporters that read only `stack`; the `cause`
        // property above already covers cause-aware tooling.
        $29f5d8123cf3f839$var$appendCauseStack(axiosError, error);
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $lnoYZ.default).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $lnoYZ.default).isArray(redactKeys) && redactKeys.length > 0 ? $29f5d8123cf3f839$var$redactConfig(config, redactKeys) : (0, $lnoYZ.default).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$29f5d8123cf3f839$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$29f5d8123cf3f839$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$29f5d8123cf3f839$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$29f5d8123cf3f839$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$29f5d8123cf3f839$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$29f5d8123cf3f839$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$29f5d8123cf3f839$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$29f5d8123cf3f839$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$29f5d8123cf3f839$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$29f5d8123cf3f839$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$29f5d8123cf3f839$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$29f5d8123cf3f839$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$29f5d8123cf3f839$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$29f5d8123cf3f839$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $29f5d8123cf3f839$export$2e2bcd8739ae039 = $29f5d8123cf3f839$var$AxiosError;

});
parcelRegister("klzwS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed015434c89f2d50$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $1kJ5T = parcelRequire("1kJ5T");

var $bVr18 = parcelRequire("bVr18");
'use strict';
const $ed015434c89f2d50$var$$internals = Symbol('internals');
function $ed015434c89f2d50$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $ed015434c89f2d50$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $lnoYZ.default).isArray(value) ? value.map($ed015434c89f2d50$var$normalizeValue) : (0, $bVr18.sanitizeHeaderValue)(String(value));
}
function $ed015434c89f2d50$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $ed015434c89f2d50$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $ed015434c89f2d50$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $ed015434c89f2d50$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $ed015434c89f2d50$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $ed015434c89f2d50$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $ed015434c89f2d50$var$trimOWS(part.slice(0, equals));
        if (!$ed015434c89f2d50$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $ed015434c89f2d50$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $ed015434c89f2d50$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $ed015434c89f2d50$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
// `__proto__` is a valid field name, and the one name the uppercase mapping at
// the bottom of this file cannot reach: it is inherited from Object.prototype
// instead of being declared on AxiosHeaders.prototype, so `self.__proto__ = v`
// runs the inherited setter. That silently discards the header, and an array
// value replaces the instance prototype, taking every method with it.
// Store it under the same kind of case variant that mapping uses for `set` and
// `constructor`. Header lookup is caseless, so it reads back under either
// spelling, and no own `__proto__` slot is ever created for a later
// `Object.assign` to copy onto a plain object through the same setter.
const $ed015434c89f2d50$var$PROTO_HEADER_SLOT = '__Proto__';
const $ed015434c89f2d50$var$headerSlot = (name)=>name === '__proto__' ? $ed015434c89f2d50$var$PROTO_HEADER_SLOT : name;
function $ed015434c89f2d50$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $lnoYZ.default).isFunction(filter)) return filter.call(context, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $lnoYZ.default).isString(value)) return;
    if ((0, $lnoYZ.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $lnoYZ.default).isRegExp(filter)) return filter.test(value);
}
function $ed015434c89f2d50$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $ed015434c89f2d50$var$buildAccessors(obj, header) {
    const accessorName = (0, $lnoYZ.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $ed015434c89f2d50$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $ed015434c89f2d50$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $lnoYZ.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[$ed015434c89f2d50$var$headerSlot(key || _header)] = $ed015434c89f2d50$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $lnoYZ.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $lnoYZ.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $lnoYZ.default).isString(header) && (header = header.trim()) && !$ed015434c89f2d50$var$isValidHeaderName(header)) setHeaders((0, $1kJ5T.default)(header), valueOrRewrite);
        else if ((0, $lnoYZ.default).isObject(header) && (0, $lnoYZ.default).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $lnoYZ.default).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $lnoYZ.default).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $lnoYZ.default).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $ed015434c89f2d50$var$normalizeHeader(header);
        if (header) {
            const key = (0, $lnoYZ.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $ed015434c89f2d50$var$parseTokens(value);
                if ((0, $lnoYZ.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $lnoYZ.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $ed015434c89f2d50$var$normalizeHeader(header);
        if (header) {
            const key = (0, $lnoYZ.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $ed015434c89f2d50$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $ed015434c89f2d50$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $lnoYZ.default).findKey(self, _header);
                if (key && (!matcher || $ed015434c89f2d50$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $lnoYZ.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $ed015434c89f2d50$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = Object.create(null);
        (0, $lnoYZ.default).forEach(this, (value, header)=>{
            const key = (0, $lnoYZ.default).findKey(headers, header);
            if (key) {
                self[key] = $ed015434c89f2d50$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = $ed015434c89f2d50$var$headerSlot(format ? $ed015434c89f2d50$var$formatHeader(header) : String(header).trim());
            if (normalized !== header) delete self[header];
            self[normalized] = $ed015434c89f2d50$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $lnoYZ.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $lnoYZ.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $lnoYZ.default).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $ed015434c89f2d50$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$ed015434c89f2d50$var$$internals] = this[$ed015434c89f2d50$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $ed015434c89f2d50$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $ed015434c89f2d50$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $lnoYZ.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$ed015434c89f2d50$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $lnoYZ.default).reduceDescriptors($ed015434c89f2d50$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $lnoYZ.default).freezeMethods($ed015434c89f2d50$var$AxiosHeaders);
var $ed015434c89f2d50$export$2e2bcd8739ae039 = $ed015434c89f2d50$var$AxiosHeaders;

});
parcelRegister("1kJ5T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f8aa3754826a550$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $0f8aa3754826a550$var$ignoreDuplicateOf = (0, $lnoYZ.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $0f8aa3754826a550$export$2e2bcd8739ae039 = (rawHeaders)=>{
    // Header names are data, including __proto__; avoid inherited setters.
    const parsed = Object.create(null);
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $lnoYZ.default).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $lnoYZ.default).hasOwnProp($0f8aa3754826a550$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

});

parcelRegister("bVr18", function(module, exports) {

$parcel$export(module.exports, "sanitizeHeaderValue", function () { return $8ae9f9ad1c7c4977$export$9e344cffce061a22; });
$parcel$export(module.exports, "toByteStringHeaderObject", function () { return $8ae9f9ad1c7c4977$export$c30c72bb7e677d54; });

var $lnoYZ = parcelRequire("lnoYZ");
'use strict';
function $8ae9f9ad1c7c4977$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $8ae9f9ad1c7c4977$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $8ae9f9ad1c7c4977$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $8ae9f9ad1c7c4977$var$sanitizeValue(value, invalidChars) {
    if ((0, $lnoYZ.default).isArray(value)) return value.map((item)=>$8ae9f9ad1c7c4977$var$sanitizeValue(item, invalidChars));
    return $8ae9f9ad1c7c4977$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $8ae9f9ad1c7c4977$export$9e344cffce061a22 = (value)=>$8ae9f9ad1c7c4977$var$sanitizeValue(value, $8ae9f9ad1c7c4977$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $8ae9f9ad1c7c4977$export$59dd66c2a12d8f62 = (value)=>$8ae9f9ad1c7c4977$var$sanitizeValue(value, $8ae9f9ad1c7c4977$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $8ae9f9ad1c7c4977$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $lnoYZ.default).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $8ae9f9ad1c7c4977$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}

});



parcelRegister("fz04f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b54a2d4b329b1354$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $b54a2d4b329b1354$export$2e2bcd8739ae039 = null;

});




parcelRegister("6BXfN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d0429586c8107bb$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");
'use strict';
const $4d0429586c8107bb$var$$internals = Symbol('internals');
// `handlers` is public and may be replaced with a nullish value by user code;
// `clear()` has always tolerated that. Treat it as an empty stack rather than
// dereferencing it.
function $4d0429586c8107bb$var$countHandlers(handlers) {
    return handlers ? handlers.length : 0;
}
function $4d0429586c8107bb$var$trimHandlers(handlers) {
    if (!handlers) return;
    while(handlers.length && handlers[handlers.length - 1] === null)handlers.pop();
}
// Preserve the array-key coercion used before IDs were stored in a Map, without
// treating null, empty strings, or noncanonical numeric strings as ID zero.
function $4d0429586c8107bb$var$normalizeHandlerId(id) {
    if (typeof id === 'string' && id !== '' && String(Number(id)) === id) return Number(id);
    return id;
}
function $4d0429586c8107bb$var$syncHandlerEntries(manager, internals) {
    const handlers = manager.handlers;
    const length = $4d0429586c8107bb$var$countHandlers(handlers);
    if (handlers !== internals.handlersRef) {
        internals.handlersRef = handlers;
        internals.handlerEntries.clear();
    } else if (length !== internals.handlersLength) {
        if (!length) internals.handlerEntries.clear();
        else internals.handlerEntries.forEach(function removeStaleEntry(entry, id) {
            if (handlers[entry.index] !== entry.handler) internals.handlerEntries.delete(id);
        });
    }
    internals.handlersLength = length;
}
class $4d0429586c8107bb$var$InterceptorManager {
    constructor(){
        this.handlers = [];
        this[$4d0429586c8107bb$var$$internals] = {
            handlersRef: this.handlers,
            handlersLength: this.handlers.length,
            handlerEntries: new Map(),
            iterationDepth: 0,
            nextId: 0
        };
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        const handler = {
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        };
        const internals = this[$4d0429586c8107bb$var$$internals];
        if (this.handlers == null) this.handlers = [];
        $4d0429586c8107bb$var$syncHandlerEntries(this, internals);
        const id = internals.nextId++;
        this.handlers.push(handler);
        internals.handlerEntries.set(id, {
            handler: handler,
            index: this.handlers.length - 1
        });
        internals.handlersLength = this.handlers.length;
        return id;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        const internals = this[$4d0429586c8107bb$var$$internals];
        $4d0429586c8107bb$var$syncHandlerEntries(this, internals);
        const handlerId = $4d0429586c8107bb$var$normalizeHandlerId(id);
        const entry = internals.handlerEntries.get(handlerId);
        if (entry) {
            internals.handlerEntries.delete(handlerId);
            // Ignore IDs invalidated by clear or direct replacement of handlers.
            if (this.handlers[entry.index] !== entry.handler) return;
            this.handlers[entry.index] = null;
            // Do not reuse an index while forEach is walking its length snapshot.
            if (!internals.iterationDepth) {
                $4d0429586c8107bb$var$trimHandlers(this.handlers);
                internals.handlersLength = this.handlers.length;
            }
        }
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) {
            this.handlers = [];
            $4d0429586c8107bb$var$syncHandlerEntries(this, this[$4d0429586c8107bb$var$$internals]);
        }
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        const internals = this[$4d0429586c8107bb$var$$internals];
        $4d0429586c8107bb$var$syncHandlerEntries(this, internals);
        internals.iterationDepth++;
        try {
            (0, $lnoYZ.default).forEach(this.handlers, function forEachHandler(h) {
                if (h !== null) fn(h);
            });
        } finally{
            if (!--internals.iterationDepth) {
                $4d0429586c8107bb$var$syncHandlerEntries(this, internals);
                $4d0429586c8107bb$var$trimHandlers(this.handlers);
                internals.handlersLength = $4d0429586c8107bb$var$countHandlers(this.handlers);
            }
        }
    }
}
var $4d0429586c8107bb$export$2e2bcd8739ae039 = $4d0429586c8107bb$var$InterceptorManager;

});

parcelRegister("avznc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a683cfe041b9144$export$2e2bcd8739ae039; });

var $8P2Ez = parcelRequire("8P2Ez");

var $ckJjs = parcelRequire("ckJjs");

var $4hvqU = parcelRequire("4hvqU");

var $fTjDq = parcelRequire("fTjDq");

var $klzwS = parcelRequire("klzwS");

var $c4h6w = parcelRequire("c4h6w");

var $lnoYZ = parcelRequire("lnoYZ");
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $7a683cfe041b9144$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $fTjDq.default)(null, config);
}
/**
 * Milliseconds elapsed since `start`, floored at zero.
 *
 * Wall-clock, to match the rest of the codebase (speedometer, throttle,
 * AxiosTransformStream). A backwards clock adjustment mid-request would
 * otherwise produce a negative duration, so the result is clamped.
 *
 * @param {number} start Timestamp from `Date.now()`
 *
 * @returns {number} Non-negative elapsed milliseconds
 */ function $7a683cfe041b9144$var$elapsedSince(start) {
    return Math.max(0, Date.now() - start);
}
function $7a683cfe041b9144$export$2e2bcd8739ae039(_config) {
    // Interceptors may replace the merged config with an ordinary object. Flatten
    // it at the dispatch boundary so shared prototype members cannot become
    // request behavior, while preserving intentional template/class members.
    const config = (0, $lnoYZ.default).toSafeFlatObject(_config);
    $7a683cfe041b9144$var$throwIfCancellationRequested(config);
    config.headers = (0, $klzwS.default).from((0, $lnoYZ.default).getSafeProp(config, 'headers'));
    // Transform request data
    config.data = (0, $8P2Ez.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $c4h6w.default).getAdapter(config.adapter || (0, $4hvqU.default).adapter, config);
    const start = Date.now();
    return adapter(config).then(function onAdapterResolution(response) {
        $7a683cfe041b9144$var$throwIfCancellationRequested(config);
        response.duration = $7a683cfe041b9144$var$elapsedSince(start);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $8P2Ez.default).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $klzwS.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ckJjs.default)(reason)) {
            $7a683cfe041b9144$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.duration = $7a683cfe041b9144$var$elapsedSince(start);
                config.response = reason.response;
                try {
                    reason.response.data = (0, $8P2Ez.default).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $klzwS.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("8P2Ez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66c5250e4edd4899$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $4hvqU = parcelRequire("4hvqU");

var $klzwS = parcelRequire("klzwS");
'use strict';
function $66c5250e4edd4899$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $4hvqU.default);
    const context = response || config;
    const headers = (0, $klzwS.default).from(context.headers);
    let data = context.data;
    (0, $lnoYZ.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("4hvqU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31e121e7fe3092fc$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");

var $eHJJm = parcelRequire("eHJJm");

var $7160o = parcelRequire("7160o");

var $d1qAN = parcelRequire("d1qAN");

var $7RQMv = parcelRequire("7RQMv");

var $CVDVT = parcelRequire("CVDVT");

var $3uE2d = parcelRequire("3uE2d");
'use strict';
const $31e121e7fe3092fc$var$own = (obj, key)=>obj != null && (0, $lnoYZ.default).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $31e121e7fe3092fc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $lnoYZ.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $lnoYZ.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $31e121e7fe3092fc$var$defaults = {
    transitional: (0, $eHJJm.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $lnoYZ.default).isObject(data);
            if (isObjectPayload && (0, $lnoYZ.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $lnoYZ.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $CVDVT.default)(data)) : data;
            if ((0, $lnoYZ.default).isArrayBuffer(data) || (0, $lnoYZ.default).isBuffer(data) || (0, $lnoYZ.default).isStream(data) || (0, $lnoYZ.default).isFile(data) || (0, $lnoYZ.default).isBlob(data) || (0, $lnoYZ.default).isReadableStream(data)) return data;
            if ((0, $lnoYZ.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $lnoYZ.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $31e121e7fe3092fc$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $d1qAN.default)(data, formSerializer).toString();
                if ((isFileList = (0, $lnoYZ.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $31e121e7fe3092fc$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $7160o.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $31e121e7fe3092fc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $31e121e7fe3092fc$var$own(this, 'transitional') || $31e121e7fe3092fc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $31e121e7fe3092fc$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $lnoYZ.default).isResponse(data) || (0, $lnoYZ.default).isReadableStream(data)) return data;
            if (data && (0, $lnoYZ.default).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $31e121e7fe3092fc$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $3BlWa.default).from(e, (0, $3BlWa.default).ERR_BAD_RESPONSE, this, null, $31e121e7fe3092fc$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $7RQMv.default).classes.FormData,
        Blob: (0, $7RQMv.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $lnoYZ.default).forEach((0, $3uE2d.default), (method)=>{
    $31e121e7fe3092fc$var$defaults.headers[method] = {};
});
var $31e121e7fe3092fc$export$2e2bcd8739ae039 = $31e121e7fe3092fc$var$defaults;

});
parcelRegister("eHJJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab488e00b7a3ad98$export$2e2bcd8739ae039; });
'use strict';
var $ab488e00b7a3ad98$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true,
    encodeBasicAuthUsername: false
};

});

parcelRegister("d1qAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97afff1126a8d4c7$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $7160o = parcelRequire("7160o");

var $7RQMv = parcelRequire("7RQMv");
'use strict';
function $97afff1126a8d4c7$export$2e2bcd8739ae039(data, options) {
    return (0, $7160o.default)(data, new (0, $7RQMv.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $7RQMv.default).isNode && (0, $lnoYZ.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

});
parcelRegister("7RQMv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba66ce9129abb98$export$2e2bcd8739ae039; });

var $aUlg2 = parcelRequire("aUlg2");

var $hUADh = parcelRequire("hUADh");
var $5ba66ce9129abb98$export$2e2bcd8739ae039 = {
    ...$hUADh,
    ...(0, $aUlg2.default)
};

});
parcelRegister("aUlg2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f0f9fb00b286964$export$2e2bcd8739ae039; });

var $gSRJl = parcelRequire("gSRJl");

var $2aNQP = parcelRequire("2aNQP");

var $iqpkB = parcelRequire("iqpkB");
var $7f0f9fb00b286964$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $gSRJl.default,
        FormData: $2aNQP.default,
        Blob: $iqpkB.default
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

});
parcelRegister("gSRJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4ab5e3dd93544ef$export$2e2bcd8739ae039; });

var $jW4FZ = parcelRequire("jW4FZ");
'use strict';
var $c4ab5e3dd93544ef$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $jW4FZ.default);

});

parcelRegister("2aNQP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19532f57b9b97886$export$2e2bcd8739ae039; });
'use strict';
var $19532f57b9b97886$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;

});

parcelRegister("iqpkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d69e4df7ba67920c$export$2e2bcd8739ae039; });
'use strict';
var $d69e4df7ba67920c$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;

});


parcelRegister("hUADh", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $d0a415168a8ccd15$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "navigator", function () { return $d0a415168a8ccd15$export$ec7c8efa7f5790ae; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $d0a415168a8ccd15$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $d0a415168a8ccd15$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $d0a415168a8ccd15$export$f710a83a91838a36; });
const $d0a415168a8ccd15$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $d0a415168a8ccd15$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $d0a415168a8ccd15$export$c0bcc9250309d66 = $d0a415168a8ccd15$export$c4996c4b7b93b0bf && (!$d0a415168a8ccd15$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($d0a415168a8ccd15$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $d0a415168a8ccd15$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $d0a415168a8ccd15$export$f710a83a91838a36 = $d0a415168a8ccd15$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';

});



parcelRegister("CVDVT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $075043704fca9095$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");

var $7160o = parcelRequire("7160o");
'use strict';
const $075043704fca9095$var$MAX_DEPTH = (0, $7160o.DEFAULT_FORM_DATA_MAX_DEPTH);
function $075043704fca9095$var$throwIfDepthExceeded(index) {
    if (index > $075043704fca9095$var$MAX_DEPTH) throw new (0, $3BlWa.default)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $075043704fca9095$var$MAX_DEPTH, (0, $3BlWa.default).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $075043704fca9095$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $075043704fca9095$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $075043704fca9095$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
function $075043704fca9095$var$normalizeArray(value) {
    if (!(0, $lnoYZ.default).isArray(value)) return value;
    const keys = Object.keys(value);
    return keys.length !== value.length || keys.some((key, index)=>key !== String(index)) ? $075043704fca9095$var$arrayToObject(value) : value;
}
function $075043704fca9095$var$normalizeArrays(obj) {
    const pending = [
        obj
    ];
    while(pending.length){
        const target = pending.pop();
        Object.keys(target).forEach((key)=>{
            const value = target[key] = $075043704fca9095$var$normalizeArray(target[key]);
            if ((0, $lnoYZ.default).isArray(value) || (0, $lnoYZ.default).isPlainObject(value)) pending.push(value);
        });
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $075043704fca9095$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $075043704fca9095$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $lnoYZ.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $lnoYZ.default).hasOwnProp(target, name)) {
                target[name] = $075043704fca9095$var$normalizeArray(target[name]);
                target[name] = (0, $lnoYZ.default).isArray(target[name]) ? target[name].concat(value) : [
                    target[name],
                    value
                ];
            } else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $lnoYZ.default).hasOwnProp(target, name) || !(0, $lnoYZ.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $lnoYZ.default).isArray(target[name])) target[name] = $075043704fca9095$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $lnoYZ.default).isFormData(formData) && (0, $lnoYZ.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $lnoYZ.default).forEachEntry(formData, (name, value)=>{
            buildPath($075043704fca9095$var$parsePropPath(name), value, obj, 0);
        });
        return $075043704fca9095$var$normalizeArrays(obj);
    }
    return null;
}
var $075043704fca9095$export$2e2bcd8739ae039 = $075043704fca9095$var$formDataToJSON;

});

parcelRegister("3uE2d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28b33a85a9b8fe34$export$2e2bcd8739ae039; });
'use strict';
const $28b33a85a9b8fe34$var$methodList = Object.freeze([
    'get',
    'delete',
    'head',
    'options',
    'post',
    'put',
    'patch',
    'purge',
    'link',
    'unlink',
    'query'
]);
var $28b33a85a9b8fe34$export$2e2bcd8739ae039 = $28b33a85a9b8fe34$var$methodList;

});



parcelRegister("ckJjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8faa807ac2ececbb$export$2e2bcd8739ae039; });
'use strict';
function $8faa807ac2ececbb$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("fTjDq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b91b392ba2655ca9$export$2e2bcd8739ae039; });

var $3BlWa = parcelRequire("3BlWa");
'use strict';
class $b91b392ba2655ca9$var$CanceledError extends (0, $3BlWa.default) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $3BlWa.default).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $b91b392ba2655ca9$export$2e2bcd8739ae039 = $b91b392ba2655ca9$var$CanceledError;

});

parcelRegister("c4h6w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c93204921a51edd$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $fz04f = parcelRequire("fz04f");

var $2E5nn = parcelRequire("2E5nn");

var $9iBOx = parcelRequire("9iBOx");

var $3BlWa = parcelRequire("3BlWa");
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $8c93204921a51edd$var$knownAdapters = {
    http: (0, $fz04f.default),
    xhr: (0, $2E5nn.default),
    fetch: {
        get: $9iBOx.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, $lnoYZ.default).forEach($8c93204921a51edd$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $8c93204921a51edd$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $8c93204921a51edd$var$isResolvedHandle = (adapter)=>(0, $lnoYZ.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $8c93204921a51edd$var$getAdapter(adapters, config) {
    adapters = (0, $lnoYZ.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$8c93204921a51edd$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $8c93204921a51edd$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $3BlWa.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $lnoYZ.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($8c93204921a51edd$var$renderReason).join('\n') : ' ' + $8c93204921a51edd$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $3BlWa.default)(`There is no suitable adapter to dispatch the request ` + s, (0, $3BlWa.default).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $8c93204921a51edd$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $8c93204921a51edd$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $8c93204921a51edd$var$knownAdapters
};

});
parcelRegister("2E5nn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ed37cc8ab2271c6$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $1c8fo = parcelRequire("1c8fo");

var $eHJJm = parcelRequire("eHJJm");

var $3BlWa = parcelRequire("3BlWa");

var $fTjDq = parcelRequire("fTjDq");

var $5ByqM = parcelRequire("5ByqM");

var $inLLf = parcelRequire("inLLf");

var $7RQMv = parcelRequire("7RQMv");

var $klzwS = parcelRequire("klzwS");

var $3BTe1 = parcelRequire("3BTe1");

var $cdaMI = parcelRequire("cdaMI");

var $iOm2Z = parcelRequire("iOm2Z");

var $bVr18 = parcelRequire("bVr18");
const $1ed37cc8ab2271c6$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $1ed37cc8ab2271c6$export$2e2bcd8739ae039 = $1ed37cc8ab2271c6$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let useAsyncXsrf;
        try {
            const store = (0, $7RQMv.default).hasStandardBrowserEnv && typeof window !== 'undefined' && window.cookieStore;
            useAsyncXsrf = store && (0, $lnoYZ.default).isFunction(store.get);
        } catch (e) {
        // A restricted Cookie Store getter must retain the synchronous fallback.
        }
        let xsrfCookieName;
        const _config = (0, $iOm2Z.default)(config, useAsyncXsrf ? (name)=>{
            xsrfCookieName = name;
            return null;
        } : undefined);
        let requestData = _config.data;
        const requestHeaders = (0, $klzwS.default).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let timeoutId;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload, flushDownloadWithEvent;
        function done() {
            clearTimeout(timeoutId);
            // A final progress callback must not prevent the remaining cleanup.
            // Report errors asynchronously, as onloadend and the throttle timer do.
            try {
                flushUpload && flushUpload(); // flush events
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            try {
                flushDownload && flushDownload(); // flush events
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A flush can synchronously cancel the request and reenter done().
            // In that case the inner call has already detached these listeners.
            if (request) {
                downloadThrottled && request.removeEventListener('progress', downloadThrottled);
                if (request.upload) {
                    uploadThrottled && request.upload.removeEventListener('progress', uploadThrottled);
                    flushUpload && request.upload.removeEventListener('loadend', flushUpload);
                }
            }
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend(event) {
            if (!request) return;
            // Status 0 means no response was received, which onerror and onabort normally
            // reject before this runs. Firefox 152 fires only readystatechange and loadend for
            // navigation-canceled requests (https://bugzilla.mozilla.org/show_bug.cgi?id=1505389),
            // leaving settle() to resolve them as an empty success. ECONNABORTED is the error
            // onabort raised on Firefox 151. Reads over file:, which some environments report as
            // status 0 on success, are excluded by the request URL's scheme after browser-style
            // preprocessing, by the page origin's scheme for relative URLs (which inherit it), or
            // by responseURL where implemented.
            if (request.status === 0 && ((0, $inLLf.default)((0, $5ByqM.default)(_config.url)) || (0, $inLLf.default)((0, $7RQMv.default).origin)) !== 'file' && !(request.responseURL && request.responseURL.startsWith('file:'))) {
                reject(new (0, $3BlWa.default)('Request aborted', (0, $3BlWa.default).ECONNABORTED, config, request));
                done();
                // Clean up request
                request = null;
                return;
            }
            // When loadend is still dispatching, flushing with it gives progress
            // listeners a final delivery whose event has a live target. The legacy
            // ready-state fallback has no event, so replay its pending progress.
            // A throwing listener must not block settlement; rethrow asynchronously,
            // matching how listener errors surface on the throttle timer path.
            try {
                if (event) flushDownloadWithEvent && flushDownloadWithEvent(event);
                else flushDownload && flushDownload();
            } catch (err) {
                setTimeout(()=>{
                    throw err;
                });
            }
            // A final progress callback can cancel the request synchronously.
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $klzwS.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $1c8fo.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $3BlWa.default)('Request aborted', (0, $3BlWa.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $3BlWa.default)(msg, (0, $3BlWa.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            if (!request) return;
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $eHJJm.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $3BlWa.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $3BlWa.default).ETIMEDOUT : (0, $3BlWa.default).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add withCredentials to request if needed
        if (!(0, $lnoYZ.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload, flushDownloadWithEvent] = (0, $cdaMI.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $cdaMI.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $fTjDq.default)(null, config, request) : cancel);
                const xhr = request;
                done();
                request = null;
                xhr.abort();
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (!request) return;
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        if (!request) return;
        const protocol = (0, $inLLf.default)(_config.url);
        if (protocol && !(0, $7RQMv.default).protocols.includes(protocol)) {
            reject(new (0, $3BlWa.default)('Unsupported protocol ' + protocol + ':', (0, $3BlWa.default).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        const sendRequest = ()=>{
            if (!request) return;
            // Apply headers after an asynchronous XSRF read so existing headers are
            // replaced through AxiosHeaders rather than appended by the native XHR.
            if ('setRequestHeader' in request) (0, $lnoYZ.default).forEach((0, $bVr18.toByteStringHeaderObject)(requestHeaders), function setRequestHeader(val, key) {
                request.setRequestHeader(key, val);
            });
            request.send(requestData || null);
        };
        if (xsrfCookieName) {
            // Native XHR timeout starts at send(). Cover cookie preparation and the
            // subsequent request with the same budget and existing timeout handler.
            const now = typeof performance !== 'undefined' && (0, $lnoYZ.default).isFunction(performance.now) ? ()=>performance.now() : Date.now;
            const deadline = request.timeout > 0 ? now() + Number(request.timeout) : undefined;
            const abortOnTimeout = ()=>{
                if (!request) return;
                const xhr = request;
                xhr.ontimeout();
                xhr.abort();
            };
            if (deadline !== undefined) {
                const scheduleTimeout = ()=>{
                    const remaining = deadline - now();
                    if (remaining > 0) // Browser timers overflow above the signed 32-bit delay limit.
                    timeoutId = setTimeout(scheduleTimeout, Math.min(remaining, 0x7fffffff));
                    else abortOnTimeout();
                };
                scheduleTimeout();
            }
            (0, $3BTe1.default).readAsync(xsrfCookieName).then((value)=>{
                if (!request) return;
                // Promise callbacks may run before an overdue timer after a busy task.
                if (deadline !== undefined && now() >= deadline) {
                    abortOnTimeout();
                    return;
                }
                if (value) {
                    const headerName = (0, $lnoYZ.default).hasOwnProp(_config, 'xsrfHeaderName') && _config.xsrfHeaderName;
                    requestHeaders.set(headerName, value);
                }
                sendRequest();
            }).catch((error)=>{
                if (!request) return;
                reject((0, $3BlWa.default).from(error, null, config, request));
                done();
                request = null;
            });
        } else sendRequest();
    });
};

});
parcelRegister("1c8fo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ded4f3106fb1f2d$export$2e2bcd8739ae039; });

var $3BlWa = parcelRequire("3BlWa");
'use strict';
function $0ded4f3106fb1f2d$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $3BlWa.default)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $3BlWa.default).ERR_BAD_REQUEST : (0, $3BlWa.default).ERR_BAD_RESPONSE, response.config, response.request, response));
}

});

parcelRegister("5ByqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $414b1dbae8a0519f$export$2e2bcd8739ae039; });
'use strict';
const $414b1dbae8a0519f$var$urlParserControlCharacters = /[\t\n\r]/g;
function $414b1dbae8a0519f$export$2e2bcd8739ae039(url) {
    if (typeof url !== 'string') return url;
    let start = 0;
    while(start < url.length && url.charCodeAt(start) <= 0x20)start++;
    return url.slice(start).replace($414b1dbae8a0519f$var$urlParserControlCharacters, '');
}

});

parcelRegister("inLLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61f6c561e799608$export$2e2bcd8739ae039; });
'use strict';
function $d61f6c561e799608$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1].toLowerCase() || '';
}

});

parcelRegister("3BTe1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a0faa5a261fe760$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $7RQMv = parcelRequire("7RQMv");
const $2a0faa5a261fe760$var$decodeCookieValue = (value)=>{
    try {
        return decodeURIComponent(value);
    } catch (e) {
        return value;
    }
};
var $2a0faa5a261fe760$export$2e2bcd8739ae039 = (0, $7RQMv.default).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $lnoYZ.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $lnoYZ.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, $lnoYZ.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $lnoYZ.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const cookieString = document.cookie;
        if (!cookieString) return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = cookieString.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) return $2a0faa5a261fe760$var$decodeCookieValue(cookie.slice(eq + 1));
        }
        return null;
    },
    async readAsync (name) {
        try {
            const store = typeof window !== 'undefined' && window.cookieStore;
            if (store && (0, $lnoYZ.default).isFunction(store.get)) {
                const cookie = await store.get(name);
                // Both APIs expose stored bytes; preserve Axios's existing URI decoding.
                return cookie ? $2a0faa5a261fe760$var$decodeCookieValue(cookie.value) : null;
            }
        } catch (e) {
        // Restricted or unavailable storage retains the synchronous fallback.
        }
        return this.read(name);
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    async readAsync () {
        return null;
    },
    remove () {}
};

});

parcelRegister("cdaMI", function(module, exports) {

$parcel$export(module.exports, "progressEventReducer", function () { return $8e3f1090340f888e$export$c1b28109d46c3592; });
$parcel$export(module.exports, "progressEventDecorator", function () { return $8e3f1090340f888e$export$d9fadd12586c18d6; });
$parcel$export(module.exports, "asyncDecorator", function () { return $8e3f1090340f888e$export$5d35863c355a22a9; });

var $dzlZh = parcelRequire("dzlZh");

var $aH07m = parcelRequire("aH07m");

var $lnoYZ = parcelRequire("lnoYZ");
const $8e3f1090340f888e$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $dzlZh.default)(50, 250);
    return (0, $aH07m.default)((e)=>{
        if (!e || !(0, $lnoYZ.default).isNumber(e.loaded)) return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $8e3f1090340f888e$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $8e3f1090340f888e$export$5d35863c355a22a9 = (fn, scheduler = (0, $lnoYZ.default).asap)=>(...args)=>scheduler(()=>fn(...args));

});
parcelRegister("dzlZh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0f997a6e412bcb$export$2e2bcd8739ae039; });
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $9e0f997a6e412bcb$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $9e0f997a6e412bcb$export$2e2bcd8739ae039 = $9e0f997a6e412bcb$var$speedometer;

});

parcelRegister("aH07m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c8e02ec43b78b7b$export$2e2bcd8739ae039; });
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Array<Function>}
 */ function $7c8e02ec43b78b7b$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    const flushWith = (...args)=>invoke(args);
    return [
        throttled,
        flush,
        flushWith
    ];
}
var $7c8e02ec43b78b7b$export$2e2bcd8739ae039 = $7c8e02ec43b78b7b$var$throttle;

});


parcelRegister("iOm2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db1dff9b7193ce6b$export$2e2bcd8739ae039; });

var $7RQMv = parcelRequire("7RQMv");

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");

var $bhY3V = parcelRequire("bhY3V");

var $3BTe1 = parcelRequire("3BTe1");

var $4IOn3 = parcelRequire("4IOn3");

var $aZNCn = parcelRequire("aZNCn");

var $klzwS = parcelRequire("klzwS");

var $iFhPF = parcelRequire("iFhPF");

var $4fIXp = parcelRequire("4fIXp");
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $db1dff9b7193ce6b$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
const $db1dff9b7193ce6b$var$readCookie = (name)=>(0, $3BTe1.default).read(name);
function $db1dff9b7193ce6b$var$resolveConfig(config, readXsrfCookie = $db1dff9b7193ce6b$var$readCookie) {
    const newConfig = (0, $aZNCn.default)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $lnoYZ.default).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $klzwS.default).from(headers);
    newConfig.url = (0, $4fIXp.default)((0, $4IOn3.default)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $lnoYZ.default).getSafeProp(auth, 'username') || '';
        const password = (0, $lnoYZ.default).getSafeProp(auth, 'password') || '';
        const transitional = own('transitional');
        const encodeUsername = transitional && (0, $lnoYZ.default).hasOwnProp(transitional, 'encodeBasicAuthUsername') && transitional.encodeBasicAuthUsername === true;
        try {
            headers.set('Authorization', // Preserve legacy username bytes unless the caller opts in to UTF-8.
            'Basic ' + btoa((encodeUsername ? $db1dff9b7193ce6b$var$encodeUTF8(username) : username) + ':' + (password ? $db1dff9b7193ce6b$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $3BlWa.default).from(e, (0, $3BlWa.default).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $lnoYZ.default).isFormData(data)) {
        const getHeaders = (0, $lnoYZ.default).getSafeProp(data, 'getHeaders');
        if ((0, $7RQMv.default).hasStandardBrowserEnv || (0, $7RQMv.default).hasStandardBrowserWebWorkerEnv || (0, $lnoYZ.default).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $lnoYZ.default).isFunction(getHeaders)) // Node.js FormData (like form-data package)
        (0, $iFhPF.default)(headers, getHeaders.call(data), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $7RQMv.default).hasStandardBrowserEnv) {
        if ((0, $lnoYZ.default).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $bhY3V.default)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && readXsrfCookie(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $db1dff9b7193ce6b$export$2e2bcd8739ae039 = $db1dff9b7193ce6b$var$resolveConfig;

});
parcelRegister("bhY3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $837fdf62f37e169a$export$2e2bcd8739ae039; });

var $7RQMv = parcelRequire("7RQMv");
var $837fdf62f37e169a$export$2e2bcd8739ae039 = (0, $7RQMv.default).hasStandardBrowserEnv ? ((origin)=>(url)=>{
        url = new URL(url, document.baseURI || (0, $7RQMv.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && origin.port === url.port;
    })(new URL((0, $7RQMv.default).origin)) : ()=>true;

});

parcelRegister("4IOn3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $370258179d1a3b20$export$2e2bcd8739ae039; });

var $3BlWa = parcelRequire("3BlWa");

var $6hWyu = parcelRequire("6hWyu");

var $aAfwH = parcelRequire("aAfwH");

var $5ByqM = parcelRequire("5ByqM");
'use strict';
const $370258179d1a3b20$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $370258179d1a3b20$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $3BlWa.REDACTED}`;
    });
}
function $370258179d1a3b20$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $3BlWa.REDACTED)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $3BlWa.REDACTED)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$370258179d1a3b20$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $370258179d1a3b20$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = (0, $5ByqM.default)(url);
        if ($370258179d1a3b20$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $3BlWa.default)(`Invalid URL ${JSON.stringify($370258179d1a3b20$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $3BlWa.default).ERR_INVALID_URL, config);
    }
}
function $370258179d1a3b20$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $370258179d1a3b20$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $6hWyu.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $370258179d1a3b20$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $aAfwH.default)(baseURL, requestedURL);
    }
    return requestedURL;
}

});
parcelRegister("6hWyu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4941c075822f12f8$export$2e2bcd8739ae039; });
'use strict';
function $4941c075822f12f8$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("aAfwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b494f681ecabccb$export$2e2bcd8739ae039; });
'use strict';
function $7b494f681ecabccb$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}

});


parcelRegister("aZNCn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801616fe11952ef8$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $klzwS = parcelRequire("klzwS");

var $irzm7 = parcelRequire("irzm7");
'use strict';
const $801616fe11952ef8$var$headersToObject = (thing)=>thing instanceof (0, $klzwS.default) ? {
        ...thing
    } : thing;
const $801616fe11952ef8$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>{
        const descriptor = Object.getOwnPropertyDescriptor(thing, symbol);
        return descriptor && descriptor.enumerable;
    }));
    return Object.keys(thing);
};
// Copy params without recursive merges so the serializer remains responsible
// for its depth policy. Only visit defaults that contribute to the result.
function $801616fe11952ef8$var$mergeParams(a, b) {
    const pending = [];
    const copies = new WeakMap();
    const empty = {};
    function copy(target, source) {
        if (!(0, $lnoYZ.default).isPlainObject(source)) return (0, $lnoYZ.default).isArray(source) ? source.slice() : source;
        const base = (0, $lnoYZ.default).isPlainObject(target) ? target : empty;
        let bases = copies.get(source);
        if (!bases) {
            bases = new WeakMap();
            copies.set(source, bases);
        }
        if (bases.has(base)) return bases.get(base);
        const result = {};
        bases.set(base, result);
        pending.push({
            base: base,
            source: source,
            result: result
        });
        return result;
    }
    const result = (0, $lnoYZ.default).isUndefined(b) ? copy(undefined, a) : copy(a, b);
    while(pending.length){
        const { base: base, source: source, result: target } = pending.pop();
        const baseKeys = new Set($801616fe11952ef8$var$ownEnumerableKeys(base));
        const sourceKeys = new Set($801616fe11952ef8$var$ownEnumerableKeys(source));
        const keys = new Set([
            ...baseKeys,
            ...sourceKeys
        ]);
        keys.forEach((key)=>{
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
            const hasSource = sourceKeys.has(key);
            const value = hasSource ? source[key] : undefined;
            const previous = (!hasSource || (0, $lnoYZ.default).isPlainObject(value)) && baseKeys.has(key) ? base[key] : undefined;
            target[key] = hasSource ? copy(previous, value) : copy(undefined, previous);
        });
    }
    (0, $irzm7.default)(result);
    return result;
}
function $801616fe11952ef8$var$getMergedValue(target, source, prop, caseless) {
    if ((0, $lnoYZ.default).isPlainObject(target) && (0, $lnoYZ.default).isPlainObject(source)) return (0, $lnoYZ.default).merge.call({
        caseless: caseless
    }, target, source);
    else if ((0, $lnoYZ.default).isPlainObject(source)) return (0, $lnoYZ.default).merge({}, source);
    else if ((0, $lnoYZ.default).isArray(source)) return source.slice();
    return source;
}
function $801616fe11952ef8$var$mergeDeepProperties(a, b, prop, caseless) {
    if (!(0, $lnoYZ.default).isUndefined(b)) return $801616fe11952ef8$var$getMergedValue(a, b, prop, caseless);
    else if (!(0, $lnoYZ.default).isUndefined(a)) return $801616fe11952ef8$var$getMergedValue(undefined, a, prop, caseless);
}
// eslint-disable-next-line consistent-return
function $801616fe11952ef8$var$valueFromConfig2(a, b) {
    if (!(0, $lnoYZ.default).isUndefined(b)) return $801616fe11952ef8$var$getMergedValue(undefined, b);
}
// eslint-disable-next-line consistent-return
function $801616fe11952ef8$var$defaultToConfig2(a, b) {
    if (!(0, $lnoYZ.default).isUndefined(b)) return $801616fe11952ef8$var$getMergedValue(undefined, b);
    else if (!(0, $lnoYZ.default).isUndefined(a)) return $801616fe11952ef8$var$getMergedValue(undefined, a);
}
function $801616fe11952ef8$var$getMergedTransitionalOption(config1, config2, prop) {
    const transitional2 = (0, $lnoYZ.default).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
    if (!(0, $lnoYZ.default).isUndefined(transitional2)) {
        if ((0, $lnoYZ.default).isPlainObject(transitional2)) {
            if ((0, $lnoYZ.default).hasOwnProp(transitional2, prop)) return transitional2[prop];
        } else return undefined;
    }
    const transitional1 = (0, $lnoYZ.default).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
    if ((0, $lnoYZ.default).isPlainObject(transitional1) && (0, $lnoYZ.default).hasOwnProp(transitional1, prop)) return transitional1[prop];
    return undefined;
}
// eslint-disable-next-line consistent-return
function $801616fe11952ef8$var$mergeDirectKeys(a, b, prop, config1, config2) {
    if ((0, $lnoYZ.default).hasOwnProp(config2, prop)) return $801616fe11952ef8$var$getMergedValue(a, b);
    else if ((0, $lnoYZ.default).hasOwnProp(config1, prop)) return $801616fe11952ef8$var$getMergedValue(undefined, a);
}
function $801616fe11952ef8$var$mergeHeaders(a, b, prop) {
    return $801616fe11952ef8$var$mergeDeepProperties($801616fe11952ef8$var$headersToObject(a), $801616fe11952ef8$var$headersToObject(b), prop, true);
}
// Null-proto, frozen descriptor so a polluted Object.prototype.get cannot turn
// this data descriptor into an accessor descriptor on the way in.
// defineProperty only reads it, so one shared instance serves every call.
const $801616fe11952ef8$var$hasOwnPropertyDescriptor = Object.freeze({
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: false,
    writable: true,
    configurable: true
});
// The strategy table and the strategies above are stateless, so they are
// built once at module load instead of on every call: mergeConfig runs at
// most twice per request (once from a method alias, once from `_request`).
const $801616fe11952ef8$var$mergeMap = {
    url: $801616fe11952ef8$var$valueFromConfig2,
    method: $801616fe11952ef8$var$valueFromConfig2,
    data: $801616fe11952ef8$var$valueFromConfig2,
    baseURL: $801616fe11952ef8$var$defaultToConfig2,
    transformRequest: $801616fe11952ef8$var$defaultToConfig2,
    transformResponse: $801616fe11952ef8$var$defaultToConfig2,
    params: $801616fe11952ef8$var$mergeParams,
    paramsSerializer: $801616fe11952ef8$var$defaultToConfig2,
    timeout: $801616fe11952ef8$var$defaultToConfig2,
    timeoutErrorMessage: $801616fe11952ef8$var$defaultToConfig2,
    withCredentials: $801616fe11952ef8$var$defaultToConfig2,
    withXSRFToken: $801616fe11952ef8$var$defaultToConfig2,
    adapter: $801616fe11952ef8$var$defaultToConfig2,
    responseType: $801616fe11952ef8$var$defaultToConfig2,
    xsrfCookieName: $801616fe11952ef8$var$defaultToConfig2,
    xsrfHeaderName: $801616fe11952ef8$var$defaultToConfig2,
    onUploadProgress: $801616fe11952ef8$var$defaultToConfig2,
    onDownloadProgress: $801616fe11952ef8$var$defaultToConfig2,
    decompress: $801616fe11952ef8$var$defaultToConfig2,
    maxContentLength: $801616fe11952ef8$var$defaultToConfig2,
    maxBodyLength: $801616fe11952ef8$var$defaultToConfig2,
    beforeRedirect: $801616fe11952ef8$var$defaultToConfig2,
    transport: $801616fe11952ef8$var$defaultToConfig2,
    httpAgent: $801616fe11952ef8$var$defaultToConfig2,
    httpsAgent: $801616fe11952ef8$var$defaultToConfig2,
    cancelToken: $801616fe11952ef8$var$defaultToConfig2,
    socketPath: $801616fe11952ef8$var$defaultToConfig2,
    allowedSocketPaths: $801616fe11952ef8$var$defaultToConfig2,
    responseEncoding: $801616fe11952ef8$var$defaultToConfig2,
    validateStatus: $801616fe11952ef8$var$mergeDirectKeys,
    headers: $801616fe11952ef8$var$mergeHeaders
};
function $801616fe11952ef8$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', $801616fe11952ef8$var$hasOwnPropertyDescriptor);
    const keys = $801616fe11952ef8$var$ownEnumerableKeys({
        ...config1,
        ...config2
    });
    for(let i = 0, len = keys.length; i < len; i++){
        const prop = keys[i];
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') continue;
        const merge = (0, $lnoYZ.default).hasOwnProp($801616fe11952ef8$var$mergeMap, prop) ? $801616fe11952ef8$var$mergeMap[prop] : $801616fe11952ef8$var$mergeDeepProperties;
        const a = (0, $lnoYZ.default).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $lnoYZ.default).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge === $801616fe11952ef8$var$mergeDirectKeys ? merge(a, b, prop, config1, config2) : merge(a, b, prop);
        (0, $lnoYZ.default).isUndefined(configValue) && merge !== $801616fe11952ef8$var$mergeDirectKeys || (config[prop] = configValue);
    }
    if ((0, $lnoYZ.default).hasOwnProp(config2, 'validateStatus') && (0, $lnoYZ.default).isUndefined(config2.validateStatus) && $801616fe11952ef8$var$getMergedTransitionalOption(config1, config2, 'validateStatusUndefinedResolves') === false) {
        if ((0, $lnoYZ.default).hasOwnProp(config1, 'validateStatus')) config.validateStatus = $801616fe11952ef8$var$getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}

});
parcelRegister("irzm7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6d62c84442bcdb0$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");
'use strict';
function $d6d62c84442bcdb0$export$2e2bcd8739ae039(params) {
    const pending = [
        {
            value: params
        }
    ];
    const active = new WeakSet();
    const visited = new WeakSet();
    while(pending.length){
        const { value: value, done: done } = pending.pop();
        if (!(0, $lnoYZ.default).isPlainObject(value) && !(0, $lnoYZ.default).isArray(value)) continue;
        if (done) {
            active.delete(value);
            continue;
        }
        if (active.has(value)) throw new (0, $3BlWa.default)('Circular reference detected in params', (0, $3BlWa.default).ERR_BAD_OPTION_VALUE);
        if (visited.has(value)) continue;
        visited.add(value);
        active.add(value);
        pending.push({
            value: value,
            done: true
        });
        const keys = Object.keys(value);
        if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) Object.getOwnPropertySymbols(value).forEach((key)=>{
            const descriptor = Object.getOwnPropertyDescriptor(value, key);
            if (descriptor && descriptor.enumerable) keys.push(key);
        });
        // Shallow array elements retain fields filtered during plain-object merges.
        // Inspect reserved data properties without evaluating their accessors.
        keys.forEach((key)=>{
            if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                const descriptor = Object.getOwnPropertyDescriptor(value, key);
                if (descriptor && (0, $lnoYZ.default).hasOwnProp(descriptor, 'value')) pending.push({
                    value: descriptor.value
                });
            } else pending.push({
                value: value[key]
            });
        });
    }
}

});


parcelRegister("iFhPF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d969e36fa8def489$export$2e2bcd8739ae039; });
'use strict';
const $d969e36fa8def489$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $d969e36fa8def489$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($d969e36fa8def489$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}

});



parcelRegister("9iBOx", function(module, exports) {

$parcel$export(module.exports, "getFetch", function () { return $6c53209649ca9ada$export$3105c6651375d4fa; });

var $7RQMv = parcelRequire("7RQMv");

var $lnoYZ = parcelRequire("lnoYZ");

var $3BlWa = parcelRequire("3BlWa");

var $keCRa = parcelRequire("keCRa");

var $cXDNn = parcelRequire("cXDNn");

var $QsPP6 = parcelRequire("QsPP6");

var $klzwS = parcelRequire("klzwS");

var $cdaMI = parcelRequire("cdaMI");

var $iOm2Z = parcelRequire("iOm2Z");

var $1c8fo = parcelRequire("1c8fo");

var $5gp9V = parcelRequire("5gp9V");

var $leIjU = parcelRequire("leIjU");

var $bVr18 = parcelRequire("bVr18");
const $6c53209649ca9ada$var$DEFAULT_CHUNK_SIZE = 65536;
const $6c53209649ca9ada$var$DEFAULT_REQUEST_OPTIONS = {
    cache: 'default',
    redirect: 'follow',
    referrer: 'about:client',
    referrerPolicy: '',
    mode: 'cors',
    integrity: '',
    keepalive: false,
    priority: 'auto',
    window: null
};
const { isFunction: $6c53209649ca9ada$var$isFunction } = (0, $lnoYZ.default);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $6c53209649ca9ada$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $6c53209649ca9ada$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $lnoYZ.default).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $6c53209649ca9ada$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $6c53209649ca9ada$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $6c53209649ca9ada$var$factory = (env)=>{
    const globalObject = (0, $lnoYZ.default).global !== undefined && (0, $lnoYZ.default).global !== null ? (0, $lnoYZ.default).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $lnoYZ.default).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response,
        Blob: globalObject.Blob
    }, env);
    const envFetch = (0, $lnoYZ.default).hasOwnProp(env, 'fetch') ? env.fetch : undefined;
    const { Request: Request, Response: Response, Blob: Blob } = env;
    const isFetchSupported = envFetch ? $6c53209649ca9ada$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $6c53209649ca9ada$var$isFunction(Request);
    const isResponseSupported = $6c53209649ca9ada$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $6c53209649ca9ada$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $6c53209649ca9ada$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $7RQMv.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $6c53209649ca9ada$var$test(()=>(0, $lnoYZ.default).isReadableStream(new Response('').body));
    // Some runtimes reject every explicit cache mode. Use own defaults for both
    // probes so unrelated polluted options cannot affect cache-mode detection.
    const requestDefaults = Object.assign(Object.create(null), $6c53209649ca9ada$var$DEFAULT_REQUEST_OPTIONS);
    if (isRequestSupported && !$6c53209649ca9ada$var$test(()=>new Request((0, $7RQMv.default).origin, requestDefaults))) {
        delete requestDefaults.cache;
        // Only omit cache when that makes Request construction succeed. Otherwise
        // retain the explicit default that protects supporting runtimes from pollution.
        if (!$6c53209649ca9ada$var$test(()=>new Request((0, $7RQMv.default).origin, requestDefaults))) requestDefaults.cache = $6c53209649ca9ada$var$DEFAULT_REQUEST_OPTIONS.cache;
    }
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $3BlWa.default)(`Response type '${type}' is not supported`, (0, $3BlWa.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $lnoYZ.default).isBlob(body)) return body.size;
        if ((0, $lnoYZ.default).isArrayBufferView(body) || (0, $lnoYZ.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, $lnoYZ.default).isURLSearchParams(body)) body = body + '';
        if ((0, $lnoYZ.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $lnoYZ.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength, maxRedirects: maxRedirects } = (0, $iOm2Z.default)(config);
        const hasMaxContentLength = (0, $lnoYZ.default).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $lnoYZ.default).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $lnoYZ.default).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $keCRa.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosErrors we raise while request or response bodies are being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        let pendingResponseError = null;
        const maxBodyLengthError = ()=>new (0, $3BlWa.default)('Request body larger than maxBodyLength limit', (0, $3BlWa.default).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $lnoYZ.default).getSafeProp(configAuth, 'username') || '';
                const password = (0, $lnoYZ.default).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            let parsedURL;
            if ($6c53209649ca9ada$var$maybeWithAuthCredentials(url)) {
                parsedURL = new URL(url, (0, $7RQMv.default).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $6c53209649ca9ada$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $6c53209649ca9ada$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($6c53209649ca9ada$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && parsedURL && parsedURL.protocol === 'data:') {
                const estimated = (0, $5gp9V.default)(parsedURL.href);
                if (estimated > maxContentLength) throw new (0, $3BlWa.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3BlWa.default).ERR_BAD_RESPONSE, config, request);
            }
            const formContentType = (0, $lnoYZ.default).isSpecCompliantForm(data) && (0, $klzwS.default).from(own('headers')).getContentType();
            let formBoundary;
            if ((0, $lnoYZ.default).isString(formContentType) && /^multipart\/form-data(?:\s*;|$)/i.test(formContentType.trim())) {
                const parameters = (0, $klzwS.default).parseParameters(formContentType);
                if ((0, $lnoYZ.default).hasOwnProp(parameters, 'boundary')) formBoundary = parameters.boundary;
            }
            if ((0, $lnoYZ.default).isSpecCompliantForm(data) && method !== 'get' && method !== 'head' && (hasMaxBodyLength || onUploadProgress && supportsRequestStream || formBoundary !== undefined)) {
                data = (0, $QsPP6.default)(data, Blob, hasMaxBodyLength ? maxBodyLength : Infinity, maxBodyLengthError, formBoundary);
                // Blob.type lowercases its value, including a case-sensitive boundary.
                // Retain the caller's header when an explicit boundary was serialized.
                headers.setContentType(formBoundary === undefined ? data.type : formContentType);
                requestContentLength = data.size;
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $lnoYZ.default).isReadableStream(data) || (0, $lnoYZ.default).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $cXDNn.trackStream)(stream, $6c53209649ca9ada$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $lnoYZ.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $cdaMI.progressEventDecorator)(requestContentLength, (0, $cdaMI.progressEventReducer)((0, $cdaMI.asyncDecorator)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $3BlWa.default)('Stream request bodies are not supported by the current fetch implementation', (0, $3BlWa.default).ERR_NOT_SUPPORT, config, request);
            if (!(0, $lnoYZ.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $lnoYZ.default).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $leIjU.VERSION), false);
            const safeFetchOptions = fetchOptions == null ? fetchOptions : Object.assign(Object.create(null), fetchOptions);
            if (safeFetchOptions) {
                // These options are owned by Axios and are already reflected in the
                // resolved Request passed to fetch.
                delete safeFetchOptions.body;
                delete safeFetchOptions.headers;
                delete safeFetchOptions.method;
                delete safeFetchOptions.signal;
                delete safeFetchOptions.duplex;
                delete safeFetchOptions.credentials;
            }
            const resolvedOptions = Object.assign(Object.create(null), safeFetchOptions, {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $bVr18.toByteStringHeaderObject)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            if (isRequestSupported) {
                (0, $lnoYZ.default).forEach(requestDefaults, (value, key)=>{
                    if (resolvedOptions[key] === undefined) resolvedOptions[key] = value;
                });
                if (resolvedOptions.signal === undefined) resolvedOptions.signal = null;
                if (resolvedOptions.body === undefined) resolvedOptions.body = null;
            }
            if (maxRedirects === 0) {
                resolvedOptions.redirect = 'manual';
                if (safeFetchOptions) safeFetchOptions.redirect = 'manual';
            }
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, safeFetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $klzwS.default).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $lnoYZ.default).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $3BlWa.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3BlWa.default).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $lnoYZ.default).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $cdaMI.progressEventDecorator)(responseContentLength, (0, $cdaMI.progressEventReducer)((0, $cdaMI.asyncDecorator)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw pendingResponseError = new (0, $3BlWa.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3BlWa.default).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $cXDNn.trackStream)(response.body, $6c53209649ca9ada$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $lnoYZ.default).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $3BlWa.default)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $3BlWa.default).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $1c8fo.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, $klzwS.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $3BlWa.default)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Keeping the original error (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            if (pendingResponseError) throw pendingResponseError;
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $3BlWa.default)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $3BlWa.default)('Network Error', (0, $3BlWa.default).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $3BlWa.default).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $6c53209649ca9ada$var$seedCache = new Map();
const $6c53209649ca9ada$export$3105c6651375d4fa = (config)=>{
    const env = Object.create(null);
    const configuredEnv = config && (0, $lnoYZ.default).hasOwnProp(config, 'env') && config.env;
    [
        'fetch',
        'Request',
        'Response',
        'Blob'
    ].forEach((key)=>{
        if (configuredEnv && (0, $lnoYZ.default).hasOwnProp(configuredEnv, key)) env[key] = configuredEnv[key];
    });
    const { fetch: fetch1, Request: Request, Response: Response, Blob: Blob } = env;
    const seeds = [
        Request,
        Response,
        fetch1,
        Blob
    ];
    let len = seeds.length, i = len, seed, target, map = $6c53209649ca9ada$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $6c53209649ca9ada$var$factory(env));
        map = target;
    }
    return target;
};
const $6c53209649ca9ada$var$adapter = $6c53209649ca9ada$export$3105c6651375d4fa();
var $6c53209649ca9ada$export$2e2bcd8739ae039 = $6c53209649ca9ada$var$adapter;

});
parcelRegister("keCRa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebb34189b6a7db0e$export$2e2bcd8739ae039; });

var $fTjDq = parcelRequire("fTjDq");

var $3BlWa = parcelRequire("3BlWa");

var $lnoYZ = parcelRequire("lnoYZ");
const $ebb34189b6a7db0e$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $3BlWa.default) ? err : new (0, $fTjDq.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $3BlWa.default)(`timeout of ${timeout}ms exceeded`, (0, $3BlWa.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            const unsubscribeSignal = (0, $lnoYZ.default).getSafeProp(signal, 'unsubscribe');
            (0, $lnoYZ.default).isFunction(unsubscribeSignal) ? unsubscribeSignal.call(signal, onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $lnoYZ.default).asap(unsubscribe);
    return signal;
};
var $ebb34189b6a7db0e$export$2e2bcd8739ae039 = $ebb34189b6a7db0e$var$composeSignals;

});

parcelRegister("cXDNn", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $96f9dd4010e547ad$export$b0119225647bd83; });
const $96f9dd4010e547ad$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $96f9dd4010e547ad$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $96f9dd4010e547ad$var$readStream(iterable))yield* $96f9dd4010e547ad$export$71b051935044bd5d(chunk, chunkSize);
};
const $96f9dd4010e547ad$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $96f9dd4010e547ad$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $96f9dd4010e547ad$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});

parcelRegister("QsPP6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09db397225355018$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");

var $7RQMv = parcelRequire("7RQMv");

var $3BlWa = parcelRequire("3BlWa");

var $5xlJd = parcelRequire("5xlJd");
function $09db397225355018$export$2e2bcd8739ae039(form, Blob, limit, limitError, boundary) {
    // Report missing Blob support before trying to select a random source.
    if (!(0, $lnoYZ.default).isFunction(Blob)) throw new (0, $3BlWa.default)('Blob is not supported', (0, $3BlWa.default).ERR_NOT_SUPPORT);
    if (boundary === undefined) {
        if ((0, $lnoYZ.default).isFunction((0, $7RQMv.default).generateString)) boundary = 'axios-' + (0, $7RQMv.default).generateString(36, '0123456789abcdef');
        else {
            const crypto = (0, $lnoYZ.default).global.crypto;
            if (!crypto || !(0, $lnoYZ.default).isFunction(crypto.getRandomValues)) throw new (0, $3BlWa.default)('Random byte generation is not supported', (0, $3BlWa.default).ERR_NOT_SUPPORT);
            const random = new Uint8Array(18);
            crypto.getRandomValues(random);
            boundary = 'axios-' + Array.from(random, (value)=>('0' + value.toString(16)).slice(-2)).join('');
        }
    }
    try {
        return (0, $5xlJd.default)(form, Blob, limit, limitError, boundary);
    } catch (error) {
        if (error instanceof (0, $5xlJd.FormDataError)) {
            const code = error.reason === 'boundary' ? (0, $3BlWa.default).ERR_BAD_OPTION_VALUE : (0, $3BlWa.default).ERR_BAD_REQUEST;
            throw new (0, $3BlWa.default)(error.message, code);
        }
        throw error;
    }
}

});
parcelRegister("5xlJd", function(module, exports) {

$parcel$export(module.exports, "FormDataError", function () { return $4080e395766a8bca$export$694d7cf787438f29; });
$parcel$export(module.exports, "default", function () { return $4080e395766a8bca$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");
const $4080e395766a8bca$var$CRLF = '\r\n';
const $4080e395766a8bca$var$normalizeLines = (value)=>String(value).replace(/\r\n|\r|\n/g, $4080e395766a8bca$var$CRLF);
const $4080e395766a8bca$var$escapeName = (value)=>String(value).replace(/[\r\n"]/g, (char)=>char === '\r' ? '%0D' : char === '\n' ? '%0A' : '%22');
// Count UTF-8 bytes without allocating an encoded copy of a field. FormData
// string values normalize line endings; Blob/File contents remain unchanged.
const $4080e395766a8bca$var$stringBytes = (value, normalize)=>{
    let length = 0;
    for(let i = 0; i < value.length; i++){
        const code = value.charCodeAt(i);
        if (normalize && (code === 13 || code === 10)) {
            if (code === 13 && value.charCodeAt(i + 1) === 10) i++;
            length += 2;
        } else if (code < 0x80) length++;
        else if (code < 0x800) length += 2;
        else if (code >= 0xd800 && code <= 0xdbff && value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) {
            length += 4;
            i++;
        } else length += 3;
    }
    return length;
};
class $4080e395766a8bca$export$694d7cf787438f29 extends TypeError {
    constructor(message, reason){
        super(message);
        this.name = 'FormDataError';
        this.reason = reason;
    }
}
function $4080e395766a8bca$export$2e2bcd8739ae039(form, Blob, limit, limitError, boundary) {
    if (!(0, $lnoYZ.default).isFunction(Blob)) throw new $4080e395766a8bca$export$694d7cf787438f29('Blob is not supported', 'blob');
    if (!(0, $lnoYZ.default).isString(boundary) || !/^[A-Za-z0-9'()+_,./:=? -]{1,70}$/.test(boundary) || / $/.test(boundary)) throw new $4080e395766a8bca$export$694d7cf787438f29('Invalid multipart boundary', 'boundary');
    const footer = '--' + boundary + '--' + $4080e395766a8bca$var$CRLF;
    let length = footer.length;
    const parts = [];
    const checkLength = (extra)=>{
        if (length + extra > limit) throw limitError();
    };
    checkLength(0);
    for (const [name, value] of form){
        const isString = (0, $lnoYZ.default).isString(value);
        const valueLength = isString ? $4080e395766a8bca$var$stringBytes(value, true) : value.size;
        if (!Number.isFinite(valueLength) || valueLength < 0) throw new $4080e395766a8bca$export$694d7cf787438f29('Unsupported FormData part size', 'part');
        // Reject large values and names before building normalized header strings.
        checkLength(valueLength + $4080e395766a8bca$var$stringBytes(name, true) + (!isString && value.name ? $4080e395766a8bca$var$stringBytes(value.name, false) : 0) + (!isString && value.type ? $4080e395766a8bca$var$stringBytes(value.type, false) : 0));
        let header = '--' + boundary + $4080e395766a8bca$var$CRLF + 'Content-Disposition: form-data; name="' + $4080e395766a8bca$var$escapeName($4080e395766a8bca$var$normalizeLines(name)) + '"';
        if (!isString) header += '; filename="' + $4080e395766a8bca$var$escapeName((0, $lnoYZ.default).isString(value.name) ? value.name : 'blob') + '"' + $4080e395766a8bca$var$CRLF + 'Content-Type: ' + String(value.type || 'application/octet-stream').replace(/[\r\n]/g, '');
        header += $4080e395766a8bca$var$CRLF + $4080e395766a8bca$var$CRLF;
        const partLength = $4080e395766a8bca$var$stringBytes(header, false) + valueLength + $4080e395766a8bca$var$CRLF.length;
        checkLength(partLength);
        length += partLength;
        parts.push({
            header: header,
            value: value,
            isString: isString
        });
    }
    // Native Blob composition retains existing Blob/File data. No file is read
    // and no complete multipart ArrayBuffer is created to determine its length.
    const blobParts = [];
    for (const part of parts)blobParts.push(part.header, part.isString ? $4080e395766a8bca$var$normalizeLines(part.value) : part.value, $4080e395766a8bca$var$CRLF);
    blobParts.push(footer);
    return new Blob(blobParts, {
        type: 'multipart/form-data; boundary=' + boundary
    });
}

});


parcelRegister("5gp9V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d51f674a750ca53$export$2e2bcd8739ae039; });
/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   percent-decoded body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $3d51f674a750ca53$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $3d51f674a750ca53$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $3d51f674a750ca53$var$isHexDigit(str.charCodeAt(i + 1)) && $3d51f674a750ca53$var$isHexDigit(str.charCodeAt(i + 2));
const $3d51f674a750ca53$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $3d51f674a750ca53$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $3d51f674a750ca53$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $3d51f674a750ca53$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $3d51f674a750ca53$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $3d51f674a750ca53$var$estimatePercentDecodedBase64BufferAllocation = (body)=>{
    // Ordinary Base64 needs only its length and trailing padding.
    if (body.indexOf('%') === -1) return $3d51f674a750ca53$var$estimateBase64BufferAllocation(body);
    let length = 0;
    let previous = 0;
    let last = 0;
    for(let i = 0, len = body.length; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $3d51f674a750ca53$var$isPercentEncodedByte(body, i, len)) {
            code = $3d51f674a750ca53$var$hexValue(body.charCodeAt(i + 1)) * 16 + $3d51f674a750ca53$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        length++;
        previous = last;
        last = code;
    }
    const padding = last === 61 ? previous === 61 ? 2 : 1 : 0;
    return Math.floor((length - padding) * 3 / 4);
};
const $3d51f674a750ca53$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $3d51f674a750ca53$var$isPercentEncodedByte(body, i, len)) {
            code = $3d51f674a750ca53$var$hexValue(body.charCodeAt(i + 1)) * 16 + $3d51f674a750ca53$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($3d51f674a750ca53$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$3d51f674a750ca53$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $3d51f674a750ca53$var$estimateBase64BufferAllocation(body);
    return $3d51f674a750ca53$var$base64Bytes(significant);
};
const $3d51f674a750ca53$var$estimateDataURLBytes = (url, estimateBase64, base64Pattern)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!/^data:/i.test(url)) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = base64Pattern.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $3d51f674a750ca53$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $3d51f674a750ca53$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $3d51f674a750ca53$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $3d51f674a750ca53$var$estimatePercentDecodedBase64Bytes, /; *base64[\t\n\f\r ]*$/i);
}
function $3d51f674a750ca53$export$1f39e64b554a246f(url) {
    // Match fromDataURI's case-insensitive protocol and encoding suffix.
    return $3d51f674a750ca53$var$estimateDataURLBytes(url, $3d51f674a750ca53$var$estimatePercentDecodedBase64BufferAllocation, /;base64$/i);
}

});

parcelRegister("leIjU", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $f75d48db5a624441$export$a4ad2735b021c132; });
const $f75d48db5a624441$export$a4ad2735b021c132 = "1.21.0";

});




parcelRegister("7Jvar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a14e996cbe16cd7$export$2e2bcd8739ae039; });

var $leIjU = parcelRequire("leIjU");

var $3BlWa = parcelRequire("3BlWa");
'use strict';
const $5a14e996cbe16cd7$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $5a14e996cbe16cd7$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $5a14e996cbe16cd7$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $5a14e996cbe16cd7$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $leIjU.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $3BlWa.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $3BlWa.default).ERR_DEPRECATED);
        if (version && !$5a14e996cbe16cd7$var$deprecatedWarnings[opt]) {
            $5a14e996cbe16cd7$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$5a14e996cbe16cd7$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $5a14e996cbe16cd7$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $3BlWa.default)('options must be an object', (0, $3BlWa.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $3BlWa.default)('option ' + opt + ' must be ' + result, (0, $3BlWa.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $3BlWa.default)('Unknown option ' + opt, (0, $3BlWa.default).ERR_BAD_OPTION);
    }
}
var $5a14e996cbe16cd7$export$2e2bcd8739ae039 = {
    assertOptions: $5a14e996cbe16cd7$var$assertOptions,
    validators: $5a14e996cbe16cd7$var$validators
};

});


parcelRegister("3sfVr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2840571489895e91$export$2e2bcd8739ae039; });

var $fTjDq = parcelRequire("fTjDq");
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $2840571489895e91$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $fTjDq.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $2840571489895e91$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $2840571489895e91$export$2e2bcd8739ae039 = $2840571489895e91$var$CancelToken;

});

parcelRegister("hWCvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d105b97f26962ab6$export$2e2bcd8739ae039; });
'use strict';
function $d105b97f26962ab6$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("a1ZvZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d9b6fde4d75fe0$export$2e2bcd8739ae039; });

var $lnoYZ = parcelRequire("lnoYZ");
'use strict';
function $74d9b6fde4d75fe0$export$2e2bcd8739ae039(payload) {
    return (0, $lnoYZ.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("4DC2S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $360850f863a6c940$export$2e2bcd8739ae039; });
const $360850f863a6c940$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    /**
   * @deprecated Use `ContentTooLarge` instead.
   */ PayloadTooLarge: 413,
    ContentTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    /**
   * @deprecated Use `UnprocessableContent` instead.
   */ UnprocessableEntity: 422,
    UnprocessableContent: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($360850f863a6c940$var$HttpStatusCode).forEach(([key, value])=>{
    if ($360850f863a6c940$var$HttpStatusCode[value] === undefined) $360850f863a6c940$var$HttpStatusCode[value] = key;
});
var $360850f863a6c940$export$2e2bcd8739ae039 = $360850f863a6c940$var$HttpStatusCode;

});



parcelRegister("kK73x", function(module, exports) {

$parcel$export(module.exports, "REACT_APP_AUTH_CLIENTID", function () { return $6385f3990e1afaff$export$86418af64495c91a; });
$parcel$export(module.exports, "REACT_APP_AUTH_AUTHORITY", function () { return $6385f3990e1afaff$export$b63d04bf2b883c66; });
$parcel$export(module.exports, "REACT_APP_AUTH_REDIRECT_URI", function () { return $6385f3990e1afaff$export$aa4512a2f7b5b6e0; });
$parcel$export(module.exports, "REACT_APP_AUTH_SCOPE", function () { return $6385f3990e1afaff$export$1a1ec953b528f792; });
$parcel$export(module.exports, "REACT_APP_BACKENDURL", function () { return $6385f3990e1afaff$export$5e6c164a709aa411; });
$parcel$export(module.exports, "REACT_APP_CRYSTALURL", function () { return $6385f3990e1afaff$export$287d2823a454ef64; });
$parcel$export(module.exports, "REACT_APP_STAGE", function () { return $6385f3990e1afaff$export$b3fcf1fbd33113a9; });
$parcel$export(module.exports, "STYLES_TO_CLEAN", function () { return $6385f3990e1afaff$export$6766f11fcfb1e821; });
$parcel$export(module.exports, "STYLES_TO_DELETE", function () { return $6385f3990e1afaff$export$577164c20d9bfb9e; });
const $6385f3990e1afaff$export$86418af64495c91a = "__REACT_APP_AUTH_CLIENTID__";
const $6385f3990e1afaff$export$b63d04bf2b883c66 = "__REACT_APP_AUTH_AUTHORITY__";
const $6385f3990e1afaff$export$aa4512a2f7b5b6e0 = "__REACT_APP_AUTH_REDIRECT_URI__";
const $6385f3990e1afaff$export$1a1ec953b528f792 = "__REACT_APP_AUTH_SCOPE__";
const $6385f3990e1afaff$export$5e6c164a709aa411 = "__REACT_APP_BACKENDURL__";
const $6385f3990e1afaff$export$287d2823a454ef64 = "__REACT_APP_CRYSTALURL__";
const $6385f3990e1afaff$export$b3fcf1fbd33113a9 = "__REACT_APP_STAGE__";
const $6385f3990e1afaff$export$6766f11fcfb1e821 = [
    "Optional",
    "OptionalLocked"
];
const $6385f3990e1afaff$export$577164c20d9bfb9e = [
    "Notes"
];

});

parcelRegister("9cA6s", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $6b313d64cfcdc558$export$882461b6382ed46c; }, function (v) { return $6b313d64cfcdc558$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $6b313d64cfcdc558$export$757ceba2d55c277e; }, function (v) { return $6b313d64cfcdc558$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $6b313d64cfcdc558$export$83d89fbfd8236492; }, function (v) { return $6b313d64cfcdc558$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $6b313d64cfcdc558$export$882461b6382ed46c;
var $6b313d64cfcdc558$export$757ceba2d55c277e;
var $6b313d64cfcdc558$export$83d89fbfd8236492;
"use strict";



(function() {
    function findHook(fiber, id) {
        for(fiber = fiber.memoizedState; null !== fiber && 0 < id;)fiber = fiber.next, id--;
        return fiber;
    }
    function copyWithSetImpl(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) console.warn("copyWithRename() expects paths of the same length");
        else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                console.warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
        }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        index + 1 === oldPath.length ? (updated[newPath[index]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    }
    function copyWithDeleteImpl(obj, path, index) {
        var key = path[index], updated = isArrayImpl(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    }
    function shouldSuspendImpl() {
        return !1;
    }
    function shouldErrorImpl() {
        return null;
    }
    function warnInvalidHookAccess() {
        console.error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks");
    }
    function warnInvalidContextAccess() {
        console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    }
    function noop() {}
    function warnForMissingKey() {}
    function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    }
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function scheduleRoot(root, element) {
        root.context === emptyContextObject && (updateContainerImpl(root.current, 2, element, root, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root, update) {
        if (null !== resolveFamily) {
            var staleFamilies = update.staleFamilies;
            update = update.updatedFamilies;
            flushPendingEffects();
            scheduleFibersWithFamiliesRecursively(root.current, update, staleFamilies);
            flushSyncWork$1();
        }
    }
    function setRefreshHandler(handler) {
        resolveFamily = handler;
    }
    function isValidContainer(node) {
        return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
        for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
        for(; node.return;)node = node.return;
        return 3 === node.tag ? fiber : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (13 === fiber.tag) {
            var suspenseState = fiber.memoizedState;
            null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
            if (null !== suspenseState) return suspenseState.dehydrated;
        }
        return null;
    }
    function getActivityInstanceFromFiber(fiber) {
        if (31 === fiber.tag) {
            var activityState = fiber.memoizedState;
            null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
            if (null !== activityState) return activityState.dehydrated;
        }
        return null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error("Unable to find node on an unmounted component.");
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, _child = parentA.child; _child;){
                    if (_child === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    for(_child = parentB.child; _child;){
                        if (_child === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (3 !== a.tag) throw Error("Unable to find node on an unmounted component.");
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function traverseFragmentInstancesAndTextInstances(fragmentFiber, fn, a, b, c) {
        traverseVisibleInstancesAndTextInstances(fragmentFiber.child, !1, fn, a, b, c);
    }
    function traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
        for(; null !== child;){
            if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
            child = child.sibling;
        }
        return !1;
    }
    function getFragmentParentInstanceOrContainerFiber(fiber) {
        for(fiber = fiber.return; null !== fiber;){
            if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
            fiber = fiber.return;
        }
        return null;
    }
    function fiberIsPortaledIntoHost(fiber) {
        var foundPortalParent = !1;
        for(fiber = fiber.return; null !== fiber;){
            4 === fiber.tag && (foundPortalParent = !0);
            if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
            fiber = fiber.return;
        }
        return foundPortalParent;
    }
    function getFragmentInstanceOrTextInstanceSiblings(fiber) {
        var result = [
            null,
            null
        ], parentHostFiber = getFragmentParentInstanceOrContainerFiber(fiber);
        if (null === parentHostFiber) return result;
        findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
            foundSelf: !1
        });
        return result;
    }
    function findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
        for(; null !== child;){
            if (child === self) state.foundSelf = !0;
            else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
                if (state.foundSelf) return result[1] = child, !0;
                result[0] = child;
            } else if ((22 !== child.tag || null === child.memoizedState) && findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
            child = child.sibling;
        }
        return !1;
    }
    function getInstanceFromHostFiber(fiber) {
        switch(fiber.tag){
            case 5:
            case 27:
            case 6:
                return fiber.stateNode;
            case 3:
                return fiber.stateNode.containerInfo;
            default:
                throw Error("Expected to find a host node. This is a bug in React.");
        }
    }
    function isFiberPrecedingCheck(child, target, boundary) {
        return child === boundary ? !0 : child === target ? (searchTarget = child, !0) : !1;
    }
    function isFiberFollowingCheck(child, target, boundary) {
        return child === boundary ? (searchBoundary = child, !1) : child === target ? (null !== searchBoundary && (searchTarget = child), !0) : !1;
    }
    function getParentForFragmentAncestors(inst) {
        if (null === inst) return null;
        do inst = null === inst ? null : inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
        return inst ? inst : null;
    }
    function getLowestCommonAncestor(instA, instB, getParent) {
        for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
        tempA = 0;
        for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
        for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
        for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
        for(; depthA--;){
            if (instA === instB || null !== instB && instA === instB.alternate) return instA;
            instA = getParent(instA);
            instB = getParent(instB);
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
            case REACT_VIEW_TRANSITION_TYPE:
                return "ViewTransition";
        }
        if ("object" === typeof type) switch("number" === typeof type.tag && console.error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function getComponentNameFromOwner(owner) {
        return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
        var type = fiber.type;
        switch(fiber.tag){
            case 31:
                return "Activity";
            case 24:
                return "Cache";
            case 9:
                return (type._context.displayName || "Context") + ".Consumer";
            case 10:
                return type.displayName || "Context";
            case 18:
                return "DehydratedFragment";
            case 11:
                return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
            case 7:
                return "Fragment";
            case 26:
            case 27:
            case 5:
                return type;
            case 4:
                return "Portal";
            case 3:
                return "Root";
            case 6:
                return "Text";
            case 16:
                return getComponentNameFromType(type);
            case 8:
                return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
            case 22:
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
                break;
            case 12:
                return "Profiler";
            case 21:
                return "Scope";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 25:
                return "TracingMarker";
            case 30:
                return "ViewTransition";
            case 1:
            case 0:
            case 14:
            case 15:
                if ("function" === typeof type) return type.displayName || type.name || null;
                if ("string" === typeof type) return type;
                break;
            case 29:
                type = fiber._debugInfo;
                if (null != type) {
                    for(var i = type.length - 1; 0 <= i; i--)if ("string" === typeof type[i].name) return type[i].name;
                }
                if (null !== fiber.return) return getComponentNameFromFiber(fiber.return);
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value, fiber) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        fiberStack[index$jscomp$0] = fiber;
        cursor.current = value;
    }
    function requiredContext(c) {
        null === c && console.error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance, fiber);
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor, null, fiber);
        var nextRootContext = nextRootInstance.nodeType;
        switch(nextRootContext){
            case 9:
            case 11:
                nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
                nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
                break;
            default:
                if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(nextRootInstance, nextRootContext);
                else switch(nextRootContext){
                    case "svg":
                        nextRootInstance = HostContextNamespaceSvg;
                        break;
                    case "math":
                        nextRootInstance = HostContextNamespaceMath;
                        break;
                    default:
                        nextRootInstance = HostContextNamespaceNone;
                }
        }
        nextRootContext = nextRootContext.toLowerCase();
        nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
        nextRootContext = {
            context: nextRootInstance,
            ancestorInfo: nextRootContext
        };
        pop(contextStackCursor, fiber);
        push(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
        var stateHook = fiber.memoizedState;
        null !== stateHook && (HostTransitionContext._currentValue = stateHook.memoizedState, push(hostTransitionProviderCursor, fiber, fiber));
        stateHook = requiredContext(contextStackCursor.current);
        var type = fiber.type;
        var nextContext = getChildHostContextProd(stateHook.context, type);
        type = updatedAncestorInfoDev(stateHook.ancestorInfo, type);
        nextContext = {
            context: nextContext,
            ancestorInfo: type
        };
        stateHook !== nextContext && (push(contextFiberStackCursor, fiber, fiber), push(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {}
    function disableLogs() {
        if (0 === disabledDepth) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
                configurable: !0,
                enumerable: !0,
                value: disabledLog,
                writable: !0
            };
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (0 === disabledDepth) {
            var props = {
                configurable: !0,
                enumerable: !0,
                writable: !0
            };
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        }
        0 > disabledDepth && console.error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    function formatOwnerStack(error) {
        var prevPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        error = error.stack;
        Error.prepareStackTrace = prevPrepareStackTrace;
        error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
        prevPrepareStackTrace = error.indexOf("\n");
        -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
        prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
        -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf("\n", prevPrepareStackTrace));
        if (-1 !== prevPrepareStackTrace) error = error.slice(0, prevPrepareStackTrace);
        else return "";
        return error;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (void 0 !== frame) return frame;
        reentry = !0;
        frame = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher = null;
        previousDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = null;
        disableLogs();
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                Fake = !1;
                                try {
                                    var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                    Object.defineProperty(fn.prototype, "props", {
                                        configurable: !0,
                                        set: function() {
                                            throw Error();
                                        }
                                    });
                                    Fake = !0;
                                    new fn();
                                } finally{
                                    Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                                }
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                for(; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes("DetermineComponentFrameRoot");)_RunInRootFrame$Deter++;
                if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length) for(namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter];)_RunInRootFrame$Deter--;
                for(; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                        do if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                            var _frame = "\n" + sampleLines[namePropDescriptor].replace(" at new ", " at ");
                            fn.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn.displayName));
                            "function" === typeof fn && componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                        while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, ReactSharedInternals.H = previousDispatcher, reenableLogs(), Error.prepareStackTrace = frame;
        }
        sampleLines = (sampleLines = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
        "function" === typeof fn && componentFrameCache.set(fn, sampleLines);
        return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            case 30:
                return describeBuiltInComponentFrame("ViewTransition");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do {
                info += describeFiber(workInProgress, previous);
                var debugInfo = workInProgress._debugInfo;
                if (debugInfo) for(var i = debugInfo.length - 1; 0 <= i; i--){
                    var entry = debugInfo[i];
                    if ("string" === typeof entry.name) {
                        var JSCompiler_temp_const = info;
                        a: {
                            var name = entry.name, env = entry.env, location = entry.debugLocation;
                            if (null != location) {
                                var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                                if (-1 !== lastLine.indexOf(name)) {
                                    var JSCompiler_inline_result = "\n" + lastLine;
                                    break a;
                                }
                            }
                            JSCompiler_inline_result = describeBuiltInComponentFrame(name + (env ? " [" + env + "]" : ""));
                        }
                        info = JSCompiler_temp_const + JSCompiler_inline_result;
                    }
                }
                previous = workInProgress;
                workInProgress = workInProgress.return;
            }while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn) {
        return (fn = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(fn) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (null === current) return null;
        var owner = current._debugOwner;
        return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
        if (null === current) return "";
        var workInProgress = current;
        try {
            var info = "";
            6 === workInProgress.tag && (workInProgress = workInProgress.return);
            switch(workInProgress.tag){
                case 26:
                case 27:
                case 5:
                    info += describeBuiltInComponentFrame(workInProgress.type);
                    break;
                case 13:
                    info += describeBuiltInComponentFrame("Suspense");
                    break;
                case 19:
                    info += describeBuiltInComponentFrame("SuspenseList");
                    break;
                case 31:
                    info += describeBuiltInComponentFrame("Activity");
                    break;
                case 30:
                    info += describeBuiltInComponentFrame("ViewTransition");
                    break;
                case 0:
                case 15:
                case 1:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type));
                    break;
                case 11:
                    workInProgress._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(workInProgress.type.render));
            }
            for(; workInProgress;)if ("number" === typeof workInProgress.tag) {
                var fiber = workInProgress;
                workInProgress = fiber._debugOwner;
                var debugStack = fiber._debugStack;
                if (workInProgress && debugStack) {
                    var formattedStack = formatOwnerStack(debugStack);
                    "" !== formattedStack && (info += "\n" + formattedStack);
                }
            } else if (null != workInProgress.debugStack) {
                var ownerStack = workInProgress.debugStack;
                (workInProgress = workInProgress.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
            } else break;
            var JSCompiler_inline_result = info;
        } catch (x) {
            JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
        }
        return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
        var previousFiber = current;
        setCurrentFiber(fiber);
        try {
            return null !== fiber && fiber._debugTask ? fiber._debugTask.run(callback.bind(null, arg0, arg1, arg2, arg3, arg4)) : callback(arg0, arg1, arg2, arg3, arg4);
        } finally{
            setCurrentFiber(previousFiber);
        }
        throw Error("runWithFiberInDEV should never be called in production. This is a bug in React.");
    }
    function setCurrentFiber(fiber) {
        ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
        isRendering = !1;
        current = fiber;
    }
    function typeName(value) {
        return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
        try {
            return testStringCoercion(value), !1;
        } catch (e) {
            return !0;
        }
    }
    function testStringCoercion(value) {
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.", attributeName, typeName(value)), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) return console.error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.", propName, typeName(value)), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) return console.error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.", typeName(value)), testStringCoercion(value);
    }
    function injectInternals(internals) {
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) return !0;
        if (!hook.supportsFiber) return console.error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"), !0;
        try {
            rendererID = hook.inject(internals), injectedHook = hook;
        } catch (err) {
            console.error("React instrumentation encountered an error: %o.", err);
        }
        return hook.checkDCE ? !0 : !1;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & -lanes;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function getEntangledLanes(root, renderLanes) {
        0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
        var allEntangledLanes = root.entangledLanes;
        if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
            var index = 31 - clz32(allEntangledLanes), lane = 1 << index;
            renderLanes |= root[index];
            allEntangledLanes &= ~lane;
        }
        return renderLanes;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return console.error("Should have found matching lanes. This is a bug in React."), -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index = 31 - clz32(remainingLanes), lane = 1 << index;
            entanglements[index] = 0;
            expirationTimes[index] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index] = null, index = 0; index < hiddenUpdatesForLane.length; index++){
                var update = hiddenUpdatesForLane[index];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index = 31 - clz32(rootEntangledLanes), lane = 1 << index;
            lane & entangledLanes | root[index] & entangledLanes && (root[index] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (isDevToolsPresent) for(root = root.pendingUpdatersLaneMap; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            root[index].add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (isDevToolsPresent) for(var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap, memoizedUpdaters = root.memoizedUpdaters; 0 < lanes;){
            var index = 31 - clz32(lanes);
            root = 1 << index;
            index = pendingUpdatersLaneMap[index];
            0 < index.size && (index.forEach(function(fiber) {
                var alternate = fiber.alternate;
                null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
            }), index.clear());
            lanes &= ~root;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 0 !== DiscreteEventPriority && DiscreteEventPriority < lanes ? 0 !== ContinuousEventPriority && ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
        var updatePriority = ReactDOMSharedInternals.p;
        if (0 !== updatePriority) return updatePriority;
        updatePriority = window.event;
        return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn) {
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            return ReactDOMSharedInternals.p = priority, fn();
        } finally{
            ReactDOMSharedInternals.p = previousPriority;
        }
    }
    function detachDeletedInstance(node) {
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
        var targetInst;
        if (targetInst = targetNode[internalInstanceKey]) return targetInst;
        for(var parentNode = targetNode.parentNode; parentNode;){
            if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
                parentNode = targetInst.alternate;
                if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                    if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                    targetNode = getParentHydrationBoundary(targetNode);
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    function getInstanceFromNode(node) {
        if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
            var tag = node.tag;
            if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
        }
        return null;
    }
    function getNodeFromInstance(inst) {
        var tag = inst.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root) {
        var resources = root[internalRootNodeResourcesKey];
        resources || (resources = root[internalRootNodeResourcesKey] = {
            hoistableStyles: new Map(),
            hoistableScripts: new Map()
        });
        return resources;
    }
    function markNodeAsHoistable(node) {
        node[internalHoistableMarker] = !0;
    }
    function clearPendingLoadOnNode(node) {
        node[internalLoadPendingKey] = void 0;
    }
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        registrationNameDependencies[registrationName] && console.error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
        for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
    }
    function checkControlledValueProps(tagName, props) {
        hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || null == props.value || ("select" === tagName ? console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`.") : console.error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."));
        props.onChange || props.readOnly || props.disabled || null == props.checked || console.error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
        illegalAttributeNameCache[attributeName] = !0;
        console.error("Invalid attribute name: `%s`", attributeName);
        return !1;
    }
    function pushMutationContext() {
        var prev = viewTransitionMutationContext;
        viewTransitionMutationContext = !1;
        return prev;
    }
    function getValueForAttributeOnCustomComponent(node, name, expected) {
        if (isAttributeNameSafe(name)) {
            if (!node.hasAttribute(name)) {
                switch(typeof expected){
                    case "symbol":
                    case "object":
                        return expected;
                    case "function":
                        return expected;
                    case "boolean":
                        if (!1 === expected) return expected;
                }
                return void 0 === expected ? void 0 : null;
            }
            node = "nonce" === name.toLowerCase() ? node.nonce : node.getAttribute(name);
            if ("" === node && !0 === expected) return !0;
            checkAttributeStringCoercion(expected, name);
            return node === "" + expected ? expected : node;
        }
    }
    function setValueForAttribute(node, name, value) {
        if (isAttributeNameSafe(name)) {
            if (null === value) node.removeAttribute(name);
            else {
                switch(typeof value){
                    case "undefined":
                    case "function":
                    case "symbol":
                        node.removeAttribute(name);
                        return;
                    case "boolean":
                        var prefix = name.toLowerCase().slice(0, 5);
                        if ("data-" !== prefix && "aria-" !== prefix) {
                            node.removeAttribute(name);
                            return;
                        }
                }
                checkAttributeStringCoercion(value, name);
                node.setAttribute(name, value);
            }
        }
    }
    function setValueForKnownAttribute(node, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttribute(name, value);
        }
    }
    function setValueForNamespacedAttribute(node, namespace, name, value) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                case "boolean":
                    node.removeAttribute(name);
                    return;
            }
            checkAttributeStringCoercion(value, name);
            node.setAttributeNS(namespace, name, value);
        }
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "bigint":
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                return checkFormFieldValueStringCoercion(value), value;
            default:
                return "";
        }
    }
    function isCheckable(elem) {
        var type = elem.type;
        return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
            var get = descriptor.get, set = descriptor.set;
            Object.defineProperty(node, valueField, {
                configurable: !0,
                get: function() {
                    return get.call(this);
                },
                set: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                    set.call(this, value);
                }
            });
            Object.defineProperty(node, valueField, {
                enumerable: descriptor.enumerable
            });
            return {
                getValue: function() {
                    return currentValue;
                },
                setValue: function(value) {
                    checkFormFieldValueStringCoercion(value);
                    currentValue = "" + value;
                },
                stopTracking: function() {
                    node._valueTracker = null;
                    delete node[valueField];
                }
            };
        }
    }
    function track(node) {
        if (!node._valueTracker) {
            var valueField = isCheckable(node) ? "checked" : "value";
            node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
        }
    }
    function updateValueIfChanged(node) {
        if (!node) return !1;
        var tracker = node._valueTracker;
        if (!tracker) return !0;
        var lastValue = tracker.getValue();
        var value = "";
        node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
        node = value;
        return node !== lastValue ? (tracker.setValue(node), !0) : !1;
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
        return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
            return "\\" + ch.charCodeAt(0).toString(16) + " ";
        });
    }
    function validateInputProps(element, props) {
        void 0 === props.checked || void 0 === props.defaultChecked || didWarnCheckedDefaultChecked || (console.error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnCheckedDefaultChecked = !0);
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue$1 || (console.error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type), didWarnValueDefaultValue$1 = !0);
    }
    function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
        element.name = "";
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element.type = type) : element.removeAttribute("type");
        if (null != value) {
            if ("number" === type) {
                if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
            } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
        } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
        null != value ? "number" === type && element.value == value ? setDefaultValue(element, getToStringValue(element.value)) : setDefaultValue(element, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
        null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
        null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? (checkAttributeStringCoercion(name, "name"), element.name = "" + getToStringValue(name)) : element.removeAttribute("name");
    }
    function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
        null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element.type = type);
        if (null != value || null != defaultValue) {
            if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
                track(element);
                return;
            }
            defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
            value = null != value ? "" + getToStringValue(value) : defaultValue;
            isHydrating || value === element.value || (element.value = value);
            element.defaultValue = value;
        }
        checked = null != checked ? checked : defaultChecked;
        checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
        element.checked = isHydrating ? element.checked : !!checked;
        element.defaultChecked = !!checked;
        null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (checkAttributeStringCoercion(name, "name"), element.name = name);
        track(element);
    }
    function setDefaultValue(node, value) {
        node.defaultValue !== "" + value && (node.defaultValue = "" + value);
    }
    function validateOptionProps(element, props) {
        null == props.value && ("object" === typeof props.children && null !== props.children ? React.Children.forEach(props.children, function(child) {
            null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = !0, console.error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."));
        }) : null == props.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = !0, console.error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")));
        null == props.selected || didWarnSelectedSetOnOption || (console.error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), didWarnSelectedSetOnOption = !0);
    }
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        node = node.options;
        if (multiple) {
            multiple = {};
            for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
            for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
        } else {
            propValue = "" + getToStringValue(propValue);
            multiple = null;
            for(i = 0; i < node.length; i++){
                if (node[i].value === propValue) {
                    node[i].selected = !0;
                    setDefaultSelected && (node[i].defaultSelected = !0);
                    return;
                }
                null !== multiple || node[i].disabled || (multiple = node[i]);
            }
            null !== multiple && (multiple.selected = !0);
        }
    }
    function validateSelectProps(element, props) {
        for(element = 0; element < valuePropNames.length; element++){
            var propName = valuePropNames[element];
            if (null != props[propName]) {
                var propNameIsArray = isArrayImpl(props[propName]);
                props.multiple && !propNameIsArray ? console.error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum()) : !props.multiple && propNameIsArray && console.error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
            }
        }
        void 0 === props.value || void 0 === props.defaultValue || didWarnValueDefaultValue || (console.error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"), didWarnValueDefaultValue = !0);
    }
    function validateTextareaProps(element, props) {
        void 0 === props.value || void 0 === props.defaultValue || didWarnValDefaultVal || (console.error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component"), didWarnValDefaultVal = !0);
        null != props.children && null == props.value && console.error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
    }
    function updateTextarea(element, value, defaultValue) {
        if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
            element.defaultValue !== value && (element.defaultValue = value);
            return;
        }
        element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
    }
    function initTextarea(element, value, defaultValue, children) {
        if (null == value) {
            if (null != children) {
                if (null != defaultValue) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArrayImpl(children)) {
                    if (1 < children.length) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            null == defaultValue && (defaultValue = "");
            value = defaultValue;
        }
        defaultValue = getToStringValue(value);
        element.defaultValue = defaultValue;
        children = element.textContent;
        children === defaultValue && "" !== children && null !== children && (element.value = children);
        track(element);
    }
    function findNotableNode(node, indent) {
        return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent ? findNotableNode(node.children[0], indent) : node;
    }
    function indentation(indent) {
        return "  " + "  ".repeat(indent);
    }
    function added(indent) {
        return "+ " + "  ".repeat(indent);
    }
    function removed(indent) {
        return "- " + "  ".repeat(indent);
    }
    function describeFiberType(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return fiber.type;
            case 16:
                return "Lazy";
            case 31:
                return "Activity";
            case 13:
                return "Suspense";
            case 19:
                return "SuspenseList";
            case 0:
            case 15:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            case 11:
                return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
            case 1:
                return fiber = fiber.type, fiber.displayName || fiber.name || null;
            default:
                return null;
        }
    }
    function describeTextNode(content, maxLength) {
        return needsEscaping.test(content) ? (content = JSON.stringify(content), content.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content.slice(0, maxLength - 7) + '..."}' : "{" + content + "}") : content.length > maxLength ? 5 > maxLength ? '{"..."}' : content.slice(0, maxLength - 3) + "..." : content;
    }
    function describeTextDiff(clientText, serverProps, indent) {
        var maxLength = 120 - 2 * indent;
        if (null === serverProps) return added(indent) + describeTextNode(clientText, maxLength) + "\n";
        if ("string" === typeof serverProps) {
            for(var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++);
            firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
            return added(indent) + describeTextNode(clientText, maxLength) + "\n" + removed(indent) + describeTextNode(serverProps, maxLength) + "\n";
        }
        return indentation(indent) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object) {
        return Object.prototype.toString.call(object).replace(/^\[object (.*)\]$/, function(m, p0) {
            return p0;
        });
    }
    function describeValue(value, maxLength) {
        switch(typeof value){
            case "string":
                return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
            case "object":
                if (null === value) return "null";
                if (isArrayImpl(value)) return "[...]";
                if (value.$$typeof === REACT_ELEMENT_TYPE) return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
                var name = objectName(value);
                if ("Object" === name) {
                    name = "";
                    maxLength -= 2;
                    for(var propName in value)if (value.hasOwnProperty(propName)) {
                        var jsonPropName = JSON.stringify(propName);
                        jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                        maxLength -= propName.length - 2;
                        jsonPropName = describeValue(value[propName], 15 > maxLength ? maxLength : 15);
                        maxLength -= jsonPropName.length;
                        if (0 > maxLength) {
                            name += "" === name ? "..." : ", ...";
                            break;
                        }
                        name += ("" === name ? "" : ",") + propName + ":" + jsonPropName;
                    }
                    return "{" + name + "}";
                }
                return name;
            case "function":
                return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
            default:
                return String(value);
        }
    }
    function describePropValue(value, maxLength) {
        return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props, rowPrefix) {
        var remainingRowLength = 120 - rowPrefix.length - type.length, properties = [], propName;
        for(propName in props)if (props.hasOwnProperty(propName) && "children" !== propName) {
            var propValue = describePropValue(props[propName], 120 - rowPrefix.length - propName.length - 1);
            remainingRowLength -= propName.length + propValue.length + 2;
            properties.push(propName + "=" + propValue);
        }
        return 0 === properties.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent) {
        var properties = "", remainingServerProperties = assign({}, serverObject), propName;
        for(propName in clientObject)if (clientObject.hasOwnProperty(propName)) {
            delete remainingServerProperties[propName];
            var maxLength = 120 - 2 * indent - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
            serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties += added(indent) + propName + ": " + clientPropValue + "\n", properties += removed(indent) + propName + ": " + maxLength + "\n") : properties += added(indent) + propName + ": " + clientPropValue + "\n";
        }
        for(var _propName in remainingServerProperties)remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(remainingServerProperties[_propName], 120 - 2 * indent - _propName.length - 2), properties += removed(indent) + _propName + ": " + clientObject + "\n");
        return properties;
    }
    function describeElementDiff(type, clientProps, serverProps, indent) {
        var content = "", serverPropNames = new Map();
        for(propName$jscomp$0 in serverProps)serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(propName$jscomp$0.toLowerCase(), propName$jscomp$0);
        if (1 === serverPropNames.size && serverPropNames.has("children")) content += describeExpandedElement(type, clientProps, indentation(indent));
        else {
            for(var _propName2 in clientProps)if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
                var maxLength$jscomp$0 = 120 - 2 * (indent + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
                if (void 0 !== serverPropName) {
                    serverPropNames.delete(_propName2.toLowerCase());
                    var propName$jscomp$0 = clientProps[_propName2];
                    serverPropName = serverProps[serverPropName];
                    var clientPropValue = describePropValue(propName$jscomp$0, maxLength$jscomp$0);
                    maxLength$jscomp$0 = describePropValue(serverPropName, maxLength$jscomp$0);
                    "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content += indentation(indent + 1) + _propName2 + "={{\n" + describePropertiesDiff(propName$jscomp$0, serverPropName, indent + 2) + indentation(indent + 1) + "}}\n" : (content += added(indent + 1) + _propName2 + "=" + clientPropValue + "\n", content += removed(indent + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
                } else content += indentation(indent + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
            }
            serverPropNames.forEach(function(propName) {
                if ("children" !== propName) {
                    var maxLength = 120 - 2 * (indent + 1) - propName.length - 1;
                    content += removed(indent + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
                }
            });
            content = "" === content ? indentation(indent) + "<" + type + ">\n" : indentation(indent) + "<" + type + "\n" + content + indentation(indent) + ">\n";
        }
        type = serverProps.children;
        clientProps = clientProps.children;
        if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
            serverPropNames = "";
            if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) serverPropNames = "" + clientProps;
            content += describeTextDiff(serverPropNames, "" + type, indent + 1);
        } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps) content = null == type ? content + describeTextDiff("" + clientProps, null, indent + 1) : content + describeTextDiff("" + clientProps, void 0, indent + 1);
        return content;
    }
    function describeSiblingFiber(fiber, indent) {
        var type = describeFiberType(fiber);
        if (null === type) {
            type = "";
            for(fiber = fiber.child; fiber;)type += describeSiblingFiber(fiber, indent), fiber = fiber.sibling;
            return type;
        }
        return indentation(indent) + "<" + type + ">\n";
    }
    function describeNode(node, indent) {
        var skipToNode = findNotableNode(node, indent);
        if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode)) return indentation(indent) + "...\n" + describeNode(skipToNode, indent + 1);
        skipToNode = "";
        var debugInfo = node.fiber._debugInfo;
        if (debugInfo) for(var i = 0; i < debugInfo.length; i++){
            var serverComponentName = debugInfo[i].name;
            "string" === typeof serverComponentName && (skipToNode += indentation(indent) + "<" + serverComponentName + ">\n", indent++);
        }
        debugInfo = "";
        i = node.fiber.pendingProps;
        if (6 === node.fiber.tag) debugInfo = describeTextDiff(i, node.serverProps, indent), indent++;
        else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName) {
            if (void 0 === node.serverProps) {
                debugInfo = indent;
                var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content = "";
                for(propName in i)if (i.hasOwnProperty(propName) && "children" !== propName) {
                    var propValue = describePropValue(i[propName], 15);
                    maxLength -= propName.length + propValue.length + 2;
                    if (0 > maxLength) {
                        content += " ...";
                        break;
                    }
                    content += " " + propName + "=" + propValue;
                }
                debugInfo = indentation(debugInfo) + "<" + serverComponentName + content + ">\n";
                indent++;
            } else null === node.serverProps ? (debugInfo = describeExpandedElement(serverComponentName, i, added(indent)), indent++) : "string" === typeof node.serverProps ? console.error("Should not have matched a non HostText fiber to a Text node. This is a bug in React.") : (debugInfo = describeElementDiff(serverComponentName, i, node.serverProps, indent), indent++);
        }
        var propName = "";
        i = node.fiber.child;
        for(serverComponentName = 0; i && serverComponentName < node.children.length;)maxLength = node.children[serverComponentName], maxLength.fiber === i ? (propName += describeNode(maxLength, indent), serverComponentName++) : propName += describeSiblingFiber(i, indent), i = i.sibling;
        i && 0 < node.children.length && (propName += indentation(indent) + "...\n");
        i = node.serverTail;
        null === node.serverProps && indent--;
        for(node = 0; node < i.length; node++)serverComponentName = i[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent) + describeTextNode(serverComponentName, 120 - 2 * indent) + "\n") : propName + describeExpandedElement(serverComponentName.type, serverComponentName.props, removed(indent));
        return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
        try {
            return "\n\n" + describeNode(rootNode, 0);
        } catch (x) {
            return "";
        }
    }
    function describeAncestors(ancestor, child, props) {
        for(var fiber = child, node = null, distanceFromLeaf = 0; fiber;)fiber === ancestor && (distanceFromLeaf = 0), node = {
            fiber: fiber,
            children: null !== node ? [
                node
            ] : [],
            serverProps: fiber === child ? props : fiber === ancestor ? null : void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
        return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfoDev), info = {
            tag: tag
        };
        -1 !== inScopeTags.indexOf(tag) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
        -1 !== buttonScopeTags.indexOf(tag) && (ancestorInfo.pTagInButtonScope = null);
        -1 !== specialTags.indexOf(tag) && "address" !== tag && "div" !== tag && "p" !== tag && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
        ancestorInfo.current = info;
        "form" === tag && (ancestorInfo.formTag = info);
        "a" === tag && (ancestorInfo.aTagInScope = info);
        "button" === tag && (ancestorInfo.buttonTagInScope = info);
        "nobr" === tag && (ancestorInfo.nobrTagInScope = info);
        "p" === tag && (ancestorInfo.pTagInButtonScope = info);
        "li" === tag && (ancestorInfo.listItemTagAutoclosing = info);
        if ("dd" === tag || "dt" === tag) ancestorInfo.dlItemTagAutoclosing = info;
        "#document" === tag || "html" === tag ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
        null !== oldInfo || "#document" !== tag && "html" !== tag && "body" !== tag ? !0 === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = !1) : ancestorInfo.implicitRootScope = !0;
        return ancestorInfo;
    }
    function isTagValidWithParent(tag, parentTag, implicitRootScope) {
        switch(parentTag){
            case "tr":
                return "th" === tag || "td" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "tbody":
            case "thead":
            case "tfoot":
                return "tr" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "colgroup":
                return "col" === tag || "template" === tag;
            case "table":
                return "caption" === tag || "colgroup" === tag || "tbody" === tag || "tfoot" === tag || "thead" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "head":
                return "base" === tag || "basefont" === tag || "bgsound" === tag || "link" === tag || "meta" === tag || "title" === tag || "noscript" === tag || "noframes" === tag || "style" === tag || "script" === tag || "template" === tag;
            case "html":
                if (implicitRootScope) break;
                return "head" === tag || "body" === tag || "frameset" === tag;
            case "frameset":
                return "frame" === tag;
            case "#document":
                if (!implicitRootScope) return "html" === tag;
        }
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
            case "rp":
            case "rt":
                return -1 === impliedEndTags.indexOf(parentTag);
            case "caption":
            case "col":
            case "colgroup":
            case "input":
                return "select" !== parentTag;
            case "frameset":
            case "frame":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                return null == parentTag;
            case "head":
                return implicitRootScope || null === parentTag;
            case "html":
                return implicitRootScope && "#document" === parentTag || null === parentTag;
            case "body":
                return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
        }
        return !0;
    }
    function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    }
    function findAncestor(parent, tagName) {
        for(; parent;){
            switch(parent.tag){
                case 5:
                case 26:
                case 27:
                    if (parent.type === tagName) return parent;
            }
            parent = parent.return;
        }
        return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
        var parentInfo = ancestorInfo.current;
        ancestorInfo = (parentInfo = isTagValidWithParent(childTag, parentInfo && parentInfo.tag, ancestorInfo.implicitRootScope) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        ancestorInfo = parentInfo || ancestorInfo;
        if (!ancestorInfo) return !0;
        var ancestorTag = ancestorInfo.tag;
        ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
        if (didWarn[ancestorInfo]) return !1;
        didWarn[ancestorInfo] = !0;
        var ancestor = (ancestorInfo = current) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
        parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error("In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, parentInfo, ancestorDescription)) : console.error("In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s", tagDisplayName, ancestorTag, ancestorDescription);
        ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
            console.error("<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.", ancestorTag, tagDisplayName);
        }));
        return !1;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
        if (implicitRootScope || isTagValidWithParent("#text", parentTag, !1)) return !0;
        implicitRootScope = "#text|" + parentTag;
        if (didWarn[implicitRootScope]) return !1;
        didWarn[implicitRootScope] = !0;
        var ancestor = (implicitRootScope = current) ? findAncestor(implicitRootScope, parentTag) : null;
        implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(ancestor, implicitRootScope, 6 !== implicitRootScope.tag ? {
            children: null
        } : null) : "";
        /\S/.test(childText) ? console.error("In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s", parentTag, implicitRootScope) : console.error("In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s", parentTag, implicitRootScope);
        return !1;
    }
    function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    }
    function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    }
    function setValueForStyle(style, styleName, value) {
        var isCustomProperty = 0 === styleName.indexOf("--");
        isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported style property %s. Did you mean %s?", styleName, camelize(styleName.replace(msPattern, "ms-")))) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = !0, console.error("Unsupported vendor-prefixed style property %s. Did you mean %s?", styleName, styleName.charAt(0).toUpperCase() + styleName.slice(1))) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = !0, console.error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', styleName, value.replace(badStyleValueWithSemicolonPattern, ""))), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = !0, console.error("`NaN` is an invalid value for the `%s` css style property.", styleName)) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = !0, console.error("`Infinity` is an invalid value for the `%s` css style property.", styleName))));
        null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style[styleName] = ("" + value).trim()) : style[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
        if (null != styles && "object" !== typeof styles) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        styles && Object.freeze(styles);
        node = node.style;
        if (null != prevStyles) {
            if (styles) {
                var expandedUpdates = {};
                if (prevStyles) {
                    for(var key in prevStyles)if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key)) for(var longhands = shorthandToLonghand[key] || [
                        key
                    ], i = 0; i < longhands.length; i++)expandedUpdates[longhands[i]] = key;
                }
                for(var _key in styles)if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key])) for(key = shorthandToLonghand[_key] || [
                    _key
                ], longhands = 0; longhands < key.length; longhands++)expandedUpdates[key[longhands]] = _key;
                _key = {};
                for(var key$jscomp$0 in styles)for(key = shorthandToLonghand[key$jscomp$0] || [
                    key$jscomp$0
                ], longhands = 0; longhands < key.length; longhands++)_key[key[longhands]] = key$jscomp$0;
                key$jscomp$0 = {};
                for(var _key2 in expandedUpdates)if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i = key + "," + longhands, !key$jscomp$0[i])) {
                    key$jscomp$0[i] = !0;
                    i = console;
                    var value = styles[key];
                    i.error.call(i, "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating", key, longhands);
                }
            }
            for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", viewTransitionMutationContext = !0);
            for(var _styleName in styles)_key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && (setValueForStyle(node, _styleName, _key2), viewTransitionMutationContext = !0);
        } else for(expandedUpdates in styles)styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
        if (-1 === tagName.indexOf("-")) return !1;
        switch(tagName){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return !1;
            default:
                return !0;
        }
    }
    function getAttributeAlias(name) {
        return aliases.get(name) || name;
    }
    function validateProperty$1(tagName, name) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return !0;
        if (rARIACamel$1.test(name)) {
            tagName = "aria-" + name.slice(4).toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return console.error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name), warnedProperties$1[name] = !0;
            if (name !== tagName) return console.error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0;
        }
        if (rARIA$1.test(name)) {
            tagName = name.toLowerCase();
            tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
            if (null == tagName) return warnedProperties$1[name] = !0, !1;
            name !== tagName && (console.error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, tagName), warnedProperties$1[name] = !0);
        }
        return !0;
    }
    function validateProperties$2(type, props) {
        var invalidProps = [], key;
        for(key in props)validateProperty$1(type, key) || invalidProps.push(key);
        props = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === invalidProps.length ? console.error("Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type) : 1 < invalidProps.length && console.error("Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props", props, type);
    }
    function validateProperty(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return !0;
        var lowerCasedName = name.toLowerCase();
        if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName) return console.error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), warnedProperties[name] = !0;
        if ("function" === typeof value && ("form" === tagName && "action" === name || "input" === tagName && "formAction" === name || "button" === tagName && "formAction" === name)) return !0;
        if (null != eventRegistry) {
            tagName = eventRegistry.possibleRegistrationNames;
            if (eventRegistry.registrationNameDependencies.hasOwnProperty(name)) return !0;
            eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
            if (null != eventRegistry) return console.error("Invalid event handler property `%s`. Did you mean `%s`?", name, eventRegistry), warnedProperties[name] = !0;
            if (EVENT_NAME_REGEX.test(name)) return console.error("Unknown event handler property `%s`. It will be ignored.", name), warnedProperties[name] = !0;
        } else if (EVENT_NAME_REGEX.test(name)) return INVALID_EVENT_NAME_REGEX.test(name) && console.error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name), warnedProperties[name] = !0;
        if (rARIA.test(name) || rARIACamel.test(name)) return !0;
        if ("innerhtml" === lowerCasedName) return console.error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), warnedProperties[name] = !0;
        if ("aria" === lowerCasedName) return console.error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), warnedProperties[name] = !0;
        if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value) return console.error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value), warnedProperties[name] = !0;
        if ("number" === typeof value && isNaN(value)) return console.error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name), warnedProperties[name] = !0;
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name) return console.error("Invalid DOM property `%s`. Did you mean `%s`?", name, lowerCasedName), warnedProperties[name] = !0;
        } else if (name !== lowerCasedName) return console.error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName), warnedProperties[name] = !0;
        switch(name){
            case "dangerouslySetInnerHTML":
            case "children":
            case "style":
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                return !0;
            case "innerText":
            case "textContent":
                return !0;
        }
        switch(typeof value){
            case "boolean":
                switch(name){
                    case "autoFocus":
                    case "checked":
                    case "multiple":
                    case "muted":
                    case "selected":
                    case "contentEditable":
                    case "spellCheck":
                    case "draggable":
                    case "value":
                    case "autoReverse":
                    case "externalResourcesRequired":
                    case "focusable":
                    case "preserveAlpha":
                    case "allowFullScreen":
                    case "async":
                    case "autoPlay":
                    case "controls":
                    case "credentialless":
                    case "default":
                    case "defer":
                    case "disabled":
                    case "disablePictureInPicture":
                    case "disableRemotePlayback":
                    case "formNoValidate":
                    case "hidden":
                    case "loop":
                    case "noModule":
                    case "noValidate":
                    case "open":
                    case "playsInline":
                    case "readOnly":
                    case "required":
                    case "reversed":
                    case "scoped":
                    case "seamless":
                    case "itemScope":
                    case "capture":
                    case "download":
                    case "inert":
                        return !0;
                    default:
                        lowerCasedName = name.toLowerCase().slice(0, 5);
                        if ("data-" === lowerCasedName || "aria-" === lowerCasedName) return !0;
                        value ? console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name) : console.error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
                        return warnedProperties[name] = !0;
                }
            case "function":
            case "symbol":
                return warnedProperties[name] = !0, !1;
            case "string":
                if ("false" === value || "true" === value) {
                    switch(name){
                        case "checked":
                        case "selected":
                        case "multiple":
                        case "muted":
                        case "allowFullScreen":
                        case "async":
                        case "autoPlay":
                        case "controls":
                        case "credentialless":
                        case "default":
                        case "defer":
                        case "disabled":
                        case "disablePictureInPicture":
                        case "disableRemotePlayback":
                        case "formNoValidate":
                        case "hidden":
                        case "loop":
                        case "noModule":
                        case "noValidate":
                        case "open":
                        case "playsInline":
                        case "readOnly":
                        case "required":
                        case "reversed":
                        case "scoped":
                        case "seamless":
                        case "itemScope":
                        case "inert":
                            break;
                        default:
                            return !0;
                    }
                    console.error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
                    warnedProperties[name] = !0;
                }
        }
        return !0;
    }
    function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [], key;
        for(key in props)validateProperty(type, key, props[key], eventRegistry) || unknownProps.push(key);
        props = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        1 === unknownProps.length ? console.error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type) : 1 < unknownProps.length && console.error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ", props, type);
    }
    function sanitizeURL(url) {
        return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$1() {}
    function getEventTarget(nativeEvent) {
        nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
        nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
        return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
        var internalInstance = getInstanceFromNode(target);
        if (internalInstance && (target = internalInstance.stateNode)) {
            var props = target[internalPropsKey] || null;
            a: switch(target = internalInstance.stateNode, internalInstance.type){
                case "input":
                    updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                    internalInstance = props.name;
                    if ("radio" === props.type && null != internalInstance) {
                        for(props = target; props.parentNode;)props = props.parentNode;
                        checkAttributeStringCoercion(internalInstance, "name");
                        props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                            var otherNode = props[internalInstance];
                            if (otherNode !== target && otherNode.form === target.form) {
                                var otherProps = otherNode[internalPropsKey] || null;
                                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                                updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                            }
                        }
                        for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                    }
                    break a;
                case "textarea":
                    updateTextarea(target, props.value, props.defaultValue);
                    break a;
                case "select":
                    internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
            }
        }
    }
    function batchedUpdates$1(fn, a, b) {
        if (isInsideEventHandler) return fn(a, b);
        isInsideEventHandler = !0;
        try {
            var JSCompiler_inline_result = fn(a);
            return JSCompiler_inline_result;
        } finally{
            if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
                if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
            }
        }
    }
    function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (null === stateNode) return null;
        var props = stateNode[internalPropsKey] || null;
        if (null === props) return null;
        stateNode = props[registrationName];
        a: switch(registrationName){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
                inst = !props;
                break a;
            default:
                inst = !1;
        }
        if (inst) return null;
        if (stateNode && "function" !== typeof stateNode) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type.");
        return stateNode;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
        for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
        return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
        var keyCode = nativeEvent.keyCode;
        "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
        10 === nativeEvent && (nativeEvent = 13);
        return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
        return !0;
    }
    function functionThatReturnsFalse() {
        return !1;
    }
    function createSyntheticEvent(Interface) {
        function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
            this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = !0;
                var event = this.nativeEvent;
                event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
            },
            persist: function() {},
            isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
        var nativeEvent = this.nativeEvent;
        return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
    }
    function getEventModifierState() {
        return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
            case "keydown":
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                return !0;
            default:
                return !1;
        }
    }
    function getDataFromCustomEvent(nativeEvent) {
        nativeEvent = nativeEvent.detail;
        return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                if (nativeEvent.which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = !0;
                return SPACEBAR_CHAR;
            case "textInput":
                return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
            default:
                return null;
        }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
        switch(domEventName){
            case "paste":
                return null;
            case "keypress":
                if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                    if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                    if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
    }
    function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return !1;
        eventNameSuffix = "on" + eventNameSuffix;
        var isSupported = eventNameSuffix in document;
        isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
        return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
            target
        ] : restoreTarget = target;
        inst = accumulateTwoPhaseListeners(inst, "onChange");
        0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
            event: nativeEvent,
            listeners: inst
        }));
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
        activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
        if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
            var dispatchQueue = [];
            createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
            batchedUpdates$1(runEventInBatch, dispatchQueue);
        }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
        if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function getActiveElement(doc) {
        doc = doc || ("undefined" !== typeof document ? document : void 0);
        if ("undefined" === typeof doc) return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e$2) {
            return doc.body;
        }
    }
    function getLeafNode(node) {
        for(; node && node.firstChild;)node = node.firstChild;
        return node;
    }
    function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        root = 0;
        for(var nodeEnd; node;){
            if (3 === node.nodeType) {
                nodeEnd = root + node.textContent.length;
                if (root <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - root
                };
                root = nodeEnd;
            }
            a: {
                for(; node;){
                    if (node.nextSibling) {
                        node = node.nextSibling;
                        break a;
                    }
                    node = node.parentNode;
                }
                node = void 0;
            }
            node = getLeafNode(node);
        }
    }
    function containsNode(outerNode, innerNode) {
        return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
    }
    function getActiveElementDeep(containerInfo) {
        containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
        for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
            try {
                var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
            } catch (err) {
                JSCompiler_inline_result = !1;
            }
            if (JSCompiler_inline_result) containerInfo = element.contentWindow;
            else break;
            element = getActiveElement(containerInfo.document);
        }
        return element;
    }
    function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
        mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
            start: doc.selectionStart,
            end: doc.selectionEnd
        } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
            anchorNode: doc.anchorNode,
            anchorOffset: doc.anchorOffset,
            focusNode: doc.focusNode,
            focusOffset: doc.focusOffset
        }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
            event: nativeEvent,
            listeners: doc
        }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName], styleProp;
        for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function getViewTransitionName(props, instance) {
        if (null != props.name && "auto" !== props.name) return props.name;
        if (null !== instance.autoName) return instance.autoName;
        props = pendingEffectsRoot.identifierPrefix;
        var globalClientId = globalClientIdCounter$1++;
        props = "_" + props + "t_" + globalClientId.toString(32) + "_";
        return instance.autoName = props;
    }
    function getClassNameByType(classByType) {
        if (null == classByType || "string" === typeof classByType) return classByType;
        var className = null, activeTypes = pendingTransitionTypes;
        if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
            var match = classByType[activeTypes[i]];
            if (null != match) {
                if ("none" === match) return "none";
                className = null == className ? match : className + (" " + match);
            }
        }
        return null == className ? classByType.default : className;
    }
    function getViewTransitionClassName(defaultClass, eventClass) {
        defaultClass = getClassNameByType(defaultClass);
        eventClass = getClassNameByType(eventClass);
        return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
    }
    function getArrayKind(array) {
        for(var kind = EMPTY_ARRAY, i = 0; i < array.length && i < OBJECT_WIDTH_LIMIT; i++){
            var value = array[i];
            if ("object" === typeof value && null !== value) {
                if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
                    if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY) return COMPLEX_ARRAY;
                    kind = ENTRIES_ARRAY;
                } else return COMPLEX_ARRAY;
            } else {
                if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY || "bigint" === typeof value) return COMPLEX_ARRAY;
                kind = PRIMITIVE_ARRAY;
            }
        }
        return kind;
    }
    function addObjectToProperties(object, properties, indent, prefix) {
        if (!ArrayBuffer.isView(object)) {
            var addedProperties = 0, key;
            for(key in object)if (hasOwnProperty.call(object, key) && "_" !== key[0] && (addedProperties++, addValueToProperties(key, object[key], properties, indent, prefix), addedProperties >= OBJECT_WIDTH_LIMIT)) {
                properties.push([
                    prefix + "\u00a0\u00a0".repeat(indent) + "Only " + OBJECT_WIDTH_LIMIT + " properties are shown. React will not log more properties of this object.",
                    ""
                ]);
                break;
            }
        }
    }
    function readReactElementTypeof(value) {
        return "$$typeof" in value && hasOwnProperty.call(value, "$$typeof") ? value.$$typeof : void 0;
    }
    function addValueToProperties(propertyName, value, properties, indent, prefix) {
        switch(typeof value){
            case "object":
                if (null === value) {
                    value = "null";
                    break;
                } else {
                    if (readReactElementTypeof(value) === REACT_ELEMENT_TYPE) {
                        var typeName = getComponentNameFromType(value.type) || "\u2026", key = value.key;
                        value = value.props;
                        var propsKeys = Object.keys(value), propsLength = propsKeys.length;
                        if (null == key && 0 === propsLength) {
                            value = "<" + typeName + " />";
                            break;
                        }
                        if (3 > indent || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                            value = "<" + typeName + " \u2026 />";
                            break;
                        }
                        properties.push([
                            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                            "<" + typeName
                        ]);
                        null !== key && addValueToProperties("key", key, properties, indent + 1, prefix);
                        propertyName = !1;
                        key = 0;
                        for(var propKey in value)if (key++, "children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName = !0) : hasOwnProperty.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(propKey, value[propKey], properties, indent + 1, prefix), key >= OBJECT_WIDTH_LIMIT) break;
                        properties.push([
                            "",
                            propertyName ? ">\u2026</" + typeName + ">" : "/>"
                        ]);
                        return;
                    }
                    typeName = Object.prototype.toString.call(value);
                    typeName = typeName.slice(8, typeName.length - 1);
                    if (ArrayBuffer.isView(value)) {
                        value = value.length;
                        value = "number" === typeof value ? typeName + "(" + value + ")" : typeName;
                        break;
                    }
                    if ("Array" === typeName) {
                        if (propKey = value.length > OBJECT_WIDTH_LIMIT, key = getArrayKind(value), key === PRIMITIVE_ARRAY || key === EMPTY_ARRAY) {
                            value = JSON.stringify(propKey ? value.slice(0, OBJECT_WIDTH_LIMIT).concat("\u2026") : value);
                            break;
                        } else if (key === ENTRIES_ARRAY) {
                            properties.push([
                                prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                                ""
                            ]);
                            for(propertyName = 0; propertyName < value.length && propertyName < OBJECT_WIDTH_LIMIT; propertyName++)typeName = value[propertyName], addValueToProperties(typeName[0], typeName[1], properties, indent + 1, prefix);
                            propKey && addValueToProperties(OBJECT_WIDTH_LIMIT.toString(), "\u2026", properties, indent + 1, prefix);
                            return;
                        }
                    }
                    if ("Promise" === typeName) {
                        if ("fulfilled" === value.status) {
                            if (typeName = properties.length, addValueToProperties(propertyName, value.value, properties, indent, prefix), properties.length > typeName) {
                                properties = properties[typeName];
                                properties[1] = "Promise<" + (properties[1] || "Object") + ">";
                                return;
                            }
                        } else if ("rejected" === value.status && (typeName = properties.length, addValueToProperties(propertyName, value.reason, properties, indent, prefix), properties.length > typeName)) {
                            properties = properties[typeName];
                            properties[1] = "Rejected Promise<" + properties[1] + ">";
                            return;
                        }
                        properties.push([
                            "\u00a0\u00a0".repeat(indent) + propertyName,
                            "Promise"
                        ]);
                        return;
                    }
                    "Object" === typeName && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName = propKey.constructor.name);
                    properties.push([
                        prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
                        "Object" === typeName ? 3 > indent ? "" : "\u2026" : typeName
                    ]);
                    3 > indent && addObjectToProperties(value, properties, indent + 1, prefix);
                    return;
                }
            case "function":
                value = value.name;
                value = "" === value || "string" !== typeof value ? "() => {}" : value + "() {}";
                break;
            case "string":
                value = value === OMITTED_PROP_ERROR ? "\u2026" : JSON.stringify(1024 <= value.length ? value.slice(0, 1023) + "\u2026" : value);
                break;
            case "undefined":
                value = "undefined";
                break;
            case "boolean":
                value = value ? "true" : "false";
                break;
            default:
                value = String(value);
        }
        properties.push([
            prefix + "\u00a0\u00a0".repeat(indent) + propertyName,
            value
        ]);
    }
    function addObjectDiffToProperties(prev, next, properties, indent) {
        var isDeeplyEqual = !0, prevPropertiesChecked = 0;
        for(key in prev){
            if (prevPropertiesChecked > OBJECT_WIDTH_LIMIT) {
                properties.push([
                    "Previous object has more than " + OBJECT_WIDTH_LIMIT + " properties. React will not attempt to diff objects with too many properties.",
                    ""
                ]);
                isDeeplyEqual = !1;
                break;
            }
            key in next || (properties.push([
                REMOVED + "\u00a0\u00a0".repeat(indent) + key,
                "\u2026"
            ]), isDeeplyEqual = !1);
            prevPropertiesChecked++;
        }
        prevPropertiesChecked = 0;
        for(var _key in next){
            if (prevPropertiesChecked > OBJECT_WIDTH_LIMIT) {
                properties.push([
                    "Next object has more than " + OBJECT_WIDTH_LIMIT + " properties. React will not attempt to diff objects with too many properties.",
                    ""
                ]);
                isDeeplyEqual = !1;
                break;
            }
            if (_key in prev) {
                var key = prev[_key];
                var nextValue = next[_key];
                if (key !== nextValue) {
                    if (0 === indent && "children" === _key) {
                        isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                        properties.push([
                            REMOVED + isDeeplyEqual,
                            "\u2026"
                        ], [
                            ADDED + isDeeplyEqual,
                            "\u2026"
                        ]);
                        isDeeplyEqual = !1;
                        continue;
                    }
                    if (!(3 <= indent)) {
                        if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && readReactElementTypeof(key) === readReactElementTypeof(nextValue)) {
                            if (readReactElementTypeof(nextValue) === REACT_ELEMENT_TYPE) {
                                if (key.type === nextValue.type && key.key === nextValue.key) {
                                    key = getComponentNameFromType(nextValue.type) || "\u2026";
                                    isDeeplyEqual = "\u00a0\u00a0".repeat(indent) + _key;
                                    key = "<" + key + " \u2026 />";
                                    properties.push([
                                        REMOVED + isDeeplyEqual,
                                        key
                                    ], [
                                        ADDED + isDeeplyEqual,
                                        key
                                    ]);
                                    isDeeplyEqual = !1;
                                    continue;
                                }
                            } else {
                                var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                                if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                                    prevKind = [
                                        UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                        "[object Array]" === nextKind ? "Array" : ""
                                    ];
                                    properties.push(prevKind);
                                    nextKind = properties.length;
                                    addObjectDiffToProperties(key, nextValue, properties, indent + 1) ? nextKind === properties.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = !1;
                                    continue;
                                }
                            }
                        } else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                            key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                            properties.push([
                                UNCHANGED + "\u00a0\u00a0".repeat(indent) + _key,
                                key + " Referentially unequal function closure. Consider memoization."
                            ]);
                            continue;
                        }
                    }
                    addValueToProperties(_key, key, properties, indent, REMOVED);
                    addValueToProperties(_key, nextValue, properties, indent, ADDED);
                    isDeeplyEqual = !1;
                }
            } else properties.push([
                ADDED + "\u00a0\u00a0".repeat(indent) + _key,
                "\u2026"
            ]), isDeeplyEqual = !1;
            prevPropertiesChecked++;
        }
        return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
        currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
        supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(performance.measure.bind(performance, trigger, reusableComponentOptions)) : performance.measure(trigger, reusableComponentOptions), performance.clearMeasures(trigger));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
        logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
        var name = getComponentNameFromFiber(fiber);
        if (null !== name && supportsUserTiming) {
            var alternate = fiber.alternate, selfTime = fiber.actualDuration;
            if (null === alternate || alternate.child !== fiber.child) for(var child = fiber.child; null !== child; child = child.sibling)selfTime -= child.actualDuration;
            selfTime = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
            var props = fiber.memoizedProps;
            wasHydrated = fiber._debugTask;
            null !== props && null !== alternate && alternate.memoizedProps !== props ? (child = [
                reusableChangedPropsEntry
            ], props = addObjectDiffToProperties(alternate.memoizedProps, props, child, 0), 1 < child.length ? (props && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = !0, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = selfTime, reusableComponentDevToolDetails.tooltipText = name), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, fiber = "\u200b" + name, null != wasHydrated ? wasHydrated.run(performance.measure.bind(performance, fiber, reusableComponentOptions)) : performance.measure(fiber, reusableComponentOptions), performance.clearMeasures(fiber)) : null != wasHydrated ? wasHydrated.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : null != wasHydrated ? wasHydrated.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, selfTime);
        }
    }
    function logComponentErrored(fiber, startTime, endTime, errors) {
        if (supportsUserTiming) {
            var name = getComponentNameFromFiber(fiber);
            if (null !== name) {
                for(var debugTask = null, properties = [], i = 0; i < errors.length; i++){
                    var capturedValue = errors[i];
                    null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
                    capturedValue = capturedValue.value;
                    properties.push([
                        "Error",
                        "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
                    ]);
                }
                null !== fiber.key && addValueToProperties("key", fiber.key, properties, 0, "");
                null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties, 0, "");
                null == debugTask && (debugTask = fiber._debugTask);
                fiber = {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            color: "error",
                            track: COMPONENTS_TRACK,
                            tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                            properties: properties
                        }
                    }
                };
                name = "\u200b" + name;
                debugTask ? debugTask.run(performance.measure.bind(performance, name, fiber)) : performance.measure(name, fiber);
                performance.clearMeasures(name);
            }
        }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors) {
        if (null !== errors) {
            if (supportsUserTiming) {
                var name = getComponentNameFromFiber(fiber);
                if (null !== name) {
                    selfTime = [];
                    for(var i = 0; i < errors.length; i++){
                        var error = errors[i].value;
                        selfTime.push([
                            "Error",
                            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                        ]);
                    }
                    null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
                    null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
                    startTime = {
                        start: startTime,
                        end: endTime,
                        detail: {
                            devtools: {
                                color: "error",
                                track: COMPONENTS_TRACK,
                                tooltipText: "A lifecycle or effect errored",
                                properties: selfTime
                            }
                        }
                    };
                    fiber = fiber._debugTask;
                    endTime = "\u200b" + name;
                    fiber ? fiber.run(performance.measure.bind(performance, endTime, startTime)) : performance.measure(endTime, startTime);
                    performance.clearMeasures(endTime);
                }
            }
        } else name = getComponentNameFromFiber(fiber), null !== name && supportsUserTiming && (errors = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(console.timeStamp.bind(console, name, startTime, endTime, COMPONENTS_TRACK, void 0, errors)) : console.timeStamp(name, startTime, endTime, COMPONENTS_TRACK, void 0, errors));
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Prewarm", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(console.timeStamp.bind(console, "Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes)) : console.timeStamp("Suspended", startTime, endTime, currentTrack, LANES_TRACK_GROUP, lanes));
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Errored", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "error"));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(reason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
    }
    function logCommitErrored(startTime, endTime, errors, passive, debugTask) {
        if (supportsUserTiming && !(endTime <= startTime)) {
            for(var properties = [], i = 0; i < errors.length; i++){
                var error = errors[i].value;
                properties.push([
                    "Error",
                    "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                ]);
            }
            startTime = {
                start: startTime,
                end: endTime,
                detail: {
                    devtools: {
                        color: "error",
                        track: currentTrack,
                        trackGroup: LANES_TRACK_GROUP,
                        tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
                        properties: properties
                    }
                }
            };
            debugTask ? debugTask.run(performance.measure.bind(performance, "Errored", startTime)) : performance.measure("Errored", startTime);
            performance.clearMeasures("Errored");
        }
    }
    function logCommitPhase(startTime, endTime, errors, abortedViewTransition, debugTask) {
        null !== errors ? logCommitErrored(startTime, endTime, errors, !1, debugTask) : !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Commit Interrupted View Transition" : "Commit", startTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-dark")) : console.timeStamp(abortedViewTransition ? "Commit Interrupted View Transition" : "Commit", startTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-dark"));
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
        !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(console.timeStamp.bind(console, "Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Animating", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
        null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        for(var node = sourceFiber, parent = node.return; null !== parent;)null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
        return 3 === node.tag ? node.stateNode : null;
    }
    function resolveTypeForHotReloading(type) {
        if (null === resolveFamily) return type;
        var family = resolveFamily(type);
        return void 0 === family ? type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (null === resolveFamily) return !1;
        var resolve = resolveFamily, prevType = fiber.elementType;
        element = element.type;
        var needsCompareFamilies = !1, $$typeofNextType = "object" === typeof element && null !== element ? element.$$typeof : null;
        switch(fiber.tag){
            case 1:
                "function" === typeof element && (needsCompareFamilies = !0);
                break;
            case 0:
                "function" === typeof element ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 11:
                $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            case 14:
            case 15:
                $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = !0 : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = !0);
                break;
            default:
                return !1;
        }
        return needsCompareFamilies && (fiber = resolve(prevType), void 0 !== fiber && fiber === resolve(element)) ? !0 : !1;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        do {
            var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag = _fiber.tag, type = _fiber.type, elementType = _fiber.elementType, candidateType = null;
            _fiber = null;
            switch(tag){
                case 0:
                case 1:
                    candidateType = type;
                    break;
                case 15:
                    candidateType = type;
                    _fiber = elementType;
                    break;
                case 14:
                    _fiber = elementType;
                    break;
                case 11:
                    candidateType = type.render, _fiber = elementType;
            }
            if (null === resolveFamily) throw Error("Expected resolveFamily to be set during hot reload.");
            var resolve = resolveFamily;
            type = elementType = !1;
            null !== candidateType && (candidateType = resolve(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? type = !0 : updatedFamilies.has(candidateType) && (1 === tag ? type = !0 : elementType = !0)));
            type || null === _fiber || (tag = resolve(_fiber), void 0 !== tag && staleFamilies.has(tag) ? type = !0 : "object" === typeof _fiber && _fiber.$$typeof === REACT_LAZY_TYPE && (tag = _fiber._payload, 1 === tag._status && (tag = resolve(tag._result.default), void 0 !== tag && staleFamilies.has(tag) && (type = !0))));
            null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (type = !0);
            type && (fiber._debugNeedsRemount = !0);
            if (type || elementType) alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
            null === child || type || scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            if (null === sibling) break;
            fiber = sibling;
        }while (1);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
        this.actualDuration = -0;
        this.actualStartTime = -1.1;
        this.treeBaseDuration = this.selfBaseDuration = -0;
        this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
        this._debugNeedsRemount = !1;
        this._debugHookTypes = null;
        hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress._debugOwner = current._debugOwner, workInProgress._debugStack = current._debugStack, workInProgress._debugTask = current._debugTask, workInProgress._debugHookTypes = current._debugHookTypes, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.actualDuration = -0, workInProgress.actualStartTime = -1.1);
        workInProgress.flags = current.flags & 1206910976;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext,
            _debugThenableState: pendingProps._debugThenableState
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugInfo = current._debugInfo;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case 0:
            case 15:
            case 14:
            case 1:
            case 11:
                workInProgress.type = resolveTypeForHotReloading(current.type);
        }
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 1206910978;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null, workInProgress.selfBaseDuration = 0, workInProgress.treeBaseDuration = 0) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext,
            _debugThenableState: renderLanes._debugThenableState
        }, workInProgress.selfBaseDuration = current.selfBaseDuration, workInProgress.treeBaseDuration = current.treeBaseDuration);
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0;
        var resolvedType = resolveTypeForHotReloading(type);
        if ("function" === typeof resolvedType) shouldConstruct(resolvedType) && (fiberTag = 1);
        else if ("string" === typeof resolvedType) fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
        else a: switch(resolvedType){
            case REACT_ACTIVITY_TYPE:
                return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof type.id), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = {
                    effectDuration: 0,
                    passiveEffectDuration: 0
                }, key;
            case REACT_SUSPENSE_TYPE:
                return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
            case REACT_SUSPENSE_LIST_TYPE:
                return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
            case REACT_LEGACY_HIDDEN_TYPE:
            case REACT_VIEW_TRANSITION_TYPE:
                return type = mode | SuspenseyImagesMode, key = createFiber(30, pendingProps, key, type), key.elementType = REACT_VIEW_TRANSITION_TYPE, key.lanes = lanes, key.stateNode = {
                    autoName: null,
                    paired: null,
                    clones: null,
                    ref: null
                }, key;
            default:
                if ("object" === typeof resolvedType && null !== resolvedType) switch(resolvedType.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        resolvedType = null;
                        break a;
                }
                pendingProps = "";
                if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length) pendingProps += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                null === type ? resolvedType = "null" : isArrayImpl(type) ? resolvedType = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (resolvedType = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", pendingProps = " Did you accidentally export a JSX literal instead of a component?") : resolvedType = typeof type;
                (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (pendingProps += "\n\nCheck the render method of `" + fiberTag + "`.");
                fiberTag = 29;
                pendingProps = Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (resolvedType + "." + pendingProps));
                resolvedType = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = resolvedType;
        key.lanes = lanes;
        key._debugOwner = owner;
        return key;
    }
    function createFiberFromElement(element, mode, lanes) {
        mode = createFiberFromTypeAndProps(element.type, element.key, element.props, element._owner, mode, lanes);
        mode._debugOwner = element._owner;
        mode._debugStack = element._debugStack;
        mode._debugTask = element._debugTask;
        return mode;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating();
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        return null !== treeContextProvider ? {
            id: treeContextId,
            overflow: treeContextOverflow
        } : null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        isHydrating || console.error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
        if (null === fiber.return) {
            if (null === hydrationDiffRootDEV) hydrationDiffRootDEV = {
                fiber: fiber,
                children: [],
                serverProps: void 0,
                serverTail: [],
                distanceFromLeaf: distanceFromLeaf
            };
            else {
                if (hydrationDiffRootDEV.fiber !== fiber) throw Error("Saw multiple hydration diff roots in a pass. This is a bug in React.");
                hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
            }
            return hydrationDiffRootDEV;
        }
        var siblings = buildHydrationDiffNode(fiber.return, distanceFromLeaf + 1).children;
        if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber) return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
        distanceFromLeaf = {
            fiber: fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: distanceFromLeaf
        };
        siblings.push(distanceFromLeaf);
        return distanceFromLeaf;
    }
    function warnIfHydrating() {
        isHydrating && console.error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
        didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
        var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : !1, diff = "", diffRoot = hydrationDiffRootDEV;
        null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
        queueHydrationError(createCapturedValueAtFiber(Error("Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff), fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
        var didHydrate = fiber.stateNode;
        var type = fiber.type, props = fiber.memoizedProps;
        didHydrate[internalInstanceKey] = fiber;
        didHydrate[internalPropsKey] = props;
        validatePropertiesInDevelopment(type, props);
        switch(type){
            case "dialog":
                listenToNonDelegatedEvent("cancel", didHydrate);
                listenToNonDelegatedEvent("close", didHydrate);
                break;
            case "iframe":
            case "object":
            case "embed":
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "video":
            case "audio":
                for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
                break;
            case "source":
                listenToNonDelegatedEvent("error", didHydrate);
                break;
            case "img":
            case "image":
            case "link":
                listenToNonDelegatedEvent("error", didHydrate);
                listenToNonDelegatedEvent("load", didHydrate);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", didHydrate);
                break;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateInputProps(didHydrate, props);
                initInput(didHydrate, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
                break;
            case "option":
                validateOptionProps(didHydrate, props);
                break;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", didHydrate);
                validateSelectProps(didHydrate, props);
                break;
            case "textarea":
                checkControlledValueProps("textarea", props), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props), initTextarea(didHydrate, props.value, props.defaultValue, props.children);
        }
        type = props.children;
        "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props.onClick && (didHydrate.onclick = noop$1), didHydrate = !0) : didHydrate = !1;
        didHydrate || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag, JSCompiler_temp;
        if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
            if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
            JSCompiler_temp = !JSCompiler_temp;
        }
        if (JSCompiler_temp && nextHydratableInstance) {
            for(JSCompiler_temp = nextHydratableInstance; JSCompiler_temp;){
                var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
                diffNode.serverTail.push(description);
                JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
            }
            throwOnHydrationMismatch(fiber);
        }
        popToNextHostParent(fiber);
        if (13 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
            nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
        } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
        return !0;
    }
    function resetHydrationState() {
        nextHydratableInstance = hydrationParentFiber = null;
        didSuspendOrErrorDEV = isHydrating = !1;
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
        var diffRoot = hydrationDiffRootDEV;
        if (null !== diffRoot) {
            hydrationDiffRootDEV = null;
            for(var diff = describeDiff(diffRoot); 0 < diffRoot.children.length;)diffRoot = diffRoot.children[0];
            runWithFiberInDEV(diffRoot.fiber, function() {
                console.error("A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s", "https://react.dev/link/hydration-mismatch", diff);
            });
        }
    }
    function resetContextDependencies() {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        isDisallowedContextReadInDEV = !1;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        push(rendererCursorDEV, context._currentRenderer, providerFiber);
        void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        context._currentValue = valueCursor.current;
        var currentRenderer = rendererCursorDEV.current;
        pop(rendererCursorDEV, providerFiber);
        context._currentRenderer = currentRenderer;
        pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
        parent !== propagationRoot && console.error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error("Should have a current fiber. This is a bug in React.");
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
        return null !== current;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        isDisallowedContextReadInDEV && console.error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = context._currentValue;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context,
                _debugThenableState: null
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function retainCache(cache) {
        cache.controller.signal.aborted && console.warn("A cache instance was retained after it was already freed. This likely indicates a bug in React.");
        cache.refCount++;
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 > cache.refCount && console.warn("A cache instance was released after it was already freed. This likely indicates a bug in React.");
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function queueTransitionTypes(root, transitionTypes) {
        if (0 !== (root.pendingLanes & 4194048)) {
            var queued = root.transitionTypes;
            null === queued && (queued = root.transitionTypes = []);
            for(root = 0; root < transitionTypes.length; root++){
                var transitionType = transitionTypes[root];
                -1 === queued.indexOf(transitionType) && queued.push(transitionType);
            }
        }
    }
    function claimQueuedTransitionTypes(root) {
        var claimed = root.transitionTypes;
        root.transitionTypes = null;
        return claimed;
    }
    function startUpdateTimerByLane(lane, method, fiber) {
        if (0 !== (lane & 127)) 0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = !0, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
        else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
            lane = resolveEventTimeStamp();
            method = resolveEventType();
            if (lane !== transitionEventRepeatTime || method !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = lane;
            transitionEventType = method;
        }
    }
    function startHostActionTimer(fiber) {
        if (0 > blockingUpdateTime) {
            blockingUpdateTime = now();
            blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
            var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
            newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
            blockingEventTime = newEventTime;
            blockingEventType = newEventType;
        }
        if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
            fiber = resolveEventTimeStamp();
            newEventTime = resolveEventType();
            if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType) transitionEventRepeatTime = -1.1;
            transitionEventTime = fiber;
            transitionEventType = newEventTime;
        }
    }
    function pushNestedEffectDurations() {
        var prevEffectDuration = profilerEffectDuration;
        profilerEffectDuration = 0;
        return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration = prevEffectDuration;
        return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
        var elapsedTime = profilerEffectDuration;
        profilerEffectDuration += prevEffectDuration;
        return elapsedTime;
    }
    function resetComponentEffectTimers() {
        componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
        var prevEffectStart = componentEffectStartTime;
        componentEffectStartTime = -1.1;
        return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
        0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
        var prevEffectDuration = componentEffectDuration;
        componentEffectDuration = -0;
        return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
        0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
        var prevErrors = componentEffectErrors;
        componentEffectErrors = null;
        return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
        var prev = componentEffectSpawnedUpdate;
        componentEffectSpawnedUpdate = !1;
        return prev;
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now();
        0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
        if (0 <= profilerStartTime) {
            var elapsedTime = now() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordEffectDuration() {
        if (0 <= profilerStartTime) {
            var endTime = now(), elapsedTime = endTime - profilerStartTime;
            profilerStartTime = -1;
            profilerEffectDuration += elapsedTime;
            componentEffectDuration += elapsedTime;
            componentEffectEndTime = endTime;
        }
    }
    function recordEffectError(errorInfo) {
        null === componentEffectErrors && (componentEffectErrors = []);
        componentEffectErrors.push(errorInfo);
        null === commitErrors && (commitErrors = []);
        commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
        profilerStartTime = now();
        0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
        for(var child = fiber.child; child;)fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), entangledTransitionTypes = null, null !== currentEntangledListeners)) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current, offscreenWorkInProgress) : push(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: CacheContext._currentValue,
            pool: cacheFromPool
        };
    }
    function createThenableState() {
        return {
            didWarnAboutUncachedPromise: !1,
            thenables: []
        };
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index, fiber) {
        null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = !0);
        var trackedThenables = thenableState.thenables;
        index = trackedThenables[index];
        void 0 === index ? trackedThenables.push(thenable) : index !== thenable && (thenableState.didWarnAboutUncachedPromise || (thenableState.didWarnAboutUncachedPromise = !0, console.error("A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework.")), thenable.then(noop$1, noop$1), thenable = index);
        if (void 0 === thenable._debugInfo) {
            thenableState = performance.now();
            trackedThenables = thenable.displayName;
            var ioInfo = {
                name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
                start: thenableState,
                end: thenableState,
                value: thenable
            };
            thenable._debugInfo = [
                {
                    awaited: ioInfo
                }
            ];
            "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState = function() {
                ioInfo.end = performance.now();
            }, thenable.then(thenableState, thenableState));
        }
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                fiber = thenable.reason;
                checkIfUseWrappedInAsyncCatch(fiber);
                if (void 0 === fiber && !("reason" in thenable)) throw Error("A rejected Promise was passed to React without a `reason` property. React threw a generic error from where the Promise was used to assist in identifying the problematic Promise. Make sure that instrumented Promises correctly set the `reason` property when setting `status` to `'rejected'`.");
                throw fiber;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error("An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw fiber = thenable.reason, checkIfUseWrappedInAsyncCatch(fiber), fiber;
                }
                suspendedThenable = thenable;
                needsToResetSuspendedThenableDEV = !0;
                didIssueUseWarning || null === fiber || null !== fiber.alternate || (lastSuspendedFiber = fiber, lastSuspendedStack = Error("This library called use() to suspend in a previous render but did not call use() when it finished. This indicates an incorrect use of use(). Learn more: https://react.dev/warnings/conditional-use-of-use"));
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            return callLazyInitInDEV(lazyType);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, needsToResetSuspendedThenableDEV = !0, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error("Expected a suspended thenable. This is a bug in React. Please file an issue.");
        var thenable = suspendedThenable;
        suspendedThenable = null;
        needsToResetSuspendedThenableDEV = !1;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error("Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.");
    }
    function areSameKeyPath(a, b) {
        return a === b ? !0 : a.tag !== b.tag || a.type !== b.type || a.key !== b.key || a.index !== b.index || 3 === a.tag && a.stateNode !== b.stateNode || null === a.return || null === b.return ? !1 : areSameKeyPath(a.return, b.return);
    }
    function pushDebugInfo(debugInfo) {
        var previousDebugInfo = currentDebugInfo;
        null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
        return previousDebugInfo;
    }
    function getCurrentDebugTask() {
        var debugInfo = currentDebugInfo;
        if (null != debugInfo) {
            for(var i = debugInfo.length - 1; 0 <= i; i--)if (null != debugInfo[i].name) {
                var debugTask = debugInfo[i].debugTask;
                if (null != debugTask) return debugTask;
            }
        }
        return null;
    }
    function validateFragmentProps(element, fiber, returnFiber) {
        for(var keys = Object.keys(element.props), i = 0; i < keys.length; i++){
            var key = keys[i];
            if ("children" !== key && "key" !== key && "ref" !== key) {
                null === fiber && (fiber = createFiberFromElement(element, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
                runWithFiberInDEV(fiber, function(erroredKey) {
                    console.error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key`, `ref`, and `children` props.", erroredKey);
                }, key);
                break;
            }
        }
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = createThenableState());
        return trackUsedThenable(thenableState$1, thenable, index, null);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error('A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.');
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead.");
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = !0, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)", invalidChild, invalidChild, invalidChild) : console.error("Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>", invalidChild, invalidChild, parentName, invalidChild, parentName));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
        var parentName = getComponentNameFromFiber(returnFiber) || "Component";
        ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = !0, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error("Symbols are not valid as a React child.\n  root.render(%s)", invalidChild) : console.error("Symbols are not valid as a React child.\n  <%s>%s</%s>", parentName, invalidChild, parentName));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
        var debugTask = getCurrentDebugTask();
        null !== debugTask ? debugTask.run(warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
            newFiber.flags |= 134217730;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return current = updateFragment(returnFiber, current, element.props.children, lanes, element.key), coerceRef(current, element), validateFragmentProps(element, current, returnFiber), current;
            if (null !== current && (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current._debugOwner = element._owner, current._debugInfo = currentDebugInfo, current;
            current = createFiberFromElement(element, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current._debugOwner = returnFiber, current._debugTask = returnFiber._debugTask, current._debugInfo = currentDebugInfo, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            current._debugInfo = currentDebugInfo;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = createChild(returnFiber, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return lanes = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
                if ("function" === typeof newChild.then) return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(returnFiber, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(returnFiber, oldFiber, newChild, lanes), currentDebugInfo = key, returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
                    if (null !== key) return null;
                    key = pushDebugInfo(newChild._debugInfo);
                    returnFiber = updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                    currentDebugInfo = key;
                    return returnFiber;
                }
                if ("function" === typeof newChild.then) return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes), currentDebugInfo = key, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newIdx = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(returnFiber, newIdx, newChild, lanes), currentDebugInfo = existingChildren, returnFiber;
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
                        newChild = resolveLazy(newChild);
                        returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                        currentDebugInfo = _prevDebugInfo7;
                        return returnFiber;
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(returnFiber, newIdx, newChild, lanes, null), currentDebugInfo = existingChildren, returnFiber;
                if ("function" === typeof newChild.then) return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes), currentDebugInfo = _prevDebugInfo7, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return null;
        }
        function warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys) {
            if ("object" !== typeof child || null === child) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(returnFiber, workInProgress, child);
                    var key = child.key;
                    if ("string" !== typeof key) break;
                    if (null === knownKeys) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    runWithFiberInDEV(workInProgress, function() {
                        console.error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    });
                    break;
                case REACT_LAZY_TYPE:
                    child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress, child, knownKeys);
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, newChildren[newIdx], knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, newChildren[newIdx], knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, newChildren[newIdx], knownKeys), shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error("An iterable object provided no iterator.");
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                knownKeys = warnOnInvalidKey(returnFiber, newFiber, step.value, knownKeys);
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(returnFiber, oldFiber, step.value, knownKeys), currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(returnFiber, nextOldFiber, step.value, knownKeys), shouldTrackSideEffects && (step = nextOldFiber.alternate, null !== step && oldFiber.delete(null === step.key ? newIdx : step.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            coerceRef(lanes, newChild);
                                            lanes.return = returnFiber;
                                            lanes._debugOwner = newChild._owner;
                                            lanes._debugInfo = currentDebugInfo;
                                            validateFragmentProps(newChild, lanes, returnFiber);
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(currentFirstChild, newChild) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        lanes._debugOwner = newChild._owner;
                                        lanes._debugInfo = currentDebugInfo;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(newChild, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
                        }
                        returnFiber = placeSingleChild(returnFiber);
                        currentDebugInfo = prevDebugInfo;
                        return returnFiber;
                    case REACT_PORTAL_TYPE:
                        a: {
                            prevDebugInfo = newChild;
                            for(newChild = prevDebugInfo.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === newChild) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, prevDebugInfo.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(prevDebugInfo, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                }
                if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) {
                    prevDebugInfo = newChild;
                    newChild = getIteratorFn(prevDebugInfo);
                    if ("function" !== typeof newChild) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
                    key = newChild.call(prevDebugInfo);
                    if (key === prevDebugInfo) {
                        if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(key)) didWarnAboutGenerators || console.error("Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."), didWarnAboutGenerators = !0;
                    } else prevDebugInfo.entries !== newChild || didWarnAboutMaps || (console.error("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), didWarnAboutMaps = !0);
                    return reconcileChildrenIterator(returnFiber, currentFirstChild, key, lanes);
                }
                if ("function" === typeof newChild.then) return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes), currentDebugInfo = prevDebugInfo, returnFiber;
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(prevDebugInfo, returnFiber.mode, lanes), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
            "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
            "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            var prevDebugInfo = currentDebugInfo;
            currentDebugInfo = null;
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                var debugInfo = fiber._debugInfo = currentDebugInfo;
                fiber._debugOwner = returnFiber._debugOwner;
                fiber._debugTask = returnFiber._debugTask;
                if (null != debugInfo) {
                    for(var i = debugInfo.length - 1; 0 <= i; i--)if ("string" === typeof debugInfo[i].stack) {
                        fiber._debugOwner = debugInfo[i];
                        fiber._debugTask = debugInfo[i].debugTask;
                        break;
                    }
                }
                return fiber;
            } finally{
                currentDebugInfo = prevDebugInfo;
            }
        };
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArrayImpl(childSlot);
        childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
        return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", isAnArray, index, isAnArray), !1) : !0;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
            var componentName = getComponentNameFromFiber(fiber);
            console.error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s", componentName);
            didWarnUpdateInsideUpdate = !0;
        }
        if ((executionContext & RenderContext) !== NoContext) return componentName = updateQueue.pending, null === componentName ? update.next = update : (update.next = componentName.next, componentName.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress.updateQueue;
        hasForceUpdate = !1;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        updateLane = workInProgress;
                        var partialState = pendingQueue;
                        var nextProps = props, instance = instance$jscomp$0;
                        switch(partialState.tag){
                            case ReplaceState:
                                partialState = partialState.payload;
                                if ("function" === typeof partialState) {
                                    isDisallowedContextReadInDEV = !0;
                                    var nextState = partialState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            partialState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                    newState = nextState;
                                    break a;
                                }
                                newState = partialState;
                                break a;
                            case CaptureUpdate:
                                updateLane.flags = updateLane.flags & -65537 | 128;
                            case UpdateState:
                                nextState = partialState.payload;
                                if ("function" === typeof nextState) {
                                    isDisallowedContextReadInDEV = !0;
                                    partialState = nextState.call(instance, newState, nextProps);
                                    if (updateLane.mode & StrictLegacyMode) {
                                        setIsStrictModeForDevtools(!0);
                                        try {
                                            nextState.call(instance, newState, nextProps);
                                        } finally{
                                            setIsStrictModeForDevtools(!1);
                                        }
                                    }
                                    isDisallowedContextReadInDEV = !1;
                                } else partialState = nextState;
                                if (null === partialState || void 0 === partialState) break a;
                                newState = assign({}, newState, partialState);
                                break a;
                            case ForceUpdate:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress.flags |= 64, isHiddenUpdate && (workInProgress.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress.lanes = lastBaseUpdate;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
        var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
        if (null !== hiddenCallbacks) for(updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        var prevEntangledRenderLanes = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, context, fiber);
        entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current, fiber);
    }
    function popHiddenContext(fiber) {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor, fiber);
        pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & SubtreeSuspenseContextMask, handler);
        push(suspenseHandlerStackCursor, handler, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, fiber, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current, fiber), push(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current, fiber);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor, fiber);
    }
    function pushSuspenseListContext(fiber, newContext) {
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current, fiber);
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseListContext(fiber) {
        pop(suspenseStackCursor, fiber);
        pop(suspenseHandlerStackCursor, fiber);
        shellBoundary === fiber && (shellBoundary = null);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        null === hookTypesDev ? hookTypesDev = [
            hookName
        ] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
            var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName) && (didWarnAboutMismatchedHooksForComponent.add(componentName), null !== hookTypesDev)) {
                for(var table = "", i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i], newHookName = i === hookTypesUpdateIndexDev ? hookName : oldHookName;
                    for(oldHookName = i + 1 + ". " + oldHookName; 30 > oldHookName.length;)oldHookName += " ";
                    oldHookName += newHookName + "\n";
                    table += oldHookName;
                }
                console.error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function checkDepsAreArrayDev(deps) {
        void 0 === deps || null === deps || isArrayImpl(deps) || console.error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnUseFormStateInDev() {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber);
        didWarnAboutUseFormState.has(componentName) || (didWarnAboutUseFormState.add(componentName), console.error("ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.", componentName));
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) return !1;
        if (null === prevDeps) return console.error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev), !1;
        nextDeps.length !== prevDeps.length && console.error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        hookTypesDev = null !== current ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component)) nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error("%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.", null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"));
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null !== current && null !== current.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
        shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress.mode & StrictLegacyMode) !== NoMode;
        var children = callComponentInDEV(Component, props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        if (nextRenderLanes) {
            setIsStrictModeForDevtools(!0);
            try {
                children = renderWithHooksAgain(workInProgress, Component, props, secondArg);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        finishRenderingHooks(current, workInProgress);
        return children;
    }
    function finishRenderingHooks(current, workInProgress) {
        workInProgress._debugHookTypes = hookTypesDev;
        null === workInProgress.dependencies ? null !== thenableState && (workInProgress.dependencies = {
            lanes: 0,
            firstContext: null,
            _debugThenableState: thenableState
        }) : workInProgress.dependencies._debugThenableState = thenableState;
        var thenableState$jscomp$0 = thenableState;
        null !== lastSuspendedFiber && areSameKeyPath(lastSuspendedFiber, workInProgress) && (null !== thenableState$jscomp$0 || null === lastSuspendedStack || didIssueUseWarning || (didIssueUseWarning = !0, console.error(lastSuspendedStack)), lastSuspendedStack = lastSuspendedFiber = null);
        ReactSharedInternals.H = ContextOnlyDispatcher;
        thenableState$jscomp$0 = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        null !== current && (current.flags & 1206910976) !== (workInProgress.flags & 1206910976) && console.error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (thenableState$jscomp$0) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
        needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = !1, current = !0) : current = !1;
        current && (workInProgress = getComponentNameFromFiber(workInProgress) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress) || didWarnAboutAsyncClientComponent.has(workInProgress) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress), console.error("`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary.")));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (numberOfReRenders >= RE_RENDER_LIMIT) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            numberOfReRenders += 1;
            ignorePreviousDependencies = !1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            hookTypesUpdateIndexDev = -1;
            ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
            children = callComponentInDEV(Component, props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags = (workInProgress.mode & StrictEffectsMode) !== NoMode ? workInProgress.flags & -805308421 : workInProgress.flags & -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error("Update hook called on initial render. This is likely a bug in React. Please file an issue.");
                throw Error("Rendered more hooks than during the previous render.");
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = createThenableState());
        thenable = trackUsedThenable(thenableState, thenable, index, currentlyRenderingFiber);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null !== index && null !== index.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_RECOVERABLE_TYPE) return;
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue || ignorePreviousDependencies) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        else updateQueue.length !== size && console.error("Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.", updateQueue.length, size);
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue !== baseQueue && console.error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error("Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)");
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            var nextSnapshot = getServerSnapshot();
            didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error("The result of getServerSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        } else {
            nextSnapshot = getSnapshot();
            didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0));
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        hook.memoizedState = nextSnapshot;
        getServerSnapshot = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = getServerSnapshot;
        mountEffect(subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, getServerSnapshot, nextSnapshot, getSnapshot), null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            getServerSnapshot = getServerSnapshot();
        } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            objectIs(getServerSnapshot, cachedSnapshot) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        if (cachedSnapshot = !objectIs((currentHook || hook).memoizedState, getServerSnapshot)) hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0;
        hook = hook.queue;
        var create = subscribeToStore.bind(null, fiber, hook, subscribe);
        updateEffectImpl(2048, Passive, create, [
            subscribe
        ]);
        subscribe = hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && (workInProgressHook.memoizedState.tag & HasEffect) !== NoFlags;
        pushSimpleEffect(subscribe ? HasEffect | Passive : Passive, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (subscribe) {
            fiber.flags |= 2048;
            if (null === workInProgressRoot) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function mountState(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    }
    function mountOptimistic(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    }
    function updateOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function rerenderOptimistic(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error("Cannot update action state while rendering.");
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            currentTransition.types = null !== prevTransition ? prevTransition.types : null;
            currentTransition._updatedFibers = new Set();
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
            }
        } else try {
            currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$5) {
            onActionError(actionQueue, node, error$5);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }), node.isTransition || console.error("An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop.")) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var isMatching = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            b: {
                                var markerInstance = nextHydratableInstance;
                                for(var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType;){
                                    if (!inRootOrSingleton) {
                                        markerInstance = null;
                                        break b;
                                    }
                                    markerInstance = getNextHydratable(markerInstance.nextSibling);
                                    if (null === markerInstance) {
                                        markerInstance = null;
                                        break b;
                                    }
                                }
                                inRootOrSingleton = markerInstance.data;
                                markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                            }
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratable(markerInstance.nextSibling);
                                isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(isMatching);
                    }
                    isMatching = !1;
                }
                isMatching && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        isMatching = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = isMatching;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, isMatching);
        isMatching.dispatch = ssrFormState;
        isMatching = mountStateImpl(!1);
        inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, isMatching.queue);
        isMatching = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        isMatching.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, inRootOrSingleton, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        isMatching.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(HasEffect | Passive, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(HasEffect | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(545261568, Passive, create, deps) : mountEffectImpl(8390656, Passive, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function mountEvent(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if ((executionContext & RenderContext) !== NoContext) throw Error("A function wrapped in useEffectEvent can't be called during rendering.");
            return ref.impl.apply(void 0, arguments);
        };
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 268435456);
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return ref.hasOwnProperty("current") || console.error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(ref).join(", ") + "}"), create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = 4194308;
        (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 268435456);
        mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function updateImperativeHandle(ref, create, deps) {
        "function" !== typeof create && console.error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", null !== create ? typeof create : "null");
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, Layout, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountCallback(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValue(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function rerenderDeferredValue(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 106) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function releaseAsyncTransition() {
        ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        currentTransition._updatedFibers = new Set();
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                ReactSharedInternals.asyncTransitions++;
                returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane(fiber));
        } finally{
            ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error("We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."));
        }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error("Expected the form instance to be a HostComponent. This is a bug in React.");
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startHostActionTimer(formFiber);
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            requestFormReset$1(formFiber);
            return action(formData);
        });
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
        null === ReactSharedInternals.T && console.error("requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition.");
        var stateHook = ensureFormComponentIsStateful(formFiber);
        null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
        dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane(formFiber));
    }
    function mountTransition() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    }
    function updateTransition() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function rerenderTransition() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function mountId() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var treeId = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
            identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
            treeId = localIdCounter++;
            0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
            identifierPrefix += "_";
        } else treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    }
    function refreshCache(fiber, seedKey) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root = enqueueUpdate(provider, refreshUpdate, lane);
                    null !== root && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    fiber = createCache();
                    null !== seedKey && void 0 !== seedKey && null !== root && console.error("The seed argument is not enabled outside experimental channels.");
                    refreshUpdate.payload = {
                        cache: fiber
                    };
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        var update = {
            lane: args,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
        var args = arguments;
        "function" === typeof args[3] && console.error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        args = requestUpdateLane(fiber);
        dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
                var prevDispatcher = ReactSharedInternals.H;
                ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
                try {
                    var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                    update.hasEagerState = !0;
                    update.eagerState = eagerState;
                    if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
                } catch (error) {} finally{
                    ReactSharedInternals.H = prevDispatcher;
                }
            }
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error("An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition.");
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error("Cannot update optimistic state while rendering.");
            console.error("Cannot call startTransition while rendering.");
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function warnOnInvalidCallback(callback) {
        if (null !== callback && "function" !== typeof callback) {
            var key = String(callback);
            didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback));
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(!0);
            try {
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        void 0 === partialState && (ctor = getComponentNameFromType(ctor) || "Component", didWarnAboutUndefinedDerivedState.has(ctor) || (didWarnAboutUndefinedDerivedState.add(ctor), console.error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ctor)));
        prevState = null === partialState || void 0 === partialState ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = prevState;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if ("function" === typeof instance.shouldComponentUpdate) {
            oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    oldProps = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            void 0 === oldProps && console.error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return oldProps;
        }
        return ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== oldState && (workInProgress = getComponentNameFromFiber(workInProgress) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress) || (didWarnAboutStateAssignmentForComponent.add(workInProgress), console.error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", workInProgress)), classComponentUpdater.enqueueReplaceState(instance, instance.state, null));
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var _propName in Component)void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
        }
        return newProps;
    }
    function defaultOnUncaughtError(error) {
        reportGlobalError(error);
        console.warn("%s\n\n%s\n", componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.", "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries.");
    }
    function defaultOnCaughtError(error) {
        var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
        if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
            var JSCompiler_inline_result = error.environmentName;
            error = [
                "%o\n\n%s\n\n%s\n",
                error,
                componentNameMessage,
                recreateMessage
            ].slice(0);
            "string" === typeof error[0] ? error.splice(0, 1, badgeFormat + " " + error[0], badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle) : error.splice(0, 0, badgeFormat, badgeStyle, pad + JSCompiler_inline_result + pad, resetStyle);
            error.unshift(console);
            JSCompiler_inline_result = bind.apply(console.error, error);
            JSCompiler_inline_result();
        } else console.error("%o\n\n%s\n\n%s\n", error, componentNameMessage, recreateMessage);
    }
    function defaultOnRecoverableError(error) {
        reportGlobalError(error);
    }
    function logUncaughtError(root, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = null;
            var error = errorInfo.value;
            if (null !== ReactSharedInternals.actQueue) ReactSharedInternals.thrownErrors.push(error);
            else {
                var onUncaughtError = root.onUncaughtError;
                onUncaughtError(error, {
                    componentStack: errorInfo.stack
                });
            }
        } catch (e$6) {
            setTimeout(function() {
                throw e$6;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
            errorBoundaryName = getComponentNameFromFiber(boundary);
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e$7) {
            setTimeout(function() {
                throw e$7;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            runWithFiberInDEV(errorInfo.source, logUncaughtError, root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = CaptureUpdate;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
            runWithFiberInDEV(errorInfo.source, logCaughtError, root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            callComponentDidCatchInDEV(this, errorInfo);
            "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        isDevToolsPresent && restorePendingUpdaters(root, rootRenderLanes);
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            isHydrating && (didSuspendOrErrorDEV = !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                    case 19:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error("Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React.");
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return didSuspendOrErrorDEV = !0, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (19 === returnFiber.tag && console.error("SuspenseList should never catch while hydrating. This is a bug in React."), 0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.", {
            cause: value
        }), sourceFiber))) : (value !== HydrationMismatchException && queueHydrationError(createCapturedValueAtFiber(Error("There was an error while hydrating but React was able to recover by instead client rendering the entire root.", {
            cause: value
        }), sourceFiber)), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), !1;
        var error = createCapturedValueAtFiber(Error("There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.", {
            cause: value
        }), sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            error
        ] : workInProgressRootConcurrentErrors.push(error);
        workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    returnFiber = sourceFiber.type;
                    error = sourceFiber.stateNode;
                    if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                    break;
                case 22:
                    if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var resolvedRender = resolveTypeForHotReloading(Component);
        resolvedRender !== Component && (Component = resolvedRender, null !== current && (didReceiveUpdate = !0));
        resolvedRender = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, resolvedRender, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return Component = resolveTypeForHotReloading(type), workInProgress.tag = 15, workInProgress.type = Component, validateFunctionComponentInDev(workInProgress, type), updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(workInProgress), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(workInProgress), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: OffscreenVisible,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: CacheContext._currentValue,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack(workInProgress);
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        var hiddenProp = nextProps.hidden;
        void 0 !== hiddenProp && console.error('<Activity> doesn\'t accept a hidden prop. Use mode="hidden" instead.\n- <Activity %s>\n+ <Activity %s>', !0 === hiddenProp ? "hidden" : !1 === hiddenProp ? "hidden={false}" : "hidden={...}", hiddenProp ? 'mode="hidden"' : 'mode="visible"');
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                    baseLanes: 0,
                    cachePool: null
                }, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data === ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (nextProps = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes), nextProps.return = workInProgress, workInProgress.child = nextProps, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var activityInstance = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
            } else if (warnIfHydrating(), 0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress), didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                if (null === currentTreeHiddenStackCursor.current) {
                    nextProps = workInProgressRoot;
                    if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== activityInstance && activityInstance !== prevState.retryLane)) throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current, activityInstance), scheduleUpdateOnFiber(nextProps, current, activityInstance), SelectiveHydrationException;
                    renderDidSuspendDelayIfPossible();
                }
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(activityInstance.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
            return workInProgress;
        }
        prevState = current.child;
        nextProps = {
            mode: nextProps.mode,
            children: nextProps.children
        };
        0 !== (renderLanes & 536870912) && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        current = createWorkInProgress(prevState, nextProps);
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error("Expected ref to be a function, an object returned by React.createRef(), or undefined/null.");
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (Component.prototype && "function" === typeof Component.prototype.render) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            didWarnAboutBadClass[componentName] || (console.error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName), didWarnAboutBadClass[componentName] = !0);
        }
        workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        null === current && (validateFunctionComponentInDev(workInProgress, workInProgress.type), Component.contextTypes && (componentName = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName] || (didWarnAboutContextTypes[componentName] = !0, console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)", componentName))));
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        hookTypesUpdateIndexDev = -1;
        ignorePreviousDependencies = null !== current && current.type !== workInProgress.type;
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current, workInProgress);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        switch(shouldErrorImpl(workInProgress)){
            case !1:
                var _instance = workInProgress.stateNode, state = new workInProgress.type(workInProgress.memoizedProps, _instance.context).state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case !0:
                workInProgress.flags |= 128;
                workInProgress.flags |= 65536;
                _instance = Error("Simulated error coming from DevTools");
                var lane = renderLanes & -renderLanes;
                workInProgress.lanes |= lane;
                state = workInProgressRoot;
                if (null === state) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
                lane = createClassErrorUpdate(lane);
                initializeClassErrorUpdate(lane, state, workInProgress, createCapturedValueAtFiber(_instance, workInProgress));
                enqueueCapturedUpdate(workInProgress, lane);
        }
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            state = emptyContextObject;
            _instance = Component.contextType;
            "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(Component) || "Component", lane));
            "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
            _instance = new Component(nextProps, state);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    _instance = new Component(nextProps, state);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            state = workInProgress.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
            _instance.updater = classComponentUpdater;
            workInProgress.stateNode = _instance;
            _instance._reactInternals = workInProgress;
            _instance._reactInternalInstance = fakeInternalInstance;
            "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", state, null === _instance.state ? "null" : "undefined", state)));
            if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
                var foundWillUpdateName = lane = state = null;
                "function" === typeof _instance.componentWillMount && !0 !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
                "function" === typeof _instance.componentWillReceiveProps && !0 !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
                "function" === typeof _instance.componentWillUpdate && !0 !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
                if (null !== state || null !== lane || null !== foundWillUpdateName) {
                    _instance = getComponentNameFromType(Component) || "Component";
                    var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                    didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles", _instance, newApiName, null !== state ? "\n  " + state : "", null !== lane ? "\n  " + lane : "", null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""));
                }
            }
            _instance = workInProgress.stateNode;
            state = getComponentNameFromType(Component) || "Component";
            _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error("No `render` method found on the %s instance: did you accidentally return an object from the constructor?", state) : console.error("No `render` method found on the %s instance: you may have forgotten to define `render`.", state));
            !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", state);
            _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", state);
            _instance.contextType && console.error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", state);
            Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error("%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)", state));
            Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error("%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)", state));
            "function" === typeof _instance.componentShouldUpdate && console.error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", state);
            Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(Component) || "A pure component");
            "function" === typeof _instance.componentDidUnmount && console.error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", state);
            "function" === typeof _instance.componentDidReceiveProps && console.error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", state);
            "function" === typeof _instance.componentWillRecieveProps && console.error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", state);
            "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", state);
            lane = _instance.props !== nextProps;
            void 0 !== _instance.props && lane && console.error("When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", state);
            _instance.defaultProps && console.error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", state, state);
            "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(Component)));
            "function" === typeof _instance.getDerivedStateFromProps && console.error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof _instance.getDerivedStateFromError && console.error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", state);
            "function" === typeof Component.getSnapshotBeforeUpdate && console.error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", state);
            (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
            "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", state);
            _instance = workInProgress.stateNode;
            _instance.props = nextProps;
            _instance.state = workInProgress.memoizedState;
            _instance.refs = {};
            initializeUpdateQueue(workInProgress);
            state = Component.contextType;
            _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
            _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", state)));
            workInProgress.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, _instance);
            ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, _instance);
            _instance.state = workInProgress.memoizedState;
            state = Component.getDerivedStateFromProps;
            "function" === typeof state && (applyDerivedStateFromProps(workInProgress, Component, state, nextProps), _instance.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component"), classComponentUpdater.enqueueReplaceState(_instance, _instance.state, null)), processUpdateQueue(workInProgress, nextProps, _instance, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress.memoizedState);
            "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308);
            (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456);
            _instance = !0;
        } else if (null === current) {
            _instance = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps;
            lane = resolveClassComponentProps(Component, unresolvedOldProps);
            _instance.props = lane;
            var oldContext = _instance.context;
            foundWillUpdateName = Component.contextType;
            state = emptyContextObject;
            "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
            newApiName = Component.getDerivedStateFromProps;
            foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, state);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(workInProgress, Component, newApiName, nextProps), oldContext = workInProgress.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, lane, nextProps, oldState, oldContext, state)) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456)) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress.flags |= 4194308), (workInProgress.mode & StrictEffectsMode) !== NoMode && (workInProgress.flags |= 268435456), _instance = !1);
        } else {
            _instance = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            state = workInProgress.memoizedProps;
            foundWillUpdateName = resolveClassComponentProps(Component, state);
            _instance.props = foundWillUpdateName;
            newApiName = workInProgress.pendingProps;
            oldState = _instance.context;
            oldContext = Component.contextType;
            lane = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(workInProgress, _instance, nextProps, lane);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            _instance.state = oldState;
            processUpdateQueue(workInProgress, nextProps, _instance, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            state !== newApiName || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, foundWillUpdateName, nextProps, oldState, newState, lane) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(nextProps, newState, lane)), "function" === typeof _instance.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), _instance = !1);
        }
        lane = _instance;
        markRef(current, workInProgress);
        state = 0 !== (workInProgress.flags & 128);
        if (lane || state) {
            lane = workInProgress.stateNode;
            setCurrentFiber(workInProgress);
            if (state && "function" !== typeof Component.getDerivedStateFromError) Component = null, profilerStartTime = -1;
            else if (Component = callRenderInDEV(lane), workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(!0);
                try {
                    callRenderInDEV(lane);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            workInProgress.flags |= 1;
            null !== current && state ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes);
            workInProgress.memoizedState = lane.state;
            current = workInProgress.child;
        } else current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        renderLanes = workInProgress.stateNode;
        _instance && renderLanes.props !== nextProps && (didWarnAboutReassigningProps || console.error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component"), didWarnAboutReassigningProps = !0);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        Component && Component.childContextTypes && console.error("childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...", Component.displayName || Component.name || "Component");
        "function" === typeof Component.getDerivedStateFromProps && (workInProgress = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] || (console.error("%s: Function components do not support getDerivedStateFromProps.", workInProgress), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress] = !0));
        "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error("%s: Function components do not support contextType.", Component), didWarnAboutContextTypeOnFunctionComponent[Component] = !0));
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        shouldSuspendImpl(workInProgress) && (workInProgress.flags |= 128);
        var showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
        (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
        JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
        JSCompiler_temp = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (renderLanes = canHydrateHydrationBoundary(current, rootOrSingletonContext), renderLanes = null !== renderLanes && renderLanes.data !== ACTIVITY_START_DATA ? renderLanes : null, null !== renderLanes && (JSCompiler_temp = {
                    dehydrated: renderLanes,
                    treeContext: getSuspendedTreeContext(),
                    retryLane: 536870912,
                    hydrationErrors: null
                }, workInProgress.memoizedState = JSCompiler_temp, JSCompiler_temp = createFiberFromDehydratedFragment(renderLanes), JSCompiler_temp.return = workInProgress, workInProgress.child = JSCompiler_temp, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : renderLanes = null;
                if (null === renderLanes) throw warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(renderLanes) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            didSuspend = nextProps.children;
            nextProps = nextProps.fallback;
            if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, didSuspend = mountWorkInProgressOffscreenFiber({
                mode: "hidden",
                children: didSuspend
            }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, didSuspend);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var _dehydrated2 = prevState.dehydrated;
            if (null !== _dehydrated2) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, _dehydrated2, prevState, renderLanes);
        }
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, _dehydrated2 = prevState.sibling, nextProps = createWorkInProgress(prevState, {
            mode: "hidden",
            children: nextProps.children
        }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== _dehydrated2 ? showFallback = createWorkInProgress(_dehydrated2, showFallback) : (showFallback = createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
            parent: prevState,
            pool: prevState
        } : didSuspend) : didSuspend = getSuspendedCache(), showFallback = {
            baseLanes: showFallback.baseLanes | renderLanes,
            cachePool: didSuspend
        }), nextProps.memoizedState = showFallback, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
        null !== prevState && (renderLanes & 62914560) === renderLanes && 0 !== (renderLanes & current.lanes) && markRenderDerivedCause(workInProgress);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: nextProps.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (didSuspend) {
            if (workInProgress.flags & 256) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            if (null !== workInProgress.memoizedState) return reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, null;
            reuseSuspenseHandlerOnStack(workInProgress);
            var fallbackChildren = nextProps.fallback, fiberMode = workInProgress.mode, primaryChildFragment = mountWorkInProgressOffscreenFiber({
                mode: "visible",
                children: nextProps.children
            }, fiberMode);
            fallbackChildren = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null);
            fallbackChildren.flags |= 2;
            primaryChildFragment.return = workInProgress;
            fallbackChildren.return = workInProgress;
            primaryChildFragment.sibling = fallbackChildren;
            workInProgress.child = primaryChildFragment;
            reconcileChildFibers(workInProgress, current.child, null, renderLanes);
            fallbackChildren = workInProgress.child;
            fallbackChildren.memoizedState = mountSuspenseOffscreenState(renderLanes);
            fallbackChildren.childLanes = getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
            workInProgress.memoizedState = SUSPENDED_MARKER;
            return bailoutOffscreenComponent(null, fallbackChildren);
        }
        pushPrimaryTreeSuspenseHandler(workInProgress);
        warnIfHydrating();
        0 !== (renderLanes & 536870912) && markRenderDerivedCause(workInProgress);
        if (isSuspenseInstanceFallback(suspenseInstance)) {
            didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
            if (didPrimaryChildrenDefer) {
                fallbackChildren = didPrimaryChildrenDefer.dgst;
                var message = didPrimaryChildrenDefer.msg;
                fiberMode = didPrimaryChildrenDefer.stck;
                primaryChildFragment = didPrimaryChildrenDefer.cstck;
            }
            suspenseInstance = message;
            suspenseState = fallbackChildren;
            nextProps = fiberMode;
            didPrimaryChildrenDefer = primaryChildFragment;
            fallbackChildren = suspenseState;
            fiberMode = suspenseInstance;
            primaryChildFragment = nextProps;
            nextProps = didPrimaryChildrenDefer;
            fallbackChildren !== REACT_RECOVERABLE_DIGEST && (didPrimaryChildrenDefer = fiberMode ? Error(fiberMode) : Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), didPrimaryChildrenDefer.stack = primaryChildFragment || "", didPrimaryChildrenDefer.digest = fallbackChildren, fallbackChildren = void 0 === nextProps ? null : nextProps, fiberMode = {
                value: didPrimaryChildrenDefer,
                source: null,
                stack: fallbackChildren
            }, "string" === typeof fallbackChildren && CapturedStacks.set(didPrimaryChildrenDefer, fiberMode), queueHydrationError(fiberMode));
            return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        }
        didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1);
        didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
        if (didReceiveUpdate || didPrimaryChildrenDefer) {
            if (null !== currentTreeHiddenStackCursor.current) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            didPrimaryChildrenDefer = workInProgressRoot;
            if (null !== didPrimaryChildrenDefer && (fallbackChildren = getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== fallbackChildren && fallbackChildren !== suspenseState.retryLane)) throw suspenseState.retryLane = fallbackChildren, enqueueConcurrentRenderForLane(current, fallbackChildren), scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, fallbackChildren), SelectiveHydrationException;
            isSuspenseInstancePending(suspenseInstance) || renderDidSuspendDelayIfPossible();
            return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        }
        if (isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
        current = suspenseState.treeContext;
        nextHydratableInstance = getNextHydratable(suspenseInstance.nextSibling);
        hydrationParentFiber = workInProgress;
        isHydrating = !0;
        hydrationErrors = null;
        didSuspendOrErrorDEV = !1;
        hydrationDiffRootDEV = null;
        rootOrSingletonContext = !1;
        null !== current && restoreSuspendedTreeContext(workInProgress, current);
        workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children);
        workInProgress.flags |= 134221824;
        return workInProgress;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function findLastContentRow(firstChild) {
        for(var lastContentRow = null; null !== firstChild;){
            var currentRow = firstChild.alternate;
            null !== currentRow && null === findFirstSuspended(currentRow) && (lastContentRow = firstChild);
            firstChild = firstChild.sibling;
        }
        return lastContentRow;
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function reverseChildren(fiber) {
        var row = fiber.child;
        for(fiber.child = null; null !== row;){
            var nextRow = row.sibling;
            row.sibling = fiber.child;
            fiber.child = row;
            row = nextRow;
        }
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
        if (workInProgress.flags & 128) return pushSuspenseListContext(workInProgress, suspenseContext), null;
        (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
        pushSuspenseListContext(workInProgress, suspenseContext);
        suspenseContext = null == revealOrder ? "null" : revealOrder;
        if (null != revealOrder && "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext]) {
            if (didWarnAboutRevealOrder[suspenseContext] = !0, "string" === typeof revealOrder) switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                case "independent":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    console.error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    console.error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
            }
            else console.error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?', revealOrder);
        }
        suspenseContext = null == tailMode ? "null" : tailMode;
        didWarnAboutTailOptions[suspenseContext] || null == tailMode || ("visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = !0, console.error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?', tailMode)) : null != revealOrder && "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = !0, console.error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" (default) or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode)));
        a: if ((null == revealOrder || "forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && !1 !== newChildren) {
            if (isArrayImpl(newChildren)) for(suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++){
                if (!validateSuspenseListNestedChild(newChildren[suspenseContext], suspenseContext)) break a;
            }
            else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
                if (suspenseContext = suspenseContext.call(newChildren)) for(var step = suspenseContext.next(), _i = 0; !step.done; step = suspenseContext.next()){
                    if (!validateSuspenseListNestedChild(step.value, _i)) break a;
                    _i++;
                }
            } else console.error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
        }
        "backwards" === revealOrder && null !== current ? (reverseChildren(current), reconcileChildren(current, workInProgress, newChildren, renderLanes), reverseChildren(current)) : reconcileChildren(current, workInProgress, newChildren, renderLanes);
        isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
        if (!nextProps && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "backwards":
                renderLanes = findLastContentRow(workInProgress.child);
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, reverseChildren(workInProgress));
                initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, newChildren);
                break;
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, newChildren);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, newChildren);
                break;
            case "independent":
                workInProgress.memoizedState = null;
                break;
            default:
                renderLanes = findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, newChildren);
        }
        return workInProgress.child;
    }
    function updateContextProvider(current, workInProgress, renderLanes) {
        var context = workInProgress.type, newProps = workInProgress.pendingProps, newValue = newProps.value;
        "value" in newProps || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = !0, console.error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        pushProvider(workInProgress, context, newValue);
        reconcileChildren(current, workInProgress, newProps.children, renderLanes);
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        profilerStartTime = -1;
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error("Resuming work not yet implemented.");
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 12:
                0 !== (renderLanes & workInProgress.childLanes) && (workInProgress.flags |= 4);
                workInProgress.flags |= 2048;
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = -0;
                stateNode.passiveEffectDuration = -0;
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                stateNode = workInProgress.memoizedState;
                if (null !== stateNode) {
                    if (null !== stateNode.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    stateNode = propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                    var primaryChildLanes = workInProgress.child.childLanes;
                    if (stateNode || 0 !== (renderLanes & primaryChildLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                if (workInProgress.flags & 128) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                primaryChildLanes = 0 !== (current.flags & 128);
                stateNode = 0 !== (renderLanes & workInProgress.childLanes);
                stateNode || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), stateNode = 0 !== (renderLanes & workInProgress.childLanes));
                if (primaryChildLanes) {
                    if (stateNode) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                primaryChildLanes = workInProgress.memoizedState;
                null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
                pushSuspenseListContext(workInProgress, suspenseStackCursor.current);
                if (stateNode) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && null !== current) {
            renderLanes = createFiberFromTypeAndProps(resolveTypeForHotReloading(workInProgress.elementType), workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes);
            renderLanes._debugStack = workInProgress._debugStack;
            renderLanes._debugTask = workInProgress._debugTask;
            var returnFiber = workInProgress.return;
            if (null === returnFiber) throw Error("Cannot swap the root fiber.");
            current.alternate = null;
            workInProgress.alternate = null;
            renderLanes.index = workInProgress.index;
            renderLanes.sibling = workInProgress.sibling;
            renderLanes.return = workInProgress.return;
            renderLanes.ref = workInProgress.ref;
            renderLanes._debugInfo = workInProgress._debugInfo;
            if (workInProgress === returnFiber.child) returnFiber.child = renderLanes;
            else {
                var prevSibling = returnFiber.child;
                if (null === prevSibling) throw Error("Expected parent to have a child.");
                for(; prevSibling.sibling !== workInProgress;)if (prevSibling = prevSibling.sibling, null === prevSibling) throw Error("Expected to find the previous sibling.");
                prevSibling.sibling = renderLanes;
            }
            workInProgress = returnFiber.deletions;
            null === workInProgress ? (returnFiber.deletions = [
                current
            ], returnFiber.flags |= 16) : workInProgress.push(current);
            renderLanes.flags |= 134217730;
            return renderLanes;
        }
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps || workInProgress.type !== current.type) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else {
            didReceiveUpdate = !1;
            if (returnFiber = isHydrating) warnIfNotHydrating(), returnFiber = 0 !== (workInProgress.flags & 1048576);
            returnFiber && (returnFiber = workInProgress.index, warnIfNotHydrating(), pushTreeId(workInProgress, treeForkCount, returnFiber));
        }
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: if (returnFiber = workInProgress.pendingProps, current = resolveLazy(workInProgress.elementType), current = resolveTypeForHotReloading(current), workInProgress.type = current, "function" === typeof current) shouldConstruct(current) ? (returnFiber = resolveClassComponentProps(current, returnFiber), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, returnFiber, renderLanes)) : (workInProgress.tag = 0, validateFunctionComponentInDev(workInProgress, current), workInProgress = updateFunctionComponent(null, workInProgress, current, returnFiber, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        if (prevSibling = current.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, returnFiber, renderLanes);
                            break a;
                        } else if (prevSibling === REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = "";
                    null !== current && "object" === typeof current && current.$$typeof === REACT_LAZY_TYPE && (workInProgress = " Did you wrap a component in React.lazy() more than once?");
                    renderLanes = getComponentNameFromType(current) || current;
                    throw Error("Element type is invalid. Received a promise that resolves to: " + renderLanes + ". Lazy element type must resolve to a class or function." + workInProgress);
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return returnFiber = workInProgress.type, prevSibling = resolveClassComponentProps(returnFiber, workInProgress.pendingProps), updateClassComponent(current, workInProgress, returnFiber, prevSibling, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error("Should have a current fiber. This is a bug in React.");
                    returnFiber = workInProgress.pendingProps;
                    var prevState = workInProgress.memoizedState;
                    prevSibling = prevState.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, returnFiber, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    returnFiber = nextState.cache;
                    pushProvider(workInProgress, CacheContext, returnFiber);
                    returnFiber !== prevState.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    returnFiber = nextState.element;
                    if (prevState.isDehydrated) {
                        if (prevState = {
                            element: returnFiber,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else if (returnFiber !== prevSibling) {
                            prevSibling = createCapturedValueAtFiber(Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                            queueHydrationError(prevSibling);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, returnFiber, renderLanes);
                            break a;
                        } else {
                            current = workInProgress.stateNode.containerInfo;
                            switch(current.nodeType){
                                case 9:
                                    current = current.body;
                                    break;
                                default:
                                    current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                            }
                            nextHydratableInstance = getNextHydratable(current.firstChild);
                            hydrationParentFiber = workInProgress;
                            isHydrating = !0;
                            hydrationErrors = null;
                            didSuspendOrErrorDEV = !1;
                            hydrationDiffRootDEV = null;
                            rootOrSingletonContext = !0;
                            renderLanes = mountChildFibers(workInProgress, null, returnFiber, renderLanes);
                            for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                        }
                    } else {
                        resetHydrationState();
                        if (returnFiber === prevSibling) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, returnFiber, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (workInProgress.stateNode = createHoistableInstance(workInProgress.type, workInProgress.pendingProps, requiredContext(rootInstanceStackCursor.current), workInProgress)) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                return pushHostContext(workInProgress), null === current && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, returnFiber, prevSibling, !1), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(returnFiber, workInProgress.type, workInProgress.pendingProps, prevSibling), null !== prevSibling && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(returnFiber.firstChild)) : nextHydratableInstance = prevSibling), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                return null === current && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(workInProgress.type, prevState.ancestorInfo), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(prevSibling, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== nextState ? (workInProgress.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(nextState, workInProgress.type, workInProgress.pendingProps, prevState), null !== prevState && (buildHydrationDiffNode(workInProgress, 0).serverProps = prevState)), hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(nextState.firstChild), rootOrSingletonContext = !1, prevState = !0) : prevState = !1, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress, prevSibling), throwOnHydrationMismatch(workInProgress))), pushHostContext(workInProgress), prevSibling = workInProgress.type, prevState = workInProgress.pendingProps, nextState = null !== current ? current.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress.flags |= 32), null !== workInProgress.memoizedState && (prevSibling = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = prevSibling), markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 6:
                return null === current && isHydrating && (renderLanes = workInProgress.pendingProps, current = getHostContext(), returnFiber = current.ancestorInfo.current, renderLanes = null != returnFiber ? validateTextNesting(renderLanes, returnFiber.tag, current.ancestorInfo.implicitRootScope) : !0, current = nextHydratableInstance, (returnFiber = !current) || (returnFiber = canHydrateTextInstance(current, workInProgress.pendingProps, rootOrSingletonContext), null !== returnFiber ? (workInProgress.stateNode = returnFiber, hydrationParentFiber = workInProgress, nextHydratableInstance = null, returnFiber = !0) : returnFiber = !1, returnFiber = !returnFiber), returnFiber && (renderLanes && warnNonHydratedInstance(workInProgress, current), throwOnHydrationMismatch(workInProgress))), null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), returnFiber = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, returnFiber, renderLanes) : reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return returnFiber = workInProgress.pendingProps, markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return workInProgress.flags |= 4, workInProgress.flags |= 2048, returnFiber = workInProgress.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return updateContextProvider(current, workInProgress, renderLanes);
            case 9:
                return prevSibling = workInProgress.type._context, returnFiber = workInProgress.pendingProps.children, "function" !== typeof returnFiber && console.error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), prepareToReadContext(workInProgress), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(returnFiber, prevSibling, void 0), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, returnFiber, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), returnFiber = readContext(CacheContext), null === current ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes), prevSibling = prevState), workInProgress.memoizedState = {
                    parent: returnFiber,
                    cache: prevSibling
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, prevSibling)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current.memoizedState, prevState = workInProgress.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
                    parent: returnFiber,
                    cache: returnFiber
                }, workInProgress.memoizedState = prevSibling, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = prevSibling), pushProvider(workInProgress, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 30:
                return null === workInProgress.stateNode && (workInProgress.stateNode = {
                    autoName: null,
                    paired: null,
                    clones: null,
                    ref: null
                }), returnFiber = workInProgress.pendingProps, null != returnFiber.name && "auto" !== returnFiber.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : isHydrating && pushMaterializedTreeId(workInProgress), void 0 !== returnFiber.className && (prevSibling = "string" === typeof returnFiber.className ? JSON.stringify(returnFiber.className) : "{...}", didWarnAboutClassNameOnViewTransition[prevSibling] || (didWarnAboutClassNameOnViewTransition[prevSibling] = !0, console.error('<ViewTransition> doesn\'t accept a "className" prop. It has been renamed to "default".\n-   <ViewTransition className=%s>\n+   <ViewTransition default=%s>', prevSibling, prevSibling))), null !== current && current.memoizedProps.name !== returnFiber.name ? workInProgress.flags |= 4194816 : markRef(current, workInProgress), reconcileChildren(current, workInProgress, returnFiber.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        var JSCompiler_temp;
        if (JSCompiler_temp = (workInProgress.mode & SuspenseyImagesMode) !== NoMode) JSCompiler_temp = null === oldProps ? maySuspendCommit(type, newProps) : maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
        if (JSCompiler_temp) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
                if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded) workInProgress.flags &= -16777217;
        else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
            if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "visible":
                break;
            case "collapsed":
                for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
                null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
                break;
            default:
                hasRenderedATailFallback = renderState.tail;
                for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === tailNode ? renderState.tail = null : tailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) {
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                for(var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2;)newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 1206910976, subtreeFlags |= _child2.flags & 1206910976, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 1206910976, subtreeFlags |= _treeBaseDuration.flags & 1206910976, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        } else if ((completedWork.mode & ProfileMode) !== NoMode) {
            _treeBaseDuration = completedWork.actualDuration;
            _child2 = completedWork.selfBaseDuration;
            for(var child = completedWork.child; null !== child;)newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
            completedWork.actualDuration = _treeBaseDuration;
            completedWork.treeBaseDuration = _child2;
        } else for(_treeBaseDuration = completedWork.child; null !== _treeBaseDuration;)newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext, workInProgress);
                popHostContainer(workInProgress);
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress)) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                bubbleProperties(workInProgress);
                return null;
            case 26:
                var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
                return null;
            case 27:
                popHostContext(workInProgress);
                renderLanes = requiredContext(rootInstanceStackCursor.current);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        workInProgress.subtreeFlags &= -33554433;
                        return null;
                    }
                    current = getHostContext();
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                workInProgress.subtreeFlags &= -33554433;
                return null;
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                        bubbleProperties(workInProgress);
                        workInProgress.subtreeFlags &= -33554433;
                        return null;
                    }
                    var _currentHostContext = getHostContext();
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, _currentHostContext);
                    else {
                        nextResource = requiredContext(rootInstanceStackCursor.current);
                        validateDOMNesting(type, _currentHostContext.ancestorInfo);
                        _currentHostContext = _currentHostContext.context;
                        nextResource = getOwnerDocumentFromRootContainer(nextResource);
                        switch(_currentHostContext){
                            case HostContextNamespaceSvg:
                                nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                break;
                            case HostContextNamespaceMath:
                                nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                break;
                            default:
                                switch(type){
                                    case "svg":
                                        nextResource = nextResource.createElementNS(SVG_NAMESPACE, type);
                                        break;
                                    case "math":
                                        nextResource = nextResource.createElementNS(MATH_NAMESPACE, type);
                                        break;
                                    case "script":
                                        nextResource = nextResource.createElement("div");
                                        didWarnScriptTags || isScriptDataBlock(newProps) || (console.error("Encountered a script tag while rendering React component. Scripts inside React components are never executed when rendering on the client. Consider using template tag instead (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/template)."), didWarnScriptTags = !0);
                                        nextResource.innerHTML = "<script>\x3c/script>";
                                        nextResource = nextResource.removeChild(nextResource.firstChild);
                                        break;
                                    case "select":
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                                            is: newProps.is
                                        }) : nextResource.createElement("select");
                                        newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                        break;
                                    default:
                                        nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                                            is: newProps.is
                                        }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = !0, console.error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type)));
                                }
                        }
                        nextResource[internalInstanceKey] = workInProgress;
                        nextResource[internalPropsKey] = newProps;
                        a: for(_currentHostContext = workInProgress.child; null !== _currentHostContext;){
                            if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag) nextResource.appendChild(_currentHostContext.stateNode);
                            else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                                _currentHostContext.child.return = _currentHostContext;
                                _currentHostContext = _currentHostContext.child;
                                continue;
                            }
                            if (_currentHostContext === workInProgress) break a;
                            for(; null === _currentHostContext.sibling;){
                                if (null === _currentHostContext.return || _currentHostContext.return === workInProgress) break a;
                                _currentHostContext = _currentHostContext.return;
                            }
                            _currentHostContext.sibling.return = _currentHostContext.return;
                            _currentHostContext = _currentHostContext.sibling;
                        }
                        workInProgress.stateNode = nextResource;
                        a: switch(setInitialProperties(nextResource, type, newProps), type){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                newProps = !!newProps.autoFocus;
                                break a;
                            case "img":
                                newProps = !0;
                                break a;
                            default:
                                newProps = !1;
                        }
                        newProps && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                workInProgress.subtreeFlags &= -33554433;
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    current = requiredContext(rootInstanceStackCursor.current);
                    renderLanes = getHostContext();
                    if (popHydrationState(workInProgress)) {
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        type = !didSuspendOrErrorDEV;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 3:
                                type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                                break;
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(current, renderLanes, newProps), null !== type && (buildHydrationDiffNode(workInProgress, 0).serverProps = type));
                        }
                        current[internalInstanceKey] = workInProgress;
                        current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                        current || throwOnHydrationMismatch(workInProgress, !0);
                    } else type = renderLanes.ancestorInfo.current, null != type && validateTextNesting(newProps, type.tag, renderLanes.ancestorInfo.implicitRootScope), current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error("Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue.");
                            current[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (renderLanes = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error("Client rendering an Activity suspended it again. This is a bug in React.");
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = newProps;
                    nextResource = popHydrationState(workInProgress);
                    if (null !== type && null !== type.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
                            nextResource[internalInstanceKey] = workInProgress;
                            bubbleProperties(workInProgress);
                            (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        } else emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress.flags & 128) && (type = workInProgress.memoizedState = null), workInProgress.flags |= 4, bubbleProperties(workInProgress), (workInProgress.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress.child, null !== type && (workInProgress.treeBaseDuration -= type.treeBaseDuration));
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                (workInProgress.mode & ProfileMode) !== NoMode && renderLanes && (current = workInProgress.child, null !== current && (workInProgress.treeBaseDuration -= current.treeBaseDuration));
                return null;
            case 4:
                return popHostContainer(workInProgress), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), bubbleProperties(workInProgress), null;
            case 19:
                popSuspenseListContext(workInProgress);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (workInProgressRootExitStatus !== RootInProgress || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                pushSuspenseListContext(workInProgress, suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) {
                    current = newProps.tail;
                    a: {
                        for(renderLanes = current; null !== renderLanes;){
                            if (null !== renderLanes.alternate) {
                                renderLanes = !1;
                                break a;
                            }
                            renderLanes = renderLanes.sibling;
                        }
                        renderLanes = !0;
                    }
                    newProps.rendering = current;
                    newProps.tail = current.sibling;
                    newProps.renderingStartTime = now$1();
                    current.sibling = null;
                    nextResource = suspenseStackCursor.current;
                    nextResource = type ? nextResource & SubtreeSuspenseContextMask | ForceSuspenseFallback : nextResource & SubtreeSuspenseContextMask;
                    "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || isHydrating ? pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, push(suspenseHandlerStackCursor, workInProgress, workInProgress), push(suspenseStackCursor, renderLanes, workInProgress), null === shellBoundary && (shellBoundary = workInProgress));
                    isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                    return current;
                }
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache, workInProgress), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext, workInProgress), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return workInProgress.flags |= 33554432, bubbleProperties(workInProgress), null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 3:
                return popProvider(CacheContext, workInProgress), popHostContainer(workInProgress), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 19:
                return popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
            case 4:
                return popHostContainer(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type, workInProgress), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(workInProgress), null !== current && pop(resumedCache, workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, (workInProgress.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress), workInProgress) : null;
            case 24:
                return popProvider(CacheContext, workInProgress), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext, interruptedWork);
                popHostContainer(interruptedWork);
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer(interruptedWork);
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                popSuspenseListContext(interruptedWork);
                break;
            case 10:
                popProvider(interruptedWork.type, interruptedWork);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext(interruptedWork);
                null !== current && pop(resumedCache, interruptedWork);
                break;
            case 24:
                popProvider(CacheContext, interruptedWork);
        }
    }
    function shouldProfile(current) {
        return (current.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = runWithFiberInDEV(finishedWork, callCreateInDEV, updateQueue), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
                        var hookName = void 0;
                        hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
                        var addendum = void 0;
                        addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
                        runWithFiberInDEV(finishedWork, function(n, a) {
                            console.error("%s must not return anything besides a function, which is used for clean-up.%s", n, a);
                        }, hookName, addendum);
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !0), lastEffect = finishedWork, runWithFiberInDEV(lastEffect, callDestroyInDEV, lastEffect, nearestMountedAncestor, destroy), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = !1));
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
        shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor), recordEffectDuration()) : commitHookEffectListUnmount(hookFlags, finishedWork, nearestMountedAncestor);
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), instance.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
            try {
                runWithFiberInDEV(finishedWork, commitCallbacks, updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
        return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current) {
        var prevProps = current.memoizedProps, prevState = current.memoizedState;
        current = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), current.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
        try {
            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps);
            var snapshot = runWithFiberInDEV(finishedWork, callGetSnapshotBeforeUpdates, current, resolvedPrevProps, prevState);
            prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
            void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
                console.error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
            }));
            current.__reactInternalSnapshotBeforeUpdate = snapshot;
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        shouldProfile(current) ? (startEffectTimer(), runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance), recordEffectDuration()) : runWithFiberInDEV(current, callComponentWillUnmountInDEV, current, nearestMountedAncestor, instance);
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (null !== ref) {
            switch(finishedWork.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = finishedWork.stateNode;
                    break;
                case 30:
                    instanceToUse = finishedWork.stateNode;
                    var name = getViewTransitionName(finishedWork.memoizedProps, instanceToUse);
                    if (null === instanceToUse.ref || instanceToUse.ref.name !== name) instanceToUse.ref = createViewTransitionInstance(name);
                    instanceToUse = instanceToUse.ref;
                    break;
                case 7:
                    null === finishedWork.stateNode && (instanceToUse = new FragmentInstance(finishedWork), traverseFragmentInstancesAndTextInstances(finishedWork, addFragmentHandleToFiber, instanceToUse), finishedWork.stateNode = instanceToUse);
                    instanceToUse = finishedWork.stateNode;
                    break;
                default:
                    instanceToUse = finishedWork.stateNode;
            }
            if ("function" === typeof ref) {
                if (shouldProfile(finishedWork)) try {
                    startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
                } finally{
                    recordEffectDuration();
                }
                else finishedWork.refCleanup = ref(instanceToUse);
            } else "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork)), ref.current = instanceToUse;
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            runWithFiberInDEV(current, commitAttachRef, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, refCleanup);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, refCleanup);
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                if (shouldProfile(current)) try {
                    startEffectTimer(), runWithFiberInDEV(current, ref, null);
                } finally{
                    recordEffectDuration(current);
                }
                else runWithFiberInDEV(current, ref, null);
            } catch (error$8) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$8);
            }
            else ref.current = null;
        }
    }
    function commitProfiler(finishedWork, current, commitStartTime, effectDuration) {
        var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
        _finishedWork$memoize = _finishedWork$memoize.onRender;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize && _finishedWork$memoize(id, current, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitStartTime);
        "function" === typeof onCommit && onCommit(id, current, effectDuration, commitStartTime);
    }
    function commitProfilerPostCommitImpl(finishedWork, current, commitStartTime, passiveEffectDuration) {
        var _finishedWork$memoize2 = finishedWork.memoizedProps;
        finishedWork = _finishedWork$memoize2.id;
        _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
        current = null === current ? "mount" : "update";
        currentUpdateIsNested && (current = "nested-update");
        "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(finishedWork, current, passiveEffectDuration, commitStartTime);
    }
    function commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
        if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
    }
    function commitFragmentInstanceInsertionEffects(fiber) {
        for(var parent = fiber.return; null !== parent;){
            isFragmentInstanceParent(parent) && commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
    }
    function commitFragmentInstanceDeletionEffects(fiber) {
        for(var parent = fiber.return; null !== parent;){
            isFragmentInstanceParent(parent) && deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
    }
    function isFragmentInstanceHostBoundary(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
    }
    function isFragmentInstanceParent(fiber) {
        return fiber && 7 === fiber.tag && null !== fiber.stateNode;
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            runWithFiberInDEV(finishedWork, commitMount, instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            runWithFiberInDEV(finishedWork, commitUpdate, finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) tag = node.stateNode, before ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before)) : (warnForReactChildrenConflict(parent), before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), tag = parent._reactRootContainer, null !== tag && void 0 !== tag || null !== before.onclick || (before.onclick = noop$1)), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
        else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), commitNewChildToFragmentInstances(node, parentFragmentInstances), viewTransitionMutationContext = !0;
        else if (4 !== tag && (27 === tag && (commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
        for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
            if (isHostParent(parentFiber)) {
                hostParentFiber = parentFiber;
                break;
            }
            parentFiber = parentFiber.return;
        }
        parentFiber = null;
        for(var parent = finishedWork.return; null !== parent;){
            if (isFragmentInstanceParent(parent)) {
                var fragmentInstance = parent.stateNode;
                null === parentFiber ? parentFiber = [
                    fragmentInstance
                ] : parentFiber.push(fragmentInstance);
            }
            if (isFragmentInstanceHostBoundary(parent)) break;
            parent = parent.return;
        }
        if (null == hostParentFiber) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        switch(hostParentFiber.tag){
            case 27:
                hostParentFiber = hostParentFiber.stateNode;
                parent = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, parent, hostParentFiber, parentFiber);
                break;
            case 5:
                parent = hostParentFiber.stateNode;
                hostParentFiber.flags & 32 && (resetTextContent(parent), hostParentFiber.flags &= -33);
                hostParentFiber = getHostSibling(finishedWork);
                insertOrAppendPlacementNode(finishedWork, hostParentFiber, parent, parentFiber);
                break;
            case 3:
            case 4:
                hostParentFiber = hostParentFiber.stateNode.containerInfo;
                parent = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, parent, hostParentFiber, parentFiber);
                break;
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            runWithFiberInDEV(finishedWork, acquireSingletonInstance, finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function trackEnterViewTransitions(placement) {
        if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) shouldStartViewTransition = !0;
    }
    function pushViewTransitionCancelableScope() {
        var prevChildren = viewTransitionCancelableChildren;
        viewTransitionCancelableChildren = null;
        return prevChildren;
    }
    function applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
        viewTransitionHostInstanceIdx = 0;
        (name = applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions)) && null != fiber._debugTask && null === animatingTask && (animatingTask = fiber._debugTask);
        return name;
    }
    function applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
        for(var inViewport = !1; null !== child;){
            if (5 === child.tag) {
                var _instance = child.stateNode;
                if (null !== collectMeasurements) {
                    var measurement = measureInstance(_instance);
                    collectMeasurements.push(measurement);
                    measurement.view && (inViewport = !0);
                } else inViewport || measureInstance(_instance).view && (inViewport = !0);
                shouldStartViewTransition = !0;
                applyViewTransitionName(_instance, 0 === viewTransitionHostInstanceIdx ? name : name + "_" + viewTransitionHostInstanceIdx, className);
                viewTransitionHostInstanceIdx++;
            } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
            child = child.sibling;
        }
        return inViewport;
    }
    function restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
        for(; null !== child;){
            if (5 === child.tag) restoreViewTransitionName(child.stateNode, child.memoizedProps);
            else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
            child = child.sibling;
        }
    }
    function commitAppearingPairViewTransitions(placement) {
        if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
            if (22 !== placement.tag || null === placement.memoizedState) {
                if (commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                    var props = placement.memoizedProps;
                    if (null == props.name || "auto" === props.name) throw Error("Found a pair with an auto name. This is a bug in React.");
                    var name = props.name;
                    props = getViewTransitionClassName(props.default, props.share);
                    "none" !== props && (applyViewTransitionToHostInstances(placement, name, props, null, !1) || restoreViewTransitionOnHostInstances(placement.child, !1));
                }
            }
            placement = placement.sibling;
        }
    }
    function commitEnterViewTransitions(placement, gesture) {
        if (30 === placement.tag) {
            var state = placement.stateNode, props = placement.memoizedProps, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
            "none" !== className ? applyViewTransitionToHostInstances(placement, name, className, null, !1) ? (commitAppearingPairViewTransitions(placement), state.paired || gesture || scheduleViewTransitionEvent(placement, props.onEnter)) : restoreViewTransitionOnHostInstances(placement.child, !1) : commitAppearingPairViewTransitions(placement);
        } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
        else commitAppearingPairViewTransitions(placement);
    }
    function commitDeletedPairViewTransitions(deletion) {
        if (null !== appearingViewTransitions && 0 !== appearingViewTransitions.size) {
            var pairs = appearingViewTransitions;
            if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
                if (22 !== deletion.tag || null === deletion.memoizedState) {
                    if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                        var props = deletion.memoizedProps, name = props.name;
                        if (null != name && "auto" !== name) {
                            var pair = pairs.get(name);
                            if (void 0 !== pair) {
                                var className = getViewTransitionClassName(props.default, props.share);
                                "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, scheduleViewTransitionEvent(deletion, props.onShare)) : restoreViewTransitionOnHostInstances(deletion.child, !1));
                                pairs.delete(name);
                                if (0 === pairs.size) break;
                            }
                        }
                    }
                    commitDeletedPairViewTransitions(deletion);
                }
                deletion = deletion.sibling;
            }
        }
    }
    function commitExitViewTransitions(deletion) {
        if (30 === deletion.tag) {
            var props = deletion.memoizedProps, name = getViewTransitionName(props, deletion.stateNode), pair = null !== appearingViewTransitions ? appearingViewTransitions.get(name) : void 0, className = getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
            "none" !== className && (applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, appearingViewTransitions.delete(name), scheduleViewTransitionEvent(deletion, props.onShare)) : scheduleViewTransitionEvent(deletion, props.onExit) : restoreViewTransitionOnHostInstances(deletion.child, !1));
            null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
        } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)commitExitViewTransitions(deletion), deletion = deletion.sibling;
        else null !== appearingViewTransitions && commitDeletedPairViewTransitions(deletion);
    }
    function commitNestedViewTransitions(changedParent) {
        for(changedParent = changedParent.child; null !== changedParent;){
            if (30 === changedParent.tag) {
                var props = changedParent.memoizedProps, name = getViewTransitionName(props, changedParent.stateNode);
                props = getViewTransitionClassName(props.default, props.update);
                changedParent.flags &= -5;
                "none" !== props && applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
            } else 0 !== (changedParent.subtreeFlags & 33554432) && commitNestedViewTransitions(changedParent);
            changedParent = changedParent.sibling;
        }
    }
    function restorePairedViewTransitions(parent) {
        if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
            if (22 !== parent.tag || null === parent.memoizedState) {
                if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                    var instance = parent.stateNode;
                    null !== instance.paired && (instance.paired = null, restoreViewTransitionOnHostInstances(parent.child, !1));
                }
                restorePairedViewTransitions(parent);
            }
            parent = parent.sibling;
        }
    }
    function restoreEnterOrExitViewTransitions(fiber) {
        if (30 === fiber.tag) fiber.stateNode.paired = null, restoreViewTransitionOnHostInstances(fiber.child, !1), restorePairedViewTransitions(fiber);
        else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
        else restorePairedViewTransitions(fiber);
    }
    function restoreNestedViewTransitions(changedParent) {
        for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
    }
    function measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
        for(var inViewport = !1; null !== child;){
            if (5 === child.tag) {
                var _instance2 = child.stateNode;
                if (null !== previousMeasurements && viewTransitionHostInstanceIdx < previousMeasurements.length) {
                    var previousMeasurement = previousMeasurements[viewTransitionHostInstanceIdx], nextMeasurement = measureInstance(_instance2);
                    if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                    var JSCompiler_temp;
                    if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                        if (nextMeasurement.clip) JSCompiler_temp = !0;
                        else {
                            JSCompiler_temp = previousMeasurement.rect;
                            var newRect = nextMeasurement.rect;
                            JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                        }
                    }
                    JSCompiler_temp && (parentViewTransition.flags |= 4);
                    nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                    nextMeasurement && (parentViewTransition.flags |= 32);
                } else parentViewTransition.flags |= 32;
                0 !== (parentViewTransition.flags & 4) && applyViewTransitionName(_instance2, 0 === viewTransitionHostInstanceIdx ? newName : newName + "_" + viewTransitionHostInstanceIdx, className);
                inViewport && 0 !== (parentViewTransition.flags & 4) || (null === viewTransitionCancelableChildren && (viewTransitionCancelableChildren = []), viewTransitionCancelableChildren.push(_instance2, 0 === viewTransitionHostInstanceIdx ? oldName : oldName + "_" + viewTransitionHostInstanceIdx, child.memoizedProps));
                viewTransitionHostInstanceIdx++;
            } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
            child = child.sibling;
        }
        return inViewport;
    }
    function measureNestedViewTransitions(changedParent, gesture) {
        for(changedParent = changedParent.child; null !== changedParent;){
            if (30 === changedParent.tag) {
                var props = changedParent.memoizedProps, state = changedParent.stateNode, name = getViewTransitionName(props, state), className = getViewTransitionClassName(props.default, props.update);
                if (gesture) {
                    state = state.clones;
                    var previousMeasurements = null === state ? null : state.map(measureClonedInstance);
                } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
                state = changedParent;
                var child = changedParent.child, newName = name;
                viewTransitionHostInstanceIdx = 0;
                className = measureViewTransitionHostInstancesRecursive(state, child, newName, name, className, previousMeasurements, !1);
                0 !== (changedParent.flags & 4) && className && (gesture || scheduleViewTransitionEvent(changedParent, props.onUpdate));
            } else 0 !== (changedParent.subtreeFlags & 33554432) && measureNestedViewTransitions(changedParent, gesture);
            changedParent = changedParent.sibling;
        }
    }
    function trackNamedViewTransition(fiber) {
        var name = fiber.memoizedProps.name;
        if (null != name && "auto" !== name) {
            var existing = mountedNamedViewTransitions.get(name);
            if (void 0 !== existing) {
                if (existing !== fiber && existing !== fiber.alternate && !didWarnAboutName[name]) {
                    didWarnAboutName[name] = !0;
                    var stringifiedName = JSON.stringify(name);
                    runWithFiberInDEV(fiber, function() {
                        console.error("There are two <ViewTransition name=%s> components with the same name mounted at the same time. This is not supported and will cause View Transitions to error. Try to use a more unique name e.g. by using a namespace prefix and adding the id of an item to the name.", stringifiedName);
                    });
                    runWithFiberInDEV(existing, function() {
                        console.error("The existing <ViewTransition name=%s> duplicate has this stack trace.", stringifiedName);
                    });
                }
            } else mountedNamedViewTransitions.set(name, fiber);
        }
    }
    function untrackNamedViewTransition(fiber) {
        var name = fiber.memoizedProps.name;
        if (null != name && "auto" !== name) {
            var existing = mountedNamedViewTransitions.get(name);
            void 0 === existing || existing !== fiber && existing !== fiber.alternate || mountedNamedViewTransitions.delete(name);
        }
    }
    function isHydratingParent(current, finishedWork) {
        return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current = current.memoizedState, finishedWork = finishedWork.memoizedState, null !== current && null !== current.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : !1;
    }
    function commitBeforeMutationEffects(root, firstChild, committedLanes) {
        root = root.containerInfo;
        eventsEnabled = _enabled;
        root = getActiveElementDeep(root);
        if (hasSelectionCapabilities(root)) {
            if ("selectionStart" in root) var JSCompiler_temp = {
                start: root.selectionStart,
                end: root.selectionEnd
            };
            else a: {
                JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
                var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
                if (selection && 0 !== selection.rangeCount) {
                    JSCompiler_temp = selection.anchorNode;
                    var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                    selection = selection.focusOffset;
                    try {
                        JSCompiler_temp.nodeType, focusNode.nodeType;
                    } catch (e$3) {
                        JSCompiler_temp = null;
                        break a;
                    }
                    var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                    b: for(;;){
                        for(var next;;){
                            node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                            node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                            3 === node.nodeType && (length += node.nodeValue.length);
                            if (null === (next = node.firstChild)) break;
                            parentNode = node;
                            node = next;
                        }
                        for(;;){
                            if (node === root) break b;
                            parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                            parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                            if (null !== (next = node.nextSibling)) break;
                            node = parentNode;
                            parentNode = node.parentNode;
                        }
                        node = next;
                    }
                    JSCompiler_temp = -1 === start || -1 === end ? null : {
                        start: start,
                        end: end
                    };
                } else JSCompiler_temp = null;
            }
            JSCompiler_temp = JSCompiler_temp || {
                start: 0,
                end: 0
            };
        } else JSCompiler_temp = null;
        selectionInformation = {
            focusedElem: root,
            selectionRange: JSCompiler_temp
        };
        _enabled = !1;
        committedLanes = (committedLanes & 335544064) === committedLanes;
        nextEffect = firstChild;
        for(firstChild = committedLanes ? 9270 : 1024; null !== nextEffect;){
            root = nextEffect;
            if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
            if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && trackEnterViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes);
            else {
                if (22 === root.tag) {
                    if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                        null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && commitExitViewTransitions(JSCompiler_temp);
                        commitBeforeMutationEffects_complete(committedLanes);
                        continue;
                    } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                        committedLanes && trackEnterViewTransitions(root);
                        commitBeforeMutationEffects_complete(committedLanes);
                        continue;
                    }
                }
                JSCompiler_temp = root.child;
                0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, nextEffect = JSCompiler_temp) : (committedLanes && commitNestedViewTransitions(root), commitBeforeMutationEffects_complete(committedLanes));
            }
        }
        appearingViewTransitions = null;
    }
    function commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, finishedWork = fiber, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = finishedWork.alternate, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    0 !== (flags & 1024) && null !== current && commitClassSnapshot(finishedWork, current);
                    break;
                case 3:
                    if (0 !== (flags & 1024)) {
                        if (isViewTransitionEligible = finishedWork.stateNode.containerInfo, finishedWork = isViewTransitionEligible.nodeType, 9 === finishedWork) clearContainerSparingly(isViewTransitionEligible);
                        else if (1 === finishedWork) switch(isViewTransitionEligible.nodeName){
                            case "HEAD":
                            case "HTML":
                            case "BODY":
                                clearContainerSparingly(isViewTransitionEligible);
                                break;
                            default:
                                isViewTransitionEligible.textContent = "";
                        }
                    }
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                case 30:
                    isViewTransitionEligible && null !== current && (isViewTransitionEligible = current, current = finishedWork, finishedWork = getViewTransitionName(isViewTransitionEligible.memoizedProps, isViewTransitionEligible.stateNode), current = current.memoizedProps, current = getViewTransitionClassName(current.default, current.update), "none" !== current && applyViewTransitionToHostInstances(isViewTransitionEligible, finishedWork, current, isViewTransitionEligible.memoizedState = [], !0));
                    break;
                default:
                    if (0 !== (flags & 1024)) throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            isViewTransitionEligible = fiber.sibling;
            if (null !== isViewTransitionEligible) {
                isViewTransitionEligible.return = fiber.return;
                nextEffect = isViewTransitionEligible;
                break;
            }
            nextEffect = fiber.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance")), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, finishedRoot);
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"), finishedRoot.state !== finishedWork.memoizedState && console.error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance"));
                        shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate), recordEffectDuration()) : runWithFiberInDEV(finishedWork, callComponentDidUpdateInDEV, finishedWork, finishedRoot, prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                current = pushNestedEffectDurations();
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    prevProps = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            prevProps = finishedWork.child.stateNode;
                            break;
                        case 1:
                            prevProps = finishedWork.child.stateNode;
                    }
                    try {
                        runWithFiberInDEV(finishedWork, commitCallbacks, flags, prevProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                finishedRoot.effectDuration += popNestedEffectDurations(current);
                break;
            case 27:
                null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            runWithFiberInDEV(finishedWork, commitHydratedInstance, prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, finishedRoot.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, flags))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    current = offscreenSubtreeIsHidden;
                    prevProps = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = IncludeHostSingletons, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= IncludeWorkInProgressEffects), recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = current;
                    offscreenSubtreeWasHidden = prevProps;
                }
                break;
            case 30:
                flags & 18874368 && trackNamedViewTransition(finishedWork);
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function hideOrUnhideAllChildren(parentFiber, isHidden) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
    }
    function hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
        switch(fiber.tag){
            case 5:
            case 26:
                try {
                    var instance = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideInstance, instance) : runWithFiberInDEV(fiber, unhideInstance, fiber.stateNode, fiber.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                hideOrUnhideNearestPortals(fiber, isHidden);
                break;
            case 6:
                try {
                    var instance$jscomp$0 = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideTextInstance, instance$jscomp$0) : runWithFiberInDEV(fiber, unhideTextInstance, instance$jscomp$0, fiber.memoizedProps);
                    viewTransitionMutationContext = !0;
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case 18:
                try {
                    var instance$jscomp$1 = fiber.stateNode;
                    isHidden ? runWithFiberInDEV(fiber, hideDehydratedBoundary, instance$jscomp$1) : runWithFiberInDEV(fiber, unhideDehydratedBoundary, fiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case 22:
            case 23:
                null === fiber.memoizedState && hideOrUnhideAllChildren(fiber, isHidden);
                break;
            default:
                hideOrUnhideAllChildren(fiber, isHidden);
        }
    }
    function hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
        if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
            a: {
                var fiber = parentFiber, isHidden = isHidden$jscomp$0;
                switch(fiber.tag){
                    case 4:
                        hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                        break a;
                    case 22:
                        null === fiber.memoizedState && hideOrUnhideNearestPortals(fiber, isHidden);
                        break a;
                    default:
                        hideOrUnhideNearestPortals(fiber, isHidden);
                }
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber._debugOwner = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(deletedFiber.tag){
            case 26:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !offscreenSubtreeWasHidden && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
                break;
            case 27:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                commitFragmentInstanceDeletionEffects(deletedFiber);
                var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                runWithFiberInDEV(deletedFiber, releaseSingletonInstance, deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor), commitFragmentInstanceDeletionEffects(deletedFiber);
            case 6:
                6 === deletedFiber.tag && commitFragmentInstanceDeletionEffects(deletedFiber);
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (null !== hostParent) {
                    if (hostParentIsContainer) try {
                        runWithFiberInDEV(deletedFiber, removeChildFromContainer, hostParent, deletedFiber.stateNode), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                    else try {
                        runWithFiberInDEV(deletedFiber, removeChild, hostParent, deletedFiber.stateNode), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                    }
                }
                break;
            case 18:
                null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                prevHostParent = hostParent;
                prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = !0;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(Insertion, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(deletedFiber, nearestMountedAncestor, Layout);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            case 30:
                deletedFiber.flags & 18874368 && untrackNamedViewTransition(deletedFiber);
                safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 7:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
        (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(deletedFiber, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                runWithFiberInDEV(finishedWork, commitHydratedActivityInstance, finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            runWithFiberInDEV(finishedWork, commitHydratedSuspenseInstance, finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error("Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React.");
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                if (isDevToolsPresent) {
                    if (null !== inProgressLanes && null !== inProgressRoot) restorePendingUpdaters(inProgressRoot, inProgressLanes);
                    else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                }
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var root = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
            a: for(; null !== parent;){
                switch(parent.tag){
                    case 27:
                        if (isSingletonScope(parent.type)) {
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        }
                        break;
                    case 5:
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    case 3:
                    case 4:
                        hostParent = parent.stateNode.containerInfo;
                        hostParentIsContainer = !0;
                        break a;
                }
                parent = parent.return;
            }
            if (null === hostParent) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
            hostParent = null;
            hostParentIsContainer = !1;
            (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(deletedFiber, componentEffectStartTime, componentEffectEndTime, "Unmount");
            popComponentEffectStart(prevEffectStart);
            root = deletedFiber;
            returnFiber = root.alternate;
            null !== returnFiber && (returnFiber.return = null);
            root.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                    var _eventPayloads$ii2 = current[ii];
                    _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
                }
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout | HasEffect));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags & 64 && offscreenSubtreeIsHidden && (root = finishedWork.updateQueue, null !== root && (lanes = root.callbacks, null !== lanes && (flags = root.shared.hiddenCallbacks, root.shared.hiddenCallbacks = null === flags ? lanes : flags.concat(lanes))));
                break;
            case 26:
                ii = currentHoistableRoot;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (flags & 4) {
                    if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                        if (null === lanes) {
                            if (null === finishedWork.stateNode) {
                                if (offscreenSubtreeIsHidden) finishedWork.stateNode = createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                                else {
                                    a: {
                                        root = finishedWork.type;
                                        lanes = finishedWork.memoizedProps;
                                        flags = ii.ownerDocument || ii;
                                        b: switch(root){
                                            case "title":
                                                current = flags.getElementsByTagName("title")[0];
                                                if (!current || current[internalHoistableMarker] || current[internalInstanceKey] || current.namespaceURI === SVG_NAMESPACE || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                                setInitialProperties(current, root, lanes);
                                                current[internalInstanceKey] = finishedWork;
                                                markNodeAsHoistable(current);
                                                root = current;
                                                break a;
                                            case "link":
                                                if (ii = getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                    for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                        ii.splice(_eventPayloads$ii2, 1);
                                                        break b;
                                                    }
                                                }
                                                current = flags.createElement(root);
                                                setInitialProperties(current, root, lanes);
                                                flags.head.appendChild(current);
                                                break;
                                            case "meta":
                                                if (ii = getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                    for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], checkAttributeStringCoercion(lanes.content, "content"), current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                        ii.splice(_eventPayloads$ii2, 1);
                                                        break b;
                                                    }
                                                }
                                                current = flags.createElement(root);
                                                setInitialProperties(current, root, lanes);
                                                flags.head.appendChild(current);
                                                break;
                                            default:
                                                throw Error('getNodesForType encountered a type it did not expect: "' + root + '". This is a bug in React.');
                                        }
                                        current[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(current);
                                        root = current;
                                    }
                                    finishedWork.stateNode = root;
                                }
                            } else offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                        } else finishedWork.stateNode = acquireResource(ii, lanes, finishedWork.memoizedProps);
                    } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? offscreenSubtreeIsHidden || mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                }
                break;
            case 27:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                break;
            case 5:
                ii = offscreenDirectParentIsHidden;
                offscreenDirectParentIsHidden = !1;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                offscreenDirectParentIsHidden = ii;
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (finishedWork.flags & 32) {
                    root = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, resetTextContent, root), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
                flags & 1024 && (needsFormReset = !0, "form" !== finishedWork.type && console.error("Unexpected host component type. Expected a form. This is a bug in React."));
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (null === finishedWork.stateNode) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    root = finishedWork.memoizedProps;
                    lanes = null !== current ? current.memoizedProps : root;
                    flags = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitTextUpdate, flags, lanes, root), viewTransitionMutationContext = !0;
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                ii = pushNestedEffectDurations();
                viewTransitionMutationContext = !1;
                tagCaches = null;
                _eventPayloads$ii2 = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(root.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                currentHoistableRoot = _eventPayloads$ii2;
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                    runWithFiberInDEV(finishedWork, commitHydratedContainer, root.containerInfo);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                root.effectDuration += popNestedEffectDurations(ii);
                viewTransitionMutationContext = !1;
                break;
            case 4:
                flags = offscreenDirectParentIsHidden;
                offscreenDirectParentIsHidden = offscreenSubtreeIsHidden;
                current = pushMutationContext();
                ii = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                currentHoistableRoot = ii;
                viewTransitionMutationContext && inUpdateViewTransition && (rootViewTransitionAffected = !0);
                viewTransitionMutationContext = current;
                offscreenDirectParentIsHidden = flags;
                break;
            case 12:
                flags = pushNestedEffectDurations();
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now$1());
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 22:
                ii = null !== finishedWork.memoizedState;
                _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
                var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden, _prevOffscreenDirectParentIsHidden2 = offscreenDirectParentIsHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
                offscreenDirectParentIsHidden = _prevOffscreenDirectParentIsHidden2 || ii;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenDirectParentIsHidden = _prevOffscreenDirectParentIsHidden2;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                _eventPayloads$ii2 && !ii && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime);
                commitReconciliationEffects(finishedWork);
                flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & ~OffscreenVisible : root._visibility | OffscreenVisible, !ii || null === current || _eventPayloads$ii2 || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (root = IncludeHostSingletons, lanes = _eventPayloads$ii2 || offscreenSubtreeWasHidden, current = offscreenSubtreeIsHidden, _eventPayloads$ii2 = offscreenSubtreeWasHidden, offscreenSubtreeIsHidden = ii || offscreenSubtreeIsHidden, offscreenSubtreeWasHidden = lanes, recursivelyTraverseDisappearLayoutEffects(finishedWork, root), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect"), offscreenSubtreeIsHidden = current, offscreenSubtreeWasHidden = _eventPayloads$ii2), !ii && offscreenDirectParentIsHidden || hideOrUnhideAllChildren(finishedWork, ii));
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, attachSuspenseRetryListeners(finishedWork, lanes))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, root)));
                break;
            case 30:
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags = pushMutationContext();
                ii = inUpdateViewTransition;
                _eventPayloads$ii2 = (lanes & 335544064) === lanes;
                prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
                inUpdateViewTransition = _eventPayloads$ii2 && "none" !== getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
                recursivelyTraverseMutationEffects(root, finishedWork, lanes);
                commitReconciliationEffects(finishedWork);
                _eventPayloads$ii2 && null !== current && viewTransitionMutationContext && (finishedWork.flags |= 4);
                inUpdateViewTransition = ii;
                viewTransitionMutationContext = flags;
                break;
            case 21:
                break;
            case 7:
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
            default:
                recursivelyTraverseMutationEffects(root, finishedWork, lanes), commitReconciliationEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(finishedWork.return.alternate, finishedWork.return) || logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount")));
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, _enabled = !0, fiber.reset(), _enabled = !1);
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseAfterMutationEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
        else measureNestedViewTransitions(parentFiber, !1);
    }
    function commitAfterMutationEffectsOnFiber(finishedWork, root) {
        var current = finishedWork.alternate;
        if (null === current) commitEnterViewTransitions(finishedWork, !1);
        else switch(finishedWork.tag){
            case 3:
                rootViewTransitionNameCanceled = viewTransitionContextChanged = !1;
                pushViewTransitionCancelableScope();
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                if (!viewTransitionContextChanged && !rootViewTransitionAffected) {
                    finishedWork = viewTransitionCancelableChildren;
                    if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                        current = finishedWork[i];
                        var oldName = finishedWork[i + 1];
                        restoreViewTransitionName(current, finishedWork[i + 2]);
                        current = current.ownerDocument.documentElement;
                        null !== current && current.animate({
                            opacity: [
                                0,
                                0
                            ],
                            pointerEvents: [
                                "none",
                                "none"
                            ]
                        }, {
                            duration: 0,
                            fill: "forwards",
                            pseudoElement: "::view-transition-group(" + oldName + ")"
                        });
                    }
                    finishedWork = root.containerInfo;
                    finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                    null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(root)"
                    }), finishedWork.animate({
                        width: [
                            0,
                            0
                        ],
                        height: [
                            0,
                            0
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition"
                    }));
                    rootViewTransitionNameCanceled = !0;
                }
                viewTransitionCancelableChildren = null;
                break;
            case 5:
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                break;
            case 4:
                i = viewTransitionContextChanged;
                viewTransitionContextChanged = !1;
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                viewTransitionContextChanged && (rootViewTransitionAffected = !0);
                viewTransitionContextChanged = i;
                break;
            case 22:
                null === finishedWork.memoizedState && (null !== current.memoizedState ? commitEnterViewTransitions(finishedWork, !1) : recursivelyTraverseAfterMutationEffects(root, finishedWork));
                break;
            case 30:
                i = viewTransitionContextChanged;
                oldName = pushViewTransitionCancelableScope();
                viewTransitionContextChanged = !1;
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
                viewTransitionContextChanged && (finishedWork.flags |= 4);
                var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
                root = getViewTransitionName(props, state);
                state = getViewTransitionName(current.memoizedProps, state);
                var className = getViewTransitionClassName(props.default, props.update);
                "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, viewTransitionHostInstanceIdx = 0, root = measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
                0 !== (finishedWork.flags & 4) && root ? (scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, viewTransitionCancelableChildren), viewTransitionCancelableChildren = oldName);
                viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
                break;
            default:
                recursivelyTraverseAfterMutationEffects(root, finishedWork);
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork, layoutEffectTraversalFlags) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookLayoutUnmountEffects(finishedWork, finishedWork.return, Layout);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                (layoutEffectTraversalFlags & IncludeHostSingletons) !== NoLayoutEffectTraversalFlags && runWithFiberInDEV(finishedWork, releaseSingletonInstance, finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceDeletionEffects(finishedWork);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                finishedWork.flags & 18874368 && untrackNamedViewTransition(finishedWork);
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                safelyDetachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags) {
        for(parentFiber = parentFiber.child; null !== parentFiber;)disappearLayoutEffects(parentFiber, layoutEffectTraversalFlags), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current, finishedWork, layoutEffectTraversalFlags) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags, includeWorkInProgressEffects = (layoutEffectTraversalFlags & IncludeWorkInProgressEffects) !== NoLayoutEffectTraversalFlags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                commitHookLayoutEffects(finishedWork, Layout);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork.stateNode;
                "function" === typeof current.componentDidMount && runWithFiberInDEV(finishedWork, callComponentDidMountInDEV, finishedWork, current);
                current = finishedWork.updateQueue;
                if (null !== current) {
                    finishedRoot = finishedWork.stateNode;
                    try {
                        runWithFiberInDEV(finishedWork, commitHiddenCallbacks, current, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                (layoutEffectTraversalFlags & IncludeHostSingletons) !== NoLayoutEffectTraversalFlags && commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || commitFragmentInstanceInsertionEffects(finishedWork);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || offscreenSubtreeIsHidden || mountHoistable(getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                if (includeWorkInProgressEffects && flags & 4) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                    includeWorkInProgressEffects = finishedWork.stateNode;
                    includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfiler, finishedWork, current, commitStartTime, includeWorkInProgressEffects.effectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                flags & 18874368 && trackNamedViewTransition(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                safelyAttachRef(finishedWork, finishedWork.return);
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, layoutEffectTraversalFlags) {
        layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & ~IncludeWorkInProgressEffects;
        for(parentFiber = parentFiber.child; null !== parentFiber;)reappearLayoutEffects(finishedRoot, parentFiber.alternate, parentFiber, layoutEffectTraversalFlags), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && retainCache(current), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (retainCache(finishedWork), null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions, endTime) {
        var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
        if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(parentFiber = parentFiber.child; null !== parentFiber;)isViewTransitionEligible = parentFiber.sibling, commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions, null !== isViewTransitionEligible ? isViewTransitionEligible.actualStartTime : endTime), parentFiber = isViewTransitionEligible;
        else isViewTransitionEligible && restoreNestedViewTransitions(parentFiber);
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
        isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && restoreEnterOrExitViewTransitions(finishedWork);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
                break;
            case 1:
                (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, []) : 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
                inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = wasInHydratedSubtree;
                isViewTransitionEligible && rootViewTransitionNameCanceled && (committedLanes = finishedRoot.containerInfo, committedLanes = 9 === committedLanes.nodeType ? committedLanes.body : "HTML" === committedLanes.nodeName ? committedLanes.ownerDocument.body : committedLanes, "root" === committedLanes.style.viewTransitionName && (committedLanes.style.viewTransitionName = ""), committedLanes = committedLanes.ownerDocument.documentElement, null !== committedLanes && "none" === committedLanes.style.viewTransitionName && (committedLanes.style.viewTransitionName = ""));
                flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
                finishedRoot.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                if (flags & 2048) {
                    flags = pushNestedEffectDurations();
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                    finishedRoot = finishedWork.stateNode;
                    finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
                    try {
                        runWithFiberInDEV(finishedWork, commitProfilerPostCommitImpl, finishedWork, finishedWork.alternate, commitStartTime, finishedRoot.passiveEffectDuration);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            case 31:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                isViewTransitionEligible = finishedWork.memoizedState;
                null !== prevProfilerEffectDuration && null === isViewTransitionEligible ? (isViewTransitionEligible = finishedWork.deletions, null !== isViewTransitionEligible && 0 < isViewTransitionEligible.length && 18 === isViewTransitionEligible[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0) : inHydratedSubtree = !1;
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 13:
                flags = inHydratedSubtree;
                prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
                isViewTransitionEligible = finishedWork.memoizedState;
                null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== isViewTransitionEligible && null !== isViewTransitionEligible.dehydrated ? inHydratedSubtree = !1 : (isViewTransitionEligible = finishedWork.deletions, null !== isViewTransitionEligible && 0 < isViewTransitionEligible.length && 18 === isViewTransitionEligible[0].tag ? (inHydratedSubtree = !1, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(finishedWork, finishedWork.actualStartTime, endTime, prevProfilerEffectDuration)) : inHydratedSubtree = !0);
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                inHydratedSubtree = flags;
                break;
            case 23:
                break;
            case 22:
                wasInHydratedSubtree = finishedWork.stateNode;
                prevProfilerEffectDuration = finishedWork.alternate;
                null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== prevProfilerEffectDuration && null === prevProfilerEffectDuration.memoizedState && restoreEnterOrExitViewTransitions(prevProfilerEffectDuration), wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime)) : (isViewTransitionEligible && null !== prevProfilerEffectDuration && null !== prevProfilerEffectDuration.memoizedState && restoreEnterOrExitViewTransitions(finishedWork), wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child), endTime), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(finishedWork, componentEffectStartTime, componentEffectEndTime))));
                flags & 2048 && commitOffscreenPassiveMountEffects(prevProfilerEffectDuration, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            case 30:
                isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && (restoreViewTransitionOnHostInstances(flags.child, !0), restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime);
        }
        if ((finishedWork.mode & ProfileMode) !== NoMode) {
            if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate) committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(finishedWork, committedLanes, endTime, "Mount");
            0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Mount"));
        }
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var nextSibling = parentFiber.sibling;
            reconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, null !== nextSibling ? nextSibling.actualStartTime : endTime);
            parentFiber = nextSibling;
        }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
        includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(finishedWork, finishedWork.actualStartTime, endTime, inHydratedSubtree, committedLanes);
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                commitHookPassiveMountEffects(finishedWork, Passive);
                break;
            case 23:
                break;
            case 22:
                var _instance4 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _instance4._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) : (_instance4._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectErrors = prevEffectErrors;
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
        if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child)) for(var child = parentFiber.child; null !== child;){
            parentFiber = child.sibling;
            var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
            (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(child, child.actualStartTime, endTime, inHydratedSubtree, committedLanes);
            var flags = child.flags;
            switch(child.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
                    flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, child, committedLanes, committedTransitions, endTime);
            }
            alreadyWarnedForDeepEquality = prevDeepEquality;
            child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && (null !== fiber.memoizedState ? suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber)));
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && suspendInstance(suspendedState, fiber));
                break;
            case 3:
            case 4:
                var previousHoistableRoot = currentHoistableRoot;
                currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                currentHoistableRoot = previousHoistableRoot;
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            case 30:
                if (0 !== (fiber.flags & suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                    var state = fiber.stateNode;
                    state.paired = null;
                    null === appearingViewTransitions && (appearingViewTransitions = new Map());
                    appearingViewTransitions.set(previousHoistableRoot, state);
                }
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive | HasEffect);
                break;
            case 3:
                var prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 12:
                prevProfilerEffectDuration = pushNestedEffectDurations();
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
                break;
            case 22:
                prevProfilerEffectDuration = finishedWork.stateNode;
                null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(finishedWork, componentEffectStartTime, componentEffectEndTime, "Disconnect")) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i], prevEffectStart = pushComponentEffectStart();
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
                (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(childToDelete, componentEffectStartTime, componentEffectEndTime, "Unmount");
                popComponentEffectStart(prevEffectStart);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;)disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
        var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                commitHookPassiveUnmountEffects(finishedWork, finishedWork.return, Passive);
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(finishedWork);
        }
        (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(finishedWork, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
        for(; null !== nextEffect;){
            var fiber = nextEffect, current = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
            switch(current.tag){
                case 0:
                case 11:
                case 15:
                    commitHookPassiveUnmountEffects(current, nearestMountedAncestor, Passive);
                    break;
                case 23:
                case 22:
                    null !== current.memoizedState && null !== current.memoizedState.cachePool && (nearestMountedAncestor = current.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
                    break;
                case 24:
                    releaseCache(current.memoizedState.cache);
            }
            (current.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(current, componentEffectStartTime, componentEffectEndTime, componentEffectDuration, componentEffectErrors);
            popComponentEffectStart(prevEffectStart);
            popComponentEffectDuration(prevEffectDuration);
            componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
            componentEffectErrors = prevEffectErrors;
            current = fiber.child;
            if (null !== current) current.return = fiber, nextEffect = current;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                current = nextEffect;
                prevEffectStart = current.sibling;
                prevEffectDuration = current.return;
                detachFiberAfterEffects(current);
                if (current === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== prevEffectStart) {
                    prevEffectStart.return = prevEffectDuration;
                    nextEffect = prevEffectStart;
                    break a;
                }
                nextEffect = prevEffectDuration;
            }
        }
    }
    function onCommitRoot() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
        isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
        if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        var transition = ReactSharedInternals.T;
        if (null !== transition) return transition._updatedFibers || (transition._updatedFibers = new Set()), transition._updatedFibers.add(fiber), null !== lastSuspendedFiber && resolveUpdatePriority() === DiscreteEventPriority && (lastSuspendedFiber = null), requestTransitionLane();
        fiber = resolveUpdatePriority();
        fiber === DiscreteEventPriority && (lastSuspendedFiber = null);
        return fiber;
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleViewTransitionEvent(fiber, callback) {
        if (null != callback) {
            var state = fiber.stateNode, instance = state.ref;
            null === instance && (instance = state.ref = createViewTransitionInstance(getViewTransitionName(fiber.memoizedProps, state)));
            null === pendingViewTransitionEvents && (pendingViewTransitionEvents = []);
            pendingViewTransitionEvents.push(callback.bind(null, instance));
        }
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
        isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = !0);
        if (root === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if ((executionContext & RenderContext) !== NoContext && root === workInProgressRoot) {
            if (isRendering) switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    root = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
                    didWarnAboutUpdateInRenderForAnotherComponent.has(root) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render", fiber, root, root));
                    break;
                case 1:
                    didWarnAboutUpdateInRender || (console.error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), didWarnAboutUpdateInRender = !0);
            }
        } else isDevToolsPresent && addFiberToLanesMap(root, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root, lanes, forceSync) {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
            var yieldedFiber = workInProgress, yieldEndTime = now$1();
            switch(yieldReason){
                case SuspendedOnImmediate:
                case SuspendedOnData:
                    var startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Suspended", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                case SuspendedOnAction:
                    startTime = yieldStartTime;
                    supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(console.timeStamp.bind(console, "Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light")) : console.timeStamp("Action", startTime, yieldEndTime, COMPONENTS_TRACK, void 0, "primary-light"));
                    break;
                default:
                    supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp("Blocked", yieldStartTime, yieldEndTime, COMPONENTS_TRACK, void 0, 5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"));
            }
        }
        startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root.expiredLanes) || checkIfRootIsPrerendering(root, lanes)) ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes, !0);
        var renderWasConcurrent = forceSync;
        do {
            if (startTime === RootInProgress) {
                workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root, lanes, 0, !1);
                lanes = workInProgressSuspendedReason;
                yieldStartTime = now();
                yieldReason = lanes;
                break;
            } else {
                yieldedFiber = now$1();
                yieldEndTime = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
                    setCurrentTrackFromLanes(lanes);
                    yieldEndTime = renderStartTime;
                    startTime = yieldedFiber;
                    !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, "Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error")) : console.timeStamp("Teared Render", yieldEndTime, startTime, currentTrack, LANES_TRACK_GROUP, "error"));
                    finalizeRender(lanes, yieldedFiber);
                    startTime = renderRootSync(root, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (startTime === RootErrored) {
                    renderWasConcurrent = lanes;
                    if (root.errorRecoveryDisabledLanes & renderWasConcurrent) var errorRetryLanes = 0;
                    else errorRetryLanes = root.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
                    if (0 !== errorRetryLanes) {
                        setCurrentTrackFromLanes(lanes);
                        logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                        finalizeRender(lanes, yieldedFiber);
                        lanes = errorRetryLanes;
                        a: {
                            yieldedFiber = root;
                            startTime = renderWasConcurrent;
                            renderWasConcurrent = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                            errorRetryLanes = renderRootSync(yieldedFiber, errorRetryLanes, !1);
                            if (errorRetryLanes !== RootErrored && errorRetryLanes !== RootSuspendedAtTheShell) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                                    startTime = RootSuspendedWithDelay;
                                    break a;
                                }
                                yieldedFiber = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = renderWasConcurrent;
                                null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, yieldedFiber));
                            }
                            startTime = errorRetryLanes;
                        }
                        renderWasConcurrent = !1;
                        if (startTime !== RootErrored) continue;
                        else yieldedFiber = now$1();
                    }
                }
                if (startTime === RootFatalErrored) {
                    setCurrentTrackFromLanes(lanes);
                    logErroredRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                    finalizeRender(lanes, yieldedFiber);
                    prepareFreshStack(root, 0);
                    markRootSuspended(root, lanes, 0, !0);
                    break;
                }
                a: {
                    forceSync = root;
                    switch(startTime){
                        case RootInProgress:
                        case RootFatalErrored:
                            throw Error("Root did not complete. This is a bug in React.");
                        case RootSuspendedWithDelay:
                            if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                        case RootSuspendedAtTheShell:
                            setCurrentTrackFromLanes(lanes);
                            logSuspendedRenderPhase(renderStartTime, yieldedFiber, lanes, workInProgressUpdateTask);
                            finalizeRender(lanes, yieldedFiber);
                            yieldEndTime = lanes;
                            0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case RootErrored:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case RootSuspended:
                        case RootCompleted:
                            break;
                        default:
                            throw Error("Unknown root exit status.");
                    }
                    if (null !== ReactSharedInternals.actQueue) completeRoot(forceSync, yieldEndTime, lanes, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, null, renderStartTime, yieldedFiber);
                    else {
                        if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                            markRootSuspended(forceSync, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            if (0 !== getNextLanes(forceSync, 0, !0)) break a;
                            pendingEffectsLanes = lanes;
                            forceSync.timeoutHandle = scheduleTimeout(completeRootWhenReady.bind(null, forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, "Throttled", renderStartTime, yieldedFiber), renderWasConcurrent);
                            break a;
                        }
                        completeRootWhenReady(forceSync, yieldEndTime, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, startTime, null, renderStartTime, yieldedFiber);
                    }
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root);
    }
    function completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes, suspendedState = null;
        if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (suspendedState = {
                stylesheets: null,
                count: 0,
                imgCount: 0,
                imgBytes: 0,
                suspenseyImages: [],
                waitingForImages: !0,
                waitingForViewTransition: !1,
                unsuspend: noop$1
            }, appearingViewTransitions = null, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), isViewTransitionEligible && (subtreeFlags = suspendedState, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = subtreeFlags(completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes = getEntangledLanes(root, suspendedLanes);
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index;
            didAttemptEntireTree[index] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
        return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (workInProgressSuspendedReason === NotSuspended) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function finalizeRender(lanes, finalizationTime) {
        0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
        0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
        0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
        0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root, lanes) {
        supportsUserTiming && (console.timeStamp("Blocking Track", 0.003, 0.003, "Blocking", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Transition Track", 0.003, 0.003, "Transition", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Suspense Track", 0.003, 0.003, "Suspense", LANES_TRACK_GROUP, "primary-light"), console.timeStamp("Idle Track", 0.003, 0.003, "Idle", LANES_TRACK_GROUP, "primary-light"));
        var previousRenderStartTime = renderStartTime;
        renderStartTime = now();
        if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
            setCurrentTrackFromLanes(workInProgressRootRenderLanes);
            if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay) logSuspendedRenderPhase(previousRenderStartTime, renderStartTime, lanes, workInProgressUpdateTask);
            else {
                var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
                if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
                    var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
                    debugTask ? debugTask.run(console.timeStamp.bind(console, label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color)) : console.timeStamp(label, previousRenderStartTime, endTime, currentTrack, LANES_TRACK_GROUP, color);
                }
            }
            finalizeRender(workInProgressRootRenderLanes, renderStartTime);
        }
        previousRenderStartTime = workInProgressUpdateTask;
        workInProgressUpdateTask = null;
        if (0 !== (lanes & 127)) {
            workInProgressUpdateTask = blockingUpdateTask;
            debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
            endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
            color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
            0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(blockingSuspendedTime, color, lanes, previousRenderStartTime)) : 0 !== (animatingLanes & 127) && (setCurrentTrackFromLanes(2), logAnimatingPhase(blockingClampTime, color, animatingTask));
            previousRenderStartTime = debugTask;
            var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
            debugTask = renderStartTime;
            endTime = blockingUpdateTask;
            color = blockingUpdateMethodName;
            label = blockingUpdateComponentName;
            if (supportsUserTiming) {
                currentTrack = "Blocking";
                0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
                0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
                if (null !== eventType && previousRenderStartTime > eventTime) {
                    var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
                    endTime ? endTime.run(console.timeStamp.bind(console, eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventIsRepeat ? "Consecutive" : "Event: " + eventType, eventTime, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, color$jscomp$0);
                }
                debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label && isPingedUpdate.push([
                    "Component name",
                    label
                ]), null != color && isPingedUpdate.push([
                    "Method name",
                    color
                ]), previousRenderStartTime = {
                    start: previousRenderStartTime,
                    end: debugTask,
                    detail: {
                        devtools: {
                            properties: isPingedUpdate,
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            color: eventTime
                        }
                    }
                }, endTime ? endTime.run(performance.measure.bind(performance, isSpawnedUpdate, previousRenderStartTime)) : performance.measure(isSpawnedUpdate, previousRenderStartTime), performance.clearMeasures(isSpawnedUpdate));
            }
            blockingUpdateTime = -1.1;
            blockingUpdateType = 0;
            blockingUpdateComponentName = blockingUpdateMethodName = null;
            blockingSuspendedTime = -1.1;
            blockingEventRepeatTime = blockingEventTime;
            blockingEventTime = -1.1;
            blockingClampTime = now();
        }
        0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(transitionSuspendedTime, color, lanes, workInProgressUpdateTask)) : 0 !== (animatingLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, color, animatingTask)), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(console.timeStamp.bind(console, eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)) : console.timeStamp(eventType ? "Consecutive" : "Event: " + eventTime, isPingedUpdate, debugTask, currentTrack, LANES_TRACK_GROUP, color$jscomp$0)), previousRenderStartTime > debugTask && (endTime ? endTime.run(console.timeStamp.bind(console, "Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")) : console.timeStamp("Action", debugTask, previousRenderStartTime, currentTrack, LANES_TRACK_GROUP, "primary-dark")), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push([
            "Component name",
            isSpawnedUpdate
        ]), null != label && isPingedUpdate.push([
            "Method name",
            label
        ]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: color,
            detail: {
                devtools: {
                    properties: isPingedUpdate,
                    track: currentTrack,
                    trackGroup: LANES_TRACK_GROUP,
                    color: "primary-light"
                }
            }
        }, endTime ? endTime.run(performance.measure.bind(performance, debugTask, previousRenderStartTime)) : performance.measure(debugTask, previousRenderStartTime), performance.clearMeasures(debugTask))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
        0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime, animatingTask));
        0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime, animatingTask));
        previousRenderStartTime = root.timeoutHandle;
        previousRenderStartTime !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
        previousRenderStartTime = root.cancelPendingCommit;
        null !== previousRenderStartTime && (root.cancelPendingCommit = null, previousRenderStartTime());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = previousRenderStartTime = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = NotSuspended;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        entangledRenderLanes = getEntangledLanes(root, lanes);
        finishQueueingConcurrentUpdates();
        root = getCurrentTime();
        1e3 < root - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root);
        ReactStrictModeWarnings.discardPendingWarnings();
        return previousRenderStartTime;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        ReactSharedInternals.getCurrentStack = null;
        isRendering = !1;
        current = null;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
        workInProgressThrownValue = thrownValue;
        var erroredWork = workInProgress;
        null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current))) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
        null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = RootSuspendedWithDelay;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            prepareFreshStack(root, lanes);
        }
        lanes = !1;
        memoizedUpdaters = workInProgressRootExitStatus;
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case SuspendedOnHydration:
                        resetWorkInProgressStack();
                        memoizedUpdaters = RootSuspendedAtTheShell;
                        break a;
                    case SuspendedOnImmediate:
                    case SuspendedOnData:
                    case SuspendedOnAction:
                    case SuspendedOnDeprecatedThrowPromise:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            memoizedUpdaters = RootInProgress;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            memoizedUpdaters = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$9) {
            handleThrow(root, thrownValue$9);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        resetContextDependencies();
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return memoizedUpdaters;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                0 < memoizedUpdaters.size && (restorePendingUpdaters(root, workInProgressRootRenderLanes), memoizedUpdaters.clear());
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = null;
            workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
            prepareFreshStack(root, lanes);
        } else workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) b: switch(lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason){
                case SuspendedOnError:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnError);
                    break;
                case SuspendedOnData:
                case SuspendedOnAction:
                    if (isThenableResolved(memoizedUpdaters)) {
                        workInProgressSuspendedReason = NotSuspended;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                        ensureRootIsScheduled(root);
                    };
                    memoizedUpdaters.then(lanes, lanes);
                    break a;
                case SuspendedOnImmediate:
                    workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                    break a;
                case SuspendedOnInstance:
                    workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                    break a;
                case SuspendedAndReadyToContinue:
                    isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedAndReadyToContinue));
                    break;
                case SuspendedOnInstanceAndReadyToContinue:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = NotSuspended;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                            break;
                        default:
                            console.error("Unexpected type of fiber triggered a suspensey commit. This is a bug in React.");
                    }
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnInstanceAndReadyToContinue);
                    break;
                case SuspendedOnDeprecatedThrowPromise:
                    workInProgressSuspendedReason = NotSuspended;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, memoizedUpdaters, SuspendedOnDeprecatedThrowPromise);
                    break;
                case SuspendedOnHydration:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = RootSuspendedAtTheShell;
                    break a;
                default:
                    throw Error("Unexpected SuspendedReason. This is a bug in React.");
            }
            null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$10) {
            handleThrow(root, thrownValue$10);
        }
        while (1);
        resetContextDependencies();
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return RootInProgress;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var current = unitOfWork.alternate;
        (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current = runWithFiberInDEV(unitOfWork, beginWork, current, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === current ? completeUnitOfWork(unitOfWork) : workInProgress = current;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
        var current = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
        isProfilingMode && startProfilerTimer(unitOfWork);
        switch(unitOfWork.tag){
            case 15:
            case 0:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                current = replayFunctionComponent(current, unitOfWork, unitOfWork.pendingProps, unitOfWork.type.render, unitOfWork.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(unitOfWork);
                var fiber = unitOfWork;
                fiber === hydrationParentFiber && (isHydrating ? (popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && (nextHydratableInstance = fiber.stateNode)) : (popToNextHostParent(fiber), isHydrating = !0));
            default:
                unwindInterruptedWork(current, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current = beginWork(current, unitOfWork, entangledRenderLanes);
        }
        isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
        return current;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        resetContextDependencies();
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = RootFatalErrored;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = RootFatalErrored;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || suspendedReason === SuspendedOnError) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            var current = completedWork.alternate;
            unitOfWork = completedWork.return;
            startProfilerTimer(completedWork);
            current = runWithFiberInDEV(completedWork, completeWork, current, completedWork, entangledRenderLanes);
            (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
            if (null !== current) {
                workInProgress = current;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            if ((unitOfWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
                next = unitOfWork.actualDuration;
                for(var child = unitOfWork.child; null !== child;)next += child.actualDuration, child = child.sibling;
                unitOfWork.actualDuration = next;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = RootSuspendedAtTheShell;
        workInProgress = null;
    }
    function completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Should not already be working.");
        setCurrentTrackFromLanes(lanes);
        if (exitStatus === RootErrored) logErroredRenderPhase(completedRenderStartTime, completedRenderEndTime, lanes, workInProgressUpdateTask);
        else if (null !== recoverableErrors) {
            if (didSkipSuspendedSiblings = null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256), didIncludeRenderPhaseUpdate = workInProgressUpdateTask, supportsUserTiming && !(completedRenderEndTime <= completedRenderStartTime)) {
                exitStatus = [];
                for(var i = 0; i < recoverableErrors.length; i++){
                    var error = recoverableErrors[i].value;
                    exitStatus.push([
                        "Recoverable Error",
                        "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
                    ]);
                }
                completedRenderStartTime = {
                    start: completedRenderStartTime,
                    end: completedRenderEndTime,
                    detail: {
                        devtools: {
                            color: "primary-dark",
                            track: currentTrack,
                            trackGroup: LANES_TRACK_GROUP,
                            tooltipText: didSkipSuspendedSiblings ? "Hydration Failed" : "Recovered after Error",
                            properties: exitStatus
                        }
                    }
                };
                didIncludeRenderPhaseUpdate ? didIncludeRenderPhaseUpdate.run(performance.measure.bind(performance, "Recovered", completedRenderStartTime)) : performance.measure("Recovered", completedRenderStartTime);
                performance.clearMeasures("Recovered");
            }
        } else didIncludeRenderPhaseUpdate = workInProgressUpdateTask, !supportsUserTiming || completedRenderEndTime <= completedRenderStartTime || (didSkipSuspendedSiblings = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", exitStatus = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render", didIncludeRenderPhaseUpdate ? didIncludeRenderPhaseUpdate.run(console.timeStamp.bind(console, exitStatus, completedRenderStartTime, completedRenderEndTime, currentTrack, LANES_TRACK_GROUP, didSkipSuspendedSiblings)) : console.timeStamp(exitStatus, completedRenderStartTime, completedRenderEndTime, currentTrack, LANES_TRACK_GROUP, didSkipSuspendedSiblings));
        if (null !== finishedWork) {
            0 === lanes && console.error("finishedLanes should not be empty during a commit. This is a bug in React.");
            if (finishedWork === root.current) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            pendingEffectsRenderEndTime = completedRenderEndTime;
            pendingSuspendedCommitReason = suspendedCommitReason;
            pendingDelayedCommitReason = IMMEDIATE_COMMIT;
            pendingSuspendedViewTransitionReason = null;
            commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState, suspendedCommitReason, completedRenderEndTime);
        }
    }
    function commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState, suspendedCommitReason, completedRenderEndTime) {
        var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
        pendingEffectsRemainingLanes = remainingLanes;
        remainingLanes |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
        pendingViewTransitionEvents = null;
        (lanes & 335544064) === lanes ? (pendingTransitionTypes = claimQueuedTransitionTypes(root), spawnedLane = 10262) : (pendingTransitionTypes = null, spawnedLane = 10256);
        0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            schedulerEvent = window.event;
            pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        commitErrors = null;
        commitStartTime = now();
        null !== suspendedCommitReason && logSuspendedCommitPhase(completedRenderEndTime, commitStartTime, suspendedCommitReason, workInProgressUpdateTask);
        shouldStartViewTransition = !1;
        suspendedCommitReason = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || suspendedCommitReason) {
            suspendedCommitReason = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            completedRenderEndTime = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = DiscreteEventPriority;
            spawnedLane = executionContext;
            executionContext |= CommitContext;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = completedRenderEndTime, ReactSharedInternals.T = suspendedCommitReason;
            }
        }
        pendingEffectsStatus = PENDING_MUTATION_PHASE;
        shouldStartViewTransition ? (animatingLanes |= lanes, animatingTask = null, pendingViewTransition = startViewTransition(suspendedState, root.containerInfo, pendingTransitionTypes, flushMutationEffects, flushLayoutEffects, flushAfterMutationEffects, flushSpawnedWork, flushPassiveEffects, reportViewTransitionError, suspendedViewTransition, finishedViewTransition.bind(null, lanes))) : (flushMutationEffects(), flushLayoutEffects(), flushSpawnedWork());
    }
    function reportViewTransitionError(error) {
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS) {
            var onRecoverableError = pendingEffectsRoot.onRecoverableError;
            onRecoverableError(error, makeErrorInfo(null));
        }
    }
    function suspendedViewTransition(reason) {
        commitEndTime = now();
        logCommitPhase(null === pendingSuspendedCommitReason ? pendingEffectsRenderEndTime : commitStartTime, commitEndTime, commitErrors, pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT, workInProgressUpdateTask);
        pendingSuspendedCommitReason = pendingSuspendedViewTransitionReason = reason;
    }
    function finishedViewTransition(lanes) {
        if (0 !== (animatingLanes & lanes)) {
            var task = animatingTask;
            animatingLanes &= ~lanes;
            animatingTask = null;
            0 !== (lanes & 4194048) && 0 === (workInProgressRootRenderLanes & 4194048) && 0 === (pendingEffectsLanes & 4194048) && (setCurrentTrackFromLanes(256), logAnimatingPhase(transitionClampTime, now$1(), task));
            0 !== (lanes & 62914560) && 0 === (workInProgressRootRenderLanes & 62914560) && 0 === (pendingEffectsLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, now$1(), task));
            0 !== (lanes & 2080374784) && 0 === (workInProgressRootRenderLanes & 2080374784) && 0 === (pendingEffectsLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, now$1(), task));
        }
    }
    function flushAfterMutationEffects() {
        pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE && (pendingEffectsStatus = NO_PENDING_EFFECTS, commitAfterMutationEffectsOnFiber(pendingFinishedWork, pendingEffectsRoot), pendingEffectsStatus = PENDING_SPAWNED_WORK);
    }
    function flushMutationEffects() {
        if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = lanes;
                    inProgressRoot = root;
                    inUpdateViewTransition = rootViewTransitionAffected = !1;
                    resetComponentEffectTimers();
                    commitMutationEffectsOnFiber(finishedWork, root, lanes);
                    inProgressRoot = inProgressLanes = null;
                    lanes = selectionInformation;
                    var curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                    if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                        if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                            var start = priorSelectionRange.start, end = priorSelectionRange.end;
                            void 0 === end && (end = start);
                            if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                            else {
                                var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                                if (win.getSelection) {
                                    var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                    !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                    var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                    if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                        var range = doc.createRange();
                                        range.setStart(startMarker.node, startMarker.offset);
                                        selection.removeAllRanges();
                                        start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                    }
                                }
                            }
                        }
                        doc = [];
                        for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                            element: selection,
                            left: selection.scrollLeft,
                            top: selection.scrollTop
                        });
                        "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                        for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                            var info = doc[priorFocusedElem];
                            info.element.scrollLeft = info.left;
                            info.element.scrollTop = info.top;
                        }
                    }
                    _enabled = !!eventsEnabled;
                    selectionInformation = eventsEnabled = null;
                } finally{
                    executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = PENDING_LAYOUT_PHASE;
        }
    }
    function flushLayoutEffects() {
        if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
            if (null !== suspendedViewTransitionReason) {
                commitStartTime = now();
                var startTime = commitEndTime, endTime = commitStartTime;
                !supportsUserTiming || endTime <= startTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(suspendedViewTransitionReason, startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            suspendedViewTransitionReason = pendingEffectsRoot;
            startTime = pendingFinishedWork;
            endTime = pendingEffectsLanes;
            var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
            if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var _previousPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                var _prevExecutionContext = executionContext;
                executionContext |= CommitContext;
                try {
                    inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(suspendedViewTransitionReason, startTime.alternate, startTime), inProgressRoot = inProgressLanes = null;
                } finally{
                    executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            suspendedViewTransitionReason = pendingEffectsRenderEndTime;
            startTime = pendingSuspendedCommitReason;
            commitEndTime = now();
            logCommitPhase(null === startTime ? suspendedViewTransitionReason : commitStartTime, commitEndTime, commitErrors, pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT, workInProgressUpdateTask);
            pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
        }
    }
    function flushSpawnedWork() {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
            if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
                var startViewTransitionStartTime = commitEndTime;
                commitEndTime = now();
                var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
                !supportsUserTiming || endTime <= startViewTransitionStartTime || (animatingTask ? animatingTask.run(console.timeStamp.bind(console, abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? "error" : "secondary-light")) : console.timeStamp(abortedViewTransition ? "Interrupted View Transition" : "Starting Animation", startViewTransitionStartTime, endTime, currentTrack, LANES_TRACK_GROUP, abortedViewTransition ? " error" : "secondary-light"));
                pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
            }
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            startViewTransitionStartTime = pendingViewTransition;
            pendingViewTransition = null;
            requestPaint();
            endTime = pendingEffectsRoot;
            var finishedWork = pendingFinishedWork;
            abortedViewTransition = pendingEffectsLanes;
            var recoverableErrors = pendingRecoverableErrors, passiveSubtreeMask = (abortedViewTransition & 335544064) === abortedViewTransition ? 10262 : 10256;
            (passiveSubtreeMask = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask)) ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(endTime, endTime.pendingLanes), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
            var remainingLanes = endTime.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            passiveSubtreeMask || commitDoubleInvokeEffectsInDEV(endTime);
            remainingLanes = lanesToEventPriority(abortedViewTransition);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                var didError = 128 === (finishedWork.current.flags & 128);
                switch(remainingLanes){
                    case DiscreteEventPriority:
                        var schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority$1;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority$1;
                }
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, schedulerPriority, didError);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            isDevToolsPresent && endTime.memoizedUpdaters.clear();
            onCommitRoot();
            if (null !== recoverableErrors) {
                didError = ReactSharedInternals.T;
                schedulerPriority = ReactDOMSharedInternals.p;
                ReactDOMSharedInternals.p = DiscreteEventPriority;
                ReactSharedInternals.T = null;
                try {
                    var onRecoverableError = endTime.onRecoverableError;
                    for(finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++){
                        var recoverableError = recoverableErrors[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
                        runWithFiberInDEV(recoverableError.source, onRecoverableError, recoverableError.value, errorInfo);
                    }
                } finally{
                    ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
                }
            }
            onRecoverableError = pendingViewTransitionEvents;
            recoverableError = pendingTransitionTypes;
            pendingTransitionTypes = null;
            if (null !== onRecoverableError && (pendingViewTransitionEvents = null, null === recoverableError && (recoverableError = []), null !== startViewTransitionStartTime)) for(errorInfo = 0; errorInfo < onRecoverableError.length; errorInfo++)recoverableErrors = (0, onRecoverableError[errorInfo])(recoverableError), void 0 !== recoverableErrors && startViewTransitionStartTime.finished.finally(recoverableErrors);
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(endTime);
            remainingLanes = endTime.pendingLanes;
            0 !== (abortedViewTransition & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = !0, endTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = endTime)) : (nestedUpdateCount = 0, rootWithNestedUpdates = null);
            passiveSubtreeMask || finalizeRender(abortedViewTransition, commitEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function makeErrorInfo(componentStack) {
        componentStack = {
            componentStack: componentStack
        };
        Object.defineProperty(componentStack, "digest", {
            get: function() {
                console.error('You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.');
            }
        });
        return componentStack;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        null !== pendingViewTransition && (pendingViewTransition.skipTransition(), didWarnAboutInterruptedViewTransitions || (didWarnAboutInterruptedViewTransitions = !0, console.warn("A flushSync update cancelled a View Transition because it was called while the View Transition was still preparing. To preserve the synchronous semantics, React had to skip the View Transition. If you can, try to avoid flushSync() in a scenario that's likely to interfere.")), pendingViewTransition = null, pendingDelayedCommitReason = ABORTED_VIEW_TRANSITION_COMMIT);
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 0 === DefaultEventPriority || DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = priority;
            ReactSharedInternals.T = null;
            var transitions = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            priority = pendingEffectsRoot;
            var lanes = pendingEffectsLanes;
            pendingEffectsStatus = NO_PENDING_EFFECTS;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw Error("Cannot flush passive effects while already rendering.");
            setCurrentTrackFromLanes(lanes);
            isFlushingPassiveEffects = !0;
            didScheduleUpdateDuringPassiveEffects = !1;
            var passiveEffectStartTime = 0;
            commitErrors = null;
            passiveEffectStartTime = now$1();
            if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT) logAnimatingPhase(commitEndTime, passiveEffectStartTime, animatingTask);
            else {
                var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
                !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(console.timeStamp.bind(console, delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light")) : console.timeStamp(delayedUntilPaint ? "Waiting for Paint" : "Waiting", startTime, endTime, currentTrack, LANES_TRACK_GROUP, "secondary-light"));
            }
            startTime = executionContext;
            executionContext |= CommitContext;
            var finishedWork = priority.current;
            resetComponentEffectTimers();
            commitPassiveUnmountOnFiber(finishedWork);
            var finishedWork$jscomp$0 = priority.current;
            finishedWork = pendingEffectsRenderEndTime;
            resetComponentEffectTimers();
            commitPassiveMountOnFiber(priority, finishedWork$jscomp$0, lanes, transitions, finishedWork);
            commitDoubleInvokeEffectsInDEV(priority);
            executionContext = startTime;
            var passiveEffectsEndTime = now$1();
            finishedWork$jscomp$0 = passiveEffectStartTime;
            finishedWork = workInProgressUpdateTask;
            null !== commitErrors ? logCommitErrored(finishedWork$jscomp$0, passiveEffectsEndTime, commitErrors, !0, finishedWork) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(console.timeStamp.bind(console, "Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark")) : console.timeStamp("Remaining Effects", finishedWork$jscomp$0, passiveEffectsEndTime, currentTrack, LANES_TRACK_GROUP, "secondary-dark"));
            finalizeRender(lanes, passiveEffectsEndTime);
            flushSyncWorkAcrossRoots_impl(0, !1);
            didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
            didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = !1;
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, priority);
            } catch (err) {
                hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
            }
            var stateNode = priority.current.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
            return !0;
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        recordEffectError(sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        isRunningInsertionEffect = !1;
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else {
            for(; null !== nearestMountedAncestor;){
                if (3 === nearestMountedAncestor.tag) {
                    captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                    return;
                }
                if (1 === nearestMountedAncestor.tag) {
                    var instance = nearestMountedAncestor.stateNode;
                    if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                        recordEffectError(sourceFiber);
                        error = createClassErrorUpdate(2);
                        instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                        null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                        return;
                    }
                }
                nearestMountedAncestor = nearestMountedAncestor.return;
            }
            console.error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error);
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act");
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext ? prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
        if (0 !== (parentFiber.subtreeFlags & 134225920)) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var root = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
            isStrictModeFiber = isInStrictMode || isStrictModeFiber;
            22 !== fiber.tag ? fiber.flags & 134217728 ? isStrictModeFiber && runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, fiber, isStrictModeFiber) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 134225920 ? runWithFiberInDEV(fiber, doubleInvokeEffectsOnFiber, root, fiber) : fiber.subtreeFlags & 134217728 && runWithFiberInDEV(fiber, recursivelyTraverseAndDoubleInvokeEffectsInDEV, root, fiber, isStrictModeFiber));
            parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root, fiber) {
        setIsStrictModeForDevtools(!0);
        try {
            disappearLayoutEffects(fiber, NoLayoutEffectTraversalFlags), disconnectPassiveEffect(fiber), reappearLayoutEffects(root, fiber.alternate, fiber, NoLayoutEffectTraversalFlags), reconnectPassiveEffects(root, fiber, 0, null, !1, 0);
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    function commitDoubleInvokeEffectsInDEV(root) {
        var doubleInvokeEffects = !0;
        root.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = !1);
        recursivelyTraverseAndDoubleInvokeEffectsInDEV(root, root.current, doubleInvokeEffects);
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) === NoContext) {
            var tag = fiber.tag;
            if (3 === tag || 1 === tag || 0 === tag || 11 === tag || 14 === tag || 15 === tag) {
                tag = getComponentNameFromFiber(fiber) || "ReactComponent";
                if (null !== didWarnStateUpdateForNotYetMountedComponent) {
                    if (didWarnStateUpdateForNotYetMountedComponent.has(tag)) return;
                    didWarnStateUpdateForNotYetMountedComponent.add(tag);
                } else didWarnStateUpdateForNotYetMountedComponent = new Set([
                    tag
                ]);
                runWithFiberInDEV(fiber, function() {
                    console.error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead.");
                });
            }
        }
    }
    function restorePendingUpdaters(root, lanes) {
        isDevToolsPresent && root.memoizedUpdaters.forEach(function(schedulingFiber) {
            addFiberToLanesMap(root, schedulingFiber, lanes);
        });
    }
    function scheduleCallback$1(priorityLevel, callback) {
        var actQueue = ReactSharedInternals.actQueue;
        return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
            console.error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
        });
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = !0, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var nextLanes = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
                            }
                            0 !== nextLanes && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                        } else nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(root, root === workInProgressRoot ? nextLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root, nextLanes) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, nextLanes));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        schedulerEvent = window.event;
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now$1(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index = 31 - clz32(lanes), lane = 1 << index, expirationTime = expirationTimes[index];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root.cancelPendingCommit) return null !== pingedLanes && cancelCallback(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime !== root.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode) cancelCallback(pingedLanes);
            else return currentTime;
            switch(lanesToEventPriority(suspendedLanes)){
                case DiscreteEventPriority:
                case ContinuousEventPriority:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    suspendedLanes = NormalPriority$1;
                    break;
                case IdleEventPriority:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && cancelCallback(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        nestedUpdateScheduled = currentUpdateIsNested = !1;
        schedulerEvent = window.event;
        if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now$1());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = !1;
        performWorkOnRoot(root, lanes, !0);
    }
    function cancelCallback(callbackNode) {
        callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
        null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
            processRootScheduleInMicrotask();
            return null;
        });
        scheduleMicrotask(function() {
            (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        });
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
        if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp) return null;
        if ("function" === typeof actionProp) return actionProp;
        checkAttributeStringCoercion(actionProp, "action");
        return sanitizeURL(actionProp);
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
        if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
            var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
            submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
            var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: [
                    {
                        instance: null,
                        listener: function() {
                            if (nativeEvent.defaultPrevented) {
                                if (0 !== currentEventTransitionLane) {
                                    var formData = new FormData(nativeEventTarget, submitter), pendingState = {
                                        pending: !0,
                                        data: formData,
                                        method: nativeEventTarget.method,
                                        action: action
                                    };
                                    Object.freeze(pendingState);
                                    startHostTransition(maybeTargetInst, pendingState, null, formData);
                                }
                            } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), pendingState = {
                                pending: !0,
                                data: formData,
                                method: nativeEventTarget.method,
                                action: action
                            }, Object.freeze(pendingState), startHostTransition(maybeTargetInst, pendingState, action, formData));
                        },
                        currentTarget: nativeEventTarget
                    }
                ]
            });
        }
    }
    function executeDispatch(event, listener, currentTarget) {
        event.currentTarget = currentTarget;
        try {
            listener(event);
        } catch (error) {
            reportGlobalError(error);
        }
        event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        eventSystemFlags = 0 !== (eventSystemFlags & 4);
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i];
            a: {
                var previousInstance = void 0, event = _dispatchQueue$i.event;
                _dispatchQueue$i = _dispatchQueue$i.listeners;
                if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                    var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
                else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                    _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                    instance = _dispatchListeners$i.instance;
                    currentTarget = _dispatchListeners$i.currentTarget;
                    _dispatchListeners$i = _dispatchListeners$i.listener;
                    if (instance !== previousInstance && event.isPropagationStopped()) break a;
                    null !== instance ? runWithFiberInDEV(instance, executeDispatch, event, _dispatchListeners$i, currentTarget) : executeDispatch(event, _dispatchListeners$i, currentTarget);
                    previousInstance = instance;
                }
            }
        }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        nonDelegatedEvents.has(domEventName) || console.error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var listenerSet = targetElement[internalEventHandlersKey];
        void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = new Set());
        var listenerSetKey = domEventName + "__bubble";
        listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        isCapturePhaseListener && (eventSystemFlags |= 4);
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    }
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = !0;
            allNativeEvents.forEach(function(domEventName) {
                "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
            });
            var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
            null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
        switch(getEventPriority(domEventName)){
            case DiscreteEventPriority:
                var listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            default:
                listenerWrapper = dispatchEvent;
        }
        eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
        listenerWrapper = void 0;
        !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
        isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            capture: !0,
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
            passive: listenerWrapper
        }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
        var ancestorInst = targetInst$jscomp$0;
        if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
            if (null === targetInst$jscomp$0) return;
            var nodeTag = targetInst$jscomp$0.tag;
            if (3 === nodeTag || 4 === nodeTag) {
                var container = targetInst$jscomp$0.stateNode.containerInfo;
                if (container === targetContainer) break;
                if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                    var grandTag = nodeTag.tag;
                    if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                    nodeTag = nodeTag.return;
                }
                for(; null !== container;){
                    nodeTag = getClosestInstanceFromNode(container);
                    if (null === nodeTag) return;
                    grandTag = nodeTag.tag;
                    if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                        targetInst$jscomp$0 = ancestorInst = nodeTag;
                        continue a;
                    }
                    container = container.parentNode;
                }
            }
            targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
        batchedUpdates$1(function() {
            var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
            a: {
                var reactName = topLevelEventsToReactNames.get(domEventName);
                if (void 0 !== reactName) {
                    var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                    switch(domEventName){
                        case "keypress":
                            if (0 === getEventCharCode(nativeEvent)) break a;
                        case "keydown":
                        case "keyup":
                            SyntheticEventCtor = SyntheticKeyboardEvent;
                            break;
                        case "focusin":
                            reactEventType = "focus";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "focusout":
                            reactEventType = "blur";
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "beforeblur":
                        case "afterblur":
                            SyntheticEventCtor = SyntheticFocusEvent;
                            break;
                        case "click":
                            if (2 === nativeEvent.button) break a;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            SyntheticEventCtor = SyntheticMouseEvent;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            SyntheticEventCtor = SyntheticDragEvent;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            SyntheticEventCtor = SyntheticTouchEvent;
                            break;
                        case ANIMATION_END:
                        case ANIMATION_ITERATION:
                        case ANIMATION_START:
                            SyntheticEventCtor = SyntheticAnimationEvent;
                            break;
                        case TRANSITION_END:
                            SyntheticEventCtor = SyntheticTransitionEvent;
                            break;
                        case "scroll":
                        case "scrollend":
                            SyntheticEventCtor = SyntheticUIEvent;
                            break;
                        case "wheel":
                            SyntheticEventCtor = SyntheticWheelEvent;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            SyntheticEventCtor = SyntheticClipboardEvent;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            SyntheticEventCtor = SyntheticPointerEvent;
                            break;
                        case "submit":
                            SyntheticEventCtor = SyntheticSubmitEvent;
                            break;
                        case "toggle":
                        case "beforetoggle":
                            SyntheticEventCtor = SyntheticToggleEvent;
                    }
                    var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                    inCapturePhase = [];
                    for(var instance = targetInst, lastHostComponent; null !== instance;){
                        var _instance2 = instance;
                        lastHostComponent = _instance2.stateNode;
                        _instance2 = _instance2.tag;
                        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(createDispatchListener(instance, _instance2, lastHostComponent)));
                        if (accumulateTargetOnly) break;
                        instance = instance.return;
                    }
                    0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                        event: reactName,
                        listeners: inCapturePhase
                    }));
                }
            }
            if (0 === (eventSystemFlags & 7)) {
                a: {
                    SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                    reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                    if (SyntheticEventCtor && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                    if (reactName || SyntheticEventCtor) {
                        reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                        if (reactName) {
                            if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                        } else reactName = null, SyntheticEventCtor = targetInst;
                        if (reactName !== SyntheticEventCtor) {
                            inCapturePhase = SyntheticMouseEvent;
                            _instance2 = "onMouseLeave";
                            reactEventName = "onMouseEnter";
                            instance = "mouse";
                            if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                            accumulateTargetOnly = null == reactName ? reactEventType : getNodeFromInstance(reactName);
                            lastHostComponent = null == SyntheticEventCtor ? reactEventType : getNodeFromInstance(SyntheticEventCtor);
                            reactEventType = new inCapturePhase(_instance2, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                            reactEventType.target = accumulateTargetOnly;
                            reactEventType.relatedTarget = lastHostComponent;
                            _instance2 = null;
                            getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                            accumulateTargetOnly = _instance2;
                            inCapturePhase = reactName && SyntheticEventCtor ? getLowestCommonAncestor(reactName, SyntheticEventCtor, getParent) : null;
                            null !== reactName && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                            null !== SyntheticEventCtor && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                        }
                    }
                }
                a: {
                    reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                    SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                    if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                    else if (isTextInputElement(reactName)) {
                        if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                        else {
                            getTargetInstFunc = getTargetInstForInputEventPolyfill;
                            var handleEventFunc = handleEventsForInputEventPolyfill;
                        }
                    } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                    if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                        createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                        break a;
                    }
                    handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                }
                handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
                switch(domEventName){
                    case "focusin":
                        if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                        break;
                    case "focusout":
                        lastSelection = activeElementInst = activeElement = null;
                        break;
                    case "mousedown":
                        mouseDown = !0;
                        break;
                    case "contextmenu":
                    case "mouseup":
                    case "dragend":
                        mouseDown = !1;
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                        break;
                    case "selectionchange":
                        if (skipSelectionChangeEvent) break;
                    case "keydown":
                    case "keyup":
                        constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                }
                var fallbackData;
                if (canUseCompositionEvent) b: {
                    switch(domEventName){
                        case "compositionstart":
                            var eventType = "onCompositionStart";
                            break b;
                        case "compositionend":
                            eventType = "onCompositionEnd";
                            break b;
                        case "compositionupdate":
                            eventType = "onCompositionUpdate";
                            break b;
                    }
                    eventType = void 0;
                }
                else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
                eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: eventType,
                    listeners: handleEventFunc
                }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
                if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: handleEventFunc,
                    listeners: eventType
                }), handleEventFunc.data = fallbackData);
                extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            }
            processDispatchQueue(dispatchQueue, eventSystemFlags);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
            var _instance3 = targetFiber, stateNode = _instance3.stateNode;
            _instance3 = _instance3.tag;
            5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(createDispatchListener(targetFiber, _instance3, stateNode)), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(createDispatchListener(targetFiber, _instance3, stateNode)));
            if (3 === targetFiber.tag) return listeners;
            targetFiber = targetFiber.return;
        }
        return [];
    }
    function getParent(inst) {
        if (null === inst) return null;
        do inst = inst.return;
        while (inst && 5 !== inst.tag && 27 !== inst.tag);
        return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
            var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
            _instance4 = _instance4.tag;
            if (null !== alternate && alternate === common) break;
            5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
            target = target.return;
        }
        0 !== listeners.length && dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    }
    function validatePropertiesInDevelopment(type, props) {
        validateProperties$2(type, props);
        "input" !== type && "textarea" !== type && "select" !== type || null == props || null !== props.value || didWarnValueNull || (didWarnValueNull = !0, "select" === type && props.multiple ? console.error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type) : console.error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type));
        var eventRegistry = {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        };
        isCustomElement(type) || "string" === typeof props.is || warnUnknownProperties(type, props, eventRegistry);
        props.contentEditable && !props.suppressContentEditableWarning && null != props.children && console.error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
        serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function hasViewTransition(htmlElement) {
        return !!(htmlElement.getAttribute("vt-share") || htmlElement.getAttribute("vt-exit") || htmlElement.getAttribute("vt-enter") || htmlElement.getAttribute("vt-update"));
    }
    function isExpectedViewTransitionName(htmlElement) {
        if (!hasViewTransition(htmlElement)) return !1;
        var expectedVtName = htmlElement.getAttribute("vt-name");
        htmlElement = htmlElement.style["view-transition-name"];
        return expectedVtName ? expectedVtName === htmlElement : htmlElement.startsWith("_T_");
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
        attributeNames.forEach(function(attributeName) {
            "style" === attributeName ? "" !== domElement.getAttribute(attributeName) && (attributeName = domElement.style, (1 === attributeName.length && "view-transition-name" === attributeName[0] || 2 === attributeName.length && "view-transition-class" === attributeName[0] && "view-transition-name" === attributeName[1]) && isExpectedViewTransitionName(domElement) || (serverDifferences.style = getStylesObjectFromElement(domElement))) : serverDifferences[getPropNameFromAttributeName(attributeName)] = domElement.getAttribute(attributeName);
        });
    }
    function warnForInvalidEventListener(registrationName, listener) {
        !1 === listener ? console.error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName) : console.error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }
    function normalizeHTML(parent, html) {
        parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName) : parent.ownerDocument.createElement(parent.tagName);
        parent.innerHTML = html;
        return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
        willCoercionThrow(markup) && (console.error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.", typeName(markup)), testStringCoercion(markup));
        return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
        clientText = normalizeMarkupForTextOrAttribute(clientText);
        return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
    }
    function setProp(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "children":
                if ("string" === typeof value) validateTextNesting(value, tag, !1), "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) validateTextNesting("" + value, tag, !1), "body" !== tag && setTextContent(domElement, "" + value);
                else return;
                break;
            case "className":
                setValueForKnownAttribute(domElement, "class", value);
                break;
            case "tabIndex":
                setValueForKnownAttribute(domElement, "tabindex", value);
                break;
            case "dir":
            case "role":
            case "viewBox":
            case "width":
            case "height":
                setValueForKnownAttribute(domElement, key, value);
                break;
            case "style":
                setValueForStyles(domElement, value, prevValue);
                return;
            case "data":
                if ("object" !== tag) {
                    setValueForKnownAttribute(domElement, "data", value);
                    break;
                }
            case "src":
            case "href":
                if ("" === value && ("a" !== tag || "href" !== key)) {
                    "src" === key ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', key, key);
                    domElement.removeAttribute(key);
                    break;
                }
                if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL(value);
                domElement.setAttribute(key, value);
                break;
            case "action":
            case "formAction":
                null != value && ("form" === tag ? "formAction" === key ? console.error("You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>.") : "function" === typeof value && (null == props.encType && null == props.method || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden.")), null == props.target || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."))) : "input" === tag || "button" === tag ? "action" === key ? console.error("You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>.") : "input" !== tag || "submit" === props.type || "image" === props.type || didWarnFormActionType ? "button" !== tag || null == props.type || "submit" === props.type || didWarnFormActionType ? "function" === typeof value && (null == props.name || didWarnFormActionName || (didWarnFormActionName = !0, console.error('Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.')), null == props.formEncType && null == props.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = !0, console.error("Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden.")), null == props.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = !0, console.error("Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."))) : (didWarnFormActionType = !0, console.error('A button can only specify a formAction along with type="submit" or no type.')) : (didWarnFormActionType = !0, console.error('An input can only specify a formAction along with type="submit" or type="image".')) : "action" === key ? console.error("You can only pass the action prop to <form>.") : console.error("You can only pass the formAction prop to <input> or <button>."));
                if ("function" === typeof value) {
                    domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                    break;
                } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
                if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                    domElement.removeAttribute(key);
                    break;
                }
                checkAttributeStringCoercion(value, key);
                value = sanitizeURL(value);
                domElement.setAttribute(key, value);
                break;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                return;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                return;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                return;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                    }
                }
                break;
            case "multiple":
                domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "muted":
                domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
                break;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "defaultValue":
            case "defaultChecked":
            case "innerHTML":
            case "ref":
                break;
            case "autoFocus":
                break;
            case "xlinkHref":
                if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                    domElement.removeAttribute("xlink:href");
                    break;
                }
                checkAttributeStringCoercion(value, key);
                key = sanitizeURL(value);
                domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
                break;
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
                null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "inert":
                "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", key));
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "credentialless":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
                value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
                break;
            case "capture":
            case "download":
                !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "cols":
            case "rows":
            case "size":
            case "span":
                null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
                break;
            case "rowSpan":
            case "start":
                null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
                break;
            case "popover":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                setValueForAttribute(domElement, "popover", value);
                break;
            case "xlinkActuate":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:actuate", value);
                break;
            case "xlinkArcrole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:arcrole", value);
                break;
            case "xlinkRole":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:role", value);
                break;
            case "xlinkShow":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:show", value);
                break;
            case "xlinkTitle":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:title", value);
                break;
            case "xlinkType":
                setValueForNamespacedAttribute(domElement, xlinkNamespace, "xlink:type", value);
                break;
            case "xmlBase":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:base", value);
                break;
            case "xmlLang":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:lang", value);
                break;
            case "xmlSpace":
                setValueForNamespacedAttribute(domElement, xmlNamespace, "xml:space", value);
                break;
            case "is":
                null != prevValue && console.error('Cannot update the "is" prop after it has been initialized.');
                setValueForAttribute(domElement, "is", value);
                break;
            case "innerText":
            case "textContent":
                return;
            case "popoverTarget":
                didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = !0, console.error("The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.", value));
            default:
                if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = getAttributeAlias(key), setValueForAttribute(domElement, key, value);
                else {
                    registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                    return;
                }
        }
        viewTransitionMutationContext = !0;
    }
    function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
        switch(key){
            case "style":
                setValueForStyles(domElement, value, prevValue);
                return;
            case "dangerouslySetInnerHTML":
                if (null != value) {
                    if ("object" !== typeof value || !("__html" in value)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information.");
                    key = value.__html;
                    if (null != key) {
                        if (null != props.children) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
                        (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                    }
                }
                break;
            case "children":
                if ("string" === typeof value) setTextContent(domElement, value);
                else if ("number" === typeof value || "bigint" === typeof value) setTextContent(domElement, "" + value);
                else return;
                break;
            case "onScroll":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
                return;
            case "onScrollEnd":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
                return;
            case "onClick":
                null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$1);
                return;
            case "suppressContentEditableWarning":
            case "suppressHydrationWarning":
            case "innerHTML":
            case "ref":
                return;
            case "innerText":
            case "textContent":
                return;
            default:
                if (registrationNameDependencies.hasOwnProperty(key)) null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
                else a: {
                    if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                        "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                        domElement.addEventListener(prevValue, value, props);
                        break a;
                    }
                    viewTransitionMutationContext = !0;
                    key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
                }
                return;
        }
        viewTransitionMutationContext = !0;
    }
    function setInitialProperties(domElement, tag, props) {
        validatePropertiesInDevelopment(tag, props);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "img":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                var hasSrc = !1, hasSrcSet = !1, propKey;
                for(propKey in props)if (props.hasOwnProperty(propKey)) {
                    var propValue = props[propKey];
                    if (null != propValue) switch(propKey){
                        case "src":
                            hasSrc = !0;
                            break;
                        case "srcSet":
                            hasSrcSet = !0;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        default:
                            setProp(domElement, tag, propKey, propValue, props, null);
                    }
                }
                hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
                hasSrc && setProp(domElement, tag, "src", props.src, props, null);
                return;
            case "input":
                checkControlledValueProps("input", props);
                listenToNonDelegatedEvent("invalid", domElement);
                var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
                for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                    var _propValue = props[hasSrc];
                    if (null != _propValue) switch(hasSrc){
                        case "name":
                            hasSrcSet = _propValue;
                            break;
                        case "type":
                            propValue = _propValue;
                            break;
                        case "checked":
                            checked = _propValue;
                            break;
                        case "defaultChecked":
                            defaultChecked = _propValue;
                            break;
                        case "value":
                            propKey = _propValue;
                            break;
                        case "defaultValue":
                            defaultValue = _propValue;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != _propValue) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            setProp(domElement, tag, hasSrc, _propValue, props, null);
                    }
                }
                validateInputProps(domElement, props);
                initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
                return;
            case "select":
                checkControlledValueProps("select", props);
                listenToNonDelegatedEvent("invalid", domElement);
                hasSrc = propValue = propKey = null;
                for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                    case "value":
                        propKey = defaultValue;
                        break;
                    case "defaultValue":
                        propValue = defaultValue;
                        break;
                    case "multiple":
                        hasSrc = defaultValue;
                    default:
                        setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
                }
                validateSelectProps(domElement, props);
                tag = propKey;
                props = propValue;
                domElement.multiple = !!hasSrc;
                null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
                return;
            case "textarea":
                checkControlledValueProps("textarea", props);
                listenToNonDelegatedEvent("invalid", domElement);
                propKey = hasSrcSet = hasSrc = null;
                for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                    case "value":
                        hasSrc = defaultValue;
                        break;
                    case "defaultValue":
                        hasSrcSet = defaultValue;
                        break;
                    case "children":
                        propKey = defaultValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != defaultValue) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        setProp(domElement, tag, propValue, defaultValue, props, null);
                }
                validateTextareaProps(domElement, props);
                initTextarea(domElement, hasSrc, hasSrcSet, propKey);
                return;
            case "option":
                validateOptionProps(domElement, props);
                for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                    case "selected":
                        domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                        break;
                    default:
                        setProp(domElement, tag, checked, hasSrc, props, null);
                }
                return;
            case "dialog":
                listenToNonDelegatedEvent("beforetoggle", domElement);
                listenToNonDelegatedEvent("toggle", domElement);
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
                break;
            case "image":
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "embed":
            case "source":
            case "link":
                listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
            case "area":
            case "base":
            case "br":
            case "col":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "track":
            case "wbr":
            case "menuitem":
                for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                    default:
                        setProp(domElement, tag, defaultChecked, hasSrc, props, null);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(_propValue in props)props.hasOwnProperty(_propValue) && (hasSrc = props[_propValue], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, _propValue, hasSrc, props, void 0));
                    return;
                }
        }
        for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
    }
    function updateProperties(domElement, tag, lastProps, nextProps) {
        validatePropertiesInDevelopment(tag, nextProps);
        switch(tag){
            case "div":
            case "span":
            case "svg":
            case "path":
            case "a":
            case "g":
            case "p":
            case "li":
                break;
            case "input":
                var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
                for(propKey in lastProps){
                    var lastProp = lastProps[propKey];
                    if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                        case "checked":
                            break;
                        case "value":
                            break;
                        case "defaultValue":
                            lastDefaultValue = lastProp;
                        default:
                            nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                    }
                }
                for(var _propKey8 in nextProps){
                    var propKey = nextProps[_propKey8];
                    lastProp = lastProps[_propKey8];
                    if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp)) switch(_propKey8){
                        case "type":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            type = propKey;
                            break;
                        case "name":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            name = propKey;
                            break;
                        case "checked":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            checked = propKey;
                            break;
                        case "defaultChecked":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            defaultChecked = propKey;
                            break;
                        case "value":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            value = propKey;
                            break;
                        case "defaultValue":
                            propKey !== lastProp && (viewTransitionMutationContext = !0);
                            defaultValue = propKey;
                            break;
                        case "children":
                        case "dangerouslySetInnerHTML":
                            if (null != propKey) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                            break;
                        default:
                            propKey !== lastProp && setProp(domElement, tag, _propKey8, propKey, nextProps, lastProp);
                    }
                }
                tag = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
                nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
                tag || !nextProps || didWarnUncontrolledToControlled || (console.error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnUncontrolledToControlled = !0);
                !tag || nextProps || didWarnControlledToUncontrolled || (console.error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"), didWarnControlledToUncontrolled = !0);
                updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
                return;
            case "select":
                propKey = value = defaultValue = _propKey8 = null;
                for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                    case "value":
                        break;
                    case "multiple":
                        propKey = lastDefaultValue;
                    default:
                        nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
                }
                for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                    case "value":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                        _propKey8 = type;
                        break;
                    case "defaultValue":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0);
                        defaultValue = type;
                        break;
                    case "multiple":
                        type !== lastDefaultValue && (viewTransitionMutationContext = !0), value = type;
                    default:
                        type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
                }
                nextProps = defaultValue;
                tag = value;
                lastProps = propKey;
                null != _propKey8 ? updateOptions(domElement, !!tag, _propKey8, !1) : !!lastProps !== !!tag && (null != nextProps ? updateOptions(domElement, !!tag, nextProps, !0) : updateOptions(domElement, !!tag, tag ? [] : "", !1));
                return;
            case "textarea":
                propKey = _propKey8 = null;
                for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                    case "value":
                        break;
                    case "children":
                        break;
                    default:
                        setProp(domElement, tag, defaultValue, null, nextProps, name);
                }
                for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                    case "value":
                        name !== type && (viewTransitionMutationContext = !0);
                        _propKey8 = name;
                        break;
                    case "defaultValue":
                        name !== type && (viewTransitionMutationContext = !0);
                        propKey = name;
                        break;
                    case "children":
                        break;
                    case "dangerouslySetInnerHTML":
                        if (null != name) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
                        break;
                    default:
                        name !== type && setProp(domElement, tag, value, name, nextProps, type);
                }
                updateTextarea(domElement, _propKey8, propKey);
                return;
            case "option":
                for(var _propKey13 in lastProps)if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13)) switch(_propKey13){
                    case "selected":
                        domElement.selected = !1;
                        break;
                    default:
                        setProp(domElement, tag, _propKey13, null, nextProps, _propKey8);
                }
                for(lastDefaultValue in nextProps)if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(lastDefaultValue){
                    case "selected":
                        _propKey8 !== propKey && (viewTransitionMutationContext = !0);
                        domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                        break;
                    default:
                        setProp(domElement, tag, lastDefaultValue, _propKey8, nextProps, propKey);
                }
                return;
            case "img":
            case "link":
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "keygen":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
            case "menuitem":
                for(var _propKey15 in lastProps)_propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(domElement, tag, _propKey15, null, nextProps, _propKey8);
                for(checked in nextProps)if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey)) switch(checked){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != _propKey8) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
                        break;
                    default:
                        setProp(domElement, tag, checked, _propKey8, nextProps, propKey);
                }
                return;
            default:
                if (isCustomElement(tag)) {
                    for(var _propKey17 in lastProps)_propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(domElement, tag, _propKey17, void 0, nextProps, _propKey8);
                    for(defaultChecked in nextProps)_propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, _propKey8, nextProps, propKey);
                    return;
                }
        }
        for(var _propKey19 in lastProps)_propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag, _propKey19, null, nextProps, _propKey8);
        for(lastProp in nextProps)_propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
        switch(attrName){
            case "class":
                return "className";
            case "for":
                return "htmlFor";
            default:
                return attrName;
        }
    }
    function getStylesObjectFromElement(domElement) {
        for(var serverValueInObjectForm = {}, style = domElement.style, i = 0; i < style.length; i++){
            var styleName = style[i];
            "view-transition-name" === styleName && isExpectedViewTransitionName(domElement) || (serverValueInObjectForm[styleName] = style.getPropertyValue(styleName));
        }
        return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
        if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0) console.error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        else {
            var clientValue;
            var delimiter = clientValue = "", styleName;
            for(styleName in value$jscomp$0)if (value$jscomp$0.hasOwnProperty(styleName)) {
                var value = value$jscomp$0[styleName];
                null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
            }
            clientValue = clientValue || null;
            value$jscomp$0 = domElement.getAttribute("style");
            value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), value$jscomp$0 = normalizeMarkupForTextOrAttribute(value$jscomp$0), value$jscomp$0 === clientValue || ";" === value$jscomp$0[value$jscomp$0.length - 1] && hasViewTransition(domElement) || (serverDifferences.style = getStylesObjectFromElement(domElement)));
        }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) {
            switch(typeof value){
                case "function":
                case "symbol":
                    return;
            }
            if (!value) return;
        } else switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
                break;
            default:
                if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
            default:
                if (isNaN(value)) return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value)) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
        extraAttributes.delete(attributeName);
        domElement = domElement.getAttribute(attributeName);
        if (null === domElement) switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                return;
        }
        else if (null != value) switch(typeof value){
            case "function":
            case "symbol":
            case "boolean":
                break;
            default:
                if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName) return;
        }
        warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag, props, hostContext) {
        for(var serverDifferences = {}, extraAttributes = new Set(), attributes = domElement.attributes, i = 0; i < attributes.length; i++)switch(attributes[i].name.toLowerCase()){
            case "value":
                break;
            case "checked":
                break;
            case "selected":
                break;
            case "vt-name":
            case "vt-update":
            case "vt-enter":
            case "vt-exit":
            case "vt-share":
            case "vt-parent-enter":
            case "vt-parent-exit":
                break;
            default:
                extraAttributes.add(attributes[i].name);
        }
        if (isCustomElement(tag)) {
            for(var propKey in props)if (props.hasOwnProperty(propKey)) {
                var value = props[propKey];
                if (null != value) {
                    if (registrationNameDependencies.hasOwnProperty(propKey)) "function" !== typeof value && warnForInvalidEventListener(propKey, value);
                    else if (!0 !== props.suppressHydrationWarning) switch(propKey){
                        case "children":
                            "string" !== typeof value && "number" !== typeof value || warnForPropDifference("children", domElement.textContent, value, serverDifferences);
                            continue;
                        case "suppressContentEditableWarning":
                        case "suppressHydrationWarning":
                        case "defaultValue":
                        case "defaultChecked":
                        case "innerHTML":
                        case "ref":
                            continue;
                        case "dangerouslySetInnerHTML":
                            attributes = domElement.innerHTML;
                            value = value ? value.__html : void 0;
                            null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(propKey, attributes, value, serverDifferences));
                            continue;
                        case "style":
                            extraAttributes.delete(propKey);
                            diffHydratedStyles(domElement, value, serverDifferences);
                            continue;
                        case "offsetParent":
                        case "offsetTop":
                        case "offsetLeft":
                        case "offsetWidth":
                        case "offsetHeight":
                        case "isContentEditable":
                        case "outerText":
                        case "outerHTML":
                            extraAttributes.delete(propKey.toLowerCase());
                            console.error("Assignment to read-only property will result in a no-op: `%s`", propKey);
                            continue;
                        case "className":
                            extraAttributes.delete("class");
                            attributes = getValueForAttributeOnCustomComponent(domElement, "class", value);
                            warnForPropDifference("className", attributes, value, serverDifferences);
                            continue;
                        default:
                            hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(domElement, propKey, value), warnForPropDifference(propKey, attributes, value, serverDifferences);
                    }
                }
            }
        } else for(value in props)if (props.hasOwnProperty(value) && (propKey = props[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value)) "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (!0 !== props.suppressHydrationWarning) switch(value){
                case "children":
                    "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference("children", domElement.textContent, propKey, serverDifferences);
                    continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                    continue;
                case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    propKey = propKey ? propKey.__html : void 0;
                    null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = {
                        __html: attributes
                    }));
                    continue;
                case "className":
                    hydrateAttribute(domElement, value, "class", propKey, extraAttributes, serverDifferences);
                    continue;
                case "tabIndex":
                    hydrateAttribute(domElement, value, "tabindex", propKey, extraAttributes, serverDifferences);
                    continue;
                case "style":
                    extraAttributes.delete(value);
                    diffHydratedStyles(domElement, propKey, serverDifferences);
                    continue;
                case "multiple":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.multiple, propKey, serverDifferences);
                    continue;
                case "muted":
                    extraAttributes.delete(value);
                    warnForPropDifference(value, domElement.muted, propKey, serverDifferences);
                    continue;
                case "autoFocus":
                    extraAttributes.delete("autofocus");
                    warnForPropDifference(value, domElement.autofocus, propKey, serverDifferences);
                    continue;
                case "data":
                    if ("object" !== tag) {
                        extraAttributes.delete(value);
                        attributes = domElement.getAttribute("data");
                        warnForPropDifference(value, attributes, propKey, serverDifferences);
                        continue;
                    }
                case "src":
                case "href":
                    if (!("" !== propKey || "a" === tag && "href" === value || "object" === tag && "data" === value)) {
                        "src" === value ? console.error('An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value) : console.error('An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.', value, value);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "action":
                case "formAction":
                    attributes = domElement.getAttribute(value);
                    if ("function" === typeof propKey) {
                        extraAttributes.delete(value.toLowerCase());
                        "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                        continue;
                    } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                        extraAttributes.delete(value.toLowerCase());
                        warnForPropDifference(value, "function", propKey, serverDifferences);
                        continue;
                    }
                    hydrateSanitizedAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkHref":
                    hydrateSanitizedAttribute(domElement, value, "xlink:href", propKey, extraAttributes, serverDifferences);
                    continue;
                case "contentEditable":
                    hydrateBooleanishAttribute(domElement, value, "contenteditable", propKey, extraAttributes, serverDifferences);
                    continue;
                case "spellCheck":
                    hydrateBooleanishAttribute(domElement, value, "spellcheck", propKey, extraAttributes, serverDifferences);
                    continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                    hydrateBooleanishAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "credentialless":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                    hydrateBooleanAttribute(domElement, value, value.toLowerCase(), propKey, extraAttributes, serverDifferences);
                    continue;
                case "capture":
                case "download":
                    a: {
                        i = domElement;
                        var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                                break a;
                            default:
                                if (!1 === propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                                break;
                            case "boolean":
                                if (!0 === propKey && "" === i) break a;
                                break;
                            default:
                                if (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                    a: {
                        i = domElement;
                        attributeName = attributes = value;
                        serverDifferences$jscomp$0 = serverDifferences;
                        extraAttributes.delete(attributeName);
                        i = i.getAttribute(attributeName);
                        if (null === i) switch(typeof propKey){
                            case "undefined":
                            case "function":
                            case "symbol":
                            case "boolean":
                                break a;
                            default:
                                if (isNaN(propKey) || 1 > propKey) break a;
                        }
                        else if (null != propKey) switch(typeof propKey){
                            case "function":
                            case "symbol":
                            case "boolean":
                                break;
                            default:
                                if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i === "" + propKey)) break a;
                        }
                        warnForPropDifference(attributes, i, propKey, serverDifferences$jscomp$0);
                    }
                    continue;
                case "rowSpan":
                    hydrateNumericAttribute(domElement, value, "rowspan", propKey, extraAttributes, serverDifferences);
                    continue;
                case "start":
                    hydrateNumericAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                case "xHeight":
                    hydrateAttribute(domElement, value, "x-height", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkActuate":
                    hydrateAttribute(domElement, value, "xlink:actuate", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkArcrole":
                    hydrateAttribute(domElement, value, "xlink:arcrole", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkRole":
                    hydrateAttribute(domElement, value, "xlink:role", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkShow":
                    hydrateAttribute(domElement, value, "xlink:show", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkTitle":
                    hydrateAttribute(domElement, value, "xlink:title", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xlinkType":
                    hydrateAttribute(domElement, value, "xlink:type", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlBase":
                    hydrateAttribute(domElement, value, "xml:base", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlLang":
                    hydrateAttribute(domElement, value, "xml:lang", propKey, extraAttributes, serverDifferences);
                    continue;
                case "xmlSpace":
                    hydrateAttribute(domElement, value, "xml:space", propKey, extraAttributes, serverDifferences);
                    continue;
                case "inert":
                    "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = !0, console.error("Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.", value));
                    hydrateBooleanAttribute(domElement, value, value, propKey, extraAttributes, serverDifferences);
                    continue;
                default:
                    if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                        i = getAttributeAlias(value);
                        attributes = !1;
                        hostContext.context === HostContextNamespaceNone && "svg" !== tag && "math" !== tag ? extraAttributes.delete(i.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(attributeName) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = !0, extraAttributes.delete(attributeName)), extraAttributes.delete(i));
                        a: if (attributeName = domElement, serverDifferences$jscomp$0 = i, i = propKey, isAttributeNameSafe(serverDifferences$jscomp$0)) {
                            if (attributeName.hasAttribute(serverDifferences$jscomp$0)) attributeName = "nonce" === serverDifferences$jscomp$0.toLowerCase() ? attributeName.nonce : attributeName.getAttribute(serverDifferences$jscomp$0), checkAttributeStringCoercion(i, serverDifferences$jscomp$0), i = attributeName === "" + i ? i : attributeName;
                            else {
                                switch(typeof i){
                                    case "function":
                                    case "symbol":
                                        break a;
                                    case "boolean":
                                        if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName) break a;
                                }
                                i = void 0 === i ? void 0 : null;
                            }
                        } else i = void 0;
                        attributes || warnForPropDifference(value, i, propKey, serverDifferences);
                    }
            }
        }
        0 < extraAttributes.size && !0 !== props.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
        return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list, combinator) {
        switch(list.length){
            case 0:
                return "";
            case 1:
                return list[0];
            case 2:
                return list[0] + " " + combinator + " " + list[1];
            default:
                return list.slice(0, -1).join(", ") + ", " + combinator + " " + list[list.length - 1];
        }
    }
    function isLikelyStaticResource(initiatorType) {
        switch(initiatorType){
            case "css":
            case "script":
            case "font":
            case "img":
            case "image":
            case "input":
            case "link":
                return !0;
            default:
                return !1;
        }
    }
    function estimateBandwidth() {
        if ("function" === typeof performance.getEntriesByType) {
            for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
                var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
                if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                    initiatorType = 0;
                    duration = entry.responseEnd;
                    for(i += 1; i < resourceEntries.length; i++){
                        var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                        if (overlapStartTime > duration) break;
                        var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                        overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                    }
                    --i;
                    bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                    count++;
                    if (10 < count) break;
                }
            }
            if (0 < count) return bits / count / 1e6;
        }
        return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
        switch(namespaceURI){
            case SVG_NAMESPACE:
                return HostContextNamespaceSvg;
            case MATH_NAMESPACE:
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
    }
    function getChildHostContextProd(parentNamespace, type) {
        if (parentNamespace === HostContextNamespaceNone) switch(type){
            case "svg":
                return HostContextNamespaceSvg;
            case "math":
                return HostContextNamespaceMath;
            default:
                return HostContextNamespaceNone;
        }
        return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
        rootContainerInstance = getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
        rootContainerInstance[internalInstanceKey] = internalInstanceHandle;
        rootContainerInstance[internalPropsKey] = props;
        setInitialProperties(rootContainerInstance, type, props);
        markNodeAsHoistable(rootContainerInstance);
        return rootContainerInstance;
    }
    function isScriptDataBlock(props) {
        props = props.type;
        if ("string" !== typeof props || "" === props) return !1;
        props = props.toLowerCase();
        if ("module" === props || "importmap" === props || "speculationrules" === props) return !1;
        switch(props){
            case "application/ecmascript":
            case "application/javascript":
            case "application/x-ecmascript":
            case "application/x-javascript":
            case "text/ecmascript":
            case "text/javascript":
            case "text/javascript1.0":
            case "text/javascript1.1":
            case "text/javascript1.2":
            case "text/javascript1.3":
            case "text/javascript1.4":
            case "text/javascript1.5":
            case "text/jscript":
            case "text/livescript":
            case "text/x-ecmascript":
            case "text/x-javascript":
                return !1;
        }
        return !0;
    }
    function shouldSetTextContent(type, props) {
        return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
        var event = window.event;
        if (event && "popstate" === event.type) {
            if (event === currentPopstateTransitionEvent) return !1;
            currentPopstateTransitionEvent = event;
            return !0;
        }
        currentPopstateTransitionEvent = null;
        return !1;
    }
    function resolveEventType() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
        var event = window.event;
        return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    }
    function commitMount(domElement, type, newProps) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                newProps.autoFocus && domElement.focus();
                break;
            case "img":
                newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
        }
    }
    function commitHydratedInstance() {}
    function commitUpdate(domElement, type, oldProps, newProps) {
        updateProperties(domElement, type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
        if (!container.__reactWarnedAboutChildrenConflict) {
            var props = container[internalPropsKey] || null;
            if (null !== props) {
                var fiber = getInstanceFromNode(container);
                null !== fiber && ("string" === typeof props.children || "number" === typeof props.children ? (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })) : null != props.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = !0, runWithFiberInDEV(fiber, function() {
                    console.error('Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.');
                })));
            }
        }
    }
    function isSingletonScope(type) {
        return "head" === type;
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
        var node = hydrationInstance, depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
                    if (0 === depth) {
                        parentInstance.removeChild(nextNode);
                        retryIfBlockedOn(hydrationInstance);
                        return;
                    }
                    depth--;
                } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA) depth++;
                else if (node === PREAMBLE_CONTRIBUTION_HTML) clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
                else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
                    node = parentInstance.ownerDocument.head;
                    clearSingletonPreambleContribution(node);
                    for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                        var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                        node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                        node$jscomp$0 = nextNode$jscomp$0;
                    }
                } else node === PREAMBLE_CONTRIBUTION_BODY && clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
            }
            node = nextNode;
        }while (node);
        retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
        var node = suspenseInstance;
        suspenseInstance = 0;
        do {
            var nextNode = node.nextSibling;
            1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
            if (nextNode && 8 === nextNode.nodeType) {
                if (node = nextNode.data, node === SUSPENSE_END_DATA) {
                    if (0 === suspenseInstance) break;
                    else suspenseInstance--;
                } else node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
            }
            node = nextNode;
        }while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
        hideOrUnhideDehydratedBoundary(suspenseInstance, !0);
    }
    function hideInstance(instance) {
        instance = instance.style;
        "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
        hideOrUnhideDehydratedBoundary(dehydratedInstance, !1);
    }
    function unhideInstance(instance, props) {
        props = props[STYLE];
        props = void 0 !== props && null !== props && props.hasOwnProperty("display") ? props.display : null;
        instance.style.display = null == props || "boolean" === typeof props ? "" : ("" + props).trim();
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function warnForBlockInsideInline(instance) {
        for(var nextNode = instance.firstChild; null != nextNode;){
            if (1 === nextNode.nodeType && "block" === getComputedStyle(nextNode).display) {
                var fiber = getInstanceFromNode(nextNode) || getInstanceFromNode(instance);
                runWithFiberInDEV(fiber, function(parentTag, childTag) {
                    console.error("You're about to start a <ViewTransition> around a display: inline element <%s>, which itself has a display: block element <%s> inside it. This might trigger a bug in Safari which causes the View Transition to be skipped with a duplicate name error.\nhttps://bugs.webkit.org/show_bug.cgi?id=290923", parentTag.toLocaleLowerCase(), childTag.toLocaleLowerCase());
                }, instance.tagName, nextNode.tagName);
                break;
            }
            if (null != nextNode.firstChild) nextNode = nextNode.firstChild;
            else {
                if (nextNode === instance) break;
                for(; null == nextNode.nextSibling && null != nextNode.parentNode && nextNode.parentNode !== instance;)nextNode = nextNode.parentNode;
                nextNode = nextNode.nextSibling;
            }
        }
    }
    function applyViewTransitionName(instance, name, className) {
        name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
        instance.style.viewTransitionName = name;
        null != className && (instance.style.viewTransitionClass = className);
        className = getComputedStyle(instance);
        if ("inline" === className.display) {
            name = instance.getClientRects();
            if (1 === name.length) var JSCompiler_inline_result = 1;
            else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
                var rect = name[i];
                0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
            }
            1 === JSCompiler_inline_result ? (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom) : warnForBlockInsideInline(instance);
        }
    }
    function restoreViewTransitionName(instance, props) {
        instance = instance.style;
        props = props[STYLE];
        var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
        instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
        viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
        instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
        "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
    }
    function createMeasurement(rect, computedStyle, element) {
        element = element.ownerDocument.defaultView;
        return {
            rect: rect,
            abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
            clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
            view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
        };
    }
    function measureInstance(instance) {
        var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
        return createMeasurement(rect, computedStyle, instance);
    }
    function measureClonedInstance(instance) {
        var measuredRect = instance.getBoundingClientRect();
        measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
        var computedStyle = getComputedStyle(instance);
        return createMeasurement(measuredRect, computedStyle, instance);
    }
    function customizeViewTransitionError(error, ignoreAbort) {
        if ("object" === typeof error && null !== error) switch(error.name){
            case "TimeoutError":
                return Error("A ViewTransition timed out because a Navigation stalled. This can happen if a Navigation is blocked on React itself. Such as if it's resolved inside useEffect. This can be solved by moving the resolution to useLayoutEffect.", {
                    cause: error
                });
            case "AbortError":
                return ignoreAbort ? null : Error("A ViewTransition was aborted early. This might be because you have other View Transition libraries on the page and only one can run at a time. To avoid this, use only React's built-in <ViewTransition> to coordinate.", {
                    cause: error
                });
            case "InvalidStateError":
                if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) return null;
        }
        return error;
    }
    function forceLayout(ownerDocument) {
        return ownerDocument.documentElement.clientHeight;
    }
    function waitForImageToLoad(resolve) {
        this.addEventListener("load", resolve);
        this.addEventListener("error", resolve);
    }
    function startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback, blockedCallback, finishedAnimation) {
        var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
        try {
            var transition = ownerDocument.startViewTransition({
                update: function() {
                    var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                    mutationCallback();
                    var blockingPromises = [];
                    "loaded" === previousFontLoadingStatus && (forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                    previousFontLoadingStatus = blockingPromises.length;
                    if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                        var suspenseyImage = suspenseyImages[i];
                        if (!suspenseyImage.complete) {
                            var rect = suspenseyImage.getBoundingClientRect();
                            if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                                imgBytes += estimateImageBytes(suspenseyImage);
                                if (imgBytes > estimatedBytesWithinLimit) {
                                    blockingPromises.length = previousFontLoadingStatus;
                                    break;
                                }
                                suspenseyImage = new Promise(waitForImageToLoad.bind(suspenseyImage));
                                blockingPromises.push(suspenseyImage);
                            }
                        }
                    }
                    if (0 < blockingPromises.length) return blockedCallback(0 < previousFontLoadingStatus ? blockingPromises.length > previousFontLoadingStatus ? "Waiting on Fonts and Images" : "Waiting on Fonts" : "Waiting on Images"), ownerWindow = Promise.race([
                        Promise.all(blockingPromises),
                        new Promise(function(resolve) {
                            return setTimeout(resolve, SUSPENSEY_FONT_AND_IMAGE_TIMEOUT);
                        })
                    ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                        pendingNavigation.finished,
                        ownerWindow
                    ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                    layoutCallback();
                    if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                    afterMutationCallback();
                },
                types: transitionTypes
            });
            ownerDocument.__reactViewTransition = transition;
            var viewTransitionAnimations = [];
            transition.ready.then(function() {
                for(var animations = ownerDocument.documentElement.getAnimations({
                    subtree: !0
                }), i = 0; i < animations.length; i++){
                    var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                    if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                        viewTransitionAnimations.push(animation);
                        animation = effect.getKeyframes();
                        for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                            var keyframe = animation[j], w = keyframe.width;
                            if (void 0 === pseudoElement) pseudoElement = w;
                            else if (pseudoElement !== w) {
                                unchangedDimensions = !1;
                                break;
                            }
                            w = keyframe.height;
                            if (void 0 === height) height = w;
                            else if (height !== w) {
                                unchangedDimensions = !1;
                                break;
                            }
                            delete keyframe.width;
                            delete keyframe.height;
                            "none" === keyframe.transform && delete keyframe.transform;
                        }
                        unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                    }
                }
                spawnedWorkCallback();
            }, function(error) {
                ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
                try {
                    error = customizeViewTransitionError(error, !1), null !== error && errorCallback(error);
                } finally{
                    mutationCallback(), layoutCallback(), spawnedWorkCallback(), finishedAnimation();
                }
            });
            transition.finished.finally(function() {
                for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
                ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
                finishedAnimation();
                passiveCallback();
            });
            return transition;
        } catch (x) {
            return mutationCallback(), layoutCallback(), finishedAnimation(), spawnedWorkCallback(), null;
        }
    }
    function ViewTransitionPseudoElement(pseudo, name) {
        this._scope = document.documentElement;
        this._selector = "::view-transition-" + pseudo + "(" + name + ")";
    }
    function createViewTransitionInstance(name) {
        return {
            name: name,
            group: new ViewTransitionPseudoElement("group", name),
            imagePair: new ViewTransitionPseudoElement("image-pair", name),
            old: new ViewTransitionPseudoElement("old", name),
            new: new ViewTransitionPseudoElement("new", name)
        };
    }
    function FragmentInstance(fragmentFiber) {
        this._fragmentFiber = fragmentFiber;
        this._observers = this._eventListeners = null;
    }
    function addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
        getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
        return !1;
    }
    function removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
        getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
        return !1;
    }
    function getAttachOptions(opts) {
        return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
            capture: opts.capture,
            passive: opts.passive
        } : opts;
    }
    function normalizeListenerOptions(opts) {
        return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
    }
    function indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
        if (0 === eventListeners.length) return -1;
        optionsOrUseCapture = normalizeListenerOptions(optionsOrUseCapture);
        for(var i = 0; i < eventListeners.length; i++){
            var item = eventListeners[i];
            if (item.type === type && item.listener === listener && normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
        }
        return -1;
    }
    function setFocusOnFiberIfFocusable(fiber, focusOptions) {
        if (6 === fiber.tag) return !1;
        fiber = getInstanceFromHostFiber(fiber);
        return setFocusIfFocusable(fiber, focusOptions);
    }
    function collectChildren(child, collection) {
        collection.push(child);
        return !1;
    }
    function blurActiveElementWithinFragment(child, activeElement) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
    }
    function observeChild(child, observer) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        observer.observe(child);
        return !1;
    }
    function unobserveChild(child, observer) {
        if (6 === child.tag) return !1;
        child = getInstanceFromHostFiber(child);
        observer.unobserve(child);
        return !1;
    }
    function schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
        pendingIntersectionUnobserves.push({
            fragmentInstance: fragmentInstance,
            observer: observer,
            instance: instance
        });
        intersectionUnobserveScheduled || (intersectionUnobserveScheduled = !0, requestPostPaintCallback(function() {
            intersectionUnobserveScheduled = !1;
            var pending = pendingIntersectionUnobserves;
            pendingIntersectionUnobserves = [];
            for(var i = 0; i < pending.length; i++){
                var item = pending[i];
                item.observer.unobserve(item.instance);
            }
        }));
    }
    function collectClientRects(child, rects) {
        if (6 === child.tag) {
            child = child.stateNode;
            var range = child.ownerDocument.createRange();
            range.selectNodeContents(child);
            rects.push.apply(rects, range.getClientRects());
        } else child = getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
        return !1;
    }
    function validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
        var otherFiber = getClosestInstanceFromNode(otherNode);
        if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            if (precedingBoundaryFiber = !!otherFiber) a: {
                for(; null !== otherFiber;){
                    if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                        precedingBoundaryFiber = !0;
                        break a;
                    }
                    otherFiber = otherFiber.return;
                }
                precedingBoundaryFiber = !1;
            }
            return precedingBoundaryFiber;
        }
        if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
            if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
            a: {
                otherFiber = fragmentFiber;
                for(fragmentFiber = getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                    if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                        otherFiber = !0;
                        break a;
                    }
                    otherFiber = otherFiber.return;
                }
                otherFiber = !1;
            }
            return otherFiber;
        }
        return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = searchTarget, searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = getLowestCommonAncestor(followingBoundaryFiber, otherFiber, getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : (traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = searchTarget, searchBoundary = searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
    }
    function scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
        var range = textNode.ownerDocument.createRange();
        range.selectNodeContents(textNode);
        textNode = range.getBoundingClientRect();
        window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
    }
    function addFragmentHandleToFiber(child, fragmentInstance) {
        child = getInstanceFromHostFiber(child);
        addFragmentHandleToInstance(child, fragmentInstance);
        return !1;
    }
    function addFragmentHandleToInstance(instance, fragmentInstance) {
        null == instance.reactFragments && (instance.reactFragments = new Set());
        instance.reactFragments.add(fragmentInstance);
    }
    function commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
        var eventListeners = fragmentInstance._eventListeners;
        if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
            var _eventListeners$i2 = eventListeners[i$jscomp$0];
            childInstance.addEventListener(_eventListeners$i2.type, _eventListeners$i2.attachedListener, getAttachOptions(_eventListeners$i2.optionsOrUseCapture));
        }
        3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
            for(var writeIdx = 0, i = 0; i < pendingIntersectionUnobserves.length; i++){
                var pending = pendingIntersectionUnobserves[i];
                if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) pendingIntersectionUnobserves[writeIdx++] = pending;
            }
            pendingIntersectionUnobserves.length = writeIdx;
            observer.observe(childInstance);
        }), addFragmentHandleToInstance(childInstance, fragmentInstance));
    }
    function deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
        var eventListeners = fragmentInstance._eventListeners;
        if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i3 = eventListeners[i];
            childInstance.removeEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
        }
        3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
            "string" === typeof observer.rootMargin ? schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
        }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
    }
    function clearContainerSparingly(container) {
        var nextNode = container.firstChild;
        nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
        for(; nextNode;){
            var node = nextNode;
            nextNode = nextNode.nextSibling;
            switch(node.nodeName){
                case "HTML":
                case "HEAD":
                case "BODY":
                    clearContainerSparingly(node);
                    detachDeletedInstance(node);
                    continue;
                case "SCRIPT":
                case "STYLE":
                    continue;
                case "LINK":
                    if ("stylesheet" === node.rel.toLowerCase()) continue;
            }
            container.removeChild(node);
        }
    }
    function canHydrateInstance(instance, type, props, inRootOrSingleton) {
        for(; 1 === instance.nodeType;){
            var anyProps = props;
            if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
                if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
            } else if (!inRootOrSingleton) {
                if ("input" === type && "hidden" === instance.type) {
                    checkAttributeStringCoercion(anyProps.name, "name");
                    var name = null == anyProps.name ? null : "" + anyProps.name;
                    if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
                } else return instance;
            } else if (!instance[internalHoistableMarker]) switch(type){
                case "meta":
                    if (!instance.hasAttribute("itemprop")) break;
                    return instance;
                case "link":
                    name = instance.getAttribute("rel");
                    if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                    else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                    return instance;
                case "style":
                    if (instance.hasAttribute("data-precedence")) break;
                    return instance;
                case "script":
                    name = instance.getAttribute("src");
                    if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                    return instance;
                default:
                    return instance;
            }
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) break;
        }
        return null;
    }
    function canHydrateTextInstance(instance, text, inRootOrSingleton) {
        if ("" === text) return null;
        for(; 3 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
        for(; 8 !== instance.nodeType;){
            if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
            instance = getNextHydratable(instance.nextSibling);
            if (null === instance) return null;
        }
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        var ownerDocument = instance.ownerDocument;
        if (instance.data === SUSPENSE_QUEUED_START_DATA) instance._reactRetry = callback;
        else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING) callback();
        else {
            var listener = function() {
                callback();
                ownerDocument.removeEventListener("DOMContentLoaded", listener);
            };
            ownerDocument.addEventListener("DOMContentLoaded", listener);
            instance._reactRetry = listener;
        }
    }
    function getNextHydratable(node) {
        for(; null != node; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (1 === nodeType || 3 === nodeType) break;
            if (8 === nodeType) {
                nodeType = node.data;
                if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING) break;
                if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA) return null;
            }
        }
        return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
        if (1 === instance.nodeType) {
            for(var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i = 0; i < attributes.length; i++){
                var attr = attributes[i];
                serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
            }
            return {
                type: JSCompiler_temp_const,
                props: serverDifferences
            };
        }
        return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? {
            type: "Activity",
            props: {}
        } : {
            type: "Suspense",
            props: {}
        } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text, parentProps) {
        return null === parentProps || !0 !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text ? textInstance = null : (text = normalizeMarkupForTextOrAttribute(text), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
        hydrationInstance = hydrationInstance.nextSibling;
        for(var depth = 0; hydrationInstance;){
            if (8 === hydrationInstance.nodeType) {
                var data = hydrationInstance.data;
                if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
                    if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                    depth--;
                } else data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
            }
            hydrationInstance = hydrationInstance.nextSibling;
        }
        return null;
    }
    function getParentHydrationBoundary(targetInstance) {
        targetInstance = targetInstance.previousSibling;
        for(var depth = 0; targetInstance;){
            if (8 === targetInstance.nodeType) {
                var data = targetInstance.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
                    if (0 === depth) return targetInstance;
                    depth--;
                } else data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
            }
            targetInstance = targetInstance.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
        retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        retryIfBlockedOn(suspenseInstance);
    }
    function setFocusIfFocusable(node, focusOptions) {
        function handleFocus() {
            didFocus = !0;
        }
        if (node.ownerDocument.activeElement === node) return !0;
        var didFocus = !1;
        try {
            node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
        } finally{
            node.ownerDocument.removeEventListener("focus", handleFocus, !0);
        }
        return didFocus;
    }
    function requestPostPaintCallback(callback) {
        localRequestAnimationFrame(function() {
            localRequestAnimationFrame(function(time) {
                return callback(time);
            });
        });
    }
    function resolveSingletonInstance(type, props, rootContainerInstance, hostContext, validateDOMNestingDev) {
        validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
        props = getOwnerDocumentFromRootContainer(rootContainerInstance);
        switch(type){
            case "html":
                type = props.documentElement;
                if (!type) throw Error("React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "head":
                type = props.head;
                if (!type) throw Error("React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            case "body":
                type = props.body;
                if (!type) throw Error("React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page.");
                return type;
            default:
                throw Error("resolveSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
    }
    function acquireSingletonInstance(type, props, instance, internalInstanceHandle) {
        if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
            var tagName = instance.tagName.toLowerCase();
            console.error("You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.", tagName, tagName, tagName);
        }
        switch(type){
            case "html":
            case "head":
            case "body":
                break;
            default:
                console.error("acquireSingletonInstance was called with an element type that is not supported. This is a bug in React.");
        }
        for(tagName = instance.attributes; tagName.length;)instance.removeAttributeNode(tagName[0]);
        setInitialProperties(instance, type, props);
        instance[internalInstanceKey] = internalInstanceHandle;
        instance[internalPropsKey] = props;
    }
    function releaseSingletonInstance(instance, type, props) {
        for(var propKey in props){
            var propValue = props[propKey];
            props.hasOwnProperty(propKey) && null != propValue && setProp(instance, type, propKey, null, emptyProps, propValue);
        }
        null != props.dangerouslySetInnerHTML && (instance.textContent = "");
        instance.onclick === noop$1 && (instance.onclick = null);
        detachDeletedInstance(instance);
    }
    function clearSingletonPreambleContribution(instance) {
        for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
        detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
        if ("function" === typeof container.getRootNode) {
            var rootNode = container.getRootNode();
            if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
        }
        return 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
        var ownerDocument = globalDocument;
        if (ownerDocument && "string" === typeof href && href) {
            var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
            limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
            "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
            preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
                rel: rel,
                crossOrigin: crossOrigin,
                href: href
            }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
        }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
        var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
        if (!resourceRoot) throw Error('"resourceRoot" was expected to exist. This is a bug in React.');
        switch(type){
            case "meta":
            case "title":
                return null;
            case "style":
                return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "style",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            case "link":
                if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                    type = getStyleKey(pendingProps.href);
                    var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
                    _resource || (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
                        type: "stylesheet",
                        instance: null,
                        count: 0,
                        state: {
                            loading: NotLoaded,
                            preload: null
                        }
                    }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(getStylesheetSelectorFromKey(type))) ? _styles._p || (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted) : (_styles = preloadPropsMap.get(type), _styles || (_styles = {
                        rel: "preload",
                        as: "style",
                        href: pendingProps.href,
                        crossOrigin: pendingProps.crossOrigin,
                        integrity: pendingProps.integrity,
                        media: pendingProps.media,
                        hrefLang: pendingProps.hrefLang,
                        referrerPolicy: pendingProps.referrerPolicy
                    }, preloadPropsMap.set(type, _styles)), preloadStylesheet(resourceRoot, type, _styles, _resource.state)));
                    if (currentProps && null === currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                    return _resource;
                }
                if (currentProps && null !== currentResource) throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error("Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps);
                return null;
            case "script":
                return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                    type: "script",
                    instance: null,
                    count: 0,
                    state: null
                }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                    type: "void",
                    instance: null,
                    count: 0,
                    state: null
                };
            default:
                throw Error('getResource encountered a type it did not expect: "' + type + '". this is a bug in React.');
        }
    }
    function describeLinkForResourceErrorDEV(props) {
        var describedProps = 0, description = "<link";
        "string" === typeof props.rel ? (describedProps++, description += ' rel="' + props.rel + '"') : hasOwnProperty.call(props, "rel") && (describedProps++, description += ' rel="' + (null === props.rel ? "null" : "invalid type " + typeof props.rel) + '"');
        "string" === typeof props.href ? (describedProps++, description += ' href="' + props.href + '"') : hasOwnProperty.call(props, "href") && (describedProps++, description += ' href="' + (null === props.href ? "null" : "invalid type " + typeof props.href) + '"');
        "string" === typeof props.precedence ? (describedProps++, description += ' precedence="' + props.precedence + '"') : hasOwnProperty.call(props, "precedence") && (describedProps++, description += " precedence={" + (null === props.precedence ? "null" : "invalid type " + typeof props.precedence) + "}");
        Object.getOwnPropertyNames(props).length > describedProps && (description += " ...");
        return description + " />";
    }
    function getStyleKey(href) {
        return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
        return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
        return assign({}, rawProps, {
            "data-precedence": rawProps.precedence,
            precedence: null
        });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
        if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
            if (!0 !== key[internalLoadPendingKey]) {
                state.loading = Loaded;
                return;
            }
        } else key = ownerDocument.createElement("link"), key[internalLoadPendingKey] = !0, key.onload = key.onerror = clearPendingLoadOnNode.bind(null, key), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
        state.preload = key;
        key.addEventListener("load", function() {
            return state.loading |= Loaded;
        });
        key.addEventListener("error", function() {
            return state.loading |= Errored;
        });
    }
    function getScriptKey(src) {
        return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
        return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props) {
        resource.count++;
        if (null === resource.instance) switch(resource.type){
            case "style":
                var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
                if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
                var styleProps = assign({}, props, {
                    "data-href": props.href,
                    "data-precedence": props.precedence,
                    href: null,
                    precedence: null
                });
                instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
                markNodeAsHoistable(instance);
                setInitialProperties(instance, "style", styleProps);
                insertStylesheet(instance, props.precedence, hoistableRoot);
                return resource.instance = instance;
            case "stylesheet":
                styleProps = getStyleKey(props.href);
                var _instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
                if (_instance) return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
                instance = stylesheetPropsFromRawProps(props);
                (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
                _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
                markNodeAsHoistable(_instance);
                var linkInstance = _instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(_instance, "link", instance);
                resource.state.loading |= Inserted;
                insertStylesheet(_instance, props.precedence, hoistableRoot);
                return resource.instance = _instance;
            case "script":
                _instance = getScriptKey(props.src);
                if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(_instance))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
                instance = props;
                if (styleProps = preloadPropsMap.get(_instance)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                styleProps = hoistableRoot.createElement("script");
                markNodeAsHoistable(styleProps);
                setInitialProperties(styleProps, "link", instance);
                hoistableRoot.head.appendChild(styleProps);
                return resource.instance = styleProps;
            case "void":
                return null;
            default:
                throw Error('acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.');
        }
        else "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props.precedence, hoistableRoot));
        return resource.instance;
    }
    function insertStylesheet(instance, precedence, root) {
        for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
            var node = nodes[i];
            if (node.dataset.precedence === precedence) prior = node;
            else if (prior !== last) break;
        }
        prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
        null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
        null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
        null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
        null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
        null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
        null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
        if (null === tagCaches) {
            var cache = new Map();
            var caches = tagCaches = new Map();
            caches.set(ownerDocument, cache);
        } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
        if (cache.has(type)) return cache;
        cache.set(type, null);
        ownerDocument = ownerDocument.getElementsByTagName(type);
        for(caches = 0; caches < ownerDocument.length; caches++){
            var node = ownerDocument[caches];
            if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
                var nodeKey = node.getAttribute(keyAttribute) || "";
                nodeKey = type + nodeKey;
                var existing = cache.get(nodeKey);
                existing ? existing.push(node) : cache.set(nodeKey, [
                    node
                ]);
            }
        }
        return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
        hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
        hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
    }
    function isHostHoistableType(type, props, hostContext) {
        var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
        if (hostContext.context === HostContextNamespaceSvg || null != props.itemProp) return !outsideHostContainerContext || null == props.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error("Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.", type, type), !1;
        switch(type){
            case "meta":
            case "title":
                return !0;
            case "style":
                if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) {
                    outsideHostContainerContext && console.error('Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.');
                    break;
                }
                return !0;
            case "link":
                if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) {
                    if ("stylesheet" === props.rel && "string" === typeof props.precedence) {
                        type = props.href;
                        var onError = props.onError, disabled = props.disabled;
                        hostContext = [];
                        props.onLoad && hostContext.push("`onLoad`");
                        onError && hostContext.push("`onError`");
                        null != disabled && hostContext.push("`disabled`");
                        onError = propNamesListJoin(hostContext, "and");
                        onError += 1 === hostContext.length ? " prop" : " props";
                        disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
                        hostContext.length && console.error('React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.', type, disabled, onError);
                    }
                    outsideHostContainerContext && ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href ? console.error("Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag") : (props.onError || props.onLoad) && console.error("Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."));
                    break;
                }
                switch(props.rel){
                    case "stylesheet":
                        return type = props.precedence, props = props.disabled, "string" !== typeof type && outsideHostContainerContext && console.error('Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'), "string" === typeof type && null == props;
                    default:
                        return !0;
                }
            case "script":
                type = props.async && "function" !== typeof props.async && "symbol" !== typeof props.async;
                if (!type || props.onLoad || props.onError || !props.src || "string" !== typeof props.src) {
                    outsideHostContainerContext && (type ? props.onLoad || props.onError ? console.error("Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>.") : console.error("Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>.") : console.error('Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'));
                    break;
                }
                return !0;
            case "noscript":
            case "template":
                outsideHostContainerContext && console.error("Cannot render <%s> outside the main document. Try moving it into the root <head> tag.", type);
        }
        return !1;
    }
    function maySuspendCommit(type, props) {
        return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
    }
    function preloadResource(resource) {
        return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? !1 : !0;
    }
    function estimateImageBytes(instance) {
        return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
    }
    function suspendInstance(state, instance) {
        "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = onUnsuspendImg.bind(state), instance.decode().then(state, state));
    }
    function suspendResource(state, hoistableRoot, resource, props) {
        if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
            if (null === resource.instance) {
                var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
                if (instance) {
                    hoistableRoot = instance._p;
                    null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                    resource.state.loading |= Inserted;
                    resource.instance = instance;
                    markNodeAsHoistable(instance);
                    return;
                }
                instance = hoistableRoot.ownerDocument || hoistableRoot;
                props = stylesheetPropsFromRawProps(props);
                (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
                instance = instance.createElement("link");
                markNodeAsHoistable(instance);
                var linkInstance = instance;
                linkInstance._p = new Promise(function(resolve, reject) {
                    linkInstance.onload = resolve;
                    linkInstance.onerror = reject;
                });
                setInitialProperties(instance, "link", props);
                resource.instance = instance;
            }
            null === state.stylesheets && (state.stylesheets = new Map());
            state.stylesheets.set(resource, hoistableRoot);
            (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
        }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
        state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
        return 0 < state.count || 0 < state.imgCount ? function(commit) {
            var stylesheetTimer = setTimeout(function() {
                state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
                if (state.unsuspend) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
            0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
            var imgTimer = setTimeout(function() {
                state.waitingForImages = !1;
                if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                    var unsuspend = state.unsuspend;
                    state.unsuspend = null;
                    unsuspend();
                }
            }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset);
            state.unsuspend = commit;
            return function() {
                state.unsuspend = null;
                clearTimeout(stylesheetTimer);
                clearTimeout(imgTimer);
            };
        } : null;
    }
    function checkIfFullyUnsuspended(state) {
        if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
            if (state.stylesheets) insertSuspendedStylesheets(state, state.stylesheets);
            else if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }
    }
    function onUnsuspend() {
        this.count--;
        checkIfFullyUnsuspended(this);
    }
    function onUnsuspendImg() {
        this.imgCount--;
        checkIfFullyUnsuspended(this);
    }
    function insertSuspendedStylesheets(state, resources) {
        state.stylesheets = null;
        null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root, resource) {
        if (!(resource.state.loading & Inserted)) {
            var precedences = precedencesByRoot.get(root);
            if (precedences) var last = precedences.get(LAST_PRECEDENCE);
            else {
                precedences = new Map();
                precedencesByRoot.set(root, precedences);
                for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                    var node = nodes[i];
                    if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
                }
                last && precedences.set(LAST_PRECEDENCE, last);
            }
            nodes = resource.instance;
            node = nodes.getAttribute("data-precedence");
            i = precedences.get(node) || last;
            i === last && precedences.set(LAST_PRECEDENCE, nodes);
            precedences.set(node, nodes);
            this.count++;
            last = onUnsuspend.bind(this);
            nodes.addEventListener("load", last);
            nodes.addEventListener("error", last);
            i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
            resource.state.loading |= Inserted;
        }
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.transitionTypes = null;
        this.incompleteTransitions = new Map();
        this.passiveEffectDuration = this.effectDuration = -0;
        this.memoizedUpdaters = new Set();
        containerInfo = this.pendingUpdatersLaneMap = [];
        for(tag = 0; 31 > tag; tag++)containerInfo.push(new Set());
        this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = ConcurrentMode;
        !0 === isStrictMode && (tag |= StrictLegacyMode | StrictEffectsMode);
        tag |= ProfileMode;
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        retainCache(tag);
        containerInfo.pooledCache = tag;
        retainCache(tag);
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot) try {
            injectedHook.onScheduleFiberRoot(rendererID, container, element);
        } catch (err) {
            hasLoggedError || (hasLoggedError = !0, console.error("React instrumentation encountered an error: %o", err));
        }
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        isRendering && null !== current && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = !0, console.error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown"));
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && ("function" !== typeof callback && console.error("Expected the last optional `callback` argument to be a function. Instead received: %s.", callback), container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane(fiber);
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var prevTransition = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        try {
            ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (_enabled) {
            var blockedOn = findInstanceBlockingEvent(nativeEvent);
            if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
            else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
            else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
                for(; null !== blockedOn;){
                    var fiber = getInstanceFromNode(blockedOn);
                    if (null !== fiber) switch(fiber.tag){
                        case 3:
                            fiber = fiber.stateNode;
                            if (fiber.current.memoizedState.isDehydrated) {
                                var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                                if (0 !== lanes) {
                                    var root = fiber;
                                    root.pendingLanes |= 2;
                                    for(root.entangledLanes |= 2; lanes;){
                                        var lane = 1 << 31 - clz32(lanes);
                                        root.entanglements[1] |= lane;
                                        lanes &= ~lane;
                                    }
                                    ensureRootIsScheduled(fiber);
                                    (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0, !1));
                                }
                            }
                            break;
                        case 31:
                        case 13:
                            root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                    }
                    fiber = findInstanceBlockingEvent(nativeEvent);
                    null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                    if (fiber === blockedOn) break;
                    blockedOn = fiber;
                }
                null !== blockedOn && nativeEvent.stopPropagation();
            } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
        }
    }
    function findInstanceBlockingEvent(nativeEvent) {
        nativeEvent = getEventTarget(nativeEvent);
        return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
        return_targetInst = null;
        targetNode = getClosestInstanceFromNode(targetNode);
        if (null !== targetNode) {
            var nearestMounted = getNearestMountedFiber(targetNode);
            if (null === nearestMounted) targetNode = null;
            else {
                var tag = nearestMounted.tag;
                if (13 === tag) {
                    targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (31 === tag) {
                    targetNode = getActivityInstanceFromFiber(nearestMounted);
                    if (null !== targetNode) return targetNode;
                    targetNode = null;
                } else if (3 === tag) {
                    if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    targetNode = null;
                } else nearestMounted !== targetNode && (targetNode = null);
            }
        }
        return_targetInst = targetNode;
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            case "beforetoggle":
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "seeked":
            case "submit":
            case "toggle":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "fullscreenerror":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "resize":
            case "scroll":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                switch(getCurrentPriorityLevel()){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority$1:
                    case LowPriority:
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                queuedPointers.delete(nativeEvent.pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                queuedPointerCaptures.delete(nativeEvent.pointerId);
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        blockedOn = existingQueuedEvent.targetContainers;
        null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        switch(domEventName){
            case "focusin":
                return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "dragenter":
                return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "mouseover":
                return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
            case "pointerover":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
                return !0;
            case "gotpointercapture":
                return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
        }
        return !1;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (null !== targetInst) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (null !== nearestMounted) {
                if (targetInst = nearestMounted.tag, 13 === targetInst) {
                    if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (31 === targetInst) {
                    if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                        queuedTarget.blockedOn = targetInst;
                        runWithPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                    queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                    return;
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (null !== queuedEvent.blockedOn) return !1;
        for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
            if (null === nextBlockedOn) {
                nextBlockedOn = queuedEvent.nativeEvent;
                var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn), event = nativeEventClone;
                null !== currentReplayingEvent && console.error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = event;
                nextBlockedOn.target.dispatchEvent(nativeEventClone);
                null === currentReplayingEvent && console.error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
                currentReplayingEvent = null;
            } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
            targetContainers.shift();
        }
        return !0;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = !1;
        null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
        null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
        null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
        lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
            lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
            for(var i = 0; i < formReplayingQueue.length; i += 3){
                var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
                if ("function" !== typeof submitterOrAction) {
                    if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                    else break;
                }
                var formInst = getInstanceFromNode(form);
                null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, form = {
                    pending: !0,
                    data: formData,
                    method: form.method,
                    action: submitterOrAction
                }, Object.freeze(form), startHostTransition(formInst, form, submitterOrAction, formData));
            }
        }));
    }
    function retryIfBlockedOn(unblocked) {
        function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        }
        null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
            var queuedTarget = queuedExplicitHydrationTargets[i];
            queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
        }
        for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
        i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
        if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
            var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
            if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
            else if (formProps) {
                var action = null;
                if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                    if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                    else {
                        if (null !== findInstanceBlockingTarget(form)) continue;
                    }
                } else action = formProps.action;
                "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
                scheduleReplayQueueIfNeeded(i);
            }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
        function handleNavigate(event) {
            event.canIntercept && "react-transition" === event.info && event.intercept({
                handler: function() {
                    return new Promise(function(resolve) {
                        return pendingResolve = resolve;
                    });
                },
                focusReset: "manual",
                scroll: "manual"
            });
        }
        function handleNavigateComplete() {
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            isCancelled || setTimeout(startFakeNavigation, 20);
        }
        function startFakeNavigation() {
            if (!isCancelled && !navigation.transition) {
                var currentEntry = navigation.currentEntry;
                currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                    state: currentEntry.getState(),
                    info: "react-transition",
                    history: "replace"
                });
            }
        }
        if ("object" === typeof navigation) {
            var isCancelled = !1, pendingResolve = null;
            navigation.addEventListener("navigate", handleNavigate);
            navigation.addEventListener("navigatesuccess", handleNavigateComplete);
            navigation.addEventListener("navigateerror", handleNavigateComplete);
            setTimeout(startFakeNavigation, 100);
            return function() {
                isCancelled = !0;
                navigation.removeEventListener("navigate", handleNavigate);
                navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
                navigation.removeEventListener("navigateerror", handleNavigateComplete);
                null !== pendingResolve && (pendingResolve(), pendingResolve = null);
            };
        }
    }
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
        container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : console.error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler = (parcelRequire("uSeK6")), React = (parcelRequire("spJKX")), ReactDOM = (parcelRequire("oS63j")), searchTarget = null, searchBoundary = null, assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
        pending: !1,
        data: null,
        method: null,
        action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = !0;
    var prefix, suffix, reentry = !1;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current = null, isRendering = !1, hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now$1 = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = !1, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, internalLoadPendingKey = "__reactLoad$" + randomKey, allNativeEvents = new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, viewTransitionMutationContext = !1, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = !1, didWarnCheckedDefaultChecked = !1, didWarnSelectedSetOnOption = !1, didWarnInvalidChild = !1, didWarnInvalidInnerHTML = !1;
    var didWarnValueDefaultValue = !1;
    var valuePropNames = [
        "value",
        "defaultValue"
    ], didWarnValDefaultVal = !1, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(" "), inScopeTags = "applet caption html table td th marquee object select template foreignObject desc title".split(" "), buttonScopeTags = inScopeTags.concat([
        "button"
    ]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null,
        containerTagInScope: null,
        implicitRootScope: !1
    }, didWarn = {}, shorthandToLonghand = {
        animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(" "),
        background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(" "),
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(" "),
        borderBlock: "borderBlockEndColor borderBlockEndStyle borderBlockEndWidth borderBlockStartColor borderBlockStartStyle borderBlockStartWidth".split(" "),
        borderBlockColor: [
            "borderBlockEndColor",
            "borderBlockStartColor"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBlockStyle: [
            "borderBlockEndStyle",
            "borderBlockStartStyle"
        ],
        borderBlockWidth: [
            "borderBlockEndWidth",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInline: "borderInlineEndColor borderInlineEndStyle borderInlineEndWidth borderInlineStartColor borderInlineStartStyle borderInlineStartWidth".split(" "),
        borderInlineColor: [
            "borderInlineEndColor",
            "borderInlineStartColor"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderInlineStyle: [
            "borderInlineEndStyle",
            "borderInlineStartStyle"
        ],
        borderInlineWidth: [
            "borderInlineEndWidth",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        colorAdjust: [
            "printColorAdjust"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        containIntrinsicSize: [
            "containIntrinsicHeight",
            "containIntrinsicWidth"
        ],
        container: [
            "containerName",
            "containerType"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(" "),
        fontSynthesis: [
            "fontSynthesisPosition",
            "fontSynthesisSmallCaps",
            "fontSynthesisStyle",
            "fontSynthesisWeight"
        ],
        fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(" "),
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(" "),
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        inset: [
            "bottom",
            "left",
            "right",
            "top"
        ],
        insetBlock: [
            "insetBlockEnd",
            "insetBlockStart"
        ],
        insetInline: [
            "insetInlineEnd",
            "insetInlineStart"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marginBlock: [
            "marginBlockEnd",
            "marginBlockStart"
        ],
        marginInline: [
            "marginInlineEnd",
            "marginInlineStart"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(" "),
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        offset: [
            "offsetAnchor",
            "offsetDistance",
            "offsetPath",
            "offsetPosition",
            "offsetRotate"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        overscrollBehavior: [
            "overscrollBehaviorX",
            "overscrollBehaviorY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        paddingBlock: [
            "paddingBlockEnd",
            "paddingBlockStart"
        ],
        paddingInline: [
            "paddingInlineEnd",
            "paddingInlineStart"
        ],
        pageBreakAfter: [
            "breakAfter"
        ],
        pageBreakBefore: [
            "breakBefore"
        ],
        pageBreakInside: [
            "breakInside"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        scrollMargin: [
            "scrollMarginBottom",
            "scrollMarginLeft",
            "scrollMarginRight",
            "scrollMarginTop"
        ],
        scrollMarginBlock: [
            "scrollMarginBlockEnd",
            "scrollMarginBlockStart"
        ],
        scrollMarginInline: [
            "scrollMarginInlineEnd",
            "scrollMarginInlineStart"
        ],
        scrollPadding: [
            "scrollPaddingBottom",
            "scrollPaddingLeft",
            "scrollPaddingRight",
            "scrollPaddingTop"
        ],
        scrollPaddingBlock: [
            "scrollPaddingBlockEnd",
            "scrollPaddingBlockStart"
        ],
        scrollPaddingInline: [
            "scrollPaddingInlineEnd",
            "scrollPaddingInlineStart"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle",
            "textDecorationThickness"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        textWrap: [
            "textWrapMode",
            "textWrapStyle"
        ],
        transition: [
            "transitionBehavior",
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        verticalAlign: [
            "alignmentBaseline",
            "baselineShift",
            "baselineSource"
        ],
        whiteSpace: [
            "textWrapMode",
            "whiteSpaceCollapse"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = !1, warnedForInfinityValue = !1, unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = new Map([
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ],
        [
            "crossOrigin",
            "crossorigin"
        ],
        [
            "accentHeight",
            "accent-height"
        ],
        [
            "alignmentBaseline",
            "alignment-baseline"
        ],
        [
            "arabicForm",
            "arabic-form"
        ],
        [
            "baselineShift",
            "baseline-shift"
        ],
        [
            "capHeight",
            "cap-height"
        ],
        [
            "clipPath",
            "clip-path"
        ],
        [
            "clipRule",
            "clip-rule"
        ],
        [
            "colorInterpolation",
            "color-interpolation"
        ],
        [
            "colorInterpolationFilters",
            "color-interpolation-filters"
        ],
        [
            "colorProfile",
            "color-profile"
        ],
        [
            "colorRendering",
            "color-rendering"
        ],
        [
            "dominantBaseline",
            "dominant-baseline"
        ],
        [
            "enableBackground",
            "enable-background"
        ],
        [
            "fillOpacity",
            "fill-opacity"
        ],
        [
            "fillRule",
            "fill-rule"
        ],
        [
            "floodColor",
            "flood-color"
        ],
        [
            "floodOpacity",
            "flood-opacity"
        ],
        [
            "fontFamily",
            "font-family"
        ],
        [
            "fontSize",
            "font-size"
        ],
        [
            "fontSizeAdjust",
            "font-size-adjust"
        ],
        [
            "fontStretch",
            "font-stretch"
        ],
        [
            "fontStyle",
            "font-style"
        ],
        [
            "fontVariant",
            "font-variant"
        ],
        [
            "fontWeight",
            "font-weight"
        ],
        [
            "glyphName",
            "glyph-name"
        ],
        [
            "glyphOrientationHorizontal",
            "glyph-orientation-horizontal"
        ],
        [
            "glyphOrientationVertical",
            "glyph-orientation-vertical"
        ],
        [
            "horizAdvX",
            "horiz-adv-x"
        ],
        [
            "horizOriginX",
            "horiz-origin-x"
        ],
        [
            "imageRendering",
            "image-rendering"
        ],
        [
            "letterSpacing",
            "letter-spacing"
        ],
        [
            "lightingColor",
            "lighting-color"
        ],
        [
            "markerEnd",
            "marker-end"
        ],
        [
            "markerMid",
            "marker-mid"
        ],
        [
            "markerStart",
            "marker-start"
        ],
        [
            "maskType",
            "mask-type"
        ],
        [
            "overlinePosition",
            "overline-position"
        ],
        [
            "overlineThickness",
            "overline-thickness"
        ],
        [
            "paintOrder",
            "paint-order"
        ],
        [
            "panose-1",
            "panose-1"
        ],
        [
            "pointerEvents",
            "pointer-events"
        ],
        [
            "renderingIntent",
            "rendering-intent"
        ],
        [
            "shapeRendering",
            "shape-rendering"
        ],
        [
            "stopColor",
            "stop-color"
        ],
        [
            "stopOpacity",
            "stop-opacity"
        ],
        [
            "strikethroughPosition",
            "strikethrough-position"
        ],
        [
            "strikethroughThickness",
            "strikethrough-thickness"
        ],
        [
            "strokeDasharray",
            "stroke-dasharray"
        ],
        [
            "strokeDashoffset",
            "stroke-dashoffset"
        ],
        [
            "strokeLinecap",
            "stroke-linecap"
        ],
        [
            "strokeLinejoin",
            "stroke-linejoin"
        ],
        [
            "strokeMiterlimit",
            "stroke-miterlimit"
        ],
        [
            "strokeOpacity",
            "stroke-opacity"
        ],
        [
            "strokeWidth",
            "stroke-width"
        ],
        [
            "textAnchor",
            "text-anchor"
        ],
        [
            "textDecoration",
            "text-decoration"
        ],
        [
            "textRendering",
            "text-rendering"
        ],
        [
            "transformOrigin",
            "transform-origin"
        ],
        [
            "underlinePosition",
            "underline-position"
        ],
        [
            "underlineThickness",
            "underline-thickness"
        ],
        [
            "unicodeBidi",
            "unicode-bidi"
        ],
        [
            "unicodeRange",
            "unicode-range"
        ],
        [
            "unitsPerEm",
            "units-per-em"
        ],
        [
            "vAlphabetic",
            "v-alphabetic"
        ],
        [
            "vHanging",
            "v-hanging"
        ],
        [
            "vIdeographic",
            "v-ideographic"
        ],
        [
            "vMathematical",
            "v-mathematical"
        ],
        [
            "vectorEffect",
            "vector-effect"
        ],
        [
            "vertAdvY",
            "vert-adv-y"
        ],
        [
            "vertOriginX",
            "vert-origin-x"
        ],
        [
            "vertOriginY",
            "vert-origin-y"
        ],
        [
            "wordSpacing",
            "word-spacing"
        ],
        [
            "writingMode",
            "writing-mode"
        ],
        [
            "xmlnsXlink",
            "xmlns:xlink"
        ],
        [
            "xHeight",
            "x-height"
        ]
    ]), possibleStandardNames = {
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        credentialless: "credentialless",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        fetchpriority: "fetchPriority",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        inert: "inert",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        masktype: "maskType",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        popover: "popover",
        popovertarget: "popoverTarget",
        popovertargetaction: "popoverTargetAction",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        transformorigin: "transformOrigin",
        "transform-origin": "transformOrigin",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    }, ariaProperties = {
        "aria-current": 0,
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        "aria-hidden": 0,
        "aria-invalid": 0,
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0,
        "aria-braillelabel": 0,
        "aria-brailleroledescription": 0,
        "aria-colindextext": 0,
        "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel$1 = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), didWarnValueNull = !1, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp("^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), rARIACamel = RegExp("^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = !1, canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
    if (canUseDOM) try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
            get: function() {
                passiveBrowserEventsSupported = !0;
            }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
    } catch (e) {
        passiveBrowserEventsSupported = !1;
    }
    var root = null, startText = null, fallbackText = null, EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
            return lastMovementX;
        },
        movementY: function(event) {
            return "movementY" in event ? event.movementY : lastMovementY;
        }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    }, translateToKey = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
    }, modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }, KeyboardEventInterface = assign({}, UIEventInterface, {
        key: function(nativeEvent) {
            if (nativeEvent.key) {
                var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
                if ("Unidentified" !== key) return key;
            }
            return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
        },
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        charCode: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : 0;
        },
        keyCode: function(event) {
            return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        },
        which: function(event) {
            return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
        }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), SubmitEventInterface = assign({}, EventInterface, {
        submitter: 0
    }), SyntheticSubmitEvent = createSyntheticEvent(SubmitEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
        newState: 0,
        oldState: 0,
        source: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
        9,
        13,
        27,
        32
    ], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
    canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = !1, isComposing = !1, supportedInputTypes = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = !1;
    canUseDOM && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is, skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1, vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionrun: makePrefixMap("Transition", "TransitionRun"),
        transitionstart: makePrefixMap("Transition", "TransitionStart"),
        transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    simpleEventPluginEvents.push("scrollEnd");
    var globalClientIdCounter$1 = 0, lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        var getCurrentTime = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        getCurrentTime = function() {
            return localDate.now();
        };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, OBJECT_WIDTH_LIMIT = 100, REMOVED = "-\u00a0", ADDED = "+\u00a0", UNCHANGED = "\u2007\u00a0", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components \u269b", LANES_TRACK_GROUP = "Scheduler \u269b", currentTrack = "Blocking", alreadyWarnedForDeepEquality = !1, reusableComponentDevToolDetails = {
        color: "primary",
        properties: null,
        tooltipText: "",
        track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
        start: -0,
        end: -0,
        detail: {
            devtools: reusableComponentDevToolDetails
        }
    }, reusableChangedPropsEntry = [
        "Changed Props",
        ""
    ], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = [
        "Changed Props",
        DEEP_EQUALITY_WARNING
    ], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = !1;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    } catch (e$4) {
        hasBadMapPolyfill = !0;
    }
    var CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, didSuspendOrErrorDEV = !1, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error("Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = !1, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0,
        _currentRenderer: null,
        _currentRenderer2: null
    }, entangledTransitionTypes = null, now = Scheduler.unstable_now, createTask = console.createTask ? console.createTask : function() {
        return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = !1, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = !1, nestedUpdateScheduled = !1, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now$1();
        if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
            if (0 > transitionStartTime && 0 > transitionUpdateTime) {
                transitionStartTime = now();
                var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
                if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType) transitionEventRepeatTime = -1.1;
                transitionEventTime = newEventTime;
                transitionEventType = newEventType;
            }
            entangleAsyncAction(transition, returnValue);
        }
        if (null !== entangledTransitionTypes) for(newEventTime = firstScheduledRoot; null !== newEventTime;)queueTransitionTypes(newEventTime, entangledTransitionTypes), newEventTime = newEventTime.next;
        newEventTime = transition.types;
        if (null !== newEventTime) {
            for(newEventType = firstScheduledRoot; null !== newEventType;)queueTransitionTypes(newEventType, newEventTime), newEventType = newEventType.next;
            if (0 !== currentEntangledLane) {
                newEventType = entangledTransitionTypes;
                null === newEventType && (newEventType = entangledTransitionTypes = []);
                for(var i = 0; i < newEventTime.length; i++){
                    var transitionType = newEventTime[i];
                    -1 === newEventType.indexOf(transitionType) && newEventType.push(transitionType);
                }
            }
        }
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function() {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function() {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && !0 !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && !0 !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && !0 !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        var componentWillMountUniqueNames = new Set();
        0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
            componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillMountWarnings = []);
        var UNSAFE_componentWillMountUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
            UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillMountWarnings = []);
        var componentWillReceivePropsUniqueNames = new Set();
        0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
            componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillReceivePropsWarnings = []);
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
            UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
        var componentWillUpdateUniqueNames = new Set();
        0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
            componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingComponentWillUpdateWarnings = []);
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
            UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutUnsafeLifecycles.add(fiber.type);
        }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
        if (0 < UNSAFE_componentWillMountUniqueNames.size) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            console.error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames), console.error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s", sortedNames));
        0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(UNSAFE_componentWillUpdateUniqueNames), console.error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn("componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(componentWillReceivePropsUniqueNames), console.warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
        0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn("componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", sortedNames));
    };
    var pendingLegacyContextWarning = new Map(), didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = null;
        for(var node = fiber; null !== node;)node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
        null === strictRoot ? console.error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.") : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray) {
            if (0 !== fiberArray.length) {
                var firstFiber = fiberArray[0], uniqueNames = new Set();
                fiberArray.forEach(function(fiber) {
                    uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                    didWarnAboutLegacyContext.add(fiber.type);
                });
                var sortedNames = setToSortedString(uniqueNames);
                runWithFiberInDEV(firstFiber, function() {
                    console.error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context", sortedNames);
                });
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var REACT_RECOVERABLE_DIGEST = "", callComponent = {
        react_stack_bottom_frame: function(Component, props, secondArg) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return Component(props, secondArg);
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
        react_stack_bottom_frame: function(instance) {
            var wasRendering = isRendering;
            isRendering = !0;
            try {
                return instance.render();
            } finally{
                isRendering = wasRendering;
            }
        }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
        react_stack_bottom_frame: function(finishedWork, instance) {
            try {
                instance.componentDidMount();
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(callComponentDidMount), callComponentDidUpdate = {
        react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
            try {
                instance.componentDidUpdate(prevProps, prevState, snapshot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(callComponentDidUpdate), callComponentDidCatch = {
        react_stack_bottom_frame: function(instance, errorInfo) {
            var stack = errorInfo.stack;
            instance.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(callComponentDidCatch), callComponentWillUnmount = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, instance) {
            try {
                instance.componentWillUnmount();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(callComponentWillUnmount), callCreate = {
        react_stack_bottom_frame: function(effect) {
            var create = effect.create;
            effect = effect.inst;
            create = create();
            return effect.destroy = create;
        }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
        react_stack_bottom_frame: function(current, nearestMountedAncestor, destroy) {
            try {
                destroy();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            }
        }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
        react_stack_bottom_frame: function(lazy) {
            var init = lazy._init;
            return init(lazy._payload);
        }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."), SuspenseyCommitException = Error("Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."), SuspenseActionException = Error("Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."), noopSuspenseyCommitThenable = {
        then: function() {
            console.error('Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.');
        }
    }, lastSuspendedFiber = null, lastSuspendedStack = null, didIssueUseWarning = !1, suspendedThenable = null, needsToResetSuspendedThenableDEV = !1, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = !1;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress, child) {
        if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
            if ("object" !== typeof child._store) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
            child._store.validated = 1;
            var componentName = getComponentNameFromFiber(returnFiber), componentKey = componentName || "null";
            if (!ownerHasKeyUseWarning[componentKey]) {
                ownerHasKeyUseWarning[componentKey] = !0;
                child = child._owner;
                returnFiber = returnFiber._debugOwner;
                var currentComponentErrorInfo = "";
                returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
                currentComponentErrorInfo || componentName && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName + ">.");
                var childOwnerAppendix = "";
                null != child && returnFiber !== child && (componentName = null, "number" === typeof child.tag ? componentName = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName = child.name), componentName && (childOwnerAppendix = " It was passed a child from " + componentName + "."));
                runWithFiberInDEV(workInProgress, function() {
                    console.error('Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.', currentComponentErrorInfo, childOwnerAppendix);
                });
            }
        }
    };
    var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = !1;
    var didWarnUpdateInsideUpdate = !1;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = new Set();
    var didWarnAboutUseWrappedInTryCatch = new Set();
    var didWarnAboutAsyncClientComponent = new Set();
    var didWarnAboutUseFormState = new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = !1, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError,
        useEffectEvent: throwInvalidHookError
    }, HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            mountHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return mountActionState(action, initialState);
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return mountEvent(callback);
        }
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        use: use,
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            updateHookTypesDev();
            warnOnUseFormStateInDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            mountEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        useFormState: function(action, initialState) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useActionState: function(action, initialState) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountActionState(action, initialState);
        },
        useOptimistic: function(passthrough) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOptimistic(passthrough);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            mountHookTypesDev();
            return mountRefresh();
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        use: function(usable) {
            warnInvalidHookAccess();
            return use(usable);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            updateEffectImpl(2048, Passive, create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Insertion, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffectImpl(4, Layout, create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useRef: function() {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useState: function() {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactSharedInternals.H;
            ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(basicStateReducer);
            } finally{
                ReactSharedInternals.H = prevDispatcher;
            }
        },
        useDebugValue: function() {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
        },
        useDeferredValue: function(value, initialValue) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value, initialValue);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useFormState: function(action) {
            currentHookNameInDev = "useFormState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useActionState: function(action) {
            currentHookNameInDev = "useActionState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderActionState(action);
        },
        useOptimistic: function(passthrough, reducer) {
            currentHookNameInDev = "useOptimistic";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOptimistic(passthrough, reducer);
        },
        useMemoCache: function(size) {
            warnInvalidHookAccess();
            return useMemoCache(size);
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useCacheRefresh: function() {
            currentHookNameInDev = "useCacheRefresh";
            updateHookTypesDev();
            return updateWorkInProgressHook().memoizedState;
        },
        useEffectEvent: function(callback) {
            currentHookNameInDev = "useEffectEvent";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEvent(callback);
        }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = new Set();
    var didWarnAboutUninitializedState = new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    var didWarnAboutDirectlyAssigningPropsToState = new Set();
    var didWarnAboutUndefinedDerivedState = new Set();
    var didWarnAboutContextTypes$1 = new Set();
    var didWarnAboutChildContextTypes = new Set();
    var didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ReplaceState;
            update.payload = payload;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(inst), update = createUpdate(lane);
            update.tag = ForceUpdate;
            void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error("This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."), didReceiveUpdate = !1;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = !1;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var didWarnAboutClassNameOnViewTransition = {};
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = !1, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var shouldStartViewTransition = !1, appearingViewTransitions = null, viewTransitionCancelableChildren = null, viewTransitionHostInstanceIdx = 0, mountedNamedViewTransitions = new Map(), didWarnAboutName = {}, NoLayoutEffectTraversalFlags = 0, IncludeWorkInProgressEffects = 1, IncludeHostSingletons = 2, offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, offscreenDirectParentIsHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, viewTransitionContextChanged = !1, inUpdateViewTransition = !1, rootViewTransitionAffected = !1, rootViewTransitionNameCanceled = !1, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, inHydratedSubtree = !1, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        },
        getOwner: function() {
            return current;
        }
    };
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        symbolFor("selector.component");
        symbolFor("selector.has_pseudo_class");
        symbolFor("selector.role");
        symbolFor("selector.test_id");
        symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingViewTransition = null, pendingViewTransitionEvents = null, pendingTransitionTypes = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = !1, didScheduleUpdateDuringPassiveEffects = !1, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = !1, didWarnAboutInterruptedViewTransitions = !1, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = !1;
    var didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, didScheduleMicrotask_act = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i], domEventName = eventName.toLowerCase();
            eventName = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + eventName);
        }
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
        registerSimpleEvent(TRANSITION_START, "onTransitionStart");
        registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onMouseLeave", [
        "mouseout",
        "mouseover"
    ]);
    registerDirectEvent("onPointerEnter", [
        "pointerout",
        "pointerover"
    ]);
    registerDirectEvent("onPointerLeave", [
        "pointerout",
        "pointerover"
    ]);
    registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
    registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
    registerTwoPhaseEvent("onBeforeInput", [
        "compositionend",
        "keypress",
        "textInput",
        "paste"
    ]);
    registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
    registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = !1, didWarnUncontrolledToControlled = !1, didWarnFormActionType = !1, didWarnFormActionName = !1, didWarnFormActionTarget = !1, didWarnFormActionMethod = !1, didWarnPopoverTargetObject = !1;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", emptyProps = {}, EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, didWarnScriptTags = !1, warnedUnknownTags = {
        dialog: !0,
        webview: !0
    }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : scheduleTimeout, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, SUSPENSEY_FONT_AND_IMAGE_TIMEOUT = 500;
    ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
        options = "number" === typeof options ? {
            duration: options
        } : assign({}, options);
        options.pseudoElement = this._selector;
        return this._scope.animate(keyframes, options);
    };
    ViewTransitionPseudoElement.prototype.getAnimations = function() {
        for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
            subtree: !0
        }), result = [], i = 0; i < animations.length; i++){
            var effect = animations[i].effect;
            null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
        }
        return result;
    };
    ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
        return getComputedStyle(this._scope, this._selector);
    };
    FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
        var signal = null, cleanup = null;
        if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
        null === this._eventListeners && (this._eventListeners = []);
        var listeners = this._eventListeners;
        if (-1 === indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
            var fragmentInstance = this, attachedListener = listener;
            null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
                fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
                "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
            });
            null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
                once: !0
            }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
            signal = getAttachOptions(optionsOrUseCapture);
            listeners.push({
                type: type,
                listener: listener,
                optionsOrUseCapture: optionsOrUseCapture,
                attachedListener: attachedListener,
                cleanup: cleanup
            });
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, addEventListenerToChild, type, attachedListener, signal);
        }
        this._eventListeners = listeners;
    };
    FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
        var listeners = this._eventListeners;
        if (null !== listeners && (listener = indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
            var _listeners$index = listeners[listener];
            optionsOrUseCapture = _listeners$index.attachedListener;
            var cleanup = _listeners$index.cleanup;
            _listeners$index = getAttachOptions(_listeners$index.optionsOrUseCapture);
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
            listeners.splice(listener, 1);
            null !== cleanup && cleanup();
        }
    };
    FragmentInstance.prototype.dispatchEvent = function(event) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        if (null === parentHostFiber) return !0;
        parentHostFiber = getInstanceFromHostFiber(parentHostFiber);
        var eventListeners = this._eventListeners;
        if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
            var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
            if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
                var _eventListeners$i = eventListeners[i];
                temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
            }
            parentHostFiber.appendChild(temp);
            event = temp.dispatchEvent(event);
            if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, getAttachOptions(_eventListeners$i.optionsOrUseCapture));
            parentHostFiber.removeChild(temp);
            return event;
        }
        return parentHostFiber.dispatchEvent(event);
    };
    FragmentInstance.prototype.focus = function(focusOptions) {
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
    };
    FragmentInstance.prototype.focusLast = function(focusOptions) {
        var children = [];
        traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, collectChildren, children, void 0, void 0);
        for(var i = children.length - 1; 0 <= i && !setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
    };
    FragmentInstance.prototype.blur = function() {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        null !== parentHostFiber && (parentHostFiber = getInstanceFromHostFiber(parentHostFiber), parentHostFiber = getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && traverseFragmentInstancesAndTextInstances(this._fragmentFiber, blurActiveElementWithinFragment, parentHostFiber));
    };
    FragmentInstance.prototype.observeUsing = function(observer) {
        var hasText = !1, hasElement = !1;
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, function(child) {
            if (6 === child.tag) hasText = !0;
            else return hasElement = !0;
            return !1;
        });
        hasText && !hasElement && console.error("observeUsing() was called on a FragmentInstance with only text children. Observers do not work on text nodes.");
        null === this._observers && (this._observers = new Set());
        this._observers.add(observer);
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, observeChild, observer);
    };
    FragmentInstance.prototype.unobserveUsing = function(observer) {
        var observers = this._observers;
        if (null !== observers && observers.has(observer)) {
            observers.delete(observer);
            traverseFragmentInstancesAndTextInstances(this._fragmentFiber, unobserveChild, observer);
            for(var i = observers = 0; i < pendingIntersectionUnobserves.length; i++){
                var pending = pendingIntersectionUnobserves[i];
                pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : pendingIntersectionUnobserves[observers++] = pending;
            }
            pendingIntersectionUnobserves.length = observers;
        } else console.error("You are calling unobserveUsing() with an observer that is not being observed with this fragment instance. First attach the observer with observeUsing()");
    };
    var pendingIntersectionUnobserves = [], intersectionUnobserveScheduled = !1;
    FragmentInstance.prototype.getClientRects = function() {
        var rects = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectClientRects, rects);
        return rects;
    };
    FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        return null === parentHostFiber ? this : getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
    };
    FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
        var parentHostFiber = getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
        if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
        var children = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectChildren, children);
        var parentHostInstance = getInstanceFromHostFiber(parentHostFiber);
        if (0 === children.length) {
            parentHostFiber = parentHostInstance;
            if (fiberIsPortaledIntoHost(this._fragmentFiber)) {
                a: {
                    for(children = this._fragmentFiber.return; null !== children;){
                        if (4 === children.tag) {
                            children = children.stateNode.containerInfo;
                            break a;
                        }
                        if (3 === children.tag || 5 === children.tag || 27 === children.tag) break;
                        children = children.return;
                    }
                    children = null;
                }
                null != children && (parentHostFiber = children);
            }
            children = this._fragmentFiber;
            var result = parentHostInstance = parentHostFiber.compareDocumentPosition(otherNode);
            parentHostFiber === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = getFragmentInstanceOrTextInstanceSiblings(children)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
            return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
        }
        parentHostFiber = getInstanceFromHostFiber(children[0]);
        result = getInstanceFromHostFiber(children[children.length - 1]);
        var parentHostInstanceFromDOM = fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
        if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
        parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
        parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
        var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
        lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
        parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
        return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    };
    FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
        if ("object" === typeof alignToTop) throw Error("FragmentInstance.scrollIntoView() does not support scrollIntoViewOptions. Use the alignToTop boolean instead.");
        var children = [];
        traverseFragmentInstancesAndTextInstances(this._fragmentFiber, collectChildren, children);
        var resolvedAlignToTop = !1 !== alignToTop;
        if (0 === children.length) {
            var hostSiblings = getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
            hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
            if (null === hostSiblings) return;
            if (6 === hostSiblings.tag) {
                alignToTop = getInstanceFromHostFiber(hostSiblings);
                scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
                return;
            }
            hostSiblings = getInstanceFromHostFiber(hostSiblings);
            if (9 !== hostSiblings.nodeType) {
                if (11 === hostSiblings.nodeType) {
                    resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                    null !== resolvedAlignToTop ? resolvedAlignToTop.scrollIntoView(alignToTop) : console.warn("You are attempting to scroll a FragmentInstance that is only mounted inside a detached DocumentFragment. No scroll was performed.");
                    return;
                }
                hostSiblings.scrollIntoView(alignToTop);
            }
        }
        for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
            var child = children[hostSiblings];
            6 === child.tag ? (child = getInstanceFromHostFiber(child), scrollTextNodeIntoView(child, resolvedAlignToTop)) : getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
            hostSiblings += resolvedAlignToTop ? -1 : 1;
        }
    };
    var previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = new Map(), preconnectsSet = new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
        f: function() {
            var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
            return previousWasRendering || wasRendering;
        },
        r: function(form) {
            var formInst = getInstanceFromNode(form);
            null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
        },
        D: function(href) {
            previousDispatcher.D(href);
            preconnectAs("dns-prefetch", href, null);
        },
        C: function(href, crossOrigin) {
            previousDispatcher.C(href, crossOrigin);
            preconnectAs("preconnect", href, crossOrigin);
        },
        L: function(href, as, options) {
            previousDispatcher.L(href, as, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href && as) {
                var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
                "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
                var key = preloadSelector;
                switch(as){
                    case "style":
                        key = getStyleKey(href);
                        break;
                    case "script":
                        key = getScriptKey(href);
                }
                if (!(preloadPropsMap.has(key) || (href = assign({
                    rel: "preload",
                    href: "image" === as && options && options.imageSrcSet ? void 0 : href,
                    as: as
                }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key))))) {
                    var instance = ownerDocument.createElement("link");
                    setInitialProperties(instance, "link", href);
                    "style" === as && (instance[internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                        clearPendingLoadOnNode(instance);
                    });
                    markNodeAsHoistable(instance);
                    ownerDocument.head.appendChild(instance);
                }
            }
        },
        m: function(href, options) {
            previousDispatcher.m(href, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
                switch(as){
                    case "audioworklet":
                    case "paintworklet":
                    case "serviceworker":
                    case "sharedworker":
                    case "worker":
                    case "script":
                        key = getScriptKey(href);
                }
                if (!preloadPropsMap.has(key) && (href = assign({
                    rel: "modulepreload",
                    href: href
                }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
                    switch(as){
                        case "audioworklet":
                        case "paintworklet":
                        case "serviceworker":
                        case "sharedworker":
                        case "worker":
                        case "script":
                            if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
                    }
                    as = ownerDocument.createElement("link");
                    setInitialProperties(as, "link", href);
                    markNodeAsHoistable(as);
                    ownerDocument.head.appendChild(as);
                }
            }
        },
        X: function(src, options) {
            previousDispatcher.X(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        },
        S: function(href, precedence, options) {
            previousDispatcher.S(href, precedence, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && href) {
                var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
                precedence = precedence || "default";
                var resource = styles.get(key);
                if (!resource) {
                    var state = {
                        loading: NotLoaded,
                        preload: null
                    };
                    if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = Loaded | Inserted;
                    else {
                        href = assign({
                            rel: "stylesheet",
                            href: href,
                            "data-precedence": precedence
                        }, options);
                        (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                        var link = resource = ownerDocument.createElement("link");
                        markNodeAsHoistable(link);
                        setInitialProperties(link, "link", href);
                        link._p = new Promise(function(resolve, reject) {
                            link.onload = resolve;
                            link.onerror = reject;
                        });
                        link.addEventListener("load", function() {
                            state.loading |= Loaded;
                        });
                        link.addEventListener("error", function() {
                            state.loading |= Errored;
                        });
                        state.loading |= Inserted;
                        insertStylesheet(resource, precedence, ownerDocument);
                    }
                    resource = {
                        type: "stylesheet",
                        instance: resource,
                        count: 1,
                        state: state
                    };
                    styles.set(key, resource);
                }
            }
        },
        M: function(src, options) {
            previousDispatcher.M(src, options);
            var ownerDocument = globalDocument;
            if (ownerDocument && src) {
                var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
                resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
                    src: src,
                    async: !0,
                    type: "module"
                }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
                    type: "script",
                    instance: resource,
                    count: 1,
                    state: null
                }, scripts.set(key, resource));
            }
        }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Provider: null,
        Consumer: null,
        _currentValue: NotPendingTransition,
        _currentValue2: NotPendingTransition,
        _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = !1;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id, path, value) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithSetImpl(id.memoizedState, path, 0, value), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        id = findHook(fiber, id);
        null !== id && (path = copyWithDeleteImpl(id.memoizedState, path, 0), id.memoizedState = path, id.baseState = path, fiber.memoizedProps = assign({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        id = findHook(fiber, id);
        null !== id && (oldPath = copyWithRename(id.memoizedState, oldPath, newPath), id.memoizedState = oldPath, id.baseState = oldPath, fiber.memoizedProps = assign({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        path = enqueueConcurrentRenderForLane(fiber, 2);
        null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
        oldPath = enqueueConcurrentRenderForLane(fiber, 2);
        null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    };
    scheduleRetry = function(fiber) {
        var lane = claimNextRetryLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = !0, return_targetInst = null, hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" "), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (null === root) throw Error("Cannot update an unmounted root.");
        var args = arguments;
        "function" === typeof args[1] ? console.error("does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : isValidContainer(args[1]) ? console.error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : "undefined" !== typeof args[1] && console.error("You passed a second argument to root.render(...) but it only accepts one argument.");
        args = children;
        var current = root.current, lane = requestUpdateLane(current);
        updateContainerImpl(current, lane, args, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        var args = arguments;
        "function" === typeof args[0] && console.error("does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        args = this._internalRoot;
        if (null !== args) {
            this._internalRoot = null;
            var container = args.containerInfo;
            (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            updateContainerImpl(args.current, 2, null, args, null, null);
            flushSyncWork$1();
            container[internalContainerInstanceKey] = null;
        }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
        if (target) {
            var updatePriority = resolveUpdatePriority();
            target = {
                blockedOn: null,
                target: target,
                priority: updatePriority
            };
            for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
            queuedExplicitHydrationTargets.splice(i, 0, target);
            0 === i && attemptExplicitHydrationTarget(target);
        }
    };
    (function() {
        var isomorphicReactPackageVersion = React.version;
        if ("19.3.1" !== isomorphicReactPackageVersion) throw Error('Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.3.1\nLearn more: https://react.dev/warnings/version-mismatch"));
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills");
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
        var fiber = componentOrElement._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof componentOrElement.render) throw Error("Unable to find node on an unmounted component.");
            componentOrElement = Object.keys(componentOrElement).join(",");
            throw Error("Argument appears to not be a ReactComponent. Keys: " + componentOrElement);
        }
        componentOrElement = findCurrentFiberUsingSlowPath(fiber);
        componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
        componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
        return componentOrElement;
    };
    if (!function() {
        var internals = {
            bundleType: 1,
            version: "19.3.1",
            rendererPackageName: "react-dom",
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.3.1"
        };
        internals.overrideHookState = overrideHookState;
        internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
        internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
        internals.overrideProps = overrideProps;
        internals.overridePropsDeletePath = overridePropsDeletePath;
        internals.overridePropsRenamePath = overridePropsRenamePath;
        internals.scheduleUpdate = scheduleUpdate;
        internals.scheduleRetry = scheduleRetry;
        internals.setErrorHandler = setErrorHandler;
        internals.setSuspenseHandler = setSuspenseHandler;
        internals.scheduleRefresh = scheduleRefresh;
        internals.scheduleRoot = scheduleRoot;
        internals.setRefreshHandler = setRefreshHandler;
        internals.getCurrentFiber = getCurrentFiberForDevTools;
        return injectInternals(internals);
    }() && canUseDOM && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
        var protocol = window.location.protocol;
        /^(https?|file):$/.test(protocol) && console.info("%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""), "font-weight:bold");
    }
    $6b313d64cfcdc558$export$882461b6382ed46c = function(container, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
        null !== options && void 0 !== options && (options.hydrate ? console.warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : "object" === typeof options && null !== options && options.$$typeof === REACT_ELEMENT_TYPE && console.error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"), !0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
        options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        container[internalContainerInstanceKey] = options.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMRoot(options);
    };
    $6b313d64cfcdc558$export$757ceba2d55c277e = function(container, initialChildren, options) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        void 0 === initialChildren && console.error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
        null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
        initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        options = initialChildren.current;
        isStrictMode = requestUpdateLane(options);
        isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
        identifierPrefix = createUpdate(isStrictMode);
        identifierPrefix.callback = null;
        enqueueUpdate(options, identifierPrefix, isStrictMode);
        startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
        options = isStrictMode;
        initialChildren.current.lanes = options;
        markRootUpdated$1(initialChildren, options);
        ensureRootIsScheduled(initialChildren);
        container[internalContainerInstanceKey] = initialChildren.current;
        listenToAllSupportedEvents(container);
        return new ReactDOMHydrationRoot(initialChildren);
    };
    $6b313d64cfcdc558$export$83d89fbfd8236492 = "19.3.1";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});
parcelRegister("uSeK6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cAkzM"));

});
parcelRegister("cAkzM", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9298cecc3361f664$export$c4744153514ff05d; }, function (v) { return $9298cecc3361f664$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9298cecc3361f664$export$3e506c1ccc9cc1a7; }, function (v) { return $9298cecc3361f664$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9298cecc3361f664$export$e26fe2ed2fa76875; }, function (v) { return $9298cecc3361f664$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9298cecc3361f664$export$502329bbf4b505b1; }, function (v) { return $9298cecc3361f664$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9298cecc3361f664$export$6e3807111c4874c4; }, function (v) { return $9298cecc3361f664$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9298cecc3361f664$export$c27134553091fb3a; }, function (v) { return $9298cecc3361f664$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9298cecc3361f664$export$33ee1acdc04fd2a2; }, function (v) { return $9298cecc3361f664$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9298cecc3361f664$export$b00a404bbd5edef2; }, function (v) { return $9298cecc3361f664$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9298cecc3361f664$export$d66a1c1c77bd778b; }, function (v) { return $9298cecc3361f664$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9298cecc3361f664$export$d3dfb8e4810cb555; }, function (v) { return $9298cecc3361f664$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9298cecc3361f664$export$72fdf0e06517287b; }, function (v) { return $9298cecc3361f664$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9298cecc3361f664$export$816d2913ae6b83b1; }, function (v) { return $9298cecc3361f664$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9298cecc3361f664$export$61bcfe829111a1d0; }, function (v) { return $9298cecc3361f664$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9298cecc3361f664$export$7ee8c9beb337bc3f; }, function (v) { return $9298cecc3361f664$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9298cecc3361f664$export$b5836b71941fa3ed; }, function (v) { return $9298cecc3361f664$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9298cecc3361f664$export$cf845f2c119da08a; }, function (v) { return $9298cecc3361f664$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9298cecc3361f664$export$c4744153514ff05d;
var $9298cecc3361f664$export$3e506c1ccc9cc1a7;
var $9298cecc3361f664$export$e26fe2ed2fa76875;
var $9298cecc3361f664$export$502329bbf4b505b1;
var $9298cecc3361f664$export$6e3807111c4874c4;
var $9298cecc3361f664$export$c27134553091fb3a;
var $9298cecc3361f664$export$33ee1acdc04fd2a2;
var $9298cecc3361f664$export$b00a404bbd5edef2;
var $9298cecc3361f664$export$d66a1c1c77bd778b;
var $9298cecc3361f664$export$d3dfb8e4810cb555;
var $9298cecc3361f664$export$72fdf0e06517287b;
var $9298cecc3361f664$export$816d2913ae6b83b1;
var $9298cecc3361f664$export$61bcfe829111a1d0;
var $9298cecc3361f664$export$7ee8c9beb337bc3f;
var $9298cecc3361f664$export$b5836b71941fa3ed;
var $9298cecc3361f664$export$cf845f2c119da08a;
"use strict";
(function() {
    function performWorkUntilDeadline() {
        needsPaint = !1;
        if (isMessageLoopRunning) {
            var currentTime = $9298cecc3361f664$export$c4744153514ff05d();
            startTime = currentTime;
            var hasMoreWork = !0;
            try {
                a: {
                    isHostCallbackScheduled = !1;
                    isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                    isPerformingWork = !0;
                    var previousPriorityLevel = currentPriorityLevel;
                    try {
                        b: {
                            advanceTimers(currentTime);
                            for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                                var callback = currentTask.callback;
                                if ("function" === typeof callback) {
                                    currentTask.callback = null;
                                    currentPriorityLevel = currentTask.priorityLevel;
                                    var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                    currentTime = $9298cecc3361f664$export$c4744153514ff05d();
                                    if ("function" === typeof continuationCallback) {
                                        currentTask.callback = continuationCallback;
                                        advanceTimers(currentTime);
                                        hasMoreWork = !0;
                                        break b;
                                    }
                                    currentTask === peek(taskQueue) && pop(taskQueue);
                                    advanceTimers(currentTime);
                                } else pop(taskQueue);
                                currentTask = peek(taskQueue);
                            }
                            if (null !== currentTask) hasMoreWork = !0;
                            else {
                                var firstTimer = peek(timerQueue);
                                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                                hasMoreWork = !1;
                            }
                        }
                        break a;
                    } finally{
                        currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                    }
                    hasMoreWork = void 0;
                }
            } finally{
                hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
            }
        }
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        a: for(; 0 < index;){
            var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
            if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
            else break a;
        }
    }
    function peek(heap) {
        return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
        if (0 === heap.length) return null;
        var first = heap[0], last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
                var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
                if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
                else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
                else break a;
            }
        }
        return first;
    }
    function compare(a, b) {
        var diff = a.sortIndex - b.sortIndex;
        return 0 !== diff ? diff : a.id - b.id;
    }
    function advanceTimers(currentTime) {
        for(var timer = peek(timerQueue); null !== timer;){
            if (null === timer.callback) pop(timerQueue);
            else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
            else break;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = !1;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
            else {
                var firstTimer = peek(timerQueue);
                null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function shouldYieldToHost() {
        return needsPaint ? !0 : $9298cecc3361f664$export$c4744153514ff05d() - startTime < frameInterval ? !1 : !0;
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($9298cecc3361f664$export$c4744153514ff05d());
        }, ms);
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    $9298cecc3361f664$export$c4744153514ff05d = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        $9298cecc3361f664$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date, initialTime = localDate.now();
        $9298cecc3361f664$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    if ("function" === typeof localSetImmediate) var schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    $9298cecc3361f664$export$3e506c1ccc9cc1a7 = 5;
    $9298cecc3361f664$export$e26fe2ed2fa76875 = 1;
    $9298cecc3361f664$export$502329bbf4b505b1 = 4;
    $9298cecc3361f664$export$6e3807111c4874c4 = 3;
    $9298cecc3361f664$export$c27134553091fb3a = null;
    $9298cecc3361f664$export$33ee1acdc04fd2a2 = 2;
    $9298cecc3361f664$export$b00a404bbd5edef2 = function(task) {
        task.callback = null;
    };
    $9298cecc3361f664$export$d66a1c1c77bd778b = function(fps) {
        0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    $9298cecc3361f664$export$d3dfb8e4810cb555 = function() {
        return currentPriorityLevel;
    };
    $9298cecc3361f664$export$72fdf0e06517287b = function(eventHandler) {
        switch(currentPriorityLevel){
            case 1:
            case 2:
            case 3:
                var priorityLevel = 3;
                break;
            default:
                priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $9298cecc3361f664$export$816d2913ae6b83b1 = function() {
        needsPaint = !0;
    };
    $9298cecc3361f664$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            default:
                priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
    $9298cecc3361f664$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
        var currentTime = $9298cecc3361f664$export$c4744153514ff05d();
        "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
        switch(priorityLevel){
            case 1:
                var timeout = -1;
                break;
            case 2:
                timeout = 250;
                break;
            case 5:
                timeout = 1073741823;
                break;
            case 4:
                timeout = 1e4;
                break;
            default:
                timeout = 5e3;
        }
        timeout = options + timeout;
        priorityLevel = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: options,
            expirationTime: timeout,
            sortIndex: -1
        };
        options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
    };
    $9298cecc3361f664$export$b5836b71941fa3ed = shouldYieldToHost;
    $9298cecc3361f664$export$cf845f2c119da08a = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});


parcelRegister("oS63j", function(module, exports) {
'use strict';
function $04ac3477c194749e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

module.exports = (parcelRequire("cOjTy"));

});
parcelRegister("cOjTy", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $9539964fb4cbf074$export$69ce8ef3fe5cead0; }, function (v) { return $9539964fb4cbf074$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "browser", function () { return $9539964fb4cbf074$export$3f2684e5d7cb1006; }, function (v) { return $9539964fb4cbf074$export$3f2684e5d7cb1006 = v; });
$parcel$export(module.exports, "createPortal", function () { return $9539964fb4cbf074$export$d39a5bbd09211389; }, function (v) { return $9539964fb4cbf074$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $9539964fb4cbf074$export$cd75ccfd720a3cd4; }, function (v) { return $9539964fb4cbf074$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $9539964fb4cbf074$export$a0816fa17a9e79be; }, function (v) { return $9539964fb4cbf074$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $9539964fb4cbf074$export$7292efcadded39f3; }, function (v) { return $9539964fb4cbf074$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $9539964fb4cbf074$export$da407abadb9b8f86; }, function (v) { return $9539964fb4cbf074$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $9539964fb4cbf074$export$314cfea32580671c; }, function (v) { return $9539964fb4cbf074$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $9539964fb4cbf074$export$513ccb98c53b8039; }, function (v) { return $9539964fb4cbf074$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $9539964fb4cbf074$export$dbca993bc2d264a; }, function (v) { return $9539964fb4cbf074$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $9539964fb4cbf074$export$4797a8006f0655d0; }, function (v) { return $9539964fb4cbf074$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $9539964fb4cbf074$export$c78a37762a8d58e1; }, function (v) { return $9539964fb4cbf074$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $9539964fb4cbf074$export$606f11b2eb45ecc6; }, function (v) { return $9539964fb4cbf074$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $9539964fb4cbf074$export$f7e8a0bf92324b1e; }, function (v) { return $9539964fb4cbf074$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $9539964fb4cbf074$export$83d89fbfd8236492; }, function (v) { return $9539964fb4cbf074$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9539964fb4cbf074$export$69ce8ef3fe5cead0;
var $9539964fb4cbf074$export$3f2684e5d7cb1006;
var $9539964fb4cbf074$export$d39a5bbd09211389;
var $9539964fb4cbf074$export$cd75ccfd720a3cd4;
var $9539964fb4cbf074$export$a0816fa17a9e79be;
var $9539964fb4cbf074$export$7292efcadded39f3;
var $9539964fb4cbf074$export$da407abadb9b8f86;
var $9539964fb4cbf074$export$314cfea32580671c;
var $9539964fb4cbf074$export$513ccb98c53b8039;
var $9539964fb4cbf074$export$dbca993bc2d264a;
var $9539964fb4cbf074$export$4797a8006f0655d0;
var $9539964fb4cbf074$export$c78a37762a8d58e1;
var $9539964fb4cbf074$export$606f11b2eb45ecc6;
var $9539964fb4cbf074$export$f7e8a0bf92324b1e;
var $9539964fb4cbf074$export$83d89fbfd8236492;
"use strict";

(function() {
    function noop() {}
    function testStringCoercion(value) {
        return "" + value;
    }
    function createPortal$1(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        if (null == key) key = null;
        else if (key === REACT_OPTIMISTIC_KEY) key = REACT_OPTIMISTIC_KEY;
        else {
            try {
                testStringCoercion(key);
                var JSCompiler_inline_result = !1;
            } catch (e) {
                JSCompiler_inline_result = !0;
            }
            JSCompiler_inline_result && (console.error("The provided key is an unsupported type %s. This value must be coerced to a string before using it here.", "function" === typeof Symbol && Symbol.toStringTag && key[Symbol.toStringTag] || key.constructor.name || "Object"), testStringCoercion(key));
            key = "" + key;
        }
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    function getCrossOriginStringAs(as, input) {
        if ("font" === as) return "";
        if ("string" === typeof input) return "use-credentials" === input ? input : "";
    }
    function getValueDescriptorExpectingObjectForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : 'something with type "' + typeof thing + '"';
    }
    function getValueDescriptorExpectingEnumForWarning(thing) {
        return null === thing ? "`null`" : void 0 === thing ? "`undefined`" : "" === thing ? "an empty string" : "string" === typeof thing ? JSON.stringify(thing) : "number" === typeof thing ? "`" + thing + "`" : 'something with type "' + typeof thing + '"';
    }
    function resolveDispatcher() {
        var dispatcher = ReactSharedInternals.H;
        null === dispatcher && console.error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = (parcelRequire("spJKX")), Internals = {
        d: {
            f: noop,
            r: function() {
                throw Error("Invalid form element. requestFormReset must be passed a form that was rendered by React.");
            },
            D: noop,
            C: noop,
            L: noop,
            m: noop,
            X: noop,
            S: noop,
            M: noop
        },
        p: 0,
        findDOMNode: null
    }, REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    $9539964fb4cbf074$export$69ce8ef3fe5cead0 = Internals;
    $9539964fb4cbf074$export$3f2684e5d7cb1006 = function(reason) {
        return {
            $$typeof: REACT_RECOVERABLE_TYPE,
            _reason: reason
        };
    };
    $9539964fb4cbf074$export$d39a5bbd09211389 = function(children, container) {
        var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
        if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error("Target container is not a DOM element.");
        return createPortal$1(children, container, null, key);
    };
    $9539964fb4cbf074$export$cd75ccfd720a3cd4 = function(fn) {
        var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
        try {
            if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
        } finally{
            ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f() && console.error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        }
    };
    $9539964fb4cbf074$export$a0816fa17a9e79be = function(href, options) {
        "string" === typeof href && href ? null != options && "object" !== typeof options ? console.error("ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.", getValueDescriptorExpectingEnumForWarning(options)) : null != options && "string" !== typeof options.crossOrigin && console.error("ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.", getValueDescriptorExpectingObjectForWarning(options.crossOrigin)) : console.error("ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
    };
    $9539964fb4cbf074$export$7292efcadded39f3 = function(href) {
        if ("string" !== typeof href || !href) console.error("ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        else if (1 < arguments.length) {
            var options = arguments[1];
            "object" === typeof options && options.hasOwnProperty("crossOrigin") ? console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options)) : console.error("ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.", getValueDescriptorExpectingEnumForWarning(options));
        }
        "string" === typeof href && Internals.d.D(href);
    };
    $9539964fb4cbf074$export$da407abadb9b8f86 = function(href, options) {
        "string" === typeof href && href ? null == options || "object" !== typeof options ? console.error("ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.", getValueDescriptorExpectingEnumForWarning(options)) : "style" !== options.as && "script" !== options.as && console.error('ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".', getValueDescriptorExpectingEnumForWarning(options.as)) : console.error("ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.", getValueDescriptorExpectingObjectForWarning(href));
        if ("string" === typeof href && options && "string" === typeof options.as) {
            var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
            "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority
            }) : "script" === as && Internals.d.X(href, {
                crossOrigin: crossOrigin,
                integrity: integrity,
                fetchPriority: fetchPriority,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0
            });
        }
    };
    $9539964fb4cbf074$export$314cfea32580671c = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "script" !== options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingEnumForWarning(options.as) + ".");
        if (encountered) console.error("ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s", encountered);
        else switch(encountered = options && "string" === typeof options.as ? options.as : "script", encountered){
            case "script":
                break;
            default:
                encountered = getValueDescriptorExpectingEnumForWarning(encountered), console.error('ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)', encountered, href);
        }
        if ("string" === typeof href) {
            if ("object" === typeof options && null !== options) {
                if (null == options.as || "script" === options.as) encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.M(href, {
                    crossOrigin: encountered,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            } else null == options && Internals.d.M(href);
        }
    };
    $9539964fb4cbf074$export$513ccb98c53b8039 = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        null == options || "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : "string" === typeof options.as && options.as || (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s', encountered);
        if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
            encountered = options.as;
            var crossOrigin = getCrossOriginStringAs(encountered, options.crossOrigin);
            Internals.d.L(href, encountered, {
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                type: "string" === typeof options.type ? options.type : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
                referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
                imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
                imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
                media: "string" === typeof options.media ? options.media : void 0
            });
        }
    };
    $9539964fb4cbf074$export$dbca993bc2d264a = function(href, options) {
        var encountered = "";
        "string" === typeof href && href || (encountered += " The `href` argument encountered was " + getValueDescriptorExpectingObjectForWarning(href) + ".");
        void 0 !== options && "object" !== typeof options ? encountered += " The `options` argument encountered was " + getValueDescriptorExpectingObjectForWarning(options) + "." : options && "as" in options && "string" !== typeof options.as && (encountered += " The `as` option encountered was " + getValueDescriptorExpectingObjectForWarning(options.as) + ".");
        encountered && console.error('ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s', encountered);
        "string" === typeof href && (options ? (encountered = getCrossOriginStringAs(options.as, options.crossOrigin), Internals.d.m(href, {
            as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
            crossOrigin: encountered,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
        })) : Internals.d.m(href));
    };
    $9539964fb4cbf074$export$4797a8006f0655d0 = function(form) {
        Internals.d.r(form);
    };
    $9539964fb4cbf074$export$c78a37762a8d58e1 = function(fn, a) {
        return fn(a);
    };
    $9539964fb4cbf074$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
        return resolveDispatcher().useFormState(action, initialState, permalink);
    };
    $9539964fb4cbf074$export$f7e8a0bf92324b1e = function() {
        return resolveDispatcher().useHostTransitionStatus();
    };
    $9539964fb4cbf074$export$83d89fbfd8236492 = "19.3.1";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

});



parcelRegister("4Q81F", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_RELATIVE_URL_REGEX", function () { return $073772d363daddd9$export$825a82322d91916e; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $073772d363daddd9$export$719fc203c4e16dee; });
$parcel$export(module.exports, "invariant", function () { return $073772d363daddd9$export$f5708dca728d7177; });
$parcel$export(module.exports, "createContext", function () { return $073772d363daddd9$export$fd42f52fd3ae1109; });
$parcel$export(module.exports, "RouterContextProvider", function () { return $073772d363daddd9$export$b8d3e69d4b3eff04; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return $073772d363daddd9$export$87cb1a9238dc3fba; });
$parcel$export(module.exports, "matchRoutes", function () { return $073772d363daddd9$export$2708184779ceb39d; });
$parcel$export(module.exports, "matchRoutesImpl", function () { return $073772d363daddd9$export$5c7b09132f833c25; });
$parcel$export(module.exports, "stripBasename", function () { return $073772d363daddd9$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "resolvePath", function () { return $073772d363daddd9$export$b09f2ff0bbcb43c7; });
$parcel$export(module.exports, "redirect", function () { return $073772d363daddd9$export$89e12c5b50f7529d; });
$parcel$export(module.exports, "redirectDocument", function () { return $073772d363daddd9$export$a6cd19cd1951a23c; });
$parcel$export(module.exports, "replace", function () { return $073772d363daddd9$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return $073772d363daddd9$export$f2680fa305b734ca; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $073772d363daddd9$export$972111febbeef05b; });
$parcel$export(module.exports, "instrumentHandler", function () { return $073772d363daddd9$export$8f7a8e481272777; });
$parcel$export(module.exports, "validateNavigationTarget", function () { return $073772d363daddd9$export$6c8e41f66e7aa990; });
$parcel$export(module.exports, "createRouter", function () { return $073772d363daddd9$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "isMutationMethod", function () { return $073772d363daddd9$export$cbae47800eb95bc3; });
$parcel$export(module.exports, "createStaticHandler", function () { return $073772d363daddd9$export$3336b097a6fbc59a; });
$parcel$export(module.exports, "isResponse", function () { return $073772d363daddd9$export$3f1eb41d9a6a6a27; });
$parcel$export(module.exports, "isRedirectResponse", function () { return $073772d363daddd9$export$6e80290866a84dd4; });
$parcel$export(module.exports, "isDataWithResponseInit", function () { return $073772d363daddd9$export$e0163cfdf7bc9cfa; });
$parcel$export(module.exports, "getStaticContextFromError", function () { return $073772d363daddd9$export$fec11da027c70692; });
$parcel$export(module.exports, "hasInvalidProtocol", function () { return $073772d363daddd9$export$961a3ef7a4da3a39; });
$parcel$export(module.exports, "isRedirectStatusCode", function () { return $073772d363daddd9$export$794b2760043cf8cd; });
$parcel$export(module.exports, "RSCRouterContext", function () { return $073772d363daddd9$export$717f757c655223f1; });
$parcel$export(module.exports, "ENABLE_DEV_WARNINGS", function () { return $073772d363daddd9$export$945fecf35a8ef089; });
$parcel$export(module.exports, "decodeRedirectErrorDigest", function () { return $073772d363daddd9$export$30db792b333fd2ee; });
$parcel$export(module.exports, "decodeRouteErrorResponseDigest", function () { return $073772d363daddd9$export$2b5950305b3e7eaf; });
$parcel$export(module.exports, "useLocation", function () { return $073772d363daddd9$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $073772d363daddd9$export$9770f232ac06a008; });
$parcel$export(module.exports, "useParams", function () { return $073772d363daddd9$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useRouteError", function () { return $073772d363daddd9$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "useNavigation", function () { return $073772d363daddd9$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useRevalidator", function () { return $073772d363daddd9$export$600dc272ed516c15; });
$parcel$export(module.exports, "useLoaderData", function () { return $073772d363daddd9$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useBlocker", function () { return $073772d363daddd9$export$b273b3273281a049; });
$parcel$export(module.exports, "warnOnce", function () { return $073772d363daddd9$export$5b28268982f175ba; });
$parcel$export(module.exports, "mapRouteProperties", function () { return $073772d363daddd9$export$9269a41d8c4635e; });
$parcel$export(module.exports, "hydrationRouteProperties", function () { return $073772d363daddd9$export$e2fd2c03906469db; });
$parcel$export(module.exports, "createMemoryRouter", function () { return $073772d363daddd9$export$f30f7e456d254e83; });
$parcel$export(module.exports, "RouterProvider", function () { return $073772d363daddd9$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Outlet", function () { return $073772d363daddd9$export$910ae8079b2c2852; });
$parcel$export(module.exports, "withComponentProps", function () { return $073772d363daddd9$export$1a5de91a5c3255e0; });
$parcel$export(module.exports, "withHydrateFallbackProps", function () { return $073772d363daddd9$export$cd4a5850c74ba029; });
$parcel$export(module.exports, "withErrorBoundaryProps", function () { return $073772d363daddd9$export$26aea97ad016e70c; });
$parcel$export(module.exports, "encode", function () { return $073772d363daddd9$export$c564cdbbe6da493; });
$parcel$export(module.exports, "createRequestInit", function () { return $073772d363daddd9$export$a30aa2a0fce6c468; });
$parcel$export(module.exports, "escapeHtml", function () { return $073772d363daddd9$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeAttribute", function () { return $073772d363daddd9$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "SingleFetchRedirectSymbol", function () { return $073772d363daddd9$export$60644022b8b46aaa; });
$parcel$export(module.exports, "SINGLE_FETCH_REDIRECT_STATUS", function () { return $073772d363daddd9$export$ae9272e641ead836; });
$parcel$export(module.exports, "NO_BODY_STATUS_CODES", function () { return $073772d363daddd9$export$e35ccdcde387134d; });
$parcel$export(module.exports, "StreamTransfer", function () { return $073772d363daddd9$export$2b0b5f24fd77a79f; });
$parcel$export(module.exports, "getTurboStreamSingleFetchDataStrategy", function () { return $073772d363daddd9$export$77d7799427e365da; });
$parcel$export(module.exports, "getSingleFetchDataStrategyImpl", function () { return $073772d363daddd9$export$7144ac7f1a8613d3; });
$parcel$export(module.exports, "stripIndexParam", function () { return $073772d363daddd9$export$425969b7f98e2c9c; });
$parcel$export(module.exports, "singleFetchUrl", function () { return $073772d363daddd9$export$7b977381851b2c; });
$parcel$export(module.exports, "decodeViaTurboStream", function () { return $073772d363daddd9$export$4023ad4ecd4126a2; });
$parcel$export(module.exports, "createServerRoutes", function () { return $073772d363daddd9$export$5be2318464878170; });
$parcel$export(module.exports, "createClientRoutesWithHMRRevalidationOptOut", function () { return $073772d363daddd9$export$49d9dc160d22054c; });
$parcel$export(module.exports, "createClientRoutes", function () { return $073772d363daddd9$export$af76e85f27ba0229; });
$parcel$export(module.exports, "noActionDefinedError", function () { return $073772d363daddd9$export$2754e84c8e66e57d; });
$parcel$export(module.exports, "shouldHydrateRouteLoader", function () { return $073772d363daddd9$export$6ac68922d4e92125; });
$parcel$export(module.exports, "URL_LIMIT", function () { return $073772d363daddd9$export$b5915cf27fa06b9f; });
$parcel$export(module.exports, "getPathsWithAncestors", function () { return $073772d363daddd9$export$791cac19ae57137a; });
$parcel$export(module.exports, "isFogOfWarEnabled", function () { return $073772d363daddd9$export$741d98b28dbfd; });
$parcel$export(module.exports, "shouldUseInitialRouteDiscovery", function () { return $073772d363daddd9$export$6b125d9215e726d; });
$parcel$export(module.exports, "getPatchRoutesOnNavigationFunction", function () { return $073772d363daddd9$export$72ab377a1030deb9; });
$parcel$export(module.exports, "useFogOFWarDiscovery", function () { return $073772d363daddd9$export$5ef046b23d96090d; });
$parcel$export(module.exports, "getManifestPath", function () { return $073772d363daddd9$export$bcb79c3deff01d56; });
$parcel$export(module.exports, "FrameworkContext", function () { return $073772d363daddd9$export$208d6a3bc3aa62bd; });
$parcel$export(module.exports, "setIsHydrated", function () { return $073772d363daddd9$export$3be068dde909e563; });
$parcel$export(module.exports, "RemixErrorBoundary", function () { return $073772d363daddd9$export$32e57f52df4b6e34; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $073772d363daddd9$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $073772d363daddd9$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "NavLink", function () { return $073772d363daddd9$export$b0d92dbee9b5b60d; });
$parcel$export(module.exports, "useSearchParams", function () { return $073772d363daddd9$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "StaticRouterProvider", function () { return $073772d363daddd9$export$3d80f15952491985; });
$parcel$export(module.exports, "createStaticRouter", function () { return $073772d363daddd9$export$3dd6171c30258b6f; });
/**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $spJKX = parcelRequire("spJKX");
var $073772d363daddd9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-6KYCQHYJ.mjs"
});
var $073772d363daddd9$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $073772d363daddd9$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $073772d363daddd9$var$__typeError("Cannot " + msg);
var $073772d363daddd9$var$__privateGet = (obj, member, getter)=>($073772d363daddd9$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $073772d363daddd9$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $073772d363daddd9$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $073772d363daddd9$var$__privateSet = (obj, member, value, setter)=>($073772d363daddd9$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $073772d363daddd9$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $073772d363daddd9$export$825a82322d91916e = /^[\\/]{2}/;
function $073772d363daddd9$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $073772d363daddd9$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($073772d363daddd9$export$e19cd5f9376f8cee || {});
var $073772d363daddd9$var$PopStateEventType = "popstate";
function $073772d363daddd9$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $073772d363daddd9$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $073772d363daddd9$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $073772d363daddd9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $073772d363daddd9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $073772d363daddd9$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $073772d363daddd9$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $073772d363daddd9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to);
    }
    return $073772d363daddd9$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $073772d363daddd9$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $073772d363daddd9$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $073772d363daddd9$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $073772d363daddd9$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $073772d363daddd9$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $073772d363daddd9$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $073772d363daddd9$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $073772d363daddd9$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $073772d363daddd9$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $073772d363daddd9$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $073772d363daddd9$var$createKey(),
        mask: mask
    };
    return location;
}
function $073772d363daddd9$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $073772d363daddd9$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $073772d363daddd9$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $073772d363daddd9$var$isLocation(to) ? to : $073772d363daddd9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $073772d363daddd9$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $073772d363daddd9$var$isLocation(to) ? to : $073772d363daddd9$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $073772d363daddd9$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $073772d363daddd9$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($073772d363daddd9$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($073772d363daddd9$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $073772d363daddd9$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $073772d363daddd9$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $073772d363daddd9$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $073772d363daddd9$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $073772d363daddd9$var$_map;
var $073772d363daddd9$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $073772d363daddd9$var$__privateAdd(this, $073772d363daddd9$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_map).has(context)) return $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_map).set(context, value);
    }
};
$073772d363daddd9$var$_map = new WeakMap();
var $073772d363daddd9$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $073772d363daddd9$var$isUnsupportedLazyRouteObjectKey(key) {
    return $073772d363daddd9$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $073772d363daddd9$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $073772d363daddd9$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $073772d363daddd9$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $073772d363daddd9$var$isIndexRoute(route) {
    return route.index === true;
}
function $073772d363daddd9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $073772d363daddd9$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $073772d363daddd9$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($073772d363daddd9$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $073772d363daddd9$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $073772d363daddd9$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $073772d363daddd9$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $073772d363daddd9$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $073772d363daddd9$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $073772d363daddd9$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $073772d363daddd9$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $073772d363daddd9$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $073772d363daddd9$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $073772d363daddd9$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $073772d363daddd9$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $073772d363daddd9$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $073772d363daddd9$var$flattenAndRankRoutes(routes) {
    let branches = $073772d363daddd9$var$flattenRoutes(routes);
    $073772d363daddd9$var$rankRouteBranches(branches);
    return branches;
}
function $073772d363daddd9$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $073772d363daddd9$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $073772d363daddd9$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $073772d363daddd9$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $073772d363daddd9$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $073772d363daddd9$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $073772d363daddd9$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $073772d363daddd9$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $073772d363daddd9$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $073772d363daddd9$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $073772d363daddd9$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $073772d363daddd9$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $073772d363daddd9$var$paramRe = /^:[\w-]+$/;
var $073772d363daddd9$var$dynamicSegmentValue = 3;
var $073772d363daddd9$var$indexRouteValue = 2;
var $073772d363daddd9$var$emptySegmentValue = 1;
var $073772d363daddd9$var$staticSegmentValue = 10;
var $073772d363daddd9$var$splatPenalty = -2;
var $073772d363daddd9$var$isSplat = (s)=>s === "*";
function $073772d363daddd9$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($073772d363daddd9$var$isSplat)) initialScore += $073772d363daddd9$var$splatPenalty;
    if (index) initialScore += $073772d363daddd9$var$indexRouteValue;
    return segments.filter((s)=>!$073772d363daddd9$var$isSplat(s)).reduce((score, segment)=>score + ($073772d363daddd9$var$paramRe.test(segment) ? $073772d363daddd9$var$dynamicSegmentValue : segment === "" ? $073772d363daddd9$var$emptySegmentValue : $073772d363daddd9$var$staticSegmentValue), initialScore);
}
function $073772d363daddd9$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $073772d363daddd9$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $073772d363daddd9$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $073772d363daddd9$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $073772d363daddd9$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $073772d363daddd9$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $073772d363daddd9$var$normalizePathname($073772d363daddd9$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $073772d363daddd9$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $073772d363daddd9$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $073772d363daddd9$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $073772d363daddd9$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $073772d363daddd9$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $073772d363daddd9$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $073772d363daddd9$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $073772d363daddd9$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $073772d363daddd9$var$removeTrailingSlash(matchedPathname, 1);
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = $073772d363daddd9$var$removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $073772d363daddd9$var$compilePath(path, caseSensitive = false, end = true) {
    $073772d363daddd9$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $073772d363daddd9$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $073772d363daddd9$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $073772d363daddd9$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $073772d363daddd9$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $073772d363daddd9$var$joinPaths([
        basename,
        pathname
    ]);
}
var $073772d363daddd9$var$isAbsoluteUrl = (url)=>$073772d363daddd9$var$ABSOLUTE_URL_REGEX.test(url);
function $073772d363daddd9$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $073772d363daddd9$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $073772d363daddd9$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $073772d363daddd9$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $073772d363daddd9$var$normalizeSearch(search),
        hash: $073772d363daddd9$var$normalizeHash(hash)
    };
}
function $073772d363daddd9$var$resolvePathname(relativePath, fromPathname) {
    let segments = $073772d363daddd9$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $073772d363daddd9$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $073772d363daddd9$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $073772d363daddd9$var$getResolveToMatches(matches) {
    let pathMatches = $073772d363daddd9$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $073772d363daddd9$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $073772d363daddd9$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $073772d363daddd9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $073772d363daddd9$var$getInvalidPathError("?", "pathname", "search", to));
        $073772d363daddd9$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $073772d363daddd9$var$getInvalidPathError("#", "pathname", "hash", to));
        $073772d363daddd9$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $073772d363daddd9$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $073772d363daddd9$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $073772d363daddd9$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $073772d363daddd9$var$joinPaths = (paths)=>$073772d363daddd9$var$removeDoubleSlashes(paths.join("/"));
function $073772d363daddd9$var$removeTrailingSlash(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var $073772d363daddd9$var$normalizePathname = (pathname)=>$073772d363daddd9$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $073772d363daddd9$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $073772d363daddd9$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $073772d363daddd9$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $073772d363daddd9$export$4051a07651545597(data2, init) {
    return new $073772d363daddd9$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $073772d363daddd9$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $073772d363daddd9$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $073772d363daddd9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $073772d363daddd9$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $073772d363daddd9$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $073772d363daddd9$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $073772d363daddd9$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $073772d363daddd9$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $073772d363daddd9$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $073772d363daddd9$var$joinPaths(parts) || "/";
}
var $073772d363daddd9$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $073772d363daddd9$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$073772d363daddd9$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($073772d363daddd9$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $073772d363daddd9$export$825a82322d91916e.test(to) ? new URL($073772d363daddd9$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $073772d363daddd9$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $073772d363daddd9$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $073772d363daddd9$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $073772d363daddd9$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $073772d363daddd9$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $073772d363daddd9$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$073772d363daddd9$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $073772d363daddd9$var$wrapImpl(aggregated[key], original, (...args)=>$073772d363daddd9$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$073772d363daddd9$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$073772d363daddd9$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $073772d363daddd9$var$wrapImpl(aggregated.middleware, original, (...args)=>$073772d363daddd9$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$073772d363daddd9$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $073772d363daddd9$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$073772d363daddd9$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $073772d363daddd9$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $073772d363daddd9$export$fe53371bee54353d(to) : ".",
                ...$073772d363daddd9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$073772d363daddd9$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$073772d363daddd9$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $073772d363daddd9$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$073772d363daddd9$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$073772d363daddd9$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $073772d363daddd9$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $073772d363daddd9$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $073772d363daddd9$var$getReadonlyRequest(request),
            context: context != null ? $073772d363daddd9$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $073772d363daddd9$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $073772d363daddd9$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $073772d363daddd9$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $073772d363daddd9$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $073772d363daddd9$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $073772d363daddd9$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $073772d363daddd9$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $073772d363daddd9$var$getReadonlyContext(context)
    };
}
function $073772d363daddd9$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $073772d363daddd9$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $073772d363daddd9$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $073772d363daddd9$var$getReadonlyContext(context) {
    if ($073772d363daddd9$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $073772d363daddd9$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $073772d363daddd9$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $073772d363daddd9$var$objectProtoNames;
}
// lib/router/navigation.ts
var $073772d363daddd9$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $073772d363daddd9$var$getNavigatorCurrentUrl(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $073772d363daddd9$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $073772d363daddd9$var$DEFAULT_NAVIGATION_URL;
    }
}
function $073772d363daddd9$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $073772d363daddd9$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $073772d363daddd9$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$073772d363daddd9$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$073772d363daddd9$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$073772d363daddd9$var$isExplicitUrl(original, originalUrl) || !$073772d363daddd9$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}
// lib/router/router.ts
var $073772d363daddd9$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $073772d363daddd9$var$validMutationMethods = new Set($073772d363daddd9$var$validMutationMethodsArr);
var $073772d363daddd9$var$validRequestMethodsArr = [
    "GET",
    ...$073772d363daddd9$var$validMutationMethodsArr
];
var $073772d363daddd9$var$validRequestMethods = new Set($073772d363daddd9$var$validRequestMethodsArr);
var $073772d363daddd9$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $073772d363daddd9$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $073772d363daddd9$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $073772d363daddd9$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $073772d363daddd9$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $073772d363daddd9$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $073772d363daddd9$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $073772d363daddd9$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $073772d363daddd9$var$_routes, $073772d363daddd9$var$_branches, $073772d363daddd9$var$_hmrRoutes, $073772d363daddd9$var$_hmrBranches;
var $073772d363daddd9$var$DataRoutes = class {
    constructor(routes){
        $073772d363daddd9$var$__privateAdd(this, $073772d363daddd9$var$_routes);
        $073772d363daddd9$var$__privateAdd(this, $073772d363daddd9$var$_branches);
        $073772d363daddd9$var$__privateAdd(this, $073772d363daddd9$var$_hmrRoutes);
        $073772d363daddd9$var$__privateAdd(this, $073772d363daddd9$var$_hmrBranches);
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_routes, routes);
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_branches, $073772d363daddd9$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrRoutes) ?? $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrBranches) ?? $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_branches);
    }
    get hasHMRRoutes() {
        return $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_routes, routes);
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_branches, $073772d363daddd9$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_hmrRoutes, routes);
        $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_hmrBranches, $073772d363daddd9$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrRoutes)) {
            $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_routes, $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrRoutes));
            $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_branches, $073772d363daddd9$var$__privateGet(this, $073772d363daddd9$var$_hmrBranches));
            $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_hmrRoutes, void 0);
            $073772d363daddd9$var$__privateSet(this, $073772d363daddd9$var$_hmrBranches, void 0);
        }
    }
};
$073772d363daddd9$var$_routes = new WeakMap();
$073772d363daddd9$var$_branches = new WeakMap();
$073772d363daddd9$var$_hmrRoutes = new WeakMap();
$073772d363daddd9$var$_hmrBranches = new WeakMap();
function $073772d363daddd9$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $073772d363daddd9$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $073772d363daddd9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$073772d363daddd9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $073772d363daddd9$var$DataRoutes($073772d363daddd9$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $073772d363daddd9$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $073772d363daddd9$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $073772d363daddd9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$073772d363daddd9$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $073772d363daddd9$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $073772d363daddd9$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $073772d363daddd9$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $073772d363daddd9$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $073772d363daddd9$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$073772d363daddd9$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $073772d363daddd9$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $073772d363daddd9$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $073772d363daddd9$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $073772d363daddd9$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */  && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $073772d363daddd9$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $073772d363daddd9$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $073772d363daddd9$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $073772d363daddd9$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ($073772d363daddd9$export$825a82322d91916e.test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            $073772d363daddd9$export$6c8e41f66e7aa990(typeof opts.mask === "string" ? opts.mask : $073772d363daddd9$export$fe53371bee54353d(opts.mask), $073772d363daddd9$export$fe53371bee54353d(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = $073772d363daddd9$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        $073772d363daddd9$export$6c8e41f66e7aa990(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $073772d363daddd9$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $073772d363daddd9$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $073772d363daddd9$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $073772d363daddd9$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $073772d363daddd9$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $073772d363daddd9$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $073772d363daddd9$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $073772d363daddd9$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $073772d363daddd9$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $073772d363daddd9$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($073772d363daddd9$var$isErrorResult(result) && $073772d363daddd9$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $073772d363daddd9$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $073772d363daddd9$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$073772d363daddd9$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $073772d363daddd9$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $073772d363daddd9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $073772d363daddd9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $073772d363daddd9$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $073772d363daddd9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($073772d363daddd9$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $073772d363daddd9$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($073772d363daddd9$var$isErrorResult(result)) {
            let boundaryMatch = $073772d363daddd9$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $073772d363daddd9$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $073772d363daddd9$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $073772d363daddd9$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $073772d363daddd9$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $073772d363daddd9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$073772d363daddd9$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $073772d363daddd9$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $073772d363daddd9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $073772d363daddd9$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$073772d363daddd9$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $073772d363daddd9$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $073772d363daddd9$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $073772d363daddd9$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $073772d363daddd9$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $073772d363daddd9$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $073772d363daddd9$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $073772d363daddd9$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $073772d363daddd9$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $073772d363daddd9$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $073772d363daddd9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $073772d363daddd9$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $073772d363daddd9$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($073772d363daddd9$var$isRedirectResult(actionResult) || $073772d363daddd9$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($073772d363daddd9$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $073772d363daddd9$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($073772d363daddd9$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $073772d363daddd9$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $073772d363daddd9$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $073772d363daddd9$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $073772d363daddd9$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $073772d363daddd9$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $073772d363daddd9$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $073772d363daddd9$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $073772d363daddd9$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $073772d363daddd9$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $073772d363daddd9$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $073772d363daddd9$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $073772d363daddd9$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $073772d363daddd9$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $073772d363daddd9$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $073772d363daddd9$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $073772d363daddd9$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $073772d363daddd9$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(void 0));
            return;
        }
        if ($073772d363daddd9$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($073772d363daddd9$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $073772d363daddd9$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $073772d363daddd9$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        $073772d363daddd9$export$6c8e41f66e7aa990(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = $073772d363daddd9$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($073772d363daddd9$var$isAbsoluteUrl(location)) {
                const url = $073772d363daddd9$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $073772d363daddd9$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $073772d363daddd9$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($073772d363daddd9$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $073772d363daddd9$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $073772d363daddd9$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $073772d363daddd9$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$073772d363daddd9$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($073772d363daddd9$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $073772d363daddd9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $073772d363daddd9$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $073772d363daddd9$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $073772d363daddd9$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $073772d363daddd9$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $073772d363daddd9$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $073772d363daddd9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $073772d363daddd9$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $073772d363daddd9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $073772d363daddd9$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $073772d363daddd9$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $073772d363daddd9$export$386d57f03f0b2883;
        $073772d363daddd9$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $073772d363daddd9$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $073772d363daddd9$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $073772d363daddd9$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $073772d363daddd9$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$073772d363daddd9$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $073772d363daddd9$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $073772d363daddd9$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $073772d363daddd9$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($073772d363daddd9$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $073772d363daddd9$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $073772d363daddd9$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $073772d363daddd9$export$3336b097a6fbc59a(routes, opts) {
    $073772d363daddd9$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $073772d363daddd9$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$073772d363daddd9$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $073772d363daddd9$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $073772d363daddd9$var$flattenAndRankRoutes(dataRoutes);
    let matchCost = routeBranches.reduce((total, branch)=>total + branch.routesMeta.length, 0);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $073772d363daddd9$var$defaultNormalizePath;
        let method = request.method;
        let location = $073772d363daddd9$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $073772d363daddd9$export$b8d3e69d4b3eff04();
        if (!$073772d363daddd9$var$isValidMethod(method) && method !== "HEAD") {
            let error = $073772d363daddd9$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $073772d363daddd9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $073772d363daddd9$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $073772d363daddd9$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $073772d363daddd9$export$f5708dca728d7177(requestContext instanceof $073772d363daddd9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $073772d363daddd9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $073772d363daddd9$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $073772d363daddd9$var$createDataFunctionUrl(request, location),
                    pattern: $073772d363daddd9$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($073772d363daddd9$export$6e80290866a84dd4(error)) return error;
                    if ($073772d363daddd9$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $073772d363daddd9$export$f2680fa305b734ca(error.status, error.statusText, await $073772d363daddd9$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($073772d363daddd9$export$e0163cfdf7bc9cfa(error)) error = $073772d363daddd9$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $073772d363daddd9$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $073772d363daddd9$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $073772d363daddd9$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $073772d363daddd9$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($073772d363daddd9$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $073772d363daddd9$var$defaultNormalizePath;
        let method = request.method;
        let location = $073772d363daddd9$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $073772d363daddd9$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $073772d363daddd9$export$b8d3e69d4b3eff04();
        if (!$073772d363daddd9$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $073772d363daddd9$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $073772d363daddd9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $073772d363daddd9$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $073772d363daddd9$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $073772d363daddd9$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $073772d363daddd9$export$f5708dca728d7177(requestContext instanceof $073772d363daddd9$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $073772d363daddd9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $073772d363daddd9$var$runServerMiddlewarePipeline({
                request: request,
                url: $073772d363daddd9$var$createDataFunctionUrl(request, location),
                pattern: $073772d363daddd9$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $073772d363daddd9$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($073772d363daddd9$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($073772d363daddd9$var$dataWithResponseInitToResponse(error));
                if ($073772d363daddd9$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $073772d363daddd9$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($073772d363daddd9$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $073772d363daddd9$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $073772d363daddd9$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($073772d363daddd9$var$isDataStrategyResult(e) && $073772d363daddd9$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($073772d363daddd9$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $073772d363daddd9$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $073772d363daddd9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($073772d363daddd9$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($073772d363daddd9$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($073772d363daddd9$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $073772d363daddd9$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $073772d363daddd9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($073772d363daddd9$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $073772d363daddd9$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $073772d363daddd9$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $073772d363daddd9$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $073772d363daddd9$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $073772d363daddd9$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $073772d363daddd9$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $073772d363daddd9$var$callDataStrategyImpl(dataStrategy || $073772d363daddd9$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($073772d363daddd9$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $073772d363daddd9$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($073772d363daddd9$export$e0163cfdf7bc9cfa(result.result)) throw $073772d363daddd9$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $073772d363daddd9$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _matchCost: matchCost,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $073772d363daddd9$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $073772d363daddd9$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $073772d363daddd9$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $073772d363daddd9$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $073772d363daddd9$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $073772d363daddd9$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $073772d363daddd9$var$resolveTo(to ? to : ".", $073772d363daddd9$var$getResolveToMatches(contextualMatches), $073772d363daddd9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $073772d363daddd9$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $073772d363daddd9$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $073772d363daddd9$export$fe53371bee54353d(path);
}
function $073772d363daddd9$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$073772d363daddd9$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$073772d363daddd9$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $073772d363daddd9$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $073772d363daddd9$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $073772d363daddd9$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$073772d363daddd9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$073772d363daddd9$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $073772d363daddd9$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $073772d363daddd9$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $073772d363daddd9$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $073772d363daddd9$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $073772d363daddd9$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($073772d363daddd9$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $073772d363daddd9$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $073772d363daddd9$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $073772d363daddd9$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $073772d363daddd9$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $073772d363daddd9$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $073772d363daddd9$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$073772d363daddd9$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $073772d363daddd9$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($073772d363daddd9$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($073772d363daddd9$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $073772d363daddd9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $073772d363daddd9$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $073772d363daddd9$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $073772d363daddd9$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($073772d363daddd9$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $073772d363daddd9$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $073772d363daddd9$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$073772d363daddd9$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $073772d363daddd9$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $073772d363daddd9$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $073772d363daddd9$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $073772d363daddd9$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $073772d363daddd9$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$073772d363daddd9$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $073772d363daddd9$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $073772d363daddd9$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $073772d363daddd9$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$073772d363daddd9$var$isSameRoute(aChild, bChild))) ?? false;
}
var $073772d363daddd9$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $073772d363daddd9$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $073772d363daddd9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $073772d363daddd9$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $073772d363daddd9$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $073772d363daddd9$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $073772d363daddd9$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $073772d363daddd9$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $073772d363daddd9$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $073772d363daddd9$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $073772d363daddd9$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $073772d363daddd9$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $073772d363daddd9$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $073772d363daddd9$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $073772d363daddd9$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $073772d363daddd9$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $073772d363daddd9$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $073772d363daddd9$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $073772d363daddd9$var$isNonNullable(value) {
    return value !== void 0;
}
function $073772d363daddd9$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $073772d363daddd9$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($073772d363daddd9$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $073772d363daddd9$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $073772d363daddd9$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $073772d363daddd9$var$defaultDataStrategy(args);
    return $073772d363daddd9$var$runClientMiddlewarePipeline(args, ()=>$073772d363daddd9$var$defaultDataStrategy(args));
}
function $073772d363daddd9$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $073772d363daddd9$var$runMiddlewarePipeline(args, handler, processResult, $073772d363daddd9$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $073772d363daddd9$export$e0163cfdf7bc9cfa(result) ? $073772d363daddd9$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $073772d363daddd9$var$runClientMiddlewarePipeline(args, handler) {
    return $073772d363daddd9$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($073772d363daddd9$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $073772d363daddd9$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $073772d363daddd9$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $073772d363daddd9$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $073772d363daddd9$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $073772d363daddd9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $073772d363daddd9$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $073772d363daddd9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $073772d363daddd9$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $073772d363daddd9$var$loadLazyRoute(match.route, $073772d363daddd9$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $073772d363daddd9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $073772d363daddd9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $073772d363daddd9$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $073772d363daddd9$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$073772d363daddd9$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($073772d363daddd9$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $073772d363daddd9$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $073772d363daddd9$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $073772d363daddd9$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $073772d363daddd9$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $073772d363daddd9$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $073772d363daddd9$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $073772d363daddd9$var$createDataFunctionUrl(request, path),
        pattern: $073772d363daddd9$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $073772d363daddd9$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $073772d363daddd9$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $073772d363daddd9$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $073772d363daddd9$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $073772d363daddd9$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $073772d363daddd9$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $073772d363daddd9$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $073772d363daddd9$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $073772d363daddd9$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $073772d363daddd9$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($073772d363daddd9$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $073772d363daddd9$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $073772d363daddd9$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $073772d363daddd9$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($073772d363daddd9$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $073772d363daddd9$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $073772d363daddd9$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$073772d363daddd9$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $073772d363daddd9$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $073772d363daddd9$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $073772d363daddd9$export$961a3ef7a4da3a39(location) {
    try {
        return $073772d363daddd9$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $073772d363daddd9$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($073772d363daddd9$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $073772d363daddd9$export$825a82322d91916e.test(normalizedLocation) ? new URL($073772d363daddd9$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($073772d363daddd9$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $073772d363daddd9$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $073772d363daddd9$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($073772d363daddd9$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $073772d363daddd9$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($073772d363daddd9$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $073772d363daddd9$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $073772d363daddd9$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $073772d363daddd9$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $073772d363daddd9$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $073772d363daddd9$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $073772d363daddd9$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $073772d363daddd9$export$f5708dca728d7177(!$073772d363daddd9$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($073772d363daddd9$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $073772d363daddd9$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $073772d363daddd9$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $073772d363daddd9$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $073772d363daddd9$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $073772d363daddd9$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $073772d363daddd9$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($073772d363daddd9$var$isErrorResult(result)) {
            let boundaryMatch = $073772d363daddd9$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($073772d363daddd9$var$isRedirectResult(result)) $073772d363daddd9$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $073772d363daddd9$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $073772d363daddd9$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $073772d363daddd9$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $073772d363daddd9$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $073772d363daddd9$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $073772d363daddd9$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $073772d363daddd9$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $073772d363daddd9$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $073772d363daddd9$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $073772d363daddd9$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($073772d363daddd9$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $073772d363daddd9$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(path) : path;
    return $073772d363daddd9$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $073772d363daddd9$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $073772d363daddd9$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $073772d363daddd9$var$dataWithResponseInitToErrorResponse(data2) {
    return new $073772d363daddd9$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $073772d363daddd9$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $073772d363daddd9$var$isDataStrategyResult(value));
}
function $073772d363daddd9$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $073772d363daddd9$var$isRedirectDataStrategyResult(result) {
    return $073772d363daddd9$export$3f1eb41d9a6a6a27(result.result) && $073772d363daddd9$var$redirectStatusCodes.has(result.result.status);
}
function $073772d363daddd9$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $073772d363daddd9$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $073772d363daddd9$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $073772d363daddd9$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $073772d363daddd9$export$794b2760043cf8cd(statusCode) {
    return $073772d363daddd9$var$redirectStatusCodes.has(statusCode);
}
function $073772d363daddd9$export$6e80290866a84dd4(result) {
    return $073772d363daddd9$export$3f1eb41d9a6a6a27(result) && $073772d363daddd9$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $073772d363daddd9$var$isValidMethod(method) {
    return $073772d363daddd9$var$validRequestMethods.has(method.toUpperCase());
}
function $073772d363daddd9$export$cbae47800eb95bc3(method) {
    return $073772d363daddd9$var$validMutationMethods.has(method.toUpperCase());
}
function $073772d363daddd9$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $073772d363daddd9$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $073772d363daddd9$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $073772d363daddd9$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $073772d363daddd9$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $073772d363daddd9$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $073772d363daddd9$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $073772d363daddd9$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $073772d363daddd9$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $073772d363daddd9$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $073772d363daddd9$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($073772d363daddd9$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $073772d363daddd9$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($073772d363daddd9$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $073772d363daddd9$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $073772d363daddd9$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $073772d363daddd9$export$2eeee58951ff3c1c = $spJKX.createContext(null);
$073772d363daddd9$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $073772d363daddd9$export$315e3ffb01f217 = $spJKX.createContext(null);
$073772d363daddd9$export$315e3ffb01f217.displayName = "DataRouterState";
var $073772d363daddd9$export$717f757c655223f1 = $spJKX.createContext(false);
function $073772d363daddd9$var$useIsRSCRouterContext() {
    return $spJKX.useContext($073772d363daddd9$export$717f757c655223f1);
}
var $073772d363daddd9$export$3681f408decb40d1 = $spJKX.createContext({
    isTransitioning: false
});
$073772d363daddd9$export$3681f408decb40d1.displayName = "ViewTransition";
var $073772d363daddd9$export$cb3f1df1bef00a39 = $spJKX.createContext(/* @__PURE__ */ new Map());
$073772d363daddd9$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $073772d363daddd9$var$AwaitContext = $spJKX.createContext(null);
$073772d363daddd9$var$AwaitContext.displayName = "Await";
var $073772d363daddd9$export$2666c20e15407622 = (props)=>$spJKX.createElement($073772d363daddd9$var$AwaitContext.Provider, props);
var $073772d363daddd9$export$3044ab7fdabeaee6 = $spJKX.createContext(null);
$073772d363daddd9$export$3044ab7fdabeaee6.displayName = "Navigation";
var $073772d363daddd9$export$e6a44b110a0c44d3 = $spJKX.createContext(null);
$073772d363daddd9$export$e6a44b110a0c44d3.displayName = "Location";
var $073772d363daddd9$export$aac280ed165a4397 = $spJKX.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$073772d363daddd9$export$aac280ed165a4397.displayName = "Route";
var $073772d363daddd9$var$RouteErrorContext = $spJKX.createContext(null);
$073772d363daddd9$var$RouteErrorContext.displayName = "RouteError";
var $073772d363daddd9$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $073772d363daddd9$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $073772d363daddd9$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $073772d363daddd9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $073772d363daddd9$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$073772d363daddd9$var$ERROR_DIGEST_BASE}:${$073772d363daddd9$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $073772d363daddd9$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$073772d363daddd9$var$ERROR_DIGEST_BASE}:${$073772d363daddd9$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $073772d363daddd9$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $073772d363daddd9$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $073772d363daddd9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $073772d363daddd9$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $073772d363daddd9$export$9c954a9d03d32f4a() {
    return $spJKX.useContext($073772d363daddd9$export$e6a44b110a0c44d3) != null;
}
function $073772d363daddd9$export$45d76561a5302f2b() {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $spJKX.useContext($073772d363daddd9$export$e6a44b110a0c44d3).location;
}
function $073772d363daddd9$export$1b3f31771c5d07c() {
    return $spJKX.useContext($073772d363daddd9$export$e6a44b110a0c44d3).navigationType;
}
function $073772d363daddd9$export$6c330e8992e8a295(pattern) {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $073772d363daddd9$export$45d76561a5302f2b();
    return $spJKX.useMemo(()=>$073772d363daddd9$export$81336c211d5ff295(pattern, $073772d363daddd9$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $073772d363daddd9$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $073772d363daddd9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6).static;
    if (!isStatic) $spJKX.useLayoutEffect(cb);
}
function $073772d363daddd9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    return isDataRoute ? $073772d363daddd9$var$useNavigateStable() : $073772d363daddd9$var$useNavigateUnstable();
}
function $073772d363daddd9$var$useNavigateUnstable() {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let { matches: matches } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $073772d363daddd9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($073772d363daddd9$var$getResolveToMatches(matches));
    let activeRef = $spJKX.useRef(false);
    $073772d363daddd9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $spJKX.useCallback((to, options = {})=>{
        $073772d363daddd9$var$warning(activeRef.current, $073772d363daddd9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $073772d363daddd9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $073772d363daddd9$var$joinPaths([
            basename,
            path.pathname
        ]);
        $073772d363daddd9$export$6c8e41f66e7aa990(typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to), navigator.createHref(path), $073772d363daddd9$var$getNavigatorCurrentUrl(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $073772d363daddd9$var$OutletContext = $spJKX.createContext(null);
function $073772d363daddd9$export$4138103a3ae699cc() {
    return $spJKX.useContext($073772d363daddd9$var$OutletContext);
}
function $073772d363daddd9$export$a3be3530d8e40d0b(context) {
    let outlet = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397).outlet;
    return $spJKX.useMemo(()=>outlet && /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $073772d363daddd9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $073772d363daddd9$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $073772d363daddd9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($073772d363daddd9$var$getResolveToMatches(matches));
    return $spJKX.useMemo(()=>$073772d363daddd9$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $073772d363daddd9$export$5d3fca4a98652595(routes, locationArg) {
    return $073772d363daddd9$var$useRoutesImpl(routes, locationArg);
}
function $073772d363daddd9$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($073772d363daddd9$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $073772d363daddd9$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $073772d363daddd9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $073772d363daddd9$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $073772d363daddd9$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $073772d363daddd9$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($073772d363daddd9$export$945fecf35a8ef089) {
        $073772d363daddd9$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $073772d363daddd9$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $073772d363daddd9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $073772d363daddd9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $073772d363daddd9$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $073772d363daddd9$var$DefaultErrorComponent() {
    let error = $073772d363daddd9$export$ed527bf60f6e05f2();
    let message = $073772d363daddd9$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($073772d363daddd9$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $spJKX.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $spJKX.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $spJKX.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $spJKX.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $spJKX.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $073772d363daddd9$var$defaultErrorElement = /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$DefaultErrorComponent, null);
var $073772d363daddd9$var$RenderErrorBoundary = class extends $spJKX.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $073772d363daddd9$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$073772d363daddd9$var$RenderErrorBoundary.contextType = $073772d363daddd9$export$717f757c655223f1;
var $073772d363daddd9$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $073772d363daddd9$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $073772d363daddd9$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $073772d363daddd9$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $073772d363daddd9$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            $073772d363daddd9$export$6c8e41f66e7aa990(redirect2.location, target, $073772d363daddd9$var$getNavigatorCurrentUrl(navigator), "allow-explicit");
            if ($073772d363daddd9$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($073772d363daddd9$var$isBrowser && !$073772d363daddd9$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $073772d363daddd9$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $spJKX.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $073772d363daddd9$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $073772d363daddd9$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $073772d363daddd9$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $073772d363daddd9$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $073772d363daddd9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $073772d363daddd9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $spJKX.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $073772d363daddd9$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $073772d363daddd9$var$useDataRouterContext(hookName) {
    let ctx = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    $073772d363daddd9$export$f5708dca728d7177(ctx, $073772d363daddd9$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $073772d363daddd9$var$useDataRouterState(hookName) {
    let state = $spJKX.useContext($073772d363daddd9$export$315e3ffb01f217);
    $073772d363daddd9$export$f5708dca728d7177(state, $073772d363daddd9$var$getDataRouterConsoleError(hookName));
    return state;
}
function $073772d363daddd9$var$useRouteContext(hookName) {
    let route = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    $073772d363daddd9$export$f5708dca728d7177(route, $073772d363daddd9$var$getDataRouterConsoleError(hookName));
    return route;
}
function $073772d363daddd9$var$useCurrentRouteId(hookName) {
    let route = $073772d363daddd9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $073772d363daddd9$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $073772d363daddd9$var$useRouteId() {
    return $073772d363daddd9$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $073772d363daddd9$export$d0fd4b7106de2769() {
    let state = $073772d363daddd9$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $spJKX.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $073772d363daddd9$export$600dc272ed516c15() {
    let dataRouterContext = $073772d363daddd9$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $073772d363daddd9$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $spJKX.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $spJKX.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $073772d363daddd9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $073772d363daddd9$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $spJKX.useMemo(()=>matches.map((m)=>$073772d363daddd9$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $073772d363daddd9$export$1448a5050d252c4d() {
    let state = $073772d363daddd9$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $073772d363daddd9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $073772d363daddd9$export$fd5d37484eab868d(routeId) {
    let state = $073772d363daddd9$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $073772d363daddd9$export$fdc00f3f26066d5e() {
    let state = $073772d363daddd9$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $073772d363daddd9$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $073772d363daddd9$export$ed527bf60f6e05f2() {
    let error = $spJKX.useContext($073772d363daddd9$var$RouteErrorContext);
    let state = $073772d363daddd9$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $073772d363daddd9$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $073772d363daddd9$export$78a72ddb39bdd145() {
    let value = $spJKX.useContext($073772d363daddd9$var$AwaitContext);
    return value?._data;
}
function $073772d363daddd9$export$17f53340677d5831() {
    let value = $spJKX.useContext($073772d363daddd9$var$AwaitContext);
    return value?._error;
}
var $073772d363daddd9$var$blockerId = 0;
function $073772d363daddd9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $073772d363daddd9$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $073772d363daddd9$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $spJKX.useState("");
    let blockerFunction = $spJKX.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $073772d363daddd9$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $073772d363daddd9$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $spJKX.useEffect(()=>{
        let key = String(++$073772d363daddd9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $spJKX.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $073772d363daddd9$export$386d57f03f0b2883;
}
function $073772d363daddd9$var$useNavigateStable() {
    let { router: router } = $073772d363daddd9$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $073772d363daddd9$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $spJKX.useRef(false);
    $073772d363daddd9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $spJKX.useCallback(async (to, options = {})=>{
        $073772d363daddd9$var$warning(activeRef.current, $073772d363daddd9$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $073772d363daddd9$var$alreadyWarned = {};
function $073772d363daddd9$var$warningOnce(key, cond, message) {
    if (!cond && !$073772d363daddd9$var$alreadyWarned[key]) {
        $073772d363daddd9$var$alreadyWarned[key] = true;
        $073772d363daddd9$var$warning(false, message);
    }
}
function $073772d363daddd9$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $073772d363daddd9$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $073772d363daddd9$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $073772d363daddd9$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $073772d363daddd9$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $073772d363daddd9$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $spJKX.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$073772d363daddd9$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $spJKX.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$073772d363daddd9$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $spJKX.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $073772d363daddd9$var$alreadyWarned2 = {};
function $073772d363daddd9$export$5b28268982f175ba(condition, message) {
    if (!condition && !$073772d363daddd9$var$alreadyWarned2[message]) {
        $073772d363daddd9$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $073772d363daddd9$var$USE_OPTIMISTIC = "useOptimistic";
var $073772d363daddd9$var$useOptimisticImpl = $spJKX[$073772d363daddd9$var$USE_OPTIMISTIC];
var $073772d363daddd9$var$stableUseOptimisticSetter = ()=>void 0;
function $073772d363daddd9$var$useOptimisticSafe(val) {
    if ($073772d363daddd9$var$useOptimisticImpl) return $073772d363daddd9$var$useOptimisticImpl(val);
    else return [
        val,
        $073772d363daddd9$var$stableUseOptimisticSetter
    ];
}
function $073772d363daddd9$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($073772d363daddd9$export$945fecf35a8ef089) {
            if (route.element) $073772d363daddd9$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $spJKX.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($073772d363daddd9$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $073772d363daddd9$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $spJKX.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($073772d363daddd9$export$945fecf35a8ef089) {
            if (route.errorElement) $073772d363daddd9$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $spJKX.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $073772d363daddd9$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $073772d363daddd9$export$f30f7e456d254e83(routes, opts) {
    return $073772d363daddd9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $073772d363daddd9$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $073772d363daddd9$export$e2fd2c03906469db,
        mapRouteProperties: $073772d363daddd9$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $073772d363daddd9$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $073772d363daddd9$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $073772d363daddd9$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $spJKX.useState(router.state);
    let [state, setOptimisticState] = $073772d363daddd9$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $spJKX.useState();
    let [vtContext, setVtContext] = $spJKX.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $spJKX.useState();
    let [transition, setTransition] = $spJKX.useState();
    let [interruption, setInterruption] = $spJKX.useState();
    let fetcherData = $spJKX.useRef(/* @__PURE__ */ new Map());
    let setState = $spJKX.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $073772d363daddd9$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $073772d363daddd9$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $073772d363daddd9$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $spJKX.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$073772d363daddd9$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $spJKX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $spJKX.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $073772d363daddd9$var$Deferred());
    }, [
        vtContext
    ]);
    $spJKX.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $spJKX.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$073772d363daddd9$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $spJKX.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $spJKX.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $spJKX.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $spJKX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $073772d363daddd9$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $073772d363daddd9$var$MemoizedDataRoutes = $spJKX.memo($073772d363daddd9$var$DataRoutes2);
function $073772d363daddd9$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $073772d363daddd9$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $073772d363daddd9$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $spJKX.useRef();
    if (historyRef.current == null) historyRef.current = $073772d363daddd9$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $spJKX.useState({
        action: history.action,
        location: history.location
    });
    let setState = $spJKX.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $spJKX.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $spJKX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $073772d363daddd9$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $073772d363daddd9$export$f5708dca728d7177($073772d363daddd9$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    $073772d363daddd9$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let { pathname: locationPathname } = $073772d363daddd9$export$45d76561a5302f2b();
    let navigate = $073772d363daddd9$export$9770f232ac06a008();
    let path = $073772d363daddd9$var$resolveTo(to, $073772d363daddd9$var$getResolveToMatches(matches), locationPathname, relative === "path");
    $073772d363daddd9$export$6c8e41f66e7aa990(typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to), navigator.createHref(path), $073772d363daddd9$var$getNavigatorCurrentUrl(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $spJKX.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $073772d363daddd9$export$910ae8079b2c2852(props) {
    return $073772d363daddd9$export$a3be3530d8e40d0b(props.context);
}
function $073772d363daddd9$export$e7b0ac011bb776c6(props) {
    $073772d363daddd9$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $073772d363daddd9$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $073772d363daddd9$export$f5708dca728d7177(!$073772d363daddd9$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $spJKX.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $073772d363daddd9$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $spJKX.useMemo(()=>{
        let trailingPathname = $073772d363daddd9$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $073772d363daddd9$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $073772d363daddd9$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $073772d363daddd9$export$5d3fca4a98652595($073772d363daddd9$export$16da398f5434bdec(children), location);
}
function $073772d363daddd9$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $spJKX.useContext($073772d363daddd9$export$315e3ffb01f217);
    let onError = $spJKX.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $073772d363daddd9$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$ResolveAwait, null, children));
}
var $073772d363daddd9$var$AwaitErrorBoundary = class extends $spJKX.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $073772d363daddd9$var$ResolveAwait({ children: children }) {
    let data2 = $073772d363daddd9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, toRender);
}
function $073772d363daddd9$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $spJKX.Children.forEach(children, (element, index)=>{
        if (!$spJKX.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $spJKX.Fragment) {
            routes.push.apply(routes, $073772d363daddd9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $073772d363daddd9$export$f5708dca728d7177(element.type === $073772d363daddd9$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $073772d363daddd9$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $073772d363daddd9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $073772d363daddd9$export$9b5b6d122dea0c88 = $073772d363daddd9$export$16da398f5434bdec;
function $073772d363daddd9$export$daf73786167a7f72(matches) {
    return $073772d363daddd9$var$_renderMatches(matches);
}
function $073772d363daddd9$var$useRouteComponentProps() {
    return {
        params: $073772d363daddd9$export$99eaa27ddbbb95ef(),
        loaderData: $073772d363daddd9$export$1448a5050d252c4d(),
        actionData: $073772d363daddd9$export$fdc00f3f26066d5e(),
        matches: $073772d363daddd9$export$2378eb7f5ff86053()
    };
}
function $073772d363daddd9$export$6c4f3826290c37af({ children: children }) {
    const props = $073772d363daddd9$var$useRouteComponentProps();
    return $spJKX.cloneElement(children, props);
}
function $073772d363daddd9$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $073772d363daddd9$var$useRouteComponentProps();
        return $spJKX.createElement(Component4, props);
    };
}
function $073772d363daddd9$var$useHydrateFallbackProps() {
    return {
        params: $073772d363daddd9$export$99eaa27ddbbb95ef(),
        loaderData: $073772d363daddd9$export$1448a5050d252c4d(),
        actionData: $073772d363daddd9$export$fdc00f3f26066d5e()
    };
}
function $073772d363daddd9$export$f8cff34f39c1932a({ children: children }) {
    const props = $073772d363daddd9$var$useHydrateFallbackProps();
    return $spJKX.cloneElement(children, props);
}
function $073772d363daddd9$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $073772d363daddd9$var$useHydrateFallbackProps();
        return $spJKX.createElement(HydrateFallback, props);
    };
}
function $073772d363daddd9$var$useErrorBoundaryProps() {
    return {
        params: $073772d363daddd9$export$99eaa27ddbbb95ef(),
        loaderData: $073772d363daddd9$export$1448a5050d252c4d(),
        actionData: $073772d363daddd9$export$fdc00f3f26066d5e(),
        error: $073772d363daddd9$export$ed527bf60f6e05f2()
    };
}
function $073772d363daddd9$export$e5afde5c4b6d747b({ children: children }) {
    const props = $073772d363daddd9$var$useErrorBoundaryProps();
    return $spJKX.cloneElement(children, props);
}
function $073772d363daddd9$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $073772d363daddd9$var$useErrorBoundaryProps();
        return $spJKX.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $073772d363daddd9$var$defaultMethod = "get";
var $073772d363daddd9$var$defaultEncType = "application/x-www-form-urlencoded";
function $073772d363daddd9$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $073772d363daddd9$var$isButtonElement(object) {
    return $073772d363daddd9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $073772d363daddd9$var$isFormElement(object) {
    return $073772d363daddd9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $073772d363daddd9$var$isInputElement(object) {
    return $073772d363daddd9$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $073772d363daddd9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $073772d363daddd9$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$073772d363daddd9$var$isModifiedEvent(event);
}
function $073772d363daddd9$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $073772d363daddd9$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $073772d363daddd9$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $073772d363daddd9$var$_formDataSupportsSubmitter = null;
function $073772d363daddd9$var$isFormDataSubmitterSupported() {
    if ($073772d363daddd9$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $073772d363daddd9$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $073772d363daddd9$var$_formDataSupportsSubmitter = true;
    }
    return $073772d363daddd9$var$_formDataSupportsSubmitter;
}
var $073772d363daddd9$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $073772d363daddd9$var$getFormEncType(encType) {
    if (encType != null && !$073772d363daddd9$var$supportedFormEncTypes.has(encType)) {
        $073772d363daddd9$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$073772d363daddd9$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $073772d363daddd9$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($073772d363daddd9$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $073772d363daddd9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $073772d363daddd9$var$defaultMethod;
        encType = $073772d363daddd9$var$getFormEncType(target.getAttribute("enctype")) || $073772d363daddd9$var$defaultEncType;
        formData = new FormData(target);
    } else if ($073772d363daddd9$var$isButtonElement(target) || $073772d363daddd9$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $073772d363daddd9$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $073772d363daddd9$var$defaultMethod;
        encType = $073772d363daddd9$var$getFormEncType(target.getAttribute("formenctype")) || $073772d363daddd9$var$getFormEncType(form.getAttribute("enctype")) || $073772d363daddd9$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$073772d363daddd9$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($073772d363daddd9$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $073772d363daddd9$var$defaultMethod;
        action = null;
        encType = $073772d363daddd9$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $073772d363daddd9$var$HOLE = -1;
var $073772d363daddd9$var$NAN = -2;
var $073772d363daddd9$var$NEGATIVE_INFINITY = -3;
var $073772d363daddd9$var$NEGATIVE_ZERO = -4;
var $073772d363daddd9$var$NULL = -5;
var $073772d363daddd9$var$POSITIVE_INFINITY = -6;
var $073772d363daddd9$var$UNDEFINED = -7;
var $073772d363daddd9$var$TYPE_BIGINT = "B";
var $073772d363daddd9$var$TYPE_DATE = "D";
var $073772d363daddd9$var$TYPE_ERROR = "E";
var $073772d363daddd9$var$TYPE_MAP = "M";
var $073772d363daddd9$var$TYPE_NULL_OBJECT = "N";
var $073772d363daddd9$var$TYPE_PROMISE = "P";
var $073772d363daddd9$var$TYPE_REGEXP = "R";
var $073772d363daddd9$var$TYPE_SET = "S";
var $073772d363daddd9$var$TYPE_SYMBOL = "Y";
var $073772d363daddd9$var$TYPE_URL = "U";
var $073772d363daddd9$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $073772d363daddd9$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $073772d363daddd9$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $073772d363daddd9$var$TIME_LIMIT_MS = 1;
var $073772d363daddd9$var$getNow = ()=>Date.now();
var $073772d363daddd9$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $073772d363daddd9$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $073772d363daddd9$var$UNDEFINED;
    if (input === null) return $073772d363daddd9$var$NULL;
    if (Number.isNaN(input)) return $073772d363daddd9$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $073772d363daddd9$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $073772d363daddd9$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $073772d363daddd9$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $073772d363daddd9$var$stringify.call(this, stack);
    return index;
}
async function $073772d363daddd9$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $073772d363daddd9$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $073772d363daddd9$var$UNDEFINED;
        if (value === null) return $073772d363daddd9$var$NULL;
        if (Number.isNaN(value)) return $073772d363daddd9$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $073772d363daddd9$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $073772d363daddd9$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $073772d363daddd9$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $073772d363daddd9$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $073772d363daddd9$var$TIME_LIMIT_MS) {
            await $073772d363daddd9$var$yieldToMain();
            lastYieldTime = $073772d363daddd9$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$073772d363daddd9$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$073772d363daddd9$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$073772d363daddd9$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $073772d363daddd9$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$073772d363daddd9$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$073772d363daddd9$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$073772d363daddd9$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$073772d363daddd9$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$073772d363daddd9$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$073772d363daddd9$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$073772d363daddd9$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$073772d363daddd9$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$073772d363daddd9$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$073772d363daddd9$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($073772d363daddd9$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $073772d363daddd9$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $073772d363daddd9$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $073772d363daddd9$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $073772d363daddd9$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $073772d363daddd9$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $073772d363daddd9$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $073772d363daddd9$var$hydrate.call(this, startIndex);
}
function $073772d363daddd9$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $073772d363daddd9$var$UNDEFINED:
                set(void 0);
                continue;
            case $073772d363daddd9$var$NULL:
                set(null);
                continue;
            case $073772d363daddd9$var$NAN:
                set(NaN);
                continue;
            case $073772d363daddd9$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $073772d363daddd9$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $073772d363daddd9$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        $073772d363daddd9$var$validateIndex(index2, values.length);
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $073772d363daddd9$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $073772d363daddd9$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $073772d363daddd9$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $073772d363daddd9$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $073772d363daddd9$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $073772d363daddd9$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $073772d363daddd9$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $073772d363daddd9$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $073772d363daddd9$var$TYPE_PROMISE:
                        $073772d363daddd9$var$validateIndex(b, values.length);
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $073772d363daddd9$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $073772d363daddd9$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $073772d363daddd9$var$globalObj && $073772d363daddd9$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $073772d363daddd9$var$globalObj && typeof $073772d363daddd9$var$globalObj[errorType] === "function" ? new $073772d363daddd9$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $073772d363daddd9$var$TYPE_PREVIOUS_RESOLVED:
                        $073772d363daddd9$var$validateIndex(b, values.length);
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $073772d363daddd9$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    Object.defineProperty(object, r[0], {
                        value: r[1],
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
function $073772d363daddd9$var$validateIndex(index, length) {
    if (!Number.isSafeInteger(index) || index < 0 || index >= length) throw new SyntaxError();
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $073772d363daddd9$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $073772d363daddd9$var$Deferred2();
    const reader = readable.pipeThrough($073772d363daddd9$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $073772d363daddd9$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $073772d363daddd9$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $073772d363daddd9$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $073772d363daddd9$var$unflatten.call(this, line)
    };
}
async function $073772d363daddd9$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $073772d363daddd9$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $073772d363daddd9$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $073772d363daddd9$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $073772d363daddd9$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $073772d363daddd9$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $073772d363daddd9$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $073772d363daddd9$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_PROMISE}${deferredId}:[["${$073772d363daddd9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $073772d363daddd9$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_ERROR}${deferredId}:[["${$073772d363daddd9$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$073772d363daddd9$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $073772d363daddd9$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $073772d363daddd9$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $073772d363daddd9$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $073772d363daddd9$export$4cf11838cdc2a8a8(html) {
    return html.replace($073772d363daddd9$var$ESCAPE_REGEX, (match)=>$073772d363daddd9$var$ESCAPE_LOOKUP[match]);
}
function $073772d363daddd9$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
// lib/dom/ssr/invariant.ts
function $073772d363daddd9$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $073772d363daddd9$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $073772d363daddd9$var$SingleFetchNoResultError = class extends Error {
};
var $073772d363daddd9$export$ae9272e641ead836 = 202;
var $073772d363daddd9$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $073772d363daddd9$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $spJKX.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$073772d363daddd9$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, scriptTag, /* @__PURE__ */ $spJKX.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, scriptTag, /* @__PURE__ */ $spJKX.createElement($spJKX.Suspense, null, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $073772d363daddd9$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $073772d363daddd9$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $073772d363daddd9$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $073772d363daddd9$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $073772d363daddd9$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $073772d363daddd9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $073772d363daddd9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $073772d363daddd9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $073772d363daddd9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $073772d363daddd9$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $073772d363daddd9$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $073772d363daddd9$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($073772d363daddd9$export$3f1eb41d9a6a6a27(result.result) || $073772d363daddd9$export$972111febbeef05b(result.result) || $073772d363daddd9$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $073772d363daddd9$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $073772d363daddd9$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $073772d363daddd9$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $073772d363daddd9$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$073772d363daddd9$var$createDeferred2());
    let singleFetchDfd = $073772d363daddd9$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $073772d363daddd9$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $073772d363daddd9$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $073772d363daddd9$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $073772d363daddd9$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $073772d363daddd9$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $073772d363daddd9$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $073772d363daddd9$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $073772d363daddd9$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $073772d363daddd9$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $073772d363daddd9$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $073772d363daddd9$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$073772d363daddd9$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$073772d363daddd9$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $073772d363daddd9$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $073772d363daddd9$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $073772d363daddd9$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $073772d363daddd9$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $073772d363daddd9$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $073772d363daddd9$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($073772d363daddd9$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $073772d363daddd9$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $073772d363daddd9$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($073772d363daddd9$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$073772d363daddd9$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $073772d363daddd9$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $073772d363daddd9$export$4023ad4ecd4126a2(body, global) {
    return $073772d363daddd9$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $073772d363daddd9$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $073772d363daddd9$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$073772d363daddd9$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $073772d363daddd9$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $073772d363daddd9$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $073772d363daddd9$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $073772d363daddd9$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $073772d363daddd9$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $073772d363daddd9$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $073772d363daddd9$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $073772d363daddd9$var$getModuleLinkHrefs(matches, manifest);
    return $073772d363daddd9$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $073772d363daddd9$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $073772d363daddd9$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $073772d363daddd9$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($073772d363daddd9$var$prefetchStyleLink));
}
async function $073772d363daddd9$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$073772d363daddd9$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$073772d363daddd9$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$073772d363daddd9$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($073772d363daddd9$var$prefetchStyleLink));
}
async function $073772d363daddd9$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $073772d363daddd9$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $073772d363daddd9$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $073772d363daddd9$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $073772d363daddd9$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $073772d363daddd9$var$dedupeLinkDescriptors(links.flat(1).filter($073772d363daddd9$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $073772d363daddd9$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $073772d363daddd9$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $073772d363daddd9$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $073772d363daddd9$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $073772d363daddd9$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $073772d363daddd9$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$073772d363daddd9$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($073772d363daddd9$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $073772d363daddd9$var$_isPreloadSupported;
function $073772d363daddd9$var$isPreloadSupported() {
    if ($073772d363daddd9$var$_isPreloadSupported !== void 0) return $073772d363daddd9$var$_isPreloadSupported;
    let el = document.createElement("link");
    $073772d363daddd9$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $073772d363daddd9$var$_isPreloadSupported;
}
function $073772d363daddd9$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $073772d363daddd9$var$useFrameworkContext();
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $073772d363daddd9$export$945fecf35a8ef089 ? /* @__PURE__ */ $spJKX.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $073772d363daddd9$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $073772d363daddd9$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $073772d363daddd9$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $073772d363daddd9$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RemixRootDefaultErrorBoundary, {
            error: $073772d363daddd9$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $spJKX.createElement(routeModule.Layout, null, /* @__PURE__ */ $spJKX.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $spJKX.createElement(routeModule.Layout, null, /* @__PURE__ */ $spJKX.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $spJKX.createElement(routeModule.Layout, null, /* @__PURE__ */ $spJKX.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $073772d363daddd9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $073772d363daddd9$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $073772d363daddd9$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$073772d363daddd9$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $073772d363daddd9$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $073772d363daddd9$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $073772d363daddd9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $073772d363daddd9$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $073772d363daddd9$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $073772d363daddd9$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $073772d363daddd9$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $073772d363daddd9$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $073772d363daddd9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $073772d363daddd9$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $073772d363daddd9$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $073772d363daddd9$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $073772d363daddd9$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$073772d363daddd9$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $073772d363daddd9$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $073772d363daddd9$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $073772d363daddd9$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $073772d363daddd9$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $073772d363daddd9$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $073772d363daddd9$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $073772d363daddd9$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $073772d363daddd9$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $073772d363daddd9$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $073772d363daddd9$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $073772d363daddd9$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $073772d363daddd9$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $073772d363daddd9$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $073772d363daddd9$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $073772d363daddd9$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $073772d363daddd9$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $073772d363daddd9$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $073772d363daddd9$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $073772d363daddd9$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $073772d363daddd9$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $073772d363daddd9$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $073772d363daddd9$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $073772d363daddd9$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $073772d363daddd9$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $073772d363daddd9$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $073772d363daddd9$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $073772d363daddd9$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $073772d363daddd9$var$nextPaths = /* @__PURE__ */ new Set();
var $073772d363daddd9$var$discoveredPathsMaxSize = 1e3;
var $073772d363daddd9$var$discoveredPaths = /* @__PURE__ */ new Set();
var $073772d363daddd9$export$b5915cf27fa06b9f = 7680;
function $073772d363daddd9$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $073772d363daddd9$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
var $073772d363daddd9$var$MANIFEST_MATCH_COST_LIMIT = 5e4;
var $073772d363daddd9$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD = 10;
function $073772d363daddd9$export$6b125d9215e726d(pathname, matchCost = 0) {
    let segmentCount = pathname.split("/").length - 1;
    let ancestorCount = Math.max(segmentCount - 1, 0);
    return ancestorCount * pathname.length + 1 > $073772d363daddd9$export$b5915cf27fa06b9f || segmentCount > $073772d363daddd9$var$MANIFEST_MATCH_COST_SEGMENT_THRESHOLD && segmentCount * matchCost > $073772d363daddd9$var$MANIFEST_MATCH_COST_LIMIT;
}
function $073772d363daddd9$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $073772d363daddd9$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $073772d363daddd9$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$073772d363daddd9$export$741d98b28dbfd(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($073772d363daddd9$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $073772d363daddd9$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $073772d363daddd9$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $073772d363daddd9$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $spJKX.useEffect(()=>{
        if (!$073772d363daddd9$export$741d98b28dbfd(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$073772d363daddd9$var$discoveredPaths.has(pathname)) $073772d363daddd9$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($073772d363daddd9$var$nextPaths.keys()).filter((path)=>{
                if ($073772d363daddd9$var$discoveredPaths.has(path)) {
                    $073772d363daddd9$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $073772d363daddd9$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $073772d363daddd9$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $073772d363daddd9$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $073772d363daddd9$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $073772d363daddd9$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $073772d363daddd9$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $073772d363daddd9$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($073772d363daddd9$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $073772d363daddd9$export$b5915cf27fa06b9f) {
        $073772d363daddd9$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($073772d363daddd9$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($073772d363daddd9$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($073772d363daddd9$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$073772d363daddd9$var$addToFifoQueue(p, $073772d363daddd9$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $073772d363daddd9$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $073772d363daddd9$var$addToFifoQueue(path, queue) {
    if (queue.size >= $073772d363daddd9$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $073772d363daddd9$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $073772d363daddd9$var$useDataRouterContext2() {
    let context = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    $073772d363daddd9$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $073772d363daddd9$var$useDataRouterStateContext() {
    let context = $spJKX.useContext($073772d363daddd9$export$315e3ffb01f217);
    $073772d363daddd9$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $073772d363daddd9$export$208d6a3bc3aa62bd = $spJKX.createContext(void 0);
$073772d363daddd9$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $073772d363daddd9$var$useFrameworkContext() {
    let context = $spJKX.useContext($073772d363daddd9$export$208d6a3bc3aa62bd);
    $073772d363daddd9$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $073772d363daddd9$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $spJKX.useContext($073772d363daddd9$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $spJKX.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $spJKX.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $spJKX.useRef(null);
    $spJKX.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $spJKX.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $073772d363daddd9$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $073772d363daddd9$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $073772d363daddd9$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $073772d363daddd9$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $073772d363daddd9$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $073772d363daddd9$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $073772d363daddd9$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$073772d363daddd9$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $073772d363daddd9$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $073772d363daddd9$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $073772d363daddd9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $073772d363daddd9$var$useDataRouterStateContext();
    let matches = $073772d363daddd9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $spJKX.useMemo(()=>$073772d363daddd9$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $spJKX.createElement("style", {
        [$073772d363daddd9$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $spJKX.createElement("link", {
        [$073772d363daddd9$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$073772d363daddd9$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $spJKX.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $073772d363daddd9$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $073772d363daddd9$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $073772d363daddd9$var$useFrameworkContext();
    let { router: router } = $073772d363daddd9$var$useDataRouterContext2();
    let matches = $spJKX.useMemo(()=>$073772d363daddd9$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $073772d363daddd9$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $073772d363daddd9$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $spJKX.useState([]);
    $spJKX.useEffect(()=>{
        let interrupted = false;
        $073772d363daddd9$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $073772d363daddd9$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let { future: future } = $073772d363daddd9$var$useFrameworkContext();
    let { basename: basename } = $073772d363daddd9$var$useDataRouterContext2();
    let dataHrefs = $spJKX.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $073772d363daddd9$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $spJKX.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $073772d363daddd9$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $073772d363daddd9$var$useFrameworkContext();
    let { basename: basename } = $073772d363daddd9$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $073772d363daddd9$var$useDataRouterStateContext();
    let newMatchesForData = $spJKX.useMemo(()=>$073772d363daddd9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $spJKX.useMemo(()=>$073772d363daddd9$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $spJKX.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $073772d363daddd9$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $spJKX.useMemo(()=>$073772d363daddd9$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $073772d363daddd9$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $spJKX.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $spJKX.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $spJKX.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $073772d363daddd9$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $073772d363daddd9$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $073772d363daddd9$var$useDataRouterStateContext();
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let _matches = $073772d363daddd9$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$073772d363daddd9$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $spJKX.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $spJKX.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $spJKX.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $spJKX.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $073772d363daddd9$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $spJKX.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $073772d363daddd9$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $073772d363daddd9$var$isHydrated = false;
function $073772d363daddd9$export$3be068dde909e563() {
    $073772d363daddd9$var$isHydrated = true;
}
function $073772d363daddd9$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $073772d363daddd9$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $073772d363daddd9$var$useDataRouterContext2();
    let { matches: routerMatches } = $073772d363daddd9$var$useDataRouterStateContext();
    let isRSCRouterContext = $073772d363daddd9$var$useIsRSCRouterContext();
    let enableFogOfWar = $073772d363daddd9$export$741d98b28dbfd(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $073772d363daddd9$var$getActiveMatches(routerMatches, null, isSpaMode);
    $spJKX.useEffect(()=>{
        $073772d363daddd9$export$3be068dde909e563();
    }, []);
    let initialScripts = $spJKX.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $073772d363daddd9$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($073772d363daddd9$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $spJKX.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $073772d363daddd9$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($073772d363daddd9$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $073772d363daddd9$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $073772d363daddd9$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $spJKX.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $spJKX.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $spJKX.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $spJKX.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $073772d363daddd9$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $073772d363daddd9$export$32e57f52df4b6e34 = class extends $spJKX.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $073772d363daddd9$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $073772d363daddd9$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $spJKX.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($073772d363daddd9$export$972111febbeef05b(error)) return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $spJKX.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $073772d363daddd9$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $spJKX.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $spJKX.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $073772d363daddd9$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $073772d363daddd9$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $spJKX.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $spJKX.createElement("head", null, /* @__PURE__ */ $spJKX.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $spJKX.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $spJKX.createElement("title", null, title)), /* @__PURE__ */ $spJKX.createElement("body", null, /* @__PURE__ */ $spJKX.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$ff0bf87698939488, null) : null)));
}
var $073772d363daddd9$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($073772d363daddd9$var$isBrowser2) window.__reactRouterVersion = "7.18.5";
} catch (e) {}
function $073772d363daddd9$export$1f3f55432a00e06d(routes, opts) {
    return $073772d363daddd9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $073772d363daddd9$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $073772d363daddd9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $073772d363daddd9$export$9269a41d8c4635e,
        hydrationRouteProperties: $073772d363daddd9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $073772d363daddd9$export$1ba7ed8a3a7b3765(routes, opts) {
    return $073772d363daddd9$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $073772d363daddd9$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $073772d363daddd9$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $073772d363daddd9$export$9269a41d8c4635e,
        hydrationRouteProperties: $073772d363daddd9$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $073772d363daddd9$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $073772d363daddd9$var$deserializeErrors(state.errors)
    };
    return state;
}
function $073772d363daddd9$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $073772d363daddd9$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $073772d363daddd9$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $073772d363daddd9$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $spJKX.useRef();
    if (historyRef.current == null) historyRef.current = $073772d363daddd9$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $spJKX.useState({
        action: history.action,
        location: history.location
    });
    let setState = $spJKX.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $spJKX.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $spJKX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $073772d363daddd9$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $spJKX.useRef();
    if (historyRef.current == null) historyRef.current = $073772d363daddd9$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $spJKX.useState({
        action: history.action,
        location: history.location
    });
    let setState = $spJKX.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $spJKX.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $spJKX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $073772d363daddd9$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $spJKX.useState({
        action: history.action,
        location: history.location
    });
    let setState = $spJKX.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $spJKX.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $spJKX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$073772d363daddd9$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $073772d363daddd9$export$a6c7ac8248d6e38a = $spJKX.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $073772d363daddd9$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $073772d363daddd9$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $073772d363daddd9$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $073772d363daddd9$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $073772d363daddd9$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $073772d363daddd9$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $073772d363daddd9$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $spJKX.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $073772d363daddd9$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, link, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$073772d363daddd9$export$a6c7ac8248d6e38a.displayName = "Link";
var $073772d363daddd9$export$b0d92dbee9b5b60d = $spJKX.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $073772d363daddd9$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let routerState = $spJKX.useContext($073772d363daddd9$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $073772d363daddd9$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $073772d363daddd9$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$073772d363daddd9$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $073772d363daddd9$export$a7fed597f4b8afd8 = $spJKX.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $073772d363daddd9$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let submit = $073772d363daddd9$export$47c85c6e3a081d3();
    let formAction = $073772d363daddd9$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $073772d363daddd9$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $spJKX.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $spJKX.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$073772d363daddd9$export$a7fed597f4b8afd8.displayName = "Form";
function $073772d363daddd9$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $spJKX.useContext($073772d363daddd9$export$208d6a3bc3aa62bd);
    let { basename: basename } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let matches = $073772d363daddd9$export$2378eb7f5ff86053();
    $073772d363daddd9$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $spJKX.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $073772d363daddd9$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $spJKX.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$073772d363daddd9$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $073772d363daddd9$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$073772d363daddd9$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$073772d363daddd9$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $073772d363daddd9$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $073772d363daddd9$var$useDataRouterContext3(hookName) {
    let ctx = $spJKX.useContext($073772d363daddd9$export$2eeee58951ff3c1c);
    $073772d363daddd9$export$f5708dca728d7177(ctx, $073772d363daddd9$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $073772d363daddd9$var$useDataRouterState2(hookName) {
    let state = $spJKX.useContext($073772d363daddd9$export$315e3ffb01f217);
    $073772d363daddd9$export$f5708dca728d7177(state, $073772d363daddd9$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $073772d363daddd9$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $073772d363daddd9$export$9770f232ac06a008();
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let path = $073772d363daddd9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $spJKX.useCallback((event)=>{
        if ($073772d363daddd9$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $073772d363daddd9$export$fe53371bee54353d(location) === $073772d363daddd9$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $spJKX.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $073772d363daddd9$export$f1a78c17382fe22a(defaultInit) {
    $073772d363daddd9$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $spJKX.useRef($073772d363daddd9$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $spJKX.useRef(false);
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let searchParams = $spJKX.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $073772d363daddd9$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $073772d363daddd9$export$9770f232ac06a008();
    let setSearchParams = $spJKX.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $073772d363daddd9$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $073772d363daddd9$var$fetcherId = 0;
var $073772d363daddd9$var$getUniqueFetcherId = ()=>`__${String(++$073772d363daddd9$var$fetcherId)}__`;
function $073772d363daddd9$export$47c85c6e3a081d3() {
    let { router: router } = $073772d363daddd9$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let currentRouteId = $073772d363daddd9$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $spJKX.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $073772d363daddd9$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $073772d363daddd9$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $073772d363daddd9$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let routeContext = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    $073772d363daddd9$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$073772d363daddd9$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $073772d363daddd9$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $073772d363daddd9$export$fe53371bee54353d(path);
}
function $073772d363daddd9$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $073772d363daddd9$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $073772d363daddd9$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $spJKX.useContext($073772d363daddd9$export$cb3f1df1bef00a39);
    let route = $spJKX.useContext($073772d363daddd9$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $073772d363daddd9$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $073772d363daddd9$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $073772d363daddd9$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $spJKX.useId();
    let [fetcherKey, setFetcherKey] = $spJKX.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $spJKX.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $spJKX.useCallback(async (href, opts)=>{
        $073772d363daddd9$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $073772d363daddd9$export$47c85c6e3a081d3();
    let submit = $spJKX.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $spJKX.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $spJKX.useMemo(()=>{
        let FetcherForm2 = $spJKX.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $073772d363daddd9$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $spJKX.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $073772d363daddd9$export$fa996778a3a31087() {
    let state = $073772d363daddd9$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $spJKX.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $073772d363daddd9$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $073772d363daddd9$var$savedScrollPositions = {};
function $073772d363daddd9$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $073772d363daddd9$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $073772d363daddd9$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $073772d363daddd9$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $073772d363daddd9$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $spJKX.useContext($073772d363daddd9$export$3044ab7fdabeaee6);
    let location = $073772d363daddd9$export$45d76561a5302f2b();
    let matches = $073772d363daddd9$export$2378eb7f5ff86053();
    let navigation = $073772d363daddd9$export$d0fd4b7106de2769();
    $spJKX.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $073772d363daddd9$var$usePageHide($spJKX.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $073772d363daddd9$var$getScrollRestorationKey(location, matches, basename, getKey);
            $073772d363daddd9$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $073772d363daddd9$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($073772d363daddd9$var$savedScrollPositions));
        } catch (error) {
            $073772d363daddd9$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $spJKX.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $073772d363daddd9$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $073772d363daddd9$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $spJKX.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($073772d363daddd9$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$073772d363daddd9$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $spJKX.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $073772d363daddd9$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $073772d363daddd9$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $spJKX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $073772d363daddd9$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $spJKX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $073772d363daddd9$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $073772d363daddd9$export$b273b3273281a049(when);
    $spJKX.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $spJKX.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $073772d363daddd9$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $spJKX.useContext($073772d363daddd9$export$3681f408decb40d1);
    $073772d363daddd9$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $073772d363daddd9$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $073772d363daddd9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $073772d363daddd9$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $073772d363daddd9$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $073772d363daddd9$export$81336c211d5ff295(path.pathname, nextPath) != null || $073772d363daddd9$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $073772d363daddd9$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $073772d363daddd9$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $073772d363daddd9$var$getStatelessNavigator();
    return /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $073772d363daddd9$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $073772d363daddd9$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $073772d363daddd9$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $073772d363daddd9$var$serializeErrors(context.errors)
        };
        let json = $073772d363daddd9$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $spJKX.createElement($073772d363daddd9$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $spJKX.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $073772d363daddd9$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($073772d363daddd9$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $073772d363daddd9$var$getStatelessNavigator() {
    return {
        createHref: $073772d363daddd9$var$createHref,
        encodeLocation: $073772d363daddd9$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $073772d363daddd9$export$69163f0b72ec60d9(routes, opts) {
    return $073772d363daddd9$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $073772d363daddd9$export$9269a41d8c4635e
    });
}
function $073772d363daddd9$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $073772d363daddd9$export$87cb1a9238dc3fba(routes, $073772d363daddd9$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $073772d363daddd9$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $073772d363daddd9$var$createHref,
        encodeLocation: $073772d363daddd9$var$encodeLocation,
        getFetcher () {
            return $073772d363daddd9$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $073772d363daddd9$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $073772d363daddd9$var$createHref(to) {
    return typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to);
}
function $073772d363daddd9$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $073772d363daddd9$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $073772d363daddd9$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}

});

parcelRegister("6jtLO", function(module, exports) {
$parcel$export(module.exports, "AioIconButton", function () { return (parcelRequire("biia9")).AioIconButton; });
$parcel$export(module.exports, "AioReplacementDisplay", function () { return (parcelRequire("7na6X")).AioReplacementDisplay; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return (parcelRequire("2Rhsi")).isAioExternalReplacements; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return (parcelRequire("2Rhsi")).isAioExternalSingle; });
$parcel$export(module.exports, "newExternalReplacements", function () { return (parcelRequire("1LZEa")).newExternalReplacements; });
$parcel$export(module.exports, "updateExternal", function () { return (parcelRequire("vby9F")).updateExternal; });
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("321H1")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("36pkg")).AnalysisSetControl; });
$parcel$export(module.exports, "ARS", function () { return (parcelRequire("iEmH0")); });
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("jPvQk")).ArsBlock; });
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("4hgF7")).ArsContextProvider; });
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("5V1m5")).ArsListing; });
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("jKF9Q")).ArsTable; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("7RQn4")).cloneArsObject; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("7byiZ")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("7byiZ")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("7byiZ")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("7byiZ")).createNewGroupingFactor; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cJd2i")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("dMUCw")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("51n1k")).GroupingFactorControl; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("7RQn4")).hasArsObjectWithName; });
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ghR9g")).isAnalysisMethod; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("2N5BV")).isArsListingBody; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("gwArU")).isArsTableBody; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("49JG0")).isDataSubset; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("12Lyj")).isObjectRecord; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("9QVTJ")).isSubClauseWithReference; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("7G3Xj")).MultipleDatasetCheck; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cJd2i")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("cr6aM")).ReferencedEntityControl; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cJd2i")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("c5vs0")).totalSidebarItem; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("4hgF7")).useArsContext; });
$parcel$export(module.exports, "AibLineType", function () { return (parcelRequire("1ol4Z")).AibLineType; });
$parcel$export(module.exports, "AsupInternalBlock", function () { return (parcelRequire("cCgYJ")).AsupInternalBlock; });
$parcel$export(module.exports, "AddLinkButton", function () { return (parcelRequire("laHpz")).AddLinkButton; });
$parcel$export(module.exports, "AsyncButton", function () { return (parcelRequire("iuDOI")).AsyncButton; });
$parcel$export(module.exports, "Control210", function () { return (parcelRequire("kUTy1")).Control210; });
$parcel$export(module.exports, "Control211", function () { return (parcelRequire("aUt9N")).Control211; });
$parcel$export(module.exports, "Control213", function () { return (parcelRequire("iNEej")).Control213; });
$parcel$export(module.exports, "ControlBase", function () { return (parcelRequire("dd2Wn")).ControlBase; });
$parcel$export(module.exports, "ControlDate", function () { return (parcelRequire("3XbKn")).ControlDate; });
$parcel$export(module.exports, "ControlInlineEdit", function () { return (parcelRequire("i4t1Y")).ControlInlineEdit; });
$parcel$export(module.exports, "ControlNavList", function () { return (parcelRequire("fCofY")).ControlNavList; });
$parcel$export(module.exports, "ControlsGroup", function () { return (parcelRequire("lUxHn")).ControlsGroup; });
$parcel$export(module.exports, "ControlTags", function () { return (parcelRequire("fVo1v")).ControlTags; });
$parcel$export(module.exports, "ControlTypeAhead", function () { return (parcelRequire("8Uc5S")).ControlTypeAhead; });
$parcel$export(module.exports, "InTextLink", function () { return (parcelRequire("ifddf")).InTextLink; });
$parcel$export(module.exports, "SortableListHolder", function () { return (parcelRequire("3d5lD")).SortableListHolder; });
$parcel$export(module.exports, "BeFigure", function () { return (parcelRequire("fVgC1")).BeFigure; });
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("kTXvy")).isFigureSettingsDto; });
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("hFJlN")).preProcessFigureInput; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("9B5Sg")).AitTablePosition; });
$parcel$export(module.exports, "AsupInternalTable", function () { return (parcelRequire("1cgCo")).AsupInternalTable; });
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("aVRpe")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2Uw8z")).isGridItemTrafficLight; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("l6aIi")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("l6aIi")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("6GMBM")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("6GMBM")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("gMOiI")).newRowGroup; });
$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return (parcelRequire("6g7gz")).isMosaicTrafficLightsValue; });
$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return (parcelRequire("fEdhd")).isMosaicTrafficLightSwitch; });
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return (parcelRequire("6r4yf")).MosaicTrafficLightClass; });
$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return (parcelRequire("6r4yf")).MosaicTrafficLightColors; });
$parcel$export(module.exports, "checkName", function () { return (parcelRequire("klm8J")).checkName; });
$parcel$export(module.exports, "classMerge", function () { return (parcelRequire("3tKzd")).classMerge; });
$parcel$export(module.exports, "convertDateToLocaleString", function () { return (parcelRequire("9S4dL")).convertDateToLocaleString; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return (parcelRequire("9S4dL")).convertLocaleDateToUTCString; });
$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return (parcelRequire("iULHs")).datasetToAnnotatedVariables; });
$parcel$export(module.exports, "getFromDataPath", function () { return (parcelRequire("jwDoS")).getFromDataPath; });
$parcel$export(module.exports, "loadWrapper", function () { return (parcelRequire("4dL47")).loadWrapper; });
$parcel$export(module.exports, "PauseCover", function () { return (parcelRequire("1wSYE")).PauseCover; });
$parcel$export(module.exports, "stringDateCheck", function () { return (parcelRequire("7fpOF")).stringDateCheck; });
$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return (parcelRequire("dbVjd")).TLF_VIEW_MODES; });
$parcel$export(module.exports, "valueFix", function () { return (parcelRequire("dD4jq")).valueFix; });
parcelRequire("dyM3y");
parcelRequire("1p11Q");
parcelRequire("cunuO");
parcelRequire("aoPxa");
parcelRequire("aEiv0");
parcelRequire("e2uI9");
parcelRequire("hTZ2b");
parcelRequire("4Ol1K");
parcelRequire("5SMPf");

});
parcelRegister("dyM3y", function(module, exports) {
$parcel$export(module.exports, "AioIconButton", function () { return (parcelRequire("biia9")).AioIconButton; });
$parcel$export(module.exports, "AioReplacementDisplay", function () { return (parcelRequire("7na6X")).AioReplacementDisplay; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return (parcelRequire("2Rhsi")).isAioExternalReplacements; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return (parcelRequire("2Rhsi")).isAioExternalSingle; });
$parcel$export(module.exports, "isAioReplacement", function () { return (parcelRequire("2Rhsi")).isAioReplacement; });
$parcel$export(module.exports, "newExternalReplacements", function () { return (parcelRequire("1LZEa")).newExternalReplacements; });
$parcel$export(module.exports, "updateExternal", function () { return (parcelRequire("vby9F")).updateExternal; });
parcelRequire("3f0RC");
parcelRequire("8kv8T");
parcelRequire("fUdFB");
parcelRequire("biia9");
parcelRequire("9Osbv");
parcelRequire("kHJeU");
parcelRequire("7na6X");
parcelRequire("3Gn2b");
parcelRequire("4F320");
parcelRequire("gGo2X");
parcelRequire("bMqT7");
parcelRequire("fWJ6C");
parcelRequire("2Rhsi");
parcelRequire("1LZEa");
parcelRequire("azY1B");
parcelRequire("76A43");
parcelRequire("vby9F");
parcelRequire("fHFBi");

});
parcelRegister("3f0RC", function(module, exports) {

$parcel$export(module.exports, "AioBoolean", function () { return $70cbaa3dd206d493$export$178e417a4db5ac38; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $9Osbv = parcelRequire("9Osbv");
const $70cbaa3dd206d493$export$178e417a4db5ac38 = (props)=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9Osbv.AioLabel), {
                id: `${props.id}-label`,
                label: props.label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInputHolder,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                    id: props.id,
                    "aria-labelledby": `${props.id}-label`,
                    checked: props.value,
                    disabled: !(typeof props.setValue === "function") || props.disabled,
                    onChange: (e)=>props.setValue(e.currentTarget.checked),
                    type: "checkbox"
                })
            })
        ]
    });
};
$70cbaa3dd206d493$export$178e417a4db5ac38.displayName = "AioBoolean";

});
parcelRegister("9zfAS", function(module, exports) {

$parcel$export(module.exports, "absoluteLeft0", function () { return $6f737a8730fda513$export$4f17df0ebee58067; }, function (v) { return $6f737a8730fda513$export$4f17df0ebee58067 = v; });
$parcel$export(module.exports, "absoluteTopRight", function () { return $6f737a8730fda513$export$736d3278694cc0fd; }, function (v) { return $6f737a8730fda513$export$736d3278694cc0fd = v; });
$parcel$export(module.exports, "aibBlock", function () { return $6f737a8730fda513$export$7f77d671e2687ea; }, function (v) { return $6f737a8730fda513$export$7f77d671e2687ea = v; });
$parcel$export(module.exports, "aibLine", function () { return $6f737a8730fda513$export$89918ebbc3c127c7; }, function (v) { return $6f737a8730fda513$export$89918ebbc3c127c7 = v; });
$parcel$export(module.exports, "aibLineButtons", function () { return $6f737a8730fda513$export$66df7e9d68209f2d; }, function (v) { return $6f737a8730fda513$export$66df7e9d68209f2d = v; });
$parcel$export(module.exports, "aibLineItem", function () { return $6f737a8730fda513$export$ac63149497c27d24; }, function (v) { return $6f737a8730fda513$export$ac63149497c27d24 = v; });
$parcel$export(module.exports, "aibLineItemHolder", function () { return $6f737a8730fda513$export$ae3f66ca17a91b3; }, function (v) { return $6f737a8730fda513$export$ae3f66ca17a91b3 = v; });
$parcel$export(module.exports, "aibReadOnly", function () { return $6f737a8730fda513$export$a91deb551c57e7a5; }, function (v) { return $6f737a8730fda513$export$a91deb551c57e7a5 = v; });
$parcel$export(module.exports, "aieOuter", function () { return $6f737a8730fda513$export$e84853277b98a973; }, function (v) { return $6f737a8730fda513$export$e84853277b98a973 = v; });
$parcel$export(module.exports, "aioBodyRow", function () { return $6f737a8730fda513$export$f4f787701cf85254; }, function (v) { return $6f737a8730fda513$export$f4f787701cf85254 = v; });
$parcel$export(module.exports, "aioButtonHolder", function () { return $6f737a8730fda513$export$131bac28331688a9; }, function (v) { return $6f737a8730fda513$export$131bac28331688a9 = v; });
$parcel$export(module.exports, "aioCommentHolder", function () { return $6f737a8730fda513$export$29397c928c4a5781; }, function (v) { return $6f737a8730fda513$export$29397c928c4a5781 = v; });
$parcel$export(module.exports, "aioDropItem", function () { return $6f737a8730fda513$export$3f13e480f6c5271a; }, function (v) { return $6f737a8730fda513$export$3f13e480f6c5271a = v; });
$parcel$export(module.exports, "aioDropItemsHolder", function () { return $6f737a8730fda513$export$992e111a1534dd31; }, function (v) { return $6f737a8730fda513$export$992e111a1534dd31 = v; });
$parcel$export(module.exports, "aioDropItemsInnerHolder", function () { return $6f737a8730fda513$export$53de806239109854; }, function (v) { return $6f737a8730fda513$export$53de806239109854 = v; });
$parcel$export(module.exports, "aioInput", function () { return $6f737a8730fda513$export$94a472f130bf47c; }, function (v) { return $6f737a8730fda513$export$94a472f130bf47c = v; });
$parcel$export(module.exports, "aioInputHolder", function () { return $6f737a8730fda513$export$7fe9b8b6deeca5a5; }, function (v) { return $6f737a8730fda513$export$7fe9b8b6deeca5a5 = v; });
$parcel$export(module.exports, "aioLabel", function () { return $6f737a8730fda513$export$8bf3840a8957b76; }, function (v) { return $6f737a8730fda513$export$8bf3840a8957b76 = v; });
$parcel$export(module.exports, "aioRoValue", function () { return $6f737a8730fda513$export$aab6956240d8473; }, function (v) { return $6f737a8730fda513$export$aab6956240d8473 = v; });
$parcel$export(module.exports, "aioRow", function () { return $6f737a8730fda513$export$143e3912c99e9ff8; }, function (v) { return $6f737a8730fda513$export$143e3912c99e9ff8 = v; });
$parcel$export(module.exports, "aioSelect", function () { return $6f737a8730fda513$export$67ec89fec3652885; }, function (v) { return $6f737a8730fda513$export$67ec89fec3652885 = v; });
$parcel$export(module.exports, "aioTip", function () { return $6f737a8730fda513$export$4d4d141944f68e7b; }, function (v) { return $6f737a8730fda513$export$4d4d141944f68e7b = v; });
$parcel$export(module.exports, "aioTipBottom", function () { return $6f737a8730fda513$export$39303ae8a955ff80; }, function (v) { return $6f737a8730fda513$export$39303ae8a955ff80 = v; });
$parcel$export(module.exports, "aioTipBottom2", function () { return $6f737a8730fda513$export$2c2ee864cc2b56ef; }, function (v) { return $6f737a8730fda513$export$2c2ee864cc2b56ef = v; });
$parcel$export(module.exports, "aioTipLeft", function () { return $6f737a8730fda513$export$4c5ef43f16eec51e; }, function (v) { return $6f737a8730fda513$export$4c5ef43f16eec51e = v; });
$parcel$export(module.exports, "aioTipLeft2", function () { return $6f737a8730fda513$export$8b1c716ddb7d836f; }, function (v) { return $6f737a8730fda513$export$8b1c716ddb7d836f = v; });
$parcel$export(module.exports, "aioTipLhs", function () { return $6f737a8730fda513$export$2159c038930d1595; }, function (v) { return $6f737a8730fda513$export$2159c038930d1595 = v; });
$parcel$export(module.exports, "aioTipRhs", function () { return $6f737a8730fda513$export$c03d9c90aff15581; }, function (v) { return $6f737a8730fda513$export$c03d9c90aff15581 = v; });
$parcel$export(module.exports, "aioTipRight", function () { return $6f737a8730fda513$export$2407bd150fcd71d8; }, function (v) { return $6f737a8730fda513$export$2407bd150fcd71d8 = v; });
$parcel$export(module.exports, "aioTipRight2", function () { return $6f737a8730fda513$export$2be84b11fc1cc84a; }, function (v) { return $6f737a8730fda513$export$2be84b11fc1cc84a = v; });
$parcel$export(module.exports, "aioTipTop", function () { return $6f737a8730fda513$export$9588e6031755613e; }, function (v) { return $6f737a8730fda513$export$9588e6031755613e = v; });
$parcel$export(module.exports, "aioTipTop2", function () { return $6f737a8730fda513$export$1a7319974a0b196d; }, function (v) { return $6f737a8730fda513$export$1a7319974a0b196d = v; });
$parcel$export(module.exports, "aioTiptext", function () { return $6f737a8730fda513$export$a5ba150a6cd3665d; }, function (v) { return $6f737a8730fda513$export$a5ba150a6cd3665d = v; });
$parcel$export(module.exports, "aioTiptext2", function () { return $6f737a8730fda513$export$70b5f208320769cb; }, function (v) { return $6f737a8730fda513$export$70b5f208320769cb = v; });
$parcel$export(module.exports, "aioTiptextBottomarrow", function () { return $6f737a8730fda513$export$a9167f570deabdf3; }, function (v) { return $6f737a8730fda513$export$a9167f570deabdf3 = v; });
$parcel$export(module.exports, "aioTiptextLeftarrow", function () { return $6f737a8730fda513$export$e4e1a0786f152291; }, function (v) { return $6f737a8730fda513$export$e4e1a0786f152291 = v; });
$parcel$export(module.exports, "aioTiptextRightarrow", function () { return $6f737a8730fda513$export$e5f4a6b7e232f3b2; }, function (v) { return $6f737a8730fda513$export$e5f4a6b7e232f3b2 = v; });
$parcel$export(module.exports, "aioTiptextToparrow", function () { return $6f737a8730fda513$export$c39c6162216fb32d; }, function (v) { return $6f737a8730fda513$export$c39c6162216fb32d = v; });
$parcel$export(module.exports, "aioUpdateButton", function () { return $6f737a8730fda513$export$497deef337205b54; }, function (v) { return $6f737a8730fda513$export$497deef337205b54 = v; });
$parcel$export(module.exports, "aioValue", function () { return $6f737a8730fda513$export$954d66e350b33664; }, function (v) { return $6f737a8730fda513$export$954d66e350b33664 = v; });
$parcel$export(module.exports, "aiordMain", function () { return $6f737a8730fda513$export$ac8617dc00b55765; }, function (v) { return $6f737a8730fda513$export$ac8617dc00b55765 = v; });
$parcel$export(module.exports, "aiordvMain", function () { return $6f737a8730fda513$export$42ad9a1f9232e67d; }, function (v) { return $6f737a8730fda513$export$42ad9a1f9232e67d = v; });
$parcel$export(module.exports, "aiox", function () { return $6f737a8730fda513$export$91ab19af263ed1e5; }, function (v) { return $6f737a8730fda513$export$91ab19af263ed1e5 = v; });
$parcel$export(module.exports, "aioxAddDown", function () { return $6f737a8730fda513$export$5af554cb0e1c69ad; }, function (v) { return $6f737a8730fda513$export$5af554cb0e1c69ad = v; });
$parcel$export(module.exports, "aioxButton", function () { return $6f737a8730fda513$export$8a7c2065a6431a02; }, function (v) { return $6f737a8730fda513$export$8a7c2065a6431a02 = v; });
$parcel$export(module.exports, "aioxButtonCell", function () { return $6f737a8730fda513$export$a77474c7ffd9b171; }, function (v) { return $6f737a8730fda513$export$a77474c7ffd9b171 = v; });
$parcel$export(module.exports, "aioxButtonHolder", function () { return $6f737a8730fda513$export$10d4ca81a4f67998; }, function (v) { return $6f737a8730fda513$export$10d4ca81a4f67998 = v; });
$parcel$export(module.exports, "aioxButtonRowGroup", function () { return $6f737a8730fda513$export$61a59f7a4de889f3; }, function (v) { return $6f737a8730fda513$export$61a59f7a4de889f3 = v; });
$parcel$export(module.exports, "aioxButtonRowOptions", function () { return $6f737a8730fda513$export$42e3bbcebe288980; }, function (v) { return $6f737a8730fda513$export$42e3bbcebe288980 = v; });
$parcel$export(module.exports, "aioxButtonSettings", function () { return $6f737a8730fda513$export$eb941bdcd92a43d1; }, function (v) { return $6f737a8730fda513$export$eb941bdcd92a43d1 = v; });
$parcel$export(module.exports, "aioxCircle", function () { return $6f737a8730fda513$export$6b79775752681cf8; }, function (v) { return $6f737a8730fda513$export$6b79775752681cf8 = v; });
$parcel$export(module.exports, "aioxCircleRed", function () { return $6f737a8730fda513$export$88c6530c3b4d23cf; }, function (v) { return $6f737a8730fda513$export$88c6530c3b4d23cf = v; });
$parcel$export(module.exports, "aioxDown", function () { return $6f737a8730fda513$export$bfec69f8cbe4c4d6; }, function (v) { return $6f737a8730fda513$export$bfec69f8cbe4c4d6 = v; });
$parcel$export(module.exports, "aioxExplode", function () { return $6f737a8730fda513$export$68ea70fb62bde31c; }, function (v) { return $6f737a8730fda513$export$68ea70fb62bde31c = v; });
$parcel$export(module.exports, "aioxGrip", function () { return $6f737a8730fda513$export$1e9a6bab843d251a; }, function (v) { return $6f737a8730fda513$export$1e9a6bab843d251a = v; });
$parcel$export(module.exports, "aioxImplode", function () { return $6f737a8730fda513$export$f9fc73d7b6311543; }, function (v) { return $6f737a8730fda513$export$f9fc73d7b6311543 = v; });
$parcel$export(module.exports, "aioxLabel", function () { return $6f737a8730fda513$export$8b1dbac6337160ce; }, function (v) { return $6f737a8730fda513$export$8b1dbac6337160ce = v; });
$parcel$export(module.exports, "aioxList", function () { return $6f737a8730fda513$export$570ca4ca47e6110e; }, function (v) { return $6f737a8730fda513$export$570ca4ca47e6110e = v; });
$parcel$export(module.exports, "aioxMinus", function () { return $6f737a8730fda513$export$638d7b7a98bf4800; }, function (v) { return $6f737a8730fda513$export$638d7b7a98bf4800 = v; });
$parcel$export(module.exports, "aioxOpenClose", function () { return $6f737a8730fda513$export$daf8802eb43d7f66; }, function (v) { return $6f737a8730fda513$export$daf8802eb43d7f66 = v; });
$parcel$export(module.exports, "aioxPlus", function () { return $6f737a8730fda513$export$37edeaef6dea6; }, function (v) { return $6f737a8730fda513$export$37edeaef6dea6 = v; });
$parcel$export(module.exports, "aioxRemoveUp", function () { return $6f737a8730fda513$export$7e4603536a9f1f5a; }, function (v) { return $6f737a8730fda513$export$7e4603536a9f1f5a = v; });
$parcel$export(module.exports, "aioxTable", function () { return $6f737a8730fda513$export$949a8d6e33131d43; }, function (v) { return $6f737a8730fda513$export$949a8d6e33131d43 = v; });
$parcel$export(module.exports, "aioxUp", function () { return $6f737a8730fda513$export$c676ef791a38437e; }, function (v) { return $6f737a8730fda513$export$c676ef791a38437e = v; });
$parcel$export(module.exports, "aitAieHolder", function () { return $6f737a8730fda513$export$1d47042371b84542; }, function (v) { return $6f737a8730fda513$export$1d47042371b84542 = v; });
$parcel$export(module.exports, "aitAieHolderButton", function () { return $6f737a8730fda513$export$b92d6afdcd523774; }, function (v) { return $6f737a8730fda513$export$b92d6afdcd523774 = v; });
$parcel$export(module.exports, "aitBodyCell", function () { return $6f737a8730fda513$export$342f2ecab8e21136; }, function (v) { return $6f737a8730fda513$export$342f2ecab8e21136 = v; });
$parcel$export(module.exports, "aitBorderCell", function () { return $6f737a8730fda513$export$e2040b8db4e5c9f6; }, function (v) { return $6f737a8730fda513$export$e2040b8db4e5c9f6 = v; });
$parcel$export(module.exports, "aitCell", function () { return $6f737a8730fda513$export$3b9f395efd9e3155; }, function (v) { return $6f737a8730fda513$export$3b9f395efd9e3155 = v; });
$parcel$export(module.exports, "aitColumnButtons", function () { return $6f737a8730fda513$export$54ec96a9c09dc200; }, function (v) { return $6f737a8730fda513$export$54ec96a9c09dc200 = v; });
$parcel$export(module.exports, "aitHeaderCell", function () { return $6f737a8730fda513$export$57b3b332a0c04132; }, function (v) { return $6f737a8730fda513$export$57b3b332a0c04132 = v; });
$parcel$export(module.exports, "aitHolder", function () { return $6f737a8730fda513$export$f8b7bb939646bdba; }, function (v) { return $6f737a8730fda513$export$f8b7bb939646bdba = v; });
$parcel$export(module.exports, "aitOptionsButton", function () { return $6f737a8730fda513$export$27cb2bbe58ae21a; }, function (v) { return $6f737a8730fda513$export$27cb2bbe58ae21a = v; });
$parcel$export(module.exports, "aitReadonlyCell", function () { return $6f737a8730fda513$export$1f43ce3225eaafa6; }, function (v) { return $6f737a8730fda513$export$1f43ce3225eaafa6 = v; });
$parcel$export(module.exports, "aitRowButtons", function () { return $6f737a8730fda513$export$bdce32b86360bdde; }, function (v) { return $6f737a8730fda513$export$bdce32b86360bdde = v; });
$parcel$export(module.exports, "aitRowGroupButtons", function () { return $6f737a8730fda513$export$e2f53b1e18778678; }, function (v) { return $6f737a8730fda513$export$e2f53b1e18778678 = v; });
$parcel$export(module.exports, "aitRowHeaderCell", function () { return $6f737a8730fda513$export$6a9d38fd999674d0; }, function (v) { return $6f737a8730fda513$export$6a9d38fd999674d0 = v; });
$parcel$export(module.exports, "aitSpaceCell", function () { return $6f737a8730fda513$export$81cc2b81fa8469a5; }, function (v) { return $6f737a8730fda513$export$81cc2b81fa8469a5 = v; });
$parcel$export(module.exports, "aitTable", function () { return $6f737a8730fda513$export$d5b17522385c7e4e; }, function (v) { return $6f737a8730fda513$export$d5b17522385c7e4e = v; });
$parcel$export(module.exports, "aitTableOptions", function () { return $6f737a8730fda513$export$893505c455e9813b; }, function (v) { return $6f737a8730fda513$export$893505c455e9813b = v; });
$parcel$export(module.exports, "aiwBody", function () { return $6f737a8730fda513$export$866ea484f3a6b390; }, function (v) { return $6f737a8730fda513$export$866ea484f3a6b390 = v; });
$parcel$export(module.exports, "aiwBodyRow", function () { return $6f737a8730fda513$export$bfa9e64f43371c4b; }, function (v) { return $6f737a8730fda513$export$bfa9e64f43371c4b = v; });
$parcel$export(module.exports, "aiwHolder", function () { return $6f737a8730fda513$export$b7a8a3aa000ba043; }, function (v) { return $6f737a8730fda513$export$b7a8a3aa000ba043 = v; });
$parcel$export(module.exports, "borderBlackSolid", function () { return $6f737a8730fda513$export$6df1d6c7dea98904; }, function (v) { return $6f737a8730fda513$export$6df1d6c7dea98904 = v; });
$parcel$export(module.exports, "borderBottomBurlyWood", function () { return $6f737a8730fda513$export$b7cbe781f039733b; }, function (v) { return $6f737a8730fda513$export$b7cbe781f039733b = v; });
$parcel$export(module.exports, "borderBurlyWoodDotted", function () { return $6f737a8730fda513$export$f136e0ad00f5f517; }, function (v) { return $6f737a8730fda513$export$f136e0ad00f5f517 = v; });
$parcel$export(module.exports, "borderLeftBurlyWood", function () { return $6f737a8730fda513$export$c8594d35c2fcdbd; }, function (v) { return $6f737a8730fda513$export$c8594d35c2fcdbd = v; });
$parcel$export(module.exports, "borderNone", function () { return $6f737a8730fda513$export$695e5a0c7f545a4e; }, function (v) { return $6f737a8730fda513$export$695e5a0c7f545a4e = v; });
$parcel$export(module.exports, "borderRadiusBottomRight", function () { return $6f737a8730fda513$export$1987e8fd2120747d; }, function (v) { return $6f737a8730fda513$export$1987e8fd2120747d = v; });
$parcel$export(module.exports, "borderRadiusTopLeft", function () { return $6f737a8730fda513$export$d4a57905f285d6a0; }, function (v) { return $6f737a8730fda513$export$d4a57905f285d6a0 = v; });
$parcel$export(module.exports, "borderRadiusTopRight", function () { return $6f737a8730fda513$export$1cf3dcb00b707e64; }, function (v) { return $6f737a8730fda513$export$1cf3dcb00b707e64 = v; });
$parcel$export(module.exports, "borderTopBottomBurlyWood", function () { return $6f737a8730fda513$export$b72258acdf45e466; }, function (v) { return $6f737a8730fda513$export$b72258acdf45e466 = v; });
$parcel$export(module.exports, "borderTopBurlyWood", function () { return $6f737a8730fda513$export$3069856c381821fd; }, function (v) { return $6f737a8730fda513$export$3069856c381821fd = v; });
$parcel$export(module.exports, "calcSize", function () { return $6f737a8730fda513$export$ffb38d77b69e936e; }, function (v) { return $6f737a8730fda513$export$ffb38d77b69e936e = v; });
$parcel$export(module.exports, "closed", function () { return $6f737a8730fda513$export$15ff61f90f7efc74; }, function (v) { return $6f737a8730fda513$export$15ff61f90f7efc74 = v; });
$parcel$export(module.exports, "colorRed", function () { return $6f737a8730fda513$export$821c049260f9784c; }, function (v) { return $6f737a8730fda513$export$821c049260f9784c = v; });
$parcel$export(module.exports, "editorInput", function () { return $6f737a8730fda513$export$92e7d85052fbf2bf; }, function (v) { return $6f737a8730fda513$export$92e7d85052fbf2bf = v; });
$parcel$export(module.exports, "flexCenter", function () { return $6f737a8730fda513$export$6f9e4349aad79600; }, function (v) { return $6f737a8730fda513$export$6f9e4349aad79600 = v; });
$parcel$export(module.exports, "flexColumn", function () { return $6f737a8730fda513$export$ba9a56610c2a1379; }, function (v) { return $6f737a8730fda513$export$ba9a56610c2a1379 = v; });
$parcel$export(module.exports, "flexColumnGap2", function () { return $6f737a8730fda513$export$e7f624d71a302dc4; }, function (v) { return $6f737a8730fda513$export$e7f624d71a302dc4 = v; });
$parcel$export(module.exports, "flexGrow1", function () { return $6f737a8730fda513$export$edd148d0ba8d7e28; }, function (v) { return $6f737a8730fda513$export$edd148d0ba8d7e28 = v; });
$parcel$export(module.exports, "flexRow", function () { return $6f737a8730fda513$export$3b0508b4994f1c2d; }, function (v) { return $6f737a8730fda513$export$3b0508b4994f1c2d = v; });
$parcel$export(module.exports, "flexRowCenter", function () { return $6f737a8730fda513$export$e775859361eabb6a; }, function (v) { return $6f737a8730fda513$export$e775859361eabb6a = v; });
$parcel$export(module.exports, "flexRowEnd", function () { return $6f737a8730fda513$export$9446d87636e6bee2; }, function (v) { return $6f737a8730fda513$export$9446d87636e6bee2 = v; });
$parcel$export(module.exports, "flexRowStart", function () { return $6f737a8730fda513$export$132b47f05e1a488d; }, function (v) { return $6f737a8730fda513$export$132b47f05e1a488d = v; });
$parcel$export(module.exports, "fontItalic", function () { return $6f737a8730fda513$export$20cdc57ab9d905f9; }, function (v) { return $6f737a8730fda513$export$20cdc57ab9d905f9 = v; });
$parcel$export(module.exports, "fullSize", function () { return $6f737a8730fda513$export$431f51906092b59f; }, function (v) { return $6f737a8730fda513$export$431f51906092b59f = v; });
$parcel$export(module.exports, "hidden", function () { return $6f737a8730fda513$export$73920f18ca706874; }, function (v) { return $6f737a8730fda513$export$73920f18ca706874 = v; });
$parcel$export(module.exports, "margin2", function () { return $6f737a8730fda513$export$5dbac88aa7d65388; }, function (v) { return $6f737a8730fda513$export$5dbac88aa7d65388 = v; });
$parcel$export(module.exports, "margin6", function () { return $6f737a8730fda513$export$196a89292c4f85f5; }, function (v) { return $6f737a8730fda513$export$196a89292c4f85f5 = v; });
$parcel$export(module.exports, "marginBottom2", function () { return $6f737a8730fda513$export$f10ee6d57d6fb05e; }, function (v) { return $6f737a8730fda513$export$f10ee6d57d6fb05e = v; });
$parcel$export(module.exports, "marginLeft25", function () { return $6f737a8730fda513$export$9ec761144c658cdb; }, function (v) { return $6f737a8730fda513$export$9ec761144c658cdb = v; });
$parcel$export(module.exports, "marginRight025", function () { return $6f737a8730fda513$export$8d6076201b3f1dd5; }, function (v) { return $6f737a8730fda513$export$8d6076201b3f1dd5 = v; });
$parcel$export(module.exports, "marginTop2", function () { return $6f737a8730fda513$export$8aebfe367061b934; }, function (v) { return $6f737a8730fda513$export$8aebfe367061b934 = v; });
$parcel$export(module.exports, "marginTopBottom6", function () { return $6f737a8730fda513$export$1e900c5a84bf0f8b; }, function (v) { return $6f737a8730fda513$export$1e900c5a84bf0f8b = v; });
$parcel$export(module.exports, "maxHeight75vh", function () { return $6f737a8730fda513$export$9971c0517e8beb25; }, function (v) { return $6f737a8730fda513$export$9971c0517e8beb25 = v; });
$parcel$export(module.exports, "one", function () { return $6f737a8730fda513$export$80bf7733f1207381; }, function (v) { return $6f737a8730fda513$export$80bf7733f1207381 = v; });
$parcel$export(module.exports, "open", function () { return $6f737a8730fda513$export$3ce6949f20cea765; }, function (v) { return $6f737a8730fda513$export$3ce6949f20cea765 = v; });
$parcel$export(module.exports, "overflowVisible", function () { return $6f737a8730fda513$export$484949d7e9999497; }, function (v) { return $6f737a8730fda513$export$484949d7e9999497 = v; });
$parcel$export(module.exports, "padding2", function () { return $6f737a8730fda513$export$3b51273408708f4a; }, function (v) { return $6f737a8730fda513$export$3b51273408708f4a = v; });
$parcel$export(module.exports, "positionAbsolute", function () { return $6f737a8730fda513$export$f8d144aafbd3a470; }, function (v) { return $6f737a8730fda513$export$f8d144aafbd3a470 = v; });
$parcel$export(module.exports, "positionRelative", function () { return $6f737a8730fda513$export$fc51f1cf90283cd4; }, function (v) { return $6f737a8730fda513$export$fc51f1cf90283cd4 = v; });
$parcel$export(module.exports, "replacementButtonArea", function () { return $6f737a8730fda513$export$a29862c53985aa32; }, function (v) { return $6f737a8730fda513$export$a29862c53985aa32 = v; });
$parcel$export(module.exports, "replacementContainer", function () { return $6f737a8730fda513$export$de098d98afae6c81; }, function (v) { return $6f737a8730fda513$export$de098d98afae6c81 = v; });
$parcel$export(module.exports, "replacementRow", function () { return $6f737a8730fda513$export$280ab2fe54c0c581; }, function (v) { return $6f737a8730fda513$export$280ab2fe54c0c581 = v; });
$parcel$export(module.exports, "replacementRowIndented", function () { return $6f737a8730fda513$export$296b2fde5c74285a; }, function (v) { return $6f737a8730fda513$export$296b2fde5c74285a = v; });
$parcel$export(module.exports, "showBorders", function () { return $6f737a8730fda513$export$5226b987273bdf30; }, function (v) { return $6f737a8730fda513$export$5226b987273bdf30 = v; });
$parcel$export(module.exports, "three", function () { return $6f737a8730fda513$export$c93cff18cf760708; }, function (v) { return $6f737a8730fda513$export$c93cff18cf760708 = v; });
$parcel$export(module.exports, "two", function () { return $6f737a8730fda513$export$7dfe6c2e21a8ba69; }, function (v) { return $6f737a8730fda513$export$7dfe6c2e21a8ba69 = v; });
$parcel$export(module.exports, "width170", function () { return $6f737a8730fda513$export$957f4aac05bf3d72; }, function (v) { return $6f737a8730fda513$export$957f4aac05bf3d72 = v; });
$parcel$export(module.exports, "width5", function () { return $6f737a8730fda513$export$5a30a35b9f478dc6; }, function (v) { return $6f737a8730fda513$export$5a30a35b9f478dc6 = v; });
var $6f737a8730fda513$export$4f17df0ebee58067;
var $6f737a8730fda513$export$736d3278694cc0fd;
var $6f737a8730fda513$export$7f77d671e2687ea;
var $6f737a8730fda513$export$89918ebbc3c127c7;
var $6f737a8730fda513$export$66df7e9d68209f2d;
var $6f737a8730fda513$export$ac63149497c27d24;
var $6f737a8730fda513$export$ae3f66ca17a91b3;
var $6f737a8730fda513$export$a91deb551c57e7a5;
var $6f737a8730fda513$export$e84853277b98a973;
var $6f737a8730fda513$export$f4f787701cf85254;
var $6f737a8730fda513$export$131bac28331688a9;
var $6f737a8730fda513$export$29397c928c4a5781;
var $6f737a8730fda513$export$3f13e480f6c5271a;
var $6f737a8730fda513$export$992e111a1534dd31;
var $6f737a8730fda513$export$53de806239109854;
var $6f737a8730fda513$export$94a472f130bf47c;
var $6f737a8730fda513$export$7fe9b8b6deeca5a5;
var $6f737a8730fda513$export$8bf3840a8957b76;
var $6f737a8730fda513$export$aab6956240d8473;
var $6f737a8730fda513$export$143e3912c99e9ff8;
var $6f737a8730fda513$export$67ec89fec3652885;
var $6f737a8730fda513$export$4d4d141944f68e7b;
var $6f737a8730fda513$export$39303ae8a955ff80;
var $6f737a8730fda513$export$2c2ee864cc2b56ef;
var $6f737a8730fda513$export$4c5ef43f16eec51e;
var $6f737a8730fda513$export$8b1c716ddb7d836f;
var $6f737a8730fda513$export$2159c038930d1595;
var $6f737a8730fda513$export$c03d9c90aff15581;
var $6f737a8730fda513$export$2407bd150fcd71d8;
var $6f737a8730fda513$export$2be84b11fc1cc84a;
var $6f737a8730fda513$export$9588e6031755613e;
var $6f737a8730fda513$export$1a7319974a0b196d;
var $6f737a8730fda513$export$a5ba150a6cd3665d;
var $6f737a8730fda513$export$70b5f208320769cb;
var $6f737a8730fda513$export$a9167f570deabdf3;
var $6f737a8730fda513$export$e4e1a0786f152291;
var $6f737a8730fda513$export$e5f4a6b7e232f3b2;
var $6f737a8730fda513$export$c39c6162216fb32d;
var $6f737a8730fda513$export$497deef337205b54;
var $6f737a8730fda513$export$954d66e350b33664;
var $6f737a8730fda513$export$ac8617dc00b55765;
var $6f737a8730fda513$export$42ad9a1f9232e67d;
var $6f737a8730fda513$export$91ab19af263ed1e5;
var $6f737a8730fda513$export$5af554cb0e1c69ad;
var $6f737a8730fda513$export$8a7c2065a6431a02;
var $6f737a8730fda513$export$a77474c7ffd9b171;
var $6f737a8730fda513$export$10d4ca81a4f67998;
var $6f737a8730fda513$export$61a59f7a4de889f3;
var $6f737a8730fda513$export$42e3bbcebe288980;
var $6f737a8730fda513$export$eb941bdcd92a43d1;
var $6f737a8730fda513$export$6b79775752681cf8;
var $6f737a8730fda513$export$88c6530c3b4d23cf;
var $6f737a8730fda513$export$bfec69f8cbe4c4d6;
var $6f737a8730fda513$export$68ea70fb62bde31c;
var $6f737a8730fda513$export$1e9a6bab843d251a;
var $6f737a8730fda513$export$f9fc73d7b6311543;
var $6f737a8730fda513$export$8b1dbac6337160ce;
var $6f737a8730fda513$export$570ca4ca47e6110e;
var $6f737a8730fda513$export$638d7b7a98bf4800;
var $6f737a8730fda513$export$daf8802eb43d7f66;
var $6f737a8730fda513$export$37edeaef6dea6;
var $6f737a8730fda513$export$7e4603536a9f1f5a;
var $6f737a8730fda513$export$949a8d6e33131d43;
var $6f737a8730fda513$export$c676ef791a38437e;
var $6f737a8730fda513$export$1d47042371b84542;
var $6f737a8730fda513$export$b92d6afdcd523774;
var $6f737a8730fda513$export$342f2ecab8e21136;
var $6f737a8730fda513$export$e2040b8db4e5c9f6;
var $6f737a8730fda513$export$3b9f395efd9e3155;
var $6f737a8730fda513$export$54ec96a9c09dc200;
var $6f737a8730fda513$export$57b3b332a0c04132;
var $6f737a8730fda513$export$f8b7bb939646bdba;
var $6f737a8730fda513$export$27cb2bbe58ae21a;
var $6f737a8730fda513$export$1f43ce3225eaafa6;
var $6f737a8730fda513$export$bdce32b86360bdde;
var $6f737a8730fda513$export$e2f53b1e18778678;
var $6f737a8730fda513$export$6a9d38fd999674d0;
var $6f737a8730fda513$export$81cc2b81fa8469a5;
var $6f737a8730fda513$export$d5b17522385c7e4e;
var $6f737a8730fda513$export$893505c455e9813b;
var $6f737a8730fda513$export$866ea484f3a6b390;
var $6f737a8730fda513$export$bfa9e64f43371c4b;
var $6f737a8730fda513$export$b7a8a3aa000ba043;
var $6f737a8730fda513$export$6df1d6c7dea98904;
var $6f737a8730fda513$export$b7cbe781f039733b;
var $6f737a8730fda513$export$f136e0ad00f5f517;
var $6f737a8730fda513$export$c8594d35c2fcdbd;
var $6f737a8730fda513$export$695e5a0c7f545a4e;
var $6f737a8730fda513$export$1987e8fd2120747d;
var $6f737a8730fda513$export$d4a57905f285d6a0;
var $6f737a8730fda513$export$1cf3dcb00b707e64;
var $6f737a8730fda513$export$b72258acdf45e466;
var $6f737a8730fda513$export$3069856c381821fd;
var $6f737a8730fda513$export$ffb38d77b69e936e;
var $6f737a8730fda513$export$15ff61f90f7efc74;
var $6f737a8730fda513$export$821c049260f9784c;
var $6f737a8730fda513$export$92e7d85052fbf2bf;
var $6f737a8730fda513$export$6f9e4349aad79600;
var $6f737a8730fda513$export$ba9a56610c2a1379;
var $6f737a8730fda513$export$e7f624d71a302dc4;
var $6f737a8730fda513$export$edd148d0ba8d7e28;
var $6f737a8730fda513$export$3b0508b4994f1c2d;
var $6f737a8730fda513$export$e775859361eabb6a;
var $6f737a8730fda513$export$9446d87636e6bee2;
var $6f737a8730fda513$export$132b47f05e1a488d;
var $6f737a8730fda513$export$20cdc57ab9d905f9;
var $6f737a8730fda513$export$431f51906092b59f;
var $6f737a8730fda513$export$73920f18ca706874;
var $6f737a8730fda513$export$5dbac88aa7d65388;
var $6f737a8730fda513$export$196a89292c4f85f5;
var $6f737a8730fda513$export$f10ee6d57d6fb05e;
var $6f737a8730fda513$export$9ec761144c658cdb;
var $6f737a8730fda513$export$8d6076201b3f1dd5;
var $6f737a8730fda513$export$8aebfe367061b934;
var $6f737a8730fda513$export$1e900c5a84bf0f8b;
var $6f737a8730fda513$export$9971c0517e8beb25;
var $6f737a8730fda513$export$80bf7733f1207381;
var $6f737a8730fda513$export$3ce6949f20cea765;
var $6f737a8730fda513$export$484949d7e9999497;
var $6f737a8730fda513$export$3b51273408708f4a;
var $6f737a8730fda513$export$f8d144aafbd3a470;
var $6f737a8730fda513$export$fc51f1cf90283cd4;
var $6f737a8730fda513$export$a29862c53985aa32;
var $6f737a8730fda513$export$de098d98afae6c81;
var $6f737a8730fda513$export$280ab2fe54c0c581;
var $6f737a8730fda513$export$296b2fde5c74285a;
var $6f737a8730fda513$export$5226b987273bdf30;
var $6f737a8730fda513$export$c93cff18cf760708;
var $6f737a8730fda513$export$7dfe6c2e21a8ba69;
var $6f737a8730fda513$export$957f4aac05bf3d72;
var $6f737a8730fda513$export$5a30a35b9f478dc6;
$6f737a8730fda513$export$4f17df0ebee58067 = `mos-aic-module-9x6Wxa-absoluteLeft0`;
$6f737a8730fda513$export$736d3278694cc0fd = `mos-aic-module-9x6Wxa-absoluteTopRight`;
$6f737a8730fda513$export$7f77d671e2687ea = `mos-aic-module-9x6Wxa-aibBlock`;
$6f737a8730fda513$export$89918ebbc3c127c7 = `mos-aic-module-9x6Wxa-aibLine`;
$6f737a8730fda513$export$66df7e9d68209f2d = `mos-aic-module-9x6Wxa-aibLineButtons`;
$6f737a8730fda513$export$ac63149497c27d24 = `mos-aic-module-9x6Wxa-aibLineItem`;
$6f737a8730fda513$export$ae3f66ca17a91b3 = `mos-aic-module-9x6Wxa-aibLineItemHolder`;
$6f737a8730fda513$export$a91deb551c57e7a5 = `mos-aic-module-9x6Wxa-aibReadOnly`;
$6f737a8730fda513$export$e84853277b98a973 = `mos-aic-module-9x6Wxa-aieOuter`;
$6f737a8730fda513$export$f4f787701cf85254 = `mos-aic-module-9x6Wxa-aioBodyRow`;
$6f737a8730fda513$export$131bac28331688a9 = `mos-aic-module-9x6Wxa-aioButtonHolder`;
$6f737a8730fda513$export$29397c928c4a5781 = `mos-aic-module-9x6Wxa-aioCommentHolder`;
$6f737a8730fda513$export$3f13e480f6c5271a = `mos-aic-module-9x6Wxa-aioDropItem`;
$6f737a8730fda513$export$992e111a1534dd31 = `mos-aic-module-9x6Wxa-aioDropItemsHolder`;
$6f737a8730fda513$export$53de806239109854 = `mos-aic-module-9x6Wxa-aioDropItemsInnerHolder`;
$6f737a8730fda513$export$94a472f130bf47c = `mos-aic-module-9x6Wxa-aioInput`;
$6f737a8730fda513$export$7fe9b8b6deeca5a5 = `mos-aic-module-9x6Wxa-aioInputHolder`;
$6f737a8730fda513$export$8bf3840a8957b76 = `mos-aic-module-9x6Wxa-aioLabel`;
$6f737a8730fda513$export$aab6956240d8473 = `mos-aic-module-9x6Wxa-aioRoValue`;
$6f737a8730fda513$export$143e3912c99e9ff8 = `mos-aic-module-9x6Wxa-aioRow`;
$6f737a8730fda513$export$67ec89fec3652885 = `mos-aic-module-9x6Wxa-aioSelect`;
$6f737a8730fda513$export$4d4d141944f68e7b = `mos-aic-module-9x6Wxa-aioTip`;
$6f737a8730fda513$export$39303ae8a955ff80 = `mos-aic-module-9x6Wxa-aioTipBottom`;
$6f737a8730fda513$export$2c2ee864cc2b56ef = `mos-aic-module-9x6Wxa-aioTipBottom2`;
$6f737a8730fda513$export$4c5ef43f16eec51e = `mos-aic-module-9x6Wxa-aioTipLeft`;
$6f737a8730fda513$export$8b1c716ddb7d836f = `mos-aic-module-9x6Wxa-aioTipLeft2`;
$6f737a8730fda513$export$2159c038930d1595 = `mos-aic-module-9x6Wxa-aioTipLhs`;
$6f737a8730fda513$export$c03d9c90aff15581 = `mos-aic-module-9x6Wxa-aioTipRhs`;
$6f737a8730fda513$export$2407bd150fcd71d8 = `mos-aic-module-9x6Wxa-aioTipRight`;
$6f737a8730fda513$export$2be84b11fc1cc84a = `mos-aic-module-9x6Wxa-aioTipRight2`;
$6f737a8730fda513$export$9588e6031755613e = `mos-aic-module-9x6Wxa-aioTipTop`;
$6f737a8730fda513$export$1a7319974a0b196d = `mos-aic-module-9x6Wxa-aioTipTop2`;
$6f737a8730fda513$export$a5ba150a6cd3665d = `mos-aic-module-9x6Wxa-aioTiptext`;
$6f737a8730fda513$export$70b5f208320769cb = `mos-aic-module-9x6Wxa-aioTiptext2`;
$6f737a8730fda513$export$a9167f570deabdf3 = `mos-aic-module-9x6Wxa-aioTiptextBottomarrow`;
$6f737a8730fda513$export$e4e1a0786f152291 = `mos-aic-module-9x6Wxa-aioTiptextLeftarrow`;
$6f737a8730fda513$export$e5f4a6b7e232f3b2 = `mos-aic-module-9x6Wxa-aioTiptextRightarrow`;
$6f737a8730fda513$export$c39c6162216fb32d = `mos-aic-module-9x6Wxa-aioTiptextToparrow`;
$6f737a8730fda513$export$497deef337205b54 = `mos-aic-module-9x6Wxa-aioUpdateButton`;
$6f737a8730fda513$export$954d66e350b33664 = `mos-aic-module-9x6Wxa-aioValue`;
$6f737a8730fda513$export$ac8617dc00b55765 = `mos-aic-module-9x6Wxa-aiordMain`;
$6f737a8730fda513$export$42ad9a1f9232e67d = `mos-aic-module-9x6Wxa-aiordvMain`;
$6f737a8730fda513$export$91ab19af263ed1e5 = `mos-aic-module-9x6Wxa-aiox`;
$6f737a8730fda513$export$5af554cb0e1c69ad = `mos-aic-module-9x6Wxa-aioxAddDown`;
$6f737a8730fda513$export$8a7c2065a6431a02 = `mos-aic-module-9x6Wxa-aioxButton`;
$6f737a8730fda513$export$a77474c7ffd9b171 = `mos-aic-module-9x6Wxa-aioxButtonCell`;
$6f737a8730fda513$export$10d4ca81a4f67998 = `mos-aic-module-9x6Wxa-aioxButtonHolder`;
$6f737a8730fda513$export$61a59f7a4de889f3 = `mos-aic-module-9x6Wxa-aioxButtonRowGroup`;
$6f737a8730fda513$export$42e3bbcebe288980 = `mos-aic-module-9x6Wxa-aioxButtonRowOptions`;
$6f737a8730fda513$export$eb941bdcd92a43d1 = `mos-aic-module-9x6Wxa-aioxButtonSettings`;
$6f737a8730fda513$export$6b79775752681cf8 = `mos-aic-module-9x6Wxa-aioxCircle`;
$6f737a8730fda513$export$88c6530c3b4d23cf = `mos-aic-module-9x6Wxa-aioxCircleRed`;
$6f737a8730fda513$export$bfec69f8cbe4c4d6 = `mos-aic-module-9x6Wxa-aioxDown`;
$6f737a8730fda513$export$68ea70fb62bde31c = `mos-aic-module-9x6Wxa-aioxExplode`;
$6f737a8730fda513$export$1e9a6bab843d251a = `mos-aic-module-9x6Wxa-aioxGrip`;
$6f737a8730fda513$export$f9fc73d7b6311543 = `mos-aic-module-9x6Wxa-aioxImplode`;
$6f737a8730fda513$export$8b1dbac6337160ce = `mos-aic-module-9x6Wxa-aioxLabel`;
$6f737a8730fda513$export$570ca4ca47e6110e = `mos-aic-module-9x6Wxa-aioxList`;
$6f737a8730fda513$export$638d7b7a98bf4800 = `mos-aic-module-9x6Wxa-aioxMinus`;
$6f737a8730fda513$export$daf8802eb43d7f66 = `mos-aic-module-9x6Wxa-aioxOpenClose`;
$6f737a8730fda513$export$37edeaef6dea6 = `mos-aic-module-9x6Wxa-aioxPlus`;
$6f737a8730fda513$export$7e4603536a9f1f5a = `mos-aic-module-9x6Wxa-aioxRemoveUp`;
$6f737a8730fda513$export$949a8d6e33131d43 = `mos-aic-module-9x6Wxa-aioxTable`;
$6f737a8730fda513$export$c676ef791a38437e = `mos-aic-module-9x6Wxa-aioxUp`;
$6f737a8730fda513$export$1d47042371b84542 = `mos-aic-module-9x6Wxa-aitAieHolder`;
$6f737a8730fda513$export$b92d6afdcd523774 = `mos-aic-module-9x6Wxa-aitAieHolderButton`;
$6f737a8730fda513$export$342f2ecab8e21136 = `mos-aic-module-9x6Wxa-aitBodyCell`;
$6f737a8730fda513$export$e2040b8db4e5c9f6 = `mos-aic-module-9x6Wxa-aitBorderCell`;
$6f737a8730fda513$export$3b9f395efd9e3155 = `mos-aic-module-9x6Wxa-aitCell`;
$6f737a8730fda513$export$54ec96a9c09dc200 = `mos-aic-module-9x6Wxa-aitColumnButtons`;
$6f737a8730fda513$export$57b3b332a0c04132 = `mos-aic-module-9x6Wxa-aitHeaderCell`;
$6f737a8730fda513$export$f8b7bb939646bdba = `mos-aic-module-9x6Wxa-aitHolder`;
$6f737a8730fda513$export$27cb2bbe58ae21a = `mos-aic-module-9x6Wxa-aitOptionsButton`;
$6f737a8730fda513$export$1f43ce3225eaafa6 = `mos-aic-module-9x6Wxa-aitReadonlyCell`;
$6f737a8730fda513$export$bdce32b86360bdde = `mos-aic-module-9x6Wxa-aitRowButtons`;
$6f737a8730fda513$export$e2f53b1e18778678 = `mos-aic-module-9x6Wxa-aitRowGroupButtons`;
$6f737a8730fda513$export$6a9d38fd999674d0 = `mos-aic-module-9x6Wxa-aitRowHeaderCell`;
$6f737a8730fda513$export$81cc2b81fa8469a5 = `mos-aic-module-9x6Wxa-aitSpaceCell`;
$6f737a8730fda513$export$d5b17522385c7e4e = `mos-aic-module-9x6Wxa-aitTable`;
$6f737a8730fda513$export$893505c455e9813b = `mos-aic-module-9x6Wxa-aitTableOptions`;
$6f737a8730fda513$export$866ea484f3a6b390 = `mos-aic-module-9x6Wxa-aiwBody`;
$6f737a8730fda513$export$bfa9e64f43371c4b = `mos-aic-module-9x6Wxa-aiwBodyRow`;
$6f737a8730fda513$export$b7a8a3aa000ba043 = `mos-aic-module-9x6Wxa-aiwHolder`;
$6f737a8730fda513$export$6df1d6c7dea98904 = `mos-aic-module-9x6Wxa-borderBlackSolid`;
$6f737a8730fda513$export$b7cbe781f039733b = `mos-aic-module-9x6Wxa-borderBottomBurlyWood`;
$6f737a8730fda513$export$f136e0ad00f5f517 = `mos-aic-module-9x6Wxa-borderBurlyWoodDotted`;
$6f737a8730fda513$export$c8594d35c2fcdbd = `mos-aic-module-9x6Wxa-borderLeftBurlyWood`;
$6f737a8730fda513$export$695e5a0c7f545a4e = `mos-aic-module-9x6Wxa-borderNone`;
$6f737a8730fda513$export$1987e8fd2120747d = `mos-aic-module-9x6Wxa-borderRadiusBottomRight`;
$6f737a8730fda513$export$d4a57905f285d6a0 = `mos-aic-module-9x6Wxa-borderRadiusTopLeft`;
$6f737a8730fda513$export$1cf3dcb00b707e64 = `mos-aic-module-9x6Wxa-borderRadiusTopRight`;
$6f737a8730fda513$export$b72258acdf45e466 = `mos-aic-module-9x6Wxa-borderTopBottomBurlyWood`;
$6f737a8730fda513$export$3069856c381821fd = `mos-aic-module-9x6Wxa-borderTopBurlyWood`;
$6f737a8730fda513$export$ffb38d77b69e936e = `mos-aic-module-9x6Wxa-calcSize`;
$6f737a8730fda513$export$15ff61f90f7efc74 = `mos-aic-module-9x6Wxa-closed`;
$6f737a8730fda513$export$821c049260f9784c = `mos-aic-module-9x6Wxa-colorRed`;
$6f737a8730fda513$export$92e7d85052fbf2bf = `mos-aic-module-9x6Wxa-editorInput`;
$6f737a8730fda513$export$6f9e4349aad79600 = `mos-aic-module-9x6Wxa-flexCenter`;
$6f737a8730fda513$export$ba9a56610c2a1379 = `mos-aic-module-9x6Wxa-flexColumn`;
$6f737a8730fda513$export$e7f624d71a302dc4 = `mos-aic-module-9x6Wxa-flexColumnGap2`;
$6f737a8730fda513$export$edd148d0ba8d7e28 = `mos-aic-module-9x6Wxa-flexGrow1`;
$6f737a8730fda513$export$3b0508b4994f1c2d = `mos-aic-module-9x6Wxa-flexRow`;
$6f737a8730fda513$export$e775859361eabb6a = `mos-aic-module-9x6Wxa-flexRowCenter`;
$6f737a8730fda513$export$9446d87636e6bee2 = `mos-aic-module-9x6Wxa-flexRowEnd`;
$6f737a8730fda513$export$132b47f05e1a488d = `mos-aic-module-9x6Wxa-flexRowStart`;
$6f737a8730fda513$export$20cdc57ab9d905f9 = `mos-aic-module-9x6Wxa-fontItalic`;
$6f737a8730fda513$export$431f51906092b59f = `mos-aic-module-9x6Wxa-fullSize`;
$6f737a8730fda513$export$73920f18ca706874 = `mos-aic-module-9x6Wxa-hidden`;
$6f737a8730fda513$export$5dbac88aa7d65388 = `mos-aic-module-9x6Wxa-margin2`;
$6f737a8730fda513$export$196a89292c4f85f5 = `mos-aic-module-9x6Wxa-margin6`;
$6f737a8730fda513$export$f10ee6d57d6fb05e = `mos-aic-module-9x6Wxa-marginBottom2`;
$6f737a8730fda513$export$9ec761144c658cdb = `mos-aic-module-9x6Wxa-marginLeft25`;
$6f737a8730fda513$export$8d6076201b3f1dd5 = `mos-aic-module-9x6Wxa-marginRight025`;
$6f737a8730fda513$export$8aebfe367061b934 = `mos-aic-module-9x6Wxa-marginTop2`;
$6f737a8730fda513$export$1e900c5a84bf0f8b = `mos-aic-module-9x6Wxa-marginTopBottom6`;
$6f737a8730fda513$export$9971c0517e8beb25 = `mos-aic-module-9x6Wxa-maxHeight75vh`;
$6f737a8730fda513$export$80bf7733f1207381 = `mos-aic-module-9x6Wxa-one`;
$6f737a8730fda513$export$3ce6949f20cea765 = `mos-aic-module-9x6Wxa-open`;
$6f737a8730fda513$export$484949d7e9999497 = `mos-aic-module-9x6Wxa-overflowVisible`;
$6f737a8730fda513$export$3b51273408708f4a = `mos-aic-module-9x6Wxa-padding2`;
$6f737a8730fda513$export$f8d144aafbd3a470 = `mos-aic-module-9x6Wxa-positionAbsolute`;
$6f737a8730fda513$export$fc51f1cf90283cd4 = `mos-aic-module-9x6Wxa-positionRelative`;
$6f737a8730fda513$export$a29862c53985aa32 = `mos-aic-module-9x6Wxa-replacementButtonArea`;
$6f737a8730fda513$export$de098d98afae6c81 = `mos-aic-module-9x6Wxa-replacementContainer`;
$6f737a8730fda513$export$280ab2fe54c0c581 = `mos-aic-module-9x6Wxa-replacementRow`;
$6f737a8730fda513$export$296b2fde5c74285a = `mos-aic-module-9x6Wxa-replacementRowIndented`;
$6f737a8730fda513$export$5226b987273bdf30 = `mos-aic-module-9x6Wxa-showBorders`;
$6f737a8730fda513$export$c93cff18cf760708 = `mos-aic-module-9x6Wxa-three`;
$6f737a8730fda513$export$7dfe6c2e21a8ba69 = `mos-aic-module-9x6Wxa-two`;
$6f737a8730fda513$export$957f4aac05bf3d72 = `mos-aic-module-9x6Wxa-width170`;
$6f737a8730fda513$export$5a30a35b9f478dc6 = `mos-aic-module-9x6Wxa-width5`;

});

parcelRegister("9Osbv", function(module, exports) {

$parcel$export(module.exports, "AioLabel", function () { return $bcf77304a3b4296c$export$46150af52b680b36; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");
const $bcf77304a3b4296c$export$46150af52b680b36 = (props)=>{
    if (props.label === undefined) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    return /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
        htmlFor: props.htmlFor,
        children: `${props.label}${!props.noColon && props.label ? ":" : ""}`
    });
};
$bcf77304a3b4296c$export$46150af52b680b36.displayName = "AioLabel";

});


parcelRegister("8kv8T", function(module, exports) {

$parcel$export(module.exports, "AioComment", function () { return $9679b4ea71d4d4f5$export$f855cb22882ac682; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $eN4ax = parcelRequire("eN4ax");

var $9Osbv = parcelRequire("9Osbv");
const $9679b4ea71d4d4f5$export$f855cb22882ac682 = ({ id: id, editable: editable, label: label, setValue: setValue, value: value })=>{
    // Context
    const { state: state } = (0, $eN4ax.useTableContext)();
    const Editor = state?.editorProps.Editor;
    return !state || !Editor ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9Osbv.AioLabel), {
                id: `${id}-label`,
                label: label,
                htmlFor: `${id}-editor`
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioCommentHolder,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                    id: `${id}-editor`,
                    "aria-labelledby": `${id}-label`,
                    editable: state?.editable && editable !== false,
                    setValue: (ret)=>setValue(ret),
                    value: value
                })
            })
        ]
    });
};
$9679b4ea71d4d4f5$export$f855cb22882ac682.displayName = "AioComment";

});
parcelRegister("eN4ax", function(module, exports) {

$parcel$export(module.exports, "TableContextProvider", function () { return $48aaa6a3076a3a92$export$2304abde66e33a52; });
$parcel$export(module.exports, "useTableContext", function () { return $48aaa6a3076a3a92$export$3cb274deb6c2d854; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $9B5Sg = parcelRequire("9B5Sg");

var $cuEIs = parcelRequire("cuEIs");

var $kv9Fc = parcelRequire("kv9Fc");
const $48aaa6a3076a3a92$export$93e4b0b2cc49b648 = /*#__PURE__*/ (0, $spJKX.createContext)(null);
/**
 * Provider that supplies table state and dispatch to child components.
 *
 * @template T - Table payload type
 * @param props - Component props
 * @param props.initialState - Initial state used to seed the table reducer
 * @param props.children - Child nodes wrapped by the provider
 * @param props.onChange - Callback invoked when table data is pushed
 */ const $48aaa6a3076a3a92$var$TableContextProviderInner = ({ initialState: initialState, children: children, onChange: onChange })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $cuEIs.tableReducer), {
        ...initialState,
        changed: false,
        showOptionsWindow: [],
        processedTableData: (0, $kv9Fc.trProcessTable)(initialState)
    });
    // Update state from top down
    (0, $spJKX.useEffect)(()=>{
        // Compare properties that are passed down
        const initialStateForComparison = {
            ...(0, $eBlbF.omit)(initialState, [
                "changed",
                "showOptionsWindow",
                "processedTableData"
            ])
        };
        const currentStateForComparison = {
            ...(0, $eBlbF.omit)(state, [
                "changed",
                "showOptionsWindow",
                "processedTableData"
            ])
        };
        const hasChanges = !(0, $eBlbF.isEqual)(initialStateForComparison, currentStateForComparison);
        if (hasChanges) {
            if (state.changed) {
                onChange(state.originalTableData);
                dispatch({
                    operation: (0, $9B5Sg.TABLE_CHANGE_PUSHED)
                });
            } else dispatch({
                operation: (0, $9B5Sg.LOAD_STATE),
                newState: initialState
            });
        }
    }, [
        initialState,
        onChange,
        state
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($48aaa6a3076a3a92$export$93e4b0b2cc49b648.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $48aaa6a3076a3a92$export$2304abde66e33a52 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).memo($48aaa6a3076a3a92$var$TableContextProviderInner);
function $48aaa6a3076a3a92$export$3cb274deb6c2d854() {
    const context = (0, $spJKX.useContext)($48aaa6a3076a3a92$export$93e4b0b2cc49b648);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
}
$48aaa6a3076a3a92$var$TableContextProviderInner.displayName = "TableContextProvider";

});
parcelRegister("eBlbF", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("9B5Sg", function(module, exports) {

$parcel$export(module.exports, "AitTablePosition", function () { return $b572703810d972f9$export$e1ae152cdf8268f0; });
$parcel$export(module.exports, "AitCellType", function () { return $b572703810d972f9$export$17673bdfcfce3de9; });
$parcel$export(module.exports, "AitRowType", function () { return $b572703810d972f9$export$df5087a2c354e5b1; });
$parcel$export(module.exports, "GridItemChangeType", function () { return $b572703810d972f9$export$5c42d5a0bc41f791; });
$parcel$export(module.exports, "ADD_COLUMN", function () { return $b572703810d972f9$export$b1bd2b223d0ce7d0; });
$parcel$export(module.exports, "ADD_COLUMN_SPAN", function () { return $b572703810d972f9$export$22ee848e0a588553; });
$parcel$export(module.exports, "ADD_NEW_HEADER", function () { return $b572703810d972f9$export$1f0180bd2af66aee; });
$parcel$export(module.exports, "ADD_ROW", function () { return $b572703810d972f9$export$ab3740b814ea86bd; });
$parcel$export(module.exports, "ADD_ROW_GROUP", function () { return $b572703810d972f9$export$bad0637c061bfb20; });
$parcel$export(module.exports, "ADD_ROW_SPAN", function () { return $b572703810d972f9$export$ce456c8fc5a7760d; });
$parcel$export(module.exports, "DUPLICATE_COLUMN", function () { return $b572703810d972f9$export$16ad9d1ad0c7b153; });
$parcel$export(module.exports, "DUPLICATE_ROW", function () { return $b572703810d972f9$export$a5b937a7720f54b4; });
$parcel$export(module.exports, "DUPLICATE_ROW_GROUP", function () { return $b572703810d972f9$export$47418fab3a00ce65; });
$parcel$export(module.exports, "HIDE_OPTIONS_WINDOW", function () { return $b572703810d972f9$export$b69ec4aab5df8df9; });
$parcel$export(module.exports, "LOAD_STATE", function () { return $b572703810d972f9$export$c303146534fe0490; });
$parcel$export(module.exports, "REMOVE_COLUMN", function () { return $b572703810d972f9$export$880be170b22764b8; });
$parcel$export(module.exports, "REMOVE_COLUMN_SPAN", function () { return $b572703810d972f9$export$1221f725a67c1599; });
$parcel$export(module.exports, "REMOVE_ROW", function () { return $b572703810d972f9$export$6629255ca195427; });
$parcel$export(module.exports, "REMOVE_ROW_GROUP", function () { return $b572703810d972f9$export$f45f2db52671a683; });
$parcel$export(module.exports, "REMOVE_ROW_SPAN", function () { return $b572703810d972f9$export$ffd0e1e7ade2502c; });
$parcel$export(module.exports, "SET_DECIMAL_ALIGN_PERCENT", function () { return $b572703810d972f9$export$9c8d488ddebd2547; });
$parcel$export(module.exports, "SET_REPLACEMENTS", function () { return $b572703810d972f9$export$48171674ada024a2; });
$parcel$export(module.exports, "SET_ROW_HEADER_COLUMNS", function () { return $b572703810d972f9$export$e8fea413d1f48458; });
$parcel$export(module.exports, "SET_SPACE_AFTER", function () { return $b572703810d972f9$export$8419baaf3b79c261; });
$parcel$export(module.exports, "SET_TRAFFIC_LIGHTS", function () { return $b572703810d972f9$export$3dad91993096c745; });
$parcel$export(module.exports, "SHOW_OPTIONS_WINDOW", function () { return $b572703810d972f9$export$b78ab6f56f27b4a1; });
$parcel$export(module.exports, "TABLE_CHANGE_PUSHED", function () { return $b572703810d972f9$export$3b6d3e69d0d7fd73; });
$parcel$export(module.exports, "UPDATE_TABLE_CELL", function () { return $b572703810d972f9$export$21524ed19486bdb9; });
$parcel$export(module.exports, "UPDATE_COLUMN_WIDTH", function () { return $b572703810d972f9$export$27579dc167134645; });
$parcel$export(module.exports, "UPDATE_COMMENTS", function () { return $b572703810d972f9$export$e3b5e95c47cb1275; });
$parcel$export(module.exports, "UPDATE_HEADER_CELL", function () { return $b572703810d972f9$export$11765fbf334c4d6a; });
var $b572703810d972f9$export$e1ae152cdf8268f0 = /*#__PURE__*/ function(AitTablePosition) {
    AitTablePosition["table"] = "table";
    AitTablePosition["header"] = "header";
    AitTablePosition["headerRow"] = "headerRow";
    AitTablePosition["headerCell"] = "headerCell";
    AitTablePosition["body"] = "body";
    AitTablePosition["bodyRowGroup"] = "bodyRowGroup";
    AitTablePosition["bodyRow"] = "bodyRow";
    AitTablePosition["bodyCell"] = "bodyCell";
    AitTablePosition["column"] = "column";
    return AitTablePosition;
}({});
var $b572703810d972f9$export$17673bdfcfce3de9 = /*#__PURE__*/ function(AitCellType) {
    AitCellType["header"] = "header";
    AitCellType["rowHeader"] = "rowHeader";
    AitCellType["body"] = "body";
    return AitCellType;
}({});
var $b572703810d972f9$export$df5087a2c354e5b1 = /*#__PURE__*/ function(AitRowType) {
    AitRowType["header"] = "header";
    AitRowType["body"] = "body";
    AitRowType["bodyRowGroup"] = "bodyRowGroup";
    return AitRowType;
}({});
var $b572703810d972f9$export$5c42d5a0bc41f791 = /*#__PURE__*/ function(GridItemChangeType) {
    GridItemChangeType["deleted"] = "deleted";
    GridItemChangeType["added"] = "added";
    return GridItemChangeType;
}({});
const $b572703810d972f9$export$b1bd2b223d0ce7d0 = "ADD_COLUMN";
const $b572703810d972f9$export$22ee848e0a588553 = "ADD_COLUMN_SPAN";
const $b572703810d972f9$export$1f0180bd2af66aee = "ADD_NEW_HEADER";
const $b572703810d972f9$export$ab3740b814ea86bd = "ADD_ROW";
const $b572703810d972f9$export$bad0637c061bfb20 = "ADD_ROW_GROUP";
const $b572703810d972f9$export$ce456c8fc5a7760d = "ADD_ROW_SPAN";
const $b572703810d972f9$export$16ad9d1ad0c7b153 = "DUPLICATE_COLUMN";
const $b572703810d972f9$export$a5b937a7720f54b4 = "DUPLICATE_ROW";
const $b572703810d972f9$export$47418fab3a00ce65 = "DUPLICATE_ROW_GROUP";
const $b572703810d972f9$export$b69ec4aab5df8df9 = "HIDE_OPTIONS_WINDOW";
const $b572703810d972f9$export$c303146534fe0490 = "LOAD_STATE";
const $b572703810d972f9$export$880be170b22764b8 = "REMOVE_COLUMN";
const $b572703810d972f9$export$1221f725a67c1599 = "REMOVE_COLUMN_SPAN";
const $b572703810d972f9$export$6629255ca195427 = "REMOVE_ROW";
const $b572703810d972f9$export$f45f2db52671a683 = "REMOVE_ROW_GROUP";
const $b572703810d972f9$export$ffd0e1e7ade2502c = "REMOVE_ROW_SPAN";
const $b572703810d972f9$export$9c8d488ddebd2547 = "SET_DECIMAL_ALIGN_PERCENT";
const $b572703810d972f9$export$48171674ada024a2 = "SET_REPLACEMENTS";
const $b572703810d972f9$export$e8fea413d1f48458 = "SET_ROW_HEADER_COLUMNS";
const $b572703810d972f9$export$8419baaf3b79c261 = "SET_SPACE_AFTER";
const $b572703810d972f9$export$3dad91993096c745 = "SET_TRAFFIC_LIGHTS";
const $b572703810d972f9$export$b78ab6f56f27b4a1 = "SHOW_OPTIONS_WINDOW";
const $b572703810d972f9$export$3b6d3e69d0d7fd73 = "TABLE_CHANGE_PUSHED";
const $b572703810d972f9$export$21524ed19486bdb9 = "UPDATE_TABLE_CELL";
const $b572703810d972f9$export$27579dc167134645 = "UPDATE_COLUMN_WIDTH";
const $b572703810d972f9$export$e3b5e95c47cb1275 = "UPDATE_COMMENTS";
const $b572703810d972f9$export$11765fbf334c4d6a = "UPDATE_HEADER_CELL";

});

parcelRegister("cuEIs", function(module, exports) {

$parcel$export(module.exports, "tableReducer", function () { return $60f70aa1f4963485$export$a093025a80a6d2a7; });

var $eBlbF = parcelRequire("eBlbF");

var $9B5Sg = parcelRequire("9B5Sg");

var $6GMBM = parcelRequire("6GMBM");

var $3slWx = parcelRequire("3slWx");

var $9kTZb = parcelRequire("9kTZb");

var $bLMi0 = parcelRequire("bLMi0");

var $9Lr16 = parcelRequire("9Lr16");

var $3oVEB = parcelRequire("3oVEB");

var $boqBf = parcelRequire("boqBf");

var $iGLIE = parcelRequire("iGLIE");

var $7SUA6 = parcelRequire("7SUA6");

var $kv9Fc = parcelRequire("kv9Fc");

var $2LFD1 = parcelRequire("2LFD1");

var $9OWn6 = parcelRequire("9OWn6");

var $gnmHr = parcelRequire("gnmHr");

var $fEtEI = parcelRequire("fEtEI");

var $95mer = parcelRequire("95mer");

var $aLZgM = parcelRequire("aLZgM");
const $60f70aa1f4963485$export$a093025a80a6d2a7 = (state, action)=>{
    let newState = {
        ...state
    };
    switch(action.operation){
        // Done
        case 0, $9B5Sg.ADD_COLUMN:
            /* istanbul ignore else */ if (state.originalTableData.bodyData.length > 0 && state.originalTableData.bodyData[0].rows.length > 0 && state.originalTableData.bodyData[0].rows[0].cells.length < action.newColumnLength) {
                const addedColumn = (0, $9kTZb.trAddColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.columnIndex, state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.columnInformation, action.newColumnLength);
                // Determine the cell ID to use for tracking the new column
                const newColumnIndex = action.columnIndex + 1;
                let idAfterTrafficLightIsShown = "";
                // Get the aitid of the first cell in the new column position
                /* istanbul ignore else */ if (addedColumn.headerData && addedColumn.headerData.rows.length > 0) // Use header cell if available
                idAfterTrafficLightIsShown = addedColumn.headerData.rows[0].cells[newColumnIndex].aitid;
                else if (addedColumn.bodyData.length > 0 && addedColumn.bodyData[0].rows.length > 0) // Fall back to first body cell
                idAfterTrafficLightIsShown = addedColumn.bodyData[0].rows[0].cells[newColumnIndex].aitid;
                // Add the new column to changedColumns
                const newChangedColumns = [
                    ...newState.originalTableData.changedColumns ?? // istanbul ignore next
                    [],
                    {
                        gridItemId: newColumnIndex.toString(),
                        coreTrafficLight: "ChangedUnknown",
                        isOptional: false,
                        gridItemChangeType: (0, $9B5Sg.GridItemChangeType).added,
                        idAfterTrafficLightIsShown: idAfterTrafficLightIsShown
                    }
                ];
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: addedColumn.headerData,
                    bodyData: addedColumn.bodyData,
                    changedColumns: newChangedColumns,
                    columnInformation: addedColumn.columnInformation
                };
                /* istanbul ignore else */ if (action.columnIndex < (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0)) // If the column is before the row header columns, we need to increase the count
                newState.originalTableData.rowHeaderColumns = (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0) + 1;
            }
            newState.changed = true;
            break;
        // Done
        case 0, $9B5Sg.ADD_COLUMN_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $3slWx.trAddColSpan)(state.originalTableData.headerData, action.location, action.newSpan, state.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0);
                /* istanbul ignore else */ if (newHeaderData) newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.ADD_NEW_HEADER:
            newState.changed = true;
            // Create new row
            /* istanbul ignore else */ if (newState.originalTableData.headerData === false) {
                // Get columnIds from the first body row
                const columnIds = state.originalTableData.columnInformation.map((ci)=>ci.columnId);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: {
                        aitid: crypto.randomUUID(),
                        rows: [
                            (0, $6GMBM.newHeaderRow)(state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.bodyData[0].rows[0].cells.length, columnIds)
                        ],
                        coreTrafficLight: "BlankNotEvaluated"
                    }
                };
            }
            break;
        // Done
        case 0, $9B5Sg.ADD_ROW:
            {
                newState.changed = true;
                // Check ok to proceed
                const addedRow = (0, $bLMi0.trAddRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location, action.newLength, state.defaultCellWidth, state.editorProps.blankT);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: addedRow.headerData ?? state.originalTableData.headerData,
                    bodyData: addedRow.bodyData ?? state.originalTableData.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $9B5Sg.ADD_ROW_GROUP:
            {
                newState.changed = true;
                const newBodyData = (0, $9Lr16.trAddRowGroup)(state.originalTableData.bodyData, state.groupTemplates, action.newLength, state.defaultCellWidth, state.editorProps.blankT, action.location.rowGroup, action.templateName);
                /* istanbul ignore else */ if (newBodyData) newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newBodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        case 0, $9B5Sg.ADD_ROW_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $3oVEB.trAddRowSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                /* istanbul ignore else */ if (newHeaderData) newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.DUPLICATE_COLUMN:
            newState.changed = true;
            // Check ok to proceed
            /* istanbul ignore else */ if (state.originalTableData.bodyData.length > 0 && state.originalTableData.bodyData[0].rows.length > 0 && state.originalTableData.bodyData[0].rows[0].cells.length < action.newColumnLength) {
                const duplicatedColumn = (0, $boqBf.trDuplicateColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.columnIndex, state.defaultCellWidth, state.editorProps.blankT, state.originalTableData.columnInformation, action.newColumnLength);
                // Determine the cell ID to use for tracking the new column
                const newColumnIndex = action.columnIndex + 1;
                let idAfterTrafficLightIsShown = "";
                // Get the aitid of the first cell in the new column position
                /* istanbul ignore else */ if (duplicatedColumn.headerData && duplicatedColumn.headerData.rows.length > 0) // Use header cell if available
                idAfterTrafficLightIsShown = duplicatedColumn.headerData.rows[0].cells[newColumnIndex].aitid;
                else if (duplicatedColumn.bodyData.length > 0 && duplicatedColumn.bodyData[0].rows.length > 0) // Fall back to first body cell
                idAfterTrafficLightIsShown = duplicatedColumn.bodyData[0].rows[0].cells[newColumnIndex].aitid;
                // Add the new column to changedColumns
                const newChangedColumns = [
                    ...newState.originalTableData.changedColumns ?? // istanbul ignore next
                    [],
                    {
                        gridItemId: newColumnIndex.toString(),
                        coreTrafficLight: "ChangedUnknown",
                        isOptional: false,
                        gridItemChangeType: (0, $9B5Sg.GridItemChangeType).added,
                        idAfterTrafficLightIsShown: idAfterTrafficLightIsShown
                    }
                ];
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: duplicatedColumn.headerData,
                    bodyData: duplicatedColumn.bodyData,
                    changedColumns: newChangedColumns,
                    columnInformation: duplicatedColumn.columnInformation
                };
                if (action.columnIndex < (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0)) // If the column is before the row header columns, we need to increase the count
                newState.originalTableData.rowHeaderColumns = (newState.originalTableData.rowHeaderColumns ?? // istanbul ignore next
                0) + 1;
            }
            break;
        // Done
        case 0, $9B5Sg.DUPLICATE_ROW:
            {
                newState.changed = true;
                // Add new row under the original row
                const duplicateRow = (0, $iGLIE.trDuplicateRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location, action.newLength);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: duplicateRow.headerData,
                    bodyData: duplicateRow.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $9B5Sg.DUPLICATE_ROW_GROUP:
            newState.changed = true;
            /* istanbul ignore else */ if (newState.originalTableData.bodyData.length < action.newLength) {
                const newBodyData = (0, $7SUA6.trDuplicateRowGroup)(state.originalTableData.bodyData, action.location.rowGroup, action.newLength);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newBodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.HIDE_OPTIONS_WINDOW:
            newState.showOptionsWindow = newState.showOptionsWindow.filter((l)=>!(0, $eBlbF.isEqual)(l, action.location));
            break;
        // Done
        case 0, $9B5Sg.LOAD_STATE:
            newState = {
                ...action.newState,
                showOptionsWindow: newState.showOptionsWindow,
                /* This will be processed later */ processedTableData: {
                    headerData: false,
                    bodyData: [],
                    coreTrafficLight: "BlankNotEvaluated",
                    decimalAlignPercent: 60,
                    columnInformation: []
                },
                changed: false
            };
            break;
        // Done
        case 0, $9B5Sg.REMOVE_COLUMN:
            {
                newState.changed = true;
                const removedColumn = (0, $9OWn6.trRemoveColumn)(state.originalTableData.headerData, state.originalTableData.bodyData, action.cellIds);
                if (newState.originalTableData.rowHeaderColumns && action.value < newState.originalTableData.rowHeaderColumns) newState.originalTableData.rowHeaderColumns = Math.max(0, newState.originalTableData.rowHeaderColumns - 1);
                // Update columnInformation: remove the column and decrement indices for columns after it
                const removedColumnIndex = action.value;
                const updatedColumnInformation = newState.originalTableData.columnInformation?.filter((ci)=>ci.originalColumnIndex !== removedColumnIndex).map((ci)=>ci.originalColumnIndex > removedColumnIndex ? {
                        ...ci,
                        originalColumnIndex: ci.originalColumnIndex - 1
                    } : ci);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: removedColumn.headerData,
                    bodyData: removedColumn.bodyData,
                    coreTrafficLight: "ChangedUnknown",
                    columnInformation: updatedColumnInformation
                };
                break;
            }
        // Done
        case 0, $9B5Sg.REMOVE_COLUMN_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $2LFD1.trRemoveColSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData ?? state.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.REMOVE_ROW:
            {
                newState.changed = true;
                const removedRow = (0, $gnmHr.trRemoveRow)(state.originalTableData.headerData, state.originalTableData.bodyData, action.location);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: removedRow.headerData ?? state.originalTableData.headerData,
                    bodyData: removedRow.bodyData ?? state.originalTableData.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
                break;
            }
        // Done
        case 0, $9B5Sg.REMOVE_ROW_GROUP:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.filter((rowGroup)=>rowGroup.aitid !== action.location.rowGroupId),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $9B5Sg.REMOVE_ROW_SPAN:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData.headerData) {
                const newHeaderData = (0, $fEtEI.trRemoveRowSpan)(state.originalTableData.headerData, action.location, action.newSpan);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: newHeaderData ?? state.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.SET_DECIMAL_ALIGN_PERCENT:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                decimalAlignPercent: action.value,
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $9B5Sg.SET_REPLACEMENTS:
            newState.changed = true;
            /* istanbul ignore else */ if (action.location.position === (0, $9B5Sg.AitTablePosition).header && newState.originalTableData.headerData) newState.originalTableData = {
                ...newState.originalTableData,
                headerData: {
                    ...newState.originalTableData.headerData,
                    coreTrafficLight: "ChangedUnknown",
                    replacements: action.replacements
                },
                coreTrafficLight: "ChangedUnknown"
            };
            else if (action.location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup && newState.originalTableData.bodyData.findIndex((rg)=>rg.aitid === action.location.rowGroupId) !== -1) newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.map((rg)=>rg.aitid === action.location.rowGroupId ? {
                        ...rg,
                        replacements: action.replacements,
                        coreTrafficLight: "ChangedUnknown"
                    } : rg),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $9B5Sg.SET_ROW_HEADER_COLUMNS:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                rowHeaderColumns: action.value,
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $9B5Sg.SET_SPACE_AFTER:
            newState.changed = true;
            newState.originalTableData = {
                ...newState.originalTableData,
                bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === action.location.rowGroupId ? {
                        ...rowGroup,
                        spaceAfter: action.bool
                    } : rowGroup),
                coreTrafficLight: "ChangedUnknown"
            };
            break;
        // Done
        case 0, $9B5Sg.SET_TRAFFIC_LIGHTS:
            newState.noTrafficLights = action.bool;
            break;
        // Done
        case 0, $9B5Sg.TABLE_CHANGE_PUSHED:
            newState.changed = false;
            break;
        // Done
        case 0, $9B5Sg.SHOW_OPTIONS_WINDOW:
            newState.showOptionsWindow = [
                ...newState.showOptionsWindow.filter((l)=>!(0, $eBlbF.isEqual)(l, action.location)),
                action.location
            ];
            break;
        // Done
        case 0, $9B5Sg.UPDATE_TABLE_CELL:
            newState.changed = true;
            // Update the replacements in the bodyData
            /* istanbul ignore else */ if (newState.originalTableData) newState.originalTableData = {
                ...newState.originalTableData,
                coreTrafficLight: "ChangedUnknown",
                bodyData: newState.originalTableData.bodyData.map((rowGroup)=>({
                        ...rowGroup,
                        coreTrafficLight: rowGroup.aitid === action.location.rowGroupId ? "ChangedUnknown" : rowGroup.coreTrafficLight,
                        rows: rowGroup.rows.map((row)=>({
                                ...row,
                                coreTrafficLight: action.location.rowId === row.aitid ? "ChangedUnknown" : row.coreTrafficLight,
                                cells: row.cells.map((c)=>c.aitid === action.location.cellId ? {
                                        ...c,
                                        ...action.cellData,
                                        coreTrafficLight: "ChangedUnknown"
                                    } : c)
                            }))
                    }))
            };
            break;
        // Done
        case 0, $9B5Sg.UPDATE_COLUMN_WIDTH:
            newState.changed = true;
            /* istanbul ignore else */ if (state.originalTableData && newState.originalTableData) {
                const updatedWidth = (0, $95mer.trUpdateColumnWidth)(state.originalTableData, action.location.originalColumn, action.value);
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: updatedWidth.headerData,
                    bodyData: updatedWidth.bodyData,
                    coreTrafficLight: "ChangedUnknown"
                };
            }
            break;
        // Done
        case 0, $9B5Sg.UPDATE_COMMENTS:
            newState.changed = true;
            newState = (0, $aLZgM.trUpdateComments)(newState, action);
            break;
        case 0, $9B5Sg.UPDATE_HEADER_CELL:
            newState.changed = true;
            // Update the replacements in the bodyData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) {
                const headerData = newState.originalTableData.headerData;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    coreTrafficLight: "ChangedUnknown",
                    headerData: {
                        ...headerData,
                        coreTrafficLight: "ChangedUnknown",
                        rows: headerData.rows.map((row)=>row.aitid === action.location.rowId ? {
                                ...row,
                                coreTrafficLight: "ChangedUnknown",
                                cells: row.cells.map((c)=>c.aitid === action.location.cellId ? {
                                        ...c,
                                        ...action.cellData,
                                        coreTrafficLight: "ChangedUnknown"
                                    } : c)
                            } : row)
                    }
                };
            }
            break;
    }
    newState.processedTableData = (0, $kv9Fc.trProcessTable)(newState);
    return newState;
};

});
parcelRegister("6GMBM", function(module, exports) {

$parcel$export(module.exports, "newRow", function () { return $fe8f112269d1de53$export$fbe120a39049074a; });
$parcel$export(module.exports, "newHeaderRow", function () { return $fe8f112269d1de53$export$dd59b3336ab2d42a; });

var $l6aIi = parcelRequire("l6aIi");
const $fe8f112269d1de53$export$fbe120a39049074a = (defaultCellWidth, blank, l, columnIds)=>{
    const newRow = {
        aitid: crypto.randomUUID(),
        cells: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    // Add new cells in a loop to avoid duplicate aitid
    for(let i = 0; i < l; i++){
        const columnId = columnIds[i];
        newRow.cells.push((0, $l6aIi.newCell)(defaultCellWidth, blank, columnId));
    }
    return newRow;
};
const $fe8f112269d1de53$export$dd59b3336ab2d42a = (defaultCellWidth, blank, l, columnIds)=>{
    const newRow = {
        aitid: crypto.randomUUID(),
        cells: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    // Add new cells in a loop to avoid duplicate aitid
    for(let i = 0; i < l; i++){
        const columnId = columnIds[i];
        newRow.cells.push((0, $l6aIi.newHeaderCell)(defaultCellWidth, blank, columnId));
    }
    return newRow;
};

});
parcelRegister("l6aIi", function(module, exports) {

$parcel$export(module.exports, "newCell", function () { return $904941aebde51568$export$80320bc05f4522a4; });
$parcel$export(module.exports, "newHeaderCell", function () { return $904941aebde51568$export$1d3e6a75a388edd1; });
const $904941aebde51568$export$80320bc05f4522a4 = (cellWidth, blank, columnId)=>{
    const cell = {
        aitid: crypto.randomUUID(),
        text: blank,
        comments: blank,
        colWidth: cellWidth,
        coreTrafficLight: "BlankNotEvaluated",
        columnId: columnId
    };
    return cell;
};
const $904941aebde51568$export$1d3e6a75a388edd1 = (cellWidth, blank, columnId)=>{
    const cell = {
        aitid: crypto.randomUUID(),
        text: blank,
        comments: blank,
        rowSpan: 1,
        colSpan: 1,
        colWidth: cellWidth,
        coreTrafficLight: "BlankNotEvaluated",
        columnId: columnId
    };
    return cell;
};

});


parcelRegister("3slWx", function(module, exports) {

$parcel$export(module.exports, "trCanAddColSpan", function () { return $7c9143c3e17e65ee$export$36a01ae58920cd3a; });
$parcel$export(module.exports, "trAddColSpan", function () { return $7c9143c3e17e65ee$export$ce1763e3b9c43eb8; });

var $9rj0c = parcelRequire("9rj0c");
const $7c9143c3e17e65ee$export$36a01ae58920cd3a = (headerData, location, newColSpan, rowHeaderColumns)=>{
    let reasonNot = "";
    let hideCell;
    // Check target cell exists
    const targetCell = (0, $9rj0c.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "AddColSpan: target cell not found";
    else if (location.isRepeat) reasonNot = "AddColSpan: this is a repeat cell";
    else if (targetCell.rowSpan !== 1) reasonNot = "AddColSpan: cell already has row span";
    else if (location.originalColumn + newColSpan === rowHeaderColumns + 1) reasonNot = "AddColSpan: colSpan would go over the rowHeader";
    else if (location.row + 1 === headerData.rows.length) reasonNot = "AddColSpan: cannot add colSpan on the last row";
    else {
        // Get the cell to hide
        const hideColumn = location.originalColumn + newColSpan - 1;
        if (headerData.rows[location.row].cells.length <= hideColumn) reasonNot = "AddColSpan: header does not have enough columns to expand";
        else {
            hideCell = headerData.rows[location.row].cells[hideColumn];
            if (hideCell.colSpan !== 1 || hideCell.rowSpan !== 1) reasonNot = "AddColSpan: hide cell is not suitable for hiding";
        }
    }
    return reasonNot !== "" ? {
        canAdd: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        hideCell: hideCell
    } : {
        canAdd: true,
        reasonNot: undefined,
        targetCell: targetCell,
        hideCell: hideCell
    };
};
const $7c9143c3e17e65ee$export$ce1763e3b9c43eb8 = (headerData, location, newSpan, rowHeaderColumns)=>{
    // Check ok to add row span
    const { canAdd: canAdd, reasonNot: reasonNot, targetCell: targetCell, hideCell: hideCell } = $7c9143c3e17e65ee$export$36a01ae58920cd3a(headerData, location, newSpan, rowHeaderColumns);
    // Already done
    if (targetCell?.colSpan === newSpan) return;
    // Cannot add
    if (!canAdd) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                colSpan: newSpan
            };
            if (cell.aitid === hideCell.aitid) return {
                ...cell,
                colSpan: 0
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});
parcelRegister("9rj0c", function(module, exports) {

$parcel$export(module.exports, "trGetCellFromLocation", function () { return $400820588dbb32e9$export$4b3baeebec5fb406; });

var $9B5Sg = parcelRequire("9B5Sg");
function $400820588dbb32e9$export$844a59309eb2fddd(rows, rowId, cellId, rowIndex, columnIndex, ignoreRepeats) {
    return rows.find((row, ri)=>row.aitid === rowId && (ignoreRepeats || rowIndex === ri))?.cells.find((cell, ci)=>cell.aitid === cellId && (ignoreRepeats || columnIndex === ci));
}
function $400820588dbb32e9$export$4b3baeebec5fb406(tableData, location, ignoreRepeats) {
    if (location.position === (0, $9B5Sg.AitTablePosition).headerCell && tableData?.headerData) return $400820588dbb32e9$export$844a59309eb2fddd(tableData.headerData.rows, location.rowId, location.cellId, location.row, location.column, ignoreRepeats);
    if (location.position === (0, $9B5Sg.AitTablePosition).bodyCell && tableData?.bodyData) {
        const rowGroup = tableData.bodyData[location.rowGroup];
        /* istanbul ignore else */ if (rowGroup) return $400820588dbb32e9$export$844a59309eb2fddd(rowGroup.rows, location.rowId, location.cellId, location.row, location.column, ignoreRepeats);
    }
    return undefined;
}

});


parcelRegister("9kTZb", function(module, exports) {

$parcel$export(module.exports, "trAddColumn", function () { return $856d332d0d548fb0$export$80fe9699b1b96651; });

var $l6aIi = parcelRequire("l6aIi");
const $856d332d0d548fb0$export$80fe9699b1b96651 = (headerData, bodyData, columnIndex, defaultCellWidth, blankT, columnInformation, newLength)=>{
    // Check column index is acceptable
    if (columnIndex < -1) throw new Error("Column index is too low");
    if (bodyData.length === 0) throw new Error("No row groups in body data");
    if (bodyData[0].rows.length === 0) throw new Error("No rows in body data");
    if (columnIndex >= bodyData[0].rows[0].cells.length) throw new Error("Column index is too high");
    if (newLength <= bodyData[0].rows[0].cells.length) return {
        headerData: headerData,
        bodyData: bodyData,
        columnInformation: columnInformation
    };
    // Generate a new columnId for the new column
    const newColumnId = crypto.randomUUID();
    // Update columnInformation array
    let updatedColumnInformation = columnInformation.map((ci)=>ci.originalColumnIndex > columnIndex ? {
            ...ci,
            originalColumnIndex: ci.originalColumnIndex + 1
        } : ci);
    // Add new columnInformation entry for the added column (with empty annotation)
    /* istanbul ignore else */ if (updatedColumnInformation) {
        const newColumnInfo = {
            columnId: newColumnId,
            originalColumnIndex: columnIndex + 1
        };
        updatedColumnInformation = [
            ...updatedColumnInformation.slice(0, columnIndex + 1),
            newColumnInfo,
            ...updatedColumnInformation.slice(columnIndex + 1)
        ];
    }
    // Update body data
    const newBody = bodyData.map((rg)=>({
            ...rg,
            rows: rg.rows.map((r)=>{
                const newCellData = (0, $l6aIi.newCell)(defaultCellWidth, blankT, newColumnId);
                return {
                    ...r,
                    cells: [
                        ...r.cells.slice(0, columnIndex + 1),
                        newCellData,
                        ...r.cells.slice(columnIndex + 1)
                    ]
                };
            })
        }));
    // Update header group
    const newHeader = headerData ? {
        ...headerData,
        rows: headerData.rows.map((r)=>{
            const cells = r.cells;
            if (columnIndex >= 0 && cells[columnIndex + 1]?.colSpan === 0) {
                let lookback = 1;
                while(lookback <= columnIndex && cells[columnIndex + 1 - lookback].colSpan === 0)lookback++;
                const spannerIx = columnIndex + 1 - lookback;
                // Only clone the spanner cell
                const spannerCell = {
                    ...cells[spannerIx],
                    colSpan: cells[spannerIx].colSpan + 1
                };
                // Add in blank cell
                const newHeaderCellData = (0, $l6aIi.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                newHeaderCellData.colSpan = 0;
                const newCells = [
                    ...cells.slice(0, columnIndex + 1),
                    newHeaderCellData,
                    ...cells.slice(columnIndex + 1)
                ];
                // Update the spanner cell in the new cells
                newCells[spannerIx] = spannerCell;
                return {
                    ...r,
                    cells: newCells
                };
            } else {
                // Only insert a new cell, reuse others
                const newHeaderCellData = (0, $l6aIi.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                const newCells = [
                    ...cells.slice(0, columnIndex + 1),
                    newHeaderCellData,
                    ...cells.slice(columnIndex + 1)
                ];
                return {
                    ...r,
                    cells: newCells
                };
            }
        })
    } : false;
    return {
        headerData: newHeader,
        bodyData: newBody,
        columnInformation: updatedColumnInformation
    };
};

});

parcelRegister("bLMi0", function(module, exports) {

$parcel$export(module.exports, "trAddRow", function () { return $c061f1973cc94935$export$8cf66db1735c9e22; });

var $9B5Sg = parcelRequire("9B5Sg");

var $l6aIi = parcelRequire("l6aIi");

var $6GMBM = parcelRequire("6GMBM");
const $c061f1973cc94935$export$8cf66db1735c9e22 = (headerData, bodyData, location, newLength, defaultCellWidth, blankT)=>{
    // Add row to header
    if ((location.position === (0, $9B5Sg.AitTablePosition).header || location.position === (0, $9B5Sg.AitTablePosition).headerRow) && headerData !== false && headerData.rows.length < newLength) {
        // For header insertion prepend (rowIndex -1); for row-level locate by rowId
        const rowIndex = location.position === (0, $9B5Sg.AitTablePosition).header ? -1 : headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newrs = [
            ...headerData.rows
        ];
        const newr = (0, $6GMBM.newHeaderRow)(defaultCellWidth, blankT, 0, []);
        const cols = headerData.rows[0].cells.map((c)=>c.colSpan).reduce((sum, a)=>sum + a, 0);
        for(let ci = 0; ci < cols; ci++){
            // Create new cell, use column width and columnId from row 0
            const c = (0, $l6aIi.newHeaderCell)(headerData.rows[0].cells[ci].colWidth ?? // istanbul ignore next
            defaultCellWidth, blankT, headerData.rows[0].cells[ci].columnId);
            // Check rowSpans on previous row
            if (rowIndex >= 0 && newrs[rowIndex].cells[ci].rowSpan !== 1) {
                let riUp = 0;
                while(riUp <= rowIndex && newrs[rowIndex - riUp].cells[ci].rowSpan === 0)riUp++;
                newrs[rowIndex - riUp].cells[ci].rowSpan = newrs[rowIndex - riUp].cells[ci].rowSpan + 1;
                c.rowSpan = 0;
            }
            newr.cells.push(c);
        }
        newr.coreTrafficLight = "ChangedUnknown";
        newrs.splice(rowIndex + 1, 0, newr);
        return {
            headerData: {
                ...headerData,
                rows: newrs,
                coreTrafficLight: "ChangedUnknown"
            }
        };
    } else if ((location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup || location.position === (0, $9B5Sg.AitTablePosition).bodyRow) && bodyData[location.rowGroup].rows.length < newLength) {
        // Add row to body row group
        const newBodyData = [
            ...bodyData
        ];
        const newRowGroup = newBodyData[location.rowGroup];
        // For group-level insertion prepend (rowIndex -1); for row-level locate by rowId
        const rowIndex = location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup ? -1 : newRowGroup.rows.findIndex((row)=>row.aitid === location.rowId);
        // Add row to body
        const newrs = [
            ...newRowGroup.rows
        ];
        const newr = (0, $6GMBM.newRow)(defaultCellWidth, blankT, 0, []);
        const cols = newRowGroup.rows[0].cells.length;
        for(let ci = 0; ci < cols; ci++){
            // Create new cell, use column width and columnId from row 0
            const c = (0, $l6aIi.newCell)(newRowGroup.rows[0].cells[ci].colWidth ?? // istanbul ignore next
            defaultCellWidth, blankT, newRowGroup.rows[0].cells[ci].columnId);
            newr.cells.push(c);
        }
        newr.coreTrafficLight = "ChangedUnknown";
        newrs.splice(rowIndex + 1, 0, newr);
        newBodyData[location.rowGroup] = {
            ...newRowGroup,
            rows: newrs,
            coreTrafficLight: "ChangedUnknown"
        };
        return {
            bodyData: newBodyData
        };
    }
    return {};
};

});

parcelRegister("9Lr16", function(module, exports) {

$parcel$export(module.exports, "trAddRowGroup", function () { return $36fff1c22f1a915b$export$a3e94cf82ca01a25; });

var $gMOiI = parcelRequire("gMOiI");
const $36fff1c22f1a915b$export$a3e94cf82ca01a25 = (bodyData, groupTemplates, newLength, defaultCellWidth, blankT, rgi, templateName)=>{
    /* istanbul ignore else */ if (bodyData.length < newLength) {
        const newBody = [
            ...bodyData
        ];
        // Create new body, take template if it can be found
        const ix = !templateName || !groupTemplates ? -1 : groupTemplates.findIndex((g)=>g.name === templateName);
        const newRowGroupTemplate = ix > -1 && groupTemplates ? groupTemplates[ix] : {
            aitid: crypto.randomUUID(),
            rows: [
                {
                    aitid: crypto.randomUUID(),
                    cells: [],
                    coreTrafficLight: "BlankNotEvaluated"
                }
            ],
            coreTrafficLight: "BlankNotEvaluated"
        };
        // Ensure new template meets requirements
        if (bodyData.length) {
            // Get columnIds from existing bodyData
            const columnIds = bodyData[0].rows[0].cells.map((c)=>c.columnId);
            const newrg = (0, $gMOiI.newRowGroup)(defaultCellWidth, blankT, bodyData[0].rows[0].cells.length, newRowGroupTemplate, columnIds);
            // Set traffic light to indicate this is a newly added row group
            newrg.coreTrafficLight = "ChangedUnknown";
            // Set column widths (columnIds already set by newRowGroup)
            newrg.rows.forEach((r)=>r.cells.forEach((c, ci)=>{
                    c.colWidth = bodyData[0].rows[0].cells[ci].colWidth;
                }));
            // Copy existing body and splice in new data
            newBody.splice(rgi + 1, 0, newrg);
        }
        return newBody;
    }
};

});
parcelRegister("gMOiI", function(module, exports) {

$parcel$export(module.exports, "newRowGroup", function () { return $b479c9a4d652c8bd$export$9c8e61b6f140016c; });

var $l6aIi = parcelRequire("l6aIi");

var $6GMBM = parcelRequire("6GMBM");
const $b479c9a4d652c8bd$export$9c8e61b6f140016c = (defaultCellWidth, blank, rowLength, newRowGroupTemplate, columnIds)=>{
    // Generate columnIds if not provided
    const finalColumnIds = columnIds ?? Array.from({
        length: rowLength
    }, ()=>crypto.randomUUID());
    return {
        aitid: crypto.randomUUID(),
        replacements: newRowGroupTemplate?.replacements ?? [],
        rows: newRowGroupTemplate?.rows.map((row)=>{
            const newCells = [];
            for(let ci = 0; ci < rowLength; ci++)newCells.push(row.cells[ci] !== undefined ? {
                ...row.cells[ci],
                aitid: crypto.randomUUID()
            } : (0, $l6aIi.newCell)(defaultCellWidth, blank, finalColumnIds[ci]));
            return {
                aitid: crypto.randomUUID(),
                cells: newCells,
                coreTrafficLight: "BlankNotEvaluated"
            };
        }) ?? [
            (0, $6GMBM.newRow)(defaultCellWidth, blank, rowLength, finalColumnIds)
        ],
        spaceAfter: true,
        coreTrafficLight: "BlankNotEvaluated"
    };
};

});


parcelRegister("3oVEB", function(module, exports) {

$parcel$export(module.exports, "trCanAddRowSpan", function () { return $b9f580d82bc6263a$export$25e3d2af48d28306; });
$parcel$export(module.exports, "trAddRowSpan", function () { return $b9f580d82bc6263a$export$383f3f36b6a92876; });

var $9rj0c = parcelRequire("9rj0c");
const $b9f580d82bc6263a$export$25e3d2af48d28306 = (headerData, location, newRowSpan)=>{
    let reasonNot = "";
    let hideCell;
    // Check target cell exists
    const targetCell = (0, $9rj0c.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "AddRowSpan: target cell not found";
    else if (targetCell.rowSpan === newRowSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "AddRowSpan: this is a repeat cell";
    else if (targetCell.colSpan !== 1) reasonNot = "AddRowSpan: cell already has column span";
    else // Get the cell to hide
    if (headerData.rows.length <= location.row + newRowSpan - 1) reasonNot = "AddRowSpan: header does not have enough rows to expand";
    else {
        hideCell = headerData.rows[location.row + newRowSpan - 1].cells[location.originalColumn];
        if (hideCell.colSpan !== 1 || hideCell.rowSpan !== 1) reasonNot = "AddRowSpan: hide cell is not suitable for hiding";
    }
    return reasonNot !== "" ? {
        canAdd: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        hideCell: hideCell
    } : {
        canAdd: true,
        reasonNot: undefined,
        targetCell: targetCell,
        hideCell: hideCell
    };
};
const $b9f580d82bc6263a$export$383f3f36b6a92876 = (headerData, location, newSpan)=>{
    // Check ok to add row span
    const { canAdd: canAdd, reasonNot: reasonNot, targetCell: targetCell, hideCell: hideCell } = $b9f580d82bc6263a$export$25e3d2af48d28306(headerData, location, newSpan);
    // Already updated
    if (targetCell?.rowSpan === newSpan) return;
    // Cannot add
    if (!canAdd) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId && !row.cells.find((c)=>c.aitid === hideCell.aitid)) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                rowSpan: newSpan
            };
            if (cell.aitid === hideCell.aitid) return {
                ...cell,
                rowSpan: 0
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("boqBf", function(module, exports) {

$parcel$export(module.exports, "trDuplicateColumn", function () { return $965e7cd67bd03746$export$511a7861c15a00a8; });

var $l6aIi = parcelRequire("l6aIi");

var $adOP8 = parcelRequire("adOP8");
const $965e7cd67bd03746$export$511a7861c15a00a8 = (headerData, bodyData, columnIndex, defaultCellWidth, blankT, columnInformation, newLength)=>{
    // Check column index is acceptable
    if (columnIndex < 0) throw new Error("Column index is too low");
    if (bodyData.length === 0) throw new Error("No row groups in body data");
    if (bodyData.some((rg)=>rg.rows.length === 0)) throw new Error("No rows in body data");
    if (columnIndex >= bodyData[0].rows[0].cells.length) throw new Error("Column index is too high");
    // Add new columnInformation entry for the duplicated column
    const originalColumnInfo = columnInformation.find((ci)=>ci.originalColumnIndex === columnIndex);
    if (!originalColumnInfo) throw new Error("Original column information not found");
    if (newLength <= bodyData[0].rows[0].cells.length) return {
        headerData: headerData,
        bodyData: bodyData,
        columnInformation: columnInformation
    };
    // Generate a new unique columnId for the duplicated column
    const newColumnId = crypto.randomUUID();
    // Copy the annotation from the original column with the new columnId
    const newColumnInfo = {
        ...originalColumnInfo,
        columnId: newColumnId,
        originalColumnIndex: columnIndex + 1
    };
    const updatedColumnInformation = [
        ...columnInformation.slice(0, columnIndex + 1),
        newColumnInfo,
        ...columnInformation.slice(columnIndex + 1).map((ci)=>({
                ...ci,
                originalColumnIndex: ci.originalColumnIndex + 1
            }))
    ];
    // Update body data
    const newBody = bodyData.map((rg)=>{
        return {
            ...rg,
            rows: rg.rows.map((r)=>{
                const duplicate = (0, $adOP8.trDuplicate)(r.cells[columnIndex]);
                // Assign new unique columnId for the duplicated cell
                duplicate.columnId = newColumnId;
                const newCells = [
                    ...r.cells.slice(0, columnIndex + 1),
                    duplicate,
                    ...r.cells.slice(columnIndex + 1)
                ];
                return {
                    ...r,
                    cells: newCells
                };
            })
        };
    });
    // Update header group
    const newHeader = headerData === false ? false : {
        ...headerData,
        rows: headerData.rows.map((r)=>{
            const newHeaderCells = [
                ...r.cells
            ];
            // Check for colSpan
            if (r.cells[columnIndex + 1]?.colSpan === 0) {
                // Change colSpan on previous spanner
                let lookback = 1;
                while(lookback <= columnIndex && r.cells[columnIndex + 1 - lookback].colSpan === 0)lookback++;
                r.cells[columnIndex + 1 - lookback].colSpan = r.cells[columnIndex + 1 - lookback].colSpan + 1;
                // Add in blank cell
                const n = (0, $l6aIi.newHeaderCell)(defaultCellWidth, blankT, newColumnId);
                n.colSpan = 0;
                newHeaderCells.splice(columnIndex + 1, 0, n);
            } else {
                const duplicate = (0, $adOP8.trDuplicate)(r.cells[columnIndex]);
                duplicate.colSpan = 1;
                // Assign new unique columnId for the duplicated cell
                duplicate.columnId = newColumnId;
                newHeaderCells.splice(columnIndex + 1, 0, duplicate);
            }
            return {
                ...r,
                cells: newHeaderCells
            };
        })
    };
    return {
        headerData: newHeader,
        bodyData: newBody,
        columnInformation: updatedColumnInformation
    };
};

});
parcelRegister("adOP8", function(module, exports) {

$parcel$export(module.exports, "trDuplicate", function () { return $6ddf658f2de79abc$export$1484bd025c6fff3e; });
/**
 * Deep-clone a value and assign new `aitid` values where present.
 *
 * This performs a recursive clone of objects and arrays. When an object has
 * an `aitid` property the clone will receive a fresh `aitid` (via
 * `crypto.randomUUID()`); `templateAitId` and `templateColumnAitId` keys are
 * removed. If `coreTrafficLight` is present it is set to `ChangedUnknown` on
 * the clone.
 *
 * @template T - The type of the value to duplicate
 * @param obj - The value to clone; primitives are returned unchanged
 * @returns A deep-cloned value with new `aitid` values and adjusted template/traffic-light fields
 */ const $6ddf658f2de79abc$export$1484bd025c6fff3e = (obj)=>{
    if (typeof obj !== "object" || obj === null) return obj;
    else if (Array.isArray(obj)) return obj.map((item)=>$6ddf658f2de79abc$export$1484bd025c6fff3e(item));
    else {
        const newObj = {};
        for(const key in obj)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = $6ddf658f2de79abc$export$1484bd025c6fff3e(obj[key]);
        // Assign new aitid
        if ("aitid" in newObj) newObj.aitid = crypto.randomUUID();
        if ("coreTrafficLight" in newObj) newObj.coreTrafficLight = "ChangedUnknown";
        // Remove template AitIds when duplicating
        if ("templateAitId" in newObj) delete newObj.templateAitId;
        if ("templateColumnAitId" in newObj) delete newObj.templateColumnAitId;
        return newObj;
    }
};

});


parcelRegister("iGLIE", function(module, exports) {

$parcel$export(module.exports, "trDuplicateRow", function () { return $f52c84b56e1d7fa8$export$f067bb49ab7f78bc; });

var $9B5Sg = parcelRequire("9B5Sg");

var $adOP8 = parcelRequire("adOP8");
const $f52c84b56e1d7fa8$export$f067bb49ab7f78bc = (headerData, bodyData, location, newLength)=>{
    /* istanbul ignore else */ if (location.position === (0, $9B5Sg.AitTablePosition).headerRow && headerData !== false && headerData.rows.length < newLength && headerData.rows.find((row)=>row.aitid === location.rowId)) {
        const rowIndex = headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newRows = [
            ...headerData.rows
        ];
        const duplicateRow = (0, $adOP8.trDuplicate)(headerData.rows[rowIndex]);
        /* istanbul ignore else */ if (duplicateRow) {
            // Check rowSpans
            const cols = duplicateRow.cells.length;
            for(let ci = 0; ci < cols; ci++)// Change any duplicate row rowSpans to zero if they are not 1
            if (duplicateRow.cells[ci].rowSpan !== 1) {
                duplicateRow.cells[ci].rowSpan = 0;
                // Look for the previous cell to expand
                let riUp = 0;
                while(riUp <= rowIndex && newRows[rowIndex - riUp].cells[ci].rowSpan === 0)riUp++;
                // Get new length based on number of cells below with zero rowSpan
                let zeroCells = 1;
                while(newRows[rowIndex - riUp + zeroCells] && newRows[rowIndex - riUp + zeroCells].cells[ci].rowSpan === 0)zeroCells++;
                newRows[rowIndex - riUp].cells[ci] = {
                    ...newRows[rowIndex - riUp].cells[ci],
                    rowSpan: zeroCells + 1
                };
                newRows[rowIndex - riUp] = {
                    ...newRows[rowIndex - riUp],
                    cells: [
                        ...newRows[rowIndex - riUp].cells
                    ]
                };
            }
            newRows.splice(rowIndex + 1, 0, duplicateRow);
            headerData = {
                ...headerData,
                rows: newRows
            };
        }
    } else if (location.position === (0, $9B5Sg.AitTablePosition).bodyRow && bodyData[location.rowGroup].rows.length < newLength && bodyData[location.rowGroup].rows.find((row)=>row.aitid === location.rowId)) {
        const rowGroupIndex = location.rowGroup;
        const rowIndex = bodyData[rowGroupIndex].rows.findIndex((row)=>row.aitid === location.rowId);
        const duplicateRow = (0, $adOP8.trDuplicate)(bodyData[rowGroupIndex].rows[rowIndex]);
        /* istanbul ignore else */ if (duplicateRow) {
            const newRows = [
                ...bodyData[rowGroupIndex].rows.slice(0, rowIndex + 1),
                duplicateRow,
                ...bodyData[rowGroupIndex].rows.slice(rowIndex + 1)
            ];
            bodyData = [
                ...bodyData.slice(0, rowGroupIndex),
                {
                    ...bodyData[rowGroupIndex],
                    rows: newRows
                },
                ...bodyData.slice(rowGroupIndex + 1)
            ];
        }
    }
    return {
        headerData: headerData,
        bodyData: bodyData
    };
};

});

parcelRegister("7SUA6", function(module, exports) {

$parcel$export(module.exports, "trDuplicateRowGroup", function () { return $921c19cb1fd86aa1$export$89d5f4468b909739; });

var $adOP8 = parcelRequire("adOP8");
const $921c19cb1fd86aa1$export$89d5f4468b909739 = (bodyData, rgi, newLength)=>{
    return bodyData[rgi] === undefined || bodyData.length >= newLength ? bodyData : [
        ...bodyData.slice(0, rgi + 1),
        (0, $adOP8.trDuplicate)(bodyData[rgi]),
        ...bodyData.slice(rgi + 1)
    ];
};

});

parcelRegister("kv9Fc", function(module, exports) {

$parcel$export(module.exports, "trProcessTable", function () { return $390702216809d24e$export$748437235d87bd84; });

var $eBlbF = parcelRequire("eBlbF");

var $e1dPi = parcelRequire("e1dPi");

var $PFlqD = parcelRequire("PFlqD");
const $390702216809d24e$export$748437235d87bd84 = (state)=>{
    const tableData = state.originalTableData;
    let columnRepeats = tableData.bodyData.length === 0 || tableData.bodyData[0].rows.length === 0 ? null : Array.from(tableData.bodyData[0].rows[0].cells.keys()).map((n)=>{
        return {
            columnIndex: n
        };
    });
    let processedHeaderData = tableData.headerData;
    if (processedHeaderData !== false && (processedHeaderData.rows.length ?? // istanbul ignore next
    0) > 0) {
        const headerDataUpdate = (0, $e1dPi.repeatHeaders)(processedHeaderData.rows, processedHeaderData.replacements ?? // istanbul ignore next
        [], state.defaultCellWidth, state.editorProps.getTextFromT, state.editorProps.replaceTextInT, state.editorProps.blankT, state.tlfViewMode, tableData.rowHeaderColumns ?? // istanbul ignore next
        0, state.externalLists, state.externalSingles);
        processedHeaderData = {
            aitid: processedHeaderData.aitid,
            name: processedHeaderData.name,
            rows: headerDataUpdate.rows,
            comments: processedHeaderData.comments,
            spaceAfter: processedHeaderData.spaceAfter,
            replacements: processedHeaderData.replacements,
            coreTrafficLight: processedHeaderData.coreTrafficLight
        };
        columnRepeats = headerDataUpdate.columnRepeats;
    }
    // Create processed body
    const processedBodyData = tableData.bodyData.map((rg)=>{
        return {
            ...rg,
            rows: (0, $PFlqD.repeatRows)(rg.rows, state.defaultCellWidth, state.editorProps.getTextFromT, state.editorProps.replaceTextInT, state.editorProps.blankT, rg.replacements, rg.spaceAfter, state.tlfViewMode, state.externalLists, state.externalSingles).map((r)=>{
                return {
                    ...r,
                    cells: columnRepeats?.map((ci)=>r.cells[ci.columnIndex]) ?? // istanbul ignore next
                    r.cells
                };
            })
        };
    });
    const processedTableData = {
        ...(0, $eBlbF.cloneDeep)(tableData),
        headerData: processedHeaderData,
        bodyData: processedBodyData,
        columnRepeats: columnRepeats
    };
    return processedTableData;
};

});
parcelRegister("e1dPi", function(module, exports) {

$parcel$export(module.exports, "repeatHeaders", function () { return $a547ff2a198b0def$export$ebd88f229b89fe9b; });

var $fHFBi = parcelRequire("fHFBi");

var $d0OZ3 = parcelRequire("d0OZ3");

var $gIB6G = parcelRequire("gIB6G");

var $7xJts = parcelRequire("7xJts");
const $a547ff2a198b0def$export$ebd88f229b89fe9b = (rows, replacements, defaultCellWidth, getTextFromT, replaceTextInT, blankT, tlfViewMode, rowHeaderColumns, externalLists, externalSingles)=>{
    // Start with blank slate, need to strip repeat information every time!
    let newHeaderRows = (0, $d0OZ3.removeHeaderRowRepeatInfo)(rows);
    let newColumnRepeats = Array.from(rows[rows.length - 1].cells.keys()).map((n)=>{
        return {
            columnIndex: n
        };
    });
    // Strip repeat data if flagged
    if (tlfViewMode.noRepeatProcessing) return {
        rows: newHeaderRows,
        columnRepeats: newColumnRepeats
    };
    // Process replacements
    (0, $fHFBi.updateExternals)(replacements, externalLists)?.forEach((rep)=>{
        const afterReplacement = (0, $gIB6G.replaceHeaders)(rowHeaderColumns, newHeaderRows, newColumnRepeats, defaultCellWidth, getTextFromT, replaceTextInT, blankT, rep, undefined);
        newHeaderRows = afterReplacement.newHeaderRows;
        newColumnRepeats = afterReplacement.newColumnRepeats;
    });
    // Single post processing rep
    newHeaderRows = (0, $7xJts.singleReplacements)(externalSingles, newHeaderRows, replaceTextInT);
    return {
        rows: newHeaderRows,
        columnRepeats: newColumnRepeats
    };
};

});
parcelRegister("fHFBi", function(module, exports) {

$parcel$export(module.exports, "updateExternals", function () { return $8775773a1335cdd9$export$8ad79e12c8182d35; });

var $vby9F = parcelRequire("vby9F");
const $8775773a1335cdd9$export$8ad79e12c8182d35 = (reps, exts)=>{
    return reps?.map((rep)=>(0, $vby9F.updateExternal)(rep, exts));
};

});
parcelRegister("vby9F", function(module, exports) {

$parcel$export(module.exports, "updateExternal", function () { return $8bf49734bcc222cf$export$760e8c77fc5f1148; });

var $eBlbF = parcelRequire("eBlbF");

var $fHFBi = parcelRequire("fHFBi");
const $8bf49734bcc222cf$export$760e8c77fc5f1148 = (rep, exts)=>{
    const ix = rep.externalName !== undefined && exts !== undefined ? exts.findIndex((e)=>e.givenName === rep.externalName) : -1;
    let found = ix > -1 && exts !== undefined && exts.length > ix ? (0, $eBlbF.cloneDeep)(exts[ix].newTexts) : undefined;
    if (!found) found = rep.newTexts.some((nt)=>nt.subLists !== undefined) ? rep.newTexts.map((nts)=>{
        return {
            ...nts,
            subLists: (0, $fHFBi.updateExternals)(nts.subLists, exts)
        };
    }) : rep.newTexts;
    const newR = {
        ...rep,
        newTexts: found
    };
    return newR;
};

});


parcelRegister("d0OZ3", function(module, exports) {

$parcel$export(module.exports, "removeRowRepeatInfo", function () { return $b076f550e0b98c6f$export$b25987bc78488782; });
$parcel$export(module.exports, "removeHeaderRowRepeatInfo", function () { return $b076f550e0b98c6f$export$7083d1cd335b5e35; });
const $b076f550e0b98c6f$export$b25987bc78488782 = (rows)=>{
    return rows.map((r)=>{
        const ret = {
            aitid: r.aitid,
            cells: r.cells// .filter(c => !c.replacedText?.includes("__filler"))
            .map((c)=>{
                return {
                    aitid: c.aitid,
                    text: c.text,
                    justifyText: c.justifyText,
                    comments: c.comments,
                    // colSpan: c.colSpan,
                    // rowSpan: c.rowSpan,
                    colWidth: c.colWidth,
                    textIndents: c.textIndents,
                    coreTrafficLight: c.coreTrafficLight,
                    templateAitId: c.templateAitId,
                    templateColumnAitId: c.templateColumnAitId,
                    columnId: c.columnId
                };
            }),
            // spaceAfter: false,
            // rowRepeat: undefined,
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
        return ret;
    });
};
const $b076f550e0b98c6f$export$7083d1cd335b5e35 = (rows)=>{
    return rows.map((r)=>{
        const ret = {
            aitid: r.aitid,
            cells: r.cells// .filter(c => !c.replacedText?.includes("__filler"))
            .map((c)=>{
                return {
                    aitid: c.aitid,
                    text: c.text,
                    justifyText: c.justifyText,
                    comments: c.comments,
                    colSpan: c.colSpan,
                    rowSpan: c.rowSpan,
                    colWidth: c.colWidth,
                    textIndents: c.textIndents,
                    coreTrafficLight: c.coreTrafficLight,
                    templateAitId: c.templateAitId,
                    templateColumnAitId: c.templateColumnAitId,
                    columnId: c.columnId
                };
            }),
            // spaceAfter: false,
            // rowRepeat: undefined,
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
        return ret;
    });
};

});

parcelRegister("gIB6G", function(module, exports) {

$parcel$export(module.exports, "replaceHeaders", function () { return $be8681046a4a2a84$export$e3af655bc6f14763; });

var $fWJ6C = parcelRequire("fWJ6C");

var $f9pPj = parcelRequire("f9pPj");

var $l6aIi = parcelRequire("l6aIi");

var $cAxag = parcelRequire("cAxag");
const $be8681046a4a2a84$export$e3af655bc6f14763 = (rowHeaderColumns, rows, columnRepeats, defaultCellWidth, getTextFromT, replaceTextInT, blankT, replacement, externalLists)=>{
    // Check there are rows
    if (rows.length === 0) return {
        newHeaderRows: [],
        newColumnRepeats: []
    };
    // Set up holders
    let newHeaderRows = rows.map((r)=>{
        return {
            aitid: r.aitid,
            cells: [],
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
    });
    let newColumnRepeats = [];
    // Go through each column
    let colsProcessed = 1;
    let addedCols = 0;
    for(let ci = 0; ci < rows[0].cells.length; ci = ci + colsProcessed){
        // Look for match, is there is one to find
        let found = replacement === undefined || replacement.oldText === "" || replacement.newTexts.length === 0 || replacement.newTexts[0].texts.join("") === "";
        colsProcessed = 1;
        // Add next column if the text is already found
        if (found || ci < rowHeaderColumns) {
            newHeaderRows = (0, $f9pPj.appendCells)(newHeaderRows, rows.map((r)=>{
                return {
                    aitid: r.aitid,
                    cells: [
                        r.cells[ci]
                    ],
                    coreTrafficLight: r.coreTrafficLight,
                    templateAitId: r.templateAitId,
                    annotation: r.annotation
                };
            }));
            newColumnRepeats = [
                ...newColumnRepeats,
                columnRepeats[ci]
            ];
        } else {
            for(let ri = 0; ri < rows.length; ri++){
                // Skip processing if any cell below the current row in this column has colSpan === 0
                if (rows.slice(ri + 1).some((row)=>row.cells[ci].colSpan === 0)) continue;
                // Skip processing if the cell is hidden
                if (rows[ri].cells[ci].colSpan === 0 || rows[ri].cells[ci].rowSpan === 0) continue;
                // Get text parts of the cell
                const cellTextParts = getTextFromT(rows[ri].cells[ci].replacedText ?? rows[ri].cells[ci].text);
                // React if found
                if (replacement && cellTextParts.some((t)=>t.includes(replacement.oldText))) {
                    const targetCell = rows[ri].cells[ci];
                    found = true;
                    const repeatSpan = Math.max(...rows.slice(ri).map((r)=>r.cells[ci].colSpan));
                    let midRows = rows.slice(ri).map((r)=>{
                        return {
                            aitid: r.aitid,
                            cells: [],
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                    });
                    let midRepeats = [];
                    // Cycle through reach replacement value
                    for(let rvi = 0; rvi < replacement.newTexts.length; rvi++){
                        const rv = replacement.newTexts[rvi];
                        // Process sublist
                        const lowerQuad = rows.slice(ri + 1).map((r)=>{
                            return {
                                aitid: r.aitid,
                                cells: r.cells.slice(ci, ci + repeatSpan),
                                coreTrafficLight: r.coreTrafficLight,
                                templateAitId: r.templateAitId,
                                annotation: r.annotation
                            };
                        });
                        const nextReplacement = (0, $fWJ6C.flattenReplacements)(rv.subLists, externalLists, blankT);
                        const { newHeaderRows: lowerProcessed, newColumnRepeats: lowerColumnRepeats } = $be8681046a4a2a84$export$e3af655bc6f14763(0, lowerQuad, lowerQuad.length > 0 && lowerQuad[0].cells.length > 0 ? Array.from(lowerQuad[0].cells.keys()).map((n)=>{
                            return {
                                columnIndex: n
                            };
                        }) : [], defaultCellWidth, getTextFromT, replaceTextInT, blankT, nextReplacement);
                        // Perform replacements for each text entry
                        for(let ti = 0; ti < rv.texts.length; ti++){
                            const thisRepeat = (0, $cAxag.replaceCellText)(targetCell, replacement.oldText, rv.texts[ti], replaceTextInT);
                            // Expand to cover all lower columns
                            if (lowerProcessed.length > 0 && lowerProcessed[0].cells.length > repeatSpan) thisRepeat.repeatColSpan = lowerProcessed[0].cells.length + repeatSpan - targetCell.colSpan;
                            // Add into mid cells
                            const targetRow = {
                                aitid: rows[ri].aitid,
                                cells: [
                                    thisRepeat
                                ],
                                coreTrafficLight: rows[ri].coreTrafficLight,
                                templateAitId: rows[ri].templateAitId,
                                annotation: rows[ri].annotation
                            };
                            // Add usual trailing cells
                            if (thisRepeat.colSpan > 1) targetRow.cells.push(...rows[ri].cells.slice(ci + 1, ci + targetCell.colSpan));
                            // Add new blank cells
                            if (thisRepeat.colSpan !== undefined && thisRepeat.repeatColSpan !== undefined && thisRepeat.repeatColSpan > thisRepeat.colSpan) {
                                const nIns = thisRepeat.repeatColSpan - thisRepeat.colSpan;
                                for(let nci = 0; nci < nIns; nci++){
                                    const n = (0, $l6aIi.newHeaderCell)(defaultCellWidth, blankT, targetCell.columnId);
                                    n.colSpan = 0;
                                    n.repeatColSpan = 0;
                                    targetRow.cells.push(n);
                                }
                            }
                            // Add extra cells covered by repeatSpan
                            if (repeatSpan > targetCell.colSpan) targetRow.cells.push(...rows[ri].cells.slice(ci + targetCell.colSpan, ci + repeatSpan));
                            // Add this repeat into the output
                            midRows = (0, $f9pPj.appendCells)(midRows, [
                                targetRow,
                                ...lowerProcessed
                            ]);
                            // Work out new repeat for this cell
                            if (lowerColumnRepeats.length > 0) midRepeats = [
                                ...midRepeats,
                                ...lowerColumnRepeats.map((crep)=>{
                                    return {
                                        columnIndex: columnRepeats[ci].columnIndex + crep.columnIndex,
                                        colRepeat: `${columnRepeats[ci].colRepeat ?? ""}${`[${rvi},${ti}]${crep.colRepeat ?? ""}`}`
                                    };
                                })
                            ];
                            else midRepeats = [
                                ...midRepeats,
                                ...Array.from(Array(repeatSpan).keys()).map((n)=>{
                                    return {
                                        columnIndex: columnRepeats[ci + n].columnIndex,
                                        colRepeat: `${columnRepeats[ci].colRepeat ?? ""}${`[${rvi},${ti}]`}`
                                    };
                                })
                            ];
                        }
                    }
                    // Add full column
                    newHeaderRows = (0, $f9pPj.appendCells)(newHeaderRows, rows.map((r, rj)=>{
                        // Return row above
                        if (rj < ri) return {
                            aitid: r.aitid,
                            cells: [
                                ...r.cells.slice(ci, ci + repeatSpan)
                            ],
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                        else return {
                            aitid: r.aitid,
                            cells: midRows[rj - ri].cells,
                            coreTrafficLight: r.coreTrafficLight,
                            templateAitId: r.templateAitId,
                            annotation: r.annotation
                        };
                    }));
                    newColumnRepeats = [
                        ...newColumnRepeats,
                        ...midRepeats
                    ];
                    // Ensure that columns above cover the repeats
                    const nIns = midRows[0].cells.length - repeatSpan;
                    /* istanbul ignore else */ if (nIns > 0) {
                        // Number of cells to insert / colSpan to increase
                        for(let rj = ri - 1; rj >= 0; rj--){
                            let targetCellAbove = newHeaderRows[rj].cells[ci + addedCols];
                            // Update the target to have minimum repeatColSpan
                            /* istanbul ignore else */ if (targetCellAbove !== undefined) {
                                // Check that the target is showing
                                let lookup = 0;
                                // TODO: Remove this ignore
                                // istanbul ignore next
                                while(targetCellAbove.colSpan === 0 && lookup < ci){
                                    // Move to previous cell
                                    lookup++;
                                    targetCellAbove = rows[rj].cells[ci - lookup];
                                }
                                // Calculated new colSpan and add in fillers
                                targetCellAbove.repeatColSpan = (targetCellAbove.repeatColSpan ?? targetCellAbove.colSpan) + nIns;
                                const newCells2 = [];
                                for(let nci = 0; nci < nIns; nci++){
                                    const n = (0, $l6aIi.newHeaderCell)(defaultCellWidth, blankT, targetCellAbove.columnId);
                                    n.colSpan = 0;
                                    n.repeatColSpan = 0;
                                    newCells2.push(n);
                                }
                                newHeaderRows[rj].cells.splice(ci + addedCols - lookup + 1, 0, ...newCells2);
                            }
                        }
                        // Update number of columns added so far
                        addedCols = addedCols + nIns;
                    }
                    colsProcessed = repeatSpan;
                    break;
                }
            }
            // Append the row if it was not found on this pass
            if (!found) {
                newHeaderRows = (0, $f9pPj.appendCells)(newHeaderRows, rows.map((r)=>{
                    return {
                        aitid: r.aitid,
                        cells: [
                            r.cells[ci]
                        ],
                        coreTrafficLight: r.coreTrafficLight,
                        templateAitId: r.templateAitId,
                        annotation: r.annotation
                    };
                }));
                newColumnRepeats = [
                    ...newColumnRepeats,
                    columnRepeats[ci]
                ];
            }
        }
    }
    return {
        newHeaderRows: newHeaderRows,
        newColumnRepeats: newColumnRepeats
    };
};

});
parcelRegister("fWJ6C", function(module, exports) {

$parcel$export(module.exports, "flattenReplacements", function () { return $ddcf183233d628ad$export$fc0ddbef0309c989; });

var $bMqT7 = parcelRequire("bMqT7");

var $azY1B = parcelRequire("azY1B");

var $vby9F = parcelRequire("vby9F");
const $ddcf183233d628ad$export$fc0ddbef0309c989 = (reps, exts, blankT = "")=>{
    // Do nothing if there is nothing to do
    if (reps === undefined || reps.length === 0) return undefined;
    // Create holder
    let newRep = (0, $azY1B.newReplacement)(blankT);
    // Check append is ok
    reps.map((rep, repi)=>{
        // First update any external list
        const uEx = (0, $vby9F.updateExternal)(rep, exts);
        const incoming = uEx;
        // First entry can be used as a base
        if (repi === 0) newRep = incoming;
        else newRep.newTexts = newRep.newTexts.map((nt)=>{
            return {
                ...nt,
                subLists: (0, $bMqT7.appendReplacement)(incoming, nt.subLists)
            };
        });
        return true;
    });
    return newRep;
};

});
parcelRegister("bMqT7", function(module, exports) {

$parcel$export(module.exports, "appendReplacement", function () { return $f943b9f54ff629e5$export$b032f7476d2f2712; });

var $eBlbF = parcelRequire("eBlbF");
const $f943b9f54ff629e5$export$b032f7476d2f2712 = (incoming, subLists)=>{
    let newSubLists = [];
    if (subLists === undefined || subLists.length === 0) newSubLists.push((0, $eBlbF.cloneDeep)(incoming));
    else newSubLists = subLists.map((s)=>{
        return {
            ...s,
            newTexts: s.newTexts.map((nt)=>{
                return {
                    ...nt,
                    subLists: $f943b9f54ff629e5$export$b032f7476d2f2712(incoming, nt.subLists)
                };
            })
        };
    });
    return newSubLists;
};

});

parcelRegister("azY1B", function(module, exports) {

$parcel$export(module.exports, "newReplacement", function () { return $ce8ad43f321bff15$export$b9e899552636205; });

var $76A43 = parcelRequire("76A43");
const $ce8ad43f321bff15$export$b9e899552636205 = (blankT)=>{
    return {
        airid: crypto.randomUUID(),
        oldText: "",
        newTexts: [
            (0, $76A43.newReplacementValues)(blankT)
        ],
        includeTrailing: false
    };
};

});
parcelRegister("76A43", function(module, exports) {

$parcel$export(module.exports, "newReplacementValues", function () { return $4fc64306c69b880c$export$ad5c2ff5b6cd676b; });
const $4fc64306c69b880c$export$ad5c2ff5b6cd676b = (blankT)=>{
    return {
        airid: crypto.randomUUID(),
        texts: [
            blankT
        ],
        spaceAfter: false,
        subLists: []
    };
};

});



parcelRegister("f9pPj", function(module, exports) {

$parcel$export(module.exports, "appendCells", function () { return $1410fc418cee1bdd$export$222317b6d213f2f0; });
const $1410fc418cee1bdd$export$222317b6d213f2f0 = (base, append)=>{
    return base.map((r, ri)=>{
        return {
            aitid: r.aitid,
            cells: [
                ...r.cells,
                ...append[ri].cells
            ],
            coreTrafficLight: r.coreTrafficLight,
            templateAitId: r.templateAitId,
            annotation: r.annotation
        };
    });
};

});

parcelRegister("cAxag", function(module, exports) {

$parcel$export(module.exports, "replaceCellText", function () { return $dd080f3dffc545ea$export$aa26aef3d93a492f; });

var $eBlbF = parcelRequire("eBlbF");
const $dd080f3dffc545ea$export$aa26aef3d93a492f = (cell, oldText, newText, replaceText)=>{
    const replacedText = replaceText(cell.replacedText ?? cell.text, oldText, newText);
    return {
        ...cell,
        replacedText: !(0, $eBlbF.isEqual)(cell.text, replacedText) ? replacedText : undefined
    };
};

});


parcelRegister("7xJts", function(module, exports) {

$parcel$export(module.exports, "singleReplacements", function () { return $561801b3c5d82894$export$2ae140bc64d582e5; });

var $cAxag = parcelRequire("cAxag");
function $561801b3c5d82894$export$2ae140bc64d582e5(externalSingles, newRows, replaceText) {
    if (externalSingles !== undefined && externalSingles.length > 0) externalSingles.forEach((e)=>{
        /* istanbul ignore else */ if (e.oldText !== "") newRows = newRows.map((r)=>{
            return {
                ...r,
                cells: r.cells.map((c)=>(0, $cAxag.replaceCellText)(c, e.oldText, e.newText, replaceText))
            };
        });
    });
    return newRows;
}

});


parcelRegister("PFlqD", function(module, exports) {

$parcel$export(module.exports, "repeatRows", function () { return $9f62f6b7061e8673$export$aa13dffe14e158da; });

var $fHFBi = parcelRequire("fHFBi");

var $d0OZ3 = parcelRequire("d0OZ3");

var $hZ8f9 = parcelRequire("hZ8f9");

var $7xJts = parcelRequire("7xJts");
const $9f62f6b7061e8673$export$aa13dffe14e158da = (rows, defaultCellWidth, getTextFromT, replaceTextInT, blankT, replacements, spaceAfter, tlfViewMode, externalLists, externalSingles)=>{
    // Create initial return
    let newRows = (0, $d0OZ3.removeRowRepeatInfo)(rows);
    // Strip repeat data if flagged
    if (tlfViewMode?.noRepeatProcessing) {
        newRows[newRows.length - 1].spaceAfter = spaceAfter;
        return newRows;
    }
    // Process rows if there are replacements
    const extReplacements = (0, $fHFBi.updateExternals)(replacements, externalLists);
    // Check other spaceAfter if there are replacements
    if (extReplacements && extReplacements.length > 0) for(let si = 0; si < extReplacements.length; si++){
        // Data fix
        // istanbul ignore next
        if (si > 0 && extReplacements[si].includeTrailing) extReplacements[si].includeTrailing = false;
        // Run current replacement
        newRows = (0, $hZ8f9.replaceRows)(newRows, defaultCellWidth, blankT, getTextFromT, replaceTextInT, extReplacements[si]);
    }
    // Add spaceAfter for the group
    /* istanbul ignore else */ if (spaceAfter) newRows[newRows.length - 1].spaceAfter = true;
    // Check row space after
    newRows.forEach((row)=>{
        if (row.cells.some((cell)=>cell.spaceAfterRepeat)) row.spaceAfter = true;
    });
    // Single post processing replacements
    newRows = (0, $7xJts.singleReplacements)(externalSingles, newRows, replaceTextInT);
    return newRows;
};

});
parcelRegister("hZ8f9", function(module, exports) {

$parcel$export(module.exports, "replaceRows", function () { return $6bd486274f1341f5$export$3c20b2ff62792dc4; });

var $fHFBi = parcelRequire("fHFBi");
parcelRequire("5SMPf");
var $8FniJ = parcelRequire("8FniJ");

var $cAxag = parcelRequire("cAxag");
const $6bd486274f1341f5$export$3c20b2ff62792dc4 = (rows, defaultCellWidth, blankT, getTextFromT, replaceTextInT, replacement, externalLists)=>{
    // Look for match, is there is one to find
    if (replacement === undefined || replacement.oldText === "" || replacement.newTexts.length === 0 || replacement.newTexts[0].texts.join("") === "") return rows;
    // Set up holders
    const newRows = [];
    let found = false;
    // Look through each cell
    let ri = 0;
    let processedRows = 0;
    let emergencyExit = 0;
    while(ri < rows.length && emergencyExit < 10000){
        // istanbul ignore next
        if (ri >= rows.length || rows[ri] === undefined || rows[ri].cells.length === undefined) {
            console.group("High ri value somehow");
            console.warn(`ri: ${ri}`);
            console.warn(`${JSON.stringify(rows)}`);
            console.groupEnd();
        } else for(let ci = 0; ci < rows[ri].cells.length && !found; ci++){
            const cellTextParts = getTextFromT(rows[ri].cells[ci].replacedText ?? rows[ri].cells[ci].text ?? blankT);
            if (replacement !== undefined && // Compare as non-HTML text
            cellTextParts.some((t)=>t.includes((0, $8FniJ.fromHtml)(replacement.oldText)))) {
                // Get targetCell
                found = true;
                const targetCell = rows[ri].cells[ci];
                const midRows = [];
                // Cycle through newTexts
                for(let rvi = 0; rvi < replacement.newTexts.length; rvi++){
                    const rv = replacement.newTexts[rvi];
                    // Perform replacements for each text entry
                    for(let ti = 0; ti < rv.texts.length; ti++){
                        const thisRepeat = (0, $cAxag.replaceCellText)(targetCell, replacement.oldText, rv.texts[ti], replaceTextInT);
                        // Process remaining cells, including target after replacement
                        let lowerQuad = replacement.includeTrailing ?? false ? rows.slice(ri).map((r, rj)=>{
                            const cells = rj === 0 ? [
                                thisRepeat,
                                ...r.cells.slice(ci + 1).map((c)=>(0, $cAxag.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                            ] : [
                                ...r.cells.slice(ci).map((c)=>(0, $cAxag.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                            ];
                            return {
                                aitid: r.aitid,
                                rowRepeat: `${r.rowRepeat ?? ""}${`[${rvi},${ti}]`}`,
                                cells: cells,
                                coreTrafficLight: r.coreTrafficLight,
                                templateAitId: r.templateAitId,
                                annotation: r.annotation
                            };
                        }) : [
                            {
                                aitid: rows[ri].aitid,
                                rowRepeat: `${rows[ri].rowRepeat ?? ""}${`[${rvi},${ti}]`}`,
                                cells: [
                                    thisRepeat,
                                    ...rows[ri].cells.slice(ci + 1).map((c)=>(0, $cAxag.replaceCellText)(c, replacement.oldText, rv.texts[ti], replaceTextInT))
                                ],
                                coreTrafficLight: rows[ri].coreTrafficLight,
                                templateAitId: rows[ri].templateAitId,
                                annotation: rows[ri].annotation
                            }
                        ];
                        // Find amount to move row cursor
                        processedRows = lowerQuad.length;
                        // Process lowerQuad if there are subLists
                        const subLists = (0, $fHFBi.updateExternals)(rv.subLists, externalLists);
                        if (subLists && subLists.length > 0) for(let si = 0; si < subLists.length; si++)lowerQuad = $6bd486274f1341f5$export$3c20b2ff62792dc4(lowerQuad, defaultCellWidth, blankT, getTextFromT, replaceTextInT, subLists[si]);
                        // Expand to cover rest of the row
                        midRows.push(...lowerQuad);
                        // Add spaceAfter to bottom left cell in the block
                        if (rv.spaceAfter) midRows[midRows.length - 1].cells[0].spaceAfterRepeat = true;
                    }
                }
                // Add preceeding cells from current row
                if (midRows.length > 0) midRows.forEach((r, ix)=>{
                    r.cells.splice(0, 0, ...rows[ri].cells.slice(0, ci).map((c)=>({
                            ...c,
                            replacedText: ix === 0 ? c.replacedText : "",
                            spaceAfterRepeat: c.spaceAfterRepeat && ix === midRows.length - 1
                        })));
                });
                // Add returned rows
                newRows.push(...midRows);
            }
        }
        // Add the row if it was not found on this pass
        if (!found) {
            newRows.push(rows[ri]);
            ri++;
        }
        if (found) {
            ri = ri + processedRows;
            found = false;
        }
        emergencyExit++;
    }
    return newRows;
};

});
parcelRegister("5SMPf", function(module, exports) {
$parcel$export(module.exports, "checkName", function () { return (parcelRequire("klm8J")).checkName; });
$parcel$export(module.exports, "classMerge", function () { return (parcelRequire("3tKzd")).classMerge; });
$parcel$export(module.exports, "convertDateToLocaleString", function () { return (parcelRequire("9S4dL")).convertDateToLocaleString; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return (parcelRequire("9S4dL")).convertLocaleDateToUTCString; });
$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return (parcelRequire("iULHs")).datasetToAnnotatedVariables; });
$parcel$export(module.exports, "defaultEditorDefns", function () { return (parcelRequire("hcEI9")).defaultEditorDefns; });
$parcel$export(module.exports, "formatJson", function () { return (parcelRequire("4D2as")).formatJson; });
$parcel$export(module.exports, "getFromDataPath", function () { return (parcelRequire("jwDoS")).getFromDataPath; });
$parcel$export(module.exports, "isString", function () { return (parcelRequire("jwDoS")).isString; });
$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return (parcelRequire("dbVjd")).TLF_VIEW_MODES; });
$parcel$export(module.exports, "loadWrapper", function () { return (parcelRequire("4dL47")).loadWrapper; });
$parcel$export(module.exports, "mapById", function () { return (parcelRequire("4VWrH")).mapById; });
$parcel$export(module.exports, "mutateByPath", function () { return (parcelRequire("67RwR")).mutateByPath; });
$parcel$export(module.exports, "encodePath", function () { return (parcelRequire("V4sXl")).encodePath; });
$parcel$export(module.exports, "PauseCover", function () { return (parcelRequire("1wSYE")).PauseCover; });
$parcel$export(module.exports, "reduceDataPath", function () { return (parcelRequire("km9RG")).reduceDataPath; });
$parcel$export(module.exports, "removeByPath", function () { return (parcelRequire("X1On9")).removeByPath; });
$parcel$export(module.exports, "setToUTCMidnight", function () { return (parcelRequire("hFl9K")).setToUTCMidnight; });
$parcel$export(module.exports, "stringDateCheck", function () { return (parcelRequire("7fpOF")).stringDateCheck; });
$parcel$export(module.exports, "stripDisallowedNameCharacters", function () { return (parcelRequire("8oLnS")).stripDisallowedNameCharacters; });
$parcel$export(module.exports, "fromHtml", function () { return (parcelRequire("8FniJ")).fromHtml; });
$parcel$export(module.exports, "toHtml", function () { return (parcelRequire("8FniJ")).toHtml; });
$parcel$export(module.exports, "valueFix", function () { return (parcelRequire("dD4jq")).valueFix; });
parcelRequire("klm8J");
parcelRequire("3tKzd");
parcelRequire("9S4dL");
parcelRequire("iULHs");
parcelRequire("hcEI9");
parcelRequire("4D2as");
parcelRequire("jwDoS");
parcelRequire("fNNZS");
parcelRequire("ayG2q");
parcelRequire("dbVjd");
parcelRequire("4dL47");
parcelRequire("4VWrH");
parcelRequire("67RwR");
parcelRequire("V4sXl");
parcelRequire("1wSYE");
parcelRequire("km9RG");
parcelRequire("X1On9");
parcelRequire("hFl9K");
parcelRequire("bOKCS");
parcelRequire("7fpOF");
parcelRequire("8oLnS");
parcelRequire("8FniJ");
parcelRequire("dD4jq");

});
parcelRegister("klm8J", function(module, exports) {

$parcel$export(module.exports, "checkName", function () { return $0a29e37d6d57e85d$export$f7ed3bd26bb64653; });

var $8oLnS = parcelRequire("8oLnS");
const $0a29e37d6d57e85d$export$f7ed3bd26bb64653 = async (_, target)=>{
    let valid = false;
    let validationText = "Not validated";
    if (target.value.trim() === "") {
        valid = false;
        validationText = "Name cannot be blank";
    } else if ((target.options?.existingValues ?? []).findIndex((s)=>s.trim().toLowerCase() === target.value.trim().toLowerCase()) >= 0) {
        valid = false;
        validationText = "This name is taken";
    } else if (target.value.match((0, $8oLnS.allowedNameCharactersPattern)) === null) {
        valid = false;
        validationText = "Only alphanumeric characters and -_ can be used";
    } else {
        valid = true;
        validationText = "Successfully validated";
    }
    const warningText = target.options?.otherValues?.warningText;
    if (valid && warningText !== undefined) return {
        success: true,
        data: {
            valid: false,
            warning: true,
            validationText: warningText
        }
    };
    return {
        success: true,
        data: {
            valid: valid,
            validationText: validationText
        }
    };
};

});
parcelRegister("8oLnS", function(module, exports) {

$parcel$export(module.exports, "allowedNameCharactersPattern", function () { return $72f9e560cc71616d$export$1da226a1c1989e36; });
$parcel$export(module.exports, "stripDisallowedNameCharacters", function () { return $72f9e560cc71616d$export$c319ba1644e8a90d; });
/**
 * Pattern that matches only characters allowed in ARS/hierarchy names: letters, digits,
 * underscores, and hyphens. Used both to validate names (see `checkName`) and to strip disallowed
 * characters from names before they are committed to state (see `stripDisallowedNameCharacters`).
 */ const $72f9e560cc71616d$export$1da226a1c1989e36 = /^[A-Za-z0-9_-]*$/;
const $72f9e560cc71616d$export$c319ba1644e8a90d = (value)=>value.replace(/[^A-Za-z0-9_-]/g, "");

});


parcelRegister("3tKzd", function(module, exports) {

$parcel$export(module.exports, "classMerge", function () { return $9e243805e1c806ba$export$ea666cc515e97dc4; });
/**
 * Merges multiple class names into a single string, ignoring undefined/blank values.
 *
 * @param classes - List of classes to merge
 * @returns A single string containing all valid class names
 */ function $9e243805e1c806ba$export$ea666cc515e97dc4(classes) {
    return classes.map((c)=>c?.trim()).filter(Boolean).join(" ");
}

});

parcelRegister("9S4dL", function(module, exports) {

$parcel$export(module.exports, "convertDateToLocaleString", function () { return $7a10baf2bc69b799$export$886dc98a901f1d4f; });
$parcel$export(module.exports, "convertLocaleDateToUTCString", function () { return $7a10baf2bc69b799$export$e50c52e1a45b9cde; });
/**
 * Converts a date or date string to a locale string.
 *
 * @param s - The string or date
 * @returns string
 */ const $7a10baf2bc69b799$export$886dc98a901f1d4f = (s)=>{
    const d = s instanceof Date ? s : new Date(s);
    return !isNaN(d.getTime()) ? `${new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16).replace(/[T]/, " ")}` : "Invalid date";
};
const $7a10baf2bc69b799$export$e50c52e1a45b9cde = (s)=>{
    const d = new Date(s);
    return d instanceof Date && !isNaN(d.getTime()) ? `${new Date(d.getTime()).toISOString()}` : "Invalid date";
};

});

parcelRegister("iULHs", function(module, exports) {

$parcel$export(module.exports, "datasetToAnnotatedVariables", function () { return $1e63b8272e0e9b1f$export$2556cc2a604b3767; });
function $1e63b8272e0e9b1f$export$2556cc2a604b3767(dataset) {
    return dataset.clinicalVariables.map((variable)=>({
            value: `${dataset.name.trim()}.${variable.name.trim()}`,
            oid: variable.oid,
            name: variable.name,
            dataType: variable.dataType,
            length: parseInt(variable.length ?? "8", 10),
            description: variable.description,
            dataset: dataset.name,
            codeList: variable.clinicalCodeListId
        }));
}

});

parcelRegister("hcEI9", function(module, exports) {

$parcel$export(module.exports, "defaultEditorDefns", function () { return $24676658b763280d$export$a56bfc049012f820; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3tKzd = parcelRequire("3tKzd");

var $jwDoS = parcelRequire("jwDoS");
const $24676658b763280d$export$2e7dc17ee6bf4ebd = (props)=>{
    const [text, setText] = (0, $spJKX.useState)();
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (typeof props.value === "string") (0, $spJKX.startTransition)(()=>setText(props.value));
    }, [
        props.value
    ]);
    if (typeof props.value !== "string") throw new Error("If newText is not a string, a custom function is required");
    const textAlign = props.textAlignment === "decimal" ? "center" : props.textAlignment === "default" ? "left" : props.textAlignment ?? "left";
    const inputProps = {
        "aria-label": props["aria-label"],
        "aria-labelledby": props["aria-labelledby"],
        className: (0, $3tKzd.classMerge)([
            "test-editor",
            props.className
        ]),
        disabled: !props.setValue || !props.editable,
        id: props.id,
        onBlur: ()=>props.setValue && props.setValue(text),
        onChange: (e)=>setText(e.currentTarget.value),
        style: {
            background: "transparent",
            border: "none",
            boxSizing: "border-box",
            padding: "4px 8px",
            textAlign: textAlign,
            width: "100%"
        },
        value: text ?? ""
    };
    return props.resize ? /*#__PURE__*/ (0, $bR5nk.jsx)("textarea", {
        ...inputProps,
        "data-testid": `test-editor-${props.id}`
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
        ...inputProps,
        "data-testid": `test-editor-${props.id}`
    });
};
$24676658b763280d$export$2e7dc17ee6bf4ebd.displayName = "DefaultEditor";
/**
 * Check if the text in the test editor is a string
 *
 * @param o - The value to check
 */ const $24676658b763280d$var$checkTextInDefaultEditor = (o)=>typeof o === "string";
/**
 * Get text from the editor
 *
 * @param text - The text content to extract from the default editor
 */ const $24676658b763280d$var$getTextFromDefaultEditor = (text)=>{
    if (!$24676658b763280d$var$checkTextInDefaultEditor(text)) throw new Error("Update function when using an object for text");
    return [
        text
    ];
};
/**
 * Replace text in the editor
 *
 * @param s - The source string to perform replacement on
 * @param oldPhrase - The phrase to find and replace
 * @param newPhrase - The phrase to replace with
 */ const $24676658b763280d$var$replaceTextInDefaultEditor = (s, oldPhrase, newPhrase)=>{
    if (!$24676658b763280d$var$checkTextInDefaultEditor(s) || !$24676658b763280d$var$checkTextInDefaultEditor(newPhrase)) throw new Error("Update function when using an object for text");
    return s.replace(oldPhrase, newPhrase);
};
/**
 * Join lines into a block of text
 *
 * @param lines - The array of text lines to process
 */ const $24676658b763280d$var$joinDefaultEditorIntoBlock = (lines)=>{
    if (lines.some((line)=>!$24676658b763280d$var$checkTextInDefaultEditor(line))) throw new Error("Update function when using an object for text");
    return lines.join("\n");
};
/**
 * Split text into lines
 *
 * @param text - The text content to split into lines
 */ const $24676658b763280d$var$splitDefaultEditorIntoLines = (text)=>{
    if (!$24676658b763280d$var$checkTextInDefaultEditor(text)) throw new Error("Update function when using an object for text");
    return text.split("\n");
};
const $24676658b763280d$export$a56bfc049012f820 = {
    Editor: $24676658b763280d$export$2e7dc17ee6bf4ebd,
    blankT: "",
    getTextFromT: $24676658b763280d$var$getTextFromDefaultEditor,
    isT: (0, $jwDoS.isString),
    joinTintoBlock: $24676658b763280d$var$joinDefaultEditorIntoBlock,
    replaceTextInT: $24676658b763280d$var$replaceTextInDefaultEditor,
    splitTintoLines: $24676658b763280d$var$splitDefaultEditorIntoLines,
    textToT: (text)=>text
};
const $24676658b763280d$export$9e76654b4bc1019 = $24676658b763280d$export$a56bfc049012f820;

});
parcelRegister("jwDoS", function(module, exports) {

$parcel$export(module.exports, "getFromDataPath", function () { return $610c982cc54ac29d$export$fd69a3f4242d4d5d; });
$parcel$export(module.exports, "isString", function () { return $610c982cc54ac29d$export$844ec244b1367d54; });

var $3ew5o = parcelRequire("3ew5o");
const $610c982cc54ac29d$export$fd69a3f4242d4d5d = (dataPath, source, isFunction)=>{
    const pointer = (0, $3ew5o.Pointer).fromJSON(dataPath);
    const value = pointer.get(source);
    if (isFunction(value)) return value;
    return undefined;
};
const $610c982cc54ac29d$export$844ec244b1367d54 = (obj)=>typeof obj === "string";
const $610c982cc54ac29d$export$7e4aa119212bc614 = (obj)=>typeof obj === "number";
const $610c982cc54ac29d$export$f9ce7b637dfbe238 = (obj)=>typeof obj === "boolean";

});
parcelRegister("3ew5o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pointer = void 0;
module.exports.applyPatch = $25ab91899f441912$var$applyPatch;
module.exports.createPatch = $25ab91899f441912$var$createPatch;
module.exports.createTests = $25ab91899f441912$var$createTests;

var $7Pi6V = parcelRequire("7Pi6V");
Object.defineProperty(module.exports, "Pointer", {
    enumerable: true,
    get: function() {
        return $7Pi6V.Pointer;
    }
});

var $1SsWF = parcelRequire("1SsWF");

var $3TdtA = parcelRequire("3TdtA");
/**
Apply a 'application/json-patch+json'-type patch to an object.

`patch` *must* be an array of operations.

> Operation objects MUST have exactly one "op" member, whose value
> indicates the operation to perform.  Its value MUST be one of "add",
> "remove", "replace", "move", "copy", or "test"; other values are
> errors.

This method mutates the target object in-place.

@param object The object to apply the patch to
@param patch Array of operations to apply
@param options Optional customization of patch application behavior
@returns list of results, one for each operation: `null` indicated success,
         otherwise, the result will be an instance of one of the Error classes:
         MissingError, InvalidOperationError, or TestError.
*/ function $25ab91899f441912$var$applyPatch(object, patch, options) {
    return patch.map(function(operation) {
        return (0, $1SsWF.apply)(object, operation, options);
    });
}
function $25ab91899f441912$var$wrapVoidableDiff(diff) {
    function wrappedDiff(input, output, ptr) {
        var custom_patch = diff(input, output, ptr);
        // ensure an array is always returned
        return Array.isArray(custom_patch) ? custom_patch : (0, $3TdtA.diffAny)(input, output, ptr, wrappedDiff);
    }
    return wrappedDiff;
}
/**
Produce a 'application/json-patch+json'-type patch to get from one object to
another.

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

`diff` is called on each pair of comparable non-primitive nodes in the
`input`/`output` object trees, producing nested patches. Return `undefined`
to fall back to default behaviour.

Returns list of operations to perform on `input` to produce `output`.
*/ function $25ab91899f441912$var$createPatch(input, output, diff) {
    var ptr = new $7Pi6V.Pointer();
    // a new Pointer gets a default path of [''] if not specified
    return (diff ? $25ab91899f441912$var$wrapVoidableDiff(diff) : $3TdtA.diffAny)(input, output, ptr);
}
/**
Create a test operation based on `input`'s current evaluation of the JSON
Pointer `path`; if such a pointer cannot be resolved, returns undefined.
*/ function $25ab91899f441912$var$createTest(input, path) {
    var endpoint = $7Pi6V.Pointer.fromJSON(path).evaluate(input);
    if (endpoint !== undefined) return {
        op: 'test',
        path: path,
        value: endpoint.value
    };
}
/**
Produce an 'application/json-patch+json'-type list of tests, to verify that
existing values in an object are identical to the those captured at some
checkpoint (whenever this function is called).

This does not alter `input` or `output` unless they have a property getter with
side-effects (which is not a good idea anyway).

Returns list of test operations.
*/ function $25ab91899f441912$var$createTests(input, patch) {
    var tests = new Array();
    patch.filter($3TdtA.isDestructive).forEach(function(operation) {
        var pathTest = $25ab91899f441912$var$createTest(input, operation.path);
        if (pathTest) tests.push(pathTest);
        if ('from' in operation) {
            var fromTest = $25ab91899f441912$var$createTest(input, operation.from);
            if (fromTest) tests.push(fromTest);
        }
    });
    return tests;
}

});
parcelRegister("7Pi6V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Pointer = void 0;
module.exports.unescapeToken = $5b2b5835d159ece2$var$unescapeToken;
module.exports.escapeToken = $5b2b5835d159ece2$var$escapeToken;
/**
Unescape token part of a JSON Pointer string

`token` should *not* contain any '/' characters.

> Evaluation of each reference token begins by decoding any escaped
> character sequence.  This is performed by first transforming any
> occurrence of the sequence '~1' to '/', and then transforming any
> occurrence of the sequence '~0' to '~'.  By performing the
> substitutions in this order, an implementation avoids the error of
> turning '~01' first into '~1' and then into '/', which would be
> incorrect (the string '~01' correctly becomes '~1' after
> transformation).

Here's my take:

~1 is unescaped with higher priority than ~0 because it is a lower-order escape character.
I say "lower order" because '/' needs escaping due to the JSON Pointer serialization technique.
Whereas, '~' is escaped because escaping '/' uses the '~' character.
*/ function $5b2b5835d159ece2$var$unescapeToken(token) {
    return token.replace(/~1/g, '/').replace(/~0/g, '~');
}
/** Escape token part of a JSON Pointer string

> '~' needs to be encoded as '~0' and '/'
> needs to be encoded as '~1' when these characters appear in a
> reference token.

This is the exact inverse of `unescapeToken()`, so the reverse replacements must take place in reverse order.
*/ function $5b2b5835d159ece2$var$escapeToken(token) {
    return token.replace(/~/g, '~0').replace(/\//g, '~1');
}
/**
JSON Pointer representation
*/ var $5b2b5835d159ece2$var$Pointer = /** @class */ function() {
    function Pointer(tokens) {
        if (tokens === void 0) tokens = [
            ''
        ];
        this.tokens = tokens;
    }
    /**
    `path` *must* be a properly escaped string.
    */ Pointer.fromJSON = function(path) {
        var tokens = path.split('/').map($5b2b5835d159ece2$var$unescapeToken);
        if (tokens[0] !== '') throw new Error("Invalid JSON Pointer: ".concat(path));
        return new Pointer(tokens);
    };
    Pointer.prototype.toString = function() {
        return this.tokens.map($5b2b5835d159ece2$var$escapeToken).join('/');
    };
    /**
    Returns an object with 'parent', 'key', and 'value' properties.
    In the special case that this Pointer's path == "",
    this object will be {parent: null, key: '', value: object}.
    Otherwise, parent and key will have the property such that parent[key] == value.
    */ Pointer.prototype.evaluate = function(object) {
        var parent = null;
        var key = '';
        var value = object;
        for(var i = 1, l = this.tokens.length; i < l; i++){
            parent = value;
            key = this.tokens[i];
            if (key == '__proto__' || key == 'constructor' || key == 'prototype') continue;
            // not sure if this the best way to handle non-existant paths...
            value = (parent || {})[key];
        }
        return {
            parent: parent,
            key: key,
            value: value
        };
    };
    Pointer.prototype.get = function(object) {
        return this.evaluate(object).value;
    };
    Pointer.prototype.set = function(object, value) {
        var endpoint = this.evaluate(object);
        if (endpoint.parent) endpoint.parent[endpoint.key] = value;
    };
    Pointer.prototype.push = function(token) {
        // mutable
        this.tokens.push(token);
    };
    /**
    `token` should be a String. It'll be coerced to one anyway.
  
    immutable (shallowly)
    */ Pointer.prototype.add = function(token) {
        var tokens = this.tokens.concat(String(token));
        return new Pointer(tokens);
    };
    /**
    Create a new Pointer representing the parent of this one.
  
    The parent of the empty pointer is the empty pointer.
  
    immutable (shallowly)
    */ Pointer.prototype.parent = function() {
        var tokens = this.tokens.length > 1 ? this.tokens.slice(0, -1) : [
            ''
        ];
        return new Pointer(tokens);
    };
    return Pointer;
}();
module.exports.Pointer = $5b2b5835d159ece2$var$Pointer;

});

parcelRegister("1SsWF", function(module, exports) {
"use strict";
var $15e149854509a2af$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidOperationError = module.exports.TestError = module.exports.MissingError = void 0;
module.exports.add = $15e149854509a2af$var$add;
module.exports.remove = $15e149854509a2af$var$remove;
module.exports.replace = $15e149854509a2af$var$replace;
module.exports.move = $15e149854509a2af$var$move;
module.exports.copy = $15e149854509a2af$var$copy;
module.exports.test = $15e149854509a2af$var$test;
module.exports.apply = $15e149854509a2af$var$apply;

var $7Pi6V = parcelRequire("7Pi6V");

var $8vpvR = parcelRequire("8vpvR");

var $3TdtA = parcelRequire("3TdtA");
var $15e149854509a2af$var$MissingError = /** @class */ function(_super) {
    $15e149854509a2af$var$__extends(MissingError, _super);
    function MissingError(path) {
        var _this = _super.call(this, "Value required at path: ".concat(path)) || this;
        _this.path = path;
        _this.name = 'MissingError';
        return _this;
    }
    return MissingError;
}(Error);
module.exports.MissingError = $15e149854509a2af$var$MissingError;
var $15e149854509a2af$var$TestError = /** @class */ function(_super) {
    $15e149854509a2af$var$__extends(TestError, _super);
    function TestError(actual, expected) {
        var _this = _super.call(this, "Test failed: ".concat(actual, " != ").concat(expected)) || this;
        _this.actual = actual;
        _this.expected = expected;
        _this.name = 'TestError';
        return _this;
    }
    return TestError;
}(Error);
module.exports.TestError = $15e149854509a2af$var$TestError;
function $15e149854509a2af$var$_add(object, key, value) {
    if (Array.isArray(object)) {
        // `key` must be an index
        if (key == '-') object.push(value);
        else {
            var index = parseInt(key, 10);
            object.splice(index, 0, value);
        }
    } else object[key] = value;
}
function $15e149854509a2af$var$_remove(object, key) {
    if (Array.isArray(object)) {
        // '-' syntax doesn't make sense when removing
        var index = parseInt(key, 10);
        object.splice(index, 1);
    } else // not sure what the proper behavior is when path = ''
    delete object[key];
}
/**
>  o  If the target location specifies an array index, a new value is
>     inserted into the array at the specified index.
>  o  If the target location specifies an object member that does not
>     already exist, a new member is added to the object.
>  o  If the target location specifies an object member that does exist,
>     that member's value is replaced.
*/ function $15e149854509a2af$var$add(object, operation, options) {
    // RFC 6902 §4: every operation object MUST contain a "path" member.
    // Pointer.fromJSON enforces the string/syntax contract itself (and throws on violation);
    // this only guards the missing/null case.
    if (operation.path == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    // Verify RFC 6902 compliance; `undefined` is a legitimate value here,
    // so check own-property membership, not `operation.value === undefined`
    // (and not `in`, which would also see a polluted Object.prototype).
    if (!$8vpvR.hasOwnProperty.call(operation, 'value')) return new $15e149854509a2af$var$InvalidOperationError(operation);
    var pointer = $7Pi6V.Pointer.fromJSON(operation.path);
    // Handle implicit array creation for terminal "/-" paths
    if ((options === null || options === void 0 ? void 0 : options.implicitArrayCreation) && pointer.tokens[pointer.tokens.length - 1] === '-') {
        // Try to evaluate the parent (the array itself)
        var parentEndpoint = pointer.parent().evaluate(object);
        // If the array property doesn't exist but its parent does,
        // and this parent is a plain object (not an array),
        // create an (empty) array that we will add to below.
        if (parentEndpoint.value === undefined && (0, $8vpvR.objectType)(parentEndpoint.parent) === 'object') parentEndpoint.parent[parentEndpoint.key] = [];
    }
    var endpoint = pointer.evaluate(object);
    // it's not exactly a "MissingError" in the same way that `remove` is -- more like a MissingParent, or something
    if (endpoint.parent === undefined || endpoint.parent === null) return new $15e149854509a2af$var$MissingError(operation.path);
    // When using implicitArrayCreation, validate that "/-" targets are actually arrays
    if ((options === null || options === void 0 ? void 0 : options.implicitArrayCreation) && endpoint.key === '-' && !Array.isArray(endpoint.parent)) return new $15e149854509a2af$var$MissingError(operation.path);
    // For arrays, check that the key strictly follows RFC 6901:
    // only digits (no leading 0's, sign, decimal point, or exponent).
    // Also check that the index does not exceed the array's length
    // (`key == endpoint.parent.length` is the valid append case).
    if (Array.isArray(endpoint.parent) && endpoint.key !== '-') {
        if (!/^(0|[1-9][0-9]*)$/.test(endpoint.key)) return new $15e149854509a2af$var$MissingError(operation.path);
        if (Number(endpoint.key) > endpoint.parent.length) return new $15e149854509a2af$var$MissingError(operation.path);
    }
    $15e149854509a2af$var$_add(endpoint.parent, endpoint.key, (0, $8vpvR.clone)(operation.value));
    return null;
}
/**
> The "remove" operation removes the value at the target location.
> The target location MUST exist for the operation to be successful.
*/ function $15e149854509a2af$var$remove(object, operation, options) {
    // RFC 6902 §4: every operation object MUST contain a "path" member.
    if (operation.path == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    // endpoint has parent, key, and value properties
    var endpoint = $7Pi6V.Pointer.fromJSON(operation.path).evaluate(object);
    // the root pointer "" has no parent to remove from (mirrors `replace`)
    if (endpoint.parent === null) return new $15e149854509a2af$var$MissingError(operation.path);
    if (endpoint.value === undefined) return new $15e149854509a2af$var$MissingError(operation.path);
    $15e149854509a2af$var$_remove(endpoint.parent, endpoint.key);
    return null;
}
/**
> The "replace" operation replaces the value at the target location
> with a new value.  The operation object MUST contain a "value" member
> whose content specifies the replacement value.
> The target location MUST exist for the operation to be successful.

> This operation is functionally identical to a "remove" operation for
> a value, followed immediately by an "add" operation at the same
> location with the replacement value.

Even more simply, it's like the add operation with an existence check.
*/ function $15e149854509a2af$var$replace(object, operation, options) {
    // RFC 6902 §4: every operation object MUST contain a "path" member.
    if (operation.path == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    // Verify RFC 6902 compliance; `undefined` is a legitimate value here.
    // See comment in `add` above.
    if (!$8vpvR.hasOwnProperty.call(operation, 'value')) return new $15e149854509a2af$var$InvalidOperationError(operation);
    var endpoint = $7Pi6V.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === null) return new $15e149854509a2af$var$MissingError(operation.path);
    // this existence check treats arrays as a special case
    if (Array.isArray(endpoint.parent)) {
        if (parseInt(endpoint.key, 10) >= endpoint.parent.length) return new $15e149854509a2af$var$MissingError(operation.path);
    } else if (endpoint.value === undefined) return new $15e149854509a2af$var$MissingError(operation.path);
    endpoint.parent[endpoint.key] = (0, $8vpvR.clone)(operation.value);
    return null;
}
/**
> The "move" operation removes the value at a specified location and
> adds it to the target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to move the value from.
> This operation is functionally identical to a "remove" operation on
> the "from" location, followed immediately by an "add" operation at
> the target location with the value that was just removed.

> The "from" location MUST NOT be a proper prefix of the "path"
> location; i.e., a location cannot be moved into one of its children.
*/ function $15e149854509a2af$var$move(object, operation, options) {
    // RFC 6902 §4.4: the operation object MUST contain "path" and "from" members.
    if (operation.path == null || operation.from == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    var from_pointer = $7Pi6V.Pointer.fromJSON(operation.from);
    var from_endpoint = from_pointer.evaluate(object);
    if (from_endpoint.value === undefined) return new $15e149854509a2af$var$MissingError(operation.from);
    var pointer = $7Pi6V.Pointer.fromJSON(operation.path);
    // a location cannot be moved into one of its own children; doing so would
    // detach the destination along with the value and silently lose data
    if (from_pointer.tokens.length < pointer.tokens.length && from_pointer.tokens.every(function(token, index) {
        return token === pointer.tokens[index];
    })) return new $15e149854509a2af$var$MissingError(operation.path);
    var endpoint = pointer.evaluate(object);
    if (endpoint.parent === undefined || endpoint.parent === null) return new $15e149854509a2af$var$MissingError(operation.path);
    $15e149854509a2af$var$_remove(from_endpoint.parent, from_endpoint.key);
    $15e149854509a2af$var$_add(endpoint.parent, endpoint.key, from_endpoint.value);
    return null;
}
/**
> The "copy" operation copies the value at a specified location to the
> target location.
> The operation object MUST contain a "from" member, which is a string
> containing a JSON Pointer value that references the location in the
> target document to copy the value from.
> The "from" location MUST exist for the operation to be successful.

> This operation is functionally identical to an "add" operation at the
> target location using the value specified in the "from" member.

Alternatively, it's like 'move' without the 'remove'.
*/ function $15e149854509a2af$var$copy(object, operation, options) {
    // RFC 6902 §4.5: the operation object MUST contain "path" and "from" members.
    // Pointer.fromJSON enforces the string/syntax contract itself (and throws
    // on violation); this only guards the missing/null case.
    if (operation.path == null || operation.from == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    var from_endpoint = $7Pi6V.Pointer.fromJSON(operation.from).evaluate(object);
    if (from_endpoint.value === undefined) return new $15e149854509a2af$var$MissingError(operation.from);
    var endpoint = $7Pi6V.Pointer.fromJSON(operation.path).evaluate(object);
    if (endpoint.parent === undefined || endpoint.parent === null) return new $15e149854509a2af$var$MissingError(operation.path);
    $15e149854509a2af$var$_add(endpoint.parent, endpoint.key, (0, $8vpvR.clone)(from_endpoint.value));
    return null;
}
/**
> The "test" operation tests that a value at the target location is
> equal to a specified value.
> The operation object MUST contain a "value" member that conveys the
> value to be compared to the target location's value.
> The target location MUST be equal to the "value" value for the
> operation to be considered successful.
*/ function $15e149854509a2af$var$test(object, operation, options) {
    // RFC 6902 §4: every operation object MUST contain a "path" member.
    if (operation.path == null) return new $15e149854509a2af$var$InvalidOperationError(operation);
    var endpoint = $7Pi6V.Pointer.fromJSON(operation.path).evaluate(object);
    // TODO: this diffAny(...).length usage could/should be lazy
    if ((0, $3TdtA.diffAny)(endpoint.value, operation.value, new $7Pi6V.Pointer()).length) return new $15e149854509a2af$var$TestError(endpoint.value, operation.value);
    return null;
}
var $15e149854509a2af$var$InvalidOperationError = /** @class */ function(_super) {
    $15e149854509a2af$var$__extends(InvalidOperationError, _super);
    function InvalidOperationError(operation) {
        var _this = _super.call(this, "Invalid operation: ".concat(operation.op)) || this;
        _this.operation = operation;
        _this.name = 'InvalidOperationError';
        return _this;
    }
    return InvalidOperationError;
}(Error);
module.exports.InvalidOperationError = $15e149854509a2af$var$InvalidOperationError;
/**
Switch on `operation.op`, applying the corresponding patch function for each
case to `object`.
*/ function $15e149854509a2af$var$apply(object, operation, options) {
    // not sure why TypeScript can't infer typesafety of:
    //   {add, remove, replace, move, copy, test}[operation.op](object, operation)
    // (seems like a bug)
    switch(operation.op){
        case 'add':
            return $15e149854509a2af$var$add(object, operation, options);
        case 'remove':
            return $15e149854509a2af$var$remove(object, operation, options);
        case 'replace':
            return $15e149854509a2af$var$replace(object, operation, options);
        case 'move':
            return $15e149854509a2af$var$move(object, operation, options);
        case 'copy':
            return $15e149854509a2af$var$copy(object, operation, options);
        case 'test':
            return $15e149854509a2af$var$test(object, operation, options);
    }
    return new $15e149854509a2af$var$InvalidOperationError(operation);
}

});
parcelRegister("8vpvR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasOwnProperty = void 0;
module.exports.objectType = $63150252fbfa1e89$var$objectType;
module.exports.clone = $63150252fbfa1e89$var$clone;
module.exports.hasOwnProperty = Object.prototype.hasOwnProperty;
function $63150252fbfa1e89$var$objectType(object) {
    if (object === undefined) return 'undefined';
    if (object === null) return 'null';
    if (Array.isArray(object)) return 'array';
    return typeof object;
}
function $63150252fbfa1e89$var$isNonPrimitive(value) {
    // loose-equality checking for null is faster than strict checking for each of null/undefined/true/false
    // checking null first, then calling typeof, is faster than vice-versa
    return value != null && typeof value == 'object';
}
/**
Recursively copy a value.

@param source - should be a JavaScript primitive, Array, Date, or (plain old) Object.
@returns copy of source where every Array and Object have been recursively
         reconstructed from their constituent elements
*/ function $63150252fbfa1e89$var$clone(source) {
    if (!$63150252fbfa1e89$var$isNonPrimitive(source)) // short-circuiting is faster than a single return
    return source;
    // x.constructor == Array is the fastest way to check if x is an Array
    if (source.constructor == Array) {
        // construction via imperative for-loop is faster than source.map(arrayVsObject)
        var length = source.length;
        // setting the Array length during construction is faster than just `[]` or `new Array()`
        var arrayTarget = new Array(length);
        for(var i = 0; i < length; i++)arrayTarget[i] = $63150252fbfa1e89$var$clone(source[i]);
        return arrayTarget;
    }
    // Date
    if (source.constructor == Date) {
        var dateTarget = new Date(+source);
        return dateTarget;
    }
    // Object
    var objectTarget = {};
    // declaring the variable (with const) inside the loop is faster
    for(var key in source)// hasOwnProperty costs a bit of performance, but it's semantically necessary
    // using a global helper is MUCH faster than calling source.hasOwnProperty(key)
    // assigning to '__proto__' would replace objectTarget's prototype (prototype pollution)
    if (module.exports.hasOwnProperty.call(source, key) && key != '__proto__') objectTarget[key] = $63150252fbfa1e89$var$clone(source[key]);
    return objectTarget;
}

});

parcelRegister("3TdtA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDestructive = $2d50f6420edb4322$var$isDestructive;
module.exports.subtract = $2d50f6420edb4322$var$subtract;
module.exports.intersection = $2d50f6420edb4322$var$intersection;
module.exports.diffArrays = $2d50f6420edb4322$var$diffArrays;
module.exports.diffObjects = $2d50f6420edb4322$var$diffObjects;
module.exports.diffAny = $2d50f6420edb4322$var$diffAny;

var $8vpvR = parcelRequire("8vpvR");
function $2d50f6420edb4322$var$isDestructive(_a) {
    var op = _a.op;
    return op === 'remove' || op === 'replace' || op === 'copy' || op === 'move';
}
/**
List the keys in `minuend` that are not in `subtrahend`.

A key is only considered if it is both 1) an own-property (o.hasOwnProperty(k))
of the object, and 2) has a value that is not undefined. This is to match JSON
semantics, where JSON object serialization drops keys with undefined values.

@param minuend Object of interest
@param subtrahend Object of comparison
@returns Array of keys that are in `minuend` but not in `subtrahend`.
*/ function $2d50f6420edb4322$var$subtract(minuend, subtrahend) {
    var keys = [];
    for(var key in minuend)if ($8vpvR.hasOwnProperty.call(minuend, key) && minuend[key] !== undefined && !($8vpvR.hasOwnProperty.call(subtrahend, key) && subtrahend[key] !== undefined)) keys.push(key);
    return keys;
}
/**
List the keys that shared by all `objects`.

The semantics of what constitutes a "key" is described in {@link subtract}.

@param objects Array of objects to compare
@returns Array of keys that are in ("own-properties" of) every object in `objects`.
*/ function $2d50f6420edb4322$var$intersection(objects) {
    var length = objects.length;
    // prepare empty counter to keep track of how many objects each key occurred in
    var counter = {};
    // go through each object and increment the counter for each key in that object
    for(var i = 0; i < length; i++){
        var object = objects[i];
        for(var key in object)if ($8vpvR.hasOwnProperty.call(object, key) && object[key] !== undefined) counter[key] = (counter[key] || 0) + 1;
    }
    // now delete all keys from the counter that were not seen in every object
    for(var key in counter)if (counter[key] < length) delete counter[key];
    // finally, extract whatever keys remain in the counter
    return Object.keys(counter);
}
/**
List the keys that shared by all `a` and `b`.

The semantics of what constitutes a "key" is described in {@link subtract}.

@param a First object to compare
@param b Second object to compare
@returns Array of keys that are in ("own-properties" of) `a` and `b`.
*/ function $2d50f6420edb4322$var$intersection2(a, b) {
    var keys = [];
    for(var key in a)if ($8vpvR.hasOwnProperty.call(a, key) && a[key] !== undefined && $8vpvR.hasOwnProperty.call(b, key) && b[key] !== undefined) keys.push(key);
    return keys;
}
function $2d50f6420edb4322$var$isArrayAdd(array_operation) {
    return array_operation.op === 'add';
}
function $2d50f6420edb4322$var$isArrayRemove(array_operation) {
    return array_operation.op === 'remove';
}
function $2d50f6420edb4322$var$appendArrayOperation(base, operation) {
    return {
        // the new operation must be pushed on the end
        operations: base.operations.concat(operation),
        cost: base.cost + 1
    };
}
/**
Calculate the shortest sequence of operations to get from `input` to `output`,
using a dynamic programming implementation of the Levenshtein distance algorithm.

To get from the input ABC to the output AZ we could just delete all the input
and say "insert A, insert Z" and be done with it. That's what we do if the
input is empty. But we can be smarter.

          output
               A   Z
               -   -
          [0]  1   2
input A |  1  [0]  1
      B |  2  [1]  1
      C |  3   2  [2]

1) start at 0,0 (+0)
2) keep A (+0)
3) remove B (+1)
4) replace C with Z (+1)

If the `input` (source) is empty, they'll all be in the top row, resulting in an
array of 'add' operations.
If the `output` (target) is empty, everything will be in the left column,
resulting in an array of 'remove' operations.

@returns A list of add/remove/replace operations.
*/ function $2d50f6420edb4322$var$diffArrays(input, output, ptr, diff) {
    if (diff === void 0) diff = $2d50f6420edb4322$var$diffAny;
    // set up cost matrix (very simple initialization: just a map)
    var max_length = Math.max(input.length, output.length);
    var memo = new Map([
        [
            0,
            {
                operations: [],
                cost: 0
            }
        ]
    ]);
    /**
    Calculate the cheapest sequence of operations required to get from
    input.slice(0, i) to output.slice(0, j).
    There may be other valid sequences with the same cost, but none cheaper.
  
    @param i The row in the layout above
    @param j The column in the layout above
    @returns An object containing a list of operations, along with the total cost
             of applying them (+1 for each add/remove/replace operation)
    */ function dist(i, j) {
        // memoized
        var memo_key = i * (max_length + 1) + j;
        var memoized = memo.get(memo_key);
        if (memoized === undefined) {
            // TODO: this !diff(...).length usage could/should be lazy
            if (i > 0 && j > 0 && !diff(input[i - 1], output[j - 1], ptr.add(String(i - 1))).length) // equal (no operations => no cost)
            memoized = dist(i - 1, j - 1);
            else {
                var alternatives = [];
                if (i > 0) {
                    // NOT topmost row
                    var remove_base = dist(i - 1, j);
                    var remove_operation = {
                        op: 'remove',
                        index: i - 1
                    };
                    alternatives.push($2d50f6420edb4322$var$appendArrayOperation(remove_base, remove_operation));
                }
                if (j > 0) {
                    // NOT leftmost column
                    var add_base = dist(i, j - 1);
                    var add_operation = {
                        op: 'add',
                        index: i - 1,
                        value: output[j - 1]
                    };
                    alternatives.push($2d50f6420edb4322$var$appendArrayOperation(add_base, add_operation));
                }
                if (i > 0 && j > 0) {
                    // TABLE MIDDLE
                    // supposing we replaced it, compute the rest of the costs:
                    var replace_base = dist(i - 1, j - 1);
                    // okay, the general plan is to replace it, but we can be smarter,
                    // recursing into the structure and replacing only part of it if
                    // possible, but to do so we'll need the original value
                    var replace_operation = {
                        op: 'replace',
                        index: i - 1,
                        original: input[i - 1],
                        value: output[j - 1]
                    };
                    alternatives.push($2d50f6420edb4322$var$appendArrayOperation(replace_base, replace_operation));
                }
                // the only other case, i === 0 && j === 0, has already been memoized
                // the meat of the algorithm:
                // sort by cost to find the lowest one (might be several ties for lowest)
                // [4, 6, 7, 1, 2].sort((a, b) => a - b) -> [ 1, 2, 4, 6, 7 ]
                var best = alternatives.sort(function(a, b) {
                    return a.cost - b.cost;
                })[0];
                memoized = best;
            }
            memo.set(memo_key, memoized);
        }
        return memoized;
    }
    // handle weird objects masquerading as Arrays that don't have proper length
    // properties by using 0 for everything but positive numbers
    var input_length = isNaN(input.length) || input.length <= 0 ? 0 : input.length;
    var output_length = isNaN(output.length) || output.length <= 0 ? 0 : output.length;
    var array_operations = dist(input_length, output_length).operations;
    var padded_operations = array_operations.reduce(function(_a, array_operation) {
        var operations = _a[0], padding = _a[1];
        if ($2d50f6420edb4322$var$isArrayAdd(array_operation)) {
            var padded_index = array_operation.index + 1 + padding;
            var index_token = padded_index < input_length + padding ? String(padded_index) : '-';
            var operation = {
                op: array_operation.op,
                path: ptr.add(index_token).toString(),
                value: array_operation.value
            };
            // padding++ // maybe only if array_operation.index > -1 ?
            return [
                operations.concat(operation),
                padding + 1
            ];
        } else if ($2d50f6420edb4322$var$isArrayRemove(array_operation)) {
            var operation = {
                op: array_operation.op,
                path: ptr.add(String(array_operation.index + padding)).toString()
            };
            // padding--
            return [
                operations.concat(operation),
                padding - 1
            ];
        } else {
            var replace_ptr = ptr.add(String(array_operation.index + padding));
            var replace_operations = diff(array_operation.original, array_operation.value, replace_ptr);
            return [
                operations.concat.apply(operations, replace_operations),
                padding
            ];
        }
    }, [
        [],
        0
    ])[0];
    return padded_operations;
}
function $2d50f6420edb4322$var$diffObjects(input, output, ptr, diff) {
    if (diff === void 0) diff = $2d50f6420edb4322$var$diffAny;
    // if a key is in input but not output -> remove it
    var operations = [];
    $2d50f6420edb4322$var$subtract(input, output).forEach(function(key) {
        operations.push({
            op: 'remove',
            path: ptr.add(key).toString()
        });
    });
    // if a key is in output but not input -> add it
    $2d50f6420edb4322$var$subtract(output, input).forEach(function(key) {
        operations.push({
            op: 'add',
            path: ptr.add(key).toString(),
            value: output[key]
        });
    });
    // if a key is in both, diff it recursively
    $2d50f6420edb4322$var$intersection2(input, output).forEach(function(key) {
        operations.push.apply(operations, diff(input[key], output[key], ptr.add(key)));
    });
    return operations;
}
/**
`diffAny()` returns an empty array if `input` and `output` are materially equal
(i.e., would produce equivalent JSON); otherwise it produces an array of patches
that would transform `input` into `output`.

> Here, "equal" means that the value at the target location and the
> value conveyed by "value" are of the same JSON type, and that they
> are considered equal by the following rules for that type:
> o  strings: are considered equal if they contain the same number of
>    Unicode characters and their code points are byte-by-byte equal.
> o  numbers: are considered equal if their values are numerically
>    equal.
> o  arrays: are considered equal if they contain the same number of
>    values, and if each value can be considered equal to the value at
>    the corresponding position in the other array, using this list of
>    type-specific rules.
> o  objects: are considered equal if they contain the same number of
>    members, and if each member can be considered equal to a member in
>    the other object, by comparing their keys (as strings) and their
>    values (using this list of type-specific rules).
> o  literals (false, true, and null): are considered equal if they are
>    the same.
*/ function $2d50f6420edb4322$var$diffAny(input, output, ptr, diff) {
    if (diff === void 0) diff = $2d50f6420edb4322$var$diffAny;
    // strict equality handles literals, numbers, and strings (a sufficient but not necessary cause)
    if (input === output) return [];
    var input_type = (0, $8vpvR.objectType)(input);
    var output_type = (0, $8vpvR.objectType)(output);
    if (input_type == 'array' && output_type == 'array') return $2d50f6420edb4322$var$diffArrays(input, output, ptr, diff);
    if (input_type == 'object' && output_type == 'object') return $2d50f6420edb4322$var$diffObjects(input, output, ptr, diff);
    // at this point we know that input and output are materially different;
    // could be array -> object, object -> array, boolean -> undefined,
    // number -> string, or some other combination, but nothing that can be split
    // up into multiple patches: so `output` must replace `input` wholesale.
    return [
        {
            op: 'replace',
            path: ptr.toString(),
            value: output
        }
    ];
}

});





parcelRegister("4D2as", function(module, exports) {

$parcel$export(module.exports, "formatJson", function () { return $e4cee895272a8b4a$export$caaf42eec70aeca7; });
/**
 * Helper function to format a JSON string with specified indentation.
 *
 * @param input - The JSON input to format
 * @param indentation - The indentation level or string to use for formatting
 * @returns string
 */ const $e4cee895272a8b4a$export$caaf42eec70aeca7 = (input, indentation = 2)=>{
    try {
        const parsed = JSON.parse(input.trim());
        return JSON.stringify(parsed, null, indentation);
    } catch  {
        return input;
    }
};

});

parcelRegister("fNNZS", function(module, exports) {

$parcel$export(module.exports, "getNestedValue", function () { return $65a9aef571b673cb$export$2516322ffbb7f3fb; });
/**
 * Gets or creates a nested value at the current path level for recursive operations.
 * If the existing value is an object or array, a copy is returned to maintain immutability.
 * Otherwise, a new object or array is created based on whether the next path part is numeric.
 *
 * @param obj - The current object or array being traversed.
 * @param firstPart - The current path part (property name or array index).
 * @param restParts - The remaining path parts.
 * @returns A copy of the nested value to recurse into, either copied or newly created.
 */ const $65a9aef571b673cb$export$2516322ffbb7f3fb = (obj, firstPart, restParts)=>{
    const existingValue = obj[firstPart];
    const nested = (typeof existingValue === "object" || Array.isArray(existingValue)) && existingValue !== null ? Array.isArray(existingValue) ? [
        ...existingValue
    ] : {
        ...existingValue
    } : /^\d+$/.test(restParts[0]) ? [] : {};
    return nested;
};

});

parcelRegister("ayG2q", function(module, exports) {

$parcel$export(module.exports, "getValidationOptions", function () { return $3e50a1edfaf2bf9a$export$6ba34a08af76995f; });
const $3e50a1edfaf2bf9a$export$6ba34a08af76995f = (input, values)=>typeof input.validationOptions === "function" ? input.validationOptions(values) : input.validationOptions;

});

parcelRegister("dbVjd", function(module, exports) {

$parcel$export(module.exports, "TLF_VIEW_MODES", function () { return $3ee919fecb0286aa$export$fbd78b4dd0bb31e2; });

var $4lHS7 = parcelRequire("4lHS7");
const $3ee919fecb0286aa$export$fbd78b4dd0bb31e2 = [
    // The first value will be used as the default
    {
        value: "TLF",
        label: "TLF view"
    },
    {
        value: "ANNOTATIONS",
        label: "Annotations view"
    },
    {
        value: "SUPPRESS_REPEATS",
        label: "Suppress repeats",
        showOnlyForTlfTypes: new Set([
            (0, $4lHS7.eTlfItemType).table,
            (0, $4lHS7.eTlfItemType).listing
        ]),
        noRepeatProcessing: true
    },
    {
        value: "ARS_VIEW",
        label: "ARS view",
        showOnlyForTlfTypes: new Set([
            (0, $4lHS7.eTlfItemType).arsListing,
            (0, $4lHS7.eTlfItemType).arsTable
        ])
    }
];

});
parcelRegister("4lHS7", function(module, exports) {

$parcel$export(module.exports, "eAccessLevel", function () { return $3f96b3e42c3802e2$export$a80b30d56dd149b1; });
$parcel$export(module.exports, "eAccessRights", function () { return $3f96b3e42c3802e2$export$4bec5847cb5ff3a; });
$parcel$export(module.exports, "eApplicationPermission", function () { return $3f96b3e42c3802e2$export$d8ac1aa81292809d; });
$parcel$export(module.exports, "eHierarchy", function () { return $3f96b3e42c3802e2$export$e7266695cf55e88a; });
$parcel$export(module.exports, "eHierarchyLevel", function () { return $3f96b3e42c3802e2$export$5a585d9be59e92c4; });
$parcel$export(module.exports, "eLinkType", function () { return $3f96b3e42c3802e2$export$e870f6113b70591b; });
$parcel$export(module.exports, "eReleaseStatus", function () { return $3f96b3e42c3802e2$export$164fbd244bbd9b38; });
$parcel$export(module.exports, "eTlfItemType", function () { return $3f96b3e42c3802e2$export$2ada4144fce9aac8; });
$parcel$export(module.exports, "eHistoryType", function () { return $3f96b3e42c3802e2$export$b19998638fca5954; });
$parcel$export(module.exports, "eTlfOutputType", function () { return $3f96b3e42c3802e2$export$39b5e962b0bc717b; });
$parcel$export(module.exports, "eShowTiFo", function () { return $3f96b3e42c3802e2$export$f7aaabe3472f411a; });
$parcel$export(module.exports, "SearchableEditorBlocks", function () { return $3f96b3e42c3802e2$export$850e61c9e6223cb4; });
var $3f96b3e42c3802e2$export$a80b30d56dd149b1 = /*#__PURE__*/ function(eAccessLevel) {
    eAccessLevel["none"] = "No access";
    eAccessLevel["viewer"] = "Viewer";
    eAccessLevel["editor"] = "Editor";
    eAccessLevel["lead"] = "Lead";
    eAccessLevel["admin"] = "Admin";
    eAccessLevel["remove"] = "Remove rights";
    return eAccessLevel;
}({});
var $3f96b3e42c3802e2$export$4bec5847cb5ff3a = /*#__PURE__*/ function(eAccessRights) {
    eAccessRights["CreateHierarchy"] = "CreateHierarchy";
    eAccessRights["DeleteHierarchy"] = "DeleteHierarchy";
    eAccessRights["DeleteReport"] = "DeleteReport";
    eAccessRights["MaintainHierarchy"] = "MaintainHierarchy";
    eAccessRights["MaintainHierarchyComments"] = "MaintainHierarchyComments";
    eAccessRights["MaintainHierarchyUsers"] = "MaintainHierarchyUsers";
    eAccessRights["ReadTlfItemsFromHierarchy"] = "ReadTlfItemsFromHierarchy";
    eAccessRights["WriteToTlfItemsInHierarchy"] = "WriteToTlfItemsInHierarchy";
    return eAccessRights;
}({});
var $3f96b3e42c3802e2$export$d8ac1aa81292809d = /*#__PURE__*/ function(eApplicationPermission) {
    eApplicationPermission["AllowArsBulkExportImport"] = "AllowArsBulkExportImport";
    eApplicationPermission["AllowJsonDownload"] = "AllowJsonDownload";
    eApplicationPermission["AllowJsonUpload"] = "AllowJsonUpload";
    eApplicationPermission["AllowHelpEdit"] = "AllowHelpEdit";
    eApplicationPermission["AllowNewsEdit"] = "AllowNewsEdit";
    eApplicationPermission["AllowStudyStandardDateEdit"] = "AllowStudyStandardDateEdit";
    eApplicationPermission["UpdateStandardsSettings"] = "UpdateStandardsSettings";
    eApplicationPermission["AllowStyleManagement"] = "AllowStyleManagement";
    eApplicationPermission["AllowTextRuleManagement"] = "AllowTextRuleManagement";
    eApplicationPermission["AllowDefineXmlUpload"] = "AllowDefineXmlUpload";
    eApplicationPermission["ManageTlfTags"] = "ManageTlfTags";
    eApplicationPermission["EditAnalysisMethods"] = "EditAnalysisMethods";
    return eApplicationPermission;
}({});
var $3f96b3e42c3802e2$export$e7266695cf55e88a = /*#__PURE__*/ function(eHierarchy) {
    eHierarchy["TopLevel"] = "TopLevel";
    eHierarchy["Directory"] = "Directory";
    eHierarchy["StudyDirectory"] = "StudyDirectory";
    eHierarchy["Report"] = "Report";
    return eHierarchy;
}({});
var $3f96b3e42c3802e2$export$5a585d9be59e92c4 = /*#__PURE__*/ function(eHierarchyLevel) {
    eHierarchyLevel["TopLevel"] = "TopLevel";
    eHierarchyLevel["Corporate"] = "Corporate";
    eHierarchyLevel["TA"] = "TA";
    eHierarchyLevel["Project"] = "Project";
    eHierarchyLevel["Study"] = "Study";
    eHierarchyLevel["Report"] = "Report";
    return eHierarchyLevel;
}({});
var $3f96b3e42c3802e2$export$e870f6113b70591b = /*#__PURE__*/ function(eLinkType) {
    eLinkType["CopiedFromTemplate"] = "CopiedFromTemplate";
    eLinkType["BasedOn"] = "BasedOn";
    eLinkType["HasVersion"] = "HasVersion";
    eLinkType["Successor"] = "Successor";
    eLinkType["Predecessor"] = "Predecessor";
    return eLinkType;
}({});
var $3f96b3e42c3802e2$export$164fbd244bbd9b38 = /*#__PURE__*/ function(eReleaseStatus) {
    eReleaseStatus["Draft"] = "Draft";
    eReleaseStatus["ReleasePending"] = "ReleasePending";
    eReleaseStatus["Valid"] = "Valid";
    eReleaseStatus["DecommissingPending"] = "DecomissionPending";
    eReleaseStatus["Decommissioned"] = "Decommissioned";
    eReleaseStatus["RetirePending"] = "RetirePending";
    eReleaseStatus["Retired"] = "Retired";
    return eReleaseStatus;
}({});
var $3f96b3e42c3802e2$export$2ada4144fce9aac8 = /*#__PURE__*/ function(eTlfItemType) {
    eTlfItemType["arsListing"] = "ArsListing";
    eTlfItemType["arsTable"] = "ArsTable";
    eTlfItemType["figure"] = "Figure";
    eTlfItemType["listing"] = "Listing";
    eTlfItemType["section"] = "Section";
    eTlfItemType["table"] = "Table";
    eTlfItemType["v1figure"] = "V1Figure";
    return eTlfItemType;
}({});
var $3f96b3e42c3802e2$export$b19998638fca5954 = /*#__PURE__*/ function(eHistoryType) {
    eHistoryType["Created"] = "Created";
    eHistoryType["Updated"] = "Updated";
    eHistoryType["Released"] = "Released";
    eHistoryType["Decommissioned"] = "Decommissioned";
    eHistoryType["Deleted"] = "Deleted";
    eHistoryType["DeletionWithdrawn"] = "DeletionWithdrawn";
    eHistoryType["Retired"] = "Retired";
    return eHistoryType;
}({});
var $3f96b3e42c3802e2$export$39b5e962b0bc717b = /*#__PURE__*/ function(eTlfOutputType) {
    eTlfOutputType["Docx"] = "docx";
    eTlfOutputType["Pdf"] = "pdf";
    eTlfOutputType["Rtf"] = "rtf";
    eTlfOutputType["Lst"] = "lst";
    return eTlfOutputType;
}({});
var $3f96b3e42c3802e2$export$f7aaabe3472f411a = /*#__PURE__*/ function(eShowTiFo) {
    eShowTiFo["ToC"] = "ToC view";
    eShowTiFo["Titles"] = "Titles";
    eShowTiFo["Footnotes"] = "Footnotes";
    eShowTiFo["Comments"] = "Comments";
    eShowTiFo["ProgramInfo"] = "Program info";
    return eShowTiFo;
}({});
var $3f96b3e42c3802e2$export$850e61c9e6223cb4 = /*#__PURE__*/ function(SearchableEditorBlocks) {
    SearchableEditorBlocks["Titles"] = "Titles";
    SearchableEditorBlocks["PageBy"] = "Page by";
    SearchableEditorBlocks["Footnotes"] = "Footnotes";
    SearchableEditorBlocks["TableHeaderData"] = "Table header";
    SearchableEditorBlocks["TableComments"] = "Table comments";
    SearchableEditorBlocks["TableBodyData"] = "Table body";
    SearchableEditorBlocks["TableBodyRowGroupComments"] = "Table body comments";
    SearchableEditorBlocks["StandardsNotes"] = "Standards notes";
    SearchableEditorBlocks["ProgrammerNotes"] = "Programmer notes";
    return SearchableEditorBlocks;
}({});

});


parcelRegister("4dL47", function(module, exports) {

$parcel$export(module.exports, "loadWrapper", function () { return $082ecf52ff4dc5b6$export$c7ac62050b844f22; });

var $eBlbF = parcelRequire("eBlbF");
async function $082ecf52ff4dc5b6$export$c7ac62050b844f22(loadFunction, target, status, setStatus, backEndUrl, onProgress) {
    // Assume nothing is happening
    const doLoad = status.requesting && !(0, $eBlbF.isEqual)(status.requestingId, target) || !status.requesting && !(0, $eBlbF.isEqual)(status.requestedId, target);
    // Check there is a need to request
    if (doLoad && status.cancel) status.cancel();
    // Stop if hierarchy is less than zero or already requesting, or already errored
    if (doLoad && !status.error) {
        const controller = new AbortController();
        setStatus({
            requesting: true,
            requestingId: (0, $eBlbF.cloneDeep)(target),
            cancel: ()=>controller.abort(),
            error: false
        });
        const response = await loadFunction(backEndUrl, target, controller, onProgress);
        if (response.success) {
            setStatus({
                requesting: false,
                requestedId: (0, $eBlbF.cloneDeep)(target),
                error: false
            });
            return response;
        } else {
            console.warn(`LoadWrapper fail: ${response.errorText} from ${backEndUrl}/${JSON.stringify(target)}`);
            // Do nothing on a cancellation error
            /* istanbul ignore else */ if (!response.errorText?.toLocaleLowerCase().includes("request cancelled")) {
                setStatus({
                    requesting: false,
                    requestedId: (0, $eBlbF.cloneDeep)(target),
                    error: true,
                    errorText: response.errorText
                });
                return response;
            }
        }
    }
    return null;
}

});

parcelRegister("4VWrH", function(module, exports) {

$parcel$export(module.exports, "mapById", function () { return $258fca636874a671$export$513947f29ba0afbf; });
/**
 * Maps an array of ID-based items into a record keyed by item ID.
 *
 * @param items - Collection of ARS entities to index by ID.
 * @returns Record keyed by each entity ID.
 */ const $258fca636874a671$export$513947f29ba0afbf = (items)=>Object.fromEntries(items.map((item)=>[
            item.id,
            item
        ]));

});

parcelRegister("67RwR", function(module, exports) {

$parcel$export(module.exports, "mutateByPath", function () { return $ca13e514f2d6979f$export$d3634dfc1866e1d; });

var $fNNZS = parcelRequire("fNNZS");

var $V4sXl = parcelRequire("V4sXl");

var $bOKCS = parcelRequire("bOKCS");
const $ca13e514f2d6979f$export$d3634dfc1866e1d = (obj, dataPath, newValue)=>{
    const { firstPart: firstPart, restParts: restParts } = (0, $V4sXl.parsePathParts)(dataPath);
    const isArray = Array.isArray(obj);
    const newObj = isArray ? [
        ...obj
    ] : {
        ...obj
    };
    if (restParts.length === 0) // Base case: last part, set the value
    (0, $bOKCS.setValueAtKey)(newObj, firstPart, newValue, isArray);
    else {
        // Recursive case: get or create the nested value (with copy) and recurse
        const nested = (0, $fNNZS.getNestedValue)(obj, firstPart, restParts);
        const nextPath = (0, $V4sXl.joinPathParts)(restParts);
        const recursiveResult = $ca13e514f2d6979f$export$d3634dfc1866e1d(nested, nextPath, newValue);
        (0, $bOKCS.setValueAtKey)(newObj, firstPart, recursiveResult, isArray);
    }
    return newObj;
};

});
parcelRegister("V4sXl", function(module, exports) {

$parcel$export(module.exports, "parsePathParts", function () { return $8031d87c59263d74$export$4ff252707494f8d1; });
$parcel$export(module.exports, "encodePath", function () { return $8031d87c59263d74$export$20c03ce31e68a433; });
$parcel$export(module.exports, "joinPathParts", function () { return $8031d87c59263d74$export$b7c2900d5da733e5; });
/**
 * Normalizes a JSON Pointer path and splits it into parts with RFC 6901 escape sequences decoded.
 *
 * @param dataPath - The RFC 6901 JSON Pointer path (e.g., "/a/b/c" or "/items/0").
 * @returns An object containing the normalized path parts and the first part separated from the rest.
 */ const $8031d87c59263d74$export$4ff252707494f8d1 = (dataPath)=>{
    const normalizedPath = dataPath.startsWith("/") ? dataPath.slice(1) : dataPath;
    const pathParts = normalizedPath.split("/").map((part)=>// Decode RFC 6901 escape sequences: ~1 -> /, ~0 -> ~
        part.replace(/~1/g, "/").replace(/~0/g, "~"));
    const [firstPart, ...restParts] = pathParts;
    return {
        firstPart: firstPart,
        restParts: restParts
    };
};
const $8031d87c59263d74$export$20c03ce31e68a433 = (path)=>{
    return path.replace(/~/g, "~0").replace(/\//g, "~1");
};
const $8031d87c59263d74$export$b7c2900d5da733e5 = (parts)=>{
    return "/" + parts.map($8031d87c59263d74$export$20c03ce31e68a433).join("/");
};

});

parcelRegister("bOKCS", function(module, exports) {

$parcel$export(module.exports, "setValueAtKey", function () { return $ae802bf822258aa5$export$3e9deff39cbbd85a; });
/**
 * Sets a value in an object or array, handling both string keys (for objects) and numeric indices (for arrays).
 *
 * @param target - The object or array to set the value in.
 * @param key - The property name or array index as a string.
 * @param value - The value to set.
 * @param isArray - Whether the target is an array.
 */ const $ae802bf822258aa5$export$3e9deff39cbbd85a = (target, key, value, isArray)=>{
    if (isArray) {
        const index = parseInt(key, 10);
        /* istanbul ignore else - NaN index is a no-op, item remains unchanged */ if (!isNaN(index)) target[index] = value;
    } else target[key] = value;
};

});


parcelRegister("1wSYE", function(module, exports) {

$parcel$export(module.exports, "PauseCover", function () { return $b1270bd498bb3d64$export$8860b6543868183a; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $5dhsh = parcelRequire("5dhsh");
const $b1270bd498bb3d64$export$8860b6543868183a = /*#__PURE__*/ (0, $spJKX.forwardRef)(({ text: text, spinner: spinner = true, variant: variant }, coverRef)=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 1,
            backgroundColor: "#ccc",
            opacity: "0.75",
            color: "--var(--bs-black)",
            borderRadius: "4px",
            border: "1px --var(--bs-dark) solid",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            maxHeight: "100%",
            cursor: "wait"
        },
        onClickCapture: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        children: [
            spinner && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                animation: "border",
                "aria-label": "Please wait",
                size: "sm",
                variant: variant ?? "dark",
                style: {
                    alignSelf: "center"
                }
            }),
            text && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                ref: coverRef,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                    className: `text-${variant ?? "dark"} ms-2`,
                    children: text
                })
            })
        ]
    });
});
$b1270bd498bb3d64$export$8860b6543868183a.displayName = "PauseCover";

});
parcelRegister("5dhsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3cbbb4d96ee35f4d$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $3cbbb4d96ee35f4d$var$Spinner = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$3cbbb4d96ee35f4d$var$Spinner.displayName = 'Spinner';
var $3cbbb4d96ee35f4d$export$2e2bcd8739ae039 = $3cbbb4d96ee35f4d$var$Spinner;

});
parcelRegister("gr2Ty", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dz672", function(module, exports) {

$parcel$export(module.exports, "useBootstrapPrefix", function () { return $9e03491206bb8f96$export$7f387860ebffb32c; });
$parcel$export(module.exports, "useBootstrapBreakpoints", function () { return $9e03491206bb8f96$export$8970c8db816a5863; });
$parcel$export(module.exports, "useBootstrapMinBreakpoint", function () { return $9e03491206bb8f96$export$d926d6ef38f3fd32; });
$parcel$export(module.exports, "useIsRTL", function () { return $9e03491206bb8f96$export$35e511eefa30ac5a; });

var $spJKX = parcelRequire("spJKX");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $9e03491206bb8f96$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $9e03491206bb8f96$export$ff817e17bad2e091 = 'xs';
const $9e03491206bb8f96$var$ThemeContext = /*#__PURE__*/ $spJKX.createContext({
    prefixes: {},
    breakpoints: $9e03491206bb8f96$export$666ad80b5007f835,
    minBreakpoint: $9e03491206bb8f96$export$ff817e17bad2e091
});
const { Consumer: $9e03491206bb8f96$export$b631efc24e9d5e2f, Provider: $9e03491206bb8f96$var$Provider } = $9e03491206bb8f96$var$ThemeContext;
function $9e03491206bb8f96$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $9e03491206bb8f96$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $9e03491206bb8f96$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $spJKX.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($9e03491206bb8f96$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $9e03491206bb8f96$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $spJKX.useContext)($9e03491206bb8f96$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $9e03491206bb8f96$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $spJKX.useContext)($9e03491206bb8f96$var$ThemeContext);
    return breakpoints;
}
function $9e03491206bb8f96$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $spJKX.useContext)($9e03491206bb8f96$var$ThemeContext);
    return minBreakpoint;
}
function $9e03491206bb8f96$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $spJKX.useContext)($9e03491206bb8f96$var$ThemeContext);
    return dir === 'rtl';
}
function $9e03491206bb8f96$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $spJKX.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $9e03491206bb8f96$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $9e03491206bb8f96$export$2e2bcd8739ae039 = $9e03491206bb8f96$var$ThemeProvider;

});



parcelRegister("km9RG", function(module, exports) {

$parcel$export(module.exports, "reduceDataPath", function () { return $0f2f4684a5368c4d$export$54a39e6c3d52a8a3; });
/**
 * Utility function to reduce a data path by a specified number of levels, used for targeting parent nodes in the table's bodyData structure.
 *
 * @param dataPath - The original data path string (e.g., "/columns/0/subGroups/1")
 * @param levels - The number of levels to reduce from the end of the path
 * @returns The reduced data path string (e.g., "/columns/0" if levels is 2)
 */ const $0f2f4684a5368c4d$export$54a39e6c3d52a8a3 = (dataPath, levels)=>{
    const parts = dataPath.split("/").filter(Boolean);
    if (parts.length <= levels) return "";
    return "/" + parts.slice(0, -levels).join("/");
};

});

parcelRegister("X1On9", function(module, exports) {

$parcel$export(module.exports, "removeByPath", function () { return $524281d535bebcc9$export$ceab6855354994b2; });

var $fNNZS = parcelRequire("fNNZS");

var $V4sXl = parcelRequire("V4sXl");

var $bOKCS = parcelRequire("bOKCS");
const $524281d535bebcc9$export$ceab6855354994b2 = (obj, dataPath, newLength)=>{
    const { firstPart: firstPart, restParts: restParts } = (0, $V4sXl.parsePathParts)(dataPath);
    const isArray = Array.isArray(obj);
    if (restParts.length === 0) {
        // Base case: last part, remove the property
        if (isArray) {
            // Check new length if provided to prevent unintended removals
            if (newLength === undefined) throw new Error("newLength must be provided when removing an item from an array");
            else if (newLength !== obj.length - 1) return obj;
            else {
                const newArr = [
                    ...obj
                ];
                const index = parseInt(firstPart, 10);
                if (!isNaN(index) && index < obj.length && index >= 0) {
                    newArr.splice(index, 1);
                    return newArr;
                } else return obj;
            }
        } else {
            const newObj = {
                ...obj
            };
            if (firstPart in obj) {
                delete newObj[firstPart];
                return newObj;
            }
            // Return original object if the property does not exist
            return obj;
        }
    } else {
        // Recursive case: get or create the nested value (with copy) and recurse
        const existingValue = obj[firstPart];
        const newObj = isArray ? [
            ...obj
        ] : {
            ...obj
        };
        if (existingValue !== undefined) {
            const nested = (0, $fNNZS.getNestedValue)(obj, firstPart, restParts);
            const nextPath = (0, $V4sXl.joinPathParts)(restParts);
            const recursiveResult = $524281d535bebcc9$export$ceab6855354994b2(nested, nextPath, newLength);
            (0, $bOKCS.setValueAtKey)(newObj, firstPart, recursiveResult, isArray);
        }
        return newObj;
    }
};

});

parcelRegister("hFl9K", function(module, exports) {

$parcel$export(module.exports, "setToUTCMidnight", function () { return $1e80f25683338d8b$export$5932491ae1c7e059; });

var $9S4dL = parcelRequire("9S4dL");
const $1e80f25683338d8b$export$5932491ae1c7e059 = (s, tomorrow)=>{
    const date = s instanceof Date ? s : new Date(s);
    if (!isNaN(date.getTime())) {
        /* istanbul ignore else */ if (tomorrow) date.setDate(date.getDate() + 1);
        date.setUTCHours(0, 0, 0, 0);
        return (0, $9S4dL.convertDateToLocaleString)(date);
    } else {
        console.warn(`Invalid date: ${s}`);
        return "";
    }
};

});

parcelRegister("7fpOF", function(module, exports) {

$parcel$export(module.exports, "stringDateCheck", function () { return $7a8a2c9a6f6d74a2$export$ba21b05758a2af71; });
const $7a8a2c9a6f6d74a2$export$ba21b05758a2af71 = (date, options)=>{
    if (date === "" && !options?.blankBad) return {
        success: true,
        returnedDate: null,
        validationText: "No date"
    };
    else if (date === "") return {
        success: false,
        returnedDate: null,
        validationText: "Date missing"
    };
    else {
        const badDate = isNaN(Date.parse(date));
        /* istanbul ignore else */ if (badDate) return {
            success: false,
            validationText: "Invalid date"
        };
        const newDate = new Date(date);
        /* istanbul ignore else */ if (options?.pastBad && newDate < new Date()) return {
            success: false,
            validationText: "Cannot be in the past",
            returnedDate: newDate
        };
        /* istanbul ignore else */ if (options?.futureBad && newDate > new Date()) return {
            success: false,
            validationText: "Cannot be in the future",
            returnedDate: newDate
        };
        else return {
            success: true,
            validationText: `${newDate.toString()}`,
            returnedDate: newDate
        };
    }
};

});

parcelRegister("8FniJ", function(module, exports) {

$parcel$export(module.exports, "toHtml", function () { return $3dfa4daf797b816f$export$a10125c086a4df16; });
$parcel$export(module.exports, "fromHtml", function () { return $3dfa4daf797b816f$export$657711bc6c3b0a5b; });
/**
 * Converts a string to HTML entities.
 *
 * @param text - The text to convert.
 * @returns The converted HTML string.
 */ const $3dfa4daf797b816f$export$a10125c086a4df16 = (text)=>text.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/≥/g, "&ge;").replace(/≤/g, "&le;").replace(/</g, "&lt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\n/g, "<br/>").replace(/\u00a0/g, "&nbsp;");
const $3dfa4daf797b816f$export$657711bc6c3b0a5b = (text)=>text.replace(/&nbsp;/g, "\u00a0").replace(/<br\/>/g, "\n").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&lt;/g, "<").replace(/&le;/g, "\u2264").replace(/&ge;/g, "\u2265").replace(/&gt;/g, ">").replace(/&amp;/g, "&");

});

parcelRegister("dD4jq", function(module, exports) {

$parcel$export(module.exports, "valueFix", function () { return $cb95951d304e9a86$export$c949713a1ce95c7e; });
/**
 * Fixes the value by trimming whitespace if specified.
 *
 * @param inString - The input string to process and format
 * @param trim - Whether to trim whitespace from the string
 */ const $cb95951d304e9a86$export$c949713a1ce95c7e = (inString, trim)=>{
    let n = inString;
    /* istanbul ignore else */ if (trim) n = n.replace(/\s+/g, " ").trim();
    return n;
};

});





parcelRegister("2LFD1", function(module, exports) {

$parcel$export(module.exports, "trCanRemoveColSpan", function () { return $eb3f1e44edc0446e$export$e52aa4c13a9232fe; });
$parcel$export(module.exports, "trRemoveColSpan", function () { return $eb3f1e44edc0446e$export$eabc64b75793e7ef; });

var $9rj0c = parcelRequire("9rj0c");
const $eb3f1e44edc0446e$export$e52aa4c13a9232fe = (headerData, location, newColSpan)=>{
    let reasonNot = "";
    let showCell;
    // Check target cell exists
    const targetCell = (0, $9rj0c.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        columnInformation: [],
        coreTrafficLight: "BlankNotEvaluated"
    }, location, true);
    if (targetCell === undefined) reasonNot = "RemoveColSpan: target cell not found";
    else if (targetCell.colSpan === newColSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "RemoveColSpan: this is a repeat cell";
    else if (newColSpan < 1) reasonNot = "RemoveColSpan: col span cannot be reduced";
    else {
        const oldColSpan = targetCell.colSpan;
        // Get the cell to show
        showCell = headerData.rows[location.row]?.cells[location.originalColumn + oldColSpan - 1];
        if (showCell === undefined) reasonNot = "RemoveColSpan: show cell does not exist";
        else if (showCell.colSpan !== 0) reasonNot = "RemoveColSpan: show cell is not hidden";
    }
    return reasonNot !== "" ? {
        canRemove: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        showCell: showCell
    } : {
        canRemove: true,
        reasonNot: undefined,
        targetCell: targetCell,
        showCell: showCell
    };
};
const $eb3f1e44edc0446e$export$eabc64b75793e7ef = (headerData, location, newSpan)=>{
    // Check if we can remove
    const { canRemove: canRemove, reasonNot: reasonNot, targetCell: targetCell, showCell: showCell } = $eb3f1e44edc0446e$export$e52aa4c13a9232fe(headerData, location, newSpan);
    // Already done
    if (targetCell?.colSpan === newSpan) return;
    // Cannot remove
    if (!canRemove) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = newHeaderData.rows.map((row)=>{
        if (row.aitid !== location.rowId) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                colSpan: newSpan
            };
            if (cell.aitid === showCell.aitid) return {
                ...cell,
                colSpan: 1
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("9OWn6", function(module, exports) {

$parcel$export(module.exports, "trRemoveColumn", function () { return $c88a70065474a287$export$b837ed71e9eb942; });
const $c88a70065474a287$export$b837ed71e9eb942 = (headerData, bodyData, cellIds)=>{
    let newHeaderData = headerData ? {
        ...headerData
    } : false;
    // Update header data
    if (newHeaderData !== false) newHeaderData = {
        ...newHeaderData,
        rows: newHeaderData.rows.map((r)=>{
            const newRow = {
                ...r
            };
            const newCells = [
                ...newRow.cells
            ];
            // Check for colSpan
            const c = newCells.find((c)=>cellIds.includes(c.aitid));
            /* istanbul ignore else */ if (c) {
                const columnIndex = newCells.indexOf(c);
                // Reduce where a hidden cell has been removed
                if (c.colSpan === 0) {
                    let lookBack = 1;
                    while(newCells[columnIndex - lookBack].colSpan === 0)lookBack++;
                    newCells[columnIndex - lookBack] = {
                        ...newCells[columnIndex - lookBack],
                        colSpan: newCells[columnIndex - lookBack].colSpan - 1
                    };
                } else if (c.colSpan > 1) for(let cj = 1; cj < c.colSpan; cj++)newCells[columnIndex + cj] = {
                    ...newCells[columnIndex + cj],
                    colSpan: 1
                };
                newCells.splice(columnIndex, 1);
            }
            return {
                ...newRow,
                cells: newCells
            };
        })
    };
    // Update body groups
    const newBodyData = bodyData.map((rg)=>{
        const newRg = {
            ...rg
        };
        newRg.rows = rg.rows.map((r)=>{
            const newRow = {
                ...r
            };
            // Remove cells that match the cellIds
            newRow.cells = newRow.cells.filter((c)=>!cellIds.includes(c.aitid));
            return newRow;
        });
        return newRg;
    });
    // Check each row is the same length
    const rowLength = bodyData[0].rows[0].cells.length;
    if (bodyData.some((rg)=>rg.rows.some((r)=>r.cells.length !== rowLength)) || headerData !== false && headerData.rows.some((r)=>r.cells.length !== rowLength)) throw new Error("Row lengths are not consistent after removing column");
    return {
        headerData: newHeaderData,
        bodyData: newBodyData
    };
};

});

parcelRegister("gnmHr", function(module, exports) {

$parcel$export(module.exports, "trRemoveRow", function () { return $640b259950bf865c$export$8697e7b3bc5752f8; });

var $9B5Sg = parcelRequire("9B5Sg");
const $640b259950bf865c$export$8697e7b3bc5752f8 = (headerData, bodyData, location)=>{
    if (location.position === (0, $9B5Sg.AitTablePosition).headerRow && headerData !== false && headerData.rows.findIndex((row)=>row.aitid === location.rowId) > -1) {
        const ri = headerData.rows.findIndex((row)=>row.aitid === location.rowId);
        const newRows = [
            ...headerData.rows
        ];
        // Check cells for rowSpan
        newRows[ri].cells.forEach((c, ci)=>{
            // Found hidden cell
            if (c.rowSpan > 1) // Adjust the rowSpan of the cells below
            for(let i = 1; i < c.rowSpan; i++)newRows[ri + i].cells[ci].rowSpan = 1;
            // Found hidden cell
            if (c.rowSpan === 0) {
                let riUp = 1;
                let found = false;
                // Adjust the rowSpan of the cell above
                while(!found && riUp <= ri){
                    /* istanbul ignore else */ if (newRows[ri - riUp].cells[ci].rowSpan > 1) {
                        newRows[ri - riUp].cells[ci].rowSpan = newRows[ri - riUp].cells[ci].rowSpan - 1;
                        found = true;
                    }
                    riUp++;
                }
            }
        });
        // Remove the row
        newRows.splice(ri, 1);
        // Check that the bottom row has no colSpan
        if (ri === newRows.length && ri > 0) newRows[ri - 1].cells = newRows[ri - 1].cells.map((c)=>{
            c.colSpan = 1;
            return c;
        });
        return {
            headerData: newRows.length === 0 ? false : {
                ...headerData,
                rows: newRows
            }
        };
    } else if (location.position === (0, $9B5Sg.AitTablePosition).bodyRow && bodyData[location.rowGroup].rows.findIndex((row)=>row.aitid === location.rowId) > -1) {
        const ri = bodyData[location.rowGroup].rows.findIndex((row)=>row.aitid === location.rowId);
        const newBody = [
            ...bodyData
        ];
        const newRows = [
            ...newBody[location.rowGroup].rows
        ];
        newRows.splice(ri, 1);
        newBody[location.rowGroup] = {
            ...bodyData[location.rowGroup],
            rows: newRows
        };
        return {
            bodyData: newBody
        };
    }
    return {};
};

});

parcelRegister("fEtEI", function(module, exports) {

$parcel$export(module.exports, "trCanRemoveRowSpan", function () { return $826fa46154b2ab36$export$584bbb513d75641; });
$parcel$export(module.exports, "trRemoveRowSpan", function () { return $826fa46154b2ab36$export$97909e0a16849ca2; });

var $9rj0c = parcelRequire("9rj0c");
const $826fa46154b2ab36$export$584bbb513d75641 = (headerData, location, newRowSpan)=>{
    let reasonNot = "";
    let showCell;
    // Check target cell exists
    const targetCell = (0, $9rj0c.trGetCellFromLocation)({
        headerData: headerData,
        bodyData: [],
        coreTrafficLight: "BlankNotEvaluated",
        columnInformation: []
    }, location, true);
    if (targetCell === undefined) reasonNot = "RemoveRowSpan: target cell not found";
    else if (targetCell.rowSpan === newRowSpan) reasonNot = "";
    else if (location.isRepeat) reasonNot = "RemoveRowSpan: this is a repeat cell";
    else {
        // Calculated new row span
        const oldRowSpan = targetCell.rowSpan;
        if (newRowSpan < 1) reasonNot = "RemoveRowSpan: row span cannot be reduced";
        else {
            // Get the cell to show
            showCell = headerData.rows[location.row + oldRowSpan - 1]?.cells[location.originalColumn];
            if (showCell === undefined) reasonNot = "RemoveRowSpan: show cell does not exist";
            else if (showCell.rowSpan !== 0) reasonNot = "RemoveRowSpan: show cell is not hidden";
        }
    }
    return reasonNot !== "" ? {
        canRemove: false,
        reasonNot: reasonNot,
        targetCell: targetCell,
        showCell: showCell
    } : {
        canRemove: true,
        reasonNot: undefined,
        targetCell: targetCell,
        showCell: showCell
    };
};
const $826fa46154b2ab36$export$97909e0a16849ca2 = (headerData, location, newSpan)=>{
    const { canRemove: canRemove, reasonNot: reasonNot, targetCell: targetCell, showCell: showCell } = $826fa46154b2ab36$export$584bbb513d75641(headerData, location, newSpan);
    // Already updated
    if (targetCell?.rowSpan === newSpan) return;
    // Cannot remove
    if (!canRemove) throw new Error(reasonNot);
    // Create return object
    const newHeaderData = {
        ...headerData
    };
    newHeaderData.rows = headerData.rows.map((row)=>{
        if (row.aitid !== location.rowId && !row.cells.find((c)=>c.aitid === showCell.aitid)) return row;
        const newCells = row.cells.map((cell)=>{
            if (cell.aitid === targetCell.aitid) return {
                ...cell,
                rowSpan: newSpan
            };
            if (cell.aitid === showCell.aitid) return {
                ...cell,
                rowSpan: 1
            };
            return cell;
        });
        return {
            ...row,
            cells: newCells
        };
    });
    return newHeaderData;
};

});

parcelRegister("95mer", function(module, exports) {

$parcel$export(module.exports, "trUpdateColumnWidth", function () { return $e692545e3329a436$export$c4c807c4c39aa044; });
const $e692545e3329a436$export$c4c807c4c39aa044 = (table, colNo, colWidth)=>{
    const newHeaderData = table.headerData !== undefined && table.headerData !== false ? {
        ...table.headerData,
        rows: table.headerData.rows.map((r)=>({
                ...r,
                cells: r.cells.map((c, ci)=>({
                        ...c,
                        colWidth: ci === colNo ? colWidth : c.colWidth,
                        coreTrafficLight: "ChangedUnknown"
                    }))
            })),
        coreTrafficLight: "ChangedUnknown"
    } : table.headerData;
    const newBodyData = table.bodyData.map((rg)=>({
            ...rg,
            rows: rg.rows.map((r)=>({
                    ...r,
                    cells: r.cells.map((c, ci)=>({
                            ...c,
                            colWidth: ci === colNo ? colWidth : c.colWidth,
                            coreTrafficLight: "ChangedUnknown"
                        })),
                    coreTrafficLight: "ChangedUnknown"
                })),
            coreTrafficLight: "ChangedUnknown"
        }));
    return {
        headerData: newHeaderData,
        bodyData: newBodyData
    };
};

});

parcelRegister("aLZgM", function(module, exports) {

$parcel$export(module.exports, "trUpdateComments", function () { return $842001012f5d209f$export$e3ed0b249227508f; });

var $9B5Sg = parcelRequire("9B5Sg");
const $842001012f5d209f$export$e3ed0b249227508f = (newState, action)=>{
    switch(action.location.position){
        case (0, $9B5Sg.AitTablePosition).table:
            // Update the comments in the tableData
            newState.originalTableData = {
                ...newState.originalTableData,
                comments: action.comment
            };
            break;
        case (0, $9B5Sg.AitTablePosition).header:
            // Update the comments in the headerData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) newState.originalTableData = {
                ...newState.originalTableData,
                headerData: {
                    ...newState.originalTableData.headerData,
                    comments: action.comment
                }
            };
            break;
        case (0, $9B5Sg.AitTablePosition).headerCell:
            // Update the comments in the headerData
            /* istanbul ignore else */ if (newState.originalTableData.headerData) {
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    headerData: {
                        ...newState.originalTableData.headerData,
                        rows: newState.originalTableData.headerData.rows.map((row)=>({
                                ...row,
                                cells: row.cells.map((c)=>c.aitid === location.cellId ? {
                                        ...c,
                                        comments: action.comment
                                    } : c)
                            }))
                    }
                };
            }
            break;
        case (0, $9B5Sg.AitTablePosition).bodyRowGroup:
            {
                // Update the comments in the bodyData
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                            ...rowGroup,
                            comments: action.comment
                        } : rowGroup)
                };
                break;
            }
        case (0, $9B5Sg.AitTablePosition).bodyCell:
            {
                // Update the comments in the bodyData
                const location = action.location;
                newState.originalTableData = {
                    ...newState.originalTableData,
                    bodyData: newState.originalTableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                            ...rowGroup,
                            rows: rowGroup.rows.map((row)=>row.aitid === location.rowId ? {
                                    ...row,
                                    cells: row.cells.map((c)=>c.aitid === location.cellId ? {
                                            ...c,
                                            comments: action.comment
                                        } : c)
                                } : row)
                        } : rowGroup)
                };
                break;
            }
    }
    return newState;
};

});




parcelRegister("fUdFB", function(module, exports) {

$parcel$export(module.exports, "AioDropSelect", function () { return $6daba1041ccd6f5f$export$4a80a85fb7744798; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");

var $biia9 = parcelRequire("biia9");
const $6daba1041ccd6f5f$export$4a80a85fb7744798 = ({ id: id, value: value, setValue: setValue, availableValues: availableValues, ...rest })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            ...rest,
            id: id,
            style: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    id: `${id}-value`,
                    style: {
                        marginRight: "0.25rem"
                    },
                    "data-available-items": availableValues?.join(","),
                    children: value
                }),
                setValue && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                    id: `${id}-button`,
                    menuItems: availableValues?.map((s)=>({
                            label: s,
                            action: ()=>setValue(s)
                        }))
                })
            ]
        })
    });
};
$6daba1041ccd6f5f$export$4a80a85fb7744798.displayName = "AioDropSelect";

});
parcelRegister("biia9", function(module, exports) {

$parcel$export(module.exports, "AioIconButton", function () { return $7682f53e9b7ba7ec$export$df2853518659514; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");
const $7682f53e9b7ba7ec$export$df2853518659514 = ({ id: id, onClick: onClick, iconName: iconName = "aioxDown", tipText: tipText, popUpTip: popUpTip = false, menuItems: menuItems, style: style })=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioButtonHolder,
        style: style,
        id: `${id}-holder`,
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ClickForMenu), {
            className: (0, $3tKzd.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioTip,
                (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexCenter
            ]),
            id: `${id}-menu`,
            menuItems: menuItems,
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    id: id,
                    className: (0, $3tKzd.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS)))[iconName]
                    ]),
                    "aria-label": tipText,
                    title: tipText,
                    role: "button",
                    onClick: onClick
                }),
                popUpTip && tipText && /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    className: (0, $3tKzd.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioTiptext,
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioTipTop
                    ]),
                    children: tipText
                })
            ]
        })
    });
$7682f53e9b7ba7ec$export$df2853518659514.displayName = "AioIconButton";

});
parcelRegister("5EkSD", function(module, exports) {

$parcel$export(module.exports, "AutoHeight", function () { return $41d0e28ea3e97704$export$77bf000da9303d1; });
$parcel$export(module.exports, "ClickForMenu", function () { return $41d0e28ea3e97704$export$d4ebdd58e04c6ace; });
$parcel$export(module.exports, "ContextMenuHandler", function () { return $41d0e28ea3e97704$export$ed4f9641643dc7e4; });
$parcel$export(module.exports, "ContextWindow", function () { return $41d0e28ea3e97704$export$1af8984c69ba1b24; });
$parcel$export(module.exports, "DockingProvider", function () { return $41d0e28ea3e97704$export$a90da4d36ed57428; });
$parcel$export(module.exports, "useMouseMove", function () { return $41d0e28ea3e97704$export$f93615b9594453fc; });
$parcel$export(module.exports, "useDocking", function () { return $41d0e28ea3e97704$export$a3af73b13b2dc8c7; });


var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");
function $41d0e28ea3e97704$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $41d0e28ea3e97704$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $41d0e28ea3e97704$var$$b65191f6d0a0a991$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "AutoHeight", function() {
    return $41d0e28ea3e97704$export$77bf000da9303d1;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "ClickForMenu", function() {
    return $41d0e28ea3e97704$export$d4ebdd58e04c6ace;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "ContextMenu", function() {
    return $41d0e28ea3e97704$export$8dc6765e8be191c7;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "ContextMenuHandler", function() {
    return $41d0e28ea3e97704$export$ed4f9641643dc7e4;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "ContextWindow", function() {
    return $41d0e28ea3e97704$export$1af8984c69ba1b24;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "DockingProvider", function() {
    return $41d0e28ea3e97704$export$a90da4d36ed57428;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$b65191f6d0a0a991$exports, "DockPanel", function() {
    return $41d0e28ea3e97704$export$73a97460965f977b;
});
var $41d0e28ea3e97704$var$$181673e3e0e596f3$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$181673e3e0e596f3$exports, "autoHeightInner", function() {
    return $41d0e28ea3e97704$var$$181673e3e0e596f3$export$df919f6b0f7f84e6;
}, function(v) {
    return $41d0e28ea3e97704$var$$181673e3e0e596f3$export$df919f6b0f7f84e6 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$181673e3e0e596f3$exports, "autoHeightWrapper", function() {
    return $41d0e28ea3e97704$var$$181673e3e0e596f3$export$563bd8f955c52746;
}, function(v) {
    return $41d0e28ea3e97704$var$$181673e3e0e596f3$export$563bd8f955c52746 = v;
});
var $41d0e28ea3e97704$var$$181673e3e0e596f3$export$df919f6b0f7f84e6;
var $41d0e28ea3e97704$var$$181673e3e0e596f3$export$563bd8f955c52746;
$41d0e28ea3e97704$var$$181673e3e0e596f3$export$df919f6b0f7f84e6 = `acxtm-AutoHeight-module-autoHeightInner`;
$41d0e28ea3e97704$var$$181673e3e0e596f3$export$563bd8f955c52746 = `acxtm-AutoHeight-module-autoHeightWrapper`;
function $41d0e28ea3e97704$export$77bf000da9303d1({ children: children, hide: hide = false, duration: duration = 300, ...rest }) {
    const wrapperRef = (0, $spJKX.useRef)(null);
    const innerRef = (0, $spJKX.useRef)(null);
    const [height, setHeight] = (0, $spJKX.useState)(null);
    const [animationState, setAnimationState] = (0, $spJKX.useState)(!hide ? "open" : "closed");
    const rafRef = (0, $spJKX.useRef)(null);
    const timeoutRef = (0, $spJKX.useRef)(null);
    const targetChildren = animationState === "closed" || !children ? null : children;
    const setTargetHeight = (0, $spJKX.useEffectEvent)((newHeight)=>{
        setHeight(newHeight);
    });
    const transitionToOpening = (0, $spJKX.useEffectEvent)(()=>{
        // Cancel any pending close timeout
        if (timeoutRef.current !== null) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setAnimationState("opening");
        const id = window.requestAnimationFrame(()=>{
            rafRef.current = null;
            setTargetHeight(1);
            const frameId = window.requestAnimationFrame(()=>{
                const inner = innerRef.current;
                /* istanbul ignore else */ if (inner) {
                    setTargetHeight(inner.offsetHeight);
                    setAnimationState("open");
                }
            });
            rafRef.current = frameId;
        });
        rafRef.current = id;
    });
    const transitionToClosing = (0, $spJKX.useEffectEvent)(()=>{
        // Cancel any pending RAF
        if (rafRef.current !== null) {
            cancelAnimationFrame(rafRef.current);
            rafRef.current = null;
        }
        setAnimationState("closing");
        setTargetHeight(1);
        timeoutRef.current = window.setTimeout(()=>{
            timeoutRef.current = null;
            setAnimationState("closed");
        }, duration);
    });
    (0, $spJKX.useLayoutEffect)(()=>{
        if (!hide) {
            if (animationState === "closed" || animationState === "closing") // eslint-disable-next-line react-hooks/set-state-in-effect
            transitionToOpening();
        } else if (animationState === "open" || animationState === "opening") transitionToClosing();
    }, [
        hide,
        animationState
    ]);
    (0, $spJKX.useEffect)(()=>{
        const transition = innerRef.current;
        /* istanbul ignore else */ if (transition) {
            const observer = new ResizeObserver(()=>{
                if (animationState === "open") setTargetHeight(transition.offsetHeight);
            });
            observer.observe(transition);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        animationState
    ]);
    (0, $spJKX.useEffect)(()=>{
        return ()=>{
            if (rafRef.current !== null) {
                cancelAnimationFrame(rafRef.current);
                rafRef.current = null;
            }
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);
    return (0, $bR5nk.jsx)("div", {
        ...rest,
        className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$181673e3e0e596f3$exports).autoHeightWrapper,
        ref: wrapperRef,
        style: {
            ...rest.style,
            display: animationState === "closed" ? "none" : undefined,
            height: height ? `${height}px` : "auto",
            transitionDuration: `${duration}ms`
        },
        children: (0, $bR5nk.jsx)("div", {
            className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$181673e3e0e596f3$exports).autoHeightInner,
            ref: innerRef,
            children: targetChildren
        })
    });
}
$41d0e28ea3e97704$export$77bf000da9303d1.displayName = "AutoHeight";
function $41d0e28ea3e97704$var$$c08ad60fd9b1e214$export$d6e287b3eb2b1e0e(isDocked, pointer, savedRect, anchorElement) {
    if (pointer) return {
        left: pointer.x,
        top: pointer.y,
        width: savedRect?.width,
        height: savedRect?.height,
        anchorToPointer: true
    };
    if (isDocked && savedRect) return {
        left: savedRect.x,
        top: savedRect.y,
        width: savedRect.width,
        height: savedRect.height
    };
    const anchor = anchorElement?.getBoundingClientRect();
    return {
        left: (anchor?.left ?? 16) + window.scrollX,
        top: (anchor?.bottom ?? 16) + window.scrollY
    };
}
const $41d0e28ea3e97704$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196 = (divRef)=>{
    if (!divRef.current) return {
        translateX: 0,
        translateY: 0
    };
    else {
        const innerBounce = 16;
        const posn = divRef.current.getBoundingClientRect();
        let translateX = 0;
        if (posn.left < innerBounce) translateX = -posn.left + innerBounce;
        else if (posn.right > window.innerWidth) translateX = Math.max(-posn.left + innerBounce, window.innerWidth - posn.right - innerBounce);
        let translateY = 0;
        /* istanbul ignore else */ if (posn.top < innerBounce) translateY = -posn.top + innerBounce;
        else if (posn.bottom > window.innerHeight) translateY = Math.max(-posn.top + innerBounce, window.innerHeight - posn.bottom - innerBounce);
        return {
            translateX: translateX,
            translateY: translateY
        };
    }
};
const $41d0e28ea3e97704$var$$2146bdc2bddecd64$var$DEFAULT_VIEWPORT_PADDING = 32;
const $41d0e28ea3e97704$var$$2146bdc2bddecd64$export$6a980bbd2c4486f3 = (element, viewportPadding = $41d0e28ea3e97704$var$$2146bdc2bddecd64$var$DEFAULT_VIEWPORT_PADDING)=>{
    if (!element) return;
    const availableWidth = Math.max(0, window.innerWidth - viewportPadding);
    const availableHeight = Math.max(0, window.innerHeight - viewportPadding);
    const rect = element.getBoundingClientRect();
    const horizontalChrome = rect.width - element.clientWidth;
    const verticalChrome = rect.height - element.clientHeight;
    if (rect.width > availableWidth) element.style.width = `${Math.max(0, availableWidth - horizontalChrome)}px`;
    if (rect.height > availableHeight) element.style.height = `${Math.max(0, availableHeight - verticalChrome)}px`;
};
const $41d0e28ea3e97704$var$$1d453c921d235704$export$1e4ae39bb8625cc1 = (divRef, move)=>{
    const position = $41d0e28ea3e97704$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196(divRef);
    move(position.translateX, position.translateY);
    $41d0e28ea3e97704$var$$2146bdc2bddecd64$export$6a980bbd2c4486f3(divRef.current);
};
const $41d0e28ea3e97704$var$$862ad0fd74423c06$export$bbd25dc97cf925d5 = 80;
const $41d0e28ea3e97704$var$$862ad0fd74423c06$export$7537a8df642a88c2 = 48;
const $41d0e28ea3e97704$var$$862ad0fd74423c06$export$268d176903180528 = 40;
const $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526 = (edge)=>edge === "left" || edge === "right";
const $41d0e28ea3e97704$var$$acd9a92a5e458e67$export$d80c2d434e31f05c = (edge, size)=>{
    const viewport = $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526(edge) ? window.innerWidth : window.innerHeight;
    const max = Math.max($41d0e28ea3e97704$var$$862ad0fd74423c06$export$bbd25dc97cf925d5, viewport - $41d0e28ea3e97704$var$$862ad0fd74423c06$export$268d176903180528);
    return Math.round(Math.min(max, Math.max($41d0e28ea3e97704$var$$862ad0fd74423c06$export$bbd25dc97cf925d5, size)));
};
function $41d0e28ea3e97704$var$$1bfa610553173d32$export$8610480ca405b39c(left, top, width, height) {
    const innerBounce = 16;
    const viewLeft = left - window.scrollX;
    const viewTop = top - window.scrollY;
    let clampedLeft = left;
    let clampedTop = top;
    if (viewLeft + width > window.innerWidth) clampedLeft = Math.max(innerBounce, window.innerWidth - width - innerBounce) + window.scrollX;
    if (viewTop + height > window.innerHeight) clampedTop = Math.max(innerBounce, window.innerHeight - height - innerBounce) + window.scrollY;
    return {
        left: clampedLeft,
        top: clampedTop
    };
}
/** Joins the truthy class names with spaces */ const $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff = (...names)=>names.filter((name)=>name).join(" ");
const $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$4f9fb66ac71c7da5 = 3000;
const $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$e2f9a725ee199e81 = 3100;
const $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$8b1a8a6f35b93a85 = "data-context-window";
const $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$a07396834f0a23c5 = "context-window-reset-z-index";
const $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01 = 24;
const $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$6fb5df6a93cc7d5f = 40;
function $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$82b02b62465609f1(mouseX, mouseY, currentSnap) {
    const detectionThreshold = currentSnap ? $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$6fb5df6a93cc7d5f : $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01;
    if (currentSnap === "left" && mouseX < detectionThreshold) return "left";
    if (currentSnap === "right" && mouseX > window.innerWidth - detectionThreshold) return "right";
    if (currentSnap === "top" && mouseY < detectionThreshold) return "top";
    if (currentSnap === "bottom" && mouseY > window.innerHeight - detectionThreshold) return "bottom";
    if (currentSnap) return null;
    if (mouseX < $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01) return "left";
    if (mouseX > window.innerWidth - $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01) return "right";
    if (mouseY < $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01) return "top";
    if (mouseY > window.innerHeight - $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$fcc35e8bb3792d01) return "bottom";
    return null;
}
/** Distance from a point to the nearest part of a rectangle (0 when inside) */ const $41d0e28ea3e97704$var$$6c269f1c280b7331$export$b56b08e1e3afa1ba = (rect, x, y)=>{
    const dx = Math.max(rect.left - x, 0, x - rect.right);
    const dy = Math.max(rect.top - y, 0, y - rect.bottom);
    return Math.hypot(dx, dy);
};
function $41d0e28ea3e97704$var$$490c563190f0963e$export$8ea33f091e4ee473(transform) {
    const match = transform?.match(/translate\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\)/);
    if (match) return {
        x: Number.parseFloat(match[1]),
        y: Number.parseFloat(match[2])
    };
    return {
        x: 0,
        y: 0
    };
}
const $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$b894d4d38265648a = 20;
function $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$823b384202443f8f(edge, mouseX, mouseY) {
    if (edge === "top" && mouseY > $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$b894d4d38265648a) return true;
    if (edge === "bottom" && mouseY < window.innerHeight - $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$b894d4d38265648a) return true;
    if (edge === "left" && mouseX > $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$b894d4d38265648a) return true;
    if (edge === "right" && mouseX < window.innerWidth - $41d0e28ea3e97704$var$$962d683f6fb7e9e7$export$b894d4d38265648a) return true;
    return false;
}
const $41d0e28ea3e97704$var$$d0f18e2b9990ccc1$export$b761f7e9cb0ead3d = (edge, dx, dy)=>{
    switch(edge){
        case "left":
            return dx;
        case "right":
            return -dx;
        case "top":
            return dy;
        case "bottom":
            return -dy;
    }
};
const $41d0e28ea3e97704$var$$7e03492697c3c93f$export$673fd997fc6cbd43 = (enabled, elementRef)=>{
    const [isAutoHidden, setIsAutoHidden] = (0, $spJKX.useState)(false);
    (0, $spJKX.useEffect)(()=>{
        if (!enabled) return;
        const handlePointerMove = (e)=>{
            const element = elementRef.current;
            /* istanbul ignore next */ if (!element) return;
            // Measured as rendered: the full bar while shown, just the edge line while hidden
            const rect = element.getBoundingClientRect();
            setIsAutoHidden($41d0e28ea3e97704$var$$6c269f1c280b7331$export$b56b08e1e3afa1ba(rect, e.clientX, e.clientY) > $41d0e28ea3e97704$var$$862ad0fd74423c06$export$7537a8df642a88c2);
        };
        // Leaving the window counts as moving away
        const handlePointerLeave = (e)=>{
            if (e.relatedTarget === null) setIsAutoHidden(true);
        };
        document.addEventListener("mousemove", handlePointerMove);
        document.addEventListener("mouseout", handlePointerLeave);
        return ()=>{
            document.removeEventListener("mousemove", handlePointerMove);
            document.removeEventListener("mouseout", handlePointerLeave);
        };
    }, [
        elementRef,
        enabled
    ]);
    return [
        enabled && isAutoHidden,
        setIsAutoHidden
    ];
};
const $41d0e28ea3e97704$var$$08f56600d1771fb2$export$e7a24757611c6a37 = (element, savedRect)=>{
    const width = savedRect?.width ?? element.offsetWidth ?? 300;
    const height = savedRect?.height ?? element.offsetHeight ?? 200;
    const left = savedRect?.x ?? Math.max(16, (window.innerWidth - width) / 2) + window.scrollX;
    const top = savedRect?.y ?? Math.max(16, (window.innerHeight - height) / 2) + window.scrollY;
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
    if (savedRect?.width !== undefined) element.style.width = `${savedRect.width}px`;
    if (savedRect?.height !== undefined) element.style.height = `${savedRect.height}px`;
    element.style.transform = "";
    const position = $41d0e28ea3e97704$var$$ab4d5d6bf03370d0$export$d81cfea7c54be196({
        current: element
    });
    element.style.transform = `translate(${position.translateX}px, ${position.translateY}px)`;
    return {
        x: position.translateX,
        y: position.translateY
    };
};
const $41d0e28ea3e97704$var$$c84264d31d035fb5$export$1f4588fc9076f828 = (element, pending, pointer)=>{
    let { left: left, top: top } = pending;
    if (pending.anchorToPointer) {
        const width = pending.width ?? 200;
        left = Math.max(0, pointer.x - width / 2) + window.scrollX;
        top = Math.max(0, pointer.y - 14) + window.scrollY;
    } else if (pending.centerInViewport) {
        left = Math.max(16, (window.innerWidth - element.offsetWidth) / 2) + window.scrollX;
        top = Math.max(16, (window.innerHeight - element.offsetHeight) / 2) + window.scrollY;
    } else {
        const padding = 16;
        const width = pending.width ?? element.offsetWidth;
        const height = pending.height ?? element.offsetHeight;
        const viewLeft = left - window.scrollX;
        const viewTop = top - window.scrollY;
        if (viewLeft + width > window.innerWidth) left = Math.max(padding, window.innerWidth - width - padding) + window.scrollX;
        if (viewTop + height > window.innerHeight) top = Math.max(padding, window.innerHeight - height - padding) + window.scrollY;
    }
    element.style.left = `${left}px`;
    element.style.top = `${top}px`;
    element.style.transform = "";
    if (pending.width !== undefined) element.style.width = `${pending.width}px`;
    if (pending.height !== undefined) element.style.height = `${pending.height}px`;
};
const $41d0e28ea3e97704$export$f93615b9594453fc = ({ onMouseDown: onMouseDownCallback, onMouseMove: onMouseMoveCallback, onMouseUp: onMouseUpCallback, onInteractionEnd: onInteractionEndCallback, interactionEndEnabled: interactionEndEnabled, onViewportResize: onViewportResizeCallback, viewportResizeEnabled: viewportResizeEnabled })=>{
    const mouseMoveRef = (0, $spJKX.useRef)(null);
    const mouseUpRef = (0, $spJKX.useRef)(null);
    const activeInputRef = (0, $spJKX.useRef)(null);
    const mouseDownElementRef = (0, $spJKX.useRef)(null);
    const mouseDownUserSelectRef = (0, $spJKX.useRef)("");
    const interactionEndRef = (0, $spJKX.useRef)(null);
    const interactionEndCallbackRef = (0, $spJKX.useRef)(onInteractionEndCallback);
    const viewportResizeCallbackRef = (0, $spJKX.useRef)(onViewportResizeCallback);
    // Document listeners are attached once per interaction, so route them through refs
    // to always invoke the latest callbacks (state can change mid-drag, e.g. undocking)
    const mouseMoveCallbackRef = (0, $spJKX.useRef)(onMouseMoveCallback);
    const mouseUpCallbackRef = (0, $spJKX.useRef)(onMouseUpCallback);
    (0, $spJKX.useLayoutEffect)(()=>{
        mouseMoveCallbackRef.current = onMouseMoveCallback;
    }, [
        onMouseMoveCallback
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        mouseUpCallbackRef.current = onMouseUpCallback;
    }, [
        onMouseUpCallback
    ]);
    (0, $spJKX.useEffect)(()=>{
        interactionEndCallbackRef.current = onInteractionEndCallback;
    }, [
        onInteractionEndCallback
    ]);
    (0, $spJKX.useEffect)(()=>{
        viewportResizeCallbackRef.current = onViewportResizeCallback;
    }, [
        onViewportResizeCallback
    ]);
    const removeMouseListeners = (0, $spJKX.useCallback)(()=>{
        if (mouseMoveRef.current) {
            document.removeEventListener("mousemove", mouseMoveRef.current);
            document.removeEventListener("pointermove", mouseMoveRef.current);
        }
        if (mouseUpRef.current) {
            document.removeEventListener("mouseup", mouseUpRef.current);
            document.removeEventListener("pointerup", mouseUpRef.current);
        }
        activeInputRef.current = null;
    }, []);
    const restoreMouseDownUserSelect = (0, $spJKX.useCallback)(()=>{
        if (mouseDownElementRef.current) {
            mouseDownElementRef.current.style.userSelect = mouseDownUserSelectRef.current;
            mouseDownElementRef.current = null;
            mouseDownUserSelectRef.current = "";
        }
    }, []);
    const removeInteractionEndListeners = (0, $spJKX.useCallback)(()=>{
        if (interactionEndRef.current) {
            document.removeEventListener("mouseup", interactionEndRef.current, true);
            document.removeEventListener("pointerup", interactionEndRef.current, true);
            interactionEndRef.current = null;
        }
    }, []);
    const onMouseMove = (0, $spJKX.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        mouseMoveCallbackRef.current?.(e);
    }, []);
    const onMouseUp = (0, $spJKX.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        removeMouseListeners();
        restoreMouseDownUserSelect();
        mouseUpCallbackRef.current?.(e);
    }, [
        removeMouseListeners,
        restoreMouseDownUserSelect
    ]);
    const onMouseDown = (0, $spJKX.useCallback)((e)=>{
        restoreMouseDownUserSelect();
        mouseDownElementRef.current = e.currentTarget;
        mouseDownUserSelectRef.current = e.currentTarget.style.userSelect;
        e.currentTarget.style.userSelect = "none";
        mouseMoveRef.current = onMouseMove;
        mouseUpRef.current = onMouseUp;
        // React can emit both pointer and mouse streams for one interaction.
        // Subscribe to only one stream to avoid applying movement deltas twice.
        if (e.type === "pointerdown") {
            activeInputRef.current = "pointer";
            document.addEventListener("pointermove", onMouseMove);
        } else {
            activeInputRef.current = "mouse";
            document.addEventListener("mousemove", onMouseMove);
        }
        // Release events can arrive on either stream depending on the browser
        // and the element the interaction finishes over.
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("pointerup", onMouseUp);
        onMouseDownCallback?.(e);
    }, [
        onMouseDownCallback,
        onMouseMove,
        onMouseUp,
        restoreMouseDownUserSelect
    ]);
    const armInteractionEnd = (0, $spJKX.useCallback)(()=>{
        if (!interactionEndEnabled || interactionEndRef.current) return;
        const onInteractionEnd = (e)=>{
            removeInteractionEndListeners();
            interactionEndCallbackRef.current?.(e);
        };
        interactionEndRef.current = onInteractionEnd;
        document.addEventListener("mouseup", onInteractionEnd, true);
        document.addEventListener("pointerup", onInteractionEnd, true);
    }, [
        interactionEndEnabled,
        removeInteractionEndListeners
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!interactionEndEnabled) removeInteractionEndListeners();
    }, [
        interactionEndEnabled,
        removeInteractionEndListeners
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!viewportResizeEnabled || !viewportResizeCallbackRef.current || !onViewportResizeCallback) return;
        const onViewportResize = (e)=>{
            viewportResizeCallbackRef.current?.(e);
        };
        window.addEventListener("resize", onViewportResize);
        return ()=>{
            window.removeEventListener("resize", onViewportResize);
        };
    }, [
        onViewportResizeCallback,
        viewportResizeEnabled
    ]);
    (0, $spJKX.useEffect)(()=>{
        return ()=>{
            removeMouseListeners();
            removeInteractionEndListeners();
            restoreMouseDownUserSelect();
        };
    }, [
        removeInteractionEndListeners,
        removeMouseListeners,
        restoreMouseDownUserSelect
    ]);
    return {
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        armInteractionEnd: armInteractionEnd
    };
};
const $41d0e28ea3e97704$var$$5beb376faad492b0$var$UNDOCK_THRESHOLD = 20;
const $41d0e28ea3e97704$var$$5beb376faad492b0$var$parseTranslate = (transform)=>{
    const match = transform?.match(/translate\((-?\d+(?:\.\d+)?)px,\s*(-?\d+(?:\.\d+)?)px\)/);
    if (match) return {
        x: Number.parseFloat(match[1]),
        y: Number.parseFloat(match[2])
    };
    return {
        x: 0,
        y: 0
    };
};
const $41d0e28ea3e97704$var$$5beb376faad492b0$export$33c22f8d38d5ec2 = ({ id: id, dockable: dockable, dockingEnabled: dockingEnabled = true, pushToTop: pushToTop, allowUndock: allowUndock, isDocked: isDocked, dockedEdge: dockedEdge, windowVisible: windowVisible, moving: moving, windowRef: windowRef, windowPosRef: windowPosRef, isDockedRef: isDockedRef, dispatch: dispatch, move: move, setMoving: setMoving, setWindowVisible: setWindowVisible, handleDock: handleDock, handleUndock: handleUndock })=>{
    const targetSnapEdgeRef = (0, $spJKX.useRef)(null);
    const lastMousePosRef = (0, $spJKX.useRef)({
        x: 0,
        y: 0
    });
    const interactionProcessedRef = (0, $spJKX.useRef)(false);
    const isInInteractionRef = (0, $spJKX.useRef)(false);
    const hasMovedRef = (0, $spJKX.useRef)(false);
    const handleDockRef = (0, $spJKX.useRef)(handleDock);
    (0, $spJKX.useLayoutEffect)(()=>{
        handleDockRef.current = handleDock;
    }, [
        handleDock
    ]);
    const handleUndockRef = (0, $spJKX.useRef)(handleUndock);
    (0, $spJKX.useLayoutEffect)(()=>{
        handleUndockRef.current = handleUndock;
    }, [
        handleUndock
    ]);
    const { onMouseDown: onMouseDown, armInteractionEnd: armInteractionEnd } = $41d0e28ea3e97704$export$f93615b9594453fc({
        onMouseDown: ()=>{
            interactionProcessedRef.current = false;
            isInInteractionRef.current = true;
            hasMovedRef.current = false;
            windowPosRef.current = $41d0e28ea3e97704$var$$5beb376faad492b0$var$parseTranslate(windowRef.current?.style.transform);
            setMoving(true);
            if (dockingEnabled) dispatch({
                type: "startDockDrag",
                id: id
            });
            if (!windowVisible) setWindowVisible(true);
            armInteractionEnd();
            if (pushToTop) pushToTop();
            else dispatch({
                type: "raiseWindow",
                id: id
            });
        },
        onMouseMove: (e)=>{
            hasMovedRef.current = true;
            lastMousePosRef.current = {
                x: e.clientX,
                y: e.clientY
            };
            if (!windowVisible && windowRef.current) {
                const rect = windowRef.current.getBoundingClientRect();
                const isInViewport = rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
                if (isInViewport) setWindowVisible(true);
            }
            if (dockingEnabled && !isDockedRef.current && dockable) {
                let topPanel = null;
                let topZ = -Infinity;
                const panels = document.querySelectorAll("[data-dock-panel-edge]");
                for (const panel of panels){
                    const r = panel.getBoundingClientRect();
                    const isOver = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
                    // Equal z-index: the later panel in the DOM paints on top
                    const z = parseInt(getComputedStyle(panel).zIndex, 10) || 0;
                    if (isOver && z >= topZ) {
                        topPanel = panel;
                        topZ = z;
                    }
                }
                for (const panel of panels)panel.toggleAttribute("data-dock-target", panel === topPanel);
                const panelEdge = topPanel?.dataset.dockPanelEdge;
                const snapEdge = panelEdge ?? $41d0e28ea3e97704$var$$42f70e7cec25de7e$export$82b02b62465609f1(e.clientX, e.clientY, targetSnapEdgeRef.current);
                targetSnapEdgeRef.current = snapEdge;
                dispatch({
                    type: "setDockDragEdge",
                    edge: snapEdge
                });
            }
            if (isDockedRef.current && dockable && allowUndock) {
                let shouldUndock = false;
                if (dockedEdge === "top" && e.clientY > $41d0e28ea3e97704$var$$5beb376faad492b0$var$UNDOCK_THRESHOLD) shouldUndock = true;
                if (dockedEdge === "bottom" && e.clientY < window.innerHeight - $41d0e28ea3e97704$var$$5beb376faad492b0$var$UNDOCK_THRESHOLD) shouldUndock = true;
                if (dockedEdge === "left" && e.clientX > $41d0e28ea3e97704$var$$5beb376faad492b0$var$UNDOCK_THRESHOLD) shouldUndock = true;
                if (dockedEdge === "right" && e.clientX < window.innerWidth - $41d0e28ea3e97704$var$$5beb376faad492b0$var$UNDOCK_THRESHOLD) shouldUndock = true;
                if (shouldUndock) {
                    handleUndockRef.current({
                        x: e.clientX,
                        y: e.clientY
                    });
                    isDockedRef.current = false;
                    return;
                }
            }
            move(e.movementX, e.movementY);
        },
        onMouseUp: ()=>{
            setMoving(false);
            isInInteractionRef.current = false;
            if (dockingEnabled) {
                dispatch({
                    type: "setDockDragEdge",
                    edge: null
                });
                document.querySelectorAll("[data-dock-target]").forEach((panel)=>panel.removeAttribute("data-dock-target"));
            }
        },
        onInteractionEnd: ()=>{
            if (!isInInteractionRef.current || interactionProcessedRef.current) return;
            interactionProcessedRef.current = true;
            const isDockedNow = isDockedRef.current;
            let isDocking = false;
            if (!isDockedNow && dockable && targetSnapEdgeRef.current) {
                handleDockRef.current(targetSnapEdgeRef.current);
                isDocking = true;
            }
            if (dockingEnabled) dispatch({
                type: "endDockDrag",
                id: id
            });
            targetSnapEdgeRef.current = null;
            isInInteractionRef.current = false;
            const shouldCheckPosition = !isDocking && !isDockedNow && hasMovedRef.current;
            hasMovedRef.current = false;
            if (shouldCheckPosition) $41d0e28ea3e97704$var$$1d453c921d235704$export$1e4ae39bb8625cc1(windowRef, move);
        },
        interactionEndEnabled: windowVisible,
        onViewportResize: ()=>{
            $41d0e28ea3e97704$var$$1d453c921d235704$export$1e4ae39bb8625cc1(windowRef, move);
        },
        viewportResizeEnabled: windowVisible
    });
    const onMouseDownRef = (0, $spJKX.useRef)(onMouseDown);
    (0, $spJKX.useLayoutEffect)(()=>{
        onMouseDownRef.current = onMouseDown;
    }, [
        onMouseDown
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (isDocked) targetSnapEdgeRef.current = null;
    }, [
        isDocked
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!moving) return;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = previousOverflow;
        };
    }, [
        moving
    ]);
    const onTitleMouseDown = (0, $spJKX.useCallback)((e)=>{
        onMouseDownRef.current(e);
    }, []);
    return {
        onTitleMouseDown: onTitleMouseDown,
        armInteractionEnd: armInteractionEnd,
        lastMousePosRef: lastMousePosRef
    };
};
const $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154 = (zOrder, id)=>{
    const index = zOrder.indexOf(id);
    if (index === -1 || index === zOrder.length - 1) return zOrder;
    return [
        ...zOrder.filter((windowId)=>windowId !== id),
        id
    ];
};
const $41d0e28ea3e97704$var$$265d95d94411cc8a$export$dadb2d7b57583a65 = (edges, edge)=>{
    if (!edges.has(edge)) return edges;
    const next = new Set(edges);
    next.delete(edge);
    return next;
};
const $41d0e28ea3e97704$var$$f1094e4200ae32e9$export$37a3192b19bf0fed = (state, action)=>{
    const { edge: edge, id: id } = action;
    // If a specific window is requested, use it; otherwise find the first/active window
    const targetId = id ?? state.activeWindowsByEdge.get(edge) ?? Array.from(state.dockedWindows.values()).find((w)=>w.edge === edge)?.id ?? null;
    if (!targetId) return state;
    const alreadyActive = state.activeWindowsByEdge.get(edge) === targetId;
    const zOrder = $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154(state.zOrder, targetId);
    const collapsed = state.collapsedEdges.has(edge);
    if (alreadyActive && zOrder === state.zOrder && !collapsed) return state;
    const activeWindowsByEdge = alreadyActive ? state.activeWindowsByEdge : new Map(state.activeWindowsByEdge).set(edge, targetId);
    const collapsedEdges = collapsed ? $41d0e28ea3e97704$var$$265d95d94411cc8a$export$dadb2d7b57583a65(state.collapsedEdges, edge) : state.collapsedEdges;
    return {
        ...state,
        activeWindowsByEdge: activeWindowsByEdge,
        zOrder: zOrder,
        collapsedEdges: collapsedEdges
    };
};
const $41d0e28ea3e97704$var$$f4597164f1c3b1f8$export$f08bf38cfbe999b8 = (state, action)=>{
    const { id: id, edge: edge, preDockRect: preDockRect } = action;
    const wasDocked = state.dockedWindows.has(id);
    const dockedWindows = new Map(state.dockedWindows);
    const nextOrder = Math.max(-1, ...Array.from(dockedWindows.values()).filter((window1)=>window1.edge === edge && window1.id !== id).map((window1)=>window1.order)) + 1;
    dockedWindows.set(id, {
        id: id,
        edge: edge,
        order: nextOrder
    });
    const activeWindowsByEdge = new Map(state.activeWindowsByEdge);
    activeWindowsByEdge.set(edge, id);
    // The original floating position is kept for the life of the dock, so a window that is
    // drag-undocked and re-docked in the same gesture still restores where it started
    let preDockRects = state.preDockRects;
    if (!wasDocked && preDockRect && !preDockRects.has(id)) {
        preDockRects = new Map(preDockRects);
        preDockRects.set(id, preDockRect);
    }
    return {
        ...state,
        dockedWindows: dockedWindows,
        activeWindowsByEdge: activeWindowsByEdge,
        preDockRects: preDockRects,
        // Docking a window shows it, so a pinned edge is unpinned
        collapsedEdges: $41d0e28ea3e97704$var$$265d95d94411cc8a$export$dadb2d7b57583a65(state.collapsedEdges, edge),
        zOrder: $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154(state.zOrder, id)
    };
};
const $41d0e28ea3e97704$var$$8e88b4b3dae38c3b$export$9639ccd506cc988e = (state, action)=>{
    // A window released while floating keeps no stale floating rect for its next dock
    let preDockRects = state.preDockRects;
    if (!state.dockedWindows.has(action.id) && preDockRects.has(action.id)) {
        preDockRects = new Map(preDockRects);
        preDockRects.delete(action.id);
    }
    if (preDockRects === state.preDockRects && state.dragWindowId === null && state.dragSnapEdge === null) return state;
    return {
        ...state,
        preDockRects: preDockRects,
        dragWindowId: null,
        dragSnapEdge: null
    };
};
const $41d0e28ea3e97704$var$$9d3b1c0b8bec5922$export$ded363a045b3ed3c = (state, action)=>{
    const zOrder = $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154(state.zOrder, action.id);
    return zOrder === state.zOrder ? state : {
        ...state,
        zOrder: zOrder
    };
};
const $41d0e28ea3e97704$var$$e3606e2aeaa2d2cf$export$f6278c69e3ee2bda = (state, action)=>{
    if (state.zOrder.includes(action.id)) return state;
    return {
        ...state,
        zOrder: [
            ...state.zOrder,
            action.id
        ]
    };
};
const $41d0e28ea3e97704$var$$b4ea6c08e8bb0788$var$areConfigsEqual = (left, right)=>{
    const keys = new Set([
        ...Object.keys(left),
        ...Object.keys(right)
    ]);
    for (const key of keys){
        const typedKey = key;
        if (left[typedKey] !== right[typedKey]) return false;
    }
    return true;
};
const $41d0e28ea3e97704$var$$b4ea6c08e8bb0788$export$6faecb39eaef6e98 = (state, action)=>{
    const currentConfig = state.windowConfigs.get(action.id);
    const nextConfig = currentConfig ? {
        ...currentConfig,
        ...action.config
    } : {
        title: action.id,
        ...action.config
    };
    if (currentConfig && $41d0e28ea3e97704$var$$b4ea6c08e8bb0788$var$areConfigsEqual(currentConfig, nextConfig)) return state;
    const windowConfigs = new Map(state.windowConfigs);
    windowConfigs.set(action.id, nextConfig);
    return {
        ...state,
        windowConfigs: windowConfigs
    };
};
const $41d0e28ea3e97704$var$$916c79525673093e$export$79f302cfe063cfd5 = (state, action)=>{
    const preDockRects = new Map(state.preDockRects);
    preDockRects.set(action.id, action.rect);
    return {
        ...state,
        preDockRects: preDockRects
    };
};
const $41d0e28ea3e97704$var$$7ccac318cfd8efb0$export$fe687a6d76b1ced1 = (state, action)=>{
    const { edge: edge, id: id } = action;
    const alreadyActive = state.activeWindowsByEdge.get(edge) === id;
    const zOrder = $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154(state.zOrder, id);
    if (alreadyActive && zOrder === state.zOrder) return state;
    const activeWindowsByEdge = alreadyActive ? state.activeWindowsByEdge : new Map(state.activeWindowsByEdge).set(edge, id);
    return {
        ...state,
        activeWindowsByEdge: activeWindowsByEdge,
        zOrder: zOrder
    };
};
const $41d0e28ea3e97704$var$$da37762de24eb786$export$fecaf878371e3fce = (state, action)=>{
    return state.dragSnapEdge === action.edge ? state : {
        ...state,
        dragSnapEdge: action.edge
    };
};
const $41d0e28ea3e97704$var$$14143dd2e0159415$export$2a1654aa430f7fe = (state, action)=>{
    const { edge: edge, host: host } = action;
    if ((state.panelContentHosts.get(edge) ?? null) === host) return state;
    const panelContentHosts = new Map(state.panelContentHosts);
    if (host) panelContentHosts.set(edge, host);
    else panelContentHosts.delete(edge);
    return {
        ...state,
        panelContentHosts: panelContentHosts
    };
};
const $41d0e28ea3e97704$var$$9db79d6ae9f7a617$export$82e9fb311ab63b42 = (state, action)=>{
    return {
        ...state,
        dragWindowId: action.id,
        dragSnapEdge: null
    };
};
const $41d0e28ea3e97704$var$$29f2eafe6190d987$export$b4ca0100c77ea701 = (state, action)=>{
    const { edge: edge } = action;
    const collapsedEdges = new Set(state.collapsedEdges);
    if (collapsedEdges.has(edge)) collapsedEdges.delete(edge);
    else collapsedEdges.add(edge);
    // When toggling, also ensure the edge's panel is brought to top by raising its active window
    const activeId = state.activeWindowsByEdge.get(edge) ?? Array.from(state.dockedWindows.values()).find((w)=>w.edge === edge)?.id ?? null;
    const zOrder = activeId ? $41d0e28ea3e97704$var$$265d95d94411cc8a$export$66313c302b2ea154(state.zOrder, activeId) : state.zOrder;
    return {
        ...state,
        collapsedEdges: collapsedEdges,
        zOrder: zOrder
    };
};
const $41d0e28ea3e97704$var$$4dd676131a678463$export$1591f925636a50a8 = (state, action)=>{
    const collapsedEdges = new Set(state.collapsedEdges);
    if (collapsedEdges.has(action.edge)) collapsedEdges.delete(action.edge);
    else collapsedEdges.add(action.edge);
    return {
        ...state,
        collapsedEdges: collapsedEdges
    };
};
const $41d0e28ea3e97704$var$$93bfab851de4445f$export$2e441201aef1ed64 = (state, action)=>{
    const removed = state.dockedWindows.get(action.id);
    if (!removed) return state;
    const dockedWindows = new Map(state.dockedWindows);
    dockedWindows.delete(action.id);
    const edgeIsEmpty = !Array.from(dockedWindows.values()).some((window1)=>window1.edge === removed.edge);
    // A drag undock may re-dock before the gesture ends, so its stored rect is kept
    let preDockRects = state.preDockRects;
    if (!action.viaDrag && preDockRects.has(action.id)) {
        preDockRects = new Map(preDockRects);
        preDockRects.delete(action.id);
    }
    return {
        ...state,
        dockedWindows: dockedWindows,
        preDockRects: preDockRects,
        // An empty edge has no panel, so drop its pinned state
        collapsedEdges: edgeIsEmpty ? $41d0e28ea3e97704$var$$265d95d94411cc8a$export$dadb2d7b57583a65(state.collapsedEdges, removed.edge) : state.collapsedEdges
    };
};
const $41d0e28ea3e97704$var$$b20b896126e47d90$export$4a5146d42def3778 = (state, action)=>{
    if (!state.zOrder.includes(action.id)) return state;
    const preDockRects = new Map(state.preDockRects);
    preDockRects.delete(action.id);
    const windowConfigs = new Map(state.windowConfigs);
    windowConfigs.delete(action.id);
    return {
        ...state,
        preDockRects: preDockRects,
        windowConfigs: windowConfigs,
        zOrder: state.zOrder.filter((windowId)=>windowId !== action.id)
    };
};
const $41d0e28ea3e97704$var$$ff908357802e2625$export$3d45dde97c2699c0 = (state, action)=>{
    switch(action.type){
        case "activateWindowOnEdge":
            return $41d0e28ea3e97704$var$$f1094e4200ae32e9$export$37a3192b19bf0fed(state, action);
        case "dock":
            return $41d0e28ea3e97704$var$$f4597164f1c3b1f8$export$f08bf38cfbe999b8(state, action);
        case "endDockDrag":
            return $41d0e28ea3e97704$var$$8e88b4b3dae38c3b$export$9639ccd506cc988e(state, action);
        case "raiseWindow":
            return $41d0e28ea3e97704$var$$9d3b1c0b8bec5922$export$ded363a045b3ed3c(state, action);
        case "registerWindow":
            return $41d0e28ea3e97704$var$$e3606e2aeaa2d2cf$export$f6278c69e3ee2bda(state, action);
        case "registerWindowConfig":
            return $41d0e28ea3e97704$var$$b4ea6c08e8bb0788$export$6faecb39eaef6e98(state, action);
        case "saveWindowPosition":
            return $41d0e28ea3e97704$var$$916c79525673093e$export$79f302cfe063cfd5(state, action);
        case "setActiveWindowOnEdge":
            return $41d0e28ea3e97704$var$$7ccac318cfd8efb0$export$fe687a6d76b1ced1(state, action);
        case "setDockDragEdge":
            return $41d0e28ea3e97704$var$$da37762de24eb786$export$fecaf878371e3fce(state, action);
        case "setPanelContentHost":
            return $41d0e28ea3e97704$var$$14143dd2e0159415$export$2a1654aa430f7fe(state, action);
        case "startDockDrag":
            return $41d0e28ea3e97704$var$$9db79d6ae9f7a617$export$82e9fb311ab63b42(state, action);
        case "toggleAndRaiseEdge":
            return $41d0e28ea3e97704$var$$29f2eafe6190d987$export$b4ca0100c77ea701(state, action);
        case "toggleEdgeCollapse":
            return $41d0e28ea3e97704$var$$4dd676131a678463$export$1591f925636a50a8(state, action);
        case "undock":
            return $41d0e28ea3e97704$var$$93bfab851de4445f$export$2e441201aef1ed64(state, action);
        case "unregisterWindow":
            return $41d0e28ea3e97704$var$$b20b896126e47d90$export$4a5146d42def3778(state, action);
    }
};
const $41d0e28ea3e97704$var$$ce332fbbbbb80a62$export$e77dde540745ac60 = {
    dockedWindows: new Map(),
    collapsedEdges: new Set(),
    activeWindowsByEdge: new Map(),
    panelContentHosts: new Map(),
    preDockRects: new Map(),
    windowConfigs: new Map(),
    zOrder: [],
    dragWindowId: null,
    dragSnapEdge: null
};
var $41d0e28ea3e97704$var$$7dff23e63d160359$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "activeDockTabButton", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$4a4aabf059e15017;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$4a4aabf059e15017 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "autoHidden", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$4beb793c0f133f07;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$4beb793c0f133f07 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockLayoutButton", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$40ffcf42f07f3bb0;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$40ffcf42f07f3bb0 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockLayoutButtonActive", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc83dcbb9840986c;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc83dcbb9840986c = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockPanel", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$3fd77751d6e24ccf;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$3fd77751d6e24ccf = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockPanelContent", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$47c3f3f4ec9d9c3a;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$47c3f3f4ec9d9c3a = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockPanelTabs", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e3f82adc28e02459;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e3f82adc28e02459 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockPinButton", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e7210b99cd48ced1;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e7210b99cd48ced1 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockPinButtonPinned", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$54d48a56596c606b;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$54d48a56596c606b = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "dockTabButton", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$89dbca9168526a7b;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$89dbca9168526a7b = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "edge-bottom", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e860763dac0b09ad;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$e860763dac0b09ad = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "edge-left", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$b06fa6df9a79d05e;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$b06fa6df9a79d05e = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "edge-right", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$42dbd3ac47b2cf0b;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$42dbd3ac47b2cf0b = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "edge-top", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$8725382f520acefe;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$8725382f520acefe = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "pinned", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$9cea6167b1171147;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$9cea6167b1171147 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandle", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$8e36b812ea421d73;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$8e36b812ea421d73 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandle-bottom", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$f5351dcf639e012f;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$f5351dcf639e012f = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandle-left", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc91b6c8bccf62ae;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc91b6c8bccf62ae = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandle-right", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$6d75662911e858e9;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$6d75662911e858e9 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandle-top", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$d385bafee48de05;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$d385bafee48de05 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$7dff23e63d160359$exports, "resizeHandleActive", function() {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$531de18751b54ed7;
}, function(v) {
    return $41d0e28ea3e97704$var$$7dff23e63d160359$export$531de18751b54ed7 = v;
});
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$4a4aabf059e15017;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$4beb793c0f133f07;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$40ffcf42f07f3bb0;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc83dcbb9840986c;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$3fd77751d6e24ccf;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$47c3f3f4ec9d9c3a;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$e3f82adc28e02459;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$e7210b99cd48ced1;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$54d48a56596c606b;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$89dbca9168526a7b;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$e860763dac0b09ad;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$b06fa6df9a79d05e;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$42dbd3ac47b2cf0b;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$8725382f520acefe;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$9cea6167b1171147;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$8e36b812ea421d73;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$f5351dcf639e012f;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$bc91b6c8bccf62ae;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$6d75662911e858e9;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$d385bafee48de05;
var $41d0e28ea3e97704$var$$7dff23e63d160359$export$531de18751b54ed7;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$4a4aabf059e15017 = `acxtm-DockPanel-module-activeDockTabButton`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$4beb793c0f133f07 = `acxtm-DockPanel-module-autoHidden`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$40ffcf42f07f3bb0 = `acxtm-DockPanel-module-dockLayoutButton`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$bc83dcbb9840986c = `acxtm-DockPanel-module-dockLayoutButtonActive`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$3fd77751d6e24ccf = `acxtm-DockPanel-module-dockPanel`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$47c3f3f4ec9d9c3a = `acxtm-DockPanel-module-dockPanelContent`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$e3f82adc28e02459 = `acxtm-DockPanel-module-dockPanelTabs`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$e7210b99cd48ced1 = `acxtm-DockPanel-module-dockPinButton`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$54d48a56596c606b = `acxtm-DockPanel-module-dockPinButtonPinned`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$89dbca9168526a7b = `acxtm-DockPanel-module-dockTabButton`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$e860763dac0b09ad = `acxtm-DockPanel-module-edge-bottom`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$b06fa6df9a79d05e = `acxtm-DockPanel-module-edge-left`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$42dbd3ac47b2cf0b = `acxtm-DockPanel-module-edge-right`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$8725382f520acefe = `acxtm-DockPanel-module-edge-top`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$9cea6167b1171147 = `acxtm-DockPanel-module-pinned`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$8e36b812ea421d73 = `acxtm-DockPanel-module-resizeHandle`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$f5351dcf639e012f = `acxtm-DockPanel-module-resizeHandle-bottom`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$bc91b6c8bccf62ae = `acxtm-DockPanel-module-resizeHandle-left`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$6d75662911e858e9 = `acxtm-DockPanel-module-resizeHandle-right`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$d385bafee48de05 = `acxtm-DockPanel-module-resizeHandle-top`;
$41d0e28ea3e97704$var$$7dff23e63d160359$export$531de18751b54ed7 = `acxtm-DockPanel-module-resizeHandleActive`;
const $41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed = ({ path: path, size: size = 16 })=>(0, $bR5nk.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        fill: "currentColor",
        viewBox: "0 0 16 16",
        "aria-hidden": "true",
        children: (0, $bR5nk.jsx)("path", {
            d: path
        })
    });
const $41d0e28ea3e97704$var$$3b28b85e28627662$export$5e4a7579d3e78657 = ({ size: size })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
    });
const $41d0e28ea3e97704$var$$b10722879a80d7fe$export$cae179f078f4b4a4 = ({ size: size })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
    });
const $41d0e28ea3e97704$var$$f0b7ceca946f33cc$var$paths = {
    left: "M2 2h12v12H2v-2h1v1h10V3H3v1H2V2zM1 4h6v8H1V4zm1 1v6h4V5H2z",
    right: "M2 2h12v2h-1V3H3v10h10v-1h1v2H2V2zM9 4h6v8H9V4zm1 1v6h4V5h-4z",
    top: "M2 2h2v1H3v10h10V3h-1V2h2v12H2V2zM4 1h8v6H4V1zm1 1v4h6V2H5z",
    bottom: "M2 2h12v12h-2v-1h1V3H3v10h1v1H2V2zM4 9h8v6H4V9zm1 1v4h6v-4H5z"
};
const $41d0e28ea3e97704$var$$f0b7ceca946f33cc$export$e1eaa2e4bcae5678 = ({ size: size, edge: edge = "right" })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: $41d0e28ea3e97704$var$$f0b7ceca946f33cc$var$paths[edge]
    });
const $41d0e28ea3e97704$var$$4fb973ad4cb4e151$var$paths = {
    left: "M1 2h14v12H1V2zm1 1v10h3V3H2zm4 0v10h8V3H6zm7 4.5h-3v-2L7 8l3 2.5v-2h3v-1z",
    right: "M1 2h14v12H1V2zm1 1v10h8V3H2zm9 0v10h3V3h-3zM3 7.5h3v-2L9 8l-3 2.5v-2H3v-1z",
    top: "M1 2h14v12H1V2zm1 1v2h12V3H2zm0 3v7h12V6H2zm5.5 6V9h-2L8 6l2.5 3h-2v3h-1z",
    bottom: "M1 2h14v12H1V2zm1 1v7h12V3H2zm0 8v2h12v-2H2zm5.5-7v3h-2L8 10l2.5-3h-2V4h-1z"
};
const $41d0e28ea3e97704$var$$4fb973ad4cb4e151$export$d73250f348fbe223 = ({ size: size, edge: edge = "right" })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: $41d0e28ea3e97704$var$$4fb973ad4cb4e151$var$paths[edge]
    });
const $41d0e28ea3e97704$var$$c64ccf8ad5ebee79$export$8dedaee0e594ee0e = ({ size: size })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: "M4.146.146A.5.5 0 0 1 4.5 0h7a.5.5 0 0 1 .5.5c0 .68-.342 1.174-.646 1.479-.126.125-.25.224-.354.298v4.431l.078.048c.203.127.476.314.751.555C12.36 7.775 13 8.527 13 9.5a.5.5 0 0 1-.5.5h-4v4.5c0 .276-.224 1.5-.5 1.5s-.5-1.224-.5-1.5V10h-4a.5.5 0 0 1-.5-.5c0-.973.64-1.725 1.17-2.189A6 6 0 0 1 5 6.708V2.277a3 3 0 0 1-.354-.298C4.342 1.674 4 1.179 4 .5a.5.5 0 0 1 .146-.354z"
    });
const $41d0e28ea3e97704$var$$b66bde7eb27aff99$var$paths = {
    left: "M1 2h14v12H1V2zm1 1v10h3V3H2zm4 0v10h8V3H6zm1 4.5h3v-2L13 8l-3 2.5v-2H7v-1z",
    right: "M1 2h14v12H1V2zm1 1v10h8V3H2zm9 0v10h3V3h-3zM9 7.5H6v-2L3 8l3 2.5v-2h3v-1z",
    top: "M1 2h14v12H1V2zm1 1v2h12V3H2zm0 3v7h12V6H2zm5.5 1v2h-2L8 12l2.5-3h-2V7h-1z",
    bottom: "M1 2h14v12H1V2zm1 1v7h12V3H2zm0 8v2h12v-2H2zm5.5-2V7h-2L8 4l2.5 3h-2v2h-1z"
};
const $41d0e28ea3e97704$var$$b66bde7eb27aff99$export$bde78f63b3a5d832 = ({ size: size, edge: edge = "left" })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: $41d0e28ea3e97704$var$$b66bde7eb27aff99$var$paths[edge]
    });
const $41d0e28ea3e97704$var$$875bf51c800fe6dc$export$76d7b85b3941290e = ({ size: size })=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$7cd112d45e0d5d4b$export$dbcb8210e8a983ed, {
        size: size,
        path: "M5 2h10v12H5v-3h1v2h8V3H6v2H5V2zM1 8l3-2.5v2h5v1H4v2L1 8z"
    });
const $41d0e28ea3e97704$var$$d94e6cfd1a49c82c$export$6e77d9bcca831e18 = ({ edge: edge, isPinned: isPinned, onClick: onClick })=>(0, $bR5nk.jsx)("button", {
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockPinButton, isPinned && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockPinButtonPinned),
        "aria-pressed": isPinned,
        "aria-label": isPinned ? `Unpin ${edge} dock panel` : `Pin ${edge} dock panel`,
        title: isPinned ? "Unpin: show window contents" : "Pin: hide window contents",
        onClick: onClick,
        children: (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$c64ccf8ad5ebee79$export$8dedaee0e594ee0e, {
            size: 12
        })
    });
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "anchor", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$2e2992790a6f69a8;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$2e2992790a6f69a8 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "caretHolder", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "contextMenu", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$218b899e1d476006;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$218b899e1d476006 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "contextMenuHandler", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "contextMenuItem", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$e5ea51c279904378;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$e5ea51c279904378 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "contextMenuItemCheck", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "contextMenuItemLabel", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ada86c5b962aa22;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ada86c5b962aa22 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "disabled", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$683472f6198a076e;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$683472f6198a076e = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "hidden", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$73920f18ca706874;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$73920f18ca706874 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "subMenu", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports, "visible", function() {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$664c6d24e3175067;
}, function(v) {
    return $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$664c6d24e3175067 = v;
});
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$2e2992790a6f69a8;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$218b899e1d476006;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$e5ea51c279904378;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ada86c5b962aa22;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$683472f6198a076e;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$73920f18ca706874;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361;
var $41d0e28ea3e97704$var$$47067f35ca62d4a5$export$664c6d24e3175067;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$2e2992790a6f69a8 = `acxtm-ContextMenu-module-anchor`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ed5f4fbab298e07 = `acxtm-ContextMenu-module-caretHolder`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$218b899e1d476006 = `acxtm-ContextMenu-module-contextMenu`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$ed8ffb5bb55a3bc8 = `acxtm-ContextMenu-module-contextMenuHandler`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$e5ea51c279904378 = `acxtm-ContextMenu-module-contextMenuItem`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$df8b30f6d1f93a68 = `acxtm-ContextMenu-module-contextMenuItemCheck`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6ada86c5b962aa22 = `acxtm-ContextMenu-module-contextMenuItemLabel`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$683472f6198a076e = `acxtm-ContextMenu-module-disabled`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$73920f18ca706874 = `acxtm-ContextMenu-module-hidden`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$6e0e6ce39e5a0361 = `acxtm-ContextMenu-module-subMenu`;
$41d0e28ea3e97704$var$$47067f35ca62d4a5$export$664c6d24e3175067 = `acxtm-ContextMenu-module-visible`;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "caretHolder", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "disabled", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$683472f6198a076e;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$683472f6198a076e = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "hidden", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$73920f18ca706874;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$73920f18ca706874 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "lowMenu", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$59e4b099a896b33;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$59e4b099a896b33 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "lowMenu-item", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$19fbf76b734bf310;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$19fbf76b734bf310 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "lowMenuButtonHolder", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$22ec12d194e0789c;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$22ec12d194e0789c = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "lowMenuItem", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$2ad34a478577e75d;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$2ad34a478577e75d = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "lowMenuItemCheck", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$507a880a74122b06;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$507a880a74122b06 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "subMenu", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports, "visible", function() {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$664c6d24e3175067;
}, function(v) {
    return $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$664c6d24e3175067 = v;
});
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$683472f6198a076e;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$73920f18ca706874;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$59e4b099a896b33;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$19fbf76b734bf310;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$22ec12d194e0789c;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$2ad34a478577e75d;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$507a880a74122b06;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361;
var $41d0e28ea3e97704$var$$c7a6ae87165004e6$export$664c6d24e3175067;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6ed5f4fbab298e07 = `acxtm-LowMenu-module-caretHolder`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$683472f6198a076e = `acxtm-LowMenu-module-disabled`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$73920f18ca706874 = `acxtm-LowMenu-module-hidden`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$59e4b099a896b33 = `acxtm-LowMenu-module-lowMenu`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$19fbf76b734bf310 = `acxtm-LowMenu-module-lowMenu-item`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$22ec12d194e0789c = `acxtm-LowMenu-module-lowMenuButtonHolder`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$2ad34a478577e75d = `acxtm-LowMenu-module-lowMenuItem`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$507a880a74122b06 = `acxtm-LowMenu-module-lowMenuItemCheck`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$6e0e6ce39e5a0361 = `acxtm-LowMenu-module-subMenu`;
$41d0e28ea3e97704$var$$c7a6ae87165004e6$export$664c6d24e3175067 = `acxtm-LowMenu-module-visible`;
const $41d0e28ea3e97704$var$$61945e5157f5e5bf$export$251b9f54013cdfac = ({ entry: entry })=>{
    const [visible, setVisible] = (0, $spJKX.useState)(false);
    if (!entry.group || entry.group.length === 0) return (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    return (0, $bR5nk.jsxs)("span", {
        "aria-label": `Sub menu for ${entry.label}`,
        className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).caretHolder,
        onMouseEnter: ()=>{
            setVisible(true);
        },
        onMouseLeave: ()=>{
            setVisible(false);
        },
        children: [
            (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$3b28b85e28627662$export$5e4a7579d3e78657, {}),
            (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).subMenu,
                children: visible && (0, $bR5nk.jsx)($41d0e28ea3e97704$export$8dc6765e8be191c7, {
                    visible: visible,
                    entries: entry.group,
                    xPos: 14,
                    yPos: entry.group.length * -21 - 8,
                    toClose: ()=>setVisible(false)
                })
            })
        ]
    });
};
$41d0e28ea3e97704$var$$61945e5157f5e5bf$export$251b9f54013cdfac.displayName = "LowSubMenu";
const $41d0e28ea3e97704$var$$556d6f9158abfc99$export$aafc28aea571c4bc = ({ entry: entry })=>{
    const [target, setTarget] = (0, $spJKX.useState)(null);
    return (0, $bR5nk.jsxs)("div", {
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).lowMenuItem, entry.disabled && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).disabled),
        "aria-label": typeof entry.label === "string" ? entry.label : undefined,
        "aria-disabled": entry.disabled,
        onMouseEnter: ()=>{
            const sel = window.getSelection();
            const target = sel && sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
            setTarget(target);
        },
        onMouseLeave: ()=>{
            setTarget(null);
        },
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            /* istanbul ignore else */ if (!entry.disabled) entry.action?.(target);
        },
        children: [
            (0, $bR5nk.jsx)("span", {
                children: entry.label
            }),
            entry.selected && (0, $bR5nk.jsx)("span", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).lowMenuItemCheck,
                "aria-hidden": "true",
                children: entry.selectedIcon ?? "\u2713"
            }),
            entry.group && (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$61945e5157f5e5bf$export$251b9f54013cdfac, {
                entry: entry
            })
        ]
    });
};
$41d0e28ea3e97704$var$$556d6f9158abfc99$export$aafc28aea571c4bc.displayName = "LowMenuButton";
const $41d0e28ea3e97704$var$$914758b0c9d59759$export$49e8edc8ebca5f25 = ({ entries: entries, visible: visible, xPos: xPos, yPos: yPos, maxWidth: maxWidth })=>{
    // Only show the low menu if it is on the screen
    if (xPos >= window.innerWidth || yPos >= window.innerHeight) return (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    // Show the menu
    return (0, $bR5nk.jsx)("div", {
        className: [
            /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).lowMenu,
            visible ? /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).visible : /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).hidden
        ].join(" "),
        "aria-label": "Low context menu",
        style: {
            left: `${xPos}px`,
            top: `${yPos}px`,
            maxWidth: `calc(${maxWidth}px)`,
            width: `calc(${maxWidth}px - 4px)`
        },
        children: (0, $bR5nk.jsx)("div", {
            className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c7a6ae87165004e6$exports).lowMenuButtonHolder,
            children: entries.map((e, i)=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$556d6f9158abfc99$export$aafc28aea571c4bc, {
                    entry: e
                }, i))
        })
    });
};
$41d0e28ea3e97704$var$$914758b0c9d59759$export$49e8edc8ebca5f25.displayName = "LowMenu";
const $41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2 = (0, $spJKX.createContext)(null);
function $41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$c5c72b048734faff(label) {
    return typeof label !== "string" && label.type === "hr";
}
const $41d0e28ea3e97704$export$ed4f9641643dc7e4 = ({ children: children, menuItems: menuItems, showLowMenu: showLowMenu = false, ...rest })=>{
    // Check for higher content menu
    const higherContext = (0, $spJKX.useContext)($41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2);
    const thisMenuItems = [
        ...higherContext !== null ? [
            ...higherContext.menuItems,
            ...[
                higherContext.menuItems.length > 0 && !$41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$c5c72b048734faff(higherContext.menuItems[higherContext.menuItems.length - 1].label) && menuItems.length > 0 && !$41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$c5c72b048734faff(menuItems[0].label) ? {
                    label: (0, $bR5nk.jsx)("hr", {})
                } : null
            ].filter((item)=>item !== null)
        ] : [],
        ...menuItems
    ];
    // Menu resources
    const divHandlderRef = (0, $spJKX.useRef)(null);
    const menuRef = (0, $spJKX.useRef)(null);
    const [menuXPos, setMenuXPos] = (0, $spJKX.useState)(0);
    const [menuYPos, setMenuYPos] = (0, $spJKX.useState)(0);
    const [menuVisible, setMenuVisible] = (0, $spJKX.useState)(false);
    const [menuInDom, setMenuInDom] = (0, $spJKX.useState)(false);
    const [mouseOverHandlerDiv, setMouseOverHandlerDiv] = (0, $spJKX.useState)(false);
    const [mouseOverMenu, setMouseOverMenu] = (0, $spJKX.useState)(false);
    // Holder position - measured in an effect to avoid reading refs during render
    const [divHandlerPos, setDivHandlerPos] = (0, $spJKX.useState)(null);
    (0, $spJKX.useLayoutEffect)(()=>{
        function updatePos() {
            /* istanbul ignore else */ if (divHandlderRef.current) setDivHandlerPos(divHandlderRef.current.getBoundingClientRect());
        }
        // When the handler is hovered or the menu is mounted, ensure we have a fresh position
        if (mouseOverHandlerDiv || menuInDom) updatePos();
        // Attach listeners while the menu/low-menu may be visible so the position stays correct
        if (mouseOverHandlerDiv || menuInDom) {
            window.addEventListener("resize", updatePos);
            // listen on capture to catch scrolls from ancestor elements as well
            window.addEventListener("scroll", updatePos, true);
            let ro = null;
            if (typeof ResizeObserver !== "undefined" && divHandlderRef.current) {
                ro = new ResizeObserver(updatePos);
                ro.observe(divHandlderRef.current);
            }
            return ()=>{
                window.removeEventListener("resize", updatePos);
                window.removeEventListener("scroll", updatePos, true);
                if (ro) ro.disconnect();
            };
        }
    }, [
        mouseOverHandlerDiv,
        menuInDom
    ]);
    // Handle click off the menu
    const handleClick = (0, $spJKX.useCallback)((e)=>{
        /* istanbul ignore else */ if (menuRef.current && (e.target instanceof Element && !menuRef.current?.contains(e.target) || !(e.target instanceof Element))) setMenuVisible(false);
    }, []);
    (0, $spJKX.useEffect)(()=>{
        if (menuVisible) document.addEventListener("mousedown", handleClick);
        return ()=>{
            document.removeEventListener("mousedown", handleClick);
        };
    }, [
        handleClick,
        menuVisible
    ]);
    const removeController = (0, $spJKX.useRef)(new AbortController());
    (0, $spJKX.useEffect)(()=>{
        if (!mouseOverMenu && !menuVisible && !mouseOverHandlerDiv) {
            removeController.current.abort();
            removeController.current = new AbortController();
            setTimeout(()=>{
                if (!removeController.current.signal.aborted) setMenuInDom(false);
            }, 300);
        }
    }, [
        mouseOverHandlerDiv,
        menuVisible,
        mouseOverMenu
    ]);
    return (0, $bR5nk.jsxs)($41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$fc58dc71afe92de2.Provider, {
        value: {
            menuItems: thisMenuItems
        },
        children: [
            (0, $bR5nk.jsx)("div", {
                ref: divHandlderRef,
                ...rest,
                className: [
                    /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).contextMenuHandler,
                    rest.className
                ].join(" "),
                onContextMenu: async (e)=>{
                    /* istanbul ignore else */ if (!showLowMenu) {
                        setMenuInDom(true);
                        e.preventDefault();
                        e.stopPropagation();
                        setTimeout(()=>{
                            removeController.current.abort();
                            setMenuVisible(true);
                            setMenuXPos(e.pageX);
                            setMenuYPos(e.pageY);
                        }, 1);
                    }
                },
                onMouseEnter: async (e)=>{
                    if (showLowMenu) {
                        setMenuInDom(true);
                        setMouseOverHandlerDiv(false);
                        setTimeout(()=>{
                            removeController.current.abort();
                            setMouseOverHandlerDiv(true);
                        }, 1);
                    }
                    rest.onMouseEnter?.(e);
                },
                onMouseLeave: async (e)=>{
                    if (showLowMenu) {
                        removeController.current.abort();
                        removeController.current = new AbortController();
                        setMouseOverHandlerDiv(false);
                    }
                    rest.onMouseLeave?.(e);
                },
                children: children
            }),
            menuInDom && divHandlerPos && (0, $oS63j.createPortal)((0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).anchor,
                onMouseEnter: ()=>{
                    removeController.current.abort();
                    setMouseOverMenu(true);
                },
                onMouseLeave: ()=>{
                    removeController.current.abort();
                    removeController.current = new AbortController();
                    setMouseOverMenu(false);
                },
                children: showLowMenu ? (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$914758b0c9d59759$export$49e8edc8ebca5f25, {
                    visible: mouseOverHandlerDiv,
                    entries: menuItems,
                    xPos: divHandlerPos.left,
                    yPos: divHandlerPos.bottom,
                    maxWidth: divHandlerPos.width
                }) : (0, $bR5nk.jsx)($41d0e28ea3e97704$export$8dc6765e8be191c7, {
                    visible: menuVisible,
                    ref: menuRef,
                    entries: thisMenuItems,
                    xPos: menuXPos,
                    yPos: menuYPos,
                    toClose: ()=>{
                        setMenuVisible(false);
                        setMouseOverMenu(false);
                    }
                })
            }), document.body)
        ]
    });
};
$41d0e28ea3e97704$export$ed4f9641643dc7e4.displayName = "ContextMenuHandler";
const $41d0e28ea3e97704$var$$d59d2db81da674e7$export$966b8d65bfd35d56 = ({ windowId: windowId, edge: edge, isActive: isActive })=>{
    const docking = $41d0e28ea3e97704$export$a3af73b13b2dc8c7();
    const dispatch = docking.dispatch;
    const windowTitle = docking.getWindowConfig(windowId).title;
    const showWindow = ()=>{
        dispatch({
            type: "activateWindowOnEdge",
            edge: edge,
            id: windowId
        });
    };
    return (0, $bR5nk.jsx)($41d0e28ea3e97704$export$ed4f9641643dc7e4, {
        menuItems: [
            {
                label: "Show",
                action: showWindow
            },
            {
                label: "Close",
                action: ()=>docking.closeWindow(windowId)
            },
            {
                label: "Undock",
                action: ()=>docking.getWindowController(windowId)?.onUndock?.()
            }
        ],
        style: {
            display: "contents"
        },
        children: (0, $bR5nk.jsx)("button", {
            className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockTabButton, isActive && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).activeDockTabButton),
            onClick: showWindow,
            title: `Activate ${windowTitle}`,
            children: windowTitle
        })
    });
};
const $41d0e28ea3e97704$export$73a97460965f977b = ({ edge: edge, initialSettings: initialSettings, onSettingsChange: onSettingsChange })=>{
    const docking = $41d0e28ea3e97704$export$a3af73b13b2dc8c7();
    const dispatch = docking.dispatch;
    const windows = docking.getWindowsOnEdge(edge);
    const panelRef = (0, $spJKX.useRef)(null);
    const contentHostRef = (0, $spJKX.useRef)(null);
    const [pushContent, setPushContent] = (0, $spJKX.useState)(initialSettings?.pushContent ?? true);
    const getActiveWindowOnEdge = docking.getActiveWindowOnEdge;
    // The chosen size is kept while the panel is empty so it is reused when a window docks again
    const { panelSize: panelSize, isResizing: isResizing, handleResizeMouseDown: handleResizeMouseDown, handleResizeKeyDown: handleResizeKeyDown } = $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$export$29ee659ed4badccd(edge, panelRef, ()=>dispatch({
            type: "activateWindowOnEdge",
            edge: edge
        }), initialSettings?.size ?? null);
    (0, $spJKX.useEffect)(()=>{
        if (!isResizing) onSettingsChange?.(edge, {
            size: panelSize,
            pushContent: pushContent
        });
    }, [
        edge,
        isResizing,
        onSettingsChange,
        panelSize,
        pushContent
    ]);
    (0, $spJKX.useEffect)(()=>{
        dispatch({
            type: "setPanelContentHost",
            edge: edge,
            host: contentHostRef.current
        });
        return ()=>{
            dispatch({
                type: "setPanelContentHost",
                edge: edge,
                host: null
            });
        };
    }, [
        dispatch,
        edge,
        windows.length
    ]);
    const isPinned = windows.length > 0 && docking.isEdgeCollapsed(edge);
    // A pinned bar slides away to a thin line once the pointer moves away from it
    const [autoHidden, setAutoHidden] = $41d0e28ea3e97704$var$$7e03492697c3c93f$export$673fd997fc6cbd43(isPinned, panelRef);
    const hasWindows = windows.length > 0;
    (0, $spJKX.useLayoutEffect)(()=>{
        const panel = panelRef.current;
        if (!pushContent || isPinned || !hasWindows || !panel) return;
        const bodyStyle = document.body.style;
        const paddingProperty = `padding-${edge}`;
        const insetProperty = `--dock-panel-inset-${edge}`;
        const originalPadding = bodyStyle.getPropertyValue(paddingProperty);
        const originalPaddingPriority = bodyStyle.getPropertyPriority(paddingProperty);
        const originalInset = bodyStyle.getPropertyValue(insetProperty);
        const originalInsetPriority = bodyStyle.getPropertyPriority(insetProperty);
        const basePadding = parseFloat(getComputedStyle(document.body).getPropertyValue(paddingProperty)) || 0;
        const updateInset = ()=>{
            const rect = panel.getBoundingClientRect();
            const size = $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526(edge) ? rect.width : rect.height;
            bodyStyle.setProperty(paddingProperty, `${basePadding + size}px`);
            bodyStyle.setProperty(insetProperty, `${size}px`);
        };
        updateInset();
        const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(updateInset);
        observer?.observe(panel);
        window.addEventListener("resize", updateInset);
        return ()=>{
            observer?.disconnect();
            window.removeEventListener("resize", updateInset);
            bodyStyle.setProperty(paddingProperty, originalPadding, originalPaddingPriority);
            bodyStyle.setProperty(insetProperty, originalInset, originalInsetPriority);
        };
    }, [
        edge,
        hasWindows,
        isPinned,
        panelSize,
        pushContent
    ]);
    if (windows.length === 0) return null;
    const activeWindowId = getActiveWindowOnEdge(edge) ?? windows[0].id;
    // Panels stack with floating windows using the z-index of their visible (active) window
    const panelZIndex = docking.getPanelZIndex(edge) ?? undefined;
    const horizontal = $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526(edge);
    const sizeStyle = panelSize === null || isPinned ? {} : horizontal ? {
        width: panelSize,
        maxWidth: `calc(100vw - ${$41d0e28ea3e97704$var$$862ad0fd74423c06$export$268d176903180528}px)`
    } : {
        height: panelSize,
        maxHeight: `calc(100vh - ${$41d0e28ea3e97704$var$$862ad0fd74423c06$export$268d176903180528}px)`
    };
    return (0, $bR5nk.jsxs)("div", {
        ref: panelRef,
        "data-dock-panel-edge": edge,
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockPanel, /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports)[`edge-${edge}`], isPinned && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).pinned, autoHidden && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).autoHidden),
        style: {
            zIndex: panelZIndex,
            ...sizeStyle
        },
        children: [
            !isPinned && (0, $bR5nk.jsx)("div", {
                className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).resizeHandle, /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports)[`resizeHandle-${edge}`], isResizing && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).resizeHandleActive),
                role: "separator",
                "aria-orientation": horizontal ? "vertical" : "horizontal",
                "aria-label": `Resize ${edge} dock panel`,
                "aria-valuemin": $41d0e28ea3e97704$var$$862ad0fd74423c06$export$bbd25dc97cf925d5,
                "aria-valuenow": panelSize ?? undefined,
                tabIndex: 0,
                onMouseDown: handleResizeMouseDown,
                onKeyDown: handleResizeKeyDown
            }),
            (0, $bR5nk.jsx)("div", {
                ref: contentHostRef,
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockPanelContent,
                hidden: isPinned
            }),
            (0, $bR5nk.jsxs)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockPanelTabs,
                children: [
                    (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$d94e6cfd1a49c82c$export$6e77d9bcca831e18, {
                        edge: edge,
                        isPinned: isPinned,
                        onClick: ()=>{
                            // The pointer is on the pin button, so a freshly pinned bar starts shown
                            setAutoHidden(false);
                            dispatch({
                                type: "toggleAndRaiseEdge",
                                edge: edge
                            });
                        }
                    }),
                    (0, $bR5nk.jsx)("button", {
                        type: "button",
                        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockLayoutButton, pushContent && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$7dff23e63d160359$exports).dockLayoutButtonActive),
                        "aria-pressed": pushContent,
                        "aria-label": `Push content with ${edge} dock panel`,
                        title: pushContent ? "Cover content" : "Push content",
                        onClick: ()=>setPushContent((previous)=>!previous),
                        children: pushContent ? (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$f0b7ceca946f33cc$export$e1eaa2e4bcae5678, {
                            size: 12,
                            edge: edge
                        }) : (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$b66bde7eb27aff99$export$bde78f63b3a5d832, {
                            size: 12,
                            edge: edge
                        })
                    }),
                    windows.map((window1)=>(0, $bR5nk.jsx)($41d0e28ea3e97704$var$$d59d2db81da674e7$export$966b8d65bfd35d56, {
                            windowId: window1.id,
                            edge: edge,
                            isActive: window1.id === activeWindowId
                        }, window1.id))
                ]
            })
        ]
    });
};
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports, "bottom", function() {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$40e543e69a8b3fbb;
}, function(v) {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$40e543e69a8b3fbb = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports, "dockZoneIndicator", function() {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79f467ba15a02210;
}, function(v) {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79f467ba15a02210 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports, "left", function() {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$eabcd2c8791e7bf4;
}, function(v) {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$eabcd2c8791e7bf4 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports, "right", function() {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79ffe56a765070d2;
}, function(v) {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79ffe56a765070d2 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports, "top", function() {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$1e95b668f3b82d;
}, function(v) {
    return $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$1e95b668f3b82d = v;
});
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$40e543e69a8b3fbb;
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79f467ba15a02210;
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$eabcd2c8791e7bf4;
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79ffe56a765070d2;
var $41d0e28ea3e97704$var$$c0b5c3018d04563e$export$1e95b668f3b82d;
$41d0e28ea3e97704$var$$c0b5c3018d04563e$export$40e543e69a8b3fbb = `acxtm-DockZoneIndicator-module-bottom`;
$41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79f467ba15a02210 = `acxtm-DockZoneIndicator-module-dockZoneIndicator`;
$41d0e28ea3e97704$var$$c0b5c3018d04563e$export$eabcd2c8791e7bf4 = `acxtm-DockZoneIndicator-module-left`;
$41d0e28ea3e97704$var$$c0b5c3018d04563e$export$79ffe56a765070d2 = `acxtm-DockZoneIndicator-module-right`;
$41d0e28ea3e97704$var$$c0b5c3018d04563e$export$1e95b668f3b82d = `acxtm-DockZoneIndicator-module-top`;
const $41d0e28ea3e97704$var$$9bffd6b61a8ed701$var$edgeClassNames = {
    top: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports).top,
    bottom: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports).bottom,
    left: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports).left,
    right: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports).right
};
const $41d0e28ea3e97704$var$$9bffd6b61a8ed701$export$a102d5e2f87c8e4a = ({ targetEdge: targetEdge, isDragging: isDragging })=>{
    const edgeClassName = targetEdge ? $41d0e28ea3e97704$var$$9bffd6b61a8ed701$var$edgeClassNames[targetEdge] : undefined;
    if (!isDragging || !edgeClassName) return null;
    return (0, $bR5nk.jsx)("div", {
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$c0b5c3018d04563e$exports).dockZoneIndicator, edgeClassName),
        "data-dock-edge": targetEdge
    });
};
const $41d0e28ea3e97704$var$$9607a6fd838bc199$export$e872cdc81afcb03c = (0, $spJKX.createContext)(undefined);
const $41d0e28ea3e97704$var$$9607a6fd838bc199$var$PANEL_SETTINGS_KEY = "@asup/context-menu:dock-panels";
const $41d0e28ea3e97704$var$$9607a6fd838bc199$var$DOCK_EDGES = [
    "top",
    "left",
    "right",
    "bottom"
];
const $41d0e28ea3e97704$var$$9607a6fd838bc199$var$readPanelSettings = ()=>{
    const settings = {
        top: {
            size: null,
            pushContent: true
        },
        left: {
            size: null,
            pushContent: true
        },
        right: {
            size: null,
            pushContent: true
        },
        bottom: {
            size: null,
            pushContent: true
        }
    };
    if (typeof window === "undefined") return settings;
    try {
        const saved = JSON.parse(window.localStorage.getItem($41d0e28ea3e97704$var$$9607a6fd838bc199$var$PANEL_SETTINGS_KEY) ?? "null");
        if (typeof saved !== "object" || saved === null || Array.isArray(saved)) return settings;
        for (const edge of $41d0e28ea3e97704$var$$9607a6fd838bc199$var$DOCK_EDGES){
            const panel = saved[edge];
            if (typeof panel !== "object" || panel === null || Array.isArray(panel)) continue;
            const { size: size, pushContent: pushContent } = panel;
            settings[edge] = {
                size: typeof size === "number" && Number.isFinite(size) && size > 0 ? size : null,
                pushContent: typeof pushContent === "boolean" ? pushContent : true
            };
        }
    } catch  {
        return settings;
    }
    return settings;
};
const $41d0e28ea3e97704$export$a90da4d36ed57428 = ({ children: children, minZIndex: minZIndex = $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$4f9fb66ac71c7da5, maxZIndex: maxZIndex = $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$e2f9a725ee199e81 })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)($41d0e28ea3e97704$var$$ff908357802e2625$export$3d45dde97c2699c0, $41d0e28ea3e97704$var$$ce332fbbbbb80a62$export$e77dde540745ac60);
    const [panelSettings, setPanelSettings] = (0, $spJKX.useState)($41d0e28ea3e97704$var$$9607a6fd838bc199$var$readPanelSettings);
    const savedPanelSettings = (0, $spJKX.useRef)(panelSettings);
    const windowControllers = (0, $spJKX.useRef)(new Map());
    const updatePanelSettings = (0, $spJKX.useCallback)((edge, settings)=>{
        setPanelSettings((previous)=>{
            const current = previous[edge];
            return current.size === settings.size && current.pushContent === settings.pushContent ? previous : {
                ...previous,
                [edge]: settings
            };
        });
    }, []);
    (0, $spJKX.useEffect)(()=>{
        if (savedPanelSettings.current === panelSettings) return;
        savedPanelSettings.current = panelSettings;
        try {
            window.localStorage.setItem($41d0e28ea3e97704$var$$9607a6fd838bc199$var$PANEL_SETTINGS_KEY, JSON.stringify(panelSettings));
        } catch  {
            return;
        }
    }, [
        panelSettings
    ]);
    const contextValue = (0, $spJKX.useMemo)(()=>({
            dispatch: dispatch,
            maxZIndex: maxZIndex,
            minZIndex: minZIndex,
            state: state,
            windowControllers: windowControllers
        }), [
        dispatch,
        maxZIndex,
        minZIndex,
        state
    ]);
    return (0, $bR5nk.jsxs)($41d0e28ea3e97704$var$$9607a6fd838bc199$export$e872cdc81afcb03c.Provider, {
        value: contextValue,
        children: [
            children,
            $41d0e28ea3e97704$var$$9607a6fd838bc199$var$DOCK_EDGES.map((edge)=>(0, $bR5nk.jsx)($41d0e28ea3e97704$export$73a97460965f977b, {
                    edge: edge,
                    initialSettings: panelSettings[edge],
                    onSettingsChange: updatePanelSettings
                }, edge)),
            (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$9bffd6b61a8ed701$export$a102d5e2f87c8e4a, {
                targetEdge: state.dragSnapEdge,
                isDragging: state.dragWindowId !== null
            })
        ]
    });
};
const $41d0e28ea3e97704$var$$8daad186b917b55f$export$bf8fc23fb02307c1 = ()=>{
    const context = (0, $spJKX.useContext)($41d0e28ea3e97704$var$$9607a6fd838bc199$export$e872cdc81afcb03c);
    return (0, $spJKX.useMemo)(()=>{
        if (!context) return undefined;
        const { dispatch: dispatch, maxZIndex: maxZIndex, minZIndex: minZIndex, state: state, windowControllers: windowControllers } = context;
        const closeWindow = (id)=>windowControllers.current.get(id)?.onClose?.();
        const getActiveWindowOnEdge = (edge)=>{
            const activeId = state.activeWindowsByEdge.get(edge);
            if (activeId && state.dockedWindows.get(activeId)?.edge === edge) return activeId;
            return getWindowsOnEdge(edge)[0]?.id ?? null;
        };
        const getDockedWindow = (id)=>state.dockedWindows.get(id);
        const getPanelContentHost = (edge)=>state.panelContentHosts.get(edge) ?? null;
        const getPanelZIndex = (edge)=>{
            const activeId = getActiveWindowOnEdge(edge);
            return activeId ? getWindowZIndex(activeId) : null;
        };
        const getPreDockRect = (id)=>state.preDockRects.get(id) ?? null;
        const getWindowConfig = (id)=>state.windowConfigs.get(id) ?? {
                title: id || "window"
            };
        const getWindowController = (id)=>windowControllers.current.get(id);
        const getWindowsOnEdge = (edge)=>Array.from(state.dockedWindows.values()).filter((window1)=>window1.edge === edge).sort((windowA, windowB)=>windowA.order - windowB.order);
        const getWindowZIndex = (id)=>{
            const index = state.zOrder.indexOf(id);
            if (index === -1) return minZIndex;
            return Math.min(maxZIndex, minZIndex + index);
        };
        const isEdgeCollapsed = (edge)=>state.collapsedEdges.has(edge);
        const registerWindowConfig = (id, config)=>{
            dispatch({
                type: "registerWindowConfig",
                id: id,
                config: config
            });
        };
        const registerWindowController = (id, controller)=>{
            windowControllers.current.set(id, controller);
        };
        const showWindowById = (id)=>{
            if (state.zOrder.includes(id)) dispatch({
                type: "raiseWindow",
                id: id
            });
        };
        const unregisterWindowController = (id)=>{
            windowControllers.current.delete(id);
        };
        return {
            maxZIndex: maxZIndex,
            minZIndex: minZIndex,
            dispatch: dispatch,
            closeWindow: closeWindow,
            getActiveWindowOnEdge: getActiveWindowOnEdge,
            getDockedWindow: getDockedWindow,
            showWindowById: showWindowById,
            getPanelContentHost: getPanelContentHost,
            getPanelZIndex: getPanelZIndex,
            getPreDockRect: getPreDockRect,
            getWindowConfig: getWindowConfig,
            getWindowController: getWindowController,
            getWindowZIndex: getWindowZIndex,
            getWindowsOnEdge: getWindowsOnEdge,
            isEdgeCollapsed: isEdgeCollapsed,
            registerWindowConfig: registerWindowConfig,
            registerWindowController: registerWindowController,
            unregisterWindowController: unregisterWindowController
        };
    }, [
        context
    ]);
};
const $41d0e28ea3e97704$var$$d59f5b924090c987$export$987ee34ae7cb65f5 = (id)=>{
    const [config, setConfig] = (0, $spJKX.useState)(()=>({
            id: id,
            value: {
                title: id || "window"
            }
        }));
    const savedPosition = (0, $spJKX.useRef)(null);
    const registerWindowConfig = (0, $spJKX.useCallback)((windowId, update)=>{
        setConfig((previous)=>{
            const current = previous.id === windowId ? previous.value : {
                title: windowId || "window"
            };
            const next = {
                ...current,
                ...update,
                canDock: false,
                canUndock: false
            };
            const unchanged = previous.id === windowId && Object.keys(next).every((key)=>Object.is(current[key], next[key]));
            return unchanged ? previous : {
                id: windowId,
                value: next
            };
        });
    }, []);
    const dispatch = (0, $spJKX.useCallback)((action)=>{
        if (action.type === "saveWindowPosition") savedPosition.current = {
            id: action.id,
            rect: action.rect
        };
    }, []);
    const getPreDockRect = (0, $spJKX.useCallback)((windowId)=>{
        return savedPosition.current?.id === windowId ? savedPosition.current.rect : null;
    }, []);
    return {
        windowConfig: config.id === id ? config.value : {
            title: id || "window"
        },
        registerWindowConfig: registerWindowConfig,
        dispatch: dispatch,
        getPreDockRect: getPreDockRect
    };
};
const $41d0e28ea3e97704$var$$84c1f233a211da19$export$162abb67c6a55c5d = (value, fallback)=>{
    if (!value?.trim()) return fallback;
    const parsed = Number(value);
    return Number.isSafeInteger(parsed) ? parsed : fallback;
};
const $41d0e28ea3e97704$var$$9163197232ab0e67$var$MIN_ATTRIBUTE = "data-acm-min-z-index";
const $41d0e28ea3e97704$var$$9163197232ab0e67$var$MAX_ATTRIBUTE = "data-acm-max-z-index";
const $41d0e28ea3e97704$var$$9163197232ab0e67$export$cb632d2e3ccab20b = ()=>{
    const body = typeof document === "undefined" ? null : document.body;
    const min = $41d0e28ea3e97704$var$$84c1f233a211da19$export$162abb67c6a55c5d(body?.getAttribute($41d0e28ea3e97704$var$$9163197232ab0e67$var$MIN_ATTRIBUTE) ?? null, $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$4f9fb66ac71c7da5);
    const maximum = $41d0e28ea3e97704$var$$84c1f233a211da19$export$162abb67c6a55c5d(body?.getAttribute($41d0e28ea3e97704$var$$9163197232ab0e67$var$MAX_ATTRIBUTE) ?? null, $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$e2f9a725ee199e81);
    const max = maximum > min ? maximum : min + $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$e2f9a725ee199e81 - $41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$4f9fb66ac71c7da5;
    return {
        min: min,
        max: max
    };
};
const $41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_COUNTER_ATTRIBUTE = "data-context-window-reset-counter";
const $41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_SOURCE_ATTRIBUTE = "data-context-window-reset-source";
const $41d0e28ea3e97704$var$$57d0b397dc76b965$export$3d74ee14e0a9c725 = (element)=>{
    const { min: min, max: max } = $41d0e28ea3e97704$var$$9163197232ab0e67$export$cb632d2e3ccab20b();
    const windows = Array.from(document.body.querySelectorAll(`[${$41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$8b1a8a6f35b93a85}]`));
    const highestOther = ()=>windows.reduce((highest, node)=>{
            const index = Number.parseInt(node.style.zIndex, 10);
            return node !== element && Number.isFinite(index) ? Math.max(highest, index) : highest;
        }, min - 1);
    let highest = highestOther();
    const reset = highest >= max;
    if (reset) {
        for (const node of windows){
            node.style.zIndex = `${min}`;
            node.setAttribute("data-context-window-min-z-index", `${min}`);
        }
        const counter = $41d0e28ea3e97704$var$$84c1f233a211da19$export$162abb67c6a55c5d(document.body.getAttribute($41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_COUNTER_ATTRIBUTE), 0);
        document.body.setAttribute($41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_COUNTER_ATTRIBUTE, `${counter + 1}`);
        if (element.id) document.body.setAttribute($41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_SOURCE_ATTRIBUTE, element.id);
        else document.body.removeAttribute($41d0e28ea3e97704$var$$57d0b397dc76b965$var$RESET_SOURCE_ATTRIBUTE);
        highest = highestOther();
    }
    const current = Number.parseInt(element.style.zIndex, 10);
    const next = reset || !Number.isFinite(current) || current <= highest ? highest + 1 : current;
    element.style.zIndex = `${next}`;
    element.setAttribute("data-context-window-min-z-index", `${min}`);
    if (reset) document.dispatchEvent(new Event($41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$a07396834f0a23c5));
    return next;
};
const $41d0e28ea3e97704$var$$0487576f420f9f67$export$6cc5c68b073b4343 = (enabled, windowRef)=>{
    const [zIndex, setZIndex] = (0, $spJKX.useState)(()=>$41d0e28ea3e97704$var$$9163197232ab0e67$export$cb632d2e3ccab20b().min);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (!enabled) return;
        const handleReset = ()=>{
            const index = Number.parseInt(windowRef.current?.style.zIndex ?? "", 10);
            setZIndex(Number.isFinite(index) ? index : $41d0e28ea3e97704$var$$9163197232ab0e67$export$cb632d2e3ccab20b().min);
        };
        document.addEventListener($41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$a07396834f0a23c5, handleReset);
        return ()=>document.removeEventListener($41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$a07396834f0a23c5, handleReset);
    }, [
        enabled,
        windowRef
    ]);
    const pushToTop = (0, $spJKX.useCallback)(()=>{
        if (enabled && windowRef.current) setZIndex($41d0e28ea3e97704$var$$57d0b397dc76b965$export$3d74ee14e0a9c725(windowRef.current));
    }, [
        enabled,
        windowRef
    ]);
    return {
        zIndex: zIndex,
        pushToTop: pushToTop
    };
};
const $41d0e28ea3e97704$var$$e5bda5e31951bbc7$export$e07b0ab38bf95de5 = (id, { onClose: onClose, onOpen: onOpen } = {})=>{
    const divRef = (0, $spJKX.useRef)(null);
    const windowRef = (0, $spJKX.useRef)(null);
    const docking = $41d0e28ea3e97704$var$$8daad186b917b55f$export$bf8fc23fb02307c1();
    const hasDocking = !!docking;
    const standalone = $41d0e28ea3e97704$var$$d59f5b924090c987$export$987ee34ae7cb65f5(id);
    const stacking = $41d0e28ea3e97704$var$$0487576f420f9f67$export$6cc5c68b073b4343(!docking, windowRef);
    const windowConfig = docking?.getWindowConfig(id) ?? standalone.windowConfig;
    const allowUndock = windowConfig.allowUndock ?? true;
    const dockable = !!docking && (windowConfig.dockable ?? true);
    const initialDockEdge = docking ? windowConfig.initialDockEdge : undefined;
    const visible = windowConfig.visible ?? false;
    const windowVisible = windowConfig.windowVisible ?? false;
    const moving = windowConfig.moving ?? false;
    const dockedWindow = docking?.getDockedWindow(id);
    const isDocked = !!dockedWindow;
    const activeDockedWindowId = isDocked && dockedWindow ? docking?.getActiveWindowOnEdge(dockedWindow.edge) ?? null : null;
    const isActiveDockedWindow = !isDocked || !dockedWindow || !activeDockedWindowId || activeDockedWindowId === id;
    const dockPanelContentHost = isDocked && dockedWindow ? docking?.getPanelContentHost(dockedWindow.edge) ?? null : null;
    const portalTarget = dockPanelContentHost ?? document.body;
    const zIndex = docking?.getWindowZIndex(id) ?? stacking.zIndex;
    const dispatch = docking?.dispatch ?? standalone.dispatch;
    const registerWindowConfig = docking?.registerWindowConfig ?? standalone.registerWindowConfig;
    const registerWindowController = docking?.registerWindowController;
    const unregisterWindowController = docking?.unregisterWindowController;
    const getPreDockRect = docking?.getPreDockRect ?? standalone.getPreDockRect;
    const raiseStandalone = stacking.pushToTop;
    const pushToTop = (0, $spJKX.useCallback)(()=>{
        if (docking) dispatch({
            type: "raiseWindow",
            id: id
        });
        else raiseStandalone();
    }, [
        docking,
        dispatch,
        id,
        raiseStandalone
    ]);
    const positionedWindowRef = (0, $spJKX.useRef)(null);
    const windowPos = (0, $spJKX.useRef)({
        x: 0,
        y: 0
    });
    const isDockedRef = (0, $spJKX.useRef)(isDocked);
    const dockingRef = (0, $spJKX.useRef)(docking);
    const undockViaActionRef = (0, $spJKX.useRef)(false);
    const pendingFloatingStyleRef = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        if (!hasDocking) return;
        dispatch({
            type: "registerWindow",
            id: id
        });
        return ()=>dispatch({
                type: "unregisterWindow",
                id: id
            });
    }, [
        dispatch,
        hasDocking,
        id
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        isDockedRef.current = isDocked;
    }, [
        isDocked
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        dockingRef.current = docking;
    }, [
        docking
    ]);
    (0, $spJKX.useEffect)(()=>()=>{
            if (isDockedRef.current) dockingRef.current?.dispatch({
                type: "undock",
                id: id
            });
        }, [
        id
    ]);
    // Apply pointer deltas directly to the floating element without a React render.
    const move = (0, $spJKX.useCallback)((x, y)=>{
        if (windowRef.current && !isDockedRef.current) {
            windowPos.current.x += x;
            windowPos.current.y += y;
            windowRef.current.style.transform = `translate(${windowPos.current.x}px, ${windowPos.current.y}px)`;
        }
    }, []);
    // Persist visibility changes in the provider's window config.
    const setWindowVisible = (0, $spJKX.useCallback)((nextValue)=>registerWindowConfig(id, {
            windowVisible: nextValue
        }), [
        id,
        registerWindowConfig
    ]);
    // Persist movement state so the title bar and window style stay in sync.
    const setMoving = (0, $spJKX.useCallback)((nextValue)=>registerWindowConfig(id, {
            moving: nextValue
        }), [
        id,
        registerWindowConfig
    ]);
    // Preserve the floating rect before docking so the window can be restored later.
    const handleDock = (0, $spJKX.useCallback)((edge)=>{
        if (!hasDocking) return;
        if (!windowRef.current) {
            dispatch({
                type: "dock",
                id: id,
                edge: edge
            });
            return;
        }
        const rect = isDocked ? null : windowRef.current.getBoundingClientRect();
        dispatch({
            type: "dock",
            id: id,
            edge: edge,
            preDockRect: rect && {
                x: rect.left + window.scrollX,
                y: rect.top + window.scrollY,
                width: rect.width,
                height: rect.height
            }
        });
    }, [
        dispatch,
        hasDocking,
        id,
        isDocked
    ]);
    // Capture the pending floating placement before removing the window from its panel.
    const handleUndock = (0, $spJKX.useCallback)((pointer)=>{
        if (!isDocked || !allowUndock) return;
        const restoreState = getPreDockRect(id);
        if (pointer) pendingFloatingStyleRef.current = {
            left: pointer.x,
            top: pointer.y,
            width: restoreState?.width,
            height: restoreState?.height,
            anchorToPointer: true
        };
        else if (restoreState) pendingFloatingStyleRef.current = {
            left: restoreState.x,
            top: restoreState.y,
            width: restoreState.width,
            height: restoreState.height
        };
        else pendingFloatingStyleRef.current = {
            left: 0,
            top: 0,
            centerInViewport: true
        };
        undockViaActionRef.current = !pointer;
        dispatch({
            type: "undock",
            id: id,
            viaDrag: !!pointer
        });
    }, [
        allowUndock,
        dispatch,
        getPreDockRect,
        id,
        isDocked
    ]);
    // Guard controller docking actions against stale controls and non-dockable windows.
    const onDock = (0, $spJKX.useCallback)((edge)=>{
        if (dockable && !isDockedRef.current) handleDock(edge);
    }, [
        dockable,
        handleDock
    ]);
    // Guard controller undocking actions against stale controls and locked windows.
    const onUndock = (0, $spJKX.useCallback)(()=>{
        if (dockable && allowUndock && isDockedRef.current) handleUndock();
    }, [
        allowUndock,
        dockable,
        handleUndock
    ]);
    const { onTitleMouseDown: onTitleMouseDown, armInteractionEnd: armInteractionEnd, lastMousePosRef: lastMousePosRef } = $41d0e28ea3e97704$var$$5beb376faad492b0$export$33c22f8d38d5ec2({
        id: id,
        dockable: dockable,
        dockingEnabled: !!docking,
        pushToTop: pushToTop,
        allowUndock: allowUndock,
        isDocked: isDocked,
        dockedEdge: dockedWindow?.edge,
        windowVisible: windowVisible,
        moving: moving,
        windowRef: windowRef,
        windowPosRef: windowPos,
        isDockedRef: isDockedRef,
        dispatch: dispatch,
        move: move,
        setMoving: setMoving,
        setWindowVisible: setWindowVisible,
        handleDock: handleDock,
        handleUndock: handleUndock
    });
    (0, $spJKX.useEffect)(()=>{
        if (!visible && isDocked) dispatch({
            type: "undock",
            id: id
        });
    }, [
        dispatch,
        id,
        isDocked,
        visible
    ]);
    // Apply initial docking before paint so the window never flashes as floating.
    const initialDockAppliedRef = (0, $spJKX.useRef)(false);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (!visible) {
            initialDockAppliedRef.current = false;
            return;
        }
        if (initialDockEdge && !initialDockAppliedRef.current) {
            initialDockAppliedRef.current = true;
            if (!isDockedRef.current) dispatch({
                type: "dock",
                id: id,
                edge: initialDockEdge
            });
        }
    }, [
        dispatch,
        id,
        initialDockEdge,
        visible
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!visible && windowVisible) setWindowVisible(false);
    }, [
        visible,
        windowVisible,
        setWindowVisible
    ]);
    // Save the final floating rect while the detached node is still measurable.
    const setWindowNode = (0, $spJKX.useCallback)((node)=>{
        windowRef.current = node;
        if (!node) return;
        if (!hasDocking) node.setAttribute($41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$8b1a8a6f35b93a85, "true");
        else node.removeAttribute($41d0e28ea3e97704$var$$5fbd1a62a2c5779a$export$8b1a8a6f35b93a85);
        return ()=>{
            windowRef.current = null;
            if (isDockedRef.current || positionedWindowRef.current !== node) return;
            positionedWindowRef.current = null;
            const rect = node.getBoundingClientRect();
            if (rect.width === 0 && rect.height === 0) return;
            dispatch({
                type: "saveWindowPosition",
                id: id,
                rect: {
                    x: rect.left + window.scrollX,
                    y: rect.top + window.scrollY,
                    width: rect.width,
                    height: rect.height
                }
            });
        };
    }, [
        dispatch,
        hasDocking,
        id
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (visible && !windowVisible && windowRef.current) {
            if (!isDockedRef.current) {
                const savedRect = getPreDockRect(id);
                windowPos.current = $41d0e28ea3e97704$var$$08f56600d1771fb2$export$e7a24757611c6a37(windowRef.current, savedRect);
                positionedWindowRef.current = windowRef.current;
            }
            onOpen?.();
            pushToTop();
            setWindowVisible(true);
        }
    }, [
        getPreDockRect,
        id,
        onOpen,
        pushToTop,
        setWindowVisible,
        visible,
        windowVisible
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!windowVisible || !windowRef.current || typeof ResizeObserver === "undefined") return;
        const observer = new ResizeObserver(()=>armInteractionEnd());
        observer.observe(windowRef.current);
        return ()=>observer.disconnect();
    }, [
        armInteractionEnd,
        windowVisible
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (isDocked && windowRef.current) {
            windowRef.current.style.left = "";
            windowRef.current.style.top = "";
            windowRef.current.style.transform = "";
            windowPos.current = {
                x: 0,
                y: 0
            };
        }
    }, [
        id,
        isDocked,
        moving
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        const pending = pendingFloatingStyleRef.current;
        if (isDocked || !pending || !windowRef.current) return;
        pendingFloatingStyleRef.current = null;
        const element = windowRef.current;
        $41d0e28ea3e97704$var$$c84264d31d035fb5$export$1f4588fc9076f828(element, pending, lastMousePosRef.current);
        windowPos.current = {
            x: 0,
            y: 0
        };
        if (undockViaActionRef.current) {
            undockViaActionRef.current = false;
            $41d0e28ea3e97704$var$$1d453c921d235704$export$1e4ae39bb8625cc1(windowRef, move);
        }
        positionedWindowRef.current = element;
    });
    // Raise the window when its surface is clicked and activate it within its dock edge.
    const handleWindowClick = (0, $spJKX.useCallback)((event)=>{
        if (event.currentTarget.contains(event.target)) {
            if (isDocked && dockedWindow && activeDockedWindowId !== id) dispatch({
                type: "setActiveWindowOnEdge",
                edge: dockedWindow.edge,
                id: id
            });
            pushToTop();
        }
    }, [
        activeDockedWindowId,
        dispatch,
        dockedWindow,
        id,
        isDocked,
        pushToTop
    ]);
    // Preserve the action-based undock behavior for the imperative handle.
    const undock = (0, $spJKX.useCallback)(()=>handleUndock(), [
        handleUndock
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        const controller = {
            windowRef: windowRef,
            onClose: onClose,
            onOpen: onOpen,
            onMouseDown: onTitleMouseDown,
            onDock: onDock,
            onUndock: onUndock
        };
        registerWindowController?.(id, controller);
        return ()=>unregisterWindowController?.(id);
    }, [
        id,
        onClose,
        onDock,
        onOpen,
        onTitleMouseDown,
        onUndock,
        registerWindowController,
        unregisterWindowController,
        windowRef
    ]);
    return {
        dock: handleDock,
        dockedWindow: dockedWindow,
        divRef: divRef,
        handleWindowClick: handleWindowClick,
        isActiveDockedWindow: isActiveDockedWindow,
        isDocked: isDocked,
        moving: moving,
        onTitleMouseDown: onTitleMouseDown,
        portalTarget: portalTarget,
        pushToTop: pushToTop,
        registerWindowConfig: registerWindowConfig,
        onDock: onDock,
        onUndock: onUndock,
        onClose: onClose,
        setWindowNode: setWindowNode,
        undock: undock,
        windowConfig: windowConfig,
        windowVisible: windowVisible,
        windowRef: windowRef,
        zIndex: zIndex
    };
};
const $41d0e28ea3e97704$export$a3af73b13b2dc8c7 = ()=>{
    const docking = $41d0e28ea3e97704$var$$8daad186b917b55f$export$bf8fc23fb02307c1();
    if (!docking) throw new Error("useDocking must be used within a DockingProvider");
    return docking;
};
const $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$var$KEYBOARD_STEP = 10;
const $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$var$KEYBOARD_LARGE_STEP = 50;
const $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$export$29ee659ed4badccd = (edge, panelRef, onResizeStart, initialSize = null)=>{
    const [panelSize, setPanelSize] = (0, $spJKX.useState)(()=>initialSize === null ? null : $41d0e28ea3e97704$var$$acd9a92a5e458e67$export$d80c2d434e31f05c(edge, initialSize));
    const [isResizing, setIsResizing] = (0, $spJKX.useState)(false);
    const resizeCleanupRef = (0, $spJKX.useRef)(null);
    const getCurrentSize = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore next */ if (!panelRef.current) return $41d0e28ea3e97704$var$$862ad0fd74423c06$export$bbd25dc97cf925d5;
        const rect = panelRef.current.getBoundingClientRect();
        return $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526(edge) ? rect.width : rect.height;
    }, [
        edge,
        panelRef
    ]);
    const handleResizeMouseDown = (0, $spJKX.useCallback)((e)=>{
        if (e.button !== 0) return;
        e.preventDefault();
        e.stopPropagation();
        onResizeStart();
        const startX = e.clientX;
        const startY = e.clientY;
        const startSize = getCurrentSize();
        const previousCursor = document.body.style.cursor;
        const previousUserSelect = document.body.style.userSelect;
        document.body.style.cursor = $41d0e28ea3e97704$var$$89394849a72dbdf6$export$cfffc9f7f5ad6526(edge) ? "col-resize" : "row-resize";
        document.body.style.userSelect = "none";
        setIsResizing(true);
        const onMouseMove = (moveEvent)=>{
            const delta = $41d0e28ea3e97704$var$$d0f18e2b9990ccc1$export$b761f7e9cb0ead3d(edge, moveEvent.clientX - startX, moveEvent.clientY - startY);
            setPanelSize($41d0e28ea3e97704$var$$acd9a92a5e458e67$export$d80c2d434e31f05c(edge, startSize + delta));
        };
        const cleanup = ()=>{
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", cleanup);
            document.body.style.cursor = previousCursor;
            document.body.style.userSelect = previousUserSelect;
            resizeCleanupRef.current = null;
            setIsResizing(false);
        };
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", cleanup);
        resizeCleanupRef.current = cleanup;
    }, [
        edge,
        getCurrentSize,
        onResizeStart
    ]);
    const handleResizeKeyDown = (0, $spJKX.useCallback)((e)=>{
        const step = e.shiftKey ? $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$var$KEYBOARD_LARGE_STEP : $41d0e28ea3e97704$var$$f9a14a992c4ddbb7$var$KEYBOARD_STEP;
        const keyDeltas = {
            ArrowLeft: [
                -step,
                0
            ],
            ArrowRight: [
                step,
                0
            ],
            ArrowUp: [
                0,
                -step
            ],
            ArrowDown: [
                0,
                step
            ]
        };
        const keyDelta = keyDeltas[e.key];
        if (!keyDelta) return;
        const delta = $41d0e28ea3e97704$var$$d0f18e2b9990ccc1$export$b761f7e9cb0ead3d(edge, keyDelta[0], keyDelta[1]);
        if (delta === 0) return;
        e.preventDefault();
        onResizeStart();
        setPanelSize($41d0e28ea3e97704$var$$acd9a92a5e458e67$export$d80c2d434e31f05c(edge, getCurrentSize() + delta));
    }, [
        edge,
        getCurrentSize,
        onResizeStart
    ]);
    (0, $spJKX.useEffect)(()=>{
        return ()=>{
            resizeCleanupRef.current?.();
        };
    }, []);
    return {
        panelSize: panelSize,
        isResizing: isResizing,
        handleResizeMouseDown: handleResizeMouseDown,
        handleResizeKeyDown: handleResizeKeyDown
    };
};
const $41d0e28ea3e97704$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e = ({ entries: entries, toClose: toClose, visible: visible })=>{
    return (0, $bR5nk.jsxs)("span", {
        className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).caretHolder,
        children: [
            (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$3b28b85e28627662$export$5e4a7579d3e78657, {}),
            visible && (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).subMenu,
                children: (0, $bR5nk.jsx)($41d0e28ea3e97704$export$8dc6765e8be191c7, {
                    visible: true,
                    entries: entries,
                    xPos: 14,
                    yPos: -21,
                    toClose: toClose
                })
            })
        ]
    });
};
$41d0e28ea3e97704$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e.displayName = "ContextSubMenu";
const $41d0e28ea3e97704$var$$813754bb7a4251f1$export$c868ef28d2ba36f1 = ({ entry: entry, selectedSpace: selectedSpace, toClose: toClose })=>{
    const [target, setTarget] = (0, $spJKX.useState)(null);
    const [subMenuVisible, setSubMenuVisible] = (0, $spJKX.useState)(false);
    return (0, $bR5nk.jsxs)("div", {
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).contextMenuItem, entry.disabled && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).disabled),
        onMouseEnter: entry.group ? ()=>{
            setSubMenuVisible(true);
        } : undefined,
        onMouseLeave: entry.group ? ()=>{
            setSubMenuVisible(false);
        } : undefined,
        children: [
            selectedSpace && (0, $bR5nk.jsx)("span", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).contextMenuItemCheck,
                "aria-hidden": "true",
                children: entry.selected ? entry.selectedIcon ?? "\u2713" : "\u00a0"
            }),
            typeof entry.label === "string" ? (0, $bR5nk.jsx)("span", {
                "aria-label": entry.label,
                "aria-disabled": entry.disabled,
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).contextMenuItemLabel,
                onMouseEnter: ()=>{
                    const selection = window.getSelection();
                    const target = selection?.rangeCount ? selection.getRangeAt(0) : null;
                    setTarget(target);
                },
                onMouseLeave: ()=>{
                    setTarget(null);
                },
                onMouseDownCapture: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    /* istanbul ignore else */ if (!entry.disabled) {
                        /* istanbul ignore else */ if (entry.action) entry.action(target, e);
                        toClose();
                    }
                },
                children: entry.label
            }) : entry.label,
            entry.group && (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$6ca59110355c8bf1$export$7e4e6110f96afd7e, {
                toClose: toClose,
                entries: entry.group,
                visible: subMenuVisible
            })
        ]
    });
};
// Constants for menu size estimation when ref is not yet available
const $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT = 34;
const $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING = 4;
const $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH = 200;
const $41d0e28ea3e97704$export$8dc6765e8be191c7 = (0, $spJKX.forwardRef)(({ visible: visible, entries: entries, xPos: xPos, yPos: yPos, toClose: toClose }, ref)=>{
    // Measure menu size after mount/render to avoid accessing refs during render
    const [menuHeight, setMenuHeight] = (0, $spJKX.useState)(entries.length * $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT + $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING);
    const [menuWidth, setMenuWidth] = (0, $spJKX.useState)($41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH);
    (0, $spJKX.useLayoutEffect)(()=>{
        // Only measure when visible; ref access inside effect is allowed
        if (visible && ref && typeof ref !== "function" && ref.current instanceof HTMLDivElement) {
            setMenuHeight(ref.current.offsetHeight);
            setMenuWidth(ref.current.offsetWidth);
        }
        // When not visible, fall back to estimates
        if (!visible) {
            setMenuHeight(entries.length * $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_ITEM_HEIGHT + $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING);
            setMenuWidth($41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_WIDTH);
        }
    }, [
        visible,
        entries,
        ref
    ]);
    const adjustedYPos = yPos + menuHeight > window.innerHeight ? Math.max(window.innerHeight - menuHeight - $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING, 0) : yPos;
    const adjustedXPos = xPos + menuWidth > window.innerWidth ? Math.max(window.innerWidth - menuWidth - $41d0e28ea3e97704$var$$567ed433af94513f$var$ESTIMATED_MENU_PADDING, 0) : xPos;
    const selectedSpace = entries.some((e)=>e.selected !== undefined);
    return (0, $bR5nk.jsx)("div", {
        ref: ref,
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).contextMenu, visible ? /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).visible : /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).hidden),
        style: {
            top: `${adjustedYPos}px`,
            left: `${adjustedXPos}px`
        },
        onContextMenu: (e)=>{
            e.preventDefault();
            e.stopPropagation();
        },
        children: entries.map((entry, i)=>$41d0e28ea3e97704$var$$1e1c1e9e0b943830$export$c5c72b048734faff(entry.label) ? (0, $bR5nk.jsx)((0, $spJKX.Fragment), {
                children: entry.label
            }, i) : (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$813754bb7a4251f1$export$c868ef28d2ba36f1, {
                entry: entry,
                selectedSpace: selectedSpace,
                toClose: toClose
            }, i))
    });
});
$41d0e28ea3e97704$export$8dc6765e8be191c7.displayName = "ContextMenu";
const $41d0e28ea3e97704$export$d4ebdd58e04c6ace = ({ id: id, menuItems: menuItems, children: children, ...rest })=>{
    // Menu state
    const [menuInDom, setMenuInDom] = (0, $spJKX.useState)(false);
    const [menuVisible, setMenuVisible] = (0, $spJKX.useState)(false);
    const [menuXPos, setMenuXPos] = (0, $spJKX.useState)(0);
    const [menuYPos, setMenuYPos] = (0, $spJKX.useState)(0);
    // Set up outsideClick handler
    const menuRef = (0, $spJKX.useRef)(null);
    // Handle click off the menu
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleClick = (e)=>{
        /* istanbul ignore else */ if (menuRef.current && (e.target instanceof Element && !menuRef.current.contains(e.target) || !(e.target instanceof Element))) setMenuInDom(false);
    };
    const removeController = (0, $spJKX.useRef)(null);
    const removeTimeoutRef = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        if (!menuVisible && removeTimeoutRef.current === null) {
            // Only create a new controller when scheduling a new timeout
            if (removeController.current) removeController.current.abort();
            removeController.current = new AbortController();
            const controller = removeController.current;
            // Set up the timeout with a reference to the current controller
            removeTimeoutRef.current = setTimeout(()=>{
                if (!controller.signal.aborted) setMenuInDom(false);
                removeTimeoutRef.current = null;
            }, 300);
        }
        return ()=>{
            // Clean up on unmount or when menuVisible changes
            if (removeTimeoutRef.current) {
                clearTimeout(removeTimeoutRef.current);
                removeTimeoutRef.current = null;
            }
        };
    }, [
        menuVisible
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (menuInDom) document.addEventListener("mousedown", handleClick);
        return ()=>{
            document.removeEventListener("mousedown", handleClick);
            /* istanbul ignore else */ if (removeController.current) removeController.current.abort();
        };
    }, [
        handleClick,
        menuInDom
    ]);
    return (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            (0, $bR5nk.jsx)("div", {
                ...rest,
                id: id,
                onClick: (e)=>{
                    if (menuItems) {
                        setMenuInDom(true);
                        e.preventDefault();
                        e.stopPropagation();
                        setTimeout(()=>{
                            /* istanbul ignore else */ if (removeController.current) removeController.current.abort();
                            setMenuVisible(true);
                            setMenuXPos(e.pageX);
                            setMenuYPos(e.pageY);
                        }, 1);
                    } else rest.onClick?.(e);
                },
                children: children
            }),
            menuInDom && menuItems && (0, $oS63j.createPortal)((0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$47067f35ca62d4a5$exports).anchor,
                children: (0, $bR5nk.jsx)($41d0e28ea3e97704$export$8dc6765e8be191c7, {
                    visible: menuVisible,
                    ref: menuRef,
                    entries: menuItems,
                    xPos: menuXPos,
                    yPos: menuYPos,
                    toClose: ()=>{
                        setMenuVisible(false);
                        setMenuInDom(false);
                    }
                })
            }), document.body)
        ]
    });
};
$41d0e28ea3e97704$export$d4ebdd58e04c6ace.displayName = "ClickForMenu";
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$exports = {};
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindow", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowAnchor", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowBody", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowTitle", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowTitleButtons", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$2a1d867301054bc7;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$2a1d867301054bc7 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowTitleClose", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "contextWindowTitleText", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$cebbac70b4d99c48;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$cebbac70b4d99c48 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockButton", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$df6423883c32ca3c;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$df6423883c32ca3c = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "docked", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$e53b60adc1718bcc;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$e53b60adc1718bcc = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockedBottom", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$22f524431905d89c;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$22f524431905d89c = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockedCollapsed", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$31f417ddb84b8bba;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$31f417ddb84b8bba = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockedLeft", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7d7bfeeab5caf5df;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7d7bfeeab5caf5df = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockedRight", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$64b0341db20b6cb7;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$64b0341db20b6cb7 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "dockedTop", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$b92e8d0892391948;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$b92e8d0892391948 = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "moving", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$d03a2f3acc60252b;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$d03a2f3acc60252b = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "undockButton", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$950ac76bce8c5fad;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$950ac76bce8c5fad = v;
});
$41d0e28ea3e97704$var$$parcel$export($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports, "undockDisabled", function() {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9bf9684b7c245e6b;
}, function(v) {
    return $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9bf9684b7c245e6b = v;
});
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$2a1d867301054bc7;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$cebbac70b4d99c48;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$df6423883c32ca3c;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$e53b60adc1718bcc;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$22f524431905d89c;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$31f417ddb84b8bba;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7d7bfeeab5caf5df;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$64b0341db20b6cb7;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$b92e8d0892391948;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$d03a2f3acc60252b;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$950ac76bce8c5fad;
var $41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9bf9684b7c245e6b;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$72cad2e5ad4d2674 = `acxtm-ContextWindow-module-contextWindow`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9f3a8a17ac700f7d = `acxtm-ContextWindow-module-contextWindowAnchor`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$dfb2c4d2d1c0156f = `acxtm-ContextWindow-module-contextWindowBody`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$1b02f2cd2f7db0f4 = `acxtm-ContextWindow-module-contextWindowTitle`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$2a1d867301054bc7 = `acxtm-ContextWindow-module-contextWindowTitleButtons`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7ba38d4cc2870e66 = `acxtm-ContextWindow-module-contextWindowTitleClose`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$cebbac70b4d99c48 = `acxtm-ContextWindow-module-contextWindowTitleText`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$df6423883c32ca3c = `acxtm-ContextWindow-module-dockButton`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$e53b60adc1718bcc = `acxtm-ContextWindow-module-docked`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$22f524431905d89c = `acxtm-ContextWindow-module-dockedBottom`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$31f417ddb84b8bba = `acxtm-ContextWindow-module-dockedCollapsed`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$7d7bfeeab5caf5df = `acxtm-ContextWindow-module-dockedLeft`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$64b0341db20b6cb7 = `acxtm-ContextWindow-module-dockedRight`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$b92e8d0892391948 = `acxtm-ContextWindow-module-dockedTop`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$d03a2f3acc60252b = `acxtm-ContextWindow-module-moving`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$950ac76bce8c5fad = `acxtm-ContextWindow-module-undockButton`;
$41d0e28ea3e97704$var$$ddf7153c7c69b209$export$9bf9684b7c245e6b = `acxtm-ContextWindow-module-undockDisabled`;
const $41d0e28ea3e97704$var$$9dbd8a6db1a2e5fe$export$36ea48aa761313d1 = ({ className: className, label: label, title: title, onClick: onClick, children: children })=>{
    const handleClick = (event)=>{
        event.stopPropagation();
        onClick?.();
    };
    return (0, $bR5nk.jsx)("div", {
        className: className,
        role: "button",
        "aria-label": label,
        onMouseDown: (event)=>event.stopPropagation(),
        onClick: handleClick,
        title: title,
        children: children
    });
};
const $41d0e28ea3e97704$var$$ab0add082f3a5a8e$export$5150fb64544038ef = ({ window: window1 })=>{
    const config = window1.windowConfig;
    const { defaultDockEdge: defaultDockEdge = "right", moving: moving, title: title, titleBarButtons: titleBarButtons, titleElement: titleElement, canDock: canDock, canUndock: canUndock, canClose: canClose } = config;
    const windowLabel = title && title.trim() !== "" ? title : "window";
    const undockDisabled = config.allowUndock === false && window1.isDocked;
    return (0, $bR5nk.jsxs)("div", {
        className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowTitle, moving && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).moving, undockDisabled && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).undockDisabled),
        onMouseDown: window1.onTitleMouseDown,
        children: [
            (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowTitleText,
                title: title,
                children: titleElement ? titleElement : title
            }),
            canDock && (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$9dbd8a6db1a2e5fe$export$36ea48aa761313d1, {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).dockButton,
                label: "Dock",
                title: `Dock ${windowLabel}`,
                onClick: ()=>window1.onDock(defaultDockEdge),
                children: (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$4fb973ad4cb4e151$export$d73250f348fbe223, {
                    size: 14,
                    edge: defaultDockEdge
                })
            }),
            canUndock && (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$9dbd8a6db1a2e5fe$export$36ea48aa761313d1, {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).undockButton,
                label: "Undock",
                title: `Undock ${windowLabel}`,
                onClick: window1.onUndock,
                children: (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$875bf51c800fe6dc$export$76d7b85b3941290e, {
                    size: 14
                })
            }),
            titleBarButtons !== undefined && titleBarButtons !== null && (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowTitleButtons,
                onMouseDown: (event)=>event.stopPropagation(),
                onPointerDown: (event)=>event.stopPropagation(),
                onClick: (event)=>event.stopPropagation(),
                children: titleBarButtons
            }),
            canClose && (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$9dbd8a6db1a2e5fe$export$36ea48aa761313d1, {
                className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowTitleClose,
                label: "Close",
                title: `Close ${windowLabel}`,
                onClick: window1.onClose,
                children: (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$b10722879a80d7fe$export$cae179f078f4b4a4, {})
            })
        ]
    });
};
const $41d0e28ea3e97704$var$$b5e8657823def5be$var$dockedEdgeClassNames = {
    top: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).dockedTop,
    bottom: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).dockedBottom,
    left: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).dockedLeft,
    right: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).dockedRight
};
const $41d0e28ea3e97704$export$1af8984c69ba1b24 = (0, $spJKX.forwardRef)(({ allowUndock: allowUndock = true, children: children, defaultDockEdge: defaultDockEdge = "right", dockable: dockable = true, id: id, initialDockEdge: initialDockEdge, onClose: onClose, onOpen: onOpen, title: title, titleBarButtons: titleBarButtons, titleElement: titleElement, visible: visible, ...rest }, ref)=>{
    const window1 = $41d0e28ea3e97704$var$$e5bda5e31951bbc7$export$e07b0ab38bf95de5(id, {
        onClose: onClose,
        onOpen: onOpen
    });
    const { isDocked: isDocked, registerWindowConfig: registerWindowConfig } = window1;
    (0, $spJKX.useLayoutEffect)(()=>{
        registerWindowConfig(id, {
            id: id,
            visible: visible,
            title: title,
            titleBarButtons: titleBarButtons,
            titleElement: titleElement,
            dockable: dockable,
            defaultDockEdge: defaultDockEdge,
            initialDockEdge: initialDockEdge,
            allowUndock: allowUndock,
            canClose: onClose !== undefined,
            canDock: dockable && !isDocked,
            canUndock: dockable && isDocked && allowUndock
        });
    }, [
        allowUndock,
        defaultDockEdge,
        dockable,
        id,
        initialDockEdge,
        onClose,
        title,
        titleBarButtons,
        titleElement,
        visible,
        isDocked,
        registerWindowConfig
    ]);
    (0, $spJKX.useImperativeHandle)(ref, ()=>({
            pushToTop: window1.pushToTop,
            dock: window1.dock,
            undock: window1.undock
        }), [
        window1.dock,
        window1.pushToTop,
        window1.undock
    ]);
    return (0, $bR5nk.jsx)("div", {
        className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowAnchor,
        ref: window1.divRef,
        children: visible && (0, $oS63j.createPortal)((0, $bR5nk.jsxs)("div", {
            ...rest,
            ref: window1.setWindowNode,
            id: id,
            className: $41d0e28ea3e97704$var$$a14ffc6cf2ad5acf$export$ce4ab0c55987d1ff(/*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindow, window1.isDocked && /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).docked, window1.isDocked && window1.dockedWindow && $41d0e28ea3e97704$var$$b5e8657823def5be$var$dockedEdgeClassNames[window1.dockedWindow.edge], rest.className),
            style: {
                ...window1.isDocked ? {} : rest.style,
                opacity: window1.moving ? 0.8 : window1.windowVisible ? 1 : 0,
                visibility: window1.windowVisible ? "visible" : "hidden",
                display: window1.isDocked ? window1.isActiveDockedWindow ? "flex" : "none" : rest.style?.display,
                zIndex: window1.zIndex,
                minHeight: window1.isDocked ? "auto" : rest.style?.minHeight ?? "150px",
                minWidth: window1.isDocked ? "auto" : rest.style?.minWidth ?? "200px",
                maxHeight: window1.isDocked ? "100%" : rest.style?.maxHeight ?? "1000px",
                maxWidth: window1.isDocked ? "100%" : rest.style?.maxWidth ?? "1000px",
                width: window1.isDocked ? "100%" : rest.style?.width,
                height: window1.isDocked ? "100%" : rest.style?.height
            },
            onClickCapture: (event)=>{
                window1.handleWindowClick(event);
                rest.onClickCapture?.(event);
            },
            children: [
                (0, $bR5nk.jsx)($41d0e28ea3e97704$var$$ab0add082f3a5a8e$export$5150fb64544038ef, {
                    window: window1
                }),
                (0, $bR5nk.jsx)("div", {
                    className: /*@__PURE__*/ $41d0e28ea3e97704$var$$parcel$interopDefault($41d0e28ea3e97704$var$$ddf7153c7c69b209$exports).contextWindowBody,
                    children: (0, $bR5nk.jsx)("div", {
                        children: children
                    })
                })
            ]
        }), window1.portalTarget)
    });
});
$41d0e28ea3e97704$export$1af8984c69ba1b24.displayName = "ContextWindow";

});



parcelRegister("kHJeU", function(module, exports) {

$parcel$export(module.exports, "AioNumber", function () { return $d37fd802c0e5b3df$export$34024c4c1ca38817; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $9Osbv = parcelRequire("9Osbv");
const $d37fd802c0e5b3df$export$34024c4c1ca38817 = (props)=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [value, setValue] = (0, $spJKX.useState)(props.value);
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>setValue(Math.max(props.minValue ?? -Infinity, Math.min(props.maxValue ?? Infinity, props.value))));
    }, [
        props.maxValue,
        props.minValue,
        props.value
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9Osbv.AioLabel), {
                id: `${props.id}-label`,
                label: props.label,
                htmlFor: props.id
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInputHolder,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                    id: props.id,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInput,
                    "aria-labelledby": `${props.id}-label`,
                    value: `${value}`,
                    type: "number",
                    disabled: !props.setValue,
                    onChange: (e)=>setValue(parseFloat(e.currentTarget.value)),
                    onBlur: ()=>props.setValue?.(value),
                    step: props.step,
                    min: props.minValue,
                    max: props.maxValue
                })
            })
        ]
    });
};
$d37fd802c0e5b3df$export$34024c4c1ca38817.displayName = "AioNumber";

});

parcelRegister("7na6X", function(module, exports) {

$parcel$export(module.exports, "AioReplacementDisplay", function () { return $7424f1aae5f97b60$export$6079dbe36a5ae246; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");
var $8FniJ = parcelRequire("8FniJ");

var $3tKzd = parcelRequire("3tKzd");

var $fUdFB = parcelRequire("fUdFB");

var $biia9 = parcelRequire("biia9");

var $4F320 = parcelRequire("4F320");

var $76A43 = parcelRequire("76A43");
const $7424f1aae5f97b60$export$6079dbe36a5ae246 = ({ id: id, airid: airid, oldText: oldText, newTexts: newTexts, includeTrailing: includeTrailing, externalName: externalName, setReplacement: setReplacement, externalLists: externalLists, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, noText: noText, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), level: level })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [displayText, setDisplayText] = (0, $spJKX.useState)((0, $8FniJ.fromHtml)(oldText));
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>setDisplayText((0, $8FniJ.fromHtml)(oldText)));
    }, [
        oldText
    ]);
    const availableListNames = (0, $spJKX.useMemo)(()=>{
        const a = [
            "with..."
        ];
        const exl = [];
        externalLists?.map((rep)=>{
            exl.push(rep.givenName);
            return true;
        });
        a.push(...exl.sort((a, b)=>a.localeCompare(b)));
        return a;
    }, [
        externalLists
    ]);
    /**
   * Return updated replacement object
   *
   * @param newReplacement - Partial replacement object with updated values
   */ const returnData = (newReplacement)=>{
        /* istanbul ignore else */ if (setReplacement) {
            // Create new object
            const r = {
                airid: airid ?? crypto.randomUUID(),
                oldText: oldText,
                newTexts: newTexts,
                includeTrailing: includeTrailing,
                externalName: externalName,
                ...newReplacement
            };
            // Remove default
            if (r.externalName === "with...") delete r.externalName;
            // Update existing object
            setReplacement(r);
        }
    };
    /**
   * Add new text entry
   *
   * @param i - Index to add at
   */ const addNewText = (i)=>{
        /* istanbul ignore else */ if (setReplacement) {
            const nts = [
                ...newTexts
            ];
            nts.splice(i, 0, (0, $76A43.newReplacementValues)(editorProps.blankT));
            returnData({
                newTexts: nts
            });
        }
    };
    /**
   * Remove new text entry
   *
   * @param i - Index to remove at
   */ const removeNewText = (i)=>{
        /* istanbul ignore else */ if (setReplacement) {
            const nts = [
                ...newTexts
            ];
            nts.splice(i, 1);
            returnData({
                newTexts: nts
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).replacementContainer,
        children: [
            !noText && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                children: [
                    typeof setReplacement !== "function" ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        children: `${oldText}`.trim() !== "" ? (0, $8FniJ.fromHtml)(oldText) : /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                            children: "Nothing"
                        })
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                        id: `${id}-input`,
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInput,
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).width170
                        ]),
                        type: "text",
                        value: displayText,
                        onChange: (e)=>setDisplayText(e.currentTarget.value),
                        onBlur: (e)=>{
                            returnData({
                                oldText: (0, $8FniJ.toHtml)(e.currentTarget.value)
                            });
                        }
                    }),
                    !dontAskTrail && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).replacementButtonArea,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                                htmlFor: `${id}-includetrailing`,
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                                    children: "Include trailing rows"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                                id: `${id}-includetrailing`,
                                disabled: typeof setReplacement !== "function",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).margin6,
                                type: "checkbox",
                                checked: includeTrailing,
                                onChange: (e)=>returnData({
                                        includeTrailing: e.currentTarget.checked
                                    })
                            })
                        ]
                    })
                ]
            }),
            typeof setReplacement === "function" && externalLists !== undefined && externalLists.length > 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fUdFB.AioDropSelect), {
                    id: `${id}-dropselect`,
                    value: !externalName ? "with..." : externalName,
                    availableValues: availableListNames,
                    setValue: (ret)=>{
                        returnData({
                            externalName: ret
                        });
                    }
                })
            }) : externalName !== undefined && externalName !== "" ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).fontItalic,
                children: externalName
            }) : null,
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: externalLists?.some((e)=>e.givenName === externalName) ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                    children: externalLists?.find((e)=>e.givenName === externalName)?.newTexts.map((e)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $4F320.AioReplacementValuesDisplay), {
                            id: `${id}-subdisplay`,
                            airid: e.airid,
                            texts: e.texts,
                            spaceAfter: e.spaceAfter,
                            subLists: e.subLists,
                            editorProps: editorProps,
                            level: level
                        }, e.airid))
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                    children: newTexts.map((rv, i)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4F320.AioReplacementValuesDisplay), {
                                    id: `${id}-subdisplay`,
                                    airid: rv.airid,
                                    texts: rv.texts,
                                    spaceAfter: rv.spaceAfter,
                                    subLists: rv.subLists,
                                    externalLists: externalLists,
                                    dontAskSpace: dontAskSpace,
                                    dontAskTrail: typeof setReplacement === "function" ? dontAskTrail : true,
                                    setReplacementValue: typeof setReplacement === "function" ? (ret)=>{
                                        const nts = [
                                            ...newTexts
                                        ];
                                        nts.splice(i, 1, ret);
                                        returnData({
                                            newTexts: nts
                                        });
                                    } : undefined,
                                    editorProps: editorProps,
                                    level: level
                                }, rv.airid),
                                typeof setReplacement === "function" && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                    className: (0, $3tKzd.classMerge)([
                                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButtonHolder,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).replacementRowIndented
                                    ]),
                                    children: [
                                        newTexts && newTexts.length > 1 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                                            id: `${id}-remove`,
                                            iconName: "aioxRemoveUp",
                                            onClick: ()=>removeNewText(i),
                                            tipText: "Remove new text"
                                        }),
                                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                                            id: `${id}-add`,
                                            iconName: "aioxAddDown",
                                            onClick: ()=>addNewText(i + 1),
                                            tipText: "Add new text"
                                        })
                                    ]
                                })
                            ]
                        }, `${i}-${rv.airid}`))
                })
            })
        ]
    });
};
$7424f1aae5f97b60$export$6079dbe36a5ae246.displayName = "AioReplacementDisplay";

});
parcelRegister("4F320", function(module, exports) {

$parcel$export(module.exports, "AioReplacementValuesDisplay", function () { return $ead151a043095e1f$export$b2a4f9c268dcb341; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $hcEI9 = parcelRequire("hcEI9");

var $3Gn2b = parcelRequire("3Gn2b");
const $ead151a043095e1f$export$b2a4f9c268dcb341 = ({ id: id, airid: airid, texts: texts, spaceAfter: spaceAfter = false, subLists: subLists = [], setReplacementValue: setReplacementValue, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, externalLists: externalLists, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), level: level })=>{
    const Editor = editorProps.Editor;
    const returnData = (0, $spJKX.useCallback)((newRV)=>{
        /* istanbul ignore else */ if (setReplacementValue) {
            const r = {
                airid: airid,
                spaceAfter: newRV.spaceAfter ?? spaceAfter,
                texts: newRV.texts ?? texts,
                subLists: newRV.subLists ?? subLists
            };
            setReplacementValue(r);
        }
    }, [
        airid,
        setReplacementValue,
        spaceAfter,
        subLists,
        texts
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiordvMain,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                style: {
                    marginRight: "4px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: "2px"
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                        id: id,
                        "aria-label": "Replacement values",
                        editable: setReplacementValue !== undefined,
                        value: editorProps.joinTintoBlock(texts),
                        setValue: (ret)=>returnData({
                                texts: editorProps.splitTintoLines(ret)
                            }),
                        style: {
                            width: "170px",
                            minWidth: "170px",
                            minHeight: "64px",
                            marginTop: "4px",
                            height: "Calc(100% - 16px)",
                            padding: "4px",
                            border: "1px solid black",
                            borderRadius: "4px"
                        },
                        resize: true
                    }),
                    !dontAskSpace && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                                htmlFor: `${id}-spaceafter`,
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                                    children: "Space after repeat"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                                id: `${id}-spaceafter`,
                                style: {
                                    margin: "6px"
                                },
                                type: "checkbox",
                                checked: spaceAfter,
                                disabled: !setReplacementValue,
                                onChange: (e)=>returnData({
                                        spaceAfter: e.currentTarget.checked
                                    })
                            })
                        ]
                    })
                ]
            }),
            setReplacementValue || subLists.length > 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    level < 4 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        style: {
                                            flexGrow: 1,
                                            minWidth: "5px",
                                            width: "5px",
                                            borderBottom: "1px burlywood solid",
                                            borderBottomRightRadius: "4px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        style: {
                                            flexGrow: 1,
                                            minWidth: "5px",
                                            width: "5px",
                                            borderTop: "1px burlywood solid",
                                            borderTopRightRadius: "4px"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                style: {
                                    minWidth: "5px",
                                    width: "5px",
                                    marginTop: "6px",
                                    marginBottom: "6px",
                                    borderLeft: "1px burlywood solid",
                                    borderTop: "1px burlywood solid",
                                    borderBottom: "1px burlywood solid",
                                    borderTopLeftRadius: "4px",
                                    borderBottomLeftRadius: "4px"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3Gn2b.AioReplacementList), {
                        id: `${id}-sublists`,
                        replacements: subLists,
                        setReplacements: setReplacementValue ? (ret)=>returnData({
                                subLists: ret
                            }) : undefined,
                        dontAskSpace: setReplacementValue ? dontAskSpace : true,
                        dontAskTrail: dontAskTrail,
                        externalLists: externalLists,
                        editorProps: editorProps,
                        level: level + 1
                    })
                ]
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {})
        ]
    });
};
$ead151a043095e1f$export$b2a4f9c268dcb341.displayName = "AioReplacementValuesDisplay";

});
parcelRegister("3Gn2b", function(module, exports) {

$parcel$export(module.exports, "AioReplacementList", function () { return $8a8303d881d833eb$export$e09e09c0bb6298e3; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $3tKzd = parcelRequire("3tKzd");

var $biia9 = parcelRequire("biia9");

var $9Osbv = parcelRequire("9Osbv");

var $7na6X = parcelRequire("7na6X");

var $azY1B = parcelRequire("azY1B");
const $8a8303d881d833eb$export$e09e09c0bb6298e3 = ({ id: id, label: label, replacements: replacements, setReplacements: setReplacements, dontAskSpace: dontAskSpace, dontAskTrail: dontAskTrail, externalLists: externalLists, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), level: level })=>{
    const updateReplacement = (0, $spJKX.useCallback)((ret, i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newValue = [
                ...replacements
            ];
            newValue[i] = ret;
            setReplacements(newValue);
        }
    }, [
        replacements,
        setReplacements
    ]);
    const addReplacement = (0, $spJKX.useCallback)((i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newReplacements = [
                ...replacements
            ];
            newReplacements.splice(i, 0, (0, $azY1B.newReplacement)(editorProps.blankT));
            setReplacements(newReplacements);
        }
    }, [
        editorProps.blankT,
        replacements,
        setReplacements
    ]);
    const removeReplacement = (0, $spJKX.useCallback)((i)=>{
        /* istanbul ignore else */ if (setReplacements) {
            const newReplacements = [
                ...replacements
            ];
            newReplacements.splice(i, 1);
            setReplacements(newReplacements);
        }
    }, [
        replacements,
        setReplacements
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9Osbv.AioLabel), {
                id: `${id}-label`,
                label: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                children: [
                    level < 5 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            !label && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                        children: "then..."
                                    }),
                                    " "
                                ]
                            }),
                            setReplacements && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                id: `${id}-addreplacement`,
                                title: "Add replacement",
                                className: (0, $3tKzd.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxAddDown
                                ]),
                                onClick: ()=>addReplacement(0)
                            })
                        ]
                    }),
                    replacements.map((repl, i)=>{
                        return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            children: [
                                i > 0 && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                    children: " and..."
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7na6X.AioReplacementDisplay), {
                                    id: `${id}-replacementdisplay-${i}`,
                                    airid: repl.airid,
                                    oldText: repl.oldText,
                                    newTexts: repl.newTexts,
                                    includeTrailing: repl.includeTrailing,
                                    externalName: repl.externalName,
                                    setReplacement: setReplacements ? (ret)=>updateReplacement(ret, i) : undefined,
                                    dontAskSpace: dontAskSpace,
                                    dontAskTrail: dontAskTrail,
                                    externalLists: externalLists,
                                    editorProps: editorProps,
                                    level: level
                                }),
                                setReplacements && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                    className: (0, $3tKzd.classMerge)([
                                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButtonHolder,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexRowCenter,
                                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).marginBottom2
                                    ]),
                                    children: [
                                        replacements && replacements.length >= 1 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                                            id: `${id}-remove`,
                                            iconName: "aioxRemoveUp",
                                            onClick: ()=>removeReplacement(i),
                                            tipText: "Remove old text"
                                        }),
                                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                                            id: `${id}-add`,
                                            iconName: "aioxAddDown",
                                            onClick: ()=>addReplacement(i + 1),
                                            tipText: "Add old text"
                                        })
                                    ]
                                })
                            ]
                        }, `${i}-${repl.airid}`);
                    })
                ]
            })
        ]
    });
};
$8a8303d881d833eb$export$e09e09c0bb6298e3.displayName = "AioReplacementList";

});



parcelRegister("gGo2X", function(module, exports) {

$parcel$export(module.exports, "AioSelect", function () { return $eea7b662c7fe7fbd$export$56481f24960d73ae; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $9Osbv = parcelRequire("9Osbv");
const $eea7b662c7fe7fbd$export$56481f24960d73ae = (props)=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9Osbv.AioLabel), {
                id: `${props.id}-label`,
                label: props.label,
                htmlFor: props.id
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInputHolder,
                children: !props.setValue ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    id: props.id,
                    children: props.value
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)("select", {
                    id: props.id,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioSelect,
                    value: props.value,
                    onChange: (e)=>props.setValue(e.currentTarget.value),
                    children: props.availableValues && props.availableValues.map((v, i)=>{
                        return /*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                            value: v,
                            children: v
                        }, i);
                    })
                })
            })
        ]
    });
};
$eea7b662c7fe7fbd$export$56481f24960d73ae.displayName = "AioSelect";

});

parcelRegister("2Rhsi", function(module, exports) {

$parcel$export(module.exports, "isAioReplacement", function () { return $caf5d495f0eceb38$export$c8b64ff2405d449e; });
$parcel$export(module.exports, "isAioExternalReplacements", function () { return $caf5d495f0eceb38$export$e4d19c9b1a11fefc; });
$parcel$export(module.exports, "isAioExternalSingle", function () { return $caf5d495f0eceb38$export$51e8bc9d3e0fab16; });

var $12Lyj = parcelRequire("12Lyj");
const $caf5d495f0eceb38$export$c8b64ff2405d449e = (obj, chkT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    if (typeof obj.oldText !== "string") return false;
    if (!Array.isArray(obj.newTexts) || obj.newTexts.some((o)=>!$caf5d495f0eceb38$export$6b777ae226a0af37(o, chkT))) return false;
    // Check optional props
    if (obj.includeTrailing !== undefined && typeof obj.includeTrailing !== "boolean") return false;
    if (obj.externalName !== undefined && typeof obj.externalName !== "string") return false;
    // Everything is good
    return true;
};
const $caf5d495f0eceb38$export$6b777ae226a0af37 = (obj, chkT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    // texts must be an array and none of the entries should fail the chkT guard
    if (!Array.isArray(obj.texts) || obj.texts.some((t)=>!chkT(t))) return false;
    // Check optional props
    if (obj.spaceAfter !== undefined && typeof obj.spaceAfter !== "boolean") return false;
    if (obj.subLists !== undefined && (!Array.isArray(obj.subLists) || obj.subLists.some((s)=>!$caf5d495f0eceb38$export$c8b64ff2405d449e(s, chkT)))) return false;
    // Everything is good
    return true;
};
const $caf5d495f0eceb38$export$e4d19c9b1a11fefc = (obj, isT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check lower interface
    if (typeof obj.givenName !== "string") return false;
    if (!Array.isArray(obj.newTexts) || obj.newTexts.some((o)=>!$caf5d495f0eceb38$export$6b777ae226a0af37(o, isT))) return false;
    // Everything is good
    return true;
};
const $caf5d495f0eceb38$export$51e8bc9d3e0fab16 = (obj, isT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check basic props
    if (typeof obj.airid !== "string") return false;
    if (typeof obj.oldText !== "string") return false;
    // Check generic type
    if (!isT(obj.newText)) return false;
    // Everything is good
    return true;
};
var $caf5d495f0eceb38$export$edfa68647a85ef1 = /*#__PURE__*/ function(AioOptionType) {
    AioOptionType["string"] = "string";
    AioOptionType["number"] = "number";
    AioOptionType["array"] = "array";
    AioOptionType["object"] = "object";
    AioOptionType["boolean"] = "boolean";
    AioOptionType["select"] = "select";
    AioOptionType["replacements"] = "replacements";
    return AioOptionType;
}({});
var $caf5d495f0eceb38$export$55057b6697351b90 = /*#__PURE__*/ function(AioNewItem) {
    AioNewItem["newKey"] = "newKey";
    AioNewItem["newType"] = "newType";
    return AioNewItem;
}({});

});
parcelRegister("12Lyj", function(module, exports) {

$parcel$export(module.exports, "isObjectRecord", function () { return $ff2997b0a0016191$export$ff15efac2955c26a; });
/**
 * Type guard to check if a value is a non-null object record.
 *
 * @param obj - The value to check
 * @returns True if the value is an object record
 */ const $ff2997b0a0016191$export$ff15efac2955c26a = (obj)=>{
    return typeof obj === "object" && obj !== null;
};

});


parcelRegister("1LZEa", function(module, exports) {

$parcel$export(module.exports, "newExternalReplacements", function () { return $1db043bdf38e3966$export$3658d80c4fee3eff; });

var $76A43 = parcelRequire("76A43");
const $1db043bdf38e3966$export$3658d80c4fee3eff = (blankT)=>{
    return {
        givenName: "",
        newTexts: [
            (0, $76A43.newReplacementValues)(blankT)
        ]
    };
};

});


parcelRegister("1p11Q", function(module, exports) {
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("jPvQk")).ArsBlock; });
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("321H1")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("36pkg")).AnalysisSetControl; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("dMUCw")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("51n1k")).GroupingFactorControl; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("cr6aM")).ReferencedEntityControl; });
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("4hgF7")).ArsContextProvider; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("7RQn4")).cloneArsObject; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("7byiZ")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("7byiZ")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("7byiZ")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("7byiZ")).createNewGroupingFactor; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cJd2i")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("7RQn4")).hasArsObjectWithName; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("7G3Xj")).MultipleDatasetCheck; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cJd2i")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cJd2i")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("4hgF7")).useArsContext; });
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("5V1m5")).ArsListing; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("2N5BV")).isArsListingBody; });
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("c5vs0")).totalSidebarItem; });
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("jKF9Q")).ArsTable; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("gwArU")).isArsTableBody; });
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ghR9g")).isAnalysisMethod; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("49JG0")).isDataSubset; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("12Lyj")).isObjectRecord; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("9QVTJ")).isSubClauseWithReference; });

$parcel$export(module.exports, "ARS", function () { return (parcelRequire("iEmH0")); });

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1wddy");
parcelRequire("d0WZT");
parcelRequire("j4dHK");
parcelRequire("fc2Ha");
parcelRequire("kgT2g");
parcelRequire("4Sj6S");
parcelRequire("5VyPu");
parcelRequire("1ZdiT");
parcelRequire("cS6mF");

});
parcelRegister("iEmH0", function(module, exports) {

$parcel$export(module.exports, "OutputFileTypeEnum", function () { return $4aee295553360663$export$47f803b406f26046; });
$parcel$export(module.exports, "ExpressionLogicalOperatorEnum", function () { return $4aee295553360663$export$348d7552f54576b; });
$parcel$export(module.exports, "ConditionComparatorEnum", function () { return $4aee295553360663$export$ea8e51ef45e00dd8; });
$parcel$export(module.exports, "DisplaySectionTypeEnum", function () { return $4aee295553360663$export$fd824ba75eca195; });
$parcel$export(module.exports, "OperationRoleEnum", function () { return $4aee295553360663$export$efdc6d0631ac9420; });
$parcel$export(module.exports, "AnalysisReasonEnum", function () { return $4aee295553360663$export$d1a83c055b3f235e; });
$parcel$export(module.exports, "AnalysisPurposeEnum", function () { return $4aee295553360663$export$dec38678dda78c02; });
$parcel$export(module.exports, "ExtensibleTerminologyEnum", function () { return $4aee295553360663$export$e9ba74e51b2847c6; });
$parcel$export(module.exports, "PageRefTypeEnum", function () { return $4aee295553360663$export$4fd4a62032f22875; });
var $4aee295553360663$export$47f803b406f26046 = /*#__PURE__*/ function(OutputFileTypeEnum) {
    /** Portable Document Format (PDF) */ OutputFileTypeEnum["pdf"] = "pdf";
    /** Rich Text Format (RTF) */ OutputFileTypeEnum["rtf"] = "rtf";
    /** Plain text */ OutputFileTypeEnum["txt"] = "txt";
    return OutputFileTypeEnum;
}({});
var $4aee295553360663$export$348d7552f54576b = /*#__PURE__*/ function(ExpressionLogicalOperatorEnum) {
    ExpressionLogicalOperatorEnum["AND"] = "AND";
    ExpressionLogicalOperatorEnum["OR"] = "OR";
    ExpressionLogicalOperatorEnum["NOT"] = "NOT";
    return ExpressionLogicalOperatorEnum;
}({});
var $4aee295553360663$export$ea8e51ef45e00dd8 = /*#__PURE__*/ function(ConditionComparatorEnum) {
    /** Is equal to */ ConditionComparatorEnum["EQ"] = "EQ";
    /** Is not equal to */ ConditionComparatorEnum["NE"] = "NE";
    /** Is greater than */ ConditionComparatorEnum["GT"] = "GT";
    /** Is greater than or equal to */ ConditionComparatorEnum["GE"] = "GE";
    /** Is less than */ ConditionComparatorEnum["LT"] = "LT";
    /** Is less than or equal to */ ConditionComparatorEnum["LE"] = "LE";
    /** Is in */ ConditionComparatorEnum["IN"] = "IN";
    /** Is not in */ ConditionComparatorEnum["NOTIN"] = "NOTIN";
    return ConditionComparatorEnum;
}({});
var $4aee295553360663$export$fd824ba75eca195 = /*#__PURE__*/ function(DisplaySectionTypeEnum) {
    /** Lines of text appearing above the title and containing additional generic information such as study identifier or page numbering. */ DisplaySectionTypeEnum["Header"] = "Header";
    /** The title is a caption of a table beginning with "Table" followed by sequenced numbers or letters and separated by full stops. The title includes additional lines describing the content. */ DisplaySectionTypeEnum["Title"] = "Title";
    /** Optional text placed in the column header for a column containing row/stub labels. */ DisplaySectionTypeEnum["Rowlabel_Header"] = "Rowlabel Header";
    /** Lines of text placed immediately after the body of the table containing statements explaining the use of terms or values. May be prefaced with a word such as 'Note:'. */ DisplaySectionTypeEnum["Legend"] = "Legend";
    /** Lines of text defining abbreviations, acronyms, and terms used in the body of the display. */ DisplaySectionTypeEnum["Abbreviation"] = "Abbreviation";
    /** Placed after the abbreviations and definitions, if any. Footnotes lead with symbols (asterisk, dagger, double dagger, or section symbol) or superscripted letters (a, b, c) or numbers (1, 2, 3) which are in the table behind units of measure or words. Footnotes add information regarding the associated values where they occur in the body. */ DisplaySectionTypeEnum["Footnote"] = "Footnote";
    /** Lines of text appearing below any footnote and containing additional information such as traceability of the source program or page numbering. */ DisplaySectionTypeEnum["Footer"] = "Footer";
    /** ADDED BY AZ */ /** Page by */ DisplaySectionTypeEnum["PageBy"] = "PageBy";
    /** Columns in the table */ DisplaySectionTypeEnum["Columns"] = "Columns";
    /** Rows in the table */ DisplaySectionTypeEnum["Rows"] = "Rows";
    return DisplaySectionTypeEnum;
}({});
var $4aee295553360663$export$efdc6d0631ac9420 = /*#__PURE__*/ function(OperationRoleEnum) {
    /** The dividend of a fraction. */ OperationRoleEnum["NUMERATOR"] = "NUMERATOR";
    /** The divisor of a fraction. */ OperationRoleEnum["DENOMINATOR"] = "DENOMINATOR";
    return OperationRoleEnum;
}({});
var $4aee295553360663$export$d1a83c055b3f235e = /*#__PURE__*/ function(AnalysisReasonEnum) {
    /** The analysis is specified in a protocol. */ AnalysisReasonEnum["SPECIFIED_IN_PROTOCOL"] = "SPECIFIED IN PROTOCOL";
    /** The analysis is specified in a statistical analysis plan. */ AnalysisReasonEnum["SPECIFIED_IN_SAP"] = "SPECIFIED IN SAP";
    /** The analysis was triggered by findings in the data. */ AnalysisReasonEnum["DATA_DRIVEN"] = "DATA DRIVEN";
    /** The analysis has been requested by a regulatory agency. */ AnalysisReasonEnum["REQUESTED_BY_REGULATORY_AGENCY"] = "REQUESTED BY REGULATORY AGENCY";
    return AnalysisReasonEnum;
}({});
var $4aee295553360663$export$dec38678dda78c02 = /*#__PURE__*/ function(AnalysisPurposeEnum) {
    /** The outcome measure(s) of greatest importance specified in the protocol, usually the one(s) used in the power calculation, to evaluate the primary endpoint(s) associated with the primary study objective(s). (After Clinicaltrials.gov) */ AnalysisPurposeEnum["PRIMARY_OUTCOME_MEASURE"] = "PRIMARY OUTCOME MEASURE";
    /** The outcome measure(s) that is part of a pre-specified analysis plan used to evaluate the secondary endpoint(s) associated with secondary study objective(s) and/or used to evaluate any measure(s) ancillary to the primary or secondary endpoint(s). (After Clinicaltrials.gov). */ AnalysisPurposeEnum["SECONDARY_OUTCOME_MEASURE"] = "SECONDARY OUTCOME MEASURE";
    /** The outcome measure(s) that is part of a pre-specified analysis plan used to evaluate the exploratory endpoint(s) associated with exploratory study objective(s) and/or any other measures, excluding post-hoc measures, that are a focus of the study. (After clinicaltrials.gov) */ AnalysisPurposeEnum["EXPLORATORY_OUTCOME_MEASURE"] = "EXPLORATORY OUTCOME MEASURE";
    return AnalysisPurposeEnum;
}({});
var $4aee295553360663$export$e9ba74e51b2847c6 = /*#__PURE__*/ function(ExtensibleTerminologyEnum) {
    /** The rationale for performing this analysis. It indicates when the analysis was planned. */ ExtensibleTerminologyEnum["AnalysisReasonEnum"] = "AnalysisReasonEnum";
    /** The purpose of the analysis within the body of evidence (e.g., section in the clinical study report). */ ExtensibleTerminologyEnum["AnalysisPurposeEnum"] = "AnalysisPurposeEnum";
    /** The role that the referenced operation's result plays in the calculation of the result of this operation. */ ExtensibleTerminologyEnum["OperationRoleEnum"] = "OperationRoleEnum";
    /** The file format of the file containing output from analyses. */ ExtensibleTerminologyEnum["OutputFileTypeEnum"] = "OutputFileTypeEnum";
    return ExtensibleTerminologyEnum;
}({});
var $4aee295553360663$export$4fd4a62032f22875 = /*#__PURE__*/ function(PageRefTypeEnum) {
    /** References are to page numbers. */ PageRefTypeEnum["PhysicalRef"] = "PhysicalRef";
    /** References are to named destinations in the referenced document. */ PageRefTypeEnum["NamedDestination"] = "NamedDestination";
    return PageRefTypeEnum;
}({});

});

parcelRegister("1wddy", function(module, exports) {
$parcel$export(module.exports, "ArsBlock", function () { return (parcelRequire("jPvQk")).ArsBlock; });
parcelRequire("jPvQk");
parcelRequire("3J0K0");

});
parcelRegister("jPvQk", function(module, exports) {

$parcel$export(module.exports, "ArsBlock", function () { return $b58ea83463af51ad$export$eb18248e32b55f71; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $jP6k0 = parcelRequire("jP6k0");

var $f4xry = parcelRequire("f4xry");

var $jZnkP = parcelRequire("jZnkP");

var $eIjwt = parcelRequire("eIjwt");
const $b58ea83463af51ad$export$eb18248e32b55f71 = ({ disabled: disabled, dropText: dropText, editorDefns: editorDefns, id: id, setValue: setValue, style: style, value: value })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    /**
   * Appends grouping factors dropped onto the block.
   *
   * @param event - Drop event from a grouping-factor drag source
   * @param ix - Index of the page-by item being dropped onto, used when multiple page-by blocks are present; currently unused as only one block is supported, but included for future extensibility
   */ const addGroupingFactors = (event, ix)=>{
        event.preventDefault();
        if (disabled) return;
        const transferText = event.dataTransfer.getData("application/json");
        if (!transferText) return;
        try {
            const parsed = JSON.parse(transferText);
            if (!Array.isArray(parsed.data)) return;
            const newValue = [
                ...value
            ];
            const addValues = [];
            for (const item of parsed.data){
                if (!(0, $f4xry.isArsSidebarItemData)(item) || item.kind !== (0, $jP6k0.ArsSidebarItemKind).GroupingFactor) continue;
                if (!state.groupingFactors[item.dropItem.id]) continue;
                if (newValue.some(({ groupingFactorId: groupingFactorId })=>groupingFactorId === item.dropItem.id) || addValues.some(({ groupingFactorId: groupingFactorId })=>groupingFactorId === item.dropItem.id)) continue;
                addValues.push({
                    groupingFactorId: item.dropItem.id,
                    label: editorDefns.textToT([
                        item.dropItem.label,
                        item.dropItem.name,
                        item.dropItem.description,
                        item.dropItem.id
                    ].map((value)=>value?.trim() ?? "").find((value)=>value !== ""))
                });
            }
            newValue.splice(ix, 0, ...addValues);
            if (newValue.length !== value.length) setValue(newValue);
        } catch  {
            return;
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibBlock,
        style: style,
        children: value.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLine,
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItemHolder,
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexGrow1,
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jZnkP.ArsBlockDropZone), {
                                id: `${id}-dropzone`,
                                onDrop: (e)=>addGroupingFactors(e, 0),
                                top: "0",
                                bottom: "0"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: (0, $3tKzd.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItem,
                                    "fst-italic"
                                ]),
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)(editorDefns.Editor, {
                                    id: `ars-block-line-editor-ro`,
                                    editable: false,
                                    value: dropText ?? editorDefns.textToT("Drop grouping factors here"),
                                    setValue: // istanbul ignore next
                                    ()=>undefined
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons
                })
            ]
        }) : value.map((pageByItem, index)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLine,
                style: {
                    position: "relative"
                },
                children: [
                    index === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jZnkP.ArsBlockDropZone), {
                        id: `${id}-dropzone-${index}`,
                        onDrop: (e)=>addGroupingFactors(e, 0),
                        top: "-8px",
                        bottom: "calc(100% - 8px)"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jZnkP.ArsBlockDropZone), {
                        id: `${id}-dropzone-${index}`,
                        onDrop: (e)=>addGroupingFactors(e, index + 1),
                        top: "calc(100% - 8px)",
                        bottom: "-8px"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eIjwt.ArsBlockLine), {
                        disabled: disabled,
                        editorDefns: editorDefns,
                        pageByIndex: index,
                        setValue: setValue,
                        value: value
                    })
                ]
            }, `${pageByItem.groupingFactorId}-${index}`))
    });
};
$b58ea83463af51ad$export$eb18248e32b55f71.displayName = "ArsBlock";

});
parcelRegister("j4dHK", function(module, exports) {
$parcel$export(module.exports, "ArsContextProvider", function () { return (parcelRequire("4hgF7")).ArsContextProvider; });
$parcel$export(module.exports, "useArsContext", function () { return (parcelRequire("4hgF7")).useArsContext; });
$parcel$export(module.exports, "createNewAnalysisMethod", function () { return (parcelRequire("7byiZ")).createNewAnalysisMethod; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return (parcelRequire("7byiZ")).createNewAnalysisSet; });
$parcel$export(module.exports, "createNewDataSubset", function () { return (parcelRequire("7byiZ")).createNewDataSubset; });
$parcel$export(module.exports, "createNewGroup", function () { return (parcelRequire("7byiZ")).createNewGroup; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return (parcelRequire("7byiZ")).createNewGroupingFactor; });
$parcel$export(module.exports, "cloneArsObject", function () { return (parcelRequire("7RQn4")).cloneArsObject; });
$parcel$export(module.exports, "hasArsObjectWithName", function () { return (parcelRequire("7RQn4")).hasArsObjectWithName; });
$parcel$export(module.exports, "ADD_EXTRA_WHERE_CLAUSE", function () { return (parcelRequire("cJd2i")).ADD_EXTRA_WHERE_CLAUSE; });
$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return (parcelRequire("cJd2i")).CURRENT_HIERARCHY_ID; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return (parcelRequire("cJd2i")).PATCH_ARS_STATE; });
$parcel$export(module.exports, "REMOVE_WHERE_CLAUSE", function () { return (parcelRequire("cJd2i")).REMOVE_WHERE_CLAUSE; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_ANALYSIS_METHOD_ID; });
$parcel$export(module.exports, "SET_SIDEBAR_DATASET", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_DATASET; });
$parcel$export(module.exports, "SET_SIDEBAR_FILTER", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_FILTER; });
$parcel$export(module.exports, "SET_SIDEBAR_VIEW", function () { return (parcelRequire("cJd2i")).SET_SIDEBAR_VIEW; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return (parcelRequire("cJd2i")).SET_VARIABLES_IN_USE; });
$parcel$export(module.exports, "MultipleDatasetCheck", function () { return (parcelRequire("7G3Xj")).MultipleDatasetCheck; });
parcelRequire("aFqFb");
parcelRequire("4hgF7");
parcelRequire("gGMaR");
parcelRequire("7byiZ");
parcelRequire("7RQn4");
parcelRequire("cJd2i");
parcelRequire("7G3Xj");

});
parcelRegister("aFqFb", function(module, exports) {

$parcel$export(module.exports, "ArsContext", function () { return $e679572efea734e3$export$8498abec16db8a5d; });

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");
const $e679572efea734e3$export$a81908c0103a1f28 = {
    // Read-only reference data
    comparators: [],
    variables: [],
    // Editable/sharable lists
    analyses: {},
    analysisMethods: {},
    analysisSets: {},
    caseWhenConditions: {},
    dataSubsets: {},
    groupingFactors: {},
    // UI state
    changed: false,
    datasetsInUse: new Set(),
    disableAnalysisMethodEdit: false,
    editorDefns: (0, $hcEI9.defaultEditorDefns),
    uiRequestStatus: {
        requesting: false,
        error: false
    },
    variablesInUse: new Set(),
    // Sidebar state
    currentSidebar: {
        view: "groupingFactor",
        filter: ""
    }
};
const $e679572efea734e3$export$8498abec16db8a5d = (0, $spJKX.createContext)({
    state: $e679572efea734e3$export$a81908c0103a1f28,
    dispatch: // istanbul ignore next
    ()=>{}
});

});

parcelRegister("4hgF7", function(module, exports) {

$parcel$export(module.exports, "ArsContextProvider", function () { return $849539a68c930029$export$e673e34db547c51c; });
$parcel$export(module.exports, "useArsContext", function () { return $849539a68c930029$export$9f8067ef80b208f8; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $4VWrH = parcelRequire("4VWrH");

var $aFqFb = parcelRequire("aFqFb");

var $gGMaR = parcelRequire("gGMaR");

var $cJd2i = parcelRequire("cJd2i");
const $849539a68c930029$export$e673e34db547c51c = ({ children: children, analyses: analyses, analysisMethods: analysisMethods, analysisSets: analysisSets, caseWhenConditions: caseWhenConditions, comparators: comparators, dataSubsets: dataSubsets, disableAnalysisMethodEdit: disableAnalysisMethodEdit = false, editorDefns: editorDefns, groupingFactors: groupingFactors, initialSidebarView: initialSidebarView = "groupingFactor", updateARS: updateARS, variables: variables })=>{
    const initialDataState = (0, $spJKX.useMemo)(()=>({
            analyses: (0, $4VWrH.mapById)(analyses),
            analysisMethods: (0, $4VWrH.mapById)(analysisMethods),
            analysisSets: (0, $4VWrH.mapById)(analysisSets),
            caseWhenConditions: (0, $4VWrH.mapById)(caseWhenConditions),
            changed: false,
            comparators: comparators,
            dataSubsets: (0, $4VWrH.mapById)(dataSubsets),
            datasetsInUse: new Set(),
            disableAnalysisMethodEdit: disableAnalysisMethodEdit,
            editorDefns: editorDefns,
            groupingFactors: (0, $4VWrH.mapById)(groupingFactors),
            uiRequestStatus: {
                requesting: false,
                error: false
            },
            variables: variables,
            variablesInUse: new Set()
        }), [
        analyses,
        analysisMethods,
        analysisSets,
        caseWhenConditions,
        comparators,
        dataSubsets,
        disableAnalysisMethodEdit,
        editorDefns,
        groupingFactors,
        variables
    ]);
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $gGMaR.arsContextReducer), {
        ...initialDataState,
        editorDefns: editorDefns,
        currentSidebar: {
            filter: "",
            view: initialSidebarView
        }
    });
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state, initialDataState);
        // Send changes up
        /* istanbul ignore else */ if (state.changed && !eq) {
            updateARS(state);
            dispatch({
                operation: (0, $cJd2i.ARS_CHANGE_SENT)
            });
        } else if (!state.changed && !eq) {
            const updates = [];
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(analyses), state.analyses)) updates.push({
                dataPath: "/analyses",
                value: (0, $4VWrH.mapById)(analyses)
            });
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(analysisMethods), state.analysisMethods)) updates.push({
                dataPath: "/analysisMethods",
                value: (0, $4VWrH.mapById)(analysisMethods)
            });
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(analysisSets), state.analysisSets)) updates.push({
                dataPath: "/analysisSets",
                value: (0, $4VWrH.mapById)(analysisSets)
            });
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(caseWhenConditions), state.caseWhenConditions)) updates.push({
                dataPath: "/caseWhenConditions",
                value: (0, $4VWrH.mapById)(caseWhenConditions)
            });
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(dataSubsets), state.dataSubsets)) updates.push({
                dataPath: "/dataSubsets",
                value: (0, $4VWrH.mapById)(dataSubsets)
            });
            if (!(0, $eBlbF.isEqual)((0, $4VWrH.mapById)(groupingFactors), state.groupingFactors)) updates.push({
                dataPath: "/groupingFactors",
                value: (0, $4VWrH.mapById)(groupingFactors)
            });
            if (!(0, $eBlbF.isEqual)(variables, state.variables)) updates.push({
                dataPath: "/variables",
                value: variables
            });
            if (!(0, $eBlbF.isEqual)(comparators, state.comparators)) updates.push({
                dataPath: "/comparators",
                value: comparators
            });
            if (updates.length > 0) dispatch({
                operation: (0, $cJd2i.LOAD_ARS_PATCH),
                updates: updates
            });
        }
    }, [
        analyses,
        analysisMethods,
        analysisSets,
        caseWhenConditions,
        comparators,
        dataSubsets,
        groupingFactors,
        initialDataState,
        state,
        updateARS,
        variables
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aFqFb.ArsContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$849539a68c930029$export$e673e34db547c51c.displayName = "ArsContextProvider";
const $849539a68c930029$export$9f8067ef80b208f8 = ()=>{
    const context = (0, $spJKX.useContext)((0, $aFqFb.ArsContext));
    return context;
};

});
parcelRegister("gGMaR", function(module, exports) {

$parcel$export(module.exports, "arsContextReducer", function () { return $5543ab502a717e61$export$e206421faa69fe86; });
parcelRequire("1uqrp");
var $7Edaq = parcelRequire("7Edaq");
var $125l7 = parcelRequire("125l7");
var $j9fLB = parcelRequire("j9fLB");
var $7E63S = parcelRequire("7E63S");
var $L9kpJ = parcelRequire("L9kpJ");
var $8i2kO = parcelRequire("8i2kO");
var $gJ0yP = parcelRequire("gJ0yP");
var $ePGej = parcelRequire("ePGej");
var $1o4wl = parcelRequire("1o4wl");
var $4FLQz = parcelRequire("4FLQz");
var $dOlaU = parcelRequire("dOlaU");
var $ctJKH = parcelRequire("ctJKH");
var $1I6ja = parcelRequire("1I6ja");
var $ac7gP = parcelRequire("ac7gP");

var $cJd2i = parcelRequire("cJd2i");
const $5543ab502a717e61$export$e206421faa69fe86 = (state, action)=>{
    switch(action.operation){
        case 0, $cJd2i.ADD_EXTRA_WHERE_CLAUSE:
            return (0, $7Edaq.arsc_addExtraWhereClause)(state, action);
        case 0, $cJd2i.ARS_CHANGE_SENT:
            return (0, $j9fLB.arsc_changeSent)(state);
        case 0, $cJd2i.ADD_NOT_TO_WHERE_CLAUSE:
            return (0, $125l7.arsc_addNotToWhereClause)(state, action);
        case 0, $cJd2i.LOAD_ARS_PATCH:
            return (0, $7E63S.arsc_loadArsPatch)(state, action);
        case 0, $cJd2i.PATCH_ARS_STATE:
            return (0, $L9kpJ.arsc_patchArsState)(state, action);
        case 0, $cJd2i.REMOVE_ARS_ITEM:
            return (0, $8i2kO.arsc_removeArsItem)(state, action);
        case 0, $cJd2i.REMOVE_NOT_FROM_WHERE_CLAUSE:
            return (0, $gJ0yP.arsc_removeNotFromWhereClause)(state, action);
        case 0, $cJd2i.REMOVE_WHERE_CLAUSE:
            return (0, $ePGej.arsc_removeWhereClause)(state, action);
        case 0, $cJd2i.SET_SIDEBAR_VIEW:
            return (0, $ctJKH.arsc_setSidebarView)(state, action);
        case 0, $cJd2i.SET_SIDEBAR_ANALYSIS_METHOD_ID:
            return (0, $1o4wl.arsc_setSidebarAnalysisMethodId)(state, action);
        case 0, $cJd2i.SET_SIDEBAR_DATASET:
            return (0, $4FLQz.arsc_setSidebarDataset)(state, action);
        case 0, $cJd2i.SET_SIDEBAR_FILTER:
            return (0, $dOlaU.arsc_setSidebarFilter)(state, action);
        case 0, $cJd2i.SET_UI_REQUEST_STATUS:
            return (0, $1I6ja.arsc_setUiRequestStatus)(state, action);
        case 0, $cJd2i.SET_VARIABLES_IN_USE:
            return (0, $ac7gP.arsc_setVariablesInUse)(state, action);
    }
};

});
parcelRegister("1uqrp", function(module, exports) {
$parcel$export(module.exports, "arsc_addExtraWhereClause", function () { return (parcelRequire("7Edaq")).arsc_addExtraWhereClause; });
$parcel$export(module.exports, "arsc_addNotToWhereClause", function () { return (parcelRequire("125l7")).arsc_addNotToWhereClause; });
$parcel$export(module.exports, "arsc_changeSent", function () { return (parcelRequire("j9fLB")).arsc_changeSent; });
$parcel$export(module.exports, "arsc_loadArsPatch", function () { return (parcelRequire("7E63S")).arsc_loadArsPatch; });
$parcel$export(module.exports, "arsc_patchArsState", function () { return (parcelRequire("L9kpJ")).arsc_patchArsState; });
$parcel$export(module.exports, "arsc_removeArsItem", function () { return (parcelRequire("8i2kO")).arsc_removeArsItem; });
$parcel$export(module.exports, "arsc_removeNotFromWhereClause", function () { return (parcelRequire("gJ0yP")).arsc_removeNotFromWhereClause; });
$parcel$export(module.exports, "arsc_removeWhereClause", function () { return (parcelRequire("ePGej")).arsc_removeWhereClause; });
$parcel$export(module.exports, "arsc_setSidebarAnalysisMethodId", function () { return (parcelRequire("1o4wl")).arsc_setSidebarAnalysisMethodId; });
$parcel$export(module.exports, "arsc_setSidebarDataset", function () { return (parcelRequire("4FLQz")).arsc_setSidebarDataset; });
$parcel$export(module.exports, "arsc_setSidebarFilter", function () { return (parcelRequire("dOlaU")).arsc_setSidebarFilter; });
$parcel$export(module.exports, "arsc_setSidebarView", function () { return (parcelRequire("ctJKH")).arsc_setSidebarView; });
$parcel$export(module.exports, "arsc_setUiRequestStatus", function () { return (parcelRequire("1I6ja")).arsc_setUiRequestStatus; });
$parcel$export(module.exports, "arsc_setVariablesInUse", function () { return (parcelRequire("ac7gP")).arsc_setVariablesInUse; });
parcelRequire("7Edaq");
parcelRequire("125l7");
parcelRequire("j9fLB");
parcelRequire("7E63S");
parcelRequire("L9kpJ");
parcelRequire("8i2kO");
parcelRequire("gJ0yP");
parcelRequire("ePGej");
parcelRequire("1o4wl");
parcelRequire("4FLQz");
parcelRequire("dOlaU");
parcelRequire("ctJKH");
parcelRequire("1I6ja");
parcelRequire("ac7gP");

});
parcelRegister("7Edaq", function(module, exports) {

$parcel$export(module.exports, "arsc_addExtraWhereClause", function () { return $a3137f7c00d15ac6$export$82d2d4cb4703cd00; });

var $eBlbF = parcelRequire("eBlbF");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1ZdiT");
var $6dqyB = parcelRequire("6dqyB");
var $cTgGQ = parcelRequire("cTgGQ");
const $a3137f7c00d15ac6$export$82d2d4cb4703cd00 = (state, action)=>{
    const whereClause = (0, $jwDoS.getFromDataPath)(action.dataPath, state, (0, $6dqyB.isWhereClause));
    if (!whereClause) throw new Error(`Invalid dataPath for ADD_EXTRA_WHERE_CLAUSE: ${action.dataPath}`);
    if ((0, $cTgGQ.isWhereClauseWithCondition)(whereClause)) {
        const newCompoundExpression = {
            logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).AND,
            whereClauses: [
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: whereClause.condition,
                    level: whereClause.level + 1,
                    order: 0
                },
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: {},
                    level: whereClause.level + 1,
                    order: 1
                }
            ]
        };
        const newEntity = {
            ...(0, $eBlbF.omit)(whereClause, "condition"),
            compoundExpression: newCompoundExpression,
            level: whereClause.level,
            order: whereClause.order
        };
        return (0, $67RwR.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity);
    }
    const ce = whereClause.compoundExpression;
    const newClause = {
        id: crypto.randomUUID(),
        subClauseId: "",
        condition: {},
        level: ce.whereClauses?.[0]?.level ?? // istanbul ignore next
        1,
        order: (ce.whereClauses ?? // istanbul ignore next
        []).length
    };
    const newWhereClauses = [
        ...ce.whereClauses ?? // istanbul ignore next
        [],
        newClause
    ];
    const newCompoundExpression = {
        ...ce,
        logicalOperator: ce.logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT ? (0, $iEmH0.ExpressionLogicalOperatorEnum).AND : ce.logicalOperator,
        whereClauses: newWhereClauses
    };
    return (0, $67RwR.mutateByPath)({
        ...state,
        changed: true
    }, `${action.dataPath}/compoundExpression`, newCompoundExpression);
};

});
parcelRegister("1ZdiT", function(module, exports) {
$parcel$export(module.exports, "isAnalysisMethod", function () { return (parcelRequire("ghR9g")).isAnalysisMethod; });
$parcel$export(module.exports, "isAnalysisOutputProgrammingCodeValue", function () { return (parcelRequire("bze11")).isAnalysisOutputProgrammingCodeValue; });
$parcel$export(module.exports, "isAnalysisProgrammingCodeTemplate", function () { return (parcelRequire("gOxn7")).isAnalysisProgrammingCodeTemplate; });
$parcel$export(module.exports, "isAnalysisSet", function () { return (parcelRequire("jsEoI")).isAnalysisSet; });
$parcel$export(module.exports, "isCaseWhenCondition", function () { return (parcelRequire("2x5bU")).isCaseWhenCondition; });
$parcel$export(module.exports, "isCaseWhenItem", function () { return (parcelRequire("1jtoS")).isCaseWhenItem; });
$parcel$export(module.exports, "isDataSubset", function () { return (parcelRequire("49JG0")).isDataSubset; });
$parcel$export(module.exports, "isGroup", function () { return (parcelRequire("6PiIn")).isGroup; });
$parcel$export(module.exports, "isGroupingFactor", function () { return (parcelRequire("czm2N")).isGroupingFactor; });
$parcel$export(module.exports, "isObjectRecord", function () { return (parcelRequire("12Lyj")).isObjectRecord; });
$parcel$export(module.exports, "isOperation", function () { return (parcelRequire("j3kPF")).isOperation; });
$parcel$export(module.exports, "isSubClauseWithCompoundExpression", function () { return (parcelRequire("4FB18")).isSubClauseWithCompoundExpression; });
$parcel$export(module.exports, "isSubClauseWithCondition", function () { return (parcelRequire("ejHCH")).isSubClauseWithCondition; });
$parcel$export(module.exports, "isSubClauseWithReference", function () { return (parcelRequire("9QVTJ")).isSubClauseWithReference; });
$parcel$export(module.exports, "isWhereClause", function () { return (parcelRequire("6dqyB")).isWhereClause; });
$parcel$export(module.exports, "isWhereClauseWithCompoundExpression", function () { return (parcelRequire("lPVPO")).isWhereClauseWithCompoundExpression; });
$parcel$export(module.exports, "isWhereClauseWithCondition", function () { return (parcelRequire("cTgGQ")).isWhereClauseWithCondition; });
parcelRequire("k6V4B");
parcelRequire("ghR9g");
parcelRequire("1S4ua");
parcelRequire("bze11");
parcelRequire("gOxn7");
parcelRequire("jsEoI");
parcelRequire("IhPMk");
parcelRequire("2x5bU");
parcelRequire("1jtoS");
parcelRequire("49JG0");
parcelRequire("4rBn8");
parcelRequire("bGBvr");
parcelRequire("6PiIn");
parcelRequire("czm2N");
parcelRequire("kcXWJ");
parcelRequire("drWxP");
parcelRequire("hbLfc");
parcelRequire("03NtQ");
parcelRequire("12Lyj");
parcelRequire("j3kPF");
parcelRequire("g8tFs");
parcelRequire("kOvH2");
parcelRequire("fRRM2");
parcelRequire("4FB18");
parcelRequire("ejHCH");
parcelRequire("9QVTJ");
parcelRequire("3PmXz");
parcelRequire("6dqyB");
parcelRequire("cA3dJ");
parcelRequire("7TeSQ");
parcelRequire("lPVPO");
parcelRequire("cTgGQ");

});
parcelRegister("k6V4B", function(module, exports) {

$parcel$export(module.exports, "isAnalysis", function () { return $8702d377939667d9$export$617b58bca42992df; });

var $4rBn8 = parcelRequire("4rBn8");

var $bGBvr = parcelRequire("bGBvr");

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");
const $8702d377939667d9$export$617b58bca42992df = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!(0, $bGBvr.isExtensibleTerminologyTerm)(obj.reason)) return false;
    if (!(0, $bGBvr.isExtensibleTerminologyTerm)(obj.purpose)) return false;
    if (typeof obj.methodId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.version)) return false;
    if (obj.documentRefs !== undefined && (!Array.isArray(obj.documentRefs) || obj.documentRefs.some((documentRef)=>!(0, $4rBn8.isDocumentReference)(documentRef)))) return false;
    return true;
};

});
parcelRegister("4rBn8", function(module, exports) {

$parcel$export(module.exports, "isDocumentReference", function () { return $235114bf12fa5884$export$69664ad679805f4e; });

var $12Lyj = parcelRequire("12Lyj");

var $g8tFs = parcelRequire("g8tFs");
const $235114bf12fa5884$export$69664ad679805f4e = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.referenceDocumentId !== "string") return false;
    if (obj.pageRefs !== undefined) {
        if (!Array.isArray(obj.pageRefs)) return false;
        if (obj.pageRefs.some((pageRef)=>!(0, $g8tFs.isPageRef)(pageRef))) return false;
    }
    return true;
};

});
parcelRegister("g8tFs", function(module, exports) {

$parcel$export(module.exports, "isPageRef", function () { return $3262fb55f41f08b4$export$f54921fd905b8d5d; });

var $12Lyj = parcelRequire("12Lyj");
const $3262fb55f41f08b4$export$f54921fd905b8d5d = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.refType !== "string") return false;
    if (obj.label !== undefined && typeof obj.label !== "string") return false;
    if (obj.pageNames !== undefined) {
        if (!Array.isArray(obj.pageNames)) return false;
        if (obj.pageNames.some((name)=>typeof name !== "string")) return false;
    }
    if (obj.pageNumbers !== undefined) {
        if (!Array.isArray(obj.pageNumbers)) return false;
        if (obj.pageNumbers.some((pageNumber)=>typeof pageNumber !== "number")) return false;
    }
    if (obj.firstPage !== undefined && typeof obj.firstPage !== "number") return false;
    if (obj.lastPage !== undefined && typeof obj.lastPage !== "number") return false;
    return true;
};

});


parcelRegister("bGBvr", function(module, exports) {

$parcel$export(module.exports, "isExtensibleTerminologyTerm", function () { return $531899a0bde8f63f$export$d43c57bf932db175; });

var $12Lyj = parcelRequire("12Lyj");
const $531899a0bde8f63f$export$d43c57bf932db175 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (obj.controlledTerm !== undefined && typeof obj.controlledTerm !== "string") return false;
    if (obj.sponsorTermId !== undefined && typeof obj.sponsorTermId !== "string") return false;
    if (obj.controlledTerm === undefined && obj.sponsorTermId === undefined) return false;
    return true;
};

});

parcelRegister("03NtQ", function(module, exports) {

$parcel$export(module.exports, "isNamedObject", function () { return $9440d070a366a06b$export$8f7d4fd01ac01edc; });

var $12Lyj = parcelRequire("12Lyj");
const $9440d070a366a06b$export$8f7d4fd01ac01edc = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (typeof obj.name !== "string") return false;
    if (obj.description !== undefined && typeof obj.description !== "string") return false;
    if (obj.label !== undefined && typeof obj.label !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("ghR9g", function(module, exports) {

$parcel$export(module.exports, "isAnalysisMethod", function () { return $20a51dc6060226bb$export$18a4c8014c5fb20f; });

var $gOxn7 = parcelRequire("gOxn7");

var $4rBn8 = parcelRequire("4rBn8");

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");

var $j3kPF = parcelRequire("j3kPF");
const $20a51dc6060226bb$export$18a4c8014c5fb20f = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    // Required: operations must be an array of valid Operations
    if (!Array.isArray(obj.operations)) return false;
    if (obj.operations.some((op)=>!(0, $j3kPF.isOperation)(op))) return false;
    // Optional: documentRefs must be an array of valid DocumentReference values
    if (obj.documentRefs !== undefined) {
        if (!Array.isArray(obj.documentRefs)) return false;
        if (obj.documentRefs.some((documentReference)=>!(0, $4rBn8.isDocumentReference)(documentReference))) return false;
    }
    // Optional: codeTemplate must be a valid AnalysisProgrammingCodeTemplate value
    if (obj.codeTemplate !== undefined && !(0, $gOxn7.isAnalysisProgrammingCodeTemplate)(obj.codeTemplate)) return false;
    return true;
};

});
parcelRegister("gOxn7", function(module, exports) {

$parcel$export(module.exports, "isAnalysisProgrammingCodeTemplate", function () { return $281fb77f4b2edebc$export$5eec27d0d9461f05; });

var $4rBn8 = parcelRequire("4rBn8");

var $12Lyj = parcelRequire("12Lyj");

var $3PmXz = parcelRequire("3PmXz");
const $281fb77f4b2edebc$export$5eec27d0d9461f05 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.context !== "string") return false;
    if (obj.code !== undefined && typeof obj.code !== "string") return false;
    if (obj.documentRef !== undefined && !(0, $4rBn8.isDocumentReference)(obj.documentRef)) return false;
    if (obj.parameters !== undefined) {
        if (!Array.isArray(obj.parameters)) return false;
        if (obj.parameters.some((parameter)=>!(0, $3PmXz.isTemplateCodeParameter)(parameter))) return false;
    }
    return true;
};

});
parcelRegister("3PmXz", function(module, exports) {

$parcel$export(module.exports, "isTemplateCodeParameter", function () { return $eee4e785993ecf59$export$6d20581905e381a8; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");
const $eee4e785993ecf59$export$6d20581905e381a8 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    if (typeof obj.valueSource !== "string" || ![
        "groupingFactor",
        "operation"
    ].includes(obj.valueSource)) return false;
    if (obj.value !== undefined && (!Array.isArray(obj.value) || obj.value.some((value)=>typeof value !== "string"))) return false;
    if (typeof obj.parameterType !== "string" || ![
        "string",
        "number",
        "boolean",
        "stringList",
        "numberList",
        "select",
        "multiSelect",
        "dataset.variable"
    ].includes(obj.parameterType)) return false;
    if (obj.availableValues !== undefined && (!Array.isArray(obj.availableValues) || obj.availableValues.some((value)=>typeof value !== "string"))) return false;
    /* Everything is good */ return true;
};

});


parcelRegister("j3kPF", function(module, exports) {

$parcel$export(module.exports, "isOperation", function () { return $0d6e5b9266641192$export$13853810e01af068; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");

var $kOvH2 = parcelRequire("kOvH2");
const $0d6e5b9266641192$export$13853810e01af068 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.order !== "number") return false;
    // Optional: resultPattern must be a string if present
    if (obj.resultPattern !== undefined && typeof obj.resultPattern !== "string") return false;
    // Optional authoring configuration must remain a string, including an explicit empty default.
    if (obj.defaultTargetVariable !== undefined && typeof obj.defaultTargetVariable !== "string") return false;
    // Optional: referencedOperationRelationships must be an array if present,
    // and each element must be a valid ReferencedOperationRelationship
    if (obj.referencedOperationRelationships !== undefined) {
        if (!Array.isArray(obj.referencedOperationRelationships)) return false;
        if (obj.referencedOperationRelationships.some((rel)=>!(0, $kOvH2.isReferencedOperationRelationship)(rel))) return false;
    }
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.denominatorOnly)) return false;
    return true;
};

});
parcelRegister("kOvH2", function(module, exports) {

$parcel$export(module.exports, "isReferencedOperationRelationship", function () { return $aa5be0ce6716f2d2$export$b872dcc21978c18f; });

var $bGBvr = parcelRequire("bGBvr");

var $12Lyj = parcelRequire("12Lyj");
const $aa5be0ce6716f2d2$export$b872dcc21978c18f = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.operationId !== "string") return false;
    if (!(0, $bGBvr.isExtensibleTerminologyTerm)(obj.referencedOperationRole)) return false;
    if (obj.analysisId !== undefined && typeof obj.analysisId !== "string") return false;
    if (obj.description !== undefined && typeof obj.description !== "string") return false;
    return true;
};

});



parcelRegister("1S4ua", function(module, exports) {

$parcel$export(module.exports, "isAnalysisOutputCodeParameter", function () { return $8589a1a930d5d60a$export$237bc416e5e84312; });

var $12Lyj = parcelRequire("12Lyj");
const $8589a1a930d5d60a$export$237bc416e5e84312 = (obj)=>{
    // Check type
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check Properties
    if (!Array.isArray(obj.value) || obj.value.some((value)=>typeof value !== "string")) return false;
    if (typeof obj.name !== "string") return false;
    if ([
        "string",
        "undefined"
    ].includes(typeof obj.description) === false) return false;
    if ([
        "string",
        "undefined"
    ].includes(typeof obj.label) === false) return false;
    // Everything is good
    return true;
};

});

parcelRegister("bze11", function(module, exports) {

$parcel$export(module.exports, "isAnalysisOutputProgrammingCodeValue", function () { return $589e0c515d7a5345$export$3de1f488c0332f3b; });

var $1S4ua = parcelRequire("1S4ua");

var $4rBn8 = parcelRequire("4rBn8");

var $12Lyj = parcelRequire("12Lyj");
const $589e0c515d7a5345$export$3de1f488c0332f3b = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.context !== "string") return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.code)) return false;
    if (obj.documentRef !== undefined && !(0, $4rBn8.isDocumentReference)(obj.documentRef)) return false;
    if (obj.parameters !== undefined && (!Array.isArray(obj.parameters) || obj.parameters.some((param)=>!(0, $1S4ua.isAnalysisOutputCodeParameter)(param)))) return false;
    return true;
};

});

parcelRegister("jsEoI", function(module, exports) {

$parcel$export(module.exports, "isAnalysisSet", function () { return $6cde77a88c78f3ee$export$14fdd86edf0a5540; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");

var $6dqyB = parcelRequire("6dqyB");
const $6cde77a88c78f3ee$export$14fdd86edf0a5540 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $03NtQ.isNamedObject)(obj) || !(0, $6dqyB.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Everything is good
    return true;
};

});
parcelRegister("6dqyB", function(module, exports) {

$parcel$export(module.exports, "isWhereClause", function () { return $e69ef7441ce9b450$export$2c9b8aab4e488ca5; });

var $lPVPO = parcelRequire("lPVPO");

var $cTgGQ = parcelRequire("cTgGQ");
const $e69ef7441ce9b450$export$2c9b8aab4e488ca5 = (obj)=>{
    return (0, $cTgGQ.isWhereClauseWithCondition)(obj) || (0, $lPVPO.isWhereClauseWithCompoundExpression)(obj);
};

});
parcelRegister("lPVPO", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseWithCompoundExpression", function () { return $cf2ea0339f3af186$export$5a5d6d060341749a; });

var $hbLfc = parcelRequire("hbLfc");

var $12Lyj = parcelRequire("12Lyj");

var $cA3dJ = parcelRequire("cA3dJ");
const $cf2ea0339f3af186$export$5a5d6d060341749a = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $hbLfc.isLevelOrder)(obj)) return false;
    // Must have a valid compoundExpression
    if (!(0, $cA3dJ.isWhereClauseCompoundExpression)(objectRecord.compoundExpression)) return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    return true;
};

});
parcelRegister("hbLfc", function(module, exports) {

$parcel$export(module.exports, "isLevelOrder", function () { return $4a35655d9ac3c682$export$3039618a6f988e1d; });

var $12Lyj = parcelRequire("12Lyj");
const $4a35655d9ac3c682$export$3039618a6f988e1d = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (typeof obj.level !== "number") return false;
    if (typeof obj.order !== "number") return false;
    // Everything is good
    return true;
};

});

parcelRegister("cA3dJ", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseCompoundExpression", function () { return $ee7071186253c7a3$export$84b60981a7879d23; });

var $iEmH0 = parcelRequire("iEmH0");

var $12Lyj = parcelRequire("12Lyj");

var $fRRM2 = parcelRequire("fRRM2");
const $ee7071186253c7a3$export$84b60981a7879d23 = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check properties exist
    if (!Object.values((0, $iEmH0.ExpressionLogicalOperatorEnum)).includes(obj.logicalOperator)) return false;
    if (obj.whereClauses !== undefined && (!Array.isArray(obj.whereClauses) || obj.whereClauses.some((item)=>!(0, $fRRM2.isSubClause)(item)))) return false;
    // Validate logical operator constraints
    const whereClausesCount = Array.isArray(obj.whereClauses) ? obj.whereClauses.length : 0;
    // If NOT, max 1 whereClause
    if (obj.logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT && whereClausesCount > 1) return false;
    // Everything is good
    return true;
};

});
parcelRegister("fRRM2", function(module, exports) {

$parcel$export(module.exports, "isSubClause", function () { return $036336f8664f4bae$export$7ff1e2a1f10ca427; });

var $4FB18 = parcelRequire("4FB18");

var $ejHCH = parcelRequire("ejHCH");

var $9QVTJ = parcelRequire("9QVTJ");
const $036336f8664f4bae$export$7ff1e2a1f10ca427 = (obj)=>{
    return (0, $ejHCH.isSubClauseWithCondition)(obj) || (0, $4FB18.isSubClauseWithCompoundExpression)(obj) || (0, $9QVTJ.isSubClauseWithReference)(obj);
};

});
parcelRegister("4FB18", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithCompoundExpression", function () { return $7ba2e76742bae147$export$68e2647985da6ebf; });

var $hbLfc = parcelRequire("hbLfc");

var $12Lyj = parcelRequire("12Lyj");

var $cA3dJ = parcelRequire("cA3dJ");
const $7ba2e76742bae147$export$68e2647985da6ebf = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $hbLfc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is "" (empty string for non-referenced clauses)
    if (objectRecord.subClauseId !== "") return false;
    // Must have a valid compoundExpression
    if (!(0, $cA3dJ.isWhereClauseCompoundExpression)(objectRecord.compoundExpression)) return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    return true;
};

});

parcelRegister("ejHCH", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithCondition", function () { return $3d3e5a63e4340018$export$e0a1c5e124a468e6; });

var $hbLfc = parcelRequire("hbLfc");

var $12Lyj = parcelRequire("12Lyj");

var $7TeSQ = parcelRequire("7TeSQ");
const $3d3e5a63e4340018$export$e0a1c5e124a468e6 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $hbLfc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is "" (empty string for non-referenced clauses)
    if (objectRecord.subClauseId !== "") return false;
    // Must have a valid condition
    if (!(0, $7TeSQ.isWhereClauseCondition)(objectRecord.condition)) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});
parcelRegister("7TeSQ", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseCondition", function () { return $30d27eedbfe765eb$export$df0591a812ecba90; });

var $12Lyj = parcelRequire("12Lyj");
const $30d27eedbfe765eb$export$df0591a812ecba90 = (value)=>{
    if (!(0, $12Lyj.isObjectRecord)(value)) return false;
    // Check strings
    if (![
        "undefined",
        "string"
    ].includes(typeof value.dataset)) return false;
    if (![
        "undefined",
        "string"
    ].includes(typeof value.variable)) return false;
    if (![
        "undefined",
        "string"
    ].includes(typeof value.comparator)) return false;
    // Check value array
    if (value.value !== undefined && (!Array.isArray(value.value) || !value.value.every((v)=>typeof v === "string"))) return false;
    // Everything is good
    return true;
};

});


parcelRegister("9QVTJ", function(module, exports) {

$parcel$export(module.exports, "isSubClauseWithReference", function () { return $0de77329a982622c$export$279cd76c77d09678; });

var $hbLfc = parcelRequire("hbLfc");

var $12Lyj = parcelRequire("12Lyj");
const $0de77329a982622c$export$279cd76c77d09678 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $hbLfc.isLevelOrder)(obj)) return false;
    // Check id is a non-blank string
    if (typeof objectRecord.id !== "string" || objectRecord.id === "") return false;
    // Check subClauseId is a non-blank string
    if (typeof objectRecord.subClauseId !== "string" || objectRecord.subClauseId === "") return false;
    // Must not have condition property
    if (objectRecord.condition !== undefined) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});




parcelRegister("cTgGQ", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseWithCondition", function () { return $5b32fa4ff72db5a3$export$2f7410233cb1ab51; });

var $hbLfc = parcelRequire("hbLfc");

var $12Lyj = parcelRequire("12Lyj");

var $7TeSQ = parcelRequire("7TeSQ");
const $5b32fa4ff72db5a3$export$2f7410233cb1ab51 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    const objectRecord = obj;
    // Check basic structure
    if (!(0, $hbLfc.isLevelOrder)(obj)) return false;
    // Must have a valid condition
    if (!(0, $7TeSQ.isWhereClauseCondition)(objectRecord.condition)) return false;
    // Must not have compoundExpression property
    if (objectRecord.compoundExpression !== undefined) return false;
    return true;
};

});



parcelRegister("IhPMk", function(module, exports) {

$parcel$export(module.exports, "isAnnotationVariable", function () { return $aaa741149b17a729$export$62d7bd2ac80ebe0f; });

var $12Lyj = parcelRequire("12Lyj");
const $aaa741149b17a729$export$62d7bd2ac80ebe0f = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.value !== "string") return false;
    if (typeof obj.oid !== "string") return false;
    if (typeof obj.name !== "string") return false;
    if (typeof obj.dataType !== "string") return false;
    if (typeof obj.length !== "number") return false;
    if (typeof obj.description !== "string") return false;
    if (typeof obj.dataset !== "string") return false;
    if (![
        "number",
        "string",
        "undefined"
    ].includes(typeof obj.codeList)) return false;
    return true;
};

});

parcelRegister("2x5bU", function(module, exports) {

$parcel$export(module.exports, "isCaseWhenCondition", function () { return $bdb563e9a5e760b3$export$85ab7521cb4ddb45; });

var $1jtoS = parcelRequire("1jtoS");

var $12Lyj = parcelRequire("12Lyj");
const $bdb563e9a5e760b3$export$85ab7521cb4ddb45 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!Array.isArray(obj.caseWhenItems)) return false;
    if (obj.caseWhenItems.some((item)=>!(0, $1jtoS.isCaseWhenItem)(item, isT))) return false;
    return true;
};

});
parcelRegister("1jtoS", function(module, exports) {

$parcel$export(module.exports, "isCaseWhenItem", function () { return $970c8451fb46ecfe$export$880314432ed2ddf0; });

var $12Lyj = parcelRequire("12Lyj");

var $6dqyB = parcelRequire("6dqyB");
const $970c8451fb46ecfe$export$880314432ed2ddf0 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (!isT(obj.displayPattern)) return false;
    if (typeof obj.resultPattern !== "string") return false;
    if (obj.when !== undefined && obj.when !== null && !(0, $6dqyB.isWhereClause)(obj.when)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("49JG0", function(module, exports) {

$parcel$export(module.exports, "isDataSubset", function () { return $abfb594aea612dd7$export$8c73c4b825c9c990; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");

var $6dqyB = parcelRequire("6dqyB");
const $abfb594aea612dd7$export$8c73c4b825c9c990 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $03NtQ.isNamedObject)(obj) || !(0, $6dqyB.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Check uniqueSubjects if present
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.uniqueSubjects)) return false;
    // Check uniqueDataSet if present
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.uniqueDataSet)) return false;
    // Check uniqueVariables if present
    if (obj.uniqueVariables !== undefined && !(Array.isArray(obj.uniqueVariables) && obj.uniqueVariables.every((v)=>typeof v === "string"))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("6PiIn", function(module, exports) {

$parcel$export(module.exports, "isGroup", function () { return $69b68352838f5f81$export$d7976824e9f55785; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");

var $6dqyB = parcelRequire("6dqyB");
const $69b68352838f5f81$export$d7976824e9f55785 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check NamedObject and WhereClause
    if (!(0, $03NtQ.isNamedObject)(obj) || !(0, $6dqyB.isWhereClause)(obj)) return false;
    // Check id
    if (typeof obj.id !== "string") return false;
    // Everything is good
    return true;
};

});

parcelRegister("czm2N", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactor", function () { return $8814915b292928ee$export$b662cc52f4a905e8; });

var $kcXWJ = parcelRequire("kcXWJ");

var $drWxP = parcelRequire("drWxP");
const $8814915b292928ee$export$b662cc52f4a905e8 = (obj)=>{
    return (0, $kcXWJ.isGroupingFactorDataDriven)(obj) || (0, $drWxP.isGroupingFactorWithGroups)(obj);
};

});
parcelRegister("kcXWJ", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactorDataDriven", function () { return $cea65ec0973b5b50$export$d792980dd40fdeec; });

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");
const $cea65ec0973b5b50$export$d792980dd40fdeec = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check NamedObject properties
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    // Check required properties and their types
    if (obj.dataDriven !== true) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.groupingDataset !== "string") return false;
    if (typeof obj.groupingVariable !== "string") return false;
    if (!Array.isArray(obj.dataValues)) return false;
    if (obj.dataValues.some((v)=>typeof v !== "string")) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.fromHierarchyId)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("drWxP", function(module, exports) {

$parcel$export(module.exports, "isGroupingFactorWithGroups", function () { return $18b09731c439e92d$export$565b5810163ecf52; });

var $6PiIn = parcelRequire("6PiIn");

var $03NtQ = parcelRequire("03NtQ");

var $12Lyj = parcelRequire("12Lyj");
const $18b09731c439e92d$export$565b5810163ecf52 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check NamedObject properties
    if (!(0, $03NtQ.isNamedObject)(obj)) return false;
    // Check required properties and their types
    if (typeof obj.id !== "string") return false;
    if (obj.dataDriven !== false) return false;
    if (!Array.isArray(obj.groups)) return false;
    if (obj.groups.some((group)=>!(0, $6PiIn.isGroup)(group))) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.fromHierarchyId)) return false;
    // Everything is good
    return true;
};

});




parcelRegister("125l7", function(module, exports) {

$parcel$export(module.exports, "arsc_addNotToWhereClause", function () { return $d1b500de8ac698e2$export$42fe98b3d28e2ad; });

var $eBlbF = parcelRequire("eBlbF");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1ZdiT");
var $6dqyB = parcelRequire("6dqyB");
var $cTgGQ = parcelRequire("cTgGQ");
const $d1b500de8ac698e2$export$42fe98b3d28e2ad = (state, action)=>{
    const whereClause = (0, $jwDoS.getFromDataPath)(action.dataPath, state, (0, $6dqyB.isWhereClause));
    if (!whereClause) throw new Error(`Invalid dataPath for NOT_WHERE_CLAUSE: ${action.dataPath}`);
    if ((0, $cTgGQ.isWhereClauseWithCondition)(whereClause)) {
        const newCompoundExpression = {
            logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT,
            whereClauses: [
                {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    condition: whereClause.condition,
                    level: whereClause.level + 1,
                    order: 0
                }
            ]
        };
        const newEntity = {
            ...(0, $eBlbF.omit)(whereClause, "condition"),
            compoundExpression: newCompoundExpression,
            level: whereClause.level,
            order: whereClause.order
        };
        return (0, $67RwR.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity);
    }
    const ce = whereClause.compoundExpression;
    if ((ce.whereClauses?.length ?? // istanbul ignore next
    0) > 1) throw new Error(`Cannot apply NOT operator to ${action.dataPath} because it has multiple sub-clauses`);
    const newCompoundExpression = {
        logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT,
        whereClauses: ce.whereClauses ?? // istanbul ignore next
        []
    };
    const newWhereClause = {
        compoundExpression: newCompoundExpression,
        level: whereClause.level,
        order: whereClause.order
    };
    return (0, $67RwR.mutateByPath)({
        ...state,
        changed: true
    }, action.dataPath, newWhereClause);
};

});

parcelRegister("j9fLB", function(module, exports) {

$parcel$export(module.exports, "arsc_changeSent", function () { return $e5bfa16ad18e27ca$export$4e092654bb1f798b; });
const $e5bfa16ad18e27ca$export$4e092654bb1f798b = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("7E63S", function(module, exports) {

$parcel$export(module.exports, "arsc_loadArsPatch", function () { return $39c77f3644b9bbae$export$4cc49bc08b78b13d; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");
const $39c77f3644b9bbae$export$4cc49bc08b78b13d = (state, action)=>{
    let newState = state;
    action.updates.forEach((update)=>{
        newState = (0, $67RwR.mutateByPath)(newState, update.dataPath, update.value);
    });
    return newState;
};

});

parcelRegister("L9kpJ", function(module, exports) {

$parcel$export(module.exports, "arsc_patchArsState", function () { return $90c84b6478ec6b1b$export$f23861c9f47d05a; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");
const $90c84b6478ec6b1b$export$f23861c9f47d05a = (state, action)=>{
    let newState = state;
    const updates = "updates" in action ? action.updates : [
        action
    ];
    for (const update of updates)newState = (0, $67RwR.mutateByPath)(newState, update.dataPath, update.value);
    return {
        ...newState,
        changed: true
    };
};

});

parcelRegister("8i2kO", function(module, exports) {

$parcel$export(module.exports, "arsc_removeArsItem", function () { return $69ead1962e593df8$export$67c0acf52a3db53d; });
parcelRequire("5SMPf");
var $X1On9 = parcelRequire("X1On9");
const $69ead1962e593df8$export$67c0acf52a3db53d = (state, action)=>(0, $X1On9.removeByPath)({
        ...state,
        changed: true
    }, action.dataPath, action.newLength);

});

parcelRegister("gJ0yP", function(module, exports) {

$parcel$export(module.exports, "arsc_removeNotFromWhereClause", function () { return $fa0efbfdcec9138b$export$1c49aa48bdaaa522; });

var $eBlbF = parcelRequire("eBlbF");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1ZdiT");
var $4FB18 = parcelRequire("4FB18");
var $ejHCH = parcelRequire("ejHCH");
var $6dqyB = parcelRequire("6dqyB");
var $lPVPO = parcelRequire("lPVPO");
const $fa0efbfdcec9138b$export$1c49aa48bdaaa522 = (state, action)=>{
    const whereClause = (0, $jwDoS.getFromDataPath)(action.dataPath, state, (0, $6dqyB.isWhereClause));
    if (!whereClause || !(0, $lPVPO.isWhereClauseWithCompoundExpression)(whereClause) || !whereClause.compoundExpression.whereClauses || whereClause.compoundExpression.whereClauses.length > 1) throw new Error(`Invalid dataPath for REMOVE_NOT_FROM_WHERE_CLAUSE: ${action.dataPath}`);
    if (whereClause.compoundExpression.logicalOperator !== (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT) throw new Error(`Cannot remove NOT operator from ${action.dataPath} because it is not a NOT clause`);
    if (whereClause.compoundExpression.whereClauses.length === 0) throw new Error(`Cannot remove NOT operator from ${action.dataPath} because it has no sub-clauses`);
    const subClause = whereClause.compoundExpression.whereClauses[0];
    if ((0, $ejHCH.isSubClauseWithCondition)(subClause)) {
        const newEntity = {
            ...(0, $eBlbF.omit)(whereClause, "compoundExpression"),
            condition: subClause.condition,
            level: subClause.level - 1,
            order: whereClause.order
        };
        return (0, $67RwR.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newEntity);
    }
    if ((0, $4FB18.isSubClauseWithCompoundExpression)(subClause)) {
        const newWhereClause = {
            compoundExpression: subClause.compoundExpression,
            level: subClause.level - 1,
            order: whereClause.order
        };
        return (0, $67RwR.mutateByPath)({
            ...state,
            changed: true
        }, action.dataPath, newWhereClause);
    }
    throw new Error(`Cannot remove NOT operator from ${action.dataPath} - sub-clause is a reference`);
};

});

parcelRegister("ePGej", function(module, exports) {

$parcel$export(module.exports, "arsc_removeWhereClause", function () { return $a84cbd15127531a5$export$58ecff8ba85d96f; });

var $eBlbF = parcelRequire("eBlbF");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");
parcelRequire("1ZdiT");
var $lPVPO = parcelRequire("lPVPO");
var $cTgGQ = parcelRequire("cTgGQ");

var $8E7ct = parcelRequire("8E7ct");
const $a84cbd15127531a5$export$58ecff8ba85d96f = (state, action)=>{
    const whereClause = (0, $jwDoS.getFromDataPath)(action.dataPath, state, (0, $lPVPO.isWhereClauseWithCompoundExpression));
    let removedState = state;
    if (whereClause) {
        const compoundExpression = whereClause.compoundExpression;
        if (!compoundExpression.whereClauses || compoundExpression.whereClauses.length <= 1) throw new Error(`Cannot remove where clause from ${action.dataPath} because it does not have multiple clauses`);
        else if (compoundExpression.whereClauses.length === 2) {
            const remainingClause = compoundExpression.whereClauses.find((clause)=>clause.id !== action.id);
            if (remainingClause) {
                if ((0, $cTgGQ.isWhereClauseWithCondition)(remainingClause)) {
                    const newEntity = {
                        ...(0, $eBlbF.omit)(whereClause, "compoundExpression"),
                        condition: remainingClause.condition,
                        level: remainingClause.level - 1,
                        order: 0
                    };
                    removedState = (0, $67RwR.mutateByPath)({
                        ...state,
                        changed: true
                    }, action.dataPath, newEntity);
                } else if ((0, $lPVPO.isWhereClauseWithCompoundExpression)(remainingClause)) {
                    const parentPath = action.dataPath.substring(0, action.dataPath.lastIndexOf("/compoundExpression/whereClauses"));
                    const parentEntity = (0, $jwDoS.getFromDataPath)(parentPath, state, (0, $lPVPO.isWhereClauseWithCompoundExpression));
                    const normalizedCompound = {
                        ...remainingClause.compoundExpression,
                        whereClauses: remainingClause.compoundExpression.whereClauses?.map((clause)=>({
                                ...clause
                            }))
                    };
                    if (parentEntity && parentEntity.compoundExpression.whereClauses?.length === 1) {
                        normalizedCompound.whereClauses?.forEach((clause, index)=>{
                            (0, $8E7ct.normalizeSubClauseLevelsAndOrders)(clause, parentEntity.level + 1, index);
                        });
                        removedState = (0, $67RwR.mutateByPath)({
                            ...state,
                            changed: true
                        }, `${parentPath}/compoundExpression`, normalizedCompound);
                    } else {
                        normalizedCompound.whereClauses?.forEach((clause, index)=>{
                            (0, $8E7ct.normalizeSubClauseLevelsAndOrders)(clause, whereClause.level + 1, index);
                        });
                        const newEntity = {
                            ...whereClause,
                            compoundExpression: normalizedCompound,
                            level: whereClause.level,
                            order: whereClause.order
                        };
                        removedState = (0, $67RwR.mutateByPath)({
                            ...state,
                            changed: true
                        }, action.dataPath, newEntity);
                    }
                } else if ("subClauseId" in whereClause) {
                    const newEntity = {
                        ...(0, $eBlbF.omit)(whereClause, "compoundExpression"),
                        subClauseId: remainingClause.subClauseId,
                        level: remainingClause.level - 1,
                        order: whereClause.order
                    };
                    removedState = (0, $67RwR.mutateByPath)({
                        ...state,
                        changed: true
                    }, action.dataPath, newEntity);
                } else throw new Error(`Cannot collapse to single clause at ${action.dataPath} - remaining clause is a reference`);
            }
        } else {
            const newWhereClauses = compoundExpression.whereClauses.filter((clause)=>clause.id !== action.id);
            const newCompoundExpression = {
                ...compoundExpression,
                whereClauses: newWhereClauses
            };
            removedState = (0, $67RwR.mutateByPath)({
                ...state,
                changed: true
            }, `${action.dataPath}/compoundExpression`, newCompoundExpression);
        }
    }
    return removedState;
};

});
parcelRegister("8E7ct", function(module, exports) {

$parcel$export(module.exports, "parseWhereClauseFromCode", function () { return $10fc1feff03009ef$export$6baa19d4f0d0724a; });
$parcel$export(module.exports, "normalizeSubClauseLevelsAndOrders", function () { return $10fc1feff03009ef$export$ff15257b9599a61a; });

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1ZdiT");
var $4FB18 = parcelRequire("4FB18");
var $lPVPO = parcelRequire("lPVPO");

var $dDwJ9 = parcelRequire("dDwJ9");
/**
 * Checks whether a character should be treated as part of a word token.
 *
 * @param char - The character to check.
 * @returns True when the character is a word character.
 */ const $10fc1feff03009ef$var$isWordChar = (char)=>/[A-Za-z0-9_]/.test(char);
/**
 * Attempts to match a logical operator at the provided index.
 *
 * @param code - The full input string.
 * @param index - The current scan index.
 * @returns The matched operator or null if none is matched.
 */ const $10fc1feff03009ef$var$matchLogicalOperator = (code, index)=>{
    const remaining = code.slice(index);
    const upper = remaining.toUpperCase();
    const operators = [
        (0, $iEmH0.ExpressionLogicalOperatorEnum).AND,
        (0, $iEmH0.ExpressionLogicalOperatorEnum).OR,
        (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT
    ];
    for (const operator of operators){
        if (!upper.startsWith(operator)) continue;
        const before = index === 0 ? "" : code[index - 1];
        const after = code[index + operator.length];
        const beforeOk = before === "" || !$10fc1feff03009ef$var$isWordChar(before);
        const afterOk = after === "" || !$10fc1feff03009ef$var$isWordChar(after);
        if (beforeOk && afterOk) return operator;
    }
    return null;
};
/**
 * Tokenises a where clause string into logical operators, groupings, references, and predicates.
 * Predicates keep comparator and value text intact, including IN list parentheses.
 *
 * @param code - The raw where clause string.
 * @returns An array of tokens or null when lexing fails.
 */ const $10fc1feff03009ef$var$tokenizeWhereClause = (code)=>{
    const tokens = [];
    let buffer = "";
    let inQuote = null;
    let predicateParenDepth = 0;
    /**
   * Pushes the current buffer as a predicate token if it contains non-whitespace content.
   */ const pushPredicate = ()=>{
        const trimmed = buffer.trim();
        if (trimmed) tokens.push({
            type: "predicate",
            value: trimmed
        });
        buffer = "";
    };
    /**
   * Returns the type of the most recently emitted token, or null if no tokens have been emitted.
   *
   * @returns The last token type or null.
   */ const lastTokenType = ()=>tokens.length > 0 ? tokens[tokens.length - 1].type : null;
    /**
   * Determines whether a unary NOT operator can be emitted based on the last token type.
   *
   * @returns True if a NOT operator can start at the current position.
   */ const canStartUnary = ()=>{
        const lastType = lastTokenType();
        return lastType === null || lastType === "and" || lastType === "or" || lastType === "not" || lastType === "lparen";
    };
    /**
   * Determines whether a binary AND/OR operator can be emitted based on the last token type.
   *
   * @returns True if an AND or OR operator can start at the current position.
   */ const canStartBinary = ()=>{
        const lastType = lastTokenType();
        return lastType === "predicate" || lastType === "reference" || lastType === "rparen";
    };
    let i = 0;
    while(i < code.length){
        const char = code[i];
        if (inQuote) {
            buffer += char;
            if (char === inQuote && code[i - 1] !== "\\") inQuote = null;
            i += 1;
            continue;
        }
        if (char === "'" || char === '"') {
            buffer += char;
            inQuote = char;
            i += 1;
            continue;
        }
        // Skip leading whitespace outside predicates
        if (char === " " && buffer.trim() === "" && predicateParenDepth === 0) {
            i += 1;
            continue;
        }
        if (char === "(" && buffer.trim() === "" && predicateParenDepth === 0) {
            tokens.push({
                type: "lparen"
            });
            i += 1;
            continue;
        }
        if (char === ")" && predicateParenDepth === 0) {
            pushPredicate();
            tokens.push({
                type: "rparen"
            });
            i += 1;
            continue;
        }
        if (char === "[" && buffer.trim() === "") {
            const closingIndex = code.indexOf("]", i + 1);
            /* istanbul ignore else - Defensive: malformed reference with no closing bracket */ if (closingIndex > i + 1) {
                const referenceId = code.slice(i + 1, closingIndex).trim();
                /* istanbul ignore else - Defensive: empty reference ID like [] */ if (referenceId) {
                    tokens.push({
                        type: "reference",
                        value: referenceId
                    });
                    i = closingIndex + 1;
                    continue;
                }
            }
        }
        if (char === "(" && buffer.trim() !== "") {
            predicateParenDepth += 1;
            buffer += char;
            i += 1;
            continue;
        }
        if (char === ")" && predicateParenDepth > 0) {
            predicateParenDepth -= 1;
            buffer += char;
            i += 1;
            continue;
        }
        const operator = $10fc1feff03009ef$var$matchLogicalOperator(code, i);
        if (operator && predicateParenDepth === 0) {
            if (operator === (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT && buffer.trim() === "" && canStartUnary()) {
                tokens.push({
                    type: "not"
                });
                i += operator.length;
                continue;
            }
            if (operator !== (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT) {
                if (buffer.trim() !== "") {
                    pushPredicate();
                    tokens.push({
                        type: operator === (0, $iEmH0.ExpressionLogicalOperatorEnum).AND ? "and" : "or"
                    });
                    i += operator.length;
                    continue;
                }
                /* istanbul ignore else - Defensive: binary operator in invalid position */ if (canStartBinary()) {
                    tokens.push({
                        type: operator === (0, $iEmH0.ExpressionLogicalOperatorEnum).AND ? "and" : "or"
                    });
                    i += operator.length;
                    continue;
                }
            }
        }
        buffer += char;
        i += 1;
    }
    if (inQuote || predicateParenDepth !== 0) return null;
    pushPredicate();
    return tokens.length > 0 ? tokens : null;
};
/**
 * Converts a parsed clause node into a sub-clause structure.
 *
 * @param node - The parsed clause node.
 * @returns The sub-clause or null if conversion fails.
 */ const $10fc1feff03009ef$var$buildSubClause = (node)=>{
    switch(node.kind){
        case "condition":
            return {
                id: crypto.randomUUID(),
                subClauseId: "",
                condition: node.condition,
                level: 0,
                order: 0
            };
        case "reference":
            return {
                id: crypto.randomUUID(),
                subClauseId: node.subClauseId,
                level: 0,
                order: 0
            };
        case "compound":
            {
                const whereClauses = node.whereClauses.map((child)=>$10fc1feff03009ef$var$buildSubClause(child)).filter((child)=>child !== null);
                /* istanbul ignore next - Defensive: parser guarantees valid node types */ if (whereClauses.length !== node.whereClauses.length) return null;
                return {
                    id: crypto.randomUUID(),
                    subClauseId: "",
                    compoundExpression: {
                        logicalOperator: node.logicalOperator,
                        whereClauses: whereClauses
                    },
                    level: 0,
                    order: 0
                };
            }
        /* istanbul ignore next - Defensive: TypeScript ensures exhaustive case coverage */ default:
            return null;
    }
};
/**
 * Parses tokens into a clause tree using logical operator precedence.
 *
 * @param tokens - The token stream to parse.
 * @param availableVariables - List of available dataset.variable combinations for validation.
 * @param availableSubClauseIds - List of available subClauseIds for validation.
 * @returns The root clause node or null when parsing fails.
 */ const $10fc1feff03009ef$var$parseTokensToClauseNode = (tokens, availableVariables, availableSubClauseIds)=>{
    let index = 0;
    let acceptedUnlistedVariable = false;
    /**
   * Returns the current token without advancing the index.
   *
   * @returns The current token or null if at end of stream.
   */ const peek = ()=>index < tokens.length ? tokens[index] : null;
    /**
   * Returns the current token and advances the index to the next token.
   *
   * @returns The consumed token or null if at end of stream.
   */ const consume = ()=>index < tokens.length ? tokens[index++] : null;
    /**
   * Parses a complete expression, starting with the lowest precedence (OR).
   *
   * @returns The parsed clause node or null if parsing fails.
   */ const parseExpression = ()=>parseOr();
    /**
   * Parses OR expressions (lowest precedence binary operator).
   * Accumulates multiple AND expressions separated by OR.
   *
   * @returns The parsed OR clause node or null if parsing fails.
   */ const parseOr = ()=>{
        const left = parseAnd();
        if (!left) return null;
        const clauses = [
            left
        ];
        while(peek()?.type === "or"){
            consume();
            const right = parseAnd();
            if (!right) return null;
            clauses.push(right);
        }
        return clauses.length === 1 ? left : {
            kind: "compound",
            logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).OR,
            whereClauses: clauses
        };
    };
    /**
   * Parses AND expressions (higher precedence than OR).
   * Accumulates multiple NOT expressions separated by AND.
   *
   * @returns The parsed AND clause node or null if parsing fails.
   */ const parseAnd = ()=>{
        const left = parseNot();
        if (!left) return null;
        const clauses = [
            left
        ];
        while(peek()?.type === "and"){
            consume();
            const right = parseNot();
            if (!right) return null;
            clauses.push(right);
        }
        return clauses.length === 1 ? left : {
            kind: "compound",
            logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).AND,
            whereClauses: clauses
        };
    };
    /**
   * Parses NOT expressions (highest precedence unary operator).
   * Recursively handles multiple consecutive NOTs.
   *
   * @returns The parsed NOT clause node or null if parsing fails.
   */ const parseNot = ()=>{
        if (peek()?.type === "not") {
            consume();
            const target = parseNot();
            if (!target) return null;
            return {
                kind: "compound",
                logicalOperator: (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT,
                whereClauses: [
                    target
                ]
            };
        }
        return parsePrimary();
    };
    /**
   * Parses primary expressions (predicates, references, and parenthesized expressions).
   * This is the highest precedence level in the grammar.
   *
   * @returns The parsed primary clause node or null if parsing fails.
   */ const parsePrimary = ()=>{
        const token = peek();
        /* istanbul ignore next - Defensive: parser logic ensures tokens exist before calling parsePrimary */ if (!token) return null;
        if (token.type === "lparen") {
            consume();
            const inner = parseExpression();
            if (!inner || peek()?.type !== "rparen") return null;
            consume();
            return inner;
        }
        if (token.type === "reference") {
            consume();
            if (!availableSubClauseIds.includes(token.value)) return null;
            return {
                kind: "reference",
                subClauseId: token.value
            };
        }
        if (token.type === "predicate") {
            consume();
            const conditionResult = (0, $dDwJ9.parseConditionFromCode)(token.value, availableVariables);
            if (!conditionResult) return null;
            acceptedUnlistedVariable ||= conditionResult.acceptedUnlistedVariable;
            return {
                kind: "condition",
                condition: conditionResult.condition
            };
        }
        return null;
    };
    const result = parseExpression();
    if (!result || index !== tokens.length) return {
        node: null,
        acceptedUnlistedVariable: false
    };
    return {
        node: result,
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
};
function $10fc1feff03009ef$export$6baa19d4f0d0724a(code, availableVariables, availableSubClauseIds = []) {
    if (!code || code.trim() === "") return false;
    const tokens = $10fc1feff03009ef$var$tokenizeWhereClause(code);
    if (!tokens) return false;
    const { node: rootNode, acceptedUnlistedVariable: acceptedUnlistedVariable } = $10fc1feff03009ef$var$parseTokensToClauseNode(tokens, availableVariables, availableSubClauseIds);
    if (!rootNode) return false;
    if (rootNode.kind === "condition") return {
        whereClause: {
            condition: rootNode.condition,
            level: 0,
            order: 0
        },
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
    if (rootNode.kind === "reference") return false;
    const whereClauses = rootNode.whereClauses.map((child)=>$10fc1feff03009ef$var$buildSubClause(child)).filter((child)=>child !== null);
    /* istanbul ignore next - Defensive: parser guarantees valid node types */ if (whereClauses.length !== rootNode.whereClauses.length) return false;
    const whereClause = {
        compoundExpression: {
            logicalOperator: rootNode.logicalOperator,
            whereClauses: whereClauses
        },
        level: 0,
        order: 0
    };
    $10fc1feff03009ef$var$normalizeWhereClauseLevelsAndOrders(whereClause);
    return {
        whereClause: whereClause,
        acceptedUnlistedVariable: acceptedUnlistedVariable
    };
}
/**
 * Normalizes level and order values in a WhereClause hierarchy.
 * Sets level = parent level + 1 for child subclauses, and incrementing order values for siblings.
 *
 * @param whereClause - The WhereClause to normalize.
 * @param parentLevel - The level of the parent (default 0 for top-level).
 */ const $10fc1feff03009ef$var$normalizeWhereClauseLevelsAndOrders = (whereClause, parentLevel = 0)=>{
    whereClause.level = parentLevel;
    whereClause.order = 0;
    /* istanbul ignore else */ if ((0, $lPVPO.isWhereClauseWithCompoundExpression)(whereClause) && whereClause.compoundExpression.whereClauses) {
        const childLevel = parentLevel + 1;
        whereClause.compoundExpression.whereClauses.forEach((subClause, index)=>{
            $10fc1feff03009ef$export$ff15257b9599a61a(subClause, childLevel, index);
        });
    }
};
const $10fc1feff03009ef$export$ff15257b9599a61a = (subClause, level, order)=>{
    subClause.level = level;
    subClause.order = order;
    if ((0, $4FB18.isSubClauseWithCompoundExpression)(subClause) && subClause.compoundExpression.whereClauses) {
        const childLevel = level + 1;
        subClause.compoundExpression.whereClauses.forEach((child, index)=>{
            $10fc1feff03009ef$export$ff15257b9599a61a(child, childLevel, index);
        });
    }
};

});
parcelRegister("dDwJ9", function(module, exports) {

$parcel$export(module.exports, "comparatorDefinitions", function () { return $b6947dff91ac680a$export$278773736a300e33; });
$parcel$export(module.exports, "parseConditionFromCode", function () { return $b6947dff91ac680a$export$8e83f93584123e08; });

var $iEmH0 = parcelRequire("iEmH0");

var $OARmT = parcelRequire("OARmT");
const $b6947dff91ac680a$export$278773736a300e33 = {
    EQ: {
        enum: (0, $iEmH0.ConditionComparatorEnum).EQ,
        write: "=",
        read: [
            "EQ",
            "="
        ]
    },
    NE: {
        enum: (0, $iEmH0.ConditionComparatorEnum).NE,
        write: "!=",
        read: [
            "NE",
            "!=",
            "<>"
        ]
    },
    GT: {
        enum: (0, $iEmH0.ConditionComparatorEnum).GT,
        write: ">",
        read: [
            "GT",
            ">"
        ]
    },
    GE: {
        enum: (0, $iEmH0.ConditionComparatorEnum).GE,
        write: ">=",
        read: [
            "GE",
            ">="
        ]
    },
    LT: {
        enum: (0, $iEmH0.ConditionComparatorEnum).LT,
        write: "<",
        read: [
            "LT",
            "<"
        ]
    },
    LE: {
        enum: (0, $iEmH0.ConditionComparatorEnum).LE,
        write: "<=",
        read: [
            "LE",
            "<="
        ]
    },
    IN: {
        enum: (0, $iEmH0.ConditionComparatorEnum).IN,
        write: "IN",
        read: [
            "IN"
        ]
    },
    NOTIN: {
        enum: (0, $iEmH0.ConditionComparatorEnum).NOTIN,
        write: "NOT IN",
        read: [
            "NOTIN",
            "NOT IN"
        ]
    }
};
/**
 * Builds a regex pattern group from read strings, escaping special regex characters.
 * Sorts by length (descending) to ensure longer patterns like "NOT IN" match before "IN".
 *
 * @param readStrings - Array of strings that should match this comparator.
 * @returns Escaped pattern string for use in regex alternation.
 */ const $b6947dff91ac680a$var$buildComparatorPattern = (readStrings)=>{
    return readStrings.slice().sort((a, b)=>b.length - a.length).map((s)=>s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
};
/**
 * Finds the comparator definition that matches the given token.
 *
 * @param token - The comparator token to look up.
 * @returns The matching comparator definition or undefined.
 */ const $b6947dff91ac680a$var$findComparatorDef = (token)=>{
    const upperToken = token.toUpperCase();
    return Object.values($b6947dff91ac680a$export$278773736a300e33).find((def)=>def.read.map((r)=>r.toUpperCase()).includes(upperToken));
};
function $b6947dff91ac680a$export$8e83f93584123e08(code, availableVariables) {
    if (!code || code.trim() === "") return false;
    const trimmed = code.trim();
    // Build regex patterns from comparator definitions
    const singleValueComparators = [];
    const listValueComparators = [];
    Object.values($b6947dff91ac680a$export$278773736a300e33).forEach((def)=>{
        const pattern = $b6947dff91ac680a$var$buildComparatorPattern(def.read);
        if (def.enum === (0, $iEmH0.ConditionComparatorEnum).IN || def.enum === (0, $iEmH0.ConditionComparatorEnum).NOTIN) listValueComparators.push(pattern);
        else singleValueComparators.push(pattern);
    });
    // Sort patterns by length (descending) to match longer patterns first
    const sortedSingleValueComparators = singleValueComparators.sort((a, b)=>b.length - a.length);
    const sortedListValueComparators = listValueComparators.sort((a, b)=>b.length - a.length);
    // Allow optional spaces around comparators (e.g., ADSL.SAFFL='Y' or ADSL.SAFFL = 'Y')
    const singleValuePattern = new RegExp(`^([A-Z0-9_]+)\\.([A-Z0-9_]+)\\s*(${sortedSingleValueComparators.join("|")})\\s*(?:'([^']*)'|"([^"]*)"|([^\\s]+))$`, "i");
    const inPattern = new RegExp(`^([A-Z0-9_]+)\\.([A-Z0-9_]+)\\s*(${sortedListValueComparators.join("|")})\\s*\\(([^)]+)\\)$`, "i");
    let match = trimmed.match(singleValuePattern);
    if (match) {
        const [, dataset, variable, comparator, singleQuotedValue, doubleQuotedValue, unquotedValue] = match;
        const datasetVariable = `${dataset.toUpperCase()}.${variable.toUpperCase()}`;
        const acceptedUnlistedVariable = (0, $OARmT.normaliseDatasetVariable)(datasetVariable) === datasetVariable;
        const isAvailableVariable = availableVariables.map((v)=>v.toUpperCase()).includes(datasetVariable);
        // Validate that the variable exists
        if (!isAvailableVariable && !acceptedUnlistedVariable) return false;
        const value = singleQuotedValue !== undefined ? singleQuotedValue : doubleQuotedValue !== undefined ? doubleQuotedValue : unquotedValue;
        const def = $b6947dff91ac680a$var$findComparatorDef(comparator);
        return def ? {
            condition: {
                dataset: dataset.toUpperCase(),
                variable: variable.toUpperCase(),
                comparator: def.enum,
                value: [
                    value
                ]
            },
            acceptedUnlistedVariable: !isAvailableVariable && acceptedUnlistedVariable
        } : false;
    }
    match = trimmed.match(inPattern);
    if (match) {
        const [, dataset, variable, comparator, valuesString] = match;
        const datasetVariable = `${dataset.toUpperCase()}.${variable.toUpperCase()}`;
        const acceptedUnlistedVariable = (0, $OARmT.normaliseDatasetVariable)(datasetVariable) === datasetVariable;
        const isAvailableVariable = availableVariables.map((v)=>v.toUpperCase()).includes(datasetVariable);
        // Validate that the variable exists
        if (!isAvailableVariable && !acceptedUnlistedVariable) return false;
        // Parse values from the IN clause
        const values = valuesString.split(",").map((v)=>v.trim()).filter((v)=>v.length > 0).map((v)=>{
            // Remove quotes if present
            if (v.startsWith("'") && v.endsWith("'") || v.startsWith('"') && v.endsWith('"')) return v.slice(1, -1);
            return v;
        });
        if (values.length === 0) return false;
        const def = $b6947dff91ac680a$var$findComparatorDef(comparator);
        // istanbul ignore next - defensive check, should never fail since regex is built from definitions
        return def ? {
            condition: {
                dataset: dataset.toUpperCase(),
                variable: variable.toUpperCase(),
                comparator: def.enum,
                value: values
            },
            acceptedUnlistedVariable: !isAvailableVariable && acceptedUnlistedVariable
        } : false;
    }
    // No match found
    return false;
}

});
parcelRegister("OARmT", function(module, exports) {

$parcel$export(module.exports, "normaliseDatasetVariable", function () { return $f0a5188e816c0cd9$export$bae91192748a9ffb; });

var $cncLz = parcelRequire("cncLz");
const $f0a5188e816c0cd9$export$bae91192748a9ffb = (value)=>{
    const trimmedValue = value.trim();
    const match = (0, $cncLz.DATASET_VARIABLE_PATTERN).exec(trimmedValue);
    return match ? `${match[1].toUpperCase()}.${match[2].toUpperCase()}` : null;
};

});
parcelRegister("cncLz", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_DATASET_VARIABLE_WARNING", function () { return $17d6008a1bc8e024$export$871b3f531f482a32; });
$parcel$export(module.exports, "DATASET_VARIABLE_PATTERN", function () { return $17d6008a1bc8e024$export$93f0d4ea94b02498; });
/**
 * Warning shown when a correctly formatted dataset.variable value is not present in the
 * available variables list.
 */ const $17d6008a1bc8e024$export$871b3f531f482a32 = "This 'dataset.variable' is not in the list of available variables";
/**
 * Maximum allowed length for the dataset and variable parts of a dataset.variable value.
 */ const $17d6008a1bc8e024$var$DATASET_VARIABLE_PART_MAX_LENGTH = 32;
const $17d6008a1bc8e024$export$93f0d4ea94b02498 = new RegExp(`^([A-Za-z_][A-Za-z0-9_]{0,${$17d6008a1bc8e024$var$DATASET_VARIABLE_PART_MAX_LENGTH - 1}})\\.([A-Za-z_][A-Za-z0-9_]{0,${$17d6008a1bc8e024$var$DATASET_VARIABLE_PART_MAX_LENGTH - 1}})$`, "i");

});





parcelRegister("1o4wl", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarAnalysisMethodId", function () { return $fb696426753122cf$export$573b6539ae3901d3; });
const $fb696426753122cf$export$573b6539ae3901d3 = (state, action)=>{
    if (action.analysisMethodId && !Object.keys(state.analysisMethods).includes(action.analysisMethodId)) return state;
    return {
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            analysisMethodId: action.analysisMethodId
        }
    };
};

});

parcelRegister("4FLQz", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarDataset", function () { return $2ab2da5e32bc4971$export$6e6ba20af486399c; });
const $2ab2da5e32bc4971$export$6e6ba20af486399c = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            dataset: action.dataset
        }
    });

});

parcelRegister("dOlaU", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarFilter", function () { return $57eec2eeab32c2e0$export$3a3cd8a9efe6302d; });
const $57eec2eeab32c2e0$export$3a3cd8a9efe6302d = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            filter: action.filter
        }
    });

});

parcelRegister("ctJKH", function(module, exports) {

$parcel$export(module.exports, "arsc_setSidebarView", function () { return $57cfd9ea45095b3f$export$7f9c530b737fb37b; });
const $57cfd9ea45095b3f$export$7f9c530b737fb37b = (state, action)=>({
        ...state,
        currentSidebar: {
            ...state.currentSidebar,
            view: action.view
        }
    });

});

parcelRegister("1I6ja", function(module, exports) {

$parcel$export(module.exports, "arsc_setUiRequestStatus", function () { return $95cbe62012cf147c$export$a77aff271a01de06; });
const $95cbe62012cf147c$export$a77aff271a01de06 = (state, action)=>({
        ...state,
        uiRequestStatus: action.uiRequestStatus
    });

});

parcelRegister("ac7gP", function(module, exports) {

$parcel$export(module.exports, "arsc_setVariablesInUse", function () { return $7db451f60cd7eeeb$export$3536b4a3d351827e; });
const $7db451f60cd7eeeb$export$3536b4a3d351827e = (state, action)=>{
    const datasetsInUse = new Set(Array.from(action.variablesInUse).flatMap((varName)=>varName.split(".")[0]));
    return {
        ...state,
        datasetsInUse: datasetsInUse,
        variablesInUse: action.variablesInUse
    };
};

});


parcelRegister("cJd2i", function(module, exports) {

$parcel$export(module.exports, "CURRENT_HIERARCHY_ID", function () { return $9b9e190d6c5a4f9b$export$4f0b6970955c9123; });
$parcel$export(module.exports, "ADD_EXTRA_WHERE_CLAUSE", function () { return $9b9e190d6c5a4f9b$export$3912afcb6b7edd68; });
$parcel$export(module.exports, "ADD_NOT_TO_WHERE_CLAUSE", function () { return $9b9e190d6c5a4f9b$export$545344ae9a096bed; });
$parcel$export(module.exports, "ARS_CHANGE_SENT", function () { return $9b9e190d6c5a4f9b$export$6fabd0b616fe4052; });
$parcel$export(module.exports, "LOAD_ARS_PATCH", function () { return $9b9e190d6c5a4f9b$export$f8a4a712c6311d83; });
$parcel$export(module.exports, "PATCH_ARS_STATE", function () { return $9b9e190d6c5a4f9b$export$4bb8ad8cad329501; });
$parcel$export(module.exports, "REMOVE_ARS_ITEM", function () { return $9b9e190d6c5a4f9b$export$d176a2e1750e98f9; });
$parcel$export(module.exports, "REMOVE_NOT_FROM_WHERE_CLAUSE", function () { return $9b9e190d6c5a4f9b$export$cabe4bcf8c89f956; });
$parcel$export(module.exports, "REMOVE_WHERE_CLAUSE", function () { return $9b9e190d6c5a4f9b$export$d21ab455e9f38f6e; });
$parcel$export(module.exports, "SET_SIDEBAR_ANALYSIS_METHOD_ID", function () { return $9b9e190d6c5a4f9b$export$cffad4d3def4d19f; });
$parcel$export(module.exports, "SET_SIDEBAR_DATASET", function () { return $9b9e190d6c5a4f9b$export$44da99aaf8bfb48b; });
$parcel$export(module.exports, "SET_SIDEBAR_FILTER", function () { return $9b9e190d6c5a4f9b$export$765fe3a6e1d0b478; });
$parcel$export(module.exports, "SET_SIDEBAR_VIEW", function () { return $9b9e190d6c5a4f9b$export$8dd709d4cb9f58f8; });
$parcel$export(module.exports, "SET_UI_REQUEST_STATUS", function () { return $9b9e190d6c5a4f9b$export$db8956672730be81; });
$parcel$export(module.exports, "SET_VARIABLES_IN_USE", function () { return $9b9e190d6c5a4f9b$export$ffc598eb026768a5; });
const $9b9e190d6c5a4f9b$export$4f0b6970955c9123 = "__current__";
const $9b9e190d6c5a4f9b$export$3912afcb6b7edd68 = "ADD_EXTRA_WHERE_CLAUSE";
const $9b9e190d6c5a4f9b$export$545344ae9a096bed = "ADD_NOT_TO_WHERE_CLAUSE";
const $9b9e190d6c5a4f9b$export$6fabd0b616fe4052 = "ARS_CHANGE_SENT";
const $9b9e190d6c5a4f9b$export$f8a4a712c6311d83 = "LOAD_ARS_PATCH";
const $9b9e190d6c5a4f9b$export$4bb8ad8cad329501 = "PATCH_ARS_STATE";
const $9b9e190d6c5a4f9b$export$d176a2e1750e98f9 = "REMOVE_ARS_ITEM";
const $9b9e190d6c5a4f9b$export$cabe4bcf8c89f956 = "REMOVE_NOT_FROM_WHERE_CLAUSE";
const $9b9e190d6c5a4f9b$export$d21ab455e9f38f6e = "REMOVE_WHERE_CLAUSE";
const $9b9e190d6c5a4f9b$export$7431817582ed8a25 = "RESET_STATE";
const $9b9e190d6c5a4f9b$export$cffad4d3def4d19f = "SET_SIDEBAR_ANALYSIS_METHOD_ID";
const $9b9e190d6c5a4f9b$export$44da99aaf8bfb48b = "SET_SIDEBAR_DATASET";
const $9b9e190d6c5a4f9b$export$765fe3a6e1d0b478 = "SET_SIDEBAR_FILTER";
const $9b9e190d6c5a4f9b$export$8dd709d4cb9f58f8 = "SET_SIDEBAR_VIEW";
const $9b9e190d6c5a4f9b$export$db8956672730be81 = "SET_UI_REQUEST_STATUS";
const $9b9e190d6c5a4f9b$export$ffc598eb026768a5 = "SET_VARIABLES_IN_USE";

});



parcelRegister("7byiZ", function(module, exports) {

$parcel$export(module.exports, "createNewAnalysisMethod", function () { return $d443bc19a6190923$export$c5681825d741e59e; });
$parcel$export(module.exports, "createNewAnalysisSet", function () { return $d443bc19a6190923$export$3f54066e8c80d26f; });
$parcel$export(module.exports, "createNewDataSubset", function () { return $d443bc19a6190923$export$e01d8a5d48196499; });
$parcel$export(module.exports, "createNewGroupingFactor", function () { return $d443bc19a6190923$export$ab13c7a12bef3f24; });
$parcel$export(module.exports, "createNewGroup", function () { return $d443bc19a6190923$export$8197413158a6a707; });

var $cJd2i = parcelRequire("cJd2i");
const $d443bc19a6190923$export$c5681825d741e59e = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        operations: [],
        codeTemplate: {
            context: "",
            code: ""
        },
        fromHierarchyId: (0, $cJd2i.CURRENT_HIERARCHY_ID)
    });
const $d443bc19a6190923$export$3f54066e8c80d26f = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        level: 0,
        order: 0,
        condition: {
            dataset: "",
            variable: ""
        },
        fromHierarchyId: (0, $cJd2i.CURRENT_HIERARCHY_ID)
    });
const $d443bc19a6190923$export$e01d8a5d48196499 = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        level: 0,
        order: 0,
        condition: {
            dataset: "",
            variable: ""
        },
        fromHierarchyId: (0, $cJd2i.CURRENT_HIERARCHY_ID)
    });
const $d443bc19a6190923$export$ab13c7a12bef3f24 = (name)=>({
        id: crypto.randomUUID(),
        name: name,
        dataDriven: false,
        groups: [],
        fromHierarchyId: (0, $cJd2i.CURRENT_HIERARCHY_ID)
    });
const $d443bc19a6190923$export$8197413158a6a707 = (name, order)=>({
        id: crypto.randomUUID(),
        name: name,
        label: name,
        description: "",
        condition: {},
        level: 0,
        order: order
    });

});

parcelRegister("7RQn4", function(module, exports) {

$parcel$export(module.exports, "hasArsObjectWithName", function () { return $6aa0c07e85d01bf1$export$a746c501b6d0fc51; });
$parcel$export(module.exports, "cloneArsObject", function () { return $6aa0c07e85d01bf1$export$87722bce1ba81ee0; });

var $eBlbF = parcelRequire("eBlbF");

var $cJd2i = parcelRequire("cJd2i");
const $6aa0c07e85d01bf1$export$a746c501b6d0fc51 = (items, item)=>(items ?? []).some((currentItem)=>currentItem.name === item.name);
const $6aa0c07e85d01bf1$export$87722bce1ba81ee0 = (item)=>{
    const copiedItem = (0, $eBlbF.cloneDeep)(item);
    copiedItem.id = crypto.randomUUID();
    copiedItem.fromHierarchyId = (0, $cJd2i.CURRENT_HIERARCHY_ID);
    delete copiedItem.disableEditing;
    return copiedItem;
};

});

parcelRegister("7G3Xj", function(module, exports) {

$parcel$export(module.exports, "MultipleDatasetCheck", function () { return $de08f9f1b6e44a63$export$983eb9c426b83475; });

var $bR5nk = parcelRequire("bR5nk");

var $jSGv3 = parcelRequire("jSGv3");

var $4hgF7 = parcelRequire("4hgF7");
const $de08f9f1b6e44a63$export$983eb9c426b83475 = ()=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    return Array.from(state.datasetsInUse).filter((d)=>d !== "ADSL").length <= 1 ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: `text-danger`,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jSGv3.default), {}),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                className: "mx-1",
                children: [
                    "The listing is being built from multiple datasets (",
                    Array.from(state.datasetsInUse).join(", "),
                    ")."
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                children: "This may result in unexpected behaviour."
            })
        ]
    });
};
$de08f9f1b6e44a63$export$983eb9c426b83475.displayName = "MultipleDatasetCheck";

});
parcelRegister("jSGv3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e794071386ea03ac$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $e794071386ea03ac$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $e794071386ea03ac$var$_extends() {
    return $e794071386ea03ac$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e794071386ea03ac$var$_extends.apply(null, arguments);
}
function $e794071386ea03ac$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e794071386ea03ac$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e794071386ea03ac$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e794071386ea03ac$var$ExclamationOctagonFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $e794071386ea03ac$var$_objectWithoutProperties(_ref, $e794071386ea03ac$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $e794071386ea03ac$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-octagon-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM8 4c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995A.905.905 0 0 1 8 4m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    }));
});
$e794071386ea03ac$var$ExclamationOctagonFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $e794071386ea03ac$export$2e2bcd8739ae039 = $e794071386ea03ac$var$ExclamationOctagonFill;

});
parcelRegister("fGs19", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $59LGR = parcelRequire("59LGR");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $b6b082f4faa66d58$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("1Xt73"))($59LGR.isElement, $b6b082f4faa66d58$var$throwOnDirectAccess);

});
parcelRegister("59LGR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dpdi0"));

});
parcelRegister("dpdi0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $9c27eb2d52fb90f2$export$2b8d127b894957b9; }, function (v) { return $9c27eb2d52fb90f2$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $9c27eb2d52fb90f2$export$cea3a54a6425200c; }, function (v) { return $9c27eb2d52fb90f2$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $9c27eb2d52fb90f2$export$a7c73072b1a182ae; }, function (v) { return $9c27eb2d52fb90f2$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9c27eb2d52fb90f2$export$9f27bc3417b4524d; }, function (v) { return $9c27eb2d52fb90f2$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9c27eb2d52fb90f2$export$db77ccec0bb4ccac; }, function (v) { return $9c27eb2d52fb90f2$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9c27eb2d52fb90f2$export$8392c0c9d3dcbd35; }, function (v) { return $9c27eb2d52fb90f2$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9c27eb2d52fb90f2$export$ffb0004e005737fa; }, function (v) { return $9c27eb2d52fb90f2$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9c27eb2d52fb90f2$export$b624eff549462981; }, function (v) { return $9c27eb2d52fb90f2$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9c27eb2d52fb90f2$export$7897aa7841a5380c; }, function (v) { return $9c27eb2d52fb90f2$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9c27eb2d52fb90f2$export$602eac185826482c; }, function (v) { return $9c27eb2d52fb90f2$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9c27eb2d52fb90f2$export$e2c29f18771995cb; }, function (v) { return $9c27eb2d52fb90f2$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9c27eb2d52fb90f2$export$5f8d39834fd61797; }, function (v) { return $9c27eb2d52fb90f2$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9c27eb2d52fb90f2$export$74bf444e3cd11ea5; }, function (v) { return $9c27eb2d52fb90f2$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9c27eb2d52fb90f2$export$92387174baf9b227; }, function (v) { return $9c27eb2d52fb90f2$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9c27eb2d52fb90f2$export$ec112efeb987d9c6; }, function (v) { return $9c27eb2d52fb90f2$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9c27eb2d52fb90f2$export$b706b080d889d2c9; }, function (v) { return $9c27eb2d52fb90f2$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9c27eb2d52fb90f2$export$5be5a87408f70ddc; }, function (v) { return $9c27eb2d52fb90f2$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9c27eb2d52fb90f2$export$45a5e7f76e0caa8d; }, function (v) { return $9c27eb2d52fb90f2$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9c27eb2d52fb90f2$export$455c2e768291efa6; }, function (v) { return $9c27eb2d52fb90f2$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9c27eb2d52fb90f2$export$9522e17588c12572; }, function (v) { return $9c27eb2d52fb90f2$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9c27eb2d52fb90f2$export$2110ac352bb060b9; }, function (v) { return $9c27eb2d52fb90f2$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9c27eb2d52fb90f2$export$56885ab8b9c456ab; }, function (v) { return $9c27eb2d52fb90f2$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9c27eb2d52fb90f2$export$d927fcb6adf8f9de; }, function (v) { return $9c27eb2d52fb90f2$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9c27eb2d52fb90f2$export$b82d16f27459e05a; }, function (v) { return $9c27eb2d52fb90f2$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9c27eb2d52fb90f2$export$522c17b4f5e123e8; }, function (v) { return $9c27eb2d52fb90f2$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9c27eb2d52fb90f2$export$1aabd8a0274ecfd6; }, function (v) { return $9c27eb2d52fb90f2$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9c27eb2d52fb90f2$export$9b621391a187a31a; }, function (v) { return $9c27eb2d52fb90f2$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9c27eb2d52fb90f2$export$f5bbd400c2f4426f; }, function (v) { return $9c27eb2d52fb90f2$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c27eb2d52fb90f2$export$2b8d127b894957b9;
var $9c27eb2d52fb90f2$export$cea3a54a6425200c;
var $9c27eb2d52fb90f2$export$a7c73072b1a182ae;
var $9c27eb2d52fb90f2$export$9f27bc3417b4524d;
var $9c27eb2d52fb90f2$export$db77ccec0bb4ccac;
var $9c27eb2d52fb90f2$export$8392c0c9d3dcbd35;
var $9c27eb2d52fb90f2$export$ffb0004e005737fa;
var $9c27eb2d52fb90f2$export$b624eff549462981;
var $9c27eb2d52fb90f2$export$7897aa7841a5380c;
var $9c27eb2d52fb90f2$export$602eac185826482c;
var $9c27eb2d52fb90f2$export$e2c29f18771995cb;
var $9c27eb2d52fb90f2$export$5f8d39834fd61797;
var $9c27eb2d52fb90f2$export$74bf444e3cd11ea5;
var $9c27eb2d52fb90f2$export$92387174baf9b227;
var $9c27eb2d52fb90f2$export$ec112efeb987d9c6;
var $9c27eb2d52fb90f2$export$b706b080d889d2c9;
var $9c27eb2d52fb90f2$export$5be5a87408f70ddc;
var $9c27eb2d52fb90f2$export$45a5e7f76e0caa8d;
var $9c27eb2d52fb90f2$export$455c2e768291efa6;
var $9c27eb2d52fb90f2$export$9522e17588c12572;
var $9c27eb2d52fb90f2$export$2110ac352bb060b9;
var $9c27eb2d52fb90f2$export$56885ab8b9c456ab;
var $9c27eb2d52fb90f2$export$d927fcb6adf8f9de;
var $9c27eb2d52fb90f2$export$b82d16f27459e05a;
var $9c27eb2d52fb90f2$export$522c17b4f5e123e8;
var $9c27eb2d52fb90f2$export$1aabd8a0274ecfd6;
var $9c27eb2d52fb90f2$export$9b621391a187a31a;
var $9c27eb2d52fb90f2$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $9c27eb2d52fb90f2$export$2b8d127b894957b9 = AsyncMode;
    $9c27eb2d52fb90f2$export$cea3a54a6425200c = ConcurrentMode;
    $9c27eb2d52fb90f2$export$a7c73072b1a182ae = ContextConsumer;
    $9c27eb2d52fb90f2$export$9f27bc3417b4524d = ContextProvider;
    $9c27eb2d52fb90f2$export$db77ccec0bb4ccac = Element;
    $9c27eb2d52fb90f2$export$8392c0c9d3dcbd35 = ForwardRef;
    $9c27eb2d52fb90f2$export$ffb0004e005737fa = Fragment;
    $9c27eb2d52fb90f2$export$b624eff549462981 = Lazy;
    $9c27eb2d52fb90f2$export$7897aa7841a5380c = Memo;
    $9c27eb2d52fb90f2$export$602eac185826482c = Portal;
    $9c27eb2d52fb90f2$export$e2c29f18771995cb = Profiler;
    $9c27eb2d52fb90f2$export$5f8d39834fd61797 = StrictMode;
    $9c27eb2d52fb90f2$export$74bf444e3cd11ea5 = Suspense;
    $9c27eb2d52fb90f2$export$92387174baf9b227 = isAsyncMode;
    $9c27eb2d52fb90f2$export$ec112efeb987d9c6 = isConcurrentMode;
    $9c27eb2d52fb90f2$export$b706b080d889d2c9 = isContextConsumer;
    $9c27eb2d52fb90f2$export$5be5a87408f70ddc = isContextProvider;
    $9c27eb2d52fb90f2$export$45a5e7f76e0caa8d = isElement;
    $9c27eb2d52fb90f2$export$455c2e768291efa6 = isForwardRef;
    $9c27eb2d52fb90f2$export$9522e17588c12572 = isFragment;
    $9c27eb2d52fb90f2$export$2110ac352bb060b9 = isLazy;
    $9c27eb2d52fb90f2$export$56885ab8b9c456ab = isMemo;
    $9c27eb2d52fb90f2$export$d927fcb6adf8f9de = isPortal;
    $9c27eb2d52fb90f2$export$b82d16f27459e05a = isProfiler;
    $9c27eb2d52fb90f2$export$522c17b4f5e123e8 = isStrictMode;
    $9c27eb2d52fb90f2$export$1aabd8a0274ecfd6 = isSuspense;
    $9c27eb2d52fb90f2$export$9b621391a187a31a = isValidElementType;
    $9c27eb2d52fb90f2$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("1Xt73", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $59LGR = parcelRequire("59LGR");

var $gBhuC = parcelRequire("gBhuC");

var $hy8fX = parcelRequire("hy8fX");

var $kltdL = parcelRequire("kltdL");

var $aeUi5 = parcelRequire("aeUi5");
var $16d1e24cea466d1f$var$printWarning = function() {};
$16d1e24cea466d1f$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $16d1e24cea466d1f$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $hy8fX) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $16d1e24cea466d1f$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($16d1e24cea466d1f$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $hy8fX);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$59LGR.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $16d1e24cea466d1f$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $16d1e24cea466d1f$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $16d1e24cea466d1f$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($kltdL(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $hy8fX);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $16d1e24cea466d1f$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $16d1e24cea466d1f$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $16d1e24cea466d1f$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $16d1e24cea466d1f$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $hy8fX);
                if (checkerResult == null) return null;
                if (checkerResult.data && $kltdL(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $hy8fX);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $gBhuC({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($kltdL(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $hy8fX);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $aeUi5;
    ReactPropTypes.resetWarningCache = $aeUi5.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("gBhuC", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $c15dabc7dd0da0b0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c15dabc7dd0da0b0$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $c15dabc7dd0da0b0$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $c15dabc7dd0da0b0$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $c15dabc7dd0da0b0$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $c15dabc7dd0da0b0$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $c15dabc7dd0da0b0$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($c15dabc7dd0da0b0$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($c15dabc7dd0da0b0$var$getOwnPropertySymbols) {
            symbols = $c15dabc7dd0da0b0$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($c15dabc7dd0da0b0$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("hy8fX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $cc6c042e977160a8$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $cc6c042e977160a8$var$ReactPropTypesSecret;

});

parcelRegister("kltdL", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("aeUi5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $7746e05a9cd3e525$var$printWarning = function() {};

var $hy8fX = parcelRequire("hy8fX");
var $7746e05a9cd3e525$var$loggedTypeFailures = {};

var $kltdL = parcelRequire("kltdL");
$7746e05a9cd3e525$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $7746e05a9cd3e525$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($kltdL(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $hy8fX);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $7746e05a9cd3e525$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $7746e05a9cd3e525$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $7746e05a9cd3e525$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $7746e05a9cd3e525$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $7746e05a9cd3e525$var$checkPropTypes.resetWarningCache = function() {
    $7746e05a9cd3e525$var$loggedTypeFailures = {};
};
module.exports = $7746e05a9cd3e525$var$checkPropTypes;

});






parcelRegister("jP6k0", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarItemKind", function () { return $b1ef124904668be5$export$255c8eaae90ff2f5; });
var $b1ef124904668be5$export$255c8eaae90ff2f5 = /*#__PURE__*/ function(ArsSidebarItemKind) {
    ArsSidebarItemKind["AnalysisMethod"] = "analysisMethod";
    ArsSidebarItemKind["GroupingFactor"] = "groupingFactor";
    ArsSidebarItemKind["Operation"] = "operation";
    ArsSidebarItemKind["Variable"] = "variable";
    return ArsSidebarItemKind;
}({});

});

parcelRegister("f4xry", function(module, exports) {

$parcel$export(module.exports, "isArsSidebarItemData", function () { return $e67cc22afcfbae40$export$c346f5059222947c; });

var $ghR9g = parcelRequire("ghR9g");

var $IhPMk = parcelRequire("IhPMk");

var $czm2N = parcelRequire("czm2N");

var $12Lyj = parcelRequire("12Lyj");

var $j3kPF = parcelRequire("j3kPF");
const $e67cc22afcfbae40$export$c346f5059222947c = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj) || !("kind" in obj) || !("dropItem" in obj)) return false;
    // Check sub object
    if (obj.kind === "groupingFactor") return (0, $czm2N.isGroupingFactor)(obj.dropItem);
    else if (obj.kind === "analysisMethod") return (0, $ghR9g.isAnalysisMethod)(obj.dropItem);
    else if (obj.kind === "operation") return (0, $j3kPF.isOperation)(obj.dropItem);
    else if (obj.kind === "variable") return (0, $IhPMk.isAnnotationVariable)(obj.dropItem);
    // Not good
    return false;
};

});

parcelRegister("jZnkP", function(module, exports) {

$parcel$export(module.exports, "ArsBlockDropZone", function () { return $7faddbdd75e14ac9$export$4616c5256231f105; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
const $7faddbdd75e14ac9$export$ea09616471217332 = "#4dabf7";
const $7faddbdd75e14ac9$export$4616c5256231f105 = ({ id: id, onDrop: onDrop, top: top, bottom: bottom })=>{
    const { state: arsState } = (0, $4hgF7.useArsContext)();
    const [showHighlight, setShowHighlight] = (0, $spJKX.useState)(false);
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: id,
        className: "ars-block-drop-zone",
        onDragOver: (e)=>{
            e.preventDefault();
            // Can only drop when the current view is showing the right thing
            if (arsState.currentSidebar.view === "groupingFactor") {
                setShowHighlight(true);
                e.dataTransfer.dropEffect = "copy";
            } else {
                setShowHighlight(false);
                e.dataTransfer.dropEffect = "none";
            }
        },
        onDragLeave: (e)=>{
            e.preventDefault();
            e.dataTransfer.dropEffect = "none";
            setShowHighlight(false);
        },
        onDrop: (e)=>{
            e.preventDefault();
            setShowHighlight(false);
            onDrop(e);
        },
        style: {
            backgroundColor: showHighlight ? $7faddbdd75e14ac9$export$ea09616471217332 : undefined,
            border: showHighlight ? `2px solid ${$7faddbdd75e14ac9$export$ea09616471217332}` : undefined,
            bottom: bottom,
            left: 0,
            opacity: showHighlight ? "0.5" : "0",
            position: "absolute",
            right: 0,
            top: top,
            zIndex: 199
        }
    });
};
$7faddbdd75e14ac9$export$4616c5256231f105.displayName = "ArsBlockDropZone";

});

parcelRegister("eIjwt", function(module, exports) {

$parcel$export(module.exports, "ArsBlockLine", function () { return $5197e4eeac7ffe29$export$3a579d6a3465a635; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $biia9 = parcelRequire("biia9");

var $9zfAS = parcelRequire("9zfAS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
const $5197e4eeac7ffe29$export$3a579d6a3465a635 = ({ disabled: disabled = false, editorDefns: editorDefns, pageByIndex: pageByIndex, setValue: setValue, value: value })=>{
    const { state: arsState } = (0, $4hgF7.useArsContext)();
    const pageByItem = value[pageByIndex];
    const groupingFactor = arsState.groupingFactors[pageByItem.groupingFactorId];
    const label = pageByItem.label !== undefined ? pageByItem.label : editorDefns.textToT(groupingFactor?.label ?? groupingFactor?.name ?? // istanbul ignore next
    "Unknown grouping factor");
    /**
   * Remove the current line from the array
   */ const removeLine = ()=>{
        setValue(value.filter((_, itemIndex)=>itemIndex !== pageByIndex));
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLine,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).calcSize,
                menuItems: disabled ? [] : [
                    {
                        label: "Delete line",
                        action: removeLine
                    }
                ],
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItemHolder,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexGrow1,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItem,
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)(editorDefns.Editor, {
                                id: `ars-block-line-editor-${pageByIndex}`,
                                value: label,
                                editable: !disabled,
                                setValue: (ret)=>{
                                    const newPageItem = {
                                        ...pageByItem,
                                        label: ret
                                    };
                                    const newPageBy = value.map((item, index)=>index === pageByIndex ? newPageItem : item);
                                    setValue(newPageBy);
                                }
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons,
                children: !disabled ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                    id: `ars-block-remove-line-${pageByIndex}`,
                    iconName: "aioxMinus",
                    onClick: removeLine,
                    tipText: "Remove page by line"
                }) : null
            })
        ]
    });
};
$5197e4eeac7ffe29$export$3a579d6a3465a635.displayName = "ArsBlockLine";

});


parcelRegister("3J0K0", function(module, exports) {

});


parcelRegister("d0WZT", function(module, exports) {
$parcel$export(module.exports, "AnalysisMethodControl", function () { return (parcelRequire("321H1")).AnalysisMethodControl; });
$parcel$export(module.exports, "AnalysisSetControl", function () { return (parcelRequire("36pkg")).AnalysisSetControl; });
$parcel$export(module.exports, "CaseWhenControl", function () { return (parcelRequire("3C4oq")).CaseWhenControl; });
$parcel$export(module.exports, "DataSubsetControl", function () { return (parcelRequire("dMUCw")).DataSubsetControl; });
$parcel$export(module.exports, "GroupingFactorControl", function () { return (parcelRequire("51n1k")).GroupingFactorControl; });
$parcel$export(module.exports, "OperationControl", function () { return (parcelRequire("j32AA")).OperationControl; });
$parcel$export(module.exports, "ReferencedEntityControl", function () { return (parcelRequire("cr6aM")).ReferencedEntityControl; });
$parcel$export(module.exports, "WhereClauseInput", function () { return (parcelRequire("2udjB")).WhereClauseInput; });
parcelRequire("8QBWT");
parcelRequire("eaCIg");
parcelRequire("321H1");
parcelRequire("4AeiR");
parcelRequire("dhw82");
parcelRequire("afLof");
parcelRequire("8MT0G");
parcelRequire("36pkg");
parcelRequire("3C4oq");
parcelRequire("dMUCw");
parcelRequire("96lV1");
parcelRequire("7afc2");
parcelRequire("51n1k");
parcelRequire("a5JBX");
parcelRequire("j32AA");
parcelRequire("2qbjE");
parcelRequire("cr6aM");
parcelRequire("jmOP2");
parcelRequire("bRLeU");
parcelRequire("bwkcO");
parcelRequire("2fs6I");
parcelRequire("PD7KB");
parcelRequire("imiah");
parcelRequire("2udjB");
parcelRequire("dZDV0");

});
parcelRegister("8QBWT", function(module, exports) {

$parcel$export(module.exports, "AddWhereClauseButton", function () { return $05be33e1f673ce48$export$49cc53c327ca84a7; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");

var $iuDOI = parcelRequire("iuDOI");
const $05be33e1f673ce48$export$49cc53c327ca84a7 = ({ id: id, onClick: onClick, isPending: isPending, disabled: disabled = false })=>/*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        "aria-label": "Add clause",
        className: "mt-2 d-flex align-items-center",
        disabled: isPending || disabled,
        id: id,
        onClick: onClick,
        requestStatus: isPending ? {
            requesting: true,
            error: false
        } : undefined,
        size: "sm",
        variant: "success",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                className: "me-2",
                children: "Add clause"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
        ]
    });
$05be33e1f673ce48$export$49cc53c327ca84a7.displayName = "AddWhereClauseButton";

});
parcelRegister("gCZ2V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1af8c79a83ef1d2$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $c1af8c79a83ef1d2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $c1af8c79a83ef1d2$var$_extends() {
    return $c1af8c79a83ef1d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1af8c79a83ef1d2$var$_extends.apply(null, arguments);
}
function $c1af8c79a83ef1d2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c1af8c79a83ef1d2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c1af8c79a83ef1d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c1af8c79a83ef1d2$var$PlusCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $c1af8c79a83ef1d2$var$_objectWithoutProperties(_ref, $c1af8c79a83ef1d2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $c1af8c79a83ef1d2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-plus-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"
    }));
});
$c1af8c79a83ef1d2$var$PlusCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $c1af8c79a83ef1d2$export$2e2bcd8739ae039 = $c1af8c79a83ef1d2$var$PlusCircle;

});

parcelRegister("iuDOI", function(module, exports) {

$parcel$export(module.exports, "AsyncButton", function () { return $fd9ccd0d99aa9b9a$export$3956658c2d361270; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");

var $lYgW3 = parcelRequire("lYgW3");
parcelRequire("5SMPf");
var $1wSYE = parcelRequire("1wSYE");
const $fd9ccd0d99aa9b9a$export$3956658c2d361270 = ({ requestStatus: requestStatus, pauseCoverText: pauseCoverText, ...props })=>{
    const requesting = Array.isArray(requestStatus) ? requestStatus.some((s)=>s.requesting) : requestStatus?.requesting;
    const error = Array.isArray(requestStatus) ? requestStatus.some((s)=>s.error) : requestStatus?.error;
    const errorText = Array.isArray(requestStatus) ? requestStatus.filter((s)=>s.error && s.errorText)?.map((s)=>s.errorText).join(", ") : requestStatus?.errorText;
    const buttonRef = (0, $spJKX.useRef)(null);
    const coverTextRef = (0, $spJKX.useRef)(null);
    const [minWidth, setMinWidth] = (0, $spJKX.useState)("0px");
    (0, $spJKX.useEffect)(()=>{
        const button = buttonRef.current;
        const coverText = coverTextRef.current;
        if (button && coverText && requesting) {
            let coverTextWidth = coverText.offsetWidth;
            coverTextWidth = coverTextWidth + 26; // 26 for the spinner and a bit of padding
            const buttonWidth = button.offsetWidth;
            /* istanbul ignore else */ if (coverTextWidth > buttonWidth) setMinWidth(`${coverTextWidth}px`);
        } else setMinWidth("0px");
    }, [
        requesting
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
        ref: buttonRef,
        role: "button",
        ...props,
        disabled: props.disabled || requesting,
        onClick: !requesting ? props.onClick : undefined,
        title: error ? errorText : props.title,
        style: {
            ...props.style,
            minWidth: minWidth,
            position: "relative"
        },
        children: requesting ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                    ref: coverTextRef,
                    text: pauseCoverText
                }),
                props.children
            ]
        }) : error ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lYgW3.default), {}),
                " ",
                errorText?.trim() !== "" ? errorText : "Error"
            ]
        }) : props.children
    });
};
$fd9ccd0d99aa9b9a$export$3956658c2d361270.displayName = "AsyncButton";

});
parcelRegister("c28Y1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c2ca09905ca7de2$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $lxFPe = parcelRequire("lxFPe");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $8c2ca09905ca7de2$var$Button = /*#__PURE__*/ $spJKX.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $lxFPe.useButtonProps)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$8c2ca09905ca7de2$var$Button.displayName = 'Button';
var $8c2ca09905ca7de2$export$2e2bcd8739ae039 = $8c2ca09905ca7de2$var$Button;

});
parcelRegister("lxFPe", function(module, exports) {

$parcel$export(module.exports, "useButtonProps", function () { return $faed1faccdbb9395$export$a0ee72f2c720a5c3; });
$parcel$export(module.exports, "default", function () { return $faed1faccdbb9395$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $bR5nk = parcelRequire("bR5nk");
const $faed1faccdbb9395$var$_excluded = [
    "as",
    "disabled"
];
function $faed1faccdbb9395$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $faed1faccdbb9395$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $faed1faccdbb9395$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $faed1faccdbb9395$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $faed1faccdbb9395$var$Button = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $faed1faccdbb9395$var$_objectWithoutPropertiesLoose(_ref, $faed1faccdbb9395$var$_excluded);
    const [buttonProps, { tagName: Component }] = $faed1faccdbb9395$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$faed1faccdbb9395$var$Button.displayName = 'Button';
var $faed1faccdbb9395$export$2e2bcd8739ae039 = $faed1faccdbb9395$var$Button;

});


parcelRegister("lYgW3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffec56949a021ef1$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $ffec56949a021ef1$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $ffec56949a021ef1$var$_extends() {
    return $ffec56949a021ef1$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ffec56949a021ef1$var$_extends.apply(null, arguments);
}
function $ffec56949a021ef1$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ffec56949a021ef1$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ffec56949a021ef1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ffec56949a021ef1$var$ExclamationCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $ffec56949a021ef1$var$_objectWithoutProperties(_ref, $ffec56949a021ef1$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $ffec56949a021ef1$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"
    }));
});
$ffec56949a021ef1$var$ExclamationCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $ffec56949a021ef1$export$2e2bcd8739ae039 = $ffec56949a021ef1$var$ExclamationCircle;

});



parcelRegister("eaCIg", function(module, exports) {

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $aHdRW = parcelRequire("aHdRW");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("fc2Ha");
var $krPhG = parcelRequire("krPhG");
var $d4ZHR = parcelRequire("d4ZHR");

var $k6V4B = parcelRequire("k6V4B");

var $dhw82 = parcelRequire("dhw82");

var $afLof = parcelRequire("afLof");

var $96lV1 = parcelRequire("96lV1");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");
/**
 * Builds dropdown options for ARS entity ID selectors.
 *
 * Includes the current value when it is not present in state to avoid
 * rendering an empty selection for legacy or out-of-sync data.
 *
 * @param records - Available ARS entities from context state.
 * @param selectedId - Currently selected ID on the edited analysis.
 * @returns Select options for use with ArsSelect.
 */ const $6302d3d954d67850$var$buildIdOptions = (records, selectedId)=>{
    const entityIds = Object.keys(records);
    const knownIds = [
        ...entityIds,
        ...[
            selectedId
        ].filter((id)=>id && !entityIds.includes(id))
    ];
    return knownIds.map((id)=>{
        const name = records[id]?.name ?? id;
        return {
            value: id,
            label: `${name} (${id})`
        };
    });
};
const $6302d3d954d67850$export$1c12e92016548ee4 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [activeTab, setActiveTab] = (0, $spJKX.useState)("properties");
    const analysis = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $k6V4B.isAnalysis));
    const documentReferences = (0, $spJKX.useMemo)(()=>analysis?.documentRefs ?? // istanbul ignore next
        [], [
        analysis
    ]);
    const analysisSetOptions = (0, $spJKX.useMemo)(()=>$6302d3d954d67850$var$buildIdOptions(state.analysisSets, analysis?.analysisSetId ?? // istanbul ignore next
        ""), [
        state.analysisSets,
        analysis?.analysisSetId
    ]);
    const dataSubsetOptions = (0, $spJKX.useMemo)(()=>$6302d3d954d67850$var$buildIdOptions(state.dataSubsets, analysis?.dataSubsetId ?? // istanbul ignore next
        ""), [
        state.dataSubsets,
        analysis?.dataSubsetId
    ]);
    const methodOptions = (0, $spJKX.useMemo)(()=>$6302d3d954d67850$var$buildIdOptions(state.analysisMethods, analysis?.methodId ?? // istanbul ignore next
        ""), [
        state.analysisMethods,
        analysis?.methodId
    ]);
    const hasProgrammingCode = analysis?.programmingCode !== undefined;
    /**
   * Handles adding a new document reference to the analysis.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysis) {
            const documentReferenceCount = documentReferences.length;
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRefs/${documentReferenceCount}`,
                value: newDocumentReference
            });
        }
    };
    /**
   * Handles adding a programming code block to the analysis.
   */ const handleAddProgrammingCode = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysis && !hasProgrammingCode) {
            const newProgrammingCode = {
                context: "",
                code: "",
                parameters: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/programmingCode`,
                value: newProgrammingCode
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            canRename && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
                activeKey: activeTab,
                onSelect: (k)=>{
                    /* istanbul ignore else */ if (k) setActiveTab(k);
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default), {
                        variant: "tabs",
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "properties",
                                    children: "Properties"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "data-selection",
                                    children: "Data selection"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "document-refs",
                                    children: "Document references"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "programming-code",
                                    children: "Programming code"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "programming-parameters",
                                    children: "Programming parameters"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Content, {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "properties",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                                        dataPath: dataPath,
                                        canRename: canRename,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                                        dataPath: `${dataPath}/reason/controlledTerm`,
                                        id: `${idRoute}-reason-controlled-term`,
                                        label: "Reason controlled term",
                                        labelWidth: 2,
                                        placeholder: "Enter reason controlled term",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                                        dataPath: `${dataPath}/purpose/controlledTerm`,
                                        id: `${idRoute}-purpose-controlled-term`,
                                        label: "Purpose controlled term",
                                        labelWidth: 2,
                                        placeholder: "Enter purpose controlled term",
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "data-selection",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                                        dataPath: `${dataPath}/dataset`,
                                        id: `${idRoute}-dataset`,
                                        label: "Dataset",
                                        labelWidth: 2,
                                        placeholder: "Enter dataset",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                                        dataPath: `${dataPath}/variable`,
                                        id: `${idRoute}-variable`,
                                        label: "Variable",
                                        labelWidth: 2,
                                        placeholder: "Enter variable",
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                                        dataPath: `${dataPath}/analysisSetId`,
                                        id: `${idRoute}-analysis-set-id`,
                                        label: "Analysis set id",
                                        labelWidth: 2,
                                        options: analysisSetOptions,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                                        dataPath: `${dataPath}/dataSubsetId`,
                                        id: `${idRoute}-data-subset-id`,
                                        label: "Data subset id",
                                        labelWidth: 2,
                                        options: dataSubsetOptions,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                                        dataPath: `${dataPath}/methodId`,
                                        id: `${idRoute}-method-id`,
                                        label: "Method id",
                                        labelWidth: 2,
                                        options: methodOptions,
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "document-refs",
                                children: [
                                    documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $96lV1.DocumentReferenceControl), {
                                            dataPath: `${dataPath}/documentRefs/${index}`,
                                            disabled: disabled,
                                            siblingCount: documentReferences.length
                                        }, `${documentReference.referenceDocumentId}-${index}`)),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                        id: `${idRoute}-add-document-reference`,
                                        onClick: handleAddDocumentReference,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: disabled,
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                className: "me-2",
                                                children: "Add document reference"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "programming-code",
                                children: [
                                    hasProgrammingCode && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dhw82.AnalysisOutputProgrammingCodeControl), {
                                        dataPath: `${dataPath}/programmingCode`,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                        id: `${idRoute}-add-programming-code`,
                                        onClick: handleAddProgrammingCode,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: disabled || hasProgrammingCode,
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                className: "me-2",
                                                children: "Add programming code"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                                eventKey: "programming-parameters",
                                children: hasProgrammingCode && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $afLof.AnalysisOutputProgrammingCodeParametersControl), {
                                    dataPath: `${dataPath}/programmingCode`,
                                    disabled: disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$6302d3d954d67850$export$1c12e92016548ee4.displayName = "AnalysisControl";

});
parcelRegister("aHdRW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c98ada82ad17438$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");
parcelRequire("ai3tA");
var $iq7Zt = parcelRequire("iq7Zt");

var $k7dg4 = parcelRequire("k7dg4");

var $dz672 = parcelRequire("dz672");

var $27dwU = parcelRequire("27dwU");

var $7rbo2 = parcelRequire("7rbo2");

var $lr8rv = parcelRequire("lr8rv");

var $17hhV = parcelRequire("17hhV");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $7c98ada82ad17438$var$Nav = /*#__PURE__*/ $spJKX.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $iq7Zt.default)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $dz672.useBootstrapPrefix)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $spJKX.useContext)((0, $27dwU.default));
    const cardHeaderContext = (0, $spJKX.useContext)((0, $7rbo2.default));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $k7dg4.default), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$7c98ada82ad17438$var$Nav.displayName = 'Nav';
var $7c98ada82ad17438$export$2e2bcd8739ae039 = Object.assign($7c98ada82ad17438$var$Nav, {
    Item: (0, $lr8rv.default),
    Link: (0, $17hhV.default)
});

});
parcelRegister("ai3tA", function(module, exports) {

$parcel$export(module.exports, "useUncontrolled", function () { return (parcelRequire("iq7Zt")).default; });

var $iq7Zt = parcelRequire("iq7Zt");

var $kjJ8h = parcelRequire("kjJ8h");

});
parcelRegister("iq7Zt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d690da74334f1608$export$2e2bcd8739ae039; });

var $hQ9Qa = parcelRequire("hQ9Qa");

var $hEp2O = parcelRequire("hEp2O");

var $spJKX = parcelRequire("spJKX");

var $kTbn0 = parcelRequire("kTbn0");
function $d690da74334f1608$var$_toPropertyKey(arg) {
    var key = $d690da74334f1608$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $d690da74334f1608$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $d690da74334f1608$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $spJKX.useRef)(propValue !== undefined);
    var _useState = (0, $spJKX.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $spJKX.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $d690da74334f1608$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$kTbn0.defaultKey(fieldName)], propsValue = _ref[fieldName], rest = (0, $hEp2O.default)(_ref, [
            $kTbn0.defaultKey(fieldName),
            fieldName
        ].map($d690da74334f1608$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $d690da74334f1608$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $hQ9Qa.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}

});
parcelRegister("hQ9Qa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfceed1d4d94f224$export$2e2bcd8739ae039; });
function $cfceed1d4d94f224$export$2e2bcd8739ae039() {
    return $cfceed1d4d94f224$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cfceed1d4d94f224$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("hEp2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd999967580e4580$export$2e2bcd8739ae039; });
function $cd999967580e4580$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("kTbn0", function(module, exports) {

$parcel$export(module.exports, "defaultKey", function () { return $f351c38baf421787$export$26cbf8c37e721e67; });
$parcel$export(module.exports, "uncontrolledPropTypes", function () { return $f351c38baf421787$export$8abd944bed26e726; });
$parcel$export(module.exports, "isProp", function () { return $f351c38baf421787$export$12ae2baa35bd9b8b; });
$parcel$export(module.exports, "canAcceptRef", function () { return $f351c38baf421787$export$95e5b18573b29087; });

var $bwjdr = parcelRequire("bwjdr");
var $f351c38baf421787$var$noop = function noop() {};
function $f351c38baf421787$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $f351c38baf421787$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $f351c38baf421787$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$f351c38baf421787$export$26cbf8c37e721e67(prop)] = $f351c38baf421787$var$noop;
        var handler = controlledValues[prop];
        !(typeof handler === 'string' && handler.trim().length) && (0, (/*@__PURE__*/$parcel$interopDefault($bwjdr)))(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
        propTypes[prop] = $f351c38baf421787$var$readOnlyPropType(handler, displayName);
    });
    return propTypes;
}
function $f351c38baf421787$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $f351c38baf421787$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f351c38baf421787$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}

});
parcelRegister("bwjdr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $863196bddbbcb70d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (format === undefined) throw new Error('invariant requires an error message argument');
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $863196bddbbcb70d$var$invariant;

});



parcelRegister("kjJ8h", function(module, exports) {

var $hEp2O = parcelRequire("hEp2O");

var $hQ9Qa = parcelRequire("hQ9Qa");

var $1dwng = parcelRequire("1dwng");

var $spJKX = parcelRequire("spJKX");

var $7mWbM = parcelRequire("7mWbM");

var $bwjdr = parcelRequire("bwjdr");

var $kTbn0 = parcelRequire("kTbn0");
var $eca897676edcc0dc$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $eca897676edcc0dc$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $kTbn0.canAcceptRef(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($kTbn0.defaultKey);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($bwjdr)))(false, "[uncontrollable] stateless function components cannot pass through methods because they have no associated instances. Check component: " + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $1dwng.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $hQ9Qa.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$kTbn0.defaultKey(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $hQ9Qa.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$kTbn0.isProp(props, key) && $kTbn0.isProp(prevProps, key)) nextState.values[key] = props[$kTbn0.defaultKey(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $hEp2O.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement(Component, (0, $hQ9Qa.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Component);
    (0, $7mWbM.polyfill)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $hQ9Qa.default)({
        innerRef: function innerRef() {}
    }, $kTbn0.uncontrolledPropTypes(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement(UncontrolledComponent, (0, $hQ9Qa.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $eca897676edcc0dc$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $eca897676edcc0dc$export$2e2bcd8739ae039(newComponent, (0, $hQ9Qa.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}

});
parcelRegister("1dwng", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e301e32ad9ebaa1$export$2e2bcd8739ae039; });

var $1ZLEu = parcelRequire("1ZLEu");
function $0e301e32ad9ebaa1$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $1ZLEu.default)(t, o);
}

});
parcelRegister("1ZLEu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $174073a73ee2bf2d$export$2e2bcd8739ae039; });
function $174073a73ee2bf2d$export$2e2bcd8739ae039(t, e) {
    return $174073a73ee2bf2d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $174073a73ee2bf2d$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("7mWbM", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $55d7b99e2e28d69e$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $55d7b99e2e28d69e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $55d7b99e2e28d69e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $55d7b99e2e28d69e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$55d7b99e2e28d69e$var$componentWillMount.__suppressDeprecationWarning = true;
$55d7b99e2e28d69e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$55d7b99e2e28d69e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $55d7b99e2e28d69e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $55d7b99e2e28d69e$var$componentWillMount;
        prototype.componentWillReceiveProps = $55d7b99e2e28d69e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $55d7b99e2e28d69e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("k7dg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea4ebedf1f3d9104$export$2e2bcd8739ae039; });

var $c9yOz = parcelRequire("c9yOz");

var $spJKX = parcelRequire("spJKX");

var $hSHOz = parcelRequire("hSHOz");

var $6q3bl = parcelRequire("6q3bl");

var $fxRpF = parcelRequire("fxRpF");

var $4dgBw = parcelRequire("4dgBw");

var $bfB4F = parcelRequire("bfB4F");

var $4aNCA = parcelRequire("4aNCA");

var $3ZWUQ = parcelRequire("3ZWUQ");

var $bR5nk = parcelRequire("bR5nk");
const $ea4ebedf1f3d9104$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $ea4ebedf1f3d9104$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $ea4ebedf1f3d9104$var$noop = ()=>{};
const $ea4ebedf1f3d9104$var$EVENT_KEY_ATTR = (0, $4aNCA.dataAttr)('event-key');
const $ea4ebedf1f3d9104$var$Nav = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $ea4ebedf1f3d9104$var$_objectWithoutPropertiesLoose(_ref, $ea4ebedf1f3d9104$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $hSHOz.default)();
    const needsRefocusRef = (0, $spJKX.useRef)(false);
    const parentOnSelect = (0, $spJKX.useContext)((0, $4dgBw.default));
    const tabContext = (0, $spJKX.useContext)((0, $bfB4F.default));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $spJKX.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $c9yOz.default)(currentListNode, `[${$ea4ebedf1f3d9104$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $4aNCA.dataProp)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $spJKX.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$ea4ebedf1f3d9104$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $6q3bl.default)(ref, listNode);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fxRpF.default).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $4dgBw.makeEventKey)(activeKey),
                getControlledId: getControlledId || $ea4ebedf1f3d9104$var$noop,
                getControllerId: getControllerId || $ea4ebedf1f3d9104$var$noop
            },
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$ea4ebedf1f3d9104$var$Nav.displayName = 'Nav';
var $ea4ebedf1f3d9104$export$2e2bcd8739ae039 = Object.assign($ea4ebedf1f3d9104$var$Nav, {
    Item: (0, $3ZWUQ.default)
});

});
parcelRegister("c9yOz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9154c288264e28$export$2e2bcd8739ae039; });
var $8d9154c288264e28$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $8d9154c288264e28$export$2e2bcd8739ae039(element, selector) {
    return $8d9154c288264e28$var$toArray(element.querySelectorAll(selector));
}

});

parcelRegister("hSHOz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d049777ea3e6bb37$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $d049777ea3e6bb37$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $spJKX.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}

});

parcelRegister("6q3bl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ac7a3a980526785$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $4ac7a3a980526785$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $4ac7a3a980526785$export$c9058316764c140e(refA, refB) {
    const a = $4ac7a3a980526785$var$toFnRef(refA);
    const b = $4ac7a3a980526785$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $4ac7a3a980526785$var$useMergedRefs(refA, refB) {
    return (0, $spJKX.useMemo)(()=>$4ac7a3a980526785$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $4ac7a3a980526785$export$2e2bcd8739ae039 = $4ac7a3a980526785$var$useMergedRefs;

});

parcelRegister("fxRpF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5135ecc702309f7$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $b5135ecc702309f7$var$NavContext = /*#__PURE__*/ $spJKX.createContext(null);
$b5135ecc702309f7$var$NavContext.displayName = 'NavContext';
var $b5135ecc702309f7$export$2e2bcd8739ae039 = $b5135ecc702309f7$var$NavContext;

});

parcelRegister("4dgBw", function(module, exports) {

$parcel$export(module.exports, "makeEventKey", function () { return $31154191ab066e0a$export$eef49b42fde998a3; });
$parcel$export(module.exports, "default", function () { return $31154191ab066e0a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $31154191ab066e0a$var$SelectableContext = /*#__PURE__*/ $spJKX.createContext(null);
const $31154191ab066e0a$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $31154191ab066e0a$export$2e2bcd8739ae039 = $31154191ab066e0a$var$SelectableContext;

});

parcelRegister("bfB4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $830dda949e86958e$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $830dda949e86958e$var$TabContext = /*#__PURE__*/ $spJKX.createContext(null);
var $830dda949e86958e$export$2e2bcd8739ae039 = $830dda949e86958e$var$TabContext;

});

parcelRegister("4aNCA", function(module, exports) {

$parcel$export(module.exports, "dataAttr", function () { return $309e9659ef2cea62$export$5cc3b7b83e34ade7; });
$parcel$export(module.exports, "dataProp", function () { return $309e9659ef2cea62$export$7776c0a7cd2eb3e0; });
const $309e9659ef2cea62$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $309e9659ef2cea62$export$635202801f9383a0 = `rrUi`;
function $309e9659ef2cea62$export$5cc3b7b83e34ade7(property) {
    return `${$309e9659ef2cea62$export$fd7bcb7e9bef4e8a}${property}`;
}
function $309e9659ef2cea62$export$7776c0a7cd2eb3e0(property) {
    return `${$309e9659ef2cea62$export$635202801f9383a0}${property}`;
}

});

parcelRegister("3ZWUQ", function(module, exports) {

$parcel$export(module.exports, "useNavItem", function () { return $2e94c50bb754e5f1$export$d7a68693710982a; });
$parcel$export(module.exports, "default", function () { return $2e94c50bb754e5f1$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $1nkOT = parcelRequire("1nkOT");

var $fxRpF = parcelRequire("fxRpF");

var $4dgBw = parcelRequire("4dgBw");

var $lxFPe = parcelRequire("lxFPe");

var $4aNCA = parcelRequire("4aNCA");

var $bfB4F = parcelRequire("bfB4F");

var $bR5nk = parcelRequire("bR5nk");
const $2e94c50bb754e5f1$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $2e94c50bb754e5f1$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $2e94c50bb754e5f1$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $spJKX.useContext)((0, $4dgBw.default));
    const navContext = (0, $spJKX.useContext)((0, $fxRpF.default));
    const tabContext = (0, $spJKX.useContext)((0, $bfB4F.default));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $4aNCA.dataAttr)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $1nkOT.default)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $2e94c50bb754e5f1$var$NavItem = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $lxFPe.default), active: active, eventKey: eventKey } = _ref, options = $2e94c50bb754e5f1$var$_objectWithoutPropertiesLoose(_ref, $2e94c50bb754e5f1$var$_excluded);
    const [props, meta] = $2e94c50bb754e5f1$export$d7a68693710982a(Object.assign({
        key: (0, $4dgBw.makeEventKey)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $4aNCA.dataAttr)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$2e94c50bb754e5f1$var$NavItem.displayName = 'NavItem';
var $2e94c50bb754e5f1$export$2e2bcd8739ae039 = $2e94c50bb754e5f1$var$NavItem;

});
parcelRegister("1nkOT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100816d544a46561$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $3QFOb = parcelRequire("3QFOb");
function $100816d544a46561$export$2e2bcd8739ae039(fn) {
    const ref = (0, $3QFOb.default)(fn);
    return (0, $spJKX.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("3QFOb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cd6a8b74890f576$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $2cd6a8b74890f576$var$useCommittedRef(value) {
    const ref = (0, $spJKX.useRef)(value);
    (0, $spJKX.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $2cd6a8b74890f576$export$2e2bcd8739ae039 = $2cd6a8b74890f576$var$useCommittedRef;

});




parcelRegister("27dwU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18a6baf7accb4cdc$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
// TODO: check
const $18a6baf7accb4cdc$var$context = /*#__PURE__*/ $spJKX.createContext(null);
$18a6baf7accb4cdc$var$context.displayName = 'NavbarContext';
var $18a6baf7accb4cdc$export$2e2bcd8739ae039 = $18a6baf7accb4cdc$var$context;

});

parcelRegister("7rbo2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56a3e329c0c400ae$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
const $56a3e329c0c400ae$var$context = /*#__PURE__*/ $spJKX.createContext(null);
$56a3e329c0c400ae$var$context.displayName = 'CardHeaderContext';
var $56a3e329c0c400ae$export$2e2bcd8739ae039 = $56a3e329c0c400ae$var$context;

});

parcelRegister("lr8rv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9b2ab2346231b60$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $f9b2ab2346231b60$var$NavItem = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$f9b2ab2346231b60$var$NavItem.displayName = 'NavItem';
var $f9b2ab2346231b60$export$2e2bcd8739ae039 = $f9b2ab2346231b60$var$NavItem;

});

parcelRegister("17hhV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d03daefe8541abb$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $5aXWW = parcelRequire("5aXWW");

var $3ZWUQ = parcelRequire("3ZWUQ");

var $4dgBw = parcelRequire("4dgBw");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $0d03daefe8541abb$var$NavLink = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $5aXWW.default), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $3ZWUQ.useNavItem)({
        key: (0, $4dgBw.makeEventKey)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$0d03daefe8541abb$var$NavLink.displayName = 'NavLink';
var $0d03daefe8541abb$export$2e2bcd8739ae039 = $0d03daefe8541abb$var$NavLink;

});
parcelRegister("5aXWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c4c63b28d30f381$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
parcelRequire("7vq36");
var $1nkOT = parcelRequire("1nkOT");

var $lxFPe = parcelRequire("lxFPe");

var $bR5nk = parcelRequire("bR5nk");
const $3c4c63b28d30f381$var$_excluded = [
    "onKeyDown"
];
function $3c4c63b28d30f381$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3c4c63b28d30f381$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $3c4c63b28d30f381$var$Anchor = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $3c4c63b28d30f381$var$_objectWithoutPropertiesLoose(_ref, $3c4c63b28d30f381$var$_excluded);
    const [buttonProps] = (0, $lxFPe.useButtonProps)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $1nkOT.default)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($3c4c63b28d30f381$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $bR5nk.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $bR5nk.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$3c4c63b28d30f381$var$Anchor.displayName = 'Anchor';
var $3c4c63b28d30f381$export$2e2bcd8739ae039 = $3c4c63b28d30f381$var$Anchor;

});
parcelRegister("7vq36", function(module, exports) {

$parcel$export(module.exports, "useEventCallback", function () { return (parcelRequire("1nkOT")).default; });

var $aRyvJ = parcelRequire("aRyvJ");

var $3QFOb = parcelRequire("3QFOb");

var $1nkOT = parcelRequire("1nkOT");

var $5Oo2i = parcelRequire("5Oo2i");

var $aFCDT = parcelRequire("aFCDT");

var $fLPuh = parcelRequire("fLPuh");

var $k9bgy = parcelRequire("k9bgy");

var $7fpoc = parcelRequire("7fpoc");

var $ju37O = parcelRequire("ju37O");

var $1lkRM = parcelRequire("1lkRM");

var $NZVk0 = parcelRequire("NZVk0");

var $agLw0 = parcelRequire("agLw0");

var $9Pmwu = parcelRequire("9Pmwu");

});
parcelRegister("aRyvJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e899fc235ca80e6$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $7e899fc235ca80e6$export$2e2bcd8739ae039() {
    return (0, $spJKX.useState)(null);
}

});

parcelRegister("5Oo2i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b4445326bdeafc$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $1nkOT = parcelRequire("1nkOT");
function $43b4445326bdeafc$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $1nkOT.default)(listener);
    (0, $spJKX.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}

});

parcelRegister("aFCDT", function(module, exports) {

var $5Oo2i = parcelRequire("5Oo2i");

var $spJKX = parcelRequire("spJKX");
function $7c4bb54ba27ddb41$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $spJKX.useCallback)(()=>document, []);
    return (0, $5Oo2i.default)(documentTarget, event, handler, capture);
}

});

parcelRegister("fLPuh", function(module, exports) {

var $spJKX = parcelRequire("spJKX");

var $3QFOb = parcelRequire("3QFOb");
/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $b7b32f1b10d218cf$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $3QFOb.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $3QFOb.default)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $spJKX.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $b7b32f1b10d218cf$export$2e2bcd8739ae039 = $b7b32f1b10d218cf$var$useInterval;

});

parcelRegister("k9bgy", function(module, exports) {

var $spJKX = parcelRequire("spJKX");

var $3QFOb = parcelRequire("3QFOb");
function $eaad631485cf95a1$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $3QFOb.default)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $3QFOb.default)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $spJKX.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $eaad631485cf95a1$export$2e2bcd8739ae039 = $eaad631485cf95a1$var$useRafInterval;

});

parcelRegister("7fpoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $546da0ea625f8762$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $546da0ea625f8762$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $spJKX.useState)(initialState);
    const updater = (0, $spJKX.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}

});

parcelRegister("ju37O", function(module, exports) {

var $7fpoc = parcelRequire("7fpoc");
function $e2f33e3775f49b3c$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $7fpoc.default)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}

});

parcelRegister("1lkRM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fa7f03d1d510dff$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $0fa7f03d1d510dff$export$2e2bcd8739ae039() {
    const mounted = (0, $spJKX.useRef)(true);
    const isMounted = (0, $spJKX.useRef)(()=>mounted.current);
    (0, $spJKX.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}

});

parcelRegister("NZVk0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09649c718088ad7b$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $09649c718088ad7b$export$2e2bcd8739ae039(value) {
    const ref = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}

});

parcelRegister("agLw0", function(module, exports) {

var $spJKX = parcelRequire("spJKX");
function $77a04187e5846b7e$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $spJKX.useState)({
        image: null,
        error: null
    });
    (0, $spJKX.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}

});

parcelRegister("9Pmwu", function(module, exports) {

var $spJKX = parcelRequire("spJKX");

var $hCMZV = parcelRequire("hCMZV");
const $727a5914ff28256d$var$targetMap = new WeakMap();
let $727a5914ff28256d$var$resizeObserver;
function $727a5914ff28256d$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $727a5914ff28256d$var$resizeObserver = $727a5914ff28256d$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $727a5914ff28256d$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $727a5914ff28256d$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $spJKX.useState)(null);
    (0, $hCMZV.default)(()=>{
        if (!element) return;
        $727a5914ff28256d$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $727a5914ff28256d$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $727a5914ff28256d$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}

});
parcelRegister("hCMZV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd4bfe375fa84f8d$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $cd4bfe375fa84f8d$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $cd4bfe375fa84f8d$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $cd4bfe375fa84f8d$export$2e2bcd8739ae039 = $cd4bfe375fa84f8d$var$isDOM || $cd4bfe375fa84f8d$var$isReactNative ? (0, $spJKX.useLayoutEffect) : (0, $spJKX.useEffect);

});






parcelRegister("79ius", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5347b771ed3ee66d$export$2e2bcd8739ae039; });

var $fGs19 = parcelRequire("fGs19");

var $cycBG = parcelRequire("cycBG");

var $gwpIa = parcelRequire("gwpIa");

var $2MVtb = parcelRequire("2MVtb");
const $5347b771ed3ee66d$var$propTypes = {
    eventKey: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    /**
   * Content for the tab title.
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).node.isRequired,
    /**
   * The disabled state of the tab.
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Class to pass to the underlying nav link.
   */ tabClassName: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    /**
   * Object containing attributes to pass to underlying nav link.
   */ tabAttrs: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).object
};
const $5347b771ed3ee66d$var$Tab = ()=>{
    throw new Error("ReactBootstrap: The `Tab` component is not meant to be rendered! It's an abstract component that is only valid as a direct Child of the `Tabs` Component. For custom tabs components use TabPane and TabsContainer directly");
};
$5347b771ed3ee66d$var$Tab.propTypes = $5347b771ed3ee66d$var$propTypes;
var $5347b771ed3ee66d$export$2e2bcd8739ae039 = Object.assign($5347b771ed3ee66d$var$Tab, {
    Container: (0, $cycBG.default),
    Content: (0, $gwpIa.default),
    Pane: (0, $2MVtb.default)
});

});
parcelRegister("cycBG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92327078b6410155$export$2e2bcd8739ae039; });

var $53VMI = parcelRequire("53VMI");

var $gAjQZ = parcelRequire("gAjQZ");

var $bR5nk = parcelRequire("bR5nk");
const $92327078b6410155$var$TabContainer = ({ transition: transition, ...props })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $53VMI.default), {
        ...props,
        transition: (0, $gAjQZ.default)(transition)
    });
$92327078b6410155$var$TabContainer.displayName = 'TabContainer';
var $92327078b6410155$export$2e2bcd8739ae039 = $92327078b6410155$var$TabContainer;

});
parcelRegister("53VMI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3afa0e695b64c9bd$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $kGFPM = parcelRequire("kGFPM");

var $lgUsY = parcelRequire("lgUsY");

var $bfB4F = parcelRequire("bfB4F");

var $4dgBw = parcelRequire("4dgBw");

var $5fb27 = parcelRequire("5fb27");

var $bR5nk = parcelRequire("bR5nk");
const $3afa0e695b64c9bd$var$Tabs = (props)=>{
    const { id: userId, generateChildId: generateCustomChildId, onSelect: propsOnSelect, activeKey: propsActiveKey, defaultActiveKey: defaultActiveKey, transition: transition, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, children: children } = props;
    const [activeKey, onSelect] = (0, $kGFPM.useUncontrolledProp)(propsActiveKey, defaultActiveKey, propsOnSelect);
    const id = (0, $lgUsY.useSSRSafeId)(userId);
    const generateChildId = (0, $spJKX.useMemo)(()=>generateCustomChildId || ((key, type)=>id ? `${id}-${type}-${key}` : null), [
        id,
        generateCustomChildId
    ]);
    const tabContext = (0, $spJKX.useMemo)(()=>({
            onSelect: onSelect,
            activeKey: activeKey,
            transition: transition,
            mountOnEnter: mountOnEnter || false,
            unmountOnExit: unmountOnExit || false,
            getControlledId: (key)=>generateChildId(key, 'tabpane'),
            getControllerId: (key)=>generateChildId(key, 'tab')
        }), [
        onSelect,
        activeKey,
        transition,
        mountOnEnter,
        unmountOnExit,
        generateChildId
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bfB4F.default).Provider, {
        value: tabContext,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
            value: onSelect || null,
            children: children
        })
    });
};
$3afa0e695b64c9bd$var$Tabs.Panel = (0, $5fb27.default);
var $3afa0e695b64c9bd$export$2e2bcd8739ae039 = $3afa0e695b64c9bd$var$Tabs;

});
parcelRegister("kGFPM", function(module, exports) {

$parcel$export(module.exports, "useUncontrolledProp", function () { return $f0f82e4b1ae36c08$export$2ee51287a16ca325; });

var $spJKX = parcelRequire("spJKX");
function $f0f82e4b1ae36c08$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f0f82e4b1ae36c08$var$_toPropertyKey(arg) {
    var key = $f0f82e4b1ae36c08$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f0f82e4b1ae36c08$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f0f82e4b1ae36c08$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f0f82e4b1ae36c08$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $spJKX.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $spJKX.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $spJKX.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $f0f82e4b1ae36c08$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $f0f82e4b1ae36c08$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $f0f82e4b1ae36c08$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($f0f82e4b1ae36c08$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $f0f82e4b1ae36c08$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}

});

parcelRegister("lgUsY", function(module, exports) {

$parcel$export(module.exports, "useSSRSafeId", function () { return $f7c6e49da0b53571$export$619500959fc48b26; });

var $spJKX = parcelRequire("spJKX");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $f7c6e49da0b53571$var$$85138adc03e1f057$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createContext($f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext);
const $f7c6e49da0b53571$var$$85138adc03e1f057$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createContext(false);
// This is only used in React < 18.
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$LegacySSRProvider(props) {
    let cur = (0, $spJKX.useContext)($f7c6e49da0b53571$var$$85138adc03e1f057$var$SSRContext);
    let counter = $f7c6e49da0b53571$var$$85138adc03e1f057$var$useCounter(cur === $f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $spJKX.useState)(true);
    let value = (0, $spJKX.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $spJKX.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($f7c6e49da0b53571$var$$85138adc03e1f057$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($f7c6e49da0b53571$var$$85138adc03e1f057$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $f7c6e49da0b53571$var$$85138adc03e1f057$var$warnedAboutSSRProvider = false;
function $f7c6e49da0b53571$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($spJKX)))['useId'] === 'function') {
        if (!$f7c6e49da0b53571$var$$85138adc03e1f057$var$warnedAboutSSRProvider) {
            console.warn('In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.');
            // oxlint-disable-next-line react/react-compiler
            $f7c6e49da0b53571$var$$85138adc03e1f057$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($f7c6e49da0b53571$var$$85138adc03e1f057$var$LegacySSRProvider, props);
}
let $f7c6e49da0b53571$var$$85138adc03e1f057$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $f7c6e49da0b53571$var$$85138adc03e1f057$var$componentIds = new WeakMap();
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$useCounter(isDisabled = false) {
    let ctx = (0, $spJKX.useContext)($f7c6e49da0b53571$var$$85138adc03e1f057$var$SSRContext);
    let ref = (0, $spJKX.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $f7c6e49da0b53571$var$$85138adc03e1f057$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $f7c6e49da0b53571$var$$85138adc03e1f057$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $f7c6e49da0b53571$var$$85138adc03e1f057$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $spJKX.useContext)($f7c6e49da0b53571$var$$85138adc03e1f057$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext && !$f7c6e49da0b53571$var$$85138adc03e1f057$var$canUseDOM && true) console.warn('When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.');
    let counter = $f7c6e49da0b53571$var$$85138adc03e1f057$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).useId();
    let [didSSR] = (0, $spJKX.useState)($f7c6e49da0b53571$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$f7c6e49da0b53571$var$$85138adc03e1f057$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $f7c6e49da0b53571$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($spJKX)))['useId'] === 'function' ? $f7c6e49da0b53571$var$$85138adc03e1f057$var$useModernSSRSafeId : $f7c6e49da0b53571$var$$85138adc03e1f057$var$useLegacySSRSafeId;
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$getSnapshot() {
    return false;
}
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $f7c6e49da0b53571$var$$85138adc03e1f057$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $f7c6e49da0b53571$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($spJKX)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX)))['useSyncExternalStore']($f7c6e49da0b53571$var$$85138adc03e1f057$var$subscribe, $f7c6e49da0b53571$var$$85138adc03e1f057$var$getSnapshot, $f7c6e49da0b53571$var$$85138adc03e1f057$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $spJKX.useContext)($f7c6e49da0b53571$var$$85138adc03e1f057$var$IsSSRContext);
}

});

parcelRegister("5fb27", function(module, exports) {

$parcel$export(module.exports, "useTabPanel", function () { return $3d16e96d2ca2f86a$export$fae0121b5afe572d; });
$parcel$export(module.exports, "default", function () { return $3d16e96d2ca2f86a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $bfB4F = parcelRequire("bfB4F");

var $4dgBw = parcelRequire("4dgBw");

var $bnFJc = parcelRequire("bnFJc");

var $bR5nk = parcelRequire("bR5nk");
const $3d16e96d2ca2f86a$var$_excluded = [
    "active",
    "eventKey",
    "mountOnEnter",
    "transition",
    "unmountOnExit",
    "role",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
], $3d16e96d2ca2f86a$var$_excluded2 = [
    "activeKey",
    "getControlledId",
    "getControllerId"
], $3d16e96d2ca2f86a$var$_excluded3 = [
    "as"
];
function $3d16e96d2ca2f86a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3d16e96d2ca2f86a$export$fae0121b5afe572d(_ref) {
    let { active: active, eventKey: eventKey, mountOnEnter: mountOnEnter, transition: transition, unmountOnExit: unmountOnExit, role: role = 'tabpanel', onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited } = _ref, props = $3d16e96d2ca2f86a$var$_objectWithoutPropertiesLoose(_ref, $3d16e96d2ca2f86a$var$_excluded);
    const context = (0, $spJKX.useContext)((0, $bfB4F.default));
    if (!context) return [
        Object.assign({}, props, {
            role: role
        }),
        {
            eventKey: eventKey,
            isActive: active,
            mountOnEnter: mountOnEnter,
            transition: transition,
            unmountOnExit: unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
    const { activeKey: activeKey, getControlledId: getControlledId, getControllerId: getControllerId } = context, rest = $3d16e96d2ca2f86a$var$_objectWithoutPropertiesLoose(context, $3d16e96d2ca2f86a$var$_excluded2);
    const key = (0, $4dgBw.makeEventKey)(eventKey);
    return [
        Object.assign({}, props, {
            role: role,
            id: getControlledId(eventKey),
            'aria-labelledby': getControllerId(eventKey)
        }),
        {
            eventKey: eventKey,
            isActive: active == null && key != null ? (0, $4dgBw.makeEventKey)(activeKey) === key : active,
            transition: transition || rest.transition,
            mountOnEnter: mountOnEnter != null ? mountOnEnter : rest.mountOnEnter,
            unmountOnExit: unmountOnExit != null ? unmountOnExit : rest.unmountOnExit,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited
        }
    ];
}
const $3d16e96d2ca2f86a$var$TabPanel = /*#__PURE__*/ $spJKX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(_ref2, ref)=>{
    let { as: Component = 'div' } = _ref2, props = $3d16e96d2ca2f86a$var$_objectWithoutPropertiesLoose(_ref2, $3d16e96d2ca2f86a$var$_excluded3);
    const [tabPanelProps, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $bnFJc.default) }] = $3d16e96d2ca2f86a$export$fae0121b5afe572d(props);
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bfB4F.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({}, tabPanelProps, {
                    ref: ref,
                    hidden: !isActive,
                    "aria-hidden": !isActive
                }))
            })
        })
    });
});
$3d16e96d2ca2f86a$var$TabPanel.displayName = 'TabPanel';
var $3d16e96d2ca2f86a$export$2e2bcd8739ae039 = $3d16e96d2ca2f86a$var$TabPanel;

});
parcelRegister("bnFJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $849236078657062a$export$2e2bcd8739ae039; });

var $1nkOT = parcelRequire("1nkOT");

var $6q3bl = parcelRequire("6q3bl");

var $spJKX = parcelRequire("spJKX");

var $feFtK = parcelRequire("feFtK");
function $849236078657062a$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $spJKX.useRef)(null);
    const hasEnteredRef = (0, $spJKX.useRef)(inProp);
    const handleExited = (0, $1nkOT.default)(onExited);
    (0, $spJKX.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $6q3bl.default)(ref, (0, $feFtK.getChildRef)(children));
    const child = /*#__PURE__*/ (0, $spJKX.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $849236078657062a$export$2e2bcd8739ae039 = $849236078657062a$var$NoopTransition;

});
parcelRegister("feFtK", function(module, exports) {

$parcel$export(module.exports, "isEscKey", function () { return $b17856a981fec086$export$806fcc22e55e107d; });
$parcel$export(module.exports, "getChildRef", function () { return $b17856a981fec086$export$87943f2672146d57; });

var $spJKX = parcelRequire("spJKX");
function $b17856a981fec086$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $b17856a981fec086$export$13e065f3a74cfe36() {
    const parts = $spJKX.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $b17856a981fec086$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $b17856a981fec086$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}

});




parcelRegister("gAjQZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c12f68a38b569d73$export$2e2bcd8739ae039; });

var $bnFJc = parcelRequire("bnFJc");

var $bE9uK = parcelRequire("bE9uK");
function $c12f68a38b569d73$export$2e2bcd8739ae039(transition) {
    if (typeof transition === 'boolean') return transition ? (0, $bE9uK.default) : (0, $bnFJc.default);
    return transition;
}

});
parcelRegister("bE9uK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87aacba02d58bb60$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $iu3Vz = parcelRequire("iu3Vz");

var $feFtK = parcelRequire("feFtK");

var $fSJNV = parcelRequire("fSJNV");

var $7je9W = parcelRequire("7je9W");

var $jVveE = parcelRequire("jVveE");

var $bR5nk = parcelRequire("bR5nk");
const $87aacba02d58bb60$var$fadeStyles = {
    [(0, $iu3Vz.ENTERING)]: 'show',
    [(0, $iu3Vz.ENTERED)]: 'show'
};
const $87aacba02d58bb60$var$Fade = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $spJKX.useCallback)((node, isAppearing)=>{
        (0, $7je9W.default)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jVveE.default), {
        ref: ref,
        addEndListener: (0, $fSJNV.default),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $feFtK.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $spJKX.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))('fade', className, children.props.className, $87aacba02d58bb60$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$87aacba02d58bb60$var$Fade.displayName = 'Fade';
var $87aacba02d58bb60$export$2e2bcd8739ae039 = $87aacba02d58bb60$var$Fade;

});
parcelRegister("iu3Vz", function(module, exports) {

$parcel$export(module.exports, "EXITED", function () { return $d74e133dd6aa6cd5$export$84cbff306f539230; });
$parcel$export(module.exports, "ENTERING", function () { return $d74e133dd6aa6cd5$export$df38205c966be359; });
$parcel$export(module.exports, "ENTERED", function () { return $d74e133dd6aa6cd5$export$78e9e6e3e014d60a; });
$parcel$export(module.exports, "EXITING", function () { return $d74e133dd6aa6cd5$export$4aacc83d4d59139f; });
$parcel$export(module.exports, "default", function () { return $d74e133dd6aa6cd5$export$2e2bcd8739ae039; });

var $hEp2O = parcelRequire("hEp2O");

var $1dwng = parcelRequire("1dwng");

var $fGs19 = parcelRequire("fGs19");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $9El8N = parcelRequire("9El8N");

var $cAT6q = parcelRequire("cAT6q");

var $fSttk = parcelRequire("fSttk");

var $e6Z7p = parcelRequire("e6Z7p");
var $d74e133dd6aa6cd5$export$bb38bb9a1161268 = 'unmounted';
var $d74e133dd6aa6cd5$export$84cbff306f539230 = 'exited';
var $d74e133dd6aa6cd5$export$df38205c966be359 = 'entering';
var $d74e133dd6aa6cd5$export$78e9e6e3e014d60a = 'entered';
var $d74e133dd6aa6cd5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $d74e133dd6aa6cd5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $1dwng.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $d74e133dd6aa6cd5$export$84cbff306f539230;
                _this.appearStatus = $d74e133dd6aa6cd5$export$df38205c966be359;
            } else initialStatus = $d74e133dd6aa6cd5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $d74e133dd6aa6cd5$export$bb38bb9a1161268;
        else initialStatus = $d74e133dd6aa6cd5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $d74e133dd6aa6cd5$export$bb38bb9a1161268) return {
            status: $d74e133dd6aa6cd5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $d74e133dd6aa6cd5$export$df38205c966be359 && status !== $d74e133dd6aa6cd5$export$78e9e6e3e014d60a) nextStatus = $d74e133dd6aa6cd5$export$df38205c966be359;
            } else if (status === $d74e133dd6aa6cd5$export$df38205c966be359 || status === $d74e133dd6aa6cd5$export$78e9e6e3e014d60a) nextStatus = $d74e133dd6aa6cd5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $d74e133dd6aa6cd5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $e6Z7p.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $d74e133dd6aa6cd5$export$84cbff306f539230) this.setState({
            status: $d74e133dd6aa6cd5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9El8N.default).disabled) {
            this.safeSetState({
                status: $d74e133dd6aa6cd5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $d74e133dd6aa6cd5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $d74e133dd6aa6cd5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9El8N.default).disabled) {
            this.safeSetState({
                status: $d74e133dd6aa6cd5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $d74e133dd6aa6cd5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $d74e133dd6aa6cd5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $d74e133dd6aa6cd5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hEp2O.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, $fSttk.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Component);
$d74e133dd6aa6cd5$var$Transition.contextType = (0, $fSttk.default);
$d74e133dd6aa6cd5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).shape({
        current: typeof Element === 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $cAT6q.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func
}; // Name the function so it is clearer in the documentation
function $d74e133dd6aa6cd5$var$noop() {}
$d74e133dd6aa6cd5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $d74e133dd6aa6cd5$var$noop,
    onEntering: $d74e133dd6aa6cd5$var$noop,
    onEntered: $d74e133dd6aa6cd5$var$noop,
    onExit: $d74e133dd6aa6cd5$var$noop,
    onExiting: $d74e133dd6aa6cd5$var$noop,
    onExited: $d74e133dd6aa6cd5$var$noop
};
$d74e133dd6aa6cd5$var$Transition.UNMOUNTED = $d74e133dd6aa6cd5$export$bb38bb9a1161268;
$d74e133dd6aa6cd5$var$Transition.EXITED = $d74e133dd6aa6cd5$export$84cbff306f539230;
$d74e133dd6aa6cd5$var$Transition.ENTERING = $d74e133dd6aa6cd5$export$df38205c966be359;
$d74e133dd6aa6cd5$var$Transition.ENTERED = $d74e133dd6aa6cd5$export$78e9e6e3e014d60a;
$d74e133dd6aa6cd5$var$Transition.EXITING = $d74e133dd6aa6cd5$export$4aacc83d4d59139f;
var $d74e133dd6aa6cd5$export$2e2bcd8739ae039 = $d74e133dd6aa6cd5$var$Transition;

});
parcelRegister("9El8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70683f99794cdac1$export$2e2bcd8739ae039; });
var $70683f99794cdac1$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("cAT6q", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", function () { return $92b3970b26e52153$export$3458ee1082941f5e; });

var $fGs19 = parcelRequire("fGs19");
var $92b3970b26e52153$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    }).isRequired
]);
var $92b3970b26e52153$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
    })
]);

});

parcelRegister("fSttk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8f2c2ab4490d81c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
var $b8f2c2ab4490d81c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createContext(null);

});

parcelRegister("e6Z7p", function(module, exports) {

$parcel$export(module.exports, "forceReflow", function () { return $a4610914ee2bf201$export$7d26bbb1236dafd6; });
var $a4610914ee2bf201$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("fSJNV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ff6df072b307e4$export$2e2bcd8739ae039; });

var $hSUY5 = parcelRequire("hSUY5");

var $1AFqp = parcelRequire("1AFqp");
function $b8ff6df072b307e4$var$parseDuration(node, property) {
    const str = (0, $hSUY5.default)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $b8ff6df072b307e4$export$2e2bcd8739ae039(element, handler) {
    const duration = $b8ff6df072b307e4$var$parseDuration(element, 'transitionDuration');
    const delay = $b8ff6df072b307e4$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $1AFqp.default)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}

});
parcelRegister("hSUY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d053ab7f3f6b2d8a$export$2e2bcd8739ae039; });

var $5KK8k = parcelRequire("5KK8k");

var $jeUJ3 = parcelRequire("jeUJ3");

var $ev5rk = parcelRequire("ev5rk");
function $d053ab7f3f6b2d8a$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $jeUJ3.default)(property)) || (0, $5KK8k.default)(node).getPropertyValue((0, $jeUJ3.default)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $jeUJ3.default)(key));
        else if ((0, $ev5rk.default)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $jeUJ3.default)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $d053ab7f3f6b2d8a$export$2e2bcd8739ae039 = $d053ab7f3f6b2d8a$var$style;

});
parcelRegister("5KK8k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $430508ba7230a11c$export$2e2bcd8739ae039; });

var $3K2Ac = parcelRequire("3K2Ac");
function $430508ba7230a11c$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $3K2Ac.default)(node).getComputedStyle(node, psuedoElement);
}

});
parcelRegister("3K2Ac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b97abddcb325eac$export$2e2bcd8739ae039; });

var $6s2Od = parcelRequire("6s2Od");
function $2b97abddcb325eac$export$2e2bcd8739ae039(node) {
    var doc = (0, $6s2Od.default)(node);
    return doc && doc.defaultView || window;
}

});
parcelRegister("6s2Od", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b27895fcf49b09e$export$2e2bcd8739ae039; });
/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $4b27895fcf49b09e$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});



parcelRegister("jeUJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e01b53abc697770d$export$2e2bcd8739ae039; });
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ 
var $lzmLj = parcelRequire("lzmLj");
var $e01b53abc697770d$var$msPattern = /^ms-/;
function $e01b53abc697770d$export$2e2bcd8739ae039(string) {
    return (0, $lzmLj.default)(string).replace($e01b53abc697770d$var$msPattern, '-ms-');
}

});
parcelRegister("lzmLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb3e85edcc5a1f07$export$2e2bcd8739ae039; });
var $fb3e85edcc5a1f07$var$rUpper = /([A-Z])/g;
function $fb3e85edcc5a1f07$export$2e2bcd8739ae039(string) {
    return string.replace($fb3e85edcc5a1f07$var$rUpper, '-$1').toLowerCase();
}

});


parcelRegister("ev5rk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8e82e2c460c297c$export$2e2bcd8739ae039; });
var $a8e82e2c460c297c$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $a8e82e2c460c297c$export$2e2bcd8739ae039(value) {
    return !!(value && $a8e82e2c460c297c$var$supportedTransforms.test(value));
}

});


parcelRegister("1AFqp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1289496189f246a6$export$2e2bcd8739ae039; });

var $hSUY5 = parcelRequire("hSUY5");

var $7VtiN = parcelRequire("7VtiN");

var $2hyZY = parcelRequire("2hyZY");
function $1289496189f246a6$var$parseDuration(node) {
    var str = (0, $hSUY5.default)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $1289496189f246a6$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $2hyZY.default)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $7VtiN.default)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $1289496189f246a6$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $1289496189f246a6$var$parseDuration(element) || 0;
    var removeEmulate = $1289496189f246a6$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $7VtiN.default)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}

});
parcelRegister("7VtiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c5496138b173160$export$2e2bcd8739ae039; });

var $3GPnw = parcelRequire("3GPnw");

var $fml6v = parcelRequire("fml6v");
function $5c5496138b173160$var$listen(node, eventName, handler, options) {
    (0, $3GPnw.default)(node, eventName, handler, options);
    return function() {
        (0, $fml6v.default)(node, eventName, handler, options);
    };
}
var $5c5496138b173160$export$2e2bcd8739ae039 = $5c5496138b173160$var$listen;

});
parcelRegister("3GPnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2afd2606972f0da5$export$2e2bcd8739ae039; });
/* eslint-disable no-return-assign */ 
var $gWWOE = parcelRequire("gWWOE");
var $2afd2606972f0da5$export$63fefd044b2bc624 = false;
var $2afd2606972f0da5$export$a614c6b395900f69 = false;
try {
    var $2afd2606972f0da5$var$options = {
        get passive () {
            return $2afd2606972f0da5$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $2afd2606972f0da5$export$a614c6b395900f69 = $2afd2606972f0da5$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $gWWOE.default) {
        window.addEventListener('test', $2afd2606972f0da5$var$options, $2afd2606972f0da5$var$options);
        window.removeEventListener('test', $2afd2606972f0da5$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $2afd2606972f0da5$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$2afd2606972f0da5$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$2afd2606972f0da5$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $2afd2606972f0da5$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $2afd2606972f0da5$export$2e2bcd8739ae039 = $2afd2606972f0da5$var$addEventListener;

});
parcelRegister("gWWOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c56fafc26b7ba534$export$2e2bcd8739ae039; });
var $c56fafc26b7ba534$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("fml6v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e947ddca76ec55$export$2e2bcd8739ae039; });
/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $b2e947ddca76ec55$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $b2e947ddca76ec55$export$2e2bcd8739ae039 = $b2e947ddca76ec55$var$removeEventListener;

});


parcelRegister("2hyZY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a98514738b6d641$export$2e2bcd8739ae039; });
/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $1a98514738b6d641$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}

});



parcelRegister("7je9W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55254a7b5429bf65$export$2e2bcd8739ae039; });
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $55254a7b5429bf65$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}

});

parcelRegister("jVveE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e81b91da2d94767c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $iu3Vz = parcelRequire("iu3Vz");

var $4E7Hm = parcelRequire("4E7Hm");

var $dhaAU = parcelRequire("dhaAU");

var $bR5nk = parcelRequire("bR5nk");
"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $e81b91da2d94767c$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $spJKX.useRef)(null);
    const mergedRef = (0, $4E7Hm.default)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $dhaAU.default)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $spJKX.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $spJKX.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $spJKX.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $spJKX.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $spJKX.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $spJKX.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $spJKX.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iu3Vz.default), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$e81b91da2d94767c$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $e81b91da2d94767c$export$2e2bcd8739ae039 = $e81b91da2d94767c$var$TransitionWrapper;

});
parcelRegister("4E7Hm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3620de9bd5df27b2$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $3620de9bd5df27b2$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $3620de9bd5df27b2$export$c9058316764c140e(refA, refB) {
    const a = $3620de9bd5df27b2$var$toFnRef(refA);
    const b = $3620de9bd5df27b2$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3620de9bd5df27b2$var$useMergedRefs(refA, refB) {
    return (0, $spJKX.useMemo)(()=>$3620de9bd5df27b2$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $3620de9bd5df27b2$export$2e2bcd8739ae039 = $3620de9bd5df27b2$var$useMergedRefs;

});

parcelRegister("dhaAU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9aa514b32497eca8$export$2e2bcd8739ae039; });

var $oS63j = parcelRequire("oS63j");
function $9aa514b32497eca8$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}

});





parcelRegister("gwpIa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c073943eb8518858$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $c073943eb8518858$var$TabContent = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'tab-content');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$c073943eb8518858$var$TabContent.displayName = 'TabContent';
var $c073943eb8518858$export$2e2bcd8739ae039 = $c073943eb8518858$var$TabContent;

});

parcelRegister("2MVtb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $207ca4c56930a497$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $4dgBw = parcelRequire("4dgBw");

var $bfB4F = parcelRequire("bfB4F");

var $5fb27 = parcelRequire("5fb27");

var $dz672 = parcelRequire("dz672");

var $bE9uK = parcelRequire("bE9uK");

var $gAjQZ = parcelRequire("gAjQZ");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $207ca4c56930a497$var$TabPane = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, transition: transition, ...props }, ref)=>{
    const [{ className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', ...rest }, { isActive: isActive, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit, transition: Transition = (0, $bE9uK.default) }] = (0, $5fb27.useTabPanel)({
        ...props,
        transition: (0, $gAjQZ.default)(transition)
    });
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'tab-pane');
    // We provide an empty the TabContext so `<Nav>`s in `<TabPanel>`s don't
    // conflict with the top level one.
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bfB4F.default).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
            value: null,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(Transition, {
                in: isActive,
                onEnter: onEnter,
                onEntering: onEntering,
                onEntered: onEntered,
                onExit: onExit,
                onExiting: onExiting,
                onExited: onExited,
                mountOnEnter: mountOnEnter,
                unmountOnExit: unmountOnExit,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
                    ...rest,
                    ref: ref,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, isActive && 'active')
                })
            })
        })
    });
});
$207ca4c56930a497$var$TabPane.displayName = 'TabPane';
var $207ca4c56930a497$export$2e2bcd8739ae039 = $207ca4c56930a497$var$TabPane;

});


parcelRegister("aoPxa", function(module, exports) {
$parcel$export(module.exports, "AddLinkButton", function () { return (parcelRequire("laHpz")).AddLinkButton; });
$parcel$export(module.exports, "AsyncButton", function () { return (parcelRequire("iuDOI")).AsyncButton; });
$parcel$export(module.exports, "CollapseRow", function () { return (parcelRequire("6822T")).CollapseRow; });
$parcel$export(module.exports, "Control210", function () { return (parcelRequire("kUTy1")).Control210; });
$parcel$export(module.exports, "Control211", function () { return (parcelRequire("aUt9N")).Control211; });
$parcel$export(module.exports, "Control213", function () { return (parcelRequire("iNEej")).Control213; });
$parcel$export(module.exports, "ControlBase", function () { return (parcelRequire("dd2Wn")).ControlBase; });
$parcel$export(module.exports, "ControlDate", function () { return (parcelRequire("3XbKn")).ControlDate; });
$parcel$export(module.exports, "ControlInlineEdit", function () { return (parcelRequire("i4t1Y")).ControlInlineEdit; });
$parcel$export(module.exports, "ControlNavList", function () { return (parcelRequire("fCofY")).ControlNavList; });
$parcel$export(module.exports, "ControlsGroup", function () { return (parcelRequire("lUxHn")).ControlsGroup; });
$parcel$export(module.exports, "ControlTags", function () { return (parcelRequire("fVo1v")).ControlTags; });
$parcel$export(module.exports, "ControlTypeAhead", function () { return (parcelRequire("8Uc5S")).ControlTypeAhead; });
$parcel$export(module.exports, "DraggableSidebar", function () { return (parcelRequire("fkJGt")).DraggableSidebar; });
$parcel$export(module.exports, "InTextLink", function () { return (parcelRequire("ifddf")).InTextLink; });
$parcel$export(module.exports, "ReorderableNavList", function () { return (parcelRequire("2VxLR")).ReorderableNavList; });
$parcel$export(module.exports, "SortableListHolder", function () { return (parcelRequire("3d5lD")).SortableListHolder; });
parcelRequire("laHpz");
parcelRequire("iuDOI");
parcelRequire("6822T");
parcelRequire("kUTy1");
parcelRequire("aUt9N");
parcelRequire("iNEej");
parcelRequire("dd2Wn");
parcelRequire("3XbKn");
parcelRequire("i4t1Y");
parcelRequire("fCofY");
parcelRequire("lUxHn");
parcelRequire("fVo1v");
parcelRequire("8Uc5S");
parcelRequire("4FU9I");
parcelRequire("fkJGt");
parcelRequire("ifddf");
parcelRequire("2VxLR");
parcelRequire("3d5lD");
parcelRequire("4MUDD");

});
parcelRegister("laHpz", function(module, exports) {

$parcel$export(module.exports, "AddLinkButton", function () { return $2b4e02811ad47f95$export$25406dc469b0f375; });

var $bR5nk = parcelRequire("bR5nk");

var $c28Y1 = parcelRequire("c28Y1");
var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");

var $gCZ2V = parcelRequire("gCZ2V");
const $2b4e02811ad47f95$export$25406dc469b0f375 = ({ label: label, onClick: onClick, disabled: disabled = false, colWidth: colWidth = 9, className: className = "" })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Group, {
        as: (0, $31g00.default),
        className: `mb-3 ${className}`,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
            sm: colWidth,
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $c28Y1.default), {
                variant: "link",
                className: "p-0 text-primary d-flex align-items-center text-decoration-none",
                onClick: onClick,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
                        size: 16,
                        className: "me-1"
                    }),
                    label
                ]
            })
        })
    });
};
$2b4e02811ad47f95$export$25406dc469b0f375.displayName = "AddLinkButton";

});
parcelRegister("iOTZL", function(module, exports) {

$parcel$export(module.exports, "useCol", function () { return $db3854fbe29916b1$export$2ed43d61a0a9f5a3; });
$parcel$export(module.exports, "default", function () { return $db3854fbe29916b1$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
function $db3854fbe29916b1$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'col');
    const breakpoints = (0, $dz672.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $dz672.useBootstrapMinBreakpoint)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $db3854fbe29916b1$var$Col = /*#__PURE__*/ $spJKX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $db3854fbe29916b1$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, !spans.length && bsPrefix)
    });
});
$db3854fbe29916b1$var$Col.displayName = 'Col';
var $db3854fbe29916b1$export$2e2bcd8739ae039 = $db3854fbe29916b1$var$Col;

});

parcelRegister("eZYX7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb60b1ef0f9a935$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $fGs19 = parcelRequire("fGs19");

var $spJKX = parcelRequire("spJKX");

var $ivVQI = parcelRequire("ivVQI");

var $34WuF = parcelRequire("34WuF");

var $fMLGG = parcelRequire("fMLGG");

var $aBQPJ = parcelRequire("aBQPJ");

var $4XVBb = parcelRequire("4XVBb");

var $f6ykx = parcelRequire("f6ykx");

var $6QRpt = parcelRequire("6QRpt");

var $3Q96n = parcelRequire("3Q96n");

var $g4kEh = parcelRequire("g4kEh");

var $dKDus = parcelRequire("dKDus");

var $bR5nk = parcelRequire("bR5nk");
const $aeb60b1ef0f9a935$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).elementType
};
const $aeb60b1ef0f9a935$var$Form = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, validated && 'was-validated')
    }));
$aeb60b1ef0f9a935$var$Form.displayName = 'Form';
$aeb60b1ef0f9a935$var$Form.propTypes = $aeb60b1ef0f9a935$var$propTypes;
var $aeb60b1ef0f9a935$export$2e2bcd8739ae039 = Object.assign($aeb60b1ef0f9a935$var$Form, {
    Group: (0, $aBQPJ.default),
    Control: (0, $34WuF.default),
    Floating: (0, $fMLGG.default),
    Check: (0, $ivVQI.default),
    Switch: $g4kEh.default,
    Label: (0, $4XVBb.default),
    Text: (0, $3Q96n.default),
    Range: (0, $f6ykx.default),
    Select: (0, $6QRpt.default),
    FloatingLabel: $dKDus.default
});

});
parcelRegister("ivVQI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7a7fee96bb71ea5$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $c7DnF = parcelRequire("c7DnF");

var $8Ytep = parcelRequire("8Ytep");

var $bRhu9 = parcelRequire("bRhu9");

var $92wCI = parcelRequire("92wCI");

var $dz672 = parcelRequire("dz672");

var $bMrPt = parcelRequire("bMrPt");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $d7a7fee96bb71ea5$var$FormCheck = /*#__PURE__*/ $spJKX.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $dz672.useBootstrapPrefix)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    const innerFormContext = (0, $spJKX.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $bMrPt.hasChildOfType)(children, (0, $bRhu9.default));
    const input = /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Ytep.default), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $92wCI.default).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRhu9.default), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c7DnF.default), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$d7a7fee96bb71ea5$var$FormCheck.displayName = 'FormCheck';
var $d7a7fee96bb71ea5$export$2e2bcd8739ae039 = Object.assign($d7a7fee96bb71ea5$var$FormCheck, {
    Input: (0, $8Ytep.default),
    Label: (0, $bRhu9.default)
});

});
parcelRegister("c7DnF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d34afb28bae7e13$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");

var $bR5nk = parcelRequire("bR5nk");
const $8d34afb28bae7e13$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).elementType
};
const $8d34afb28bae7e13$var$Feedback = /*#__PURE__*/ $spJKX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$8d34afb28bae7e13$var$Feedback.displayName = 'Feedback';
$8d34afb28bae7e13$var$Feedback.propTypes = $8d34afb28bae7e13$var$propTypes;
var $8d34afb28bae7e13$export$2e2bcd8739ae039 = $8d34afb28bae7e13$var$Feedback;

});

parcelRegister("8Ytep", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688a9a142a4630c1$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $92wCI = parcelRequire("92wCI");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $688a9a142a4630c1$var$FormCheckInput = /*#__PURE__*/ $spJKX.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$688a9a142a4630c1$var$FormCheckInput.displayName = 'FormCheckInput';
var $688a9a142a4630c1$export$2e2bcd8739ae039 = $688a9a142a4630c1$var$FormCheckInput;

});
parcelRegister("92wCI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $694d9b4ef9359aa0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
// TODO
const $694d9b4ef9359aa0$var$FormContext = /*#__PURE__*/ $spJKX.createContext({});
var $694d9b4ef9359aa0$export$2e2bcd8739ae039 = $694d9b4ef9359aa0$var$FormContext;

});


parcelRegister("bRhu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a223529f2102860$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $92wCI = parcelRequire("92wCI");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $8a223529f2102860$var$FormCheckLabel = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix)
    });
});
$8a223529f2102860$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $8a223529f2102860$export$2e2bcd8739ae039 = $8a223529f2102860$var$FormCheckLabel;

});

parcelRegister("bMrPt", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $8939c3af0968b602$export$871de8747c9eaa88; });
$parcel$export(module.exports, "forEach", function () { return $8939c3af0968b602$export$4b80e395e36b5a56; });
$parcel$export(module.exports, "hasChildOfType", function () { return $8939c3af0968b602$export$500fd6099226ffae; });

var $spJKX = parcelRequire("spJKX");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $8939c3af0968b602$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $spJKX.Children.map(children, (child)=>/*#__PURE__*/ $spJKX.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $8939c3af0968b602$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $spJKX.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $spJKX.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $8939c3af0968b602$export$500fd6099226ffae(children, type) {
    return $spJKX.Children.toArray(children).some((child)=>/*#__PURE__*/ $spJKX.isValidElement(child) && child.type === type);
}

});


parcelRegister("34WuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23df1e6ec2bf59d5$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $6WYSv = parcelRequire("6WYSv");

var $c7DnF = parcelRequire("c7DnF");

var $92wCI = parcelRequire("92wCI");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $23df1e6ec2bf59d5$var$FormControl = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-control');
    (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(controlId == null || !id, '`controlId` is ignored on `<FormControl>` when `id` is specified.');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$23df1e6ec2bf59d5$var$FormControl.displayName = 'FormControl';
var $23df1e6ec2bf59d5$export$2e2bcd8739ae039 = Object.assign($23df1e6ec2bf59d5$var$FormControl, {
    Feedback: $c7DnF.default
});

});
parcelRegister("6WYSv", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $50f761fa59a9e48b$var$__DEV__ = true;
var $50f761fa59a9e48b$var$warning = function() {};
if ($50f761fa59a9e48b$var$__DEV__) {
    var $50f761fa59a9e48b$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $50f761fa59a9e48b$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $50f761fa59a9e48b$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $50f761fa59a9e48b$var$warning;

});


parcelRegister("fMLGG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7e05476d023f36a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $b7e05476d023f36a$var$FormFloating = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$b7e05476d023f36a$var$FormFloating.displayName = 'FormFloating';
var $b7e05476d023f36a$export$2e2bcd8739ae039 = $b7e05476d023f36a$var$FormFloating;

});

parcelRegister("aBQPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9657ab31c4f16a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $92wCI = parcelRequire("92wCI");

var $bR5nk = parcelRequire("bR5nk");
const $7b9657ab31c4f16a$var$FormGroup = /*#__PURE__*/ $spJKX.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $spJKX.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $92wCI.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$7b9657ab31c4f16a$var$FormGroup.displayName = 'FormGroup';
var $7b9657ab31c4f16a$export$2e2bcd8739ae039 = $7b9657ab31c4f16a$var$FormGroup;

});

parcelRegister("4XVBb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39d959ff698f2f13$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $6WYSv = parcelRequire("6WYSv");

var $iOTZL = parcelRequire("iOTZL");

var $92wCI = parcelRequire("92wCI");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $39d959ff698f2f13$var$FormLabel = /*#__PURE__*/ $spJKX.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(controlId == null || !htmlFor, '`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified.');
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$39d959ff698f2f13$var$FormLabel.displayName = 'FormLabel';
var $39d959ff698f2f13$export$2e2bcd8739ae039 = $39d959ff698f2f13$var$FormLabel;

});

parcelRegister("f6ykx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff20bd05ef429b6$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $92wCI = parcelRequire("92wCI");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $aff20bd05ef429b6$var$FormRange = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        id: id || controlId
    });
});
$aff20bd05ef429b6$var$FormRange.displayName = 'FormRange';
var $aff20bd05ef429b6$export$2e2bcd8739ae039 = $aff20bd05ef429b6$var$FormRange;

});

parcelRegister("6QRpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4fd10782d312381e$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $92wCI = parcelRequire("92wCI");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $4fd10782d312381e$var$FormSelect = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $spJKX.useContext)((0, $92wCI.default));
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $bR5nk.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$4fd10782d312381e$var$FormSelect.displayName = 'FormSelect';
var $4fd10782d312381e$export$2e2bcd8739ae039 = $4fd10782d312381e$var$FormSelect;

});

parcelRegister("3Q96n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cbd49d8d0a41479$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $2cbd49d8d0a41479$var$FormText = /*#__PURE__*/ $spJKX.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, muted && 'text-muted')
    });
});
$2cbd49d8d0a41479$var$FormText.displayName = 'FormText';
var $2cbd49d8d0a41479$export$2e2bcd8739ae039 = $2cbd49d8d0a41479$var$FormText;

});

parcelRegister("g4kEh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb2d096f7c51d205$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $ivVQI = parcelRequire("ivVQI");

var $bR5nk = parcelRequire("bR5nk");
const $bb2d096f7c51d205$var$Switch = /*#__PURE__*/ $spJKX.forwardRef((props, ref)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $ivVQI.default), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$bb2d096f7c51d205$var$Switch.displayName = 'Switch';
var $bb2d096f7c51d205$export$2e2bcd8739ae039 = Object.assign($bb2d096f7c51d205$var$Switch, {
    Input: (0, $ivVQI.default).Input,
    Label: (0, $ivVQI.default).Label
});

});

parcelRegister("dKDus", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a02e342f9d4a2109$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $aBQPJ = parcelRequire("aBQPJ");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $a02e342f9d4a2109$var$FloatingLabel = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aBQPJ.default), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$a02e342f9d4a2109$var$FloatingLabel.displayName = 'FloatingLabel';
var $a02e342f9d4a2109$export$2e2bcd8739ae039 = $a02e342f9d4a2109$var$FloatingLabel;

});


parcelRegister("31g00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $232de027bff89020$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $232de027bff89020$var$Row = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'row');
    const breakpoints = (0, $dz672.useBootstrapBreakpoints)();
    const minBreakpoint = (0, $dz672.useBootstrapMinBreakpoint)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, decoratedBsPrefix, ...classes)
    });
});
$232de027bff89020$var$Row.displayName = 'Row';
var $232de027bff89020$export$2e2bcd8739ae039 = $232de027bff89020$var$Row;

});


parcelRegister("6822T", function(module, exports) {

$parcel$export(module.exports, "CollapseRow", function () { return $d24a9bc64c7fe025$export$d0d261886ae9657b; });

var $bR5nk = parcelRequire("bR5nk");

var $iOTZL = parcelRequire("iOTZL");
var $fa1i3 = parcelRequire("fa1i3");
var $4XVBb = parcelRequire("4XVBb");
var $31g00 = parcelRequire("31g00");

var $1cWYI = parcelRequire("1cWYI");
var $2d6Pt = parcelRequire("2d6Pt");
const $d24a9bc64c7fe025$export$d0d261886ae9657b = ({ label: label, isOpen: isOpen, setIsOpen: setIsOpen, children: children, ...rest })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
        ...rest,
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $4XVBb.default), {
                            onClick: ()=>setIsOpen((prev)=>!prev),
                            className: "d-flex align-items-center cursor-pointer",
                            children: [
                                typeof label === "string" ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    className: "fw-bold",
                                    children: label
                                }) : label,
                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    className: "ms-2",
                                    children: isOpen ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1cWYI.default), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {})
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa1i3.default), {
                    className: "mb-2",
                    in: isOpen,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: children
                    })
                })
            ]
        })
    });
$d24a9bc64c7fe025$export$d0d261886ae9657b.displayName = "CollapseRow";

});
parcelRegister("fa1i3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b098ca68520fa7b7$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $hSUY5 = parcelRequire("hSUY5");

var $spJKX = parcelRequire("spJKX");

var $iu3Vz = parcelRequire("iu3Vz");

var $feFtK = parcelRequire("feFtK");

var $fSJNV = parcelRequire("fSJNV");

var $8WlkA = parcelRequire("8WlkA");

var $7je9W = parcelRequire("7je9W");

var $jVveE = parcelRequire("jVveE");

var $bR5nk = parcelRequire("bR5nk");
const $b098ca68520fa7b7$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $b098ca68520fa7b7$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $b098ca68520fa7b7$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $hSUY5.default)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $hSUY5.default)(elem, margins[1]), 10);
}
const $b098ca68520fa7b7$var$collapseStyles = {
    [(0, $iu3Vz.EXITED)]: 'collapse',
    [(0, $iu3Vz.EXITING)]: 'collapsing',
    [(0, $iu3Vz.ENTERING)]: 'collapsing',
    [(0, $iu3Vz.ENTERED)]: 'collapse show'
};
const $b098ca68520fa7b7$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $b098ca68520fa7b7$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $spJKX.useMemo)(()=>(0, $8WlkA.default)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $spJKX.useMemo)(()=>(0, $8WlkA.default)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $spJKX.useMemo)(()=>(0, $8WlkA.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $spJKX.useMemo)(()=>(0, $8WlkA.default)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $7je9W.default)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $spJKX.useMemo)(()=>(0, $8WlkA.default)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jVveE.default), {
        ref: ref,
        addEndListener: (0, $fSJNV.default),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $feFtK.getChildRef)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, children.props.className, $b098ca68520fa7b7$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$b098ca68520fa7b7$var$Collapse.displayName = 'Collapse';
var $b098ca68520fa7b7$export$2e2bcd8739ae039 = $b098ca68520fa7b7$var$Collapse;

});
parcelRegister("8WlkA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6824496eb9035bf2$export$2e2bcd8739ae039; });
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $6824496eb9035bf2$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $6824496eb9035bf2$export$2e2bcd8739ae039 = $6824496eb9035bf2$var$createChainedFunction;

});


parcelRegister("1cWYI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e14a949d29a3381$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $0e14a949d29a3381$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0e14a949d29a3381$var$_extends() {
    return $0e14a949d29a3381$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0e14a949d29a3381$var$_extends.apply(null, arguments);
}
function $0e14a949d29a3381$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0e14a949d29a3381$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0e14a949d29a3381$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0e14a949d29a3381$var$ChevronDown = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $0e14a949d29a3381$var$_objectWithoutProperties(_ref, $0e14a949d29a3381$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $0e14a949d29a3381$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-down',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
    }));
});
$0e14a949d29a3381$var$ChevronDown.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $0e14a949d29a3381$export$2e2bcd8739ae039 = $0e14a949d29a3381$var$ChevronDown;

});

parcelRegister("2d6Pt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c217d2f3d073cf$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $19c217d2f3d073cf$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $19c217d2f3d073cf$var$_extends() {
    return $19c217d2f3d073cf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $19c217d2f3d073cf$var$_extends.apply(null, arguments);
}
function $19c217d2f3d073cf$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $19c217d2f3d073cf$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $19c217d2f3d073cf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $19c217d2f3d073cf$var$ChevronRight = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $19c217d2f3d073cf$var$_objectWithoutProperties(_ref, $19c217d2f3d073cf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $19c217d2f3d073cf$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
    }));
});
$19c217d2f3d073cf$var$ChevronRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $19c217d2f3d073cf$export$2e2bcd8739ae039 = $19c217d2f3d073cf$var$ChevronRight;

});


parcelRegister("kUTy1", function(module, exports) {

$parcel$export(module.exports, "Control210", function () { return $7bdde55d7c640472$export$8bdae7a3d24bf7ec; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");
var $4D2as = parcelRequire("4D2as");
var $4dL47 = parcelRequire("4dL47");

var $dd2Wn = parcelRequire("dd2Wn");

var $i4t1Y = parcelRequire("i4t1Y");

var $4FU9I = parcelRequire("4FU9I");

var $ifddf = parcelRequire("ifddf");
const $7bdde55d7c640472$export$8bdae7a3d24bf7ec = ({ id: id, ActionButton: ActionButton, allowCarriageReturn: allowCarriageReturn = false, allowCopy: allowCopy = false, autoFocus: autoFocus, disabled: disabled, editButton: editButton = false, forcePrefix: forcePrefix = "", invalidMessage: invalidMessage, isJsonText: isJsonText = false, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, noInvalidReturn: noInvalidReturn, onEditChange: onEditChange, ReadComponent: ReadComponent, rows: rows, setValue: setValue, spellCheck: spellCheck = true, subText: subText, type: type = "string", validCondition: validCondition, validMessage: validMessage, validationTargetOptions: validationTargetOptions, validationRequestUrl: validationRequestUrl = "", validationReturn: validationReturn, value: value, whiteSpaceFix: whiteSpaceFix = false, ...rest })=>{
    // Run validation check on current value
    const [validationStatus, setValidationStatus] = (0, $spJKX.useState)({
        success: false,
        errorText: ""
    });
    const [validationRequest, setValidationRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    // Edit-button mode state; starts as true when there is no edit button so the input is always active
    const [isEditing, setIsEditing] = (0, $spJKX.useState)(!editButton);
    // Tracks the value the user is currently typing in edit mode so validation runs live.
    // When not in edit mode, validation uses the committed `value` prop instead.
    const [editingValue, setEditingValue] = (0, $spJKX.useState)(value);
    // The value to validate: use the in-progress editing value while editing, otherwise the committed prop value.
    const validationValue = editButton && isEditing ? editingValue : value;
    const lastEffectValidationTarget = (0, $spJKX.useRef)(undefined);
    /**
   * Runs validation for a candidate control value and updates validation state.
   *
   * @param newValue - Candidate value and validation options to check
   * @returns The completed validation response, or null when no response is returned
   */ const runValidation = async (newValue)=>{
        if (!validCondition) {
            const response = {
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            };
            setValidationStatus(response);
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
            return response;
        } else {
            const response = await (0, $4dL47.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, (ret)=>{
                // Report the current name as not-yet-valid as soon as a new validation check starts if a check needs to occur
                // consumers (e.g. save/set buttons) cannot act on a stale valid result while this one is pending.
                if (ret.requesting) validationReturn?.(false);
                setValidationRequest(ret);
            }, validationRequestUrl);
            /* istanbul ignore else */ if (response) {
                setValidationStatus(response);
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
            return response;
        }
    };
    const checkValidation = (0, $spJKX.useEffectEvent)(runValidation);
    /**
   * Updates the committed value after completing validation for the proposed value.
   *
   * @param newValue - Value produced by the input control
   */ const setValidatedValue = async (newValue)=>{
        if (validCondition) {
            const response = await runValidation({
                value: newValue,
                options: validationTargetOptions
            });
            const isValid = response?.success === true && response.data.valid === true;
            if (!noInvalidReturn || isValid) setValue?.(newValue);
        } else setValue?.(newValue);
    };
    /** Call validation when the value or options change */ (0, $spJKX.useEffect)(()=>{
        const target = {
            value: validationValue,
            options: validationTargetOptions
        };
        if (!(0, $eBlbF.isEqual)(target, lastEffectValidationTarget.current)) {
            lastEffectValidationTarget.current = target;
            checkValidation(target);
        }
    }, [
        validationRequest.requesting,
        validationTargetOptions,
        validationValue
    ]);
    // Calculate extra column deductions (allowCopy and actionButton each take 1 col)
    const extraColDeduction = (allowCopy ? 1 : 0) + (ActionButton ? 1 : 0);
    const isInputDisabled = disabled === true || !setValue;
    const validationClassName = validationStatus.success && !validationRequest.requesting ? validationStatus.data.warning ? "is-warning" : validationStatus.data.valid === true ? "is-valid" : "is-invalid" : "";
    const combinedClassName = (0, $3tKzd.classMerge)([
        rest.className,
        validationClassName
    ]);
    const hasWarningState = combinedClassName.split(/\s+/).includes("is-warning");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
        as: (0, $31g00.default),
        className: "my-1",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                htmlFor: id,
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                md: labelWidth === "auto" ? undefined : Math.max(maxWidthCols - labelWidth - extraColDeduction, 1),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "d-flex align-items-center gap-1",
                        children: editButton ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i4t1Y.ControlInlineEdit), {
                            ...rest,
                            id: id,
                            value: isJsonText ? (0, $4D2as.formatJson)(value) : value,
                            setValue: setValue ? (ret)=>void setValidatedValue(ret) : undefined,
                            onDraftChange: setEditingValue,
                            onEditChange: (editing)=>{
                                setIsEditing(editing);
                                onEditChange?.(editing);
                            },
                            preventInvalidExit: false,
                            ReadComponent: ReadComponent,
                            editButtonVariant: "outline-primary",
                            whiteSpaceFix: whiteSpaceFix,
                            disabled: disabled,
                            type: isJsonText ? "textarea" : type,
                            forcePrefix: forcePrefix,
                            rows: rows,
                            allowCarriageReturn: allowCarriageReturn,
                            className: combinedClassName,
                            spellCheck: spellCheck,
                            autoFocus: autoFocus
                        }) : isInputDisabled && ReadComponent ? /*#__PURE__*/ (0, $bR5nk.jsx)(ReadComponent, {
                            value: value
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dd2Wn.ControlBase), {
                            ...rest,
                            id: id,
                            value: isJsonText ? (0, $4D2as.formatJson)(value) : value,
                            setValue: (ret)=>void setValidatedValue(ret),
                            whiteSpaceFix: whiteSpaceFix,
                            disabled: isInputDisabled,
                            type: isJsonText ? "textarea" : type,
                            forcePrefix: forcePrefix,
                            rows: rows,
                            allowCarriageReturn: allowCarriageReturn,
                            className: combinedClassName,
                            spellCheck: spellCheck,
                            autoFocus: autoFocus
                        })
                    }),
                    (subText || validCondition) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                        className: `${validationStatus.success && !validationRequest.requesting ? hasWarningState ? "warning-feedback d-block" : validationStatus.data?.valid === true ? "valid-feedback d-block" : "invalid-feedback d-block" : "text-muted"}`,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ifddf.InTextLink), {
                            text: [
                                subText ?? "",
                                validationRequest.requesting ? "updating status..." : validationStatus.success ? validationStatus.data.validationText !== "" ? validationStatus.data.validationText : validationStatus.data.valid === true ? validMessage ?? // istanbul ignore next
                                "" : invalidMessage ?? // istanbul ignore next
                                "" : validationStatus.errorText
                            ].filter((s)=>s !== "").join(", ")
                        })
                    })
                ]
            }),
            allowCopy && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                xs: 1,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4FU9I.CopyText), {
                    value: value
                })
            }),
            ActionButton && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                xs: 1,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(ActionButton, {})
            })
        ]
    });
};
$7bdde55d7c640472$export$8bdae7a3d24bf7ec.displayName = "Control210";

});
parcelRegister("dd2Wn", function(module, exports) {

$parcel$export(module.exports, "ControlBase", function () { return $0396f6945b69cc5f$export$176dfbb73f409824; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
parcelRequire("5SMPf");
var $dD4jq = parcelRequire("dD4jq");

const $0396f6945b69cc5f$export$176dfbb73f409824 = (props)=>{
    const { allowCarriageReturn: allowCarriageReturn = false, className: className = "", debounceMilliseconds: debounceMilliseconds = 500, disabled: disabled = false, forcePrefix: forcePrefix = "", sanitiseValue: sanitiseValue, setValue: setValue, spellCheck: spellCheck = true, type: type = "string", value: value, whiteSpaceFix: whiteSpaceFix = false, ...rest } = props;
    const [currentValue, setCurrentValue] = (0, $spJKX.useState)(value);
    const debounceTimer = (0, $spJKX.useRef)(null);
    /**
   * Force an immediate update, bypassing debounce.
   *
   * @param newValue - Optional new value to set before forcing the update
   */ const forceUpdate = (newValue)=>{
        // Clear any pending debounce timer
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
        // Use provided value or current value
        const valueToUpdate = newValue ?? currentValue;
        // Update parent if setValue is available
        setValue?.(valueToUpdate);
        // Update local state if new value provided
        if (newValue !== undefined) setCurrentValue(valueToUpdate);
    };
    // Sync with parent value changes
    (0, $spJKX.useEffect)(()=>{
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
        (0, $spJKX.startTransition)(()=>setCurrentValue(value));
    }, [
        value
    ]);
    // Handle debounced updates when currentValue changes
    (0, $spJKX.useEffect)(()=>{
        const fixedValue = whiteSpaceFix ? (0, $dD4jq.valueFix)(value, true) : value;
        // Only debounce if setValue exists and value differs from parent
        /* istanbul ignore else */ if (setValue && currentValue !== fixedValue) {
            // Clear existing timer
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            // Set up debounced update (0ms for immediate, for negative values no need to set)
            if (debounceMilliseconds >= 0) debounceTimer.current = setTimeout(()=>{
                setValue(currentValue);
                debounceTimer.current = null;
            }, debounceMilliseconds);
        } else if (currentValue === fixedValue) // If values are the same, ensure no pending timer
        {
            if (debounceTimer.current) {
                clearTimeout(debounceTimer.current);
                debounceTimer.current = null;
            }
        }
        // Cleanup function to clear timer on unmount
        return ()=>{
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
        };
    }, [
        currentValue,
        debounceMilliseconds,
        setValue,
        value,
        whiteSpaceFix
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
        ...rest,
        autoFocus: props.autoFocus,
        as: type === "textarea" ? "textarea" : undefined,
        className: className,
        disabled: disabled || !setValue,
        onBlur: (e)=>{
            if (e.currentTarget.value !== value) {
                const fixedValue = whiteSpaceFix ? (0, $dD4jq.valueFix)(e.currentTarget.value, true) : e.currentTarget.value;
                setCurrentValue(fixedValue);
                forceUpdate(fixedValue);
            }
        },
        onChange: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            /* istanbul ignore else */ if (e.currentTarget.value.startsWith(forcePrefix)) {
                const newValue = sanitiseValue?.(e.currentTarget.value) ?? e.currentTarget.value;
                setCurrentValue(newValue);
            }
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter" && !allowCarriageReturn || e.key === "Enter" && e.shiftKey && allowCarriageReturn && type === "textarea") {
                e.preventDefault();
                e.stopPropagation();
                forceUpdate();
            }
        },
        placeholder: props.placeholder,
        size: "sm",
        spellCheck: spellCheck,
        type: type !== "textarea" ? type : undefined,
        value: currentValue
    });
};
$0396f6945b69cc5f$export$176dfbb73f409824.displayName = "ControlBase";

});

parcelRegister("i4t1Y", function(module, exports) {

$parcel$export(module.exports, "ControlInlineEdit", function () { return $d77a085413137660$export$3b7a715021016461; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");

var $av9bi = parcelRequire("av9bi");
var $bP72q = parcelRequire("bP72q");

var $dD4jq = parcelRequire("dD4jq");

var $dd2Wn = parcelRequire("dd2Wn");
const $d77a085413137660$export$3b7a715021016461 = ({ id: id, deleteLabel: deleteLabel = "Delete", draftValue: draftValue, editButtonVariant: editButtonVariant = "link", editLabel: editLabel = "Edit", editOnDoubleClick: editOnDoubleClick = false, disabled: disabled = false, isInvalid: isInvalid = false, onDelete: onDelete, onDraftChange: onDraftChange, onEditChange: onEditChange, onInput: onInput, preventInvalidExit: preventInvalidExit = true, ReadComponent: ReadComponent, setValue: setValue, showEditButtonWhileEditing: showEditButtonWhileEditing = false, value: value, whiteSpaceFix: whiteSpaceFix = false, ...rest })=>{
    const [editing, setEditing] = (0, $spJKX.useState)(false);
    const [draft, setDraft] = (0, $spJKX.useState)(value);
    const cancelled = (0, $spJKX.useRef)(false);
    const inputDisabled = !editing || disabled || !setValue;
    (0, $spJKX.useEffect)(()=>{
        if (editing) {
            const input = document.getElementById(id);
            if (input) input.focus();
        }
    }, [
        editing,
        id
    ]);
    /**
   * Captures the committed value as a draft and enters inline edit mode.
   */ const startEdit = ()=>{
        cancelled.current = false;
        setDraft(value);
        setEditing(true);
        onDraftChange?.(value);
        onEditChange?.(true);
    };
    /**
   * Commits or cancels an edit when focus leaves the control, retaining invalid drafts.
   *
   * @param event - Wrapper blur containing the input and the next focused element
   */ const handleBlur = (event)=>{
        if (editing && !event.currentTarget.contains(event.relatedTarget)) {
            const input = event.target;
            if (preventInvalidExit && isInvalid) queueMicrotask(()=>input.focus());
            else {
                if (!cancelled.current && !disabled) setValue?.(whiteSpaceFix ? (0, $dD4jq.valueFix)(input.value, true) : input.value);
                cancelled.current = false;
                setDraft(value);
                setEditing(false);
                onEditChange?.(false);
            }
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex align-items-start gap-2 w-100",
        onBlurCapture: handleBlur,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "flex-grow-1",
                style: {
                    minWidth: 0
                },
                onDoubleClick: editOnDoubleClick && !disabled && setValue && !editing ? startEdit : undefined,
                children: inputDisabled && ReadComponent ? /*#__PURE__*/ (0, $bR5nk.jsx)(ReadComponent, {
                    value: value
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dd2Wn.ControlBase), {
                    ...rest,
                    id: id,
                    disabled: inputDisabled,
                    isInvalid: isInvalid,
                    value: editing ? draftValue ?? draft : value,
                    setValue: setDraft,
                    whiteSpaceFix: whiteSpaceFix,
                    debounceMilliseconds: -1,
                    onInput: (event)=>{
                        setDraft(event.currentTarget.value);
                        onDraftChange?.(event.currentTarget.value);
                        onInput?.(event);
                    },
                    onKeyDownCapture: (event)=>{
                        if (event.key === "Escape") {
                            event.preventDefault();
                            event.stopPropagation();
                            if (!preventInvalidExit || !isInvalid) {
                                cancelled.current = true;
                                event.currentTarget.blur();
                                setDraft(value);
                            }
                        } else if (event.key === "Enter" && !(event.shiftKey && rest.allowCarriageReturn && rest.type === "textarea")) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.currentTarget.blur();
                        }
                    }
                })
            }),
            setValue && (!editing || showEditButtonWhileEditing) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                size: "sm",
                variant: editButtonVariant,
                className: editButtonVariant === "link" ? "p-0 text-primary" : undefined,
                "aria-label": editLabel,
                title: editLabel,
                disabled: disabled || editing,
                style: {
                    flexShrink: 0
                },
                onClick: startEdit,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bP72q.default), {})
            }),
            onDelete && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                size: "sm",
                variant: "link",
                className: "p-0 text-danger",
                "aria-label": deleteLabel,
                title: deleteLabel,
                disabled: disabled || editing,
                style: {
                    flexShrink: 0
                },
                onClick: ()=>onDelete(),
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {})
            })
        ]
    });
};
$d77a085413137660$export$3b7a715021016461.displayName = "ControlInlineEdit";

});
parcelRegister("av9bi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a53ebd96de1fa0c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $7a53ebd96de1fa0c$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $7a53ebd96de1fa0c$var$_extends() {
    return $7a53ebd96de1fa0c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7a53ebd96de1fa0c$var$_extends.apply(null, arguments);
}
function $7a53ebd96de1fa0c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7a53ebd96de1fa0c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7a53ebd96de1fa0c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7a53ebd96de1fa0c$var$DashCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $7a53ebd96de1fa0c$var$_objectWithoutProperties(_ref, $7a53ebd96de1fa0c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $7a53ebd96de1fa0c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-dash-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"
    }));
});
$7a53ebd96de1fa0c$var$DashCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $7a53ebd96de1fa0c$export$2e2bcd8739ae039 = $7a53ebd96de1fa0c$var$DashCircle;

});

parcelRegister("bP72q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0238ad138e730051$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $0238ad138e730051$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $0238ad138e730051$var$_extends() {
    return $0238ad138e730051$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $0238ad138e730051$var$_extends.apply(null, arguments);
}
function $0238ad138e730051$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0238ad138e730051$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $0238ad138e730051$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $0238ad138e730051$var$Pen = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $0238ad138e730051$var$_objectWithoutProperties(_ref, $0238ad138e730051$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $0238ad138e730051$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pen',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"
    }));
});
$0238ad138e730051$var$Pen.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $0238ad138e730051$export$2e2bcd8739ae039 = $0238ad138e730051$var$Pen;

});


parcelRegister("4FU9I", function(module, exports) {

$parcel$export(module.exports, "CopyText", function () { return $16374bb650436e09$export$1d8a493107fb4b3a; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3bZGF = parcelRequire("3bZGF");
var $3VYCn = parcelRequire("3VYCn");

const $16374bb650436e09$export$1d8a493107fb4b3a = ({ value: value, disabled: disabled = false, onCopy: onCopy })=>{
    const [copied, setCopied] = (0, $spJKX.useState)(false);
    /**
   * Copies text to clipboard and shows confirmation feedback.
   */ const handleCopy = async ()=>{
        if (disabled) return;
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            if (onCopy) onCopy();
            setTimeout(()=>setCopied(false), 2000);
        } catch (error) {
            console.warn("Failed to copy text: ", error);
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: `copy-text-container ${disabled ? "disabled" : ""}`,
        onClick: handleCopy,
        title: copied ? "Copied!" : "Copy to Clipboard",
        children: copied ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3bZGF.default), {
            className: "copied-icon"
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3VYCn.default), {
            className: "copy-icon"
        })
    });
};
$16374bb650436e09$export$1d8a493107fb4b3a.displayName = "CopyText";

});
parcelRegister("3bZGF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25323ff6bc9e09c3$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $25323ff6bc9e09c3$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $25323ff6bc9e09c3$var$_extends() {
    return $25323ff6bc9e09c3$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $25323ff6bc9e09c3$var$_extends.apply(null, arguments);
}
function $25323ff6bc9e09c3$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $25323ff6bc9e09c3$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $25323ff6bc9e09c3$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $25323ff6bc9e09c3$var$Check = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $25323ff6bc9e09c3$var$_objectWithoutProperties(_ref, $25323ff6bc9e09c3$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $25323ff6bc9e09c3$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"
    }));
});
$25323ff6bc9e09c3$var$Check.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $25323ff6bc9e09c3$export$2e2bcd8739ae039 = $25323ff6bc9e09c3$var$Check;

});

parcelRegister("3VYCn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2dd5b76b9f06db4e$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $2dd5b76b9f06db4e$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $2dd5b76b9f06db4e$var$_extends() {
    return $2dd5b76b9f06db4e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2dd5b76b9f06db4e$var$_extends.apply(null, arguments);
}
function $2dd5b76b9f06db4e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2dd5b76b9f06db4e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2dd5b76b9f06db4e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2dd5b76b9f06db4e$var$Copy = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $2dd5b76b9f06db4e$var$_objectWithoutProperties(_ref, $2dd5b76b9f06db4e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $2dd5b76b9f06db4e$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-copy',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
    }));
});
$2dd5b76b9f06db4e$var$Copy.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $2dd5b76b9f06db4e$export$2e2bcd8739ae039 = $2dd5b76b9f06db4e$var$Copy;

});


parcelRegister("ifddf", function(module, exports) {

$parcel$export(module.exports, "InTextLink", function () { return $3c50fe2e5e158139$export$7dedd20f026aa918; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
const $3c50fe2e5e158139$export$c98178282bbfc788 = (groups)=>{
    const newGroups = [];
    const urlRe = /\[([^[]+)\]\((.*)\)/gm;
    let match;
    groups.forEach((group)=>{
        if (group.type === "string" && group.text !== undefined) {
            let i = 0;
            while((match = urlRe.exec(group.text)) !== null){
                if (match.index > i) newGroups.push({
                    type: "string",
                    text: group.text.substring(i, match.index)
                });
                newGroups.push({
                    type: "link",
                    text: match[1],
                    href: match[2]
                });
                i = match.index + match[0].length;
            }
            if (i < group.text.length) newGroups.push({
                type: "string",
                text: group.text.substring(i)
            });
        } else newGroups.push(group);
    });
    return newGroups;
};
const $3c50fe2e5e158139$export$5a387c01ade40f44 = (groups)=>{
    const newGroups = [];
    const urlRe = /(http:\/\/[\w\d.]+)/gm;
    let match;
    groups.forEach((group)=>{
        if (group.type === "string" && group.text !== undefined) {
            let i = 0;
            while((match = urlRe.exec(group.text)) !== null){
                /* istanbul ignore else */ if (match.index > i) newGroups.push({
                    type: "string",
                    text: group.text.substring(i, match.index)
                });
                newGroups.push({
                    type: "link",
                    text: "link",
                    href: match[1]
                });
                i = match.index + match[0].length;
            }
            if (i < group.text.length) newGroups.push({
                type: "string",
                text: group.text.substring(i)
            });
        } else newGroups.push(group);
    });
    return newGroups;
};
const $3c50fe2e5e158139$export$7dedd20f026aa918 = ({ text: text })=>{
    let groups = [
        {
            type: "string",
            text: text
        }
    ];
    groups = $3c50fe2e5e158139$export$c98178282bbfc788(groups);
    groups = $3c50fe2e5e158139$export$5a387c01ade40f44(groups);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: groups.map((group, i)=>{
            switch(group.type){
                case "string":
                    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $spJKX.Fragment), {
                        children: group.text
                    }, i);
                case "link":
                    return /*#__PURE__*/ (0, $bR5nk.jsx)("a", {
                        href: group.href,
                        target: "_blank",
                        rel: "noreferrer",
                        children: group.text
                    }, i);
            }
        })
    });
};
$3c50fe2e5e158139$export$7dedd20f026aa918.displayName = "InTextLink";

});


parcelRegister("aUt9N", function(module, exports) {

$parcel$export(module.exports, "Control211", function () { return $f9ada553b0e6ef3d$export$62b044822953a2ee; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $4dL47 = parcelRequire("4dL47");

var $ifddf = parcelRequire("ifddf");
const $f9ada553b0e6ef3d$export$62b044822953a2ee = ({ id: id, contentSize: contentSize = false, disabled: disabled, invalidMessage: invalidMessage, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, multiple: multiple, options: options, setValue: setValue, subText: subText, title: title, validCondition: validCondition, validMessage: validMessage, validationTargetOptions: validationTargetOptions, validationRequestUrl: validationRequestUrl = "", validationReturn: validationReturn, value: value })=>{
    // Run validation check on current value
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const [validationStatus, setValidationStatus] = (0, $spJKX.useState)({
        success: false,
        errorText: ""
    });
    const [validationRequest, setValidationRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Checks validation for the current value.
   *
   * @param newValue - The validation target containing the value to check
   */ const checkValidation = (0, $spJKX.useEffectEvent)(async (newValue)=>{
        if (!validCondition) startTransition(()=>{
            setValidationStatus({
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            });
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
        });
        else {
            const response = await (0, $4dL47.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, setValidationRequest, validationRequestUrl);
            /* istanbul ignore else */ if (response) {
                startTransition(()=>setValidationStatus(response));
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
        }
    });
    (0, $spJKX.useEffect)(()=>{
        if (!validationRequest.requesting && (value !== validationRequest.requestedId?.value || !(0, $eBlbF.isEqual)(validationTargetOptions, validationRequest.requestedId?.options))) checkValidation({
            value: value,
            options: validationTargetOptions
        });
    }, [
        validationRequest,
        validationTargetOptions,
        value
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
        controlId: `${id}`,
        as: (0, $31g00.default),
        className: "my-1",
        title: title,
        children: [
            labelWidth !== 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                md: labelWidth === 0 ? maxWidthCols : labelWidth === "auto" ? undefined : maxWidthCols - labelWidth,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Select, {
                        multiple: multiple,
                        style: {
                            minHeight: multiple ? "120px" : undefined,
                            fieldSizing: contentSize ? "content" : undefined
                        },
                        size: "sm",
                        value: multiple ? value ? value.split("|") : [] : value,
                        disabled: disabled || !setValue,
                        onChange: (e)=>setValue?.(multiple ? Array.from(e.currentTarget.selectedOptions, (option)=>option.value).join("|") : e.currentTarget.value),
                        "aria-label": label,
                        className: `${validationStatus.success && !validationRequest.requesting ? validationStatus.data.valid === true ? "is-valid" : "is-invalid" : ""}`,
                        children: options.map((o)=>typeof o === "string" ? {
                                value: o,
                                label: o
                            } : o).map((o, i)=>/*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                                value: o.value,
                                children: o.label
                            }, i))
                    }),
                    (subText || validCondition) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                        style: {
                            minHeight: "1.5em",
                            display: "block"
                        },
                        className: `${validationStatus.success && !validationRequest.requesting ? validationStatus.data?.valid === true ? "valid-feedback" : "invalid-feedback" : "text-muted"}`,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ifddf.InTextLink), {
                            text: [
                                subText ?? "",
                                validationRequest.requesting || pending ? "updating status..." : validationStatus.success ? validationStatus.data.validationText !== "" ? validationStatus.data.validationText : validationStatus.data.valid === true ? validMessage ?? // istanbul ignore next
                                "" : invalidMessage ?? // istanbul ignore next
                                "" : ""
                            ].filter((f)=>f !== "").join(" ")
                        })
                    })
                ]
            })
        ]
    });
};
$f9ada553b0e6ef3d$export$62b044822953a2ee.displayName = "Control211";

});

parcelRegister("iNEej", function(module, exports) {

$parcel$export(module.exports, "Control213", function () { return $2fa3da66cf5b9bee$export$a68e0b398c3ef1ab; });

var $bR5nk = parcelRequire("bR5nk");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
/**
 * Internal component for rendering a group of related checkboxes with a "Select All" option.
 *
 * @param props - Component props
 * @param props.id - Unique identifier for the checkbox group
 * @param props.checked - Array of checked states for each checkbox
 * @param props.disabled - Whether all checkboxes are disabled
 * @param props.groupLabel - Overall label for the group
 * @param props.labelWidth - Width of the label column in Bootstrap grid units
 * @param props.labels - Array of labels for individual checkboxes
 * @param props.maxWidthCols - Maximum width in Bootstrap grid columns
 * @param props.offsetCols - Number of columns to offset the group
 * @param props.setChecked - Callback function to update all checked states
 * @returns A React functional component rendering a Form.Group with multiple checkboxes
 */ const $2fa3da66cf5b9bee$var$CheckedGroup = ({ id: id, groupLabel: groupLabel, labels: labels, labelWidth: labelWidth, maxWidthCols: maxWidthCols, offsetCols: offsetCols, checked: checked, setChecked: setChecked, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
        controlId: id,
        as: (0, $31g00.default),
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                column: true,
                md: labelWidth,
                offset: offsetCols,
                children: groupLabel
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                md: maxWidthCols - labelWidth - offsetCols,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                        id: `${id}-select-all`,
                        className: "mb-1",
                        label: "Select All",
                        type: "checkbox",
                        checked: labels.length === checked.filter((c)=>c).length,
                        onChange: (e)=>{
                            setChecked(labels.map(()=>e.target.checked));
                        },
                        disabled: disabled
                    }),
                    labels.map((label, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                            id: `${id}-${index}`,
                            type: "checkbox",
                            name: `${id}-${index}`,
                            label: label,
                            checked: checked[index],
                            onChange: (e)=>{
                                const newChecked = [
                                    ...checked
                                ];
                                newChecked[index] = e.target.checked;
                                setChecked(newChecked);
                            },
                            disabled: disabled
                        }, index))
                ]
            })
        ]
    });
};
$2fa3da66cf5b9bee$var$CheckedGroup.displayName = "CheckedGroup";
const $2fa3da66cf5b9bee$export$a68e0b398c3ef1ab = ({ id: id, type: type = "checkbox", name: name, label: label, groupLabel: groupLabel, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, offsetCols: offsetCols, checked: checked, setChecked: setChecked, disabled: disabled })=>{
    const sensibleCheck = new Set([
        Array.isArray(checked),
        Array.isArray(label)
    ]);
    return sensibleCheck.size > 1 ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: "Mismatch in labels/checks"
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: typeof label === "string" && typeof checked === "boolean" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Group, {
            controlId: `${id}`,
            as: (0, $31g00.default),
            className: "mb-1",
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                md: {
                    span: maxWidthCols - labelWidth - (offsetCols ?? 0),
                    offset: offsetCols
                },
                className: "d-flex align-items-center",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                    type: type,
                    name: name ?? id,
                    label: label,
                    checked: checked,
                    onChange: (e)=>setChecked && setChecked(e.target.checked),
                    disabled: disabled
                })
            })
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)($2fa3da66cf5b9bee$var$CheckedGroup, {
            id: id,
            groupLabel: groupLabel || "",
            labels: label,
            labelWidth: labelWidth,
            maxWidthCols: maxWidthCols,
            offsetCols: offsetCols ?? 0,
            checked: checked,
            setChecked: setChecked,
            disabled: disabled
        })
    });
};
$2fa3da66cf5b9bee$export$a68e0b398c3ef1ab.displayName = "Control213";

});

parcelRegister("3XbKn", function(module, exports) {

$parcel$export(module.exports, "ControlDate", function () { return $ef13bad14db43d20$export$5cef76cf8c55602b; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $9S4dL = parcelRequire("9S4dL");
var $hFl9K = parcelRequire("hFl9K");
var $7fpOF = parcelRequire("7fpOF");

var $iuDOI = parcelRequire("iuDOI");

var $ifddf = parcelRequire("ifddf");
const $ef13bad14db43d20$export$5cef76cf8c55602b = ({ id: id, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, value: value, setValue: setValue, disabled: disabled, timeAllowed: timeAllowed, pastBad: pastBad, futureBad: futureBad, blankBad: blankBad, showNowButton: showNowButton = false })=>{
    const [currentDate, setCurrentDate] = (0, $spJKX.useState)("");
    const [currentTime, setCurrentTime] = (0, $spJKX.useState)("");
    const [isNowActive, setIsNowActive] = (0, $spJKX.useState)(false);
    const [, startTransition] = (0, $spJKX.useTransition)();
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>{
            switch(value){
                case "now":
                    setIsNowActive(true);
                    break;
                case "":
                    setIsNowActive(false);
                    setCurrentDate("");
                    setCurrentTime("");
                    break;
                default:
                    {
                        setIsNowActive(false);
                        const d = (0, $9S4dL.convertDateToLocaleString)(new Date(value));
                        setCurrentDate(d.slice(0, 10));
                        setCurrentTime(d.slice(11, 19));
                        break;
                    }
            }
        });
    }, [
        timeAllowed,
        value
    ]);
    const validationReturn = currentDate === "" && blankBad ? {
        success: false,
        validationText: "Date missing"
    } : isNowActive ? {
        success: true,
        returnedDate: "now"
    } : (0, $7fpOF.stringDateCheck)(`${currentDate} ${currentTime}`.trim(), {
        blankBad: blankBad,
        pastBad: pastBad,
        futureBad: futureBad
    });
    /**
   * Return the current date and time in UTC format or "now" via setValue callback.
   *
   * @param now - -Whether to set the value to "now"
   */ const returnDate = (now)=>{
        if (now) setValue?.("now");
        else {
            const s = `${currentDate} ${currentTime}`.trim();
            const ret = s !== "" ? (0, $9S4dL.convertLocaleDateToUTCString)(s) : "";
            if (ret !== value && ret !== "Invalid date") setValue?.(ret);
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                as: (0, $31g00.default),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                        column: true,
                        md: labelWidth,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                        md: Math.floor((maxWidthCols - labelWidth) / 2),
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                            id: `${id}-date`,
                            "aria-label": `${label} date`,
                            size: "sm",
                            value: isNowActive ? "" : currentDate,
                            disabled: disabled || !setValue || isNowActive,
                            type: "date",
                            min: pastBad ? new Date().getDate() : undefined,
                            max: futureBad ? new Date().getDate() : undefined,
                            onChange: setValue ? (e)=>{
                                let newDate = "";
                                if (!timeAllowed && e.currentTarget.value !== "") {
                                    const d = new Date(e.currentTarget.value);
                                    /* istanbul ignore else */ if (!isNaN(d.getTime())) {
                                        const m = (0, $hFl9K.setToUTCMidnight)(d, d.getTimezoneOffset() > 0);
                                        newDate = m.slice(0, 10);
                                        setCurrentTime(m.slice(11, 19));
                                    }
                                } else newDate = e.currentTarget.value;
                                setCurrentDate(newDate);
                            } : undefined,
                            className: `${validationReturn.success === true ? "is-valid" : "is-invalid"}`,
                            onBlur: setValue ? (e)=>{
                                setCurrentDate(e.currentTarget.value);
                                returnDate();
                            } : undefined
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                        md: Math.ceil((maxWidthCols - labelWidth) / 2),
                        className: "d-flex gap-4 align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                id: `${id}-time`,
                                "aria-label": `${label} time`,
                                size: "sm",
                                value: isNowActive ? "" : currentTime,
                                disabled: disabled || !setValue || !timeAllowed || isNowActive,
                                type: "time",
                                onChange: setValue ? (e)=>{
                                    setCurrentTime(e.currentTarget.value);
                                    if (e.currentTarget.value === "") setCurrentDate("");
                                } : undefined,
                                className: `${validationReturn.success === true ? "is-valid" : "is-invalid"}`,
                                onBlur: setValue ? (e)=>{
                                    setCurrentTime(e.currentTarget.value);
                                    returnDate();
                                } : undefined
                            }),
                            showNowButton && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                id: `${id}-now-button`,
                                size: "sm",
                                variant: isNowActive ? "success" : "outline-primary",
                                "aria-label": "Now",
                                style: {
                                    width: "72px"
                                },
                                title: "Set the date and time to now",
                                onClick: ()=>{
                                    returnDate(!isNowActive);
                                },
                                children: "Now"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                className: "mb-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    md: {
                        offset: labelWidth
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                        style: validationReturn.success === false ? {
                            color: "var(--bs-danger)"
                        } : undefined,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ifddf.InTextLink), {
                            text: isNowActive ? "Time is set when submitted" : validationReturn.success === true ? validationReturn.returnedDate ? validationReturn.returnedDate.toString() : "" : validationReturn.validationText ?? // istanbul ignore next
                            ""
                        })
                    })
                })
            })
        ]
    });
};
$ef13bad14db43d20$export$5cef76cf8c55602b.displayName = "ControlDate";

});

parcelRegister("fCofY", function(module, exports) {

$parcel$export(module.exports, "ControlNavList", function () { return $8bac4c658ca76b3d$export$5ab1e435eaa08dbd; });

var $bR5nk = parcelRequire("bR5nk");

var $aHdRW = parcelRequire("aHdRW");

var $kyGOj = parcelRequire("kyGOj");
var $bP72q = parcelRequire("bP72q");
var $gCZ2V = parcelRequire("gCZ2V");

const $8bac4c658ca76b3d$export$5ab1e435eaa08dbd = ({ id: id, list: list, selected: selected, setSelected: setSelected, addItem: addItem, addLabel: addLabel = "Add new", removeItem: removeItem, removeLabel: removeLabel = "Remove", renameItem: renameItem, renameLabel: renameLabel = "Rename", renderItem: renderItem = ({ label: label })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: label
    }) })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default), {
        variant: "pills",
        className: "flex-column",
        id: `${id}`,
        children: [
            list.map((l)=>/*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default).Link, {
                    id: `${id}-link-${l.id}`,
                    className: `control-nav-item ${selected === l.id ? "active" : ""}`,
                    onClick: ()=>{
                        setSelected?.(l.id);
                    },
                    children: [
                        removeItem && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "icon-holder",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kyGOj.default), {
                                id: `${id}-remove-${l.id}`,
                                onClick: ()=>removeItem(l.id),
                                "aria-label": `${removeLabel} ${l.label}`,
                                style: {
                                    color: selected === l.id ? "var(--bs-light)" : "var(--bs-danger)"
                                }
                            })
                        }),
                        renameItem && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "icon-holder",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bP72q.default), {
                                id: `${id}-rename-${l.id}`,
                                onClick: ()=>renameItem(l.id),
                                "aria-label": `${renameLabel} ${l.label}`,
                                style: {
                                    color: selected === l.id ? "var(--bs-light)" : "var(--bs-dark)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "control-nav-inner",
                            children: renderItem(l)
                        })
                    ]
                }, l.id)),
            addItem && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default).Link, {
                id: `${id}-add`,
                className: "control-nav-item",
                onClick: ()=>addItem(),
                children: [
                    " ",
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "icon-holder",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                    }),
                    addLabel
                ]
            })
        ]
    });
};
$8bac4c658ca76b3d$export$5ab1e435eaa08dbd.displayName = "ControlNavList";

});
parcelRegister("kyGOj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef7830e5b6c9907f$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $ef7830e5b6c9907f$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $ef7830e5b6c9907f$var$_extends() {
    return $ef7830e5b6c9907f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ef7830e5b6c9907f$var$_extends.apply(null, arguments);
}
function $ef7830e5b6c9907f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ef7830e5b6c9907f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ef7830e5b6c9907f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ef7830e5b6c9907f$var$DashCircleDotted = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $ef7830e5b6c9907f$var$_objectWithoutProperties(_ref, $ef7830e5b6c9907f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $ef7830e5b6c9907f$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-dash-circle-dotted',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1z"
    }));
});
$ef7830e5b6c9907f$var$DashCircleDotted.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $ef7830e5b6c9907f$export$2e2bcd8739ae039 = $ef7830e5b6c9907f$var$DashCircleDotted;

});


parcelRegister("lUxHn", function(module, exports) {

$parcel$export(module.exports, "ControlsGroup", function () { return $aab720e997b7445c$export$ceef51eaa926795d; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $fa1i3 = parcelRequire("fa1i3");

var $ayG2q = parcelRequire("ayG2q");

var $kUTy1 = parcelRequire("kUTy1");

var $aUt9N = parcelRequire("aUt9N");
const $aab720e997b7445c$export$ceef51eaa926795d = ({ baseId: baseId, currentValues: currentValues, inputs: inputs, onFieldChange: onFieldChange, setCurrentValues: setCurrentValues, setTextValid: setTextValid, spellCheck: spellCheck = true })=>{
    // Recompute derived values when currentValues change
    const computedValues = Object.fromEntries(inputs.filter((inp)=>inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.computeValue(currentValues)
        ]));
    // Compute hidden states for all inputs
    const hiddenStates = inputs.map((inp)=>typeof inp.hidden === "function" ? inp.hidden({
            ...currentValues,
            ...computedValues
        }) : inp.hidden ?? false);
    // Track previous hidden states to detect changes
    const [prevHiddenStates, setPrevHiddenStates] = (0, $spJKX.useState)([]);
    const validateHidden = (0, $spJKX.useEffectEvent)(async (hiddenStates)=>{
        for (const [ix, hidden] of hiddenStates.entries()){
            // If an input is hidden, it is valid
            if (hidden) (0, $spJKX.startTransition)(()=>setTextValid?.((prev)=>[
                        ...prev.slice(0, ix),
                        true,
                        ...prev.slice(ix + 1)
                    ]));
            else if (!hidden && prevHiddenStates[ix] === true && inputs[ix].validCondition) {
                const mergedValues = {
                    ...currentValues,
                    ...computedValues
                };
                let valid = false;
                try {
                    const ret = await inputs[ix].validCondition(inputs[ix].validationRequestUrl ?? "", {
                        value: mergedValues[inputs[ix].inputName],
                        options: (0, $ayG2q.getValidationOptions)(inputs[ix], mergedValues)
                    }, new AbortController());
                    valid = ret?.success ? ret.data.valid : false;
                } catch  {
                    valid = false;
                }
                (0, $spJKX.startTransition)(()=>setTextValid?.((prev)=>[
                            ...prev.slice(0, ix),
                            valid,
                            ...prev.slice(ix + 1)
                        ]));
            }
        }
        (0, $spJKX.startTransition)(()=>setPrevHiddenStates(hiddenStates));
    });
    // Validate hidden states on mount and when they change
    (0, $spJKX.useEffect)(()=>{
        if (!hiddenStates.every((val, ix)=>val === prevHiddenStates[ix])) validateHidden(hiddenStates);
    }, [
        hiddenStates,
        prevHiddenStates
    ]);
    return inputs.map((inp, ix)=>{
        const mergedValues = {
            ...currentValues,
            ...computedValues
        };
        const sharedProps = {
            id: `${baseId}-${ix}`,
            label: inp.inputLabel,
            labelWidth: 4,
            value: mergedValues[inp.inputName],
            setValue: (ret)=>{
                const newCurrentValues = {
                    ...currentValues,
                    [inp.inputName]: ret
                };
                const newComputedValues = Object.fromEntries(inputs.filter((i)=>i.computeValue).map((i)=>[
                        i.inputName,
                        i.computeValue(newCurrentValues)
                    ]));
                setCurrentValues({
                    ...newCurrentValues,
                    ...newComputedValues
                });
                onFieldChange?.({
                    ...newCurrentValues,
                    ...newComputedValues
                });
            },
            disabled: typeof inp.readonly === "function" ? inp.readonly(mergedValues) : inp.readonly,
            validationTargetOptions: (0, $ayG2q.getValidationOptions)(inp, mergedValues)
        };
        return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa1i3.default), {
            in: !hiddenStates[ix],
            children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: inp.dropdownOptions ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    ...sharedProps,
                    multiple: inp.multiple,
                    options: [
                        ...!inp.multiple && !inp.dropdownOptions.includes(mergedValues[inp.inputName]) ? [
                            {
                                label: "Select...",
                                value: ""
                            }
                        ] : [],
                        ...inp.dropdownOptions.map((opt)=>({
                                label: opt,
                                value: opt
                            }))
                    ],
                    validCondition: inp.validCondition,
                    validationReturn: (ret)=>setTextValid?.((prev)=>[
                                ...prev.slice(0, ix),
                                ret,
                                ...prev.slice(ix + 1)
                            ]),
                    validationRequestUrl: inp.validationRequestUrl
                }, inp.inputName) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                    ...sharedProps,
                    autoFocus: ix === 0,
                    forcePrefix: inp.forcePrefix,
                    placeholder: inp.placeholder,
                    spellCheck: spellCheck,
                    validCondition: inp.validCondition,
                    validationReturn: (ret)=>setTextValid?.((prev)=>[
                                ...prev.slice(0, ix),
                                ret,
                                ...prev.slice(ix + 1)
                            ]),
                    validationRequestUrl: inp.validationRequestUrl,
                    whiteSpaceFix: true
                }, inp.inputName)
            })
        }, ix);
    });
};

});

parcelRegister("fVo1v", function(module, exports) {

$parcel$export(module.exports, "ControlTags", function () { return $bcf15bbf31eb03b2$export$b1411b87eeeb7c6c; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $1EdOx = parcelRequire("1EdOx");

var $eHWpk = parcelRequire("eHWpk");

var $lp634 = parcelRequire("lp634");
const $bcf15bbf31eb03b2$export$b1411b87eeeb7c6c = ({ allowCreate: allowCreate = false, allowEdit: allowEdit = false, automaticallyCreateOnReturn: automaticallyCreateOnReturn = false, availableOptions: availableOptions, className: className, disabled: disabled = false, height: height = "80px", inputAriaLabel: inputAriaLabel = "Search tags", onSelectionChange: onSelectionChange, placeholder: placeholder = "Select...", selectedTags: selectedTags, showCheckboxes: showCheckboxes = true })=>{
    const [searchText, setSearchText] = (0, $spJKX.useState)("");
    const [showDropdown, setShowDropdown] = (0, $spJKX.useState)(false);
    const [selectedIndex, setSelectedIndex] = (0, $spJKX.useState)(-1);
    /** Index of the chip currently being edited inline, or null when not editing. */ const [editingIndex, setEditingIndex] = (0, $spJKX.useState)(null);
    /** Current text value of the chip being edited inline. */ const [editValue, setEditValue] = (0, $spJKX.useState)("");
    const containerRef = (0, $spJKX.useRef)(null);
    const inputRef = (0, $spJKX.useRef)(null);
    /** Whether the dropdown has content to display (options or create capability). */ const hasDropdown = availableOptions.length > 0 || allowCreate;
    /**
   * The control is effectively disabled when explicitly disabled OR when there
   * are no available options, creation is not allowed, and free-text entry is not allowed.
   */ const effectivelyDisabled = disabled || !hasDropdown && !automaticallyCreateOnReturn;
    /**
   * Whether the input should commit its value on blur. This is only true in
   * pure free-text mode (no dropdown present) to avoid blur-triggered commits
   * conflicting with dropdown item selection.
   */ const commitOnBlur = automaticallyCreateOnReturn && !hasDropdown;
    /**
   * Build dropdown items from the union of available options and currently-selected tags,
   * filtered by the current search text. Each item carries a `checked` flag so the dropdown
   * renders a checkbox indicating whether the tag is already selected.
   * An optional "Create" entry is prepended when `allowCreate` is on and the search text
   * is a novel value.
   */ const dropdownItems = (0, $spJKX.useMemo)(()=>{
        if (!hasDropdown) return [];
        // Union of available options and any orphaned selected tags not in the options list
        const allOptions = [
            ...new Set([
                ...availableOptions,
                ...selectedTags
            ])
        ];
        const filtered = allOptions.filter((option)=>option.toLowerCase().includes(searchText.toLowerCase()));
        const items = filtered.map((option, index)=>({
                id: `option-${index}`,
                text: option,
                ...showCheckboxes ? {
                    checked: selectedTags.includes(option)
                } : {}
            }));
        // Prepend a "Create" entry when allowCreate is true and the search text is a novel value
        if (allowCreate && searchText.trim() && !allOptions.some((opt)=>opt.toLowerCase() === searchText.toLowerCase()) && !selectedTags.includes(searchText.trim())) items.unshift({
            id: "create-option",
            text: `Create: "${searchText.trim()}"`,
            data: searchText.trim(),
            isCreateOption: true
        });
        return items;
    }, [
        availableOptions,
        selectedTags,
        searchText,
        allowCreate,
        showCheckboxes,
        hasDropdown
    ]);
    /**
   * Toggle a tag on or off via the dropdown. For "Create" options the new tag is added
   * and the search text is cleared. For regular items the tag is added when unchecked or
   * removed when already checked. The dropdown remains open after each interaction to
   * support multi-select without re-opening.
   */ const handleToggleTag = (0, $spJKX.useCallback)((item)=>{
        const tag = item.isCreateOption ? item.data : item.text;
        if (item.isCreateOption) {
            onSelectionChange([
                ...selectedTags,
                tag
            ]);
            setSearchText("");
        } else if (selectedTags.includes(tag)) onSelectionChange(selectedTags.filter((t)=>t !== tag));
        else onSelectionChange([
            ...selectedTags,
            tag
        ]);
    // Dropdown intentionally stays open for multi-select
    }, [
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Remove an individual tag via its chip close button.
   *
   * @param tagToRemove - The tag string value to remove from the selection.
   */ const handleRemoveTag = (0, $spJKX.useCallback)((tagToRemove)=>{
        onSelectionChange(selectedTags.filter((tag)=>tag !== tagToRemove));
    }, [
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Commits a free-text tag from the primary input. Trims whitespace,
   * rejects empty strings and duplicates, then appends the new tag.
   */ const commitFreeText = (0, $spJKX.useCallback)(()=>{
        const trimmed = searchText.trim();
        if (trimmed && !selectedTags.includes(trimmed)) onSelectionChange([
            ...selectedTags,
            trimmed
        ]);
        setSearchText("");
    }, [
        searchText,
        selectedTags,
        onSelectionChange
    ]);
    /**
   * Commits the in-progress inline chip edit, updating or removing the tag.
   * If the edited value is empty, the tag is removed. If the edited value
   * duplicates another tag, the edit is rejected and the original value restored.
   */ const commitEdit = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else */ if (editingIndex !== null) {
            const trimmed = editValue.trim();
            const updated = [
                ...selectedTags
            ];
            if (trimmed) {
                // Reject edits that would create a duplicate (excluding the tag being edited)
                const isDuplicate = selectedTags.some((tag, index)=>index !== editingIndex && tag === trimmed);
                if (!isDuplicate) {
                    updated[editingIndex] = trimmed;
                    onSelectionChange(updated);
                }
            } else {
                // Empty value removes the tag
                updated.splice(editingIndex, 1);
                onSelectionChange(updated);
            }
            setEditingIndex(null);
            setEditValue("");
        }
    }, [
        editingIndex,
        editValue,
        onSelectionChange,
        selectedTags
    ]);
    /**
   * Cancels the in-progress inline chip edit, restoring the original value.
   */ const cancelEdit = (0, $spJKX.useCallback)(()=>{
        setEditingIndex(null);
        setEditValue("");
    }, []);
    /**
   * Open the dropdown (if available) and focus the search input when the
   * container area is clicked. Does nothing when editing a chip.
   */ const handleContainerClick = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else */ if (!effectivelyDisabled && editingIndex === null) {
            if (hasDropdown) setShowDropdown(true);
            inputRef.current?.focus();
        }
    }, [
        effectivelyDisabled,
        editingIndex,
        hasDropdown
    ]);
    /**
   * Close the dropdown and reset search state. Called by DropdownPortal on
   * click-outside and Escape key.
   */ const handleClose = (0, $spJKX.useCallback)(()=>{
        setShowDropdown(false);
        setSearchText("");
        setSelectedIndex(-1);
    }, []);
    /**
   * Handles keydown events on the primary input. Manages Enter for free-text
   * creation, Escape for clearing, and delegates to existing dropdown keyboard
   * navigation when appropriate.
   *
   * @param e - The keyboard event from the primary input.
   */ const handleInputKeyDown = (0, $spJKX.useCallback)((e)=>{
        if (e.key === "Enter") {
            // If the dropdown has a highlighted item, let DropdownPortal handle it
            if (hasDropdown && selectedIndex >= 0) return;
            // Otherwise, commit free-text if enabled
            if (automaticallyCreateOnReturn && searchText.trim()) {
                e.preventDefault();
                commitFreeText();
                // Re-focus the input for continuous entry
                setTimeout(()=>inputRef.current?.focus(), 0);
            }
        } else if (e.key === "Escape") // In free-text-only mode, clear the input text
        /* istanbul ignore else */ {
            if (automaticallyCreateOnReturn) setSearchText("");
        }
    }, [
        automaticallyCreateOnReturn,
        commitFreeText,
        hasDropdown,
        searchText,
        selectedIndex
    ]);
    /**
   * Handles keydown events on the inline edit input.
   * Enter commits the edit; Escape cancels it.
   *
   * @param e - The keyboard event from the edit input.
   */ const handleEditKeyDown = (0, $spJKX.useCallback)((e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            commitEdit();
        } else if (e.key === "Escape") cancelEdit();
    }, [
        commitEdit,
        cancelEdit
    ]);
    /**
   * Handles blur on the primary input. In pure free-text mode (no dropdown),
   * commits the current text as a new tag.
   */ const handleInputBlur = (0, $spJKX.useCallback)(()=>{
        if (commitOnBlur && searchText.trim()) commitFreeText();
    }, [
        commitOnBlur,
        commitFreeText,
        searchText
    ]);
    /**
   * Enters inline edit mode for a chip at the given index.
   *
   * @param index - The index of the tag to edit.
   * @param currentValue - The current text value of the tag.
   */ const enterEditMode = (0, $spJKX.useCallback)((index, currentValue)=>{
        /* istanbul ignore else */ if (allowEdit && !effectivelyDisabled) {
            setEditingIndex(index);
            setEditValue(currentValue);
        }
    }, [
        allowEdit,
        effectivelyDisabled
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: `tag-multiselect ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                ref: containerRef,
                role: "combobox",
                "aria-expanded": showDropdown && !effectivelyDisabled && hasDropdown,
                "aria-haspopup": "listbox",
                className: "form-control d-flex flex-wrap align-items-start gap-1 p-2",
                style: {
                    height: height,
                    overflowY: "auto",
                    overflowX: "auto",
                    cursor: effectivelyDisabled ? "default" : "text",
                    backgroundColor: effectivelyDisabled ? "var(--bs-secondary-bg)" : undefined
                },
                onClick: handleContainerClick,
                onMouseDown: (e)=>{
                    // Prevent container clicks from blurring the inline edit input
                    if (editingIndex !== null) e.preventDefault();
                },
                children: [
                    selectedTags.map((tag, index)=>allowEdit && !effectivelyDisabled && editingIndex === index ? /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                            type: "text",
                            className: `border rounded px-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).editInput}`,
                            value: editValue,
                            autoFocus: true,
                            onChange: (e)=>{
                                setEditValue(e.target.value);
                            },
                            onBlur: commitEdit,
                            onKeyDown: handleEditKeyDown,
                            "aria-label": `Edit tag: ${tag}`,
                            onClick: (e)=>e.stopPropagation()
                        }, `edit-${index}`) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $1EdOx.default), {
                            bg: "secondary",
                            className: `d-flex align-items-center ${(0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).chip} ${effectivelyDisabled ? (0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).chipDisabled : (0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).chipClickable}`,
                            onClick: (e)=>{
                                /* istanbul ignore else */ if (!effectivelyDisabled) {
                                    e.stopPropagation();
                                    if (allowEdit) enterEditMode(index, tag);
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    children: tag
                                }),
                                !effectivelyDisabled && /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
                                    type: "button",
                                    className: "btn-close btn-close-white ms-1",
                                    style: {
                                        fontSize: "0.6em"
                                    },
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        handleRemoveTag(tag);
                                    },
                                    "aria-label": `Remove ${tag}`
                                })
                            ]
                        }, tag)),
                    !effectivelyDisabled && /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                        ref: inputRef,
                        type: "text",
                        className: `border-0 flex-grow-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).tagInput}`,
                        placeholder: selectedTags.length === 0 ? placeholder : "",
                        value: searchText,
                        onChange: (e)=>{
                            setSearchText(e.target.value);
                            if (hasDropdown && !showDropdown) setShowDropdown(true);
                        },
                        onFocus: ()=>{
                            if (hasDropdown) setShowDropdown(true);
                        },
                        onBlur: handleInputBlur,
                        onKeyDown: handleInputKeyDown,
                        disabled: effectivelyDisabled,
                        autoComplete: "off",
                        "aria-label": inputAriaLabel,
                        onClick: (e)=>e.stopPropagation()
                    })
                ]
            }),
            hasDropdown && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lp634.DropdownPortal), {
                isOpen: showDropdown && dropdownItems.length > 0 && !effectivelyDisabled,
                items: dropdownItems,
                onSelect: handleToggleTag,
                onClose: handleClose,
                anchorRef: containerRef,
                selectedIndex: selectedIndex,
                onSelectedIndexChange: setSelectedIndex
            })
        ]
    });
};
$bcf15bbf31eb03b2$export$b1411b87eeeb7c6c.displayName = "ControlTags";

});
parcelRegister("1EdOx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $13343e10ff8bd006$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $13343e10ff8bd006$var$Badge = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$13343e10ff8bd006$var$Badge.displayName = 'Badge';
var $13343e10ff8bd006$export$2e2bcd8739ae039 = $13343e10ff8bd006$var$Badge;

});

parcelRegister("eHWpk", function(module, exports) {

$parcel$export(module.exports, "chip", function () { return $ab52635fa13ac3ae$export$aa2a4c698c03a4c8; }, function (v) { return $ab52635fa13ac3ae$export$aa2a4c698c03a4c8 = v; });
$parcel$export(module.exports, "chipClickable", function () { return $ab52635fa13ac3ae$export$81380617abd11352; }, function (v) { return $ab52635fa13ac3ae$export$81380617abd11352 = v; });
$parcel$export(module.exports, "chipDisabled", function () { return $ab52635fa13ac3ae$export$1614914b034795e5; }, function (v) { return $ab52635fa13ac3ae$export$1614914b034795e5 = v; });
$parcel$export(module.exports, "dropdownCheckbox", function () { return $ab52635fa13ac3ae$export$c34e0625d8499c68; }, function (v) { return $ab52635fa13ac3ae$export$c34e0625d8499c68 = v; });
$parcel$export(module.exports, "dropdownItem", function () { return $ab52635fa13ac3ae$export$a8f2ac991e6b7a5; }, function (v) { return $ab52635fa13ac3ae$export$a8f2ac991e6b7a5 = v; });
$parcel$export(module.exports, "dropdownItemActive", function () { return $ab52635fa13ac3ae$export$1608f866457f675e; }, function (v) { return $ab52635fa13ac3ae$export$1608f866457f675e = v; });
$parcel$export(module.exports, "dropdownItemCreate", function () { return $ab52635fa13ac3ae$export$35b16a6e2ae70fba; }, function (v) { return $ab52635fa13ac3ae$export$35b16a6e2ae70fba = v; });
$parcel$export(module.exports, "editInput", function () { return $ab52635fa13ac3ae$export$4f56ae17fec11c82; }, function (v) { return $ab52635fa13ac3ae$export$4f56ae17fec11c82 = v; });
$parcel$export(module.exports, "tagInput", function () { return $ab52635fa13ac3ae$export$915122dd47a5f34c; }, function (v) { return $ab52635fa13ac3ae$export$915122dd47a5f34c = v; });
var $ab52635fa13ac3ae$export$aa2a4c698c03a4c8;
var $ab52635fa13ac3ae$export$81380617abd11352;
var $ab52635fa13ac3ae$export$1614914b034795e5;
var $ab52635fa13ac3ae$export$c34e0625d8499c68;
var $ab52635fa13ac3ae$export$a8f2ac991e6b7a5;
var $ab52635fa13ac3ae$export$1608f866457f675e;
var $ab52635fa13ac3ae$export$35b16a6e2ae70fba;
var $ab52635fa13ac3ae$export$4f56ae17fec11c82;
var $ab52635fa13ac3ae$export$915122dd47a5f34c;
$ab52635fa13ac3ae$export$aa2a4c698c03a4c8 = `mos-ControlTags-module-3IyqPa-chip`;
$ab52635fa13ac3ae$export$81380617abd11352 = `mos-ControlTags-module-3IyqPa-chipClickable`;
$ab52635fa13ac3ae$export$1614914b034795e5 = `mos-ControlTags-module-3IyqPa-chipDisabled`;
$ab52635fa13ac3ae$export$c34e0625d8499c68 = `mos-ControlTags-module-3IyqPa-dropdownCheckbox`;
$ab52635fa13ac3ae$export$a8f2ac991e6b7a5 = `mos-ControlTags-module-3IyqPa-dropdownItem`;
$ab52635fa13ac3ae$export$1608f866457f675e = `mos-ControlTags-module-3IyqPa-dropdownItemActive`;
$ab52635fa13ac3ae$export$35b16a6e2ae70fba = `mos-ControlTags-module-3IyqPa-dropdownItemCreate`;
$ab52635fa13ac3ae$export$4f56ae17fec11c82 = `mos-ControlTags-module-3IyqPa-editInput`;
$ab52635fa13ac3ae$export$915122dd47a5f34c = `mos-ControlTags-module-3IyqPa-tagInput`;

});

parcelRegister("lp634", function(module, exports) {

$parcel$export(module.exports, "DropdownPortal", function () { return $e7e948c65c0da59a$export$6fde95e347518364; });

var $bR5nk = parcelRequire("bR5nk");

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $eHWpk = parcelRequire("eHWpk");
/**
 * Calculate dropdown position relative to anchor element.
 * When positioning above, the top is set to the anchor's top edge,
 * and the transform translateY(-100%) moves it up by its own height.
 * When positioning below, the top is set to the anchor's bottom edge.
 *
 * @param anchorEl - The anchor HTML element to position the dropdown relative to
 * @param dropdownHeight - The height of the dropdown to determine if it fits below or needs to be shown above
 * @returns The calculated dropdown position with all positioning properties
 */ const $e7e948c65c0da59a$var$calculatePosition = (anchorEl, dropdownHeight)=>{
    const rect = anchorEl.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const spaceBelow = viewportHeight - rect.bottom;
    const spaceAbove = rect.top;
    // Position below by default, above if not enough space
    const showAbove = spaceBelow < dropdownHeight && spaceAbove > spaceBelow;
    return {
        calculated: true,
        left: rect.left,
        top: showAbove ? rect.top : rect.bottom,
        width: rect.width,
        showAbove: showAbove
    };
};
const $e7e948c65c0da59a$export$6fde95e347518364 = ({ isOpen: isOpen, items: items, onSelect: onSelect, onClose: onClose, anchorRef: anchorRef, maxHeight: maxHeight = 200, zIndex: zIndex = 10000, className: className = "", backgroundColor: backgroundColor = "var(--bs-body-bg)", selectedIndex: selectedIndex = -1, onSelectedIndexChange: onSelectedIndexChange })=>{
    const dropdownRef = (0, $spJKX.useRef)(null);
    const [position, setPosition] = (0, $spJKX.useState)({
        calculated: false
    });
    /**
   * Update dropdown position when anchor changes or dropdown opens
   */ const updatePosition = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else */ if (anchorRef.current && isOpen) {
            const newPosition = $e7e948c65c0da59a$var$calculatePosition(anchorRef.current, maxHeight);
            setPosition(newPosition);
        }
    }, [
        anchorRef,
        isOpen,
        maxHeight
    ]);
    /**
   * Update position on open and window resize/scroll
   */ (0, $spJKX.useEffect)(()=>{
        if (isOpen) {
            updatePosition();
            window.addEventListener("resize", updatePosition);
            window.addEventListener("scroll", updatePosition, true);
            return ()=>{
                window.removeEventListener("resize", updatePosition);
                window.removeEventListener("scroll", updatePosition, true);
            };
        }
    }, [
        isOpen,
        updatePosition
    ]);
    /**
   * Handle keyboard navigation
   */ const handleKeyDown = (0, $spJKX.useCallback)((e)=>{
        if (!isOpen || items.length === 0) return;
        switch(e.key){
            case "ArrowDown":
                {
                    e.preventDefault();
                    e.stopPropagation();
                    const nextIndex = Math.min(selectedIndex + 1, items.length - 1);
                    onSelectedIndexChange?.(nextIndex);
                    break;
                }
            case "ArrowUp":
                {
                    e.preventDefault();
                    e.stopPropagation();
                    const prevIndex = Math.max(selectedIndex - 1, 0);
                    onSelectedIndexChange?.(prevIndex);
                    break;
                }
            case "Enter":
            case "Tab":
                if (selectedIndex >= 0 && selectedIndex < items.length) {
                    e.preventDefault();
                    e.stopPropagation();
                    onSelect(items[selectedIndex]);
                }
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                onClose();
                break;
        }
    }, [
        isOpen,
        items,
        selectedIndex,
        onSelect,
        onClose,
        onSelectedIndexChange
    ]);
    /**
   * Set up keyboard event listeners
   */ (0, $spJKX.useEffect)(()=>{
        if (isOpen) {
            document.addEventListener("keydown", handleKeyDown);
            return ()=>document.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        isOpen,
        handleKeyDown
    ]);
    /**
   * Scroll selected item into view
   */ (0, $spJKX.useEffect)(()=>{
        if (isOpen && selectedIndex >= 0 && dropdownRef.current) {
            const selectedElement = dropdownRef.current.children[selectedIndex];
            /* istanbul ignore else */ if (selectedElement) selectedElement.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    }, [
        isOpen,
        selectedIndex
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!isOpen) return;
        /**
     * Handle click outside to close dropdown.
     *
     * @param e - The event object
     */ const handleClickOutside = (e)=>{
            const target = e.target;
            // Don't close if clicking on anchor element or dropdown
            if (anchorRef.current?.contains(target) || dropdownRef.current?.contains(target)) return;
            onClose();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, [
        isOpen,
        onClose,
        anchorRef
    ]);
    /**
   * Don't render if not open or no items or position not calculated yet
   */ if (!isOpen || items.length === 0 || !position.calculated) return null;
    /**
   * Render dropdown content
   */ const dropdownContent = /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: dropdownRef,
        role: "menu",
        className: `dropdown-menu show position-fixed ${className}`,
        style: {
            left: position.left,
            top: position.top,
            width: position.width,
            maxHeight: maxHeight,
            overflowY: "auto",
            zIndex: zIndex,
            backgroundColor: backgroundColor,
            transform: position.showAbove ? "translateY(-100%)" : "none"
        },
        children: items.map((item, index)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("button", {
                type: "button",
                role: "menuitem",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))("dropdown-item d-flex align-items-center", (0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).dropdownItem, {
                    [(0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).dropdownItemActive]: index === selectedIndex,
                    active: index === selectedIndex
                }, item.isCreateOption && (0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).dropdownItemCreate, item.className),
                onMouseDown: (e)=>{
                    e.preventDefault(); // Prevent input blur
                    onSelect(item);
                },
                children: [
                    item.checked !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                        type: "checkbox",
                        checked: item.checked,
                        readOnly: true,
                        className: `form-check-input me-2 flex-shrink-0 ${(0, (/*@__PURE__*/$parcel$interopDefault($eHWpk))).dropdownCheckbox}`,
                        tabIndex: -1
                    }),
                    item.text
                ]
            }, item.id))
    });
    /**
   * Render as portal to document body
   */ return /*#__PURE__*/ (0, $oS63j.createPortal)(dropdownContent, document.body);
};
$e7e948c65c0da59a$export$6fde95e347518364.displayName = "DropdownPortal";

});


parcelRegister("8Uc5S", function(module, exports) {

$parcel$export(module.exports, "ControlTypeAhead", function () { return $f0f3ac3b69f9a5a2$export$f475efa2efc7dadf; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $4dL47 = parcelRequire("4dL47");

var $3tKzd = parcelRequire("3tKzd");

var $iuDOI = parcelRequire("iuDOI");


var $lp634 = parcelRequire("lp634");
const $f0f3ac3b69f9a5a2$export$f475efa2efc7dadf = ({ id: id, availableList: availableList, backgroundColor: backgroundColor = "var(--bs-body-bg)", buttonLabel: buttonLabel = "OK", disabled: disabled, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, onEnter: onEnter, onEscape: onEscape, onButtonClick: onButtonClick, pauseCoverText: pauseCoverText, placeHolder: placeHolder, requestStatus: requestStatus, setValue: setValue, spellCheck: spellCheck = true, validCondition: validCondition, validationTargetOptions: extraValidationTargetOptions, validationReturn: validationReturn, value: value })=>{
    // Current value in the control
    const [currentValue, setCurrentValue] = (0, $spJKX.useState)(value);
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    (0, $spJKX.useEffect)(()=>startTransition(()=>setCurrentValue(value)), [
        value
    ]);
    const [validationStatus, setValidationStatus] = (0, $spJKX.useState)({
        success: true,
        data: {
            valid: true,
            validationText: ""
        }
    });
    const [validationRequest, setValidationRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    // Input ref for dropdown positioning
    const inputRef = (0, $spJKX.useRef)(null);
    // Currently available values
    const currentList = availableList.filter((i)=>i.value.toLowerCase().includes(currentValue.toLowerCase()));
    const [selectedIndex, setSelectedIndex] = (0, $spJKX.useState)(-1);
    // Show dropdown state
    const [showDropdown, setShowDropdown] = (0, $spJKX.useState)(false);
    const validationTargetOptions = (0, $spJKX.useMemo)(()=>({
            ...extraValidationTargetOptions,
            existingValues: availableList.map((item)=>item.value)
        }), [
        availableList,
        extraValidationTargetOptions
    ]);
    /**
   * Checks validation for the current value.
   *
   * @param newValue - The validation target containing the value to check.
   */ const checkValidation = (0, $spJKX.useEffectEvent)(async (newValue)=>{
        if (!validCondition) {
            setValidationStatus({
                success: true,
                data: {
                    valid: newValue.value !== "" && validationTargetOptions.existingValues.includes(newValue.value),
                    validationText: ""
                }
            });
            setValidationRequest({
                requesting: false,
                error: false,
                requestedId: newValue
            });
            validationReturn?.(newValue.value !== "" && validationTargetOptions.existingValues.includes(newValue.value));
        } else {
            const response = await (0, $4dL47.loadWrapper)(validCondition, newValue, {
                ...validationRequest,
                error: false,
                errorText: undefined
            }, setValidationRequest, "");
            /* istanbul ignore else */ if (response) {
                setValidationStatus(response);
                validationReturn?.(response.success === false ? false : response.data.valid);
            }
        }
    });
    (0, $spJKX.useEffect)(()=>{
        if (!validationRequest.requesting && (currentValue !== validationRequest.requestedId?.value || !(0, $eBlbF.isEqual)(validationTargetOptions, validationRequest.requestedId?.options))) startTransition(()=>{
            checkValidation({
                value: currentValue,
                options: validationTargetOptions
            });
        });
    }, [
        currentValue,
        validationRequest,
        validationTargetOptions
    ]);
    // Convert available items to dropdown items
    const dropdownItems = currentList.map((item, index)=>({
            id: `${id}-item-${index}`,
            text: item.value,
            data: item
        }));
    /**
   * Handle return
   *
   * @param e - FocusEvent<HTMLInputElement>
   */ const handleBlur = (e)=>{
        const n = e.currentTarget.value.replace(/\s+/g, " ").trim();
        setCurrentValue(n);
        // Set value if valid or if no validation function provided
        const isValidValue = validCondition ? true : n !== "" && validationTargetOptions.existingValues.includes(n);
        if (n !== value && isValidValue) setValue(n);
        setShowDropdown(false);
    };
    // Handle dropdown item selection
    /**
   * Handles selection of an item from the dropdown.
   *
   * @param item - The selected dropdown item
   */ const handleDropdownSelect = (item)=>{
        const selectedValue = item.text;
        setCurrentValue(selectedValue);
        /* istanbul ignore else */ if (value !== selectedValue) setValue?.(selectedValue);
        setShowDropdown(false);
        setSelectedIndex(-1);
    };
    /**
   * Handle typing
   *
   * @param e - React.KeyboardEvent<HTMLInputElement>
   */ const handleKeyDown = (e)=>{
        if (e.key === "Enter" && onEnter) {
            e.preventDefault();
            setShowDropdown(false);
            onEnter(e.currentTarget.value);
        } else if (e.key === "Escape" && onEscape) {
            e.preventDefault();
            setCurrentValue(value);
            setShowDropdown(false);
            setSelectedIndex(-1);
            onEscape();
        } else if (e.key === "Enter" && showDropdown && dropdownItems.length > 0) {
            e.preventDefault();
            /* istanbul ignore else */ if (selectedIndex < dropdownItems.length && selectedIndex >= 0) handleDropdownSelect(dropdownItems[selectedIndex]);
        } else if (e.key === "Enter") inputRef.current?.blur();
        else if (e.key === "Escape" && showDropdown && dropdownItems.length > 0) {
            setShowDropdown(false);
            setSelectedIndex(-1);
        } else if (e.key === "Escape") {
            setCurrentValue(value);
            setTimeout(()=>{
                inputRef.current?.blur();
            }, 1);
        }
    };
    /**
   * Handle input changes.
   *
   * @param e - React.ChangeEvent<HTMLInputElement>
   */ const handleChange = (e)=>{
        setCurrentValue(e.currentTarget.value);
        setShowDropdown(e.currentTarget.value.trim().length > 0);
        setSelectedIndex(-1);
    };
    /**
   * Handle input focus
   */ const handleFocus = ()=>{
        setShowDropdown(currentValue.trim().length > 0 && (!validationStatus.success || !validationStatus.data.valid) && currentList.length > 0);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
        controlId: `${id}`,
        as: (0, $31g00.default),
        className: "my-1",
        children: [
            labelWidth > 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                md: maxWidthCols - labelWidth - (onButtonClick ? 2 : 0),
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                            ref: inputRef,
                            size: "sm",
                            value: currentValue,
                            disabled: disabled || !setValue,
                            onChange: handleChange,
                            placeholder: placeHolder,
                            className: (0, $3tKzd.classMerge)([
                                validationStatus.success && validationStatus.data.warning ? "is-warning" : currentValue !== "" && validationStatus.success && validationStatus.data.valid ? "is-valid" : currentValue !== "" && (validationStatus.success === false || validationStatus.success && !validationStatus.data.valid) ? "is-invalid" : ""
                            ]),
                            onBlur: handleBlur,
                            onFocus: handleFocus,
                            onKeyDown: handleKeyDown,
                            autoComplete: "off",
                            spellCheck: spellCheck
                        }),
                        validationStatus.success && validationStatus.data.validationText && (validationStatus.data.warning || !validationStatus.data.valid) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                            className: validationStatus.data.warning ? "warning-feedback d-block" : "invalid-feedback d-block",
                            children: validationStatus.data.validationText
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lp634.DropdownPortal), {
                            isOpen: showDropdown && dropdownItems.length > 0 && !disabled,
                            items: dropdownItems,
                            onSelect: handleDropdownSelect,
                            onClose: ()=>{
                                setShowDropdown(false);
                                setSelectedIndex(-1);
                            },
                            anchorRef: inputRef,
                            backgroundColor: backgroundColor,
                            selectedIndex: selectedIndex,
                            onSelectedIndexChange: setSelectedIndex
                        })
                    ]
                })
            }),
            onButtonClick && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                md: 2,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                    id: `${id}-button`,
                    disabled: !(validationStatus.success && validationStatus.data.valid),
                    onClick: onButtonClick,
                    size: "sm",
                    requestStatus: requestStatus,
                    pauseCoverText: pauseCoverText,
                    children: buttonLabel
                })
            })
        ]
    });
};
$f0f3ac3b69f9a5a2$export$f475efa2efc7dadf.displayName = "ControlTypeAhead";

});

parcelRegister("fkJGt", function(module, exports) {

$parcel$export(module.exports, "DraggableSidebar", function () { return $c973ea1b253a8e39$export$22be37e491cc9b49; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");
/**
 * Custom drag MIME type for sidebar items.
 */ const $c973ea1b253a8e39$var$DRAG_ITEM_MIME_TYPE = "application/x-mosaic-draggable-sidebar-item";
/**
 * Creates a stacked drag preview element for multi-item drags.
 *
 * @param labels - Labels for the items included in the drag operation
 * @returns A detached DOM element suitable for DataTransfer.setDragImage
 */ const $c973ea1b253a8e39$var$createMultiItemDragPreview = (labels)=>{
    const previewRoot = document.createElement("div");
    previewRoot.setAttribute("data-mosaic-drag-preview", "true");
    previewRoot.style.position = "fixed";
    previewRoot.style.top = "-1000px";
    previewRoot.style.left = "-1000px";
    previewRoot.style.pointerEvents = "none";
    previewRoot.style.zIndex = "2147483647";
    const stack = document.createElement("div");
    stack.style.position = "relative";
    stack.style.width = "220px";
    stack.style.height = "48px";
    previewRoot.appendChild(stack);
    labels.slice(0, 3).reverse().forEach((label, index)=>{
        const card = document.createElement("div");
        card.textContent = label;
        card.style.position = "absolute";
        card.style.inset = "0";
        card.style.transform = `translate(${index * 6}px, ${index * 6}px)`;
        card.style.padding = "10px 12px";
        card.style.border = "1px solid #0d6efd";
        card.style.borderRadius = "6px";
        card.style.backgroundColor = "#ffffff";
        card.style.boxShadow = "0 4px 10px rgba(13, 110, 253, 0.25)";
        card.style.color = "#0d6efd";
        card.style.fontSize = "12px";
        card.style.fontWeight = "600";
        card.style.whiteSpace = "nowrap";
        card.style.overflow = "hidden";
        card.style.textOverflow = "ellipsis";
        stack.appendChild(card);
    });
    return previewRoot;
};
/**
 * Default renderer for sidebar items (button element). Displays in primary colour when selected.
 *
 * @param props - Props containing the sidebar item and selection state
 * @param props.item - The sidebar item to render
 * @param props.selected - Whether the item is currently selected
 * @returns A button element with the item label, styled to reflect selection state
 */ const $c973ea1b253a8e39$var$DefaultRenderItem = ({ item: item, selected: selected })=>/*#__PURE__*/ (0, $bR5nk.jsx)("button", {
        type: "button",
        className: `btn ${selected ? "btn-primary" : "btn-outline-secondary"} text-start w-100`,
        children: item.label
    });
$c973ea1b253a8e39$var$DefaultRenderItem.displayName = "DefaultRenderItem";
const $c973ea1b253a8e39$export$22be37e491cc9b49 = ({ header: header, items: items, multiSelect: multiSelect = false, onItemDragEnd: onItemDragEnd, onItemDragStart: onItemDragStart, RenderItem: RenderItem = $c973ea1b253a8e39$var$DefaultRenderItem, style: style, ...drawerProps })=>{
    const [selectedIds, setSelectedIds] = (0, $spJKX.useState)([]);
    const [anchorId, setAnchorId] = (0, $spJKX.useState)(null);
    const dragPreviewRef = (0, $spJKX.useRef)(null);
    const itemsById = new Map(items.map((item)=>[
            item.id,
            item
        ]));
    // Clean up drag preview element on unmount to prevent orphaned DOM nodes
    (0, $spJKX.useEffect)(()=>{
        return ()=>{
            dragPreviewRef.current?.remove();
            dragPreviewRef.current = null;
        };
    }, []);
    // Derive effective selection: items are only considered selected when multiSelect is enabled
    const effectiveSelectedIds = multiSelect ? selectedIds : [];
    /**
   * Handles item click for selection, supporting shift and ctrl/meta modifier keys.
   * - Plain click selects only the clicked item and sets it as the range anchor.
   * - Ctrl/Meta+click toggles the clicked item's selection and updates the anchor.
   * - Shift+click selects the range between the anchor and the clicked item.
   *
   * @param item - The item that was clicked
   * @param event - The originating mouse event
   */ const handleItemClick = (item, event)=>{
        if (!multiSelect) return;
        if (event.shiftKey && anchorId !== null) {
            const anchorIndex = items.findIndex((i)=>i.id === anchorId);
            const currentIndex = items.findIndex((i)=>i.id === item.id);
            const start = Math.min(anchorIndex, currentIndex);
            const end = Math.max(anchorIndex, currentIndex);
            const rangeIdsUnordered = items.slice(start, end + 1).map((i)=>i.id);
            const rangeIds = currentIndex >= anchorIndex ? rangeIdsUnordered : rangeIdsUnordered.reverse();
            if (event.ctrlKey || event.metaKey) // Ctrl/Meta + Shift expands selection without removing previously selected items.
            setSelectedIds((previousSelectedIds)=>[
                    ...previousSelectedIds,
                    ...rangeIds.filter((rangeId)=>!previousSelectedIds.includes(rangeId))
                ]);
            else setSelectedIds(rangeIds);
        } else if (event.ctrlKey || event.metaKey) {
            setSelectedIds((prev)=>prev.includes(item.id) ? prev.filter((id)=>id !== item.id) : [
                    ...prev,
                    item.id
                ]);
            setAnchorId(item.id);
        } else {
            setSelectedIds([
                item.id
            ]);
            setAnchorId(item.id);
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        allowUndock: false,
        className: drawerProps.className,
        dockable: true,
        id: drawerProps.id ?? "draggable-sidebar",
        initialDockEdge: "right",
        style: {
            backgroundColor: "var(--bs-body-bg)",
            ...style
        },
        title: drawerProps.title ?? "Draggable Sidebar",
        visible: drawerProps.visible,
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "d-flex flex-column",
            style: {
                height: "100%"
            },
            children: [
                header !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "p-2 border-bottom flex-shrink-0",
                    children: header
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "small-scrollbar flex-grow-1 p-2 overflow-auto",
                    style: {
                        minHeight: 0
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("ul", {
                        className: "list-unstyled d-flex flex-column gap-2 m-0",
                        children: items.map((item)=>{
                            const isSelected = effectiveSelectedIds.includes(item.id);
                            const itemsToDrag = isSelected && effectiveSelectedIds.length > 1 ? effectiveSelectedIds.map((selectedId)=>itemsById.get(selectedId)).filter((selectedItem)=>selectedItem !== undefined) : [
                                item
                            ];
                            const itemsToDragResolved = itemsToDrag.map((i)=>({
                                    ...i,
                                    data: typeof i.data === "function" ? i.data() : i.data
                                }));
                            return /*#__PURE__*/ (0, $bR5nk.jsx)("li", {
                                draggable: true,
                                onClick: (event)=>handleItemClick(item, event),
                                onDragStart: (event)=>{
                                    if (multiSelect && !isSelected) {
                                        setSelectedIds([
                                            item.id
                                        ]);
                                        setAnchorId(item.id);
                                    }
                                    event.dataTransfer.effectAllowed = "copy";
                                    const payload = JSON.stringify({
                                        data: itemsToDragResolved.map((i)=>i.data)
                                    });
                                    event.dataTransfer.setData("text/plain", itemsToDrag.map((i)=>i.label).join(", "));
                                    event.dataTransfer.setData("application/json", payload);
                                    event.dataTransfer.setData($c973ea1b253a8e39$var$DRAG_ITEM_MIME_TYPE, payload);
                                    const dragPreview = $c973ea1b253a8e39$var$createMultiItemDragPreview(itemsToDrag.map((draggedItem)=>draggedItem.label));
                                    if (itemsToDrag.length > 1) {
                                        dragPreviewRef.current?.remove();
                                        dragPreviewRef.current = dragPreview;
                                        document.body.appendChild(dragPreview);
                                        event.dataTransfer.setDragImage(dragPreview, 24, 24);
                                    }
                                    onItemDragStart?.(itemsToDragResolved, event);
                                },
                                onDragEnd: (event)=>{
                                    dragPreviewRef.current?.remove();
                                    dragPreviewRef.current = null;
                                    onItemDragEnd?.(itemsToDragResolved, event);
                                },
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)(RenderItem, {
                                    item: item,
                                    selected: isSelected
                                })
                            }, item.id);
                        })
                    })
                })
            ]
        })
    });
};
$c973ea1b253a8e39$export$22be37e491cc9b49.displayName = "DraggableSidebar";

});

parcelRegister("2VxLR", function(module, exports) {

$parcel$export(module.exports, "ReorderableNavList", function () { return $823a10a79d696d21$export$2b90471a4b629a80; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $aHdRW = parcelRequire("aHdRW");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");

var $hBBiG = parcelRequire("hBBiG");
const $823a10a79d696d21$export$2b90471a4b629a80 = ({ list: list, setList: setList, getEventKey: getEventKey, disabled: disabled = false, disableReorder: disableReorder = false })=>{
    /** Whether tabs may be picked up, as either flag blocks reordering */ const canReorder = !disabled && !disableReorder;
    const [dragIndex, setDragIndex] = (0, $spJKX.useState)(null);
    const [overIndex, setOverIndex] = (0, $spJKX.useState)(null);
    const [dragWidth, setDragWidth] = (0, $spJKX.useState)(0);
    /** Horizontal midpoints of each tab, captured before any drag transforms are applied */ const midPoints = (0, $spJKX.useRef)([]);
    /** Latest calculated drop index, read on drop because state updates lag drag events */ const targetIndex = (0, $spJKX.useRef)(null);
    /** Extent of the tab strip, used to ignore drops released outside it */ const listBounds = (0, $spJKX.useRef)({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    });
    /** The tab strip element, listened to during a drag so gaps between tabs accept the drop */ const container = (0, $spJKX.useRef)(null);
    /** Index of the tab being dragged, mirrored in a ref for the native strip listeners */ const activeDragIndex = (0, $spJKX.useRef)(null);
    /** Whether the pointer was last seen over the tab strip, recorded during the drag */ const overList = (0, $spJKX.useRef)(false);
    /**
   * Marks the whole tab strip as a valid drop zone. Without this the gaps between
   * tabs reject the drag and the browser shows the "not allowed" cursor even though
   * releasing there would still reorder the list.
   *
   * @param event - The native drag event raised anywhere over the tab strip.
   */ const allowDrop = (event)=>{
        event.preventDefault();
        if (event.dataTransfer) event.dataTransfer.dropEffect = "move";
        /* istanbul ignore else -- the strip only listens while a drag is in progress */ if (activeDragIndex.current !== null) {
            const nextIndex = getTargetIndex(event.clientX, activeDragIndex.current);
            targetIndex.current = nextIndex;
            setOverIndex(nextIndex);
        }
    };
    /**
   * Records whether the pointer is still over the tab strip. Drag end reports
   * unreliable coordinates, so the last known position decides whether the move is
   * committed, and this runs on the document so positions outside the strip count.
   *
   * @param event - The native drag event raised anywhere in the document.
   */ const trackPointer = (event)=>{
        overList.current = event.clientX >= listBounds.current.left && event.clientX <= listBounds.current.right && event.clientY >= listBounds.current.top && event.clientY <= listBounds.current.bottom;
    };
    /**
   * Stops the tab strip accepting drops once the drag is over.
   */ const releaseContainer = ()=>{
        container.current?.removeEventListener("dragover", allowDrop);
        container.current?.removeEventListener("drop", allowDrop);
        document.removeEventListener("dragover", trackPointer);
        container.current = null;
    };
    /**
   * Moves the dragged item to the target position and notifies the caller.
   *
   * @param from - Index of the item being dragged.
   * @param to - Index the item should be moved to.
   */ const moveItem = (from, to)=>{
        if (from !== to) {
            const newList = [
                ...list
            ];
            const [moved] = newList.splice(from, 1);
            newList.splice(to, 0, moved);
            setList(newList);
        }
    };
    /**
   * Clears all drag tracking state once a drag has finished or been cancelled.
   */ const endDrag = ()=>{
        setDragIndex(null);
        setOverIndex(null);
        setDragWidth(0);
        midPoints.current = [];
        listBounds.current = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        targetIndex.current = null;
        overList.current = false;
        releaseContainer();
    };
    /**
   * Commits the pending move when the drag finishes. This runs on drag end rather
   * than only on drop because the sliding tabs can leave a gap beneath the pointer,
   * in which case no drop event is raised by any tab.
   */ const commitDrag = ()=>{
        if (dragIndex !== null && targetIndex.current !== null && overList.current) moveItem(dragIndex, targetIndex.current);
        activeDragIndex.current = null;
        endDrag();
    };
    /**
   * Records the untransformed midpoint of every tab so that the drop position can
   * be calculated from the pointer while the tabs are being slid out of the way.
   *
   * @param source - The tab wrapper the drag started from.
   */ const captureLayout = (source)=>{
        // The tabs are always rendered as div > Nav.Item > Nav, so the strip is present
        const strip = source.parentElement.parentElement;
        const wrappers = Array.from(strip.querySelectorAll("[data-reorderable-index]"));
        midPoints.current = wrappers.map((wrapper)=>{
            const rect = wrapper.getBoundingClientRect();
            return rect.left + rect.width / 2;
        });
        const stripRect = strip.getBoundingClientRect();
        listBounds.current = {
            left: stripRect.left,
            right: stripRect.right,
            top: stripRect.top,
            bottom: stripRect.bottom
        };
        container.current = strip;
        strip.addEventListener("dragover", allowDrop);
        strip.addEventListener("drop", allowDrop);
        document.addEventListener("dragover", trackPointer);
    };
    /**
   * Works out which position the dragged tab would take if dropped at the pointer.
   *
   * @param clientX - Horizontal pointer position of the drag event.
   * @param fallback - Index used when the layout could not be captured.
   * @returns The index the dragged tab should move to.
   */ const getTargetIndex = (clientX, fallback)=>{
        let target = fallback;
        /* istanbul ignore else -- the layout is always captured before a drag reports a position */ if (midPoints.current.length === list.length) {
            target = midPoints.current.filter((midPoint)=>midPoint < clientX).length;
            target = Math.min(target, list.length - 1);
        }
        return target;
    };
    /**
   * Uses a detached copy of the dragged tab as the drag image, so the item
   * following the cursor looks identical to the tab that was picked up.
   *
   * @param event - The drag start event raised by the tab wrapper.
   */ const setDragImageFromTab = (event)=>{
        const source = event.currentTarget;
        const preview = source.cloneNode(true);
        preview.style.width = `${source.offsetWidth}px`;
        preview.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavDragImage);
        // The clone is decorative only, so it must not be discoverable as content
        preview.setAttribute("aria-hidden", "true");
        preview.removeAttribute("data-reorderable-index");
        document.body.appendChild(preview);
        const rect = source.getBoundingClientRect();
        event.dataTransfer.setDragImage(preview, event.clientX - rect.left, event.clientY - rect.top);
        // The preview must remain in the document until the browser has snapshotted it
        setTimeout(()=>preview.remove(), 0);
    };
    /**
   * Determines how far a tab should slide to show where the dragged tab will land.
   *
   * @param index - Index of the tab being rendered.
   * @returns The CSS module class applying the required shift, or an empty string.
   */ const getShiftClass = (index)=>{
        let shiftClass = "";
        if (dragIndex !== null && overIndex !== null) {
            if (index === dragIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItemDragging;
            else if (index > dragIndex && index <= overIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItemShiftStart;
            else if (index < dragIndex && index >= overIndex) shiftClass = (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItemShiftEnd;
        }
        return shiftClass;
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: list.map((item, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    draggable: canReorder,
                    onDragStart: (e)=>{
                        if (canReorder) {
                            e.dataTransfer.effectAllowed = "move";
                            e.dataTransfer.setData("text/plain", item.id);
                            activeDragIndex.current = index;
                            targetIndex.current = index;
                            captureLayout(e.currentTarget);
                            setDragImageFromTab(e);
                            setDragWidth(e.currentTarget.offsetWidth);
                            setDragIndex(index);
                        }
                    },
                    onDragEnd: commitDrag,
                    className: (0, $3tKzd.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItem,
                        dragIndex === null ? (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItemStatic : "",
                        canReorder ? (0, (/*@__PURE__*/$parcel$interopDefault($hBBiG))).reorderableNavItemDraggable : "",
                        getShiftClass(index)
                    ]),
                    style: {
                        "--mos-reorderable-drag-width": `${dragWidth}px`
                    },
                    "data-reorderable-index": index,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                        eventKey: getEventKey?.(item, index) ?? `${index}`,
                        disabled: disabled,
                        children: item.name
                    })
                })
            }, item.id))
    });
};
$823a10a79d696d21$export$2b90471a4b629a80.displayName = "ReorderableNavList";

});
parcelRegister("hBBiG", function(module, exports) {

$parcel$export(module.exports, "reorderableNavDragImage", function () { return $cd12d36b6e786786$export$9c92d948e9dd4ee7; }, function (v) { return $cd12d36b6e786786$export$9c92d948e9dd4ee7 = v; });
$parcel$export(module.exports, "reorderableNavItem", function () { return $cd12d36b6e786786$export$7a962dd883273575; }, function (v) { return $cd12d36b6e786786$export$7a962dd883273575 = v; });
$parcel$export(module.exports, "reorderableNavItemDraggable", function () { return $cd12d36b6e786786$export$6a3f25430dd3bce5; }, function (v) { return $cd12d36b6e786786$export$6a3f25430dd3bce5 = v; });
$parcel$export(module.exports, "reorderableNavItemDragging", function () { return $cd12d36b6e786786$export$1eab8ffd3e812b6e; }, function (v) { return $cd12d36b6e786786$export$1eab8ffd3e812b6e = v; });
$parcel$export(module.exports, "reorderableNavItemShiftEnd", function () { return $cd12d36b6e786786$export$ba03773125e0d26b; }, function (v) { return $cd12d36b6e786786$export$ba03773125e0d26b = v; });
$parcel$export(module.exports, "reorderableNavItemShiftStart", function () { return $cd12d36b6e786786$export$555dedc82c5ac17c; }, function (v) { return $cd12d36b6e786786$export$555dedc82c5ac17c = v; });
$parcel$export(module.exports, "reorderableNavItemStatic", function () { return $cd12d36b6e786786$export$53abb5e85e1c97b6; }, function (v) { return $cd12d36b6e786786$export$53abb5e85e1c97b6 = v; });
var $cd12d36b6e786786$export$9c92d948e9dd4ee7;
var $cd12d36b6e786786$export$7a962dd883273575;
var $cd12d36b6e786786$export$6a3f25430dd3bce5;
var $cd12d36b6e786786$export$1eab8ffd3e812b6e;
var $cd12d36b6e786786$export$ba03773125e0d26b;
var $cd12d36b6e786786$export$555dedc82c5ac17c;
var $cd12d36b6e786786$export$53abb5e85e1c97b6;
$cd12d36b6e786786$export$9c92d948e9dd4ee7 = `mos-ReorderableNavList-module-Kvegya-reorderableNavDragImage`;
$cd12d36b6e786786$export$7a962dd883273575 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItem`;
$cd12d36b6e786786$export$6a3f25430dd3bce5 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemDraggable`;
$cd12d36b6e786786$export$1eab8ffd3e812b6e = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemDragging`;
$cd12d36b6e786786$export$ba03773125e0d26b = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemShiftEnd`;
$cd12d36b6e786786$export$555dedc82c5ac17c = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemShiftStart`;
$cd12d36b6e786786$export$53abb5e85e1c97b6 = `mos-ReorderableNavList-module-Kvegya-reorderableNavItemStatic`;

});


parcelRegister("3d5lD", function(module, exports) {

$parcel$export(module.exports, "SortableListHolder", function () { return $7db4954fa1de69f6$export$ee2d8054d5691374; });

var $bR5nk = parcelRequire("bR5nk");

var $1Ubba = parcelRequire("1Ubba");

var $6wCa0 = parcelRequire("6wCa0");

var $4mdE0 = parcelRequire("4mdE0");

var $4MUDD = parcelRequire("4MUDD");
const $7db4954fa1de69f6$export$ee2d8054d5691374 = ({ id: id, canMove: canMove, handleDragEnd: handleDragEnd, items: items, maxHeights: maxHeights, showBorder: showBorder = true })=>{
    // Set up sortable list
    const sensors = (0, $1Ubba.useSensors)((0, $1Ubba.useSensor)((0, $1Ubba.PointerSensor)), (0, $1Ubba.useSensor)((0, $1Ubba.KeyboardSensor), {
        coordinateGetter: (0, $4mdE0.sortableKeyboardCoordinates)
    }));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1Ubba.DndContext), {
        sensors: sensors,
        modifiers: [
            (0, $6wCa0.restrictToVerticalAxis)
        ],
        collisionDetection: (0, $1Ubba.closestCenter),
        onDragEnd: handleDragEnd,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("ol", {
            id: id,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4mdE0.SortableContext), {
                strategy: (0, $4mdE0.verticalListSortingStrategy),
                items: items,
                children: items.map((t, ix)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $4MUDD.SortableListItem), {
                        id: t.id,
                        canMove: canMove,
                        maxHeight: maxHeights ? maxHeights[ix] : undefined,
                        showBorder: showBorder,
                        children: t.element
                    }, t.id))
            })
        })
    });
};
$7db4954fa1de69f6$export$ee2d8054d5691374.displayName = "SortableListHolder";

});
parcelRegister("1Ubba", function(module, exports) {

$parcel$export(module.exports, "useSensor", function () { return $1633b159689c3061$export$cc72dd71f4ec69eb; });
$parcel$export(module.exports, "useSensors", function () { return $1633b159689c3061$export$19012f58216d597f; });
$parcel$export(module.exports, "getFirstCollision", function () { return $1633b159689c3061$export$ef1beab6d7287295; });
$parcel$export(module.exports, "closestCenter", function () { return $1633b159689c3061$export$c8e785ae6b74bab8; });
$parcel$export(module.exports, "closestCorners", function () { return $1633b159689c3061$export$c3a6c1c7122b31c9; });
$parcel$export(module.exports, "getClientRect", function () { return $1633b159689c3061$export$b6aa1f30c53d7454; });
$parcel$export(module.exports, "getScrollableAncestors", function () { return $1633b159689c3061$export$e4864aa91b5ed091; });
$parcel$export(module.exports, "KeyboardCode", function () { return $1633b159689c3061$export$a8b1916dba3ae88b; });
$parcel$export(module.exports, "KeyboardSensor", function () { return $1633b159689c3061$export$44d67f2a438aeba9; });
$parcel$export(module.exports, "PointerSensor", function () { return $1633b159689c3061$export$b26af955418d6638; });
$parcel$export(module.exports, "DndContext", function () { return $1633b159689c3061$export$2d5c5ceac203fc1e; });
$parcel$export(module.exports, "useDraggable", function () { return $1633b159689c3061$export$df30c81f5aa01ff7; });
$parcel$export(module.exports, "useDndContext", function () { return $1633b159689c3061$export$4930f6bf413be70e; });
$parcel$export(module.exports, "useDroppable", function () { return $1633b159689c3061$export$d74e5d67dc2b3176; });

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $bFs7G = parcelRequire("bFs7G");

var $aur83 = parcelRequire("aur83");
const $1633b159689c3061$var$DndMonitorContext = /*#__PURE__*/ (0, $spJKX.createContext)(null);
function $1633b159689c3061$export$1182af90218a7b81(listener) {
    const registerListener = (0, $spJKX.useContext)($1633b159689c3061$var$DndMonitorContext);
    (0, $spJKX.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $1633b159689c3061$var$useDndMonitorProvider() {
    const [listeners] = (0, $spJKX.useState)(()=>new Set());
    const registerListener = (0, $spJKX.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $spJKX.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $1633b159689c3061$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $1633b159689c3061$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $1633b159689c3061$var$Accessibility(_ref) {
    let { announcements: announcements = $1633b159689c3061$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $1633b159689c3061$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $aur83.useAnnouncement)();
    const liveRegionId = (0, $bFs7G.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, $spJKX.useState)(false);
    (0, $spJKX.useEffect)(()=>{
        setMounted(true);
    }, []);
    $1633b159689c3061$export$1182af90218a7b81((0, $spJKX.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, $aur83.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, $aur83.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $oS63j.createPortal)(markup, container) : markup;
}
var $1633b159689c3061$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($1633b159689c3061$var$Action || ($1633b159689c3061$var$Action = {}));
function $1633b159689c3061$var$noop() {}
function $1633b159689c3061$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $spJKX.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $1633b159689c3061$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $spJKX.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $1633b159689c3061$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $1633b159689c3061$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $1633b159689c3061$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $bFs7G.getEventCoordinates)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $1633b159689c3061$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $1633b159689c3061$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $1633b159689c3061$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $1633b159689c3061$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $1633b159689c3061$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $1633b159689c3061$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $1633b159689c3061$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $1633b159689c3061$var$distanceBetween($1633b159689c3061$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($1633b159689c3061$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $1633b159689c3061$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $1633b159689c3061$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $1633b159689c3061$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $1633b159689c3061$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($1633b159689c3061$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $1633b159689c3061$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $1633b159689c3061$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $1633b159689c3061$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($1633b159689c3061$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $1633b159689c3061$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $1633b159689c3061$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $1633b159689c3061$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $1633b159689c3061$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $1633b159689c3061$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($1633b159689c3061$var$sortCollisionsAsc);
};
function $1633b159689c3061$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $1633b159689c3061$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $1633b159689c3061$export$597cbd7bbd10deb4;
}
function $1633b159689c3061$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $1633b159689c3061$var$getAdjustedRect = /*#__PURE__*/ $1633b159689c3061$var$createRectAdjustmentFn(1);
function $1633b159689c3061$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $1633b159689c3061$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $1633b159689c3061$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $1633b159689c3061$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $1633b159689c3061$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $1633b159689c3061$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $bFs7G.getWindow)(element).getComputedStyle(element);
        if (transform) rect = $1633b159689c3061$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $1633b159689c3061$var$getTransformAgnosticClientRect(element) {
    return $1633b159689c3061$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $1633b159689c3061$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $1633b159689c3061$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $bFs7G.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $1633b159689c3061$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $bFs7G.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $1633b159689c3061$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $bFs7G.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $bFs7G.isHTMLElement)(node) || (0, $bFs7G.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $bFs7G.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if ($1633b159689c3061$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($1633b159689c3061$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $1633b159689c3061$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $1633b159689c3061$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $1633b159689c3061$var$getScrollableElement(element) {
    if (!(0, $bFs7G.canUseDOM) || !element) return null;
    if ((0, $bFs7G.isWindow)(element)) return element;
    if (!(0, $bFs7G.isNode)(element)) return null;
    if ((0, $bFs7G.isDocument)(element) || element === (0, $bFs7G.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, $bFs7G.isHTMLElement)(element)) return element;
    return null;
}
function $1633b159689c3061$var$getScrollXCoordinate(element) {
    if ((0, $bFs7G.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $1633b159689c3061$var$getScrollYCoordinate(element) {
    if ((0, $bFs7G.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function $1633b159689c3061$var$getScrollCoordinates(element) {
    return {
        x: $1633b159689c3061$var$getScrollXCoordinate(element),
        y: $1633b159689c3061$var$getScrollYCoordinate(element)
    };
}
var $1633b159689c3061$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($1633b159689c3061$var$Direction || ($1633b159689c3061$var$Direction = {}));
function $1633b159689c3061$var$isDocumentScrollingElement(element) {
    if (!(0, $bFs7G.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function $1633b159689c3061$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $1633b159689c3061$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $1633b159689c3061$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $1633b159689c3061$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $1633b159689c3061$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $1633b159689c3061$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $1633b159689c3061$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $1633b159689c3061$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $1633b159689c3061$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $1633b159689c3061$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $1633b159689c3061$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $1633b159689c3061$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $bFs7G.add)(acc, $1633b159689c3061$var$getScrollCoordinates(node));
    }, $1633b159689c3061$export$597cbd7bbd10deb4);
}
function $1633b159689c3061$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $1633b159689c3061$var$getScrollXCoordinate(node);
    }, 0);
}
function $1633b159689c3061$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $1633b159689c3061$var$getScrollYCoordinate(node);
    }, 0);
}
function $1633b159689c3061$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $1633b159689c3061$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $1633b159689c3061$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $1633b159689c3061$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $1633b159689c3061$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $1633b159689c3061$var$getScrollYOffset
    ]
];
class $1633b159689c3061$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $1633b159689c3061$export$e4864aa91b5ed091(element);
        const scrollOffsets = $1633b159689c3061$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $1633b159689c3061$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $1633b159689c3061$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $1633b159689c3061$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $bFs7G.getWindow)(target);
    return target instanceof EventTarget ? target : (0, $bFs7G.getOwnerDocument)(target);
}
function $1633b159689c3061$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $1633b159689c3061$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($1633b159689c3061$var$EventName || ($1633b159689c3061$var$EventName = {}));
function $1633b159689c3061$var$preventDefault(event) {
    event.preventDefault();
}
function $1633b159689c3061$var$stopPropagation(event) {
    event.stopPropagation();
}
var $1633b159689c3061$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($1633b159689c3061$export$a8b1916dba3ae88b || ($1633b159689c3061$export$a8b1916dba3ae88b = {}));
const $1633b159689c3061$var$defaultKeyboardCodes = {
    start: [
        $1633b159689c3061$export$a8b1916dba3ae88b.Space,
        $1633b159689c3061$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $1633b159689c3061$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $1633b159689c3061$export$a8b1916dba3ae88b.Space,
        $1633b159689c3061$export$a8b1916dba3ae88b.Enter,
        $1633b159689c3061$export$a8b1916dba3ae88b.Tab
    ]
};
const $1633b159689c3061$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $1633b159689c3061$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $1633b159689c3061$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $1633b159689c3061$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $1633b159689c3061$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $1633b159689c3061$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $1633b159689c3061$var$Listeners((0, $bFs7G.getOwnerDocument)(target));
        this.windowListeners = new $1633b159689c3061$var$Listeners((0, $bFs7G.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($1633b159689c3061$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($1633b159689c3061$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($1633b159689c3061$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $1633b159689c3061$var$scrollIntoViewIfNeeded(node);
        onStart($1633b159689c3061$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $bFs7G.isKeyboardEvent)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $1633b159689c3061$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $1633b159689c3061$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $1633b159689c3061$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $bFs7G.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $1633b159689c3061$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $1633b159689c3061$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $1633b159689c3061$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $1633b159689c3061$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $1633b159689c3061$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $1633b159689c3061$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Right && !isRight || direction === $1633b159689c3061$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Down && !isBottom || direction === $1633b159689c3061$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $1633b159689c3061$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $1633b159689c3061$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $1633b159689c3061$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $bFs7G.add)((0, $bFs7G.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$1633b159689c3061$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $1633b159689c3061$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $1633b159689c3061$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $1633b159689c3061$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $1633b159689c3061$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $1633b159689c3061$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $bFs7G.getOwnerDocument)(target);
        this.documentListeners = new $1633b159689c3061$var$Listeners(this.document);
        this.listeners = new $1633b159689c3061$var$Listeners(listenerTarget);
        this.windowListeners = new $1633b159689c3061$var$Listeners((0, $bFs7G.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $bFs7G.getEventCoordinates)(event)) != null ? _getEventCoordinates : $1633b159689c3061$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($1633b159689c3061$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($1633b159689c3061$var$EventName.DragStart, $1633b159689c3061$var$preventDefault);
        this.windowListeners.add($1633b159689c3061$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($1633b159689c3061$var$EventName.ContextMenu, $1633b159689c3061$var$preventDefault);
        this.documentListeners.add($1633b159689c3061$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($1633b159689c3061$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($1633b159689c3061$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($1633b159689c3061$var$EventName.Click, $1633b159689c3061$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($1633b159689c3061$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $bFs7G.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : $1633b159689c3061$export$597cbd7bbd10deb4;
        const delta = (0, $bFs7G.subtract)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($1633b159689c3061$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $1633b159689c3061$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($1633b159689c3061$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($1633b159689c3061$var$isDelayConstraint(activationConstraint)) {
                if ($1633b159689c3061$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $1633b159689c3061$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $1633b159689c3061$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $1633b159689c3061$export$b26af955418d6638 extends $1633b159689c3061$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $bFs7G.getOwnerDocument)(event.target);
        super(props, $1633b159689c3061$var$events, listenerTarget);
    }
}
$1633b159689c3061$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $1633b159689c3061$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $1633b159689c3061$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($1633b159689c3061$var$MouseButton || ($1633b159689c3061$var$MouseButton = {}));
class $1633b159689c3061$export$b28554b50bf7f273 extends $1633b159689c3061$var$AbstractPointerSensor {
    constructor(props){
        super(props, $1633b159689c3061$var$events$1, (0, $bFs7G.getOwnerDocument)(props.event.target));
    }
}
$1633b159689c3061$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $1633b159689c3061$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $1633b159689c3061$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $1633b159689c3061$export$19b41baf2e1bcdc0 extends $1633b159689c3061$var$AbstractPointerSensor {
    constructor(props){
        super(props, $1633b159689c3061$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($1633b159689c3061$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($1633b159689c3061$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$1633b159689c3061$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $1633b159689c3061$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($1633b159689c3061$export$eefe60e26f04c318 || ($1633b159689c3061$export$eefe60e26f04c318 = {}));
var $1633b159689c3061$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($1633b159689c3061$export$f93aa492a37e1b0e || ($1633b159689c3061$export$f93aa492a37e1b0e = {}));
function $1633b159689c3061$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $1633b159689c3061$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $1633b159689c3061$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $1633b159689c3061$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $bFs7G.useInterval)();
    const scrollSpeed = (0, $spJKX.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $spJKX.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $spJKX.useMemo)(()=>{
        switch(activator){
            case $1633b159689c3061$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $1633b159689c3061$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $spJKX.useRef)(null);
    const autoScroll = (0, $spJKX.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $spJKX.useMemo)(()=>order === $1633b159689c3061$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $1633b159689c3061$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $1633b159689c3061$var$defaultScrollIntent = {
    x: {
        [$1633b159689c3061$var$Direction.Backward]: false,
        [$1633b159689c3061$var$Direction.Forward]: false
    },
    y: {
        [$1633b159689c3061$var$Direction.Backward]: false,
        [$1633b159689c3061$var$Direction.Forward]: false
    }
};
function $1633b159689c3061$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $bFs7G.usePrevious)(delta);
    return (0, $bFs7G.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $1633b159689c3061$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$1633b159689c3061$var$Direction.Backward]: previousIntent.x[$1633b159689c3061$var$Direction.Backward] || direction.x === -1,
                [$1633b159689c3061$var$Direction.Forward]: previousIntent.x[$1633b159689c3061$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$1633b159689c3061$var$Direction.Backward]: previousIntent.y[$1633b159689c3061$var$Direction.Backward] || direction.y === -1,
                [$1633b159689c3061$var$Direction.Forward]: previousIntent.y[$1633b159689c3061$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $1633b159689c3061$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $bFs7G.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $1633b159689c3061$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $spJKX.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $1633b159689c3061$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($1633b159689c3061$export$571c10ffffe014ab || ($1633b159689c3061$export$571c10ffffe014ab = {}));
var $1633b159689c3061$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($1633b159689c3061$export$8e062c3160beefd5 || ($1633b159689c3061$export$8e062c3160beefd5 = {}));
const $1633b159689c3061$var$defaultValue = /*#__PURE__*/ new Map();
function $1633b159689c3061$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $spJKX.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $spJKX.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $bFs7G.useLatestValue)(disabled);
    const measureDroppableContainers = (0, $spJKX.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $spJKX.useRef)(null);
    const droppableRects = (0, $bFs7G.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return $1633b159689c3061$var$defaultValue;
        if (!previousValue || previousValue === $1633b159689c3061$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $1633b159689c3061$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $spJKX.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $1633b159689c3061$export$571c10ffffe014ab.Always:
                return false;
            case $1633b159689c3061$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $1633b159689c3061$var$useInitialValue(value, computeFn) {
    return (0, $bFs7G.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $1633b159689c3061$var$useInitialRect(node, measure) {
    return $1633b159689c3061$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $1633b159689c3061$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $bFs7G.useEvent)(callback);
    const mutationObserver = (0, $spJKX.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $spJKX.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $1633b159689c3061$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $bFs7G.useEvent)(callback);
    const resizeObserver = (0, $spJKX.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $spJKX.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $1633b159689c3061$var$defaultMeasure(element) {
    return new $1633b159689c3061$var$Rect($1633b159689c3061$export$b6aa1f30c53d7454(element), element);
}
function $1633b159689c3061$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $1633b159689c3061$var$defaultMeasure;
    const [rect, setRect] = (0, $spJKX.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $1633b159689c3061$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $1633b159689c3061$var$useResizeObserver({
        callback: measureRect
    });
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $1633b159689c3061$var$useRectDelta(rect) {
    const initialRect = $1633b159689c3061$var$useInitialValue(rect);
    return $1633b159689c3061$var$getRectDelta(rect, initialRect);
}
const $1633b159689c3061$var$defaultValue$1 = [];
function $1633b159689c3061$var$useScrollableAncestors(node) {
    const previousNode = (0, $spJKX.useRef)(node);
    const ancestors = (0, $bFs7G.useLazyMemo)((previousValue)=>{
        if (!node) return $1633b159689c3061$var$defaultValue$1;
        if (previousValue && previousValue !== $1633b159689c3061$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $1633b159689c3061$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $spJKX.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $1633b159689c3061$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $spJKX.useState)(null);
    const prevElements = (0, $spJKX.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $spJKX.useCallback)((event)=>{
        const scrollingElement = $1633b159689c3061$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $1633b159689c3061$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $spJKX.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $1633b159689c3061$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $1633b159689c3061$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $1633b159689c3061$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $spJKX.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $bFs7G.add)(acc, coordinates), $1633b159689c3061$export$597cbd7bbd10deb4) : $1633b159689c3061$var$getScrollOffsets(elements);
        return $1633b159689c3061$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $1633b159689c3061$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $spJKX.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $1633b159689c3061$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $bFs7G.subtract)(scrollOffsets, initialScrollOffsets.current) : $1633b159689c3061$export$597cbd7bbd10deb4;
}
function $1633b159689c3061$var$useSensorSetup(sensors) {
    (0, $spJKX.useEffect)(()=>{
        if (!(0, $bFs7G.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $1633b159689c3061$var$useSyntheticListeners(listeners, id) {
    return (0, $spJKX.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $1633b159689c3061$var$useWindowRect(element) {
    return (0, $spJKX.useMemo)(()=>element ? $1633b159689c3061$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $1633b159689c3061$var$defaultValue$2 = [];
function $1633b159689c3061$var$useRects(elements, measure) {
    if (measure === void 0) measure = $1633b159689c3061$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $1633b159689c3061$var$useWindowRect(firstElement ? (0, $bFs7G.getWindow)(firstElement) : null);
    const [rects, setRects] = (0, $spJKX.useState)($1633b159689c3061$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $1633b159689c3061$var$defaultValue$2;
            return elements.map((element)=>$1633b159689c3061$var$isDocumentScrollingElement(element) ? windowRect : new $1633b159689c3061$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $1633b159689c3061$var$useResizeObserver({
        callback: measureRects
    });
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $1633b159689c3061$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $bFs7G.isHTMLElement)(firstChild) ? firstChild : node;
}
function $1633b159689c3061$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $spJKX.useState)(null);
    const handleResize = (0, $spJKX.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $bFs7G.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $1633b159689c3061$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $spJKX.useCallback)((element)=>{
        const node = $1633b159689c3061$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $bFs7G.useNodeRef)(handleNodeChange);
    return (0, $spJKX.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $1633b159689c3061$var$defaultSensors = [
    {
        sensor: $1633b159689c3061$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $1633b159689c3061$export$44d67f2a438aeba9,
        options: {}
    }
];
const $1633b159689c3061$var$defaultData = {
    current: {}
};
const $1633b159689c3061$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $1633b159689c3061$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $1633b159689c3061$var$getTransformAgnosticClientRect,
        strategy: $1633b159689c3061$export$571c10ffffe014ab.WhileDragging,
        frequency: $1633b159689c3061$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $1633b159689c3061$export$b6aa1f30c53d7454
    }
};
class $1633b159689c3061$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $1633b159689c3061$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $1633b159689c3061$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $1633b159689c3061$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $1633b159689c3061$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $1633b159689c3061$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $1633b159689c3061$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $1633b159689c3061$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $1633b159689c3061$var$noop
};
const $1633b159689c3061$var$InternalContext = /*#__PURE__*/ (0, $spJKX.createContext)($1633b159689c3061$var$defaultInternalContext);
const $1633b159689c3061$var$PublicContext = /*#__PURE__*/ (0, $spJKX.createContext)($1633b159689c3061$var$defaultPublicContext);
function $1633b159689c3061$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $1633b159689c3061$var$DroppableContainersMap()
        }
    };
}
function $1633b159689c3061$var$reducer(state, action) {
    switch(action.type){
        case $1633b159689c3061$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $1633b159689c3061$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $1633b159689c3061$var$Action.DragEnd:
        case $1633b159689c3061$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $1633b159689c3061$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $1633b159689c3061$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $1633b159689c3061$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $1633b159689c3061$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $1633b159689c3061$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $1633b159689c3061$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $1633b159689c3061$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $spJKX.useContext)($1633b159689c3061$var$InternalContext);
    const previousActivatorEvent = (0, $bFs7G.usePrevious)(activatorEvent);
    const previousActiveId = (0, $bFs7G.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $spJKX.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $bFs7G.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $bFs7G.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $1633b159689c3061$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $1633b159689c3061$var$useMeasuringConfiguration(config) {
    return (0, $spJKX.useMemo)(()=>({
            draggable: {
                ...$1633b159689c3061$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$1633b159689c3061$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$1633b159689c3061$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $1633b159689c3061$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $spJKX.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $1633b159689c3061$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $1633b159689c3061$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $1633b159689c3061$var$ActiveDraggableContext = /*#__PURE__*/ (0, $spJKX.createContext)({
    ...$1633b159689c3061$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $1633b159689c3061$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($1633b159689c3061$var$Status || ($1633b159689c3061$var$Status = {}));
const $1633b159689c3061$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $spJKX.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $1633b159689c3061$var$defaultSensors, collisionDetection: collisionDetection = $1633b159689c3061$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $spJKX.useReducer)($1633b159689c3061$var$reducer, undefined, $1633b159689c3061$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $1633b159689c3061$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $spJKX.useState)($1633b159689c3061$var$Status.Uninitialized);
    const isInitialized = status === $1633b159689c3061$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $spJKX.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $spJKX.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $1633b159689c3061$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $spJKX.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $spJKX.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $spJKX.useState)(null);
    const latestProps = (0, $bFs7G.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, $bFs7G.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $spJKX.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $1633b159689c3061$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $1633b159689c3061$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $1633b159689c3061$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $spJKX.useMemo)(()=>activatorEvent ? (0, $bFs7G.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $1633b159689c3061$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $1633b159689c3061$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $1633b159689c3061$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $1633b159689c3061$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $spJKX.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $1633b159689c3061$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $1633b159689c3061$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $1633b159689c3061$var$useWindowRect(draggingNode ? (0, $bFs7G.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $1633b159689c3061$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $1633b159689c3061$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $1633b159689c3061$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $bFs7G.add)(activationCoordinates, translate) : null;
    const scrollOffsets = $1633b159689c3061$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $1633b159689c3061$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $1633b159689c3061$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $bFs7G.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $1633b159689c3061$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $1633b159689c3061$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $spJKX.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $bFs7G.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $1633b159689c3061$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $spJKX.useRef)(null);
    const instantiateSensor = (0, $spJKX.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $oS63j.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($1633b159689c3061$var$Status.Initializing);
                    dispatch({
                        type: $1633b159689c3061$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $1633b159689c3061$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($1633b159689c3061$var$Action.DragEnd),
            onCancel: createHandler($1633b159689c3061$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $1633b159689c3061$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $1633b159689c3061$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $oS63j.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($1633b159689c3061$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $1633b159689c3061$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $spJKX.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $1633b159689c3061$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $1633b159689c3061$var$useSensorSetup(sensors);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === $1633b159689c3061$var$Status.Initializing) setStatus($1633b159689c3061$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $spJKX.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $oS63j.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $spJKX.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $oS63j.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $1633b159689c3061$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $spJKX.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $spJKX.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $1633b159689c3061$var$NullContext = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $1633b159689c3061$var$defaultRole = 'button';
const $1633b159689c3061$var$ID_PREFIX = 'Draggable';
function $1633b159689c3061$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $bFs7G.useUniqueId)($1633b159689c3061$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $spJKX.useContext)($1633b159689c3061$var$InternalContext);
    const { role: role = $1633b159689c3061$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $spJKX.useContext)(isDragging ? $1633b159689c3061$var$ActiveDraggableContext : $1633b159689c3061$var$NullContext);
    const [node, setNodeRef] = (0, $bFs7G.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, $bFs7G.useNodeRef)();
    const listeners = $1633b159689c3061$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $bFs7G.useLatestValue)(data);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $spJKX.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $1633b159689c3061$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $1633b159689c3061$export$4930f6bf413be70e() {
    return (0, $spJKX.useContext)($1633b159689c3061$var$PublicContext);
}
const $1633b159689c3061$var$ID_PREFIX$1 = 'Droppable';
const $1633b159689c3061$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $1633b159689c3061$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $bFs7G.useUniqueId)($1633b159689c3061$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $spJKX.useContext)($1633b159689c3061$var$InternalContext);
    const previous = (0, $spJKX.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $spJKX.useRef)(false);
    const rect = (0, $spJKX.useRef)(null);
    const callbackId = (0, $spJKX.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$1633b159689c3061$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $bFs7G.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $spJKX.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $1633b159689c3061$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $spJKX.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $bFs7G.useNodeRef)(handleNodeChange);
    const dataRef = (0, $bFs7G.useLatestValue)(data);
    (0, $spJKX.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $spJKX.useEffect)(()=>{
        dispatch({
            type: $1633b159689c3061$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $1633b159689c3061$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $1633b159689c3061$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $1633b159689c3061$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $spJKX.useState)(null);
    const [element, setElement] = (0, $spJKX.useState)(null);
    const previousChildren = (0, $bFs7G.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Fragment, null, children, clonedChildren ? (0, $spJKX.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $1633b159689c3061$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $1633b159689c3061$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$InternalContext.Provider, {
        value: $1633b159689c3061$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$ActiveDraggableContext.Provider, {
        value: $1633b159689c3061$var$defaultTransform
    }, children));
}
const $1633b159689c3061$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $1633b159689c3061$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $bFs7G.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $1633b159689c3061$var$PositionedOverlay = /*#__PURE__*/ (0, $spJKX.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $1633b159689c3061$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$1633b159689c3061$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $bFs7G.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $1633b159689c3061$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $1633b159689c3061$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $1633b159689c3061$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $bFs7G.CSS).Transform.toString(initial)
        },
        {
            transform: (0, $bFs7G.CSS).Transform.toString(final)
        }
    ];
};
const $1633b159689c3061$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $1633b159689c3061$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $1633b159689c3061$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $1633b159689c3061$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $bFs7G.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $1633b159689c3061$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $bFs7G.getWindow)(node).getComputedStyle(node);
        const parsedTransform = $1633b159689c3061$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $1633b159689c3061$var$createDefaultDropAnimation(config);
        $1633b159689c3061$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $1633b159689c3061$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$1633b159689c3061$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $1633b159689c3061$var$key = 0;
function $1633b159689c3061$var$useKey(id) {
    return (0, $spJKX.useMemo)(()=>{
        if (id == null) return;
        $1633b159689c3061$var$key++;
        return $1633b159689c3061$var$key;
    }, [
        id
    ]);
}
const $1633b159689c3061$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $1633b159689c3061$export$4930f6bf413be70e();
    const transform = (0, $spJKX.useContext)($1633b159689c3061$var$ActiveDraggableContext);
    const key = $1633b159689c3061$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $1633b159689c3061$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $1633b159689c3061$var$useInitialValue(activeNodeRect);
    const dropAnimation = $1633b159689c3061$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($1633b159689c3061$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

});
parcelRegister("bFs7G", function(module, exports) {

$parcel$export(module.exports, "useCombinedRefs", function () { return $87e956b192ff29a8$export$2f8294366bb2d67a; });
$parcel$export(module.exports, "canUseDOM", function () { return $87e956b192ff29a8$export$71594e8a50f746f4; });
$parcel$export(module.exports, "isWindow", function () { return $87e956b192ff29a8$export$5a096129d439f843; });
$parcel$export(module.exports, "isNode", function () { return $87e956b192ff29a8$export$8ee0fc9ee280b4ee; });
$parcel$export(module.exports, "getWindow", function () { return $87e956b192ff29a8$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "isDocument", function () { return $87e956b192ff29a8$export$62858bae88b53fd0; });
$parcel$export(module.exports, "isHTMLElement", function () { return $87e956b192ff29a8$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isSVGElement", function () { return $87e956b192ff29a8$export$17eda790a720ec57; });
$parcel$export(module.exports, "getOwnerDocument", function () { return $87e956b192ff29a8$export$b204af158042fbac; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $87e956b192ff29a8$export$700979bc83e7db82; });
$parcel$export(module.exports, "useEvent", function () { return $87e956b192ff29a8$export$90fc3a17d93f704c; });
$parcel$export(module.exports, "useInterval", function () { return $87e956b192ff29a8$export$f4b266cd2aae9cb1; });
$parcel$export(module.exports, "useLatestValue", function () { return $87e956b192ff29a8$export$86c4283a11f23f95; });
$parcel$export(module.exports, "useLazyMemo", function () { return $87e956b192ff29a8$export$b0d7b7f1fcd613d1; });
$parcel$export(module.exports, "useNodeRef", function () { return $87e956b192ff29a8$export$bc23c270f170c912; });
$parcel$export(module.exports, "usePrevious", function () { return $87e956b192ff29a8$export$5cae361ad82dce8b; });
$parcel$export(module.exports, "useUniqueId", function () { return $87e956b192ff29a8$export$c485849f2e393253; });
$parcel$export(module.exports, "add", function () { return $87e956b192ff29a8$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $87e956b192ff29a8$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "isKeyboardEvent", function () { return $87e956b192ff29a8$export$130b789831072f4c; });
$parcel$export(module.exports, "getEventCoordinates", function () { return $87e956b192ff29a8$export$36195c8aa1517e04; });
$parcel$export(module.exports, "CSS", function () { return $87e956b192ff29a8$export$c4ffa16951855e28; });
$parcel$export(module.exports, "findFirstFocusableNode", function () { return $87e956b192ff29a8$export$44f71d798fd0a62b; });

var $spJKX = parcelRequire("spJKX");
function $87e956b192ff29a8$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $spJKX.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $87e956b192ff29a8$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $87e956b192ff29a8$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $87e956b192ff29a8$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $87e956b192ff29a8$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($87e956b192ff29a8$export$5a096129d439f843(target)) return target;
    if (!$87e956b192ff29a8$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $87e956b192ff29a8$export$62858bae88b53fd0(node) {
    const { Document: Document } = $87e956b192ff29a8$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $87e956b192ff29a8$export$1b3bfaa9684536aa(node) {
    if ($87e956b192ff29a8$export$5a096129d439f843(node)) return false;
    return node instanceof $87e956b192ff29a8$export$38b2d434cce3ea22(node).HTMLElement;
}
function $87e956b192ff29a8$export$17eda790a720ec57(node) {
    return node instanceof $87e956b192ff29a8$export$38b2d434cce3ea22(node).SVGElement;
}
function $87e956b192ff29a8$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($87e956b192ff29a8$export$5a096129d439f843(target)) return target.document;
    if (!$87e956b192ff29a8$export$8ee0fc9ee280b4ee(target)) return document;
    if ($87e956b192ff29a8$export$62858bae88b53fd0(target)) return target;
    if ($87e956b192ff29a8$export$1b3bfaa9684536aa(target) || $87e956b192ff29a8$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $87e956b192ff29a8$export$700979bc83e7db82 = $87e956b192ff29a8$export$71594e8a50f746f4 ? (0, $spJKX.useLayoutEffect) : (0, $spJKX.useEffect);
function $87e956b192ff29a8$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $spJKX.useRef)(handler);
    $87e956b192ff29a8$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $spJKX.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $87e956b192ff29a8$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $spJKX.useRef)(null);
    const set = (0, $spJKX.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $spJKX.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $87e956b192ff29a8$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $spJKX.useRef)(value);
    $87e956b192ff29a8$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $87e956b192ff29a8$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $spJKX.useRef)();
    return (0, $spJKX.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $87e956b192ff29a8$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $87e956b192ff29a8$export$90fc3a17d93f704c(onChange);
    const node = (0, $spJKX.useRef)(null);
    const setNodeRef = (0, $spJKX.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $87e956b192ff29a8$export$5cae361ad82dce8b(value) {
    const ref = (0, $spJKX.useRef)();
    (0, $spJKX.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $87e956b192ff29a8$var$ids = {};
function $87e956b192ff29a8$export$c485849f2e393253(prefix, value) {
    return (0, $spJKX.useMemo)(()=>{
        if (value) return value;
        const id = $87e956b192ff29a8$var$ids[prefix] == null ? 0 : $87e956b192ff29a8$var$ids[prefix] + 1;
        $87e956b192ff29a8$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $87e956b192ff29a8$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $87e956b192ff29a8$export$e16d8520af44a096 = /*#__PURE__*/ $87e956b192ff29a8$var$createAdjustmentFn(1);
const $87e956b192ff29a8$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $87e956b192ff29a8$var$createAdjustmentFn(-1);
function $87e956b192ff29a8$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $87e956b192ff29a8$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $87e956b192ff29a8$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $87e956b192ff29a8$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $87e956b192ff29a8$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $87e956b192ff29a8$export$36195c8aa1517e04(event) {
    if ($87e956b192ff29a8$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($87e956b192ff29a8$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $87e956b192ff29a8$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $87e956b192ff29a8$export$c4ffa16951855e28.Translate.toString(transform),
                $87e956b192ff29a8$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $87e956b192ff29a8$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $87e956b192ff29a8$export$44f71d798fd0a62b(element) {
    if (element.matches($87e956b192ff29a8$var$SELECTOR)) return element;
    return element.querySelector($87e956b192ff29a8$var$SELECTOR);
}

});

parcelRegister("aur83", function(module, exports) {

$parcel$export(module.exports, "HiddenText", function () { return $7a31bffbde575dad$export$1496ac55023363a5; });
$parcel$export(module.exports, "LiveRegion", function () { return $7a31bffbde575dad$export$ae99b902be98b17; });
$parcel$export(module.exports, "useAnnouncement", function () { return $7a31bffbde575dad$export$97d78af8d95ca8bd; });

var $spJKX = parcelRequire("spJKX");
const $7a31bffbde575dad$var$hiddenStyles = {
    display: 'none'
};
function $7a31bffbde575dad$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("div", {
        id: id,
        style: $7a31bffbde575dad$var$hiddenStyles
    }, value);
}
function $7a31bffbde575dad$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $7a31bffbde575dad$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $spJKX.useState)('');
    const announce = (0, $spJKX.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}

});


parcelRegister("6wCa0", function(module, exports) {

$parcel$export(module.exports, "restrictToVerticalAxis", function () { return $4c03551e4538c0f5$export$1ed98a87b7c51b89; });

var $bFs7G = parcelRequire("bFs7G");
function $4c03551e4538c0f5$export$7f11ea1f0ba255b5(gridSize) {
    return (_ref)=>{
        let { transform: transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const $4c03551e4538c0f5$export$29320759dd5f3702 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function $4c03551e4538c0f5$var$restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const $4c03551e4538c0f5$export$c7685f801ed492b5 = (_ref)=>{
    let { containerNodeRect: containerNodeRect, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return $4c03551e4538c0f5$var$restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const $4c03551e4538c0f5$export$85bf625d52c1d097 = (_ref)=>{
    let { draggingNodeRect: draggingNodeRect, transform: transform, scrollableAncestorRects: scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return $4c03551e4538c0f5$var$restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const $4c03551e4538c0f5$export$1ed98a87b7c51b89 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const $4c03551e4538c0f5$export$57196ad89f591aab = (_ref)=>{
    let { transform: transform, draggingNodeRect: draggingNodeRect, windowRect: windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return $4c03551e4538c0f5$var$restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const $4c03551e4538c0f5$export$70a75ea36ecd3098 = (_ref)=>{
    let { activatorEvent: activatorEvent, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, $bFs7G.getEventCoordinates)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};

});

parcelRegister("4mdE0", function(module, exports) {

$parcel$export(module.exports, "verticalListSortingStrategy", function () { return $32c3ccf3f2369a75$export$fe2be640df2ffb9e; });
$parcel$export(module.exports, "SortableContext", function () { return $32c3ccf3f2369a75$export$86155fde54f06e6a; });
$parcel$export(module.exports, "useSortable", function () { return $32c3ccf3f2369a75$export$4ebcb6201122185a; });
$parcel$export(module.exports, "sortableKeyboardCoordinates", function () { return $32c3ccf3f2369a75$export$a6f27ecf02eb3a67; });

var $spJKX = parcelRequire("spJKX");

var $1Ubba = parcelRequire("1Ubba");

var $bFs7G = parcelRequire("bFs7G");
/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $32c3ccf3f2369a75$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $32c3ccf3f2369a75$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $32c3ccf3f2369a75$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $32c3ccf3f2369a75$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $32c3ccf3f2369a75$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $32c3ccf3f2369a75$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $32c3ccf3f2369a75$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $32c3ccf3f2369a75$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $32c3ccf3f2369a75$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$32c3ccf3f2369a75$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$32c3ccf3f2369a75$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$32c3ccf3f2369a75$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$32c3ccf3f2369a75$var$defaultScale
    };
};
function $32c3ccf3f2369a75$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $32c3ccf3f2369a75$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $32c3ccf3f2369a75$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $32c3ccf3f2369a75$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $32c3ccf3f2369a75$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $32c3ccf3f2369a75$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$32c3ccf3f2369a75$var$defaultScale$1
        };
    }
    const itemGap = $32c3ccf3f2369a75$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$32c3ccf3f2369a75$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$32c3ccf3f2369a75$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$32c3ccf3f2369a75$var$defaultScale$1
    };
};
function $32c3ccf3f2369a75$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $32c3ccf3f2369a75$var$ID_PREFIX = 'Sortable';
const $32c3ccf3f2369a75$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createContext({
    activeIndex: -1,
    containerId: $32c3ccf3f2369a75$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $32c3ccf3f2369a75$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $32c3ccf3f2369a75$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $32c3ccf3f2369a75$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $1Ubba.useDndContext)();
    const containerId = (0, $bFs7G.useUniqueId)($32c3ccf3f2369a75$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $spJKX.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $spJKX.useRef)(items);
    const itemsHaveChanged = !$32c3ccf3f2369a75$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $32c3ccf3f2369a75$var$normalizeDisabled(disabledProp);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $spJKX.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $spJKX.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $32c3ccf3f2369a75$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($32c3ccf3f2369a75$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $32c3ccf3f2369a75$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $32c3ccf3f2369a75$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $32c3ccf3f2369a75$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $32c3ccf3f2369a75$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $32c3ccf3f2369a75$var$transitionProperty = 'transform';
const $32c3ccf3f2369a75$var$disabledTransition = /*#__PURE__*/ (0, $bFs7G.CSS).Transition.toString({
    property: $32c3ccf3f2369a75$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $32c3ccf3f2369a75$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $32c3ccf3f2369a75$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $spJKX.useState)(null);
    const previousIndex = (0, $spJKX.useRef)(index);
    (0, $bFs7G.useIsomorphicLayoutEffect)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $1Ubba.getClientRect)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $32c3ccf3f2369a75$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $32c3ccf3f2369a75$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $32c3ccf3f2369a75$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $32c3ccf3f2369a75$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $spJKX.useContext)($32c3ccf3f2369a75$var$Context);
    const disabled = $32c3ccf3f2369a75$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $spJKX.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $spJKX.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $1Ubba.useDroppable)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $1Ubba.useDraggable)({
        id: id,
        data: data,
        attributes: {
            ...$32c3ccf3f2369a75$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $bFs7G.useCombinedRefs)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $32c3ccf3f2369a75$var$isValidIndex(activeIndex) && $32c3ccf3f2369a75$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $32c3ccf3f2369a75$var$isValidIndex(activeIndex) && $32c3ccf3f2369a75$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $spJKX.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $32c3ccf3f2369a75$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $spJKX.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $32c3ccf3f2369a75$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $bFs7G.isKeyboardEvent)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $bFs7G.CSS).Transition.toString({
            ...transition,
            property: $32c3ccf3f2369a75$var$transitionProperty
        });
        return undefined;
    }
}
function $32c3ccf3f2369a75$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $32c3ccf3f2369a75$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $32c3ccf3f2369a75$var$directions = [
    (0, $1Ubba.KeyboardCode).Down,
    (0, $1Ubba.KeyboardCode).Right,
    (0, $1Ubba.KeyboardCode).Up,
    (0, $1Ubba.KeyboardCode).Left
];
const $32c3ccf3f2369a75$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($32c3ccf3f2369a75$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $1Ubba.KeyboardCode).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $1Ubba.KeyboardCode).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $1Ubba.KeyboardCode).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $1Ubba.KeyboardCode).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $1Ubba.closestCorners)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $1Ubba.getFirstCollision)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $1Ubba.getScrollableAncestors)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $32c3ccf3f2369a75$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $32c3ccf3f2369a75$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $bFs7G.subtract)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $32c3ccf3f2369a75$var$isSameContainer(a, b) {
    if (!$32c3ccf3f2369a75$export$6424ec8a0d450b09(a) || !$32c3ccf3f2369a75$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $32c3ccf3f2369a75$var$isAfter(a, b) {
    if (!$32c3ccf3f2369a75$export$6424ec8a0d450b09(a) || !$32c3ccf3f2369a75$export$6424ec8a0d450b09(b)) return false;
    if (!$32c3ccf3f2369a75$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}

});

parcelRegister("4MUDD", function(module, exports) {

$parcel$export(module.exports, "SortableListItem", function () { return $498f47178c20ad82$export$3548239ca3a82858; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $4mdE0 = parcelRequire("4mdE0");

var $bFs7G = parcelRequire("bFs7G");

var $52t30 = parcelRequire("52t30");

var $6aU6r = parcelRequire("6aU6r");
/**
 * Drag handle button for sortable list items.
 *
 * @param props - The component props
 * @param props.listeners - Event listeners for drag interactions
 * @param props.maxHeight - Optional maximum height for the grip container
 */ const $498f47178c20ad82$var$ButtonGrip = ({ listeners: listeners, maxHeight: maxHeight })=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6aU6r))).sortableItemGripHolder,
        ...listeners,
        role: "button",
        style: {
            maxHeight: maxHeight !== undefined ? `${maxHeight}px` : "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $52t30.default), {})
    });
$498f47178c20ad82$var$ButtonGrip.displayName = "ButtonGrip";
function $498f47178c20ad82$export$3548239ca3a82858({ id: id, canMove: canMove, children: children, maxHeight: maxHeight, showBorder: showBorder = true }) {
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition } = (0, $4mdE0.useSortable)({
        id: id
    });
    const style = {
        transform: (0, $bFs7G.CSS).Translate.toString(transform),
        transition: transition
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: setNodeRef,
        ...attributes,
        role: "tab",
        style: style,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.AutoHeight), {
            hide: maxHeight === 0,
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center"
                },
                children: [
                    canMove && /*#__PURE__*/ (0, $bR5nk.jsx)($498f47178c20ad82$var$ButtonGrip, {
                        listeners: listeners,
                        maxHeight: maxHeight
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($6aU6r))).sortableItemAfterGrip,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: showBorder ? `m-1 ${(0, (/*@__PURE__*/$parcel$interopDefault($6aU6r))).sortableItemBorder}` : "m-1",
                            children: children
                        })
                    })
                ]
            })
        })
    });
}
$498f47178c20ad82$export$3548239ca3a82858.displayName = "SortableListItem";

});
parcelRegister("52t30", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ab3abdf9c406a7a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $3ab3abdf9c406a7a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $3ab3abdf9c406a7a$var$_extends() {
    return $3ab3abdf9c406a7a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3ab3abdf9c406a7a$var$_extends.apply(null, arguments);
}
function $3ab3abdf9c406a7a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3ab3abdf9c406a7a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3ab3abdf9c406a7a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3ab3abdf9c406a7a$var$GripVertical = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $3ab3abdf9c406a7a$var$_objectWithoutProperties(_ref, $3ab3abdf9c406a7a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $3ab3abdf9c406a7a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-grip-vertical',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$3ab3abdf9c406a7a$var$GripVertical.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $3ab3abdf9c406a7a$export$2e2bcd8739ae039 = $3ab3abdf9c406a7a$var$GripVertical;

});

parcelRegister("6aU6r", function(module, exports) {

$parcel$export(module.exports, "sortableItemAfterGrip", function () { return $47ef3217495b1ec6$export$289a2c9e71ad6f06; }, function (v) { return $47ef3217495b1ec6$export$289a2c9e71ad6f06 = v; });
$parcel$export(module.exports, "sortableItemBorder", function () { return $47ef3217495b1ec6$export$471747347fece6a; }, function (v) { return $47ef3217495b1ec6$export$471747347fece6a = v; });
$parcel$export(module.exports, "sortableItemGripHolder", function () { return $47ef3217495b1ec6$export$585fa63c8a467d37; }, function (v) { return $47ef3217495b1ec6$export$585fa63c8a467d37 = v; });
var $47ef3217495b1ec6$export$289a2c9e71ad6f06;
var $47ef3217495b1ec6$export$471747347fece6a;
var $47ef3217495b1ec6$export$585fa63c8a467d37;
$47ef3217495b1ec6$export$289a2c9e71ad6f06 = `mos-SortableList-module-fytC_a-sortableItemAfterGrip`;
$47ef3217495b1ec6$export$471747347fece6a = `mos-SortableList-module-fytC_a-sortableItemBorder`;
$47ef3217495b1ec6$export$585fa63c8a467d37 = `mos-SortableList-module-fytC_a-sortableItemGripHolder`;

});




parcelRegister("fc2Ha", function(module, exports) {
$parcel$export(module.exports, "ArsSelect", function () { return (parcelRequire("krPhG")).ArsSelect; });
$parcel$export(module.exports, "ArsText", function () { return (parcelRequire("d4ZHR")).ArsText; });
$parcel$export(module.exports, "ArsVariable", function () { return (parcelRequire("2VKUu")).ArsVariable; });
parcelRequire("krPhG");
parcelRequire("d4ZHR");
parcelRequire("2VKUu");

});
parcelRegister("krPhG", function(module, exports) {

$parcel$export(module.exports, "ArsSelect", function () { return $c4473da92d120a49$export$2a6c033596672218; });

var $bR5nk = parcelRequire("bR5nk");

var $3ew5o = parcelRequire("3ew5o");

var $aUt9N = parcelRequire("aUt9N");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");

var $5kgoV = parcelRequire("5kgoV");
const $c4473da92d120a49$export$2a6c033596672218 = ({ dataPath: dataPath, options: options, tableDataPath: tableDataPath = false, ...rest })=>{
    const ars = (0, $4hgF7.useArsContext)();
    const table = (0, $5kgoV.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    // Get the current value from state using the dataPath
    const pointer = (0, $3ew5o.Pointer).fromJSON(dataPath);
    const value = pointer.get(sourceState) ?? "";
    // Get all available values
    const availableValues = options.map((opt)=>typeof opt === "string" ? opt : opt.value);
    // Add current value to options at the start of the list if it's not already present
    if (!availableValues.includes(value)) {
        if (typeof options[0] === "string" || options.length === 0) options = [
            value,
            ...options
        ];
        else options = [
            {
                value: value,
                label: value
            },
            ...options
        ];
    }
    /**
   * Handle selection change by dispatching PATCH_ARS_STATE action.
   *
   * @param newValue - The new value to set.
   */ const handleChange = (newValue)=>{
        if (newValue !== "-- None --") {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: dataPath,
                value: newValue
            });
            else table.dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                dataPath: dataPath,
                value: newValue
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
        labelWidth: 2,
        options: options,
        setValue: handleChange,
        value: value,
        ...rest
    });
};
$c4473da92d120a49$export$2a6c033596672218.displayName = "ArsSelect";

});
parcelRegister("5VyPu", function(module, exports) {
$parcel$export(module.exports, "ArsTable", function () { return (parcelRequire("jKF9Q")).ArsTable; });
$parcel$export(module.exports, "ARST_PATCH_DATA", function () { return (parcelRequire("k9YO2")).ARST_PATCH_DATA; });
$parcel$export(module.exports, "ArsTableCellType", function () { return (parcelRequire("k9YO2")).ArsTableCellType; });
$parcel$export(module.exports, "ArsTextJustification", function () { return (parcelRequire("k9YO2")).ArsTextJustification; });
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("gwArU")).isArsTableBody; });
parcelRequire("jKF9Q");
parcelRequire("5xg49");
parcelRequire("cVqbP");
parcelRequire("c8cwJ");
parcelRequire("g2mVC");
parcelRequire("8fWCE");
parcelRequire("k9YO2");
parcelRequire("alciT");

});
parcelRegister("jKF9Q", function(module, exports) {

$parcel$export(module.exports, "ArsTable", function () { return $f5dd6b14a15a9ee9$export$7a45b4d483fef7bf; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $3DrUW = parcelRequire("3DrUW");

var $5kgoV = parcelRequire("5kgoV");

var $k9YO2 = parcelRequire("k9YO2");
const $f5dd6b14a15a9ee9$export$7a45b4d483fef7bf = ({ id: id = "ars-table", arsTableBody: arsTableBody, calculatedTableRows: calculatedTableRows, disabled: disabled = false, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), justification: justification = (0, $k9YO2.ArsTableJustification).Center, sidebarStyle: sidebarStyle, style: style, tlfViewMode: tlfViewMode, updateArsTableBody: updateArsTableBody })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5kgoV.ArsTableContextProvider), {
        bodyData: arsTableBody,
        calculatedTableRows: calculatedTableRows,
        updateBodyData: updateArsTableBody,
        settings: {
            id: id,
            disabled: disabled,
            editorProps: editorProps,
            justification: justification,
            sidebarStyle: sidebarStyle,
            style: style,
            tlfViewMode: tlfViewMode
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3DrUW.ArsTableContent), {})
    });
};
$f5dd6b14a15a9ee9$export$7a45b4d483fef7bf.displayName = "ArsTable";

});
parcelRegister("3DrUW", function(module, exports) {

$parcel$export(module.exports, "ArsTableContent", function () { return $d2b808b211bb43f5$export$26fdf0e2e5a3507d; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
parcelRequire("e2uI9");
var $h7u5p = parcelRequire("h7u5p");
parcelRequire("4Sj6S");
var $f4xry = parcelRequire("f4xry");

var $hGt3n = parcelRequire("hGt3n");

var $5xg49 = parcelRequire("5xg49");

var $jDDGB = parcelRequire("jDDGB");

var $5kgoV = parcelRequire("5kgoV");

var $cVqbP = parcelRequire("cVqbP");

var $hTg9m = parcelRequire("hTg9m");

var $g2mVC = parcelRequire("g2mVC");
parcelRequire("8fWCE");
var $3TPyB = parcelRequire("3TPyB");

var $k9YO2 = parcelRequire("k9YO2");
const $d2b808b211bb43f5$export$26fdf0e2e5a3507d = ()=>{
    const { state: state, dispatch: dispatch } = (0, $5kgoV.useArsTable)();
    const disabled = state?.settings.disabled;
    const justification = state?.settings.justification;
    const scaffoldModel = state?.scaffoldModel;
    const [dragItem, setDragItem] = (0, $spJKX.useState)(null);
    // Return if things are missing
    if (!state || !scaffoldModel) return null;
    const zoneColors = (0, $3TPyB.buildArsTableZoneColors)(state, dragItem?.[0]?.kind ?? null);
    /**
   * Handles scaffold drop events by building and dispatching table-drop actions.
   *
   * @param event - Drop event
   * @param rowId - Target row id
   * @param colId - Target column id
   * @param zone - Drop zone within the target cell
   */ const handleScaffoldDrop = (event, rowId, colId, zone)=>{
        if (!disabled && state && state.scaffoldModel) {
            event.preventDefault();
            try {
                // Parse dropped data from the drag event
                const jsonPayload = JSON.parse(event.dataTransfer.getData("application/json"));
                // Validate the parsed data
                if (jsonPayload.data.every((0, $f4xry.isArsSidebarItemData))) {
                    const payload = jsonPayload.data;
                    // Check all payload items are the same kind
                    const firstKind = payload[0].kind;
                    if (!payload.every((item)=>item.kind === firstKind)) return;
                    // Get target cell data
                    const targetCell = state.scaffoldModel.cellData?.[rowId]?.[colId];
                    // Now we have enough information to create the action payload
                    if (targetCell) {
                        // Get the cell config for the target cell type
                        const cellConfig = (0, $g2mVC.cellActionConfig)(targetCell, state);
                        // Get the action for this zone & dropped data
                        const matchedDropAction = cellConfig?.dropActions.find((action)=>action.dropZones.has(zone) && action.droppedDataKinds.includes(firstKind));
                        if (matchedDropAction) dispatch({
                            operation: matchedDropAction.operation,
                            rowId: rowId,
                            columnId: colId,
                            payload: payload,
                            zone: zone
                        });
                    }
                }
            } catch  {
                return;
            }
        }
    };
    /**
   * Handles scaffold column resize updates.
   *
   * @param colId - Resized column id
   * @param col - Updated scaffold column definition
   */ const handleChangeCol = (colId, col)=>{
        if (!disabled) dispatch({
            operation: (0, $k9YO2.ARST_SET_SCAFFOLD_COL_WIDTH),
            colId: colId,
            width: col.width
        });
    };
    /**
   * Handles scaffold row resize updates.
   *
   * @param rowId - Resized row id
   * @param row - Updated scaffold row definition
   */ const handleChangeRow = (rowId, row)=>{
        if (!disabled) dispatch({
            operation: (0, $k9YO2.ARST_SET_SCAFFOLD_ROW_HEIGHT),
            rowId: rowId,
            height: row.height
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "d-flex flex-row",
                style: {
                    width: "100%",
                    minWidth: 0,
                    minHeight: "500px"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "flex-grow-1",
                    style: {
                        minWidth: 0
                    },
                    children: state.settings.tlfViewMode.value === "ARS_VIEW" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hTg9m.ArsTableTreeView), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jDDGB.ArsTableContextMenuProvider), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $h7u5p.Scaffold), {
                            id: `ars-table-scaffold-${state.settings.id}`,
                            cellComponent: (0, $5xg49.ArsTableCellEditorProps)(state.settings.editorProps),
                            cellData: scaffoldModel.cellData,
                            columns: scaffoldModel.columns,
                            disabled: disabled,
                            headerCellSpans: scaffoldModel.headerColSpans,
                            justification: justification,
                            onChangeCol: handleChangeCol,
                            onChangeRow: handleChangeRow,
                            onDrop: handleScaffoldDrop,
                            rows: scaffoldModel.rows,
                            style: state.settings.style,
                            zoneColors: zoneColors
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cVqbP.ArsTableItemProperties), {}),
            !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hGt3n.ArsDraggableSidebar), {
                onItemDragStart: (items)=>setDragItem(items.map((item)=>item.data)),
                onItemDragEnd: ()=>setDragItem(null),
                showGroupingFactors: true,
                showOperations: true,
                showTotalGroupingFactor: true,
                style: state.settings.sidebarStyle
            })
        ]
    });
};
$d2b808b211bb43f5$export$26fdf0e2e5a3507d.displayName = "ArsTableContent";

});
parcelRegister("e2uI9", function(module, exports) {
$parcel$export(module.exports, "ScaffoldDropZone", function () { return (parcelRequire("aLLqu")).ScaffoldDropZone; });
$parcel$export(module.exports, "Scaffold", function () { return (parcelRequire("h7u5p")).Scaffold; });
parcelRequire("fhV9o");
parcelRequire("dChVW");
parcelRequire("8yjow");
parcelRequire("aLLqu");
parcelRequire("h7u5p");
parcelRequire("kas1l");
parcelRequire("8N6BR");
parcelRequire("luXBI");
parcelRequire("6VOa0");
parcelRequire("dAej4");
parcelRequire("7sbB1");
parcelRequire("hQIFa");
parcelRequire("c5CXQ");

});
parcelRegister("fhV9o", function(module, exports) {

$parcel$export(module.exports, "computeHeaderSpanState", function () { return $310071ab43dd8cff$export$572859033bdbdb98; });
function $310071ab43dd8cff$export$572859033bdbdb98(rows, cols, spans, previewColWidths, previewRowHeights) {
    if (!spans) return {};
    const orderedCols = [
        ...cols
    ].sort((a, b)=>a.colNumber - b.colNumber);
    /** Rows grouped by rowGroupNumber, each group sorted by rowNumber. */ const rowsByGroup = rows.reduce((acc, row)=>{
        if (!acc[row.rowGroupNumber]) acc[row.rowGroupNumber] = [];
        acc[row.rowGroupNumber].push(row);
        return acc;
    }, {});
    for (const group of Object.values(rowsByGroup))group.sort((a, b)=>a.rowNumber - b.rowNumber);
    const result = {};
    /**
   * Stores cells that are covered by a spanning cell from the same row (colSpan) or a
   * previous row (rowSpan). Keyed as "rowId:colId".
   * Value "same-row" means col-span covered; "other-row" means row-span covered.
   */ const coveredCells = new Map();
    for (const row of rows){
        const rowSpanDefs = spans[row.id];
        if (!rowSpanDefs) continue;
        for (const col of orderedCols){
            const span = rowSpanDefs[col.id];
            if (!span) continue;
            const colSpan = span.colSpan ?? 1;
            const rowSpan = span.rowSpan ?? 1;
            if (colSpan <= 1 && rowSpan <= 1) continue;
            const colIndex = orderedCols.indexOf(col);
            /**
       * `rowsByGroup` is built from the same `rows` array we iterate over, so every
       * `row.rowGroupNumber` is guaranteed to be a key in the map.  The fallback is
       * unreachable but kept as a defensive default.
       */ const groupRows = rowsByGroup[row.rowGroupNumber] ?? // istanbul ignore next – rowsByGroup is populated from the same rows array, so the key always exists
            [];
            const rowIndex = groupRows.indexOf(row);
            /** Effective pixel width: sum of the spanned columns' widths. */ let effectiveWidth;
            if (colSpan > 1) {
                effectiveWidth = 0;
                for(let i = colIndex; i < Math.min(colIndex + colSpan, orderedCols.length); i++)effectiveWidth += previewColWidths[orderedCols[i].id] ?? orderedCols[i].width;
            }
            /** Effective pixel height: sum of the spanned rows' heights. */ let effectiveHeight;
            if (rowSpan > 1) {
                effectiveHeight = 0;
                for(let j = rowIndex; j < Math.min(rowIndex + rowSpan, groupRows.length); j++){
                    effectiveHeight += previewRowHeights[groupRows[j].id] ?? groupRows[j].height;
                    /** Mark cells in subsequent rows as covered (invisible placeholder). */ if (j > rowIndex) for(let k = colIndex; k < Math.min(colIndex + colSpan, orderedCols.length); k++){
                        const key = `${groupRows[j].id}:${orderedCols[k].id}`;
                        if (!coveredCells.has(key)) coveredCells.set(key, "other-row");
                    }
                }
            }
            /** Mark same-row cells absorbed by this colSpan as not-rendered. */ for(let k = colIndex + 1; k < Math.min(colIndex + colSpan, orderedCols.length); k++){
                const key = `${row.id}:${orderedCols[k].id}`;
                if (!coveredCells.has(key)) coveredCells.set(key, "same-row");
            }
            if (!result[row.id]) result[row.id] = {};
            result[row.id][col.id] = {
                mode: "spanning",
                effectiveWidth: effectiveWidth,
                effectiveHeight: effectiveHeight,
                hasRowSpan: rowSpan > 1
            };
        }
    }
    /** Write the covered-cell entries into the result map. */ for (const [cellKey, coverType] of coveredCells){
        const colonIndex = cellKey.indexOf(":");
        const rowId = cellKey.slice(0, colonIndex);
        const colId = cellKey.slice(colonIndex + 1);
        if (!result[rowId]) result[rowId] = {};
        result[rowId][colId] = {
            mode: coverType === "same-row" ? "covered-same-row" : "covered-other-row",
            hasRowSpan: false
        };
    }
    return result;
}

});

parcelRegister("dChVW", function(module, exports) {
$parcel$export(module.exports, "addCellRangeToSelection", function () { return (parcelRequire("7c5UX")).addCellRangeToSelection; });
$parcel$export(module.exports, "addColRangeToSelection", function () { return (parcelRequire("hwdab")).addColRangeToSelection; });
$parcel$export(module.exports, "addRowRangeToSelection", function () { return (parcelRequire("logA9")).addRowRangeToSelection; });
$parcel$export(module.exports, "hasAnySelection", function () { return (parcelRequire("7BSQK")).hasAnySelection; });
$parcel$export(module.exports, "isCellHighlighted", function () { return (parcelRequire("3H15F")).isCellHighlighted; });
$parcel$export(module.exports, "isColInSelection", function () { return (parcelRequire("1SQWM")).isColInSelection; });
$parcel$export(module.exports, "isRowInSelection", function () { return (parcelRequire("ehtXd")).isRowInSelection; });
$parcel$export(module.exports, "setCellRangeSelection", function () { return (parcelRequire("hxDzv")).setCellRangeSelection; });
$parcel$export(module.exports, "setColRangeSelection", function () { return (parcelRequire("3H2xR")).setColRangeSelection; });
$parcel$export(module.exports, "setRowRangeSelection", function () { return (parcelRequire("kv7Xn")).setRowRangeSelection; });
$parcel$export(module.exports, "toggleCellInSelection", function () { return (parcelRequire("5YsY0")).toggleCellInSelection; });
$parcel$export(module.exports, "toggleColInSelection", function () { return (parcelRequire("g4iIk")).toggleColInSelection; });
$parcel$export(module.exports, "toggleRowInSelection", function () { return (parcelRequire("9gU4v")).toggleRowInSelection; });
parcelRequire("7c5UX");
parcelRequire("hwdab");
parcelRequire("logA9");
parcelRequire("hcXl0");
parcelRequire("7BSQK");
parcelRequire("3H15F");
parcelRequire("4u2zc");
parcelRequire("1SQWM");
parcelRequire("ehtXd");
parcelRequire("hxDzv");
parcelRequire("3H2xR");
parcelRequire("kv7Xn");
parcelRequire("5YsY0");
parcelRequire("g4iIk");
parcelRequire("9gU4v");
parcelRequire("50c2b");

});
parcelRegister("7c5UX", function(module, exports) {

$parcel$export(module.exports, "addCellRangeToSelection", function () { return $e26294cd9e5f5cc9$export$53257f033e096296; });

var $hIs6M = parcelRequire("hIs6M");
const $e26294cd9e5f5cc9$export$53257f033e096296 = (selection, rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>{
    const rangeItems = (0, $hIs6M.buildCellRange)(rows, cols, anchorRowId, anchorColId, targetRowId, targetColId);
    const colIdsByRow = new Map();
    for (const item of selection.selectedCells)colIdsByRow.set(item.rowId, new Set(item.colId));
    for (const rangeRow of rangeItems){
        const existing = colIdsByRow.get(rangeRow.rowId);
        if (existing) rangeRow.colId.forEach((c)=>existing.add(c));
        else colIdsByRow.set(rangeRow.rowId, new Set(rangeRow.colId));
    }
    const merged = Array.from(colIdsByRow.entries()).map(([rowId, colIdSet])=>({
            rowId: rowId,
            colId: Array.from(colIdSet)
        }));
    return {
        ...selection,
        selectedCells: merged
    };
};

});
parcelRegister("hIs6M", function(module, exports) {

$parcel$export(module.exports, "buildCellRange", function () { return $3e2274253db77fa4$export$32cb3a3235922788; });
const $3e2274253db77fa4$export$32cb3a3235922788 = (rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>{
    const anchorRow = rows.find((r)=>r.id === anchorRowId);
    const targetRow = rows.find((r)=>r.id === targetRowId);
    const anchorCol = cols.find((c)=>c.id === anchorColId);
    const targetCol = cols.find((c)=>c.id === targetColId);
    if (!anchorRow || !targetRow || !anchorCol || !targetCol) return [];
    const minRowNum = Math.min(anchorRow.rowNumber, targetRow.rowNumber);
    const maxRowNum = Math.max(anchorRow.rowNumber, targetRow.rowNumber);
    const minColNum = Math.min(anchorCol.colNumber, targetCol.colNumber);
    const maxColNum = Math.max(anchorCol.colNumber, targetCol.colNumber);
    const rangeRows = rows.filter((r)=>r.rowNumber >= minRowNum && r.rowNumber <= maxRowNum);
    const rangeCols = cols.filter((c)=>c.colNumber >= minColNum && c.colNumber <= maxColNum);
    return rangeRows.map((r)=>({
            rowId: r.id,
            colId: rangeCols.map((c)=>c.id)
        }));
};

});


parcelRegister("hwdab", function(module, exports) {

$parcel$export(module.exports, "addColRangeToSelection", function () { return $732ceba5f787b187$export$5135606fbaabac99; });

var $6Xu2J = parcelRequire("6Xu2J");
const $732ceba5f787b187$export$5135606fbaabac99 = (selection, cols, anchorColId, targetColId)=>{
    const rangeItems = (0, $6Xu2J.buildColRange)(cols, anchorColId, targetColId);
    const existingIds = new Set(selection.selectedCols.map((c)=>c.firstCellId));
    const newItems = rangeItems.filter((c)=>!existingIds.has(c.firstCellId));
    return {
        ...selection,
        selectedCols: [
            ...selection.selectedCols,
            ...newItems
        ]
    };
};

});
parcelRegister("6Xu2J", function(module, exports) {

$parcel$export(module.exports, "buildColRange", function () { return $ea29876b034efca3$export$1c4606c9f13cde10; });
const $ea29876b034efca3$export$1c4606c9f13cde10 = (cols, anchorColId, targetColId)=>{
    const anchorCol = cols.find((c)=>c.id === anchorColId);
    const targetCol = cols.find((c)=>c.id === targetColId);
    if (!anchorCol || !targetCol) return [];
    const minColNum = Math.min(anchorCol.colNumber, targetCol.colNumber);
    const maxColNum = Math.max(anchorCol.colNumber, targetCol.colNumber);
    return cols.filter((c)=>c.colNumber >= minColNum && c.colNumber <= maxColNum).map((c)=>({
            firstCellId: c.id
        }));
};

});


parcelRegister("logA9", function(module, exports) {

$parcel$export(module.exports, "addRowRangeToSelection", function () { return $687de1c87e57e535$export$170aeaa87a3eaf97; });

var $k7ReC = parcelRequire("k7ReC");
const $687de1c87e57e535$export$170aeaa87a3eaf97 = (selection, rows, anchorRowId, targetRowId)=>{
    const rangeItems = (0, $k7ReC.buildRowRange)(rows, anchorRowId, targetRowId);
    const existingIds = new Set(selection.selectedRows.map((r)=>r.firstCellId));
    const newItems = rangeItems.filter((r)=>!existingIds.has(r.firstCellId));
    return {
        ...selection,
        selectedRows: [
            ...selection.selectedRows,
            ...newItems
        ]
    };
};

});
parcelRegister("k7ReC", function(module, exports) {

$parcel$export(module.exports, "buildRowRange", function () { return $74debe0967a9c809$export$5193858f270a72a7; });
const $74debe0967a9c809$export$5193858f270a72a7 = (rows, anchorRowId, targetRowId)=>{
    const anchorRow = rows.find((r)=>r.id === anchorRowId);
    const targetRow = rows.find((r)=>r.id === targetRowId);
    if (!anchorRow || !targetRow) return [];
    const minRowNum = Math.min(anchorRow.rowNumber, targetRow.rowNumber);
    const maxRowNum = Math.max(anchorRow.rowNumber, targetRow.rowNumber);
    return rows.filter((r)=>r.rowNumber >= minRowNum && r.rowNumber <= maxRowNum).map((r)=>({
            firstCellId: r.id
        }));
};

});


parcelRegister("hcXl0", function(module, exports) {

$parcel$export(module.exports, "addSelectedCell", function () { return $d7bc9b5a6180d4c2$export$a58c5a182741e394; });
/**
 * Adds a selected cell into a row-indexed map used to build selectedCells arrays.
 *
 * @param selectedCellMap - Mutable map of row IDs to selected column ID sets.
 * @param rowId - Row ID for the cell.
 * @param colId - Column ID for the cell.
 */ const $d7bc9b5a6180d4c2$export$a58c5a182741e394 = (selectedCellMap, rowId, colId)=>{
    const rowCols = selectedCellMap.get(rowId) ?? new Set();
    rowCols.add(colId);
    selectedCellMap.set(rowId, rowCols);
};

});

parcelRegister("7BSQK", function(module, exports) {

$parcel$export(module.exports, "hasAnySelection", function () { return $a8449ad443297dcf$export$ec980a602e9ab582; });
const $a8449ad443297dcf$export$ec980a602e9ab582 = (selection)=>selection.selectedCells.length > 0 || selection.selectedRows.length > 0 || selection.selectedCols.length > 0;

});

parcelRegister("3H15F", function(module, exports) {

$parcel$export(module.exports, "isCellHighlighted", function () { return $161048fef8c8187b$export$dc55bf97786b2f87; });

var $4u2zc = parcelRequire("4u2zc");

var $1SQWM = parcelRequire("1SQWM");

var $ehtXd = parcelRequire("ehtXd");
const $161048fef8c8187b$export$dc55bf97786b2f87 = (selection, rowId, colId)=>(0, $4u2zc.isCellInSelection)(selection, rowId, colId) || (0, $ehtXd.isRowInSelection)(selection, rowId) || (0, $1SQWM.isColInSelection)(selection, colId);

});
parcelRegister("4u2zc", function(module, exports) {

$parcel$export(module.exports, "isCellInSelection", function () { return $b8d6c093b951384b$export$d8be2823b9effa13; });
const $b8d6c093b951384b$export$d8be2823b9effa13 = (selection, rowId, colId)=>selection.selectedCells.some((r)=>r.rowId === rowId && r.colId.some((selectedColId)=>selectedColId === colId));

});

parcelRegister("1SQWM", function(module, exports) {

$parcel$export(module.exports, "isColInSelection", function () { return $8bb335379259d663$export$f3465d08b8694844; });
const $8bb335379259d663$export$f3465d08b8694844 = (selection, colId)=>selection.selectedCols.some((c)=>c.firstCellId === colId);

});

parcelRegister("ehtXd", function(module, exports) {

$parcel$export(module.exports, "isRowInSelection", function () { return $d9fad66c3d443a3b$export$54f247f36fd0f222; });
const $d9fad66c3d443a3b$export$54f247f36fd0f222 = (selection, rowId)=>selection.selectedRows.some((r)=>r.firstCellId === rowId);

});


parcelRegister("hxDzv", function(module, exports) {

$parcel$export(module.exports, "setCellRangeSelection", function () { return $a4ccde100187c0b9$export$e84f3d196fb0aaa8; });

var $aLLqu = parcelRequire("aLLqu");

var $hIs6M = parcelRequire("hIs6M");
const $a4ccde100187c0b9$export$e84f3d196fb0aaa8 = (rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)=>({
        ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
        selectedCells: (0, $hIs6M.buildCellRange)(rows, cols, anchorRowId, anchorColId, targetRowId, targetColId)
    });

});
parcelRegister("aLLqu", function(module, exports) {

$parcel$export(module.exports, "ScaffoldDropZone", function () { return $c7899a65be357525$export$54f682ad17b9257d; });
$parcel$export(module.exports, "ZONE_GRID_ORDER", function () { return $c7899a65be357525$export$50b5cb74f7905444; });
$parcel$export(module.exports, "HORIZONTAL_SIDE_ZONES", function () { return $c7899a65be357525$export$dae00fd59d927e43; });
$parcel$export(module.exports, "VERTICAL_SIDE_ZONES", function () { return $c7899a65be357525$export$c797460f28ae5418; });
$parcel$export(module.exports, "SCAFFOLD_ZONE_GRID_BOUNDS", function () { return $c7899a65be357525$export$416249cdd7a6641c; });
$parcel$export(module.exports, "DEFAULT_SCAFFOLD_ZONE_COLORS", function () { return $c7899a65be357525$export$798b07a71ab66d07; });
$parcel$export(module.exports, "MIN_SCAFFOLD_COL_WIDTH_PX", function () { return $c7899a65be357525$export$98e57f844c986948; });
$parcel$export(module.exports, "MIN_SCAFFOLD_ROW_HEIGHT_PX", function () { return $c7899a65be357525$export$9496fe9da1ae70f8; });
$parcel$export(module.exports, "SCAFFOLD_ANIMATION_DURATION_MS", function () { return $c7899a65be357525$export$fc1a1e82e02399ea; });
$parcel$export(module.exports, "SCAFFOLD_ANIMATION_START_DELAY_MS", function () { return $c7899a65be357525$export$cb496f56a9ae9cb; });
$parcel$export(module.exports, "SIDE_ZONE_SIZE", function () { return $c7899a65be357525$export$4b4867e05e0827b; });
$parcel$export(module.exports, "SIDE_ZONE_MIN_SIZE", function () { return $c7899a65be357525$export$6001d82b46aba704; });
$parcel$export(module.exports, "EMPTY_SCAFFOLD_SELECTION", function () { return $c7899a65be357525$export$6a055c40c2b95347; });
$parcel$export(module.exports, "SCAFFOLD_SELECT_HANDLE_SIZE_PX", function () { return $c7899a65be357525$export$b24452eaa684ddeb; });
var $c7899a65be357525$export$54f682ad17b9257d = /*#__PURE__*/ function(ScaffoldDropZone) {
    ScaffoldDropZone["TopLeft"] = "TL";
    ScaffoldDropZone["TopEdgeLeft"] = "TEL";
    ScaffoldDropZone["TopEdgeRight"] = "TER";
    ScaffoldDropZone["TopRight"] = "TR";
    ScaffoldDropZone["LeftEdgeTop"] = "LET";
    ScaffoldDropZone["CentreTopLeft"] = "CTL";
    ScaffoldDropZone["CentreTopRight"] = "CTR";
    ScaffoldDropZone["RightEdgeTop"] = "RET";
    ScaffoldDropZone["LeftEdgeBottom"] = "LEB";
    ScaffoldDropZone["CentreBottomLeft"] = "CBL";
    ScaffoldDropZone["CentreBottomRight"] = "CBR";
    ScaffoldDropZone["RightEdgeBottom"] = "REB";
    ScaffoldDropZone["BottomLeft"] = "BL";
    ScaffoldDropZone["BottomEdgeLeft"] = "BEL";
    ScaffoldDropZone["BottomEdgeRight"] = "BER";
    ScaffoldDropZone["BottomRight"] = "BR";
    return ScaffoldDropZone;
}({});
const $c7899a65be357525$export$50b5cb74f7905444 = [
    "TL",
    "TEL",
    "TER",
    "TR",
    "LET",
    "CTL",
    "CTR",
    "RET",
    "LEB",
    "CBL",
    "CBR",
    "REB",
    "BL",
    "BEL",
    "BER",
    "BR"
];
const $c7899a65be357525$export$dae00fd59d927e43 = new Set([
    "TL",
    "LET",
    "LEB",
    "BL",
    "TR",
    "RET",
    "REB",
    "BR"
]);
const $c7899a65be357525$export$c797460f28ae5418 = new Set([
    "TL",
    "TEL",
    "TER",
    "TR",
    "BL",
    "BEL",
    "BER",
    "BR"
]);
const $c7899a65be357525$export$416249cdd7a6641c = {
    ["TL"]: {
        top: 1,
        bottom: 2,
        left: 1,
        right: 2
    },
    ["TEL"]: {
        top: 1,
        bottom: 2,
        left: 2,
        right: 3
    },
    ["TER"]: {
        top: 1,
        bottom: 2,
        left: 3,
        right: 4
    },
    ["TR"]: {
        top: 1,
        bottom: 2,
        left: 4,
        right: 5
    },
    ["LET"]: {
        top: 2,
        bottom: 3,
        left: 1,
        right: 2
    },
    ["CTL"]: {
        top: 2,
        bottom: 3,
        left: 2,
        right: 3
    },
    ["CTR"]: {
        top: 2,
        bottom: 3,
        left: 3,
        right: 4
    },
    ["RET"]: {
        top: 2,
        bottom: 3,
        left: 4,
        right: 5
    },
    ["LEB"]: {
        top: 3,
        bottom: 4,
        left: 1,
        right: 2
    },
    ["CBL"]: {
        top: 3,
        bottom: 4,
        left: 2,
        right: 3
    },
    ["CBR"]: {
        top: 3,
        bottom: 4,
        left: 3,
        right: 4
    },
    ["REB"]: {
        top: 3,
        bottom: 4,
        left: 4,
        right: 5
    },
    ["BL"]: {
        top: 4,
        bottom: 5,
        left: 1,
        right: 2
    },
    ["BEL"]: {
        top: 4,
        bottom: 5,
        left: 2,
        right: 3
    },
    ["BER"]: {
        top: 4,
        bottom: 5,
        left: 3,
        right: 4
    },
    ["BR"]: {
        top: 4,
        bottom: 5,
        left: 4,
        right: 5
    }
};
const $c7899a65be357525$export$798b07a71ab66d07 = {
    ["TL"]: "#ff6b6b",
    ["TEL"]: "#ff9999",
    ["TER"]: "#ff9999",
    ["TR"]: "#ff6b6b",
    ["LET"]: "#ff9999",
    ["CTL"]: "#4dabf7",
    ["CTR"]: "#4dabf7",
    ["RET"]: "#ff9999",
    ["LEB"]: "#ff9999",
    ["CBL"]: "#4dabf7",
    ["CBR"]: "#4dabf7",
    ["REB"]: "#ff9999",
    ["BL"]: "#ff6b6b",
    ["BEL"]: "#ff9999",
    ["BER"]: "#ff9999",
    ["BR"]: "#ff6b6b"
};
const $c7899a65be357525$export$98e57f844c986948 = 8;
const $c7899a65be357525$export$9496fe9da1ae70f8 = 8;
const $c7899a65be357525$export$fc1a1e82e02399ea = 200;
const $c7899a65be357525$export$cb496f56a9ae9cb = 5;
const $c7899a65be357525$export$4b4867e05e0827b = 11;
const $c7899a65be357525$export$6001d82b46aba704 = $c7899a65be357525$export$4b4867e05e0827b * 2 + 2;
const $c7899a65be357525$export$6a055c40c2b95347 = {
    selectedCells: [],
    selectedRows: [],
    selectedCols: []
};
const $c7899a65be357525$export$b24452eaa684ddeb = 12;

});


parcelRegister("3H2xR", function(module, exports) {

$parcel$export(module.exports, "setColRangeSelection", function () { return $8631c4b46c8e19cf$export$ff67db96b671f950; });

var $aLLqu = parcelRequire("aLLqu");

var $6Xu2J = parcelRequire("6Xu2J");
const $8631c4b46c8e19cf$export$ff67db96b671f950 = (cols, anchorColId, targetColId)=>({
        ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
        selectedCols: (0, $6Xu2J.buildColRange)(cols, anchorColId, targetColId)
    });

});

parcelRegister("kv7Xn", function(module, exports) {

$parcel$export(module.exports, "setRowRangeSelection", function () { return $231d7db971b0a15c$export$bc043024ab74f0e7; });

var $aLLqu = parcelRequire("aLLqu");

var $k7ReC = parcelRequire("k7ReC");
const $231d7db971b0a15c$export$bc043024ab74f0e7 = (rows, anchorRowId, targetRowId)=>({
        ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
        selectedRows: (0, $k7ReC.buildRowRange)(rows, anchorRowId, targetRowId)
    });

});

parcelRegister("5YsY0", function(module, exports) {

$parcel$export(module.exports, "toggleCellInSelection", function () { return $349d03ee56820353$export$9e443a4ca015dc8e; });

var $hcXl0 = parcelRequire("hcXl0");

var $4u2zc = parcelRequire("4u2zc");

var $1SQWM = parcelRequire("1SQWM");

var $ehtXd = parcelRequire("ehtXd");

var $50c2b = parcelRequire("50c2b");
const $349d03ee56820353$export$9e443a4ca015dc8e = (selection, prevRows, prevCols, rowId, colId)=>{
    if ((0, $4u2zc.isCellInSelection)(selection, rowId, colId)) {
        const newSelectedCells = selection.selectedCells.map((r)=>r.rowId === rowId ? {
                ...r,
                colId: r.colId.filter((c)=>c !== colId)
            } : r).filter((r)=>r.colId.length > 0);
        return {
            ...selection,
            selectedCells: newSelectedCells
        };
    }
    const rowSelected = (0, $ehtXd.isRowInSelection)(selection, rowId);
    const colSelected = (0, $1SQWM.isColInSelection)(selection, colId);
    if (rowSelected || colSelected) {
        const selectedCellMap = new Map();
        selection.selectedCells.forEach((selectedRow)=>{
            selectedRow.colId.forEach((selectedColId)=>{
                (0, $hcXl0.addSelectedCell)(selectedCellMap, selectedRow.rowId, selectedColId);
            });
        });
        if (rowSelected) prevCols.forEach((col)=>{
            if (col.id !== colId) (0, $hcXl0.addSelectedCell)(selectedCellMap, rowId, col.id);
        });
        if (colSelected) prevRows.forEach((row)=>{
            if (row.id !== rowId) (0, $hcXl0.addSelectedCell)(selectedCellMap, row.id, colId);
        });
        selectedCellMap.get(rowId)?.delete(colId);
        return {
            ...selection,
            selectedCells: (0, $50c2b.toSelectedCells)(selectedCellMap, prevRows, prevCols),
            selectedRows: rowSelected ? selection.selectedRows.filter((selectedRow)=>selectedRow.firstCellId !== rowId) : selection.selectedRows,
            selectedCols: colSelected ? selection.selectedCols.filter((selectedCol)=>selectedCol.firstCellId !== colId) : selection.selectedCols
        };
    }
    const existingRow = selection.selectedCells.find((r)=>r.rowId === rowId);
    if (existingRow) return {
        ...selection,
        selectedCells: selection.selectedCells.map((r)=>r.rowId === rowId ? {
                ...r,
                colId: [
                    ...r.colId,
                    colId
                ]
            } : r)
    };
    return {
        ...selection,
        selectedCells: [
            ...selection.selectedCells,
            {
                rowId: rowId,
                colId: [
                    colId
                ]
            }
        ]
    };
};

});
parcelRegister("50c2b", function(module, exports) {

$parcel$export(module.exports, "toSelectedCells", function () { return $78d31de066c8bae4$export$b242ca1596b7c393; });
const $78d31de066c8bae4$export$b242ca1596b7c393 = (selectedCellMap, prevRows, prevCols)=>{
    const rowOrder = prevRows.map((row)=>row.id);
    const colOrder = prevCols.map((col)=>col.id);
    const remainingRows = Array.from(selectedCellMap.keys()).filter((rowId)=>!rowOrder.includes(rowId));
    const orderedRowIds = [
        ...rowOrder,
        ...remainingRows
    ];
    return orderedRowIds.map((orderedRowId)=>{
        const cols = selectedCellMap.get(orderedRowId);
        if (!cols || cols.size === 0) return null;
        const remainingCols = Array.from(cols).filter((currentColId)=>!colOrder.includes(currentColId));
        const orderedColIds = [
            ...colOrder.filter((currentColId)=>cols.has(currentColId)),
            ...remainingCols
        ];
        return {
            rowId: orderedRowId,
            colId: orderedColIds
        };
    }).filter((selectedRow)=>selectedRow !== null);
};

});


parcelRegister("g4iIk", function(module, exports) {

$parcel$export(module.exports, "toggleColInSelection", function () { return $39596ea19f92f0d7$export$9185b7ffb76520e5; });

var $1SQWM = parcelRequire("1SQWM");
const $39596ea19f92f0d7$export$9185b7ffb76520e5 = (selection, colId)=>{
    if ((0, $1SQWM.isColInSelection)(selection, colId)) return {
        ...selection,
        selectedCols: selection.selectedCols.filter((c)=>c.firstCellId !== colId)
    };
    return {
        ...selection,
        selectedCols: [
            ...selection.selectedCols,
            {
                firstCellId: colId
            }
        ]
    };
};

});

parcelRegister("9gU4v", function(module, exports) {

$parcel$export(module.exports, "toggleRowInSelection", function () { return $807dbf1a18e5f76f$export$d14b6cbc81a35dc0; });

var $ehtXd = parcelRequire("ehtXd");
const $807dbf1a18e5f76f$export$d14b6cbc81a35dc0 = (selection, rowId)=>{
    if ((0, $ehtXd.isRowInSelection)(selection, rowId)) return {
        ...selection,
        selectedRows: selection.selectedRows.filter((r)=>r.firstCellId !== rowId)
    };
    return {
        ...selection,
        selectedRows: [
            ...selection.selectedRows,
            {
                firstCellId: rowId
            }
        ]
    };
};

});


parcelRegister("8yjow", function(module, exports) {

$parcel$export(module.exports, "getScaffoldContextMenuTarget", function () { return $6ff930e0d264f966$export$797de89932b1ad68; });
/**
 * The row and column ids resolved from a context menu event target.
 */ const $6ff930e0d264f966$export$797de89932b1ad68 = (target)=>{
    if (target instanceof Element) {
        const scaffoldCell = target.closest("[data-scaffold-col-id]");
        const colId = scaffoldCell?.getAttribute("data-scaffold-col-id");
        const rowId = scaffoldCell?.getAttribute("data-scaffold-row-id");
        if (colId && rowId) return {
            colId: colId,
            rowId: rowId
        };
    }
    return undefined;
};

});

parcelRegister("h7u5p", function(module, exports) {

$parcel$export(module.exports, "Scaffold", function () { return $848d8ebb3ae8ad5a$export$e460bf4b68e36254; });
$parcel$export(module.exports, "useScaffold", function () { return $848d8ebb3ae8ad5a$export$5746fe70af142290; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $fhV9o = parcelRequire("fhV9o");

var $7bbQp = parcelRequire("7bbQp");

var $lqrMK = parcelRequire("lqrMK");

var $aLLqu = parcelRequire("aLLqu");

var $feiaX = parcelRequire("feiaX");

var $f91EO = parcelRequire("f91EO");

var $8N6BR = parcelRequire("8N6BR");

var $luXBI = parcelRequire("luXBI");

var $dAej4 = parcelRequire("dAej4");
const $848d8ebb3ae8ad5a$export$3c94731494ab08e8 = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $848d8ebb3ae8ad5a$export$e460bf4b68e36254 = (props)=>{
    const [state, dispatch] = (0, $spJKX.useReducer)((s, a)=>(0, $lqrMK.scaffoldReducer)(s, a), undefined, ()=>({
            prevCols: props.columns,
            prevRows: props.rows,
            enteringColIds: new Set(),
            enteringRowIds: new Set(),
            leavingCols: [],
            leavingRows: [],
            isDragging: false,
            previewColWidths: {},
            previewRowHeights: {},
            selection: props.selection ?? (0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
            selectionAnchor: null
        }));
    const tableWrapperRef = (0, $spJKX.useRef)(null);
    const prevSelectionPropRef = (0, $spJKX.useRef)(props.selection);
    const handleDragStart = (0, $spJKX.useEffectEvent)(()=>dispatch({
            operation: (0, $7bbQp.SET_DRAGGING),
            isDragging: true
        }));
    const handleDragEnd = (0, $spJKX.useEffectEvent)(()=>dispatch({
            operation: (0, $7bbQp.SET_DRAGGING),
            isDragging: false
        }));
    const handleClickOutside = (0, $spJKX.useEffectEvent)((event)=>{
        if (tableWrapperRef.current && !tableWrapperRef.current.contains(event.target) && props.onSelectionChange) dispatch({
            operation: (0, $7bbQp.CLICK_OUTSIDE)
        });
    });
    (0, $spJKX.useEffect)(()=>{
        document.addEventListener("dragstart", handleDragStart);
        document.addEventListener("dragend", handleDragEnd);
        return ()=>{
            document.removeEventListener("dragstart", handleDragStart);
            document.removeEventListener("dragend", handleDragEnd);
        };
    }, []);
    (0, $spJKX.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    // These are outside a useEffect for animation purposes
    if ((0, $feiaX.reconcileScaffoldItems)(props.columns, state.prevCols, state.leavingCols).hasChanged) dispatch({
        operation: (0, $7bbQp.COLS_CHANGED),
        cols: props.columns
    });
    if ((0, $feiaX.reconcileScaffoldItems)(props.rows, state.prevRows, state.leavingRows).hasChanged) dispatch({
        operation: (0, $7bbQp.ROWS_CHANGED),
        rows: props.rows
    });
    const onSelectionChangeRef = (0, $spJKX.useRef)(props.onSelectionChange);
    (0, $spJKX.useLayoutEffect)(()=>{
        onSelectionChangeRef.current = props.onSelectionChange;
    });
    (0, $spJKX.useLayoutEffect)(()=>{
        if (props.selection !== undefined && !(0, $eBlbF.isEqual)(props.selection, prevSelectionPropRef.current)) {
            prevSelectionPropRef.current = props.selection;
            dispatch({
                operation: (0, $7bbQp.SELECTION_CHANGED),
                selection: props.selection
            });
        }
    }, [
        props.selection
    ]);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (!(0, $eBlbF.isEqual)(state.selection, props.selection ?? (0, $aLLqu.EMPTY_SCAFFOLD_SELECTION))) {
            onSelectionChangeRef.current?.(state.selection);
            prevSelectionPropRef.current = state.selection;
        }
    }, [
        state.selection,
        props.selection
    ]);
    /**
   * Prevents browser text selection on shift+mousedown when cell selection is already active.
   * This keeps shift+click range selection focused on scaffold behaviour instead of selecting text.
   *
   * @param event - Mouse event raised while pressing on the scaffold.
   */ const onTableMouseDownCapture = (event)=>{
        const hasActiveCellSelection = state.selection.selectedCells.length > 0;
        if (event.shiftKey && hasActiveCellSelection) event.preventDefault();
    };
    const scaffoldContextValue = {
        dispatch: dispatch,
        state: state,
        settings: {
            id: props.id,
            cellComponent: props.cellComponent,
            cellData: props.cellData,
            columns: props.columns,
            rows: props.rows,
            disabled: props.disabled,
            justification: props.justification,
            zoneColors: props.zoneColors ?? (0, $aLLqu.DEFAULT_SCAFFOLD_ZONE_COLORS),
            onChangeCol: props.onChangeCol,
            onChangeRow: props.onChangeRow,
            onChangeCell: props.onChangeCell,
            onDrop: props.onDrop,
            onSelectionChange: props.onSelectionChange,
            headerCellSpans: props.headerCellSpans
        },
        headerSpanMap: props.headerCellSpans !== undefined ? (0, $fhV9o.computeHeaderSpanState)(props.rows, props.columns, props.headerCellSpans, state.previewColWidths, state.previewRowHeights) : undefined
    };
    const orderedCols = [
        ...props.columns
    ].sort((a, b)=>a.colNumber - b.colNumber);
    const shouldRenderSelectionHandles = props.onSelectionChange !== undefined;
    let nextSelectLeft = 0;
    const colSelectLayout = orderedCols.map((col)=>{
        const colLeft = nextSelectLeft;
        const colWidth = state.previewColWidths[col.id] ?? col.width;
        nextSelectLeft += colWidth;
        return {
            colId: col.id,
            left: colLeft,
            width: colWidth
        };
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)($848d8ebb3ae8ad5a$export$3c94731494ab08e8.Provider, {
        value: scaffoldContextValue,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).tableWrapper,
            onMouseDownCapture: onTableMouseDownCapture,
            ref: tableWrapperRef,
            style: props.style,
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).table,
                id: props.id,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dAej4.ScaffoldRowGroups), {}),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).colResizeOverlay,
                        children: [
                            shouldRenderSelectionHandles && colSelectLayout.map((colSelect)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $luXBI.ScaffoldColSelectHandle), {
                                    colId: colSelect.colId,
                                    left: colSelect.left,
                                    width: colSelect.width
                                }, `col-select-handle-${colSelect.colId}`)),
                            orderedCols.filter((oc)=>!oc.noResize).map((oc, ix, arr)=>{
                                let id = oc.id;
                                // istanbul ignore next - added for debugging bad data
                                if (arr.findIndex((col)=>col.id === oc.id) !== ix) {
                                    console.warn("Having to reassign colId for resize handle due to non-unique column IDs:", oc.id);
                                    id = `${oc.id}-${ix}`;
                                }
                                return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8N6BR.ScaffoldColResizeHandle), {
                                    colId: oc.id
                                }, `col-resize-handle-${id}`);
                            })
                        ]
                    })
                ]
            })
        })
    });
};
$848d8ebb3ae8ad5a$export$e460bf4b68e36254.displayName = "Scaffold";
const $848d8ebb3ae8ad5a$export$5746fe70af142290 = ()=>{
    const context = (0, $spJKX.useContext)($848d8ebb3ae8ad5a$export$3c94731494ab08e8);
    if (!context) throw new Error("useScaffold must be used within a ScaffoldContext provider");
    return context;
};

});
parcelRegister("7bbQp", function(module, exports) {

$parcel$export(module.exports, "SET_DRAGGING", function () { return $22e2dda0e30bd0e7$export$e890ace773f2db9; });
$parcel$export(module.exports, "COLS_CHANGED", function () { return $22e2dda0e30bd0e7$export$be358cce7c15e51e; });
$parcel$export(module.exports, "ROWS_CHANGED", function () { return $22e2dda0e30bd0e7$export$2de7ede39bdbf015; });
$parcel$export(module.exports, "COL_LEAVE_COMPLETE", function () { return $22e2dda0e30bd0e7$export$54793146d18d1169; });
$parcel$export(module.exports, "COL_ENTER_COMPLETE", function () { return $22e2dda0e30bd0e7$export$5e210e20e021e0e3; });
$parcel$export(module.exports, "ROW_LEAVE_COMPLETE", function () { return $22e2dda0e30bd0e7$export$23dc4d35ed125193; });
$parcel$export(module.exports, "ROW_ENTER_COMPLETE", function () { return $22e2dda0e30bd0e7$export$96bf00166c391748; });
$parcel$export(module.exports, "PREVIEW_COL_WIDTH_CHANGE", function () { return $22e2dda0e30bd0e7$export$76f33e721b9a3a40; });
$parcel$export(module.exports, "PREVIEW_ROW_HEIGHT_CHANGE", function () { return $22e2dda0e30bd0e7$export$cc62c6a7cb0da32f; });
$parcel$export(module.exports, "CELL_CLICKED", function () { return $22e2dda0e30bd0e7$export$d924b85e5b48c870; });
$parcel$export(module.exports, "ROW_CLICKED", function () { return $22e2dda0e30bd0e7$export$bbeb390aa40344d9; });
$parcel$export(module.exports, "COL_CLICKED", function () { return $22e2dda0e30bd0e7$export$2cbb51811aa951a1; });
$parcel$export(module.exports, "CLICK_OUTSIDE", function () { return $22e2dda0e30bd0e7$export$75af710a6c1304e5; });
$parcel$export(module.exports, "SELECTION_CHANGED", function () { return $22e2dda0e30bd0e7$export$9b2609dade4b2e2a; });
const $22e2dda0e30bd0e7$export$e890ace773f2db9 = "SET_DRAGGING";
const $22e2dda0e30bd0e7$export$be358cce7c15e51e = "COLS_CHANGED";
const $22e2dda0e30bd0e7$export$2de7ede39bdbf015 = "ROWS_CHANGED";
const $22e2dda0e30bd0e7$export$54793146d18d1169 = "COL_LEAVE_COMPLETE";
const $22e2dda0e30bd0e7$export$5e210e20e021e0e3 = "COL_ENTER_COMPLETE";
const $22e2dda0e30bd0e7$export$23dc4d35ed125193 = "ROW_LEAVE_COMPLETE";
const $22e2dda0e30bd0e7$export$96bf00166c391748 = "ROW_ENTER_COMPLETE";
const $22e2dda0e30bd0e7$export$76f33e721b9a3a40 = "PREVIEW_COL_WIDTH_CHANGE";
const $22e2dda0e30bd0e7$export$cc62c6a7cb0da32f = "PREVIEW_ROW_HEIGHT_CHANGE";
const $22e2dda0e30bd0e7$export$d924b85e5b48c870 = "CELL_CLICKED";
const $22e2dda0e30bd0e7$export$bbeb390aa40344d9 = "ROW_CLICKED";
const $22e2dda0e30bd0e7$export$2cbb51811aa951a1 = "COL_CLICKED";
const $22e2dda0e30bd0e7$export$75af710a6c1304e5 = "CLICK_OUTSIDE";
const $22e2dda0e30bd0e7$export$9b2609dade4b2e2a = "SELECTION_CHANGED";

});

parcelRegister("lqrMK", function(module, exports) {

$parcel$export(module.exports, "scaffoldReducer", function () { return $56938aa9b6a0a97d$export$55cbe0465d7cf493; });

var $7bbQp = parcelRequire("7bbQp");

var $6tj6f = parcelRequire("6tj6f");

var $5XiqE = parcelRequire("5XiqE");

var $f9OrT = parcelRequire("f9OrT");

var $18Kaj = parcelRequire("18Kaj");

var $kdcOL = parcelRequire("kdcOL");

var $8aalG = parcelRequire("8aalG");

var $8JMV0 = parcelRequire("8JMV0");

var $ihVPu = parcelRequire("ihVPu");

var $at85V = parcelRequire("at85V");

var $755IR = parcelRequire("755IR");

var $5qVE1 = parcelRequire("5qVE1");

var $gzwxv = parcelRequire("gzwxv");

var $hDj78 = parcelRequire("hDj78");

var $lSQmu = parcelRequire("lSQmu");
const $56938aa9b6a0a97d$export$55cbe0465d7cf493 = (state, action)=>{
    switch(action.operation){
        case 0, $7bbQp.SET_DRAGGING:
            return (0, $lSQmu.scr_setDragging)(action, state);
        case 0, $7bbQp.COLS_CHANGED:
            return (0, $8aalG.scr_colsChanged)(action, state);
        case 0, $7bbQp.ROWS_CHANGED:
            return (0, $gzwxv.scr_rowsChanged)(action, state);
        case 0, $7bbQp.COL_LEAVE_COMPLETE:
            return (0, $kdcOL.scr_colLeaveComplete)(action, state);
        case 0, $7bbQp.COL_ENTER_COMPLETE:
            return (0, $18Kaj.scr_colEnterComplete)(action, state);
        case 0, $7bbQp.ROW_LEAVE_COMPLETE:
            return (0, $5qVE1.scr_rowLeaveComplete)(action, state);
        case 0, $7bbQp.ROW_ENTER_COMPLETE:
            return (0, $755IR.scr_rowEnterComplete)(action, state);
        case 0, $7bbQp.PREVIEW_COL_WIDTH_CHANGE:
            return (0, $8JMV0.scr_previewColWidthChange)(action, state);
        case 0, $7bbQp.PREVIEW_ROW_HEIGHT_CHANGE:
            return (0, $ihVPu.scr_previewRowHeightChange)(action, state);
        case 0, $7bbQp.CELL_CLICKED:
            return (0, $6tj6f.scr_cellClicked)(action, state);
        case 0, $7bbQp.ROW_CLICKED:
            return (0, $at85V.scr_rowClicked)(action, state);
        case 0, $7bbQp.COL_CLICKED:
            return (0, $f9OrT.scr_colClicked)(action, state);
        case 0, $7bbQp.CLICK_OUTSIDE:
            return (0, $5XiqE.scr_clickOutside)(state);
        case 0, $7bbQp.SELECTION_CHANGED:
            return (0, $hDj78.scr_selectionChanged)(action, state);
    }
};

});
parcelRegister("6tj6f", function(module, exports) {

$parcel$export(module.exports, "scr_cellClicked", function () { return $8576f79af8f33d75$export$8a28a4f362790a4; });

var $aLLqu = parcelRequire("aLLqu");
parcelRequire("dChVW");
var $7c5UX = parcelRequire("7c5UX");
var $7BSQK = parcelRequire("7BSQK");
var $hxDzv = parcelRequire("hxDzv");
var $5YsY0 = parcelRequire("5YsY0");
const $8576f79af8f33d75$export$8a28a4f362790a4 = (action, state)=>{
    const { rowId: rowId, colId: colId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevRows: prevRows, prevCols: prevCols } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "cell") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $7c5UX.addCellRangeToSelection)(selection, prevRows, prevCols, selectionAnchor.rowId, selectionAnchor.colId, rowId, colId) : (0, $hxDzv.setCellRangeSelection)(prevRows, prevCols, selectionAnchor.rowId, selectionAnchor.colId, rowId, colId)
        };
        return {
            ...state,
            selection: {
                ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
                selectedCells: [
                    {
                        rowId: rowId,
                        colId: [
                            colId
                        ]
                    }
                ]
            },
            selectionAnchor: {
                type: "cell",
                rowId: rowId,
                colId: colId
            }
        };
    }
    if (ctrlKey || metaKey) return {
        ...state,
        selection: (0, $5YsY0.toggleCellInSelection)(selection, prevRows, prevCols, rowId, colId),
        selectionAnchor: {
            type: "cell",
            rowId: rowId,
            colId: colId
        }
    };
    if ((0, $7BSQK.hasAnySelection)(selection)) return {
        ...state,
        selection: (0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
        selectionAnchor: null
    };
    return state;
};

});

parcelRegister("5XiqE", function(module, exports) {

$parcel$export(module.exports, "scr_clickOutside", function () { return $ff634970c753cea9$export$8053598e85c798e4; });

var $aLLqu = parcelRequire("aLLqu");
parcelRequire("dChVW");
var $7BSQK = parcelRequire("7BSQK");
const $ff634970c753cea9$export$8053598e85c798e4 = (state)=>{
    if ((0, $7BSQK.hasAnySelection)(state.selection)) return {
        ...state,
        selection: (0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
        selectionAnchor: null
    };
    return state;
};

});

parcelRegister("f9OrT", function(module, exports) {

$parcel$export(module.exports, "scr_colClicked", function () { return $2b2dede1f07768aa$export$951dc268b55f27d8; });

var $aLLqu = parcelRequire("aLLqu");
parcelRequire("dChVW");
var $hwdab = parcelRequire("hwdab");
var $3H2xR = parcelRequire("3H2xR");
var $g4iIk = parcelRequire("g4iIk");
const $2b2dede1f07768aa$export$951dc268b55f27d8 = (action, state)=>{
    const { colId: colId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevCols: prevCols } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "col") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $hwdab.addColRangeToSelection)(selection, prevCols, selectionAnchor.colId, colId) : (0, $3H2xR.setColRangeSelection)(prevCols, selectionAnchor.colId, colId)
        };
        return {
            ...state,
            selection: {
                ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
                selectedCols: [
                    {
                        firstCellId: colId
                    }
                ]
            },
            selectionAnchor: {
                type: "col",
                colId: colId
            }
        };
    }
    return {
        ...state,
        selection: ctrlKey || metaKey ? (0, $g4iIk.toggleColInSelection)(selection, colId) : {
            ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
            selectedCols: [
                {
                    firstCellId: colId
                }
            ]
        },
        selectionAnchor: {
            type: "col",
            colId: colId
        }
    };
};

});

parcelRegister("18Kaj", function(module, exports) {

$parcel$export(module.exports, "scr_colEnterComplete", function () { return $726845a327c4591d$export$75ca774af0b5b6e7; });
const $726845a327c4591d$export$75ca774af0b5b6e7 = (action, state)=>{
    if (!state.enteringColIds.has(action.colId)) return state;
    const next = new Set(state.enteringColIds);
    next.delete(action.colId);
    return {
        ...state,
        enteringColIds: next
    };
};

});

parcelRegister("kdcOL", function(module, exports) {

$parcel$export(module.exports, "scr_colLeaveComplete", function () { return $cb28b67ef9c1067b$export$199b4ad1e2e17f2e; });
const $cb28b67ef9c1067b$export$199b4ad1e2e17f2e = (action, state)=>({
        ...state,
        leavingCols: state.leavingCols.filter((c)=>c.id !== action.colId)
    });

});

parcelRegister("8aalG", function(module, exports) {

$parcel$export(module.exports, "scr_colsChanged", function () { return $70739f8cb532e4cc$export$e8399f2559dbfa73; });

var $feiaX = parcelRequire("feiaX");
const $70739f8cb532e4cc$export$e8399f2559dbfa73 = (action, state)=>{
    const reconciliation = (0, $feiaX.reconcileScaffoldItems)(action.cols, state.prevCols, state.leavingCols);
    return !reconciliation.hasChanged ? state : {
        ...state,
        enteringColIds: reconciliation.enteringIds,
        leavingCols: reconciliation.nextLeavingItems,
        prevCols: action.cols
    };
};

});
parcelRegister("feiaX", function(module, exports) {

$parcel$export(module.exports, "reconcileScaffoldItems", function () { return $216501690ead45d9$export$991f8dffdded4e61; });
/**
 * Reconciliation result for scaffold collections such as rows and columns.
 */ const $216501690ead45d9$export$991f8dffdded4e61 = (currentItems, previousItems, leavingItems)=>{
    const currentItemIds = currentItems.map((item)=>item.id);
    const previousItemIds = previousItems.map((item)=>item.id);
    const currentItemIdSet = new Set(currentItemIds);
    const previousItemIdSet = new Set(previousItemIds);
    const hasChanged = currentItemIds.some((id)=>!previousItemIdSet.has(id)) || previousItemIds.some((id)=>!currentItemIdSet.has(id));
    if (!hasChanged) return {
        hasChanged: false,
        enteringIds: new Set(),
        nextLeavingItems: leavingItems
    };
    const enteringIds = new Set(currentItemIds.filter((id)=>!previousItemIdSet.has(id)));
    const reconciledLeavingItems = leavingItems.filter((item)=>!currentItemIdSet.has(item.id));
    const alreadyLeavingIds = new Set(reconciledLeavingItems.map((item)=>item.id));
    const newLeavingItems = previousItems.filter((item)=>!currentItemIdSet.has(item.id) && !alreadyLeavingIds.has(item.id));
    return {
        hasChanged: true,
        enteringIds: enteringIds,
        nextLeavingItems: [
            ...reconciledLeavingItems,
            ...newLeavingItems
        ]
    };
};

});


parcelRegister("8JMV0", function(module, exports) {

$parcel$export(module.exports, "scr_previewColWidthChange", function () { return $04ec037fe56d5235$export$97d1d429cdc91eb7; });
const $04ec037fe56d5235$export$97d1d429cdc91eb7 = (action, state)=>{
    if (action.width === null) {
        if (!(action.colId in state.previewColWidths)) return state;
        const { [action.colId]: _removed, ...remaining } = state.previewColWidths;
        return {
            ...state,
            previewColWidths: remaining
        };
    }
    if (state.previewColWidths[action.colId] === action.width) return state;
    return {
        ...state,
        previewColWidths: {
            ...state.previewColWidths,
            [action.colId]: action.width
        }
    };
};

});

parcelRegister("ihVPu", function(module, exports) {

$parcel$export(module.exports, "scr_previewRowHeightChange", function () { return $a6837d5302463ae5$export$a439fe2bb228ad9a; });
const $a6837d5302463ae5$export$a439fe2bb228ad9a = (action, state)=>{
    if (action.height === null) {
        if (!(action.rowId in state.previewRowHeights)) return state;
        const { [action.rowId]: _removed, ...remaining } = state.previewRowHeights;
        return {
            ...state,
            previewRowHeights: remaining
        };
    }
    if (state.previewRowHeights[action.rowId] === action.height) return state;
    return {
        ...state,
        previewRowHeights: {
            ...state.previewRowHeights,
            [action.rowId]: action.height
        }
    };
};

});

parcelRegister("at85V", function(module, exports) {

$parcel$export(module.exports, "scr_rowClicked", function () { return $ca25cee83a0089be$export$1ee5a0c821b1d4e1; });

var $aLLqu = parcelRequire("aLLqu");
parcelRequire("dChVW");
var $logA9 = parcelRequire("logA9");
var $kv7Xn = parcelRequire("kv7Xn");
var $9gU4v = parcelRequire("9gU4v");
const $ca25cee83a0089be$export$1ee5a0c821b1d4e1 = (action, state)=>{
    const { rowId: rowId, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = action;
    const { selection: selection, selectionAnchor: selectionAnchor, prevRows: prevRows } = state;
    if (shiftKey) {
        if (selectionAnchor && selectionAnchor.type === "row") return {
            ...state,
            selection: ctrlKey || metaKey ? (0, $logA9.addRowRangeToSelection)(selection, prevRows, selectionAnchor.rowId, rowId) : (0, $kv7Xn.setRowRangeSelection)(prevRows, selectionAnchor.rowId, rowId)
        };
        return {
            ...state,
            selection: {
                ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
                selectedRows: [
                    {
                        firstCellId: rowId
                    }
                ]
            },
            selectionAnchor: {
                type: "row",
                rowId: rowId
            }
        };
    }
    return {
        ...state,
        selection: ctrlKey || metaKey ? (0, $9gU4v.toggleRowInSelection)(selection, rowId) : {
            ...(0, $aLLqu.EMPTY_SCAFFOLD_SELECTION),
            selectedRows: [
                {
                    firstCellId: rowId
                }
            ]
        },
        selectionAnchor: {
            type: "row",
            rowId: rowId
        }
    };
};

});

parcelRegister("755IR", function(module, exports) {

$parcel$export(module.exports, "scr_rowEnterComplete", function () { return $45c896cac20a783d$export$ea15e708dbe5ac65; });
const $45c896cac20a783d$export$ea15e708dbe5ac65 = (action, state)=>{
    if (!state.enteringRowIds.has(action.rowId)) return state;
    const next = new Set(state.enteringRowIds);
    next.delete(action.rowId);
    return {
        ...state,
        enteringRowIds: next
    };
};

});

parcelRegister("5qVE1", function(module, exports) {

$parcel$export(module.exports, "scr_rowLeaveComplete", function () { return $bd770779e8640c2f$export$1a3bf6161f0a2204; });
const $bd770779e8640c2f$export$1a3bf6161f0a2204 = (action, state)=>({
        ...state,
        leavingRows: state.leavingRows.filter((r)=>r.id !== action.rowId)
    });

});

parcelRegister("gzwxv", function(module, exports) {

$parcel$export(module.exports, "scr_rowsChanged", function () { return $8bdf16e752921b21$export$6522f061e582ef5c; });

var $feiaX = parcelRequire("feiaX");
const $8bdf16e752921b21$export$6522f061e582ef5c = (action, state)=>{
    const reconciliation = (0, $feiaX.reconcileScaffoldItems)(action.rows, state.prevRows, state.leavingRows);
    return !reconciliation.hasChanged ? state : {
        ...state,
        enteringRowIds: reconciliation.enteringIds,
        leavingRows: reconciliation.nextLeavingItems,
        prevRows: action.rows
    };
};

});

parcelRegister("hDj78", function(module, exports) {

$parcel$export(module.exports, "scr_selectionChanged", function () { return $399196866168b47d$export$6079fe221acffb85; });
const $399196866168b47d$export$6079fe221acffb85 = (action, state)=>({
        ...state,
        selection: action.selection,
        selectionAnchor: null
    });

});

parcelRegister("lSQmu", function(module, exports) {

$parcel$export(module.exports, "scr_setDragging", function () { return $4ce3ef6843e8003e$export$ab01bf5fd45ff60b; });
const $4ce3ef6843e8003e$export$ab01bf5fd45ff60b = (action, state)=>({
        ...state,
        isDragging: action.isDragging
    });

});


parcelRegister("f91EO", function(module, exports) {

$parcel$export(module.exports, "body", function () { return $b068fb66bbd7d6aa$export$32180ef41b15b513; }, function (v) { return $b068fb66bbd7d6aa$export$32180ef41b15b513 = v; });
$parcel$export(module.exports, "cell", function () { return $b068fb66bbd7d6aa$export$e2e1361cdc35271d; }, function (v) { return $b068fb66bbd7d6aa$export$e2e1361cdc35271d = v; });
$parcel$export(module.exports, "cellContent", function () { return $b068fb66bbd7d6aa$export$b3e5b2f2dfaeed75; }, function (v) { return $b068fb66bbd7d6aa$export$b3e5b2f2dfaeed75 = v; });
$parcel$export(module.exports, "cellLeaving", function () { return $b068fb66bbd7d6aa$export$8a3f5022f873121c; }, function (v) { return $b068fb66bbd7d6aa$export$8a3f5022f873121c = v; });
$parcel$export(module.exports, "cellResizing", function () { return $b068fb66bbd7d6aa$export$7b65290b667564b4; }, function (v) { return $b068fb66bbd7d6aa$export$7b65290b667564b4 = v; });
$parcel$export(module.exports, "cellSelected", function () { return $b068fb66bbd7d6aa$export$5ce057a02585195d; }, function (v) { return $b068fb66bbd7d6aa$export$5ce057a02585195d = v; });
$parcel$export(module.exports, "cellWithRowSpan", function () { return $b068fb66bbd7d6aa$export$e9e8bf8107bcc6bb; }, function (v) { return $b068fb66bbd7d6aa$export$e9e8bf8107bcc6bb = v; });
$parcel$export(module.exports, "colResizeHandle", function () { return $b068fb66bbd7d6aa$export$afc04767dd1cd2dc; }, function (v) { return $b068fb66bbd7d6aa$export$afc04767dd1cd2dc = v; });
$parcel$export(module.exports, "colResizeHandleDisabled", function () { return $b068fb66bbd7d6aa$export$a8a189742dc309ea; }, function (v) { return $b068fb66bbd7d6aa$export$a8a189742dc309ea = v; });
$parcel$export(module.exports, "colResizeOverlay", function () { return $b068fb66bbd7d6aa$export$307b7c34e981e610; }, function (v) { return $b068fb66bbd7d6aa$export$307b7c34e981e610 = v; });
$parcel$export(module.exports, "colSelectHandle", function () { return $b068fb66bbd7d6aa$export$e640260e805140e7; }, function (v) { return $b068fb66bbd7d6aa$export$e640260e805140e7 = v; });
$parcel$export(module.exports, "colSelectHandleSelected", function () { return $b068fb66bbd7d6aa$export$36ffebeca4bf609a; }, function (v) { return $b068fb66bbd7d6aa$export$36ffebeca4bf609a = v; });
$parcel$export(module.exports, "footer", function () { return $b068fb66bbd7d6aa$export$adb608be33961c98; }, function (v) { return $b068fb66bbd7d6aa$export$adb608be33961c98 = v; });
$parcel$export(module.exports, "header", function () { return $b068fb66bbd7d6aa$export$38e42c68cf43b5d4; }, function (v) { return $b068fb66bbd7d6aa$export$38e42c68cf43b5d4 = v; });
$parcel$export(module.exports, "row", function () { return $b068fb66bbd7d6aa$export$120ff0929b202a6d; }, function (v) { return $b068fb66bbd7d6aa$export$120ff0929b202a6d = v; });
$parcel$export(module.exports, "rowCells", function () { return $b068fb66bbd7d6aa$export$41e54bef763a37c2; }, function (v) { return $b068fb66bbd7d6aa$export$41e54bef763a37c2 = v; });
$parcel$export(module.exports, "rowCellsWithSpan", function () { return $b068fb66bbd7d6aa$export$90ce25cc2b233c4a; }, function (v) { return $b068fb66bbd7d6aa$export$90ce25cc2b233c4a = v; });
$parcel$export(module.exports, "rowGroup", function () { return $b068fb66bbd7d6aa$export$da117b1940f09074; }, function (v) { return $b068fb66bbd7d6aa$export$da117b1940f09074 = v; });
$parcel$export(module.exports, "rowLeaving", function () { return $b068fb66bbd7d6aa$export$84868fcdcc3bde41; }, function (v) { return $b068fb66bbd7d6aa$export$84868fcdcc3bde41 = v; });
$parcel$export(module.exports, "rowResizeHandle", function () { return $b068fb66bbd7d6aa$export$2bb1efb2b04c9462; }, function (v) { return $b068fb66bbd7d6aa$export$2bb1efb2b04c9462 = v; });
$parcel$export(module.exports, "rowResizeHandleDisabled", function () { return $b068fb66bbd7d6aa$export$7572739fd2d70b89; }, function (v) { return $b068fb66bbd7d6aa$export$7572739fd2d70b89 = v; });
$parcel$export(module.exports, "rowResizing", function () { return $b068fb66bbd7d6aa$export$6ef4649251b223a4; }, function (v) { return $b068fb66bbd7d6aa$export$6ef4649251b223a4 = v; });
$parcel$export(module.exports, "rowSelectHandle", function () { return $b068fb66bbd7d6aa$export$5dc579b272dc7ce1; }, function (v) { return $b068fb66bbd7d6aa$export$5dc579b272dc7ce1 = v; });
$parcel$export(module.exports, "rowSelectHandleSelected", function () { return $b068fb66bbd7d6aa$export$2a0421a348c2718c; }, function (v) { return $b068fb66bbd7d6aa$export$2a0421a348c2718c = v; });
$parcel$export(module.exports, "table", function () { return $b068fb66bbd7d6aa$export$9852986a3ec5f6a0; }, function (v) { return $b068fb66bbd7d6aa$export$9852986a3ec5f6a0 = v; });
$parcel$export(module.exports, "tableWrapper", function () { return $b068fb66bbd7d6aa$export$e7d47881ec916f76; }, function (v) { return $b068fb66bbd7d6aa$export$e7d47881ec916f76 = v; });
$parcel$export(module.exports, "zoneGrid", function () { return $b068fb66bbd7d6aa$export$e8728c4dee7ee1ba; }, function (v) { return $b068fb66bbd7d6aa$export$e8728c4dee7ee1ba = v; });
$parcel$export(module.exports, "zoneGridCell", function () { return $b068fb66bbd7d6aa$export$38ed7698121dea36; }, function (v) { return $b068fb66bbd7d6aa$export$38ed7698121dea36 = v; });
var $b068fb66bbd7d6aa$export$32180ef41b15b513;
var $b068fb66bbd7d6aa$export$e2e1361cdc35271d;
var $b068fb66bbd7d6aa$export$b3e5b2f2dfaeed75;
var $b068fb66bbd7d6aa$export$8a3f5022f873121c;
var $b068fb66bbd7d6aa$export$7b65290b667564b4;
var $b068fb66bbd7d6aa$export$5ce057a02585195d;
var $b068fb66bbd7d6aa$export$e9e8bf8107bcc6bb;
var $b068fb66bbd7d6aa$export$afc04767dd1cd2dc;
var $b068fb66bbd7d6aa$export$a8a189742dc309ea;
var $b068fb66bbd7d6aa$export$307b7c34e981e610;
var $b068fb66bbd7d6aa$export$e640260e805140e7;
var $b068fb66bbd7d6aa$export$36ffebeca4bf609a;
var $b068fb66bbd7d6aa$export$adb608be33961c98;
var $b068fb66bbd7d6aa$export$38e42c68cf43b5d4;
var $b068fb66bbd7d6aa$export$120ff0929b202a6d;
var $b068fb66bbd7d6aa$export$41e54bef763a37c2;
var $b068fb66bbd7d6aa$export$90ce25cc2b233c4a;
var $b068fb66bbd7d6aa$export$da117b1940f09074;
var $b068fb66bbd7d6aa$export$84868fcdcc3bde41;
var $b068fb66bbd7d6aa$export$2bb1efb2b04c9462;
var $b068fb66bbd7d6aa$export$7572739fd2d70b89;
var $b068fb66bbd7d6aa$export$6ef4649251b223a4;
var $b068fb66bbd7d6aa$export$5dc579b272dc7ce1;
var $b068fb66bbd7d6aa$export$2a0421a348c2718c;
var $b068fb66bbd7d6aa$export$9852986a3ec5f6a0;
var $b068fb66bbd7d6aa$export$e7d47881ec916f76;
var $b068fb66bbd7d6aa$export$e8728c4dee7ee1ba;
var $b068fb66bbd7d6aa$export$38ed7698121dea36;
$b068fb66bbd7d6aa$export$32180ef41b15b513 = `mos-Scaffold-module-XdYGQG-body`;
$b068fb66bbd7d6aa$export$e2e1361cdc35271d = `mos-Scaffold-module-XdYGQG-cell`;
$b068fb66bbd7d6aa$export$b3e5b2f2dfaeed75 = `mos-Scaffold-module-XdYGQG-cellContent`;
$b068fb66bbd7d6aa$export$8a3f5022f873121c = `mos-Scaffold-module-XdYGQG-cellLeaving`;
$b068fb66bbd7d6aa$export$7b65290b667564b4 = `mos-Scaffold-module-XdYGQG-cellResizing`;
$b068fb66bbd7d6aa$export$5ce057a02585195d = `mos-Scaffold-module-XdYGQG-cellSelected`;
$b068fb66bbd7d6aa$export$e9e8bf8107bcc6bb = `mos-Scaffold-module-XdYGQG-cellWithRowSpan`;
$b068fb66bbd7d6aa$export$afc04767dd1cd2dc = `mos-Scaffold-module-XdYGQG-colResizeHandle`;
$b068fb66bbd7d6aa$export$a8a189742dc309ea = `mos-Scaffold-module-XdYGQG-colResizeHandleDisabled`;
$b068fb66bbd7d6aa$export$307b7c34e981e610 = `mos-Scaffold-module-XdYGQG-colResizeOverlay`;
$b068fb66bbd7d6aa$export$e640260e805140e7 = `mos-Scaffold-module-XdYGQG-colSelectHandle`;
$b068fb66bbd7d6aa$export$36ffebeca4bf609a = `mos-Scaffold-module-XdYGQG-colSelectHandleSelected`;
$b068fb66bbd7d6aa$export$adb608be33961c98 = `mos-Scaffold-module-XdYGQG-footer`;
$b068fb66bbd7d6aa$export$38e42c68cf43b5d4 = `mos-Scaffold-module-XdYGQG-header`;
$b068fb66bbd7d6aa$export$120ff0929b202a6d = `mos-Scaffold-module-XdYGQG-row`;
$b068fb66bbd7d6aa$export$41e54bef763a37c2 = `mos-Scaffold-module-XdYGQG-rowCells`;
$b068fb66bbd7d6aa$export$90ce25cc2b233c4a = `mos-Scaffold-module-XdYGQG-rowCellsWithSpan`;
$b068fb66bbd7d6aa$export$da117b1940f09074 = `mos-Scaffold-module-XdYGQG-rowGroup`;
$b068fb66bbd7d6aa$export$84868fcdcc3bde41 = `mos-Scaffold-module-XdYGQG-rowLeaving`;
$b068fb66bbd7d6aa$export$2bb1efb2b04c9462 = `mos-Scaffold-module-XdYGQG-rowResizeHandle`;
$b068fb66bbd7d6aa$export$7572739fd2d70b89 = `mos-Scaffold-module-XdYGQG-rowResizeHandleDisabled`;
$b068fb66bbd7d6aa$export$6ef4649251b223a4 = `mos-Scaffold-module-XdYGQG-rowResizing`;
$b068fb66bbd7d6aa$export$5dc579b272dc7ce1 = `mos-Scaffold-module-XdYGQG-rowSelectHandle`;
$b068fb66bbd7d6aa$export$2a0421a348c2718c = `mos-Scaffold-module-XdYGQG-rowSelectHandleSelected`;
$b068fb66bbd7d6aa$export$9852986a3ec5f6a0 = `mos-Scaffold-module-XdYGQG-table`;
$b068fb66bbd7d6aa$export$e7d47881ec916f76 = `mos-Scaffold-module-XdYGQG-tableWrapper`;
$b068fb66bbd7d6aa$export$e8728c4dee7ee1ba = `mos-Scaffold-module-XdYGQG-zoneGrid`;
$b068fb66bbd7d6aa$export$38ed7698121dea36 = `mos-Scaffold-module-XdYGQG-zoneGridCell`;

});

parcelRegister("8N6BR", function(module, exports) {

$parcel$export(module.exports, "ScaffoldColResizeHandle", function () { return $f766d1f9b1fea0e0$export$c92236b18139d109; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $3tKzd = parcelRequire("3tKzd");

var $aLLqu = parcelRequire("aLLqu");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");
const $f766d1f9b1fea0e0$export$9153ba04ac8b58a9 = (headerSpanMap, orderedColIds, rowId, cellColId, targetColId)=>{
    if (cellColId === targetColId) return true;
    if (headerSpanMap === undefined || rowId === undefined) return false;
    const rowSpanInfo = headerSpanMap[rowId];
    const cellInfo = rowSpanInfo?.[cellColId];
    if (cellInfo?.mode !== "spanning" || cellInfo.effectiveWidth === undefined) return false;
    const startIndex = orderedColIds.indexOf(cellColId);
    const targetIndex = orderedColIds.indexOf(targetColId);
    if (startIndex < 0 || targetIndex < 0 || targetIndex <= startIndex) return false;
    for(let i = startIndex + 1; i <= targetIndex; i++){
        const coveredInfo = rowSpanInfo?.[orderedColIds[i]];
        if (coveredInfo?.mode !== "covered-same-row") return false;
    }
    return true;
};
const $f766d1f9b1fea0e0$export$c92236b18139d109 = ({ colId: colId })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const leavingCol = scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
    const enteringCol = scaffoldContext.state.enteringColIds.has(colId);
    const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? leavingCol;
    const justification = scaffoldContext.settings.justification ?? "left";
    // Calculate left offset by accumulating column widths (including this column)
    const orderedCols = [
        ...scaffoldContext.settings.columns,
        ...scaffoldContext.state.leavingCols
    ].sort((a, b)=>a.colNumber - b.colNumber);
    const orderedColIds = orderedCols.map((orderedCol)=>orderedCol.id);
    let leftOffset = 0;
    for (const c of orderedCols){
        leftOffset += scaffoldContext.state.previewColWidths[c.id] ?? c.width;
        if (c.id === colId) break;
    }
    // For right justification the handle sits at the left edge of the column so that
    // dragging leftward widens the column as the table grows toward the left.
    const thisColWidth = scaffoldContext.state.previewColWidths[colId] ?? col?.width ?? 0;
    const handleLeftOffset = justification === "right" ? leftOffset - thisColWidth : leftOffset;
    // Derive canResize from context state
    const isDragging = scaffoldContext.state.isDragging === true;
    const canResize = scaffoldContext.settings.disabled !== true && scaffoldContext.settings.onChangeCol !== undefined && !isDragging && !leavingCol && !enteringCol && col !== undefined;
    const resizeSessionRef = (0, $spJKX.useRef)(null);
    const colRef = (0, $spJKX.useRef)(col);
    const leavingColRef = (0, $spJKX.useRef)(leavingCol);
    const onChangeColRef = (0, $spJKX.useRef)(scaffoldContext.settings.onChangeCol);
    const scaffoldRootRef = (0, $spJKX.useRef)(null);
    /**
   * Adds the cellResizing CSS class to the scaffold root so all cells show the col-resize
   * cursor throughout the drag, regardless of where the pointer is within the scaffold.
   */ const applyResizingClass = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else -- scaffoldRootRef is always set before applyResizingClass is called */ if (scaffoldRootRef.current !== null) scaffoldRootRef.current.classList.add((0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellResizing);
    }, []);
    /**
   * Removes the cellResizing CSS class from the scaffold root after a resize session ends.
   */ const clearResizingClass = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else -- scaffoldRootRef is always set before clearResizingClass is called */ if (scaffoldRootRef.current !== null) scaffoldRootRef.current.classList.remove((0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellResizing);
    }, []);
    /**
   * Keeps mutable refs synchronised for document-level column resize handlers.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        colRef.current = col;
        leavingColRef.current = leavingCol;
        onChangeColRef.current = scaffoldContext.settings.onChangeCol;
    }, [
        col,
        leavingCol,
        scaffoldContext.settings.onChangeCol
    ]);
    /**
   * Applies column width updates during drag by manipulating DOM style directly (no React state).
   * Uses delta-based calculation from initial width for instant visual feedback and jsdom compatibility.
   * The delta is multiplied by 2 for centre-justified tables (the table expands symmetrically so
   * the column edge moves at half the mouse rate) and inverted for right-justified tables (the handle
   * sits at the left edge and dragging left widens the column).
   *
   * @param e - Native mouse move event emitted on the window.
   */ const handleResizeMouseMove = (e)=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const deltaMultiplier = justification === "center" ? 2 : justification === "right" ? -1 : 1;
        const nextWidth = Math.max((0, $aLLqu.MIN_SCAFFOLD_COL_WIDTH_PX), Math.round(session.startWidth + deltaMultiplier * (e.clientX - session.startX)));
        if (nextWidth === session.latestWidth) return;
        const widthDelta = nextWidth - session.startWidth;
        session.latestWidth = nextWidth;
        session.targetCells.forEach((targetCell)=>{
            const targetWidth = Math.max((0, $aLLqu.MIN_SCAFFOLD_COL_WIDTH_PX), targetCell.startWidth + widthDelta);
            targetCell.cell.style.width = `${targetWidth}px`;
        });
    };
    /**
   * Clears transient inline width styles from all cells participating in an active column resize.
   */ const clearColumnResizeStyles = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore next -- only called from handleResizeMouseUp when session is non-null */ if (resizeSessionRef.current === null) return;
        resizeSessionRef.current.targetCells.forEach((targetCell)=>{
            targetCell.cell.style.width = "";
        });
    }, []);
    /**
   * Reads an element's inline width in pixels, falling back to a provided default width.
   *
   * @param cell - Cell element whose width should be measured.
   * @param fallbackWidth - Width to use when no parseable inline width exists.
   * @returns The parsed or fallback width in pixels.
   */ const getCellWidthOrFallback = (0, $spJKX.useCallback)((cell, fallbackWidth)=>{
        const parsedWidth = Math.round(parseFloat(cell.style.width));
        return parsedWidth || fallbackWidth;
    }, []);
    /**
   * Completes column resize by extracting final width from inline style and emitting single update.
   */ const handleResizeMouseUp = (0, $spJKX.useCallback)(()=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) {
            clearResizingClass();
            scaffoldRootRef.current = null;
            return;
        }
        clearResizingClass();
        scaffoldRootRef.current = null;
        const width = session.latestWidth;
        resizeSessionRef.current = null;
        const currentCol = colRef.current;
        const currentLeavingCol = leavingColRef.current;
        if (currentCol !== undefined && !currentLeavingCol && width !== currentCol.width) onChangeColRef.current?.(colId, {
            ...currentCol,
            width: width
        });
    }, [
        clearResizingClass,
        colId
    ]);
    /**
   * Ensures document listeners are cleaned up on unmount.
   */ (0, $spJKX.useEffect)(()=>{
        return ()=>{
            clearResizingClass();
            scaffoldRootRef.current = null;
            clearColumnResizeStyles();
            resizeSessionRef.current = null;
        };
    }, [
        clearColumnResizeStyles,
        clearResizingClass
    ]);
    /**
   * Starts a column width drag operation from this resize handle.
   *
   * @param event - React mouse down event from the resize handle.
   */ const handleResizeMouseDown = (event)=>{
        if (canResize) {
            event.preventDefault();
            const scaffoldRoot = document.getElementById(scaffoldContext.settings.id);
            /* istanbul ignore else */ if (scaffoldRoot !== null) {
                const targetCells = Array.from(scaffoldRoot.querySelectorAll("div[data-scaffold-col-id]")).filter((element)=>{
                    if (!(element instanceof HTMLDivElement)) return false;
                    const cellRowId = element.dataset.scaffoldRowId;
                    const cellColId = element.dataset.scaffoldColId;
                    if (cellColId === undefined) return false;
                    return $f766d1f9b1fea0e0$export$9153ba04ac8b58a9(scaffoldContext.headerSpanMap, orderedColIds, cellRowId, cellColId, colId);
                });
                /* istanbul ignore else */ if (targetCells.length > 0) {
                    const referenceCell = targetCells.find((targetCell)=>{
                        if (targetCell.dataset.scaffoldColId !== colId) return false;
                        const targetRowId = targetCell.dataset.scaffoldRowId;
                        const targetCellInfo = targetRowId !== undefined ? scaffoldContext.headerSpanMap?.[targetRowId]?.[colId] : undefined;
                        return targetCellInfo?.mode !== "spanning";
                    });
                    const currentWidth = referenceCell !== undefined ? getCellWidthOrFallback(referenceCell, col.width) : col.width;
                    resizeSessionRef.current = {
                        startX: event.clientX,
                        startWidth: currentWidth,
                        latestWidth: currentWidth,
                        targetCells: targetCells.map((targetCell)=>({
                                cell: targetCell,
                                startWidth: getCellWidthOrFallback(targetCell, currentWidth)
                            }))
                    };
                    resizeSessionRef.current.targetCells.forEach((targetCell)=>{
                        targetCell.cell.style.width = `${targetCell.startWidth}px`;
                    });
                    scaffoldRootRef.current = scaffoldRoot;
                    clearResizingClass();
                    applyResizingClass();
                }
            }
        }
    };
    const { onMouseDown: onResizeHandleMouseDown } = (0, $5EkSD.useMouseMove)({
        onMouseDown: handleResizeMouseDown,
        onMouseMove: handleResizeMouseMove,
        onMouseUp: handleResizeMouseUp,
        interactionEndEnabled: false,
        viewportResizeEnabled: false
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).colResizeHandle,
            canResize ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).colResizeHandleDisabled
        ]),
        style: {
            left: handleLeftOffset
        },
        onMouseDown: onResizeHandleMouseDown
    });
};
$f766d1f9b1fea0e0$export$c92236b18139d109.displayName = "ScaffoldColResizeHandle";

});

parcelRegister("luXBI", function(module, exports) {

$parcel$export(module.exports, "ScaffoldColSelectHandle", function () { return $15c0dc55d1674059$export$938d1c980c519dd7; });

var $bR5nk = parcelRequire("bR5nk");

var $3tKzd = parcelRequire("3tKzd");

var $7bbQp = parcelRequire("7bbQp");
parcelRequire("dChVW");
var $1SQWM = parcelRequire("1SQWM");

var $aLLqu = parcelRequire("aLLqu");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");
const $15c0dc55d1674059$export$938d1c980c519dd7 = ({ colId: colId, left: left, width: width })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const isSelected = (0, $1SQWM.isColInSelection)(scaffoldContext.state.selection, colId);
    return /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
        type: "button",
        "aria-label": "Select column",
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).colSelectHandle,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).colSelectHandleSelected : undefined
        ]),
        style: {
            left: left,
            width: width,
            height: (0, $aLLqu.SCAFFOLD_SELECT_HANDLE_SIZE_PX)
        },
        onClick: (event)=>{
            event.preventDefault();
            scaffoldContext.dispatch({
                operation: (0, $7bbQp.COL_CLICKED),
                colId: colId,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey
            });
        }
    });
};
$15c0dc55d1674059$export$938d1c980c519dd7.displayName = "ScaffoldColSelectHandle";

});

parcelRegister("dAej4", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowGroups", function () { return $ba49f5fed7793173$export$38b33fefcd8c69b9; });

var $bR5nk = parcelRequire("bR5nk");

var $3tKzd = parcelRequire("3tKzd");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");

var $6VOa0 = parcelRequire("6VOa0");
const $ba49f5fed7793173$export$38b33fefcd8c69b9 = ()=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const currentRowIdSet = new Set(scaffoldContext.settings.rows.map((r)=>r.id));
    const rgStyles = {
        header: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).header,
        body: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).body,
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).footer
    };
    const allDisplayRows = [
        ...scaffoldContext.settings.rows,
        ...scaffoldContext.state.leavingRows
    ].sort((a, b)=>{
        if (a.rowNumber !== b.rowNumber) return a.rowNumber - b.rowNumber;
        // When row numbers collide during removal, keep the leaving row first so it visibly collapses.
        const isALeavingRow = !currentRowIdSet.has(a.id);
        const isBLeavingRow = !currentRowIdSet.has(b.id);
        if (isALeavingRow === isBLeavingRow) return 0;
        return isALeavingRow ? -1 : 1;
    });
    const rowGroupList = new Set(allDisplayRows.map((r)=>r.rowGroupNumber));
    const rowGroupTypes = allDisplayRows.reduce((acc, r)=>{
        acc[r.rowGroupNumber] = r.type;
        return acc;
    }, {});
    return Array.from(rowGroupList).map((rgNum)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: (0, $3tKzd.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowGroup,
                rgStyles[rowGroupTypes[rgNum]]
            ]),
            children: allDisplayRows.filter((r)=>r.rowGroupNumber === rgNum).map((r, ix, arr)=>{
                let id = r.id;
                const style = {};
                /* Check for non-unique rowIDs from bad input data and highlight them,
             added for debugging, doesn't require testing */ // istanbul ignore next
                if (arr.findIndex((row)=>row.id === r.id) !== ix) {
                    console.warn(`Duplicate row ID detected: ${r.id}. Appending index to make unique.`);
                    id = `${r.id}-${ix}`;
                    style.background = "rgba(255, 0, 0, 0.1)";
                }
                return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6VOa0.ScaffoldRow), {
                    rowId: r.id,
                    style: style
                }, `row-${id}`);
            })
        }, `row-group-${rgNum}`));
};
$ba49f5fed7793173$export$38b33fefcd8c69b9.displayName = "ScaffoldRowGroups";

});
parcelRegister("6VOa0", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRow", function () { return $b1f7ed3b749cccb7$export$3bcb108d4b2aa233; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3tKzd = parcelRequire("3tKzd");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");

var $kas1l = parcelRequire("kas1l");

var $7sbB1 = parcelRequire("7sbB1");

var $hQIFa = parcelRequire("hQIFa");

var $7bbQp = parcelRequire("7bbQp");

var $aLLqu = parcelRequire("aLLqu");
const $b1f7ed3b749cccb7$export$3bcb108d4b2aa233 = ({ rowId: rowId, style: style })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const { columns: columns, rows: rows } = scaffoldContext.settings;
    const { leavingCols: leavingCols, enteringRowIds: enteringRowIds, leavingRows: leavingRows } = scaffoldContext.state;
    const isEnteringRow = enteringRowIds.has(rowId);
    const leavingRow = leavingRows.find((r)=>r.id === rowId);
    const row = rows.find((r)=>r.id === rowId) || leavingRow;
    /**
   * Determine initial state: entering rows start at "placed" (0px), leaving start at "open" (full)
   */ const getInitialState = ()=>isEnteringRow ? "placed" : "open";
    const [state, setState] = (0, $spJKX.useState)(getInitialState());
    // Store timeout IDs to clear them on cleanup
    const timeoutsRef = (0, $spJKX.useRef)([]);
    const wasLeavingRowRef = (0, $spJKX.useRef)(Boolean(leavingRow));
    const hasNotifiedRowLeaveCompleteRef = (0, $spJKX.useRef)(false);
    const hasNotifiedRowEnterCompleteRef = (0, $spJKX.useRef)(false);
    /**
   * State machine for entering rows: placed (5ms delay) → opening (animate for 200ms) → open
   * State machine for leaving rows: open → closing (animate for 200ms) → closed (unmount)
   */ (0, $spJKX.useLayoutEffect)(()=>{
        if (state !== "closing") hasNotifiedRowLeaveCompleteRef.current = false;
        if (state !== "opening") hasNotifiedRowEnterCompleteRef.current = false;
        if (state === "placed") {
            const id = window.setTimeout(()=>{
                setState("opening");
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_START_DELAY_MS));
            timeoutsRef.current.push(id);
        }
        if (state === "opening") {
            const id = window.setTimeout(()=>{
                setState("open");
                /* istanbul ignore else */ if (isEnteringRow && !hasNotifiedRowEnterCompleteRef.current) {
                    hasNotifiedRowEnterCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $7bbQp.ROW_ENTER_COMPLETE),
                        rowId: rowId
                    });
                }
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        if (state === "closing") {
            const id = window.setTimeout(()=>{
                setState("closed");
                /* istanbul ignore else */ if (leavingRow && !hasNotifiedRowLeaveCompleteRef.current) {
                    hasNotifiedRowLeaveCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $7bbQp.ROW_LEAVE_COMPLETE),
                        rowId: rowId
                    });
                }
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        // Cleanup: clear all scheduled timeouts
        return ()=>{
            timeoutsRef.current.forEach((id)=>clearTimeout(id));
            timeoutsRef.current = [];
        };
    }, [
        isEnteringRow,
        leavingRow,
        rowId,
        scaffoldContext,
        state
    ]);
    /**
   * When a row enters the leaving state, trigger the closing animation.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        if (leavingRow && state === "open") // This needs to be disabled as immediate effects need to occur from useLayoutEffect
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setState("closing");
    }, [
        leavingRow,
        state
    ]);
    /**
   * If a row stops being a leaving row before the close animation completes,
   * reset its state so it can remain visible.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        const wasLeavingRow = wasLeavingRowRef.current;
        const isLeavingRow = Boolean(leavingRow);
        if (wasLeavingRow && !isLeavingRow) // This needs to be disabled as immediate effects need to occur from useLayoutEffect
        setState(isEnteringRow ? "placed" : "open");
        wasLeavingRowRef.current = isLeavingRow;
    }, [
        isEnteringRow,
        leavingRow
    ]);
    const currentColIdSet = new Set(columns.map((c)=>c.id));
    const allDisplayCols = [
        ...columns,
        ...leavingCols.filter((c)=>!currentColIdSet.has(c.id))
    ].sort((a, b)=>{
        if (a.colNumber !== b.colNumber) return a.colNumber - b.colNumber;
        // When col numbers collide during removal, keep the leaving col first so it visibly collapses.
        const isALeavingCol = !currentColIdSet.has(a.id);
        const isBLeavingCol = !currentColIdSet.has(b.id);
        if (isALeavingCol === isBLeavingCol) return 0;
        return isALeavingCol ? -1 : 1;
    });
    const rowHeight = row?.height ?? // istanbul ignore next
    0;
    const previewRowHeight = scaffoldContext.state.previewRowHeights[rowId];
    const liveRowHeight = previewRowHeight ?? rowHeight;
    // Height is 0 in "placed" state (entering), or when "closing" (leaving). Otherwise full height.
    const displayHeight = state === "placed" || state === "closing" ? 0 : liveRowHeight;
    /** True when any cell in this row has an active rowSpan; requires overflow:visible on rowCells. */ const rowHasRowSpanningCells = allDisplayCols.some((c)=>scaffoldContext.headerSpanMap?.[rowId]?.[c.id]?.hasRowSpan);
    return state === "closed" ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).row,
            leavingRow ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowLeaving : undefined,
            previewRowHeight !== undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowResizing : undefined
        ]),
        style: {
            ...style,
            height: displayHeight,
            transition: previewRowHeight === undefined && (state === "opening" || state === "closing") ? `height ${0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS}ms linear` : undefined
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7sbB1.ScaffoldRowResizeHandle), {
                rowId: rowId
            }),
            scaffoldContext.settings.onSelectionChange !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hQIFa.ScaffoldRowSelectHandle), {
                rowId: rowId
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowCells,
                    rowHasRowSpanningCells ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowCellsWithSpan : undefined
                ]),
                children: allDisplayCols.map((c, ix, arr)=>{
                    let id = c.id;
                    const style = {};
                    /* Check for non-unique columnIDs from bad input data and highlight them,
             added for debugging, doesn't require testing */ // istanbul ignore next
                    if (arr.findIndex((col)=>col.id === c.id) !== ix) {
                        console.warn(`Duplicate column ID detected: ${c.id}. Appending index to make unique.`);
                        id = `${c.id}-${ix}`;
                        style.background = "rgba(255, 0, 0, 0.1)";
                    }
                    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kas1l.ScaffoldCell), {
                        rowId: rowId,
                        colId: c.id,
                        rowHeightOverride: previewRowHeight,
                        style: style
                    }, `${rowId}-${id}`);
                })
            })
        ]
    });
};
$b1f7ed3b749cccb7$export$3bcb108d4b2aa233.displayName = "ScaffoldRow";

});
parcelRegister("kas1l", function(module, exports) {

$parcel$export(module.exports, "ScaffoldCell", function () { return $dee64a049f150b21$export$dbbbdee3e4fba4de; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3tKzd = parcelRequire("3tKzd");

var $7bbQp = parcelRequire("7bbQp");
parcelRequire("dChVW");
var $3H15F = parcelRequire("3H15F");

var $aLLqu = parcelRequire("aLLqu");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");

var $c5CXQ = parcelRequire("c5CXQ");
const $dee64a049f150b21$export$dbbbdee3e4fba4de = ({ rowId: rowId, colId: colId, rowHeightOverride: rowHeightOverride, style: style })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const isEnteringCol = scaffoldContext.state.enteringColIds.has(colId);
    const leavingCol = scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
    const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? leavingCol;
    const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
    /**
   * Determine initial state: entering columns start at "placed" (0px), leaving start at "open" (full).
   * All other columns start in the settled open state.
   *
   * @returns The initial animation state for the cell.
   */ const getInitialState = ()=>{
        if (isEnteringCol) return "placed";
        if (leavingCol) return "open";
        return "open";
    };
    const [animationState, setAnimationState] = (0, $spJKX.useState)(getInitialState());
    const timeoutsRef = (0, $spJKX.useRef)([]);
    const wasLeavingColRef = (0, $spJKX.useRef)(Boolean(leavingCol));
    const hasNotifiedColLeaveCompleteRef = (0, $spJKX.useRef)(false);
    const hasNotifiedColEnterCompleteRef = (0, $spJKX.useRef)(false);
    /**
   * State machine for entering columns: placed (5ms delay) -> opening (animate for 200ms) -> open.
   * State machine for leaving columns: open -> closing (animate for 200ms) -> closed (unmount).
   */ (0, $spJKX.useLayoutEffect)(()=>{
        if (animationState !== "closing") hasNotifiedColLeaveCompleteRef.current = false;
        if (animationState !== "opening") hasNotifiedColEnterCompleteRef.current = false;
        if (animationState === "placed") {
            const id = window.setTimeout(()=>{
                setAnimationState("opening");
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_START_DELAY_MS));
            timeoutsRef.current.push(id);
        }
        if (animationState === "opening") {
            const id = window.setTimeout(()=>{
                setAnimationState("open");
                /* istanbul ignore else */ if (isEnteringCol && !hasNotifiedColEnterCompleteRef.current) {
                    hasNotifiedColEnterCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $7bbQp.COL_ENTER_COMPLETE),
                        colId: colId
                    });
                }
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        if (animationState === "closing") {
            const id = window.setTimeout(()=>{
                setAnimationState("closed");
                /* istanbul ignore else */ if (leavingCol && !hasNotifiedColLeaveCompleteRef.current) {
                    hasNotifiedColLeaveCompleteRef.current = true;
                    scaffoldContext.dispatch({
                        operation: (0, $7bbQp.COL_LEAVE_COMPLETE),
                        colId: colId
                    });
                }
            }, (0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS));
            timeoutsRef.current.push(id);
        }
        return ()=>{
            timeoutsRef.current.forEach((id)=>clearTimeout(id));
            timeoutsRef.current = [];
        };
    }, [
        animationState,
        colId,
        isEnteringCol,
        leavingCol,
        scaffoldContext
    ]);
    /**
   * When a column enters the leaving state, trigger the closing animation.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        if (leavingCol && animationState === "open") (0, $spJKX.startTransition)(()=>setAnimationState("closing"));
    }, [
        leavingCol,
        animationState
    ]);
    /**
   * If a column stops being a leaving column before close completes,
   * reset so it can remain visible.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        const wasLeavingCol = wasLeavingColRef.current;
        const isLeavingCol = Boolean(leavingCol);
        if (wasLeavingCol && !isLeavingCol) (0, $spJKX.startTransition)(()=>setAnimationState(isEnteringCol ? "placed" : "open"));
        wasLeavingColRef.current = isLeavingCol;
    }, [
        isEnteringCol,
        leavingCol
    ]);
    const colWidth = col?.width ?? 0;
    const rowHeight = rowHeightOverride ?? row?.height;
    const textAlignment = row?.textAlignment ?? col?.textAlignment ?? "default";
    const cellEditor = col?.cellComponent ?? scaffoldContext.settings.cellComponent;
    const cellValue = leavingCol || scaffoldContext.settings.cellData[rowId]?.[colId] === undefined ? cellEditor.blankT : scaffoldContext.settings.cellData[rowId]?.[colId];
    const CellEditor = cellEditor.Editor;
    /** Span information for this cell, if any span definitions are active. */ const spanInfo = scaffoldContext.headerSpanMap?.[rowId]?.[colId];
    /**
   * Cells covered by a colSpan in the same row are removed from the DOM so the spanning
   * cell's width fills the correct space without duplication.
   */ const isCoveredSameRow = spanInfo?.mode === "covered-same-row";
    /**
   * Cells covered by a rowSpan from a preceding row are rendered as invisible placeholders
   * to preserve flex column alignment in subsequent rows.
   */ const isCoveredOtherRow = spanInfo?.mode === "covered-other-row";
    /** Effective width: use merged column width for spanning cells, otherwise normal column width. */ const effectiveColWidth = spanInfo?.effectiveWidth ?? colWidth;
    /** Effective height: use merged row height for spanning cells, otherwise normal row height. */ const effectiveRowHeight = spanInfo?.effectiveHeight ?? rowHeight;
    const displayWidth = animationState === "placed" || animationState === "closing" ? 0 : effectiveColWidth;
    const isSelected = (0, $3H15F.isCellHighlighted)(scaffoldContext.state.selection, rowId, colId);
    return animationState === "closed" || !col || isCoveredSameRow ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cell,
            leavingCol ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellLeaving : undefined,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellSelected : undefined,
            spanInfo?.hasRowSpan ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellWithRowSpan : undefined
        ]),
        "data-scaffold-col-id": colId,
        "data-scaffold-row-id": rowId,
        style: {
            ...style,
            visibility: isCoveredOtherRow ? "hidden" : undefined,
            width: displayWidth,
            height: effectiveRowHeight,
            transition: animationState === "opening" || animationState === "closing" ? `width ${0, $aLLqu.SCAFFOLD_ANIMATION_DURATION_MS}ms linear` : undefined
        },
        onClick: (event)=>{
            if (!isCoveredOtherRow) {
                if (event.shiftKey) event.preventDefault();
                scaffoldContext.dispatch({
                    operation: (0, $7bbQp.CELL_CLICKED),
                    rowId: rowId,
                    colId: colId,
                    ctrlKey: event.ctrlKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
            }
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).cellContent,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(CellEditor, {
                    id: `${rowId}-${colId}`,
                    colId: colId,
                    editable: !scaffoldContext.settings.disabled,
                    rowId: rowId,
                    setValue: (newValue)=>scaffoldContext.settings.onChangeCell?.(rowId, colId, newValue),
                    textAlignment: textAlignment,
                    value: cellValue
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c5CXQ.ScaffoldZoneGrid), {
                rowId: rowId,
                colId: colId
            })
        ]
    });
};
$dee64a049f150b21$export$dbbbdee3e4fba4de.displayName = "ScaffoldCell";

});
parcelRegister("c5CXQ", function(module, exports) {

$parcel$export(module.exports, "ScaffoldZoneGrid", function () { return $9233e4bb3a834d37$export$831bc2bab2690d94; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");

var $7bbQp = parcelRequire("7bbQp");

var $aLLqu = parcelRequire("aLLqu");
const $9233e4bb3a834d37$export$831bc2bab2690d94 = ({ rowId: rowId, colId: colId })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const [activeZone, setActiveZone] = (0, $spJKX.useState)(null);
    const [activeHighlightedZones, setActiveHighlightedZones] = (0, $spJKX.useState)(new Set());
    const [activeHighlightColor, setActiveHighlightColor] = (0, $spJKX.useState)(undefined);
    const [containerSize, setContainerSize] = (0, $spJKX.useState)({
        width: 0,
        height: 0
    });
    const divRef = (0, $spJKX.useRef)(null);
    /**
   * Resolves highlight behaviour for a zone from static or function-based zoneColors.
   *
   * @param zone - Zone being evaluated.
   * @returns Resolved highlight colour and additional highlighted zones.
   */ const resolveZoneHighlight = (zone)=>{
        const zoneColors = scaffoldContext.settings.zoneColors;
        const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
        const col = scaffoldContext.settings.columns.find((c)=>c.id === colId) ?? scaffoldContext.state.leavingCols.find((c)=>c.id === colId);
        if (typeof zoneColors === "function") return zoneColors({
            rowId: rowId,
            colId: colId,
            rowNumber: row?.rowNumber,
            colNumber: col?.colNumber,
            zone: zone
        });
        return {
            color: zoneColors[zone],
            additionalHighlightedZones: []
        };
    };
    (0, $spJKX.useLayoutEffect)(()=>{
        const el = divRef.current;
        /* istanbul ignore else */ if (el) {
            const observer = new ResizeObserver(([entry])=>{
                const { width: width, height: height } = entry.contentRect;
                setContainerSize({
                    width: width,
                    height: height
                });
            });
            observer.observe(el);
            return ()=>observer.disconnect();
        }
    }, []);
    /** Hide zones if the container is smaller than the minimum size for side zones */ const showHorizontalSides = containerSize.width >= (0, $aLLqu.SIDE_ZONE_MIN_SIZE);
    const showVerticalSides = containerSize.height >= (0, $aLLqu.SIDE_ZONE_MIN_SIZE);
    const visibleZones = (0, $aLLqu.ZONE_GRID_ORDER).filter((zone)=>{
        if (!showHorizontalSides && (0, $aLLqu.HORIZONTAL_SIDE_ZONES).has(zone)) return false;
        if (!showVerticalSides && (0, $aLLqu.VERTICAL_SIDE_ZONES).has(zone)) return false;
        return true;
    });
    const colTemplate = showHorizontalSides ? `${0, $aLLqu.SIDE_ZONE_SIZE}px 1fr 1fr ${0, $aLLqu.SIDE_ZONE_SIZE}px` : "1fr 1fr";
    const rowTemplate = showVerticalSides ? `${0, $aLLqu.SIDE_ZONE_SIZE}px 1fr 1fr ${0, $aLLqu.SIDE_ZONE_SIZE}px` : "1fr 1fr";
    /**
   * Clears any active zone highlight state.
   */ const clearActiveZoneHighlight = ()=>{
        setActiveZone(null);
        setActiveHighlightedZones(new Set());
        setActiveHighlightColor(undefined);
    };
    /**
   * Handles drag-over highlighting for a zone.
   *
   * @param event - Drag event from the hovered zone element.
   * @param zone - Zone currently being hovered.
   */ const onZoneDragOver = (event, zone)=>{
        const highlight = resolveZoneHighlight(zone);
        if (highlight.color !== null) {
            event.preventDefault();
            const highlightedZones = new Set([
                zone,
                ...highlight.additionalHighlightedZones ?? []
            ]);
            setActiveZone(zone);
            setActiveHighlightedZones(highlightedZones);
            setActiveHighlightColor(highlight.color);
        } else clearActiveZoneHighlight();
    };
    /**
   * Clears highlight state when the pointer leaves the zone-grid container.
   *
   * @param event - Drag leave event from any zone cell.
   */ const onZoneDragLeave = (event)=>{
        // Only clear zone if leaving entirely (not moving to a sibling zone in the grid)
        if (event.relatedTarget instanceof Node && event.currentTarget.parentElement?.contains(event.relatedTarget)) return;
        clearActiveZoneHighlight();
    };
    /**
   * Handles a drop for a zone, including optional drop suppression via zone-color resolver.
   *
   * @param event - Drop event from the target zone element.
   * @param zone - Zone receiving the drop.
   */ const onZoneDrop = (event, zone)=>{
        const highlight = resolveZoneHighlight(zone);
        if (highlight.color !== null) {
            event.preventDefault();
            event.stopPropagation();
            clearActiveZoneHighlight();
            scaffoldContext.dispatch({
                operation: (0, $7bbQp.SET_DRAGGING),
                isDragging: false
            });
            scaffoldContext.settings.onDrop?.(event, rowId, colId, zone);
        } else clearActiveZoneHighlight();
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: divRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).zoneGrid,
        style: {
            gridTemplateColumns: colTemplate,
            gridTemplateRows: rowTemplate,
            zIndex: scaffoldContext.state.isDragging && !scaffoldContext.settings.disabled ? 1 : -1
        },
        children: scaffoldContext.state.isDragging && visibleZones.map((zone)=>{
            const canonicalBounds = (0, $aLLqu.SCAFFOLD_ZONE_GRID_BOUNDS)[zone];
            const rowOffset = showVerticalSides ? 0 : 1;
            const colOffset = showHorizontalSides ? 0 : 1;
            const top = canonicalBounds.top - rowOffset;
            const bottom = canonicalBounds.bottom - rowOffset;
            const left = canonicalBounds.left - colOffset;
            const right = canonicalBounds.right - colOffset;
            return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                "data-zone": zone,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).zoneGridCell,
                onDragOver: (event)=>onZoneDragOver(event, zone),
                onDragLeave: onZoneDragLeave,
                onDrop: (event)=>onZoneDrop(event, zone),
                style: {
                    gridRow: `${top} / ${bottom}`,
                    gridColumn: `${left} / ${right}`,
                    backgroundColor: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? activeHighlightColor : "transparent",
                    opacity: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? 0.5 : 0,
                    border: activeZone !== null && activeHighlightedZones.has(zone) && activeHighlightColor !== undefined ? `2px solid ${activeHighlightColor}` : "none"
                }
            }, zone);
        })
    });
};
$9233e4bb3a834d37$export$831bc2bab2690d94.displayName = "ScaffoldZoneGrid";

});


parcelRegister("7sbB1", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowResizeHandle", function () { return $7d54a441721c3728$export$4451812414ec2bc2; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $3tKzd = parcelRequire("3tKzd");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");

var $7bbQp = parcelRequire("7bbQp");

var $aLLqu = parcelRequire("aLLqu");
const $7d54a441721c3728$export$4451812414ec2bc2 = ({ rowId: rowId })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const leavingRow = scaffoldContext.state.leavingRows.find((r)=>r.id === rowId);
    const row = scaffoldContext.settings.rows.find((r)=>r.id === rowId) ?? leavingRow;
    const canResize = scaffoldContext.settings.disabled !== true && scaffoldContext.settings.onChangeRow !== undefined && !leavingRow && row !== undefined && !scaffoldContext.state.enteringRowIds.has(rowId);
    const resizeSessionRef = (0, $spJKX.useRef)(null);
    const rowRef = (0, $spJKX.useRef)(row);
    const leavingRowRef = (0, $spJKX.useRef)(leavingRow);
    const onChangeRowRef = (0, $spJKX.useRef)(scaffoldContext.settings.onChangeRow);
    const dispatchRef = (0, $spJKX.useRef)(scaffoldContext.dispatch);
    /**
   * Keeps mutable refs synchronised with the latest row data for document-level mouse handlers.
   */ (0, $spJKX.useLayoutEffect)(()=>{
        rowRef.current = row;
        leavingRowRef.current = leavingRow;
        onChangeRowRef.current = scaffoldContext.settings.onChangeRow;
        dispatchRef.current = scaffoldContext.dispatch;
    }, [
        row,
        leavingRow,
        scaffoldContext.settings.onChangeRow,
        scaffoldContext.dispatch
    ]);
    /**
   * Applies transient row height updates while the user drags the resize handle.
   *
   * @param e - Native mouse move event from useMouseMove.
   */ const handleResizeMouseMove = (e)=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const nextHeight = Math.max((0, $aLLqu.MIN_SCAFFOLD_ROW_HEIGHT_PX), Math.round(session.startHeight + (e.clientY - session.startY)));
        if (nextHeight === session.latestHeight) return;
        session.latestHeight = nextHeight;
        dispatchRef.current({
            operation: (0, $7bbQp.PREVIEW_ROW_HEIGHT_CHANGE),
            rowId: rowId,
            height: nextHeight
        });
    };
    /**
   * Completes an active row resize, resets transient state, and emits a single row update.
   */ const handleResizeMouseUp = (0, $spJKX.useCallback)(()=>{
        const session = resizeSessionRef.current;
        /* istanbul ignore next -- listeners only attached during active resize */ if (session === null) return;
        const latestHeight = session.latestHeight;
        resizeSessionRef.current = null;
        dispatchRef.current({
            operation: (0, $7bbQp.PREVIEW_ROW_HEIGHT_CHANGE),
            rowId: rowId,
            height: null
        });
        const currentRow = rowRef.current;
        const currentLeavingRow = leavingRowRef.current;
        if (currentRow !== undefined && !currentLeavingRow && latestHeight !== currentRow.height) onChangeRowRef.current?.(rowId, {
            ...currentRow,
            height: latestHeight
        });
    }, [
        rowId
    ]);
    /**
   * Starts a row height drag operation from this resize handle.
   *
   * @param event - React mouse down event from the resize handle.
   */ const handleResizeMouseDown = (event)=>{
        if (canResize) {
            event.preventDefault();
            const initialHeight = Math.max((0, $aLLqu.MIN_SCAFFOLD_ROW_HEIGHT_PX), rowRef.current.height);
            resizeSessionRef.current = {
                startY: event.clientY,
                startHeight: initialHeight,
                latestHeight: initialHeight
            };
            dispatchRef.current({
                operation: (0, $7bbQp.PREVIEW_ROW_HEIGHT_CHANGE),
                rowId: rowId,
                height: initialHeight
            });
        }
    };
    /**
   * Clears transient preview state if the component unmounts mid-drag.
   */ (0, $spJKX.useEffect)(()=>{
        return ()=>{
            resizeSessionRef.current = null;
            dispatchRef.current({
                operation: (0, $7bbQp.PREVIEW_ROW_HEIGHT_CHANGE),
                rowId: rowId,
                height: null
            });
        };
    }, [
        rowId
    ]);
    const { onMouseDown: onMouseDown } = (0, $5EkSD.useMouseMove)({
        onMouseDown: handleResizeMouseDown,
        onMouseMove: handleResizeMouseMove,
        onMouseUp: handleResizeMouseUp,
        interactionEndEnabled: false,
        viewportResizeEnabled: false
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowResizeHandle,
            canResize ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowResizeHandleDisabled
        ]),
        onMouseDown: onMouseDown
    });
};
$7d54a441721c3728$export$4451812414ec2bc2.displayName = "ScaffoldRowResizeHandle";

});

parcelRegister("hQIFa", function(module, exports) {

$parcel$export(module.exports, "ScaffoldRowSelectHandle", function () { return $d2321aea993cb9eb$export$4095f1cf56c9041d; });

var $bR5nk = parcelRequire("bR5nk");

var $3tKzd = parcelRequire("3tKzd");

var $7bbQp = parcelRequire("7bbQp");
parcelRequire("dChVW");
var $ehtXd = parcelRequire("ehtXd");

var $aLLqu = parcelRequire("aLLqu");

var $h7u5p = parcelRequire("h7u5p");

var $f91EO = parcelRequire("f91EO");
const $d2321aea993cb9eb$export$4095f1cf56c9041d = ({ rowId: rowId })=>{
    const scaffoldContext = (0, $h7u5p.useScaffold)();
    const isSelected = (0, $ehtXd.isRowInSelection)(scaffoldContext.state.selection, rowId);
    return /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
        type: "button",
        "aria-label": "Select row",
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowSelectHandle,
            isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($f91EO))).rowSelectHandleSelected : undefined
        ]),
        style: {
            width: (0, $aLLqu.SCAFFOLD_SELECT_HANDLE_SIZE_PX)
        },
        onClick: (event)=>{
            event.preventDefault();
            scaffoldContext.dispatch({
                operation: (0, $7bbQp.ROW_CLICKED),
                rowId: rowId,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey,
                shiftKey: event.shiftKey
            });
        }
    });
};
$d2321aea993cb9eb$export$4095f1cf56c9041d.displayName = "ScaffoldRowSelectHandle";

});





parcelRegister("4Sj6S", function(module, exports) {
$parcel$export(module.exports, "totalSidebarItem", function () { return (parcelRequire("c5vs0")).totalSidebarItem; });
$parcel$export(module.exports, "isArsSidebarItemData", function () { return (parcelRequire("f4xry")).isArsSidebarItemData; });
parcelRequire("hGt3n");
parcelRequire("gulOL");
parcelRequire("jP6k0");
parcelRequire("8veDH");
parcelRequire("c5vs0");
parcelRequire("38bQC");
parcelRequire("55Z5Q");

});
parcelRegister("hGt3n", function(module, exports) {

$parcel$export(module.exports, "ArsDraggableSidebar", function () { return $22493f5565c5f784$export$9c5dc59b1a987623; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
parcelRequire("aoPxa");
var $fkJGt = parcelRequire("fkJGt");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $hOUj5 = parcelRequire("hOUj5");

var $knd99 = parcelRequire("knd99");

var $8vWHr = parcelRequire("8vWHr");

var $jP6k0 = parcelRequire("jP6k0");

var $eim8g = parcelRequire("eim8g");

var $c5vs0 = parcelRequire("c5vs0");
const $22493f5565c5f784$export$9c5dc59b1a987623 = ({ onItemDragStart: onItemDragStart, onItemDragEnd: onItemDragEnd, showGroupingFactors: showGroupingFactors = true, showOperations: showOperations = false, showTotalGroupingFactor: showTotalGroupingFactor = false, showVariables: showVariables = false, style: style })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const currentView = state.currentSidebar.view;
    const availableViews = [
        showGroupingFactors ? "groupingFactor" : null,
        showOperations ? "operation" : null,
        showVariables ? "variable" : null
    ].filter(Boolean);
    const filterText = state.currentSidebar.filter.toLowerCase();
    // Update current view if it is not available
    (0, $spJKX.useEffect)(()=>{
        if (availableViews.length > 0 && !availableViews.includes(currentView)) dispatch({
            operation: (0, $cJd2i.SET_SIDEBAR_VIEW),
            view: availableViews[0]
        });
    }, [
        availableViews,
        currentView,
        dispatch
    ]);
    if (availableViews.length === 0) return null;
    const groupingFactorItems = showGroupingFactors ? Object.values(state.groupingFactors).map((gf)=>({
            id: `ars-table-sidebar-grouping-factor-${gf.id}`,
            label: gf.description && gf.description.trim() !== "" ? gf.description.trim() : gf.name,
            data: {
                kind: (0, $jP6k0.ArsSidebarItemKind).GroupingFactor,
                dropItem: gf
            }
        })) : [];
    const analysisMethodItems = showOperations ? Object.values(state.analysisMethods).filter((am)=>!state.currentSidebar.analysisMethodId || state.currentSidebar.analysisMethodId && am.id === state.currentSidebar.analysisMethodId).flatMap((am)=>{
        const analysisItems = [
            {
                id: `ars-table-sidebar-analysis-method-${am.id}`,
                label: am.description && am.description.trim() !== "" ? am.description.trim() : am.name,
                data: {
                    kind: (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod,
                    dropItem: am
                }
            }
        ];
        const operationSidebarItems = am.operations.map((operation)=>({
                id: `ars-table-sidebar-operation-${operation.id}`,
                label: operation.label ?? operation.name,
                data: {
                    kind: (0, $jP6k0.ArsSidebarItemKind).Operation,
                    dropItem: operation,
                    analysisMethodId: am.id
                }
            }));
        return [
            ...analysisItems,
            ...operationSidebarItems
        ];
    }) : [];
    const variables = showVariables ? state.variables.filter((v)=>v.dataset === state.currentSidebar.dataset).map((v)=>({
            id: `ars-table-sidebar-variable-${v.oid}`,
            label: v.value,
            data: {
                kind: (0, $jP6k0.ArsSidebarItemKind).Variable,
                dropItem: v
            }
        })) : [];
    const sidebarItems = (currentView === "groupingFactor" ? [
        ...showTotalGroupingFactor ? [
            (0, $c5vs0.totalSidebarItem)
        ] : [],
        ...groupingFactorItems
    ] : currentView === "operation" ? analysisMethodItems : variables).filter((item)=>item.label.toLowerCase().includes(filterText));
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "d-flex justify-content-end align-items-start",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fkJGt.DraggableSidebar), {
            header: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "d-flex flex-column gap-2",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8vWHr.ArsSidebarViewRadio), {
                        showGroupingFactors: showGroupingFactors,
                        showOperations: showOperations,
                        showVariables: showVariables
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hOUj5.ArsSidebarFilter), {}),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eim8g.NewItemButton), {})
                ]
            }),
            id: "ars-draggable-sidebar",
            items: sidebarItems,
            multiSelect: true,
            onItemDragEnd: onItemDragEnd,
            onItemDragStart: onItemDragStart,
            RenderItem: (0, $knd99.ArsSidebarItem),
            style: style,
            title: "ARS sidebar",
            visible: true
        })
    });
};
$22493f5565c5f784$export$9c5dc59b1a987623.displayName = "ArsDraggableSidebar";

});
parcelRegister("hOUj5", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarFilter", function () { return $29e9ea5e84bca417$export$37caa1f917380740; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $bvonN = parcelRequire("bvonN");
const $29e9ea5e84bca417$export$37caa1f917380740 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            state.currentSidebar.view === "variable" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bvonN.DatasetSelect), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                id: "ars-sidebar-filter",
                size: "sm",
                type: "text",
                "aria-label": "Filter sidebar items",
                placeholder: "Filter items\u2026",
                value: state.currentSidebar.filter,
                onChange: (event)=>{
                    dispatch({
                        operation: (0, $cJd2i.SET_SIDEBAR_FILTER),
                        filter: event.currentTarget.value
                    });
                }
            })
        ]
    });
};
$29e9ea5e84bca417$export$37caa1f917380740.displayName = "ArsSidebarFilter";

});
parcelRegister("bvonN", function(module, exports) {

$parcel$export(module.exports, "DatasetSelect", function () { return $ec323444d996db90$export$d90fb6e23f5d91a5; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
const $ec323444d996db90$export$d90fb6e23f5d91a5 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const datasets = new Set(state.variables.map((v)=>v.dataset));
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Select, {
        id: "ars-sidebar-dataset-select",
        size: "sm",
        value: state.currentSidebar.dataset ?? "",
        disabled: datasets.size === 0,
        onChange: (event)=>{
            dispatch({
                operation: (0, $cJd2i.SET_SIDEBAR_DATASET),
                dataset: event.currentTarget.value
            });
        },
        children: [
            !datasets.has(state.currentSidebar.dataset ?? "") && /*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                value: "",
                children: "-- Select --"
            }),
            Array.from(datasets).map((dataset)=>/*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                    value: dataset,
                    children: dataset
                }, dataset))
        ]
    });
};
$ec323444d996db90$export$d90fb6e23f5d91a5.displayName = "DatasetSelect";

});


parcelRegister("knd99", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarItem", function () { return $bdf9193a946ba9a9$export$6b7fddce67934df4; });

var $bR5nk = parcelRequire("bR5nk");

var $gulOL = parcelRequire("gulOL");

var $jP6k0 = parcelRequire("jP6k0");

var $8veDH = parcelRequire("8veDH");

var $c5vs0 = parcelRequire("c5vs0");

var $55Z5Q = parcelRequire("55Z5Q");
const $bdf9193a946ba9a9$export$6b7fddce67934df4 = ({ item: item, selected: selected })=>{
    const resolvedItem = typeof item.data === "function" ? {
        ...item,
        data: item.data()
    } : item;
    return item.id === (0, $c5vs0.totalSidebarItem).id ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c5vs0.TotalGroupingFactorSidebarItem), {
        selected: selected
    }) : resolvedItem.data.kind === (0, $jP6k0.ArsSidebarItemKind).GroupingFactor ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gulOL.GroupingFactorSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : resolvedItem.data.kind === (0, $jP6k0.ArsSidebarItemKind).Operation || resolvedItem.data.kind === (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8veDH.OperationSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : resolvedItem.data.kind === (0, $jP6k0.ArsSidebarItemKind).Variable ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $55Z5Q.VariableSidebarItem), {
        item: resolvedItem,
        selected: selected
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        children: "Unknown sidebar item type"
    });
};
$bdf9193a946ba9a9$export$6b7fddce67934df4.displayName = "ArsSidebarItem";

});
parcelRegister("gulOL", function(module, exports) {

$parcel$export(module.exports, "GroupingFactorSidebarItem", function () { return $d1923eaa5b49acb0$export$72a518a9654d1160; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");
parcelRequire("d0WZT");
var $51n1k = parcelRequire("51n1k");
const $d1923eaa5b49acb0$export$72a518a9654d1160 = ({ item: item, selected: selected })=>{
    const groupingFactor = item.data.dropItem;
    const [showWindow, setShowWindow] = (0, $spJKX.useState)(false);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                className: "w-100",
                menuItems: [
                    {
                        label: showWindow ? "Hide properties" : "Show properties",
                        action: ()=>setShowWindow(!showWindow)
                    }
                ],
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: (0, $3tKzd.classMerge)([
                        "grouping-factor-sidebar-item",
                        "px-2",
                        "py-1",
                        "border",
                        "rounded",
                        "w-100",
                        selected ? "border-primary bg-primary-subtle" : ""
                    ]),
                    style: {
                        cursor: "grab"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "fw-semibold",
                            children: item.label
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                            className: "text-muted",
                            children: [
                                groupingFactor.dataDriven ? "Data driven" : "Groups",
                                " \u2022 ",
                                groupingFactor.name,
                                " ",
                                groupingFactor.disableEditing ? /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                                    className: "px-1",
                                    children: "\u2022 Read only"
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
                id: `grouping-factor-sidebar-item-${groupingFactor.id}-context-window`,
                title: `Grouping Factor: ${groupingFactor.name}`,
                visible: showWindow,
                onClose: ()=>setShowWindow(false),
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $51n1k.GroupingFactorControl), {
                    dataPath: `/groupingFactors/${groupingFactor.id}`,
                    canRename: true
                })
            })
        ]
    });
};
$d1923eaa5b49acb0$export$72a518a9654d1160.displayName = "GroupingFactorSidebarItem";

});

parcelRegister("8veDH", function(module, exports) {

$parcel$export(module.exports, "OperationSidebarItem", function () { return $177aa15068e9362d$export$33fd664cf87b548e; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");

var $321H1 = parcelRequire("321H1");

var $j32AA = parcelRequire("j32AA");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
const $177aa15068e9362d$export$33fd664cf87b548e = ({ item: item, selected: selected })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const [showWindow, setShowWindow] = (0, $spJKX.useState)(false);
    const isMethod = item.data.kind === "analysisMethod";
    const isOperation = item.data.kind === "operation";
    // Type assertion needed due to discriminated union limitation with generic components
    const analysisMethod = isMethod ? item.data.dropItem : null;
    const operation = isOperation ? item.data.dropItem : null;
    let operationControlProps = null;
    if (operation) for (const [analysisMethodId, method] of Object.entries(state.analysisMethods)){
        const operationIndex = method.operations.findIndex((methodOperation)=>methodOperation.id === operation.id);
        if (operationIndex >= 0) {
            operationControlProps = {
                dataPath: `/analysisMethods/${analysisMethodId}/operations/${operationIndex}`,
                siblingCount: method.operations.length,
                disableEditing: method.disableEditing
            };
            break;
        }
    }
    const windowTitle = analysisMethod ? `Analysis method: ${analysisMethod.name}` : `Operation: ${item.data.dropItem.name}`;
    const windowId = analysisMethod ? `analysis-method-sidebar-item-${analysisMethod.id}-context-window` : `operation-sidebar-item-${item.data.dropItem.id}-context-window`;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                className: "w-100",
                menuItems: [
                    {
                        label: showWindow ? "Hide properties" : "Show properties",
                        action: ()=>setShowWindow(!showWindow)
                    }
                ],
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, $3tKzd.classMerge)([
                        "operation-sidebar-item",
                        "px-2",
                        "py-1",
                        "border",
                        "rounded",
                        "w-100",
                        selected ? "border-primary bg-primary-subtle" : ""
                    ]),
                    style: {
                        cursor: "grab"
                    },
                    children: isMethod ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "fw-bold",
                                children: item.label
                            }),
                            analysisMethod && /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                                className: "text-muted",
                                children: [
                                    "Analysis method \u2022 ",
                                    analysisMethod.name,
                                    analysisMethod.disableEditing ? /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                                        className: "px-1",
                                        children: "\u2022 Read only"
                                    }) : null
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "fw-semibold",
                                children: item.label
                            }),
                            operation && /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                                className: "text-muted",
                                children: [
                                    operation.name,
                                    " ",
                                    operation.label && `\u{2022} ${operation.label}`,
                                    operationControlProps?.disableEditing ? /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                                        className: "px-1",
                                        children: "\u2022 Read only"
                                    }) : null
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextWindow), {
                id: windowId,
                title: windowTitle,
                visible: showWindow,
                onClose: ()=>setShowWindow(false),
                children: [
                    analysisMethod && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $321H1.AnalysisMethodControl), {
                        dataPath: `/analysisMethods/${analysisMethod.id}`,
                        canRename: true
                    }),
                    operation && operationControlProps && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j32AA.OperationControl), {
                        dataPath: operationControlProps.dataPath,
                        siblingCount: operationControlProps.siblingCount
                    })
                ]
            })
        ]
    });
};
$177aa15068e9362d$export$33fd664cf87b548e.displayName = "OperationSidebarItem";

});
parcelRegister("321H1", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodControl", function () { return $0781df223caca6ff$export$a77a2f024136e812; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
var $aHdRW = parcelRequire("aHdRW");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $ghR9g = parcelRequire("ghR9g");

var $cC8h9 = parcelRequire("cC8h9");

var $i0DBY = parcelRequire("i0DBY");

var $8MT0G = parcelRequire("8MT0G");

var $96lV1 = parcelRequire("96lV1");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");
const $0781df223caca6ff$export$a77a2f024136e812 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [activeTab, setActiveTab] = (0, $spJKX.useState)("named-object");
    const analysisMethod = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $ghR9g.isAnalysisMethod));
    const documentReferences = (0, $spJKX.useMemo)(()=>analysisMethod?.documentRefs ?? [], [
        analysisMethod
    ]);
    const operations = (0, $spJKX.useMemo)(()=>analysisMethod?.operations ?? [], [
        analysisMethod
    ]);
    const hasCodeTemplate = analysisMethod?.codeTemplate !== undefined;
    // Disable editing for parent templates
    if (analysisMethod?.disableEditing) disabled = true;
    // Check state settings for disableAnalysisMethodEdit
    if (state.disableAnalysisMethodEdit) disabled = true;
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $spJKX.useEffectEvent)((newTab)=>(0, $spJKX.startTransition)(()=>setActiveTab(newTab)));
    /**
   * Change the active document tab if it no longer exists.
   */ (0, $spJKX.useEffect)(()=>{
        if (activeTab.startsWith("document-references-") && documentReferences.length > 0 && parseInt(activeTab.split("-")[2], 10) >= documentReferences.length) updateActiveTab(`document-references-${documentReferences.length - 1}`);
        else if (activeTab.startsWith("document-references-") && documentReferences.length === 0) updateActiveTab(`named-object`);
    }, [
        operations.length,
        documentReferences.length,
        activeTab
    ]);
    /**
   * Handles adding a new document reference to the method.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod) {
            const documentReferenceCount = documentReferences.length;
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRefs/${documentReferenceCount}`,
                value: newDocumentReference
            });
        }
    };
    /**
   * Handles adding a new programming code template to the method.
   */ const handleAddCodeTemplate = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod && !hasCodeTemplate) {
            const newCodeTemplate = {
                context: "",
                code: "",
                parameters: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/codeTemplate`,
                value: newCodeTemplate
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            analysisMethod && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
                activeKey: activeTab,
                onSelect: (k)=>{
                    /* istanbul ignore else */ if (k) setActiveTab(k);
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default), {
                        variant: "tabs",
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "named-object",
                                    children: "Properties"
                                })
                            }),
                            documentReferences.length > 0 && documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default).Link, {
                                        eventKey: `document-references-${index}`,
                                        children: [
                                            "Document reference ",
                                            index + 1
                                        ]
                                    })
                                }, documentReference.referenceDocumentId)),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "code-template",
                                    children: "Code template"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: `operations`,
                                    children: "Operations"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                    eventKey: "parameters",
                                    children: "Parameters"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Content, {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "named-object",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                                        dataPath: dataPath,
                                        canRename: canRename,
                                        disabled: disabled
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                        id: `${idRoute}-add-document-reference`,
                                        onClick: handleAddDocumentReference,
                                        className: "d-flex align-items-center btn-sm btn-success m-2",
                                        disabled: disabled,
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                className: "me-2",
                                                children: "Add document reference"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                                        ]
                                    })
                                ]
                            }),
                            documentReferences.map((documentReference, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                                    eventKey: `document-references-${index}`,
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $96lV1.DocumentReferenceControl), {
                                        dataPath: `${dataPath}/documentRefs/${index}`,
                                        disabled: disabled,
                                        siblingCount: documentReferences.length
                                    }, `${documentReference.referenceDocumentId}-${index}`)
                                }, `${documentReference.referenceDocumentId}-${index}`)),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                eventKey: "code-template",
                                children: [
                                    hasCodeTemplate && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8MT0G.AnalysisProgrammingCodeTemplateControl), {
                                        dataPath: `${dataPath}/codeTemplate`,
                                        disabled: disabled
                                    }),
                                    !disabled && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                        id: `${idRoute}-add-code-template`,
                                        onClick: handleAddCodeTemplate,
                                        className: "d-flex align-items-center btn-sm btn-success",
                                        disabled: hasCodeTemplate,
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                className: "me-2",
                                                children: "Add code template"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                                eventKey: "parameters",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i0DBY.AnalysisMethodParametersControl), {
                                    dataPath: `${dataPath}/codeTemplate`,
                                    disabled: disabled
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                                eventKey: `operations`,
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cC8h9.AnalysisMethodOperationsControl), {
                                    dataPath: dataPath,
                                    disabled: disabled
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$0781df223caca6ff$export$a77a2f024136e812.displayName = "AnalysisMethodControl";

});
parcelRegister("cC8h9", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodOperationsControl", function () { return $9236eb71558d749d$export$2d02eae519161b1b; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $aHdRW = parcelRequire("aHdRW");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
var $2VxLR = parcelRequire("2VxLR");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");

var $j32AA = parcelRequire("j32AA");
const $9236eb71558d749d$export$2d02eae519161b1b = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const analysisMethod = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $ghR9g.isAnalysisMethod));
    const operations = analysisMethod?.operations ?? [];
    const [activeTab, setActiveTab] = (0, $spJKX.useState)(operations.length > 0 ? "operation-0" : "");
    /**
   * Handles adding a new operation to the method.
   */ const handleAddOperation = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && analysisMethod) {
            const operationCount = operations.length;
            const newOperation = {
                id: crypto.randomUUID(),
                name: `Operation_${operationCount + 1}`,
                label: `Operation ${operationCount + 1}`,
                description: "",
                order: operationCount,
                referencedOperationRelationships: [],
                resultPattern: ""
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/operations/${operationCount}`,
                value: newOperation
            });
        }
    };
    /**
   * Handles reordering operations and reapplies their sequential order values.
   *
   * @param newOperations - The operations in their new order.
   */ const handleReorderOperations = (newOperations)=>{
        /* istanbul ignore else -- reordering is disabled unless an analysis method is present */ if (!disabled && analysisMethod) dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: `${dataPath}/operations`,
            value: newOperations.map((operation, index)=>({
                    ...operation,
                    order: index
                }))
        });
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $spJKX.useEffectEvent)((newTab)=>(0, $spJKX.startTransition)(async ()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $spJKX.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= operations.length) updateActiveTab(operations.length > 0 ? "operation-0" : "");
        else if (activeTab === "" && operations.length > 0) updateActiveTab("operation-0");
    }, [
        operations.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-operations";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default), {
                variant: "tabs",
                className: "mb-3",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VxLR.ReorderableNavList), {
                    list: operations,
                    setList: handleReorderOperations,
                    getEventKey: (_operation, index)=>`operation-${index}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Content, {
                children: operations.map((operation, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                        eventKey: `operation-${index}`,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j32AA.OperationControl), {
                            dataPath: `${dataPath}/operations/${index}`,
                            disabled: disabled,
                            siblingCount: operations.length
                        })
                    }, operation.id))
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-operation`,
                onClick: handleAddOperation,
                className: "d-flex align-items-center btn-sm btn-success m-2",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add operation"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$9236eb71558d749d$export$2d02eae519161b1b.displayName = "AnalysisMethodOperationsControl";

});
parcelRegister("j32AA", function(module, exports) {

$parcel$export(module.exports, "OperationControl", function () { return $5a52d2b686d81114$export$1693b8e4288ddb91; });

var $bR5nk = parcelRequire("bR5nk");

var $eZYX7 = parcelRequire("eZYX7");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $5cJwY = parcelRequire("5cJwY");

var $d4ZHR = parcelRequire("d4ZHR");

var $2VKUu = parcelRequire("2VKUu");

var $j3kPF = parcelRequire("j3kPF");

var $a5JBX = parcelRequire("a5JBX");

var $jmOP2 = parcelRequire("jmOP2");

var $bRLeU = parcelRequire("bRLeU");
const $5a52d2b686d81114$export$1693b8e4288ddb91 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    let correctedDataPath = dataPath;
    // Find correct datapath for the operation in the analysisMethods
    if (correctedDataPath.startsWith("/operations/")) {
        let ix = -1;
        const holdingAnalysisMethod = Object.values(state.analysisMethods).find((am)=>{
            const thisIx = am.operations.findIndex((op)=>op.id === correctedDataPath.split("/").pop());
            ix = thisIx;
            return thisIx > -1;
        });
        /* istanbul ignore else */ if (holdingAnalysisMethod) correctedDataPath = `/analysisMethods/${holdingAnalysisMethod.id}/operations/${ix}`;
    }
    // Check state settings for disableAnalysisMethodEdit
    if (state.disableAnalysisMethodEdit) disabled = true;
    const operation = (0, $jwDoS.getFromDataPath)(correctedDataPath, state, (0, $j3kPF.isOperation));
    const relationships = operation?.referencedOperationRelationships ?? [];
    /**
   * Handles adding a new referenced operation relationship.
   */ const handleAddRelationship = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && operation) {
            const relationshipCount = relationships.length;
            const newRelationship = {
                id: crypto.randomUUID(),
                referencedOperationRole: {
                    controlledTerm: "NUMERATOR"
                },
                operationId: "",
                analysisId: "",
                description: ""
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${correctedDataPath}/referencedOperationRelationships/${relationshipCount}`,
                value: newRelationship
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            operation && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                        children: [
                            "Id: ",
                            operation.id
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: correctedDataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: correctedDataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${correctedDataPath}/resultPattern`,
                id: `${idRoute}-result-pattern`,
                label: "Result pattern",
                labelWidth: 2,
                placeholder: "Enter result pattern",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5cJwY.ArsBoolean), {
                dataPath: `${correctedDataPath}/denominatorOnly`,
                id: `${idRoute}-denominator-only`,
                label: "Denominator only",
                labelWidth: 2,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                combinedDataPath: `${correctedDataPath}/defaultTargetVariable`,
                id: `${idRoute}-default-target-variable`,
                label: "Default target variable",
                labelWidth: 2,
                disabled: disabled
            }),
            relationships.map((relationship, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $jmOP2.ReferencedOperationRelationshipControl), {
                    dataPath: `${correctedDataPath}/referencedOperationRelationships/${index}`,
                    disabled: disabled,
                    siblingCount: relationships.length
                }, relationship.id)),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-relationship`,
                onClick: handleAddRelationship,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add relationship"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$5a52d2b686d81114$export$1693b8e4288ddb91.displayName = "OperationControl";

});
parcelRegister("5cJwY", function(module, exports) {

$parcel$export(module.exports, "ArsBoolean", function () { return $075784f3b3b47234$export$b83579e3cc9aa2a8; });

var $bR5nk = parcelRequire("bR5nk");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $5kgoV = parcelRequire("5kgoV");

var $k9YO2 = parcelRequire("k9YO2");
const $075784f3b3b47234$export$b83579e3cc9aa2a8 = ({ dataPath: dataPath, disabled: disabled = false, falseIsUndefined: falseIsUndefined = false, id: id, label: label, labelWidth: labelWidth = 2, maxWidthCols: maxWidthCols = 12, tableDataPath: tableDataPath = false })=>{
    const ars = (0, $4hgF7.useArsContext)();
    const table = (0, $5kgoV.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    const value = (0, $jwDoS.getFromDataPath)(dataPath, sourceState, (v)=>typeof v === "boolean") ?? false;
    /**
   * Handles updating the boolean value in ArsContext state or ArsTable body data.
   *
   * @param e - The change event from the checkbox input.
   */ const handleChange = (e)=>{
        const newValue = e.target.checked;
        const updatedValue = falseIsUndefined && newValue === false ? undefined : newValue;
        if (tableDataPath) table.dispatch({
            operation: (0, $k9YO2.ARST_PATCH_DATA),
            dataPath: dataPath,
            value: updatedValue
        });
        else ars.dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: updatedValue
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
        controlId: `${id}`,
        as: (0, $31g00.default),
        className: "mb-1",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                column: true,
                md: labelWidth,
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                md: {
                    span: maxWidthCols - labelWidth
                },
                className: "d-flex align-items-center",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                    type: "switch",
                    name: id,
                    checked: value,
                    onChange: handleChange,
                    disabled: disabled
                })
            })
        ]
    });
};
$075784f3b3b47234$export$b83579e3cc9aa2a8.displayName = "ArsBoolean";

});
parcelRegister("5kgoV", function(module, exports) {

$parcel$export(module.exports, "ArsTableContextProvider", function () { return $e30ecba24bde4df8$export$7163c3f2ae2eebce; });
$parcel$export(module.exports, "useArsTable", function () { return $e30ecba24bde4df8$export$643c750033874924; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $c8cwJ = parcelRequire("c8cwJ");
parcelRequire("8fWCE");
var $lWi18 = parcelRequire("lWi18");
var $9Ua4K = parcelRequire("9Ua4K");

var $k9YO2 = parcelRequire("k9YO2");
const $e30ecba24bde4df8$export$945521e500a6f7d5 = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $e30ecba24bde4df8$export$7163c3f2ae2eebce = ({ children: children, bodyData: bodyData, calculatedTableRows: calculatedTableRows, settings: settings, updateBodyData: updateBodyData })=>{
    const { state: arsContextState } = (0, $4hgF7.useArsContext)();
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $c8cwJ.arsTableReducer), {
        analysisMethod: arsContextState.analysisMethods[bodyData.analysisMethodId],
        bodyData: bodyData,
        scaffoldModel: (0, $lWi18.buildArsTableScaffoldModel)(calculatedTableRows, settings.editorProps),
        calculatedTableRows: calculatedTableRows,
        settings: settings,
        changed: false,
        usedGroupingFactorIds: (0, $9Ua4K.computeUsedGroupingFactorIds)(bodyData),
        viewItem: undefined
    });
    // Update the stored analysis method if it has been updated via bodyData or in the parent context
    (0, $spJKX.useEffect)(()=>{
        const analysisMethod = arsContextState.analysisMethods[state.bodyData.analysisMethodId];
        if (!(0, $eBlbF.isEqual)(state.analysisMethod, analysisMethod) || state.bodyData.analysisMethodId !== (state.analysisMethod?.id ?? "")) dispatch({
            operation: (0, $k9YO2.ARST_SET_ANALYSIS_METHOD),
            analysisMethod: analysisMethod
        });
    }, [
        arsContextState.analysisMethods,
        state.analysisMethod,
        state.bodyData.analysisMethodId
    ]);
    // Synchronise any changes with the parent for body data and internally calculated rows
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state.bodyData, bodyData);
        // Send changes up
        if (!eq && state.bodyData.id === bodyData.id && state.changed) {
            updateBodyData(state.bodyData, state.calculatedTableRows ?? // istanbul ignore next
            []);
            dispatch({
                operation: (0, $k9YO2.ARST_CHANGE_SENT)
            });
        } else if (state.bodyData.id !== bodyData.id || !eq) dispatch({
            operation: (0, $k9YO2.ARST_LOAD_DATA),
            bodyData: bodyData
        });
    }, [
        bodyData,
        state.bodyData,
        state.calculatedTableRows,
        state.changed,
        updateBodyData
    ]);
    // Synchronise any tlfViewMode changes
    (0, $spJKX.useEffect)(()=>{
        if (!(0, $eBlbF.isEqual)(state.settings.tlfViewMode, settings.tlfViewMode)) dispatch({
            operation: (0, $k9YO2.ARST_SET_TLF_VIEW_MODE),
            tlfViewMode: settings.tlfViewMode
        });
    }, [
        settings.tlfViewMode,
        state.settings.tlfViewMode
    ]);
    // Synchronise any calculated row changes from the parent
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state.calculatedTableRows, calculatedTableRows);
        if (!eq && calculatedTableRows) dispatch({
            operation: (0, $k9YO2.ARST_UPDATE_SCAFFOLD),
            calculatedTableRows: calculatedTableRows
        });
    }, [
        calculatedTableRows,
        state.calculatedTableRows
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($e30ecba24bde4df8$export$945521e500a6f7d5.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$e30ecba24bde4df8$export$7163c3f2ae2eebce.displayName = "ArsTableContextProvider";
const $e30ecba24bde4df8$export$643c750033874924 = ()=>{
    const context = (0, $spJKX.useContext)($e30ecba24bde4df8$export$945521e500a6f7d5);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("c8cwJ", function(module, exports) {

$parcel$export(module.exports, "arsTableReducer", function () { return $92d527fd638ed1e9$export$a5201d85a1deb82f; });
parcelRequire("8fWCE");
var $3k3DP = parcelRequire("3k3DP");
var $8QhfH = parcelRequire("8QhfH");
var $umSOJ = parcelRequire("umSOJ");
var $13PzW = parcelRequire("13PzW");
var $19GEW = parcelRequire("19GEW");
var $9hujo = parcelRequire("9hujo");
var $igrOH = parcelRequire("igrOH");
var $kuulP = parcelRequire("kuulP");
var $cFA3U = parcelRequire("cFA3U");
var $hOK7P = parcelRequire("hOK7P");
var $blsOh = parcelRequire("blsOh");
var $dLEmP = parcelRequire("dLEmP");
var $xmY6k = parcelRequire("xmY6k");
var $1H4JF = parcelRequire("1H4JF");
var $8wTiM = parcelRequire("8wTiM");
var $5v6vb = parcelRequire("5v6vb");
var $60kjb = parcelRequire("60kjb");

var $k9YO2 = parcelRequire("k9YO2");
const $92d527fd638ed1e9$export$a5201d85a1deb82f = (state, action)=>{
    switch(action.operation){
        case 0, $k9YO2.ARST_CHANGE_SENT:
            return (0, $3k3DP.arst_changeSent)(state);
        case 0, $k9YO2.ARST_INSERT_COLUMN_AFTER:
        case 0, $k9YO2.ARST_INSERT_COLUMN_BEFORE:
        case 0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_AFTER:
        case 0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_BEFORE:
        case 0, $k9YO2.ARST_INSERT_OPERATION_ROW_AFTER:
        case 0, $k9YO2.ARST_INSERT_OPERATION_ROW_BEFORE:
        case 0, $k9YO2.ARST_INSERT_OPERATION_SUBGROUP:
        case 0, $k9YO2.ARST_INSERT_ROW_AFTER:
        case 0, $k9YO2.ARST_INSERT_ROW_BEFORE:
        case 0, $k9YO2.ARST_INSERT_SUBGROUP:
            return (0, $8QhfH.arst_insertDroppedItem)(state, action);
        case 0, $k9YO2.ARST_LOAD_DATA:
            return (0, $umSOJ.arst_loadData)(state, action);
        case 0, $k9YO2.ARST_PATCH_DATA:
            return (0, $13PzW.arst_patchData)(state, action);
        case 0, $k9YO2.ARST_REMOVE_GROUPINGFACTOR:
            return (0, $19GEW.arst_removeGroupingFactor)(state, action);
        case 0, $k9YO2.ARST_REMOVE_OPERATION:
            return (0, $9hujo.arst_removeOperation)(state, action);
        case 0, $k9YO2.ARST_SET_ANALYSIS_METHOD:
            return (0, $igrOH.arst_setAnalysisMethod)(state, action);
        case 0, $k9YO2.ARST_SET_SCAFFOLD_COL_WIDTH:
            return (0, $kuulP.arst_setScaffoldColWidth)(state, action);
        case 0, $k9YO2.ARST_SET_SCAFFOLD_ROW_HEIGHT:
            return (0, $cFA3U.arst_setScaffoldRowHeight)(state, action);
        case 0, $k9YO2.ARST_SET_TLF_VIEW_MODE:
            return (0, $hOK7P.arst_setTlfViewMode)(state, action);
        case 0, $k9YO2.ARST_SET_VIEW_ITEM:
            return (0, $blsOh.arst_setViewItem)(state, action);
        case 0, $k9YO2.ARST_TOGGLE_GROUP_LABEL_VISIBILITY:
            return (0, $dLEmP.arst_toggleGroupLabelVisibility)(state, action);
        case 0, $k9YO2.ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL:
            return (0, $1H4JF.arst_toggleInlineWithPreviousLevel)(state, action);
        case 0, $k9YO2.ARST_TOGGLE_GROUP_LABEL_INLINE:
            return (0, $xmY6k.arst_toggleInlineRowHeader)(state, action);
        case 0, $k9YO2.ARST_TOGGLE_SPACE_AFTER_GROUP:
            return (0, $8wTiM.arst_toggleSpaceAfterGroup)(state, action);
        case 0, $k9YO2.ARST_TOGGLE_SPACE_AFTER_SUBGROUPS:
            return (0, $5v6vb.arst_toggleSpaceAfterSubGroups)(state, action);
        case 0, $k9YO2.ARST_UPDATE_SCAFFOLD:
            return (0, $60kjb.arst_updateScaffold)(state, action);
    }
};

});
parcelRegister("8fWCE", function(module, exports) {
$parcel$export(module.exports, "arst_changeSent", function () { return (parcelRequire("3k3DP")).arst_changeSent; });
$parcel$export(module.exports, "arst_insertDroppedItem", function () { return (parcelRequire("8QhfH")).arst_insertDroppedItem; });
$parcel$export(module.exports, "arst_loadData", function () { return (parcelRequire("umSOJ")).arst_loadData; });
$parcel$export(module.exports, "arst_patchData", function () { return (parcelRequire("13PzW")).arst_patchData; });
$parcel$export(module.exports, "arst_removeGroupingFactor", function () { return (parcelRequire("19GEW")).arst_removeGroupingFactor; });
$parcel$export(module.exports, "arst_removeOperation", function () { return (parcelRequire("9hujo")).arst_removeOperation; });
$parcel$export(module.exports, "arst_resolveTargetPath", function () { return (parcelRequire("7qo9o")).arst_resolveTargetPath; });
$parcel$export(module.exports, "arst_setAnalysisMethod", function () { return (parcelRequire("igrOH")).arst_setAnalysisMethod; });
$parcel$export(module.exports, "arst_setScaffoldColWidth", function () { return (parcelRequire("kuulP")).arst_setScaffoldColWidth; });
$parcel$export(module.exports, "arst_setScaffoldRowHeight", function () { return (parcelRequire("cFA3U")).arst_setScaffoldRowHeight; });
$parcel$export(module.exports, "arst_setTlfViewMode", function () { return (parcelRequire("hOK7P")).arst_setTlfViewMode; });
$parcel$export(module.exports, "arst_setViewItem", function () { return (parcelRequire("blsOh")).arst_setViewItem; });
$parcel$export(module.exports, "arst_toggleGroupLabelVisibility", function () { return (parcelRequire("dLEmP")).arst_toggleGroupLabelVisibility; });
$parcel$export(module.exports, "arst_toggleInlineRowHeader", function () { return (parcelRequire("xmY6k")).arst_toggleInlineRowHeader; });
$parcel$export(module.exports, "arst_toggleInlineWithPreviousLevel", function () { return (parcelRequire("1H4JF")).arst_toggleInlineWithPreviousLevel; });
$parcel$export(module.exports, "arst_toggleSpaceAfterGroup", function () { return (parcelRequire("8wTiM")).arst_toggleSpaceAfterGroup; });
$parcel$export(module.exports, "arst_toggleSpaceAfterSubGroups", function () { return (parcelRequire("5v6vb")).arst_toggleSpaceAfterSubGroups; });
$parcel$export(module.exports, "arst_updateScaffold", function () { return (parcelRequire("60kjb")).arst_updateScaffold; });
$parcel$export(module.exports, "buildArsTableScaffoldModel", function () { return (parcelRequire("lWi18")).buildArsTableScaffoldModel; });
$parcel$export(module.exports, "buildArsTableZoneColors", function () { return (parcelRequire("3TPyB")).buildArsTableZoneColors; });
$parcel$export(module.exports, "computeUsedGroupingFactorIds", function () { return (parcelRequire("9Ua4K")).computeUsedGroupingFactorIds; });
$parcel$export(module.exports, "groupToTreeNode", function () { return (parcelRequire("hjdwt")).groupToTreeNode; });
parcelRequire("ei0PJ");
parcelRequire("3k3DP");
parcelRequire("8gYcX");
parcelRequire("8QhfH");
parcelRequire("umSOJ");
parcelRequire("13PzW");
parcelRequire("19GEW");
parcelRequire("9hujo");
parcelRequire("7qo9o");
parcelRequire("igrOH");
parcelRequire("kuulP");
parcelRequire("cFA3U");
parcelRequire("hOK7P");
parcelRequire("blsOh");
parcelRequire("dLEmP");
parcelRequire("xmY6k");
parcelRequire("1H4JF");
parcelRequire("bLVB2");
parcelRequire("8wTiM");
parcelRequire("5v6vb");
parcelRequire("60kjb");
parcelRequire("1twua");
parcelRequire("lWi18");
parcelRequire("3TPyB");
parcelRequire("9R8ZC");
parcelRequire("9Ua4K");
parcelRequire("9BhZI");
parcelRequire("7SquG");
parcelRequire("hjdwt");
parcelRequire("7UgoN");
parcelRequire("cA8Wl");

});
parcelRegister("ei0PJ", function(module, exports) {

$parcel$export(module.exports, "arst_groupingFactorToTableGroup", function () { return $1a2177b6c6e955e6$export$c39ac8d686174190; });
$parcel$export(module.exports, "arst_operationToTableGroup", function () { return $1a2177b6c6e955e6$export$ecb4203dbcf899c6; });
$parcel$export(module.exports, "arst_analysisMethodToTableGroup", function () { return $1a2177b6c6e955e6$export$e905566fc5d81d62; });
$parcel$export(module.exports, "arst_tableGroupDepth", function () { return $1a2177b6c6e955e6$export$51689c75fc7b9724; });

var $c5vs0 = parcelRequire("c5vs0");
parcelRequire("alciT");
var $6OSNn = parcelRequire("6OSNn");
var $hVpcI = parcelRequire("hVpcI");
const $1a2177b6c6e955e6$export$92ce999aba37533e = (group, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(group.label?.replaceAll("~", "\n") ?? group.name),
        group: group,
        groupId: group.id
    });
const $1a2177b6c6e955e6$export$c39ac8d686174190 = (groupingFactor, editorProps)=>({
        id: crypto.randomUUID(),
        groupingFactor: groupingFactor,
        groupingFactorId: groupingFactor.id,
        label: editorProps.textToT(groupingFactor.label?.replaceAll("~", "\n") ?? groupingFactor.name),
        isPlaceholder: groupingFactor.name === (0, $c5vs0.PLACEHOLDERGROUPINGFACTOR)
    });
const $1a2177b6c6e955e6$export$ecb4203dbcf899c6 = (operation, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(operation.label?.replaceAll("~", "\n") ?? operation.name),
        operation: operation,
        operationId: operation.id,
        targetVariable: operation.defaultTargetVariable ?? ""
    });
const $1a2177b6c6e955e6$export$e905566fc5d81d62 = (analysisMethod, editorProps)=>({
        id: crypto.randomUUID(),
        label: editorProps.textToT(analysisMethod.label?.replaceAll("~", "\n") ?? analysisMethod.name),
        analysisMethod: analysisMethod,
        analysisMethodId: analysisMethod.id,
        subGroups: analysisMethod.operations.map((operation)=>$1a2177b6c6e955e6$export$ecb4203dbcf899c6(operation, editorProps))
    });
const $1a2177b6c6e955e6$export$51689c75fc7b9724 = (group, editorProps)=>{
    const subGroups = "subGroups" in group && group.subGroups ? group.subGroups : [];
    const subGroupDepth = Math.max(...subGroups.map((subGroup)=>$1a2177b6c6e955e6$export$51689c75fc7b9724(subGroup, editorProps)), 0);
    let thisDepth = (0, $hVpcI.isArsTableSubGroupGroupingFactor)(group, editorProps.isT) && !group.hidden && (group.groupingFactor.dataDriven && group.groupingFactor.dataValues.length > 0 || !group.groupingFactor.dataDriven && group.groupingFactor.groups.length > 0) ? 2 : (0, $6OSNn.isArsTableOperation)(group, editorProps.isT) && group.hidden ? 0 : 1;
    if (group.inlineWithPreviousLevel) thisDepth = thisDepth - 1;
    return thisDepth + subGroupDepth;
};

});
parcelRegister("c5vs0", function(module, exports) {

$parcel$export(module.exports, "PLACEHOLDERGROUPINGFACTOR", function () { return $9497d4ef2fd89876$export$416a1f95adf53e00; });
$parcel$export(module.exports, "totalSidebarItem", function () { return $9497d4ef2fd89876$export$b81ccfe0ad0c2cd5; });
$parcel$export(module.exports, "TotalGroupingFactorSidebarItem", function () { return $9497d4ef2fd89876$export$70468526533b0af0; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");

var $jP6k0 = parcelRequire("jP6k0");
const $9497d4ef2fd89876$var$PLACEHOLDERLABEL = "Placeholder";
const $9497d4ef2fd89876$var$PLACEHOLDERDESCRIPTION = "Blank placeholder for display only";
const $9497d4ef2fd89876$export$416a1f95adf53e00 = "__placeholder__";
const $9497d4ef2fd89876$export$b81ccfe0ad0c2cd5 = {
    id: "placeholder-sidebar-item",
    label: $9497d4ef2fd89876$var$PLACEHOLDERLABEL,
    data: ()=>({
            kind: (0, $jP6k0.ArsSidebarItemKind).GroupingFactor,
            dropItem: {
                id: crypto.randomUUID(),
                name: $9497d4ef2fd89876$export$416a1f95adf53e00,
                label: $9497d4ef2fd89876$var$PLACEHOLDERLABEL,
                description: $9497d4ef2fd89876$var$PLACEHOLDERDESCRIPTION,
                groups: [],
                dataDriven: false,
                fromHierarchyId: (0, $cJd2i.CURRENT_HIERARCHY_ID)
            }
        })
};
const $9497d4ef2fd89876$export$70468526533b0af0 = ({ selected: selected })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: `px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`,
        style: {
            cursor: "grab"
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "fw-semibold",
                children: $9497d4ef2fd89876$var$PLACEHOLDERLABEL
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                className: "text-muted",
                children: $9497d4ef2fd89876$var$PLACEHOLDERDESCRIPTION
            })
        ]
    });
};
$9497d4ef2fd89876$export$70468526533b0af0.displayName = "TotalGroupingFactorSidebarItem";

});

parcelRegister("alciT", function(module, exports) {
$parcel$export(module.exports, "isArsTableBody", function () { return (parcelRequire("gwArU")).isArsTableBody; });
$parcel$export(module.exports, "isArsTableColumnGroupLabel", function () { return (parcelRequire("dYUuZ")).isArsTableColumnGroupLabel; });
$parcel$export(module.exports, "isArsTableColumnOperationCell", function () { return (parcelRequire("bc2Bd")).isArsTableColumnOperationCell; });
$parcel$export(module.exports, "isArsTableGroupCalculationDto", function () { return (parcelRequire("atjhL")).isArsTableGroupCalculationDto; });
$parcel$export(module.exports, "isArsTableHeaderCell", function () { return (parcelRequire("kpDSD")).isArsTableHeaderCell; });
$parcel$export(module.exports, "isArsTableHeaderRow", function () { return (parcelRequire("gp7zE")).isArsTableHeaderRow; });
$parcel$export(module.exports, "isArsTableOperation", function () { return (parcelRequire("6OSNn")).isArsTableOperation; });
$parcel$export(module.exports, "isArsTableRowHeaderCell", function () { return (parcelRequire("28uJJ")).isArsTableRowHeaderCell; });
$parcel$export(module.exports, "isArsTableSubGroupAnalysisMethod", function () { return (parcelRequire("hVpcI")).isArsTableSubGroupAnalysisMethod; });
$parcel$export(module.exports, "isArsTableSubGroupGroupingFactor", function () { return (parcelRequire("hVpcI")).isArsTableSubGroupGroupingFactor; });
parcelRequire("gwArU");
parcelRequire("N7CUN");
parcelRequire("9SGcw");
parcelRequire("b49qh");
parcelRequire("kiDiR");
parcelRequire("dYUuZ");
parcelRequire("bc2Bd");
parcelRequire("gSn3q");
parcelRequire("atjhL");
parcelRequire("kpDSD");
parcelRequire("gp7zE");
parcelRequire("6OSNn");
parcelRequire("fjj8Z");
parcelRequire("7CYqv");
parcelRequire("1Hly8");
parcelRequire("Aom8T");
parcelRequire("28uJJ");
parcelRequire("jusAh");
parcelRequire("hVpcI");

});
parcelRegister("gwArU", function(module, exports) {

$parcel$export(module.exports, "isArsTableBody", function () { return $e67ebe24ed15aae8$export$44ab8a672ac1389f; });

var $12Lyj = parcelRequire("12Lyj");

var $atjhL = parcelRequire("atjhL");

var $Aom8T = parcelRequire("Aom8T");
const $e67ebe24ed15aae8$export$44ab8a672ac1389f = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.analysisMethodId !== "string") return false;
    if (!Array.isArray(obj.columns) || obj.columns.some((col)=>!(0, $atjhL.isArsTableGroupCalculationDto)(col, isT))) return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof obj.dataSubsetId)) return false;
    if (!Array.isArray(obj.rowHeaders) || obj.rowHeaders.some((rh)=>!(0, $Aom8T.isArsTableRowHeader)(rh, isT))) return false;
    if (!Array.isArray(obj.rows) || obj.rows.some((row)=>!(0, $atjhL.isArsTableGroupCalculationDto)(row, isT))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("atjhL", function(module, exports) {

$parcel$export(module.exports, "isArsTableGroupCalculationDto", function () { return $fdffc6b61271ea29$export$203b2f7d0b312e07; });

var $6OSNn = parcelRequire("6OSNn");

var $hVpcI = parcelRequire("hVpcI");
const $fdffc6b61271ea29$export$203b2f7d0b312e07 = (obj, isT)=>(0, $hVpcI.isArsTableSubGroup)(obj, isT) || (0, $6OSNn.isArsTableOperation)(obj, isT);

});
parcelRegister("6OSNn", function(module, exports) {

$parcel$export(module.exports, "isArsTableOperation", function () { return $af1a20117bea54ce$export$1a71d9da30d9c479; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");
var $j3kPF = parcelRequire("j3kPF");

var $atjhL = parcelRequire("atjhL");
const $af1a20117bea54ce$export$1a71d9da30d9c479 = (obj, isT = (val)=>typeof val === "string")=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.decimalAlignPercent)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.dimension)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.spaceAfterGroup)) return false;
    if (!isT(obj.label)) return false;
    if (!(0, $j3kPF.isOperation)(obj.operation)) return false;
    if (typeof obj.operationId !== "string") return false;
    if (obj.subGroups !== undefined && (!Array.isArray(obj.subGroups) || obj.subGroups.some((subGroup)=>!(0, $atjhL.isArsTableGroupCalculationDto)(subGroup, isT)))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("hVpcI", function(module, exports) {

$parcel$export(module.exports, "isArsTableSubGroupAnalysisMethod", function () { return $0881c27e2d030d66$export$37d1de1a885b6445; });
$parcel$export(module.exports, "isArsTableSubGroupGroupingFactor", function () { return $0881c27e2d030d66$export$300858b96baac018; });
$parcel$export(module.exports, "isArsTableSubGroup", function () { return $0881c27e2d030d66$export$9135b42996dd97b6; });
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");
var $6PiIn = parcelRequire("6PiIn");
var $12Lyj = parcelRequire("12Lyj");

var $czm2N = parcelRequire("czm2N");

var $atjhL = parcelRequire("atjhL");
/**
 * Validates shared ArsTableSubGroup properties that all subgroup variants have.
 *
 * @param obj - The object to check
 * @param isT - A type guard function for the generic type T used in the subgroup label
 * @returns - True if all common subgroup fields are valid
 */ const $0881c27e2d030d66$var$isArsTableSubGroupBase = (obj, isT)=>{
    if (typeof obj.id !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.dimension)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.spaceAfterGroup)) return false;
    if (!isT(obj.label)) return false;
    if (obj.subGroups !== undefined && (!Array.isArray(obj.subGroups) || obj.subGroups.some((subGroup)=>!(0, $atjhL.isArsTableGroupCalculationDto)(subGroup, isT)))) return false;
    return true;
};
const $0881c27e2d030d66$export$37d1de1a885b6445 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.analysisMethodId !== "string") return false;
    if (!$0881c27e2d030d66$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (!(0, $ghR9g.isAnalysisMethod)(obj.analysisMethod)) return false;
    if (!Array.isArray(obj.subGroups)) return false;
    return true;
};
const $0881c27e2d030d66$export$9cebbe6bbf8073dc = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.groupId !== "string") return false;
    if (!$0881c27e2d030d66$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (!(0, $6PiIn.isGroup)(obj.group)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.isDataDriven)) return false;
    return true;
};
const $0881c27e2d030d66$export$300858b96baac018 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $czm2N.isGroupingFactor)(obj.groupingFactor)) return false;
    if (!$0881c27e2d030d66$var$isArsTableSubGroupBase(obj, isT)) return false;
    if (typeof obj.groupingFactorId !== "string") return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.spaceAfterSubGroups)) return false;
    return true;
};
const $0881c27e2d030d66$export$9135b42996dd97b6 = (obj, isT)=>$0881c27e2d030d66$export$300858b96baac018(obj, isT) || $0881c27e2d030d66$export$9cebbe6bbf8073dc(obj, isT) || $0881c27e2d030d66$export$37d1de1a885b6445(obj, isT);

});


parcelRegister("Aom8T", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowHeader", function () { return $1f3e704e66e3454e$export$b5fd69fb9037f7f3; });

var $12Lyj = parcelRequire("12Lyj");
const $1f3e704e66e3454e$export$b5fd69fb9037f7f3 = (obj, isT = (value)=>typeof value === "string")=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!Array.isArray(obj.heights) || obj.heights.some((h)=>typeof h !== "number")) return false;
    if (!isT(obj.label)) return false;
    if (typeof obj.width !== "number") return false;
    return true;
};

});


parcelRegister("N7CUN", function(module, exports) {

$parcel$export(module.exports, "isArsTableBodyCell", function () { return $858b7705c734a7d2$export$65000cda1567003b; });

var $gSn3q = parcelRequire("gSn3q");

var $7CYqv = parcelRequire("7CYqv");

var $1Hly8 = parcelRequire("1Hly8");

var $jusAh = parcelRequire("jusAh");
const $858b7705c734a7d2$export$65000cda1567003b = (obj, isT)=>(0, $gSn3q.isArsTableDataCell)(obj, isT) || (0, $7CYqv.isArsTableRowGroupCell)(obj, isT) || (0, $1Hly8.isArsTableRowGroupLabel)(obj, isT) || (0, $jusAh.isArsTableRowOperationCell)(obj, isT);

});
parcelRegister("gSn3q", function(module, exports) {

$parcel$export(module.exports, "isArsTableDataCell", function () { return $f38e332f03cad33b$export$3ecf0544bb36b9a7; });

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $f38e332f03cad33b$export$3ecf0544bb36b9a7 = (obj, isT)=>{
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).DataCell) return false;
    if (obj.targetType !== "data") return false;
    // Everything is good
    return true;
};

});
parcelRegister("k9YO2", function(module, exports) {

$parcel$export(module.exports, "ArsTableJustification", function () { return $0f1c75aa1b6479d6$export$7d9f6ee099b6db7b; });
$parcel$export(module.exports, "ArsTextJustification", function () { return $0f1c75aa1b6479d6$export$ee40378e59d6a6c; });
$parcel$export(module.exports, "defaultColumnWidth", function () { return $0f1c75aa1b6479d6$export$886404f422f393c4; });
$parcel$export(module.exports, "defaultRowHeight", function () { return $0f1c75aa1b6479d6$export$6936fd3acc6fc2ae; });
$parcel$export(module.exports, "ArsTableCellType", function () { return $0f1c75aa1b6479d6$export$47ff599de1827f35; });
$parcel$export(module.exports, "ARST_CHANGE_SENT", function () { return $0f1c75aa1b6479d6$export$cfed06c756844cf6; });
$parcel$export(module.exports, "ARST_LOAD_DATA", function () { return $0f1c75aa1b6479d6$export$5ada652acce7912f; });
$parcel$export(module.exports, "ARST_PATCH_DATA", function () { return $0f1c75aa1b6479d6$export$6ecacf39e0a26df2; });
$parcel$export(module.exports, "ARST_SET_ANALYSIS_METHOD", function () { return $0f1c75aa1b6479d6$export$97bd07d9bcc39649; });
$parcel$export(module.exports, "ARST_SET_SCAFFOLD_COL_WIDTH", function () { return $0f1c75aa1b6479d6$export$218f0f67ef351e1c; });
$parcel$export(module.exports, "ARST_SET_SCAFFOLD_ROW_HEIGHT", function () { return $0f1c75aa1b6479d6$export$155c0e95cab929f1; });
$parcel$export(module.exports, "ARST_SET_TLF_VIEW_MODE", function () { return $0f1c75aa1b6479d6$export$483d097f90c2cc26; });
$parcel$export(module.exports, "ARST_SET_VIEW_ITEM", function () { return $0f1c75aa1b6479d6$export$86669dc20b972f5a; });
$parcel$export(module.exports, "ARST_UPDATE_SCAFFOLD", function () { return $0f1c75aa1b6479d6$export$1a03622c6b060f45; });
$parcel$export(module.exports, "ARST_REMOVE_GROUPINGFACTOR", function () { return $0f1c75aa1b6479d6$export$70a7af7c9f0d8e12; });
$parcel$export(module.exports, "ARST_REMOVE_OPERATION", function () { return $0f1c75aa1b6479d6$export$c23f96b8e147acf0; });
$parcel$export(module.exports, "ARST_TOGGLE_GROUP_LABEL_INLINE", function () { return $0f1c75aa1b6479d6$export$537a49b218fbef41; });
$parcel$export(module.exports, "ARST_TOGGLE_GROUP_LABEL_VISIBILITY", function () { return $0f1c75aa1b6479d6$export$5c51c9231c63c37a; });
$parcel$export(module.exports, "ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL", function () { return $0f1c75aa1b6479d6$export$1b8f7a1b6e30aa10; });
$parcel$export(module.exports, "ARST_TOGGLE_SPACE_AFTER_GROUP", function () { return $0f1c75aa1b6479d6$export$38c7c667f2c4a00c; });
$parcel$export(module.exports, "ARST_TOGGLE_SPACE_AFTER_SUBGROUPS", function () { return $0f1c75aa1b6479d6$export$19a501fa0c145035; });
$parcel$export(module.exports, "ARST_INSERT_COLUMN_AFTER", function () { return $0f1c75aa1b6479d6$export$2c17c1ca0f467a4b; });
$parcel$export(module.exports, "ARST_INSERT_COLUMN_BEFORE", function () { return $0f1c75aa1b6479d6$export$b9122efadb51714e; });
$parcel$export(module.exports, "ARST_INSERT_ROW_AFTER", function () { return $0f1c75aa1b6479d6$export$1eae02ed16bfbdf5; });
$parcel$export(module.exports, "ARST_INSERT_ROW_BEFORE", function () { return $0f1c75aa1b6479d6$export$d07bcef33db63800; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_COLUMN_AFTER", function () { return $0f1c75aa1b6479d6$export$ad448d57afd9077; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_COLUMN_BEFORE", function () { return $0f1c75aa1b6479d6$export$d38b740e1f7a68d1; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_ROW_AFTER", function () { return $0f1c75aa1b6479d6$export$451ee3a8df697c4e; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_ROW_BEFORE", function () { return $0f1c75aa1b6479d6$export$adb710d4cbc8f45f; });
$parcel$export(module.exports, "ARST_INSERT_OPERATION_SUBGROUP", function () { return $0f1c75aa1b6479d6$export$64cf2863dc911646; });
$parcel$export(module.exports, "ARST_INSERT_SUBGROUP", function () { return $0f1c75aa1b6479d6$export$43e16b6ac3552ed5; });
var $0f1c75aa1b6479d6$export$7d9f6ee099b6db7b = /*#__PURE__*/ function(ArsTableJustification) {
    ArsTableJustification["Left"] = "left";
    ArsTableJustification["Center"] = "center";
    ArsTableJustification["Right"] = "right";
    return ArsTableJustification;
}({});
var $0f1c75aa1b6479d6$export$ee40378e59d6a6c = /*#__PURE__*/ function(ArsTextJustification) {
    ArsTextJustification["Default"] = "default";
    ArsTextJustification["Left"] = "left";
    ArsTextJustification["Center"] = "center";
    ArsTextJustification["Right"] = "right";
    ArsTextJustification["Decimal"] = "decimal";
    return ArsTextJustification;
}({});
const $0f1c75aa1b6479d6$export$886404f422f393c4 = 120;
const $0f1c75aa1b6479d6$export$6936fd3acc6fc2ae = 40;
var $0f1c75aa1b6479d6$export$47ff599de1827f35 = /*#__PURE__*/ function(ArsTableCellType) {
    ArsTableCellType["ColumnGroupCell"] = "columnGroupCell";
    ArsTableCellType["ColumnGroupLabel"] = "columnGroupLabel";
    ArsTableCellType["ColumnOperation"] = "columnOperation";
    ArsTableCellType["DataCell"] = "dataCell";
    ArsTableCellType["RowGroupCell"] = "rowGroupCell";
    ArsTableCellType["RowGroupLabel"] = "rowGroupLabel";
    ArsTableCellType["RowHeader"] = "rowHeader";
    ArsTableCellType["RowOperation"] = "rowOperation";
    return ArsTableCellType;
}({});
const $0f1c75aa1b6479d6$export$b92d99cadb25c9f8 = new Set([
    "rowGroupCell",
    "rowGroupLabel",
    "rowOperation"
]);
const $0f1c75aa1b6479d6$export$1db9ab1cef372d16 = new Set([
    "columnGroupCell",
    "columnGroupLabel",
    "columnOperation"
]);
const $0f1c75aa1b6479d6$export$ddfb028992d54455 = new Set([
    "rowHeader"
]);
const $0f1c75aa1b6479d6$export$137715ee943ad637 = new Set([
    "columnGroupLabel",
    "rowGroupLabel"
]);
const $0f1c75aa1b6479d6$export$a61d1802597b7710 = new Set([
    ...$0f1c75aa1b6479d6$export$1db9ab1cef372d16,
    ...$0f1c75aa1b6479d6$export$b92d99cadb25c9f8
]);
const $0f1c75aa1b6479d6$export$cfed06c756844cf6 = "ARST_CHANGE_SENT";
const $0f1c75aa1b6479d6$export$5ada652acce7912f = "ARST_LOAD_DATA";
const $0f1c75aa1b6479d6$export$6ecacf39e0a26df2 = "ARST_PATCH_DATA";
const $0f1c75aa1b6479d6$export$97bd07d9bcc39649 = "ARST_SET_ANALYSIS_METHOD";
const $0f1c75aa1b6479d6$export$218f0f67ef351e1c = "ARST_SET_SCAFFOLD_COL_WIDTH";
const $0f1c75aa1b6479d6$export$155c0e95cab929f1 = "ARST_SET_SCAFFOLD_ROW_HEIGHT";
const $0f1c75aa1b6479d6$export$e599521a5514fb1d = "ARST_SET_SIDEBAR_FILTER";
const $0f1c75aa1b6479d6$export$fefc559b78ddf85 = "ARST_SET_SIDEBAR_VIEW";
const $0f1c75aa1b6479d6$export$483d097f90c2cc26 = "ARST_SET_TLF_VIEW_MODE";
const $0f1c75aa1b6479d6$export$86669dc20b972f5a = "ARST_SET_VIEW_ITEM";
const $0f1c75aa1b6479d6$export$1a03622c6b060f45 = "ARST_UPDATE_SCAFFOLD";
const $0f1c75aa1b6479d6$export$70a7af7c9f0d8e12 = "ARST_REMOVE_GROUPINGFACTOR";
const $0f1c75aa1b6479d6$export$c23f96b8e147acf0 = "ARST_REMOVE_OPERATION";
const $0f1c75aa1b6479d6$export$537a49b218fbef41 = "ARST_TOGGLE_GROUP_LABEL_INLINE";
const $0f1c75aa1b6479d6$export$5c51c9231c63c37a = "ARST_TOGGLE_GROUP_LABEL_VISIBILITY";
const $0f1c75aa1b6479d6$export$1b8f7a1b6e30aa10 = "ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL";
const $0f1c75aa1b6479d6$export$38c7c667f2c4a00c = "ARST_TOGGLE_SPACE_AFTER_GROUP";
const $0f1c75aa1b6479d6$export$19a501fa0c145035 = "ARST_TOGGLE_SPACE_AFTER_SUBGROUPS";
const $0f1c75aa1b6479d6$export$2c17c1ca0f467a4b = "ARST_INSERT_COLUMN_AFTER";
const $0f1c75aa1b6479d6$export$b9122efadb51714e = "ARST_INSERT_COLUMN_BEFORE";
const $0f1c75aa1b6479d6$export$1eae02ed16bfbdf5 = "ARST_INSERT_ROW_AFTER";
const $0f1c75aa1b6479d6$export$d07bcef33db63800 = "ARST_INSERT_ROW_BEFORE";
const $0f1c75aa1b6479d6$export$ad448d57afd9077 = "ARST_INSERT_OPERATION_COLUMN_AFTER";
const $0f1c75aa1b6479d6$export$d38b740e1f7a68d1 = "ARST_INSERT_OPERATION_COLUMN_BEFORE";
const $0f1c75aa1b6479d6$export$451ee3a8df697c4e = "ARST_INSERT_OPERATION_ROW_AFTER";
const $0f1c75aa1b6479d6$export$adb710d4cbc8f45f = "ARST_INSERT_OPERATION_ROW_BEFORE";
const $0f1c75aa1b6479d6$export$64cf2863dc911646 = "ARST_INSERT_OPERATION_SUBGROUP";
const $0f1c75aa1b6479d6$export$43e16b6ac3552ed5 = "ARST_INSERT_SUBGROUP";

});

parcelRegister("9SGcw", function(module, exports) {

$parcel$export(module.exports, "isArsTableCellBase", function () { return $1b561e59646fc21f$export$2780cb1ef49f9bdd; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");
const $1b561e59646fc21f$export$2780cb1ef49f9bdd = (obj, isT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.annotationContent !== "string") return false;
    if (!Object.values((0, $k9YO2.ArsTableCellType)).includes(obj.cellType)) return false;
    if (typeof obj.dataPath !== "string") return false;
    if (!isT(obj.displayContent)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("7CYqv", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowGroupCell", function () { return $ac76e317646d1ecc$export$baa85814fe3f2d0c; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $ac76e317646d1ecc$export$baa85814fe3f2d0c = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupCell) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (typeof obj.targetType !== "string" || ![
        "analysisMethod",
        "groupingFactor"
    ].includes(obj.targetType)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("1Hly8", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowGroupLabel", function () { return $e3a8f3c0eada557a$export$b1f1aba6be74dad8; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $e3a8f3c0eada557a$export$b1f1aba6be74dad8 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupLabel) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (typeof obj.targetType !== "string" || ![
        "dataDriven",
        "group"
    ].includes(obj.targetType)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("jusAh", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowOperationCell", function () { return $9f16f3d29140e897$export$f296242daf9cf562; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $9f16f3d29140e897$export$f296242daf9cf562 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).RowOperation) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.height)) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.indents)) return false;
    if (typeof obj.targetId !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("b49qh", function(module, exports) {

var $N7CUN = parcelRequire("N7CUN");

var $kpDSD = parcelRequire("kpDSD");
const $6c5840c70849a43e$export$29b498ea8d90aec4 = (obj, isT)=>(0, $kpDSD.isArsTableHeaderCell)(obj, isT) || (0, $N7CUN.isArsTableBodyCell)(obj, isT);

});
parcelRegister("kpDSD", function(module, exports) {

$parcel$export(module.exports, "isArsTableHeaderCell", function () { return $e91a50ab8080e3e3$export$9b9801f30387dcd4; });

var $kiDiR = parcelRequire("kiDiR");

var $dYUuZ = parcelRequire("dYUuZ");

var $bc2Bd = parcelRequire("bc2Bd");

var $28uJJ = parcelRequire("28uJJ");
const $e91a50ab8080e3e3$export$9b9801f30387dcd4 = (obj, isT)=>(0, $kiDiR.isArsTableColumnGroupCell)(obj, isT) || (0, $dYUuZ.isArsTableColumnGroupLabel)(obj, isT) || (0, $bc2Bd.isArsTableColumnOperationCell)(obj, isT) || (0, $28uJJ.isArsTableRowHeaderCell)(obj, isT);

});
parcelRegister("kiDiR", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnGroupCell", function () { return $1f2d4d2397904193$export$f30dbcde1814eba3; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $1f2d4d2397904193$export$f30dbcde1814eba3 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupCell) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("dYUuZ", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnGroupLabel", function () { return $a90b898c4347c6af$export$cd51abffdf7e351d; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $a90b898c4347c6af$export$cd51abffdf7e351d = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupLabel) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.colSpan)) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.rowSpan)) return false;
    if (typeof obj.siblingCount !== "number") return false;
    if (typeof obj.targetId !== "string") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("bc2Bd", function(module, exports) {

$parcel$export(module.exports, "isArsTableColumnOperationCell", function () { return $a8f1bd564cf3bd68$export$fcdcc125580624b1; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $a8f1bd564cf3bd68$export$fcdcc125580624b1 = (obj, isT)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    if (obj.cellType !== (0, $k9YO2.ArsTableCellType).ColumnOperation) return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.hidden)) return false;
    if (typeof obj.targetId !== "string") return false;
    if (obj.targetType !== "operation") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.width)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("28uJJ", function(module, exports) {

$parcel$export(module.exports, "isArsTableRowHeaderCell", function () { return $b65574df422cc261$export$dd40550f5f871171; });

var $k9YO2 = parcelRequire("k9YO2");

var $9SGcw = parcelRequire("9SGcw");
const $b65574df422cc261$export$dd40550f5f871171 = (obj, isT)=>{
    if (!(0, $9SGcw.isArsTableCellBase)(obj, isT)) return false;
    const rowHeaderCell = obj;
    if (rowHeaderCell.cellType !== (0, $k9YO2.ArsTableCellType).RowHeader) return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof rowHeaderCell.width)) return false;
    // Everything is good
    return true;
};

});



parcelRegister("gp7zE", function(module, exports) {

$parcel$export(module.exports, "isArsTableHeaderRow", function () { return $a2a8f4f2fe1c787e$export$966b773f074095b5; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $kpDSD = parcelRequire("kpDSD");
const $a2a8f4f2fe1c787e$export$966b773f074095b5 = (obj, isT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.height !== "number") return false;
    if (!Array.isArray(obj.arsTableCells) || obj.arsTableCells.some((cell)=>!(0, $kpDSD.isArsTableHeaderCell)(cell, isT))) return false;
    // Everything is good
    return true;
};

});

parcelRegister("fjj8Z", function(module, exports) {

var $kkQBS = parcelRequire("kkQBS");

var $gp7zE = parcelRequire("gp7zE");
const $ed53c4d7f98d9649$export$1e1e66a8334346dd = (obj, isT)=>(0, $gp7zE.isArsTableHeaderRow)(obj, isT) || (0, $kkQBS.isArsTableBodyRow)(obj, isT);

});
parcelRegister("kkQBS", function(module, exports) {

$parcel$export(module.exports, "isArsTableBodyRow", function () { return $217fa573f4747d3c$export$87de302a2225036b; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $N7CUN = parcelRequire("N7CUN");
const $217fa573f4747d3c$export$87de302a2225036b = (obj, isT)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.height !== "number") return false;
    if (typeof obj.rowGroup !== "number") return false;
    if (![
        "boolean",
        "undefined"
    ].includes(typeof obj.spaceAfterGroup)) return false;
    if (!Array.isArray(obj.arsTableCells) || obj.arsTableCells.some((cell)=>!(0, $N7CUN.isArsTableBodyCell)(cell, isT))) return false;
    // Everything is good
    return true;
};

});




parcelRegister("3k3DP", function(module, exports) {

$parcel$export(module.exports, "arst_changeSent", function () { return $06795107f5279363$export$c402551ff46b4719; });
const $06795107f5279363$export$c402551ff46b4719 = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("8gYcX", function(module, exports) {

$parcel$export(module.exports, "arst_checkRowHeaders", function () { return $593eece15d30f22b$export$f85f9a86e4c625f2; });

var $k9YO2 = parcelRequire("k9YO2");

var $ei0PJ = parcelRequire("ei0PJ");

var $1twua = parcelRequire("1twua");
const $593eece15d30f22b$export$f85f9a86e4c625f2 = (bodyData, editorProps)=>{
    const columnDepth = Math.max(...bodyData.columns.map((group)=>(0, $ei0PJ.arst_tableGroupDepth)(group, editorProps)), 1);
    const rowDepth = Math.max(...bodyData.rows.map((group)=>(0, $ei0PJ.arst_tableGroupDepth)(group, editorProps)), 1);
    const rowHeaderTemplate = (0, $1twua.blankRowHeaderCell)(editorProps.blankT, columnDepth);
    // Check that a change is required
    if (bodyData.rowHeaders.length === rowDepth && bodyData.rowHeaders.every((rowHeader)=>rowHeader.heights.length === columnDepth && rowHeader.heights.every((height)=>height === rowHeaderTemplate.heights[0]))) return bodyData.rowHeaders;
    // Otherwise create new rowHeaders with correct heights and number of cells
    const currentRowHeights = bodyData.rowHeaders.length > 0 ? bodyData.rowHeaders[0].heights : [];
    const newRowHeights = [
        ...currentRowHeights.slice(0, columnDepth),
        ...Array.from({
            length: columnDepth - currentRowHeights.length
        }, ()=>(0, $k9YO2.defaultRowHeight))
    ];
    const newRowHeaders = [
        ...bodyData.rowHeaders.slice(0, rowDepth).map((rowHeader)=>({
                ...rowHeader,
                heights: newRowHeights
            })),
        ...Array.from({
            length: rowDepth - bodyData.rowHeaders.length
        }, ()=>({
                ...rowHeaderTemplate
            }))
    ];
    return newRowHeaders;
};

});
parcelRegister("1twua", function(module, exports) {

$parcel$export(module.exports, "blankRowHeaderCell", function () { return $7212cc9151e07102$export$c3378a17afe7beab; });

var $k9YO2 = parcelRequire("k9YO2");
const $7212cc9151e07102$export$c3378a17afe7beab = (blankT, columnHeaderHeights)=>({
        width: (0, $k9YO2.defaultColumnWidth),
        label: blankT,
        heights: Array.isArray(columnHeaderHeights) ? columnHeaderHeights : Array(columnHeaderHeights).fill((0, $k9YO2.defaultRowHeight))
    });

});


parcelRegister("8QhfH", function(module, exports) {

$parcel$export(module.exports, "arst_insertDroppedItem", function () { return $92cc0b8a38a0ed67$export$807a30f214efc0ee; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $km9RG = parcelRequire("km9RG");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $7qo9o = parcelRequire("7qo9o");

var $7UgoN = parcelRequire("7UgoN");
const $92cc0b8a38a0ed67$export$807a30f214efc0ee = (state, action)=>{
    const targetCell = state.scaffoldModel?.cellData?.[action.rowId]?.[action.columnId];
    if (!targetCell) return state;
    const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(targetCell.dataPath);
    // Get path parts here
    const targetPathParts = targetDataPath.split("/").filter(Boolean);
    // Resolve if column or row
    const isInsertColumn = [
        (0, $k9YO2.ARST_INSERT_COLUMN_AFTER),
        (0, $k9YO2.ARST_INSERT_COLUMN_BEFORE),
        (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_AFTER),
        (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_BEFORE)
    ].includes(action.operation);
    // Inserting at start of root
    let groupsPath = isInsertColumn ? "/columns" : "/rows";
    let insertIndex = 0;
    // Insert subGroup under target group
    if ([
        (0, $k9YO2.ARST_INSERT_SUBGROUP),
        (0, $k9YO2.ARST_INSERT_OPERATION_SUBGROUP)
    ].includes(action.operation)) {
        // Get target group
        const currentGroup = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
        // Abort if target is not found
        if (!currentGroup) return state;
        // Get new subGroups for the current group
        groupsPath = `${targetDataPath}/subGroups`;
        insertIndex = currentGroup.subGroups?.length ?? 0;
    } else // Adding at a lower level within the hierarchy
    if (targetPathParts.length > 0 && targetPathParts[0] !== "rowHeaders") {
        const thisIndex = parseInt(targetPathParts[targetPathParts.length - 1], 10);
        if (Number.isNaN(thisIndex)) return state;
        // Resolve if before or after
        const isInsertAfter = [
            (0, $k9YO2.ARST_INSERT_COLUMN_AFTER),
            (0, $k9YO2.ARST_INSERT_ROW_AFTER),
            (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_AFTER),
            (0, $k9YO2.ARST_INSERT_OPERATION_ROW_AFTER)
        ].includes(action.operation);
        // Update inserting index if inserting after
        insertIndex = thisIndex + (isInsertAfter ? 1 : 0);
        // Update table groups, either rows or columns
        const parentPath = (0, $km9RG.reduceDataPath)(targetDataPath, 2);
        const parentGroup = (0, $jwDoS.getFromDataPath)(parentPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
        if (parentGroup) groupsPath = `${parentPath}/subGroups`;
    // Inserting at root level uses the same position as the header drop path.
    }
    return (0, $7UgoN.insertItemAt)(state, action.payload, groupsPath, insertIndex);
};

});
parcelRegister("7qo9o", function(module, exports) {

$parcel$export(module.exports, "arst_resolveTargetPath", function () { return $1ac6104988be884c$export$13cf4a2dbbe8a783; });
parcelRequire("5SMPf");
var $km9RG = parcelRequire("km9RG");
function $1ac6104988be884c$export$13cf4a2dbbe8a783(inp) {
    // Standard string
    if (typeof inp === "string") {
        const pathParts = inp.split("/").filter(Boolean);
        // Check for dataValues/groups
        if ([
            "dataValues",
            "groups"
        ].includes(pathParts[pathParts.length - 2])) pathParts.splice(-2, 2);
        return `/${pathParts.join("/")}`;
    } else return "targetType" in inp.cellValue && [
        "group",
        "dataDriven"
    ].includes(inp.cellValue.targetType) ? (0, $km9RG.reduceDataPath)(inp.cellValue.dataPath, 2) : inp.cellValue.dataPath;
}

});

parcelRegister("7UgoN", function(module, exports) {

$parcel$export(module.exports, "insertItemAt", function () { return $3bd772b4a3461a33$export$67c9d98e9da0a5c1; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");

var $jP6k0 = parcelRequire("jP6k0");
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");
var $czm2N = parcelRequire("czm2N");
var $j3kPF = parcelRequire("j3kPF");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $ei0PJ = parcelRequire("ei0PJ");

var $8gYcX = parcelRequire("8gYcX");

var $9R8ZC = parcelRequire("9R8ZC");

var $cA8Wl = parcelRequire("cA8Wl");
const $3bd772b4a3461a33$export$67c9d98e9da0a5c1 = (state, payload, groupsPath, insertIndex)=>{
    // Create new table groups from the dropped item
    const newTableGroups = payload.map((item)=>item.dropItem).map((item)=>{
        return (0, $czm2N.isGroupingFactor)(item) ? (0, $ei0PJ.arst_groupingFactorToTableGroup)(item, state.settings.editorProps) : (0, $j3kPF.isOperation)(item) ? (0, $ei0PJ.arst_operationToTableGroup)(item, state.settings.editorProps) : (0, $ghR9g.isAnalysisMethod)(item) ? (0, $ei0PJ.arst_analysisMethodToTableGroup)(item, state.settings.editorProps) : null;
    }).filter((group)=>group !== null);
    if (newTableGroups.length === 0) return state;
    // Update AnalysisMethodId
    const droppedAnalysisMethodIds = [
        ...payload.filter((item)=>item.kind === "analysisMethod").map((item)=>item.dropItem.id),
        ...payload.filter((item)=>item.kind === "operation").map((item)=>item.analysisMethodId)
    ];
    const newAnalysisMethodIds = new Set([
        state.bodyData.analysisMethodId,
        ...droppedAnalysisMethodIds
    ].filter(Boolean));
    if (newAnalysisMethodIds.size > 1) // Abort if multiple analysis methods are being inserted or if the new analysis method is different from the current one
    return state;
    const currentGroups = (0, $jwDoS.getFromDataPath)(groupsPath, state.bodyData, (value)=>Array.isArray(value) && value.every((group)=>(0, $atjhL.isArsTableGroupCalculationDto)(group, state.settings.editorProps.isT)));
    const newGroups = [
        ...currentGroups ?? []
    ];
    newGroups.splice(insertIndex, 0, ...newTableGroups);
    let newBodyData = (0, $67RwR.mutateByPath)(state.bodyData, groupsPath, newGroups);
    const sourcePath = newTableGroups.flatMap((group, index)=>{
        const path = `${groupsPath}/${insertIndex + index}`;
        return [
            ...(0, $9R8ZC.collectParameterPaths)(group, path, "groupingFactor"),
            ...(0, $9R8ZC.collectParameterPaths)(group, path, "operation")
        ];
    }).at(0);
    // Sync after dropping
    if (state.analysisMethod && sourcePath) newBodyData = (0, $cA8Wl.syncParameters)(newBodyData, sourcePath, state.analysisMethod, state.settings.editorProps.isT, true);
    // Track new used grouping factor IDs
    const newGroupingFactorIds = new Set(state.usedGroupingFactorIds);
    payload.forEach((item)=>{
        if (item.kind === (0, $jP6k0.ArsSidebarItemKind).GroupingFactor) newGroupingFactorIds.add(item.dropItem.id);
    });
    // Check and update row headers after inserting new subgroups or siblings
    newBodyData.rowHeaders = (0, $8gYcX.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    return {
        ...state,
        bodyData: {
            ...newBodyData,
            analysisMethodId: newAnalysisMethodIds.values().next().value ?? ""
        },
        usedGroupingFactorIds: newGroupingFactorIds,
        changed: true
    };
};

});
parcelRegister("9R8ZC", function(module, exports) {

$parcel$export(module.exports, "collectParameterPaths", function () { return $7ed6390accbb02bf$export$977c32412673f94f; });
const $7ed6390accbb02bf$export$977c32412673f94f = (group, path, valueSource)=>[
        ...(valueSource === "operation" ? "operationId" : "groupingFactorId") in group ? [
            path
        ] : [],
        ...group.subGroups?.flatMap((child, index)=>$7ed6390accbb02bf$export$977c32412673f94f(child, `${path}/subGroups/${index}`, valueSource)) ?? []
    ];

});

parcelRegister("cA8Wl", function(module, exports) {

$parcel$export(module.exports, "syncParameters", function () { return $ef05f618d2247bd6$export$c9934d205c35fd16; });

var $3ew5o = parcelRequire("3ew5o");

var $jwDoS = parcelRequire("jwDoS");

var $67RwR = parcelRequire("67RwR");

var $9Ag83 = parcelRequire("9Ag83");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $9R8ZC = parcelRequire("9R8ZC");
const $ef05f618d2247bd6$export$c9934d205c35fd16 = (body, itemPath, inheritedMethod, isT, inserting = false)=>{
    /** Segments of the JSON Pointer identifying the edited item. */ const pathParts = itemPath.split("/").filter(Boolean);
    /** Table axis containing the edited item. */ const section = pathParts[0];
    /** Index of the edited item's owning table group. */ const ownerIndex = Number(pathParts[1]);
    if (section !== "columns" && section !== "rows" || !Number.isInteger(ownerIndex) || ownerIndex < 0 || ownerIndex >= body[section].length) return body;
    /** The operation or grouping factor addressed by the edited path. */ const source = (0, $jwDoS.getFromDataPath)(itemPath, body, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, isT));
    if (!source || !("operationId" in source || "groupingFactorId" in source)) return body;
    /** Parameter value source represented by the edited item. */ const valueSource = "operationId" in source ? "operation" : "groupingFactor";
    /** Identifier property used to determine whether every group has the same source type. */ const sourceKey = valueSource === "operation" ? "operationId" : "groupingFactorId";
    /** Groups on the same table axis as the edited item. */ const tableGroups = body[section];
    /** Group that owns the edited item. */ const owner = tableGroups[ownerIndex];
    /** Paths to matching parameter items, limited to sibling operations when syncing operations. */ const targets = (tableGroups.every((group)=>sourceKey in group) ? tableGroups.flatMap((group, index)=>(0, $9R8ZC.collectParameterPaths)(group, `/${section}/${index}`, valueSource)) : (0, $9R8ZC.collectParameterPaths)(owner, `/${section}/${ownerIndex}`, valueSource)).filter((targetPath)=>valueSource !== "operation" || targetPath.slice(0, targetPath.lastIndexOf("/")) === itemPath.slice(0, itemPath.lastIndexOf("/")));
    /** Method parameters applicable to the edited item's value source. */ const parameters = inheritedMethod.codeTemplate?.parameters?.filter((parameter)=>parameter.valueSource === valueSource) ?? [];
    /** Existing matching items used to seed values when the edited item was just inserted. */ const peerItems = inserting ? targets.filter((targetPath)=>targetPath !== itemPath).map((targetPath)=>(0, $jwDoS.getFromDataPath)(targetPath, body, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, isT))).filter((target)=>target !== undefined) : [];
    /** Existing peer chosen as the value source for a newly inserted item, if applicable. */ const sourceForSync = inserting ? peerItems.find((peer)=>parameters.some((parameter)=>peer.parameters?.[(0, $9Ag83.normalizeParameterName)(parameter.name)] !== undefined) || "operationId" in peer && peer.targetVariable !== "") ?? peerItems[0] : source;
    if (!sourceForSync) return body;
    /** Body copy updated as each matching parameter value is synchronised. */ let result = body;
    /** Each applicable method parameter to synchronise. */ for (const parameter of parameters)/** Each item path receiving the current parameter value. */ for (const targetPath of targets){
        /** JSON Pointer to the current parameter value. */ const parameterPath = (0, $3ew5o.Pointer).fromJSON(`${targetPath}/parameters`);
        parameterPath.push((0, $9Ag83.normalizeParameterName)(parameter.name));
        result = (0, $67RwR.mutateByPath)(result, parameterPath.toString(), sourceForSync.parameters?.[(0, $9Ag83.normalizeParameterName)(parameter.name)]);
    }
    /** Each item path receiving the operation's target variable. */ if ("operationId" in sourceForSync) /** Each target path whose operation target variable is synchronised. */ for (const targetPath of targets)result = (0, $67RwR.mutateByPath)(result, `${targetPath}/targetVariable`, sourceForSync.targetVariable);
    return result;
};

});
parcelRegister("9Ag83", function(module, exports) {

$parcel$export(module.exports, "normalizeParameterName", function () { return $f4bb530e00ffacf5$export$d7c443851ddd561; });
/**
 * Normalizes a parameter name to the format used by the application and back end.
 *
 * Invalid characters are removed and the casing is adjusted to match how parameter
 * names are serialised as dictionary keys by the back end. This ensures the parameter
 * name remains consistent after a round trip.
 *
 * @param name - The parameter name to normalize.
 * @returns The normalized parameter name.
 */ const $f4bb530e00ffacf5$export$d7c443851ddd561 = (name)=>{
    const normalizedName = name.replace(/[^a-zA-Z0-9_-]/g, "");
    if (normalizedName === "" || !$f4bb530e00ffacf5$var$isUpperCase(normalizedName[0])) return normalizedName;
    const chars = normalizedName.split("");
    for(let i = 0; i < chars.length; i++){
        if (i === 1 && !$f4bb530e00ffacf5$var$isUpperCase(chars[i])) break;
        if (i > 0 && i + 1 < chars.length && !$f4bb530e00ffacf5$var$isUpperCase(chars[i + 1])) break;
        chars[i] = chars[i].toLowerCase();
    }
    return chars.join("");
};
/**
 * Checks whether a character is an uppercase letter.
 *
 * @param char - The character to check.
 * @returns Whether the character is an uppercase letter.
 */ const $f4bb530e00ffacf5$var$isUpperCase = (char)=>char !== char.toLowerCase() && char === char.toUpperCase();

});




parcelRegister("umSOJ", function(module, exports) {

$parcel$export(module.exports, "arst_loadData", function () { return $ff9891a464137c79$export$30f618da6e7a7d27; });

var $9Ua4K = parcelRequire("9Ua4K");
const $ff9891a464137c79$export$30f618da6e7a7d27 = (state, action)=>({
        ...state,
        bodyData: action.bodyData,
        usedGroupingFactorIds: (0, $9Ua4K.computeUsedGroupingFactorIds)(action.bodyData),
        changed: false
    });

});
parcelRegister("9Ua4K", function(module, exports) {

$parcel$export(module.exports, "computeUsedGroupingFactorIds", function () { return $cdd21fc9da7dfc8a$export$695e8c0c21c59820; });
/**
 * Recursively collects all grouping factor IDs present in an ArsTable group tree.
 *
 * @param groups - The array of table groups to inspect
 * @param ids - Set to accumulate IDs into
 */ const $cdd21fc9da7dfc8a$var$collectGroupingFactorIds = (groups, ids)=>{
    for (const group of groups){
        if ("groupingFactor" in group) ids.add(group.groupingFactor.id);
        if ("subGroups" in group && group.subGroups) $cdd21fc9da7dfc8a$var$collectGroupingFactorIds(group.subGroups, ids);
    }
};
const $cdd21fc9da7dfc8a$export$695e8c0c21c59820 = (bodyData)=>{
    const ids = new Set();
    $cdd21fc9da7dfc8a$var$collectGroupingFactorIds(bodyData.columns, ids);
    $cdd21fc9da7dfc8a$var$collectGroupingFactorIds(bodyData.rows, ids);
    return ids;
};

});


parcelRegister("13PzW", function(module, exports) {

$parcel$export(module.exports, "arst_patchData", function () { return $0ee72a5ef0efe0d2$export$68f982a626f4c267; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");

var $9Ua4K = parcelRequire("9Ua4K");

var $cA8Wl = parcelRequire("cA8Wl");
const $0ee72a5ef0efe0d2$export$68f982a626f4c267 = (state, action)=>{
    let newBodyData = {
        ...state.bodyData
    };
    let scaffoldModel = state.scaffoldModel ? {
        ...state.scaffoldModel
    } : null;
    let calculatedTableRows = state.calculatedTableRows ? [
        ...state.calculatedTableRows
    ] : [];
    const updates = "updates" in action ? action.updates : [
        {
            dataPath: action.dataPath,
            value: action.value
        }
    ];
    for (const update of updates){
        if (update.dataPath.startsWith("scaffoldModel")) {
            if (!scaffoldModel) continue;
            scaffoldModel = (0, $67RwR.mutateByPath)(scaffoldModel, update.dataPath.replace("scaffoldModel/", ""), update.value);
        } else if (update.dataPath.startsWith("calculatedTableRows")) calculatedTableRows = (0, $67RwR.mutateByPath)(calculatedTableRows, update.dataPath.replace("calculatedTableRows/", ""), update.value);
        else {
            newBodyData = (0, $67RwR.mutateByPath)(newBodyData, update.dataPath, update.value);
            const parts = update.dataPath.split("/");
            const isParameter = parts.at(-2) === "parameters";
            if ((isParameter || parts.at(-1) === "targetVariable") && state.analysisMethod) newBodyData = (0, $cA8Wl.syncParameters)(newBodyData, parts.slice(0, isParameter ? -2 : -1).join("/"), state.analysisMethod, state.settings.editorProps.isT);
        }
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: scaffoldModel,
        calculatedTableRows: calculatedTableRows,
        usedGroupingFactorIds: (0, $9Ua4K.computeUsedGroupingFactorIds)(newBodyData),
        changed: true
    };
};

});

parcelRegister("19GEW", function(module, exports) {

$parcel$export(module.exports, "arst_removeGroupingFactor", function () { return $14a48f2700513a48$export$ced1eb8c2ea8a585; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $km9RG = parcelRequire("km9RG");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $8gYcX = parcelRequire("8gYcX");

var $7qo9o = parcelRequire("7qo9o");

var $9Ua4K = parcelRequire("9Ua4K");

var $6oyXv = parcelRequire("6oyXv");
const $14a48f2700513a48$export$ced1eb8c2ea8a585 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupLabel && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupLabel) return state;
    // Get updates dataPath
    const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(action);
    // Check if the target dataPath exists in the bodyData
    let targetValue = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetValue) return state;
    // Get sibling count
    let siblingCount = action.cellValue.siblingCount;
    const isRemoveColumn = [
        (0, $k9YO2.ArsTableCellType).ColumnGroupCell,
        (0, $k9YO2.ArsTableCellType).ColumnGroupLabel
    ].includes(action.cellValue.cellType);
    // Get grouping factor sibling count
    if (targetDataPath !== action.cellValue.dataPath) targetValue = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    // Refresh sibling count
    const parentDataPath = (0, $km9RG.reduceDataPath)(targetDataPath, 2);
    const parentGroup = (0, $jwDoS.getFromDataPath)(parentDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    siblingCount = parentGroup?.subGroups?.length ?? (isRemoveColumn ? state.bodyData.columns.length : state.bodyData.rows.length);
    // Remove grouping factor node from bodyData
    const newBodyData = (0, $X1On9.removeByPath)(state.bodyData, targetDataPath, siblingCount - 1);
    // Check if row headers need to be updated
    newBodyData.rowHeaders = (0, $8gYcX.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    // Check some operations are still present in the table, if not, clear the analysisMethodId
    if (!(0, $6oyXv.containsAnalysisMethod)(newBodyData.columns) && !(0, $6oyXv.containsAnalysisMethod)(newBodyData.rows)) newBodyData.analysisMethodId = "";
    return {
        ...state,
        bodyData: newBodyData,
        usedGroupingFactorIds: (0, $9Ua4K.computeUsedGroupingFactorIds)(newBodyData),
        changed: true
    };
};

});
parcelRegister("6oyXv", function(module, exports) {

$parcel$export(module.exports, "containsAnalysisMethod", function () { return $806aba4b09c25960$export$6f148dcbdf337b4c; });
const $806aba4b09c25960$export$6f148dcbdf337b4c = (tableGroups)=>{
    return tableGroups?.some((tableGroup)=>{
        if ("analysisMethod" in tableGroup || "operation" in tableGroup) return true;
        else return $806aba4b09c25960$export$6f148dcbdf337b4c(tableGroup.subGroups);
    }) ?? false;
};

});


parcelRegister("9hujo", function(module, exports) {

$parcel$export(module.exports, "arst_removeOperation", function () { return $2ba7aac268cd5427$export$a8417f1f72e65940; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $km9RG = parcelRequire("km9RG");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $8gYcX = parcelRequire("8gYcX");

var $6oyXv = parcelRequire("6oyXv");
const $2ba7aac268cd5427$export$a8417f1f72e65940 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).ColumnOperation && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowOperation) return state;
    // Get target dataPath
    const targetDataPath = action.cellValue.dataPath;
    // Check if the target dataPath exists in the bodyData
    const targetValue = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetValue) return state;
    const isRemoveColumn = action.cellValue.cellType === (0, $k9YO2.ArsTableCellType).ColumnOperation;
    // Get sibling count
    const parentDataPath = (0, $km9RG.reduceDataPath)(action.cellValue.dataPath, 2);
    const parentGroup = (0, $jwDoS.getFromDataPath)(parentDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    const siblingCount = parentGroup?.subGroups?.length ?? (isRemoveColumn ? state.bodyData.columns.length : state.bodyData.rows.length);
    const newBodyData = (0, $X1On9.removeByPath)(state.bodyData, targetDataPath, siblingCount - 1);
    // Check if row headers need to be updated
    newBodyData.rowHeaders = (0, $8gYcX.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    // Check some operations are still present in the table, if not, clear the analysisMethodId
    if (!(0, $6oyXv.containsAnalysisMethod)(newBodyData.columns) && !(0, $6oyXv.containsAnalysisMethod)(newBodyData.rows)) newBodyData.analysisMethodId = "";
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("igrOH", function(module, exports) {

$parcel$export(module.exports, "arst_setAnalysisMethod", function () { return $464f0d33299d1329$export$999c90f920010e0d; });
const $464f0d33299d1329$export$999c90f920010e0d = (state, action)=>({
        ...state,
        analysisMethod: action.analysisMethod
    });

});

parcelRegister("kuulP", function(module, exports) {

$parcel$export(module.exports, "arst_setScaffoldColWidth", function () { return $09adef098aafcba6$export$8fd5e5a4535a87c8; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");
parcelRequire("alciT");
var $dYUuZ = parcelRequire("dYUuZ");
var $bc2Bd = parcelRequire("bc2Bd");
var $28uJJ = parcelRequire("28uJJ");

var $7qo9o = parcelRequire("7qo9o");

var $7SquG = parcelRequire("7SquG");
const $09adef098aafcba6$export$8fd5e5a4535a87c8 = (state, action)=>{
    // Find correct target
    const colCells = (0, $7SquG.getColumnCells)(state.calculatedTableRows, action.colId);
    const targetCell = colCells.find((cell)=>(0, $28uJJ.isArsTableRowHeaderCell)(cell, state.settings.editorProps.isT) || (0, $bc2Bd.isArsTableColumnOperationCell)(cell, state.settings.editorProps.isT) || (0, $dYUuZ.isArsTableColumnGroupLabel)(cell, state.settings.editorProps.isT) && (cell.colSpan ?? 1) === 1);
    if (!targetCell || !state.scaffoldModel) return state;
    // Update scaffold model with new column width
    const newScaffoldModel = (0, $67RwR.mutateByPath)(state.scaffoldModel, `/columns/${targetCell.columnIndex}/width`, action.width);
    let newBodyData = state.bodyData;
    if (targetCell.dataPath.startsWith("/rowHeaders")) newBodyData = (0, $67RwR.mutateByPath)(newBodyData, `${targetCell.dataPath}/width`, action.width);
    else {
        const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(targetCell.dataPath);
        newBodyData = (0, $67RwR.mutateByPath)(newBodyData, `${targetDataPath}/dimension`, action.width);
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: newScaffoldModel,
        changed: true
    };
};

});
parcelRegister("7SquG", function(module, exports) {

$parcel$export(module.exports, "getColumnCells", function () { return $7e0131a18874ff76$export$772487724a7ca0b6; });
const $7e0131a18874ff76$export$772487724a7ca0b6 = (tableRows, columnId)=>{
    if (!tableRows) return [];
    return tableRows.map((row)=>row.arsTableCells.find((cell)=>cell.columnId === columnId)).filter((cell)=>cell !== undefined);
};

});


parcelRegister("cFA3U", function(module, exports) {

$parcel$export(module.exports, "arst_setScaffoldRowHeight", function () { return $8d4e0850edc4dc78$export$1990263dcc98afc6; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");

var $7qo9o = parcelRequire("7qo9o");
const $8d4e0850edc4dc78$export$1990263dcc98afc6 = (state, action)=>{
    if (!state.scaffoldModel) return state;
    const rowIndex = state.scaffoldModel.rows.findIndex((row)=>row.id === action.rowId);
    if (rowIndex === -1) return state;
    // Update scaffold model with new row height
    const scaffoldRow = state.scaffoldModel.rows[rowIndex];
    const newScaffoldModel = (0, $67RwR.mutateByPath)(state.scaffoldModel, `/rows/${rowIndex}/height`, action.height);
    let newBodyData = state.bodyData;
    // Update all rowHeaders if a header row, otherwise find target cell and update height/rowspan as needed
    if (scaffoldRow.type === "header") {
        const newHeights = state.scaffoldModel.rows.filter((row)=>row.type === "header").map((row)=>row.id === action.rowId ? action.height : row.height);
        newBodyData = (0, $67RwR.mutateByPath)(newBodyData, `/rowHeaders`, state.bodyData.rowHeaders.map((rowHeader)=>({
                ...rowHeader,
                heights: newHeights
            })));
    } else {
        const targetRow = Object.values(state.scaffoldModel.cellData[action.rowId] ?? // istanbul ignore next
        {});
        const targetCell = targetRow.find((cell)=>!("rowSpan" in cell) || (cell.rowSpan ?? 1) === 1);
        /* istanbul ignore else */ if (targetCell) {
            const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(targetCell.dataPath);
            newBodyData = (0, $67RwR.mutateByPath)(newBodyData, `${targetDataPath}/dimension`, action.height);
        }
    }
    return {
        ...state,
        bodyData: newBodyData,
        scaffoldModel: newScaffoldModel,
        changed: true
    };
};

});

parcelRegister("hOK7P", function(module, exports) {

$parcel$export(module.exports, "arst_setTlfViewMode", function () { return $cdad5f2744d8ee65$export$e58696dbc96dad07; });
const $cdad5f2744d8ee65$export$e58696dbc96dad07 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            tlfViewMode: action.tlfViewMode
        }
    });

});

parcelRegister("blsOh", function(module, exports) {

$parcel$export(module.exports, "arst_setViewItem", function () { return $1b4339b477194084$export$3f068d8d146a97b3; });
const $1b4339b477194084$export$3f068d8d146a97b3 = (state, action)=>{
    return {
        ...state,
        viewItem: action.viewItem
    };
};

});

parcelRegister("dLEmP", function(module, exports) {

$parcel$export(module.exports, "arst_toggleGroupLabelVisibility", function () { return $10b0b0d61bbef2d4$export$9780ca33f4ba43ca; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");

var $hVpcI = parcelRequire("hVpcI");

var $8gYcX = parcelRequire("8gYcX");

var $7qo9o = parcelRequire("7qo9o");
const $10b0b0d61bbef2d4$export$9780ca33f4ba43ca = (state, action)=>{
    if (action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).ColumnGroupLabel && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $7qo9o.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $jwDoS.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $hVpcI.isArsTableSubGroup)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.hidden) {
        // Remove if it is already there
        newBodyData = (0, $X1On9.removeByPath)(newBodyData, `${targetGroupingFactorPath}/hidden`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $67RwR.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/hidden`, true);
        newBodyData.rowHeaders = (0, $8gYcX.arst_checkRowHeaders)(newBodyData, state.settings.editorProps);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("xmY6k", function(module, exports) {

$parcel$export(module.exports, "arst_toggleInlineRowHeader", function () { return $36064ac010054b2e$export$49fdd18eac83b9f7; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");

var $hVpcI = parcelRequire("hVpcI");

var $7qo9o = parcelRequire("7qo9o");
const $36064ac010054b2e$export$49fdd18eac83b9f7 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $7qo9o.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $jwDoS.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $hVpcI.isArsTableSubGroup)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.inlineRowHeaders) {
        // Remove if it is already there
        newBodyData = (0, $X1On9.removeByPath)(newBodyData, `${targetGroupingFactorPath}/inlineRowHeaders`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $67RwR.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/inlineRowHeaders`, true);
        // Remove rowHeader cell, there should be less now
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex - (action.cellValue.cellType === (0, $k9YO2.ArsTableCellType).RowGroupLabel ? 1 : 0), 1);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("1H4JF", function(module, exports) {

$parcel$export(module.exports, "arst_toggleInlineWithPreviousLevel", function () { return $d4526578374aec27$export$60b999c71accaf34; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $7qo9o = parcelRequire("7qo9o");
const $d4526578374aec27$export$60b999c71accaf34 = (state, action)=>{
    if (action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupCell && action.cellValue.cellType !== (0, $k9YO2.ArsTableCellType).RowGroupLabel) return state;
    const targetGroupingFactorPath = (0, $7qo9o.arst_resolveTargetPath)(action.cellValue.dataPath);
    const targetItem = (0, $jwDoS.getFromDataPath)(targetGroupingFactorPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
    if (!targetItem) return state;
    let newBodyData = {
        ...state.bodyData
    };
    /* istanbul ignore else */ if (targetItem?.inlineWithPreviousLevel) {
        // Remove if it is already there
        newBodyData = (0, $X1On9.removeByPath)(newBodyData, `${targetGroupingFactorPath}/inlineWithPreviousLevel`);
        // Add rowHeader cell back in
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
            heights: [],
            label: state.settings.editorProps.blankT,
            width: 120
        });
    } else if (targetItem) {
        // Add if it is not there or false
        newBodyData = (0, $67RwR.mutateByPath)(state.bodyData, `${targetGroupingFactorPath}/inlineWithPreviousLevel`, true);
        // Remove rowHeader cell, there should be less now
        newBodyData.rowHeaders = [
            ...state.bodyData.rowHeaders
        ];
        newBodyData.rowHeaders.splice(action.cellValue.columnIndex - (action.cellValue.cellType === (0, $k9YO2.ArsTableCellType).RowGroupLabel ? 1 : 0), 1);
    }
    return {
        ...state,
        bodyData: newBodyData,
        changed: true
    };
};

});

parcelRegister("bLVB2", function(module, exports) {

$parcel$export(module.exports, "arst_toggleSpaceAfter", function () { return $c2322df3fbdfae9d$export$f73c09fcbcdd24ee; });
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $67RwR = parcelRequire("67RwR");
var $X1On9 = parcelRequire("X1On9");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");

var $7qo9o = parcelRequire("7qo9o");
/**
 * Row-axis cell types that can carry space-after settings.
 */ const $c2322df3fbdfae9d$var$rowAfterCellTypes = new Set([
    (0, $k9YO2.ArsTableCellType).RowGroupCell,
    (0, $k9YO2.ArsTableCellType).RowGroupLabel,
    (0, $k9YO2.ArsTableCellType).RowOperation
]);
const $c2322df3fbdfae9d$export$f73c09fcbcdd24ee = (state, action, property)=>{
    if ($c2322df3fbdfae9d$var$rowAfterCellTypes.has(action.cellValue.cellType)) {
        const targetPath = (0, $7qo9o.arst_resolveTargetPath)(action);
        const targetItem = (0, $jwDoS.getFromDataPath)(targetPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
        if (targetItem && (property === "spaceAfterGroup" || "groupingFactor" in targetItem)) {
            // Only grouping factors carry spaceAfterSubGroups, so other items can only be toggling spaceAfterGroup
            const isEnabled = "groupingFactor" in targetItem ? targetItem[property] : targetItem.spaceAfterGroup;
            return {
                ...state,
                bodyData: isEnabled ? (0, $X1On9.removeByPath)(state.bodyData, `${targetPath}/${property}`) : (0, $67RwR.mutateByPath)(state.bodyData, `${targetPath}/${property}`, true),
                changed: true
            };
        }
    }
    return state;
};

});

parcelRegister("8wTiM", function(module, exports) {

$parcel$export(module.exports, "arst_toggleSpaceAfterGroup", function () { return $04c463915e9630df$export$cb4879ae86a6334e; });

var $bLVB2 = parcelRequire("bLVB2");
const $04c463915e9630df$export$cb4879ae86a6334e = (state, action)=>(0, $bLVB2.arst_toggleSpaceAfter)(state, action, "spaceAfterGroup");

});

parcelRegister("5v6vb", function(module, exports) {

$parcel$export(module.exports, "arst_toggleSpaceAfterSubGroups", function () { return $d31dc09d643007af$export$5842c11d8b5c8dfb; });

var $bLVB2 = parcelRequire("bLVB2");
const $d31dc09d643007af$export$5842c11d8b5c8dfb = (state, action)=>(0, $bLVB2.arst_toggleSpaceAfter)(state, action, "spaceAfterSubGroups");

});

parcelRegister("60kjb", function(module, exports) {

$parcel$export(module.exports, "arst_updateScaffold", function () { return $dd071f160fc5187a$export$4c13525f5a2bcc23; });

var $lWi18 = parcelRequire("lWi18");
const $dd071f160fc5187a$export$4c13525f5a2bcc23 = (state, action)=>({
        ...state,
        calculatedTableRows: action.calculatedTableRows,
        scaffoldModel: (0, $lWi18.buildArsTableScaffoldModel)(action.calculatedTableRows, state.settings.editorProps)
    });

});
parcelRegister("lWi18", function(module, exports) {

$parcel$export(module.exports, "buildArsTableScaffoldModel", function () { return $a4ae7f2dc5cc094d$export$e2602cebd0c576ca; });

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $kpDSD = parcelRequire("kpDSD");
var $gp7zE = parcelRequire("gp7zE");
const $a4ae7f2dc5cc094d$var$defaultColumnWidth = 120;
const $a4ae7f2dc5cc094d$var$defaultRowHeight = 40;
const $a4ae7f2dc5cc094d$export$e2602cebd0c576ca = (calculatedTableRows, editorProps)=>{
    // Send blank table is there is nothing to see here
    if (!calculatedTableRows || calculatedTableRows.length === 0) return {
        cellData: {
            blankRow: {
                blankCol: {
                    annotationContent: "Drop items here",
                    cellType: (0, $k9YO2.ArsTableCellType).RowHeader,
                    columnId: "blankCol",
                    columnIndex: 0,
                    dataPath: "",
                    disabled: true,
                    displayContent: editorProps.textToT("Drop items here"),
                    justification: (0, $k9YO2.ArsTextJustification).Center,
                    rowId: "blankRow",
                    targetType: "rowHeader"
                }
            }
        },
        columns: [
            {
                id: "blankCol",
                colNumber: 1,
                width: $a4ae7f2dc5cc094d$var$defaultColumnWidth + 80,
                noResize: true
            }
        ],
        rows: [
            {
                id: "blankRow",
                height: $a4ae7f2dc5cc094d$var$defaultRowHeight,
                rowGroupNumber: 0,
                rowNumber: 1,
                type: "header"
            }
        ],
        headerColSpans: {}
    };
    // Set up base objects to return
    const cellData = {};
    const columns = [];
    const rows = [];
    const headerColSpans = {};
    // Tranverse the calculated rows to populate the scaffold model. This will respect any header row spans and use the calculated layout as the source of truth for dimensions and cell placement.
    calculatedTableRows.forEach((calculatedRow, rowIndex)=>{
        const rowId = calculatedRow.arsTableCells[0].rowId;
        const rowNumber = rowIndex + 1;
        // Add new row on each pass
        const newRowScaffold = {
            id: rowId,
            rowGroupNumber: (0, $gp7zE.isArsTableHeaderRow)(calculatedRow, editorProps.isT) ? -1 : calculatedRow.rowGroup,
            rowNumber: rowNumber,
            type: (0, $gp7zE.isArsTableHeaderRow)(calculatedRow, editorProps.isT) ? "header" : "body",
            height: calculatedRow.height
        };
        rows.push(newRowScaffold);
        // Look at each cell
        calculatedRow.arsTableCells.forEach((cell)=>{
            const colSpan = "colSpan" in cell && cell.colSpan ? cell.colSpan : 1;
            const rowSpan = "rowSpan" in cell && cell.rowSpan ? cell.rowSpan : 1;
            const colId = cell.columnId;
            if (!columns[cell.columnIndex] && (0, $kpDSD.isArsTableHeaderCell)(cell, editorProps.isT) && colSpan === 1) columns[cell.columnIndex] = {
                id: colId,
                colNumber: cell.columnIndex + 1,
                width: cell.width ?? $a4ae7f2dc5cc094d$var$defaultColumnWidth
            };
            // Add cells to cellData map on each pass
            if (!cellData[rowId]) cellData[rowId] = {};
            cellData[rowId][colId] = cell;
            // Add span info to headerColSpans
            if (colSpan > 1 || rowSpan > 1) {
                if (!headerColSpans[rowId]) headerColSpans[rowId] = {};
                headerColSpans[rowId][colId] = {
                    colSpan: colSpan,
                    rowSpan: rowSpan
                };
            }
        });
    });
    return {
        cellData: cellData,
        columns: columns,
        rows: rows,
        headerColSpans: headerColSpans
    };
};

});


parcelRegister("3TPyB", function(module, exports) {

$parcel$export(module.exports, "buildArsTableZoneColors", function () { return $222eca12bfb09d3f$export$401b74ce86f9914d; });
parcelRequire("e2uI9");
var $aLLqu = parcelRequire("aLLqu");

var $g2mVC = parcelRequire("g2mVC");

var $k9YO2 = parcelRequire("k9YO2");
const $222eca12bfb09d3f$export$75f4aa1e3eaf7003 = "#4dabf7";
const $222eca12bfb09d3f$var$LEFT_EDGE_ZONES = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopLeft,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeBottom,
    (0, $aLLqu.ScaffoldDropZone).BottomLeft
]);
/**
 * Drop zones on the right edge of a cell (insert-after).
 */ const $222eca12bfb09d3f$var$RIGHT_EDGE_ZONES = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopRight,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeBottom,
    (0, $aLLqu.ScaffoldDropZone).BottomRight
]);
const $222eca12bfb09d3f$export$401b74ce86f9914d = (state, dragKind, suppressAllZones = false)=>({ rowId: rowId, colId: colId, zone: zone })=>{
        const result = {
            color: null
        };
        if (suppressAllZones) return result;
        if (!state?.scaffoldModel) return result;
        const targetCell = state.scaffoldModel.cellData?.[rowId]?.[colId];
        if (!targetCell) return result;
        const config = (0, $g2mVC.cellActionConfig)(targetCell, state);
        const matchedAction = config.dropActions.find((action)=>action.dropZones.has(zone) && (dragKind === null || action.droppedDataKinds.includes(dragKind)));
        if (!matchedAction) return result;
        const matchedZones = Array.from(matchedAction.dropZones);
        // For RowHeader cells, suppress RHS actions on non-last headers and
        // LHS actions on non-first headers to avoid misleading drop targets.
        if (targetCell.cellType === (0, $k9YO2.ArsTableCellType).RowHeader && state.bodyData.rowHeaders.length > 1) {
            const rowHeaderIndex = parseInt(targetCell.dataPath.replace("/rowHeaders/", ""), 10);
            const rowHeaderCount = state.bodyData.rowHeaders.length;
            const isLastRowHeader = !isNaN(rowHeaderIndex) && rowHeaderIndex === rowHeaderCount - 1;
            const isFirstRowHeader = !isNaN(rowHeaderIndex) && rowHeaderIndex === 0;
            if (!isLastRowHeader && matchedZones.some((z)=>$222eca12bfb09d3f$var$RIGHT_EDGE_ZONES.has(z))) return result;
            if (!isFirstRowHeader && matchedZones.some((z)=>$222eca12bfb09d3f$var$LEFT_EDGE_ZONES.has(z))) return result;
        }
        return {
            color: $222eca12bfb09d3f$export$75f4aa1e3eaf7003,
            additionalHighlightedZones: matchedZones
        };
    };

});
parcelRegister("g2mVC", function(module, exports) {

$parcel$export(module.exports, "cellActionConfig", function () { return $9fb1684a042f72c0$export$9d3272000e6dcb39; });
parcelRequire("e2uI9");
var $aLLqu = parcelRequire("aLLqu");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");

var $jP6k0 = parcelRequire("jP6k0");

var $7qo9o = parcelRequire("7qo9o");

var $k9YO2 = parcelRequire("k9YO2");

var $hVpcI = parcelRequire("hVpcI");
const $9fb1684a042f72c0$export$4694e219efffa1d = new Set([
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeBottom
]);
const $9fb1684a042f72c0$export$99c6501f32dd4b22 = new Set([
    (0, $aLLqu.ScaffoldDropZone).RightEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeBottom
]);
const $9fb1684a042f72c0$export$2e88df9459aef37b = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopLeft,
    (0, $aLLqu.ScaffoldDropZone).TopEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).TopEdgeRight,
    (0, $aLLqu.ScaffoldDropZone).TopRight
]);
const $9fb1684a042f72c0$export$953f010e02ba9e77 = new Set([
    (0, $aLLqu.ScaffoldDropZone).BottomLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeRight,
    (0, $aLLqu.ScaffoldDropZone).BottomRight
]);
const $9fb1684a042f72c0$export$75b722808fb4f534 = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopLeft,
    (0, $aLLqu.ScaffoldDropZone).TopEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).TopEdgeRight
]);
const $9fb1684a042f72c0$export$a3a44b12c2858e12 = new Set([
    (0, $aLLqu.ScaffoldDropZone).BottomLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeRight
]);
const $9fb1684a042f72c0$export$31125a4b8fc0a7c3 = new Set([
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).CentreTopLeft,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeBottom,
    (0, $aLLqu.ScaffoldDropZone).CentreBottomLeft
]);
const $9fb1684a042f72c0$export$2923c563557780b7 = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopRight,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeBottom,
    (0, $aLLqu.ScaffoldDropZone).BottomRight
]);
const $9fb1684a042f72c0$export$5a25131cc91898d6 = new Set([
    (0, $aLLqu.ScaffoldDropZone).TopRight,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeBottom,
    (0, $aLLqu.ScaffoldDropZone).BottomRight
]);
const $9fb1684a042f72c0$export$a639a1623e19ea0b = new Set([
    (0, $aLLqu.ScaffoldDropZone).BottomLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeRight
]);
const $9fb1684a042f72c0$export$53152418615043d6 = {
    label: "Remove group",
    operation: (0, $k9YO2.ARST_REMOVE_GROUPINGFACTOR)
};
const $9fb1684a042f72c0$export$3327bf6f84120a1e = {
    label: "Remove operation",
    operation: (0, $k9YO2.ARST_REMOVE_OPERATION)
};
const $9fb1684a042f72c0$export$321f564fb61ba3ef = {
    label: "Toggle visible group label",
    operation: (0, $k9YO2.ARST_TOGGLE_GROUP_LABEL_VISIBILITY)
};
const $9fb1684a042f72c0$export$31e23ca08a82c9c5 = {
    label: "Toggle inline group label",
    operation: (0, $k9YO2.ARST_TOGGLE_GROUP_LABEL_INLINE)
};
const $9fb1684a042f72c0$export$549b00ca91309c2e = {
    label: "Toggle inline with previous level",
    operation: (0, $k9YO2.ARST_TOGGLE_INLINE_WITH_PREVIOUS_LEVEL)
};
const $9fb1684a042f72c0$export$8a4ef53a1bd50c12 = {
    label: "Toggle space after group",
    operation: (0, $k9YO2.ARST_TOGGLE_SPACE_AFTER_GROUP)
};
const $9fb1684a042f72c0$export$7506d49129a77cdd = {
    label: "Toggle space after each subgroup",
    operation: (0, $k9YO2.ARST_TOGGLE_SPACE_AFTER_SUBGROUPS)
};
const $9fb1684a042f72c0$var$columnDropActions = [
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$4694e219efffa1d,
        operation: (0, $k9YO2.ARST_INSERT_COLUMN_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$99c6501f32dd4b22,
        operation: (0, $k9YO2.ARST_INSERT_COLUMN_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$953f010e02ba9e77,
        operation: (0, $k9YO2.ARST_INSERT_SUBGROUP)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$4694e219efffa1d,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$99c6501f32dd4b22,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$953f010e02ba9e77,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_SUBGROUP)
    }
];
const $9fb1684a042f72c0$var$rowDropActions = [
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$75b722808fb4f534,
        operation: (0, $k9YO2.ARST_INSERT_ROW_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$a3a44b12c2858e12,
        operation: (0, $k9YO2.ARST_INSERT_ROW_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
        ],
        dropZones: $9fb1684a042f72c0$export$2923c563557780b7,
        operation: (0, $k9YO2.ARST_INSERT_SUBGROUP)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$75b722808fb4f534,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_ROW_BEFORE)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$a3a44b12c2858e12,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_ROW_AFTER)
    },
    {
        droppedDataKinds: [
            (0, $jP6k0.ArsSidebarItemKind).Operation,
            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
        ],
        dropZones: $9fb1684a042f72c0$export$2923c563557780b7,
        operation: (0, $k9YO2.ARST_INSERT_OPERATION_SUBGROUP)
    }
];
const $9fb1684a042f72c0$export$9d3272000e6dcb39 = (value, state)=>{
    if (!state) return {
        contextMenuActions: [],
        dropActions: []
    };
    const target = (0, $jwDoS.getFromDataPath)((0, $7qo9o.arst_resolveTargetPath)(value.dataPath), state.bodyData, (obj)=>(0, $hVpcI.isArsTableSubGroupGroupingFactor)(obj, state.settings.editorProps.isT));
    // A visible label with no groups or data values to replace it cannot be hidden
    const groupLabelHidingBlocked = !!target && !target.hidden && (target.groupingFactor.dataDriven ? target.groupingFactor.dataValues.length : target.groupingFactor.groups.length) === 0;
    const toggleLabelAction = {
        ...$9fb1684a042f72c0$export$321f564fb61ba3ef,
        disabled: groupLabelHidingBlocked
    };
    switch(value.cellType){
        case (0, $k9YO2.ArsTableCellType).ColumnGroupCell:
        case (0, $k9YO2.ArsTableCellType).ColumnGroupLabel:
            return {
                contextMenuActions: [
                    toggleLabelAction,
                    $9fb1684a042f72c0$export$53152418615043d6
                ],
                dropActions: $9fb1684a042f72c0$var$columnDropActions
            };
        case (0, $k9YO2.ArsTableCellType).RowGroupCell:
        case (0, $k9YO2.ArsTableCellType).RowGroupLabel:
            {
                const ret = {
                    contextMenuActions: [
                        toggleLabelAction,
                        $9fb1684a042f72c0$export$53152418615043d6,
                        ...groupLabelHidingBlocked ? [] : [
                            $9fb1684a042f72c0$export$31e23ca08a82c9c5
                        ],
                        $9fb1684a042f72c0$export$8a4ef53a1bd50c12
                    ],
                    dropActions: $9fb1684a042f72c0$var$rowDropActions
                };
                // Analysis methods have no groups or data values, so cannot space their sub-groups
                if (value.targetType !== "analysisMethod") ret.contextMenuActions.push($9fb1684a042f72c0$export$7506d49129a77cdd);
                if (value.dataPath.split("/").length > 3) ret.contextMenuActions.push($9fb1684a042f72c0$export$549b00ca91309c2e);
                return ret;
            }
        case (0, $k9YO2.ArsTableCellType).ColumnOperation:
            return {
                contextMenuActions: [
                    $9fb1684a042f72c0$export$3327bf6f84120a1e
                ],
                dropActions: $9fb1684a042f72c0$var$columnDropActions
            };
        case (0, $k9YO2.ArsTableCellType).RowOperation:
            return {
                contextMenuActions: [
                    $9fb1684a042f72c0$export$3327bf6f84120a1e,
                    $9fb1684a042f72c0$export$8a4ef53a1bd50c12
                ],
                dropActions: $9fb1684a042f72c0$var$rowDropActions
            };
        case (0, $k9YO2.ArsTableCellType).RowHeader:
            return {
                contextMenuActions: [],
                dropActions: [
                    {
                        droppedDataKinds: [
                            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
                        ],
                        dropZones: $9fb1684a042f72c0$export$5a25131cc91898d6,
                        operation: (0, $k9YO2.ARST_INSERT_COLUMN_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $jP6k0.ArsSidebarItemKind).GroupingFactor
                        ],
                        dropZones: $9fb1684a042f72c0$export$a639a1623e19ea0b,
                        operation: (0, $k9YO2.ARST_INSERT_ROW_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $jP6k0.ArsSidebarItemKind).Operation,
                            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
                        ],
                        dropZones: $9fb1684a042f72c0$export$5a25131cc91898d6,
                        operation: (0, $k9YO2.ARST_INSERT_OPERATION_COLUMN_AFTER)
                    },
                    {
                        droppedDataKinds: [
                            (0, $jP6k0.ArsSidebarItemKind).Operation,
                            (0, $jP6k0.ArsSidebarItemKind).AnalysisMethod
                        ],
                        dropZones: $9fb1684a042f72c0$export$a639a1623e19ea0b,
                        operation: (0, $k9YO2.ARST_INSERT_OPERATION_ROW_AFTER)
                    }
                ]
            };
        default:
            return {
                contextMenuActions: [],
                dropActions: []
            };
    }
};

});


parcelRegister("9BhZI", function(module, exports) {
parcelRequire("alciT");
var $6OSNn = parcelRequire("6OSNn");
var $hVpcI = parcelRequire("hVpcI");
const $f0df61f138c6fefe$export$6fe6f31bd6746336 = (tableGroups, id, isT)=>{
    const ret = [];
    for (const group of tableGroups){
        if ((0, $hVpcI.isArsTableSubGroupGroupingFactor)(group, isT) && group.groupingFactor?.id === id) ret.push(group);
        else if ((0, $6OSNn.isArsTableOperation)(group, isT) && group.operation?.id === id) ret.push(group);
        if (group.subGroups && group.subGroups.length > 0) ret.push(...$f0df61f138c6fefe$export$6fe6f31bd6746336(group.subGroups, id, isT));
    }
    return ret;
};

});

parcelRegister("hjdwt", function(module, exports) {

$parcel$export(module.exports, "groupToTreeNode", function () { return $27a1b18b34b4f370$export$c18dc29351454736; });
const $27a1b18b34b4f370$export$c18dc29351454736 = (group, isT)=>{
    // SubGroup node
    const children = (group.subGroups ?? []).map((g)=>$27a1b18b34b4f370$export$c18dc29351454736(g, isT));
    if ("groupingFactor" in group) {
        const sggf = group;
        return {
            id: sggf.id,
            label: sggf.label,
            type: "groupingFactor",
            subNodes: children.length > 0 ? children : undefined
        };
    } else if ("group" in group) {
        const sgg = group;
        return {
            id: sgg.id,
            label: sgg.label,
            type: "group",
            subNodes: children.length > 0 ? children : undefined
        };
    } else if ("operation" in group) {
        const op = group;
        return {
            id: op.id,
            label: op.label,
            type: "operation",
            subNodes: children.length > 0 ? children : undefined
        };
    } else {
        const sgam = group;
        return {
            id: sgam.id,
            label: sgam.label,
            type: "analysisMethod",
            subNodes: children.length > 0 ? children : undefined
        };
    }
};

});





parcelRegister("d4ZHR", function(module, exports) {

$parcel$export(module.exports, "ArsText", function () { return $a1b5329b96bc354b$export$a465d06d3ea2cdc1; });

var $bR5nk = parcelRequire("bR5nk");

var $3ew5o = parcelRequire("3ew5o");

var $kUTy1 = parcelRequire("kUTy1");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");

var $5kgoV = parcelRequire("5kgoV");
const $a1b5329b96bc354b$export$a465d06d3ea2cdc1 = ({ dataPath: dataPath, isArray: isArray = false, isMultiline: isMultiline = false, tableDataPath: tableDataPath = false, ...rest })=>{
    const ars = (0, $4hgF7.useArsContext)();
    const table = (0, $5kgoV.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    // Get the current value from state using the dataPath
    const pointer = (0, $3ew5o.Pointer).fromJSON(dataPath);
    const rawValue = pointer.get(sourceState) ?? (isArray ? [] : "");
    // Auto-detect if value is an array
    const isArrayValue = isArray || Array.isArray(rawValue);
    // Handle both string and string[] values
    // If it's an array, convert to newline-separated string for textarea display
    const value = isArrayValue ? rawValue.join("\n") : rawValue;
    /**
   * Handle input change by dispatching PATCH_ARS_STATE action.
   * If the original value was an array, convert newline-separated string back to array.
   *
   * @param newValue - The new value to set.
   */ const handleChange = (newValue)=>{
        let valueToSave;
        if (isArrayValue) // Convert newline-separated string back to array
        valueToSave = newValue.split("\n").map((v)=>v.trimEnd()).filter((v)=>v.length > 0);
        else if (rest.type === "number") {
            const numValue = Number(newValue);
            valueToSave = newValue.trim() === "" || !isFinite(numValue) ? undefined : numValue;
        } else valueToSave = newValue;
        if (!tableDataPath) ars.dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: valueToSave
        });
        else table.dispatch({
            operation: (0, $k9YO2.ARST_PATCH_DATA),
            dataPath: dataPath,
            value: valueToSave
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
        value: value,
        setValue: handleChange,
        type: isArrayValue || isMultiline ? "textarea" : rest.type,
        allowCarriageReturn: isArrayValue || isMultiline,
        ...rest
    });
};
$a1b5329b96bc354b$export$a465d06d3ea2cdc1.displayName = "ArsText";

});

parcelRegister("2VKUu", function(module, exports) {

$parcel$export(module.exports, "ArsVariable", function () { return $2cb93230323b7f6f$export$d5912eafadbcc42a; });

var $bR5nk = parcelRequire("bR5nk");

var $8Uc5S = parcelRequire("8Uc5S");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");

var $5kgoV = parcelRequire("5kgoV");

var $aBkbH = parcelRequire("aBkbH");
/**
 * Type guard for the combined path prop shape.
 *
 * @param props - ArsVariable props in either mode.
 * @returns True when props use a single combined data path.
 */ const $2cb93230323b7f6f$var$isCombinedPathProps = (props)=>"combinedDataPath" in props;
const $2cb93230323b7f6f$export$d5912eafadbcc42a = (props)=>{
    const { canChangeDataset: canChangeDataset = true, tableDataPath: tableDataPath = false, validCondition: validCondition, ...rest } = props;
    const ars = (0, $4hgF7.useArsContext)();
    const table = (0, $5kgoV.useArsTable)();
    const sourceState = tableDataPath ? table.state?.bodyData ?? {} : ars.state;
    const isCombinedPath = $2cb93230323b7f6f$var$isCombinedPathProps(props);
    // Get the current values from state using the dataPaths
    let combinedValue = "";
    let dataset = "";
    if (isCombinedPath) {
        combinedValue = (0, $jwDoS.getFromDataPath)(props.combinedDataPath, sourceState, (0, $jwDoS.isString)) ?? "";
        dataset = combinedValue.split(".")[0];
    } else {
        dataset = (0, $jwDoS.getFromDataPath)(props.datasetDataPath, sourceState, (0, $jwDoS.isString)) ?? "";
        const variable = (0, $jwDoS.getFromDataPath)(props.variableDataPath, sourceState, (0, $jwDoS.isString)) ?? "";
        combinedValue = dataset && variable ? `${dataset}.${variable}` : "";
    }
    /**
   * Handle selection change by splitting the value and dispatching updates to both paths.
   * Expected format: "DATASET.VARIABLE" (e.g., "ADSL.AGE")
   *
   * @param newValue - The new combined value in format "DATASET.VARIABLE".
   */ const handleChange = (newValue)=>{
        // Split the value on the first period to separate dataset and variable
        const dotIndex = newValue.indexOf(".");
        let newDataset = "";
        let newVariable = "";
        if (isCombinedPath) {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.combinedDataPath,
                        value: newValue
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.combinedDataPath,
                        value: newValue
                    }
                ]
            });
            return;
        }
        // When dataset changes are disabled and input is cleared, only clear variable.
        if (!canChangeDataset && newValue === "") {
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: ""
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: ""
                    }
                ]
            });
            return;
        }
        if (dotIndex > 0) {
            newDataset = newValue.substring(0, dotIndex);
            newVariable = newValue.substring(dotIndex + 1);
        } else // If no period found, treat entire value as dataset
        newDataset = newValue;
        if (!canChangeDataset) {
            // Ignore values that would change dataset or that are dataset-only.
            if (dotIndex <= 0 || newDataset !== dataset) return;
            if (!tableDataPath) ars.dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: newVariable
                    }
                ]
            });
            else table.dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                updates: [
                    {
                        dataPath: props.variableDataPath,
                        value: newVariable
                    }
                ]
            });
            return;
        }
        // Dispatch both updates atomically
        if (!tableDataPath) ars.dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            updates: [
                {
                    dataPath: props.datasetDataPath,
                    value: newDataset
                },
                {
                    dataPath: props.variableDataPath,
                    value: newVariable
                }
            ]
        });
        else table.dispatch({
            operation: (0, $k9YO2.ARST_PATCH_DATA),
            updates: [
                {
                    dataPath: props.datasetDataPath,
                    value: newDataset
                },
                {
                    dataPath: props.variableDataPath,
                    value: newVariable
                }
            ]
        });
    };
    const availableVariables = canChangeDataset ? ars.state.variables : ars.state.variables.filter((variable)=>variable.dataset === dataset);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Uc5S.ControlTypeAhead), {
        ...rest,
        availableList: availableVariables,
        value: combinedValue,
        setValue: handleChange,
        validCondition: canChangeDataset ? (0, $aBkbH.isUnlistedDatasetVariableValue) : validCondition
    });
};
$2cb93230323b7f6f$export$d5912eafadbcc42a.displayName = "ArsVariable";

});
parcelRegister("aBkbH", function(module, exports) {

$parcel$export(module.exports, "isUnlistedDatasetVariableValue", function () { return $348a63e3295a01c0$export$6b881c0dedb4dc3b; });

var $cncLz = parcelRequire("cncLz");

var $OARmT = parcelRequire("OARmT");
/**
 * Builds a successful validation response for dataset.variable validation.
 *
 * @param valid - Whether the candidate value is valid.
 * @param validationText - Feedback text to display for the validation result.
 * @param warning - Whether the valid result should be shown as a warning.
 * @returns A successful validation result payload.
 */ const $348a63e3295a01c0$var$buildDatasetVariableValidationResult = (valid, validationText, warning = false)=>({
        success: true,
        data: {
            valid: valid,
            validationText: validationText,
            warning: warning
        }
    });
const $348a63e3295a01c0$export$6b881c0dedb4dc3b = async (_backEndUrl, target, _controller)=>{
    const trimmedValue = target.value.trim();
    const normalisedValue = (0, $OARmT.normaliseDatasetVariable)(trimmedValue);
    const existingValues = (target.options?.existingValues ?? []).map((value)=>value.toUpperCase());
    const upperTrimmedValue = trimmedValue.toUpperCase();
    if (existingValues.includes(upperTrimmedValue)) return $348a63e3295a01c0$var$buildDatasetVariableValidationResult(true, "Valid dataset and variable");
    if (normalisedValue) return $348a63e3295a01c0$var$buildDatasetVariableValidationResult(true, (0, $cncLz.CUSTOM_DATASET_VARIABLE_WARNING), true);
    return $348a63e3295a01c0$var$buildDatasetVariableValidationResult(false, "");
};

});


parcelRegister("a5JBX", function(module, exports) {

$parcel$export(module.exports, "NamedObjectControl", function () { return $1b845929de692398$export$d09896024493583c; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("5SMPf");
var $klm8J = parcelRequire("klm8J");
var $8oLnS = parcelRequire("8oLnS");

var $d4ZHR = parcelRequire("d4ZHR");
const $1b845929de692398$export$d09896024493583c = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false, invalidNames: invalidNames = [] })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/name`,
                debounceMilliseconds: -1,
                disabled: !canRename || disabled,
                id: `${dataPath.replace(/\//g, "-")}-name`,
                label: "Name",
                labelWidth: 2,
                noInvalidReturn: true,
                placeholder: "Enter name",
                sanitiseValue: (0, $8oLnS.stripDisallowedNameCharacters),
                validCondition: (0, $klm8J.checkName),
                validationTargetOptions: {
                    existingValues: invalidNames
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/label`,
                disabled: disabled,
                id: `${dataPath.replace(/\//g, "-")}-label`,
                isMultiline: true,
                label: "Label",
                labelWidth: 2,
                placeholder: "Enter label"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                allowCarriageReturn: true,
                dataPath: `${dataPath}/description`,
                disabled: disabled,
                id: `${dataPath.replace(/\//g, "-")}-description`,
                label: "Description",
                labelWidth: 2,
                placeholder: "Enter description",
                rows: 3,
                type: "textarea"
            })
        ]
    });
};
$1b845929de692398$export$d09896024493583c.displayName = "NamedObjectControl";

});

parcelRegister("jmOP2", function(module, exports) {

$parcel$export(module.exports, "ReferencedOperationRelationshipControl", function () { return $11221d3fa3c33d22$export$849f0aa9bced019; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $km9RG = parcelRequire("km9RG");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $krPhG = parcelRequire("krPhG");

var $d4ZHR = parcelRequire("d4ZHR");
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");
var $j3kPF = parcelRequire("j3kPF");

var $bRLeU = parcelRequire("bRLeU");
const $11221d3fa3c33d22$export$849f0aa9bced019 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const roleOptions = Object.values((0, $iEmH0.OperationRoleEnum)).map((role)=>({
            value: role,
            label: role
        }));
    const idRoute = dataPath.replace(/\//g, "-");
    const thisAnalysisMethod = (0, $jwDoS.getFromDataPath)((0, $km9RG.reduceDataPath)(dataPath, 4), state, (0, $ghR9g.isAnalysisMethod));
    const thisOperation = (0, $jwDoS.getFromDataPath)((0, $km9RG.reduceDataPath)(dataPath, 2), state, (0, $j3kPF.isOperation));
    if (!thisAnalysisMethod || !thisOperation) return null;
    const otherOperationNames = thisAnalysisMethod.operations.map((op)=>({
            value: op.id,
            label: op.name
        })).filter((op)=>op.label !== thisOperation.name);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                dataPath: `${dataPath}/referencedOperationRole/controlledTerm`,
                id: `${idRoute}-role`,
                label: "Role",
                labelWidth: 2,
                options: roleOptions,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                dataPath: `${dataPath}/operationId`,
                id: `${idRoute}-operation-id`,
                label: "Operation name",
                labelWidth: 2,
                options: otherOperationNames,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/description`,
                id: `${idRoute}-description`,
                label: "Description",
                labelWidth: 2,
                placeholder: "Enter description",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            })
        ]
    });
};
$11221d3fa3c33d22$export$849f0aa9bced019.displayName = "ReferencedOperationRelationshipControl";

});
parcelRegister("bRLeU", function(module, exports) {

$parcel$export(module.exports, "RemoveArsItemButton", function () { return $35fee4f35921c93d$export$16cd719b01abfc97; });

var $bR5nk = parcelRequire("bR5nk");

var $av9bi = parcelRequire("av9bi");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
const $35fee4f35921c93d$export$16cd719b01abfc97 = ({ dataPath: dataPath, disabled: disabled = false, onChange: onChange, siblingCount: siblingCount, ...iconProps })=>{
    const { dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    /**
   * Handles removing the item.
   */ const handleRemove = ()=>{
        /* istanbul ignore else -- Disabled buttons do not invoke the click handler */ if (!disabled) {
            if (onChange) onChange();
            else dispatch({
                operation: (0, $cJd2i.REMOVE_ARS_ITEM),
                dataPath: dataPath,
                newLength: siblingCount !== undefined ? siblingCount - 1 : undefined
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
        ...iconProps,
        id: `${dataPath.replace(/\//g, "-")}-remove-button`,
        className: "text-danger",
        role: "button",
        "aria-label": "Remove item",
        title: "Remove item",
        "aria-disabled": disabled,
        onClick: disabled ? undefined : handleRemove,
        style: {
            cursor: disabled ? "not-allowed" : "pointer",
            ...iconProps.style
        }
    });
};
$35fee4f35921c93d$export$16cd719b01abfc97.displayName = "RemoveArsItemButton";

});




parcelRegister("i0DBY", function(module, exports) {

$parcel$export(module.exports, "AnalysisMethodParametersControl", function () { return $4636c9567dc71efa$export$92a4aae0289a9db; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $aHdRW = parcelRequire("aHdRW");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
var $2VxLR = parcelRequire("2VxLR");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $gOxn7 = parcelRequire("gOxn7");

var $2fs6I = parcelRequire("2fs6I");
const $4636c9567dc71efa$export$92a4aae0289a9db = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const codeTemplate = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $gOxn7.isAnalysisProgrammingCodeTemplate));
    const parameters = codeTemplate?.parameters ?? [];
    const reorderableParameters = parameters.map((parameter, index)=>({
            ...parameter,
            id: `${index}`
        }));
    const [activeTab, setActiveTab] = (0, $spJKX.useState)(parameters.length > 0 ? "parameter-0" : "");
    /**
   * Handles adding a template code parameter.
   */ const handleAddParameter = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && codeTemplate) {
            const parameterCount = parameters.length;
            const newParameter = {
                name: `Parameter_${parameterCount + 1}`,
                label: `Parameter ${parameterCount + 1}`,
                description: "",
                valueSource: "operation",
                value: [],
                parameterType: "string"
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/parameters/${parameterCount}`,
                value: newParameter
            });
        }
    };
    /**
   * Handles reordering the template code parameters.
   *
   * @param newParameters - The parameters in their new order.
   */ const handleReorderParameters = (newParameters)=>{
        /* istanbul ignore else -- reordering is disabled unless a code template is present */ if (!disabled && codeTemplate) dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: `${dataPath}/parameters`,
            value: newParameters.map((parameter)=>parameters[Number(parameter.id)])
        });
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $spJKX.useEffectEvent)((newTab)=>(0, $spJKX.startTransition)(()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $spJKX.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= parameters.length) updateActiveTab(parameters.length > 0 ? "parameter-0" : "");
        else if (activeTab === "" && parameters.length > 0) updateActiveTab("parameter-0");
    }, [
        parameters.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-parameters";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default), {
                variant: "tabs",
                className: "mb-3",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VxLR.ReorderableNavList), {
                    list: reorderableParameters,
                    setList: handleReorderParameters,
                    getEventKey: (_parameter, index)=>`parameter-${index}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Content, {
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                        eventKey: `parameter-${index}`,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2fs6I.TemplateCodeParameterControl), {
                            dataPath: `${dataPath}/parameters/${index}`,
                            disabled: disabled,
                            siblingCount: parameters.length
                        }, `${parameter.name}-${index}`)
                    }, index))
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-parameter`,
                onClick: handleAddParameter,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add parameter"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$4636c9567dc71efa$export$92a4aae0289a9db.displayName = "AnalysisMethodParametersControl";

});
parcelRegister("2fs6I", function(module, exports) {

$parcel$export(module.exports, "TemplateCodeParameterControl", function () { return $2d22efb505a77d2c$export$bdb8b8609127e8cd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
var $km9RG = parcelRequire("km9RG");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $krPhG = parcelRequire("krPhG");

var $d4ZHR = parcelRequire("d4ZHR");
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");
const $2d22efb505a77d2c$export$bdb8b8609127e8cd = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const idRoute = dataPath.replace(/\//g, "-");
    const parameterType = (0, $jwDoS.getFromDataPath)(`${dataPath}/parameterType`, state, (0, $jwDoS.isString)) ?? // istanbul ignore next
    "string";
    const holdingAnalysisMethod = (0, $jwDoS.getFromDataPath)((0, $km9RG.reduceDataPath)(dataPath, 3), state, (0, $ghR9g.isAnalysisMethod));
    /** Get other existing parameter names */ const otherParameterNames = holdingAnalysisMethod?.codeTemplate?.parameters?.map((p)=>p.name) ?? // istanbul ignore next
    [];
    const thisIx = dataPath.split("/").pop();
    otherParameterNames.splice(Number(thisIx), 1); // Remove this parameter's name from the list
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled,
                invalidNames: otherParameterNames
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                dataPath: `${dataPath}/valueSource`,
                id: `${idRoute}-value-source`,
                label: "Value source",
                labelWidth: 2,
                options: [
                    {
                        value: "operation",
                        label: "Operation"
                    },
                    {
                        value: "groupingFactor",
                        label: "Grouping Factor"
                    }
                ],
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/value`,
                id: `${idRoute}-value`,
                label: "Default value(s)",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                dataPath: `${dataPath}/parameterType`,
                id: `${idRoute}-parameter-type`,
                label: "Parameter type",
                labelWidth: 2,
                disabled: disabled,
                options: [
                    {
                        value: "boolean",
                        label: "Boolean"
                    },
                    {
                        value: "multiSelect",
                        label: "Multiselect"
                    },
                    {
                        value: "number",
                        label: "Number"
                    },
                    {
                        value: "numberList",
                        label: "Number List"
                    },
                    {
                        value: "select",
                        label: "Select"
                    },
                    {
                        value: "string",
                        label: "String"
                    },
                    {
                        value: "stringList",
                        label: "String List"
                    },
                    {
                        value: "dataset.variable",
                        label: "Variable"
                    }
                ]
            }),
            [
                "multiSelect",
                "select"
            ].includes(parameterType) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/availableValues`,
                id: `${idRoute}-available-values`,
                label: "Available values",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 5,
                disabled: disabled
            })
        ]
    });
};
$2d22efb505a77d2c$export$bdb8b8609127e8cd.displayName = "TemplateCodeParameterControl";

});


parcelRegister("8MT0G", function(module, exports) {

$parcel$export(module.exports, "AnalysisProgrammingCodeTemplateControl", function () { return $3a4a288b5a71f8d9$export$e24891d9b51594b8; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $d4ZHR = parcelRequire("d4ZHR");

var $gOxn7 = parcelRequire("gOxn7");

var $96lV1 = parcelRequire("96lV1");
const $3a4a288b5a71f8d9$export$e24891d9b51594b8 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const codeTemplate = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $gOxn7.isAnalysisProgrammingCodeTemplate));
    /**
   * Handles adding a document reference for the code template.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && codeTemplate && codeTemplate.documentRef === undefined) {
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRef`,
                value: newDocumentReference
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/context`,
                id: `${idRoute}-context`,
                label: "Context",
                labelWidth: 2,
                placeholder: "Enter context",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/code`,
                id: `${idRoute}-code`,
                label: "Code",
                labelWidth: 2,
                placeholder: "Enter code",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 6,
                disabled: disabled
            }),
            codeTemplate?.documentRef && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $96lV1.DocumentReferenceControl), {
                dataPath: `${dataPath}/documentRef`,
                disabled: disabled,
                siblingCount: 1
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-document-reference`,
                onClick: handleAddDocumentReference,
                className: "d-flex align-items-center btn-sm btn-success mb-3",
                disabled: disabled || codeTemplate?.documentRef !== undefined,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add document reference"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$3a4a288b5a71f8d9$export$e24891d9b51594b8.displayName = "AnalysisProgrammingCodeTemplateControl";

});
parcelRegister("96lV1", function(module, exports) {

$parcel$export(module.exports, "DocumentReferenceControl", function () { return $dce95e7ef98334d5$export$cd9be9681dddf8ba; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $d4ZHR = parcelRequire("d4ZHR");

var $4rBn8 = parcelRequire("4rBn8");

var $2qbjE = parcelRequire("2qbjE");

var $bRLeU = parcelRequire("bRLeU");
const $dce95e7ef98334d5$export$cd9be9681dddf8ba = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const documentReference = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $4rBn8.isDocumentReference));
    const pageRefs = documentReference?.pageRefs ?? [];
    const idRoute = dataPath.replace(/\//g, "-");
    /**
   * Handles adding a new page reference to the current document reference.
   */ const handleAddPageRef = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && documentReference) {
            const pageRefCount = pageRefs.length;
            const newPageRef = {
                refType: (0, $iEmH0.PageRefTypeEnum).PhysicalRef,
                label: "",
                pageNames: [],
                pageNumbers: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/pageRefs/${pageRefCount}`,
                value: newPageRef
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/referenceDocumentId`,
                id: `${idRoute}-reference-document-id`,
                label: "Reference document id",
                labelWidth: 2,
                placeholder: "Enter reference document id",
                disabled: disabled
            }),
            pageRefs.map((pageRef, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $2qbjE.PageRefControl), {
                    dataPath: `${dataPath}/pageRefs/${index}`,
                    disabled: disabled,
                    siblingCount: pageRefs.length
                }, `${pageRef.refType}-${index}`)),
            !disabled && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-page-reference`,
                onClick: handleAddPageRef,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add page reference"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$dce95e7ef98334d5$export$cd9be9681dddf8ba.displayName = "DocumentReferenceControl";

});
parcelRegister("2qbjE", function(module, exports) {

$parcel$export(module.exports, "PageRefControl", function () { return $c8b5f96ac90ae9fe$export$3b60448f76d704d1; });

var $bR5nk = parcelRequire("bR5nk");

var $iEmH0 = parcelRequire("iEmH0");

var $krPhG = parcelRequire("krPhG");

var $d4ZHR = parcelRequire("d4ZHR");

var $bRLeU = parcelRequire("bRLeU");
const $c8b5f96ac90ae9fe$export$3b60448f76d704d1 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const pageRefTypeOptions = Object.values((0, $iEmH0.PageRefTypeEnum)).map((value)=>({
            value: value,
            label: value
        }));
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                dataPath: `${dataPath}/refType`,
                id: `${idRoute}-ref-type`,
                label: "Reference type",
                labelWidth: 2,
                options: pageRefTypeOptions,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/label`,
                id: `${idRoute}-label`,
                label: "Label",
                labelWidth: 2,
                placeholder: "Enter page reference label",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/pageNames`,
                id: `${idRoute}-page-names`,
                label: "Page names",
                labelWidth: 2,
                placeholder: "Enter one page name per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/pageNumbers`,
                id: `${idRoute}-page-numbers`,
                label: "Page numbers",
                labelWidth: 2,
                placeholder: "Enter one page number per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/firstPage`,
                id: `${idRoute}-first-page`,
                label: "First page",
                labelWidth: 2,
                placeholder: "Enter first page",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/lastPage`,
                id: `${idRoute}-last-page`,
                label: "Last page",
                labelWidth: 2,
                placeholder: "Enter last page",
                disabled: disabled
            })
        ]
    });
};
$c8b5f96ac90ae9fe$export$3b60448f76d704d1.displayName = "PageRefControl";

});





parcelRegister("55Z5Q", function(module, exports) {

$parcel$export(module.exports, "VariableSidebarItem", function () { return $5ea239d104d1ffc1$export$1a2f8a0c656327a6; });

var $bR5nk = parcelRequire("bR5nk");
const $5ea239d104d1ffc1$export$1a2f8a0c656327a6 = ({ item: item, selected: selected })=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: `px-2 py-1 border rounded w-100 ${selected ? "border-primary bg-primary-subtle" : ""}`,
        style: {
            cursor: "grab"
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "fw-semibold",
                children: item.label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                className: "text-muted",
                children: [
                    item.data.dropItem.name,
                    " ",
                    item.data.dropItem.dataType
                ]
            })
        ]
    });
$5ea239d104d1ffc1$export$1a2f8a0c656327a6.displayName = "VariableSidebarItem";

});


parcelRegister("8vWHr", function(module, exports) {

$parcel$export(module.exports, "ArsSidebarViewRadio", function () { return $36e5248616e0bbeb$export$eac86e21b49fd3fc; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
const $36e5248616e0bbeb$export$eac86e21b49fd3fc = ({ showGroupingFactors: showGroupingFactors = true, showOperations: showOperations = false, showVariables: showVariables = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const currentView = state.currentSidebar.view;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex gap-3",
        children: [
            showVariables && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-variables",
                label: "Variables",
                name: "ars-table-sidebar-view",
                value: "variable",
                checked: currentView === "variable",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cJd2i.SET_SIDEBAR_VIEW),
                        view: "variable"
                    });
                }
            }),
            showGroupingFactors && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-grouping-factors",
                label: "Grouping factors",
                name: "ars-table-sidebar-view",
                value: "groupingFactor",
                checked: currentView === "groupingFactor",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cJd2i.SET_SIDEBAR_VIEW),
                        view: "groupingFactor"
                    });
                }
            }),
            showOperations && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                type: "radio",
                id: "ars-table-sidebar-view-operations",
                label: "Operations",
                name: "ars-table-sidebar-view",
                value: "operation",
                checked: currentView === "operation",
                onChange: ()=>{
                    dispatch({
                        operation: (0, $cJd2i.SET_SIDEBAR_VIEW),
                        view: "operation"
                    });
                }
            })
        ]
    });
};
$36e5248616e0bbeb$export$eac86e21b49fd3fc.displayName = "ArsSidebarViewRadio";

});

parcelRegister("eim8g", function(module, exports) {

$parcel$export(module.exports, "NewItemButton", function () { return $b144dcd1f3c7ce9d$export$f9da8ac0bf4c10b; });

var $bR5nk = parcelRequire("bR5nk");

var $c28Y1 = parcelRequire("c28Y1");
parcelRequire("j4dHK");
var $7byiZ = parcelRequire("7byiZ");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
const $b144dcd1f3c7ce9d$export$f9da8ac0bf4c10b = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    if (![
        "operation",
        "groupingFactor"
    ].includes(state.currentSidebar.view)) return null;
    /* Do not show add button when an analysisMethod is selected */ if (state.currentSidebar.view === "operation" && state.currentSidebar.analysisMethodId) return null;
    /**
   * Add new item to the current sidebar view
   */ const addItem = ()=>{
        if (state.currentSidebar.view === "groupingFactor") {
            const newFactor = (0, $7byiZ.createNewGroupingFactor)("New grouping factor");
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: "/groupingFactors/" + newFactor.id,
                value: newFactor
            });
        } else {
            const newMethod = (0, $7byiZ.createNewAnalysisMethod)("New analysis method");
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: "/analysisMethods/" + newMethod.id,
                value: newMethod
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $c28Y1.default), {
        id: "ars-sidebar-new-item-button",
        variant: "primary",
        className: "w-100 mt-2",
        onClick: addItem,
        children: [
            "Add new",
            state.currentSidebar.view === "groupingFactor" ? " grouping factor" : " analysis method"
        ]
    });
};
$b144dcd1f3c7ce9d$export$f9da8ac0bf4c10b.displayName = "NewItemButton";

});


parcelRegister("38bQC", function(module, exports) {
$parcel$export(module.exports, "isArsSidebarItemData", function () { return (parcelRequire("f4xry")).isArsSidebarItemData; });
parcelRequire("f4xry");

});


parcelRegister("5xg49", function(module, exports) {

$parcel$export(module.exports, "ArsTableCellEditorProps", function () { return $e0d289e423b03a71$export$fadae6fc2a19ab98; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");
var $V4sXl = parcelRequire("V4sXl");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $49ar9 = parcelRequire("49ar9");

var $5kgoV = parcelRequire("5kgoV");
parcelRequire("8fWCE");
var $7qo9o = parcelRequire("7qo9o");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $6OSNn = parcelRequire("6OSNn");
var $hVpcI = parcelRequire("hVpcI");
// FE-only display metadata that must not affect content-equality checks below
const $e0d289e423b03a71$var$DISPLAY_ONLY_KEYS = [
    "disableEditing",
    "fromHierarchyId"
];
const $e0d289e423b03a71$export$438b09b12f54002e = ({ id: id, colId: colId, rowId: rowId, value: value })=>{
    const ars = (0, $4hgF7.useArsContext)();
    const { state: state, dispatch: dispatch } = (0, $5kgoV.useArsTable)();
    /**
   * Check table group against state and update if groupingFactor has changed
   * @param targetDataPath DataPath for table group to check
   */ const checkGroupingFactorChanges = (0, $spJKX.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableGroup = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $hVpcI.isArsTableSubGroupGroupingFactor)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableGroup) {
            const stateGroupingFactor = ars.state.groupingFactors[thisTableGroup.groupingFactor.id];
            if (stateGroupingFactor && !(0, $eBlbF.isEqual)((0, $eBlbF.omit)(thisTableGroup.groupingFactor, $e0d289e423b03a71$var$DISPLAY_ONLY_KEYS), (0, $eBlbF.omit)(stateGroupingFactor, $e0d289e423b03a71$var$DISPLAY_ONLY_KEYS))) dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/groupingFactor`,
                value: stateGroupingFactor
            });
        }
    });
    /**
   * Check table group against state and update if analysisMethod has changed
   * @param targetDataPath DataPath for table group to check
   */ const checkAnalysisMethodChanges = (0, $spJKX.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableGroup = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $hVpcI.isArsTableSubGroupAnalysisMethod)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableGroup) {
            const stateAnalysisMethod = ars.state.analysisMethods[thisTableGroup.analysisMethodId];
            if (stateAnalysisMethod && !(0, $eBlbF.isEqual)((0, $eBlbF.omit)(thisTableGroup.analysisMethod, $e0d289e423b03a71$var$DISPLAY_ONLY_KEYS), (0, $eBlbF.omit)(stateAnalysisMethod, $e0d289e423b03a71$var$DISPLAY_ONLY_KEYS))) dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/analysisMethod`,
                value: stateAnalysisMethod
            });
        }
    });
    /**
   * Check table against state and update if operation has changed
   * @param targetDataPath DataPath for table operation to check
   */ const checkOperationChanges = (0, $spJKX.useEffectEvent)((targetDataPath)=>{
        // istanbul ignore next
        if (!state) return;
        const thisTableOperation = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $6OSNn.isArsTableOperation)(obj, state.settings.editorProps.isT));
        /* istanbul ignore else */ if (thisTableOperation) {
            const stateOperation = Object.values(ars.state.analysisMethods).flatMap((am)=>am.operations).find((op)=>op.id === thisTableOperation.operation.id);
            if (stateOperation && !(0, $eBlbF.isEqual)(thisTableOperation.operation, stateOperation)) dispatch({
                operation: (0, $k9YO2.ARST_PATCH_DATA),
                dataPath: `${targetDataPath}/operation`,
                value: stateOperation
            });
        }
    });
    /* Monitor for groupingFactor changes, on grouping factor cells */ (0, $spJKX.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "groupingFactor") checkGroupingFactorChanges(value.dataPath);
    }, [
        ars.state.groupingFactors,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for groupingFactor changes on group/dataValues cells */ (0, $spJKX.useEffect)(()=>{
        if (value.dataPath.endsWith("/0") && state?.bodyData && state?.settings && (value.targetType === "group" || value.targetType === "dataDriven")) {
            const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(value.dataPath);
            checkGroupingFactorChanges(targetDataPath);
        }
    }, [
        ars.state.groupingFactors,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for analysisMethod changes, on analysis method cells */ (0, $spJKX.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "analysisMethod") checkAnalysisMethodChanges(value.dataPath);
    }, [
        ars.state.analysisMethods,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    /* Monitor for operation changes, on operation cells */ (0, $spJKX.useEffect)(()=>{
        if (state?.bodyData && state?.settings && value.targetType === "operation") checkOperationChanges(value.dataPath);
    }, [
        ars.state.analysisMethods,
        dispatch,
        state?.bodyData,
        state?.settings,
        value.dataPath,
        value.targetType
    ]);
    if (!state || !rowId || !colId) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    const editorProps = state.settings.editorProps;
    const Editor = editorProps.Editor;
    const isAnnotationsView = state.settings.tlfViewMode.value === "ANNOTATIONS";
    const displayContent = value.displayContent;
    const annotationContent = value.annotationContent;
    const editable = !isAnnotationsView && !state.settings.disabled && !value.disabled && value.targetType !== "dataDriven" && value.targetType !== "group" && value.cellType !== (0, $k9YO2.ArsTableCellType).DataCell;
    let justification = value.justification ?? // istanbul ignore next
    (0, $k9YO2.ArsTextJustification).Default;
    if (justification === (0, $k9YO2.ArsTextJustification).Default) {
        if ([
            (0, $k9YO2.ArsTableCellType).RowHeader,
            (0, $k9YO2.ArsTableCellType).RowGroupCell,
            (0, $k9YO2.ArsTableCellType).RowGroupLabel,
            (0, $k9YO2.ArsTableCellType).RowOperation
        ].includes(value.cellType)) justification = (0, $k9YO2.ArsTextJustification).Left;
        else justification = (0, $k9YO2.ArsTextJustification).Center;
    }
    const rowIndex = Object.keys(state.scaffoldModel?.cellData ?? {}).indexOf(rowId);
    const row = state.scaffoldModel?.cellData?.[rowId];
    const colIndex = Object.keys(row ?? {}).indexOf(colId);
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($49ar9))).arsTableCell,
            (0, (/*@__PURE__*/$parcel$interopDefault($49ar9)))[value.cellType],
            editable ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($49ar9))).disabled
        ]),
        style: {
            paddingLeft: value.inlineIndent ? `${value.inlineIndent}em` : undefined
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
            id: id,
            decimalAlignPercent: "decimalAlignPercent" in value ? value.decimalAlignPercent : undefined,
            editable: editable,
            pending: state.changed,
            setValue: (newValue)=>{
                const updates = [
                    {
                        dataPath: `${value.dataPath}/label`,
                        value: newValue
                    },
                    {
                        dataPath: `scaffoldModel/cellData/${(0, $V4sXl.encodePath)(rowId)}/${(0, $V4sXl.encodePath)(colId)}/displayContent`,
                        value: newValue
                    }
                ];
                /* istanbul ignore else */ if (rowIndex > -1 && colIndex > -1) updates.push({
                    dataPath: `calculatedTableRows/${rowIndex}/arsTableCells/${colIndex}/displayContent`,
                    value: newValue
                });
                dispatch({
                    operation: (0, $k9YO2.ARST_PATCH_DATA),
                    updates: updates
                });
            },
            textAlignment: justification,
            value: isAnnotationsView ? editorProps.textToT(annotationContent) : displayContent ?? // istanbul ignore next
            editorProps.blankT
        })
    });
};
$e0d289e423b03a71$export$438b09b12f54002e.displayName = "ArsTableCell";
const $e0d289e423b03a71$export$fadae6fc2a19ab98 = (tProps)=>({
        Editor: $e0d289e423b03a71$export$438b09b12f54002e,
        blankT: {
            annotationContent: "",
            cellType: (0, $k9YO2.ArsTableCellType).DataCell,
            columnId: "",
            columnIndex: -1,
            dataPath: "",
            displayContent: tProps.textToT(""),
            justification: (0, $k9YO2.ArsTextJustification).Default,
            rowId: "",
            targetType: "data"
        },
        getTextFromT: (cellValue)=>{
            const cellDisplay = cellValue.displayContent;
            return tProps.getTextFromT(cellDisplay);
        },
        isT: (value)=>{
            return (0, $12Lyj.isObjectRecord)(value) && "annotationContent" in value && (0, $jwDoS.isString)(value.annotationContent) && "cellType" in value && Object.values((0, $k9YO2.ArsTableCellType)).includes(value.cellType) && "dataPath" in value && (0, $jwDoS.isString)(value.dataPath) && "displayContent" in value && tProps.isT(value.displayContent);
        },
        joinTintoBlock: (cellValues)=>{
            const displayContents = cellValues.map((cv)=>cv.displayContent);
            return {
                annotationContent: cellValues.map((cv)=>cv.annotationContent).join("\n"),
                cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                columnId: cellValues[0]?.columnId ?? // istanbul ignore next
                "",
                columnIndex: cellValues[0]?.columnIndex ?? // istanbul ignore next
                -1,
                dataPath: cellValues[0]?.dataPath ?? // istanbul ignore next
                "",
                displayContent: tProps.joinTintoBlock(displayContents),
                justification: cellValues[0]?.justification ?? // istanbul ignore next
                (0, $k9YO2.ArsTextJustification).Default,
                rowId: cellValues[0]?.rowId ?? // istanbul ignore next
                "",
                targetType: "data"
            };
        },
        replaceTextInT: (cellValue, oldPhrase, newPhrase)=>{
            return {
                ...cellValue,
                displayContent: tProps.replaceTextInT(cellValue.displayContent, oldPhrase, newPhrase.displayContent)
            };
        },
        splitTintoLines: (cellValue)=>{
            const displayContent = cellValue.displayContent;
            const splitDisplay = tProps.splitTintoLines(displayContent);
            return splitDisplay.map((line)=>({
                    annotationContent: cellValue.annotationContent,
                    cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                    columnId: cellValue.columnId,
                    columnIndex: cellValue.columnIndex,
                    dataPath: cellValue.dataPath,
                    displayContent: line,
                    justification: cellValue.justification,
                    rowId: cellValue.rowId,
                    targetType: "data"
                }));
        },
        textToT: (text)=>({
                annotationContent: "",
                cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                columnId: "",
                columnIndex: -1,
                dataPath: "",
                displayContent: tProps.textToT(text),
                rowId: "",
                justification: (0, $k9YO2.ArsTextJustification).Default,
                targetType: "data"
            })
    });

});
parcelRegister("49ar9", function(module, exports) {

$parcel$export(module.exports, "arsTableCell", function () { return $305019383866e7d1$export$4e76e29d6076414e; }, function (v) { return $305019383866e7d1$export$4e76e29d6076414e = v; });
$parcel$export(module.exports, "disabled", function () { return $305019383866e7d1$export$683472f6198a076e; }, function (v) { return $305019383866e7d1$export$683472f6198a076e = v; });
var $305019383866e7d1$export$4e76e29d6076414e;
var $305019383866e7d1$export$683472f6198a076e;
$305019383866e7d1$export$4e76e29d6076414e = `mos-ArsTableCell-module--j4d_W-arsTableCell`;
$305019383866e7d1$export$683472f6198a076e = `mos-ArsTableCell-module--j4d_W-disabled`;

});


parcelRegister("jDDGB", function(module, exports) {

$parcel$export(module.exports, "ArsTableContextMenuProvider", function () { return $d65950043a7e7075$export$25eb647dcebd95bd; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $kK73x = parcelRequire("kK73x");

var $8yjow = parcelRequire("8yjow");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("1ZdiT");
var $czm2N = parcelRequire("czm2N");

var $5kgoV = parcelRequire("5kgoV");

var $g2mVC = parcelRequire("g2mVC");
parcelRequire("8fWCE");
var $7qo9o = parcelRequire("7qo9o");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");
/**
 * Resolves a view-item payload from a scaffold cell when the target is supported.
 *
 * @param cellValue - Current scaffold cell value
 * @param state - Current ArsTableContext state
 * @returns View-item payload for the properties panel, or undefined when unsupported
 */ const $d65950043a7e7075$var$resolveViewItem = (cellValue, state)=>{
    // istanbul ignore next - typeGuard that has already been validated before this call
    if (!("targetId" in cellValue)) return undefined;
    /** For groups and dataValues return the groupingFactor */ if (cellValue.targetType === "group" || cellValue.targetType === "dataDriven") {
        const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(cellValue.dataPath);
        const groupingFactor = (0, $jwDoS.getFromDataPath)(`${targetDataPath}/groupingFactor`, state.bodyData, (obj)=>(0, $czm2N.isGroupingFactor)(obj));
        /* istanbul ignore else */ if (groupingFactor) return {
            id: groupingFactor.id,
            type: "groupingFactor",
            dataPath: targetDataPath
        };
        else return undefined;
    }
    return {
        id: cellValue.targetId,
        type: cellValue.targetType,
        dataPath: cellValue.dataPath
    };
};
/**
 * Builds sorted context-menu labels for developer inspection groups.
 *
 * @param obj - Source object used to build display rows
 * @returns Context-menu items for developer display
 */ // istanbul ignore next -- developer-only inspection helper is intentionally excluded from coverage gate
const $d65950043a7e7075$var$getDeveloperMenuItems = (obj)=>Object.entries(obj ?? {}).filter(([key])=>![
            "analysisMethod",
            "groupingFactor",
            "operation",
            "displayContent"
        ].includes(key)).sort(([keyA], [keyB])=>keyA.localeCompare(keyB)).map(([key, val])=>({
            label: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        style: {
                            fontWeight: "bold"
                        },
                        children: `${key}`
                    }),
                    `: ${val}`
                ]
            })
        }));
const $d65950043a7e7075$export$25eb647dcebd95bd = ({ children: children })=>{
    const { state: state, dispatch: dispatch } = (0, $5kgoV.useArsTable)();
    const [contextMenuTarget, setContextMenuTarget] = (0, $spJKX.useState)(undefined);
    if (!state) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children
    });
    /**
   * Function to blur active element
   */ const blurActiveElement = ()=>{
        /* istanbul ignore else */ if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    };
    /**
   * Captures scaffold row and column ids before opening the context menu.
   *
   * @param event - Context menu event fired from scaffold cells
   */ const handleScaffoldContextMenuCapture = (event)=>{
        let ret = undefined;
        const target = (0, $8yjow.getScaffoldContextMenuTarget)(event.target);
        /* istanbul ignore else */ if (target) {
            const resolvedValue = state?.scaffoldModel?.cellData?.[target.rowId]?.[target.colId];
            /* istanbul ignore else */ if (resolvedValue) ret = {
                ...target,
                value: resolvedValue
            };
        }
        setContextMenuTarget(ret);
    };
    const actionList = [];
    if (contextMenuTarget) {
        if ("targetId" in contextMenuTarget.value && contextMenuTarget.value.targetType) actionList.push({
            label: "Show item properties",
            action: ()=>{
                blurActiveElement();
                const viewItem = $d65950043a7e7075$var$resolveViewItem(contextMenuTarget.value, state);
                /* istanbul ignore else */ if (viewItem) dispatch({
                    operation: (0, $k9YO2.ARST_SET_VIEW_ITEM),
                    viewItem: viewItem
                });
            }
        });
        const cellActions = (0, $g2mVC.cellActionConfig)(contextMenuTarget.value, state).contextMenuActions.map((actionDefn)=>({
                label: actionDefn.label,
                disabled: actionDefn.disabled,
                action: ()=>{
                    blurActiveElement();
                    dispatch({
                        operation: actionDefn.operation,
                        cellValue: contextMenuTarget.value
                    });
                }
            }));
        actionList.push(...cellActions);
        /** Add developer info display */ // istanbul ignore next
        if ([
            "local",
            "development",
            "test",
            "__REACT_APP_STAGE__"
        ].includes((0, $kK73x.REACT_APP_STAGE)) && state.bodyData) {
            const developerMenuItems = [
                {
                    label: "Developer info",
                    group: $d65950043a7e7075$var$getDeveloperMenuItems(contextMenuTarget.value)
                }
            ];
            actionList.push(...developerMenuItems);
            const targetDataPath = (0, $7qo9o.arst_resolveTargetPath)(contextMenuTarget.value.dataPath);
            const dataPathData = (0, $jwDoS.getFromDataPath)(targetDataPath, state.bodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT));
            if (dataPathData) {
                const developerGroupMenuItems = [
                    {
                        label: "Developer info (group)",
                        group: $d65950043a7e7075$var$getDeveloperMenuItems(dataPathData)
                    }
                ];
                if ("groupingFactor" in dataPathData) developerGroupMenuItems[0].group?.push(...$d65950043a7e7075$var$getDeveloperMenuItems(dataPathData.groupingFactor));
                if ("analysisMethod" in dataPathData) developerGroupMenuItems[0].group?.push(...$d65950043a7e7075$var$getDeveloperMenuItems(dataPathData.analysisMethod));
                if ("operation" in dataPathData) developerGroupMenuItems[0].group?.push(...$d65950043a7e7075$var$getDeveloperMenuItems(dataPathData.operation));
                actionList.push(...developerGroupMenuItems);
            }
        }
    }
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
        menuItems: actionList,
        onContextMenuCapture: handleScaffoldContextMenuCapture,
        children: children
    });
};
$d65950043a7e7075$export$25eb647dcebd95bd.displayName = "ArsTableContextMenuProvider";

});

parcelRegister("cVqbP", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemProperties", function () { return $3be40ce4701e7992$export$f9216f51529681b3; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("d0WZT");
var $321H1 = parcelRequire("321H1");
var $51n1k = parcelRequire("51n1k");
var $j32AA = parcelRequire("j32AA");

var $5kgoV = parcelRequire("5kgoV");

var $5UwO1 = parcelRequire("5UwO1");

var $k9YO2 = parcelRequire("k9YO2");
const $3be40ce4701e7992$export$f9216f51529681b3 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $5kgoV.useArsTable)();
    if (!state?.viewItem) return null;
    /**
   * Clears the current view item and closes the properties panel.
   */ const handleHide = ()=>{
        dispatch({
            operation: (0, $k9YO2.ARST_SET_VIEW_ITEM),
            viewItem: undefined
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: "ars-table-item-properties",
        visible: state.viewItem !== undefined,
        onClose: handleHide,
        initialDockEdge: "left",
        title: "Item properties",
        children: state.viewItem.type === "analysisMethod" ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $321H1.AnalysisMethodControl), {
                    dataPath: `/analysisMethods/${state.viewItem.id}`,
                    disabled: true
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5UwO1.ArsTableItemParameters), {
                    dataPath: state.viewItem.dataPath
                })
            ]
        }) : state.viewItem.type === "operation" ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j32AA.OperationControl), {
                    dataPath: `/operations/${state.viewItem.id}`,
                    siblingCount: -9,
                    disabled: true
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5UwO1.ArsTableItemParameters), {
                    dataPath: state.viewItem.dataPath
                })
            ]
        }) : state.viewItem.type === "groupingFactor" ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $51n1k.GroupingFactorControl), {
                    dataPath: `/groupingFactors/${state.viewItem.id}`,
                    disabled: true
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5UwO1.ArsTableItemParameters), {
                    dataPath: state.viewItem.dataPath
                })
            ]
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: "text-danger",
            children: "Invalid item type"
        })
    });
};
$3be40ce4701e7992$export$f9216f51529681b3.displayName = "ArsTableItemProperties";

});
parcelRegister("5UwO1", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemParameters", function () { return $84634b0c30c71f3f$export$821b30b6c0d300f5; });

var $bR5nk = parcelRequire("bR5nk");

var $iOTZL = parcelRequire("iOTZL");
var $31g00 = parcelRequire("31g00");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("d0WZT");
var $3C4oq = parcelRequire("3C4oq");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("fc2Ha");
var $krPhG = parcelRequire("krPhG");
var $d4ZHR = parcelRequire("d4ZHR");
var $2VKUu = parcelRequire("2VKUu");

var $5cJwY = parcelRequire("5cJwY");
parcelRequire("1ZdiT");
var $ghR9g = parcelRequire("ghR9g");
var $j3kPF = parcelRequire("j3kPF");

var $czm2N = parcelRequire("czm2N");

var $5kgoV = parcelRequire("5kgoV");

var $aEq6t = parcelRequire("aEq6t");

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("alciT");
var $atjhL = parcelRequire("atjhL");
const $84634b0c30c71f3f$export$821b30b6c0d300f5 = ({ dataPath: dataPath, disabled: disabled })=>{
    const ars = (0, $4hgF7.useArsContext)();
    const { state: state, dispatch: dispatch } = (0, $5kgoV.useArsTable)();
    const tableBodyData = state?.bodyData;
    const thisItem = tableBodyData ? (0, $jwDoS.getFromDataPath)(dataPath, tableBodyData, (obj)=>(0, $atjhL.isArsTableGroupCalculationDto)(obj, state.settings.editorProps.isT)) : null;
    const analysisMethod = state && state.bodyData.analysisMethodId ? (0, $jwDoS.getFromDataPath)(`/analysisMethods/${state.bodyData.analysisMethodId}`, ars.state, (0, $ghR9g.isAnalysisMethod)) : null;
    if (!state || !thisItem || !analysisMethod) return null;
    const groupingFactor = tableBodyData ? (0, $jwDoS.getFromDataPath)(`${dataPath}/groupingFactor`, tableBodyData, (0, $czm2N.isGroupingFactor)) : null;
    const operation = tableBodyData ? (0, $jwDoS.getFromDataPath)(`${dataPath}/operation`, tableBodyData, (0, $j3kPF.isOperation)) : null;
    const availableParameters = analysisMethod.codeTemplate?.parameters?.filter((tcp)=>tcp.valueSource === "groupingFactor" && groupingFactor || tcp.valueSource === "operation" && operation) ?? [];
    // Space after group only applies to items on the row axis
    const isRowItem = dataPath.startsWith("/rows/");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            operation && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                id: `${dataPath.replace(/\//g, "-")}-target-variable`,
                combinedDataPath: `${dataPath}/targetVariable`,
                tableDataPath: true,
                label: "Target variable",
                labelWidth: 5,
                disabled: disabled
            }),
            availableParameters.map((parameter, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $aEq6t.ArsTableItemParameterValue), {
                    parameter: parameter,
                    index: index,
                    dataPath: dataPath,
                    disabled: disabled
                }, `${parameter.name}-${index}`)),
            operation && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                        id: `${dataPath.replace(/\//g, "-")}-justification`,
                        dataPath: `${dataPath}/justification`,
                        tableDataPath: true,
                        label: "Justification",
                        labelWidth: 5,
                        options: Object.entries((0, $k9YO2.ArsTextJustification)).map(([label, value])=>({
                                value: value,
                                label: label
                            })),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                        id: `${dataPath.replace(/\//g, "-")}-decimal-align-percent`,
                        dataPath: `${dataPath}/decimalAlignPercent`,
                        disabled: disabled,
                        label: "Decimal align %",
                        labelWidth: 5,
                        type: "number",
                        tableDataPath: true
                    })
                ]
            }),
            isRowItem && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5cJwY.ArsBoolean), {
                id: `${dataPath.replace(/\//g, "-")}-space-after-group`,
                dataPath: `${dataPath}/spaceAfterGroup`,
                disabled: disabled,
                falseIsUndefined: true,
                label: "Space after group",
                labelWidth: 5,
                tableDataPath: true
            }),
            isRowItem && groupingFactor && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5cJwY.ArsBoolean), {
                id: `${dataPath.replace(/\//g, "-")}-space-after-sub-groups`,
                dataPath: `${dataPath}/spaceAfterSubGroups`,
                disabled: disabled,
                falseIsUndefined: true,
                label: "Space after each sub-group",
                labelWidth: 5,
                tableDataPath: true
            }),
            operation && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                        className: "my-1",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            id: "ars-table-operation-case-when-label",
                            "aria-label": "Complex display conditions",
                            className: "mt-3 form-label col-form-label",
                            htmlFor: "ars-table-operation-case-when",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                children: "Complex display conditions"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3C4oq.CaseWhenControl), {
                                id: "ars-table-operation-case-when",
                                "aria-labelledby": "ars-table-operation-case-when-label",
                                dataPath: `/caseWhenConditions/${thisItem.id}`,
                                disabled: state.settings.disabled,
                                editorDefns: state.settings.editorProps,
                                onChange: (ret)=>{
                                    // Update the ARS table state to show a change has been made
                                    dispatch({
                                        operation: (0, $k9YO2.ARST_PATCH_DATA),
                                        dataPath: `${dataPath}/caseWhenCondition`,
                                        value: ret
                                    });
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$84634b0c30c71f3f$export$821b30b6c0d300f5.displayName = "ArsTableItemParameters";

});
parcelRegister("aEq6t", function(module, exports) {

$parcel$export(module.exports, "ArsTableItemParameterValue", function () { return $e0e7f1a8086fed38$export$9948cf09eae9aad2; });

var $bR5nk = parcelRequire("bR5nk");

var $krPhG = parcelRequire("krPhG");

var $d4ZHR = parcelRequire("d4ZHR");

var $2VKUu = parcelRequire("2VKUu");
parcelRequire("cS6mF");
var $9Ag83 = parcelRequire("9Ag83");
const $e0e7f1a8086fed38$export$9948cf09eae9aad2 = ({ index: index, dataPath: dataPath, disabled: disabled, parameter: parameter })=>{
    const baseDataPath = `${dataPath}/parameters`;
    // The back end camel-cases dictionary keys, so the saved value lives under the normalised name.
    // Names are normalised when edited, but this also covers parameters saved before that change.
    const parameterPath = `${baseDataPath}/${(0, $9Ag83.normalizeParameterName)(parameter.name)}`;
    const idRoute = `${dataPath.replace(/\//g, "-")}-parameter-${index}`;
    const label = parameter.label ?? parameter.name;
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: parameter.parameterType === "select" || parameter.parameterType === "multiSelect" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-select`,
            label: label,
            labelWidth: 5,
            options: (parameter.availableValues ?? []).map((value)=>({
                    value: value,
                    label: value
                })),
            multiple: parameter.parameterType === "multiSelect",
            disabled: disabled || (parameter.availableValues ?? []).length === 0
        }) : parameter.parameterType === "boolean" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-boolean`,
            label: label,
            labelWidth: 5,
            options: [
                {
                    value: "true",
                    label: "True"
                },
                {
                    value: "false",
                    label: "False"
                }
            ],
            disabled: disabled
        }) : parameter.parameterType === "dataset.variable" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
            combinedDataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-dataset-variable`,
            label: label,
            labelWidth: 5,
            disabled: disabled
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
            dataPath: parameterPath,
            tableDataPath: true,
            id: `${idRoute}-text`,
            label: label,
            labelWidth: 5,
            placeholder: `Enter ${label}`,
            isArray: parameter.parameterType === "stringList" || parameter.parameterType === "numberList",
            disabled: disabled
        })
    });
};
$e0e7f1a8086fed38$export$9948cf09eae9aad2.displayName = "ArsTableItemParameter";

});
parcelRegister("cS6mF", function(module, exports) {
$parcel$export(module.exports, "normalizeParameterName", function () { return (parcelRequire("9Ag83")).normalizeParameterName; });
parcelRequire("5JArC");
parcelRequire("6iDPv");
parcelRequire("9Ag83");
parcelRequire("dDwJ9");
parcelRequire("8E7ct");

});
parcelRegister("5JArC", function(module, exports) {

$parcel$export(module.exports, "formatConditionAsCode", function () { return $b2e4485da09501db$export$416fe34beaf1829a; });

var $iEmH0 = parcelRequire("iEmH0");

var $dDwJ9 = parcelRequire("dDwJ9");
const $b2e4485da09501db$export$416fe34beaf1829a = (condition, availableVariables)=>{
    if (!condition || !condition.dataset || !condition.variable) return "";
    const dataset = condition.dataset;
    const variable = condition.variable;
    // Determine comparator enum (default to EQ)
    const compEnum = condition.comparator ?? (0, $iEmH0.ConditionComparatorEnum).EQ;
    // Default to empty array when value is undefined (provably unreachable in normal operation)
    const values = condition.value ?? // istanbul ignore next
    [];
    const displayComparator = (0, $dDwJ9.comparatorDefinitions)[compEnum] ? (0, $dDwJ9.comparatorDefinitions)[compEnum].write : compEnum;
    if (values.length === 0) return `${dataset}.${variable} ${displayComparator} ?`;
    // Find the variable in the available list to determine its dataType
    const variableKey = `${dataset}.${variable}`;
    const variableInfo = availableVariables?.find((v)=>v.value === variableKey);
    const isNumeric = variableInfo?.dataType?.toLowerCase() === "integer" || variableInfo?.dataType?.toLowerCase() === "float" || variableInfo?.dataType?.toLowerCase() === "numeric" || variableInfo?.dataType?.toLowerCase() === "number" || !variableInfo && !isNaN(Number(values[0])); // Fallback: if variable info is not available, check if value is numeric
    /**
   * Formats a single value with or without quotes based on dataType.
   *
   * @param v - The value to format.
   * @returns The formatted value.
   */ const formatValue = (v)=>{
        return isNumeric ? v : `'${v}'`;
    };
    // Format values based on comparator
    if (compEnum === (0, $iEmH0.ConditionComparatorEnum).IN || compEnum === (0, $iEmH0.ConditionComparatorEnum).NOTIN) {
        const formattedValues = values.map(formatValue).join(", ");
        const compString = compEnum === (0, $iEmH0.ConditionComparatorEnum).NOTIN ? "NOT IN" : "IN";
        return `${dataset}.${variable} ${compString} (${formattedValues})`;
    }
    // Single value comparators
    const value = values[0];
    return `${dataset}.${variable} ${displayComparator} ${formatValue(value)}`;
};

});

parcelRegister("6iDPv", function(module, exports) {

$parcel$export(module.exports, "formatWhereClauseAsCode", function () { return $5b2b253f4223f65b$export$d99b8d05a55e7c39; });

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("1ZdiT");
var $4FB18 = parcelRequire("4FB18");
var $ejHCH = parcelRequire("ejHCH");
var $9QVTJ = parcelRequire("9QVTJ");
var $lPVPO = parcelRequire("lPVPO");
var $cTgGQ = parcelRequire("cTgGQ");

var $5JArC = parcelRequire("5JArC");
const $5b2b253f4223f65b$export$d99b8d05a55e7c39 = (whereClause, availableVariables)=>{
    if ((0, $9QVTJ.isSubClauseWithReference)(whereClause) && whereClause.subClauseId !== "") return `[${whereClause.subClauseId}]`;
    else if ((0, $cTgGQ.isWhereClauseWithCondition)(whereClause) || (0, $ejHCH.isSubClauseWithCondition)(whereClause)) return (0, $5JArC.formatConditionAsCode)(whereClause.condition, availableVariables);
    else if ((0, $lPVPO.isWhereClauseWithCompoundExpression)(whereClause) || (0, $4FB18.isSubClauseWithCompoundExpression)(whereClause)) {
        const { logicalOperator: logicalOperator, whereClauses: whereClauses } = whereClause.compoundExpression;
        if (!whereClauses || whereClauses.length === 0) return "";
        // Format each sub-clause
        const formattedClauses = whereClauses.map((subClause)=>$5b2b253f4223f65b$var$formatSubClause(subClause, availableVariables)).filter((clause)=>clause !== "");
        if (formattedClauses.length === 0) return "";
        // Handle NOT operator
        if (logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT) {
            const clause = formattedClauses[0];
            // Clause is either already bracketed or a simple condition
            return `NOT ${clause}`;
        }
        // Handle AND/OR operators
        const operator = logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).AND ? " AND " : " OR ";
        const combined = formattedClauses.join(operator);
        // Wrap in brackets for compound expressions
        return `(${combined})`;
    }
    return "";
};
/**
 * Formats a sub-clause (part of a compound expression) as code.
 *
 * @param subClause - The sub-clause to format.
 * @param availableVariables - List of available variables with dataType information.
 * @returns Formatted string for the sub-clause.
 */ const $5b2b253f4223f65b$var$formatSubClause = (subClause, availableVariables)=>{
    // Handle referenced where clause (subClauseId)
    /* istanbul ignore else  */ if ((0, $9QVTJ.isSubClauseWithReference)(subClause) && subClause.subClauseId !== "") return `[${subClause.subClauseId}]`;
    else if ((0, $ejHCH.isSubClauseWithCondition)(subClause)) return (0, $5JArC.formatConditionAsCode)(subClause.condition, availableVariables);
    else if ((0, $4FB18.isSubClauseWithCompoundExpression)(subClause)) {
        const { logicalOperator: logicalOperator, whereClauses: whereClauses } = subClause.compoundExpression;
        if (!whereClauses || whereClauses.length === 0) return "";
        const formattedClauses = whereClauses.map((sc)=>$5b2b253f4223f65b$var$formatSubClause(sc, availableVariables)).filter((clause)=>clause !== "");
        if (formattedClauses.length === 0) return "";
        // Handle NOT operator
        if (logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).NOT) {
            const clause = formattedClauses[0];
            // Clause is either already bracketed or a simple condition
            return `NOT ${clause}`;
        }
        // Handle AND/OR operators
        const operator = logicalOperator === (0, $iEmH0.ExpressionLogicalOperatorEnum).AND ? " AND " : " OR ";
        return `(${formattedClauses.join(operator)})`;
    }
    // istanbul ignore next
    return "";
};

});





parcelRegister("hTg9m", function(module, exports) {

$parcel$export(module.exports, "ArsTableTreeView", function () { return $9706ec9f5250e8df$export$56249a5b523308ba; });

var $bR5nk = parcelRequire("bR5nk");

var $5kgoV = parcelRequire("5kgoV");

var $7QjLH = parcelRequire("7QjLH");

var $3pgYM = parcelRequire("3pgYM");
parcelRequire("8fWCE");
var $hjdwt = parcelRequire("hjdwt");
/**
 * Renders one side of the ArsTableTreeView (either rows or columns) with a heading and tree nodes.
 *
 * @param props - Component properties
 * @param props.label - Heading label for the tree side (e.g., "Rows" or "Columns")
 * @param props.nodes - Array of tree nodes to render under this side
 * @param props.defaultExpanded - Whether tree nodes should be expanded by default (default: true)
 * @returns Rendered tree view side component
 */ const $9706ec9f5250e8df$var$ArsTableTreeViewSide = ({ label: label, nodes: nodes, defaultExpanded: defaultExpanded })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-body-tree-section"],
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-body-tree-heading"],
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-body-tree-content"],
                children: nodes.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-body-tree-empty"],
                    children: "No groups defined"
                }) : nodes.map((node)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $3pgYM.ArsTableTreeNode), {
                        defaultExpanded: defaultExpanded,
                        ...node
                    }, node.id))
            })
        ]
    });
};
$9706ec9f5250e8df$var$ArsTableTreeViewSide.displayName = "ArsTableTreeViewSide";
const $9706ec9f5250e8df$export$56249a5b523308ba = ({ defaultExpanded: defaultExpanded = true })=>{
    const { state: state } = (0, $5kgoV.useArsTable)();
    if (!state) return null;
    const rowNodes = state.bodyData.rows.map((row)=>(0, $hjdwt.groupToTreeNode)(row, state.settings.editorProps.isT));
    const columnNodes = state.bodyData.columns.map((col)=>(0, $hjdwt.groupToTreeNode)(col, state.settings.editorProps.isT));
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-body-tree-view"],
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)($9706ec9f5250e8df$var$ArsTableTreeViewSide, {
                label: "Rows",
                nodes: rowNodes,
                defaultExpanded: defaultExpanded
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)($9706ec9f5250e8df$var$ArsTableTreeViewSide, {
                label: "Columns",
                nodes: columnNodes,
                defaultExpanded: defaultExpanded
            })
        ]
    });
};
$9706ec9f5250e8df$export$56249a5b523308ba.displayName = "ArsTableTreeView";

});
parcelRegister("7QjLH", function(module, exports) {

$parcel$export(module.exports, "mos-ars-body-tree-content", function () { return $5b5cb95380669ff4$export$e73c47a2197af69b; }, function (v) { return $5b5cb95380669ff4$export$e73c47a2197af69b = v; });
$parcel$export(module.exports, "mos-ars-body-tree-empty", function () { return $5b5cb95380669ff4$export$24888271bc299ff7; }, function (v) { return $5b5cb95380669ff4$export$24888271bc299ff7 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-heading", function () { return $5b5cb95380669ff4$export$ff5b88941eeddb72; }, function (v) { return $5b5cb95380669ff4$export$ff5b88941eeddb72 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-section", function () { return $5b5cb95380669ff4$export$3715647d719cacd5; }, function (v) { return $5b5cb95380669ff4$export$3715647d719cacd5 = v; });
$parcel$export(module.exports, "mos-ars-body-tree-view", function () { return $5b5cb95380669ff4$export$606fb8533ca7774f; }, function (v) { return $5b5cb95380669ff4$export$606fb8533ca7774f = v; });
$parcel$export(module.exports, "mos-ars-tree-node", function () { return $5b5cb95380669ff4$export$96ae3f9c054415b3; }, function (v) { return $5b5cb95380669ff4$export$96ae3f9c054415b3 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-children", function () { return $5b5cb95380669ff4$export$cf04eda64b18505b; }, function (v) { return $5b5cb95380669ff4$export$cf04eda64b18505b = v; });
$parcel$export(module.exports, "mos-ars-tree-node-content", function () { return $5b5cb95380669ff4$export$bdbd357637db81e3; }, function (v) { return $5b5cb95380669ff4$export$bdbd357637db81e3 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-id", function () { return $5b5cb95380669ff4$export$3cee6b62e86b25c6; }, function (v) { return $5b5cb95380669ff4$export$3cee6b62e86b25c6 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-label", function () { return $5b5cb95380669ff4$export$8fd2cfb32f8466d4; }, function (v) { return $5b5cb95380669ff4$export$8fd2cfb32f8466d4 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-spacer", function () { return $5b5cb95380669ff4$export$7c06628002aa3fe8; }, function (v) { return $5b5cb95380669ff4$export$7c06628002aa3fe8 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-toggle", function () { return $5b5cb95380669ff4$export$acde1c1bf05b2cde; }, function (v) { return $5b5cb95380669ff4$export$acde1c1bf05b2cde = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type", function () { return $5b5cb95380669ff4$export$c09494a2673157df; }, function (v) { return $5b5cb95380669ff4$export$c09494a2673157df = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-analysisMethod", function () { return $5b5cb95380669ff4$export$7bf88682578e874c; }, function (v) { return $5b5cb95380669ff4$export$7bf88682578e874c = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-group", function () { return $5b5cb95380669ff4$export$b2c4c3b6783bb4f9; }, function (v) { return $5b5cb95380669ff4$export$b2c4c3b6783bb4f9 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-groupingFactor", function () { return $5b5cb95380669ff4$export$826cf34c869b6802; }, function (v) { return $5b5cb95380669ff4$export$826cf34c869b6802 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-operation", function () { return $5b5cb95380669ff4$export$619c2077ebcc21b0; }, function (v) { return $5b5cb95380669ff4$export$619c2077ebcc21b0 = v; });
$parcel$export(module.exports, "mos-ars-tree-node-type-subgroup", function () { return $5b5cb95380669ff4$export$6b2a74972bf44a8a; }, function (v) { return $5b5cb95380669ff4$export$6b2a74972bf44a8a = v; });
var $5b5cb95380669ff4$export$e73c47a2197af69b;
var $5b5cb95380669ff4$export$24888271bc299ff7;
var $5b5cb95380669ff4$export$ff5b88941eeddb72;
var $5b5cb95380669ff4$export$3715647d719cacd5;
var $5b5cb95380669ff4$export$606fb8533ca7774f;
var $5b5cb95380669ff4$export$96ae3f9c054415b3;
var $5b5cb95380669ff4$export$cf04eda64b18505b;
var $5b5cb95380669ff4$export$bdbd357637db81e3;
var $5b5cb95380669ff4$export$3cee6b62e86b25c6;
var $5b5cb95380669ff4$export$8fd2cfb32f8466d4;
var $5b5cb95380669ff4$export$7c06628002aa3fe8;
var $5b5cb95380669ff4$export$acde1c1bf05b2cde;
var $5b5cb95380669ff4$export$c09494a2673157df;
var $5b5cb95380669ff4$export$7bf88682578e874c;
var $5b5cb95380669ff4$export$b2c4c3b6783bb4f9;
var $5b5cb95380669ff4$export$826cf34c869b6802;
var $5b5cb95380669ff4$export$619c2077ebcc21b0;
var $5b5cb95380669ff4$export$6b2a74972bf44a8a;
$5b5cb95380669ff4$export$e73c47a2197af69b = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-content`;
$5b5cb95380669ff4$export$24888271bc299ff7 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-empty`;
$5b5cb95380669ff4$export$ff5b88941eeddb72 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-heading`;
$5b5cb95380669ff4$export$3715647d719cacd5 = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-section`;
$5b5cb95380669ff4$export$606fb8533ca7774f = `mos-ArsTableTree-module-ylA56W-mos-ars-body-tree-view`;
$5b5cb95380669ff4$export$96ae3f9c054415b3 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node`;
$5b5cb95380669ff4$export$cf04eda64b18505b = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-children`;
$5b5cb95380669ff4$export$bdbd357637db81e3 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-content`;
$5b5cb95380669ff4$export$3cee6b62e86b25c6 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-id`;
$5b5cb95380669ff4$export$8fd2cfb32f8466d4 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-label`;
$5b5cb95380669ff4$export$7c06628002aa3fe8 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-spacer`;
$5b5cb95380669ff4$export$acde1c1bf05b2cde = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-toggle`;
$5b5cb95380669ff4$export$c09494a2673157df = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type`;
$5b5cb95380669ff4$export$7bf88682578e874c = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-analysisMethod`;
$5b5cb95380669ff4$export$b2c4c3b6783bb4f9 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-group`;
$5b5cb95380669ff4$export$826cf34c869b6802 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-groupingFactor`;
$5b5cb95380669ff4$export$619c2077ebcc21b0 = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-operation`;
$5b5cb95380669ff4$export$6b2a74972bf44a8a = `mos-ArsTableTree-module-ylA56W-mos-ars-tree-node-type-subgroup`;

});

parcelRegister("3pgYM", function(module, exports) {

$parcel$export(module.exports, "ArsTableTreeNode", function () { return $2defc7e91141eb11$export$81350f32bf958e67; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $5kgoV = parcelRequire("5kgoV");

var $7QjLH = parcelRequire("7QjLH");
const $2defc7e91141eb11$export$81350f32bf958e67 = ({ defaultExpanded: defaultExpanded = true, id: id, label: label, subNodes: subNodes, type: type })=>{
    const { state: state } = (0, $5kgoV.useArsTable)();
    const [isExpanded, setIsExpanded] = (0, $spJKX.useState)(defaultExpanded);
    if (!state) return null;
    const hasChildren = subNodes && subNodes.length > 0;
    const stringLabel = state.settings.editorProps.getTextFromT(label).join("");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node"],
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-content"],
                children: [
                    hasChildren ? /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-toggle"],
                        onClick: ()=>setIsExpanded(!isExpanded),
                        type: "button",
                        "aria-label": `Toggle ${stringLabel}`,
                        children: isExpanded ? "\u25bc" : "\u25b6"
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-spacer"]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: `${(0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-type"]} ${(0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))[`mos-ars-tree-node-type-${type}`]}`,
                        children: type
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-label"],
                        children: stringLabel
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-id"],
                        children: id
                    })
                ]
            }),
            hasChildren && isExpanded && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($7QjLH)))["mos-ars-tree-node-children"],
                children: subNodes.map((child)=>/*#__PURE__*/ (0, $bR5nk.jsx)($2defc7e91141eb11$export$81350f32bf958e67, {
                        ...child,
                        defaultExpanded: defaultExpanded
                    }, child.id))
            })
        ]
    });
};
$2defc7e91141eb11$export$81350f32bf958e67.displayName = "ArsTableTreeNode";

});







parcelRegister("dhw82", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputProgrammingCodeControl", function () { return $309ffc9f7dbfd54c$export$ef66fa1ea94f6f9b; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $d4ZHR = parcelRequire("d4ZHR");
parcelRequire("1ZdiT");
var $bze11 = parcelRequire("bze11");

var $96lV1 = parcelRequire("96lV1");
const $309ffc9f7dbfd54c$export$ef66fa1ea94f6f9b = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const programmingCode = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $bze11.isAnalysisOutputProgrammingCodeValue));
    /**
   * Handles adding a document reference for the programming code.
   */ const handleAddDocumentReference = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && programmingCode && programmingCode.documentRef === undefined) {
            const newDocumentReference = {
                referenceDocumentId: "",
                pageRefs: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/documentRef`,
                value: newDocumentReference
            });
        }
    };
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/context`,
                id: `${idRoute}-context`,
                label: "Context",
                labelWidth: 2,
                placeholder: "Enter context",
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/code`,
                id: `${idRoute}-code`,
                label: "Code",
                labelWidth: 2,
                placeholder: "Enter code",
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 6,
                disabled: disabled
            }),
            programmingCode?.documentRef && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $96lV1.DocumentReferenceControl), {
                dataPath: `${dataPath}/documentRef`,
                disabled: disabled,
                siblingCount: 1
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-document-reference`,
                onClick: handleAddDocumentReference,
                className: "d-flex align-items-center btn-sm btn-success mb-3",
                disabled: disabled || programmingCode?.documentRef !== undefined || programmingCode === undefined,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add document reference"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$309ffc9f7dbfd54c$export$ef66fa1ea94f6f9b.displayName = "AnalysisOutputProgrammingCodeControl";

});

parcelRegister("afLof", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputProgrammingCodeParametersControl", function () { return $8411e1a4ea4ceefa$export$ec04ac7a6b87501f; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $aHdRW = parcelRequire("aHdRW");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $bze11 = parcelRequire("bze11");

var $4AeiR = parcelRequire("4AeiR");
const $8411e1a4ea4ceefa$export$ec04ac7a6b87501f = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const programmingCode = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $bze11.isAnalysisOutputProgrammingCodeValue));
    const parameters = programmingCode?.parameters ?? [];
    const [activeTab, setActiveTab] = (0, $spJKX.useState)(parameters.length > 0 ? "parameter-0" : "");
    /**
   * Handles adding an analysis output code parameter.
   */ const handleAddParameter = ()=>{
        /* istanbul ignore else -- Disabled buttons cannot invoke this handler from the UI */ if (!disabled && programmingCode) {
            const parameterCount = parameters.length;
            const newParameter = {
                name: `Parameter_${parameterCount + 1}`,
                label: `Parameter ${parameterCount + 1}`,
                description: "",
                value: []
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/parameters/${parameterCount}`,
                value: newParameter
            });
        }
    };
    /**
   * Event handler to update the active tab.
   *
   * @param newTab - Tab key to activate.
   */ const updateActiveTab = (0, $spJKX.useEffectEvent)((newTab)=>(0, $spJKX.startTransition)(async ()=>setActiveTab(newTab)));
    /** Move tabs */ (0, $spJKX.useEffect)(()=>{
        if (parseInt(activeTab.split("-")[1], 10) >= parameters.length) updateActiveTab(parameters.length > 0 ? "parameter-0" : "");
        else if (activeTab === "" && parameters.length > 0) updateActiveTab("parameter-0");
    }, [
        parameters.length,
        activeTab
    ]);
    const idRoute = dataPath.replace(/\//g, "-") + "-parameters";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
        activeKey: activeTab,
        onSelect: (k)=>{
            /* istanbul ignore else */ if (k) setActiveTab(k);
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default), {
                variant: "tabs",
                className: "mb-3",
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                            eventKey: `parameter-${index}`,
                            children: parameter.name
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Content, {
                children: parameters.map((parameter, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                        eventKey: `parameter-${index}`,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4AeiR.AnalysisOutputCodeParameterControl), {
                            dataPath: `${dataPath}/parameters/${index}`,
                            disabled: disabled,
                            siblingCount: parameters.length
                        }, `${parameter.name}-${index}`)
                    }, index))
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: `${idRoute}-add-parameter`,
                onClick: handleAddParameter,
                className: "d-flex align-items-center btn-sm btn-success",
                disabled: disabled || programmingCode === undefined,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: "me-2",
                        children: "Add parameter"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                ]
            })
        ]
    });
};
$8411e1a4ea4ceefa$export$ec04ac7a6b87501f.displayName = "AnalysisOutputProgrammingCodeParametersControl";

});
parcelRegister("4AeiR", function(module, exports) {

$parcel$export(module.exports, "AnalysisOutputCodeParameterControl", function () { return $de4e088d86ec1c91$export$f621922ff05ed0e1; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("fc2Ha");
var $d4ZHR = parcelRequire("d4ZHR");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");
const $de4e088d86ec1c91$export$f621922ff05ed0e1 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    const idRoute = dataPath.replace(/\//g, "-");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                dataPath: `${dataPath}/value`,
                id: `${idRoute}-value`,
                label: "Value(s)",
                labelWidth: 2,
                placeholder: "Enter one value per line",
                isArray: true,
                type: "textarea",
                debounceMilliseconds: 2000,
                rows: 3,
                disabled: disabled
            })
        ]
    });
};
$de4e088d86ec1c91$export$f621922ff05ed0e1.displayName = "AnalysisOutputCodeParameterControl";

});



parcelRegister("36pkg", function(module, exports) {

$parcel$export(module.exports, "AnalysisSetControl", function () { return $851b10c03a3e463a$export$50ac7856e9864cb8; });

var $bR5nk = parcelRequire("bR5nk");

var $eZYX7 = parcelRequire("eZYX7");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $jsEoI = parcelRequire("jsEoI");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");

var $dZDV0 = parcelRequire("dZDV0");
const $851b10c03a3e463a$export$50ac7856e9864cb8 = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const analysisSet = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $jsEoI.isAnalysisSet));
    // Disable editing for parent templates
    if (analysisSet?.disableEditing) disabled = true;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: dataPath,
                canRename: canRename,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dZDV0.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$851b10c03a3e463a$export$50ac7856e9864cb8.displayName = "AnalysisSetControl";

});
parcelRegister("dZDV0", function(module, exports) {

$parcel$export(module.exports, "WhereClauseManager", function () { return $0cd4346259b26d6b$export$d4fb6a65856f09b4; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");
var $fa1i3 = parcelRequire("fa1i3");

var $1cWYI = parcelRequire("1cWYI");
var $2d6Pt = parcelRequire("2d6Pt");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $6dqyB = parcelRequire("6dqyB");

var $4n175 = parcelRequire("4n175");

var $imiah = parcelRequire("imiah");

var $2udjB = parcelRequire("2udjB");
const $0cd4346259b26d6b$export$d4fb6a65856f09b4 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const [isExpanded, setIsExpanded] = (0, $spJKX.useState)(false);
    // Get the current entity from state
    const whereClause = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $6dqyB.isWhereClause));
    const idPath = `${dataPath.replace(/\//g, "-")}`;
    return !whereClause ? /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).compactContainer,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        id: `${idPath}-toggle-expand`,
                        onClick: ()=>setIsExpanded(!isExpanded),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).toggleButton,
                        variant: "link",
                        size: "sm",
                        "aria-label": isExpanded ? "Collapse" : "Expand",
                        disabled: disabled,
                        children: isExpanded ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1cWYI.default), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2udjB.WhereClauseInput), {
                            dataPath: dataPath,
                            disabled: disabled
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa1i3.default), {
                in: isExpanded,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $imiah.WhereClauseEditor), {
                        dataPath: dataPath,
                        disabled: disabled
                    })
                })
            })
        ]
    });
};
$0cd4346259b26d6b$export$d4fb6a65856f09b4.displayName = "WhereClauseManager";

});
parcelRegister("4n175", function(module, exports) {

$parcel$export(module.exports, "actionButtons", function () { return $32ea2c7f7a1732a8$export$b6fb1741c7f64881; }, function (v) { return $32ea2c7f7a1732a8$export$b6fb1741c7f64881 = v; });
$parcel$export(module.exports, "codeBlock", function () { return $32ea2c7f7a1732a8$export$7bb0d5c671655cc4; }, function (v) { return $32ea2c7f7a1732a8$export$7bb0d5c671655cc4 = v; });
$parcel$export(module.exports, "compactContainer", function () { return $32ea2c7f7a1732a8$export$5613def557f780e6; }, function (v) { return $32ea2c7f7a1732a8$export$5613def557f780e6 = v; });
$parcel$export(module.exports, "toggleButton", function () { return $32ea2c7f7a1732a8$export$c3f9788a1ddcf2d9; }, function (v) { return $32ea2c7f7a1732a8$export$c3f9788a1ddcf2d9 = v; });
$parcel$export(module.exports, "validationText", function () { return $32ea2c7f7a1732a8$export$82d15ec6f07228ea; }, function (v) { return $32ea2c7f7a1732a8$export$82d15ec6f07228ea = v; });
var $32ea2c7f7a1732a8$export$b6fb1741c7f64881;
var $32ea2c7f7a1732a8$export$7bb0d5c671655cc4;
var $32ea2c7f7a1732a8$export$5613def557f780e6;
var $32ea2c7f7a1732a8$export$c3f9788a1ddcf2d9;
var $32ea2c7f7a1732a8$export$82d15ec6f07228ea;
$32ea2c7f7a1732a8$export$b6fb1741c7f64881 = `mos-WhereClauseConditionItemControl-module-tdtjtq-actionButtons`;
$32ea2c7f7a1732a8$export$7bb0d5c671655cc4 = `mos-WhereClauseConditionItemControl-module-tdtjtq-codeBlock`;
$32ea2c7f7a1732a8$export$5613def557f780e6 = `mos-WhereClauseConditionItemControl-module-tdtjtq-compactContainer`;
$32ea2c7f7a1732a8$export$c3f9788a1ddcf2d9 = `mos-WhereClauseConditionItemControl-module-tdtjtq-toggleButton`;
$32ea2c7f7a1732a8$export$82d15ec6f07228ea = `mos-WhereClauseConditionItemControl-module-tdtjtq-validationText`;

});

parcelRegister("imiah", function(module, exports) {

$parcel$export(module.exports, "WhereClauseEditor", function () { return $d3fef1180e16d988$export$2c5072d85c877532; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
parcelRequire("aoPxa");
var $3d5lD = parcelRequire("3d5lD");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("1ZdiT");
var $9QVTJ = parcelRequire("9QVTJ");
var $6dqyB = parcelRequire("6dqyB");
var $lPVPO = parcelRequire("lPVPO");
var $cTgGQ = parcelRequire("cTgGQ");

var $8QBWT = parcelRequire("8QBWT");

var $bwkcO = parcelRequire("bwkcO");

var $PD7KB = parcelRequire("PD7KB");
const $d3fef1180e16d988$export$2c5072d85c877532 = ({ dataPath: dataPath, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [isPending, startTransition] = (0, $spJKX.useTransition)();
    // Get the current entity from state
    const whereClause = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $6dqyB.isWhereClause));
    const condition = (0, $cTgGQ.isWhereClauseWithCondition)(whereClause) ? whereClause.condition : undefined;
    const ce = (0, $lPVPO.isWhereClauseWithCompoundExpression)(whereClause) ? whereClause.compoundExpression : undefined;
    const hasCondition = condition !== undefined;
    const whereClauseCount = hasCondition ? 1 : ce?.whereClauses?.length ?? 0;
    const refClauseCount = ce?.whereClauses?.filter((clause)=>(0, $9QVTJ.isSubClauseWithReference)(clause)).length ?? 0;
    /**
   * Handles NOT checkbox change.
   * Dispatches ADD_NOT_TO_WHERE_CLAUSE when checked, or REMOVE_NOT_FROM_WHERE_CLAUSE when unchecked.
   *
   * @param event - The checkbox change event.
   */ const handleNotCheckboxChange = (event)=>{
        startTransition(()=>{
            if (event.target.checked) dispatch({
                operation: (0, $cJd2i.ADD_NOT_TO_WHERE_CLAUSE),
                dataPath: dataPath
            });
            else dispatch({
                operation: (0, $cJd2i.REMOVE_NOT_FROM_WHERE_CLAUSE),
                dataPath: dataPath
            });
        });
    };
    /**
   * Handles adding a new where clause.
   * Converts single condition to compound expression if needed.
   */ const handleAddClause = ()=>{
        startTransition(()=>{
            dispatch({
                operation: (0, $cJd2i.ADD_EXTRA_WHERE_CLAUSE),
                dataPath: dataPath,
                newLength: whereClauseCount + 1
            });
        });
    };
    /**
   * Handles drag-end event for reordering clauses.
   *
   * @param event - The drag end event from dnd-kit.
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (over !== null && over.id !== active.id && ce) {
            const whereClauses = ce.whereClauses ?? // istanbul ignore next
            [];
            const oldIndex = whereClauses.findIndex((clause)=>clause.id === active.id);
            const newIndex = whereClauses.findIndex((clause)=>clause.id === over.id);
            // Reorder the array
            const reorderedClauses = [
                ...whereClauses
            ];
            const [movedClause] = reorderedClauses.splice(oldIndex, 1);
            reorderedClauses.splice(newIndex, 0, movedClause);
            // Update order properties
            const updatedClauses = reorderedClauses.map((clause, index)=>({
                    ...clause,
                    order: index
                }));
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/compoundExpression/whereClauses`,
                value: updatedClauses
            });
        }
    };
    return !whereClause ? /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            whereClauseCount <= 1 ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "d-flex align-items-center",
                style: {
                    height: "32px"
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                        className: "form-check-label",
                        htmlFor: `${dataPath.replace(/\//g, "-")}-not-checkbox`,
                        children: "NOT"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                        type: "checkbox",
                        className: "form-check-input ms-2",
                        id: `${dataPath.replace(/\//g, "-")}-not-checkbox`,
                        checked: ce?.logicalOperator === "NOT",
                        disabled: disabled,
                        onChange: handleNotCheckboxChange
                    })
                ]
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "d-flex align-items-center",
                style: {
                    height: "32px"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("select", {
                    className: "form-select form-select-sm w-auto",
                    id: `${dataPath.replace(/\//g, "-")}-logical-operator-select`,
                    disabled: disabled,
                    onChange: (ret)=>{
                        dispatch({
                            operation: (0, $cJd2i.PATCH_ARS_STATE),
                            dataPath: `${dataPath}/compoundExpression/logicalOperator`,
                            value: ret.currentTarget.value
                        });
                    },
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                            value: (0, $iEmH0.ExpressionLogicalOperatorEnum).AND,
                            children: "AND"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                            value: (0, $iEmH0.ExpressionLogicalOperatorEnum).OR,
                            children: "OR"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3d5lD.SortableListHolder), {
                canMove: !disabled,
                handleDragEnd: handleDragEnd,
                showBorder: false,
                items: hasCondition ? [
                    {
                        id: "single-condition",
                        element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $PD7KB.WhereClauseConditionItemControl), {
                            dataPath: `${dataPath}/condition`,
                            disabled: disabled
                        })
                    }
                ] : (ce?.whereClauses ?? // istanbul ignore next
                []).map((clause, ix)=>({
                        id: clause.id,
                        element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bwkcO.SubClauseItemControl), {
                            isRemovable: whereClauseCount - refClauseCount > 1,
                            dataPath: `${dataPath}/compoundExpression/whereClauses/${ix}`,
                            disabled: disabled
                        })
                    }))
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8QBWT.AddWhereClauseButton), {
                id: `${dataPath.replace(/\//g, "-")}-add-clause-button`,
                onClick: handleAddClause,
                isPending: isPending,
                disabled: disabled
            })
        ]
    });
};
$d3fef1180e16d988$export$2c5072d85c877532.displayName = "WhereClauseEditor";

});
parcelRegister("bwkcO", function(module, exports) {

$parcel$export(module.exports, "SubClauseItemControl", function () { return $ba4ddd2484dc1831$export$f2f4d85386f16cde; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $jwDoS = parcelRequire("jwDoS");
var $9QVTJ = parcelRequire("9QVTJ");
var $cr6aM = parcelRequire("cr6aM");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $fRRM2 = parcelRequire("fRRM2");

var $4FB18 = parcelRequire("4FB18");

var $ejHCH = parcelRequire("ejHCH");

var $PD7KB = parcelRequire("PD7KB");

var $imiah = parcelRequire("imiah");
const $ba4ddd2484dc1831$export$f2f4d85386f16cde = ({ dataPath: dataPath, isRemovable: isRemovable = false, disabled: disabled = false })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    // Get the sub-clause from state
    const subClause = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $fRRM2.isSubClause));
    return (0, $4FB18.isSubClauseWithCompoundExpression)(subClause) ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        style: {
            paddingLeft: "1rem",
            borderLeft: "2px solid #dee2e6"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $imiah.WhereClauseEditor), {
            dataPath: dataPath,
            disabled: disabled
        })
    }) : (0, $ejHCH.isSubClauseWithCondition)(subClause) ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $PD7KB.WhereClauseConditionItemControl), {
        dataPath: `${dataPath}/condition`,
        isRemovable: isRemovable,
        disabled: disabled
    }) : (0, $9QVTJ.isSubClauseWithReference)(subClause) ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cr6aM.ReferencedEntityControl), {
            dataPath: `${dataPath}/subClauseId`,
            entityType: "DataSubset",
            disabled: disabled
        })
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
        className: "text-danger",
        children: [
            "SubClause not found at path: ",
            dataPath
        ]
    });
};
$ba4ddd2484dc1831$export$f2f4d85386f16cde.displayName = "SubClauseItemControl";

});
parcelRegister("PD7KB", function(module, exports) {

$parcel$export(module.exports, "WhereClauseConditionItemControl", function () { return $a5cc76a9a4f4e630$export$e47a210cc0c53b08; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $i4t1Y = parcelRequire("i4t1Y");
var $jwDoS = parcelRequire("jwDoS");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");
var $fa1i3 = parcelRequire("fa1i3");
var $eZYX7 = parcelRequire("eZYX7");

var $4U3f3 = parcelRequire("4U3f3");
var $1cWYI = parcelRequire("1cWYI");
var $2d6Pt = parcelRequire("2d6Pt");
var $gCZ2V = parcelRequire("gCZ2V");

var $3tKzd = parcelRequire("3tKzd");

var $iEmH0 = parcelRequire("iEmH0");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $krPhG = parcelRequire("krPhG");

var $d4ZHR = parcelRequire("d4ZHR");

var $2VKUu = parcelRequire("2VKUu");

var $fRRM2 = parcelRequire("fRRM2");

var $ejHCH = parcelRequire("ejHCH");

var $7TeSQ = parcelRequire("7TeSQ");

var $5JArC = parcelRequire("5JArC");

var $dDwJ9 = parcelRequire("dDwJ9");

var $4n175 = parcelRequire("4n175");
const $a5cc76a9a4f4e630$export$e47a210cc0c53b08 = ({ dataPath: dataPath, isRemovable: isRemovable = false, disabled: disabled = false, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [isExpanded, setIsExpanded] = (0, $spJKX.useState)(false);
    const [isEditing, setIsEditing] = (0, $spJKX.useState)(false);
    const [editValue, setEditValue] = (0, $spJKX.useState)("");
    const subClausePath = dataPath.endsWith("/condition") ? dataPath.substring(0, dataPath.lastIndexOf("/condition")) : "";
    const subClause = (0, $jwDoS.getFromDataPath)(subClausePath, state, (0, $ejHCH.isSubClauseWithCondition));
    const canSwapToReference = subClause !== undefined;
    // Get the condition from state
    const whereClauseCondition = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $7TeSQ.isWhereClauseCondition));
    const thisId = (0, $jwDoS.getFromDataPath)(dataPath.substring(0, dataPath.lastIndexOf("/")), state, (0, $fRRM2.isSubClause))?.id ?? "";
    const groupComparator = whereClauseCondition?.comparator === (0, $iEmH0.ConditionComparatorEnum).IN || whereClauseCondition?.comparator === (0, $iEmH0.ConditionComparatorEnum).NOTIN;
    // Convert comparators enum to options for ArsSelect
    const comparatorOptions = state.comparators.map((comp)=>({
            value: comp,
            label: comp
        }));
    // Compact mode with toggle (default view)
    const compactCode = (0, $5JArC.formatConditionAsCode)(whereClauseCondition, state.variables);
    // Get available variables for validation
    const availableVariables = state.variables.map((v)=>v.value);
    // Validate current edit value
    const parsedCondition = isEditing && editValue ? (0, $dDwJ9.parseConditionFromCode)(editValue, availableVariables) : undefined;
    const isValid = parsedCondition !== false;
    const isInvalid = isEditing && editValue.length > 0 && !isValid;
    /**
   * Saves the changes to the condition.
   *
   * @param value - The value to save
   */ const saveChanges = (value)=>{
        const parsed = (0, $dDwJ9.parseConditionFromCode)(value, availableVariables);
        if (parsed) dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: dataPath,
            value: parsed.condition
        });
    };
    /**
   * Handles removing a where clause.
   * Reverts to single condition if only 2 clauses remain.
   */ const handleRemoveClause = ()=>{
        const parentPath = dataPath.substring(0, dataPath.lastIndexOf("/compoundExpression/whereClauses/"));
        dispatch({
            operation: (0, $cJd2i.REMOVE_WHERE_CLAUSE),
            dataPath: parentPath,
            id: thisId
        });
    };
    /**
   * Handles swapping a condition clause to a referenced entity.
   */ const handleSwapToReference = ()=>{
        /* istanbul ignore else */ if (subClause && subClausePath) dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: subClausePath,
            value: {
                id: subClause.id,
                level: subClause.level,
                order: subClause.order,
                subClauseId: "-- None --"
            }
        });
    };
    /**
   * Converts the current SubClauseWithCondition into a SubClauseWithCompoundExpression.
   */ const handleSwapToCompound = ()=>{
        dispatch({
            operation: (0, $cJd2i.ADD_EXTRA_WHERE_CLAUSE),
            dataPath: subClausePath,
            newLength: 2
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).compactContainer,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        id: `${dataPath.replace(/\//g, "-")}-toggle-expand`,
                        onClick: ()=>setIsExpanded(!isExpanded),
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).toggleButton,
                        variant: "link",
                        size: "sm",
                        "aria-label": isExpanded ? "Collapse" : "Expand",
                        disabled: isEditing || disabled,
                        children: isExpanded ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1cWYI.default), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i4t1Y.ControlInlineEdit), {
                            id: `${dataPath.replace(/\//g, "-")}-edit-input`,
                            "aria-label": "Enter condition",
                            editLabel: "Edit condition",
                            deleteLabel: "Remove clause",
                            disabled: disabled,
                            value: compactCode,
                            setValue: saveChanges,
                            onDraftChange: setEditValue,
                            onEditChange: setIsEditing,
                            onDelete: isRemovable && !isEditing ? handleRemoveClause : undefined,
                            preventInvalidExit: false,
                            whiteSpaceFix: true,
                            spellCheck: false,
                            isInvalid: isInvalid,
                            className: (0, $3tKzd.classMerge)([
                                isEditing && isValid && editValue.length > 0 ? "is-valid" : ""
                            ]),
                            ReadComponent: ({ value: value })=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                    className: "form-control form-control-sm",
                                    style: {
                                        border: "none"
                                    },
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("code", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).codeBlock,
                                        onClick: ()=>setIsExpanded(!isExpanded),
                                        children: value === "" ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                            className: "text-muted",
                                            children: "No condition defined"
                                        }) : value
                                    })
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).actionButtons,
                        children: !isEditing && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4U3f3.default), {
                                id: `${dataPath.replace(/\//g, "-")}-swap`,
                                className: canSwapToReference ? "text-primary" : "text-muted",
                                role: "button",
                                "aria-label": "Swap to reference",
                                "aria-disabled": !canSwapToReference || disabled,
                                onClick: canSwapToReference && !disabled ? handleSwapToReference : undefined,
                                style: {
                                    cursor: canSwapToReference && !disabled ? "pointer" : "not-allowed"
                                }
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                style: {
                    height: isEditing ? "1.5em" : 0,
                    minHeight: isEditing ? "1.5em" : 0,
                    transition: "height 0.2s ease, min-height 0.2s ease"
                },
                className: (0, $3tKzd.classMerge)([
                    isValid && editValue.length > 0 ? "valid-feedback" : isInvalid ? "invalid-feedback" : "text-muted",
                    (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).validationText
                ]),
                children: isValid && editValue.length > 0 ? "Valid condition" : isInvalid ? "Invalid condition format" : ""
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa1i3.default), {
                in: isExpanded,
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                            datasetDataPath: `${dataPath}/dataset`,
                            variableDataPath: `${dataPath}/variable`,
                            id: `${dataPath.replace(/\//g, "-")}-variable`,
                            label: "Variable",
                            placeHolder: "Select dataset and variable",
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                            dataPath: `${dataPath}/comparator`,
                            id: `${dataPath.replace(/\//g, "-")}-comparator`,
                            label: "Comparator",
                            options: comparatorOptions,
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                            dataPath: `${dataPath}/value`,
                            isArray: true,
                            id: `${dataPath.replace(/\//g, "-")}-value`,
                            label: groupComparator ? "Values" : "Value",
                            type: "textarea",
                            rows: groupComparator ? 3 : 1,
                            placeholder: "Enter values (one per line)",
                            allowCarriageReturn: true,
                            disabled: isEditing || disabled
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                            "aria-label": "Add nested clause",
                            className: "mt-2 d-flex align-items-center",
                            disabled: disabled,
                            id: `${dataPath.replace(/\//g, "-")}-to-compound-expression`,
                            onClick: handleSwapToCompound,
                            size: "sm",
                            variant: "success",
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    className: "me-2",
                                    children: "Add nested clause"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
$a5cc76a9a4f4e630$export$e47a210cc0c53b08.displayName = "WhereClauseConditionItemControl";

});
parcelRegister("4U3f3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $391ee822b1b204d0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $391ee822b1b204d0$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $391ee822b1b204d0$var$_extends() {
    return $391ee822b1b204d0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $391ee822b1b204d0$var$_extends.apply(null, arguments);
}
function $391ee822b1b204d0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $391ee822b1b204d0$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $391ee822b1b204d0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $391ee822b1b204d0$var$ArrowLeftRight = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $391ee822b1b204d0$var$_objectWithoutProperties(_ref, $391ee822b1b204d0$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $391ee822b1b204d0$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-left-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5m14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5"
    }));
});
$391ee822b1b204d0$var$ArrowLeftRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $391ee822b1b204d0$export$2e2bcd8739ae039 = $391ee822b1b204d0$var$ArrowLeftRight;

});




parcelRegister("2udjB", function(module, exports) {

$parcel$export(module.exports, "WhereClauseInput", function () { return $d2cf91f5f00c0321$export$220896b0b25e2f48; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $i4t1Y = parcelRequire("i4t1Y");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");

var $lp634 = parcelRequire("lp634");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");

var $3tKzd = parcelRequire("3tKzd");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");
parcelRequire("1ZdiT");
var $6dqyB = parcelRequire("6dqyB");

var $cncLz = parcelRequire("cncLz");

var $6iDPv = parcelRequire("6iDPv");

var $8E7ct = parcelRequire("8E7ct");

var $4n175 = parcelRequire("4n175");
/**
 * Extracts the last contiguous variable-name token from the end of a string.
 * A token is a sequence of alphanumeric characters, underscores, and dots.
 *
 * @param value - The input string to extract the last token from
 * @returns The last token, or an empty string if none found
 */ const $d2cf91f5f00c0321$var$getLastToken = (value)=>/[A-Za-z0-9_.]+$/.exec(value)?.[0] ?? "";
/**
 * Replaces the last variable-name token in a string with a replacement and appends a space.
 * Uses a `*`-quantifier so the regex always matches, handling both cases (token present
 * or absent) without branching: when no token exists an empty string is replaced, which
 * has the same effect as appending the replacement.
 *
 * @param inputValue - The current input string
 * @param replacement - The string to replace the last token with
 * @returns The updated string with the token replaced and a trailing space appended
 */ const $d2cf91f5f00c0321$var$replaceLastToken = (inputValue, replacement)=>inputValue.replace(/[A-Za-z0-9_.]*$/, `${replacement} `);
const $d2cf91f5f00c0321$export$220896b0b25e2f48 = ({ dataPath: dataPath, disabled: disabled = false, onChange: onChange, value: value })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [isEditing, setIsEditing] = (0, $spJKX.useState)(false);
    const wrapperRef = (0, $spJKX.useRef)(null);
    const [currentValue, setCurrentValue] = (0, $spJKX.useState)("");
    const [selectedIndex, setSelectedIndex] = (0, $spJKX.useState)(-1);
    /** The token value for which the dropdown was explicitly closed by the user */ const [closedForToken, setClosedForToken] = (0, $spJKX.useState)(null);
    const whereClause = value ?? (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $6dqyB.isWhereClause));
    const compactCode = whereClause ? (0, $6iDPv.formatWhereClauseAsCode)(whereClause, state.variables) : "";
    const availableVariables = state.variables.map((variable)=>variable.value);
    const valueToValidate = isEditing ? currentValue : compactCode;
    const parsedWhereClauseResult = valueToValidate.length > 0 ? (0, $8E7ct.parseWhereClauseFromCode)(valueToValidate, availableVariables, Object.keys(state.dataSubsets)) : false;
    const isValid = parsedWhereClauseResult !== false;
    const isWarning = parsedWhereClauseResult && parsedWhereClauseResult.acceptedUnlistedVariable;
    const isInvalid = isEditing && currentValue.length > 0 && !isValid;
    // Get the last variable-like token being typed (e.g. "ADSL.AG" from "x = 1 AND ADSL.AG")
    const lastToken = $d2cf91f5f00c0321$var$getLastToken(currentValue);
    // Filter available variables matching the last token (requires 3+ chars)
    const filteredVariables = lastToken.length >= 3 ? state.variables.filter((v)=>v.value.toLowerCase().includes(lastToken.toLowerCase())) : [];
    // Show dropdown when matches exist and the user has not explicitly closed it for this token
    const isDropdownOpen = isEditing && filteredVariables.length > 0 && closedForToken !== lastToken;
    // Build dropdown items from the filtered variable list
    const inputId = `${dataPath.replace(/\//g, "-")}-edit-input`;
    const dropdownItems = filteredVariables.map((v, i)=>({
            id: `${inputId}-var-${i}`,
            text: v.value
        }));
    /**
   * Saves edits back into ARS state when parsing succeeds.
   *
   * @param value - Edited where clause code
   */ const saveChanges = (value)=>{
        // handle onChange first
        if (onChange) {
            if (value.trim() === "") onChange(null);
            else {
                const parsed = (0, $8E7ct.parseWhereClauseFromCode)(value, availableVariables, Object.keys(state.dataSubsets));
                if (parsed) onChange(parsed.whereClause);
            }
            return;
        }
        // handle dispatch changes - include non-WhereClause properties to avoid overwriting them
        const parsed = (0, $8E7ct.parseWhereClauseFromCode)(value, availableVariables, Object.keys(state.dataSubsets));
        // Replace valid or blank clauses
        if (parsed || value.trim() === "") {
            const newValue = {
                ...(0, $eBlbF.omit)(whereClause, [
                    "compoundExpression",
                    "condition"
                ]),
                ...parsed ? parsed.whereClause : {
                    level: 0,
                    order: 0,
                    condition: {
                        dataset: "",
                        variable: ""
                    }
                }
            };
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: dataPath,
                value: newValue
            });
        }
    };
    /**
   * Inserts a selected variable into the input by replacing the last token,
   * appending a trailing space, and resetting dropdown state.
   * Reads the current DOM value directly to avoid stale debounced state.
   *
   * @param variable - The variable string to insert into the input
   */ const insertVariable = (variable)=>{
        const inputEl = wrapperRef.current?.querySelector("input");
        const inputValue = inputEl?.value ?? // istanbul ignore next -- Unreachable: wrapperRef always contains an input when this function is called
        currentValue;
        const newValue = $d2cf91f5f00c0321$var$replaceLastToken(inputValue, variable);
        setCurrentValue(newValue);
        setSelectedIndex(-1);
        setClosedForToken(null);
    };
    /**
   * Handles keyboard events in the capture phase to intercept navigation keys.
   *
   * When the dropdown is open:
   * - ArrowDown / ArrowUp: navigate the highlighted item
   * - Enter: insert the highlighted variable (or close dropdown if none highlighted)
   * - Escape: close the dropdown and reset selection
   *
   * When the dropdown is closed, keyboard events reach ControlInlineEdit unchanged.
   *
   * @param e - The keyboard event from the capture phase
   */ const handleKeyDown = (e)=>{
        if (isDropdownOpen) switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                e.stopPropagation();
                setSelectedIndex((prev)=>Math.min(prev + 1, dropdownItems.length - 1));
                break;
            case "ArrowUp":
                e.preventDefault();
                e.stopPropagation();
                setSelectedIndex((prev)=>Math.max(prev - 1, 0));
                break;
            case "Enter":
            case "Tab":
                e.preventDefault();
                e.stopPropagation();
                if (selectedIndex >= 0 && selectedIndex < dropdownItems.length) insertVariable(dropdownItems[selectedIndex].text);
                else setClosedForToken(lastToken);
                break;
            case "Escape":
                e.preventDefault();
                e.stopPropagation();
                setClosedForToken(lastToken);
                setSelectedIndex(-1);
                break;
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                ref: wrapperRef,
                onKeyDownCapture: handleKeyDown,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i4t1Y.ControlInlineEdit), {
                        id: inputId,
                        "aria-label": "Enter where clause",
                        editLabel: "Edit where clause",
                        disabled: disabled,
                        value: compactCode,
                        draftValue: currentValue,
                        setValue: saveChanges,
                        onDraftChange: setCurrentValue,
                        onEditChange: (editing)=>{
                            setIsEditing(editing);
                            setSelectedIndex(-1);
                            setClosedForToken(null);
                        },
                        editOnDoubleClick: true,
                        preventInvalidExit: false,
                        spellCheck: false,
                        isInvalid: isInvalid,
                        className: (0, $3tKzd.classMerge)([
                            isWarning ? "is-warning" : isValid && currentValue.length > 0 ? "is-valid" : isInvalid ? "is-invalid" : ""
                        ]),
                        whiteSpaceFix: true,
                        ReadComponent: ({ value: value })=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "form-control form-control-sm",
                                style: {
                                    border: "none"
                                },
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("code", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).codeBlock,
                                    children: value === "" ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                        className: "text-muted",
                                        children: "No where clause defined"
                                    }) : value
                                })
                            })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lp634.DropdownPortal), {
                        isOpen: isDropdownOpen && !disabled,
                        items: dropdownItems,
                        onSelect: (item)=>insertVariable(item.text),
                        onClose: ()=>{
                            setClosedForToken(lastToken);
                            setSelectedIndex(-1);
                        },
                        anchorRef: wrapperRef,
                        selectedIndex: selectedIndex,
                        onSelectedIndexChange: setSelectedIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                style: {
                    height: isEditing ? "1.5em" : 0,
                    minHeight: isEditing ? "1.5em" : 0,
                    transition: "height 0.2s ease, min-height 0.2s ease"
                },
                className: (0, $3tKzd.classMerge)([
                    isWarning ? "warning-feedback" : isValid && currentValue.length > 0 ? "valid-feedback" : isInvalid ? "invalid-feedback" : "text-muted",
                    (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).validationText
                ]),
                children: isWarning ? (0, $cncLz.CUSTOM_DATASET_VARIABLE_WARNING) : isValid && currentValue.length > 0 ? "Valid where clause" : isInvalid ? "Invalid where clause format" : ""
            })
        ]
    });
};
$d2cf91f5f00c0321$export$220896b0b25e2f48.displayName = "WhereClauseInput";

});



parcelRegister("3C4oq", function(module, exports) {

$parcel$export(module.exports, "CaseWhenControl", function () { return $83ebcc420dabcfc2$export$d181fee453ee208f; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $3d5lD = parcelRequire("3d5lD");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $2x5bU = parcelRequire("2x5bU");

var $gRHat = parcelRequire("gRHat");

var $8H7iZ = parcelRequire("8H7iZ");
const $83ebcc420dabcfc2$export$d181fee453ee208f = ({ id: id, dataPath: dataPath, disabled: disabled, editorDefns: editorDefns = (0, $hcEI9.defaultEditorDefns), onChange: onChange })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const thisCaseWhenCondition = (0, $spJKX.useMemo)(()=>(0, $jwDoS.getFromDataPath)(dataPath, state, (obj)=>(0, $2x5bU.isCaseWhenCondition)(obj, editorDefns.isT)) ?? (dataPath.split("/").slice(-2)[0] === "caseWhenConditions" ? {
            id: dataPath.split("/").slice(-1)[0],
            caseWhenItems: []
        } : undefined), [
        dataPath,
        editorDefns,
        state
    ]);
    if (!thisCaseWhenCondition) return /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
        className: "text-danger",
        children: [
            "Entity not found at path: ",
            dataPath
        ]
    });
    /**
   * Handle variable reordering
   *
   * @param event - Sortable list drag end event
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (active.id !== over?.id) {
            const activeIndex = thisCaseWhenCondition.caseWhenItems.findIndex((item)=>item.id === active.id);
            const overIndex = thisCaseWhenCondition.caseWhenItems.findIndex((item)=>item.id === over?.id);
            const newItems = [
                ...thisCaseWhenCondition.caseWhenItems
            ];
            const [movedItem] = newItems.splice(activeIndex, 1);
            newItems.splice(overIndex, 0, movedItem);
            if (onChange) onChange({
                ...thisCaseWhenCondition,
                caseWhenItems: newItems
            });
            else dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}/caseWhenItems`,
                value: newItems
            });
        }
    };
    /**
   * Add new item to the condition
   */ const handleAddItem = ()=>{
        const newCaseWhenItem = {
            id: crypto.randomUUID(),
            displayPattern: state.editorDefns.blankT,
            resultPattern: "",
            when: null
        };
        const newItems = [
            ...thisCaseWhenCondition.caseWhenItems,
            newCaseWhenItem
        ];
        if (onChange) onChange({
            ...thisCaseWhenCondition,
            caseWhenItems: newItems
        });
        else {
            if (newItems.length === 1) // If this is the first item, we need to create the parent condition as well
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}`,
                value: {
                    ...thisCaseWhenCondition,
                    caseWhenItems: newItems
                }
            });
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `/caseWhenConditions/${thisCaseWhenCondition.id}/caseWhenItems`,
                value: newItems
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
        className: $gRHat.itemsHolder,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3d5lD.SortableListHolder), {
                id: id,
                canMove: !disabled,
                handleDragEnd: handleDragEnd,
                items: thisCaseWhenCondition.caseWhenItems.map((v, ix)=>({
                        id: v.id,
                        element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8H7iZ.CaseWhenItemControl), {
                            id: `${id}-item-${ix}`,
                            dataPath: `${dataPath}/caseWhenItems/${ix}`,
                            disabled: disabled,
                            onChange: onChange ? (ret)=>{
                                const newItems = [
                                    ...thisCaseWhenCondition.caseWhenItems
                                ];
                                const thisIx = newItems.findIndex((item)=>item.id === v.id);
                                if (thisIx !== -1) {
                                    if (ret) newItems[thisIx] = ret;
                                    else newItems.splice(thisIx, 1);
                                    onChange({
                                        ...thisCaseWhenCondition,
                                        caseWhenItems: newItems
                                    });
                                }
                            } : undefined,
                            siblingCount: thisCaseWhenCondition.caseWhenItems.length
                        })
                    }))
            }),
            !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
                id: `${id}-add-item-button`,
                className: "text-success",
                role: "button",
                "aria-label": "Add item",
                onClick: handleAddItem,
                style: {
                    cursor: "pointer"
                }
            })
        ]
    });
};
$83ebcc420dabcfc2$export$d181fee453ee208f.displayName = "CaseWhenControl";

});
parcelRegister("gRHat", function(module, exports) {

$parcel$export(module.exports, "itemHolder", function () { return $c47314d29c441216$export$1aea70eb3432192b; }, function (v) { return $c47314d29c441216$export$1aea70eb3432192b = v; });
$parcel$export(module.exports, "itemPropertyHolder", function () { return $c47314d29c441216$export$c614277c8b92264f; }, function (v) { return $c47314d29c441216$export$c614277c8b92264f = v; });
$parcel$export(module.exports, "itemPropertyInput", function () { return $c47314d29c441216$export$f8a603587aa593ca; }, function (v) { return $c47314d29c441216$export$f8a603587aa593ca = v; });
$parcel$export(module.exports, "itemPropertyLabel", function () { return $c47314d29c441216$export$7ca45c7ba071faf8; }, function (v) { return $c47314d29c441216$export$7ca45c7ba071faf8 = v; });
$parcel$export(module.exports, "itemsHolder", function () { return $c47314d29c441216$export$f0e1e65e737ee5a9; }, function (v) { return $c47314d29c441216$export$f0e1e65e737ee5a9 = v; });
$parcel$export(module.exports, "removeButtonHolder", function () { return $c47314d29c441216$export$f5c6df7622a3a9e0; }, function (v) { return $c47314d29c441216$export$f5c6df7622a3a9e0 = v; });
var $c47314d29c441216$export$c38d73f44da0bd96;
var $c47314d29c441216$export$1aea70eb3432192b;
var $c47314d29c441216$export$c614277c8b92264f;
var $c47314d29c441216$export$f8a603587aa593ca;
var $c47314d29c441216$export$7ca45c7ba071faf8;
var $c47314d29c441216$export$27f39136c7b0387a;
var $c47314d29c441216$export$d13e7c52906aadd2;
var $c47314d29c441216$export$f0e1e65e737ee5a9;
var $c47314d29c441216$export$f5c6df7622a3a9e0;
$c47314d29c441216$export$c38d73f44da0bd96 = `mos-CaseWhen-module-5rP9JG-itemDeleteButton`;
$c47314d29c441216$export$1aea70eb3432192b = `mos-CaseWhen-module-5rP9JG-itemHolder`;
$c47314d29c441216$export$c614277c8b92264f = `mos-CaseWhen-module-5rP9JG-itemPropertyHolder`;
$c47314d29c441216$export$f8a603587aa593ca = `mos-CaseWhen-module-5rP9JG-itemPropertyInput`;
$c47314d29c441216$export$7ca45c7ba071faf8 = `mos-CaseWhen-module-5rP9JG-itemPropertyLabel`;
$c47314d29c441216$export$27f39136c7b0387a = `mos-CaseWhen-module-5rP9JG-itemTypeOption`;
$c47314d29c441216$export$d13e7c52906aadd2 = `mos-CaseWhen-module-5rP9JG-itemTypeSelect`;
$c47314d29c441216$export$f0e1e65e737ee5a9 = `mos-CaseWhen-module-5rP9JG-itemsHolder`;
$c47314d29c441216$export$f5c6df7622a3a9e0 = `mos-CaseWhen-module-5rP9JG-removeButtonHolder`;

});

parcelRegister("8H7iZ", function(module, exports) {

$parcel$export(module.exports, "CaseWhenItemControl", function () { return $92aa558917178499$export$aed991923e1439fd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("aoPxa");
var $dd2Wn = parcelRequire("dd2Wn");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");
parcelRequire("1ZdiT");
var $1jtoS = parcelRequire("1jtoS");

var $gRHat = parcelRequire("gRHat");

var $bRLeU = parcelRequire("bRLeU");

var $2udjB = parcelRequire("2udjB");
const $92aa558917178499$export$aed991923e1439fd = ({ id: id, dataPath: dataPath, disabled: disabled, onChange: onChange, siblingCount: siblingCount })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const thisCaseWhenItem = (0, $jwDoS.getFromDataPath)(dataPath, state, (obj)=>(0, $1jtoS.isCaseWhenItem)(obj, state.editorDefns.isT));
    if (!thisCaseWhenItem) return null;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        id: id,
        className: $gRHat.itemHolder,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: $gRHat.itemPropertyHolder,
                style: {
                    flexGrow: 2,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0,
                    justifyContent: "flex-start",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2udjB.WhereClauseInput), {
                    dataPath: `${dataPath}/when`,
                    disabled: disabled,
                    onChange: (newValue)=>{
                        if (onChange) onChange({
                            ...thisCaseWhenItem,
                            when: newValue
                        });
                        else dispatch({
                            operation: (0, $cJd2i.PATCH_ARS_STATE),
                            dataPath: `${dataPath}/when`,
                            value: newValue
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: $gRHat.itemPropertyHolder,
                style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: $gRHat.itemPropertyLabel,
                        children: "Display"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)(state.editorDefns.Editor, {
                        id: `${id}-then-display-pattern`,
                        "aria-label": "Display pattern",
                        className: $gRHat.itemPropertyInput,
                        editable: !disabled,
                        setValue: (newValue)=>onChange ? onChange({
                                ...thisCaseWhenItem,
                                displayPattern: newValue
                            }) : dispatch({
                                operation: (0, $cJd2i.PATCH_ARS_STATE),
                                dataPath: `${dataPath}/displayPattern`,
                                value: newValue
                            }),
                        type: "string",
                        value: thisCaseWhenItem.displayPattern
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: $gRHat.itemPropertyHolder,
                style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    flexBasis: 0,
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: $gRHat.itemPropertyLabel,
                        children: "Result"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dd2Wn.ControlBase), {
                        "aria-label": "Result pattern",
                        disabled: disabled,
                        setValue: (newValue)=>onChange ? onChange({
                                ...thisCaseWhenItem,
                                resultPattern: newValue
                            }) : dispatch({
                                operation: (0, $cJd2i.PATCH_ARS_STATE),
                                dataPath: `${dataPath}/resultPattern`,
                                value: newValue
                            }),
                        type: "string",
                        value: thisCaseWhenItem.resultPattern
                    }),
                    !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: $gRHat.removeButtonHolder,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                            id: `${id}-remove-button`,
                            dataPath: dataPath,
                            onChange: ()=>onChange?.(),
                            siblingCount: siblingCount
                        })
                    })
                ]
            })
        ]
    });
};
$92aa558917178499$export$aed991923e1439fd.displayName = "CaseWhenItemControl";

});


parcelRegister("dMUCw", function(module, exports) {

$parcel$export(module.exports, "DataSubsetControl", function () { return $27e78d6ee1c7f5f7$export$e92914d539e7b41b; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $jwDoS = parcelRequire("jwDoS");
var $49JG0 = parcelRequire("49JG0");
var $4hgF7 = parcelRequire("4hgF7");

var $eZYX7 = parcelRequire("eZYX7");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");

var $dZDV0 = parcelRequire("dZDV0");
const $27e78d6ee1c7f5f7$export$e92914d539e7b41b = ({ dataPath: dataPath, canRename: canRename = false, disabled: disabled = false })=>{
    const { state: state } = (0, $4hgF7.useArsContext)();
    const dataSubset = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $49JG0.isDataSubset));
    // Disable editing for parent templates
    if (dataSubset?.disableEditing) disabled = true;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "border rounded p-3 mb-3 position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute bottom-0 end-0 m-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                        children: [
                            "Id: ",
                            dataPath.split("/").pop()
                        ]
                    })
                })
            }),
            canRename && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute top-0 end-0 m-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: dataPath,
                canRename: canRename,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dZDV0.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$27e78d6ee1c7f5f7$export$e92914d539e7b41b.displayName = "DataSubsetControl";

});

parcelRegister("7afc2", function(module, exports) {

$parcel$export(module.exports, "GroupControl", function () { return $bd0f32501e4446ae$export$33557f4114f177b3; });

var $bR5nk = parcelRequire("bR5nk");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");

var $dZDV0 = parcelRequire("dZDV0");
const $bd0f32501e4446ae$export$33557f4114f177b3 = ({ dataPath: dataPath, disabled: disabled = false, siblingCount: siblingCount })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "position-relative",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-absolute",
                style: {
                    zIndex: 1,
                    top: "-0.75rem",
                    right: "-.75rem"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                    dataPath: dataPath,
                    disabled: disabled,
                    siblingCount: siblingCount
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                dataPath: dataPath,
                canRename: true,
                disabled: disabled
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dZDV0.WhereClauseManager), {
                dataPath: dataPath,
                disabled: disabled
            })
        ]
    });
};
$bd0f32501e4446ae$export$33557f4114f177b3.displayName = "GroupControl";

});

parcelRegister("51n1k", function(module, exports) {

$parcel$export(module.exports, "GroupingFactorControl", function () { return $40b409fd1c420ef7$export$95bd92bc1dba1edd; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");
var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $27W8h = parcelRequire("27W8h");
var $aHdRW = parcelRequire("aHdRW");
var $31g00 = parcelRequire("31g00");
var $79ius = parcelRequire("79ius");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
var $2VxLR = parcelRequire("2VxLR");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $7byiZ = parcelRequire("7byiZ");
var $4hgF7 = parcelRequire("4hgF7");

var $cJd2i = parcelRequire("cJd2i");

var $d4ZHR = parcelRequire("d4ZHR");

var $2VKUu = parcelRequire("2VKUu");

var $czm2N = parcelRequire("czm2N");

var $kcXWJ = parcelRequire("kcXWJ");

var $drWxP = parcelRequire("drWxP");

var $7afc2 = parcelRequire("7afc2");

var $a5JBX = parcelRequire("a5JBX");

var $bRLeU = parcelRequire("bRLeU");
const $40b409fd1c420ef7$export$95bd92bc1dba1edd = ({ dataPath: dataPath, canRename: canRename, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [activeTab, setActiveTab] = (0, $spJKX.useState)("named-object");
    const [showConfirmModal, setShowConfirmModal] = (0, $spJKX.useState)(false);
    // Get the current grouping factor from state
    const groupingFactor = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $czm2N.isGroupingFactor));
    const dataDriven = (0, $kcXWJ.isGroupingFactorDataDriven)(groupingFactor);
    const groups = (0, $spJKX.useMemo)(()=>(0, $drWxP.isGroupingFactorWithGroups)(groupingFactor) ? groupingFactor.groups : [], [
        groupingFactor
    ]);
    // Disable editing for parent templates
    if (groupingFactor?.disableEditing) disabled = true;
    /**
   * Event handler to update the active tab.
   */ const updateActiveTab = (0, $spJKX.useEffectEvent)((newTab)=>{
        (0, $spJKX.startTransition)(()=>setActiveTab(newTab));
    });
    /**
   * Change the active group tab if it no longer exists
   */ (0, $spJKX.useEffect)(()=>{
        if (activeTab.startsWith("group-") && groups.length > 0 && parseInt(activeTab.split("-")[1], 10) >= groups.length) {
            const lastGroupIndex = groups.length - 1;
            updateActiveTab(`group-${lastGroupIndex}`);
        } else if (activeTab.startsWith("group-") && groups.length === 0) updateActiveTab("named-object");
    }, [
        groups.length,
        dataDriven,
        activeTab
    ]);
    /**
   * Handles showing the confirmation modal when toggling dataDriven.
   */ const handleDataDrivenChange = ()=>{
        // istanbul ignore next
        if (disabled) return;
        if (dataDriven && groupingFactor.groupingDataset === "" && groupingFactor.groupingVariable === "" && groupingFactor.dataValues.length === 0) confirmDataDrivenChange();
        else if (!dataDriven && groups.length === 0) confirmDataDrivenChange();
        else setShowConfirmModal(true);
    };
    /**
   * Confirms the dataDriven toggle after user acknowledgement.
   */ const confirmDataDrivenChange = ()=>{
        /* istanbul ignore else */ if (groupingFactor) {
            if ((0, $kcXWJ.isGroupingFactorDataDriven)(groupingFactor)) {
                const newGroupingFactor = {
                    dataDriven: false,
                    description: groupingFactor.description,
                    fromHierarchyId: groupingFactor.fromHierarchyId,
                    groups: [],
                    id: groupingFactor.id,
                    label: groupingFactor.label,
                    name: groupingFactor.name
                };
                dispatch({
                    operation: (0, $cJd2i.PATCH_ARS_STATE),
                    dataPath: dataPath,
                    value: newGroupingFactor
                });
            } else {
                const newGroupingFactor = {
                    dataDriven: true,
                    dataValues: [],
                    description: groupingFactor.description,
                    fromHierarchyId: groupingFactor.fromHierarchyId,
                    groupingDataset: "",
                    groupingVariable: "",
                    id: groupingFactor.id,
                    label: groupingFactor.label,
                    name: groupingFactor.name
                };
                dispatch({
                    operation: (0, $cJd2i.PATCH_ARS_STATE),
                    dataPath: dataPath,
                    value: newGroupingFactor
                });
            }
        }
        setShowConfirmModal(false);
    };
    /**
   * Handles adding a new group to the groups array.
   */ const handleAddGroup = ()=>{
        /* istanbul ignore else */ if (!disabled && (0, $drWxP.isGroupingFactorWithGroups)(groupingFactor)) {
            const newGroup = (0, $7byiZ.createNewGroup)(`Group_${groups.length + 1}`, groups.length);
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/groups`,
                value: [
                    ...groupingFactor.groups,
                    newGroup
                ]
            });
        }
    };
    /**
   * Handles reordering of the groups array after a tab has been dragged.
   *
   * @param newGroups - The groups in their new order, with order values re-applied.
   */ const handleReorderGroups = (newGroups)=>{
        /* istanbul ignore else -- reordering is disabled unless groups are present */ if (!disabled && (0, $drWxP.isGroupingFactorWithGroups)(groupingFactor)) {
            const groups = newGroups.map((group, index)=>({
                    ...group,
                    order: index
                }));
            dispatch({
                operation: (0, $cJd2i.PATCH_ARS_STATE),
                dataPath: `${dataPath}/groups`,
                value: groups
            });
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "border rounded p-3 mb-3 position-relative",
                children: [
                    groupingFactor && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "position-absolute bottom-0 end-0 m-1",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                                children: [
                                    "Id: ",
                                    dataPath.split("/").pop()
                                ]
                            })
                        })
                    }),
                    canRename && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "position-absolute top-0 end-0 m-2",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bRLeU.RemoveArsItemButton), {
                            dataPath: dataPath,
                            disabled: disabled
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Container, {
                        activeKey: activeTab,
                        onSelect: (k)=>{
                            /* istanbul ignore else -- Disabled tabs and null selections are not reachable from the UI */ if (k) setActiveTab(k);
                        },
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $aHdRW.default), {
                                variant: "tabs",
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                            eventKey: "named-object",
                                            children: "Properties"
                                        })
                                    }),
                                    dataDriven ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Item, {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aHdRW.default).Link, {
                                            eventKey: "dataset-variable",
                                            children: "Dataset/Variable"
                                        })
                                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VxLR.ReorderableNavList), {
                                        list: groups,
                                        setList: handleReorderGroups,
                                        getEventKey: (_group, index)=>`group-${index}`,
                                        disabled: disabled
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Content, {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                        eventKey: "named-object",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a5JBX.NamedObjectControl), {
                                                dataPath: dataPath,
                                                canRename: canRename,
                                                disabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                                                controlId: `${dataPath.replace(/\//g, "-")}-data-driven`,
                                                as: (0, $31g00.default),
                                                className: "my-1",
                                                title: "Data driven",
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                                                        column: true,
                                                        md: 2,
                                                        children: "Data driven"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                                        md: 10,
                                                        className: "d-flex align-items-center justify-content-start",
                                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                                            type: "switch",
                                                            checked: dataDriven,
                                                            disabled: disabled,
                                                            onChange: handleDataDrivenChange
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Group, {
                                                controlId: `${dataPath.replace(/\//g, "-")}-add-group`,
                                                className: "mt-3",
                                                children: !disabled && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                                    id: `${dataPath.replace(/\//g, "-")}-add-group-btn`,
                                                    onClick: handleAddGroup,
                                                    className: "d-flex align-items-center btn-sm btn-success",
                                                    disabled: dataDriven,
                                                    children: [
                                                        /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                            className: "me-2",
                                                            children: "Add group"
                                                        }),
                                                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    dataDriven ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $79ius.default).Pane, {
                                        eventKey: "dataset-variable",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/groupingVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-grouping-variable`,
                                                label: "Grouping variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable",
                                                disabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/orderVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-order-variable`,
                                                canChangeDataset: false,
                                                disabled: disabled || !groupingFactor?.groupingDataset,
                                                label: "Order variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/unitVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-unit-variable`,
                                                canChangeDataset: false,
                                                disabled: disabled || !groupingFactor?.groupingDataset,
                                                label: "Unit variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2VKUu.ArsVariable), {
                                                datasetDataPath: `${dataPath}/groupingDataset`,
                                                variableDataPath: `${dataPath}/otherVariable`,
                                                id: `${dataPath.replace(/\//g, "-")}-other-variable`,
                                                canChangeDataset: false,
                                                disabled: disabled || !groupingFactor?.groupingDataset,
                                                label: "Other variable",
                                                labelWidth: 2,
                                                placeHolder: "Select dataset.variable"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $d4ZHR.ArsText), {
                                                dataPath: `${dataPath}/dataValues`,
                                                id: `${dataPath.replace(/\//g, "-")}-data-values`,
                                                debounceMilliseconds: 2000,
                                                disabled: disabled,
                                                isArray: true,
                                                label: "Data values",
                                                labelWidth: 2,
                                                rows: 5,
                                                type: "textarea"
                                            })
                                        ]
                                    }) : groups.map((group, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $79ius.default).Pane, {
                                            eventKey: `group-${index}`,
                                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7afc2.GroupControl), {
                                                dataPath: `${dataPath}/groups/${index}`,
                                                disabled: disabled,
                                                siblingCount: groups.length
                                            })
                                        }, group.id))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
                show: showConfirmModal,
                onHide: ()=>setShowConfirmModal(false),
                centered: true,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                        closeButton: true,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                            children: "Confirm change"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Body, {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                children: "Changing the Data driven setting will result in loss of any existing changes."
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                children: "Are you sure you want to proceed?"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                variant: "secondary",
                                onClick: ()=>setShowConfirmModal(false),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                variant: "primary",
                                onClick: confirmDataDrivenChange,
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$40b409fd1c420ef7$export$95bd92bc1dba1edd.displayName = "GroupingFactorControl";

});
parcelRegister("27W8h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18c9542547f83e07$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $3GPnw = parcelRequire("3GPnw");

var $gWWOE = parcelRequire("gWWOE");

var $6s2Od = parcelRequire("6s2Od");

var $fml6v = parcelRequire("fml6v");

var $24J0W = parcelRequire("24J0W");

var $g36YP = parcelRequire("g36YP");

var $i1VQA = parcelRequire("i1VQA");

var $4E7Hm = parcelRequire("4E7Hm");

var $e3oKF = parcelRequire("e3oKF");

var $1AFqp = parcelRequire("1AFqp");

var $spJKX = parcelRequire("spJKX");

var $8nXch = parcelRequire("8nXch");

var $ihhAo = parcelRequire("ihhAo");

var $bE9uK = parcelRequire("bE9uK");

var $jLegW = parcelRequire("jLegW");

var $4KFS5 = parcelRequire("4KFS5");

var $3w3wb = parcelRequire("3w3wb");

var $kAAzj = parcelRequire("kAAzj");

var $2KtFr = parcelRequire("2KtFr");

var $g9pqw = parcelRequire("g9pqw");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
function $18c9542547f83e07$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bE9uK.default), {
        ...props,
        timeout: null
    });
}
function $18c9542547f83e07$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bE9uK.default), {
        ...props,
        timeout: null
    });
}
const $18c9542547f83e07$var$Modal = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $3w3wb.default), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $spJKX.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $spJKX.useState)(false);
    const waitingForMouseUpRef = (0, $spJKX.useRef)(false);
    const ignoreBackdropClickRef = (0, $spJKX.useRef)(false);
    const removeStaticModalAnimationRef = (0, $spJKX.useRef)(null);
    const [modal, setModalRef] = (0, $g36YP.default)();
    const mergedRef = (0, $4E7Hm.default)(ref, setModalRef);
    const handleHide = (0, $i1VQA.default)(onHide);
    const isRTL = (0, $dz672.useIsRTL)();
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal');
    const modalContext = (0, $spJKX.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $ihhAo.getSharedManager)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $gWWOE.default)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $6s2Od.default)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $24J0W.default)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $24J0W.default)() : undefined
        });
    }
    const handleWindowResize = (0, $i1VQA.default)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $e3oKF.default)(()=>{
        (0, $fml6v.default)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $1AFqp.default)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $3GPnw.default)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $fml6v.default)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $spJKX.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4KFS5.default).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8nXch.default), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $18c9542547f83e07$var$DialogTransition : undefined,
            backdropTransition: animation ? $18c9542547f83e07$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$18c9542547f83e07$var$Modal.displayName = 'Modal';
var $18c9542547f83e07$export$2e2bcd8739ae039 = Object.assign($18c9542547f83e07$var$Modal, {
    Body: (0, $jLegW.default),
    Header: (0, $2KtFr.default),
    Title: (0, $g9pqw.default),
    Footer: (0, $kAAzj.default),
    Dialog: (0, $3w3wb.default),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});

});
parcelRegister("24J0W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $182edf655fe3af55$export$2e2bcd8739ae039; });

var $gWWOE = parcelRequire("gWWOE");
var $182edf655fe3af55$var$size;
function $182edf655fe3af55$export$2e2bcd8739ae039(recalc) {
    if (!$182edf655fe3af55$var$size && $182edf655fe3af55$var$size !== 0 || recalc) {
        if (0, $gWWOE.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $182edf655fe3af55$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $182edf655fe3af55$var$size;
}

});

parcelRegister("g36YP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baf2573bd3750e83$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $baf2573bd3750e83$export$2e2bcd8739ae039() {
    return (0, $spJKX.useState)(null);
}

});

parcelRegister("i1VQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d205313bdc0f8329$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $bkjKV = parcelRequire("bkjKV");
function $d205313bdc0f8329$export$2e2bcd8739ae039(fn) {
    const ref = (0, $bkjKV.default)(fn);
    return (0, $spJKX.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}

});
parcelRegister("bkjKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83f0e30b27a85535$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $83f0e30b27a85535$var$useCommittedRef(value) {
    const ref = (0, $spJKX.useRef)(value);
    (0, $spJKX.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $83f0e30b27a85535$export$2e2bcd8739ae039 = $83f0e30b27a85535$var$useCommittedRef;

});


parcelRegister("e3oKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3b48bae12248db1$export$2e2bcd8739ae039; });

var $2CQ9n = parcelRequire("2CQ9n");

var $spJKX = parcelRequire("spJKX");
function $a3b48bae12248db1$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $2CQ9n.default)(fn);
    (0, $spJKX.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("2CQ9n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e97955945c5f200$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $1e97955945c5f200$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $spJKX.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("8nXch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ae64016d72841b$export$2e2bcd8739ae039; });

var $lpvjp = parcelRequire("lpvjp");

var $e15HB = parcelRequire("e15HB");

var $gWWOE = parcelRequire("gWWOE");

var $7VtiN = parcelRequire("7VtiN");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $1lkRM = parcelRequire("1lkRM");

var $ie3FC = parcelRequire("ie3FC");

var $NZVk0 = parcelRequire("NZVk0");

var $1nkOT = parcelRequire("1nkOT");

var $fNHsX = parcelRequire("fNHsX");

var $4XJuk = parcelRequire("4XJuk");

var $2Mg2Q = parcelRequire("2Mg2Q");

var $2xtMk = parcelRequire("2xtMk");

var $feFtK = parcelRequire("feFtK");

var $bR5nk = parcelRequire("bR5nk");
const $61ae64016d72841b$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $61ae64016d72841b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $61ae64016d72841b$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $61ae64016d72841b$var$getManager(window) {
    if (!$61ae64016d72841b$var$manager) $61ae64016d72841b$var$manager = new (0, $fNHsX.default)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $61ae64016d72841b$var$manager;
}
function $61ae64016d72841b$var$useModalManager(provided) {
    const window = (0, $2Mg2Q.default)();
    const modalManager = provided || $61ae64016d72841b$var$getManager(window);
    const modal = (0, $spJKX.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $spJKX.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $spJKX.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $61ae64016d72841b$var$Modal = /*#__PURE__*/ (0, $spJKX.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $61ae64016d72841b$var$_objectWithoutPropertiesLoose(_ref, $61ae64016d72841b$var$_excluded);
    const ownerWindow = (0, $2Mg2Q.default)();
    const container = (0, $4XJuk.default)(containerRef);
    const modal = $61ae64016d72841b$var$useModalManager(providedManager);
    const isMounted = (0, $1lkRM.default)();
    const prevShow = (0, $NZVk0.default)(show);
    const [exited, setExited] = (0, $spJKX.useState)(!show);
    const lastFocusRef = (0, $spJKX.useRef)(null);
    (0, $spJKX.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $gWWOE.default) && !prevShow && show) lastFocusRef.current = (0, $lpvjp.default)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $1nkOT.default)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $7VtiN.default)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $7VtiN.default)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $lpvjp.default)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $e15HB.default)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $1nkOT.default)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $spJKX.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $spJKX.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $ie3FC.default)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $1nkOT.default)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $lpvjp.default)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $e15HB.default)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $1nkOT.default)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $1nkOT.default)((e)=>{
        if (keyboard && (0, $feFtK.isEscKey)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $spJKX.useRef)();
    const removeKeydownListenerRef = (0, $spJKX.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $spJKX.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $2xtMk.renderTransition)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $2xtMk.renderTransition)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).createPortal(/*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$61ae64016d72841b$var$Modal.displayName = 'Modal';
var $61ae64016d72841b$export$2e2bcd8739ae039 = Object.assign($61ae64016d72841b$var$Modal, {
    Manager: (0, $fNHsX.default)
});

});
parcelRegister("lpvjp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f96438b54d33df50$export$2e2bcd8739ae039; });

var $6s2Od = parcelRequire("6s2Od");
function $f96438b54d33df50$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $6s2Od.default)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}

});

parcelRegister("e15HB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a345950fe32cb630$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $a345950fe32cb630$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}

});

parcelRegister("ie3FC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d44c61a1ae00c187$export$2e2bcd8739ae039; });

var $exzip = parcelRequire("exzip");

var $spJKX = parcelRequire("spJKX");
function $d44c61a1ae00c187$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $exzip.default)(fn);
    (0, $spJKX.useEffect)(()=>()=>onUnmount.current(), []);
}

});
parcelRegister("exzip", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a95f86c868294dad$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
function $a95f86c868294dad$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $spJKX.useRef)(value);
    valueRef.current = value;
    return valueRef;
}

});


parcelRegister("fNHsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b80d260da18c2832$export$2e2bcd8739ae039; });

var $hSUY5 = parcelRequire("hSUY5");

var $4aNCA = parcelRequire("4aNCA");

var $hIL19 = parcelRequire("hIL19");
const $b80d260da18c2832$export$1a88c12b8b979fa0 = (0, $4aNCA.dataAttr)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $b80d260da18c2832$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $hIL19.default)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $hSUY5.default)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($b80d260da18c2832$export$1a88c12b8b979fa0, '');
        (0, $hSUY5.default)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($b80d260da18c2832$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $b80d260da18c2832$export$2e2bcd8739ae039 = $b80d260da18c2832$var$ModalManager;

});
parcelRegister("hIL19", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce6b0472c5ddec50$export$2e2bcd8739ae039; });
/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $ce6b0472c5ddec50$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}

});


parcelRegister("4XJuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39cff520440db265$export$2e2bcd8739ae039; });

var $6s2Od = parcelRequire("6s2Od");

var $gWWOE = parcelRequire("gWWOE");

var $spJKX = parcelRequire("spJKX");

var $2Mg2Q = parcelRequire("2Mg2Q");
const $39cff520440db265$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $gWWOE.default)) return null;
    if (ref == null) return (document || (0, $6s2Od.default)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $39cff520440db265$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $2Mg2Q.default)();
    const [resolvedRef, setRef] = (0, $spJKX.useState)(()=>$39cff520440db265$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $39cff520440db265$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $spJKX.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $spJKX.useEffect)(()=>{
        const nextRef = $39cff520440db265$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}

});
parcelRegister("2Mg2Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $205c82a15bd76178$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gWWOE = parcelRequire("gWWOE");
const $205c82a15bd76178$var$Context = /*#__PURE__*/ (0, $spJKX.createContext)((0, $gWWOE.default) ? window : undefined);
const $205c82a15bd76178$export$f7d306aeb1cf5fbc = $205c82a15bd76178$var$Context.Provider;
function $205c82a15bd76178$export$2e2bcd8739ae039() {
    return (0, $spJKX.useContext)($205c82a15bd76178$var$Context);
}

});


parcelRegister("2xtMk", function(module, exports) {

$parcel$export(module.exports, "renderTransition", function () { return $1d95c33585daa68b$export$f41d64aae6d6dba5; });

var $6q3bl = parcelRequire("6q3bl");

var $1nkOT = parcelRequire("1nkOT");

var $hCMZV = parcelRequire("hCMZV");

var $spJKX = parcelRequire("spJKX");

var $bnFJc = parcelRequire("bnFJc");

var $8ttFN = parcelRequire("8ttFN");

var $feFtK = parcelRequire("feFtK");

var $bR5nk = parcelRequire("bR5nk");
function $1d95c33585daa68b$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $spJKX.useRef)(null);
    const isInitialRef = (0, $spJKX.useRef)(true);
    const handleTransition = (0, $1nkOT.default)(onTransition);
    (0, $hCMZV.default)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $hCMZV.default)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $1d95c33585daa68b$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $spJKX.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $1d95c33585daa68b$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $6q3bl.default)(ref, (0, $feFtK.getChildRef)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $spJKX.cloneElement)(children, {
        ref: combinedRef
    });
}
function $1d95c33585daa68b$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8ttFN.default), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $bR5nk.jsx)($1d95c33585daa68b$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bnFJc.default), Object.assign({}, props));
}

});
parcelRegister("8ttFN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62b80c9c264b3d48$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $bhYKV = parcelRequire("bhYKV");

var $bR5nk = parcelRequire("bR5nk");
const $62b80c9c264b3d48$var$_excluded = [
    "component"
];
function $62b80c9c264b3d48$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $62b80c9c264b3d48$var$RTGTransition = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $62b80c9c264b3d48$var$_objectWithoutPropertiesLoose(_ref, $62b80c9c264b3d48$var$_excluded);
    const transitionProps = (0, $bhYKV.default)(props);
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $62b80c9c264b3d48$export$2e2bcd8739ae039 = $62b80c9c264b3d48$var$RTGTransition;

});
parcelRegister("bhYKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8380691802f776c4$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $6q3bl = parcelRequire("6q3bl");

var $feFtK = parcelRequire("feFtK");
const $8380691802f776c4$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $8380691802f776c4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $8380691802f776c4$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $8380691802f776c4$var$_objectWithoutPropertiesLoose(_ref, $8380691802f776c4$var$_excluded);
    const nodeRef = (0, $spJKX.useRef)(null);
    const mergedRef = (0, $6q3bl.default)(nodeRef, (0, $feFtK.getChildRef)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $spJKX.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $spJKX.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $spJKX.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $spJKX.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $spJKX.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $spJKX.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $spJKX.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $spJKX.cloneElement)(children, {
            ref: mergedRef
        })
    });
}

});




parcelRegister("ihhAo", function(module, exports) {

$parcel$export(module.exports, "getSharedManager", function () { return $d4e774b6f021e362$export$a03641438014b436; });
$parcel$export(module.exports, "default", function () { return $d4e774b6f021e362$export$2e2bcd8739ae039; });

var $d0YVp = parcelRequire("d0YVp");

var $hSUY5 = parcelRequire("hSUY5");

var $c9yOz = parcelRequire("c9yOz");

var $bjJrB = parcelRequire("bjJrB");

var $fNHsX = parcelRequire("fNHsX");
const $d4e774b6f021e362$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $d4e774b6f021e362$var$BootstrapModalManager extends (0, $fNHsX.default) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $hSUY5.default)(element, {
            [prop]: `${parseFloat((0, $hSUY5.default)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $hSUY5.default)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $d0YVp.default)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $bjJrB.default)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $c9yOz.default)(container, $d4e774b6f021e362$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $d4e774b6f021e362$var$sharedManager;
function $d4e774b6f021e362$export$a03641438014b436(options) {
    if (!$d4e774b6f021e362$var$sharedManager) $d4e774b6f021e362$var$sharedManager = new $d4e774b6f021e362$var$BootstrapModalManager(options);
    return $d4e774b6f021e362$var$sharedManager;
}
var $d4e774b6f021e362$export$2e2bcd8739ae039 = $d4e774b6f021e362$var$BootstrapModalManager;

});
parcelRegister("d0YVp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $979a88e3bf04d101$export$2e2bcd8739ae039; });

var $bVXmG = parcelRequire("bVXmG");
function $979a88e3bf04d101$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $bVXmG.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("bVXmG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0311327b0ef0b7$export$2e2bcd8739ae039; });
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $8b0311327b0ef0b7$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("bjJrB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d4b853042bbc8c$export$2e2bcd8739ae039; });
function $83d4b853042bbc8c$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $83d4b853042bbc8c$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $83d4b853042bbc8c$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $83d4b853042bbc8c$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});


parcelRegister("jLegW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e62d7a42028239d6$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $e62d7a42028239d6$var$ModalBody = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$e62d7a42028239d6$var$ModalBody.displayName = 'ModalBody';
var $e62d7a42028239d6$export$2e2bcd8739ae039 = $e62d7a42028239d6$var$ModalBody;

});

parcelRegister("4KFS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $375bf010a2e013f0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
const $375bf010a2e013f0$var$ModalContext = /*#__PURE__*/ $spJKX.createContext({
    onHide () {}
});
var $375bf010a2e013f0$export$2e2bcd8739ae039 = $375bf010a2e013f0$var$ModalContext;

});

parcelRegister("3w3wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28f716dc90b30870$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $28f716dc90b30870$var$ModalDialog = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$28f716dc90b30870$var$ModalDialog.displayName = 'ModalDialog';
var $28f716dc90b30870$export$2e2bcd8739ae039 = $28f716dc90b30870$var$ModalDialog;

});

parcelRegister("kAAzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $efd38931883d795e$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $efd38931883d795e$var$ModalFooter = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$efd38931883d795e$var$ModalFooter.displayName = 'ModalFooter';
var $efd38931883d795e$export$2e2bcd8739ae039 = $efd38931883d795e$var$ModalFooter;

});

parcelRegister("2KtFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2006e3f971c251e4$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $dq88X = parcelRequire("dq88X");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $2006e3f971c251e4$var$ModalHeader = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dq88X.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$2006e3f971c251e4$var$ModalHeader.displayName = 'ModalHeader';
var $2006e3f971c251e4$export$2e2bcd8739ae039 = $2006e3f971c251e4$var$ModalHeader;

});
parcelRegister("dq88X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c54052f2893bc1b$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $i1VQA = parcelRequire("i1VQA");

var $lOUau = parcelRequire("lOUau");

var $4KFS5 = parcelRequire("4KFS5");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $9c54052f2893bc1b$var$AbstractModalHeader = /*#__PURE__*/ $spJKX.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $spJKX.useContext)((0, $4KFS5.default));
    const handleClick = (0, $i1VQA.default)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lOUau.default), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$9c54052f2893bc1b$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $9c54052f2893bc1b$export$2e2bcd8739ae039 = $9c54052f2893bc1b$var$AbstractModalHeader;

});
parcelRegister("lOUau", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe29d654aa6f4817$export$2e2bcd8739ae039; });

var $fGs19 = parcelRequire("fGs19");

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $bR5nk = parcelRequire("bR5nk");
const $fe29d654aa6f4817$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOf([
        'white'
    ])
};
const $fe29d654aa6f4817$var$CloseButton = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $bR5nk.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$fe29d654aa6f4817$var$CloseButton.displayName = 'CloseButton';
$fe29d654aa6f4817$var$CloseButton.propTypes = $fe29d654aa6f4817$var$propTypes;
var $fe29d654aa6f4817$export$2e2bcd8739ae039 = $fe29d654aa6f4817$var$CloseButton;

});



parcelRegister("g9pqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc2135d4ac531446$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $hQinx = parcelRequire("hQinx");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $bc2135d4ac531446$var$DivStyledAsH4 = (0, $hQinx.default)('h4');
const $bc2135d4ac531446$var$ModalTitle = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $bc2135d4ac531446$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$bc2135d4ac531446$var$ModalTitle.displayName = 'ModalTitle';
var $bc2135d4ac531446$export$2e2bcd8739ae039 = $bc2135d4ac531446$var$ModalTitle;

});
parcelRegister("hQinx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfd58c997d5d3b71$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $bR5nk = parcelRequire("bR5nk");
var $cfd58c997d5d3b71$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $spJKX.forwardRef((p, ref)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(p.className, className)
        }));

});




parcelRegister("cr6aM", function(module, exports) {

$parcel$export(module.exports, "ReferencedEntityControl", function () { return $312a6acb4cc80192$export$7e5b7980c50e925f; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $4U3f3 = parcelRequire("4U3f3");
var $872CV = parcelRequire("872CV");
var $av9bi = parcelRequire("av9bi");
parcelRequire("5SMPf");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("j4dHK");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $krPhG = parcelRequire("krPhG");

var $9QVTJ = parcelRequire("9QVTJ");

var $36pkg = parcelRequire("36pkg");

var $dMUCw = parcelRequire("dMUCw");

var $4n175 = parcelRequire("4n175");
const $312a6acb4cc80192$export$502b2f06a26bc541 = {
    AnalysisSet: {
        name: "Analysis set",
        label: "Analysis set",
        arsKey: "analysisSets"
    },
    DataSubset: {
        name: "Data subset",
        label: "Data subset",
        arsKey: "dataSubsets"
    }
};
const $312a6acb4cc80192$export$7e5b7980c50e925f = ({ dataPath: dataPath, entityType: entityType, disabled: disabled = false })=>{
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [isContextWindowOpen, setIsContextWindowOpen] = (0, $spJKX.useState)(false);
    const subClausePath = dataPath.endsWith("/subClauseId") ? dataPath.substring(0, dataPath.lastIndexOf("/subClauseId")) : "";
    const subClause = (0, $jwDoS.getFromDataPath)(subClausePath, state, (0, $9QVTJ.isSubClauseWithReference));
    const canSwapToCondition = subClause !== undefined;
    // Get the current subClauseId value
    const subClauseId = (0, $jwDoS.getFromDataPath)(dataPath, state, (0, $jwDoS.isString)) ?? "-- None --";
    /**
   * Get the entity configuration based on the entity type and subClauseId.
   * This includes the collection of entities, display name, label for the dropdown, and options for the dropdown.
   *
   * @param entityType - The type of entity being referenced (AnalysisSet or DataSubset)
   * @param subClauseId - The ID of the referenced entity to find the full details for
   * @return The entity configuration for the specified entity type, or undefined if the subClauseId does not correspond to a valid entity
   */ const getEntityConfig = ()=>{
        // Get the right entity collection based on the entity type
        const entities = entityType === "AnalysisSet" ? state.analysisSets : state.dataSubsets;
        // Find the specific entity being referenced using the subClauseId
        const entity = subClauseId ? entities[subClauseId] : undefined;
        // Return undefined if the subClauseId does not correspond to a valid entity
        const name = $312a6acb4cc80192$export$502b2f06a26bc541[entityType].name;
        const label = $312a6acb4cc80192$export$502b2f06a26bc541[entityType].label;
        const options = Object.values(entities).map((e)=>({
                value: e.id,
                label: e.name
            }));
        if (subClauseId === "-- None --" || subClauseId === "") options.unshift({
            value: "-- None --",
            label: "-- None --"
        });
        // Otherwise return the full entity configuration for the specified entity type
        return {
            entity: entity,
            name: name,
            label: label,
            options: options
        };
    };
    const entityConfig = getEntityConfig();
    /**
   * Get the dataPath for the referenced entity based on entity type.
   *
   * @returns The RFC 6901 JSON Pointer path to the referenced entity in ArsContext state
   */ const getEntityDataPath = ()=>{
        const typePrefix = $312a6acb4cc80192$export$502b2f06a26bc541[entityType].arsKey;
        return `/${typePrefix}/${subClauseId}`;
    };
    /**
   * Handles opening the context window to view the referenced entity.
   */ const handleOpenContextWindow = ()=>{
        setIsContextWindowOpen(true);
    };
    /**
   * Handles removing a where clause.
   * Reverts to single condition if only 2 clauses remain.
   */ const handleRemoveClause = ()=>{
        const parentPath = dataPath.substring(0, dataPath.lastIndexOf("/compoundExpression/whereClauses/"));
        dispatch({
            operation: (0, $cJd2i.REMOVE_WHERE_CLAUSE),
            dataPath: parentPath,
            id: subClauseId
        });
    };
    /**
   * Handles swapping a referenced entity back to a condition clause.
   */ const handleSwapToCondition = ()=>{
        /* istanbul ignore else */ if (subClause && subClausePath) dispatch({
            operation: (0, $cJd2i.PATCH_ARS_STATE),
            dataPath: subClausePath,
            value: {
                id: subClause.id,
                level: subClause.level,
                order: subClause.order,
                subClauseId: "",
                condition: {}
            }
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).compactContainer,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "flex-grow-1",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $krPhG.ArsSelect), {
                    dataPath: dataPath,
                    labelWidth: 2,
                    label: entityConfig.label,
                    options: entityConfig.options,
                    id: `${dataPath.replace(/\//g, "-")}-${entityType.toLowerCase()}`,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($4n175))).actionButtons,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4U3f3.default), {
                        id: `${dataPath.replace(/\//g, "-")}-swap`,
                        className: canSwapToCondition ? "text-primary" : "text-muted",
                        "aria-label": "Swap to condition",
                        "aria-disabled": !canSwapToCondition || disabled,
                        onClick: canSwapToCondition && !disabled ? handleSwapToCondition : undefined,
                        style: {
                            cursor: canSwapToCondition && !disabled ? "pointer" : "not-allowed"
                        }
                    }),
                    entityConfig.entity && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $872CV.default), {
                                className: "text-primary",
                                "aria-label": `Open referenced ${entityType.toLowerCase()}`,
                                "aria-disabled": disabled,
                                onClick: disabled ? undefined : handleOpenContextWindow,
                                style: {
                                    cursor: disabled ? "not-allowed" : "pointer"
                                }
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
                                id: `${dataPath.replace(/\//g, "-")}-remove`,
                                className: "text-danger",
                                "aria-label": "Remove clause",
                                "aria-disabled": disabled,
                                onClick: disabled ? undefined : ()=>handleRemoveClause(),
                                style: {
                                    cursor: disabled ? "not-allowed" : "pointer"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
                id: `ref-${entityType.toLowerCase()}-${subClauseId}`,
                title: entityConfig.name,
                visible: isContextWindowOpen,
                onClose: ()=>setIsContextWindowOpen(false),
                style: {
                    width: "500px",
                    minHeight: "300px",
                    maxHeight: "70vh",
                    maxWidth: "80vw"
                },
                children: entityType === "DataSubset" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dMUCw.DataSubsetControl), {
                    dataPath: getEntityDataPath(),
                    disabled: disabled
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $36pkg.AnalysisSetControl), {
                    dataPath: getEntityDataPath(),
                    disabled: disabled
                })
            })
        ]
    });
};
$312a6acb4cc80192$export$7e5b7980c50e925f.displayName = "ReferencedEntityControl";

});
parcelRegister("872CV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e8103cb66c00baa$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $5e8103cb66c00baa$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $5e8103cb66c00baa$var$_extends() {
    return $5e8103cb66c00baa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e8103cb66c00baa$var$_extends.apply(null, arguments);
}
function $5e8103cb66c00baa$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5e8103cb66c00baa$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $5e8103cb66c00baa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5e8103cb66c00baa$var$BoxArrowUpRight = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $5e8103cb66c00baa$var$_objectWithoutProperties(_ref, $5e8103cb66c00baa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $5e8103cb66c00baa$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-box-arrow-up-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"
    }));
});
$5e8103cb66c00baa$var$BoxArrowUpRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $5e8103cb66c00baa$export$2e2bcd8739ae039 = $5e8103cb66c00baa$var$BoxArrowUpRight;

});



parcelRegister("kgT2g", function(module, exports) {
$parcel$export(module.exports, "ArsListing", function () { return (parcelRequire("5V1m5")).ArsListing; });
$parcel$export(module.exports, "isArsListingBody", function () { return (parcelRequire("2N5BV")).isArsListingBody; });
parcelRequire("5V1m5");
parcelRequire("awLZy");
parcelRequire("7dBqL");
parcelRequire("idzk5");
parcelRequire("2N5BV");
parcelRequire("ifFUN");
parcelRequire("6bHL1");
parcelRequire("5VRwu");

});
parcelRegister("5V1m5", function(module, exports) {

$parcel$export(module.exports, "ArsListing", function () { return $cb90f3a4c0ccc690$export$b5fd9e15e5729e76; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $lXWd9 = parcelRequire("lXWd9");

var $4rIQR = parcelRequire("4rIQR");
const $cb90f3a4c0ccc690$export$b5fd9e15e5729e76 = ({ id: id = "ars-listing", arsListingBody: arsListingBody, calculatedTableRows: calculatedTableRows, disabled: disabled = false, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), justification: justification, sidebarWidth: sidebarWidth = "360px", tlfViewMode: tlfViewMode, updateArsListingBody: updateArsListingBody, sidebarStyle: sidebarStyle, style: style })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4rIQR.ArsListingContextProvider), {
        bodyData: arsListingBody,
        calculatedTableRows: calculatedTableRows,
        updateBodyData: updateArsListingBody,
        settings: {
            id: id,
            disabled: disabled,
            editorProps: editorProps,
            justification: justification,
            sidebarStyle: sidebarStyle,
            sidebarWidth: sidebarWidth,
            style: style,
            tlfViewMode: tlfViewMode,
            variableFilter: ""
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lXWd9.ArsListingContent), {})
    });
};
$cb90f3a4c0ccc690$export$b5fd9e15e5729e76.displayName = "ArsListing";

});
parcelRegister("lXWd9", function(module, exports) {

$parcel$export(module.exports, "ArsListingContent", function () { return $e549461b3d185be1$export$918e1fc4c9b36de5; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("e2uI9");
var $h7u5p = parcelRequire("h7u5p");
parcelRequire("j4dHK");
var $4hgF7 = parcelRequire("4hgF7");

var $hGt3n = parcelRequire("hGt3n");

var $jiUhT = parcelRequire("jiUhT");

var $h3Wl0 = parcelRequire("h3Wl0");

var $awLZy = parcelRequire("awLZy");

var $hBA47 = parcelRequire("hBA47");

var $lTMQV = parcelRequire("lTMQV");

var $4rIQR = parcelRequire("4rIQR");
parcelRequire("7dBqL");
var $bcylU = parcelRequire("bcylU");
var $lanM6 = parcelRequire("lanM6");

var $idzk5 = parcelRequire("idzk5");
const $e549461b3d185be1$export$918e1fc4c9b36de5 = ()=>{
    const arsContext = (0, $4hgF7.useArsContext)();
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    const scaffoldModel = state?.scaffoldModel;
    if (!state || !scaffoldModel) return null;
    const arsListingBody = state.bodyData;
    const arsListingColumns = arsListingBody.arsListingColumns;
    const disabled = state.settings.disabled;
    const id = state.settings.id;
    const justification = state.settings.justification;
    /**
   * Handles variable drops on scaffold cells.
   *
   * @param event - Drop event
   * @param rowId - Target scaffold row id
   * @param colId - Target scaffold column id
   * @param zone - Classified drop zone within the target cell
   */ const handleScaffoldDrop = (event, rowId, colId, zone)=>{
        /* istanbul ignore else */ if (!disabled && rowId === (0, $idzk5.HEADER_ROW_ID)) {
            event.preventDefault();
            const jsonPayload = event.dataTransfer.getData("application/json");
            const action = (0, $lanM6.buildApplyDroppedColumnsAction)(jsonPayload, colId, zone, state.settings.editorProps.textToT);
            /* istanbul ignore else */ if (action !== null) dispatch(action);
        }
    };
    /**
   * Handles column width changes from user resize operations.
   *
   * @param colId - Column id being resized
   * @param col - Updated column definition with new width
   */ const handleChangeCol = (colId, col)=>{
        if (!disabled) {
            const updatedColumns = arsListingColumns.map((column)=>column.id === colId ? {
                    ...column,
                    columnWidth: col.width
                } : column);
            dispatch({
                operation: (0, $idzk5.ARSL_SET_COLUMNS),
                columns: updatedColumns
            });
        }
    };
    /**
   * Handles row height changes from user resize operations.
   *
   * @param rowId - Row id being resized
   * @param row - Updated row definition with new height
   */ const handleChangeRow = (rowId, row)=>{
        if (!disabled) {
            if (rowId === (0, $idzk5.HEADER_ROW_ID)) dispatch({
                operation: (0, $idzk5.ARSL_SET_COLUMNS),
                columns: arsListingColumns.map((column)=>({
                        ...column,
                        headerHeight: row.height
                    }))
            });
            else {
                const bodyRowIndex = arsListingBody.arsBodyRows.findIndex((r)=>r.id === rowId);
                /* istanbul ignore else -- scaffold only passes rowIds built from arsBodyRows */ if (bodyRowIndex !== -1) dispatch({
                    operation: (0, $idzk5.ARSL_SET_ROW_HEIGHT),
                    rowId: rowId,
                    rowHeight: row.height
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "d-flex flex-row",
                style: {
                    width: "100%",
                    minWidth: 0,
                    minHeight: "500px"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    style: {
                        width: "100%",
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            className: "d-flex flex-row gap-1",
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lTMQV.ArsListingContextMenuProvider), {
                                    selectedColumns: arsListingColumns,
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $h7u5p.Scaffold), {
                                        id: id,
                                        cellComponent: (0, $awLZy.ArsListingCellEditorProps)(state.settings.editorProps),
                                        cellData: scaffoldModel.cellData,
                                        columns: scaffoldModel.columns,
                                        disabled: disabled,
                                        justification: justification,
                                        onChangeCol: handleChangeCol,
                                        onChangeRow: handleChangeRow,
                                        onDrop: arsContext.state.currentSidebar.view === "variable" ? handleScaffoldDrop : undefined,
                                        rows: scaffoldModel.rows,
                                        style: state.settings.style,
                                        zoneColors: arsContext.state.currentSidebar.view === "variable" ? (0, $bcylU.arsListingZoneColorResolver) : ()=>({
                                                color: null
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jiUhT.ArsListingAddColumnButton), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "ars-listing-footer",
                            style: {
                                display: "flex",
                                justifyContent: "flex-end",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $h3Wl0.ArsListingAddRowButton), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hBA47.ArsListingColumnProperties), {}),
            !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hGt3n.ArsDraggableSidebar), {
                showGroupingFactors: true,
                showOperations: false,
                showVariables: true,
                style: state.settings.sidebarStyle
            })
        ]
    });
};
$e549461b3d185be1$export$918e1fc4c9b36de5.displayName = "ArsListingContent";

});
parcelRegister("jiUhT", function(module, exports) {

$parcel$export(module.exports, "ArsListingAddColumnButton", function () { return $5bf9a33e70e4cd11$export$5acfa20267893247; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $5bf9a33e70e4cd11$export$5acfa20267893247 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state || state.settings.disabled) return null;
    const totalCols = state.bodyData.arsListingColumns.length;
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "ars-listing-add-column-button",
        title: "Add blank column",
        role: "button",
        tabIndex: 0,
        onClick: ()=>{
            const colId = crypto.randomUUID();
            dispatch({
                operation: (0, $idzk5.ARSL_ADD_BLANK_COLUMN),
                colIx: totalCols,
                colId: colId
            });
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
            "aria-label": "Add column"
        })
    });
};
$5bf9a33e70e4cd11$export$5acfa20267893247.displayName = "ArsListingAddColumnButton";

});
parcelRegister("4rIQR", function(module, exports) {

$parcel$export(module.exports, "ArsListingContextProvider", function () { return $0eba2cb5dde894aa$export$bb061f9f796add9a; });
$parcel$export(module.exports, "useArsListing", function () { return $0eba2cb5dde894aa$export$d63771a112713ff8; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $dmRq4 = parcelRequire("dmRq4");
parcelRequire("7dBqL");
var $5za9D = parcelRequire("5za9D");
var $gHAR7 = parcelRequire("gHAR7");

var $idzk5 = parcelRequire("idzk5");
const $0eba2cb5dde894aa$export$7c5696f82472f580 = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $0eba2cb5dde894aa$export$bb061f9f796add9a = ({ children: children, bodyData: bodyData, calculatedTableRows: calculatedTableRows, settings: settings, updateBodyData: updateBodyData })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $dmRq4.arsListingReducer), {
        bodyData: bodyData,
        calculatedTableRows: calculatedTableRows,
        scaffoldModel: (0, $5za9D.buildScaffoldFromCalculatedRows)(calculatedTableRows, settings.editorProps),
        changed: false,
        datasets: (0, $gHAR7.datasetsFromColumns)(bodyData.arsListingColumns),
        settings: settings
    });
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state.bodyData, bodyData);
        // Send changes up
        if (!eq && state.bodyData.id === bodyData.id && state.changed) {
            updateBodyData(state.bodyData);
            dispatch({
                operation: (0, $idzk5.ARSL_CHANGE_SENT)
            });
        } else if (state.bodyData.id !== bodyData.id || !eq) dispatch({
            operation: (0, $idzk5.ARSL_LOAD_DATA),
            bodyData: bodyData
        });
    }, [
        bodyData,
        state.changed,
        state.bodyData,
        updateBodyData
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!(0, $eBlbF.isEqual)(state.settings.tlfViewMode, settings.tlfViewMode)) dispatch({
            operation: (0, $idzk5.ARSL_SET_TLF_VIEW_MODE),
            tlfViewMode: settings.tlfViewMode
        });
    }, [
        settings.tlfViewMode,
        state.settings.tlfViewMode
    ]);
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state.calculatedTableRows, calculatedTableRows ?? []);
        if (!eq && calculatedTableRows) dispatch({
            operation: (0, $idzk5.ARSL_UPDATE_SCAFFOLD),
            calculatedTableRows: calculatedTableRows
        });
    }, [
        calculatedTableRows,
        state.calculatedTableRows
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($0eba2cb5dde894aa$export$7c5696f82472f580.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$0eba2cb5dde894aa$export$bb061f9f796add9a.displayName = "ArsListingContextProvider";
const $0eba2cb5dde894aa$export$d63771a112713ff8 = ()=>{
    const context = (0, $spJKX.useContext)($0eba2cb5dde894aa$export$7c5696f82472f580);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("dmRq4", function(module, exports) {

$parcel$export(module.exports, "arsListingReducer", function () { return $8f9d7cd4495b072b$export$575da89f0b9456a2; });
parcelRequire("7dBqL");
var $9U8y4 = parcelRequire("9U8y4");
var $aSGLV = parcelRequire("aSGLV");
var $4gICR = parcelRequire("4gICR");
var $dEvf6 = parcelRequire("dEvf6");
var $6QtZu = parcelRequire("6QtZu");
var $cWSYP = parcelRequire("cWSYP");
var $2HIuc = parcelRequire("2HIuc");
var $iDVtL = parcelRequire("iDVtL");
var $4nqNm = parcelRequire("4nqNm");
var $89klF = parcelRequire("89klF");
var $9EWDE = parcelRequire("9EWDE");
var $edvwv = parcelRequire("edvwv");
var $fQ8Jd = parcelRequire("fQ8Jd");
var $aMsSQ = parcelRequire("aMsSQ");
var $1pBNO = parcelRequire("1pBNO");
var $3OeHo = parcelRequire("3OeHo");
var $487WA = parcelRequire("487WA");

var $4iFpV = parcelRequire("4iFpV");

var $idzk5 = parcelRequire("idzk5");
const $8f9d7cd4495b072b$export$575da89f0b9456a2 = (state, action)=>{
    switch(action.operation){
        case 0, $idzk5.ARSL_ADD_BLANK_COLUMN:
            return (0, $4iFpV.arsl_addBlankColumn)(state, action);
        case 0, $idzk5.ARSL_ADD_ROW:
            return (0, $9U8y4.arsl_addRow)(state, action);
        case 0, $idzk5.ARSL_ADD_VARIABLES_TO_COLUMN:
            return (0, $aSGLV.arsl_addVariablesToColumn)(state, action);
        case 0, $idzk5.ARSL_ALIGN_TEXT:
            return (0, $4gICR.arsl_alignText)(state, action);
        case 0, $idzk5.ARSL_APPLY_DROPPED_COLUMNS:
            return (0, $dEvf6.arsl_applyDroppedColumns)(state, action);
        case 0, $idzk5.ARSL_APPLY_DROPPED_SORT_COLUMNS:
            return (0, $6QtZu.arsl_applyDroppedSortColumns)(state, action);
        case 0, $idzk5.ARSL_CELL_UPDATE:
            return (0, $cWSYP.arsl_cellUpdate)(state, action);
        case 0, $idzk5.ARSL_CHANGE_SENT:
            return (0, $2HIuc.arsl_changeSent)(state);
        case 0, $idzk5.ARSL_COLUMN_UPDATE:
            return (0, $iDVtL.arsl_columnUpdate)(state, action);
        case 0, $idzk5.ARSL_LOAD_DATA:
            return (0, $4nqNm.arsl_loadData)(state, action);
        case 0, $idzk5.ARSL_REMOVE_COLUMN:
            return (0, $89klF.arsl_removeColumn)(state, action);
        case 0, $idzk5.ARSL_REMOVE_ROW:
            return (0, $9EWDE.arsl_removeRow)(state, action);
        case 0, $idzk5.ARSL_SET_COLUMNS:
            return (0, $edvwv.arsl_setColumns)(state, action);
        case 0, $idzk5.ARSL_SET_ROW_HEIGHT:
            return (0, $fQ8Jd.arsl_setRowHeight)(state, action);
        case 0, $idzk5.ARSL_SET_TLF_VIEW_MODE:
            return (0, $aMsSQ.arsl_setTlfViewMode)(state, action);
        case 0, $idzk5.ARSL_SET_VARIABLE_FILTER:
            return (0, $1pBNO.arsl_setVariableFilter)(state, action);
        case 0, $idzk5.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID:
            return (0, $3OeHo.arsl_setViewColumnPropertiesId)(state, action);
        case 0, $idzk5.ARSL_UPDATE_SCAFFOLD:
            return (0, $487WA.arsl_updateScaffold)(state, action);
    }
};

});
parcelRegister("7dBqL", function(module, exports) {
$parcel$export(module.exports, "arsl_addRow", function () { return (parcelRequire("9U8y4")).arsl_addRow; });
$parcel$export(module.exports, "arsl_addVariablesToColumn", function () { return (parcelRequire("aSGLV")).arsl_addVariablesToColumn; });
$parcel$export(module.exports, "arsl_alignText", function () { return (parcelRequire("4gICR")).arsl_alignText; });
$parcel$export(module.exports, "arsl_applyDroppedColumns", function () { return (parcelRequire("dEvf6")).arsl_applyDroppedColumns; });
$parcel$export(module.exports, "arsl_applyDroppedSortColumns", function () { return (parcelRequire("6QtZu")).arsl_applyDroppedSortColumns; });
$parcel$export(module.exports, "arsl_cellUpdate", function () { return (parcelRequire("cWSYP")).arsl_cellUpdate; });
$parcel$export(module.exports, "arsl_changeSent", function () { return (parcelRequire("2HIuc")).arsl_changeSent; });
$parcel$export(module.exports, "arsl_columnUpdate", function () { return (parcelRequire("iDVtL")).arsl_columnUpdate; });
$parcel$export(module.exports, "arsl_loadData", function () { return (parcelRequire("4nqNm")).arsl_loadData; });
$parcel$export(module.exports, "arsl_removeColumn", function () { return (parcelRequire("89klF")).arsl_removeColumn; });
$parcel$export(module.exports, "arsl_removeRow", function () { return (parcelRequire("9EWDE")).arsl_removeRow; });
$parcel$export(module.exports, "arsl_setColumns", function () { return (parcelRequire("edvwv")).arsl_setColumns; });
$parcel$export(module.exports, "arsl_setRowHeight", function () { return (parcelRequire("fQ8Jd")).arsl_setRowHeight; });
$parcel$export(module.exports, "arsl_setTlfViewMode", function () { return (parcelRequire("aMsSQ")).arsl_setTlfViewMode; });
$parcel$export(module.exports, "arsl_setVariableFilter", function () { return (parcelRequire("1pBNO")).arsl_setVariableFilter; });
$parcel$export(module.exports, "arsl_setViewColumnPropertiesId", function () { return (parcelRequire("3OeHo")).arsl_setViewColumnPropertiesId; });
$parcel$export(module.exports, "arsl_updateScaffold", function () { return (parcelRequire("487WA")).arsl_updateScaffold; });
$parcel$export(module.exports, "arsListingZoneColorResolver", function () { return (parcelRequire("bcylU")).arsListingZoneColorResolver; });
$parcel$export(module.exports, "buildApplyDroppedColumnsAction", function () { return (parcelRequire("lanM6")).buildApplyDroppedColumnsAction; });
$parcel$export(module.exports, "buildScaffoldFromCalculatedRows", function () { return (parcelRequire("5za9D")).buildScaffoldFromCalculatedRows; });
$parcel$export(module.exports, "datasetsFromColumns", function () { return (parcelRequire("gHAR7")).datasetsFromColumns; });
parcelRequire("9U8y4");
parcelRequire("aSGLV");
parcelRequire("4gICR");
parcelRequire("dEvf6");
parcelRequire("6QtZu");
parcelRequire("cWSYP");
parcelRequire("2HIuc");
parcelRequire("iDVtL");
parcelRequire("4nqNm");
parcelRequire("89klF");
parcelRequire("9EWDE");
parcelRequire("edvwv");
parcelRequire("fQ8Jd");
parcelRequire("aMsSQ");
parcelRequire("1pBNO");
parcelRequire("3OeHo");
parcelRequire("487WA");
parcelRequire("bcylU");
parcelRequire("lanM6");
parcelRequire("5za9D");
parcelRequire("gHAR7");

});
parcelRegister("9U8y4", function(module, exports) {

$parcel$export(module.exports, "arsl_addRow", function () { return $fea130de0271bd54$export$a452f9d2653afda; });
const $fea130de0271bd54$export$a452f9d2653afda = (state, action)=>{
    const targetIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === action.rowId);
    const insertAt = targetIndex + 1;
    const updatedRows = [
        ...state.bodyData.arsBodyRows.slice(0, insertAt),
        {
            id: crypto.randomUUID(),
            rowHeight: 34,
            ellipsis: action.type === "ellipsis"
        },
        ...state.bodyData.arsBodyRows.slice(insertAt)
    ];
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: updatedRows
        }
    };
};

});

parcelRegister("aSGLV", function(module, exports) {

$parcel$export(module.exports, "arsl_addVariablesToColumn", function () { return $987324dc8d823a8f$export$cb35876320fd6625; });

var $idzk5 = parcelRequire("idzk5");

var $lanM6 = parcelRequire("lanM6");
const $987324dc8d823a8f$export$cb35876320fd6625 = (state, action)=>{
    const targetColumn = state.bodyData.arsListingColumns.find((col)=>col.id === action.colId);
    if (!targetColumn) return state;
    const textToT = state.settings.editorProps.textToT;
    const getTextFromT = state.settings.editorProps.getTextFromT;
    const newDisplayPattern = [
        ...targetColumn.displayPattern.map((displayPattern)=>getTextFromT(displayPattern)),
        ...action.variables.map((variable)=>(0, $lanM6.resolvePlaceholderText)(variable.dataType))
    ].join("/");
    const newHeaderText = [
        getTextFromT(targetColumn.headerText),
        ...action.variables.map((variable)=>variable.description?.trim() !== "" ? variable.description : variable.name)
    ].join("/");
    const newResultPattern = [
        targetColumn.resultPattern,
        ...action.variables.map((variable)=>`{${variable.name.toLowerCase()}}`)
    ].join("/");
    const newColumn = {
        ...targetColumn,
        displayPattern: [
            textToT(newDisplayPattern)
        ],
        resultPattern: newResultPattern,
        headerText: textToT(newHeaderText),
        variables: [
            ...targetColumn.variables,
            ...action.variables.map((variable)=>({
                    id: crypto.randomUUID(),
                    dataset: variable.dataset,
                    variable: variable.name,
                    variableType: (0, $idzk5.ArsListingVariableEnum).DisplayOnly
                }))
        ]
    };
    const newState = {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? newColumn : col)
        }
    };
    // Check new datasets
    if (newColumn.variables.some((v)=>!state.datasets.has(v.dataset))) newState.datasets = new Set([
        ...state.datasets,
        ...newColumn.variables.map((v)=>v.dataset)
    ]);
    return newState;
};

});
parcelRegister("idzk5", function(module, exports) {

$parcel$export(module.exports, "ArsListingVariableEnum", function () { return $24002d074b8a20af$export$509f77194832f4eb; });
$parcel$export(module.exports, "ARSL_DEFAULT_COLUMN_WIDTH", function () { return $24002d074b8a20af$export$44f8c3d174a4d96; });
$parcel$export(module.exports, "HEADER_ROW_ID", function () { return $24002d074b8a20af$export$a721ca93c346c699; });
$parcel$export(module.exports, "EMPTY_HEADER_COL_ID", function () { return $24002d074b8a20af$export$ffa019c98ea23dbb; });
$parcel$export(module.exports, "ARSL_ADD_BLANK_COLUMN", function () { return $24002d074b8a20af$export$5fce5e704635675e; });
$parcel$export(module.exports, "ARSL_ADD_ROW", function () { return $24002d074b8a20af$export$db5e3b0d3f7bb985; });
$parcel$export(module.exports, "ARSL_ADD_VARIABLES_TO_COLUMN", function () { return $24002d074b8a20af$export$44766ae23dffaa6d; });
$parcel$export(module.exports, "ARSL_ALIGN_TEXT", function () { return $24002d074b8a20af$export$570ec6e2b98dfc6d; });
$parcel$export(module.exports, "ARSL_APPLY_DROPPED_COLUMNS", function () { return $24002d074b8a20af$export$29d129289d7e12de; });
$parcel$export(module.exports, "ARSL_APPLY_DROPPED_SORT_COLUMNS", function () { return $24002d074b8a20af$export$9f3c533acc804246; });
$parcel$export(module.exports, "ARSL_CELL_UPDATE", function () { return $24002d074b8a20af$export$b6c3821a1eb72b88; });
$parcel$export(module.exports, "ARSL_CHANGE_SENT", function () { return $24002d074b8a20af$export$ccea787a9f2e730a; });
$parcel$export(module.exports, "ARSL_COLUMN_UPDATE", function () { return $24002d074b8a20af$export$b81ea38594802f40; });
$parcel$export(module.exports, "ARSL_LOAD_DATA", function () { return $24002d074b8a20af$export$350c0380e4705ad4; });
$parcel$export(module.exports, "ARSL_REMOVE_COLUMN", function () { return $24002d074b8a20af$export$a89107a5dd1f225; });
$parcel$export(module.exports, "ARSL_REMOVE_ROW", function () { return $24002d074b8a20af$export$fe4b47de842515fc; });
$parcel$export(module.exports, "ARSL_SET_COLUMNS", function () { return $24002d074b8a20af$export$d36d0fbebee1931a; });
$parcel$export(module.exports, "ARSL_SET_ROW_HEIGHT", function () { return $24002d074b8a20af$export$913bdfd40ec3aaee; });
$parcel$export(module.exports, "ARSL_SET_TLF_VIEW_MODE", function () { return $24002d074b8a20af$export$3d99936c4a6c70b; });
$parcel$export(module.exports, "ARSL_SET_VARIABLE_FILTER", function () { return $24002d074b8a20af$export$a6c62932fb112c5e; });
$parcel$export(module.exports, "ARSL_SET_VIEW_COLUMN_PROPERTIES_ID", function () { return $24002d074b8a20af$export$2ef97af8c15aad9d; });
$parcel$export(module.exports, "ARSL_UPDATE_SCAFFOLD", function () { return $24002d074b8a20af$export$b92f08f85dc30d43; });
$parcel$export(module.exports, "LEFT_HEADER_ZONES", function () { return $24002d074b8a20af$export$6252eef46558336d; });
$parcel$export(module.exports, "CENTRE_HEADER_ZONES", function () { return $24002d074b8a20af$export$f3256a048c3f3c69; });
$parcel$export(module.exports, "RIGHT_HEADER_ZONES", function () { return $24002d074b8a20af$export$9114f44185bfc9f6; });
$parcel$export(module.exports, "BOTTOM_HEADER_ZONES", function () { return $24002d074b8a20af$export$77da637b1b6e60a7; });
parcelRequire("e2uI9");
var $aLLqu = parcelRequire("aLLqu");
var $24002d074b8a20af$export$509f77194832f4eb = /*#__PURE__*/ function(ArsListingVariableEnum) {
    ArsListingVariableEnum["DisplayOnly"] = "displayOnly";
    ArsListingVariableEnum["Group"] = "group";
    ArsListingVariableEnum["HiddenSortAscending"] = "hidden-sort-ascending";
    ArsListingVariableEnum["HiddenSortDescending"] = "hidden-sort-descending";
    return ArsListingVariableEnum;
}({});
const $24002d074b8a20af$export$44f8c3d174a4d96 = 200;
const $24002d074b8a20af$export$a721ca93c346c699 = "ars-listing-header-row";
const $24002d074b8a20af$export$ffa019c98ea23dbb = "ars-listing-empty-header-col";
const $24002d074b8a20af$export$5fce5e704635675e = "ARSL_ADD_BLANK_COLUMN";
const $24002d074b8a20af$export$db5e3b0d3f7bb985 = "ARSL_ADD_ROW";
const $24002d074b8a20af$export$44766ae23dffaa6d = "ARSL_ADD_VARIABLES_TO_COLUMN";
const $24002d074b8a20af$export$570ec6e2b98dfc6d = "ARSL_ALIGN_TEXT";
const $24002d074b8a20af$export$29d129289d7e12de = "ARSL_APPLY_DROPPED_COLUMNS";
const $24002d074b8a20af$export$9f3c533acc804246 = "ARSL_APPLY_DROPPED_SORT_COLUMNS";
const $24002d074b8a20af$export$b6c3821a1eb72b88 = "ARSL_CELL_UPDATE";
const $24002d074b8a20af$export$ccea787a9f2e730a = "ARSL_CHANGE_SENT";
const $24002d074b8a20af$export$b81ea38594802f40 = "ARSL_COLUMN_UPDATE";
const $24002d074b8a20af$export$350c0380e4705ad4 = "ARSL_LOAD_DATA";
const $24002d074b8a20af$export$a89107a5dd1f225 = "ARSL_REMOVE_COLUMN";
const $24002d074b8a20af$export$fe4b47de842515fc = "ARSL_REMOVE_ROW";
const $24002d074b8a20af$export$d36d0fbebee1931a = "ARSL_SET_COLUMNS";
const $24002d074b8a20af$export$913bdfd40ec3aaee = "ARSL_SET_ROW_HEIGHT";
const $24002d074b8a20af$export$3d99936c4a6c70b = "ARSL_SET_TLF_VIEW_MODE";
const $24002d074b8a20af$export$a6c62932fb112c5e = "ARSL_SET_VARIABLE_FILTER";
const $24002d074b8a20af$export$2ef97af8c15aad9d = "ARSL_SET_VIEW_COLUMN_PROPERTIES_ID";
const $24002d074b8a20af$export$b92f08f85dc30d43 = "ARSL_UPDATE_SCAFFOLD";
const $24002d074b8a20af$export$6252eef46558336d = [
    (0, $aLLqu.ScaffoldDropZone).TopLeft,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).LeftEdgeBottom
];
const $24002d074b8a20af$export$f3256a048c3f3c69 = [
    (0, $aLLqu.ScaffoldDropZone).TopEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).TopEdgeRight,
    (0, $aLLqu.ScaffoldDropZone).CentreTopLeft,
    (0, $aLLqu.ScaffoldDropZone).CentreTopRight,
    (0, $aLLqu.ScaffoldDropZone).CentreBottomLeft,
    (0, $aLLqu.ScaffoldDropZone).CentreBottomRight
];
const $24002d074b8a20af$export$9114f44185bfc9f6 = [
    (0, $aLLqu.ScaffoldDropZone).TopRight,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeTop,
    (0, $aLLqu.ScaffoldDropZone).RightEdgeBottom
];
const $24002d074b8a20af$export$77da637b1b6e60a7 = [
    (0, $aLLqu.ScaffoldDropZone).BottomLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeLeft,
    (0, $aLLqu.ScaffoldDropZone).BottomEdgeRight,
    (0, $aLLqu.ScaffoldDropZone).BottomRight
];

});

parcelRegister("lanM6", function(module, exports) {

$parcel$export(module.exports, "resolvePlaceholderText", function () { return $8c8ac57f1f31e614$export$6226a6356d56e9d9; });
$parcel$export(module.exports, "buildApplyDroppedColumnsAction", function () { return $8c8ac57f1f31e614$export$1bb0b1f17dd71c6f; });

var $IhPMk = parcelRequire("IhPMk");

var $idzk5 = parcelRequire("idzk5");
/**
 * Parses a JSON drop payload string into an array of ArsListing variables.
 *
 * @param jsonPayload - Raw JSON string from a DataTransfer object
 * @returns Parsed variable list, or an empty array when the payload is invalid
 */ const $8c8ac57f1f31e614$var$parseVariables = (jsonPayload)=>{
    try {
        const parsed = JSON.parse(jsonPayload);
        const parsedDataArray = typeof parsed === "object" ? Array.isArray(parsed.data) ? parsed.data : [
            parsed.data
        ] : [];
        const variables = parsedDataArray.map((item)=>item.dropItem).filter((0, $IhPMk.isAnnotationVariable));
        return variables;
    } catch  {
        return [];
    }
};
const $8c8ac57f1f31e614$export$6226a6356d56e9d9 = (dataType)=>{
    switch(dataType.toLowerCase()){
        case "boolean":
            return "true/false";
        case "datetime":
            return "01Jan2025 12:00";
        case "date":
            return "01Jan2025";
        case "time":
            return "12:00";
        case "integer":
        case "float":
        case "double":
        case "number":
        case "numeric":
        case "decimal":
            return "xx.x";
        default:
            return "xxxxx";
    }
};
/**
 * Maps a scaffold drop zone to a column placement action.
 *
 * @param zone - Classified drop zone within the target cell
 * @returns Column placement action
 */ const $8c8ac57f1f31e614$var$resolveDropAction = (zone)=>{
    if ((0, $idzk5.LEFT_HEADER_ZONES).includes(zone)) return "insert-before";
    else if ((0, $idzk5.RIGHT_HEADER_ZONES).includes(zone)) return "insert-after";
    else return "replace";
};
function $8c8ac57f1f31e614$export$1bb0b1f17dd71c6f(jsonPayload, colId, zone, textToT) {
    const variables = $8c8ac57f1f31e614$var$parseVariables(jsonPayload);
    if (variables.length === 0) return null;
    if ((0, $idzk5.BOTTOM_HEADER_ZONES).includes(zone) && colId !== (0, $idzk5.EMPTY_HEADER_COL_ID)) return {
        operation: (0, $idzk5.ARSL_ADD_VARIABLES_TO_COLUMN),
        colId: colId,
        variables: variables
    };
    const columns = variables.map((variable)=>{
        const placeholderText = $8c8ac57f1f31e614$export$6226a6356d56e9d9(variable.dataType);
        const displayPattern = [
            textToT(placeholderText)
        ];
        const resultPattern = `{${variable.name.toLowerCase()}}`;
        const headerText = textToT(variable.description?.trim() !== "" ? variable.description : variable.name);
        return {
            id: crypto.randomUUID(),
            columnWidth: (0, $idzk5.ARSL_DEFAULT_COLUMN_WIDTH),
            displayPattern: displayPattern,
            resultPattern: resultPattern,
            headerText: headerText,
            variables: [
                {
                    id: crypto.randomUUID(),
                    dataset: variable.dataset,
                    variable: variable.name,
                    variableType: "displayOnly"
                }
            ]
        };
    });
    return {
        operation: (0, $idzk5.ARSL_APPLY_DROPPED_COLUMNS),
        colId: colId,
        columns: columns,
        dropAction: $8c8ac57f1f31e614$var$resolveDropAction(zone)
    };
}

});


parcelRegister("4gICR", function(module, exports) {

$parcel$export(module.exports, "arsl_alignText", function () { return $6d5e5bb159b5fd9c$export$84f09db62243ed6f; });
const $6d5e5bb159b5fd9c$export$84f09db62243ed6f = (state, action)=>{
    const updatedColumns = state.bodyData.arsListingColumns.map((column)=>column.id === action.colId ? {
            ...column,
            [action.isHeader ? "headerTextAlignment" : "bodyTextAlignment"]: action.alignment
        } : column);
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns
        }
    };
};

});

parcelRegister("dEvf6", function(module, exports) {

$parcel$export(module.exports, "arsl_applyDroppedColumns", function () { return $f335a71c2d6ccfbf$export$c61a9ec237dbc53; });

var $idzk5 = parcelRequire("idzk5");

var $gHAR7 = parcelRequire("gHAR7");
const $f335a71c2d6ccfbf$export$c61a9ec237dbc53 = (state, action)=>{
    if (state.bodyData.arsListingColumns.length >= 20) return state;
    const existingColumns = state.bodyData.arsListingColumns;
    if (existingColumns.length === 0 || action.colId === (0, $idzk5.EMPTY_HEADER_COL_ID)) return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: action.columns.slice(0, 20)
        }
    };
    const targetIndex = existingColumns.findIndex((column)=>column.id === action.colId);
    let updatedColumns;
    if (targetIndex < 0) updatedColumns = [
        ...existingColumns,
        ...action.columns
    ];
    else if (action.dropAction === "insert-before") updatedColumns = [
        ...existingColumns.slice(0, targetIndex),
        ...action.columns,
        ...existingColumns.slice(targetIndex)
    ];
    else if (action.dropAction === "insert-after") updatedColumns = [
        ...existingColumns.slice(0, targetIndex + 1),
        ...action.columns,
        ...existingColumns.slice(targetIndex + 1)
    ];
    else {
        const [replacementColumn, ...remainingColumns] = action.columns;
        const nextColumns = [
            ...existingColumns
        ];
        nextColumns[targetIndex] = replacementColumn;
        if (remainingColumns.length > 0) nextColumns.splice(targetIndex + 1, 0, ...remainingColumns);
        updatedColumns = nextColumns;
    }
    const newState = {
        ...state,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns.slice(0, 20)
        },
        changed: true,
        datasets: (0, $gHAR7.datasetsFromColumns)(updatedColumns)
    };
    return newState;
};

});
parcelRegister("gHAR7", function(module, exports) {

$parcel$export(module.exports, "datasetsFromColumns", function () { return $1b908edd8f9b02ee$export$77e7561f74373956; });
parcelRequire("1ZdiT");
var $4FB18 = parcelRequire("4FB18");
var $ejHCH = parcelRequire("ejHCH");
var $9QVTJ = parcelRequire("9QVTJ");
var $cTgGQ = parcelRequire("cTgGQ");
const $1b908edd8f9b02ee$export$84cc69fa060e55b1 = (columns)=>{
    const datasets = new Set();
    const variables = new Set();
    columns.forEach((column)=>{
        column.variables.forEach((variable)=>{
            datasets.add(variable.dataset.toUpperCase());
            variables.add(`${variable.dataset}.${variable.variable}`.toUpperCase());
        });
        if (column.caseWhenCondition) $1b908edd8f9b02ee$export$733df0fb66151793([
            column.caseWhenCondition
        ]).forEach((caseWhenVariable)=>{
            variables.add(caseWhenVariable.toUpperCase());
            const [dataset] = caseWhenVariable.split(".");
            if (dataset) datasets.add(dataset.toUpperCase());
        });
        if (column.filterWhereClause) $1b908edd8f9b02ee$export$53eb125b3e27834d(column.filterWhereClause).forEach((filterVariable)=>{
            variables.add(filterVariable.toUpperCase());
            const [dataset] = filterVariable.split(".");
            if (dataset) datasets.add(dataset.toUpperCase());
        });
    });
    return {
        datasets: datasets,
        variables: variables
    };
};
const $1b908edd8f9b02ee$export$77e7561f74373956 = (columns)=>{
    return $1b908edd8f9b02ee$export$84cc69fa060e55b1(columns).datasets;
};
const $1b908edd8f9b02ee$export$733df0fb66151793 = (caseWhenConditions)=>{
    const variables = new Set();
    caseWhenConditions.forEach((caseWhen)=>{
        caseWhen.caseWhenItems.forEach((item)=>{
            if (item.when) $1b908edd8f9b02ee$export$53eb125b3e27834d(item.when).forEach((variable)=>{
                variables.add(variable.toUpperCase());
            });
        });
    });
    return variables;
};
const $1b908edd8f9b02ee$export$d7dd435d21d58c23 = (condition)=>{
    const variables = new Set();
    if (condition.variable) variables.add(`${condition.dataset ?? ""}.${condition.variable}`.toUpperCase());
    return variables;
};
const $1b908edd8f9b02ee$export$67cc1df9fc753923 = (compoundExpression)=>{
    const variables = new Set();
    compoundExpression.whereClauses?.forEach((sc)=>{
        if ((0, $ejHCH.isSubClauseWithCondition)(sc)) $1b908edd8f9b02ee$export$d7dd435d21d58c23(sc.condition).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
        else if ((0, $4FB18.isSubClauseWithCompoundExpression)(sc)) $1b908edd8f9b02ee$export$67cc1df9fc753923(sc.compoundExpression).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
        else if ((0, $9QVTJ.isSubClauseWithReference)(sc)) $1b908edd8f9b02ee$export$a30ae6c413e0164b(sc.subClauseId).forEach((variable)=>{
            variables.add(variable.toUpperCase());
        });
    });
    return variables;
};
const $1b908edd8f9b02ee$export$53eb125b3e27834d = (whereClause)=>{
    if ((0, $cTgGQ.isWhereClauseWithCondition)(whereClause)) return $1b908edd8f9b02ee$export$d7dd435d21d58c23(whereClause.condition);
    else return $1b908edd8f9b02ee$export$67cc1df9fc753923(whereClause.compoundExpression);
};
const $1b908edd8f9b02ee$export$a30ae6c413e0164b = (subClauseId)=>{
    return new Set([
        `ARS_REF: ${subClauseId.toUpperCase()}`
    ]);
};

});


parcelRegister("6QtZu", function(module, exports) {

$parcel$export(module.exports, "arsl_applyDroppedSortColumns", function () { return $f088106a4070b9f0$export$52c25efc7e3e10fd; });
parcelRequire("4Sj6S");
var $f4xry = parcelRequire("f4xry");

var $idzk5 = parcelRequire("idzk5");
const $f088106a4070b9f0$export$52c25efc7e3e10fd = (state, action)=>{
    const targetColumnVars = state.bodyData.arsListingColumns.find((column)=>column.id === action.colId)?.variables;
    if (!targetColumnVars) return state;
    /* Get jsonPayload - should be ArsSidebarItemVariable[] */ try {
        const jsonData = JSON.parse(action.jsonPayload).data;
        if (!jsonData || !Array.isArray(jsonData) || !jsonData.length || jsonData.some((item)=>!(0, $f4xry.isArsSidebarItemData)(item) || item.kind !== "variable")) return state;
        const newSortVars = jsonData.map((item)=>({
                id: crypto.randomUUID(),
                dataset: item.dropItem.dataset,
                variable: item.dropItem.name,
                variableType: (0, $idzk5.ArsListingVariableEnum).HiddenSortAscending
            }));
        const newVariables = [
            ...targetColumnVars.slice(0, action.variableIndex),
            ...newSortVars,
            ...targetColumnVars.slice(action.variableIndex)
        ];
        const newColumns = state.bodyData.arsListingColumns.map((column)=>column.id === action.colId ? {
                ...column,
                variables: newVariables
            } : column);
        const newState = {
            ...state,
            bodyData: {
                ...state.bodyData,
                arsListingColumns: newColumns
            },
            changed: true
        };
        // Check new datasets
        if (newSortVars.some((ds)=>!state.datasets.has(ds.dataset))) newState.datasets = new Set([
            ...state.datasets,
            ...newSortVars.map((v)=>v.dataset)
        ]);
        return newState;
    } catch  {
        return state;
    }
};

});

parcelRegister("cWSYP", function(module, exports) {

$parcel$export(module.exports, "arsl_cellUpdate", function () { return $d115f8934f06e006$export$a5610229829d3479; });

var $idzk5 = parcelRequire("idzk5");
const $d115f8934f06e006$export$a5610229829d3479 = (state, action)=>{
    const targetColumn = state.bodyData.arsListingColumns.find((col)=>col.id === action.colId);
    if (!targetColumn) return state;
    /* Update from a header cell */ if (action.rowId === (0, $idzk5.HEADER_ROW_ID)) {
        if (state.settings.tlfViewMode.value === "ANNOTATIONS") return state;
        const updatedColumn = {
            ...targetColumn,
            headerText: action.value
        };
        return {
            ...state,
            changed: true,
            bodyData: {
                ...state.bodyData,
                arsListingColumns: state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? updatedColumn : col)
            }
        };
    }
    /* Update from a body cell */ const updatedColumn = {
        ...targetColumn
    };
    /* Update to annotations */ if (state.settings.tlfViewMode.value === "ANNOTATIONS") updatedColumn.resultPattern = state.settings.editorProps.getTextFromT(action.value).join("\n");
    else {
        /* Update to disable pattern */ const rowIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === action.rowId);
        /* Update a the only displayPattern in the column if it's the first row and the column has a single displayPattern */ if (updatedColumn.displayPattern.length === 1) {
            if (rowIndex <= 0) updatedColumn.displayPattern = [
                action.value
            ];
            else {
                /* Change to a displayPattern array */ const displayPatternArray = new Array(state.bodyData.arsBodyRows.length).fill(updatedColumn.displayPattern[0]);
                displayPatternArray[rowIndex] = action.value;
                updatedColumn.displayPattern = displayPatternArray;
            }
        } else {
            /* Update existing displayPattern array */ const displayPatternArray = [
                ...updatedColumn.displayPattern
            ];
            /* Extend the array if the rowIndex is greater than the current length */ while(rowIndex >= displayPatternArray.length)displayPatternArray.push(...updatedColumn.displayPattern);
            displayPatternArray[rowIndex] = action.value;
            updatedColumn.displayPattern = displayPatternArray;
        }
    }
    /* Create new array */ const updatedColumns = state.bodyData.arsListingColumns.map((col)=>col.id === action.colId ? updatedColumn : col);
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: updatedColumns
        }
    };
};

});

parcelRegister("2HIuc", function(module, exports) {

$parcel$export(module.exports, "arsl_changeSent", function () { return $6d1bd66ea42ac7c9$export$448e6498526c95f7; });
const $6d1bd66ea42ac7c9$export$448e6498526c95f7 = (state)=>({
        ...state,
        changed: false
    });

});

parcelRegister("iDVtL", function(module, exports) {

$parcel$export(module.exports, "arsl_columnUpdate", function () { return $3667533cf3bc9432$export$15b3baa4a4604709; });
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");

var $gHAR7 = parcelRequire("gHAR7");
const $3667533cf3bc9432$export$15b3baa4a4604709 = (state, action)=>{
    const ix = state.bodyData.arsListingColumns.findIndex((col)=>col.id === action.colId);
    if (ix === -1) return state;
    const dataPath = `/bodyData/arsListingColumns/${ix}`;
    const newColumn = {
        ...state.bodyData.arsListingColumns[ix],
        ...action.column
    };
    const newState = (0, $67RwR.mutateByPath)(state, dataPath, newColumn);
    // Check new datasets
    const actionDatasets = (0, $gHAR7.datasetsFromColumns)([
        newColumn
    ]);
    const newDatasets = new Set([
        ...state.datasets,
        ...actionDatasets
    ]);
    if (newDatasets.size > state.datasets.size) newState.datasets = newDatasets;
    return {
        ...newState,
        changed: true
    };
};

});

parcelRegister("4nqNm", function(module, exports) {

$parcel$export(module.exports, "arsl_loadData", function () { return $4d2f29a1cb6b2efd$export$38ae57f74bddbb6f; });

var $gHAR7 = parcelRequire("gHAR7");
const $4d2f29a1cb6b2efd$export$38ae57f74bddbb6f = (state, action)=>({
        ...state,
        bodyData: action.bodyData,
        datasets: (0, $gHAR7.datasetsFromColumns)(action.bodyData.arsListingColumns),
        changed: false
    });

});

parcelRegister("89klF", function(module, exports) {

$parcel$export(module.exports, "arsl_removeColumn", function () { return $01bb5f00908a941b$export$8746c262b165b4d4; });

var $gHAR7 = parcelRequire("gHAR7");
const $01bb5f00908a941b$export$8746c262b165b4d4 = (state, action)=>{
    if (state.bodyData.arsListingColumns.length <= 1) return state;
    const newState = {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: state.bodyData.arsListingColumns.filter((column)=>column.id !== action.colId)
        }
    };
    // Refresh datasets list
    newState.datasets = (0, $gHAR7.datasetsFromColumns)(newState.bodyData.arsListingColumns);
    return newState;
};

});

parcelRegister("9EWDE", function(module, exports) {

$parcel$export(module.exports, "arsl_removeRow", function () { return $c1368996644e87c6$export$4e03b044ac474182; });
const $c1368996644e87c6$export$4e03b044ac474182 = (state, action)=>state.bodyData.arsBodyRows.length <= 1 ? state : {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: state.bodyData.arsBodyRows.filter((row)=>row.id !== action.rowId)
        }
    };

});

parcelRegister("edvwv", function(module, exports) {

$parcel$export(module.exports, "arsl_setColumns", function () { return $8ccecacb485b6396$export$d4ed0c6524d30911; });

var $gHAR7 = parcelRequire("gHAR7");
const $8ccecacb485b6396$export$d4ed0c6524d30911 = (state, action)=>({
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: action.columns.slice(0, 20)
        },
        datasets: (0, $gHAR7.datasetsFromColumns)(action.columns)
    });

});

parcelRegister("fQ8Jd", function(module, exports) {

$parcel$export(module.exports, "arsl_setRowHeight", function () { return $5e607e2936e69458$export$75b17e304e06698f; });
const $5e607e2936e69458$export$75b17e304e06698f = (state, action)=>({
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsBodyRows: state.bodyData.arsBodyRows.map((row)=>row.id === action.rowId ? {
                    ...row,
                    rowHeight: action.rowHeight
                } : row)
        }
    });

});

parcelRegister("aMsSQ", function(module, exports) {

$parcel$export(module.exports, "arsl_setTlfViewMode", function () { return $70a874ee6ea8cd33$export$5067cd37822e11d6; });
const $70a874ee6ea8cd33$export$5067cd37822e11d6 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            tlfViewMode: action.tlfViewMode
        }
    });

});

parcelRegister("1pBNO", function(module, exports) {

$parcel$export(module.exports, "arsl_setVariableFilter", function () { return $8554fd6bea6ca77a$export$b057419fc26ea6ca; });
const $8554fd6bea6ca77a$export$b057419fc26ea6ca = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            variableFilter: action.variableFilter
        }
    });

});

parcelRegister("3OeHo", function(module, exports) {

$parcel$export(module.exports, "arsl_setViewColumnPropertiesId", function () { return $fa8a1edd086442e4$export$4f117c9059f03748; });
const $fa8a1edd086442e4$export$4f117c9059f03748 = (state, action)=>({
        ...state,
        settings: {
            ...state.settings,
            viewColumnPropertiesId: action.colId
        }
    });

});

parcelRegister("487WA", function(module, exports) {

$parcel$export(module.exports, "arsl_updateScaffold", function () { return $556b83dc3271a729$export$78274a534fcede62; });

var $5za9D = parcelRequire("5za9D");
const $556b83dc3271a729$export$78274a534fcede62 = (state, action)=>({
        ...state,
        calculatedTableRows: action.calculatedTableRows,
        scaffoldModel: (0, $5za9D.buildScaffoldFromCalculatedRows)(action.calculatedTableRows, state.settings.editorProps)
    });

});
parcelRegister("5za9D", function(module, exports) {

$parcel$export(module.exports, "buildScaffoldFromCalculatedRows", function () { return $6c2ea2ab8a4ffee6$export$abf95200d511c1a0; });

var $lWi18 = parcelRequire("lWi18");

var $idzk5 = parcelRequire("idzk5");
const $6c2ea2ab8a4ffee6$export$abf95200d511c1a0 = (calculatedTableRows, editorDefns)=>{
    const scaffoldModel = (0, $lWi18.buildArsTableScaffoldModel)(calculatedTableRows, editorDefns);
    const rows = scaffoldModel.rows.map((row)=>{
        const isHeader = row.id === (0, $idzk5.HEADER_ROW_ID) || row.type === "header";
        return {
            id: row.id,
            height: row.height,
            rowGroupNumber: isHeader ? 0 : 1,
            rowNumber: row.rowNumber,
            type: isHeader ? "header" : "body"
        };
    });
    return {
        cellData: scaffoldModel.cellData,
        columns: scaffoldModel.columns,
        headerColSpans: scaffoldModel.headerColSpans,
        rows: rows
    };
};

});


parcelRegister("bcylU", function(module, exports) {

$parcel$export(module.exports, "arsListingZoneColorResolver", function () { return $470970f2f463b23b$export$5b89438c23ec2281; });

var $idzk5 = parcelRequire("idzk5");
/**
 * All header drop zones grouped into a single set for use with the empty column header.
 * When there are no existing columns the entire cell acts as one drop target.
 */ const $470970f2f463b23b$var$ALL_HEADER_ZONES = [
    ...(0, $idzk5.LEFT_HEADER_ZONES),
    ...(0, $idzk5.CENTRE_HEADER_ZONES),
    ...(0, $idzk5.RIGHT_HEADER_ZONES),
    ...(0, $idzk5.BOTTOM_HEADER_ZONES)
];
/**
 * Drop-zone colours used for each header placement action.
 */ const $470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS = {
    left: "var(--bs-primary)",
    centre: "var(--bs-primary)",
    right: "var(--bs-primary)",
    bottom: "var(--bs-primary)"
};
/**
 * Builds a colour resolution result for one grouped header action.
 *
 * @param color - Highlight colour for the grouped action.
 * @param zone - Active drop zone.
 * @param groupedZones - Zones belonging to the same action.
 * @returns Zone highlight result with sibling zones included.
 */ const $470970f2f463b23b$var$buildGroupedHeaderZoneResult = (color, zone, groupedZones)=>{
    return {
        color: color,
        additionalHighlightedZones: groupedZones.filter((groupedZone)=>groupedZone !== zone)
    };
};
const $470970f2f463b23b$export$5b89438c23ec2281 = ({ rowId: rowId, colId: colId, zone: zone })=>{
    if (rowId !== (0, $idzk5.HEADER_ROW_ID)) return {
        color: null,
        additionalHighlightedZones: []
    };
    if (colId === (0, $idzk5.EMPTY_HEADER_COL_ID)) return $470970f2f463b23b$var$buildGroupedHeaderZoneResult($470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS.left, zone, $470970f2f463b23b$var$ALL_HEADER_ZONES);
    if ((0, $idzk5.LEFT_HEADER_ZONES).includes(zone)) return $470970f2f463b23b$var$buildGroupedHeaderZoneResult($470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS.left, zone, (0, $idzk5.LEFT_HEADER_ZONES));
    if ((0, $idzk5.RIGHT_HEADER_ZONES).includes(zone)) return $470970f2f463b23b$var$buildGroupedHeaderZoneResult($470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS.right, zone, (0, $idzk5.RIGHT_HEADER_ZONES));
    if ((0, $idzk5.BOTTOM_HEADER_ZONES).includes(zone)) return $470970f2f463b23b$var$buildGroupedHeaderZoneResult($470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS.bottom, zone, (0, $idzk5.BOTTOM_HEADER_ZONES));
    return $470970f2f463b23b$var$buildGroupedHeaderZoneResult($470970f2f463b23b$var$HEADER_ZONE_GROUP_COLORS.centre, zone, (0, $idzk5.CENTRE_HEADER_ZONES));
};

});


parcelRegister("4iFpV", function(module, exports) {

$parcel$export(module.exports, "arsl_addBlankColumn", function () { return $d0f43dc6601596d6$export$33d9c547b1d61026; });

var $idzk5 = parcelRequire("idzk5");
const $d0f43dc6601596d6$export$33d9c547b1d61026 = (state, action)=>{
    const newColumn = {
        id: action.colId,
        columnWidth: (0, $idzk5.ARSL_DEFAULT_COLUMN_WIDTH),
        displayPattern: [
            state.settings.editorProps.blankT
        ],
        headerText: state.settings.editorProps.blankT,
        resultPattern: "",
        variables: []
    };
    const newColumns = [
        ...state.bodyData.arsListingColumns.slice(0, action.colIx),
        newColumn,
        ...state.bodyData.arsListingColumns.slice(action.colIx)
    ];
    return {
        ...state,
        changed: true,
        bodyData: {
            ...state.bodyData,
            arsListingColumns: newColumns
        }
    };
};

});




parcelRegister("h3Wl0", function(module, exports) {

$parcel$export(module.exports, "ArsListingAddRowButton", function () { return $41d9df321318ec9f$export$9a89baf7ce95c149; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $41d9df321318ec9f$export$9a89baf7ce95c149 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state || state.settings.disabled) return null;
    const lastRowId = state.bodyData.arsBodyRows[state.bodyData.arsBodyRows.length - 1].id;
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "ars-listing-add-row-button",
        title: "Add default row",
        role: "button",
        tabIndex: 0,
        onClick: ()=>{
            dispatch({
                operation: (0, $idzk5.ARSL_ADD_ROW),
                rowId: lastRowId,
                type: "default"
            });
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
            "aria-label": "Add row"
        })
    });
};
$41d9df321318ec9f$export$9a89baf7ce95c149.displayName = "ArsListingAddRowButton";

});

parcelRegister("awLZy", function(module, exports) {

$parcel$export(module.exports, "ArsListingCellEditorProps", function () { return $260ea9684d516178$export$fe981243cbee0d02; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");
var $jwDoS = parcelRequire("jwDoS");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");

var $9KN4s = parcelRequire("9KN4s");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $260ea9684d516178$export$33da031833176af6 = ({ id: id, colId: colId, rowId: rowId, value: value })=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state || !colId || !rowId) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    const isHeaderRow = rowId === (0, $idzk5.HEADER_ROW_ID);
    const column = state.bodyData.arsListingColumns.find((col)=>col.id === colId);
    if (!column) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    const textJustification = value.justification;
    const editorProps = state.settings.editorProps;
    const Editor = editorProps.Editor;
    const isAnnotationsView = state.settings.tlfViewMode.value === "ANNOTATIONS";
    const displayValue = value.displayContent;
    const annotationValue = value.annotationContent;
    const disabled = state.settings.disabled || value.disabled || state.settings.tlfViewMode.value === "ANNOTATIONS" && isHeaderRow || state.bodyData.arsBodyRows.find((row)=>row.id === rowId)?.ellipsis;
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        style: {
            paddingLeft: value.inlineIndent ? `${value.inlineIndent}em` : undefined
        },
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9KN4s))).cell,
            disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($9KN4s))).disabled : ""
        ]),
        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
            id: id,
            decimalAlignPercent: column.decimalAlignPercent,
            editable: !disabled,
            pending: state.changed,
            setValue: (newValue)=>{
                dispatch({
                    operation: (0, $idzk5.ARSL_CELL_UPDATE),
                    rowId: rowId,
                    colId: colId,
                    value: newValue
                });
            },
            textAlignment: textJustification,
            value: isAnnotationsView ? editorProps.textToT(annotationValue) : displayValue ?? // istanbul ignore next
            editorProps.blankT
        })
    });
};
$260ea9684d516178$export$33da031833176af6.displayName = "ArsListingCell";
const $260ea9684d516178$export$fe981243cbee0d02 = (tProps)=>({
        Editor: $260ea9684d516178$export$33da031833176af6,
        blankT: {
            annotationContent: "",
            cellType: (0, $k9YO2.ArsTableCellType).DataCell,
            columnId: "",
            columnIndex: -1,
            dataPath: "",
            displayContent: tProps.textToT(""),
            justification: (0, $k9YO2.ArsTextJustification).Default,
            rowId: "",
            targetType: "data"
        },
        getTextFromT: (cellValue)=>{
            const cellDisplay = cellValue.displayContent;
            return tProps.getTextFromT(cellDisplay);
        },
        isT: (value)=>{
            return (0, $12Lyj.isObjectRecord)(value) && "annotationContent" in value && (0, $jwDoS.isString)(value.annotationContent) && "cellType" in value && Object.values((0, $k9YO2.ArsTableCellType)).includes(value.cellType) && "dataPath" in value && (0, $jwDoS.isString)(value.dataPath) && "displayContent" in value && tProps.isT(value.displayContent);
        },
        joinTintoBlock: (cellValues)=>{
            const displayContents = cellValues.map((cv)=>cv.displayContent);
            return {
                annotationContent: cellValues.map((cv)=>cv.annotationContent).join("\n"),
                cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                columnId: cellValues[0]?.columnId ?? // istanbul ignore next
                "",
                columnIndex: cellValues[0]?.columnIndex ?? // istanbul ignore next
                -1,
                dataPath: cellValues[0]?.dataPath ?? // istanbul ignore next
                "",
                displayContent: tProps.joinTintoBlock(displayContents),
                justification: cellValues[0]?.justification ?? // istanbul ignore next
                (0, $k9YO2.ArsTextJustification).Default,
                rowId: cellValues[0]?.rowId ?? // istanbul ignore next
                "",
                targetType: "data"
            };
        },
        replaceTextInT: (cellValue, oldPhrase, newPhrase)=>{
            return {
                ...cellValue,
                displayContent: tProps.replaceTextInT(cellValue.displayContent, oldPhrase, newPhrase.displayContent)
            };
        },
        splitTintoLines: (cellValue)=>{
            const displayContent = cellValue.displayContent;
            const splitDisplay = tProps.splitTintoLines(displayContent);
            return splitDisplay.map((line)=>({
                    annotationContent: cellValue.annotationContent,
                    cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                    columnId: cellValue.columnId,
                    columnIndex: cellValue.columnIndex,
                    dataPath: cellValue.dataPath,
                    displayContent: line,
                    justification: cellValue.justification,
                    rowId: cellValue.rowId,
                    targetType: "data"
                }));
        },
        textToT: (text)=>({
                annotationContent: "",
                cellType: (0, $k9YO2.ArsTableCellType).DataCell,
                columnId: "",
                columnIndex: -1,
                dataPath: "",
                displayContent: tProps.textToT(text),
                rowId: "",
                justification: (0, $k9YO2.ArsTextJustification).Default,
                targetType: "data"
            })
    });

});
parcelRegister("9KN4s", function(module, exports) {

$parcel$export(module.exports, "arsListingColumnPropertiesEditor", function () { return $719e796696bffd49$export$530e747465b29b1a; }, function (v) { return $719e796696bffd49$export$530e747465b29b1a = v; });
$parcel$export(module.exports, "cell", function () { return $719e796696bffd49$export$e2e1361cdc35271d; }, function (v) { return $719e796696bffd49$export$e2e1361cdc35271d = v; });
$parcel$export(module.exports, "columnVariablesHolder", function () { return $719e796696bffd49$export$30859f03d3fe0786; }, function (v) { return $719e796696bffd49$export$30859f03d3fe0786 = v; });
$parcel$export(module.exports, "disabled", function () { return $719e796696bffd49$export$683472f6198a076e; }, function (v) { return $719e796696bffd49$export$683472f6198a076e = v; });
$parcel$export(module.exports, "variableDropSortTarget", function () { return $719e796696bffd49$export$67c494eca312b214; }, function (v) { return $719e796696bffd49$export$67c494eca312b214 = v; });
$parcel$export(module.exports, "variableDropSortTargetActive", function () { return $719e796696bffd49$export$b5e1d054d0a23f64; }, function (v) { return $719e796696bffd49$export$b5e1d054d0a23f64 = v; });
$parcel$export(module.exports, "variableProperties", function () { return $719e796696bffd49$export$94c7ae51d7c1a64d; }, function (v) { return $719e796696bffd49$export$94c7ae51d7c1a64d = v; });
$parcel$export(module.exports, "variablePropertiesDeleteButton", function () { return $719e796696bffd49$export$c4d39b54c987408b; }, function (v) { return $719e796696bffd49$export$c4d39b54c987408b = v; });
$parcel$export(module.exports, "variablePropertiesLabel", function () { return $719e796696bffd49$export$667005cb11d04864; }, function (v) { return $719e796696bffd49$export$667005cb11d04864 = v; });
$parcel$export(module.exports, "variablePropertiesTypeHolder", function () { return $719e796696bffd49$export$abaca76971a02943; }, function (v) { return $719e796696bffd49$export$abaca76971a02943 = v; });
$parcel$export(module.exports, "variablePropertiesTypeOption", function () { return $719e796696bffd49$export$1412b2356b50248a; }, function (v) { return $719e796696bffd49$export$1412b2356b50248a = v; });
$parcel$export(module.exports, "variablePropertiesTypeSelect", function () { return $719e796696bffd49$export$6498b5ed1a142206; }, function (v) { return $719e796696bffd49$export$6498b5ed1a142206 = v; });
var $719e796696bffd49$export$530e747465b29b1a;
var $719e796696bffd49$export$e2e1361cdc35271d;
var $719e796696bffd49$export$30859f03d3fe0786;
var $719e796696bffd49$export$683472f6198a076e;
var $719e796696bffd49$export$67c494eca312b214;
var $719e796696bffd49$export$b5e1d054d0a23f64;
var $719e796696bffd49$export$94c7ae51d7c1a64d;
var $719e796696bffd49$export$c4d39b54c987408b;
var $719e796696bffd49$export$667005cb11d04864;
var $719e796696bffd49$export$abaca76971a02943;
var $719e796696bffd49$export$1412b2356b50248a;
var $719e796696bffd49$export$6498b5ed1a142206;
$719e796696bffd49$export$530e747465b29b1a = `mos-ArsListing-module-7zIQ-G-arsListingColumnPropertiesEditor`;
$719e796696bffd49$export$e2e1361cdc35271d = `mos-ArsListing-module-7zIQ-G-cell`;
$719e796696bffd49$export$30859f03d3fe0786 = `mos-ArsListing-module-7zIQ-G-columnVariablesHolder`;
$719e796696bffd49$export$683472f6198a076e = `mos-ArsListing-module-7zIQ-G-disabled`;
$719e796696bffd49$export$67c494eca312b214 = `mos-ArsListing-module-7zIQ-G-variableDropSortTarget`;
$719e796696bffd49$export$b5e1d054d0a23f64 = `mos-ArsListing-module-7zIQ-G-variableDropSortTargetActive`;
$719e796696bffd49$export$94c7ae51d7c1a64d = `mos-ArsListing-module-7zIQ-G-variableProperties`;
$719e796696bffd49$export$c4d39b54c987408b = `mos-ArsListing-module-7zIQ-G-variablePropertiesDeleteButton`;
$719e796696bffd49$export$667005cb11d04864 = `mos-ArsListing-module-7zIQ-G-variablePropertiesLabel`;
$719e796696bffd49$export$abaca76971a02943 = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeHolder`;
$719e796696bffd49$export$1412b2356b50248a = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeOption`;
$719e796696bffd49$export$6498b5ed1a142206 = `mos-ArsListing-module-7zIQ-G-variablePropertiesTypeSelect`;

});


parcelRegister("hBA47", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnProperties", function () { return $d2a7dc3fc4da016b$export$759167ce2a1509da; });

var $bR5nk = parcelRequire("bR5nk");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $b6GTY = parcelRequire("b6GTY");
var $31g00 = parcelRequire("31g00");
parcelRequire("aoPxa");
var $kUTy1 = parcelRequire("kUTy1");
var $aUt9N = parcelRequire("aUt9N");
var $3d5lD = parcelRequire("3d5lD");
parcelRequire("d0WZT");
var $3C4oq = parcelRequire("3C4oq");
var $2udjB = parcelRequire("2udjB");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");

var $9KN4s = parcelRequire("9KN4s");

var $atv4p = parcelRequire("atv4p");

var $7r86S = parcelRequire("7r86S");

var $9T9b1 = parcelRequire("9T9b1");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $d2a7dc3fc4da016b$export$759167ce2a1509da = ()=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state?.settings.viewColumnPropertiesId) return null;
    const colId = state?.settings.viewColumnPropertiesId;
    const colIx = state.bodyData.arsListingColumns.findIndex((col)=>col.id === colId);
    const column = colIx >= 0 ? state.bodyData.arsListingColumns[colIx] : undefined;
    if (!column) return null;
    /**
   * Update component state
   */ const handleHide = ()=>dispatch({
            operation: (0, $idzk5.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
            colId: undefined
        });
    const value = state.settings.editorProps.joinTintoBlock(column.displayPattern);
    const alignOptions = Object.entries((0, $k9YO2.ArsTextJustification)).map(([k, v])=>({
            label: k,
            value: v
        }));
    const Editor = state.settings.editorProps.Editor;
    const editorProps = {
        className: `${$9KN4s.arsListingColumnPropertiesEditor}`,
        disabled: state.settings.disabled,
        editable: true,
        resize: "vertical"
    };
    /**
   * Handle variable reordering
   *
   * @param event - Sortable list drag end event
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore else */ if (column && over !== null && over.id !== active.id) {
            const oldIndex = column.variables.findIndex((v)=>`${v.id}` === active.id);
            const newIndex = column.variables.findIndex((v)=>`${v.id}` === over.id);
            // Reorder the array
            const reorderedVariables = [
                ...column.variables
            ];
            const [movedVariable] = reorderedVariables.splice(oldIndex, 1);
            reorderedVariables.splice(newIndex, 0, movedVariable);
            dispatch({
                operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                colId: colId,
                column: {
                    variables: reorderedVariables
                }
            });
        }
    };
    /**
   * Validate that all variables in the result pattern are present
   * in the column's variables.
   *
   * @param _backEndUrl - Backend URL (not used in this validation)
   * @param value - The value to validate
   * @param _controller - Abort controller (not used in this validation)
   * @returns A promise that resolves to an IValidReturn object indicating whether the validation passed or failed
   */ const validateResultPattern = (_backEndUrl, value, _controller)=>{
        /* Use regex to find all variable references between curly braces */ const variablePattern = /\{([^}]+)\}/g;
        const matches = value.value.match(variablePattern);
        if (!matches) {
            const ret = {
                success: true,
                data: {
                    valid: true,
                    validationText: ""
                }
            };
            return Promise.resolve(ret);
        }
        const variableNamesInPattern = matches.map((match)=>match.slice(1, -1));
        /* Get the variable names from the column's variables */ const variableNamesInColumn = column.variables.map((v)=>v.variable.toLowerCase());
        /* Check if all variables in the pattern are present in the column's variables */ const missingVariables = variableNamesInPattern.filter((varName)=>!variableNamesInColumn.includes(varName.toLowerCase()));
        /* It's not good */ if (missingVariables.length > 0) {
            const ret = {
                success: true,
                data: {
                    valid: false,
                    validationText: `Missing variables: ${missingVariables.join(", ")}`
                }
            };
            return Promise.resolve(ret);
        }
        /* Everything is good */ const ret = {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
        return Promise.resolve(ret);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $b6GTY.default), {
        id: "ars-listing-column-properties",
        show: column !== undefined,
        onHide: handleHide,
        backdrop: false,
        scroll: true,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $b6GTY.default).Title, {
                    className: "d-flex flex-row justify-content-between w-100",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                            className: "d-flex flex-row align-items-left gap-1",
                            children: [
                                "Column",
                                " ",
                                colIx !== undefined ? colIx + 1 : "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7r86S.ArsListingColumnNavButtons), {
                            colIx: colIx
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Body, {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                            children: [
                                "Id: ",
                                colId
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                            id: "ars-listing-column-properties-column-width",
                            disabled: true,
                            label: "Column width",
                            labelWidth: 3,
                            value: `${column.columnWidth}`
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                            id: "ars-listing-column-properties-body-text-alignment",
                            disabled: state.settings.disabled,
                            label: "Body text alignment",
                            labelWidth: 3,
                            options: alignOptions,
                            setValue: (ret)=>dispatch({
                                    operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        bodyTextAlignment: ret
                                    }
                                }),
                            value: column.bodyTextAlignment ?? "left"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                            id: "ars-listing-column-properties-decimal-align-percent",
                            disabled: state.settings.disabled,
                            label: "Decimal align %",
                            labelWidth: 3,
                            setValue: (ret)=>{
                                const parsed = parseFloat(ret);
                                const parsedValue = isNaN(parsed) ? undefined : parsed;
                                dispatch({
                                    operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        decimalAlignPercent: parsedValue
                                    }
                                });
                            },
                            type: "number",
                            value: `${column.decimalAlignPercent ?? ""}`
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                            className: "my-1",
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                    md: 3,
                                    id: "ars-listing-column-properties-display-pattern-label",
                                    htmlFor: "ars-listing-column-properties-display-pattern",
                                    className: "form-label col-form-label",
                                    children: "Display value"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                                        ...editorProps,
                                        id: "ars-listing-column-properties-display-pattern",
                                        "aria-labelledby": "ars-listing-column-properties-display-pattern-label",
                                        decimalAlignPercent: column.decimalAlignPercent,
                                        setValue: (ret)=>{
                                            const newValue = state.settings.editorProps.splitTintoLines(ret);
                                            dispatch({
                                                operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                                colId: colId,
                                                column: {
                                                    displayPattern: newValue
                                                }
                                            });
                                        },
                                        textAlignment: column.bodyTextAlignment ?? "left",
                                        value: value
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                            className: "my-1",
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                    className: "form-label col-form-label",
                                    htmlFor: "ars-listing-column-properties-header-text",
                                    id: "ars-listing-column-properties-header-text-label",
                                    md: 3,
                                    children: "Header text"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                                        ...editorProps,
                                        id: "ars-listing-column-properties-header-text",
                                        "aria-labelledby": "ars-listing-column-properties-header-text-label",
                                        decimalAlignPercent: column.decimalAlignPercent,
                                        setValue: (ret)=>{
                                            dispatch({
                                                operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                                colId: colId,
                                                column: {
                                                    headerText: ret
                                                }
                                            });
                                        },
                                        textAlignment: column.headerTextAlignment ?? "center",
                                        value: column.headerText ?? state.settings.editorProps.blankT
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                            id: "ars-listing-column-properties-header-height",
                            disabled: true,
                            label: "Header height",
                            labelWidth: 3,
                            value: `${column.headerHeight ?? ""}`
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                            id: "ars-listing-column-properties-header-text-alignment",
                            disabled: state.settings.disabled,
                            label: "Header text alignment",
                            labelWidth: 3,
                            options: alignOptions.filter((option)=>option.value !== (0, $k9YO2.ArsTextJustification).Decimal),
                            setValue: (ret)=>dispatch({
                                    operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        headerTextAlignment: ret
                                    }
                                }),
                            value: column.headerTextAlignment ?? "left"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                            id: "ars-listing-column-properties-result-pattern",
                            disabled: state.settings.disabled,
                            label: "Result pattern",
                            labelWidth: 3,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                    colId: colId,
                                    column: {
                                        resultPattern: ret
                                    }
                                });
                            },
                            validCondition: validateResultPattern,
                            value: column.resultPattern
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "my-1",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                id: "ars-listing-column-properties-variables-label",
                                "aria-label": "Variables associated with the column",
                                className: "mt-3 form-label col-form-label",
                                htmlFor: "ars-listing-column-properties-variables",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    children: "Variables"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                className: $9KN4s.columnVariablesHolder,
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3d5lD.SortableListHolder), {
                                        id: "ars-listing-column-properties-variables",
                                        "aria-labelledby": "ars-listing-column-properties-variables-label",
                                        canMove: !state.settings.disabled,
                                        handleDragEnd: handleDragEnd,
                                        items: column.variables.map((v)=>({
                                                id: v.id,
                                                label: v.dataset,
                                                element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9T9b1.ArsListingColumnVariableProperties), {
                                                    id: v.id
                                                })
                                            }))
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $atv4p.ArsListingColumnDropSortVariableTarget), {
                                        colId: column.id,
                                        addVarIx: column.variables.length
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                                        className: "ms-2",
                                        children: "Variables dropped here will be added to the sort order"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "my-1",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                id: "ars-listing-column-properties-case-when-label",
                                "aria-label": "Complex display conditions",
                                className: "mt-3 form-label col-form-label",
                                htmlFor: "ars-listing-column-properties-case-when",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    children: "Complex display conditions"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3C4oq.CaseWhenControl), {
                                    id: "ars-listing-column-properties-case-when",
                                    "aria-labelledby": "ars-listing-column-properties-case-when-label",
                                    dataPath: `/caseWhenConditions/${column.id}`,
                                    disabled: state.settings.disabled,
                                    editorDefns: state.settings.editorProps,
                                    onChange: (ret)=>{
                                        // Update the ARS listing state to show a change has been made
                                        dispatch({
                                            operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                            colId: colId,
                                            column: {
                                                caseWhenCondition: ret
                                            }
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "my-1",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                id: "ars-listing-column-properties-filter-where-clause-label",
                                "aria-label": "Filter where clause",
                                className: "mt-3 form-label col-form-label",
                                htmlFor: "ars-listing-column-properties-filter-where-clause",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    children: "Filter where clause"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2udjB.WhereClauseInput), {
                                    dataPath: `/arsListingColumns/${column.id}/filterWhereClause`,
                                    disabled: state.settings.disabled,
                                    onChange: (ret)=>{
                                        dispatch({
                                            operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                            colId: colId,
                                            column: {
                                                filterWhereClause: ret ?? undefined
                                            }
                                        });
                                    },
                                    value: column.filterWhereClause
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$d2a7dc3fc4da016b$export$759167ce2a1509da.displayName = "ArsListingColumnProperties";

});
parcelRegister("iPQyT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db65c31b19960708$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $db65c31b19960708$var$Container = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$db65c31b19960708$var$Container.displayName = 'Container';
var $db65c31b19960708$export$2e2bcd8739ae039 = $db65c31b19960708$var$Container;

});

parcelRegister("b6GTY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816188a7dc149291$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $1aaBO = parcelRequire("1aaBO");

var $i1VQA = parcelRequire("i1VQA");

var $spJKX = parcelRequire("spJKX");

var $8nXch = parcelRequire("8nXch");

var $bE9uK = parcelRequire("bE9uK");

var $6hqfT = parcelRequire("6hqfT");

var $3hz2c = parcelRequire("3hz2c");

var $4KFS5 = parcelRequire("4KFS5");

var $3TdJJ = parcelRequire("3TdJJ");

var $lI9MC = parcelRequire("lI9MC");

var $dz672 = parcelRequire("dz672");

var $ihhAo = parcelRequire("ihhAo");

var $bR5nk = parcelRequire("bR5nk");
"use client";
function $816188a7dc149291$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3hz2c.default), {
        ...props
    });
}
function $816188a7dc149291$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bE9uK.default), {
        ...props
    });
}
const $816188a7dc149291$var$Offcanvas = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $spJKX.useRef)();
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $spJKX.useState)(false);
    const handleHide = (0, $i1VQA.default)(onHide);
    const hideResponsiveOffcanvas = (0, $1aaBO.default)(responsive || 'xs', 'up');
    (0, $spJKX.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $spJKX.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $ihhAo.default)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $ihhAo.getSharedManager)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $spJKX.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4KFS5.default).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8nXch.default), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $816188a7dc149291$var$DialogTransition,
                    backdropTransition: $816188a7dc149291$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$816188a7dc149291$var$Offcanvas.displayName = 'Offcanvas';
var $816188a7dc149291$export$2e2bcd8739ae039 = Object.assign($816188a7dc149291$var$Offcanvas, {
    Body: (0, $6hqfT.default),
    Header: (0, $3TdJJ.default),
    Title: (0, $lI9MC.default)
});

});
parcelRegister("1aaBO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d8ef44e891c5ad8$export$2e2bcd8739ae039; });

var $6uHE5 = parcelRequire("6uHE5");

var $spJKX = parcelRequire("spJKX");
function $0d8ef44e891c5ad8$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $spJKX.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $6uHE5.default)(query, window);
    }
    return useBreakpoint;
}
const $0d8ef44e891c5ad8$var$useBreakpoint = $0d8ef44e891c5ad8$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $0d8ef44e891c5ad8$export$2e2bcd8739ae039 = $0d8ef44e891c5ad8$var$useBreakpoint;

});
parcelRegister("6uHE5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ba76682ee3b1c29$export$2e2bcd8739ae039; });

var $dHq7H = parcelRequire("dHq7H");

var $spJKX = parcelRequire("spJKX");
const $4ba76682ee3b1c29$var$matchersByWindow = new WeakMap();
const $4ba76682ee3b1c29$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $4ba76682ee3b1c29$var$matchersByWindow.get(targetWindow) || new Map();
    $4ba76682ee3b1c29$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $4ba76682ee3b1c29$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $4ba76682ee3b1c29$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $spJKX.useState)(()=>mql ? mql.matches : false);
    (0, $dHq7H.default)(()=>{
        let mql = $4ba76682ee3b1c29$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $4ba76682ee3b1c29$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}

});
parcelRegister("dHq7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f938e0aee885f60$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $9f938e0aee885f60$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $9f938e0aee885f60$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $9f938e0aee885f60$export$2e2bcd8739ae039 = $9f938e0aee885f60$var$isDOM || $9f938e0aee885f60$var$isReactNative ? (0, $spJKX.useLayoutEffect) : (0, $spJKX.useEffect);

});



parcelRegister("6hqfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4928b26558c819aa$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $4928b26558c819aa$var$OffcanvasBody = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$4928b26558c819aa$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $4928b26558c819aa$export$2e2bcd8739ae039 = $4928b26558c819aa$var$OffcanvasBody;

});

parcelRegister("3hz2c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $263e22c1b56b7b57$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $iu3Vz = parcelRequire("iu3Vz");

var $feFtK = parcelRequire("feFtK");

var $fSJNV = parcelRequire("fSJNV");

var $jVveE = parcelRequire("jVveE");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $263e22c1b56b7b57$var$transitionStyles = {
    [(0, $iu3Vz.ENTERING)]: 'show',
    [(0, $iu3Vz.ENTERED)]: 'show'
};
const $263e22c1b56b7b57$var$OffcanvasToggling = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jVveE.default), {
        ref: ref,
        addEndListener: (0, $fSJNV.default),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $feFtK.getChildRef)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $spJKX.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, children.props.className, (status === (0, $iu3Vz.ENTERING) || status === (0, $iu3Vz.EXITING)) && `${bsPrefix}-toggling`, $263e22c1b56b7b57$var$transitionStyles[status])
            })
    });
});
$263e22c1b56b7b57$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $263e22c1b56b7b57$export$2e2bcd8739ae039 = $263e22c1b56b7b57$var$OffcanvasToggling;

});

parcelRegister("3TdJJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d5129f359fb730f$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $dq88X = parcelRequire("dq88X");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $2d5129f359fb730f$var$OffcanvasHeader = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dq88X.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$2d5129f359fb730f$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $2d5129f359fb730f$export$2e2bcd8739ae039 = $2d5129f359fb730f$var$OffcanvasHeader;

});

parcelRegister("lI9MC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fce54bc7c98dc594$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $hQinx = parcelRequire("hQinx");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $fce54bc7c98dc594$var$DivStyledAsH5 = (0, $hQinx.default)('h5');
const $fce54bc7c98dc594$var$OffcanvasTitle = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $fce54bc7c98dc594$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$fce54bc7c98dc594$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $fce54bc7c98dc594$export$2e2bcd8739ae039 = $fce54bc7c98dc594$var$OffcanvasTitle;

});


parcelRegister("atv4p", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnDropSortVariableTarget", function () { return $8a1be1a5f0a1ddf0$export$3ada8fdbf5078124; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");
parcelRequire("5SMPf");
var $3tKzd = parcelRequire("3tKzd");

var $9KN4s = parcelRequire("9KN4s");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $8a1be1a5f0a1ddf0$export$3ada8fdbf5078124 = ({ colId: colId, addVarIx: addVarIx })=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    const [isBeingDraggedOver, setIsBeingDraggedOver] = (0, $spJKX.useState)(false);
    if (!state) return null;
    /**
   * Handles the drop event when sort columns are dropped onto the target div.
   *
   * @param e - Drag event
   */ const handleDrop = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        const jsonPayLoad = e.dataTransfer.getData("application/json");
        setIsBeingDraggedOver(false);
        dispatch({
            operation: (0, $idzk5.ARSL_APPLY_DROPPED_SORT_COLUMNS),
            colId: colId,
            variableIndex: addVarIx,
            jsonPayload: jsonPayLoad
        });
    };
    /**
   * Handles the drag over event to allow dropping of sort columns onto the target div.
   *
   * @param e - Drag event
   */ const handleDragOver = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "copy";
        setIsBeingDraggedOver(true);
    };
    /**
   * Handle the drag leave event to reset the drag over state when the dragged item leaves the target div.
   *
   * @param e - Drag event
   */ const handleDragLeave = (e)=>{
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setIsBeingDraggedOver(false);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: `ars-listing-column-drop-sort-variable-target-${colId}-${addVarIx}`,
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9KN4s))).variableDropSortTarget,
            isBeingDraggedOver ? (0, (/*@__PURE__*/$parcel$interopDefault($9KN4s))).variableDropSortTargetActive : ""
        ]),
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        onDragLeave: handleDragLeave
    });
};
$8a1be1a5f0a1ddf0$export$3ada8fdbf5078124.displayName = "ArsListingColumnDropSortVariableTarget";

});

parcelRegister("7r86S", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnNavButtons", function () { return $d2b06226951cf081$export$4b0139ab3db60234; });

var $bR5nk = parcelRequire("bR5nk");

var $02Kog = parcelRequire("02Kog");
var $2d6Pt = parcelRequire("2d6Pt");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $d2b06226951cf081$export$4b0139ab3db60234 = ({ colIx: colIx })=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state || !state.settings.viewColumnPropertiesId) return null;
    const totalColumns = state.bodyData.arsListingColumns.length;
    const leftDest = colIx > 0 ? state.bodyData.arsListingColumns[colIx - 1].id : null;
    const rightDest = colIx < totalColumns - 1 ? state.bodyData.arsListingColumns[colIx + 1].id : null;
    /**
   * Change properties view column with a dispatch action
   *
   * @param id - New column id
   */ const setNewviewColumnPropertiesId = (id)=>{
        dispatch({
            operation: (0, $idzk5.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
            colId: id
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $02Kog.default), {
                style: leftDest ? {
                    cursor: "pointer",
                    color: "black"
                } : {
                    cursor: "not-allowed",
                    color: "grey"
                },
                "aria-label": "Previous column",
                title: "Previous column",
                onClick: ()=>leftDest && setNewviewColumnPropertiesId(leftDest)
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {
                style: rightDest ? {
                    cursor: "pointer",
                    color: "black"
                } : {
                    cursor: "not-allowed",
                    color: "grey"
                },
                "aria-label": "Next column",
                title: "Next column",
                onClick: ()=>rightDest && setNewviewColumnPropertiesId(rightDest)
            })
        ]
    });
};
$d2b06226951cf081$export$4b0139ab3db60234.displayName = "ArsListingColumnNavButtons";

});
parcelRegister("02Kog", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00842c2cb2cc141d$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $00842c2cb2cc141d$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $00842c2cb2cc141d$var$_extends() {
    return $00842c2cb2cc141d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $00842c2cb2cc141d$var$_extends.apply(null, arguments);
}
function $00842c2cb2cc141d$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $00842c2cb2cc141d$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $00842c2cb2cc141d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $00842c2cb2cc141d$var$ChevronLeft = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $00842c2cb2cc141d$var$_objectWithoutProperties(_ref, $00842c2cb2cc141d$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $00842c2cb2cc141d$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chevron-left',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
    }));
});
$00842c2cb2cc141d$var$ChevronLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $00842c2cb2cc141d$export$2e2bcd8739ae039 = $00842c2cb2cc141d$var$ChevronLeft;

});


parcelRegister("9T9b1", function(module, exports) {

$parcel$export(module.exports, "ArsListingColumnVariableProperties", function () { return $2a57cb21ac3d3d46$export$192cf663e2a3ea11; });

var $bR5nk = parcelRequire("bR5nk");

var $av9bi = parcelRequire("av9bi");

var $9KN4s = parcelRequire("9KN4s");

var $atv4p = parcelRequire("atv4p");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $2a57cb21ac3d3d46$export$192cf663e2a3ea11 = ({ id: id })=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    if (!state?.settings.viewColumnPropertiesId) return null;
    const colId = state?.settings.viewColumnPropertiesId;
    const colIx = state.bodyData.arsListingColumns.findIndex((col)=>col.id === colId);
    const column = colIx >= 0 ? state.bodyData.arsListingColumns[colIx] : undefined;
    const varIx = column?.variables.findIndex((v)=>v.id === id) ?? -1;
    const variable = varIx >= 0 ? column?.variables[varIx] : undefined;
    if (!column || !variable) return null;
    /**
   * Handles the change of variable type in the select dropdown.
   *
   * @param e - Select change event
   */ const handleChange = (e)=>{
        const newVariableType = e.target.value;
        const newVariable = {
            ...variable,
            variableType: newVariableType
        };
        const newVariables = column?.variables.map((v)=>v.id === variable.id ? newVariable : v);
        dispatch({
            operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
            colId: colId,
            column: {
                variables: newVariables
            }
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: $9KN4s.variableProperties,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $atv4p.ArsListingColumnDropSortVariableTarget), {
                colId: column.id,
                addVarIx: varIx
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                className: $9KN4s.variablePropertiesLabel,
                children: [
                    variable.dataset,
                    ".",
                    variable.variable
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                className: $9KN4s.variablePropertiesTypeHolder,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("select", {
                        className: $9KN4s.variablePropertiesTypeSelect,
                        "aria-label": "Variable type",
                        value: variable.variableType,
                        onChange: handleChange,
                        children: Object.entries((0, $idzk5.ArsListingVariableEnum)).map(([key, value])=>/*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                                value: value,
                                className: $9KN4s.variablePropertiesTypeOption,
                                children: key.replace(/([A-Z])/g, (match, capital, offset)=>offset > 0 ? ` ${capital.toLowerCase()}` : match)
                            }, value))
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: $9KN4s.variablePropertiesDeleteButton,
                        role: "button",
                        tabIndex: 0,
                        title: "Delete variable",
                        onClick: ()=>{
                            const newVariables = column?.variables.filter((v)=>v.id !== variable.id);
                            dispatch({
                                operation: (0, $idzk5.ARSL_COLUMN_UPDATE),
                                colId: colId,
                                column: {
                                    variables: newVariables
                                }
                            });
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
                            "aria-label": "Delete variable"
                        })
                    })
                ]
            })
        ]
    });
};
$2a57cb21ac3d3d46$export$192cf663e2a3ea11.displayName = "ArsListingColumnVariableProperties";

});


parcelRegister("lTMQV", function(module, exports) {

$parcel$export(module.exports, "ArsListingContextMenuProvider", function () { return $1ca66955a12d0b60$export$d924be207432a3dc; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $8yjow = parcelRequire("8yjow");
parcelRequire("5VyPu");
var $k9YO2 = parcelRequire("k9YO2");

var $4rIQR = parcelRequire("4rIQR");

var $idzk5 = parcelRequire("idzk5");
const $1ca66955a12d0b60$export$d924be207432a3dc = ({ children: children, selectedColumns: selectedColumns })=>{
    const { state: state, dispatch: dispatch } = (0, $4rIQR.useArsListing)();
    const [contextMenuTarget, setContextMenuTarget] = (0, $spJKX.useState)(undefined);
    if (!state) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children
    });
    /**
   * Function to blur active element
   */ const blurActiveElement = ()=>{
        /* istanbul ignore else */ if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    };
    /**
   * Captures scaffold row and column ids before opening the context menu.
   *
   * @param event - Context menu event fired from scaffold cells
   */ const handleScaffoldContextMenuCapture = (event)=>{
        setContextMenuTarget((0, $8yjow.getScaffoldContextMenuTarget)(event.target));
    };
    /**
   * Dispatches text-alignment changes for the selected context-menu column.
   *
   * @param alignment - Desired text alignment
   * @param isHeader - Whether alignment applies to header cells
   */ const handleChangeTextAlignment = (alignment, isHeader)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) dispatch({
            operation: (0, $idzk5.ARSL_ALIGN_TEXT),
            colId: contextMenuTarget.colId,
            alignment: alignment,
            isHeader: isHeader
        });
    };
    /**
   * Adds a blank column at at the index provided
   *
   * @param before - whether to insert the column before or after the current column
   */ const handleAddBlankColumn = (before)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) {
            const ix = state.bodyData.arsListingColumns.findIndex((col)=>col.id === contextMenuTarget.colId) + (before ? 0 : 1);
            dispatch({
                operation: (0, $idzk5.ARSL_ADD_BLANK_COLUMN),
                colIx: ix,
                colId: crypto.randomUUID()
            });
        }
    };
    /**
   * Adds a new row after the currently targeted context-menu row.
   *
   * @param ellipsis - Whether the inserted row is an ellipsis row
   */ const handleAddRow = (ellipsis)=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget) dispatch({
            operation: (0, $idzk5.ARSL_ADD_ROW),
            rowId: contextMenuTarget.rowId,
            type: ellipsis ? "ellipsis" : "default"
        });
    };
    /**
   * Removes the currently targeted body row when allowed.
   */ const handleRemoveRow = ()=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget && state.bodyData.arsBodyRows.length > 1) {
            const bodyRowIndex = state.bodyData.arsBodyRows.findIndex((row)=>row.id === contextMenuTarget.rowId);
            /* istanbul ignore else */ if (bodyRowIndex !== -1) dispatch({
                operation: (0, $idzk5.ARSL_REMOVE_ROW),
                rowId: contextMenuTarget.rowId
            });
        }
    };
    /**
   * Removes the currently targeted column when allowed.
   */ const handleRemoveColumn = ()=>{
        blurActiveElement();
        /* istanbul ignore else */ if (!state.settings.disabled && contextMenuTarget && selectedColumns.length > 1) dispatch({
            operation: (0, $idzk5.ARSL_REMOVE_COLUMN),
            colId: contextMenuTarget.colId
        });
    };
    const isHeaderRow = contextMenuTarget?.rowId === (0, $idzk5.HEADER_ROW_ID);
    const isRowActionDisabled = state.settings.disabled || contextMenuTarget === undefined || isHeaderRow;
    const contextMenuColumn = state.bodyData.arsListingColumns.find((col)=>col.id === contextMenuTarget?.colId);
    const arslContextMenuItems = [
        {
            label: "Show column properties",
            disabled: state.settings.disabled || contextMenuTarget === undefined,
            action: ()=>{
                dispatch({
                    operation: (0, $idzk5.ARSL_SET_VIEW_COLUMN_PROPERTIES_ID),
                    colId: contextMenuTarget?.colId
                });
            }
        },
        {
            label: "Justify text",
            disabled: state.settings.disabled || contextMenuTarget === undefined,
            group: [
                {
                    label: "Left",
                    action: ()=>handleChangeTextAlignment((0, $k9YO2.ArsTextJustification).Left, isHeaderRow),
                    selected: isHeaderRow ? contextMenuColumn?.headerTextAlignment === (0, $k9YO2.ArsTextJustification).Left : contextMenuColumn?.bodyTextAlignment === (0, $k9YO2.ArsTextJustification).Left
                },
                {
                    label: "Centre",
                    action: ()=>handleChangeTextAlignment((0, $k9YO2.ArsTextJustification).Center, isHeaderRow),
                    selected: isHeaderRow ? contextMenuColumn?.headerTextAlignment === (0, $k9YO2.ArsTextJustification).Center : contextMenuColumn?.bodyTextAlignment === (0, $k9YO2.ArsTextJustification).Center
                },
                ...contextMenuTarget?.rowId !== (0, $idzk5.HEADER_ROW_ID) ? [
                    {
                        label: "Decimal",
                        action: ()=>handleChangeTextAlignment((0, $k9YO2.ArsTextJustification).Decimal, isHeaderRow),
                        selected: contextMenuColumn?.bodyTextAlignment === (0, $k9YO2.ArsTextJustification).Decimal
                    }
                ] : [],
                {
                    label: "Right",
                    action: ()=>handleChangeTextAlignment((0, $k9YO2.ArsTextJustification).Right, isHeaderRow),
                    selected: isHeaderRow ? contextMenuColumn?.headerTextAlignment === (0, $k9YO2.ArsTextJustification).Right : contextMenuColumn?.bodyTextAlignment === (0, $k9YO2.ArsTextJustification).Right
                }
            ]
        },
        {
            label: "Add blank column",
            disabled: state.settings.disabled,
            group: [
                {
                    label: "Before",
                    action: ()=>handleAddBlankColumn(true)
                },
                {
                    label: "After",
                    action: ()=>handleAddBlankColumn(false)
                }
            ]
        },
        {
            label: "Add row below",
            disabled: isRowActionDisabled,
            group: [
                {
                    label: "Display",
                    action: ()=>handleAddRow(false)
                },
                {
                    label: "Ellipsis",
                    action: ()=>handleAddRow(true)
                }
            ]
        },
        {
            label: "Remove row",
            action: handleRemoveRow,
            disabled: isRowActionDisabled || state.bodyData.arsBodyRows.length <= 1
        },
        {
            label: "Remove column",
            action: handleRemoveColumn,
            disabled: state.settings.disabled || contextMenuTarget === undefined || selectedColumns.length <= 1
        }
    ];
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
        menuItems: arslContextMenuItems,
        onContextMenuCapture: handleScaffoldContextMenuCapture,
        children: children
    });
};
$1ca66955a12d0b60$export$d924be207432a3dc.displayName = "ArsListingContextMenuProvider";

});



parcelRegister("2N5BV", function(module, exports) {

$parcel$export(module.exports, "isArsListingBody", function () { return $f1a8eefaf1460235$export$c2d867a9a9d41163; });

var $12Lyj = parcelRequire("12Lyj");

var $ifFUN = parcelRequire("ifFUN");

var $6bHL1 = parcelRequire("6bHL1");
/**
 * Validates if a value is an array of ArsListingColumn objects.
 *
 * @param value - Unknown value to validate
 * @param isT - Optional type guard for the generic type T used in the columns' displayPattern and headerText
 * @returns True when value is an array of valid ArsListingColumn objects
 */ function $f1a8eefaf1460235$var$isColumnsArray(value, isT) {
    if (!Array.isArray(value)) return false;
    /* istanbul ignore next Check for valid columns array structure */ for (const item of value){
        if (!(0, $ifFUN.isArsListingColumn)(item, isT)) return false;
    }
    return true;
}
/**
 * Validates if a value is an array of ArsListingRow objects.
 *
 * @param value - Unknown value to validate
 * @returns True when value is an array of valid ArsListingRow objects
 */ function $f1a8eefaf1460235$var$isRowsArray(value) {
    if (!Array.isArray(value)) return false;
    /* istanbul ignore next Check for valid rows array structure */ for (const item of value){
        if (!(0, $6bHL1.isArsListingRow)(item)) return false;
    }
    return true;
}
const $f1a8eefaf1460235$export$c2d867a9a9d41163 = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (!$f1a8eefaf1460235$var$isColumnsArray(obj.arsListingColumns, isT)) return false;
    if (!$f1a8eefaf1460235$var$isRowsArray(obj.arsBodyRows)) return false;
    if (obj.dataSubsetId !== undefined && typeof obj.dataSubsetId !== "string") return false;
    // Everything is good
    return true;
};

});
parcelRegister("ifFUN", function(module, exports) {

$parcel$export(module.exports, "isArsListingColumn", function () { return $cdb64c3997b0ab19$export$d1bb9cd001fd45c; });

var $k9YO2 = parcelRequire("k9YO2");
parcelRequire("1ZdiT");
var $2x5bU = parcelRequire("2x5bU");
var $12Lyj = parcelRequire("12Lyj");
var $6dqyB = parcelRequire("6dqyB");

var $5VRwu = parcelRequire("5VRwu");
const $cdb64c3997b0ab19$var$arsTextJustifications = new Set(Object.values((0, $k9YO2.ArsTextJustification)));
/**
 * Validates if a value is a valid ArsTextAlignment.
 *
 * @param value - Unknown value to validate
 * @returns True when value is one of the ArsTextJustification enum values
 */ function $cdb64c3997b0ab19$var$isArsTextJustification(value) {
    return typeof value === "string" && $cdb64c3997b0ab19$var$arsTextJustifications.has(value);
}
const $cdb64c3997b0ab19$export$d1bb9cd001fd45c = (obj, isT = (value)=>typeof value === "string")=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.columnWidth !== "number") return false;
    if (![
        "number",
        "undefined"
    ].includes(typeof obj.decimalAlignPercent)) return false;
    if (obj.displayPattern === undefined || obj.displayPattern === null) return false;
    if (Array.isArray(obj.displayPattern) && obj.displayPattern.some((item)=>!isT(item))) return false;
    if (!Array.isArray(obj.displayPattern) && !isT(obj.displayPattern)) return false;
    if (!isT(obj.headerText)) return false;
    if (typeof obj.resultPattern !== "string") return false;
    // Check optional properties if present
    if (obj.bodyTextAlignment !== undefined && !$cdb64c3997b0ab19$var$isArsTextJustification(obj.bodyTextAlignment)) return false;
    if (obj.headerHeight !== undefined && typeof obj.headerHeight !== "number") return false;
    if (obj.headerTextAlignment !== undefined && !$cdb64c3997b0ab19$var$isArsTextJustification(obj.headerTextAlignment)) return false;
    if (obj.variables !== undefined && (!Array.isArray(obj.variables) || obj.variables.some((v)=>!(0, $5VRwu.isArsListingVariable)(v)))) return false;
    if (obj.caseWhenCondition !== undefined && !(0, $2x5bU.isCaseWhenCondition)(obj.caseWhenCondition, isT)) return false;
    if (obj.filterWhereClause !== undefined && !(0, $6dqyB.isWhereClause)(obj.filterWhereClause)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("5VRwu", function(module, exports) {

$parcel$export(module.exports, "isArsListingVariable", function () { return $30c4cd19049ef78c$export$af65bf5b59bad20b; });
parcelRequire("1ZdiT");
var $12Lyj = parcelRequire("12Lyj");
const $30c4cd19049ef78c$export$af65bf5b59bad20b = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    if (typeof obj.id !== "string") return false;
    if (typeof obj.dataset !== "string") return false;
    if (typeof obj.variable !== "string") return false;
    if (typeof obj.variableType !== "string" || ![
        "displayOnly",
        "group",
        "hidden-sort-ascending",
        "hidden-sort-descending"
    ].includes(obj.variableType)) return false;
    // Everything is good
    return true;
};

});


parcelRegister("6bHL1", function(module, exports) {

$parcel$export(module.exports, "isArsListingRow", function () { return $d206c5c73c874cd2$export$ade33056063d8e64; });

var $12Lyj = parcelRequire("12Lyj");
const $d206c5c73c874cd2$export$ade33056063d8e64 = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check required properties
    if (typeof obj.id !== "string") return false;
    if (typeof obj.rowHeight !== "number") return false;
    if (typeof obj.ellipsis !== "boolean") return false;
    // Everything is good
    return true;
};

});




parcelRegister("cunuO", function(module, exports) {
$parcel$export(module.exports, "AsupInternalBlock", function () { return (parcelRequire("cCgYJ")).AsupInternalBlock; });
$parcel$export(module.exports, "AibLineType", function () { return (parcelRequire("1ol4Z")).AibLineType; });
parcelRequire("1Woed");
parcelRequire("7sfn7");
parcelRequire("gnchS");
parcelRequire("91ezc");
parcelRequire("bHSoI");
parcelRequire("cCgYJ");
parcelRequire("1Ah8z");
parcelRequire("gqmnM");
parcelRequire("1jkD3");
parcelRequire("1ol4Z");
parcelRequire("1m4YF");
parcelRequire("54Hvb");
parcelRequire("lNTEu");

});
parcelRegister("1Woed", function(module, exports) {

$parcel$export(module.exports, "AddLineButton", function () { return $72d9b64b4c09cc45$export$d727bc568a614a1d; });

var $bR5nk = parcelRequire("bR5nk");

var $biia9 = parcelRequire("biia9");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");

var $1m4YF = parcelRequire("1m4YF");
const $72d9b64b4c09cc45$export$d727bc568a614a1d = ({ aifid: aifid, lineAbove: lineAbove = false })=>{
    const ADD_LINE_BUTTON_TOP_OFFSET = -18;
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = ix > -1 ? state.lines[ix] : null;
    const canAddLineBelow = !state.disabled && state.lines.length < state.maxLines && thisLine?.addBelow;
    return !thisLine || state.maxLines === 1 ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${state.id}-${ix}-add-line`,
        iconName: lineAbove || canAddLineBelow ? "aioxPlus" : "aioxCircle",
        tipText: "Add line",
        style: lineAbove ? {
            position: "absolute",
            top: ADD_LINE_BUTTON_TOP_OFFSET,
            marginLeft: 0
        } : {},
        onClick: ()=>{
            if (canAddLineBelow || lineAbove) {
                const line = (0, $1m4YF.newBlockLine)(state.defaultType, state.editorProps.blankT);
                line.canChangeType = state.canChangeType;
                dispatch({
                    operation: (0, $gqmnM.ADD_LINE),
                    ix: lineAbove ? ix : ix + 1,
                    line: line
                });
            }
        }
    });
};
$72d9b64b4c09cc45$export$d727bc568a614a1d.displayName = "AddLineButton";

});
parcelRegister("1Ah8z", function(module, exports) {

$parcel$export(module.exports, "BlockContextProvider", function () { return $0a12386641e88c68$export$703b49f54ceaa9bf; });
$parcel$export(module.exports, "useBlockContext", function () { return $0a12386641e88c68$export$41562f444cfa7f67; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $gqmnM = parcelRequire("gqmnM");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0a12386641e88c68$var$BlockContext = /*#__PURE__*/ (0, $spJKX.createContext)({
    state: (0, $gqmnM.defaultBlockState),
    dispatch: // istanbul ignore next
    ()=>{}
});
/**
 * Provides block context
 *
 * @param props - Destructured parameter object
 * @param props.initialState - Initial block state used to seed the provider
 * @param props.children - React children to render within the provider
 * @param props.onChange - Callback invoked with the updated lines when the block state is pushed
 */ const $0a12386641e88c68$var$BlockContextProviderInner = ({ initialState: initialState, children: children, onChange: onChange })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $gqmnM.blockReducer), initialState);
    // Update or push state
    (0, $spJKX.useEffect)(()=>{
        if (!(0, $eBlbF.isEqual)(state, initialState)) {
            if (state.changed) {
                onChange(state.lines);
                dispatch({
                    operation: (0, $gqmnM.CHANGE_PUSHED)
                });
            } else dispatch({
                operation: (0, $gqmnM.SET_STATE),
                ...initialState
            });
        }
    }, [
        initialState,
        onChange,
        state
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($0a12386641e88c68$var$BlockContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
const $0a12386641e88c68$export$703b49f54ceaa9bf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).memo($0a12386641e88c68$var$BlockContextProviderInner);
function $0a12386641e88c68$export$41562f444cfa7f67() {
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)($0a12386641e88c68$var$BlockContext);
    return {
        state: state,
        dispatch: dispatch
    };
}
$0a12386641e88c68$var$BlockContextProviderInner.displayName = "BlockContextProvider";

});
parcelRegister("gqmnM", function(module, exports) {

$parcel$export(module.exports, "defaultBlockState", function () { return $6323d8cabb9bec27$export$946ce68b1b7b58; });
$parcel$export(module.exports, "ADD_LINE", function () { return $6323d8cabb9bec27$export$7d6abe52e266964b; });
$parcel$export(module.exports, "CHANGE_PUSHED", function () { return $6323d8cabb9bec27$export$b485dc6ccc0d10c4; });
$parcel$export(module.exports, "REMOVE_LINE", function () { return $6323d8cabb9bec27$export$31431e5ed4c8ceb7; });
$parcel$export(module.exports, "SET_STATE", function () { return $6323d8cabb9bec27$export$4a4b66c21ebf4dc9; });
$parcel$export(module.exports, "UPDATE_BLOCK_CELL", function () { return $6323d8cabb9bec27$export$3127bc3075cb06b2; });
$parcel$export(module.exports, "UPDATE_LINE", function () { return $6323d8cabb9bec27$export$128e89fa5a52e2d5; });
$parcel$export(module.exports, "blockReducer", function () { return $6323d8cabb9bec27$export$4fa1eaa1ae0609f5; });
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $1ol4Z = parcelRequire("1ol4Z");
const $6323d8cabb9bec27$export$946ce68b1b7b58 = {
    id: "default-block-id",
    canAddFirstRow: false,
    canChangeType: false,
    changed: false,
    changedBlocks: [],
    disabled: true,
    editorProps: (0, $hcEI9.defaultEditorDefns),
    externalSingles: [],
    defaultType: (0, $1ol4Z.AibLineType).leftOnly,
    lines: [],
    lineStyle: {},
    minLines: 1,
    maxLines: 10,
    noComments: false,
    noTrafficLights: false
};
const $6323d8cabb9bec27$export$7d6abe52e266964b = "ADD_LINE";
const $6323d8cabb9bec27$export$b485dc6ccc0d10c4 = "CHANGE_PUSHED";
const $6323d8cabb9bec27$export$31431e5ed4c8ceb7 = "REMOVE_LINE";
const $6323d8cabb9bec27$export$4a4b66c21ebf4dc9 = "SET_STATE";
const $6323d8cabb9bec27$export$3127bc3075cb06b2 = "UPDATE_BLOCK_CELL";
const $6323d8cabb9bec27$export$128e89fa5a52e2d5 = "UPDATE_LINE";
const $6323d8cabb9bec27$export$4fa1eaa1ae0609f5 = (state, action)=>{
    // Do nothing if disabled
    if (state.disabled && action.operation !== $6323d8cabb9bec27$export$4a4b66c21ebf4dc9) return state;
    // Create new state
    let newState = {
        ...state
    };
    const errCheck = [];
    // Check action type
    switch(action.operation){
        case $6323d8cabb9bec27$export$7d6abe52e266964b:
            if (action.ix < 0 || action.ix > newState.lines.length) errCheck.push("ADD_LINE: index out of bounds");
            if (newState.lines.length >= state.maxLines) errCheck.push("ADD_LINE: max lines reached");
            if (errCheck.length > 0) break;
            /* istanbul ignore else */ if (!newState.lines.some((line)=>line.aifid === action.line.aifid)) {
                const lineWithTrafficLight = {
                    ...action.line,
                    coreTrafficLight: "ChangedUnknown"
                };
                newState.lines = [
                    ...newState.lines.slice(0, action.ix),
                    lineWithTrafficLight,
                    ...newState.lines.slice(action.ix)
                ];
            }
            newState.changed = true;
            break;
        case $6323d8cabb9bec27$export$b485dc6ccc0d10c4:
            newState.changed = false;
            break;
        case $6323d8cabb9bec27$export$31431e5ed4c8ceb7:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.aifid);
                if (ix === -1) errCheck.push("REMOVE_LINE: line not found");
                if (newState.lines.length <= state.minLines) errCheck.push("REMOVE_LINE: min lines reached");
                if (errCheck.length > 0) break;
                newState.lines = [
                    ...newState.lines.slice(0, ix),
                    ...newState.lines.slice(ix + 1)
                ];
                newState.changed = true;
                break;
            }
        case $6323d8cabb9bec27$export$4a4b66c21ebf4dc9:
            newState = {
                ...newState,
                id: action.id,
                canChangeType: action.canChangeType,
                changed: false,
                changedBlocks: action.changedBlocks,
                defaultType: action.defaultType,
                disabled: action.disabled,
                editorProps: action.editorProps,
                externalSingles: action.externalSingles,
                lineStyle: action.lineStyle,
                lines: action.lines,
                maxLines: action.maxLines,
                minLines: action.minLines,
                noTrafficLights: action.noTrafficLights
            };
            break;
        case $6323d8cabb9bec27$export$3127bc3075cb06b2:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.aifid);
                if (ix === -1) {
                    errCheck.push("UPDATE_BLOCK_CELL: line not found");
                    break;
                }
                const updatedLine = {
                    ...newState.lines[ix],
                    [action.position]: action.cellContent,
                    coreTrafficLight: "ChangedUnknown"
                };
                newState.lines = [
                    ...newState.lines.slice(0, ix),
                    updatedLine,
                    ...newState.lines.slice(ix + 1)
                ];
                newState.changed = true;
                break;
            }
        case $6323d8cabb9bec27$export$128e89fa5a52e2d5:
            {
                const ix = newState.lines.findIndex((line)=>line.aifid === action.line.aifid);
                if (ix === -1) {
                    errCheck.push("UPDATE_LINE: line not found");
                    break;
                }
                newState.lines[ix] = action.line;
                newState.changed = true;
                break;
            }
    }
    if (errCheck.length > 0) {
        console.warn(errCheck);
        return state;
    }
    return newState;
};

});
parcelRegister("1ol4Z", function(module, exports) {

$parcel$export(module.exports, "AibLineType", function () { return $3e062907bc13b77f$export$38e3d412c155a865; });
var $3e062907bc13b77f$export$38e3d412c155a865 = /*#__PURE__*/ function(AibLineType) {
    AibLineType["leftOnly"] = "Left only";
    AibLineType["centerOnly"] = "Center only";
    AibLineType["leftAndRight"] = "Left and Right";
    AibLineType["leftCenterAndRight"] = "Left, Center and Right";
    return AibLineType;
}({});

});



parcelRegister("1m4YF", function(module, exports) {

$parcel$export(module.exports, "newBlockLine", function () { return $7d7c658e5019b3c2$export$cf8236c8de36cfbf; });

var $1ol4Z = parcelRequire("1ol4Z");
const $7d7c658e5019b3c2$export$cf8236c8de36cfbf = (lineType, blankT)=>{
    const ret = {
        aifid: crypto.randomUUID(),
        lineType: lineType,
        left: [
            (0, $1ol4Z.AibLineType).leftOnly,
            (0, $1ol4Z.AibLineType).leftAndRight,
            (0, $1ol4Z.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        center: [
            (0, $1ol4Z.AibLineType).centerOnly,
            (0, $1ol4Z.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        right: [
            (0, $1ol4Z.AibLineType).leftAndRight,
            (0, $1ol4Z.AibLineType).leftCenterAndRight
        ].includes(lineType) ? blankT : null,
        addBelow: true,
        canEdit: true,
        canMove: true,
        canRemove: true,
        canChangeType: true,
        coreTrafficLight: "BlankNotEvaluated"
    };
    return ret;
};

});


parcelRegister("7sfn7", function(module, exports) {

$parcel$export(module.exports, "AibBlock", function () { return $8f8db9d922cf25ef$export$b8aa0f45b9cca988; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $gnchS = parcelRequire("gnchS");

var $1Ah8z = parcelRequire("1Ah8z");
const $8f8db9d922cf25ef$export$b8aa0f45b9cca988 = ()=>{
    const { state: state } = (0, $1Ah8z.useBlockContext)();
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: state.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibBlock,
        children: state.lines.map((l, li)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $gnchS.AibLineDisplay), {
                aifid: l.aifid
            }, `${li}-${l.aifid}`))
    });
};
$8f8db9d922cf25ef$export$b8aa0f45b9cca988.displayName = "AibBlock";

});
parcelRegister("gnchS", function(module, exports) {

$parcel$export(module.exports, "AibLineDisplay", function () { return $b18125f93c2cf6da$export$51ec7c783e305e71; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $6r4yf = parcelRequire("6r4yf");

var $3tKzd = parcelRequire("3tKzd");

var $1Woed = parcelRequire("1Woed");

var $91ezc = parcelRequire("91ezc");

var $bHSoI = parcelRequire("bHSoI");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");

var $1jkD3 = parcelRequire("1jkD3");

var $1ol4Z = parcelRequire("1ol4Z");

var $1m4YF = parcelRequire("1m4YF");

var $lNTEu = parcelRequire("lNTEu");
const $b18125f93c2cf6da$export$51ec7c783e305e71 = ({ aifid: aifid })=>{
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = ix > -1 ? state.lines[ix] : null;
    const [showOptions, setShowOptions] = (0, $spJKX.useState)(false);
    const displayType = thisLine?.lineType;
    const isFirstLine = ix === 0;
    const canAddLineAbove = isFirstLine && state.canAddFirstRow && state.lines.length < state.maxLines && !state.disabled;
    const canAddLineBelow = !state.disabled && state.lines.length < state.maxLines && thisLine?.addBelow;
    const divClassName = [
        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItem,
        displayType && [
            (0, $1ol4Z.AibLineType).leftOnly,
            (0, $1ol4Z.AibLineType).centerOnly
        ].includes(displayType) ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).one : displayType && [
            (0, $1ol4Z.AibLineType).leftAndRight
        ].includes(displayType) ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).two : (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).three
    ].filter((c)=>c !== "").join(" ");
    const lineCoreTrafficLight = (0, $spJKX.useMemo)(()=>{
        if (state && !state.noTrafficLights && thisLine && thisLine.coreTrafficLight && thisLine.coreTrafficLight !== "BlankNotEvaluated") {
            const tl = new (0, $6r4yf.MosaicTrafficLightClass)(thisLine.coreTrafficLight, "-4px", "-8px");
            return tl.element;
        } else return null;
    }, [
        state,
        thisLine
    ]);
    return !thisLine || !displayType ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        id: `${state.id}-${ix}`,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLine,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bHSoI.AibOptionsWindow), {
                aifid: aifid,
                showWindow: showOptions,
                onClose: ()=>setShowOptions(false)
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).calcSize,
                menuItems: [
                    {
                        label: "Show line options",
                        action: ()=>{
                            const focusDummy = document.createElement("input");
                            document.body.appendChild(focusDummy);
                            focusDummy.focus();
                            focusDummy.remove();
                            setShowOptions(true);
                        }
                    },
                    {
                        label: "Insert line",
                        group: [
                            {
                                label: "Above",
                                action: ()=>{
                                    const line = (0, $1m4YF.newBlockLine)(state.defaultType, state.editorProps.blankT);
                                    line.canChangeType = state.canChangeType;
                                    dispatch({
                                        operation: (0, $gqmnM.ADD_LINE),
                                        ix: ix,
                                        line: line
                                    });
                                },
                                disabled: !canAddLineAbove
                            },
                            {
                                label: "Below",
                                action: ()=>{
                                    const line = (0, $1m4YF.newBlockLine)(state.defaultType, state.editorProps.blankT);
                                    line.canChangeType = state.canChangeType;
                                    dispatch({
                                        operation: (0, $gqmnM.ADD_LINE),
                                        ix: ix + 1,
                                        line: line
                                    });
                                },
                                disabled: !canAddLineBelow
                            }
                        ]
                    },
                    {
                        label: "Delete line",
                        action: ()=>{
                            dispatch({
                                operation: (0, $gqmnM.REMOVE_LINE),
                                aifid: aifid
                            });
                        },
                        disabled: state.lines.length <= state.minLines || !thisLine.canRemove
                    }
                ],
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineItemHolder,
                    style: {
                        ...state.lineStyle
                    },
                    children: [
                        lineCoreTrafficLight,
                        [
                            (0, $1ol4Z.AibLineType).leftOnly,
                            (0, $1ol4Z.AibLineType).leftAndRight,
                            (0, $1ol4Z.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: divClassName,
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1jkD3.CellEditor), {
                                aifid: aifid,
                                position: "left"
                            })
                        }),
                        [
                            (0, $1ol4Z.AibLineType).centerOnly,
                            (0, $1ol4Z.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: (0, $3tKzd.classMerge)([
                                divClassName,
                                (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexGrow1
                            ]),
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1jkD3.CellEditor), {
                                aifid: aifid,
                                position: "center"
                            })
                        }),
                        [
                            (0, $1ol4Z.AibLineType).leftAndRight,
                            (0, $1ol4Z.AibLineType).leftCenterAndRight
                        ].includes(displayType) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: divClassName,
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1jkD3.CellEditor), {
                                aifid: aifid,
                                position: "right"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibLineButtons,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1Woed.AddLineButton), {
                        aifid: aifid
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lNTEu.RemoveLineButton), {
                        aifid: aifid
                    }),
                    canAddLineAbove && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1Woed.AddLineButton), {
                        aifid: aifid,
                        lineAbove: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $91ezc.AibLineTrafficLight), {
                aifid: aifid
            }),
            ix === state.lines.length - 1 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $91ezc.AibLineTrafficLight), {
                aifid: "final",
                top: "20px"
            })
        ]
    });
};
$b18125f93c2cf6da$export$51ec7c783e305e71.displayName = "AibLineDisplay";

});
parcelRegister("6r4yf", function(module, exports) {

$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7; });
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return $2eaa11fd57e0cb0a$export$34a14484f72df501; });

var $bR5nk = parcelRequire("bR5nk");

var $6ygGZ = parcelRequire("6ygGZ");
var $9XiLm = parcelRequire("9XiLm");
const $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7 = {
    none: {
        displayLabel: "",
        cssColor: "",
        icon: null
    },
    FromScratch: {
        displayLabel: "Created without using an existing template or basic layout",
        cssColor: "#3C1053",
        icon: (0, $9XiLm.default)
    },
    FromBasicLayout: {
        displayLabel: "Created using a basic layout",
        cssColor: "#D0006F",
        icon: (0, $9XiLm.default)
    },
    FromTemplate: {
        displayLabel: "Created using an existing template",
        cssColor: "#68D2DF",
        icon: (0, $9XiLm.default)
    },
    RedError: {
        displayLabel: "The shell includes changes that strongly deviate from the AZSOL template. Please submit a change request in CRYSTAL. In case of any questions, please reach out to the AZSOL team.",
        cssColor: "#FF0000",
        icon: (0, $9XiLm.default),
        priority: 90
    },
    AmberChangeExpected: {
        displayLabel: "A customisation is required, please follow the AZSOL General principles.",
        cssColor: "#FFA500",
        icon: (0, $9XiLm.default),
        priority: 80
    },
    GreenOk: {
        displayLabel: "OK",
        cssColor: "#008000",
        icon: (0, $9XiLm.default),
        priority: 50
    },
    GreenOverride: {
        displayLabel: "Override applied",
        cssColor: "#006400",
        icon: (0, $9XiLm.default),
        priority: 60
    },
    BlankNotEvaluated: {
        displayLabel: "Not evaluated",
        cssColor: "#808080",
        icon: (0, $9XiLm.default),
        priority: 10
    },
    ChangedUnknown: {
        displayLabel: "Changed",
        cssColor: "#FF00FF",
        icon: (0, $6ygGZ.default),
        priority: 100
    }
};
class $2eaa11fd57e0cb0a$export$34a14484f72df501 {
    /**
   * Gets the current traffic light value.
   */ get value() {
        return this._value;
    }
    /**
   * Sets the current traffic light value.
   */ set value(newValue) {
        this._value = newValue;
    }
    /**
   * Gets the display label for the current traffic light.
   */ get displayLabel() {
        return $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7[this._value].displayLabel;
    }
    /**
   * Gets the CSS colour for the current traffic light.
   */ get cssColor() {
        return $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7[this._value].cssColor;
    }
    /**
   * Gets the JSX element for rendering the traffic light icon.
   */ get element() {
        const current = $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7[this._value];
        return current.icon ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: "traffic-light",
            style: this._position === "absolute" || this._top !== "0px" && this._top !== "0" || this._left !== "0px" && this._left !== "0" ? {
                position: "relative"
            } : {
                display: "inline-block"
            },
            "aria-label": "Traffic light holder",
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(current.icon, {
                role: "alert",
                style: this._left !== "0px" && this._left !== "0" && this._top !== "0px" && this._top !== "0" ? {
                    position: "absolute",
                    left: `${this._left}`,
                    top: `${this._top}`
                } : undefined,
                title: current.displayLabel,
                "aria-label": `${this.displayLabel}`,
                color: current.cssColor
            })
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
    }
    /**
   * Creates a new traffic light instance.
   *
   * @param value - The traffic light value or array of values to determine priority
   * @param top - The top position offset for the icon
   * @param left - The left position offset for the icon
   * @param position - The CSS position property for the icon
   */ constructor(value, top = "-8px", left = "-16px", position = "relative"){
        this._value = "none";
        this._position = "relative";
        this._top = "-8px";
        this._left = "-16px";
        /* Take highest priority value if array is given */ if (Array.isArray(value)) this.value = value.reduce((highest, current)=>{
            const currentPriority = $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7[current]?.priority ?? 0;
            const highestPriority = $2eaa11fd57e0cb0a$export$e67a65ddc96bddf7[highest]?.priority ?? 0;
            return currentPriority > highestPriority ? current : highest;
        }, value[0]);
        else this.value = value;
        this._top = top;
        this._left = left;
        this._position = position;
    }
}

});
parcelRegister("6ygGZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c52ddd6191da42a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $4c52ddd6191da42a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $4c52ddd6191da42a$var$_extends() {
    return $4c52ddd6191da42a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4c52ddd6191da42a$var$_extends.apply(null, arguments);
}
function $4c52ddd6191da42a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4c52ddd6191da42a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4c52ddd6191da42a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4c52ddd6191da42a$var$QuestionOctagonFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $4c52ddd6191da42a$var$_objectWithoutProperties(_ref, $4c52ddd6191da42a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $4c52ddd6191da42a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-question-octagon-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zM5.496 6.033a.237.237 0 0 1-.24-.247C5.35 4.091 6.737 3.5 8.005 3.5c1.396 0 2.672.73 2.672 2.24 0 1.08-.635 1.594-1.244 2.057-.737.559-1.01.768-1.01 1.486v.105a.25.25 0 0 1-.25.25h-.81a.25.25 0 0 1-.25-.246l-.004-.217c-.038-.927.495-1.498 1.168-1.987.59-.444.965-.736.965-1.371 0-.825-.628-1.168-1.314-1.168-.803 0-1.253.478-1.342 1.134-.018.137-.128.25-.266.25h-.825zm2.325 6.443c-.584 0-1.009-.394-1.009-.927 0-.552.425-.94 1.01-.94.609 0 1.028.388 1.028.94 0 .533-.42.927-1.029.927"
    }));
});
$4c52ddd6191da42a$var$QuestionOctagonFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $4c52ddd6191da42a$export$2e2bcd8739ae039 = $4c52ddd6191da42a$var$QuestionOctagonFill;

});

parcelRegister("9XiLm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73f82daa1fff5cb2$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $73f82daa1fff5cb2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $73f82daa1fff5cb2$var$_extends() {
    return $73f82daa1fff5cb2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $73f82daa1fff5cb2$var$_extends.apply(null, arguments);
}
function $73f82daa1fff5cb2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $73f82daa1fff5cb2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $73f82daa1fff5cb2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $73f82daa1fff5cb2$var$StoplightsFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $73f82daa1fff5cb2$var$_objectWithoutProperties(_ref, $73f82daa1fff5cb2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $73f82daa1fff5cb2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-stoplights-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M6 0a2 2 0 0 0-2 2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v2H2c.167.5.8 1.6 2 2v1a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-1c1.2-.4 1.833-1.5 2-2h-2V8c1.2-.4 1.833-1.5 2-2h-2V4c1.2-.4 1.833-1.5 2-2h-2a2 2 0 0 0-2-2zm3.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0 4a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8 13a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    }));
});
$73f82daa1fff5cb2$var$StoplightsFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $73f82daa1fff5cb2$export$2e2bcd8739ae039 = $73f82daa1fff5cb2$var$StoplightsFill;

});


parcelRegister("91ezc", function(module, exports) {

$parcel$export(module.exports, "AibLineTrafficLight", function () { return $a29f923dc44e9a36$export$1d14acef5129c4e1; });

var $6r4yf = parcelRequire("6r4yf");

var $1Ah8z = parcelRequire("1Ah8z");
const $a29f923dc44e9a36$export$1d14acef5129c4e1 = ({ aifid: aifid, top: top = "-4px" })=>{
    const { state: state } = (0, $1Ah8z.useBlockContext)();
    // Check for traffic lights in changedBlocks (existing logic)
    const changedBlockTlValue = state.changedBlocks?.find((b)=>b.coreTrafficLight === "RedError" && (b.idAfterTrafficLightIsShown === aifid || b.idAfterTrafficLightIsShown === "" && aifid === "final"))?.coreTrafficLight;
    // Check for traffic light on the line itself
    const thisLine = state.lines.find((line)=>line.aifid === aifid);
    const lineTlValue = thisLine?.coreTrafficLight;
    // Use changedBlocks traffic light if available, otherwise use line traffic light
    const thisTlValue = changedBlockTlValue ?? (lineTlValue === "ChangedUnknown" || lineTlValue === "RedError" ? lineTlValue : "BlankNotEvaluated");
    const thisTrafficLight = !state?.noTrafficLights && thisTlValue !== "BlankNotEvaluated" ? new (0, $6r4yf.MosaicTrafficLightClass)(thisTlValue, top, "-8px").element : null;
    return !thisTrafficLight ? null : thisTrafficLight;
};
$a29f923dc44e9a36$export$1d14acef5129c4e1.displayName = "AibLineTrafficLight";

});

parcelRegister("bHSoI", function(module, exports) {

$parcel$export(module.exports, "AibOptionsWindow", function () { return $9aab6c57b4d7e8c0$export$a4434985949c680e; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $gGo2X = parcelRequire("gGo2X");

var $9zfAS = parcelRequire("9zfAS");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");

var $54Hvb = parcelRequire("54Hvb");
const $9aab6c57b4d7e8c0$export$a4434985949c680e = ({ aifid: aifid, onClose: onClose, showWindow: showWindow })=>{
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    return !thisLine ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextWindow), {
        id: `${state.id}-${ix}-options-window`,
        title: "Line options",
        visible: showWindow,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gGo2X.AioSelect), {
                    id: `${state.id}-${ix}-linetype`,
                    label: "Line type",
                    availableValues: [
                        "Left only",
                        "Center only",
                        "Left, Center and Right",
                        "Left and Right"
                    ],
                    value: thisLine.lineType,
                    setValue: !state.disabled && thisLine.canChangeType ? (ret)=>dispatch({
                            operation: (0, $gqmnM.UPDATE_LINE),
                            line: {
                                ...thisLine,
                                lineType: ret
                            }
                        }) : undefined
                })
            }),
            thisLine.lineType.toString().includes("Left") && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $54Hvb.OriginalTextEditor), {
                aifid: aifid,
                position: "left"
            }),
            thisLine.lineType.toString().includes("Center") && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $54Hvb.OriginalTextEditor), {
                aifid: aifid,
                position: "center"
            }),
            " ",
            thisLine.lineType.toString().includes("Right") && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $54Hvb.OriginalTextEditor), {
                aifid: aifid,
                position: "right"
            })
        ]
    });
};
$9aab6c57b4d7e8c0$export$a4434985949c680e.displayName = "AibOptionsWindow";

});
parcelRegister("54Hvb", function(module, exports) {

$parcel$export(module.exports, "OriginalTextEditor", function () { return $9f6ee40962bd97fb$export$d9e75a14757ff5ac; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");
const $9f6ee40962bd97fb$export$d9e75a14757ff5ac = ({ aifid: aifid, position: position })=>{
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    const thisCell = thisLine[position];
    const Editor = state.editorProps.Editor;
    const id = `${state.id}-${ix}-${position}-original-text`;
    const label = position.slice(0, 1).toUpperCase() + position.slice(1) + " text";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
                htmlFor: id,
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInputHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).borderBlackSolid
                ]),
                children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                    id: id,
                    value: thisCell,
                    editable: !state.disabled && thisLine?.canEdit,
                    allowWindowView: false,
                    allowMarkdown: false,
                    setValue: (ret)=>dispatch({
                            operation: (0, $gqmnM.UPDATE_BLOCK_CELL),
                            aifid: aifid,
                            position: position,
                            cellContent: ret
                        })
                })
            })
        ]
    });
};
$9f6ee40962bd97fb$export$d9e75a14757ff5ac.displayName = "OriginalTextEditor";

});


parcelRegister("1jkD3", function(module, exports) {

$parcel$export(module.exports, "CellEditor", function () { return $699fbe7e0c90c030$export$142345a3064ebeb3; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");
const $699fbe7e0c90c030$export$142345a3064ebeb3 = ({ aifid: aifid, position: position })=>{
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    const thisCell = thisLine[position];
    const Editor = state.editorProps.Editor;
    // Update for replacements
    const displayValue = (0, $spJKX.useMemo)(()=>{
        if (thisCell === undefined || thisCell === null) return undefined;
        let ret = (0, $eBlbF.cloneDeep)(thisCell);
        state.externalSingles.forEach((repl)=>{
            ret = state.editorProps.replaceTextInT(ret, repl.oldText, repl.newText);
        });
        return ret;
    }, [
        state.editorProps,
        state.externalSingles,
        thisCell
    ]);
    const editable = !state.disabled && thisLine?.canEdit;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
        id: `${state.id}-${ix}-${position}-text`,
        className: !editable ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aibReadOnly : "",
        editable: editable,
        preReplacedText: thisCell,
        setValue: (ret)=>dispatch({
                operation: (0, $gqmnM.UPDATE_BLOCK_CELL),
                aifid: aifid,
                position: position,
                cellContent: ret
            }),
        textAlignment: position,
        value: displayValue ?? state.editorProps.blankT,
        commentConfig: state.noComments ? undefined : {
            id: aifid,
            activeContext: "TlfItem",
            label: "New line comment",
            iconPosition: {
                top: "-2px",
                left: "-2px"
            }
        }
    });
};
$699fbe7e0c90c030$export$142345a3064ebeb3.displayName = "CellEditor";

});

parcelRegister("lNTEu", function(module, exports) {

$parcel$export(module.exports, "RemoveLineButton", function () { return $591c80fc48fa1341$export$a284800d32a54efe; });

var $bR5nk = parcelRequire("bR5nk");

var $biia9 = parcelRequire("biia9");

var $1Ah8z = parcelRequire("1Ah8z");

var $gqmnM = parcelRequire("gqmnM");
const $591c80fc48fa1341$export$a284800d32a54efe = ({ aifid: aifid })=>{
    const { state: state, dispatch: dispatch } = (0, $1Ah8z.useBlockContext)();
    const ix = state.lines.findIndex((l)=>l.aifid === aifid);
    const thisLine = state.lines[ix];
    return state.disabled || state.maxLines === 1 && state.minLines === 1 || !thisLine ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${state.id}-${ix}-remove-line`,
        iconName: state.lines.length <= state.minLines || !thisLine.canRemove ? "aioxCircleRed" : "aioxMinus",
        onClick: ()=>!state.disabled && state.lines.length > state.minLines && thisLine.canRemove && dispatch({
                operation: (0, $gqmnM.REMOVE_LINE),
                aifid: aifid
            }),
        tipText: "Remove line"
    });
};
$591c80fc48fa1341$export$a284800d32a54efe.displayName = "RemoveLineButton";

});



parcelRegister("cCgYJ", function(module, exports) {

$parcel$export(module.exports, "AsupInternalBlock", function () { return $80ef493f8249f13d$export$35969708b67f5ce6; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");

var $7sfn7 = parcelRequire("7sfn7");

var $1Ah8z = parcelRequire("1Ah8z");

var $1ol4Z = parcelRequire("1ol4Z");
const $80ef493f8249f13d$export$35969708b67f5ce6 = ({ id: id, canAddFirstRow: canAddFirstRow = false, canChangeType: canChangeType = false, changedBlocks: changedBlocks = [], defaultType: defaultType = (0, $1ol4Z.AibLineType).centerOnly, disabled: disabled = false, editorProps: editorProps, externalSingles: externalSingles = [], lineStyle: lineStyle = {}, lines: lines, maxLines: maxLines = 10, minLines: minLines = 1, noComments: noComments = false, noTrafficLights: noTrafficLights = false, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1Ah8z.BlockContextProvider), {
        initialState: {
            id: id,
            canAddFirstRow: canAddFirstRow,
            canChangeType: canChangeType,
            changed: false,
            changedBlocks: changedBlocks,
            defaultType: defaultType,
            disabled: disabled,
            editorProps: editorProps,
            externalSingles: externalSingles,
            lineStyle: lineStyle,
            lines: lines,
            maxLines: maxLines,
            minLines: minLines,
            noComments: noComments,
            noTrafficLights: noTrafficLights
        },
        onChange: onChange,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7sfn7.AibBlock), {})
    });
};
$80ef493f8249f13d$export$35969708b67f5ce6.displayName = "AsupInternalBlock";

});


parcelRegister("aEiv0", function(module, exports) {
$parcel$export(module.exports, "BeFigure", function () { return (parcelRequire("fVgC1")).BeFigure; });
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("hFJlN")).preProcessFigureInput; });
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("kTXvy")).isFigureSettingsDto; });
parcelRequire("fVgC1");
parcelRequire("89lY5");
parcelRequire("hKPkg");
parcelRequire("eP3ql");
parcelRequire("fKlTJ");

});
parcelRegister("fVgC1", function(module, exports) {

$parcel$export(module.exports, "BeFigure", function () { return $5e59f6089bcb51e8$export$ef68e6ff349d0dd2; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $gm3sK = parcelRequire("gm3sK");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("5SMPf");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $89lY5 = parcelRequire("89lY5");

var $hKPkg = parcelRequire("hKPkg");
const $5e59f6089bcb51e8$export$ef68e6ff349d0dd2 = ({ backEndUrl: backEndUrl, externalFigureRequest: externalFigureRequest, figureInput: figureInput, figureSettings: figureSettings, updateFigureInput: updateFigureInput, varNames: varNames })=>{
    const [showBeFigure, setShowBeFigure] = (0, $spJKX.useState)(false);
    const [generatedImage, setGeneratedImage] = (0, $spJKX.useState)("");
    const [requestStatus, setRequestStatus] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    /**
   * Load an image based on the current parameters
   */ const loadFigure = (0, $spJKX.useEffectEvent)(async (input)=>{
        const request = await (0, $4dL47.loadWrapper)(externalFigureRequest, input, requestStatus, setRequestStatus, backEndUrl);
        if (request?.success) startTransition(()=>setGeneratedImage(request.data));
    });
    /**
   * Reset requesting state on error click
   */ const handleErrorClick = ()=>{
        setRequestStatus({
            requesting: false,
            error: false
        });
    };
    /**
   * Figure load/reload
   */ (0, $spJKX.useEffect)(()=>{
        if (!requestStatus.error && !requestStatus.requesting) loadFigure(figureInput);
    }, [
        figureInput,
        requestStatus
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $89lY5.BeFigureContextProvider), {
        figureInput: figureInput,
        figureSettings: figureSettings,
        varNames: varNames,
        updateFigureInput: updateFigureInput,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "w-100 mt-3 d-flex justify-content-end",
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                    id: "figure-options-toggle",
                    "aria-label": "Toggle figure options",
                    variant: "secondary",
                    size: "sm",
                    onClick: ()=>setShowBeFigure(!showBeFigure),
                    className: "my-2",
                    children: [
                        showBeFigure ? "Hide" : "Show",
                        " figure options"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "d-flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "flex-grow-1 d-flex justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            className: "border border-1 border-gray-500 rounded p-2 position-relative d-flex justify-content-center align-items-center",
                            children: [
                                (requestStatus.requesting || pending) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {}),
                                requestStatus.error ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                    className: "text-center align-items-center",
                                    style: {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        minHeight: "600px"
                                    },
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("a", {
                                        className: "text-danger",
                                        onClick: handleErrorClick,
                                        role: "button",
                                        children: "Error loading figure, click to retry"
                                    })
                                }) : generatedImage ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gm3sK.default), {
                                    id: "be-image",
                                    src: generatedImage,
                                    alt: "Generated figure",
                                    style: {
                                        maxWidth: "100%",
                                        maxHeight: "600px",
                                        objectFit: "contain"
                                    }
                                }) : /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    children: "Loading..."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "d-flex justify-content-end align-items-start ms-3",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hKPkg.BeFigureOptions), {
                            show: showBeFigure
                        })
                    })
                ]
            })
        ]
    });
};
$5e59f6089bcb51e8$export$ef68e6ff349d0dd2.displayName = "BeFigure";

});
parcelRegister("gm3sK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be81630830196930$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $be81630830196930$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).bool
};
const $be81630830196930$var$Image = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $bR5nk.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$be81630830196930$var$Image.displayName = 'Image';
var $be81630830196930$export$2e2bcd8739ae039 = $be81630830196930$var$Image;

});

parcelRegister("89lY5", function(module, exports) {

$parcel$export(module.exports, "BeFigureContextProvider", function () { return $6e6839fb1028ea19$export$cd63364b4fef623c; });
$parcel$export(module.exports, "useBeFigure", function () { return $6e6839fb1028ea19$export$e384a75e65f89108; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $ipSte = parcelRequire("ipSte");

var $5NA6O = parcelRequire("5NA6O");
const $6e6839fb1028ea19$export$4b7e741aafc2baa4 = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $6e6839fb1028ea19$export$cd63364b4fef623c = ({ children: children, figureInput: figureInput, figureSettings: figureSettings, updateFigureInput: updateFigureInput, varNames: varNames })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $ipSte.figureReducer), {
        figureInput: figureInput,
        figureSettings: figureSettings,
        varNames: varNames,
        changed: false
    });
    (0, $spJKX.useEffect)(()=>{
        const eq = (0, $eBlbF.isEqual)(state.figureInput, figureInput);
        // Send changes up
        if (!eq && state.figureInput.id === figureInput.id && state.changed) {
            updateFigureInput(state.figureInput);
            dispatch({
                operation: (0, $5NA6O.FIGURE_CHANGE_SENT)
            });
        } else if (state.figureInput.id !== figureInput.id || !eq) dispatch({
            operation: (0, $5NA6O.LOAD_FIGURE_INPUT),
            figureInput: figureInput
        });
    }, [
        figureInput,
        state.changed,
        state.figureInput,
        updateFigureInput
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)($6e6839fb1028ea19$export$4b7e741aafc2baa4.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: children
    });
};
$6e6839fb1028ea19$export$cd63364b4fef623c.displayName = "BeFigureContextProvider";
const $6e6839fb1028ea19$export$e384a75e65f89108 = ()=>{
    const context = (0, $spJKX.useContext)($6e6839fb1028ea19$export$4b7e741aafc2baa4);
    return !context ? {
        state: null,
        dispatch: ()=>console.error("WARNING: Dispatch not initiated")
    } : context;
};

});
parcelRegister("ipSte", function(module, exports) {

$parcel$export(module.exports, "figureReducer", function () { return $1f26acf17599d231$export$af91632802d2877e; });

var $3ew5o = parcelRequire("3ew5o");
parcelRequire("5SMPf");
var $67RwR = parcelRequire("67RwR");
var $X1On9 = parcelRequire("X1On9");

var $2kqnu = parcelRequire("2kqnu");

var $5NA6O = parcelRequire("5NA6O");
const $1f26acf17599d231$export$af91632802d2877e = (state, action)=>{
    switch(action.operation){
        case 0, $5NA6O.ADD_DATA_GROUP:
            if (state.figureInput.dataGroups.length === action.newLength - 1) {
                const newDataGroup = {
                    id: crypto.randomUUID(),
                    dataGroupName: `DataGroup_${action.newLength}`,
                    dataGroupLabel: `Data Group ${action.newLength}`,
                    properties: (0, $2kqnu.fillPropertiesArray)(state.figureSettings.figureTypeSettings.find((ft)=>ft.value === state.figureInput.figureType)?.dataRowVars ?? [])
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        dataGroups: [
                            ...state.figureInput.dataGroups,
                            newDataGroup
                        ]
                    }
                };
            }
            return state;
        case 0, $5NA6O.ADD_PROPERTY:
            {
                const newProperty = {
                    varName: action.varName,
                    value: ""
                };
                const pointer = (0, $3ew5o.Pointer).fromJSON(action.pointer);
                const currentProperties = pointer.get(state.figureInput);
                const newProperties = [
                    ...currentProperties,
                    newProperty
                ];
                const updatedFigureInput = (0, $67RwR.mutateByPath)(state.figureInput, action.pointer, newProperties);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5NA6O.ADD_REFERENCE_LINE:
            if (state.figureInput.referenceLines.length === action.newLength - 1) {
                const newReferenceLine = {
                    id: crypto.randomUUID(),
                    properties: (0, $2kqnu.fillPropertiesArray)(state.figureSettings.figureReferenceLinesSettings)
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        referenceLines: [
                            ...state.figureInput.referenceLines,
                            newReferenceLine
                        ]
                    }
                };
            }
            return state;
        case 0, $5NA6O.ADD_REGRESSION_LINE:
            if (state.figureInput.regressionLines.length === action.newLength - 1) {
                const defaultRLSettings = state.figureSettings.figureRegressionLineSettings[0];
                const newRegressionLine = {
                    id: crypto.randomUUID(),
                    lineType: defaultRLSettings?.lineType || "linear",
                    properties: (0, $2kqnu.fillPropertiesArray)(defaultRLSettings?.parameters ?? [])
                };
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        regressionLines: [
                            ...state.figureInput.regressionLines,
                            newRegressionLine
                        ]
                    }
                };
            }
            return state;
        case 0, $5NA6O.CHANGE_REGRESSION_LINE_TYPE:
            {
                const newLineTypeSettings = state.figureSettings.figureRegressionLineSettings.find((rls)=>rls.lineType === action.lineType);
                const thisRegressionLine = (0, $3ew5o.Pointer).fromJSON(action.pointer).get(state.figureInput);
                const newRegressionLine = {
                    ...thisRegressionLine,
                    lineType: action.lineType,
                    properties: (0, $2kqnu.fillPropertiesArray)(newLineTypeSettings?.parameters ?? [], thisRegressionLine.properties)
                };
                const updatedFigureInput = (0, $67RwR.mutateByPath)(state.figureInput, action.pointer, newRegressionLine);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5NA6O.FIGURE_CHANGE_SENT:
            return {
                ...state,
                changed: false
            };
        case 0, $5NA6O.LOAD_FIGURE_INPUT:
            return {
                ...state,
                changed: false,
                figureInput: action.figureInput,
                savedFigureData: {}
            };
        case 0, $5NA6O.PATCH_FIGURE_STATE:
            {
                const updatedFigureInput = (0, $67RwR.mutateByPath)(state.figureInput, action.pointer, action.value);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5NA6O.REMOVE_FIGURE_ITEM:
            {
                const updatedFigureInput = (0, $X1On9.removeByPath)(state.figureInput, action.dataPath, action.newLength);
                return {
                    ...state,
                    changed: true,
                    figureInput: updatedFigureInput
                };
            }
        case 0, $5NA6O.SET_FIGURE_TYPE:
            {
                const oldFigureType = state.figureInput.figureType;
                const newFigureTypeSettings = state.figureSettings.figureTypeSettings.find((ft)=>ft.value === action.newValue);
                // Save current figure data before switching
                const savedFigureData = {
                    ...state.savedFigureData ?? {},
                    [oldFigureType]: {
                        figureTypeProperties: state.figureInput.figureTypeProperties,
                        dataGroups: state.figureInput.dataGroups,
                        regressionLines: state.figureInput.regressionLines,
                        axes: state.figureInput.axes
                    }
                };
                // Check if we have saved data for the new figure type
                const restoredData = savedFigureData[action.newValue];
                let dataGroups;
                let axes;
                const figureTypeProperties = (0, $2kqnu.fillPropertiesArray)(newFigureTypeSettings?.properties ?? [], restoredData?.figureTypeProperties);
                const regressionLines = restoredData?.regressionLines ?? [];
                if (restoredData?.dataGroups && restoredData.dataGroups.length > 0) // Restore saved data groups
                dataGroups = restoredData.dataGroups.map((dg)=>({
                        ...dg,
                        properties: (0, $2kqnu.fillPropertiesArray)(newFigureTypeSettings?.dataRowVars ?? [], dg.properties)
                    }));
                else {
                    // Create default data groups
                    const numberOfSeries = newFigureTypeSettings?.defaultNumberOfSeries ?? 1;
                    const defaultSeries = newFigureTypeSettings?.defaultSeries ?? [];
                    dataGroups = [];
                    for(let i = 0; i < numberOfSeries; i++){
                        const thisDefaultSeries = defaultSeries.length > 0 ? defaultSeries[i % defaultSeries.length] : undefined;
                        const defaultGroupName = thisDefaultSeries?.dataGroupName ?? "DataGroup";
                        const defaultGroupLabel = thisDefaultSeries?.dataGroupLabel ?? "Data Group";
                        const newDataGroup = {
                            id: crypto.randomUUID(),
                            dataGroupName: `${defaultGroupName}`,
                            dataGroupLabel: `${defaultGroupLabel}`,
                            properties: (0, $2kqnu.fillPropertiesArray)(newFigureTypeSettings?.dataRowVars ?? [], thisDefaultSeries?.properties)
                        };
                        dataGroups.push(newDataGroup);
                    }
                }
                if (restoredData?.axes && restoredData.axes.length > 0) // Restore saved axes
                axes = restoredData.axes.map((axis)=>{
                    const axisSettings = state.figureSettings.figureAxisSettings.find((as)=>as.axisType === axis.axisType);
                    return {
                        ...axis,
                        properties: (0, $2kqnu.fillPropertiesArray)(axisSettings?.parameters ?? // istanbul ignore next
                        [], axis.properties)
                    };
                });
                else {
                    // Create default axes based on requiredAxis
                    const requiredAxis = newFigureTypeSettings?.requiredAxis ?? [];
                    axes = requiredAxis.map((axisType)=>{
                        const axisSettings = state.figureSettings.figureAxisSettings.find((as)=>as.axisType === axisType);
                        return {
                            id: crypto.randomUUID(),
                            axisType: axisType,
                            properties: (0, $2kqnu.fillPropertiesArray)(axisSettings?.parameters ?? // istanbul ignore next
                            [])
                        };
                    });
                }
                return {
                    ...state,
                    changed: true,
                    savedFigureData: savedFigureData,
                    figureInput: {
                        ...state.figureInput,
                        figureType: action.newValue,
                        figureTypeProperties: figureTypeProperties,
                        dataGroups: dataGroups,
                        regressionLines: regressionLines,
                        axes: axes
                    }
                };
            }
        case 0, $5NA6O.SET_LEGEND_TYPE:
            {
                const legendTypeSettings = state.figureSettings.figureLegendSettings.find((lt)=>lt.legendType === action.newValue);
                const updatedLegend = state.figureInput.legend.map((li)=>({
                        ...li,
                        properties: (0, $2kqnu.fillPropertiesArray)(legendTypeSettings?.parameters ?? [], li.properties)
                    }));
                return {
                    ...state,
                    changed: true,
                    figureInput: {
                        ...state.figureInput,
                        legendType: action.newValue,
                        legend: updatedLegend
                    }
                };
            }
    }
};

});
parcelRegister("2kqnu", function(module, exports) {

$parcel$export(module.exports, "fillPropertiesArray", function () { return $cf65614e0a42298e$export$e4e898be1499fefb; });

var $eBlbF = parcelRequire("eBlbF");
const $cf65614e0a42298e$export$e4e898be1499fefb = (propertiesSettings, existingProperties)=>{
    const newProperties = [
        ...existingProperties ?? []
    ];
    propertiesSettings.forEach((propSetting)=>{
        if (!newProperties.find((p)=>p.varName === propSetting.varName)) newProperties.push({
            varName: propSetting.varName,
            value: propSetting.defaultValue ?? (propSetting.varName === "seed" ? (0, $eBlbF.random)(1, 100).toString() : "")
        });
    });
    return newProperties;
};

});

parcelRegister("5NA6O", function(module, exports) {

$parcel$export(module.exports, "ADD_DATA_GROUP", function () { return $5d4e61f201de69ac$export$f5562b4a1c8c97cf; });
$parcel$export(module.exports, "ADD_PROPERTY", function () { return $5d4e61f201de69ac$export$a4e3dcfda69557dc; });
$parcel$export(module.exports, "ADD_REFERENCE_LINE", function () { return $5d4e61f201de69ac$export$5c91032a07a83b14; });
$parcel$export(module.exports, "ADD_REGRESSION_LINE", function () { return $5d4e61f201de69ac$export$4d568f079db6bac7; });
$parcel$export(module.exports, "CHANGE_REGRESSION_LINE_TYPE", function () { return $5d4e61f201de69ac$export$85262a788ce8b3ce; });
$parcel$export(module.exports, "FIGURE_CHANGE_SENT", function () { return $5d4e61f201de69ac$export$dfc3134222855010; });
$parcel$export(module.exports, "LOAD_FIGURE_INPUT", function () { return $5d4e61f201de69ac$export$c6dd21050e43e00; });
$parcel$export(module.exports, "PATCH_FIGURE_STATE", function () { return $5d4e61f201de69ac$export$6673c6260a15e737; });
$parcel$export(module.exports, "REMOVE_FIGURE_ITEM", function () { return $5d4e61f201de69ac$export$6fd04a860a2d0c0c; });
$parcel$export(module.exports, "SET_FIGURE_TYPE", function () { return $5d4e61f201de69ac$export$97d14988a0f67fc5; });
$parcel$export(module.exports, "SET_LEGEND_TYPE", function () { return $5d4e61f201de69ac$export$d7d24c2ec485dfe4; });
const $5d4e61f201de69ac$export$f5562b4a1c8c97cf = "ADD_DATA_GROUP";
const $5d4e61f201de69ac$export$a4e3dcfda69557dc = "ADD_PROPERTY";
const $5d4e61f201de69ac$export$5c91032a07a83b14 = "ADD_REFERENCE_LINE";
const $5d4e61f201de69ac$export$4d568f079db6bac7 = "ADD_REGRESSION_LINE";
const $5d4e61f201de69ac$export$85262a788ce8b3ce = "CHANGE_REGRESSION_LINE_TYPE";
const $5d4e61f201de69ac$export$dfc3134222855010 = "FIGURE_CHANGE_SENT";
const $5d4e61f201de69ac$export$c6dd21050e43e00 = "LOAD_FIGURE_INPUT";
const $5d4e61f201de69ac$export$6673c6260a15e737 = "PATCH_FIGURE_STATE";
const $5d4e61f201de69ac$export$6fd04a860a2d0c0c = "REMOVE_FIGURE_ITEM";
const $5d4e61f201de69ac$export$97d14988a0f67fc5 = "SET_FIGURE_TYPE";
const $5d4e61f201de69ac$export$d7d24c2ec485dfe4 = "SET_LEGEND_TYPE";

});



parcelRegister("hKPkg", function(module, exports) {

$parcel$export(module.exports, "BeFigureOptions", function () { return $98dbf315da73113b$export$32d8307fb3ca4d02; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
parcelRequire("aoPxa");
var $6822T = parcelRequire("6822T");
var $aUt9N = parcelRequire("aUt9N");

var $89lY5 = parcelRequire("89lY5");

var $cKBoc = parcelRequire("cKBoc");

var $hcWJH = parcelRequire("hcWJH");

var $5NA6O = parcelRequire("5NA6O");
parcelRequire("fKlTJ");
var $bZdFt = parcelRequire("bZdFt");
const $98dbf315da73113b$export$ab11e7d7d71c291f = [
    {
        varName: "order",
        label: "Order",
        type: (0, $bZdFt.FigureVarTypeDto).number
    },
    {
        varName: "orderHeader",
        label: "Label",
        type: (0, $bZdFt.FigureVarTypeDto).string
    },
    {
        varName: "seed",
        label: "Seed",
        type: (0, $bZdFt.FigureVarTypeDto).number
    },
    {
        varName: "length",
        label: "Length",
        type: (0, $bZdFt.FigureVarTypeDto).number
    }
];
const $98dbf315da73113b$export$32d8307fb3ca4d02 = ({ show: show })=>{
    const { state: state, dispatch: dispatch } = (0, $89lY5.useBeFigure)();
    const figureInput = state?.figureInput;
    const figureSettings = state?.figureSettings;
    const figureTypes = state?.figureSettings.figureTypeSettings.map((ft)=>({
            label: ft.label,
            value: ft.value
        })) ?? [];
    const figureTypeProperties = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.properties ?? [];
    const allowedRegressionTypes = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.allowedRegressionTypes ?? [];
    const isLegendVisible = state?.figureSettings.figureTypeSettings.find((ft)=>ft.value === figureInput?.figureType)?.isLegendVisible ?? true;
    const legendTypes = state?.figureSettings.figureLegendSettings.map((lt)=>lt.legendType) ?? [];
    const [showImageProps, setShowImageProps] = (0, $spJKX.useState)(false);
    const [showTypeProps, setShowTypeProps] = (0, $spJKX.useState)(false);
    return !figureSettings || !figureTypes || !figureInput ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: "be-figure-options",
        title: "Figure options",
        visible: show,
        allowUndock: true,
        initialDockEdge: "right",
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
            className: "border rounded border-gray-500 border-2 ps-3 pe-4 me-3 pb-1",
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    label: "Figure type",
                    labelWidth: 3,
                    value: figureInput.figureType,
                    options: figureTypes,
                    setValue: (newValue)=>dispatch({
                            operation: (0, $5NA6O.SET_FIGURE_TYPE),
                            newValue: newValue
                        }),
                    id: "figure-type"
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    label: "Legend type",
                    labelWidth: 3,
                    value: figureInput.legendType,
                    options: legendTypes,
                    setValue: (newValue)=>dispatch({
                            operation: (0, $5NA6O.SET_LEGEND_TYPE),
                            newValue: newValue
                        }),
                    id: "legend-type"
                }),
                figureSettings.figureProperties.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6822T.CollapseRow), {
                    label: "Image properties",
                    isOpen: showImageProps,
                    setIsOpen: setShowImageProps,
                    className: "border rounded border-gray-500 border-2 px-1",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hcWJH.FigureVars), {
                        id: "properties",
                        dataPath: "/properties",
                        varSettings: figureSettings.figureProperties,
                        properties: figureInput.properties
                    })
                }),
                figureTypeProperties.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6822T.CollapseRow), {
                            label: "Figure properties",
                            isOpen: showTypeProps,
                            setIsOpen: setShowTypeProps,
                            className: "border rounded border-gray-500 border-2 px-1",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hcWJH.FigureVars), {
                                id: "figure-properties",
                                dataPath: "/figureTypeProperties",
                                varSettings: figureTypeProperties,
                                properties: figureInput.figureTypeProperties
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cKBoc.FigureDataRows), {
                    dataPath: "/axes",
                    itemLabel: "Axis",
                    label: "Axes",
                    noAddRemove: true,
                    propertiesKey: "properties"
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cKBoc.FigureDataRows), {
                    addType: (0, $5NA6O.ADD_DATA_GROUP),
                    dataPath: "/dataGroups",
                    itemLabel: "Data series",
                    label: "Data Groups",
                    propertiesKey: "properties"
                }),
                isLegendVisible && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cKBoc.FigureDataRows), {
                            dataPath: "/legend",
                            itemLabel: "Settings",
                            label: "Legend",
                            propertiesKey: "properties",
                            noAddRemove: true,
                            noNumber: true
                        })
                    ]
                }),
                allowedRegressionTypes.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cKBoc.FigureDataRows), {
                            addType: (0, $5NA6O.ADD_REGRESSION_LINE),
                            dataPath: "/regressionLines",
                            itemLabel: "Regression line",
                            label: "Regression Lines",
                            propertiesKey: "properties"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {}),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cKBoc.FigureDataRows), {
                    addType: (0, $5NA6O.ADD_REFERENCE_LINE),
                    dataPath: "/referenceLines",
                    itemLabel: "Reference line",
                    label: "Reference Lines",
                    propertiesKey: "properties"
                })
            ]
        })
    });
};
$98dbf315da73113b$export$32d8307fb3ca4d02.displayName = "BeFigureOptions";

});
parcelRegister("cKBoc", function(module, exports) {

$parcel$export(module.exports, "FigureDataRows", function () { return $d331b722a887e5a0$export$a044f389a74b8cc8; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3ew5o = parcelRequire("3ew5o");
parcelRequire("aoPxa");
var $6822T = parcelRequire("6822T");

var $UiROe = parcelRequire("UiROe");

var $89lY5 = parcelRequire("89lY5");

var $10Vy9 = parcelRequire("10Vy9");
const $d331b722a887e5a0$export$a044f389a74b8cc8 = ({ addType: addType, dataPath: dataPath, itemLabel: itemLabel, label: label, noAddRemove: noAddRemove = false, noNumber: noNumber = false, propertiesKey: propertiesKey })=>{
    const { state: state } = (0, $89lY5.useBeFigure)();
    const figureInput = state?.figureInput;
    const figureSettings = state?.figureSettings;
    const figureType = figureInput?.figureType;
    const figureTypeSettings = figureSettings?.figureTypeSettings.find((fts)=>fts.value === figureType);
    const pointer = (0, $3ew5o.Pointer).fromJSON(dataPath);
    const item = pointer.get(figureInput);
    const itemArray = Array.isArray(item) ? item : undefined;
    const [show, setShow] = (0, $spJKX.useState)(false);
    return !itemArray || typeof itemArray === "string" || !figureType || !figureSettings || !figureTypeSettings ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6822T.CollapseRow), {
        label: label,
        isOpen: show,
        setIsOpen: setShow,
        className: "border rounded border-gray-500 border-2 px-1",
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            children: [
                itemArray.map((item, ix)=>{
                    let varSettings = [];
                    switch(dataPath){
                        case "/axes":
                            varSettings = figureSettings.figureAxisSettings.find((ftas)=>figureTypeSettings.requiredAxis[ix] === ftas.axisType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/legend":
                            varSettings = figureSettings.figureLegendSettings.find((ls)=>ls.legendType === figureInput.legendType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/referenceLines":
                            varSettings = figureSettings.figureReferenceLinesSettings;
                            break;
                        case "/regressionLines":
                            varSettings = figureSettings.figureRegressionLineSettings.find((fs)=>fs.lineType === item.lineType)?.parameters ?? // istanbul ignore next
                            [];
                            break;
                        case "/dataGroups":
                        default:
                            varSettings = figureTypeSettings.dataRowVars;
                            break;
                    }
                    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $10Vy9.FigureDataRow), {
                        id: item.id,
                        dataPath: `${dataPath}/${ix}`,
                        itemLabel: itemLabel,
                        noNumber: noNumber,
                        noRemove: noAddRemove,
                        propertiesKey: propertiesKey,
                        siblingCount: itemArray.length,
                        varSettings: varSettings
                    }, ix);
                }),
                !noAddRemove && addType && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $UiROe.AddNewButton), {
                    id: "add-data-row-btn",
                    operation: addType,
                    newLength: itemArray.length + 1
                })
            ]
        })
    });
};
$d331b722a887e5a0$export$a044f389a74b8cc8.displayName = "FigureDataRows";

});
parcelRegister("UiROe", function(module, exports) {

$parcel$export(module.exports, "AddNewButton", function () { return $f89b15e48459665c$export$f48e59479b265be9; });

var $bR5nk = parcelRequire("bR5nk");

var $gCZ2V = parcelRequire("gCZ2V");
parcelRequire("aoPxa");
var $iuDOI = parcelRequire("iuDOI");

var $89lY5 = parcelRequire("89lY5");
const $f89b15e48459665c$export$f48e59479b265be9 = ({ operation: operation, newLength: newLength, label: label = "Add", ...rest })=>{
    const { dispatch: dispatch } = (0, $89lY5.useBeFigure)();
    return !dispatch ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        onClick: ()=>dispatch({
                operation: operation,
                newLength: newLength
            }),
        className: "my-2 d-flex align-items-center btn btn-sm btn-success justify-content-center",
        ...rest,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                className: "me-2",
                children: label
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {})
        ]
    });
};
$f89b15e48459665c$export$f48e59479b265be9.displayName = "AddNewButton";

});

parcelRegister("10Vy9", function(module, exports) {

$parcel$export(module.exports, "FigureDataRow", function () { return $253587701c43b00b$export$f09f1e74b11b6073; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3ew5o = parcelRequire("3ew5o");
parcelRequire("aoPxa");
var $6822T = parcelRequire("6822T");
var $aUt9N = parcelRequire("aUt9N");

var $89lY5 = parcelRequire("89lY5");

var $hcWJH = parcelRequire("hcWJH");

var $5NA6O = parcelRequire("5NA6O");

var $6SlFO = parcelRequire("6SlFO");
parcelRequire("fKlTJ");
var $bNyu4 = parcelRequire("bNyu4");
const $253587701c43b00b$export$f09f1e74b11b6073 = ({ id: id, dataPath: dataPath, itemLabel: itemLabel, noNumber: noNumber = false, noRemove: noRemove = false, propertiesKey: propertiesKey, siblingCount: siblingCount, varSettings: varSettings })=>{
    const { state: state, dispatch: dispatch } = (0, $89lY5.useBeFigure)();
    const figureSettings = state?.figureSettings;
    const figureInput = state?.figureInput;
    const [isOpen, setIsOpen] = (0, $spJKX.useState)(true);
    const figureTypeSettings = figureSettings?.figureTypeSettings.find((fts)=>fts.value === figureInput?.figureType);
    const allowedRegressionLines = figureTypeSettings?.allowedRegressionTypes ?? [];
    // Get the array from figureInput using dataPath
    const pointer = (0, $3ew5o.Pointer).fromJSON(dataPath);
    const item = pointer.get(figureInput);
    const thisProps = (0, $spJKX.useMemo)(()=>Array.isArray(item?.properties) && item.properties.every((p)=>(0, $bNyu4.isFigureVarDataDto)(p)) ? item.properties : [], [
        item
    ]);
    const ix = parseInt(pointer.tokens[pointer.tokens.length - 1]);
    // Get the display label from the "name" property if it exists, otherwise use itemLabel N
    const displayLabel = (0, $spJKX.useMemo)(()=>{
        const nameProperty = thisProps.find((p)=>p.varName === "name");
        const labelProperty = thisProps.find((p)=>p.varName === "label");
        if (nameProperty?.value) return nameProperty.value;
        if (labelProperty?.value) return labelProperty.value;
        return noNumber ? itemLabel : `${itemLabel} ${ix + 1}`;
    }, [
        thisProps,
        itemLabel,
        noNumber,
        ix
    ]);
    // Check props exist for all varSettings, if not add empty
    const addMissingProps = (0, $spJKX.useEffectEvent)((varSettings, thisProps)=>varSettings.forEach((varSetting)=>{
            const pix = thisProps.findIndex((p)=>p.varName === varSetting.varName);
            if (pix < 0) dispatch({
                operation: (0, $5NA6O.ADD_PROPERTY),
                pointer: `${dataPath}/properties`,
                varName: varSetting.varName
            });
        }));
    (0, $spJKX.useEffect)(()=>{
        addMissingProps(varSettings, thisProps);
    }, [
        varSettings,
        thisProps
    ]);
    return !figureSettings || !figureInput || !item || !thisProps || varSettings.length === 0 ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $6822T.CollapseRow), {
        className: "border rounded border-gray-500 border-2 px-1 mb-2",
        label: /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
            className: "fw-bold d-flex align-items-center",
            children: [
                displayLabel,
                !noRemove && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6SlFO.RemoveFigureItemButton), {
                    id: `${id}-remove-btn`,
                    dataPath: dataPath,
                    siblingCount: siblingCount
                })
            ]
        }),
        isOpen: isOpen,
        setIsOpen: ()=>setIsOpen(!isOpen),
        children: [
            dataPath.startsWith("/regressionLines") && item.lineType && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                id: `${id}-line-type`,
                label: "Regression line type",
                labelWidth: 3,
                value: item.lineType,
                options: allowedRegressionLines,
                setValue: (newValue)=>{
                    dispatch({
                        operation: (0, $5NA6O.CHANGE_REGRESSION_LINE_TYPE),
                        pointer: `${dataPath}`,
                        lineType: newValue
                    });
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hcWJH.FigureVars), {
                id: id,
                dataPath: `${dataPath}/${propertiesKey}`,
                varSettings: varSettings,
                properties: thisProps
            })
        ]
    });
};
$253587701c43b00b$export$f09f1e74b11b6073.displayName = "FigureDataRow";

});
parcelRegister("hcWJH", function(module, exports) {

$parcel$export(module.exports, "FigureVars", function () { return $401add9057a22b73$export$491ad496ac74ba0e; });

var $bR5nk = parcelRequire("bR5nk");

var $8Pxa4 = parcelRequire("8Pxa4");
const $401add9057a22b73$export$491ad496ac74ba0e = ({ id: id, dataPath: dataPath, varSettings: varSettings, properties: properties })=>{
    return varSettings.map((varSetting)=>{
        const pix = properties.findIndex((p)=>p.varName === varSetting.varName);
        // Return null if property is missing, should be added by parent component
        if (pix < 0) return null;
        // Check if this variable has conditional requirements
        if (varSetting.requires) {
            const requiredProperty = properties.find((p)=>p.varName === varSetting.requires?.varName);
            // If the required property doesn't exist or its value is not in the allowed values, don't render
            if (!requiredProperty || !varSetting.requires.values.includes(requiredProperty.value)) return null;
        }
        return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Pxa4.FigureVar), {
            pointer: `${dataPath}/${pix}/value`,
            figureVarType: varSetting.type,
            label: varSetting.label,
            varName: varSetting.varName,
            options: varSetting.options
        }, `${id}-${varSetting.varName}`);
    });
};

});
parcelRegister("8Pxa4", function(module, exports) {

$parcel$export(module.exports, "FigureVar", function () { return $29c33ca744b07423$export$9e617fe7cdf38346; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $3ew5o = parcelRequire("3ew5o");
parcelRequire("aoPxa");
var $kUTy1 = parcelRequire("kUTy1");
var $aUt9N = parcelRequire("aUt9N");

var $89lY5 = parcelRequire("89lY5");

var $5NA6O = parcelRequire("5NA6O");
parcelRequire("fKlTJ");
var $bZdFt = parcelRequire("bZdFt");
const $29c33ca744b07423$export$9e617fe7cdf38346 = ({ label: label, figureVarType: figureVarType, pointer: pointer, varName: varName, options: options })=>{
    const id = (0, $spJKX.useId)();
    const { state: state, dispatch: dispatch } = (0, $89lY5.useBeFigure)();
    const figureInput = state?.figureInput;
    const dp = (0, $3ew5o.Pointer).fromJSON(pointer);
    const val = dp.get(figureInput) ?? "";
    return !state ? null : figureVarType === (0, $bZdFt.FigureVarTypeDto).select ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
        id: `${id}-${varName}`,
        label: label,
        labelWidth: 3,
        value: val,
        setValue: (newValue)=>dispatch({
                operation: (0, $5NA6O.PATCH_FIGURE_STATE),
                pointer: pointer,
                value: newValue
            }),
        options: [
            ...!options?.includes(val) ? [
                {
                    value: "",
                    label: "-- Select --"
                }
            ] : [],
            ...(options ?? []).map((s)=>({
                    value: s,
                    label: s
                }))
        ]
    }, `${id}-${varName}`) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
        id: `${id}-${varName}`,
        label: label,
        labelWidth: 3,
        value: val,
        type: figureVarType === (0, $bZdFt.FigureVarTypeDto).number ? "number" : "string",
        debounceMilliseconds: 500,
        setValue: (newValue)=>dispatch({
                operation: (0, $5NA6O.PATCH_FIGURE_STATE),
                pointer: pointer,
                value: newValue
            })
    }, `${id}-${varName}`);
};
$29c33ca744b07423$export$9e617fe7cdf38346.displayName = "FigureVar";

});
parcelRegister("fKlTJ", function(module, exports) {
$parcel$export(module.exports, "isFigureSettingsDto", function () { return (parcelRequire("kTXvy")).isFigureSettingsDto; });
$parcel$export(module.exports, "isFigureVarDataDto", function () { return (parcelRequire("bNyu4")).isFigureVarDataDto; });
$parcel$export(module.exports, "FigureVarTypeDto", function () { return (parcelRequire("bZdFt")).FigureVarTypeDto; });
parcelRequire("9biDA");
parcelRequire("j061K");
parcelRequire("juBhe");
parcelRequire("kuM5p");
parcelRequire("d6iwc");
parcelRequire("lPnGH");
parcelRequire("2PBU6");
parcelRequire("iR9ih");
parcelRequire("dWUFP");
parcelRequire("8kRGY");
parcelRequire("kTXvy");
parcelRequire("33voy");
parcelRequire("lprnY");
parcelRequire("bNyu4");
parcelRequire("bZdFt");

});
parcelRegister("9biDA", function(module, exports) {

$parcel$export(module.exports, "isFigureAxisDataDto", function () { return $b85ca1ebc826b1f6$export$67f3b38a36d6773c; });

var $bNyu4 = parcelRequire("bNyu4");
const $b85ca1ebc826b1f6$export$67f3b38a36d6773c = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.axisType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    return true;
};

});
parcelRegister("bNyu4", function(module, exports) {

$parcel$export(module.exports, "isFigureVarDataDto", function () { return $55a7a7083ca50320$export$1599e7102407b3b1; });
/**
 * Represents variable data for a figure property, pairing a variable name with its current value.
 */ const $55a7a7083ca50320$export$1599e7102407b3b1 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.varName !== "string") return false;
    if (typeof chkObj.value !== "string") return false;
    return true;
};

});


parcelRegister("j061K", function(module, exports) {

$parcel$export(module.exports, "isFigureAxisSettingsDto", function () { return $00e150dc1df0d343$export$9a3403397094d501; });

var $bZdFt = parcelRequire("bZdFt");
const $00e150dc1df0d343$export$9a3403397094d501 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.axisType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $bZdFt.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});
parcelRegister("bZdFt", function(module, exports) {

$parcel$export(module.exports, "FigureVarTypeDto", function () { return $029b607f5dbe4f8b$export$189a7cbcdf9d114f; });
$parcel$export(module.exports, "isFigureVarSettingsDto", function () { return $029b607f5dbe4f8b$export$5bafd2b3c43240fb; });
/**
 * Enumeration of all supported figure variable setting types.
 * Used to discriminate between different variable setting shapes.
 */ var $029b607f5dbe4f8b$export$189a7cbcdf9d114f = /*#__PURE__*/ function(FigureVarTypeDto) {
    FigureVarTypeDto["list"] = "list";
    FigureVarTypeDto["number"] = "number";
    FigureVarTypeDto["string"] = "string";
    FigureVarTypeDto["select"] = "select";
    FigureVarTypeDto["variable"] = "variable";
    return FigureVarTypeDto;
}({});
const $029b607f5dbe4f8b$export$5bafd2b3c43240fb = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.varName !== "string") return false;
    if (typeof chkObj.label !== "string") return false;
    if (chkObj.type !== "list" && chkObj.type !== "number" && chkObj.type !== "string" && chkObj.type !== "select" && chkObj.type !== "variable") return false;
    if (chkObj.type === "select") {
        const selectObj = chkObj;
        if (!Array.isArray(selectObj.options) || selectObj.options.some((option)=>typeof option !== "string")) return false;
    }
    if (chkObj.type !== "select" && "options" in chkObj) return false;
    if ("requires" in chkObj && chkObj.requires !== undefined) {
        if (typeof chkObj.requires !== "object" || chkObj.requires === null) return false;
        const requires = chkObj.requires;
        if (typeof requires.varName !== "string") return false;
        if (!Array.isArray(requires.values) || requires.values.some((value)=>typeof value !== "string")) return false;
    }
    return true;
};

});


parcelRegister("juBhe", function(module, exports) {

var $9biDA = parcelRequire("9biDA");

var $kuM5p = parcelRequire("kuM5p");

var $d6iwc = parcelRequire("d6iwc");

var $2PBU6 = parcelRequire("2PBU6");

var $dWUFP = parcelRequire("dWUFP");

var $bNyu4 = parcelRequire("bNyu4");
const $9d62c9bb63b7793d$export$174325b5313169ff = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.figureType !== "string") return false;
    if (typeof chkObj.legendType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    if (!Array.isArray(chkObj.figureTypeProperties)) return false;
    if (chkObj.figureTypeProperties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    if (!Array.isArray(chkObj.axes)) return false;
    if (chkObj.axes.some((axis)=>!(0, $9biDA.isFigureAxisDataDto)(axis))) return false;
    if (!Array.isArray(chkObj.dataGroups)) return false;
    if (chkObj.dataGroups.some((group)=>!(0, $kuM5p.isFigureGroupDataDto)(group))) return false;
    if (!Array.isArray(chkObj.legend)) return false;
    if (chkObj.legend.some((item)=>!(0, $d6iwc.isFigureLegendDataDto)(item))) return false;
    if (!Array.isArray(chkObj.referenceLines)) return false;
    if (chkObj.referenceLines.some((item)=>!(0, $2PBU6.isFigureReferenceLineDataDto)(item))) return false;
    if (!Array.isArray(chkObj.regressionLines)) return false;
    if (chkObj.regressionLines.some((line)=>!(0, $dWUFP.isFigureRegressionLineDataDto)(line))) return false;
    return true;
};

});
parcelRegister("kuM5p", function(module, exports) {

$parcel$export(module.exports, "isFigureGroupDataDto", function () { return $112c6a41a5d25dff$export$c908729a68fb157e; });

var $bNyu4 = parcelRequire("bNyu4");
const $112c6a41a5d25dff$export$c908729a68fb157e = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.dataGroupName !== "string") return false;
    if (typeof chkObj.dataGroupLabel !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("d6iwc", function(module, exports) {

$parcel$export(module.exports, "isFigureLegendDataDto", function () { return $8f0d5c0d7729e1fd$export$c1b4fefa80f8f98d; });

var $bNyu4 = parcelRequire("bNyu4");
const $8f0d5c0d7729e1fd$export$c1b4fefa80f8f98d = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.legendLabel !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("2PBU6", function(module, exports) {

$parcel$export(module.exports, "isFigureReferenceLineDataDto", function () { return $5a833273ef156a90$export$8771148fb5a37a45; });

var $bNyu4 = parcelRequire("bNyu4");
const $5a833273ef156a90$export$8771148fb5a37a45 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    return true;
};

});

parcelRegister("dWUFP", function(module, exports) {

$parcel$export(module.exports, "isFigureRegressionLineDataDto", function () { return $8085ca7a4f99089d$export$e2bf1a36c884a0f; });

var $bNyu4 = parcelRequire("bNyu4");
const $8085ca7a4f99089d$export$e2bf1a36c884a0f = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.lineType !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bNyu4.isFigureVarDataDto)(property))) return false;
    return true;
};

});


parcelRegister("lPnGH", function(module, exports) {

$parcel$export(module.exports, "isFigureLegendSettingsDto", function () { return $b2d518d32551e9aa$export$a92d26051cc06363; });

var $bZdFt = parcelRequire("bZdFt");
const $b2d518d32551e9aa$export$a92d26051cc06363 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.legendType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $bZdFt.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("iR9ih", function(module, exports) {

var $bZdFt = parcelRequire("bZdFt");
const $71df3aba029965fe$export$c1bd2fdbab4b5aaf = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (chkObj.parameters !== undefined && !Array.isArray(chkObj.parameters)) return false;
    if (Array.isArray(chkObj.parameters) && chkObj.parameters.some((parameter)=>!(0, $bZdFt.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("8kRGY", function(module, exports) {

$parcel$export(module.exports, "isFigureRegressionLineSettingsDto", function () { return $46a80a21cb7ff189$export$16033d1ff371ffed; });

var $bZdFt = parcelRequire("bZdFt");
const $46a80a21cb7ff189$export$16033d1ff371ffed = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.lineType !== "string") return false;
    if (!Array.isArray(chkObj.parameters)) return false;
    if (chkObj.parameters.some((parameter)=>!(0, $bZdFt.isFigureVarSettingsDto)(parameter))) return false;
    return true;
};

});

parcelRegister("kTXvy", function(module, exports) {

$parcel$export(module.exports, "isFigureSettingsDto", function () { return $53faff67f52a063e$export$30699a739844a206; });

var $j061K = parcelRequire("j061K");

var $lPnGH = parcelRequire("lPnGH");

var $8kRGY = parcelRequire("8kRGY");

var $lprnY = parcelRequire("lprnY");

var $bZdFt = parcelRequire("bZdFt");
const $53faff67f52a063e$export$30699a739844a206 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (!Array.isArray(chkObj.figureTypeSettings)) return false;
    if (chkObj.figureTypeSettings.some((option)=>!(0, $lprnY.isFigureTypeSettingsDto)(option))) return false;
    if (!Array.isArray(chkObj.figureProperties)) return false;
    if (chkObj.figureProperties.some((setting)=>!(0, $bZdFt.isFigureVarSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureAxisSettings)) return false;
    if (chkObj.figureAxisSettings.some((setting)=>!(0, $j061K.isFigureAxisSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureLegendSettings)) return false;
    if (chkObj.figureLegendSettings.some((setting)=>!(0, $lPnGH.isFigureLegendSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureRegressionLineSettings)) return false;
    if (chkObj.figureRegressionLineSettings.some((setting)=>!(0, $8kRGY.isFigureRegressionLineSettingsDto)(setting))) return false;
    if (!Array.isArray(chkObj.figureReferenceLinesSettings)) return false;
    if (chkObj.figureReferenceLinesSettings.some((setting)=>!(0, $bZdFt.isFigureVarSettingsDto)(setting))) return false;
    return true;
};

});
parcelRegister("lprnY", function(module, exports) {

$parcel$export(module.exports, "isFigureTypeSettingsDto", function () { return $12b4ef4aa504d4e0$export$9cddc0daa427d07c; });

var $bZdFt = parcelRequire("bZdFt");
const $12b4ef4aa504d4e0$export$9cddc0daa427d07c = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.value !== "string") return false;
    if (typeof chkObj.label !== "string") return false;
    if (!Array.isArray(chkObj.properties)) return false;
    if (chkObj.properties.some((property)=>!(0, $bZdFt.isFigureVarSettingsDto)(property))) return false;
    if (!Array.isArray(chkObj.dataRowVars)) return false;
    if (chkObj.dataRowVars.some((property)=>!(0, $bZdFt.isFigureVarSettingsDto)(property))) return false;
    if (!Array.isArray(chkObj.requiredAxis)) return false;
    if (chkObj.requiredAxis.some((name)=>typeof name !== "string")) return false;
    if (chkObj.allowedRegressionTypes !== undefined && (!Array.isArray(chkObj.allowedRegressionTypes) || chkObj.allowedRegressionTypes.some((type)=>typeof type !== "string"))) return false;
    if (chkObj.defaultNumberOfSeries !== undefined && (!Number.isFinite(chkObj.defaultNumberOfSeries) || !Number.isInteger(chkObj.defaultNumberOfSeries) || chkObj.defaultNumberOfSeries < 0)) return false;
    if (chkObj.defaultSeries !== undefined && !Array.isArray(chkObj.defaultSeries)) return false;
    if (chkObj.isLegendVisible !== undefined && typeof chkObj.isLegendVisible !== "boolean") return false;
    return true;
};

});


parcelRegister("33voy", function(module, exports) {
/**
 * Describes a data-row variable option for a selectable figure type.
 */ 
});




parcelRegister("6SlFO", function(module, exports) {

$parcel$export(module.exports, "RemoveFigureItemButton", function () { return $cc1c85d1f6db6b9d$export$1a767f0a5c160b74; });

var $bR5nk = parcelRequire("bR5nk");

var $av9bi = parcelRequire("av9bi");

var $89lY5 = parcelRequire("89lY5");

var $5NA6O = parcelRequire("5NA6O");
const $cc1c85d1f6db6b9d$export$1a767f0a5c160b74 = ({ dataPath: dataPath, id: id, siblingCount: siblingCount })=>{
    const { dispatch: dispatch } = (0, $89lY5.useBeFigure)();
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
        id: `remove-${id}`,
        className: "text-danger ms-2",
        role: "button",
        "aria-label": "Remove item",
        onClick: ()=>{
            dispatch({
                operation: (0, $5NA6O.REMOVE_FIGURE_ITEM),
                dataPath: dataPath,
                newLength: siblingCount - 1
            });
        }
    });
};
$cc1c85d1f6db6b9d$export$1a767f0a5c160b74.displayName = "RemoveFigureItemButton";

});





parcelRegister("eP3ql", function(module, exports) {
$parcel$export(module.exports, "preProcessFigureInput", function () { return (parcelRequire("hFJlN")).preProcessFigureInput; });
parcelRequire("37AcD");
parcelRequire("hFJlN");

});
parcelRegister("37AcD", function(module, exports) {
const $427034eaea38a5e2$export$2749cd6bc8a1a83a = (obj)=>Object.entries(obj).map(([varName, value])=>({
            varName: varName,
            value: String(value)
        }));

});

parcelRegister("hFJlN", function(module, exports) {

$parcel$export(module.exports, "preProcessFigureInput", function () { return $ed856488fc9ebab1$export$73d7fc73149626a8; });

var $2kqnu = parcelRequire("2kqnu");
const $ed856488fc9ebab1$export$73d7fc73149626a8 = (figureSettings, figureInput)=>{
    const preProcessedFigureInput = {
        ...figureInput ?? {}
    };
    // Throw if there are no figure type settings
    if (figureSettings.figureTypeSettings.length === 0) throw new Error("preProcessFigureInput: No figure type settings available in figureSettings");
    // Check id exists, if not create one
    if (!preProcessedFigureInput.id) preProcessedFigureInput.id = crypto.randomUUID();
    // Check figureType exists in settings or take the first
    let figureTypeSetting = figureSettings.figureTypeSettings.find((ft)=>ft.value === preProcessedFigureInput.figureType);
    if (!figureTypeSetting) {
        console.warn(`preProcessFigureInput: figureType "${preProcessedFigureInput.figureType}" not found in figureSettings`);
        figureTypeSetting = figureSettings.figureTypeSettings[0];
        preProcessedFigureInput.figureType = figureTypeSetting.value;
    }
    // Check legendType exists in settings or take the first
    let legendSetting = figureSettings.figureLegendSettings.find((ls)=>ls.legendType === preProcessedFigureInput.legendType);
    if (!legendSetting) {
        console.warn(`preProcessFigureInput: legend type "${preProcessedFigureInput.legendType}" not found in figureSettings`);
        legendSetting = figureSettings.figureLegendSettings[0];
        preProcessedFigureInput.legendType = legendSetting.legendType;
    }
    // Check all required lists exist, if not create empty
    if (!preProcessedFigureInput.properties) preProcessedFigureInput.properties = [];
    if (!preProcessedFigureInput.figureTypeProperties) preProcessedFigureInput.figureTypeProperties = [];
    if (!preProcessedFigureInput.axes) preProcessedFigureInput.axes = [];
    if (!preProcessedFigureInput.dataGroups) preProcessedFigureInput.dataGroups = [];
    if (!preProcessedFigureInput.legend) preProcessedFigureInput.legend = [];
    if (!preProcessedFigureInput.referenceLines) preProcessedFigureInput.referenceLines = [];
    if (!preProcessedFigureInput.regressionLines) preProcessedFigureInput.regressionLines = [];
    const processedFigureInput = preProcessedFigureInput;
    // Check all required figure settings exist
    processedFigureInput.properties = (0, $2kqnu.fillPropertiesArray)(figureSettings.figureProperties, processedFigureInput.properties);
    processedFigureInput.figureTypeProperties = (0, $2kqnu.fillPropertiesArray)(figureTypeSetting.properties, processedFigureInput.figureTypeProperties);
    // Ensure there is exactly one legend entry and that it has all required properties
    if (processedFigureInput.legend.length > 1) {
        console.warn(`preProcessFigureInput: More than one legend entry found, only the first will be used. Found ${processedFigureInput.legend.length} entries.`);
        processedFigureInput.legend = [
            processedFigureInput.legend[0]
        ];
    }
    // Ensure legend array has at least one entry
    if (processedFigureInput.legend.length === 0) processedFigureInput.legend.push({
        id: crypto.randomUUID(),
        legendLabel: legendSetting.legendType,
        properties: []
    });
    processedFigureInput.legend[0].properties = (0, $2kqnu.fillPropertiesArray)(legendSetting.parameters, processedFigureInput.legend[0].properties);
    // Check all required axes exist and have required fields
    const requiredAxes = figureTypeSetting.requiredAxis;
    requiredAxes.forEach((axisType)=>{
        const axisSetting = figureSettings.figureAxisSettings.find((ats)=>ats.axisType === axisType);
        if (!axisSetting) throw new Error(`preProcessFigureInput: required axis "${axisType}" not found in figureSettings`);
        let axis = processedFigureInput.axes.find((a)=>a.axisType === axisType);
        if (!axis) {
            axis = {
                id: crypto.randomUUID(),
                axisType: axisType,
                properties: (0, $2kqnu.fillPropertiesArray)(axisSetting.parameters)
            };
            processedFigureInput.axes.push(axis);
        } else axis.properties = (0, $2kqnu.fillPropertiesArray)(axisSetting.parameters, axis.properties);
    });
    // Check all required properites for dataGroups
    if (processedFigureInput.dataGroups.length > 0) processedFigureInput.dataGroups = processedFigureInput.dataGroups.map((dg)=>({
            ...dg,
            properties: (0, $2kqnu.fillPropertiesArray)(figureTypeSetting.dataRowVars, dg.properties)
        }));
    // Add default number of dataGroups if none exist
    if (processedFigureInput.dataGroups.length === 0) {
        const numberOfSeries = figureTypeSetting.defaultNumberOfSeries ?? 1;
        for(let i = 0; i < numberOfSeries; i++){
            const thisDefaultSeries = figureTypeSetting.defaultSeries?.[Math.floor(i % (figureTypeSetting.defaultSeries?.length ?? 1))];
            const newDataGroup = {
                id: crypto.randomUUID(),
                dataGroupName: `${thisDefaultSeries?.dataGroupName ?? "DataGroup_"}${i + 1}`,
                dataGroupLabel: `${thisDefaultSeries?.dataGroupLabel ?? "Data Group"} ${i + 1}`,
                properties: (0, $2kqnu.fillPropertiesArray)(figureTypeSetting.dataRowVars, thisDefaultSeries?.properties)
            };
            processedFigureInput.dataGroups.push(newDataGroup);
        }
    }
    // Check all required properites for regressionLines
    processedFigureInput.regressionLines = processedFigureInput.regressionLines.map((rl)=>{
        const rlSettings = figureSettings.figureRegressionLineSettings.find((rls)=>rls.lineType === rl.lineType);
        if (!rlSettings) throw new Error(`preProcessFigureInput: regression line type "${rl.lineType}" not found in figureSettings`);
        return {
            ...rl,
            properties: (0, $2kqnu.fillPropertiesArray)(rlSettings.parameters, rl.properties)
        };
    });
    return processedFigureInput;
};

});



parcelRegister("hTZ2b", function(module, exports) {
$parcel$export(module.exports, "AsupInternalTable", function () { return (parcelRequire("1cgCo")).AsupInternalTable; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("9B5Sg")).AitTablePosition; });
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("aVRpe")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2Uw8z")).isGridItemTrafficLight; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("l6aIi")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("l6aIi")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("6GMBM")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("6GMBM")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("gMOiI")).newRowGroup; });
parcelRequire("pul1y");
parcelRequire("iVZ7C");
parcelRequire("e37ix");
parcelRequire("j4dNb");
parcelRequire("dPawg");
parcelRequire("dUiJM");
parcelRequire("cOw5F");
parcelRequire("7oyMA");
parcelRequire("287aM");
parcelRequire("loRW9");
parcelRequire("1Hl8A");
parcelRequire("bP2ZH");
parcelRequire("04gG9");
parcelRequire("65PFO");
parcelRequire("lMDJn");
parcelRequire("ltooE");
parcelRequire("8FBJ2");
parcelRequire("5t8UN");
parcelRequire("ckomf");
parcelRequire("1oqzu");
parcelRequire("dHyIs");
parcelRequire("4wViJ");
parcelRequire("kqBs0");
parcelRequire("1D9Y3");
parcelRequire("h7Arq");
parcelRequire("86OWm");
parcelRequire("aCYgE");
parcelRequire("4h9Ky");
parcelRequire("4CqQL");
parcelRequire("iS2uZ");
parcelRequire("1NrVJ");
parcelRequire("bNi0z");
parcelRequire("eqN7F");
parcelRequire("bVXtb");
parcelRequire("jSLbr");
parcelRequire("SaWDM");
parcelRequire("1MT5N");
parcelRequire("jhDwO");
parcelRequire("fCjoA");
parcelRequire("8IdFZ");
parcelRequire("enKr0");
parcelRequire("aWcoT");
parcelRequire("51lUi");
parcelRequire("1cgCo");
parcelRequire("bDrGf");
parcelRequire("eN4ax");

});
parcelRegister("pul1y", function(module, exports) {

$parcel$export(module.exports, "AitAddColumnButton", function () { return $5e3b162dc5f648d4$export$49075aa79614575a; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $biia9 = parcelRequire("biia9");

var $eN4ax = parcelRequire("eN4ax");

var $9B5Sg = parcelRequire("9B5Sg");
const $5e3b162dc5f648d4$export$49075aa79614575a = ({ originalColumnIndex: originalColumnIndex })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const currentCols = (0, $spJKX.useMemo)(()=>state?.originalTableData.bodyData[0].rows[0].cells.length ?? 0, [
        state
    ]);
    const menuItems = (0, $spJKX.useMemo)(()=>{
        const ret = state ? [
            {
                label: "Add column",
                action: ()=>dispatch({
                        operation: (0, $9B5Sg.ADD_COLUMN),
                        columnIndex: originalColumnIndex,
                        newColumnLength: currentCols + 1
                    })
            }
        ] : [];
        if (state && originalColumnIndex >= 0) ret.push({
            label: "Duplicate previous column",
            action: ()=>dispatch({
                    operation: (0, $9B5Sg.DUPLICATE_COLUMN),
                    columnIndex: originalColumnIndex,
                    newColumnLength: currentCols + 1
                })
        });
        return ret;
    }, [
        currentCols,
        dispatch,
        originalColumnIndex,
        state
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${state.id}-addcol-${originalColumnIndex}`,
        tipText: "Add column",
        "aria-label": "Add column",
        iconName: "aioxPlus",
        menuItems: menuItems,
        style: {
            position: "absolute",
            top: "0",
            right: "-2px"
        }
    });
};
$5e3b162dc5f648d4$export$49075aa79614575a.displayName = "AitAddColumnButton";

});

parcelRegister("iVZ7C", function(module, exports) {

$parcel$export(module.exports, "AitAddRowButton", function () { return $913c2b14d5a1a377$export$ef15b734f74df3b1; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $biia9 = parcelRequire("biia9");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $913c2b14d5a1a377$export$ef15b734f74df3b1 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const thisRowGroup = state && (location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup || location.position === (0, $9B5Sg.AitTablePosition).bodyRow) ? state.originalTableData.bodyData.find((rg)=>rg.aitid === location.rowGroupId) : state && state.originalTableData.headerData ? state.originalTableData.headerData : null;
    const newLength = thisRowGroup ? thisRowGroup.rows.length + 1 : 0;
    const menuItems = (0, $spJKX.useMemo)(()=>{
        const ret = [
            {
                label: "Add row",
                action: ()=>{
                    dispatch({
                        operation: (0, $9B5Sg.ADD_ROW),
                        location: location,
                        newLength: newLength
                    });
                }
            }
        ];
        if (location.position === (0, $9B5Sg.AitTablePosition).headerRow || location.position === (0, $9B5Sg.AitTablePosition).bodyRow) ret.push({
            label: "Duplicate row",
            action: ()=>dispatch({
                    operation: (0, $9B5Sg.DUPLICATE_ROW),
                    location: location,
                    newLength: newLength
                })
        });
        return ret;
    }, [
        dispatch,
        location,
        newLength
    ]);
    return !state || !state.editable || "isRepeat" in location && location.isRepeat ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${id}-add-row`,
        tipText: "Add row",
        iconName: "aioxPlus",
        menuItems: menuItems
    });
};
$913c2b14d5a1a377$export$ef15b734f74df3b1.displayName = "AitAddRowButton";

});
parcelRegister("ickJu", function(module, exports) {

$parcel$export(module.exports, "getBaseId", function () { return $62749b7837ad998a$export$fcd700871ba79533; });

var $9B5Sg = parcelRequire("9B5Sg");
const $62749b7837ad998a$export$fcd700871ba79533 = (location, stateId)=>{
    let id = stateId ?? "table";
    // Table level
    if (location.position === (0, $9B5Sg.AitTablePosition).table) return id;
    // Column level
    if (location.position === (0, $9B5Sg.AitTablePosition).column) {
        id += `~column~${location.columnId}`;
        return id;
    }
    // Row group level
    id += `~${location.tableSection}`;
    if (location.position === (0, $9B5Sg.AitTablePosition).header || location.position === (0, $9B5Sg.AitTablePosition).body) return id;
    // Specific row group
    id += `~rowGroup~${location.rowGroupId}`;
    if (location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup) return id;
    // Row level
    id += `~row~${location.rowId}`;
    if (location.position === (0, $9B5Sg.AitTablePosition).headerRow || location.position === (0, $9B5Sg.AitTablePosition).bodyRow) return id;
    // Cell level
    id += `~cell~${location.cellId}`;
    /* istanbul ignore else */ if (location.position === (0, $9B5Sg.AitTablePosition).headerCell || location.position === (0, $9B5Sg.AitTablePosition).bodyCell) return id;
};

});


parcelRegister("e37ix", function(module, exports) {

$parcel$export(module.exports, "AitAddRowGroupButton", function () { return $f505b1d654928526$export$cd69d962c0fcfa7f; });

var $bR5nk = parcelRequire("bR5nk");

var $biia9 = parcelRequire("biia9");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $f505b1d654928526$export$cd69d962c0fcfa7f = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const currentRowGroupNumber = state?.originalTableData.bodyData.length ?? 0;
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const groupTemplateNames = (Array.isArray(state?.groupTemplates) ? state.groupTemplates.filter((g)=>(g.name ?? "").trim() !== "") : []).map((g)=>g.name).sort((a, b)=>a.localeCompare(b));
    return !thisRowGroup || !state?.editable ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${id}-add-rowgroup`,
        tipText: "Add row group",
        iconName: "aioxPlus",
        menuItems: [
            {
                label: "Add row group",
                action: ()=>dispatch({
                        operation: (0, $9B5Sg.ADD_ROW_GROUP),
                        location: location,
                        newLength: currentRowGroupNumber + 1
                    })
            },
            {
                label: "Duplicate row group",
                action: ()=>dispatch({
                        operation: (0, $9B5Sg.DUPLICATE_ROW_GROUP),
                        location: location,
                        newLength: currentRowGroupNumber + 1
                    })
            },
            {
                label: "Add row group from template",
                group: groupTemplateNames.map((templateName)=>({
                        label: templateName,
                        action: ()=>dispatch({
                                operation: (0, $9B5Sg.ADD_ROW_GROUP),
                                location: location,
                                templateName: templateName,
                                newLength: currentRowGroupNumber + 1
                            })
                    }))
            }
        ]
    });
};
$f505b1d654928526$export$cd69d962c0fcfa7f.displayName = "AitAddRowGroupButton";

});
parcelRegister("lyZtY", function(module, exports) {

$parcel$export(module.exports, "trGetPositionFromLocation", function () { return $d40a2d2cfd2a14e1$export$f7884aed6c5ea447; });

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");
function $d40a2d2cfd2a14e1$export$f7884aed6c5ea447(state, location, processed = false) {
    /* Check state */ if (!state) return {
        data: undefined,
        tableLevel: undefined
    };
    const tableData = processed ? state.processedTableData : state.originalTableData;
    /* Table level */ if (!location || location.position === (0, $9B5Sg.AitTablePosition).table) return {
        tableLevel: (0, $9B5Sg.AitTablePosition).table,
        data: tableData
    };
    else if (location.position === (0, $9B5Sg.AitTablePosition).column) {
        /* Column level - find the column information for this column */ const columnInfo = tableData?.columnInformation.find((ci)=>ci.columnId === location.columnId);
        if (columnInfo) return {
            tableLevel: (0, $9B5Sg.AitTablePosition).column,
            data: columnInfo
        };
        else return {
            data: undefined,
            tableLevel: undefined
        };
    } else if (location.tableSection === (0, $9B5Sg.AitRowType).header && tableData?.headerData) {
        /* Header data */ if (location.position === (0, $9B5Sg.AitTablePosition).headerCell) return {
            tableLevel: location.position,
            data: (0, $9rj0c.trGetCellFromLocation)(tableData, location)
        };
        else if (location.position === (0, $9B5Sg.AitTablePosition).headerRow) return {
            tableLevel: location.position,
            data: tableData.headerData.rows[location.row].aitid === location.rowId ? tableData.headerData.rows[location.row] : undefined
        };
        else return {
            tableLevel: location.position,
            data: tableData?.headerData
        };
    } else if (location.tableSection === (0, $9B5Sg.AitRowType).body && tableData?.bodyData) {
        /* Body data */ /* istanbul ignore else */ if (location.position === (0, $9B5Sg.AitTablePosition).bodyCell) return {
            tableLevel: location.position,
            data: (0, $9rj0c.trGetCellFromLocation)(tableData, location)
        };
        else if (location.position === (0, $9B5Sg.AitTablePosition).bodyRow) return {
            tableLevel: location.position,
            data: tableData.bodyData[location.rowGroup].rows[location.row].aitid === location.rowId ? tableData.bodyData[location.rowGroup].rows[location.row] : undefined
        };
        else if (location.position === (0, $9B5Sg.AitTablePosition).bodyRowGroup) return {
            tableLevel: location.position,
            data: tableData.bodyData[location.rowGroup]
        };
        else if (location.position === (0, $9B5Sg.AitTablePosition).body) return {
            tableLevel: location.position,
            data: tableData.bodyData
        };
    }
    return {
        data: undefined,
        tableLevel: undefined
    };
}

});


parcelRegister("j4dNb", function(module, exports) {

$parcel$export(module.exports, "AitBlankRow", function () { return $e333969399d45daa$export$4d92939def9257e4; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $eN4ax = parcelRequire("eN4ax");
const $e333969399d45daa$export$4d92939def9257e4 = ({ id: id, border: border })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const processedTableData = state?.processedTableData;
    const columnRepeats = processedTableData?.columnRepeats;
    const cis = columnRepeats ? Array.from(Array(columnRepeats.length).keys()) : undefined;
    return !cis ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("tr", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("td", {}),
            cis.map((ci)=>/*#__PURE__*/ (0, $bR5nk.jsx)("td", {
                    className: border ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitBorderCell : (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitSpaceCell
                }, ci)),
            /*#__PURE__*/ (0, $bR5nk.jsx)("td", {})
        ]
    });
};
$e333969399d45daa$export$4d92939def9257e4.displayName = "AitBlankRow";

});

parcelRegister("dPawg", function(module, exports) {

$parcel$export(module.exports, "AitBorderRow", function () { return $360d949840c02322$export$6f67978067436e20; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $pul1y = parcelRequire("pul1y");

var $j4dNb = parcelRequire("j4dNb");

var $lMDJn = parcelRequire("lMDJn");

var $51lUi = parcelRequire("51lUi");

var $eN4ax = parcelRequire("eN4ax");
const $360d949840c02322$export$6f67978067436e20 = (props)=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const topRow = state?.processedTableData?.headerData && state.processedTableData.headerData.rows.length > 0 ? state.processedTableData.headerData.rows[0].cells : state?.processedTableData?.bodyData && state.processedTableData.bodyData.length > 0 ? state.processedTableData.bodyData[0].rows[0].cells : [];
    const originalTopRow = state?.originalTableData.headerData && state.originalTableData.headerData.rows.length > 0 ? state.originalTableData.headerData.rows[0].cells : state?.originalTableData.bodyData && state.originalTableData.bodyData.length > 0 ? state.originalTableData.bodyData[0].rows[0].cells : [];
    const cis = topRow.map((c)=>({
            aitid: c.aitid,
            originalIx: originalTopRow.findIndex((o)=>c.aitid === o.aitid),
            columnId: c.columnId
        }));
    return !state || !state.processedTableData?.columnRepeats ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            props.topBorder && /*#__PURE__*/ (0, $bR5nk.jsxs)("tr", {
                id: `${props.id}`,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
                        children: state.editable && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: (0, $3tKzd.classMerge)([
                                (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
                                (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitColumnButtons
                            ]),
                            style: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $pul1y.AitAddColumnButton), {
                                originalColumnIndex: -1
                            })
                        })
                    }),
                    cis.map((c, ci)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $51lUi.AitTopBorderCell), {
                            cellid: c.aitid,
                            columnIndex: ci,
                            originalColumnIndex: c.originalIx,
                            columnId: c.columnId
                        }, ci)),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("td", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
                        style: {
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lMDJn.AitColumnTrafficLight), {
                            cellid: "final"
                        })
                    })
                ]
            }),
            props.spaceBefore && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j4dNb.AitBlankRow), {
                id: `${props.id}-spacebeforerow`
            }),
            !props.noBorder && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j4dNb.AitBlankRow), {
                id: `${props.id}-borderrow`,
                border: true
            }),
            props.spaceAfter && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j4dNb.AitBlankRow), {
                id: `${props.id}-spaceafterrow`
            })
        ]
    });
};
$360d949840c02322$export$6f67978067436e20.displayName = "AitBorderRow";

});
parcelRegister("lMDJn", function(module, exports) {

$parcel$export(module.exports, "AitColumnTrafficLight", function () { return $68d83641426b77eb$export$4b8588d67f997cd2; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $6r4yf = parcelRequire("6r4yf");

var $eN4ax = parcelRequire("eN4ax");
const $68d83641426b77eb$export$4b8588d67f997cd2 = ({ cellid: cellid })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    // Find all columns matching this cellid
    const matchingColumns = state?.processedTableData?.changedColumns?.filter((dc)=>dc.idAfterTrafficLightIsShown === cellid || dc.idAfterTrafficLightIsShown === "" && cellid === "final") ?? [];
    const tlValues = matchingColumns.length === 0 ? [
        "BlankNotEvaluated"
    ] : matchingColumns.map((col)=>col.coreTrafficLight);
    const thisTrafficLight = !state?.noTrafficLights && tlValues.some((v)=>v !== "BlankNotEvaluated" && v !== "none") ? new (0, $6r4yf.MosaicTrafficLightClass)(tlValues, "-16px", "-8px").element : null;
    return !thisTrafficLight ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).absoluteLeft0,
        children: thisTrafficLight
    });
};
$68d83641426b77eb$export$4b8588d67f997cd2.displayName = "AitColumnTrafficLight";

});

parcelRegister("51lUi", function(module, exports) {

$parcel$export(module.exports, "AitTopBorderCell", function () { return $9aec6b415b47135c$export$d3c63ae19ffd01aa; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $pul1y = parcelRequire("pul1y");

var $04gG9 = parcelRequire("04gG9");

var $lMDJn = parcelRequire("lMDJn");

var $kqBs0 = parcelRequire("kqBs0");

var $eN4ax = parcelRequire("eN4ax");
const $9aec6b415b47135c$export$d3c63ae19ffd01aa = ({ columnIndex: columnIndex, originalColumnIndex: originalColumnIndex, cellid: cellid, columnId: columnId })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const tableData = state?.processedTableData;
    const isColumnRepeat = tableData && tableData.columnRepeats && tableData.columnRepeats.length > columnIndex && tableData.columnRepeats[columnIndex].colRepeat !== undefined && (tableData.columnRepeats[columnIndex].isRepeat || tableData.columnRepeats[columnIndex].colRepeat?.match(/^[[\]0,]+$/) === null) ? true : false;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 0;
    const maxColumnIndex = (tableData?.bodyData[0].rows[0].cells.length ?? 0) - 1;
    return !tableData ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
        style: {
            position: "relative"
        },
        children: isColumnRepeat || originalColumnIndex === -1 ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lMDJn.AitColumnTrafficLight), {
                    cellid: cellid
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $04gG9.AitColumnAnnotationButton), {
                    originalColumnIndex: originalColumnIndex,
                    columnId: columnId
                }),
                state?.editable && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: (0, $3tKzd.classMerge)([
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
                        (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitColumnButtons
                    ]),
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        position: "relative",
                        width: "100%"
                    },
                    children: [
                        !(rowHeaderColumns === 1 && columnIndex === 0) && !(columnIndex === rowHeaderColumns && columnIndex === maxColumnIndex) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kqBs0.AitRemoveColumnButton), {
                            originalColumnIndex: originalColumnIndex
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $pul1y.AitAddColumnButton), {
                            originalColumnIndex: originalColumnIndex
                        })
                    ]
                })
            ]
        })
    }, columnIndex);
};
$9aec6b415b47135c$export$d3c63ae19ffd01aa.displayName = "AitTopBorderCell";

});
parcelRegister("04gG9", function(module, exports) {

$parcel$export(module.exports, "AitColumnAnnotationButton", function () { return $15b6bd0bd62bd373$export$d7b7b867019d7ed7; });

var $bR5nk = parcelRequire("bR5nk");

var $8xj55 = parcelRequire("8xj55");

var $eN4ax = parcelRequire("eN4ax");

var $9B5Sg = parcelRequire("9B5Sg");
const $15b6bd0bd62bd373$export$d7b7b867019d7ed7 = ({ originalColumnIndex: originalColumnIndex, columnId: columnId })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    if (!state || originalColumnIndex < 0 || !columnId) return null;
    // Get the annotation from the columnInformation list using columnId
    const columnAnnotation = state.originalTableData.columnInformation.find((ci)=>ci.columnId === columnId)?.annotation;
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
        buttonId: `column-${columnId}-annotation`,
        annotationType: "Column",
        annotationLocation: {
            position: (0, $9B5Sg.AitTablePosition).column,
            originalColumn: originalColumnIndex,
            columnId: columnId
        },
        existingAnnotation: columnAnnotation,
        hidden: state.tlfViewMode.value !== "ANNOTATIONS",
        showPreview: false
    });
};
$15b6bd0bd62bd373$export$d7b7b867019d7ed7.displayName = "AitColumnAnnotationButton";

});
parcelRegister("8xj55", function(module, exports) {

$parcel$export(module.exports, "AnnotationButton", function () { return $9df86c8aeab6b12f$export$6716fe781c56d87e; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");

var $hrmRP = parcelRequire("hrmRP");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $spJKX = parcelRequire("spJKX");

var $b9tE1 = parcelRequire("b9tE1");
var $gCZ2V = parcelRequire("gCZ2V");

var $cMhqQ = parcelRequire("cMhqQ");

var $2o69n = parcelRequire("2o69n");
const $9df86c8aeab6b12f$export$6716fe781c56d87e = ({ existingAnnotation: existingAnnotation, annotationType: annotationType, annotationLocation: annotationLocation, buttonId: buttonId, hidden: hidden = false, showPreview: showPreview = false, repositionKey: repositionKey })=>{
    const ref = (0, $spJKX.useRef)(null);
    const [showAnnotationModal, setShowAnnotationModal] = (0, $spJKX.useState)(false);
    const annotationActionText = !existingAnnotation ? `Add ${annotationType} annotation` : `Edit ${annotationType} annotation`;
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const canEdit = !tlfContext.tlfData || !tlfContext.readOnly;
    // Determine bubble position based on annotation type
    const bubblePosition = annotationType === "Column" ? "top" : annotationType === "Row" ? "right" : "left";
    return hidden ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("button", {
                id: buttonId,
                type: "button",
                title: annotationActionText,
                "aria-label": annotationActionText,
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).annotationBtn,
                    !existingAnnotation ? (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).empty : undefined
                ]),
                onClick: ()=>setShowAnnotationModal(true),
                style: {
                    position: "relative"
                },
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).glyph,
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).icon,
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).letter,
                                    children: "A"
                                }),
                                canEdit && /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).hoverIcon,
                                    children: !existingAnnotation ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
                                        size: 12
                                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b9tE1.default), {
                                        size: 12
                                    })
                                })
                            ]
                        })
                    }),
                    showPreview && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2o69n.AnnotationPreviewBubble), {
                        annotation: existingAnnotation,
                        position: bubblePosition,
                        target: ref,
                        repositionKey: repositionKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hrmRP.AnnotationContextWindow), {
                isOpen: showAnnotationModal,
                onClose: ()=>setShowAnnotationModal(false),
                annotationLocation: annotationLocation,
                annotationType: annotationType,
                contextAnnotation: existingAnnotation,
                disabled: !canEdit
            })
        ]
    });
};
$9df86c8aeab6b12f$export$6716fe781c56d87e.displayName = "AnnotationButton";

});
parcelRegister("hrmRP", function(module, exports) {

$parcel$export(module.exports, "AnnotationContextWindow", function () { return $a6dbe6485ec9fb80$export$382cf34d7a242f86; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $bgW0G = parcelRequire("bgW0G");

var $2Mlm8 = parcelRequire("2Mlm8");

var $3Avah = parcelRequire("3Avah");

var $spJKX = parcelRequire("spJKX");

var $kP8DJ = parcelRequire("kP8DJ");
var $eZYX7 = parcelRequire("eZYX7");

var $faZLv = parcelRequire("faZLv");

var $aZmF8 = parcelRequire("aZmF8");

var $dcaxa = parcelRequire("dcaxa");

var $eKE9M = parcelRequire("eKE9M");

var $8nKxe = parcelRequire("8nKxe");

var $hE0Dg = parcelRequire("hE0Dg");

var $5qQ7a = parcelRequire("5qQ7a");

var $2cGNP = parcelRequire("2cGNP");

var $aITpv = parcelRequire("aITpv");

var $hVLQ5 = parcelRequire("hVLQ5");
const $a6dbe6485ec9fb80$export$382cf34d7a242f86 = ({ isOpen: isOpen, onClose: onClose, annotationType: annotationType, annotationLocation: annotationLocation, contextAnnotation: contextAnnotation, disabled: disabled = false })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const [isPending, startTransition] = (0, $spJKX.useTransition)();
    const clinicalLibrary = hierarchyContext?.hierarchy && !hierarchyContext?.isClinicalLibraryLoading ? (0, $bgW0G.getClinicalDataWithInheritance)(hierarchyContext.parentTemplates.clinicalDatasets, hierarchyContext.parentTemplates.clinicalCodeLists, hierarchyContext.parentTemplates.clinicalValueLists, hierarchyContext.parentTemplates.clinicalComments, hierarchyContext.parentTemplates.clinicalMethods, hierarchyContext.parentTemplates.clinicalWhereClauses, hierarchyContext.hierarchy.clinicalLibrary) : undefined;
    const { formState: formState, updateFormField: updateFormField, resetForm: resetForm, restoreInitial: restoreInitial, isFormValid: isFormValid, canAddNewClause: canAddNewClause, canRemoveClause: canRemoveClause, initialAnnotation: initialAnnotation, buildFinalAnnotation: buildFinalAnnotation, isUnchanged: isUnchanged, setDatasetAndVariable: setDatasetAndVariable, currentClauseIndex: currentClauseIndex, goToPreviousClause: goToPreviousClause, goToNextClause: goToNextClause, addNewWhereClause: addNewWhereClause, removeCurrentClause: removeCurrentClause, codeLists: codeLists, comparatorTypes: comparatorTypes, previewText: previewText, totalClauseCount: totalClauseCount } = (0, $hVLQ5.useAnnotationContextWindow)({
        annotationLocation: annotationLocation,
        annotationType: annotationType,
        clinicalLibrary: clinicalLibrary,
        initialAnnotation: contextAnnotation
    });
    const datasets = clinicalLibrary?.clinicalDatasets ?? [];
    const isClinicalLibraryAvailable = clinicalLibrary && clinicalLibrary.clinicalDatasets && clinicalLibrary.clinicalDatasets.length > 0;
    /**
   * Handler for primary variable selection in "dataset.variable" format.
   * Parses the format and updates both dataset and variable fields atomically.
   *
   * @param value - Selected value in "dataset.variable" format
   */ const handlePrimaryVariableChange = (value)=>{
        const parts = value.split(".");
        /* istanbul ignore else -- ControlTypeAhead only calls setValue with values from availableList, which are always in "dataset.variable" format */ if (parts.length === 2) {
            const [datasetName, variableName] = parts;
            setDatasetAndVariable(datasetName, variableName);
        }
    };
    /**
   * Get current primary variable value in "dataset.variable" format
   */ const primaryVariableValue = formState.selectedDataset && formState.selectedVariable ? `${formState.selectedDataset}.${formState.selectedVariable.name}` : "";
    /**
   * Handler for companion variables changes
   *
   * @param state - State object containing companion variables array
   * @param state.companionVariables - Array of companion variables with their types and values
   */ const handleCompanionsChange = (state)=>{
        updateFormField("companionVariables", state.companionVariables);
    };
    const contextDisplayText = (0, $hE0Dg.getContextDisplayText)(annotationLocation);
    /**
   * Cancel handler for the annotation modal.
   * Restores initial annotation if editing, otherwise resets form to defaults.
   */ const handleCancel = ()=>{
        if (initialAnnotation) restoreInitial();
        else resetForm();
        onClose();
    };
    /**
   * Save handler for the annotation modal.
   * Builds the final annotation and dispatches updates to the TLF context.
   * Uses startTransition to show a loader on the save button during the operation.
   */ const handleSave = ()=>{
        startTransition(()=>{
            const finalAnnotation = buildFinalAnnotation();
            // Handle table body annotations
            /* istanbul ignore else */ if (tlfContext && annotationLocation && (0, $3Avah.isTlfItemReadDto)(tlfContext.tlfData)) {
                const body = tlfContext.tlfData.body;
                const updatedTableData = (0, $aITpv.updateTableDataWithAnnotations)(body, annotationLocation, finalAnnotation);
                tlfContext.dispatch({
                    operation: (0, $2Mlm8.UPDATE_TLF),
                    calledFrom: "AnnotationContextWindow: TableBody",
                    tlfData: {
                        body: updatedTableData
                    }
                });
            } else if (tlfContext && annotationType === "PageBy" && (0, $3Avah.isTlfItemReadDto)(tlfContext.tlfData) && (0, $3Avah.isEditorPageBy)(tlfContext.tlfData.pageBy)) tlfContext.dispatch({
                operation: (0, $2Mlm8.UPDATE_TLF),
                calledFrom: "AnnotationContextWindow: PageBy",
                tlfData: {
                    pageBy: {
                        content: tlfContext.tlfData.pageBy.content,
                        annotation: finalAnnotation
                    }
                }
            });
            // Reset form if this was a new annotation (not editing existing)
            /* istanbul ignore else */ if (!initialAnnotation) resetForm();
            onClose();
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: `annotation-modal-${annotationType}${contextDisplayText}`,
        title: `Select ${annotationType} annotation ${contextDisplayText}`,
        visible: isOpen,
        onClose: handleCancel,
        style: {
            width: "600px",
            minHeight: "500px",
            maxHeight: "80vh",
            maxWidth: "90vw"
        },
        children: hierarchyContext && hierarchyContext.isClinicalLibraryLoading ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
            variant: "info",
            children: "Loading clinical library data. This may take a few seconds..."
        }) : !isClinicalLibraryAvailable ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
            variant: "warning",
            children: "No clinical library data is available. Clinical libraries must be loaded at the hierarchy level to use annotations."
        }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default), {
            style: {
                padding: "16px",
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aZmF8.AnnotationNavigationHeader), {
                    currentClauseIndex: currentClauseIndex,
                    totalClauseCount: totalClauseCount,
                    canRemoveClause: canRemoveClause,
                    canAddNewClause: canAddNewClause,
                    disabled: disabled,
                    onPrevious: goToPreviousClause,
                    onNext: goToNextClause,
                    onRemove: removeCurrentClause,
                    onAdd: addNewWhereClause
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5qQ7a.PrimaryVariableSelector), {
                    datasets: datasets,
                    selectedValue: primaryVariableValue,
                    onChange: handlePrimaryVariableChange,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8nKxe.CompanionVariableControl), {
                    datasets: datasets,
                    primaryDataset: formState.selectedDataset,
                    companionVariables: formState.companionVariables,
                    onChange: handleCompanionsChange,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2cGNP.TerminologySelector), {
                    formState: formState,
                    codeLists: codeLists,
                    comparatorTypes: comparatorTypes,
                    updateFormField: updateFormField,
                    disabled: disabled
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {
                    className: "my-3"
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: "mb-2",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eKE9M.AnnotationPreview), {
                            previewText: previewText
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dcaxa.AnnotationNotesField), {
                            value: formState.additionalNotes ?? // istanbul ignore next
                            "",
                            onChange: (value)=>updateFormField("additionalNotes", value),
                            disabled: disabled
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $faZLv.AnnotationActionButtons), {
                    isUnchanged: isUnchanged,
                    isFormValid: isFormValid,
                    isClinicalLibraryAvailable: isClinicalLibraryAvailable,
                    disabled: disabled,
                    onReset: restoreInitial,
                    onCancel: handleCancel,
                    onSave: handleSave,
                    isPending: isPending
                })
            ]
        })
    });
};
$a6dbe6485ec9fb80$export$382cf34d7a242f86.displayName = "AnnotationContextWindow";

});
parcelRegister("3tNrK", function(module, exports) {

$parcel$export(module.exports, "unifiedInitialState", function () { return $8ad306d230fa4ad1$export$f989076045d6f27b; });
$parcel$export(module.exports, "AppSettingsContext", function () { return $8ad306d230fa4ad1$export$759b9d795f2426a4; });
$parcel$export(module.exports, "useAppSettings", function () { return $8ad306d230fa4ad1$export$f77a225b49e0e356; });
$parcel$export(module.exports, "useHierarchyContext", function () { return $8ad306d230fa4ad1$export$b04f4289a6970a95; });
$parcel$export(module.exports, "useTocContext", function () { return $8ad306d230fa4ad1$export$4605dc24e6d468d4; });
$parcel$export(module.exports, "useTlfContext", function () { return (parcelRequire("9Q1dr")).useTlfContext; });

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $5hPwN = parcelRequire("5hPwN");

var $4W4lB = parcelRequire("4W4lB");

var $1L6jF = parcelRequire("1L6jF");

var $6hDeY = parcelRequire("6hDeY");

var $9Q1dr = parcelRequire("9Q1dr");
const $8ad306d230fa4ad1$export$f989076045d6f27b = {
    ...(0, $5hPwN.defaultSettings),
    saveRequest: {
        requesting: false,
        error: false
    },
    undoHistory: [],
    undoIndex: 0,
    hierarchyState: (0, $4W4lB.hierarchyInitialState),
    tocState: (0, $6hDeY.tocInitialState),
    tlfState: (0, $1L6jF.tlfInitialState)
};
const $8ad306d230fa4ad1$export$759b9d795f2426a4 = (0, $spJKX.createContext)({
    state: $8ad306d230fa4ad1$export$f989076045d6f27b,
    dispatch: // istanbul ignore next
    ()=>{}
});
const $8ad306d230fa4ad1$export$f77a225b49e0e356 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)($8ad306d230fa4ad1$export$759b9d795f2426a4);
    return {
        ...state,
        dispatch: dispatch
    };
};
const $8ad306d230fa4ad1$export$b04f4289a6970a95 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)($8ad306d230fa4ad1$export$759b9d795f2426a4);
    if (state.hierarchyState === (0, $4W4lB.hierarchyInitialState)) return null;
    const hierarchyState = state.hierarchyState;
    const title = hierarchyState.hierarchy ? `${hierarchyState.hierarchy.name}` : `Loading hierarchy... ${hierarchyState.id}`;
    return {
        ...hierarchyState,
        dispatch: dispatch,
        title: title
    };
};
const $8ad306d230fa4ad1$export$4605dc24e6d468d4 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)($8ad306d230fa4ad1$export$759b9d795f2426a4);
    return {
        state: {
            ...state.tocState,
            readOnly: state.hierarchyState.hierarchy?.isBackupVersion || !state.hierarchyState.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy)
        },
        dispatch: dispatch,
        tocRequest: state.tocState.tocRequestStatus
    };
};

});
parcelRegister("5hPwN", function(module, exports) {

$parcel$export(module.exports, "defaultSettings", function () { return $fb02b90221220994$export$62680b65e63e14ec; });

var $4lHS7 = parcelRequire("4lHS7");

var $coMcc = parcelRequire("coMcc");
const $fb02b90221220994$var$defaultDownloadOptions = [
    {
        label: "Standard notes",
        selected: true,
        propertiesKey: "Notes"
    },
    {
        label: "Programmer notes",
        selected: true,
        propertiesKey: "ProgrammerNotes"
    },
    {
        label: "SAP reference",
        selected: true,
        propertiesKey: "SapReference"
    },
    {
        label: "Program name",
        selected: true,
        propertiesKey: "ProgramName"
    },
    {
        label: "Output name",
        selected: true,
        propertiesKey: "OutputName"
    }
];
const $fb02b90221220994$export$775d9407c4c2c2da = [
    {
        key: "domainList",
        value: "",
        type: "string",
        label: "Available domains",
        /**
     * Validate the `domainList` value using a comparator object.
     *
     * @param _ - Unused first parameter kept for signature compatibility.
     * @param c - Comparator object containing the value to validate.
     * @returns A promise resolving to the validation result object.
     */ validCondition: async (_, c)=>({
                success: true,
                data: {
                    valid: c.value.match(/^[A-Z,]+$/) !== null,
                    validationText: c.value.match(/^[A-Z,]+$/) === null ? "Domains must be uppercase and separated by commas" : ""
                }
            })
    }
];
const $fb02b90221220994$var$TAProps = [
    (0, $coMcc.createHierarchyTagProperty)((0, $4lHS7.eHierarchyLevel).TA)
];
const $fb02b90221220994$var$ProjectProps = [
    (0, $coMcc.createHierarchyTagProperty)((0, $4lHS7.eHierarchyLevel).Project, "D")
];
const $fb02b90221220994$export$4b7587805fb94eb6 = [
    (0, $coMcc.createHierarchyTagProperty)((0, $4lHS7.eHierarchyLevel).Study),
    {
        key: "description",
        value: "",
        type: "textarea",
        label: "Description"
    },
    {
        key: "phase",
        value: "",
        type: "string",
        label: "Phase"
    },
    {
        key: "status",
        value: "Not started",
        type: "select",
        label: "Status",
        allowedValues: [
            "Not started",
            "In progress",
            "Completed"
        ]
    },
    {
        key: "studyStandardsDate",
        value: new Date(Date()).toISOString().slice(0, 11) + "00:00:00.000Z",
        type: "datetime-local",
        label: "Standards date",
        futureBad: true,
        blankBad: true,
        permissionRequired: [
            (0, $4lHS7.eApplicationPermission).AllowStudyStandardDateEdit
        ]
    }
];
const $fb02b90221220994$var$ReportProps = [
    {
        key: "description",
        value: "",
        type: "textarea",
        label: "Description"
    },
    {
        key: "reportType",
        value: "",
        type: "string",
        label: "Report type"
    }
];
const $fb02b90221220994$export$62680b65e63e14ec = {
    appSettingsLoaded: true,
    applicationPermissions: [],
    backEndUrl: "http://localhost:5218/",
    backEndVersion: "0.0.0",
    colWidthMod: 4.4,
    crystalUrl: "https://localhost:5000/",
    defaultColumnWidth: 30,
    defaultDownloadOptions: $fb02b90221220994$var$defaultDownloadOptions,
    defaultLevelProperties: {
        Corporate: $fb02b90221220994$export$775d9407c4c2c2da,
        TA: $fb02b90221220994$var$TAProps,
        Project: $fb02b90221220994$var$ProjectProps,
        Study: $fb02b90221220994$export$4b7587805fb94eb6,
        Report: $fb02b90221220994$var$ReportProps
    },
    defaultTableStyle: {
        fontFamily: "Courier New",
        fontSize: "9pt",
        fontWeight: 500
    },
    displayName: "DEFAULT NoAuth",
    domain: "astrazeneca.net",
    figureSettings: {
        figureTypeSettings: [],
        figureProperties: [],
        figureAxisSettings: [],
        figureLegendSettings: [],
        figureRegressionLineSettings: [],
        figureReferenceLinesSettings: []
    },
    helpLinks: [],
    isAdmin: false,
    maintenanceMessage: "",
    maintenanceMode: false,
    prid: "no-prid",
    styles: [],
    annotationComparatorTypes: [],
    userId: 0,
    saveBlockers: new Set(),
    allowedReportTypes: []
};

});
parcelRegister("coMcc", function(module, exports) {

$parcel$export(module.exports, "createHierarchyTagProperty", function () { return $4f77d266e3584755$export$79c7e0752e2e9ff2; });

var $bLw4O = parcelRequire("bLw4O");

var $8jG7Z = parcelRequire("8jG7Z");
const $4f77d266e3584755$export$79c7e0752e2e9ff2 = (level, value = "")=>{
    const tagInfo = (0, $bLw4O.getHierarchyTagInfo)(level);
    return {
        key: tagInfo.key,
        value: value,
        type: "hierarchyTag",
        label: tagInfo.label,
        mandatory: true,
        validCondition: (0, $8jG7Z.checkTag)(level, tagInfo.description, tagInfo.validationText)
    };
};

});
parcelRegister("bLw4O", function(module, exports) {

$parcel$export(module.exports, "getHierarchyTagInfo", function () { return $8648b78f4940b800$export$1f43db1b1dc198e9; });

var $4lHS7 = parcelRequire("4lHS7");
const $8648b78f4940b800$export$1f43db1b1dc198e9 = (level)=>{
    switch(level){
        case (0, $4lHS7.eHierarchyLevel).Corporate:
            return {
                label: "Corporate tag",
                description: "corporate tag",
                key: "hierarchyTag",
                validationText: ""
            };
        case (0, $4lHS7.eHierarchyLevel).TA:
            return {
                label: "TA prefix",
                description: "TA prefix",
                key: "taPrefix",
                validationText: "Prefix must be 2 or 3 upper case characters"
            };
        case (0, $4lHS7.eHierarchyLevel).Project:
            return {
                label: "Project code",
                description: "project code",
                key: "projectCode",
                validationText: "Project code must begin with D followed by 3 digits"
            };
        case (0, $4lHS7.eHierarchyLevel).Study:
            return {
                label: "D number",
                description: "D number",
                key: "dNumber",
                validationText: "Field should be D followed by 10 characters"
            };
        case (0, $4lHS7.eHierarchyLevel).Report:
            return {
                label: "Report tag",
                description: "report tag",
                key: "hierarchyTag",
                validationText: ""
            };
        default:
            return {
                label: "Hierarchy tag",
                description: "hierarchy tag",
                key: "hierarchyTag",
                validationText: ""
            };
    }
};

});

parcelRegister("8jG7Z", function(module, exports) {

$parcel$export(module.exports, "checkTag", function () { return $2caa384e10f1f9f2$export$36711d2e9c2363c8; });

var $4lHS7 = parcelRequire("4lHS7");
/**
 * Regex patterns for validating hierarchy tags at each level, matching the backend validation rules:
 * - TA: exactly 2 or 3 uppercase letters
 * - Project: D followed by 3 digits, then optional letters, digits, spaces, underscores, or hyphens
 * - Study: D followed by 3 digits, 2 uppercase alphanumeric characters, then exactly 5 digits
 */ const $2caa384e10f1f9f2$var$tagPatterns = {
    [(0, $4lHS7.eHierarchyLevel).TA]: /^[A-Z]{2,3}$/,
    [(0, $4lHS7.eHierarchyLevel).Project]: /^D\d{3}[A-Za-z0-9 _-]*$/,
    [(0, $4lHS7.eHierarchyLevel).Study]: /^D[0-9]{3}[A-Z0-9]{2}[0-9]{5}$/
};
const $2caa384e10f1f9f2$export$36711d2e9c2363c8 = (level, tagDesc, helpText)=>async (_backEndUrl, target, _controller)=>{
        // Short-circuit if the value hasn't changed
        if (target.options?.previousValue === target.value) return {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
        // Return help text for empty values
        if (target.value === "") return {
            success: true,
            data: {
                valid: false,
                validationText: helpText
            }
        };
        // Format validation using level-specific regex pattern
        const pattern = $2caa384e10f1f9f2$var$tagPatterns[level];
        if (pattern && !pattern.test(target.value)) return {
            success: true,
            data: {
                valid: false,
                validationText: helpText
            }
        };
        // Uniqueness check using sibling tag list from context
        if (target.options?.existingValues?.includes(target.value)) return {
            success: true,
            data: {
                valid: false,
                validationText: `This ${tagDesc} is already in use`
            }
        };
        return {
            success: true,
            data: {
                valid: true,
                validationText: ""
            }
        };
    };

});



parcelRegister("4W4lB", function(module, exports) {

$parcel$export(module.exports, "hierarchyInitialState", function () { return $3b38534e5aef6b0d$export$3c7483feed2a7f6b; });
const $3b38534e5aef6b0d$export$3c7483feed2a7f6b = {
    id: "",
    accessRights: [],
    changed: false,
    hierarchyNodes: [],
    parentTemplates: {
        clinicalDatasets: [],
        clinicalCodeLists: [],
        clinicalValueLists: [],
        clinicalComments: [],
        clinicalMethods: [],
        clinicalWhereClauses: [],
        domainReplacements: [],
        lists: [],
        rowGroups: [],
        singles: [],
        analysisSets: [],
        analysisMethods: [],
        dataSubsets: [],
        groupingFactors: []
    },
    prefix: "",
    commentPanelStatus: {
        highlightCommentId: "",
        activeRelatedTo: "",
        showComments: false,
        commentFilter: "all"
    },
    doGetAccessRights: false,
    doTocSave: false,
    hierarchy: null,
    isClinicalLibraryLoading: false,
    isSubscribed: false,
    saveRequestStatus: {
        requesting: false,
        error: false
    },
    saveTocRequestStatus: {
        requesting: false,
        error: false
    },
    savedHierarchy: null,
    tlfItemIndex: null,
    isNameChanged: false
};

});

parcelRegister("1L6jF", function(module, exports) {

$parcel$export(module.exports, "tlfInitialState", function () { return $ce8779da94314030$export$1787cd27aeb7cc5e; });

var $dbVjd = parcelRequire("dbVjd");

var $4lHS7 = parcelRequire("4lHS7");
const $ce8779da94314030$export$1787cd27aeb7cc5e = {
    changed: false,
    activeVariantPatchName: null,
    activeVariantPatchInvalidOps: [],
    appliedVariantPatches: [],
    commentPanelStatus: {
        highlightCommentId: "",
        activeRelatedTo: "",
        showComments: false,
        commentFilter: "all"
    },
    editorBlocksSearchPanelStatus: {
        showSearchPanel: false,
        searchText: "",
        blocksToSearch: Object.values((0, $4lHS7.SearchableEditorBlocks))
    },
    forcePushToParent: false,
    isSubscribed: false,
    isTlfNew: false,
    masterTlfData: null,
    readOnly: false,
    receivedMessages: [],
    requestStatus: {
        requesting: false,
        error: false
    },
    showModalWindow: "",
    showCreateVariantPatchWindow: false,
    showTrafficLights: true,
    tlfData: null,
    savedTlfData: null,
    tlfViewMode: (0, $dbVjd.TLF_VIEW_MODES)[0],
    variantCreationView: false
};

});

parcelRegister("6hDeY", function(module, exports) {

$parcel$export(module.exports, "tocInitialState", function () { return $0c85f7d1c0e7aca8$export$b43c86e3b65fe4b6; });

var $4lHS7 = parcelRequire("4lHS7");
const $0c85f7d1c0e7aca8$export$b43c86e3b65fe4b6 = {
    blocked: false,
    changed: false,
    hierarchyId: "",
    readOnly: true,
    receivedMessages: [],
    removedItems: [],
    saving: false,
    saveError: false,
    searchText: "",
    sendUpdate: false,
    showTypes: Object.values((0, $4lHS7.eTlfItemType)),
    showTiFo: (0, $4lHS7.eShowTiFo).ToC,
    tocItems: [],
    commentsFilter: "all",
    lastMinorVersionSavedAt: null,
    lastMajorVersionSavedAt: 0,
    tocRequestStatus: {
        requesting: false,
        error: false
    },
    showSaveAlert: false,
    tocIdFromMessage: undefined,
    showNeedRefresh: false
};

});

parcelRegister("9Q1dr", function(module, exports) {

$parcel$export(module.exports, "useTlfContext", function () { return $0461ebe965341272$export$e82c27c02bea6148; });

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $3tNrK = parcelRequire("3tNrK");
const $0461ebe965341272$export$e82c27c02bea6148 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)((0, $3tNrK.AppSettingsContext));
    const { hierarchyState: hierarchyState, tlfState: tlfState } = state;
    const readOnly = tlfState.readOnly || hierarchyState.hierarchy?.isBackupVersion === true || !hierarchyState.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) || tlfState.tlfData !== null && ![
        (0, $4lHS7.eReleaseStatus).Draft,
        (0, $4lHS7.eReleaseStatus).ReleasePending
    ].includes(tlfState.tlfData.releaseStatus);
    return {
        ...tlfState,
        dispatch: dispatch,
        readOnly: readOnly
    };
};
$0461ebe965341272$export$e82c27c02bea6148.displayName = "useTlfContext";

});


parcelRegister("bgW0G", function(module, exports) {

$parcel$export(module.exports, "getClinicalDataWithInheritance", function () { return $5157763fc8ee6ed9$export$35e718bcf13f7e1a; });
const $5157763fc8ee6ed9$export$35e718bcf13f7e1a = (parentClinicalDatasets, parentClinicalCodeLists, parentClinicalValueLists, parentClinicalComments, parentClinicalMethods, parentClinicalWhereClauses, currentLibrary)=>{
    if (!currentLibrary) return {
        clinicalDatasets: parentClinicalDatasets,
        clinicalCodeLists: parentClinicalCodeLists,
        clinicalValueLists: parentClinicalValueLists,
        clinicalComments: parentClinicalComments,
        clinicalMethods: parentClinicalMethods,
        clinicalWhereClauses: parentClinicalWhereClauses
    };
    // merge parent data with current data (current takes precedence)
    return {
        clinicalDatasets: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalDatasets, currentLibrary.clinicalDatasets, (d)=>d.oid),
        clinicalCodeLists: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalCodeLists, currentLibrary.clinicalCodeLists, (c)=>c.oid),
        clinicalValueLists: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalValueLists, currentLibrary.clinicalValueLists, (v)=>v.oid),
        clinicalComments: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalComments, currentLibrary.clinicalComments, (c)=>c.oid),
        clinicalMethods: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalMethods, currentLibrary.clinicalMethods, (m)=>m.oid),
        clinicalWhereClauses: $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData(parentClinicalWhereClauses, currentLibrary.clinicalWhereClauses, (w)=>w.oid)
    };
};
/**
 * Efficiently merges inherited (parent) items with current items, ensuring current items override parent duplicates.
 *
 * This function uses Set-based deduplication for optimal performance when dealing with large datasets.
 * The merging strategy places current items first to ensure they take precedence, followed by non-duplicate
 * parent items, preserving the original order within each group.
 *
 * @param parentItems - Items from parent hierarchical levels to be inherited
 * @param currentItems - Items from current library that take precedence over parent items
 * @param getKey - Function to extract a unique identifier (typically OID) from each item for deduplication
 * @returns Combined array with current items first, followed by inherited parent items with no duplicates based on key
 */ const $5157763fc8ee6ed9$var$mergeWithInheritedClinicalData = (parentItems, currentItems, getKey)=>{
    const currentItemKeys = new Set(currentItems.map(getKey));
    const inherited = parentItems.filter((p)=>!currentItemKeys.has(getKey(p)));
    return [
        ...currentItems,
        ...inherited
    ];
};

});

parcelRegister("2Mlm8", function(module, exports) {

$parcel$export(module.exports, "ACTIVATE_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$6edd9b656b07d9b; });
$parcel$export(module.exports, "ADD_RECEIVED_MESSAGE", function () { return $783fa639b91d7c0a$export$3c62dc6ab23ad792; });
$parcel$export(module.exports, "APPLY_VARIANT_TEMPLATE", function () { return $783fa639b91d7c0a$export$bbe3c5481d12a93b; });
$parcel$export(module.exports, "CANCEL_VARIANT_PATCH_CREATION", function () { return $783fa639b91d7c0a$export$da544288e0259a75; });
$parcel$export(module.exports, "CLEAR_TLF", function () { return $783fa639b91d7c0a$export$3af482df2ad31151; });
$parcel$export(module.exports, "CLOSE_MODAL_WINDOW", function () { return $783fa639b91d7c0a$export$8bebc2c59bb445dd; });
$parcel$export(module.exports, "CREATE_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$63062a04f61e74cb; });
$parcel$export(module.exports, "LOAD_TLF", function () { return $783fa639b91d7c0a$export$92293c49dfbf16c8; });
$parcel$export(module.exports, "PATCH_TLF_COMMENTS", function () { return $783fa639b91d7c0a$export$fcd722cd200d15dd; });
$parcel$export(module.exports, "PROCESS_SIGNALR_NOTIFICATION", function () { return $783fa639b91d7c0a$export$91599a31b0c51ba5; });
$parcel$export(module.exports, "REMOVE_TLF_COMMENT", function () { return $783fa639b91d7c0a$export$566a8457e5e3d6ec; });
$parcel$export(module.exports, "REMOVE_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$8a49c451d1b464f6; });
$parcel$export(module.exports, "REMOVE_VARIANT_TEMPLATE", function () { return $783fa639b91d7c0a$export$e578c446cc5706de; });
$parcel$export(module.exports, "RENAME_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$559f40152dfd9496; });
$parcel$export(module.exports, "RENAME_VARIANT_TEMPLATE", function () { return $783fa639b91d7c0a$export$c18ade7ed6cb9a1b; });
$parcel$export(module.exports, "REVERT_TO_VARIANT_MASTER", function () { return $783fa639b91d7c0a$export$d85122d47f2f476e; });
$parcel$export(module.exports, "SET_CREATE_VARIANT_PATCH_WINDOW", function () { return $783fa639b91d7c0a$export$fa1219e9b26afd7a; });
$parcel$export(module.exports, "SET_EDITOR_BLOCKS_SEARCH_PANEL", function () { return $783fa639b91d7c0a$export$ef29ffe579696bff; });
$parcel$export(module.exports, "SET_TLF_COMMENT_PANEL", function () { return $783fa639b91d7c0a$export$4b8e3a51d569628c; });
$parcel$export(module.exports, "SET_TLF_READ_ONLY", function () { return $783fa639b91d7c0a$export$23531c5f8d8474af; });
$parcel$export(module.exports, "SET_TLF_SUBSCRIPTION_STATUS", function () { return $783fa639b91d7c0a$export$ebc224f02d8ba54; });
$parcel$export(module.exports, "SET_VARIANT_CREATION_VIEW", function () { return $783fa639b91d7c0a$export$3750e965573d973a; });
$parcel$export(module.exports, "SET_VARIANT_PATCH_SELECTION", function () { return $783fa639b91d7c0a$export$5f48a5a1ec6728e3; });
$parcel$export(module.exports, "SET_VIEW_MODE", function () { return $783fa639b91d7c0a$export$3e7ee65482c898f7; });
$parcel$export(module.exports, "SHOW_MODAL_WINDOW", function () { return $783fa639b91d7c0a$export$c504062535f04932; });
$parcel$export(module.exports, "TOGGLE_TRAFFIC_LIGHTS", function () { return $783fa639b91d7c0a$export$6d2c6383eac39e42; });
$parcel$export(module.exports, "TOGGLE_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$a12f4d9f9906d017; });
$parcel$export(module.exports, "TRACK_ACTIVE_VARIANT_PATCH", function () { return $783fa639b91d7c0a$export$a9745e6b7078768d; });
$parcel$export(module.exports, "UPDATE_TLF", function () { return $783fa639b91d7c0a$export$6f0385e6121525d0; });
$parcel$export(module.exports, "UPDATE_TLF_COMMENT", function () { return $783fa639b91d7c0a$export$3906df64ba9b193b; });
$parcel$export(module.exports, "UPSERT_VARIANT_TEMPLATE", function () { return $783fa639b91d7c0a$export$8ae46a70826f80b8; });
const $783fa639b91d7c0a$export$6edd9b656b07d9b = "ACTIVATE_VARIANT_PATCH";
const $783fa639b91d7c0a$export$3c62dc6ab23ad792 = "ADD_RECEIVED_MESSAGE";
const $783fa639b91d7c0a$export$bbe3c5481d12a93b = "APPLY_VARIANT_TEMPLATE";
const $783fa639b91d7c0a$export$da544288e0259a75 = "CANCEL_VARIANT_PATCH_CREATION";
const $783fa639b91d7c0a$export$3af482df2ad31151 = "CLEAR_TLF";
const $783fa639b91d7c0a$export$8bebc2c59bb445dd = "CLOSE_MODAL_WINDOW";
const $783fa639b91d7c0a$export$63062a04f61e74cb = "CREATE_VARIANT_PATCH";
const $783fa639b91d7c0a$export$92293c49dfbf16c8 = "LOAD_TLF";
const $783fa639b91d7c0a$export$fcd722cd200d15dd = "PATCH_TLF_COMMENTS";
const $783fa639b91d7c0a$export$91599a31b0c51ba5 = "PROCESS_SIGNALR_NOTIFICATION";
const $783fa639b91d7c0a$export$566a8457e5e3d6ec = "REMOVE_TLF_COMMENT";
const $783fa639b91d7c0a$export$8a49c451d1b464f6 = "REMOVE_VARIANT_PATCH";
const $783fa639b91d7c0a$export$e578c446cc5706de = "REMOVE_VARIANT_TEMPLATE";
const $783fa639b91d7c0a$export$559f40152dfd9496 = "RENAME_VARIANT_PATCH";
const $783fa639b91d7c0a$export$c18ade7ed6cb9a1b = "RENAME_VARIANT_TEMPLATE";
const $783fa639b91d7c0a$export$d85122d47f2f476e = "REVERT_TO_VARIANT_MASTER";
const $783fa639b91d7c0a$export$fa1219e9b26afd7a = "SET_CREATE_VARIANT_PATCH_WINDOW";
const $783fa639b91d7c0a$export$f90cfd80956cd0ad = "SET_DELAYED_HIERARCHY_UPDATES";
const $783fa639b91d7c0a$export$ef29ffe579696bff = "SET_EDITOR_BLOCKS_SEARCH_PANEL";
const $783fa639b91d7c0a$export$4b8e3a51d569628c = "SET_TLF_COMMENT_PANEL";
const $783fa639b91d7c0a$export$23531c5f8d8474af = "SET_TLF_READ_ONLY";
const $783fa639b91d7c0a$export$ebc224f02d8ba54 = "SET_TLF_SUBSCRIPTION_STATUS";
const $783fa639b91d7c0a$export$3750e965573d973a = "SET_VARIANT_CREATION_VIEW";
const $783fa639b91d7c0a$export$5f48a5a1ec6728e3 = "SET_VARIANT_PATCH_SELECTION";
const $783fa639b91d7c0a$export$3e7ee65482c898f7 = "SET_VIEW_MODE";
const $783fa639b91d7c0a$export$c504062535f04932 = "SHOW_MODAL_WINDOW";
const $783fa639b91d7c0a$export$6d2c6383eac39e42 = "TOGGLE_TRAFFIC_LIGHTS";
const $783fa639b91d7c0a$export$a12f4d9f9906d017 = "TOGGLE_VARIANT_PATCH";
const $783fa639b91d7c0a$export$a9745e6b7078768d = "TRACK_ACTIVE_VARIANT_PATCH";
const $783fa639b91d7c0a$export$6f0385e6121525d0 = "UPDATE_TLF";
const $783fa639b91d7c0a$export$3906df64ba9b193b = "UPDATE_TLF_COMMENT";
const $783fa639b91d7c0a$export$8ae46a70826f80b8 = "UPSERT_VARIANT_TEMPLATE";

});

parcelRegister("3Avah", function(module, exports) {

$parcel$export(module.exports, "isEditorPageBy", function () { return $0b0e5ee581e2165b$export$70933415fe713e0a; });
$parcel$export(module.exports, "isTlfItemReadDto", function () { return $0b0e5ee581e2165b$export$32c72733f7fa0be7; });
$parcel$export(module.exports, "isArsMasterReadDto", function () { return $0b0e5ee581e2165b$export$eb25057000298cd0; });

var $bX0x9 = parcelRequire("bX0x9");

var $8LR5y = parcelRequire("8LR5y");

var $4lHS7 = parcelRequire("4lHS7");

var $kdlCe = parcelRequire("kdlCe");
const $0b0e5ee581e2165b$export$c01ff0332521efb1 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (![
        "string",
        "undefined"
    ].includes(typeof chkObj.timestamp)) return false;
    if (chkObj.id === undefined || typeof chkObj.id !== "number") return false;
    if (chkObj.updateType === undefined || !Object.values((0, $4lHS7.eHistoryType)).includes(chkObj.updateType)) return false;
    if (chkObj.comment === undefined || typeof chkObj.comment !== "string") return false;
    if (chkObj.userName === undefined || typeof chkObj.userName !== "string") return false;
    return true;
};
const $0b0e5ee581e2165b$export$70933415fe713e0a = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    return (0, $bX0x9.isIEditorV3)(obj.content);
};
const $0b0e5ee581e2165b$export$51859ba8c7a6071a = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.groupingFactorId !== "string") return false;
    if (chkObj.label !== undefined && !(0, $bX0x9.isIEditorV3)(chkObj.label)) return false;
    return true;
};
const $0b0e5ee581e2165b$export$32c72733f7fa0be7 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check lower interface
    if (!(0, $kdlCe.isTitlesFootnotesReadDto)(obj)) return false;
    // Check basic props
    const chkObj = obj;
    if (![
        "undefined",
        "string"
    ].includes(typeof chkObj.crystalReference)) return false;
    if (typeof chkObj.sapReference !== "string") return false;
    if (!(0, $bX0x9.isIEditorV3)(chkObj.standardsNotes)) return false;
    if (!(0, $bX0x9.isIEditorV3)(chkObj.programmerNotes)) return false;
    if (typeof chkObj.body !== "object") return false;
    // Check arrays
    if (!Array.isArray(chkObj.history) || chkObj.history.some((x)=>!$0b0e5ee581e2165b$export$c01ff0332521efb1(x))) return false;
    if (chkObj.pageBy === undefined) return false;
    if ((chkObj.type === (0, $4lHS7.eTlfItemType).arsListing || chkObj.type === (0, $4lHS7.eTlfItemType).arsTable) && (!Array.isArray(chkObj.pageBy) || chkObj.pageBy.some((item)=>!$0b0e5ee581e2165b$export$51859ba8c7a6071a(item)))) return false;
    if (chkObj.type !== (0, $4lHS7.eTlfItemType).arsListing && chkObj.type !== (0, $4lHS7.eTlfItemType).arsTable && !$0b0e5ee581e2165b$export$70933415fe713e0a(chkObj.pageBy)) return false;
    // Everything is good
    return true;
};
const $0b0e5ee581e2165b$export$bf61bc1178e77cc4 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check extended TlfItemReadDto properties
    if (!$0b0e5ee581e2165b$export$32c72733f7fa0be7(obj) || obj.type !== (0, $4lHS7.eTlfItemType).arsTable) return false;
    if (!(0, $8LR5y.isVariantInformation)(obj)) return false;
    // Everything is good
    return true;
};
const $0b0e5ee581e2165b$export$dc8693c1d9974b8a = (obj)=>{
    if (!$0b0e5ee581e2165b$export$32c72733f7fa0be7(obj) || obj.type !== (0, $4lHS7.eTlfItemType).arsListing) return false;
    return (0, $8LR5y.isVariantInformation)(obj);
};
const $0b0e5ee581e2165b$export$eb25057000298cd0 = (obj)=>$0b0e5ee581e2165b$export$bf61bc1178e77cc4(obj) || $0b0e5ee581e2165b$export$dc8693c1d9974b8a(obj);

});
parcelRegister("bX0x9", function(module, exports) {

$parcel$export(module.exports, "EditorV3Content", function () { return $8b359e63c1cdd74d$export$1a4903393d6b1b7d; });
$parcel$export(module.exports, "isIEditorV3", function () { return $8b359e63c1cdd74d$export$a2e4f3e0d013ef9f; });
$parcel$export(module.exports, "stringToV3", function () { return $8b359e63c1cdd74d$export$4c11677f6b5bfb11; });
$parcel$export(module.exports, "EditorV3", function () { return $8b359e63c1cdd74d$export$c410cc7dbb67874b; });
$parcel$export(module.exports, "cleanIsEqual", function () { return $8b359e63c1cdd74d$export$501d19eb8a679b38; });
$parcel$export(module.exports, "splitV3intoLines", function () { return $8b359e63c1cdd74d$export$9046ef79d808c3d9; });
$parcel$export(module.exports, "joinV3intoBlock", function () { return $8b359e63c1cdd74d$export$6be11f3b04f364b4; });
$parcel$export(module.exports, "getObjectDiff", function () { return $8b359e63c1cdd74d$export$db8269090bd3dd4; });
$parcel$export(module.exports, "getTextFromEditorV3", function () { return $8b359e63c1cdd74d$export$59ffc450e12fbd65; });
$parcel$export(module.exports, "hasStylesToRemove", function () { return $8b359e63c1cdd74d$export$5bbd286e9783a47b; });
$parcel$export(module.exports, "removeStylesFromEditorV3", function () { return $8b359e63c1cdd74d$export$c4055ded8e1007ea; });
$parcel$export(module.exports, "replaceTextInEditorV3", function () { return $8b359e63c1cdd74d$export$4473dc511c49aabc; });
$parcel$export(module.exports, "searchEditorV3Content", function () { return $8b359e63c1cdd74d$export$458b3725b25c35e4; });


var $eBlbF = parcelRequire("eBlbF");

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");
function $8b359e63c1cdd74d$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $8b359e63c1cdd74d$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $8b359e63c1cdd74d$var$$805c218341f5a4f1$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "EditorV3Align", ()=>$8b359e63c1cdd74d$export$e6890f8825213b0d);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "EditorV3AtBlock", ()=>$8b359e63c1cdd74d$export$2762eb7a56f6d4be);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "EditorV3Content", ()=>$8b359e63c1cdd74d$export$1a4903393d6b1b7d);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "EditorV3Line", ()=>$8b359e63c1cdd74d$export$f727c5bfed9e77d4);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "EditorV3TextBlock", ()=>$8b359e63c1cdd74d$export$4ed6c3ca0061f49b);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$805c218341f5a4f1$exports, "isIEditorV3", ()=>$8b359e63c1cdd74d$export$a2e4f3e0d013ef9f);
const $8b359e63c1cdd74d$var$$651e6b8a46a239ec$export$bb271ec44122dc39 = {
    defaultStyle: "defaultStyle",
    styleStartTag: "(~(",
    styleNameEndTag: "::",
    styleEndTag: ")~)",
    dropDownStartTag: "(\xac(",
    dropDownEndTag: ")\xac)",
    dropDownValueSeparator: "||",
    dropDownSelectedValueTag: "**",
    calcStartTag: "[![",
    calcNameEndTag: "::",
    calcEndTag: "]!]",
    calcConditionSeparator: "||",
    calcAndSeparator: "&&",
    atStartTag: "@[",
    atEndTag: "@]"
};
var $8b359e63c1cdd74d$export$e6890f8825213b0d = /*#__PURE__*/ function(EditorV3Align) {
    EditorV3Align["left"] = "left";
    EditorV3Align["center"] = "center";
    EditorV3Align["decimal"] = "decimal";
    EditorV3Align["right"] = "right";
    return EditorV3Align;
}({});
const $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54 = {
    allowMarkdown: false,
    allowNewLine: false,
    allowWindowView: false,
    decimalAlignPercent: 60,
    markdownSettings: $8b359e63c1cdd74d$var$$651e6b8a46a239ec$export$bb271ec44122dc39,
    showMarkdown: false,
    styles: undefined,
    textAlignment: $8b359e63c1cdd74d$export$e6890f8825213b0d.left,
    atListFunction: undefined,
    maxAtListLength: 10
};
class $8b359e63c1cdd74d$export$4ed6c3ca0061f49b {
    /**
   * End character position of this text block in the containing line.
   * Calculated from `lineStartPosition` + visible character length of `text`.
   */ get lineEndPosition() {
        return this.lineStartPosition + this.text.replaceAll(/[\u2009-\u200f]/g, "").length;
    }
    /**
   * Unique merge key identifying adjacent blocks that can be coalesced.
   * Combines lock state, type, style and label to produce a stable string key.
   *
   * @returns string
   */ get mergeKey() {
        return `${this.isLocked ? this.lineStartPosition : "-"}:${this.type}:${this.style ?? ""}:${this.label ?? ""}`;
    }
    /**
   * Whether this block should be considered 'enhanced' (non-default)
   * i.e. it has a style, label or a non-default type.
   */ get isEnhanced() {
        return this.style !== undefined && this.style !== this._defaultContentProps.markdownSettings.defaultStyle || this.label !== undefined || this.type !== "text";
    }
    // Read only variables
    /**
   * Serialise this block to its plain data shape used by the EditorV3 model.
   *
   * @returns IEditorV3TextBlock
   */ get data() {
        return {
            text: this.text,
            label: this.label,
            style: this.style,
            type: this.type,
            isLocked: this.isLocked
        };
    }
    /**
   * Compute positions for each word within this block. Words inside locked
   * blocks return a locked position so caret logic can treat them atomically.
   */ get wordPositions() {
        const ret = [];
        let _counted = 0;
        if (this.isLocked) ret.push({
            line: -1,
            startChar: this.lineStartPosition,
            endChar: this.lineStartPosition + this.text.length,
            isLocked: true
        });
        else while(_counted < this.text.length && this.text.slice(_counted).search(/\S/) > -1){
            const remainingText = this.text.slice(_counted);
            const nextWord = remainingText.match(/\S+/);
            /* istanbul ignore else */ if (nextWord) {
                ret.push({
                    line: -1,
                    startChar: this.lineStartPosition + _counted + remainingText.search(/\S/),
                    endChar: this.lineStartPosition + _counted + remainingText.search(/\S/) + nextWord[0].length,
                    isLocked: false
                });
                _counted += remainingText.search(/\S/) + nextWord[0].length;
            }
        }
        return ret;
    }
    // Constructor
    /**
   * Construct a text block from a model, DOM element, fragment or plain text.
   *
   * @param arg - Optional source value: model object, `HTMLSpanElement`, `DocumentFragment` or plain string
   * @param forcedParams - Optional parameters to override parsed values
   */ constructor(arg, forcedParams){
        this._defaultContentProps = (0, $eBlbF.cloneDeep)($8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Variables
        this.text = "";
        this.type = "text";
        this.isActive = false;
        this.isSelected = false;
        this.lineStartPosition = 0;
        // Update defaults if specified
        if (forcedParams?.markdownSettings) this._defaultContentProps.markdownSettings = forcedParams.markdownSettings;
        // Document Fragment processing
        if (arg instanceof DocumentFragment) {
            this.text = "";
            const errors = [];
            arg.childNodes.forEach((child, ix)=>{
                if (child instanceof Text || child instanceof HTMLSpanElement) {
                    const childData = this.fromHtml(child);
                    // Set parameters
                    if (ix === 0) {
                        this.text = childData.text;
                        this.label = childData.label;
                        this.style = childData.style;
                        this.type = childData.type;
                        this.isLocked = childData.isLocked;
                        this.lineStartPosition = childData.lineStartPosition ?? // istanbul ignore next
                        0;
                    } else {
                        if (childData.type !== this.type) errors.push("Multiple types in fragment");
                        if (childData.style !== this.style) errors.push("Multiple styles in fragment");
                        if (childData.isLocked !== this.isLocked) errors.push("Multiple isLocked in fragment");
                        this.text += childData.text;
                    }
                } else errors.push("Unknown node type in fragment");
            });
            if (errors.length > 0) throw new Error("EditorV3TextBlock:Constructor:" + errors.join(", "));
        } else if (typeof arg === "string") this.fromMarkdown(arg, this._defaultContentProps.markdownSettings);
        else if (arg instanceof HTMLSpanElement || arg instanceof Text) {
            const spanData = this.fromHtml(arg);
            this.text = spanData.text;
            this.label = spanData.label;
            this.style = spanData.style;
            this.type = spanData.type ?? "text";
            this.isLocked = spanData.isLocked;
            this.lineStartPosition = spanData.lineStartPosition ?? // istanbul ignore next
            0;
        } else {
            this.text = arg?.text.replaceAll(/[\r\n\t]/g, "") ?? "";
            this.label = arg?.label;
            this.style = arg?.style === "" ? undefined : arg?.style;
            this.type = arg?.type ?? "text";
            this.isLocked = arg?.isLocked;
            this.lineStartPosition = arg?.lineStartPosition ?? 0;
        }
        // Forced any parameters
        if (forcedParams) {
            if (forcedParams.label) this.label = forcedParams.label;
            if (forcedParams.style) this.style = forcedParams.style;
            if (forcedParams.isLocked) this.isLocked = forcedParams.isLocked;
            if (forcedParams.lineStartPosition) this.lineStartPosition = forcedParams.lineStartPosition;
        }
        if (this.type === undefined) this.type = "text";
    }
    // Protected functions
    /**
   * Parse an `HTMLSpanElement` or `Text` node into the block's data shape.
   *
   * @param arg - The source HTML span or text node
   */ fromHtml(arg) {
        const text = (arg.textContent ?? // istanbul ignore next
        "").replaceAll(/\u00a0/g, " ").replaceAll(/[\u2009-\u200f]/g, "");
        const spanData = {
            text: text,
            lineStartPosition: arg instanceof HTMLSpanElement && arg.dataset.lineStartPosition ? parseInt(arg.dataset.lineStartPosition) : 0,
            label: arg instanceof HTMLSpanElement && arg.title !== "" ? arg.title : undefined,
            style: arg instanceof HTMLSpanElement ? arg.dataset.styleName : undefined,
            type: arg instanceof HTMLSpanElement ? arg.dataset.type : "text",
            isLocked: arg instanceof HTMLSpanElement && arg.dataset.isLocked === "true" ? true : undefined
        };
        return spanData;
    }
    /**
   * Extract a style, label and bare text from a markdown-style annotated string.
   *
   * @param markdownText - The markdown text containing optional style/label tags
   * @param markdownSettings - Settings describing the start/end tag strings
   * @param set - When true, apply the parsed values to this instance
   * @returns An object containing `{ style, label, text }`
   */ markdownStyleLabel(markdownText, markdownSettings, set = true) {
        const styleTag = markdownText.indexOf(markdownSettings.styleNameEndTag);
        let style = undefined;
        let label = undefined;
        let text = undefined;
        // No style tag, return text
        if (styleTag === -1) text = markdownText;
        else {
            const labelTag = markdownText.indexOf(markdownSettings.styleNameEndTag, styleTag + markdownSettings.styleNameEndTag.length);
            // No label tag, return text
            if (labelTag === -1) {
                style = markdownText.slice(0, styleTag);
                text = markdownText.slice(styleTag + markdownSettings.styleNameEndTag.length);
            } else {
                // Style and label tags found
                if (styleTag > 0) style = markdownText.slice(0, styleTag);
                /* istanbul ignore else */ if (labelTag > styleTag + markdownSettings.styleNameEndTag.length) label = markdownText.slice(styleTag + markdownSettings.styleNameEndTag.length, labelTag);
                text = markdownText.slice(labelTag + markdownSettings.styleNameEndTag.length);
            }
        }
        // Set if required
        if (set) {
            this.style = style;
            this.label = label;
            this.text = text;
        }
        // Return results
        return {
            style: style,
            label: label,
            text: text
        };
    }
    /**
   * Parse a markdown string into the block fields using given markdown settings.
   *
   * @param markdown - The source markdown text for this block
   * @param arg - Markdown settings used to interpret tags
   */ fromMarkdown(markdown, arg) {
        const markdownSettings = arg;
        this.isLocked = undefined;
        this.style = undefined;
        this.label = undefined;
        this.text = markdown.replaceAll(/u00a0/g, " ").replaceAll(/[\u2009-\u200f]/g, "");
        if (this.text.startsWith(markdownSettings.styleStartTag) && this.text.endsWith(markdownSettings.styleEndTag)) {
            this.text = this.text.slice(markdownSettings.styleStartTag.length, -markdownSettings.styleEndTag.length);
            // Only time default style is used
            const defaultStyle = !this.text.includes(markdownSettings.styleNameEndTag);
            // Read style and label
            this.markdownStyleLabel(this.text, markdownSettings);
            // Update default style if required
            if (defaultStyle) this.style = markdownSettings.defaultStyle;
        }
    }
    // Status updated functions
    /**
   * Mark this block as active/inactive in the UI.
   *
   * @param active - True to mark the block active
   */ setActive(active) {
        this.isActive = active;
    }
    /**
   * Apply style attributes to an element and set dataset values used by rendering.
   *
   * @param span - The span element to apply styles to
   * @param style - Optional style map used to set CSS properties
   */ applyStyle(span, style) {
        if (this.style) {
            span.classList.add(`editorv3style-${this.style}`);
            span.dataset.styleName = this.style;
            Object.entries(style ?? {}).forEach(([k, v])=>{
                if (k === "isLocked") span.dataset.isLocked = "true";
                else span.style.setProperty(k.replace(/[A-Z]/g, (m)=>"-" + m.toLowerCase()), v);
            });
        }
    }
    // Content returns
    /**
   * Render this text block into a `DocumentFragment` appropriate for the
   * editor DOM. Handles locking, labels and active state.
   *
   * @param renderProps - The render properties controlling output
   * @param style - Optional style map used when rendering
   * @returns A `DocumentFragment` containing DOM nodes for this block
   */ toHtml(renderProps, style) {
        const text = this.text === "" ? "\u200b" : this.text.replaceAll(" ", "\u00a0\u200c");
        const ret = new DocumentFragment();
        if (this.type !== "text") throw new Error("Use correct class for non-text blocks");
        else {
            const words = renderProps.doNotSplitWordSpans ? [
                text.replaceAll(/[\u2009-\u200f]/g, "")
            ] : text.split("\u200c");
            words.filter((w)=>w !== "").forEach((word)=>{
                const span = document.createElement("span");
                span.classList.add("aiev3-tb");
                span.dataset.lineStartPosition = this.lineStartPosition.toString();
                const textNode = document.createTextNode(word);
                span.appendChild(textNode);
                // Add label
                if (this.label) span.title = this.label;
                // Apply lock
                if (this.isLocked && style?.isLocked) {
                    span.classList.add("is-locked");
                    span.dataset.isLocked = "true";
                    span.contentEditable = "false";
                }
                if (this.isActive) span.classList.add("is-active");
                // Apply style
                this.applyStyle(span, style);
                // Append to return
                ret.append(span);
            });
        }
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        return ret;
    }
    /**
   * Create the markdown-style label prefix for this block using settings.
   *
   * @param markdownSettings - The markdown settings used to format the label
   * @returns A string to prefix the block's text with style/label metadata
   */ toMarkdownStyleLabel(markdownSettings) {
        if (this.label) return (this.style ?? "") + markdownSettings.styleNameEndTag + this.label + markdownSettings.styleNameEndTag;
        else if (this.style && this.style !== markdownSettings.defaultStyle) return this.style + markdownSettings.styleNameEndTag;
        else return "";
    }
    /**
   * Convert this text block into its markdown representation using the
   * provided markdown settings. Style and label metadata are encoded
   * using the configured start/end tags.
   *
   * @param markdownSettings - Optional markdown settings; defaults to the
   *        block's default content properties.
   * @returns The markdown string representing this block.
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        // Set base text
        let text = this.text;
        // Update text with style and label
        if (this.style || this.label) {
            text = markdownSettings.styleStartTag;
            text += this.toMarkdownStyleLabel(markdownSettings);
            text += this.text;
            text += markdownSettings.styleEndTag;
        }
        return text;
    }
}
/**
 * Render a single list item indicating an empty dropdown state. This
 * appends an `li` with an appropriate class and text to the provided
 * `ul` element.
 *
 * @param dropdownUl - The `ul` element to append the empty state into.
 */ const $8b359e63c1cdd74d$var$$7cf7e0ac61e95dc6$export$f1ad8b47dc439258 = (dropdownUl)=>{
    const noItems = document.createElement("li");
    noItems.classList.add("aiev3-drop-no-items");
    noItems.textContent = "No items found";
    dropdownUl.appendChild(noItems);
};
/**
 * Render an error placeholder into the dropdown when the item list
 * cannot be fetched.
 *
 * @param dropdownUl - The dropdown `ul` to render the error into.
 */ const $8b359e63c1cdd74d$var$$86c9c925a494dce9$export$367a5a17e4123093 = (dropdownUl)=>{
    dropdownUl.innerHTML = "";
    const errorItem = document.createElement("li");
    errorItem.classList.add("aiev3-drop-items-error");
    errorItem.textContent = "Error fetching list";
    dropdownUl.appendChild(errorItem);
};
const $8b359e63c1cdd74d$var$$993189bfb4c3bf83$export$38113ea00f19b1ee = (dropdownUl, dropItem)=>{
    const dropSpan = dropItem.listRender ?? document.createElement("li");
    /* istanbul ignore else */ if (!dropSpan.classList.contains("aiev3-drop-item")) dropSpan.classList.add("aiev3-drop-item");
    /* istanbul ignore else */ if (!dropSpan.dataset.text) dropSpan.dataset.text = dropItem.text;
    /* istanbul ignore else */ if (dropSpan.textContent === "" || !dropSpan.textContent) dropSpan.textContent = dropItem.text;
    // Add in data from atItem
    /* istanbul ignore else */ if (dropItem.data) Object.keys(dropItem.data).forEach((key)=>{
        /* istanbul ignore else */ if (dropItem.data) dropSpan.dataset[key] = dropItem.data[key];
    });
    dropdownUl.appendChild(dropSpan);
};
/**
 * Append a list item indicating there are more hidden items.
 *
 * @param dropdownUl - The dropdown unordered list element to render into
 * @param moreNumber - The number of additional items to display
 * @returns The created `HTMLLIElement` appended to `dropdownUl`
 */ const $8b359e63c1cdd74d$var$$591d0e585054a39b$export$af9d94bc34a616d5 = (dropdownUl, moreNumber)=>{
    const atSpan = document.createElement("li");
    atSpan.classList.add("aiev3-more-items");
    atSpan.textContent = `...${moreNumber} more`;
    dropdownUl.appendChild(atSpan);
    return atSpan;
};
const $8b359e63c1cdd74d$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6 = (span, text, renderProps, noaction = false)=>{
    // Clear any existing dropdowns
    const previousDropdown = document.querySelectorAll("ul.aiev3-dropdown-list");
    previousDropdown.forEach((dropdown)=>dropdown.remove());
    // Double check class list
    /* istanbul ignore else */ if (span.classList.contains("show-dropdown") && span.offsetParent) {
        // Create download
        const dropdownUl = document.createElement("ul");
        // Append to editor
        document.body.appendChild(dropdownUl);
        // Set up dropdown internals
        dropdownUl.classList.add("aiev3-dropdown-list", "skip-read");
        dropdownUl.contentEditable = "false";
        dropdownUl.innerHTML = "<li>Loading...</li>";
        // Add event listener
        if (!noaction) dropdownUl.addEventListener("mousedown", (e)=>{
            // Set long timeout to enable stack to clear
            const dropItem = e.target instanceof Element && e.target.classList.contains("aiev3-drop-item") ? e.target : e.target instanceof Element && e.target.closest(".aiev3-drop-item") ? e.target.closest(".aiev3-drop-item") : undefined;
            /* istanbul ignore else */ if (dropItem && dropItem instanceof HTMLElement) {
                // Update span
                const thisText = dropItem.textContent;
                span.textContent = dropItem.dataset.text ?? thisText;
                delete span.dataset.styleName;
                span.classList.forEach((className)=>{
                    if (className.startsWith("editorv3style-")) span.classList.remove(className);
                });
                if (dropItem.dataset.style) {
                    span.dataset.styleName = dropItem.dataset.style;
                    span.classList.add(`editorv3style-${dropItem.dataset.style}`);
                }
                span.classList.remove("is-active");
                span.classList.add("is-locked");
                span.dataset.isLocked = "true";
                // Copy any other data from the atItem
                /* istanbul ignore else */ if (dropItem.dataset) Object.keys(dropItem.dataset).filter((key)=>![
                        "isLocked",
                        "text",
                        "style"
                    ].includes(key)).forEach((key)=>{
                    span.dataset[key] = dropItem.dataset[key];
                });
                // Move dropdown to span before removing it
                span.appendChild(dropdownUl);
                // Remove dropdown
                dropdownUl.style.display = "none";
                window.setTimeout(()=>{
                    dropdownUl.remove();
                    // Dispatch refresh event to refresh the editor
                    const refreshEvent = new CustomEvent("editorv3refresh", {
                        bubbles: true,
                        detail: {
                            target: span
                        }
                    });
                    span.dispatchEvent(refreshEvent);
                }, 1);
            }
        });
        /**
     * Document-level click handler used to close the dropdown when the
     * user clicks outside of it.
     *
     * @param e - The mouse event from the document.
     */ const clickHandler = (e)=>{
            const target = e.target;
            const dropdownUl = document.querySelector(".aiev3-dropdown-list");
            if (dropdownUl && !dropdownUl.contains(target)) {
                dropdownUl.remove();
                span.classList.remove("is-active");
                span.classList.add("is-locked");
                span.dataset.isLocked = "true";
            }
            document.removeEventListener("mousedown", clickHandler);
        };
        document.addEventListener("mousedown", clickHandler);
        // Position dropdown
        const spanRect = span.getBoundingClientRect();
        dropdownUl.style.left = `${spanRect.left}px`;
        dropdownUl.style.top = `${spanRect.bottom}px`;
        // Add items to dropdown when promise resolves
        /* istanbul ignore else */ if (renderProps.atListFunction) renderProps.atListFunction(text).then((resolvedList)=>{
            const maxAtListLength = renderProps.maxAtListLength ?? 10;
            dropdownUl.innerHTML = "";
            if (resolvedList.length === 0) $8b359e63c1cdd74d$var$$7cf7e0ac61e95dc6$export$f1ad8b47dc439258(dropdownUl);
            else {
                resolvedList.slice(0, maxAtListLength).forEach((atItem)=>$8b359e63c1cdd74d$var$$993189bfb4c3bf83$export$38113ea00f19b1ee(dropdownUl, atItem));
                // Add in more items list item
                if (resolvedList.length > maxAtListLength) $8b359e63c1cdd74d$var$$591d0e585054a39b$export$af9d94bc34a616d5(dropdownUl, resolvedList.length - maxAtListLength);
            }
        }).catch(()=>{
            $8b359e63c1cdd74d$var$$86c9c925a494dce9$export$367a5a17e4123093(dropdownUl);
        });
    }
};
class $8b359e63c1cdd74d$export$2762eb7a56f6d4be extends $8b359e63c1cdd74d$export$4ed6c3ca0061f49b {
    /**
   * Returns the data representation of the at block.
   *
   * @returns The at block data interface
   */ get data() {
        const ret = super.data;
        if (Object.keys(this.atData).length > 0) ret.atData = this.atData;
        return ret;
    }
    /**
   * Returns the word positions within the at block.
   *
   * @returns Array of word positions
   */ get wordPositions() {
        return [
            {
                line: -1,
                startChar: this.lineStartPosition,
                endChar: this.lineStartPosition + this.text.length,
                isLocked: this.isLocked === true
            }
        ];
    }
    /**
   * Creates a new EditorV3AtBlock instance.
   *
   * @param arg - The source data (interface, HTML element, fragment, or string)
   * @param forcedParams - Optional parameters to force on the block
   */ constructor(arg, forcedParams){
        // Usual text block constructor
        super(arg, forcedParams), /**
   * Promise function that will return list of string values to display.
   *
   * @param typedString - Text entered into the block so far
   * @returns Promise of array of dropdown list items
   */ this.atListFunction = ()=>new Promise((resolve)=>resolve([])), /**
   * Maximum number of items to display in the returned list.
   */ this.maxAtListLength = 10, this.atData = {};
        // Force type
        this.type = "at";
        // Check for at specific information
        if (typeof arg === "string") this.furtherMarkdown(forcedParams?.markdownSettings);
        else if (arg instanceof HTMLSpanElement) this.furtherHtml(arg);
        else if (arg instanceof DocumentFragment) {
            if (arg.childNodes.length !== 1) throw new Error("EditorV3AtBlock:Constructor: DocumentFragment must have 1 child node");
            else if (!(arg.childNodes[0] instanceof HTMLSpanElement)) throw new Error("EditorV3AtBlock:Constructor: Child node must be HTMLSpanElement");
            // Read element
            this.furtherHtml(arg.childNodes[0]);
        } else {
            if (arg.atListFunction) this.atListFunction = arg.atListFunction;
            if (arg.maxAtListLength) this.maxAtListLength = arg.maxAtListLength;
            if (arg.atData) this.atData = arg.atData;
        }
        // Force any parameters
        if (forcedParams) {
            if (forcedParams.atListFunction) this.atListFunction = forcedParams.atListFunction;
            if (forcedParams.maxAtListLength) this.maxAtListLength = forcedParams.maxAtListLength;
            if (forcedParams.atData) this.atData = forcedParams.atData;
        }
    }
    /**
   * Read extra data from HTML element.
   *
   * @param arg - The HTML span element to extract data from
   */ furtherHtml(arg) {
        // Copy dataset to atFactory
        Object.keys(arg.dataset).forEach((key)=>{
            if (![
                "styleName",
                "isLocked",
                "type",
                "text",
                "lineStartPosition"
            ].includes(key)) this.atData[key] = arg.dataset[key];
        });
    }
    /**
   * Extract markdown information from block text.
   *
   * @param arg - Optional markdown settings to use
   */ furtherMarkdown(arg) {
        const markdownSettings = arg ?? this._defaultContentProps.markdownSettings;
        this.atData = {};
        /* istanbul ignore else */ if (this.text.startsWith(markdownSettings.atStartTag) && this.text.endsWith(markdownSettings.atEndTag) && this.text.includes(markdownSettings.dropDownSelectedValueTag)) {
            // Remove start and end tags
            this.text = this.text.slice(markdownSettings.atStartTag.length, -markdownSettings.atEndTag.length);
            // Find the dropdown selected value tag
            const dd = this.text.indexOf(markdownSettings.dropDownSelectedValueTag);
            // Get the data text
            const atDataText = this.text.slice(dd + markdownSettings.dropDownSelectedValueTag.length);
            try {
                this.atData = JSON.parse(atDataText);
            } catch  {
                this.atData = {};
            }
            // Get the text/style/label
            const current = this.text.slice(0, dd);
            this.markdownStyleLabel(current, markdownSettings);
        }
    }
    /**
   * Converts the at block to an HTML document fragment.
   *
   * @param renderProps - The rendering properties
   * @param style - Optional style to apply
   * @returns Document fragment containing the rendered HTML
   */ toHtml(renderProps, style) {
        // Create holder
        const ret = new DocumentFragment();
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        const span = document.createElement("span");
        ret.appendChild(span);
        span.classList.add("aiev3-tb", "at-block");
        span.dataset.lineStartPosition = this.lineStartPosition.toString();
        span.dataset.type = "at";
        // Add Text node
        const textNode = document.createTextNode(this.text.replaceAll(/[\u2009-\u200f]/g, "").replace(/^ /, "\u00a0").replace(/ $/, "\u00a0"));
        span.appendChild(textNode);
        // Add style
        this.applyStyle(span, style);
        // Add label
        if (this.label) span.title = this.label;
        // Add locked status
        /* istanbul ignore else */ if (this.isLocked || !this.isActive) {
            span.classList.add("is-locked");
            span.dataset.isLocked = "true";
            span.contentEditable = "false";
            // Add any other data items from the at item
            /* istanbul ignore else */ if (this.atData) Object.keys(this.atData).forEach((key)=>{
                span.dataset[key] = this.atData[key];
            });
        } else if (this.isActive) {
            span.classList.add("is-active");
            // Throttle render
            let renderTimeout = null;
            /* istanbul ignore else */ if (!renderTimeout) {
                span.classList.add("show-dropdown");
                renderTimeout = window.setTimeout(()=>$8b359e63c1cdd74d$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                        ...renderProps,
                        atListFunction: renderProps.atListFunction ?? this.atListFunction,
                        maxAtListLength: renderProps.maxAtListLength ?? this.maxAtListLength
                    }), 100);
            }
        }
        // Add to current element if specified
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        // Always return
        return ret;
    }
    /**
   * Converts the at block to markdown string representation.
   *
   * @param markdownSettings - The markdown settings to use
   * @returns Markdown string representation
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        // Set base text
        let text = markdownSettings.atStartTag;
        // Update text with style and label
        text += this.toMarkdownStyleLabel(markdownSettings);
        // Add text
        text += this.text;
        // Add atData
        text += markdownSettings.dropDownSelectedValueTag + JSON.stringify(this.atData);
        // Complete tag
        text += markdownSettings.atEndTag;
        return text;
    }
}
/**
 * Get the item position within the container.
 *
 * @param containerEl - The container element
 * @param targetNode - The DOM node (or text node) where the caret is located; used to derive the line container
 * @param offset - The character offset
 * @param targetRange - A mutable `Range` instance used to compute character offsets within the line
 * @returns Position object or null
 */ const $8b359e63c1cdd74d$var$$87c84f58544c8738$var$getItemPosition = (containerEl, targetNode, offset, targetRange)=>{
    // Retrieve the target element (move up in the DOM if the element is a Text node)
    //  then find the line div
    const line = (targetNode instanceof Element ? targetNode : targetNode.parentElement).closest("div.aiev3-line, div.aiev3-markdown-line");
    // Get the line number by checking the siblings
    const lineIndex = line && containerEl.contains(line) && line.parentElement ? [
        ...line.parentElement.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line")
    ].indexOf(line) : null;
    // Stop if not found
    if (lineIndex === null || !line) return null;
    // Get the character number by checking the text content
    targetRange.selectNodeContents(line);
    targetRange.setEnd(targetNode, offset);
    const charIndex = targetRange.toString().replace(/[\u2009-\u200f]/g, "").length;
    return {
        lineIndex: lineIndex,
        charIndex: charIndex
    };
};
function $8b359e63c1cdd74d$var$$87c84f58544c8738$export$7d120213748299d3(element) {
    // Check a selection is present
    let range;
    let preCaretRange;
    const sel = window.getSelection();
    if (sel && sel.rangeCount > 0) {
        range = sel.getRangeAt(0);
        preCaretRange = range.cloneRange();
    } else return null;
    /**
   * Get the anchor line and character of the caret.
   */ const anchor = (sel.anchorNode && $8b359e63c1cdd74d$var$$87c84f58544c8738$var$getItemPosition(element, sel.anchorNode, sel.anchorOffset, preCaretRange)) ?? null;
    /**
   * Get the end line and character of the caret.
   */ const focus = (sel.focusNode && $8b359e63c1cdd74d$var$$87c84f58544c8738$var$getItemPosition(element, sel.focusNode, sel.focusOffset, preCaretRange)) ?? null;
    return anchor && focus ? {
        initialLine: anchor.lineIndex,
        initialChar: anchor.charIndex,
        focusLine: focus.lineIndex,
        focusChar: focus.charIndex
    } : null;
}
class $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d extends $8b359e63c1cdd74d$export$4ed6c3ca0061f49b {
    /**
   * List of available dropdown options for this select block.
   *
   * @returns EditorV3DropListItem<Record<string, string>>[]
   */ get availableOptions() {
        return this._availableOptions;
    }
    /**
   * Set the available options for this select block.
   *
   * @param value - Array of options to use for this select block.
   */ set availableOptions(value) {
        this._availableOptions = value.map(this._styleOrNot);
    }
    /**
   * Serialise this select block including available options.
   *
   * @returns IEditorV3SelectBlock
   */ get data() {
        const ret = super.data;
        ret.availableOptions = this.availableOptions;
        return ret;
    }
    /**
   * Word position for the entire select block (treated as a locked token).
   *
   * @returns EditorV3WordPosition[]
   */ get wordPositions() {
        return [
            {
                line: -1,
                startChar: this.lineStartPosition,
                endChar: this.lineStartPosition + this.text.length,
                isLocked: this.isLocked === true
            }
        ];
    }
    /**
   * Construct a select block from model, DOM or markdown input.
   *
   * @param arg - Source for the block content
   * @param forcedParams - Optional overrides such as available options
   */ constructor(arg, forcedParams){
        // Usual text block constructor
        super(arg, forcedParams), this._availableOptions = [], /**
   * Normalise a raw option object into the internal `EditorV3DropListItem`
   * shape used by the select block, ensuring `data` contains either a
   * `style` property or an explicit `noStyle` marker.
   *
   * @param o Raw option object with optional `text` and `data`.
   * @returns A normalised `EditorV3DropListItem<Record<string,string>>`.
   */ this._styleOrNot = (o)=>{
            const option = {
                text: o.text,
                data: {}
            };
            /* istanbul ignore else */ if (o.data?.style && option.data) option.data.style = o.data.style;
            else if (option.data) option.data.noStyle = "true";
            return option;
        }, this.showDropdown = ()=>{
            this.isActive = true;
            this.isSelected = true;
        };
        // Force type
        this.type = "select";
        this.isLocked = true;
        // Check for at specific information
        if (typeof arg === "string") this.furtherMarkdown(forcedParams?.markdownSettings);
        else if (arg instanceof HTMLSpanElement) this.furtherHtml(arg);
        else if (arg instanceof DocumentFragment) {
            if (arg.childNodes.length !== 1) throw new Error("EditorV3SelectBlock:Constructor: DocumentFragment must have 1 child node");
            else if (!(arg.childNodes[0] instanceof HTMLSpanElement)) throw new Error("EditorV3SelectBlock:Constructor: DocumentFragment child node must be HTMLSpanElement");
            // Read element
            this.furtherHtml(arg.childNodes[0]);
        } else if (arg.availableOptions) this.availableOptions = arg.availableOptions;
        // Force any parameters
        if (forcedParams) {
            if (forcedParams.availableOptions) this.availableOptions = forcedParams.availableOptions;
        }
    }
    // Read extra data from HTML
    /**
   * Populate additional fields from an HTML span element's dataset (used
   * when constructing from DOM).
   *
   * @param arg - The span element containing dataset values
   */ furtherHtml(arg) {
        // Copy dataset to selectFactory
        /* istanbul ignore else */ if (arg.dataset.availableOptions) this.availableOptions = JSON.parse(arg.dataset.availableOptions);
    }
    // Get markdown information
    /**
   * Parse markdown-formatted dropdown text into `availableOptions`.
   *
   * @param arg - Optional markdown settings used to interpret tags
   */ furtherMarkdown(arg) {
        const markdownSettings = arg ?? this._defaultContentProps.markdownSettings;
        this.availableOptions = [];
        /* istanbul ignore else */ if (this.text.startsWith(markdownSettings.dropDownStartTag) && this.text.endsWith(markdownSettings.dropDownEndTag) && this.text.includes(markdownSettings.dropDownSelectedValueTag)) {
            this.text = this.text.slice(markdownSettings.dropDownStartTag.length, -markdownSettings.dropDownEndTag.length);
            const dd = this.text.indexOf(markdownSettings.dropDownSelectedValueTag);
            const current = this.text.slice(0, dd);
            const optionsTexts = this.text.slice(dd + markdownSettings.dropDownSelectedValueTag.length).split(markdownSettings.dropDownValueSeparator);
            this.markdownStyleLabel(current, markdownSettings);
            this.availableOptions = optionsTexts.map((optionText)=>{
                const ret = this.markdownStyleLabel(optionText, markdownSettings, false);
                return {
                    text: ret.text,
                    data: ret.style ? {
                        style: ret.style
                    } : undefined
                };
            });
        }
    }
    // Overload html return
    /**
   * Render the select block as a DocumentFragment containing a span that
   * includes option metadata. When editable, also displays the dropdown.
   *
   * @param renderProps - Render options and callbacks used by the editor
   * @param style - Optional style map
   * @returns DocumentFragment
   */ toHtml(renderProps, style) {
        // Create holder
        const ret = new DocumentFragment();
        const span = document.createElement("span");
        ret.appendChild(span);
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        span.classList.add("aiev3-tb", "select-block");
        span.dataset.lineStartPosition = this.lineStartPosition.toString();
        span.dataset.type = "select";
        // Add Text node
        const textNode = document.createTextNode(this.text.replaceAll(/[\u2009-\u200f]/g, "").replace(/^ /, "\u00a0").replace(/ $/, "\u00a0"));
        span.appendChild(textNode);
        // Add style
        this.applyStyle(span, style);
        // Add label
        if (this.label) span.title = this.label;
        // Add locked status
        span.classList.add("is-locked");
        span.dataset.isLocked = "true";
        span.contentEditable = "false";
        // Add other data items from the at item
        span.dataset.availableOptions = JSON.stringify(this.availableOptions);
        // Add caret
        const caret = document.createElement("span");
        caret.classList.add("select-block-caret", "skip-read");
        span.prepend(caret);
        // Throttle dropdown render
        let renderTimeout = null;
        // Editable render dropdown when selected
        if (!renderTimeout && this.isSelected && this.availableOptions.length > 0 && renderProps.caretPosition?.isCollapsed === false && renderProps.editableEl?.contentEditable === "true") {
            span.classList.add("show-dropdown");
            renderTimeout = window.setTimeout(()=>{
                $8b359e63c1cdd74d$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                    ...renderProps,
                    atListFunction: async ()=>{
                        return this.availableOptions.map((option)=>{
                            const listItem = document.createElement("li");
                            const tb = new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b({
                                text: option.text,
                                style: option.data?.style
                            });
                            tb.toHtml({
                                currentEl: listItem
                            }, renderProps.styles?.[option.data?.style ?? // istanbul ignore next
                            ""]);
                            return {
                                text: option.text,
                                data: option.data,
                                listRender: listItem
                            };
                        });
                    },
                    maxAtListLength: Math.max(1, this.availableOptions.length)
                });
            }, 100);
        }
        // Read-only render dropdown on hover
        if (renderProps.editableEl?.contentEditable === "false") {
            span.style.pointerEvents = "auto";
            span.onmousedown = (e)=>{
                e.preventDefault();
                e.stopPropagation();
            };
            span.addEventListener("mouseenter", ()=>{
                span.classList.add("show-dropdown");
                $8b359e63c1cdd74d$var$$4f9e74395483aeb1$export$86e7ee11642b7cd6(span, this.text, {
                    ...renderProps,
                    atListFunction: async ()=>{
                        return this.availableOptions.map((option)=>{
                            const listItem = document.createElement("li");
                            const tb = new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b({
                                text: option.text,
                                style: option.data?.style
                            });
                            tb.toHtml({
                                currentEl: listItem
                            }, renderProps.styles?.[option.data?.style ?? // istanbul ignore next
                            ""]);
                            return {
                                text: option.text,
                                data: option.data,
                                listRender: listItem
                            };
                        });
                    },
                    maxAtListLength: Math.max(1, this.availableOptions.length)
                }, true);
            });
            span.addEventListener("mouseleave", ()=>{
                const dropdown = document.querySelector(".aiev3-dropdown-list");
                /* istanbul ignore else */ if (dropdown) window.setTimeout(()=>{
                    dropdown.remove();
                }, 100);
            });
        }
        if (this.isActive) span.classList.add("is-active");
        // Add to current element if specified
        if (renderProps.currentEl) renderProps.currentEl.append(ret);
        // Always return
        return ret;
    }
    /**
   * Convert this select block into a markdown dropdown representation
   * using the provided settings. The returned string contains the
   * selected value followed by available options separated by the
   * configured separator tags.
   *
   * @param markdownSettings - Optional markdown settings used to control
   *        the encoding of options and selection.
   * @returns A markdown string representing the select block and its
   *          available options.
   */ toMarkdown(markdownSettings = this._defaultContentProps.markdownSettings) {
        let text = markdownSettings.dropDownStartTag;
        text += this.toMarkdownStyleLabel(markdownSettings);
        text += this.text + markdownSettings.dropDownSelectedValueTag + this._availableOptions.map((option)=>(option.data?.style ? option.data.style + markdownSettings.styleNameEndTag : "") + option.text).join(markdownSettings.dropDownValueSeparator);
        text += markdownSettings.dropDownEndTag;
        return text;
    }
}
const $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d = (arg, forcedParams)=>{
    // Span element
    if (arg instanceof HTMLSpanElement) switch(arg.dataset.type){
        case "at":
            return new $8b359e63c1cdd74d$export$2762eb7a56f6d4be(arg, forcedParams);
        case "select":
            return new $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
        default:
            return new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b(arg, forcedParams);
    }
    else if (arg instanceof DocumentFragment) {
        if (arg.childNodes.length > 0 && arg.childNodes[0] instanceof HTMLSpanElement) {
            const span = arg.childNodes[0];
            switch(span.dataset.type){
                case "at":
                    return new $8b359e63c1cdd74d$export$2762eb7a56f6d4be(arg, forcedParams);
                case "select":
                    return new $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
                default:
                    return new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b(arg, forcedParams);
            }
        }
        throw new Error("TextBlockFactory:DocumentFragment: Bad contents");
    } else if (arg instanceof Text) return new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b({
        text: (arg.textContent ?? // istanbul ignore next
        "").replaceAll("\u00a0", " ")
    }, forcedParams);
    else switch(forcedParams?.type ?? arg.type){
        case "at":
            return new $8b359e63c1cdd74d$export$2762eb7a56f6d4be(arg, forcedParams);
        case "select":
            return new $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d(arg, forcedParams);
        default:
            return new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b(arg, forcedParams);
    }
};
const $8b359e63c1cdd74d$var$$283486dc8b1946f0$export$1fe33d47a8cb2fd9 = (arg)=>{
    const ret = {
        textBlocks: [],
        decimalAlignPercent: 60,
        textAlignment: $8b359e63c1cdd74d$export$e6890f8825213b0d.left
    };
    // Remove skip-read elements
    const skipRead = arg.querySelectorAll(".skip-read");
    skipRead.forEach((el)=>el.remove());
    // Decimal aligned
    if (arg.classList.contains("aiev3-line")) {
        if (arg.classList.contains("decimal")) {
            ret.textAlignment = $8b359e63c1cdd74d$export$e6890f8825213b0d.decimal;
            ret.decimalAlignPercent = arg.children.length === 2 && arg.style.gridTemplateColumns ? parseFloat(arg.style.gridTemplateColumns.split("%")[0]) : 60;
            // This will skip the inner offcanvas span
            ret.textBlocks = arg.firstChild instanceof HTMLSpanElement && arg.lastChild instanceof HTMLSpanElement && arg.firstChild.classList.contains("lhs") && arg.lastChild.classList.contains("rhs") ? [
                ...[
                    ...arg.firstChild.childNodes
                ].map((el)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    })),
                ...[
                    ...arg.lastChild.childNodes
                ].map((el)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b") : [
                ...[
                    ...arg.childNodes
                ].map((el)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b");
        } else {
            ret.textBlocks = [
                ...[
                    ...arg.childNodes
                ].map((el)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(el instanceof HTMLSpanElement || el instanceof Text ? el : {
                        text: ""
                    }))
            ].filter((tb)=>tb.text !== "" && tb.text !== "\u200b");
            ret.textAlignment = [
                "left",
                "center",
                "right"
            ].includes(arg.classList[1]) ? arg.classList[1] : $8b359e63c1cdd74d$export$e6890f8825213b0d.left;
        }
    }
    // Ensure there is at least something
    if (ret.textBlocks.length === 0) ret.textBlocks = [
        new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b()
    ];
    return ret;
};
const $8b359e63c1cdd74d$var$$a6492f8421d8d930$export$dd39f3dafa818d0c = (renderProps, contentProps, lhsContent, rhsContent)=>{
    /* istanbul ignore else */ if (renderProps.currentEl) {
        const prePoint = document.createElement("span");
        prePoint.className = "aiev3-span-point lhs";
        renderProps.currentEl.append(prePoint);
        if (lhsContent.length) lhsContent.forEach((tb)=>prePoint.append(tb.toHtml({
                ...renderProps,
                currentEl: prePoint
            }, tb.style ? contentProps.styles?.[tb.style] : undefined)));
        else prePoint.textContent = "\u200b";
        // Set up space after (excluding) decimal
        const postPoint = document.createElement("span");
        postPoint.className = "aiev3-span-point rhs";
        renderProps.currentEl.append(postPoint);
        if (rhsContent.length) rhsContent.forEach((tb)=>{
            postPoint.append(tb.toHtml({
                ...renderProps,
                currentEl: postPoint
            }, tb.style ? contentProps.styles?.[tb.style] : undefined));
        });
        else postPoint.textContent = "\u200b";
        // Set grid column widths
        renderProps.currentEl.style.gridTemplateColumns = `${contentProps.decimalAlignPercent}% ${100 - contentProps.decimalAlignPercent}%`;
    }
};
class $8b359e63c1cdd74d$export$f727c5bfed9e77d4 {
    // #region Renderers
    /**
   * Render the line as editable HTML for the editor DOM.
   *
   * @param renderProps - Rendering options and targets used during build
   */ toHtml(renderProps) {
        const h = document.createElement("div");
        this._setBlockStartPositions();
        renderProps.currentEl = h;
        h.className = `aiev3-line ${this.contentProps.textAlignment}`;
        if (this.contentProps.textAlignment === $8b359e63c1cdd74d$export$e6890f8825213b0d.decimal) {
            const decimalPosition = this.lineText.match(/\./)?.index ?? Infinity;
            const upTo = this.upToPos(decimalPosition, true);
            const from = this.fromPos(decimalPosition, true);
            $8b359e63c1cdd74d$var$$a6492f8421d8d930$export$dd39f3dafa818d0c(renderProps, this.contentProps, upTo, from);
        } else {
            if (this.textBlocks[0]?.isLocked) {
                const startLineEl = document.createElement("span");
                startLineEl.textContent = "\u2009";
                h.appendChild(startLineEl);
            }
            this.textBlocks.forEach((tb)=>h.append(tb.toHtml(renderProps, tb.style ? this.contentProps.styles?.[tb.style] : undefined)));
        }
        // Need to add a space to the end of the line to allow for the cursor to be placed at the end
        if (this.textBlocks.length > 0 && this.textBlocks[this.textBlocks.length - 1].isLocked && this.contentProps.textAlignment !== $8b359e63c1cdd74d$export$e6890f8825213b0d.decimal) {
            const endLineEl = document.createElement("span");
            endLineEl.textContent = "\u200b";
            h.append(endLineEl);
        }
        if (renderProps.editableEl) renderProps.editableEl.append(h);
        return h;
    }
    /**
   * Render the line as a markdown-style HTML div. Used for read-only or
   * markdown-mode rendering.
   *
   * @param renderProps - Rendering options and targets used during build
   */ toMarkdown(renderProps) {
        const h = document.createElement("div");
        renderProps.currentEl = h;
        h.className = "aiev3-markdown-line";
        h.textContent = this.textBlocks.map((tb)=>tb.toMarkdown(renderProps.markdownSettings ?? this.contentProps.markdownSettings)).join("");
        if (h.textContent === "") h.textContent = "\u200b";
        if (renderProps.editableEl) renderProps.editableEl.append(h);
        return h;
    }
    // #endregion Renderers
    // #region Getters
    /**
   * Combined text of all blocks in the line.
   */ get lineText() {
        return this.textBlocks.map((tb)=>tb.text).join("");
    }
    /**
   * The markdown representation of the line by concatenating block markdowns.
   */ get lineMarkdown() {
        return this.textBlocks.map((tb)=>tb.toMarkdown()).join("");
    }
    /**
   * Word-level positions across all blocks in this line.
   */ get wordPositions() {
        return this.textBlocks.flatMap((tb)=>tb.wordPositions);
    }
    /**
   * Total character length of the line's text.
   */ get lineLength() {
        return this.lineText.length;
    }
    /**
   * Whether any block in the line is enhanced (non-default style/label/type).
   */ get isEnhanced() {
        return this.textBlocks.some((tb)=>tb.isEnhanced);
    }
    /**
   * Serialise the line to the model shape used by the EditorV3 API.
   */ get data() {
        const contentProps = (0, $eBlbF.cloneDeep)(this.contentProps);
        Object.keys($8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54).forEach((k)=>{
            const key = k;
            if ((0, $eBlbF.isEqual)(this.contentProps[key], this._defaultContentProps[key])) delete contentProps[key];
        });
        const textBlocks = this.textBlocks.map((tb)=>tb.data);
        return Object.keys(contentProps).length === 0 ? {
            textBlocks: textBlocks
        } : {
            contentProps: contentProps,
            textBlocks: textBlocks
        };
    }
    // #endregion Getters
    // #region Constructors
    // Constructor
    /**
   * Construct a line from a model object, HTML div, block array or markdown string.
   *
   * @param arg - Source value used to build the line
   * @param contentProps - Optional content property overrides
   */ constructor(arg, contentProps){
        this._defaultContentProps = (0, $eBlbF.cloneDeep)($8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Set defaults
        this.textBlocks = [];
        this.contentProps = (0, $eBlbF.cloneDeep)(this._defaultContentProps);
        // Markdown HTMLDivElement
        if (arg instanceof HTMLDivElement && arg.classList.contains("aiev3-markdown-line")) {
            this.contentProps = {
                ...contentProps,
                ...this._defaultContentProps
            };
            this.fromMarkdown(arg.textContent ?? // istanbul ignore next
            "");
        } else if (arg instanceof HTMLDivElement) {
            const ret = $8b359e63c1cdd74d$var$$283486dc8b1946f0$export$1fe33d47a8cb2fd9(arg);
            this.textBlocks = ret.textBlocks;
            this.contentProps.textAlignment = ret.textAlignment;
            this.contentProps.decimalAlignPercent = ret.decimalAlignPercent;
            // Only need to merge after HMTL read?
            this._mergeBlocks();
        } else if (typeof arg === "string") {
            this.contentProps = {
                ...contentProps,
                ...this._defaultContentProps
            };
            this.fromMarkdown(arg);
        } else if (Array.isArray(arg)) {
            this.textBlocks = arg;
            this._mergeBlocks();
        } else {
            this.textBlocks = arg?.textBlocks.map((tb)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(tb)) ?? [
                new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b()
            ];
            this.contentProps = {
                ...this.contentProps,
                ...arg?.contentProps
            };
        }
        // Always take these if provided
        if (contentProps) this.contentProps = {
            ...this._defaultContentProps,
            ...contentProps
        };
        // Fix any problems
        this._lockTextBlocksByStyle();
        this._setBlockStartPositions();
    }
    /**
   * Parse a markdown string and populate `textBlocks` according to markdown rules.
   *
   * @param markdown - The markdown string representing this line
   */ fromMarkdown(markdown) {
        /* istanbul ignore else */ if (this.contentProps.markdownSettings) {
            let remainingMarkdown = markdown.replace(/[\u2009-\u200f]/g, "");
            let safety = 0;
            while(remainingMarkdown.length > 0 && safety < 100){
                safety++;
                // Start of complete select block
                if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.dropDownStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownSelectedValueTag) > -1 && remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.dropDownEndTag);
                    this.textBlocks.push(new $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.dropDownEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.dropDownEndTag.length);
                } else if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.atStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.atEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.atEndTag);
                    this.textBlocks.push(new $8b359e63c1cdd74d$export$2762eb7a56f6d4be(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.atEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.atEndTag.length);
                } else if (remainingMarkdown.startsWith(this.contentProps.markdownSettings.styleStartTag) && remainingMarkdown.indexOf(this.contentProps.markdownSettings.styleEndTag) > -1) {
                    const blockEnd = remainingMarkdown.indexOf(this.contentProps.markdownSettings.styleEndTag);
                    this.textBlocks.push(new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b(remainingMarkdown.slice(0, blockEnd + this.contentProps.markdownSettings.styleEndTag.length), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd + this.contentProps.markdownSettings.styleEndTag.length);
                } else {
                    const nextDropTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.dropDownStartTag);
                    const nextAtTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.atStartTag);
                    const nextStyleTag = remainingMarkdown.slice(1).indexOf(this.contentProps.markdownSettings.styleStartTag);
                    const blockEnd = Math.min(nextDropTag > -1 ? nextDropTag + 1 : Infinity, nextAtTag > -1 ? nextAtTag + 1 : Infinity, nextStyleTag > -1 ? nextStyleTag + 1 : Infinity, remainingMarkdown.length);
                    this.textBlocks.push(new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b(remainingMarkdown.slice(0, blockEnd), {
                        markdownSettings: this.contentProps.markdownSettings
                    }));
                    remainingMarkdown = remainingMarkdown.slice(blockEnd);
                }
            }
        }
    }
    // #endregion Constructors
    // #region Get/Set block methods
    /**
   * Return the block containing a given character position.
   *
   * @param pos - Character index within the line
   */ getBlockAt(pos) {
        return this.textBlocks.find((tb)=>tb.lineStartPosition <= pos && tb.lineEndPosition > pos);
    }
    /**
   * Return the style name applied at a character position.
   *
   * @param pos - Character index within the line
   */ getStyleAt(pos) {
        return this.getBlockAt(pos)?.style;
    }
    /**
   * Return the names of all the styles used in the line.
   */ getAllStyles() {
        const stylesSet = new Set();
        this.textBlocks.forEach((tb)=>{
            if (tb.style) stylesSet.add(tb.style);
        });
        return Array.from(stylesSet);
    }
    /**
   * Set the active block according to a caret/selection position.
   *
   * @param pos - Position object describing the caret or selection
   */ setActiveBlock(pos) {
        this.textBlocks.forEach((tb)=>tb.setActive(false));
        const nextBlock = this.getBlockAt(pos.startChar);
        const lastBlock = this.getBlockAt(Math.max(0, pos.startChar - 1));
        if (lastBlock && lastBlock instanceof $8b359e63c1cdd74d$export$2762eb7a56f6d4be && pos.isCollapsed) {
            lastBlock.setActive(true);
            return lastBlock;
        } else if (nextBlock && nextBlock instanceof $8b359e63c1cdd74d$var$$55b76cc9e420f966$export$e7963cc196b8739d) {
            nextBlock.showDropdown();
            return nextBlock;
        } else {
            nextBlock?.setActive(true);
            return nextBlock;
        }
    }
    // #endregion Get/Set block methods
    // #region Subset methods
    /**
   * Extract a list of blocks representing a subset of the line between
   * `startPos` and `endPosOpt`. Optionally split locked blocks.
   *
   * @param startPos - Start character index
   * @param endPosOpt - Optional end character index
   * @param splitLocked - When true, locked blocks may be split to fit
   */ subBlocks(startPos, endPosOpt, splitLocked = false) {
        const ret = [];
        const endPos = endPosOpt ?? this.lineLength + 1;
        // Return empty styled block for start/end same
        if (startPos >= endPos || endPos <= 0) return ret;
        for(let _i = 0; _i < this.textBlocks.length; _i++){
            const block = this.textBlocks[_i];
            // Block after start and before end
            if (startPos <= block.lineStartPosition && block.lineEndPosition < endPos) ret.push((0, $eBlbF.cloneDeep)(block));
            else if (block.lineStartPosition < startPos && block.lineEndPosition > startPos && (!block.isLocked || splitLocked)) {
                const slicedBlock = $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    ...block.data,
                    // Split locked occurs on decimals, so lineStartPosition is needed
                    lineStartPosition: splitLocked ? block.lineStartPosition : undefined,
                    text: block.text.slice(startPos - block.lineStartPosition, endPos - block.lineStartPosition)
                });
                ret.push(slicedBlock);
            } else if (block.lineStartPosition >= startPos && block.lineStartPosition < endPos && block.lineEndPosition >= endPos) {
                if (block.isLocked && !splitLocked) ret.push((0, $eBlbF.cloneDeep)(block));
                else {
                    const slicedBlock = $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                        ...block,
                        text: block.text.slice(0, endPos - block.lineStartPosition)
                    });
                    ret.push(slicedBlock);
                }
            }
            // Stop if the end is reached
            if (block.lineStartPosition >= endPos) break;
        }
        if (!splitLocked) this._setBlockStartPositions(ret, startPos);
        return ret;
    }
    /**
   * Return blocks from the start of the line up to `pos`.
   *
   * @param pos - Character index to cut off at
   * @param splitLocked - Whether locked blocks can be split
   */ upToPos(pos, splitLocked = false) {
        return this.subBlocks(0, pos, splitLocked);
    }
    /**
   * Return blocks from `pos` to the end of the line.
   *
   * @param pos - Character index to start from
   * @param splitLocked - Whether locked blocks can be split
   */ fromPos(pos, splitLocked = false) {
        return this.subBlocks(pos, undefined, splitLocked);
    }
    // #endregion Subset methods
    // #region Insert and remove methods
    /**
   * Split the line at `pos` returning the tail as a new `EditorV3Line`.
   *
   * @param pos - Character index where the split occurs
   */ splitLine(pos) {
        if (pos >= this.lineLength) return new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(undefined, this.contentProps);
        else {
            const preSplit = this.upToPos(pos);
            const postSplit = this.fromPos(pos);
            this.textBlocks = preSplit.length > 0 ? preSplit : [
                new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b()
            ];
            this._setBlockStartPositions();
            return new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(postSplit, this.contentProps);
        }
    }
    /**
   * Insert blocks at a character position within the line.
   *
   * @param newTextBlocks - Blocks to insert
   * @param pos - Character index where insertion begins
   */ insertBlocks(newTextBlocks, pos) {
        const pre = this.upToPos(pos);
        const post = this.fromPos(pos);
        this.textBlocks = [
            ...pre,
            ...newTextBlocks,
            ...post
        ];
        this._mergeBlocks();
        this._setBlockStartPositions();
    }
    /**
   * Remove a section of the line between `startPos` and `endPos` and
   * return the removed blocks.
   *
   * @param startPos - Starting character index (inclusive)
   * @param endPos - Ending character index (exclusive)
   */ removeSection(startPos, endPos) {
        let ret = [];
        if (startPos < endPos && startPos < this.lineLength) {
            const pre = this.upToPos(startPos);
            ret = this.subBlocks(startPos, endPos);
            const post = this.fromPos(endPos);
            this.textBlocks = [
                ...pre,
                ...post
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return ret;
    }
    /**
   * Delete a single character at position `pos` and return the mutated line.
   *
   * @param pos - Character index to delete
   */ deleteCharacter(pos) {
        this.removeSection(pos, pos + 1);
        return this;
    }
    // #endregion Insert and remove methods
    // #region Update style methods
    /**
   * Apply a named style to a range of characters in the line.
   *
   * @param styleName - Style identifier to apply
   * @param startPos - Start character index
   * @param endPos - End character index
   */ applyStyle(styleName, startPos, endPos) {
        if (startPos < endPos) {
            const upTo = this.upToPos(startPos);
            const mid = this.subBlocks(startPos, endPos).map((tb)=>{
                tb.style = styleName;
                if (this.contentProps.styles?.[styleName]?.isLocked) tb.isLocked = true;
                return tb;
            });
            const from = this.fromPos(endPos);
            this.textBlocks = [
                ...upTo,
                ...mid,
                ...from
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return this;
    }
    /**
   * Remove style information from blocks in the supplied range.
   *
   * @param startPos - Start character index
   * @param endPos - End character index
   */ removeStyle(startPos, endPos) {
        if (startPos < endPos) {
            this.textBlocks = [
                ...this.upToPos(startPos),
                ...this.subBlocks(startPos, endPos).map((tb)=>{
                    tb.style = undefined;
                    if (tb.isLocked) delete tb.isLocked;
                    return tb;
                }),
                ...this.fromPos(endPos)
            ];
            this._mergeBlocks();
            this._setBlockStartPositions();
        }
        return this;
    }
    /**
   * Remove the style information from all blocks that have any of the specified styles.
   *
   * @param styleNames - Array of style names to remove
   * @returns The updated line instance
   */ cleanStyles(styleNames) {
        this.textBlocks = this.textBlocks.map((tb)=>{
            if (tb.style && styleNames.includes(tb.style)) {
                tb.style = undefined;
                if (tb.isLocked) delete tb.isLocked;
            }
            return tb;
        });
        this._mergeBlocks();
        this._setBlockStartPositions();
        return this;
    }
    /**
   * Delete text blocks that have any of the specified styles.
   *
   * @param styleNames - Array of style names to delete
   * @returns The updated line instance
   */ deleteStyles(styleNames) {
        this.textBlocks = this.textBlocks.filter((tb)=>styleNames.includes(tb.style ?? "") === false);
        if (this.textBlocks.length === 0) this.textBlocks = [
            new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b()
        ];
        this._mergeBlocks();
        this._setBlockStartPositions();
        return this;
    }
    // #endregion Update style methods
    // #region Private methods
    /**
   * Merge adjacent blocks that share the same merge key into single blocks.
   */ _mergeBlocks() {
        if (new Set(this.textBlocks.map((tb)=>tb.mergeKey)).size < this.textBlocks.length) {
            const mergedBlocks = [];
            let lastTypeStyle = null;
            for(let _i = 0; _i < this.textBlocks.length; _i++)if (this.textBlocks[_i].mergeKey === lastTypeStyle && mergedBlocks.length > 0) mergedBlocks[mergedBlocks.length - 1] = $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                ...mergedBlocks[mergedBlocks.length - 1].data,
                text: mergedBlocks[mergedBlocks.length - 1].text + this.textBlocks[_i].text
            });
            else {
                mergedBlocks.push(this.textBlocks[_i]);
                lastTypeStyle = this.textBlocks[_i].mergeKey;
            }
            this.textBlocks = mergedBlocks.filter((tb)=>tb.text !== "");
        }
    }
    /**
   * Apply `isLocked` to blocks when their style is defined as locked in
   * the content properties.
   */ _lockTextBlocksByStyle() {
        // Check for any locked styles
        const lockedStyles = Object.keys(this.contentProps.styles ?? []).filter((k)=>this.contentProps.styles[k].isLocked);
        if (lockedStyles.length > 0) this.textBlocks.forEach((tb)=>{
            if (lockedStyles.includes(tb.style ?? "")) tb.isLocked = true;
        });
    }
    /**
   * Calculate and set `lineStartPosition` for each block, optionally for a
   * provided subset starting at `initialPos`.
   *
   * @param blocks - Optional block array to update (defaults to this.textBlocks)
   * @param initialPos - Starting character position for the first block
   */ _setBlockStartPositions(blocks, initialPos = 0) {
        let _linePos = initialPos;
        const tbs = blocks ?? this.textBlocks;
        tbs.forEach((tb)=>{
            tb.lineStartPosition = _linePos;
            /* istanbul ignore else */ if (tb.lineEndPosition !== undefined) _linePos = tb.lineEndPosition;
        });
    }
}
const $8b359e63c1cdd74d$export$4c11677f6b5bfb11 = (value)=>{
    return {
        lines: value.replace(/[\u2009-\u200f\r\t]/g, "") // Undesirable non-printing chars
        .split(/\n/).map((line)=>({
                textBlocks: [
                    {
                        text: line,
                        type: "text"
                    }
                ]
            }))
    };
};
const $8b359e63c1cdd74d$var$$2067a2da3f93f04c$export$e225106f908d1c80 = (div, contentProps)=>{
    const ret = {
        lines: [],
        contentProps: contentProps
    };
    // Set up line counter
    let currentLine = 0;
    // Loop through all child nodes of the div
    div.childNodes.forEach((node)=>{
        // Handle aiev3-line div elements
        /* istanbul ignore else */ if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "DIV") {
            const div = node;
            let line = new $8b359e63c1cdd74d$export$f727c5bfed9e77d4("");
            /* istanbul ignore else */ if (div.classList.contains("aiev3-line")) line = new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(div);
            else if (div.classList.contains("aiev3-markdown-line")) line = new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(div.textContent ?? "", {
                ...$8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
                ...ret.contentProps,
                ...contentProps
            });
            // if the current line is not empty, append it
            if (currentLine < ret.lines.length && ret.lines[currentLine].lineText.length > 0) {
                ret.lines[currentLine] = new $8b359e63c1cdd74d$export$f727c5bfed9e77d4([
                    ...ret.lines[currentLine].textBlocks,
                    ...line.textBlocks
                ], ret.contentProps);
                currentLine++;
            } else {
                ret.lines.push(line);
                currentLine++;
            }
        } else if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent ?? "";
            const lines = $8b359e63c1cdd74d$export$4c11677f6b5bfb11(text).lines.map((l)=>new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(l));
            // Push each line to the ret.lines array, do not increment currentLine
            ret.lines.push(...lines);
        }
        // Always take contentProps from the input if it exists
        /* istanbul ignore else */ if (contentProps) ret.contentProps = contentProps;
    });
    // Trim down to data to return
    return {
        lines: ret.lines.map((l)=>l.data),
        contentProps: ret.contentProps
    };
};
/**
 * Finds the text node at a specific character offset within an HTML element.
 * Traverses child nodes accounting for locked blocks and special formatting to locate the text node and its internal offset.
 *
 * @param el - The HTML element to search for text nodes in
 * @param offset - The character offset position to locate within the element's text content
 * @returns Object with the text node and internal offset, or null if not found
 */ const $8b359e63c1cdd74d$var$$ca31a371b094ebb3$export$dded4910b0de370b = (el, offset)=>{
    let currentPos = 0;
    if (el) for(let _i = 0; _i < el.childNodes.length && currentPos <= offset; _i++){
        const currentNode = el.childNodes[_i];
        /* istanbul ignore else */ if (currentPos + (currentNode?.textContent?.replaceAll(/[\u2009-\u200f]/g, "") ?? "").length < offset) currentPos += (currentNode?.textContent?.replaceAll(/[\u2009-\u200f]/g, "") ?? "").length;
        else if (currentNode instanceof HTMLSpanElement && currentNode.classList.contains("is-locked") && offset !== 0) {
            const nextSibling = currentNode.nextSibling;
            if (nextSibling instanceof Text) return {
                node: nextSibling,
                offset: 0
            };
            else {
                const newTextNode = document.createTextNode("");
                el.insertBefore(newTextNode, nextSibling);
                return {
                    node: newTextNode,
                    offset: 0
                };
            }
        } else if (currentNode instanceof Element) return $8b359e63c1cdd74d$var$$ca31a371b094ebb3$export$dded4910b0de370b(currentNode, offset - currentPos);
        else if (currentNode instanceof Text) /* istanbul ignore else */ return {
            node: currentNode,
            offset: offset - currentPos
        };
    }
    return null;
};
function $8b359e63c1cdd74d$var$$91b8bca718afa68e$export$97ab23b40042f8af(el, pos) {
    // Go to a lower line if required
    /* istanbul ignore else */ if (el instanceof HTMLDivElement && el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line").length > 0) {
        const lines = el.querySelectorAll("div.aiev3-line, div.aiev3-markdown-line");
        /* istanbul ignore else */ if (lines && pos.startLine < lines.length) {
            const f = $8b359e63c1cdd74d$var$$ca31a371b094ebb3$export$dded4910b0de370b(lines[pos.startLine], pos.startChar);
            const l = $8b359e63c1cdd74d$var$$ca31a371b094ebb3$export$dded4910b0de370b(lines[pos.endLine], pos.endChar);
            /* istanbul ignore else */ if (f) {
                const range = document.createRange();
                range.setStart(f.node, f.offset);
                /* istanbul ignore else */ if (l) range.setEnd(l.node, l.offset);
                const sel = window.getSelection();
                /* istanbul ignore else */ if (sel && document.contains(range.startContainer) && document.contains(range.endContainer)) {
                    sel.removeAllRanges();
                    // Text node between locked spans
                    if (range.startOffset === 0 && range.startContainer instanceof Text && range.startContainer.parentElement instanceof HTMLDivElement && range.startContainer.nextSibling instanceof HTMLSpanElement && range.startContainer.nextSibling.classList.contains("is-locked") && range.startContainer.previousSibling instanceof HTMLSpanElement && range.startContainer.previousSibling.classList.contains("is-locked") && range.startContainer.textContent === "") range.startContainer.textContent = "\u200b";
                    if (range.endOffset === 0 && range.endContainer instanceof Text && range.endContainer.parentElement instanceof HTMLDivElement && range.endContainer.nextSibling instanceof HTMLSpanElement && range.endContainer.nextSibling.classList.contains("is-locked") && range.endContainer.previousSibling instanceof HTMLSpanElement && range.endContainer.previousSibling.classList.contains("is-locked") && range.endContainer.textContent === "") range.endContainer.textContent = "\u200b";
                    // Backwards selection
                    if (pos.data.focusAt === "start") sel.setBaseAndExtent(range.endContainer, range.endOffset, range.startContainer, range.startOffset);
                    else {
                        sel.addRange(range);
                        /* istanbul ignore else */ if (pos.isCollapsed) sel.collapseToEnd();
                    }
                }
            }
            return $8b359e63c1cdd74d$var$$87c84f58544c8738$export$7d120213748299d3(el);
        }
    }
    return null;
}
class $8b359e63c1cdd74d$var$$5a0668075ad354fa$export$79e893ac3b4e6564 {
    /**
   * Whether the selection is collapsed (caret) rather than a range.
   *
   * @returns boolean
   */ get isCollapsed() {
        return this.initialLine === this.focusLine && this.initialChar === this.focusChar;
    }
    /**
   * The lower of the two line indices making up the selection.
   *
   * @returns number
   */ get startLine() {
        return Math.min(this.initialLine, this.focusLine);
    }
    /**
   * The higher of the two line indices making up the selection.
   *
   * @returns number
   */ get endLine() {
        return Math.max(this.initialLine, this.focusLine);
    }
    /**
   * The starting character index of the selection (smallest character index
   * considering line ordering and collapsed selections).
   *
   * @returns number
   */ get startChar() {
        return this.initialLine < this.focusLine ? this.initialChar : this.initialLine > this.focusLine ? this.focusChar : Math.min(this.initialChar, this.focusChar);
    }
    /**
   * The ending character index of the selection (largest character index
   * considering line ordering and collapsed selections).
   *
   * @returns number
   */ get endChar() {
        return this.initialLine < this.focusLine ? this.focusChar : this.initialLine > this.focusLine ? this.initialChar : Math.max(this.initialChar, this.focusChar);
    }
    /**
   * Current start/end selection information derived from this position.
   * Includes `isCollapsed` and the computed `focusAt` direction.
   *
   * @returns A plain `EditorV3Position` object representing the current
   *          selection range.
   */ get pos() {
        return {
            startLine: this.startLine,
            startChar: this.startChar,
            endLine: this.endLine,
            endChar: this.endChar,
            isCollapsed: this.isCollapsed,
            focusAt: this.endLine === this.focusLine && this.endChar === this.focusChar ? "end" : "start"
        };
    }
    /**
   * The raw floating position data with initial/focus coordinates.
   * Useful for serialising or restoring precise caret state.
   *
   * @returns An `EditorV3PositionF` representing the internal anchor and
   *          focus coordinates.
   */ get posF() {
        return {
            initialLine: this.initialLine,
            initialChar: this.initialChar,
            focusLine: this.focusLine,
            focusChar: this.focusChar
        };
    }
    /**
   * Serialised position data including start/end, collapse state and
   * caret focus direction.
   */ get data() {
        return {
            ...this.pos,
            initialLine: this.initialLine,
            initialChar: this.initialChar,
            focusLine: this.focusLine,
            focusChar: this.focusChar
        };
    }
    /**
   * Create a new position instance.
   *
   * @param initialLine - Initial anchor line index
   * @param initialChar - Initial anchor character index
   * @param focusLine - Focus line index
   * @param focusChar - Focus character index
   * @param lineLengths - Array of line lengths used for bounds checking
   * @param words - Word positions used for word-wise navigation
   */ constructor(initialLine, initialChar, focusLine, focusChar, lineLengths, words){
        this.lastAction = "move";
        this.lastKey = undefined;
        this.initialLine = initialLine;
        this.initialChar = initialChar;
        this.focusLine = focusLine;
        this.focusChar = focusChar;
        this.lineLengths = lineLengths;
        this.words = words;
    }
    /**
   * Internal helper used to adjust collapse state after movement operations.
   *
   * @param shiftKey - Whether the shift key is pressed
   */ _checkCollapse(shiftKey) {
        if (this.lastAction === "move" && !shiftKey) {
            this.initialLine = this.focusLine;
            this.initialChar = this.focusChar;
        } else if (this.lastAction !== "select" && shiftKey) this.lastAction = "select";
    }
    /**
   * Set the caret/selection based on an external `EditorV3Position` input.
   *
   * @param posInput - Position object describing the desired selection
   */ setCaret(posInput) {
        const pos = posInput;
        if (pos && !pos.focusAt) pos.focusAt = "end";
        if (pos && !(0, $eBlbF.isEqual)(pos, this.pos)) {
            if (pos.focusAt === "end") {
                this.initialLine = pos.startLine;
                this.initialChar = pos.startChar;
                this.focusLine = pos.endLine;
                this.focusChar = pos.endChar;
            } else {
                this.initialLine = pos.endLine;
                this.initialChar = pos.endChar;
                this.focusLine = pos.startLine;
                this.focusChar = pos.startChar;
            }
        }
    }
    /**
   * Move the caret left by one character or word depending on modifier keys.
   *
   * @param shiftKey - Whether the shift key is pressed (extend selection)
   * @param ctrlKey - Whether the ctrl key is pressed (jump by word)
   */ moveLeft(shiftKey, ctrlKey) {
        // CTRL at the start of a line to beginning of item
        if (ctrlKey && this.focusChar === 0 && this.focusLine > 0) {
            this.focusLine = 0;
            this.focusChar = 0;
        } else if (ctrlKey) {
            const nextWordBoundary = this.words.filter((w)=>w.line === this.focusLine && w.startChar < this.focusChar).reduce((acc, cur)=>cur.startChar > acc ? cur.startChar : acc, 0);
            this.focusChar = nextWordBoundary;
        } else if (!this.isCollapsed && !shiftKey) {
            this.focusChar = this.startChar;
            this.lastAction = "move";
        } else if (this.focusChar === 0) {
            if (this.focusLine > 0) {
                this.focusLine -= 1;
                this.focusChar = this.lineLengths[this.focusLine];
            }
        } else {
            this.focusChar -= 1;
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.startChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.endChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret right by one character or word depending on modifier keys.
   *
   * @param shiftKey - Whether the shift key is pressed (extend selection)
   * @param ctrlKey - Whether the ctrl key is pressed (jump by word)
   */ moveRight(shiftKey, ctrlKey) {
        // CTRL at the end of a line to end of item
        if (ctrlKey && this.focusChar === this.lineLengths[this.focusLine] && this.focusLine < this.lineLengths.length - 1) {
            this.focusLine = this.lineLengths.length - 1;
            this.focusChar = this.lineLengths[this.focusLine];
        } else if (ctrlKey) {
            const nextWordBoundary = this.words.filter((w)=>w.line === this.focusLine && w.endChar > this.focusChar).reduce((acc, cur)=>cur.endChar < acc ? cur.endChar : acc, this.lineLengths[this.focusLine]);
            this.focusChar = nextWordBoundary;
        } else if (!this.isCollapsed && !shiftKey) {
            this.focusChar = this.endChar;
            this.lastAction = "move";
        } else if (this.focusChar === this.lineLengths[this.focusLine]) {
            if (this.focusLine < this.lineLengths.length - 1) {
                this.focusLine += 1;
                this.focusChar = 0;
            }
        } else {
            this.focusChar += 1;
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.endChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.startChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret up one line, adjusting character position and handling
   * locked-word expansion.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the top/beginning
   */ moveUp(shiftKey, ctrlKey) {
        // Already at the top
        /* istanbul ignore else */ if (this.focusLine === 0) {
            this.focusChar = 0;
            this.lastAction = "move";
        } else if (this.focusLine > 0) {
            if (ctrlKey) this.focusLine = 0;
            else this.focusLine -= 1;
            // Check line length
            if (this.focusChar > this.lineLengths[this.focusLine]) this.focusChar = this.lineLengths[this.focusLine];
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.startChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.endChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move the caret down one line, adjusting character position and handling
   * locked-word expansion.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the end/bottom
   */ moveDown(shiftKey, ctrlKey) {
        // Already at the bottom
        /* istanbul ignore else */ if (this.focusLine === this.lineLengths.length - 1) {
            this.focusChar = this.lineLengths[this.focusLine];
            this.lastAction = "move";
        } else if (this.focusLine < this.lineLengths.length - 1) {
            if (ctrlKey) this.focusLine = this.lineLengths.length - 1;
            else this.focusLine += 1;
            // Check line length
            if (this.focusChar > this.lineLengths[this.focusLine]) this.focusChar = this.lineLengths[this.focusLine];
            // Check if we are inside a locked block and expand
            const insideLocked = this.words.find((w)=>w.isLocked && w.line === this.focusLine && w.startChar < this.focusChar && w.endChar > this.focusChar);
            if (insideLocked) {
                this.lastAction = "select";
                this.focusChar = insideLocked.endChar;
                if (!shiftKey) {
                    this.initialLine = insideLocked.line;
                    this.initialChar = insideLocked.startChar;
                }
            }
        }
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move caret to the start of the current line or top of content if `ctrlKey`.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the very start
   */ moveHome(shiftKey, ctrlKey) {
        // Move to the top line on CTRL to already at the start
        if (ctrlKey || this.startChar === 0) this.focusLine = 0;
        this.focusChar = 0;
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
    /**
   * Move caret to the end of the current line or bottom of content if `ctrlKey`.
   *
   * @param shiftKey - Whether to extend the selection
   * @param ctrlKey - Whether to jump to the very end
   */ moveEnd(shiftKey, ctrlKey) {
        if (ctrlKey || this.endChar === this.lineLengths[this.endLine]) this.focusLine = this.lineLengths.length - 1;
        this.focusChar = this.lineLengths[this.focusLine];
        // Collapse if required
        this._checkCollapse(shiftKey);
    }
}
class $8b359e63c1cdd74d$export$1a4903393d6b1b7d {
    /**
   * Current text alignment.
   */ get textAlignment() {
        return this._textAlignment;
    }
    /**
   * Set text alignment.
   *
   * @param newTa - The new text alignment value
   */ set textAlignment(newTa) {
        /* istanbul ignore else */ if (newTa !== this._textAlignment) {
            this.lines.forEach((l)=>l.contentProps.textAlignment = newTa);
            this._textAlignment = newTa;
        }
    }
    /**
   * Current decimal alignment percent.
   */ get decimalAlignPercent() {
        return this._decimalAlignPercent;
    }
    /**
   * Set decimal alignment percent.
   *
   * @param newDap - The new decimal alignment percentage
   */ set decimalAlignPercent(newDap) {
        /* istanbul ignore else */ if (newDap !== this._decimalAlignPercent) {
            this.lines.forEach((l)=>l.contentProps.decimalAlignPercent = newDap);
            this._decimalAlignPercent = newDap;
        }
    }
    /**
   * Current available styles in the editor.
   */ get styles() {
        return this._styles;
    }
    /**
   * Set available styles.
   *
   * @param newStyles - The new style definitions
   */ set styles(newStyles) {
        this._styles = newStyles;
    }
    /**
   * Get all styles currently used in the content.
   */ get hasStyles() {
        const usedStyles = new Set();
        this.lines.forEach((line)=>{
            line.getAllStyles().forEach((s)=>usedStyles.add(s));
        });
        return Array.from(usedStyles).sort((a, b)=>a.localeCompare(b));
    }
    /**
   * Whether markdown syntax is allowed.
   */ get allowMarkdown() {
        return this._allowMarkdown;
    }
    /**
   * Set whether markdown syntax is allowed.
   *
   * @param newAllow - Whether to allow markdown
   */ set allowMarkdown(newAllow) {
        this._allowMarkdown = newAllow;
    }
    /**
   * Current markdown parsing settings.
   */ get markdownSettings() {
        return this._markdownSettings;
    }
    /**
   * Set markdown parsing settings.
   *
   * @param newSettings - The new markdown settings
   */ set markdownSettings(newSettings) {
        this._markdownSettings = newSettings;
        this.lines.forEach((l)=>l.contentProps.markdownSettings = newSettings);
    }
    /**
   * Whether to display markdown syntax instead of rendered content.
   */ get showMarkdown() {
        return this._showMarkdown;
    }
    /**
   * Set whether to display markdown syntax.
   *
   * @param newShow - Whether to show markdown
   */ set showMarkdown(newShow) {
        this._showMarkdown = newShow;
    }
    /**
   * Whether window view mode is allowed.
   */ get allowWindowView() {
        return this._allowWindowView;
    }
    /**
   * Set whether window view mode is allowed.
   *
   * @param newAllow - Whether to allow window view
   */ set allowWindowView(newAllow) {
        this._allowWindowView = newAllow;
    }
    /**
   * Function to fetch at-mention suggestions.
   */ get atListFunction() {
        return this._atListFunction;
    }
    /**
   * Maximum number of at-mention suggestions to display.
   */ get maxAtListLength() {
        return this._maxAtListLength;
    }
    /**
   * Whether multiple lines are allowed.
   */ get allowNewLine() {
        return this._allowNewLine;
    }
    /**
   * Set whether multiple lines are allowed.
   *
   * @param newAllow - Whether to allow new lines
   */ set allowNewLine(newAllow) {
        this._allowNewLine = newAllow;
    }
    /**
   * Array of line lengths.
   */ get lineLengths() {
        return this.lines.map((l)=>l.lineLength);
    }
    /**
   * Array of word positions across all lines.
   */ get wordPositions() {
        return this.lines.flatMap((l, ix)=>l.wordPositions.map((w)=>({
                    ...w,
                    line: ix
                })));
    }
    /**
   * Gets the caret position.
   *
   * @returns The current caret position or null
   */ get caretPosition() {
        return this._caretPosition?.pos ?? null;
    }
    /**
   * Sets the caret position.
   *
   * @param posInput - The new caret position or null
   */ set caretPosition(posInput) {
        if (posInput === null) this._caretPosition = null;
        else if (this._caretPosition) this._caretPosition.setCaret(posInput);
        else {
            const newPos = posInput.focusAt === "start" ? new $8b359e63c1cdd74d$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.endLine, posInput.endChar, posInput.startLine, posInput.startChar, this.lineLengths, this.wordPositions) : new $8b359e63c1cdd74d$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.startLine, posInput.startChar, posInput.endLine, posInput.endChar, this.lineLengths, this.wordPositions);
            this._caretPosition = newPos;
        }
    }
    /**
   * Gets the caret position with focus information.
   *
   * @returns The current caret position with focus or null
   */ get caretPositionF() {
        return this._caretPosition?.posF ?? null;
    }
    /**
   * Sets the caret position with focus information.
   *
   * @param posInput - The new caret position with focus or null
   */ set caretPositionF(posInput) {
        if (posInput === null) this._caretPosition = null;
        else this._caretPosition = new $8b359e63c1cdd74d$var$$5a0668075ad354fa$export$79e893ac3b4e6564(posInput.initialLine, posInput.initialChar, posInput.focusLine, posInput.focusChar, this.lineLengths, this.wordPositions);
    }
    /**
   * Indicates if the current content can be updated with this selection.
   *
   * @param pos - The position to check
   * @returns True if caret is locked
   */ isCaretLocked(pos = this._caretPosition) {
        /* istanbul ignore else */ if (!pos || pos.isCollapsed) return false;
        const selectedBlocks = this.subLines(pos).flatMap((l)=>l.textBlocks);
        return selectedBlocks.length > 1 && selectedBlocks.some((b)=>b.isLocked);
    }
    /**
   * Check if any at blocks are present that can be locked.
   *
   * @returns True if lockable at blocks exist
   */ get _isLockable() {
        return this.lines.some((l)=>l.textBlocks.some((tb)=>tb.type === "at" && !tb.isLocked));
    }
    /**
   * Text from the element.
   *
   * @returns Plain text content
   */ get text() {
        return this.lines.map((l)=>l.lineText).join("\n");
    }
    /**
   * Markdown text from the element.
   *
   * @returns Markdown formatted content
   */ get markdownText() {
        return this.lines.map((l)=>l.lineMarkdown).join("\n");
    }
    /**
   * Returns true if the content is not plain text.
   *
   * @returns True if content has styles or special blocks
   */ get isEnhanced() {
        return this.lines.some((l)=>l.isEnhanced);
    }
    /**
   * Current content properties.
   *
   * @returns Content properties object
   */ get contentProps() {
        return {
            textAlignment: this._textAlignment,
            decimalAlignPercent: this._decimalAlignPercent,
            styles: this._styles,
            allowNewLine: this._allowNewLine,
            allowWindowView: this._allowWindowView,
            showMarkdown: this._showMarkdown,
            markdownSettings: this._markdownSettings,
            allowMarkdown: this._allowMarkdown,
            atListFunction: this.atListFunction,
            maxAtListLength: this._maxAtListLength
        };
    }
    /**
   * Data representation of content.
   *
   * @returns Serializable content data
   */ get data() {
        const contentProps = (0, $eBlbF.cloneDeep)(this.contentProps);
        Object.keys($8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54).forEach((k)=>{
            const key = k;
            /* istanbul ignore else */ if (typeof this[key] === "function") delete contentProps[key];
            if ((0, $eBlbF.isEqual)(this[key], this._defaultContentProps[key])) delete contentProps[key];
        });
        const lines = this.lines.map((l)=>({
                textBlocks: l.textBlocks.map((tb)=>tb.data)
            }));
        const ret = {
            lines: lines
        };
        if (Object.keys(contentProps).length > 0) ret.contentProps = contentProps;
        if (this._caretPosition) ret.caretPosition = this._caretPosition.pos;
        return ret;
    }
    /**
   * Element to render.
   *
   * @param renderProps - The rendering properties
   * @returns Document fragment containing the rendered HTML
   */ toHtml(renderProps) {
        // Remove any existing dropdowns
        const previousDropdown = document.querySelectorAll(".aiev3-dropdown-list");
        previousDropdown.forEach((dropdown)=>dropdown.remove());
        // Create new DocumentFragment
        const ret = new DocumentFragment();
        // Add each line to the element
        this.lines.forEach((l)=>ret.append(l.toHtml(renderProps)));
        // Add content properties node
        /* istanbul ignore else */ if (renderProps.editableEl) renderProps.editableEl.append(ret);
        return ret;
    }
    /**
   * Convert the editor model into a markdown-styled HTML fragment.
   *
   * @param renderProps - Rendering options applied during build
   */ toMarkdownHtml(renderProps) {
        const ret = new DocumentFragment();
        // Add content to the element
        this.lines.forEach((l)=>ret.append(l.toMarkdown(renderProps)));
        /* istanbul ignore else */ if (renderProps.editableEl) renderProps.editableEl.append(ret);
        return ret;
    }
    /**
   * Create a new EditorV3Content instance from a string, DOM node or model.
   *
   * @param arg - Optional source content: HTML `div`, serialized JSON string or model
   * @param props - Optional content properties to override defaults
   */ constructor(arg, props){
        this._defaultContentProps = (0, $eBlbF.cloneDeep)($8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54);
        // Standard attributes
        this._textAlignment = this._defaultContentProps.textAlignment;
        this._decimalAlignPercent = this._defaultContentProps.decimalAlignPercent;
        this._styles = this._defaultContentProps.styles;
        this._allowMarkdown = this._defaultContentProps.allowMarkdown;
        this._markdownSettings = this._defaultContentProps.markdownSettings;
        this._showMarkdown = this._defaultContentProps.showMarkdown;
        this._allowWindowView = this._defaultContentProps.allowWindowView;
        this._maxAtListLength = this._defaultContentProps.maxAtListLength;
        /**
   * Current lines in the editor.
   */ this.lines = [];
        this._allowNewLine = this._defaultContentProps.allowNewLine;
        /**
   * Current caret position and lock status.
   */ this._caretPosition = null;
        /**
   * Handle copy and cut inside the holding div
   *
   * @param e Copy or cut event
   */ this.handleCopy = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            /* istanbul ignore else */ if (this._caretPosition) {
                const toClipboard = this.subLines(this._caretPosition);
                e.clipboardData.setData("text/plain", toClipboard.map((l)=>l.lineText).join("\n"));
                e.clipboardData.setData("text/html", toClipboard.map((l)=>l.toHtml({}).outerHTML).join(""));
                e.clipboardData.setData("data/aiev3", JSON.stringify(toClipboard.map((l)=>l.data)));
                /* istanbul ignore else */ if (e.type === "cut" && !this.isCaretLocked()) this.splice(this._caretPosition);
            }
        };
        // Process incoming data
        /* istanbul ignore else */ if (arg instanceof HTMLDivElement) {
            // Remove skip-read elements
            const skipRead = arg.querySelectorAll(".skip-read");
            skipRead.forEach((el)=>el.remove());
            // Read in HTML
            const r = $8b359e63c1cdd74d$var$$2067a2da3f93f04c$export$e225106f908d1c80(arg, props ?? this.contentProps);
            this._copyImport(r);
            this.caretPositionF = $8b359e63c1cdd74d$var$$87c84f58544c8738$export$7d120213748299d3(arg);
        } else if (typeof arg === "string") this.loadString(arg, props);
        else if (arg !== undefined) this._copyImport(arg, props);
        else this.lines = [
            new $8b359e63c1cdd74d$export$f727c5bfed9e77d4()
        ];
        // Forced parameters
        if (props) {
            this._updateProps(props);
            this.lines.map((l)=>l.contentProps = this.contentProps);
        }
        if (this.lines.length === 0) this.lines = [
            new $8b359e63c1cdd74d$export$f727c5bfed9e77d4()
        ];
    }
    /**
   * Update internal content properties from provided settings.
   *
   * @param props - Partial content properties to merge into the instance
   */ _updateProps(props) {
        if (props.allowMarkdown !== undefined) this._allowMarkdown = props.allowMarkdown;
        if (props.allowNewLine !== undefined) this._allowNewLine = props.allowNewLine;
        if (props.allowWindowView !== undefined) this._allowWindowView = props.allowWindowView;
        if (props.decimalAlignPercent !== undefined) this._decimalAlignPercent = props.decimalAlignPercent;
        if (props.markdownSettings !== undefined) this._markdownSettings = props.markdownSettings;
        if (props.showMarkdown !== undefined) this._showMarkdown = props.showMarkdown;
        if (props.styles !== undefined) this._styles = props.styles;
        if (props.textAlignment !== undefined) this._textAlignment = props.textAlignment;
        if (props.atListFunction !== undefined) this._atListFunction = props.atListFunction;
        if (props.maxAtListLength !== undefined) this._maxAtListLength = props.maxAtListLength;
    }
    /* istanbul ignore else */ /**
   * Debug helper that logs a representation of the content lines to the console.
   *
   * @param from - Label to prefix the debug output
   */ _debugText(from) {
        console.debug(from + "\n", this.lines.map((l)=>l.textBlocks.map((tb)=>tb.text).join("|")).join("\n"));
    }
    /**
   * Copy data from a parsed model into this instance, merging content props.
   *
   * @param read - Model data to import into this instance
   * @param props - Optional properties to merge during import
   */ _copyImport(read, props) {
        const consolidatedProps = {
            ...read.contentProps,
            ...props
        };
        this._updateProps(consolidatedProps);
        this.lines = read.lines.map((l)=>l instanceof $8b359e63c1cdd74d$export$f727c5bfed9e77d4 ? l : new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(l, consolidatedProps));
        this.caretPosition = read.caretPosition ?? null;
    }
    /**
   * Load content from a serialized string representation. Attempts JSON first,
   * falls back to parsing HTML and finally to a V3 string conversion.
   *
   * @param arg - String input containing JSON, HTML or plain text
   * @param props - Optional content props to apply during load
   */ loadString(arg, props) {
        try {
            // Check for stringified class input
            const jsonInput = JSON.parse(arg);
            if (!Array.isArray(jsonInput.lines)) throw "No lines";
            this._copyImport(jsonInput, props);
        } catch  {
            // Check if the input is HTML
            /* istanbul ignore else */ if (arg.match(/^<div(.*)<\/div>$/i)) {
                // Read in v3 HTML/text
                const div = document.createElement("div");
                div.innerHTML = arg;
                // Check this is a v3 input
                /* istanbul ignore else */ if (Array.from(div.childNodes).every((node)=>node.nodeType === Node.ELEMENT_NODE && node.nodeName === "DIV" && (node.classList.contains("aiev3-line") || node.classList.contains("aiev3-markdown-line")))) {
                    const r = $8b359e63c1cdd74d$var$$2067a2da3f93f04c$export$e225106f908d1c80(div, props ?? this.contentProps);
                    this._copyImport(r);
                    return;
                }
            }
            this._copyImport($8b359e63c1cdd74d$export$4c11677f6b5bfb11(arg));
        }
    }
    /**
   * Return a subset of `EditorV3Line` instances from the content based on a position.
   *
   * @param pos - Position object describing a range within the content
   */ subLines(pos) {
        const ret = [];
        if (pos.startLine === pos.endLine && pos.startChar === pos.endChar && pos.startLine < this.lines.length) {
            const style = this.lines[pos.startLine].getStyleAt(pos.startChar);
            ret.push(new $8b359e63c1cdd74d$export$f727c5bfed9e77d4([
                $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: "",
                    style: style
                })
            ], this.contentProps));
        }
        // Check selection contains something
        if (pos.startLine < this.lines.length && (pos.startLine === pos.endLine && pos.startChar < pos.endChar || pos.startLine < pos.endLine)) {
            // First line
            /* istanbul ignore else */ if (pos.startLine <= pos.endLine) {
                const subBlocks = new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(this.lines[pos.startLine].subBlocks(pos.startChar, pos.startLine === pos.endLine ? pos.endChar : undefined), this.contentProps);
                if (subBlocks.textBlocks.length === 0) subBlocks.textBlocks.push($8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: ""
                }));
                ret.push(subBlocks);
            }
            // At least one line between
            if (pos.startLine + 1 < pos.endLine) ret.push(...this.lines.slice(pos.startLine + 1, pos.endLine));
            // End line to end character
            if (pos.startLine < pos.endLine && pos.endLine < this.lines.length) ret.push(new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(this.lines[pos.endLine].upToPos(pos.endChar), this.contentProps));
        }
        return ret;
    }
    /**
   * Return the lines from the start of the content up to the specified
   * end position. The returned array represents the content slice ending
   * at the given line/character (exclusive of any subsequent content).
   *
   * @param endLine - Zero-based index of the line to end at.
   * @param endChar - Character index on `endLine` to end at.
   * @returns An array of `EditorV3Line` representing the content up to the
   *          specified position.
   */ upToPos(endLine, endChar) {
        return this.subLines({
            startLine: 0,
            startChar: 0,
            endLine: endLine,
            endChar: endChar
        });
    }
    /**
   * Return the lines from the specified start position to the end of the
   * content. This is the complement of `upToPos` and includes all content
   * from `startLine`/`startChar` through the last line.
   *
   * @param startLine - Zero-based index of the line to start from.
   * @param startChar - Character index on `startLine` to start from.
   * @returns An array of `EditorV3Line` representing the content from the
   *          specified position to the end.
   */ fromPos(startLine, startChar) {
        return this.subLines({
            startLine: startLine,
            startChar: startChar,
            endLine: this.lines.length - 1,
            endChar: this.lines[this.lines.length - 1].lineLength
        });
    }
    /**
   * Get the active style at a particular line and character index.
   * Returns the style name if present, otherwise `undefined`.
   *
   * @param line - Zero-based line index to query.
   * @param character - Character index within the line to query.
   * @returns The style name at the specified position, or `undefined`.
   */ getStyleAt(line, character) {
        return line < this.lines.length ? this.lines[line].getStyleAt(character) : undefined;
    }
    /**
   * Split the content at the given position. The line containing `pos`
   * will be split into two lines and the internal `lines` array updated.
   * The returned value is the new collapsed caret position after the split.
   *
   * @param pos - Position at which to split the line.
   * @returns A collapsed `EditorV3Position` representing the caret after
   *          the split.
   */ splitLine(pos) {
        const u = this.upToPos(pos.startLine, pos.startChar);
        const f = this.fromPos(pos.endLine, pos.endChar);
        const newLines = [
            ...u,
            ...f
        ];
        this.lines = newLines;
        return {
            isCollapsed: true,
            startLine: pos.startLine + 1,
            startChar: 0,
            endLine: pos.startLine + 1,
            endChar: 0
        };
    }
    /**
   * Merge the specified line with the following line if the following
   * line exists. After merging, the following line is removed.
   *
   * @param line - Index of the line to merge with the next line.
   */ mergeLines(line) {
        if (this.lines.length > line + 1) {
            this.lines[line].insertBlocks(this.lines[line + 1].textBlocks, this.lines[line].lineLength);
            this.lines.splice(line + 1, 1);
        }
    }
    /**
   * Delete a character at or around the current caret position. When
   * `backwards` is true the method behaves like a backspace; otherwise
   * it behaves like a forward delete. Optionally provide a `pos` to set
   * the caret before deletion.
   *
   * @param backwards - If true, delete backwards (backspace). If false,
   *        delete forwards (delete).
   * @param pos - Optional position to set as the caret before deletion.
   */ deleteCharacter(backwards, pos) {
        // Update caret position
        if (pos) this.caretPosition = pos;
        // Check caret position exists
        if (this._caretPosition && this._caretPosition.isCollapsed) {
            // Extend selection one place backwards
            if (backwards) this._caretPosition?.moveLeft(true, false);
            else this._caretPosition?.moveRight(true, false);
        }
        /* istanbul ignore else */ if (this._caretPosition) this.splice(this._caretPosition.pos);
    }
    /**
   * Find all occurrences of the given text in the content and return an
   * array of `EditorV3Position` ranges for each match. Returns `null` if
   * no matches are found.
   *
   * @param text - The substring to search for.
   * @returns An array of positions for each match, or `null` when none are
   *          found.
   */ getTextPosition(text) {
        const ret = [];
        this.lines.forEach((l, ix)=>{
            l.textBlocks.forEach((tb)=>{
                let pos = 0;
                while(tb.text.indexOf(text, pos) >= 0){
                    const found = tb.text.indexOf(text, pos);
                    /* istanbul ignore else */ if (found >= 0) {
                        ret.push({
                            isCollapsed: false,
                            startLine: ix,
                            startChar: tb.lineStartPosition + found,
                            endLine: ix,
                            endChar: tb.lineStartPosition + found + text.length
                        });
                        pos = found + text.length;
                    }
                }
            });
        });
        return ret.length > 0 ? ret : null;
    }
    /**
   * Replace the content in `pos` with the optional `newLines`. Returns
   * the lines that were removed by the splice operation.
   *
   * @param pos - The position range to replace.
   * @param newLines - Optional array of `EditorV3Line` to insert at `pos`.
   * @returns An array of `EditorV3Line` representing the removed content.
   */ splice(pos, newLines) {
        // if (this._showMarkdown) {
        //   return this.spliceMarkdown(pos, newLines);
        // } else
        if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine && !(pos.startLine === pos.endLine && pos.endChar < pos.startChar)) {
            const ret = this.subLines(pos);
            const u = this.upToPos(pos.startLine, pos.startChar);
            const f = this.fromPos(pos.endLine, pos.endChar);
            this.lines = [
                ...u,
                ...newLines ? newLines.map((l)=>new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(l, this.contentProps)) : [],
                ...f
            ];
            // Merge line after U
            this.mergeLines(pos.startLine);
            // Merge line after newLines if it exists and there is something after it
            if (newLines?.length) this.mergeLines(pos.startLine + newLines.length - 1);
            // Check all lines have at least 1 text block
            this.lines.forEach((l)=>{
                /* istanbul ignore else */ if (l.textBlocks.length === 0) l.textBlocks.push($8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    text: "",
                    style: l.getStyleAt(0)
                }));
            });
            // Calculate end character position
            const endChar = !newLines || newLines.length === 0 ? pos.startChar : newLines?.length === 1 ? pos.startChar + newLines[0].lineLength : newLines[newLines.length - 1].lineLength;
            // Update caret position if it is set
            if (this._caretPosition) this._caretPosition = new $8b359e63c1cdd74d$var$$5a0668075ad354fa$export$79e893ac3b4e6564(pos.startLine + (newLines ? newLines.length - 1 : 0), endChar, pos.startLine + (newLines ? newLines?.length - 1 : 0), endChar, this.lineLengths, this.wordPositions);
            return ret;
        }
        return [];
    }
    /**
   * Apply a named style to the text within the given position or the
   * current selection. When `applyPos` is omitted the current caret
   * selection is used. The method returns `this` to allow chaining.
   *
   * @param styleName - The style identifier to apply.
   * @param applyPos - Optional position to apply the style to instead of
   *        using the current selection.
   * @returns The current `EditorV3Content` instance for chaining.
   */ applyStyle(styleName, applyPos) {
        /* istanbul ignore else */ if (applyPos || this._caretPosition && !this._caretPosition.isCollapsed) {
            const pos = applyPos ?? this._caretPosition?.pos;
            /* istanbul ignore else */ if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine) {
                for(let _i = pos.startLine; _i <= pos.endLine && _i < this.lines.length; _i++)this.lines[_i].applyStyle(styleName, _i === pos.startLine ? pos.startChar : 0, _i === pos.endLine ? pos.endChar : Infinity);
                this.caretPosition = {
                    startLine: pos.endLine,
                    startChar: pos.endChar,
                    endLine: pos.endLine,
                    endChar: pos.endChar
                };
            }
        }
        return this;
    }
    /**
   * Remove any applied style from the text within `removePos` or the
   * current selection. Returns `this` for chaining.
   *
   * @param removePos - Optional position to remove styles from. If omitted
   *        the current selection is used.
   * @returns The current `EditorV3Content` instance.
   */ removeStyle(removePos) {
        /* istanbul ignore else */ if (removePos || this._caretPosition && !this._caretPosition.isCollapsed) {
            const pos = removePos ?? this._caretPosition?.pos;
            /* istanbul ignore else */ if (pos.startLine < this.lines.length && pos.startLine <= pos.endLine) {
                for(let _i = pos.startLine; _i <= pos.endLine && _i < this.lines.length; _i++)this.lines[_i].removeStyle(_i === pos.startLine ? pos.startChar : 0, _i === pos.endLine ? pos.endChar : Infinity);
                this.caretPosition = {
                    startLine: pos.endLine,
                    startChar: pos.endChar,
                    endLine: pos.endLine,
                    endChar: pos.endChar
                };
            }
        }
        return this;
    }
    /**
   * Remove styles from the content that match the specified style names.
   *
   * @param styleNames - Array of style names to remove
   */ cleanStyles(styleNames) {
        this.lines.forEach((l)=>l.cleanStyles(styleNames));
    }
    /**
   * Delete text from the content that uses the specified styles.
   *
   * @param styleNames - Array of style names to delete
   */ deleteStyles(styleNames) {
        const lengthsBefore = this.lineLengths;
        this.lines.forEach((l)=>l.deleteStyles(styleNames));
        // Delete whole lines if they are now empty
        if (this.lines.length > 1) this.lines = this.lines.filter((l, ix)=>l.lineLength !== 0 || lengthsBefore[ix] === 0);
    }
    /**
   * Redraw the editor content into the provided editable element. This
   * will render the content as HTML (or markdown) and restore the caret
   * position if it is set.
   *
   * @param editableEl - The `HTMLDivElement` to render the editor content
   *        into.
   */ redraw(editableEl) {
        // Set active block
        /* istanbul ignore else */ if (this._caretPosition) this.lines[this._caretPosition.startLine].setActiveBlock(this._caretPosition);
        // Draw HTML
        editableEl.innerHTML = "";
        if (this._showMarkdown) this.toMarkdownHtml({
            editableEl: editableEl,
            markdownSettings: this._markdownSettings
        });
        else this.toHtml({
            editableEl: editableEl,
            atListFunction: this._atListFunction,
            maxAtListLength: this._maxAtListLength,
            caretPosition: this._caretPosition,
            styles: this._styles
        });
        // Set caret position
        /* istanbul ignore else */ if (this._caretPosition) $8b359e63c1cdd74d$var$$91b8bca718afa68e$export$97ab23b40042f8af(editableEl, this._caretPosition);
    }
    /**
   * Validate and enforce the editor's current status: update the active
   * block based on the caret and enforce locked-block selection rules.
   */ checkStatus() {
        // Set active block
        const activeBlock = this._caretPosition && this._caretPosition.endChar < this.lines[this._caretPosition.endLine].lineLength && this.lines[this._caretPosition.focusLine].setActiveBlock(this._caretPosition);
        // If active block is locked select all
        /* istanbul ignore else */ if (activeBlock && activeBlock.isLocked && this._caretPosition) this.caretPosition = {
            startLine: this._caretPosition.focusLine,
            startChar: activeBlock.lineStartPosition,
            endLine: this._caretPosition.focusLine,
            endChar: activeBlock.lineEndPosition
        };
    }
    /**
   * Handle keyboard down events for editor interactions including
   * selection, navigation, deletion and special key behaviours.
   *
   * @param e - The keyboard event from the editable element.
   */ handleKeydown(e) {
        // Select all
        /* istanbul ignore else */ if (e.ctrlKey && e.code === "KeyA" && this.text !== "") {
            e.stopPropagation();
            e.preventDefault();
            this.caretPosition = {
                startLine: 0,
                startChar: 0,
                endLine: this.lines.length - 1,
                endChar: this.lines[this.lines.length - 1].lineLength
            };
        } else if ([
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End",
            "Backspace",
            "Delete",
            "Escape"
        ].includes(e.key)) {
            e.stopPropagation();
            e.preventDefault();
            if (this._caretPosition === null) this.caretPosition = {
                startLine: 0,
                startChar: 0,
                endLine: 0,
                endChar: 0
            };
            switch(e.key){
                case "ArrowLeft":
                    this._caretPosition.moveLeft(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowRight":
                    this._caretPosition.moveRight(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowUp":
                    this._caretPosition.moveUp(e.shiftKey, e.ctrlKey);
                    break;
                case "ArrowDown":
                    this._caretPosition.moveDown(e.shiftKey, e.ctrlKey);
                    break;
                case "Home":
                    this._caretPosition.moveHome(e.shiftKey, e.ctrlKey);
                    break;
                case "End":
                    this._caretPosition.moveEnd(e.shiftKey, e.ctrlKey);
                    break;
                case "Backspace":
                    this.deleteCharacter(true);
                    break;
                case "Delete":
                    this.deleteCharacter(false);
                    break;
                case "Escape":
                    /* istanbul ignore else */ if (this._isLockable) {
                        const lockBlock = this.lines[this._caretPosition.startLine].setActiveBlock(this._caretPosition);
                        /* istanbul ignore else */ if (lockBlock && lockBlock.type === "at") {
                            lockBlock.setActive(false);
                            lockBlock.isLocked = true;
                        }
                    }
            }
        } else if (this._caretPosition && this.allowNewLine && e.key === "Enter") {
            e.stopPropagation();
            e.preventDefault();
            this.caretPosition = this.splitLine(this._caretPosition);
        } else if (this._caretPosition) {
            this._caretPosition.lastAction = "keydown";
            // Reset a locked block to no style if it is the active block
            const activeBlock = this.lines[this._caretPosition.startLine].getBlockAt(this._caretPosition.startChar);
            /* istanbul ignore else */ if (activeBlock && (this.lines[this._caretPosition.endLine].getBlockAt(this._caretPosition.endChar), activeBlock.isLocked && !this._caretPosition.isCollapsed)) activeBlock.style = undefined;
        }
    }
    /**
   * Handle keyboard up events. This updates the caret-derived position
   * cache and suppresses default behaviour for keys managed by the
   * editor.
   *
   * @param e - The keyboard event from the editable element.
   */ handleKeyup(e) {
        // Update caret position
        /* istanbul ignore else */ if (this._caretPosition) this.caretPositionF = $8b359e63c1cdd74d$var$$87c84f58544c8738$export$7d120213748299d3(e.currentTarget);
        // Suppress returns on movement keys
        /* istanbul ignore else */ if ([
            "Enter",
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Home",
            "End"
        ].includes(e.code) || e.ctrlKey && e.code === "KeyA") {
            e.stopPropagation();
            e.preventDefault();
        }
    }
    /**
   * Handle paste events into the editor. This supports pastes from the
   * editor's custom clipboard format (`data/aiev3`) as well as plain text
   * and inserts the resulting lines at the current caret position.
   *
   * @param e - The clipboard event generated by the paste action.
   */ handlePaste(e) {
        e.preventDefault();
        e.stopPropagation();
        // Check cursor is present, and is does not contain a locked block
        /* istanbul ignore else */ if (this._caretPosition && !this.isCaretLocked()) {
            // Get clipboard data
            const lines = [];
            const linesImport = e.clipboardData.getData("data/aiev3") !== "" ? JSON.parse(e.clipboardData.getData("data/aiev3")) : e.clipboardData.getData("text/plain").split("\n").map((t)=>({
                    textBlocks: [
                        {
                            text: t
                        }
                    ]
                }));
            // Just text blocks if only one line is allowed
            /* istanbul ignore else */ if (linesImport.length > 1 && !this.allowNewLine) {
                const textBlocks = linesImport.flatMap((l)=>l.textBlocks).map((tb)=>$8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d(tb));
                lines.push(new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(textBlocks, this.contentProps));
            } else lines.push(...linesImport.map((l)=>new $8b359e63c1cdd74d$export$f727c5bfed9e77d4(l, this.contentProps)));
            // Splice in new data and set new content
            this.splice(this._caretPosition, lines);
        }
    }
}
const $8b359e63c1cdd74d$var$$c6b2f5cf3d81c3c9$export$85877a110f55e05c = (obj)=>{
    return typeof obj === "object" && obj !== null && // Check properties exist
    "textBlocks" in obj && // Check properties types
    Array.isArray(obj.textBlocks) && obj.textBlocks.every((tb)=>"text" in tb);
};
const $8b359e63c1cdd74d$export$a2e4f3e0d013ef9f = (obj)=>{
    return typeof obj === "object" && obj !== null && // Check properties exist
    "lines" in obj && // Check properties types
    Array.isArray(obj.lines) && obj.lines.every((line)=>$8b359e63c1cdd74d$var$$c6b2f5cf3d81c3c9$export$85877a110f55e05c(line));
};
var $8b359e63c1cdd74d$var$$a69491ea5a126553$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "BaseCheckbox", ()=>$8b359e63c1cdd74d$export$2148d73965a312db);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "BaseEditorV3", ()=>$8b359e63c1cdd74d$export$64d7be461af4ab3e);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "BaseInput", ()=>$8b359e63c1cdd74d$export$e1f706e5673fef9e);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "BaseSelect", ()=>$8b359e63c1cdd74d$export$dcee1aa94a106d27);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "EditorV3", ()=>$8b359e63c1cdd74d$export$c410cc7dbb67874b);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "Expander", ()=>$8b359e63c1cdd74d$export$1cfea591e85f6e12);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "ItemInput", ()=>$8b359e63c1cdd74d$export$267c05bbab99602d);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "ObjectEditor", ()=>$8b359e63c1cdd74d$export$ec7da929f39d97c8);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$a69491ea5a126553$exports, "StylesEditor", ()=>$8b359e63c1cdd74d$export$bf67e8fa85c2bdc7);
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "baseButton", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ae1096218b504ef6, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ae1096218b504ef6 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "baseCheckbox", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ba9edc512d3c089d, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ba9edc512d3c089d = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "baseCheckboxLabel", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$da22a9df4fc77cee, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$da22a9df4fc77cee = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "baseInput", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a683444876b8f754, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a683444876b8f754 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "baseSelect", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a332407e56744979, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a332407e56744979 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "closed", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$15ff61f90f7efc74, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$15ff61f90f7efc74 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "closing", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$4e69df80cd44263b, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$4e69df80cd44263b = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "disabled", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$683472f6198a076e, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$683472f6198a076e = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "editorHolder", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$6c8af10980e1f329, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$6c8af10980e1f329 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "errorText", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f1a76e4a6085c675, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f1a76e4a6085c675 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "expander", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f194ed9df726ec47, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f194ed9df726ec47 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "expanderContent", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ea222bb8b20e6221, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ea222bb8b20e6221 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "holder", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f57c6e831b0d072a, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f57c6e831b0d072a = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "label", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$1237798dc640739a, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$1237798dc640739a = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "open", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$3ce6949f20cea765, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$3ce6949f20cea765 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "opening", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$47fa9d71658d4a69, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$47fa9d71658d4a69 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports, "placing", ()=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$fe2e9688f7413ae2, (v)=>$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$fe2e9688f7413ae2 = v);
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ae1096218b504ef6;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ba9edc512d3c089d;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$da22a9df4fc77cee;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a683444876b8f754;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a332407e56744979;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$15ff61f90f7efc74;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$4e69df80cd44263b;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$683472f6198a076e;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$6c8af10980e1f329;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f1a76e4a6085c675;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f194ed9df726ec47;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ea222bb8b20e6221;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f57c6e831b0d072a;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$1237798dc640739a;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$3ce6949f20cea765;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$47fa9d71658d4a69;
var $8b359e63c1cdd74d$var$$d1df120914c5e45a$export$fe2e9688f7413ae2;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ae1096218b504ef6 = `_5aJ9Rq_baseButton`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ba9edc512d3c089d = `_5aJ9Rq_baseCheckbox`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$da22a9df4fc77cee = `_5aJ9Rq_baseCheckboxLabel`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a683444876b8f754 = `_5aJ9Rq_baseInput`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$a332407e56744979 = `_5aJ9Rq_baseSelect`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$15ff61f90f7efc74 = `_5aJ9Rq_closed`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$4e69df80cd44263b = `_5aJ9Rq_closing`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$683472f6198a076e = `_5aJ9Rq_disabled`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$6c8af10980e1f329 = `_5aJ9Rq_editorHolder`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f1a76e4a6085c675 = `_5aJ9Rq_errorText`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f194ed9df726ec47 = `_5aJ9Rq_expander`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$ea222bb8b20e6221 = `_5aJ9Rq_expanderContent`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$f57c6e831b0d072a = `_5aJ9Rq_holder`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$1237798dc640739a = `_5aJ9Rq_label`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$3ce6949f20cea765 = `_5aJ9Rq_open`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$47fa9d71658d4a69 = `_5aJ9Rq_opening`;
$8b359e63c1cdd74d$var$$d1df120914c5e45a$export$fe2e9688f7413ae2 = `_5aJ9Rq_placing`;
/**
 * Utility function to remove undefined and function properties from an object.
 *
 * @param obj - The object to clean.
 * @returns A new object with undefined and function properties removed.
 */ const $8b359e63c1cdd74d$export$969b205aa1357eaa = (obj)=>{
    if (Array.isArray(obj)) return obj.map($8b359e63c1cdd74d$export$969b205aa1357eaa);
    else if (obj && typeof obj === "object") return Object.fromEntries(Object.entries(obj).filter(([_, value])=>value !== undefined && typeof value !== "function").map(([key, value])=>[
            key,
            $8b359e63c1cdd74d$export$969b205aa1357eaa(value)
        ]));
    return obj;
};
const $8b359e63c1cdd74d$export$501d19eb8a679b38 = (oldValue, newValue)=>(0, $eBlbF.isEqual)($8b359e63c1cdd74d$export$969b205aa1357eaa(oldValue), $8b359e63c1cdd74d$export$969b205aa1357eaa(newValue));
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$c7afb07461c8486f = "SET_VALUE";
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$f989f01be2123b61 = "UPDATE_INDEX";
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a = "RESET_FLAGS";
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$432e34d6a5e9350a = "SYNC_FROM_PARENT";
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$4e684cecef6a0c5f = "FORCE_WITH_VALUE";
const $8b359e63c1cdd74d$var$$98996439382bbb96$export$48e583575aa70c22 = "CLEAR_ON_CHANGE_PAYLOAD";
function $8b359e63c1cdd74d$var$$cd8df934cc145ba4$export$6012a5cc1fdeb5ea(state, action) {
    switch(action.operation){
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$c7afb07461c8486f:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                const comparisonChanged = action.payload.addToStack;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: true,
                    comparisonChanged: comparisonChanged,
                    onChangePayload: {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    }
                };
            }
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$f989f01be2123b61:
            return {
                ...state,
                index: action.payload.index,
                changed: true,
                comparisonChanged: true,
                onChangePayload: {
                    value: state.stack[action.payload.index],
                    index: action.payload.index,
                    stack: state.stack
                }
            };
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a:
            return {
                ...state,
                changed: false,
                comparisonChanged: false
            };
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$432e34d6a5e9350a:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: false,
                    comparisonChanged: false,
                    onChangePayload: action.payload.triggerOnChange ? {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    } : null
                };
            }
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$4e684cecef6a0c5f:
            {
                let newStack = [
                    ...state.stack
                ];
                let newIndex = state.index;
                if (action.payload.addToStack) {
                    // Add to stack - comparison detected a change
                    newIndex = state.index + 1;
                    newStack = [
                        ...state.stack.slice(0, newIndex),
                        action.payload.newValue
                    ];
                } else newStack[state.index] = action.payload.newValue;
                return {
                    stack: newStack,
                    index: newIndex,
                    changed: false,
                    comparisonChanged: false,
                    onChangePayload: action.payload.triggerOnChange ? {
                        value: newStack[newIndex],
                        index: newIndex,
                        stack: newStack
                    } : null
                };
            }
        case $8b359e63c1cdd74d$var$$98996439382bbb96$export$48e583575aa70c22:
            return {
                ...state,
                onChangePayload: null
            };
    }
}
const $8b359e63c1cdd74d$export$426a3338f36cbf0a = ({ value: value, setValue: setValue, debounceMilliseconds: debounceMilliseconds = 500, onChange: onChange = ()=>{}, comparisonFunction: comparisonFunction = (0, $eBlbF.isEqual), blockReturnFunction: blockReturnFunction, blockOnChange: blockOnChange })=>{
    const [state, dispatch] = (0, $spJKX.useReducer)($8b359e63c1cdd74d$var$$cd8df934cc145ba4$export$6012a5cc1fdeb5ea, {
        stack: [
            value
        ],
        index: 0,
        changed: false,
        comparisonChanged: false,
        onChangePayload: null
    });
    const debounceTimer = (0, $spJKX.useRef)(null);
    /**
   * Set the current value in the stack, updating the stack and index if necessary
   * @param newValue The new value to set as current
   * @returns void
   */ const setCurrentValue = (0, $spJKX.useCallback)((newValue)=>{
        // There will always be an update if the value is different
        if (!$8b359e63c1cdd74d$export$501d19eb8a679b38(newValue, state.stack[state.index])) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], newValue);
            // Dispatch the update (onChange will be triggered by useEffect)
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$c7afb07461c8486f,
                payload: {
                    newValue: newValue,
                    addToStack: addToStack
                }
            });
        }
    }, [
        state.index,
        state.stack,
        comparisonFunction
    ]);
    /**
   * Undo the last change by moving back in the stack
   * @param steps Number of steps to go back, defaults to 1
   * @returns void
   */ const undo = (0, $spJKX.useCallback)((steps = 1)=>{
        const newIndex = Math.max(0, state.index - steps);
        dispatch({
            operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$f989f01be2123b61,
            payload: {
                index: newIndex
            }
        });
    }, [
        state.index
    ]);
    /**
   * Redo the last undone change by moving forward in the stack
   * @param steps Number of steps to go forward, defaults to 1
   * @returns void
   */ const redo = (0, $spJKX.useCallback)((steps = 1)=>{
        const newIndex = Math.min(state.stack.length - 1, state.index + steps);
        dispatch({
            operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$f989f01be2123b61,
            payload: {
                index: newIndex
            }
        });
    }, [
        state.index,
        state.stack
    ]);
    /**
   * Force an update to the current value, bypassing debounce
   * @param newValue Optional new value to set, if provided it will update the stack
   * @returns void
   */ const forceUpdate = (0, $spJKX.useCallback)((newValue)=>{
        // Check for a timer and clear it
        const waitingTimer = debounceTimer.current !== null;
        if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // Determine the value to pass to setValue
        let valueToSet = state.stack[state.index];
        // Check if new value is provided and update the stack accordingly
        /* istanbul ignore else */ if (newValue !== undefined && !$8b359e63c1cdd74d$export$501d19eb8a679b38(newValue, state.stack[state.index])) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], newValue);
            // Determine if onChange should be triggered
            const triggerOnChange = addToStack || waitingTimer || debounceMilliseconds === -1;
            // Dispatch the update (all stack manipulation happens in reducer)
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$4e684cecef6a0c5f,
                payload: {
                    newValue: newValue,
                    addToStack: addToStack,
                    triggerOnChange: triggerOnChange
                }
            });
            // Use the new value for setValue
            valueToSet = newValue;
        }
        // Push update to parent for the current value
        setValue(valueToSet);
        if (newValue === undefined) dispatch({
            operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a
        });
    }, [
        debounceMilliseconds,
        state.index,
        state.stack,
        setValue,
        comparisonFunction
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (state.onChangePayload) {
            onChange(state.onChangePayload.value, state.onChangePayload.index, state.onChangePayload.stack);
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$48e583575aa70c22
            });
        }
    }, [
        state.onChangePayload,
        onChange
    ]);
    (0, $spJKX.useEffect)(()=>{
        const thisCurrentValue = state.stack[state.index];
        // If no change via setCurrentValue, must be a top down change
        if (!state.changed && !$8b359e63c1cdd74d$export$501d19eb8a679b38(value, thisCurrentValue)) {
            // Determine if comparison fails (values are different)
            const addToStack = !comparisonFunction(state.stack[state.index], value);
            // Clear timer
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            // Determine if onChange should be triggered
            const triggerOnChange = !blockOnChange?.(thisCurrentValue, value);
            // Dispatch the update
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$432e34d6a5e9350a,
                payload: {
                    newValue: value,
                    addToStack: addToStack,
                    triggerOnChange: triggerOnChange
                }
            });
        } else if (state.changed && $8b359e63c1cdd74d$export$501d19eb8a679b38(value, thisCurrentValue)) {
            /* istanbul ignore else */ if (debounceTimer.current) clearTimeout(debounceTimer.current);
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a
            });
        } else if (debounceMilliseconds !== null && debounceMilliseconds >= 0 && state.comparisonChanged) {
            if (debounceTimer.current) clearTimeout(debounceTimer.current);
            if (!blockReturnFunction?.(thisCurrentValue)) debounceTimer.current = setTimeout(()=>{
                setValue(thisCurrentValue);
                dispatch({
                    operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a
                });
            }, debounceMilliseconds);
        // Do not add a return function to clear the timer here,
        // as it would clear the timer on every render, which is not desired.
        // The time will be cleared in the other scenario handlers or should be allowed to run
        // return () => {
        //   if (debounceTimer.current) clearTimeout(debounceTimer.current);
        // };
        } else if (debounceMilliseconds === null && state.comparisonChanged && !blockReturnFunction?.(thisCurrentValue)) {
            setValue(thisCurrentValue);
            dispatch({
                operation: $8b359e63c1cdd74d$var$$98996439382bbb96$export$3fc97931b5a4e60a
            });
        }
    }, [
        blockOnChange,
        blockReturnFunction,
        state.changed,
        state.comparisonChanged,
        state.index,
        state.stack,
        debounceMilliseconds,
        setValue,
        comparisonFunction,
        value
    ]);
    return {
        currentValue: state.stack[state.index],
        setCurrentValue: setCurrentValue,
        forceUpdate: forceUpdate,
        undo: undo,
        redo: redo,
        stack: state.stack,
        index: state.index
    };
};
/**
 * Clears the timeout held in the given ref, if there is one.
 *
 * @param ref - The ref holding the timer handle.
 */ const $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer = (ref)=>{
    if (ref.current !== null) {
        clearTimeout(ref.current);
        ref.current = null;
    }
};
const $8b359e63c1cdd74d$export$f13a708d2a7a10f9 = ({ input: input, onRelease: onRelease, pending: pending, timeoutMilliseconds: timeoutMilliseconds = 5000, windowMilliseconds: windowMilliseconds = 500 })=>{
    const [isWaiting, setIsWaiting] = (0, $spJKX.useState)(false);
    const armedRef = (0, $spJKX.useRef)(false);
    const windowTimerRef = (0, $spJKX.useRef)(null);
    const timeoutTimerRef = (0, $spJKX.useRef)(null);
    const releaseTimerRef = (0, $spJKX.useRef)(null);
    const deferredEventRef = (0, $spJKX.useRef)(null);
    const previousInputRef = (0, $spJKX.useRef)(input);
    const onReleaseRef = (0, $spJKX.useRef)(onRelease);
    (0, $spJKX.useEffect)(()=>{
        onReleaseRef.current = onRelease;
    }, [
        onRelease
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!pending) {
            armedRef.current = false;
            return undefined;
        }
        armedRef.current = true;
        windowTimerRef.current = setTimeout(()=>{
            windowTimerRef.current = null;
            armedRef.current = false;
        }, windowMilliseconds);
        return ()=>$8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(windowTimerRef);
    }, [
        pending,
        windowMilliseconds
    ]);
    const release = (0, $spJKX.useCallback)(()=>{
        $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
        $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        setIsWaiting(false);
        const deferredEvent = deferredEventRef.current;
        deferredEventRef.current = null;
        /* istanbul ignore else */ if (deferredEvent) onReleaseRef.current(deferredEvent);
    }, []);
    const captureFocus = (0, $spJKX.useCallback)((e)=>{
        if (!pending || !armedRef.current) return false;
        deferredEventRef.current = e;
        setIsWaiting(true);
        return true;
    }, [
        pending
    ]);
    const cancelWaiting = (0, $spJKX.useCallback)(()=>{
        $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
        $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        deferredEventRef.current = null;
        setIsWaiting(false);
    }, []);
    (0, $spJKX.useEffect)(()=>{
        const inputChanged = !$8b359e63c1cdd74d$export$501d19eb8a679b38(previousInputRef.current, input);
        previousInputRef.current = input;
        if (isWaiting && (!pending || inputChanged)) {
            $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
            // Let the redraw triggered by the incoming value land before the focus event is replayed
            releaseTimerRef.current = setTimeout(()=>{
                releaseTimerRef.current = null;
                release();
            }, 0);
        }
    }, [
        input,
        isWaiting,
        pending,
        release
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!isWaiting) return undefined;
        timeoutTimerRef.current = setTimeout(()=>{
            timeoutTimerRef.current = null;
            release();
        }, timeoutMilliseconds);
        return ()=>$8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
    }, [
        isWaiting,
        release,
        timeoutMilliseconds
    ]);
    (0, $spJKX.useEffect)(()=>()=>{
            $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(windowTimerRef);
            $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(timeoutTimerRef);
            $8b359e63c1cdd74d$var$$b7809bfc339cd256$var$clearTimer(releaseTimerRef);
        }, []);
    return {
        isWaiting: isWaiting,
        captureFocus: captureFocus,
        cancelWaiting: cancelWaiting
    };
};
const $8b359e63c1cdd74d$export$9046ef79d808c3d9 = (value)=>{
    return value.lines.map((line)=>({
            lines: [
                (0, $eBlbF.cloneDeep)(line)
            ],
            contentProps: value.contentProps
        }));
};
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$7d6abe52e266964b = "ADD_LINE";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7 = "REMOVE_LINE";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$128e89fa5a52e2d5 = "UPDATE_LINE";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$27c9658dd64ba792 = "ADD_BLOCK";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$f227699a52faa480 = "REMOVE_BLOCK";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$62e6b7d114efe4d4 = "UPDATE_BLOCK";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3923dd9698ac182b = "UPDATE_BLOCK_TYPE";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$fb62af2ed61328b8 = "UPDATE_BLOCK_STYLE";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3f6c2651d04c707 = "UPDATE_BLOCK_LABEL";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea = "UPDATE_BLOCK_TEXT";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$d4d1727b5880aab3 = "UPDATE_BLOCK_OPTIONS";
const $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$91eaa669ef26a074 = (lines, action)=>{
    const newLines = (0, $eBlbF.cloneDeep)(lines);
    switch(action.operation){
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$7d6abe52e266964b:
            {
                const newLine = action.line ?? new $8b359e63c1cdd74d$export$f727c5bfed9e77d4();
                /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex <= newLines.length) newLines.splice(action.lineIndex, 0, newLine);
                break;
            }
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length) newLines.splice(action.lineIndex, 1);
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$128e89fa5a52e2d5:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.line) newLines[action.lineIndex] = action.line;
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$27c9658dd64ba792:
            {
                const newBlock = action.block ?? new $8b359e63c1cdd74d$export$4ed6c3ca0061f49b();
                /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex <= newLines[action.lineIndex].textBlocks.length) newLines[action.lineIndex].textBlocks.splice(action.blockIndex, 0, newBlock);
                break;
            }
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$f227699a52faa480:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length) newLines[action.lineIndex].textBlocks.splice(action.blockIndex, 1);
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$62e6b7d114efe4d4:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.block) newLines[action.lineIndex].textBlocks[action.blockIndex] = action.block;
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3923dd9698ac182b:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockType !== newLines[action.lineIndex].textBlocks[action.blockIndex].type) {
                const currentBlock = {
                    ...newLines[action.lineIndex].textBlocks[action.blockIndex]
                };
                const newBlock = $8b359e63c1cdd74d$var$$3a09c4cc1db54b5c$export$10deec0673b203d({
                    ...currentBlock,
                    type: action.blockType,
                    isLocked: action.blockType === "at" || action.blockType === "select" ? true : undefined
                });
                newLines[action.lineIndex].textBlocks[action.blockIndex] = newBlock;
            }
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$fb62af2ed61328b8:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockStyle !== newLines[action.lineIndex].textBlocks[action.blockIndex].style) newLines[action.lineIndex].textBlocks[action.blockIndex].style = action.blockStyle === "" ? undefined : action.blockStyle;
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3f6c2651d04c707:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockLabel !== newLines[action.lineIndex].textBlocks[action.blockIndex].label) newLines[action.lineIndex].textBlocks[action.blockIndex].label = action.blockLabel === "" ? undefined : action.blockLabel;
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && action.blockText !== newLines[action.lineIndex].textBlocks[action.blockIndex].text) newLines[action.lineIndex].textBlocks[action.blockIndex].text = action.blockText ?? // istanbul ignore next
            "";
            break;
        case $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$d4d1727b5880aab3:
            /* istanbul ignore else */ if (action.lineIndex !== undefined && action.lineIndex >= 0 && action.lineIndex < newLines.length && action.blockIndex !== undefined && action.blockIndex >= 0 && action.blockIndex < newLines[action.lineIndex].textBlocks.length && newLines[action.lineIndex].textBlocks[action.blockIndex].type === "select" && action.blockOptions) {
                const newBlockOptions = $8b359e63c1cdd74d$export$9046ef79d808c3d9(action.blockOptions).map((l)=>{
                    const ret = {
                        text: l.lines[0].textBlocks[0].text,
                        data: {}
                    };
                    if (l.lines[0].textBlocks[0].style) ret.data.style = l.lines[0].textBlocks[0].style;
                    return ret;
                });
                newLines[action.lineIndex].textBlocks[action.blockIndex].availableOptions = newBlockOptions;
            }
            break;
    }
    return newLines;
};
var $8b359e63c1cdd74d$var$$ede054dcbe564586$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "addDiv", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$6758c6c7563dc60e, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$6758c6c7563dc60e = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "addIcon", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$3488242433cbedb, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$3488242433cbedb = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "redoBtn", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$56506a0c7710b298, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$56506a0c7710b298 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "relativeDiv", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$77612d80d648ab13, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$77612d80d648ab13 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "removeIcon", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$b62b2eefc26b7697, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$b62b2eefc26b7697 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "removeLineIcon", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$999deec9ef14a402, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$999deec9ef14a402 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ede054dcbe564586$exports, "undoBtn", ()=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$f4cd59694124b9f, (v)=>$8b359e63c1cdd74d$var$$ede054dcbe564586$export$f4cd59694124b9f = v);
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$6758c6c7563dc60e;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$3488242433cbedb;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$56506a0c7710b298;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$77612d80d648ab13;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$b62b2eefc26b7697;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$999deec9ef14a402;
var $8b359e63c1cdd74d$var$$ede054dcbe564586$export$f4cd59694124b9f;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$6758c6c7563dc60e = `hDWuzq_addDiv`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$3488242433cbedb = `hDWuzq_addIcon`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$56506a0c7710b298 = `hDWuzq_redoBtn`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$77612d80d648ab13 = `hDWuzq_relativeDiv`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$b62b2eefc26b7697 = `hDWuzq_removeIcon`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$999deec9ef14a402 = `hDWuzq_removeLineIcon`;
$8b359e63c1cdd74d$var$$ede054dcbe564586$export$f4cd59694124b9f = `hDWuzq_undoBtn`;
const $8b359e63c1cdd74d$var$$e775624493c4cd98$export$5bcea036881b4cf4 = ({ index: index })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    /**
   * Handle click event to add line.
   */ const onClick = ()=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$7d6abe52e266964b,
            lineIndex: index
        });
    };
    return (0, $bR5nk.jsx)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).addDiv,
        onClick: onClick,
        children: (0, $bR5nk.jsx)("svg", {
            className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).addIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Add line",
            children: (0, $bR5nk.jsx)("path", {
                fill: "currentColor",
                d: "M26 30h-2V20H12v10h-2V20a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2zM5.17 16L2 19.17l1.411 1.419L8 16l-4.58-4.58L2 12.83zM24 14H12a2 2 0 0 1-2-2V2h2v10h12V2h2v10a2 2 0 0 1-2 2"
            })
        })
    });
};
$8b359e63c1cdd74d$var$$e775624493c4cd98$export$5bcea036881b4cf4.displayName = "AddLine";
const $8b359e63c1cdd74d$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa = ({ onClick: onClick, fill: fill })=>(0, $bR5nk.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        viewBox: "0 0 24 24",
        width: "16",
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).redoBtn,
        fill: fill,
        onClick: ()=>onClick(),
        "aria-label": "Redo",
        children: [
            (0, $bR5nk.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $bR5nk.jsx)("path", {
                d: "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
            })
        ]
    });
$8b359e63c1cdd74d$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa.displayName = "RedoBtn";
const $8b359e63c1cdd74d$var$$63b04b789bb9c5d5$export$1085475ec51f1baf = ({ index: index })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    /**
   * Handle click event to remove line.
   */ const onClick = ()=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$31431e5ed4c8ceb7,
            lineIndex: index
        });
    };
    return (0, $bR5nk.jsx)("span", {
        onClick: onClick,
        children: (0, $bR5nk.jsxs)("svg", {
            className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).removeLineIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Remove line",
            children: [
                (0, $bR5nk.jsx)("path", {
                    fill: "currentColor",
                    d: "M29 26H12a1 1 0 0 1-.707-.293l-9-9a1 1 0 0 1 0-1.414l9-9A1 1 0 0 1 12 6h17a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1m-16.586-2H28V8H12.414l-8 8z"
                }),
                (0, $bR5nk.jsx)("path", {
                    fill: "currentColor",
                    d: "M20.414 16L25 11.414L23.586 10L19 14.586L14.414 10L13 11.414L17.586 16L13 20.586L14.414 22L19 17.414L23.586 22L25 20.586z"
                })
            ]
        })
    });
};
$8b359e63c1cdd74d$var$$63b04b789bb9c5d5$export$1085475ec51f1baf.displayName = "RemoveLine";
const $8b359e63c1cdd74d$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea = ({ onClick: onClick, fill: fill })=>(0, $bR5nk.jsxs)("svg", {
        fill: fill,
        onClick: ()=>onClick(),
        xmlns: "http://www.w3.org/2000/svg",
        height: "16",
        viewBox: "0 0 24 24",
        width: "16",
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).undoBtn,
        "aria-label": "Undo",
        children: [
            (0, $bR5nk.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $bR5nk.jsx)("path", {
                d: "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
            })
        ]
    });
$8b359e63c1cdd74d$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea.displayName = "UndoBtn";
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "height", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$ac607276a8fe9f0a, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$ac607276a8fe9f0a = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "noHeight", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$18d78b54c5658614, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$18d78b54c5658614 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "windowViewBlock", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$81010ebbeae2a09, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$81010ebbeae2a09 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "windowViewBody", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$15388d7be80e2abc, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$15388d7be80e2abc = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "windowViewLine", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$cd545671e9c668a3, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$cd545671e9c668a3 = v);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports, "windowViewLineTitle", ()=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$84df755deca3a30d, (v)=>$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$84df755deca3a30d = v);
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$ac607276a8fe9f0a;
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$18d78b54c5658614;
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$81010ebbeae2a09;
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$15388d7be80e2abc;
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$cd545671e9c668a3;
var $8b359e63c1cdd74d$var$$8a8ca0442c015654$export$84df755deca3a30d;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$ac607276a8fe9f0a = `AR1p1G_height`;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$18d78b54c5658614 = `AR1p1G_noHeight`;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$81010ebbeae2a09 = `AR1p1G_windowViewBlock`;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$15388d7be80e2abc = `AR1p1G_windowViewBody`;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$cd545671e9c668a3 = `AR1p1G_windowViewLine`;
$8b359e63c1cdd74d$var$$8a8ca0442c015654$export$84df755deca3a30d = `AR1p1G_windowViewLineTitle`;
const $8b359e63c1cdd74d$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f = ({ onClick: onClick })=>(0, $bR5nk.jsx)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).addDiv,
        onClick: onClick,
        children: (0, $bR5nk.jsx)("svg", {
            className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).addIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            "aria-label": "Add text block",
            children: (0, $bR5nk.jsx)("path", {
                fill: "currentColor",
                d: "M28 12H10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M10 4v6h18V4zm18 26H10a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2m-18-8v6h18v-6zm-1-6l-5.586-5.586L2 11.828L6.172 16L2 20.172l1.414 1.414z"
            })
        })
    });
$8b359e63c1cdd74d$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f.displayName = "AddBlock";
const $8b359e63c1cdd74d$var$$034e76b6a38d6263$export$59fc62fa579fbc85 = ({ onClick: onClick })=>(0, $bR5nk.jsx)("span", {
        onClick: onClick,
        children: (0, $bR5nk.jsxs)("svg", {
            className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).removeIcon,
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em",
            viewBox: "0 0 32 32",
            fill: "red",
            "aria-label": "Remove text block",
            children: [
                (0, $bR5nk.jsx)("path", {
                    fill: "currentColor",
                    d: "M24 30H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2M4 22h-.002L4 28h20v-6zM30 3.41L28.59 2L25 5.59L21.41 2L20 3.41L23.59 7L20 10.59L21.41 12L25 8.41L28.59 12L30 10.59L26.41 7z"
                }),
                (0, $bR5nk.jsx)("path", {
                    fill: "currentColor",
                    d: "M4 14V8h14V6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h22v-2Z"
                })
            ]
        })
    });
$8b359e63c1cdd74d$var$$034e76b6a38d6263$export$59fc62fa579fbc85.displayName = "RemoveBlock";
const $8b359e63c1cdd74d$export$dcee1aa94a106d27 = ({ id: id, value: value, availableOptions: availableOptions, change: change, label: label, ...rest })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [thisValueString, setThisValueString] = (0, $spJKX.useState)(`${value}`);
    (0, $spJKX.useEffect)(()=>{
        const ix = availableOptions.findIndex((o)=>o.value === value);
        startTransition(()=>setThisValueString(`${ix !== -1 ? `${ix}-` : ""}${value}`));
    }, [
        availableOptions,
        value
    ]);
    const availableOptionsStrings = availableOptions.map((item, ix)=>({
            label: item.label,
            value: `${ix}-${item.value?.toString() ?? "undefined"}`,
            disabled: item.disabled
        }));
    /**
   * Handle selection changes, update internal string representation and
   * propagate the selected option value via the `change` callback.
   *
   * @param e - The change event from the select element.
   */ const handleChange = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const newValueIx = availableOptionsStrings.findIndex((item)=>item.value === e.target.value);
        setThisValueString(e.target.value);
        /* istanbul ignore else */ if (newValueIx !== -1) change(availableOptions[newValueIx].value);
    };
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder,
        children: [
            label !== undefined && (0, $bR5nk.jsx)("label", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).label,
                id: `${id}-label`,
                htmlFor: id,
                children: label
            }),
            (0, $bR5nk.jsxs)("select", {
                ...rest,
                id: id,
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).baseSelect,
                value: thisValueString,
                onChange: handleChange,
                children: [
                    availableOptions.findIndex((o)=>o.value === value) === -1 && (0, $bR5nk.jsx)("option", {
                        value: thisValueString,
                        disabled: true,
                        children: thisValueString
                    }),
                    availableOptionsStrings.map((o, ix)=>(0, $bR5nk.jsx)("option", {
                            value: o.value,
                            disabled: o.disabled,
                            children: o.label
                        }, `${ix}-${o.value}`))
                ]
            })
        ]
    });
};
$8b359e63c1cdd74d$export$dcee1aa94a106d27.displayName = "BaseSelect";
const $8b359e63c1cdd74d$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectStyleId = (0, $spJKX.useId)();
    const availableOptions = (0, $spJKX.useMemo)(()=>{
        const ret = [
            {
                label: "None",
                value: undefined
            }
        ];
        /* istanbul ignore else */ if (wvc && wvc.contentProps.styles) ret.push(...Object.keys(wvc.contentProps.styles).map((sn)=>({
                label: sn,
                value: sn,
                disabled: wvc.contentProps.styles[sn].isNotAvailable
            })));
        return ret;
    }, [
        wvc
    ]);
    return !wvc || !thisBlock ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$dcee1aa94a106d27, {
        id: selectStyleId,
        label: "Style",
        value: thisBlock.style,
        availableOptions: availableOptions,
        disabled: !wvc.editable,
        change: (ret)=>{
            wvc.dispatch({
                operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$fb62af2ed61328b8,
                lineIndex: lineIndex,
                blockIndex: blockIndex,
                blockStyle: ret
            });
        }
    });
};
$8b359e63c1cdd74d$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d.displayName = "WindowViewBlockStyle";
const $8b359e63c1cdd74d$export$e1f706e5673fef9e = ({ id: id, value: value, onNewValue: onNewValue, label: label, ...rest })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [inputValue, setInputValue] = (0, $spJKX.useState)(value?.toString() ?? "");
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>setInputValue(value?.toString() ?? ""));
    }, [
        value
    ]);
    /**
   * Update the local input state when the user types. The updated value
   * will be propagated to the parent on blur via `onNewValue`.
   *
   * @param e - The change event from the input element.
   */ const handleInputChange = (e)=>{
        setInputValue(e.target.value);
    };
    const handleInputBlur = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else */ if (onNewValue) {
            const newValue = typeof value === "number" ? parseFloat(inputValue) : inputValue;
            onNewValue(newValue);
        }
    }, [
        onNewValue,
        inputValue,
        value
    ]);
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder,
        children: [
            label !== undefined && (0, $bR5nk.jsx)("label", {
                id: `${id}-label`,
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).label,
                htmlFor: id,
                children: label
            }),
            (0, $bR5nk.jsx)("input", {
                ...rest,
                type: typeof value === "number" ? "number" : "text",
                id: id,
                className: [
                    /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).baseInput,
                    rest.className
                ].filter((c)=>c).join(" "),
                value: inputValue,
                onChange: handleInputChange,
                onBlur: handleInputBlur
            })
        ]
    });
};
$8b359e63c1cdd74d$export$e1f706e5673fef9e.displayName = "BaseInput";
const $8b359e63c1cdd74d$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422 = ({ lineIndex: lineIndex, blockIndex: blockIndex, label: label = false })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const thisId = (0, $spJKX.useId)();
    return !wvc || !thisBlock ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$e1f706e5673fef9e, {
        id: thisId,
        label: label ? "Label" : "Text",
        value: label ? thisBlock.label : thisBlock.text,
        disabled: !wvc.editable,
        onNewValue: (ret)=>{
            /* istanbul ignore else */ if (wvc && typeof ret === "string") {
                /* istanbul ignore else */ if (label) wvc.dispatch({
                    operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3f6c2651d04c707,
                    lineIndex: lineIndex,
                    blockIndex: blockIndex,
                    blockLabel: ret
                });
                else wvc.dispatch({
                    operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$ce4d39216b82c0ea,
                    lineIndex: lineIndex,
                    blockIndex: blockIndex,
                    blockText: ret
                });
            }
        }
    });
};
$8b359e63c1cdd74d$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422.displayName = "WindowViewBlockText";
const $8b359e63c1cdd74d$var$$bf15b2638bfe15a8$export$290931a7697344ba = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectTypeId = (0, $spJKX.useId)();
    const availableOptions = (0, $spJKX.useMemo)(()=>{
        const ret = [];
        /* istanbul ignore else */ if (wvc) {
            ret.push(...[
                {
                    label: "Text",
                    value: "text"
                },
                {
                    label: "Select",
                    value: "select"
                }
            ]);
            if (wvc.includeAt) ret.push({
                label: "At",
                value: "at",
                disabled: true
            });
        }
        return ret;
    }, [
        wvc
    ]);
    return !wvc || !thisBlock ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$dcee1aa94a106d27, {
        id: selectTypeId,
        label: "Type",
        value: thisBlock.type,
        availableOptions: availableOptions,
        disabled: !wvc.editable,
        change: (ret)=>{
            wvc.dispatch({
                operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$3923dd9698ac182b,
                lineIndex: lineIndex,
                blockIndex: blockIndex,
                blockType: ret
            });
        }
    });
};
$8b359e63c1cdd74d$var$$bf15b2638bfe15a8$export$290931a7697344ba.displayName = "WindowViewBlockType";
const $8b359e63c1cdd74d$export$6be11f3b04f364b4 = (lines)=>{
    const retLines = lines.flatMap((l)=>l.lines);
    const retContent = lines.map((l)=>l.contentProps).reduce((p, c)=>p ?? c, undefined);
    return {
        lines: retLines,
        contentProps: retContent
    };
};
const $8b359e63c1cdd74d$var$$fbcab087cdb8341f$export$44b5c9777d5218fc = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    const selectOptionsId = (0, $spJKX.useId)();
    // Holder for available options
    const input = (0, $spJKX.useMemo)(()=>{
        if (thisBlock && thisBlock.type === "select") {
            const availableOptions = thisBlock.availableOptions;
            return $8b359e63c1cdd74d$export$6be11f3b04f364b4(availableOptions.map((o)=>({
                    lines: [
                        {
                            textBlocks: [
                                {
                                    text: o.text,
                                    style: o.data?.style
                                }
                            ]
                        }
                    ]
                })));
        } else return new $8b359e63c1cdd74d$export$1a4903393d6b1b7d().data;
    }, [
        thisBlock
    ]);
    const [validationText, setValidationText] = (0, $spJKX.useState)([]);
    const setObject = (0, $spJKX.useCallback)((value)=>{
        const validationText = [];
        if (value.lines.some((l)=>l.textBlocks.length > 1)) validationText.push("Each line must have only one style");
        if (value.lines.some((l)=>l.textBlocks.map((tb)=>tb.text.trim()).join("") === "")) validationText.push("Each line must have at least one character");
        setValidationText(validationText);
        if (validationText.length === 0) wvc?.dispatch({
            operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$d4d1727b5880aab3,
            lineIndex: lineIndex,
            blockIndex: blockIndex,
            blockOptions: value
        });
    }, [
        blockIndex,
        lineIndex,
        wvc
    ]);
    return !wvc || !thisLine || !thisBlock ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsx)("div", {
        className: [
            /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).windowViewBlock,
            thisBlock.type !== "select" ? /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).noHeight : /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).height
        ].join(" "),
        children: thisBlock.type !== "select" ? null : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$64d7be461af4ab3e, {
            id: `available-${selectOptionsId}`,
            style: {
                width: "100%",
                minHeight: "80px"
            },
            label: "Available options",
            errorText: validationText.join("\n"),
            allowNewLine: true,
            editable: wvc.editable,
            customStyleMap: wvc.contentProps.styles,
            input: input,
            setObject: setObject,
            debounceMilliseconds: -1,
            resize: "vertical"
        })
    });
};
$8b359e63c1cdd74d$var$$fbcab087cdb8341f$export$44b5c9777d5218fc.displayName = "WindowViewBlockOptions";
const $8b359e63c1cdd74d$var$$f1c5b02e089086d0$export$89d87d4877cd77dc = ({ lineIndex: lineIndex, blockIndex: blockIndex })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const thisBlock = thisLine?.textBlocks[blockIndex];
    return !wvc || !thisBlock ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            (0, $bR5nk.jsxs)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).windowViewBlock,
                children: [
                    (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$bf15b2638bfe15a8$export$290931a7697344ba, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    wvc.contentProps?.styles && Object.keys(wvc.contentProps.styles).length > 0 && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$8d91142d51e3ea2b$export$c6f5bf772b2d320d, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422, {
                        label: true,
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    }),
                    (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$164153d6fa9e6c9b$export$8789ea0b5b37a422, {
                        lineIndex: lineIndex,
                        blockIndex: blockIndex
                    })
                ]
            }),
            (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$fbcab087cdb8341f$export$44b5c9777d5218fc, {
                lineIndex: lineIndex,
                blockIndex: blockIndex
            })
        ]
    });
};
$8b359e63c1cdd74d$var$$f1c5b02e089086d0$export$89d87d4877cd77dc.displayName = "WindowViewBlock";
const $8b359e63c1cdd74d$var$$b0a19385787b7450$export$c4d333414b1626fb = ({ lineIndex: lineIndex })=>{
    const wvc = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733);
    const thisLine = wvc?.lines[lineIndex];
    const addBlock = (0, $spJKX.useCallback)((ix)=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$27c9658dd64ba792,
            lineIndex: lineIndex,
            blockIndex: ix
        });
    }, [
        lineIndex,
        wvc
    ]);
    const removeBlock = (0, $spJKX.useCallback)((ix)=>{
        /* istanbul ignore else */ if (wvc) wvc.dispatch({
            operation: $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$f227699a52faa480,
            lineIndex: lineIndex,
            blockIndex: ix
        });
    }, [
        lineIndex,
        wvc
    ]);
    return !wvc || !thisLine ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).windowViewLine,
        children: [
            wvc.contentProps.allowNewLine && (0, $bR5nk.jsxs)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).windowViewLineTitle,
                children: [
                    "Line ",
                    lineIndex + 1
                ]
            }),
            wvc.editable && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f, {
                onClick: ()=>addBlock(0)
            }),
            wvc.lines[lineIndex].textBlocks.map((textBlock, ix)=>(0, $bR5nk.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    children: [
                        wvc.editable && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$034e76b6a38d6263$export$59fc62fa579fbc85, {
                            onClick: ()=>removeBlock(ix)
                        }),
                        (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$f1c5b02e089086d0$export$89d87d4877cd77dc, {
                            lineIndex: lineIndex,
                            blockIndex: ix
                        }),
                        wvc.editable && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$4985b1bd2af31f47$export$b0bdb923ca9c9c5f, {
                            onClick: ()=>addBlock(ix + 1)
                        })
                    ]
                }, ix))
        ]
    });
};
$8b359e63c1cdd74d$var$$b0a19385787b7450$export$c4d333414b1626fb.displayName = "WindowViewLine";
const $8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733 = (0, $spJKX.createContext)(null);
const $8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40 = ({ id: id, showWindowView: showWindowView, setShowWindowView: setShowWindowView, state: state, setState: setState, includeAt: includeAt = false })=>{
    const { currentValue: currentValue, setCurrentValue: setCurrentValue, forceUpdate: forceUpdate, undo: undo, redo: redo, stack: stack, index: index } = $8b359e63c1cdd74d$export$426a3338f36cbf0a({
        value: state.lines,
        /**
     * WindowView - wrapper that renders a draggable/resizable editor window.
     *
     * @param value - Current value used to control window visibility or state.
     */ setValue: (value)=>{
            const ret = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d({
                lines: value
            }, state.contentProps);
            if (!(0, $eBlbF.isEqual)(ret.lines.map((l)=>l.data), state.lines.map((l)=>l.data))) setState(ret);
        },
        debounceMilliseconds: -1
    });
    return (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: id,
        visible: showWindowView,
        title: "Editor contents",
        titleElement: (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                "Editor contents",
                (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$16b3747771ec0ba5$export$a7a4427ce0cafbea, {
                    fill: index > 0 ? "black" : "gray",
                    onClick: ()=>undo()
                }),
                (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$4d0ecc9f8afaf0d5$export$3167bef587fc42aa, {
                    fill: index < stack.length - 1 ? "black" : "gray",
                    onClick: ()=>redo()
                })
            ]
        }),
        style: {
            height: "400px",
            width: "700px",
            maxHeight: "80vh",
            maxWidth: "90vw"
        },
        onClose: ()=>{
            forceUpdate();
            setShowWindowView(false);
        },
        children: (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$f0f9bc7213dc6733.Provider, {
            value: {
                id: id,
                lines: currentValue,
                /**
           * Handle block actions such as add/remove/move originating from the
           * window control and dispatch to the editor callbacks.
           *
           * @param action - The action identifier describing the block operation.
           */ dispatch: (action)=>{
                    const newLines = $8b359e63c1cdd74d$var$$077aaa442e4d7d24$export$91eaa669ef26a074(currentValue, action);
                    setCurrentValue(newLines);
                },
                editable: true,
                contentProps: state.contentProps,
                includeAt: includeAt
            },
            children: (0, $bR5nk.jsxs)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$8a8ca0442c015654$exports).windowViewBody,
                children: [
                    state.contentProps?.allowNewLine && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$e775624493c4cd98$export$5bcea036881b4cf4, {
                        index: 0
                    }),
                    currentValue.map((line, ix)=>(0, $bR5nk.jsxs)("div", {
                            className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$ede054dcbe564586$exports).relativeDiv,
                            children: [
                                (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$63b04b789bb9c5d5$export$1085475ec51f1baf, {
                                    index: ix
                                }),
                                (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$b0a19385787b7450$export$c4d333414b1626fb, {
                                    lineIndex: ix
                                }, ix),
                                state.contentProps?.allowNewLine && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$e775624493c4cd98$export$5bcea036881b4cf4, {
                                    index: ix + 1
                                })
                            ]
                        }, ix))
                ]
            })
        })
    });
};
$8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40.displayName = "WindowView";
/**
 * Checks if the content has any active unlocked at-mention blocks.
 *
 * @param currentValue - The editor content to check
 * @returns True if there are active at blocks
 */ const $8b359e63c1cdd74d$var$$089ef8d015806446$var$hasActiveAt = (currentValue)=>{
    return currentValue.lines.some((i)=>i.textBlocks.some((tb)=>tb.type === "at" && !tb.isLocked));
};
/**
 * Checks if two EditorV3 content values have the same text content.
 *
 * @param oldValue - The previous EditorV3 content value
 * @param newValue - The new EditorV3 content value to compare
 */ const $8b359e63c1cdd74d$var$$089ef8d015806446$var$sameText = (oldValue, newValue)=>$8b359e63c1cdd74d$export$501d19eb8a679b38({
        lines: oldValue.lines.map((l)=>l.textBlocks.map((tb)=>tb.data)),
        showMarkdown: oldValue?.showMarkdown
    }, {
        lines: newValue.lines.map((l)=>l.textBlocks.map((tb)=>tb.data)),
        showMarkdown: newValue.showMarkdown
    });
/**
 * Checks if two EditorV3 content values have the same text but new value has no cursor.
 *
 * @param oldValue - The previous EditorV3 content value
 * @param newValue - The new EditorV3 content value to compare
 */ const $8b359e63c1cdd74d$var$$089ef8d015806446$var$sameTextNoCursor = (oldValue, newValue)=>oldValue.caretPosition !== null && newValue.caretPosition === null && $8b359e63c1cdd74d$var$$089ef8d015806446$var$sameText(oldValue, newValue);
const $8b359e63c1cdd74d$export$c410cc7dbb67874b = ({ allowMarkdown: allowMarkdown = $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowMarkdown, allowNewLine: allowNewLine = $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowNewLine, allowWindowView: allowWindowView = $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.allowWindowView, atListFunction: atListFunction, customStyleMap: customStyleMap, debounceMilliseconds: debounceMilliseconds = null, decimalAlignPercent: decimalAlignPercent = $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.decimalAlignPercent, editable: editable = true, id: id, input: input, markdownSettings: markdownSettings = {
    ...$8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.markdownSettings
}, maxAtListLength: maxAtListLength = 10, noBorder: noBorder = false, onFocus: onFocus, onFocusCapture: onFocusCapture, pending: pending = false, pendingTimeoutMilliseconds: pendingTimeoutMilliseconds = 5000, pendingWindowMilliseconds: pendingWindowMilliseconds = 500, resize: resize = false, setObject: setObject, spellCheck: spellCheck = false, style: style, styleOnContextMenu: styleOnContextMenu = true, textAlignment: textAlignment = $8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54.textAlignment, ...rest })=>{
    // Set up reference to main div
    const aiev3Ref = (0, $spJKX.useRef)(null);
    // Set up reference to inner div
    const editableRef = (0, $spJKX.useRef)(null);
    // other state variables
    const [showMarkdown, setShowMarkdown] = (0, $spJKX.useState)(false);
    const [showWindowView, setShowWindowView] = (0, $spJKX.useState)(false);
    const contentProps = (0, $spJKX.useMemo)(()=>{
        return {
            ...$8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
            allowMarkdown: allowMarkdown,
            allowNewLine: allowNewLine,
            atListFunction: atListFunction,
            decimalAlignPercent: decimalAlignPercent,
            markdownSettings: markdownSettings,
            maxAtListLength: maxAtListLength,
            showMarkdown: showMarkdown,
            styles: customStyleMap,
            textAlignment: textAlignment
        };
    }, [
        allowMarkdown,
        allowNewLine,
        atListFunction,
        customStyleMap,
        decimalAlignPercent,
        markdownSettings,
        maxAtListLength,
        showMarkdown,
        textAlignment
    ]);
    // General return function
    const [hasDrawnElement, setHasDrawnElement] = (0, $spJKX.useState)(false);
    // #region Handling update
    // Redraw element, used in debounced stack as onChange callback
    const redrawElement = (0, $spJKX.useCallback)((ret)=>{
        /* istanbul ignore else */ if (editableRef.current) ret.redraw(editableRef.current);
    }, []);
    // Create debounce stack
    const { currentValue: currentValue, setCurrentValue: setCurrentValue, undo: undo, redo: redo, forceUpdate: forceReturn } = $8b359e63c1cdd74d$export$426a3338f36cbf0a({
        value: new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(input, {
            ...$8b359e63c1cdd74d$var$$f19be80785b1b837$export$fd3826d97a0a3c54,
            textAlignment: textAlignment,
            decimalAlignPercent: decimalAlignPercent,
            styles: customStyleMap,
            showMarkdown: showMarkdown,
            markdownSettings: markdownSettings,
            allowMarkdown: allowMarkdown,
            allowNewLine: allowNewLine
        }),
        // Send data base to the parent
        setValue: (ret)=>setObject({
                lines: ret.data.lines,
                contentProps: ret.data.contentProps
            }),
        debounceMilliseconds: debounceMilliseconds,
        onChange: redrawElement,
        comparisonFunction: $8b359e63c1cdd74d$var$$089ef8d015806446$var$sameText,
        blockReturnFunction: $8b359e63c1cdd74d$var$$089ef8d015806446$var$hasActiveAt,
        blockDebounceReturn: $8b359e63c1cdd74d$var$$089ef8d015806446$var$hasActiveAt,
        blockOnChange: $8b359e63c1cdd74d$var$$089ef8d015806446$var$sameTextNoCursor
    });
    // Utility callback for debugging
    const setContent = (0, $spJKX.useCallback)((newContent, _calledFrom)=>{
        // console.debug(
        //   "Set content ↓\n",
        //   newContent.markdownText,
        //   "\nCaret position: ",
        //   newContent.caretPosition,
        // );
        setCurrentValue(newContent);
    }, [
        setCurrentValue
    ]);
    // #endregion Handling update
    // #region Input utilities
    // Set up menu items
    const menuItems = (0, $spJKX.useMemo)(()=>{
        // Add different styles
        const styleIMenuItem = !editable || !contentProps.styles || Object.keys(contentProps.styles).length === 0 ? [] : [
            {
                label: "Style",
                disabled: contentProps.showMarkdown,
                group: [
                    ...Object.keys(contentProps.styles).map((s)=>{
                        return {
                            label: s,
                            disabled: contentProps.showMarkdown || currentValue.isCaretLocked() || contentProps.styles?.[s].isNotAvailable || currentValue.caretPosition?.isCollapsed,
                            action: ()=>{
                                /* istanbul ignore else */ // eslint-disable-next-line react-hooks/refs
                                if (editableRef.current) {
                                    const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                                    newContent.applyStyle(s);
                                    setContent(newContent, "Apply style from menu");
                                }
                            }
                        };
                    }),
                    {
                        label: "Remove style",
                        disabled: contentProps.showMarkdown || currentValue.caretPosition?.isCollapsed,
                        action: ()=>{
                            /* istanbul ignore else */ if (editableRef.current) {
                                const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                                newContent.removeStyle();
                                setContent(newContent, "Remove style from menu");
                            }
                        }
                    }
                ]
            }
        ];
        // Add markdown switch
        const showMarkdownMenu = !allowMarkdown ? [] : [
            {
                label: `${contentProps.showMarkdown ? "Hide" : "Show"} markdown`,
                action: ()=>{
                    /* istanbul ignore else */ if (editableRef.current) {
                        const newShowMarkdown = !contentProps.showMarkdown;
                        setShowMarkdown(newShowMarkdown);
                        const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, {
                            ...contentProps,
                            showMarkdown: newShowMarkdown
                        });
                        newContent.caretPosition = null; // Reset caret position
                        setContent(newContent, "Markdown toggle");
                    }
                }
            }
        ];
        // Add window view
        const showWindowViewMenu = !allowWindowView || !editable ? [] : [
            {
                label: `${showWindowView ? "Hide" : "Show"} window view`,
                action: ()=>{
                    /* istanbul ignore else */ if (editableRef.current) {
                        const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                        newContent.caretPosition = null;
                        setContent(newContent, "Window view menu");
                        setShowWindowView(!showWindowView);
                    }
                }
            }
        ];
        return [
            ...styleIMenuItem,
            ...showMarkdownMenu,
            ...showWindowViewMenu
        ];
    }, [
        allowMarkdown,
        allowWindowView,
        contentProps,
        currentValue,
        editable,
        setContent,
        showWindowView
    ]);
    // Create custom refresh event used by renderDropdown.
    const handleRefreshEvent = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        e.preventDefault();
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            /* istanbul ignore else */ if (newContent.caretPosition) newContent.caretPosition = {
                startLine: newContent.caretPosition.endLine,
                startChar: newContent.caretPosition.endChar,
                endLine: newContent.caretPosition.endLine,
                endChar: newContent.caretPosition.endChar
            };
            setContent(newContent, "Handle refresh event");
        }
    }, [
        contentProps,
        setContent
    ]);
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (editableRef.current) {
            const editableRefCurrent = editableRef.current;
            editableRefCurrent.addEventListener("editorv3refresh", handleRefreshEvent);
            return ()=>{
                editableRefCurrent?.removeEventListener("editorv3refresh", handleRefreshEvent);
            };
        }
    }, [
        handleRefreshEvent
    ]);
    // #endregion Input utilities
    // #region Handle focus/blur
    // Focus and blur events are container not contenteditable level events!
    const runFocusHandlers = (0, $spJKX.useCallback)((e)=>{
        onFocusCapture?.(e);
        onFocus?.(e);
    }, [
        onFocus,
        onFocusCapture
    ]);
    const { isWaiting: isWaiting, captureFocus: captureFocus, cancelWaiting: cancelWaiting } = $8b359e63c1cdd74d$export$f13a708d2a7a10f9({
        pending: pending,
        input: input,
        windowMilliseconds: pendingWindowMilliseconds,
        timeoutMilliseconds: pendingTimeoutMilliseconds,
        onRelease: runFocusHandlers
    });
    const handleFocus = (0, $spJKX.useCallback)((e)=>{
        if (captureFocus(e)) return;
        runFocusHandlers(e);
    }, [
        captureFocus,
        runFocusHandlers
    ]);
    const handleClick = (0, $spJKX.useCallback)((e)=>{
        if (e.target instanceof Node && e.target === aiev3Ref.current && editableRef.current && editable) {
            // Simulate click on editable div
            // As the target is editor, need to select all content
            const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            // Select everything
            newContent.caretPositionF = {
                initialLine: 0,
                initialChar: 0,
                focusLine: newContent.lines.length - 1,
                focusChar: newContent.showMarkdown ? newContent.lines[newContent.lines.length - 1].lineMarkdown.length : newContent.lines[newContent.lines.length - 1].lineLength
            };
            setContent(newContent, "aiev3 click select all");
            editableRef.current.focus();
        }
    }, [
        contentProps,
        editable,
        setContent
    ]);
    const handleBlur = (0, $spJKX.useCallback)(()=>{
        cancelWaiting();
        /* istanbul ignore else */ if (editableRef.current) {
            // Get current content (this should alreact be correct);
            const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            // Select nothing
            newContent.caretPosition = null;
            forceReturn(newContent);
        }
    }, [
        cancelWaiting,
        contentProps,
        forceReturn
    ]);
    // #endregion Handle focus/blur
    // #region Handle key/mouse events
    const handleKeyDown = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current && !contentProps.showMarkdown) {
            // Handle undo/redo
            /* istanbul ignore else */ if (e.ctrlKey && e.code === "KeyZ") {
                e.preventDefault();
                undo();
            } else if (e.ctrlKey && e.code === "KeyY") {
                e.preventDefault();
                redo();
            } else if (currentValue.isCaretLocked() && ![
                "ArrowLeft",
                "ArrowRight",
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End"
            ].includes(e.key)) e.preventDefault();
            else if (![
                "Control",
                "Shift",
                "Alt"
            ].includes(e.key) && !(e.ctrlKey && (e.code === "KeyC" || e.code === "KeyX" || e.code === "KeyV"))) {
                // Get current information and update content buffer for positions
                const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.handleKeydown(e);
                setContent(newContent, `Handle key down: ${e.key}`);
            }
        }
    }, [
        contentProps,
        isWaiting,
        redo,
        setContent,
        currentValue,
        undo
    ]);
    const handleKeyUp = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        // Markdown editing should not be handled
        /* istanbul ignore else */ if (editableRef.current && !currentValue.showMarkdown) {
            // Stop handled keys
            /* istanbul ignore else */ if ([
                "KeyY",
                "KeyZ"
            ].includes(e.code) && e.ctrlKey) {
                e.stopPropagation();
                e.preventDefault();
                return;
            } else if ([
                "Backspace",
                "Delete"
            ].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
            } else if (![
                "Control",
                "Shift",
                "Alt"
            ].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.handleKeyup(e);
                // Create @block if @ has been typed
                if (atListFunction && newContent.caretPosition && newContent.caretPosition.startChar > 0) {
                    const replacePos = {
                        ...newContent.caretPosition,
                        startChar: newContent.caretPosition.startChar - 1
                    };
                    const lastChar = newContent.subLines(replacePos).map((l)=>l.lineText).reduce((a, b)=>a += b, "");
                    // Look for the @ character
                    if (lastChar.trim() === "@") newContent.splice(replacePos, [
                        new $8b359e63c1cdd74d$export$f727c5bfed9e77d4([
                            new $8b359e63c1cdd74d$export$2762eb7a56f6d4be({
                                text: "@",
                                type: "at"
                            })
                        ], contentProps)
                    ]);
                }
                setContent(newContent, `Handle key up: ${e.key}`);
            }
        }
    }, [
        atListFunction,
        contentProps,
        isWaiting,
        setContent,
        currentValue
    ]);
    const handleMouseUp = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) return;
        // Drop down list last entry can target again resize (current.parentElement)
        if (editableRef.current && e.target instanceof Node && (editableRef.current.parentElement === e.target || editableRef.current === e.target || editableRef.current.contains(e.target))) setTimeout(()=>{
            /* istanbul ignore else */ if (editableRef.current) {
                const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
                newContent.checkStatus();
                setContent(newContent, "Handle mouse up on timeout");
            }
        }, 0);
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    // #endregion Handle key/mouse events
    // #region Handle clipboard events
    const handleCopy = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        // Copy is harmless while waiting, cut is not
        if (isWaiting && e.type === "cut") {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            newContent.handleCopy(e);
            setContent(newContent, "Handle copy");
        }
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    const handlePaste = (0, $spJKX.useCallback)((e)=>{
        e.stopPropagation();
        if (isWaiting) {
            e.preventDefault();
            return;
        }
        /* istanbul ignore else */ if (editableRef.current) {
            const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editableRef.current, contentProps);
            newContent.handlePaste(e);
            setContent(newContent, "Handle paste");
        }
    }, [
        contentProps,
        isWaiting,
        setContent
    ]);
    const handleBlock = (0, $spJKX.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
    }, []);
    // #endregion Handle clipboard events
    // #region Style recalculation
    const styleRecalc = (0, $spJKX.useMemo)(()=>{
        const s = {
            ...style
        };
        switch(resize){
            case "vertical":
                s.resize = "vertical";
                s.overflow = "auto";
                break;
            case true:
                s.resize = "both";
                s.overflow = "auto";
                break;
        }
        if (showWindowView) s.backgroundColor = "rgba(0, 0, 0, 0.2)";
        return s;
    }, [
        resize,
        showWindowView,
        style
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (editableRef.current && !hasDrawnElement) {
            redrawElement(currentValue);
            setHasDrawnElement(true);
        }
    }, [
        hasDrawnElement,
        redrawElement,
        currentValue
    ]);
    return (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            (0, $bR5nk.jsx)("div", {
                ...rest,
                ref: aiev3Ref,
                className: [
                    "aiev3",
                    editable ? "" : "disabled",
                    currentValue.caretPosition !== null ? "editing" : "",
                    showWindowView ? "window-view-active" : "",
                    isWaiting ? "pending" : "",
                    rest.className ?? ""
                ].filter(Boolean).join(" "),
                id: id,
                onFocusCapture: handleFocus,
                onBlurCapture: (e)=>{
                    rest.onBlurCapture?.(e);
                    handleBlur();
                    window.getSelection()?.removeAllRanges();
                    rest.onBlur?.(e);
                    e.preventDefault();
                    e.stopPropagation();
                },
                onMouseUp: (e)=>{
                    handleMouseUp(e);
                    rest.onMouseUp?.(e);
                },
                onClick: (e)=>{
                    handleClick(e);
                    rest.onClick?.(e);
                },
                children: (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                    menuItems: menuItems,
                    style: {
                        width: "100%",
                        height: "100%"
                    },
                    showLowMenu: spellCheck || !styleOnContextMenu,
                    children: (0, $bR5nk.jsx)("div", {
                        className: `aiev3-resize${!noBorder ? " aiev3-resize-border" : ""}`,
                        style: styleRecalc,
                        children: (0, $bR5nk.jsx)("div", {
                            id: `${id}-editable`,
                            className: `aiev3-editing ${allowNewLine ? "multiline" : "singleline"}`,
                            contentEditable: editable && !showWindowView,
                            suppressContentEditableWarning: true,
                            role: editable ? "textbox" : undefined,
                            spellCheck: spellCheck,
                            ref: editableRef,
                            onKeyDownCapture: handleKeyDown,
                            onKeyUpCapture: handleKeyUp,
                            onCutCapture: handleCopy,
                            onCopyCapture: handleCopy,
                            onPasteCapture: handlePaste,
                            onDragStart: handleBlock,
                            onDragOver: handleBlock,
                            onDrop: handleBlock,
                            onDragEnter: handleBlock,
                            onDragLeave: handleBlock,
                            onDragEnd: handleBlock
                        })
                    })
                })
            }),
            allowWindowView && editable && (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$969bb2bbbbbb17fd$export$a634f244d0bbcc40, {
                id: `${id}-window`,
                showWindowView: showWindowView,
                setShowWindowView: setShowWindowView,
                state: currentValue,
                setState: (ret)=>{
                    forceReturn(ret);
                    // Refocus editable after closing window view
                    setTimeout(()=>editableRef.current?.focus(), 10);
                },
                includeAt: atListFunction !== undefined
            })
        ]
    });
};
$8b359e63c1cdd74d$export$c410cc7dbb67874b.displayName = "AsupEditorV3";
const $8b359e63c1cdd74d$export$64d7be461af4ab3e = ({ label: label, errorText: errorText, style: style, resize: resize, ...rest })=>{
    const outerStyle = {};
    const innerStyle = {
        ...style
    };
    /* istanbul ignore else */ if (style) {
        /* istanbul ignore else */ if (style.width) {
            outerStyle.width = style.width;
            innerStyle.width = "100%";
        }
        /* istanbul ignore else */ if (style.maxWidth) {
            outerStyle.maxWidth = style.maxWidth;
            innerStyle.maxWidth = "100%";
        }
        /* istanbul ignore else */ if (style.minWidth) {
            outerStyle.minWidth = style.minWidth;
            innerStyle.minWidth = "100%";
        }
        /* istanbul ignore else */ if (style.height) {
            outerStyle.height = style.height;
            innerStyle.height = "100%";
        } else {
            outerStyle.height = "calc(1.5em + 26px)";
            innerStyle.height = "100%";
        }
        /* istanbul ignore else */ if (style.maxHeight) {
            outerStyle.maxHeight = style.maxHeight;
            innerStyle.maxHeight = "100%";
        }
        /* istanbul ignore else */ if (style.minHeight) {
            outerStyle.minHeight = style.minHeight;
            innerStyle.minHeight = "100%";
        } else {
            outerStyle.minHeight = "calc(1.5em + 26px)";
            innerStyle.minHeight = "100%";
        }
        /* istanbul ignore else */ if (resize === true || resize === "vertical") {
            outerStyle.resize = "vertical";
            outerStyle.overflow = "auto";
        }
    }
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder,
        style: outerStyle,
        children: [
            label !== undefined && (0, $bR5nk.jsx)("label", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).label,
                id: `${rest.id}-label`,
                htmlFor: `${rest.id}`,
                children: label
            }),
            errorText !== undefined && errorText.trim() !== "" && (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).errorText,
                children: (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                    children: errorText.split("\n").map((errorLine, ix)=>(0, $bR5nk.jsx)("div", {
                            children: errorLine
                        }, ix))
                })
            }),
            (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).editorHolder,
                children: (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$c410cc7dbb67874b, {
                    ...rest,
                    "aria-labelledby": `${rest.id}-label`,
                    style: innerStyle,
                    noBorder: true,
                    resize: false
                })
            })
        ]
    });
};
$8b359e63c1cdd74d$export$64d7be461af4ab3e.displayName = "BaseEditorV3";
const $8b359e63c1cdd74d$export$2148d73965a312db = ({ id: id, checked: checked, change: change, label: label, ...rest })=>{
    /**
   * Toggle the checkbox state and notify change handlers.
   *
   * @param e - The event object
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        change(!checked);
    };
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder,
        children: [
            (0, $bR5nk.jsx)("input", {
                ...rest,
                type: "checkbox",
                id: id,
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).baseCheckbox,
                checked: checked,
                onChange: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                onClick: handleClick
            }),
            label !== undefined && (0, $bR5nk.jsx)("label", {
                id: `${id}-label`,
                htmlFor: id,
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).baseCheckboxLabel,
                onClick: handleClick,
                children: label
            })
        ]
    });
};
$8b359e63c1cdd74d$export$2148d73965a312db.displayName = "BaseCheckbox";
const $8b359e63c1cdd74d$export$1cfea591e85f6e12 = ({ lineChild: lineChild, children: children, open: open = false, timeMs: timeMs = 300, height: height = 300, disabled: disabled = false, contentBoxStyle: contentBoxStyle, ...rest })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [expanded, setExpanded] = (0, $spJKX.useState)("closed");
    const [lastOpen, setLastOpen] = (0, $spJKX.useState)(null);
    (0, $spJKX.useLayoutEffect)(()=>{
        if (open !== lastOpen) {
            if (open) startTransition(()=>setExpanded("placing"));
            else if (lastOpen !== null) startTransition(()=>setExpanded("closing"));
            startTransition(()=>setLastOpen(open));
        }
    }, [
        expanded,
        open,
        lastOpen
    ]);
    /**
   * Toggles the expanded state between "open" and "closed".
   *
   * @param e - Mouse event triggering the toggle action.
   */ const toggle = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        switch(expanded){
            case "closed":
                setExpanded("placing");
                break;
            case "open":
                setExpanded("closing");
                break;
        }
    };
    (0, $spJKX.useLayoutEffect)(()=>{
        if (expanded === "placing") setTimeout(()=>{
            setExpanded("opening");
        }, 5);
        if (expanded === "opening") setTimeout(()=>{
            setExpanded("open");
        }, timeMs);
        if (expanded === "closing") setTimeout(()=>{
            setExpanded("closed");
        }, timeMs);
    }, [
        expanded,
        timeMs
    ]);
    return (0, $bR5nk.jsxs)("div", {
        ...rest,
        className: [
            /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).expander,
            /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports)[expanded],
            disabled ? /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).disabled : "",
            ...rest.className ?? ""
        ].join(" "),
        onClick: (e)=>{
            if (!disabled && e.target instanceof HTMLDivElement && e.target.parentElement?.classList.contains(/*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).expander) && e.target.classList.contains(/*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder)) toggle(e);
        },
        children: [
            (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).holder,
                children: lineChild
            }),
            expanded !== "closed" && (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).expanderContent,
                style: {
                    ...contentBoxStyle,
                    transition: `min-height ${timeMs}ms ease-in-out, max-height ${timeMs}ms ease-in-out, opacity ${timeMs}ms ease-in-out`,
                    maxHeight: [
                        "open",
                        "opening"
                    ].includes(expanded) ? `${height}px` : "0",
                    minHeight: [
                        "open",
                        "opening"
                    ].includes(expanded) ? `${height}px` : "0"
                },
                children: children
            })
        ]
    });
};
$8b359e63c1cdd74d$export$1cfea591e85f6e12.displayName = "Expander";
const $8b359e63c1cdd74d$var$$533e9b937ad6d455$export$8554d9663e8a7107 = (0, $spJKX.createContext)(null);
const $8b359e63c1cdd74d$var$$533e9b937ad6d455$export$fed038e1a302e255 = ({ object: object, setObject: setObject, objectTemplate: objectTemplate, children: children })=>{
    return (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$533e9b937ad6d455$export$8554d9663e8a7107.Provider, {
        value: {
            object: object,
            setObject: setObject,
            objectTemplate: objectTemplate
        },
        children: children
    });
};
$8b359e63c1cdd74d$var$$533e9b937ad6d455$export$fed038e1a302e255.displayName = "ObjectEditorContextProvider";
const $8b359e63c1cdd74d$export$267c05bbab99602d = ({ dataPoint: dataPoint, ...rest })=>{
    const objectEditorContext = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$533e9b937ad6d455$export$8554d9663e8a7107);
    const thisOption = dataPoint.split(".").pop();
    const thisOptionType = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.type;
    const thisOptionValues = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.options;
    const thisOptionLabel = objectEditorContext?.objectTemplate.find((item)=>item.name === thisOption)?.label ?? thisOption;
    const thisValueRaw = (0, $eBlbF.get)(objectEditorContext?.object, dataPoint);
    /**
   * Update the parent object with the new value for this data point.
   *
   * @param ret - The new value (string|number|boolean|undefined) provided
   *        by the child input component.
   */ const handleChange = (ret)=>{
        /* istanbul ignore else */ if (objectEditorContext) {
            const newObject = (0, $eBlbF.cloneDeep)(objectEditorContext.object);
            /* istanbul ignore else */ if ((0, $eBlbF.get)(newObject, dataPoint) !== ret) {
                (0, $eBlbF.set)(newObject, dataPoint, ret);
                objectEditorContext.setObject(newObject);
            }
        }
    };
    return !objectEditorContext ? null : (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: thisOptionType === "boolean" ? (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$2148d73965a312db, {
            id: `id-${dataPoint}`,
            checked: thisValueRaw ?? false,
            change: handleChange,
            label: thisOptionLabel,
            ...rest
        }) : thisOptionType === "select" && thisOptionValues ? (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$dcee1aa94a106d27, {
            id: `id-${dataPoint}`,
            value: thisValueRaw,
            availableOptions: thisOptionValues,
            change: handleChange,
            label: thisOptionLabel,
            ...rest
        }) : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$e1f706e5673fef9e, {
            id: `id-${dataPoint}`,
            value: thisValueRaw,
            onNewValue: handleChange,
            label: thisOptionLabel,
            ...rest
        })
    });
};
$8b359e63c1cdd74d$export$267c05bbab99602d.displayName = "ItemInput";
const $8b359e63c1cdd74d$var$$7822d9152214a22a$export$8d67358b399a570 = ({ dataPath: dataPath, ...rest })=>{
    const objectEditorContext = (0, $spJKX.useContext)($8b359e63c1cdd74d$var$$533e9b937ad6d455$export$8554d9663e8a7107);
    const parentObject = (0, $spJKX.useMemo)(()=>objectEditorContext?.object ?? {}, [
        objectEditorContext?.object
    ]);
    const thisName = dataPath.split(".").pop();
    const thisObject = (0, $spJKX.useMemo)(()=>parentObject[thisName], [
        parentObject,
        thisName
    ]);
    const availableItems = objectEditorContext?.objectTemplate ?? [];
    const ix = thisObject ? Object.keys(parentObject).indexOf(thisName) : -1;
    const [currentName, setCurrentName] = (0, $spJKX.useState)(dataPath.split(".").pop() ?? // istanbul ignore next
    "");
    const handleBlur = (0, $spJKX.useCallback)(()=>{
        /* istanbul ignore else */ if (objectEditorContext && parentObject) {
            // Get full original object
            const newParentObject = Object.entries((0, $eBlbF.cloneDeep)(parentObject));
            newParentObject[ix][0] = currentName;
            objectEditorContext.setObject(Object.fromEntries(newParentObject));
        }
    }, [
        currentName,
        ix,
        objectEditorContext,
        parentObject
    ]);
    const handleChange = (0, $spJKX.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setCurrentName(e.currentTarget.value.replace(/[^a-zA-Z0-9_]/g, ""));
    }, []);
    return ix === -1 ? (0, $bR5nk.jsxs)("div", {
        children: [
            dataPath,
            " not found"
        ]
    }) : (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$1cfea591e85f6e12, {
        ...rest,
        lineChild: (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                (0, $bR5nk.jsx)("label", {
                    className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).label,
                    id: `label-${dataPath}`,
                    htmlFor: `name-${dataPath}`,
                    children: "Name"
                }),
                (0, $bR5nk.jsx)("input", {
                    id: `name-${dataPath}`,
                    className: /*@__PURE__*/ $8b359e63c1cdd74d$var$$parcel$interopDefault($8b359e63c1cdd74d$var$$d1df120914c5e45a$exports).baseInput,
                    value: currentName,
                    onChange: handleChange,
                    onBlur: handleBlur
                })
            ]
        }),
        children: availableItems.map((item, ix)=>(0, $bR5nk.jsx)((0, $spJKX.Fragment), {
                children: (0, $bR5nk.jsx)($8b359e63c1cdd74d$export$267c05bbab99602d, {
                    dataPoint: `${dataPath}.${item.name}`
                })
            }, ix))
    });
};
$8b359e63c1cdd74d$var$$7822d9152214a22a$export$8d67358b399a570.displayName = "InternalObjectEditor";
const $8b359e63c1cdd74d$export$ec7da929f39d97c8 = ({ object: object, setObject: setObject, objectTemplate: objectTemplate })=>{
    return (0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$533e9b937ad6d455$export$fed038e1a302e255, {
        object: object,
        setObject: setObject,
        objectTemplate: objectTemplate,
        children: Object.keys(object).map((property, ix)=>(0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$7822d9152214a22a$export$8d67358b399a570, {
                dataPath: property
            }, `${ix}-${property}`))
    });
};
$8b359e63c1cdd74d$export$ec7da929f39d97c8.displayName = "ObjectEditor";
var $8b359e63c1cdd74d$var$$a26c210fc5bc2447$export$2e2bcd8739ae039 = $8b359e63c1cdd74d$export$ec7da929f39d97c8;
const $8b359e63c1cdd74d$var$$2cd891dbea8e972b$export$f1a0852707cadfcc = [
    {
        name: "fontFamily",
        label: "Font family",
        type: "select",
        options: [
            {
                value: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', sans-serif",
                label: "Sans Serif"
            },
            {
                value: "'Courier New', monospace",
                label: "Monospace"
            }
        ]
    },
    {
        name: "fontSize",
        label: "Font size",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "8pt",
                label: "8pt"
            },
            {
                value: "9pt",
                label: "9pt"
            },
            {
                value: "10pt",
                label: "10pt"
            },
            {
                value: "11pt",
                label: "11pt"
            },
            {
                value: "12pt",
                label: "12pt"
            },
            {
                value: "14pt",
                label: "14pt"
            },
            {
                value: "16pt",
                label: "16pt"
            },
            {
                value: "18pt",
                label: "18pt"
            }
        ]
    },
    {
        name: "fontStyle",
        label: "Font style",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "italic",
                label: "Italic"
            }
        ]
    },
    {
        name: "fontWeight",
        label: "Font weight",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: 300,
                label: "Thin"
            },
            {
                value: 600,
                label: "Normal"
            },
            {
                value: 700,
                label: "Heavy"
            },
            {
                value: 1000,
                label: "Very heavy"
            }
        ]
    },
    {
        name: "color",
        label: "Colour",
        type: "string"
    },
    {
        name: "textDecoration",
        label: "Text decoration",
        type: "select",
        options: [
            {
                value: undefined,
                label: "None"
            },
            {
                value: "underline",
                label: "Underline"
            },
            {
                value: "line-through",
                label: "Line Through"
            }
        ]
    },
    {
        name: "isLocked",
        label: "Stop blocks being edited (isLocked)",
        type: "boolean"
    },
    {
        name: "isNotAvailable",
        label: "Stop user from choosing this style (isNotAvailable)",
        type: "boolean"
    }
];
const $8b359e63c1cdd74d$export$bf67e8fa85c2bdc7 = ({ styles: styles, setStyles: setStyles, styleItems: styleItems = $8b359e63c1cdd74d$var$$2cd891dbea8e972b$export$f1a0852707cadfcc })=>(0, $bR5nk.jsx)($8b359e63c1cdd74d$var$$a26c210fc5bc2447$export$2e2bcd8739ae039, {
        object: styles,
        setObject: setStyles,
        objectTemplate: styleItems
    });
$8b359e63c1cdd74d$export$bf67e8fa85c2bdc7.displayName = "StylesEditor";
var $8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "getObjectDiff", ()=>$8b359e63c1cdd74d$export$db8269090bd3dd4);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "getTextFromEditorV3", ()=>$8b359e63c1cdd74d$export$59ffc450e12fbd65);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "hasStylesToRemove", ()=>$8b359e63c1cdd74d$export$5bbd286e9783a47b);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "joinV3intoBlock", ()=>$8b359e63c1cdd74d$export$6be11f3b04f364b4);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "removeStylesFromEditorV3", ()=>$8b359e63c1cdd74d$export$c4055ded8e1007ea);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "replaceTextInEditorV3", ()=>$8b359e63c1cdd74d$export$4473dc511c49aabc);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "searchEditorV3Content", ()=>$8b359e63c1cdd74d$export$458b3725b25c35e4);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "splitV3intoLines", ()=>$8b359e63c1cdd74d$export$9046ef79d808c3d9);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$4c5fb5bb6e826a01$exports, "stringToV3", ()=>$8b359e63c1cdd74d$export$4c11677f6b5bfb11);
function $8b359e63c1cdd74d$export$db8269090bd3dd4(obj1, obj2, returnChange) {
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return obj1 !== obj2 ? [
        obj1,
        obj2
    ] : undefined;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    const uniqueKeys = new Set([
        ...keys1,
        ...keys2
    ]);
    /* Set up the return object */ const isArray = Array.isArray(obj1);
    const differences = {};
    /* Loop through the keys and compare values */ for (const key of uniqueKeys){
        const value1 = obj1[key];
        const value2 = obj2[key];
        if (typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null && !returnChange) {
            const nestedDifferences = $8b359e63c1cdd74d$export$db8269090bd3dd4(value1, value2, false);
            if (nestedDifferences) differences[key] = nestedDifferences;
        } else if (typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null && returnChange && !(0, $eBlbF.isEqual)(value1, value2)) differences[key] = value2;
        else if (!(typeof value1 === "object" && value1 !== null && typeof value2 === "object" && value2 !== null) && value1 !== value2) /* Add any differences according to the return type */ differences[key] = returnChange ? value2 : [
            value1,
            value2
        ];
    }
    /* Check if there are any differences */ const hasChanges = Object.keys(differences).length > 0;
    if (!hasChanges) return undefined;
    /* Return as array if input was array, otherwise as object */ if (isArray) {
        const arrayResult = [];
        for (const key of Object.keys(differences)){
            const index = parseInt(key);
            /* istanbul ignore else */ if (!isNaN(index)) arrayResult[index] = differences[key];
        }
        return arrayResult;
    }
    return differences;
}
const $8b359e63c1cdd74d$export$59ffc450e12fbd65 = (input)=>input && input.lines.length > 0 ? input.lines.map((l)=>l.textBlocks.map((tb)=>tb.text).join("")) : [
        ""
    ];
const $8b359e63c1cdd74d$export$5bbd286e9783a47b = (content, styleList)=>{
    if (!$8b359e63c1cdd74d$export$a2e4f3e0d013ef9f(content)) return false;
    const hasStyles = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(content).hasStyles;
    return hasStyles.some((s)=>styleList.includes(s));
};
const $8b359e63c1cdd74d$export$c4055ded8e1007ea = (content, stylesToDelete, stylesToClean)=>{
    if (!$8b359e63c1cdd74d$export$a2e4f3e0d013ef9f(content)) return content;
    const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(content);
    newContent.deleteStyles(stylesToDelete);
    newContent.cleanStyles(stylesToClean);
    return {
        ...content,
        lines: newContent.data.lines
    };
};
const $8b359e63c1cdd74d$export$4473dc511c49aabc = (input, oldPhrase, newPhrase, newLineChar = "~")=>{
    const ret = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(input);
    // Check for characters in the old phrase
    // Check the phrase exists in the target
    /* istanbul ignore else */ if (oldPhrase !== "" && ret.getTextPosition(oldPhrase)) {
        // Get replacement content
        const newContent = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(newPhrase);
        // New content style
        const newContentStyleMap = new Set(newContent.lines.flatMap((line)=>line.textBlocks.map((block)=>block.style)));
        const newContentStyle = newContentStyleMap.size === 1 ? newContentStyleMap.values().next().value : undefined;
        // Add line breaks to replacement content
        while(newContent.getTextPosition(newLineChar)?.length ?? false){
            const pos = newContent.getTextPosition(newLineChar);
            /* istanbul ignore else */ if (pos) newContent.splitLine(pos[0]);
        }
        // Update all lines
        const pos = ret.getTextPosition(oldPhrase);
        /* istanbul ignore else */ if (pos && pos.length > 0) for(let i = pos.length - 1; i >= 0; i--){
            const thisPos = pos[i];
            // Check if target has a single style
            const target = ret.subLines(thisPos);
            const targetStyle = target.length === 1 && target[0].textBlocks.length === 1 ? target[0].textBlocks[0].style : undefined;
            // Create this replacement
            const thisReplacement = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(newContent);
            // Check new content has no style
            /* istanbul ignore else */ if (targetStyle && !newContentStyle) thisReplacement.applyStyle(targetStyle, {
                startLine: 0,
                startChar: 0,
                endLine: thisReplacement.lines.length - 1,
                endChar: thisReplacement.lines[thisReplacement.lines.length - 1].lineLength
            });
            // Update the content
            ret.splice(thisPos, thisReplacement.lines);
        }
    }
    return ret.data;
};
const $8b359e63c1cdd74d$export$458b3725b25c35e4 = (searchText, editorV3Content)=>{
    if (!editorV3Content || !editorV3Content.lines) return 0;
    const content = new $8b359e63c1cdd74d$export$1a4903393d6b1b7d(editorV3Content);
    // Extracted function to count line matches
    return content.lines.map((l)=>l.lineText.toLowerCase().includes(searchText.toLowerCase()) ? 1 : 0).reduce((a, b)=>a + b, 0);
};
var $8b359e63c1cdd74d$var$$ca43fe01b6155439$exports = {};
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ca43fe01b6155439$exports, "cleanIsEqual", ()=>$8b359e63c1cdd74d$export$501d19eb8a679b38);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ca43fe01b6155439$exports, "cleanObject", ()=>$8b359e63c1cdd74d$export$969b205aa1357eaa);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ca43fe01b6155439$exports, "useDebounceStack", ()=>$8b359e63c1cdd74d$export$426a3338f36cbf0a);
$8b359e63c1cdd74d$var$$parcel$export($8b359e63c1cdd74d$var$$ca43fe01b6155439$exports, "usePendingUpdate", ()=>$8b359e63c1cdd74d$export$f13a708d2a7a10f9);

});

parcelRegister("8LR5y", function(module, exports) {

$parcel$export(module.exports, "isVariantInformation", function () { return $c65a159f50b7da57$export$7a9530a6de2618ea; });

var $f37gm = parcelRequire("f37gm");

var $38JdT = parcelRequire("38JdT");
const $c65a159f50b7da57$export$7a9530a6de2618ea = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const chkObj = obj;
    if (typeof chkObj.allVariantPatches !== "object" || chkObj.allVariantPatches === null || Array.isArray(chkObj.allVariantPatches)) return false;
    if (Object.values(chkObj.allVariantPatches).some((patch)=>!(0, $f37gm.isVariantPatch)(patch))) return false;
    if (!Array.isArray(chkObj.variantTemplates) || chkObj.variantTemplates.some((item)=>!(0, $38JdT.isVariantTemplate)(item))) return false;
    return true;
};

});
parcelRegister("f37gm", function(module, exports) {

$parcel$export(module.exports, "isVariantPatch", function () { return $6cfb0eaa16d09d09$export$6e963866a5a3b98f; });

var $ee4vT = parcelRequire("ee4vT");
const $6cfb0eaa16d09d09$export$6e963866a5a3b98f = (obj)=>{
    if (!Array.isArray(obj)) return false;
    return obj.every((op)=>{
        if (typeof op !== "object" || op === null) return false;
        const chkOp = op;
        if (typeof chkOp.path !== "string" || !chkOp.path.startsWith("/") || /~(?:[^01]|$)/.test(chkOp.path)) return false;
        // Check first token is valid to be updated
        const firstToken = chkOp.path.slice(1).split("/")[0].replace(/~1/g, "/").replace(/~0/g, "~");
        if (!(0, $ee4vT.VARIANT_UPDATEABLE_KEYS).some((key)=>key === firstToken)) return false;
        // Check if the operation is one of the allowed types: add, remove, replace
        if (![
            "add",
            "remove",
            "replace"
        ].includes(chkOp.op)) return false;
        // Check new value has been specified
        if (chkOp.op === "add" || chkOp.op === "replace") {
            if (chkOp.value === undefined) return false;
        }
        // Everything is good
        return true;
    });
};

});
parcelRegister("ee4vT", function(module, exports) {

$parcel$export(module.exports, "VARIANT_UPDATEABLE_KEYS", function () { return $e7c19a260f6fc402$export$336a6b4c41c62888; });
const $e7c19a260f6fc402$export$336a6b4c41c62888 = [
    "analysisSetId",
    "body",
    "domain",
    "footnotes",
    "outputName",
    "outputType",
    "pageBy",
    "programName",
    "programmerNotes",
    "standardsNotes",
    "suffix",
    "titles"
];

});


parcelRegister("38JdT", function(module, exports) {

$parcel$export(module.exports, "isVariantTemplate", function () { return $fdb7b70887769d7c$export$8253491e484f6aa3; });
const $fdb7b70887769d7c$export$8253491e484f6aa3 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.name !== "string") return false;
    if (![
        "string",
        "undefined"
    ].includes(typeof chkObj.description)) return false;
    if (chkObj.domain !== undefined && typeof chkObj.domain !== "string") return false;
    if (!Array.isArray(chkObj.variantPatches) || chkObj.variantPatches.some((x)=>typeof x !== "string")) return false;
    // Everything is good
    return true;
};

});


parcelRegister("kdlCe", function(module, exports) {

$parcel$export(module.exports, "isTitlesFootnotesReadDto", function () { return $65fb78aff5d88a2b$export$5faa8ae3a91317b9; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $2Rhsi = parcelRequire("2Rhsi");
var $2Uw8z = parcelRequire("2Uw8z");
var $12Lyj = parcelRequire("12Lyj");

var $jek0L = parcelRequire("jek0L");

var $4lHS7 = parcelRequire("4lHS7");

var $aYj2Y = parcelRequire("aYj2Y");
const $65fb78aff5d88a2b$export$5faa8ae3a91317b9 = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check lower interface
    if (!(0, $aYj2Y.isTlfItemIndexReadDto)(obj)) return false;
    // Check basic props
    if (obj.programName !== undefined && typeof obj.programName !== "string") return false;
    if (obj.suffix !== undefined && typeof obj.suffix !== "string") return false;
    if (obj.outputName !== undefined && typeof obj.outputName !== "string") return false;
    if (obj.outputType !== undefined && (typeof obj.outputType !== "string" || !Object.values((0, $4lHS7.eTlfOutputType)).includes(obj.outputType))) return false;
    if (typeof obj.shellMinorVersion !== "number") return false;
    // Check arrays
    if (!Array.isArray(obj.titles) || !Array.isArray(obj.footnotes)) return false;
    if (!Array.isArray(obj.comments) || obj.comments.some((x)=>!(0, $jek0L.isCommentReadDto)(x))) return false;
    if (!Array.isArray(obj.changedTitles) && obj.changedTitles !== undefined) return false;
    // Check array contents
    if (obj.changedTitles?.some((x)=>!(0, $2Uw8z.isGridItemTrafficLight)(x))) return false;
    if (!Array.isArray(obj.singles) || obj.singles.some((o)=>!(0, $2Rhsi.isAioExternalSingle)(o, (0, $bX0x9.isIEditorV3)))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("jek0L", function(module, exports) {

$parcel$export(module.exports, "isCommentReadDto", function () { return $f70a8b0d0e3fe65a$export$52d60b9432851981; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $12Lyj = parcelRequire("12Lyj");
const $f70a8b0d0e3fe65a$export$52d60b9432851981 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.id === "string" && typeof obj.authorId === "number" && (0, $bX0x9.isIEditorV3)(obj.content) && typeof obj.authorDisplayName === "string" && (obj.parentId === undefined || typeof obj.parentId === "string") && (obj.relatedTo === undefined || typeof obj.relatedTo === "string") && typeof obj.createdAt === "string" && typeof obj.updatedAt === "string" && typeof obj.updateCount === "number" && (obj.entityVersion === undefined || typeof obj.entityVersion === "string"));
};

});

parcelRegister("aYj2Y", function(module, exports) {

$parcel$export(module.exports, "isHierarchyLink", function () { return $327b7792d9a42c63$export$492be82763901ee5; });
$parcel$export(module.exports, "isTlfTag", function () { return $327b7792d9a42c63$export$c8a4d7e3d2c1d67c; });
$parcel$export(module.exports, "isTlfItemIndexReadDto", function () { return $327b7792d9a42c63$export$3259877ac5d52fde; });
parcelRequire("6jtLO");
var $6g7gz = parcelRequire("6g7gz");
var $fEdhd = parcelRequire("fEdhd");
var $12Lyj = parcelRequire("12Lyj");

var $lVuyg = parcelRequire("lVuyg");

var $38JdT = parcelRequire("38JdT");

var $4lHS7 = parcelRequire("4lHS7");
const $327b7792d9a42c63$export$6036fa85d2283ca1 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.linkId === "string" && typeof obj.linkType === "string" && typeof obj.azsolId === "string" && typeof obj.version === "number" && // Check enums
    obj.linkType in (0, $4lHS7.eLinkType) && (obj.linkLocation === undefined || obj.linkLocation === null || (0, $lVuyg.isTlfLinkLocation)(obj.linkLocation)) && (obj.linkStatus === undefined || obj.linkStatus === null || typeof obj.linkStatus === "string" && obj.linkStatus in (0, $4lHS7.eReleaseStatus)));
};
const $327b7792d9a42c63$export$492be82763901ee5 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return typeof obj.hierarchyId === "string" && typeof obj.hierarchyTag === "string" && Object.values((0, $4lHS7.eHierarchyLevel)).includes(obj.hierarchyLevel);
};
const $327b7792d9a42c63$export$c8a4d7e3d2c1d67c = (obj)=>{
    return typeof obj === "object" && obj !== null && "tagId" in obj && "tagValue" in obj && typeof obj.tagId === "string" && typeof obj.tagValue === "string";
};
const $327b7792d9a42c63$export$bc294b7706d86ce = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return typeof obj.reasonCode === "string" && typeof obj.otherText === "string" && (obj.crystalReference === undefined || typeof obj.crystalReference === "string");
};
const $327b7792d9a42c63$export$3259877ac5d52fde = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.azsolId !== "string") return false;
    if (typeof chkObj.version !== "number") return false;
    if (typeof chkObj.primaryHierarchyId !== "string") return false;
    if (typeof chkObj.primaryHierarchyName !== "string") return false;
    if (typeof chkObj.primaryHierarchyLevel !== "string") return false;
    if (typeof chkObj.primaryHierarchyType !== "string") return false;
    if (typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.taPrefix !== "string") return false;
    if (typeof chkObj.projectCode !== "string") return false;
    if (chkObj.tocOrder !== undefined && typeof chkObj.tocOrder !== "number") return false;
    if (chkObj.tocNumber !== undefined && typeof chkObj.tocNumber !== "string") return false;
    if (chkObj.tocLabel !== undefined && typeof chkObj.tocLabel !== "string") return false;
    if (chkObj.analysisSetId !== undefined && typeof chkObj.analysisSetId !== "string") return false;
    if (chkObj.tocReleaseStatus !== undefined && typeof chkObj.tocReleaseStatus !== "string") return false;
    if (chkObj.tocOriginTrafficLight !== undefined && typeof chkObj.tocOriginTrafficLight !== "string") return false;
    if (!(0, $fEdhd.isMosaicTrafficLightSwitch)(chkObj.coreTrafficLightSwitch)) return false;
    if (!(0, $6g7gz.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    if (chkObj.trafficLightOverrideReason !== undefined && !$327b7792d9a42c63$export$bc294b7706d86ce(chkObj.trafficLightOverrideReason)) return false;
    if (typeof chkObj.additionalInformation !== "string") return false;
    if (typeof chkObj.type !== "string") return false;
    if (typeof chkObj.domain !== "string") return false;
    if (chkObj.releaseDate !== undefined && typeof chkObj.releaseDate !== "string") return false;
    if (chkObj.decommissionDate !== undefined && typeof chkObj.decommissionDate !== "string") return false;
    if (typeof chkObj.releaseStatus !== "string") return false;
    if (!Array.isArray(chkObj.relationships) || !chkObj.relationships.every($327b7792d9a42c63$export$6036fa85d2283ca1)) return false;
    if (typeof chkObj.isBackupVersion !== "boolean") return false;
    if (!Array.isArray(chkObj.hierarchyLinks) || !chkObj.hierarchyLinks.every($327b7792d9a42c63$export$492be82763901ee5)) return false;
    if (typeof chkObj.lastUpdatedFromHistory !== "string") return false;
    if (chkObj.tlfTags !== undefined && (!Array.isArray(chkObj.tlfTags) || !chkObj.tlfTags.every($327b7792d9a42c63$export$c8a4d7e3d2c1d67c))) return false;
    if (chkObj.variantUsed !== undefined && typeof chkObj.variantUsed !== "string") return false;
    if (chkObj.variantTemplates !== undefined && (!Array.isArray(chkObj.variantTemplates) || chkObj.variantTemplates.some((variant)=>!(0, $38JdT.isVariantTemplate)(variant)))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("lVuyg", function(module, exports) {

$parcel$export(module.exports, "isTlfLinkLocation", function () { return $616d5d9d290b427b$export$5619526cd33ee992; });
parcelRequire("6jtLO");
var $12Lyj = parcelRequire("12Lyj");

var $4lHS7 = parcelRequire("4lHS7");
const $616d5d9d290b427b$export$5619526cd33ee992 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return(// Check properties types
    typeof obj.linkHierarchyName === "string" && Object.values((0, $4lHS7.eHierarchyLevel)).includes(obj.linkLevel) && // Check enums
    typeof obj.linkHierarchyId === "string" && typeof obj.linkLevel === "string" && obj.linkLevel in (0, $4lHS7.eHierarchyLevel));
};

});




parcelRegister("kP8DJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f28f45c5b7f0f579$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");
parcelRequire("ai3tA");
var $iq7Zt = parcelRequire("iq7Zt");

var $i1VQA = parcelRequire("i1VQA");

var $dz672 = parcelRequire("dz672");

var $iI8gf = parcelRequire("iI8gf");

var $72Z5j = parcelRequire("72Z5j");

var $bE9uK = parcelRequire("bE9uK");

var $lOUau = parcelRequire("lOUau");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $f28f45c5b7f0f579$var$Alert = /*#__PURE__*/ $spJKX.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $bE9uK.default), ...props } = (0, $iq7Zt.default)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'alert');
    const handleClose = (0, $i1VQA.default)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $bE9uK.default) : transition;
    const alert = /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lOUau.default), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$f28f45c5b7f0f579$var$Alert.displayName = 'Alert';
var $f28f45c5b7f0f579$export$2e2bcd8739ae039 = Object.assign($f28f45c5b7f0f579$var$Alert, {
    Link: (0, $72Z5j.default),
    Heading: (0, $iI8gf.default)
});

});
parcelRegister("iI8gf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9f2be89a79d6c60$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $hQinx = parcelRequire("hQinx");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $d9f2be89a79d6c60$var$DivStyledAsH4 = (0, $hQinx.default)('h4');
$d9f2be89a79d6c60$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $d9f2be89a79d6c60$var$AlertHeading = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $d9f2be89a79d6c60$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$d9f2be89a79d6c60$var$AlertHeading.displayName = 'AlertHeading';
var $d9f2be89a79d6c60$export$2e2bcd8739ae039 = $d9f2be89a79d6c60$var$AlertHeading;

});

parcelRegister("72Z5j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52181a74cf3d30cd$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $5aXWW = parcelRequire("5aXWW");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $52181a74cf3d30cd$var$AlertLink = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $5aXWW.default), ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$52181a74cf3d30cd$var$AlertLink.displayName = 'AlertLink';
var $52181a74cf3d30cd$export$2e2bcd8739ae039 = $52181a74cf3d30cd$var$AlertLink;

});


parcelRegister("faZLv", function(module, exports) {

$parcel$export(module.exports, "AnnotationActionButtons", function () { return $14638ee6cb2d770f$export$622a0c576a88d8fd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
const $14638ee6cb2d770f$export$622a0c576a88d8fd = ({ isUnchanged: isUnchanged, isFormValid: isFormValid, isClinicalLibraryAvailable: isClinicalLibraryAvailable, disabled: disabled = false, onReset: onReset, onCancel: onCancel, onSave: onSave, isPending: isPending })=>{
    const saveButtonText = "Save";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex justify-content-between w-100 mt-2 pt-2 border-top",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                    id: "annotation-reset-button",
                    variant: "outline-secondary",
                    className: "me-2",
                    onClick: onReset,
                    disabled: disabled || isUnchanged,
                    size: "sm",
                    children: "Reset"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: "annotation-cancel-button",
                        variant: "secondary",
                        className: "me-2",
                        onClick: onCancel,
                        size: "sm",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: "annotation-save-button",
                        variant: "primary",
                        onClick: onSave,
                        disabled: disabled || !isFormValid || !isClinicalLibraryAvailable || isUnchanged || isPending,
                        size: "sm",
                        requestStatus: isPending ? {
                            requesting: true,
                            error: false
                        } : undefined,
                        pauseCoverText: "Saving...",
                        children: saveButtonText
                    })
                ]
            })
        ]
    });
};
$14638ee6cb2d770f$export$622a0c576a88d8fd.displayName = "AnnotationActionButtons";

});

parcelRegister("aZmF8", function(module, exports) {

$parcel$export(module.exports, "AnnotationNavigationHeader", function () { return $367dd3bcda051f4c$export$268e1f64317e140; });

var $bR5nk = parcelRequire("bR5nk");

var $7Fip9 = parcelRequire("7Fip9");
const $367dd3bcda051f4c$export$268e1f64317e140 = ({ currentClauseIndex: currentClauseIndex, totalClauseCount: totalClauseCount, canRemoveClause: canRemoveClause, canAddNewClause: canAddNewClause, disabled: disabled = false, onPrevious: onPrevious, onNext: onNext, onRemove: onRemove, onAdd: onAdd })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex justify-content-between align-items-center mb-3",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("strong", {
                    children: [
                        "Annotation ",
                        currentClauseIndex + 1,
                        " of ",
                        totalClauseCount
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7Fip9.AnnotationNavigationButtons), {
                currentClauseIndex: currentClauseIndex,
                totalClauseCount: totalClauseCount,
                canRemoveClause: canRemoveClause,
                canAddNewClause: canAddNewClause,
                disabled: disabled,
                onPrevious: onPrevious,
                onNext: onNext,
                onRemove: onRemove,
                onAdd: onAdd
            })
        ]
    });
};
$367dd3bcda051f4c$export$268e1f64317e140.displayName = "AnnotationNavigationHeader";

});
parcelRegister("7Fip9", function(module, exports) {

$parcel$export(module.exports, "AnnotationNavigationButtons", function () { return $e773b82528cfc5d6$export$968ba00b62ff271d; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $02Kog = parcelRequire("02Kog");
var $2d6Pt = parcelRequire("2d6Pt");
var $3FPRy = parcelRequire("3FPRy");
const $e773b82528cfc5d6$export$968ba00b62ff271d = ({ currentClauseIndex: currentClauseIndex, totalClauseCount: totalClauseCount, canRemoveClause: canRemoveClause, canAddNewClause: canAddNewClause, disabled: disabled = false, onPrevious: onPrevious, onNext: onNext, onRemove: onRemove, onAdd: onAdd })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                id: "annotation-prev-clause",
                variant: "outline-secondary",
                className: "me-2",
                onClick: onPrevious,
                disabled: disabled || currentClauseIndex === 0,
                size: "sm",
                title: "Previous clause",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $02Kog.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                id: "annotation-next-clause",
                variant: "outline-secondary",
                className: "me-2",
                onClick: onNext,
                disabled: disabled || currentClauseIndex >= totalClauseCount - 1,
                size: "sm",
                title: "Next clause",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                id: "annotation-remove-clause",
                variant: "outline-danger",
                className: "me-2",
                onClick: onRemove,
                disabled: disabled || !canRemoveClause,
                size: "sm",
                title: "Remove current clause",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3FPRy.default), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                id: "annotation-add-clause",
                variant: "primary",
                onClick: ()=>onAdd("AND"),
                disabled: disabled || !canAddNewClause,
                size: "sm",
                title: canAddNewClause ? "Add new clause" : "Complete current clause first",
                children: "AND"
            })
        ]
    });
};
$e773b82528cfc5d6$export$968ba00b62ff271d.displayName = "AnnotationNavigationButtons";

});
parcelRegister("3FPRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2acd6e4d39754876$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $2acd6e4d39754876$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $2acd6e4d39754876$var$_extends() {
    return $2acd6e4d39754876$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2acd6e4d39754876$var$_extends.apply(null, arguments);
}
function $2acd6e4d39754876$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $2acd6e4d39754876$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $2acd6e4d39754876$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $2acd6e4d39754876$var$Trash = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $2acd6e4d39754876$var$_objectWithoutProperties(_ref, $2acd6e4d39754876$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $2acd6e4d39754876$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"
    }));
});
$2acd6e4d39754876$var$Trash.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $2acd6e4d39754876$export$2e2bcd8739ae039 = $2acd6e4d39754876$var$Trash;

});



parcelRegister("dcaxa", function(module, exports) {

$parcel$export(module.exports, "AnnotationNotesField", function () { return $3af8d73ec66e15cb$export$b445cc7ea75978cd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $kUTy1 = parcelRequire("kUTy1");
const $3af8d73ec66e15cb$export$b445cc7ea75978cd = ({ value: value, onChange: onChange, disabled: disabled = false })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
        id: "notes-textarea",
        label: "Additional notes",
        labelWidth: "auto",
        maxWidthCols: 12,
        value: value,
        setValue: onChange,
        type: "textarea",
        rows: 2,
        placeholder: "Enter any additional notes or context for this annotation...",
        disabled: disabled
    });
};
$3af8d73ec66e15cb$export$b445cc7ea75978cd.displayName = "AnnotationNotesField";

});

parcelRegister("eKE9M", function(module, exports) {

$parcel$export(module.exports, "AnnotationPreview", function () { return $c36157217e8093bc$export$e34b0d3474931596; });

var $bR5nk = parcelRequire("bR5nk");

var $kP8DJ = parcelRequire("kP8DJ");
const $c36157217e8093bc$export$e34b0d3474931596 = ({ previewText: previewText })=>{
    const isEmpty = !previewText || previewText === "No annotation clauses configured";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h6", {
                className: "mb-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("strong", {
                    children: "Annotation Preview"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                variant: isEmpty ? "light" : "info",
                className: "mb-3",
                children: isEmpty ? /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                    className: "text-muted",
                    children: "Complete the annotation expression to see preview"
                }) : previewText
            })
        ]
    });
};
$c36157217e8093bc$export$e34b0d3474931596.displayName = "AnnotationPreview";

});

parcelRegister("8nKxe", function(module, exports) {

$parcel$export(module.exports, "CompanionVariableControl", function () { return $df2589490e7c713b$export$2537be9a62cfd173; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $laHpz = parcelRequire("laHpz");
var $3d5lD = parcelRequire("3d5lD");

var $eZYX7 = parcelRequire("eZYX7");

var $kOFwX = parcelRequire("kOFwX");
const $df2589490e7c713b$export$2537be9a62cfd173 = ({ datasets: datasets, primaryDataset: primaryDataset, companionVariables: companionVariables, onChange: onChange, disabled: disabled = false })=>{
    const hasPrimaryVariable = Boolean(primaryDataset);
    /**
   * Get variables available for companion selection (from primary dataset only)
   */ const dataset = datasets.find((ds)=>ds.name === primaryDataset);
    const variableOptions = dataset ? dataset.clinicalVariables.map((v)=>({
            value: `${primaryDataset}.${v.name}`
        })) : [
        {
            value: "No variables available"
        }
    ];
    /**
   * Get available companion types (exclude already used types)
   *
   * @param currentType - The current type of the companion being edited, excluded from used types to allow re-selection
   */ const getAvailableTypes = (currentType)=>{
        const allTypes = [
            "Order",
            "Label",
            "Unit"
        ];
        const usedTypes = companionVariables.map((c)=>c.type).filter((t)=>t !== currentType);
        return allTypes.filter((t)=>!usedTypes.includes(t));
    };
    /**
   * Handler for adding a new companion variable
   */ const handleAdd = ()=>{
        const availableTypes = getAvailableTypes();
        onChange({
            companionVariables: [
                ...companionVariables,
                {
                    variable: "",
                    type: availableTypes[0]
                }
            ]
        });
    };
    /**
   * Removes a companion variable from the list based on its type.
   *
   * @param type - Companion type to remove (Order, Label, or Unit)
   */ const handleRemove = (type)=>{
        onChange({
            companionVariables: companionVariables.filter((c)=>c.type !== type)
        });
    };
    /**
   * Updates the selected variable for a specific companion type.
   * Ignores placeholder values and updates only the matching companion.
   *
   * @param type - Companion type whose variable selection is being changed
   * @param value - New variable name in format "dataset.variableName"
   */ const handleVariableChange = (type, value)=>{
        if (value === "No variables available") return;
        onChange({
            companionVariables: companionVariables.map((c)=>c.type === type ? {
                    ...c,
                    variable: value
                } : c)
        });
    };
    /**
   * Changes a companion's type while preserving its variable selection.
   * Used when user selects a different type from the dropdown.
   *
   * @param oldType - Current type of the companion being modified
   * @param newType - New type to assign to the companion
   */ const handleTypeChange = (oldType, newType)=>{
        onChange({
            companionVariables: companionVariables.map((c)=>c.type === oldType ? {
                    ...c,
                    type: newType
                } : c)
        });
    };
    /**
   * Retrieves the selected variable name for a specific companion type.
   *
   * @param type - Companion type to look up
   * @returns Selected variable name for the companion, or empty string if not found
   */ const getVariableValue = (type)=>{
        return companionVariables.find((c)=>c.type === type)?.variable ?? // istanbul ignore next -- Default only hit if companion not in array (impossible in practice)
        "";
    };
    /**
   * Handles reordering companions via drag and drop.
   * Updates the companions array to reflect the new order.
   *
   * @param event - Drag end event containing active and target items
   */ const handleDragEnd = (event)=>{
        const { active: active, over: over } = event;
        /* istanbul ignore next -- Defensive check: over is always set by the mock in tests */ if (!over || active.id === over.id) return;
        const oldIndex = companionVariables.findIndex((c)=>c.type === active.id);
        const newIndex = companionVariables.findIndex((c)=>c.type === over.id);
        /* istanbul ignore next -- Defensive check: IDs are always valid companion types in practice */ if (oldIndex === -1 || newIndex === -1) return;
        const newCompanions = [
            ...companionVariables
        ];
        const [removed] = newCompanions.splice(oldIndex, 1);
        newCompanions.splice(newIndex, 0, removed);
        onChange({
            companionVariables: newCompanions
        });
    };
    // Check if all existing companions have variables selected
    const allCompanionsHaveVariables = companionVariables.every((c)=>c.variable !== "");
    const canAddMore = companionVariables.length < 2 && hasPrimaryVariable && allCompanionsHaveVariables && !disabled;
    const canMove = companionVariables.length > 1 && !disabled;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            companionVariables.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Label, {
                className: "mb-2",
                children: [
                    "Companion Variable",
                    companionVariables.length > 1 ? "s" : ""
                ]
            }),
            companionVariables.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3d5lD.SortableListHolder), {
                canMove: canMove,
                handleDragEnd: handleDragEnd,
                showBorder: false,
                items: companionVariables.map((companion, index)=>({
                        id: companion.type,
                        element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kOFwX.CompanionRow), {
                            type: companion.type,
                            index: index,
                            variableOptions: variableOptions,
                            getVariableValue: getVariableValue,
                            getAvailableTypes: getAvailableTypes,
                            handleVariableChange: handleVariableChange,
                            handleTypeChange: handleTypeChange,
                            handleRemove: handleRemove,
                            disabled: disabled
                        })
                    }))
            }),
            companionVariables.length < 2 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $laHpz.AddLinkButton), {
                label: "Companion Variable",
                onClick: handleAdd,
                disabled: !canAddMore
            })
        ]
    });
};
$df2589490e7c713b$export$2537be9a62cfd173.displayName = "CompanionVariableControl";

});
parcelRegister("kOFwX", function(module, exports) {

$parcel$export(module.exports, "CompanionRow", function () { return $08e3e178fe4c80b6$export$ab591e56aff52091; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $aUt9N = parcelRequire("aUt9N");
var $8Uc5S = parcelRequire("8Uc5S");

var $c28Y1 = parcelRequire("c28Y1");
var $iOTZL = parcelRequire("iOTZL");
var $31g00 = parcelRequire("31g00");

var $av9bi = parcelRequire("av9bi");
const $08e3e178fe4c80b6$export$ab591e56aff52091 = ({ type: type, index: index, variableOptions: variableOptions, getVariableValue: getVariableValue, getAvailableTypes: getAvailableTypes, handleVariableChange: handleVariableChange, handleTypeChange: handleTypeChange, handleRemove: handleRemove, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
        className: "mb-2",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                sm: 6,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Uc5S.ControlTypeAhead), {
                    id: `companion-variable-${index}`,
                    label: "",
                    labelWidth: 0,
                    value: getVariableValue(type),
                    setValue: (value)=>handleVariableChange(type, value),
                    maxWidthCols: 12,
                    availableList: variableOptions,
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                sm: 5,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    id: `companion-type-${index}`,
                    label: `Companion ${index + 1} type`,
                    labelWidth: 0,
                    maxWidthCols: 12,
                    value: type,
                    options: getAvailableTypes(type),
                    setValue: (value)=>handleTypeChange(type, value),
                    disabled: disabled
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                sm: 1,
                className: "d-flex justify-content-center align-items-start",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                    variant: "link",
                    className: "p-0 text-danger",
                    style: {
                        paddingTop: "0.15rem"
                    },
                    onClick: ()=>handleRemove(type),
                    disabled: disabled,
                    "aria-label": `Remove companion ${index + 1}`,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
                        size: 20
                    })
                })
            })
        ]
    });
};
$08e3e178fe4c80b6$export$ab591e56aff52091.displayName = "CompanionRow";

});


parcelRegister("hE0Dg", function(module, exports) {

$parcel$export(module.exports, "getContextDisplayText", function () { return $b71f9e0ced55ad9c$export$4cd279dff103abad; });
parcelRequire("6jtLO");
var $9B5Sg = parcelRequire("9B5Sg");
const $b71f9e0ced55ad9c$export$4cd279dff103abad = (location)=>{
    if (!location) return "";
    switch(location.position){
        case (0, $9B5Sg.AitTablePosition).table:
            return "";
        case (0, $9B5Sg.AitTablePosition).column:
            return `at column-${location.originalColumn + 1}`;
        case (0, $9B5Sg.AitTablePosition).headerRow:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $9B5Sg.AitTablePosition).headerCell:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $9B5Sg.AitTablePosition).bodyRowGroup:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1}`;
        case (0, $9B5Sg.AitTablePosition).bodyRow:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        case (0, $9B5Sg.AitTablePosition).bodyCell:
            return `at ${location.tableSection}-rowgroup-${location.rowGroup + 1} row-${location.row + 1}`;
        default:
            return "";
    }
};

});

parcelRegister("5qQ7a", function(module, exports) {

$parcel$export(module.exports, "PrimaryVariableSelector", function () { return $06ddc4e28a98fec6$export$e0073dc7cfd64d35; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $8Uc5S = parcelRequire("8Uc5S");
const $06ddc4e28a98fec6$export$e0073dc7cfd64d35 = ({ datasets: datasets, selectedValue: selectedValue, onChange: onChange, disabled: disabled = false })=>{
    /**
   * Generate list of all variables in "dataset.variable" format
   */ const options = datasets.flatMap((ds)=>{
        const vars = ds.clinicalVariables.map((v)=>v.name);
        return vars.map((v)=>({
                value: `${ds.name}.${v}`
            }));
    });
    const variableOptions = options.length > 0 ? options : [
        {
            value: "No variables available"
        }
    ];
    /**
   * Handler for primary variable selection
   *
   * @param value - Selected variable value in "dataset.variable" format
   */ const handleChange = (value)=>{
        if (value !== "No variables available") onChange(value);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Uc5S.ControlTypeAhead), {
        id: "primary-variable-select",
        label: "Primary Variable",
        labelWidth: 3,
        value: selectedValue,
        setValue: handleChange,
        maxWidthCols: 12,
        availableList: variableOptions,
        disabled: disabled
    });
};
$06ddc4e28a98fec6$export$e0073dc7cfd64d35.displayName = "PrimaryVariableSelector";

});

parcelRegister("2cGNP", function(module, exports) {

$parcel$export(module.exports, "TerminologySelector", function () { return $6ccf9f44919c96c6$export$20cdecc32a0af66c; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $kUTy1 = parcelRequire("kUTy1");
var $aUt9N = parcelRequire("aUt9N");
var $fVo1v = parcelRequire("fVo1v");

var $spJKX = parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");
const $6ccf9f44919c96c6$export$20cdecc32a0af66c = ({ formState: formState, codeLists: codeLists, comparatorTypes: comparatorTypes, updateFormField: updateFormField, disabled: disabled = false })=>{
    const codes = (0, $spJKX.useMemo)(()=>{
        if (!formState.selectedTerminology) return [];
        const codeList = codeLists.find((cl)=>cl.name === formState.selectedTerminology);
        return codeList?.clinicalCodes ?? [];
    }, [
        codeLists,
        formState.selectedTerminology
    ]);
    const termOptions = (0, $spJKX.useMemo)(()=>{
        const mappedCodeList = formState.selectedVariable?.clinicalCodeListId ? codeLists.find((cl)=>cl.id === formState.selectedVariable.clinicalCodeListId) : undefined;
        if (!mappedCodeList) return [];
        return [
            {
                value: "",
                label: "Select term..."
            },
            ...codes.map((code)=>({
                    value: code.codedValue,
                    label: `${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}`
                }))
        ];
    }, [
        formState.selectedVariable,
        codeLists,
        codes
    ]);
    const handleComparatorChange = (0, $spJKX.useCallback)((comparatorName)=>{
        updateFormField("comparator", comparatorName);
    }, [
        updateFormField
    ]);
    const handleTermChange = (0, $spJKX.useCallback)((codedValue)=>{
        updateFormField("value", codedValue);
    }, [
        updateFormField
    ]);
    const handleValueEntry = (0, $spJKX.useCallback)((value)=>{
        updateFormField("value", value);
    }, [
        updateFormField
    ]);
    const handleGroupValueChange = (0, $spJKX.useCallback)((selectedValues)=>{
        const codedValues = selectedValues.map((displayValue)=>{
            const matchingCode = codes.find((code)=>`${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}` === displayValue);
            // istanbul ignore next
            return matchingCode?.codedValue ?? displayValue;
        }).filter((v)=>v !== "");
        updateFormField("value", codedValues.join("\n"));
    }, [
        updateFormField,
        codes
    ]);
    const handleGroupTextEntry = (0, $spJKX.useCallback)((value)=>{
        updateFormField("value", value);
    }, [
        updateFormField
    ]);
    const comparatorOptions = comparatorTypes.map((comparator)=>({
            value: comparator.name,
            label: comparator.denotation
        }));
    const selectedComparatorType = comparatorTypes.find((c)=>c.name === formState.comparator);
    const rhsType = selectedComparatorType?.rhsType ?? "None";
    const currentGroupValues = (0, $spJKX.useMemo)(()=>{
        if (rhsType !== "Group" || !formState.value) return [];
        const storedValues = formState.value.split("\n").map((v)=>v.trim()).filter((v)=>v !== "");
        return storedValues.map((codedValue)=>{
            const code = codes.find((c)=>c.codedValue === codedValue);
            return code ? `${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}` : codedValue;
        });
    }, [
        rhsType,
        formState.value,
        codes
    ]);
    const groupTermOptions = (0, $spJKX.useMemo)(()=>{
        return codes.map((code)=>`${code.codedValue} - ${code.decodeTranslatedText ?? "No description"}`);
    }, [
        codes
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                id: "comparator-select",
                label: "Comparator",
                labelWidth: 3,
                value: formState.comparator ?? "",
                disabled: disabled || !formState.selectedVariable,
                options: [
                    {
                        value: "",
                        label: "None"
                    },
                    ...comparatorOptions
                ],
                setValue: handleComparatorChange
            }),
            formState.selectedTerminology && formState.comparator && rhsType !== "None" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                id: "mapped-code-list",
                label: "Terminology",
                labelWidth: 3,
                value: `${formState.selectedTerminology}`,
                disabled: disabled
            }),
            formState.comparator && rhsType !== "None" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                children: rhsType === "Group" ? formState.selectedTerminology ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                    className: "row mb-2",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                            column: true,
                            sm: 3,
                            htmlFor: "group-value-tags",
                            children: "Values"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "col-sm-9",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fVo1v.ControlTags), {
                                availableOptions: groupTermOptions,
                                selectedTags: currentGroupValues,
                                onSelectionChange: handleGroupValueChange,
                                placeholder: "Select values...",
                                disabled: disabled || !formState.selectedTerminology
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                    id: "group-value-textarea",
                    label: "Values",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    setValue: handleGroupTextEntry,
                    type: "textarea",
                    rows: 4,
                    allowCarriageReturn: true,
                    disabled: disabled || !formState.selectedVariable,
                    subText: "Enter each value on a new line (press Enter between values)"
                }) : formState.selectedTerminology ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    id: "term-select",
                    label: "Value",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    disabled: disabled || !formState.selectedTerminology,
                    options: termOptions,
                    setValue: handleTermChange
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                    id: "value-text",
                    label: "Value",
                    labelWidth: 3,
                    value: formState.value ?? "",
                    setValue: handleValueEntry,
                    disabled: disabled || !formState.selectedVariable
                })
            })
        ]
    });
};
$6ccf9f44919c96c6$export$20cdecc32a0af66c.displayName = "TerminologySelector";

});

parcelRegister("aITpv", function(module, exports) {

$parcel$export(module.exports, "updateTableDataWithAnnotations", function () { return $d014ed203e3be585$export$77f22004624c7b1c; });
parcelRequire("6jtLO");
var $9B5Sg = parcelRequire("9B5Sg");
const $d014ed203e3be585$export$77f22004624c7b1c = (tableData, location, annotation)=>{
    switch(location.position){
        case (0, $9B5Sg.AitTablePosition).table:
            // Update the global annotation for the entire table
            return {
                ...tableData,
                tableAnnotation: annotation
            };
        case (0, $9B5Sg.AitTablePosition).header:
            // Update the column annotation in the headerData
            if (tableData.headerData) return {
                ...tableData,
                headerData: {
                    ...tableData.headerData,
                    annotation: annotation
                }
            };
            return tableData;
        case (0, $9B5Sg.AitTablePosition).headerRow:
            // Update the annotation for a specific header row
            if (tableData.headerData) return {
                ...tableData,
                headerData: {
                    ...tableData.headerData,
                    rows: tableData.headerData.rows.map((row)=>row.aitid === location.rowId ? {
                            ...row,
                            annotation: annotation
                        } : row)
                }
            };
            return tableData;
        case (0, $9B5Sg.AitTablePosition).column:
            if (location.columnId) {
                const columnId = location.columnId;
                const originalColumnIndex = location.originalColumn;
                // Handle annotation removal
                if (!annotation) {
                    const updatedColumnInformation = tableData.columnInformation.map((ca)=>ca.columnId === columnId ? {
                            ...ca,
                            annotation: undefined
                        } : ca);
                    return {
                        ...tableData,
                        columnInformation: updatedColumnInformation
                    };
                }
                // Handle annotation addition/update
                const currentIdx = tableData.columnInformation.findIndex((ca)=>ca.columnId === columnId);
                const newColumnInfo = {
                    columnId: columnId,
                    originalColumnIndex: originalColumnIndex,
                    annotation: annotation
                };
                // istanbul ignore next - Defensive fallback: columnInformation ?? [] is unreachable since line 77 would have thrown if undefined
                const updatedColumnInformation = currentIdx >= 0 ? tableData.columnInformation.map((ca, idx)=>idx === currentIdx ? newColumnInfo : ca) : [
                    ...tableData.columnInformation ?? [],
                    newColumnInfo
                ];
                return {
                    ...tableData,
                    columnInformation: updatedColumnInformation
                };
            }
            return tableData;
        case (0, $9B5Sg.AitTablePosition).bodyRowGroup:
            // Update the annotation for a specific body row group
            return {
                ...tableData,
                bodyData: tableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                        ...rowGroup,
                        annotation: annotation
                    } : rowGroup)
            };
        case (0, $9B5Sg.AitTablePosition).bodyRow:
            // Update the annotation for a specific body row
            return {
                ...tableData,
                bodyData: tableData.bodyData.map((rowGroup)=>rowGroup.aitid === location.rowGroupId ? {
                        ...rowGroup,
                        rows: rowGroup.rows.map((row)=>row.aitid === location.rowId ? {
                                ...row,
                                annotation: annotation
                            } : row)
                    } : rowGroup)
            };
        default:
            return tableData;
    }
};

});

parcelRegister("hVLQ5", function(module, exports) {

$parcel$export(module.exports, "useAnnotationContextWindow", function () { return $9e909f07c4fc58af$export$fedc436bbf7436e4; });

var $3tNrK = parcelRequire("3tNrK");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $f3i0T = parcelRequire("f3i0T");

var $6FNAc = parcelRequire("6FNAc");
const $9e909f07c4fc58af$export$fedc436bbf7436e4 = ({ annotationLocation: annotationLocation, annotationType: annotationType, clinicalLibrary: clinicalLibrary, initialAnnotation: initialAnnotation })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const comparatorTypes = appSettings.annotationComparatorTypes;
    // #region Base Data
    const datasets = (0, $spJKX.useMemo)(()=>clinicalLibrary?.clinicalDatasets ?? [], [
        clinicalLibrary
    ]);
    const codeLists = (0, $spJKX.useMemo)(()=>clinicalLibrary?.clinicalCodeLists ?? [], [
        clinicalLibrary
    ]);
    // #endregion
    // #region Utility Functions
    /**
   * Find a dataset by name from the available datasets.
   *
   * @param name - Name of the dataset to search for
   * @returns Dataset if found, undefined otherwise
   */ const findDatasetByName = (0, $spJKX.useCallback)((name)=>datasets.find((d)=>d.name === name), [
        datasets
    ]);
    /**
   * Creates baseline form state and clauses from an annotation.
   * Used for initializing and restoring annotation data.
   *
   * @param annotation - Annotation to extract state from
   * @returns Object containing form state and clauses
   */ const createBaselineStateAndClauses = (0, $spJKX.useCallback)((annotation)=>{
        const firstClause = annotation.clauses[0];
        if (!firstClause) return {
            formState: {
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: annotation.additionalNotes ?? "",
                companionVariables: []
            },
            clauses: []
        };
        const dataset = findDatasetByName(firstClause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === firstClause?.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        return {
            formState: {
                selectedDataset: dataset?.name ?? "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? "",
                value: firstClause?.right ?? "",
                comparator: firstClause?.comparator,
                additionalNotes: annotation.additionalNotes ?? "",
                companionVariables: firstClause.left.companionVariables ?? []
            },
            clauses: annotation.clauses
        };
    }, [
        findDatasetByName,
        codeLists
    ]);
    /**
   * Creates a VariableDto from a clinical variable and dataset name.
   *
   * @param variable - Clinical variable to convert
   * @param datasetName - Name of the Dataset containing the variable
   * @returns VariableDto with mapped properties
   */ const createVariableDto = (variable, datasetName)=>({
            nameVariable: variable.name,
            dataset: datasetName
        });
    /**
   * Creates an empty where clause with default values.
   *
   * @returns New WhereClauseOp with empty values and unique ID
   */ const createEmptyClause = ()=>({
            id: crypto.randomUUID(),
            left: {
                nameVariable: "",
                dataset: ""
            },
            comparator: undefined,
            right: ""
        });
    // #endregion
    // #region State Management
    const [whereClauses, setWhereClauses] = (0, $spJKX.useState)(()=>{
        if (initialAnnotation) return createBaselineStateAndClauses(initialAnnotation).clauses;
        return [];
    });
    const [currentClauseIndex, setCurrentClauseIndex] = (0, $spJKX.useState)(0);
    const [formState, setFormState] = (0, $spJKX.useState)(()=>{
        if (initialAnnotation) return createBaselineStateAndClauses(initialAnnotation).formState;
        return {
            selectedDataset: "",
            selectedVariable: undefined,
            selectedTerminology: "",
            value: "",
            comparator: undefined,
            additionalNotes: "",
            companionVariables: []
        };
    });
    // Track previous values to detect changes
    const prevInitialAnnotationRef = (0, $spJKX.useRef)(initialAnnotation);
    const prevDatasetsLengthRef = (0, $spJKX.useRef)(datasets.length);
    /**
   * Effect event for updating form state from annotation.
   */ const updateFormFromAnnotation = (0, $spJKX.useEffectEvent)(()=>{
        if (initialAnnotation) {
            const { formState: newFormState, clauses: clauses } = createBaselineStateAndClauses(initialAnnotation);
            setFormState(newFormState);
            setWhereClauses(clauses);
            setCurrentClauseIndex(0);
        } else {
            setFormState({
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: "",
                companionVariables: []
            });
            setWhereClauses([]);
            setCurrentClauseIndex(0);
        }
    });
    /**
   * Sync state when initialAnnotation changes or when clinical library loads.
   * This ensures the form displays the correct values when reopening with a saved annotation,
   * and also handles the case where the clinical library loads lazily after the component mounts.
   */ (0, $spJKX.useEffect)(()=>{
        const annotationChanged = !(0, $eBlbF.isEqual)(prevInitialAnnotationRef.current, initialAnnotation);
        const clinicalLibraryLoaded = prevDatasetsLengthRef.current === 0 && datasets.length > 0 && initialAnnotation;
        // Update if annotation changed OR if clinical library just loaded while we have an annotation
        if (annotationChanged || clinicalLibraryLoaded) {
            prevInitialAnnotationRef.current = initialAnnotation;
            prevDatasetsLengthRef.current = datasets.length;
            updateFormFromAnnotation();
        }
    }, [
        initialAnnotation,
        datasets
    ]);
    // #endregion
    // #region Additional Utility Functions
    /**
   * Creates a where clause from form state and variable data.
   *
   * @param variable - Clinical variable for the clause
   * @param datasetName - Name of the Dataset containing the variable
   * @param existingId - Optional ID to preserve when updating
   * @param precedingLogic - Optional logical operator for multi-clause groups
   * @returns New WhereClauseOp with form state data
   */ const createWhereClause = (variable, datasetName, existingId, precedingLogic)=>{
        const baseDto = createVariableDto(variable, datasetName);
        const left = {
            ...baseDto,
            ...formState.companionVariables.length > 0 && {
                companionVariables: formState.companionVariables
            }
        };
        return {
            id: existingId ?? crypto.randomUUID(),
            left: left,
            comparator: formState.comparator,
            right: formState.value,
            precedingLogic: precedingLogic
        };
    };
    /**
   * Helper to build the current annotation object from form and clause state.
   * Used for isUnchanged and buildFinalAnnotation.
   * Removes precedingLogic from the first clause, preserves for others.
   *
   * @returns Current annotation object or undefined if no valid clauses
   */ const getCurrentAnnotationObject = ()=>{
        const allClauses = [
            ...whereClauses
        ];
        if (formState.selectedDataset && formState.selectedVariable) {
            const currentWhereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, whereClauses[currentClauseIndex]?.id, whereClauses[currentClauseIndex]?.precedingLogic);
            allClauses[currentClauseIndex] = currentWhereClause;
        }
        const validClauses = allClauses.filter((clause)=>(0, $6FNAc.validateWhereClause)(clause, comparatorTypes));
        if (validClauses.length === 0) return undefined;
        const clausesWithCorrectLogic = validClauses.map((clause, index)=>{
            if (index === 0) {
                const { precedingLogic: _precedingLogic, ...clauseWithoutLogic } = clause;
                return clauseWithoutLogic;
            } else return clause;
        });
        return {
            id: initialAnnotation?.id ?? crypto.randomUUID(),
            clauses: clausesWithCorrectLogic,
            additionalNotes: formState.additionalNotes
        };
    };
    // #endregion
    // #region Derived Data
    const availableVariables = (0, $spJKX.useMemo)(()=>formState.selectedDataset ? findDatasetByName(formState.selectedDataset)?.clinicalVariables ?? [] : [], [
        formState.selectedDataset,
        findDatasetByName
    ]);
    const datasetOptions = (0, $spJKX.useMemo)(()=>datasets.map((dataset)=>({
                name: dataset.name
            })), [
        datasets
    ]);
    const variableOptions = (0, $spJKX.useMemo)(()=>availableVariables.map((variable)=>({
                displayValue: `${variable.name} - ${variable.dataType}`,
                name: variable.name
            })), [
        availableVariables
    ]);
    // #endregion
    // #region Form Management
    /**
   * Resets the form to empty state and clears all clauses.
   * Should be called when closing or canceling the modal.
   */ const resetForm = ()=>{
        setFormState({
            selectedDataset: "",
            selectedVariable: undefined,
            selectedTerminology: "",
            value: "",
            comparator: undefined,
            additionalNotes: "",
            companionVariables: []
        });
        setWhereClauses([]);
        setCurrentClauseIndex(0);
    };
    /**
   * Creates baseline form state and clauses from an annotation using current datasets and codeLists.
   * Used for initializing and restoring annotation data with up-to-date clinical library data.
   *
   * @param annotation - The annotation to extract state from
   * @returns Object containing form state and clauses
   */ const getBaselineStateAndClauses = (annotation)=>{
        const firstClause = annotation.clauses[0];
        if (!firstClause) return {
            formState: {
                selectedDataset: "",
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                comparator: undefined,
                additionalNotes: annotation.additionalNotes ?? /* istanbul ignore next */ "",
                companionVariables: []
            },
            clauses: []
        };
        const dataset = datasets.find((d)=>d.name === firstClause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === firstClause?.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        return {
            formState: {
                selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? /* istanbul ignore next */ "",
                value: firstClause?.right ?? /* istanbul ignore next */ "",
                comparator: firstClause?.comparator,
                additionalNotes: annotation.additionalNotes ?? /* istanbul ignore next */ "",
                companionVariables: firstClause.left.companionVariables ?? []
            },
            clauses: annotation.clauses
        };
    };
    /**
   * Restores the form to the initial annotation state.
   * Should be called when canceling edits to revert to initial values.
   */ const restoreInitial = ()=>{
        if (initialAnnotation) {
            const { formState: initialFormState, clauses: clauses } = getBaselineStateAndClauses(initialAnnotation);
            setFormState(initialFormState);
            setWhereClauses(clauses);
            setCurrentClauseIndex(0);
        } else resetForm();
    };
    // #endregion
    // #region Validation and State Derived Properties
    const isFormValid = (()=>{
        // Check if current unsaved clause is valid (including companion variables check)
        const currentClauseIsValid = (0, $6FNAc.validateWhereClause)({
            selectedDataset: formState.selectedDataset,
            selectedVariable: formState.selectedVariable,
            comparator: formState.comparator,
            value: formState.value,
            companionVariables: formState.companionVariables
        }, comparatorTypes);
        // Check all saved clauses (excluding the current one being edited)
        const savedClausesExcludingCurrent = whereClauses.filter((_, idx)=>idx !== currentClauseIndex);
        const allOtherClausesValid = savedClausesExcludingCurrent.every((clause)=>(0, $6FNAc.validateWhereClause)(clause, comparatorTypes));
        // Allow saving when there's an initial annotation and all clauses have been removed (to enable removing all annotations)
        const canRemoveAllAnnotations = initialAnnotation && whereClauses.length === 0 && !currentClauseIsValid;
        // Form is valid if:
        // 1. All other saved clauses are valid AND current clause is valid, OR
        // 2. We're removing all (existing) annotations
        return !!(allOtherClausesValid && currentClauseIsValid || canRemoveAllAnnotations);
    })();
    const isCurrentClauseValid = (0, $6FNAc.validateWhereClause)({
        selectedDataset: formState.selectedDataset,
        selectedVariable: formState.selectedVariable,
        comparator: formState.comparator,
        value: formState.value,
        companionVariables: formState.companionVariables
    }, comparatorTypes);
    const canAddNewClause = isCurrentClauseValid;
    // #endregion
    // #region Clause Management
    /**
   * Saves the current form state as a where clause in the clauses list.
   * Updates existing clause at current index or creates new one.
   */ const saveCurrentClause = ()=>{
        if (!formState.selectedDataset || !formState.selectedVariable) return;
        const whereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, whereClauses[currentClauseIndex]?.id, whereClauses[currentClauseIndex]?.precedingLogic);
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            updated[currentClauseIndex] = whereClause;
            return updated;
        });
    };
    /**
   * Loads a saved clause into the form for editing.
   *
   * @param clauseIndex - Index of the clause to load
   */ const loadClauseIntoForm = (0, $spJKX.useCallback)((clauseIndex)=>{
        const clause = whereClauses[clauseIndex];
        const dataset = findDatasetByName(clause.left.dataset);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === clause.left.nameVariable);
        const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
        setFormState((prev)=>({
                ...prev,
                selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                selectedVariable: variable,
                selectedTerminology: mappedCodeList?.name ?? /* istanbul ignore next */ "",
                value: clause.right ?? /* istanbul ignore next */ "",
                comparator: clause.comparator,
                companionVariables: clause.left.companionVariables ?? []
            }));
    }, [
        codeLists,
        findDatasetByName,
        whereClauses
    ]);
    /**
   * Navigate to the previous clause, saving the current clause if valid.
   */ const goToPreviousClause = ()=>{
        /* istanbul ignore else */ if (currentClauseIndex > 0) {
            if (isCurrentClauseValid) saveCurrentClause();
            setCurrentClauseIndex(currentClauseIndex - 1);
            loadClauseIntoForm(currentClauseIndex - 1);
        }
    };
    /**
   * Navigate to the next clause, saving the current clause if valid.
   */ const goToNextClause = ()=>{
        /* istanbul ignore else */ if (currentClauseIndex < whereClauses.length - 1) {
            if (isCurrentClauseValid) saveCurrentClause();
            setCurrentClauseIndex(currentClauseIndex + 1);
            loadClauseIntoForm(currentClauseIndex + 1);
        }
    };
    /**
   * Adds a new empty where clause and navigates to it.
   * Saves current clause before adding if it's valid.
   * New clause will have precedingLogic set to the specified logical operator.
   *
   * @param logicalOperator - Logical operator for the new clause (AND/OR)
   */ const addNewWhereClause = (logicalOperator)=>{
        const newClause = createEmptyClause();
        // Set precedingLogic from the button that was clicked
        newClause.precedingLogic = logicalOperator;
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            if (isCurrentClauseValid && formState.selectedDataset && formState.selectedVariable) {
                const whereClause = createWhereClause(formState.selectedVariable, formState.selectedDataset, prev[currentClauseIndex]?.id, prev[currentClauseIndex]?.precedingLogic);
                if (currentClauseIndex >= updated.length) while(updated.length <= currentClauseIndex)updated.push(createEmptyClause());
                updated[currentClauseIndex] = whereClause;
            }
            updated.push(newClause);
            return updated;
        });
        const newIndex = isCurrentClauseValid ? Math.max(whereClauses.length, currentClauseIndex + 1) : whereClauses.length;
        setCurrentClauseIndex(newIndex);
        setFormState((prev)=>({
                ...prev,
                selectedVariable: undefined,
                selectedTerminology: "",
                value: "",
                selectedDataset: "",
                comparator: undefined,
                companionVariables: []
            }));
    };
    /**
   * Remove the current clause and update the active clause index and form state.
   */ const removeCurrentClause = ()=>{
        setWhereClauses((prev)=>{
            const updated = [
                ...prev
            ];
            updated.splice(currentClauseIndex, 1);
            // After removal, if no clauses remain, reset formState
            if (updated.length === 0) {
                setFormState((prevForm)=>({
                        selectedDataset: "",
                        selectedVariable: undefined,
                        selectedTerminology: "",
                        value: "",
                        comparator: undefined,
                        additionalNotes: prevForm.additionalNotes,
                        companionVariables: []
                    }));
                setCurrentClauseIndex(0);
            } else {
                // Otherwise, move to previous clause or first
                const newIndex = Math.min(currentClauseIndex, Math.max(0, updated.length - 1));
                setCurrentClauseIndex(newIndex);
                // Load the clause at the new index
                const clause = updated[newIndex];
                /* istanbul ignore else */ if (clause) {
                    const dataset = findDatasetByName(clause.left.dataset);
                    const variable = dataset?.clinicalVariables.find((v)=>v.name === clause.left.nameVariable);
                    const mappedCodeList = codeLists.find((cl)=>cl.id === variable?.clinicalCodeListId);
                    setFormState((prevForm)=>({
                            ...prevForm,
                            selectedDataset: dataset?.name ?? /* istanbul ignore next */ "",
                            selectedVariable: variable,
                            selectedTerminology: mappedCodeList?.name,
                            value: clause.right,
                            comparator: clause.comparator,
                            companionVariables: clause.left.companionVariables ?? []
                        }));
                }
            }
            return updated;
        });
    };
    /**
   * Determines if the current clause can be removed.
   *
   * @returns True if there are clauses to remove
   */ const canRemoveClause = whereClauses.length > 0;
    /**
   * Calculates total clause count including unsaved current clause.
   *
   * @returns Total number of clauses for display
   */ const totalClauseCount = currentClauseIndex < whereClauses.length ? Math.max(whereClauses.length, 1) : Math.max(whereClauses.length + 1, 1);
    /**
   * Determines if the current state matches the initial annotation.
   * Compares the built annotation from current state with the initial annotation using deep equality.
   *
   * @returns True if no changes have been made
   */ const isUnchanged = (()=>{
        const currentAnnotation = getCurrentAnnotationObject();
        if (initialAnnotation) return (0, $eBlbF.isEqual)(currentAnnotation, initialAnnotation);
        return currentAnnotation === undefined;
    })();
    /**
   * Builds the final annotation object from current state.
   * Returns undefined when all clauses are removed to enable annotation removal.
   * Does not perform any table I/O operations.
   * Ensures first clause has no precedingLogic, subsequent clauses have "AND".
   *
   * @returns Final annotation or undefined if all clauses removed
   */ const buildFinalAnnotation = ()=>{
        saveCurrentClause();
        return getCurrentAnnotationObject();
    };
    // #endregion
    // #region Simplified Field Handlers
    /**
   * Generic handler for form field changes with special case handling.
   * Clears dependent fields when dataset changes.
   *
   * @param field - Name of the field being changed
   * @param value - New value for the field
   */ const handleFieldChange = (field, value)=>{
        if (field === "selectedDataset") setFormState((prev)=>({
                ...prev,
                selectedDataset: value,
                selectedVariable: undefined,
                selectedTerminology: "",
                value: ""
            }));
        else if (field === "selectedVariable") {
            const variable = availableVariables?.find((v)=>v.name === value);
            const codeList = variable?.clinicalCodeListId ? codeLists.find((cl)=>cl.id === variable.clinicalCodeListId) : undefined;
            setFormState((prev)=>({
                    ...prev,
                    selectedVariable: variable,
                    selectedTerminology: codeList?.name ?? "",
                    value: ""
                }));
        } else setFormState((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    /**
   * Sets both dataset and variable fields in a single atomic update.
   * Used when selecting from "dataset.variable" format to avoid state update race conditions.
   *
   * @param datasetName - Name of the clinical dataset to select
   * @param variableName - Name of the clinical variable within the dataset to select
   */ const setDatasetAndVariable = (datasetName, variableName)=>{
        const dataset = datasets.find((d)=>d.name === datasetName);
        const variable = dataset?.clinicalVariables.find((v)=>v.name === variableName);
        if (dataset && variable) {
            const codeList = variable.clinicalCodeListId ? codeLists.find((cl)=>cl.id === variable.clinicalCodeListId) : undefined;
            setFormState((prev)=>({
                    ...prev,
                    selectedDataset: datasetName,
                    selectedVariable: variable,
                    selectedTerminology: codeList?.name ?? "",
                    value: ""
                }));
        }
    };
    // #endregion
    // #region Preview and Output
    /**
   * Generates preview text for all where clauses.
   * Includes current unsaved clause if valid.
   *
   * @returns Preview of the annotation logic
   */ const previewText = (()=>{
        const allClauses = [
            ...whereClauses
        ];
        if (formState.selectedVariable) {
            const selectedVariableDto = formState.selectedVariable;
            const variableDto = {
                nameVariable: selectedVariableDto.name,
                dataset: formState.selectedDataset,
                ...formState.companionVariables.length > 0 && {
                    companionVariables: formState.companionVariables
                }
            };
            const currentWhereClause = {
                id: whereClauses[currentClauseIndex]?.id ?? crypto.randomUUID(),
                left: variableDto,
                comparator: formState.comparator,
                right: formState.value,
                precedingLogic: whereClauses[currentClauseIndex]?.precedingLogic
            };
            allClauses[currentClauseIndex] = currentWhereClause;
        }
        const validClauses = allClauses.filter((clause)=>(0, $6FNAc.validateWhereClause)(clause, comparatorTypes));
        if (validClauses.length === 0) return "No annotation clauses configured";
        return (0, $f3i0T.generatePreviewText)(validClauses, comparatorTypes);
    })();
    // #endregion
    /**
   * Update a single form field by name.
   *
   * @param field - Name of the field to update
   * @param value - New value for the field (type matches the field's type in AnnotationControlsState)
   */ const updateFormField = (field, value)=>{
        setFormState((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    return {
        formState: // Core state and validation
        formState,
        isFormValid: isFormValid,
        isCurrentClauseValid: isCurrentClauseValid,
        canAddNewClause: canAddNewClause,
        canRemoveClause: canRemoveClause,
        isUnchanged: isUnchanged,
        initialAnnotation: initialAnnotation,
        updateFormField: // Core actions (wrapper functions to allow external calls)
        updateFormField,
        resetForm: resetForm,
        restoreInitial: restoreInitial,
        buildFinalAnnotation: buildFinalAnnotation,
        handleFieldChange: // Centralized annotations field change handler
        handleFieldChange,
        setDatasetAndVariable: setDatasetAndVariable,
        whereClauses: // Multi-clause management
        whereClauses,
        currentClauseIndex: currentClauseIndex,
        goToPreviousClause: goToPreviousClause,
        goToNextClause: goToNextClause,
        addNewWhereClause: addNewWhereClause,
        removeCurrentClause: removeCurrentClause,
        saveCurrentClause: saveCurrentClause,
        datasetOptions: // Data for selectors
        datasetOptions,
        variableOptions: variableOptions,
        codeLists: codeLists,
        comparatorTypes: comparatorTypes,
        annotationLocation: annotationLocation,
        annotationType: annotationType,
        previewText: // Preview data
        previewText,
        totalClauseCount: totalClauseCount
    };
};

});
parcelRegister("f3i0T", function(module, exports) {

$parcel$export(module.exports, "generatePreviewText", function () { return $89d3e0df0726520a$export$6af7c3d4d6b539c4; });

var $jXvYW = parcelRequire("jXvYW");
/**
 * Generate preview text for a single where clause operation.
 *
 * @param whereClause - The where clause to generate a preview for
 * @param comparatorTypes - Available comparator types used to determine formatting
 * @returns Preview text string
 */ const $89d3e0df0726520a$var$generateSingleClausePreviewFromOp = (whereClause, comparatorTypes)=>{
    if (!whereClause.left?.dataset || !whereClause.left) return "";
    let text = `${whereClause.left.dataset}.${whereClause.left.nameVariable}`;
    // Add companions in the order they appear in the array
    if (whereClause.left.companionVariables && whereClause.left.companionVariables.length > 0) whereClause.left.companionVariables.forEach((companion)=>{
        const formatFn = (0, $jXvYW.COMPANION_TYPE_CONFIG)[companion.type];
        text += formatFn(companion.variable);
    });
    if (!whereClause.comparator) return text;
    // Look up the full comparator object by name
    const comparatorType = comparatorTypes.find((c)=>c.name === whereClause.comparator);
    if (!comparatorType) return text;
    // Check if comparator doesn't require right-hand side value
    if (comparatorType.rhsType === "None") text += ` ${comparatorType.denotation}`;
    else if (whereClause.right) {
        if (comparatorType.rhsType === "Group") {
            // For group comparators, parse values separated by newlines
            const values = whereClause.right.split("\n").map((v)=>v.trim()).filter((v)=>v !== "");
            const isNumeric = values.every((v)=>/^\d+(\.\d+)?$/.test(v));
            const formattedValues = values.map((v)=>isNumeric ? v : `"${v}"`).join(", ");
            text += ` ${comparatorType.denotation} (${formattedValues})`;
        } else {
            // For single value comparators
            const isNumeric = /^\d+(\.\d+)?$/.test(whereClause.right);
            const formattedValue = isNumeric ? whereClause.right : `"${whereClause.right}"`;
            text += ` ${comparatorType.denotation} ${formattedValue}`;
        }
    }
    return text;
};
const $89d3e0df0726520a$export$6af7c3d4d6b539c4 = (whereClauses, comparatorTypes)=>{
    const previews = whereClauses.map((clause, idx)=>{
        const clausePreview = $89d3e0df0726520a$var$generateSingleClausePreviewFromOp(clause, comparatorTypes);
        if (clausePreview === "") return "";
        // Only show precedingLogic for clauses after the first
        const logicText = idx > 0 && clause.precedingLogic ? `${clause.precedingLogic} ` : "";
        return `${logicText}${clausePreview}`;
    }).filter((preview)=>preview !== "");
    return previews.join(" ");
};

});
parcelRegister("jXvYW", function(module, exports) {

$parcel$export(module.exports, "COMPANION_TYPE_CONFIG", function () { return $c1d131c76ce7de22$export$150b644aabea4fbb; });
$parcel$export(module.exports, "isVariableDto", function () { return $c1d131c76ce7de22$export$580697d40ab95f51; });
/**
 * Companion variable type options
 */ const $c1d131c76ce7de22$export$150b644aabea4fbb = {
    Order: (variable)=>`/${variable}`,
    Label: (variable)=>`/${variable}`,
    Unit: (variable)=>` (${variable})`
};
const $c1d131c76ce7de22$export$580697d40ab95f51 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.nameVariable !== "string") return false;
    if (typeof chkObj.dataset !== "string") return false;
    // Check optional companionVariables array
    if (chkObj.companionVariables !== undefined) {
        if (!Array.isArray(chkObj.companionVariables)) return false;
        for (const companion of chkObj.companionVariables){
            if (typeof companion !== "object" || companion === null) return false;
            if (typeof companion.variable !== "string") return false;
            if (![
                "Order",
                "Label",
                "Unit"
            ].includes(companion.type)) return false;
        }
    }
    // Everything is good
    return true;
};

});


parcelRegister("6FNAc", function(module, exports) {

$parcel$export(module.exports, "validateWhereClause", function () { return $53434514c8b2f3e9$export$3daeae5176c2a71c; });

var $9ykYT = parcelRequire("9ykYT");
const $53434514c8b2f3e9$export$3daeae5176c2a71c = (data, comparatorTypes)=>{
    // Convert to ValidatableWhereClause format based on input type
    const validatable = (0, $9ykYT.isWhereClause)(data) ? {
        dataset: data.left?.dataset,
        nameVariable: data.left?.nameVariable,
        comparator: data.comparator,
        value: data.right,
        companionVariables: data.left?.companionVariables
    } : "selectedDataset" in data ? {
        dataset: data.selectedDataset,
        nameVariable: data.selectedVariable?.name,
        comparator: data.comparator,
        value: data.value,
        companionVariables: data.companionVariables
    } : data;
    const { dataset: dataset, nameVariable: nameVariable, comparator: comparator, value: value, companionVariables: companionVariables } = validatable;
    // Check basic required fields (dataset and variable are always required)
    if (!dataset || !nameVariable) return false;
    // Check that all companion variables have a value selected
    if (companionVariables?.some((companion)=>!companion.variable || companion.variable.split(".")[0] !== dataset)) return false;
    // If no comparator is selected, the clause is still valid (just references the variable)
    if (!comparator) return true;
    // Check if comparator requires a value (only validate if comparatorType is found)
    const comparatorType = comparatorTypes?.find((ct)=>ct.name === comparator);
    if (comparatorType && comparatorType.rhsType !== "None" && !value) return false;
    return true;
};

});
parcelRegister("9ykYT", function(module, exports) {

$parcel$export(module.exports, "isWhereClauseOp", function () { return $621608fb2910fe28$export$db8818ddfdcc306b; });
$parcel$export(module.exports, "isWhereClause", function () { return $621608fb2910fe28$export$2c9b8aab4e488ca5; });

var $lX9NV = parcelRequire("lX9NV");

var $jXvYW = parcelRequire("jXvYW");
const $621608fb2910fe28$export$db8818ddfdcc306b = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.left !== "object" || !(0, $jXvYW.isVariableDto)(chkObj.left)) return false;
    if (chkObj.comparator !== undefined && typeof chkObj.comparator !== "string") return false;
    if (chkObj.right !== undefined && typeof chkObj.right !== "string") return false;
    if (chkObj.precedingLogic !== undefined && !(0, $lX9NV.isLogicalOperator)(chkObj.precedingLogic)) return false;
    // Everything is good
    return true;
};
const $621608fb2910fe28$export$2c9b8aab4e488ca5 = (data)=>"left" in data;

});
parcelRegister("lX9NV", function(module, exports) {

$parcel$export(module.exports, "isLogicalOperator", function () { return $6b407a6ec6c78397$export$787487a2edbfc02e; });
/**
 * Logical operators for combining where groups.
 * Currently supports AND and OR operations.
 */ const $6b407a6ec6c78397$export$787487a2edbfc02e = (obj)=>{
    return typeof obj === "string" && [
        "AND",
        "OR"
    ].includes(obj);
};

});





parcelRegister("b9tE1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81e787c0d42651fa$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $81e787c0d42651fa$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $81e787c0d42651fa$var$_extends() {
    return $81e787c0d42651fa$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $81e787c0d42651fa$var$_extends.apply(null, arguments);
}
function $81e787c0d42651fa$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $81e787c0d42651fa$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $81e787c0d42651fa$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $81e787c0d42651fa$var$PencilSquare = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $81e787c0d42651fa$var$_objectWithoutProperties(_ref, $81e787c0d42651fa$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $81e787c0d42651fa$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pencil-square',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
    }));
});
$81e787c0d42651fa$var$PencilSquare.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $81e787c0d42651fa$export$2e2bcd8739ae039 = $81e787c0d42651fa$var$PencilSquare;

});

parcelRegister("cMhqQ", function(module, exports) {

$parcel$export(module.exports, "annotationBtn", function () { return $94d77d5ba6458a4d$export$2c1bbb5dc6e1a1c3; }, function (v) { return $94d77d5ba6458a4d$export$2c1bbb5dc6e1a1c3 = v; });
$parcel$export(module.exports, "badEmpty", function () { return $94d77d5ba6458a4d$export$e73814cfefd51fbe; }, function (v) { return $94d77d5ba6458a4d$export$e73814cfefd51fbe = v; });
$parcel$export(module.exports, "empty", function () { return $94d77d5ba6458a4d$export$6e22c362a0406a2c; }, function (v) { return $94d77d5ba6458a4d$export$6e22c362a0406a2c = v; });
$parcel$export(module.exports, "glyph", function () { return $94d77d5ba6458a4d$export$f1f5ddeb20d14f; }, function (v) { return $94d77d5ba6458a4d$export$f1f5ddeb20d14f = v; });
$parcel$export(module.exports, "hoverIcon", function () { return $94d77d5ba6458a4d$export$5a7c758e1af5ce6; }, function (v) { return $94d77d5ba6458a4d$export$5a7c758e1af5ce6 = v; });
$parcel$export(module.exports, "icon", function () { return $94d77d5ba6458a4d$export$1ca1ec8b29a4ce27; }, function (v) { return $94d77d5ba6458a4d$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "letter", function () { return $94d77d5ba6458a4d$export$30780d0b6b610af8; }, function (v) { return $94d77d5ba6458a4d$export$30780d0b6b610af8 = v; });
$parcel$export(module.exports, "wide", function () { return $94d77d5ba6458a4d$export$163ab120a2115199; }, function (v) { return $94d77d5ba6458a4d$export$163ab120a2115199 = v; });
var $94d77d5ba6458a4d$export$2c1bbb5dc6e1a1c3;
var $94d77d5ba6458a4d$export$e73814cfefd51fbe;
var $94d77d5ba6458a4d$export$6e22c362a0406a2c;
var $94d77d5ba6458a4d$export$f1f5ddeb20d14f;
var $94d77d5ba6458a4d$export$5a7c758e1af5ce6;
var $94d77d5ba6458a4d$export$1ca1ec8b29a4ce27;
var $94d77d5ba6458a4d$export$30780d0b6b610af8;
var $94d77d5ba6458a4d$export$163ab120a2115199;
$94d77d5ba6458a4d$export$2c1bbb5dc6e1a1c3 = `mos-AnnotationButton-module-S3bPeq-annotationBtn`;
$94d77d5ba6458a4d$export$e73814cfefd51fbe = `mos-AnnotationButton-module-S3bPeq-badEmpty`;
$94d77d5ba6458a4d$export$6e22c362a0406a2c = `mos-AnnotationButton-module-S3bPeq-empty`;
$94d77d5ba6458a4d$export$f1f5ddeb20d14f = `mos-AnnotationButton-module-S3bPeq-glyph`;
$94d77d5ba6458a4d$export$5a7c758e1af5ce6 = `mos-AnnotationButton-module-S3bPeq-hoverIcon`;
$94d77d5ba6458a4d$export$1ca1ec8b29a4ce27 = `mos-AnnotationButton-module-S3bPeq-icon`;
$94d77d5ba6458a4d$export$30780d0b6b610af8 = `mos-AnnotationButton-module-S3bPeq-letter`;
$94d77d5ba6458a4d$export$163ab120a2115199 = `mos-AnnotationButton-module-S3bPeq-wide`;

});

parcelRegister("2o69n", function(module, exports) {

$parcel$export(module.exports, "AnnotationPreviewBubble", function () { return $244d6c12c11cdbe9$export$1d96d319de4d1c3a; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");

var $3tNrK = parcelRequire("3tNrK");

var $spJKX = parcelRequire("spJKX");

var $4x5ZA = parcelRequire("4x5ZA");
var $1ewFu = parcelRequire("1ewFu");

var $8VKFD = parcelRequire("8VKFD");

var $f3i0T = parcelRequire("f3i0T");
const $244d6c12c11cdbe9$export$1d96d319de4d1c3a = ({ annotation: annotation, className: className = "", position: position = "right", variant: variant = "bubble", onClick: onClick, target: target, repositionKey: repositionKey })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    /**
   * Container for Overlay popover. Uses target's parent or document.body.
   */ /* istanbul ignore next */ const container = target.current?.parentElement ?? (typeof document !== "undefined" ? document.body : undefined);
    /**
   * Memoized preview text for annotation clauses.
   */ const previewText = (0, $spJKX.useMemo)(()=>annotation ? (0, $f3i0T.generatePreviewText)(annotation.clauses, appSettings.annotationComparatorTypes) : "", [
        annotation,
        appSettings.annotationComparatorTypes
    ]);
    /**
   * Keyboard event handler for accessibility.
   * Triggers onClick when Enter or Space is pressed.
   *
   * @param e - Keyboard event
   */ const handleKeyDown = onClick ? (e)=>{
        /* istanbul ignore else */ if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
        }
    } : /* istanbul ignore next */ undefined;
    // Bubble variant - Bootstrap Overlay with Popover
    return !annotation || !annotation.clauses || annotation.clauses.length === 0 ? null : variant === "column" ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).columnPreview,
            className
        ]),
        onClick: onClick,
        role: onClick ? "button" : undefined,
        tabIndex: onClick ? 0 : undefined,
        onKeyDown: handleKeyDown,
        "aria-label": onClick ? "Annotation preview" : undefined,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).bubbleContent,
            children: previewText && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).bubbleText,
                children: previewText
            })
        })
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4x5ZA.default), {
        placement: position,
        target: target?.current,
        show: true,
        container: container,
        popperConfig: {
            modifiers: [
                {
                    name: "arrow",
                    enabled: false
                },
                {
                    name: "offset",
                    options: {
                        offset: [
                            0,
                            2
                        ]
                    }
                },
                {
                    name: "eventListeners",
                    options: {
                        scroll: true,
                        resize: true
                    }
                },
                {
                    name: "flip",
                    enabled: true,
                    options: {
                        // Only allow horizontal flipping (left <-> right), not vertical (top <-> bottom)
                        fallbackPlacements: position === "left" || position === "right" ? [
                            position === "left" ? "right" : "left"
                        ] : []
                    }
                },
                {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                        boundary: "viewport"
                    }
                }
            ]
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1ewFu.default), {
            id: `annotation-preview-${annotation.id}`,
            className: (0, $3tKzd.classMerge)([
                (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).annotationPreviewBubble,
                className
            ]),
            onClick: onClick,
            role: onClick ? "button" : undefined,
            tabIndex: onClick ? 0 : undefined,
            onKeyDown: handleKeyDown,
            "aria-label": onClick ? "Annotation preview bubble" : undefined,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1ewFu.default).Body, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).bubbleContent,
                children: previewText && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($8VKFD))).bubbleText,
                    children: previewText
                })
            })
        })
    }, repositionKey !== undefined ? `overlay-${repositionKey}` : undefined);
};
$244d6c12c11cdbe9$export$1d96d319de4d1c3a.displayName = "AnnotationPreviewBubble";

});
parcelRegister("4x5ZA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34cee47223a603e0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $2za67 = parcelRequire("2za67");

var $i1VQA = parcelRequire("i1VQA");

var $dHq7H = parcelRequire("dHq7H");

var $4E7Hm = parcelRequire("4E7Hm");

var $didSY = parcelRequire("didSY");

var $bE9uK = parcelRequire("bE9uK");

var $dhaAU = parcelRequire("dhaAU");

var $bR5nk = parcelRequire("bR5nk");
"use client";
function $34cee47223a603e0$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $dhaAU.default)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $dhaAU.default)(r)));
}
const $34cee47223a603e0$var$Overlay = /*#__PURE__*/ $spJKX.forwardRef(({ children: overlay, transition: transition = (0, $bE9uK.default), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $spJKX.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $spJKX.useState)(null);
    const [ref, modifiers] = (0, $didSY.default)(outerProps.offset);
    const mergedRef = (0, $4E7Hm.default)(outerRef, ref);
    const actualTransition = transition === true ? (0, $bE9uK.default) : transition || undefined;
    const handleFirstUpdate = (0, $i1VQA.default)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $dHq7H.default)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2za67.default), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $34cee47223a603e0$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $spJKX.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$34cee47223a603e0$var$Overlay.displayName = 'Overlay';
var $34cee47223a603e0$export$2e2bcd8739ae039 = $34cee47223a603e0$var$Overlay;

});
parcelRegister("2za67", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1de6aed832d02725$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $aRyvJ = parcelRequire("aRyvJ");

var $6q3bl = parcelRequire("6q3bl");

var $dRPXQ = parcelRequire("dRPXQ");

var $4tmaK = parcelRequire("4tmaK");

var $4XJuk = parcelRequire("4XJuk");

var $jyTHg = parcelRequire("jyTHg");

var $2xtMk = parcelRequire("2xtMk");
/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $1de6aed832d02725$var$Overlay = /*#__PURE__*/ $spJKX.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $aRyvJ.default)();
    const [arrowElement, attachArrowRef] = (0, $aRyvJ.default)();
    const mergedRef = (0, $6q3bl.default)(attachRef, outerRef);
    const container = (0, $4XJuk.default)(props.container);
    const target = (0, $4XJuk.default)(props.target);
    const [exited, setExited] = (0, $spJKX.useState)(!props.show);
    const popper = (0, $dRPXQ.default)(target, rootElement, (0, $jyTHg.default)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $4tmaK.default)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $2xtMk.renderTransition)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($oS63j))).createPortal(child, container) : null;
});
$1de6aed832d02725$var$Overlay.displayName = 'Overlay';
var $1de6aed832d02725$export$2e2bcd8739ae039 = $1de6aed832d02725$var$Overlay;

});
parcelRegister("dRPXQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a18888979a1944eb$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $a0O7K = parcelRequire("a0O7K");

var $3EzTS = parcelRequire("3EzTS");

var $gu6oZ = parcelRequire("gu6oZ");
const $a18888979a1944eb$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $a18888979a1944eb$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $a18888979a1944eb$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $a18888979a1944eb$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $a18888979a1944eb$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $a18888979a1944eb$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $a18888979a1944eb$var$EMPTY_MODIFIERS } = _ref, config = $a18888979a1944eb$var$_objectWithoutPropertiesLoose(_ref, $a18888979a1944eb$var$_excluded);
    const prevModifiers = (0, $spJKX.useRef)(modifiers);
    const popperInstanceRef = (0, $spJKX.useRef)();
    const update = (0, $spJKX.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $spJKX.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $3EzTS.default)((0, $spJKX.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $spJKX.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $spJKX.useMemo)(()=>{
        if (!(0, $a0O7K.dequal)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $a18888979a1944eb$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $gu6oZ.createPopper)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $a18888979a1944eb$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $a18888979a1944eb$export$2e2bcd8739ae039 = $a18888979a1944eb$var$usePopper;

});
parcelRegister("a0O7K", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $4d0717a1cb0e05ea$export$de8294bb3be0322f; });
var $4d0717a1cb0e05ea$var$has = Object.prototype.hasOwnProperty;
function $4d0717a1cb0e05ea$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($4d0717a1cb0e05ea$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $4d0717a1cb0e05ea$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4d0717a1cb0e05ea$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $4d0717a1cb0e05ea$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $4d0717a1cb0e05ea$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$4d0717a1cb0e05ea$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4d0717a1cb0e05ea$var$has.call(foo, ctor) && ++len && !$4d0717a1cb0e05ea$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4d0717a1cb0e05ea$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}

});

parcelRegister("3EzTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a90f4925d97ef0d$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $1lkRM = parcelRequire("1lkRM");
/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $2a90f4925d97ef0d$var$useSafeState(state) {
    const isMounted = (0, $1lkRM.default)();
    return [
        state[0],
        (0, $spJKX.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $2a90f4925d97ef0d$export$2e2bcd8739ae039 = $2a90f4925d97ef0d$var$useSafeState;

});

parcelRegister("gu6oZ", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $c0046a0341f2416b$export$8f7491d57c8f97a9; });

var $ctfuh = parcelRequire("ctfuh");

var $71ZCZ = parcelRequire("71ZCZ");

var $jgsVh = parcelRequire("jgsVh");

var $iwGUr = parcelRequire("iwGUr");

var $jvf4l = parcelRequire("jvf4l");

var $5BiCB = parcelRequire("5BiCB");

var $9PL7e = parcelRequire("9PL7e");

var $l8QNs = parcelRequire("l8QNs");


var $iggzA = parcelRequire("iggzA");
const $c0046a0341f2416b$export$8f7491d57c8f97a9 = (0, $iggzA.popperGenerator)({
    defaultModifiers: [
        (0, $jvf4l.default),
        (0, $9PL7e.default),
        (0, $71ZCZ.default),
        (0, $jgsVh.default),
        (0, $5BiCB.default),
        (0, $iwGUr.default),
        (0, $l8QNs.default),
        (0, $ctfuh.default)
    ]
});

});
parcelRegister("ctfuh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $914434ecea422b0a$export$2e2bcd8739ae039; });

var $8F3WF = parcelRequire("8F3WF");

var $hdDkD = parcelRequire("hdDkD");

var $eyKMN = parcelRequire("eyKMN");

var $6vNa9 = parcelRequire("6vNa9");

var $lPcNr = parcelRequire("lPcNr");

var $i7KpF = parcelRequire("i7KpF");

var $gGw0y = parcelRequire("gGw0y");

var $k7wJu = parcelRequire("k7wJu");

var $bfw5I = parcelRequire("bfw5I");
var $914434ecea422b0a$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $gGw0y.default)(typeof padding !== 'number' ? padding : (0, $k7wJu.default)(padding, (0, $bfw5I.basePlacements)));
};
function $914434ecea422b0a$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8F3WF.default)(state.placement);
    var axis = (0, $lPcNr.default)(basePlacement);
    var isVertical = [
        (0, $bfw5I.left),
        (0, $bfw5I.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $914434ecea422b0a$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $hdDkD.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $bfw5I.top) : (0, $bfw5I.left);
    var maxProp = axis === 'y' ? (0, $bfw5I.bottom) : (0, $bfw5I.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6vNa9.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $i7KpF.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $914434ecea422b0a$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $eyKMN.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $914434ecea422b0a$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $914434ecea422b0a$var$arrow,
    effect: $914434ecea422b0a$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});
parcelRegister("8F3WF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64e53682df15642a$export$2e2bcd8739ae039; });

function $64e53682df15642a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hdDkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c892290a6638f328$export$2e2bcd8739ae039; });

var $92OIM = parcelRequire("92OIM");
function $c892290a6638f328$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $92OIM.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRegister("92OIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $695ba5280fe47994$export$2e2bcd8739ae039; });

var $5u8iS = parcelRequire("5u8iS");

var $6CWdy = parcelRequire("6CWdy");

var $2bPgR = parcelRequire("2bPgR");

var $3OXPL = parcelRequire("3OXPL");
function $695ba5280fe47994$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $5u8iS.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $6CWdy.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $6CWdy.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $5u8iS.isElement)(element) ? (0, $2bPgR.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3OXPL.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("5u8iS", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $3fe63200151bd402$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $3fe63200151bd402$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $3fe63200151bd402$export$af51f0f06c0f328a; });

var $2bPgR = parcelRequire("2bPgR");
function $3fe63200151bd402$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $2bPgR.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $3fe63200151bd402$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $2bPgR.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $3fe63200151bd402$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $2bPgR.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("2bPgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $198461331ee8c90d$export$2e2bcd8739ae039; });
function $198461331ee8c90d$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("6CWdy", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $4d337380e93050a2$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $4d337380e93050a2$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $4d337380e93050a2$export$2077e0241d6afd3c; });
var $4d337380e93050a2$export$8960430cfd85939f = Math.max;
var $4d337380e93050a2$export$96ec731ed4dcb222 = Math.min;
var $4d337380e93050a2$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("3OXPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c84745f55793beb$export$2e2bcd8739ae039; });

var $5oVuF = parcelRequire("5oVuF");
function $2c84745f55793beb$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $5oVuF.default)());
}

});
parcelRegister("5oVuF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3eebcaa7ead66441$export$2e2bcd8739ae039; });
function $3eebcaa7ead66441$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});




parcelRegister("eyKMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a998886695aa8cef$export$2e2bcd8739ae039; });

var $5u8iS = parcelRequire("5u8iS");
function $a998886695aa8cef$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $5u8iS.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("6vNa9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdbc60bcca87763$export$2e2bcd8739ae039; });

var $2bPgR = parcelRequire("2bPgR");

var $01DoM = parcelRequire("01DoM");

var $a5Az8 = parcelRequire("a5Az8");

var $5u8iS = parcelRequire("5u8iS");

var $cnJ1o = parcelRequire("cnJ1o");

var $8jQNx = parcelRequire("8jQNx");

var $5oVuF = parcelRequire("5oVuF");
function $4bdbc60bcca87763$var$getTrueOffsetParent(element) {
    if (!(0, $5u8iS.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $a5Az8.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $4bdbc60bcca87763$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $5oVuF.default)());
    var isIE = /Trident/i.test((0, $5oVuF.default)());
    if (isIE && (0, $5u8iS.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $a5Az8.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $8jQNx.default)(element);
    if ((0, $5u8iS.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $5u8iS.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $01DoM.default)(currentNode)) < 0){
        var css = (0, $a5Az8.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $4bdbc60bcca87763$export$2e2bcd8739ae039(element) {
    var window = (0, $2bPgR.default)(element);
    var offsetParent = $4bdbc60bcca87763$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cnJ1o.default)(offsetParent) && (0, $a5Az8.default)(offsetParent).position === 'static')offsetParent = $4bdbc60bcca87763$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $01DoM.default)(offsetParent) === 'html' || (0, $01DoM.default)(offsetParent) === 'body' && (0, $a5Az8.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $4bdbc60bcca87763$var$getContainingBlock(element) || window;
}

});
parcelRegister("01DoM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $004ea7e0343ffe7a$export$2e2bcd8739ae039; });
function $004ea7e0343ffe7a$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("a5Az8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7586bc314bbe9696$export$2e2bcd8739ae039; });

var $2bPgR = parcelRequire("2bPgR");
function $7586bc314bbe9696$export$2e2bcd8739ae039(element) {
    return (0, $2bPgR.default)(element).getComputedStyle(element);
}

});

parcelRegister("cnJ1o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $903a8e5bd8b1fc08$export$2e2bcd8739ae039; });

var $01DoM = parcelRequire("01DoM");
function $903a8e5bd8b1fc08$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $01DoM.default)(element)) >= 0;
}

});

parcelRegister("8jQNx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60e90dafbde1f4c3$export$2e2bcd8739ae039; });

var $01DoM = parcelRequire("01DoM");

var $2us3t = parcelRequire("2us3t");

var $5u8iS = parcelRequire("5u8iS");
function $60e90dafbde1f4c3$export$2e2bcd8739ae039(element) {
    if ((0, $01DoM.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5u8iS.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $2us3t.default)(element) // fallback
    );
}

});
parcelRegister("2us3t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d0425445740ab9d$export$2e2bcd8739ae039; });

var $5u8iS = parcelRequire("5u8iS");
function $1d0425445740ab9d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5u8iS.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRegister("lPcNr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe38497acdf80b1f$export$2e2bcd8739ae039; });
function $fe38497acdf80b1f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});

parcelRegister("i7KpF", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $d31ce217bc326b4d$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $d31ce217bc326b4d$export$86c8af6d3ef0b4a; });

var $6CWdy = parcelRequire("6CWdy");
function $d31ce217bc326b4d$export$f28d906d67a997f3(min, value, max) {
    return (0, $6CWdy.max)(min, (0, $6CWdy.min)(value, max));
}
function $d31ce217bc326b4d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d31ce217bc326b4d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRegister("gGw0y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c25965acc585e137$export$2e2bcd8739ae039; });

var $kn28c = parcelRequire("kn28c");
function $c25965acc585e137$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kn28c.default)(), paddingObject);
}

});
parcelRegister("kn28c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed479bd6f0908644$export$2e2bcd8739ae039; });
function $ed479bd6f0908644$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("k7wJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea5dda24b28a0945$export$2e2bcd8739ae039; });
function $ea5dda24b28a0945$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});

parcelRegister("bfw5I", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $8309fd11200a4561$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $8309fd11200a4561$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $8309fd11200a4561$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $8309fd11200a4561$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $8309fd11200a4561$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $8309fd11200a4561$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $8309fd11200a4561$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $8309fd11200a4561$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $8309fd11200a4561$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $8309fd11200a4561$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $8309fd11200a4561$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $8309fd11200a4561$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $8309fd11200a4561$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $8309fd11200a4561$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $8309fd11200a4561$export$d087d3878fdf71d5; });
var $8309fd11200a4561$export$1e95b668f3b82d = 'top';
var $8309fd11200a4561$export$40e543e69a8b3fbb = 'bottom';
var $8309fd11200a4561$export$79ffe56a765070d2 = 'right';
var $8309fd11200a4561$export$eabcd2c8791e7bf4 = 'left';
var $8309fd11200a4561$export$dfb5619354ba860 = 'auto';
var $8309fd11200a4561$export$aec2ce47c367b8c3 = [
    $8309fd11200a4561$export$1e95b668f3b82d,
    $8309fd11200a4561$export$40e543e69a8b3fbb,
    $8309fd11200a4561$export$79ffe56a765070d2,
    $8309fd11200a4561$export$eabcd2c8791e7bf4
];
var $8309fd11200a4561$export$b3571188c770cc5a = 'start';
var $8309fd11200a4561$export$bd5df0f255a350f8 = 'end';
var $8309fd11200a4561$export$390fd549c5303b4d = 'clippingParents';
var $8309fd11200a4561$export$d7b7311ec04a3e8f = 'viewport';
var $8309fd11200a4561$export$ae5ab1c730825774 = 'popper';
var $8309fd11200a4561$export$ca50aac9f3ba507f = 'reference';
var $8309fd11200a4561$export$368f9a87e87fa4e1 = /*#__PURE__*/ $8309fd11200a4561$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $8309fd11200a4561$export$b3571188c770cc5a,
        placement + "-" + $8309fd11200a4561$export$bd5df0f255a350f8
    ]);
}, []);
var $8309fd11200a4561$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($8309fd11200a4561$export$aec2ce47c367b8c3, [
    $8309fd11200a4561$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $8309fd11200a4561$export$b3571188c770cc5a,
        placement + "-" + $8309fd11200a4561$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $8309fd11200a4561$export$421679a7c3d56e = 'beforeRead';
var $8309fd11200a4561$export$aafa59e2e03f2942 = 'read';
var $8309fd11200a4561$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $8309fd11200a4561$export$c65e99957a05207c = 'beforeMain';
var $8309fd11200a4561$export$f22da7240b7add18 = 'main';
var $8309fd11200a4561$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $8309fd11200a4561$export$8d4d2d70e7d46032 = 'beforeWrite';
var $8309fd11200a4561$export$68d8715fc104d294 = 'write';
var $8309fd11200a4561$export$70a6e5159acce2e6 = 'afterWrite';
var $8309fd11200a4561$export$d087d3878fdf71d5 = [
    $8309fd11200a4561$export$421679a7c3d56e,
    $8309fd11200a4561$export$aafa59e2e03f2942,
    $8309fd11200a4561$export$6964f6c886723980,
    $8309fd11200a4561$export$c65e99957a05207c,
    $8309fd11200a4561$export$f22da7240b7add18,
    $8309fd11200a4561$export$bab79516f2d662fe,
    $8309fd11200a4561$export$8d4d2d70e7d46032,
    $8309fd11200a4561$export$68d8715fc104d294,
    $8309fd11200a4561$export$70a6e5159acce2e6
];

});


parcelRegister("71ZCZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51e86e6769bf2b6c$export$2e2bcd8739ae039; });

var $bfw5I = parcelRequire("bfw5I");

var $6vNa9 = parcelRequire("6vNa9");

var $2bPgR = parcelRequire("2bPgR");

var $2us3t = parcelRequire("2us3t");

var $a5Az8 = parcelRequire("a5Az8");

var $8F3WF = parcelRequire("8F3WF");

var $8peuU = parcelRequire("8peuU");

var $6CWdy = parcelRequire("6CWdy");
var $51e86e6769bf2b6c$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $51e86e6769bf2b6c$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $6CWdy.round)(x * dpr) / dpr || 0,
        y: (0, $6CWdy.round)(y * dpr) / dpr || 0
    };
}
function $51e86e6769bf2b6c$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $bfw5I.left);
    var sideY = (0, $bfw5I.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6vNa9.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $2bPgR.default)(popper)) {
            offsetParent = (0, $2us3t.default)(popper);
            if ((0, $a5Az8.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $bfw5I.top) || (placement === (0, $bfw5I.left) || placement === (0, $bfw5I.right)) && variation === (0, $bfw5I.end)) {
            sideY = (0, $bfw5I.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $bfw5I.left) || (placement === (0, $bfw5I.top) || placement === (0, $bfw5I.bottom)) && variation === (0, $bfw5I.end)) {
            sideX = (0, $bfw5I.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $51e86e6769bf2b6c$var$unsetSides);
    var _ref4 = roundOffsets === true ? $51e86e6769bf2b6c$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $2bPgR.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $51e86e6769bf2b6c$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8F3WF.default)(state.placement),
        variation: (0, $8peuU.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $51e86e6769bf2b6c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $51e86e6769bf2b6c$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $51e86e6769bf2b6c$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $51e86e6769bf2b6c$var$computeStyles,
    data: {}
};

});
parcelRegister("8peuU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61ebe7749f0f1142$export$2e2bcd8739ae039; });
function $61ebe7749f0f1142$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});


parcelRegister("jgsVh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e065f266a69a353d$export$2e2bcd8739ae039; });

var $2bPgR = parcelRequire("2bPgR");
var $e065f266a69a353d$var$passive = {
    passive: true
};
function $e065f266a69a353d$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $2bPgR.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e065f266a69a353d$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e065f266a69a353d$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e065f266a69a353d$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e065f266a69a353d$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e065f266a69a353d$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e065f266a69a353d$var$effect,
    data: {}
};

});

parcelRegister("iwGUr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d7cc8011ac7f6737$export$2e2bcd8739ae039; });

var $3E9Ix = parcelRequire("3E9Ix");

var $8F3WF = parcelRequire("8F3WF");

var $lQ2XU = parcelRequire("lQ2XU");

var $9CKxN = parcelRequire("9CKxN");

var $di4Qg = parcelRequire("di4Qg");

var $bfw5I = parcelRequire("bfw5I");

var $8peuU = parcelRequire("8peuU");
function $d7cc8011ac7f6737$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8F3WF.default)(placement) === (0, $bfw5I.auto)) return [];
    var oppositePlacement = (0, $3E9Ix.default)(placement);
    return [
        (0, $lQ2XU.default)(placement),
        oppositePlacement,
        (0, $lQ2XU.default)(oppositePlacement)
    ];
}
function $d7cc8011ac7f6737$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8F3WF.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3E9Ix.default)(preferredPlacement)
    ] : $d7cc8011ac7f6737$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8F3WF.default)(placement) === (0, $bfw5I.auto) ? (0, $di4Qg.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8F3WF.default)(placement);
        var isStartVariation = (0, $8peuU.default)(placement) === (0, $bfw5I.start);
        var isVertical = [
            (0, $bfw5I.top),
            (0, $bfw5I.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9CKxN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $bfw5I.right) : (0, $bfw5I.left) : isStartVariation ? (0, $bfw5I.bottom) : (0, $bfw5I.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3E9Ix.default)(mainVariationSide);
        var altVariationSide = (0, $3E9Ix.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $d7cc8011ac7f6737$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $d7cc8011ac7f6737$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3E9Ix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a7ca52bbef7d05e$export$2e2bcd8739ae039; });
var $2a7ca52bbef7d05e$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2a7ca52bbef7d05e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2a7ca52bbef7d05e$var$hash[matched];
    });
}

});

parcelRegister("lQ2XU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe60c1269539930b$export$2e2bcd8739ae039; });
var $fe60c1269539930b$var$hash = {
    start: 'end',
    end: 'start'
};
function $fe60c1269539930b$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $fe60c1269539930b$var$hash[matched];
    });
}

});

parcelRegister("9CKxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $701bc454c6e8d807$export$2e2bcd8739ae039; });

var $ftV5S = parcelRequire("ftV5S");

var $2us3t = parcelRequire("2us3t");

var $92OIM = parcelRequire("92OIM");

var $2y0K1 = parcelRequire("2y0K1");

var $a4vcc = parcelRequire("a4vcc");

var $bfw5I = parcelRequire("bfw5I");

var $5u8iS = parcelRequire("5u8iS");

var $gGw0y = parcelRequire("gGw0y");

var $k7wJu = parcelRequire("k7wJu");
function $701bc454c6e8d807$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $bfw5I.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $bfw5I.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $bfw5I.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $gGw0y.default)(typeof padding !== 'number' ? padding : (0, $k7wJu.default)(padding, (0, $bfw5I.basePlacements)));
    var altContext = elementContext === (0, $bfw5I.popper) ? (0, $bfw5I.reference) : (0, $bfw5I.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $ftV5S.default)((0, $5u8iS.isElement)(element) ? element : element.contextElement || (0, $2us3t.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $92OIM.default)(state.elements.reference);
    var popperOffsets = (0, $2y0K1.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $a4vcc.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $bfw5I.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $bfw5I.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $bfw5I.right),
                (0, $bfw5I.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $bfw5I.top),
                (0, $bfw5I.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("ftV5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b455da10c35a65a6$export$2e2bcd8739ae039; });

var $bfw5I = parcelRequire("bfw5I");

var $2UmJz = parcelRequire("2UmJz");

var $2IKfl = parcelRequire("2IKfl");

var $6GjwS = parcelRequire("6GjwS");

var $6vNa9 = parcelRequire("6vNa9");

var $2us3t = parcelRequire("2us3t");

var $a5Az8 = parcelRequire("a5Az8");

var $5u8iS = parcelRequire("5u8iS");

var $92OIM = parcelRequire("92OIM");

var $8jQNx = parcelRequire("8jQNx");

var $eyKMN = parcelRequire("eyKMN");

var $01DoM = parcelRequire("01DoM");

var $a4vcc = parcelRequire("a4vcc");

var $6CWdy = parcelRequire("6CWdy");
function $b455da10c35a65a6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $92OIM.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b455da10c35a65a6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $bfw5I.viewport) ? (0, $a4vcc.default)((0, $2UmJz.default)(element, strategy)) : (0, $5u8iS.isElement)(clippingParent) ? $b455da10c35a65a6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $a4vcc.default)((0, $2IKfl.default)((0, $2us3t.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b455da10c35a65a6$var$getClippingParents(element) {
    var clippingParents = (0, $6GjwS.default)((0, $8jQNx.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $a5Az8.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $5u8iS.isHTMLElement)(element) ? (0, $6vNa9.default)(element) : element;
    if (!(0, $5u8iS.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $5u8iS.isElement)(clippingParent) && (0, $eyKMN.default)(clippingParent, clipperElement) && (0, $01DoM.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b455da10c35a65a6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $b455da10c35a65a6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b455da10c35a65a6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $6CWdy.max)(rect.top, accRect.top);
        accRect.right = (0, $6CWdy.min)(rect.right, accRect.right);
        accRect.bottom = (0, $6CWdy.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $6CWdy.max)(rect.left, accRect.left);
        return accRect;
    }, $b455da10c35a65a6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("2UmJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21e2723865a3b4c6$export$2e2bcd8739ae039; });

var $2bPgR = parcelRequire("2bPgR");

var $2us3t = parcelRequire("2us3t");

var $eWTJz = parcelRequire("eWTJz");

var $3OXPL = parcelRequire("3OXPL");
function $21e2723865a3b4c6$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $2bPgR.default)(element);
    var html = (0, $2us3t.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3OXPL.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $eWTJz.default)(element),
        y: y
    };
}

});
parcelRegister("eWTJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae21b7115c0a0093$export$2e2bcd8739ae039; });

var $92OIM = parcelRequire("92OIM");

var $2us3t = parcelRequire("2us3t");

var $bW8rb = parcelRequire("bW8rb");
function $ae21b7115c0a0093$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $92OIM.default)((0, $2us3t.default)(element)).left + (0, $bW8rb.default)(element).scrollLeft;
}

});
parcelRegister("bW8rb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0ba7fb8aaa9397$export$2e2bcd8739ae039; });

var $2bPgR = parcelRequire("2bPgR");
function $8b0ba7fb8aaa9397$export$2e2bcd8739ae039(node) {
    var win = (0, $2bPgR.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRegister("2IKfl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fb3906c31f0fb9d$export$2e2bcd8739ae039; });

var $2us3t = parcelRequire("2us3t");

var $a5Az8 = parcelRequire("a5Az8");

var $eWTJz = parcelRequire("eWTJz");

var $bW8rb = parcelRequire("bW8rb");

var $6CWdy = parcelRequire("6CWdy");
function $1fb3906c31f0fb9d$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $2us3t.default)(element);
    var winScroll = (0, $bW8rb.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $6CWdy.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $6CWdy.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $eWTJz.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $a5Az8.default)(body || html).direction === 'rtl') x += (0, $6CWdy.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("6GjwS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4dd5d0693d207655$export$2e2bcd8739ae039; });

var $fqTFX = parcelRequire("fqTFX");

var $8jQNx = parcelRequire("8jQNx");

var $2bPgR = parcelRequire("2bPgR");

var $6BU1g = parcelRequire("6BU1g");
function $4dd5d0693d207655$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $fqTFX.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $2bPgR.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $6BU1g.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($4dd5d0693d207655$export$2e2bcd8739ae039((0, $8jQNx.default)(target)));
}

});
parcelRegister("fqTFX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c478c11caad2b7$export$2e2bcd8739ae039; });

var $8jQNx = parcelRequire("8jQNx");

var $6BU1g = parcelRequire("6BU1g");

var $01DoM = parcelRequire("01DoM");

var $5u8iS = parcelRequire("5u8iS");
function $b3c478c11caad2b7$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $01DoM.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5u8iS.isHTMLElement)(node) && (0, $6BU1g.default)(node)) return node;
    return $b3c478c11caad2b7$export$2e2bcd8739ae039((0, $8jQNx.default)(node));
}

});
parcelRegister("6BU1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d01a711db36e7ed$export$2e2bcd8739ae039; });

var $a5Az8 = parcelRequire("a5Az8");
function $4d01a711db36e7ed$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $a5Az8.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRegister("a4vcc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $755279f1b9198a9a$export$2e2bcd8739ae039; });
function $755279f1b9198a9a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("2y0K1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1daf54f19b71cf74$export$2e2bcd8739ae039; });

var $8F3WF = parcelRequire("8F3WF");

var $8peuU = parcelRequire("8peuU");

var $lPcNr = parcelRequire("lPcNr");

var $bfw5I = parcelRequire("bfw5I");
function $1daf54f19b71cf74$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8F3WF.default)(placement) : null;
    var variation = placement ? (0, $8peuU.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $bfw5I.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $bfw5I.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $bfw5I.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $bfw5I.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lPcNr.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $bfw5I.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $bfw5I.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRegister("di4Qg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ad0b654c6e41c34$export$2e2bcd8739ae039; });

var $8peuU = parcelRequire("8peuU");

var $bfw5I = parcelRequire("bfw5I");

var $9CKxN = parcelRequire("9CKxN");

var $8F3WF = parcelRequire("8F3WF");
function $9ad0b654c6e41c34$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $bfw5I.placements) : _options$allowedAutoP;
    var variation = (0, $8peuU.default)(placement);
    var placements = variation ? flipVariations ? (0, $bfw5I.variationPlacements) : (0, $bfw5I.variationPlacements).filter(function(placement) {
        return (0, $8peuU.default)(placement) === variation;
    }) : (0, $bfw5I.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9CKxN.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8F3WF.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("jvf4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e32c99fb28c54b15$export$2e2bcd8739ae039; });

var $bfw5I = parcelRequire("bfw5I");

var $9CKxN = parcelRequire("9CKxN");
function $e32c99fb28c54b15$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $e32c99fb28c54b15$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $bfw5I.top),
        (0, $bfw5I.right),
        (0, $bfw5I.bottom),
        (0, $bfw5I.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $e32c99fb28c54b15$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9CKxN.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9CKxN.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $e32c99fb28c54b15$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $e32c99fb28c54b15$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $e32c99fb28c54b15$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $e32c99fb28c54b15$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $e32c99fb28c54b15$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $e32c99fb28c54b15$var$hide
};

});

parcelRegister("5BiCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $413eda4da05575a8$export$2e2bcd8739ae039; });

var $8F3WF = parcelRequire("8F3WF");

var $bfw5I = parcelRequire("bfw5I");
function $413eda4da05575a8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8F3WF.default)(placement);
    var invertDistance = [
        (0, $bfw5I.left),
        (0, $bfw5I.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $bfw5I.left),
        (0, $bfw5I.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $413eda4da05575a8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $bfw5I.placements).reduce(function(acc, placement) {
        acc[placement] = $413eda4da05575a8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $413eda4da05575a8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $413eda4da05575a8$var$offset
};

});

parcelRegister("9PL7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $728d6ca70ff193bb$export$2e2bcd8739ae039; });

var $2y0K1 = parcelRequire("2y0K1");
function $728d6ca70ff193bb$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2y0K1.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $728d6ca70ff193bb$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $728d6ca70ff193bb$var$popperOffsets,
    data: {}
};

});

parcelRegister("l8QNs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6434ca64206990a$export$2e2bcd8739ae039; });

var $bfw5I = parcelRequire("bfw5I");

var $8F3WF = parcelRequire("8F3WF");

var $lPcNr = parcelRequire("lPcNr");

var $bciNL = parcelRequire("bciNL");

var $i7KpF = parcelRequire("i7KpF");

var $hdDkD = parcelRequire("hdDkD");

var $6vNa9 = parcelRequire("6vNa9");

var $9CKxN = parcelRequire("9CKxN");

var $8peuU = parcelRequire("8peuU");

var $kn28c = parcelRequire("kn28c");

var $6CWdy = parcelRequire("6CWdy");
function $f6434ca64206990a$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9CKxN.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8F3WF.default)(state.placement);
    var variation = (0, $8peuU.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lPcNr.default)(basePlacement);
    var altAxis = (0, $bciNL.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $bfw5I.top) : (0, $bfw5I.left);
        var altSide = mainAxis === 'y' ? (0, $bfw5I.bottom) : (0, $bfw5I.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $bfw5I.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $bfw5I.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $hdDkD.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $kn28c.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $i7KpF.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6vNa9.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $i7KpF.within)(tether ? (0, $6CWdy.min)(min, tetherMin) : min, offset, tether ? (0, $6CWdy.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $bfw5I.top) : (0, $bfw5I.left);
        var _altSide = mainAxis === 'x' ? (0, $bfw5I.bottom) : (0, $bfw5I.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $bfw5I.top),
            (0, $bfw5I.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $i7KpF.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $i7KpF.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f6434ca64206990a$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $f6434ca64206990a$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("bciNL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $826f66510b5e0a74$export$2e2bcd8739ae039; });
function $826f66510b5e0a74$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});


parcelRegister("iggzA", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $d4b693ab17764574$export$ed5e13716264f202; });

var $cddpS = parcelRequire("cddpS");

var $hdDkD = parcelRequire("hdDkD");

var $6GjwS = parcelRequire("6GjwS");

var $6vNa9 = parcelRequire("6vNa9");

var $izxMR = parcelRequire("izxMR");

var $a4F1P = parcelRequire("a4F1P");

var $kU7zP = parcelRequire("kU7zP");


var $5u8iS = parcelRequire("5u8iS");
var $d4b693ab17764574$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $d4b693ab17764574$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $d4b693ab17764574$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $d4b693ab17764574$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $d4b693ab17764574$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5u8iS.isElement)(reference) ? (0, $6GjwS.default)(reference) : reference.contextElement ? (0, $6GjwS.default)(reference.contextElement) : [],
                    popper: (0, $6GjwS.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $izxMR.default)((0, $kU7zP.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$d4b693ab17764574$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $cddpS.default)(reference, (0, $6vNa9.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $hdDkD.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $a4F1P.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$d4b693ab17764574$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $d4b693ab17764574$export$8f7491d57c8f97a9 = /*#__PURE__*/ $d4b693ab17764574$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("cddpS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e411b26593e59b7$export$2e2bcd8739ae039; });

var $92OIM = parcelRequire("92OIM");

var $ij9IZ = parcelRequire("ij9IZ");

var $01DoM = parcelRequire("01DoM");

var $5u8iS = parcelRequire("5u8iS");

var $eWTJz = parcelRequire("eWTJz");

var $2us3t = parcelRequire("2us3t");

var $6BU1g = parcelRequire("6BU1g");

var $6CWdy = parcelRequire("6CWdy");
function $8e411b26593e59b7$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $6CWdy.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $6CWdy.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $8e411b26593e59b7$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5u8iS.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $5u8iS.isHTMLElement)(offsetParent) && $8e411b26593e59b7$var$isElementScaled(offsetParent);
    var documentElement = (0, $2us3t.default)(offsetParent);
    var rect = (0, $92OIM.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $01DoM.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $6BU1g.default)(documentElement)) scroll = (0, $ij9IZ.default)(offsetParent);
        if ((0, $5u8iS.isHTMLElement)(offsetParent)) {
            offsets = (0, $92OIM.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $eWTJz.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("ij9IZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5418b723c8bd332$export$2e2bcd8739ae039; });

var $bW8rb = parcelRequire("bW8rb");

var $2bPgR = parcelRequire("2bPgR");

var $5u8iS = parcelRequire("5u8iS");

var $5TcLL = parcelRequire("5TcLL");
function $d5418b723c8bd332$export$2e2bcd8739ae039(node) {
    if (node === (0, $2bPgR.default)(node) || !(0, $5u8iS.isHTMLElement)(node)) return (0, $bW8rb.default)(node);
    else return (0, $5TcLL.default)(node);
}

});
parcelRegister("5TcLL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $449bfe8d947e5e4a$export$2e2bcd8739ae039; });
function $449bfe8d947e5e4a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRegister("izxMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d855b449aae7d162$export$2e2bcd8739ae039; });

var $bfw5I = parcelRequire("bfw5I");
function $d855b449aae7d162$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d855b449aae7d162$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d855b449aae7d162$var$order(modifiers); // order based on phase
    return (0, $bfw5I.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("a4F1P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $755a1a7d5368146e$export$2e2bcd8739ae039; });
function $755a1a7d5368146e$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("kU7zP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37eea3e30501dd4$export$2e2bcd8739ae039; });
function $f37eea3e30501dd4$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});




parcelRegister("4tmaK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $341b11d054599aa2$export$2e2bcd8739ae039; });

var $7VtiN = parcelRequire("7VtiN");

var $6s2Od = parcelRequire("6s2Od");

var $spJKX = parcelRequire("spJKX");

var $1nkOT = parcelRequire("1nkOT");

var $gAujg = parcelRequire("gAujg");

var $feFtK = parcelRequire("feFtK");
const $341b11d054599aa2$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $341b11d054599aa2$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $341b11d054599aa2$var$noop;
    (0, $gAujg.default)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $1nkOT.default)((e)=>{
        if ((0, $feFtK.isEscKey)(e)) onClose(e);
    });
    (0, $spJKX.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $6s2Od.default)((0, $gAujg.getRefTarget)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $7VtiN.default)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $341b11d054599aa2$export$2e2bcd8739ae039 = $341b11d054599aa2$var$useRootClose;

});
parcelRegister("gAujg", function(module, exports) {

$parcel$export(module.exports, "getRefTarget", function () { return $c137850575c4d17e$export$347601c75fcd4732; });
$parcel$export(module.exports, "default", function () { return $c137850575c4d17e$export$2e2bcd8739ae039; });

var $e15HB = parcelRequire("e15HB");

var $7VtiN = parcelRequire("7VtiN");

var $6s2Od = parcelRequire("6s2Od");

var $spJKX = parcelRequire("spJKX");

var $1nkOT = parcelRequire("1nkOT");

var $6WYSv = parcelRequire("6WYSv");
const $c137850575c4d17e$var$noop = ()=>{};
function $c137850575c4d17e$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $c137850575c4d17e$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $c137850575c4d17e$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $c137850575c4d17e$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $c137850575c4d17e$var$useClickOutside(ref, onClickOutside = $c137850575c4d17e$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $spJKX.useRef)(false);
    const waitingForTrigger = (0, $spJKX.useRef)(false);
    const handleMouseCapture = (0, $spJKX.useCallback)((e)=>{
        const currentTarget = $c137850575c4d17e$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $c137850575c4d17e$var$isModifiedEvent(e) || !$c137850575c4d17e$var$isLeftClickEvent(e) || !!(0, $e15HB.default)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $1nkOT.default)((e)=>{
        const currentTarget = $c137850575c4d17e$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $e15HB.default)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $1nkOT.default)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $spJKX.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $6s2Od.default)($c137850575c4d17e$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($c137850575c4d17e$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $7VtiN.default)(doc, $c137850575c4d17e$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $7VtiN.default)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $7VtiN.default)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $7VtiN.default)(el, 'mousemove', $c137850575c4d17e$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $c137850575c4d17e$export$2e2bcd8739ae039 = $c137850575c4d17e$var$useClickOutside;

});


parcelRegister("jyTHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3dc6583a41693ef$export$2e2bcd8739ae039; });
function $e3dc6583a41693ef$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $e3dc6583a41693ef$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $e3dc6583a41693ef$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $e3dc6583a41693ef$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $e3dc6583a41693ef$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}

});


parcelRegister("didSY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ad7ba3746b6b89f$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $bVXmG = parcelRequire("bVXmG");

var $dz672 = parcelRequire("dz672");

var $1ewFu = parcelRequire("1ewFu");

var $jQNZJ = parcelRequire("jQNZJ");
"use client";
function $9ad7ba3746b6b89f$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $spJKX.useRef)(null);
    const popoverClass = (0, $dz672.useBootstrapPrefix)(undefined, 'popover');
    const tooltipClass = (0, $dz672.useBootstrapPrefix)(undefined, 'tooltip');
    const offset = (0, $spJKX.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bVXmG.default)(overlayRef.current, popoverClass)) return (0, $1ewFu.default).POPPER_OFFSET;
                        if ((0, $bVXmG.default)(overlayRef.current, tooltipClass)) return (0, $jQNZJ.default).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}

});
parcelRegister("1ewFu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e60707a9dfeb5c9$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $2XfSm = parcelRequire("2XfSm");

var $dOYNO = parcelRequire("dOYNO");

var $9lVJT = parcelRequire("9lVJT");

var $e2pHO = parcelRequire("e2pHO");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $0e60707a9dfeb5c9$var$Popover = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'popover');
    const isRTL = (0, $dz672.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $9lVJT.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $e2pHO.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dOYNO.default), {
                children: children
            }) : children
        ]
    });
});
$0e60707a9dfeb5c9$var$Popover.displayName = 'Popover';
var $0e60707a9dfeb5c9$export$2e2bcd8739ae039 = Object.assign($0e60707a9dfeb5c9$var$Popover, {
    Header: (0, $2XfSm.default),
    Body: (0, $dOYNO.default),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});

});
parcelRegister("2XfSm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $226d680cb5410f2b$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $226d680cb5410f2b$var$PopoverHeader = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$226d680cb5410f2b$var$PopoverHeader.displayName = 'PopoverHeader';
var $226d680cb5410f2b$export$2e2bcd8739ae039 = $226d680cb5410f2b$var$PopoverHeader;

});

parcelRegister("dOYNO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0ff1bf44591b259$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $a0ff1bf44591b259$var$PopoverBody = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$a0ff1bf44591b259$var$PopoverBody.displayName = 'PopoverBody';
var $a0ff1bf44591b259$export$2e2bcd8739ae039 = $a0ff1bf44591b259$var$PopoverBody;

});

parcelRegister("9lVJT", function(module, exports) {

$parcel$export(module.exports, "getOverlayDirection", function () { return $6cf2dd03c3859e25$export$c15856915a9b3464; });

var $spJKX = parcelRequire("spJKX");
class $6cf2dd03c3859e25$export$34582a676b91ff07 extends $spJKX.Component {
}
function $6cf2dd03c3859e25$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}

});

parcelRegister("e2pHO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a38531378104ab45$export$2e2bcd8739ae039; });
function $a38531378104ab45$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}

});


parcelRegister("jQNZJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e739a79367a69180$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $9lVJT = parcelRequire("9lVJT");

var $e2pHO = parcelRequire("e2pHO");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $e739a79367a69180$var$Tooltip = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'tooltip');
    const isRTL = (0, $dz672.useIsRTL)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $9lVJT.getOverlayDirection)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $e2pHO.default)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$e739a79367a69180$var$Tooltip.displayName = 'Tooltip';
var $e739a79367a69180$export$2e2bcd8739ae039 = Object.assign($e739a79367a69180$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});

});



parcelRegister("8VKFD", function(module, exports) {

$parcel$export(module.exports, "annotationBtn", function () { return $6807d96c0c897b12$export$2c1bbb5dc6e1a1c3; }, function (v) { return $6807d96c0c897b12$export$2c1bbb5dc6e1a1c3 = v; });
$parcel$export(module.exports, "annotationPreviewBubble", function () { return $6807d96c0c897b12$export$3b5a6760338ba651; }, function (v) { return $6807d96c0c897b12$export$3b5a6760338ba651 = v; });
$parcel$export(module.exports, "bubbleContent", function () { return $6807d96c0c897b12$export$2a2787b3ff8c035; }, function (v) { return $6807d96c0c897b12$export$2a2787b3ff8c035 = v; });
$parcel$export(module.exports, "bubbleText", function () { return $6807d96c0c897b12$export$bc489a46220551d3; }, function (v) { return $6807d96c0c897b12$export$bc489a46220551d3 = v; });
$parcel$export(module.exports, "columnPreview", function () { return $6807d96c0c897b12$export$b59caf56f5de4e5d; }, function (v) { return $6807d96c0c897b12$export$b59caf56f5de4e5d = v; });
var $6807d96c0c897b12$export$2c1bbb5dc6e1a1c3;
var $6807d96c0c897b12$export$3b5a6760338ba651;
var $6807d96c0c897b12$export$2a2787b3ff8c035;
var $6807d96c0c897b12$export$bc489a46220551d3;
var $6807d96c0c897b12$export$b59caf56f5de4e5d;
$6807d96c0c897b12$export$2c1bbb5dc6e1a1c3 = `mos-AnnotationPreviewBubble-module-p9ZkTW-annotationBtn`;
$6807d96c0c897b12$export$3b5a6760338ba651 = `mos-AnnotationPreviewBubble-module-p9ZkTW-annotationPreviewBubble`;
$6807d96c0c897b12$export$2a2787b3ff8c035 = `mos-AnnotationPreviewBubble-module-p9ZkTW-bubbleContent`;
$6807d96c0c897b12$export$bc489a46220551d3 = `mos-AnnotationPreviewBubble-module-p9ZkTW-bubbleText`;
$6807d96c0c897b12$export$b59caf56f5de4e5d = `mos-AnnotationPreviewBubble-module-p9ZkTW-columnPreview`;

});




parcelRegister("kqBs0", function(module, exports) {

$parcel$export(module.exports, "AitRemoveColumnButton", function () { return $c1aea0d57f2159de$export$4db8d1216848fd27; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $biia9 = parcelRequire("biia9");

var $eN4ax = parcelRequire("eN4ax");

var $9B5Sg = parcelRequire("9B5Sg");
const $c1aea0d57f2159de$export$4db8d1216848fd27 = ({ originalColumnIndex: originalColumnIndex })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const cellIds = (0, $spJKX.useMemo)(()=>{
        if (!state) return [];
        return [
            ...state.originalTableData.headerData !== false ? state.originalTableData.headerData.rows.flatMap((r)=>r.cells[originalColumnIndex].aitid) : [],
            ...state.originalTableData.bodyData.flatMap((rg)=>rg.rows.flatMap((r)=>r.cells[originalColumnIndex].aitid))
        ];
    }, [
        state,
        originalColumnIndex
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${state.id}-remcol-${originalColumnIndex}`,
        tipText: "Remove column",
        iconName: "aioxMinus",
        onClick: ()=>{
            dispatch({
                operation: (0, $9B5Sg.REMOVE_COLUMN),
                value: originalColumnIndex,
                cellIds: cellIds
            });
        }
    });
};
$c1aea0d57f2159de$export$4db8d1216848fd27.displayName = "AitRemoveColumnButton";

});



parcelRegister("dUiJM", function(module, exports) {

$parcel$export(module.exports, "AitCell", function () { return $8a3fa0d01e5bb3cd$export$3425f453fd376cda; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $6r4yf = parcelRequire("6r4yf");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $3tKzd = parcelRequire("3tKzd");

var $bP2ZH = parcelRequire("bP2ZH");

var $5t8UN = parcelRequire("5t8UN");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $eN4ax = parcelRequire("eN4ax");
const $8a3fa0d01e5bb3cd$export$3425f453fd376cda = ({ location: location, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const displayText = thisCell?.replacedText ?? thisCell?.text ?? state?.editorProps.blankT ?? (0, $hcEI9.defaultEditorDefns).blankT;
    // Static options/variables
    const currentReadOnly = (0, $spJKX.useMemo)(()=>!state || !thisCell ? true : !state.editable || location.isRepeat, [
        location.isRepeat,
        state,
        thisCell
    ]);
    // Update cell style when options change
    const cellStyle = (0, $spJKX.useMemo)(()=>{
        return !state || !thisCell ? {} : {
            overflow: "visible",
            width: `${state.colWidthMod * (thisCell.colWidth ?? // istanbul ignore next
            state.defaultCellWidth)}px`,
            paddingLeft: location.cellType === (0, $9B5Sg.AitCellType).rowHeader && thisCell.textIndents !== undefined ? `${thisCell.textIndents}rem` : undefined,
            borderLeft: state.showCellBorders ? "1px dashed burlywood" : "",
            borderBottom: state.showCellBorders ? "1px dashed burlywood" : "",
            borderRight: state.showCellBorders && location.column === (state.processedTableData?.rowHeaderColumns ?? // istanbul ignore next
            0) - 1 ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : "",
            borderTop: state.showCellBorders && location.row === 0 && location.rowGroup !== undefined && location.rowGroup > 0 ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : ""
        };
    }, [
        location.cellType,
        location.column,
        location.row,
        location.rowGroup,
        state,
        thisCell
    ]);
    // Traffic light
    const cellTrafficLight = !state?.noTrafficLights && !location.isRepeat && thisCell && ![
        "BlankNotEvaluated",
        "GreenOk"
    ].includes(thisCell.coreTrafficLight) ? new (0, $6r4yf.MosaicTrafficLightClass)(thisCell.coreTrafficLight, "-4px", "-8px", "absolute").element : null;
    // Render element
    return !state || !id || !state.processedTableData || !Editor || !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        ...rest,
        id: id,
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
            location.cellType === (0, $9B5Sg.AitCellType).rowHeader ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitRowHeaderCell : (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitBodyCell,
            currentReadOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitReadonlyCell : ""
        ]),
        style: cellStyle,
        role: "cell",
        onClick: (0, $5t8UN.clickCell),
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                style: {
                    width: `calc(${cellStyle.width} - ${thisCell.textIndents ?? // istanbul ignore next
                    0}rem)`,
                    height: "100%"
                },
                children: [
                    cellTrafficLight,
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
                        menuItems: [
                            {
                                label: "Show cell options",
                                action: ()=>{
                                    const focusDummy = document.createElement("input");
                                    document.body.appendChild(focusDummy);
                                    focusDummy.focus();
                                    focusDummy.remove();
                                    dispatch({
                                        operation: (0, $9B5Sg.SHOW_OPTIONS_WINDOW),
                                        location: location
                                    });
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                            id: `${id}-editor`,
                            decimalAlignPercent: state.processedTableData.decimalAlignPercent,
                            editable: !currentReadOnly,
                            preReplacedText: thisCell.text,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $9B5Sg.UPDATE_TABLE_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                });
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).editorInput,
                            textAlignment: !thisCell.justifyText || thisCell.justifyText === "default" ? location.column < (state.processedTableData.rowHeaderColumns ?? // istanbul ignore next
                            0) ? "left" : "center" : thisCell.justifyText,
                            value: displayText,
                            commentConfig: {
                                id: id,
                                activeContext: "TlfItem",
                                label: "New cell comment",
                                iconPosition: {
                                    top: "-2px",
                                    left: "-2px"
                                },
                                noIcon: location.isRepeat
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bP2ZH.AitCellWindow), {
                location: location
            })
        ]
    });
};
$8a3fa0d01e5bb3cd$export$3425f453fd376cda.displayName = "AitCell";

});
parcelRegister("bP2ZH", function(module, exports) {

$parcel$export(module.exports, "AitCellWindow", function () { return $e67f9a0ecfbe11fb$export$733ecc2d57f07177; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $eBlbF = parcelRequire("eBlbF");

var $9zfAS = parcelRequire("9zfAS");

var $cOw5F = parcelRequire("cOw5F");

var $7oyMA = parcelRequire("7oyMA");

var $287aM = parcelRequire("287aM");

var $loRW9 = parcelRequire("loRW9");

var $1Hl8A = parcelRequire("1Hl8A");

var $ltooE = parcelRequire("ltooE");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $eN4ax = parcelRequire("eN4ax");
const $e67f9a0ecfbe11fb$export$733ecc2d57f07177 = ({ location: location })=>{
    // Context
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return !Editor || !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextWindow), {
        id: `${id}-window`,
        title: "Cell options",
        visible: state.showOptionsWindow.findIndex((l)=>(0, $eBlbF.isEqual)(l, location)) > -1,
        onClose: ()=>{
            dispatch({
                operation: (0, $9B5Sg.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ltooE.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("label", {
                        id: `${id}-unprocessed-label`,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
                        htmlFor: `${id}-unprocessed`,
                        children: "Unprocessed text:"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioInputHolder,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                            id: `${id}-unprocessed`,
                            value: thisCell.text,
                            setValue: (ret)=>location.position === (0, $9B5Sg.AitTablePosition).bodyCell ? dispatch({
                                    operation: (0, $9B5Sg.UPDATE_TABLE_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                }) : dispatch({
                                    operation: (0, $9B5Sg.UPDATE_HEADER_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                }),
                            editable: !thisCell.readOnly && !location.isRepeat && state.editable,
                            className: !thisCell.readOnly && !location.isRepeat && state.editable ? "can-edit" : "readonly",
                            textAlignment: thisCell.justifyText,
                            decimalAlignPercent: state.processedTableData?.decimalAlignPercent,
                            "aria-labelledby": `${id}-unprocessed-label`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cOw5F.AitCellAlign), {
                location: location
            }),
            location.position === (0, $9B5Sg.AitTablePosition).headerCell && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1Hl8A.AitCellWidth), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $loRW9.AitCellRowSpans), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7oyMA.AitCellColSpans), {
                        location: location
                    })
                ]
            }),
            location.cellType === (0, $9B5Sg.AitCellType).rowHeader && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $287aM.AitCellIndents), {
                location: location
            })
        ]
    }, "Cell");
};
$e67f9a0ecfbe11fb$export$733ecc2d57f07177.displayName = "AitCellWindow";

});
parcelRegister("cOw5F", function(module, exports) {

$parcel$export(module.exports, "AitCellAlign", function () { return $9f63c21d8b6c2c99$export$e5f5529ff06758f9; });

var $bR5nk = parcelRequire("bR5nk");

var $gGo2X = parcelRequire("gGo2X");

var $9zfAS = parcelRequire("9zfAS");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $eN4ax = parcelRequire("eN4ax");
const $9f63c21d8b6c2c99$export$e5f5529ff06758f9 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gGo2X.AioSelect), {
            id: `${id}-justify`,
            label: "Justify text",
            value: thisCell.justifyText === undefined ? "Default" : thisCell.justifyText.charAt(0).toUpperCase() + thisCell.justifyText.substring(1).toLowerCase(),
            availableValues: [
                "Default",
                "Left",
                "Center",
                "Right",
                "Decimal"
            ],
            setValue: !thisCell.readOnly && !location.isRepeat ? (ret)=>location.position === (0, $9B5Sg.AitTablePosition).headerCell ? dispatch({
                    operation: (0, $9B5Sg.UPDATE_HEADER_CELL),
                    location: location,
                    cellData: {
                        justifyText: ret.toLowerCase()
                    }
                }) : dispatch({
                    operation: (0, $9B5Sg.UPDATE_TABLE_CELL),
                    location: location,
                    cellData: {
                        justifyText: ret.toLowerCase()
                    }
                }) : undefined
        })
    });
};
$9f63c21d8b6c2c99$export$e5f5529ff06758f9.displayName = "AitCellAlign";

});

parcelRegister("7oyMA", function(module, exports) {

$parcel$export(module.exports, "AitCellColSpans", function () { return $f896ccbd87cfc794$export$c3eed5616b8ae6c5; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $3slWx = parcelRequire("3slWx");

var $9rj0c = parcelRequire("9rj0c");

var $2LFD1 = parcelRequire("2LFD1");

var $eN4ax = parcelRequire("eN4ax");
const $f896ccbd87cfc794$export$c3eed5616b8ae6c5 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const originalHeaderData = state?.originalTableData.headerData;
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const changeColSpan = (0, $spJKX.useMemo)(()=>{
        if (originalHeaderData && thisCell) {
            const canAdd = (0, $3slWx.trCanAddColSpan)(originalHeaderData, location, thisCell.colSpan + 1, state?.originalTableData.rowHeaderColumns ?? // istanbul ignore next
            0);
            const canRemove = (0, $2LFD1.trCanRemoveColSpan)(originalHeaderData, location, thisCell.colSpan - 1);
            return {
                canAdd: canAdd.canAdd,
                canRemove: canRemove.canRemove
            };
        }
        return {
            canAdd: false,
            canRemove: false
        };
    }, [
        location,
        originalHeaderData,
        state?.originalTableData.rowHeaderColumns,
        thisCell
    ]);
    return !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
                children: "Column span: "
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioRoValue,
                children: thisCell.repeatColSpan ?? thisCell.colSpan
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).padding2
                ]),
                children: [
                    changeColSpan.canAdd !== false ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        id: `${id}-add-colspan`,
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxPlus
                        ]),
                        title: "Add column span",
                        "aria-label": "Add column span",
                        onClick: ()=>dispatch({
                                operation: (0, $9B5Sg.ADD_COLUMN_SPAN),
                                location: location,
                                newSpan: thisCell.colSpan + 1
                            })
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton
                    }),
                    changeColSpan.canRemove !== false && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        id: `${id}-remove-colspan`,
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxMinus
                        ]),
                        title: "Remove column span",
                        "aria-label": "Remove column span",
                        onClick: ()=>dispatch({
                                operation: (0, $9B5Sg.REMOVE_COLUMN_SPAN),
                                location: location,
                                newSpan: thisCell.colSpan - 1
                            })
                    })
                ]
            })
        ]
    });
};
$f896ccbd87cfc794$export$c3eed5616b8ae6c5.displayName = "AitCellColSpans";

});

parcelRegister("287aM", function(module, exports) {

$parcel$export(module.exports, "AitCellIndents", function () { return $4790c4b7d5a28f56$export$23c33c832c8301fd; });

var $bR5nk = parcelRequire("bR5nk");

var $kHJeU = parcelRequire("kHJeU");

var $9zfAS = parcelRequire("9zfAS");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $eN4ax = parcelRequire("eN4ax");
const $4790c4b7d5a28f56$export$23c33c832c8301fd = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return !thisCell || location.cellType !== (0, $9B5Sg.AitCellType).rowHeader ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kHJeU.AioNumber), {
            id: `${id}-indents`,
            label: "Text indents",
            value: thisCell.textIndents ?? // istanbul ignore next
            0,
            setValue: !thisCell.readOnly && !location.isRepeat ? (ret)=>dispatch({
                    operation: (0, $9B5Sg.UPDATE_TABLE_CELL),
                    location: location,
                    cellData: {
                        textIndents: ret
                    }
                }) : undefined
        })
    });
};
$4790c4b7d5a28f56$export$23c33c832c8301fd.displayName = "AitCellIndents";

});

parcelRegister("loRW9", function(module, exports) {

$parcel$export(module.exports, "AitCellRowSpans", function () { return $be0aa164e9a09b34$export$740be5db2e61b2a3; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $3oVEB = parcelRequire("3oVEB");

var $9rj0c = parcelRequire("9rj0c");

var $fEtEI = parcelRequire("fEtEI");

var $eN4ax = parcelRequire("eN4ax");
const $be0aa164e9a09b34$export$740be5db2e61b2a3 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const originalHeaderData = state?.originalTableData.headerData;
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const changeRowSpan = (0, $spJKX.useMemo)(()=>{
        if (originalHeaderData && thisCell) {
            const canAdd = (0, $3oVEB.trCanAddRowSpan)(originalHeaderData, location, thisCell.rowSpan + 1);
            const canRemove = (0, $fEtEI.trCanRemoveRowSpan)(originalHeaderData, location, thisCell.rowSpan - 1);
            return {
                canAdd: canAdd.canAdd,
                canRemove: canRemove.canRemove
            };
        }
        return {
            canAdd: false,
            canRemove: false
        };
    }, [
        originalHeaderData,
        thisCell,
        location
    ]);
    return !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
                children: "Row span: "
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioRoValue,
                children: thisCell.repeatRowSpan ?? thisCell.rowSpan
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).padding2
                ]),
                children: [
                    changeRowSpan.canAdd ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        id: `${id}-add-rowspan`,
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxPlus
                        ]),
                        title: "Add row span",
                        "aria-label": "Add row span",
                        onClick: ()=>dispatch({
                                operation: (0, $9B5Sg.ADD_ROW_SPAN),
                                location: location,
                                newSpan: thisCell.rowSpan + 1
                            })
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton
                    }),
                    changeRowSpan.canRemove && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        id: `${id}-remove-rowspan`,
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
                            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxMinus
                        ]),
                        title: "Remove row span",
                        "aria-label": "Remove row span",
                        onClick: ()=>dispatch({
                                operation: (0, $9B5Sg.REMOVE_ROW_SPAN),
                                location: location,
                                newSpan: thisCell.rowSpan - 1
                            })
                    })
                ]
            })
        ]
    });
};
$be0aa164e9a09b34$export$740be5db2e61b2a3.displayName = "AitCellRowSpans";

});

parcelRegister("1Hl8A", function(module, exports) {

$parcel$export(module.exports, "AitCellWidth", function () { return $fb581ddcf5b66f30$export$dc84ad22932f5ba1; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $kHJeU = parcelRequire("kHJeU");

var $9zfAS = parcelRequire("9zfAS");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $fb581ddcf5b66f30$export$dc84ad22932f5ba1 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const displayColWidth = (0, $spJKX.useMemo)(()=>{
        if (state && location.position === (0, $9B5Sg.AitTablePosition).headerCell && thisCell) {
            const thisHeaderCell = thisCell;
            if (thisHeaderCell.colSpan >= 2) {
                const thisHeaderRow = (0, $lyZtY.trGetPositionFromLocation)(state, {
                    ...location,
                    position: (0, $9B5Sg.AitTablePosition).headerRow
                }).data;
                /* istanbul ignore else */ if (thisHeaderRow) return {
                    width: thisHeaderRow.cells.slice(location.column, location.column + thisHeaderCell.colSpan).map((c)=>c.colWidth ?? // istanbul ignore next
                        state.defaultCellWidth).reduce((a, b)=>a + b, 0),
                    calculated: true
                };
            }
        }
        return {
            width: thisCell?.colWidth
        };
    }, [
        location,
        state,
        thisCell
    ]);
    return !state || !thisCell ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kHJeU.AioNumber), {
            id: `${id}-width`,
            label: "Width (mm)",
            value: displayColWidth.width ?? // istanbul ignore next
            state.defaultCellWidth,
            setValue: state.editable && !displayColWidth.calculated && !location.isRepeat ? (ret)=>dispatch({
                    operation: (0, $9B5Sg.UPDATE_COLUMN_WIDTH),
                    location: location,
                    value: ret
                }) : undefined
        })
    });
};
$fb581ddcf5b66f30$export$dc84ad22932f5ba1.displayName = "AitCellWidth";

});

parcelRegister("ltooE", function(module, exports) {

$parcel$export(module.exports, "AitCommentRow", function () { return $d11897aeec7f7b28$export$c897d27006e3cd3a; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $8kv8T = parcelRequire("8kv8T");

var $9zfAS = parcelRequire("9zfAS");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $d11897aeec7f7b28$export$c897d27006e3cd3a = ({ location: location })=>{
    const id = (0, $spJKX.useId)();
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const locationPoint = (0, $lyZtY.trGetPositionFromLocation)(state, location, true);
    const thisComment = locationPoint.data && "comments" in locationPoint.data ? locationPoint.data.comments : "";
    const isLocationRepeat = "isRepeat" in location ? location.isRepeat : false;
    return !state ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8kv8T.AioComment), {
            id: `${state.id}-${location.position}-comment-${id}`,
            label: "Notes",
            value: thisComment,
            editable: state.editable && !isLocationRepeat,
            setValue: (ret)=>{
                dispatch({
                    operation: (0, $9B5Sg.UPDATE_COMMENTS),
                    location: location,
                    comment: ret
                });
            }
        })
    });
};
$d11897aeec7f7b28$export$c897d27006e3cd3a.displayName = "AitCommentRow";

});


parcelRegister("5t8UN", function(module, exports) {

$parcel$export(module.exports, "clickCell", function () { return $66fbc346b3fd3978$export$42e583b3f7d813c2; });
$parcel$export(module.exports, "AitHeaderCell", function () { return $66fbc346b3fd3978$export$bf406f4913f10b4a; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $9zfAS = parcelRequire("9zfAS");

var $6r4yf = parcelRequire("6r4yf");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");

var $3tKzd = parcelRequire("3tKzd");

var $bP2ZH = parcelRequire("bP2ZH");

var $eN4ax = parcelRequire("eN4ax");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $9rj0c = parcelRequire("9rj0c");

var $lyZtY = parcelRequire("lyZtY");
const $66fbc346b3fd3978$export$42e583b3f7d813c2 = (e)=>{
    e.preventDefault();
    e.stopPropagation();
    if (e.target instanceof HTMLTableCellElement) {
        const innerClick = new MouseEvent("click", {
            bubbles: true,
            cancelable: true
        });
        const editor = e.target.querySelector("div.aiev3");
        editor?.dispatchEvent(innerClick);
    }
};
const $66fbc346b3fd3978$export$bf406f4913f10b4a = ({ location: location, ...rest })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const Editor = state?.editorProps.Editor;
    const thisCell = state?.processedTableData ? (0, $9rj0c.trGetCellFromLocation)(state.processedTableData, location) : undefined;
    const thisHeaderRow = (0, $lyZtY.trGetPositionFromLocation)(state, {
        ...location,
        position: (0, $9B5Sg.AitTablePosition).headerRow
    }, true).data;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const displayText = thisCell?.replacedText ?? thisCell?.text ?? state?.editorProps.blankT ?? (0, $hcEI9.defaultEditorDefns).blankT;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 1;
    const decimalAlignPercent = state?.processedTableData?.decimalAlignPercent ?? 60;
    // Static options/variables
    const currentReadOnly = (0, $spJKX.useMemo)(()=>!state || !thisCell ? true : !state.editable || location.isRepeat, [
        location.isRepeat,
        state,
        thisCell
    ]);
    const displayColWidth = (0, $spJKX.useMemo)(()=>{
        if ((thisCell?.repeatColSpan ?? thisCell?.colSpan ?? 1) >= 2) {
            /* istanbul ignore else */ if (thisHeaderRow) return {
                width: thisHeaderRow.cells.slice(location.column, location.column + (thisCell.repeatColSpan ?? thisCell.colSpan)).map((c)=>c.colWidth ?? // istanbul ignore next
                    state.defaultCellWidth).reduce((a, b)=>a + b, 0),
                calculated: true
            };
        }
        return {
            width: thisCell?.colWidth ?? 0
        };
    }, [
        location.column,
        state,
        thisCell,
        thisHeaderRow
    ]);
    // Update cell style when options change
    const cellStyle = (0, $spJKX.useMemo)(()=>!state || !thisCell ? {} : {
            overflow: "visible",
            width: `${state.colWidthMod * displayColWidth.width}px`,
            borderLeft: state.showCellBorders ? "1px dashed burlywood" : "",
            borderBottom: state.showCellBorders ? "1px dashed burlywood" : "",
            borderRight: state.showCellBorders && location.column === (state.processedTableData?.rowHeaderColumns ?? // istanbul ignore next
            0) - thisCell.colSpan ? "1px solid burlywood" : state.showCellBorders ? "1px dashed burlywood" : "",
            borderTop: state.showCellBorders && location.row === 0 && location.rowGroup !== undefined && state.showCellBorders ? "1px dashed burlywood" : ""
        }, [
        displayColWidth.width,
        location.column,
        location.row,
        location.rowGroup,
        state,
        thisCell
    ]);
    // Traffic light
    const cellTrafficLight = !state?.noTrafficLights && !location.isRepeat && thisCell && ![
        "BlankNotEvaluated",
        "GreenOk"
    ].includes(thisCell.coreTrafficLight) ? new (0, $6r4yf.MosaicTrafficLightClass)(thisCell.coreTrafficLight, "-4px", "-8px", "absolute").element : null;
    // Render element
    return !Editor || !thisCell || thisCell.colSpan === 0 || thisCell.rowSpan === 0 || thisCell.repeatColSpan === 0 || thisCell.repeatRowSpan === 0 || location.row === undefined || location.column === undefined ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        ...rest,
        id: id,
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitHeaderCell,
            currentReadOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitReadonlyCell : ""
        ]),
        colSpan: thisCell.repeatColSpan ?? thisCell.colSpan,
        rowSpan: (thisCell.repeatRowSpan ?? thisCell.rowSpan) + (thisCell.spaceAfterSpan ?? 0),
        style: cellStyle,
        onClick: $66fbc346b3fd3978$export$42e583b3f7d813c2,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                style: {
                    width: cellStyle.width,
                    height: "100%"
                },
                children: [
                    cellTrafficLight,
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
                        menuItems: [
                            {
                                label: "Show cell options",
                                action: ()=>{
                                    const focusDummy = document.createElement("input");
                                    document.body.appendChild(focusDummy);
                                    focusDummy.focus();
                                    focusDummy.remove();
                                    dispatch({
                                        operation: (0, $9B5Sg.SHOW_OPTIONS_WINDOW),
                                        location: location
                                    });
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Editor, {
                            id: `${id}-editor`,
                            decimalAlignPercent: decimalAlignPercent,
                            editable: !currentReadOnly,
                            preReplacedText: thisCell.text,
                            setValue: (ret)=>{
                                dispatch({
                                    operation: (0, $9B5Sg.UPDATE_HEADER_CELL),
                                    location: location,
                                    cellData: {
                                        text: ret
                                    }
                                });
                            },
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).editorInput,
                            textAlignment: !thisCell.justifyText || thisCell.justifyText === "default" ? location.column < (rowHeaderColumns ?? // istanbul ignore next
                            0) ? "left" : "center" : thisCell.justifyText,
                            value: displayText,
                            commentConfig: {
                                id: id ?? // istanbul ignore next
                                "",
                                activeContext: "TlfItem",
                                label: "New cell comment",
                                iconPosition: {
                                    top: "-2px",
                                    left: "-2px"
                                },
                                noIcon: location.isRepeat
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bP2ZH.AitCellWindow), {
                location: location
            })
        ]
    });
};
$66fbc346b3fd3978$export$bf406f4913f10b4a.displayName = "AitHeaderCell";

});


parcelRegister("65PFO", function(module, exports) {

$parcel$export(module.exports, "AitColumnAnnotationPreviewRow", function () { return $81503d0d035fea27$export$3ca059bedcde62a; });

var $bR5nk = parcelRequire("bR5nk");

var $hrmRP = parcelRequire("hrmRP");

var $2o69n = parcelRequire("2o69n");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");

var $3tKzd = parcelRequire("3tKzd");

var $dT60i = parcelRequire("dT60i");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $81503d0d035fea27$export$3ca059bedcde62a = ()=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const headerData = state?.processedTableData?.headerData;
    const ref = (0, $spJKX.useRef)(null);
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    const columnRepeats = state?.processedTableData?.columnRepeats ?? // istanbul ignore next
    [];
    const [annotationModalState, setAnnotationModalState] = (0, $spJKX.useState)({
        isOpen: false
    });
    if (!showAnnotationPreview || !headerData) return null;
    // Get the last row of the header to access column annotations
    const lastHeaderRow = headerData.rows[headerData.rows.length - 1];
    if (!lastHeaderRow) return null;
    const annotationModal = annotationModalState.isOpen && annotationModalState.cellId !== undefined && annotationModalState.columnIndex !== undefined && annotationModalState.originalColumnIndex !== undefined ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hrmRP.AnnotationContextWindow), {
        isOpen: annotationModalState.isOpen,
        onClose: ()=>setAnnotationModalState({
                isOpen: false
            }),
        annotationLocation: {
            position: (0, $9B5Sg.AitTablePosition).column,
            columnId: annotationModalState.cellId,
            originalColumn: annotationModalState.originalColumnIndex
        },
        annotationType: "Column",
        contextAnnotation: state.originalTableData.columnInformation?.find((ci)=>ci.columnId === annotationModalState.cellId)?.annotation,
        disabled: !state.editable
    }) : null;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("tr", {
                ref: ref,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("td", {
                        className: "ait-cell"
                    }),
                    lastHeaderRow.cells.map((cell, ci)=>{
                        // Calculate effective colspan (accounts for column repeats)
                        const effectiveColSpan = cell.repeatColSpan ?? cell.colSpan;
                        // Calculate the width based on effective colspan
                        const cellWidth = effectiveColSpan >= 2 ? lastHeaderRow.cells.slice(ci, ci + effectiveColSpan).map((c)=>c.colWidth ?? // istanbul ignore next
                            state.defaultCellWidth).reduce((a, b)=>a + b, 0) : cell.colWidth ?? // istanbul ignore next
                        state.defaultCellWidth;
                        const displayWidth = `${state.colWidthMod * cellWidth}px`;
                        // Get original column index from columnRepeats
                        const originalColumnIndex = columnRepeats[ci]?.columnIndex ?? // istanbul ignore next
                        ci;
                        const isColumnRepeat = columnRepeats[ci] !== undefined && columnRepeats[ci].colRepeat !== undefined ? columnRepeats[ci].colRepeat.match(/^[[\]0,]+$/) === null : false;
                        // Get the annotation for this column from columnInformation
                        const columnAnnotation = state.originalTableData.columnInformation?.find((colInfo)=>colInfo.columnId === cell.columnId)?.annotation;
                        return /*#__PURE__*/ (0, $bR5nk.jsx)("td", {
                            className: (0, $3tKzd.classMerge)([
                                `ait-cell ${(0, (/*@__PURE__*/$parcel$interopDefault($dT60i))).columnAnnotationCell}`
                            ]),
                            colSpan: effectiveColSpan,
                            style: {
                                width: displayWidth,
                                minWidth: displayWidth,
                                maxWidth: displayWidth
                            },
                            children: !isColumnRepeat && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2o69n.AnnotationPreviewBubble), {
                                annotation: columnAnnotation,
                                variant: "column",
                                target: ref,
                                onClick: ()=>{
                                    setAnnotationModalState({
                                        isOpen: true,
                                        cellId: cell.columnId,
                                        columnIndex: ci,
                                        originalColumnIndex: originalColumnIndex
                                    });
                                }
                            })
                        }, `col-annotation-${cell.columnId}-${ci}`);
                    })
                ]
            }),
            annotationModal && typeof document !== "undefined" ? /*#__PURE__*/ (0, $oS63j.createPortal)(annotationModal, document.body) : null
        ]
    });
};
$81503d0d035fea27$export$3ca059bedcde62a.displayName = "AitColumnAnnotationPreviewRow";

});
parcelRegister("dT60i", function(module, exports) {

$parcel$export(module.exports, "columnAnnotationCell", function () { return $a1c511a18676fd7f$export$35fa903b7f71b39; }, function (v) { return $a1c511a18676fd7f$export$35fa903b7f71b39 = v; });
var $a1c511a18676fd7f$export$35fa903b7f71b39;
$a1c511a18676fd7f$export$35fa903b7f71b39 = `mos-AitColumnAnnotationPreviewRow-module-lKuulq-columnAnnotationCell`;

});


parcelRegister("8FBJ2", function(module, exports) {

$parcel$export(module.exports, "AitHeader", function () { return $dda9c09f4888bb54$export$602f446165ff67c5; });

var $bR5nk = parcelRequire("bR5nk");

var $dPawg = parcelRequire("dPawg");

var $65PFO = parcelRequire("65PFO");

var $1oqzu = parcelRequire("1oqzu");

var $eN4ax = parcelRequire("eN4ax");

var $9B5Sg = parcelRequire("9B5Sg");
const $dda9c09f4888bb54$export$602f446165ff67c5 = ()=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisHeader = state?.processedTableData?.headerData;
    const id = `${state?.id}-header`;
    const rows = thisHeader ? thisHeader.rows : [];
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("thead", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dPawg.AitBorderRow), {
                id: `${id}-top-border`,
                spaceAfter: true,
                topBorder: true
            }),
            showAnnotationPreview && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $65PFO.AitColumnAnnotationPreviewRow), {}),
            thisHeader && rows.map((row, ri)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $1oqzu.AitHeaderRow), {
                    location: {
                        tableSection: (0, $9B5Sg.AitRowType).header,
                        position: (0, $9B5Sg.AitTablePosition).headerRow,
                        rowGroup: 0,
                        rowGroupId: thisHeader.aitid,
                        rowId: row.aitid,
                        rowRepeat: undefined,
                        row: ri,
                        isRepeat: false
                    }
                }, row.aitid)),
            // No border required if thisHeader is false/undefined
            !thisHeader || rows.length === 0 ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dPawg.AitBorderRow), {
                id: `${id}-midtable-border`,
                spaceBefore: true,
                spaceAfter: true
            })
        ]
    });
};
$dda9c09f4888bb54$export$602f446165ff67c5.displayName = "AitHeader";

});
parcelRegister("1oqzu", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRow", function () { return $3e6824a7b297f82c$export$7b1459f869ce1381; });

var $bR5nk = parcelRequire("bR5nk");

var $5t8UN = parcelRequire("5t8UN");

var $dHyIs = parcelRequire("dHyIs");

var $4wViJ = parcelRequire("4wViJ");

var $eN4ax = parcelRequire("eN4ax");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");
const $3e6824a7b297f82c$export$7b1459f869ce1381 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const thisHeaderRow = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const columnRepeats = state?.processedTableData?.columnRepeats;
    return !state || !state.processedTableData || !thisHeaderRow || !columnRepeats || location.row === undefined ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("tr", {
        id: id,
        role: "row",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dHyIs.AitHeaderRowFirstCell), {
                location: location
            }),
            thisHeaderRow.cells.map((cell, ci)=>{
                // Get cell from column repeat
                const cr = Array.isArray(columnRepeats) && columnRepeats.length > ci ? columnRepeats[ci] : undefined;
                const isColumnRepeat = cr !== undefined && cr.colRepeat !== undefined ? cr.colRepeat.match(/^[[\]0,]+$/) === null : false;
                return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5t8UN.AitHeaderCell), {
                    location: {
                        ...location,
                        position: (0, $9B5Sg.AitTablePosition).headerCell,
                        cellId: cell.aitid,
                        cellType: (0, $9B5Sg.AitCellType).header,
                        column: ci,
                        colRepeat: cr?.colRepeat ?? "",
                        isRepeat: location.isRepeat || isColumnRepeat,
                        originalColumn: columnRepeats[ci].columnIndex
                    }
                }, `${cell.aitid}-${ci}`);
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4wViJ.AitHeaderRowLastCell), {
                location: location
            })
        ]
    });
};
$3e6824a7b297f82c$export$7b1459f869ce1381.displayName = "AitHeaderRow";

});
parcelRegister("dHyIs", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRowFirstCell", function () { return $011b73bd10bc7f44$export$e63bcac22f65f481; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $ckomf = parcelRequire("ckomf");

var $bNi0z = parcelRequire("bNi0z");

var $SaWDM = parcelRequire("SaWDM");

var $9B5Sg = parcelRequire("9B5Sg");
const $011b73bd10bc7f44$export$e63bcac22f65f481 = ({ location: location })=>/*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $SaWDM.AitRowGroupTrafficLight), {
                location: {
                    ...location,
                    position: (0, $9B5Sg.AitTablePosition).header
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitRowGroupButtons,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexRowEnd
                ]),
                children: location.row === 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bNi0z.AitRowGroupOptionsButton), {
                            location: {
                                position: (0, $9B5Sg.AitTablePosition).header,
                                tableSection: location.tableSection,
                                rowGroup: location.rowGroup,
                                rowGroupId: location.rowGroupId
                            }
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ckomf.AitHeaderOptionsWindow), {})
                    ]
                })
            })
        ]
    });
$011b73bd10bc7f44$export$e63bcac22f65f481.displayName = "AitHeaderRowFirstCell";

});
parcelRegister("ckomf", function(module, exports) {

$parcel$export(module.exports, "AitHeaderOptionsWindow", function () { return $679eb92150ada30c$export$f138948b670bdfe5; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $eBlbF = parcelRequire("eBlbF");

var $ltooE = parcelRequire("ltooE");

var $bVXtb = parcelRequire("bVXtb");

var $1MT5N = parcelRequire("1MT5N");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $679eb92150ada30c$export$f138948b670bdfe5 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const headerData = state?.processedTableData?.headerData;
    const location = {
        position: (0, $9B5Sg.AitTablePosition).header,
        tableSection: (0, $9B5Sg.AitRowType).header,
        rowGroup: 0,
        rowGroupId: headerData ? headerData.aitid : ""
    };
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return !headerData ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextWindow), {
        id: `${id}-header-options-window`,
        title: "Header options",
        visible: state.showOptionsWindow.findIndex((l)=>(0, $eBlbF.isEqual)(l, location)) > -1,
        onClose: ()=>{
            dispatch({
                operation: (0, $9B5Sg.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        style: {
            maxHeight: "75vh"
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ltooE.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1MT5N.AitRowHeaderColumns), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bVXtb.AitRowGroupReplacements), {
                location: location
            })
        ]
    });
};
$679eb92150ada30c$export$f138948b670bdfe5.displayName = "AitHeaderOptionsWindow";

});
parcelRegister("bVXtb", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupReplacements", function () { return $68fd5f5ade9a2301$export$2f4ea3c13f465f1b; });

var $bR5nk = parcelRequire("bR5nk");

var $3Gn2b = parcelRequire("3Gn2b");

var $9zfAS = parcelRequire("9zfAS");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $68fd5f5ade9a2301$export$2f4ea3c13f465f1b = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = state?.processedTableData ? (0, $lyZtY.trGetPositionFromLocation)(state, location).data : undefined;
    const id = `${(0, $ickJu.getBaseId)(location, state?.id)}-replacements`;
    return !state || !thisRowGroup ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3Gn2b.AioReplacementList), {
            id: id,
            label: "Replacements",
            replacements: thisRowGroup.replacements ?? // istanbul ignore next
            [],
            setReplacements: state.editable ? (ret)=>dispatch({
                    operation: (0, $9B5Sg.SET_REPLACEMENTS),
                    location: location,
                    replacements: ret
                }) : undefined,
            externalLists: state.externalLists,
            dontAskSpace: location.tableSection === (0, $9B5Sg.AitRowType).header,
            dontAskTrail: location.tableSection === (0, $9B5Sg.AitRowType).header,
            editorProps: state.editorProps,
            level: 0
        })
    });
};
$68fd5f5ade9a2301$export$2f4ea3c13f465f1b.displayName = "AitRowGroupReplacements";

});

parcelRegister("1MT5N", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumns", function () { return $2f8b6d0c0ec514da$export$b23b6e9eae0c3bf5; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $jhDwO = parcelRequire("jhDwO");

var $fCjoA = parcelRequire("fCjoA");

var $eN4ax = parcelRequire("eN4ax");
const $2f8b6d0c0ec514da$export$b23b6e9eae0c3bf5 = ()=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioLabel,
                children: "Row headers: "
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                "aria-label": "Row headers",
                role: "status",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioRoValue,
                children: rowHeaderColumns
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButtonHolder,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).padding2
                ]),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jhDwO.AitRowHeaderColumnsAdd), {}),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fCjoA.AitRowHeaderColumnsRemove), {})
                ]
            })
        ]
    });
};
$2f8b6d0c0ec514da$export$b23b6e9eae0c3bf5.displayName = "AitRowHeaderColumns";

});
parcelRegister("jhDwO", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumnsAdd", function () { return $2526603208197f7f$export$7275d6cab1e25d6; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $2526603208197f7f$export$7275d6cab1e25d6 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return state && state.editable && state.processedTableData?.bodyData && state.processedTableData?.bodyData.length > 0 && state.processedTableData?.bodyData[0].rows.length > 0 && rowHeaderColumns < state.processedTableData?.bodyData[0].rows[0].cells.length - 1 ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: `${state.id}-add-row-header-column`,
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxPlus
        ]),
        "aria-label": "Increase row header columns",
        role: "button",
        onClick: ()=>dispatch({
                operation: (0, $9B5Sg.SET_ROW_HEADER_COLUMNS),
                value: rowHeaderColumns + 1
            })
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton
    });
};
$2526603208197f7f$export$7275d6cab1e25d6.displayName = "AitRowHeaderColumnsAdd";

});

parcelRegister("fCjoA", function(module, exports) {

$parcel$export(module.exports, "AitRowHeaderColumnsRemove", function () { return $b4bdace54de5540b$export$107228130358bd8b; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $b4bdace54de5540b$export$107228130358bd8b = ()=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns !== undefined ? state.processedTableData.rowHeaderColumns : 1;
    return !state || !state.editable || rowHeaderColumns === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, $3tKzd.classMerge)([
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxButton,
            (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aioxMinus
        ]),
        id: `${state.id}-remove-row-header-column`,
        "aria-label": "Decrease row header columns",
        role: "button",
        onClick: ()=>dispatch({
                operation: (0, $9B5Sg.SET_ROW_HEADER_COLUMNS),
                value: rowHeaderColumns - 1
            })
    });
};
$b4bdace54de5540b$export$107228130358bd8b.displayName = "AitRowHeaderColumnsRemove";

});



parcelRegister("bNi0z", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupOptionsButton", function () { return $7703425acb329dea$export$217609e4806a14a5; });

var $bR5nk = parcelRequire("bR5nk");

var $eBlbF = parcelRequire("eBlbF");

var $biia9 = parcelRequire("biia9");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $7703425acb329dea$export$217609e4806a14a5 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${id}-rowgroup-options`,
        tipText: location.position === (0, $9B5Sg.AitTablePosition).header ? "Header options" : "Row group options",
        iconName: "aioxButtonRowGroup",
        onClick: ()=>{
            dispatch({
                operation: state?.showOptionsWindow.findIndex((l)=>(0, $eBlbF.isEqual)(l, location)) === -1 ? (0, $9B5Sg.SHOW_OPTIONS_WINDOW) : (0, $9B5Sg.HIDE_OPTIONS_WINDOW),
                location: location
            });
        }
    });
};
$7703425acb329dea$export$217609e4806a14a5.displayName = "AitRowGroupOptionsButton";

});

parcelRegister("SaWDM", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupTrafficLight", function () { return $99d9bec52e7d6a67$export$d38eccab70eaa01d; });

var $6r4yf = parcelRequire("6r4yf");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $99d9bec52e7d6a67$export$d38eccab70eaa01d = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const coreTrafficLight = thisRowGroup?.coreTrafficLight ?? "BlankNotEvaluated";
    return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated" ? new (0, $6r4yf.MosaicTrafficLightClass)(coreTrafficLight, "4px", "-16px").element : null;
};
$99d9bec52e7d6a67$export$d38eccab70eaa01d.displayName = "AitRowGroupTrafficLight";

});


parcelRegister("4wViJ", function(module, exports) {

$parcel$export(module.exports, "AitHeaderRowLastCell", function () { return $0d55bab08cb8e82b$export$500807074636dbe2; });

var $bR5nk = parcelRequire("bR5nk");

var $8xj55 = parcelRequire("8xj55");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $iVZ7C = parcelRequire("iVZ7C");

var $1D9Y3 = parcelRequire("1D9Y3");

var $aCYgE = parcelRequire("aCYgE");

var $1NrVJ = parcelRequire("1NrVJ");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $0d55bab08cb8e82b$export$500807074636dbe2 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRow = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && !location.isRepeat && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1NrVJ.AitRowGroupDeletedItemTrafficLight), {
                location: {
                    position: (0, $9B5Sg.AitTablePosition).header,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aCYgE.AitRowDeletedItemTrafficLight), {
                location: location
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexRowStart,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder
                ]),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitRowButtons,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iVZ7C.AitAddRowButton), {
                                location: location
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1D9Y3.AitRemoveRowButton), {
                                location: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
                        buttonId: `${location.position}-row-${location.rowId}-annotation`,
                        annotationType: "Row",
                        annotationLocation: location,
                        existingAnnotation: thisRow?.annotation,
                        hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: state?.tlfViewMode.value === "ANNOTATIONS"
                    })
                ]
            })
        ]
    });
};
$0d55bab08cb8e82b$export$500807074636dbe2.displayName = "AitHeaderRowLastCell";

});
parcelRegister("1D9Y3", function(module, exports) {

$parcel$export(module.exports, "AitRemoveRowButton", function () { return $70c83cf64cb453fe$export$11bf415b53ace422; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $biia9 = parcelRequire("biia9");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $70c83cf64cb453fe$export$11bf415b53ace422 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = location.position === (0, $9B5Sg.AitTablePosition).headerRow ? state?.originalTableData.headerData : state?.originalTableData.bodyData.find((group)=>group.aitid === location.rowGroupId);
    const canRemoveRow = (0, $spJKX.useMemo)(()=>{
        return state?.editable && thisRowGroup ? thisRowGroup.rows.length > 1 : false;
    }, [
        state?.editable,
        thisRowGroup
    ]);
    return !state || !thisRowGroup || !canRemoveRow ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${state.id}-remove-row`,
        tipText: "Remove row",
        iconName: "aioxMinus",
        "aria-label": "Remove row",
        onClick: ()=>{
            dispatch({
                operation: (0, $9B5Sg.REMOVE_ROW),
                location: location,
                newLength: thisRowGroup.rows.length - 1
            });
        }
    });
};
$70c83cf64cb453fe$export$11bf415b53ace422.displayName = "AitRemoveRowButton";

});

parcelRegister("aCYgE", function(module, exports) {

$parcel$export(module.exports, "AitRowDeletedItemTrafficLight", function () { return $6a93a90c01dca9c2$export$d7787c39ff111c99; });

var $6r4yf = parcelRequire("6r4yf");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $6a93a90c01dca9c2$export$d7787c39ff111c99 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, {
        position: location.position === (0, $9B5Sg.AitTablePosition).headerRow ? (0, $9B5Sg.AitTablePosition).header : (0, $9B5Sg.AitTablePosition).bodyRowGroup,
        tableSection: location.tableSection,
        rowGroup: location.rowGroup,
        rowGroupId: location.rowGroupId
    }, true).data;
    const deletedItemTrafficLight = (thisRowGroup?.changedRows?.filter((dr)=>dr.coreTrafficLight === "RedError" && dr.idAfterTrafficLightIsShown === location.rowId).length ?? 0) > 0 ? "RedError" : "BlankNotEvaluated";
    return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated" ? new (0, $6r4yf.MosaicTrafficLightClass)(deletedItemTrafficLight, "-4px", "-8px").element : null;
};
$6a93a90c01dca9c2$export$d7787c39ff111c99.displayName = "AitRowDeletedItemTrafficLight";

});

parcelRegister("1NrVJ", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupDeletedItemTrafficLight", function () { return $16132b54773bfd7e$export$b7931672b030692d; });

var $6r4yf = parcelRequire("6r4yf");

var $eN4ax = parcelRequire("eN4ax");
const $16132b54773bfd7e$export$b7931672b030692d = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const deletedItemTrafficLight = (state?.processedTableData?.changedRowGroups?.filter((drg)=>drg.coreTrafficLight === "RedError" && drg.idAfterTrafficLightIsShown === location.rowGroupId).length ?? 0) > 0 ? "RedError" : "BlankNotEvaluated";
    return !state?.noTrafficLights && deletedItemTrafficLight !== "BlankNotEvaluated" ? new (0, $6r4yf.MosaicTrafficLightClass)(deletedItemTrafficLight, "-8px", "40px").element : null;
};
$16132b54773bfd7e$export$b7931672b030692d.displayName = "AitRowGroupDeletedItemTrafficLight";

});




parcelRegister("h7Arq", function(module, exports) {

$parcel$export(module.exports, "AitRemoveRowGroupButton", function () { return $56440758c68b1546$export$be06a28eb12bcc76; });

var $bR5nk = parcelRequire("bR5nk");

var $biia9 = parcelRequire("biia9");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $56440758c68b1546$export$be06a28eb12bcc76 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    return !state || !thisRowGroup || !state.editable || !state.processedTableData || state.processedTableData.bodyData.length < 2 ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
        id: `${id}-remove-rowgroup`,
        tipText: "Remove row group",
        iconName: "aioxMinus",
        onClick: ()=>dispatch({
                operation: (0, $9B5Sg.REMOVE_ROW_GROUP),
                location: location,
                newLength: state.originalTableData.bodyData.length - 1
            })
    });
};
$56440758c68b1546$export$be06a28eb12bcc76.displayName = "AitRemoveRowGroupButton";

});

parcelRegister("86OWm", function(module, exports) {

$parcel$export(module.exports, "AitRow", function () { return $d152b5315ae2e4b9$export$7cfeb9b0bb6a5b0b; });

var $bR5nk = parcelRequire("bR5nk");

var $dPawg = parcelRequire("dPawg");

var $dUiJM = parcelRequire("dUiJM");

var $4h9Ky = parcelRequire("4h9Ky");

var $8IdFZ = parcelRequire("8IdFZ");

var $eN4ax = parcelRequire("eN4ax");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");
const $d152b5315ae2e4b9$export$7cfeb9b0bb6a5b0b = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const thisRow = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const columnRepeats = state?.processedTableData?.columnRepeats ?? [];
    const cells = thisRow?.cells ?? [];
    const spaceAfter = thisRow?.spaceAfter ?? false;
    const rowHeaderColumns = state?.processedTableData?.rowHeaderColumns ?? 0;
    return !thisRow ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("tr", {
                id: `${id}`,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4h9Ky.AitRowFirstCell), {
                        location: location
                    }),
                    cells.map((cell, ci)=>{
                        // Get cell from column repeat
                        const cr = Array.isArray(columnRepeats) && columnRepeats.length > ci ? columnRepeats[ci] : undefined;
                        const isColumnRepeat = cr !== undefined && cr.colRepeat !== undefined ? cr.colRepeat.match(/^[[\]0,]+$/) === null : false;
                        // Render object
                        return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dUiJM.AitCell), {
                            location: {
                                ...location,
                                position: (0, $9B5Sg.AitTablePosition).bodyCell,
                                column: ci,
                                colRepeat: cr?.colRepeat ?? "",
                                cellId: cell.aitid,
                                cellType: (cr?.columnIndex ?? // istanbul ignore next
                                1) < rowHeaderColumns ? (0, $9B5Sg.AitCellType).rowHeader : (0, $9B5Sg.AitCellType).body,
                                isRepeat: location.isRepeat || isColumnRepeat,
                                originalColumn: columnRepeats[ci]?.columnIndex ?? // istanbul ignore next
                                ci
                            }
                        }, isColumnRepeat && cr ? `${cell.aitid}-${JSON.stringify(cr.colRepeat)}` : cell.aitid);
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8IdFZ.AitRowLastCell), {
                        location: location
                    })
                ]
            }),
            (spaceAfter !== false || cells.some((c)=>c.spaceAfterRepeat)) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dPawg.AitBorderRow), {
                id: `${id}-spaceafter-row`,
                spaceAfter: true,
                noBorder: true
            })
        ]
    });
};
$d152b5315ae2e4b9$export$7cfeb9b0bb6a5b0b.displayName = "AitRow";

});
parcelRegister("4h9Ky", function(module, exports) {

$parcel$export(module.exports, "AitRowFirstCell", function () { return $41b54f00d4da1f14$export$7602816e942f3095; });

var $bR5nk = parcelRequire("bR5nk");

var $9zfAS = parcelRequire("9zfAS");

var $iS2uZ = parcelRequire("iS2uZ");

var $SaWDM = parcelRequire("SaWDM");

var $9B5Sg = parcelRequire("9B5Sg");
const $41b54f00d4da1f14$export$7602816e942f3095 = ({ location: location })=>/*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
        width: "50px",
        children: [
            location.row === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $SaWDM.AitRowGroupTrafficLight), {
                location: {
                    position: (0, $9B5Sg.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            location.row === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iS2uZ.AitRowGroupButtons), {
                location: {
                    position: (0, $9B5Sg.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            })
        ]
    });
$41b54f00d4da1f14$export$7602816e942f3095.displayName = "AitRowFirstCell";

});
parcelRegister("iS2uZ", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupButtons", function () { return $acabd384b9548351$export$e388b51195b92d37; });

var $bR5nk = parcelRequire("bR5nk");

var $8xj55 = parcelRequire("8xj55");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $e37ix = parcelRequire("e37ix");

var $h7Arq = parcelRequire("h7Arq");

var $bNi0z = parcelRequire("bNi0z");

var $eqN7F = parcelRequire("eqN7F");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $acabd384b9548351$export$e388b51195b92d37 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const showAnnotation = state?.tlfViewMode.value === "ANNOTATIONS";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
                buttonId: `${location.position}-rowgroup-${location.rowGroupId}-annotation`,
                annotationType: "RowGroup",
                annotationLocation: location,
                existingAnnotation: thisRowGroup?.annotation,
                hidden: !showAnnotation,
                showPreview: showAnnotation
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitRowGroupButtons,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexRowEnd
                ]),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $h7Arq.AitRemoveRowGroupButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $e37ix.AitAddRowGroupButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bNi0z.AitRowGroupOptionsButton), {
                        location: location
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eqN7F.AitRowGroupOptionsWindow), {
                        location: location
                    })
                ]
            })
        ]
    });
};
$acabd384b9548351$export$e388b51195b92d37.displayName = "AitRowGroupButtons";

});
parcelRegister("eqN7F", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupOptionsWindow", function () { return $1e0ff320adc617fe$export$a7e35f4b581e7232; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $eBlbF = parcelRequire("eBlbF");

var $ltooE = parcelRequire("ltooE");

var $bVXtb = parcelRequire("bVXtb");

var $jSLbr = parcelRequire("jSLbr");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $1e0ff320adc617fe$export$a7e35f4b581e7232 = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location).data;
    const showRowGroupOptions = state && state.showOptionsWindow.findIndex((l)=>(0, $eBlbF.isEqual)(l, location)) > -1;
    return !thisRowGroup || !showRowGroupOptions ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextWindow), {
        id: `${id}-rowgroup-options-window`,
        title: "Row group options",
        visible: showRowGroupOptions,
        onClose: ()=>{
            dispatch({
                operation: (0, $9B5Sg.HIDE_OPTIONS_WINDOW),
                location: location
            });
        },
        style: {
            maxHeight: "75vh"
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ltooE.AitCommentRow), {
                location: location
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jSLbr.AitRowGroupSpaceAfter), {
                location: location
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bVXtb.AitRowGroupReplacements), {
                location: location
            })
        ]
    });
};
$1e0ff320adc617fe$export$a7e35f4b581e7232.displayName = "AitRowGroupOptionsWindow";

});
parcelRegister("jSLbr", function(module, exports) {

$parcel$export(module.exports, "AitRowGroupSpaceAfter", function () { return $dde1158f1b7a18f0$export$26b0f783a13903e; });

var $bR5nk = parcelRequire("bR5nk");

var $3f0RC = parcelRequire("3f0RC");

var $9zfAS = parcelRequire("9zfAS");

var $ickJu = parcelRequire("ickJu");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $dde1158f1b7a18f0$export$26b0f783a13903e = ({ location: location })=>{
    const { state: state, dispatch: dispatch } = (0, $eN4ax.useTableContext)();
    const id = (0, $ickJu.getBaseId)(location, state?.id);
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location).data;
    return !state || !thisRowGroup ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aiwBodyRow,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3f0RC.AioBoolean), {
            id: `${id}-spaceafter-group`,
            label: "Space after group",
            value: thisRowGroup.spaceAfter ?? // istanbul ignore next
            false,
            disabled: !state.editable,
            setValue: (bool)=>{
                dispatch({
                    operation: (0, $9B5Sg.SET_SPACE_AFTER),
                    location: location,
                    bool: bool
                });
            }
        })
    });
};
$dde1158f1b7a18f0$export$26b0f783a13903e.displayName = "AitRowGroupSpaceAfter";

});




parcelRegister("8IdFZ", function(module, exports) {

$parcel$export(module.exports, "AitRowLastCell", function () { return $41d992d494a6505b$export$a0c0b9565704f2b8; });

var $bR5nk = parcelRequire("bR5nk");

var $8xj55 = parcelRequire("8xj55");

var $9zfAS = parcelRequire("9zfAS");

var $3tKzd = parcelRequire("3tKzd");

var $iVZ7C = parcelRequire("iVZ7C");

var $1D9Y3 = parcelRequire("1D9Y3");

var $aCYgE = parcelRequire("aCYgE");

var $1NrVJ = parcelRequire("1NrVJ");

var $enKr0 = parcelRequire("enKr0");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $41d992d494a6505b$export$a0c0b9565704f2b8 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRow = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const showRowTrafficLight = thisRow?.coreTrafficLight === "ChangedUnknown";
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitCell,
        width: "50px",
        children: [
            showRowTrafficLight && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $enKr0.AitRowTrafficLight), {
                location: location
            }),
            location.row === 0 && !location.isRepeat && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1NrVJ.AitRowGroupDeletedItemTrafficLight), {
                location: {
                    position: (0, $9B5Sg.AitTablePosition).bodyRowGroup,
                    tableSection: location.tableSection,
                    rowGroup: location.rowGroup,
                    rowGroupId: location.rowGroupId
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aCYgE.AitRowDeletedItemTrafficLight), {
                location: location
            }),
            !location.isRepeat && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).flexRowStart,
                    (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitAieHolder
                ]),
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitRowButtons,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iVZ7C.AitAddRowButton), {
                                location: location
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1D9Y3.AitRemoveRowButton), {
                                location: location
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
                        buttonId: `${location.position}-row-${location.rowId}-annotation`,
                        annotationType: "Row",
                        annotationLocation: location,
                        existingAnnotation: thisRow?.annotation,
                        hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: showAnnotationPreview
                    })
                ]
            })
        ]
    });
};
$41d992d494a6505b$export$a0c0b9565704f2b8.displayName = "AitRowLastCell";

});
parcelRegister("enKr0", function(module, exports) {

$parcel$export(module.exports, "AitRowTrafficLight", function () { return $76c27510edde688e$export$279bce6043283abb; });

var $6r4yf = parcelRequire("6r4yf");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $76c27510edde688e$export$279bce6043283abb = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRow = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    const coreTrafficLight = thisRow?.coreTrafficLight ?? // istanbul ignore next
    "BlankNotEvaluated";
    return !state?.noTrafficLights && coreTrafficLight !== "BlankNotEvaluated" ? new (0, $6r4yf.MosaicTrafficLightClass)(coreTrafficLight, "4px", "-16px").element : null;
};
$76c27510edde688e$export$279bce6043283abb.displayName = "AitRowTrafficLight";

});



parcelRegister("4CqQL", function(module, exports) {

$parcel$export(module.exports, "AitRowGroup", function () { return $55012aa396f757c8$export$940f0b7b4d70b6d6; });

var $bR5nk = parcelRequire("bR5nk");

var $86OWm = parcelRequire("86OWm");

var $9B5Sg = parcelRequire("9B5Sg");

var $lyZtY = parcelRequire("lyZtY");

var $eN4ax = parcelRequire("eN4ax");
const $55012aa396f757c8$export$940f0b7b4d70b6d6 = ({ location: location })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const thisRowGroup = (0, $lyZtY.trGetPositionFromLocation)(state, location, true).data;
    // Output the rows
    return !thisRowGroup ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("tbody", {
        children: thisRowGroup.rows.map((row, ri)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $86OWm.AitRow), {
                location: {
                    ...location,
                    position: (0, $9B5Sg.AitTablePosition).bodyRow,
                    rowId: row.aitid,
                    row: ri,
                    rowRepeat: !row.rowRepeat?.match(/^[[\]0,]+$/) ? row.rowRepeat ?? // istanbul ignore next
                    "" : undefined,
                    isRepeat: (row.rowRepeat ?? // istanbul ignore next
                    "") !== "" && row.rowRepeat?.match(/^[[\]0,]+$/) === null
                }
            }, `row-${ri}-${row.aitid}`))
    });
};
$55012aa396f757c8$export$940f0b7b4d70b6d6.displayName = "AitRowGroup";

});

parcelRegister("aWcoT", function(module, exports) {

$parcel$export(module.exports, "AitTable", function () { return $20248b337d582c43$export$2f7b0fa48de90557; });

var $bR5nk = parcelRequire("bR5nk");

var $8xj55 = parcelRequire("8xj55");

var $9zfAS = parcelRequire("9zfAS");

var $dPawg = parcelRequire("dPawg");

var $8FBJ2 = parcelRequire("8FBJ2");

var $4CqQL = parcelRequire("4CqQL");

var $9B5Sg = parcelRequire("9B5Sg");

var $eN4ax = parcelRequire("eN4ax");
const $20248b337d582c43$export$2f7b0fa48de90557 = ({ id: id, style: style })=>{
    const { state: state } = (0, $eN4ax.useTableContext)();
    const bodyData = state?.processedTableData?.bodyData;
    const showAnnotationPreview = state?.tlfViewMode.value === "ANNOTATIONS";
    // Calculate total number of columns for repositioning key
    // This ensures the preview bubble repositions when columns are added/removed
    const columnCount = bodyData?.[0]?.rows?.[0]?.cells?.length ?? 0;
    return !bodyData ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitHolder,
        style: style,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
                buttonId: `${state.id}-table-annotation`,
                annotationType: "Table",
                annotationLocation: {
                    position: (0, $9B5Sg.AitTablePosition).table
                },
                existingAnnotation: state?.originalTableData.tableAnnotation,
                hidden: state?.tlfViewMode.value !== "ANNOTATIONS",
                showPreview: showAnnotationPreview,
                repositionKey: columnCount
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("table", {
                id: id,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($9zfAS))).aitTable,
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8FBJ2.AitHeader), {}),
                    bodyData.map((rowGroup, rgi)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $4CqQL.AitRowGroup), {
                            location: {
                                tableSection: (0, $9B5Sg.AitRowType).body,
                                position: (0, $9B5Sg.AitTablePosition).bodyRowGroup,
                                rowGroup: rgi,
                                rowGroupId: rowGroup.aitid
                            }
                        }, `row-group-${rgi}-${rowGroup.aitid}`)),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("tbody", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dPawg.AitBorderRow), {
                            id: `${id}-bottom-border`
                        })
                    })
                ]
            })
        ]
    });
};
$20248b337d582c43$export$2f7b0fa48de90557.displayName = "AitTable";

});

parcelRegister("1cgCo", function(module, exports) {

$parcel$export(module.exports, "AsupInternalTable", function () { return $b1f59b7119d3b885$export$587223f259f21e10; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("spJKX");
parcelRequire("5SMPf");
var $hcEI9 = parcelRequire("hcEI9");
var $dbVjd = parcelRequire("dbVjd");

var $aWcoT = parcelRequire("aWcoT");

var $eN4ax = parcelRequire("eN4ax");
const $b1f59b7119d3b885$export$587223f259f21e10 = ({ id: id, tableData: tableData, isEditable: isEditable = true, onChange: onChange, externalLists: externalLists = [], externalSingles: externalSingles = [], style: style, showCellBorders: showCellBorders = true, groupTemplates: groupTemplates, colWidthMod: colWidthMod = 2, defaultCellWidth: defaultCellWidth = 60, noTableOptions: noTableOptions = false, noTrafficLights: noTrafficLights = false, editorProps: editorProps = (0, $hcEI9.defaultEditorDefns), tlfViewMode: tlfViewMode = (0, $dbVjd.TLF_VIEW_MODES)[0] })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $eN4ax.TableContextProvider), {
        initialState: {
            originalTableData: {
                ...tableData,
                changedRowGroups: tableData.changedRowGroups ?? // istanbul ignore next
                [],
                changedColumns: tableData.changedColumns ?? // istanbul ignore next
                []
            },
            colWidthMod: colWidthMod,
            defaultCellWidth: defaultCellWidth,
            editorProps: editorProps,
            editable: isEditable,
            externalLists: externalLists,
            externalSingles: externalSingles,
            groupTemplates: groupTemplates,
            id: id,
            noTableOptions: noTableOptions,
            noTrafficLights: noTrafficLights,
            showCellBorders: showCellBorders,
            tlfViewMode: tlfViewMode
        },
        onChange: onChange,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aWcoT.AitTable), {
            id: id,
            style: style
        })
    });
$b1f59b7119d3b885$export$587223f259f21e10.displayName = "AsupInternalTable";

});

parcelRegister("bDrGf", function(module, exports) {
$parcel$export(module.exports, "isAitRowGroupData", function () { return (parcelRequire("aVRpe")).isAitRowGroupData; });
$parcel$export(module.exports, "isGridItemTrafficLight", function () { return (parcelRequire("2Uw8z")).isGridItemTrafficLight; });
$parcel$export(module.exports, "AitTablePosition", function () { return (parcelRequire("9B5Sg")).AitTablePosition; });
$parcel$export(module.exports, "newCell", function () { return (parcelRequire("l6aIi")).newCell; });
$parcel$export(module.exports, "newHeaderCell", function () { return (parcelRequire("l6aIi")).newHeaderCell; });
$parcel$export(module.exports, "newHeaderRow", function () { return (parcelRequire("6GMBM")).newHeaderRow; });
$parcel$export(module.exports, "newRow", function () { return (parcelRequire("6GMBM")).newRow; });
$parcel$export(module.exports, "newRowGroup", function () { return (parcelRequire("gMOiI")).newRowGroup; });
parcelRequire("gPFch");
parcelRequire("d8aRo");
parcelRequire("aVRpe");
parcelRequire("f9pPj");
parcelRequire("ickJu");
parcelRequire("2Uw8z");
parcelRequire("9B5Sg");
parcelRequire("l6aIi");
parcelRequire("6GMBM");
parcelRequire("gMOiI");
parcelRequire("d0OZ3");
parcelRequire("e1dPi");
parcelRequire("PFlqD");
parcelRequire("cAxag");
parcelRequire("gIB6G");
parcelRequire("hZ8f9");
parcelRequire("7xJts");
parcelRequire("cuEIs");
parcelRequire("3slWx");
parcelRequire("9kTZb");
parcelRequire("bLMi0");
parcelRequire("9Lr16");
parcelRequire("3oVEB");
parcelRequire("adOP8");
parcelRequire("boqBf");
parcelRequire("iGLIE");
parcelRequire("7SUA6");
parcelRequire("9rj0c");
parcelRequire("lyZtY");
parcelRequire("kv9Fc");
parcelRequire("2LFD1");
parcelRequire("9OWn6");
parcelRequire("gnmHr");
parcelRequire("fEtEI");
parcelRequire("cMUd7");
parcelRequire("95mer");
parcelRequire("aLZgM");

});
parcelRegister("gPFch", function(module, exports) {

$parcel$export(module.exports, "isAitCellData", function () { return $1212951a94874ea8$export$7bac3abcce3f492b; });
parcelRequire("4Ol1K");
var $6g7gz = parcelRequire("6g7gz");
const $1212951a94874ea8$export$7bac3abcce3f492b = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic property
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (!isT(chkObj.text)) return false;
    if (!isT(chkObj.comments)) return false;
    if (!noColumnIdCheck && typeof chkObj.columnId !== "string") return false;
    if (typeof chkObj.colWidth !== "undefined" && typeof chkObj.colWidth !== "number") return false;
    if (typeof chkObj.textIndents !== "undefined" && typeof chkObj.textIndents !== "number") return false;
    if (chkObj.replacedText !== undefined && !isT(chkObj.replacedText)) return false;
    if (typeof chkObj.spaceAfterRepeat !== "undefined" && typeof chkObj.spaceAfterRepeat !== "boolean") return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    if (typeof chkObj.templateColumnAitId !== "undefined" && typeof chkObj.templateColumnAitId !== "string") return false;
    if (typeof chkObj.showCellOptions !== "undefined" && typeof chkObj.showCellOptions !== "boolean") return false;
    if (typeof chkObj.readOnly !== "undefined" && typeof chkObj.readOnly !== "boolean") return false;
    // Check types
    if (chkObj.justifyText !== undefined && ![
        "left",
        "center",
        "right",
        "justify",
        "decimal",
        "default"
    ].includes(chkObj.justifyText)) return false;
    if (!(0, $6g7gz.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("4Ol1K", function(module, exports) {
$parcel$export(module.exports, "MosaicTrafficLightClass", function () { return (parcelRequire("6r4yf")).MosaicTrafficLightClass; });
$parcel$export(module.exports, "MosaicTrafficLightColors", function () { return (parcelRequire("6r4yf")).MosaicTrafficLightColors; });
$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return (parcelRequire("6g7gz")).isMosaicTrafficLightsValue; });
$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return (parcelRequire("fEdhd")).isMosaicTrafficLightSwitch; });
parcelRequire("6r4yf");
parcelRequire("6g7gz");
parcelRequire("fEdhd");

});
parcelRegister("6g7gz", function(module, exports) {

$parcel$export(module.exports, "isMosaicTrafficLightsValue", function () { return $60815c85542c8f71$export$f9ab8bbf5b7da0c3; });
/**
 * Available traffic light values
 */ const $60815c85542c8f71$export$f9ab8bbf5b7da0c3 = (obj)=>typeof obj === "string" && [
        "none",
        "FromScratch",
        "FromBasicLayout",
        "FromTemplate",
        "RedError",
        "AmberChangeExpected",
        "GreenOk",
        "BlankNotEvaluated",
        "ChangedUnknown",
        "GreenOverride"
    ].includes(obj);

});

parcelRegister("fEdhd", function(module, exports) {

$parcel$export(module.exports, "isMosaicTrafficLightSwitch", function () { return $32e5298753f3b479$export$e651a6276e9ff426; });
const $32e5298753f3b479$export$e651a6276e9ff426 = (obj)=>{
    return typeof obj === "string" && [
        "DoNotCalculate",
        "Calculate"
    ].includes(obj);
};

});



parcelRegister("d8aRo", function(module, exports) {

$parcel$export(module.exports, "isAitRowData", function () { return $f795cda46ecdfdd1$export$d7117232a007430b; });

var $gRBNV = parcelRequire("gRBNV");
parcelRequire("4Ol1K");
var $6g7gz = parcelRequire("6g7gz");

var $gPFch = parcelRequire("gPFch");
const $f795cda46ecdfdd1$export$d7117232a007430b = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic property
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (typeof chkObj.rowRepeat !== "undefined" && typeof chkObj.rowRepeat !== "string") return false;
    if (typeof chkObj.spaceAfter !== "undefined" && typeof chkObj.spaceAfter !== "boolean") return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    // Check arrays
    if (!Array.isArray(chkObj.cells) || chkObj.cells.some((cell)=>!(0, $gPFch.isAitCellData)(cell, isT, noColumnIdCheck))) return false;
    // Check types
    if (!(0, $6g7gz.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    // Check lower level objects
    if (typeof chkObj.annotation !== "undefined" && !(0, $gRBNV.isAnnotationWhereGroup)(chkObj.annotation)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("gRBNV", function(module, exports) {

$parcel$export(module.exports, "isAnnotationWhereGroup", function () { return $05c3bcfb2fe194b9$export$bd254dfc157df8f7; });

var $9ykYT = parcelRequire("9ykYT");
const $05c3bcfb2fe194b9$export$bd254dfc157df8f7 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check basic props
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (!Array.isArray(chkObj.clauses) || chkObj.clauses.some((c)=>!(0, $9ykYT.isWhereClauseOp)(c))) return false;
    // Check optional props
    if (chkObj.additionalNotes !== undefined && typeof chkObj.additionalNotes !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("aVRpe", function(module, exports) {

$parcel$export(module.exports, "isAitRowGroupData", function () { return $f1bc25bc26b74a98$export$147e7523057ffe20; });

var $gRBNV = parcelRequire("gRBNV");
parcelRequire("dyM3y");
var $2Rhsi = parcelRequire("2Rhsi");
parcelRequire("4Ol1K");
var $6g7gz = parcelRequire("6g7gz");

var $d8aRo = parcelRequire("d8aRo");

var $2Uw8z = parcelRequire("2Uw8z");
const $f1bc25bc26b74a98$export$147e7523057ffe20 = (obj, isT, noColumnIdCheck)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check lower interface
    const chkObj = obj;
    if (typeof chkObj.aitid !== "string") return false;
    if (typeof chkObj.name !== "undefined" && typeof chkObj.name !== "string") return false;
    if (!Array.isArray(chkObj.rows) || chkObj.rows.some((x)=>!(0, $d8aRo.isAitRowData)(x, isT, noColumnIdCheck))) return false;
    if (typeof chkObj.comments !== "undefined" && !isT(chkObj.comments)) return false;
    if (typeof chkObj.spaceAfter !== "undefined" && typeof chkObj.spaceAfter !== "boolean") return false;
    if (typeof chkObj.replacements !== "undefined" && chkObj.replacements.some((x)=>!(0, $2Rhsi.isAioReplacement)(x, isT))) return false;
    if (!(0, $6g7gz.isMosaicTrafficLightsValue)(chkObj.coreTrafficLight)) return false;
    if (typeof chkObj.changedRows !== "undefined" && chkObj.changedRows.some((x)=>!(0, $2Uw8z.isGridItemTrafficLight)(x))) return false;
    if (typeof chkObj.templateAitId !== "undefined" && typeof chkObj.templateAitId !== "string") return false;
    if (typeof chkObj.annotation !== "undefined" && !(0, $gRBNV.isAnnotationWhereGroup)(chkObj.annotation)) return false;
    // Everything is good
    return true;
};

});
parcelRegister("2Uw8z", function(module, exports) {

$parcel$export(module.exports, "isGridItemTrafficLight", function () { return $27827d6a66ae1b54$export$e6b70f04b92d6b8e; });

var $12Lyj = parcelRequire("12Lyj");
parcelRequire("4Ol1K");
var $6g7gz = parcelRequire("6g7gz");
const $27827d6a66ae1b54$export$e6b70f04b92d6b8e = (obj)=>{
    // Check object
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    // Check basic property types
    if (typeof obj.coreTrafficLight !== "string" || typeof obj.gridItemId !== "string" || typeof obj.isOptional !== "boolean" || typeof obj.gridItemChangeType !== "string") return false;
    // Check optional property types
    if (obj.idAfterTrafficLightIsShown !== undefined && typeof obj.idAfterTrafficLightIsShown !== "string") return false;
    // Check enums
    if (!(0, $6g7gz.isMosaicTrafficLightsValue)(obj.coreTrafficLight)) return false;
    // All good
    return true;
};

});


parcelRegister("cMUd7", function(module, exports) {

var $9B5Sg = parcelRequire("9B5Sg");
/**
 * Update the core traffic-light value on a row, row-group and table.
 *
 * Internal helper used to synchronise `coreTrafficLight` across a row,
 * its parent row-group and the table data when a change occurs.
 *
 * @template T - The row/cell payload type
 * @param coreTrafficLight - New `MosaicTrafficLightsValue` to set
 * @param row - The row to update
 * @param rowGroup - The parent row group or header group
 * @param tableData - The table data object which will have its `coreTrafficLight` updated
 */ const $275f581ba299d9db$var$updateCoreTrafficLight = (coreTrafficLight, row, rowGroup, tableData)=>{
    row.coreTrafficLight = coreTrafficLight;
    rowGroup.coreTrafficLight = coreTrafficLight;
    tableData.coreTrafficLight = coreTrafficLight;
};
const $275f581ba299d9db$export$783eb81b2852b9bb = (state, location)=>{
    if (location.position === (0, $9B5Sg.AitTablePosition).headerCell && state.originalTableData && state.originalTableData.headerData) {
        const headerData = state.originalTableData.headerData;
        const row = headerData.rows[location.row];
        /* istanbul ignore else */ if (row && row.coreTrafficLight !== "ChangedUnknown") $275f581ba299d9db$var$updateCoreTrafficLight("ChangedUnknown", row, headerData, state.originalTableData);
    }
    if (location.position === (0, $9B5Sg.AitTablePosition).bodyCell && state.originalTableData) {
        const bodyData = state.originalTableData.bodyData;
        const rowGroup = bodyData[location.rowGroup];
        /* istanbul ignore else */ if (rowGroup) {
            const row = rowGroup.rows[location.row];
            /* istanbul ignore else */ if (row && row.coreTrafficLight !== "ChangedUnknown") $275f581ba299d9db$var$updateCoreTrafficLight("ChangedUnknown", row, rowGroup, state.originalTableData);
        }
    }
};

});




parcelRegister("6iYEs", function(module, exports) {

$parcel$export(module.exports, "UnsavedChangesProvider", function () { return $9ea073020df592dc$export$94e7b68100342a47; });
$parcel$export(module.exports, "useUnsavedChanges", function () { return $9ea073020df592dc$export$13d7b18655d4746; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");

var $9BTO4 = parcelRequire("9BTO4");
const $9ea073020df592dc$export$41bdd42c1cc3b964 = {
    clearUnsavedChanges: // istanbul ignore next
    ()=>{},
    hasUnsavedChanges: false,
    isLoading: null,
    /**
   * Fallback navigate implementation used when the provider is not available.
   * This performs a hard navigation by setting `window.location.href`.
   */ navigate: ()=>{
        window.location.href = "/";
    },
    /**
   * Fallback navigate-after-save used when the provider is not mounted.
   * Intended to be no-op in test environments; real behaviour is provided
   * by the `UnsavedChangesProvider` implementation.
   */ navigateAfterSave: // istanbul ignore next
    ()=>{},
    /**
   * Fallback registerUnsavedChanges used when the provider is not mounted.
   */ registerUnsavedChanges: // istanbul ignore next
    ()=>{}
};
const $9ea073020df592dc$export$c6190abc0aa2e52c = /*#__PURE__*/ (0, $spJKX.createContext)($9ea073020df592dc$export$41bdd42c1cc3b964);
const $9ea073020df592dc$export$94e7b68100342a47 = ({ children: children })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const rrNavigate = (0, $4Q81F.useNavigate)();
    const [unsavedChangesSources, setUnsavedChangesSources] = (0, $spJKX.useState)({});
    const location = (0, $4Q81F.useLocation)();
    const [isLoading, setIsLoading] = (0, $spJKX.useState)(null);
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>setIsLoading(null));
    }, [
        location.pathname
    ]);
    const clearUnsavedChanges = (0, $spJKX.useCallback)(()=>{
        setUnsavedChangesSources({});
    }, []);
    /**
   * Clear all registered unsaved-change flags.
   * Used after a successful save or when navigation is forced.
   */ const registerUnsavedChanges = (0, $spJKX.useCallback)((id, hasChanges)=>{
        setUnsavedChangesSources((prev)=>({
                ...prev,
                [id]: hasChanges
            }));
    }, []);
    /**
   * Register or update a component's unsaved-changes state.
   *
   * @param id - The identifier for the component registering changes
   * @param hasChanges - True if the component currently has unsaved changes
   */ const hasUnsavedChanges = (0, $spJKX.useMemo)(()=>Object.values(unsavedChangesSources).some(Boolean), [
        unsavedChangesSources
    ]);
    const navigate = (0, $spJKX.useCallback)((url, id, options)=>{
        setIsLoading(id);
        rrNavigate(url, options);
    }, [
        rrNavigate
    ]);
    /**
   * Trigger navigation and set the component `id` as the loading source.
   * This prevents the unsaved-changes blocker from prompting while
   * navigation initiated by the same component proceeds.
   *
   * @param url - The destination to navigate to
   * @param id - The component id initiating navigation
   * @param options - Optional navigation options forwarded to the router
   */ const navigateAfterSave = (0, $spJKX.useCallback)((url, id, options)=>{
        setIsLoading(id);
        clearUnsavedChanges();
        setTimeout(()=>{
            rrNavigate(url, options);
        }, 1);
    }, [
        clearUnsavedChanges,
        rrNavigate
    ]);
    /**
   * Navigate after performing a save: clear any unsaved flags and then
   * navigate to the supplied `url`. `setTimeout` is used to allow any
   * save completion logic to settle before routing.
   *
   * @param url - The destination to navigate to after save
   * @param id - The component id initiating the save-and-navigate flow
   * @param options - Optional navigation options forwarded to the router
   */ // Single beforeunload handler
    (0, $spJKX.useEffect)(()=>{
        /**
     * Beforeunload handler that prompts the browser to show a confirmation
     * if there are registered unsaved changes.
     *
     * @param event - The beforeunload event provided by the browser
     */ const handleBeforeUnload = (event)=>{
            /* istanbul ignore else */ if (hasUnsavedChanges) {
                event.preventDefault();
                return "";
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [
        hasUnsavedChanges
    ]);
    // Register the blocker with the router
    (0, $4Q81F.useBlocker)((args)=>{
        if (!hasUnsavedChanges) return false;
        const { currentLocation: currentLocation, nextLocation: nextLocation } = args;
        if ((0, $9BTO4.locationCheck)(currentLocation.pathname, nextLocation.pathname)) {
            const question = window.confirm("You have unsaved changes. Do you want to discard them and navigate away?");
            // Clear loading flag if you don't want to navigate
            if (!question) setIsLoading(null);
            return !question;
        }
        return false;
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)($9ea073020df592dc$export$c6190abc0aa2e52c.Provider, {
        value: {
            clearUnsavedChanges: clearUnsavedChanges,
            hasUnsavedChanges: hasUnsavedChanges,
            isLoading: isLoading,
            navigate: navigate,
            navigateAfterSave: navigateAfterSave,
            registerUnsavedChanges: registerUnsavedChanges
        },
        children: children
    });
};
$9ea073020df592dc$export$94e7b68100342a47.displayName = "UnsavedChangesProvider";
const $9ea073020df592dc$export$13d7b18655d4746 = (id)=>{
    const cxt = (0, $spJKX.useContext)($9ea073020df592dc$export$c6190abc0aa2e52c);
    return {
        ...cxt,
        /**
     * Navigate while scoping the call to this hook's `id` so that the
     * provider can mark which component initiated loading.
     *
     * @param url - The destination to navigate to
     * @param options - Optional navigate options forwarded to the router
     */ navigate: (url, options)=>{
            cxt.navigate(url, id, options);
        },
        /**
     * Navigate after a successful save, clearing this component's
     * unsaved-changes state before performing the navigation.
     *
     * @param url - The destination to navigate to after save
     * @param options - Optional navigate options forwarded to the router
     */ navigateAfterSave: (url, options)=>{
            cxt.navigateAfterSave(url, id, options);
        }
    };
};

});
parcelRegister("9BTO4", function(module, exports) {

$parcel$export(module.exports, "locationCheck", function () { return $173702615e4f5e64$export$e1d44f3ebb457149; });

var $eBlbF = parcelRequire("eBlbF");

var $4OToH = parcelRequire("4OToH");
const $173702615e4f5e64$export$e1d44f3ebb457149 = (currentLocation, nextLocation)=>{
    const currentParams = (0, $4OToH.getRouteLoaderParams)(currentLocation);
    const targetParams = (0, $4OToH.getRouteLoaderParams)(nextLocation);
    const loaderChange = !(0, $eBlbF.isEqual)(currentParams, targetParams);
    return loaderChange;
};

});
parcelRegister("4OToH", function(module, exports) {

$parcel$export(module.exports, "getRouteLoaderParams", function () { return $cbfaf45252c7c49a$export$216bdd1e94d01766; });

var $4Q81F = parcelRequire("4Q81F");

var $5Khvr = parcelRequire("5Khvr");
const $cbfaf45252c7c49a$export$216bdd1e94d01766 = (path)=>{
    return (0, $4Q81F.matchRoutes)((0, $5Khvr.routes), path)?.filter((match)=>match.route.loader).map((m)=>({
            params: m.params,
            pathname: m.pathname
        })).pop();
};

});
parcelRegister("5Khvr", function(module, exports) {

$parcel$export(module.exports, "routes", function () { return $0874995828be5bfd$export$66b32f6f30eb4b4; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1wSYE = parcelRequire("1wSYE");

var $aIQKp = parcelRequire("aIQKp");

var $2cGbu = parcelRequire("2cGbu");

var $hOl3X = parcelRequire("hOl3X");

var $4RsO4 = parcelRequire("4RsO4");

var $7aR3H = parcelRequire("7aR3H");

var $4PTsY = parcelRequire("4PTsY");

var $4m8te = parcelRequire("4m8te");

var $bYupS = parcelRequire("bYupS");

var $hJxsI = parcelRequire("hJxsI");

var $34RgW = parcelRequire("34RgW");

var $8KU6W = parcelRequire("8KU6W");

var $hXN68 = parcelRequire("hXN68");
/**
 * Determines whether a route loader should be revalidated.
 * When a navigation occurs (currentUrl differs from nextUrl), revalidation is
 * only triggered if the pathname changes, preventing unnecessary loader runs
 * when only search parameters are modified. For non-navigation triggers such
 * as explicit revalidation or action-driven refreshes (where both URLs are
 * identical), the router's default decision is used.
 *
 * @param args - Revalidation arguments from React Router.
 * @param args.currentUrl - URL for the current route state before navigation.
 * @param args.nextUrl - URL for the target route state after navigation.
 * @param args.defaultShouldRevalidate - The router's default revalidation decision,
 *        used as a fallback for non-navigation triggers.
 * @returns True when the pathname changes, or when the router would revalidate by default.
 */ const $0874995828be5bfd$var$shouldRevalidateOnPathnameChange = ({ currentUrl: currentUrl, nextUrl: nextUrl, defaultShouldRevalidate: defaultShouldRevalidate })=>{
    return currentUrl.href === nextUrl.href ? defaultShouldRevalidate : currentUrl.pathname !== nextUrl.pathname;
};









































const $0874995828be5bfd$export$66b32f6f30eb4b4 = [
    {
        path: "/",
        loader: (0, $bYupS.appSettingsLoader),
        errorElement: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $34RgW.default), {}),
        element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aIQKp.default), {}),
        hydrateFallbackElement: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
            text: "Loading application..."
        }),
        children: [
            {
                index: true,
                element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8KU6W.default), {})
            },
            // Admin page
            {
                path: "/Admin",
                lazy: async ()=>({
                        Component: (await (parcelRequire("9kv6K"))).AdminPage
                    })
            },
            // Maintenance page
            {
                path: "/Maintenance",
                lazy: async ()=>({
                        Component: (await (parcelRequire("j8yNh"))).MaintenancePage
                    })
            },
            // Not Allowed Page
            {
                path: "/NotAllowed",
                lazy: async ()=>({
                        Component: (await (parcelRequire("gc9wr"))).NotAllowedPage
                    })
            },
            // Legacy tag-based hierarchy redirects — preserve backward compatibility
            // for bookmarks and external links that used the old level-prefixed URL scheme,
            // including deep links (for example: /TA/:hierarchyTag/Access).
            ...[
                "/TA/:hierarchyTag",
                "/TA/:hierarchyTag/:more",
                "/TA/:hierarchyTag/:more/*",
                "/Project/:hierarchyTag",
                "/Project/:hierarchyTag/:more",
                "/Project/:hierarchyTag/:more/*",
                "/Study/:hierarchyTag",
                "/Study/:hierarchyTag/:more",
                "/Study/:hierarchyTag/:more/*",
                "/Study/:studyName/Report/:reportName",
                "/Study/:studyName/Report/:reportName/:more",
                "/Study/:studyName/Report/:reportName/:more/*",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion/:more",
                "/Study/:studyName/Report/:reportName/Version/:tocMajorVersion/:more/*"
            ].map((path)=>({
                    path: path,
                    loader: (0, $2cGbu.hierarchyLegacyTagRedirectLoader),
                    element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hJxsI.default), {})
                })),
            // Ancestor tags encoded in path segments so the
            // backend can resolve the hierarchy within the correct parent scope.
            ...[
                "/Corporate",
                "/:taPrefix",
                "/:taPrefix/:projectCode",
                "/:taPrefix/:projectCode/:studyTag",
                "/:taPrefix/:projectCode/:studyTag/:reportName",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion"
            ].map((path)=>({
                    path: path,
                    loader: (0, $hOl3X.hierarchyLoader),
                    lazy: async ()=>({
                            Component: (await (parcelRequire("jyTqa"))).HierarchyPage
                        }),
                    children: [
                        {
                            index: true,
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("ds3GY"))).TOC : (await (parcelRequire("hYWVp"))).HierarchyProperties
                                })
                        },
                        {
                            path: "Access",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("bEAkI"))).AccessRights
                                })
                        },
                        {
                            path: "ClinicalLibrary",
                            children: [
                                {
                                    index: true,
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("bvOm4"))).LibraryNavigation
                                        })
                                },
                                {
                                    path: "CodeLists",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "CodeList/:codeListName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "DataSets",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "DataSet/:dataSetName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "ValueLists",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "ValueList/:valueListName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Comments",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Methods",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClauses",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClause/:whereClauseName/RangeCheck/:rangeCheckId",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "WhereClause/:whereClauseName",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Comment/:commentId",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                },
                                {
                                    path: "Method/:methodOid",
                                    lazy: async ()=>({
                                            Component: (await (parcelRequire("32h2z"))).LibraryTable
                                        })
                                }
                            ]
                        },
                        {
                            path: "DomainReplacements",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("8g2sn"))).HierarchyDomainReplacements
                                })
                        },
                        {
                            path: "Lists",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("722us"))).HierarchyLists
                                })
                        },
                        {
                            path: "Properties",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("hYWVp"))).HierarchyProperties
                                })
                        },
                        {
                            path: "Replacements",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("iDMqC"))).ExternalSinglesTable
                                })
                        },
                        {
                            path: "Tags",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("f07ct"))).HierarchyTags
                                })
                        },
                        {
                            path: "RowGroups",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("gw1l7"))).HierarchyRowGroups
                                })
                        },
                        {
                            path: "AnalysisMethods",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("glWJI"))).HierarchyAnalysisMethods
                                })
                        },
                        {
                            path: "AnalysisSets",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("4IOu9"))).HierarchyAnalysisSets
                                })
                        },
                        {
                            path: "DataSubsets",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("2A5OV"))).HierarchyDataSubsets
                                })
                        },
                        {
                            path: "GroupingFactors",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("enwL1"))).HierarchyGroupingFactors
                                })
                        },
                        {
                            path: "TOC",
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("ds3GY"))).TOC : (await (parcelRequire("6QJfg"))).NotFound
                                })
                        },
                        {
                            path: "Versions",
                            lazy: async ()=>({
                                    Component: path.includes(":reportName") ? (await (parcelRequire("hnIFa"))).ReportVersions : (await (parcelRequire("gGvWF"))).HierarchyHistoryTable
                                })
                        },
                        {
                            path: "AdvancedSearch",
                            lazy: async ()=>({
                                    Component: (await (parcelRequire("f7yUK"))).EditorBlocksSearchControls
                                })
                        }
                    ]
                })),
            // TLF pages (with hierarchy ancestor tags)
            ...[
                "/Corporate",
                "/:taPrefix",
                "/:taPrefix/:projectCode",
                "/:taPrefix/:projectCode/:studyTag",
                "/:taPrefix/:projectCode/:studyTag/:reportName"
            ].map((path)=>({
                    path: `${path}/NewTlf/:newType`,
                    loader: (0, $7aR3H.newTlfLoader),
                    lazy: async ()=>({
                            Component: (await (parcelRequire("7ooId"))).TlfPage
                        })
                })),
            // Old redirect links (numeric / UUID IDs)
            ...[
                "/H/:hierarchyId",
                "/H/:hierarchyId/:more",
                "/S/:hierarchyId",
                "/S/:hierarchyId/:more",
                "/R/:hierarchyId",
                "/R/:hierarchyId/:more"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4RsO4.hierarchyRedirectLoader),
                    element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hJxsI.default), {})
                })),
            // Old TlfDesigner pages and redirect from search
            ...[
                "/TlfDesigner/:azsolId/:version",
                "/TlfDesigner/:id"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4m8te.tlfRedirectLoader),
                    element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hJxsI.default), {})
                })),
            // Legacy template TLF URLs — redirect to the new /Template/-prefixed canonical routes.
            // Corporate: /Corporate/:azsolId/:version is unambiguous because the static "Corporate"
            // segment outranks the all-dynamic ancestor-path hierarchy routes.
            // TA / Project: the old level-prefix segments (/TA/, /Project/) are static, so these
            // four-segment routes are ranked above the all-dynamic
            // /:taPrefix/:projectCode/:studyTag/:reportName Report hierarchy route that would
            // otherwise consume them.
            ...[
                "/Corporate/:azsolId/:version",
                "/TA/:taPrefix/:azsolId/:version",
                "/Project/:projectCode/:azsolId/:version"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4m8te.tlfRedirectLoader),
                    element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hJxsI.default), {})
                })),
            // Load tlf (with hierarchy ancestor tags)
            ...[
                "/Corporate/Load",
                "/:taPrefix/Load",
                "/:taPrefix/:projectCode/Load",
                "/:taPrefix/:projectCode/:studyTag/Load",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Load",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion/Load"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4PTsY.tlfLoader),
                    shouldRevalidate: $0874995828be5bfd$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("7ooId"))).TlfPage
                        })
                })),
            // Template pages — a static "Template" segment is required for all levels to avoid
            // ambiguity with the all-dynamic hierarchy routes. Without it,
            // /:taPrefix/:azsolId/:version is indistinguishable from
            // /:taPrefix/:projectCode/:studyTag (Study hierarchy), and
            // /:taPrefix/:projectCode/:azsolId/:version is indistinguishable from
            // /:taPrefix/:projectCode/:studyTag/:reportName (Report hierarchy).
            // Corporate could technically omit the prefix (the static "Corporate" segment
            // already disambiguates), but the prefix is kept for consistency.
            ...[
                "/Corporate/Template/:azsolId/:version",
                "/:taPrefix/Template/:azsolId/:version",
                "/:taPrefix/:projectCode/Template/:azsolId/:version"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4PTsY.tlfLoader),
                    shouldRevalidate: $0874995828be5bfd$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("7ooId"))).TlfPage
                        })
                })),
            // Shell pages (with hierarchy ancestor tag)
            ...[
                "/:taPrefix/:projectCode/:studyTag/:reportName/:tocNumber",
                "/:taPrefix/:projectCode/:studyTag/:reportName/Version/:tocMajorVersion/:tocNumber"
            ].map((path)=>({
                    path: path,
                    loader: (0, $4PTsY.tlfLoader),
                    shouldRevalidate: $0874995828be5bfd$var$shouldRevalidateOnPathnameChange,
                    lazy: async ()=>({
                            Component: (await (parcelRequire("7ooId"))).TlfPage
                        })
                })),
            // Review pages (with hierarchy ancestor tags)
            ...[
                "/:taPrefix/:projectCode/:studyTag/:reportName/Review"
            ].map((path)=>({
                    path: path,
                    loader: (0, $hOl3X.hierarchyLoader),
                    element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hXN68.default), {}),
                    children: [
                        {
                            path: ":tocNumber",
                            loader: (0, $4PTsY.tlfLoader),
                            element: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hXN68.TlfReviewRHS), {})
                        },
                        {
                            index: true,
                            element: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "w-100 h-100 d-flex align-items-center justify-content-center",
                                children: "Choose from the list of TLF items"
                            })
                        }
                    ]
                })),
            // Not found splat
            {
                path: "/*",
                lazy: async ()=>({
                        Component: (await (parcelRequire("6QJfg"))).NotFound
                    })
            }
        ]
    }
];

});
parcelRegister("aIQKp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bd5dee87036f679$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $dbTcY = parcelRequire("dbTcY");

var $6iYEs = parcelRequire("6iYEs");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");

var $5hPwN = parcelRequire("5hPwN");

var $3iVnd = parcelRequire("3iVnd");

var $3tNrK = parcelRequire("3tNrK");

var $7EL5p = parcelRequire("7EL5p");

var $irvto = parcelRequire("irvto");
const $7bd5dee87036f679$export$b89f06cf587ba0db = ()=>{
    const loaderData = (0, $4Q81F.useLoaderData)();
    const navigate = (0, $4Q81F.useNavigate)(); // Save not to use useCheckBeforeNavigate here - there are no unsaved changes in this context
    const location = (0, $4Q81F.useLocation)();
    // MSAL info
    const { accounts: accounts } = (0, $dbTcY.useMsal)();
    const account = (0, $dbTcY.useAccount)(accounts[0]);
    const backEndUrl = loaderData.backEndUrl;
    const crystalUrl = loaderData.crystalUrl;
    let displayName = (0, $5hPwN.defaultSettings).displayName;
    let prid = (0, $5hPwN.defaultSettings).prid;
    if (account) {
        displayName = `${account.name} (${account.username})`;
        prid = account.username.split("@")[0];
    }
    // Navigate for bad people
    if (account && account.username.split("@")[1] !== (0, $5hPwN.defaultSettings).domain && account.username.split("@")[0].length > 20 && location.pathname !== "/NotAllowed") navigate("/NotAllowed");
    // Get application permissions
    const userId = loaderData.me.userId ?? // istanbul ignore next
    (0, $5hPwN.defaultSettings).userId;
    const isAdmin = loaderData.me.isAdmin ?? // istanbul ignore next
    false;
    const applicationPermissions = loaderData.me.applicationPermissions ?? // istanbul ignore next
    [];
    // Get back end version number
    const backEndVersion = loaderData.backEndVersion ?? // istanbul ignore next
    "Error getting version";
    // Check maintenance mode
    const maintenanceMode = loaderData.maintenanceMode.maintenanceMode;
    const maintenanceMessage = loaderData.maintenanceMode.maintenanceMessage ?? // istanbul ignore next
    "";
    // Redirect for maintenance mode
    /* istanbul ignore else */ if (maintenanceMode && !location.pathname.startsWith("/Admin") && location.pathname !== "/Maintenance") navigate("/Maintenance");
    // Extra context data
    const helpLinks = loaderData.helpLinks;
    const styles = loaderData.styles;
    const figureSettings = loaderData.figureSettings;
    const annotationComparatorTypes = loaderData.annotationComparatorTypes;
    const allowedReportTypes = loaderData.allowedReportTypes;
    // Unified reducer managing domain slices and their shared undo history
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $3iVnd.unifiedReducer), {
        ...(0, $3tNrK.unifiedInitialState),
        appSettingsLoaded: true,
        applicationPermissions: applicationPermissions,
        backEndUrl: backEndUrl,
        backEndVersion: backEndVersion,
        crystalUrl: crystalUrl,
        displayName: displayName,
        figureSettings: figureSettings,
        helpLinks: helpLinks,
        isAdmin: isAdmin,
        maintenanceMessage: maintenanceMessage,
        maintenanceMode: maintenanceMode,
        prid: prid,
        styles: styles,
        userId: userId,
        annotationComparatorTypes: annotationComparatorTypes,
        allowedReportTypes: allowedReportTypes
    });
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $3tNrK.AppSettingsContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7EL5p.KeyboardBindings), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $irvto.SignalRProvider), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6iYEs.UnsavedChangesProvider), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.DockingProvider), {
                        minZIndex: 900,
                        maxZIndex: 1049,
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            id: "app-root",
                            style: {
                                paddingBottom: "42px",
                                height: "100vh",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4Q81F.Outlet), {})
                        })
                    })
                })
            })
        ]
    });
};
$7bd5dee87036f679$export$b89f06cf587ba0db.displayName = "AppSettingsContextProvider";
var $7bd5dee87036f679$export$2e2bcd8739ae039 = $7bd5dee87036f679$export$b89f06cf587ba0db;

});
parcelRegister("dbTcY", function(module, exports) {

$parcel$export(module.exports, "MsalAuthenticationTemplate", function () { return $98bbc3c8a7bbabad$export$c9cd7a02d4bd7707; }, function (v) { return $98bbc3c8a7bbabad$export$c9cd7a02d4bd7707 = v; });
$parcel$export(module.exports, "MsalProvider", function () { return $98bbc3c8a7bbabad$export$25bac41dc3d78d47; }, function (v) { return $98bbc3c8a7bbabad$export$25bac41dc3d78d47 = v; });
$parcel$export(module.exports, "useAccount", function () { return $98bbc3c8a7bbabad$export$83a8e409853da004; }, function (v) { return $98bbc3c8a7bbabad$export$83a8e409853da004 = v; });
$parcel$export(module.exports, "useMsal", function () { return $98bbc3c8a7bbabad$export$f41558044a1dd55; }, function (v) { return $98bbc3c8a7bbabad$export$f41558044a1dd55 = v; });
/*! @azure/msal-react v5.7.4 2026-10-27 */ var $98bbc3c8a7bbabad$export$3f7734c901feade6;
var $98bbc3c8a7bbabad$export$c9cd7a02d4bd7707;
var $98bbc3c8a7bbabad$export$b74154d0810e24c1;
var $98bbc3c8a7bbabad$export$66324aeea97dd1e5;
var $98bbc3c8a7bbabad$export$25bac41dc3d78d47;
var $98bbc3c8a7bbabad$export$8285a35799c5812b;
var $98bbc3c8a7bbabad$export$83a8e409853da004;
var $98bbc3c8a7bbabad$export$7e9c60d6d1836c84;
var $98bbc3c8a7bbabad$export$f41558044a1dd55;
var $98bbc3c8a7bbabad$export$d130d543558e611f;
var $98bbc3c8a7bbabad$export$83d89fbfd8236492;
var $98bbc3c8a7bbabad$export$8dea26c30ebc61cd;
'use strict';
'use strict';

var $spJKX = parcelRequire("spJKX");

var $884tT = parcelRequire("884tT");
function $98bbc3c8a7bbabad$var$_interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n.default = e;
    return Object.freeze(n);
}
var $98bbc3c8a7bbabad$var$React__namespace = /*#__PURE__*/ $98bbc3c8a7bbabad$var$_interopNamespaceDefault($spJKX);
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $98bbc3c8a7bbabad$var$defaultMsalContext = {
    instance: $884tT.stubbedPublicClientApplication,
    inProgress: $884tT.InteractionStatus.None,
    accounts: [],
    logger: new $884tT.Logger({})
};
const $98bbc3c8a7bbabad$var$MsalContext = $98bbc3c8a7bbabad$var$React__namespace.createContext($98bbc3c8a7bbabad$var$defaultMsalContext);
const $98bbc3c8a7bbabad$var$MsalConsumer = $98bbc3c8a7bbabad$var$MsalContext.Consumer;
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $98bbc3c8a7bbabad$var$getChildrenOrFunction(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $98bbc3c8a7bbabad$var$accountArraysAreEqual(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $98bbc3c8a7bbabad$var$getAccountByIdentifiers(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}
/* eslint-disable header/header */ const $98bbc3c8a7bbabad$var$name = "@azure/msal-react";
const $98bbc3c8a7bbabad$var$version = "5.7.4";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $98bbc3c8a7bbabad$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $98bbc3c8a7bbabad$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $98bbc3c8a7bbabad$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === $884tT.InteractionStatus.Startup) {
                newInProgress = $884tT.InteractionStatus.None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'", "");
            }
            break;
        case $98bbc3c8a7bbabad$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = $884tT.EventMessageUtils.getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - '${message.eventType}' results in setting inProgress from '${previousState.inProgress}' to '${status}'`, "");
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    if (newInProgress === $884tT.InteractionStatus.Startup) // Can't start checking accounts until initialization is complete
    return previousState;
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !$98bbc3c8a7bbabad$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!$98bbc3c8a7bbabad$var$accountArraysAreEqual(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $98bbc3c8a7bbabad$var$MsalProvider({ instance: instance, children: children }) {
    $spJKX.useEffect(()=>{
        instance.initializeWrapperLibrary($884tT.WrapperSKU.React, $98bbc3c8a7bbabad$var$version);
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = $spJKX.useMemo(()=>{
        return instance.getLogger().clone($98bbc3c8a7bbabad$var$name, $98bbc3c8a7bbabad$var$version);
    }, [
        instance
    ]);
    const [state, updateState] = $spJKX.useReducer($98bbc3c8a7bbabad$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: $884tT.InteractionStatus.Startup,
            accounts: []
        };
    });
    $spJKX.useEffect(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $98bbc3c8a7bbabad$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: '${callbackId}'`, "");
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $98bbc3c8a7bbabad$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback '${callbackId}'`, "");
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return $spJKX.createElement($98bbc3c8a7bbabad$var$MsalContext.Provider, {
        value: contextValue
    }, children);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $98bbc3c8a7bbabad$var$useMsal = ()=>$spJKX.useContext($98bbc3c8a7bbabad$var$MsalContext);
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $98bbc3c8a7bbabad$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!$98bbc3c8a7bbabad$var$getAccountByIdentifiers(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $98bbc3c8a7bbabad$var$useIsAuthenticated(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = $98bbc3c8a7bbabad$var$useMsal();
    const isUserAuthenticated = $spJKX.useMemo(()=>{
        if (inProgress === $884tT.InteractionStatus.Startup) return false;
        return $98bbc3c8a7bbabad$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $98bbc3c8a7bbabad$var$AuthenticatedTemplate({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = $98bbc3c8a7bbabad$var$useMsal();
    const accountIdentifier = $spJKX.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $98bbc3c8a7bbabad$var$useIsAuthenticated(accountIdentifier);
    if (isAuthenticated && context.inProgress !== $884tT.InteractionStatus.Startup) return $spJKX.createElement($spJKX.Fragment, null, $98bbc3c8a7bbabad$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $98bbc3c8a7bbabad$var$UnauthenticatedTemplate({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = $98bbc3c8a7bbabad$var$useMsal();
    const accountIdentifier = $spJKX.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = $98bbc3c8a7bbabad$var$useIsAuthenticated(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== $884tT.InteractionStatus.Startup && context.inProgress !== $884tT.InteractionStatus.HandleRedirect) return $spJKX.createElement($spJKX.Fragment, null, $98bbc3c8a7bbabad$var$getChildrenOrFunction(children, context));
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $98bbc3c8a7bbabad$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return $98bbc3c8a7bbabad$var$getAccountByIdentifiers(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Helper function to determine whether 2 accountInfo objects represent the same account
 * @param accountA
 * @param accountB
 */ function $98bbc3c8a7bbabad$var$accountInfoIsEqual(accountA, accountB) {
    if (!accountA || !accountB) return false;
    const accountAClaims = accountA.idTokenClaims || {};
    const accountBClaims = accountB.idTokenClaims || {};
    // issued at timestamp and nonce are expected to change each time a new id token is acquired
    const claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
    return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $98bbc3c8a7bbabad$var$useAccount(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $98bbc3c8a7bbabad$var$useMsal();
    const [account, setAccount] = $spJKX.useState(()=>{
        if (inProgress === $884tT.InteractionStatus.Startup) return null;
        else return $98bbc3c8a7bbabad$var$getAccount(instance, accountIdentifiers);
    });
    const updateAccount = $spJKX.useCallback(()=>{
        const nextAccount = $98bbc3c8a7bbabad$var$getAccount(instance, accountIdentifiers);
        setAccount((currentAccount)=>{
            if (!$98bbc3c8a7bbabad$var$accountInfoIsEqual(currentAccount, nextAccount)) {
                logger.info("useAccount - Updating account", "");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        accountIdentifiers,
        instance,
        logger
    ]);
    $spJKX.useEffect(()=>{
        if (inProgress !== $884tT.InteractionStatus.Startup) updateAccount();
        const callbackId = instance.addEventCallback((message)=>{
            if (message.eventType === $884tT.EventType.ACTIVE_ACCOUNT_CHANGED || message.eventType === $884tT.EventType.LOGIN_SUCCESS && message.interactionType === $884tT.InteractionType.Silent) updateAccount();
        });
        return ()=>{
            if (callbackId) instance.removeEventCallback(callbackId);
        };
    }, [
        updateAccount,
        inProgress,
        instance
    ]);
    return account;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $98bbc3c8a7bbabad$var$ReactAuthErrorMessage = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $98bbc3c8a7bbabad$var$ReactAuthError extends $884tT.AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $98bbc3c8a7bbabad$var$ReactAuthError.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError(correlationId) {
        return new $98bbc3c8a7bbabad$var$ReactAuthError($98bbc3c8a7bbabad$var$ReactAuthErrorMessage.invalidInteractionType.code, correlationId || "", $98bbc3c8a7bbabad$var$ReactAuthErrorMessage.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError(correlationId) {
        return new $98bbc3c8a7bbabad$var$ReactAuthError($98bbc3c8a7bbabad$var$ReactAuthErrorMessage.unableToFallbackToInteraction.code, correlationId || "", $98bbc3c8a7bbabad$var$ReactAuthErrorMessage.unableToFallbackToInteraction.desc);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $98bbc3c8a7bbabad$var$useMsalAuthentication(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = $98bbc3c8a7bbabad$var$useMsal();
    const isAuthenticated = $98bbc3c8a7bbabad$var$useIsAuthenticated(accountIdentifiers);
    const account = $98bbc3c8a7bbabad$var$useAccount(accountIdentifiers);
    const [[result, error], setResponse] = $spJKX.useState([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = $spJKX.useRef(true);
    $spJKX.useEffect(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = $spJKX.useRef(inProgress !== $884tT.InteractionStatus.None);
    $spJKX.useEffect(()=>{
        interactionInProgress.current = inProgress !== $884tT.InteractionStatus.None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = $spJKX.useRef(true);
    $spJKX.useEffect(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = $spJKX.useCallback(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling getToken", callbackRequest?.correlationId || "");
            switch(loginType){
                case $884tT.InteractionType.Popup:
                    logger.verbose("useMsalAuthentication - Calling loginPopup", callbackRequest?.correlationId || "");
                    return instance.loginPopup(loginRequest);
                case $884tT.InteractionType.Redirect:
                    // This promise is not expected to resolve due to full frame redirect
                    logger.verbose("useMsalAuthentication - Calling loginRedirect", callbackRequest?.correlationId || "");
                    await instance.handleRedirectPromise();
                    return instance.loginRedirect(loginRequest).then(()=>null);
                case $884tT.InteractionType.Silent:
                    logger.verbose("useMsalAuthentication - Calling ssoSilent", callbackRequest?.correlationId || "");
                    return instance.ssoSilent(!!loginRequest ? loginRequest : {});
                default:
                    const invalidTypeError = $98bbc3c8a7bbabad$var$ReactAuthError.createInvalidInteractionTypeError(loginRequest?.correlationId);
                    if (mounted.current) setResponse([
                        null,
                        invalidTypeError
                    ]);
                    throw invalidTypeError;
            }
        };
        return getToken().then((response)=>{
            if (response && mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = $spJKX.useCallback(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback", callbackRequest.correlationId || "");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook", authenticationRequest.correlationId || "");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || $884tT.OIDC_DEFAULT_SCOPES
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.", "");
            tokenRequest = {
                scopes: $884tT.OIDC_DEFAULT_SCOPES
            };
        }
        const correlationId = tokenRequest.correlationId || $884tT.BrowserUtils.createGuid();
        tokenRequest.correlationId = correlationId;
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request", correlationId);
            tokenRequest.account = account;
        }
        return instance.acquireTokenSilent(tokenRequest).then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch(async (e)=>{
            if (e instanceof $884tT.InteractionRequiredAuthError) {
                if (!interactionInProgress.current) {
                    logger.error("useMsalAuthentication - Interaction required, falling back to interaction", correlationId);
                    return login(fallbackInteractionType, tokenRequest);
                } else {
                    const fallbackError = $98bbc3c8a7bbabad$var$ReactAuthError.createUnableToFallbackToInteractionError(correlationId);
                    logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.", correlationId);
                    if (mounted.current) setResponse([
                        null,
                        fallbackError
                    ]);
                    throw fallbackError;
                }
            }
            // Handle other errors
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    $spJKX.useEffect(()=>{
        if (shouldAcquireToken.current && inProgress === $884tT.InteractionStatus.None) {
            if (!isAuthenticated) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login", "");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                shouldAcquireToken.current = false;
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token", "");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        // If logging out, set the state to null so the component doesn't display authenticated content for a user that is logged out
        } else if (!account && result) setResponse([
            null,
            null
        ]);
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $98bbc3c8a7bbabad$var$MsalAuthenticationTemplate({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = $spJKX.useMemo(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = $98bbc3c8a7bbabad$var$useMsal();
    const msalAuthResult = $98bbc3c8a7bbabad$var$useMsalAuthentication(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = $98bbc3c8a7bbabad$var$useIsAuthenticated(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === $884tT.InteractionStatus.None) {
        if (!!ErrorComponent) return $spJKX.createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return $spJKX.createElement($spJKX.Fragment, null, $98bbc3c8a7bbabad$var$getChildrenOrFunction(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== $884tT.InteractionStatus.None) return $spJKX.createElement(LoadingComponent, {
        ...context
    });
    return null;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $98bbc3c8a7bbabad$var$withMsal = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = $98bbc3c8a7bbabad$var$useMsal();
        return $spJKX.createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};
$98bbc3c8a7bbabad$export$3f7734c901feade6 = $98bbc3c8a7bbabad$var$AuthenticatedTemplate;
$98bbc3c8a7bbabad$export$c9cd7a02d4bd7707 = $98bbc3c8a7bbabad$var$MsalAuthenticationTemplate;
$98bbc3c8a7bbabad$export$b74154d0810e24c1 = $98bbc3c8a7bbabad$var$MsalConsumer;
$98bbc3c8a7bbabad$export$66324aeea97dd1e5 = $98bbc3c8a7bbabad$var$MsalContext;
$98bbc3c8a7bbabad$export$25bac41dc3d78d47 = $98bbc3c8a7bbabad$var$MsalProvider;
$98bbc3c8a7bbabad$export$8285a35799c5812b = $98bbc3c8a7bbabad$var$UnauthenticatedTemplate;
$98bbc3c8a7bbabad$export$83a8e409853da004 = $98bbc3c8a7bbabad$var$useAccount;
$98bbc3c8a7bbabad$export$7e9c60d6d1836c84 = $98bbc3c8a7bbabad$var$useIsAuthenticated;
$98bbc3c8a7bbabad$export$f41558044a1dd55 = $98bbc3c8a7bbabad$var$useMsal;
$98bbc3c8a7bbabad$export$d130d543558e611f = $98bbc3c8a7bbabad$var$useMsalAuthentication;
$98bbc3c8a7bbabad$export$83d89fbfd8236492 = $98bbc3c8a7bbabad$var$version;
$98bbc3c8a7bbabad$export$8dea26c30ebc61cd = $98bbc3c8a7bbabad$var$withMsal; //# sourceMappingURL=msal-react.cjs.map

});
parcelRegister("884tT", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $9797579afd7d961c$export$243e62d78d3b544d; }, function (v) { return $9797579afd7d961c$export$243e62d78d3b544d = v; });
$parcel$export(module.exports, "InteractionType", function () { return $9797579afd7d961c$export$4ec29255e7e7f68f; }, function (v) { return $9797579afd7d961c$export$4ec29255e7e7f68f = v; });
$parcel$export(module.exports, "AuthError", function () { return $9797579afd7d961c$export$145273558d58e0ac; }, function (v) { return $9797579afd7d961c$export$145273558d58e0ac = v; });
$parcel$export(module.exports, "BrowserUtils", function () { return $9797579afd7d961c$export$311899ae85124b2d; }, function (v) { return $9797579afd7d961c$export$311899ae85124b2d = v; });
$parcel$export(module.exports, "EventMessageUtils", function () { return $9797579afd7d961c$export$ba9166e03da6599c; }, function (v) { return $9797579afd7d961c$export$ba9166e03da6599c = v; });
$parcel$export(module.exports, "EventType", function () { return $9797579afd7d961c$export$3d7865934588d77e; }, function (v) { return $9797579afd7d961c$export$3d7865934588d77e = v; });
$parcel$export(module.exports, "InteractionRequiredAuthError", function () { return $9797579afd7d961c$export$6ba3e818c6bc76ba; }, function (v) { return $9797579afd7d961c$export$6ba3e818c6bc76ba = v; });
$parcel$export(module.exports, "InteractionStatus", function () { return $9797579afd7d961c$export$bec20eda0179362b; }, function (v) { return $9797579afd7d961c$export$bec20eda0179362b = v; });
$parcel$export(module.exports, "Logger", function () { return $9797579afd7d961c$export$efa9a398d6368992; }, function (v) { return $9797579afd7d961c$export$efa9a398d6368992 = v; });
$parcel$export(module.exports, "OIDC_DEFAULT_SCOPES", function () { return $9797579afd7d961c$export$893b1b5b686d84ef; }, function (v) { return $9797579afd7d961c$export$893b1b5b686d84ef = v; });
$parcel$export(module.exports, "PublicClientApplication", function () { return $9797579afd7d961c$export$89f4855ef88b7920; }, function (v) { return $9797579afd7d961c$export$89f4855ef88b7920 = v; });
$parcel$export(module.exports, "WrapperSKU", function () { return $9797579afd7d961c$export$8abb9de997bb4e44; }, function (v) { return $9797579afd7d961c$export$8abb9de997bb4e44 = v; });
$parcel$export(module.exports, "stubbedPublicClientApplication", function () { return $9797579afd7d961c$export$29650b96fd06034a; }, function (v) { return $9797579afd7d961c$export$29650b96fd06034a = v; });
/*! @azure/msal-browser v5.27.0 2026-10-27 */ /*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $9797579afd7d961c$export$243e62d78d3b544d;
/*
 * Interaction type of the API - used for state and telemetry
 */ var $9797579afd7d961c$export$4ec29255e7e7f68f;
var $9797579afd7d961c$export$192d74ad69b40705;
var $9797579afd7d961c$export$145273558d58e0ac;
var $9797579afd7d961c$export$473ab0b56598aacd;
var $9797579afd7d961c$export$46f6771f16bdfbc6;
var $9797579afd7d961c$export$901491a717da2ba5;
var $9797579afd7d961c$export$4cda21933050d9ec;
var $9797579afd7d961c$export$f8eb6760ca13876a;
var $9797579afd7d961c$export$a206205e46059d69;
var $9797579afd7d961c$export$573384e47a12d835;
var $9797579afd7d961c$export$2eb7a1dfdc4c5fba;
var $9797579afd7d961c$export$5b6860c1e1ad8019;
var $9797579afd7d961c$export$3714d85cfc8f4a02;
var $9797579afd7d961c$export$f97b8b5459a3aa4;
var $9797579afd7d961c$export$2ae77374159d4955;
var $9797579afd7d961c$export$311899ae85124b2d;
var $9797579afd7d961c$export$4394baa7e922d42d;
var $9797579afd7d961c$export$a839ff85a7957561;
var $9797579afd7d961c$export$dc9623d93fc077da;
var $9797579afd7d961c$export$ac9d9d20c2327339;
var $9797579afd7d961c$export$5fde068af21a5dfb;
var $9797579afd7d961c$export$f3ffe700be354b19;
var $9797579afd7d961c$export$ce0ba2422a1c7815;
var $9797579afd7d961c$export$ba9166e03da6599c;
var $9797579afd7d961c$export$3d7865934588d77e;
var $9797579afd7d961c$export$6ba3e818c6bc76ba;
var $9797579afd7d961c$export$ecddfe385fe09c26;
var $9797579afd7d961c$export$bec20eda0179362b;
var $9797579afd7d961c$export$fe5c42ed17efe603;
var $9797579afd7d961c$export$19fffca37ef3e106;
var $9797579afd7d961c$export$efa9a398d6368992;
var $9797579afd7d961c$export$d7392285c701ecf5;
var $9797579afd7d961c$export$d0d362a73d466c9b;
var $9797579afd7d961c$export$893b1b5b686d84ef;
var $9797579afd7d961c$export$49a06cbda5acaa5;
var $9797579afd7d961c$export$73a3e3dedd37150d;
var $9797579afd7d961c$export$89f4855ef88b7920;
var $9797579afd7d961c$export$f990a5bae1260b8c;
var $9797579afd7d961c$export$ea52035eac03daf0;
var $9797579afd7d961c$export$2c4b17e1c2e0931;
var $9797579afd7d961c$export$e1f04f41501741ea;
var $9797579afd7d961c$export$c70f2989a65fda3e;
var $9797579afd7d961c$export$8abb9de997bb4e44;
var $9797579afd7d961c$export$210078d2745a65ac;
var $9797579afd7d961c$export$f28b97cfb2f3098;
var $9797579afd7d961c$export$df47a28b08fa2370;
var $9797579afd7d961c$export$bce61db0d62ff8e2;
var $9797579afd7d961c$export$267894f3740f96bf;
var $9797579afd7d961c$export$29650b96fd06034a;
var $9797579afd7d961c$export$83d89fbfd8236492;
'use strict';
'use strict';
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$CLIENT_ID = "client_id";
const $9797579afd7d961c$var$REDIRECT_URI = "redirect_uri";
const $9797579afd7d961c$var$RESPONSE_TYPE = "response_type";
const $9797579afd7d961c$var$RESPONSE_MODE = "response_mode";
const $9797579afd7d961c$var$GRANT_TYPE = "grant_type";
const $9797579afd7d961c$var$CLAIMS = "claims";
const $9797579afd7d961c$var$SCOPE = "scope";
const $9797579afd7d961c$var$REFRESH_TOKEN = "refresh_token";
const $9797579afd7d961c$var$STATE = "state";
const $9797579afd7d961c$var$NONCE = "nonce";
const $9797579afd7d961c$var$PROMPT = "prompt";
const $9797579afd7d961c$var$CODE = "code";
const $9797579afd7d961c$var$CODE_CHALLENGE = "code_challenge";
const $9797579afd7d961c$var$CODE_CHALLENGE_METHOD = "code_challenge_method";
const $9797579afd7d961c$var$CODE_VERIFIER = "code_verifier";
const $9797579afd7d961c$var$CLIENT_REQUEST_ID = "client-request-id";
const $9797579afd7d961c$var$X_CLIENT_SKU = "x-client-SKU";
const $9797579afd7d961c$var$X_CLIENT_VER = "x-client-VER";
const $9797579afd7d961c$var$X_CLIENT_OS = "x-client-OS";
const $9797579afd7d961c$var$X_CLIENT_CPU = "x-client-CPU";
const $9797579afd7d961c$var$X_CLIENT_CURR_TELEM = "x-client-current-telemetry";
const $9797579afd7d961c$var$X_CLIENT_LAST_TELEM = "x-client-last-telemetry";
const $9797579afd7d961c$var$X_MS_LIB_CAPABILITY = "x-ms-lib-capability";
const $9797579afd7d961c$var$X_APP_NAME = "x-app-name";
const $9797579afd7d961c$var$X_APP_VER = "x-app-ver";
const $9797579afd7d961c$var$POST_LOGOUT_URI = "post_logout_redirect_uri";
const $9797579afd7d961c$var$ID_TOKEN_HINT = "id_token_hint";
const $9797579afd7d961c$var$CLIENT_SECRET = "client_secret";
const $9797579afd7d961c$var$CLIENT_ASSERTION = "client_assertion";
const $9797579afd7d961c$var$CLIENT_ASSERTION_TYPE = "client_assertion_type";
const $9797579afd7d961c$var$TOKEN_TYPE = "token_type";
const $9797579afd7d961c$var$REQ_CNF = "req_cnf";
const $9797579afd7d961c$var$DPOP_JKT = "dpop_jkt";
const $9797579afd7d961c$var$RETURN_SPA_CODE = "return_spa_code";
const $9797579afd7d961c$var$NATIVE_BROKER = "nativebroker";
const $9797579afd7d961c$var$LOGOUT_HINT = "logout_hint";
const $9797579afd7d961c$var$SID = "sid";
const $9797579afd7d961c$var$LOGIN_HINT = "login_hint";
const $9797579afd7d961c$var$DOMAIN_HINT = "domain_hint";
const $9797579afd7d961c$var$X_CLIENT_EXTRA_SKU = "x-client-xtra-sku";
const $9797579afd7d961c$var$BROKER_CLIENT_ID = "brk_client_id";
const $9797579afd7d961c$var$BROKER_REDIRECT_URI = "brk_redirect_uri";
const $9797579afd7d961c$var$INSTANCE_AWARE = "instance_aware";
const $9797579afd7d961c$var$EAR_JWK = "ear_jwk";
const $9797579afd7d961c$var$EAR_JWE_CRYPTO = "ear_jwe_crypto";
const $9797579afd7d961c$var$RESOURCE = "resource";
const $9797579afd7d961c$var$CLI_DATA = "clidata";
const $9797579afd7d961c$var$ATTRIBUTE_TOKENS = "attribute_tokens";
/**
 * Popup-origin-check-done. Signals to the STS that the client verified the
 * popup cannot be reached by an untrusted window, so the
 * Cross-Origin-Opener-Policy response header may be omitted.
 */ const $9797579afd7d961c$var$POPUP_ORIGIN_CHECK_DONE = "pocd";
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$SKU = "msal.js.common";
// default authority
const $9797579afd7d961c$var$DEFAULT_AUTHORITY = "https://login.microsoftonline.com/common/";
const $9797579afd7d961c$var$DEFAULT_AUTHORITY_HOST = "login.microsoftonline.com";
const $9797579afd7d961c$var$DEFAULT_COMMON_TENANT = "common";
// ADFS String
const $9797579afd7d961c$var$ADFS = "adfs";
// Default AAD Instance Discovery Endpoint
const $9797579afd7d961c$var$AAD_INSTANCE_DISCOVERY_ENDPT = `${$9797579afd7d961c$var$DEFAULT_AUTHORITY}discovery/instance?api-version=1.1&authorization_endpoint=`;
// CIAM URL
const $9797579afd7d961c$var$CIAM_AUTH_URL = ".ciamlogin.com";
const $9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX = ".onmicrosoft.com";
// Resource delimiter - used for certain cache entries
const $9797579afd7d961c$var$RESOURCE_DELIM = "|";
// Default scopes
const $9797579afd7d961c$var$OPENID_SCOPE = "openid";
const $9797579afd7d961c$var$PROFILE_SCOPE = "profile";
const $9797579afd7d961c$var$OFFLINE_ACCESS_SCOPE = "offline_access";
const $9797579afd7d961c$var$EMAIL_SCOPE = "email";
const $9797579afd7d961c$var$S256_CODE_CHALLENGE_METHOD = "S256";
const $9797579afd7d961c$var$URL_FORM_CONTENT_TYPE = "application/x-www-form-urlencoded;charset=utf-8";
const $9797579afd7d961c$var$NOT_APPLICABLE = "N/A";
const $9797579afd7d961c$var$NOT_AVAILABLE = "Not Available";
const $9797579afd7d961c$var$FORWARD_SLASH = "/";
const $9797579afd7d961c$var$IMDS_ENDPOINT = "http://169.254.169.254/metadata/instance/compute";
const $9797579afd7d961c$var$IMDS_VERSION = "2021-02-01";
const $9797579afd7d961c$var$IMDS_TIMEOUT = 2000;
const $9797579afd7d961c$var$AZURE_REGION_AUTO_DISCOVER_FLAG = "TryAutoDetect";
const $9797579afd7d961c$var$REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX = "login.microsoft.com";
const $9797579afd7d961c$var$KNOWN_PUBLIC_CLOUDS = [
    "login.microsoftonline.com",
    "login.windows.net",
    "login.microsoft.com",
    "sts.windows.net"
];
const $9797579afd7d961c$var$SHR_NONCE_VALIDITY = 240;
const $9797579afd7d961c$var$INVALID_INSTANCE = "invalid_instance";
const $9797579afd7d961c$var$HTTP_SUCCESS = 200;
const $9797579afd7d961c$var$HTTP_CLIENT_ERROR_RANGE_START = 400;
const $9797579afd7d961c$var$HTTP_BAD_REQUEST = 400;
const $9797579afd7d961c$var$HTTP_CLIENT_ERROR_RANGE_END = 499;
const $9797579afd7d961c$var$HTTP_SERVER_ERROR_RANGE_START = 500;
const $9797579afd7d961c$var$HTTP_SERVER_ERROR_RANGE_END = 599;
const $9797579afd7d961c$var$HttpMethod = {
    GET: "GET",
    POST: "POST"
};
const $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1 = [
    $9797579afd7d961c$var$OPENID_SCOPE,
    $9797579afd7d961c$var$PROFILE_SCOPE,
    $9797579afd7d961c$var$OFFLINE_ACCESS_SCOPE
];
const $9797579afd7d961c$var$OIDC_SCOPES = [
    ...$9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1,
    $9797579afd7d961c$var$EMAIL_SCOPE
];
/**
 * Request header names
 */ const $9797579afd7d961c$var$HeaderNames = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    DPOP: "DPoP",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $9797579afd7d961c$var$PersistentCacheKeys = {
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $9797579afd7d961c$var$AADAuthority = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $9797579afd7d961c$var$ClaimsRequestKeys = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc",
    ID_TOKEN: "id_token",
    SIGNIN_STATE: "signin_state",
    LOGIN_HINT: "login_hint",
    TENANT_REGION_SUB_SCOPE: "tenant_region_sub_scope"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $9797579afd7d961c$var$PromptValue$1 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * Allowed values for response_type
 */ const $9797579afd7d961c$var$OAuthResponseType = {
    CODE: "code",
    IDTOKEN_TOKEN_REFRESHTOKEN: "id_token token refresh_token"
};
/**
 * allowed values for response_mode
 */ const $9797579afd7d961c$var$ResponseMode$1 = {
    QUERY: "query",
    FRAGMENT: "fragment",
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $9797579afd7d961c$var$GrantType = {
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    REFRESH_TOKEN_GRANT: "refresh_token"
};
/**
 * Account types in Cache
 */ const $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_MSSTS = "MSSTS";
const $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_ADFS = "ADFS";
const $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_GENERIC = "Generic";
/**
 * Separators used in cache
 */ const $9797579afd7d961c$var$CACHE_KEY_SEPARATOR$1 = "-";
const $9797579afd7d961c$var$CLIENT_INFO_SEPARATOR = ".";
/**
 * Credential Type stored in the cache
 */ const $9797579afd7d961c$var$CredentialType = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * More Cache related constants
 */ const $9797579afd7d961c$var$APP_METADATA = "appmetadata";
const $9797579afd7d961c$var$CLIENT_INFO = "client_info";
const $9797579afd7d961c$var$THE_FAMILY_ID = "1";
const $9797579afd7d961c$var$AUTHORITY_METADATA_CACHE_KEY = "authority-metadata";
const $9797579afd7d961c$var$AUTHORITY_METADATA_REFRESH_TIME_SECONDS = 86400; // 24 Hours
const $9797579afd7d961c$var$AuthorityMetadataSource = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $9797579afd7d961c$var$SERVER_TELEM_SCHEMA_VERSION = 5;
const $9797579afd7d961c$var$SERVER_TELEM_MAX_LAST_HEADER_BYTES = 330; // ESTS limit is 350B, set to 330 to provide a 20B buffer,
const $9797579afd7d961c$var$SERVER_TELEM_MAX_CACHED_ERRORS = 50; // Limit the number of errors that can be stored to prevent uncontrolled size gains
const $9797579afd7d961c$var$SERVER_TELEM_CACHE_KEY = "server-telemetry";
const $9797579afd7d961c$var$SERVER_TELEM_CATEGORY_SEPARATOR = "|";
const $9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR = ",";
const $9797579afd7d961c$var$SERVER_TELEM_OVERFLOW_TRUE = "1";
const $9797579afd7d961c$var$SERVER_TELEM_OVERFLOW_FALSE = "0";
const $9797579afd7d961c$var$SERVER_TELEM_UNKNOWN_ERROR = "unknown_error";
/**
 * Type of the authentication request
 */ const $9797579afd7d961c$var$AuthenticationScheme$1 = {
    BEARER: "Bearer",
    POP: "pop",
    DPOP: "DPoP",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $9797579afd7d961c$var$DEFAULT_THROTTLE_TIME_SECONDS = 60;
// Default maximum time to throttle in seconds, overrides what the server sends back
const $9797579afd7d961c$var$DEFAULT_MAX_THROTTLE_TIME_SECONDS = 3600;
// Prefix for storing throttling entries
const $9797579afd7d961c$var$THROTTLING_PREFIX = "throttling";
// Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
const $9797579afd7d961c$var$X_MS_LIB_CAPABILITY_VALUE = "retry-after, h429";
/**
 * Errors
 */ const $9797579afd7d961c$var$INVALID_GRANT_ERROR = "invalid_grant";
const $9797579afd7d961c$var$CLIENT_MISMATCH_ERROR = "client_mismatch";
/**
 * Region Discovery Sources
 */ const $9797579afd7d961c$var$RegionDiscoverySources = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $9797579afd7d961c$var$RegionDiscoveryOutcomes = {
    CONFIGURED_NO_AUTO_DETECTION: "2",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $9797579afd7d961c$var$CacheOutcome = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $9797579afd7d961c$var$JsonWebTokenTypes$1 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop",
    Dpop: "dpop+jwt"
};
// Token renewal offset default in seconds
const $9797579afd7d961c$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$getDefaultErrorMessage$1(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * General error class thrown by the MSAL.js library.
 */ class $9797579afd7d961c$var$AuthError extends Error {
    constructor(errorCode, correlationId, errorMessage, suberror){
        const message = errorMessage || (errorCode ? $9797579afd7d961c$var$getDefaultErrorMessage$1(errorCode) : "");
        const errorString = message ? `${errorCode}: ${message}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$AuthError.prototype);
        this.errorCode = errorCode || "";
        this.errorMessage = message || "";
        this.subError = suberror || "";
        this.correlationId = correlationId;
        this.name = "AuthError";
    }
}
function $9797579afd7d961c$var$createAuthError(code, correlationId, additionalMessage) {
    return new $9797579afd7d961c$var$AuthError(code, correlationId, additionalMessage || $9797579afd7d961c$var$getDefaultErrorMessage$1(code));
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $9797579afd7d961c$var$ClientAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, additionalMessage){
        super(errorCode, correlationId, additionalMessage);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $9797579afd7d961c$var$ClientAuthError.prototype);
    }
}
function $9797579afd7d961c$var$createClientAuthError(errorCode, correlationId, additionalMessage) {
    return new $9797579afd7d961c$var$ClientAuthError(errorCode, correlationId, additionalMessage);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$clientInfoDecodingError = "client_info_decoding_error";
const $9797579afd7d961c$var$clientInfoEmptyError = "client_info_empty_error";
const $9797579afd7d961c$var$tokenParsingError = "token_parsing_error";
const $9797579afd7d961c$var$nullOrEmptyToken = "null_or_empty_token";
const $9797579afd7d961c$var$endpointResolutionError = "endpoints_resolution_error";
const $9797579afd7d961c$var$networkError = "network_error";
const $9797579afd7d961c$var$openIdConfigError = "openid_config_error";
const $9797579afd7d961c$var$hashNotDeserialized = "hash_not_deserialized";
const $9797579afd7d961c$var$invalidState = "invalid_state";
const $9797579afd7d961c$var$stateMismatch = "state_mismatch";
const $9797579afd7d961c$var$stateNotFound = "state_not_found";
const $9797579afd7d961c$var$nonceMismatch = "nonce_mismatch";
const $9797579afd7d961c$var$multipleMatchingTokens = "multiple_matching_tokens";
const $9797579afd7d961c$var$multipleMatchingAppMetadata = "multiple_matching_appMetadata";
const $9797579afd7d961c$var$requestCannotBeMade = "request_cannot_be_made";
const $9797579afd7d961c$var$cannotRemoveEmptyScope = "cannot_remove_empty_scope";
const $9797579afd7d961c$var$cannotAppendScopeSet = "cannot_append_scopeset";
const $9797579afd7d961c$var$emptyInputScopeSet = "empty_input_scopeset";
const $9797579afd7d961c$var$noAccountInSilentRequest = "no_account_in_silent_request";
const $9797579afd7d961c$var$invalidCacheRecord = "invalid_cache_record";
const $9797579afd7d961c$var$invalidCacheEnvironment = "invalid_cache_environment";
const $9797579afd7d961c$var$noAccountFound = "no_account_found";
const $9797579afd7d961c$var$noCryptoObject = "no_crypto_object";
const $9797579afd7d961c$var$unexpectedCredentialType = "unexpected_credential_type";
const $9797579afd7d961c$var$dpopTokenTypeMismatch = "dpop_token_type_mismatch";
const $9797579afd7d961c$var$tokenRefreshRequired = "token_refresh_required";
const $9797579afd7d961c$var$tokenClaimsCnfRequiredForSignedJwt = "token_claims_cnf_required_for_signedjwt";
const $9797579afd7d961c$var$authorizationCodeMissingFromServerResponse = "authorization_code_missing_from_server_response";
const $9797579afd7d961c$var$bindingKeyNotRemoved = "binding_key_not_removed";
const $9797579afd7d961c$var$endSessionEndpointNotSupported = "end_session_endpoint_not_supported";
const $9797579afd7d961c$var$keyIdMissing = "key_id_missing";
const $9797579afd7d961c$var$noNetworkConnectivity$1 = "no_network_connectivity";
const $9797579afd7d961c$var$userCanceled = "user_canceled";
const $9797579afd7d961c$var$methodNotImplemented = "method_not_implemented";
const $9797579afd7d961c$var$nestedAppAuthBridgeDisabled = "nested_app_auth_bridge_disabled";
const $9797579afd7d961c$var$platformBrokerError = "platform_broker_error";
const $9797579afd7d961c$var$resourceParameterRequired = "resource_parameter_required";
const $9797579afd7d961c$var$misplacedResourceParam = "misplaced_resource_parameter";
var $9797579afd7d961c$var$ClientAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authorizationCodeMissingFromServerResponse: $9797579afd7d961c$var$authorizationCodeMissingFromServerResponse,
    bindingKeyNotRemoved: $9797579afd7d961c$var$bindingKeyNotRemoved,
    cannotAppendScopeSet: $9797579afd7d961c$var$cannotAppendScopeSet,
    cannotRemoveEmptyScope: $9797579afd7d961c$var$cannotRemoveEmptyScope,
    clientInfoDecodingError: $9797579afd7d961c$var$clientInfoDecodingError,
    clientInfoEmptyError: $9797579afd7d961c$var$clientInfoEmptyError,
    dpopTokenTypeMismatch: $9797579afd7d961c$var$dpopTokenTypeMismatch,
    emptyInputScopeSet: $9797579afd7d961c$var$emptyInputScopeSet,
    endSessionEndpointNotSupported: $9797579afd7d961c$var$endSessionEndpointNotSupported,
    endpointResolutionError: $9797579afd7d961c$var$endpointResolutionError,
    hashNotDeserialized: $9797579afd7d961c$var$hashNotDeserialized,
    invalidCacheEnvironment: $9797579afd7d961c$var$invalidCacheEnvironment,
    invalidCacheRecord: $9797579afd7d961c$var$invalidCacheRecord,
    invalidState: $9797579afd7d961c$var$invalidState,
    keyIdMissing: $9797579afd7d961c$var$keyIdMissing,
    methodNotImplemented: $9797579afd7d961c$var$methodNotImplemented,
    misplacedResourceParam: $9797579afd7d961c$var$misplacedResourceParam,
    multipleMatchingAppMetadata: $9797579afd7d961c$var$multipleMatchingAppMetadata,
    multipleMatchingTokens: $9797579afd7d961c$var$multipleMatchingTokens,
    nestedAppAuthBridgeDisabled: $9797579afd7d961c$var$nestedAppAuthBridgeDisabled,
    networkError: $9797579afd7d961c$var$networkError,
    noAccountFound: $9797579afd7d961c$var$noAccountFound,
    noAccountInSilentRequest: $9797579afd7d961c$var$noAccountInSilentRequest,
    noCryptoObject: $9797579afd7d961c$var$noCryptoObject,
    noNetworkConnectivity: $9797579afd7d961c$var$noNetworkConnectivity$1,
    nonceMismatch: $9797579afd7d961c$var$nonceMismatch,
    nullOrEmptyToken: $9797579afd7d961c$var$nullOrEmptyToken,
    openIdConfigError: $9797579afd7d961c$var$openIdConfigError,
    platformBrokerError: $9797579afd7d961c$var$platformBrokerError,
    requestCannotBeMade: $9797579afd7d961c$var$requestCannotBeMade,
    resourceParameterRequired: $9797579afd7d961c$var$resourceParameterRequired,
    stateMismatch: $9797579afd7d961c$var$stateMismatch,
    stateNotFound: $9797579afd7d961c$var$stateNotFound,
    tokenClaimsCnfRequiredForSignedJwt: $9797579afd7d961c$var$tokenClaimsCnfRequiredForSignedJwt,
    tokenParsingError: $9797579afd7d961c$var$tokenParsingError,
    tokenRefreshRequired: $9797579afd7d961c$var$tokenRefreshRequired,
    unexpectedCredentialType: $9797579afd7d961c$var$unexpectedCredentialType,
    userCanceled: $9797579afd7d961c$var$userCanceled
});
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $9797579afd7d961c$var$buildClientInfo(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$clientInfoEmptyError, "");
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$clientInfoDecodingError, "");
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(homeAccountId) {
    if (!homeAccountId) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$clientInfoDecodingError, "");
    const clientInfoParts = homeAccountId.split($9797579afd7d961c$var$CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? "" : clientInfoParts[1]
    };
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $9797579afd7d961c$var$extractTokenClaims(encodedToken, base64Decode, correlationId) {
    const jswPayload = $9797579afd7d961c$var$getJWSPayload(encodedToken, correlationId);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenParsingError, correlationId);
    }
}
/**
 * Check if the signin_state claim contains "kmsi"
 * @param idTokenClaims
 * @returns
 */ function $9797579afd7d961c$var$isKmsi(idTokenClaims) {
    if (!idTokenClaims.signin_state) return false;
    /**
     * Signin_state claim known values:
     * dvc_mngd - device is managed
     * dvc_dmjd - device is domain joined
     * kmsi - user opted to "keep me signed in"
     * inknownntwk - Request made inside a known network. Don't use this, use CAE instead.
     */ const kmsiClaims = [
        "kmsi",
        "dvc_dmjd"
    ]; // There are some cases where kmsi may not be returned but persistent storage is still OK - allow dvc_dmjd as well
    return idTokenClaims.signin_state.some((value)=>kmsiClaims.includes(value.trim().toLowerCase()));
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $9797579afd7d961c$var$getJWSPayload(authToken, correlationId) {
    if (!authToken) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$nullOrEmptyToken, correlationId);
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenParsingError, correlationId);
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $9797579afd7d961c$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param nativeAccountId - Native account identifier for this tenant
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $9797579afd7d961c$var$buildTenantProfile(homeAccountId, localAccountId, tenantId, nativeAccountId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr, preferred_username: preferred_username, upn: upn, login_hint: login_hint } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            username: preferred_username || upn || "",
            loginHint: login_hint,
            isHomeTenant: $9797579afd7d961c$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId),
            upn: upn,
            ...nativeAccountId && {
                nativeAccountId: nativeAccountId
            }
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        username: "",
        isHomeTenant: $9797579afd7d961c$var$tenantIdMatchesHomeTenant(tenantId, homeAccountId),
        ...nativeAccountId && {
            nativeAccountId: nativeAccountId
        }
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $9797579afd7d961c$var$updateAccountTenantProfileData(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant which is a utility property of tenant profile but not required in base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $9797579afd7d961c$var$buildTenantProfile(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, updatedAccountInfo.nativeAccountId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret,
            kmsi: $9797579afd7d961c$var$isKmsi(idTokenClaims)
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $9797579afd7d961c$var$AuthorityType = {
    Default: 0,
    Adfs: 1,
    Ciam: 3
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $9797579afd7d961c$var$getTenantIdFromIdTokenClaims(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $9797579afd7d961c$var$ProtocolMode = {
    /**
     * Auth Code + PKCE with Entra ID (formerly AAD) specific optimizations and features
     */ AAD: "AAD",
    /**
     * Auth Code + PKCE without Entra ID specific optimizations and features. For use only with non-Microsoft owned authorities.
     * Support is limited for this mode.
     */ OIDC: "OIDC",
    /**
     * Encrypted Authorize Response (EAR) with Entra ID specific optimizations and features
     */ EAR: "EAR"
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /**
 * Returns the AccountInfo interface for this account.
 * @internal
 */ function $9797579afd7d961c$var$getAccountInfo(accountEntity) {
    const tenantProfiles = accountEntity.tenantProfiles || [];
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountEntity.realm && accountEntity.localAccountId) tenantProfiles.push($9797579afd7d961c$var$buildTenantProfile(accountEntity.homeAccountId, accountEntity.localAccountId, accountEntity.realm, accountEntity.nativeAccountId));
    // Resolve nativeAccountId from the home tenant profile first, fall back to top-level (deprecated) for old cache entries
    const homeTenantProfile = tenantProfiles.find((tp)=>tp.tenantId === accountEntity.realm);
    const nativeAccountId = homeTenantProfile?.nativeAccountId || accountEntity.nativeAccountId;
    return {
        homeAccountId: accountEntity.homeAccountId,
        environment: accountEntity.environment,
        tenantId: accountEntity.realm,
        username: accountEntity.username,
        localAccountId: accountEntity.localAccountId,
        loginHint: accountEntity.loginHint,
        name: accountEntity.name,
        nativeAccountId: nativeAccountId,
        authorityType: accountEntity.authorityType,
        // Deserialize tenant profiles array into a Map
        tenantProfiles: new Map(tenantProfiles.map((tenantProfile)=>{
            return [
                tenantProfile.tenantId,
                tenantProfile
            ];
        })),
        dataBoundary: accountEntity.dataBoundary
    };
}
/**
 * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
 * @param accountDetails
 * @internal
 */ function $9797579afd7d961c$var$createAccountEntity(accountDetails, authority, correlationId, base64Decode) {
    let authorityType;
    if (authority.authorityType === $9797579afd7d961c$var$AuthorityType.Adfs) authorityType = $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_ADFS;
    else if (authority.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC) authorityType = $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_GENERIC;
    else authorityType = $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_MSSTS;
    let clientInfo;
    let dataBoundary;
    if (accountDetails.clientInfo && base64Decode) {
        clientInfo = $9797579afd7d961c$var$buildClientInfo(accountDetails.clientInfo, base64Decode);
        if (clientInfo.xms_tdbr) dataBoundary = clientInfo.xms_tdbr === "EU" ? "EU" : "None";
    }
    const env = accountDetails.environment || authority && authority.getPreferredCache();
    if (!env) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidCacheEnvironment, correlationId);
    /*
     * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
     * In most cases it will contain a single email. This field should not be relied upon if a custom
     * policy is configured to return more than 1 email.
     */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
    const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
    const username = preferredUsername || email || "";
    const loginHint = accountDetails.idTokenClaims?.login_hint;
    const realm = clientInfo?.utid || $9797579afd7d961c$var$getTenantIdFromIdTokenClaims(accountDetails.idTokenClaims) || ""; // non-AAD scenarios can have empty realm
    // How do you account for MSA CID here?
    const localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
    let tenantProfiles;
    if (accountDetails.tenantProfiles) tenantProfiles = accountDetails.tenantProfiles;
    else {
        const tenantProfile = $9797579afd7d961c$var$buildTenantProfile(accountDetails.homeAccountId, localAccountId, realm, accountDetails.nativeAccountId, accountDetails.idTokenClaims);
        tenantProfiles = [
            tenantProfile
        ];
    }
    return {
        homeAccountId: accountDetails.homeAccountId,
        environment: env,
        realm: realm,
        localAccountId: localAccountId,
        username: username,
        authorityType: authorityType,
        loginHint: loginHint,
        clientInfo: accountDetails.clientInfo,
        name: accountDetails.idTokenClaims?.name || "",
        lastModificationTime: undefined,
        lastModificationApp: undefined,
        cloudGraphHostName: accountDetails.cloudGraphHostName,
        msGraphHost: accountDetails.msGraphHost,
        nativeAccountId: accountDetails.nativeAccountId,
        tenantProfiles: tenantProfiles,
        dataBoundary: dataBoundary
    };
}
/**
 * Creates an AccountEntity object from AccountInfo
 * @param accountInfo
 * @param cloudGraphHostName
 * @param msGraphHost
 * @returns
 * @internal
 */ function $9797579afd7d961c$var$createAccountEntityFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
    // Serialize tenant profiles map into an array
    const tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
    // Ensure at least the home tenant profile exists
    if (tenantProfiles.length === 0 && accountInfo.tenantId && accountInfo.localAccountId) tenantProfiles.push($9797579afd7d961c$var$buildTenantProfile(accountInfo.homeAccountId, accountInfo.localAccountId, accountInfo.tenantId, accountInfo.nativeAccountId, accountInfo.idTokenClaims));
    else if (accountInfo.nativeAccountId) {
        // Ensure nativeAccountId is set on the matching tenant profile
        const matchingProfile = tenantProfiles.find((tp)=>tp.tenantId === accountInfo.tenantId);
        if (matchingProfile && !matchingProfile.nativeAccountId) matchingProfile.nativeAccountId = accountInfo.nativeAccountId;
    }
    return {
        authorityType: accountInfo.authorityType || $9797579afd7d961c$var$CACHE_ACCOUNT_TYPE_GENERIC,
        homeAccountId: accountInfo.homeAccountId,
        localAccountId: accountInfo.localAccountId,
        nativeAccountId: accountInfo.nativeAccountId,
        realm: accountInfo.tenantId,
        environment: accountInfo.environment,
        username: accountInfo.username,
        loginHint: accountInfo.loginHint,
        name: accountInfo.name,
        cloudGraphHostName: cloudGraphHostName,
        msGraphHost: msGraphHost,
        tenantProfiles: tenantProfiles,
        dataBoundary: accountInfo.dataBoundary
    };
}
/**
 * Generate HomeAccountId from server response
 * @param serverClientInfo
 * @param authType
 */ function $9797579afd7d961c$var$generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, correlationId, idTokenClaims) {
    // ADFS does not have tid and does not set client_info
    if (authType !== $9797579afd7d961c$var$AuthorityType.Adfs) {
        // for cases where there is clientInfo
        if (serverClientInfo) try {
            const clientInfo = $9797579afd7d961c$var$buildClientInfo(serverClientInfo, cryptoObj.base64Decode);
            if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
        } catch (e) {}
        logger.warning("1ub6wv", correlationId);
    }
    // default to "sub" claim
    return idTokenClaims?.sub || "";
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 * @internal
 */ function $9797579afd7d961c$var$isAccountEntity(entity) {
    if (!entity) return false;
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $9797579afd7d961c$var$unexpectedError = "unexpected_error";
const $9797579afd7d961c$var$postRequestFailed$1 = "post_request_failed";
var $9797579afd7d961c$var$AuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    postRequestFailed: $9797579afd7d961c$var$postRequestFailed$1,
    unexpectedError: $9797579afd7d961c$var$unexpectedError
});
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $9797579afd7d961c$var$ClientConfigurationError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId){
        super(errorCode, correlationId);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $9797579afd7d961c$var$ClientConfigurationError.prototype);
    }
}
function $9797579afd7d961c$var$createClientConfigurationError(errorCode, correlationId) {
    return new $9797579afd7d961c$var$ClientConfigurationError(errorCode, correlationId);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Track only our normalized copies, never caller-owned mutable inputs.
const $9797579afd7d961c$var$normalizedHeaderRecords = new WeakSet();
/**
 * Creates a lowercase-keyed snapshot without changing header values or the input.
 * Reuses snapshots produced by this function to avoid repeated normalization.
 * @internal
 */ function $9797579afd7d961c$var$normalizeResponseHeaders(headers) {
    if ($9797579afd7d961c$var$normalizedHeaderRecords.has(headers)) return headers;
    const normalized = Object.fromEntries(Object.entries(headers).map(([name, value])=>[
            name.toLowerCase(),
            value
        ]));
    $9797579afd7d961c$var$normalizedHeaderRecords.add(normalized);
    return normalized;
}
/**
 * Reads a response header case-insensitively.
 * Normalized snapshots are never scanned, even when a header is missing.
 * @internal
 */ function $9797579afd7d961c$var$getResponseHeader(headers, name) {
    const key = name.toLowerCase();
    if (Object.prototype.hasOwnProperty.call(headers, key)) return headers[key];
    if ($9797579afd7d961c$var$normalizedHeaderRecords.has(headers)) return undefined;
    const headerName = Object.keys(headers).find((header)=>header.toLowerCase() === key);
    return headerName === undefined ? undefined : headers[headerName];
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$redirectUriEmpty = "redirect_uri_empty";
const $9797579afd7d961c$var$claimsRequestParsingError = "claims_request_parsing_error";
const $9797579afd7d961c$var$authorityUriInsecure = "authority_uri_insecure";
const $9797579afd7d961c$var$urlParseError = "url_parse_error";
const $9797579afd7d961c$var$urlEmptyError = "empty_url_error";
const $9797579afd7d961c$var$emptyInputScopesError = "empty_input_scopes_error";
const $9797579afd7d961c$var$invalidClaims = "invalid_claims";
const $9797579afd7d961c$var$tokenRequestEmpty = "token_request_empty";
const $9797579afd7d961c$var$logoutRequestEmpty = "logout_request_empty";
const $9797579afd7d961c$var$invalidCodeChallengeMethod = "invalid_code_challenge_method";
const $9797579afd7d961c$var$pkceParamsMissing = "pkce_params_missing";
const $9797579afd7d961c$var$invalidCloudDiscoveryMetadata = "invalid_cloud_discovery_metadata";
const $9797579afd7d961c$var$invalidAuthorityMetadata = "invalid_authority_metadata";
const $9797579afd7d961c$var$untrustedAuthority = "untrusted_authority";
const $9797579afd7d961c$var$missingSshJwk = "missing_ssh_jwk";
const $9797579afd7d961c$var$missingSshKid = "missing_ssh_kid";
const $9797579afd7d961c$var$unsupportedAuthenticationScheme = "unsupported_authentication_scheme";
const $9797579afd7d961c$var$missingNonceAuthenticationHeader = "missing_nonce_authentication_header";
const $9797579afd7d961c$var$invalidAuthenticationHeader = "invalid_authentication_header";
const $9797579afd7d961c$var$cannotSetOIDCOptions = "cannot_set_OIDCOptions";
const $9797579afd7d961c$var$cannotAllowPlatformBroker = "cannot_allow_platform_broker";
const $9797579afd7d961c$var$authorityMismatch = "authority_mismatch";
const $9797579afd7d961c$var$invalidRequestMethodForEAR = "invalid_request_method_for_EAR";
const $9797579afd7d961c$var$invalidPlatformBrokerConfiguration = "invalid_platform_broker_configuration";
const $9797579afd7d961c$var$issuerValidationFailed = "issuer_validation_failed";
const $9797579afd7d961c$var$invalidResponseMode = "invalid_response_mode";
const $9797579afd7d961c$var$invalidDpopHtm = "invalid_dpop_htm";
const $9797579afd7d961c$var$invalidDpopHtu = "invalid_dpop_htu";
const $9797579afd7d961c$var$invalidDpopNonce = "invalid_dpop_nonce";
const $9797579afd7d961c$var$dpopMissingResourceContext = "dpop_missing_resource_context";
var $9797579afd7d961c$var$ClientConfigurationErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authorityMismatch: $9797579afd7d961c$var$authorityMismatch,
    authorityUriInsecure: $9797579afd7d961c$var$authorityUriInsecure,
    cannotAllowPlatformBroker: $9797579afd7d961c$var$cannotAllowPlatformBroker,
    cannotSetOIDCOptions: $9797579afd7d961c$var$cannotSetOIDCOptions,
    claimsRequestParsingError: $9797579afd7d961c$var$claimsRequestParsingError,
    dpopMissingResourceContext: $9797579afd7d961c$var$dpopMissingResourceContext,
    emptyInputScopesError: $9797579afd7d961c$var$emptyInputScopesError,
    invalidAuthenticationHeader: $9797579afd7d961c$var$invalidAuthenticationHeader,
    invalidAuthorityMetadata: $9797579afd7d961c$var$invalidAuthorityMetadata,
    invalidClaims: $9797579afd7d961c$var$invalidClaims,
    invalidCloudDiscoveryMetadata: $9797579afd7d961c$var$invalidCloudDiscoveryMetadata,
    invalidCodeChallengeMethod: $9797579afd7d961c$var$invalidCodeChallengeMethod,
    invalidDpopHtm: $9797579afd7d961c$var$invalidDpopHtm,
    invalidDpopHtu: $9797579afd7d961c$var$invalidDpopHtu,
    invalidDpopNonce: $9797579afd7d961c$var$invalidDpopNonce,
    invalidPlatformBrokerConfiguration: $9797579afd7d961c$var$invalidPlatformBrokerConfiguration,
    invalidRequestMethodForEAR: $9797579afd7d961c$var$invalidRequestMethodForEAR,
    invalidResponseMode: $9797579afd7d961c$var$invalidResponseMode,
    issuerValidationFailed: $9797579afd7d961c$var$issuerValidationFailed,
    logoutRequestEmpty: $9797579afd7d961c$var$logoutRequestEmpty,
    missingNonceAuthenticationHeader: $9797579afd7d961c$var$missingNonceAuthenticationHeader,
    missingSshJwk: $9797579afd7d961c$var$missingSshJwk,
    missingSshKid: $9797579afd7d961c$var$missingSshKid,
    pkceParamsMissing: $9797579afd7d961c$var$pkceParamsMissing,
    redirectUriEmpty: $9797579afd7d961c$var$redirectUriEmpty,
    tokenRequestEmpty: $9797579afd7d961c$var$tokenRequestEmpty,
    unsupportedAuthenticationScheme: $9797579afd7d961c$var$unsupportedAuthenticationScheme,
    untrustedAuthority: $9797579afd7d961c$var$untrustedAuthority,
    urlEmptyError: $9797579afd7d961c$var$urlEmptyError,
    urlParseError: $9797579afd7d961c$var$urlParseError
});
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This is a helper class that parses supported HTTP response authentication headers to extract and return
 * header challenge values that can be used outside the basic authorization flows.
 */ class $9797579afd7d961c$var$AuthenticationHeaderParser {
    /** Captures a case-insensitive snapshot of the response headers. */ constructor(headers){
        this.headers = $9797579afd7d961c$var$normalizeResponseHeaders(headers);
    }
    /**
     * This method parses the SHR nonce value out of either the Authentication-Info or WWW-Authenticate authentication headers.
     * @returns
     */ getShrNonce() {
        // Attempt to parse nonce from Authentiacation-Info
        const authenticationInfo = $9797579afd7d961c$var$getResponseHeader(this.headers, $9797579afd7d961c$var$HeaderNames.AuthenticationInfo);
        if (authenticationInfo) {
            const authenticationInfoChallenges = this.parseChallenges(authenticationInfo);
            if (authenticationInfoChallenges.nextnonce) return authenticationInfoChallenges.nextnonce;
            throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidAuthenticationHeader, "");
        }
        // Attempt to parse nonce from WWW-Authenticate
        const wwwAuthenticate = $9797579afd7d961c$var$getResponseHeader(this.headers, $9797579afd7d961c$var$HeaderNames.WWWAuthenticate);
        if (wwwAuthenticate) {
            const wwwAuthenticateChallenges = this.parseChallenges(wwwAuthenticate);
            if (wwwAuthenticateChallenges.nonce) return wwwAuthenticateChallenges.nonce;
            throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidAuthenticationHeader, "");
        }
        // If neither header is present, throw missing headers error
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$missingNonceAuthenticationHeader, "");
    }
    /**
     * Parses an HTTP header's challenge set into a key/value map.
     * @param header
     * @returns
     */ parseChallenges(header) {
        const schemeSeparator = header.indexOf(" ");
        const challenges = header.substr(schemeSeparator + 1).split(",");
        const challengeMap = {};
        challenges.forEach((challenge)=>{
            const [key, value] = challenge.split("=");
            // Remove escaped quotation marks (', ") from challenge string to keep only the challenge value
            challengeMap[key] = unescape(value.replace(/['"]+/g, ""));
        });
        return challengeMap;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$isOpenIdConfigResponse(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $9797579afd7d961c$var$StringUtils {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $9797579afd7d961c$var$UrlString {
    get urlString() {
        return this._urlString;
    }
    constructor(url, correlationId){
        this._urlString = url;
        this.correlationId = correlationId;
        if (!this._urlString) // Throws error if url is empty
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlEmptyError, correlationId);
        if (!url.includes("#")) this._urlString = $9797579afd7d961c$var$UrlString.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ($9797579afd7d961c$var$StringUtils.endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ($9797579afd7d961c$var$StringUtils.endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!$9797579afd7d961c$var$StringUtils.endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, this.correlationId);
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, this.correlationId);
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$authorityUriInsecure, this.correlationId);
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $9797579afd7d961c$var$UrlString.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === $9797579afd7d961c$var$AADAuthority.COMMON || pathArray[0] === $9797579afd7d961c$var$AADAuthority.ORGANIZATIONS)) pathArray[0] = tenantId;
        return $9797579afd7d961c$var$UrlString.constructAuthorityUriFromObject(urlObject, this.correlationId);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, this.correlationId);
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url, correlationId) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, correlationId);
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl, correlationId) {
        if (relativeUrl[0] === $9797579afd7d961c$var$FORWARD_SLASH) {
            const url = new $9797579afd7d961c$var$UrlString(baseUrl, correlationId);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject, correlationId) {
        return new $9797579afd7d961c$var$UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"), correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Build endpoint metadata dynamically to avoid string duplication
const $9797579afd7d961c$var$endpointHosts = [
    {
        host: "login.microsoftonline.com"
    },
    {
        host: "login.partner.microsoftonline.cn"
    },
    {
        host: "login.microsoftonline.us"
    },
    {
        host: "login.sovcloud-identity.fr"
    },
    {
        host: "login.sovcloud-identity.de"
    },
    {
        host: "login.sovcloud-identity.sg"
    }
];
function $9797579afd7d961c$var$buildOpenIdConfig(host, issuerHost) {
    return {
        token_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/token`,
        jwks_uri: `https://${host}/{tenantid}/discovery/v2.0/keys`,
        issuer: `https://${issuerHost}/{tenantid}/v2.0`,
        authorization_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/authorize`,
        end_session_endpoint: `https://${host}/{tenantid}/oauth2/v2.0/logout`
    };
}
const $9797579afd7d961c$var$dynamicEndpointMetadata = $9797579afd7d961c$var$endpointHosts.reduce((acc, { host: host, issuerHost: issuerHost })=>{
    acc[host] = $9797579afd7d961c$var$buildOpenIdConfig(host, issuerHost || host);
    return acc;
}, {});
const $9797579afd7d961c$var$rawMetdataJSON = {
    endpointMetadata: $9797579afd7d961c$var$dynamicEndpointMetadata,
    instanceDiscoveryMetadata: {
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.fr",
                preferred_cache: "login.sovcloud-identity.fr",
                aliases: [
                    "login.sovcloud-identity.fr"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.de",
                preferred_cache: "login.sovcloud-identity.de",
                aliases: [
                    "login.sovcloud-identity.de"
                ]
            },
            {
                preferred_network: "login.sovcloud-identity.sg",
                preferred_cache: "login.sovcloud-identity.sg",
                aliases: [
                    "login.sovcloud-identity.sg"
                ]
            }
        ]
    }
};
const $9797579afd7d961c$var$EndpointMetadata = $9797579afd7d961c$var$rawMetdataJSON.endpointMetadata;
const $9797579afd7d961c$var$InstanceDiscoveryMetadata = $9797579afd7d961c$var$rawMetdataJSON.instanceDiscoveryMetadata;
const $9797579afd7d961c$var$InstanceDiscoveryMetadataAliases = new Set();
$9797579afd7d961c$var$InstanceDiscoveryMetadata.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $9797579afd7d961c$var$InstanceDiscoveryMetadataAliases.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $9797579afd7d961c$var$getAliasesFromStaticSources(staticAuthorityOptions, logger, correlationId) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new $9797579afd7d961c$var$UrlString(canonicalAuthority, correlationId).getUrlComponents().HostNameAndPort;
        staticAliases = $9797579afd7d961c$var$getAliasesFromMetadata(logger, correlationId, authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, $9797579afd7d961c$var$AuthorityMetadataSource.CONFIG) || $9797579afd7d961c$var$getAliasesFromMetadata(logger, correlationId, authorityHost, $9797579afd7d961c$var$InstanceDiscoveryMetadata.metadata, $9797579afd7d961c$var$AuthorityMetadataSource.HARDCODED_VALUES) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $9797579afd7d961c$var$getAliasesFromMetadata(logger, correlationId, authorityHost, cloudDiscoveryMetadata, source) {
    logger.trace(`1bmquz ${source}`, correlationId);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $9797579afd7d961c$var$getCloudDiscoveryMetadataFromNetworkResponse(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger.trace(`1fotbt ${source}`, correlationId);
            return metadata.aliases;
        } else logger.trace(`14avvj ${source}`, correlationId);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $9797579afd7d961c$var$getCloudDiscoveryMetadataFromHardcodedValues(authorityHost) {
    const metadata = $9797579afd7d961c$var$getCloudDiscoveryMetadataFromNetworkResponse($9797579afd7d961c$var$InstanceDiscoveryMetadata.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $9797579afd7d961c$var$getCloudDiscoveryMetadataFromNetworkResponse(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$AzureCloudInstance = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$isCloudInstanceDiscoveryResponse(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$isCloudInstanceDiscoveryErrorResponse(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Time spent sending/waiting for the response of a request to the token endpoint
 */ const $9797579afd7d961c$var$NetworkClientSendPostRequestAsync = "networkClientSendPostRequestAsync";
const $9797579afd7d961c$var$RefreshTokenClientExecutePostToTokenEndpoint = "refreshTokenClientExecutePostToTokenEndpoint";
const $9797579afd7d961c$var$AuthorizationCodeClientExecutePostToTokenEndpoint = "authorizationCodeClientExecutePostToTokenEndpoint";
/**
 * Time spent on the network for refresh token acquisition
 */ const $9797579afd7d961c$var$RefreshTokenClientExecuteTokenRequest = "refreshTokenClientExecuteTokenRequest";
/**
 * Time taken for acquiring refresh token , records RT size
 */ const $9797579afd7d961c$var$RefreshTokenClientAcquireToken = "refreshTokenClientAcquireToken";
/**
 * Time taken for acquiring cached refresh token
 */ const $9797579afd7d961c$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken = "refreshTokenClientAcquireTokenWithCachedRefreshToken";
/**
 * Helper function to create token request body in RefreshTokenClient (msal-common).
 */ const $9797579afd7d961c$var$RefreshTokenClientCreateTokenRequestBody = "refreshTokenClientCreateTokenRequestBody";
const $9797579afd7d961c$var$SilentFlowClientGenerateResultFromCacheRecord = "silentFlowClientGenerateResultFromCacheRecord";
/**
 * getAuthCodeUrl API (msal-browser and msal-node).
 */ const $9797579afd7d961c$var$GetAuthCodeUrl = "getAuthCodeUrl";
/**
 * Functions from InteractionHandler (msal-browser)
 */ const $9797579afd7d961c$var$HandleCodeResponseFromServer = "handleCodeResponseFromServer";
/**
 * APIs in Authorization Code Client (msal-common)
 */ const $9797579afd7d961c$var$AuthClientExecuteTokenRequest = "authClientExecuteTokenRequest";
const $9797579afd7d961c$var$AuthClientCreateTokenRequestBody = "authClientCreateTokenRequestBody";
const $9797579afd7d961c$var$UpdateTokenEndpointAuthority = "updateTokenEndpointAuthority";
/**
 * Generate functions in PopTokenGenerator (msal-common)
 */ const $9797579afd7d961c$var$PopTokenGenerateCnf = "popTokenGenerateCnf";
/**
 * handleServerTokenResponse API in ResponseHandler (msal-common)
 */ const $9797579afd7d961c$var$HandleServerTokenResponse = "handleServerTokenResponse";
/**
 * Authority functions
 */ const $9797579afd7d961c$var$AuthorityResolveEndpointsAsync = "authorityResolveEndpointsAsync";
const $9797579afd7d961c$var$AuthorityGetCloudDiscoveryMetadataFromNetwork = "authorityGetCloudDiscoveryMetadataFromNetwork";
const $9797579afd7d961c$var$AuthorityUpdateCloudDiscoveryMetadata = "authorityUpdateCloudDiscoveryMetadata";
const $9797579afd7d961c$var$AuthorityGetEndpointMetadataFromNetwork = "authorityGetEndpointMetadataFromNetwork";
const $9797579afd7d961c$var$AuthorityUpdateEndpointMetadata = "authorityUpdateEndpointMetadata";
const $9797579afd7d961c$var$AuthorityUpdateMetadataWithRegionalInformation = "authorityUpdateMetadataWithRegionalInformation";
/**
 * Region Discovery functions
 */ const $9797579afd7d961c$var$RegionDiscoveryDetectRegion = "regionDiscoveryDetectRegion";
const $9797579afd7d961c$var$RegionDiscoveryGetRegionFromIMDS = "regionDiscoveryGetRegionFromIMDS";
const $9797579afd7d961c$var$RegionDiscoveryGetCurrentVersion = "regionDiscoveryGetCurrentVersion";
/**
 * Cache operations
 */ const $9797579afd7d961c$var$CacheManagerGetRefreshToken = "cacheManagerGetRefreshToken";
const $9797579afd7d961c$var$SetUserData = "setUserData";
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9797579afd7d961c$var$invoke = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        try {
            const result = callback(...args);
            inProgressEvent.end({
                success: true
            });
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            return result;
        } catch (e) {
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9797579afd7d961c$var$invokeAsync = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`1plfzx ${eventName}`, correlationId);
        const inProgressEvent = telemetryClient.startMeasurement(eventName, correlationId);
        if (correlationId) // Track number of times this API is called in a single request
        telemetryClient.incrementFields({
            [`ext.${eventName}CallCount`]: 1
        }, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`1g8n6a ${eventName}`, correlationId);
            inProgressEvent.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`0cfd8i ${eventName}`, correlationId);
            try {
                logger.trace(JSON.stringify(e), correlationId);
            } catch (e) {
                logger.trace("00dty7", correlationId);
            }
            inProgressEvent.end({
                success: false
            }, e);
            throw e;
        });
    };
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$RegionDiscovery {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $9797579afd7d961c$var$RegionDiscovery.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await $9797579afd7d961c$var$invokeAsync(this.getRegionFromIMDS.bind(this), $9797579afd7d961c$var$RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)($9797579afd7d961c$var$IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === $9797579afd7d961c$var$HTTP_SUCCESS) {
                    autodetectedRegionName = localIMDSVersionResponse.body?.location;
                    if (autodetectedRegionName) regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === $9797579afd7d961c$var$HTTP_BAD_REQUEST) {
                    const currentIMDSVersion = await $9797579afd7d961c$var$invokeAsync(this.getCurrentVersion.bind(this), $9797579afd7d961c$var$RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await $9797579afd7d961c$var$invokeAsync(this.getRegionFromIMDS.bind(this), $9797579afd7d961c$var$RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === $9797579afd7d961c$var$HTTP_SUCCESS) {
                        autodetectedRegionName = currentIMDSVersionResponse.body?.location;
                        if (autodetectedRegionName) regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = $9797579afd7d961c$var$RegionDiscoverySources.FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param version
     * @param options
     * @returns Promise<NetworkResponse<ImdsComputeResponse>>
     */ async getRegionFromIMDS(version, options) {
        return this.networkInterface.sendGetRequestAsync(`${$9797579afd7d961c$var$IMDS_ENDPOINT}?api-version=${version}`, options, $9797579afd7d961c$var$IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${$9797579afd7d961c$var$IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === $9797579afd7d961c$var$HTTP_BAD_REQUEST && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$9797579afd7d961c$var$RegionDiscovery.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $9797579afd7d961c$var$nowSeconds() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * Converts JS Date object to seconds
 * @param date Date
 */ function $9797579afd7d961c$var$toSecondsFromDate(date) {
    // Convert date to seconds
    return date.getTime() / 1000;
}
/**
 * Convert seconds to JS Date object. Seconds can be in a number or string format or undefined (will still return a date).
 * @param seconds
 */ function $9797579afd7d961c$var$toDateFromSeconds(seconds) {
    if (seconds) return new Date(Number(seconds) * 1000);
    return new Date();
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $9797579afd7d961c$var$isTokenExpired(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $9797579afd7d961c$var$nowSeconds() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * Checks if a cache entry is expired based on the last updated time and cache retention days.
 * @param lastUpdatedAt
 * @param cacheRetentionDays
 * @returns
 */ function $9797579afd7d961c$var$isCacheExpired(lastUpdatedAt, cacheRetentionDays) {
    const cacheExpirationTimestamp = Number(lastUpdatedAt) + cacheRetentionDays * 86400000;
    return Date.now() > cacheExpirationTimestamp;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $9797579afd7d961c$var$wasClockTurnedBack(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $9797579afd7d961c$var$nowSeconds();
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9797579afd7d961c$var$createIdTokenEntity(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: $9797579afd7d961c$var$CredentialType.ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId,
        lastUpdatedAt: Date.now().toString()
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $9797579afd7d961c$var$createAccessTokenEntity(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, correlationId, refreshOn, tokenType, userAssertionHash, keyId, additionalCacheKeyComponents) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: $9797579afd7d961c$var$nowSeconds().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    const normalizedTokenType = atEntity.tokenType?.toLowerCase();
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== $9797579afd7d961c$var$AuthenticationScheme$1.BEARER.toLowerCase()) {
        atEntity.credentialType = $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(normalizedTokenType){
            case $9797579afd7d961c$var$AuthenticationScheme$1.POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = $9797579afd7d961c$var$extractTokenClaims(accessToken, base64Decode, correlationId);
                if (!tokenClaims?.cnf?.kid) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenClaimsCnfRequiredForSignedJwt, correlationId);
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case "dpop":
                if (!keyId) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$keyIdMissing, correlationId);
                atEntity.keyId = keyId;
                break;
            case $9797579afd7d961c$var$AuthenticationScheme$1.SSH:
                atEntity.keyId = keyId;
        }
    }
    /* Additional cache key components for cache isolation (e.g., FMI path) */ if (additionalCacheKeyComponents && Object.keys(additionalCacheKeyComponents).length > 0) atEntity.additionalCacheKeyComponents = additionalCacheKeyComponents;
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $9797579afd7d961c$var$createRefreshTokenEntity(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: $9797579afd7d961c$var$CredentialType.REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken,
        lastUpdatedAt: Date.now().toString()
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $9797579afd7d961c$var$isCredentialEntity(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9797579afd7d961c$var$isAccessTokenEntity(entity) {
    if (!entity) return false;
    return $9797579afd7d961c$var$isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN || entity["credentialType"] === $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9797579afd7d961c$var$isIdTokenEntity(entity) {
    if (!entity) return false;
    return $9797579afd7d961c$var$isCredentialEntity(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === $9797579afd7d961c$var$CredentialType.ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9797579afd7d961c$var$isRefreshTokenEntity(entity) {
    if (!entity) return false;
    return $9797579afd7d961c$var$isCredentialEntity(entity) && entity["credentialType"] === $9797579afd7d961c$var$CredentialType.REFRESH_TOKEN;
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $9797579afd7d961c$var$isServerTelemetryEntity(key, entity) {
    const validateKey = key.indexOf($9797579afd7d961c$var$SERVER_TELEM_CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $9797579afd7d961c$var$isThrottlingEntity(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf($9797579afd7d961c$var$THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $9797579afd7d961c$var$generateAppMetadataKey({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        $9797579afd7d961c$var$APP_METADATA,
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join($9797579afd7d961c$var$CACHE_KEY_SEPARATOR$1).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9797579afd7d961c$var$isAppMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf($9797579afd7d961c$var$APP_METADATA) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $9797579afd7d961c$var$isAuthorityMetadataEntity(key, entity) {
    if (!entity) return false;
    return key.indexOf($9797579afd7d961c$var$AUTHORITY_METADATA_CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $9797579afd7d961c$var$generateAuthorityMetadataExpiresAt() {
    return $9797579afd7d961c$var$nowSeconds() + $9797579afd7d961c$var$AUTHORITY_METADATA_REFRESH_TIME_SECONDS;
}
/** @internal */ function $9797579afd7d961c$var$updateAuthorityEndpointMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
/** @internal */ function $9797579afd7d961c$var$updateCloudDiscoveryMetadata(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 * @internal
 */ function $9797579afd7d961c$var$isAuthorityMetadataExpired(metadata) {
    return metadata.expiresAt <= $9797579afd7d961c$var$nowSeconds();
}
/**
 * Serialize attribute tokens synchronously (sort and join).
 * This is a sync-only operation for use at request construction time.
 * @param attributeTokens - array of tokens
 * @returns serialized partition string or undefined if no tokens
 */ function $9797579afd7d961c$var$serializeAttributeTokens(attributeTokens) {
    if (!attributeTokens || attributeTokens.length === 0) return undefined;
    // Serialize: sort and join tokens
    return [
        ...attributeTokens
    ].sort().join(" ");
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $9797579afd7d961c$var$Authority {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new $9797579afd7d961c$var$RegionDiscovery(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType:type}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith($9797579afd7d961c$var$CIAM_AUTH_URL)) return $9797579afd7d961c$var$AuthorityType.Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case $9797579afd7d961c$var$ADFS:
                return $9797579afd7d961c$var$AuthorityType.Adfs;
        }
        return $9797579afd7d961c$var$AuthorityType.Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new $9797579afd7d961c$var$UrlString(url, this.correlationId);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endSessionEndpointNotSupported, this.correlationId);
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$9797579afd7d961c$var$Authority.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === $9797579afd7d961c$var$AuthorityType.Default && this.protocolMode !== $9797579afd7d961c$var$ProtocolMode.OIDC;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new $9797579afd7d961c$var$UrlString(this.metadata.canonical_authority, this.correlationId);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new $9797579afd7d961c$var$UrlString(this.metadata.authorization_endpoint, this.correlationId).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`1q3g2x ${cachedPart} ${tenantId}`, this.correlationId);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === $9797579afd7d961c$var$AuthorityType.Adfs || this.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await $9797579afd7d961c$var$invokeAsync(this.updateCloudDiscoveryMetadata.bind(this), $9797579afd7d961c$var$AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await $9797579afd7d961c$var$invokeAsync(this.updateEndpointMetadata.bind(this), $9797579afd7d961c$var$AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwise returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort, this.correlationId);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: $9797579afd7d961c$var$generateAuthorityMetadataExpiresAt(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== $9797579afd7d961c$var$AuthorityMetadataSource.CACHE && endpointMetadataResult?.source !== $9797579afd7d961c$var$AuthorityMetadataSource.CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = $9797579afd7d961c$var$generateAuthorityMetadataExpiresAt();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache, this.correlationId);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity, this.correlationId);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === $9797579afd7d961c$var$AuthorityMetadataSource.HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await $9797579afd7d961c$var$invokeAsync(this.updateMetadataWithRegionalInformation.bind(this), $9797579afd7d961c$var$AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        $9797579afd7d961c$var$updateAuthorityEndpointMetadata(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await $9797579afd7d961c$var$invokeAsync(this.getEndpointMetadataFromNetwork.bind(this), $9797579afd7d961c$var$AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // Validate the issuer returned by the OIDC discovery document.
            this.validateIssuer(metadata.issuer);
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await $9797579afd7d961c$var$invokeAsync(this.updateMetadataWithRegionalInformation.bind(this), $9797579afd7d961c$var$AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            $9797579afd7d961c$var$updateAuthorityEndpointMetadata(metadataEntity, metadata, true);
            return $9797579afd7d961c$var$AuthorityMetadataSource.NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$openIdConfigError, this.defaultOpenIdConfigurationEndpoint, this.correlationId);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1fi0kc", this.correlationId);
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("06t0uj", this.correlationId);
            $9797579afd7d961c$var$updateAuthorityEndpointMetadata(metadataEntity, configMetadata, false);
            return {
                source: $9797579afd7d961c$var$AuthorityMetadataSource.CONFIG
            };
        }
        this.logger.verbose("151k0p", this.correlationId);
        const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
        if (hardcodedMetadata) {
            $9797579afd7d961c$var$updateAuthorityEndpointMetadata(metadataEntity, hardcodedMetadata, false);
            return {
                source: $9797579afd7d961c$var$AuthorityMetadataSource.HARDCODED_VALUES,
                metadata: hardcodedMetadata
            };
        } else this.logger.verbose("1imop5", this.correlationId);
        // Check cached metadata entity expiration status
        const metadataEntityExpired = $9797579afd7d961c$var$isAuthorityMetadataExpired(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("16uq31", "");
            return {
                source: $9797579afd7d961c$var$AuthorityMetadataSource.CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new $9797579afd7d961c$var$UrlString(metadataEntity.canonical_authority, this.correlationId);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidAuthorityMetadata, this.correlationId);
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`1y65x6 ${openIdConfigurationEndpoint}`, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = $9797579afd7d961c$var$isOpenIdConfigResponse(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose("1koyv8", this.correlationId);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`0a9wik ${e}`, this.correlationId);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in $9797579afd7d961c$var$EndpointMetadata) return $9797579afd7d961c$var$EndpointMetadata[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== $9797579afd7d961c$var$AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = $9797579afd7d961c$var$RegionDiscoveryOutcomes.CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $9797579afd7d961c$var$Authority.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion, this.correlationId);
            }
            const autodetectedRegionName = await $9797579afd7d961c$var$invokeAsync(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), $9797579afd7d961c$var$RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = $9797579afd7d961c$var$RegionDiscoveryOutcomes.AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $9797579afd7d961c$var$Authority.replaceWithRegionalInformation(metadata, autodetectedRegionName, this.correlationId);
            }
            this.regionDiscoveryMetadata.region_outcome = $9797579afd7d961c$var$RegionDiscoveryOutcomes.AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await $9797579afd7d961c$var$invokeAsync(this.getCloudDiscoveryMetadataFromNetwork.bind(this), $9797579afd7d961c$var$AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            $9797579afd7d961c$var$updateCloudDiscoveryMetadata(metadataEntity, metadata, true);
            return $9797579afd7d961c$var$AuthorityMetadataSource.NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$untrustedAuthority, this.correlationId);
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("1tpqlr", this.correlationId);
        this.logger.verbosePii(`1fy7uz ${this.authorityOptions.knownAuthorities || $9797579afd7d961c$var$NOT_APPLICABLE}`, this.correlationId);
        this.logger.verbosePii(`08zabj ${this.authorityOptions.authorityMetadata || $9797579afd7d961c$var$NOT_APPLICABLE}`, this.correlationId);
        this.logger.verbosePii(`1o1kv3 ${metadataEntity.canonical_authority || $9797579afd7d961c$var$NOT_APPLICABLE}`, this.correlationId);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("1nakio", this.correlationId);
            $9797579afd7d961c$var$updateCloudDiscoveryMetadata(metadataEntity, metadata, false);
            return $9797579afd7d961c$var$AuthorityMetadataSource.CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("1x74aj", this.correlationId);
        const hardcodedMetadata = $9797579afd7d961c$var$getCloudDiscoveryMetadataFromHardcodedValues(this.hostnameAndPort);
        if (hardcodedMetadata) {
            this.logger.verbose("0by47c", this.correlationId);
            $9797579afd7d961c$var$updateCloudDiscoveryMetadata(metadataEntity, hardcodedMetadata, false);
            return $9797579afd7d961c$var$AuthorityMetadataSource.HARDCODED_VALUES;
        }
        this.logger.verbose("0r2fzy", this.correlationId);
        const metadataEntityExpired = $9797579afd7d961c$var$isAuthorityMetadataExpired(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("1uffgh", "");
            // No need to update
            return $9797579afd7d961c$var$AuthorityMetadataSource.CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("0uoibc", "");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === $9797579afd7d961c$var$AuthorityType.Ciam) {
            this.logger.verbose("04y84h", this.correlationId);
            return $9797579afd7d961c$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("0gszr3", this.correlationId);
            try {
                this.logger.verbose("1iifkx", this.correlationId);
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = $9797579afd7d961c$var$getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("0q67e3", "");
                if (metadata) {
                    this.logger.verbose("0hzfao", this.correlationId);
                    return metadata;
                } else this.logger.verbose("1ajz3u", this.correlationId);
            } catch (e) {
                this.logger.verbose("1wq5tu", this.correlationId);
                throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidCloudDiscoveryMetadata, this.correlationId);
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities(this.hostnameAndPort)) {
            this.logger.verbose("0mt9al", this.correlationId);
            return $9797579afd7d961c$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        const instanceDiscoveryEndpoint = `${$9797579afd7d961c$var$AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ($9797579afd7d961c$var$isCloudInstanceDiscoveryResponse(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`1vglyt ${typedResponseBody.tenant_discovery_endpoint}`, this.correlationId);
            } else if ($9797579afd7d961c$var$isCloudInstanceDiscoveryErrorResponse(response.body)) {
                this.logger.warning(`062uto ${response.status}`, this.correlationId);
                typedResponseBody = response.body;
                if (typedResponseBody.error === $9797579afd7d961c$var$INVALID_INSTANCE) {
                    this.logger.error("1x90tm", this.correlationId);
                    return null;
                }
                this.logger.warning(`0wchdm ${typedResponseBody.error}`, this.correlationId);
                this.logger.warning(`1s5mpv ${typedResponseBody.error_description}`, this.correlationId);
                this.logger.warning("1yhqpw", this.correlationId);
                metadata = [];
            } else {
                this.logger.error("0768g0", this.correlationId);
                return null;
            }
            this.logger.verbose("1lrobr", this.correlationId);
            match = $9797579afd7d961c$var$getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof $9797579afd7d961c$var$AuthError) this.logger.error(`0vwhc7 ${error.errorCode} ${error.errorMessage}`, this.correlationId);
            else {
                const typedError = error;
                this.logger.error(`0s2z41 ${typedError.name} ${typedError.message}`, this.correlationId);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("0jp28q", this.correlationId);
            this.logger.verbose("130sd8", this.correlationId);
            match = $9797579afd7d961c$var$Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if a host is included in the knownAuthorities config option.
     */ isInKnownAuthorities(host) {
        const normalizedHost = host.toLowerCase();
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && $9797579afd7d961c$var$UrlString.getDomainFromUrl(authority, this.correlationId).toLowerCase() === normalizedHost;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== $9797579afd7d961c$var$AzureCloudInstance.None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : $9797579afd7d961c$var$DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return $9797579afd7d961c$var$DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, this.correlationId);
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return $9797579afd7d961c$var$InstanceDiscoveryMetadataAliases.has(host);
    }
    /**
     * Validates the `issuer` returned by an OIDC discovery document against
     * this authority, per
     * https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationValidation
     *
     * The issuer is accepted when ANY of the following holds:
     *  1. The issuer scheme + host + port match the authority's (path may
     *     differ). Applies to all authorities.
     *  2. The authority is a Microsoft cloud authority (public, sovereign,
     *     or CIAM), the issuer is HTTPS, and the issuer host is in the known
     *     Microsoft authority host set.
     *  3. Same as (2), but the issuer host is a single-label regional variant
     *     of a known Microsoft host (e.g. `westus.login.microsoftonline.com`).
     *  4. Same as (2), but the issuer host matches the CIAM tenant pattern
     *     `{tenant}.ciamlogin.com` with an optional `/{tenant}[.onmicrosoft.com][/v2.0]`
     *     path.
     *  5. The issuer host is HTTPS and is explicitly listed in the
     *     developer-configured `knownAuthorities`. This covers scenarios where
     *     the OIDC discovery document returns an issuer host that differs from
     *     the authority (e.g., a GUID-based issuer for a name-based CIAM authority).
     *
     * @param issuer The `issuer` value returned in the OIDC discovery document.
     * @throws ClientConfigurationError("issuer_validation_failed") on failure.
     */ validateIssuer(issuer) {
        if (!issuer) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$issuerValidationFailed, this.correlationId);
        // Parse with the WHATWG URL API. URL normalizes scheme + host to lowercase per RFC 3986.
        let issuerUrl;
        try {
            issuerUrl = new URL(issuer);
        } catch  {
            throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$issuerValidationFailed, this.correlationId);
        }
        const issuerScheme = issuerUrl.protocol;
        const issuerHost = issuerUrl.host;
        const authorityScheme = (this.canonicalAuthorityUrlComponents.Protocol || "").toLowerCase();
        const authorityHost = (this.canonicalAuthorityUrlComponents.HostNameAndPort || "").toLowerCase();
        // Rule 1: Same scheme and host
        const matchesAuthorityOrigin = this.matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost);
        // Rule 2: The issuer host is a well-known Microsoft authority host (HTTPS only)
        const matchesKnownMicrosoftHost = issuerScheme === "https:" && this.isAliasOfKnownMicrosoftAuthority(issuerHost);
        /*
         * Rule 3: The issuer host is a regional variant ({region}.{host}) of a well-known host
         * (HTTPS only). E.g. westus2.login.microsoft.com
         */ const matchesRegionalMicrosoftHost = issuerScheme === "https:" && this.matchesRegionalMicrosoftHost(issuerHost);
        /*
         * Rule 4: CIAM-specific validation. In a CIAM scenario the issuer is expected to
         * have "{tenant}.ciamlogin.com" as the host, even when using a custom domain.
         */ const matchesCiamTenantPattern = this.matchesCiamTenantPattern(issuerUrl, authorityHost, this.canonicalAuthorityUrlComponents.PathSegments);
        /*
         * Rule 5: The issuer host is explicitly listed in the developer-configured
         * knownAuthorities. This covers scenarios where the OIDC discovery document
         * returns an issuer with a different host than the authority
         * (e.g., a GUID-based issuer for a name-based authority).
         */ const matchesKnownAuthority = issuerScheme === "https:" && this.isInKnownAuthorities(issuerHost);
        // Each rule is an independent boolean; the issuer is valid if ANY rule matches.
        if (matchesAuthorityOrigin || matchesKnownMicrosoftHost || matchesRegionalMicrosoftHost || matchesCiamTenantPattern || matchesKnownAuthority) return;
        // issuer validation fails if none of the above rules are satisfied
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$issuerValidationFailed, this.correlationId);
    }
    /**
     * Rule 1: The issuer scheme + host (and port) match the authority's. Path
     * may differ. Applies to all authorities.
     */ matchesAuthorityOrigin(issuerScheme, issuerHost, authorityScheme, authorityHost) {
        return issuerScheme === authorityScheme && issuerHost === authorityHost;
    }
    /**
     * Rule 3: The issuer host is a regional variant
     * (`{region}.{host}`) of a known Microsoft authority host.
     * E.g. `westus2.login.microsoft.com`.
     */ matchesRegionalMicrosoftHost(issuerHost) {
        const firstDot = issuerHost.indexOf(".");
        if (firstDot > 0 && firstDot < issuerHost.length - 1) {
            const hostWithoutRegion = issuerHost.substring(firstDot + 1);
            return this.isAliasOfKnownMicrosoftAuthority(hostWithoutRegion);
        }
        return false;
    }
    /**
     * Rule 4: The issuer matches one of the well-known CIAM tenant patterns
     * (`https://{tenant}.ciamlogin.com[/{tenant}[.onmicrosoft.com][/v2.0]]`).
     *
     * The bare tenant name is extracted from the authority's first path segment
     * when available (stripping the `.onmicrosoft.com` suffix that
     * `transformCIAMAuthority` adds), or otherwise from the leftmost label of
     * the authority host (to support CIAM custom domain scenarios).
     *
     * Both `/{tenant}` and `/{tenant}.onmicrosoft.com` path forms are accepted
     * because the OIDC issuer may use either form depending on the authority URL
     * that was used to trigger discovery.
     */ matchesCiamTenantPattern(issuerUrl, authorityHost, authorityPathSegments) {
        /*
         * authorityPathSegments[0] is the first path segment of the *authority
         * URL* after transformCIAMAuthority runs (e.g. "contoso.onmicrosoft.com").
         * Additional CIAM issuer path segments such as "/v2.0" are part of the
         * issuer string, not the authority URL's PathSegments.
         */ const pathSegment = authorityPathSegments[0];
        /*
         * Extract the bare tenant name: strip the .onmicrosoft.com suffix when
         * present (introduced by transformCIAMAuthority), or fall back to the
         * first label of the authority hostname for non-transformed/custom-domain
         * CIAM authorities.
         */ const tenantName = pathSegment ? pathSegment.endsWith($9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX) ? pathSegment.slice(0, -$9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX.length) : pathSegment : authorityHost.split(".")[0];
        if (!tenantName) return false;
        const ciamBaseURL = `https://${tenantName}${$9797579afd7d961c$var$CIAM_AUTH_URL}`;
        const validCiamPatterns = [
            ciamBaseURL,
            `${ciamBaseURL}/${tenantName}`,
            `${ciamBaseURL}/${tenantName}/v2.0`,
            `${ciamBaseURL}/${tenantName}${$9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX}`,
            `${ciamBaseURL}/${tenantName}${$9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX}/v2.0`
        ];
        /*
         * Compose the canonical issuer string from URL components and strip any
         * trailing slashes from the path so it can be compared to the pattern set.
         */ const issuerPath = issuerUrl.pathname.replace(/\/+$/, "");
        const normalizedIssuer = `${issuerUrl.protocol}//${issuerUrl.host}${issuerPath}`;
        return validCiamPatterns.some((pattern)=>pattern === normalizedIssuer);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return $9797579afd7d961c$var$KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, correlationId, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new $9797579afd7d961c$var$UrlString(host, correlationId);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${$9797579afd7d961c$var$REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = $9797579afd7d961c$var$UrlString.constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }, correlationId).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion, correlationId) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $9797579afd7d961c$var$Authority.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion, correlationId);
        regionalMetadata.token_endpoint = $9797579afd7d961c$var$Authority.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion, correlationId);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $9797579afd7d961c$var$Authority.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion, correlationId);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority, correlationId) {
        let ciamAuthority = authority;
        const authorityUrl = new $9797579afd7d961c$var$UrlString(authority, correlationId);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith($9797579afd7d961c$var$CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${$9797579afd7d961c$var$AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$9797579afd7d961c$var$Authority.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    $9797579afd7d961c$var$AADAuthority.COMMON,
    $9797579afd7d961c$var$AADAuthority.CONSUMERS,
    $9797579afd7d961c$var$AADAuthority.ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $9797579afd7d961c$var$getTenantFromAuthorityString(authority, correlationId) {
    const authorityUrl = new $9797579afd7d961c$var$UrlString(authority, correlationId);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case $9797579afd7d961c$var$AADAuthority.COMMON:
        case $9797579afd7d961c$var$AADAuthority.ORGANIZATIONS:
        case $9797579afd7d961c$var$AADAuthority.CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $9797579afd7d961c$var$formatAuthorityUri(authorityUri) {
    return authorityUri.endsWith($9797579afd7d961c$var$FORWARD_SLASH) ? authorityUri : `${authorityUri}${$9797579afd7d961c$var$FORWARD_SLASH}`;
}
function $9797579afd7d961c$var$buildStaticAuthorityOptions(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidCloudDiscoveryMetadata, "");
    }
    return {
        canonicalAuthority: authOptions.authority ? $9797579afd7d961c$var$formatAuthorityUri(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param cacheManager
 * @param authorityOptions
 * @param logger
 * @param correlationId
 * @param performanceClient
 * @internal
 */ async function $9797579afd7d961c$var$createDiscoveredInstance(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    const authorityUriFinal = $9797579afd7d961c$var$Authority.transformCIAMAuthority($9797579afd7d961c$var$formatAuthorityUri(authorityUri), correlationId);
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new $9797579afd7d961c$var$Authority(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await $9797579afd7d961c$var$invokeAsync(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), $9797579afd7d961c$var$AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$endpointResolutionError, correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $9797579afd7d961c$var$ScopeSet {
    constructor(inputScopes, correlationId){
        this.correlationId = correlationId;
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? $9797579afd7d961c$var$StringUtils.trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? $9797579afd7d961c$var$StringUtils.removeEmptyStringsFromArray(scopeArr) : [];
        // Check if scopes array has at least one member
        if (!filteredInput || !filteredInput.length) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$emptyInputScopesError, correlationId);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString, correlationId) {
        const scopeString = inputScopeString || "";
        const inputScopes = scopeString.split(" ");
        return new $9797579afd7d961c$var$ScopeSet(inputScopes, correlationId);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString, correlationId) {
        // Handle empty scopes by using default OIDC scopes for cache lookup
        const scopesToUse = inputScopeString && inputScopeString.length > 0 ? inputScopeString : [
            ...$9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1
        ];
        const scopeSet = new $9797579afd7d961c$var$ScopeSet(scopesToUse, correlationId);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope($9797579afd7d961c$var$OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $9797579afd7d961c$var$ScopeSet(lowerCaseScopes, this.correlationId);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        $9797579afd7d961c$var$OIDC_SCOPES.forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$cannotAppendScopeSet, this.correlationId);
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$cannotRemoveEmptyScope, this.correlationId);
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        $9797579afd7d961c$var$OIDC_SCOPES.forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$emptyInputScopeSet, this.correlationId);
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$emptyInputScopeSet, this.correlationId);
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return "";
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get($9797579afd7d961c$var$CLIENT_ID);
    if (clientId && parameters.has($9797579afd7d961c$var$BROKER_CLIENT_ID)) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get($9797579afd7d961c$var$REDIRECT_URI)
    }, correlationId);
}
/**
 * Add the given response_type
 * @param parameters
 * @param responseType
 */ function $9797579afd7d961c$var$addResponseType(parameters, responseType) {
    parameters.set($9797579afd7d961c$var$RESPONSE_TYPE, responseType);
}
/**
 * add response_mode. defaults to query.
 * @param responseMode
 */ function $9797579afd7d961c$var$addResponseMode(parameters, responseMode) {
    parameters.set($9797579afd7d961c$var$RESPONSE_MODE, responseMode ? responseMode : $9797579afd7d961c$var$ResponseMode$1.QUERY);
}
/**
 * Add flag to indicate STS should attempt to use WAM if available
 */ function $9797579afd7d961c$var$addNativeBroker(parameters) {
    parameters.set($9797579afd7d961c$var$NATIVE_BROKER, "1");
}
/**
 * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
 * @param scopeSet
 * @param addOidcScopes
 */ function $9797579afd7d961c$var$addScopes(parameters, scopes, correlationId, addOidcScopes = true, defaultScopes = $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1) {
    // Always add openid to the scopes when adding OIDC scopes
    if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
    const requestScopes = addOidcScopes ? [
        ...scopes || [],
        ...defaultScopes
    ] : scopes || [];
    const scopeSet = new $9797579afd7d961c$var$ScopeSet(requestScopes, correlationId);
    parameters.set($9797579afd7d961c$var$SCOPE, scopeSet.printScopes());
}
/**
 * add clientId
 * @param clientId
 */ function $9797579afd7d961c$var$addClientId(parameters, clientId) {
    parameters.set($9797579afd7d961c$var$CLIENT_ID, clientId);
}
/**
 * add redirect_uri
 * @param redirectUri
 */ function $9797579afd7d961c$var$addRedirectUri(parameters, redirectUri) {
    parameters.set($9797579afd7d961c$var$REDIRECT_URI, redirectUri);
}
/**
 * add post logout redirectUri
 * @param redirectUri
 */ function $9797579afd7d961c$var$addPostLogoutRedirectUri(parameters, redirectUri) {
    parameters.set($9797579afd7d961c$var$POST_LOGOUT_URI, redirectUri);
}
/**
 * add id_token_hint to logout request
 * @param idTokenHint
 */ function $9797579afd7d961c$var$addIdTokenHint(parameters, idTokenHint) {
    parameters.set($9797579afd7d961c$var$ID_TOKEN_HINT, idTokenHint);
}
/**
 * add domain_hint
 * @param domainHint
 */ function $9797579afd7d961c$var$addDomainHint(parameters, domainHint) {
    parameters.set($9797579afd7d961c$var$DOMAIN_HINT, domainHint);
}
/**
 * add login_hint
 * @param loginHint
 */ function $9797579afd7d961c$var$addLoginHint(parameters, loginHint) {
    parameters.set($9797579afd7d961c$var$LOGIN_HINT, loginHint);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for login_hint
 * @param loginHint
 */ function $9797579afd7d961c$var$addCcsUpn(parameters, loginHint) {
    parameters.set($9797579afd7d961c$var$HeaderNames.CCS_HEADER, `UPN:${loginHint}`);
}
/**
 * Adds the CCS (Cache Credential Service) query parameter for account object
 * @param loginHint
 */ function $9797579afd7d961c$var$addCcsOid(parameters, clientInfo) {
    parameters.set($9797579afd7d961c$var$HeaderNames.CCS_HEADER, `Oid:${clientInfo.uid}@${clientInfo.utid}`);
}
/**
 * add sid
 * @param sid
 */ function $9797579afd7d961c$var$addSid(parameters, sid) {
    parameters.set($9797579afd7d961c$var$SID, sid);
}
/**
 * Adds claims to request parameters, conditionally excluding clientCapabilities
 * when skipBrokerClaims is true and a brokered flow is in effect.
 * @param parameters - The request parameters map
 * @param correlationId - The request correlation id
 * @param claims - The claims string from the request
 * @param clientCapabilities - The client capabilities from configuration
 * @param skipBrokerClaims - When true and BROKER_CLIENT_ID is present, excludes clientCapabilities from claims
 * @param claimsToMerge - Optional client-originated claims JSON string (e.g. `claimsFromClient`) deep-merged into `claims` with precedence on conflicts
 */ function $9797579afd7d961c$var$addClaims(parameters, correlationId, claims, clientCapabilities, skipBrokerClaims, claimsToMerge) {
    // Skip clientCapabilities if skipBrokerClaims is set to true and this is a brokered authentication flow
    const configClaims = skipBrokerClaims && parameters.has($9797579afd7d961c$var$BROKER_CLIENT_ID) ? undefined : clientCapabilities;
    const mergedClaims = $9797579afd7d961c$var$buildMergedClaims$1(claims, configClaims, correlationId, claimsToMerge);
    parameters.set($9797579afd7d961c$var$CLAIMS, mergedClaims);
}
/**
 * add correlationId
 * @param correlationId
 */ function $9797579afd7d961c$var$addCorrelationId(parameters, correlationId) {
    parameters.set($9797579afd7d961c$var$CLIENT_REQUEST_ID, correlationId);
}
/**
 * add library info query params
 * @param libraryInfo
 */ function $9797579afd7d961c$var$addLibraryInfo(parameters, libraryInfo) {
    // Telemetry Info
    parameters.set($9797579afd7d961c$var$X_CLIENT_SKU, libraryInfo.sku);
    parameters.set($9797579afd7d961c$var$X_CLIENT_VER, libraryInfo.version);
    if (libraryInfo.os) parameters.set($9797579afd7d961c$var$X_CLIENT_OS, libraryInfo.os);
    if (libraryInfo.cpu) parameters.set($9797579afd7d961c$var$X_CLIENT_CPU, libraryInfo.cpu);
}
/**
 * Add client telemetry parameters
 * @param appTelemetry
 */ function $9797579afd7d961c$var$addApplicationTelemetry(parameters, appTelemetry) {
    if (appTelemetry?.appName) parameters.set($9797579afd7d961c$var$X_APP_NAME, appTelemetry.appName);
    if (appTelemetry?.appVersion) parameters.set($9797579afd7d961c$var$X_APP_VER, appTelemetry.appVersion);
}
/**
 * add prompt
 * @param prompt
 */ function $9797579afd7d961c$var$addPrompt(parameters, prompt) {
    parameters.set($9797579afd7d961c$var$PROMPT, prompt);
}
/**
 * add state
 * @param state
 */ function $9797579afd7d961c$var$addState(parameters, state) {
    if (state) parameters.set($9797579afd7d961c$var$STATE, state);
}
/**
 * add nonce
 * @param nonce
 */ function $9797579afd7d961c$var$addNonce(parameters, nonce) {
    parameters.set($9797579afd7d961c$var$NONCE, nonce);
}
/**
 * add code_challenge and code_challenge_method
 * - throw if either of them are not passed
 * @param codeChallenge
 * @param codeChallengeMethod
 */ function $9797579afd7d961c$var$addCodeChallengeParams(parameters, codeChallenge, codeChallengeMethod) {
    if (codeChallenge && codeChallengeMethod) {
        parameters.set($9797579afd7d961c$var$CODE_CHALLENGE, codeChallenge);
        parameters.set($9797579afd7d961c$var$CODE_CHALLENGE_METHOD, codeChallengeMethod);
    } else throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$pkceParamsMissing, "");
}
/**
 * add the `authorization_code` passed by the user to exchange for a token
 * @param code
 */ function $9797579afd7d961c$var$addAuthorizationCode(parameters, code) {
    parameters.set($9797579afd7d961c$var$CODE, code);
}
/**
 * add the `refreshToken` passed by the user
 * @param refreshToken
 */ function $9797579afd7d961c$var$addRefreshToken(parameters, refreshToken) {
    parameters.set($9797579afd7d961c$var$REFRESH_TOKEN, refreshToken);
}
/**
 * add the `code_verifier` passed by the user to exchange for a token
 * @param codeVerifier
 */ function $9797579afd7d961c$var$addCodeVerifier(parameters, codeVerifier) {
    parameters.set($9797579afd7d961c$var$CODE_VERIFIER, codeVerifier);
}
/**
 * add client_secret
 * @param clientSecret
 */ function $9797579afd7d961c$var$addClientSecret(parameters, clientSecret) {
    parameters.set($9797579afd7d961c$var$CLIENT_SECRET, clientSecret);
}
/**
 * add clientAssertion for confidential client flows
 * @param clientAssertion
 */ function $9797579afd7d961c$var$addClientAssertion(parameters, clientAssertion) {
    if (clientAssertion) parameters.set($9797579afd7d961c$var$CLIENT_ASSERTION, clientAssertion);
}
/**
 * add clientAssertionType for confidential client flows
 * @param clientAssertionType
 */ function $9797579afd7d961c$var$addClientAssertionType(parameters, clientAssertionType) {
    if (clientAssertionType) parameters.set($9797579afd7d961c$var$CLIENT_ASSERTION_TYPE, clientAssertionType);
}
/**
 * add grant type
 * @param grantType
 */ function $9797579afd7d961c$var$addGrantType(parameters, grantType) {
    parameters.set($9797579afd7d961c$var$GRANT_TYPE, grantType);
}
/**
 * add client info
 *
 */ function $9797579afd7d961c$var$addClientInfo(parameters) {
    parameters.set($9797579afd7d961c$var$CLIENT_INFO, "1");
}
/**
 * add clidata=1 to request to indicate client data support
 */ function $9797579afd7d961c$var$addCliData(parameters) {
    parameters.set($9797579afd7d961c$var$CLI_DATA, "1");
}
function $9797579afd7d961c$var$addInstanceAware(parameters) {
    if (!parameters.has($9797579afd7d961c$var$INSTANCE_AWARE)) parameters.set($9797579afd7d961c$var$INSTANCE_AWARE, "true");
}
/**
 * Adds `pocd=1`, telling the STS that the client verified the popup driving
 * this request cannot be reached by an untrusted window, so the
 * Cross-Origin-Opener-Policy response header may be omitted.
 *
 * Only ever added when the check passed — a negative result is signalled by
 * omitting the parameter, which keeps the STS default (apply COOP) and stays
 * compatible with library versions that never send it.
 */ function $9797579afd7d961c$var$addPopupOriginCheckDone(parameters) {
    if (!parameters.has($9797579afd7d961c$var$POPUP_ORIGIN_CHECK_DONE)) parameters.set($9797579afd7d961c$var$POPUP_ORIGIN_CHECK_DONE, "1");
}
/**
 * Add extraParameters
 * @param extraParams - String dictionary containing extra parameters to be added.
 */ function $9797579afd7d961c$var$addExtraParameters(parameters, extraParams) {
    Object.entries(extraParams).forEach(([key, value])=>{
        if (!parameters.has(key) && value) parameters.set(key, value);
    });
}
/**
 * Default optional idToken claims requested on all auth requests.
 * signin_state enables KMSI detection; login_hint enables login hint propagation;
 * tenant_region_sub_scope identifies the sovereign enclave a tenant belongs to.
 */ const $9797579afd7d961c$var$DEFAULT_ID_TOKEN_CLAIMS = {
    [$9797579afd7d961c$var$ClaimsRequestKeys.SIGNIN_STATE]: {
        essential: false
    },
    [$9797579afd7d961c$var$ClaimsRequestKeys.LOGIN_HINT]: {
        essential: false
    },
    [$9797579afd7d961c$var$ClaimsRequestKeys.TENANT_REGION_SUB_SCOPE]: {
        essential: false
    }
};
/**
 * Parses a claims JSON string into an object, throwing a ClientConfigurationError
 * (error code `invalid_claims`) if the value is not a valid JSON object. The raw
 * claims value is never included in the error - it may contain sensitive data.
 * @param claims - Claims JSON string. Must be valid JSON representing an object.
 * @param correlationId - The request correlation id
 * @returns The parsed claims object
 */ function $9797579afd7d961c$var$parseClaims(claims, correlationId = "") {
    let parsed;
    try {
        parsed = JSON.parse(claims);
    } catch (e) {
        // Malformed JSON
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidClaims, correlationId);
    }
    if (!$9797579afd7d961c$var$isPlainObject$1(parsed)) // Valid JSON, but not an object (e.g. an array, a scalar, or the literal `null`).
    throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidClaims, correlationId);
    return parsed;
}
/**
 * Type guard for a non-null, non-array object (a JSON "object" value).
 * @param value - The value to test
 * @returns True when value is a plain object that can be deep-merged
 */ function $9797579afd7d961c$var$isPlainObject$1(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
/**
 * Recursively deep-merges two parsed claims objects. Nested objects are merged key-by-key;
 * for any other value type (arrays, scalars, null) the value from `claimsToMerge` replaces
 * the base. This mirrors the deep merge used by msal-dotnet so that, for example, a server
 * `access_token` challenge and a client-originated `access_token` claim are combined rather
 * than one clobbering the other.
 * @param baseClaims - The parsed base claims object
 * @param claimsToMerge - The parsed claims object merged in with precedence
 * @returns The deep-merged claims object
 */ function $9797579afd7d961c$var$deepMergeClaims(baseClaims, claimsToMerge) {
    const merged = {
        ...baseClaims
    };
    for (const [key, mergeInValue] of Object.entries(claimsToMerge)){
        const baseValue = merged[key];
        if ($9797579afd7d961c$var$isPlainObject$1(baseValue) && $9797579afd7d961c$var$isPlainObject$1(mergeInValue)) merged[key] = $9797579afd7d961c$var$deepMergeClaims(baseValue, mergeInValue);
        else merged[key] = mergeInValue;
    }
    return merged;
}
/**
 * Parses claims JSON, optionally deep-merges a second client-originated claims string
 * (`claimsToMerge`, e.g. `claimsFromClient`) with precedence on conflicting keys, merges
 * default optional idToken claims (signin_state, login_hint, tenant_region_sub_scope), and appends client
 * capabilities (xms_cc) to the access_token section
 * Does not overwrite idToken claims already specified by the caller.
 * @param claims - Existing claims JSON string from the request (may be undefined)
 * @param clientCapabilities - Client capabilities array from configuration
 * @param correlationId - The request correlation id
 * @param claimsToMerge - Optional second claims JSON string (e.g. client-originated `claimsFromClient`)
 * deep-merged into `claims` with precedence on conflicts; parsed and validated when present. Nested
 * objects are merged recursively; arrays and scalar values are replaced.
 * @returns Merged claims JSON string
 */ function $9797579afd7d961c$var$buildMergedClaims$1(claims, clientCapabilities, correlationId = "", claimsToMerge) {
    // Parse provided claims into JSON object or initialize empty object
    let mergedClaims = claims ? $9797579afd7d961c$var$parseClaims(claims, correlationId) : {};
    // Deep-merge client-originated claims (e.g. `claimsFromClient`) with precedence on conflicts
    if (claimsToMerge?.trim()) mergedClaims = $9797579afd7d961c$var$deepMergeClaims(mergedClaims, $9797579afd7d961c$var$parseClaims(claimsToMerge, correlationId));
    // Add default optional idToken claims
    if (!Object.prototype.hasOwnProperty.call(mergedClaims, $9797579afd7d961c$var$ClaimsRequestKeys.ID_TOKEN)) mergedClaims[$9797579afd7d961c$var$ClaimsRequestKeys.ID_TOKEN] = {};
    const idTokenClaims = mergedClaims[$9797579afd7d961c$var$ClaimsRequestKeys.ID_TOKEN];
    for (const [key, value] of Object.entries($9797579afd7d961c$var$DEFAULT_ID_TOKEN_CLAIMS))if (!(key in idTokenClaims)) idTokenClaims[key] = value;
    // Add client capabilities
    if (clientCapabilities && clientCapabilities.length > 0) {
        if (!Object.prototype.hasOwnProperty.call(mergedClaims, $9797579afd7d961c$var$ClaimsRequestKeys.ACCESS_TOKEN)) // Add access_token key to claims object
        mergedClaims[$9797579afd7d961c$var$ClaimsRequestKeys.ACCESS_TOKEN] = {};
        // Add xms_cc claim with provided clientCapabilities to access_token key
        mergedClaims[$9797579afd7d961c$var$ClaimsRequestKeys.ACCESS_TOKEN][$9797579afd7d961c$var$ClaimsRequestKeys.XMS_CC] = {
            values: clientCapabilities
        };
    }
    return JSON.stringify(mergedClaims);
}
/**
 * add pop_jwk to query params
 * @param cnfString
 */ function $9797579afd7d961c$var$addPopToken(parameters, cnfString) {
    if (cnfString) {
        parameters.set($9797579afd7d961c$var$TOKEN_TYPE, $9797579afd7d961c$var$AuthenticationScheme$1.POP);
        parameters.set($9797579afd7d961c$var$REQ_CNF, cnfString);
    }
}
/**
 * add SSH JWK and key ID to query params
 */ function $9797579afd7d961c$var$addSshJwk(parameters, sshJwkString) {
    if (sshJwkString) {
        parameters.set($9797579afd7d961c$var$TOKEN_TYPE, $9797579afd7d961c$var$AuthenticationScheme$1.SSH);
        parameters.set($9797579afd7d961c$var$REQ_CNF, sshJwkString);
    }
}
/**
 * add server telemetry fields
 * @param serverTelemetryManager
 * @internal
 */ function $9797579afd7d961c$var$addServerTelemetry(parameters, serverTelemetryManager) {
    parameters.set($9797579afd7d961c$var$X_CLIENT_CURR_TELEM, serverTelemetryManager.generateCurrentRequestHeaderValue());
    parameters.set($9797579afd7d961c$var$X_CLIENT_LAST_TELEM, serverTelemetryManager.generateLastRequestHeaderValue());
}
/**
 * Adds parameter that indicates to the server that throttling is supported
 */ function $9797579afd7d961c$var$addThrottling(parameters) {
    parameters.set($9797579afd7d961c$var$X_MS_LIB_CAPABILITY, $9797579afd7d961c$var$X_MS_LIB_CAPABILITY_VALUE);
}
/**
 * Adds logout_hint parameter for "silent" logout which prevent server account picker
 */ function $9797579afd7d961c$var$addLogoutHint(parameters, logoutHint) {
    parameters.set($9797579afd7d961c$var$LOGOUT_HINT, logoutHint);
}
function $9797579afd7d961c$var$addBrokerParameters(parameters, brokerClientId, brokerRedirectUri) {
    if (!parameters.has($9797579afd7d961c$var$BROKER_CLIENT_ID)) parameters.set($9797579afd7d961c$var$BROKER_CLIENT_ID, brokerClientId);
    if (!parameters.has($9797579afd7d961c$var$BROKER_REDIRECT_URI)) parameters.set($9797579afd7d961c$var$BROKER_REDIRECT_URI, brokerRedirectUri);
}
/**
 * Add EAR (Encrypted Authorize Response) request parameters
 * @param parameters
 * @param jwk
 */ function $9797579afd7d961c$var$addEARParameters(parameters, jwk) {
    parameters.set($9797579afd7d961c$var$EAR_JWK, encodeURIComponent(jwk));
    // ear_jwe_crypto will always have value: {"alg":"dir","enc":"A256GCM"} so we can hardcode this
    const jweCryptoB64Encoded = "eyJhbGciOiJkaXIiLCJlbmMiOiJBMjU2R0NNIn0";
    parameters.set($9797579afd7d961c$var$EAR_JWE_CRYPTO, jweCryptoB64Encoded);
}
function $9797579afd7d961c$var$addResource(parameters, resource) {
    if (resource) parameters.set($9797579afd7d961c$var$RESOURCE, resource);
}
/**
 * Add the `attribute_tokens` parameter to a /token request body.
 *
 * When `attributeTokens` is a non-empty array the values are sorted lexicographically and joined
 * with a single space, then written to the request body. When `attributeTokens` is an empty array
 * the parameter is deleted from the request body.
 *
 * @param parameters - request parameter map that will be serialized into the /token body
 * @param attributeTokens - caller-provided attribute token strings
 */ function $9797579afd7d961c$var$addAttributeTokens(parameters, attributeTokens) {
    const serialized = $9797579afd7d961c$var$serializeAttributeTokens(attributeTokens);
    if (serialized) parameters.set($9797579afd7d961c$var$ATTRIBUTE_TOKENS, serialized);
    else parameters.delete($9797579afd7d961c$var$ATTRIBUTE_TOKENS);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $9797579afd7d961c$var$stripLeadingHashOrQuery(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns flat fragment or query parameters as an authorization response.
 * Application routes and unrecognized responses return null.
 */ function $9797579afd7d961c$var$getDeserializedResponse(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $9797579afd7d961c$var$stripLeadingHashOrQuery(responseString);
        /*
         * Require a flat parameter name, not an application route.
         * Reject routes like #/dashboard?tab=orders&code=... and
         * #/dashboard/orders&state=..., where ?, /, or # appears before
         * the first = or &. These characters are allowed in parameter values.
         */ if (!/^[^=&?#/]+(?:=|&|$)/.test(normalizedResponse)) return null;
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.ear_jwe || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$hashNotDeserialized, "");
    }
    return null;
}
/**
 * Utility to create a URL from the params map
 */ function $9797579afd7d961c$var$mapToQueryString(parameters) {
    const queryParameterArray = new Array();
    parameters.forEach((value, key)=>{
        queryParameterArray.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParameterArray.join("&");
}
/**
 * Normalizes URLs for comparison per MDN & RFC 3986 standards:
 * - Hash/fragment is removed
 * - Scheme and host are lowercased (case-insensitive per spec)
 * - Path and query parameters preserve original casing (case-sensitive per spec)
 * - Percent-encoding in pathname is normalized (e.g., %27 and ' are treated equivalently)
 * - Ensures pathname ends with /
 * Throws a urlParseError if the provided URL is malformed and cannot be parsed.
 * @param url - URL to normalize
 * @param logger - Optional logger used to log parse failures
 * @param correlationId - Optional correlationId associated with the log entry
 * @returns Normalized URL string for comparison
 */ function $9797579afd7d961c$var$normalizeUrlForComparison(url, logger, correlationId) {
    if (!url) return url;
    const urlWithoutHash = url.split("#")[0];
    if (!urlWithoutHash) return urlWithoutHash;
    try {
        const urlObj = new URL(urlWithoutHash);
        // Treat an empty query string (a bare trailing "?") as equivalent to no query
        if (!urlObj.search) urlObj.search = "";
        // Decode the pathname to normalize percent-encoding and ensure trailing slash
        let pathname;
        try {
            pathname = decodeURIComponent(urlObj.pathname);
        } catch (e) {
            pathname = urlObj.pathname;
        }
        if (!pathname.endsWith("/")) pathname += "/";
        urlObj.pathname = pathname;
        return urlObj.href;
    } catch (e) {
        logger?.error(`15apdm ${e}`, correlationId || "");
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, correlationId || "");
    }
}
/**
 * Validates that the provided value is a well-formed, parseable absolute URL.
 * Throws a urlParseError if the value cannot be parsed by the URL API (e.g. the
 * literal string "null", an empty string, or any malformed/relative URL). Use this
 * to guard against persisting an invalid value (such as a redirect URL) to the cache.
 * @param url - URL to validate
 * @param logger - Optional logger used to log validation failures
 * @param correlationId - Optional correlationId associated with the log entry
 */ function $9797579afd7d961c$var$validateUrl(url, logger, correlationId) {
    try {
        new URL(url);
    } catch (e) {
        logger?.error(`1lrjz7 ${e}`, correlationId || "");
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, correlationId || "");
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Shared JOSE algorithm literals used by MSAL package internals.
 * @internal
 */ const $9797579afd7d961c$var$JsonWebTokenAlgorithms = {
    ES256: "ES256",
    RS256: "RS256"
};
/**
 * Default crypto implementation used when a platform-specific implementation has
 * not been provided.
 */ const $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION = {
    createNewGuid: ()=>{
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    base64Decode: ()=>{
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    base64Encode: ()=>{
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    base64UrlEncode: ()=>{
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    encodeKid: ()=>{
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    async removeTokenBindingKey (kid, correlationId) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId);
    },
    async clearKeystore (correlationId) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId);
    },
    async signTokenBindingJwt (header, payload, kid, correlationId) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId);
    },
    async hashString () {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Default token-binding key manager used when a platform-specific implementation
 * has not been provided.
 * @internal
 */ const $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER = {
    async provisionTokenBindingKey (request) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, request.correlationId);
    },
    async removeTokenBindingKey (_kid, correlationId) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId);
    },
    async getTokenBindingPublicKeyJwk (_kid, correlationId) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId);
    }
};
$9797579afd7d961c$export$243e62d78d3b544d = void 0;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($9797579afd7d961c$export$243e62d78d3b544d || ($9797579afd7d961c$export$243e62d78d3b544d = {}));
// Shared cache state for better minification - using Map's insertion order for LRU
const $9797579afd7d961c$var$CACHE_CAPACITY = 50;
const $9797579afd7d961c$var$MAX_LOGS_PER_CORRELATION = 500;
const $9797579afd7d961c$var$correlationCache = new Map();
/**
 * Mark correlation ID as recently used by moving it to end of Map
 * @param correlationId
 * @param {CorrelationLogData} data
 */ function $9797579afd7d961c$var$markAsRecentlyUsed(correlationId, data) {
    $9797579afd7d961c$var$correlationCache.delete(correlationId);
    $9797579afd7d961c$var$correlationCache.set(correlationId, data);
}
/**
 * Add log message to cache for specific correlation ID
 * @param correlationId
 * @param {LoggedMessage} loggedMessage
 */ function $9797579afd7d961c$var$addLogToCache(correlationId, loggedMessage) {
    const currentTime = Date.now();
    let data = $9797579afd7d961c$var$correlationCache.get(correlationId);
    if (data) // Mark as recently used
    $9797579afd7d961c$var$markAsRecentlyUsed(correlationId, data);
    else {
        // Create new entry
        data = {
            logs: [],
            firstEventTime: currentTime
        };
        $9797579afd7d961c$var$correlationCache.set(correlationId, data);
        // Remove LRU (first entry) if capacity exceeded
        if ($9797579afd7d961c$var$correlationCache.size > $9797579afd7d961c$var$CACHE_CAPACITY) {
            const firstKey = $9797579afd7d961c$var$correlationCache.keys().next().value;
            if (firstKey !== undefined) $9797579afd7d961c$var$correlationCache.delete(firstKey);
        }
    }
    // Add log to the data, maintaining max logs per correlation
    data.logs.push({
        ...loggedMessage,
        milliseconds: currentTime - data.firstEventTime
    });
    if (data.logs.length > $9797579afd7d961c$var$MAX_LOGS_PER_CORRELATION) data.logs.shift(); // Remove oldest log
}
/**
 * Get logs for correlation ID and flush them from cache
 * Attaches logs with empty correlation id to the requested correlation logs
 * @param correlationId
 */ function $9797579afd7d961c$var$getAndFlushLogsFromCache(correlationId) {
    const res = [];
    for (const id of [
        "",
        correlationId
    ]){
        const data = $9797579afd7d961c$var$correlationCache.get(id);
        res.push(...data?.logs ?? []);
        $9797579afd7d961c$var$correlationCache.delete(id); // Remove the correlation ID completely from cache
    }
    return res;
}
/**
 * Extracts the leading minification hash from a log message, if present.
 *
 * Minified messages are produced by the logger-minify rollup plugin and are
 * either a bare 6-character alphanumeric hash, or that hash followed by a space
 * and runtime variables appended for local (console) logging, e.g.
 * "abc123 user-1 popup". Only the leading hash is returned so that telemetry
 * never captures the appended variables. Returns null when the message is not
 * a minified message.
 */ function $9797579afd7d961c$var$getMessageHash(str) {
    if (str.length < 6) return null;
    /*
     * If the message is longer than the hash, the hash must be delimited by a
     * space (the separator the plugin inserts before appended variables).
     */ if (str.length > 6 && str[6] !== " ") return null;
    for(let i = 0; i < 6; i++){
        const char = str[i];
        const isAlphaNumeric = char >= "a" && char <= "z" || char >= "A" && char <= "Z" || char >= "0" && char <= "9";
        if (!isAlphaNumeric) return null;
    }
    return str.substring(0, 6);
}
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $9797579afd7d961c$var$Logger {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $9797579afd7d961c$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $9797579afd7d961c$var$Logger.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $9797579afd7d961c$export$243e62d78d3b544d.Info;
        this.packageName = packageName || "";
        this.packageVersion = packageVersion || "";
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion) {
        return new $9797579afd7d961c$var$Logger({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        const correlationId = options.correlationId;
        const messageHash = $9797579afd7d961c$var$getMessageHash(logMessage);
        if (messageHash) {
            const loggedMessage = {
                hash: messageHash,
                level: options.logLevel,
                containsPii: options.containsPii || false,
                milliseconds: 0
            };
            $9797579afd7d961c$var$addLogToCache(correlationId, loggedMessage);
        }
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${correlationId}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$9797579afd7d961c$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /* eslint-disable header/header */ const $9797579afd7d961c$var$name$1 = "@azure/msal-common";
const $9797579afd7d961c$var$version$1 = "16.15.0";
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$cacheQuotaExceeded = "cache_quota_exceeded";
const $9797579afd7d961c$var$cacheErrorUnknown = "cache_error_unknown";
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the cache
 */ class $9797579afd7d961c$var$CacheError extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || $9797579afd7d961c$var$getDefaultErrorMessage$1(errorCode);
        super(message);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$CacheError.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $9797579afd7d961c$var$createCacheError(e) {
    if (!(e instanceof Error)) return new $9797579afd7d961c$var$CacheError($9797579afd7d961c$var$cacheErrorUnknown);
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $9797579afd7d961c$var$CacheError($9797579afd7d961c$var$cacheQuotaExceeded);
    else return new $9797579afd7d961c$var$CacheError(e.name, e.message);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $9797579afd7d961c$var$CacheManager {
    constructor(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions, tokenBindingKeyManager){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.commonLogger = logger.clone($9797579afd7d961c$var$name$1, $9797579afd7d961c$var$version$1);
        this.staticAuthorityOptions = staticAuthorityOptions;
        this.performanceClient = performanceClient;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter = {}, correlationId) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        if (Object.keys(accountFilter).length === 0 || Object.values(accountFilter).every((value)=>value === null || value === undefined || value === "")) {
            this.commonLogger.warning("1skb02", correlationId);
            return null;
        }
        const allAccounts = this.getAllAccounts(accountFilter, correlationId);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((a, b)=>{
                const aHasClaims = a.idTokenClaims ? 1 : 0;
                const bHasClaims = b.idTokenClaims ? 1 : 0;
                return bHasClaims - aHasClaims;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return $9797579afd7d961c$var$getAccountInfo(accountEntities[0]);
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(idToken.secret, this.cryptoImpl.base64Decode, correlationId);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = $9797579afd7d961c$var$updateAccountTenantProfileData(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = $9797579afd7d961c$var$getAccountInfo(accountEntity);
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        if (!!tenantProfileFilter.username && !this.matchUsername(tenantProfile.username, tenantProfileFilter.username) && !this.matchUsername(tenantProfile.upn, tenantProfileFilter.username)) return false;
        if (!!tenantProfileFilter.loginHint && !this.matchLoginHintWithTenantProfile(tenantProfile, tenantProfileFilter.loginHint)) return false;
        if (!!tenantProfileFilter.upn && !(tenantProfile.upn === tenantProfileFilter.upn)) return false;
        if (!!tenantProfileFilter.nativeAccountId && tenantProfile.nativeAccountId !== tenantProfileFilter.nativeAccountId) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username) && !this.matchUsername(idTokenClaims.upn, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        if (!cacheRecord) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidCacheRecord, correlationId);
        try {
            if (!!cacheRecord.account) await this.setAccount(cacheRecord.account, correlationId, kmsi, apiId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) await this.setIdTokenCredential(cacheRecord.idToken, correlationId, kmsi);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId, kmsi);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) await this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId, kmsi);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error("0j476p", correlationId);
            if (e instanceof $9797579afd7d961c$var$AuthError) throw e;
            else throw $9797579afd7d961c$var$createCacheError(e);
        }
    }
    /**
     * saves access token credential
     * @param credential - the access token entity to save
     * @param correlationId - unique identifier for the request
     * @param kmsi - keep me signed in flag
     */ async saveAccessToken(credential, correlationId, kmsi) {
        // Compute hash from components on the entity itself — no need to thread externally.
        let additionalCacheKeyHash;
        if (credential.additionalCacheKeyComponents && Object.keys(credential.additionalCacheKeyComponents).length > 0) additionalCacheKeyHash = await this.cryptoImpl.hashString(JSON.stringify(credential.additionalCacheKeyComponents));
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = $9797579afd7d961c$var$ScopeSet.fromString(credential.target, correlationId);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter, correlationId)) {
                const tokenScopeSet = $9797579afd7d961c$var$ScopeSet.fromString(tokenEntity.target, correlationId);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        await this.setAccessTokenCredential(credential, correlationId, kmsi, additionalCacheKeyHash);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            const entity = this.getAccount(cacheKey, correlationId);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment, correlationId)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name,
                username: accountFilter?.username,
                loginHint: accountFilter?.loginHint,
                upn: accountFilter?.upn,
                nativeAccountId: accountFilter?.nativeAccountId
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @param correlationId
     * @returns
     */ credentialMatchesFilter(entity, filter, correlationId) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target, correlationId)) return false;
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!this.matchAccessTokenWithAuthScheme(entity, filter)) return false;
        }
        // Additional cache key components matching (bidirectional isolation)
        const entityComponents = entity.additionalCacheKeyComponents;
        const filterComponents = filter.additionalCacheKeyComponents;
        const entityHasComponents = !!entityComponents && Object.keys(entityComponents).length > 0;
        const filterHasComponents = !!filterComponents && Object.keys(filterComponents).length > 0;
        if (entityHasComponents !== filterHasComponents) return false;
        if (entityHasComponents && filterHasComponents) {
            const entityKeys = Object.keys(entityComponents).sort();
            const filterKeys = Object.keys(filterComponents).sort();
            if (entityKeys.length !== filterKeys.length) return false;
            for(let i = 0; i < entityKeys.length; i++){
                if (entityKeys[i] !== filterKeys[i] || entityComponents[entityKeys[i]] !== filterComponents[filterKeys[i]]) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     * @param correlationId
     */ getAppMetadataFilteredBy(filter, correlationId) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment, correlationId)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param host
     * @param correlationId
     */ getAuthorityMetadataByAlias(host, correlationId) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey, correlationId);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ removeAllAccounts(correlationId) {
        const accounts = this.getAllAccounts({}, correlationId);
        accounts.forEach((account)=>{
            this.removeAccount(account, correlationId);
        });
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ removeAccount(account, correlationId) {
        this.removeAccountContext(account, correlationId);
        const accountKeys = this.getAccountKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        accountKeys.filter(keyFilter).forEach((key)=>{
            this.removeItem(key, correlationId);
            this.performanceClient.incrementFields({
                accountsRemoved: 1
            }, correlationId);
        });
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const keyFilter = (key)=>{
            return key.includes(account.homeAccountId) && key.includes(account.environment);
        };
        allTokenKeys.idToken.filter(keyFilter).forEach((key)=>{
            this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.filter(keyFilter).forEach((key)=>{
            this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.filter(keyFilter).forEach((key)=>{
            this.removeRefreshToken(key, correlationId);
        });
    }
    /**
     * returns a boolean if the given credential is removed
     * @param key
     * @param correlationId
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        if (!credential) return;
        this.removeItem(key, correlationId);
        this.performanceClient.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        // Remove Token Binding Key from key store for token-bound access token credentials
        if (credential.credentialType.toLowerCase() === $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) {
            const tokenType = credential.tokenType?.toLowerCase();
            switch(tokenType){
                case $9797579afd7d961c$var$AuthenticationScheme$1.POP:
                case $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase():
                    {
                        const accessTokenWithAuthSchemeEntity = credential;
                        const kid = accessTokenWithAuthSchemeEntity.keyId;
                        if (kid) this.tokenBindingKeyManager.removeTokenBindingKey(kid, correlationId).catch(()=>{
                            this.commonLogger.error("0id34f", correlationId);
                            this.performanceClient?.incrementFields({
                                removeTokenBindingKeyFailure: 1
                            }, correlationId);
                        });
                        break;
                    }
            }
        }
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm) {
        this.commonLogger.trace("1drz22", correlationId);
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: $9797579afd7d961c$var$CredentialType.ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("1atvtd", correlationId);
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("0ooalx", correlationId);
                    return idTokenMap.values().next().value ?? null;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("1eq2vc", correlationId);
                    return homeIdTokenMap.values().next().value ?? null;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("1ws328", correlationId);
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("1sm769", correlationId);
        return idTokenMap.values().next().value ?? null;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter, correlationId)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     */ getAccessToken(account, request, tokenKeys, targetRealm) {
        const correlationId = request.correlationId;
        this.commonLogger.trace("1t7hz1", correlationId);
        const scopes = $9797579afd7d961c$var$ScopeSet.createSearchScopes(request.scopes, correlationId);
        const authScheme = request.authenticationScheme || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== $9797579afd7d961c$var$AuthenticationScheme$1.BEARER.toLowerCase() ? $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME : $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN;
        const attributeTokenPartition = $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens);
        const additionalCacheKeyComponents = attributeTokenPartition ? {
            attribute_tokens: attributeTokenPartition
        } : undefined;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: authScheme === $9797579afd7d961c$var$AuthenticationScheme$1.SSH ? request.sshKid : undefined,
            additionalCacheKeyComponents: additionalCacheKeyComponents
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        const matchedKeys = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter, correlationId)) {
                    accessTokens.push(accessToken);
                    matchedKeys.push(key);
                }
            }
        });
        if (accessTokens.length < 1) {
            this.commonLogger.info("1nckna", correlationId);
            return null;
        } else if (accessTokens.length > 1) {
            this.commonLogger.info("1wkfwp", correlationId);
            matchedKeys.forEach((key)=>{
                this.removeAccessToken(key, correlationId);
            });
            this.performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, correlationId);
            return null;
        }
        this.commonLogger.info("06yt98", correlationId);
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter, correlationId)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys) {
        this.commonLogger.trace("0x53vi", correlationId);
        const id = familyRT ? $9797579afd7d961c$var$THE_FAMILY_ID : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: $9797579afd7d961c$var$CredentialType.REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter, correlationId)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("0dlw11", correlationId);
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1) this.performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("0wcnep", correlationId);
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment, correlationId) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter, correlationId);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$multipleMatchingAppMetadata, correlationId);
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment, correlationId) {
        const appMetadata = this.readAppMetadataFromCache(environment, correlationId);
        return !!(appMetadata && appMetadata.familyId === $9797579afd7d961c$var$THE_FAMILY_ID);
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match loginhints
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintWithTenantProfile(tenantProfile, loginHintFilter) {
        return tenantProfile.loginHint === loginHintFilter || tenantProfile.username === loginHintFilter || tenantProfile.upn === loginHintFilter;
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment, correlationId) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = $9797579afd7d961c$var$getAliasesFromStaticSources(this.staticAuthorityOptions, this.commonLogger, correlationId);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment, correlationId);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        // check login hint against list of emails in token claims
        if (tokenClaims.emails && tokenClaims.emails.includes(loginHint)) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target, correlationId) {
        const isNotAccessTokenCredential = entity.credentialType !== $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN && entity.credentialType !== $9797579afd7d961c$var$CredentialType.ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = $9797579afd7d961c$var$ScopeSet.fromString(entity.target, correlationId);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType.toLowerCase() === tokenType.toLowerCase());
    }
    matchAccessTokenWithAuthScheme(entity, filter) {
        const normalizedFilterTokenType = filter.tokenType?.toLowerCase();
        if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
        switch(normalizedFilterTokenType){
            case "dpop":
            case $9797579afd7d961c$var$AuthenticationScheme$1.SSH:
                return this.matchKeyBoundAccessToken(entity, filter);
            default:
                return true;
        }
    }
    matchKeyBoundAccessToken(entity, filter) {
        if (!filter.keyId) return true;
        return this.matchKeyId(entity, filter.keyId);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf($9797579afd7d961c$var$APP_METADATA) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf($9797579afd7d961c$var$AUTHORITY_METADATA_CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${$9797579afd7d961c$var$AUTHORITY_METADATA_CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $9797579afd7d961c$var$DefaultStorageClass extends $9797579afd7d961c$var$CacheManager {
    async setAccount() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAccount() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    async setIdTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getIdTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    async setAccessTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAccessTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    async setRefreshTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getRefreshTokenCredential() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    setAppMetadata() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAppMetadata() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    setServerTelemetry() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getServerTelemetry() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    setAuthorityMetadata() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAuthorityMetadata() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAuthorityMetadataKeys() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    setThrottlingCache() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getThrottlingCache() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    removeItem() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getKeys() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getAccountKeys() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    getTokenKeys() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    /* eslint-disable @typescript-eslint/no-unused-vars */ generateCredentialKey(_credential, _hash) {
        /* eslint-enable @typescript-eslint/no-unused-vars */ throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    generateAccountKey() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $9797579afd7d961c$var$PerformanceEventStatus = {
    InProgress: 1,
    Completed: 2
};
/**
 * Prefix used to mark telemetry field names as dynamic.
 * Fields with this prefix in addFields/incrementFields calls will be routed
 * to the PerformanceEvent.ext sub-object.
 */ const $9797579afd7d961c$var$EXT_FIELD_PREFIX = "ext.";
const $9797579afd7d961c$var$IntFields = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT",
    "unencryptedCacheCount",
    "encryptedCacheExpiredCount",
    "oldAccountCount",
    "oldAccessCount",
    "oldIdCount",
    "oldRefreshCount",
    "currAccountCount",
    "currAccessCount",
    "currIdCount",
    "currRefreshCount",
    "ttlExpiredAcntCount",
    "ttlExpiredITCount",
    "ttlExpiredATCount",
    "ttlExpiredRTCount",
    "decryptFailedAcntCount",
    "decryptFailedITCount",
    "decryptFailedATCount",
    "decryptFailedRTCount",
    "invalidAcntCount",
    "invalidITCount",
    "invalidATCount",
    "invalidRTCount",
    "expiredATCount",
    "expiredRTCount",
    "upgradedCacheCount",
    "cacheMatchedAccounts",
    "networkRtt",
    "redirectBridgeTimeoutMs",
    "redirectBridgeMessageVersion",
    "fetchRetryCount"
]);
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$StubPerformanceClient {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: $9797579afd7d961c$var$PerformanceEventStatus.InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            }
        };
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    addGlobalFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$DEFAULT_SYSTEM_OPTIONS = {
    tokenRenewalOffsetSeconds: $9797579afd7d961c$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC,
    preventCorsPreflight: false
};
const $9797579afd7d961c$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Info,
    correlationId: ""
};
const $9797579afd7d961c$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    },
    async sendPostRequestAsync () {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
};
const $9797579afd7d961c$var$DEFAULT_LIBRARY_INFO = {
    sku: $9797579afd7d961c$var$SKU,
    version: $9797579afd7d961c$var$version$1,
    cpu: "",
    os: ""
};
const $9797579afd7d961c$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: "",
    clientAssertion: undefined
};
const $9797579afd7d961c$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: $9797579afd7d961c$var$AzureCloudInstance.None,
    tenant: `${$9797579afd7d961c$var$DEFAULT_COMMON_TENANT}`
};
const $9797579afd7d961c$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 * @internal
 */ function $9797579afd7d961c$var$buildClientConfiguration({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, tokenBindingKeyManager: tokenBindingKeyManager, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$9797579afd7d961c$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    const resolvedTokenBindingKeyManager = tokenBindingKeyManager || $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
    return {
        authOptions: $9797579afd7d961c$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$9797579afd7d961c$var$DEFAULT_SYSTEM_OPTIONS,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        storageInterface: storageImplementation || new $9797579afd7d961c$var$DefaultStorageClass(userAuthOptions.clientId, $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION, new $9797579afd7d961c$var$Logger(loggerOptions, $9797579afd7d961c$var$name$1, $9797579afd7d961c$var$version$1), new $9797579afd7d961c$var$StubPerformanceClient(), undefined, resolvedTokenBindingKeyManager),
        networkInterface: networkImplementation || $9797579afd7d961c$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION,
        tokenBindingKeyManager: resolvedTokenBindingKeyManager,
        clientCredentials: clientCredentials || $9797579afd7d961c$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$9797579afd7d961c$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$9797579afd7d961c$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $9797579afd7d961c$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $9797579afd7d961c$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        instanceAware: false,
        isMcp: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $9797579afd7d961c$var$isOidcProtocolMode(config) {
    return config.authOptions.authority.options.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $9797579afd7d961c$var$TokenCacheContext {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $9797579afd7d961c$var$JoseHeaderError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $9797579afd7d961c$var$JoseHeaderError.prototype);
    }
}
/** Returns JoseHeaderError object */ function $9797579afd7d961c$var$createJoseHeaderError(code, correlationId) {
    return new $9797579afd7d961c$var$JoseHeaderError(code, correlationId);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks whether a value is a plain JSON-like object.
 * Allows objects with null prototypes, but rejects arrays and object subclasses.
 */ function $9797579afd7d961c$var$isPlainObject(value) {
    if (typeof value !== "object" || value === null || Object.prototype.toString.call(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    let proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$missingKidError = "missing_kid_error";
const $9797579afd7d961c$var$missingAlgError = "missing_alg_error";
const $9797579afd7d961c$var$missingJwkError = "missing_jwk_error";
const $9797579afd7d961c$var$invalidJwkError = "invalid_jwk_error";
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9797579afd7d961c$var$JoseHeader {
    constructor(options, correlationId){
        if (typeof options.alg !== "string" || !options.alg) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$missingAlgError, correlationId);
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
        this.jwk = options.jwk;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @param correlationId
     * @returns
     */ static getShrHeader(shrHeaderOptions, correlationId) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$missingKidError, correlationId);
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$missingAlgError, correlationId);
        return new $9797579afd7d961c$var$JoseHeader({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || $9797579afd7d961c$var$JsonWebTokenTypes$1.Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        }, correlationId);
    }
    /**
     * Builds a DPoP formatted JOSE Header from the JOSE Header options provided.
     * Throws if public JWK or algorithm aren't provided since they are required for DPoP.
     * @param dpopHeaderOptions
     * @param correlationId
     * @returns
     */ static getDpopHeader(dpopHeaderOptions, correlationId) {
        if (!$9797579afd7d961c$var$isPlainObject(dpopHeaderOptions.jwk)) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$missingJwkError, correlationId);
        if (!dpopHeaderOptions.alg) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$missingAlgError, correlationId);
        if (Object.keys(dpopHeaderOptions.jwk).length === 0) throw $9797579afd7d961c$var$createJoseHeaderError($9797579afd7d961c$var$invalidJwkError, correlationId);
        return new $9797579afd7d961c$var$JoseHeader({
            typ: $9797579afd7d961c$var$JsonWebTokenTypes$1.Dpop,
            alg: dpopHeaderOptions.alg,
            jwk: dpopHeaderOptions.jwk
        }, correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$KeyLocation = {
    SW: "sw"
};
const $9797579afd7d961c$var$SHR_TOKEN_BINDING_KEY_TYPE = "shr";
const $9797579afd7d961c$var$SHR_TOKEN_BINDING_KEY_ALGORITHM = $9797579afd7d961c$var$JsonWebTokenAlgorithms.RS256;
/** @internal */ class $9797579afd7d961c$var$PopTokenGenerator {
    constructor(cryptoUtils, tokenBindingKeyManager, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        const reqCnf = await $9797579afd7d961c$var$invokeAsync(this.generateKid.bind(this), $9797579afd7d961c$var$PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        const kidThumbprint = await this.tokenBindingKeyManager.provisionTokenBindingKey({
            correlationId: request.correlationId,
            tokenBindingKeyType: $9797579afd7d961c$var$SHR_TOKEN_BINDING_KEY_TYPE,
            tokenBindingKeyAlgorithm: $9797579afd7d961c$var$SHR_TOKEN_BINDING_KEY_ALGORITHM
        });
        return {
            kid: kidThumbprint,
            xms_ksl: $9797579afd7d961c$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new $9797579afd7d961c$var$UrlString(resourceRequestUri, request.correlationId) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        const publicKeyJwk = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(keyId, request.correlationId);
        const encodedKeyIdThumbprint = this.cryptoUtils.base64UrlEncode(JSON.stringify({
            kid: keyId
        }));
        const shrAlgorithm = shrOptions?.header?.alg || publicKeyJwk.alg || $9797579afd7d961c$var$SHR_TOKEN_BINDING_KEY_ALGORITHM;
        const shrHeader = $9797579afd7d961c$var$JoseHeader.getShrHeader({
            ...shrOptions?.header,
            alg: shrAlgorithm,
            kid: encodedKeyIdThumbprint
        }, request.correlationId);
        const shrPayload = {
            at: payload,
            ts: $9797579afd7d961c$var$nowSeconds(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims,
            cnf: {
                jwk: publicKeyJwk
            }
        };
        return this.cryptoUtils.signTokenBindingJwt(shrHeader, shrPayload, keyId, request.correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$DPOP_HTM_REGEX = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
const $9797579afd7d961c$var$DPOP_TOKEN_BINDING_KEY_TYPE = "dpop";
const $9797579afd7d961c$var$DPOP_JWT_HEADER_ALGORITHM = $9797579afd7d961c$var$JsonWebTokenAlgorithms.ES256;
function $9797579afd7d961c$var$buildProofHeader(publicJwk, correlationId) {
    return $9797579afd7d961c$var$JoseHeader.getDpopHeader({
        alg: $9797579afd7d961c$var$DPOP_JWT_HEADER_ALGORITHM,
        jwk: publicJwk
    }, correlationId);
}
function $9797579afd7d961c$var$normalizeHtm(htm, correlationId) {
    if (typeof htm !== "string" || !$9797579afd7d961c$var$DPOP_HTM_REGEX.test(htm)) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidDpopHtm, correlationId);
    return htm.toUpperCase();
}
/**
 * Normalizes a URL for use as the DPoP htu claim.
 * Per RFC 9449 §4.2, htu is the target URI without query and fragment components.
 * WHATWG URL serialization handles RFC 3986 syntax- and scheme-based normalization
 * such as lowercasing scheme/host and eliding default ports.
 */ function $9797579afd7d961c$var$normalizeHtu(url, correlationId) {
    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch  {
        throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$urlParseError, correlationId);
    }
    if (!/^https:\/\//i.test(url) || parsedUrl.protocol !== "https:" || parsedUrl.username || parsedUrl.password) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidDpopHtu, correlationId);
    parsedUrl.search = "";
    parsedUrl.hash = "";
    return parsedUrl.href;
}
function $9797579afd7d961c$var$validateDpopNonce(nonce, correlationId) {
    if (nonce !== undefined && nonce.trim().length === 0) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidDpopNonce, correlationId);
}
/**
 * Builds RFC 9449 DPoP proof JWT payloads for token-endpoint and
 * resource-endpoint proof bindings.
 *
 * Not exported from any public package entry point.
 * This helper is internal-only until DPoP is wired into acquisition flows
 * in a subsequent work item.
 *
 * DPoP proofs do not contain SHR fields (at, ts, m, u, p, q).
 * @internal
 */ class $9797579afd7d961c$var$DpopProofGenerator {
    constructor(cryptoUtils, tokenBindingKeyManager){
        this.cryptoUtils = cryptoUtils;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
    }
    /**
     * Provisions a fresh DPoP key and returns the RFC 7638 JWK thumbprint used
     * as `dpop_jkt`.
     */ async generateJkt(correlationId = "") {
        return this.tokenBindingKeyManager.provisionTokenBindingKey({
            tokenBindingKeyType: $9797579afd7d961c$var$DPOP_TOKEN_BINDING_KEY_TYPE,
            tokenBindingKeyAlgorithm: $9797579afd7d961c$var$DPOP_JWT_HEADER_ALGORITHM,
            correlationId: correlationId
        });
    }
    /**
     * Builds RFC 9449 claims for a token-endpoint DPoP proof.
     * - htm is always "POST" because token endpoint requests use HTTP POST (RFC 9449 §5).
     * - htu is the normalized token endpoint URI (query and fragment stripped).
     * - jti is a fresh CSPRNG-backed unique identifier for every proof.
     */ buildTokenProofClaims(params, correlationId = "") {
        $9797579afd7d961c$var$validateDpopNonce(params.nonce, correlationId);
        const claims = {
            jti: this.cryptoUtils.createNewGuid(),
            htm: "POST",
            htu: $9797579afd7d961c$var$normalizeHtu(params.tokenEndpoint, correlationId),
            iat: $9797579afd7d961c$var$nowSeconds()
        };
        if (params.nonce !== undefined) claims.nonce = params.nonce;
        return claims;
    }
    /**
     * Builds and signs a compact DPoP proof JWT for a token-endpoint request.
     */ async generateTokenProof(params, keyId, correlationId = "") {
        return this.generateProof(this.buildTokenProofClaims(params, correlationId), keyId, correlationId);
    }
    /**
     * Builds RFC 9449 claims for a resource-endpoint DPoP proof.
     * - htm is uppercased per RFC 9449 §4.2.
     * - htu is the normalized resource URI (query and fragment stripped).
     * - ath is the base64url-encoded SHA-256 hash of the ASCII access token.
     * - jti is a fresh CSPRNG-backed unique identifier for every proof.
     */ buildResourceProofClaims(params, correlationId = "") {
        $9797579afd7d961c$var$validateDpopNonce(params.nonce, correlationId);
        const claims = {
            jti: this.cryptoUtils.createNewGuid(),
            htm: $9797579afd7d961c$var$normalizeHtm(params.htm, correlationId),
            htu: $9797579afd7d961c$var$normalizeHtu(params.htu, correlationId),
            ath: params.ath,
            iat: $9797579afd7d961c$var$nowSeconds()
        };
        if (params.nonce !== undefined) claims.nonce = params.nonce;
        return claims;
    }
    /**
     * Builds and signs a compact DPoP proof JWT for a resource request.
     */ async generateResourceProof(params, keyId, correlationId = "") {
        const { htu: htu, htm: htm, nonce: nonce } = params;
        if (!htu || !htm) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$dpopMissingResourceContext, correlationId);
        const ath = await this.cryptoUtils.hashString(params.accessToken);
        return this.generateProof(this.buildResourceProofClaims({
            htu: htu,
            htm: htm,
            ath: ath,
            nonce: nonce
        }, correlationId), keyId, correlationId);
    }
    async generateProof(claims, keyId, correlationId) {
        const publicJwk = await this.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(keyId, correlationId);
        return this.cryptoUtils.signTokenBindingJwt($9797579afd7d961c$var$buildProofHeader(publicJwk, correlationId), claims, keyId, correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * MSAL-defined interaction required error code indicating no tokens are found in cache.
 * @public
 */ const $9797579afd7d961c$var$noTokensFound = "no_tokens_found";
/**
 * MSAL-defined error code indicating a native account is unavailable on the platform.
 * @public
 */ const $9797579afd7d961c$var$nativeAccountUnavailable = "native_account_unavailable";
/**
 * MSAL-defined error code indicating the refresh token has expired and user interaction is needed.
 * @public
 */ const $9797579afd7d961c$var$refreshTokenExpired = "refresh_token_expired";
/**
 * MSAL-defined error code indicating UI/UX is not allowed (e.g., blocked by policy), requiring alternate interaction.
 * @public
 */ const $9797579afd7d961c$var$uiNotAllowed = "ui_not_allowed";
/**
 * Server-originated error code indicating interaction is required to complete the request.
 * @public
 */ const $9797579afd7d961c$var$interactionRequired = "interaction_required";
/**
 * Server-originated error code indicating user consent is required.
 * @public
 */ const $9797579afd7d961c$var$consentRequired = "consent_required";
/**
 * Server-originated error code indicating user login is required.
 * @public
 */ const $9797579afd7d961c$var$loginRequired = "login_required";
/**
 * Server-originated error code indicating the token is invalid or corrupted.
 * @public
 */ const $9797579afd7d961c$var$badToken = "bad_token";
/**
 * Server-originated error code indicating the user is in an interrupted state and interaction is required.
 * @public
 */ const $9797579afd7d961c$var$interruptedUser = "interrupted_user";
var $9797579afd7d961c$var$InteractionRequiredAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    badToken: $9797579afd7d961c$var$badToken,
    consentRequired: $9797579afd7d961c$var$consentRequired,
    interactionRequired: $9797579afd7d961c$var$interactionRequired,
    interruptedUser: $9797579afd7d961c$var$interruptedUser,
    loginRequired: $9797579afd7d961c$var$loginRequired,
    nativeAccountUnavailable: $9797579afd7d961c$var$nativeAccountUnavailable,
    noTokensFound: $9797579afd7d961c$var$noTokensFound,
    refreshTokenExpired: $9797579afd7d961c$var$refreshTokenExpired,
    uiNotAllowed: $9797579afd7d961c$var$uiNotAllowed
});
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $9797579afd7d961c$var$InteractionRequiredServerErrorMessage = [
    $9797579afd7d961c$var$interactionRequired,
    $9797579afd7d961c$var$consentRequired,
    $9797579afd7d961c$var$loginRequired,
    $9797579afd7d961c$var$badToken,
    $9797579afd7d961c$var$uiNotAllowed,
    $9797579afd7d961c$var$interruptedUser
];
const $9797579afd7d961c$var$InteractionRequiredAuthSubErrorMessage = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token",
    "ui_not_allowed",
    "interrupted_user"
];
/**
 * Error thrown when user interaction is required.
 */ class $9797579afd7d961c$var$InteractionRequiredAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, errorMessage, subError, timestamp, traceId, claims, errorNo){
        super(errorCode, correlationId, errorMessage, subError);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$InteractionRequiredAuthError.prototype);
        this.timestamp = timestamp || "";
        this.traceId = traceId || "";
        this.claims = claims || "";
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $9797579afd7d961c$var$isInteractionRequiredError(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $9797579afd7d961c$var$InteractionRequiredServerErrorMessage.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $9797579afd7d961c$var$InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $9797579afd7d961c$var$InteractionRequiredServerErrorMessage.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $9797579afd7d961c$var$createInteractionRequiredAuthError(errorCode, correlationId, errorMessage) {
    return new $9797579afd7d961c$var$InteractionRequiredAuthError(errorCode, correlationId, errorMessage);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $9797579afd7d961c$var$ServerError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, errorMessage, subError, errorNo, status){
        super(errorCode, correlationId, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $9797579afd7d961c$var$ServerError.prototype);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Appends user state with random guid, or returns random guid.
 * @param cryptoObj
 * @param userState
 * @param meta
 * @param correlationId
 */ function $9797579afd7d961c$var$setRequestState(cryptoObj, userState, meta, correlationId) {
    const libraryState = $9797579afd7d961c$var$generateLibraryState(cryptoObj, correlationId, meta);
    return userState ? `${libraryState}${$9797579afd7d961c$var$RESOURCE_DELIM}${userState}` : libraryState;
}
/**
 * Generates the state value used by the common library.
 * @param cryptoObj
 * @param correlationId
 * @param meta
 */ function $9797579afd7d961c$var$generateLibraryState(cryptoObj, correlationId, meta) {
    if (!cryptoObj) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noCryptoObject, correlationId);
    // Create a state object containing a unique id and the timestamp of the request creation
    const stateObj = {
        id: cryptoObj.createNewGuid()
    };
    if (meta) stateObj.meta = meta;
    const stateString = JSON.stringify(stateObj);
    return cryptoObj.base64Encode(stateString);
}
/**
 * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
 * @param base64Decode
 * @param state
 * @param correlationId
 */ function $9797579afd7d961c$var$parseRequestState(base64Decode, state, correlationId) {
    if (!base64Decode) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noCryptoObject, correlationId);
    if (!state) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidState, correlationId);
    try {
        // Split the state between library state and user passed state and decode them separately
        const splitState = state.split($9797579afd7d961c$var$RESOURCE_DELIM);
        const libraryState = splitState[0];
        const userState = splitState.length > 1 ? splitState.slice(1).join($9797579afd7d961c$var$RESOURCE_DELIM) : "";
        const libraryStateString = base64Decode(libraryState);
        const libraryStateObj = JSON.parse(libraryStateString);
        return {
            userRequestState: userState || "",
            libraryState: libraryStateObj
        };
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidState, correlationId);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class that handles response parsing.
 * @internal
 */ class $9797579afd7d961c$var$ResponseHandler {
    constructor(clientId, cacheStorage, cryptoObj, logger, performanceClient, serializableCache, persistencePlugin, tokenBindingKeyManager = $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.tokenBindingKeyManager = tokenBindingKeyManager;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param correlationId
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, correlationId, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || $9797579afd7d961c$var$NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || $9797579afd7d961c$var$NOT_AVAILABLE} - Description: ${serverResponse.error_description || $9797579afd7d961c$var$NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || $9797579afd7d961c$var$NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || $9797579afd7d961c$var$NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new $9797579afd7d961c$var$ServerError(serverResponse.error || "", serverResponse.correlation_id || "", errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= $9797579afd7d961c$var$HTTP_SERVER_ERROR_RANGE_START && serverResponse.status <= $9797579afd7d961c$var$HTTP_SERVER_ERROR_RANGE_END) {
                this.logger.warning(`16ks7j ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= $9797579afd7d961c$var$HTTP_CLIENT_ERROR_RANGE_START && serverResponse.status <= $9797579afd7d961c$var$HTTP_CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`0g61x3 ${serverError}`, correlationId);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ($9797579afd7d961c$var$isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new $9797579afd7d961c$var$InteractionRequiredAuthError(serverResponse.error || "", serverResponse.correlation_id || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, apiId, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId, additionalCacheKeyComponents) {
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(serverTokenResponse.id_token || "", this.cryptoObj.base64Decode, request.correlationId);
        /*
         * Callers opt in to strict nonce-presence validation by including
         * the nonce property, even when its value is undefined.
         */ if (authCodePayload && Object.prototype.hasOwnProperty.call(authCodePayload, "nonce")) {
            const expectedNonce = authCodePayload.nonce;
            const tokenNonce = idTokenClaims?.nonce;
            // Warn when the ID Token nonce cannot be bound to the request.
            if (tokenNonce !== undefined && expectedNonce === undefined) {
                this.logger.warning("0thba9", request.correlationId);
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$nonceMismatch, request.correlationId);
            }
            // If the request supplies a nonce, the ID Token value must be a matching string.
            if (expectedNonce !== undefined && (typeof expectedNonce !== "string" || typeof tokenNonce !== "string" || expectedNonce !== tokenNonce)) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$nonceMismatch, request.correlationId);
        }
        // generate homeAccountId
        this.homeAccountIdentifier = $9797579afd7d961c$var$generateHomeAccountId(serverTokenResponse.client_info || "", authority.authorityType, this.logger, this.cryptoObj, request.correlationId, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = $9797579afd7d961c$var$parseRequestState(this.cryptoObj.base64Decode, authCodePayload.state, request.correlationId);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.dpopJkt || request.sshKid || undefined;
        if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP) {
            if (serverTokenResponse.token_type?.toLowerCase() !== $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
                this.performanceClient?.addFields({
                    dpopTokenTypeMismatch: serverTokenResponse.token_type
                }, request.correlationId);
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$dpopTokenTypeMismatch, request.correlationId);
            }
            serverTokenResponse.token_type = $9797579afd7d961c$var$AuthenticationScheme$1.DPOP;
        }
        // Compute components once for entity storage (fallback if hash not provided by client)
        const attributeTokenPartition = $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens);
        const cacheKeyComponents = additionalCacheKeyComponents ?? (attributeTokenPartition ? {
            attribute_tokens: attributeTokenPartition
        } : undefined);
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, cacheKeyComponents);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("0jbz5k", request.correlationId);
                cacheContext = new $9797579afd7d961c$var$TokenCacheContext(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const cachedAccounts = this.cacheStorage.getAllAccounts({
                    homeAccountId: cacheRecord.account.homeAccountId,
                    environment: cacheRecord.account.environment
                }, request.correlationId);
                if (cachedAccounts.length < 1) {
                    this.logger.warning("1gmt66", request.correlationId);
                    this.performanceClient?.addFields({
                        acntLoggedOut: true
                    }, request.correlationId);
                    return await $9797579afd7d961c$var$ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, {
                        idTokenClaims: idTokenClaims,
                        requestState: requestStateObj,
                        requestId: serverRequestId,
                        tokenBindingKeyManager: this.tokenBindingKeyManager
                    });
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, $9797579afd7d961c$var$isKmsi(idTokenClaims || {}), apiId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("1bh17u", request.correlationId);
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $9797579afd7d961c$var$ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, this.performanceClient, {
            idTokenClaims: idTokenClaims,
            requestState: requestStateObj,
            serverTokenResponse: serverTokenResponse,
            requestId: serverRequestId,
            tokenBindingKeyManager: this.tokenBindingKeyManager
        });
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload, additionalCacheKeyComponents) {
        const env = authority.getPreferredCache();
        if (!env) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidCacheEnvironment, request.correlationId);
        const claimsTenantId = $9797579afd7d961c$var$getTenantIdFromIdTokenClaims(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = $9797579afd7d961c$var$createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $9797579afd7d961c$var$buildAccountToCache(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger, this.performanceClient);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? $9797579afd7d961c$var$ScopeSet.fromString(serverTokenResponse.scope, request.correlationId) : new $9797579afd7d961c$var$ScopeSet(request.scopes || [], request.correlationId);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = $9797579afd7d961c$var$createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, request.correlationId, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, additionalCacheKeyComponents);
            // Set resource (to be used for MCP scenarios)
            const resource = request.resource || null;
            if (resource) cachedAccessToken.resource = resource;
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
                this.performanceClient?.addFields({
                    ntwkRtExpiresOnSeconds: rtExpiresOn
                }, request.correlationId);
            }
            cachedRefreshToken = $9797579afd7d961c$var$createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, performanceClient, options = {}) {
        const { idTokenClaims: idTokenClaims, requestState: requestState, serverTokenResponse: serverTokenResponse, requestId: requestId, tokenBindingKeyManager: tokenBindingKeyManager = $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER } = options;
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = "";
        let dpopProof;
        if (cacheRecord.accessToken) {
            const accessTokenType = cacheRecord.accessToken.tokenType?.toLowerCase();
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === $9797579afd7d961c$var$AuthenticationScheme$1.POP && !request.popKid) {
                const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(cryptoObj, tokenBindingKeyManager, performanceClient);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$keyIdMissing, request.correlationId);
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            if (accessTokenType === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
                if (!cacheRecord.accessToken.keyId) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$keyIdMissing, request.correlationId);
                const dpopProofGenerator = new $9797579afd7d961c$var$DpopProofGenerator(cryptoObj, tokenBindingKeyManager);
                dpopProof = await dpopProofGenerator.generateResourceProof({
                    htu: request.resourceRequestUri,
                    htm: request.resourceRequestMethod,
                    accessToken: cacheRecord.accessToken.secret
                }, cacheRecord.accessToken.keyId, request.correlationId);
            }
            responseScopes = $9797579afd7d961c$var$ScopeSet.fromString(cacheRecord.accessToken.target, request.correlationId).asArray();
            // Access token expiresOn cached in seconds, converting to Date for AuthenticationResult
            expiresOn = $9797579afd7d961c$var$toDateFromSeconds(cacheRecord.accessToken.expiresOn);
            extExpiresOn = $9797579afd7d961c$var$toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
            if (cacheRecord.accessToken.refreshOn) refreshOn = $9797579afd7d961c$var$toDateFromSeconds(cacheRecord.accessToken.refreshOn);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === $9797579afd7d961c$var$THE_FAMILY_ID ? $9797579afd7d961c$var$THE_FAMILY_ID : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        /*
         * Surface the sovereign enclave for telemetry. This runs for both freshly acquired
         * and cache-served tokens because SilentFlowClient shares this method, so the field
         * is present on silent requests that never hit the network.
         */ const regionSubScope = idTokenClaims?.tenant_region_sub_scope;
        if (typeof regionSubScope === "string") performanceClient?.addFields({
            regionSubScope: regionSubScope
        }, request.correlationId);
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) {
            // Set on deprecated top-level for downgrade compat
            cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
            // Set on the matching tenant profile (source of truth)
            const targetTenantId = tid || cacheRecord.account.realm;
            if (cacheRecord.account.tenantProfiles) {
                const matchingProfile = cacheRecord.account.tenantProfiles.find((tp)=>tp.tenantId === targetTenantId);
                if (matchingProfile) matchingProfile.nativeAccountId = serverTokenResponse.spa_accountid;
            }
        }
        const accountInfo = cacheRecord.account ? $9797579afd7d961c$var$updateAccountTenantProfileData($9797579afd7d961c$var$getAccountInfo(cacheRecord.account), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            dpopProof: dpopProof,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || "",
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType?.toLowerCase() === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase() ? $9797579afd7d961c$var$AuthenticationScheme$1.DPOP : cacheRecord.accessToken?.tokenType || "",
            state: requestState ? requestState.userRequestState : "",
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || "",
            msGraphHost: cacheRecord.account?.msGraphHost || "",
            code: serverTokenResponse?.spa_code,
            fromPlatformBroker: false
        };
    }
}
/** @internal */ function $9797579afd7d961c$var$buildAccountToCache(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger, performanceClient) {
    logger?.verbose("09jz0t", correlationId);
    /*
     * Check if base account is already cached. Filter by homeAccountId (identifies
     * the user's home identity) and environment (identifies the cloud) — the two
     * tenant-agnostic properties that uniquely locate a base AccountEntity.
     */ const accountEnvironment = environment || authority.getPreferredCache();
    const matchedAccounts = cacheStorage.getAccountsFilteredBy({
        homeAccountId: homeAccountId,
        environment: accountEnvironment
    }, correlationId);
    performanceClient?.addFields({
        cacheMatchedAccounts: matchedAccounts.length
    }, correlationId);
    if (matchedAccounts.length > 1) /*
         * Base accounts are expected to be unique for a given homeAccountId in normal cache usage.
         * If multiple matches exist, ignore the cache hit rather than arbitrarily choosing one.
         */ logger?.warning("0x7ad1", correlationId);
    const cachedAccount = matchedAccounts.length === 1 ? matchedAccounts[0] : null;
    const baseAccount = cachedAccount || $9797579afd7d961c$var$createAccountEntity({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, correlationId, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = $9797579afd7d961c$var$buildTenantProfile(homeAccountId, baseAccount.localAccountId, tenantId, nativeAccountId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$CcsCredentialType = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $9797579afd7d961c$var$getClientAssertion(clientAssertion, clientId, tokenEndpoint, fmiPath) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            fmiPath: fmiPath
        };
        return clientAssertion(config);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$getRequestThumbprint(clientId, request, homeAccountId) {
    return {
        clientId: clientId,
        authority: request.authority,
        scopes: request.scopes,
        homeAccountIdentifier: homeAccountId,
        claims: request.claims,
        authenticationScheme: request.authenticationScheme,
        resourceRequestMethod: request.resourceRequestMethod,
        resourceRequestUri: request.resourceRequestUri,
        shrClaims: request.shrClaims,
        sshKid: request.sshKid,
        embeddedClientId: request.embeddedClientId || request.extraParameters?.clientId,
        resource: request.resource,
        attributeTokens: $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens)
    };
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9797579afd7d961c$var$ThrottlingUtils {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${$9797579afd7d961c$var$THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $9797579afd7d961c$var$ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key, correlationId);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new $9797579afd7d961c$var$ServerError(value.errorCodes?.join(" ") || "", correlationId, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response - Token response with case-insensitive header names.
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        const retryAfter = $9797579afd7d961c$var$getRetryAfterHeader(response);
        if ($9797579afd7d961c$var$ThrottlingUtils.checkResponseStatus(response) || retryAfter !== undefined) {
            const thumbprintValue = {
                throttleTime: $9797579afd7d961c$var$ThrottlingUtils.calculateThrottleTime(parseInt(retryAfter || "")),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($9797579afd7d961c$var$ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response - Token response with case-insensitive header names.
     */ static checkResponseForRetryAfter(response) {
        return $9797579afd7d961c$var$getRetryAfterHeader(response) !== undefined;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || $9797579afd7d961c$var$DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + $9797579afd7d961c$var$DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = $9797579afd7d961c$var$getRequestThumbprint(clientId, request, homeAccountIdentifier);
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}
/** Reads Retry-After only for non-success responses. */ function $9797579afd7d961c$var$getRetryAfterHeader(response) {
    if ((response.status < 200 || response.status >= 300) && response.headers) return $9797579afd7d961c$var$getResponseHeader(response.headers, $9797579afd7d961c$var$HeaderNames.RETRY_AFTER);
    return undefined;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $9797579afd7d961c$var$NetworkError extends $9797579afd7d961c$var$AuthError {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.correlationId, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$NetworkError.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $9797579afd7d961c$var$createNetworkError(error, httpStatus, responseHeaders, additionalError) {
    error.errorMessage = `${error.errorMessage}, additionalErrorInfo: error.name:${additionalError?.name}, error.message:${additionalError?.message}`;
    return new $9797579afd7d961c$var$NetworkError(error, httpStatus, responseHeaders);
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates default headers for requests to token endpoint
 */ function $9797579afd7d961c$var$createTokenRequestHeaders(logger, preventCorsPreflight, ccsCred) {
    const headers = {};
    headers[$9797579afd7d961c$var$HeaderNames.CONTENT_TYPE] = $9797579afd7d961c$var$URL_FORM_CONTENT_TYPE;
    if (!preventCorsPreflight && ccsCred) switch(ccsCred.type){
        case $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID:
            try {
                const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(ccsCred.credential);
                headers[$9797579afd7d961c$var$HeaderNames.CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
            } catch (e) {
                logger.verbose(`1qhtee ${e}`, "");
            }
            break;
        case $9797579afd7d961c$var$CcsCredentialType.UPN:
            headers[$9797579afd7d961c$var$HeaderNames.CCS_HEADER] = `UPN: ${ccsCred.credential}`;
            break;
    }
    return headers;
}
/**
 * Adds the DPoP proof header for token endpoint requests when DPoP is requested.
 * @internal
 */ async function $9797579afd7d961c$var$addDpopTokenProofHeader(headers, request, tokenEndpoint, cryptoUtils, tokenBindingKeyManager) {
    if (request.authenticationScheme !== $9797579afd7d961c$var$AuthenticationScheme$1.DPOP) return;
    const dpopProofGenerator = new $9797579afd7d961c$var$DpopProofGenerator(cryptoUtils, tokenBindingKeyManager);
    const keyId = request.dpopJkt;
    if (!keyId?.trim()) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$keyIdMissing, request.correlationId);
    headers[$9797579afd7d961c$var$HeaderNames.DPOP] = await dpopProofGenerator.generateTokenProof({
        tokenEndpoint: tokenEndpoint
    }, keyId, request.correlationId);
}
/**
 * Creates query string for the /token request
 * @param request
 */ function $9797579afd7d961c$var$createTokenQueryParameters(request, clientId, redirectUri, performanceClient) {
    const parameters = new Map();
    if (request.embeddedClientId) $9797579afd7d961c$var$addBrokerParameters(parameters, clientId, redirectUri);
    if (request.extraQueryParameters) $9797579afd7d961c$var$addExtraParameters(parameters, request.extraQueryParameters);
    $9797579afd7d961c$var$addCorrelationId(parameters, request.correlationId);
    $9797579afd7d961c$var$instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return $9797579afd7d961c$var$mapToQueryString(parameters);
}
/**
 * Http post to token endpoint
 * @param tokenEndpoint
 * @param queryString
 * @param headers
 * @param thumbprint
 * @internal
 */ async function $9797579afd7d961c$var$executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, cacheManager, networkClient, logger, performanceClient, serverTelemetryManager) {
    const response = await $9797579afd7d961c$var$sendPostRequest(thumbprint, tokenEndpoint, {
        body: queryString,
        headers: headers
    }, correlationId, cacheManager, networkClient, logger, performanceClient);
    if (serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
    serverTelemetryManager.clearTelemetryCache();
    return response;
}
/**
 * Wraps sendPostRequestAsync with necessary preflight and postflight logic
 * @param thumbprint - Request thumbprint for throttling
 * @param tokenEndpoint - Endpoint to make the POST to
 * @param options - Body and Headers to include on the POST request
 * @param correlationId - CorrelationId for telemetry
 * @param cacheManager - Cache manager instance
 * @param networkClient - Network module instance
 * @param logger - Logger instance
 * @param performanceClient - Performance client instance
 * @internal
 */ async function $9797579afd7d961c$var$sendPostRequest(thumbprint, tokenEndpoint, options, correlationId, cacheManager, networkClient, logger, performanceClient) {
    $9797579afd7d961c$var$ThrottlingUtils.preProcess(cacheManager, thumbprint, correlationId);
    let response;
    try {
        response = await $9797579afd7d961c$var$invokeAsync(networkClient.sendPostRequestAsync.bind(networkClient), $9797579afd7d961c$var$NetworkClientSendPostRequestAsync, logger, performanceClient, correlationId)(tokenEndpoint, {
            ...options,
            correlationId: correlationId,
            performanceClient: performanceClient
        });
        const responseHeaders = $9797579afd7d961c$var$normalizeResponseHeaders(response.headers || {});
        response = {
            ...response,
            headers: responseHeaders
        };
        performanceClient?.addFields({
            refreshTokenSize: response.body.refresh_token?.length || 0,
            httpVerToken: responseHeaders[$9797579afd7d961c$var$HeaderNames.X_MS_HTTP_VERSION] || "",
            requestId: responseHeaders[$9797579afd7d961c$var$HeaderNames.X_MS_REQUEST_ID] || ""
        }, correlationId);
    } catch (e) {
        if (e instanceof $9797579afd7d961c$var$NetworkError) {
            const responseHeaders = e.responseHeaders ? $9797579afd7d961c$var$normalizeResponseHeaders(e.responseHeaders) : undefined;
            if (responseHeaders) performanceClient?.addFields({
                httpVerToken: responseHeaders[$9797579afd7d961c$var$HeaderNames.X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[$9797579afd7d961c$var$HeaderNames.X_MS_REQUEST_ID] || "",
                contentTypeHeader: $9797579afd7d961c$var$getResponseHeader(responseHeaders, $9797579afd7d961c$var$HeaderNames.CONTENT_TYPE) || undefined,
                contentLengthHeader: $9797579afd7d961c$var$getResponseHeader(responseHeaders, $9797579afd7d961c$var$HeaderNames.CONTENT_LENGTH) || undefined,
                httpStatus: e.httpStatus
            }, correlationId);
            throw e.error;
        }
        if (e instanceof $9797579afd7d961c$var$AuthError) throw e;
        else throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$networkError, correlationId);
    }
    $9797579afd7d961c$var$ThrottlingUtils.postProcess(cacheManager, thumbprint, response, correlationId);
    return response;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $9797579afd7d961c$var$AuthorizationCodeClient {
    constructor(configuration, performanceClient){
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        // Set the configuration
        this.config = $9797579afd7d961c$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9797579afd7d961c$var$Logger(this.config.loggerOptions, $9797579afd7d961c$var$name$1, $9797579afd7d961c$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, apiId, authCodePayload) {
        if (!request.code) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$requestCannotBeMade, request.correlationId);
        // Check for new cloud instance
        if (authCodePayload && authCodePayload.cloud_instance_host_name) await $9797579afd7d961c$var$invokeAsync(this.updateTokenEndpointAuthority.bind(this), $9797579afd7d961c$var$UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodePayload.cloud_instance_host_name, request.correlationId);
        const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
        const response = await $9797579afd7d961c$var$invokeAsync(this.executeTokenRequest.bind(this), $9797579afd7d961c$var$AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request, this.serverTelemetryManager);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[$9797579afd7d961c$var$HeaderNames.X_MS_REQUEST_ID];
        const responseHandler = new $9797579afd7d961c$var$ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return $9797579afd7d961c$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9797579afd7d961c$var$HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$logoutRequestEmpty, "");
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return $9797579afd7d961c$var$UrlString.appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request, serverTelemetryManager) {
        const queryParametersString = $9797579afd7d961c$var$createTokenQueryParameters(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = $9797579afd7d961c$var$UrlString.appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await $9797579afd7d961c$var$invokeAsync(this.createTokenRequestBody.bind(this), $9797579afd7d961c$var$AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = $9797579afd7d961c$var$buildClientInfo(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${$9797579afd7d961c$var$CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        const headers = $9797579afd7d961c$var$createTokenRequestHeaders(this.logger, this.config.systemOptions.preventCorsPreflight, ccsCredential || request.ccsCredential);
        await $9797579afd7d961c$var$addDpopTokenProofHeader(headers, request, endpoint, this.cryptoUtils, this.config.tokenBindingKeyManager);
        const thumbprint = $9797579afd7d961c$var$getRequestThumbprint(this.config.authOptions.clientId, request);
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$executePostToTokenEndpoint, $9797579afd7d961c$var$AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, serverTelemetryManager);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        $9797579afd7d961c$var$addClientId(parameters, request.embeddedClientId || request.extraParameters?.[$9797579afd7d961c$var$CLIENT_ID] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) {
            // Just validate
            if (!request.redirectUri) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$redirectUriEmpty, request.correlationId);
        } else // Validate and include redirect uri
        $9797579afd7d961c$var$addRedirectUri(parameters, request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        $9797579afd7d961c$var$addScopes(parameters, request.scopes, request.correlationId, true, this.oidcDefaultScopes);
        $9797579afd7d961c$var$addResource(parameters, request.resource);
        if (request.attributeTokens) $9797579afd7d961c$var$addAttributeTokens(parameters, request.attributeTokens);
        this.performanceClient?.addFields({
            hasAttributeTokens: !!request.attributeTokens?.length
        }, request.correlationId);
        // add code: user set, not validated
        $9797579afd7d961c$var$addAuthorizationCode(parameters, request.code);
        // Add library metadata
        $9797579afd7d961c$var$addLibraryInfo(parameters, this.config.libraryInfo);
        $9797579afd7d961c$var$addApplicationTelemetry(parameters, this.config.telemetry.application);
        $9797579afd7d961c$var$addThrottling(parameters);
        if (this.serverTelemetryManager && !$9797579afd7d961c$var$isOidcProtocolMode(this.config)) $9797579afd7d961c$var$addServerTelemetry(parameters, this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) $9797579afd7d961c$var$addCodeVerifier(parameters, request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) $9797579afd7d961c$var$addClientSecret(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            $9797579afd7d961c$var$addClientAssertion(parameters, await $9797579afd7d961c$var$getClientAssertion(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            $9797579afd7d961c$var$addClientAssertionType(parameters, clientAssertion.assertionType);
        }
        $9797579afd7d961c$var$addGrantType(parameters, $9797579afd7d961c$var$GrantType.AUTHORIZATION_CODE_GRANT);
        $9797579afd7d961c$var$addClientInfo(parameters);
        if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.POP) {
            const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await $9797579afd7d961c$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9797579afd7d961c$var$PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            $9797579afd7d961c$var$addPopToken(parameters, reqCnfData);
        } else if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.SSH) {
            if (request.sshJwk) $9797579afd7d961c$var$addSshJwk(parameters, request.sshJwk);
            else throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$missingSshJwk, request.correlationId);
        }
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = $9797579afd7d961c$var$buildClientInfo(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${$9797579afd7d961c$var$CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose(`0wznt3 ${e}`, request.correlationId);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID:
                try {
                    const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(ccsCred.credential);
                    $9797579afd7d961c$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case $9797579afd7d961c$var$CcsCredentialType.UPN:
                $9797579afd7d961c$var$addCcsUpn(parameters, ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) $9797579afd7d961c$var$addBrokerParameters(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) $9797579afd7d961c$var$addExtraParameters(parameters, request.extraParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.extraParameters || !request.extraParameters[$9797579afd7d961c$var$RETURN_SPA_CODE])) $9797579afd7d961c$var$addExtraParameters(parameters, {
            [$9797579afd7d961c$var$RETURN_SPA_CODE]: "1"
        });
        $9797579afd7d961c$var$instrumentBrokerParams(parameters, request.correlationId, this.performanceClient);
        $9797579afd7d961c$var$addClaims(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return $9797579afd7d961c$var$mapToQueryString(parameters);
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameters = new Map();
        if (request.postLogoutRedirectUri) $9797579afd7d961c$var$addPostLogoutRedirectUri(parameters, request.postLogoutRedirectUri);
        if (request.correlationId) $9797579afd7d961c$var$addCorrelationId(parameters, request.correlationId);
        if (request.idTokenHint) $9797579afd7d961c$var$addIdTokenHint(parameters, request.idTokenHint);
        if (request.state) $9797579afd7d961c$var$addState(parameters, request.state);
        if (request.logoutHint) $9797579afd7d961c$var$addLogoutHint(parameters, request.logoutHint);
        if (request.popupOriginCheckDone) $9797579afd7d961c$var$addPopupOriginCheckDone(parameters);
        if (request.extraQueryParameters) $9797579afd7d961c$var$addExtraParameters(parameters, request.extraQueryParameters);
        if (this.config.authOptions.instanceAware) $9797579afd7d961c$var$addInstanceAware(parameters);
        return $9797579afd7d961c$var$mapToQueryString(parameters);
    }
    /**
     * Updates the authority to the cloud instance provided in the authorization response
     * @param cloudInstanceHostName - cloud instance host name from authorization code payload
     * @param correlationId - request correlation id
     */ async updateTokenEndpointAuthority(cloudInstanceHostName, correlationId) {
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostName}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await $9797579afd7d961c$var$createDiscoveredInstance(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 * @internal
 */ function $9797579afd7d961c$var$getStandardAuthorizeRequestParameters(authOptions, request, logger, performanceClient) {
    // generate the correlationId if not set by the user and add
    const correlationId = request.correlationId;
    const parameters = new Map();
    $9797579afd7d961c$var$addClientId(parameters, request.embeddedClientId || request.extraQueryParameters?.[$9797579afd7d961c$var$CLIENT_ID] || authOptions.clientId);
    const requestScopes = [
        ...request.scopes || [],
        ...request.extraScopesToConsent || []
    ];
    $9797579afd7d961c$var$addScopes(parameters, requestScopes, request.correlationId, true, authOptions.authority.options.OIDCOptions?.defaultScopes);
    $9797579afd7d961c$var$addResource(parameters, request.resource);
    $9797579afd7d961c$var$addRedirectUri(parameters, request.redirectUri);
    $9797579afd7d961c$var$addCorrelationId(parameters, correlationId);
    // add response_mode. If not passed in it defaults to query.
    $9797579afd7d961c$var$addResponseMode(parameters, request.responseMode);
    // add client_info=1
    $9797579afd7d961c$var$addClientInfo(parameters);
    // add clidata=1
    $9797579afd7d961c$var$addCliData(parameters);
    if (request.prompt) {
        $9797579afd7d961c$var$addPrompt(parameters, request.prompt);
        performanceClient?.addFields({
            prompt: request.prompt
        }, correlationId);
    }
    if (request.domainHint) {
        $9797579afd7d961c$var$addDomainHint(parameters, request.domainHint);
        performanceClient?.addFields({
            domainHintFromRequest: true
        }, correlationId);
    }
    // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
    if (request.prompt !== $9797579afd7d961c$var$PromptValue$1.SELECT_ACCOUNT) {
        // AAD will throw if prompt=select_account is passed with an account hint
        if (request.sid && request.prompt === $9797579afd7d961c$var$PromptValue$1.NONE) {
            // SessionID is only used in silent calls
            logger.verbose("1tvqyx", request.correlationId);
            $9797579afd7d961c$var$addSid(parameters, request.sid);
            performanceClient?.addFields({
                sidFromRequest: true
            }, correlationId);
        } else if (request.account) {
            const accountSid = $9797579afd7d961c$var$extractAccountSid(request.account);
            let accountLoginHintClaim = $9797579afd7d961c$var$extractLoginHint(request.account);
            if (accountLoginHintClaim && request.domainHint) {
                logger.warning("0wkg3v", request.correlationId);
                accountLoginHintClaim = null;
            }
            // If login_hint claim is present, use it over sid/username
            if (accountLoginHintClaim) {
                logger.verbose("1eyfsw", request.correlationId);
                $9797579afd7d961c$var$addLoginHint(parameters, accountLoginHintClaim);
                performanceClient?.addFields({
                    loginHintFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9797579afd7d961c$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (accountSid && request.prompt === $9797579afd7d961c$var$PromptValue$1.NONE) {
                /*
                 * If account and loginHint are provided, we will check account first for sid before adding loginHint
                 * SessionId is only used in silent calls
                 */ logger.verbose("1rmd8s", request.correlationId);
                $9797579afd7d961c$var$addSid(parameters, accountSid);
                performanceClient?.addFields({
                    sidFromClaim: true
                }, correlationId);
                try {
                    const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9797579afd7d961c$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            } else if (request.loginHint) {
                logger.verbose("0y3007", request.correlationId);
                $9797579afd7d961c$var$addLoginHint(parameters, request.loginHint);
                $9797579afd7d961c$var$addCcsUpn(parameters, request.loginHint);
                performanceClient?.addFields({
                    loginHintFromRequest: true
                }, correlationId);
            } else if (request.account.username) {
                // Fallback to account username if provided
                logger.verbose("02f507", request.correlationId);
                $9797579afd7d961c$var$addLoginHint(parameters, request.account.username);
                performanceClient?.addFields({
                    loginHintFromUpn: true
                }, correlationId);
                try {
                    const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(request.account.homeAccountId);
                    $9797579afd7d961c$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    logger.verbose("12ugck", request.correlationId);
                }
            }
        } else if (request.loginHint) {
            logger.verbose("0g01ey", request.correlationId);
            $9797579afd7d961c$var$addLoginHint(parameters, request.loginHint);
            $9797579afd7d961c$var$addCcsUpn(parameters, request.loginHint);
            performanceClient?.addFields({
                loginHintFromRequest: true
            }, correlationId);
        }
    } else logger.verbose("169k9v", request.correlationId);
    if (request.nonce) $9797579afd7d961c$var$addNonce(parameters, request.nonce);
    if (request.state) $9797579afd7d961c$var$addState(parameters, request.state);
    if (request.embeddedClientId) $9797579afd7d961c$var$addBrokerParameters(parameters, authOptions.clientId, authOptions.redirectUri);
    $9797579afd7d961c$var$addClaims(parameters, request.correlationId, request.claims, authOptions.clientCapabilities, request.skipBrokerClaims);
    // If extraQueryParameters includes instance_aware its value will be added when extraQueryParameters are added
    if (authOptions.instanceAware && (!request.extraQueryParameters || !Object.keys(request.extraQueryParameters).includes($9797579afd7d961c$var$INSTANCE_AWARE))) $9797579afd7d961c$var$addInstanceAware(parameters);
    if (request.popupOriginCheckDone) $9797579afd7d961c$var$addPopupOriginCheckDone(parameters);
    return parameters;
}
/**
 * Returns authorize endpoint with given request parameters in the query string
 * @param authority
 * @param requestParameters
 * @returns
 * @internal
 */ function $9797579afd7d961c$var$getAuthorizeUrl(authority, requestParameters) {
    const queryString = $9797579afd7d961c$var$mapToQueryString(requestParameters);
    return $9797579afd7d961c$var$UrlString.appendQueryString(authority.authorizationEndpoint, queryString);
}
/**
 * Handles the hash fragment response from public client code request. Returns a code response used by
 * the client to exchange for a token in acquireToken.
 * @param serverParams
 * @param cachedState
 * @param correlationId
 */ function $9797579afd7d961c$var$getAuthorizationCodePayload(serverParams, cachedState, correlationId) {
    // Get code response
    $9797579afd7d961c$var$validateAuthorizationResponse(serverParams, cachedState, correlationId);
    // throw when there is no auth code in the response
    if (!serverParams.code) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$authorizationCodeMissingFromServerResponse, correlationId);
    return serverParams;
}
/**
 * Function which validates server authorization code response.
 * @param serverResponseHash
 * @param requestState
 * @param correlationId
 */ function $9797579afd7d961c$var$validateAuthorizationResponse(serverResponse, requestState, correlationId) {
    if (!serverResponse.state || !requestState) throw serverResponse.state ? $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$stateNotFound, correlationId, "Cached State") : $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$stateNotFound, correlationId, "Server State");
    let decodedServerResponseState;
    let decodedRequestState;
    try {
        decodedServerResponseState = decodeURIComponent(serverResponse.state);
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidState, correlationId, serverResponse.state);
    }
    try {
        decodedRequestState = decodeURIComponent(requestState);
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidState, correlationId, serverResponse.state);
    }
    if (decodedServerResponseState !== decodedRequestState) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$stateMismatch, correlationId);
    // Check for error
    if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
        const serverErrorNo = $9797579afd7d961c$var$parseServerErrorNo(serverResponse);
        if ($9797579afd7d961c$var$isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new $9797579afd7d961c$var$InteractionRequiredAuthError(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.claims || "", serverErrorNo);
        throw new $9797579afd7d961c$var$ServerError(serverResponse.error || "", serverResponse.correlation_id || correlationId, serverResponse.error_description, serverResponse.suberror, serverErrorNo);
    }
}
/**
 * Get server error No from the error_uri
 * @param serverResponse
 * @returns
 */ function $9797579afd7d961c$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
 * @param account
 */ function $9797579afd7d961c$var$extractAccountSid(account) {
    return account.idTokenClaims?.sid || null;
}
function $9797579afd7d961c$var$extractLoginHint(account) {
    return account.loginHint || account.idTokenClaims?.login_hint || null;
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Starts context by adding payload to the stack
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 */ function $9797579afd7d961c$var$startContext(event, stack) {
    if (!stack) return;
    stack.push({
        name: event.name
    });
}
/**
 * Ends context by removing payload from the stack and returning parent or self, if stack is empty, payload
 *
 * @param event {PerformanceEvent}
 * @param stack {?PerformanceEventStackedContext[]} stack
 * @param error {?unknown} error
 */ function $9797579afd7d961c$var$endContext(event, stack, error) {
    if (!stack?.length) return;
    const peek = (stack)=>{
        return stack.length ? stack[stack.length - 1] : undefined;
    };
    const abbrEventName = event.name;
    const top = peek(stack);
    if (top?.name !== abbrEventName) return;
    const current = stack?.pop();
    if (!current) return;
    const errorCode = error instanceof $9797579afd7d961c$var$AuthError ? error.errorCode : error instanceof Error ? error.name : undefined;
    const subErr = error instanceof $9797579afd7d961c$var$AuthError ? error.subError : undefined;
    if (errorCode && current.childErr !== errorCode) {
        current.err = errorCode;
        if (subErr) current.subErr = subErr;
    }
    delete current.name;
    delete current.childErr;
    const context = {
        ...current,
        dur: event.durationMs
    };
    if (!event.success) context.fail = 1;
    const parent = peek(stack);
    if (!parent) return {
        [abbrEventName]: context
    };
    if (errorCode) parent.childErr = errorCode;
    let childName;
    if (!parent[abbrEventName]) childName = abbrEventName;
    else {
        const siblings = Object.keys(parent).filter((key)=>key.startsWith(abbrEventName)).length;
        childName = `${abbrEventName}_${siblings + 1}`;
    }
    parent[childName] = context;
    return parent;
}
/**
 * Adds error name and stack trace to the telemetry event
 * @param error {Error}
 * @param logger {Logger}
 * @param event {PerformanceEvent}
 * @param stackMaxSize {number} max error stack size to capture
 */ function $9797579afd7d961c$var$addError(error, logger, event, stackMaxSize = 5) {
    if (!(error instanceof Error)) {
        logger.trace("0gcyox", event.correlationId);
        return;
    } else if (error instanceof $9797579afd7d961c$var$AuthError) {
        event.errorCode = error.errorCode;
        event.subErrorCode = error.subError;
        if (!event.serverErrorNo && (error instanceof $9797579afd7d961c$var$ServerError || error instanceof $9797579afd7d961c$var$InteractionRequiredAuthError) && error.errorNo) event.serverErrorNo = error.errorNo;
        return;
    } else if (error instanceof $9797579afd7d961c$var$CacheError) {
        event.errorCode = error.errorCode;
        return;
    } else if (event.errorStack?.length) {
        logger.trace("0lmqrh", event.correlationId);
        return;
    } else if (!error.stack?.length) {
        logger.trace("1cnpwa", event.correlationId);
        return;
    }
    if (error.stack) event.errorStack = $9797579afd7d961c$var$compactStack(error.stack, stackMaxSize);
    event.errorName = error.name;
}
/**
 * Compacts error stack into array by fetching N first entries
 * @param stack {string} error stack
 * @param stackMaxSize {number} max error stack size to capture
 * @returns {string[]}
 */ function $9797579afd7d961c$var$compactStack(stack, stackMaxSize) {
    if (stackMaxSize < 0) return [];
    const stackArr = stack.split("\n") || [];
    const res = [];
    // Check for a handful of known, common runtime errors and log them (with redaction where applicable).
    const firstLine = stackArr[0];
    if (firstLine.startsWith("TypeError: Cannot read property") || firstLine.startsWith("TypeError: Cannot read properties of") || firstLine.startsWith("TypeError: Cannot set property") || firstLine.startsWith("TypeError: Cannot set properties of") || firstLine.endsWith("is not a function")) // These types of errors are not at risk of leaking PII. They will indicate unavailable APIs
    res.push($9797579afd7d961c$var$compactStackLine(firstLine));
    else if (firstLine.startsWith("SyntaxError") || firstLine.startsWith("TypeError")) // Prevent unintentional leaking of arbitrary info by redacting contents between both single and double quotes
    res.push($9797579afd7d961c$var$compactStackLine(// Example: SyntaxError: Unexpected token 'e', "test" is not valid JSON -> SyntaxError: Unexpected token <redacted>, <redacted> is not valid JSON
    firstLine.replace(/['].*[']|["].*["]/g, "<redacted>")));
    // Get top N stack lines
    for(let ix = 1; ix < stackArr.length; ix++){
        if (res.length >= stackMaxSize) break;
        const line = stackArr[ix];
        res.push($9797579afd7d961c$var$compactStackLine(line));
    }
    return res;
}
/**
 * Compacts error stack line by shortening file path
 * Example: https://localhost/msal-common/src/authority/Authority.js:100:1 -> Authority.js:100:1
 * @param line {string} stack line
 * @returns {string}
 */ function $9797579afd7d961c$var$compactStackLine(line) {
    const filePathIx = line.lastIndexOf(" ") + 1;
    if (filePathIx < 1) return line;
    const filePath = line.substring(filePathIx);
    let fileNameIx = filePath.lastIndexOf("/");
    fileNameIx = fileNameIx < 0 ? filePath.lastIndexOf("\\") : fileNameIx;
    if (fileNameIx >= 0) return (line.substring(0, filePathIx) + "(" + filePath.substring(fileNameIx + 1) + (filePath.charAt(filePath.length - 1) === ")" ? "" : ")")).trimStart();
    return line.trimStart();
}
function $9797579afd7d961c$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
class $9797579afd7d961c$var$PerformanceClient {
    /**
     * Creates an instance of PerformanceClient,
     * an abstract class containing core performance telemetry logic.
     *
     * @constructor
     * @param {string} clientId Client ID of the application
     * @param {string} authority Authority used by the application
     * @param {Logger} logger Logger used by the application
     * @param {string} libraryName Name of the library
     * @param {string} libraryVersion Version of the library
     * @param {ApplicationTelemetry} applicationTelemetry application name and version
     * @param {Set<String>} intFields integer fields to be truncated
     */ constructor(clientId, authority, logger, libraryName, libraryVersion, applicationTelemetry, intFields){
        this.authority = authority;
        this.libraryName = libraryName;
        this.libraryVersion = libraryVersion;
        this.globalFields = {};
        this.applicationTelemetry = applicationTelemetry;
        this.clientId = clientId;
        this.logger = logger;
        this.callbacks = new Map();
        this.eventsByCorrelationId = new Map();
        this.eventStack = new Map();
        this.intFields = intFields || new Set();
        for (const item of $9797579afd7d961c$var$IntFields)this.intFields.add(item);
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {InProgressPerformanceEvent}
     */ startMeasurement(measureName, correlationId) {
        // Generate a placeholder correlation if the request does not provide one
        const eventCorrelationId = correlationId || this.generateId();
        const inProgressEvent = {
            eventId: this.generateId(),
            status: $9797579afd7d961c$var$PerformanceEventStatus.InProgress,
            authority: this.authority,
            libraryName: this.libraryName,
            libraryVersion: this.libraryVersion,
            clientId: this.clientId,
            name: measureName,
            startTimeMs: Date.now(),
            correlationId: eventCorrelationId,
            appName: this.applicationTelemetry?.appName,
            appVersion: this.applicationTelemetry?.appVersion
        };
        // Store in progress events so they can be discarded if not ended properly
        this.cacheEventByCorrelationId(inProgressEvent);
        $9797579afd7d961c$var$startContext(inProgressEvent, this.eventStack.get(eventCorrelationId));
        // Return the event and functions the caller can use to properly end/flush the measurement
        return {
            end: (event, error, account)=>{
                return this.endMeasurement({
                    // Initial set of event properties
                    ...inProgressEvent,
                    // Properties set when event ends
                    ...event
                }, error, account);
            },
            discard: ()=>{
                return this.discardMeasurements(inProgressEvent.correlationId);
            },
            add: (fields)=>{
                return this.addFields(fields, inProgressEvent.correlationId);
            },
            increment: (fields)=>{
                return this.incrementFields(fields, inProgressEvent.correlationId);
            },
            event: inProgressEvent
        };
    }
    /**
     * Stops measuring the performance for an operation. Should only be called directly by PerformanceClient classes,
     * as consumers should instead use the function returned by startMeasurement.
     * Adds a new field named as "[event name]DurationMs" for sub-measurements, completes and emits an event
     * otherwise.
     *
     * @param {PerformanceEvent} event
     * @param {unknown} error
     * @param {AccountInfo?} account
     * @returns {(PerformanceEvent | null)}
     */ endMeasurement(event, error, account) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (!rootEvent) {
            this.logger.trace(`0k9ti8 ${event.eventId}`, event.correlationId);
            return null;
        }
        const isRoot = event.eventId === rootEvent.eventId;
        event.durationMs = Math.round(event.durationMs || this.getDurationMs(event.startTimeMs));
        const context = JSON.stringify($9797579afd7d961c$var$endContext(event, this.eventStack.get(rootEvent.correlationId), error));
        if (isRoot) this.discardMeasurements(rootEvent.correlationId);
        else rootEvent.incompleteSubMeasurements?.delete(event.eventId);
        if (error) $9797579afd7d961c$var$addError(error, this.logger, rootEvent);
        // Add sub-measurement attribute to root event's ext field.
        if (!isRoot) {
            rootEvent.ext = {
                ...rootEvent.ext,
                ...event.ext
            };
            rootEvent.ext[event.name + "DurationMs"] = Math.floor(event.durationMs);
            return {
                ...rootEvent
            };
        }
        if (isRoot && !error && (rootEvent.errorCode || rootEvent.subErrorCode)) {
            this.logger.trace(`1fm1tm ${event.name}`, event.correlationId);
            rootEvent.errorCode = undefined;
            rootEvent.subErrorCode = undefined;
        }
        let finalEvent = {
            ...rootEvent,
            ...event
        };
        let incompleteSubsCount = 0;
        // Incomplete sub-measurements are discarded. They are likely an instrumentation bug that should be fixed.
        finalEvent.incompleteSubMeasurements?.forEach((subMeasurement)=>{
            this.logger.trace(`0nxk52 ${subMeasurement.name} ${event.name}`, finalEvent.correlationId);
            incompleteSubsCount++;
        });
        finalEvent.incompleteSubMeasurements = undefined;
        const logs = $9797579afd7d961c$var$getAndFlushLogsFromCache(event.correlationId);
        // Format logs: [millis1,hash1;millis2,hash2;...]
        const formattedLogs = logs.map((logMessage)=>`${logMessage.milliseconds},${logMessage.hash}`).join(";");
        finalEvent = {
            ...finalEvent,
            status: $9797579afd7d961c$var$PerformanceEventStatus.Completed,
            incompleteSubsCount: incompleteSubsCount,
            context: context,
            logs: formattedLogs,
            /*
             * Global fields are spread last so they are always present on the
             * emitted event and never overridden, even when registered after
             * the measurement started.
             */ ...this.globalFields
        };
        if (account) {
            finalEvent.accountType = $9797579afd7d961c$var$getAccountType(account);
            finalEvent.dataBoundary = account.dataBoundary;
        }
        this.truncateIntegralFields(finalEvent);
        this.emitEvents([
            finalEvent
        ], event.correlationId);
        return finalEvent;
    }
    /**
     * Saves extra information to be emitted when the measurements are flushed
     * @param fields
     * @param correlationId
     */ addFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            const staticFields = {};
            const dynamicFields = {};
            for(const key in fields)if (key.startsWith($9797579afd7d961c$var$EXT_FIELD_PREFIX)) {
                const dynamicKey = key.slice($9797579afd7d961c$var$EXT_FIELD_PREFIX.length);
                const value = fields[key];
                if (typeof value === "string" || typeof value === "number") dynamicFields[dynamicKey] = value;
            } else staticFields[key] = fields[key];
            const updatedEvent = {
                ...event,
                ...staticFields
            };
            if (Object.keys(dynamicFields).length) updatedEvent.ext = {
                ...updatedEvent.ext,
                ...dynamicFields
            };
            this.eventsByCorrelationId.set(correlationId, updatedEvent);
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Saves fields to be emitted on every event measured by this client.
     * Unlike addFields, these are not scoped to a single correlationId and persist for the
     * lifetime of the client (e.g. previousLibraryVersion for upgrade/downgrade telemetry).
     * @param fields
     */ addGlobalFields(fields) {
        this.globalFields = {
            ...this.globalFields,
            ...fields
        };
    }
    /**
     * Increment counters to be emitted when the measurements are flushed
     * @param fields {string[]}
     * @param correlationId {string} correlation identifier
     */ incrementFields(fields, correlationId) {
        const event = this.eventsByCorrelationId.get(correlationId);
        if (event) {
            for(const counter in fields)if (counter.startsWith($9797579afd7d961c$var$EXT_FIELD_PREFIX)) {
                event.ext = event.ext || {};
                // Route to ext sub-object
                const dynamicKey = counter.slice($9797579afd7d961c$var$EXT_FIELD_PREFIX.length);
                const currentValue = event.ext[dynamicKey];
                if (currentValue === undefined) event.ext[dynamicKey] = 0;
                else if (isNaN(Number(currentValue))) return;
                event.ext[dynamicKey] = (Number(event.ext[dynamicKey]) || 0) + (fields[counter] ?? 0);
            } else {
                /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal dispatching of static fields by name */ if (!event.hasOwnProperty(counter)) event[counter] = 0;
                else if (isNaN(Number(event[counter]))) return;
                event[counter] += fields[counter];
            /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ }
        } else this.logger.trace("0thl6s", correlationId);
    }
    /**
     * Upserts event into event cache.
     * First key is the correlation id, second key is the event id.
     * Allows for events to be grouped by correlation id,
     * and to easily allow for properties on them to be updated.
     *
     * @private
     * @param {PerformanceEvent} event
     */ cacheEventByCorrelationId(event) {
        const rootEvent = this.eventsByCorrelationId.get(event.correlationId);
        if (rootEvent) {
            rootEvent.incompleteSubMeasurements = rootEvent.incompleteSubMeasurements || new Map();
            rootEvent.incompleteSubMeasurements.set(event.eventId, {
                name: event.name,
                startTimeMs: event.startTimeMs
            });
        } else {
            this.eventsByCorrelationId.set(event.correlationId, {
                ...event
            });
            this.eventStack.set(event.correlationId, []);
        }
    }
    /**
     * Removes measurements and aux data for a given correlation id.
     *
     * @param {string} correlationId
     */ discardMeasurements(correlationId) {
        this.eventsByCorrelationId.delete(correlationId);
        this.eventStack.delete(correlationId);
    }
    /**
     * Registers a callback function to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        for (const [id, cb] of this.callbacks)if (cb.toString() === callback.toString()) {
            this.logger.warning(`1eap5p ${id}`, "");
            return id;
        }
        const callbackId = this.generateId();
        this.callbacks.set(callbackId, callback);
        this.logger.verbose(`0c9ujz ${callbackId}`, "");
        return callbackId;
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        const result = this.callbacks.delete(callbackId);
        if (result) this.logger.verbose(`0253if ${callbackId}`, "");
        else this.logger.verbose(`0iqk07 ${callbackId}`, "");
        return result;
    }
    /**
     * Emits events to all registered callbacks.
     *
     * @param {PerformanceEvent[]} events
     * @param {?string} [correlationId]
     */ emitEvents(events, correlationId) {
        this.logger.verbose("11jb1y", correlationId);
        this.callbacks.forEach((callback, callbackId)=>{
            this.logger.trace(`0p2pjl ${callbackId}`, correlationId);
            callback.apply(null, [
                events
            ]);
        });
    }
    /**
     * Enforce truncation of integral fields in performance event.
     * @param {PerformanceEvent} event performance event to update.
     */ truncateIntegralFields(event) {
        this.intFields.forEach((key)=>{
            /* eslint-disable custom-msal/no-dynamic-telemetry-fields -- internal truncation of known integer fields */ if (key in event && typeof event[key] === "number") event[key] = Math.floor(event[key]);
        /* eslint-enable custom-msal/no-dynamic-telemetry-fields */ });
    }
    /**
     * Returns event duration in milliseconds
     * @param startTimeMs {number}
     * @returns {number}
     */ getDurationMs(startTimeMs) {
        const durationMs = Date.now() - startTimeMs;
        // Handle clock skew
        return durationMs < 0 ? durationMs : 0;
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $9797579afd7d961c$var$RefreshTokenClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = $9797579afd7d961c$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9797579afd7d961c$var$Logger(this.config.loggerOptions, $9797579afd7d961c$var$name$1, $9797579afd7d961c$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    async acquireToken(request, apiId) {
        const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
        const response = await $9797579afd7d961c$var$invokeAsync(this.executeTokenRequest.bind(this), $9797579afd7d961c$var$RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[$9797579afd7d961c$var$HeaderNames.X_MS_REQUEST_ID];
        const responseHandler = new $9797579afd7d961c$var$ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.performanceClient, this.config.serializableCache, this.config.persistencePlugin, this.config.tokenBindingKeyManager);
        responseHandler.validateTokenResponse(response.body, request.correlationId);
        return $9797579afd7d961c$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9797579afd7d961c$var$HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, apiId, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request, apiId) {
        // Cannot renew token if no request object is given.
        if (!request) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$tokenRequestEmpty, "");
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noAccountInSilentRequest, request.correlationId);
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, request.correlationId);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await $9797579afd7d961c$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9797579afd7d961c$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true, apiId);
        } catch (e) {
            const noFamilyRTInCache = e instanceof $9797579afd7d961c$var$InteractionRequiredAuthError && e.errorCode === $9797579afd7d961c$var$noTokensFound;
            const clientMismatchErrorWithFamilyRT = e instanceof $9797579afd7d961c$var$ServerError && e.errorCode === $9797579afd7d961c$var$INVALID_GRANT_ERROR && e.subError === $9797579afd7d961c$var$CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return $9797579afd7d961c$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9797579afd7d961c$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return $9797579afd7d961c$var$invokeAsync(this.acquireTokenWithCachedRefreshToken.bind(this), $9797579afd7d961c$var$RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false, apiId);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci, apiId) {
        // fetches family RT or application RT based on FOCI value
        const refreshToken = $9797579afd7d961c$var$invoke(this.cacheManager.getRefreshToken.bind(this.cacheManager), $9797579afd7d961c$var$CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined);
        if (!refreshToken) throw $9797579afd7d961c$var$createInteractionRequiredAuthError($9797579afd7d961c$var$noTokensFound, request.correlationId);
        if (refreshToken.expiresOn) {
            const offset = request.refreshTokenExpirationOffsetSeconds || $9797579afd7d961c$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS;
            this.performanceClient?.addFields({
                cacheRtExpiresOnSeconds: Number(refreshToken.expiresOn),
                rtOffsetSeconds: offset
            }, request.correlationId);
            if ($9797579afd7d961c$var$isTokenExpired(refreshToken.expiresOn, offset)) throw $9797579afd7d961c$var$createInteractionRequiredAuthError($9797579afd7d961c$var$refreshTokenExpired, request.correlationId);
        }
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID
            }
        };
        if (refreshTokenRequest.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP && !refreshTokenRequest.dpopJkt) {
            const dpopProofGenerator = new $9797579afd7d961c$var$DpopProofGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager);
            refreshTokenRequest.dpopJkt = await dpopProofGenerator.generateJkt(request.correlationId);
        }
        try {
            return await $9797579afd7d961c$var$invokeAsync(this.acquireToken.bind(this), $9797579afd7d961c$var$RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest, apiId);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$InteractionRequiredAuthError) {
                if (e.subError === $9797579afd7d961c$var$badToken) {
                    // Remove bad refresh token from cache
                    this.logger.verbose("1pg3ap", request.correlationId);
                    const badRefreshTokenKey = this.cacheManager.generateCredentialKey(refreshToken);
                    this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
                }
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        const queryParametersString = $9797579afd7d961c$var$createTokenQueryParameters(request, this.config.authOptions.clientId, this.config.authOptions.redirectUri, this.performanceClient);
        const endpoint = $9797579afd7d961c$var$UrlString.appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await $9797579afd7d961c$var$invokeAsync(this.createTokenRequestBody.bind(this), $9797579afd7d961c$var$RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = $9797579afd7d961c$var$createTokenRequestHeaders(this.logger, this.config.systemOptions.preventCorsPreflight, request.ccsCredential);
        await $9797579afd7d961c$var$addDpopTokenProofHeader(headers, request, endpoint, this.cryptoUtils, this.config.tokenBindingKeyManager);
        const thumbprint = $9797579afd7d961c$var$getRequestThumbprint(this.config.authOptions.clientId, request);
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$executePostToTokenEndpoint, $9797579afd7d961c$var$RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, this.cacheManager, this.networkClient, this.logger, this.performanceClient, this.serverTelemetryManager);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        const parameters = new Map();
        $9797579afd7d961c$var$addClientId(parameters, request.embeddedClientId || request.extraParameters?.[$9797579afd7d961c$var$CLIENT_ID] || this.config.authOptions.clientId);
        if (request.redirectUri) $9797579afd7d961c$var$addRedirectUri(parameters, request.redirectUri);
        $9797579afd7d961c$var$addScopes(parameters, request.scopes, request.correlationId, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        $9797579afd7d961c$var$addResource(parameters, request.resource);
        $9797579afd7d961c$var$addGrantType(parameters, $9797579afd7d961c$var$GrantType.REFRESH_TOKEN_GRANT);
        $9797579afd7d961c$var$addClientInfo(parameters);
        $9797579afd7d961c$var$addLibraryInfo(parameters, this.config.libraryInfo);
        $9797579afd7d961c$var$addApplicationTelemetry(parameters, this.config.telemetry.application);
        $9797579afd7d961c$var$addThrottling(parameters);
        if (this.serverTelemetryManager && !$9797579afd7d961c$var$isOidcProtocolMode(this.config)) $9797579afd7d961c$var$addServerTelemetry(parameters, this.serverTelemetryManager);
        $9797579afd7d961c$var$addRefreshToken(parameters, request.refreshToken);
        if (request.attributeTokens) $9797579afd7d961c$var$addAttributeTokens(parameters, request.attributeTokens);
        this.performanceClient?.addFields({
            hasAttributeTokens: !!request.attributeTokens?.length
        }, request.correlationId);
        if (this.config.clientCredentials.clientSecret) $9797579afd7d961c$var$addClientSecret(parameters, this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            $9797579afd7d961c$var$addClientAssertion(parameters, await $9797579afd7d961c$var$getClientAssertion(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            $9797579afd7d961c$var$addClientAssertionType(parameters, clientAssertion.assertionType);
        }
        if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.POP) {
            const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(this.cryptoUtils, this.config.tokenBindingKeyManager, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await $9797579afd7d961c$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9797579afd7d961c$var$PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            $9797579afd7d961c$var$addPopToken(parameters, reqCnfData);
        } else if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.SSH) {
            if (request.sshJwk) $9797579afd7d961c$var$addSshJwk(parameters, request.sshJwk);
            else throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$missingSshJwk, request.correlationId);
        }
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID:
                try {
                    const clientInfo = $9797579afd7d961c$var$buildClientInfoFromHomeAccountId(request.ccsCredential.credential);
                    $9797579afd7d961c$var$addCcsOid(parameters, clientInfo);
                } catch (e) {
                    this.logger.verbose(`1qhtee ${e}`, request.correlationId);
                }
                break;
            case $9797579afd7d961c$var$CcsCredentialType.UPN:
                $9797579afd7d961c$var$addCcsUpn(parameters, request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) $9797579afd7d961c$var$addBrokerParameters(parameters, this.config.authOptions.clientId, this.config.authOptions.redirectUri);
        if (request.extraParameters) $9797579afd7d961c$var$addExtraParameters(parameters, {
            ...request.extraParameters
        });
        $9797579afd7d961c$var$instrumentBrokerParams(parameters, request.correlationId, this.performanceClient);
        $9797579afd7d961c$var$addClaims(parameters, request.correlationId, request.claims, this.config.authOptions.clientCapabilities, request.skipBrokerClaims);
        return $9797579afd7d961c$var$mapToQueryString(parameters);
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$skuGroupSeparator = ",";
const $9797579afd7d961c$var$skuValueSeparator = "|";
function $9797579afd7d961c$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($9797579afd7d961c$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$9797579afd7d961c$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $9797579afd7d961c$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($9797579afd7d961c$var$skuGroupSeparator);
}
function $9797579afd7d961c$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($9797579afd7d961c$var$skuValueSeparator);
}
/** @internal */ class $9797579afd7d961c$var$ServerTelemetryManager {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = $9797579afd7d961c$var$CacheOutcome.NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || "";
        this.wrapperVer = telemetryRequest.wrapperVer || "";
        this.telemetryCacheKey = $9797579afd7d961c$var$SERVER_TELEM_CACHE_KEY + $9797579afd7d961c$var$CACHE_KEY_SEPARATOR$1 + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${$9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join($9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join($9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR);
        return [
            $9797579afd7d961c$var$SERVER_TELEM_SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join($9797579afd7d961c$var$SERVER_TELEM_CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $9797579afd7d961c$var$ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join($9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join($9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? $9797579afd7d961c$var$SERVER_TELEM_OVERFLOW_TRUE : $9797579afd7d961c$var$SERVER_TELEM_OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join($9797579afd7d961c$var$SERVER_TELEM_VALUE_SEPARATOR);
        return [
            $9797579afd7d961c$var$SERVER_TELEM_SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join($9797579afd7d961c$var$SERVER_TELEM_CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        try {
            const lastRequests = this.getLastRequests();
            if (lastRequests.errors.length >= $9797579afd7d961c$var$SERVER_TELEM_MAX_CACHED_ERRORS) {
                // Remove a cached error to make room, first in first out
                lastRequests.failedRequests.shift(); // apiId
                lastRequests.failedRequests.shift(); // correlationId
                lastRequests.errors.shift();
            }
            lastRequests.failedRequests.push(this.apiId, this.correlationId);
            if (error instanceof Error && !!error && error.toString()) {
                if (error instanceof $9797579afd7d961c$var$AuthError) {
                    if (error.subError) lastRequests.errors.push(error.subError);
                    else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                    else lastRequests.errors.push(error.toString());
                } else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push($9797579afd7d961c$var$SERVER_TELEM_UNKNOWN_ERROR);
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        } catch  {
        // Ignore telemetry cache failures to avoid masking the original auth error path.
        }
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey, this.correlationId);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $9797579afd7d961c$var$ServerTelemetryManager.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || "";
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || "";
            const errorCode = serverTelemetryEntity.errors[i] || "";
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < $9797579afd7d961c$var$SERVER_TELEM_MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || "");
        regionDiscoveryFields.push(this.regionSource || "");
        regionDiscoveryFields.push(this.regionOutcome || "");
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $9797579afd7d961c$var$makeExtraSkuString(params);
    }
}
/** @internal */ class $9797579afd7d961c$var$StubServerTelemetryManager extends $9797579afd7d961c$var$ServerTelemetryManager {
    constructor(){
        super({
            clientId: "",
            apiId: 0,
            correlationId: "",
            forceRefresh: false
        }, {});
    }
    generateCurrentRequestHeaderValue() {
        return "";
    }
    generateLastRequestHeaderValue() {
        return "";
    }
    cacheFailedRequest() {}
    incrementCacheHits() {
        return 0;
    }
    clearTelemetryCache() {}
    getRegionDiscoveryFields() {
        return "";
    }
    updateRegionDiscoveryMetadata() {}
    setCacheOutcome() {}
    setNativeBrokerErrorCode() {}
    getNativeBrokerErrorCode() {
        return undefined;
    }
    clearNativeBrokerErrorCode() {}
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $9797579afd7d961c$var$SilentFlowClient {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = $9797579afd7d961c$var$buildClientConfiguration(configuration);
        // Initialize the logger
        this.logger = new $9797579afd7d961c$var$Logger(this.config.loggerOptions, $9797579afd7d961c$var$name$1, $9797579afd7d961c$var$version$1);
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        let lastCacheOutcome = $9797579afd7d961c$var$CacheOutcome.NOT_APPLICABLE;
        if (request.forceRefresh || !$9797579afd7d961c$var$StringUtils.isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noAccountInSilentRequest, request.correlationId);
        const requestTenantId = request.account.tenantId || $9797579afd7d961c$var$getTenantFromAuthorityString(request.authority, request.correlationId);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
        } else if ($9797579afd7d961c$var$wasClockTurnedBack(cachedAccessToken.cachedAt) || $9797579afd7d961c$var$isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
        } else if (request.resource) // cached access token must have a resource that matches the request resource for MCP scenarios
        {
            if (cachedAccessToken.resource !== request.resource) {
                this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
            }
        } else if (cachedAccessToken.refreshOn && $9797579afd7d961c$var$isTokenExpired(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = $9797579afd7d961c$var$CacheOutcome.PROACTIVELY_REFRESHED;
        const cachedAccessTokenType = cachedAccessToken.tokenType?.toLowerCase();
        if (cachedAccessTokenType === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase()) {
            if (!cachedAccessToken.keyId) {
                this.logger.info("1enswf", request.correlationId);
                this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
            }
            try {
                await this.config.tokenBindingKeyManager.getTokenBindingPublicKeyJwk(cachedAccessToken.keyId, request.correlationId);
            } catch  {
                this.logger.info("14djth", request.correlationId);
                this.setCacheOutcome($9797579afd7d961c$var$CacheOutcome.NO_CACHED_ACCESS_TOKEN, request.correlationId);
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, request.correlationId);
            }
        }
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.getAccount(this.cacheManager.generateAccountKey(request.account), request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment, request.correlationId)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await $9797579afd7d961c$var$invokeAsync(this.generateResultFromCacheRecord.bind(this), $9797579afd7d961c$var$SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== $9797579afd7d961c$var$CacheOutcome.NOT_APPLICABLE) this.logger.info(`09ingz ${cacheOutcome}`, correlationId);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode, request.correlationId);
        return $9797579afd7d961c$var$ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, this.performanceClient, {
            idTokenClaims: idTokenClaims,
            tokenBindingKeyManager: this.config.tokenBindingKeyManager
        });
    }
}
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$StubbedNetworkModule = {
    // Module-level singleton: no per-request correlationId available
    sendGetRequestAsync: ()=>{
        return Promise.reject($9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, ""));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject($9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, ""));
    }
};
/*! @azure/msal-common v16.15.0 2026-10-27 */ /*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Helper to enforce resource parameter presence in token requests when isMcp is set in the configuration.
 * If resource parameter is set in both the request and in extraQueryParameters or extraParameters, an error will be thrown.
 * This is used for MCP flows.
 * @param isMcp - Flag indicating if application is an MCP app, from configuration
 * @param request - Auth request
 */ function $9797579afd7d961c$var$enforceResourceParameter(isMcp, request) {
    if (!isMcp) return;
    if (request.resource && ($9797579afd7d961c$var$containsResourceParam(request.extraParameters) || $9797579afd7d961c$var$containsResourceParam(request.extraQueryParameters))) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$misplacedResourceParam, request.correlationId || "");
    if (!request.resource) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$resourceParameterRequired, request.correlationId || "");
}
function $9797579afd7d961c$var$containsResourceParam(params) {
    if (!params) return false;
    return Object.prototype.hasOwnProperty.call(params, "resource");
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenFromCache (msal-browser).
 * Internal API for acquiring token from cache
 */ const $9797579afd7d961c$var$AcquireTokenFromCache = "acquireTokenFromCache";
/**
 * acquireTokenByRefreshToken API (msal-browser and msal-node).
 * Used to renew an access token using a refresh token against the token endpoint.
 */ const $9797579afd7d961c$var$AcquireTokenByRefreshToken = "acquireTokenByRefreshToken";
/**
 * acquireTokenSilentAsync (msal-browser).
 * Internal API for acquireTokenSilent.
 */ const $9797579afd7d961c$var$AcquireTokenSilentAsync = "acquireTokenSilentAsync";
/**
 * provisionTokenBindingKey API in TokenBindingKeyManager class (msal-browser).
 * Used to provision token-binding key material and return a key identifier.
 */ const $9797579afd7d961c$var$CryptoOptsGetPublicKeyThumbprint = "cryptoOptsGetPublicKeyThumbprint";
/**
 * signTokenBindingJwt API in CryptoOpts class (msal-browser).
 * Used to sign token-binding JWTs.
 */ const $9797579afd7d961c$var$CryptoOptsSignJwt = "cryptoOptsSignJwt";
/**
 * acquireToken API in the SilentCacheClient class (msal-browser).
 * Used to read access tokens from the cache.
 */ const $9797579afd7d961c$var$SilentCacheClientAcquireToken = "silentCacheClientAcquireToken";
/**
 * acquireToken API in the SilentIframeClient class (msal-browser).
 * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
 */ const $9797579afd7d961c$var$SilentIframeClientAcquireToken = "silentIframeClientAcquireToken";
const $9797579afd7d961c$var$AwaitConcurrentIframe = "awaitConcurrentIframe"; // Time spent waiting for a concurrent iframe to complete
/**
 * acquireToken API in SilentRereshClient (msal-browser).
 * Used to acquire a new set of tokens from the token endpoint using a refresh token.
 */ const $9797579afd7d961c$var$SilentRefreshClientAcquireToken = "silentRefreshClientAcquireToken";
/**
 * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
 * Used to load authority metadata for a request.
 */ const $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority = "standardInteractionClientGetDiscoveredAuthority";
/**
 * acquireToken API in NativeInteractionClient class (msal-browser).
 * Used to acquire a token from Native component when native brokering is enabled.
 */ const $9797579afd7d961c$var$NativeInteractionClientAcquireToken = "nativeInteractionClientAcquireToken";
const $9797579afd7d961c$var$NativeInteractionClientAcquireTokenRedirect = "nativeInteractionClientAcquireToken";
/**
 * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
 */ const $9797579afd7d961c$var$RefreshTokenClientAcquireTokenByRefreshToken = "refreshTokenClientAcquireTokenByRefreshToken";
/**
 * acquireTokenBySilentIframe (msal-browser).
 * Internal API for acquiring token by silent Iframe
 */ const $9797579afd7d961c$var$AcquireTokenBySilentIframe = "acquireTokenBySilentIframe";
/**
 * Internal API for initializing base request in BaseInteractionClient (msal-browser)
 */ const $9797579afd7d961c$var$InitializeBaseRequest = "initializeBaseRequest";
/**
 * Internal API for initializing silent request in SilentCacheClient (msal-browser)
 */ const $9797579afd7d961c$var$InitializeSilentRequest = "initializeSilentRequest";
const $9797579afd7d961c$var$InitializeCache = "initializeCache";
/**
 * Helper function in SilentIframeClient class (msal-browser).
 */ const $9797579afd7d961c$var$SilentIframeClientTokenHelper = "silentIframeClientTokenHelper";
/**
 * SilentHandler
 */ const $9797579afd7d961c$var$SilentHandlerInitiateAuthRequest = "silentHandlerInitiateAuthRequest";
const $9797579afd7d961c$var$SilentHandlerMonitorIframeForHash = "silentHandlerMonitorIframeForHash";
/**
 * Helper functions in StandardInteractionClient class (msal-browser)
 */ const $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient = "standardInteractionClientCreateAuthCodeClient";
const $9797579afd7d961c$var$StandardInteractionClientGetClientConfiguration = "standardInteractionClientGetClientConfiguration";
const $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest = "standardInteractionClientInitializeAuthorizationRequest";
const $9797579afd7d961c$var$SilentFlowClientAcquireCachedToken = "silentFlowClientAcquireCachedToken";
const $9797579afd7d961c$var$GetStandardParams = "getStandardParams";
const $9797579afd7d961c$var$HandleCodeResponse = "handleCodeResponse";
const $9797579afd7d961c$var$HandleResponseEar = "handleResponseEar";
const $9797579afd7d961c$var$HandleResponsePlatformBroker = "handleResponsePlatformBroker";
const $9797579afd7d961c$var$HandleResponseCode = "handleResponseCode";
const $9797579afd7d961c$var$AuthClientAcquireToken = "authClientAcquireToken";
const $9797579afd7d961c$var$DeserializeResponse = "deserializeResponse";
const $9797579afd7d961c$var$AuthorityFactoryCreateDiscoveredInstance = "authorityFactoryCreateDiscoveredInstance";
const $9797579afd7d961c$var$AcquireTokenByCodeAsync = "acquireTokenByCodeAsync";
const $9797579afd7d961c$var$HandleRedirectPromiseMeasurement = "handleRedirectPromise";
const $9797579afd7d961c$var$HandleNativeRedirectPromiseMeasurement = "handleNativeRedirectPromise";
const $9797579afd7d961c$var$NativeMessageHandlerHandshake = "nativeMessageHandlerHandshake";
const $9797579afd7d961c$var$NativeGenerateAuthResult = "nativeGenerateAuthResult";
const $9797579afd7d961c$var$PlatformAuthProviderDiscovery = "platformAuthProviderDiscovery";
const $9797579afd7d961c$var$PlatformAuthDOMCreateProvider = "platformAuthDOMCreateProvider";
const $9797579afd7d961c$var$PlatformAuthDOMGetSupportedContracts = "platformAuthDOMGetSupportedContracts";
const $9797579afd7d961c$var$PlatformAuthDOMInitializeRequest = "platformAuthDOMInitializeRequest";
const $9797579afd7d961c$var$PlatformAuthDOMGetToken = "platformAuthDOMGetToken";
const $9797579afd7d961c$var$PlatformAuthDOMValidateResponse = "platformAuthDOMValidateResponse";
const $9797579afd7d961c$var$PlatformAuthExtensionCreateProvider = "platformAuthExtensionCreateProvider";
const $9797579afd7d961c$var$PlatformAuthExtensionGetToken = "platformAuthExtensionGetToken";
const $9797579afd7d961c$var$PlatformAuthExtensionValidateResponse = "platformAuthExtensionValidateResponse";
const $9797579afd7d961c$var$PlatformAuthInteractionClientInitializeRequest = "platformAuthInteractionClientInitializeRequest";
const $9797579afd7d961c$var$PlatformAuthHandleNativeResponse = "platformAuthHandleNativeResponse";
const $9797579afd7d961c$var$PlatformAuthCacheAccount = "platformAuthCacheAccount";
const $9797579afd7d961c$var$PlatformAuthCacheNativeTokens = "platformAuthCacheNativeTokens";
const $9797579afd7d961c$var$RemoveHiddenIframe = "removeHiddenIframe";
const $9797579afd7d961c$var$ImportExistingCache = "importExistingCache";
/**
 * Crypto Operations
 */ const $9797579afd7d961c$var$GeneratePkceCodes = "generatePkceCodes";
const $9797579afd7d961c$var$GenerateCodeVerifier = "generateCodeVerifier";
const $9797579afd7d961c$var$GenerateCodeChallengeFromVerifier = "generateCodeChallengeFromVerifier";
const $9797579afd7d961c$var$Sha256Digest = "sha256Digest";
const $9797579afd7d961c$var$GetRandomValues = "getRandomValues";
const $9797579afd7d961c$var$GenerateHKDF = "generateHKDF";
const $9797579afd7d961c$var$GenerateBaseKey = "generateBaseKey";
const $9797579afd7d961c$var$Base64Decode = "base64Decode";
const $9797579afd7d961c$var$UrlEncodeArr = "urlEncodeArr";
const $9797579afd7d961c$var$Encrypt = "encrypt";
const $9797579afd7d961c$var$Decrypt = "decrypt";
const $9797579afd7d961c$var$GenerateEarKey = "generateEarKey";
const $9797579afd7d961c$var$DecryptEarResponse = "decryptEarResponse";
const $9797579afd7d961c$var$LoadAccount = "loadAccount";
const $9797579afd7d961c$var$LoadIdToken = "loadIdToken";
const $9797579afd7d961c$var$LoadAccessToken = "loadAccessToken";
const $9797579afd7d961c$var$LoadRefreshToken = "loadRefreshToken";
/**
 * Background telemetry measurement that tracks whether a late bridge response
 * arrives after the iframe timeout has already fired.
 */ const $9797579afd7d961c$var$WaitForBridgeLateResponse$1 = "waitForBridgeLateResponse";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$pkceNotCreated = "pkce_not_created";
const $9797579afd7d961c$var$earJwkEmpty = "ear_jwk_empty";
const $9797579afd7d961c$var$earJweEmpty = "ear_jwe_empty";
const $9797579afd7d961c$var$cryptoNonExistent = "crypto_nonexistent";
const $9797579afd7d961c$var$emptyNavigateUri = "empty_navigate_uri";
const $9797579afd7d961c$var$hashEmptyError = "hash_empty_error";
const $9797579afd7d961c$var$noStateInHash = "no_state_in_hash";
const $9797579afd7d961c$var$hashDoesNotContainKnownProperties = "hash_does_not_contain_known_properties";
const $9797579afd7d961c$var$unableToParseState = "unable_to_parse_state";
const $9797579afd7d961c$var$stateInteractionTypeMismatch = "state_interaction_type_mismatch";
const $9797579afd7d961c$var$interactionInProgress = "interaction_in_progress";
const $9797579afd7d961c$var$interactionInProgressCancelled = "interaction_in_progress_cancelled";
const $9797579afd7d961c$var$popupWindowError = "popup_window_error";
const $9797579afd7d961c$var$emptyWindowError = "empty_window_error";
const $9797579afd7d961c$var$userCancelled = "user_cancelled";
const $9797579afd7d961c$var$redirectBridgeEmptyResponse = "redirect_bridge_empty_response";
const $9797579afd7d961c$var$redirectInIframe = "redirect_in_iframe";
const $9797579afd7d961c$var$blockIframeReload = "block_iframe_reload";
const $9797579afd7d961c$var$blockNestedPopups = "block_nested_popups";
const $9797579afd7d961c$var$popupRelayUnsupportedFlow = "popup_relay_unsupported_flow";
const $9797579afd7d961c$var$iframeClosedPrematurely = "iframe_closed_prematurely";
const $9797579afd7d961c$var$silentLogoutUnsupported = "silent_logout_unsupported";
const $9797579afd7d961c$var$noAccountError = "no_account_error";
const $9797579afd7d961c$var$silentPromptValueError = "silent_prompt_value_error";
const $9797579afd7d961c$var$noTokenRequestCacheError = "no_token_request_cache_error";
const $9797579afd7d961c$var$unableToParseTokenRequestCacheError = "unable_to_parse_token_request_cache_error";
const $9797579afd7d961c$var$authRequestNotSetError = "auth_request_not_set_error";
const $9797579afd7d961c$var$invalidCacheType = "invalid_cache_type";
const $9797579afd7d961c$var$nonBrowserEnvironment = "non_browser_environment";
const $9797579afd7d961c$var$databaseNotOpen = "database_not_open";
const $9797579afd7d961c$var$noNetworkConnectivity = "no_network_connectivity";
const $9797579afd7d961c$var$postRequestFailed = "post_request_failed";
const $9797579afd7d961c$var$getRequestFailed = "get_request_failed";
const $9797579afd7d961c$var$failedToParseResponse = "failed_to_parse_response";
const $9797579afd7d961c$var$unableToLoadToken = "unable_to_load_token";
const $9797579afd7d961c$var$cryptoKeyNotFound = "crypto_key_not_found";
const $9797579afd7d961c$var$invalidPublicJwk = "invalid_public_jwk";
const $9797579afd7d961c$var$authCodeRequired = "auth_code_required";
const $9797579afd7d961c$var$authCodeOrNativeAccountIdRequired = "auth_code_or_nativeAccountId_required";
const $9797579afd7d961c$var$spaCodeAndNativeAccountIdPresent = "spa_code_and_nativeAccountId_present";
const $9797579afd7d961c$var$databaseUnavailable = "database_unavailable";
const $9797579afd7d961c$var$unableToAcquireTokenFromNativePlatform = "unable_to_acquire_token_from_native_platform";
const $9797579afd7d961c$var$nativeHandshakeTimeout = "native_handshake_timeout";
const $9797579afd7d961c$var$nativeExtensionNotInstalled = "native_extension_not_installed";
const $9797579afd7d961c$var$nativeConnectionNotEstablished = "native_connection_not_established";
const $9797579afd7d961c$var$uninitializedPublicClientApplication = "uninitialized_public_client_application";
const $9797579afd7d961c$var$nativePromptNotSupported = "native_prompt_not_supported";
const $9797579afd7d961c$var$invalidBase64String = "invalid_base64_string";
const $9797579afd7d961c$var$invalidPopTokenRequest = "invalid_pop_token_request";
const $9797579afd7d961c$var$unsupportedTokenBindingAlgorithm = "unsupported_token_binding_algorithm";
const $9797579afd7d961c$var$tokenBindingKeyAlgorithmMismatch = "token_binding_key_algorithm_mismatch";
const $9797579afd7d961c$var$tokenBindingKeyJwkThumbprintMismatch = "token_binding_key_jwk_thumbprint_mismatch";
const $9797579afd7d961c$var$failedToBuildHeaders = "failed_to_build_headers";
const $9797579afd7d961c$var$failedToParseHeaders = "failed_to_parse_headers";
const $9797579afd7d961c$var$failedToDecryptEarResponse = "failed_to_decrypt_ear_response";
const $9797579afd7d961c$var$timedOut = "timed_out";
const $9797579afd7d961c$var$emptyResponse = "empty_response";
var $9797579afd7d961c$var$BrowserAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    authCodeOrNativeAccountIdRequired: $9797579afd7d961c$var$authCodeOrNativeAccountIdRequired,
    authCodeRequired: $9797579afd7d961c$var$authCodeRequired,
    authRequestNotSetError: $9797579afd7d961c$var$authRequestNotSetError,
    blockIframeReload: $9797579afd7d961c$var$blockIframeReload,
    blockNestedPopups: $9797579afd7d961c$var$blockNestedPopups,
    cryptoKeyNotFound: $9797579afd7d961c$var$cryptoKeyNotFound,
    cryptoNonExistent: $9797579afd7d961c$var$cryptoNonExistent,
    databaseNotOpen: $9797579afd7d961c$var$databaseNotOpen,
    databaseUnavailable: $9797579afd7d961c$var$databaseUnavailable,
    earJweEmpty: $9797579afd7d961c$var$earJweEmpty,
    earJwkEmpty: $9797579afd7d961c$var$earJwkEmpty,
    emptyNavigateUri: $9797579afd7d961c$var$emptyNavigateUri,
    emptyResponse: $9797579afd7d961c$var$emptyResponse,
    emptyWindowError: $9797579afd7d961c$var$emptyWindowError,
    failedToBuildHeaders: $9797579afd7d961c$var$failedToBuildHeaders,
    failedToDecryptEarResponse: $9797579afd7d961c$var$failedToDecryptEarResponse,
    failedToParseHeaders: $9797579afd7d961c$var$failedToParseHeaders,
    failedToParseResponse: $9797579afd7d961c$var$failedToParseResponse,
    getRequestFailed: $9797579afd7d961c$var$getRequestFailed,
    hashDoesNotContainKnownProperties: $9797579afd7d961c$var$hashDoesNotContainKnownProperties,
    hashEmptyError: $9797579afd7d961c$var$hashEmptyError,
    iframeClosedPrematurely: $9797579afd7d961c$var$iframeClosedPrematurely,
    interactionInProgress: $9797579afd7d961c$var$interactionInProgress,
    interactionInProgressCancelled: $9797579afd7d961c$var$interactionInProgressCancelled,
    invalidBase64String: $9797579afd7d961c$var$invalidBase64String,
    invalidCacheType: $9797579afd7d961c$var$invalidCacheType,
    invalidPopTokenRequest: $9797579afd7d961c$var$invalidPopTokenRequest,
    invalidPublicJwk: $9797579afd7d961c$var$invalidPublicJwk,
    nativeConnectionNotEstablished: $9797579afd7d961c$var$nativeConnectionNotEstablished,
    nativeExtensionNotInstalled: $9797579afd7d961c$var$nativeExtensionNotInstalled,
    nativeHandshakeTimeout: $9797579afd7d961c$var$nativeHandshakeTimeout,
    nativePromptNotSupported: $9797579afd7d961c$var$nativePromptNotSupported,
    noAccountError: $9797579afd7d961c$var$noAccountError,
    noNetworkConnectivity: $9797579afd7d961c$var$noNetworkConnectivity,
    noStateInHash: $9797579afd7d961c$var$noStateInHash,
    noTokenRequestCacheError: $9797579afd7d961c$var$noTokenRequestCacheError,
    nonBrowserEnvironment: $9797579afd7d961c$var$nonBrowserEnvironment,
    pkceNotCreated: $9797579afd7d961c$var$pkceNotCreated,
    popupRelayUnsupportedFlow: $9797579afd7d961c$var$popupRelayUnsupportedFlow,
    popupWindowError: $9797579afd7d961c$var$popupWindowError,
    postRequestFailed: $9797579afd7d961c$var$postRequestFailed,
    redirectBridgeEmptyResponse: $9797579afd7d961c$var$redirectBridgeEmptyResponse,
    redirectInIframe: $9797579afd7d961c$var$redirectInIframe,
    silentLogoutUnsupported: $9797579afd7d961c$var$silentLogoutUnsupported,
    silentPromptValueError: $9797579afd7d961c$var$silentPromptValueError,
    spaCodeAndNativeAccountIdPresent: $9797579afd7d961c$var$spaCodeAndNativeAccountIdPresent,
    stateInteractionTypeMismatch: $9797579afd7d961c$var$stateInteractionTypeMismatch,
    timedOut: $9797579afd7d961c$var$timedOut,
    tokenBindingKeyAlgorithmMismatch: $9797579afd7d961c$var$tokenBindingKeyAlgorithmMismatch,
    tokenBindingKeyJwkThumbprintMismatch: $9797579afd7d961c$var$tokenBindingKeyJwkThumbprintMismatch,
    unableToAcquireTokenFromNativePlatform: $9797579afd7d961c$var$unableToAcquireTokenFromNativePlatform,
    unableToLoadToken: $9797579afd7d961c$var$unableToLoadToken,
    unableToParseState: $9797579afd7d961c$var$unableToParseState,
    unableToParseTokenRequestCacheError: $9797579afd7d961c$var$unableToParseTokenRequestCacheError,
    uninitializedPublicClientApplication: $9797579afd7d961c$var$uninitializedPublicClientApplication,
    unsupportedTokenBindingAlgorithm: $9797579afd7d961c$var$unsupportedTokenBindingAlgorithm,
    userCancelled: $9797579afd7d961c$var$userCancelled
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$getDefaultErrorMessage(code) {
    return `See https://aka.ms/msal.js.errors#${code} for details`;
}
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $9797579afd7d961c$var$BrowserAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, subError){
        super(errorCode, correlationId, $9797579afd7d961c$var$getDefaultErrorMessage(errorCode), subError);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$BrowserAuthError.prototype);
        this.name = "BrowserAuthError";
    }
}
function $9797579afd7d961c$var$createBrowserAuthError(errorCode, correlationId, subError) {
    return new $9797579afd7d961c$var$BrowserAuthError(errorCode, correlationId, subError);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $9797579afd7d961c$var$base64Decode(input) {
    return new TextDecoder().decode($9797579afd7d961c$var$base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $9797579afd7d961c$var$base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidBase64String, "");
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $9797579afd7d961c$var$BrowserConstants = {
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $9797579afd7d961c$var$PlatformAuthConstants = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS",
    MICROSOFT_ENTRA_BROKERID: "MicrosoftEntra",
    DOM_API_NAME: "DOM API",
    PLATFORM_DOM_APIS: "get-token-and-sign-out",
    PLATFORM_DOM_PROVIDER: "PlatformAuthDOMHandler",
    PLATFORM_EXTENSION_PROVIDER: "PlatformAuthExtensionHandler"
};
const $9797579afd7d961c$var$NativeExtensionMethod = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $9797579afd7d961c$var$BrowserCacheLocation = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $9797579afd7d961c$var$HTTP_REQUEST_TYPE = {
    GET: "GET",
    POST: "POST"
};
const $9797579afd7d961c$var$INTERACTION_TYPE = {
    SIGNIN: "signin",
    SIGNOUT: "signout"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $9797579afd7d961c$var$TemporaryCacheKeys = {
    ORIGIN_URI: "request.origin",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    VERIFIER: "code.verifier",
    INTERACTION_STATUS_KEY: "interaction.status",
    NATIVE_REQUEST: "request.native"
};
/**
 * Cache keys stored in-memory
 */ const $9797579afd7d961c$var$InMemoryCacheKeys = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 * 900-999 Misc
 */ const $9797579afd7d961c$var$ApiId = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962,
    hydrateCache: 963,
    loadExternalTokens: 964
};
/**
 * API Names for Telemetry purposes.
 */ const $9797579afd7d961c$var$ApiName = {
    861: "acquireTokenRedirect",
    862: "acquireTokenPopup",
    863: "ssoSilent",
    864: "acquireTokenSilent_authCode",
    865: "handleRedirectPromise",
    866: "acquireTokenByCode",
    61: "acquireTokenSilent_silentFlow",
    961: "logout",
    962: "logoutPopup",
    963: "hydrateCache",
    964: "loadExternalTokens"
};
const $9797579afd7d961c$var$apiIdToName = (id)=>{
    if (typeof id === "number" && id in $9797579afd7d961c$var$ApiName) return $9797579afd7d961c$var$ApiName[id];
    return "unknown";
};
$9797579afd7d961c$export$4ec29255e7e7f68f = void 0;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($9797579afd7d961c$export$4ec29255e7e7f68f || ($9797579afd7d961c$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $9797579afd7d961c$var$InteractionStatus = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $9797579afd7d961c$var$DEFAULT_REQUEST = {
    scopes: $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $9797579afd7d961c$var$KEY_FORMAT_JWK = "jwk";
// Supported wrapper SKUs
const $9797579afd7d961c$var$WrapperSKU = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $9797579afd7d961c$var$DB_NAME = "msal.db";
const $9797579afd7d961c$var$DB_VERSION = 1;
const $9797579afd7d961c$var$DB_TABLE_NAME = `${$9797579afd7d961c$var$DB_NAME}.keys`;
const $9797579afd7d961c$var$CacheLookupPolicy = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $9797579afd7d961c$var$iFrameRenewalPolicies = [
    $9797579afd7d961c$var$CacheLookupPolicy.Default,
    $9797579afd7d961c$var$CacheLookupPolicy.Skip,
    $9797579afd7d961c$var$CacheLookupPolicy.RefreshTokenAndNetwork
];
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $9797579afd7d961c$var$urlEncode(input) {
    return encodeURIComponent($9797579afd7d961c$var$base64Encode(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $9797579afd7d961c$var$urlEncodeArr(inputArr) {
    return $9797579afd7d961c$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $9797579afd7d961c$var$base64Encode(input) {
    return $9797579afd7d961c$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $9797579afd7d961c$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // Algorithms
const $9797579afd7d961c$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
const $9797579afd7d961c$var$AES_GCM = "AES-GCM";
const $9797579afd7d961c$var$HKDF = "HKDF";
// SHA-256 hashing algorithm
const $9797579afd7d961c$var$S256_HASH_ALG = "SHA-256";
// JWK values used by browser-internal WebCrypto helpers.
const $9797579afd7d961c$var$JSON_WEB_KEY_CURVE_P256 = "P-256";
const $9797579afd7d961c$var$JSON_WEB_KEY_TYPE_EC = "EC";
const $9797579afd7d961c$var$JSON_WEB_KEY_TYPE_RSA = "RSA";
const $9797579afd7d961c$var$MISSING_JWK_KTY_SUBERROR = "missing_jwk_kty";
const $9797579afd7d961c$var$UNSUPPORTED_JWK_KTY_SUBERROR = "unsupported_jwk_kty";
const $9797579afd7d961c$var$MISSING_JWK_MEMBER_SUBERROR = "missing_jwk_member";
const $9797579afd7d961c$var$EMPTY_JWK_MEMBER_SUBERROR = "empty_jwk_member";
// MOD length for PoP tokens
const $9797579afd7d961c$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $9797579afd7d961c$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $9797579afd7d961c$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $9797579afd7d961c$var$UINT32_ARR = new Uint32Array(1);
// Key Format
const $9797579afd7d961c$var$RAW = "raw";
// Key Usages
const $9797579afd7d961c$var$ENCRYPT = "encrypt";
const $9797579afd7d961c$var$DECRYPT = "decrypt";
const $9797579afd7d961c$var$DERIVE_KEY = "deriveKey";
// Suberror
const $9797579afd7d961c$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $9797579afd7d961c$var$RSA_KEYGEN_ALGORITHM_OPTIONS = {
    name: $9797579afd7d961c$var$PKCS1_V15_KEYGEN_ALG,
    hash: $9797579afd7d961c$var$S256_HASH_ALG,
    modulusLength: $9797579afd7d961c$var$MODULUS_LENGTH,
    publicExponent: $9797579afd7d961c$var$PUBLIC_EXPONENT
};
const $9797579afd7d961c$var$RSA_SIGN_ALGORITHM_OPTIONS = {
    name: $9797579afd7d961c$var$PKCS1_V15_KEYGEN_ALG
};
const $9797579afd7d961c$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS = {
    name: "ECDSA",
    namedCurve: $9797579afd7d961c$var$JSON_WEB_KEY_CURVE_P256
};
const $9797579afd7d961c$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS = {
    name: "ECDSA",
    hash: {
        name: $9797579afd7d961c$var$S256_HASH_ALG
    }
};
/**
 * Check whether browser crypto is available.
 */ function $9797579afd7d961c$var$validateCryptoAvailable(skipValidateSubtleCrypto) {
    if (!window) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nonBrowserEnvironment, "");
    if (!window.crypto) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$cryptoNonExistent, "");
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$cryptoNonExistent, "", $9797579afd7d961c$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $9797579afd7d961c$var$sha256Digest(dataString) {
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($9797579afd7d961c$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $9797579afd7d961c$var$getRandomValues(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $9797579afd7d961c$var$getRandomUint32() {
    window.crypto.getRandomValues($9797579afd7d961c$var$UINT32_ARR);
    return $9797579afd7d961c$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $9797579afd7d961c$var$createNewGuid() {
    const currentTimestamp = Date.now();
    const baseRand = $9797579afd7d961c$var$getRandomUint32() * 0x400 + ($9797579afd7d961c$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $9797579afd7d961c$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $9797579afd7d961c$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $9797579afd7d961c$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on the provided algorithm config.
 * @param extractable
 * @param usages
 * @param algorithm
 */ async function $9797579afd7d961c$var$generateKeyPair(extractable, usages, algorithm) {
    return window.crypto.subtle.generateKey(algorithm, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $9797579afd7d961c$var$exportJwk(key) {
    return window.crypto.subtle.exportKey($9797579afd7d961c$var$KEY_FORMAT_JWK, key);
}
/**
 * Signs given data with given key.
 * @param key
 * @param data
 * @param algorithm
 */ async function $9797579afd7d961c$var$sign(key, data, algorithm) {
    return window.crypto.subtle.sign(algorithm, key, data);
}
/**
 * Generates Base64 encoded jwk used in the Encrypted Authorize Response (EAR) flow
 */ async function $9797579afd7d961c$var$generateEarKey() {
    const key = await $9797579afd7d961c$var$generateBaseKey();
    const keyStr = $9797579afd7d961c$var$urlEncodeArr(new Uint8Array(key));
    const jwk = {
        alg: "dir",
        kty: "oct",
        k: keyStr
    };
    return $9797579afd7d961c$var$base64Encode(JSON.stringify(jwk));
}
/**
 * Parses earJwk for encryption key and returns CryptoKey object
 * @param earJwk
 * @returns
 */ async function $9797579afd7d961c$var$importEarKey(earJwk) {
    const b64DecodedJwk = $9797579afd7d961c$var$base64Decode(earJwk);
    const jwkJson = JSON.parse(b64DecodedJwk);
    const rawKey = jwkJson.k;
    const keyBuffer = $9797579afd7d961c$var$base64DecToArr(rawKey);
    return window.crypto.subtle.importKey($9797579afd7d961c$var$RAW, keyBuffer, $9797579afd7d961c$var$AES_GCM, false, [
        $9797579afd7d961c$var$DECRYPT
    ]);
}
/**
 * Decrypt ear_jwe response returned in the Encrypted Authorize Response (EAR) flow
 * @param earJwk
 * @param earJwe
 * @returns
 */ async function $9797579afd7d961c$var$decryptEarResponse(earJwk, earJwe) {
    const earJweParts = earJwe.split(".");
    if (earJweParts.length !== 5) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToDecryptEarResponse, "", "jwe_length");
    const key = await $9797579afd7d961c$var$importEarKey(earJwk).catch(()=>{
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToDecryptEarResponse, "", "import_key");
    });
    try {
        const header = new TextEncoder().encode(earJweParts[0]);
        const iv = $9797579afd7d961c$var$base64DecToArr(earJweParts[2]);
        const ciphertext = $9797579afd7d961c$var$base64DecToArr(earJweParts[3]);
        const tag = $9797579afd7d961c$var$base64DecToArr(earJweParts[4]);
        const tagLengthBits = tag.byteLength * 8;
        // Concat ciphertext and tag
        const encryptedData = new Uint8Array(ciphertext.length + tag.length);
        encryptedData.set(ciphertext);
        encryptedData.set(tag, ciphertext.length);
        const decryptedData = await window.crypto.subtle.decrypt({
            name: $9797579afd7d961c$var$AES_GCM,
            iv: iv,
            tagLength: tagLengthBits,
            additionalData: header
        }, key, encryptedData);
        return new TextDecoder().decode(decryptedData);
    } catch (e) {
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToDecryptEarResponse, "", "decrypt");
    }
}
/**
 * Generates symmetric base encryption key. This may be stored as all encryption/decryption keys will be derived from this one.
 */ async function $9797579afd7d961c$var$generateBaseKey() {
    const key = await window.crypto.subtle.generateKey({
        name: $9797579afd7d961c$var$AES_GCM,
        length: 256
    }, true, [
        $9797579afd7d961c$var$ENCRYPT,
        $9797579afd7d961c$var$DECRYPT
    ]);
    return window.crypto.subtle.exportKey($9797579afd7d961c$var$RAW, key);
}
/**
 * Returns the raw key to be passed into the key derivation function
 * @param baseKey
 * @returns
 */ async function $9797579afd7d961c$var$generateHKDF(baseKey) {
    return window.crypto.subtle.importKey($9797579afd7d961c$var$RAW, baseKey, $9797579afd7d961c$var$HKDF, false, [
        $9797579afd7d961c$var$DERIVE_KEY
    ]);
}
/**
 * Given a base key and a nonce generates a derived key to be used in encryption and decryption.
 * Note: every time we encrypt a new key is derived
 * @param baseKey
 * @param nonce
 * @returns
 */ async function $9797579afd7d961c$var$deriveKey(baseKey, nonce, context) {
    return window.crypto.subtle.deriveKey({
        name: $9797579afd7d961c$var$HKDF,
        salt: nonce,
        hash: $9797579afd7d961c$var$S256_HASH_ALG,
        info: new TextEncoder().encode(context)
    }, baseKey, {
        name: $9797579afd7d961c$var$AES_GCM,
        length: 256
    }, false, [
        $9797579afd7d961c$var$ENCRYPT,
        $9797579afd7d961c$var$DECRYPT
    ]);
}
/**
 * Encrypt the given data given a base key. Returns encrypted data and a nonce that must be provided during decryption
 * @param key
 * @param rawData
 */ async function $9797579afd7d961c$var$encrypt(baseKey, rawData, context) {
    const encodedData = new TextEncoder().encode(rawData);
    // The nonce must never be reused with a given key.
    const nonce = window.crypto.getRandomValues(new Uint8Array(16));
    const derivedKey = await $9797579afd7d961c$var$deriveKey(baseKey, nonce, context);
    const encryptedData = await window.crypto.subtle.encrypt({
        name: $9797579afd7d961c$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return {
        data: $9797579afd7d961c$var$urlEncodeArr(new Uint8Array(encryptedData)),
        nonce: $9797579afd7d961c$var$urlEncodeArr(nonce)
    };
}
/**
 * Decrypt data with the given key and nonce
 * @param key
 * @param nonce
 * @param encryptedData
 * @returns
 */ async function $9797579afd7d961c$var$decrypt(baseKey, nonce, context, encryptedData) {
    const encodedData = $9797579afd7d961c$var$base64DecToArr(encryptedData);
    const derivedKey = await $9797579afd7d961c$var$deriveKey(baseKey, $9797579afd7d961c$var$base64DecToArr(nonce), context);
    const decryptedData = await window.crypto.subtle.decrypt({
        name: $9797579afd7d961c$var$AES_GCM,
        iv: new Uint8Array(12)
    }, derivedKey, encodedData);
    return new TextDecoder().decode(decryptedData);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $9797579afd7d961c$var$hashString(plainText) {
    const hashBuffer = await $9797579afd7d961c$var$sha256Digest(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return $9797579afd7d961c$var$urlEncodeArr(hashBytes);
}
const $9797579afd7d961c$var$JWK_THUMBPRINT_REQUIRED_MEMBERS = {
    [$9797579afd7d961c$var$JSON_WEB_KEY_TYPE_EC]: [
        "crv",
        "kty",
        "x",
        "y"
    ],
    [$9797579afd7d961c$var$JSON_WEB_KEY_TYPE_RSA]: [
        "e",
        "kty",
        "n"
    ]
};
function $9797579afd7d961c$var$getJwkThumbprintMembers(publicJwk, correlationId) {
    const kty = publicJwk.kty;
    if (typeof kty !== "string" || kty.length === 0) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPublicJwk, correlationId, $9797579afd7d961c$var$MISSING_JWK_KTY_SUBERROR);
    const requiredMembers = $9797579afd7d961c$var$JWK_THUMBPRINT_REQUIRED_MEMBERS[kty];
    if (!requiredMembers) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPublicJwk, correlationId, $9797579afd7d961c$var$UNSUPPORTED_JWK_KTY_SUBERROR);
    return requiredMembers.reduce((thumbprintMembers, memberName)=>{
        const memberValue = publicJwk[memberName];
        if (typeof memberValue !== "string") throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPublicJwk, correlationId, $9797579afd7d961c$var$MISSING_JWK_MEMBER_SUBERROR);
        if (memberValue.length === 0) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPublicJwk, correlationId, $9797579afd7d961c$var$EMPTY_JWK_MEMBER_SUBERROR);
        thumbprintMembers[memberName] = memberValue;
        return thumbprintMembers;
    }, {});
}
/**
 * Computes an RFC 7638 JWK thumbprint for a public key.
 * The required members for the JWK key type are serialised in lexicographic order
 * and the SHA-256 digest is returned as a base64url string.
 * @internal
 */ async function $9797579afd7d961c$var$computeJwkThumbprint(publicJwk, correlationId) {
    const thumbprintMembers = $9797579afd7d961c$var$getJwkThumbprintMembers(publicJwk, correlationId);
    // RFC 7638 §3.3: use only required members, sorted lexicographically
    const thumbprintJson = JSON.stringify(thumbprintMembers, Object.keys(thumbprintMembers).sort());
    return $9797579afd7d961c$var$hashString(thumbprintJson);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$storageNotSupported = "storage_not_supported";
const $9797579afd7d961c$var$stubbedPublicClientApplicationCalled = "stubbed_public_client_application_called";
const $9797579afd7d961c$var$inMemRedirectUnavailable = "in_mem_redirect_unavailable";
var $9797579afd7d961c$var$BrowserConfigurationAuthErrorCodes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    inMemRedirectUnavailable: $9797579afd7d961c$var$inMemRedirectUnavailable,
    storageNotSupported: $9797579afd7d961c$var$storageNotSupported,
    stubbedPublicClientApplicationCalled: $9797579afd7d961c$var$stubbedPublicClientApplicationCalled
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $9797579afd7d961c$var$BrowserConfigurationAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $9797579afd7d961c$var$BrowserConfigurationAuthError.prototype);
    }
}
function $9797579afd7d961c$var$createBrowserConfigurationAuthError(errorCode, correlationId) {
    return new $9797579afd7d961c$var$BrowserConfigurationAuthError(errorCode, correlationId, $9797579afd7d961c$var$getDefaultErrorMessage(errorCode));
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts and parses the authentication response from URL (hash and/or query string).
 * This is a shared utility used across multiple components in msal-browser.
 *
 * @returns {Object} An object containing the parsed state information and URL parameters.
 * @returns {URLSearchParams} params - The parsed URL parameters from the payload.
 * @returns {string} payload - The combined query string and hash content.
 * @returns {string} urlHash - The original URL hash.
 * @returns {string} urlQuery - The original URL query string.
 * @returns {LibraryStateObject} libraryState - The decoded library state from the state parameter.
 *
 * @throws {AuthError} If no authentication payload is found in the URL.
 * @throws {AuthError} If the state parameter is missing.
 * @throws {AuthError} If the state is missing required 'id' or 'meta' attributes.
 */ function $9797579afd7d961c$var$parseAuthResponseFromUrl() {
    // Extract both hash and query string to support hybrid response format
    const urlHash = window.location.hash;
    const urlQuery = window.location.search;
    // Determine which part contains the auth response by checking for 'state' parameter
    let hasResponseInHash = false;
    let hasResponseInQuery = false;
    let payload = "";
    let params = undefined;
    if (urlHash && urlHash.length > 1) {
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        const hashParams = new URLSearchParams(hashContent);
        if (hashParams.has("state")) {
            hasResponseInHash = true;
            payload = hashContent;
            params = hashParams;
        }
    }
    if (urlQuery && urlQuery.length > 1) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const queryParams = new URLSearchParams(queryContent);
        if (queryParams.has("state")) {
            hasResponseInQuery = true;
            payload = queryContent;
            params = queryParams;
        }
    }
    // If response is in both, combine them (hybrid format)
    if (hasResponseInHash && hasResponseInQuery) {
        const queryContent = urlQuery.charAt(0) === "?" ? urlQuery.substring(1) : urlQuery;
        const hashContent = urlHash.charAt(0) === "#" ? urlHash.substring(1) : urlHash;
        payload = `${queryContent}${hashContent}`;
        params = new URLSearchParams(payload);
    }
    /*
     * Called by the redirect-bridge entry point before any request context exists,
     * so correlationId is intentionally empty for the throws below.
     */ if (!payload || !params) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$emptyResponse, "");
    const state = params.get("state");
    if (!state) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noStateInHash, "");
    const { libraryState: libraryState } = $9797579afd7d961c$var$parseRequestState($9797579afd7d961c$var$base64Decode, state, "");
    const { id: id, meta: meta } = libraryState;
    if (!id || !meta) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unableToParseState, "", "missing_library_state");
    return {
        params: params,
        payload: payload,
        urlHash: urlHash,
        urlQuery: urlQuery,
        hasResponseInHash: hasResponseInHash,
        hasResponseInQuery: hasResponseInQuery,
        libraryState: {
            id: id,
            meta: meta
        }
    };
}
/**
 * Clears a recognized authentication response fragment, preserving the query string.
 * Assigns an empty hash, then removes the trailing # when history updates are available.
 */ function $9797579afd7d961c$var$clearHash(contentWindow) {
    const serverParams = $9797579afd7d961c$var$getDeserializedResponse(contentWindow.location.hash);
    if (!serverParams) return;
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Strips both hash and query string from the given window's URL by replacing
 * with origin + pathname only. Used to remove auth response parameters
 * (auth code, state, etc.) before the window is closed or navigated away.
 */ function $9797579afd7d961c$var$clearAuthResponseFromUrl(contentWindow) {
    if (typeof contentWindow.history?.replaceState === "function") contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $9797579afd7d961c$var$replaceHash(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $9797579afd7d961c$var$isInIframe() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $9797579afd7d961c$var$isInPopup() {
    if ($9797579afd7d961c$var$isInIframe()) return false;
    try {
        const { libraryState: libraryState } = $9797579afd7d961c$var$parseAuthResponseFromUrl();
        const { meta: meta } = libraryState;
        return meta["interactionType"] === $9797579afd7d961c$export$4ec29255e7e7f68f.Popup;
    } catch (e) {
        // If parsing fails (no state, invalid URL, etc.), we're not in a popup
        return false;
    }
}
/**
 * Await a response from a redirect bridge using BroadcastChannel.
 * This unified function works for both popup and iframe scenarios by listening on a
 * BroadcastChannel for the server payload.
 *
 * @param timeoutMs - Timeout in milliseconds.
 * @param logger - Logger instance for logging monitoring events.
 * @param browserCrypto - Browser crypto instance for decoding state.
 * @param request - The authorization or end session request.
 * @returns Promise<string> - Resolves with the response string (query or hash) from the window.
 */ // Track the active bridge monitor to allow cancellation when overriding interactions
let $9797579afd7d961c$var$activeBridgeMonitor = null;
/**
 * Cancels the pending bridge response monitor if one exists.
 * This is called when overrideInteractionInProgress is used to cancel
 * any pending popup interaction before starting a new one.
 */ function $9797579afd7d961c$var$cancelPendingBridgeResponse(logger, correlationId) {
    if ($9797579afd7d961c$var$activeBridgeMonitor) {
        logger.verbose("18y01k", correlationId);
        clearTimeout($9797579afd7d961c$var$activeBridgeMonitor.timeoutId);
        $9797579afd7d961c$var$activeBridgeMonitor.channel.close();
        $9797579afd7d961c$var$activeBridgeMonitor.reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$interactionInProgressCancelled, ""));
        $9797579afd7d961c$var$activeBridgeMonitor = null;
    }
}
/** @internal */ async function $9797579afd7d961c$var$waitForBridgeResponse(timeoutMs, logger, request, performanceClient, experimentalConfig) {
    return new Promise((resolve, reject)=>{
        logger.verbose("1rf6em", request.correlationId);
        const correlationId = request.correlationId;
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs,
            lateResponseExperimentEnabled: experimentalConfig?.iframeTimeoutTelemetry || false
        }, correlationId);
        const { libraryState: libraryState } = $9797579afd7d961c$var$parseRequestState($9797579afd7d961c$var$base64Decode, request.state || "", request.correlationId);
        const channel = new BroadcastChannel(libraryState.id);
        let responseString = undefined;
        let timedOut$1 = false;
        let lateTimeoutId;
        let lateMeasurement;
        const timeoutId = window.setTimeout(()=>{
            // Clear the active monitor
            $9797579afd7d961c$var$activeBridgeMonitor = null;
            if (experimentalConfig?.iframeTimeoutTelemetry) {
                lateMeasurement = performanceClient.startMeasurement($9797579afd7d961c$var$WaitForBridgeLateResponse$1, correlationId);
                timedOut$1 = true;
                lateTimeoutId = window.setTimeout(()=>{
                    lateMeasurement?.end({
                        success: false
                    });
                    clearTimeout(lateTimeoutId);
                    channel.close();
                }, 60000); // 60s late response timeout to allow for telemetry of late responses
            } else channel.close();
            reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$timedOut, "", "redirect_bridge_timeout"));
        }, timeoutMs);
        // Track this monitor so it can be cancelled if needed
        $9797579afd7d961c$var$activeBridgeMonitor = {
            timeoutId: timeoutId,
            channel: channel,
            reject: reject
        };
        channel.onmessage = (event)=>{
            responseString = event.data.payload;
            const messageVersion = event?.data && typeof event.data.v === "number" ? event.data.v : undefined;
            if (timedOut$1) {
                lateMeasurement?.end({
                    success: responseString ? true : false
                });
                clearTimeout(lateTimeoutId);
                channel.close();
                return;
            }
            performanceClient.addFields({
                redirectBridgeMessageVersion: messageVersion
            }, correlationId);
            // Clear the active monitor
            $9797579afd7d961c$var$activeBridgeMonitor = null;
            clearTimeout(timeoutId);
            channel.close();
            if (responseString) resolve(responseString);
            else reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$redirectBridgeEmptyResponse, correlationId));
        };
    });
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $9797579afd7d961c$var$getCurrentUri() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $9797579afd7d961c$var$getHomepage(correlationId) {
    const currentUrl = new $9797579afd7d961c$var$UrlString(window.location.href, correlationId || "");
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $9797579afd7d961c$var$blockReloadInHiddenIframes() {
    const isResponseHash = $9797579afd7d961c$var$getDeserializedResponse(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $9797579afd7d961c$var$isInIframe()) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$blockIframeReload, "");
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $9797579afd7d961c$var$blockRedirectInIframe(allowRedirectInIframe) {
    if ($9797579afd7d961c$var$isInIframe() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$redirectInIframe, "");
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $9797579afd7d961c$var$blockAcquireTokenInPopups() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($9797579afd7d961c$var$isInPopup()) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$blockNestedPopups, "");
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $9797579afd7d961c$var$blockNonBrowserEnvironment() {
    if (typeof window === "undefined") throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nonBrowserEnvironment, "");
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $9797579afd7d961c$var$blockAPICallsBeforeInitialize(initialized) {
    if (!initialized) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$uninitializedPublicClientApplication, "");
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $9797579afd7d961c$var$preflightCheck$1(initialized) {
    // Block request if not in browser environment
    $9797579afd7d961c$var$blockNonBrowserEnvironment();
    // Block auth requests inside a hidden iframe
    $9797579afd7d961c$var$blockReloadInHiddenIframes();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $9797579afd7d961c$var$blockAcquireTokenInPopups();
    // Block token acquisition before initialize has been called
    $9797579afd7d961c$var$blockAPICallsBeforeInitialize(initialized);
}
/**
 * Helper to validate app environment before making redirect request
 * @param initialized
 * @param config
 * @internal
 */ function $9797579afd7d961c$var$redirectPreflightCheck(initialized, config) {
    $9797579afd7d961c$var$preflightCheck$1(initialized);
    $9797579afd7d961c$var$blockRedirectInIframe(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled
    if (config.cache.cacheLocation === $9797579afd7d961c$var$BrowserCacheLocation.MemoryStorage) throw $9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$inMemRedirectUnavailable, "");
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $9797579afd7d961c$var$preconnect(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $9797579afd7d961c$var$createGuid() {
    return $9797579afd7d961c$var$createNewGuid();
}
const $9797579afd7d961c$var$buildMergedClaims = $9797579afd7d961c$var$buildMergedClaims$1;
var $9797579afd7d961c$var$BrowserUtils = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blockAPICallsBeforeInitialize: $9797579afd7d961c$var$blockAPICallsBeforeInitialize,
    blockAcquireTokenInPopups: $9797579afd7d961c$var$blockAcquireTokenInPopups,
    blockNonBrowserEnvironment: $9797579afd7d961c$var$blockNonBrowserEnvironment,
    blockRedirectInIframe: $9797579afd7d961c$var$blockRedirectInIframe,
    blockReloadInHiddenIframes: $9797579afd7d961c$var$blockReloadInHiddenIframes,
    buildMergedClaims: $9797579afd7d961c$var$buildMergedClaims,
    cancelPendingBridgeResponse: $9797579afd7d961c$var$cancelPendingBridgeResponse,
    clearAuthResponseFromUrl: $9797579afd7d961c$var$clearAuthResponseFromUrl,
    clearHash: $9797579afd7d961c$var$clearHash,
    createGuid: $9797579afd7d961c$var$createGuid,
    getCurrentUri: $9797579afd7d961c$var$getCurrentUri,
    getHomepage: $9797579afd7d961c$var$getHomepage,
    invoke: $9797579afd7d961c$var$invoke,
    invokeAsync: $9797579afd7d961c$var$invokeAsync,
    isInIframe: $9797579afd7d961c$var$isInIframe,
    isInPopup: $9797579afd7d961c$var$isInPopup,
    parseAuthResponseFromUrl: $9797579afd7d961c$var$parseAuthResponseFromUrl,
    preconnect: $9797579afd7d961c$var$preconnect,
    preflightCheck: $9797579afd7d961c$var$preflightCheck$1,
    redirectPreflightCheck: $9797579afd7d961c$var$redirectPreflightCheck,
    replaceHash: $9797579afd7d961c$var$replaceHash,
    waitForBridgeResponse: $9797579afd7d961c$var$waitForBridgeResponse
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $9797579afd7d961c$var$DatabaseStorage {
    constructor(){
        this.dbName = $9797579afd7d961c$var$DB_NAME;
        this.version = $9797579afd7d961c$var$DB_VERSION;
        this.tableName = $9797579afd7d961c$var$DB_TABLE_NAME;
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseUnavailable, "")));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$databaseNotOpen, ""));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase($9797579afd7d961c$var$DB_NAME);
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$MemoryStorage {
    constructor(){
        this.cache = new Map();
    }
    async initialize() {
    // Memory storage does not require initialization
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
    decryptData() {
        // Memory storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $9797579afd7d961c$var$AsyncMemoryStorage {
    constructor(logger){
        this.inMemoryCache = new $9797579afd7d961c$var$MemoryStorage();
        this.indexedDBCache = new $9797579afd7d961c$var$DatabaseStorage();
        this.logger = logger;
    }
    handleDatabaseAccessError(error, correlationId) {
        if (error instanceof $9797579afd7d961c$var$BrowserAuthError && error.errorCode === $9797579afd7d961c$var$databaseUnavailable) this.logger.error("1wx7zz", correlationId);
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     * @param correlationId
     */ async getItem(key, correlationId) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("0naxpl", correlationId);
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     * @param correlationId
     */ async setItem(key, value, correlationId) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     * @param correlationId
     */ async removeItem(key, correlationId) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
    }
    /**
     * Get all keys from both in-memory and persistent storage.
     * @param correlationId
     */ async getKeys(correlationId) {
        const cacheKeys = this.inMemoryCache.getKeys();
        try {
            const persistentCacheKeys = await this.indexedDBCache.getKeys();
            return Array.from(new Set([
                ...cacheKeys,
                ...persistentCacheKeys
            ]));
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return cacheKeys;
        }
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     * @param correlationId
     */ async containsKey(key, correlationId) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("03zl2j", correlationId);
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     * @param correlationId
     */ clearInMemory(correlationId) {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose("03r21p", correlationId);
        this.inMemoryCache.clear();
        this.logger.verbose("0uksk1", correlationId);
    }
    /**
     * Tries to delete the IndexedDB database
     * @param correlationId
     * @returns
     */ async clearPersistent(correlationId) {
        try {
            this.logger.verbose("0rdqut", correlationId);
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("149ouc", correlationId);
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e, correlationId);
            return false;
        }
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Owns browser token-binding key lifecycle and storage lookup.
 * @internal
 */ class $9797579afd7d961c$var$TokenBindingKeyManager {
    constructor(logger, performanceClient){
        this.logger = logger;
        this.cache = $9797579afd7d961c$var$TokenBindingKeyManager.getTokenBindingKeyStorage(this.logger);
        this.performanceClient = performanceClient;
    }
    static getTokenBindingKeyStorage(logger) {
        if (!$9797579afd7d961c$var$TokenBindingKeyManager.tokenBindingKeyStorage) $9797579afd7d961c$var$TokenBindingKeyManager.tokenBindingKeyStorage = new $9797579afd7d961c$var$AsyncMemoryStorage(logger);
        return $9797579afd7d961c$var$TokenBindingKeyManager.tokenBindingKeyStorage;
    }
    /**
     * Provisions a browser token-binding key and returns its key identifier.
     * @param request - Key provisioning policy.
     */ async provisionTokenBindingKey(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement($9797579afd7d961c$var$CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        try {
            const activeKeyPair = await this.createTokenBindingKey(request);
            publicKeyThumbMeasurement?.end({
                success: true,
                ...this.getTokenBindingKeyTelemetry(activeKeyPair)
            });
            return activeKeyPair.keyId;
        } catch (e) {
            publicKeyThumbMeasurement?.end({
                success: false,
                tokenBindingKeyType: request.tokenBindingKeyType,
                tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
            });
            throw e;
        }
    }
    /**
     * Removes a browser token-binding key by identifier.
     * @param kid - Token-binding key identifier.
     * @param correlationId - Request correlation identifier.
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.cache.removeItem(kid, correlationId);
        const keyFound = await this.cache.containsKey(kid, correlationId);
        if (keyFound) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$bindingKeyNotRemoved, correlationId);
    }
    /**
     * Clears browser token-binding keys from memory and persistent storage.
     * @param correlationId - Request correlation identifier.
     */ async clearKeystore(correlationId) {
        this.cache.clearInMemory(correlationId);
        try {
            await this.cache.clearPersistent(correlationId);
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`1owpn8 ${e.message}`, correlationId);
            else this.logger.error("0yrmwo", correlationId);
            return false;
        }
    }
    /**
     * Gets a token-binding public key as a JWK by identifier.
     * @param keyId - Token-binding key identifier.
     * @param correlationId - Request correlation identifier.
     */ async getTokenBindingPublicKeyJwk(keyId, correlationId) {
        const cachedKeyPair = await this.getTokenBindingKeyPair(keyId, correlationId);
        return $9797579afd7d961c$var$exportJwk(cachedKeyPair.publicKey);
    }
    async createTokenBindingKey(request) {
        const keyGenAlgorithm = this.getTokenBindingKeyGenAlgorithmOptions(request.tokenBindingKeyAlgorithm, request.correlationId);
        const generatedKeyPair = await this.generateKeyPairAndThumbprint($9797579afd7d961c$var$TokenBindingKeyManager.TOKEN_BINDING_KEY_USAGES, keyGenAlgorithm, request.correlationId);
        await this.cache.setItem(generatedKeyPair.keyId, {
            ...generatedKeyPair,
            tokenBindingKeyType: request.tokenBindingKeyType,
            tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
        }, request.correlationId);
        return {
            ...generatedKeyPair,
            tokenBindingKeyType: request.tokenBindingKeyType,
            tokenBindingKeyAlgorithm: request.tokenBindingKeyAlgorithm
        };
    }
    async generateKeyPairAndThumbprint(usages, keyGenAlgorithm, correlationId) {
        const keyPair = await $9797579afd7d961c$var$generateKeyPair(false, usages, keyGenAlgorithm);
        const publicJwk = await $9797579afd7d961c$var$exportJwk(keyPair.publicKey);
        const keyId = await $9797579afd7d961c$var$computeJwkThumbprint(publicJwk, correlationId);
        return {
            publicKey: keyPair.publicKey,
            privateKey: keyPair.privateKey,
            keyId: keyId
        };
    }
    /** @internal */ async getTokenBindingKeyPair(keyId, correlationId) {
        const cachedKeyPair = await this.cache.getItem(keyId, correlationId);
        if (!cachedKeyPair) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$cryptoKeyNotFound, correlationId);
        return cachedKeyPair;
    }
    /** @internal */ getTokenBindingKeyTelemetry(cachedKeyPair, fallbackAlgorithm) {
        return {
            ...cachedKeyPair.tokenBindingKeyType && {
                tokenBindingKeyType: cachedKeyPair.tokenBindingKeyType
            },
            ...cachedKeyPair.tokenBindingKeyAlgorithm || fallbackAlgorithm ? {
                tokenBindingKeyAlgorithm: cachedKeyPair.tokenBindingKeyAlgorithm || fallbackAlgorithm
            } : {}
        };
    }
    getTokenBindingKeyGenAlgorithmOptions(tokenBindingKeyAlgorithm, correlationId) {
        if (tokenBindingKeyAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.RS256) return $9797579afd7d961c$var$RSA_KEYGEN_ALGORITHM_OPTIONS;
        if (tokenBindingKeyAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.ES256) return $9797579afd7d961c$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS;
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unsupportedTokenBindingAlgorithm, correlationId);
    }
}
$9797579afd7d961c$var$TokenBindingKeyManager.TOKEN_BINDING_KEY_USAGES = [
    "sign",
    "verify"
];
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $9797579afd7d961c$var$CryptoOps {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        $9797579afd7d961c$var$validateCryptoAvailable(skipValidateSubtleCrypto ?? false);
        this.performanceClient = performanceClient;
        this.tokenBindingKeyManager = new $9797579afd7d961c$var$TokenBindingKeyManager(this.logger, this.performanceClient);
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return $9797579afd7d961c$var$createNewGuid();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return $9797579afd7d961c$var$base64Encode(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return $9797579afd7d961c$var$base64Decode(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return $9797579afd7d961c$var$urlEncode(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     * @param correlationId
     */ async removeTokenBindingKey(kid, correlationId) {
        await this.tokenBindingKeyManager.removeTokenBindingKey(kid, correlationId);
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     * @param correlationId
     */ async clearKeystore(correlationId) {
        return this.tokenBindingKeyManager.clearKeystore(correlationId);
    }
    /** @internal */ async signTokenBindingJwt(header, payload, kid, correlationId) {
        let telemetry = {};
        const signTokenBindingJwtMeasurement = this.performanceClient?.startMeasurement($9797579afd7d961c$var$CryptoOptsSignJwt, correlationId);
        try {
            const cachedKeyPair = await this.tokenBindingKeyManager.getTokenBindingKeyPair(kid, correlationId);
            await this.validateTokenBindingJwtHeaderKey(header, kid, correlationId);
            telemetry = this.tokenBindingKeyManager.getTokenBindingKeyTelemetry(cachedKeyPair, header.alg);
            const signingAlgorithm = this.getTokenBindingKeySigningAlgorithm(cachedKeyPair, header.alg, correlationId);
            const tokenString = `${$9797579afd7d961c$var$urlEncode(JSON.stringify(header))}.${$9797579afd7d961c$var$urlEncode(JSON.stringify(payload))}`;
            const encodedSignature = await this.signInput(cachedKeyPair, tokenString, signingAlgorithm);
            signTokenBindingJwtMeasurement?.end({
                success: true,
                ...telemetry
            });
            return `${tokenString}.${encodedSignature}`;
        } catch (e) {
            signTokenBindingJwtMeasurement?.end({
                success: false,
                ...telemetry
            });
            throw e;
        }
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return $9797579afd7d961c$var$hashString(plainText);
    }
    async signInput(cachedKeyPair, signingInput, algorithm) {
        const encoder = new TextEncoder();
        const signatureBuffer = await $9797579afd7d961c$var$sign(cachedKeyPair.privateKey, encoder.encode(signingInput), algorithm);
        return $9797579afd7d961c$var$urlEncodeArr(new Uint8Array(signatureBuffer));
    }
    getTokenBindingKeySigningAlgorithm(cachedKeyPair, requestedAlgorithm, correlationId) {
        const keyAlgorithm = cachedKeyPair.privateKey.algorithm;
        if (requestedAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.RS256 && keyAlgorithm.name === $9797579afd7d961c$var$RSA_SIGN_ALGORITHM_OPTIONS.name) return $9797579afd7d961c$var$RSA_SIGN_ALGORITHM_OPTIONS;
        if (requestedAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.ES256 && keyAlgorithm.name === $9797579afd7d961c$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS.name && keyAlgorithm.namedCurve === $9797579afd7d961c$var$ECDSA_P256_KEYGEN_ALGORITHM_OPTIONS.namedCurve) return $9797579afd7d961c$var$ECDSA_SHA256_SIGN_ALGORITHM_OPTIONS;
        if (requestedAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.RS256 || requestedAlgorithm === $9797579afd7d961c$var$JsonWebTokenAlgorithms.ES256) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unsupportedTokenBindingAlgorithm, correlationId, $9797579afd7d961c$var$tokenBindingKeyAlgorithmMismatch);
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unsupportedTokenBindingAlgorithm, correlationId);
    }
    async validateTokenBindingJwtHeaderKey(header, kid, correlationId) {
        if (!header.jwk) return;
        const headerKeyId = await $9797579afd7d961c$var$computeJwkThumbprint(header.jwk, correlationId);
        if (headerKeyId !== kid) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPublicJwk, correlationId, $9797579afd7d961c$var$tokenBindingKeyJwkThumbprintMismatch);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * acquireTokenSilent API (msal-browser and msal-node).
 * Used to silently acquire a new access token (from the cache or the network).
 */ const $9797579afd7d961c$var$AcquireTokenSilent = "acquireTokenSilent";
/**
 * acquireTokenByCode API (msal-browser and msal-node).
 * Used to acquire tokens by trading an authorization code against the token endpoint.
 */ const $9797579afd7d961c$var$AcquireTokenByCode = "acquireTokenByCode";
/**
 * acquireTokenPopup (msal-browser).
 * Used to acquire a new access token interactively through pop ups
 */ const $9797579afd7d961c$var$AcquireTokenPopup = "acquireTokenPopup";
/**
 * acquireTokenPreRedirect (msal-browser).
 * First part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $9797579afd7d961c$var$AcquireTokenPreRedirect = "acquireTokenPreRedirect";
/**
 * acquireTokenRedirect (msal-browser).
 * Second part of the redirect flow.
 * Used to acquire a new access token interactively through redirects.
 */ const $9797579afd7d961c$var$AcquireTokenRedirect = "acquireTokenRedirect";
/**
 * ssoSilent API (msal-browser).
 * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
 */ const $9797579afd7d961c$var$SsoSilent = "ssoSilent";
// Initialize client application
const $9797579afd7d961c$var$InitializeClientApplication = "initializeClientApplication";
// Update cache storage
const $9797579afd7d961c$var$LocalStorageUpdated = "localStorageUpdated";
// Load external tokens
const $9797579afd7d961c$var$LoadExternalTokens = "loadExternalTokens";
/**
 * SSO capability verification call (msal-browser).
 * Fire-and-forget SSO verification call made after interactive authentication completes.
 */ const $9797579afd7d961c$var$SsoCapable = "ssoCapable";
// Wait for late response from bridge after timeout has already occurred
const $9797579afd7d961c$var$WaitForBridgeLateResponse = "waitForBridgeLateResponse";
var $9797579afd7d961c$var$BrowserRootPerformanceEvents = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AcquireTokenByCode: $9797579afd7d961c$var$AcquireTokenByCode,
    AcquireTokenPopup: $9797579afd7d961c$var$AcquireTokenPopup,
    AcquireTokenPreRedirect: $9797579afd7d961c$var$AcquireTokenPreRedirect,
    AcquireTokenRedirect: $9797579afd7d961c$var$AcquireTokenRedirect,
    AcquireTokenSilent: $9797579afd7d961c$var$AcquireTokenSilent,
    InitializeClientApplication: $9797579afd7d961c$var$InitializeClientApplication,
    LoadExternalTokens: $9797579afd7d961c$var$LoadExternalTokens,
    LocalStorageUpdated: $9797579afd7d961c$var$LocalStorageUpdated,
    SsoCapable: $9797579afd7d961c$var$SsoCapable,
    SsoSilent: $9797579afd7d961c$var$SsoSilent,
    WaitForBridgeLateResponse: $9797579afd7d961c$var$WaitForBridgeLateResponse
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$PREFIX = "msal";
const $9797579afd7d961c$var$BROWSER_PREFIX = "browser";
const $9797579afd7d961c$var$CACHE_KEY_SEPARATOR = "|";
const $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION = 3;
const $9797579afd7d961c$var$ACCOUNT_SCHEMA_VERSION = 3;
const $9797579afd7d961c$var$LOG_LEVEL_CACHE_KEY = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$BROWSER_PREFIX}.log.level`;
const $9797579afd7d961c$var$LOG_PII_CACHE_KEY = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$BROWSER_PREFIX}.log.pii`;
const $9797579afd7d961c$var$BROWSER_PERF_ENABLED_KEY = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$BROWSER_PREFIX}.performance.enabled`;
const $9797579afd7d961c$var$VERSION_CACHE_KEY = `${$9797579afd7d961c$var$PREFIX}.version`;
const $9797579afd7d961c$var$ACCOUNT_KEYS = "account.keys";
const $9797579afd7d961c$var$TOKEN_KEYS = "token.keys";
const $9797579afd7d961c$var$SSO_CAPABLE = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$BROWSER_PREFIX}.sso.capable`;
function $9797579afd7d961c$var$getAccountKeysCacheKey(schema = $9797579afd7d961c$var$ACCOUNT_SCHEMA_VERSION) {
    if (schema < 1) return `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$ACCOUNT_KEYS}`;
    return `${$9797579afd7d961c$var$PREFIX}.${schema}.${$9797579afd7d961c$var$ACCOUNT_KEYS}`;
}
function $9797579afd7d961c$var$getTokenKeysCacheKey(clientId, schema = $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION) {
    if (schema < 1) return `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$TOKEN_KEYS}.${clientId}`;
    return `${$9797579afd7d961c$var$PREFIX}.${schema}.${$9797579afd7d961c$var$TOKEN_KEYS}.${clientId}`;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $9797579afd7d961c$var$COOKIE_LIFE_MULTIPLIER = 86400000;
const $9797579afd7d961c$var$SameSiteOptions = {
    Lax: "Lax",
    None: "None"
};
class $9797579afd7d961c$var$CookieStorage {
    initialize() {
        return Promise.resolve();
    }
    getItem(key) {
        const name = encodeURIComponent(key);
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i].trim();
            const eqIndex = cookie.indexOf("=");
            const rawKey = eqIndex === -1 ? cookie : cookie.substring(0, eqIndex);
            if (rawKey === name) {
                const rawValue = eqIndex === -1 ? "" : cookie.substring(eqIndex + 1);
                try {
                    return decodeURIComponent(rawValue);
                } catch  {
                    return rawValue;
                }
            }
        }
        return "";
    }
    getUserData() {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, "");
    }
    setItem(key, value, cookieLifeDays, secure = true, sameSite = $9797579afd7d961c$var$SameSiteOptions.Lax) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=${sameSite};`;
        if (cookieLifeDays) {
            const expireTime = $9797579afd7d961c$var$getCookieExpirationTime(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure || sameSite === $9797579afd7d961c$var$SameSiteOptions.None) // SameSite None requires Secure flag
        cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    async setUserData(_key, _value, correlationId) {
        return Promise.reject($9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$methodNotImplemented, correlationId));
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const trimmed = cookie.trim();
            const eqIndex = trimmed.indexOf("=");
            const rawKey = eqIndex === -1 ? trimmed : trimmed.substring(0, eqIndex);
            try {
                keys.push(decodeURIComponent(rawKey));
            } catch  {
            // Skip cookies with malformed percent-encoded sequences in the key
            }
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
    decryptData() {
        // Cookie storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $9797579afd7d961c$var$getCookieExpirationTime(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $9797579afd7d961c$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns a list of cache keys for all known accounts
 * @param storage
 * @returns
 */ function $9797579afd7d961c$var$getAccountKeys(storage, schemaVersion) {
    const accountKeys = storage.getItem($9797579afd7d961c$var$getAccountKeysCacheKey(schemaVersion));
    if (accountKeys) return JSON.parse(accountKeys);
    return [];
}
/**
 * Returns a list of cache keys for all known tokens
 * @param clientId
 * @param storage
 * @returns
 */ function $9797579afd7d961c$var$getTokenKeys(clientId, storage, schemaVersion) {
    const item = storage.getItem($9797579afd7d961c$var$getTokenKeysCacheKey(clientId, schemaVersion));
    if (item) {
        const tokenKeys = JSON.parse(item);
        if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
    }
    return {
        idToken: [],
        accessToken: [],
        refreshToken: []
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$isEncrypted(data) {
    return data.hasOwnProperty("id") && data.hasOwnProperty("nonce") && data.hasOwnProperty("data");
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$ENCRYPTION_KEY = "msal.cache.encryption";
const $9797579afd7d961c$var$BROADCAST_CHANNEL_NAME$1 = "msal.broadcast.cache";
class $9797579afd7d961c$var$LocalStorage {
    constructor(clientId, logger, performanceClient){
        if (!window.localStorage) throw $9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$storageNotSupported, "");
        this.memoryStorage = new $9797579afd7d961c$var$MemoryStorage();
        this.initialized = false;
        this.clientId = clientId;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.broadcast = new BroadcastChannel($9797579afd7d961c$var$BROADCAST_CHANNEL_NAME$1);
    }
    async initialize(correlationId) {
        const cookies = new $9797579afd7d961c$var$CookieStorage();
        const cookieString = cookies.getItem($9797579afd7d961c$var$ENCRYPTION_KEY);
        let parsedCookie = {
            key: "",
            id: ""
        };
        if (cookieString) try {
            parsedCookie = JSON.parse(cookieString);
        } catch (e) {}
        if (parsedCookie.key && parsedCookie.id) {
            // Encryption key already exists, import
            const baseKey = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$base64DecToArr, $9797579afd7d961c$var$Base64Decode, this.logger, this.performanceClient, correlationId)(parsedCookie.key);
            this.encryptionCookie = {
                id: parsedCookie.id,
                key: await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateHKDF, $9797579afd7d961c$var$GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
        } else {
            // Encryption key doesn't exist or is invalid, generate a new one
            const id = $9797579afd7d961c$var$createNewGuid();
            const baseKey = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateBaseKey, $9797579afd7d961c$var$GenerateBaseKey, this.logger, this.performanceClient, correlationId)();
            const keyStr = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$urlEncodeArr, $9797579afd7d961c$var$UrlEncodeArr, this.logger, this.performanceClient, correlationId)(new Uint8Array(baseKey));
            this.encryptionCookie = {
                id: id,
                key: await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateHKDF, $9797579afd7d961c$var$GenerateHKDF, this.logger, this.performanceClient, correlationId)(baseKey)
            };
            const cookieData = {
                id: id,
                key: keyStr
            };
            cookies.setItem($9797579afd7d961c$var$ENCRYPTION_KEY, JSON.stringify(cookieData), 0, true, $9797579afd7d961c$var$SameSiteOptions.None // SameSite must be None to support iframed apps
            );
        }
        await $9797579afd7d961c$var$invokeAsync(this.importExistingCache.bind(this), $9797579afd7d961c$var$ImportExistingCache, this.logger, this.performanceClient, correlationId)(correlationId);
        // Register listener for cache updates in other tabs
        this.broadcast.addEventListener("message", (event)=>{
            this.updateCache(event, correlationId).catch(()=>{
                this.logger.error("0ufnan", correlationId);
            });
        });
        this.initialized = true;
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    getUserData(key) {
        if (!this.initialized) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$uninitializedPublicClientApplication, "");
        return this.memoryStorage.getItem(key);
    }
    async decryptData(key, data, correlationId) {
        if (!this.initialized || !this.encryptionCookie) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$uninitializedPublicClientApplication, "");
        if (data.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        const decryptedData = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$decrypt, $9797579afd7d961c$var$Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, data.nonce, this.getContext(key), data.data);
        if (!decryptedData) return null;
        try {
            return {
                ...JSON.parse(decryptedData),
                lastUpdatedAt: data.lastUpdatedAt
            };
        } catch (e) {
            this.performanceClient.incrementFields({
                encryptedCacheCorruptionCount: 1
            }, correlationId);
            return null;
        }
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    async setUserData(key, value, correlationId, timestamp, kmsi) {
        if (!this.initialized || !this.encryptionCookie) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$uninitializedPublicClientApplication, "");
        if (kmsi) this.setItem(key, value);
        else {
            const { data: data, nonce: nonce } = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$encrypt, $9797579afd7d961c$var$Encrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, value, this.getContext(key));
            const encryptedData = {
                id: this.encryptionCookie.id,
                nonce: nonce,
                data: data,
                lastUpdatedAt: timestamp
            };
            this.setItem(key, JSON.stringify(encryptedData));
        }
        this.memoryStorage.setItem(key, value);
        // Notify other frames to update their in-memory cache
        this.broadcast.postMessage({
            key: key,
            value: value,
            context: this.getBroadcastContext(key)
        });
    }
    removeItem(key) {
        const itemExists = this.containsKey(key) || this.memoryStorage.containsKey(key);
        window.localStorage.removeItem(key);
        this.memoryStorage.removeItem(key);
        if (itemExists) this.broadcast.postMessage({
            key: key,
            value: null,
            context: this.getBroadcastContext(key)
        });
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
    /**
     * Removes all known MSAL keys from the cache
     */ clear() {
        // Removes all remaining MSAL cache items
        this.memoryStorage.clear();
        const accountKeys = $9797579afd7d961c$var$getAccountKeys(this);
        accountKeys.forEach((key)=>this.removeItem(key));
        const tokenKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this);
        tokenKeys.idToken.forEach((key)=>this.removeItem(key));
        tokenKeys.accessToken.forEach((key)=>this.removeItem(key));
        tokenKeys.refreshToken.forEach((key)=>this.removeItem(key));
        // Clean up anything left
        this.getKeys().forEach((cacheKey)=>{
            if (cacheKey.startsWith($9797579afd7d961c$var$PREFIX) || cacheKey.indexOf(this.clientId) !== -1) this.removeItem(cacheKey);
        });
    }
    /**
     * Helper to decrypt all known MSAL keys in localStorage and save them to inMemory storage
     * @returns
     */ async importExistingCache(correlationId) {
        if (!this.encryptionCookie) return;
        let accountKeys = $9797579afd7d961c$var$getAccountKeys(this);
        accountKeys = await this.importArray(accountKeys, correlationId);
        // Write valid account keys back to map
        if (accountKeys.length) this.setItem($9797579afd7d961c$var$getAccountKeysCacheKey(), JSON.stringify(accountKeys));
        else this.removeItem($9797579afd7d961c$var$getAccountKeysCacheKey());
        const tokenKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this);
        tokenKeys.idToken = await this.importArray(tokenKeys.idToken, correlationId);
        tokenKeys.accessToken = await this.importArray(tokenKeys.accessToken, correlationId);
        tokenKeys.refreshToken = await this.importArray(tokenKeys.refreshToken, correlationId);
        // Write valid token keys back to map
        if (tokenKeys.idToken.length || tokenKeys.accessToken.length || tokenKeys.refreshToken.length) this.setItem($9797579afd7d961c$var$getTokenKeysCacheKey(this.clientId), JSON.stringify(tokenKeys));
        else this.removeItem($9797579afd7d961c$var$getTokenKeysCacheKey(this.clientId));
    }
    /**
     * Helper to decrypt and save cache entries
     * @param key
     * @returns
     */ async getItemFromEncryptedCache(key, correlationId) {
        if (!this.encryptionCookie) return null;
        const rawCache = this.getItem(key);
        if (!rawCache) return null;
        let encObj;
        try {
            encObj = JSON.parse(rawCache);
        } catch (e) {
            // Not a valid encrypted object, remove
            return null;
        }
        if (!$9797579afd7d961c$var$isEncrypted(encObj)) {
            // Data is not encrypted
            this.performanceClient.incrementFields({
                unencryptedCacheCount: 1
            }, correlationId);
            return rawCache;
        }
        if (encObj.id !== this.encryptionCookie.id) {
            // Data was encrypted with a different key. It must be removed because it is from a previous session.
            this.performanceClient.incrementFields({
                encryptedCacheExpiredCount: 1
            }, correlationId);
            return null;
        }
        this.performanceClient.incrementFields({
            encryptedCacheCount: 1
        }, correlationId);
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$decrypt, $9797579afd7d961c$var$Decrypt, this.logger, this.performanceClient, correlationId)(this.encryptionCookie.key, encObj.nonce, this.getContext(key), encObj.data);
    }
    /**
     * Helper to decrypt and save an array of cache keys
     * @param arr
     * @returns Array of keys successfully imported
     */ async importArray(arr, correlationId) {
        const importedArr = [];
        const promiseArr = [];
        arr.forEach((key)=>{
            const promise = this.getItemFromEncryptedCache(key, correlationId).then((value)=>{
                if (value) {
                    this.memoryStorage.setItem(key, value);
                    importedArr.push(key);
                } else // If value is empty, unencrypted or expired remove
                this.removeItem(key);
            });
            promiseArr.push(promise);
        });
        await Promise.all(promiseArr);
        return importedArr;
    }
    getContext(key) {
        return key.includes(this.clientId) ? this.clientId : "";
    }
    getBroadcastContext(key) {
        const normalizedKey = key.toLowerCase();
        const keySegments = normalizedKey.split($9797579afd7d961c$var$CACHE_KEY_SEPARATOR);
        if (keySegments.length > 1) return keySegments[4] === this.clientId.toLowerCase() ? this.clientId : "";
        const credentialType = this.getCredentialType(normalizedKey);
        if (credentialType) {
            const ownerPrefix = `-${credentialType}-${this.clientId.toLowerCase()}-`;
            return normalizedKey.includes(ownerPrefix) ? this.clientId : "";
        }
        return normalizedKey.includes(this.clientId.toLowerCase()) ? this.clientId : "";
    }
    getCredentialType(key) {
        const normalizedKey = key.toLowerCase();
        const keySegments = normalizedKey.split($9797579afd7d961c$var$CACHE_KEY_SEPARATOR);
        const structuredCredentialType = keySegments[3];
        return Object.values($9797579afd7d961c$var$CredentialType).map((type)=>type.toLowerCase()).find((type)=>structuredCredentialType === type || normalizedKey.includes(`-${type}-`));
    }
    isFamilyRefreshToken(key, credentialType) {
        if (credentialType !== $9797579afd7d961c$var$CredentialType.REFRESH_TOKEN.toLowerCase()) return false;
        const normalizedKey = key.toLowerCase();
        const keySegments = normalizedKey.split($9797579afd7d961c$var$CACHE_KEY_SEPARATOR);
        return keySegments.length > 1 ? keySegments[4] === $9797579afd7d961c$var$THE_FAMILY_ID : normalizedKey.includes(`-${credentialType}-${$9797579afd7d961c$var$THE_FAMILY_ID}-`);
    }
    isContextValid(key, context) {
        const credentialType = this.getCredentialType(key);
        const isFamilyRefreshToken = credentialType && this.isFamilyRefreshToken(key, credentialType);
        const isClientBoundCredential = !!credentialType && !isFamilyRefreshToken;
        return (!isClientBoundCredential || !!context) && context === this.getBroadcastContext(key);
    }
    async updateCache(event, correlationId) {
        this.logger.trace("17cxcm", correlationId);
        const perfMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$LocalStorageUpdated);
        perfMeasurement.add({
            isBackground: true
        });
        const key = event.data?.key;
        const context = event.data?.context;
        if (typeof key !== "string" || !key) {
            this.logger.error("0e10qr", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "noKey"
            });
            return;
        }
        if (typeof context !== "string") {
            this.logger.error("16gtk4", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "noContext"
            });
            return;
        }
        if (!this.isContextValid(key, context)) {
            this.logger.trace(`04rtdy ${context}`, correlationId);
            /*
             * Discarded rather than ended: this is expected routing, not a failure.
             * BroadcastChannel has no server-side filtering, so every MSAL instance on
             * the origin receives every message and drops the ones scoped to another
             * clientId. With N instances sharing an origin each write produces N-1 of
             * these no-ops, so emitting them scales O(N^2) - and because they were
             * previously reported with success: false they bypassed both the 1% misc
             * sampler and the observability trimming in the 1P telemetry reporter,
             * shipping at full payload. On origins hosting many embedded first-party
             * apps that dwarfed all other MSAL telemetry combined. These events carry
             * no diagnostic value, so drop the measurement entirely. Genuine faults
             * such as the noKey case above are still reported.
             */ perfMeasurement.discard();
            return;
        }
        const persistedValue = this.getItem(key);
        try {
            const value = await this.getItemFromEncryptedCache(key, correlationId);
            // A newer write or removal occurred while this entry was decrypted.
            if (this.getItem(key) !== persistedValue) {
                perfMeasurement.discard();
                return;
            }
            if (!value) {
                this.memoryStorage.removeItem(key);
                this.logger.verbose("04ypih", correlationId);
            } else {
                this.memoryStorage.setItem(key, value);
                this.logger.verbose("1vzsgt", correlationId);
            }
            perfMeasurement.end({
                success: true
            });
        } catch  {
            if (this.getItem(key) !== persistedValue) {
                perfMeasurement.discard();
                return;
            }
            this.memoryStorage.removeItem(key);
            this.logger.error("0flmza", correlationId);
            perfMeasurement.end({
                success: false,
                errorCode: "cacheUpdateFailed"
            });
        }
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SessionStorage {
    constructor(){
        if (!window.sessionStorage) throw $9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$storageNotSupported, "");
    }
    async initialize() {
    // Session storage does not require initialization
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    getUserData(key) {
        return this.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    async setUserData(key, value) {
        this.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
    decryptData() {
        // Session storage does not support encryption, so this method is a no-op
        return Promise.resolve(null);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$EventType = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_SUCCESS: "msal:loginSuccess",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    BROKERED_REQUEST_START: "msal:brokeredRequestStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    BROKERED_REQUEST_SUCCESS: "msal:brokeredRequestSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    BROKERED_REQUEST_FAILURE: "msal:brokeredRequestFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache",
    BROKER_CONNECTION_ESTABLISHED: "msal:brokerConnectionEstablished"
};
/* eslint-disable header/header */ const $9797579afd7d961c$var$name = "@azure/msal-browser";
const $9797579afd7d961c$var$version = "5.27.0";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility function to remove an element from an array in place.
 * @param array - The array from which to remove the element.
 * @param element - The element to remove from the array.
 */ function $9797579afd7d961c$var$removeElementFromArray(array, element) {
    const index = array.indexOf(element);
    if (index > -1) array.splice(index, 1);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Reason an old-schema cache entry was removed during migration.
 */ const $9797579afd7d961c$var$MigrationRemovalReason = {
    Invalid: "invalid",
    TtlExpired: "ttlExpired",
    DecryptFailed: "decryptFailed",
    Expired: "expired"
};
/**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 */ class $9797579afd7d961c$var$BrowserCacheManager extends $9797579afd7d961c$var$CacheManager {
    constructor(clientId, cacheConfig, cryptoImpl, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager = $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER){
        super(clientId, cryptoImpl, logger, performanceClient, staticAuthorityOptions, tokenBindingKeyManager);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new $9797579afd7d961c$var$MemoryStorage();
        this.browserStorage = $9797579afd7d961c$var$getStorageImplementation(clientId, cacheConfig.cacheLocation, logger, performanceClient);
        this.temporaryCacheStorage = $9797579afd7d961c$var$getStorageImplementation(clientId, $9797579afd7d961c$var$BrowserCacheLocation.SessionStorage, logger, performanceClient);
        this.cookieStorage = new $9797579afd7d961c$var$CookieStorage();
        this.eventHandler = eventHandler;
    }
    async initialize(correlationId) {
        this.performanceClient.addFields({
            cacheLocation: this.cacheConfig.cacheLocation,
            cacheRetentionDays: this.cacheConfig.cacheRetentionDays
        }, correlationId);
        await this.browserStorage.initialize(correlationId);
        await this.migrateExistingCache(correlationId);
        this.trackVersionChanges(correlationId);
    }
    /**
     * Migrates any existing cache data from previous versions of MSAL.js into the current cache structure.
     */ async migrateExistingCache(correlationId) {
        let accountKeys = $9797579afd7d961c$var$getAccountKeys(this.browserStorage);
        let tokenKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            preMigrateAcntCount: accountKeys.length,
            preMigrateATCount: tokenKeys.accessToken.length,
            preMigrateITCount: tokenKeys.idToken.length,
            preMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
        for(let i = 0; i < $9797579afd7d961c$var$ACCOUNT_SCHEMA_VERSION; i++){
            const credentialSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.removeStaleAccounts(i, credentialSchema, correlationId);
        }
        // Must migrate idTokens first to ensure we have KMSI info for the rest
        for(let i = 0; i < $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; i++){
            const accountSchema = i; // For now account and credential schemas are the same, but may diverge in future
            await this.migrateIdTokens(i, accountSchema, correlationId);
        }
        const kmsiMap = this.getKMSIValues();
        for(let i = 0; i < $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; i++){
            await this.migrateAccessTokens(i, kmsiMap, correlationId);
            await this.migrateRefreshTokens(i, kmsiMap, correlationId);
        }
        accountKeys = $9797579afd7d961c$var$getAccountKeys(this.browserStorage);
        tokenKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage);
        this.performanceClient.addFields({
            postMigrateAcntCount: accountKeys.length,
            postMigrateATCount: tokenKeys.accessToken.length,
            postMigrateITCount: tokenKeys.idToken.length,
            postMigrateRTCount: tokenKeys.refreshToken.length
        }, correlationId);
    }
    /**
     * Parses entry, adds lastUpdatedAt if it doesn't exist, removes entry if expired or invalid
     * @param key
     * @param correlationId
     * @returns
     */ async updateOldEntry(key, correlationId) {
        const rawValue = this.browserStorage.getItem(key);
        const parsedValue = this.validateAndParseJson(rawValue || "");
        if (!parsedValue) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9797579afd7d961c$var$MigrationRemovalReason.Invalid
            };
        }
        if (!parsedValue.lastUpdatedAt) {
            // Add lastUpdatedAt to the existing v0 entry if it doesnt exist so we know when it's safe to remove it
            parsedValue.lastUpdatedAt = Date.now().toString();
            this.setItem(key, JSON.stringify(parsedValue), correlationId);
        } else if ($9797579afd7d961c$var$isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9797579afd7d961c$var$MigrationRemovalReason.TtlExpired
            };
        }
        const wasEncrypted = $9797579afd7d961c$var$isEncrypted(parsedValue);
        const decryptedData = wasEncrypted ? await this.browserStorage.decryptData(key, parsedValue, correlationId) : parsedValue;
        if (!decryptedData) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: wasEncrypted ? $9797579afd7d961c$var$MigrationRemovalReason.DecryptFailed : $9797579afd7d961c$var$MigrationRemovalReason.Invalid
            };
        }
        if (!$9797579afd7d961c$var$isCredentialEntity(decryptedData)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9797579afd7d961c$var$MigrationRemovalReason.Invalid
            };
        }
        if (($9797579afd7d961c$var$isAccessTokenEntity(decryptedData) || $9797579afd7d961c$var$isRefreshTokenEntity(decryptedData)) && decryptedData.expiresOn && $9797579afd7d961c$var$isTokenExpired(decryptedData.expiresOn, $9797579afd7d961c$var$DEFAULT_TOKEN_RENEWAL_OFFSET_SEC)) {
            this.browserStorage.removeItem(key);
            return {
                entry: null,
                removalReason: $9797579afd7d961c$var$MigrationRemovalReason.Expired
            };
        }
        return {
            entry: decryptedData
        };
    }
    /**
     * Remove accounts from the cache for older schema versions if they have not been updated in the last cacheRetentionDays
     * @param accountSchema
     * @param credentialSchema
     * @param correlationId
     * @returns
     */ async removeStaleAccounts(accountSchema, credentialSchema, correlationId) {
        const accountKeysToCheck = $9797579afd7d961c$var$getAccountKeys(this.browserStorage, accountSchema);
        if (accountKeysToCheck.length === 0) return;
        for (const accountKey of [
            ...accountKeysToCheck
        ]){
            this.performanceClient.incrementFields({
                oldAcntCount: 1
            }, correlationId);
            const rawValue = this.browserStorage.getItem(accountKey);
            const parsedValue = this.validateAndParseJson(rawValue || "");
            if (!parsedValue) {
                this.browserStorage.removeItem(accountKey);
                this.performanceClient.incrementFields({
                    invalidAcntCount: 1
                }, correlationId);
                $9797579afd7d961c$var$removeElementFromArray(accountKeysToCheck, accountKey);
                continue;
            }
            if (!parsedValue.lastUpdatedAt) {
                // Add lastUpdatedAt to the existing entry if it doesnt exist so we know when it's safe to remove it
                parsedValue.lastUpdatedAt = Date.now().toString();
                this.setItem(accountKey, JSON.stringify(parsedValue), correlationId);
                continue;
            } else if ($9797579afd7d961c$var$isCacheExpired(parsedValue.lastUpdatedAt, this.cacheConfig.cacheRetentionDays)) {
                // Cache expired remove account and associated tokens
                await this.removeAccountOldSchema(accountKey, parsedValue, credentialSchema, correlationId);
                this.performanceClient.incrementFields({
                    ttlExpiredAcntCount: 1
                }, correlationId);
                $9797579afd7d961c$var$removeElementFromArray(accountKeysToCheck, accountKey);
            } else if ($9797579afd7d961c$var$isEncrypted(parsedValue)) {
                // Remove accounts encrypted with a different key (session cookie expired/changed)
                const decrypted = await this.browserStorage.decryptData(accountKey, parsedValue, correlationId);
                if (!decrypted) {
                    this.browserStorage.removeItem(accountKey);
                    this.performanceClient.incrementFields({
                        decryptFailedAcntCount: 1
                    }, correlationId);
                    $9797579afd7d961c$var$removeElementFromArray(accountKeysToCheck, accountKey);
                }
            }
        }
        this.setAccountKeys(accountKeysToCheck, correlationId, accountSchema);
    }
    /**
     * Remove the given account and all associated tokens from the cache
     * @param accountKey
     * @param rawObject
     * @param credentialSchema
     * @param correlationId
     */ async removeAccountOldSchema(accountKey, rawObject, credentialSchema, correlationId) {
        const decryptedData = $9797579afd7d961c$var$isEncrypted(rawObject) ? await this.browserStorage.decryptData(accountKey, rawObject, correlationId) : rawObject;
        const homeAccountId = decryptedData?.homeAccountId;
        if (homeAccountId) {
            const tokenKeys = this.getTokenKeys(credentialSchema);
            [
                ...tokenKeys.idToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9797579afd7d961c$var$removeElementFromArray(tokenKeys.idToken, key);
            });
            [
                ...tokenKeys.accessToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9797579afd7d961c$var$removeElementFromArray(tokenKeys.accessToken, key);
            });
            [
                ...tokenKeys.refreshToken
            ].filter((key)=>key.includes(homeAccountId)).forEach((key)=>{
                this.browserStorage.removeItem(key);
                $9797579afd7d961c$var$removeElementFromArray(tokenKeys.refreshToken, key);
            });
            this.setTokenKeys(tokenKeys, correlationId, credentialSchema);
        }
        this.browserStorage.removeItem(accountKey);
    }
    /**
     * Gets key value pair mapping homeAccountId to KMSI value
     * @returns
     */ getKMSIValues() {
        const kmsiMap = {};
        const tokenKeys = this.getTokenKeys().idToken;
        for (const key of tokenKeys){
            const rawValue = this.browserStorage.getUserData(key);
            if (rawValue) {
                const idToken = JSON.parse(rawValue);
                const claims = $9797579afd7d961c$var$extractTokenClaims(idToken.secret, $9797579afd7d961c$var$base64Decode, "");
                if (claims) kmsiMap[idToken.homeAccountId] = $9797579afd7d961c$var$isKmsi(claims);
            }
        }
        return kmsiMap;
    }
    /**
     * Migrates id tokens from the old schema to the new schema, also migrates associated account object if it doesn't already exist in the new schema
     * @param credentialSchema
     * @param accountSchema
     * @param correlationId
     * @returns
     */ async migrateIdTokens(credentialSchema, accountSchema, correlationId) {
        const credentialKeysToMigrate = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.idToken.length === 0) return;
        const currentCredentialKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION);
        const currentAccountKeys = $9797579afd7d961c$var$getAccountKeys(this.browserStorage);
        const previousAccountKeys = $9797579afd7d961c$var$getAccountKeys(this.browserStorage, accountSchema);
        for (const idTokenKey of [
            ...credentialKeysToMigrate.idToken
        ]){
            this.performanceClient.incrementFields({
                oldITCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(idTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9797579afd7d961c$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredITCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedITCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidITCount: 1
                        }, correlationId);
                        break;
                }
                $9797579afd7d961c$var$removeElementFromArray(credentialKeysToMigrate.idToken, idTokenKey);
                continue;
            }
            const currentAccountKey = currentAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            const previousAccountKey = previousAccountKeys.find((key)=>key.includes(oldSchemaData.homeAccountId));
            let account = null;
            if (currentAccountKey) account = this.getAccount(currentAccountKey, correlationId);
            else if (previousAccountKey) {
                const rawValue = this.browserStorage.getItem(previousAccountKey);
                const parsedValue = this.validateAndParseJson(rawValue || "");
                account = parsedValue && $9797579afd7d961c$var$isEncrypted(parsedValue) ? await this.browserStorage.decryptData(previousAccountKey, parsedValue, correlationId) : parsedValue;
            }
            if (!account) {
                // Don't migrate idToken if we don't have an account for it
                this.performanceClient.incrementFields({
                    skipITMigrateCount: 1
                }, correlationId);
                continue;
            }
            const claims = $9797579afd7d961c$var$extractTokenClaims(oldSchemaData.secret, $9797579afd7d961c$var$base64Decode, correlationId);
            const newIdTokenKey = this.generateCredentialKey(oldSchemaData);
            const currentIdToken = this.getIdTokenCredential(newIdTokenKey, correlationId);
            const oldTokenHasSignInState = Object.keys(claims).includes("signin_state");
            const currentTokenHasSignInState = currentIdToken && Object.keys($9797579afd7d961c$var$extractTokenClaims(currentIdToken.secret, $9797579afd7d961c$var$base64Decode, correlationId) || {}).includes("signin_state");
            /**
             * Only migrate if:
             * 1. Token doesn't yet exist in current schema
             * 2. Old schema token has been updated more recently than the current one AND migrating it won't result in loss of KMSI state
             */ if (!currentIdToken || oldSchemaData.lastUpdatedAt > currentIdToken.lastUpdatedAt && (oldTokenHasSignInState || !currentTokenHasSignInState)) {
                const tenantProfiles = account.tenantProfiles || [];
                const tenantId = $9797579afd7d961c$var$getTenantIdFromIdTokenClaims(claims) || account.realm;
                if (tenantId && !tenantProfiles.find((tenantProfile)=>{
                    return tenantProfile.tenantId === tenantId;
                })) {
                    const newTenantProfile = $9797579afd7d961c$var$buildTenantProfile(account.homeAccountId, account.localAccountId, tenantId, account.nativeAccountId, claims);
                    tenantProfiles.push(newTenantProfile);
                }
                account.tenantProfiles = tenantProfiles;
                const newAccountKey = this.generateAccountKey($9797579afd7d961c$var$getAccountInfo(account));
                const kmsi = $9797579afd7d961c$var$isKmsi(claims);
                await this.setUserData(newAccountKey, JSON.stringify(account), correlationId, account.lastUpdatedAt, kmsi);
                if (!currentAccountKeys.includes(newAccountKey)) currentAccountKeys.push(newAccountKey);
                await this.setUserData(newIdTokenKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedITCount: 1
                }, correlationId);
                if (!currentCredentialKeys.idToken.includes(newIdTokenKey)) currentCredentialKeys.idToken.push(newIdTokenKey);
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
        this.setAccountKeys(currentAccountKeys, correlationId);
    }
    /**
     * Migrates access tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateAccessTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.accessToken.length === 0) return;
        const currentCredentialKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION);
        for (const accessTokenKey of [
            ...credentialKeysToMigrate.accessToken
        ]){
            this.performanceClient.incrementFields({
                oldATCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(accessTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9797579afd7d961c$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredATCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedATCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredATCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidATCount: 1
                        }, correlationId);
                        break;
                }
                $9797579afd7d961c$var$removeElementFromArray(credentialKeysToMigrate.accessToken, accessTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipATMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.accessToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedATCount: 1
                }, correlationId);
                currentCredentialKeys.accessToken.push(newKey);
            } else {
                const currentToken = this.getAccessTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedATCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Migrates refresh tokens from old cache schema to current schema
     * @param credentialSchema
     * @param kmsiMap
     * @param correlationId
     * @returns
     */ async migrateRefreshTokens(credentialSchema, kmsiMap, correlationId) {
        const credentialKeysToMigrate = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, credentialSchema);
        if (credentialKeysToMigrate.refreshToken.length === 0) return;
        const currentCredentialKeys = $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION);
        for (const refreshTokenKey of [
            ...credentialKeysToMigrate.refreshToken
        ]){
            this.performanceClient.incrementFields({
                oldRTCount: 1
            }, correlationId);
            const result = await this.updateOldEntry(refreshTokenKey, correlationId);
            const oldSchemaData = result.entry;
            if (!oldSchemaData) {
                switch(result.removalReason){
                    case $9797579afd7d961c$var$MigrationRemovalReason.TtlExpired:
                        this.performanceClient.incrementFields({
                            ttlExpiredRTCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.DecryptFailed:
                        this.performanceClient.incrementFields({
                            decryptFailedRTCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.Expired:
                        this.performanceClient.incrementFields({
                            expiredRTCount: 1
                        }, correlationId);
                        break;
                    case $9797579afd7d961c$var$MigrationRemovalReason.Invalid:
                        this.performanceClient.incrementFields({
                            invalidRTCount: 1
                        }, correlationId);
                        break;
                }
                $9797579afd7d961c$var$removeElementFromArray(credentialKeysToMigrate.refreshToken, refreshTokenKey);
                continue;
            }
            if (!(oldSchemaData.homeAccountId in kmsiMap)) {
                // Don't migrate tokens if we don't have an idToken for them
                this.performanceClient.incrementFields({
                    skipRTMigrateCount: 1
                }, correlationId);
                continue;
            }
            const newKey = this.generateCredentialKey(oldSchemaData);
            const kmsi = kmsiMap[oldSchemaData.homeAccountId];
            if (!currentCredentialKeys.refreshToken.includes(newKey)) {
                await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                this.performanceClient.incrementFields({
                    migratedRTCount: 1
                }, correlationId);
                currentCredentialKeys.refreshToken.push(newKey);
            } else {
                const currentToken = this.getRefreshTokenCredential(newKey, correlationId);
                if (!currentToken || oldSchemaData.lastUpdatedAt > currentToken.lastUpdatedAt) {
                    // If the token already exists, only overwrite it if the old token has a more recent lastUpdatedAt
                    await this.setUserData(newKey, JSON.stringify(oldSchemaData), correlationId, oldSchemaData.lastUpdatedAt, kmsi);
                    this.performanceClient.incrementFields({
                        migratedRTCount: 1
                    }, correlationId);
                }
            }
        }
        this.setTokenKeys(credentialKeysToMigrate, correlationId, credentialSchema);
        this.setTokenKeys(currentCredentialKeys, correlationId);
    }
    /**
     * Tracks upgrades and downgrades for telemetry and debugging purposes
     */ trackVersionChanges(correlationId) {
        const previousVersion = this.browserStorage.getItem($9797579afd7d961c$var$VERSION_CACHE_KEY);
        if (previousVersion) {
            this.logger.info(`1wuc87 ${previousVersion}`, correlationId);
            this.performanceClient.addGlobalFields({
                previousLibraryVersion: previousVersion
            });
        }
        if (previousVersion !== $9797579afd7d961c$var$version) this.setItem($9797579afd7d961c$var$VERSION_CACHE_KEY, $9797579afd7d961c$var$version, correlationId);
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        if (!jsonValue) return null;
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * Helper to setItem in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        const tokenKeysCount = new Array($9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)// Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
        try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = $9797579afd7d961c$var$createCacheError(e);
            if (cacheError.errorCode === $9797579afd7d961c$var$cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    // If we are currently trying to set the token keys, use the value we're trying to set
                    for(let i = 0; i <= $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; i++)if (key === $9797579afd7d961c$var$getTokenKeysCacheKey(this.clientId, i)) {
                        const tokenKeys = JSON.parse(value).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    } else {
                        const tokenKeys = this.getTokenKeys(i).accessToken;
                        accessTokenKeys.push(...tokenKeys);
                        tokenKeysCount[i] = tokenKeys.length;
                    }
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Helper to setUserData in browser storage, with cleanup in case of quota errors
     * @param key
     * @param value
     * @param correlationId
     */ async setUserData(key, value, correlationId, timestamp, kmsi) {
        const tokenKeysCount = new Array($9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION + 1).fill(0); // Array mapping schema version to number of token keys stored for that version
        const accessTokenKeys = []; // Flat map of all access token keys stored, ordered by schema version
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            // Attempt to store item in cache, if cache is full this call will throw and we'll attempt to clear space by removing access tokens from the cache one by one, starting with tokens stored by previous versions of MSAL.js
            await $9797579afd7d961c$var$invokeAsync(this.browserStorage.setUserData.bind(this.browserStorage), $9797579afd7d961c$var$SetUserData, this.logger, this.performanceClient, correlationId)(key, value, correlationId, timestamp, kmsi);
            if (i > 0) // If any tokens were removed in order to store this item update the token keys array with the tokens removed
            for(let schemaVersion = 0; schemaVersion <= $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; schemaVersion++){
                // Get the sum of all previous token counts to use as start index for this schema version
                const startIndex = tokenKeysCount.slice(0, schemaVersion).reduce((sum, count)=>sum + count, 0);
                if (startIndex >= i) break;
                const endIndex = i > startIndex + tokenKeysCount[schemaVersion] ? startIndex + tokenKeysCount[schemaVersion] : i;
                if (i > startIndex && tokenKeysCount[schemaVersion] > 0) this.removeAccessTokenKeys(accessTokenKeys.slice(startIndex, endIndex), correlationId, schemaVersion);
            }
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = $9797579afd7d961c$var$createCacheError(e);
            if (cacheError.errorCode === $9797579afd7d961c$var$cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) // If we are currently trying to set the token keys, use the value we're trying to set
                for(let i = 0; i <= $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION; i++){
                    const tokenKeys = this.getTokenKeys(i).accessToken;
                    accessTokenKeys.push(...tokenKeys);
                    tokenKeysCount[i] = tokenKeys.length;
                }
                if (accessTokenKeys.length <= i) // Nothing left to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getAccount(accountKey, correlationId) {
        this.logger.trace("1lfvm6", correlationId);
        const serializedAccount = this.browserStorage.getUserData(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !$9797579afd7d961c$var$isAccountEntity(parsedAccount)) return null;
        const account = $9797579afd7d961c$var$CacheManager.toObject({}, parsedAccount);
        this.performanceClient.addFields({
            accountCachedBy: $9797579afd7d961c$var$apiIdToName(account.cachedByApiId)
        }, correlationId);
        return account;
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ async setAccount(account, correlationId, kmsi, apiId) {
        this.logger.trace("1bz3wr", correlationId);
        const key = this.generateAccountKey($9797579afd7d961c$var$getAccountInfo(account));
        const timestamp = Date.now().toString();
        account.lastUpdatedAt = timestamp;
        account.cachedByApiId = apiId;
        await this.setUserData(key, JSON.stringify(account), correlationId, timestamp, kmsi);
        this.addAccountKeyToMap(key, correlationId);
        this.performanceClient.addFields({
            kmsi: kmsi
        }, correlationId);
    }
    setAccountKeys(accountKeys, correlationId, schemaVersion = $9797579afd7d961c$var$ACCOUNT_SCHEMA_VERSION) {
        if (accountKeys.length === 0) this.removeItem($9797579afd7d961c$var$getAccountKeysCacheKey(schemaVersion));
        else this.setItem($9797579afd7d961c$var$getAccountKeysCacheKey(schemaVersion), JSON.stringify(accountKeys), correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        return $9797579afd7d961c$var$getAccountKeys(this.browserStorage);
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("0rb85k", correlationId);
        this.logger.tracePii(`1l9bdo ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem($9797579afd7d961c$var$getAccountKeysCacheKey(), JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("0xia39", correlationId);
            return true;
        } else {
            this.logger.verbose("0161kk", correlationId);
            return false;
        }
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("1jpigu", correlationId);
        this.logger.tracePii(`1xzspl ${key}`, correlationId);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            this.setAccountKeys(accountKeys, correlationId);
        } else this.logger.trace("1dytu2", correlationId);
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ removeAccount(account, correlationId) {
        const activeAccount = this.getActiveAccount(correlationId);
        if (activeAccount?.homeAccountId === account.homeAccountId && activeAccount?.environment === account.environment) this.setActiveAccount(null, correlationId);
        super.removeAccount(account, correlationId);
        this.removeAccountKeyFromMap(this.generateAccountKey(account), correlationId);
        // Remove all other associated cache items
        this.browserStorage.getKeys().forEach((key)=>{
            if (key.includes(account.homeAccountId) && key.includes(account.environment)) this.browserStorage.removeItem(key);
        });
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const idRemoval = tokenKeys.idToken.indexOf(key);
        if (idRemoval > -1) {
            this.logger.info("05udv9", correlationId);
            tokenKeys.idToken.splice(idRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        updateTokenKeys && this.removeAccessTokenKeys([
            key
        ], correlationId);
    }
    /**
     * Remove access token key from the key map
     * @param key
     * @param correlationId
     * @param tokenKeys
     */ removeAccessTokenKeys(keys, correlationId, schemaVersion = $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION) {
        this.logger.trace("17o18n", correlationId);
        const tokenKeys = this.getTokenKeys(schemaVersion);
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`15i5d5 ${keysRemoved}`, correlationId);
            this.setTokenKeys(tokenKeys, correlationId, schemaVersion);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        const tokenKeys = this.getTokenKeys();
        const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
        if (refreshRemoval > -1) {
            this.logger.info("1f4fq3", correlationId);
            tokenKeys.refreshToken.splice(refreshRemoval, 1);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys(schemaVersion = $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION) {
        return $9797579afd7d961c$var$getTokenKeys(this.clientId, this.browserStorage, schemaVersion);
    }
    /**
     * Sets the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId, schemaVersion = $9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem($9797579afd7d961c$var$getTokenKeysCacheKey(this.clientId, schemaVersion));
            return;
        } else this.setItem($9797579afd7d961c$var$getTokenKeysCacheKey(this.clientId, schemaVersion), JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(idTokenKey);
        if (!value) {
            this.logger.trace("1jukz6", correlationId);
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !$9797579afd7d961c$var$isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("1jukz6", correlationId);
            return null;
        }
        this.logger.trace("01ju66", correlationId);
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ async setIdTokenCredential(idToken, correlationId, kmsi) {
        this.logger.trace("13hjll", correlationId);
        const idTokenKey = this.generateCredentialKey(idToken);
        const timestamp = Date.now().toString();
        idToken.lastUpdatedAt = timestamp;
        await this.setUserData(idTokenKey, JSON.stringify(idToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.idToken.indexOf(idTokenKey) === -1) {
            this.logger.info("07jy92", correlationId);
            tokenKeys.idToken.push(idTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(accessTokenKey);
        if (!value) {
            this.logger.trace("0bqvx8", correlationId);
            this.removeAccessTokenKeys([
                accessTokenKey
            ], correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !$9797579afd7d961c$var$isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("0bqvx8", correlationId);
            return null;
        }
        this.logger.trace("1o81rl", correlationId);
        return parsedAccessToken;
    }
    /**
     * Set accessToken credential to the platform cache
     * @param accessToken - the access token entity to cache
     */ async setAccessTokenCredential(accessToken, correlationId, kmsi, additionalCacheKeyHash) {
        this.logger.trace("1pondb", correlationId);
        const accessTokenKey = this.generateCredentialKey(accessToken, additionalCacheKeyHash);
        const timestamp = Date.now().toString();
        accessToken.lastUpdatedAt = timestamp;
        await this.setUserData(accessTokenKey, JSON.stringify(accessToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        const index = tokenKeys.accessToken.indexOf(accessTokenKey);
        if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
        this.logger.trace(`1onhey ${index === -1 ? "added to" : "updated in"}`, correlationId);
        tokenKeys.accessToken.push(accessTokenKey);
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.browserStorage.getUserData(refreshTokenKey);
        if (!value) {
            this.logger.trace("0jlizt", correlationId);
            this.removeRefreshToken(refreshTokenKey, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !$9797579afd7d961c$var$isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("0jlizt", correlationId);
            return null;
        }
        this.logger.trace("0nokxi", correlationId);
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ async setRefreshTokenCredential(refreshToken, correlationId, kmsi) {
        this.logger.trace("0tcg8d", correlationId);
        const refreshTokenKey = this.generateCredentialKey(refreshToken);
        const timestamp = Date.now().toString();
        refreshToken.lastUpdatedAt = timestamp;
        await this.setUserData(refreshTokenKey, JSON.stringify(refreshToken), correlationId, timestamp, kmsi);
        const tokenKeys = this.getTokenKeys();
        if (tokenKeys.refreshToken.indexOf(refreshTokenKey) === -1) {
            this.logger.info("0eckjs", correlationId);
            tokenKeys.refreshToken.push(refreshTokenKey);
            this.setTokenKeys(tokenKeys, correlationId);
        }
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     * @param correlationId
     */ getAppMetadata(appMetadataKey, correlationId) {
        const value = this.browserStorage.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !$9797579afd7d961c$var$isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("1q101h", correlationId);
            return null;
        }
        this.logger.trace("19pvg2", correlationId);
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     * @param correlationId
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("0cyma6", correlationId);
        const appMetadataKey = $9797579afd7d961c$var$generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     * @param correlationId
     */ getServerTelemetry(serverTelemetryKey, correlationId) {
        const value = this.browserStorage.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !$9797579afd7d961c$var$isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("0jk19c", correlationId);
            return null;
        }
        this.logger.trace("12jguk", correlationId);
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("1poh61", correlationId);
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key, correlationId) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("1r39oe", correlationId);
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && $9797579afd7d961c$var$isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("1ohvk3", correlationId);
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem($9797579afd7d961c$var$InMemoryCacheKeys.WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem($9797579afd7d961c$var$InMemoryCacheKeys.WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem($9797579afd7d961c$var$InMemoryCacheKeys.WRAPPER_SKU) || "";
        const version = this.internalStorage.getItem($9797579afd7d961c$var$InMemoryCacheKeys.WRAPPER_VER) || "";
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param key
     * @param entity
     * @param correlationId
     */ setAuthorityMetadata(key, entity, correlationId) {
        this.logger.trace("07w8n2", correlationId);
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey($9797579afd7d961c$var$PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.browserStorage.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            this.logger.trace("08gw0e", correlationId);
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("1t3ch7", correlationId);
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("0me1up", correlationId);
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey($9797579afd7d961c$var$PersistentCacheKeys.ACTIVE_ACCOUNT_FILTERS);
        if (account) {
            this.logger.verbose("0rsj80", correlationId);
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
        } else {
            this.logger.verbose("1bp5z5", correlationId);
            this.browserStorage.removeItem(activeAccountKey);
        }
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACTIVE_ACCOUNT_CHANGED, correlationId);
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     * @param correlationId
     */ getThrottlingCache(throttlingCacheKey, correlationId) {
        const value = this.browserStorage.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !$9797579afd7d961c$var$isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("1h4wa6", correlationId);
            return null;
        }
        this.logger.trace("0of6n8", correlationId);
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("0wfgh6", correlationId);
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * @param cacheKey
     * @param correlationId
     * @param generateKey
     */ getTemporaryCache(cacheKey, correlationId, generateKey) {
        this.logger.trace("1ordf8", correlationId);
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        return this.temporaryCacheStorage.getItem(key);
    }
    /**
     * Sets the cache item with the key and value given.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ clear(correlationId) {
        // Removes all accounts and their credentials
        this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf($9797579afd7d961c$var$PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf($9797579afd7d961c$var$PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Prepend msal.<client-id> to each key
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        if ($9797579afd7d961c$var$StringUtils.startsWith(key, $9797579afd7d961c$var$PREFIX)) return key;
        return `${$9797579afd7d961c$var$PREFIX}.${this.clientId}.${key}`;
    }
    /**
     * Generate Credential Key. All changes to the key REQUIRE a schema version update.
     * Cache Key: msal.<schema_version>|<home_account_id>|<environment>|<credential_type>|<client_id or familyId>|<realm>|<scopes>|<scheme>|<additional_cache_key_components_hash>
     *
     * @param credentialEntity
     * @param hash - optional precomputed hash of additionalCacheKeyComponents
     * @returns
     */ generateCredentialKey(credential, additionalCacheKeyHash) {
        const familyId = credential.credentialType === $9797579afd7d961c$var$CredentialType.REFRESH_TOKEN && credential.familyId || credential.clientId;
        const scheme = credential.tokenType && credential.tokenType.toLowerCase() !== $9797579afd7d961c$var$AuthenticationScheme$1.BEARER.toLowerCase() ? credential.tokenType.toLowerCase() : "";
        const credentialKey = [
            `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$CREDENTIAL_SCHEMA_VERSION}`,
            credential.homeAccountId,
            credential.environment,
            credential.credentialType,
            familyId,
            credential.realm || "",
            credential.target || "",
            scheme
        ];
        // Append precomputed component-hash segment.
        if (credential.additionalCacheKeyComponents && Object.keys(credential.additionalCacheKeyComponents).length > 0 && additionalCacheKeyHash) credentialKey.push(additionalCacheKeyHash);
        return credentialKey.join($9797579afd7d961c$var$CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Cache Key: msal.<schema_version>.<home_account_id>.<environment>.<tenant_id>
     * @param account
     * @returns
     */ generateAccountKey(account) {
        const homeTenantId = account.homeAccountId.split(".")[1];
        const accountKey = [
            `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$ACCOUNT_SCHEMA_VERSION}`,
            account.homeAccountId,
            account.environment,
            homeTenantId || account.tenantId || ""
        ];
        return accountKey.join($9797579afd7d961c$var$CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Reset all temporary cache items
     * @param correlationId
     */ resetRequestCache(correlationId) {
        this.logger.trace("0h0ynu", correlationId);
        this.removeTemporaryItem(this.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.VERIFIER));
        this.removeTemporaryItem(this.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.NATIVE_REQUEST));
        this.setInteractionInProgress(false, undefined);
    }
    cacheAuthorizeRequest(authCodeRequest, correlationId, codeVerifier) {
        this.logger.trace("1tzef5", correlationId);
        const encodedValue = $9797579afd7d961c$var$base64Encode(JSON.stringify(authCodeRequest));
        this.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.REQUEST_PARAMS, encodedValue, true);
        if (codeVerifier) {
            const encodedVerifier = $9797579afd7d961c$var$base64Encode(codeVerifier);
            this.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.VERIFIER, encodedVerifier, true);
        }
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     * @param correlationId
     */ getCachedRequest(correlationId) {
        this.logger.trace("0uen20", correlationId);
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.REQUEST_PARAMS, correlationId, true);
        if (!encodedTokenRequest) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noTokenRequestCacheError, "");
        const encodedVerifier = this.getTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.VERIFIER, correlationId, true);
        let parsedRequest;
        let verifier = "";
        try {
            parsedRequest = JSON.parse($9797579afd7d961c$var$base64Decode(encodedTokenRequest));
            if (encodedVerifier) verifier = $9797579afd7d961c$var$base64Decode(encodedVerifier);
        } catch (e) {
            this.logger.errorPii(`0ewsey ${encodedTokenRequest}`, correlationId);
            this.logger.error(`0tvdic ${e}`, correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unableToParseTokenRequestCacheError, "");
        }
        return [
            parsedRequest,
            verifier
        ];
    }
    /**
     * Gets cached native request for redirect flows
     * @param correlationId
     */ getCachedNativeRequest() {
        this.logger.trace("1yxcdm", "");
        const cachedRequest = this.getTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.NATIVE_REQUEST, "", true);
        if (!cachedRequest) {
            this.logger.trace("0mnxd4", "");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("0rrkip", "");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress()?.clientId;
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$TemporaryCacheKeys.INTERACTION_STATUS_KEY}`;
        const value = this.getTemporaryCache(key, "", false);
        try {
            return value ? JSON.parse(value) : null;
        } catch (e) {
            // Remove interaction and other temp keys if interaction status can't be parsed
            this.logger.error("0jjyys", "");
            this.removeTemporaryItem(key);
            this.resetRequestCache("");
            $9797579afd7d961c$var$clearHash(window);
            return null;
        }
    }
    setInteractionInProgress(inProgress, type = $9797579afd7d961c$var$INTERACTION_TYPE.SIGNIN, allowOverride = false, correlationId = "") {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${$9797579afd7d961c$var$PREFIX}.${$9797579afd7d961c$var$TemporaryCacheKeys.INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            const existingInteraction = this.getInteractionInProgress();
            if (existingInteraction) {
                if (allowOverride) {
                    this.logger.warning(`1pmscr ${existingInteraction.clientId} ${existingInteraction.type}`, correlationId);
                    // Cancel any active bridge monitor from the previous interaction
                    $9797579afd7d961c$var$cancelPendingBridgeResponse(this.logger, correlationId);
                    // Clear existing interaction to allow new one
                    this.removeTemporaryItem(key);
                } else throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$interactionInProgress, "");
            }
            // Set new interaction
            this.setTemporaryCache(key, JSON.stringify({
                clientId: this.clientId,
                type: type
            }), false);
        } else if (!inProgress && this.getInteractionInProgress()?.clientId === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = $9797579afd7d961c$var$createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.clientId, result.tenantId);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = $9797579afd7d961c$var$createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), // Access token expiresOn stored in seconds, converting from AuthenticationResult expiresOn stored as Date
        result.expiresOn ? $9797579afd7d961c$var$toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? $9797579afd7d961c$var$toSecondsFromDate(result.extExpiresOn) : 0, $9797579afd7d961c$var$base64Decode, request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid);
        if (request.resource) accessTokenEntity.resource = request.resource;
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId, $9797579afd7d961c$var$isKmsi($9797579afd7d961c$var$extractTokenClaims(result.idToken, $9797579afd7d961c$var$base64Decode, result.correlationId)), $9797579afd7d961c$var$ApiId.hydrateCache);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, kmsi, apiId, storeInCache);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$CacheError && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
/**
 * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
 * @param cacheLocation
 */ function $9797579afd7d961c$var$getStorageImplementation(clientId, cacheLocation, logger, performanceClient) {
    try {
        switch(cacheLocation){
            case $9797579afd7d961c$var$BrowserCacheLocation.LocalStorage:
                return new $9797579afd7d961c$var$LocalStorage(clientId, logger, performanceClient);
            case $9797579afd7d961c$var$BrowserCacheLocation.SessionStorage:
                return new $9797579afd7d961c$var$SessionStorage();
            case $9797579afd7d961c$var$BrowserCacheLocation.MemoryStorage:
            default:
                break;
        }
    } catch (e) {
        logger.error(e, "");
    }
    return new $9797579afd7d961c$var$MemoryStorage();
}
const $9797579afd7d961c$var$DEFAULT_BROWSER_CACHE_MANAGER = (clientId, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager = $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER)=>{
    const cacheOptions = {
        cacheLocation: $9797579afd7d961c$var$BrowserCacheLocation.MemoryStorage,
        cacheRetentionDays: 5
    };
    return new $9797579afd7d961c$var$BrowserCacheManager(clientId, cacheOptions, $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION, logger, performanceClient, eventHandler, staticAuthorityOptions, tokenBindingKeyManager);
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $9797579afd7d961c$var$getAllAccounts(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("1yd030", correlationId);
    return isInBrowser ? browserStorage.getAllAccounts(accountFilter, correlationId) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $9797579afd7d961c$var$getAccount(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("0u7b90", correlationId);
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("0btgll", correlationId);
        return account;
    } else {
        logger.verbose("0ltaj5", correlationId);
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $9797579afd7d961c$var$setActiveAccount(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $9797579afd7d961c$var$getActiveAccount(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$POPUP_POLL_INTERVAL_MS = 30;
let $9797579afd7d961c$var$activePopupPoller;
/**
 * Cancels legacy popup polling when an interaction is superseded.
 *
 * @internal
 * @param logger Logger for the interaction.
 */ function $9797579afd7d961c$var$cancelPendingPopupPollingResponse(logger) {
    if ($9797579afd7d961c$var$activePopupPoller) {
        logger.verbose("0g9n3p", $9797579afd7d961c$var$activePopupPoller.correlationId);
        $9797579afd7d961c$var$activePopupPoller.cancel();
    }
}
/**
 * Monitors a popup window for a URL change to the same origin as the parent application.
 * Polls the popup at a specified interval until it is redirected back to the application,
 * closed by the user, or a navigation to a same-origin URL is detected. Once a same-origin
 * URL is detected, extracts the response string (query or hash) and resolves the promise.
 *
 * @param popupWindow - The popup window to monitor for navigation.
 * @param popupWindowParent - The parent window that opened the popup.
 * @param responseMode - Response mode (`"query"` | `"fragment"`) determines whether
 *   to read `location.search` or `location.hash` from the popup once on the same
 *   origin. Any value other than `"query"` is treated as fragment.
 * @param logger - Logger instance.
 * @param unloadWindow - Event handler to remove from the parent window on cleanup.
 * @param correlationId
 */ async function $9797579afd7d961c$var$monitorPopupForHash(popupWindow, popupWindowParent, responseMode, logger, unloadWindow, correlationId) {
    let poller;
    return new Promise((resolve, reject)=>{
        logger.verbose("0cp91u", correlationId);
        const intervalId = window.setInterval(()=>{
            if (popupWindow.closed) {
                logger.error("0n69wb", correlationId);
                window.clearInterval(intervalId);
                reject(new $9797579afd7d961c$var$BrowserAuthError($9797579afd7d961c$var$userCancelled, correlationId));
                return;
            }
            let href = "";
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = popupWindow.location.href;
            } catch (e) {}
            // Don't process blank pages or cross domain
            if (!href || href === "about:blank") return;
            window.clearInterval(intervalId);
            let responseString;
            if (responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY) responseString = popupWindow.location.search;
            else responseString = popupWindow.location.hash;
            logger.verbose("0po9er", correlationId);
            resolve(responseString);
        }, $9797579afd7d961c$var$POPUP_POLL_INTERVAL_MS);
        poller = {
            correlationId: correlationId,
            cancel: ()=>{
                window.clearInterval(intervalId);
                if ($9797579afd7d961c$var$activePopupPoller === poller) $9797579afd7d961c$var$activePopupPoller = undefined;
                reject(new $9797579afd7d961c$var$BrowserAuthError($9797579afd7d961c$var$interactionInProgressCancelled, correlationId));
            }
        };
        $9797579afd7d961c$var$activePopupPoller = poller;
    }).finally(()=>{
        if (poller && $9797579afd7d961c$var$activePopupPoller === poller) $9797579afd7d961c$var$activePopupPoller = undefined;
        $9797579afd7d961c$var$cleanPopup(popupWindow, popupWindowParent, unloadWindow);
    });
}
/**
 * Performs cleanup operations after popup authentication.
 * Strips auth-response params (code/state) from the popup URL while it is still
 * open, closes the popup window, and removes the 'beforeunload' event listener
 * from the parent window.
 *
 * @param popupWindow - The popup window to be closed.
 * @param popupWindowParent - The parent window from which the event listener will be removed.
 * @param unloadWindow - The event handler function to remove.
 */ function $9797579afd7d961c$var$cleanPopup(popupWindow, popupWindowParent, unloadWindow) {
    if (!popupWindow.closed) try {
        $9797579afd7d961c$var$clearAuthResponseFromUrl(popupWindow);
    } catch  {
    // Popup may have become cross-origin or otherwise inaccessible; ignore.
    }
    popupWindow.close();
    popupWindowParent.removeEventListener("beforeunload", unloadWindow);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$BROADCAST_CHANNEL_NAME = "msal.broadcast.event";
class $9797579afd7d961c$var$EventHandler {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new $9797579afd7d961c$var$Logger({}, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        if (typeof BroadcastChannel !== "undefined") this.broadcastChannel = new BroadcastChannel($9797579afd7d961c$var$BROADCAST_CHANNEL_NAME);
        this.invokeCrossTabCallbacks = this.invokeCrossTabCallbacks.bind(this);
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || $9797579afd7d961c$var$createGuid();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`1578i0 ${id}`, "");
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`1cnec4 ${id}`, "");
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`12zotd ${callbackId}`, "");
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, correlationId, interactionType, payload, error) {
        const message = {
            eventType: eventType,
            interactionType: interactionType || null,
            payload: payload || null,
            error: error || null,
            correlationId: correlationId,
            timestamp: Date.now()
        };
        switch(eventType){
            case $9797579afd7d961c$var$EventType.LOGIN_SUCCESS:
            case $9797579afd7d961c$var$EventType.LOGOUT_SUCCESS:
            case $9797579afd7d961c$var$EventType.ACTIVE_ACCOUNT_CHANGED:
                // Send event to other open tabs / MSAL instances on same domain
                this.broadcastChannel?.postMessage(message);
        }
        // Emit event to callbacks registered in this instance
        this.invokeCallbacks(message);
    }
    /**
     * Invoke registered callbacks
     * @param message
     */ invokeCallbacks(message) {
        this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
            if (eventTypes.length === 0 || eventTypes.includes(message.eventType)) {
                this.logger.verbose(`15jpwk ${callbackId} ${message.eventType}`, "");
                callback.apply(null, [
                    message
                ]);
            }
        });
    }
    /**
     * Wrapper around invokeCallbacks to handle broadcast events received from other tabs/instances
     * @param event
     */ invokeCrossTabCallbacks(event) {
        const message = event.data;
        this.invokeCallbacks(message);
    }
    /**
     * Listen for events broadcasted from other tabs/instances
     */ subscribeCrossTab() {
        this.broadcastChannel?.addEventListener("message", this.invokeCrossTabCallbacks);
    }
    /**
     * Unsubscribe from broadcast events
     */ unsubscribeCrossTab() {
        this.broadcastChannel?.removeEventListener("message", this.invokeCrossTabCallbacks);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$BaseInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.platformAuthProvider = platformAuthProvider;
        this.correlationId = correlationId;
        this.logger = logger.clone($9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        this.performanceClient = performanceClient;
        this.tokenBindingKeyManager = tokenBindingKeyManager || new $9797579afd7d961c$var$TokenBindingKeyManager(this.logger, this.performanceClient);
    }
}
/**
 * Use to get the redirect URI configured in MSAL or construct one from the current page.
 * @param requestRedirectUri - Redirect URI from the request or undefined if not configured
 * @param clientConfigRedirectUri - Redirect URI from the client configuration or undefined if not configured
 * @param logger - Logger instance from the calling client
 * @param correlationId
 * @returns Absolute redirect URL constructed from the provided URI, config, or current page
 */ function $9797579afd7d961c$var$getRedirectUri(requestRedirectUri, clientConfigRedirectUri, logger, correlationId) {
    logger.verbose("0bd1la", correlationId);
    const redirectUri = requestRedirectUri || clientConfigRedirectUri || "";
    return $9797579afd7d961c$var$UrlString.getAbsoluteUrl(redirectUri, $9797579afd7d961c$var$getCurrentUri(), correlationId);
}
/**
 * Initializes and returns a ServerTelemetryManager with the provided telemetry configuration.
 * @param apiId - The API identifier for telemetry tracking
 * @param clientId - The client application identifier
 * @param correlationId - Unique identifier for correlating requests
 * @param browserStorage - Browser cache manager instance for storing telemetry data
 * @param logger - Optional logger instance for verbose logging
 * @param forceRefresh - Optional flag to force refresh of telemetry data
 * @param enabled - Optional flag to enable or disable server telemetry (default: true for custom_auth flows, false for standard flows)
 * @returns Configured ServerTelemetryManager instance
 */ function $9797579afd7d961c$var$initializeServerTelemetryManager(apiId, clientId, correlationId, browserStorage, logger, forceRefresh, enabled = true) {
    logger.verbose("1p12tq", correlationId);
    if (!enabled) {
        logger.verbose("0tajnr", correlationId);
        return new $9797579afd7d961c$var$StubServerTelemetryManager();
    }
    const telemetryPayload = {
        clientId: clientId,
        correlationId: correlationId,
        apiId: apiId,
        forceRefresh: false,
        wrapperSKU: browserStorage.getWrapperMetadata()[0],
        wrapperVer: browserStorage.getWrapperMetadata()[1]
    };
    return new $9797579afd7d961c$var$ServerTelemetryManager(telemetryPayload, browserStorage);
}
/**
 * Used to get a discovered version of the default authority.
 * @param params - Configuration object containing authority and cloud options
 * @param params.requestAuthority - Optional specific authority URL to use
 * @param params.requestAzureCloudOptions - Optional Azure cloud configuration options
 * @param params.requestExtraQueryParameters - Optional additional query parameters
 * @param params.account - Optional account info for instance-aware scenarios
 * @param config - Browser configuration containing auth settings
 * @param correlationId - Unique identifier for correlating requests
 * @param performanceClient - Performance monitoring client instance
 * @param browserStorage - Browser cache manager instance
 * @param logger - Logger instance for tracking operations
 * @returns Promise that resolves to a discovered Authority instance
 */ async function $9797579afd7d961c$var$getDiscoveredAuthority(config, correlationId, performanceClient, browserStorage, logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account) {
    const instanceAwareEQ = requestExtraQueryParameters && requestExtraQueryParameters.hasOwnProperty("instance_aware") ? requestExtraQueryParameters["instance_aware"] : undefined;
    const authorityOptions = {
        protocolMode: config.system.protocolMode,
        OIDCOptions: config.auth.OIDCOptions,
        knownAuthorities: config.auth.knownAuthorities,
        cloudDiscoveryMetadata: config.auth.cloudDiscoveryMetadata,
        authorityMetadata: config.auth.authorityMetadata
    };
    // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
    const resolvedAuthority = requestAuthority || config.auth.authority;
    const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : config.auth.instanceAware;
    const userAuthority = account && resolvedInstanceAware ? config.auth.authority.replace($9797579afd7d961c$var$UrlString.getDomainFromUrl(resolvedAuthority, correlationId), account.environment) : resolvedAuthority;
    // fall back to the authority from config
    const builtAuthority = $9797579afd7d961c$var$Authority.generateAuthority(userAuthority, requestAzureCloudOptions || config.auth.azureCloudOptions);
    const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$createDiscoveredInstance, $9797579afd7d961c$var$AuthorityFactoryCreateDiscoveredInstance, logger, performanceClient, correlationId)(builtAuthority, config.system.networkClient, browserStorage, authorityOptions, logger, correlationId, performanceClient);
    if (account && !discoveredAuthority.isAlias(account.environment)) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$authorityMismatch, correlationId);
    return discoveredAuthority;
}
/**
 * Clears cache and account information during logout.
 *
 * If an account is provided, removes the account from cache and, if it is the active account, sets the active account to null.
 * If no account is provided, clears all accounts and tokens from cache.
 *
 * @param browserStorage - The browser cache manager instance used to manage cache.
 * @param browserCrypto - The crypto interface for cache operations.
 * @param logger - Logger instance for logging operations.
 * @param correlationId - Correlation ID for the logout operation.
 * @param account - (Optional) The account to clear from cache. If not provided, all accounts are cleared.
 * @returns A promise that resolves when the cache has been cleared.
 */ async function $9797579afd7d961c$var$clearCacheOnLogout(browserStorage, browserCrypto, logger, correlationId, account) {
    if (account) // Clear given account.
    try {
        browserStorage.removeAccount(account, correlationId);
        logger.verbose("0s4z6h", correlationId);
    } catch (error) {
        logger.error("0mgg1d", correlationId);
    }
    else try {
        logger.verbose("0zj631", correlationId);
        // Clear all accounts and tokens
        browserStorage.clear(correlationId);
        // Clear any stray keys from IndexedDB
        await browserCrypto.clearKeystore(correlationId);
    } catch (e) {
        logger.error("12ih0c", correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$SUPPORTED_AUTHENTICATION_SCHEMES = new Set([
    $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
    $9797579afd7d961c$var$AuthenticationScheme$1.POP,
    $9797579afd7d961c$var$AuthenticationScheme$1.DPOP,
    $9797579afd7d961c$var$AuthenticationScheme$1.SSH
]);
function $9797579afd7d961c$var$validateSshRequest(request, correlationId) {
    if (!request.sshJwk) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$missingSshJwk, correlationId);
    if (!request.sshKid) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$missingSshKid, correlationId);
}
function $9797579afd7d961c$var$validateDpopRequest(request, correlationId) {
    if (!request.resourceRequestMethod?.trim() || !request.resourceRequestUri?.trim()) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$dpopMissingResourceContext, correlationId);
}
/**
 * Resolves the token-binding parameters needed before building authorize or token requests.
 * Public PCA DPoP requests use a dpopJkt thumbprint, while platform broker PoP requests use
 * a reqCnf confirmation claim. Requests that do not require request-time token binding return
 * no additional parameters.
 */ async function $9797579afd7d961c$var$getTokenBindingRequestParams(request, tokenBindingKeyManager, logger, performanceClient) {
    switch(request.authenticationScheme){
        case $9797579afd7d961c$var$AuthenticationScheme$1.DPOP:
            if (request.platformBroker) return {};
            if (request.dpopJkt) return {
                dpopJkt: request.dpopJkt
            };
            return {
                dpopJkt: await tokenBindingKeyManager.provisionTokenBindingKey({
                    tokenBindingKeyType: $9797579afd7d961c$var$AuthenticationScheme$1.DPOP.toLowerCase(),
                    tokenBindingKeyAlgorithm: $9797579afd7d961c$var$JsonWebTokenAlgorithms.ES256,
                    correlationId: request.correlationId
                })
            };
        case $9797579afd7d961c$var$AuthenticationScheme$1.POP:
            if (!request.platformBroker) return {};
            const cryptoOps = new $9797579afd7d961c$var$CryptoOps(logger, performanceClient);
            if (request.popKid) return {
                reqCnf: cryptoOps.encodeKid(request.popKid)
            };
            const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(cryptoOps, tokenBindingKeyManager, performanceClient);
            const generatedReqCnfData = await $9797579afd7d961c$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9797579afd7d961c$var$PopTokenGenerateCnf, logger, performanceClient, request.correlationId)(request, logger);
            return {
                reqCnf: generatedReqCnfData.reqCnfString
            };
        default:
            return {};
    }
}
/**
 * Initializer function for all request APIs
 * @param request
 * @param config
 * @param performanceClient
 * @param logger
 * @param correlationId
 */ async function $9797579afd7d961c$var$initializeBaseRequest(request, config, performanceClient, logger, correlationId) {
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = $9797579afd7d961c$var$AuthenticationScheme$1.BEARER;
        logger.verbose("1l4fwv", correlationId);
    } else {
        if (!$9797579afd7d961c$var$SUPPORTED_AUTHENTICATION_SCHEMES.has(validatedRequest.authenticationScheme)) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$unsupportedAuthenticationScheme, correlationId);
        switch(validatedRequest.authenticationScheme){
            case $9797579afd7d961c$var$AuthenticationScheme$1.SSH:
                $9797579afd7d961c$var$validateSshRequest(request, correlationId);
                break;
            case $9797579afd7d961c$var$AuthenticationScheme$1.DPOP:
                $9797579afd7d961c$var$validateDpopRequest(request, correlationId);
                break;
        }
        logger.verbose(`1ecmns ${validatedRequest.authenticationScheme}`, correlationId);
    }
    return validatedRequest;
}
async function $9797579afd7d961c$var$initializeSilentRequest(request, account, config, performanceClient, logger) {
    const baseRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeBaseRequest, $9797579afd7d961c$var$InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger, request.correlationId);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}
/**
 * Validates that the combination of request method, protocol mode and authorize body parameters is correct.
 * Returns the validated or defaulted HTTP method or throws if the configured combination is invalid.
 * @param interactionRequest
 * @param protocolMode
 * @returns
 */ function $9797579afd7d961c$var$validateRequestMethod(interactionRequest, protocolMode) {
    let httpMethod;
    const requestMethod = interactionRequest.httpMethod;
    if (protocolMode === $9797579afd7d961c$var$ProtocolMode.EAR) {
        // Validate that method can only be POST when protocol mode is EAR
        if (requestMethod && requestMethod !== $9797579afd7d961c$var$HttpMethod.POST) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidRequestMethodForEAR, "");
        else httpMethod = $9797579afd7d961c$var$HttpMethod.POST;
    } else // For non-EAR protocol modes, default to GET if httpMethod is not set
    httpMethod = requestMethod || $9797579afd7d961c$var$HttpMethod.GET;
    return httpMethod;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * `window.origin` of a document with an opaque origin, e.g. one sandboxed
 * without `allow-same-origin`. Read from `window.origin`, not
 * `location.origin`, which reports the real host even when sandboxed.
 */ const $9797579afd7d961c$var$OPAQUE_ORIGIN = "null";
/**
 * Returns `true` when every ancestor browsing context is same-origin with
 * `win`. A top-level document has no ancestors, so it always passes.
 */ function $9797579afd7d961c$var$allAncestorsSameOrigin(win) {
    try {
        // Sandboxed: no origin to compare ancestors against.
        if (win.origin === $9797579afd7d961c$var$OPAQUE_ORIGIN) return false;
        let current = win;
        // `window.parent` is self-referential at the top level, never falsy.
        while(current !== current.parent){
            current = current.parent;
            // Throws SecurityError if this ancestor is cross-origin.
            current.location.href;
        }
        return true;
    } catch  {
        return false;
    }
}
/**
 * Returns `true` when the top-level window has no opener, or one that is
 * same-origin with it.
 *
 * Reads the opener from `win.top`, not `win`: a framed document always reports
 * `window.opener === null` and would pass while the top window's untrusted
 * opener still holds a handle on it.
 */ function $9797579afd7d961c$var$topOpenerIsSameOriginOrAbsent(win) {
    try {
        const top = win.top;
        if (!top) // Detached from its browsing context; treat as unsafe.
        return false;
        const opener = top.opener;
        if (!opener || opener === top) return true;
        // Throws SecurityError if the opener is cross-origin.
        opener.location.href;
        return true;
    } catch  {
        return false;
    }
}
/**
 * Computes the `pocd` ("popup origin check done") authorize parameter value.
 *
 * `1` means no untrusted window can reach the popup, which is what lets Entra
 * omit the `Cross-Origin-Opener-Policy` response header for the request.
 *
 * @param config Resolved browser configuration.
 * @param win Window whose hosting environment is being checked. Defaults to the app window.
 * @returns `1` when the check passes, otherwise `0`.
 */ function $9797579afd7d961c$var$computePocd(config, win = typeof window !== "undefined" ? window : undefined) {
    /*
     * Only an explicit false opts out; anything else computes the check, so an
     * unresolved config fails closed rather than asserting pocd=1.
     */ if (config.auth.originCheck === false) return 1;
    if (!win || !$9797579afd7d961c$var$allAncestorsSameOrigin(win)) return 0;
    return $9797579afd7d961c$var$topOpenerIsSameOriginOrAbsent(win) ? 1 : 0;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $9797579afd7d961c$var$StandardInteractionClient extends $9797579afd7d961c$var$BaseInteractionClient {
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("0546u4", this.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId,
            ...logoutRequest,
            /*
             * Computed here rather than per flow so every end-session request
             * carries it, matching the authorize path.
             */ popupOriginCheckDone: $9797579afd7d961c$var$computePocd(this.config) === 1
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from account loginHint or ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = logoutRequest.account.loginHint || this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("0d7s8p", this.correlationId);
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("0pdtc3", this.correlationId);
            } else this.logger.verbose("12k4l4", this.correlationId);
        } else this.logger.verbose("07ndze", this.correlationId);
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("1vamm6", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9797579afd7d961c$var$UrlString.getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, $9797579afd7d961c$var$getCurrentUri(), validLogoutRequest.correlationId);
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("15m5g7", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("1f4xlz", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9797579afd7d961c$var$UrlString.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, $9797579afd7d961c$var$getCurrentUri(), validLogoutRequest.correlationId);
            } else {
                this.logger.verbose("17s5rf", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = $9797579afd7d961c$var$UrlString.getAbsoluteUrl($9797579afd7d961c$var$getCurrentUri(), $9797579afd7d961c$var$getCurrentUri(), validLogoutRequest.correlationId);
            }
        } else this.logger.verbose("0ljv63", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) {
                this.logger.verbose("0u5bmc", this.correlationId);
                return idTokenClaims.login_hint;
            } else this.logger.verbose("0mvp54", this.correlationId);
        } else this.logger.verbose("1e7bdp", this.correlationId);
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        // Create auth module.
        const clientConfig = await $9797579afd7d961c$var$invokeAsync(this.getClientConfiguration.bind(this), $9797579afd7d961c$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new $9797579afd7d961c$var$AuthorizationCodeClient(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        const discoveredAuthority = params.authority || await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, requestAzureCloudOptions, requestExtraQueryParameters, account);
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri,
                isMcp: this.config.auth.isMcp
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cryptoInterface: this.browserCrypto,
            tokenBindingKeyManager: this.tokenBindingKeyManager,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: $9797579afd7d961c$var$BrowserConstants.MSAL_SKU,
                version: $9797579afd7d961c$var$version,
                cpu: "",
                os: ""
            },
            telemetry: this.config.telemetry
        };
    }
}
/**
 * Helper to initialize required request parameters for interactive APIs and ssoSilent().
 *
 * @param request - The authentication request object (RedirectRequest, PopupRequest, or SsoSilentRequest).
 * @param interactionType - The type of interaction (e.g., redirect, popup, silent).
 * @param config - The browser configuration object.
 * @param browserCrypto - The cryptographic interface for browser operations.
 * @param browserStorage - The browser storage manager instance.
 * @param logger - The logger instance for logging messages.
 * @param performanceClient - The performance client for telemetry.
 * @param correlationId - The correlation ID for the request.
 * @returns A promise that resolves to a CommonAuthorizationUrlRequest object with initialized parameters.
 */ async function $9797579afd7d961c$var$initializeAuthorizationRequest(request, interactionType, config, browserCrypto, browserStorage, logger, performanceClient, correlationId) {
    const redirectUri = $9797579afd7d961c$var$getRedirectUri(request.redirectUri, config.auth.redirectUri, logger, correlationId);
    if (new URL(redirectUri).origin !== new URL(window.location.href).origin) {
        logger.warning("08qbvw", correlationId);
        performanceClient.addFields({
            isRedirectUriCrossOrigin: true
        }, correlationId);
    }
    const browserState = {
        interactionType: interactionType
    };
    const state = $9797579afd7d961c$var$setRequestState(browserCrypto, request && request.state || "", browserState, correlationId);
    const baseRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeBaseRequest, $9797579afd7d961c$var$InitializeBaseRequest, logger, performanceClient, correlationId)({
        ...request,
        correlationId: correlationId
    }, config, performanceClient, logger, correlationId);
    const interactionRequest = {
        ...baseRequest,
        redirectUri: redirectUri,
        state: state,
        nonce: request.nonce || $9797579afd7d961c$var$createNewGuid(),
        responseMode: config.auth.OIDCOptions.responseMode
    };
    const validatedRequest = {
        ...interactionRequest,
        httpMethod: $9797579afd7d961c$var$validateRequestMethod(interactionRequest, config.system.protocolMode)
    };
    // Skip active account lookup if either login hint or session id is set
    if (request.loginHint || request.sid) return validatedRequest;
    const account = request.account || browserStorage.getActiveAccount(correlationId);
    if (account) {
        logger.verbose("1eqlb3", correlationId);
        logger.verbosePii(`0tf99t ${account.homeAccountId}`, correlationId);
        validatedRequest.account = account;
    }
    return validatedRequest;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true when the supplied user agent is using Safari
 *
 * @internal
 */ function $9797579afd7d961c$var$isSafari(userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "") {
    if (/OPR\/|OPiOS|PhantomJS|SamsungBrowser|Edge|EdgiOS|EdgA/.test(userAgent)) return false;
    const browserNavigator = typeof navigator !== "undefined" ? navigator : undefined;
    if (/Edg/.test(userAgent) || browserNavigator?.userAgentData?.brands?.some((brand)=>brand?.brand === "Microsoft Edge")) return false;
    if (/Electron|CriOS|Chrome|Trident|FxiOS|Firefox/.test(userAgent)) return false;
    return /Safari/.test(userAgent) || /AppleWebKit/.test(userAgent);
}
/**
 * Returns true when EAR should be used for the current request.
 *
 * Safari cannot complete EAR's cross-origin form POST, so requests configured
 * for EAR transparently use authorization code flow instead.
 *
 * @internal
 */ function $9797579afd7d961c$var$shouldUseEar(protocolMode, logger, performanceClient, correlationId, userAgent) {
    if (protocolMode !== $9797579afd7d961c$var$ProtocolMode.EAR) return false;
    if (!$9797579afd7d961c$var$isSafari(userAgent)) return true;
    logger.verbose("0wirye", correlationId);
    performanceClient.addFields({
        "ext.earFallbackReason": "safari"
    }, correlationId);
    return false;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * postMessage envelope type used to relay an auth response from a popup-relay
 * page (see `runPopupRelay`) back to the embedded frame that opened it. See
 * {@link BrowserAuthOptions.popupRelayUri}.
 *
 * Kept dependency-free so both the relay-page entry (`./index.js`) and the
 * client-side helpers (`./relayClient.js`) can import it without either bundle
 * pulling in the other's dependencies.
 *
 * @internal
 */ const $9797579afd7d961c$var$POPUP_RELAY_RESPONSE_TYPE = "msal:popup-relay-response:v1";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Builds the URL of the popup-relay page to open. The action the relay page
 * must perform (GET navigation or POST form) is carried in the page's hash
 * (client-side only, never sent to a server), keyed by the per-request
 * library-state `id` so the relay page can listen on the right BroadcastChannel
 * and echo the id back. The relay URI is resolved against the app origin, so it
 * must be same-origin as the embedded frame. See `runPopupRelay`.
 *
 * @internal
 */ function $9797579afd7d961c$var$buildPopupRelayUrl(popupRelayUri, id, action, correlationId) {
    const req = {
        id: id,
        ...action
    };
    const target = new URL(popupRelayUri, window.location.origin);
    /*
     * The relay page must be same-origin as the embedded frame: the response is
     * relayed back via postMessage and only accepted from this origin, and a
     * cross-origin page would also receive the relayed /authorize request. Fail
     * fast with a clear error instead of silently relaying to (and timing out
     * against) the wrong origin.
     */ if (target.origin !== window.location.origin) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$popupRelayUnsupportedFlow, correlationId, "popup_relay_cross_origin");
    const hashParams = new URLSearchParams();
    hashParams.set("req", JSON.stringify(req));
    target.hash = hashParams.toString();
    return target.toString();
}
/**
 * Waits for the popup-relay page to relay the raw auth response back to the
 * embedded frame via postMessage. Used in place of `waitForBridgeResponse`
 * when `auth.popupRelayUri` is configured, because third-party storage
 * partitioning blocks the BroadcastChannel the redirect bridge uses from
 * reaching the embedded frame.
 *
 * The response is accepted only from the popup window we opened, on our own
 * origin (the relay page is same-origin as the embedded frame), and only when
 * it carries the matching per-request library-state id.
 *
 * @internal
 */ async function $9797579afd7d961c$var$waitForPopupRelayResponse(timeoutMs, logger, request, popupWindow, performanceClient) {
    return new Promise((resolve, reject)=>{
        const correlationId = request.correlationId;
        logger.verbose("1d05g9", correlationId);
        performanceClient.addFields({
            redirectBridgeTimeoutMs: timeoutMs
        }, correlationId);
        const { libraryState: libraryState } = $9797579afd7d961c$var$parseRequestState($9797579afd7d961c$var$base64Decode, request.state || "", correlationId);
        const expectedId = libraryState.id;
        const expectedOrigin = window.location.origin;
        let settled = false;
        const cleanup = ()=>{
            window.removeEventListener("message", onMessage);
            clearTimeout(timeoutId);
            clearInterval(closedPoll);
        };
        const onMessage = (event)=>{
            if (event.origin !== expectedOrigin || event.source !== popupWindow) return;
            const data = event.data;
            if (!data || data.type !== $9797579afd7d961c$var$POPUP_RELAY_RESPONSE_TYPE || data.id !== expectedId) return;
            if (settled) return;
            settled = true;
            cleanup();
            if (data.error) reject($9797579afd7d961c$var$createBrowserAuthError(data.error, correlationId));
            else if (data.payload) resolve(data.payload);
            else reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$redirectBridgeEmptyResponse, correlationId));
        };
        window.addEventListener("message", onMessage);
        const timeoutId = window.setTimeout(()=>{
            if (settled) return;
            settled = true;
            cleanup();
            reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$timedOut, correlationId, "popup_relay_timeout"));
        }, timeoutMs);
        const closedPoll = window.setInterval(()=>{
            if (popupWindow.closed && !settled) {
                settled = true;
                cleanup();
                reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$userCancelled, correlationId));
            }
        }, 500);
    });
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $9797579afd7d961c$var$extractBrowserRequestState(browserCrypto, state, correlationId) {
    if (!state) return null;
    try {
        const requestStateObj = $9797579afd7d961c$var$parseRequestState(browserCrypto.base64Decode, state, correlationId);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidState, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$deserializeResponse(responseString, responseLocation, logger, correlationId) {
    // Deserialize hash fragment response parameters.
    const serverParams = $9797579afd7d961c$var$getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!$9797579afd7d961c$var$stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`18h0l1 ${responseLocation} ${responseLocation}`, correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$hashEmptyError, correlationId);
        } else {
            logger.error(`13pl0s ${responseLocation} ${responseLocation}`, correlationId);
            logger.errorPii(`1097vx ${responseLocation} ${responseString}`, correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$hashDoesNotContainKnownProperties, correlationId);
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $9797579afd7d961c$var$validateInteractionType(response, browserCrypto, interactionType, correlationId) {
    if (!response.state) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noStateInHash, correlationId);
    const platformStateObj = $9797579afd7d961c$var$extractBrowserRequestState(browserCrypto, response.state, correlationId);
    if (!platformStateObj) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unableToParseState, correlationId);
    if (platformStateObj.interactionType !== interactionType) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$stateInteractionTypeMismatch, correlationId);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $9797579afd7d961c$var$InteractionHandler {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request, apiId) {
        let authCodeResponse;
        try {
            authCodeResponse = $9797579afd7d961c$var$getAuthorizationCodePayload(response, request.state, request.correlationId);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$ServerError && e.subError === $9797579afd7d961c$var$userCancelled) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$userCancelled, request.correlationId);
            else throw e;
        }
        return $9797579afd7d961c$var$invokeAsync(this.handleCodeResponseFromServer.bind(this), $9797579afd7d961c$var$HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request, apiId);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param request
     * @param validateNonce
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, apiId, validateNonce = true) {
        this.logger.trace("0mf2hb", request.correlationId);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await $9797579afd7d961c$var$invokeAsync(this.authModule.acquireToken.bind(this.authModule), $9797579afd7d961c$var$AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, apiId, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: $9797579afd7d961c$var$CcsCredentialType.HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: $9797579afd7d961c$var$CcsCredentialType.UPN
        };
        return null;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token types supported by the platform broker request contract.
 */ const $9797579afd7d961c$var$PlatformAuthTokenType = {
    DPOP_WITH_PROOF: "dpop+proof"
};
const $9797579afd7d961c$var$PROOF_OF_POSSESSION_TOKEN_TYPES = [
    $9797579afd7d961c$var$AuthenticationScheme$1.POP,
    $9797579afd7d961c$var$AuthenticationScheme$1.DPOP,
    $9797579afd7d961c$var$PlatformAuthTokenType.DPOP_WITH_PROOF
];
/**
 * Returns whether a platform broker token type requires proof request metadata.
 */ function $9797579afd7d961c$var$isProofOfPossessionTokenType(tokenType) {
    return tokenType !== undefined && $9797579afd7d961c$var$PROOF_OF_POSSESSION_TOKEN_TYPES.includes(tokenType);
}
/**
 * Adds canonical proof request fields to the broker no-cache property bag.
 */ function $9797579afd7d961c$var$createPlatformAuthExtraParametersNoCache(extraParametersNoCache, isProofOfPossessionRequest, resourceRequestMethod, resourceRequestUri, dpopNonce) {
    if (!isProofOfPossessionRequest) return extraParametersNoCache;
    return {
        ...extraParametersNoCache,
        ...resourceRequestMethod && {
            pop_method: resourceRequestMethod
        },
        ...resourceRequestUri && {
            pop_url: resourceRequestUri
        },
        ...dpopNonce && {
            pop_nonce: dpopNonce
        }
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$contentError = "ContentError";
const $9797579afd7d961c$var$pageException = "PageException";
const $9797579afd7d961c$var$userSwitch = "user_switch";
const $9797579afd7d961c$var$unsupportedMethod = "unsupported_method";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $9797579afd7d961c$var$USER_INTERACTION_REQUIRED = "USER_INTERACTION_REQUIRED";
const $9797579afd7d961c$var$USER_CANCEL = "USER_CANCEL";
const $9797579afd7d961c$var$NO_NETWORK = "NO_NETWORK";
const $9797579afd7d961c$var$DISABLED = "DISABLED";
const $9797579afd7d961c$var$ACCOUNT_UNAVAILABLE = "ACCOUNT_UNAVAILABLE";
const $9797579afd7d961c$var$UI_NOT_ALLOWED = "UI_NOT_ALLOWED";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$INVALID_METHOD_ERROR = -2147186943;
class $9797579afd7d961c$var$NativeAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, description, ext){
        super(errorCode, correlationId, description || $9797579afd7d961c$var$getDefaultErrorMessage(errorCode));
        Object.setPrototypeOf(this, $9797579afd7d961c$var$NativeAuthError.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $9797579afd7d961c$var$isFatalNativeAuthError(error) {
    if (error.ext && error.ext.status && error.ext.status === $9797579afd7d961c$var$DISABLED) return true;
    if (error.ext && error.ext.error && error.ext.error === $9797579afd7d961c$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case $9797579afd7d961c$var$contentError:
        case $9797579afd7d961c$var$pageException:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $9797579afd7d961c$var$createNativeAuthError(code, correlationId, description, ext) {
    let error;
    if (ext && ext.status) {
        switch(ext.status){
            case $9797579afd7d961c$var$ACCOUNT_UNAVAILABLE:
                error = $9797579afd7d961c$var$createInteractionRequiredAuthError($9797579afd7d961c$var$nativeAccountUnavailable, correlationId, $9797579afd7d961c$var$getDefaultErrorMessage(code));
                break;
            case $9797579afd7d961c$var$USER_INTERACTION_REQUIRED:
                error = new $9797579afd7d961c$var$InteractionRequiredAuthError(code, correlationId, description);
                break;
            case $9797579afd7d961c$var$USER_CANCEL:
                error = $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$userCancelled, correlationId);
                break;
            case $9797579afd7d961c$var$NO_NETWORK:
                error = $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noNetworkConnectivity, correlationId);
                break;
            case $9797579afd7d961c$var$UI_NOT_ALLOWED:
                error = $9797579afd7d961c$var$createInteractionRequiredAuthError($9797579afd7d961c$var$uiNotAllowed, correlationId);
                break;
            default:
                error = new $9797579afd7d961c$var$NativeAuthError(code, correlationId, description, ext);
        }
        return error;
    }
    error = new $9797579afd7d961c$var$NativeAuthError(code, correlationId, description, ext);
    return error;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SilentCacheClient extends $9797579afd7d961c$var$StandardInteractionClient {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const clientConfig = await $9797579afd7d961c$var$invokeAsync(this.getClientConfiguration.bind(this), $9797579afd7d961c$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new $9797579afd7d961c$var$SilentFlowClient(clientConfig, this.performanceClient);
        this.logger.verbose("0wa871", this.correlationId);
        try {
            const response = await $9797579afd7d961c$var$invokeAsync(silentAuthClient.acquireCachedToken.bind(silentAuthClient), $9797579afd7d961c$var$SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof $9797579afd7d961c$var$BrowserAuthError && error.errorCode === $9797579afd7d961c$var$cryptoKeyNotFound) this.logger.verbose("06wena", this.correlationId);
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return $9797579afd7d961c$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$PlatformAuthInteractionClient extends $9797579afd7d961c$var$BaseInteractionClient {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId, tokenBindingKeyManager){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider, tokenBindingKeyManager);
        this.apiId = apiId;
        this.accountId = accountId;
        this.platformAuthProvider = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new $9797579afd7d961c$var$SilentCacheClient(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, provider, this.tokenBindingKeyManager);
        const extensionName = this.platformAuthProvider.getExtensionName();
        this.skus = $9797579afd7d961c$var$ServerTelemetryManager.makeExtraSkuString({
            libraryName: $9797579afd7d961c$var$BrowserConstants.MSAL_SKU,
            libraryVersion: $9797579afd7d961c$var$version,
            extensionName: extensionName,
            extensionVersion: this.platformAuthProvider.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [$9797579afd7d961c$var$X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request, cacheLookupPolicy) {
        this.logger.trace("03qeos", this.correlationId);
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$NativeInteractionClientAcquireToken, this.correlationId);
        const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        // initialize native request (statically builds the request; does not contact the broker)
        let nativeRequest;
        try {
            nativeRequest = await $9797579afd7d961c$var$invokeAsync(this.initializePlatformRequest.bind(this), $9797579afd7d961c$var$PlatformAuthInteractionClientInitializeRequest, this.logger, this.performanceClient, this.correlationId)(request);
        } catch (e) {
            /*
             * Request initialization (e.g. PoP token generation or authority
             * resolution) failed before the broker was contacted, so end the
             * measurement here to avoid an orphaned sub-measurement.
             * Broker was never engaged, so this was not a native broker outcome.
             */ nativeATMeasurement.add({
                isNativeBroker: false
            });
            nativeATMeasurement.end({
                success: false
            }, e);
            throw e;
        }
        // check if the tokens can be retrieved from internal cache
        try {
            const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
            // Served from the native internal cache; token did not come directly from the broker
            nativeATMeasurement.add({
                isNativeBroker: false
            });
            nativeATMeasurement.end({
                success: true,
                fromCache: true
            });
            return result;
        } catch (e) {
            if (cacheLookupPolicy === $9797579afd7d961c$var$CacheLookupPolicy.AccessToken) {
                this.logger.info("0eitbc", this.correlationId);
                nativeATMeasurement.add({
                    isNativeBroker: false
                });
                nativeATMeasurement.end({
                    success: false
                });
                throw e;
            }
            // continue with a native call for any and all errors
            this.logger.info("0957j1", this.correlationId);
        }
        // dispatch the request to the broker
        try {
            const validatedResponse = await this.platformAuthProvider.sendMessage(nativeRequest);
            const result = await $9797579afd7d961c$var$invokeAsync(this.handleNativeResponse.bind(this), $9797579afd7d961c$var$PlatformAuthHandleNativeResponse, this.logger, this.performanceClient, this.correlationId)(validatedResponse, nativeRequest, reqTimestamp, request.storeInCache);
            nativeATMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            serverTelemetryManager.clearNativeBrokerErrorCode();
            return result;
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$NativeAuthError) serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            nativeATMeasurement.end({
                success: false
            }, e);
            this.setBrokerErrorTelemetry(e);
            throw e;
        }
    }
    /**
     * Records platform-broker error telemetry on the root event for the current
     * correlationId. `isNativeBroker` is set optimistically to true because the
     * broker was engaged; when the caller subsequently falls back to a web flow
     * that succeeds, the root success measurement overrides it to false via
     * `result.fromPlatformBroker`. Terminal broker errors (no fallback) retain
     * true. `brokerErrorName`/`brokerErrorCode` are recorded when the error is an `AuthError`.
     * @param error error thrown by the broker interaction
     */ setBrokerErrorTelemetry(error) {
        if (error instanceof $9797579afd7d961c$var$AuthError) this.performanceClient.addFields({
            isNativeBroker: true,
            brokerErrorName: error.name,
            brokerErrorCode: error.errorCode
        }, this.correlationId);
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        const silentRequest = {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: $9797579afd7d961c$var$ScopeSet.fromString(request.scope, this.correlationId).asArray(),
            account: cachedAccount,
            forceRefresh: false,
            resource: request.extraParameters?.resource
        };
        // Preserve FMI partition semantics for silent cache filtering.
        if (request.attributeTokens) silentRequest.attributeTokens = request.attributeTokens.split(" ");
        return silentRequest;
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("1ndf3e", this.correlationId);
            throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noAccountFound, this.correlationId);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, this.correlationId);
        if (!account) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$noAccountFound, this.correlationId);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const idToken = this.browserStorage.getIdToken(account, this.correlationId, this.browserStorage.getTokenKeys(), account.tenantId);
            const idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(idToken?.secret || "", $9797579afd7d961c$var$base64Decode, this.correlationId);
            const fullAccount = $9797579afd7d961c$var$updateAccountTenantProfileData(account, undefined, idTokenClaims, idToken?.secret);
            return {
                ...result,
                idToken: idToken?.secret || "",
                idTokenClaims: idTokenClaims,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     * @param {HandleRedirectPromiseOptions} options
     */ async acquireTokenRedirect(request, rootMeasurement, options) {
        this.logger.trace("0luikq", this.correlationId);
        const nativeRequest = await $9797579afd7d961c$var$invokeAsync(this.initializePlatformRequest.bind(this), $9797579afd7d961c$var$PlatformAuthInteractionClientInitializeRequest, this.logger, this.performanceClient, this.correlationId)(request);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            await this.platformAuthProvider.sendMessage(nativeRequest);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof $9797579afd7d961c$var$NativeAuthError) {
                const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
                serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ($9797579afd7d961c$var$isFatalNativeAuthError(e)) {
                    /*
                     * Fatal error on redirect initiate always falls back to a
                     * regular web redirect, so this request did not complete
                     * natively. Token telemetry for the eventual outcome lands
                     * in handleRedirectPromise (phase 2).
                     */ this.setBrokerErrorTelemetry(e);
                    throw e;
                }
            }
        }
        this.browserStorage.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.NATIVE_REQUEST, JSON.stringify({
            ...nativeRequest,
            storeInCache: request.storeInCache
        }), true);
        const navigationOptions = {
            apiId: $9797579afd7d961c$var$ApiId.acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = navigateToLoginRequestUrl ? $9797579afd7d961c$var$UrlString.getAbsoluteUrl(request.redirectStartPage || window.location.href, $9797579afd7d961c$var$getCurrentUri(), this.correlationId) : $9797579afd7d961c$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise() {
        this.logger.trace("1c5lhw", this.correlationId);
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("0le6uv", this.correlationId);
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("0a6zjb", this.correlationId);
            this.performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, this.correlationId);
            return null;
        }
        /*
         * storeInCache is a client-side cache directive persisted alongside the cached
         * request (not a broker-contract parameter), so extract it here before resending.
         */ const { prompt: prompt, storeInCache: storeInCache, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("0ac34v", this.correlationId);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.NATIVE_REQUEST));
        const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
        try {
            this.logger.verbose("003x5a", this.correlationId);
            const response = await this.platformAuthProvider.sendMessage(request);
            const authResult = await $9797579afd7d961c$var$invokeAsync(this.handleNativeResponse.bind(this), $9797579afd7d961c$var$PlatformAuthHandleNativeResponse, this.logger, this.performanceClient, this.correlationId)(response, request, reqTimestamp, storeInCache);
            const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
            serverTelemetryManager.clearNativeBrokerErrorCode();
            return authResult;
        } catch (e) {
            this.setBrokerErrorTelemetry(e);
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("0u2sjm", this.correlationId);
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp, storeInCache) {
        this.logger.trace("1bojln", this.correlationId);
        // generate identifiers
        const idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(response.id_token, $9797579afd7d961c$var$base64Decode, this.correlationId);
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        // add exception for double brokering, please note this is temporary and will be fortified in future
        if (request.extraParameters?.child_client_id && response.account.id !== request.accountId) this.logger.info("1ub1in", this.correlationId);
        else if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw $9797579afd7d961c$var$createNativeAuthError($9797579afd7d961c$var$userSwitch, this.correlationId);
        // Get the preferred_cache domain for the given authority
        const authority = await $9797579afd7d961c$var$getDiscoveredAuthority(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, request.authority);
        const baseAccount = $9797579afd7d961c$var$buildAccountToCache(this.browserStorage, authority, homeAccountIdentifier, $9797579afd7d961c$var$base64Decode, this.correlationId, idTokenClaims, response.client_info, authority.getPreferredCache(), idTokenClaims.tid, undefined, response.account.id, this.logger, this.performanceClient);
        // Ensure expires_in is in number format
        response.expires_in = Number(response.expires_in);
        // generate authenticationResult
        const result = await $9797579afd7d961c$var$invokeAsync(this.generateAuthenticationResult.bind(this), $9797579afd7d961c$var$NativeGenerateAuthResult, this.logger, this.performanceClient, this.correlationId)(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        await $9797579afd7d961c$var$invokeAsync(this.cacheAccount.bind(this), $9797579afd7d961c$var$PlatformAuthCacheAccount, this.logger, this.performanceClient, this.correlationId)(baseAccount, $9797579afd7d961c$var$isKmsi(idTokenClaims));
        await $9797579afd7d961c$var$invokeAsync(this.cacheNativeTokens.bind(this), $9797579afd7d961c$var$PlatformAuthCacheNativeTokens, this.logger, this.performanceClient, this.correlationId)(response, request, homeAccountIdentifier, idTokenClaims, result.tenantId, reqTimestamp, authority.getPreferredCache(), storeInCache);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = $9797579afd7d961c$var$generateHomeAccountId(response.client_info || "", $9797579afd7d961c$var$AuthorityType.Default, this.logger, this.browserCrypto, this.correlationId, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(requestScopes, responseScopes) {
        return responseScopes ? $9797579afd7d961c$var$ScopeSet.fromString(responseScopes, this.correlationId) : $9797579afd7d961c$var$ScopeSet.fromString(requestScopes, this.correlationId);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === $9797579afd7d961c$var$AuthenticationScheme$1.POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("0coqhu", this.correlationId);
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$keyIdMissing, this.correlationId);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response.properties.MATS);
        // If scopes not returned in server response, use request scopes
        const responseScopes = this.generateScopes(request.scope, response.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || "";
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || "";
        const accountInfo = $9797579afd7d961c$var$updateAccountTenantProfileData($9797579afd7d961c$var$getAccountInfo(accountEntity), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) {
            accountInfo.nativeAccountId = response.account.id;
            // Also update the matching tenant profile (source of truth)
            const targetTenantId = tid || accountInfo.tenantId;
            const tenantProfile = accountInfo.tenantProfiles?.get(targetTenantId);
            if (tenantProfile) tenantProfile.nativeAccountId = response.account.id;
        }
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === $9797579afd7d961c$var$AuthenticationScheme$1.POP ? $9797579afd7d961c$var$AuthenticationScheme$1.POP : $9797579afd7d961c$var$AuthenticationScheme$1.BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            // Request timestamp and NativeResponse expires_in are in seconds, converting to Date for AuthenticationResult
            expiresOn: $9797579afd7d961c$var$toDateFromSeconds(reqTimestamp + response.expires_in),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromPlatformBroker: true,
            ...request.extraParameters?.resource && {
                resource: request.extraParameters.resource
            }
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ async cacheAccount(accountEntity, kmsi) {
        // Store the account info and hence `nativeAccountId` in browser cache
        await this.browserStorage.setAccount(accountEntity, this.correlationId, kmsi, this.apiId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext($9797579afd7d961c$var$getAccountInfo(accountEntity), this.correlationId);
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ async cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, tenantId, reqTimestamp, environment, storeInCache) {
        const cachedIdToken = $9797579afd7d961c$var$createIdTokenEntity(homeAccountIdentifier, environment, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === $9797579afd7d961c$var$AuthenticationScheme$1.POP ? $9797579afd7d961c$var$SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response.scope, request.scope);
        const additionalCacheKeyComponents = request.attributeTokens ? {
            attribute_tokens: request.attributeTokens
        } : undefined;
        const cachedAccessToken = $9797579afd7d961c$var$createAccessTokenEntity(homeAccountIdentifier, environment, response.access_token, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, $9797579afd7d961c$var$base64Decode, request.correlationId, undefined, request.tokenType, undefined, request.keyId, additionalCacheKeyComponents);
        if (request.extraParameters?.resource) cachedAccessToken.resource = request.extraParameters.resource;
        // save idtoken credential in configured browser storage
        if (!!cachedIdToken && storeInCache?.idToken !== false) await this.browserStorage.setIdTokenCredential(cachedIdToken, this.correlationId, $9797579afd7d961c$var$isKmsi(idTokenClaims));
        // save access token credential in memory storage
        const nativeCacheRecord = {
            accessToken: cachedAccessToken
        };
        return this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, this.correlationId, $9797579afd7d961c$var$isKmsi(idTokenClaims), this.apiId, storeInCache);
    }
    getExpiresInValue(tokenType, expiresIn) {
        return tokenType === $9797579afd7d961c$var$AuthenticationScheme$1.POP ? $9797579afd7d961c$var$SHR_NONCE_VALIDITY : (typeof expiresIn === "string" ? parseInt(expiresIn, 10) : expiresIn) || 0;
    }
    addTelemetryFromNativeResponse(matsResponse) {
        const mats = this.getMATSFromResponse(matsResponse);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.platformAuthProvider.getExtensionId(),
            extensionVersion: this.platformAuthProvider.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(matsResponse) {
        if (matsResponse) try {
            return JSON.parse(matsResponse);
        } catch (e) {
            this.logger.error("0b3l57", this.correlationId);
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("1okqev", this.correlationId);
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializePlatformRequest(request) {
        this.logger.trace("1xdm2a", this.correlationId);
        const canonicalAuthority = await this.getCanonicalAuthority(request);
        // ignore config claims if skipBrokerClaims is set to true and this is a brokered authentication flow
        const configClaims = request.skipBrokerClaims && !!request.embeddedClientId ? undefined : this.config.auth.clientCapabilities;
        /*
         * scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
         * attributeTokens is destructured out because PlatformAuthRequest represents it as a pre-serialized string, not the caller-provided Array<string>.
         */ const { scopes: scopes, claims: claims, extraParametersNoCache: extraParametersNoCache, dpopNonce: dpopNonce } = request;
        const scopeSet = new $9797579afd7d961c$var$ScopeSet([
            ...scopes || [],
            ...$9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1
        ], this.correlationId);
        const mergedClaims = $9797579afd7d961c$var$buildMergedClaims$1(claims, configClaims?.length ? configClaims : undefined);
        const hasAttributeTokens = !!request.attributeTokens?.length;
        this.performanceClient?.addFields({
            hasAttributeTokens: hasAttributeTokens
        }, this.correlationId);
        const validatedRequest = {
            claims: mergedClaims,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: $9797579afd7d961c$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId),
            prompt: this.getPrompt(request.prompt),
            correlationId: this.correlationId,
            isSts: false,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            nonce: request.nonce,
            state: request.state,
            loginHint: request.loginHint,
            extraParameters: {
                ...request.extraParameters,
                ...request.resource && {
                    resource: request.resource
                }
            },
            extendedExpiryToken: false,
            keyId: request.popKid,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            shrNonce: request.shrNonce,
            extraParametersNoCache: $9797579afd7d961c$var$createPlatformAuthExtraParametersNoCache(extraParametersNoCache, $9797579afd7d961c$var$isProofOfPossessionTokenType(request.authenticationScheme), request.resourceRequestMethod, request.resourceRequestUri, dpopNonce)
        };
        if (hasAttributeTokens) validatedRequest.attributeTokens = $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens);
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$invalidPopTokenRequest, this.correlationId);
        this.handleExtraBrokerParams(validatedRequest, request.embeddedClientId);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = $9797579afd7d961c$var$PlatformAuthConstants.MATS_TELEMETRY;
        if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce,
                correlationId: this.correlationId
            };
            const popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(this.browserCrypto, this.tokenBindingKeyManager, this.performanceClient);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await $9797579afd7d961c$var$invokeAsync(popTokenGenerator.generateCnf.bind(popTokenGenerator), $9797579afd7d961c$var$PopTokenGenerateCnf, this.logger, this.performanceClient, this.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    async getCanonicalAuthority(request) {
        const requestAuthority = request.authority || this.config.auth.authority;
        const { azureCloudOptions: azureCloudOptions, account: account } = request;
        if (account) // validate authority
        await $9797579afd7d961c$var$getDiscoveredAuthority(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, requestAuthority, azureCloudOptions, undefined, account);
        const canonicalAuthority = new $9797579afd7d961c$var$UrlString(requestAuthority, this.correlationId);
        canonicalAuthority.validateAsUri();
        return canonicalAuthority;
    }
    getPrompt(prompt) {
        // If request is silent, prompt is always none
        switch(this.apiId){
            case $9797579afd7d961c$var$ApiId.ssoSilent:
            case $9797579afd7d961c$var$ApiId.acquireTokenSilent_silentFlow:
                this.logger.trace("12n1y2", this.correlationId);
                return $9797579afd7d961c$var$PromptValue$1.NONE;
        }
        // Prompt not provided, request may proceed and native broker decides if it needs to prompt
        if (!prompt) {
            this.logger.trace("0uid1p", this.correlationId);
            return undefined;
        }
        // If request is interactive, check if prompt provided is allowed to go directly to native broker
        switch(prompt){
            case $9797579afd7d961c$var$PromptValue$1.NONE:
            case $9797579afd7d961c$var$PromptValue$1.CONSENT:
            case $9797579afd7d961c$var$PromptValue$1.LOGIN:
                this.logger.trace("0i0hco", this.correlationId);
                return prompt;
            default:
                this.logger.trace(`0w3tpw ${prompt}`, this.correlationId);
                throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nativePromptNotSupported, this.correlationId);
        }
    }
    /**
     * Handles extra broker request parameters
     * @param request {PlatformAuthRequest}
     * @private
     */ handleExtraBrokerParams(request, embeddedClientId) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty($9797579afd7d961c$var$BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty($9797579afd7d961c$var$BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty($9797579afd7d961c$var$CLIENT_ID);
        if (!embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[$9797579afd7d961c$var$BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[$9797579afd7d961c$var$CLIENT_ID];
        }
        const { // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9797579afd7d961c$var$BROKER_CLIENT_ID]: _brkClientId, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9797579afd7d961c$var$BROKER_REDIRECT_URI]: _brkRedirectUri, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [$9797579afd7d961c$var$CLIENT_ID]: _clientId, ...remainingExtraParameters } = request.extraParameters || {};
        request.extraParameters = {
            ...remainingExtraParameters,
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, this.correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$clientDataAccountTypeMapping = new Map([
    [
        "e",
        "AAD"
    ],
    [
        "m",
        "MSA"
    ]
]);
/**
 * Parses the clientdata response parameter from the /authorize endpoint.
 *
 * Logically, the clientdata value is URL-encoded and pipe-delimited:
 *   urlencoded(account_type | error | sub_error | cloud_instance | caller_data_boundary)
 *
 * In normal browser flows, this value may already have been URL-decoded
 * (e.g. by URLSearchParams). This function will only apply decodeURIComponent
 * when the string appears to contain percent-encoded sequences to avoid
 * double-decoding.
 *
 * @param clientdata - The raw clientdata string from the authorize response
 * @returns Parsed ClientData object, or null if the input is empty/invalid
 */ function $9797579afd7d961c$var$parseClientData(clientdata) {
    if (!clientdata) return null;
    try {
        // Only decode when the string appears to contain percent-encoded sequences
        const shouldDecode = /%(?:[0-9A-Fa-f]{2})/.test(clientdata);
        const decoded = shouldDecode ? decodeURIComponent(clientdata) : clientdata;
        const parts = decoded.split("|");
        if (parts.length < 5) return null;
        return {
            accountType: $9797579afd7d961c$var$clientDataAccountTypeMapping.get(parts[0]?.trim() || "") || "",
            error: parts[1]?.trim() || "",
            subError: parts[2]?.trim() || "",
            cloudInstance: parts[3]?.trim() || "",
            callerDataBoundary: parts[4]?.trim() || ""
        };
    } catch  {
        return null;
    }
}
/**
 * Instruments account type, error, and suberror from clientdata
 */ function $9797579afd7d961c$var$instrumentClientData(response, correlationId, performanceClient) {
    const parsed = $9797579afd7d961c$var$parseClientData(response.clientdata);
    parsed?.accountType && performanceClient.addFields({
        accountType: parsed.accountType
    }, correlationId);
    parsed?.error && performanceClient.addFields({
        serverErrorNo: parsed.error
    }, correlationId);
    parsed?.subError && performanceClient.addFields({
        serverSubErrorNo: parsed.subError
    }, correlationId);
}
/**
 * Returns map of parameters that are applicable to all calls to /authorize whether using PKCE or EAR
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9797579afd7d961c$var$getStandardParameters(config, authority, request, logger, performanceClient) {
    const parameters = $9797579afd7d961c$var$getStandardAuthorizeRequestParameters({
        ...config.auth,
        authority: authority
    }, {
        ...request,
        /*
         * Computed here rather than per flow so every authorize request
         * carries it — GET, POST and EAR, interactive and silent alike.
         * A request may assert it instead when the topology, rather than
         * the current window, is what makes the popup unreachable.
         */ popupOriginCheckDone: request.popupOriginCheckDone ?? $9797579afd7d961c$var$computePocd(config) === 1
    }, logger, performanceClient);
    $9797579afd7d961c$var$addLibraryInfo(parameters, {
        sku: $9797579afd7d961c$var$BrowserConstants.MSAL_SKU,
        version: $9797579afd7d961c$var$version,
        os: "",
        cpu: ""
    });
    if (config.system.protocolMode !== $9797579afd7d961c$var$ProtocolMode.OIDC) $9797579afd7d961c$var$addApplicationTelemetry(parameters, config.telemetry.application);
    if (request.platformBroker) {
        // signal ests that this is a WAM call
        $9797579afd7d961c$var$addNativeBroker(parameters);
        // instrument JS-platform bridge specific fields
        performanceClient.addFields({
            isPlatformAuthorizeRequest: true
        }, request.correlationId);
        // pass the req_cnf for POP
        if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.POP && request.reqCnf) $9797579afd7d961c$var$addPopToken(parameters, request.reqCnf);
    }
    if (request.authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.DPOP && request.dpopJkt) parameters.set($9797579afd7d961c$var$DPOP_JKT, request.dpopJkt);
    $9797579afd7d961c$var$instrumentBrokerParams(parameters, request.correlationId, performanceClient);
    return parameters;
}
/**
 * Gets the full /authorize URL with request parameters when using Auth Code + PKCE
 * @param config
 * @param authority
 * @param request
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9797579afd7d961c$var$getAuthCodeRequestUrl(config, authority, request, logger, performanceClient) {
    if (!request.codeChallenge) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$pkceParamsMissing, request.correlationId);
    const parameters = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getStandardParameters, $9797579afd7d961c$var$GetStandardParams, logger, performanceClient, request.correlationId)(config, authority, request, logger, performanceClient);
    $9797579afd7d961c$var$addResponseType(parameters, $9797579afd7d961c$var$OAuthResponseType.CODE);
    $9797579afd7d961c$var$addCodeChallengeParams(parameters, request.codeChallenge, $9797579afd7d961c$var$S256_CODE_CHALLENGE_METHOD);
    // Merge extraQueryParameters and extraParameters to be appended to request URL
    $9797579afd7d961c$var$addExtraParameters(parameters, {
        ...request.extraQueryParameters,
        ...request.extraParameters
    });
    return $9797579afd7d961c$var$getAuthorizeUrl(authority, parameters);
}
function $9797579afd7d961c$var$getAuthorizeFormAction(authority, request, parameters) {
    const queryParams = new Map();
    $9797579afd7d961c$var$addExtraParameters(queryParams, request.extraQueryParameters || {});
    if (parameters.has($9797579afd7d961c$var$POPUP_ORIGIN_CHECK_DONE)) queryParams.delete($9797579afd7d961c$var$POPUP_ORIGIN_CHECK_DONE);
    $9797579afd7d961c$var$addCorrelationId(queryParams, request.correlationId);
    return $9797579afd7d961c$var$getAuthorizeUrl(authority, queryParams);
}
/**
 * Builds the action URL + POST-body fields for the EAR /authorize form.
 */ async function $9797579afd7d961c$var$getEARFormData(config, authority, request, logger, performanceClient) {
    if (!request.earJwk) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$earJwkEmpty, request.correlationId);
    const parameters = await $9797579afd7d961c$var$getStandardParameters(config, authority, request, logger, performanceClient);
    $9797579afd7d961c$var$addResponseType(parameters, $9797579afd7d961c$var$OAuthResponseType.IDTOKEN_TOKEN_REFRESHTOKEN);
    $9797579afd7d961c$var$addEARParameters(parameters, request.earJwk);
    // Also add codeChallenge as backup in case EAR is not supported
    $9797579afd7d961c$var$addCodeChallengeParams(parameters, request.codeChallenge, $9797579afd7d961c$var$S256_CODE_CHALLENGE_METHOD);
    $9797579afd7d961c$var$addExtraParameters(parameters, {
        ...request.extraParameters
    });
    const action = $9797579afd7d961c$var$getAuthorizeFormAction(authority, request, parameters);
    return {
        action: action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using EAR
 */ async function $9797579afd7d961c$var$getEARForm(frame, config, authority, request, logger, performanceClient) {
    const { action: action, fields: fields } = await $9797579afd7d961c$var$getEARFormData(config, authority, request, logger, performanceClient);
    return $9797579afd7d961c$var$createForm(frame, action, fields);
}
/**
 * Builds the action URL + POST-body fields for the auth-code /authorize form.
 */ async function $9797579afd7d961c$var$getCodeFormData(config, authority, request, logger, performanceClient) {
    const parameters = await $9797579afd7d961c$var$getStandardParameters(config, authority, request, logger, performanceClient);
    $9797579afd7d961c$var$addResponseType(parameters, $9797579afd7d961c$var$OAuthResponseType.CODE);
    $9797579afd7d961c$var$addCodeChallengeParams(parameters, request.codeChallenge, request.codeChallengeMethod || $9797579afd7d961c$var$S256_CODE_CHALLENGE_METHOD);
    // Add extraParameters to the request body
    $9797579afd7d961c$var$addExtraParameters(parameters, {
        ...request.extraParameters
    });
    const action = $9797579afd7d961c$var$getAuthorizeFormAction(authority, request, parameters);
    return {
        action: action,
        fields: Object.fromEntries(parameters)
    };
}
/**
 * Gets the form that will be posted to /authorize with request parameters when using POST method
 */ async function $9797579afd7d961c$var$getCodeForm(frame, config, authority, request, logger, performanceClient) {
    const { action: action, fields: fields } = await $9797579afd7d961c$var$getCodeFormData(config, authority, request, logger, performanceClient);
    return $9797579afd7d961c$var$createForm(frame, action, fields);
}
/**
 * Creates a POST `<form>` in the provided document with the given auth
 * parameters as hidden inputs, targeting `action`. Shared by the popup auth
 * flows (`getEARForm` / `getCodeForm`) and the popup-relay page
 * (`runPopupRelay`) so the form is built one way only.
 *
 * @param frame - document to create the form in
 * @param action - form action (the /authorize URL)
 * @param fields - POST-body fields
 * @internal
 */ function $9797579afd7d961c$var$createForm(frame, action, fields) {
    const form = frame.createElement("form");
    form.method = "post";
    form.action = action;
    Object.keys(fields).forEach((name)=>{
        const input = frame.createElement("input");
        input.hidden = true;
        input.name = name;
        input.value = fields[name];
        form.appendChild(input);
    });
    frame.body.appendChild(form);
    return form;
}
/**
 * Response handler when server returns accountId on the /authorize request
 * @param request
 * @param accountId
 * @param apiId
 * @param config
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $9797579afd7d961c$var$handleResponsePlatformBroker(request, accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    logger.verbose("11qcow", request.correlationId);
    if (!platformAuthProvider) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nativeConnectionNotEstablished, request.correlationId);
    const browserCrypto = new $9797579afd7d961c$var$CryptoOps(logger, performanceClient);
    const nativeInteractionClient = new $9797579afd7d961c$var$PlatformAuthInteractionClient(config, browserStorage, browserCrypto, logger, eventHandler, config.system.navigationClient, apiId, performanceClient, platformAuthProvider, accountId, nativeStorage, request.correlationId);
    const { userRequestState: userRequestState } = $9797579afd7d961c$var$parseRequestState(browserCrypto.base64Decode, request.state, request.correlationId);
    return $9797579afd7d961c$var$invokeAsync(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), $9797579afd7d961c$var$NativeInteractionClientAcquireToken, logger, performanceClient, request.correlationId)({
        ...request,
        state: userRequestState,
        prompt: undefined
    });
}
/**
 * Response handler when server returns code on the /authorize request
 * @param request
 * @param response
 * @param codeVerifier
 * @param authClient
 * @param browserStorage
 * @param logger
 * @param performanceClient
 * @returns
 */ async function $9797579afd7d961c$var$handleResponseCode(request, response, codeVerifier, apiId, config, authClient, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    $9797579afd7d961c$var$ThrottlingUtils.removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $9797579afd7d961c$var$instrumentClientData(response, request.correlationId, performanceClient);
    if (response.accountId) return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponsePlatformBroker, $9797579afd7d961c$var$HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, response.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const authCodeRequest = {
        ...request,
        code: response.code || "",
        codeVerifier: codeVerifier
    };
    // Create popup interaction handler.
    const interactionHandler = new $9797579afd7d961c$var$InteractionHandler(authClient, browserStorage, authCodeRequest, logger, performanceClient);
    // Handle response from hash string.
    const result = await $9797579afd7d961c$var$invokeAsync(interactionHandler.handleCodeResponse.bind(interactionHandler), $9797579afd7d961c$var$HandleCodeResponse, logger, performanceClient, request.correlationId)(response, request, apiId);
    return result;
}
/**
 * Response handler when server returns ear_jwe on the /authorize request
 * @param request
 * @param response
 * @param apiId
 * @param config
 * @param authority
 * @param browserStorage
 * @param nativeStorage
 * @param eventHandler
 * @param logger
 * @param performanceClient
 * @param nativeMessageHandler
 * @returns
 */ async function $9797579afd7d961c$var$handleResponseEAR(request, response, apiId, config, authority, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider) {
    // Remove throttle if it exists
    $9797579afd7d961c$var$ThrottlingUtils.removeThrottle(browserStorage, config.auth.clientId, request);
    // Instrument clientdata telemetry fields from the authorize response
    $9797579afd7d961c$var$instrumentClientData(response, request.correlationId, performanceClient);
    // Validate state & check response for errors
    $9797579afd7d961c$var$validateAuthorizationResponse(response, request.state, request.correlationId);
    if (!response.ear_jwe) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$earJweEmpty, request.correlationId);
    if (!request.earJwk) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$earJwkEmpty, request.correlationId);
    const decryptedData = JSON.parse(await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$decryptEarResponse, $9797579afd7d961c$var$DecryptEarResponse, logger, performanceClient, request.correlationId)(request.earJwk, response.ear_jwe));
    if (decryptedData.accountId) return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponsePlatformBroker, $9797579afd7d961c$var$HandleResponsePlatformBroker, logger, performanceClient, request.correlationId)(request, decryptedData.accountId, apiId, config, browserStorage, nativeStorage, eventHandler, logger, performanceClient, platformAuthProvider);
    const responseHandler = new $9797579afd7d961c$var$ResponseHandler(config.auth.clientId, browserStorage, new $9797579afd7d961c$var$CryptoOps(logger, performanceClient), logger, performanceClient, null, null, new $9797579afd7d961c$var$TokenBindingKeyManager(logger, performanceClient));
    // Validate response. This function throws a server error if an error is returned by the server.
    responseHandler.validateTokenResponse(decryptedData, request.correlationId);
    // Temporary until response handler is refactored to be more flow agnostic.
    const additionalData = {
        code: "",
        state: request.state,
        nonce: request.nonce,
        client_info: decryptedData.client_info,
        cloud_graph_host_name: decryptedData.cloud_graph_host_name,
        cloud_instance_host_name: decryptedData.cloud_instance_host_name,
        cloud_instance_name: decryptedData.cloud_instance_name,
        msgraph_host: decryptedData.msgraph_host
    };
    return await $9797579afd7d961c$var$invokeAsync(responseHandler.handleServerTokenResponse.bind(responseHandler), $9797579afd7d961c$var$HandleServerTokenResponse, logger, performanceClient, request.correlationId)(decryptedData, authority, $9797579afd7d961c$var$nowSeconds(), request, apiId, additionalData, undefined, undefined, undefined, undefined);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $9797579afd7d961c$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $9797579afd7d961c$var$generatePkceCodes(performanceClient, logger, correlationId) {
    const codeVerifier = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$generateCodeVerifier, $9797579afd7d961c$var$GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateCodeChallengeFromVerifier, $9797579afd7d961c$var$GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $9797579afd7d961c$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($9797579afd7d961c$var$RANDOM_BYTE_ARR_LENGTH);
        $9797579afd7d961c$var$invoke($9797579afd7d961c$var$getRandomValues, $9797579afd7d961c$var$GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = $9797579afd7d961c$var$urlEncodeArr(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$pkceNotCreated, correlationId);
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $9797579afd7d961c$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$sha256Digest, $9797579afd7d961c$var$Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier);
        // encode hash as base64
        return $9797579afd7d961c$var$urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$pkceNotCreated, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$NavigationClient {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $9797579afd7d961c$var$NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $9797579afd7d961c$var$NavigationClient.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        else window.location.assign(url); // CodeQL [SM03712] Application owner controls the URL. User can't change it.
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$timedOut, "", "failed_to_redirect"));
            }, options.timeout);
        });
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$MAX_FETCH_POST_RETRIES = 1;
const $9797579afd7d961c$var$RETRY_DELAY_MS = 100;
/**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $9797579afd7d961c$var$FetchClient {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $9797579afd7d961c$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: $9797579afd7d961c$var$HTTP_REQUEST_TYPE.GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError(window.navigator.onLine ? $9797579afd7d961c$var$getRequestFailed : $9797579afd7d961c$var$noNetworkConnectivity, ""), undefined, undefined, e);
        }
        responseHeaders = $9797579afd7d961c$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToParseResponse, ""), responseStatus, responseHeaders, e);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $9797579afd7d961c$var$getFetchHeaders(options);
        const correlationId = options?.correlationId;
        const performanceClient = options?.performanceClient;
        let response;
        let lastError;
        for(let attempt = 1; attempt <= $9797579afd7d961c$var$MAX_FETCH_POST_RETRIES + 1; attempt++)try {
            response = await fetch(url, {
                method: $9797579afd7d961c$var$HTTP_REQUEST_TYPE.POST,
                headers: reqHeaders,
                body: reqBody
            });
            break;
        } catch (e) {
            lastError = e;
            if (!$9797579afd7d961c$var$shouldRetryPostFetchError(lastError, attempt)) throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError(window.navigator.onLine !== false ? $9797579afd7d961c$var$postRequestFailed : $9797579afd7d961c$var$noNetworkConnectivity, correlationId || ""), undefined, undefined, lastError);
            // Brief backoff before retry
            await new Promise((resolve)=>setTimeout(resolve, $9797579afd7d961c$var$RETRY_DELAY_MS));
            if (correlationId) performanceClient?.incrementFields({
                fetchRetryCount: 1
            }, correlationId);
        }
        if (!response) throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError(window.navigator.onLine !== false ? $9797579afd7d961c$var$postRequestFailed : $9797579afd7d961c$var$noNetworkConnectivity, correlationId || ""), undefined, undefined, lastError);
        let responseStatus = 0;
        let responseHeaders = {};
        responseHeaders = $9797579afd7d961c$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToParseResponse, correlationId || ""), responseStatus, responseHeaders, e);
        }
    }
}
function $9797579afd7d961c$var$shouldRetryPostFetchError(error, attempt) {
    return attempt <= $9797579afd7d961c$var$MAX_FETCH_POST_RETRIES && window.navigator.onLine !== false && error.name !== "AbortError";
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $9797579afd7d961c$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw $9797579afd7d961c$var$createNetworkError($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToBuildHeaders, ""), undefined, undefined, e);
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $9797579afd7d961c$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$failedToParseHeaders, "");
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $9797579afd7d961c$var$DEFAULT_POPUP_TIMEOUT_MS = 60000;
const $9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS$1 = 10000;
const $9797579afd7d961c$var$DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
const $9797579afd7d961c$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $9797579afd7d961c$var$buildConfiguration({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, experimental: userInputExperimental, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: "",
        authority: `${$9797579afd7d961c$var$DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: "",
        authorityMetadata: "",
        redirectUri: typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "",
        postLogoutRedirectUri: "",
        popupRelayUri: "",
        clientCapabilities: [],
        OIDCOptions: {
            responseMode: $9797579afd7d961c$var$ResponseMode$1.FRAGMENT,
            defaultScopes: [
                $9797579afd7d961c$var$OPENID_SCOPE,
                $9797579afd7d961c$var$PROFILE_SCOPE,
                $9797579afd7d961c$var$OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: $9797579afd7d961c$var$AzureCloudInstance.None,
            tenant: ""
        },
        instanceAware: false,
        isMcp: false,
        verifySSO: false,
        // Legacy polling needs COOP omitted, so it implies asserting pocd=1.
        originCheck: !userInputSystem?.enableLegacyPolling
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: $9797579afd7d961c$var$BrowserCacheLocation.SessionStorage,
        cacheRetentionDays: 5
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: $9797579afd7d961c$export$243e62d78d3b544d.Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...$9797579afd7d961c$var$DEFAULT_SYSTEM_OPTIONS,
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new $9797579afd7d961c$var$FetchClient() : $9797579afd7d961c$var$StubbedNetworkModule,
        navigationClient: new $9797579afd7d961c$var$NavigationClient(),
        popupBridgeTimeout: userInputSystem?.popupBridgeTimeout || $9797579afd7d961c$var$DEFAULT_POPUP_TIMEOUT_MS,
        iframeBridgeTimeout: userInputSystem?.iframeBridgeTimeout || $9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS$1,
        redirectNavigationTimeout: $9797579afd7d961c$var$DEFAULT_REDIRECT_TIMEOUT_MS,
        allowRedirectInIframe: false,
        navigatePopups: true,
        allowPlatformBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $9797579afd7d961c$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS,
        protocolMode: $9797579afd7d961c$var$ProtocolMode.AAD,
        serverTelemetryEnabled: false,
        enableLegacyPolling: false
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: "",
            appVersion: ""
        },
        client: new $9797579afd7d961c$var$StubPerformanceClient()
    };
    const DEFAULT_EXPERIMENTAL_OPTIONS = {
        iframeTimeoutTelemetry: false,
        allowPlatformBrokerWithDOM: false
    };
    let logger;
    const getLogger = ()=>{
        if (!logger) logger = new $9797579afd7d961c$var$Logger(providedSystemOptions.loggerOptions, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        return logger;
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputSystem?.protocolMode !== $9797579afd7d961c$var$ProtocolMode.OIDC && userInputAuth?.OIDCOptions) getLogger().warning(JSON.stringify($9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$cannotSetOIDCOptions, "")), "");
    // Throw an error if user has set allowPlatformBroker to true with OIDC protocol mode
    if (userInputSystem?.protocolMode && userInputSystem.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC && providedSystemOptions?.allowPlatformBroker) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$cannotAllowPlatformBroker, "");
    /*
     * The origin check computes 0 in the embedded contexts legacy polling
     * serves, so re-enabling it there breaks the flow. Honor it, but warn.
     */ if (userInputSystem?.enableLegacyPolling && userInputAuth?.originCheck === true) getLogger().warning("buildConfiguration: system.enableLegacyPolling is true and auth.originCheck is explicitly true. Legacy polling requires pocd=1, which the origin check will not produce in an embedded context. Unset auth.originCheck to let legacy polling assert it.", "");
    /*
     * Opting out is a deliberate risk transfer, not an error — but the app
     * cannot know at config time that the risky topology is actually present.
     */ if ((userInputAuth?.originCheck ?? DEFAULT_AUTH_OPTIONS.originCheck) === false && typeof window !== "undefined" && !$9797579afd7d961c$var$topOpenerIsSameOriginOrAbsent(window)) getLogger().warning("buildConfiguration: auth.originCheck is disabled and the top-level window has a cross-origin opener. MSAL will assert pocd=1, so the STS omits Cross-Origin-Opener-Policy and that opener can reach the auth popup. The application is responsible for this risk.", "");
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        experimental: {
            ...DEFAULT_EXPERIMENTAL_OPTIONS,
            ...userInputExperimental
        },
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$PlatformAuthExtensionHandler {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId, correlationId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.correlationId = correlationId || $9797579afd7d961c$var$createNewGuid();
        this.handshakeEvent = this.performanceClient.startMeasurement($9797579afd7d961c$var$NativeMessageHandlerHandshake, this.correlationId);
        this.platformAuthType = $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER;
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param request
     */ async sendMessage(request) {
        const correlationId = this.getCorrelationId(request.correlationId);
        const sendMessageMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthExtensionGetToken, correlationId);
        sendMessageMeasurement.add({
            platformAuthProviderType: this.platformAuthType
        });
        this.logger.trace(`0on4p2 ${this.platformAuthType}`, correlationId);
        try {
            // fall back to native calls
            const extensionRequest = {
                ...request
            };
            delete extensionRequest.resourceRequestMethod;
            delete extensionRequest.resourceRequestUri;
            const messageBody = {
                method: $9797579afd7d961c$var$NativeExtensionMethod.GetToken,
                request: extensionRequest
            };
            const req = {
                channel: $9797579afd7d961c$var$PlatformAuthConstants.CHANNEL_ID,
                extensionId: this.extensionId,
                responseId: $9797579afd7d961c$var$createNewGuid(),
                body: messageBody
            };
            this.logger.trace(`1qadfi ${this.platformAuthType}`, correlationId);
            this.logger.tracePii(`1xm533 ${this.platformAuthType} ${JSON.stringify(req)}`, correlationId);
            this.messageChannel.port1.postMessage(req);
            const response = await new Promise((resolve, reject)=>{
                this.resolvers.set(req.responseId, {
                    resolve: resolve,
                    reject: reject,
                    correlationId: correlationId
                });
            });
            const validatedResponse = this.validatePlatformBrokerResponse(response, correlationId);
            sendMessageMeasurement.end({
                success: true,
                platformAuthProviderType: this.platformAuthType
            });
            return validatedResponse;
        } catch (e) {
            sendMessageMeasurement.end({
                success: false,
                platformAuthProviderType: this.platformAuthType
            }, e);
            throw e;
        }
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient, correlationId) {
        logger.trace("15zfnw", correlationId);
        const createProviderMeasurement = performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthExtensionCreateProvider, correlationId);
        try {
            const preferredProvider = new $9797579afd7d961c$var$PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient, $9797579afd7d961c$var$PlatformAuthConstants.PREFERRED_EXTENSION_ID, correlationId);
            await preferredProvider.sendHandshakeRequest();
            createProviderMeasurement.add({
                platformAuthProviderAvailable: true,
                platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER
            });
            createProviderMeasurement.end({
                platformAuthProviderAvailable: true,
                platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER
            });
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            try {
                const backupProvider = new $9797579afd7d961c$var$PlatformAuthExtensionHandler(logger, handshakeTimeoutMs, performanceClient, undefined, correlationId);
                await backupProvider.sendHandshakeRequest();
                createProviderMeasurement.add({
                    platformAuthProviderAvailable: true,
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER
                });
                createProviderMeasurement.end({
                    platformAuthProviderAvailable: true,
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER
                });
                return backupProvider;
            } catch (backupError) {
                createProviderMeasurement.add({
                    platformAuthProviderAvailable: false
                });
                createProviderMeasurement.end({
                    platformAuthProviderAvailable: false
                }, backupError);
                throw backupError;
            }
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace(`1dpg9o ${this.platformAuthType}`, this.correlationId);
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: $9797579afd7d961c$var$PlatformAuthConstants.CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: $9797579afd7d961c$var$createNewGuid(),
            body: {
                method: $9797579afd7d961c$var$NativeExtensionMethod.HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs,
            platformAuthRequestCorrelationId: this.correlationId
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject,
                correlationId: this.correlationId
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.add({
                    extensionHandshakeTimedOut: true
                });
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nativeHandshakeTimeout, this.correlationId));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        let correlationId = $9797579afd7d961c$var$createGuid();
        this.logger.trace(`0jpn5u ${this.platformAuthType}`, correlationId);
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== $9797579afd7d961c$var$PlatformAuthConstants.CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === $9797579afd7d961c$var$NativeExtensionMethod.HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`07buhm ${this.platformAuthType} ${request.responseId}`, correlationId);
                return;
            }
            correlationId = handshakeResolver.correlationId;
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `0xrkug ${request.extensionId}` : "No extension installed", correlationId);
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.add({
                extensionInstalled: false
            });
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nativeExtensionNotInstalled, correlationId));
            this.handshakeResolvers.delete(request.responseId);
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        const request = event.data;
        const responseId = request?.responseId;
        const resolver = responseId ? this.resolvers.get(responseId) : undefined;
        const handshakeResolver = responseId ? this.handshakeResolvers.get(responseId) : undefined;
        const correlationId = resolver?.correlationId || handshakeResolver?.correlationId || $9797579afd7d961c$var$createGuid();
        this.logger.trace(`1py8yf ${this.platformAuthType}`, correlationId);
        try {
            const method = request.body.method;
            if (method === $9797579afd7d961c$var$NativeExtensionMethod.Response) {
                if (!resolver) return;
                try {
                    const response = request.body.response;
                    this.logger.trace(`19hpgm ${this.platformAuthType}`, correlationId);
                    this.logger.tracePii(`179a24 ${this.platformAuthType} ${JSON.stringify(response)}`, correlationId);
                    if (response.status !== "Success") resolver.reject($9797579afd7d961c$var$createNativeAuthError(response.code, correlationId, response.description, response.ext));
                    else if (response.result) {
                        if (response.result["code"] && response.result["description"]) resolver.reject($9797579afd7d961c$var$createNativeAuthError(response.result["code"], correlationId, response.result["description"], response.result["ext"]));
                        else resolver.resolve(response.result);
                    } else throw $9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, correlationId, "Event does not contain result.");
                } finally{
                    this.resolvers.delete(request.responseId);
                }
            } else if (method === $9797579afd7d961c$var$NativeExtensionMethod.HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`082qnt ${this.platformAuthType} ${request.responseId}`, correlationId);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version?.toString();
                this.logger.verbose(`0yf5ib ${this.platformAuthType} ${this.extensionId}`, correlationId);
                this.handshakeEvent.add({
                    extensionId: this.extensionId,
                    extensionVersion: this.extensionVersion,
                    extensionInstalled: true
                });
                this.handshakeEvent.end({
                    extensionId: this.extensionId,
                    extensionVersion: this.extensionVersion,
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            } else if (resolver) {
                this.resolvers.delete(request.responseId);
                resolver.reject($9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, correlationId, "Extension response contains an unexpected method."));
            }
        } catch (err) {
            this.logger.error("0xf978", correlationId);
            this.logger.errorPii(`04i99o ${err}`, correlationId);
            this.logger.errorPii(`0xdvsy ${event}`, correlationId);
            if (resolver) {
                this.resolvers.delete(responseId);
                resolver.reject(err instanceof $9797579afd7d961c$var$AuthError ? err : $9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, correlationId, "Unable to parse extension response."));
            } else if (handshakeResolver) {
                clearTimeout(this.timeoutId);
                window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    success: false
                });
                this.handshakeResolvers.delete(responseId);
                handshakeResolver.reject(err);
            }
        }
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validatePlatformBrokerResponse(response, correlationId) {
        const responseCorrelationId = this.getCorrelationId(correlationId);
        const validationMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthExtensionValidateResponse, responseCorrelationId);
        if (response && Object.prototype.hasOwnProperty.call(response, "access_token") && Object.prototype.hasOwnProperty.call(response, "id_token") && Object.prototype.hasOwnProperty.call(response, "client_info") && Object.prototype.hasOwnProperty.call(response, "account") && Object.prototype.hasOwnProperty.call(response, "scope") && Object.prototype.hasOwnProperty.call(response, "expires_in")) {
            validationMeasurement.end({
                success: true,
                platformAuthProviderType: this.platformAuthType
            });
            return response;
        } else {
            const error = $9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, responseCorrelationId, "Response missing expected properties.");
            validationMeasurement.end({
                success: false,
                platformAuthProviderType: this.platformAuthType
            }, error);
            throw error;
        }
    }
    getCorrelationId(correlationId) {
        return correlationId || this.correlationId;
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    getExtensionName() {
        return this.getExtensionId() === $9797579afd7d961c$var$PlatformAuthConstants.PREFERRED_EXTENSION_ID ? "chrome" : this.getExtensionId()?.length ? "unknown" : undefined;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$PlatformAuthDOMHandler {
    constructor(logger, performanceClient, correlationId){
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.platformAuthType = $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER;
    }
    static async createProvider(logger, performanceClient, correlationId) {
        logger.trace("12mj4a", correlationId);
        const createProviderMeasurement = performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthDOMCreateProvider, correlationId);
        try {
            const platformAuthentication = window.navigator.platformAuthentication;
            if (!platformAuthentication) {
                createProviderMeasurement.add({
                    platformAuthProviderAvailable: false
                });
                createProviderMeasurement.end({
                    platformAuthProviderAvailable: false
                });
                return undefined;
            }
            const supportedContracts = await $9797579afd7d961c$var$invokeAsync(platformAuthentication.getSupportedContracts.bind(platformAuthentication), $9797579afd7d961c$var$PlatformAuthDOMGetSupportedContracts, logger, performanceClient, correlationId)($9797579afd7d961c$var$PlatformAuthConstants.MICROSOFT_ENTRA_BROKERID);
            const contractSupported = supportedContracts?.includes($9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_APIS);
            if (contractSupported) {
                logger.trace("1h5q1r", correlationId);
                createProviderMeasurement.add({
                    platformAuthProviderAvailable: true,
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER
                });
                createProviderMeasurement.end({
                    platformAuthProviderAvailable: true,
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER
                });
                return new $9797579afd7d961c$var$PlatformAuthDOMHandler(logger, performanceClient, correlationId);
            }
            createProviderMeasurement.add({
                platformAuthProviderAvailable: false
            });
            createProviderMeasurement.end({
                platformAuthProviderAvailable: false
            });
            return undefined;
        } catch (e) {
            createProviderMeasurement.add({
                platformAuthProviderAvailable: false
            });
            createProviderMeasurement.end({
                platformAuthProviderAvailable: false
            }, e);
            throw e;
        }
    }
    /**
     * Returns the Id for the broker extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return $9797579afd7d961c$var$PlatformAuthConstants.MICROSOFT_ENTRA_BROKERID;
    }
    getExtensionVersion() {
        return "";
    }
    getExtensionName() {
        return $9797579afd7d961c$var$PlatformAuthConstants.DOM_API_NAME;
    }
    /**
     * Send token request to platform broker via browser DOM API
     * @param request
     * @returns
     */ async sendMessage(request) {
        const correlationId = this.getCorrelationId(request.correlationId);
        const sendMessageMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthDOMGetToken, correlationId);
        sendMessageMeasurement.add({
            platformAuthProviderType: this.platformAuthType
        });
        this.logger.trace(`02bcil ${this.platformAuthType}`, correlationId);
        try {
            const platformDOMRequest = $9797579afd7d961c$var$invoke(this.initializePlatformDOMRequest.bind(this), $9797579afd7d961c$var$PlatformAuthDOMInitializeRequest, this.logger, this.performanceClient, correlationId)(request);
            const response = // @ts-ignore
            await window.navigator.platformAuthentication.executeGetToken(platformDOMRequest);
            const validatedResponse = this.validatePlatformBrokerResponse(response, correlationId);
            sendMessageMeasurement.end({
                success: true,
                platformAuthProviderType: this.platformAuthType
            });
            return validatedResponse;
        } catch (e) {
            this.logger.error(`11im7g ${this.platformAuthType}`, correlationId);
            sendMessageMeasurement.end({
                success: false,
                platformAuthProviderType: this.platformAuthType
            }, e);
            throw e;
        }
    }
    initializePlatformDOMRequest(request) {
        const { accountId: accountId, clientId: clientId, authority: authority, scope: scope, redirectUri: redirectUri, correlationId: correlationId, state: state, preferBinding: preferBinding, enclave: enclave, reqCnf: reqCnf, extraParametersNoCache: extraParametersNoCache, extraParameters: extraParameters, ...remainingProperties } = request;
        const requestCorrelationId = this.getCorrelationId(correlationId);
        this.logger.trace(`15d6yv ${this.platformAuthType}`, requestCorrelationId);
        delete remainingProperties.resourceRequestMethod;
        delete remainingProperties.resourceRequestUri;
        const validExtraParameters = this.getDOMExtraParams(remainingProperties, requestCorrelationId);
        const platformDOMRequest = {
            accountId: accountId,
            brokerId: this.getExtensionId(),
            authority: authority,
            clientId: clientId,
            correlationId: requestCorrelationId,
            extraParameters: {
                ...extraParameters,
                ...validExtraParameters
            },
            isSecurityTokenService: false,
            redirectUri: redirectUri,
            scope: scope,
            state: state,
            preferBinding: preferBinding,
            enclave: enclave,
            requestConfirmation: reqCnf,
            extraParametersNoCache: extraParametersNoCache
        };
        return platformDOMRequest;
    }
    validatePlatformBrokerResponse(response, correlationId) {
        const validationMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthDOMValidateResponse, correlationId);
        const requiredKeys = [
            "accessToken",
            "idToken",
            "clientInfo",
            "account",
            "scopes",
            "expiresIn"
        ];
        const isValid = response && requiredKeys.every((key)=>Object.prototype.hasOwnProperty.call(response, key));
        if (response && Object.prototype.hasOwnProperty.call(response, "isSuccess")) {
            if (isValid) {
                this.logger.trace(`0h4vei ${this.platformAuthType}`, correlationId);
                try {
                    const validatedResponse = this.convertToPlatformBrokerResponse(response, correlationId);
                    validationMeasurement.end({
                        success: true,
                        platformAuthProviderType: this.platformAuthType
                    });
                    return validatedResponse;
                } catch (e) {
                    validationMeasurement.end({
                        success: false,
                        platformAuthProviderType: this.platformAuthType
                    }, e);
                    throw e;
                }
            } else if (Object.prototype.hasOwnProperty.call(response, "error")) {
                const errorResponse = response;
                if (errorResponse.isSuccess === false && errorResponse.error && errorResponse.error.code) {
                    this.logger.trace(`0g92vm ${this.platformAuthType}`, correlationId);
                    const nativeAuthError = $9797579afd7d961c$var$createNativeAuthError(errorResponse.error.code, correlationId, errorResponse.error.description, {
                        error: parseInt(errorResponse.error.errorCode),
                        protocol_error: errorResponse.error.protocolError,
                        status: errorResponse.error.status,
                        properties: errorResponse.error.properties
                    });
                    validationMeasurement.end({
                        success: false,
                        platformAuthProviderType: this.platformAuthType,
                        brokerErrorName: errorResponse.error.code,
                        brokerErrorCode: errorResponse.error.errorCode
                    }, nativeAuthError);
                    throw nativeAuthError;
                }
            }
        }
        const error = $9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, correlationId, "Response missing expected properties.");
        validationMeasurement.end({
            success: false,
            platformAuthProviderType: this.platformAuthType
        }, error);
        throw error;
    }
    getCorrelationId(correlationId) {
        return correlationId || this.correlationId;
    }
    convertToPlatformBrokerResponse(response, correlationId) {
        this.logger.trace(`14913t ${this.platformAuthType}`, correlationId);
        const responseProperties = response.properties || {};
        const bindingAttested = this.parseDOMBoolean(responseProperties.binding_attested, "binding_attested", correlationId);
        const nativeResponse = {
            access_token: response.accessToken,
            id_token: response.idToken,
            client_info: response.clientInfo,
            account: response.account,
            expires_in: response.expiresIn,
            scope: response.scopes,
            state: response.state || "",
            properties: responseProperties,
            extendedLifetimeToken: response.extendedLifetimeToken ?? false,
            shr: response.proofOfPossessionPayload,
            token_type: responseProperties.token_type,
            DPoP: responseProperties.dpop_proof,
            binding_attested: bindingAttested
        };
        return nativeResponse;
    }
    parseDOMBoolean(value, propertyName, correlationId) {
        if (value === undefined) return undefined;
        if (value === "true" || value === "false") return value === "true";
        throw $9797579afd7d961c$var$createAuthError($9797579afd7d961c$var$unexpectedError, correlationId, `Platform broker returned invalid ${propertyName} value.`);
    }
    getDOMExtraParams(extraParameters, correlationId) {
        try {
            const stringifiedProperties = {};
            for (const [key, value] of Object.entries(extraParameters)){
                if (!value) continue;
                if (typeof value === "object") stringifiedProperties[key] = JSON.stringify(value);
                else stringifiedProperties[key] = String(value);
            }
            return stringifiedProperties;
        } catch (e) {
            this.logger.error(`0eu9o3 ${this.platformAuthType}`, correlationId);
            this.logger.errorPii(`17rpl5 ${this.platformAuthType} ${e}`, correlationId);
            return {};
        }
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Checks if the platform broker is available in the current environment.
 * @param domConfig - Whether to enable platform broker DOM API support (required)
 * @param loggerOptions - Optional logger options
 * @param perfClient - Optional performance client
 * @param correlationId - Optional correlation ID
 * @returns Promise<boolean> indicating if platform broker is available
 */ async function $9797579afd7d961c$var$isPlatformBrokerAvailable(domConfig, loggerOptions, perfClient, correlationId) {
    const logger = new $9797579afd7d961c$var$Logger(loggerOptions || {}, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
    const performanceClient = perfClient || new $9797579afd7d961c$var$StubPerformanceClient();
    if (typeof window === "undefined") {
        logger.trace("082ed3", correlationId || $9797579afd7d961c$var$createNewGuid());
        return false;
    }
    return !!await $9797579afd7d961c$var$getPlatformAuthProvider(logger, performanceClient, correlationId || $9797579afd7d961c$var$createNewGuid(), undefined, domConfig);
}
async function $9797579afd7d961c$var$getPlatformAuthProvider(logger, performanceClient, correlationId, nativeBrokerHandshakeTimeout, enablePlatformBrokerDOMSupport) {
    logger.trace("134j0v", correlationId);
    const discoveryMeasurement = performanceClient.startMeasurement($9797579afd7d961c$var$PlatformAuthProviderDiscovery, correlationId);
    logger.trace(`04c81g ${enablePlatformBrokerDOMSupport}`, correlationId);
    let platformAuthProvider;
    try {
        if (enablePlatformBrokerDOMSupport) {
            // Check if DOM platform API is supported first
            try {
                platformAuthProvider = await $9797579afd7d961c$var$PlatformAuthDOMHandler.createProvider(logger, performanceClient, correlationId);
            } catch (e) {
                logger.trace("1ij09j", correlationId);
            }
            if (platformAuthProvider) {
                discoveryMeasurement.add({
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER
                });
                discoveryMeasurement.end({
                    success: true,
                    platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER
                });
                return platformAuthProvider;
            }
        }
        logger.trace("0l3na8", correlationId);
        /*
         * If DOM APIs are not available, check if browser extension is available.
         * Platform authentication via DOM APIs is preferred over extension APIs.
         */ platformAuthProvider = await $9797579afd7d961c$var$PlatformAuthExtensionHandler.createProvider(logger, nativeBrokerHandshakeTimeout || $9797579afd7d961c$var$DEFAULT_NATIVE_BROKER_HANDSHAKE_TIMEOUT_MS, performanceClient, correlationId);
        if (platformAuthProvider) discoveryMeasurement.add({
            platformAuthProviderType: $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER
        });
        discoveryMeasurement.end({
            success: !!platformAuthProvider,
            platformAuthProviderType: platformAuthProvider ? $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER : undefined
        });
    } catch (e) {
        logger.trace("0icbd7", e);
        discoveryMeasurement.end({
            success: false
        }, e);
    }
    return platformAuthProvider;
}
/**
 * Returns boolean indicating whether or not the request should attempt to use platform broker
 * @param logger
 * @param config
 * @param correlationId
 * @param platformAuthProvider
 * @param authenticationScheme
 */ function $9797579afd7d961c$var$isPlatformAuthAllowed(config, logger, correlationId, platformAuthProvider, authenticationScheme, performanceClient) {
    logger.trace("0uko3r", correlationId);
    const schemeSupported = !authenticationScheme || authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.BEARER || authenticationScheme === $9797579afd7d961c$var$AuthenticationScheme$1.POP;
    const fields = {
        allowPlatformBroker: config.system.allowPlatformBroker,
        ...config.system.allowPlatformBroker && {
            platformAuthProviderType: platformAuthProvider instanceof $9797579afd7d961c$var$PlatformAuthDOMHandler ? $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_DOM_PROVIDER : platformAuthProvider ? $9797579afd7d961c$var$PlatformAuthConstants.PLATFORM_EXTENSION_PROVIDER : undefined
        }
    };
    performanceClient?.addFields(fields, correlationId);
    // throw an error if allowPlatformBroker is not enabled and allowPlatformBrokerWithDOM is enabled
    if (!config.system.allowPlatformBroker && config.experimental.allowPlatformBrokerWithDOM) throw $9797579afd7d961c$var$createClientConfigurationError($9797579afd7d961c$var$invalidPlatformBrokerConfiguration, "");
    if (!config.system.allowPlatformBroker) {
        logger.trace("04hozs", correlationId);
        // Developer disabled WAM
        return false;
    }
    if (!platformAuthProvider) {
        logger.trace("0kvv1r", correlationId);
        // Platform broker auth providers are not available
        return false;
    }
    if (!schemeSupported) {
        logger.trace("1dd2nh", correlationId);
        return false;
    }
    logger.trace("18tev1", correlationId);
    return true;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$PopupClient extends $9797579afd7d961c$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, waitForPopupResponseHook, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler, tokenBindingKeyManager);
        this.nativeStorage = nativeStorageImpl;
        this.eventHandler = eventHandler;
        this.waitForPopupResponseHook = waitForPopupResponseHook;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     * @param pkceCodes
     */ acquireToken(request, pkceCodes) {
        let popupParams = undefined;
        try {
            const popupName = this.generatePopupName(request.scopes || $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1, request.authority || this.config.auth.authority);
            popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            this.performanceClient.addFields({
                isAsyncPopup: !this.config.system.navigatePopups
            }, this.correlationId);
            // navigatePopups flag is false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("162h4u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams, pkceCodes);
            } else {
                // navigatePopups flag is set to true. Opens popup before acquiring token.
                // Pre-validate request method to avoid opening popup if the request is invalid
                const validatedRequest = {
                    ...request,
                    httpMethod: $9797579afd7d961c$var$validateRequestMethod(request, this.config.system.protocolMode)
                };
                this.logger.verbose("1f9ok3", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(validatedRequest, popupParams, pkceCodes);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("068rup", this.correlationId);
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            validLogoutRequest.popupOriginCheckDone = this.getPopupOriginCheckDone(popupParams.popupWindowParent) ?? validLogoutRequest.popupOriginCheckDone;
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // navigatePopups flag set to false. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (!this.config.system.navigatePopups) {
                this.logger.verbose("1phd8u", this.correlationId);
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // navigatePopups flag is set to true. Opens popup before logging out.
                this.logger.verbose("1a28da", this.correlationId);
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param request
     * @param popupParams
     * @param pkceCodes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams, pkceCodes) {
        this.logger.verbose("1g77pg", this.correlationId);
        const validRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeAuthorizationRequest, $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        /*
         * Skip pre-connect for async popups to reduce time between user interaction and popup window creation to avoid
         * popup from being blocked by browsers with shorter popup timers
         */ if (popupParams.popup) $9797579afd7d961c$var$preconnect(validRequest.authority);
        const isPlatformBroker = $9797579afd7d961c$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        validRequest.platformBroker = isPlatformBroker;
        if ($9797579afd7d961c$var$shouldUseEar(this.config.system.protocolMode, this.logger, this.performanceClient, this.correlationId)) return this.executeEarFlow(validRequest, popupParams, pkceCodes);
        else return this.executeCodeFlow(validRequest, popupParams, pkceCodes);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @param popupParams
     * @param pkceCodes
     * @returns
     */ async executeCodeFlow(request, popupParams, pkceCodes) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkce = pkceCodes || await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const popupRequest = {
            ...request,
            codeChallenge: pkce.challenge,
            ...tokenBindingParams,
            popupOriginCheckDone: this.getPopupOriginCheckDone(popupParams.popupWindowParent)
        };
        try {
            // Initialize the client
            const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: popupRequest.authority,
                requestAzureCloudOptions: popupRequest.azureCloudOptions,
                requestExtraQueryParameters: popupRequest.extraQueryParameters,
                account: popupRequest.account
            });
            if (popupRequest.httpMethod === $9797579afd7d961c$var$HttpMethod.POST) return await this.executeCodeFlowWithPost(popupRequest, popupParams, authClient, pkce.verifier);
            else {
                // Create acquire token url.
                const navigateUrl = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getAuthCodeRequestUrl, $9797579afd7d961c$var$GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, popupRequest, this.logger, this.performanceClient);
                /*
                 * When a popup-relay page is configured, open it top-level
                 * (same first-party origin) instead of navigating the popup
                 * straight to the IdP, and carry the /authorize URL in its hash.
                 * The relay page opens the IdP child popup and relays the
                 * response back via postMessage (see waitForPopupResponse).
                 */ const popupRelayUri = this.config.auth.popupRelayUri;
                const popupNavigateUrl = popupRelayUri ? $9797579afd7d961c$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                    method: "GET",
                    url: navigateUrl
                }, correlationId) : navigateUrl;
                // Show the UI once the url has been created. Get the window handle for the popup.
                const popupWindow = this.initiateAuthRequest(popupNavigateUrl, popupParams);
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.POPUP_OPENED, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, {
                    popupWindow: popupWindow
                }, null);
                // Wait for the redirect bridge response
                const responseString = await this.waitForPopupResponse(request, popupWindow, popupParams.popupWindowParent);
                const serverParams = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$deserializeResponse, $9797579afd7d961c$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
                return await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, $9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
            }
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request, popupParams, pkceCodes) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateEarKey, $9797579afd7d961c$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkce = pkceCodes || await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const popupRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkce.challenge,
            ...tokenBindingParams,
            popupOriginCheckDone: this.getPopupOriginCheckDone(popupParams.popupWindowParent)
        };
        const popupWindow = await this.openPostFormPopup(popupRequest, discoveredAuthority, popupParams, correlationId, true);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await $9797579afd7d961c$var$invokeAsync(this.waitForPopupResponse.bind(this), $9797579afd7d961c$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(popupRequest, popupWindow, popupParams.popupWindowParent);
        const serverParams = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$deserializeResponse, $9797579afd7d961c$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, pkce.verifier, $9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseEAR, $9797579afd7d961c$var$HandleResponseEar, this.logger, this.performanceClient, correlationId)(popupRequest, serverParams, $9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    async executeCodeFlowWithPost(request, popupParams, authClient, pkceVerifier) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        const popupWindow = await this.openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, false);
        // Monitor the popup for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await $9797579afd7d961c$var$invokeAsync(this.waitForPopupResponse.bind(this), $9797579afd7d961c$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(request, popupWindow, popupParams.popupWindowParent);
        const serverParams = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$deserializeResponse, $9797579afd7d961c$var$DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.responseMode, this.logger, this.correlationId);
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(request, serverParams, pkceVerifier, $9797579afd7d961c$var$ApiId.acquireTokenPopup, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("0b7yrk", this.correlationId);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_START, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, validRequest);
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.logoutPopup, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Clear cache on logout
            await $9797579afd7d961c$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validRequest.account);
            // Initialize the client
            const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC) {
                    this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_SUCCESS, validRequest.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: $9797579afd7d961c$var$ApiId.logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = $9797579afd7d961c$var$UrlString.getAbsoluteUrl(mainWindowRedirectUri, $9797579afd7d961c$var$getCurrentUri(), this.correlationId);
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validRequest.state = $9797579afd7d961c$var$setRequestState(this.browserCrypto, validRequest.state || "", {
                interactionType: $9797579afd7d961c$export$4ec29255e7e7f68f.Popup
            }, validRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_SUCCESS, validRequest.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, validRequest);
            /*
             * When a popup-relay page is configured, open it top-level (same
             * first-party origin) and carry the end-session URL in its hash,
             * exactly like the login flow. The relay page opens the IdP child
             * popup and the post-logout redirect page (running the redirect
             * bridge) relays completion back via postMessage — so logout works
             * from an embedded, cross-origin iframe where a direct popup to the
             * IdP cannot. See runPopupRelay / waitForPopupResponse.
             */ const popupRelayUri = this.config.auth.popupRelayUri;
            const popupNavigateUrl = popupRelayUri ? $9797579afd7d961c$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(validRequest.state || "", this.correlationId), {
                method: "GET",
                url: logoutUri
            }, this.correlationId) : logoutUri;
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(popupNavigateUrl, popupParams);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.POPUP_OPENED, validRequest.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, {
                popupWindow: popupWindow
            }, null);
            await this.waitForPopupResponse(validRequest, popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: $9797579afd7d961c$var$ApiId.logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = $9797579afd7d961c$var$UrlString.getAbsoluteUrl(mainWindowRedirectUri, $9797579afd7d961c$var$getCurrentUri(), this.correlationId);
                this.logger.verbose("0qcur2", this.correlationId);
                this.logger.verbosePii(`0oj7lk ${absoluteUrl}`, this.correlationId);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("03zgcf", this.correlationId);
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_FAILURE, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, null, e);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_END, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup);
            throw e;
        }
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_END, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`1kcr9k ${requestUrl}`, this.correlationId);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("1l7hyp", this.correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$emptyNavigateUri, this.correlationId);
        }
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`0cgeo7 ${urlNavigate}`, this.correlationId);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`0c2awd ${urlNavigate}`, this.correlationId);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$emptyWindowError, this.correlationId);
            try {
                popupWindow.document.title = "Microsoft Authentication";
            } catch (e) {
                if (typeof DOMException !== "undefined" && e instanceof DOMException && e.name === "SecurityError") ;
                else this.logger.verbose("1s1yfs", this.correlationId);
            }
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            return popupWindow;
        } catch (e) {
            this.logger.error(`0dxfb9 ${e.message}`, this.correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$popupWindowError, this.correlationId);
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("08vfmo", this.correlationId);
            width = $9797579afd7d961c$var$BrowserConstants.POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("09cxa0", this.correlationId);
            height = $9797579afd7d961c$var$BrowserConstants.POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("1qh4wo", this.correlationId);
            top = Math.max(0, winHeight / 2 - $9797579afd7d961c$var$BrowserConstants.POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("1sz3en", this.correlationId);
            left = Math.max(0, winWidth / 2 - $9797579afd7d961c$var$BrowserConstants.POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${$9797579afd7d961c$var$BrowserConstants.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${$9797579afd7d961c$var$BrowserConstants.POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
    /**
     * Decodes the per-request library-state id from the encoded request state.
     */ getRelayStateId(state, correlationId) {
        return $9797579afd7d961c$var$parseRequestState($9797579afd7d961c$var$base64Decode, state, correlationId).libraryState.id;
    }
    /**
     * Asserts `pocd=1` for the relay flow. Direct popups also require the
     * environment of a delegated opening window to pass the origin check.
     *
     * With a relay the IdP window is a grandchild popup, which an untrusted
     * ancestor cannot reach by name — so the topology satisfies the check by
     * construction. The current window is framed and would otherwise compute
     * `0`. Without a delegated parent, the standard app check remains unchanged.
     *
     * @param popupWindowParent Window that opens the popup.
     */ getPopupOriginCheckDone(popupWindowParent) {
        if (this.config.auth.popupRelayUri) return true;
        if (popupWindowParent !== window) return $9797579afd7d961c$var$computePocd(this.config) === 1 && $9797579afd7d961c$var$computePocd(this.config, popupWindowParent) === 1;
        return undefined;
    }
    /**
     * Opens the interactive popup for a POST-form /authorize request. Shared by
     * the auth-code POST and EAR flows, which are identical apart from the form
     * builder (`isEAR` selects the EAR vs auth-code builders). When a
     * popup-relay page is configured the form is carried to the relay page
     * (which opens the IdP child popup); otherwise the form is submitted
     * directly into the popup.
     */ async openPostFormPopup(request, discoveredAuthority, popupParams, correlationId, isEAR) {
        const popupRelayUri = this.config.auth.popupRelayUri;
        if (popupRelayUri) {
            const getFormData = isEAR ? $9797579afd7d961c$var$getEARFormData : $9797579afd7d961c$var$getCodeFormData;
            const formData = await getFormData(this.config, discoveredAuthority, request, this.logger, this.performanceClient);
            const relayUrl = $9797579afd7d961c$var$buildPopupRelayUrl(popupRelayUri, this.getRelayStateId(request.state, correlationId), {
                method: "POST",
                action: formData.action,
                fields: formData.fields
            }, correlationId);
            return this.initiateAuthRequest(relayUrl, popupParams);
        }
        const popupWindow = popupParams.popup || this.openPopup("about:blank", popupParams);
        const getForm = isEAR ? $9797579afd7d961c$var$getEARForm : $9797579afd7d961c$var$getCodeForm;
        const form = await getForm(popupWindow.document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return popupWindow;
    }
    async waitForPopupResponse(request, popupWindow, popupWindowParent) {
        /*
         * When a popup-relay page is configured the response is relayed back to
         * this frame by the relay page via postMessage, and the relay popup's
         * lifecycle (including the user dismissing it before signing in) must be
         * tracked here. This takes precedence over the default bridge response
         * hook, whose BroadcastChannel cannot reach a partitioned cross-site
         * frame and which does not track the relay popup.
         */ if (this.config.auth.popupRelayUri) return $9797579afd7d961c$var$waitForPopupRelayResponse(this.config.system.popupBridgeTimeout, this.logger, request, popupWindow, this.performanceClient);
        if (this.waitForPopupResponseHook) return this.waitForPopupResponseHook(request, popupWindow, popupWindowParent);
        return $9797579afd7d961c$var$waitForBridgeResponse(this.config.system.popupBridgeTimeout, this.logger, request, this.performanceClient);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $9797579afd7d961c$var$RedirectClient extends $9797579afd7d961c$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, correlationId, platformAuthHandler, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthHandler, tokenBindingKeyManager);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeAuthorizationRequest, $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        validRequest.platformBroker = $9797579afd7d961c$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, request.authenticationScheme);
        let rejectBackButtonCancellation;
        const backButtonCancellation = new Promise((_, reject)=>{
            rejectBackButtonCancellation = reject;
        });
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("0udvtt", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.RESTORE_FROM_BFCACHE, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
                rejectBackButtonCancellation($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$userCancelled, this.correlationId));
            }
        };
        const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
        this.logger.verbosePii(`0zao0a ${redirectStartPage}`, this.correlationId);
        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
        this.browserStorage.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.ORIGIN_URI, redirectStartPage, true);
        // Clear temporary cache if the back button is clicked during the redirect flow.
        window.addEventListener("pageshow", handleBackButton);
        try {
            const redirectOperation = $9797579afd7d961c$var$shouldUseEar(this.config.system.protocolMode, this.logger, this.performanceClient, this.correlationId) ? this.executeEarFlow(validRequest) : this.executeCodeFlow(validRequest);
            await Promise.race([
                redirectOperation,
                backButtonCancellation
            ]);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) e.correlationId = this.correlationId;
            window.removeEventListener("pageshow", handleBackButton);
            throw e;
        }
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        const correlationId = request.correlationId;
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.acquireTokenRedirect, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const pkceCodes = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const redirectRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        try {
            if (redirectRequest.httpMethod === $9797579afd7d961c$var$HttpMethod.POST) return await this.executeCodeFlowWithPost(redirectRequest);
            else {
                // Initialize the client
                const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                    serverTelemetryManager: serverTelemetryManager,
                    requestAuthority: redirectRequest.authority,
                    requestAzureCloudOptions: redirectRequest.azureCloudOptions,
                    requestExtraQueryParameters: redirectRequest.extraQueryParameters,
                    account: redirectRequest.account
                });
                // Create acquire token url.
                const navigateUrl = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getAuthCodeRequestUrl, $9797579afd7d961c$var$GetAuthCodeUrl, this.logger, this.performanceClient, request.correlationId)(this.config, authClient.authority, redirectRequest, this.logger, this.performanceClient);
                // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
                return await this.initiateAuthRequest(navigateUrl);
            }
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateEarKey, $9797579afd7d961c$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const redirectRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        this.browserStorage.cacheAuthorizeRequest(redirectRequest, this.correlationId, pkceCodes.verifier);
        const form = await $9797579afd7d961c$var$getEARForm(document, this.config, discoveredAuthority, redirectRequest, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$timedOut, "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Executes classic Authorization Code flow with a POST request.
     * @param request
     */ async executeCodeFlowWithPost(request) {
        const correlationId = request.correlationId;
        // Get the frame handle for the silent request
        const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger);
        this.browserStorage.cacheAuthorizeRequest(request, this.correlationId);
        const form = await $9797579afd7d961c$var$getCodeForm(document, this.config, discoveredAuthority, request, this.logger, this.performanceClient);
        form.submit();
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$timedOut, "", "failed_to_redirect"));
            }, this.config.system.redirectNavigationTimeout);
        });
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     * @param request {CommonAuthorizationUrlRequest} request object
     * @param pkceVerifier {string} PKCE verifier
     * @param options {HandleRedirectPromiseOptions} options for handling redirect promise
     */ async handleRedirectPromise(request, pkceVerifier, parentMeasurement, options) {
        const originalTitle = document.title;
        document.title = "Microsoft Authentication";
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.handleRedirectPromise, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const navigateToLoginRequestUrl = options?.navigateToLoginRequestUrl ?? true;
        try {
            const [serverParams, responseString] = this.getRedirectResponse(options?.hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("1qmv0q", this.correlationId);
                this.browserStorage.resetRequestCache(this.correlationId);
                // Do not instrument "no_server_response" if user clicked back button
                if ($9797579afd7d961c$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("1eqegq", this.correlationId);
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.ORIGIN_URI, this.correlationId, true) || "";
            const loginRequestUrlNormalized = $9797579afd7d961c$var$normalizeUrlForComparison(loginRequestUrl, this.logger, this.correlationId);
            const currentUrlNormalized = $9797579afd7d961c$var$normalizeUrlForComparison(window.location.href, this.logger, this.correlationId);
            if (loginRequestUrlNormalized === currentUrlNormalized && navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("11yred", this.correlationId);
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                $9797579afd7d961c$var$replaceHash(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
                return handleHashResult;
            } else if (!navigateToLoginRequestUrl) {
                this.logger.verbose("0v4sdv", this.correlationId);
                return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            } else if (!$9797579afd7d961c$var$isInIframe() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: $9797579afd7d961c$var$ApiId.handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl) {
                    // Redirect to home page if login request url is empty
                    const homepage = $9797579afd7d961c$var$getHomepage(this.correlationId);
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.ORIGIN_URI, homepage, true);
                    this.logger.warning("1dutq1", this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`08jpy1 ${loginRequestUrl}`, this.correlationId);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, request, pkceVerifier, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        } finally{
            document.title = originalTitle;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("1c5i8m", this.correlationId);
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = $9797579afd7d961c$var$getDeserializedResponse(responseString);
        if (response) {
            try {
                $9797579afd7d961c$var$validateInteractionType(response, this.browserCrypto, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, this.correlationId);
            } catch (e) {
                if (e instanceof $9797579afd7d961c$var$AuthError) this.logger.error(`0bkq6p ${e.errorCode} ${e.errorMessage}`, this.correlationId);
                return [
                    null,
                    ""
                ];
            }
            this.logger.verbose("00uvho", this.correlationId);
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache($9797579afd7d961c$var$TemporaryCacheKeys.URL_HASH, this.correlationId, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey($9797579afd7d961c$var$TemporaryCacheKeys.URL_HASH));
        if (cachedHash) {
            response = $9797579afd7d961c$var$getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("001671", this.correlationId);
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, request, codeVerifier, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noStateInHash, request.correlationId);
        const { authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        if (serverParams.ear_jwe) {
            const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, request.correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
            return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseEAR, $9797579afd7d961c$var$HandleResponseEar, this.logger, this.performanceClient, request.correlationId)(request, serverParams, $9797579afd7d961c$var$ApiId.acquireTokenRedirect, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        }
        const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: request.authority
        });
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(request, serverParams, codeVerifier, $9797579afd7d961c$var$ApiId.acquireTokenRedirect, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     * @param onRedirectNavigateRequest - onRedirectNavigate callback provided on the request
     */ async initiateAuthRequest(requestUrl) {
        this.logger.verbose("0yaw2e", this.correlationId);
        // Navigate if valid URL
        if (requestUrl) {
            this.logger.infoPii(`1luf83 ${requestUrl}`, this.correlationId);
            const navigationOptions = {
                apiId: $9797579afd7d961c$var$ApiId.acquireTokenRedirect,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof onRedirectNavigate === "function") {
                this.logger.verbose("1nehvl", this.correlationId);
                const navigate = onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("1a0jxh", this.correlationId);
                    await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("09k5h5", this.correlationId);
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("0klwf7", this.correlationId);
                await this.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("0rlh4e", this.correlationId);
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$emptyNavigateUri, this.correlationId);
        }
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("1rkurh", this.correlationId);
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.logout, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_START, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, logoutRequest);
            // Clear cache on logout
            await $9797579afd7d961c$var$clearCacheOnLogout(this.browserStorage, this.browserCrypto, this.logger, this.correlationId, validLogoutRequest.account);
            const navigationOptions = {
                apiId: $9797579afd7d961c$var$ApiId.logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === $9797579afd7d961c$var$ProtocolMode.OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_SUCCESS, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, validLogoutRequest);
                    return;
                }
            }
            // Redirect bridge requires "state" param to work properly
            validLogoutRequest.state = $9797579afd7d961c$var$setRequestState(this.browserCrypto, validLogoutRequest.state || "", {
                interactionType: $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect
            }, validLogoutRequest.correlationId);
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            if (validLogoutRequest.account?.homeAccountId) this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_SUCCESS, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            const onRedirectNavigate = this.config.auth.onRedirectNavigate;
            if (typeof onRedirectNavigate === "function") {
                const navigate = onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("06v57e", this.correlationId);
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNOUT);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("0xqes1", this.correlationId);
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNOUT);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_FAILURE, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, null, e);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_END, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
            throw e;
        }
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGOUT_END, this.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        const absoluteRedirectStartPage = $9797579afd7d961c$var$UrlString.getAbsoluteUrl(redirectStartPage, $9797579afd7d961c$var$getCurrentUri(), this.correlationId);
        // Sanity check the URL before it is cached so we never persist a malformed value (e.g. the literal string "null")
        $9797579afd7d961c$var$validateUrl(absoluteRedirectStartPage, this.logger, this.correlationId);
        return absoluteRedirectStartPage;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Navigates the given hidden iframe to the provided URL.
 * @param frame
 * @param requestUrl
 */ async function $9797579afd7d961c$var$initiateCodeRequest(frame, requestUrl, logger, correlationId) {
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("1l7hyp", correlationId);
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$emptyNavigateUri, correlationId);
    }
    frame.src = requestUrl;
    return frame;
}
async function $9797579afd7d961c$var$initiateCodeFlowWithPost(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await $9797579afd7d961c$var$getCodeForm(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
async function $9797579afd7d961c$var$initiateEarRequest(frame, config, authority, request, logger, performanceClient) {
    if (!frame.contentDocument) throw "No document associated with iframe!";
    const form = await $9797579afd7d961c$var$getEARForm(frame.contentDocument, config, authority, request, logger, performanceClient);
    form.submit();
    return frame;
}
/**
 * @hidden
 * Creates a new hidden iframe for silent token renewal. Callers navigate it
 * (set `src` or submit a form) after registering the response listener.
 * @ignore
 */ function $9797579afd7d961c$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.title = "Microsoft Authentication";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    authFrame.setAttribute("allow", "local-network-access *");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from `document.body` if it is a direct child.
 * @param iframe - The iframe element to remove.
 */ function $9797579afd7d961c$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SilentIframeClient extends $9797579afd7d961c$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, correlationId, platformAuthProvider, waitForIframeResponseHook, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
        this.waitForIframeResponseHook = waitForIframeResponseHook;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("1kl318", this.correlationId);
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== $9797579afd7d961c$var$PromptValue$1.NONE && inputRequest.prompt !== $9797579afd7d961c$var$PromptValue$1.NO_SESSION) {
                this.logger.warning(`0bmctg ${inputRequest.prompt} ${$9797579afd7d961c$var$PromptValue$1.NONE}`, this.correlationId);
                inputRequest.prompt = $9797579afd7d961c$var$PromptValue$1.NONE;
            }
        } else inputRequest.prompt = $9797579afd7d961c$var$PromptValue$1.NONE;
        // Create silent request
        const silentRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeAuthorizationRequest, $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(inputRequest, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        silentRequest.platformBroker = $9797579afd7d961c$var$isPlatformAuthAllowed(this.config, this.logger, this.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme);
        $9797579afd7d961c$var$preconnect(silentRequest.authority);
        if ($9797579afd7d961c$var$shouldUseEar(this.config.system.protocolMode, this.logger, this.performanceClient, this.correlationId)) return this.executeEarFlow(silentRequest);
        else return this.executeCodeFlow(silentRequest);
    }
    /**
     * Executes auth code + PKCE flow
     * @param request
     * @returns
     */ async executeCodeFlow(request) {
        let authClient;
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            // Initialize the client
            authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account
            });
            return await $9797579afd7d961c$var$invokeAsync(this.silentTokenHelper.bind(this), $9797579afd7d961c$var$SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, request);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof $9797579afd7d961c$var$AuthError) || e.errorCode !== $9797579afd7d961c$var$BrowserConstants.INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            return await $9797579afd7d961c$var$invokeAsync(this.silentTokenHelper.bind(this), $9797579afd7d961c$var$SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, request);
        }
    }
    /**
     * Executes EAR flow
     * @param request
     */ async executeEarFlow(request) {
        const { correlationId: correlationId, authority: authority, azureCloudOptions: azureCloudOptions, extraQueryParameters: extraQueryParameters, account: account } = request;
        const discoveredAuthority = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getDiscoveredAuthority, $9797579afd7d961c$var$StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, correlationId)(this.config, this.correlationId, this.performanceClient, this.browserStorage, this.logger, authority, azureCloudOptions, extraQueryParameters, account);
        const earJwk = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generateEarKey, $9797579afd7d961c$var$GenerateEarKey, this.logger, this.performanceClient, correlationId)();
        const pkceCodes = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const silentRequest = {
            ...request,
            earJwk: earJwk,
            codeChallenge: pkceCodes.challenge
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = $9797579afd7d961c$var$createHiddenIframe();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        let responseString;
        try {
            const responsePromise = $9797579afd7d961c$var$invokeAsync(this.waitForIframeResponse.bind(this), $9797579afd7d961c$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If navigation below throws before responsePromise is awaited,
                 * the listener still rejects on timeout. Swallow it here so it
                 * does not surface as an unhandled rejection; the navigation
                 * error is propagated instead.
                 */ });
            await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initiateEarRequest, $9797579afd7d961c$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, this.config, discoveredAuthority, silentRequest, this.logger, this.performanceClient);
            responseString = await responsePromise;
        } finally{
            $9797579afd7d961c$var$invoke($9797579afd7d961c$var$removeHiddenIframe, $9797579afd7d961c$var$RemoveHiddenIframe, this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$deserializeResponse, $9797579afd7d961c$var$DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        if (!serverParams.ear_jwe && serverParams.code) {
            // If server doesn't support EAR, they may fallback to auth code flow instead
            const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, correlationId)({
                serverTelemetryManager: $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
                requestAuthority: request.authority,
                requestAzureCloudOptions: request.azureCloudOptions,
                requestExtraQueryParameters: request.extraQueryParameters,
                account: request.account,
                authority: discoveredAuthority
            });
            return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
        } else return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseEAR, $9797579afd7d961c$var$HandleResponseEar, this.logger, this.performanceClient, correlationId)(silentRequest, serverParams, this.apiId, this.config, discoveredAuthority, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Verifies SSO capability by making an iframe request to /authorize without exchanging the code for tokens.
     * This is useful for verifying SSO capability in the background without the overhead of a full token exchange.
     * @param request - The SSO silent request
     * @returns true if SSO verification was successful with a valid authorization code, false otherwise
     */ async verifySso(request) {
        const inputRequest = {
            ...request
        };
        if (!inputRequest.prompt) inputRequest.prompt = $9797579afd7d961c$var$PromptValue$1.NONE;
        // Create silent request
        const silentRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeAuthorizationRequest, $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(inputRequest, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, this.correlationId);
        const authClient = await $9797579afd7d961c$var$invokeAsync(this.createAuthCodeClient.bind(this), $9797579afd7d961c$var$StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled),
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            requestExtraQueryParameters: silentRequest.extraQueryParameters,
            account: silentRequest.account
        });
        const { serverParams: serverParams } = await this.silentAuthorizeHelper(authClient, silentRequest);
        const correlationId = silentRequest.correlationId;
        // Validate the response - this checks for errors and validates state
        $9797579afd7d961c$var$validateAuthorizationResponse(serverParams, silentRequest.state, correlationId);
        // Verify a valid authorization code is present
        if (!serverParams.code) {
            this.logger.warning("0y34ti", correlationId);
            return false;
        }
        this.logger.verbose("0kkkcj", correlationId);
        return true;
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$silentLogoutUnsupported, ""));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, request) {
        const { serverParams: serverParams, pkceCodes: pkceCodes, silentRequest: silentRequest } = await this.silentAuthorizeHelper(authClient, request);
        return $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$handleResponseCode, $9797579afd7d961c$var$HandleResponseCode, this.logger, this.performanceClient, request.correlationId)(silentRequest, serverParams, pkceCodes.verifier, this.apiId, this.config, authClient, this.browserStorage, this.nativeStorage, this.eventHandler, this.logger, this.performanceClient, this.platformAuthProvider);
    }
    /**
     * Shared helper that generates PKCE codes, builds the /authorize URL,
     * loads it in a hidden iframe, waits for the redirect-bridge response,
     * and returns the deserialized server parameters along with the PKCE codes
     * and the request that was sent.
     */ async silentAuthorizeHelper(authClient, request) {
        const correlationId = request.correlationId;
        const pkceCodes = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(request, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const silentRequest = {
            ...request,
            codeChallenge: pkceCodes.challenge,
            ...tokenBindingParams
        };
        // Create the iframe, register the response listener, then navigate, so the listener is active before the iframe can respond.
        const iframe = $9797579afd7d961c$var$createHiddenIframe();
        const responseType = this.config.auth.OIDCOptions.responseMode;
        // Wait for response from the redirect bridge.
        let responseString;
        try {
            const responsePromise = $9797579afd7d961c$var$invokeAsync(this.waitForIframeResponse.bind(this), $9797579afd7d961c$var$SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(iframe, request);
            responsePromise.catch(()=>{
            /*
                 * If URL creation or navigation below throws before
                 * responsePromise is awaited, the listener still rejects on
                 * timeout. Swallow it here so it does not surface as an
                 * unhandled rejection; the navigation error is propagated
                 * instead.
                 */ });
            if (request.httpMethod === $9797579afd7d961c$var$HttpMethod.POST) await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initiateCodeFlowWithPost, $9797579afd7d961c$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
            else {
                // Create authorize request url
                const navigateUrl = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$getAuthCodeRequestUrl, $9797579afd7d961c$var$GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)(this.config, authClient.authority, silentRequest, this.logger, this.performanceClient);
                // Navigate the iframe to the authorize request url
                await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initiateCodeRequest, $9797579afd7d961c$var$SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(iframe, navigateUrl, this.logger, correlationId);
            }
            responseString = await responsePromise;
        } finally{
            $9797579afd7d961c$var$invoke($9797579afd7d961c$var$removeHiddenIframe, $9797579afd7d961c$var$RemoveHiddenIframe, this.logger, this.performanceClient, correlationId)(iframe);
        }
        const serverParams = $9797579afd7d961c$var$invoke($9797579afd7d961c$var$deserializeResponse, $9797579afd7d961c$var$DeserializeResponse, this.logger, this.performanceClient, correlationId)(responseString, responseType, this.logger, this.correlationId);
        return {
            serverParams: serverParams,
            pkceCodes: pkceCodes,
            silentRequest: silentRequest
        };
    }
    async waitForIframeResponse(iframe, request) {
        if (this.waitForIframeResponseHook) return this.waitForIframeResponseHook(iframe, request);
        return $9797579afd7d961c$var$waitForBridgeResponse(this.config.system.iframeBridgeTimeout, this.logger, request, this.performanceClient, this.config.experimental);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SilentRefreshClient extends $9797579afd7d961c$var$StandardInteractionClient {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        const baseRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeBaseRequest, $9797579afd7d961c$var$InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger, this.correlationId);
        const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(baseRequest, this.tokenBindingKeyManager, this.logger, this.performanceClient);
        const silentRequest = {
            ...request,
            ...baseRequest,
            ...tokenBindingParams
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = $9797579afd7d961c$var$getRedirectUri(request.redirectUri, this.config.auth.redirectUri, this.logger, this.correlationId);
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager($9797579afd7d961c$var$ApiId.acquireTokenSilent_silentFlow, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return $9797579afd7d961c$var$invokeAsync(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), $9797579afd7d961c$var$RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest, $9797579afd7d961c$var$ApiId.acquireTokenSilent_silentFlow).catch((e)=>{
            e.correlationId = this.correlationId;
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$silentLogoutUnsupported, ""));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await $9797579afd7d961c$var$invokeAsync(this.getClientConfiguration.bind(this), $9797579afd7d961c$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new $9797579afd7d961c$var$RefreshTokenClient(clientConfig, this.performanceClient);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$HybridSpaAuthorizationCodeClient extends $9797579afd7d961c$var$AuthorizationCodeClient {
    constructor(config, performanceClient){
        super(config, performanceClient);
        this.includeRedirectUri = false;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SilentAuthCodeClient extends $9797579afd7d961c$var$StandardInteractionClient {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, correlationId, platformAuthProvider, tokenBindingKeyManager);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$authCodeRequired, this.correlationId);
        // Create silent request
        const silentRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeAuthorizationRequest, $9797579afd7d961c$var$StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, this.config, this.browserCrypto, this.browserStorage, this.logger, this.performanceClient, /*
         * correlationId is optional in request payload, while this.correlationId is always instantiated as request.correlationId || createGuid().
         * Each auth request creates a new instance of *Client so we can safely use this.correlationId.
         */ this.correlationId);
        const serverTelemetryManager = $9797579afd7d961c$var$initializeServerTelemetryManager(this.apiId, this.config.auth.clientId, this.correlationId, this.browserStorage, this.logger, undefined, this.config.system.serverTelemetryEnabled);
        try {
            const tokenBindingParams = await $9797579afd7d961c$var$getTokenBindingRequestParams(silentRequest, this.tokenBindingKeyManager, this.logger, this.performanceClient);
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code,
                ...tokenBindingParams
            };
            // Initialize the client
            const clientConfig = await $9797579afd7d961c$var$invokeAsync(this.getClientConfiguration.bind(this), $9797579afd7d961c$var$StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new $9797579afd7d961c$var$HybridSpaAuthorizationCodeClient(clientConfig, this.performanceClient);
            this.logger.verbose("1uic5e", this.correlationId);
            // Create silent handler
            const interactionHandler = new $9797579afd7d961c$var$InteractionHandler(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await $9797579afd7d961c$var$invokeAsync(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), $9797579afd7d961c$var$HandleCodeResponseFromServer, this.logger, this.performanceClient, this.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, this.apiId, false);
        } catch (e) {
            if (e instanceof $9797579afd7d961c$var$AuthError) {
                e.correlationId = this.correlationId;
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject($9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$silentLogoutUnsupported, ""));
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */ function $9797579afd7d961c$var$getNetworkInfo() {
    if (typeof window === "undefined" || !window.navigator) return {};
    const connection = "connection" in window.navigator ? window.navigator.connection : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt
    };
}
function $9797579afd7d961c$var$collectInstanceStats(currentClientId, performanceEvent, logger, correlationId) {
    const frameInstances = // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i)=>i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) logger.warning("1e88vg", correlationId);
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount
    });
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Selects request preparation using the current account and broker availability.
 */ function $9797579afd7d961c$var$resolveSilentRequestPreparation(input, platformAuthProvider, logger, performanceClient) {
    const { request: request, account: account, correlationId: correlationId, config: config } = input;
    const prepareRequest = account.nativeAccountId && $9797579afd7d961c$var$isPlatformAuthAllowed(config, logger, correlationId, platformAuthProvider, request.authenticationScheme, performanceClient) ? $9797579afd7d961c$var$preparePlatformSilentRequest : $9797579afd7d961c$var$prepareWebSilentRequest;
    return prepareRequest(input);
}
/**
 * Extends the web thumbprint with silent-flow options while preserving caller-owned references.
 */ function $9797579afd7d961c$var$prepareWebSilentRequest({ request: request, account: account, correlationId: correlationId, config: config }) {
    const thumbprint = $9797579afd7d961c$var$getRequestThumbprint(config.auth.clientId, {
        ...request,
        authority: request.authority || config.auth.authority
    }, account.homeAccountId);
    return {
        key: JSON.stringify({
            ...thumbprint,
            forceRefresh: !!request.forceRefresh,
            cacheLookupPolicy: request.cacheLookupPolicy ?? $9797579afd7d961c$var$CacheLookupPolicy.Default,
            extraParameters: $9797579afd7d961c$var$canonicalizeStringDict(request.extraParameters),
            extraQueryParameters: $9797579afd7d961c$var$canonicalizeStringDict(request.extraQueryParameters)
        }),
        request: request,
        account: account
    };
}
/**
 * Snapshots broker inputs and creates the extended key before acquisition begins.
 */ function $9797579afd7d961c$var$preparePlatformSilentRequest({ request: request, account: account, config: config }) {
    const platformRequest = $9797579afd7d961c$var$snapshotPlatformSilentRequest({
        ...request,
        account: account
    });
    return {
        key: `platform:${$9797579afd7d961c$var$getPlatformSilentRequestKey(platformRequest, config)}`,
        request: platformRequest,
        account: platformRequest.account
    };
}
/**
 * Extends the common thumbprint with broker and client-side silent-flow inputs.
 * Scopes are normalized like the broker request, without folding their casing.
 */ function $9797579afd7d961c$var$getPlatformSilentRequestKey(request, config) {
    const thumbprint = $9797579afd7d961c$var$getRequestThumbprint(config.auth.clientId, {
        ...request,
        authority: request.authority || config.auth.authority,
        correlationId: request.correlationId || "",
        scopes: new $9797579afd7d961c$var$ScopeSet([
            ...request.scopes || [],
            ...$9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1
        ], request.correlationId || "").asArray().sort()
    }, request.account.homeAccountId);
    return JSON.stringify({
        ...thumbprint,
        accountId: request.account.nativeAccountId,
        accountTenantId: request.account.tenantId,
        accountEnvironment: request.account.environment,
        azureCloudInstance: request.azureCloudOptions?.azureCloudInstance,
        cloudTenantId: request.azureCloudOptions?.tenant,
        redirectUri: request.redirectUri || config.auth.redirectUri,
        nonce: request.nonce,
        prompt: request.prompt,
        state: request.state,
        loginHint: request.loginHint,
        popKid: request.popKid,
        shrNonce: request.shrNonce,
        dpopNonce: request.dpopNonce,
        skipBrokerClaims: request.embeddedClientId ? !!request.skipBrokerClaims : undefined,
        extraParameters: $9797579afd7d961c$var$canonicalizeStringDict(request.extraParameters),
        extraQueryParameters: $9797579afd7d961c$var$canonicalizeStringDict(request.extraQueryParameters),
        extraParametersNoCache: $9797579afd7d961c$var$canonicalizeStringDict(request.extraParametersNoCache),
        forceRefresh: !!request.forceRefresh,
        cacheLookupPolicy: request.cacheLookupPolicy ?? $9797579afd7d961c$var$CacheLookupPolicy.Default
    });
}
/**
 * Copies caller-owned mutable inputs before asynchronous broker initialization.
 */ function $9797579afd7d961c$var$snapshotPlatformSilentRequest(request) {
    return {
        ...request,
        scopes: [
            ...request.scopes || []
        ],
        account: {
            ...request.account
        },
        azureCloudOptions: request.azureCloudOptions ? {
            ...request.azureCloudOptions
        } : undefined,
        extraParameters: request.extraParameters ? {
            ...request.extraParameters
        } : undefined,
        extraQueryParameters: request.extraQueryParameters ? {
            ...request.extraQueryParameters
        } : undefined,
        extraParametersNoCache: request.extraParametersNoCache ? {
            ...request.extraParametersNoCache
        } : undefined,
        attributeTokens: request.attributeTokens ? [
            ...request.attributeTokens
        ] : undefined,
        storeInCache: request.storeInCache ? {
            ...request.storeInCache
        } : undefined
    };
}
/**
 * Canonicalizes dictionary ordering while preserving exact parameter values.
 */ function $9797579afd7d961c$var$canonicalizeStringDict(values = {}) {
    return Object.keys(values).sort().map((key)=>[
            key,
            values[key]
        ]);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$preflightCheck(initialized, performanceEvent, config, request) {
    try {
        $9797579afd7d961c$var$preflightCheck$1(initialized);
        $9797579afd7d961c$var$enforceResourceParameter(config.auth.isMcp, request);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e, request.account);
        throw e;
    }
}
class $9797579afd7d961c$var$StandardController {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        this.performanceClient.addGlobalFields({
            allowPlatformBroker: this.config.system.allowPlatformBroker
        });
        // Initialize environment-specific crypto and token-binding services.
        if (this.isBrowserEnvironment) {
            this.browserCrypto = new $9797579afd7d961c$var$CryptoOps(this.logger, this.performanceClient);
            this.tokenBindingKeyManager = new $9797579afd7d961c$var$TokenBindingKeyManager(this.logger, this.performanceClient);
        } else {
            this.browserCrypto = $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION;
            this.tokenBindingKeyManager = $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
        }
        this.eventHandler = new $9797579afd7d961c$var$EventHandler(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new $9797579afd7d961c$var$BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, $9797579afd7d961c$var$buildStaticAuthorityOptions(this.config.auth), this.tokenBindingKeyManager) : $9797579afd7d961c$var$DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler, undefined, this.tokenBindingKeyManager);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: $9797579afd7d961c$var$BrowserCacheLocation.MemoryStorage,
            cacheRetentionDays: 5
        };
        this.nativeInternalStorage = new $9797579afd7d961c$var$BrowserCacheManager(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, undefined, this.tokenBindingKeyManager);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackStateChange = this.trackStateChange.bind(this);
        // Register listener functions
        this.trackStateChangeWithMeasurement = this.trackStateChangeWithMeasurement.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $9797579afd7d961c$var$StandardController(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackStateChange(correlationId, event) {
        if (!correlationId) return;
        if (event.type === "visibilitychange") {
            this.logger.info("16v6hv", correlationId);
            this.performanceClient.incrementFields({
                visibilityChangeCount: 1
            }, correlationId);
        } else if (event.type === "online") {
            this.logger.info("0zirfd", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        } else if (event.type === "offline") {
            this.logger.info("1xk9ef", correlationId);
            this.performanceClient.incrementFields({
                onlineStatusChangeCount: 1
            }, correlationId);
        }
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1f7joy", correlationId);
        if (this.initialized) {
            this.logger.info("061m5x", correlationId);
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("19fvpi", correlationId);
            this.initialized = true;
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.INITIALIZE_END, correlationId);
            return;
        }
        const allowPlatformBroker = this.config.system.allowPlatformBroker;
        const initMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$InitializeClientApplication, correlationId);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.INITIALIZE_START, correlationId);
        // Broker applications are initialized twice, so we avoid double-counting it
        this.logMultipleInstances(initMeasurement, correlationId);
        initMeasurement.add({
            isMcp: this.config.auth.isMcp
        });
        await $9797579afd7d961c$var$invokeAsync(this.browserStorage.initialize.bind(this.browserStorage), $9797579afd7d961c$var$InitializeCache, this.logger, this.performanceClient, correlationId)(correlationId);
        if (allowPlatformBroker) try {
            // check if platform authentication is available via DOM or browser extension and create relevant handlers
            this.platformAuthProvider = await $9797579afd7d961c$var$getPlatformAuthProvider(this.logger, this.performanceClient, correlationId, this.config.system.nativeBrokerHandshakeTimeout, this.config.experimental.allowPlatformBrokerWithDOM);
        } catch (e) {
            this.logger.verbose(e, correlationId);
        }
        if (this.config.cache.cacheLocation === $9797579afd7d961c$var$BrowserCacheLocation.LocalStorage) this.eventHandler.subscribeCrossTab();
        !this.config.system.navigatePopups && await this.preGeneratePkceCodes(correlationId);
        this.initialized = true;
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.INITIALIZE_END, correlationId);
        initMeasurement.end({
            allowPlatformBroker: allowPlatformBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(options) {
        this.logger.verbose("02l8bm", "");
        // Block token acquisition before initialize has been called
        $9797579afd7d961c$var$blockAPICallsBeforeInitialize(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = options?.hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(options);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("1wn9kp", "");
            } else this.logger.verbose("0w0gm3", "");
            return response;
        }
        this.logger.verbose("12xi63", "");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(options) {
        // Preserve the response for RedirectClient before removing it from the URL.
        const responseString = options?.hash || (this.config.auth.OIDCOptions.responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY ? window.location.search : window.location.hash);
        const anyClientInteractionInProgress = this.browserStorage.isInteractionInProgress(false);
        const currentClientInteraction = this.browserStorage.isInteractionInProgress(true);
        const isBridgeCallback = $9797579afd7d961c$var$isInPopup() || $9797579afd7d961c$var$isInIframe() && !this.config.system.allowRedirectInIframe;
        /*
         * Clear recognized response fragments for:
         * - Stale callbacks with no pending interaction.
         * - This client's login callback, even if request setup or response validation fails.
         * - This client's logout callback containing state, before the SIGNOUT early return.
         * Leave another client's callback untouched. clearHash preserves query strings
         * and application routes, and does nothing when no response fragment is present.
         * Skip popup and non-redirect iframe callbacks: legacy apps may call HRP
         * before their redirect bridge reads and broadcasts the response.
         */ if (!isBridgeCallback && (!anyClientInteractionInProgress || currentClientInteraction)) $9797579afd7d961c$var$clearHash(window);
        if (!currentClientInteraction) {
            this.logger.info("0le6uv", "");
            return null;
        }
        const interactionType = this.browserStorage.getInteractionInProgress()?.type;
        if (interactionType === $9797579afd7d961c$var$INTERACTION_TYPE.SIGNOUT) {
            this.logger.verbose("1ywcv2", "");
            this.browserStorage.setInteractionInProgress(false);
            return null;
        }
        const loggedInAccounts = this.getAllAccounts();
        const platformBrokerRequest = this.browserStorage.getCachedNativeRequest();
        const useNative = platformBrokerRequest && !options?.hash;
        let rootMeasurement;
        let redirectResponse;
        let cachedRedirectRequest;
        try {
            if (useNative && this.platformAuthProvider) {
                const correlationId = platformBrokerRequest?.correlationId || "";
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.HANDLE_REDIRECT_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
                rootMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenRedirect, correlationId);
                this.logger.trace("12v7is", correlationId);
                // Cached nativeAccountId routes directly to the broker (no /authorize call)
                rootMeasurement.add({
                    isPlatformBrokerRequest: true
                });
                const nativeClient = new $9797579afd7d961c$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9797579afd7d961c$var$ApiId.handleRedirectPromise, this.performanceClient, this.platformAuthProvider, platformBrokerRequest.accountId, this.nativeInternalStorage, platformBrokerRequest.correlationId, this.tokenBindingKeyManager);
                redirectResponse = $9797579afd7d961c$var$invokeAsync(nativeClient.handleRedirectPromise.bind(nativeClient), $9797579afd7d961c$var$HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)();
            } else {
                const [standardRequest, codeVerifier] = this.browserStorage.getCachedRequest("");
                cachedRedirectRequest = standardRequest;
                const correlationId = standardRequest.correlationId;
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.HANDLE_REDIRECT_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
                // Reset rootMeasurement now that we have correlationId
                rootMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenRedirect, correlationId);
                this.logger.trace("0znzs5", correlationId);
                const redirectClient = this.createRedirectClient(correlationId);
                redirectResponse = $9797579afd7d961c$var$invokeAsync(redirectClient.handleRedirectPromise.bind(redirectClient), $9797579afd7d961c$var$HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(standardRequest, codeVerifier, rootMeasurement, options?.hash ? options : {
                    ...options,
                    hash: responseString
                });
            }
        } catch (e) {
            this.browserStorage.resetRequestCache("");
            throw e;
        }
        return redirectResponse.then((result)=>{
            if (result) {
                this.browserStorage.resetRequestCache(result.correlationId);
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, result.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, result);
                this.logger.verbose("0ui8f5", result.correlationId);
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGIN_SUCCESS, result.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, result.account);
                    this.logger.verbose("16im3l", result.correlationId);
                }
                rootMeasurement.end({
                    success: true,
                    isNativeBroker: result.fromPlatformBroker ?? false
                }, undefined, result.account);
                // Fire-and-forget SSO capability verification in background
                this.verifySsoCapability(cachedRedirectRequest, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (!!rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
            return result;
        }).catch((e)=>{
            this.browserStorage.resetRequestCache(rootMeasurement.event.correlationId);
            const eventError = e;
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, rootMeasurement.event.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, null, eventError);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.HANDLE_REDIRECT_END, rootMeasurement.event.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0os66p", correlationId);
        $9797579afd7d961c$var$redirectPreflightCheck(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNIN);
        const atrMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            scenarioId: request.scenarioId
        });
        const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
        this.config.auth.onRedirectNavigate = (url)=>{
            const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
            atrMeasurement.add({
                navigateCallbackResult: navigate !== false
            });
            atrMeasurement.event = atrMeasurement.end({
                success: true
            }, undefined, request.account) || atrMeasurement.event;
            return navigate;
        };
        try {
            $9797579afd7d961c$var$enforceResourceParameter(this.config.auth.isMcp, request);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, request);
            let result;
            const platformAuthProvider = this.platformAuthProvider;
            if (this.canUsePlatformBroker(request) && platformAuthProvider) {
                const nativeClient = new $9797579afd7d961c$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9797579afd7d961c$var$ApiId.acquireTokenRedirect, this.performanceClient, platformAuthProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId, this.tokenBindingKeyManager);
                result = $9797579afd7d961c$var$invokeAsync(nativeClient.acquireTokenRedirect.bind(nativeClient), $9797579afd7d961c$var$NativeInteractionClientAcquireTokenRedirect, this.logger, this.performanceClient, correlationId)(request, atrMeasurement).catch((e)=>{
                    if (e instanceof $9797579afd7d961c$var$NativeAuthError && $9797579afd7d961c$var$isFatalNativeAuthError(e)) {
                        this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof $9797579afd7d961c$var$InteractionRequiredAuthError) {
                        this.logger.verbose("1ipyz4", correlationId);
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            this.browserStorage.resetRequestCache(correlationId);
            /*
             * Pre-redirect event completes before navigation occurs.
             * Timed out navigation needs to be instrumented separately as a post-redirect event.
             */ if (atrMeasurement.event.status === 2) this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenRedirect, correlationId).end({
                success: false
            }, e, request.account);
            else atrMeasurement.end({
                success: false
            }, e, request.account);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            this.logger.verbose("0ch87b", correlationId);
            $9797579afd7d961c$var$preflightCheck(this.initialized, atPopupMeasurement, this.config, request);
            this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNIN, request.overrideInteractionInProgress, correlationId);
            if (request.overrideInteractionInProgress) $9797579afd7d961c$var$cancelPendingPopupPollingResponse(this.logger);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, request);
        let result;
        const pkce = this.getPreGeneratedPkceCodes(correlationId);
        if (this.canUsePlatformBroker(request)) {
            // Cached nativeAccountId routes directly to the broker (no /authorize call)
            atPopupMeasurement.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative({
                ...request,
                correlationId: correlationId
            }, $9797579afd7d961c$var$ApiId.acquireTokenPopup).then((response)=>{
                atPopupMeasurement.end({
                    success: true,
                    isNativeBroker: response.fromPlatformBroker ?? false
                }, undefined, response.account);
                return response;
            }).catch((e)=>{
                if (e instanceof $9797579afd7d961c$var$NativeAuthError && $9797579afd7d961c$var$isFatalNativeAuthError(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                } else if (e instanceof $9797579afd7d961c$var$InteractionRequiredAuthError) {
                    this.logger.verbose("0yy5fw", correlationId);
                    const popupClient = this.createPopupClient(correlationId);
                    return popupClient.acquireToken(request, pkce);
                }
                throw e;
            });
        } else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request, pkce);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, result);
            if (isLoggingIn) this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGIN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, result.account);
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: result.fromPlatformBroker ?? false,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            // SSO capability verification in background
            this.verifySsoCapability(request, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup);
            return result;
        }).catch((e)=>{
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }).finally(async ()=>{
            this.browserStorage.setInteractionInProgress(false);
            if (!this.config.system.navigatePopups) await this.preGeneratePkceCodes(correlationId);
        });
    }
    trackStateChangeWithMeasurement(event) {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        if (event.type === "visibilitychange") {
            this.logger.info(`0yzimq ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                visibilityChangeCount: 1
            });
        } else if (event.type === "online") {
            this.logger.info(`1caf53 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        } else if (event.type === "offline") {
            this.logger.info(`0fdyk7 ${measurement.event.name}`, measurement.event.correlationId);
            measurement.increment({
                onlineStatusChangeCount: 1
            });
        }
    }
    addStateChangeListeners(listener) {
        document.addEventListener("visibilitychange", listener);
        window.addEventListener("online", listener);
        window.addEventListener("offline", listener);
    }
    removeStateChangeListeners(listener) {
        document.removeEventListener("visibilitychange", listener);
        window.removeEventListener("online", listener);
        window.removeEventListener("offline", listener);
    }
    /**
     * Reads the cached ssoCapable value from localStorage.
     * @returns The cached ssoCapable boolean value, or undefined if not cached or expired.
     */ getCachedSsoCapable() {
        try {
            const cachedValue = window.localStorage.getItem($9797579afd7d961c$var$SSO_CAPABLE);
            if (cachedValue) {
                const parsed = JSON.parse(cachedValue);
                if (parsed && typeof parsed.ssoCapable === "boolean" && parsed.expiresOn && Date.now() < parsed.expiresOn) return parsed.ssoCapable;
            }
        } catch  {
        // If parsing fails, return undefined
        }
        return undefined;
    }
    /**
     * SSO capability verification in the background.
     * This method makes an iframe request to /authorize to verify SSO capability without calling /token.
     * This method does not block the caller and tracks telemetry for success/failure.
     * This method only executes if verifySSO is set to true in the auth configuration.
     * The result is cached in localStorage with a 24-hour TTL; the SSO verification call
     * is only attempted when the cached value is absent or expired.
     * @param request - The original request used for the authentication flow
     * @param interactionType - The interactionType of the AT operation for logging purposes
     */ verifySsoCapability(request, interactionType) {
        // Check if SSO capability verification is enabled
        if (!this.config.auth.verifySSO) return;
        // Check TTL: derive ssoCapable state from localStorage and skip if not expired
        const ssoCacheKey = $9797579afd7d961c$var$SSO_CAPABLE;
        const SSO_CAPABLE_TTL_MS = 86400000; // 24 hours
        const cachedSsoCapable = this.getCachedSsoCapable();
        if (cachedSsoCapable !== undefined) {
            this.logger.verbose(`13poou ${interactionType}`, "");
            return;
        }
        const correlationId = $9797579afd7d961c$var$createNewGuid();
        const ssoCapableMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$SsoCapable, correlationId);
        ssoCapableMeasurement.add({
            "ext.interactionType": interactionType
        });
        this.logger.verbose(`0pbr0i ${interactionType}`, correlationId);
        /*
         * Use setTimeout to ensure this runs in a separate macrotask after the current call stack completes
         * This ensures the result is returned to the caller before the SSO verification starts and doesn't affect performance
         */ setTimeout(()=>{
            const ssoVerificationRequest = {
                ...request,
                correlationId: correlationId
            };
            const silentIframeClient = this.createSilentIframeClient(correlationId);
            silentIframeClient.verifySso(ssoVerificationRequest).then((result)=>{
                this.logger.verbose(`1gd1iv ${interactionType} ${result}`, correlationId);
                // TBD to add profileTelemetry later in localStorage with 24h TTL
                try {
                    const cacheEntry = JSON.stringify({
                        ssoCapable: result,
                        expiresOn: Date.now() + SSO_CAPABLE_TTL_MS
                    });
                    window.localStorage.setItem(ssoCacheKey, cacheEntry);
                } catch  {
                    this.logger.warning(`18lmoj ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: result
                }, undefined);
            }).catch((error)=>{
                this.logger.warning(`05g83w ${interactionType} ${error.message}`, correlationId);
                // reset the cache
                try {
                    window.localStorage.removeItem(ssoCacheKey);
                } catch  {
                    this.logger.warning(`0nlf9q ${interactionType}`, correlationId);
                }
                ssoCapableMeasurement.end({
                    fromCache: false,
                    success: false
                }, error);
            });
        }, 0);
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $9797579afd7d961c$var$preflightCheck(this.initialized, this.ssoSilentMeasurement, this.config, validRequest);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const loggedInAccounts = this.getAllAccounts();
        this.logger.verbose("0w1b45", correlationId);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, validRequest);
        let result;
        if (this.canUsePlatformBroker(validRequest)) {
            // Cached nativeAccountId routes directly to the broker (no /authorize call)
            this.ssoSilentMeasurement?.add({
                isPlatformBrokerRequest: true
            });
            result = this.acquireTokenNative(validRequest, $9797579afd7d961c$var$ApiId.ssoSilent).catch((e)=>{
                // If native token acquisition fails for availability reasons fallback to standard flow
                if (e instanceof $9797579afd7d961c$var$NativeAuthError && $9797579afd7d961c$var$isFatalNativeAuthError(e)) {
                    this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt platform broker calls
                    const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                    return silentIframeClient.acquireToken(validRequest);
                }
                throw e;
            });
        } else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, response);
            if (isLoggingIn) this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.LOGIN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, response.account);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromPlatformBroker ?? false,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length
            }, undefined, response.account);
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw e;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0ch6ga", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenByCode, correlationId);
        $9797579afd7d961c$var$preflightCheck(this.initialized, atbcMeasurement, this.config, request);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$spaCodeAndNativeAccountIdPresent, correlationId);
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("06eh73", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: false,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length
                        }, undefined, result.account);
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("0qgp28", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUsePlatformBroker(request, request.nativeAccountId)) {
                    atbcMeasurement.add({
                        isPlatformBrokerRequest: true
                    });
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, $9797579afd7d961c$var$ApiId.acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof $9797579afd7d961c$var$NativeAuthError && $9797579afd7d961c$var$isFatalNativeAuthError(e)) this.platformAuthProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        success: true,
                        isNativeBroker: result.fromPlatformBroker ?? false
                    }, undefined, result.account);
                    return result;
                } else throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unableToAcquireTokenFromNativePlatform, correlationId);
            } else throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$authCodeOrNativeAccountIdRequired, correlationId);
        } catch (e) {
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("10d9hy", correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenByCodeAsync, correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        });
        this.addStateChangeListeners(this.trackStateChangeWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                isNativeBroker: false,
                fromCache: response.fromCache
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(this.trackStateChangeWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case $9797579afd7d961c$var$CacheLookupPolicy.Default:
            case $9797579afd7d961c$var$CacheLookupPolicy.AccessToken:
            case $9797579afd7d961c$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return $9797579afd7d961c$var$invokeAsync(silentCacheClient.acquireToken.bind(silentCacheClient), $9797579afd7d961c$var$SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        switch(cacheLookupPolicy){
            case $9797579afd7d961c$var$CacheLookupPolicy.Default:
            case $9797579afd7d961c$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
            case $9797579afd7d961c$var$CacheLookupPolicy.RefreshToken:
            case $9797579afd7d961c$var$CacheLookupPolicy.RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return $9797579afd7d961c$var$invokeAsync(silentRefreshClient.acquireToken.bind(silentRefreshClient), $9797579afd7d961c$var$SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, commonRequest.correlationId);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return $9797579afd7d961c$var$invokeAsync(silentIframeClient.acquireToken.bind(silentIframeClient), $9797579afd7d961c$var$SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        $9797579afd7d961c$var$redirectPreflightCheck(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNOUT);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            $9797579afd7d961c$var$preflightCheck$1(this.initialized);
            this.browserStorage.setInteractionInProgress(true, $9797579afd7d961c$var$INTERACTION_TYPE.SIGNOUT);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest).finally(()=>{
                this.browserStorage.setInteractionInProgress(false);
            });
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) return;
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return $9797579afd7d961c$var$getAllAccounts(this.logger, this.browserStorage, this.isBrowserEnvironment, this.getRequestCorrelationId(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return $9797579afd7d961c$var$getAccount(accountFilter, this.logger, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        $9797579afd7d961c$var$setActiveAccount(account, this.browserStorage, this.getRequestCorrelationId());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return $9797579afd7d961c$var$getActiveAccount(this.browserStorage, this.getRequestCorrelationId());
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = $9797579afd7d961c$var$createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, $9797579afd7d961c$var$isKmsi(result.idTokenClaims), $9797579afd7d961c$var$ApiId.hydrateCache);
        if (result.fromPlatformBroker) {
            this.logger.verbose("1i5atf", result.correlationId);
            // Create idToken entity and store in browser storage
            const idTokenEntity = $9797579afd7d961c$var$createIdTokenEntity(result.account.homeAccountId, result.account.environment, result.idToken, this.config.auth.clientId, result.tenantId);
            // Create accessToken entity and store in native internal storage
            const attributeTokenPartition = $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens);
            const additionalCacheKeyComponents = attributeTokenPartition ? {
                attribute_tokens: attributeTokenPartition
            } : undefined;
            const accessTokenEntity = $9797579afd7d961c$var$createAccessTokenEntity(result.account.homeAccountId, result.account.environment, result.accessToken, this.config.auth.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? $9797579afd7d961c$var$toSecondsFromDate(result.expiresOn) : 0, result.extExpiresOn ? $9797579afd7d961c$var$toSecondsFromDate(result.extExpiresOn) : 0, $9797579afd7d961c$var$base64Decode, request.correlationId || "", undefined, result.tokenType, undefined, request.sshKid, additionalCacheKeyComponents);
            if (request.resource) accessTokenEntity.resource = request.resource;
            // Get attribute token partition hash for cache key isolation
            const components = additionalCacheKeyComponents;
            const additionalCacheKeyHash = components ? await this.browserCrypto.hashString(JSON.stringify(components)) : undefined;
            const kmsi = $9797579afd7d961c$var$isKmsi(result.idTokenClaims);
            // Store idToken in browser storage
            await this.browserStorage.setIdTokenCredential(idTokenEntity, result.correlationId, kmsi);
            // Store accessToken in native internal storage
            await this.nativeInternalStorage.setAccessTokenCredential(accessTokenEntity, result.correlationId, kmsi, additionalCacheKeyHash);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     * @param apiId
     * @param accountId
     * @param cacheLookupPolicy
     */ async acquireTokenNative(request, apiId, accountId, cacheLookupPolicy) {
        /*
         * Callers always normalize correlationId onto the request before delegating
         * here, so it is guaranteed defined and is the single id used to key this
         * flow's telemetry.
         */ const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("0b9y3p", correlationId);
        if (!this.platformAuthProvider) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$nativeConnectionNotEstablished, correlationId);
        const nativeClient = new $9797579afd7d961c$var$PlatformAuthInteractionClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.platformAuthProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, correlationId, this.tokenBindingKeyManager);
        return $9797579afd7d961c$var$invokeAsync(nativeClient.acquireToken.bind(nativeClient), $9797579afd7d961c$var$NativeInteractionClientAcquireToken, this.logger, this.performanceClient, correlationId)(request, cacheLookupPolicy);
    }
    /**
     * Returns boolean indicating if this request can use the platform broker
     * @param request
     */ canUsePlatformBroker(request, accountId) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("1n9lbl", correlationId);
        const platformAuthAllowed = $9797579afd7d961c$var$isPlatformAuthAllowed(this.config, this.logger, correlationId, this.platformAuthProvider, request.authenticationScheme, this.performanceClient);
        if (!platformAuthAllowed) {
            this.logger.trace("0yoy1g", correlationId);
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case $9797579afd7d961c$var$PromptValue$1.NONE:
            case $9797579afd7d961c$var$PromptValue$1.CONSENT:
            case $9797579afd7d961c$var$PromptValue$1.LOGIN:
                this.logger.trace("0vdv8e", correlationId);
                break;
            default:
                this.logger.trace(`0pdzw6 ${request.prompt}`, correlationId);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("16lbtk", correlationId);
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || (!request.loginHint && !request.sid ? this.getActiveAccount() : null);
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new $9797579afd7d961c$var$PopupClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForPopupResponse, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new $9797579afd7d961c$var$RedirectClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new $9797579afd7d961c$var$SilentIframeClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9797579afd7d961c$var$ApiId.ssoSilent, this.performanceClient, this.nativeInternalStorage, correlationId, this.platformAuthProvider, this.operatingContext.getResponseHandlers()?.waitForIframeResponse, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new $9797579afd7d961c$var$SilentCacheClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new $9797579afd7d961c$var$SilentRefreshClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new $9797579afd7d961c$var$SilentAuthCodeClient(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, $9797579afd7d961c$var$ApiId.acquireTokenByCode, this.performanceClient, correlationId, this.platformAuthProvider, this.tokenBindingKeyManager);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        $9797579afd7d961c$var$blockNonBrowserEnvironment();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return $9797579afd7d961c$var$createNewGuid();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return "";
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0lz9hf", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || $9797579afd7d961c$var$DEFAULT_REQUEST
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("0qw7v5", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || $9797579afd7d961c$var$DEFAULT_REQUEST
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId,
            ssoCapable: this.getCachedSsoCapable()
        });
        $9797579afd7d961c$var$preflightCheck(this.initialized, atsMeasurement, this.config, request);
        this.logger.verbose("0x1c4s", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$noAccountError, correlationId);
        return this.acquireTokenSilentDeduped(request, account, correlationId).then((result)=>{
            atsMeasurement.end({
                success: true,
                isNativeBroker: result.fromPlatformBroker ?? false,
                fromCache: result.fromCache,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            }, undefined, result.account);
            return {
                ...result,
                state: request.state,
                correlationId: correlationId
            };
        }).catch((error)=>{
            if (error instanceof $9797579afd7d961c$var$AuthError) // Ensures PWB scenarios can correctly match request to response
            error.correlationId = correlationId;
            atsMeasurement.end({
                success: false
            }, error, account);
            throw error;
        });
    }
    /**
     * Checks if identical request is already in flight and returns reference to the existing promise or fires off a new one if this is the first
     * @param request
     * @param account
     * @param correlationId
     * @returns
     */ async acquireTokenSilentDeduped(request, account, correlationId) {
        const preparedRequest = $9797579afd7d961c$var$resolveSilentRequestPreparation({
            request: request,
            account: account,
            correlationId: correlationId,
            config: this.config
        }, this.platformAuthProvider, this.logger, this.performanceClient);
        const inProgressRequest = this.activeSilentTokenRequests.get(preparedRequest.key);
        if (typeof inProgressRequest === "undefined") {
            this.logger.verbose("0fcjbk", correlationId);
            this.performanceClient.addFields({
                deduped: false
            }, correlationId);
            const activeRequest = $9797579afd7d961c$var$invokeAsync(this.acquireTokenSilentAsync.bind(this), $9797579afd7d961c$var$AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...preparedRequest.request,
                correlationId: correlationId
            }, preparedRequest.account);
            this.activeSilentTokenRequests.set(preparedRequest.key, activeRequest);
            return activeRequest.finally(()=>{
                this.activeSilentTokenRequests.delete(preparedRequest.key);
            });
        } else {
            this.logger.verbose("1yq7nb", correlationId);
            this.performanceClient.addFields({
                deduped: true
            }, correlationId);
            return inProgressRequest;
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackStateChange = (event)=>this.trackStateChange(request.correlationId, event);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, request.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0,
            onlineStatusChangeCount: 0
        }, request.correlationId);
        this.addStateChangeListeners(trackStateChange);
        const silentRequest = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$initializeSilentRequest, $9797579afd7d961c$var$InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || $9797579afd7d961c$var$CacheLookupPolicy.Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $9797579afd7d961c$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                const silentRefreshReason = `${refreshTokenError.errorCode}${refreshTokenError.subError ? `|${refreshTokenError.subError}` : ""}`;
                this.performanceClient.addFields({
                    silentRefreshReason: silentRefreshReason
                }, request.correlationId);
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("0rh08z", silentRequest.correlationId);
                    return $9797579afd7d961c$var$invokeAsync(this.acquireTokenBySilentIframe.bind(this), $9797579afd7d961c$var$AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== $9797579afd7d961c$var$CacheLookupPolicy.Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`1w8fso ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement($9797579afd7d961c$var$AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`0ywzzi ${activeCorrelationId}`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`17y14q ${activeCorrelationId}`, silentRequest.correlationId);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("1bd4p8", silentRequest.correlationId);
                    return $9797579afd7d961c$var$invokeAsync(this.acquireTokenBySilentIframe.bind(this), $9797579afd7d961c$var$AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, request.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromPlatformBroker ?? false
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, request.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            this.removeStateChangeListeners(trackStateChange);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        // if the cache policy is set to access_token only, we should not be hitting the native layer yet
        if ($9797579afd7d961c$var$isPlatformAuthAllowed(this.config, this.logger, silentRequest.correlationId, this.platformAuthProvider, silentRequest.authenticationScheme, this.performanceClient) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("0sczo4", silentRequest.correlationId);
            this.performanceClient.addFields({
                isPlatformBrokerRequest: true
            }, silentRequest.correlationId);
            return this.acquireTokenNative(silentRequest, $9797579afd7d961c$var$ApiId.acquireTokenSilent_silentFlow, silentRequest.account.nativeAccountId, cacheLookupPolicy).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof $9797579afd7d961c$var$NativeAuthError && $9797579afd7d961c$var$isFatalNativeAuthError(e)) {
                    this.logger.verbose("07rkmb", silentRequest.correlationId);
                    this.platformAuthProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$tokenRefreshRequired, silentRequest.correlationId);
                }
                throw e;
            });
        } else {
            this.logger.verbose("0ox81t", silentRequest.correlationId);
            // add logs to identify embedded cache retrieval
            if (cacheLookupPolicy === $9797579afd7d961c$var$CacheLookupPolicy.AccessToken) this.logger.verbose("0fvwxe", silentRequest.correlationId);
            return $9797579afd7d961c$var$invokeAsync(this.acquireTokenFromCache.bind(this), $9797579afd7d961c$var$AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === $9797579afd7d961c$var$CacheLookupPolicy.AccessToken) throw cacheError;
                this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_NETWORK_START, silentRequest.correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, silentRequest);
                return $9797579afd7d961c$var$invokeAsync(this.acquireTokenByRefreshToken.bind(this), $9797579afd7d961c$var$AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
    /**
     * Pre-generates PKCE codes and stores it in local variable
     * @param correlationId
     */ async preGeneratePkceCodes(correlationId) {
        this.logger.verbose("1x6uj6", correlationId);
        this.pkceCode = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$generatePkceCodes, $9797579afd7d961c$var$GeneratePkceCodes, this.logger, this.performanceClient, correlationId)(this.performanceClient, this.logger, correlationId);
        return Promise.resolve();
    }
    /**
     * Provides pre-generated PKCE codes, if any
     * @param correlationId
     */ getPreGeneratedPkceCodes(correlationId) {
        const res = this.pkceCode ? {
            ...this.pkceCode
        } : undefined;
        this.pkceCode = undefined;
        if (res) this.logger.verbose("12js1o", correlationId);
        else this.logger.verbose("1oe9ci", correlationId);
        this.performanceClient.addFields({
            usePreGeneratedPkce: !!res
        }, correlationId);
        return res;
    }
    logMultipleInstances(performanceEvent, correlationId) {
        const clientId = this.config.auth.clientId;
        if (!window) return;
        // @ts-ignore
        window.msal = window.msal || {};
        // @ts-ignore
        window.msal.clientIds = window.msal.clientIds || [];
        // @ts-ignore
        const clientIds = window.msal.clientIds;
        if (clientIds.length > 0) this.logger.verbose("1qtz3l", correlationId);
        // @ts-ignore
        window.msal.clientIds.push(clientId);
        $9797579afd7d961c$var$collectInstanceStats(clientId, performanceEvent, this.logger, correlationId);
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $9797579afd7d961c$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof $9797579afd7d961c$var$InteractionRequiredAuthError && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== $9797579afd7d961c$var$badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === $9797579afd7d961c$var$BrowserConstants.INVALID_GRANT_ERROR || refreshTokenError.errorCode === $9797579afd7d961c$var$tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === $9797579afd7d961c$var$noTokensFound || refreshTokenError.errorCode === $9797579afd7d961c$var$refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = $9797579afd7d961c$var$iFrameRenewalPolicies.includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $9797579afd7d961c$var$BaseOperatingContext {
    static loggerCallback(level, message) {
        switch(level){
            case $9797579afd7d961c$export$243e62d78d3b544d.Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case $9797579afd7d961c$export$243e62d78d3b544d.Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case $9797579afd7d961c$export$243e62d78d3b544d.Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case $9797579afd7d961c$export$243e62d78d3b544d.Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config, responseHandlers){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = $9797579afd7d961c$var$buildConfiguration(config, this.browserEnvironment);
        this.responseHandlers = responseHandlers;
        let sessionStorage;
        try {
            sessionStorage = window[$9797579afd7d961c$var$BrowserCacheLocation.SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem($9797579afd7d961c$var$LOG_LEVEL_CACHE_KEY);
        const piiLoggingKey = sessionStorage?.getItem($9797579afd7d961c$var$LOG_PII_CACHE_KEY)?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys($9797579afd7d961c$export$243e62d78d3b544d).includes(logLevelKey) ? $9797579afd7d961c$export$243e62d78d3b544d[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $9797579afd7d961c$var$BaseOperatingContext.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new $9797579afd7d961c$var$Logger(loggerOptions, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the internal response handlers supplied by PublicClientApplication, if any.
     * @returns AuthResponseHandlers | undefined
     */ getResponseHandlers() {
        return this.responseHandlers;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$StandardOperatingContext extends $9797579afd7d961c$var$BaseOperatingContext {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $9797579afd7d961c$var$StandardOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $9797579afd7d961c$var$StandardOperatingContext.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async initialize(correlationId) {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $9797579afd7d961c$var$StandardOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $9797579afd7d961c$var$StandardOperatingContext.ID = "StandardOperatingContext";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $9797579afd7d961c$var$isBridgeError(error) {
    return error.status !== undefined;
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$BridgeStatusCode = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Unified error taxonomy shared by NAA and PWB.
 *
 * Each code maps to exactly one of the four base MSAL error classes
 * (`AuthError`, `ClientAuthError`, `ServerError`,
 * `InteractionRequiredAuthError`) via `toAuthError` in
 * `./WebBrokerBridgeErrorMap`.
 */ const $9797579afd7d961c$var$WebBrokerBridgeErrorCode = {
    /* Interaction / auth outcomes */ UserInteractionRequired: "user_interaction_required",
    UserCanceled: "user_canceled",
    /* Environment / connectivity */ NoNetwork: "no_network",
    AccountUnavailable: "account_unavailable",
    BridgeDisabled: "bridge_disabled",
    BridgeUnavailable: "bridge_unavailable",
    /* Server-side outcomes */ TransientError: "transient_error",
    PersistentError: "persistent_error",
    /* Broker-channel failures */ BridgeTimeout: "bridge_timeout",
    BridgeHandshakeFailed: "bridge_handshake_failed",
    BridgeConnectionReset: "bridge_connection_reset",
    BridgeResponseInvalid: "bridge_response_invalid",
    PopupWillRedirect: "popup_will_redirect",
    ShrGenerationError: "shr_generation_error",
    /* Fallback */ Unknown: "unknown"
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Lift a normalized `WebBrokerBridgeError` to one of the four base
 * MSAL error classes. Callers are responsible for lowering
 * transport-specific errors into `WebBrokerBridgeError` before calling
 * this function.
 */ function $9797579afd7d961c$var$toAuthError(err) {
    const correlationId = err.correlationId ?? "";
    switch(err.code){
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.UserInteractionRequired:
            return new $9797579afd7d961c$var$InteractionRequiredAuthError(err.innerErrorCode || "", correlationId, err.description, err.subError);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.TransientError:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.PersistentError:
            return new $9797579afd7d961c$var$ServerError(err.innerErrorCode || "", correlationId, err.description, err.subError);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.UserCanceled:
            return new $9797579afd7d961c$var$ClientAuthError($9797579afd7d961c$var$userCanceled, correlationId);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.NoNetwork:
            return new $9797579afd7d961c$var$ClientAuthError($9797579afd7d961c$var$noNetworkConnectivity$1, correlationId);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.AccountUnavailable:
            return new $9797579afd7d961c$var$ClientAuthError($9797579afd7d961c$var$noAccountFound, correlationId);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeDisabled:
            return new $9797579afd7d961c$var$ClientAuthError($9797579afd7d961c$var$nestedAppAuthBridgeDisabled, correlationId);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeUnavailable:
            /*
             * NAA parity: pass through inner code when the broker supplied
             * one, otherwise fall back to the disabled code.
             */ return new $9797579afd7d961c$var$ClientAuthError(err.innerErrorCode || $9797579afd7d961c$var$nestedAppAuthBridgeDisabled, correlationId, err.description);
        /*
         * PWB broker-channel failures. The common code doubles as the
         * concrete errorCode on AuthError so the original error identity
         * can be recovered by round-tripping the string.
         */ case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeTimeout:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeHandshakeFailed:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeConnectionReset:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeResponseInvalid:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.PopupWillRedirect:
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.ShrGenerationError:
            return new $9797579afd7d961c$var$AuthError(err.code, correlationId, err.description, err.subError);
        case $9797579afd7d961c$var$WebBrokerBridgeErrorCode.Unknown:
        default:
            return new $9797579afd7d961c$var$AuthError(err.innerErrorCode || "unknown_error", correlationId, err.description || "An unknown error occurred", err.subError);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$NestedAppAuthAdapter {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const claims = $9797579afd7d961c$var$buildMergedClaims$1(request.claims, this.clientCapabilities);
        const scopes = request.scopes || $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1;
        const attributeTokens = $9797579afd7d961c$var$serializeAttributeTokens(request.attributeTokens);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            resource: request.resource,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !$9797579afd7d961c$var$StringUtils.isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
            extraParameters: extraParams,
            attributeTokens: attributeTokens
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$nullOrEmptyToken, request.correlationId);
        // Request timestamp and AuthResult expires_in are in seconds, converting to Date for AuthenticationResult
        const expiresOn = $9797579afd7d961c$var$toDateFromSeconds(reqTimestamp + (response.token.expires_in || 0));
        const idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(response.token.id_token, this.crypto.base64Decode, request.correlationId);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        /*
         * In B2C scenarios tid may not be present, use getTenantIdFromIdTokenClaims
         * which handles tid, tfp (modern B2C), and acr (legacy B2C) claims
         */ const tenantId = fromAccount.tenantId || $9797579afd7d961c$var$getTenantIdFromIdTokenClaims(effectiveIdTokenClaims) || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        // Validate environment - required field
        const environment = fromAccount.environment;
        if (!environment) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$invalidCacheEnvironment, "");
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = effectiveIdTokenClaims?.preferred_username || effectiveIdTokenClaims?.upn;
        const email = effectiveIdTokenClaims?.emails?.[0] || null;
        const username = fromAccount.username || preferredUsername || email || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name || "";
        const loginHint = fromAccount.loginHint || effectiveIdTokenClaims?.login_hint;
        const tenantProfiles = new Map();
        const tenantProfile = $9797579afd7d961c$var$buildTenantProfile(homeAccountId, localAccountId, tenantId, fromAccount.platformBrokerId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            loginHint: loginHint,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            nativeAccountId: fromAccount.platformBrokerId,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ($9797579afd7d961c$var$isBridgeError(error)) return $9797579afd7d961c$var$toAuthError($9797579afd7d961c$var$bridgeErrorToWebBrokerBridgeError(error));
        return new $9797579afd7d961c$var$AuthError("unknown_error", "", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw $9797579afd7d961c$var$createClientAuthError($9797579afd7d961c$var$nullOrEmptyToken, correlationId);
        const idTokenClaims = $9797579afd7d961c$var$extractTokenClaims(idToken.secret, this.crypto.base64Decode, correlationId);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: $9797579afd7d961c$var$toDateFromSeconds(accessToken.expiresOn),
            extExpiresOn: $9797579afd7d961c$var$toDateFromSeconds(accessToken.extendedExpiresOn),
            tokenType: request.authenticationScheme || $9797579afd7d961c$var$AuthenticationScheme$1.BEARER,
            correlationId: correlationId,
            state: request.state
        };
        return authenticationResult;
    }
}
/**
 * Converts NAA `BridgeError` into the shared `WebBrokerBridgeError`
 * taxonomy.
 */ function $9797579afd7d961c$var$bridgeErrorToWebBrokerBridgeError(error) {
    switch(error.status){
        case $9797579afd7d961c$var$BridgeStatusCode.UserCancel:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.UserCanceled
            };
        case $9797579afd7d961c$var$BridgeStatusCode.NoNetwork:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.NoNetwork
            };
        case $9797579afd7d961c$var$BridgeStatusCode.AccountUnavailable:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.AccountUnavailable
            };
        case $9797579afd7d961c$var$BridgeStatusCode.Disabled:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeDisabled
            };
        case $9797579afd7d961c$var$BridgeStatusCode.NestedAppAuthUnavailable:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.BridgeUnavailable,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9797579afd7d961c$var$BridgeStatusCode.TransientError:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.TransientError,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9797579afd7d961c$var$BridgeStatusCode.PersistentError:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.PersistentError,
                innerErrorCode: error.code,
                description: error.description
            };
        case $9797579afd7d961c$var$BridgeStatusCode.UserInteractionRequired:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.UserInteractionRequired,
                innerErrorCode: error.code,
                description: error.description
            };
        default:
            return {
                code: $9797579afd7d961c$var$WebBrokerBridgeErrorCode.Unknown,
                innerErrorCode: error.code,
                description: error.description
            };
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$NestedAppAuthError extends $9797579afd7d961c$var$AuthError {
    constructor(errorCode, correlationId, errorMessage){
        super(errorCode, correlationId, errorMessage);
        Object.setPrototypeOf(this, $9797579afd7d961c$var$NestedAppAuthError.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError(correlationId) {
        /*
         * Some controller stubs (perf callbacks, getPerformanceClient, getRedirectResponse)
         * have no request param and thus no correlationId to forward
         */ return new $9797579afd7d961c$var$NestedAppAuthError($9797579afd7d961c$var$unsupportedMethod, correlationId || "");
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$NestedAppAuthController {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new $9797579afd7d961c$var$CryptoOps(this.logger, this.performanceClient, true) : $9797579afd7d961c$var$DEFAULT_CRYPTO_IMPLEMENTATION;
        const tokenBindingKeyManager = operatingContext.isBrowserEnvironment() ? new $9797579afd7d961c$var$TokenBindingKeyManager(this.logger, this.performanceClient) : $9797579afd7d961c$var$DEFAULT_TOKEN_BINDING_KEY_MANAGER;
        this.eventHandler = new $9797579afd7d961c$var$EventHandler(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new $9797579afd7d961c$var$BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, this.performanceClient, this.eventHandler, $9797579afd7d961c$var$buildStaticAuthorityOptions(this.config.auth), tokenBindingKeyManager) : $9797579afd7d961c$var$DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger, this.performanceClient, this.eventHandler, undefined, tokenBindingKeyManager);
        this.nestedAppAuthAdapter = new $9797579afd7d961c$var$NestedAppAuthAdapter(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        this.currentAccountContext = accountContext ? accountContext : null;
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $9797579afd7d961c$var$NestedAppAuthController(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ async initialize(request, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isBroker) {
        const initCorrelationId = request?.correlationId || $9797579afd7d961c$var$createNewGuid();
        await this.browserStorage.initialize(initCorrelationId);
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || $9797579afd7d961c$var$createNewGuid();
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            nestedAppAuthRequest: true,
            bridgeType: "NAA"
        });
        try {
            $9797579afd7d961c$var$enforceResourceParameter(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof $9797579afd7d961c$var$AuthError ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        const correlationId = validRequest.correlationId || $9797579afd7d961c$var$createNewGuid();
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$SsoSilent, correlationId);
        ssoSilentMeasurement.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement.add({
            nestedAppAuthRequest: true,
            bridgeType: "NAA"
        });
        try {
            $9797579afd7d961c$var$enforceResourceParameter(this.config.auth.isMcp, validRequest);
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            naaRequest.forceRefresh = validRequest.forceRefresh;
            const reqTimestamp = $9797579afd7d961c$var$nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            try {
                // cache hydration can fail in JS Runtime scenario that doesn't support full crypto API
                await this.hydrateCache(result, request);
            } catch (error) {
                this.logger.warningPii(`1mwr91 ${error}`, correlationId);
            }
            // cache the account context in memory after successful token fetch
            this.currentAccountContext = {
                homeAccountId: result.account.homeAccountId,
                environment: result.account.environment,
                tenantId: result.account.tenantId
            };
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            }, undefined, result.account);
            return result;
        } catch (e) {
            const error = e instanceof $9797579afd7d961c$var$AuthError ? e : this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e, request.account);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const correlationId = request.correlationId || $9797579afd7d961c$var$createNewGuid();
        const atsMeasurement = this.performanceClient.startMeasurement($9797579afd7d961c$var$AcquireTokenSilent, correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true,
            bridgeType: "NAA"
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("11t57w", correlationId);
            return null;
        }
        // if the request has forceRefresh, we cannot look up in the cache
        if (request.forceRefresh) {
            this.logger.verbose("1ovnmo", correlationId);
            return null;
        }
        // respect cache lookup policy
        let result = null;
        if (!request.cacheLookupPolicy) request.cacheLookupPolicy = $9797579afd7d961c$var$CacheLookupPolicy.Default;
        switch(request.cacheLookupPolicy){
            case $9797579afd7d961c$var$CacheLookupPolicy.Default:
            case $9797579afd7d961c$var$CacheLookupPolicy.AccessToken:
            case $9797579afd7d961c$var$CacheLookupPolicy.AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, result);
            atsMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atsMeasurement.end({
                success: true
            }, undefined, result.account);
            return result;
        }
        this.logger.warning("1yb4fi", correlationId);
        this.eventHandler.emitEvent($9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE, correlationId, $9797579afd7d961c$export$4ec29255e7e7f68f.Silent, null);
        atsMeasurement.end({
            success: false
        }, undefined, request.account);
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        // always prioritize the account context from the bridge
        const accountContext = this.bridgeProxy.getAccountContext() || this.currentAccountContext;
        const correlationId = request.correlationId || $9797579afd7d961c$var$createNewGuid();
        let currentAccount = null;
        if (accountContext) currentAccount = $9797579afd7d961c$var$getAccount(accountContext, this.logger, this.browserStorage, correlationId);
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("10qnr0", correlationId);
            return Promise.resolve(null);
        }
        this.logger.verbose("1u7hux", correlationId);
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...$9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("03vm49", correlationId);
            return Promise.resolve(null);
        } else if ($9797579afd7d961c$var$wasClockTurnedBack(cachedAccessToken.cachedAt) || $9797579afd7d961c$var$isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("18egye", correlationId);
            return Promise.resolve(null);
        } else if (authRequest.resource) {
            const requestedResource = authRequest.resource;
            const cachedResource = cachedAccessToken.resource;
            if (!cachedResource || cachedResource !== requestedResource) {
                this.logger.verbose("0qraxd", correlationId);
                return Promise.resolve(null);
            }
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId);
        if (!cachedIdToken) {
            this.logger.verbose("0d68kd", correlationId);
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ acquireTokenRedirect(request) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ acquireTokenByCode(request) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        // No request context: callback registration is not per-request
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        // No request context: callback registration is not per-request
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return $9797579afd7d961c$var$getAllAccounts(this.logger, this.browserStorage, this.isBrowserEnv(), $9797579afd7d961c$var$createNewGuid(), accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return $9797579afd7d961c$var$getAccount(accountFilter, this.logger, this.browserStorage, $9797579afd7d961c$var$createNewGuid());
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ return $9797579afd7d961c$var$setActiveAccount(account, this.browserStorage, $9797579afd7d961c$var$createNewGuid());
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return $9797579afd7d961c$var$getActiveAccount(this.browserStorage, $9797579afd7d961c$var$createNewGuid());
    }
    // #endregion
    handleRedirectPromise(options // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || $9797579afd7d961c$var$DEFAULT_REQUEST);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(request?.correlationId);
    }
    logoutRedirect(logoutRequest) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    logoutPopup(logoutRequest) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("1k8729", "");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        // Accessor stub with no request context
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError();
    }
    getRedirectResponse() {
        // Accessor stub with no request context
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw $9797579afd7d961c$var$NestedAppAuthError.createUnsupportedError(logoutRequest?.correlationId);
    }
    async hydrateCache(result, request) {
        this.logger.verbose("16jycr", result.correlationId);
        const accountEntity = $9797579afd7d961c$var$createAccountEntityFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        await this.browserStorage.setAccount(accountEntity, result.correlationId, $9797579afd7d961c$var$isKmsi(result.idTokenClaims), $9797579afd7d961c$var$ApiId.hydrateCache);
        return this.browserStorage.hydrateCache(result, request);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Correlates outbound requests with inbound responses by `requestId`.
 */ class $9797579afd7d961c$var$PendingRequestRegistry {
    constructor(){
        this.pending = new Map();
    }
    /**
     * Register a pending request. Returns a promise that resolves when a
     * response with the matching `requestId` arrives, or rejects if the
     * caller invokes `reject` for that id.
     */ register(requestId) {
        return new Promise((resolve, reject)=>{
            this.pending.set(requestId, {
                resolve: resolve,
                reject: reject
            });
        });
    }
    /** Resolve a pending request. No-op if `requestId` isn't registered. */ resolve(requestId, response) {
        const entry = this.pending.get(requestId);
        if (entry === undefined) return;
        this.pending.delete(requestId);
        entry.resolve(response);
    }
    /** Reject a pending request. No-op if `requestId` isn't registered. */ reject(requestId, reason) {
        const entry = this.pending.get(requestId);
        if (entry === undefined) return;
        this.pending.delete(requestId);
        entry.reject(reason);
    }
    /** True if `requestId` has an in-flight registration. */ has(requestId) {
        return this.pending.has(requestId);
    }
    /**
     * Register, then invoke `send` synchronously. If `send` throws, the
     * pending entry is cleared and the promise rejects with the thrown
     * error.
     */ async sendAndAwait(message, send) {
        const promise = this.register(message.requestId);
        try {
            send(message);
        } catch (err) {
            this.reject(message.requestId, err);
        }
        return promise;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $9797579afd7d961c$var$BridgeProxy {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                if (responseEnvelope.success) $9797579afd7d961c$var$BridgeProxy.pendingRegistry.resolve(responseEnvelope.requestId, responseEnvelope);
                else $9797579afd7d961c$var$BridgeProxy.pendingRegistry.reject(responseEnvelope.requestId, responseEnvelope.error);
            });
            const bridgeResponse = await $9797579afd7d961c$var$BridgeProxy.sendRequestViaRegistry($9797579afd7d961c$var$BridgeProxy.buildRequest("GetInitContext"));
            return $9797579afd7d961c$var$BridgeProxy.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $9797579afd7d961c$var$BridgeProxy.validateBridgeResultOrThrow(result.token),
            account: $9797579afd7d961c$var$BridgeProxy.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: $9797579afd7d961c$var$createNewGuid(),
            sendTime: Date.now(),
            clientLibrary: $9797579afd7d961c$var$BrowserConstants.MSAL_SKU,
            clientLibraryVersion: $9797579afd7d961c$var$version,
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        return $9797579afd7d961c$var$BridgeProxy.sendRequestViaRegistry($9797579afd7d961c$var$BridgeProxy.buildRequest(method, requestParams));
    }
    /**
     * Registers `message.requestId` with the shared pending-request
     * registry, then posts the envelope over the host bridge. Resolves
     * with the matching response envelope; rejects with the raw
     * `BridgeError` payload.
     */ static sendRequestViaRegistry(message) {
        const correlationKey = {
            requestId: message.requestId,
            type: message.method
        };
        return $9797579afd7d961c$var$BridgeProxy.pendingRegistry.sendAndAwait(correlationKey, ()=>{
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: $9797579afd7d961c$var$BridgeStatusCode.NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $9797579afd7d961c$var$BridgeProxy.initializeNestedAppAuthBridge();
        return new $9797579afd7d961c$var$BridgeProxy(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
/**
 * Correlates outbound bridge requests with inbound responses by
 * `requestId`
 */ $9797579afd7d961c$var$BridgeProxy.pendingRegistry = new $9797579afd7d961c$var$PendingRequestRegistry();
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$NestedAppOperatingContext extends $9797579afd7d961c$var$BaseOperatingContext {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $9797579afd7d961c$var$NestedAppOperatingContext.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $9797579afd7d961c$var$NestedAppOperatingContext.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @param correlationId
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize(correlationId) {
        const cid = correlationId || "";
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await $9797579afd7d961c$var$BridgeProxy.create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`1mdxyj ${ex}`, cid);
        }
        this.logger.info(`12jy9a ${this.available}`, cid);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $9797579afd7d961c$var$NestedAppOperatingContext.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $9797579afd7d961c$var$NestedAppOperatingContext.ID = "NestedAppOperatingContext";
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$IFRAME_POLL_INTERVAL_MS = 50;
const $9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS = 10000;
/**
 * Monitors an iframe content window until it loads a URL with a known hash, or hits a specified timeout.
 *
 * @param iframe - The hidden iframe to monitor.
 * @param timeout - Maximum time (ms) to wait for navigation before rejecting with
 *   `monitor_window_timeout`.
 * @param logger - Logger instance.
 * @param correlationId
 * @param responseMode - `"query"` or `"fragment"` — determines whether to read
 *   `location.search` or `location.hash`. Any value other than `"query"` is
 *   treated as fragment.
 */ async function $9797579afd7d961c$var$monitorIframeForHash(iframe, timeout, logger, correlationId, responseMode) {
    return new Promise((resolve, reject)=>{
        if (timeout < $9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS) logger.warning(`137tec ${timeout} ${$9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS}`, correlationId);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject(new $9797579afd7d961c$var$AuthError($9797579afd7d961c$var$timedOut, correlationId, undefined, "monitor_window_timeout"));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            const contentWindow = iframe.contentWindow;
            if (!contentWindow) return;
            let href = "";
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow.location.href;
            } catch (e) {}
            if (!href || href === "about:blank") return;
            const responseString = responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY ? contentWindow.location.search : contentWindow.location.hash;
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, $9797579afd7d961c$var$IFRAME_POLL_INTERVAL_MS);
    }).finally(()=>{
        /*
         * Strip auth-response params from the iframe URL. The monitor owns the
         * iframe for the duration of the poll, mirroring cleanPopup in
         * PopupMonitor.
         */ try {
            if (iframe.contentWindow) $9797579afd7d961c$var$clearAuthResponseFromUrl(iframe.contentWindow);
        } catch  {
        // Iframe may already be navigated away or cross-origin; ignore.
        }
    });
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $9797579afd7d961c$var$PublicClientApplication {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new $9797579afd7d961c$var$StandardController(new $9797579afd7d961c$var$StandardOperatingContext(configuration, {
            waitForPopupResponse: this.waitForPopupResponse.bind(this),
            waitForIframeResponse: this.waitForIframeResponse.bind(this)
        }));
    }
    /**
     * Waits for the auth response from a popup window opened by MSAL.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge,
     * or to the v4-style same-origin location poller when
     * `system.enableLegacyPolling` is set. Subclasses must return the raw response
     * string (hash/query/fragment), or reject with an `AuthError` on failure.
     *
     * @internal
     * @param request The in-flight authorization or end-session request.
     * @param popupWindow The popup window opened by MSAL.
     * @param popupWindowParent The parent window that opened the popup.
     */ async waitForPopupResponse(request, popupWindow, popupWindowParent) {
        const controller = this.controller;
        const config = controller.getConfiguration();
        if (config.system.enableLegacyPolling) return $9797579afd7d961c$var$waitForPopupPollingResponse(config, controller.getLogger(), controller.getPerformanceClient(), request, popupWindow, popupWindowParent);
        return $9797579afd7d961c$var$waitForBridgeResponse(config.system.popupBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient());
    }
    /**
     * Waits for the auth response from a hidden iframe used by MSAL silent flows.
     *
     * The default implementation delegates to MSAL's `BroadcastChannel`-based bridge,
     * or to the v4-style location poller when `system.enableLegacyPolling` is set.
     * Subclasses must return the raw response string (hash/query/fragment), or reject
     * with an `AuthError` on failure.
     *
     * @internal
     * @param iframe The hidden iframe MSAL attached to the document.
     * @param request The in-flight authorization request.
     */ async waitForIframeResponse(iframe, request) {
        const controller = this.controller;
        const config = controller.getConfiguration();
        if (config.system.enableLegacyPolling) return $9797579afd7d961c$var$waitForIframePollingResponse(config, controller.getLogger(), controller.getPerformanceClient(), iframe, request);
        return $9797579afd7d961c$var$waitForBridgeResponse(config.system.iframeBridgeTimeout, controller.getLogger(), request, controller.getPerformanceClient(), config.experimental);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @param options Object containing optional configuration for redirect promise handling.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(options) {
        return this.controller.handleRedirectPromise(options);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @param correlationId
 * @param pcaFactory
 * @returns IPublicClientApplication
 *
 */ async function $9797579afd7d961c$var$createNestablePublicClientApplication(configuration, correlationId, pcaFactory) {
    const nestedAppAuth = new $9797579afd7d961c$var$NestedAppOperatingContext(configuration);
    await nestedAppAuth.initialize(correlationId);
    if (nestedAppAuth.isAvailable()) {
        const cid = correlationId || $9797579afd7d961c$var$createNewGuid();
        const controller = new $9797579afd7d961c$var$NestedAppAuthController(nestedAppAuth);
        const nestablePCA = pcaFactory ? pcaFactory(configuration, controller) : new $9797579afd7d961c$var$PublicClientApplication(configuration, controller);
        await nestablePCA.initialize({
            correlationId: cid
        });
        return nestablePCA;
    }
    return $9797579afd7d961c$var$createStandardPublicClientApplication(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $9797579afd7d961c$var$createStandardPublicClientApplication(configuration) {
    const pca = new $9797579afd7d961c$var$PublicClientApplication(configuration);
    await pca.initialize();
    return pca;
}
/**
 * Collects a popup auth response using the v4-style same-origin location
 * poller instead of the `BroadcastChannel` redirect bridge.
 */ async function $9797579afd7d961c$var$waitForPopupPollingResponse(config, logger, performanceClient, request, popupWindow, popupWindowParent) {
    const responseMode = config.auth.OIDCOptions?.responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY ? $9797579afd7d961c$var$ResponseMode$1.QUERY : $9797579afd7d961c$var$ResponseMode$1.FRAGMENT;
    performanceClient.addFields({
        usesLegacyPolling: true
    }, request.correlationId);
    const unloadHandler = ()=>{
        try {
            if (popupWindow && !popupWindow.closed) popupWindow.close();
        } catch  {
        /* ignore */ }
    };
    popupWindowParent.addEventListener("beforeunload", unloadHandler);
    return $9797579afd7d961c$var$monitorPopupForHash(popupWindow, popupWindowParent, responseMode, logger, unloadHandler, request.correlationId);
}
/**
 * Collects a silent-iframe auth response using the v4-style location poller
 * instead of the `BroadcastChannel` redirect bridge.
 */ async function $9797579afd7d961c$var$waitForIframePollingResponse(config, logger, performanceClient, iframe, request) {
    const responseMode = config.auth.OIDCOptions?.responseMode === $9797579afd7d961c$var$ResponseMode$1.QUERY ? $9797579afd7d961c$var$ResponseMode$1.QUERY : $9797579afd7d961c$var$ResponseMode$1.FRAGMENT;
    const iframePollTimeout = config.system.iframeBridgeTimeout;
    performanceClient.addFields({
        usesLegacyPolling: true,
        iframePollTimeout: iframePollTimeout
    }, request.correlationId);
    return $9797579afd7d961c$var$monitorIframeForHash(iframe, iframePollTimeout, logger, request.correlationId, responseMode);
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9797579afd7d961c$var$stubbedPublicClientApplication = {
    initialize: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    loginPopup: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    loginRedirect: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    logoutRedirect: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    logoutPopup: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    ssoSilent: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    getLogger: ()=>{
        throw $9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, "");
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw $9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, "");
    },
    hydrateCache: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    },
    clearCache: ()=>{
        return Promise.reject($9797579afd7d961c$var$createBrowserConfigurationAuthError($9797579afd7d961c$var$stubbedPublicClientApplicationCalled, ""));
    }
};
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * API to load tokens to msal-browser cache.
 * @param config - Object to configure the MSAL app.
 * @param request - Silent request containing authority, scopes, and account.
 * @param response - External token response to load into the cache.
 * @param options - Options controlling how tokens are loaded into the cache.
 * @param performanceClient - Optional performance client used for telemetry measurements.
 * @returns `AuthenticationResult` for the response that was loaded.
 */ async function $9797579afd7d961c$var$loadExternalTokens(config, request, response, options, performanceClient = new $9797579afd7d961c$var$StubPerformanceClient()) {
    $9797579afd7d961c$var$blockNonBrowserEnvironment();
    const browserConfig = $9797579afd7d961c$var$buildConfiguration(config, true);
    const correlationId = request.correlationId || $9797579afd7d961c$var$createNewGuid();
    const rootMeasurement = performanceClient.startMeasurement($9797579afd7d961c$var$LoadExternalTokens, correlationId);
    try {
        const idTokenClaims = response.id_token ? $9797579afd7d961c$var$extractTokenClaims(response.id_token, $9797579afd7d961c$var$base64Decode, correlationId) : undefined;
        const kmsi = $9797579afd7d961c$var$isKmsi(idTokenClaims || {});
        const authorityOptions = {
            protocolMode: browserConfig.system.protocolMode,
            knownAuthorities: browserConfig.auth.knownAuthorities,
            cloudDiscoveryMetadata: browserConfig.auth.cloudDiscoveryMetadata,
            authorityMetadata: browserConfig.auth.authorityMetadata
        };
        const logger = new $9797579afd7d961c$var$Logger(browserConfig.system.loggerOptions || {}, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        const cryptoOps = new $9797579afd7d961c$var$CryptoOps(logger, browserConfig.telemetry.client);
        const storage = new $9797579afd7d961c$var$BrowserCacheManager(browserConfig.auth.clientId, browserConfig.cache, cryptoOps, logger, browserConfig.telemetry.client, new $9797579afd7d961c$var$EventHandler(logger), $9797579afd7d961c$var$buildStaticAuthorityOptions(browserConfig.auth), new $9797579afd7d961c$var$TokenBindingKeyManager(logger, browserConfig.telemetry.client));
        await storage.initialize(correlationId);
        const authorityString = request.authority || browserConfig.auth.authority;
        const authority = await $9797579afd7d961c$var$createDiscoveredInstance($9797579afd7d961c$var$Authority.generateAuthority(authorityString, request.azureCloudOptions), browserConfig.system.networkClient, storage, authorityOptions, logger, correlationId, performanceClient);
        const cacheRecordAccount = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$loadAccount, $9797579afd7d961c$var$LoadAccount, logger, performanceClient, correlationId)(request, options.clientInfo || response.client_info || "", correlationId, storage, logger, cryptoOps, authority, idTokenClaims, performanceClient);
        const idToken = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$loadIdToken, $9797579afd7d961c$var$LoadIdToken, logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, correlationId, storage, logger, config.auth.clientId);
        const accessToken = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$loadAccessToken, $9797579afd7d961c$var$LoadAccessToken, logger, performanceClient, correlationId)(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, kmsi, options, correlationId, storage, logger, config.auth.clientId);
        const refreshToken = await $9797579afd7d961c$var$invokeAsync($9797579afd7d961c$var$loadRefreshToken, $9797579afd7d961c$var$LoadRefreshToken, logger, performanceClient, correlationId)(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, kmsi, correlationId, storage, logger, config.auth.clientId, performanceClient);
        rootMeasurement.end({
            success: true
        }, undefined, $9797579afd7d961c$var$getAccountInfo(cacheRecordAccount));
        return $9797579afd7d961c$var$generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, authority, idTokenClaims);
    } catch (error) {
        rootMeasurement.end({
            success: false
        }, error);
        throw error;
    }
}
/**
 * Helper function to load account to msal-browser cache
 * @param idToken
 * @param environment
 * @param clientInfo
 * @param authorityType
 * @param requestHomeAccountId
 * @returns `AccountEntity`
 */ async function $9797579afd7d961c$var$loadAccount(request, clientInfo, correlationId, storage, logger, cryptoObj, authority, idTokenClaims, performanceClient) {
    logger.verbose("0ke46k", correlationId);
    if (request.account) {
        const accountEntity = $9797579afd7d961c$var$createAccountEntityFromAccountInfo(request.account);
        await storage.setAccount(accountEntity, correlationId, $9797579afd7d961c$var$isKmsi(idTokenClaims || {}), $9797579afd7d961c$var$ApiId.loadExternalTokens);
        return accountEntity;
    } else if (!clientInfo && !idTokenClaims) {
        logger.error("0hzcn4", correlationId);
        throw $9797579afd7d961c$var$createBrowserAuthError($9797579afd7d961c$var$unableToLoadToken, "");
    }
    const homeAccountId = $9797579afd7d961c$var$generateHomeAccountId(clientInfo, authority.authorityType, logger, cryptoObj, correlationId, idTokenClaims);
    const claimsTenantId = idTokenClaims?.tid;
    const cachedAccount = $9797579afd7d961c$var$buildAccountToCache(storage, authority, homeAccountId, $9797579afd7d961c$var$base64Decode, correlationId, idTokenClaims, clientInfo, authority.getPreferredCache(), claimsTenantId, undefined, undefined, logger, performanceClient);
    await storage.setAccount(cachedAccount, correlationId, $9797579afd7d961c$var$isKmsi(idTokenClaims || {}), $9797579afd7d961c$var$ApiId.loadExternalTokens);
    return cachedAccount;
}
/**
 * Helper function to load id tokens to msal-browser cache
 * @param idToken
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `IdTokenEntity`
 */ async function $9797579afd7d961c$var$loadIdToken(response, homeAccountId, environment, tenantId, kmsi, correlationId, storage, logger, clientId) {
    if (!response.id_token) {
        logger.verbose("1pm7g1", correlationId);
        return null;
    }
    logger.verbose("168lyi", correlationId);
    const idTokenEntity = $9797579afd7d961c$var$createIdTokenEntity(homeAccountId, environment, response.id_token, clientId, tenantId);
    await storage.setIdTokenCredential(idTokenEntity, correlationId, kmsi);
    return idTokenEntity;
}
/**
 * Helper function to load access tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @param tenantId
 * @returns `AccessTokenEntity`
 */ async function $9797579afd7d961c$var$loadAccessToken(request, response, homeAccountId, environment, tenantId, kmsi, options, correlationId, storage, logger, clientId) {
    if (!response.access_token) {
        logger.verbose("1ckp9e", correlationId);
        return null;
    } else if (!response.expires_in) {
        logger.error("15mzx8", correlationId);
        return null;
    } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
        logger.error("1h7xse", correlationId);
        return null;
    }
    logger.verbose("01kmxb", correlationId);
    const scopes = response.scope ? $9797579afd7d961c$var$ScopeSet.fromString(response.scope, correlationId) : new $9797579afd7d961c$var$ScopeSet(request.scopes, correlationId);
    const expiresOn = options.expiresOn || response.expires_in + $9797579afd7d961c$var$nowSeconds();
    const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + $9797579afd7d961c$var$nowSeconds();
    const accessTokenEntity = $9797579afd7d961c$var$createAccessTokenEntity(homeAccountId, environment, response.access_token, clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, $9797579afd7d961c$var$base64Decode, correlationId);
    await storage.setAccessTokenCredential(accessTokenEntity, correlationId, kmsi);
    return accessTokenEntity;
}
/**
 * Helper function to load refresh tokens to msal-browser cache
 * @param request
 * @param response
 * @param homeAccountId
 * @param environment
 * @returns `RefreshTokenEntity`
 */ async function $9797579afd7d961c$var$loadRefreshToken(response, homeAccountId, environment, kmsi, correlationId, storage, logger, clientId, performanceClient) {
    if (!response.refresh_token) {
        logger.verbose("1l7um5", correlationId);
        return null;
    }
    const expiresOn = response.refresh_token_expires_in ? response.refresh_token_expires_in + $9797579afd7d961c$var$nowSeconds() : undefined;
    performanceClient.addFields({
        extRtExpiresOnSeconds: expiresOn
    }, correlationId);
    logger.verbose("0qy8ev", correlationId);
    const refreshTokenEntity = $9797579afd7d961c$var$createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, clientId, response.foci, undefined, expiresOn);
    await storage.setRefreshTokenCredential(refreshTokenEntity, correlationId, kmsi);
    return refreshTokenEntity;
}
/**
 * Helper function to generate an `AuthenticationResult` for the result.
 * @param request
 * @param idTokenObj
 * @param cacheRecord
 * @param authority
 * @returns `AuthenticationResult`
 */ function $9797579afd7d961c$var$generateAuthenticationResult(request, cacheRecord, authority, idTokenClaims) {
    let accessToken = "";
    let responseScopes = [];
    let expiresOn = null;
    let extExpiresOn;
    if (cacheRecord?.accessToken) {
        accessToken = cacheRecord.accessToken.secret;
        responseScopes = $9797579afd7d961c$var$ScopeSet.fromString(cacheRecord.accessToken.target, request.correlationId || "").asArray();
        // Access token expiresOn stored in seconds, converting to Date for AuthenticationResult
        expiresOn = $9797579afd7d961c$var$toDateFromSeconds(cacheRecord.accessToken.expiresOn);
        extExpiresOn = $9797579afd7d961c$var$toDateFromSeconds(cacheRecord.accessToken.extendedExpiresOn);
    }
    const accountEntity = cacheRecord.account;
    return {
        authority: authority.canonicalAuthority,
        uniqueId: cacheRecord.account.localAccountId,
        tenantId: cacheRecord.account.realm,
        scopes: responseScopes,
        account: $9797579afd7d961c$var$getAccountInfo(accountEntity),
        idToken: cacheRecord.idToken?.secret || "",
        idTokenClaims: idTokenClaims || {},
        accessToken: accessToken,
        fromCache: true,
        expiresOn: expiresOn,
        correlationId: request.correlationId || "",
        requestId: "",
        extExpiresOn: extExpiresOn,
        familyId: cacheRecord.refreshToken?.familyId || "",
        tokenType: cacheRecord?.accessToken?.tokenType || "",
        state: request.state || "",
        cloudGraphHostName: accountEntity.cloudGraphHostName || "",
        msGraphHost: accountEntity.msGraphHost || "",
        fromPlatformBroker: false
    };
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$EventMessageUtils {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case $9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_START:
                if (message.interactionType === $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect || message.interactionType === $9797579afd7d961c$export$4ec29255e7e7f68f.Popup) return $9797579afd7d961c$var$InteractionStatus.AcquireToken;
                break;
            case $9797579afd7d961c$var$EventType.HANDLE_REDIRECT_START:
                return $9797579afd7d961c$var$InteractionStatus.HandleRedirect;
            case $9797579afd7d961c$var$EventType.LOGOUT_START:
                return $9797579afd7d961c$var$InteractionStatus.Logout;
            case $9797579afd7d961c$var$EventType.LOGOUT_END:
                if (currentStatus && currentStatus !== $9797579afd7d961c$var$InteractionStatus.Logout) break;
                return $9797579afd7d961c$var$InteractionStatus.None;
            case $9797579afd7d961c$var$EventType.HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== $9797579afd7d961c$var$InteractionStatus.HandleRedirect) break;
                return $9797579afd7d961c$var$InteractionStatus.None;
            case $9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_SUCCESS:
            case $9797579afd7d961c$var$EventType.ACQUIRE_TOKEN_FAILURE:
            case $9797579afd7d961c$var$EventType.RESTORE_FROM_BFCACHE:
                if (message.interactionType === $9797579afd7d961c$export$4ec29255e7e7f68f.Redirect || message.interactionType === $9797579afd7d961c$export$4ec29255e7e7f68f.Popup) {
                    if (currentStatus && currentStatus !== $9797579afd7d961c$var$InteractionStatus.AcquireToken) break;
                    return $9797579afd7d961c$var$InteractionStatus.None;
                }
                break;
        }
        return null;
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$SignedHttpRequest {
    constructor(shrParameters, shrOptions){
        const loggerOptions = shrOptions && shrOptions.loggerOptions || {};
        this.logger = new $9797579afd7d961c$var$Logger(loggerOptions, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version);
        this.cryptoOps = new $9797579afd7d961c$var$CryptoOps(this.logger);
        const tokenBindingKeyManager = new $9797579afd7d961c$var$TokenBindingKeyManager(this.logger);
        this.popTokenGenerator = new $9797579afd7d961c$var$PopTokenGenerator(this.cryptoOps, tokenBindingKeyManager, new $9797579afd7d961c$var$StubPerformanceClient());
        this.shrParameters = shrParameters;
    }
    /**
     * Generates and caches a keypair for the given request options.
     * @returns Public key digest, which should be sent to the token issuer.
     */ async generatePublicKeyThumbprint() {
        const { kid: kid } = await this.popTokenGenerator.generateKid(this.shrParameters);
        return kid;
    }
    /**
     * Generates a signed http request for the given payload with the given key.
     * @param payload Payload to sign (e.g. access token)
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param claims Additional claims to include/override in the signed JWT
     * @returns Pop token signed with the corresponding private key
     */ async signRequest(payload, publicKeyThumbprint, claims) {
        return this.popTokenGenerator.signPayload(payload, publicKeyThumbprint, this.shrParameters, claims);
    }
    /**
     * Removes cached keys from browser for given public key thumbprint
     * @param publicKeyThumbprint Public key digest (from generatePublicKeyThumbprint API)
     * @param correlationId
     * @returns If keys are properly deleted
     */ async removeKeys(publicKeyThumbprint, correlationId) {
        return this.cryptoOps.removeTokenBindingKey(publicKeyThumbprint, correlationId);
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns browser performance measurement module if session flag is enabled. Returns undefined otherwise.
 */ function $9797579afd7d961c$var$getPerfMeasurementModule() {
    let sessionStorage;
    try {
        sessionStorage = window[$9797579afd7d961c$var$BrowserCacheLocation.SessionStorage];
        const perfEnabled = sessionStorage?.getItem($9797579afd7d961c$var$BROWSER_PERF_ENABLED_KEY);
        if (Number(perfEnabled) === 1) return Promise.resolve().then(function() {
            return $9797579afd7d961c$var$BrowserPerformanceMeasurement$1;
        });
    // Mute errors if it's a non-browser environment or cookies are blocked.
    } catch (e) {}
    return undefined;
}
/**
 * Returns boolean, indicating whether browser supports window.performance.now() function.
 */ function $9797579afd7d961c$var$supportsBrowserPerformanceNow() {
    return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.now === "function";
}
/**
 * Returns event duration in milliseconds using window performance API if available. Returns undefined otherwise.
 * @param startTime {DOMHighResTimeStamp | undefined}
 * @returns {number | undefined}
 */ function $9797579afd7d961c$var$getPerfDurationMs(startTime) {
    if (!startTime || !$9797579afd7d961c$var$supportsBrowserPerformanceNow()) return undefined;
    return Math.round(window.performance.now() - startTime);
}
class $9797579afd7d961c$var$BrowserPerformanceClient extends $9797579afd7d961c$var$PerformanceClient {
    constructor(configuration, intFields){
        super(configuration.auth.clientId, configuration.auth.authority || `${$9797579afd7d961c$var$DEFAULT_AUTHORITY}`, new $9797579afd7d961c$var$Logger(configuration.system?.loggerOptions || {}, $9797579afd7d961c$var$name, $9797579afd7d961c$var$version), $9797579afd7d961c$var$name, $9797579afd7d961c$var$version, configuration.telemetry?.application || {
            appName: "",
            appVersion: ""
        }, intFields);
    }
    generateId() {
        return $9797579afd7d961c$var$createNewGuid();
    }
    getPageVisibility() {
        return document.visibilityState?.toString() || null;
    }
    getOnlineStatus() {
        return typeof navigator !== "undefined" ? navigator.onLine : null;
    }
    deleteIncompleteSubMeasurements(inProgressEvent) {
        $9797579afd7d961c$var$getPerfMeasurementModule()?.then((module)=>{
            const rootEvent = this.eventsByCorrelationId.get(inProgressEvent.event.correlationId);
            const isRootEvent = rootEvent && rootEvent.eventId === inProgressEvent.event.eventId;
            const incompleteMeasurements = [];
            if (isRootEvent && rootEvent?.incompleteSubMeasurements) rootEvent.incompleteSubMeasurements.forEach((subMeasurement)=>{
                incompleteMeasurements.push({
                    ...subMeasurement
                });
            });
            // Clean up remaining marks for incomplete sub-measurements
            module.BrowserPerformanceMeasurement.flushMeasurements(inProgressEvent.event.correlationId, incompleteMeasurements);
        });
    }
    /**
     * Starts measuring performance for a given operation. Returns a function that should be used to end the measurement.
     * Also captures browser page visibilityState.
     *
     * @param {PerformanceEvents} measureName
     * @param {?string} [correlationId]
     * @returns {((event?: Partial<PerformanceEvent>) => PerformanceEvent| null)}
     */ startMeasurement(measureName, correlationId) {
        // Capture page visibilityState and then invoke start/end measurement
        const startPageVisibility = this.getPageVisibility();
        const startOnlineStatus = this.getOnlineStatus();
        const inProgressEvent = super.startMeasurement(measureName, correlationId);
        const startTime = $9797579afd7d961c$var$supportsBrowserPerformanceNow() ? window.performance.now() : undefined;
        const browserMeasurement = $9797579afd7d961c$var$getPerfMeasurementModule()?.then((module)=>{
            return new module.BrowserPerformanceMeasurement(measureName, inProgressEvent.event.correlationId);
        });
        browserMeasurement?.then((measurement)=>measurement.startMeasurement());
        return {
            ...inProgressEvent,
            end: (event, error, account)=>{
                const networkInfo = $9797579afd7d961c$var$getNetworkInfo();
                const res = inProgressEvent.end({
                    ...event,
                    startPageVisibility: startPageVisibility,
                    startOnlineStatus: startOnlineStatus,
                    endPageVisibility: this.getPageVisibility(),
                    durationMs: $9797579afd7d961c$var$getPerfDurationMs(startTime),
                    networkEffectiveType: networkInfo.effectiveType,
                    networkRtt: networkInfo.rtt
                }, error, account);
                browserMeasurement?.then((measurement)=>measurement.endMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
                return res;
            },
            discard: ()=>{
                inProgressEvent.discard();
                browserMeasurement?.then((measurement)=>measurement.flushMeasurement());
                this.deleteIncompleteSubMeasurements(inProgressEvent);
            }
        };
    }
}
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $9797579afd7d961c$var$BrowserPerformanceMeasurement {
    constructor(name, correlationId){
        this.correlationId = correlationId;
        this.measureName = $9797579afd7d961c$var$BrowserPerformanceMeasurement.makeMeasureName(name, correlationId);
        this.startMark = $9797579afd7d961c$var$BrowserPerformanceMeasurement.makeStartMark(name, correlationId);
        this.endMark = $9797579afd7d961c$var$BrowserPerformanceMeasurement.makeEndMark(name, correlationId);
    }
    static makeMeasureName(name, correlationId) {
        return `msal.measure.${name}.${correlationId}`;
    }
    static makeStartMark(name, correlationId) {
        return `msal.start.${name}.${correlationId}`;
    }
    static makeEndMark(name, correlationId) {
        return `msal.end.${name}.${correlationId}`;
    }
    static supportsBrowserPerformance() {
        return typeof window !== "undefined" && typeof window.performance !== "undefined" && typeof window.performance.mark === "function" && typeof window.performance.measure === "function" && typeof window.performance.clearMarks === "function" && typeof window.performance.clearMeasures === "function" && typeof window.performance.getEntriesByName === "function";
    }
    /**
     * Flush browser marks and measurements.
     * @param {string} correlationId
     * @param {SubMeasurement} measurements
     */ static flushMeasurements(correlationId, measurements) {
        if ($9797579afd7d961c$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            measurements.forEach((measurement)=>{
                const measureName = $9797579afd7d961c$var$BrowserPerformanceMeasurement.makeMeasureName(measurement.name, correlationId);
                const entriesForMeasurement = window.performance.getEntriesByName(measureName, "measure");
                if (entriesForMeasurement.length > 0) {
                    window.performance.clearMeasures(measureName);
                    window.performance.clearMarks($9797579afd7d961c$var$BrowserPerformanceMeasurement.makeStartMark(measureName, correlationId));
                    window.performance.clearMarks($9797579afd7d961c$var$BrowserPerformanceMeasurement.makeEndMark(measureName, correlationId));
                }
            });
        } catch (e) {
        // Silently catch and return null
        }
    }
    startMeasurement() {
        if ($9797579afd7d961c$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.startMark);
        } catch (e) {
        // Silently catch
        }
    }
    endMeasurement() {
        if ($9797579afd7d961c$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            window.performance.mark(this.endMark);
            window.performance.measure(this.measureName, this.startMark, this.endMark);
        } catch (e) {
        // Silently catch
        }
    }
    flushMeasurement() {
        if ($9797579afd7d961c$var$BrowserPerformanceMeasurement.supportsBrowserPerformance()) try {
            const entriesForMeasurement = window.performance.getEntriesByName(this.measureName, "measure");
            if (entriesForMeasurement.length > 0) {
                const durationMs = entriesForMeasurement[0].duration;
                window.performance.clearMeasures(this.measureName);
                window.performance.clearMarks(this.startMark);
                window.performance.clearMarks(this.endMark);
                return durationMs;
            }
        } catch (e) {
        // Silently catch and return null
        }
        return null;
    }
}
var $9797579afd7d961c$var$BrowserPerformanceMeasurement$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BrowserPerformanceMeasurement: $9797579afd7d961c$var$BrowserPerformanceMeasurement
});
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @packageDocumentation
 * @module @azure/msal-browser
 */ // Common constants
const $9797579afd7d961c$var$AuthenticationScheme = $9797579afd7d961c$var$AuthenticationScheme$1;
const $9797579afd7d961c$var$ResponseMode = $9797579afd7d961c$var$ResponseMode$1;
const $9797579afd7d961c$var$PromptValue = $9797579afd7d961c$var$PromptValue$1;
const $9797579afd7d961c$var$JsonWebTokenTypes = $9797579afd7d961c$var$JsonWebTokenTypes$1;
const $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES = $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES$1;
$9797579afd7d961c$export$192d74ad69b40705 = $9797579afd7d961c$var$ApiId;
$9797579afd7d961c$export$145273558d58e0ac = $9797579afd7d961c$var$AuthError;
$9797579afd7d961c$export$473ab0b56598aacd = $9797579afd7d961c$var$AuthErrorCodes;
$9797579afd7d961c$export$46f6771f16bdfbc6 = $9797579afd7d961c$var$AuthenticationHeaderParser;
$9797579afd7d961c$export$901491a717da2ba5 = $9797579afd7d961c$var$AuthenticationScheme;
$9797579afd7d961c$export$4cda21933050d9ec = $9797579afd7d961c$var$AzureCloudInstance;
$9797579afd7d961c$export$f8eb6760ca13876a = $9797579afd7d961c$var$BrowserAuthError;
$9797579afd7d961c$export$a206205e46059d69 = $9797579afd7d961c$var$BrowserAuthErrorCodes;
$9797579afd7d961c$export$573384e47a12d835 = $9797579afd7d961c$var$BrowserCacheLocation;
$9797579afd7d961c$export$2eb7a1dfdc4c5fba = $9797579afd7d961c$var$BrowserConfigurationAuthError;
$9797579afd7d961c$export$5b6860c1e1ad8019 = $9797579afd7d961c$var$BrowserConfigurationAuthErrorCodes;
$9797579afd7d961c$export$3714d85cfc8f4a02 = $9797579afd7d961c$var$BrowserPerformanceClient;
$9797579afd7d961c$export$f97b8b5459a3aa4 = $9797579afd7d961c$var$BrowserPerformanceMeasurement;
$9797579afd7d961c$export$2ae77374159d4955 = $9797579afd7d961c$var$BrowserRootPerformanceEvents;
$9797579afd7d961c$export$311899ae85124b2d = $9797579afd7d961c$var$BrowserUtils;
$9797579afd7d961c$export$4394baa7e922d42d = $9797579afd7d961c$var$CacheLookupPolicy;
$9797579afd7d961c$export$a839ff85a7957561 = $9797579afd7d961c$var$ClientAuthError;
$9797579afd7d961c$export$dc9623d93fc077da = $9797579afd7d961c$var$ClientAuthErrorCodes;
$9797579afd7d961c$export$ac9d9d20c2327339 = $9797579afd7d961c$var$ClientConfigurationError;
$9797579afd7d961c$export$5fde068af21a5dfb = $9797579afd7d961c$var$ClientConfigurationErrorCodes;
$9797579afd7d961c$export$f3ffe700be354b19 = $9797579afd7d961c$var$DEFAULT_IFRAME_TIMEOUT_MS$1;
$9797579afd7d961c$export$ce0ba2422a1c7815 = $9797579afd7d961c$var$EventHandler;
$9797579afd7d961c$export$ba9166e03da6599c = $9797579afd7d961c$var$EventMessageUtils;
$9797579afd7d961c$export$3d7865934588d77e = $9797579afd7d961c$var$EventType;
$9797579afd7d961c$export$6ba3e818c6bc76ba = $9797579afd7d961c$var$InteractionRequiredAuthError;
$9797579afd7d961c$export$ecddfe385fe09c26 = $9797579afd7d961c$var$InteractionRequiredAuthErrorCodes;
$9797579afd7d961c$export$bec20eda0179362b = $9797579afd7d961c$var$InteractionStatus;
$9797579afd7d961c$export$fe5c42ed17efe603 = $9797579afd7d961c$var$JsonWebTokenTypes;
$9797579afd7d961c$export$19fffca37ef3e106 = $9797579afd7d961c$var$LocalStorage;
$9797579afd7d961c$export$efa9a398d6368992 = $9797579afd7d961c$var$Logger;
$9797579afd7d961c$export$d7392285c701ecf5 = $9797579afd7d961c$var$MemoryStorage;
$9797579afd7d961c$export$d0d362a73d466c9b = $9797579afd7d961c$var$NavigationClient;
$9797579afd7d961c$export$893b1b5b686d84ef = $9797579afd7d961c$var$OIDC_DEFAULT_SCOPES;
$9797579afd7d961c$export$49a06cbda5acaa5 = $9797579afd7d961c$var$PromptValue;
$9797579afd7d961c$export$73a3e3dedd37150d = $9797579afd7d961c$var$ProtocolMode;
$9797579afd7d961c$export$89f4855ef88b7920 = $9797579afd7d961c$var$PublicClientApplication;
$9797579afd7d961c$export$f990a5bae1260b8c = $9797579afd7d961c$var$ResponseMode;
$9797579afd7d961c$export$ea52035eac03daf0 = $9797579afd7d961c$var$ServerError;
$9797579afd7d961c$export$2c4b17e1c2e0931 = $9797579afd7d961c$var$SessionStorage;
$9797579afd7d961c$export$e1f04f41501741ea = $9797579afd7d961c$var$SignedHttpRequest;
$9797579afd7d961c$export$c70f2989a65fda3e = $9797579afd7d961c$var$StubPerformanceClient;
$9797579afd7d961c$export$8abb9de997bb4e44 = $9797579afd7d961c$var$WrapperSKU;
$9797579afd7d961c$export$210078d2745a65ac = $9797579afd7d961c$var$createNestablePublicClientApplication;
$9797579afd7d961c$export$f28b97cfb2f3098 = $9797579afd7d961c$var$createStandardPublicClientApplication;
$9797579afd7d961c$export$df47a28b08fa2370 = $9797579afd7d961c$var$enforceResourceParameter;
$9797579afd7d961c$export$bce61db0d62ff8e2 = $9797579afd7d961c$var$isPlatformBrokerAvailable;
$9797579afd7d961c$export$267894f3740f96bf = $9797579afd7d961c$var$loadExternalTokens;
$9797579afd7d961c$export$29650b96fd06034a = $9797579afd7d961c$var$stubbedPublicClientApplication;
$9797579afd7d961c$export$83d89fbfd8236492 = $9797579afd7d961c$var$version; //# sourceMappingURL=msal-browser.cjs.map

});


parcelRegister("3iVnd", function(module, exports) {

$parcel$export(module.exports, "unifiedReducer", function () { return $f52ae520138a2518$export$69d5f9b007ee9bda; });
parcelRequire("eiI4b");
var $jO6Fi = parcelRequire("jO6Fi");
var $TyLsR = parcelRequire("TyLsR");
var $74NRg = parcelRequire("74NRg");
var $cOMZi = parcelRequire("cOMZi");
var $c9VC0 = parcelRequire("c9VC0");
var $6m6iW = parcelRequire("6m6iW");
var $fn3Te = parcelRequire("fn3Te");
var $1XCiH = parcelRequire("1XCiH");
var $iAlxu = parcelRequire("iAlxu");
var $dqZe8 = parcelRequire("dqZe8");
var $8yz5e = parcelRequire("8yz5e");
var $h0kLA = parcelRequire("h0kLA");
var $5bCbF = parcelRequire("5bCbF");
var $4t0nF = parcelRequire("4t0nF");
var $6tZYZ = parcelRequire("6tZYZ");
var $148VJ = parcelRequire("148VJ");
var $bLA9d = parcelRequire("bLA9d");
var $cK7Ef = parcelRequire("cK7Ef");
var $2NWpy = parcelRequire("2NWpy");
var $jvPQV = parcelRequire("jvPQV");
var $eKeed = parcelRequire("eKeed");
var $5dGw6 = parcelRequire("5dGw6");
var $8v0hS = parcelRequire("8v0hS");
var $93lQV = parcelRequire("93lQV");
var $1hz5x = parcelRequire("1hz5x");
var $l8e1b = parcelRequire("l8e1b");

var $0eakK = parcelRequire("0eakK");

var $2Mlm8 = parcelRequire("2Mlm8");
parcelRequire("fi705");
var $9peQn = parcelRequire("9peQn");
var $3bTEh = parcelRequire("3bTEh");
var $8BVnE = parcelRequire("8BVnE");
var $hDW0t = parcelRequire("hDW0t");
var $6g7jD = parcelRequire("6g7jD");
var $iQCBi = parcelRequire("iQCBi");
var $licSs = parcelRequire("licSs");
var $eFCJ9 = parcelRequire("eFCJ9");
var $izwfU = parcelRequire("izwfU");
var $79ZAU = parcelRequire("79ZAU");
var $jYtAo = parcelRequire("jYtAo");
var $imj4N = parcelRequire("imj4N");
var $h8Dcs = parcelRequire("h8Dcs");
var $5K8cU = parcelRequire("5K8cU");
var $aZkQ1 = parcelRequire("aZkQ1");
var $BtObB = parcelRequire("BtObB");
var $hYxsn = parcelRequire("hYxsn");
var $cKin3 = parcelRequire("cKin3");
var $aefxR = parcelRequire("aefxR");
var $gO34q = parcelRequire("gO34q");
var $8unDl = parcelRequire("8unDl");
var $dXplA = parcelRequire("dXplA");
var $86Xek = parcelRequire("86Xek");
var $4qS4e = parcelRequire("4qS4e");
var $2kXh8 = parcelRequire("2kXh8");
var $aO7iy = parcelRequire("aO7iy");
var $6dv42 = parcelRequire("6dv42");
var $6OvqD = parcelRequire("6OvqD");
var $jPTUt = parcelRequire("jPTUt");
var $djMm9 = parcelRequire("djMm9");
var $jIhEp = parcelRequire("jIhEp");

var $f2M6x = parcelRequire("f2M6x");
parcelRequire("2uo2k");
var $7Poeg = parcelRequire("7Poeg");
var $d2rCN = parcelRequire("d2rCN");
var $69HdE = parcelRequire("69HdE");
var $f6HCY = parcelRequire("f6HCY");
var $4x2zK = parcelRequire("4x2zK");
var $l8bhP = parcelRequire("l8bhP");
var $6YOxT = parcelRequire("6YOxT");
var $ifhbO = parcelRequire("ifhbO");
var $lmDtA = parcelRequire("lmDtA");
var $dCMsy = parcelRequire("dCMsy");
var $gbACq = parcelRequire("gbACq");
var $iRGkV = parcelRequire("iRGkV");
var $gxQzQ = parcelRequire("gxQzQ");
var $7v6lU = parcelRequire("7v6lU");
var $8PBoD = parcelRequire("8PBoD");
var $fzmMk = parcelRequire("fzmMk");
var $gTRxb = parcelRequire("gTRxb");
var $5GKCG = parcelRequire("5GKCG");
var $inVyK = parcelRequire("inVyK");
var $1HVxb = parcelRequire("1HVxb");
var $bNZuU = parcelRequire("bNZuU");
var $6Jy5A = parcelRequire("6Jy5A");
var $648Q5 = parcelRequire("648Q5");
var $gPxFT = parcelRequire("gPxFT");
var $1mYsg = parcelRequire("1mYsg");

var $4lHS7 = parcelRequire("4lHS7");
parcelRequire("kEQk4");
var $l2VIL = parcelRequire("l2VIL");
var $jIN7z = parcelRequire("jIN7z");
var $9RMDT = parcelRequire("9RMDT");
var $9G4DM = parcelRequire("9G4DM");
var $bYHsj = parcelRequire("bYHsj");

var $faq47 = parcelRequire("faq47");

var $ctrWF = parcelRequire("ctrWF");
parcelRequire("lerp3");
var $j8b39 = parcelRequire("j8b39");
/** Master and patch editing commands that must never run for a Report's current view. */ const $f52ae520138a2518$var$templateEditingOperations = new Set([
    $2Mlm8.ACTIVATE_VARIANT_PATCH,
    $2Mlm8.CANCEL_VARIANT_PATCH_CREATION,
    $2Mlm8.CREATE_VARIANT_PATCH,
    $2Mlm8.REMOVE_VARIANT_PATCH,
    $2Mlm8.REMOVE_VARIANT_TEMPLATE,
    $2Mlm8.RENAME_VARIANT_PATCH,
    $2Mlm8.RENAME_VARIANT_TEMPLATE,
    $2Mlm8.SET_CREATE_VARIANT_PATCH_WINDOW,
    $2Mlm8.SET_VARIANT_CREATION_VIEW,
    $2Mlm8.SET_VARIANT_PATCH_SELECTION,
    $2Mlm8.TOGGLE_VARIANT_PATCH,
    $2Mlm8.TRACK_ACTIVE_VARIANT_PATCH,
    $2Mlm8.UPSERT_VARIANT_TEMPLATE
]);
const $f52ae520138a2518$export$69d5f9b007ee9bda = (state, action)=>{
    const nextState = $f52ae520138a2518$var$reduceSlices(state, action);
    if (action.operation === (0, $ctrWF.UNDO) || action.operation === (0, $ctrWF.REDO)) return nextState;
    return (0, $faq47.finishHistory)(state, nextState, action);
};
/**
 * Unified reducer for application, hierarchy, TLF, and ToC actions.
 *
 * @param state - Current unified application state
 * @param action - The unified action to apply.
 * @returns The updated {@link IUnifiedState}.
 */ const $f52ae520138a2518$var$reduceSlices = (state, action)=>{
    if (state.hierarchyState.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report && $f52ae520138a2518$var$templateEditingOperations.has(action.operation)) return state;
    switch(action.operation){
        // Added to ensure that undo and redo operations are included in the slice
        case 0, $ctrWF.REDO:
            return $bYHsj.app_undoRedo(state, action);
        case 0, $ctrWF.UNDO:
            return $bYHsj.app_undoRedo(state, action);
        case $0eakK.ADD_DOMAIN_REPLACEMENT:
            {
                const hierarchyState = $jO6Fi.hcr_addDomainReplacement(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.ADD_HIERARCHY_NODES:
            {
                const hierarchyState = $TyLsR.hcr_addHierarchyNodes(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.ADD_SINGLE_REPLACEMENT:
            {
                const hierarchyState = $74NRg.hcr_addSingleReplacement(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.CLEAR_HIERARCHY:
            {
                const hierarchyState = $cOMZi.hcr_clearHierarchy(state.hierarchyState);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.LOAD_CLINICAL_LIBRARY:
            {
                const hierarchyState = $c9VC0.hcr_loadClinicalLibrary(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.LOAD_HIERARCHY:
            {
                const hierarchyState = $6m6iW.hcr_loadHierarchy(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.PATCH_HIERARCHY_COMMENTS:
            {
                const hierarchyState = $fn3Te.hcr_patchHierarchyComments(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.REMOVE_DOMAIN_REPLACEMENT:
            {
                const hierarchyState = $1XCiH.hcr_removeDomainReplacement(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.REMOVE_HIERARCHY_COMMENT:
            {
                const hierarchyState = $iAlxu.hcr_removeHierarchyComment(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.REMOVE_HIERARCHY_NODE:
            {
                const hierarchyState = $dqZe8.hcr_removeHierarchyNode(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.REMOVE_SINGLE_REPLACEMENT:
            {
                const hierarchyState = $8yz5e.hcr_removeSingleReplacement(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case 0, $ctrWF.SAVE_COMPLETED:
            return $jIN7z.app_saveCompleted(state, action);
        case $0eakK.SAVE_HIERARCHY_COMPLETED:
            {
                const hierarchyState = $h0kLA.hcr_saveHierarchyCompleted(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SAVE_HIERARCHY_FAILED:
            {
                const hierarchyState = $5bCbF.hcr_saveHierarchyFailed(state.hierarchyState);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SAVE_TOC_MAJOR_VERSION:
            {
                const hierarchyState = $4t0nF.hcr_saveTocMajorVersion(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case 0, $ctrWF.SAVE_TLF_COMPLETED:
            return $9RMDT.app_saveTlfCompleted(state, action);
        case 0, $ctrWF.SET_SAVE_REQUEST:
            return $9G4DM.app_setSaveRequest(state, action);
        case $0eakK.SET_ACCESS_RIGHTS:
            {
                const hierarchyState = $6tZYZ.hcr_setAccessRights(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_CLINICAL_LIBRARY_LOADING:
            {
                const hierarchyState = $148VJ.hcr_setClinicalLibraryLoading(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_HIERARCHY_COMMENT_PANEL:
            {
                const hierarchyState = $bLA9d.hcr_setHierarchyCommentPanel(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_HIERARCHY_ID:
            {
                const hierarchyState = $cK7Ef.hcr_setHierarchyId(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_HIERARCHY_SAVE_REQUEST_STATUS:
            {
                const hierarchyState = $2NWpy.hcr_setHierarchySaveRequestStatus(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS:
            {
                const hierarchyState = $jvPQV.hcr_setHierarchySaveTocRequestStatus(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.SET_HIERARCHY_SUBSCRIPTION_STATUS:
            {
                const hierarchyState = $eKeed.hcr_setHierarchySubscriptionStatus(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case 0, $ctrWF.SET_HIERARCHY_VALIDATION_SAVE_BLOCKER:
            return (0, $l2VIL.app_reduceValidationSaveBlockers)(state, action);
        case $0eakK.UPDATE_DOMAIN_REPLACEMENT:
            {
                const hierarchyState = $5dGw6.hcr_updateDomainReplacement(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.UPDATE_HIERARCHY:
            {
                const hierarchyState = $8v0hS.hcr_updateHierarchy(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.UPDATE_HIERARCHY_COMMENT:
            {
                const hierarchyState = $93lQV.hcr_updateHierarchyComment(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.UPDATE_SINGLE_REPLACEMENT:
            {
                const hierarchyState = $1hz5x.hcr_updateSingleReplacements(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $0eakK.UPDATE_TLF_ITEM_INDEX:
            {
                const hierarchyState = $l8e1b.hcr_updateTlfItemIndex(state.hierarchyState, action);
                return {
                    ...state,
                    hierarchyState: hierarchyState,
                    saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, action, state.allowedReportTypes)
                };
            }
        case $2Mlm8.ACTIVATE_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $9peQn.tlf_activateVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.ADD_RECEIVED_MESSAGE:
            return {
                ...state,
                tlfState: $3bTEh.tlf_addReceivedMessage(state.tlfState, action)
            };
        case $2Mlm8.APPLY_VARIANT_TEMPLATE:
            return {
                ...state,
                tlfState: $8BVnE.tlf_applyVariantTemplate(state.tlfState, action)
            };
        case $2Mlm8.CANCEL_VARIANT_PATCH_CREATION:
            return {
                ...state,
                tlfState: $hDW0t.tlf_cancelVariantPatchCreation(state.tlfState)
            };
        case $2Mlm8.CLEAR_TLF:
            return {
                ...state,
                tlfState: $6g7jD.tlf_clearTlf()
            };
        case $2Mlm8.CLOSE_MODAL_WINDOW:
            return {
                ...state,
                tlfState: $iQCBi.tlf_closeModalWindow(state.tlfState)
            };
        case $2Mlm8.CREATE_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $licSs.tlf_createVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.LOAD_TLF:
            return {
                ...state,
                tlfState: $eFCJ9.tlf_loadTlf(state.tlfState, action)
            };
        case $2Mlm8.PATCH_TLF_COMMENTS:
            return {
                ...state,
                tlfState: $izwfU.tlf_patchTlfComments(state.tlfState, action)
            };
        case $2Mlm8.PROCESS_SIGNALR_NOTIFICATION:
            return {
                ...state,
                tlfState: $79ZAU.tlf_processSignalrNotification(state.tlfState, action)
            };
        case $2Mlm8.REMOVE_TLF_COMMENT:
            return {
                ...state,
                tlfState: $jYtAo.tlf_removeTlfComment(state.tlfState, action)
            };
        case $2Mlm8.REMOVE_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $imj4N.tlf_removeVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.REMOVE_VARIANT_TEMPLATE:
            return {
                ...state,
                tlfState: $h8Dcs.tlf_removeVariantTemplate(state.tlfState, action)
            };
        case $2Mlm8.RENAME_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $5K8cU.tlf_renameVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.RENAME_VARIANT_TEMPLATE:
            return {
                ...state,
                tlfState: $aZkQ1.tlf_renameVariantTemplate(state.tlfState, action)
            };
        case $2Mlm8.REVERT_TO_VARIANT_MASTER:
            return {
                ...state,
                tlfState: $BtObB.tlf_revertToVariantMaster(state.tlfState, action)
            };
        case $2Mlm8.SET_CREATE_VARIANT_PATCH_WINDOW:
            return {
                ...state,
                tlfState: $hYxsn.tlf_setCreateVariantPatchWindow(state.tlfState, action)
            };
        case $2Mlm8.SET_EDITOR_BLOCKS_SEARCH_PANEL:
            return {
                ...state,
                tlfState: $cKin3.tlf_setEditorBlocksSearchPanel(state.tlfState, action)
            };
        case $2Mlm8.SET_TLF_COMMENT_PANEL:
            return {
                ...state,
                tlfState: $aefxR.tlf_setTlfCommentPanel(state.tlfState, action)
            };
        case $2Mlm8.SET_TLF_READ_ONLY:
            return {
                ...state,
                tlfState: $gO34q.tlf_setTlfReadOnly(state.tlfState, action)
            };
        case $2Mlm8.SET_TLF_SUBSCRIPTION_STATUS:
            return {
                ...state,
                tlfState: $8unDl.tlf_setTlfSubscriptionStatus(state.tlfState, action)
            };
        case $2Mlm8.SET_VARIANT_CREATION_VIEW:
            return {
                ...state,
                tlfState: $dXplA.tlf_setVariantCreationMode(state.tlfState, action)
            };
        case $2Mlm8.SET_VARIANT_PATCH_SELECTION:
            return {
                ...state,
                tlfState: $86Xek.tlf_setVariantPatchSelection(state.tlfState, action)
            };
        case $2Mlm8.SET_VIEW_MODE:
            return {
                ...state,
                tlfState: $4qS4e.tlf_setViewMode(state.tlfState, action)
            };
        case $2Mlm8.SHOW_MODAL_WINDOW:
            return {
                ...state,
                tlfState: $2kXh8.tlf_showModalWindow(state.tlfState, action)
            };
        case $2Mlm8.TOGGLE_TRAFFIC_LIGHTS:
            return {
                ...state,
                tlfState: $aO7iy.tlf_toggleTrafficLights(state.tlfState, action)
            };
        case $2Mlm8.TOGGLE_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $6dv42.tlf_toggleVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.TRACK_ACTIVE_VARIANT_PATCH:
            return {
                ...state,
                tlfState: $6OvqD.tlf_trackActiveVariantPatch(state.tlfState, action)
            };
        case $2Mlm8.UPDATE_TLF:
            {
                let tlfState = $jPTUt.tlf_updateTlf(state.tlfState, action);
                if (tlfState.activeVariantPatchName !== null && !action.newSavePoint && !action.doNotAddUndo && !action.reset && !action.calledFrom.startsWith("SignalR")) // Record the edited view and its derived patch catalogue as one global undo entry.
                tlfState = $6OvqD.tlf_trackActiveVariantPatch(tlfState, {
                    operation: $2Mlm8.TRACK_ACTIVE_VARIANT_PATCH,
                    calledFrom: action.calledFrom
                });
                return {
                    ...state,
                    tlfState: tlfState
                };
            }
        case $2Mlm8.UPDATE_TLF_COMMENT:
            return {
                ...state,
                tlfState: $djMm9.tlf_updateTlfComment(state.tlfState, action)
            };
        case $2Mlm8.UPSERT_VARIANT_TEMPLATE:
            return {
                ...state,
                tlfState: $jIhEp.tlf_upsertVariantTemplate(state.tlfState, action)
            };
        case $f2M6x.ADD_NEW_TOC_ENTRIES:
            return {
                ...state,
                tocState: $7Poeg.toc_addNewTocEntries(state.tocState, action)
            };
        case $f2M6x.ADD_SECTION:
            return {
                ...state,
                tocState: $d2rCN.toc_addSection(state.tocState, action)
            };
        case $f2M6x.CLEAR_REMOVED:
            return {
                ...state,
                tocState: $69HdE.toc_clearRemoved(state.tocState)
            };
        case $f2M6x.CLOSE_TOC_NEED_REFRESH:
            return {
                ...state,
                tocState: $f6HCY.toc_closeTocNeedRefresh(state.tocState)
            };
        case $f2M6x.CLOSE_TOC_SAVE_ALERT:
            return {
                ...state,
                tocState: $4x2zK.toc_closeTocSaveAlert(state.tocState)
            };
        case $f2M6x.DELETE:
            return {
                ...state,
                tocState: $l8bhP.toc_delete(state.tocState, action)
            };
        case $f2M6x.FROM_SIGNALR:
            return {
                ...state,
                tocState: $6YOxT.toc_fromSignalR(state.tocState, action)
            };
        case $f2M6x.MOVE_ITEM:
            return {
                ...state,
                tocState: $ifhbO.toc_moveItem(state.tocState, action)
            };
        case $f2M6x.REASSIGN_TOC_NUMBERS:
            return {
                ...state,
                tocState: $lmDtA.toc_reassignTocNumbers(state.tocState)
            };
        case $f2M6x.REFRESH:
            return {
                ...state,
                tocState: $dCMsy.toc_refresh(state.tocState, action)
            };
        case $f2M6x.SAVE_FAIL:
            return {
                ...state,
                tocState: $gbACq.toc_saveFail(state.tocState)
            };
        case $f2M6x.SAVE_SUCCESS:
            return {
                ...state,
                tocState: $iRGkV.toc_saveSuccess(state.tocState, action)
            };
        case $f2M6x.SET_TOC_REQUEST_STATUS:
            return {
                ...state,
                tocState: $gxQzQ.toc_setTocRequestStatus(state.tocState, action)
            };
        case $f2M6x.SET_TYPE_FILTER:
            return {
                ...state,
                tocState: $7v6lU.toc_setTypeFilter(state.tocState, action)
            };
        case $f2M6x.SHOW_TOC_NEED_REFRESH:
            return {
                ...state,
                tocState: $8PBoD.toc_showTocNeedRefresh(state.tocState)
            };
        case $f2M6x.SHOW_TOC_SAVE_ALERT:
            return {
                ...state,
                tocState: $fzmMk.toc_showTocSaveAlert(state.tocState, action)
            };
        case $f2M6x.SORT_TOC:
            return {
                ...state,
                tocState: $gTRxb.toc_sortToc(state.tocState)
            };
        case $f2M6x.UPDATE_AFTER_PATCH:
            return {
                ...state,
                tocState: $5GKCG.toc_updateAfterPatch(state.tocState)
            };
        case $f2M6x.UPDATE_COMMENTS_FILTER:
            return {
                ...state,
                tocState: $inVyK.toc_updateCommentsFilter(state.tocState, action)
            };
        case $f2M6x.UPDATE_ENTRY:
            return {
                ...state,
                tocState: $1HVxb.toc_updateEntry(state.tocState, action)
            };
        case $f2M6x.UPDATE_LAST_MAJOR_VERSION_SAVED_AT:
            return {
                ...state,
                tocState: $bNZuU.toc_updateLastMajorVersionSavedAt(state.tocState, action)
            };
        case $f2M6x.UPDATE_SEARCH_TEXT:
            return {
                ...state,
                tocState: $6Jy5A.toc_updateSearchText(state.tocState, action)
            };
        case $f2M6x.UPDATE_SECTION:
            return {
                ...state,
                tocState: $648Q5.toc_updateSection(state.tocState, action)
            };
        case $f2M6x.UPDATE_TRAFFIC_LIGHTS_FILTER:
            return {
                ...state,
                tocState: $gPxFT.toc_updateTrafficLightsFilter(state.tocState, action)
            };
        case $f2M6x.UPDATE_VIEW_TIFO:
            return {
                ...state,
                tocState: $1mYsg.toc_updateViewTiFo(state.tocState, action)
            };
    }
// There should never be a final return statement - all possible outcomes should have a corresponding case above.
};

});
parcelRegister("eiI4b", function(module, exports) {
$parcel$export(module.exports, "hcr_addDomainReplacement", function () { return (parcelRequire("jO6Fi")).hcr_addDomainReplacement; });
$parcel$export(module.exports, "hcr_addHierarchyNodes", function () { return (parcelRequire("TyLsR")).hcr_addHierarchyNodes; });
$parcel$export(module.exports, "hcr_addSingleReplacement", function () { return (parcelRequire("74NRg")).hcr_addSingleReplacement; });
$parcel$export(module.exports, "hcr_clearHierarchy", function () { return (parcelRequire("cOMZi")).hcr_clearHierarchy; });
$parcel$export(module.exports, "hcr_loadClinicalLibrary", function () { return (parcelRequire("c9VC0")).hcr_loadClinicalLibrary; });
$parcel$export(module.exports, "hcr_loadHierarchy", function () { return (parcelRequire("6m6iW")).hcr_loadHierarchy; });
$parcel$export(module.exports, "hcr_patchHierarchyComments", function () { return (parcelRequire("fn3Te")).hcr_patchHierarchyComments; });
$parcel$export(module.exports, "hcr_removeDomainReplacement", function () { return (parcelRequire("1XCiH")).hcr_removeDomainReplacement; });
$parcel$export(module.exports, "hcr_removeHierarchyComment", function () { return (parcelRequire("iAlxu")).hcr_removeHierarchyComment; });
$parcel$export(module.exports, "hcr_removeHierarchyNode", function () { return (parcelRequire("dqZe8")).hcr_removeHierarchyNode; });
$parcel$export(module.exports, "hcr_removeSingleReplacement", function () { return (parcelRequire("8yz5e")).hcr_removeSingleReplacement; });
$parcel$export(module.exports, "hcr_saveHierarchyCompleted", function () { return (parcelRequire("h0kLA")).hcr_saveHierarchyCompleted; });
$parcel$export(module.exports, "hcr_saveHierarchyFailed", function () { return (parcelRequire("5bCbF")).hcr_saveHierarchyFailed; });
$parcel$export(module.exports, "hcr_saveTocMajorVersion", function () { return (parcelRequire("4t0nF")).hcr_saveTocMajorVersion; });
$parcel$export(module.exports, "hcr_setAccessRights", function () { return (parcelRequire("6tZYZ")).hcr_setAccessRights; });
$parcel$export(module.exports, "hcr_setClinicalLibraryLoading", function () { return (parcelRequire("148VJ")).hcr_setClinicalLibraryLoading; });
$parcel$export(module.exports, "hcr_setHierarchyCommentPanel", function () { return (parcelRequire("bLA9d")).hcr_setHierarchyCommentPanel; });
$parcel$export(module.exports, "hcr_setHierarchyId", function () { return (parcelRequire("cK7Ef")).hcr_setHierarchyId; });
$parcel$export(module.exports, "hcr_setHierarchySaveRequestStatus", function () { return (parcelRequire("2NWpy")).hcr_setHierarchySaveRequestStatus; });
$parcel$export(module.exports, "hcr_setHierarchySaveTocRequestStatus", function () { return (parcelRequire("jvPQV")).hcr_setHierarchySaveTocRequestStatus; });
$parcel$export(module.exports, "hcr_setHierarchySubscriptionStatus", function () { return (parcelRequire("eKeed")).hcr_setHierarchySubscriptionStatus; });
$parcel$export(module.exports, "hcr_updateDomainReplacement", function () { return (parcelRequire("5dGw6")).hcr_updateDomainReplacement; });
$parcel$export(module.exports, "hcr_updateHierarchy", function () { return (parcelRequire("8v0hS")).hcr_updateHierarchy; });
$parcel$export(module.exports, "hcr_updateHierarchyComment", function () { return (parcelRequire("93lQV")).hcr_updateHierarchyComment; });
$parcel$export(module.exports, "hcr_updateSingleReplacements", function () { return (parcelRequire("1hz5x")).hcr_updateSingleReplacements; });
$parcel$export(module.exports, "hcr_updateTlfItemIndex", function () { return (parcelRequire("l8e1b")).hcr_updateTlfItemIndex; });
parcelRequire("jO6Fi");
parcelRequire("TyLsR");
parcelRequire("74NRg");
parcelRequire("cOMZi");
parcelRequire("c9VC0");
parcelRequire("6m6iW");
parcelRequire("fn3Te");
parcelRequire("1XCiH");
parcelRequire("iAlxu");
parcelRequire("dqZe8");
parcelRequire("8yz5e");
parcelRequire("h0kLA");
parcelRequire("5bCbF");
parcelRequire("4t0nF");
parcelRequire("6tZYZ");
parcelRequire("148VJ");
parcelRequire("bLA9d");
parcelRequire("cK7Ef");
parcelRequire("2NWpy");
parcelRequire("jvPQV");
parcelRequire("eKeed");
parcelRequire("8apm4");
parcelRequire("5dGw6");
parcelRequire("8v0hS");
parcelRequire("93lQV");
parcelRequire("1hz5x");
parcelRequire("l8e1b");

});
parcelRegister("jO6Fi", function(module, exports) {

$parcel$export(module.exports, "hcr_addDomainReplacement", function () { return $fadc0a3603370f09$export$79ada65322d17b0; });

var $8apm4 = parcelRequire("8apm4");
const $fadc0a3603370f09$export$79ada65322d17b0 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: [
                ...state.hierarchy.domainReplacements,
                action.domainReplacement
            ]
        }
    }, action);
};

});
parcelRegister("8apm4", function(module, exports) {

$parcel$export(module.exports, "hcr_updateChangedFlag", function () { return $d8f602205c398ea0$export$447b516ea97d3601; });

var $bX0x9 = parcelRequire("bX0x9");

var $h24Ud = parcelRequire("h24Ud");

var $0eakK = parcelRequire("0eakK");
/**
 * Reducer operations that should recompute the changed flag from hierarchy diffs.
 */ const $d8f602205c398ea0$var$changedOperations = new Set([
    (0, $0eakK.ADD_DOMAIN_REPLACEMENT),
    (0, $0eakK.ADD_SINGLE_REPLACEMENT),
    (0, $0eakK.PATCH_HIERARCHY_COMMENTS),
    (0, $0eakK.REMOVE_DOMAIN_REPLACEMENT),
    (0, $0eakK.REMOVE_HIERARCHY_COMMENT),
    (0, $0eakK.REMOVE_SINGLE_REPLACEMENT),
    (0, $0eakK.UPDATE_DOMAIN_REPLACEMENT),
    (0, $0eakK.UPDATE_HIERARCHY),
    (0, $0eakK.UPDATE_HIERARCHY_COMMENT),
    (0, $0eakK.UPDATE_SINGLE_REPLACEMENT),
    (0, $0eakK.UPDATE_TLF_ITEM_INDEX)
]);
/**
 * Hierarchy fields excluded from changed-flag diffing because they are transient,
 * derived, or intentionally ignored by save-change detection.
 */ const $d8f602205c398ea0$var$changedIgnorePaths = [
    "comments",
    "tocMinorVersion",
    "sections",
    "children",
    "studyStandardsDate",
    "history",
    "clinicalLibrary"
];
const $d8f602205c398ea0$export$447b516ea97d3601 = (state, action)=>{
    if (action.operation === (0, $0eakK.LOAD_HIERARCHY) || action.operation === (0, $0eakK.SAVE_HIERARCHY_COMPLETED) || action.operation === (0, $0eakK.SAVE_HIERARCHY_FAILED) || action.operation === (0, $0eakK.SAVE_TOC_MAJOR_VERSION)) return state;
    if (!$d8f602205c398ea0$var$changedOperations.has(action.operation)) return {
        ...state,
        changed: state.changed
    };
    const changed = (0, $bX0x9.getObjectDiff)((0, $h24Ud.omitDeep)(state.hierarchy, $d8f602205c398ea0$var$changedIgnorePaths), (0, $h24Ud.omitDeep)(state.savedHierarchy, $d8f602205c398ea0$var$changedIgnorePaths));
    return {
        ...state,
        changed: changed !== undefined
    };
};

});
parcelRegister("h24Ud", function(module, exports) {

$parcel$export(module.exports, "omitDeep", function () { return $85757e81539ef781$export$77ceec6772d0c749; });

var $eBlbF = parcelRequire("eBlbF");
function $85757e81539ef781$export$77ceec6772d0c749(obj, keys) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eBlbF))).isArray(obj)) return obj.map((item)=>$85757e81539ef781$export$77ceec6772d0c749(item, keys));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($eBlbF))).isObject(obj)) {
        const omitted = (0, (/*@__PURE__*/$parcel$interopDefault($eBlbF))).omit((0, (/*@__PURE__*/$parcel$interopDefault($eBlbF))).omitBy(obj, (value)=>value === undefined), keys);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eBlbF))).mapValues(omitted, (value)=>$85757e81539ef781$export$77ceec6772d0c749(value, keys));
    }
    return obj;
}

});

parcelRegister("0eakK", function(module, exports) {

$parcel$export(module.exports, "eSingleSource", function () { return $1331e2552ac71b12$export$abb8334d921faac2; });
$parcel$export(module.exports, "ADD_DOMAIN_REPLACEMENT", function () { return $1331e2552ac71b12$export$aebf9a63aeca33a2; });
$parcel$export(module.exports, "ADD_HIERARCHY_NODES", function () { return $1331e2552ac71b12$export$af63543297d305d3; });
$parcel$export(module.exports, "ADD_SINGLE_REPLACEMENT", function () { return $1331e2552ac71b12$export$1f26f8a4b9501121; });
$parcel$export(module.exports, "CLEAR_HIERARCHY", function () { return $1331e2552ac71b12$export$257c673177a91d25; });
$parcel$export(module.exports, "LOAD_CLINICAL_LIBRARY", function () { return $1331e2552ac71b12$export$ac3998a107a43651; });
$parcel$export(module.exports, "LOAD_HIERARCHY", function () { return $1331e2552ac71b12$export$7cc68a8d696fbd52; });
$parcel$export(module.exports, "PATCH_HIERARCHY_COMMENTS", function () { return $1331e2552ac71b12$export$271d48053b04aeae; });
$parcel$export(module.exports, "REMOVE_DOMAIN_REPLACEMENT", function () { return $1331e2552ac71b12$export$70df1c7f38ea0a27; });
$parcel$export(module.exports, "REMOVE_HIERARCHY_COMMENT", function () { return $1331e2552ac71b12$export$a8285857be72f67d; });
$parcel$export(module.exports, "REMOVE_HIERARCHY_NODE", function () { return $1331e2552ac71b12$export$5dad260e960f0189; });
$parcel$export(module.exports, "REMOVE_SINGLE_REPLACEMENT", function () { return $1331e2552ac71b12$export$ab292c949b56bfc7; });
$parcel$export(module.exports, "SAVE_HIERARCHY_COMPLETED", function () { return $1331e2552ac71b12$export$655b96db8658da6c; });
$parcel$export(module.exports, "SAVE_HIERARCHY_FAILED", function () { return $1331e2552ac71b12$export$9109a1640aa38ed; });
$parcel$export(module.exports, "SAVE_TOC_MAJOR_VERSION", function () { return $1331e2552ac71b12$export$c347f60526f1d96e; });
$parcel$export(module.exports, "SET_ACCESS_RIGHTS", function () { return $1331e2552ac71b12$export$1738d08d010c5538; });
$parcel$export(module.exports, "SET_CLINICAL_LIBRARY_LOADING", function () { return $1331e2552ac71b12$export$8289db70244884a2; });
$parcel$export(module.exports, "SET_HIERARCHY_COMMENT_PANEL", function () { return $1331e2552ac71b12$export$ef54187a16f8d1d8; });
$parcel$export(module.exports, "SET_HIERARCHY_ID", function () { return $1331e2552ac71b12$export$9d2edfc625b73cbb; });
$parcel$export(module.exports, "SET_HIERARCHY_SAVE_REQUEST_STATUS", function () { return $1331e2552ac71b12$export$a5abb8ce3f5e191b; });
$parcel$export(module.exports, "SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS", function () { return $1331e2552ac71b12$export$ad7562a69c9ee774; });
$parcel$export(module.exports, "SET_HIERARCHY_SUBSCRIPTION_STATUS", function () { return $1331e2552ac71b12$export$efd77e54249e655e; });
$parcel$export(module.exports, "UPDATE_DOMAIN_REPLACEMENT", function () { return $1331e2552ac71b12$export$69e68a1ae7b0c92; });
$parcel$export(module.exports, "UPDATE_HIERARCHY", function () { return $1331e2552ac71b12$export$ab8bfe308b46c5f6; });
$parcel$export(module.exports, "UPDATE_HIERARCHY_COMMENT", function () { return $1331e2552ac71b12$export$e68420b86c7c0e7b; });
$parcel$export(module.exports, "UPDATE_SINGLE_REPLACEMENT", function () { return $1331e2552ac71b12$export$bc2926584d3936e1; });
$parcel$export(module.exports, "UPDATE_TLF_ITEM_INDEX", function () { return $1331e2552ac71b12$export$cf1d4a398dc07663; });
$parcel$export(module.exports, "eShowDomainText", function () { return $1331e2552ac71b12$export$5aeb33928fc04af7; });
var $1331e2552ac71b12$export$abb8334d921faac2 = /*#__PURE__*/ function(eSingleSource) {
    eSingleSource["hierarchy"] = "Hierarchy";
    eSingleSource["tlfItem"] = "TlfItem";
    eSingleSource["domain"] = "Domain";
    return eSingleSource;
}({});
const $1331e2552ac71b12$export$aebf9a63aeca33a2 = "ADD_DOMAIN_REPLACEMENT";
const $1331e2552ac71b12$export$af63543297d305d3 = "ADD_HIERARCHY_NODES";
const $1331e2552ac71b12$export$1f26f8a4b9501121 = "ADD_SINGLE_REPLACEMENT";
const $1331e2552ac71b12$export$257c673177a91d25 = "CLEAR_HIERARCHY";
const $1331e2552ac71b12$export$ac3998a107a43651 = "LOAD_CLINICAL_LIBRARY";
const $1331e2552ac71b12$export$7cc68a8d696fbd52 = "LOAD_HIERARCHY";
const $1331e2552ac71b12$export$271d48053b04aeae = "PATCH_HIERARCHY_COMMENTS";
const $1331e2552ac71b12$export$70df1c7f38ea0a27 = "REMOVE_DOMAIN_REPLACEMENT";
const $1331e2552ac71b12$export$a8285857be72f67d = "REMOVE_HIERARCHY_COMMENT";
const $1331e2552ac71b12$export$5dad260e960f0189 = "REMOVE_HIERARCHY_NODE";
const $1331e2552ac71b12$export$ab292c949b56bfc7 = "REMOVE_SINGLE_REPLACEMENT";
const $1331e2552ac71b12$export$655b96db8658da6c = "SAVE_HIERARCHY_COMPLETED";
const $1331e2552ac71b12$export$9109a1640aa38ed = "SAVE_HIERARCHY_FAILED";
const $1331e2552ac71b12$export$c347f60526f1d96e = "SAVE_TOC_MAJOR_VERSION";
const $1331e2552ac71b12$export$1738d08d010c5538 = "SET_ACCESS_RIGHTS";
const $1331e2552ac71b12$export$8289db70244884a2 = "SET_CLINICAL_LIBRARY_LOADING";
const $1331e2552ac71b12$export$ef54187a16f8d1d8 = "SET_HIERARCHY_COMMENT_PANEL";
const $1331e2552ac71b12$export$9d2edfc625b73cbb = "SET_HIERARCHY_ID";
const $1331e2552ac71b12$export$a5abb8ce3f5e191b = "SET_HIERARCHY_SAVE_REQUEST_STATUS";
const $1331e2552ac71b12$export$ad7562a69c9ee774 = "SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS";
const $1331e2552ac71b12$export$efd77e54249e655e = "SET_HIERARCHY_SUBSCRIPTION_STATUS";
const $1331e2552ac71b12$export$69e68a1ae7b0c92 = "UPDATE_DOMAIN_REPLACEMENT";
const $1331e2552ac71b12$export$ab8bfe308b46c5f6 = "UPDATE_HIERARCHY";
const $1331e2552ac71b12$export$e68420b86c7c0e7b = "UPDATE_HIERARCHY_COMMENT";
const $1331e2552ac71b12$export$bc2926584d3936e1 = "UPDATE_SINGLE_REPLACEMENT";
const $1331e2552ac71b12$export$cf1d4a398dc07663 = "UPDATE_TLF_ITEM_INDEX";
var $1331e2552ac71b12$export$5aeb33928fc04af7 = /*#__PURE__*/ function(eShowDomainText) {
    eShowDomainText["Domain"] = "Domain";
    eShowDomainText["Original text"] = "Original Text";
    return eShowDomainText;
}({});

});



parcelRegister("TyLsR", function(module, exports) {

$parcel$export(module.exports, "hcr_addHierarchyNodes", function () { return $471979b4a262c08f$export$d962c2733f17e2f3; });

var $hUmQb = parcelRequire("hUmQb");
const $471979b4a262c08f$export$d962c2733f17e2f3 = (state, action)=>{
    const updatedHierarchyNodes = [
        ...state.hierarchyNodes.filter((hn)=>!action.hierarchyNodes.find((h)=>h.id === hn.id)),
        ...action.hierarchyNodes
    ];
    return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        parentTemplates: state.hierarchy ? (0, $hUmQb.hcr_buildParentTemplates)(state.hierarchy, updatedHierarchyNodes) : state.parentTemplates
    };
};

});
parcelRegister("hUmQb", function(module, exports) {

$parcel$export(module.exports, "hcr_buildParentTemplates", function () { return $a98b6b934877c6e0$export$213b383f0aab3bdf; });

var $bkN8u = parcelRequire("bkN8u");

var $dzXQW = parcelRequire("dzXQW");

var $fAVrY = parcelRequire("fAVrY");
const $a98b6b934877c6e0$export$213b383f0aab3bdf = (currentHierarchy, hierarchyNodes)=>{
    const parents = (0, $bkN8u.getThisAndParentHierarchies)(currentHierarchy.parentId, hierarchyNodes);
    const parentsWithTlfType = parents.map((ph)=>({
            ...ph,
            tlfType: (0, $dzXQW.getHierarchyTlfType)(ph.level)
        }));
    /**
   * The resolved TLF type (Template or Shell) of the current hierarchy, used to
   * determine which parent hierarchies' data should be included in the parentTemplates.
   */ const currentTlfType = (0, $dzXQW.getHierarchyTlfType)(currentHierarchy.level);
    return parentsWithTlfType.reduce((acc, ph)=>{
        // Add in new domain replacements from this hierarchy - Shell levels still inherit
        // from other Shell-level ancestors (e.g. Report inherits from Study, but Study itself
        // has no Shell-level ancestors so gets none)
        if (currentTlfType === ph.tlfType) acc.domainReplacements = [
            ...acc.domainReplacements,
            ...ph.domainReplacements.filter((dr)=>!acc.domainReplacements.some((r)=>r.domain === dr.domain && r.oldText === dr.oldText))
        ];
        // Add in new external list replacements from this hierarchy - Shell levels still inherit
        // from other Shell-level ancestors (e.g. Report inherits from Study)
        if (currentTlfType === ph.tlfType) acc.lists = [
            ...acc.lists,
            ...ph.lists.filter((list)=>!acc.lists.some((l)=>l.givenName === (list.givenName ?? // istanbul ignore next
                    "blank"))).map((list)=>({
                    ...list,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add in new row groups from this hierarchy - no level type filter
        acc.rowGroups = [
            ...acc.rowGroups,
            ...ph.rowGroups.filter((rowGroup)=>!acc.rowGroups.some((rg)=>rg.name === (rowGroup.name ?? // istanbul ignore next
                    "blank"))).map((rg)=>({
                    ...rg,
                    fromHierarchyId: ph.id
                }))
        ];
        // Get current single names (Report inherits from Study)
        if (currentTlfType === ph.tlfType) acc.singles = [
            ...acc.singles,
            ...ph.singles.filter((single)=>!acc.singles.some((s)=>s.oldText === single.oldText)).map((single)=>({
                    ...single,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add clinical library data from parent hierarchies with matching TLF type - Shell
        // levels still inherit from other Shell-level ancestors (Report inherits from
        // Study, but Study itself has no Shell-level ancestors so gets none)
        if (currentTlfType === ph.tlfType && ph.clinicalLibrary) {
            const mergedClinicalData = (0, $fAVrY.mergeClinicalLibraryData)({
                clinicalDatasets: acc.clinicalDatasets,
                clinicalCodeLists: acc.clinicalCodeLists,
                clinicalValueLists: acc.clinicalValueLists,
                clinicalComments: acc.clinicalComments,
                clinicalMethods: acc.clinicalMethods,
                clinicalWhereClauses: acc.clinicalWhereClauses
            }, ph.clinicalLibrary);
            acc.clinicalDatasets = mergedClinicalData.clinicalDatasets;
            acc.clinicalCodeLists = mergedClinicalData.clinicalCodeLists;
            acc.clinicalValueLists = mergedClinicalData.clinicalValueLists;
            acc.clinicalComments = mergedClinicalData.clinicalComments;
            acc.clinicalMethods = mergedClinicalData.clinicalMethods;
            acc.clinicalWhereClauses = mergedClinicalData.clinicalWhereClauses;
        }
        // Add ARS entities from parent hierarchies - no level type filter, so the full ancestor chain contributes
        acc.analysisMethods = [
            ...acc.analysisMethods,
            ...(ph.analysisMethods ?? []).filter((am)=>!acc.analysisMethods.some((a)=>a.name === am.name)).map((am)=>({
                    ...am,
                    fromHierarchyId: ph.id
                }))
        ];
        // Add ARS entities from parent hierarchies
        if (currentTlfType === ph.tlfType) {
            acc.analysisSets = [
                ...acc.analysisSets,
                ...(ph.analysisSets ?? []).filter((ans)=>!acc.analysisSets.some((a)=>a.name === ans.name)).map((as)=>({
                        ...as,
                        fromHierarchyId: ph.id
                    }))
            ];
            acc.dataSubsets = [
                ...acc.dataSubsets,
                ...(ph.dataSubsets ?? []).filter((ds)=>!acc.dataSubsets.some((d)=>d.name === ds.name)).map((ds)=>({
                        ...ds,
                        fromHierarchyId: ph.id
                    }))
            ];
            acc.groupingFactors = [
                ...acc.groupingFactors,
                ...(ph.groupingFactors ?? []).filter((gf)=>!acc.groupingFactors.some((g)=>g.name === gf.name)).map((gf)=>({
                        ...gf,
                        fromHierarchyId: ph.id
                    }))
            ];
        }
        return acc;
    }, {
        clinicalDatasets: [],
        clinicalCodeLists: [],
        clinicalValueLists: [],
        clinicalComments: [],
        clinicalMethods: [],
        clinicalWhereClauses: [],
        domainReplacements: [],
        lists: [],
        rowGroups: [],
        singles: [],
        analysisSets: [],
        analysisMethods: [],
        caseWhenConditions: [],
        dataSubsets: [],
        groupingFactors: []
    });
};

});
parcelRegister("bkN8u", function(module, exports) {

$parcel$export(module.exports, "getThisAndParentHierarchies", function () { return $f6699047b38d16ce$export$ce82dff99bac84cc; });

var $4lHS7 = parcelRequire("4lHS7");
const $f6699047b38d16ce$export$ce82dff99bac84cc = (id, hierarchyNodes)=>{
    const ret = [];
    // Get first node
    let current = hierarchyNodes.find((h)=>h.id === id && h.level !== (0, $4lHS7.eHierarchyLevel).TopLevel);
    // Loop through parents
    while(current){
        ret.push(current);
        current = hierarchyNodes.find((h)=>h.id === current.parentId && h.level !== (0, $4lHS7.eHierarchyLevel).TopLevel);
    }
    return ret;
};

});

parcelRegister("dzXQW", function(module, exports) {

$parcel$export(module.exports, "getHierarchyTlfType", function () { return $59bbf81d088f2f91$export$2a23292893528fc; });

var $4lHS7 = parcelRequire("4lHS7");

var $8VrYk = parcelRequire("8VrYk");
/**
 * The hierarchy levels that are classified as Template-type levels. All other levels
 * (Study, Report) are classified as Shell-type levels.
 */ const $59bbf81d088f2f91$var$templateLevels = [
    (0, $4lHS7.eHierarchyLevel).TopLevel,
    (0, $4lHS7.eHierarchyLevel).Corporate,
    (0, $4lHS7.eHierarchyLevel).TA,
    (0, $4lHS7.eHierarchyLevel).Project
];
const $59bbf81d088f2f91$export$2a23292893528fc = (level)=>{
    return $59bbf81d088f2f91$var$templateLevels.includes(level) ? (0, $8VrYk.eTlfType).Template : (0, $8VrYk.eTlfType).Shell;
};

});
parcelRegister("8VrYk", function(module, exports) {

$parcel$export(module.exports, "eTlfType", function () { return $4293cccc698437a7$export$f9a29ff46b9877a8; });
$parcel$export(module.exports, "getAllStyles", function () { return $4293cccc698437a7$export$f54e945d4d58df5e; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
var $4293cccc698437a7$export$f9a29ff46b9877a8 = /*#__PURE__*/ function(eTlfType) {
    eTlfType["Template"] = "Template";
    eTlfType["Shell"] = "Shell";
    return eTlfType;
}({});
const $4293cccc698437a7$export$f54e945d4d58df5e = async (backEndUrl, _, controller)=>{
    const url = `${backEndUrl}Styles`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load styles failed", error);
    }
};

});
parcelRegister("4xeqQ", function(module, exports) {

$parcel$export(module.exports, "processAxiosError", function () { return $baece8b235c89213$export$a55fd5fdaaeb0e70; });

var $ae9tk = parcelRequire("ae9tk");
const $baece8b235c89213$export$a55fd5fdaaeb0e70 = (msg, error)=>{
    // Base error
    let errorText = `${msg}, unknown error`;
    // Check for axios error
    switch(error.response?.status){
        case (0, $ae9tk.HttpStatusCode).TooManyRequests:
            errorText = `${msg}, ${error.response.data?.message ?? "The report you are trying to access is currently in use, please try again later."}`;
            break;
        case (0, $ae9tk.HttpStatusCode).Forbidden:
            errorText = `${msg}, ${error.response.data?.message ?? "access denied"}`;
            break;
        case (0, $ae9tk.HttpStatusCode).BadRequest:
            {
                const data = error.response.data;
                const message = typeof data === "string" ? data : data?.message;
                errorText = `${msg}${message ? `, ${message}` : ""}`;
            }
            break;
        case (0, $ae9tk.HttpStatusCode).InternalServerError:
            errorText = `${msg}, server error`;
            break;
        default:
            switch(error.code){
                case "ERR_NETWORK":
                    errorText = `${msg}, network error`;
                    break;
                case "ERR_CANCELED":
                    errorText = `${msg}, request cancelled`;
                    break;
                case "ERR_BAD_RESPONSE":
                    errorText = `${msg}, server error`;
                    break;
                case "ERR_BAD_REQUEST":
                    {
                        errorText = `${msg}`;
                        const badRequestMessage = error.response.data?.message ?? "";
                        if (badRequestMessage !== "") errorText += `, ${badRequestMessage}`;
                    }
                    break;
                default:
                    if (error.message) errorText = `${msg}, ${error.message}`;
            }
            break;
    }
    return {
        success: false,
        errorText: errorText
    };
};

});



parcelRegister("fAVrY", function(module, exports) {

$parcel$export(module.exports, "mergeClinicalLibraryData", function () { return $395e313453acd48c$export$b9a2f7993287c44; });
const $395e313453acd48c$export$b9a2f7993287c44 = (acc, clinicalLibrary)=>{
    // Add clinical datasets
    const clinicalDatasets = [
        ...acc.clinicalDatasets,
        ...clinicalLibrary.clinicalDatasets.filter((dataset)=>!acc.clinicalDatasets.some((d)=>d.oid === dataset.oid))
    ];
    // Add clinical code lists
    const clinicalCodeLists = [
        ...acc.clinicalCodeLists,
        ...clinicalLibrary.clinicalCodeLists.filter((codeList)=>!acc.clinicalCodeLists.some((cl)=>cl.oid === codeList.oid))
    ];
    // Add clinical value lists
    const clinicalValueLists = [
        ...acc.clinicalValueLists,
        ...clinicalLibrary.clinicalValueLists.filter((valueList)=>!acc.clinicalValueLists.some((vl)=>vl.oid === valueList.oid))
    ];
    // Add clinical comments
    const clinicalComments = [
        ...acc.clinicalComments,
        ...clinicalLibrary.clinicalComments.filter((comment)=>!acc.clinicalComments.some((c)=>c.oid === comment.oid))
    ];
    // Add clinical methods
    const clinicalMethods = [
        ...acc.clinicalMethods,
        ...clinicalLibrary.clinicalMethods.filter((method)=>!acc.clinicalMethods.some((m)=>m.oid === method.oid))
    ];
    // Add clinical where clauses
    const clinicalWhereClauses = [
        ...acc.clinicalWhereClauses,
        ...clinicalLibrary.clinicalWhereClauses.filter((whereClause)=>!acc.clinicalWhereClauses.some((wc)=>wc.oid === whereClause.oid))
    ];
    return {
        clinicalDatasets: clinicalDatasets,
        clinicalCodeLists: clinicalCodeLists,
        clinicalValueLists: clinicalValueLists,
        clinicalComments: clinicalComments,
        clinicalMethods: clinicalMethods,
        clinicalWhereClauses: clinicalWhereClauses
    };
};

});



parcelRegister("74NRg", function(module, exports) {

$parcel$export(module.exports, "hcr_addSingleReplacement", function () { return $7a5fbcdf73b362b5$export$34c8489a963a8cfe; });

var $8apm4 = parcelRequire("8apm4");
const $7a5fbcdf73b362b5$export$34c8489a963a8cfe = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    if (state.hierarchy.singles.some((single)=>single.airid === action.single.airid)) return state;
    return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: [
                ...state.hierarchy.singles,
                action.single
            ]
        }
    }, action);
};

});

parcelRegister("cOMZi", function(module, exports) {

$parcel$export(module.exports, "hcr_clearHierarchy", function () { return $263b412628aff713$export$3fbad32e71c0faaa; });

var $4W4lB = parcelRequire("4W4lB");
const $263b412628aff713$export$3fbad32e71c0faaa = (state)=>{
    return {
        ...(0, $4W4lB.hierarchyInitialState),
        hierarchyNodes: state.hierarchyNodes
    };
};

});

parcelRegister("c9VC0", function(module, exports) {

$parcel$export(module.exports, "hcr_loadClinicalLibrary", function () { return $73605c32b322f9cc$export$f434806804f769fe; });

var $dzXQW = parcelRequire("dzXQW");

var $fAVrY = parcelRequire("fAVrY");
const $73605c32b322f9cc$export$f434806804f769fe = (state, action)=>{
    if (action.clinicalLibrary.length === 0) return {
        ...state,
        isClinicalLibraryLoading: false
    };
    const updatedHierarchyNodes = state.hierarchyNodes.map((hn)=>{
        const matchingLibrary = action.clinicalLibrary.find((cl)=>cl.hierarchyId === hn.id);
        if (matchingLibrary) return {
            ...hn,
            clinicalLibrary: matchingLibrary
        };
        return hn;
    });
    const matchingHierarchyLibrary = state.hierarchy ? action.clinicalLibrary.find((cl)=>cl.hierarchyId === state.hierarchy?.id) : undefined;
    const updatedHierarchy = state.hierarchy && matchingHierarchyLibrary ? {
        ...state.hierarchy,
        clinicalLibrary: matchingHierarchyLibrary
    } : state.hierarchy;
    if (!state.hierarchy) return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        isClinicalLibraryLoading: false
    };
    const currentHierarchy = state.hierarchy;
    const thisTlfType = (0, $dzXQW.getHierarchyTlfType)(currentHierarchy.level);
    const relevantLibraries = action.clinicalLibrary.filter((cl)=>cl.hierarchyId !== currentHierarchy.id && (0, $dzXQW.getHierarchyTlfType)(cl.hierarchyLevel) === thisTlfType && updatedHierarchyNodes.some((hn)=>hn.id === cl.hierarchyId));
    const clinicalTemplates = relevantLibraries.reduce((acc, clinicalLibrary)=>(0, $fAVrY.mergeClinicalLibraryData)(acc, clinicalLibrary), {
        clinicalDatasets: [
            ...state.parentTemplates.clinicalDatasets
        ],
        clinicalCodeLists: [
            ...state.parentTemplates.clinicalCodeLists
        ],
        clinicalValueLists: [
            ...state.parentTemplates.clinicalValueLists
        ],
        clinicalComments: [
            ...state.parentTemplates.clinicalComments
        ],
        clinicalMethods: [
            ...state.parentTemplates.clinicalMethods
        ],
        clinicalWhereClauses: [
            ...state.parentTemplates.clinicalWhereClauses
        ]
    });
    return {
        ...state,
        hierarchyNodes: updatedHierarchyNodes,
        hierarchy: updatedHierarchy,
        isClinicalLibraryLoading: false,
        parentTemplates: {
            ...clinicalTemplates,
            domainReplacements: [
                ...state.parentTemplates.domainReplacements
            ],
            lists: [
                ...state.parentTemplates.lists
            ],
            rowGroups: [
                ...state.parentTemplates.rowGroups
            ],
            singles: [
                ...state.parentTemplates.singles
            ],
            analysisSets: [
                ...state.parentTemplates.analysisSets
            ],
            analysisMethods: [
                ...state.parentTemplates.analysisMethods
            ],
            dataSubsets: [
                ...state.parentTemplates.dataSubsets
            ],
            groupingFactors: [
                ...state.parentTemplates.groupingFactors
            ]
        }
    };
};

});

parcelRegister("6m6iW", function(module, exports) {

$parcel$export(module.exports, "hcr_loadHierarchy", function () { return $b583efb13a26036d$export$e2294dfdfcd7c99b; });

var $4lHS7 = parcelRequire("4lHS7");

var $eBlbF = parcelRequire("eBlbF");

var $d5FRF = parcelRequire("d5FRF");

var $hUmQb = parcelRequire("hUmQb");
const $b583efb13a26036d$export$e2294dfdfcd7c99b = (state, action)=>{
    const hierarchyNodes = [
        ...state.hierarchyNodes.filter((h)=>![
                ...action.hierarchyNodes.map((hn)=>hn.id),
                action.hierarchy.id
            ].includes(h.id)),
        action.hierarchy,
        ...action.hierarchyNodes.filter((h)=>h.level !== (0, $4lHS7.eHierarchyLevel).TopLevel)
    ];
    const commentPanelStatus = state.commentPanelStatus.showComments ? {
        showComments: false,
        highlightCommentId: "",
        activeRelatedTo: "",
        commentFilter: "all"
    } : state.commentPanelStatus;
    return {
        ...state,
        changed: false,
        id: action.hierarchy.id,
        hierarchy: action.hierarchy,
        savedHierarchy: (0, $eBlbF.cloneDeep)(action.hierarchy),
        isNameChanged: false,
        prefix: (0, $d5FRF.getHierarchyPrefix)(action.hierarchy.level),
        hierarchyNodes: hierarchyNodes,
        parentTemplates: (0, $hUmQb.hcr_buildParentTemplates)(action.hierarchy, hierarchyNodes),
        accessRights: action.accessRights,
        tlfItemIndex: action.hierarchy.id === state.hierarchy?.id ? state.tlfItemIndex : null,
        isSubscribed: action.isSubscribed,
        commentPanelStatus: commentPanelStatus
    };
};

});
parcelRegister("d5FRF", function(module, exports) {

$parcel$export(module.exports, "getHierarchyPrefix", function () { return $f24155798f96b8ec$export$6b93194f3da1639a; });

var $4lHS7 = parcelRequire("4lHS7");
const $f24155798f96b8ec$export$6b93194f3da1639a = (type)=>{
    switch(type){
        case (0, $4lHS7.eHierarchyLevel).Report:
        case (0, $4lHS7.eHierarchy).Report:
            return "R";
        case (0, $4lHS7.eHierarchyLevel).Study:
        case (0, $4lHS7.eHierarchy).StudyDirectory:
            return "S";
        case (0, $4lHS7.eHierarchy).Directory:
        case (0, $4lHS7.eHierarchy).TopLevel:
        case (0, $4lHS7.eHierarchyLevel).TopLevel:
        case (0, $4lHS7.eHierarchyLevel).Corporate:
        case (0, $4lHS7.eHierarchyLevel).TA:
        case (0, $4lHS7.eHierarchyLevel).Project:
        case undefined:
        default:
            return "H";
    }
};

});


parcelRegister("fn3Te", function(module, exports) {

$parcel$export(module.exports, "hcr_patchHierarchyComments", function () { return $efd46a73c140d342$export$fa1003f096db3dbf; });

var $8BrMb = parcelRequire("8BrMb");

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $8apm4 = parcelRequire("8apm4");
const $efd46a73c140d342$export$fa1003f096db3dbf = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const commentsPatch = action.patch;
    /* istanbul ignore else */ if (commentsPatch.length > 0) {
        const newComments = (0, $eBlbF.cloneDeep)(state.hierarchy.comments).sort((0, $8BrMb.sortCommentsAscending));
        (0, $3ew5o.applyPatch)(newComments, commentsPatch);
        return (0, $8apm4.hcr_updateChangedFlag)({
            ...state,
            hierarchy: {
                ...state.hierarchy,
                comments: newComments
            }
        }, action);
    }
    return state;
};

});
parcelRegister("8BrMb", function(module, exports) {

$parcel$export(module.exports, "sortComments", function () { return $fa4ef60e9997cebe$export$6d9937f48401e58a; });
$parcel$export(module.exports, "sortCommentsAscending", function () { return $fa4ef60e9997cebe$export$1d50cb8071ce747e; });
const $fa4ef60e9997cebe$export$6d9937f48401e58a = (a, b)=>{
    return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};
const $fa4ef60e9997cebe$export$1d50cb8071ce747e = (a, b)=>{
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
};

});


parcelRegister("1XCiH", function(module, exports) {

$parcel$export(module.exports, "hcr_removeDomainReplacement", function () { return $92dc2fa7ec67097d$export$878863058d2e2b5; });

var $8apm4 = parcelRequire("8apm4");
const $92dc2fa7ec67097d$export$878863058d2e2b5 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.domainReplacements.findIndex((dr)=>dr.airid === action.domainReplacement.airid);
    if (ix > -1) return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: state.hierarchy.domainReplacements.filter((dr)=>dr.airid !== action.domainReplacement.airid)
        }
    }, action);
    return state;
};

});

parcelRegister("iAlxu", function(module, exports) {

$parcel$export(module.exports, "hcr_removeHierarchyComment", function () { return $971cc6b082bdadd8$export$8345555f51e6810a; });

var $8apm4 = parcelRequire("8apm4");
const $971cc6b082bdadd8$export$8345555f51e6810a = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            comments: state.hierarchy.comments.filter((c)=>c.id !== action.commentId)
        }
    }, action);
};

});

parcelRegister("dqZe8", function(module, exports) {

$parcel$export(module.exports, "hcr_removeHierarchyNode", function () { return $0be00863f254c8f5$export$e73995fd5cd4a52a; });
const $0be00863f254c8f5$export$e73995fd5cd4a52a = (state, action)=>({
        ...state,
        hierarchyNodes: state.hierarchyNodes.filter((hn)=>hn.id !== action.hierarchyId)
    });

});

parcelRegister("8yz5e", function(module, exports) {

$parcel$export(module.exports, "hcr_removeSingleReplacement", function () { return $6fa5d09d4b00b6d4$export$7b2a51d8d75587d4; });

var $8apm4 = parcelRequire("8apm4");
const $6fa5d09d4b00b6d4$export$7b2a51d8d75587d4 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.singles.findIndex((s)=>s.airid === action.single.airid);
    if (ix > -1) return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: state.hierarchy.singles.filter((s)=>s.airid !== action.single.airid)
        }
    }, action);
    return state;
};

});

parcelRegister("h0kLA", function(module, exports) {

$parcel$export(module.exports, "hcr_saveHierarchyCompleted", function () { return $52cd4d2a34e36911$export$e52ae9003a99ba3e; });

var $0eakK = parcelRequire("0eakK");

var $6m6iW = parcelRequire("6m6iW");
const $52cd4d2a34e36911$export$e52ae9003a99ba3e = (state, action)=>{
    const filteredHierarchyNodes = [
        ...state.hierarchyNodes.filter((hn)=>hn.id !== action.hierarchy.id && hn.id !== action.oldHierarchyId).map((hn)=>{
            if (action.oldHierarchyId && hn.id === action.hierarchy.parentId) return {
                ...hn,
                children: [
                    ...hn.children.filter((cid)=>cid.id !== action.oldHierarchyId),
                    {
                        id: action.hierarchy.id,
                        hierarchyTag: hn.hierarchyTag,
                        level: hn.level,
                        name: action.hierarchy.name,
                        parentTag: hn.parentTag,
                        type: hn.type,
                        tocMajorVersion: action.hierarchy.tocMajorVersion,
                        tocMinorVersion: action.hierarchy.tocMinorVersion
                    }
                ]
            };
            return hn;
        }),
        action.hierarchy
    ];
    const loadLikeAction = {
        operation: (0, $0eakK.LOAD_HIERARCHY),
        hierarchy: action.hierarchy,
        hierarchyNodes: [],
        accessRights: state.accessRights,
        isSubscribed: state.isSubscribed
    };
    const loadedState = (0, $6m6iW.hcr_loadHierarchy)({
        ...state,
        hierarchyNodes: filteredHierarchyNodes
    }, loadLikeAction);
    return {
        ...loadedState,
        isNameChanged: false,
        doTocSave: false,
        hierarchyNodes: filteredHierarchyNodes
    };
};

});

parcelRegister("5bCbF", function(module, exports) {

$parcel$export(module.exports, "hcr_saveHierarchyFailed", function () { return $be57d1506ccf4267$export$9d61445d901f8233; });
const $be57d1506ccf4267$export$9d61445d901f8233 = (state)=>({
        ...state,
        doTocSave: false,
        saveTocDescription: undefined
    });

});

parcelRegister("4t0nF", function(module, exports) {

$parcel$export(module.exports, "hcr_saveTocMajorVersion", function () { return $228b19069aef5cd5$export$5f26c6cd46f36614; });
const $228b19069aef5cd5$export$5f26c6cd46f36614 = (state, action)=>({
        ...state,
        doTocSave: true,
        saveTocDescription: action.saveTocDescription,
        hierarchyNodes: state.hierarchyNodes.filter((hn)=>hn.id !== action.oldHierarchyId)
    });

});

parcelRegister("6tZYZ", function(module, exports) {

$parcel$export(module.exports, "hcr_setAccessRights", function () { return $a9d162fa4b2b331a$export$665db080416fe367; });
const $a9d162fa4b2b331a$export$665db080416fe367 = (state, action)=>({
        ...state,
        accessRights: action.accessRights,
        doGetAccessRights: false
    });

});

parcelRegister("148VJ", function(module, exports) {

$parcel$export(module.exports, "hcr_setClinicalLibraryLoading", function () { return $3c42730bea82928c$export$160ed4ec6785ce84; });
const $3c42730bea82928c$export$160ed4ec6785ce84 = (state, action)=>({
        ...state,
        isClinicalLibraryLoading: action.isClinicalLibraryLoading
    });

});

parcelRegister("bLA9d", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchyCommentPanel", function () { return $075f57af4114c2a8$export$9b7ea640d911e0e1; });
const $075f57af4114c2a8$export$9b7ea640d911e0e1 = (state, action)=>({
        ...state,
        commentPanelStatus: {
            ...state.commentPanelStatus,
            ...action.commentPanelStatus
        }
    });

});

parcelRegister("cK7Ef", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchyId", function () { return $874703f651f89bc6$export$b92f04a6e50f033e; });
const $874703f651f89bc6$export$b92f04a6e50f033e = (state, action)=>({
        ...state,
        id: action.hierarchyId
    });

});

parcelRegister("2NWpy", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySaveRequestStatus", function () { return $a5befaf914381901$export$450b53273f39217d; });
const $a5befaf914381901$export$450b53273f39217d = (state, action)=>action.expectedCancel && state.saveRequestStatus.cancel !== action.expectedCancel ? state : {
        ...state,
        saveRequestStatus: action.saveRequestStatus
    };

});

parcelRegister("jvPQV", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySaveTocRequestStatus", function () { return $11464b9223d2f58f$export$9c5154ece3fcf2c6; });
const $11464b9223d2f58f$export$9c5154ece3fcf2c6 = (state, action)=>({
        ...state,
        saveTocRequestStatus: action.saveTocRequestStatus
    });

});

parcelRegister("eKeed", function(module, exports) {

$parcel$export(module.exports, "hcr_setHierarchySubscriptionStatus", function () { return $57da974b70ae4e56$export$401c19560aaf0b70; });
const $57da974b70ae4e56$export$401c19560aaf0b70 = (state, action)=>({
        ...state,
        isSubscribed: action.isSubscribed
    });

});

parcelRegister("5dGw6", function(module, exports) {

$parcel$export(module.exports, "hcr_updateDomainReplacement", function () { return $def9adf705fac67d$export$9c8b9b5d0dd030a1; });

var $8apm4 = parcelRequire("8apm4");
const $def9adf705fac67d$export$9c8b9b5d0dd030a1 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.domainReplacements.findIndex((dr)=>dr.airid === action.domainReplacement.airid);
    if (ix > -1) return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            domainReplacements: state.hierarchy.domainReplacements.map((dr)=>dr.airid === action.domainReplacement.airid ? action.domainReplacement : dr)
        }
    }, action);
    return state;
};

});

parcelRegister("8v0hS", function(module, exports) {

$parcel$export(module.exports, "hcr_updateHierarchy", function () { return $c92c1e6332847904$export$bc351d584c8a03db; });

var $eBlbF = parcelRequire("eBlbF");

var $8apm4 = parcelRequire("8apm4");
const $c92c1e6332847904$export$bc351d584c8a03db = (state, action)=>{
    if (action.expectedHierarchyId !== undefined && state.hierarchy?.id !== action.expectedHierarchyId) return state;
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const newState = {
        ...state,
        hierarchy: {
            ...state.hierarchy,
            ...action.hierarchy
        },
        isNameChanged: typeof action.isNameChanged === "boolean" ? action.isNameChanged : state.isNameChanged
    };
    if (action.savedHierarchy) newState.savedHierarchy = (0, $eBlbF.cloneDeep)(action.savedHierarchy);
    return (0, $8apm4.hcr_updateChangedFlag)(newState, action);
};

});

parcelRegister("93lQV", function(module, exports) {

$parcel$export(module.exports, "hcr_updateHierarchyComment", function () { return $fdbcd667a38222ef$export$2aff6d62e3e3128c; });

var $8apm4 = parcelRequire("8apm4");
const $fdbcd667a38222ef$export$2aff6d62e3e3128c = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            comments: [
                ...state.hierarchy.comments.filter((c)=>c.id !== action.comment.id),
                action.comment
            ]
        }
    }, action);
};

});

parcelRegister("1hz5x", function(module, exports) {

$parcel$export(module.exports, "hcr_updateSingleReplacements", function () { return $7d2267ed304bd26a$export$7a9546419291dc25; });

var $8apm4 = parcelRequire("8apm4");
const $7d2267ed304bd26a$export$7a9546419291dc25 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    const ix = state.hierarchy.singles.findIndex((s)=>s.airid === action.single.airid);
    if (ix > -1) return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            singles: state.hierarchy.singles.map((s)=>s.airid === action.single.airid ? action.single : s)
        }
    }, action);
    return state;
};

});

parcelRegister("l8e1b", function(module, exports) {

$parcel$export(module.exports, "hcr_updateTlfItemIndex", function () { return $b4f7c874528e8b19$export$95eac10549f91727; });

var $8apm4 = parcelRequire("8apm4");
const $b4f7c874528e8b19$export$95eac10549f91727 = (state, action)=>{
    if (!state.hierarchy) throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);
    return (0, $8apm4.hcr_updateChangedFlag)({
        ...state,
        hierarchy: {
            ...state.hierarchy,
            tocMinorVersion: action.tocMinorVersion
        },
        tlfItemIndex: action.tlfItemIndex
    }, action);
};

});


parcelRegister("fi705", function(module, exports) {
$parcel$export(module.exports, "tlf_activateVariantPatch", function () { return (parcelRequire("9peQn")).tlf_activateVariantPatch; });
$parcel$export(module.exports, "tlf_addReceivedMessage", function () { return (parcelRequire("3bTEh")).tlf_addReceivedMessage; });
$parcel$export(module.exports, "tlf_applyVariantTemplate", function () { return (parcelRequire("8BVnE")).tlf_applyVariantTemplate; });
$parcel$export(module.exports, "tlf_cancelVariantPatchCreation", function () { return (parcelRequire("hDW0t")).tlf_cancelVariantPatchCreation; });
$parcel$export(module.exports, "tlf_clearTlf", function () { return (parcelRequire("6g7jD")).tlf_clearTlf; });
$parcel$export(module.exports, "tlf_closeModalWindow", function () { return (parcelRequire("iQCBi")).tlf_closeModalWindow; });
$parcel$export(module.exports, "tlf_createVariantPatch", function () { return (parcelRequire("licSs")).tlf_createVariantPatch; });
$parcel$export(module.exports, "tlf_loadTlf", function () { return (parcelRequire("eFCJ9")).tlf_loadTlf; });
$parcel$export(module.exports, "tlf_patchTlfComments", function () { return (parcelRequire("izwfU")).tlf_patchTlfComments; });
$parcel$export(module.exports, "tlf_processSignalrNotification", function () { return (parcelRequire("79ZAU")).tlf_processSignalrNotification; });
$parcel$export(module.exports, "tlf_removeTlfComment", function () { return (parcelRequire("jYtAo")).tlf_removeTlfComment; });
$parcel$export(module.exports, "tlf_removeVariantPatch", function () { return (parcelRequire("imj4N")).tlf_removeVariantPatch; });
$parcel$export(module.exports, "tlf_removeVariantTemplate", function () { return (parcelRequire("h8Dcs")).tlf_removeVariantTemplate; });
$parcel$export(module.exports, "tlf_renameVariantPatch", function () { return (parcelRequire("5K8cU")).tlf_renameVariantPatch; });
$parcel$export(module.exports, "tlf_renameVariantTemplate", function () { return (parcelRequire("aZkQ1")).tlf_renameVariantTemplate; });
$parcel$export(module.exports, "tlf_revertToVariantMaster", function () { return (parcelRequire("BtObB")).tlf_revertToVariantMaster; });
$parcel$export(module.exports, "tlf_setCreateVariantPatchWindow", function () { return (parcelRequire("hYxsn")).tlf_setCreateVariantPatchWindow; });
$parcel$export(module.exports, "tlf_setEditorBlocksSearchPanel", function () { return (parcelRequire("cKin3")).tlf_setEditorBlocksSearchPanel; });
$parcel$export(module.exports, "tlf_setTlfCommentPanel", function () { return (parcelRequire("aefxR")).tlf_setTlfCommentPanel; });
$parcel$export(module.exports, "tlf_setTlfReadOnly", function () { return (parcelRequire("gO34q")).tlf_setTlfReadOnly; });
$parcel$export(module.exports, "tlf_setTlfSubscriptionStatus", function () { return (parcelRequire("8unDl")).tlf_setTlfSubscriptionStatus; });
$parcel$export(module.exports, "tlf_setVariantCreationMode", function () { return (parcelRequire("dXplA")).tlf_setVariantCreationMode; });
$parcel$export(module.exports, "tlf_setVariantPatchSelection", function () { return (parcelRequire("86Xek")).tlf_setVariantPatchSelection; });
$parcel$export(module.exports, "tlf_setViewMode", function () { return (parcelRequire("4qS4e")).tlf_setViewMode; });
$parcel$export(module.exports, "tlf_showModalWindow", function () { return (parcelRequire("2kXh8")).tlf_showModalWindow; });
$parcel$export(module.exports, "tlf_toggleTrafficLights", function () { return (parcelRequire("aO7iy")).tlf_toggleTrafficLights; });
$parcel$export(module.exports, "tlf_toggleVariantPatch", function () { return (parcelRequire("6dv42")).tlf_toggleVariantPatch; });
$parcel$export(module.exports, "tlf_trackActiveVariantPatch", function () { return (parcelRequire("6OvqD")).tlf_trackActiveVariantPatch; });
$parcel$export(module.exports, "tlf_updateTlf", function () { return (parcelRequire("jPTUt")).tlf_updateTlf; });
$parcel$export(module.exports, "tlf_updateTlfComment", function () { return (parcelRequire("djMm9")).tlf_updateTlfComment; });
$parcel$export(module.exports, "tlf_upsertVariantTemplate", function () { return (parcelRequire("jIhEp")).tlf_upsertVariantTemplate; });
parcelRequire("9peQn");
parcelRequire("3bTEh");
parcelRequire("8BVnE");
parcelRequire("hDW0t");
parcelRequire("6g7jD");
parcelRequire("iQCBi");
parcelRequire("licSs");
parcelRequire("eFCJ9");
parcelRequire("izwfU");
parcelRequire("79ZAU");
parcelRequire("jYtAo");
parcelRequire("imj4N");
parcelRequire("h8Dcs");
parcelRequire("5K8cU");
parcelRequire("aZkQ1");
parcelRequire("BtObB");
parcelRequire("hYxsn");
parcelRequire("cKin3");
parcelRequire("aefxR");
parcelRequire("gO34q");
parcelRequire("8unDl");
parcelRequire("dXplA");
parcelRequire("86Xek");
parcelRequire("4qS4e");
parcelRequire("2kXh8");
parcelRequire("aO7iy");
parcelRequire("6dv42");
parcelRequire("6OvqD");
parcelRequire("jPTUt");
parcelRequire("djMm9");
parcelRequire("jIhEp");

});
parcelRegister("9peQn", function(module, exports) {

$parcel$export(module.exports, "tlf_activateVariantPatch", function () { return $b3b824030458b9ef$export$3422aa9759dc9863; });

var $kKLWF = parcelRequire("kKLWF");

var $2Mlm8 = parcelRequire("2Mlm8");

var $dXplA = parcelRequire("dXplA");

var $86Xek = parcelRequire("86Xek");

var $ea3F0 = parcelRequire("ea3F0");
const $b3b824030458b9ef$export$3422aa9759dc9863 = (state, action)=>{
    if (!state.appliedVariantPatches.includes(action.patchName)) return state;
    const { state: committedState, catalog: catalog } = (0, $kKLWF.commitActivePatch)(state, action.calledFrom);
    if (catalog === null) return committedState;
    const creationState = (0, $dXplA.tlf_setVariantCreationMode)(committedState, {
        operation: (0, $2Mlm8.SET_VARIANT_CREATION_VIEW),
        variantCreationView: true,
        calledFrom: action.calledFrom
    });
    const newState = (0, $86Xek.tlf_setVariantPatchSelection)(creationState, {
        operation: (0, $2Mlm8.SET_VARIANT_PATCH_SELECTION),
        appliedPatchNames: state.appliedVariantPatches,
        activePatchName: action.patchName,
        calledFrom: action.calledFrom
    });
    return (0, $ea3F0.updateActivePatchErrors)(newState);
};

});
parcelRegister("kKLWF", function(module, exports) {

$parcel$export(module.exports, "commitActivePatch", function () { return $77d12c5479bb88b3$export$54f0505b2bac502d; });

var $eBlbF = parcelRequire("eBlbF");

var $fWOjh = parcelRequire("fWOjh");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");
const $77d12c5479bb88b3$export$54f0505b2bac502d = (state, calledFrom)=>{
    const { information: information } = (0, $6RNmK.getVariantPatchContext)(state);
    const activeName = state.activeVariantPatchName;
    if (information === null || activeName === null) return {
        state: state,
        catalog: information?.allVariantPatches ?? {}
    };
    const result = (0, $fWOjh.getActivePatchResult)(state, (0, $6RNmK.getVariantPatchContext)(state));
    if (result === null || result.invalidOps.length > 0) return {
        state: state,
        catalog: null
    };
    const catalog = {
        ...information.allVariantPatches,
        [activeName]: result.patch
    };
    if ((0, $eBlbF.isEqual)(catalog, information.allVariantPatches)) return {
        state: state,
        catalog: catalog
    };
    return {
        state: (0, $jPTUt.tlf_updateTlf)(state, {
            operation: (0, $2Mlm8.UPDATE_TLF),
            tlfData: {
                allVariantPatches: catalog
            },
            calledFrom: calledFrom
        }),
        catalog: catalog
    };
};

});
parcelRegister("fWOjh", function(module, exports) {

$parcel$export(module.exports, "getActivePatchResult", function () { return $b3b278d4136b0bb3$export$7360ef81f072e16d; });

var $3JMQg = parcelRequire("3JMQg");

var $5Cujf = parcelRequire("5Cujf");
const $b3b278d4136b0bb3$export$7360ef81f072e16d = (state, context)=>{
    const { master: master, currentMaster: currentMaster, information: information } = context;
    const activeName = state.activeVariantPatchName;
    if (master === null || currentMaster === null || information === null || activeName === null) return null;
    const base = (0, $3JMQg.applyVariantPatches)(master, information, state.appliedVariantPatches.filter((name)=>name !== activeName));
    // Applied patch selections are validated before an active patch is edited.
    // istanbul ignore next
    if (!base.success) return null;
    return (0, $5Cujf.buildVariantPatch)(base.data, currentMaster);
};

});
parcelRegister("3JMQg", function(module, exports) {

$parcel$export(module.exports, "applyVariantPatches", function () { return $ada19de3900915a6$export$8683ae0e29cef201; });

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $2gZen = parcelRequire("2gZen");

var $f37gm = parcelRequire("f37gm");
const $ada19de3900915a6$export$8683ae0e29cef201 = (master, variantInformation, patchNames)=>{
    const conflicts = (0, $2gZen.findVariantPatchConflicts)(variantInformation, patchNames);
    if (conflicts.length > 0) return {
        success: false,
        conflict: conflicts[0]
    };
    const current = (0, $eBlbF.cloneDeep)(master);
    const selectedNames = new Set(patchNames);
    const orderedPatchNames = Object.keys(variantInformation.allVariantPatches).filter((name)=>selectedNames.has(name));
    for (const name of orderedPatchNames){
        const patch = variantInformation.allVariantPatches[name];
        if ((0, $f37gm.isVariantPatch)(patch)) {
            const errors = (0, $3ew5o.applyPatch)(current, patch).filter((error)=>error !== null);
            if (errors.length > 0) return {
                success: false,
                errors: errors
            };
        }
    }
    return {
        success: true,
        data: current
    };
};

});
parcelRegister("2gZen", function(module, exports) {

$parcel$export(module.exports, "findVariantPatchConflicts", function () { return $1afed8bcce7694eb$export$f9d4931683f7fee; });
/**
 * Decode the property levels used to group a JSON Pointer path.
 *
 * @param path - RFC6901 JSON Pointer path
 * @returns The initial property, or the body property and its immediate child
 */ const $1afed8bcce7694eb$var$getPointerTokens = (path)=>path === "" ? [] : path.slice(1).split("/").slice(0, path.startsWith("/body/") ? 2 : 1).map((token)=>token.replace(/~1/g, "/").replace(/~0/g, "~"));
/**
 * Check whether two paths affect the same initial property or immediate body child.
 *
 * @param firstPath - First RFC6901 path
 * @param secondPath - Second RFC6901 path
 * @returns True when the paths overlap
 */ const $1afed8bcce7694eb$var$pathsOverlap = (firstPath, secondPath)=>{
    const firstTokens = $1afed8bcce7694eb$var$getPointerTokens(firstPath);
    const secondTokens = $1afed8bcce7694eb$var$getPointerTokens(secondPath);
    const sharedLength = Math.min(firstTokens.length, secondTokens.length);
    return firstTokens.slice(0, sharedLength).every((token, ix)=>token === secondTokens[ix]);
};
const $1afed8bcce7694eb$export$f9d4931683f7fee = (variantInformation, patchNames)=>{
    const conflicts = [];
    const selectedNames = [
        ...new Set(patchNames)
    ];
    selectedNames.forEach((firstName, firstIx)=>{
        const firstPatch = variantInformation.allVariantPatches[firstName];
        selectedNames.slice(firstIx + 1).forEach((secondName)=>{
            const secondPatch = variantInformation.allVariantPatches[secondName];
            if (firstPatch && secondPatch) firstPatch.forEach((firstOperation)=>{
                secondPatch.forEach((secondOperation)=>{
                    if ($1afed8bcce7694eb$var$pathsOverlap(firstOperation.path, secondOperation.path)) conflicts.push({
                        firstPatchName: firstName,
                        firstPath: firstOperation.path,
                        secondPatchName: secondName,
                        secondPath: secondOperation.path
                    });
                });
            });
        });
    });
    return conflicts;
};

});


parcelRegister("5Cujf", function(module, exports) {

$parcel$export(module.exports, "buildVariantPatch", function () { return $4433f74571833383$export$25e0fe065061b045; });

var $4lHS7 = parcelRequire("4lHS7");

var $h24Ud = parcelRequire("h24Ud");

var $3ew5o = parcelRequire("3ew5o");

var $5e2AG = parcelRequire("5e2AG");
const $4433f74571833383$export$25e0fe065061b045 = (master, current)=>{
    // These objects are resolved from hierarchy IDs for display, not editable TLF content.
    const hydratedKeys = [
        "analysisMethod",
        "groupingFactor",
        "operation"
    ];
    const masterValues = {
        ...(0, $5e2AG.pickVariantUpdateable)(master),
        body: master.type === (0, $4lHS7.eTlfItemType).arsTable ? (0, $h24Ud.omitDeep)(master.body, hydratedKeys) : master.body
    };
    const currentValues = {
        ...(0, $5e2AG.pickVariantUpdateable)(current),
        body: current.type === (0, $4lHS7.eTlfItemType).arsTable ? (0, $h24Ud.omitDeep)(current.body, hydratedKeys) : current.body
    };
    const allOps = (0, $3ew5o.createPatch)(masterValues, currentValues);
    const reverseOps = (0, $3ew5o.createPatch)(currentValues, masterValues);
    return {
        // TODO: Restore or remove these
        // Unsure if there will be invalid patch types at this point,
        // but I would like to have the functionality there just in case
        // patch: allOps.filter((op) => op.op === "remove" || op.op === "replace"),
        // invalidOps: allOps.filter((op) => op.op !== "remove" && op.op !== "replace"),
        patch: allOps.filter(()=>true),
        invalidOps: allOps.filter(()=>false),
        reverseOps: reverseOps
    };
};

});
parcelRegister("5e2AG", function(module, exports) {

$parcel$export(module.exports, "pickVariantUpdateable", function () { return $2ac6dc46fb5c5571$export$1a7a0c44f80c6f65; });

var $ee4vT = parcelRequire("ee4vT");
const $2ac6dc46fb5c5571$export$1a7a0c44f80c6f65 = (tlfItem)=>Object.fromEntries((0, $ee4vT.VARIANT_UPDATEABLE_KEYS).map((key)=>[
            key,
            tlfItem[key]
        ]));

});



parcelRegister("6RNmK", function(module, exports) {

$parcel$export(module.exports, "getVariantPatchContext", function () { return $d83457e399027753$export$c6a474e8d17ff7f4; });

var $3Avah = parcelRequire("3Avah");
const $d83457e399027753$export$c6a474e8d17ff7f4 = (state)=>{
    const master = state.masterTlfData;
    const currentMaster = (0, $3Avah.isArsMasterReadDto)(state.tlfData) ? state.tlfData : null;
    const information = currentMaster === null ? null : {
        allVariantPatches: currentMaster.allVariantPatches,
        variantTemplates: currentMaster.variantTemplates
    };
    return {
        master: master,
        currentMaster: currentMaster,
        information: information
    };
};

});

parcelRegister("jPTUt", function(module, exports) {

$parcel$export(module.exports, "tlf_updateTlf", function () { return $5d49401aa42cc3ec$export$95cad242a2a55eb6; });

var $eBlbF = parcelRequire("eBlbF");

var $3DUZ0 = parcelRequire("3DUZ0");

var $2Mlm8 = parcelRequire("2Mlm8");
const $5d49401aa42cc3ec$export$95cad242a2a55eb6 = (state, action)=>{
    if (!state.tlfData) throw new Error(`tlfContextReducer: ${(0, $2Mlm8.UPDATE_TLF)}: TLF data not set`);
    const newState = {
        ...state
    };
    const newTlfData = {
        ...state.tlfData,
        ...action.tlfData
    };
    newState.tlfData = newTlfData;
    if (action.reset) {
        newState.savedTlfData = (0, $eBlbF.cloneDeep)(newTlfData);
        newState.showModalWindow = "";
        newState.forcePushToParent = true;
    } else if (action.newSavePoint) {
        newState.savedTlfData = (0, $eBlbF.cloneDeep)(newTlfData);
        newState.showModalWindow = "";
        newState.forcePushToParent = true;
    } else if (action.doNotAddUndo) {
        newState.savedTlfData = (0, $eBlbF.cloneDeep)({
            ...state.savedTlfData ?? state.tlfData,
            ...action.tlfData
        });
        newState.forcePushToParent = true;
    }
    (0, $3DUZ0.checkChanged)(newState);
    return newState;
};

});
parcelRegister("3DUZ0", function(module, exports) {

$parcel$export(module.exports, "checkChanged", function () { return $92dc4779b181d11e$export$b7b8859ed511125; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $dbVjd = parcelRequire("dbVjd");

var $5mgHe = parcelRequire("5mgHe");

var $4lHS7 = parcelRequire("4lHS7");

var $eBlbF = parcelRequire("eBlbF");

var $iT4QT = parcelRequire("iT4QT");
/** Derived TLF fields excluded from dirty comparison outside variant patch catalogues. */ const $92dc4779b181d11e$var$excludedFields = new Set([
    "relationships",
    "isLocked",
    "contentProps",
    "coreTrafficLight"
]);
const $92dc4779b181d11e$export$b7b8859ed511125 = (state)=>{
    // Changed memo
    const currentData = (0, $iT4QT.toTlfChangedData)(state.tlfData);
    const savedData = (0, $iT4QT.toTlfChangedData)(state.savedTlfData);
    const current = (0, $5mgHe.omitStaticMetadata)(currentData === null ? null : (0, $eBlbF.omit)(currentData, [
        "comments"
    ]), [], $92dc4779b181d11e$var$excludedFields);
    const saved = (0, $5mgHe.omitStaticMetadata)(savedData === null ? null : (0, $eBlbF.omit)(savedData, [
        "comments"
    ]), [], $92dc4779b181d11e$var$excludedFields);
    const changed = (0, $bX0x9.getObjectDiff)(current, saved);
    // Get changed (unsaved) flag
    state.changed = changed !== undefined;
    // Check if traffic lights should be hidden initially
    if (state.tlfData?.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report && state.tlfData?.coreTrafficLightSwitch === "DoNotCalculate" && ("tocOriginTrafficLight" in state.tlfData ? state.tlfData.tocOriginTrafficLight === "FromScratch" || state.tlfData.tocOriginTrafficLight === "FromBasicLayout" || state.tlfData.type === (0, $4lHS7.eTlfItemType).figure || state.tlfData.type === (0, $4lHS7.eTlfItemType).v1figure : true)) state.showTrafficLights = false;
    // Check if view mode is ok
    if (state.tlfViewMode.showOnlyForTlfTypes && state.tlfData?.type && !state.tlfViewMode.showOnlyForTlfTypes.has(state.tlfData.type)) state.tlfViewMode = (0, $dbVjd.TLF_VIEW_MODES)[0];
};

});
parcelRegister("5mgHe", function(module, exports) {

$parcel$export(module.exports, "omitStaticMetadata", function () { return $edbbaa77f2424518$export$27767089a5736895; });

var $d04Xe = parcelRequire("d04Xe");
const $edbbaa77f2424518$export$27767089a5736895 = (value, path = [], excludedFields)=>{
    if (path.includes("allVariantPatches")) return value;
    if (Array.isArray(value)) return value.map((item, index)=>$edbbaa77f2424518$export$27767089a5736895(item, [
            ...path,
            String(index)
        ], excludedFields));
    if (value !== null && typeof value === "object") {
        const entries = Object.entries(value);
        return Object.fromEntries(entries.filter(([key, item])=>item !== undefined && !(0, $d04Xe.isEditableMetadataPath)([
                ...path,
                key
            ], excludedFields)).map(([key, item])=>[
                key,
                $edbbaa77f2424518$export$27767089a5736895(item, [
                    ...path,
                    key
                ], excludedFields)
            ]));
    }
    return value;
};

});
parcelRegister("d04Xe", function(module, exports) {

$parcel$export(module.exports, "isEditableMetadataPath", function () { return $bf69b476a227b49d$export$74af27975e51b367; });
/** Fields managed by synchronisation, presentation or server save responses. */ const $bf69b476a227b49d$var$ignoredFields = new Set([
    "comments",
    "relationships",
    "isLocked",
    "contentProps",
    "coreTrafficLight",
    "history",
    "saved",
    "changed",
    "inError",
    "updatedAt",
    "updatedBy",
    "tocMinorVersion",
    "studyStandardsDate",
    "clinicalLibrary"
]);
const $bf69b476a227b49d$export$74af27975e51b367 = (segments, excludedFields = $bf69b476a227b49d$var$ignoredFields)=>{
    const catalogueIndex = segments.indexOf("allVariantPatches");
    const domainSegments = catalogueIndex < 0 ? segments : segments.slice(0, catalogueIndex);
    const isDiscussionComments = domainSegments[0] === "tlfData" && domainSegments[1] === "comments" || domainSegments[0] === "hierarchy" && domainSegments[1] === "comments" || domainSegments[0] === "hierarchyNodes" && domainSegments[2] === "comments";
    return excludedFields.has("comments") && isDiscussionComments || domainSegments.some((segment)=>segment !== "comments" && excludedFields.has(segment));
};

});


parcelRegister("iT4QT", function(module, exports) {

$parcel$export(module.exports, "toTlfChangedData", function () { return $05c9a3a602758f09$export$d93d938bbb6aa332; });

var $3Avah = parcelRequire("3Avah");

var $60M0D = parcelRequire("60M0D");
const $05c9a3a602758f09$export$d93d938bbb6aa332 = (data)=>{
    if ((0, $3Avah.isArsMasterReadDto)(data) && Object.keys(data.allVariantPatches).length === 0 && data.variantTemplates.length === 0) return (0, $60M0D.toArsTlfSnapshot)(data);
    return data;
};

});
parcelRegister("60M0D", function(module, exports) {

$parcel$export(module.exports, "toArsTlfSnapshot", function () { return $dfe7d76bfa7717f4$export$a83dfb687c5591d7; });
const $dfe7d76bfa7717f4$export$a83dfb687c5591d7 = (master)=>{
    const { allVariantPatches: _allVariantPatches, variantTemplates: _variantTemplates, ...snapshot } = master;
    return snapshot;
};

});





parcelRegister("dXplA", function(module, exports) {

$parcel$export(module.exports, "tlf_setVariantCreationMode", function () { return $073a84cb5e35eae6$export$52dbad1cfbeae137; });

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $eBlbF = parcelRequire("eBlbF");

var $3DUZ0 = parcelRequire("3DUZ0");

var $60M0D = parcelRequire("60M0D");

var $cQCJN = parcelRequire("cQCJN");
const $073a84cb5e35eae6$export$52dbad1cfbeae137 = (state, action)=>{
    const newState = {
        ...state
    };
    newState.variantCreationView = action.variantCreationView;
    newState.activeVariantPatchName = state.appliedVariantPatches.find((name)=>name === state.activeVariantPatchName) ?? state.appliedVariantPatches[0] ?? null;
    const arsItem = (0, $3Avah.isTlfItemReadDto)(state.tlfData) && (state.tlfData.type === (0, $4lHS7.eTlfItemType).arsTable || state.tlfData.type === (0, $4lHS7.eTlfItemType).arsListing) ? state.tlfData : null;
    if (action.variantCreationView && arsItem) {
        const promoted = (0, $3Avah.isArsMasterReadDto)(arsItem) ? arsItem : {
            ...arsItem,
            allVariantPatches: {},
            variantTemplates: []
        };
        const master = state.appliedVariantPatches.length > 0 ? state.masterTlfData ?? (0, $60M0D.toArsTlfSnapshot)(promoted) : (0, $60M0D.toArsTlfSnapshot)(promoted);
        const current = {
            ...state.appliedVariantPatches.length > 0 ? promoted : master,
            allVariantPatches: promoted.allVariantPatches,
            variantTemplates: promoted.variantTemplates
        };
        newState.tlfData = (0, $eBlbF.cloneDeep)(current);
        newState.masterTlfData = (0, $eBlbF.cloneDeep)(master);
    } else if (state.variantCreationView === true && (0, $3Avah.isArsMasterReadDto)(state.tlfData) && Object.keys(state.tlfData.allVariantPatches).length === 0 && state.tlfData.variantTemplates.length === 0) {
        newState.tlfData = (0, $eBlbF.omit)(state.tlfData, [
            "allVariantPatches",
            "variantTemplates"
        ]);
        newState.masterTlfData = null;
    } else if ((0, $3Avah.isArsMasterReadDto)(state.tlfData)) newState.masterTlfData = (0, $eBlbF.cloneDeep)(state.appliedVariantPatches.length > 0 ? state.masterTlfData ?? (0, $60M0D.toArsTlfSnapshot)(state.tlfData) : (0, $60M0D.toArsTlfSnapshot)(state.tlfData));
    // Presentation-only promotion/demotion must not rewrite the persisted baseline.
    if (newState.tlfData !== state.tlfData) (0, $3DUZ0.checkChanged)(newState);
    return (0, $cQCJN.updateVariantPatchSelection)(newState, state.appliedVariantPatches, newState.activeVariantPatchName);
};

});
parcelRegister("cQCJN", function(module, exports) {

$parcel$export(module.exports, "updateVariantPatchSelection", function () { return $9d469fb68d7b871e$export$9a1790955e8e0aae; });
const $9d469fb68d7b871e$export$9a1790955e8e0aae = (state, appliedPatchNames, activePatchName)=>{
    const appliedVariantPatches = [
        ...appliedPatchNames
    ];
    const nextActivePatchName = appliedPatchNames.length === 0 ? null : activePatchName ?? appliedPatchNames[0];
    return {
        ...state,
        appliedVariantPatches: appliedVariantPatches,
        activeVariantPatchName: nextActivePatchName
    };
};

});


parcelRegister("86Xek", function(module, exports) {

$parcel$export(module.exports, "tlf_setVariantPatchSelection", function () { return $f736a6114c277d00$export$d7b8c35d6d38e758; });

var $cQCJN = parcelRequire("cQCJN");
const $f736a6114c277d00$export$d7b8c35d6d38e758 = (state, action)=>(0, $cQCJN.updateVariantPatchSelection)(state, action.appliedPatchNames, action.activePatchName);

});

parcelRegister("ea3F0", function(module, exports) {

$parcel$export(module.exports, "updateActivePatchErrors", function () { return $6719b23f5ef82ddb$export$6c4835b0d9ee5a29; });

var $eBlbF = parcelRequire("eBlbF");

var $fWOjh = parcelRequire("fWOjh");

var $6RNmK = parcelRequire("6RNmK");
const $6719b23f5ef82ddb$export$6c4835b0d9ee5a29 = (state)=>{
    const result = (0, $fWOjh.getActivePatchResult)(state, (0, $6RNmK.getVariantPatchContext)(state));
    const invalidOps = result?.invalidOps ?? [];
    return (0, $eBlbF.isEqual)(state.activeVariantPatchInvalidOps, invalidOps) ? state : {
        ...state,
        activeVariantPatchInvalidOps: invalidOps
    };
};

});


parcelRegister("3bTEh", function(module, exports) {

$parcel$export(module.exports, "tlf_addReceivedMessage", function () { return $739dfaa24cd70e8d$export$172e2a06c5a427eb; });
const $739dfaa24cd70e8d$export$172e2a06c5a427eb = (state, action)=>{
    const newState = {
        ...state
    };
    if (state.receivedMessages.some((message)=>message.messageId === action.receivedMessage.messageId)) return newState;
    newState.receivedMessages = [
        ...state.receivedMessages,
        {
            messageId: action.receivedMessage.messageId,
            updatedId: action.receivedMessage.groupName,
            updateTS: new Date(action.receivedMessage.timeStamp)
        }
    ];
    return newState;
};

});

parcelRegister("8BVnE", function(module, exports) {

$parcel$export(module.exports, "tlf_applyVariantTemplate", function () { return $95c1797af43df750$export$b08250c2cb1a206; });

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $3JMQg = parcelRequire("3JMQg");

var $fwbcv = parcelRequire("fwbcv");

var $5e2AG = parcelRequire("5e2AG");

var $3DUZ0 = parcelRequire("3DUZ0");

var $60M0D = parcelRequire("60M0D");

var $cQCJN = parcelRequire("cQCJN");
const $95c1797af43df750$export$b08250c2cb1a206 = (state, action)=>{
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    const current = state.tlfData;
    const patchNames = action.patchNames;
    if (state.activeVariantPatchInvalidOps.length > 0 || patchNames.some((name)=>!Object.hasOwn(current.allVariantPatches, name)) || (0, $fwbcv.groupVariantPatches)(current).some((group)=>group.filter((name)=>patchNames.includes(name)).length > 1)) return state;
    const master = current.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report || state.appliedVariantPatches.length > 0 ? state.masterTlfData : (0, $60M0D.toArsTlfSnapshot)(current);
    if (master === null) return state;
    const composed = (0, $3JMQg.applyVariantPatches)(master, current, patchNames);
    if (!composed.success) return state;
    const updated = (0, $cQCJN.updateVariantPatchSelection)({
        ...state,
        tlfData: {
            ...current,
            ...(0, $5e2AG.pickVariantUpdateable)(composed.data)
        },
        masterTlfData: master,
        variantCreationView: false,
        activeVariantPatchInvalidOps: []
    }, patchNames, null);
    (0, $3DUZ0.checkChanged)(updated);
    return updated;
};

});
parcelRegister("fwbcv", function(module, exports) {

$parcel$export(module.exports, "groupVariantPatches", function () { return $cf0e357feacc5518$export$7b9f36f6e7c7f0ce; });

var $2gZen = parcelRequire("2gZen");
const $cf0e357feacc5518$export$7b9f36f6e7c7f0ce = (information)=>{
    const patchNames = Object.keys(information.allVariantPatches);
    const groups = patchNames.map((name)=>[
            name
        ]);
    (0, $2gZen.findVariantPatchConflicts)(information, patchNames).forEach((conflict)=>{
        const firstIndex = groups.findIndex((group)=>group.includes(conflict.firstPatchName));
        const secondIndex = groups.findIndex((group)=>group.includes(conflict.secondPatchName));
        if (firstIndex !== secondIndex) {
            const retainedIndex = Math.min(firstIndex, secondIndex);
            const removedIndex = Math.max(firstIndex, secondIndex);
            groups[retainedIndex].push(...groups[removedIndex]);
            groups.splice(removedIndex, 1);
        }
    });
    return groups.map((group)=>patchNames.filter((name)=>group.includes(name)));
};

});


parcelRegister("hDW0t", function(module, exports) {

$parcel$export(module.exports, "tlf_cancelVariantPatchCreation", function () { return $0bb9e0e31f3f1d7c$export$ff7f322af6c0e641; });

var $3Avah = parcelRequire("3Avah");

var $5e2AG = parcelRequire("5e2AG");

var $eBlbF = parcelRequire("eBlbF");

var $3DUZ0 = parcelRequire("3DUZ0");

var $cQCJN = parcelRequire("cQCJN");
const $0bb9e0e31f3f1d7c$export$ff7f322af6c0e641 = (state)=>{
    let newState = {
        ...state,
        showCreateVariantPatchWindow: false
    };
    if (state.activeVariantPatchName !== null) return newState;
    const current = (0, $3Avah.isArsMasterReadDto)(state.tlfData) ? state.tlfData : null;
    const master = state.masterTlfData;
    if (master === null) return newState;
    const restored = {
        ...current ?? master,
        ...(0, $5e2AG.pickVariantUpdateable)(master),
        allVariantPatches: current?.allVariantPatches ?? {},
        variantTemplates: current?.variantTemplates ?? []
    };
    const isEmptyMaster = Object.keys(restored.allVariantPatches).length === 0 && restored.variantTemplates.length === 0;
    const tlfData = isEmptyMaster ? (0, $eBlbF.omit)(restored, [
        "allVariantPatches",
        "variantTemplates"
    ]) : restored;
    newState = {
        ...newState,
        tlfData: tlfData,
        masterTlfData: isEmptyMaster ? null : (0, $eBlbF.cloneDeep)(master),
        appliedVariantPatches: [],
        activeVariantPatchName: null,
        variantCreationView: false,
        forcePushToParent: true
    };
    const selectedState = (0, $cQCJN.updateVariantPatchSelection)(newState, [], null);
    (0, $3DUZ0.checkChanged)(selectedState);
    return selectedState;
};

});

parcelRegister("6g7jD", function(module, exports) {

$parcel$export(module.exports, "tlf_clearTlf", function () { return $c12938adc9ead19a$export$f8e802e005da8a74; });

var $1L6jF = parcelRequire("1L6jF");
const $c12938adc9ead19a$export$f8e802e005da8a74 = ()=>({
        ...(0, $1L6jF.tlfInitialState)
    });

});

parcelRegister("iQCBi", function(module, exports) {

$parcel$export(module.exports, "tlf_closeModalWindow", function () { return $c23ff0894c6f9eae$export$148267ba3cea07bf; });
const $c23ff0894c6f9eae$export$148267ba3cea07bf = (state)=>{
    const newState = {
        ...state
    };
    newState.showModalWindow = "";
    newState.requestStatus = {
        requesting: false,
        error: false
    };
    return newState;
};

});

parcelRegister("licSs", function(module, exports) {

$parcel$export(module.exports, "tlf_createVariantPatch", function () { return $7cac6e2aa96128dc$export$1d41b338cdf78393; });

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $3JMQg = parcelRequire("3JMQg");

var $5Cujf = parcelRequire("5Cujf");

var $eBlbF = parcelRequire("eBlbF");

var $3DUZ0 = parcelRequire("3DUZ0");

var $60M0D = parcelRequire("60M0D");

var $cQCJN = parcelRequire("cQCJN");
const $7cac6e2aa96128dc$export$1d41b338cdf78393 = (state, action)=>{
    const patchName = action.patchName.trim();
    if (state.readOnly || patchName === "") return state;
    let creationState = state;
    if (!state.variantCreationView) {
        const arsItem = (0, $3Avah.isTlfItemReadDto)(state.tlfData) && (state.tlfData.type === (0, $4lHS7.eTlfItemType).arsTable || state.tlfData.type === (0, $4lHS7.eTlfItemType).arsListing) ? state.tlfData : null;
        if (arsItem === null) return state;
        const promoted = (0, $3Avah.isArsMasterReadDto)(arsItem) ? arsItem : {
            ...arsItem,
            allVariantPatches: {},
            variantTemplates: []
        };
        const master = state.masterTlfData ?? (0, $60M0D.toArsTlfSnapshot)(promoted);
        const current = (0, $eBlbF.cloneDeep)(state.appliedVariantPatches.length > 0 ? promoted : {
            ...master,
            allVariantPatches: promoted.allVariantPatches,
            variantTemplates: promoted.variantTemplates
        });
        creationState = {
            ...state,
            variantCreationView: true,
            masterTlfData: (0, $eBlbF.cloneDeep)(master),
            tlfData: current
        };
    }
    const current = (0, $3Avah.isArsMasterReadDto)(creationState.tlfData) ? creationState.tlfData : null;
    const master = creationState.masterTlfData;
    if (current === null || master === null) return state;
    const catalog = {
        ...current.allVariantPatches
    };
    const activeName = creationState.activeVariantPatchName;
    if (activeName !== null) {
        const patchBaseline = {
            ...master,
            allVariantPatches: catalog,
            variantTemplates: current.variantTemplates
        };
        const base = (0, $3JMQg.applyVariantPatches)(patchBaseline, {
            allVariantPatches: catalog,
            variantTemplates: current.variantTemplates
        }, creationState.appliedVariantPatches.filter((name)=>name !== activeName));
        if (!base.success) return state;
        const activeResult = (0, $5Cujf.buildVariantPatch)(base.data, current);
        if (activeResult.invalidOps.length > 0) return state;
        catalog[activeName] = activeResult.patch;
    }
    if (catalog[patchName] !== undefined) return state;
    catalog[patchName] = [];
    const tlfData = {
        ...current,
        allVariantPatches: catalog
    };
    const newState = {
        ...creationState,
        tlfData: tlfData,
        appliedVariantPatches: [
            ...creationState.appliedVariantPatches,
            patchName
        ],
        activeVariantPatchName: patchName,
        activeVariantPatchInvalidOps: [],
        showCreateVariantPatchWindow: false
    };
    const selectedState = (0, $cQCJN.updateVariantPatchSelection)(newState, newState.appliedVariantPatches, newState.activeVariantPatchName);
    (0, $3DUZ0.checkChanged)(selectedState);
    return selectedState;
};

});

parcelRegister("eFCJ9", function(module, exports) {

$parcel$export(module.exports, "tlf_loadTlf", function () { return $7adf2be3da66c593$export$e1cc49f6061b463e; });

var $3Avah = parcelRequire("3Avah");

var $eBlbF = parcelRequire("eBlbF");

var $3DUZ0 = parcelRequire("3DUZ0");

var $60M0D = parcelRequire("60M0D");
const $7adf2be3da66c593$export$e1cc49f6061b463e = (state, action)=>{
    const newState = {
        ...state
    };
    newState.isSubscribed = action.isSubscribed;
    newState.isTlfNew = action.isTlfNew;
    newState.activeVariantPatchName = null;
    newState.activeVariantPatchInvalidOps = [];
    newState.appliedVariantPatches = [];
    newState.showCreateVariantPatchWindow = false;
    newState.variantCreationView = false;
    newState.masterTlfData = (0, $3Avah.isArsMasterReadDto)(action.tlfData) ? (0, $eBlbF.cloneDeep)((0, $60M0D.toArsTlfSnapshot)(action.tlfData)) : null;
    newState.readOnly = action.readOnly;
    newState.showModalWindow = "";
    newState.tlfData = action.tlfData;
    newState.savedTlfData = (0, $eBlbF.cloneDeep)(action.tlfData);
    (0, $3DUZ0.checkChanged)(newState);
    return newState;
};

});

parcelRegister("izwfU", function(module, exports) {

$parcel$export(module.exports, "tlf_patchTlfComments", function () { return $56ed22ca4ee16372$export$57df786e368e6641; });

var $8BrMb = parcelRequire("8BrMb");

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $3DUZ0 = parcelRequire("3DUZ0");

var $2Mlm8 = parcelRequire("2Mlm8");
const $56ed22ca4ee16372$export$57df786e368e6641 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $2Mlm8.PATCH_TLF_COMMENTS)}:${action.calledFrom}: TLF data not set`);
    const commentsPatch = action.patch;
    /* istanbul ignore else -- empty patches intentionally leave the current comment state unchanged. */ if (commentsPatch && commentsPatch.length > 0) {
        const newComments = (0, $eBlbF.cloneDeep)(newState.tlfData.comments).sort((0, $8BrMb.sortCommentsAscending));
        (0, $3ew5o.applyPatch)(newComments, commentsPatch);
        newState.tlfData = {
            ...newState.tlfData,
            comments: newComments
        };
        newState.forcePushToParent = true;
        (0, $3DUZ0.checkChanged)(newState);
    }
    return newState;
};

});

parcelRegister("79ZAU", function(module, exports) {

$parcel$export(module.exports, "tlf_processSignalrNotification", function () { return $84fd4bd19ff86e93$export$103f2d6f36dcaaa9; });

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $3DUZ0 = parcelRequire("3DUZ0");

var $2Mlm8 = parcelRequire("2Mlm8");

var $cQCJN = parcelRequire("cQCJN");
const $84fd4bd19ff86e93$export$103f2d6f36dcaaa9 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $2Mlm8.PROCESS_SIGNALR_NOTIFICATION)}:${action.calledFrom}: TLF data not set`);
    newState.tlfData = (0, $eBlbF.cloneDeep)(newState.tlfData);
    (0, $3ew5o.applyPatch)(newState.tlfData, action.patch);
    newState.savedTlfData = (0, $eBlbF.cloneDeep)(state.savedTlfData);
    /* istanbul ignore else */ if (newState.savedTlfData) (0, $3ew5o.applyPatch)(newState.savedTlfData, action.patch);
    newState.showModalWindow = "";
    newState.forcePushToParent = true;
    const updatedState = (0, $cQCJN.updateVariantPatchSelection)(newState, state.appliedVariantPatches, state.activeVariantPatchName);
    (0, $3DUZ0.checkChanged)(updatedState);
    return updatedState;
};

});

parcelRegister("jYtAo", function(module, exports) {

$parcel$export(module.exports, "tlf_removeTlfComment", function () { return $ef6b448170dbed8f$export$6ecd8cae5022f959; });

var $3DUZ0 = parcelRequire("3DUZ0");

var $2Mlm8 = parcelRequire("2Mlm8");
const $ef6b448170dbed8f$export$6ecd8cae5022f959 = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $2Mlm8.REMOVE_TLF_COMMENT)}: TLF data not set`);
    newState.tlfData = {
        ...newState.tlfData,
        comments: newState.tlfData.comments.filter((comment)=>comment.id !== action.commentId)
    };
    newState.forcePushToParent = true;
    (0, $3DUZ0.checkChanged)(newState);
    return newState;
};

});

parcelRegister("imj4N", function(module, exports) {

$parcel$export(module.exports, "tlf_removeVariantPatch", function () { return $5d9083d0a99cfaec$export$b7f1cd66d9054196; });

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $3JMQg = parcelRequire("3JMQg");

var $5e2AG = parcelRequire("5e2AG");

var $kKLWF = parcelRequire("kKLWF");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");

var $60M0D = parcelRequire("60M0D");

var $cQCJN = parcelRequire("cQCJN");
const $5d9083d0a99cfaec$export$b7f1cd66d9054196 = (state, action)=>{
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    const current = state.tlfData;
    if (!Object.hasOwn(current.allVariantPatches, action.patchName)) return state;
    const master = (0, $6RNmK.getVariantPatchContext)(state).master ?? (state.appliedVariantPatches.length === 0 ? (0, $60M0D.toArsTlfSnapshot)(current) : null);
    if (master === null) return state;
    const { catalog: catalog } = (0, $kKLWF.commitActivePatch)(state.activeVariantPatchName === action.patchName ? {
        ...state,
        activeVariantPatchName: null
    } : state, action.calledFrom);
    if (catalog === null) return state;
    const allVariantPatches = {
        ...catalog
    };
    delete allVariantPatches[action.patchName];
    const appliedVariantPatches = state.appliedVariantPatches.filter((name)=>name !== action.patchName);
    const variantTemplates = current.variantTemplates.map((template)=>({
            ...template,
            variantPatches: template.variantPatches.filter((name)=>name !== action.patchName)
        }));
    const composed = (0, $3JMQg.applyVariantPatches)(master, {
        allVariantPatches: allVariantPatches,
        variantTemplates: variantTemplates
    }, appliedVariantPatches);
    if (!composed.success) return state;
    const tlfData = composed.data.type === (0, $4lHS7.eTlfItemType).arsListing ? {
        type: composed.data.type,
        ...(0, $5e2AG.pickVariantUpdateable)(composed.data),
        allVariantPatches: allVariantPatches,
        variantTemplates: variantTemplates
    } : {
        type: composed.data.type,
        ...(0, $5e2AG.pickVariantUpdateable)(composed.data),
        allVariantPatches: allVariantPatches,
        variantTemplates: variantTemplates
    };
    const newState = (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        calledFrom: action.calledFrom,
        tlfData: tlfData
    });
    return (0, $cQCJN.updateVariantPatchSelection)({
        ...newState,
        activeVariantPatchInvalidOps: []
    }, appliedVariantPatches, state.activeVariantPatchName === action.patchName ? appliedVariantPatches[0] ?? null : state.activeVariantPatchName);
};

});

parcelRegister("h8Dcs", function(module, exports) {

$parcel$export(module.exports, "tlf_removeVariantTemplate", function () { return $784af532e91e2d08$export$303437b0c578d835; });

var $3Avah = parcelRequire("3Avah");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");
const $784af532e91e2d08$export$303437b0c578d835 = (state, action)=>{
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    return (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: {
            ...state.tlfData,
            variantTemplates: state.tlfData.variantTemplates.filter((template)=>template.name !== action.variantName)
        },
        calledFrom: action.calledFrom
    });
};

});

parcelRegister("5K8cU", function(module, exports) {

$parcel$export(module.exports, "tlf_renameVariantPatch", function () { return $a8eb6a5687ae6fd2$export$f15fe5342bbf6da; });

var $3Avah = parcelRequire("3Avah");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");

var $cQCJN = parcelRequire("cQCJN");
const $a8eb6a5687ae6fd2$export$f15fe5342bbf6da = (state, action)=>{
    const newPatchName = action.newPatchName.trim();
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    const current = state.tlfData;
    if (newPatchName === "" || !Object.hasOwn(current.allVariantPatches, action.patchName) || Object.hasOwn(current.allVariantPatches, newPatchName)) return state;
    const newState = (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        calledFrom: action.calledFrom,
        tlfData: {
            allVariantPatches: Object.fromEntries(Object.entries(current.allVariantPatches).map(([name, patch])=>[
                    name === action.patchName ? newPatchName : name,
                    patch
                ])),
            variantTemplates: current.variantTemplates.map((template)=>({
                    ...template,
                    variantPatches: template.variantPatches.map((name)=>name === action.patchName ? newPatchName : name)
                }))
        }
    });
    return (0, $cQCJN.updateVariantPatchSelection)(newState, state.appliedVariantPatches.map((name)=>name === action.patchName ? newPatchName : name), state.activeVariantPatchName === action.patchName ? newPatchName : state.activeVariantPatchName);
};

});

parcelRegister("aZkQ1", function(module, exports) {

$parcel$export(module.exports, "tlf_renameVariantTemplate", function () { return $6dff5dc24584a624$export$aaa2c74033281a69; });

var $3Avah = parcelRequire("3Avah");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");
const $6dff5dc24584a624$export$aaa2c74033281a69 = (state, action)=>{
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    const current = state.tlfData;
    const newVariantName = action.newVariantName.trim();
    const currentTemplate = current.variantTemplates.find((template)=>template.name === action.variantName);
    if (currentTemplate === undefined || newVariantName.length === 0 || current.variantTemplates.some((template)=>template !== currentTemplate && template.name.toLowerCase() === newVariantName.toLowerCase())) return state;
    if (newVariantName === currentTemplate.name) return state;
    return (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: {
            variantTemplates: current.variantTemplates.map((template)=>template === currentTemplate ? {
                    ...template,
                    name: newVariantName
                } : template)
        },
        calledFrom: action.calledFrom
    });
};

});

parcelRegister("BtObB", function(module, exports) {

$parcel$export(module.exports, "tlf_revertToVariantMaster", function () { return $85bd4ff7b8c8db36$export$200b520c9d4afd69; });

var $4lHS7 = parcelRequire("4lHS7");

var $5e2AG = parcelRequire("5e2AG");

var $kKLWF = parcelRequire("kKLWF");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $dXplA = parcelRequire("dXplA");

var $jPTUt = parcelRequire("jPTUt");

var $ea3F0 = parcelRequire("ea3F0");
const $85bd4ff7b8c8db36$export$200b520c9d4afd69 = (state, action)=>{
    const { state: committedState, catalog: catalog } = (0, $kKLWF.commitActivePatch)(state, action.calledFrom);
    const { master: master, currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(committedState);
    if (catalog === null || master === null || currentMaster === null) return committedState;
    const tlfData = master.type === (0, $4lHS7.eTlfItemType).arsListing ? {
        type: master.type,
        ...(0, $5e2AG.pickVariantUpdateable)(master),
        allVariantPatches: catalog
    } : {
        type: master.type,
        ...(0, $5e2AG.pickVariantUpdateable)(master),
        allVariantPatches: catalog
    };
    const updated = (0, $jPTUt.tlf_updateTlf)(committedState, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: tlfData,
        calledFrom: action.calledFrom
    });
    const unselected = {
        ...updated,
        appliedVariantPatches: [],
        activeVariantPatchName: null
    };
    const newState = (0, $dXplA.tlf_setVariantCreationMode)(unselected, {
        operation: (0, $2Mlm8.SET_VARIANT_CREATION_VIEW),
        variantCreationView: false,
        calledFrom: action.calledFrom
    });
    return (0, $ea3F0.updateActivePatchErrors)(newState);
};

});

parcelRegister("hYxsn", function(module, exports) {

$parcel$export(module.exports, "tlf_setCreateVariantPatchWindow", function () { return $2d13ce7ea3413004$export$1cf30a53d56e0e16; });
const $2d13ce7ea3413004$export$1cf30a53d56e0e16 = (state, action)=>({
        ...state,
        showCreateVariantPatchWindow: action.show
    });

});

parcelRegister("cKin3", function(module, exports) {

$parcel$export(module.exports, "tlf_setEditorBlocksSearchPanel", function () { return $b58c0e5d316c6041$export$1576c29562e0a760; });
const $b58c0e5d316c6041$export$1576c29562e0a760 = (state, action)=>({
        ...state,
        editorBlocksSearchPanelStatus: action.editorBlocksSearchPanelStatus
    });

});

parcelRegister("aefxR", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfCommentPanel", function () { return $ac6604d8d4ef5066$export$1b59748e23a96a7b; });
const $ac6604d8d4ef5066$export$1b59748e23a96a7b = (state, action)=>({
        ...state,
        commentPanelStatus: action.commentPanelStatus
    });

});

parcelRegister("gO34q", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfReadOnly", function () { return $8b8b8741dad52f51$export$9087dbcea44de9d6; });
const $8b8b8741dad52f51$export$9087dbcea44de9d6 = (state, action)=>({
        ...state,
        readOnly: action.readOnly
    });

});

parcelRegister("8unDl", function(module, exports) {

$parcel$export(module.exports, "tlf_setTlfSubscriptionStatus", function () { return $47004828e561e54e$export$f3264ae9cebda665; });
const $47004828e561e54e$export$f3264ae9cebda665 = (state, action)=>({
        ...state,
        isSubscribed: action.isSubscribed
    });

});

parcelRegister("4qS4e", function(module, exports) {

$parcel$export(module.exports, "tlf_setViewMode", function () { return $aa27df71603d88a0$export$53ea11b202e6a10d; });
const $aa27df71603d88a0$export$53ea11b202e6a10d = (state, action)=>({
        ...state,
        tlfViewMode: action.tlfViewMode
    });

});

parcelRegister("2kXh8", function(module, exports) {

$parcel$export(module.exports, "tlf_showModalWindow", function () { return $6008e97946aeb4ab$export$54c52b9fc6ae4c60; });
const $6008e97946aeb4ab$export$54c52b9fc6ae4c60 = (state, action)=>({
        ...state,
        showModalWindow: action.modalWindow
    });

});

parcelRegister("aO7iy", function(module, exports) {

$parcel$export(module.exports, "tlf_toggleTrafficLights", function () { return $c6cdc2281a653a52$export$e5aafac61afa59f9; });
const $c6cdc2281a653a52$export$e5aafac61afa59f9 = (state, action)=>({
        ...state,
        showTrafficLights: action.showTrafficLights
    });

});

parcelRegister("6dv42", function(module, exports) {

$parcel$export(module.exports, "tlf_toggleVariantPatch", function () { return $a9abae3fb60dbd62$export$70674b76125069eb; });

var $3Avah = parcelRequire("3Avah");

var $fwbcv = parcelRequire("fwbcv");

var $5T7FV = parcelRequire("5T7FV");

var $kKLWF = parcelRequire("kKLWF");

var $2Mlm8 = parcelRequire("2Mlm8");

var $dXplA = parcelRequire("dXplA");

var $60M0D = parcelRequire("60M0D");

var $ea3F0 = parcelRequire("ea3F0");
const $a9abae3fb60dbd62$export$70674b76125069eb = (state, action)=>{
    const { state: committedState, catalog: catalog } = (0, $kKLWF.commitActivePatch)(state, action.calledFrom);
    if (catalog === null) return committedState;
    const selectedGroup = (0, $fwbcv.groupVariantPatches)({
        allVariantPatches: catalog,
        variantTemplates: []
    }).filter((group)=>group.includes(action.patchName)).flat();
    const appliedPatchNames = action.applied ? [
        ...state.appliedVariantPatches.filter((name)=>!selectedGroup.includes(name)),
        action.patchName
    ] : state.appliedVariantPatches.filter((name)=>name !== action.patchName);
    const firstPatchApplied = action.applied && state.appliedVariantPatches.length === 0;
    const currentItem = (0, $3Avah.isArsMasterReadDto)(committedState.tlfData) ? committedState.tlfData : null;
    const patchState = firstPatchApplied && currentItem !== null ? {
        ...state,
        masterTlfData: (0, $60M0D.toArsTlfSnapshot)(currentItem)
    } : state;
    const activePatchName = action.applied ? action.patchName : state.activeVariantPatchName ?? action.patchName;
    let newState = (0, $5T7FV.applySelection)(patchState, appliedPatchNames, catalog, activePatchName, action.calledFrom);
    if (newState !== patchState && (action.applied || appliedPatchNames.length === 0 && state.variantCreationView)) newState = (0, $dXplA.tlf_setVariantCreationMode)(newState, {
        operation: (0, $2Mlm8.SET_VARIANT_CREATION_VIEW),
        variantCreationView: action.applied,
        calledFrom: action.calledFrom
    });
    return (0, $ea3F0.updateActivePatchErrors)(newState);
};

});
parcelRegister("5T7FV", function(module, exports) {

$parcel$export(module.exports, "applySelection", function () { return $d64cef0f5c0f8a7a$export$7dfdfafc3c1a9817; });

var $4lHS7 = parcelRequire("4lHS7");

var $3JMQg = parcelRequire("3JMQg");

var $5e2AG = parcelRequire("5e2AG");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $86Xek = parcelRequire("86Xek");

var $jPTUt = parcelRequire("jPTUt");
const $d64cef0f5c0f8a7a$export$7dfdfafc3c1a9817 = (state, patchNames, catalog, activeName, calledFrom)=>{
    const { master: master, information: information } = (0, $6RNmK.getVariantPatchContext)(state);
    if (master === null || information === null) return state;
    const composed = (0, $3JMQg.applyVariantPatches)(master, {
        ...information,
        allVariantPatches: catalog
    }, patchNames);
    // Overlapping patches are rejected before selection reaches this helper.
    // istanbul ignore next
    if (!composed.success) return state;
    const tlfData = composed.data.type === (0, $4lHS7.eTlfItemType).arsListing ? {
        type: composed.data.type,
        ...(0, $5e2AG.pickVariantUpdateable)(composed.data),
        allVariantPatches: catalog
    } : {
        type: composed.data.type,
        ...(0, $5e2AG.pickVariantUpdateable)(composed.data),
        allVariantPatches: catalog
    };
    const updated = (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: tlfData,
        calledFrom: calledFrom
    });
    const selectedName = patchNames.includes(activeName) ? activeName : patchNames[0] ?? null;
    if (selectedName === null) return (0, $86Xek.tlf_setVariantPatchSelection)(updated, {
        operation: (0, $2Mlm8.SET_VARIANT_PATCH_SELECTION),
        appliedPatchNames: [],
        activePatchName: activeName,
        calledFrom: calledFrom
    });
    return (0, $86Xek.tlf_setVariantPatchSelection)(updated, {
        operation: (0, $2Mlm8.SET_VARIANT_PATCH_SELECTION),
        appliedPatchNames: patchNames,
        activePatchName: selectedName,
        calledFrom: calledFrom
    });
};

});


parcelRegister("6OvqD", function(module, exports) {

$parcel$export(module.exports, "tlf_trackActiveVariantPatch", function () { return $cb4ad29ff66ee0ee$export$a609a81103c63840; });

var $fwbcv = parcelRequire("fwbcv");

var $eBlbF = parcelRequire("eBlbF");

var $5T7FV = parcelRequire("5T7FV");

var $fWOjh = parcelRequire("fWOjh");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");

var $ea3F0 = parcelRequire("ea3F0");
const $cb4ad29ff66ee0ee$export$a609a81103c63840 = (state, action)=>{
    const context = (0, $6RNmK.getVariantPatchContext)(state);
    const result = (0, $fWOjh.getActivePatchResult)(state, context);
    let newState = state;
    if (result !== null && result.invalidOps.length === 0 && context.information !== null && state.activeVariantPatchName !== null && !(0, $eBlbF.isEqual)(context.information.allVariantPatches[state.activeVariantPatchName], result.patch)) {
        const activeName = state.activeVariantPatchName;
        const allVariantPatches = {
            ...context.information.allVariantPatches,
            [activeName]: result.patch
        };
        newState = (0, $jPTUt.tlf_updateTlf)(state, {
            operation: (0, $2Mlm8.UPDATE_TLF),
            tlfData: {
                allVariantPatches: allVariantPatches
            },
            calledFrom: action.calledFrom
        });
        newState.forcePushToParent = true;
        const activeGroup = (0, $fwbcv.groupVariantPatches)({
            ...context.information,
            allVariantPatches: allVariantPatches
        }).filter((group)=>group.includes(activeName)).flat();
        const appliedPatchNames = state.appliedVariantPatches.filter((name)=>name === activeName || !activeGroup.includes(name));
        if (appliedPatchNames.length !== state.appliedVariantPatches.length) newState = (0, $5T7FV.applySelection)(newState, appliedPatchNames, allVariantPatches, activeName, action.calledFrom);
    }
    return (0, $ea3F0.updateActivePatchErrors)(newState);
};

});

parcelRegister("djMm9", function(module, exports) {

$parcel$export(module.exports, "tlf_updateTlfComment", function () { return $02418165c5194adb$export$f997fd347dcfde9a; });

var $3DUZ0 = parcelRequire("3DUZ0");

var $2Mlm8 = parcelRequire("2Mlm8");
const $02418165c5194adb$export$f997fd347dcfde9a = (state, action)=>{
    const newState = {
        ...state
    };
    if (!newState.tlfData) throw new Error(`tlfContextReducer: ${(0, $2Mlm8.UPDATE_TLF_COMMENT)}: TLF data not set`);
    newState.tlfData = {
        ...newState.tlfData,
        comments: [
            ...newState.tlfData.comments.filter((comment)=>comment.id !== action.comment.id),
            action.comment
        ]
    };
    newState.forcePushToParent = true;
    (0, $3DUZ0.checkChanged)(newState);
    return newState;
};

});

parcelRegister("jIhEp", function(module, exports) {

$parcel$export(module.exports, "tlf_upsertVariantTemplate", function () { return $2b019d12267c467d$export$826de3aa0b3167fe; });

var $3Avah = parcelRequire("3Avah");

var $2kvJR = parcelRequire("2kvJR");

var $fwbcv = parcelRequire("fwbcv");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");
const $2b019d12267c467d$export$826de3aa0b3167fe = (state, action)=>{
    if (state.readOnly || !(0, $3Avah.isArsMasterReadDto)(state.tlfData)) return state;
    const current = state.tlfData;
    const name = action.template.name.trim();
    const variantPatches = action.template.variantPatches;
    if (name.length === 0 || (0, $2kvJR.getDuplicateVariantName)(current.variantTemplates, variantPatches, name) !== undefined || variantPatches.some((patch)=>!Object.hasOwn(current.allVariantPatches, patch)) || (0, $fwbcv.groupVariantPatches)(current).some((group)=>group.filter((patch)=>variantPatches.includes(patch)).length > 1)) return state;
    const template = {
        ...action.template,
        name: name,
        variantPatches: variantPatches
    };
    const exists = current.variantTemplates.some((entry)=>entry.name === name);
    const variantTemplates = exists ? current.variantTemplates.map((entry)=>entry.name === name ? template : entry) : [
        ...current.variantTemplates,
        template
    ];
    return (0, $jPTUt.tlf_updateTlf)(state, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: {
            ...current,
            variantTemplates: variantTemplates
        },
        calledFrom: action.calledFrom
    });
};

});
parcelRegister("2kvJR", function(module, exports) {

$parcel$export(module.exports, "getDuplicateVariantName", function () { return $ba2e262adf4ef7d3$export$e13478370c3cb490; });
const $ba2e262adf4ef7d3$export$e13478370c3cb490 = (templates, patchNames, variantName)=>{
    const selected = new Set(patchNames);
    return templates.find((template)=>{
        const patches = new Set(template.variantPatches);
        return template.name !== variantName && patches.size === selected.size && [
            ...patches
        ].every((patch)=>selected.has(patch));
    })?.name;
};

});



parcelRegister("f2M6x", function(module, exports) {

$parcel$export(module.exports, "ADD_NEW_TOC_ENTRIES", function () { return $73d4fe3082fce2b2$export$b34d12c25bb2dd91; });
$parcel$export(module.exports, "ADD_SECTION", function () { return $73d4fe3082fce2b2$export$c7111862174a3986; });
$parcel$export(module.exports, "CLEAR_REMOVED", function () { return $73d4fe3082fce2b2$export$d1bc7c5f629d50ed; });
$parcel$export(module.exports, "CLOSE_TOC_NEED_REFRESH", function () { return $73d4fe3082fce2b2$export$99d31802a554c5b; });
$parcel$export(module.exports, "CLOSE_TOC_SAVE_ALERT", function () { return $73d4fe3082fce2b2$export$3717e9f3cef35195; });
$parcel$export(module.exports, "DELETE", function () { return $73d4fe3082fce2b2$export$4bd2facc4a3e6aa1; });
$parcel$export(module.exports, "FROM_SIGNALR", function () { return $73d4fe3082fce2b2$export$5e5681c39cb93dd7; });
$parcel$export(module.exports, "MOVE_ITEM", function () { return $73d4fe3082fce2b2$export$41c09ed761ad8908; });
$parcel$export(module.exports, "REASSIGN_TOC_NUMBERS", function () { return $73d4fe3082fce2b2$export$5db4b16d450baa30; });
$parcel$export(module.exports, "REFRESH", function () { return $73d4fe3082fce2b2$export$6c953e829e7f40b1; });
$parcel$export(module.exports, "SAVE_FAIL", function () { return $73d4fe3082fce2b2$export$edc98118e39a5f08; });
$parcel$export(module.exports, "SAVE_SUCCESS", function () { return $73d4fe3082fce2b2$export$c97525462b847b71; });
$parcel$export(module.exports, "SET_TOC_REQUEST_STATUS", function () { return $73d4fe3082fce2b2$export$62389da2c73c504f; });
$parcel$export(module.exports, "SET_TYPE_FILTER", function () { return $73d4fe3082fce2b2$export$ec772941a6ed73d2; });
$parcel$export(module.exports, "SHOW_TOC_NEED_REFRESH", function () { return $73d4fe3082fce2b2$export$9df14b3306a3dc55; });
$parcel$export(module.exports, "SHOW_TOC_SAVE_ALERT", function () { return $73d4fe3082fce2b2$export$6b7f955731436599; });
$parcel$export(module.exports, "SORT_TOC", function () { return $73d4fe3082fce2b2$export$6e957318c416b9ca; });
$parcel$export(module.exports, "UPDATE_AFTER_PATCH", function () { return $73d4fe3082fce2b2$export$d4684aa5138afe65; });
$parcel$export(module.exports, "UPDATE_COMMENTS_FILTER", function () { return $73d4fe3082fce2b2$export$e5be5d1ddab7a027; });
$parcel$export(module.exports, "UPDATE_ENTRY", function () { return $73d4fe3082fce2b2$export$8e3020b6be7d753a; });
$parcel$export(module.exports, "UPDATE_LAST_MAJOR_VERSION_SAVED_AT", function () { return $73d4fe3082fce2b2$export$d5abd8e8b336f12c; });
$parcel$export(module.exports, "UPDATE_SEARCH_TEXT", function () { return $73d4fe3082fce2b2$export$7995e32e37a98def; });
$parcel$export(module.exports, "UPDATE_SECTION", function () { return $73d4fe3082fce2b2$export$6b6dcf2c69db97d3; });
$parcel$export(module.exports, "UPDATE_TRAFFIC_LIGHTS_FILTER", function () { return $73d4fe3082fce2b2$export$b25f651b871e7eb7; });
$parcel$export(module.exports, "UPDATE_VIEW_TIFO", function () { return $73d4fe3082fce2b2$export$6db0c9048fe59122; });
const $73d4fe3082fce2b2$export$b34d12c25bb2dd91 = "ADD_NEW_TOC_ENTRIES";
const $73d4fe3082fce2b2$export$c7111862174a3986 = "ADD_SECTION";
const $73d4fe3082fce2b2$export$d1bc7c5f629d50ed = "CLEAR_REMOVED";
const $73d4fe3082fce2b2$export$99d31802a554c5b = "CLOSE_TOC_NEED_REFRESH";
const $73d4fe3082fce2b2$export$3717e9f3cef35195 = "CLOSE_TOC_SAVE_ALERT";
const $73d4fe3082fce2b2$export$4bd2facc4a3e6aa1 = "DELETE";
const $73d4fe3082fce2b2$export$5e5681c39cb93dd7 = "FROM_SIGNALR";
const $73d4fe3082fce2b2$export$41c09ed761ad8908 = "MOVE_ITEM";
const $73d4fe3082fce2b2$export$5db4b16d450baa30 = "REASSIGN_TOC_NUMBERS";
const $73d4fe3082fce2b2$export$6c953e829e7f40b1 = "REFRESH";
const $73d4fe3082fce2b2$export$edc98118e39a5f08 = "SAVE_FAIL";
const $73d4fe3082fce2b2$export$c97525462b847b71 = "SAVE_SUCCESS";
const $73d4fe3082fce2b2$export$62389da2c73c504f = "SET_TOC_REQUEST_STATUS";
const $73d4fe3082fce2b2$export$ec772941a6ed73d2 = "SET_TYPE_FILTER";
const $73d4fe3082fce2b2$export$9df14b3306a3dc55 = "SHOW_TOC_NEED_REFRESH";
const $73d4fe3082fce2b2$export$6b7f955731436599 = "SHOW_TOC_SAVE_ALERT";
const $73d4fe3082fce2b2$export$6e957318c416b9ca = "SORT_TOC";
const $73d4fe3082fce2b2$export$d4684aa5138afe65 = "UPDATE_AFTER_PATCH";
const $73d4fe3082fce2b2$export$e5be5d1ddab7a027 = "UPDATE_COMMENTS_FILTER";
const $73d4fe3082fce2b2$export$8e3020b6be7d753a = "UPDATE_ENTRY";
const $73d4fe3082fce2b2$export$d5abd8e8b336f12c = "UPDATE_LAST_MAJOR_VERSION_SAVED_AT";
const $73d4fe3082fce2b2$export$7995e32e37a98def = "UPDATE_SEARCH_TEXT";
const $73d4fe3082fce2b2$export$6b6dcf2c69db97d3 = "UPDATE_SECTION";
const $73d4fe3082fce2b2$export$b25f651b871e7eb7 = "UPDATE_TRAFFIC_LIGHTS_FILTER";
const $73d4fe3082fce2b2$export$6db0c9048fe59122 = "UPDATE_VIEW_TIFO";

});

parcelRegister("2uo2k", function(module, exports) {
$parcel$export(module.exports, "toc_addNewTocEntries", function () { return (parcelRequire("7Poeg")).toc_addNewTocEntries; });
$parcel$export(module.exports, "toc_addSection", function () { return (parcelRequire("d2rCN")).toc_addSection; });
$parcel$export(module.exports, "toc_clearRemoved", function () { return (parcelRequire("69HdE")).toc_clearRemoved; });
$parcel$export(module.exports, "toc_closeTocNeedRefresh", function () { return (parcelRequire("f6HCY")).toc_closeTocNeedRefresh; });
$parcel$export(module.exports, "toc_closeTocSaveAlert", function () { return (parcelRequire("4x2zK")).toc_closeTocSaveAlert; });
$parcel$export(module.exports, "toc_delete", function () { return (parcelRequire("l8bhP")).toc_delete; });
$parcel$export(module.exports, "toc_fromSignalR", function () { return (parcelRequire("6YOxT")).toc_fromSignalR; });
$parcel$export(module.exports, "toc_moveItem", function () { return (parcelRequire("ifhbO")).toc_moveItem; });
$parcel$export(module.exports, "toc_reassignTocNumbers", function () { return (parcelRequire("lmDtA")).toc_reassignTocNumbers; });
$parcel$export(module.exports, "toc_refresh", function () { return (parcelRequire("dCMsy")).toc_refresh; });
$parcel$export(module.exports, "toc_saveFail", function () { return (parcelRequire("gbACq")).toc_saveFail; });
$parcel$export(module.exports, "toc_saveSuccess", function () { return (parcelRequire("iRGkV")).toc_saveSuccess; });
$parcel$export(module.exports, "toc_setTocRequestStatus", function () { return (parcelRequire("gxQzQ")).toc_setTocRequestStatus; });
$parcel$export(module.exports, "toc_setTypeFilter", function () { return (parcelRequire("7v6lU")).toc_setTypeFilter; });
$parcel$export(module.exports, "toc_showTocNeedRefresh", function () { return (parcelRequire("8PBoD")).toc_showTocNeedRefresh; });
$parcel$export(module.exports, "toc_showTocSaveAlert", function () { return (parcelRequire("fzmMk")).toc_showTocSaveAlert; });
$parcel$export(module.exports, "toc_sortToc", function () { return (parcelRequire("gTRxb")).toc_sortToc; });
$parcel$export(module.exports, "toc_updateAfterPatch", function () { return (parcelRequire("5GKCG")).toc_updateAfterPatch; });
$parcel$export(module.exports, "toc_updateCommentsFilter", function () { return (parcelRequire("inVyK")).toc_updateCommentsFilter; });
$parcel$export(module.exports, "toc_updateEntry", function () { return (parcelRequire("1HVxb")).toc_updateEntry; });
$parcel$export(module.exports, "toc_updateLastMajorVersionSavedAt", function () { return (parcelRequire("bNZuU")).toc_updateLastMajorVersionSavedAt; });
$parcel$export(module.exports, "toc_updateSearchText", function () { return (parcelRequire("6Jy5A")).toc_updateSearchText; });
$parcel$export(module.exports, "toc_updateSection", function () { return (parcelRequire("648Q5")).toc_updateSection; });
$parcel$export(module.exports, "toc_updateTrafficLightsFilter", function () { return (parcelRequire("gPxFT")).toc_updateTrafficLightsFilter; });
$parcel$export(module.exports, "toc_updateViewTiFo", function () { return (parcelRequire("1mYsg")).toc_updateViewTiFo; });
parcelRequire("7Poeg");
parcelRequire("d2rCN");
parcelRequire("69HdE");
parcelRequire("f6HCY");
parcelRequire("4x2zK");
parcelRequire("l8bhP");
parcelRequire("6YOxT");
parcelRequire("ifhbO");
parcelRequire("lmDtA");
parcelRequire("dCMsy");
parcelRequire("gbACq");
parcelRequire("iRGkV");
parcelRequire("gxQzQ");
parcelRequire("7v6lU");
parcelRequire("8PBoD");
parcelRequire("fzmMk");
parcelRequire("gTRxb");
parcelRequire("5GKCG");
parcelRequire("inVyK");
parcelRequire("1HVxb");
parcelRequire("bNZuU");
parcelRequire("6Jy5A");
parcelRequire("648Q5");
parcelRequire("gPxFT");
parcelRequire("1mYsg");

});
parcelRegister("7Poeg", function(module, exports) {

$parcel$export(module.exports, "toc_addNewTocEntries", function () { return $e6f2ebbb6c785cc7$export$ca84015e21a0e92f; });
const $e6f2ebbb6c785cc7$export$ca84015e21a0e92f = (state, action)=>{
    const newState = {
        ...state
    };
    const existingIds = newState.tocItems.map((item)=>item.id);
    newState.tocItems = [
        ...newState.tocItems,
        ...action.entries.filter((item)=>!existingIds.includes(item.id))
    ].sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- reducer items should already carry a persisted order value.
        0) - (second.tocOrder ?? // istanbul ignore next -- reducer items should already carry a persisted order value.
        0));
    newState.saving = false;
    newState.lastMinorVersionSavedAt = action.loadTimeStamp;
    newState.sendUpdate = true;
    return newState;
};

});

parcelRegister("d2rCN", function(module, exports) {

$parcel$export(module.exports, "toc_addSection", function () { return $989079431e8f477c$export$9905c9b4e7c93cf3; });

var $lp5N7 = parcelRequire("lp5N7");
const $989079431e8f477c$export$9905c9b4e7c93cf3 = (state, action)=>{
    const newState = {
        ...state
    };
    /* istanbul ignore else -- reducer callers only dispatch unique identifiers. */ if (newState.tocItems.findIndex((item)=>item.id === action.newId) === -1) {
        const newSection = new (0, $lp5N7.MosaicTocSectionClass)({
            id: action.newId,
            primaryHierarchyId: newState.hierarchyId,
            sectionLabel: "",
            sectionNumber: "",
            order: newState.tocItems.map((item)=>item.tocOrder ?? // istanbul ignore next -- all ToC items should carry an order before insertion.
                0).reduce((first, second)=>Math.min(first, second), 0) - 1,
            changed: true
        });
        newState.tocItems.splice(0, 0, newSection);
        newState.saving = true;
    }
    return newState;
};

});
parcelRegister("lp5N7", function(module, exports) {

$parcel$export(module.exports, "MosaicTocSectionClass", function () { return $2de0fd2d1c17da41$export$3a645995f5f4e506; });
parcelRequire("6jtLO");
var $12Lyj = parcelRequire("12Lyj");

var $4lHS7 = parcelRequire("4lHS7");

var $ezvcS = parcelRequire("ezvcS");
const $2de0fd2d1c17da41$export$6e61049aca2d3937 = (obj)=>{
    if (!(0, $12Lyj.isObjectRecord)(obj)) return false;
    return typeof obj.id === "string" && typeof obj.sectionNumber === "string" && typeof obj.sectionLabel === "string" && typeof obj.order === "number" && typeof obj.primaryHierarchyId === "string";
};
class $2de0fd2d1c17da41$export$3a645995f5f4e506 extends (0, $ezvcS.MosaicTocBaseClass) {
    /**
   * Construct a `MosaicTocSectionClass` from either an expanded section or DTO.
   *
   * @param input - Source object either expanded (`ITocSectionExpanded`) or DTO form.
   */ constructor(input){
        const feedSuper = $2de0fd2d1c17da41$export$6e61049aca2d3937(input) ? {
            id: input.id,
            primaryHierarchyId: input.primaryHierarchyId,
            tocLabel: input.sectionLabel,
            tocNumber: input.sectionNumber,
            tocOrder: input.order,
            changed: input.changed ?? false,
            inError: false
        } : input;
        super(feedSuper), this.type = (0, $4lHS7.eTlfItemType).section;
    }
    /**
   * Return the data transfer object representation of this section.
   *
   * @returns A `MosaicTocSectionDto` representing this section's persisted shape.
   */ get data() {
        return {
            id: this.id,
            type: this.type,
            primaryHierarchyId: this.primaryHierarchyId,
            tocLabel: this.tocLabel,
            tocNumber: this.tocNumber,
            tocOrder: this.tocOrder,
            changed: this.changed,
            inError: this.inError
        };
    }
}

});
parcelRegister("ezvcS", function(module, exports) {

$parcel$export(module.exports, "MosaicTocBaseClass", function () { return $b959ac77b1fad428$export$8c30cd20218100fd; });
class $b959ac77b1fad428$export$8c30cd20218100fd {
    /**
   * Gets the unique identifier for this TOC item.
   */ get id() {
        return this._id;
    }
    /**
   * Gets whether this item has unsaved changes.
   */ get changed() {
        return this._changed;
    }
    /**
   * Gets whether this item has a save error.
   */ get inError() {
        return this._inError;
    }
    /**
   * Gets the primary hierarchy ID for this item.
   */ get primaryHierarchyId() {
        return this._primaryHierarchyId;
    }
    /**
   * Gets the timestamp of the last update.
   */ get updateTimestamp() {
        return this._updateTimestamp;
    }
    /**
   * Gets the TOC number (e.g., "1.2.3").
   */ get tocNumber() {
        return this._tocNumber;
    }
    /**
   * Gets the TOC label text.
   */ get tocLabel() {
        return this._tocLabel;
    }
    /**
   * Gets the sort order for this TOC item.
   */ get tocOrder() {
        return this._tocOrder;
    }
    /**
   * Creates a new TOC base class instance.
   *
   * @param input - The TOC base data to initialise from
   */ constructor(input){
        this._id = "";
        this._changed = false;
        this._inError = false;
        this._primaryHierarchyId = "";
        this._updateTimestamp = null;
        this._tocNumber = "";
        this._tocLabel = "";
        this._tocOrder = -1;
        const errCheck = [];
        if (input.id.trim().length === 0) errCheck.push("mosaicTocItem: contructor: id cannot be blank");
        else if (input.id.match(/^[A-Za-z0-9-_]+$/) === null) errCheck.push(`mosaicTocItem: contructor: id (${input.id}) must contain alphanumerics, hyphen and underscore`);
        if (errCheck.length > 0) throw errCheck.join("\n");
        this._id = input.id;
        this._primaryHierarchyId = input.primaryHierarchyId;
        this._tocNumber = input.tocNumber ?? // istanbul ignore next
        "";
        this._tocLabel = input.tocLabel ?? // istanbul ignore next
        "";
        this._updateTimestamp = new Date().getTime();
        this._tocOrder = input.tocOrder ?? // istanbul ignore next
        -1;
        this._changed = input.changed;
        this._inError = input.inError;
    }
    /**
   * Marks this item as successfully saved.
   */ markSaved() {
        this._changed = false;
        this._inError = false;
        this._updateTimestamp = new Date().getTime();
    }
    /**
   * Marks this item as having a save failure.
   */ markSaveFailed() {
        this._changed = true;
        this._inError = true;
        this._updateTimestamp = new Date().getTime();
    }
    /**
   * Updates this TOC item with new values.
   *
   * @param update - The update data to apply
   * @param now - Optional. The timestamp for this update
   */ update(update, now = null) {
        if (update.id !== this._id) throw new Error("Cannot update a section with a different id");
        now = now ?? new Date().getTime();
        if (update.primaryHierarchyId !== undefined && this._primaryHierarchyId !== update.primaryHierarchyId) {
            this._primaryHierarchyId = update.primaryHierarchyId;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocNumber !== undefined && this._tocNumber !== update.tocNumber) {
            this._tocNumber = update.tocNumber;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocLabel !== undefined && this._tocLabel !== update.tocLabel) {
            this._tocLabel = update.tocLabel;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
        if (update.tocOrder !== undefined && this._tocOrder !== update.tocOrder) {
            this._tocOrder = update.tocOrder;
            this._changed = !update.saved;
            this._inError = false;
            this._updateTimestamp = now;
        }
    }
}

});



parcelRegister("69HdE", function(module, exports) {

$parcel$export(module.exports, "toc_clearRemoved", function () { return $0035e94571438c4d$export$7250148a97c9b0a1; });
const $0035e94571438c4d$export$7250148a97c9b0a1 = (state)=>({
        ...state,
        removedItems: [],
        changed: false
    });

});

parcelRegister("f6HCY", function(module, exports) {

$parcel$export(module.exports, "toc_closeTocNeedRefresh", function () { return $a6592c63aa9eb153$export$667658cd9f64b286; });
const $a6592c63aa9eb153$export$667658cd9f64b286 = (state)=>({
        ...state,
        showNeedRefresh: false
    });

});

parcelRegister("4x2zK", function(module, exports) {

$parcel$export(module.exports, "toc_closeTocSaveAlert", function () { return $0b82725f0c7f4e33$export$327d020828e9fb64; });
const $0b82725f0c7f4e33$export$327d020828e9fb64 = (state)=>({
        ...state,
        showSaveAlert: false,
        tocIdFromMessage: undefined
    });

});

parcelRegister("l8bhP", function(module, exports) {

$parcel$export(module.exports, "toc_delete", function () { return $912868dcdb2105b1$export$43af0e84986eaf51; });
const $912868dcdb2105b1$export$43af0e84986eaf51 = (state, action)=>{
    const newState = {
        ...state
    };
    const removed = newState.tocItems.find((item)=>item.id === action.itemId);
    /* istanbul ignore else -- callers only request deletion for visible ToC items. */ if (removed) {
        newState.tocItems = newState.tocItems.filter((item)=>item.id !== action.itemId);
        if (removed.type === "Section") newState.removedItems.push({
            id: removed.id,
            changed: true
        });
        else newState.removedItems.push({
            id: removed.id,
            azsolId: removed.azsolId,
            version: removed.version,
            changed: true
        });
        newState.saving = true;
    }
    return newState;
};

});

parcelRegister("6YOxT", function(module, exports) {

$parcel$export(module.exports, "toc_fromSignalR", function () { return $1f7cf6821e650058$export$84307661cfc4b7a0; });

var $4lHS7 = parcelRequire("4lHS7");

var $lp5N7 = parcelRequire("lp5N7");
const $1f7cf6821e650058$export$84307661cfc4b7a0 = (state, action)=>{
    const newState = {
        ...state
    };
    // Delete item if found
    if (newState.tocItems.findIndex((item)=>item.id === action.deletedItemId) > -1) {
        const index = newState.tocItems.findIndex((item)=>item.id === action.deletedItemId);
        newState.removedItems.push(...newState.tocItems.splice(index, 1));
    }
    action.items.forEach((item)=>{
        const index = newState.tocItems.findIndex((currentItem)=>currentItem.id === item.id);
        const current = newState.tocItems[index];
        // Update item when found
        if (index > -1 && item.type === (0, $4lHS7.eTlfItemType).section && current instanceof (0, $lp5N7.MosaicTocSectionClass)) current.update({
            ...item,
            saved: true
        });
        else if (index > -1 && item.type !== (0, $4lHS7.eTlfItemType).section && current.type !== (0, $4lHS7.eTlfItemType).section) newState.tocItems[index] = {
            ...current,
            ...item,
            saved: true
        };
        else if (item.type === (0, $4lHS7.eTlfItemType).section) {
            const newSection = new (0, $lp5N7.MosaicTocSectionClass)({
                id: item.id,
                sectionNumber: item.tocNumber ?? // istanbul ignore next -- SignalR section updates should include the section number.
                "",
                sectionLabel: item.tocLabel ?? // istanbul ignore next -- SignalR section updates should include the section label.
                "",
                order: item.tocOrder ?? // istanbul ignore next -- SignalR section updates should include the section order.
                0,
                primaryHierarchyId: newState.hierarchyId,
                changed: false
            });
            newState.tocItems.push(newSection);
        } else newState.tocItems.push(item);
    });
    newState.receivedMessages.push(action.receivedMessage);
    newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- all ToC items are expected to have a numeric order.
        0) - (second.tocOrder ?? // istanbul ignore next -- all ToC items are expected to have a numeric order.
        0));
    newState.saving = false;
    return newState;
};

});

parcelRegister("ifhbO", function(module, exports) {

$parcel$export(module.exports, "toc_moveItem", function () { return $cfc65e1db37b1434$export$2028bd3b4beb0dc1; });

var $lp5N7 = parcelRequire("lp5N7");
const $cfc65e1db37b1434$export$2028bd3b4beb0dc1 = (state, action)=>{
    const newState = {
        ...state
    };
    const moveIndex = newState.tocItems.map((item)=>item.id).indexOf(action.itemId);
    if (moveIndex < 0) return newState;
    /* istanbul ignore else */ if (moveIndex !== action.newIndex) {
        newState.tocItems.splice(action.newIndex, 0, newState.tocItems.splice(moveIndex, 1)[0]);
        newState.tocItems.forEach((item, index)=>{
            if (item.tocOrder !== index) {
                if (item instanceof (0, $lp5N7.MosaicTocSectionClass)) item.update({
                    id: item.id,
                    saved: false,
                    tocOrder: index
                });
                else {
                    item.tocOrder = index;
                    item.changed = true;
                    item.inError = false;
                }
            }
        });
    }
    newState.saving = true;
    return newState;
};

});

parcelRegister("lmDtA", function(module, exports) {

$parcel$export(module.exports, "toc_reassignTocNumbers", function () { return $ace8bfeda2bd3ed9$export$c2ae119a8cbcdf9e; });

var $lp5N7 = parcelRequire("lp5N7");
const $ace8bfeda2bd3ed9$export$c2ae119a8cbcdf9e = (state)=>{
    const newState = {
        ...state
    };
    newState.tocItems = newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- ToC items should already have a numeric order.
        0) - (second.tocOrder ?? // istanbul ignore next -- ToC items should already have a numeric order.
        0));
    let lastSection = "";
    let lastNumber = 0;
    newState.tocItems = newState.tocItems.map((item)=>{
        if (item instanceof (0, $lp5N7.MosaicTocSectionClass)) {
            lastSection = item.tocNumber;
            lastNumber = 0;
            return item;
        }
        lastNumber++;
        const newTocNumber = lastSection !== "" ? `${lastSection}.${lastNumber}` : "";
        if (newTocNumber !== item.tocNumber) return {
            ...item,
            tocNumber: newTocNumber,
            changed: true,
            inError: false
        };
        return item;
    });
    newState.saving = true;
    return newState;
};

});

parcelRegister("dCMsy", function(module, exports) {

$parcel$export(module.exports, "toc_refresh", function () { return $e2577d081bb805a6$export$e1ba7625da1d0d0; });
const $e2577d081bb805a6$export$e1ba7625da1d0d0 = (state, action)=>{
    const newState = {
        ...state
    };
    newState.changed = false;
    newState.hierarchyId = action.hierarchyId;
    newState.removedItems = action.removedItems ?? [];
    newState.saving = false;
    newState.saveError = false;
    newState.sendUpdate = false;
    newState.tocItems = [
        ...action.items
    ];
    newState.tocItems.sort((first, second)=>(first.tocOrder ?? // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0) - (second.tocOrder ?? // istanbul ignore next -- refreshed ToC items should already carry a persisted order.
        0));
    return newState;
};

});

parcelRegister("gbACq", function(module, exports) {

$parcel$export(module.exports, "toc_saveFail", function () { return $c32855b519ff121a$export$804404ce6ca64db9; });

var $lp5N7 = parcelRequire("lp5N7");
const $c32855b519ff121a$export$804404ce6ca64db9 = (state)=>{
    const newState = {
        ...state
    };
    newState.blocked = false;
    newState.changed = true;
    newState.saveError = true;
    newState.saving = false;
    newState.sendUpdate = false;
    newState.tocItems.filter((item)=>item.changed).forEach((item)=>{
        if (item instanceof (0, $lp5N7.MosaicTocSectionClass)) item.markSaveFailed();
        else {
            item.inError = true;
            item.changed = true;
        }
    });
    return newState;
};

});

parcelRegister("iRGkV", function(module, exports) {

$parcel$export(module.exports, "toc_saveSuccess", function () { return $30f275a651bd62ae$export$abbadbf2e22cae26; });

var $lp5N7 = parcelRequire("lp5N7");
const $30f275a651bd62ae$export$abbadbf2e22cae26 = (state, action)=>{
    const newState = {
        ...state
    };
    newState.tocItems.forEach((item)=>{
        if (item instanceof (0, $lp5N7.MosaicTocSectionClass)) item.markSaved();
        else {
            item.inError = false;
            item.changed = false;
        }
    });
    newState.saving = false;
    newState.blocked = false;
    newState.saveError = false;
    newState.changed = false;
    newState.sendUpdate = true;
    newState.lastMinorVersionSavedAt = action.saveTimeStamp;
    return newState;
};

});

parcelRegister("gxQzQ", function(module, exports) {

$parcel$export(module.exports, "toc_setTocRequestStatus", function () { return $35bf6cc355ca3d50$export$a7c36566e6d32f46; });
const $35bf6cc355ca3d50$export$a7c36566e6d32f46 = (state, action)=>({
        ...state,
        tocRequestStatus: action.tocRequestStatus
    });

});

parcelRegister("7v6lU", function(module, exports) {

$parcel$export(module.exports, "toc_setTypeFilter", function () { return $0b8f602e797dfb0a$export$93cedf76c4089a76; });
const $0b8f602e797dfb0a$export$93cedf76c4089a76 = (state, action)=>({
        ...state,
        showTypes: action.showTypes
    });

});

parcelRegister("8PBoD", function(module, exports) {

$parcel$export(module.exports, "toc_showTocNeedRefresh", function () { return $ac14191737db5680$export$c37340cbfdd3e708; });
const $ac14191737db5680$export$c37340cbfdd3e708 = (state)=>({
        ...state,
        showNeedRefresh: true
    });

});

parcelRegister("fzmMk", function(module, exports) {

$parcel$export(module.exports, "toc_showTocSaveAlert", function () { return $644895b9c274150f$export$91645051c93c25ba; });
const $644895b9c274150f$export$91645051c93c25ba = (state, action)=>({
        ...state,
        showSaveAlert: true,
        tocIdFromMessage: action.tocIdFromMessage
    });

});

parcelRegister("gTRxb", function(module, exports) {

$parcel$export(module.exports, "toc_sortToc", function () { return $591ac2b63e9ab049$export$de199bb0e6f4f13d; });

var $lp5N7 = parcelRequire("lp5N7");

var $d76ZD = parcelRequire("d76ZD");
const $591ac2b63e9ab049$export$de199bb0e6f4f13d = (state)=>{
    const newState = {
        ...state
    };
    newState.tocItems = newState.tocItems.sort((first, second)=>(0, $d76ZD.tocSort)(first.tocNumber, second.tocNumber));
    newState.tocItems.forEach((item, index)=>{
        if (item.tocOrder !== index) {
            if (item instanceof (0, $lp5N7.MosaicTocSectionClass)) item.update({
                id: item.id,
                saved: false,
                tocOrder: index
            });
            else {
                item.tocOrder = index;
                item.changed = true;
                item.inError = false;
            }
        }
    });
    newState.saving = true;
    return newState;
};

});
parcelRegister("d76ZD", function(module, exports) {

$parcel$export(module.exports, "tocSort", function () { return $59b1690938d77a8f$export$61f391d90643b342; });
/**
 * Compares two hierarchical string sections (e.g., "1.2.3" vs "1.10.2") and sorts them accordingly.
 *
 * This function splits each input string by the delimiter '.', creating an array of strings.
 * It then iterates over the parts:
 * - If both parts convert to valid numbers, they are compared numerically.
 * - If one or both parts are not numbers, it falls back to a lexical comparison.
 *
 * The function processes up to the maximum number of parts present in either string.
 *
 * @param a - The first section string to compare.
 * @param b - The second section string to compare.
 * @returns A negative number if `a` should come before `b`, a positive number if `a` should come after `b`, or zero if they are equivalent.
 */ const $59b1690938d77a8f$export$61f391d90643b342 = (a, b)=>{
    const splitA = (a ?? "").split(".");
    const splitB = (b ?? "").split(".");
    for(let i = 0; i < Math.max(splitA.length, splitB.length); i++){
        const partA = splitA[i] || "";
        const partB = splitB[i] || "";
        const numA = parseInt(partA, 10);
        const numB = parseInt(partB, 10);
        if (!isNaN(numA) && !isNaN(numB)) {
            if (numA !== numB) return numA - numB;
        } else {
            if (partA !== partB) return partA.localeCompare(partB);
        }
    }
    return 0;
};

});


parcelRegister("5GKCG", function(module, exports) {

$parcel$export(module.exports, "toc_updateAfterPatch", function () { return $c09b50df2aaf25b2$export$e6f50a1d3e36bb5; });
const $c09b50df2aaf25b2$export$e6f50a1d3e36bb5 = (state)=>({
        ...state,
        blocked: false
    });

});

parcelRegister("inVyK", function(module, exports) {

$parcel$export(module.exports, "toc_updateCommentsFilter", function () { return $7f994a0ddcc28b42$export$bc8db3b1297c3fec; });
const $7f994a0ddcc28b42$export$bc8db3b1297c3fec = (state, action)=>({
        ...state,
        commentsFilter: action.commentsFilter
    });

});

parcelRegister("1HVxb", function(module, exports) {

$parcel$export(module.exports, "toc_updateEntry", function () { return $928467655cb1c3b1$export$f4a7af8f7ebf5793; });

var $kdlCe = parcelRequire("kdlCe");
const $928467655cb1c3b1$export$f4a7af8f7ebf5793 = (state, action)=>{
    const newState = {
        ...state
    };
    const index = newState.tocItems.findIndex((item)=>item.id === action.update.id && (0, $kdlCe.isTitlesFootnotesReadDto)(item));
    /* istanbul ignore else -- callers only update entries that already exist in ToC state. */ if (index > -1) {
        const current = {
            ...newState.tocItems[index]
        };
        current.inError = false;
        current.changed = false;
        Object.keys(action.update).filter((key)=>![
                "id",
                "saved",
                "changed",
                "inError"
            ].includes(key)).forEach((key)=>{
            if (action.update[key] !== current[key]) current[key] = action.update[key];
        });
        newState.tocItems = [
            ...newState.tocItems.slice(0, index),
            current,
            ...newState.tocItems.slice(index + 1)
        ];
    }
    newState.blocked = "getNewVersion";
    return newState;
};

});

parcelRegister("bNZuU", function(module, exports) {

$parcel$export(module.exports, "toc_updateLastMajorVersionSavedAt", function () { return $d5b2c4a02dfb3e34$export$f8b3ad4bc14ce61e; });
const $d5b2c4a02dfb3e34$export$f8b3ad4bc14ce61e = (state, action)=>({
        ...state,
        lastMajorVersionSavedAt: action.savedTimeStamp.getTime()
    });

});

parcelRegister("6Jy5A", function(module, exports) {

$parcel$export(module.exports, "toc_updateSearchText", function () { return $864a82c793978c82$export$727702058c237c46; });
const $864a82c793978c82$export$727702058c237c46 = (state, action)=>({
        ...state,
        searchText: action.searchText
    });

});

parcelRegister("648Q5", function(module, exports) {

$parcel$export(module.exports, "toc_updateSection", function () { return $2efddf01556aa340$export$66d92f1b4b43b1fb; });

var $lp5N7 = parcelRequire("lp5N7");
const $2efddf01556aa340$export$66d92f1b4b43b1fb = (state, action)=>{
    const newState = {
        ...state
    };
    const index = newState.tocItems.findIndex((item)=>item.id === action.update.id && item instanceof (0, $lp5N7.MosaicTocSectionClass));
    /* istanbul ignore else -- callers only update sections that already exist in ToC state. */ if (index > -1) {
        const current = newState.tocItems[index];
        current.update(action.update);
        if (current.changed) newState.saving = true;
    }
    return newState;
};

});

parcelRegister("gPxFT", function(module, exports) {

$parcel$export(module.exports, "toc_updateTrafficLightsFilter", function () { return $90ed3a7ee555500a$export$439c3f58c30be172; });
const $90ed3a7ee555500a$export$439c3f58c30be172 = (state, action)=>({
        ...state,
        trafficLightsFilter: action.trafficLightFilter
    });

});

parcelRegister("1mYsg", function(module, exports) {

$parcel$export(module.exports, "toc_updateViewTiFo", function () { return $ac48b18d4f30786b$export$abff13325407d3eb; });
const $ac48b18d4f30786b$export$abff13325407d3eb = (state, action)=>({
        ...state,
        showTiFo: action.showTiFo
    });

});


parcelRegister("kEQk4", function(module, exports) {
$parcel$export(module.exports, "app_reduceValidationSaveBlockers", function () { return (parcelRequire("l2VIL")).app_reduceValidationSaveBlockers; });
$parcel$export(module.exports, "app_saveCompleted", function () { return (parcelRequire("jIN7z")).app_saveCompleted; });
$parcel$export(module.exports, "app_saveTlfCompleted", function () { return (parcelRequire("9RMDT")).app_saveTlfCompleted; });
$parcel$export(module.exports, "app_setSaveRequest", function () { return (parcelRequire("9G4DM")).app_setSaveRequest; });
$parcel$export(module.exports, "app_undoRedo", function () { return (parcelRequire("bYHsj")).app_undoRedo; });
parcelRequire("l2VIL");
parcelRequire("jIN7z");
parcelRequire("9RMDT");
parcelRequire("9G4DM");
parcelRequire("bYHsj");

});
parcelRegister("l2VIL", function(module, exports) {

$parcel$export(module.exports, "app_reduceValidationSaveBlockers", function () { return $e5d9a771fe1c7c2c$export$e69c1fbde5d7e76c; });

var $4XFMT = parcelRequire("4XFMT");
const $e5d9a771fe1c7c2c$export$e69c1fbde5d7e76c = (state, action)=>{
    const updatedBlockers = new Set(Array.from(state.saveBlockers).filter((blocker)=>blocker.type !== action.propertyKey));
    (0, $4XFMT.createSingletonSaveBlockerSet)(action.propertyKey, action.warningText).forEach((blocker)=>updatedBlockers.add(blocker));
    return {
        ...state,
        saveBlockers: updatedBlockers
    };
};

});
parcelRegister("4XFMT", function(module, exports) {

$parcel$export(module.exports, "createSingletonSaveBlockerSet", function () { return $c0fe87ffc13fb089$export$eed10bfcf8f3a2a4; });
const $c0fe87ffc13fb089$export$eed10bfcf8f3a2a4 = (type, warningText)=>warningText ? new Set([
        {
            id: type,
            type: type,
            warningText: warningText
        }
    ]) : new Set();

});


parcelRegister("jIN7z", function(module, exports) {

$parcel$export(module.exports, "app_saveCompleted", function () { return $2f081c30b41ab2a6$export$fc7a3e9a4f3250f9; });

var $h0kLA = parcelRequire("h0kLA");

var $8v0hS = parcelRequire("8v0hS");

var $0eakK = parcelRequire("0eakK");

var $hnK3q = parcelRequire("hnK3q");

var $eBlbF = parcelRequire("eBlbF");

var $9RMDT = parcelRequire("9RMDT");

var $ctrWF = parcelRequire("ctrWF");
parcelRequire("lerp3");
var $j8b39 = parcelRequire("j8b39");
const $2f081c30b41ab2a6$export$fc7a3e9a4f3250f9 = (state, action)=>{
    if (state.hierarchyState.hierarchy?.id !== action.submittedHierarchy.id || state.tlfState.tlfData?.id !== action.submittedTlfId) return state;
    if (action.result.tlfItem && action.submittedTlfId !== undefined) return (0, $9RMDT.app_saveTlfCompleted)(state, {
        ...action,
        operation: (0, $ctrWF.SAVE_TLF_COMPLETED),
        result: {
            ...action.result,
            tlfItem: action.result.tlfItem
        },
        submittedTlfId: action.submittedTlfId
    });
    const returnedHierarchy = action.result.hierarchy;
    if (!returnedHierarchy) return state;
    const subsequentUpdates = Object.fromEntries(Object.entries((0, $hnK3q.toHierarchyUpdateDto)(state.hierarchyState.hierarchy)).filter(([key, value])=>!(0, $eBlbF.isEqual)(value, action.submittedHierarchy[key])));
    const completedAction = {
        operation: (0, $0eakK.SAVE_HIERARCHY_COMPLETED),
        hierarchy: {
            ...(0, $eBlbF.cloneDeep)(returnedHierarchy),
            clinicalLibrary: state.hierarchyState.hierarchy.clinicalLibrary
        }
    };
    let hierarchyState = (0, $h0kLA.hcr_saveHierarchyCompleted)(state.hierarchyState, completedAction);
    if (Object.keys(subsequentUpdates).length > 0) hierarchyState = (0, $8v0hS.hcr_updateHierarchy)(hierarchyState, {
        operation: (0, $0eakK.UPDATE_HIERARCHY),
        hierarchy: subsequentUpdates,
        isNameChanged: state.hierarchyState.isNameChanged
    });
    return {
        ...state,
        hierarchyState: hierarchyState,
        saveBlockers: (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, completedAction, state.allowedReportTypes)
    };
};

});
parcelRegister("hnK3q", function(module, exports) {

$parcel$export(module.exports, "toHierarchyUpdateDto", function () { return $017399bd99c3db7f$export$66f7c850a8c441fb; });
const $017399bd99c3db7f$export$66f7c850a8c441fb = (hierarchy)=>({
        id: hierarchy.id,
        name: hierarchy.name,
        parentTag: hierarchy.parentTag,
        description: hierarchy.description,
        lists: hierarchy.lists,
        phase: hierarchy.phase,
        reportType: hierarchy.reportType,
        rowGroups: hierarchy.rowGroups,
        sections: hierarchy.sections,
        singles: hierarchy.singles,
        status: hierarchy.status,
        domainList: hierarchy.domainList,
        domainReplacements: hierarchy.domainReplacements,
        arsEnabled: hierarchy.arsEnabled,
        analysisMethods: hierarchy.analysisMethods,
        analysisSets: hierarchy.analysisSets,
        dataSubsets: hierarchy.dataSubsets,
        groupingFactors: hierarchy.groupingFactors,
        tlfTags: hierarchy.tlfTags
    });

});

parcelRegister("9RMDT", function(module, exports) {

$parcel$export(module.exports, "app_saveTlfCompleted", function () { return $679924cb5c40aacd$export$e81de4acd614a86e; });

var $h0kLA = parcelRequire("h0kLA");

var $8v0hS = parcelRequire("8v0hS");

var $0eakK = parcelRequire("0eakK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $jPTUt = parcelRequire("jPTUt");

var $60M0D = parcelRequire("60M0D");

var $f2M6x = parcelRequire("f2M6x");

var $dCMsy = parcelRequire("dCMsy");

var $4lHS7 = parcelRequire("4lHS7");

var $hnK3q = parcelRequire("hnK3q");

var $3UQIM = parcelRequire("3UQIM");

var $3Avah = parcelRequire("3Avah");

var $3JMQg = parcelRequire("3JMQg");

var $ee4vT = parcelRequire("ee4vT");

var $i7S9u = parcelRequire("i7S9u");

var $eBlbF = parcelRequire("eBlbF");
const $679924cb5c40aacd$export$e81de4acd614a86e = (state, action)=>{
    // Check we are saving the active ID
    if (state.tlfState.tlfData?.id !== action.submittedTlfId) return state;
    let hierarchyState = state.hierarchyState;
    // Reapply only fields edited after submission, retaining server-normalised values elsewhere.
    const subsequentUpdates = hierarchyState.hierarchy?.id === action.submittedHierarchy.id ? Object.fromEntries(Object.entries((0, $hnK3q.toHierarchyUpdateDto)(hierarchyState.hierarchy)).filter(([key, value])=>!(0, $eBlbF.isEqual)(value, action.submittedHierarchy[key]))) : {};
    const hasSubsequentUpdates = Object.keys(subsequentUpdates).length > 0;
    const savedMaster = (0, $eBlbF.cloneDeep)(action.result.tlfItem);
    // Hydration belongs to the editor view, never the persisted master or its baseline.
    let savedTlf = (0, $eBlbF.cloneDeep)(savedMaster);
    let variantCompositionFailed = false;
    let fallbackVariantUpdates = {};
    if (action.submittedVariantView && (0, $3Avah.isArsMasterReadDto)(savedMaster)) {
        const composed = (0, $3JMQg.applyVariantPatches)(savedMaster, savedMaster, state.tlfState.appliedVariantPatches);
        if (composed.success) savedTlf = composed.data;
        else {
            variantCompositionFailed = true;
            // A fallback view is not a persisted DTO: retain only editable variant values as dirty edits.
            fallbackVariantUpdates = (0, $eBlbF.cloneDeep)(Object.fromEntries(Object.entries(action.submittedVariantView).filter(([key, value])=>(0, $ee4vT.VARIANT_UPDATEABLE_KEYS).some((allowed)=>allowed === key) && !(0, $eBlbF.isEqual)(value, savedMaster[key]))));
        }
    }
    const returnedHierarchy = action.result.hierarchy;
    if (returnedHierarchy) {
        const existingHierarchy = hierarchyState.hierarchyNodes.find((node)=>node.id === returnedHierarchy.id);
        const savedHierarchy = {
            ...returnedHierarchy,
            clinicalLibrary: hierarchyState.hierarchy?.id === returnedHierarchy.id ? hierarchyState.hierarchy.clinicalLibrary : existingHierarchy?.clinicalLibrary
        };
        if (savedHierarchy.id === hierarchyState.id) {
            hierarchyState = (0, $h0kLA.hcr_saveHierarchyCompleted)(hierarchyState, {
                operation: (0, $0eakK.SAVE_HIERARCHY_COMPLETED),
                hierarchy: savedHierarchy
            });
            if (hasSubsequentUpdates) hierarchyState = (0, $8v0hS.hcr_updateHierarchy)(hierarchyState, {
                operation: (0, $0eakK.UPDATE_HIERARCHY),
                hierarchy: subsequentUpdates,
                isNameChanged: state.hierarchyState.isNameChanged
            });
        } else hierarchyState = {
            ...hierarchyState,
            hierarchyNodes: [
                ...hierarchyState.hierarchyNodes.filter((node)=>node.id !== savedHierarchy.id),
                savedHierarchy
            ]
        };
    }
    if (savedTlf.type === (0, $4lHS7.eTlfItemType).arsTable && savedTlf.primaryHierarchyId === hierarchyState.id) (0, $3UQIM.hydrateArsTableBody)(hierarchyState.hierarchyNodes, savedTlf);
    const tlfItemIndex = [
        ...(hierarchyState.tlfItemIndex ?? []).filter((item)=>!(item.azsolId === savedTlf.azsolId && item.version === savedTlf.version)),
        (0, $i7S9u.toIndexDto)(savedMaster)
    ].sort((first, second)=>first.azsolId.localeCompare(second.azsolId));
    const tocEntry = {
        ...savedMaster,
        changed: false,
        inError: false,
        changedTitles: savedMaster.changedTitles ?? []
    };
    const submittedTlf = action.submittedTlf;
    let subsequentTlfUpdates = {
        ...fallbackVariantUpdates,
        ...submittedTlf && state.tlfState.tlfData ? Object.fromEntries(Object.entries(state.tlfState.tlfData).filter(([key, value])=>!(0, $eBlbF.isEqual)(value, submittedTlf[key]))) : {}
    };
    if (action.submittedVariantView && (0, $3Avah.isArsMasterReadDto)(savedMaster) && (0, $3Avah.isArsMasterReadDto)(state.tlfState.tlfData) && (0, $3Avah.isArsMasterReadDto)(submittedTlf)) {
        const currentMaster = state.tlfState.tlfData;
        const catalog = {
            ...savedMaster.allVariantPatches
        };
        const patchNames = new Set([
            ...Object.keys(submittedTlf.allVariantPatches),
            ...Object.keys(currentMaster.allVariantPatches)
        ]);
        for (const name of patchNames){
            const currentPatch = currentMaster.allVariantPatches[name];
            if (!(0, $eBlbF.isEqual)(currentPatch, submittedTlf.allVariantPatches[name])) {
                if (currentPatch) catalog[name] = (0, $eBlbF.cloneDeep)(currentPatch);
                else delete catalog[name];
            } else if (!(name in catalog) && state.tlfState.appliedVariantPatches.includes(name)) catalog[name] = (0, $eBlbF.cloneDeep)(currentPatch);
        }
        // Catalogue changes are reconciled per patch, never by replacing server-normalised metadata.
        delete subsequentTlfUpdates.allVariantPatches;
        if (!(0, $eBlbF.isEqual)(catalog, savedMaster.allVariantPatches)) {
            // Compose using retained catalogue edits before restoring direct field edits.
            // These values remain a separate undo entry, not part of the persisted save point.
            const retainedMaster = {
                ...savedMaster,
                allVariantPatches: catalog
            };
            const composed = (0, $3JMQg.applyVariantPatches)(retainedMaster, retainedMaster, state.tlfState.appliedVariantPatches);
            const retainedView = composed.success ? composed.data : {
                ...retainedMaster,
                ...(0, $eBlbF.cloneDeep)(Object.fromEntries(Object.entries(currentMaster).filter(([key])=>(0, $ee4vT.VARIANT_UPDATEABLE_KEYS).some((allowed)=>allowed === key))))
            };
            if (retainedView.type === (0, $4lHS7.eTlfItemType).arsTable && retainedView.primaryHierarchyId === hierarchyState.id) (0, $3UQIM.hydrateArsTableBody)(hierarchyState.hierarchyNodes, retainedView);
            // Both values describe the same TLF item (checked via submittedTlfId), so they share a variant.
            // Object.assign is used because spreading the two unions yields cross-variant combinations
            // that TypeScript cannot assign, even though they cannot occur here.
            subsequentTlfUpdates = Object.assign({}, retainedView, subsequentTlfUpdates, {
                allVariantPatches: catalog
            });
        }
    }
    const persistedTlfState = {
        ...state.tlfState
    };
    if (action.submittedVariantView && (0, $3Avah.isArsMasterReadDto)(savedMaster)) {
        // Undo to the save point must not reactivate patches that the server did not persist.
        persistedTlfState.appliedVariantPatches = variantCompositionFailed ? [] : state.tlfState.appliedVariantPatches.filter((name)=>name in savedMaster.allVariantPatches);
        persistedTlfState.activeVariantPatchName = !variantCompositionFailed && state.tlfState.activeVariantPatchName !== null && state.tlfState.activeVariantPatchName in savedMaster.allVariantPatches ? state.tlfState.activeVariantPatchName : null;
    }
    let tlfState = (0, $jPTUt.tlf_updateTlf)(persistedTlfState, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: savedTlf,
        newSavePoint: true,
        calledFrom: "app_saveTlfCompleted"
    });
    if (Object.keys(subsequentTlfUpdates).length > 0 || variantCompositionFailed) tlfState = (0, $jPTUt.tlf_updateTlf)({
        ...tlfState,
        appliedVariantPatches: state.tlfState.appliedVariantPatches,
        activeVariantPatchName: state.tlfState.activeVariantPatchName
    }, {
        operation: (0, $2Mlm8.UPDATE_TLF),
        tlfData: subsequentTlfUpdates,
        calledFrom: "app_saveTlfCompleted:RetainEdits"
    });
    return {
        ...state,
        hierarchyState: {
            ...hierarchyState,
            tlfItemIndex: tlfItemIndex
        },
        tlfState: {
            ...tlfState,
            masterTlfData: (0, $3Avah.isArsMasterReadDto)(savedMaster) ? (0, $60M0D.toArsTlfSnapshot)(savedMaster) : tlfState.masterTlfData
        },
        tocState: (0, $dCMsy.toc_refresh)(state.tocState, {
            operation: (0, $f2M6x.REFRESH),
            hierarchyId: hierarchyState.id,
            items: [
                ...state.tocState.tocItems.filter((item)=>item.id !== savedTlf.id),
                tocEntry
            ]
        })
    };
};

});
parcelRegister("3UQIM", function(module, exports) {

$parcel$export(module.exports, "hydrateArsTableBody", function () { return $5c6136ea490d8ee5$export$63c092d7f3ee6571; });
parcelRequire("6jtLO");
var $c5vs0 = parcelRequire("c5vs0");
/**
 * Coalesces ARS items from multiple hierarchies into a single collection.
 *
 * @param hierarchies - Array of hierarchy objects containing ARS items
 * @returns Coalesced ARS items from all provided hierarchies
 */ const $5c6136ea490d8ee5$var$coalesceArsItemsFromHierarchies = (hierarchies)=>{
    const arsItems = {
        analysisMethods: [
            ...hierarchies.flatMap((h)=>h.analysisMethods).filter((am)=>am !== undefined)
        ],
        operations: [],
        analysisSets: [
            ...hierarchies.flatMap((h)=>h.analysisSets).filter((as)=>as !== undefined)
        ],
        dataSubsets: [
            ...hierarchies.flatMap((h)=>h.dataSubsets).filter((ds)=>ds !== undefined)
        ],
        groupingFactors: [
            ...hierarchies.flatMap((h)=>h.groupingFactors).filter((gf)=>gf !== undefined)
        ]
    };
    arsItems.operations = arsItems.analysisMethods.flatMap((am)=>am.operations);
    return arsItems;
};
/**
 * Hydrates a single table group with the corresponding ARS items based on its identifiers.
 *
 * @param group - The table group to hydrate
 * @param arsItems - Available ARS items for hydration
 */ const $5c6136ea490d8ee5$var$hydrateArsTableGroup = (group, arsItems)=>{
    // Implement the hydration logic for the ArsTableGroup here
    if ("analysisMethodId" in group) group.analysisMethod = arsItems.analysisMethods.find((am)=>am.id === group.analysisMethodId);
    else if ("operationId" in group) group.operation = arsItems.operations.find((op)=>op.id === group.operationId);
    else if ("groupingFactorId" in group) group.groupingFactor = arsItems.groupingFactors.find((gf)=>gf.id === group.groupingFactorId) ?? // If the grouping factor is not found, then add a placeholder item
    {
        ...(0, $c5vs0.totalSidebarItem).data().dropItem,
        id: group.groupingFactorId
    };
    group.subGroups?.forEach((sg)=>$5c6136ea490d8ee5$var$hydrateArsTableGroup(sg, arsItems));
};
const $5c6136ea490d8ee5$export$63c092d7f3ee6571 = (hierarchies, tlfItem)=>{
    // Only ARS tables need this
    if (!("columns" in tlfItem.body && "rows" in tlfItem.body)) return;
    // Implement the hydration logic for ARS items into the ArsTable here
    const body = tlfItem.body;
    const arsItems = $5c6136ea490d8ee5$var$coalesceArsItemsFromHierarchies(hierarchies);
    body.columns.forEach((g)=>$5c6136ea490d8ee5$var$hydrateArsTableGroup(g, arsItems));
    body.rows.forEach((g)=>$5c6136ea490d8ee5$var$hydrateArsTableGroup(g, arsItems));
};

});

parcelRegister("i7S9u", function(module, exports) {

$parcel$export(module.exports, "toIndexDto", function () { return $aa16d5dacc08bb3d$export$ac1fa944a44ed3d4; });
const $aa16d5dacc08bb3d$export$ac1fa944a44ed3d4 = (tlfItem)=>({
        id: tlfItem.id,
        azsolId: tlfItem.azsolId,
        version: tlfItem.version,
        primaryHierarchyId: tlfItem.primaryHierarchyId,
        primaryHierarchyLevel: tlfItem.primaryHierarchyLevel,
        primaryHierarchyName: tlfItem.primaryHierarchyName,
        primaryHierarchyType: tlfItem.primaryHierarchyType,
        taPrefix: tlfItem.taPrefix,
        projectCode: tlfItem.projectCode,
        dNumber: tlfItem.dNumber,
        hierarchyLinks: tlfItem.hierarchyLinks,
        singles: tlfItem.singles,
        tocOrder: tlfItem.tocOrder,
        tocNumber: tlfItem.tocNumber,
        tocLabel: tlfItem.tocLabel,
        tocReleaseStatus: tlfItem.tocReleaseStatus,
        tocOriginTrafficLight: tlfItem.tocOriginTrafficLight,
        coreTrafficLight: tlfItem.coreTrafficLight,
        coreTrafficLightSwitch: tlfItem.coreTrafficLightSwitch,
        additionalInformation: tlfItem.additionalInformation,
        type: tlfItem.type,
        domain: tlfItem.domain,
        tlfTags: tlfItem.tlfTags,
        releaseDate: tlfItem.releaseDate,
        decommissionDate: tlfItem.decommissionDate,
        releaseStatus: tlfItem.releaseStatus,
        relationships: tlfItem.relationships,
        isBackupVersion: tlfItem.isBackupVersion,
        lastUpdatedFromHistory: tlfItem.lastUpdatedFromHistory
    });

});


parcelRegister("ctrWF", function(module, exports) {

$parcel$export(module.exports, "UNDO", function () { return $d211c0e5bd5645c2$export$43a2f1ba8f9235b5; });
$parcel$export(module.exports, "REDO", function () { return $d211c0e5bd5645c2$export$ad4c0b8108ea0716; });
$parcel$export(module.exports, "SAVE_COMPLETED", function () { return $d211c0e5bd5645c2$export$c02237111296b13f; });
$parcel$export(module.exports, "SAVE_TLF_COMPLETED", function () { return $d211c0e5bd5645c2$export$c15ef9eb5837444c; });
$parcel$export(module.exports, "SET_HIERARCHY_VALIDATION_SAVE_BLOCKER", function () { return $d211c0e5bd5645c2$export$2fe516e76939f1a0; });
$parcel$export(module.exports, "SET_SAVE_REQUEST", function () { return $d211c0e5bd5645c2$export$a379b55d6bcff7; });
const $d211c0e5bd5645c2$export$43a2f1ba8f9235b5 = "UNDO";
const $d211c0e5bd5645c2$export$ad4c0b8108ea0716 = "REDO";
const $d211c0e5bd5645c2$export$c02237111296b13f = "SAVE_COMPLETED";
const $d211c0e5bd5645c2$export$c15ef9eb5837444c = "SAVE_TLF_COMPLETED";
const $d211c0e5bd5645c2$export$2fe516e76939f1a0 = "SET_HIERARCHY_VALIDATION_SAVE_BLOCKER";
const $d211c0e5bd5645c2$export$a379b55d6bcff7 = "SET_SAVE_REQUEST";

});

parcelRegister("lerp3", function(module, exports) {
$parcel$export(module.exports, "isValidReportTypeSelection", function () { return (parcelRequire("k9IqU")).isValidReportTypeSelection; });
$parcel$export(module.exports, "reduceHierarchySaveBlockers", function () { return (parcelRequire("j8b39")).reduceHierarchySaveBlockers; });
parcelRequire("4XFMT");
parcelRequire("lABIC");
parcelRequire("5FmZb");
parcelRequire("fKAEx");
parcelRequire("k9IqU");
parcelRequire("j8b39");
parcelRequire("g4cWJ");

});
parcelRegister("lABIC", function(module, exports) {

$parcel$export(module.exports, "getDomainReplacementsSaveBlockers", function () { return $8140f6903f22cc90$export$72ba12f79017fb26; });

var $81cs6 = parcelRequire("81cs6");
const $8140f6903f22cc90$export$72ba12f79017fb26 = (hierarchy)=>(0, $81cs6.getReplacementSaveBlockers)(hierarchy?.domainReplacements ?? [], (a, b)=>a.domain === b.domain && a.oldText === b.oldText, "domainReplacements");

});
parcelRegister("81cs6", function(module, exports) {

$parcel$export(module.exports, "getReplacementSaveBlockers", function () { return $b54e936ab7b8efc0$export$d45a06b2a2a41ca9; });
const $b54e936ab7b8efc0$export$d45a06b2a2a41ca9 = (replacements, isDuplicate, replacementType)=>{
    const blockers = new Set();
    replacements.forEach((replacement)=>{
        if (replacement.oldText === "") blockers.add({
            id: replacement.airid,
            type: replacementType,
            warningText: "Missing text will be ignored"
        });
        if (replacements.filter((other)=>isDuplicate(replacement, other)).length > 1) blockers.add({
            id: replacement.airid,
            type: replacementType,
            warningText: "Duplicates will cause unpredictable results"
        });
        if (replacement.oldText !== "" && replacement.newText.lines.map((l)=>l.textBlocks.map((b)=>b.text).join("")).join("\n").includes(replacement.oldText)) blockers.add({
            id: replacement.airid,
            type: replacementType,
            warningText: "New text cannot contain the original text"
        });
    });
    return blockers;
};

});


parcelRegister("5FmZb", function(module, exports) {

$parcel$export(module.exports, "getSinglesSaveBlockers", function () { return $7ed24a4a426b72db$export$ff81dcc6da0c133b; });

var $81cs6 = parcelRequire("81cs6");
const $7ed24a4a426b72db$export$ff81dcc6da0c133b = (hierarchy)=>(0, $81cs6.getReplacementSaveBlockers)(hierarchy?.singles ?? [], (a, b)=>a.oldText === b.oldText, "singles");

});

parcelRegister("fKAEx", function(module, exports) {
/**
 * Save blocker categories that are re-derived from hierarchy replacement state.
 */ 
});

parcelRegister("k9IqU", function(module, exports) {

$parcel$export(module.exports, "isValidReportTypeSelection", function () { return $9e0faa25c0eb794c$export$322fd9b1ed9af30d; });
/**
 * Determines whether a report type selection is valid against the centrally loaded allowed list.
 *
 * @param reportTypeValue - The current report type value from the hierarchy.
 * @param allowedReportTypes - The allowed report types loaded into app settings.
 * @returns `true` when the value is non-blank and present in the allowed list.
 */ const $9e0faa25c0eb794c$export$322fd9b1ed9af30d = (reportTypeValue, allowedReportTypes)=>{
    return reportTypeValue !== undefined && reportTypeValue !== "" && allowedReportTypes.includes(reportTypeValue);
};

});

parcelRegister("j8b39", function(module, exports) {

$parcel$export(module.exports, "reduceHierarchySaveBlockers", function () { return $11403dae1f0850c1$export$f1a970cae654309a; });

var $0eakK = parcelRequire("0eakK");

var $4lHS7 = parcelRequire("4lHS7");

var $lABIC = parcelRequire("lABIC");

var $5FmZb = parcelRequire("5FmZb");

var $k9IqU = parcelRequire("k9IqU");

var $g4cWJ = parcelRequire("g4cWJ");
const $11403dae1f0850c1$export$f1a970cae654309a = (saveBlockers, hierarchyState, action, allowedReportTypes)=>{
    const shouldRefreshReplacementSaveBlockers = (0, $g4cWJ.shouldRebuildDerivedSaveBlockers)(action);
    const shouldRefreshReportTypeSaveBlocker = new Set([
        $0eakK.CLEAR_HIERARCHY,
        $0eakK.LOAD_HIERARCHY,
        $0eakK.SAVE_HIERARCHY_COMPLETED,
        $0eakK.UPDATE_HIERARCHY
    ]).has(action.operation);
    const updatedBlockers = [
        $0eakK.CLEAR_HIERARCHY,
        $0eakK.LOAD_HIERARCHY
    ].includes(action.operation) ? new Set() : !shouldRefreshReplacementSaveBlockers && !shouldRefreshReportTypeSaveBlocker ? saveBlockers : action.operation === $0eakK.SAVE_HIERARCHY_COMPLETED ? new Set() : new Set(Array.from(saveBlockers).filter((blocker)=>(!shouldRefreshReplacementSaveBlockers || blocker.type !== "singles" && blocker.type !== "domainReplacements") && (!shouldRefreshReportTypeSaveBlocker || blocker.type !== "reportType") && (!("arsSaveBlockers" in action) || blocker.type !== "arsObjects")));
    if (shouldRefreshReplacementSaveBlockers) {
        (0, $5FmZb.getSinglesSaveBlockers)(hierarchyState.hierarchy).forEach((blocker)=>updatedBlockers.add(blocker));
        (0, $lABIC.getDomainReplacementsSaveBlockers)(hierarchyState.hierarchy).forEach((blocker)=>updatedBlockers.add(blocker));
    }
    if (shouldRefreshReportTypeSaveBlocker && hierarchyState.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report && allowedReportTypes.length > 0 && !(0, $k9IqU.isValidReportTypeSelection)(hierarchyState.hierarchy.reportType, allowedReportTypes)) updatedBlockers.add({
        id: "reportType",
        type: "reportType",
        warningText: "Before saving the report, specify a valid report type."
    });
    if ("arsSaveBlockers" in action && action.arsSaveBlockers) action.arsSaveBlockers.forEach((blocker)=>updatedBlockers.add(blocker));
    return updatedBlockers;
};

});
parcelRegister("g4cWJ", function(module, exports) {

$parcel$export(module.exports, "shouldRebuildDerivedSaveBlockers", function () { return $21157a91f7f5ac20$export$368cb24ea861b7e5; });

var $0eakK = parcelRequire("0eakK");
const $21157a91f7f5ac20$export$368cb24ea861b7e5 = (action)=>{
    return new Set([
        $0eakK.ADD_DOMAIN_REPLACEMENT,
        $0eakK.ADD_SINGLE_REPLACEMENT,
        $0eakK.REMOVE_DOMAIN_REPLACEMENT,
        $0eakK.REMOVE_SINGLE_REPLACEMENT,
        $0eakK.SAVE_HIERARCHY_COMPLETED,
        $0eakK.UPDATE_DOMAIN_REPLACEMENT,
        $0eakK.UPDATE_HIERARCHY,
        $0eakK.UPDATE_SINGLE_REPLACEMENT
    ]).has(action.operation);
};

});




parcelRegister("9G4DM", function(module, exports) {

$parcel$export(module.exports, "app_setSaveRequest", function () { return $af0b5ea41598b656$export$434d2937fbab86b3; });
const $af0b5ea41598b656$export$434d2937fbab86b3 = (state, action)=>({
        ...state,
        saveRequest: action.saveRequest
    });

});

parcelRegister("bYHsj", function(module, exports) {

$parcel$export(module.exports, "app_undoRedo", function () { return $114d5c732d3df488$export$65190c30c0e3477f; });

var $8apm4 = parcelRequire("8apm4");

var $hUmQb = parcelRequire("hUmQb");

var $0eakK = parcelRequire("0eakK");

var $3DUZ0 = parcelRequire("3DUZ0");

var $huS79 = parcelRequire("huS79");

var $ea3F0 = parcelRequire("ea3F0");

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $ctrWF = parcelRequire("ctrWF");

var $8KLbz = parcelRequire("8KLbz");
parcelRequire("lerp3");
var $j8b39 = parcelRequire("j8b39");

var $jlghD = parcelRequire("jlghD");
const $114d5c732d3df488$export$65190c30c0e3477f = (state, action)=>{
    const requested = action.steps ?? 1;
    const steps = Number.isNaN(requested) ? 0 : Math.max(0, Math.floor(requested));
    const redo = action.operation === (0, $ctrWF.REDO);
    const index = redo ? Math.min(state.undoHistory.length, state.undoIndex + steps) : Math.max(0, state.undoIndex - steps);
    if (index === state.undoIndex) return state;
    const data = (0, $eBlbF.cloneDeep)((0, $jlghD.toEditableData)(state));
    let tlfDataChanged = false;
    for(let cursor = state.undoIndex; cursor !== index; cursor += redo ? 1 : -1){
        const entry = state.undoHistory[redo ? cursor : cursor - 1];
        const patch = redo ? entry.forward : entry.reverse;
        const changesTlf = patch.some((operation)=>(0, $8KLbz.isTlfEditablePath)(operation.path));
        if (changesTlf && (0, $huS79.isTlfReadOnly)({
            ...state.tlfState,
            tlfData: data.tlfData
        }, {
            ...state.hierarchyState,
            hierarchy: data.hierarchy
        })) // Decline the complete command rather than partially undoing a protected mixed transaction.
        return state;
        (0, $3ew5o.applyPatch)(data, patch);
        if (changesTlf) tlfDataChanged = true;
    }
    const tlfState = tlfDataChanged ? (0, $ea3F0.updateActivePatchErrors)({
        ...state.tlfState,
        ...data.variant,
        tlfData: data.tlfData,
        forcePushToParent: true
    }) : state.tlfState;
    if (tlfDataChanged) (0, $3DUZ0.checkChanged)(tlfState);
    let hierarchyState = {
        ...state.hierarchyState,
        hierarchy: data.hierarchy,
        hierarchyNodes: data.hierarchyNodes
    };
    const hierarchy = hierarchyState.hierarchy;
    if (hierarchy) {
        hierarchyState.hierarchyNodes = hierarchyState.hierarchyNodes.map((node)=>node.id === hierarchy.id ? hierarchy : node);
        hierarchyState = (0, $8apm4.hcr_updateChangedFlag)(hierarchyState, {
            operation: (0, $0eakK.UPDATE_HIERARCHY),
            hierarchy: {}
        });
        hierarchyState.parentTemplates = (0, $hUmQb.hcr_buildParentTemplates)(hierarchy, hierarchyState.hierarchyNodes);
        hierarchyState.isNameChanged = hierarchy.name !== hierarchyState.savedHierarchy?.name;
    }
    const saveBlockers = (0, $j8b39.reduceHierarchySaveBlockers)(state.saveBlockers, hierarchyState, {
        operation: (0, $0eakK.UPDATE_HIERARCHY),
        hierarchy: {}
    }, state.allowedReportTypes);
    return {
        ...state,
        tlfState: tlfState,
        hierarchyState: hierarchyState,
        saveBlockers: saveBlockers,
        undoIndex: index
    };
};

});
parcelRegister("huS79", function(module, exports) {

$parcel$export(module.exports, "isTlfReadOnly", function () { return $d14af7345dff7556$export$3e70824251f972a; });

var $4lHS7 = parcelRequire("4lHS7");
const $d14af7345dff7556$export$3e70824251f972a = (tlfState, hierarchyState)=>tlfState.readOnly || hierarchyState.hierarchy?.isBackupVersion === true || !hierarchyState.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) || tlfState.tlfData !== null && ![
        (0, $4lHS7.eReleaseStatus).Draft,
        (0, $4lHS7.eReleaseStatus).ReleasePending
    ].includes(tlfState.tlfData.releaseStatus);

});

parcelRegister("8KLbz", function(module, exports) {

$parcel$export(module.exports, "isTlfEditablePath", function () { return $66c8b7ad9895a82b$export$295e4a221dcbd717; });
/**
 * Identifies TLF data and variant metadata paths belonging to the same editable transaction.
 *
 * @param path - JSON pointer from a unified history operation.
 * @returns Whether the operation affects the TLF view or its variant composition.
 */ const $66c8b7ad9895a82b$export$295e4a221dcbd717 = (path)=>path === "/tlfData" || path.startsWith("/tlfData/") || path === "/variant" || path.startsWith("/variant/");

});

parcelRegister("jlghD", function(module, exports) {

$parcel$export(module.exports, "toEditableData", function () { return $f2371a3f50f65c73$export$c8f51bc2d8883adb; });

var $eBlbF = parcelRequire("eBlbF");
const $f2371a3f50f65c73$export$c8f51bc2d8883adb = (state)=>({
        tlfData: (0, $eBlbF.cloneDeep)(state.tlfState.tlfData),
        hierarchy: (0, $eBlbF.cloneDeep)(state.hierarchyState.hierarchy),
        hierarchyNodes: (0, $eBlbF.cloneDeep)(state.hierarchyState.hierarchyNodes),
        variant: {
            masterTlfData: (0, $eBlbF.cloneDeep)(state.tlfState.masterTlfData),
            appliedVariantPatches: (0, $eBlbF.cloneDeep)(state.tlfState.appliedVariantPatches),
            activeVariantPatchName: (0, $eBlbF.cloneDeep)(state.tlfState.activeVariantPatchName),
            variantCreationView: (0, $eBlbF.cloneDeep)(state.tlfState.variantCreationView)
        }
    });

});



parcelRegister("faq47", function(module, exports) {

$parcel$export(module.exports, "finishHistory", function () { return $f4a37c1fb3351d47$export$de6a014326b90c68; });

var $ctrWF = parcelRequire("ctrWF");

var $0eakK = parcelRequire("0eakK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $dx6SZ = parcelRequire("dx6SZ");

var $8KLbz = parcelRequire("8KLbz");

var $jlghD = parcelRequire("jlghD");
/** Domain operations representing local edits rather than synchronisation or UI changes. */ const $f4a37c1fb3351d47$var$editableOperations = new Set([
    $0eakK.ADD_DOMAIN_REPLACEMENT,
    $0eakK.ADD_SINGLE_REPLACEMENT,
    $0eakK.REMOVE_DOMAIN_REPLACEMENT,
    $0eakK.REMOVE_SINGLE_REPLACEMENT,
    $0eakK.UPDATE_DOMAIN_REPLACEMENT,
    $0eakK.UPDATE_SINGLE_REPLACEMENT,
    $0eakK.UPDATE_HIERARCHY,
    $2Mlm8.ACTIVATE_VARIANT_PATCH,
    $2Mlm8.APPLY_VARIANT_TEMPLATE,
    $2Mlm8.CANCEL_VARIANT_PATCH_CREATION,
    $2Mlm8.CREATE_VARIANT_PATCH,
    $2Mlm8.REMOVE_VARIANT_PATCH,
    $2Mlm8.REMOVE_VARIANT_TEMPLATE,
    $2Mlm8.RENAME_VARIANT_PATCH,
    $2Mlm8.RENAME_VARIANT_TEMPLATE,
    $2Mlm8.REVERT_TO_VARIANT_MASTER,
    $2Mlm8.SET_VARIANT_CREATION_VIEW,
    $2Mlm8.SET_VARIANT_PATCH_SELECTION,
    $2Mlm8.TOGGLE_VARIANT_PATCH,
    $2Mlm8.UPDATE_TLF,
    $2Mlm8.UPSERT_VARIANT_TEMPLATE
]);
const $f4a37c1fb3351d47$export$de6a014326b90c68 = (previous, next, action)=>{
    /** If a undo stack should be reset due to certain actions. */ const reset = action.operation === $ctrWF.SAVE_COMPLETED && (previous.hierarchyState.hierarchy?.id !== next.hierarchyState.hierarchy?.id || previous.tlfState.tlfData?.id !== next.tlfState.tlfData?.id) || action.operation === $2Mlm8.LOAD_TLF || action.operation === $2Mlm8.CLEAR_TLF || action.operation === $0eakK.LOAD_HIERARCHY || action.operation === $0eakK.CLEAR_HIERARCHY || action.operation === $0eakK.SET_HIERARCHY_ID && previous.hierarchyState.id !== next.hierarchyState.id || action.operation === $0eakK.SAVE_HIERARCHY_COMPLETED && previous.hierarchyState.hierarchy?.id !== next.hierarchyState.hierarchy?.id || action.operation === $2Mlm8.UPDATE_TLF && action.newSavePoint && previous.tlfState.tlfData?.id !== next.tlfState.tlfData?.id || action.operation === $2Mlm8.UPDATE_TLF && action.reset;
    if (reset) return {
        ...next,
        undoHistory: [],
        undoIndex: 0
    };
    const isExternal = action.operation === $2Mlm8.UPDATE_TLF && (action.newSavePoint || action.doNotAddUndo) || action.operation === $0eakK.UPDATE_HIERARCHY && (!!action.savedHierarchy || action.isSynchronisation === true) || "calledFrom" in action && action.calledFrom?.startsWith("SignalR") === true;
    if (action.operation === $2Mlm8.UPDATE_TLF && action.newSavePoint || action.operation === $2Mlm8.TRACK_ACTIVE_VARIANT_PATCH) {
        const before = (0, $jlghD.toEditableData)(previous);
        const after = (0, $jlghD.toEditableData)(next);
        const normalisation = (0, $dx6SZ.editablePatch)(before, after);
        const index = previous.undoHistory.slice(0, previous.undoIndex).findLastIndex((entry)=>entry.forward.some((patch)=>(0, $8KLbz.isTlfEditablePath)(patch.path)));
        if (normalisation.length > 0 && index >= 0) {
            // Fold derived catalogues or server normalisation into their originating TLF edit.
            const history = previous.undoHistory.slice(0, previous.undoIndex);
            const entry = history[index];
            history[index] = {
                forward: [
                    ...entry.forward,
                    ...normalisation
                ],
                reverse: [
                    ...(0, $dx6SZ.editablePatch)(after, before),
                    ...entry.reverse
                ]
            };
            return {
                ...next,
                undoHistory: history
            };
        }
    }
    if (!isExternal && $f4a37c1fb3351d47$var$editableOperations.has(action.operation)) {
        const before = (0, $jlghD.toEditableData)(previous);
        const after = (0, $jlghD.toEditableData)(next);
        const forward = (0, $dx6SZ.editablePatch)(before, after);
        if (forward.length > 0) {
            const history = previous.undoHistory.slice(0, previous.undoIndex);
            history.push({
                forward: forward,
                reverse: (0, $dx6SZ.editablePatch)(after, before)
            });
            return {
                ...next,
                undoHistory: history,
                undoIndex: history.length
            };
        }
    }
    if ((isExternal || !$f4a37c1fb3351d47$var$editableOperations.has(action.operation)) && (previous.tlfState.tlfData !== next.tlfState.tlfData || previous.tlfState.masterTlfData !== next.tlfState.masterTlfData || previous.tlfState.appliedVariantPatches !== next.tlfState.appliedVariantPatches || previous.tlfState.activeVariantPatchName !== next.tlfState.activeVariantPatchName || previous.tlfState.variantCreationView !== next.tlfState.variantCreationView || previous.hierarchyState.hierarchy !== next.hierarchyState.hierarchy || previous.hierarchyState.hierarchyNodes !== next.hierarchyState.hierarchyNodes)) {
        // Remote writes win; overlapping changes invalidate the whole dependent patch sequence.
        const remote = (0, $dx6SZ.editablePatch)((0, $jlghD.toEditableData)(previous), (0, $jlghD.toEditableData)(next));
        /**
     * Identifies local patch paths overwritten by remote synchronisation.
     *
     * @param path - Local editable-data JSON pointer.
     * @returns Whether a remote write replaces this path or one of its ancestors or descendants.
     */ const overlaps = (path)=>remote.some((patch)=>{
                // Array insertion/removal shifts indices, so conflicts cover the entire collection.
                const localPath = path.replace(/\/\d+(\/.*)?$/, "");
                const remotePath = patch.path.replace(/\/\d+(\/.*)?$/, "");
                return localPath === remotePath || localPath.startsWith(`${remotePath}/`) || remotePath.startsWith(`${localPath}/`);
            });
        const conflict = previous.undoHistory.some((entry)=>[
                ...entry.forward,
                ...entry.reverse
            ].some((patch)=>overlaps(patch.path)));
        if (conflict) return {
            ...next,
            undoHistory: [],
            undoIndex: 0
        };
    }
    return next;
};

});
parcelRegister("dx6SZ", function(module, exports) {

$parcel$export(module.exports, "editablePatch", function () { return $df1cb007ec714818$export$19a77a0f840b684c; });

var $eBlbF = parcelRequire("eBlbF");

var $3ew5o = parcelRequire("3ew5o");

var $d04Xe = parcelRequire("d04Xe");

var $5mgHe = parcelRequire("5mgHe");
const $df1cb007ec714818$export$19a77a0f840b684c = (before, after)=>{
    // Omission is only a no-op check; operation values always come from complete domain objects.
    if ((0, $eBlbF.isEqual)((0, $5mgHe.omitStaticMetadata)(before), (0, $5mgHe.omitStaticMetadata)(after))) return [];
    return (0, $eBlbF.cloneDeep)((0, $3ew5o.createPatch)(before, after, (_input, _output, ptr)=>(0, $d04Xe.isEditableMetadataPath)(ptr.tokens.slice(1)) ? [] : undefined).filter((operation)=>!(0, $d04Xe.isEditableMetadataPath)(operation.path.split("/").slice(1).map((segment)=>segment.replace(/~1/g, "/").replace(/~0/g, "~")))));
};

});



parcelRegister("7EL5p", function(module, exports) {

$parcel$export(module.exports, "KeyboardBindings", function () { return $6f27fb8441813176$export$cb39f2c96aa94e1; });

var $spJKX = parcelRequire("spJKX");

var $ctrWF = parcelRequire("ctrWF");

var $3tNrK = parcelRequire("3tNrK");
const $6f27fb8441813176$export$cb39f2c96aa94e1 = ()=>{
    const { dispatch: dispatch, undoIndex: undoIndex, undoHistory: undoHistory } = (0, $3tNrK.useAppSettings)();
    (0, $spJKX.useEffect)(()=>{
        /**
     * Dispatches an available history action for Ctrl+Z or Ctrl+Y.
     *
     * @param event - Keyboard event received anywhere in the application.
     */ const handleKeyDown = (event)=>{
            const key = typeof event.key === "string" ? event.key.toLowerCase() : "";
            if (event.ctrlKey && !event.altKey && !event.metaKey && !event.shiftKey && !event.defaultPrevented && (key === "z" && undoIndex > 0 || key === "y" && undoIndex < undoHistory.length)) {
                event.preventDefault();
                dispatch({
                    operation: key === "z" ? (0, $ctrWF.UNDO) : (0, $ctrWF.REDO)
                });
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        dispatch,
        undoIndex,
        undoHistory.length
    ]);
    return null;
};
$6f27fb8441813176$export$cb39f2c96aa94e1.displayName = "KeyboardBindings";

});

parcelRegister("irvto", function(module, exports) {

$parcel$export(module.exports, "SignalRContext", function () { return $754e05db5f4147ff$export$f89226e2c0f985ba; });
$parcel$export(module.exports, "SignalRProvider", function () { return $754e05db5f4147ff$export$d9137f7c4ee47bfb; });

var $bR5nk = parcelRequire("bR5nk");

var $h9eE2 = parcelRequire("h9eE2");
parcelRequire("6jtLO");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");

var $eL8NP = parcelRequire("eL8NP");

var $spJKX = parcelRequire("spJKX");

var $gilEr = parcelRequire("gilEr");
const $754e05db5f4147ff$export$f89226e2c0f985ba = /*#__PURE__*/ (0, $spJKX.createContext)(null);
const $754e05db5f4147ff$export$d9137f7c4ee47bfb = ({ children: children })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [connection, setConnection] = (0, $spJKX.useState)(null);
    const [joinGroupList, setJoinGroupList] = (0, $spJKX.useState)(new Set());
    const [groups, setGroups] = (0, $spJKX.useState)(new Set());
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const MAX_SIGNALR_CONNECTION_ATTEMPTS = 3;
    // Max is 32K, however we still get errors as 32000, so reducing further
    const MAX_SIGNALR_MESSAGE_LENGTH = 28000;
    const [isConnecting, setIsConnecting] = (0, $spJKX.useState)(false);
    const [connectionAttempts, setConnectionAttempts] = (0, $spJKX.useState)(0);
    /**
   * Connect to SignalR hub asynchronously.
   */ const connectToHubAsync = (0, $spJKX.useEffectEvent)(async ()=>{
        /* istanbul ignore else */ if (appSettings.appSettingsLoaded && appSettings.displayName && (!connection || connection.state === (0, $h9eE2.HubConnectionState).Disconnected)) try {
            setIsConnecting(true);
            setConnectionAttempts(connectionAttempts + 1);
            const connection = await (0, $gilEr.connectToHub)(`${appSettings.backEndUrl}hubs/notifications`);
            setConnection(connection);
            /**
         * Processes incoming SignalR messages and updates group membership.
         *
         * @param message - The message string to process
         */ const processSignalRMessage = (message)=>{
                const messageDetails = JSON.parse(message);
                if (connection && messageDetails.displayName === connection.connectionId) return;
                console.debug("Received message from group:", messageDetails.groupName, messageDetails);
                if (messageDetails.messageType === "joinGroup") {
                    setGroups((prev)=>new Set(prev).add(messageDetails.groupName));
                    return;
                }
            };
            if (connection && connection.state === (0, $h9eE2.HubConnectionState).Connected) connection.on("SendMessageToGroup", processSignalRMessage);
        } catch (error) {
            /* istanbul ignore next */ console.warn("Error starting SignalR:", error);
        } finally{
            setIsConnecting(false);
        }
    });
    /**
   * Check message size before sending to the group, then add the message to the list of sent messages.
   * @param message Message to send
   * @param groupName Name of the group to send the message to
   */ const checkBeforeSendToGroup = (0, $spJKX.useCallback)(async (message, groupName)=>{
        /* istanbul ignore else */ if (connection) {
            message.displayName = connection.connectionId;
            const len = JSON.stringify(message).length;
            if (len > MAX_SIGNALR_MESSAGE_LENGTH) {
                message.messageType = "tooBig";
                message.text = [
                    "{}"
                ];
            }
            console.debug("Sending message ", message.messageId, "to group:", groupName, " from:", message.displayName, " - ", connection.connectionId);
            // Wait before sending to allow for state updates
            // Wait for the connection to be connected before invoking.
            /**
         * Wait until the given HubConnection reaches `Connected` state or the timeout expires.
         *
         * @param conn - HubConnection to wait for
         * @param timeout - Timeout in milliseconds
         * @returns true if connected within timeout, false otherwise
         */ const waitForConnected = async (conn, timeout = 2000)=>{
                const start = Date.now();
                while(conn.state !== (0, $h9eE2.HubConnectionState).Connected && Date.now() - start < timeout)await new Promise((r)=>setTimeout(r, 25));
                return conn.state === (0, $h9eE2.HubConnectionState).Connected;
            };
            try {
                const ready = await waitForConnected(connection);
                /* istanbul ignore next */ if (!ready) {
                    console.warn("Connection not ready to send message");
                    return;
                }
                await connection.invoke("SendMessageToGroup", JSON.stringify(message), groupName);
            } catch (err) {
                console.warn("Error sending message to group!", err);
                console.group("Message to group failed");
                console.warn("Message length: ", JSON.stringify(message).length);
                console.warn("Message: ", message);
                console.groupEnd();
            }
        }
    }, [
        connection
    ]);
    /**
   * Send a message to a specific group.
   * @param message The message to send
   * @param groupName The name of the group to send the message to
   * @param messageType The type of the message, defaults to "message"
   * @returns A promise that resolves when the message is sent
   */ const sendMessageToGroup = (0, $spJKX.useCallback)(async (message, groupName, messageType)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: messageType,
            text: message.split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a Table of Contents (ToC) update to a specific group.
   * @param actionSignal The ToC action signal containing the update details
   * @param groupName The name of the group to send the update to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTocUpdateToGroup = (0, $spJKX.useCallback)(async (actionSignal, groupName)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tocUpdate",
            text: JSON.stringify(actionSignal).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a TLF (Table of Contents) update to a specific group.
   * @param actionSignal The TLF update action signal containing the update details
   * @param groupName The name of the group to send the update to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTlfUpdateToGroup = (0, $spJKX.useCallback)(async (actionSignal, groupName)=>{
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tlfUpdate",
            text: JSON.stringify(actionSignal).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Send a Table of Contents (ToC) save to a specific group.
   * @param saveSignal The ToC save signal containing the new hierarchy
   * @param groupName The name of the group to send the save to
   * @returns A promise that resolves to the HubGroupMessage sent
   */ const sendTocSaveToGroup = (0, $spJKX.useCallback)(async (saveSignal, groupName)=>{
        const tocAction = {
            hierarchy: saveSignal.newHierarchy,
            items: []
        };
        const newMessage = {
            messageId: crypto.randomUUID(),
            groupName: groupName,
            displayName: "",
            timeStamp: Date.now(),
            messageType: "tocSave",
            text: JSON.stringify(tocAction).split("\n").map((m)=>m.trim())
        };
        await checkBeforeSendToGroup(newMessage, groupName);
        return newMessage;
    }, [
        checkBeforeSendToGroup
    ]);
    /**
   * Connect to a SignalR group.
   * @param group Name of the group to connect to
   * @returns A promise that resolves when the connection is established
   */ const connectToGroup = (0, $spJKX.useCallback)(async (newGroup)=>{
        /* istanbul ignore else */ if (connection && !groups.has(newGroup) && !joinGroupList.has(newGroup)) {
            await connection.invoke("JoinGroup", newGroup, `${appSettings.displayName}~${connection.connectionId}`);
            startTransition(()=>setJoinGroupList((prev)=>new Set(prev).add(newGroup)));
            console.debug("Joining group:", newGroup);
        }
    }, [
        appSettings.displayName,
        connection,
        groups,
        joinGroupList
    ]);
    /**
   * Effect to connect to SignalR hub when displayName changes or connection is disconnected.
   */ (0, $spJKX.useEffect)(()=>{
        if ((!connection || connection.state === (0, $h9eE2.HubConnectionState).Disconnected) && !isConnecting && connectionAttempts < MAX_SIGNALR_CONNECTION_ATTEMPTS && !pending) startTransition(()=>connectToHubAsync());
    }, [
        appSettings.displayName,
        connection,
        connectionAttempts,
        isConnecting,
        pending
    ]);
    return connectionAttempts >= MAX_SIGNALR_CONNECTION_ATTEMPTS ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eL8NP.default), {}) : !connection || connection.state !== (0, $h9eE2.HubConnectionState).Connected ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
        text: "Connecting to the server"
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)($754e05db5f4147ff$export$f89226e2c0f985ba.Provider, {
        value: {
            connectToGroup: connectToGroup,
            connection: connection,
            groups: groups,
            joinGroupList: joinGroupList,
            sendMessageToGroup: sendMessageToGroup,
            sendTlfUpdateToGroup: sendTlfUpdateToGroup,
            sendTocSaveToGroup: sendTocSaveToGroup,
            sendTocUpdateToGroup: sendTocUpdateToGroup
        },
        children: children
    });
};
$754e05db5f4147ff$export$d9137f7c4ee47bfb.displayName = "SignalRProvider";

});
parcelRegister("h9eE2", function(module, exports) {

$parcel$export(module.exports, "HubConnectionState", function () { return $c7bea31259b1b1e9$export$b8b4168ab851a6c3; });
$parcel$export(module.exports, "HubConnection", function () { return $c7bea31259b1b1e9$export$e5dbe756ed73e8c8; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $45uJE = parcelRequire("45uJE");

var $kLqxE = parcelRequire("kLqxE");

var $657oj = parcelRequire("657oj");

var $aEdNZ = parcelRequire("aEdNZ");

var $9yrVU = parcelRequire("9yrVU");

var $1Y1Ki = parcelRequire("1Y1Ki");

var $jmeZZ = parcelRequire("jmeZZ");
const $c7bea31259b1b1e9$var$DEFAULT_TIMEOUT_IN_MS = 30000;
const $c7bea31259b1b1e9$var$DEFAULT_PING_INTERVAL_IN_MS = 15000;
const $c7bea31259b1b1e9$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE = 100000;
var $c7bea31259b1b1e9$export$b8b4168ab851a6c3;
(function(HubConnectionState) {
    /** The hub connection is disconnected. */ HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */ HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */ HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */ HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */ HubConnectionState["Reconnecting"] = "Reconnecting";
})($c7bea31259b1b1e9$export$b8b4168ab851a6c3 || ($c7bea31259b1b1e9$export$b8b4168ab851a6c3 = {}));
class $c7bea31259b1b1e9$export$e5dbe756ed73e8c8 {
    /** @internal */ // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        return new $c7bea31259b1b1e9$export$e5dbe756ed73e8c8(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize);
    }
    constructor(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize){
        this._nextKeepAlive = 0;
        this._freezeEventListener = ()=>{
            this._logger.log((0, $aEdNZ.LogLevel).Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        (0, $1Y1Ki.Arg).isRequired(connection, "connection");
        (0, $1Y1Ki.Arg).isRequired(logger, "logger");
        (0, $1Y1Ki.Arg).isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = serverTimeoutInMilliseconds !== null && serverTimeoutInMilliseconds !== void 0 ? serverTimeoutInMilliseconds : $c7bea31259b1b1e9$var$DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = keepAliveIntervalInMilliseconds !== null && keepAliveIntervalInMilliseconds !== void 0 ? keepAliveIntervalInMilliseconds : $c7bea31259b1b1e9$var$DEFAULT_PING_INTERVAL_IN_MS;
        this._statefulReconnectBufferSize = statefulReconnectBufferSize !== null && statefulReconnectBufferSize !== void 0 ? statefulReconnectBufferSize : $c7bea31259b1b1e9$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new (0, $45uJE.HandshakeProtocol)();
        this.connection.onreceive = (data)=>this._processIncomingData(data);
        this.connection.onclose = (error)=>this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({
            type: (0, $657oj.MessageType).Ping
        });
    }
    /** Indicates the state of the {@link HubConnection} to the server. */ get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */ get connectionId() {
        return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */ get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */ set baseUrl(url) {
        if (this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected && this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!url) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */ start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connecting;
        this._logger.log((0, $aEdNZ.LogLevel).Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if ((0, $1Y1Ki.Platform).isBrowser) // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
            window.document.addEventListener("freeze", this._freezeEventListener);
            this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected;
            this._connectionStarted = true;
            this._logger.log((0, $aEdNZ.LogLevel).Debug, "HubConnection connected successfully.");
        } catch (e) {
            this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected;
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject)=>{
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            let version = this._protocol.version;
            if (!this.connection.features.reconnect) // Stateful Reconnect starts with HubProtocol version 2, newer clients connecting to older servers will fail to connect due to
            // the handshake only supporting version 1, so we will try to send version 1 during the handshake to keep old servers working.
            version = 1;
            const handshakeRequest = {
                protocol: this._protocol.name,
                version: version
            };
            this._logger.log((0, $aEdNZ.LogLevel).Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log((0, $aEdNZ.LogLevel).Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
            // will cause the calling continuation to get scheduled to run later.
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw this._stopDuringStartError;
            const useStatefulReconnect = this.connection.features.reconnect || false;
            if (useStatefulReconnect) {
                this._messageBuffer = new (0, $jmeZZ.MessageBuffer)(this._protocol, this.connection, this._statefulReconnectBufferSize);
                this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer);
                this.connection.features.resend = ()=>{
                    if (this._messageBuffer) return this._messageBuffer._resend();
                };
            }
            if (!this.connection.features.inherentKeepAlive) await this._sendMessage(this._cachedPingMessage);
        } catch (e) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */ async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this.connection.features.reconnect = false;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnecting) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        const state = this._connectionState;
        this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnecting;
        this._logger.log((0, $aEdNZ.LogLevel).Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log((0, $aEdNZ.LogLevel).Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        if (state === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendCloseMessage();
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new (0, $kLqxE.AbortError)("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    async _sendCloseMessage() {
        try {
            await this._sendWithProtocol(this._createCloseMessage());
        } catch  {
        // Ignore, this is a best effort attempt to let the server know the client closed gracefully.
        }
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */ stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new (0, $9yrVU.Subject)();
        subject.cancelCallback = ()=>{
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(()=>{
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
            if (error) {
                subject.error(error);
                return;
            } else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === (0, $657oj.MessageType).Completion) {
                    if (invocationEvent.error) subject.error(new Error(invocationEvent.error));
                    else subject.complete();
                } else subject.next(invocationEvent.item);
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */ _sendWithProtocol(message) {
        if (this._messageBuffer) return this._messageBuffer._send(message);
        else return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */ send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */ invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject)=>{
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
                if (error) {
                    reject(error);
                    return;
                } else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === (0, $657oj.MessageType).Completion) {
                        if (invocationEvent.error) reject(new Error(invocationEvent.error));
                        else resolve(invocationEvent.result);
                    } else reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    on(methodName, newMethod) {
        if (!methodName || !newMethod) return;
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) this._methods[methodName] = [];
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) return;
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) return;
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) return;
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) delete this._methods[methodName];
            }
        } else delete this._methods[methodName];
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */ onclose(callback) {
        if (callback) this._closedCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */ onreconnecting(callback) {
        if (callback) this._reconnectingCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */ onreconnected(callback) {
        if (callback) this._reconnectedCallbacks.push(callback);
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages){
                if (this._messageBuffer && !this._messageBuffer._shouldProcessMessage(message)) continue;
                switch(message.type){
                    case (0, $657oj.MessageType).Invocation:
                        this._invokeClientMethod(message).catch((e)=>{
                            this._logger.log((0, $aEdNZ.LogLevel).Error, `Invoke client method threw error: ${(0, $1Y1Ki.getErrorString)(e)}`);
                        });
                        break;
                    case (0, $657oj.MessageType).StreamItem:
                    case (0, $657oj.MessageType).Completion:
                        {
                            const callback = this._callbacks[message.invocationId];
                            if (callback) {
                                if (message.type === (0, $657oj.MessageType).Completion) delete this._callbacks[message.invocationId];
                                try {
                                    callback(message);
                                } catch (e) {
                                    this._logger.log((0, $aEdNZ.LogLevel).Error, `Stream callback threw error: ${(0, $1Y1Ki.getErrorString)(e)}`);
                                }
                            }
                            break;
                        }
                    case (0, $657oj.MessageType).Ping:
                        break;
                    case (0, $657oj.MessageType).Close:
                        {
                            this._logger.log((0, $aEdNZ.LogLevel).Information, "Close message received from server.");
                            const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                            if (message.allowReconnect === true) // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.connection.stop(error);
                            else // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this._stopPromise = this._stopInternal(error);
                            break;
                        }
                    case (0, $657oj.MessageType).Ack:
                        if (this._messageBuffer) this._messageBuffer._ack(message);
                        break;
                    case (0, $657oj.MessageType).Sequence:
                        if (this._messageBuffer) this._messageBuffer._resetSequence(message);
                        break;
                    default:
                        this._logger.log((0, $aEdNZ.LogLevel).Warning, `Invalid message type: ${message.type}.`);
                        break;
                }
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        } catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log((0, $aEdNZ.LogLevel).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log((0, $aEdNZ.LogLevel).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        } else this._logger.log((0, $aEdNZ.LogLevel).Debug, "Server handshake complete.");
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) return;
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(()=>this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Immediately fire Keep-Alive ping if nextPing is overdue to avoid dependency on JS timers
            let nextPing = this._nextKeepAlive - new Date().getTime();
            if (nextPing < 0) {
                if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._trySendPingMessage();
                return;
            }
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                if (nextPing < 0) nextPing = 0;
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async ()=>{
                    if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected) await this._trySendPingMessage();
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    async _invokeClientMethod(invocationMessage) {
        const methodName = invocationMessage.target.toLowerCase();
        const methods = this._methods[methodName];
        if (!methods) {
            this._logger.log((0, $aEdNZ.LogLevel).Warning, `No client method with the name '${methodName}' found.`);
            // No handlers provided by client but the server is expecting a response still, so we send an error
            if (invocationMessage.invocationId) {
                this._logger.log((0, $aEdNZ.LogLevel).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                await this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));
            }
            return;
        }
        // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
        const methodsCopy = methods.slice();
        // Server expects a response
        const expectsResponse = invocationMessage.invocationId ? true : false;
        // We preserve the last result or exception but still call all handlers
        let res;
        let exception;
        let completionMessage;
        for (const m of methodsCopy)try {
            const prevRes = res;
            res = await m.apply(this, invocationMessage.arguments);
            if (expectsResponse && res && prevRes) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `Multiple results provided for '${methodName}'. Sending error to server.`);
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `Client provided multiple results.`, null);
            }
            // Ignore exception if we got a result after, the exception will be logged
            exception = undefined;
        } catch (e) {
            exception = e;
            this._logger.log((0, $aEdNZ.LogLevel).Error, `A callback for the method '${methodName}' threw error '${e}'.`);
        }
        if (completionMessage) await this._sendWithProtocol(completionMessage);
        else if (expectsResponse) {
            // If there is an exception that means either no result was given or a handler after a result threw
            if (exception) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `${exception}`, null);
            else if (res !== undefined) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
            else {
                this._logger.log((0, $aEdNZ.LogLevel).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                // Client didn't provide a result or throw from a handler, server expects a response so we send an error
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
            }
            await this._sendWithProtocol(completionMessage);
        } else if (res) this._logger.log((0, $aEdNZ.LogLevel).Error, `Result given for '${methodName}' method but server is not expecting a result.`);
    }
    _connectionClosed(error) {
        this._logger.log((0, $aEdNZ.LogLevel).Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new (0, $kLqxE.AbortError)("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) this._handshakeResolver();
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnecting) this._completeClose(error);
        else if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected && this._reconnectPolicy) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
        else if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected) this._completeClose(error);
    // If none of the above if conditions were true were called the HubConnection must be in either:
    // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
    // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
    //    and potentially continue the reconnect() loop.
    // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnected;
            this._connectionStarted = false;
            if (this._messageBuffer) {
                this._messageBuffer._dispose(error !== null && error !== void 0 ? error : new Error("Connection closed."));
                this._messageBuffer = undefined;
            }
            if ((0, $1Y1Ki.Platform).isBrowser) window.document.removeEventListener("freeze", this._freezeEventListener);
            try {
                this._closedCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Reconnecting;
        if (error) this._logger.log((0, $aEdNZ.LogLevel).Information, `Connection reconnecting because of error '${error}'.`);
        else this._logger.log((0, $aEdNZ.LogLevel).Information, "Connection reconnecting.");
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $aEdNZ.LogLevel).Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while(nextRetryDelay !== null){
            this._logger.log((0, $aEdNZ.LogLevel).Information, `Reconnect attempt number ${previousReconnectAttempts + 1} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve)=>{
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $aEdNZ.LogLevel).Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Connected;
                this._logger.log((0, $aEdNZ.LogLevel).Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) try {
                    this._reconnectedCallbacks.forEach((c)=>c.apply(this, [
                            this.connection.connectionId
                        ]));
                } catch (e) {
                    this._logger.log((0, $aEdNZ.LogLevel).Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                }
                return;
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Reconnecting) {
                    this._logger.log((0, $aEdNZ.LogLevel).Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === $c7bea31259b1b1e9$export$b8b4168ab851a6c3.Disconnecting) this._completeClose();
                    return;
                }
                previousReconnectAttempts++;
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log((0, $aEdNZ.LogLevel).Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason
            });
        } catch (e) {
            this._logger.log((0, $aEdNZ.LogLevel).Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks).forEach((key)=>{
            const callback = callbacks[key];
            try {
                callback(null, error);
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `Stream 'error' callback called with '${error}' threw error: ${(0, $1Y1Ki.getErrorString)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) clearTimeout(this._timeoutHandle);
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                streamIds: streamIds,
                type: (0, $657oj.MessageType).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                type: (0, $657oj.MessageType).Invocation
            };
        } else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                type: (0, $657oj.MessageType).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                type: (0, $657oj.MessageType).Invocation
            };
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) return;
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) promiseQueue = Promise.resolve();
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for(const streamId in streams)streams[streamId].subscribe({
            complete: ()=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId)));
            },
            error: (err)=>{
                let message;
                if (err instanceof Error) message = err.message;
                else if (err && err.toString) message = err.toString();
                else message = "Unknown error";
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
            },
            next: (item)=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
            }
        });
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for(let i = 0; i < args.length; i++){
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [
            streams,
            streamIds
        ];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            type: (0, $657oj.MessageType).StreamInvocation
        };
        else return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            type: (0, $657oj.MessageType).StreamInvocation
        };
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: (0, $657oj.MessageType).CancelInvocation
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item: item,
            type: (0, $657oj.MessageType).StreamItem
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) return {
            error: error,
            invocationId: id,
            type: (0, $657oj.MessageType).Completion
        };
        return {
            invocationId: id,
            result: result,
            type: (0, $657oj.MessageType).Completion
        };
    }
    _createCloseMessage() {
        return {
            type: (0, $657oj.MessageType).Close
        };
    }
    async _trySendPingMessage() {
        try {
            await this._sendMessage(this._cachedPingMessage);
        } catch  {
            // We don't care about the error. It should be seen elsewhere in the client.
            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
            this._cleanupPingTimer();
        }
    }
}

});
parcelRegister("45uJE", function(module, exports) {

$parcel$export(module.exports, "HandshakeProtocol", function () { return $2f9f787724ad31dd$export$b23df48528d3f5f4; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $6Ksss = parcelRequire("6Ksss");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $2f9f787724ad31dd$export$b23df48528d3f5f4 {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return (0, $6Ksss.TextMessageFormat).write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, $1Y1Ki.isArrayBuffer)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf((0, $6Ksss.TextMessageFormat).RecordSeparatorCode);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
        } else {
            const textData = data;
            const separatorIndex = textData.indexOf((0, $6Ksss.TextMessageFormat).RecordSeparator);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = (0, $6Ksss.TextMessageFormat).parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) throw new Error("Expected a handshake response from the server.");
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [
            remainingData,
            responseMessage
        ];
    }
}

});
parcelRegister("6Ksss", function(module, exports) {

$parcel$export(module.exports, "TextMessageFormat", function () { return $4e9d1d205c870a2a$export$fc2e5d47850f626b; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */ class $4e9d1d205c870a2a$export$fc2e5d47850f626b {
    static write(output) {
        return `${output}${$4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== $4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparator) throw new Error("Message is incomplete.");
        const messages = input.split($4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparator);
        messages.pop();
        return messages;
    }
}
$4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparatorCode = 0x1e;
$4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparator = String.fromCharCode($4e9d1d205c870a2a$export$fc2e5d47850f626b.RecordSeparatorCode);

});

parcelRegister("1Y1Ki", function(module, exports) {

$parcel$export(module.exports, "Arg", function () { return $16ecbfb9c86fca7f$export$83f0753fc4347e43; });
$parcel$export(module.exports, "Platform", function () { return $16ecbfb9c86fca7f$export$2dffd0b5373a4389; });
$parcel$export(module.exports, "getDataDetail", function () { return $16ecbfb9c86fca7f$export$a688b91586df8fd9; });
$parcel$export(module.exports, "isArrayBuffer", function () { return $16ecbfb9c86fca7f$export$9dd3754ae86f0017; });
$parcel$export(module.exports, "sendMessage", function () { return $16ecbfb9c86fca7f$export$465cb47180de50f0; });
$parcel$export(module.exports, "getUserAgentHeader", function () { return $16ecbfb9c86fca7f$export$56c7340f89ca57c5; });
$parcel$export(module.exports, "createLogger", function () { return $16ecbfb9c86fca7f$export$fe2e61603b61130d; });
$parcel$export(module.exports, "ConsoleLogger", function () { return $16ecbfb9c86fca7f$export$ba6a9c7ac8291f7f; });
$parcel$export(module.exports, "SubjectSubscription", function () { return $16ecbfb9c86fca7f$export$b7a41f2bfb5c60c3; });
$parcel$export(module.exports, "getErrorString", function () { return $16ecbfb9c86fca7f$export$375b49718dbd9ced; });
$parcel$export(module.exports, "getGlobalThis", function () { return $16ecbfb9c86fca7f$export$ff5f2eeb11fc7e14; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $aEdNZ = parcelRequire("aEdNZ");

var $5jfsC = parcelRequire("5jfsC");

var $5YRqC = parcelRequire("5YRqC");

var $bjWjT = parcelRequire("bjWjT");
class $16ecbfb9c86fca7f$export$83f0753fc4347e43 {
    static isRequired(val, name) {
        if (val === null || val === undefined) throw new Error(`The '${name}' argument is required.`);
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) throw new Error(`The '${name}' argument should not be empty.`);
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) throw new Error(`Unknown ${name} value: ${val}.`);
    }
}
class $16ecbfb9c86fca7f$export$2dffd0b5373a4389 {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return !$16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return !$16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode && typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return !$16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return false;
    }
}
function $16ecbfb9c86fca7f$export$a688b91586df8fd9(data, includeContent) {
    let detail = "";
    if ($16ecbfb9c86fca7f$export$9dd3754ae86f0017(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) detail += `. Content: '${$16ecbfb9c86fca7f$export$3ddcef0d22959f49(data)}'`;
    } else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) detail += `. Content: '${data}'`;
    }
    return detail;
}
function $16ecbfb9c86fca7f$export$3ddcef0d22959f49(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num)=>{
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substring(0, str.length - 1);
}
function $16ecbfb9c86fca7f$export$9dd3754ae86f0017(val) {
    return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
    val.constructor && val.constructor.name === "ArrayBuffer");
}
async function $16ecbfb9c86fca7f$export$465cb47180de50f0(logger, transportName, httpClient, url, content, options) {
    const headers = {};
    const [name, value] = $16ecbfb9c86fca7f$export$56c7340f89ca57c5();
    headers[name] = value;
    logger.log((0, $aEdNZ.LogLevel).Trace, `(${transportName} transport) sending data. ${$16ecbfb9c86fca7f$export$a688b91586df8fd9(content, options.logMessageContent)}.`);
    const responseType = $16ecbfb9c86fca7f$export$9dd3754ae86f0017(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content: content,
        headers: {
            ...headers,
            ...options.headers
        },
        responseType: responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials
    });
    logger.log((0, $aEdNZ.LogLevel).Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function $16ecbfb9c86fca7f$export$fe2e61603b61130d(logger) {
    if (logger === undefined) return new $16ecbfb9c86fca7f$export$ba6a9c7ac8291f7f((0, $aEdNZ.LogLevel).Information);
    if (logger === null) return (0, $5jfsC.NullLogger).instance;
    if (logger.log !== undefined) return logger;
    return new $16ecbfb9c86fca7f$export$ba6a9c7ac8291f7f(logger);
}
class $16ecbfb9c86fca7f$export$b7a41f2bfb5c60c3 {
    constructor(subject, observer){
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) this._subject.observers.splice(index, 1);
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) this._subject.cancelCallback().catch((_)=>{});
    }
}
class $16ecbfb9c86fca7f$export$ba6a9c7ac8291f7f {
    constructor(minimumLogLevel){
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${(0, $aEdNZ.LogLevel)[logLevel]}: ${message}`;
            switch(logLevel){
                case (0, $aEdNZ.LogLevel).Critical:
                case (0, $aEdNZ.LogLevel).Error:
                    this.out.error(msg);
                    break;
                case (0, $aEdNZ.LogLevel).Warning:
                    this.out.warn(msg);
                    break;
                case (0, $aEdNZ.LogLevel).Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
function $16ecbfb9c86fca7f$export$56c7340f89ca57c5() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if ($16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode) userAgentHeaderName = "User-Agent";
    return [
        userAgentHeaderName,
        $16ecbfb9c86fca7f$export$1feb51270b0ce71b((0, $5YRqC.VERSION), $16ecbfb9c86fca7f$var$getOsName(), $16ecbfb9c86fca7f$var$getRuntime(), $16ecbfb9c86fca7f$var$getRuntimeVersion())
    ];
}
function $16ecbfb9c86fca7f$export$1feb51270b0ce71b(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") userAgent += `${os}; `;
    else userAgent += "Unknown OS; ";
    userAgent += `${runtime}`;
    if (runtimeVersion) userAgent += `; ${runtimeVersion}`;
    else userAgent += "; Unknown Runtime Version";
    userAgent += ")";
    return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $16ecbfb9c86fca7f$var$getOsName() {
    if ($16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode) switch($bjWjT.platform){
        case "win32":
            return "Windows NT";
        case "darwin":
            return "macOS";
        case "linux":
            return "Linux";
        default:
            return $bjWjT.platform;
    }
    else return "";
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $16ecbfb9c86fca7f$var$getRuntimeVersion() {
    if ($16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode) return $bjWjT.versions.node;
    return undefined;
}
function $16ecbfb9c86fca7f$var$getRuntime() {
    if ($16ecbfb9c86fca7f$export$2dffd0b5373a4389.isNode) return "NodeJS";
    else return "Browser";
}
function $16ecbfb9c86fca7f$export$375b49718dbd9ced(e) {
    if (e.stack) return e.stack;
    else if (e.message) return e.message;
    return `${e}`;
}
function $16ecbfb9c86fca7f$export$ff5f2eeb11fc7e14() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("could not find global");
}

});
parcelRegister("aEdNZ", function(module, exports) {

$parcel$export(module.exports, "LogLevel", function () { return $7c08593df4311a24$export$243e62d78d3b544d; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */ var $7c08593df4311a24$export$243e62d78d3b544d;
(function(LogLevel) {
    /** Log level for very low severity diagnostic messages. */ LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */ LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */ LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */ LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */ LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */ LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */ LogLevel[LogLevel["None"] = 6] = "None";
})($7c08593df4311a24$export$243e62d78d3b544d || ($7c08593df4311a24$export$243e62d78d3b544d = {}));

});

parcelRegister("5jfsC", function(module, exports) {

$parcel$export(module.exports, "NullLogger", function () { return $3ddab84402ec1c3c$export$17ac58a1138ded46; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** A logger that does nothing when log messages are sent to it. */ class $3ddab84402ec1c3c$export$17ac58a1138ded46 {
    constructor(){}
    /** @inheritDoc */ // eslint-disable-next-line
    log(_logLevel, _message) {}
}
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */ $3ddab84402ec1c3c$export$17ac58a1138ded46.instance = new $3ddab84402ec1c3c$export$17ac58a1138ded46();

});

parcelRegister("5YRqC", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $45ac0018e9fc314d$export$a4ad2735b021c132; });
const $45ac0018e9fc314d$export$a4ad2735b021c132 = '10.0.11';

});

parcelRegister("bjWjT", function(module, exports) {
// shim for using process in browser
var $83deb52f518973d9$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $83deb52f518973d9$var$cachedSetTimeout;
var $83deb52f518973d9$var$cachedClearTimeout;
function $83deb52f518973d9$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $83deb52f518973d9$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $83deb52f518973d9$var$cachedSetTimeout = setTimeout;
        else $83deb52f518973d9$var$cachedSetTimeout = $83deb52f518973d9$var$defaultSetTimout;
    } catch (e) {
        $83deb52f518973d9$var$cachedSetTimeout = $83deb52f518973d9$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $83deb52f518973d9$var$cachedClearTimeout = clearTimeout;
        else $83deb52f518973d9$var$cachedClearTimeout = $83deb52f518973d9$var$defaultClearTimeout;
    } catch (e) {
        $83deb52f518973d9$var$cachedClearTimeout = $83deb52f518973d9$var$defaultClearTimeout;
    }
})();
function $83deb52f518973d9$var$runTimeout(fun) {
    if ($83deb52f518973d9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($83deb52f518973d9$var$cachedSetTimeout === $83deb52f518973d9$var$defaultSetTimout || !$83deb52f518973d9$var$cachedSetTimeout) && setTimeout) {
        $83deb52f518973d9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $83deb52f518973d9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $83deb52f518973d9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $83deb52f518973d9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $83deb52f518973d9$var$runClearTimeout(marker) {
    if ($83deb52f518973d9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($83deb52f518973d9$var$cachedClearTimeout === $83deb52f518973d9$var$defaultClearTimeout || !$83deb52f518973d9$var$cachedClearTimeout) && clearTimeout) {
        $83deb52f518973d9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $83deb52f518973d9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $83deb52f518973d9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $83deb52f518973d9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $83deb52f518973d9$var$queue = [];
var $83deb52f518973d9$var$draining = false;
var $83deb52f518973d9$var$currentQueue;
var $83deb52f518973d9$var$queueIndex = -1;
function $83deb52f518973d9$var$cleanUpNextTick() {
    if (!$83deb52f518973d9$var$draining || !$83deb52f518973d9$var$currentQueue) return;
    $83deb52f518973d9$var$draining = false;
    if ($83deb52f518973d9$var$currentQueue.length) $83deb52f518973d9$var$queue = $83deb52f518973d9$var$currentQueue.concat($83deb52f518973d9$var$queue);
    else $83deb52f518973d9$var$queueIndex = -1;
    if ($83deb52f518973d9$var$queue.length) $83deb52f518973d9$var$drainQueue();
}
function $83deb52f518973d9$var$drainQueue() {
    if ($83deb52f518973d9$var$draining) return;
    var timeout = $83deb52f518973d9$var$runTimeout($83deb52f518973d9$var$cleanUpNextTick);
    $83deb52f518973d9$var$draining = true;
    var len = $83deb52f518973d9$var$queue.length;
    while(len){
        $83deb52f518973d9$var$currentQueue = $83deb52f518973d9$var$queue;
        $83deb52f518973d9$var$queue = [];
        while(++$83deb52f518973d9$var$queueIndex < len)if ($83deb52f518973d9$var$currentQueue) $83deb52f518973d9$var$currentQueue[$83deb52f518973d9$var$queueIndex].run();
        $83deb52f518973d9$var$queueIndex = -1;
        len = $83deb52f518973d9$var$queue.length;
    }
    $83deb52f518973d9$var$currentQueue = null;
    $83deb52f518973d9$var$draining = false;
    $83deb52f518973d9$var$runClearTimeout(timeout);
}
$83deb52f518973d9$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $83deb52f518973d9$var$queue.push(new $83deb52f518973d9$var$Item(fun, args));
    if ($83deb52f518973d9$var$queue.length === 1 && !$83deb52f518973d9$var$draining) $83deb52f518973d9$var$runTimeout($83deb52f518973d9$var$drainQueue);
};
// v8 likes predictible objects
function $83deb52f518973d9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$83deb52f518973d9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$83deb52f518973d9$var$process.title = 'browser';
$83deb52f518973d9$var$process.browser = true;
$83deb52f518973d9$var$process.env = {};
$83deb52f518973d9$var$process.argv = [];
$83deb52f518973d9$var$process.version = ''; // empty string to avoid regexp issues
$83deb52f518973d9$var$process.versions = {};
function $83deb52f518973d9$var$noop() {}
$83deb52f518973d9$var$process.on = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.addListener = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.once = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.off = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.removeListener = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.removeAllListeners = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.emit = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.prependListener = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.prependOnceListener = $83deb52f518973d9$var$noop;
$83deb52f518973d9$var$process.listeners = function(name) {
    return [];
};
$83deb52f518973d9$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$83deb52f518973d9$var$process.cwd = function() {
    return '/';
};
$83deb52f518973d9$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$83deb52f518973d9$var$process.umask = function() {
    return 0;
};

});



parcelRegister("kLqxE", function(module, exports) {

$parcel$export(module.exports, "HttpError", function () { return $f1dcc90d6ca44e79$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "TimeoutError", function () { return $f1dcc90d6ca44e79$export$66d311bf29d5c89c; });
$parcel$export(module.exports, "AbortError", function () { return $f1dcc90d6ca44e79$export$18b052ffd8c84d7; });
$parcel$export(module.exports, "UnsupportedTransportError", function () { return $f1dcc90d6ca44e79$export$c7cbd7482d8bece8; });
$parcel$export(module.exports, "DisabledTransportError", function () { return $f1dcc90d6ca44e79$export$764b8cd64449c5b0; });
$parcel$export(module.exports, "FailedToStartTransportError", function () { return $f1dcc90d6ca44e79$export$264839a6ea29f91a; });
$parcel$export(module.exports, "FailedToNegotiateWithServerError", function () { return $f1dcc90d6ca44e79$export$b4f59905103de78d; });
$parcel$export(module.exports, "AggregateErrors", function () { return $f1dcc90d6ca44e79$export$9341e26d19ed3783; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Error thrown when an HTTP request fails. */ class $f1dcc90d6ca44e79$export$65bd6083489bd8bb extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */ constructor(errorMessage, statusCode){
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$66d311bf29d5c89c extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "A timeout occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$18b052ffd8c84d7 extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "An abort occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$c7cbd7482d8bece8 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$764b8cd64449c5b0 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$264839a6ea29f91a extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$b4f59905103de78d extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */ constructor(message){
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $f1dcc90d6ca44e79$export$9341e26d19ed3783 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */ constructor(message, innerErrors){
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}

});

parcelRegister("657oj", function(module, exports) {

$parcel$export(module.exports, "MessageType", function () { return $46d8f16c32bf9c8f$export$80edbf15fa61a4db; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Defines the type of a Hub Message. */ var $46d8f16c32bf9c8f$export$80edbf15fa61a4db;
(function(MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */ MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */ MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */ MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */ MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */ MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */ MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */ MessageType[MessageType["Close"] = 7] = "Close";
    MessageType[MessageType["Ack"] = 8] = "Ack";
    MessageType[MessageType["Sequence"] = 9] = "Sequence";
})($46d8f16c32bf9c8f$export$80edbf15fa61a4db || ($46d8f16c32bf9c8f$export$80edbf15fa61a4db = {}));

});

parcelRegister("9yrVU", function(module, exports) {

$parcel$export(module.exports, "Subject", function () { return $6f4cf4f775c2e0ba$export$b6bbab5a9b109038; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $1Y1Ki = parcelRequire("1Y1Ki");
class $6f4cf4f775c2e0ba$export$b6bbab5a9b109038 {
    constructor(){
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers)observer.next(item);
    }
    error(err) {
        for (const observer of this.observers)if (observer.error) observer.error(err);
    }
    complete() {
        for (const observer of this.observers)if (observer.complete) observer.complete();
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new (0, $1Y1Ki.SubjectSubscription)(this, observer);
    }
}

});

parcelRegister("jmeZZ", function(module, exports) {

$parcel$export(module.exports, "MessageBuffer", function () { return $e17bb4dcc1f669b3$export$9d24a0f7b61acd07; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $657oj = parcelRequire("657oj");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $e17bb4dcc1f669b3$export$9d24a0f7b61acd07 {
    constructor(protocol, connection, bufferSize){
        this._bufferSize = 100000;
        this._messages = [];
        this._totalMessageCount = 0;
        this._waitForSequenceMessage = false;
        // Message IDs start at 1 and always increment by 1
        this._nextReceivingSequenceId = 1;
        this._latestReceivedSequenceId = 0;
        this._bufferedByteCount = 0;
        this._reconnectInProgress = false;
        this._protocol = protocol;
        this._connection = connection;
        this._bufferSize = bufferSize;
    }
    async _send(message) {
        const serializedMessage = this._protocol.writeMessage(message);
        let backpressurePromise = Promise.resolve();
        // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
        if (this._isInvocationMessage(message)) {
            this._totalMessageCount++;
            let backpressurePromiseResolver = ()=>{};
            let backpressurePromiseRejector = ()=>{};
            if ((0, $1Y1Ki.isArrayBuffer)(serializedMessage)) this._bufferedByteCount += serializedMessage.byteLength;
            else this._bufferedByteCount += serializedMessage.length;
            if (this._bufferedByteCount >= this._bufferSize) backpressurePromise = new Promise((resolve, reject)=>{
                backpressurePromiseResolver = resolve;
                backpressurePromiseRejector = reject;
            });
            this._messages.push(new $e17bb4dcc1f669b3$var$BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
        }
        try {
            // If this is set it means we are reconnecting or resending
            // We don't want to send on a disconnected connection
            // And we don't want to send if resend is running since that would mean sending
            // this message twice
            if (!this._reconnectInProgress) await this._connection.send(serializedMessage);
        } catch  {
            this._disconnected();
        }
        await backpressurePromise;
    }
    _ack(ackMessage) {
        let newestAckedMessage = -1;
        // Find index of newest message being acked
        for(let index = 0; index < this._messages.length; index++){
            const element = this._messages[index];
            if (element._id <= ackMessage.sequenceId) {
                newestAckedMessage = index;
                if ((0, $1Y1Ki.isArrayBuffer)(element._message)) this._bufferedByteCount -= element._message.byteLength;
                else this._bufferedByteCount -= element._message.length;
                // resolve items that have already been sent and acked
                element._resolver();
            } else if (this._bufferedByteCount < this._bufferSize) // resolve items that now fall under the buffer limit but haven't been acked
            element._resolver();
            else break;
        }
        if (newestAckedMessage !== -1) // We're removing everything including the message pointed to, so add 1
        this._messages = this._messages.slice(newestAckedMessage + 1);
    }
    _shouldProcessMessage(message) {
        if (this._waitForSequenceMessage) {
            if (message.type !== (0, $657oj.MessageType).Sequence) return false;
            else {
                this._waitForSequenceMessage = false;
                return true;
            }
        }
        // No special processing for acks, pings, etc.
        if (!this._isInvocationMessage(message)) return true;
        const currentId = this._nextReceivingSequenceId;
        this._nextReceivingSequenceId++;
        if (currentId <= this._latestReceivedSequenceId) {
            if (currentId === this._latestReceivedSequenceId) // Should only hit this if we just reconnected and the server is sending
            // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
            this._ackTimer();
            // Ignore, this is a duplicate message
            return false;
        }
        this._latestReceivedSequenceId = currentId;
        // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
        // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
        this._ackTimer();
        return true;
    }
    _resetSequence(message) {
        if (message.sequenceId > this._nextReceivingSequenceId) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
            return;
        }
        this._nextReceivingSequenceId = message.sequenceId;
    }
    _disconnected() {
        this._reconnectInProgress = true;
        this._waitForSequenceMessage = true;
    }
    async _resend() {
        const sequenceId = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
        await this._connection.send(this._protocol.writeMessage({
            type: (0, $657oj.MessageType).Sequence,
            sequenceId: sequenceId
        }));
        // Get a local variable to the _messages, just in case messages are acked while resending
        // Which would slice the _messages array (which creates a new copy)
        const messages = this._messages;
        for (const element of messages)await this._connection.send(element._message);
        this._reconnectInProgress = false;
    }
    _dispose(error) {
        error !== null && error !== void 0 ? error : error = new Error("Unable to reconnect to server.");
        // Unblock backpressure if any
        for (const element of this._messages)element._rejector(error);
    }
    _isInvocationMessage(message) {
        // There is no way to check if something implements an interface.
        // So we individually check the messages in a switch statement.
        // To make sure we don't miss any message types we rely on the compiler
        // seeing the function returns a value and it will do the
        // exhaustive check for us on the switch statement, since we don't use 'case default'
        switch(message.type){
            case (0, $657oj.MessageType).Invocation:
            case (0, $657oj.MessageType).StreamItem:
            case (0, $657oj.MessageType).Completion:
            case (0, $657oj.MessageType).StreamInvocation:
            case (0, $657oj.MessageType).CancelInvocation:
                return true;
            case (0, $657oj.MessageType).Close:
            case (0, $657oj.MessageType).Sequence:
            case (0, $657oj.MessageType).Ping:
            case (0, $657oj.MessageType).Ack:
                return false;
        }
    }
    _ackTimer() {
        if (this._ackTimerHandle === undefined) this._ackTimerHandle = setTimeout(async ()=>{
            try {
                if (!this._reconnectInProgress) await this._connection.send(this._protocol.writeMessage({
                    type: (0, $657oj.MessageType).Ack,
                    sequenceId: this._latestReceivedSequenceId
                }));
            // Ignore errors, that means the connection is closed and we don't care about the Ack message anymore.
            } catch  {}
            clearTimeout(this._ackTimerHandle);
            this._ackTimerHandle = undefined;
        // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
        }, 1000);
    }
}
class $e17bb4dcc1f669b3$var$BufferedItem {
    constructor(message, id, resolver, rejector){
        this._message = message;
        this._id = id;
        this._resolver = resolver;
        this._rejector = rejector;
    }
}

});


parcelRegister("eL8NP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca3a33cdf475001$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $dVR7M = parcelRequire("dVR7M");

var $lE7gc = parcelRequire("lE7gc");

var $6iYEs = parcelRequire("6iYEs");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");
const $7ca3a33cdf475001$export$e6dcbb50012c752c = ()=>{
    const maintenanceCassette = "/maintenance-cassette.jpg";
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("server-down-page");
    (0, $spJKX.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lE7gc.TopBar), {
                title: "Server unavailable",
                showUser: false
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            className: "d-flex justify-content-center",
                            xs: {
                                offset: 2,
                                span: 4
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)("img", {
                                src: maintenanceCassette,
                                alt: "Server unavailable",
                                title: "Server unavailable",
                                width: "400",
                                height: "300"
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            xs: 4,
                            className: "d-flex justify-content-center align-items-center",
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("h5", {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        children: "Sorry, the MOSAIC\xa0Biometrics server is not responding"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        children: "Try again later"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        className: "d-flex justify-content-center mt-3",
                                        children: "\u2639"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dVR7M.BottomNav), {})
        ]
    });
};
$7ca3a33cdf475001$export$e6dcbb50012c752c.displayName = "ServerDownPage";
var $7ca3a33cdf475001$export$2e2bcd8739ae039 = $7ca3a33cdf475001$export$e6dcbb50012c752c;

});
parcelRegister("dVR7M", function(module, exports) {

$parcel$export(module.exports, "BottomNav", function () { return $0e02e5d1acc6921b$export$b77dc13a7753f3ee; });

var $bR5nk = parcelRequire("bR5nk");

var $go4Wi = parcelRequire("go4Wi");

var $3tNrK = parcelRequire("3tNrK");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
var $50zs8 = parcelRequire("50zs8");

var $fprWv = parcelRequire("fprWv");

var $5jVZh = parcelRequire("5jVZh");
const $0e02e5d1acc6921b$export$b77dc13a7753f3ee = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [showInfo, setShowInfo] = (0, $spJKX.useState)(false);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $50zs8.default), {
        variant: "dark",
        bg: "dark",
        style: {
            padding: 0
        },
        fixed: "bottom",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                fluid: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $50zs8.default).Text, {
                    className: "d-flex gap-2 align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("small", {
                            id: "bottomnav-versions",
                            children: [
                                "mbfe",
                                " ",
                                "6.0.0.90",
                                " / ",
                                appSettings.backEndVersion
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fprWv.default), {
                            id: "bottomnav-info",
                            "aria-label": "Show information panel",
                            onClick: ()=>setShowInfo(!showInfo)
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $go4Wi.ConnectionStatus), {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5jVZh.BottomNavInfoModal), {
                show: showInfo,
                setShow: setShowInfo
            })
        ]
    });
};
$0e02e5d1acc6921b$export$b77dc13a7753f3ee.displayName = "BottomNav";

});
parcelRegister("go4Wi", function(module, exports) {

$parcel$export(module.exports, "ConnectionStatus", function () { return $ff158d3404ed16e0$export$7516420eb880ab68; });

var $bR5nk = parcelRequire("bR5nk");

var $h9eE2 = parcelRequire("h9eE2");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");

var $irvto = parcelRequire("irvto");

var $spJKX = parcelRequire("spJKX");

var $atyjc = parcelRequire("atyjc");

var $bHjn7 = parcelRequire("bHjn7");
const $ff158d3404ed16e0$export$7516420eb880ab68 = ()=>{
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const connection = signalR?.connection;
    const groups = signalR?.groups;
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $atyjc.default), {
        className: (0, $3tKzd.classMerge)([
            connection?.state === (0, $h9eE2.HubConnectionState).Connected ? (0, (/*@__PURE__*/$parcel$interopDefault($bHjn7))).connected : (0, (/*@__PURE__*/$parcel$interopDefault($bHjn7))).notConnected
        ]),
        title: `Connection status: ${connection?.state === (0, $h9eE2.HubConnectionState).Connected ? "Connected" : "Not connected"}` + `\n${Array.from(groups ?? []).join(",\n")}`
    });
};
$ff158d3404ed16e0$export$7516420eb880ab68.displayName = "ConnectionStatus";

});
parcelRegister("atyjc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a0739cf199b8a40$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $7a0739cf199b8a40$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $7a0739cf199b8a40$var$_extends() {
    return $7a0739cf199b8a40$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7a0739cf199b8a40$var$_extends.apply(null, arguments);
}
function $7a0739cf199b8a40$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7a0739cf199b8a40$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7a0739cf199b8a40$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7a0739cf199b8a40$var$CircleFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $7a0739cf199b8a40$var$_objectWithoutProperties(_ref, $7a0739cf199b8a40$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $7a0739cf199b8a40$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "8"
    }));
});
$7a0739cf199b8a40$var$CircleFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $7a0739cf199b8a40$export$2e2bcd8739ae039 = $7a0739cf199b8a40$var$CircleFill;

});

parcelRegister("bHjn7", function(module, exports) {

$parcel$export(module.exports, "connected", function () { return $8842bcb0ed7eb567$export$179c556db9c9a30f; }, function (v) { return $8842bcb0ed7eb567$export$179c556db9c9a30f = v; });
$parcel$export(module.exports, "notConnected", function () { return $8842bcb0ed7eb567$export$e0a79238d4dc4fc8; }, function (v) { return $8842bcb0ed7eb567$export$e0a79238d4dc4fc8 = v; });
var $8842bcb0ed7eb567$export$179c556db9c9a30f;
var $8842bcb0ed7eb567$export$e0a79238d4dc4fc8;
$8842bcb0ed7eb567$export$179c556db9c9a30f = `mos-ConnectionStatus-module-iSGICq-connected`;
$8842bcb0ed7eb567$export$e0a79238d4dc4fc8 = `mos-ConnectionStatus-module-iSGICq-notConnected`;

});


parcelRegister("50zs8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a58740602b7f40c$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $4dgBw = parcelRequire("4dgBw");
parcelRequire("ai3tA");
var $iq7Zt = parcelRequire("iq7Zt");

var $jCZTF = parcelRequire("jCZTF");

var $j1Ixk = parcelRequire("j1Ixk");

var $1JD52 = parcelRequire("1JD52");

var $2AWFS = parcelRequire("2AWFS");

var $dz672 = parcelRequire("dz672");

var $27dwU = parcelRequire("27dwU");

var $lvuD3 = parcelRequire("lvuD3");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $3a58740602b7f40c$var$Navbar = /*#__PURE__*/ $spJKX.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $iq7Zt.default)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $dz672.useBootstrapPrefix)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $spJKX.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $spJKX.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27dwU.default).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$3a58740602b7f40c$var$Navbar.displayName = 'Navbar';
var $3a58740602b7f40c$export$2e2bcd8739ae039 = Object.assign($3a58740602b7f40c$var$Navbar, {
    Brand: (0, $jCZTF.default),
    Collapse: (0, $j1Ixk.default),
    Offcanvas: (0, $2AWFS.default),
    Text: (0, $lvuD3.default),
    Toggle: (0, $1JD52.default)
});

});
parcelRegister("jCZTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4a194550ff9ed35$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $e4a194550ff9ed35$var$NavbarBrand = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix)
    });
});
$e4a194550ff9ed35$var$NavbarBrand.displayName = 'NavbarBrand';
var $e4a194550ff9ed35$export$2e2bcd8739ae039 = $e4a194550ff9ed35$var$NavbarBrand;

});

parcelRegister("j1Ixk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dda0a85df42c8cd4$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fa1i3 = parcelRequire("fa1i3");

var $dz672 = parcelRequire("dz672");

var $27dwU = parcelRequire("27dwU");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $dda0a85df42c8cd4$var$NavbarCollapse = /*#__PURE__*/ $spJKX.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'navbar-collapse');
    const context = (0, $spJKX.useContext)((0, $27dwU.default));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa1i3.default), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$dda0a85df42c8cd4$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $dda0a85df42c8cd4$export$2e2bcd8739ae039 = $dda0a85df42c8cd4$var$NavbarCollapse;

});

parcelRegister("1JD52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14384eeb29ee9848$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $i1VQA = parcelRequire("i1VQA");

var $dz672 = parcelRequire("dz672");

var $27dwU = parcelRequire("27dwU");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $14384eeb29ee9848$var$NavbarToggle = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $spJKX.useContext)((0, $27dwU.default)) || {};
    const handleClick = (0, $i1VQA.default)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$14384eeb29ee9848$var$NavbarToggle.displayName = 'NavbarToggle';
var $14384eeb29ee9848$export$2e2bcd8739ae039 = $14384eeb29ee9848$var$NavbarToggle;

});

parcelRegister("2AWFS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e3c75182e61c1d0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $i1VQA = parcelRequire("i1VQA");

var $b6GTY = parcelRequire("b6GTY");

var $27dwU = parcelRequire("27dwU");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $1e3c75182e61c1d0$var$NavbarOffcanvas = /*#__PURE__*/ $spJKX.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $spJKX.useContext)((0, $27dwU.default));
    const handleHide = (0, $i1VQA.default)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$1e3c75182e61c1d0$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $1e3c75182e61c1d0$export$2e2bcd8739ae039 = $1e3c75182e61c1d0$var$NavbarOffcanvas;

});

parcelRegister("lvuD3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa844082870664cd$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $fa844082870664cd$var$NavbarText = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$fa844082870664cd$var$NavbarText.displayName = 'NavbarText';
var $fa844082870664cd$export$2e2bcd8739ae039 = $fa844082870664cd$var$NavbarText;

});


parcelRegister("fprWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b37edda061558ee8$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $b37edda061558ee8$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $b37edda061558ee8$var$_extends() {
    return $b37edda061558ee8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b37edda061558ee8$var$_extends.apply(null, arguments);
}
function $b37edda061558ee8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b37edda061558ee8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b37edda061558ee8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b37edda061558ee8$var$InfoCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $b37edda061558ee8$var$_objectWithoutProperties(_ref, $b37edda061558ee8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $b37edda061558ee8$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-info-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$b37edda061558ee8$var$InfoCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $b37edda061558ee8$export$2e2bcd8739ae039 = $b37edda061558ee8$var$InfoCircle;

});

parcelRegister("5jVZh", function(module, exports) {

$parcel$export(module.exports, "BottomNavInfoModal", function () { return $d6034d35ed2fcec7$export$5249b5f981c8cfd5; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $27W8h = parcelRequire("27W8h");
var $31g00 = parcelRequire("31g00");

var $kK73x = parcelRequire("kK73x");
const $d6034d35ed2fcec7$export$5249b5f981c8cfd5 = ({ show: show, setShow: setShow })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        id: "bottomnav-info-modal",
        show: show,
        onHide: ()=>setShow(false),
        size: "lg",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                        children: "Developer information panel"
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                children: [
                                    "Application version: ",
                                    "mbfe",
                                    " ",
                                    "6.0.0.90"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                children: [
                                    "Stage: ",
                                    (0, $kK73x.REACT_APP_STAGE)
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                children: [
                                    "Backend URL: ",
                                    appSettings.backEndUrl
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                children: [
                                    "Backend versions: ",
                                    appSettings.backEndVersion
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                                children: [
                                    "Application permissions:",
                                    appSettings.isAdmin ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                            className: "mx-3",
                                            children: "Admin"
                                        })
                                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}),
                                    appSettings.applicationPermissions.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                            className: "mx-3",
                                            children: "No permissions assigned"
                                        })
                                    }) : appSettings.applicationPermissions.map((p)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                className: "mx-3",
                                                children: p
                                            })
                                        }, p))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    id: "hierarchy-context-info"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    id: "toc-context-info"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                            className: "mt-2",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                    id: "tlf-context-info"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
$d6034d35ed2fcec7$export$5249b5f981c8cfd5.displayName = "BottomNavInfoModal";

});


parcelRegister("lE7gc", function(module, exports) {

$parcel$export(module.exports, "TopBar", function () { return $98c4cd4b30a652ac$export$c4e96258f3b6511; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");

var $6zNYN = parcelRequire("6zNYN");

var $3tNrK = parcelRequire("3tNrK");

var $6iYEs = parcelRequire("6iYEs");

var $bH32m = parcelRequire("bH32m");

var $lMl8s = parcelRequire("lMl8s");

var $j6deD = parcelRequire("j6deD");

var $fetYZ = parcelRequire("fetYZ");

var $2ObvW = parcelRequire("2ObvW");

const $98c4cd4b30a652ac$export$c4e96258f3b6511 = ({ title: title, fileEntry: fileEntry, settingsEntry: settingsEntry, showUser: showUser = true })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const logo = new URL((parcelRequire("hseKe")));
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("top-bar");
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).grid,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).gridBrandCell,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).brandHolder,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).brandBackgroud,
                        id: "topbar-brand",
                        onClick: ()=>navigate("/"),
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("img", {
                            src: logo.href,
                            alt: "Mosaic logo",
                            title: "Mosaic logo",
                            width: "214",
                            height: "63"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                id: "topbar-top-row",
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).gridRowOne,
                    "bg-light"
                ]),
                children: [
                    !appSettings.maintenanceMode && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).menuHolder,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lMl8s.NewItemDropMenu), {
                                fileEntry: fileEntry
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fetYZ.SettingsDropMenu), {
                                settingsEntry: settingsEntry
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        id: "topbar-title",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).center,
                        title: title,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                className: (0, $3tKzd.classMerge)([
                                    (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).titleText,
                                    "text-dark",
                                    "fw-bold"
                                ]),
                                children: title
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6zNYN.TocSaveIndicator), {})
                        ]
                    }),
                    showUser && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $j6deD.RightDropMenu), {})
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).gridRowTwo,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bH32m.HierarchyCrumbs), {})
            })
        ]
    });
};
$98c4cd4b30a652ac$export$c4e96258f3b6511.displayName = "TopBar";

});
parcelRegister("6zNYN", function(module, exports) {

$parcel$export(module.exports, "TocSaveIndicator", function () { return $0314be12af09e034$export$46c00358fae4df76; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $spJKX = parcelRequire("spJKX");

var $7ZhQG = parcelRequire("7ZhQG");

const $0314be12af09e034$export$46c00358fae4df76 = ()=>{
    const { state: state } = (0, $3tNrK.useTocContext)();
    const [showIndicator, setShowIndicator] = (0, $spJKX.useState)(false);
    const lastTriggeredAtRef = (0, $spJKX.useRef)(null);
    const hideTimerRef = (0, $spJKX.useRef)(null);
    const triggerTimerRef = (0, $spJKX.useRef)(null);
    /**
   * Trigger the indicator in response to an external event.
   * Scheduled from an effect via a timer to avoid synchronous setState.
   */ const triggerIndicator = (0, $spJKX.useEffectEvent)(()=>{
        setShowIndicator(true);
        // Clear any previous hide timers and schedule dismissal in 2 seconds
        if (hideTimerRef.current !== null) clearTimeout(hideTimerRef.current);
        hideTimerRef.current = window.setTimeout(()=>{
            setShowIndicator(false);
            hideTimerRef.current = null;
        }, 2000);
    });
    (0, $spJKX.useEffect)(()=>{
        // React to a successful save completion timestamp rather than version maths
        if (state.sendUpdate && !state.saveError && state.lastMinorVersionSavedAt !== null && state.lastMinorVersionSavedAt !== undefined) {
            const prev = lastTriggeredAtRef.current;
            const hasChanged = prev !== state.lastMinorVersionSavedAt;
            // Trigger on every new save timestamp to restart the 2-second flash
            if (hasChanged) {
                lastTriggeredAtRef.current = state.lastMinorVersionSavedAt;
                // Clear any previous trigger timer
                if (triggerTimerRef.current !== null) clearTimeout(triggerTimerRef.current);
                // Schedule indicator update asynchronously to avoid React warning about synchronous setState in effect
                triggerTimerRef.current = window.setTimeout(()=>{
                    triggerIndicator();
                    triggerTimerRef.current = null;
                }, 0);
            }
        }
    }, [
        state.lastMinorVersionSavedAt,
        state.sendUpdate,
        state.saveError
    ]);
    // Cleanup timers on unmount
    (0, $spJKX.useEffect)(()=>()=>{
            if (triggerTimerRef.current !== null) clearTimeout(triggerTimerRef.current);
            if (hideTimerRef.current !== null) clearTimeout(hideTimerRef.current);
        }, []);
    return showIndicator && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "toc-save-indicator",
        title: "TOC saved",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7ZhQG.default), {
            className: "save-icon-flash toc-save-icon",
            size: 16
        })
    });
};
$0314be12af09e034$export$46c00358fae4df76.displayName = "TocSaveIndicator";

});
parcelRegister("7ZhQG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d0c1345ae897e01$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $5d0c1345ae897e01$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $5d0c1345ae897e01$var$_extends() {
    return $5d0c1345ae897e01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5d0c1345ae897e01$var$_extends.apply(null, arguments);
}
function $5d0c1345ae897e01$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5d0c1345ae897e01$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $5d0c1345ae897e01$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5d0c1345ae897e01$var$FloppyFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $5d0c1345ae897e01$var$_objectWithoutProperties(_ref, $5d0c1345ae897e01$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $5d0c1345ae897e01$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-floppy-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M0 1.5A1.5 1.5 0 0 1 1.5 0H3v5.5A1.5 1.5 0 0 0 4.5 7h7A1.5 1.5 0 0 0 13 5.5V0h.086a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5H14v-5.5A1.5 1.5 0 0 0 12.5 9h-9A1.5 1.5 0 0 0 2 10.5V16h-.5A1.5 1.5 0 0 1 0 14.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M3 16h10v-5.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5zm9-16H4v5.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5zM9 1h2v4H9z"
    }));
});
$5d0c1345ae897e01$var$FloppyFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $5d0c1345ae897e01$export$2e2bcd8739ae039 = $5d0c1345ae897e01$var$FloppyFill;

});


parcelRegister("bH32m", function(module, exports) {

$parcel$export(module.exports, "HierarchyCrumbs", function () { return $8baf72230803f301$export$37236bf3d3d32cd7; });

var $bR5nk = parcelRequire("bR5nk");

var $iBbNa = parcelRequire("iBbNa");

var $jHdQm = parcelRequire("jHdQm");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $bkN8u = parcelRequire("bkN8u");

var $spJKX = parcelRequire("spJKX");

var $4wYgQ = parcelRequire("4wYgQ");

var $1p1jo = parcelRequire("1p1jo");
const $8baf72230803f301$export$37236bf3d3d32cd7 = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const breadcrumbRef = (0, $spJKX.useRef)(null);
    const [fullWidth, setFullWidth] = (0, $spJKX.useState)(0);
    const [measuredNodes, setMeasuredNodes] = (0, $spJKX.useState)(0);
    const [hideTree, setHideTree] = (0, $spJKX.useState)(false);
    const hierarchies = (0, $spJKX.useMemo)(()=>hierarchyContext && hierarchyContext.hierarchy ? [
            hierarchyContext.hierarchy,
            ...(0, $bkN8u.getThisAndParentHierarchies)(hierarchyContext.hierarchy.parentId, hierarchyContext.hierarchyNodes)
        ].map((h)=>({
                name: h.name,
                id: h.id,
                url: (0, $K53Ru.getHierarchyBaseUrl)(h)
            })).reverse() : [], [
        hierarchyContext
    ]);
    // Get expanded size
    (0, $spJKX.useEffect)(()=>{
        const breadcrumb = breadcrumbRef.current;
        const container = breadcrumb?.parentElement;
        if (breadcrumb && container && !hideTree && (measuredNodes !== hierarchies.length || fullWidth === 0)) {
            // Get max width
            setFullWidth(breadcrumb.offsetWidth);
            setMeasuredNodes(hierarchies.length);
        }
    }, [
        fullWidth,
        hideTree,
        hierarchies.length,
        measuredNodes
    ]);
    // Add resize observer
    (0, $spJKX.useEffect)(()=>{
        // Get parent element (which changes size with document)
        const container = breadcrumbRef.current?.parentElement;
        if (container && fullWidth) {
            // Set resize observer to check for overflow
            /**
       * Check container width and toggle compact breadcrumb mode when necessary.
       */ const checkContainerSize = ()=>{
                setHideTree(container.offsetWidth < fullWidth + 40);
            };
            const resizeObserver = new ResizeObserver(checkContainerSize);
            resizeObserver.observe(container);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        fullWidth
    ]);
    return !hierarchyContext?.hierarchy ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $4wYgQ.default), {
        ref: breadcrumbRef,
        className: "text-nowrap d-block",
        children: [
            hideTree && hierarchies.length >= 2 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4wYgQ.default).Item, {
                id: `breadcrumbs-up`,
                linkAs: (0, $iBbNa.ActiveNavLink),
                linkProps: {
                    to: `${hierarchies[hierarchies.length - 2].url}`,
                    end: true
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1p1jo.default), {})
            }, `breadcrumbs-up`),
            hierarchies.slice(hideTree ? hierarchies.length - 1 : 0).map((hierarchy)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $4wYgQ.default).Item, {
                    id: `breadcrumbs-${hierarchy.name}`,
                    linkAs: (0, $iBbNa.ActiveNavLink),
                    linkProps: {
                        to: `${hierarchy.url}`,
                        end: true
                    },
                    children: hierarchy.name
                }, hierarchy.id)),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jHdQm.CommentPanel), {
                activeContext: "Hierarchy"
            })
        ]
    });
};
$8baf72230803f301$export$37236bf3d3d32cd7.displayName = "HierarchyCrumbs";

});
parcelRegister("iBbNa", function(module, exports) {

$parcel$export(module.exports, "ActiveNavLink", function () { return $d7591284a24beb58$export$7c1c44d1ec04feb2; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1wSYE = parcelRequire("1wSYE");

var $6iYEs = parcelRequire("6iYEs");

var $4Q81F = parcelRequire("4Q81F");
const $d7591284a24beb58$export$7c1c44d1ec04feb2 = (props)=>{
    const { navigate: navigate, isLoading: isLoading } = (0, $6iYEs.useUnsavedChanges)(props.to.toString());
    const location = (0, $4Q81F.useLocation)();
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "position-relative overflow-hidden",
        children: [
            isLoading === props.to.toString() && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4Q81F.NavLink), {
                ...props,
                style: ({ isActive: isActive })=>isActive ? {
                        color: "black",
                        textDecorationLine: "none",
                        cursor: "default"
                    } : {},
                to: props.to,
                end: true,
                onClick: (e)=>{
                    if (e.ctrlKey || e.metaKey || e.button === 1 || e.shiftKey) return; // Allow default behavior for these keys
                    e.preventDefault();
                    e.stopPropagation();
                    if (props.to !== location.pathname) navigate(props.to);
                }
            })
        ]
    });
};
$d7591284a24beb58$export$7c1c44d1ec04feb2.displayName = "ActiveNavLink";

});

parcelRegister("jHdQm", function(module, exports) {

$parcel$export(module.exports, "CommentPanelInner", function () { return $38b3551335b8915e$export$f90eb0df6f6898f7; });
$parcel$export(module.exports, "CommentPanel", function () { return $38b3551335b8915e$export$ec8595c232deccb9; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $1wSYE = parcelRequire("1wSYE");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $b6GTY = parcelRequire("b6GTY");
var $31g00 = parcelRequire("31g00");

var $eRjZN = parcelRequire("eRjZN");
var $9HDOe = parcelRequire("9HDOe");

var $4Q81F = parcelRequire("4Q81F");

var $018QD = parcelRequire("018QD");

var $fgkxK = parcelRequire("fgkxK");


var $9h0pt = parcelRequire("9h0pt");

var $eX3Qo = parcelRequire("eX3Qo");

var $8ArNI = parcelRequire("8ArNI");

var $e5pGr = parcelRequire("e5pGr");

var $8vKHa = parcelRequire("8vKHa");

var $joohN = parcelRequire("joohN");
const $38b3551335b8915e$export$f90eb0df6f6898f7 = ({ activeContext: activeContext })=>{
    // Get contexts
    const { isSubscribed: isSubscribed, toggleCommentsSubscription: toggleCommentsSubscription, toggleCommentsSubscriptionRequest: toggleSubscriptionStatusRequest } = (0, $joohN.useComments)(activeContext);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "comment-button-header-panel d-flex flex-row justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eX3Qo.CreateCommentButton), {
                                activeContext: activeContext
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                className: "d-flex justify-content-end",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9h0pt.CommentSubscriptionButton), {
                                        toggleCommentsSubscription: toggleCommentsSubscription,
                                        isSubscribed: isSubscribed,
                                        toggleSubscriptionStatusRequest: toggleSubscriptionStatusRequest
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8ArNI.ResolveAllCommentsButton), {
                                        activeContext: activeContext
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $018QD.CommentFilter), {
                        activeContext: activeContext
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fgkxK.CommentThreads), {
                        activeContext: activeContext
                    })
                })
            })
        ]
    });
};
$38b3551335b8915e$export$f90eb0df6f6898f7.displayName = "CommentPanelInner";
/**
 * Icon for the comment button. Filled variant when comments exist.
 *
 * @param props - Component props.
 * @param props.anyComments - When true, show the filled icon.
 */ const $38b3551335b8915e$var$CommentIcon = (props)=>{
    return props.anyComments ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9HDOe.default), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eRjZN.default), {});
};
$38b3551335b8915e$var$CommentIcon.displayName = "CommentIcon";
const $38b3551335b8915e$export$ec8595c232deccb9 = ({ activeContext: activeContext, asButton: asButton = false, disabled: disabled })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, title: title } = (0, $joohN.useComments)(activeContext);
    const location = (0, $4Q81F.useLocation)();
    const isDisabled = disabled ?? false;
    // Component render
    return !comments || !commentPanelStatus || !setCommentPanelStatus ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            asButton ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                id: "tlf-comments-button",
                "aria-label": title,
                variant: "primary",
                size: "sm",
                className: "d-flex align-items-center gap-2",
                disabled: isDisabled,
                title: isDisabled ? (0, $e5pGr.NEW_TLF_COMMENT_TOOLTIP) : undefined,
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: !commentPanelStatus.showComments
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)($38b3551335b8915e$var$CommentIcon, {
                        anyComments: comments.length > 0
                    }),
                    title
                ]
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "comment-panel-button align-self-start ms-2",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: !commentPanelStatus.showComments
                    });
                },
                "aria-label": title,
                title: title,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)($38b3551335b8915e$var$CommentIcon, {
                    anyComments: comments.length > 0
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $b6GTY.default), {
                show: commentPanelStatus.showComments,
                placement: "end",
                onHide: ()=>setCommentPanelStatus({
                        ...commentPanelStatus,
                        showComments: false
                    }),
                backdrop: false,
                scroll: true,
                children: [
                    (0, $8vKHa.isRedirectingFromNotifications)(location.search) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                        text: "Redirecting to comment..."
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Header, {
                        closeButton: true,
                        className: "comments-offcanvas-header",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Title, {
                            className: "comments-offcanvas-title me-2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Body, {
                        className: "comments-offcanvas-body",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)($38b3551335b8915e$export$f90eb0df6f6898f7, {
                            activeContext: activeContext
                        })
                    })
                ]
            })
        ]
    });
};
$38b3551335b8915e$export$ec8595c232deccb9.displayName = "CommentPanel";

});
parcelRegister("eRjZN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad1586adfcc8fe6a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $ad1586adfcc8fe6a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $ad1586adfcc8fe6a$var$_extends() {
    return $ad1586adfcc8fe6a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad1586adfcc8fe6a$var$_extends.apply(null, arguments);
}
function $ad1586adfcc8fe6a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ad1586adfcc8fe6a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ad1586adfcc8fe6a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ad1586adfcc8fe6a$var$ChatLeftDots = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $ad1586adfcc8fe6a$var$_objectWithoutProperties(_ref, $ad1586adfcc8fe6a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $ad1586adfcc8fe6a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chat-left-dots',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    }));
});
$ad1586adfcc8fe6a$var$ChatLeftDots.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $ad1586adfcc8fe6a$export$2e2bcd8739ae039 = $ad1586adfcc8fe6a$var$ChatLeftDots;

});

parcelRegister("9HDOe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7107027a789dc7fd$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $7107027a789dc7fd$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $7107027a789dc7fd$var$_extends() {
    return $7107027a789dc7fd$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7107027a789dc7fd$var$_extends.apply(null, arguments);
}
function $7107027a789dc7fd$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7107027a789dc7fd$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7107027a789dc7fd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7107027a789dc7fd$var$ChatLeftDotsFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $7107027a789dc7fd$var$_objectWithoutProperties(_ref, $7107027a789dc7fd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $7107027a789dc7fd$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-chat-left-dots-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793zm5 4a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }));
});
$7107027a789dc7fd$var$ChatLeftDotsFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $7107027a789dc7fd$export$2e2bcd8739ae039 = $7107027a789dc7fd$var$ChatLeftDotsFill;

});

parcelRegister("018QD", function(module, exports) {

$parcel$export(module.exports, "CommentFilter", function () { return $0a7dd1fcf6709589$export$deea89e42080a68; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $aUt9N = parcelRequire("aUt9N");

var $joohN = parcelRequire("joohN");
const $0a7dd1fcf6709589$export$ff651bac85597a6d = [
    {
        value: "all",
        label: "All Comments"
    },
    {
        value: "resolved",
        label: "Resolved Comments Only"
    },
    {
        value: "open",
        label: "Open Comments Only"
    }
];
const $0a7dd1fcf6709589$export$deea89e42080a68 = ({ activeContext: activeContext })=>{
    const { commentFilter: commentFilter, setCommentFilter: setCommentFilter } = (0, $joohN.useComments)(activeContext);
    return !setCommentFilter ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
        id: "toc-comment-filter",
        label: "Comment filter",
        labelWidth: "auto",
        value: commentFilter,
        options: $0a7dd1fcf6709589$export$ff651bac85597a6d,
        setValue: (ret)=>{
            setCommentFilter(ret);
        }
    });
};
$0a7dd1fcf6709589$export$deea89e42080a68.displayName = "CommentFilter";

});
parcelRegister("joohN", function(module, exports) {

$parcel$export(module.exports, "useComments", function () { return $44664d85f07ce8d0$export$80ad823ea511ef0f; });
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $0eakK = parcelRequire("0eakK");

var $irvto = parcelRequire("irvto");

var $2Mlm8 = parcelRequire("2Mlm8");

var $f2M6x = parcelRequire("f2M6x");

var $1W4IY = parcelRequire("1W4IY");

var $fnSpc = parcelRequire("fnSpc");

var $irWpm = parcelRequire("irWpm");

var $8Mti0 = parcelRequire("8Mti0");

var $56q8t = parcelRequire("56q8t");

var $4lHS7 = parcelRequire("4lHS7");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $3ew5o = parcelRequire("3ew5o");

var $8BrMb = parcelRequire("8BrMb");
const $44664d85f07ce8d0$export$80ad823ea511ef0f = (activeContext, tocId)=>{
    // Get contexts
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const level = hierarchyContext?.hierarchy?.level;
    const { state: tocState } = (0, $3tNrK.useTocContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { state: state, dispatch: dispatch } = (0, $3tNrK.useTocContext)();
    // #region Variables based on context
    /**
   * Title for the comments section based on the active context.
   */ const title = `${activeContext === "Hierarchy" && level ? level : activeContext === "TlfItem" && tlfContext && tlfContext.tlfData && tlfContext.tlfData.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report ? "Shell" : activeContext === "TlfItem" && tlfContext.tlfData ? "Template" : "Unknown"} comments`;
    /**
   * Entity ID based on the active context.
   */ const entityId = activeContext === "Hierarchy" ? hierarchyContext?.hierarchy?.id : tlfContext.tlfData?.id;
    /**
   * Check if the current context is subscribed to comments.
   */ const isSubscribed = activeContext === "Hierarchy" && hierarchyContext ? hierarchyContext.isSubscribed : activeContext === "TlfItem" && tlfContext ? tlfContext.isSubscribed : false;
    /**
   * Current comment panel status based on the active context.
   */ const commentPanelStatus = activeContext === "Hierarchy" && hierarchyContext ? hierarchyContext?.commentPanelStatus : activeContext === "TlfItem" && tlfContext ? tlfContext.commentPanelStatus : null;
    /**
   * Current comment filter based on the active context.
   */ const commentFilter = activeContext === "Toc" ? state.commentsFilter : commentPanelStatus?.commentFilter ?? "all";
    /**
   * Details for the active context to use in server requests.
   */ const xdetails = activeContext === "Hierarchy" && hierarchyContext?.hierarchy ? {
        hierarchyId: hierarchyContext?.hierarchy.id
    } : activeContext === "TlfItem" && tlfContext.tlfData ? {
        id: tlfContext.tlfData.id,
        azsolId: tlfContext.tlfData.azsolId,
        version: tlfContext.tlfData.version
    } : null;
    /**
   * Fetches comments from the active context and cleans up any bad parentIds.
   */ const comments = activeContext === "Hierarchy" && hierarchyContext?.hierarchy?.comments ? hierarchyContext.hierarchy.comments : activeContext === "TlfItem" && tlfContext.tlfData && "comments" in tlfContext.tlfData ? tlfContext.tlfData.comments : tocState.tocItems.find((item)=>item.id === tocId && "comments" in item)?.comments ?? [];
    // Clean bad parentIds
    comments.forEach((c)=>{
        if (c.parentId && !comments.find((p)=>p.id === c.parentId)) c.parentId = undefined;
    });
    // #endregion
    // #region Utility functions
    /**
   * Sets the comment panel status in the appropriate context based on the active context.
   *
   * @param status - The new comment panel status to set.
   *        This should be of type CommentPanelStatus.
   */ const setCommentPanelStatusInContext = (status)=>{
        if (activeContext === "Hierarchy") hierarchyContext?.dispatch({
            operation: (0, $0eakK.SET_HIERARCHY_COMMENT_PANEL),
            commentPanelStatus: status
        });
        else tlfContext.dispatch({
            operation: (0, $2Mlm8.SET_TLF_COMMENT_PANEL),
            calledFrom: "useComments:setCommentPanelStatus",
            commentPanelStatus: status
        });
    };
    /**
   * Sets the comment filter in the appropriate context based on the active context.
   *
   * @param commentFilter - The new comment filter to set.
   *        This should be of type CommentFilterOptionValue.
   */ const setCommentFilterInContext = (commentFilter)=>{
        switch(activeContext){
            case "Hierarchy":
            case "TlfItem":
                /* istanbul ignore else */ if (commentPanelStatus) setCommentPanelStatusInContext({
                    ...commentPanelStatus,
                    commentFilter: commentFilter
                });
                break;
            case "Toc":
                dispatch({
                    operation: (0, $f2M6x.UPDATE_COMMENTS_FILTER),
                    commentsFilter: commentFilter
                });
                break;
        }
    };
    /**
   * Signal R groupname
   */ const signalRgroup = activeContext === "Hierarchy" ? `hie${hierarchyContext?.hierarchy?.id}` : `tlf${tlfContext.tlfData?.id}`;
    /**
   * Send a comment update to other users in the assigned context
   *
   * @param commentsPatch - Comments patch to send
   * @returns Promise resolving to the sent message
   */ const sendCommentPatchToOthers = async (commentsPatch)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify(commentsPatch), signalRgroup, "commentsPatch");
    };
    /**
   * Sets the comments in the appropriate context based on the active context.
   *
   * @param newComments - The new comments to set in the context.
   * @param sendPatch - When true, send a patch of the changes to other users.
   */ const setCommentsInContext = (newComments, sendPatch = false)=>{
        /* istanbul ignore else */ if (sendPatch && comments) {
            const patch = (0, $3ew5o.createPatch)(comments.sort((0, $8BrMb.sortCommentsAscending)), newComments.sort((0, $8BrMb.sortCommentsAscending)));
            /* istanbul ignore else */ if (patch.length > 0) sendCommentPatchToOthers(patch);
        }
        /* istanbul ignore else */ if (activeContext === "Hierarchy" && hierarchyContext && hierarchyContext.hierarchy && !(0, $eBlbF.isEqual)(newComments, hierarchyContext.hierarchy.comments)) {
            const hierarchyPatch = {
                comments: newComments
            };
            hierarchyContext.dispatch({
                operation: (0, $0eakK.UPDATE_HIERARCHY),
                hierarchy: hierarchyPatch
            });
        } else if (activeContext === "TlfItem" && hierarchyContext && tlfContext && tlfContext.tlfData && "comments" in tlfContext.tlfData && !(0, $eBlbF.isEqual)(newComments, tlfContext.tlfData.comments)) tlfContext.dispatch({
            operation: (0, $2Mlm8.UPDATE_TLF),
            tlfData: {
                comments: newComments
            },
            calledFrom: "useComments:setCommentsInContext",
            doNotAddUndo: true
        });
    };
    /**
   * Updates the subscription status in the appropriate context based on the active context.
   *
   * @param status - A boolean indicating the subscription status to set.
   *        `true` means subscribed, and `false` means unsubscribed.
   */ const setSubscriptionStatusInContext = (status)=>{
        if (activeContext === "Hierarchy") hierarchyContext?.dispatch({
            operation: (0, $0eakK.SET_HIERARCHY_SUBSCRIPTION_STATUS),
            isSubscribed: status
        });
        else tlfContext.dispatch({
            operation: (0, $2Mlm8.SET_TLF_SUBSCRIPTION_STATUS),
            calledFrom: "useComments:setSubscriptionStatus",
            isSubscribed: status
        });
    };
    /**
   * Create a new comment in the assigned context
   *
   * @param parentId - Id of the parent comment, if any
   * @param relatedTo - Section/Item/Id in assigned context the comment relates to
   */ const createComment = (parentId, relatedTo)=>{
        /* istanbul ignore else */ if (comments && appSettings.userId && appSettings.userId > -1) {
            const now = new Date().toISOString();
            const newComment = {
                id: `new-${crypto.randomUUID()}`,
                authorDisplayName: appSettings.displayName,
                authorId: appSettings.userId,
                commentReviewStatus: (0, $8Mti0.eCommentReviewStatus).open,
                content: {
                    lines: [
                        {
                            textBlocks: [
                                {
                                    text: ""
                                }
                            ]
                        }
                    ]
                },
                createdAt: now,
                parentId: parentId,
                relatedTo: relatedTo,
                updateCount: 0,
                updatedAt: now,
                canDelete: true
            };
            setCommentsInContext([
                ...comments,
                newComment
            ]);
            return newComment;
        }
    };
    /**
   * Read an existing comment from the assigned context
   *
   * @param commentId - Assigned comment id
   */ const readComment = (commentId)=>comments?.find((c)=>c.id === commentId);
    /**
   * Send a comment to other users in the assigned context
   *
   * @param comment - Comment to send
   * @returns Promise resolving to the sent message
   */ const sendCommentToOthers = async (comment)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify(comment), signalRgroup, "comment");
    };
    /**
   * Delete a comment for other users in the assigned context
   *
   * @param commentId - Id of the comment to delete
   * @returns Promise resolving to the sent message
   */ const deleteCommentForOthers = async (commentId)=>{
        return await signalR?.sendMessageToGroup(JSON.stringify({
            id: commentId
        }), signalRgroup, "deleteComment");
    };
    // Update request status
    const [updateRequest, setUpdateRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Post comment to the server,
   * status of the request is in the postRequest variable
   *
   * @param commentId - Id of the comment to save
   * @param commentContents - New content for the comment
   */ const updateCommentInContext = async (commentId, commentContents)=>{
        const newComments = [
            ...comments
        ];
        const ix = newComments.findIndex((c)=>c.id === commentId);
        // Check comment is found and can be posted
        /* istanbul ignore else */ if (ix > -1 && xdetails) {
            const thisComment = newComments[ix];
            // Remove any errors
            setUpdateRequest({
                ...updateRequest,
                error: false
            });
            // Set request
            let request;
            // Add new comment to the server & context
            if (thisComment.id.startsWith("new")) {
                const dto = {
                    content: commentContents,
                    parentId: thisComment.parentId,
                    relatedTo: thisComment.relatedTo,
                    ...xdetails
                };
                request = await (0, $4dL47.loadWrapper)((0, $1W4IY.addComment), dto, {
                    ...updateRequest,
                    requestedId: undefined
                }, setUpdateRequest, appSettings.backEndUrl);
            } else {
                const dto = {
                    commentId: thisComment.id,
                    content: commentContents,
                    ...xdetails
                };
                request = await (0, $4dL47.loadWrapper)((0, $56q8t.updateComment), dto, {
                    ...updateRequest,
                    requestedId: undefined
                }, setUpdateRequest, appSettings.backEndUrl);
            }
            // Process successful return
            /* istanbul ignore else */ if (request?.success) {
                newComments.splice(ix, 1, request.data);
                setCommentsInContext(newComments);
                sendCommentToOthers(request.data);
                /* istanbul ignore else */ if (!isSubscribed) setSubscriptionStatusInContext(true);
            }
        }
    };
    // Delete request status.
    const [deleteRequest, setDeleteRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Delete a comment in the assigned context,
   * status of the request is in the deleteRequest variable
   *
   * @param commentId - Id of the comment to delete
   */ const deleteCommentFromContext = async (commentId)=>{
        const newComments = [
            ...comments
        ];
        const ix = comments.findIndex((c)=>c.id === commentId);
        /* istanbul ignore else */ if (ix > -1 && xdetails) {
            const thisComment = newComments[ix];
            let response = null;
            // Send request to delete existing comment
            if (!thisComment.id.startsWith("new")) response = await (0, $4dL47.loadWrapper)((0, $fnSpc.deleteComment), {
                commentId: commentId,
                ...xdetails
            }, deleteRequest, setDeleteRequest, appSettings.backEndUrl);
            else response = {
                success: true
            };
            // Update on success
            /* istanbul ignore else */ if (response && response.success) {
                newComments.splice(ix, 1);
                setCommentsInContext(newComments);
                deleteCommentForOthers(thisComment.id);
            }
            // Remove any highlight for deleted comment
            /* istanbul ignore else */ if (commentPanelStatus && commentPanelStatus.highlightCommentId === commentId) setCommentPanelStatusInContext({
                ...commentPanelStatus,
                highlightCommentId: "",
                activeRelatedTo: ""
            });
        }
    };
    // Toggle comment subscription request status.
    const [toggleCommentsSubscriptionRequest, setToggleCommentsSubscriptionRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Toggle comments subscription for the active context
   */ const toggleCommentsSubscription = async ()=>{
        if (!entityId || activeContext === "Toc") return;
        const action = isSubscribed ? "unsubscribe" : "subscribe";
        const response = await (0, $4dL47.loadWrapper)((0, $irWpm.handleCommentsSubscription), {
            activeContext: activeContext,
            entityId: entityId,
            action: action
        }, toggleCommentsSubscriptionRequest, setToggleCommentsSubscriptionRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) setSubscriptionStatusInContext(response.data);
    };
    // #endregion
    return {
        commentFilter: commentFilter,
        commentPanelStatus: commentPanelStatus,
        comments: comments,
        createComment: createComment,
        deleteComment: deleteCommentFromContext,
        deleteRequest: deleteRequest,
        isSubscribed: isSubscribed,
        readComment: readComment,
        setCommentFilter: setCommentFilterInContext,
        setCommentPanelStatus: setCommentPanelStatusInContext,
        setComments: setCommentsInContext,
        title: title,
        toggleCommentsSubscription: toggleCommentsSubscription,
        toggleCommentsSubscriptionRequest: toggleCommentsSubscriptionRequest,
        updateComment: updateCommentInContext,
        updateRequest: updateRequest
    };
};

});
parcelRegister("1W4IY", function(module, exports) {

$parcel$export(module.exports, "addComment", function () { return $8e3cd491e9eefa5b$export$1cab2cf04e810197; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $8e3cd491e9eefa5b$export$1cab2cf04e810197 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comments`;
            const ret = await (0, $lCyBC.default).post(url, {
                content: details.content,
                parentId: details.parentId,
                relatedTo: details.relatedTo
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comments`;
            const ret = await (0, $lCyBC.default).post(url, {
                content: details.content,
                parentId: details.parentId,
                relatedTo: details.relatedTo
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        }
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Add comment failed", error);
    }
};

});

parcelRegister("fnSpc", function(module, exports) {

$parcel$export(module.exports, "deleteComment", function () { return $b24502d1bc4738ef$export$2e6e3ad634e3776; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $b24502d1bc4738ef$export$2e6e3ad634e3776 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
            await (0, $lCyBC.default).delete(url, {
                signal: controller.signal
            });
            return {
                success: true
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
            await (0, $lCyBC.default).delete(url, {
                signal: controller.signal
            });
            return {
                success: true
            };
        }
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Delete comment failed", error);
    }
};

});

parcelRegister("irWpm", function(module, exports) {

$parcel$export(module.exports, "handleCommentsSubscription", function () { return $7496166913f2c526$export$d5e5af18e4d63273; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $7496166913f2c526$export$d5e5af18e4d63273 = async (backEndUrl, details, controller)=>{
    try {
        const url = `${backEndUrl}Comments/${details.activeContext}/${details.entityId}/${details.action}`;
        const response = await (0, $lCyBC.default).put(url, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)(`Failed to ${details.action}`, error);
    }
};

});

parcelRegister("8Mti0", function(module, exports) {

$parcel$export(module.exports, "eCommentReviewStatus", function () { return $927a110f708e321c$export$150f08c6992f2990; });
var $927a110f708e321c$export$150f08c6992f2990 = /*#__PURE__*/ function(eCommentReviewStatus) {
    eCommentReviewStatus["open"] = "Open";
    eCommentReviewStatus["resolved"] = "Resolved";
    return eCommentReviewStatus;
}({});

});

parcelRegister("56q8t", function(module, exports) {

$parcel$export(module.exports, "updateComment", function () { return $23e9dee0859696ba$export$5a1cd239009d83a6; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $23e9dee0859696ba$export$5a1cd239009d83a6 = async (backEndUrl, details, controller)=>{
    try {
        if (details.hierarchyId) {
            const hdets = details;
            const url = `${backEndUrl}Hierarchy/${hdets.hierarchyId}/Comment/${hdets.commentId}`;
            const ret = await (0, $lCyBC.default).put(url, {
                content: details.content
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        } else {
            const tdets = details;
            const url = `${backEndUrl}TlfItems/${tdets.id}/Comment/${tdets.commentId}`;
            const ret = await (0, $lCyBC.default).put(url, {
                content: details.content
            }, {
                signal: controller.signal
            });
            return {
                success: true,
                data: ret.data
            };
        }
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Update comment failed", error);
    }
};

});



parcelRegister("fgkxK", function(module, exports) {

$parcel$export(module.exports, "CommentThreads", function () { return $aa2eff9498ba0067$export$e6645788a16b92c0; });

var $bR5nk = parcelRequire("bR5nk");

var $idk5r = parcelRequire("idk5r");

var $fFqMd = parcelRequire("fFqMd");

var $jZNjZ = parcelRequire("jZNjZ");

var $8BrMb = parcelRequire("8BrMb");

var $joohN = parcelRequire("joohN");
const $aa2eff9498ba0067$export$e6645788a16b92c0 = ({ activeContext: activeContext, tocId: tocId })=>{
    const { comments: comments, commentFilter: commentFilter } = (0, $joohN.useComments)(activeContext, tocId);
    const parentComments = comments.filter((c)=>c.parentId === undefined);
    const visibleComments = parentComments.sort((0, $8BrMb.sortComments)).filter((comment)=>(0, $jZNjZ.shouldShowCommentThread)(comment.id, comments, commentFilter));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: parentComments.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            className: "text-muted text-center d-block",
            children: /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                children: "No comments"
            })
        }) : visibleComments.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            className: "text-muted text-center d-block",
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("em", {
                children: [
                    "No ",
                    commentFilter,
                    " comments"
                ]
            })
        }) : visibleComments.map((comment)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "comment-initial-thread",
                children: [
                    activeContext !== "Toc" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fFqMd.ResolveThreadCommentsButton), {
                        activeContext: activeContext,
                        commentId: comment.id
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $idk5r.CommentThread), {
                        id: comment.id,
                        activeContext: activeContext,
                        tocId: tocId
                    })
                ]
            }, comment.id))
    });
};
$aa2eff9498ba0067$export$e6645788a16b92c0.displayName = "CommentThreads";

});
parcelRegister("idk5r", function(module, exports) {

$parcel$export(module.exports, "CommentThread", function () { return $af7614e983317720$export$534dc0e681c6a2d7; });

var $bR5nk = parcelRequire("bR5nk");

var $frt8Z = parcelRequire("frt8Z");

var $8BrMb = parcelRequire("8BrMb");

var $joohN = parcelRequire("joohN");
const $af7614e983317720$export$534dc0e681c6a2d7 = ({ id: id, activeContext: activeContext, tocId: tocId })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, readComment: readComment } = (0, $joohN.useComments)(activeContext, tocId);
    const thisComment = readComment(id);
    return !thisComment || (!commentPanelStatus || !setCommentPanelStatus) && activeContext !== "Toc" ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $frt8Z.CommentBox), {
                commentId: id,
                activeContext: activeContext,
                disabled: activeContext === "Toc" || comments.some((c)=>c.parentId === id),
                tocId: tocId
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "comment-reply-holder",
                children: comments.filter((c)=>c.parentId === id).sort((0, $8BrMb.sortCommentsAscending)).map((c)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "comment-reply",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)($af7614e983317720$export$534dc0e681c6a2d7, {
                            id: c.id,
                            activeContext: activeContext,
                            tocId: tocId
                        })
                    }, c.id))
            })
        ]
    });
};
$af7614e983317720$export$534dc0e681c6a2d7.displayName = "CommentThread";

});
parcelRegister("frt8Z", function(module, exports) {

$parcel$export(module.exports, "CommentBox", function () { return $1de658f5dce7e731$export$b201898d93a12223; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $9S4dL = parcelRequire("9S4dL");

var $3tNrK = parcelRequire("3tNrK");

var $er09a = parcelRequire("er09a");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");


var $eX3Qo = parcelRequire("eX3Qo");

var $gCLgg = parcelRequire("gCLgg");

var $1nHEe = parcelRequire("1nHEe");

var $8vKHa = parcelRequire("8vKHa");

var $izQmG = parcelRequire("izQmG");

var $3G7sT = parcelRequire("3G7sT");

var $joohN = parcelRequire("joohN");
const $1de658f5dce7e731$export$b201898d93a12223 = ({ activeContext: activeContext, commentId: commentId, disabled: disabled, tocId: tocId })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    // Get contexts
    const appSettings = (0, $3tNrK.useAppSettings)();
    const { commentPanelStatus: commentPanelStatus, readComment: readComment, setCommentPanelStatus: setCommentPanelStatus, commentFilter: commentFilter } = (0, $joohN.useComments)(activeContext, tocId);
    const location = (0, $4Q81F.useLocation)();
    // Ref to the comment box element for managing focus
    const commentBoxRef = (0, $spJKX.useRef)(null);
    /**
   * Reads the comment with the given ID from the context
   */ const thisComment = readComment(commentId);
    /**
   * Initializes the original text of the comment
   */ const originalText = thisComment?.content ?? (0, $bX0x9.stringToV3)("");
    /**
   * Determines if the current user can edit the comment
   */ const canEdit = (0, $spJKX.useMemo)(()=>thisComment?.authorId === appSettings.userId && !disabled && thisComment.commentReviewStatus !== "Resolved", [
        appSettings.userId,
        disabled,
        thisComment?.authorId,
        thisComment?.commentReviewStatus
    ]);
    /**
   * State to manage the current content of the comment editor
   */ const [currentContent, setCurrentContent] = (0, $spJKX.useState)(originalText);
    /**
   * State to manage the current status of the comment save button
   */ const [currentStatus, setCurrentStatus] = (0, $spJKX.useState)(!canEdit ? "disabled" : thisComment?.id.startsWith("new-") ? "new" : "saved");
    /**
   * Update currentStatus if canEdit changes, shouldn't be possible to have new comments with a resolved status
   */ (0, $spJKX.useEffect)(()=>{
        if (canEdit && currentStatus === "disabled" && !thisComment?.id.startsWith("new-")) startTransition(()=>setCurrentStatus("saved"));
    }, [
        canEdit,
        currentStatus,
        thisComment?.id
    ]);
    /**
   * Effect to reset the current content when the comment is updated from the top down and is not in editing or new status
   */ (0, $spJKX.useEffect)(()=>{
        if (!(0, $eBlbF.isEqual)(currentContent, originalText) && ![
            "editing",
            "new"
        ].includes(currentStatus)) startTransition(()=>setCurrentContent(originalText));
    }, [
        currentContent,
        currentStatus,
        originalText
    ]);
    /**
   * Effect to set activeRelatedTo when the comment is focused from notifications
   */ (0, $spJKX.useEffect)(()=>{
        if (thisComment?.relatedTo && commentPanelStatus?.highlightCommentId === commentId && thisComment?.relatedTo !== commentPanelStatus.activeRelatedTo) setCommentPanelStatus({
            ...commentPanelStatus,
            activeRelatedTo: thisComment.relatedTo
        });
    }, [
        thisComment?.relatedTo,
        commentId,
        commentPanelStatus,
        setCommentPanelStatus
    ]);
    /**
   * Determines if the user can post this comment based on the current status and content
   */ const canPost = (0, $spJKX.useMemo)(()=>canEdit && (currentStatus === "new" || currentStatus === "editing") && (0, $bX0x9.getTextFromEditorV3)(currentContent).join("").trim() !== "" && !(0, $bX0x9.cleanIsEqual)(currentContent, originalText), [
        canEdit,
        currentContent,
        currentStatus,
        originalText
    ]);
    /**
   * Function to handle the @ mention list for the editor
   * @param typedString - The string currently being typed in the editor
   * @returns A promise that resolves to a list of users matching the typed string
   */ const atListFunction = (0, $spJKX.useCallback)(async (typedString)=>{
        if (typedString.length === 1) return [
            {
                text: "Waiting...",
                data: {}
            }
        ];
        const request = await (0, $er09a.searchUsers)(appSettings.backEndUrl, typedString.slice(1));
        const ret = [];
        /* istanbul ignore else */ if (request?.success) request.data?.sort((a, b)=>`${a.displayName}`.localeCompare(`${b.displayName}`)).forEach((u)=>{
            /* istanbul ignore else */ if (u.displayName && u.prid) ret.push({
                text: u.displayName,
                data: {
                    prid: u.prid
                }
            });
        });
        return ret;
    }, [
        appSettings.backEndUrl
    ]);
    /**
   * Function to update the comment panel status
   * @param updates - Updates to the comment panel status
   */ const updateCommentPanelStatus = (0, $spJKX.useCallback)((updates)=>{
        /* istanbul ignore else */ if (setCommentPanelStatus && commentPanelStatus) setCommentPanelStatus({
            ...commentPanelStatus,
            ...updates
        });
    }, [
        setCommentPanelStatus,
        commentPanelStatus
    ]);
    /**
   * Determines if the comment should be visible based on the filter and review status.
   */ const shouldShowComment = (0, $spJKX.useMemo)(()=>(0, $1nHEe.isCommentVisible)(commentFilter, thisComment?.commentReviewStatus), [
        commentFilter,
        thisComment?.commentReviewStatus
    ]);
    /**
   * Memo for the class name for the comment based on its status
   */ const getCommentClassName = (0, $spJKX.useMemo)(()=>{
        if (commentPanelStatus?.highlightCommentId === commentId || commentPanelStatus?.activeRelatedTo && commentPanelStatus?.activeRelatedTo === thisComment?.relatedTo) return "highlight";
        return "";
    }, [
        commentId,
        commentPanelStatus,
        thisComment
    ]);
    // Add global mousedown handler to clear highlight when clicking outside comment box
    const handleDocumentMouseDown = (0, $spJKX.useCallback)((e)=>{
        if (e.target && commentBoxRef.current && !commentBoxRef.current.contains(e.target) && (commentPanelStatus?.activeRelatedTo !== "" || commentPanelStatus?.highlightCommentId !== "")) updateCommentPanelStatus({
            highlightCommentId: "",
            activeRelatedTo: ""
        });
    }, [
        commentPanelStatus?.activeRelatedTo,
        commentPanelStatus?.highlightCommentId,
        updateCommentPanelStatus
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (commentPanelStatus?.highlightCommentId === commentId && !(0, $8vKHa.isRedirectingFromNotifications)(location.search)) {
            document.addEventListener("mousedown", handleDocumentMouseDown);
            return ()=>{
                document.removeEventListener("mousedown", handleDocumentMouseDown);
            };
        }
    }, [
        handleDocumentMouseDown,
        commentId,
        commentPanelStatus?.highlightCommentId,
        location.search
    ]);
    /**
   * Shared onBlur handler for comment box and editor
   */ const handleBlur = (0, $spJKX.useCallback)((e)=>{
        const commentBox = commentBoxRef.current;
        const nextFocused = e.relatedTarget;
        // Only handle blur if this is the outermost comment box
        if ((0, $8vKHa.isRedirectingFromNotifications)(location.search) || "currentTarget" in e && e.currentTarget && commentBox && e.currentTarget !== commentBox) return;
        if (!nextFocused || !commentBox?.contains(nextFocused)) updateCommentPanelStatus({
            highlightCommentId: "",
            activeRelatedTo: ""
        });
    }, [
        updateCommentPanelStatus,
        location.search
    ]);
    return !thisComment || !shouldShowComment ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: `comment ${getCommentClassName}`,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            className: "comment-text-holder position-relative",
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "comment-box",
                role: "region",
                id: `comment-${commentId}-box`,
                tabIndex: 0,
                ref: commentBoxRef,
                onBlur: handleBlur,
                onFocus: ()=>{
                    if (commentPanelStatus && (thisComment.relatedTo ?? "") !== commentPanelStatus.activeRelatedTo) updateCommentPanelStatus({
                        highlightCommentId: thisComment.id,
                        activeRelatedTo: thisComment.relatedTo
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "comment-header col pe-0",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "comment-header-name",
                                children: thisComment.authorDisplayName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bX0x9.EditorV3), {
                                    className: "comment-editor",
                                    id: `comment-${commentId}`,
                                    input: currentContent,
                                    allowNewLine: true,
                                    atListFunction: atListFunction,
                                    debounceMilliseconds: -1,
                                    "aria-label": "Comment text",
                                    "aria-readonly": [
                                        "editing",
                                        "new"
                                    ].includes(currentStatus),
                                    editable: [
                                        "editing",
                                        "new"
                                    ].includes(currentStatus),
                                    setObject: (ret)=>{
                                        setCurrentContent({
                                            lines: ret.lines
                                        });
                                    },
                                    resize: !disabled ? "vertical" : undefined,
                                    onBlur: handleBlur
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                    className: "comment-button-holder d-flex flex-column gap-1 col pt-1",
                                    children: [
                                        !disabled && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                            className: "d-flex flex-row gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3G7sT.UpdateCommentButton), {
                                                    activeContext: activeContext,
                                                    currentStatus: currentStatus,
                                                    disabled: [
                                                        "new",
                                                        "editing"
                                                    ].includes(currentStatus) ? !canPost : !canEdit,
                                                    commentId: commentId,
                                                    currentContent: currentContent,
                                                    setCurrentStatus: setCurrentStatus
                                                }),
                                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCLgg.DeleteCommentButton), {
                                                    activeContext: activeContext,
                                                    commentId: commentId,
                                                    canEdit: canEdit
                                                })
                                            ]
                                        }),
                                        activeContext !== "Toc" && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $izQmG.ResolveCommentButton), {
                                                    activeContext: activeContext,
                                                    commentId: commentId,
                                                    disabled: [
                                                        "new",
                                                        "editing",
                                                        "error"
                                                    ].includes(currentStatus)
                                                }),
                                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eX3Qo.CreateCommentButton), {
                                                    id: `reply-comment-${commentId}`,
                                                    activeContext: activeContext,
                                                    parentId: commentId,
                                                    relatedTo: thisComment.relatedTo,
                                                    reply: true,
                                                    disabled: [
                                                        "new",
                                                        "editing",
                                                        "error"
                                                    ].includes(currentStatus) || thisComment.commentReviewStatus === "Resolved"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "row w-100 pe-0",
                                children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                    className: "comment-header comment-header-time col pe-0 text-muted",
                                    children: [
                                        thisComment.entityVersion && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                            className: "comment-header-version",
                                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("em", {
                                                children: [
                                                    "Added on version ",
                                                    thisComment.entityVersion
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bR5nk.jsxs)("em", {
                                            children: [
                                                thisComment.updateCount >= 1 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                                                    children: "Edited "
                                                }),
                                                (0, $9S4dL.convertDateToLocaleString)(thisComment.updatedAt)
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
$1de658f5dce7e731$export$b201898d93a12223.displayName = "CommentBox";

});
parcelRegister("er09a", function(module, exports) {

$parcel$export(module.exports, "searchUsers", function () { return $bd31fcbcc56db3bc$export$c996479cb76ab18b; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $bd31fcbcc56db3bc$export$c996479cb76ab18b = async (backEndUrl, searchText, controller)=>{
    const url = `${backEndUrl}Users/search?search=${searchText}`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load all users failed", error);
    }
};

});

parcelRegister("eX3Qo", function(module, exports) {

$parcel$export(module.exports, "CreateCommentButton", function () { return $40e76c8f524890b1$export$b70263bc36c4d2b6; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $eRjZN = parcelRequire("eRjZN");

var $joohN = parcelRequire("joohN");
const $40e76c8f524890b1$export$b70263bc36c4d2b6 = ({ id: id = "create-comment-button", activeContext: activeContext, parentId: parentId, relatedTo: relatedTo, reply: reply = false, disabled: disabled = false, label: label = reply ? "Reply" : "Create comment" })=>{
    // Get contexts
    const { createComment: createComment } = (0, $joohN.useComments)(activeContext);
    /**
   * Handle click event to create a new comment.
   *
   * @param e - Mouse event
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (!disabled) createComment(parentId, relatedTo);
    };
    // Component render
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        id: id,
        title: label,
        "aria-label": label,
        onClick: handleClick,
        size: "sm",
        disabled: disabled,
        children: [
            label === "Create comment" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eRjZN.default), {
                className: "me-1"
            }),
            label
        ]
    });
};
$40e76c8f524890b1$export$b70263bc36c4d2b6.displayName = "CreateCommentButton";

});

parcelRegister("gCLgg", function(module, exports) {

$parcel$export(module.exports, "DeleteCommentButton", function () { return $b6eadf41d6749df2$export$fdf3fce3c5515e3b; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $spJKX = parcelRequire("spJKX");

var $47XFM = parcelRequire("47XFM");

var $joohN = parcelRequire("joohN");
const $b6eadf41d6749df2$export$fdf3fce3c5515e3b = ({ activeContext: activeContext, commentId: commentId, canEdit: canEdit })=>{
    const { deleteComment: deleteComment, comments: comments, readComment: readComment, deleteRequest: deleteRequest } = (0, $joohN.useComments)(activeContext);
    const thisComment = readComment(commentId);
    /**
   * Handle click event to delete the comment.
   *
   * @param e - Mouse event
   */ const handleClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        deleteComment(commentId);
    };
    const disabled = (0, $spJKX.useMemo)(()=>!thisComment?.canDelete || !canEdit || comments.filter((c)=>c.parentId === thisComment.id).length > 0, [
        thisComment,
        canEdit,
        comments
    ]);
    return thisComment && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        size: "sm",
        "aria-label": "Delete comment",
        disabled: disabled,
        id: `delete-comment-${thisComment.id}`,
        className: "align-self-top",
        onClick: handleClick,
        variant: "danger",
        requestStatus: deleteRequest,
        title: disabled ? "Comment cannot be deleted" : "Delete comment",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $47XFM.default), {
            size: 14
        })
    });
};
$b6eadf41d6749df2$export$fdf3fce3c5515e3b.displayName = "DeleteCommentButton";

});
parcelRegister("47XFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30161aa818128e92$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $30161aa818128e92$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $30161aa818128e92$var$_extends() {
    return $30161aa818128e92$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $30161aa818128e92$var$_extends.apply(null, arguments);
}
function $30161aa818128e92$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $30161aa818128e92$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $30161aa818128e92$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $30161aa818128e92$var$TrashFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $30161aa818128e92$var$_objectWithoutProperties(_ref, $30161aa818128e92$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $30161aa818128e92$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-trash-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0"
    }));
});
$30161aa818128e92$var$TrashFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $30161aa818128e92$export$2e2bcd8739ae039 = $30161aa818128e92$var$TrashFill;

});


parcelRegister("1nHEe", function(module, exports) {

$parcel$export(module.exports, "isCommentVisible", function () { return $d5d3924e55866217$export$8dc79b823b8935c4; });
const $d5d3924e55866217$export$8dc79b823b8935c4 = (commentFilter, commentReviewStatus)=>{
    return commentFilter === "all" || commentFilter === "open" && commentReviewStatus === "Open" || commentFilter === "resolved" && commentReviewStatus === "Resolved";
};

});

parcelRegister("8vKHa", function(module, exports) {

$parcel$export(module.exports, "isRedirectingFromNotifications", function () { return $0cd3ede12ee3a1ec$export$c50291a50a530ee0; });
/**
 * Check whether the URL search string contains comment highlighting parameters from notifications.
 *
 * @param search - The URL search string to check
 * @returns True if redirecting from notifications with comment parameters
 */ const $0cd3ede12ee3a1ec$export$c50291a50a530ee0 = (search)=>{
    const searchParams = new URLSearchParams(search);
    return searchParams.has("showTlfItemComments") || searchParams.has("commentId") || searchParams.has("showHierarchyComments");
};

});

parcelRegister("izQmG", function(module, exports) {

$parcel$export(module.exports, "ResolveCommentButton", function () { return $ce589e8ed7876980$export$9cd9729cf91515f8; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $8Mti0 = parcelRequire("8Mti0");

var $5Q0fQ = parcelRequire("5Q0fQ");

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $joohN = parcelRequire("joohN");
const $ce589e8ed7876980$export$9cd9729cf91515f8 = ({ activeContext: activeContext, commentId: commentId, disabled: disabled })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { comments: comments, readComment: readComment, setComments: setComments } = (0, $joohN.useComments)(activeContext);
    const thisComment = readComment(commentId);
    const newStatus = thisComment?.commentReviewStatus === (0, $8Mti0.eCommentReviewStatus).resolved ? (0, $8Mti0.eCommentReviewStatus).open : (0, $8Mti0.eCommentReviewStatus).resolved;
    const buttonAction = newStatus === (0, $8Mti0.eCommentReviewStatus).resolved ? "Resolve" : "Open";
    const thisCommentRequestDto = (0, $spJKX.useMemo)(()=>{
        if (activeContext === "Hierarchy" && hierarchy) return {
            activeContext: "Hierarchy",
            hierarchyId: hierarchy.id,
            commentId: commentId,
            newStatus: newStatus
        };
        else if ([
            "TlfItem"
        ].includes(activeContext) && tlfData) return {
            activeContext: "TlfItem",
            id: tlfData.id,
            azsolId: tlfData.azsolId,
            version: tlfData.version,
            commentId: commentId,
            newStatus: newStatus
        };
        return null;
    }, [
        activeContext,
        commentId,
        hierarchy,
        newStatus,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $spJKX.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $4dL47.loadWrapper)((0, $5Q0fQ.patchCommentStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                const newComments = [
                    ...comments.filter((c)=>c.id !== request.data.id),
                    request.data
                ];
                setComments(newComments, true);
            }
        }
    }, [
        appSettings.backEndUrl,
        comments,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return thisComment && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        id: `resolve-comment-${commentId}`,
        "aria-label": `${buttonAction} comment`,
        className: "resolve-button",
        title: `${buttonAction} this comment`,
        size: "sm",
        variant: newStatus === (0, $8Mti0.eCommentReviewStatus).resolved ? "success" : "warning",
        disabled: disabled || !hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).MaintainHierarchyComments) || !thisCommentRequestDto,
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: buttonAction
    });
};
$ce589e8ed7876980$export$9cd9729cf91515f8.displayName = "ResolveCommentButton";

});
parcelRegister("5Q0fQ", function(module, exports) {

$parcel$export(module.exports, "patchCommentStatus", function () { return $ac7f704124fc3733$export$62cae3389f875941; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ac7f704124fc3733$export$62cae3389f875941 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus/${details.commentId}` : `${backEndUrl}TlfItems/${details.id}/CommentStatus/${details.commentId}`;
    try {
        const commentStatusUpdate = {
            status: details.newStatus
        };
        const ret = await (0, $lCyBC.default).patch(url, commentStatusUpdate, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Update comment failed", error);
    }
};

});


parcelRegister("3G7sT", function(module, exports) {

$parcel$export(module.exports, "UpdateCommentButton", function () { return $9b89d4ad966bb7f4$export$dc74a7fec1111808; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
parcelRequire("spJKX");

var $ghpIf = parcelRequire("ghpIf");
var $fAjo1 = parcelRequire("fAjo1");

var $joohN = parcelRequire("joohN");
const $9b89d4ad966bb7f4$export$dc74a7fec1111808 = ({ activeContext: activeContext, currentStatus: currentStatus, disabled: disabled, commentId: commentId, currentContent: currentContent, setCurrentStatus: setCurrentStatus })=>{
    const { updateComment: updateComment, updateRequest: updateRequest } = (0, $joohN.useComments)(activeContext);
    /**
   * Handle click event to post or edit the comment.
   *
   * @param e - Mouse event
   */ const handleClick = async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        switch(currentStatus){
            case "new":
            case "editing":
                await updateComment(commentId, currentContent);
                setCurrentStatus("saved");
                break;
            case "saved":
                setCurrentStatus("editing");
                break;
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        size: "sm",
        "aria-label": [
            "new",
            "editing"
        ].includes(currentStatus) ? "Post comment" : "Edit comment",
        disabled: disabled,
        id: `update-comment-${commentId}`,
        onClick: handleClick,
        variant: currentStatus === "editing" ? "primary" : "outline-primary",
        requestStatus: updateRequest,
        children: [
            "new",
            "editing"
        ].includes(currentStatus) ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ghpIf.default), {
            size: 14
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fAjo1.default), {
            size: 14
        })
    });
};
$9b89d4ad966bb7f4$export$dc74a7fec1111808.displayName = "UpdateCommentButton";

});
parcelRegister("ghpIf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bda22ddefb9dc255$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $bda22ddefb9dc255$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $bda22ddefb9dc255$var$_extends() {
    return $bda22ddefb9dc255$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $bda22ddefb9dc255$var$_extends.apply(null, arguments);
}
function $bda22ddefb9dc255$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $bda22ddefb9dc255$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $bda22ddefb9dc255$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $bda22ddefb9dc255$var$Floppy = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $bda22ddefb9dc255$var$_objectWithoutProperties(_ref, $bda22ddefb9dc255$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $bda22ddefb9dc255$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-floppy',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M11 2H9v3h2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"
    }));
});
$bda22ddefb9dc255$var$Floppy.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $bda22ddefb9dc255$export$2e2bcd8739ae039 = $bda22ddefb9dc255$var$Floppy;

});

parcelRegister("fAjo1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b589418f9eaeac87$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $b589418f9eaeac87$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $b589418f9eaeac87$var$_extends() {
    return $b589418f9eaeac87$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b589418f9eaeac87$var$_extends.apply(null, arguments);
}
function $b589418f9eaeac87$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $b589418f9eaeac87$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $b589418f9eaeac87$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $b589418f9eaeac87$var$PenFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $b589418f9eaeac87$var$_objectWithoutProperties(_ref, $b589418f9eaeac87$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $b589418f9eaeac87$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pen-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001"
    }));
});
$b589418f9eaeac87$var$PenFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $b589418f9eaeac87$export$2e2bcd8739ae039 = $b589418f9eaeac87$var$PenFill;

});




parcelRegister("fFqMd", function(module, exports) {

$parcel$export(module.exports, "ResolveThreadCommentsButton", function () { return $53721349c8c2c036$export$45b5ec0e58aa670f; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $8Mti0 = parcelRequire("8Mti0");

var $bJ9Dc = parcelRequire("bJ9Dc");

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $3bZGF = parcelRequire("3bZGF");

var $joohN = parcelRequire("joohN");
const $53721349c8c2c036$export$45b5ec0e58aa670f = ({ activeContext: activeContext, commentId: commentId })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { comments: comments, readComment: readComment, setComments: setComments } = (0, $joohN.useComments)(activeContext);
    const thisComment = readComment(commentId);
    /**
   * Check if a comment thread has any unresolved (open) comments.
   * @param parentCommentId - Id of the root comment for the recursive check.
   * @returns True if any comment in the thread is open, false otherwise.
   */ const isCommentThreadOpen = (0, $spJKX.useCallback)((parentCommentId)=>{
        /**
       * Recursive check for any open child comments.
       *
       * @param commentId - Id of the root comment for the recursive check.
       */ const hasOpenChildComments = (commentId)=>{
            const currentComment = comments.find((comment)=>comment.id === commentId);
            if (currentComment && (!currentComment.commentReviewStatus || currentComment.commentReviewStatus === "Open")) return true;
            const childComments = comments.filter((comment)=>comment.parentId === commentId);
            return childComments.some((childComment)=>hasOpenChildComments(childComment.id));
        };
        return hasOpenChildComments(parentCommentId);
    }, [
        comments
    ]);
    const thisCommentRequestDto = (0, $spJKX.useMemo)(()=>{
        if (activeContext === "Hierarchy" && hierarchy) return {
            activeContext: "Hierarchy",
            hierarchyId: hierarchy.id,
            commentId: commentId,
            newStatus: (0, $8Mti0.eCommentReviewStatus).resolved
        };
        else if (activeContext === "TlfItem" && tlfData) return {
            activeContext: "TlfItem",
            id: tlfData.id,
            azsolId: tlfData.azsolId,
            version: tlfData.version,
            commentId: commentId,
            newStatus: (0, $8Mti0.eCommentReviewStatus).resolved
        };
        return null;
    }, [
        activeContext,
        commentId,
        hierarchy,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $spJKX.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $4dL47.loadWrapper)((0, $bJ9Dc.patchCommentThreadStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                const newComments = [
                    ...comments.filter((c)=>!request.data.map((c)=>c.id).includes(c.id)),
                    ...request.data
                ];
                setComments(newComments, true);
            }
        }
    }, [
        appSettings.backEndUrl,
        comments,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return thisComment && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        id: `resolve-thread-comments-${commentId}`,
        className: "resolve-thread-button mb-1",
        title: "Resolve thread",
        size: "sm",
        variant: "success",
        disabled: !hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).MaintainHierarchyComments) || !isCommentThreadOpen(commentId) || commentId.startsWith("new-"),
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3bZGF.default), {
                className: "me-1"
            }),
            "Resolve thread"
        ]
    });
};
$53721349c8c2c036$export$45b5ec0e58aa670f.displayName = "ResolveThreadCommentsButton";

});
parcelRegister("bJ9Dc", function(module, exports) {

$parcel$export(module.exports, "patchCommentThreadStatus", function () { return $5c0974dee53b1b8a$export$599d2005bf5bc9d5; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $5c0974dee53b1b8a$export$599d2005bf5bc9d5 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentThreadStatus/${details.commentId}` : `${backEndUrl}TlfItems/${details.id}/CommentThreadStatus/${details.commentId}`;
    try {
        const ret = await (0, $lCyBC.default).patch(url, {
            status: details.newStatus
        }, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Update comment failed", error);
    }
};

});


parcelRegister("jZNjZ", function(module, exports) {

$parcel$export(module.exports, "shouldShowCommentThread", function () { return $cb76866ddc2d9b7e$export$7bcab44e898bd894; });

var $1nHEe = parcelRequire("1nHEe");
const $cb76866ddc2d9b7e$export$7bcab44e898bd894 = (id, comments, commentFilter)=>{
    if (commentFilter === "all") return true;
    const comment = comments.find((c)=>c.id === id);
    if ((0, $1nHEe.isCommentVisible)(commentFilter, comment?.commentReviewStatus)) return true;
    const hasMatchingChildren = comments.some((c)=>{
        if (c.parentId === id) return $cb76866ddc2d9b7e$export$7bcab44e898bd894(c.id, comments, commentFilter);
        return false;
    });
    return (0, $1nHEe.isCommentVisible)(commentFilter, comment?.commentReviewStatus) || hasMatchingChildren;
};

});


parcelRegister("9h0pt", function(module, exports) {

$parcel$export(module.exports, "CommentSubscriptionButton", function () { return $efee3b939281d57d$export$b3d298092c86ec1d; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $bjOSg = parcelRequire("bjOSg");
var $lN920 = parcelRequire("lN920");
const $efee3b939281d57d$export$b3d298092c86ec1d = ({ isSubscribed: isSubscribed, toggleCommentsSubscription: toggleCommentsSubscription, toggleSubscriptionStatusRequest: toggleSubscriptionStatusRequest })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        id: "comment-subscription-button",
        size: "sm",
        onClick: (e)=>{
            toggleCommentsSubscription();
            e.preventDefault();
            e.stopPropagation();
        },
        title: isSubscribed ? "Unsubscribe from Comments notifications" : "Subscribe to comments",
        requestStatus: toggleSubscriptionStatusRequest,
        children: isSubscribed ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lN920.default), {
                    className: "me-1"
                }),
                "Unsubscribe"
            ]
        }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bjOSg.default), {
                    className: "me-1"
                }),
                "Subscribe"
            ]
        })
    });
};
$efee3b939281d57d$export$b3d298092c86ec1d.displayName = "CommentSubscriptionButton";

});
parcelRegister("bjOSg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83d8eea0ec4c360c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $83d8eea0ec4c360c$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $83d8eea0ec4c360c$var$_extends() {
    return $83d8eea0ec4c360c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $83d8eea0ec4c360c$var$_extends.apply(null, arguments);
}
function $83d8eea0ec4c360c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $83d8eea0ec4c360c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $83d8eea0ec4c360c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $83d8eea0ec4c360c$var$BellFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $83d8eea0ec4c360c$var$_objectWithoutProperties(_ref, $83d8eea0ec4c360c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $83d8eea0ec4c360c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2m.995-14.901a1 1 0 1 0-1.99 0A5 5 0 0 0 3 6c0 1.098-.5 6-2 7h14c-1.5-1-2-5.902-2-7 0-2.42-1.72-4.44-4.005-4.901"
    }));
});
$83d8eea0ec4c360c$var$BellFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $83d8eea0ec4c360c$export$2e2bcd8739ae039 = $83d8eea0ec4c360c$var$BellFill;

});

parcelRegister("lN920", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdd52e0727cae8cf$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $fdd52e0727cae8cf$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $fdd52e0727cae8cf$var$_extends() {
    return $fdd52e0727cae8cf$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fdd52e0727cae8cf$var$_extends.apply(null, arguments);
}
function $fdd52e0727cae8cf$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $fdd52e0727cae8cf$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $fdd52e0727cae8cf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $fdd52e0727cae8cf$var$BellSlashFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $fdd52e0727cae8cf$var$_objectWithoutProperties(_ref, $fdd52e0727cae8cf$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $fdd52e0727cae8cf$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell-slash-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M5.164 14H15c-1.5-1-2-5.902-2-7q0-.396-.06-.776zm6.288-10.617A5 5 0 0 0 8.995 2.1a1 1 0 1 0-1.99 0A5 5 0 0 0 3 7c0 .898-.335 4.342-1.278 6.113zM10 15a2 2 0 1 1-4 0zm-9.375.625a.53.53 0 0 0 .75.75l14.75-14.75a.53.53 0 0 0-.75-.75z"
    }));
});
$fdd52e0727cae8cf$var$BellSlashFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $fdd52e0727cae8cf$export$2e2bcd8739ae039 = $fdd52e0727cae8cf$var$BellSlashFill;

});


parcelRegister("8ArNI", function(module, exports) {

$parcel$export(module.exports, "ResolveAllCommentsButton", function () { return $1fcbe9d7dd8df9de$export$e6dfe2d8494c7210; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $8Mti0 = parcelRequire("8Mti0");

var $gAVw4 = parcelRequire("gAVw4");

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $eOuYt = parcelRequire("eOuYt");

var $joohN = parcelRequire("joohN");
const $1fcbe9d7dd8df9de$export$e6dfe2d8494c7210 = ({ activeContext: activeContext })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const { setComments: setComments } = (0, $joohN.useComments)(activeContext);
    const canResolveAll = (0, $spJKX.useMemo)(()=>{
        if (activeContext === "Hierarchy") return hierarchyContext?.hierarchy?.comments?.some((c)=>c.commentReviewStatus === (0, $8Mti0.eCommentReviewStatus).open) ?? false;
        else return tlfContext.tlfData?.comments?.some((c)=>c.commentReviewStatus === (0, $8Mti0.eCommentReviewStatus).open) ?? false;
    }, [
        activeContext,
        hierarchyContext,
        tlfContext
    ]);
    const thisCommentRequestDto = (0, $spJKX.useMemo)(()=>{
        if (activeContext === "Hierarchy") {
            if (!hierarchy) return null;
            return {
                activeContext: "Hierarchy",
                hierarchyId: hierarchy.id,
                newStatus: (0, $8Mti0.eCommentReviewStatus).resolved
            };
        } else {
            if (!tlfData) return null;
            return {
                activeContext: "TlfItem",
                id: tlfData.id,
                azsolId: tlfData.azsolId,
                version: tlfData.version,
                newStatus: (0, $8Mti0.eCommentReviewStatus).resolved
            };
        }
    }, [
        activeContext,
        hierarchy,
        tlfData
    ]);
    const [patchCommentStatusRequest, setPatchCommentStatusRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const handleClick = (0, $spJKX.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        /* istanbul ignore else */ if (thisCommentRequestDto) {
            const request = await (0, $4dL47.loadWrapper)((0, $gAVw4.patchAllCommentStatus), thisCommentRequestDto, {
                ...patchCommentStatusRequest,
                requestedId: undefined,
                error: false
            }, setPatchCommentStatusRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) setComments(request.data, true);
        }
    }, [
        appSettings.backEndUrl,
        patchCommentStatusRequest,
        setComments,
        thisCommentRequestDto
    ]);
    return !thisCommentRequestDto ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        id: `resolve-all-comments-${activeContext}`,
        className: "resolve-all-button ms-2",
        title: "Resolve all",
        size: "sm",
        variant: "success",
        disabled: !hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).MaintainHierarchyComments) || !canResolveAll,
        requestStatus: patchCommentStatusRequest,
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eOuYt.default), {
                className: "me-1"
            }),
            "Resolve all"
        ]
    });
};
$1fcbe9d7dd8df9de$export$e6dfe2d8494c7210.displayName = "ResolveAllCommentsButton";

});
parcelRegister("gAVw4", function(module, exports) {

$parcel$export(module.exports, "patchAllCommentStatus", function () { return $6e9f6881389a51a0$export$640adaa654676056; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $6e9f6881389a51a0$export$640adaa654676056 = async (backEndUrl, details, controller)=>{
    const url = details.activeContext === "Hierarchy" ? `${backEndUrl}Hierarchy/${details.hierarchyId}/CommentStatus` : `${backEndUrl}TlfItems/${details.id}/CommentStatus`;
    try {
        const ret = await (0, $lCyBC.default).patch(url, {
            status: details.newStatus
        }, {
            signal: controller.signal
        });
        return {
            success: true,
            data: ret.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Update comment failed", error);
    }
};

});

parcelRegister("eOuYt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac8dc317ad75a01f$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $ac8dc317ad75a01f$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $ac8dc317ad75a01f$var$_extends() {
    return $ac8dc317ad75a01f$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ac8dc317ad75a01f$var$_extends.apply(null, arguments);
}
function $ac8dc317ad75a01f$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $ac8dc317ad75a01f$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $ac8dc317ad75a01f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $ac8dc317ad75a01f$var$Check2All = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $ac8dc317ad75a01f$var$_objectWithoutProperties(_ref, $ac8dc317ad75a01f$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $ac8dc317ad75a01f$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check2-all',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708"
    }));
});
$ac8dc317ad75a01f$var$Check2All.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $ac8dc317ad75a01f$export$2e2bcd8739ae039 = $ac8dc317ad75a01f$var$Check2All;

});


parcelRegister("e5pGr", function(module, exports) {

$parcel$export(module.exports, "NEW_TLF_COMMENT_TOOLTIP", function () { return $b5808968d8d09d51$export$c7af62884c02a609; });
const $b5808968d8d09d51$export$c7af62884c02a609 = "Save the TLF item before adding comments";

});


parcelRegister("K53Ru", function(module, exports) {

$parcel$export(module.exports, "getHierarchyBaseUrl", function () { return $eaef40e57f6a0029$export$67f15bf95912850; });

var $4lHS7 = parcelRequire("4lHS7");
const $eaef40e57f6a0029$export$67f15bf95912850 = (hierarchy, pathName)=>{
    /**
   * Joins non-empty string/number path segments into a slash-separated URL path.
   *
   * @param parts - Path segments to join; empty strings, booleans, and undefined values are omitted
   * @returns The joined path, always starting with a leading slash
   */ const buildPath = (...parts)=>"/" + parts.filter((p)=>typeof p === "string" && p !== "" || typeof p === "number").join("/");
    // Generate the base URL
    let baseUrl;
    switch(hierarchy.level){
        case (0, $4lHS7.eHierarchyLevel).TA:
            baseUrl = buildPath(hierarchy.taPrefix);
            break;
        case (0, $4lHS7.eHierarchyLevel).Project:
            baseUrl = buildPath(hierarchy.taPrefix, hierarchy.projectCode);
            break;
        case (0, $4lHS7.eHierarchyLevel).Study:
            baseUrl = buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.hierarchyTag);
            break;
        case (0, $4lHS7.eHierarchyLevel).Report:
            {
                const isBackup = "isBackupVersion" in hierarchy && hierarchy.isBackupVersion === true && hierarchy.tocMajorVersion !== undefined;
                // Full ancestor-path format.
                baseUrl = isBackup ? buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.parentTag, hierarchy.name, "Version", hierarchy.tocMajorVersion) : buildPath(hierarchy.taPrefix, hierarchy.projectCode, hierarchy.parentTag, hierarchy.name);
                break;
            }
        case (0, $4lHS7.eHierarchyLevel).Corporate, (0, $4lHS7.eHierarchyLevel).TopLevel:
        default:
            baseUrl = "/Corporate";
    }
    // Navigate to the same path as needed.
    if (pathName) {
        const decodedPathName = decodeURIComponent(pathName);
        /* istanbul ignore else */ if (decodedPathName.startsWith(baseUrl) && decodedPathName.length > baseUrl.length) {
            const remainingPath = decodedPathName.substring(baseUrl.length);
            return `${baseUrl}${remainingPath}`;
        }
    }
    return baseUrl;
};

});

parcelRegister("4wYgQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34c8e718a996f58b$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $hFZA1 = parcelRequire("hFZA1");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $34c8e718a996f58b$var$Breadcrumb = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, listProps: listProps = {}, children: children, label: label = 'breadcrumb', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'nav', ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        "aria-label": label,
        className: className,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("ol", {
            ...listProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(prefix, listProps == null ? void 0 : listProps.className),
            children: children
        })
    });
});
$34c8e718a996f58b$var$Breadcrumb.displayName = 'Breadcrumb';
var $34c8e718a996f58b$export$2e2bcd8739ae039 = Object.assign($34c8e718a996f58b$var$Breadcrumb, {
    Item: (0, $hFZA1.default)
});

});
parcelRegister("hFZA1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cde60881578b1f24$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $5aXWW = parcelRequire("5aXWW");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $cde60881578b1f24$var$BreadcrumbItem = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, active: active = false, children: children, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'li', linkAs: LinkComponent = (0, $5aXWW.default), linkProps: linkProps = {}, href: href, title: title, target: target, ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(prefix, className, {
            active: active
        }),
        "aria-current": active ? 'page' : undefined,
        children: active ? children : /*#__PURE__*/ (0, $bR5nk.jsx)(LinkComponent, {
            ...linkProps,
            href: href,
            title: title,
            target: target,
            children: children
        })
    });
});
$cde60881578b1f24$var$BreadcrumbItem.displayName = 'BreadcrumbItem';
var $cde60881578b1f24$export$2e2bcd8739ae039 = $cde60881578b1f24$var$BreadcrumbItem;

});


parcelRegister("1p1jo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $105924b9f3a7f3fe$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $105924b9f3a7f3fe$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $105924b9f3a7f3fe$var$_extends() {
    return $105924b9f3a7f3fe$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $105924b9f3a7f3fe$var$_extends.apply(null, arguments);
}
function $105924b9f3a7f3fe$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $105924b9f3a7f3fe$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $105924b9f3a7f3fe$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $105924b9f3a7f3fe$var$ArrowUpSquare = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $105924b9f3a7f3fe$var$_objectWithoutProperties(_ref, $105924b9f3a7f3fe$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $105924b9f3a7f3fe$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-up-square',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M15 2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm8.5 9.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707z"
    }));
});
$105924b9f3a7f3fe$var$ArrowUpSquare.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $105924b9f3a7f3fe$export$2e2bcd8739ae039 = $105924b9f3a7f3fe$var$ArrowUpSquare;

});


parcelRegister("lMl8s", function(module, exports) {

$parcel$export(module.exports, "NewItemDropMenu", function () { return $97b0a913b79ff7dd$export$c7cc4c9bbf63ebdd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $4lHS7 = parcelRequire("4lHS7");

var $5FU7L = parcelRequire("5FU7L");

var $4Q81F = parcelRequire("4Q81F");

var $kK73x = parcelRequire("kK73x");
const $97b0a913b79ff7dd$export$c7cc4c9bbf63ebdd = ({ fileEntry: fileEntry })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const navigation = (0, $4Q81F.useNavigation)();
    const hierarchyBaseUrl = hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchy.level !== (0, $4lHS7.eHierarchyLevel).Study ? (0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy) : "/Corporate";
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5FU7L.default), {
        id: "topbar-file",
        title: "File",
        style: {
            paddingLeft: "12px",
            position: "relative"
        },
        children: [
            navigation.state === "loading" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                text: "Loading New Template..."
            }),
            hierarchyContext?.hierarchy?.arsEnabled && [
                "local",
                "development",
                "test",
                "__REACT_APP_STAGE__"
            ].includes((0, $kK73x.REACT_APP_STAGE)) && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                        id: "topbar-new-ars-table-link",
                        as: (0, $4Q81F.Link),
                        to: `${hierarchyBaseUrl}/NewTlf/newArsTable`,
                        children: "New ARS Table"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                        id: "topbar-new-ars-listing-link",
                        as: (0, $4Q81F.Link),
                        to: `${hierarchyBaseUrl}/NewTlf/newArsListing`,
                        children: "New ARS Listing"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                id: "topbar-new-table-link",
                as: (0, $4Q81F.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newTable`,
                children: "New Table"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                id: "topbar-new-listing-link",
                as: (0, $4Q81F.Link),
                to: "/Corporate/AZLBL01/2",
                children: "New Listing"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                id: "topbar-new-figure-link",
                as: (0, $4Q81F.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newFigure`,
                children: "New Interactive Figure"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                id: "topbar-new-v1figure-link",
                as: (0, $4Q81F.Link),
                to: `${hierarchyBaseUrl}/NewTlf/newV1Figure`,
                children: "New Static Figure"
            }),
            fileEntry !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                children: fileEntry
            })
        ]
    });
};
$97b0a913b79ff7dd$export$c7cc4c9bbf63ebdd.displayName = "NewItemDropMenu";

});
parcelRegister("5FU7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $421c512f8d2b70e3$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $cvxSH = parcelRequire("cvxSH");

var $17hhV = parcelRequire("17hhV");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $421c512f8d2b70e3$var$NavDropdown = /*#__PURE__*/ $spJKX.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $dz672.useBootstrapPrefix)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $cvxSH.default), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cvxSH.default).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $17hhV.default),
                children: title
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cvxSH.default).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$421c512f8d2b70e3$var$NavDropdown.displayName = 'NavDropdown';
var $421c512f8d2b70e3$export$2e2bcd8739ae039 = Object.assign($421c512f8d2b70e3$var$NavDropdown, {
    Item: (0, $cvxSH.default).Item,
    ItemText: (0, $cvxSH.default).ItemText,
    Divider: (0, $cvxSH.default).Divider,
    Header: (0, $cvxSH.default).Header
});

});
parcelRegister("cvxSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91b2a9606e69af09$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $6ge7o = parcelRequire("6ge7o");
parcelRequire("ai3tA");
var $iq7Zt = parcelRequire("iq7Zt");

var $i1VQA = parcelRequire("i1VQA");

var $9F1OD = parcelRequire("9F1OD");

var $b5nI3 = parcelRequire("b5nI3");

var $ltY3n = parcelRequire("ltY3n");

var $dZUxL = parcelRequire("dZUxL");

var $cLF7H = parcelRequire("cLF7H");

var $kOv7r = parcelRequire("kOv7r");

var $7ZLzX = parcelRequire("7ZLzX");

var $8mdMm = parcelRequire("8mdMm");

var $dz672 = parcelRequire("dz672");


var $bR5nk = parcelRequire("bR5nk");
"use client";
const $91b2a9606e69af09$var$Dropdown = /*#__PURE__*/ $spJKX.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $iq7Zt.default)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $spJKX.useContext)((0, $8mdMm.default));
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown');
    const isRTL = (0, $dz672.useIsRTL)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $i1VQA.default)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $kOv7r.getDropdownMenuPlacement)(alignEnd, drop, isRTL);
    const contextValue = (0, $spJKX.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9F1OD.default).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6ge7o.default), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$91b2a9606e69af09$var$Dropdown.displayName = 'Dropdown';
var $91b2a9606e69af09$export$2e2bcd8739ae039 = Object.assign($91b2a9606e69af09$var$Dropdown, {
    Toggle: (0, $7ZLzX.default),
    Menu: (0, $kOv7r.default),
    Item: (0, $dZUxL.default),
    ItemText: (0, $cLF7H.default),
    Divider: (0, $b5nI3.default),
    Header: (0, $ltY3n.default)
});

});
parcelRegister("6ge7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ef3043cc8e7449$export$2e2bcd8739ae039; });

var $c9yOz = parcelRequire("c9yOz");

var $3GPnw = parcelRequire("3GPnw");

var $spJKX = parcelRequire("spJKX");

var $kGFPM = parcelRequire("kGFPM");

var $NZVk0 = parcelRequire("NZVk0");

var $hSHOz = parcelRequire("hSHOz");

var $5Oo2i = parcelRequire("5Oo2i");

var $1nkOT = parcelRequire("1nkOT");

var $602UY = parcelRequire("602UY");

var $cBDhw = parcelRequire("cBDhw");

var $g8zid = parcelRequire("g8zid");

var $g1Ewg = parcelRequire("g1Ewg");

var $4dgBw = parcelRequire("4dgBw");

var $4aNCA = parcelRequire("4aNCA");

var $2Mg2Q = parcelRequire("2Mg2Q");

var $bR5nk = parcelRequire("bR5nk");
function $48ef3043cc8e7449$var$useRefWithUpdate() {
    const forceUpdate = (0, $hSHOz.default)();
    const ref = (0, $spJKX.useRef)(null);
    const attachRef = (0, $spJKX.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $48ef3043cc8e7449$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $4aNCA.dataAttr)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $2Mg2Q.default)();
    const [show, onToggle] = (0, $kGFPM.useUncontrolledProp)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $48ef3043cc8e7449$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $48ef3043cc8e7449$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $NZVk0.default)(show);
    const lastSourceEvent = (0, $spJKX.useRef)(null);
    const focusInDropdown = (0, $spJKX.useRef)(false);
    const onSelectCtx = (0, $spJKX.useContext)((0, $4dgBw.default));
    const toggle = (0, $spJKX.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $1nkOT.default)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $spJKX.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $1nkOT.default)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $1nkOT.default)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $g8zid.isRoleMenu)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $c9yOz.default)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $spJKX.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $spJKX.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $c9yOz.default)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $5Oo2i.default)((0, $spJKX.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $3GPnw.default)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4dgBw.default).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $602UY.default).Provider, {
            value: context,
            children: children
        })
    });
}
$48ef3043cc8e7449$var$Dropdown.displayName = 'Dropdown';
$48ef3043cc8e7449$var$Dropdown.Menu = (0, $cBDhw.default);
$48ef3043cc8e7449$var$Dropdown.Toggle = (0, $g8zid.default);
$48ef3043cc8e7449$var$Dropdown.Item = (0, $g1Ewg.default);
var $48ef3043cc8e7449$export$2e2bcd8739ae039 = $48ef3043cc8e7449$var$Dropdown;

});
parcelRegister("602UY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45e5019a4d6f5ae0$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
const $45e5019a4d6f5ae0$var$DropdownContext = /*#__PURE__*/ $spJKX.createContext(null);
var $45e5019a4d6f5ae0$export$2e2bcd8739ae039 = $45e5019a4d6f5ae0$var$DropdownContext;

});

parcelRegister("cBDhw", function(module, exports) {

$parcel$export(module.exports, "useDropdownMenu", function () { return $92d76938ca1f2dfd$export$133c4d08f3775d64; });
$parcel$export(module.exports, "default", function () { return $92d76938ca1f2dfd$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $aRyvJ = parcelRequire("aRyvJ");

var $602UY = parcelRequire("602UY");

var $dRPXQ = parcelRequire("dRPXQ");

var $gAujg = parcelRequire("gAujg");

var $jyTHg = parcelRequire("jyTHg");

var $bR5nk = parcelRequire("bR5nk");
const $92d76938ca1f2dfd$var$_excluded = [
    "children",
    "usePopper"
];
function $92d76938ca1f2dfd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $92d76938ca1f2dfd$var$noop = ()=>{};
function $92d76938ca1f2dfd$export$133c4d08f3775d64(options = {}) {
    const context = (0, $spJKX.useContext)((0, $602UY.default));
    const [arrowElement, attachArrowRef] = (0, $aRyvJ.default)();
    const hasShownRef = (0, $spJKX.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $dRPXQ.default)(toggleElement, menuElement, (0, $jyTHg.default)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $92d76938ca1f2dfd$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $gAujg.default)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $92d76938ca1f2dfd$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $92d76938ca1f2dfd$var$_objectWithoutPropertiesLoose(_ref, $92d76938ca1f2dfd$var$_excluded);
    const [props, meta] = $92d76938ca1f2dfd$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children(props, meta)
    });
}
$92d76938ca1f2dfd$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $92d76938ca1f2dfd$export$2e2bcd8739ae039 = $92d76938ca1f2dfd$var$DropdownMenu;

});

parcelRegister("g8zid", function(module, exports) {

$parcel$export(module.exports, "isRoleMenu", function () { return $bbf8c52149ca159c$export$386b1213cf9779d8; });
$parcel$export(module.exports, "useDropdownToggle", function () { return $bbf8c52149ca159c$export$96df6c7c5036b9a2; });
$parcel$export(module.exports, "default", function () { return $bbf8c52149ca159c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $lgUsY = parcelRequire("lgUsY");

var $602UY = parcelRequire("602UY");

var $bR5nk = parcelRequire("bR5nk");
const $bbf8c52149ca159c$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $bbf8c52149ca159c$var$noop = ()=>{};
function $bbf8c52149ca159c$export$96df6c7c5036b9a2() {
    const id = (0, $lgUsY.useSSRSafeId)();
    const { show: show = false, toggle: toggle = $bbf8c52149ca159c$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $spJKX.useContext)((0, $602UY.default)) || {};
    const handleClick = (0, $spJKX.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $bbf8c52149ca159c$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $bbf8c52149ca159c$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $bbf8c52149ca159c$var$DropdownToggle({ children: children }) {
    const [props, meta] = $bbf8c52149ca159c$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children(props, meta)
    });
}
$bbf8c52149ca159c$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $bbf8c52149ca159c$export$2e2bcd8739ae039 = $bbf8c52149ca159c$var$DropdownToggle;

});

parcelRegister("g1Ewg", function(module, exports) {

$parcel$export(module.exports, "useDropdownItem", function () { return $baac2ba096a06aca$export$522d7e1e4e0e22b2; });
$parcel$export(module.exports, "default", function () { return $baac2ba096a06aca$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $1nkOT = parcelRequire("1nkOT");

var $4dgBw = parcelRequire("4dgBw");

var $fxRpF = parcelRequire("fxRpF");

var $lxFPe = parcelRequire("lxFPe");

var $4aNCA = parcelRequire("4aNCA");

var $bR5nk = parcelRequire("bR5nk");
const $baac2ba096a06aca$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $baac2ba096a06aca$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $baac2ba096a06aca$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $spJKX.useContext)((0, $4dgBw.default));
    const navContext = (0, $spJKX.useContext)((0, $fxRpF.default));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $4dgBw.makeEventKey)(key, href);
    const isActive = active == null && key != null ? (0, $4dgBw.makeEventKey)(activeKey) === eventKey : active;
    const handleClick = (0, $1nkOT.default)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $4aNCA.dataAttr)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $baac2ba096a06aca$var$DropdownItem = /*#__PURE__*/ $spJKX.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $lxFPe.default) } = _ref, props = $baac2ba096a06aca$var$_objectWithoutPropertiesLoose(_ref, $baac2ba096a06aca$var$_excluded);
    const [dropdownItemProps] = $baac2ba096a06aca$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$baac2ba096a06aca$var$DropdownItem.displayName = 'DropdownItem';
var $baac2ba096a06aca$export$2e2bcd8739ae039 = $baac2ba096a06aca$var$DropdownItem;

});


parcelRegister("9F1OD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708959f555728b70$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
const $708959f555728b70$var$DropdownContext = /*#__PURE__*/ $spJKX.createContext({});
$708959f555728b70$var$DropdownContext.displayName = 'DropdownContext';
var $708959f555728b70$export$2e2bcd8739ae039 = $708959f555728b70$var$DropdownContext;

});

parcelRegister("b5nI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $81228d8d1bc0566a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $81228d8d1bc0566a$var$DropdownDivider = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$81228d8d1bc0566a$var$DropdownDivider.displayName = 'DropdownDivider';
var $81228d8d1bc0566a$export$2e2bcd8739ae039 = $81228d8d1bc0566a$var$DropdownDivider;

});

parcelRegister("ltY3n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa3ae3c8c6713c94$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $fa3ae3c8c6713c94$var$DropdownHeader = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$fa3ae3c8c6713c94$var$DropdownHeader.displayName = 'DropdownHeader';
var $fa3ae3c8c6713c94$export$2e2bcd8739ae039 = $fa3ae3c8c6713c94$var$DropdownHeader;

});

parcelRegister("dZUxL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a30cd53b6ab04645$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $g1Ewg = parcelRequire("g1Ewg");

var $5aXWW = parcelRequire("5aXWW");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $a30cd53b6ab04645$var$DropdownItem = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $5aXWW.default), ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $g1Ewg.useDropdownItem)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$a30cd53b6ab04645$var$DropdownItem.displayName = 'DropdownItem';
var $a30cd53b6ab04645$export$2e2bcd8739ae039 = $a30cd53b6ab04645$var$DropdownItem;

});

parcelRegister("cLF7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b9c60816480f61$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $gr2Ty = parcelRequire("gr2Ty");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $94b9c60816480f61$var$DropdownItemText = /*#__PURE__*/ $spJKX.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        ...props
    });
});
$94b9c60816480f61$var$DropdownItemText.displayName = 'DropdownItemText';
var $94b9c60816480f61$export$2e2bcd8739ae039 = $94b9c60816480f61$var$DropdownItemText;

});

parcelRegister("kOv7r", function(module, exports) {

$parcel$export(module.exports, "getDropdownMenuPlacement", function () { return $f2709dc0d45eff20$export$a2c648e264f4a946; });
$parcel$export(module.exports, "default", function () { return $f2709dc0d45eff20$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $cBDhw = parcelRequire("cBDhw");

var $dHq7H = parcelRequire("dHq7H");

var $4E7Hm = parcelRequire("4E7Hm");

var $6WYSv = parcelRequire("6WYSv");

var $9F1OD = parcelRequire("9F1OD");

var $8mdMm = parcelRequire("8mdMm");

var $27dwU = parcelRequire("27dwU");

var $dz672 = parcelRequire("dz672");

var $k9qhp = parcelRequire("k9qhp");


var $bR5nk = parcelRequire("bR5nk");
"use client";
function $f2709dc0d45eff20$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $f2709dc0d45eff20$var$DropdownMenu = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $spJKX.useContext)((0, $27dwU.default));
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $spJKX.useContext)((0, $9F1OD.default));
    align = align || contextAlign;
    const isInputGroup = (0, $spJKX.useContext)((0, $8mdMm.default));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(keys.length === 1, 'There should only be 1 breakpoint when passing an object to `align`');
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $f2709dc0d45eff20$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $cBDhw.useDropdownMenu)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $4E7Hm.default)((0, $k9qhp.default)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $dHq7H.default)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$f2709dc0d45eff20$var$DropdownMenu.displayName = 'DropdownMenu';
var $f2709dc0d45eff20$export$2e2bcd8739ae039 = $f2709dc0d45eff20$var$DropdownMenu;

});
parcelRegister("8mdMm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $615b1108258f50b4$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");
"use client";
const $615b1108258f50b4$var$context = /*#__PURE__*/ $spJKX.createContext(null);
$615b1108258f50b4$var$context.displayName = 'InputGroupContext';
var $615b1108258f50b4$export$2e2bcd8739ae039 = $615b1108258f50b4$var$context;

});

parcelRegister("k9qhp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eab908843b548d3d$export$2e2bcd8739ae039; });

var $bwjdr = parcelRequire("bwjdr");

var $spJKX = parcelRequire("spJKX");

var $4E7Hm = parcelRequire("4E7Hm");
function $eab908843b548d3d$export$2e2bcd8739ae039(ref, componentName) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const warningRef = (0, $spJKX.useCallback)((refValue)=>{
        !(refValue == null || !refValue.isReactComponent) && (0, (/*@__PURE__*/$parcel$interopDefault($bwjdr)))(false, `${componentName} injected a ref to a provided \`as\` component that resolved to a component instance instead of a DOM element. ` + 'Use `React.forwardRef` to provide the injected ref to the class component as a prop in order to pass it directly to a DOM element');
    }, [
        componentName
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $4E7Hm.default)(warningRef, ref);
}

});


parcelRegister("7ZLzX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d23231f0c9eb79b$export$2e2bcd8739ae039; });

var $4E7Hm = parcelRequire("4E7Hm");

var $602UY = parcelRequire("602UY");

var $g8zid = parcelRequire("g8zid");

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $c28Y1 = parcelRequire("c28Y1");

var $dz672 = parcelRequire("dz672");

var $k9qhp = parcelRequire("k9qhp");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $5d23231f0c9eb79b$var$DropdownToggle = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $c28Y1.default), ...props }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $spJKX.useContext)((0, $602UY.default));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $g8zid.useDropdownToggle)();
    toggleProps.ref = (0, $4E7Hm.default)(toggleProps.ref, (0, $k9qhp.default)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$5d23231f0c9eb79b$var$DropdownToggle.displayName = 'DropdownToggle';
var $5d23231f0c9eb79b$export$2e2bcd8739ae039 = $5d23231f0c9eb79b$var$DropdownToggle;

});




parcelRegister("j6deD", function(module, exports) {

$parcel$export(module.exports, "RightDropMenu", function () { return $6e9725f9a915945e$export$9e7bb86d1e89feab; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $50zs8 = parcelRequire("50zs8");

var $5jCZC = parcelRequire("5jCZC");

var $6HRyM = parcelRequire("6HRyM");

var $49H4I = parcelRequire("49H4I");

var $2ObvW = parcelRequire("2ObvW");
const $6e9725f9a915945e$export$9e7bb86d1e89feab = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        id: "rhs-menu",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).rightNav,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $49H4I.TocNavigate), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $50zs8.default).Text, {
                id: "rightdropmenu-displayname",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2ObvW))).rightNavText,
                children: appSettings.displayName
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5jCZC.HelpLinkDropDown), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6HRyM.NotificationsButton), {})
        ]
    });
};
$6e9725f9a915945e$export$9e7bb86d1e89feab.displayName = "RightDropMenu";

});
parcelRegister("5jCZC", function(module, exports) {

$parcel$export(module.exports, "HelpLinkDropDown", function () { return $1da912b8221b6ba7$export$a2b0e0b3122aace; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $5FU7L = parcelRequire("5FU7L");

var $4Q81F = parcelRequire("4Q81F");
const $1da912b8221b6ba7$export$a2b0e0b3122aace = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5FU7L.default), {
        id: "topbar-help",
        title: "Help",
        children: [
            (appSettings.isAdmin || appSettings.applicationPermissions.filter((p)=>[
                    (0, $4lHS7.eApplicationPermission).AllowHelpEdit,
                    (0, $4lHS7.eApplicationPermission).AllowNewsEdit
                ].includes(p)).length > 0) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                id: "topbar-admin-link",
                as: (0, $4Q81F.Link),
                to: "/Admin#news",
                children: "Admin page"
            }),
            appSettings.helpLinks.map((h, i)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                    id: `topbar-help-link-${i}`,
                    target: "_blank",
                    href: h.linkUrl,
                    children: h.linkLabel
                }, i))
        ]
    });
};
$1da912b8221b6ba7$export$a2b0e0b3122aace.displayName = "HelpLinkDropDown";

});

parcelRegister("6HRyM", function(module, exports) {

$parcel$export(module.exports, "NotificationsButton", function () { return $de59f1d1701b5f8c$export$40e326b1271b1326; });

var $bR5nk = parcelRequire("bR5nk");

var $h9eE2 = parcelRequire("h9eE2");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $irvto = parcelRequire("irvto");

var $4CKH9 = parcelRequire("4CKH9");

var $2Mlm8 = parcelRequire("2Mlm8");

var $6iYEs = parcelRequire("6iYEs");

var $da5DV = parcelRequire("da5DV");

var $spJKX = parcelRequire("spJKX");

var $1EdOx = parcelRequire("1EdOx");
var $lvuD3 = parcelRequire("lvuD3");

var $8kLS1 = parcelRequire("8kLS1");

var $4Q81F = parcelRequire("4Q81F");

var $3nwcZ = parcelRequire("3nwcZ");
const $de59f1d1701b5f8c$export$40e326b1271b1326 = ()=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const connection = signalR?.connection;
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("topbar-notifications-button");
    const [searchParams] = (0, $4Q81F.useSearchParams)();
    const urlParams = (0, $4Q81F.useParams)();
    const [loadRequest, setLoadRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [notificationsList, setNotificationsList] = (0, $spJKX.useState)([]);
    const [showNotifications, setShowNotifications] = (0, $spJKX.useState)(false);
    const newNotificationCount = notificationsList.filter((rn)=>!rn.notificationViewed).length;
    const loadNotifications = (0, $spJKX.useEffectEvent)(async ()=>{
        const response = await (0, $4dL47.loadWrapper)((0, $da5DV.getUserNotifications), "load", loadRequest, setLoadRequest, appSettings.backEndUrl);
        if (response?.success) startTransition(()=>setNotificationsList(response.data));
    });
    (0, $spJKX.useEffect)(()=>{
        if (!loadRequest.requesting && !loadRequest.requestedId && !loadRequest.error) loadNotifications();
    }, [
        loadRequest
    ]);
    const [sendGroupRequest, setSendGroupRequest] = (0, $spJKX.useState)(false);
    (0, $spJKX.useEffect)(()=>{
        if (connection && connection.state === (0, $h9eE2.HubConnectionState).Connected && !sendGroupRequest && appSettings.userId) {
            signalR.connectToGroup(`user-${appSettings.userId}`);
            startTransition(()=>{
                setSendGroupRequest(true);
            });
        }
    }, [
        appSettings.userId,
        connection,
        connection?.state,
        sendGroupRequest,
        signalR
    ]);
    /**
   * Process comments update messages from back end
   */ (0, $spJKX.useEffect)(()=>{
        /**
     * Process a SignalR group message containing comments updates.
     *
     * @param message - JSON string payload describing the update
     */ const processCommentsMessage = (message)=>{
            const update = JSON.parse(message);
            if (update.messageType === "commentsUpdate" && update.comments) setNotificationsList(update.comments);
        };
        signalR?.connection?.on("SendMessageToGroup", processCommentsMessage);
    // return () => {
    //   signalR?.connection?.off("SendMessageToGroup", processCommentsMessage);
    // };
    }, [
        signalR
    ]);
    const setCommentPanelStatusInContext = (0, $spJKX.useEffectEvent)((highlightCommentId, showComments, notificationContext)=>{
        let redirectUrl = "";
        /* istanbul ignore else */ if (notificationContext === "Hierarchy" && hierarchyContext?.hierarchy) {
            hierarchyContext.dispatch({
                operation: (0, $0eakK.SET_HIERARCHY_COMMENT_PANEL),
                commentPanelStatus: {
                    ...hierarchyContext.commentPanelStatus,
                    highlightCommentId: highlightCommentId,
                    showComments: showComments
                }
            });
            redirectUrl = (0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy);
        } else if (notificationContext === "TlfItem" && tlfContext.tlfData && hierarchyContext?.hierarchy) {
            tlfContext.dispatch({
                operation: (0, $2Mlm8.SET_TLF_COMMENT_PANEL),
                commentPanelStatus: {
                    ...tlfContext.commentPanelStatus,
                    highlightCommentId: highlightCommentId,
                    showComments: showComments
                },
                calledFrom: "NotificationsButton:setCommentPanelStatusInContext"
            });
            redirectUrl = (0, $4CKH9.getTlfUrl)(hierarchyContext.hierarchy, tlfContext.tlfData);
        }
        /* istanbul ignore else */ if (redirectUrl) navigate(redirectUrl, {
            replace: true
        });
    });
    // Handle Comments Panel status on redirection from Notification
    (0, $spJKX.useEffect)(()=>{
        if ((searchParams.has("showHierarchyComments") || searchParams.has("showTlfItemComments")) && hierarchyContext?.hierarchy) {
            const commentIdFromNotification = searchParams.get("commentId");
            /* istanbul ignore else */ if (searchParams.get("showHierarchyComments") === "true") {
                // A valid notification comment is handled above; the fallback only opens the panel when it is closed.
                /* istanbul ignore else */ if (commentIdFromNotification && hierarchyContext.hierarchy.comments.some((c)=>c.id === commentIdFromNotification) && hierarchyContext.commentPanelStatus.highlightCommentId !== commentIdFromNotification) setCommentPanelStatusInContext(commentIdFromNotification, true, "Hierarchy");
                else if (!hierarchyContext.commentPanelStatus.showComments) setCommentPanelStatusInContext("", true, "Hierarchy");
            } else if (searchParams.get("showTlfItemComments") === "true" && tlfContext.tlfData) {
                /* istanbul ignore else */ if (commentIdFromNotification && tlfContext.tlfData.comments.some((c)=>c.id === commentIdFromNotification) && tlfContext.commentPanelStatus.highlightCommentId !== commentIdFromNotification) setCommentPanelStatusInContext(commentIdFromNotification, true, "TlfItem");
                else if (!tlfContext.commentPanelStatus.showComments) setCommentPanelStatusInContext("", true, "TlfItem");
            }
        }
    }, [
        hierarchyContext,
        tlfContext,
        searchParams,
        urlParams
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            showNotifications && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3nwcZ.NotificationsPanel), {
                notificationsList: notificationsList,
                setNotificationsList: setNotificationsList,
                showNotifications: showNotifications,
                setShowNotifications: setShowNotifications,
                loadNotificationsRequest: loadRequest
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lvuD3.default), {
                id: "topbar-notifications-button",
                style: {
                    cursor: "pointer"
                },
                title: "View Notifications",
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    setShowNotifications(!showNotifications);
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    style: {
                        minWidth: "32px",
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "center"
                    },
                    "aria-label": "Show notifications",
                    children: newNotificationCount > 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1EdOx.default), {
                        pill: true,
                        bg: "primary",
                        "aria-label": `${newNotificationCount} new notification${newNotificationCount !== 1 ? "s" : ""}`,
                        children: newNotificationCount < 10 ? newNotificationCount : "9+"
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8kLS1.default), {
                        size: 20
                    })
                })
            })
        ]
    });
};
$de59f1d1701b5f8c$export$40e326b1271b1326.displayName = "NotificationsButton";

});
parcelRegister("4CKH9", function(module, exports) {

$parcel$export(module.exports, "getTlfUrl", function () { return $2a34d350e6de8574$export$32607bc73b33f5a3; });

var $4lHS7 = parcelRequire("4lHS7");

var $K53Ru = parcelRequire("K53Ru");
const $2a34d350e6de8574$export$32607bc73b33f5a3 = (hierarchy, tlfItem)=>tlfItem.primaryHierarchyLevel !== (0, $4lHS7.eHierarchyLevel).Report ? `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchy)}/Template/${tlfItem.azsolId}/${tlfItem.version}` : tlfItem.version === hierarchy.tocMajorVersion && tlfItem.tocNumber ? `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchy)}/${tlfItem.tocNumber}` : tlfItem.tocNumber ? `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchy)}/Version/${tlfItem.version}/${tlfItem.tocNumber}` : (0, $K53Ru.getHierarchyBaseUrl)(hierarchy);

});

parcelRegister("da5DV", function(module, exports) {

$parcel$export(module.exports, "getUserNotifications", function () { return $93e36ca7037575b9$export$7c48cc3fe3d2cf5d; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $93e36ca7037575b9$export$7c48cc3fe3d2cf5d = async (backEndUrl, _, controller)=>{
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Comments/GetUserNotifications`, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load Notifications failed", error);
    }
};

});

parcelRegister("8kLS1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61155309ad5209d8$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $61155309ad5209d8$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $61155309ad5209d8$var$_extends() {
    return $61155309ad5209d8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $61155309ad5209d8$var$_extends.apply(null, arguments);
}
function $61155309ad5209d8$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $61155309ad5209d8$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $61155309ad5209d8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $61155309ad5209d8$var$Bell = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $61155309ad5209d8$var$_objectWithoutProperties(_ref, $61155309ad5209d8$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $61155309ad5209d8$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-bell',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6"
    }));
});
$61155309ad5209d8$var$Bell.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $61155309ad5209d8$export$2e2bcd8739ae039 = $61155309ad5209d8$var$Bell;

});

parcelRegister("3nwcZ", function(module, exports) {

$parcel$export(module.exports, "NotificationsPanel", function () { return $b420cd6b9eadf3bc$export$2ed25852fd4f5fb5; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1wSYE = parcelRequire("1wSYE");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $b6GTY = parcelRequire("b6GTY");
var $31g00 = parcelRequire("31g00");

var $65ioU = parcelRequire("65ioU");

var $beLQs = parcelRequire("beLQs");
const $b420cd6b9eadf3bc$export$2ed25852fd4f5fb5 = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList, showNotifications: showNotifications, setShowNotifications: setShowNotifications, loadNotificationsRequest: loadNotificationsRequest })=>/*#__PURE__*/ (0, $bR5nk.jsxs)((0, $b6GTY.default), {
        show: showNotifications,
        placement: "end",
        onHide: ()=>{
            setShowNotifications(false);
        },
        backdrop: false,
        scroll: true,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Header, {
                closeButton: true,
                onClick: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Title, {
                    children: "Notifications"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b6GTY.default).Body, {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                    children: [
                        loadNotificationsRequest.requesting && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                            text: "Fetching Notifications..."
                        }),
                        loadNotificationsRequest.error ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                            children: " Something went wrong when fetching your notifications... "
                        }) : notificationsList.length > 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                        xs: {
                                            span: "auto"
                                        },
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $beLQs.NotificationsReadButton), {
                                            notificationsList: notificationsList,
                                            setNotificationsList: setNotificationsList
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                                    className: "mt-4",
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $65ioU.NotificationsList), {
                                            notificationsList: notificationsList,
                                            setNotificationsList: setNotificationsList,
                                            showNotifications: showNotifications,
                                            setShowNotifications: setShowNotifications
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                            children: "No Notifications Yet...!"
                        })
                    ]
                })
            })
        ]
    });
$b420cd6b9eadf3bc$export$2ed25852fd4f5fb5.displayName = "NotificationsPanel";

});
parcelRegister("65ioU", function(module, exports) {

$parcel$export(module.exports, "NotificationsList", function () { return $cbe8e4698ad9a18f$export$e3c71f1cd4cf6a5e; });

var $bR5nk = parcelRequire("bR5nk");

var $7CQgs = parcelRequire("7CQgs");

var $kpkQb = parcelRequire("kpkQb");
const $cbe8e4698ad9a18f$export$e3c71f1cd4cf6a5e = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList, setShowNotifications: setShowNotifications })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "position-relative",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7CQgs.default), {
            children: notificationsList.map((n)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $kpkQb.NotificationListItem), {
                    notification: n,
                    setNotificationsList: setNotificationsList,
                    setShowNotifications: setShowNotifications
                }, n.notificationId))
        })
    });
};
$cbe8e4698ad9a18f$export$e3c71f1cd4cf6a5e.displayName = "NotificationsList";

});
parcelRegister("7CQgs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58d49fa3ecf20024$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $6WYSv = parcelRequire("6WYSv");
parcelRequire("ai3tA");
var $iq7Zt = parcelRequire("iq7Zt");

var $k7dg4 = parcelRequire("k7dg4");

var $dz672 = parcelRequire("dz672");

var $g05uk = parcelRequire("g05uk");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $58d49fa3ecf20024$var$ListGroup = /*#__PURE__*/ $spJKX.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $iq7Zt.default)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $dz672.useBootstrapPrefix)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(!(horizontal && variant === 'flush'), '`variant="flush"` and `horizontal` should not be used together.');
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $k7dg4.default), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$58d49fa3ecf20024$var$ListGroup.displayName = 'ListGroup';
var $58d49fa3ecf20024$export$2e2bcd8739ae039 = Object.assign($58d49fa3ecf20024$var$ListGroup, {
    Item: (0, $g05uk.default)
});

});
parcelRegister("g05uk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba60e740713a691d$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $6WYSv = parcelRequire("6WYSv");

var $i1VQA = parcelRequire("i1VQA");

var $3ZWUQ = parcelRequire("3ZWUQ");

var $4dgBw = parcelRequire("4dgBw");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $ba60e740713a691d$var$ListGroupItem = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $3ZWUQ.useNavItem)({
        key: (0, $4dgBw.makeEventKey)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $i1VQA.default)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    (0, (/*@__PURE__*/$parcel$interopDefault($6WYSv)))(as || !(!action && props.href), '`action=false` and `href` should not be used together.');
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$ba60e740713a691d$var$ListGroupItem.displayName = 'ListGroupItem';
var $ba60e740713a691d$export$2e2bcd8739ae039 = $ba60e740713a691d$var$ListGroupItem;

});


parcelRegister("kpkQb", function(module, exports) {

$parcel$export(module.exports, "NotificationListItem", function () { return $48d394ecf5911e11$export$f73cbc6bc7eb6c67; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $9S4dL = parcelRequire("9S4dL");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6iYEs = parcelRequire("6iYEs");

var $lyxDt = parcelRequire("lyxDt");

var $spJKX = parcelRequire("spJKX");

var $7CQgs = parcelRequire("7CQgs");

var $4etRH = parcelRequire("4etRH");
const $48d394ecf5911e11$export$f9d3f62cd416668 = (prev, notification)=>prev.map((n)=>n.notificationId === notification.notificationId ? {
            ...n,
            notificationViewed: notification.notificationViewed
        } : n);
const $48d394ecf5911e11$export$f73cbc6bc7eb6c67 = ({ notification: n, setNotificationsList: setNotificationsList, setShowNotifications: setShowNotifications })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { navigate: navigate, isLoading: isLoading } = (0, $6iYEs.useUnsavedChanges)("NotificationListItem");
    const [doNavigate, setDoNavigate] = (0, $spJKX.useState)(false);
    const [isNavigating, setIsNavigating] = (0, $spJKX.useState)(false);
    const [updateNotificationStatusRequest, setUpdateNotificationStatusRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Toggle the viewed status of a notification.
   *
   * @param notificationId - ID of the notification to update
   */ const toggleNotificationStatus = async (notificationId)=>{
        const response = await (0, $4dL47.loadWrapper)((0, $lyxDt.updateNotificationStatus), {
            notificationId: notificationId
        }, {
            ...updateNotificationStatusRequest,
            requestedId: undefined
        }, setUpdateNotificationStatusRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) setNotificationsList((prev)=>$48d394ecf5911e11$export$f9d3f62cd416668(prev, response.data));
    };
    // Close notifications after navigating
    (0, $spJKX.useEffect)(()=>{
        if (doNavigate && isLoading && !isNavigating) startTransition(()=>{
            setIsNavigating(true);
            setDoNavigate(false);
        });
        else if (isNavigating && !isLoading) startTransition(()=>{
            setShowNotifications(false);
            setIsNavigating(false);
        });
    }, [
        doNavigate,
        isLoading,
        isNavigating,
        setShowNotifications
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $7CQgs.default), {
        id: `notification-${n.notificationId}`,
        horizontal: true,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $7CQgs.default).Item, {
                action: true,
                active: false,
                title: n.commentId ? "Click to View the associated Comment" : "Associated Comment has been deleted",
                id: `notification-${n.notificationId}-content`,
                className: "d-flex justify-content-between align-items-start",
                style: {
                    cursor: "pointer"
                },
                variant: n.notificationViewed ? "light" : "primary",
                onClick: async (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    /* istanbul ignore else */ if (!n.notificationViewed) toggleNotificationStatus(n.notificationId);
                    const commentId = n.commentId ? `&commentId=${n.commentId}` : "";
                    const target = n.entityType === "Hierarchy" ? {
                        pathname: `/H/${n.entityId}`,
                        search: `showHierarchyComments=true${commentId}`
                    } : {
                        pathname: `/TlfDesigner/${n.entityId}`,
                        search: `showTlfItemComments=true${commentId}`
                    };
                    /* istanbul ignore else */ if (n.entityType === "Hierarchy" && n.entityId !== hierarchyContext?.hierarchy?.id || n.entityType === "TlfItem" && n.entityId !== tlfContext.tlfData?.id) setDoNavigate(true);
                    else setShowNotifications(false);
                    navigate(target);
                },
                children: [
                    (doNavigate || isNavigating) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                        text: "Loading comment..."
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "ms-2 me-auto",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: n.notificationViewed ? "fw-normal" : "fw-bold",
                                children: n.notificationContent
                            }),
                            !n.commentId && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                                    className: "text-info",
                                    children: "(Comment has been deleted)"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                                className: "text-muted",
                                children: (0, $9S4dL.convertDateToLocaleString)(n.notificationDateTimeStamp)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4etRH.NotificationListItemEnvelope), {
                id: n.notificationId,
                viewed: n.notificationViewed,
                toggleNotificationStatus: toggleNotificationStatus
            })
        ]
    });
};
$48d394ecf5911e11$export$f73cbc6bc7eb6c67.displayName = "NotificationListItem";

});
parcelRegister("lyxDt", function(module, exports) {

$parcel$export(module.exports, "updateNotificationStatus", function () { return $ba03528d61b20e15$export$2f22adba7b8517; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ba03528d61b20e15$export$2f22adba7b8517 = async (backEndUrl, notification, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Comments/ToggleNotificationViewedStatus/${notification.notificationId}`;
        const response = await (0, $lCyBC.default).put(url, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("update notification status failed", error);
    }
};

});

parcelRegister("4etRH", function(module, exports) {

$parcel$export(module.exports, "NotificationListItemEnvelope", function () { return $6821c76b176affd7$export$e100b8270aee5325; });

var $bR5nk = parcelRequire("bR5nk");

var $7CQgs = parcelRequire("7CQgs");

var $5fz3T = parcelRequire("5fz3T");
var $aKDDV = parcelRequire("aKDDV");
const $6821c76b176affd7$export$e100b8270aee5325 = ({ id: id, viewed: viewed, toggleNotificationStatus: toggleNotificationStatus })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $7CQgs.default).Item, {
        id: `notification-${id}-toggle`,
        className: "d-flex align-items-center",
        style: {
            cursor: "pointer"
        },
        title: `Mark as ${viewed ? "unread" : "read"}`,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            toggleNotificationStatus(id);
        },
        children: viewed ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aKDDV.default), {
            size: "20"
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5fz3T.default), {
            size: "20"
        })
    }, `${id}-toggle`);
$6821c76b176affd7$export$e100b8270aee5325.displayName = "NotificationListItemEnvelope";

});
parcelRegister("5fz3T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d298d00cffd4a01$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $3d298d00cffd4a01$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $3d298d00cffd4a01$var$_extends() {
    return $3d298d00cffd4a01$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3d298d00cffd4a01$var$_extends.apply(null, arguments);
}
function $3d298d00cffd4a01$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $3d298d00cffd4a01$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $3d298d00cffd4a01$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $3d298d00cffd4a01$var$EnvelopeFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $3d298d00cffd4a01$var$_objectWithoutProperties(_ref, $3d298d00cffd4a01$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $3d298d00cffd4a01$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-envelope-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414zM0 4.697v7.104l5.803-3.558zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586zm3.436-.586L16 11.801V4.697z"
    }));
});
$3d298d00cffd4a01$var$EnvelopeFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $3d298d00cffd4a01$export$2e2bcd8739ae039 = $3d298d00cffd4a01$var$EnvelopeFill;

});

parcelRegister("aKDDV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d3cf3878418c33b$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $7d3cf3878418c33b$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $7d3cf3878418c33b$var$_extends() {
    return $7d3cf3878418c33b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $7d3cf3878418c33b$var$_extends.apply(null, arguments);
}
function $7d3cf3878418c33b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7d3cf3878418c33b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7d3cf3878418c33b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7d3cf3878418c33b$var$EnvelopeOpen = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $7d3cf3878418c33b$var$_objectWithoutProperties(_ref, $7d3cf3878418c33b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $7d3cf3878418c33b$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-envelope-open',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8.47 1.318a1 1 0 0 0-.94 0l-6 3.2A1 1 0 0 0 1 5.4v.817l5.75 3.45L8 8.917l1.25.75L15 6.217V5.4a1 1 0 0 0-.53-.882zM15 7.383l-4.778 2.867L15 13.117zm-.035 6.88L8 10.082l-6.965 4.18A1 1 0 0 0 2 15h12a1 1 0 0 0 .965-.738ZM1 13.116l4.778-2.867L1 7.383v5.734ZM7.059.435a2 2 0 0 1 1.882 0l6 3.2A2 2 0 0 1 16 5.4V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.4a2 2 0 0 1 1.059-1.765z"
    }));
});
$7d3cf3878418c33b$var$EnvelopeOpen.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $7d3cf3878418c33b$export$2e2bcd8739ae039 = $7d3cf3878418c33b$var$EnvelopeOpen;

});




parcelRegister("beLQs", function(module, exports) {

$parcel$export(module.exports, "NotificationsReadButton", function () { return $4f00c43e70a608eb$export$e0e93bab5111aa5f; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $hurCb = parcelRequire("hurCb");

var $spJKX = parcelRequire("spJKX");

var $eOuYt = parcelRequire("eOuYt");
const $4f00c43e70a608eb$export$e0e93bab5111aa5f = ({ notificationsList: notificationsList, setNotificationsList: setNotificationsList })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hasUnreadNotifications = (0, $spJKX.useMemo)(()=>{
        return notificationsList.some((n)=>!n.notificationViewed);
    }, [
        notificationsList
    ]);
    const [updateNotificationsStatusRequest, setUpdateNotifcationsStatusRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const markAllNotificationsAsViewed = (0, $spJKX.useCallback)(async ()=>{
        const response = await (0, $4dL47.loadWrapper)((0, $hurCb.updateAllNotificationsAsViewed), "UpdateAll", {
            ...updateNotificationsStatusRequest,
            requestedId: undefined
        }, setUpdateNotifcationsStatusRequest, appSettings.backEndUrl);
        if (response?.success) setNotificationsList(notificationsList.map((notification)=>({
                ...notification,
                notificationViewed: response.data.find((n)=>n.notificationId === notification.notificationId)?.notificationViewed ?? notification.notificationViewed
            })));
    }, [
        appSettings.backEndUrl,
        notificationsList,
        setNotificationsList,
        updateNotificationsStatusRequest
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
        id: "mark-all-notifications-button",
        disabled: !hasUnreadNotifications,
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            markAllNotificationsAsViewed();
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eOuYt.default), {
                className: "justify-self-center me-2"
            }),
            "Mark all as read"
        ]
    });
};
$4f00c43e70a608eb$export$e0e93bab5111aa5f.displayName = "NotificationsReadButton";

});
parcelRegister("hurCb", function(module, exports) {

$parcel$export(module.exports, "updateAllNotificationsAsViewed", function () { return $d66228d58afba773$export$116ade397598058a; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $d66228d58afba773$export$116ade397598058a = async (backEndUrl, _, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Comments/MarkAllNotificationsAsViewed`;
        const response = await (0, $lCyBC.default).put(url, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("update notifications status failed", error);
    }
};

});




parcelRegister("49H4I", function(module, exports) {

$parcel$export(module.exports, "TocNavigate", function () { return $d0203d75e07721f2$export$551491cff6ff209f; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4CKH9 = parcelRequire("4CKH9");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $02Kog = parcelRequire("02Kog");
var $2d6Pt = parcelRequire("2d6Pt");
const $d0203d75e07721f2$export$551491cff6ff209f = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const tocContext = (0, $3tNrK.useTocContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("toc-navigate");
    if (!hierarchy || !tocContext || !tlfContext) return null;
    const tlf = tlfContext.tlfData;
    const toc = tocContext.state.tocItems.filter((item)=>item.type !== (0, $4lHS7.eTlfItemType).section).sort((a, b)=>(a.tocOrder ?? 0) - (b.tocOrder ?? 0));
    const thisTocItemIndex = toc.findIndex((item)=>item.id === tlf?.id);
    const leftToc = thisTocItemIndex > 0 ? toc[thisTocItemIndex - 1] : null;
    const leftDest = leftToc && hierarchy.tocMajorVersion !== undefined ? (0, $4CKH9.getTlfUrl)(hierarchy, leftToc) : null;
    const rightToc = thisTocItemIndex > -1 && thisTocItemIndex < toc.length - 1 ? toc[thisTocItemIndex + 1] : null;
    const rightDest = rightToc && hierarchy.tocMajorVersion !== undefined ? (0, $4CKH9.getTlfUrl)(hierarchy, rightToc) : null;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $02Kog.default), {
                style: {
                    cursor: leftDest ? "pointer" : "not-allowed",
                    color: leftDest ? "black" : "grey"
                },
                "aria-label": "Navigate to previous ToC entry",
                title: leftToc?.tocNumber,
                onClick: ()=>leftDest && navigate(leftDest)
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2d6Pt.default), {
                style: {
                    cursor: rightDest ? "pointer" : "not-allowed",
                    color: rightDest ? "black" : "grey"
                },
                "aria-label": "Navigate to next ToC entry",
                title: rightToc?.tocNumber,
                onClick: ()=>rightDest && navigate(rightDest)
            })
        ]
    });
};
$d0203d75e07721f2$export$551491cff6ff209f.displayName = "TocNavigate";

});

parcelRegister("2ObvW", function(module, exports) {

$parcel$export(module.exports, "brandBackgroud", function () { return $20b92ec0f7c75739$export$29f8578c16b69ca6; }, function (v) { return $20b92ec0f7c75739$export$29f8578c16b69ca6 = v; });
$parcel$export(module.exports, "brandHolder", function () { return $20b92ec0f7c75739$export$829121345dabd4a0; }, function (v) { return $20b92ec0f7c75739$export$829121345dabd4a0 = v; });
$parcel$export(module.exports, "center", function () { return $20b92ec0f7c75739$export$3481c78889e8fbe8; }, function (v) { return $20b92ec0f7c75739$export$3481c78889e8fbe8 = v; });
$parcel$export(module.exports, "endSection", function () { return $20b92ec0f7c75739$export$dde49f02c5dd1db6; }, function (v) { return $20b92ec0f7c75739$export$dde49f02c5dd1db6 = v; });
$parcel$export(module.exports, "grid", function () { return $20b92ec0f7c75739$export$85fc379452d91af0; }, function (v) { return $20b92ec0f7c75739$export$85fc379452d91af0 = v; });
$parcel$export(module.exports, "gridBrandCell", function () { return $20b92ec0f7c75739$export$20e01b73bbde4d50; }, function (v) { return $20b92ec0f7c75739$export$20e01b73bbde4d50 = v; });
$parcel$export(module.exports, "gridRowOne", function () { return $20b92ec0f7c75739$export$632ba9f24b430add; }, function (v) { return $20b92ec0f7c75739$export$632ba9f24b430add = v; });
$parcel$export(module.exports, "gridRowTwo", function () { return $20b92ec0f7c75739$export$64aaea269ec583d; }, function (v) { return $20b92ec0f7c75739$export$64aaea269ec583d = v; });
$parcel$export(module.exports, "leftNav", function () { return $20b92ec0f7c75739$export$297a118919f0a00e; }, function (v) { return $20b92ec0f7c75739$export$297a118919f0a00e = v; });
$parcel$export(module.exports, "menuHolder", function () { return $20b92ec0f7c75739$export$26ae2fe8547c1936; }, function (v) { return $20b92ec0f7c75739$export$26ae2fe8547c1936 = v; });
$parcel$export(module.exports, "rightNav", function () { return $20b92ec0f7c75739$export$ef76859433d279a; }, function (v) { return $20b92ec0f7c75739$export$ef76859433d279a = v; });
$parcel$export(module.exports, "rightNavText", function () { return $20b92ec0f7c75739$export$c91f82058224546b; }, function (v) { return $20b92ec0f7c75739$export$c91f82058224546b = v; });
$parcel$export(module.exports, "titleText", function () { return $20b92ec0f7c75739$export$318bb85fd83e5f1a; }, function (v) { return $20b92ec0f7c75739$export$318bb85fd83e5f1a = v; });
var $20b92ec0f7c75739$export$29f8578c16b69ca6;
var $20b92ec0f7c75739$export$829121345dabd4a0;
var $20b92ec0f7c75739$export$3481c78889e8fbe8;
var $20b92ec0f7c75739$export$dde49f02c5dd1db6;
var $20b92ec0f7c75739$export$85fc379452d91af0;
var $20b92ec0f7c75739$export$20e01b73bbde4d50;
var $20b92ec0f7c75739$export$632ba9f24b430add;
var $20b92ec0f7c75739$export$64aaea269ec583d;
var $20b92ec0f7c75739$export$297a118919f0a00e;
var $20b92ec0f7c75739$export$26ae2fe8547c1936;
var $20b92ec0f7c75739$export$ef76859433d279a;
var $20b92ec0f7c75739$export$c91f82058224546b;
var $20b92ec0f7c75739$export$318bb85fd83e5f1a;
$20b92ec0f7c75739$export$29f8578c16b69ca6 = `mos-TopBar-module-8BkwSq-brandBackgroud`;
$20b92ec0f7c75739$export$829121345dabd4a0 = `mos-TopBar-module-8BkwSq-brandHolder`;
$20b92ec0f7c75739$export$3481c78889e8fbe8 = `mos-TopBar-module-8BkwSq-center`;
$20b92ec0f7c75739$export$dde49f02c5dd1db6 = `mos-TopBar-module-8BkwSq-endSection`;
$20b92ec0f7c75739$export$85fc379452d91af0 = `mos-TopBar-module-8BkwSq-grid`;
$20b92ec0f7c75739$export$20e01b73bbde4d50 = `mos-TopBar-module-8BkwSq-gridBrandCell`;
$20b92ec0f7c75739$export$632ba9f24b430add = `mos-TopBar-module-8BkwSq-gridRowOne`;
$20b92ec0f7c75739$export$64aaea269ec583d = `mos-TopBar-module-8BkwSq-gridRowTwo`;
$20b92ec0f7c75739$export$297a118919f0a00e = `mos-TopBar-module-8BkwSq-leftNav`;
$20b92ec0f7c75739$export$26ae2fe8547c1936 = `mos-TopBar-module-8BkwSq-menuHolder`;
$20b92ec0f7c75739$export$ef76859433d279a = `mos-TopBar-module-8BkwSq-rightNav`;
$20b92ec0f7c75739$export$c91f82058224546b = `mos-TopBar-module-8BkwSq-rightNavText`;
$20b92ec0f7c75739$export$318bb85fd83e5f1a = `mos-TopBar-module-8BkwSq-titleText`;

});


parcelRegister("fetYZ", function(module, exports) {

$parcel$export(module.exports, "SettingsDropMenu", function () { return $4e7d16d086fcc24b$export$46562ffa19c7132e; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $5FU7L = parcelRequire("5FU7L");
const $4e7d16d086fcc24b$export$46562ffa19c7132e = ({ settingsEntry: settingsEntry })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchies = hierarchyContext && hierarchyContext.hierarchy ? Array.from(new Set([
        hierarchyContext.hierarchy,
        ...hierarchyContext.hierarchyNodes
    ])) : undefined;
    return !hierarchies || !settingsEntry ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default), {
        title: "Settings",
        id: "settingsdropmenu",
        className: "align-self-center",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            style: {
                maxHeight: "75vh",
                overflowY: "auto"
            },
            children: settingsEntry
        })
    });
};
$4e7d16d086fcc24b$export$46562ffa19c7132e.displayName = "SettingsDropMenu";

});

parcelRegister("hseKe", function(module, exports) {
module.exports = $parcel$resolve("fv4oe");

});



parcelRegister("gilEr", function(module, exports) {

$parcel$export(module.exports, "connectToHub", function () { return $74daead8c2815b06$export$edc82a61196017a3; });

var $39LPx = parcelRequire("39LPx");
var $aEdNZ = parcelRequire("aEdNZ");
const $74daead8c2815b06$export$edc82a61196017a3 = async (url)=>{
    // Custom retry policy: 0ms, 2s, 10s, 30s delays between reconnect attempts.
    const retryDelays = [
        0,
        2000,
        10000,
        30000
    ];
    const retryPolicy = {
        nextRetryDelayInMilliseconds (retryContext) {
            if (retryContext.previousRetryCount >= retryDelays.length) return null;
            return retryDelays[retryContext.previousRetryCount];
        }
    };
    const conn = new (0, $39LPx.HubConnectionBuilder)().withUrl(url).configureLogging((0, $aEdNZ.LogLevel).Warning).withAutomaticReconnect(retryPolicy).build();
    await conn.start();
    return conn;
};

});
parcelRegister("39LPx", function(module, exports) {

$parcel$export(module.exports, "HubConnectionBuilder", function () { return $24c75070bb8dfdc4$export$afccb10c24910b13; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $45YNB = parcelRequire("45YNB");

var $2G6sq = parcelRequire("2G6sq");

var $h9eE2 = parcelRequire("h9eE2");

var $aEdNZ = parcelRequire("aEdNZ");

var $gLCNp = parcelRequire("gLCNp");

var $5jfsC = parcelRequire("5jfsC");

var $1Y1Ki = parcelRequire("1Y1Ki");
const $24c75070bb8dfdc4$var$LogLevelNameMapping = {
    trace: (0, $aEdNZ.LogLevel).Trace,
    debug: (0, $aEdNZ.LogLevel).Debug,
    info: (0, $aEdNZ.LogLevel).Information,
    information: (0, $aEdNZ.LogLevel).Information,
    warn: (0, $aEdNZ.LogLevel).Warning,
    warning: (0, $aEdNZ.LogLevel).Warning,
    error: (0, $aEdNZ.LogLevel).Error,
    critical: (0, $aEdNZ.LogLevel).Critical,
    none: (0, $aEdNZ.LogLevel).None
};
function $24c75070bb8dfdc4$var$parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = $24c75070bb8dfdc4$var$LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") return mapping;
    else throw new Error(`Unknown log level: ${name}`);
}
class $24c75070bb8dfdc4$export$afccb10c24910b13 {
    configureLogging(logging) {
        (0, $1Y1Ki.Arg).isRequired(logging, "logging");
        if ($24c75070bb8dfdc4$var$isLogger(logging)) this.logger = logging;
        else if (typeof logging === "string") {
            const logLevel = $24c75070bb8dfdc4$var$parseLogLevel(logging);
            this.logger = new (0, $1Y1Ki.ConsoleLogger)(logLevel);
        } else this.logger = new (0, $1Y1Ki.ConsoleLogger)(logging);
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        (0, $1Y1Ki.Arg).isRequired(url, "url");
        (0, $1Y1Ki.Arg).isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            ...transportTypeOrOptions
        };
        else this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            transport: transportTypeOrOptions
        };
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */ withHubProtocol(protocol) {
        (0, $1Y1Ki.Arg).isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        if (!retryDelaysOrReconnectPolicy) this.reconnectPolicy = new (0, $45YNB.DefaultReconnectPolicy)();
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) this.reconnectPolicy = new (0, $45YNB.DefaultReconnectPolicy)(retryDelaysOrReconnectPolicy);
        else this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withServerTimeout(milliseconds) {
        (0, $1Y1Ki.Arg).isRequired(milliseconds, "milliseconds");
        this._serverTimeoutInMilliseconds = milliseconds;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withKeepAliveInterval(milliseconds) {
        (0, $1Y1Ki.Arg).isRequired(milliseconds, "milliseconds");
        this._keepAliveIntervalInMilliseconds = milliseconds;
        return this;
    }
    /** Enables and configures options for the Stateful Reconnect feature.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withStatefulReconnect(options) {
        if (this.httpConnectionOptions === undefined) this.httpConnectionOptions = {};
        this.httpConnectionOptions._useStatefulReconnect = true;
        this._statefulReconnectBufferSize = options === null || options === void 0 ? void 0 : options.bufferSize;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */ build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
        httpConnectionOptions.logger = this.logger;
        // Now create the connection
        if (!this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const connection = new (0, $2G6sq.HttpConnection)(this.url, httpConnectionOptions);
        return (0, $h9eE2.HubConnection).create(connection, this.logger || (0, $5jfsC.NullLogger).instance, this.protocol || new (0, $gLCNp.JsonHubProtocol)(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
    }
}
function $24c75070bb8dfdc4$var$isLogger(logger) {
    return logger.log !== undefined;
}

});
parcelRegister("45YNB", function(module, exports) {

$parcel$export(module.exports, "DefaultReconnectPolicy", function () { return $2fb6ca7e6ae22c6e$export$97bc471d6a059e6e; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
const $2fb6ca7e6ae22c6e$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [
    0,
    2000,
    10000,
    30000,
    null
];
class $2fb6ca7e6ae22c6e$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays,
            null
        ] : $2fb6ca7e6ae22c6e$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}

});

parcelRegister("2G6sq", function(module, exports) {

$parcel$export(module.exports, "HttpConnection", function () { return $1f34835143631145$export$13c1f9cf8a283575; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $2lFcT = parcelRequire("2lFcT");

var $1q6lE = parcelRequire("1q6lE");

var $kLqxE = parcelRequire("kLqxE");

var $aEdNZ = parcelRequire("aEdNZ");

var $kNxgN = parcelRequire("kNxgN");

var $5WrrO = parcelRequire("5WrrO");

var $jDDGk = parcelRequire("jDDGk");

var $1Y1Ki = parcelRequire("1Y1Ki");

var $iUZ5u = parcelRequire("iUZ5u");
const $1f34835143631145$var$MAX_REDIRECTS = 100;
class $1f34835143631145$export$13c1f9cf8a283575 {
    constructor(url, options = {}){
        this._stopPromiseResolver = ()=>{};
        this.features = {};
        this._negotiateVersion = 1;
        (0, $1Y1Ki.Arg).isRequired(url, "url");
        this._logger = (0, $1Y1Ki.createLogger)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        else throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        options.timeout = options.timeout === undefined ? 100000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if ((0, $1Y1Ki.Platform).isNode && true) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!(0, $1Y1Ki.Platform).isNode && typeof WebSocket !== "undefined" && !options.WebSocket) options.WebSocket = WebSocket;
        else if ((0, $1Y1Ki.Platform).isNode && !options.WebSocket) {
            if (webSocketModule) options.WebSocket = webSocketModule;
        }
        if (!(0, $1Y1Ki.Platform).isNode && typeof EventSource !== "undefined" && !options.EventSource) options.EventSource = EventSource;
        else if ((0, $1Y1Ki.Platform).isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") options.EventSource = eventSourceModule;
        }
        this._httpClient = new (0, $2lFcT.AccessTokenHttpClient)(options.httpClient || new (0, $1q6lE.DefaultHttpClient)(this._logger), options.accessTokenFactory);
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || (0, $kNxgN.TransferFormat).Binary;
        (0, $1Y1Ki.Arg).isIn(transferFormat, (0, $kNxgN.TransferFormat), "transferFormat");
        this._logger.log((0, $aEdNZ.LogLevel).Debug, `Starting connection with transfer format '${(0, $kNxgN.TransferFormat)[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* ConnectionState.Disconnected */ ) return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        this._connectionState = "Connecting" /* ConnectionState.Connecting */ ;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log((0, $aEdNZ.LogLevel).Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new (0, $kLqxE.AbortError)(message));
        } else if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log((0, $aEdNZ.LogLevel).Error, message);
            return Promise.reject(new (0, $kLqxE.AbortError)(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        if (!this._sendQueue) this._sendQueue = new $1f34835143631145$export$ff09921d3884e946(this.transport);
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* ConnectionState.Disconnecting */ ;
        this._stopPromise = new Promise((resolve)=>{
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        } else this._logger.log((0, $aEdNZ.LogLevel).Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        this._httpClient._accessTokenFactory = this._accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === (0, $kNxgN.HttpTransportType).WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport((0, $kNxgN.HttpTransportType).WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                } else throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            } else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */  || this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) throw new (0, $kLqxE.AbortError)("The connection was stopped during negotiation.");
                    if (negotiateResponse.error) throw new Error(negotiateResponse.error);
                    if (negotiateResponse.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    if (negotiateResponse.url) url = negotiateResponse.url;
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = ()=>accessToken;
                        // set the factory to undefined so the AccessTokenHttpClient won't retry with the same token, since we know it won't change until a connection restart
                        this._httpClient._accessToken = accessToken;
                        this._httpClient._accessTokenFactory = undefined;
                    }
                    redirects++;
                }while (negotiateResponse.url && redirects < $1f34835143631145$var$MAX_REDIRECTS);
                if (redirects === $1f34835143631145$var$MAX_REDIRECTS && negotiateResponse.url) throw new Error("Negotiate redirection limit exceeded.");
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof (0, $5WrrO.LongPollingTransport)) this.features.inherentKeepAlive = true;
            if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log((0, $aEdNZ.LogLevel).Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* ConnectionState.Connected */ ;
            }
        // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
        // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
        // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        } catch (e) {
            this._logger.log((0, $aEdNZ.LogLevel).Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        const [name, value] = (0, $1Y1Ki.getUserAgentHeader)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log((0, $aEdNZ.LogLevel).Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            });
            if (response.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) // Negotiate version 0 doesn't use connectionToken
            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
            negotiateResponse.connectionToken = negotiateResponse.connectionId;
            if (negotiateResponse.useStatefulReconnect && this._options._useStatefulReconnect !== true) return Promise.reject(new (0, $kLqxE.FailedToNegotiateWithServerError)("Client didn't negotiate Stateful Reconnect but the server did."));
            return negotiateResponse;
        } catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof (0, $kLqxE.HttpError)) {
                if (e.statusCode === 404) errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
            }
            this._logger.log((0, $aEdNZ.LogLevel).Error, errorMessage);
            return Promise.reject(new (0, $kLqxE.FailedToNegotiateWithServerError)(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) return url;
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports){
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, (negotiate === null || negotiate === void 0 ? void 0 : negotiate.useStatefulReconnect) === true);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            } else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    } catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                } catch (ex) {
                    this._logger.log((0, $aEdNZ.LogLevel).Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new (0, $kLqxE.FailedToStartTransportError)(`${endpoint.transport} failed: ${ex}`, (0, $kNxgN.HttpTransportType)[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* ConnectionState.Connecting */ ) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log((0, $aEdNZ.LogLevel).Debug, message);
                        return Promise.reject(new (0, $kLqxE.AbortError)(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) return Promise.reject(new (0, $kLqxE.AggregateErrors)(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch(transport){
            case (0, $kNxgN.HttpTransportType).WebSockets:
                if (!this._options.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
                return new (0, $iUZ5u.WebSocketTransport)(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case (0, $kNxgN.HttpTransportType).ServerSentEvents:
                if (!this._options.EventSource) throw new Error("'EventSource' is not supported in your environment.");
                return new (0, $jDDGk.ServerSentEventsTransport)(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
            case (0, $kNxgN.HttpTransportType).LongPolling:
                return new (0, $5WrrO.LongPollingTransport)(this._httpClient, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        if (this.features.reconnect) this.transport.onclose = async (e)=>{
            let callStop = false;
            if (this.features.reconnect) try {
                this.features.disconnected();
                await this.transport.connect(url, transferFormat);
                await this.features.resend();
            } catch  {
                callStop = true;
            }
            else {
                this._stopConnection(e);
                return;
            }
            if (callStop) this._stopConnection(e);
        };
        else this.transport.onclose = (e)=>this._stopConnection(e);
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, useStatefulReconnect) {
        const transport = (0, $kNxgN.HttpTransportType)[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        } else if ($1f34835143631145$var$transportMatches(requestedTransport, transport)) {
            const transferFormats = endpoint.transferFormats.map((s)=>(0, $kNxgN.TransferFormat)[s]);
            if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                if (transport === (0, $kNxgN.HttpTransportType).WebSockets && !this._options.WebSocket || transport === (0, $kNxgN.HttpTransportType).ServerSentEvents && !this._options.EventSource) {
                    this._logger.log((0, $aEdNZ.LogLevel).Debug, `Skipping transport '${(0, $kNxgN.HttpTransportType)[transport]}' because it is not supported in your environment.'`);
                    return new (0, $kLqxE.UnsupportedTransportError)(`'${(0, $kNxgN.HttpTransportType)[transport]}' is not supported in your environment.`, transport);
                } else {
                    this._logger.log((0, $aEdNZ.LogLevel).Debug, `Selecting transport '${(0, $kNxgN.HttpTransportType)[transport]}'.`);
                    try {
                        this.features.reconnect = transport === (0, $kNxgN.HttpTransportType).WebSockets ? useStatefulReconnect : undefined;
                        return this._constructTransport(transport);
                    } catch (ex) {
                        return ex;
                    }
                }
            } else {
                this._logger.log((0, $aEdNZ.LogLevel).Debug, `Skipping transport '${(0, $kNxgN.HttpTransportType)[transport]}' because it does not support the requested transfer format '${(0, $kNxgN.TransferFormat)[requestedTransferFormat]}'.`);
                return new Error(`'${(0, $kNxgN.HttpTransportType)[transport]}' does not support ${(0, $kNxgN.TransferFormat)[requestedTransferFormat]}.`);
            }
        } else {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Skipping transport '${(0, $kNxgN.HttpTransportType)[transport]}' because it was disabled by the client.`);
            return new (0, $kLqxE.DisabledTransportError)(`'${(0, $kNxgN.HttpTransportType)[transport]}' is disabled by the client.`, transport);
        }
    }
    _isITransport(transport) {
        return transport && typeof transport === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log((0, $aEdNZ.LogLevel).Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $aEdNZ.LogLevel).Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
            this._logger.log((0, $aEdNZ.LogLevel).Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
        if (error) this._logger.log((0, $aEdNZ.LogLevel).Error, `Connection disconnected with error '${error}'.`);
        else this._logger.log((0, $aEdNZ.LogLevel).Information, "Connection disconnected.");
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e)=>{
                this._logger.log((0, $aEdNZ.LogLevel).Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) this.onclose(error);
            } catch (e) {
                this._logger.log((0, $aEdNZ.LogLevel).Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) return url;
        if (!(0, $1Y1Ki.Platform).isBrowser) throw new Error(`Cannot resolve '${url}'.`);
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log((0, $aEdNZ.LogLevel).Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const negotiateUrl = new URL(url);
        if (negotiateUrl.pathname.endsWith('/')) negotiateUrl.pathname += "negotiate";
        else negotiateUrl.pathname += "/negotiate";
        const searchParams = new URLSearchParams(negotiateUrl.searchParams);
        if (!searchParams.has("negotiateVersion")) searchParams.append("negotiateVersion", this._negotiateVersion.toString());
        if (searchParams.has("useStatefulReconnect")) {
            if (searchParams.get("useStatefulReconnect") === "true") this._options._useStatefulReconnect = true;
        } else if (this._options._useStatefulReconnect === true) searchParams.append("useStatefulReconnect", "true");
        negotiateUrl.search = searchParams.toString();
        return negotiateUrl.toString();
    }
}
function $1f34835143631145$var$transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class $1f34835143631145$export$ff09921d3884e946 {
    constructor(_transport){
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new $1f34835143631145$var$PromiseSource();
        this._transportResult = new $1f34835143631145$var$PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) this._transportResult = new $1f34835143631145$var$PromiseSource();
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof this._buffer[0] !== typeof data) throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data}`);
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while(true){
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) this._transportResult.reject("Connection stopped.");
                break;
            }
            this._sendBufferedData = new $1f34835143631145$var$PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof this._buffer[0] === "string" ? this._buffer.join("") : $1f34835143631145$export$ff09921d3884e946._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            } catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b)=>b.byteLength).reduce((a, b)=>a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers){
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
class $1f34835143631145$var$PromiseSource {
    constructor(){
        this.promise = new Promise((resolve, reject)=>([this._resolver, this._rejecter] = [
                resolve,
                reject
            ]));
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}

});
parcelRegister("2lFcT", function(module, exports) {

$parcel$export(module.exports, "AccessTokenHttpClient", function () { return $1b5d81c6c946ab49$export$981ab95414418dd3; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $8RxDz = parcelRequire("8RxDz");

var $eOJ4Q = parcelRequire("eOJ4Q");
class $1b5d81c6c946ab49$export$981ab95414418dd3 extends (0, $eOJ4Q.HttpClient) {
    constructor(innerClient, accessTokenFactory){
        super();
        this._innerClient = innerClient;
        this._accessTokenFactory = accessTokenFactory;
    }
    async send(request) {
        let allowRetry = true;
        if (this._accessTokenFactory && (!this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0)) {
            // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
            allowRetry = false;
            this._accessToken = await this._accessTokenFactory();
        }
        this._setAuthorizationHeader(request);
        const response = await this._innerClient.send(request);
        if (allowRetry && response.statusCode === 401 && this._accessTokenFactory) {
            this._accessToken = await this._accessTokenFactory();
            this._setAuthorizationHeader(request);
            return await this._innerClient.send(request);
        }
        return response;
    }
    _setAuthorizationHeader(request) {
        if (!request.headers) request.headers = {};
        if (this._accessToken) request.headers[(0, $8RxDz.HeaderNames).Authorization] = `Bearer ${this._accessToken}`;
        else if (this._accessTokenFactory) {
            if (request.headers[(0, $8RxDz.HeaderNames).Authorization]) delete request.headers[(0, $8RxDz.HeaderNames).Authorization];
        }
    }
    getCookieString(url) {
        return this._innerClient.getCookieString(url);
    }
}

});
parcelRegister("8RxDz", function(module, exports) {

$parcel$export(module.exports, "HeaderNames", function () { return $673d5da07f2ab718$export$28d77f87efed1d88; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
class $673d5da07f2ab718$export$28d77f87efed1d88 {
}
$673d5da07f2ab718$export$28d77f87efed1d88.Authorization = "Authorization";
$673d5da07f2ab718$export$28d77f87efed1d88.Cookie = "Cookie";

});

parcelRegister("eOJ4Q", function(module, exports) {

$parcel$export(module.exports, "HttpResponse", function () { return $ac98b38e9b42c2b4$export$1d94dfe0d9d1f1e7; });
$parcel$export(module.exports, "HttpClient", function () { return $ac98b38e9b42c2b4$export$8c6ee871e681f0f4; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */ class $ac98b38e9b42c2b4$export$1d94dfe0d9d1f1e7 {
    constructor(statusCode, statusText, content){
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
class $ac98b38e9b42c2b4$export$8c6ee871e681f0f4 {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url: url
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url: url
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url: url
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */ // @ts-ignore
    getCookieString(url) {
        return "";
    }
}

});


parcelRegister("1q6lE", function(module, exports) {

$parcel$export(module.exports, "DefaultHttpClient", function () { return $108d24c46cd0f5d4$export$4f11ab3560c519e5; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $kLqxE = parcelRequire("kLqxE");

var $izXpL = parcelRequire("izXpL");

var $eOJ4Q = parcelRequire("eOJ4Q");

var $1Y1Ki = parcelRequire("1Y1Ki");

var $8erUB = parcelRequire("8erUB");
class $108d24c46cd0f5d4$export$4f11ab3560c519e5 extends (0, $eOJ4Q.HttpClient) {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */ constructor(logger){
        super();
        if (typeof fetch !== "undefined" || (0, $1Y1Ki.Platform).isNode) this._httpClient = new (0, $izXpL.FetchHttpClient)(logger);
        else if (typeof XMLHttpRequest !== "undefined") this._httpClient = new (0, $8erUB.XhrHttpClient)(logger);
        else throw new Error("No usable HttpClient found.");
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $kLqxE.AbortError)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}

});
parcelRegister("izXpL", function(module, exports) {

$parcel$export(module.exports, "FetchHttpClient", function () { return $d869955a2b0a103a$export$1b51ed6f7c8f947b; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $kLqxE = parcelRequire("kLqxE");

var $eOJ4Q = parcelRequire("eOJ4Q");

var $aEdNZ = parcelRequire("aEdNZ");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $d869955a2b0a103a$export$1b51ed6f7c8f947b extends (0, $eOJ4Q.HttpClient) {
    constructor(logger){
        super();
        this._logger = logger;
        // Node added a fetch implementation to the global scope starting in v18.
        // We need to add a cookie jar in node to be able to share cookies with WebSocket
        if (typeof fetch === "undefined" || (0, $1Y1Ki.Platform).isNode) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            if (typeof fetch === "undefined") this._fetchType = requireFunc("node-fetch");
            else // Use fetch from Node if available
            this._fetchType = fetch;
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        } else this._fetchType = fetch.bind((0, $1Y1Ki.getGlobalThis)());
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        } else this._abortControllerType = AbortController;
    }
    /** @inheritDoc */ async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) throw new (0, $kLqxE.AbortError)();
        if (!request.method) throw new Error("No method defined.");
        if (!request.url) throw new Error("No url defined.");
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) request.abortSignal.onabort = ()=>{
            abortController.abort();
            error = new (0, $kLqxE.AbortError)();
        };
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(()=>{
                abortController.abort();
                this._logger.log((0, $aEdNZ.LogLevel).Warning, `Timeout from HTTP request.`);
                error = new (0, $kLqxE.TimeoutError)();
            }, msTimeout);
        }
        if (request.content === "") request.content = undefined;
        if (request.content) {
            // Explicitly setting the Content-Type header for React Native on Android platform.
            request.headers = request.headers || {};
            if ((0, $1Y1Ki.isArrayBuffer)(request.content)) request.headers["Content-Type"] = "application/octet-stream";
            else request.headers["Content-Type"] = "text/plain;charset=UTF-8";
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
            });
        } catch (e) {
            if (error) throw error;
            this._logger.log((0, $aEdNZ.LogLevel).Warning, `Error from HTTP request. ${e}.`);
            throw e;
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (request.abortSignal) request.abortSignal.onabort = null;
        }
        if (!response.ok) {
            const errorMessage = await $d869955a2b0a103a$var$deserializeContent(response, "text");
            throw new (0, $kLqxE.HttpError)(errorMessage || response.statusText, response.status);
        }
        const content = $d869955a2b0a103a$var$deserializeContent(response, request.responseType);
        const payload = await content;
        return new (0, $eOJ4Q.HttpResponse)(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if ((0, $1Y1Ki.Platform).isNode && this._jar) // @ts-ignore: unused variable
        this._jar.getCookies(url, (e, c)=>cookies = c.join("; "));
        return cookies;
    }
}
function $d869955a2b0a103a$var$deserializeContent(response, responseType) {
    let content;
    switch(responseType){
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}

});

parcelRegister("8erUB", function(module, exports) {

$parcel$export(module.exports, "XhrHttpClient", function () { return $5fe54847eea5e894$export$33b9ed1bd07561aa; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $kLqxE = parcelRequire("kLqxE");

var $eOJ4Q = parcelRequire("eOJ4Q");

var $aEdNZ = parcelRequire("aEdNZ");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $5fe54847eea5e894$export$33b9ed1bd07561aa extends (0, $eOJ4Q.HttpClient) {
    constructor(logger){
        super();
        this._logger = logger;
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $kLqxE.AbortError)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (request.content === "") request.content = undefined;
            if (request.content) {
                // Explicitly setting the Content-Type header for React Native on Android platform.
                if ((0, $1Y1Ki.isArrayBuffer)(request.content)) xhr.setRequestHeader("Content-Type", "application/octet-stream");
                else xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            }
            const headers = request.headers;
            if (headers) Object.keys(headers).forEach((header)=>{
                xhr.setRequestHeader(header, headers[header]);
            });
            if (request.responseType) xhr.responseType = request.responseType;
            if (request.abortSignal) request.abortSignal.onabort = ()=>{
                xhr.abort();
                reject(new (0, $kLqxE.AbortError)());
            };
            if (request.timeout) xhr.timeout = request.timeout;
            xhr.onload = ()=>{
                if (request.abortSignal) request.abortSignal.onabort = null;
                if (xhr.status >= 200 && xhr.status < 300) resolve(new (0, $eOJ4Q.HttpResponse)(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                else reject(new (0, $kLqxE.HttpError)(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
            };
            xhr.onerror = ()=>{
                this._logger.log((0, $aEdNZ.LogLevel).Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new (0, $kLqxE.HttpError)(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = ()=>{
                this._logger.log((0, $aEdNZ.LogLevel).Warning, `Timeout from HTTP request.`);
                reject(new (0, $kLqxE.TimeoutError)());
            };
            xhr.send(request.content);
        });
    }
}

});


parcelRegister("kNxgN", function(module, exports) {

$parcel$export(module.exports, "HttpTransportType", function () { return $f24230fa86927900$export$789ba40ee1a75f0; });
$parcel$export(module.exports, "TransferFormat", function () { return $f24230fa86927900$export$f29afaa8e8d2989a; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */ var $f24230fa86927900$export$789ba40ee1a75f0;
(function(HttpTransportType) {
    /** Specifies no transport preference. */ HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */ HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */ HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */ HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})($f24230fa86927900$export$789ba40ee1a75f0 || ($f24230fa86927900$export$789ba40ee1a75f0 = {}));
var $f24230fa86927900$export$f29afaa8e8d2989a;
(function(TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */ TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */ TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})($f24230fa86927900$export$f29afaa8e8d2989a || ($f24230fa86927900$export$f29afaa8e8d2989a = {}));

});

parcelRegister("5WrrO", function(module, exports) {

$parcel$export(module.exports, "LongPollingTransport", function () { return $4537a90dcb32757c$export$fbd8c90d2cca1300; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $d2HAR = parcelRequire("d2HAR");

var $kLqxE = parcelRequire("kLqxE");

var $aEdNZ = parcelRequire("aEdNZ");

var $kNxgN = parcelRequire("kNxgN");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $4537a90dcb32757c$export$fbd8c90d2cca1300 {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    constructor(httpClient, logger, options){
        this._httpClient = httpClient;
        this._logger = logger;
        this._pollAbort = new (0, $d2HAR.AbortController)();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $1Y1Ki.Arg).isRequired(url, "url");
        (0, $1Y1Ki.Arg).isRequired(transferFormat, "transferFormat");
        (0, $1Y1Ki.Arg).isIn(transferFormat, (0, $kNxgN.TransferFormat), "transferFormat");
        this._url = url;
        this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === (0, $kNxgN.TransferFormat).Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [name, value] = (0, $1Y1Ki.getUserAgentHeader)();
        const headers = {
            [name]: value,
            ...this._options.headers
        };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers: headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials
        };
        if (transferFormat === (0, $kNxgN.TransferFormat).Binary) pollOptions.responseType = "arraybuffer";
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log((0, $aEdNZ.LogLevel).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new (0, $kLqxE.HttpError)(response.statusText || "", response.statusCode);
            this._running = false;
        } else this._running = true;
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _poll(url, pollOptions) {
        try {
            while(this._running)try {
                const pollUrl = `${url}&_=${Date.now()}`;
                this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                const response = await this._httpClient.get(pollUrl, pollOptions);
                if (response.statusCode === 204) {
                    this._logger.log((0, $aEdNZ.LogLevel).Information, "(LongPolling transport) Poll terminated by server.");
                    this._running = false;
                } else if (response.statusCode !== 200) {
                    this._logger.log((0, $aEdNZ.LogLevel).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                    // Unexpected status code
                    this._closeError = new (0, $kLqxE.HttpError)(response.statusText || "", response.statusCode);
                    this._running = false;
                } else // Process the response
                if (response.content) {
                    this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) data received. ${(0, $1Y1Ki.getDataDetail)(response.content, this._options.logMessageContent)}.`);
                    if (this.onreceive) this.onreceive(response.content);
                } else // This is another way timeout manifest.
                this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Poll timed out, reissuing.");
            } catch (e) {
                if (!this._running) // Log but disregard errors that occur after stopping
                this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                else if (e instanceof (0, $kLqxE.TimeoutError)) // Ignore timeouts and reissue the poll.
                this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                else {
                    // Close the connection with the error as the result.
                    this._closeError = e;
                    this._running = false;
                }
            }
        } finally{
            this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) this._raiseOnClose();
        }
    }
    async send(data) {
        if (!this._running) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $1Y1Ki.sendMessage)(this._logger, "LongPolling", this._httpClient, this._url, data, this._options);
    }
    async stop() {
        this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, $1Y1Ki.getUserAgentHeader)();
            headers[name] = value;
            const deleteOptions = {
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            };
            let error;
            try {
                await this._httpClient.delete(this._url, deleteOptions);
            } catch (err) {
                error = err;
            }
            if (error) {
                if (error instanceof (0, $kLqxE.HttpError)) {
                    if (error.statusCode === 404) this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.");
                    else this._logger.log((0, $aEdNZ.LogLevel).Trace, `(LongPolling transport) Error sending a DELETE request: ${error}`);
                }
            } else this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) DELETE request accepted.");
        } finally{
            this._logger.log((0, $aEdNZ.LogLevel).Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) logMessage += " Error: " + this._closeError;
            this._logger.log((0, $aEdNZ.LogLevel).Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}

});
parcelRegister("d2HAR", function(module, exports) {

$parcel$export(module.exports, "AbortController", function () { return $97ed470349dc3f4f$export$48f7e099c149af88; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */ class $97ed470349dc3f4f$export$48f7e099c149af88 {
    constructor(){
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) this.onabort();
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}

});


parcelRegister("jDDGk", function(module, exports) {

$parcel$export(module.exports, "ServerSentEventsTransport", function () { return $e4c070c8c893e6fa$export$f0d4dc62ec317948; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $aEdNZ = parcelRequire("aEdNZ");

var $kNxgN = parcelRequire("kNxgN");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $e4c070c8c893e6fa$export$f0d4dc62ec317948 {
    constructor(httpClient, accessToken, logger, options){
        this._httpClient = httpClient;
        this._accessToken = accessToken;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $1Y1Ki.Arg).isRequired(url, "url");
        (0, $1Y1Ki.Arg).isRequired(transferFormat, "transferFormat");
        (0, $1Y1Ki.Arg).isIn(transferFormat, (0, $kNxgN.TransferFormat), "transferFormat");
        this._logger.log((0, $aEdNZ.LogLevel).Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this._url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessToken) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`;
        return new Promise((resolve, reject)=>{
            let opened = false;
            if (transferFormat !== (0, $kNxgN.TransferFormat).Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if ((0, $1Y1Ki.Platform).isBrowser || (0, $1Y1Ki.Platform).isWebWorker) eventSource = new this._options.EventSource(url, {
                withCredentials: this._options.withCredentials
            });
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, $1Y1Ki.getUserAgentHeader)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, {
                    withCredentials: this._options.withCredentials,
                    headers: {
                        ...headers,
                        ...this._options.headers
                    }
                });
            }
            try {
                eventSource.onmessage = (e)=>{
                    if (this.onreceive) try {
                        this._logger.log((0, $aEdNZ.LogLevel).Trace, `(SSE transport) data received. ${(0, $1Y1Ki.getDataDetail)(e.data, this._options.logMessageContent)}.`);
                        this.onreceive(e.data);
                    } catch (error) {
                        this._close(error);
                        return;
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e)=>{
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) this._close();
                    else reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
                };
                eventSource.onopen = ()=>{
                    this._logger.log((0, $aEdNZ.LogLevel).Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            } catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $1Y1Ki.sendMessage)(this._logger, "SSE", this._httpClient, this._url, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) this.onclose(e);
        }
    }
}

});

parcelRegister("iUZ5u", function(module, exports) {

$parcel$export(module.exports, "WebSocketTransport", function () { return $dc5cd7a850c83100$export$de21836fc42c6f9c; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $8RxDz = parcelRequire("8RxDz");

var $aEdNZ = parcelRequire("aEdNZ");

var $kNxgN = parcelRequire("kNxgN");

var $1Y1Ki = parcelRequire("1Y1Ki");
class $dc5cd7a850c83100$export$de21836fc42c6f9c {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers){
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        (0, $1Y1Ki.Arg).isRequired(url, "url");
        (0, $1Y1Ki.Arg).isRequired(transferFormat, "transferFormat");
        (0, $1Y1Ki.Arg).isIn(transferFormat, (0, $kNxgN.TransferFormat), "transferFormat");
        this._logger.log((0, $aEdNZ.LogLevel).Trace, "(WebSockets transport) Connecting.");
        let token;
        if (this._accessTokenFactory) token = await this._accessTokenFactory();
        return new Promise((resolve, reject)=>{
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if ((0, $1Y1Ki.Platform).isNode || (0, $1Y1Ki.Platform).isReactNative) {
                const headers = {};
                const [name, value] = (0, $1Y1Ki.getUserAgentHeader)();
                headers[name] = value;
                if (token) headers[(0, $8RxDz.HeaderNames).Authorization] = `Bearer ${token}`;
                if (cookies) headers[(0, $8RxDz.HeaderNames).Cookie] = cookies;
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: {
                        ...headers,
                        ...this._headers
                    }
                });
            } else if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
            if (!webSocket) // Chrome is not happy with passing 'undefined' as protocol
            webSocket = new this._webSocketConstructor(url);
            if (transferFormat === (0, $kNxgN.TransferFormat).Binary) webSocket.binaryType = "arraybuffer";
            webSocket.onopen = (_event)=>{
                this._logger.log((0, $aEdNZ.LogLevel).Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event)=>{
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                else error = "There was an error with the transport";
                this._logger.log((0, $aEdNZ.LogLevel).Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message)=>{
                this._logger.log((0, $aEdNZ.LogLevel).Trace, `(WebSockets transport) data received. ${(0, $1Y1Ki.getDataDetail)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) try {
                    this.onreceive(message.data);
                } catch (error) {
                    this._close(error);
                    return;
                }
            };
            webSocket.onclose = (event)=>{
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) this._close(event);
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                    else error = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log((0, $aEdNZ.LogLevel).Trace, `(WebSockets transport) sending data. ${(0, $1Y1Ki.getDataDetail)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = ()=>{};
            this._webSocket.onmessage = ()=>{};
            this._webSocket.onerror = ()=>{};
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log((0, $aEdNZ.LogLevel).Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            else if (event instanceof Error) this.onclose(event);
            else this.onclose();
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}

});


parcelRegister("gLCNp", function(module, exports) {

$parcel$export(module.exports, "JsonHubProtocol", function () { return $c34f21346ffabe9b$export$11f4f8ecec1ad0c8; });
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

var $657oj = parcelRequire("657oj");

var $aEdNZ = parcelRequire("aEdNZ");

var $kNxgN = parcelRequire("kNxgN");

var $5jfsC = parcelRequire("5jfsC");

var $6Ksss = parcelRequire("6Ksss");
const $c34f21346ffabe9b$var$JSON_HUB_PROTOCOL_NAME = "json";
class $c34f21346ffabe9b$export$11f4f8ecec1ad0c8 {
    constructor(){
        /** @inheritDoc */ this.name = $c34f21346ffabe9b$var$JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */ this.version = 2;
        /** @inheritDoc */ this.transferFormat = (0, $kNxgN.TransferFormat).Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */ parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!input) return [];
        if (logger === null) logger = (0, $5jfsC.NullLogger).instance;
        // Parse the messages
        const messages = (0, $6Ksss.TextMessageFormat).parse(input);
        const hubMessages = [];
        for (const message of messages){
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") throw new Error("Invalid payload.");
            switch(parsedMessage.type){
                case (0, $657oj.MessageType).Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case (0, $657oj.MessageType).StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case (0, $657oj.MessageType).Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case (0, $657oj.MessageType).Ping:
                    break;
                case (0, $657oj.MessageType).Close:
                    break;
                case (0, $657oj.MessageType).Ack:
                    this._isAckMessage(parsedMessage);
                    break;
                case (0, $657oj.MessageType).Sequence:
                    this._isSequenceMessage(parsedMessage);
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log((0, $aEdNZ.LogLevel).Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */ writeMessage(message) {
        return (0, $6Ksss.TextMessageFormat).write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) throw new Error("Invalid payload for StreamItem message.");
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) throw new Error("Invalid payload for Completion message.");
        if (!message.result && message.error) this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _isAckMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Ack message.");
    }
    _isSequenceMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Sequence message.");
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") throw new Error(errorMessage);
    }
}

});





parcelRegister("2cGbu", function(module, exports) {

$parcel$export(module.exports, "hierarchyLegacyTagRedirectLoader", function () { return $16996932fdf19b8f$export$e55775b1a1e8d134; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $K53Ru = parcelRequire("K53Ru");

var $4Q81F = parcelRequire("4Q81F");

var $hOl3X = parcelRequire("hOl3X");
const $16996932fdf19b8f$export$e55775b1a1e8d134 = async ({ params: params, request: request })=>{
    const url = new URL(request.url);
    const searchParams = new URLSearchParams(url.search);
    // Build the loader URL depending on which route params are present.
    // Report routes carry studyName + reportName; all other hierarchy routes
    // carry a single hierarchyTag.
    // getHierarchyLoaderUrl now always builds a query-string URL (e.g.,
    // Hierarchy/Loader?hierarchyTag=... or Hierarchy/Loader?studyTag=...&reportName=...),
    // which returns the full HierarchyLoaderReturn including taPrefix / projectCode.
    let loaderUrl;
    if (params.studyName !== undefined && params.reportName !== undefined) loaderUrl = (0, $hOl3X.getHierarchyLoaderUrl)({
        studyTag: params.studyName,
        reportName: params.reportName,
        tocMajorVersion: params.tocMajorVersion
    });
    else if (params.hierarchyTag !== undefined) loaderUrl = (0, $hOl3X.getHierarchyLoaderUrl)({
        hierarchyTag: params.hierarchyTag
    });
    if (loaderUrl !== undefined) {
        const response = await (0, $lCyBC.default).get(loaderUrl);
        /* istanbul ignore else */ if (response?.data?.hierarchy) {
            // Concatenate params.more and the splat wildcard when both are present so
            // that multi-segment deep links (e.g. /TA/CARDIO/Access/Extra) are fully
            // preserved rather than silently truncated to only the first tail segment.
            const trailingPath = params.more !== undefined && params["*"] !== undefined ? `${params.more}/${params["*"]}` : params.more ?? params["*"];
            const newPath = (0, $K53Ru.getHierarchyBaseUrl)(response.data.hierarchy) + (trailingPath !== undefined && trailingPath !== "" ? `/${trailingPath}` : "");
            const redirectTo = new URL(url.origin + newPath);
            redirectTo.search = searchParams.toString();
            return (0, $4Q81F.redirect)(redirectTo.toString());
        }
    }
    return (0, $4Q81F.redirect)("/Corporate");
};

});
parcelRegister("hOl3X", function(module, exports) {

$parcel$export(module.exports, "getHierarchyLoaderUrl", function () { return $96abfaff4ac81c65$export$1b22695b5769746; });
$parcel$export(module.exports, "getHierarchyLoaderData", function () { return $96abfaff4ac81c65$export$a567ee8e80e3e23; });
$parcel$export(module.exports, "hierarchyLoader", function () { return $96abfaff4ac81c65$export$2c5c2c1bafe112f7; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $5hPwN = parcelRequire("5hPwN");

var $a3q4Y = parcelRequire("a3q4Y");

var $kK73x = parcelRequire("kK73x");

var $5BWQf = parcelRequire("5BWQf");

var $2OYvk = parcelRequire("2OYvk");
/**
 * Get the configured backend URL.
 *
 * @returns The backend base URL
 */ const $96abfaff4ac81c65$var$getBackEndUrl = ()=>(0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
let $96abfaff4ac81c65$var$activeClinicalLibraryController;
const $96abfaff4ac81c65$export$1b22695b5769746 = (params)=>{
    const queryParams = new URLSearchParams();
    if (params.primaryHierarchyId) queryParams.set("primaryHierarchyId", params.primaryHierarchyId);
    if (params.hierarchyTag) queryParams.set("hierarchyTag", params.hierarchyTag);
    if (params.taPrefix) queryParams.set("taPrefix", params.taPrefix);
    if (params.projectCode) queryParams.set("projectCode", params.projectCode);
    if (params.studyTag) queryParams.set("studyTag", params.studyTag);
    if (params.reportName) queryParams.set("reportName", params.reportName);
    if (params.tocMajorVersion !== undefined) queryParams.set("tocMajorVersion", params.tocMajorVersion);
    if (queryParams.size === 0) queryParams.set("hierarchyTag", "Corporate");
    return `${$96abfaff4ac81c65$var$getBackEndUrl()}Hierarchy/Loader?${queryParams.toString()}`;
};
const $96abfaff4ac81c65$export$a567ee8e80e3e23 = async (params, signal)=>{
    const hierarchyResponse = await (0, $lCyBC.default).get($96abfaff4ac81c65$export$1b22695b5769746(params), {
        signal: signal
    });
    if (!hierarchyResponse.data?.hierarchy) throw new Error("Invalid response from HierarchyLoader, no data returned");
    const { hierarchy: hierarchy, parentHierarchies: parentHierarchies, accessRights: accessRights } = hierarchyResponse.data;
    const subscriptionStatusLoader = await (0, $5BWQf.getSubscriptionStatusLoaderData)({
        params: {
            entityType: "Hierarchy",
            entityId: hierarchy.id
        }
    });
    /*
   * The previous Clinical Library request belongs to the previous
   * hierarchy navigation and is no longer required.
   */ $96abfaff4ac81c65$var$activeClinicalLibraryController?.abort();
    $96abfaff4ac81c65$var$activeClinicalLibraryController = undefined;
    const clinicalLibraryHierarchyIds = (0, $a3q4Y.getClinicalLibraryHierarchyIds)(hierarchy, hierarchy.id);
    let clinicalLibraryPromise;
    /* istanbul ignore else */ if (clinicalLibraryHierarchyIds.length > 0) {
        const controller = new AbortController();
        $96abfaff4ac81c65$var$activeClinicalLibraryController = controller;
        clinicalLibraryPromise = (0, $2OYvk.getLibraries)($96abfaff4ac81c65$var$getBackEndUrl(), clinicalLibraryHierarchyIds, controller).finally(()=>{
            /*
       * Only clear the active controller if this is still the latest
       * Clinical Library request.
       */ if ($96abfaff4ac81c65$var$activeClinicalLibraryController === controller) $96abfaff4ac81c65$var$activeClinicalLibraryController = undefined;
        });
    }
    return {
        hierarchy: hierarchy,
        parentHierarchies: parentHierarchies,
        accessRights: accessRights,
        isHierarchySubscribed: subscriptionStatusLoader.isSubscribed,
        clinicalLibraryPromise: clinicalLibraryPromise
    };
};
const $96abfaff4ac81c65$export$2c5c2c1bafe112f7 = async ({ params: params, request: request })=>$96abfaff4ac81c65$export$a567ee8e80e3e23(params, request.signal);

});
parcelRegister("a3q4Y", function(module, exports) {

$parcel$export(module.exports, "getClinicalLibraryHierarchyIds", function () { return $eb30d44eac1cdbcb$export$a538615567ac0ffe; });

var $4lHS7 = parcelRequire("4lHS7");
const $eb30d44eac1cdbcb$export$a538615567ac0ffe = (hierarchy, hierarchyId)=>!hierarchy ? [] : hierarchy.level === (0, $4lHS7.eHierarchyLevel).Study ? [
        hierarchy.id
    ] : hierarchy.level === (0, $4lHS7.eHierarchyLevel).Report ? [
        hierarchy.hierarchyLinks.find((link)=>link.hierarchyLevel === (0, $4lHS7.eHierarchyLevel).Study)?.hierarchyId ?? hierarchy.id
    ] : Array.from(new Set([
        hierarchyId,
        ...hierarchy.hierarchyLinks.filter((link)=>link.hierarchyLevel !== (0, $4lHS7.eHierarchyLevel).TopLevel).map((link)=>link.hierarchyId)
    ]));

});

parcelRegister("5BWQf", function(module, exports) {

$parcel$export(module.exports, "getSubscriptionStatusLoaderData", function () { return $f046775901cb626d$export$e4de5290d9ba3c03; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $5hPwN = parcelRequire("5hPwN");

var $eBlbF = parcelRequire("eBlbF");

var $kK73x = parcelRequire("kK73x");
/**
 * Constructs the subscription status URL based on the entity type and ID.
 *
 * @param entityType - The type of the entity (e.g., "TlfItem", "Hierarchy").
 * @param entityId - The unique identifier of the entity.
 * @returns The constructed subscription status URL.
 */ const $f046775901cb626d$var$getSubscriptionUrl = (entityType, entityId)=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    return `${backEndUrl}Comments/${entityType}/${entityId}/GetSubscriptionStatus`;
};
const $f046775901cb626d$export$e4de5290d9ba3c03 = async ({ params: params })=>{
    const subscriptionStatusLoaderData = await (0, $lCyBC.default).get($f046775901cb626d$var$getSubscriptionUrl(params.entityType, params.entityId));
    if (!subscriptionStatusLoaderData || subscriptionStatusLoaderData.data === undefined || !(0, $eBlbF.isBoolean)(subscriptionStatusLoaderData.data)) throw new Error("Invalid or No response from SubscriptionStatus Loader");
    return {
        isSubscribed: subscriptionStatusLoaderData.data
    };
};

});

parcelRegister("2OYvk", function(module, exports) {

$parcel$export(module.exports, "getLibraries", function () { return $53353a0d08b6d33d$export$4df02d1b89e14240; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $53353a0d08b6d33d$export$4df02d1b89e14240 = async (backEndUrl, hierarchyIds, controller)=>{
    const url = new URL(`${backEndUrl}ClinicalLibrary/batch`);
    try {
        hierarchyIds.forEach((hierarchyId)=>{
            url.searchParams.append("hierarchyIds", hierarchyId);
        });
        const response = await (0, $lCyBC.default).get(url.href, {
            signal: controller?.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("get libraries failed", error);
    }
};

});



parcelRegister("4RsO4", function(module, exports) {

$parcel$export(module.exports, "hierarchyRedirectLoader", function () { return $4b9d702078fd3a79$export$479e664e1298840b; });

var $5hPwN = parcelRequire("5hPwN");

var $K53Ru = parcelRequire("K53Ru");

var $4Q81F = parcelRequire("4Q81F");

var $kK73x = parcelRequire("kK73x");

var $cHpYl = parcelRequire("cHpYl");
const $4b9d702078fd3a79$export$479e664e1298840b = async ({ params: params, request: request })=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    const hierarchyId = params.hierarchyId;
    const url = new URL(request.url);
    const searchParams = new URLSearchParams(url.search);
    /* istanbul ignore else */ if (hierarchyId !== undefined) {
        const hierarchyRequest = await (0, $cHpYl.loadHierarchy)(backEndUrl, {
            hierarchyId: hierarchyId
        });
        /* istanbul ignore else */ if (hierarchyRequest.success && hierarchyRequest.data) {
            const redirectTo = new URL(url.origin + (0, $K53Ru.getHierarchyBaseUrl)(hierarchyRequest.data) + (params.more !== undefined ? `/${params.more}` : ""));
            /* istanbul ignore else */ if (searchParams !== undefined) redirectTo.search = searchParams.toString();
            return (0, $4Q81F.redirect)(redirectTo.toString());
        }
    }
    return (0, $4Q81F.redirect)("/Corporate");
};

});
parcelRegister("cHpYl", function(module, exports) {

$parcel$export(module.exports, "loadHierarchy", function () { return $3a744a911cdf586e$export$73f90be9b2bf9d68; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $3a744a911cdf586e$export$73f90be9b2bf9d68 = async (backEndUrl, hierarchyQuery, controller)=>{
    let url = hierarchyQuery.hierarchyName ? `${backEndUrl}Hierarchy/Name/${hierarchyQuery.hierarchyName}` : `${backEndUrl}Hierarchy/Id/${hierarchyQuery.hierarchyId}`;
    if (hierarchyQuery.parentTag) url += `?parentTag=${hierarchyQuery.parentTag}`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load hierarchy failed", error);
    }
};

});


parcelRegister("7aR3H", function(module, exports) {

$parcel$export(module.exports, "newTlfLoader", function () { return $1f90a43af46b0a59$export$f6716b75c06b3864; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $5hPwN = parcelRequire("5hPwN");

var $4Q81F = parcelRequire("4Q81F");

var $kK73x = parcelRequire("kK73x");

var $hOl3X = parcelRequire("hOl3X");

var $fDwgE = parcelRequire("fDwgE");
const $1f90a43af46b0a59$export$f6716b75c06b3864 = async ({ params: params })=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    if (!params.newType) return (0, $4Q81F.redirect)("/NotFound");
    const requests = await Promise.all([
        (0, $lCyBC.default).get(`${backEndUrl}NewTlfItems/${params.newType}`),
        (0, $hOl3X.getHierarchyLoaderData)(params)
    ]);
    const newTlfItem = requests[0]?.data;
    const hierarchyLoader = requests[1];
    if (!newTlfItem || !hierarchyLoader.hierarchy) return (0, $4Q81F.redirect)("/NotFound");
    newTlfItem.azsolId = "";
    newTlfItem.primaryHierarchyId = hierarchyLoader.hierarchy.id;
    newTlfItem.primaryHierarchyName = hierarchyLoader.hierarchy.name;
    newTlfItem.primaryHierarchyLevel = hierarchyLoader.hierarchy.level;
    newTlfItem.primaryHierarchyType = hierarchyLoader.hierarchy.type;
    newTlfItem.id = params.newType;
    // Ensure columnIds and columnInformation for new TLF items
    /* istanbul ignore else */ if ("bodyData" in newTlfItem.body && "headerData" in newTlfItem.body) newTlfItem.body = (0, $fDwgE.addColumnInformation)(newTlfItem.body);
    const ret = {
        ...hierarchyLoader,
        tlfItem: newTlfItem,
        isTlfSubscribed: false,
        isTlfNew: true
    };
    return ret;
};

});
parcelRegister("fDwgE", function(module, exports) {

$parcel$export(module.exports, "addColumnInformation", function () { return $5e539790139301e0$export$dc3d3c973936c665; });

var $b6GOr = parcelRequire("b6GOr");

var $3Dlu6 = parcelRequire("3Dlu6");
const $5e539790139301e0$export$dc3d3c973936c665 = (body)=>{
    // Generate columnIds from the body
    const columnIds = (0, $3Dlu6.generateColumnIds)(body);
    // If no columns detected, return body with empty columnInformation
    if (columnIds.length === 0) return {
        ...body,
        columnInformation: []
    };
    // Only generate columnInformation if empty or mismatched
    const columnInformation = body.columnInformation && body.columnInformation.length > 0 && columnIds.length === body.columnInformation.length ? body.columnInformation : columnIds.map((columnId, index)=>({
            columnId: columnId,
            originalColumnIndex: index
        }));
    // Check if columnIds already exist on the cells
    const hasExistingColumnIds = body.headerData && typeof body.headerData === "object" && "rows" in body.headerData && Array.isArray(body.headerData.rows) && body.headerData.rows.length > 0 && "cells" in body.headerData.rows[0] && Array.isArray(body.headerData.rows[0].cells) && body.headerData.rows[0].cells.every((cell)=>cell.columnId && cell.columnId !== "") || body.bodyData && Array.isArray(body.bodyData) && body.bodyData.length > 0 && body.bodyData[0].rows.length > 0 && "cells" in body.bodyData[0].rows[0] && Array.isArray(body.bodyData[0].rows[0].cells) && body.bodyData[0].rows[0].cells.every((cell)=>cell.columnId && cell.columnId !== "");
    // If columnIds don't exist, assign them to cells
    if (!hasExistingColumnIds) {
        const bodyWithColumnIds = {
            ...body
        };
        // Assign columnIds to header and body cells
        (0, $b6GOr.assignColumnIdsToCells)(bodyWithColumnIds, columnIds);
        return {
            ...bodyWithColumnIds,
            columnInformation: columnInformation
        };
    }
    // ColumnIds exist, just ensure columnInformation is present
    return {
        ...body,
        columnInformation: columnInformation
    };
};

});
parcelRegister("b6GOr", function(module, exports) {

$parcel$export(module.exports, "assignColumnIdsToCells", function () { return $0a76d8f3635be79b$export$80aaca323a4572d0; });
/**
 * Assigns columnIds to header and body cells in a table body structure.
 * This function mutates the provided body object by assigning columnIds to all cells
 * based on their column position (index within each row).
 *
 * @param body - The table body containing headerData and bodyData
 * @param body.headerData - Optional header data with rows and cells
 * @param body.bodyData - Array of body groups, each with rows and cells
 * @param columnIds - Array of columnIds to assign (one per column)
 */ const $0a76d8f3635be79b$export$80aaca323a4572d0 = (body, columnIds)=>{
    if (!body.bodyData || body.bodyData.length < 1 || body.bodyData[0].rows.length < 1 || body.bodyData[0].rows[0].cells.length !== columnIds.length || columnIds.some((id)=>!id)) throw new Error(`Bad columnIds array provided`);
    // Assign columnIds to header cells if header exists
    if (body.headerData && typeof body.headerData === "object" && "rows" in body.headerData) body.headerData.rows = body.headerData.rows.map((row)=>({
            ...row,
            cells: row.cells.map((cell, index)=>({
                    ...cell,
                    columnId: columnIds[index]
                }))
        }));
    // Assign columnIds to body cells
    /* istanbul ignore else */ if (body.bodyData && Array.isArray(body.bodyData)) body.bodyData = body.bodyData.map((group)=>({
            ...group,
            rows: group.rows.map((row)=>({
                    ...row,
                    cells: row.cells.map((cell, index)=>({
                            ...cell,
                            columnId: columnIds[index]
                        }))
                }))
        }));
};

});

parcelRegister("3Dlu6", function(module, exports) {

$parcel$export(module.exports, "generateColumnIds", function () { return $d6bfaf3889af2d42$export$606f894fac65fbb3; });
const $d6bfaf3889af2d42$export$606f894fac65fbb3 = (tableData)=>{
    // Try to get column count and existing columnIds from header first
    if (tableData.headerData && typeof tableData.headerData === "object" && "rows" in tableData.headerData && Array.isArray(tableData.headerData.rows) && tableData.headerData.rows.length > 0) {
        const firstRow = tableData.headerData.rows[0];
        /* istanbul ignore else */ if ("cells" in firstRow && Array.isArray(firstRow.cells)) return firstRow.cells.map((cell)=>cell.columnId && cell.columnId !== "" ? cell.columnId : crypto.randomUUID());
    } else if (tableData.bodyData && Array.isArray(tableData.bodyData) && tableData.bodyData.length > 0 && tableData.bodyData[0].rows.length > 0) {
        const firstRow = tableData.bodyData[0].rows[0];
        /* istanbul ignore else */ if ("cells" in firstRow && Array.isArray(firstRow.cells)) return firstRow.cells.map((cell)=>cell.columnId && cell.columnId !== "" ? cell.columnId : crypto.randomUUID());
    }
    // Return empty array if no columns exist
    return [];
};

});



parcelRegister("4PTsY", function(module, exports) {

$parcel$export(module.exports, "tlfLoader", function () { return $b21e7aaaeedf1c92$export$99dd3289769a705a; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $5hPwN = parcelRequire("5hPwN");

var $kK73x = parcelRequire("kK73x");

var $5BWQf = parcelRequire("5BWQf");

var $4lHS7 = parcelRequire("4lHS7");

var $hOl3X = parcelRequire("hOl3X");

var $3UQIM = parcelRequire("3UQIM");

var $8Shut = parcelRequire("8Shut");
const $b21e7aaaeedf1c92$export$c1efadf725f85a8 = (params)=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    return params.azsolId !== undefined && params.version !== undefined ? `${backEndUrl}TlfItems/${params.azsolId}/${params.version}` : params.studyTag && params.reportName && params.tocNumber ? `${backEndUrl}TlfItems/${params.studyTag}/${params.reportName}/${params.tocNumber}${params.tocMajorVersion ? `?version=${params.tocMajorVersion}` : ""}` : params.id ? `${backEndUrl}TlfItems/${params.id}` : null;
};
const $b21e7aaaeedf1c92$export$5ea2b17da505df9b = async (params)=>{
    const url = $b21e7aaaeedf1c92$export$c1efadf725f85a8(params);
    if (!url) return {
        tlfItem: undefined,
        isTlfSubscribed: false,
        isTlfNew: false
    };
    const tlfLoaderData = (await (0, $lCyBC.default).get(url)).data;
    const subscriptionStatusLoaderData = tlfLoaderData ? await (0, $5BWQf.getSubscriptionStatusLoaderData)({
        params: {
            entityType: "TlfItem",
            entityId: tlfLoaderData.id
        }
    }) : undefined;
    const ret = {
        tlfItem: tlfLoaderData !== undefined ? (0, $8Shut.tlfPreProcess)(tlfLoaderData) : undefined,
        isTlfSubscribed: subscriptionStatusLoaderData?.isSubscribed ?? false,
        isTlfNew: false
    };
    return ret;
};
const $b21e7aaaeedf1c92$export$99dd3289769a705a = async ({ params: params, request: request })=>{
    const hierarchyLoader = (0, $hOl3X.getHierarchyLoaderData)(params, request.signal);
    const thisTlfLoader = $b21e7aaaeedf1c92$export$5ea2b17da505df9b(params);
    const [tlfLoaderData, hierarchyLoaderData] = await Promise.all([
        thisTlfLoader,
        hierarchyLoader
    ]);
    // Hydrate ARS items into ArsTable
    if (tlfLoaderData.tlfItem?.type === (0, $4lHS7.eTlfItemType).arsTable) (0, $3UQIM.hydrateArsTableBody)([
        hierarchyLoaderData.hierarchy,
        ...hierarchyLoaderData.parentHierarchies
    ], tlfLoaderData.tlfItem);
    return {
        ...hierarchyLoaderData,
        ...tlfLoaderData
    };
};

});
parcelRegister("8Shut", function(module, exports) {

$parcel$export(module.exports, "tlfPreProcess", function () { return $da4a6d9f22a950ac$export$699823975d605571; });

var $bX0x9 = parcelRequire("bX0x9");

var $4lHS7 = parcelRequire("4lHS7");

var $ipFhE = parcelRequire("ipFhE");

var $3Dlu6 = parcelRequire("3Dlu6");

var $i1ZDI = parcelRequire("i1ZDI");

var $gNdEC = parcelRequire("gNdEC");
const $da4a6d9f22a950ac$export$699823975d605571 = (tlf)=>{
    if (tlf.type === (0, $4lHS7.eTlfItemType).table || tlf.type === (0, $4lHS7.eTlfItemType).listing) {
        // Generate columnIds once and use for both header and body
        const columnIds = (0, $3Dlu6.generateColumnIds)(tlf.body);
        // Generate columnInformation if empty
        const columnInformation = tlf.body.columnInformation && tlf.body.columnInformation.length > 0 && columnIds.length === tlf.body.columnInformation.length ? tlf.body.columnInformation : columnIds.map((columnId, index)=>({
                columnId: columnId,
                originalColumnIndex: index
            }));
        const headerData = (0, $gNdEC.headerPreProcess)(60, (0, $bX0x9.stringToV3)(""), columnIds, (0, $i1ZDI.handleCellText)(tlf.body.headerData));
        const bodyData = (0, $ipFhE.bodyPreProcess)(60, (0, $bX0x9.stringToV3)(""), columnIds, (0, $i1ZDI.handleCellText)(tlf.body.bodyData));
        return {
            ...tlf,
            body: {
                ...tlf.body,
                columnInformation: columnInformation,
                headerData: headerData,
                bodyData: bodyData
            }
        };
    } else return tlf;
};

});
parcelRegister("ipFhE", function(module, exports) {

$parcel$export(module.exports, "bodyPreProcess", function () { return $56c545e6f2b3a806$export$d09f1d3f3e5e9255; });

var $fS6I7 = parcelRequire("fS6I7");
const $56c545e6f2b3a806$export$d09f1d3f3e5e9255 = (defaultCellWidth, blank, columnIds, rgs)=>{
    return (rgs ?? []).map((rg)=>{
        return {
            ...rg,
            rows: (0, $fS6I7.rowPreProcess)(defaultCellWidth, blank, columnIds, rg.rows),
            aitid: rg.aitid ?? crypto.randomUUID()
        };
    });
};

});
parcelRegister("fS6I7", function(module, exports) {

$parcel$export(module.exports, "rowPreProcess", function () { return $b7e187d86fc93041$export$19762d706eaf2a12; });
parcelRequire("6jtLO");
var $6GMBM = parcelRequire("6GMBM");

var $3VgEv = parcelRequire("3VgEv");
const $b7e187d86fc93041$export$19762d706eaf2a12 = (defaultCellWidth, blank, columnIds, rs)=>{
    // Return an empty row if there is nothing
    if (rs === undefined) return [
        (0, $6GMBM.newRow)(defaultCellWidth, blank, 0, [])
    ];
    // Check aitid
    return rs.map((r)=>({
            ...r,
            cells: (0, $3VgEv.cellPreProcess)(defaultCellWidth, blank, columnIds, r.cells),
            aitid: r.aitid ?? crypto.randomUUID(),
            rowRepeat: undefined
        }));
};

});
parcelRegister("3VgEv", function(module, exports) {

$parcel$export(module.exports, "cellPreProcess", function () { return $e78bb24b2a46935a$export$ed34dd7e0f89bb75; });
parcelRequire("6jtLO");
var $l6aIi = parcelRequire("l6aIi");
const $e78bb24b2a46935a$export$ed34dd7e0f89bb75 = (defaultCellWidth, blank, columnIds, cs)=>{
    if (cs === undefined) {
        if (!columnIds || columnIds.length === 0) throw new Error("cellPreProcess: no column Id defined for the cell");
        const columnId = columnIds[0];
        return [
            (0, $l6aIi.newCell)(defaultCellWidth, blank, columnId)
        ];
    }
    // Check aitid and columnId
    return cs.map((c, index)=>{
        // Use provided columnId if available, otherwise use existing columnId, or generate new one
        const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
        return {
            aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            colWidth: c.colWidth ?? defaultCellWidth,
            textIndents: c.textIndents,
            replacedText: undefined,
            spaceAfterRepeat: undefined,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: columnId
        };
    });
};

});



parcelRegister("i1ZDI", function(module, exports) {

$parcel$export(module.exports, "handleCellText", function () { return $cd32b764f0cfb87c$export$b1a4e7cadaf459ae; });

var $bX0x9 = parcelRequire("bX0x9");
/**
 * Ensure an editor input has at least one text block and normalised lines.
 *
 * @param input - Optional editor input
 * @returns Normalised IEditorV3 instance
 */ function $cd32b764f0cfb87c$var$processInput(input) {
    if (!input) return (0, $bX0x9.stringToV3)("");
    input.lines = !input.lines || input.lines.length === 0 ? [
        {
            textBlocks: [
                {
                    text: "",
                    type: "text"
                }
            ]
        }
    ] : input.lines.filter((line, ix)=>ix === 0 && input.lines.every((l)=>!l.textBlocks || l.textBlocks.length === 0) || line.textBlocks && line.textBlocks.length > 0).map((line)=>{
        if (line.textBlocks.length === 0) line.textBlocks.push({
            text: "",
            type: "text"
        });
        return line;
    });
    return input;
}
/**
 * Process text for an array of cells.
 *
 * @param cells - Cells to process
 * @returns Cells with normalised text content
 */ const $cd32b764f0cfb87c$var$processCellsText = (cells)=>cells.map((cell)=>({
            ...cell,
            text: $cd32b764f0cfb87c$var$processInput(cell.text)
        }));
function $cd32b764f0cfb87c$export$b1a4e7cadaf459ae(body) {
    if (body === null || body === undefined || typeof body !== "object") return body;
    const obj = body;
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        // Update cells text
        if (key === "cells") obj[key] = $cd32b764f0cfb87c$var$processCellsText(value);
        else if (key === "comments" && typeof value === "object" && value !== null && "lines" in value) obj[key] = $cd32b764f0cfb87c$var$processInput(value);
        else if (value && typeof value === "object") obj[key] = $cd32b764f0cfb87c$export$b1a4e7cadaf459ae(value);
    });
    return body;
}

});

parcelRegister("gNdEC", function(module, exports) {

$parcel$export(module.exports, "headerPreProcess", function () { return $193fccae2344492c$export$86ad0a71dced94ac; });

var $5a8MT = parcelRequire("5a8MT");
const $193fccae2344492c$export$86ad0a71dced94ac = (defaultCellWidth, blank, columnIds, rg)=>{
    if (rg === undefined) return {
        aitid: crypto.randomUUID(),
        rows: [],
        coreTrafficLight: "BlankNotEvaluated"
    };
    if (rg === false) return false;
    return {
        ...rg,
        rows: (0, $5a8MT.headerRowPreProcess)(defaultCellWidth, blank, columnIds, rg.rows),
        aitid: rg.aitid ?? crypto.randomUUID()
    };
};

});
parcelRegister("5a8MT", function(module, exports) {

$parcel$export(module.exports, "headerRowPreProcess", function () { return $ce969bcf63a1a7ae$export$8b2bff07d93d8652; });
parcelRequire("6jtLO");
var $6GMBM = parcelRequire("6GMBM");

var $ezXoa = parcelRequire("ezXoa");
const $ce969bcf63a1a7ae$export$8b2bff07d93d8652 = (defaultCellWidth, blank, columnIds, rs)=>{
    // Return an empty row if there is nothing
    if (rs === undefined) return [
        (0, $6GMBM.newHeaderRow)(defaultCellWidth, blank, 0, [])
    ];
    // Check aitid
    return rs.map((r)=>({
            ...r,
            cells: (0, $ezXoa.headerCellPreProcess)(defaultCellWidth, blank, columnIds, r.cells),
            aitid: r.aitid ?? crypto.randomUUID(),
            spaceAfter: r.spaceAfter ?? false,
            rowRepeat: undefined
        }));
};

});
parcelRegister("ezXoa", function(module, exports) {

$parcel$export(module.exports, "headerCellPreProcess", function () { return $1696f8358462a51b$export$97b9976bb98eb3da; });
parcelRequire("6jtLO");
var $l6aIi = parcelRequire("l6aIi");
const $1696f8358462a51b$export$97b9976bb98eb3da = (defaultCellWidth, blank, columnIds, cs)=>{
    if (cs === undefined) {
        const columnId = columnIds && columnIds.length > 0 ? columnIds[0] : crypto.randomUUID();
        return [
            (0, $l6aIi.newHeaderCell)(defaultCellWidth, blank, columnId)
        ];
    }
    // Check aitid and columnId and ensure defaults where necessary
    return cs.map((c, index)=>{
        // Use provided columnId if available, otherwise use existing columnId
        const columnId = columnIds && columnIds.length > index ? columnIds[index] : c.columnId;
        return {
            aitid: c.aitid && c.aitid.length > 4 ? c.aitid : crypto.randomUUID(),
            text: c.text,
            justifyText: c.justifyText,
            comments: c.comments,
            colWidth: c.colWidth ?? defaultCellWidth,
            textIndents: c.textIndents,
            replacedText: undefined,
            repeatRowSpan: undefined,
            spaceAfterRepeat: undefined,
            spaceAfterSpan: undefined,
            colSpan: c.colSpan ?? 1,
            rowSpan: c.rowSpan ?? 1,
            repeatColSpan: undefined,
            coreTrafficLight: c.coreTrafficLight,
            templateAitId: c.templateAitId,
            templateColumnAitId: c.templateColumnAitId,
            columnId: columnId
        };
    });
};

});





parcelRegister("4m8te", function(module, exports) {

$parcel$export(module.exports, "tlfRedirectLoader", function () { return $a38a24c9835446f9$export$f461775690242f9d; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $5hPwN = parcelRequire("5hPwN");

var $4CKH9 = parcelRequire("4CKH9");

var $i3pdF = parcelRequire("i3pdF");

var $4Q81F = parcelRequire("4Q81F");

var $kK73x = parcelRequire("kK73x");

var $cHpYl = parcelRequire("cHpYl");
const $a38a24c9835446f9$export$f461775690242f9d = async ({ params: params, request: request })=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    const url = params.id ? `${backEndUrl}TlfItems/ById/${params.id}${params.azsolId && (0, $i3pdF.isValidUriString)(params.azsolId) ? `/${params.azsolId}` : ""}` : params.azsolId !== undefined && params.version !== undefined ? `${backEndUrl}TlfItems/${params.azsolId}/${params.version}` : undefined;
    if (url) {
        // Get TLF item
        const tlfLoader = await (0, $lCyBC.default).get(url);
        const tlfItem = tlfLoader.data;
        /* istanbul ignore else */ if (tlfItem?.primaryHierarchyId !== undefined) {
            // Get Hierarchy
            const hierarchyRequest = await (0, $cHpYl.loadHierarchy)(backEndUrl, {
                hierarchyId: tlfItem.primaryHierarchyId
            });
            // Redirect
            /* istanbul ignore else */ if (hierarchyRequest.success) {
                const requestUrl = new URL(request.url);
                const redirectTo = requestUrl.origin + `${(0, $4CKH9.getTlfUrl)(hierarchyRequest.data, tlfItem)}`;
                const redirectUrl = new URL(redirectTo);
                // Add search params if available
                const searchParams = new URLSearchParams(requestUrl.search);
                /* istanbul ignore else */ if (searchParams !== undefined) redirectUrl.search = searchParams.toString();
                return (0, $4Q81F.redirect)(redirectUrl.toString());
            }
        }
    }
    return (0, $4Q81F.redirect)("/NotFound");
};

});
parcelRegister("i3pdF", function(module, exports) {

$parcel$export(module.exports, "isValidUriString", function () { return $5b27e64a95ba869a$export$87c852e82b53e1d5; });
/**
 * Validates if a string is a valid URI string.
 *
 * @param azsolId - The AZSOL identifier string to validate as a valid URI
 * @returns boolean
 */ const $5b27e64a95ba869a$export$87c852e82b53e1d5 = (azsolId)=>{
    // Check that the given azsolId or any sring that is passed is URI compatible
    // Should only alphanumeric characters, spaces, underscores, and hyphens
    const validPattern = /^[a-zA-Z0-9 _-]+$/;
    return validPattern.test(azsolId);
};

});


parcelRegister("bYupS", function(module, exports) {

$parcel$export(module.exports, "appSettingsLoader", function () { return $ad543918a5078da1$export$db14d4734a3bb44b; });

var $5hPwN = parcelRequire("5hPwN");

var $kK73x = parcelRequire("kK73x");

var $7xksm = parcelRequire("7xksm");

var $hGl6I = parcelRequire("hGl6I");

var $g5XB0 = parcelRequire("g5XB0");

var $k3SuE = parcelRequire("k3SuE");

var $8sSl0 = parcelRequire("8sSl0");

var $c6H5i = parcelRequire("c6H5i");

var $8VrYk = parcelRequire("8VrYk");

var $36vnH = parcelRequire("36vnH");
const $ad543918a5078da1$export$db14d4734a3bb44b = async ()=>{
    const backEndUrl = (0, $kK73x.REACT_APP_BACKENDURL).includes("_REACT_APP_BACKENDURL_") ? (0, $5hPwN.defaultSettings).backEndUrl : (0, $kK73x.REACT_APP_BACKENDURL);
    const me = (0, $36vnH.getMe)(backEndUrl);
    const crystalUrl = (0, $kK73x.REACT_APP_CRYSTALURL).includes("_REACT_APP_CRYSTALURL_") ? (0, $5hPwN.defaultSettings).crystalUrl : (0, $kK73x.REACT_APP_CRYSTALURL);
    const backEndVersion = (0, $k3SuE.getBackEndVersion)(backEndUrl);
    const maintenanceMode = (0, $7xksm.loadMaintenanceMode)(backEndUrl);
    const helpLinks = (0, $8sSl0.loadHelpLinks)(backEndUrl);
    const styles = (0, $8VrYk.getAllStyles)(backEndUrl);
    const annotationComparatorTypes = (0, $hGl6I.getComparatorTypes)(backEndUrl);
    const figureSettings = (0, $g5XB0.getFigureTypeOptions)(backEndUrl);
    const allowedReportTypes = (0, $c6H5i.getReportTypes)(backEndUrl, null);
    const request = await Promise.all([
        me,
        backEndVersion,
        maintenanceMode,
        helpLinks,
        styles,
        annotationComparatorTypes,
        figureSettings,
        allowedReportTypes
    ]);
    if (request.some((r)=>r.success === false)) throw new Error("App settings loader failed");
    const ret = {
        allowedReportTypes: request[7].data,
        backEndUrl: backEndUrl,
        crystalUrl: crystalUrl,
        me: request[0].data,
        backEndVersion: request[1].data,
        maintenanceMode: request[2].data,
        helpLinks: request[3].data,
        styles: request[4].data,
        annotationComparatorTypes: request[5].data,
        figureSettings: request[6].data
    };
    return ret;
};

});
parcelRegister("7xksm", function(module, exports) {

$parcel$export(module.exports, "loadMaintenanceMode", function () { return $faa8b13e445fcabb$export$c7d7d8f442777898; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $faa8b13e445fcabb$export$c7d7d8f442777898 = async (backEndUrl, _, controller)=>{
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Settings/MaintenanceMode`, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: {
                maintenanceMode: response.data.value !== "",
                maintenanceMessage: response.data.value
            }
        };
    } catch (error) {
        // Handle if no setting exists yet
        if (error.response?.status === 404) return {
            success: true,
            data: {
                maintenanceMode: false
            }
        };
        return (0, $4xeqQ.processAxiosError)("Load Maintenance Mode failed", error);
    }
};

});

parcelRegister("hGl6I", function(module, exports) {

$parcel$export(module.exports, "getComparatorTypes", function () { return $d5c617a056943318$export$7046b8b657e89481; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $d5c617a056943318$export$7046b8b657e89481 = async (backEndUrl)=>{
    const url = `${backEndUrl}Annotations/Comparators`;
    try {
        const response = await (0, $lCyBC.default).get(url);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load comparator types failed", error);
    }
};

});

parcelRegister("g5XB0", function(module, exports) {

$parcel$export(module.exports, "getFigureTypeOptions", function () { return $ef8472ce4c5b9c20$export$63c537751473bff1; });
parcelRequire("6jtLO");
var $kTXvy = parcelRequire("kTXvy");
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ef8472ce4c5b9c20$export$63c537751473bff1 = async (backEndUrl)=>{
    const url = `${backEndUrl}Settings/figureTypeOptions`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url);
        const returnedObject = JSON.parse(response.data.value);
        // Validate returned data
        if (!(0, $kTXvy.isFigureSettingsDto)(returnedObject)) {
            console.error("getFigureTypeOptions: returnedObject failed isFigureSettingsDto check");
            return {
                success: false,
                errorText: "Load figure type options failed: invalid data format"
            };
        }
        const returnedFigureSettings = returnedObject;
        // Return successful result
        return {
            success: true,
            data: returnedFigureSettings
        };
    } catch (error) {
        console.debug("getFigureTypeOptions: caught error", error);
        return (0, $4xeqQ.processAxiosError)("Load figure type options failed", error);
    }
};

});

parcelRegister("k3SuE", function(module, exports) {

$parcel$export(module.exports, "getBackEndVersion", function () { return $a040431d0994237c$export$9db84f9861043ae; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $a040431d0994237c$export$9db84f9861043ae = async (backEndUrl, _, controller)=>{
    const url = `${backEndUrl}Version`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: `mbbe ${response.data.backendVersion}`
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load back end version failed", error);
    }
};

});

parcelRegister("8sSl0", function(module, exports) {

$parcel$export(module.exports, "loadHelpLinks", function () { return $04439a378aff1a79$export$cc3035ff1a2ee2c6; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $04439a378aff1a79$export$cc3035ff1a2ee2c6 = async (backEndUrl)=>{
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Settings/HelpLinks`);
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value)
        };
    } catch (error) {
        // Handle if no setting exists yet
        if (error.response?.status === 404) return {
            success: true,
            data: []
        };
        return (0, $4xeqQ.processAxiosError)("Load help links failed", error);
    }
};

});

parcelRegister("c6H5i", function(module, exports) {

$parcel$export(module.exports, "getReportTypes", function () { return $72c0f3c0ad970509$export$79b431954e55b5e; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $72c0f3c0ad970509$export$79b431954e55b5e = async (backEndUrl, _, controller)=>{
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Hierarchy/ReportTypes`, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Failed to retrieve report types", error);
    }
};

});

parcelRegister("36vnH", function(module, exports) {

$parcel$export(module.exports, "getMe", function () { return $506aca9215ed2e51$export$dd7946daa6163e94; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $506aca9215ed2e51$export$dd7946daa6163e94 = async (backEndUrl)=>{
    const url = `${backEndUrl}Users/Me`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url);
        // Return successful result
        return {
            success: true,
            data: {
                userId: response.data.userId,
                isAdmin: response.data.isAdmin,
                applicationPermissions: response.data.applicationPermissions
            }
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load me failed", error);
    }
};

});


parcelRegister("hJxsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c52273a3a8fe37e6$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $6iYEs = parcelRequire("6iYEs");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");
const $c52273a3a8fe37e6$export$6395761c98695de7 = ()=>{
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("redirecting-page");
    (0, $spJKX.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                className: "d-flex justify-content-center",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    style: {
                        paddingTop: "4rem"
                    },
                    children: "Redirecting..."
                })
            })
        })
    });
};
$c52273a3a8fe37e6$export$6395761c98695de7.displayName = "RedirectingPage";
var $c52273a3a8fe37e6$export$2e2bcd8739ae039 = $c52273a3a8fe37e6$export$6395761c98695de7;

});

parcelRegister("34RgW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8ede97088646b78$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $i1Ydm = parcelRequire("i1Ydm");

var $dVR7M = parcelRequire("dVR7M");

var $lE7gc = parcelRequire("lE7gc");

var $6iYEs = parcelRequire("6iYEs");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");
const $b8ede97088646b78$export$41ce7963b9cec023 = ()=>{
    const error = (0, $4Q81F.useRouteError)();
    const errorString = JSON.stringify(error?.message ?? error, undefined, 2);
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("router-error-boundary");
    (0, $spJKX.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lE7gc.TopBar), {
                title: "An error has occurred",
                showUser: false
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i1Ydm.ErrorDetails), {
                error: error,
                errorMessage: errorString
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dVR7M.BottomNav), {})
        ]
    });
};
$b8ede97088646b78$export$41ce7963b9cec023.displayName = "RouterErrorBoundary";
var $b8ede97088646b78$export$2e2bcd8739ae039 = $b8ede97088646b78$export$41ce7963b9cec023;

});
parcelRegister("i1Ydm", function(module, exports) {

$parcel$export(module.exports, "ErrorDetails", function () { return $907f488ecd34ef6f$export$d053ec805ce391aa; });

var $bR5nk = parcelRequire("bR5nk");

var $ae9tk = parcelRequire("ae9tk");

var $i1j9w = parcelRequire("i1j9w");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");

const $907f488ecd34ef6f$export$d053ec805ce391aa = ({ error: error, errorMessage: errorMessage })=>{
    const errorCassette = new URL((parcelRequire("bXAjy")));
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("h5", {
                            children: [
                                "I am broken ",
                                "\u2639"
                            ]
                        }),
                        error instanceof (0, $ae9tk.AxiosError) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "d-flex flex-column justify-content-left align-items-center nowrap",
                            style: {
                                whiteSpace: "nowrap"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)("h4", {
                                className: "text-center",
                                children: [
                                    "Error: ",
                                    error.status,
                                    " ",
                                    error.code
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                        className: "d-flex justify-content-center align-items-center",
                        xs: {
                            span: 4
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("img", {
                            src: errorCassette.href,
                            className: "img",
                            alt: "Error",
                            title: "Error",
                            width: "350px",
                            height: "350px"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                        xs: 8,
                        className: "d-flex flex-column justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            children: [
                                "The error was something like:",
                                /*#__PURE__*/ (0, $bR5nk.jsx)("pre", {
                                    className: "m-2 p-4 border border-primary rounded bg-primary bg-opacity-50",
                                    style: {
                                        maxWidth: "800px",
                                        maxHeight: "600px",
                                        overflow: "auto"
                                    },
                                    children: errorMessage
                                }),
                                "whatever that means,",
                                /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
                                    className: "button-link mx-1",
                                    onClick: (0, $i1j9w.doReload),
                                    children: "Refresh"
                                }),
                                "might get back to normal, but if it doesn't please report this to",
                                /*#__PURE__*/ (0, $bR5nk.jsx)("a", {
                                    className: "px-1",
                                    href: "mailto:MOSAICBiometrics@astrazeneca.com",
                                    children: "MOSAICBiometrics@astrazeneca.com"
                                }),
                                "\uD83D\uDE2A"
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
$907f488ecd34ef6f$export$d053ec805ce391aa.displayName = "ErrorDetails";

});
parcelRegister("i1j9w", function(module, exports) {

$parcel$export(module.exports, "doReload", function () { return $aaa1b6d2b00dd077$export$296fe50bcc783caa; });
// istanbul ignore next
/**
 * Helper function to reload the current web page.
 */ const $aaa1b6d2b00dd077$export$296fe50bcc783caa = ()=>{
    window.location.reload();
};

});

parcelRegister("bXAjy", function(module, exports) {
module.exports = $parcel$resolve("y8LML");

});



parcelRegister("8KU6W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c04b595da689b83$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $7gpLT = parcelRequire("7gpLT");

var $5Avx6 = parcelRequire("5Avx6");

var $a6Wxu = parcelRequire("a6Wxu");

var $hHepi = parcelRequire("hHepi");

var $dVR7M = parcelRequire("dVR7M");

var $lE7gc = parcelRequire("lE7gc");

var $3tNrK = parcelRequire("3tNrK");

var $0eakK = parcelRequire("0eakK");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $4QLXA = parcelRequire("4QLXA");

var $kZ50A = parcelRequire("kZ50A");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $5FU7L = parcelRequire("5FU7L");
var $31g00 = parcelRequire("31g00");

var $4Q81F = parcelRequire("4Q81F");
const $8c04b595da689b83$export$bc2fb203e7c919f = ()=>{
    const { applicationPermissions: applicationPermissions, dispatch: dispatch, hierarchyState: hierarchyState, backEndUrl: backEndUrl } = (0, $3tNrK.useAppSettings)();
    (0, $kZ50A.useDocumentTitle)("Home page");
    const { clearUnsavedChanges: clearUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("start-page");
    (0, $spJKX.useEffect)(()=>{
        clearUnsavedChanges();
    }, [
        clearUnsavedChanges
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (hierarchyState.hierarchy) dispatch({
            operation: (0, $0eakK.CLEAR_HIERARCHY)
        });
    }, [
        hierarchyState.hierarchy,
        dispatch
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $7gpLT.default), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lE7gc.TopBar), {
                title: "MOSAIC Biometrics",
                fileEntry: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                            id: "topbar-load-link",
                            as: (0, $4Q81F.Link),
                            to: "/Corporate/Load",
                            children: "Load TLF"
                        }),
                        applicationPermissions.includes((0, $4lHS7.eApplicationPermission).AllowJsonDownload) && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Divider, {}),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    onClick: ()=>{
                                        (0, $4QLXA.downloadStats)(backEndUrl);
                                    },
                                    children: "Download JSON statistics data"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                fluid: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            id: "start-page-lhs",
                            xs: 2,
                            className: "small-scrollbar col-between-top-and-bottom",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hHepi.HierarchyLinks), {})
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            id: "start-page-rhs",
                            xs: 10,
                            className: "position-relative d-flex flex-column col-between-top-and-bottom",
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                                className: "small-scrollbar",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $a6Wxu.Search), {}),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5Avx6.News), {})
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dVR7M.BottomNav), {})
        ]
    });
};
$8c04b595da689b83$export$bc2fb203e7c919f.displayName = "StartPage";
var $8c04b595da689b83$export$2e2bcd8739ae039 = $8c04b595da689b83$export$bc2fb203e7c919f;

});
parcelRegister("7gpLT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61876c91f4d6056a$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $i1Ydm = parcelRequire("i1Ydm");
/**
 * Error boundary component that catches React errors and displays a fallback UI.
 *  No display name required
 */ class $61876c91f4d6056a$var$ErrorBoundary extends (0, $spJKX.Component) {
    static{
        this.displayName = "ErrorBoundary";
    }
    /**
   * Derives error state from caught errors.
   *
   * @param error - The caught error object
   */ static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            errorMessage: error.message
        };
    }
    /**
   * Logs error details to console when errors are caught.
   *
   * @param error - The caught error object
   * @param errorInfo - Additional error information from React
   */ componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }
    /**
   * Renders children or error UI based on error state.
   */ render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i1Ydm.ErrorDetails), {
            errorMessage: this.state.errorMessage
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false,
            errorMessage: ""
        };
    }
}
var $61876c91f4d6056a$export$2e2bcd8739ae039 = $61876c91f4d6056a$var$ErrorBoundary;

});

parcelRegister("5Avx6", function(module, exports) {

$parcel$export(module.exports, "News", function () { return $628cfad83d8e546d$export$aec6fe3795564851; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $3wNKS = parcelRequire("3wNKS");

var $kQJP9 = parcelRequire("kQJP9");

var $spJKX = parcelRequire("spJKX");

var $2QWCq = parcelRequire("2QWCq");
var $iOTZL = parcelRequire("iOTZL");
var $31g00 = parcelRequire("31g00");

var $7L3PZ = parcelRequire("7L3PZ");
const $628cfad83d8e546d$export$aec6fe3795564851 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [newsItems, setNewsItems] = (0, $spJKX.useState)([]);
    const [changed, setChanged] = (0, $spJKX.useState)(false);
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const [loadRequest, setLoadRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [saveRequest, setSaveRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const allowNewsEdit = appSettings.applicationPermissions.findIndex((p)=>p === (0, $4lHS7.eApplicationPermission).AllowNewsEdit) > -1 || appSettings.isAdmin;
    const refreshNews = (0, $spJKX.useEffectEvent)(async ()=>{
        // Get news
        const request = await (0, $4dL47.loadWrapper)((0, $3wNKS.loadNews), "loadNews", {
            ...loadRequest,
            requesting: false
        }, setLoadRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) startTransition(()=>setNewsItems(request.data));
        else if (request?.errorText) {
            startTransition(()=>setNewsItems([]));
            console.warn(`Load news failed: ${request?.errorText}`);
        }
    });
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (newsItems.length === 0 && !loadRequest.error && !loadRequest.requesting) refreshNews();
    }, [
        loadRequest.error,
        loadRequest.requesting,
        newsItems.length
    ]);
    /**
   * Add a new blank news item
   */ const addNews = ()=>{
        const nN = [
            ...newsItems
        ];
        const n = {
            timestamp: Date.now(),
            displayName: appSettings.displayName ?? // istanbul ignore next
            "Test user",
            title: "",
            text: ""
        };
        nN.push(n);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Update a news item
   *
   * @param newNews - the updated news item
   * @param i - index to update
   */ const updateNews = (newNews, i)=>{
        const nN = [
            ...newsItems ?? // istanbul ignore next
            []
        ];
        nN.splice(i, 1, newNews);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Remove a news item
   *
   * @param i - index to remove
   */ const removeNews = (i)=>{
        const nN = [
            ...newsItems ?? // istanbul ignore next
            []
        ];
        nN.splice(i, 1);
        setNewsItems(nN);
        setChanged(true);
    };
    /**
   * Save the current news items
   */ const saveCurrentNews = async ()=>{
        const request = await (0, $4dL47.loadWrapper)((0, $kQJP9.saveNews), newsItems ?? // istanbul ignore next
        [], {
            ...saveRequest,
            requesting: false
        }, setSaveRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            setNewsItems(request.data);
            setChanged(false);
        } else if (request?.errorText) console.warn(`Save failed for news: ${request?.errorText} `);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
        className: "pb-3 position-relative",
        children: [
            (loadRequest.requesting || pending) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                text: "Loading news..."
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                        children: "News"
                    }),
                    newsItems && newsItems.map((n, i)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $7L3PZ.NewsItemsDisplay), {
                            id: `news-item-${i}`,
                            item: n,
                            setItem: allowNewsEdit ? (ret)=>updateNews(ret, i) : undefined,
                            removeItem: allowNewsEdit ? ()=>removeNews(i) : undefined
                        }, i)),
                    newsItems && newsItems.length === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7L3PZ.NewsItemsDisplay), {
                        id: "news-display-0",
                        item: {
                            title: "",
                            displayName: "",
                            timestamp: 0,
                            text: "The news is, there is no news"
                        }
                    }),
                    allowNewsEdit && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $2QWCq.default), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                id: "news-add",
                                "aria-label": "Add news",
                                style: {
                                    marginLeft: "130px"
                                },
                                onClick: ()=>addNews(),
                                variant: "primary",
                                size: "sm",
                                children: "Add news"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                id: "news-save",
                                "aria-label": "Save news",
                                "aria-disabled": !changed,
                                disabled: !changed,
                                variant: "primary",
                                onClick: ()=>saveCurrentNews(),
                                style: {
                                    minWidth: "100px",
                                    minHeight: "38px",
                                    position: "relative"
                                },
                                requestStatus: saveRequest,
                                pauseCoverText: "Saving...",
                                children: "Save news"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$628cfad83d8e546d$export$aec6fe3795564851.displayName = "News";

});
parcelRegister("3wNKS", function(module, exports) {

$parcel$export(module.exports, "loadNews", function () { return $3ffad72e2c322620$export$6be879aaed7294f2; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $3ffad72e2c322620$export$6be879aaed7294f2 = async (backEndUrl)=>{
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Settings/News`);
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value).sort((a, b)=>b.timestamp - a.timestamp)
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load news failed", error);
    }
};

});

parcelRegister("kQJP9", function(module, exports) {

$parcel$export(module.exports, "saveNews", function () { return $069f0582b94b3996$export$1eb3ac603c3bde71; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $069f0582b94b3996$export$1eb3ac603c3bde71 = async (backEndUrl, news, controller)=>{
    // Send data
    try {
        const data = {
            value: JSON.stringify(news)
        };
        const response = await (0, $lCyBC.default).put(`${backEndUrl}Settings/News`, data, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: JSON.parse(response.data.value)
        };
    } catch (error) {
        console.warn(error);
        return (0, $4xeqQ.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("2QWCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $213de892cb4f9f56$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $213de892cb4f9f56$var$ButtonGroup = /*#__PURE__*/ $spJKX.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $dz672.useBootstrapPrefix)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $bR5nk.jsx)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$213de892cb4f9f56$var$ButtonGroup.displayName = 'ButtonGroup';
var $213de892cb4f9f56$export$2e2bcd8739ae039 = $213de892cb4f9f56$var$ButtonGroup;

});

parcelRegister("7L3PZ", function(module, exports) {

$parcel$export(module.exports, "NewsItemsDisplay", function () { return $3d7d564933481ecc$export$1f516c22ed0f5483; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $biia9 = parcelRequire("biia9");
var $ifddf = parcelRequire("ifddf");

var $3tNrK = parcelRequire("3tNrK");

var $spJKX = parcelRequire("spJKX");

var $eZYX7 = parcelRequire("eZYX7");

var $bP72q = parcelRequire("bP72q");
const $3d7d564933481ecc$export$1f516c22ed0f5483 = ({ id: id, item: item, setItem: setItem, removeItem: removeItem })=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [editing, setEditing] = (0, $spJKX.useState)(false);
    // Hold current values and send back onBlur
    const [currentTitle, setCurrentTitle] = (0, $spJKX.useState)(item.title);
    const [currentText, setCurrentText] = (0, $spJKX.useState)(item.text);
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>{
            setCurrentTitle(item.title);
            setCurrentText(item.text);
        });
    }, [
        item
    ]);
    /**
   * Return updated data
   */ const returnData = ()=>{
        const nN = {
            title: currentTitle,
            text: currentText,
            displayName: appSettings.displayName ?? // istanbul ignore next
            "Test user",
            timestamp: Date.now()
        };
        setItem?.(nN);
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: id,
        className: "pb-2",
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            style: {
                display: "flex"
            },
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    style: {
                        minWidth: "100px"
                    },
                    children: new Date(item.timestamp).toISOString().split("T")[0]
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    style: {
                        minWidth: "32px",
                        width: "32px"
                    },
                    className: "align-items-center justify-items-center",
                    children: typeof removeItem === "function" ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $biia9.AioIconButton), {
                                id: `${id}-remove`,
                                onClick: ()=>{
                                    removeItem();
                                },
                                iconName: "aioxMinus",
                                tipText: "Remove news item",
                                "aria-label": "Remove news item",
                                style: {
                                    paddingLeft: "8px",
                                    paddingRight: "8px"
                                }
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bP72q.default), {
                                id: `${id}-edit`,
                                onClick: ()=>setEditing(!editing),
                                style: {
                                    marginLeft: "8px"
                                },
                                "aria-label": "Edit news item"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    style: {
                        flexGrow: 1
                    },
                    children: [
                        setItem && editing ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                            id: `${id}-title-editor`,
                            style: {
                                marginBottom: "4px"
                            },
                            value: currentTitle,
                            placeholder: "Add title",
                            onChange: (e)=>setCurrentTitle(e.currentTarget.value),
                            onBlur: ()=>returnData(),
                            "aria-label": "News title",
                            spellCheck: true
                        }) : item.title !== "" ? /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                            id: `${id}-title`,
                            className: "mb-0",
                            children: item.title
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("small", {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                                children: // istanbul ignore next
                                item.displayName ?? appSettings.displayName ?? // istanbul ignore next
                                "Test user"
                            })
                        }),
                        setItem && editing ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                            id: `${id}-news-editor`,
                            as: "textarea",
                            rows: 3,
                            value: currentText,
                            onChange: (e)=>setCurrentText(e.currentTarget.value),
                            placeholder: "Add news",
                            onBlur: ()=>returnData(),
                            "aria-label": "News text",
                            spellCheck: true
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            id: `${id}-news`,
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ifddf.InTextLink), {
                                text: item.text
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$3d7d564933481ecc$export$1f516c22ed0f5483.displayName = "NewsItemsDisplay";

});


parcelRegister("a6Wxu", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $2e8728da4d89b23c$export$4b85d3515bd863a5; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");

var $8XHWE = parcelRequire("8XHWE");

var $VEySO = parcelRequire("VEySO");
const $2e8728da4d89b23c$export$4b85d3515bd863a5 = ()=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const [subText, setSubText] = (0, $spJKX.useState)("");
    const [currentValue, setCurrentValue] = (0, $spJKX.useState)("");
    const [searchText, setSearchText] = (0, $spJKX.useState)(null);
    // Update subtext
    (0, $spJKX.useEffect)(()=>{
        startTransition(()=>{
            setSubText(currentValue.trim().length < 3 ? "Enter 3 or more characters to search" : currentValue !== searchText ? "..." : "");
        });
    }, [
        currentValue,
        searchText
    ]);
    // Search results + debounce
    (0, $spJKX.useEffect)(()=>{
        const update = setTimeout(()=>{
            if (currentValue !== searchText && currentValue.trim().length > 2) setSearchText(currentValue);
        }, 1000);
        return ()=>clearTimeout(update);
    }, [
        currentValue,
        searchText
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                controlId: "search-entry",
                as: (0, $31g00.default),
                className: "d-flex under-nav-sticky",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                        column: true,
                        sm: 2,
                        style: {
                            minHeight: "70px"
                        },
                        children: "Search"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                        sm: 10,
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                className: "m-1",
                                type: "text",
                                value: currentValue,
                                onChange: (e)=>setCurrentValue(e.currentTarget.value),
                                spellCheck: true
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Text, {
                                children: subText
                            })
                        ]
                    })
                ]
            }),
            searchText !== null && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8XHWE.SearchResultsHierarchy), {
                                searchText: searchText
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $VEySO.SearchResultsTlf), {
                                searchText: searchText
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$2e8728da4d89b23c$export$4b85d3515bd863a5.displayName = "Search";

});
parcelRegister("8XHWE", function(module, exports) {

$parcel$export(module.exports, "SearchResultsHierarchy", function () { return $004d46da7cc7afa5$export$a0eb29ebe1f3e23a; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $iBbNa = parcelRequire("iBbNa");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $jr76P = parcelRequire("jr76P");

var $spJKX = parcelRequire("spJKX");

var $5dhsh = parcelRequire("5dhsh");
const $004d46da7cc7afa5$export$a0eb29ebe1f3e23a = ({ searchText: searchText, updateable: updateable = false })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const [searchStatus, setSearchStatus] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [searchResults, setSearchResults] = (0, $spJKX.useState)([]);
    // Run search
    const search = (0, $spJKX.useEffectEvent)(async (searchText)=>{
        const response = await (0, $4dL47.loadWrapper)((0, $jr76P.searchAllHierarchies), searchText, {
            ...searchStatus,
            error: false
        }, setSearchStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) startTransition(()=>setSearchResults(response.data));
        else if (response && response.success === false) startTransition(()=>setSearchResults([]));
    });
    (0, $spJKX.useEffect)(()=>{
        search(searchText);
    }, [
        searchText
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: searchStatus.requesting || pending ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "my-2",
            children: [
                "Loading search results for Hierarchies...",
                " ",
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                    animation: "border",
                    size: "sm",
                    variant: "dark"
                })
            ]
        }) : searchStatus.error ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
            className: "text-danger",
            children: searchStatus.errorText
        }) : !updateable && searchResults.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
            children: "No results for Hierarchies"
        }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "mb-2",
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                    className: "mt-1",
                    style: {
                        fontSize: "24px"
                    },
                    children: "Hierarchies"
                }),
                searchResults.map((h, hi)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                                to: `/H/${h.id}`,
                                children: h.level === (0, $4lHS7.eHierarchyLevel).Report ? `${h.parentTag}/${h.name}` : h.name
                            }),
                            " - ",
                            !h.description || h.description === "" ? /*#__PURE__*/ (0, $bR5nk.jsx)("em", {
                                children: "No description"
                            }) : h.description
                        ]
                    }, hi))
            ]
        })
    });
};
$004d46da7cc7afa5$export$a0eb29ebe1f3e23a.displayName = "SearchResultsHierarchy";

});
parcelRegister("jr76P", function(module, exports) {

$parcel$export(module.exports, "searchAllHierarchies", function () { return $9bfe412eebfca106$export$176ea7a8c923d374; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $jM83L = parcelRequire("jM83L");

var $4xeqQ = parcelRequire("4xeqQ");
const $9bfe412eebfca106$export$176ea7a8c923d374 = async (backEndUrl, searchText, controller)=>{
    const url = new URL(`${backEndUrl}Hierarchy/Search`);
    // Get data
    try {
        const searchTextParts = (0, $jM83L.getSearchTextParts)(searchText);
        searchTextParts.forEach((searchTextPart)=>{
            url.searchParams.append("searchText", searchTextPart);
        });
        const response = await (0, $lCyBC.default).get(url.href, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Search all hierarchies failed", error);
    }
};

});
parcelRegister("jM83L", function(module, exports) {

$parcel$export(module.exports, "getSearchTextParts", function () { return $d3a066ff9542e607$export$54c04952233faee7; });
/**
 * Splits the search text into parts based on non-alphanumeric characters,
 *
 * @param searchText - The search text to split into searchable parts
 * @returns string[]
 */ const $d3a066ff9542e607$export$54c04952233faee7 = (searchText)=>{
    // Use a regular expression to match non-alphanumeric characters
    // except for underscores (_), hyphens (-), and spaces ( )
    const regex = /[^a-zA-Z0-9_ -]+/g;
    // Split the searchText by the non-alphanumeric characters and filter out empty parts
    const parts = searchText.split(regex).filter((part)=>part.trim() !== "" && part.trim().length > 2);
    return parts;
};

});



parcelRegister("VEySO", function(module, exports) {

$parcel$export(module.exports, "SearchResultsTlf", function () { return $ddf2324855bc67d4$export$c7792cfc98406f09; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $kqRFN = parcelRequire("kqRFN");

var $spJKX = parcelRequire("spJKX");

var $5dhsh = parcelRequire("5dhsh");

var $6is3u = parcelRequire("6is3u");
/**
 * Inner table used by the search results page to render a list of TLF
 * items for a specific category (e.g. Templates or ToC Items).
 *
 * @param props - Destructured props object.
 * @param props.id - DOM id used for the table instance.
 * @param props.label - Label for the table section shown to users.
 * @param props.searchResults - Array of TLF index DTOs to display.
 * @param props.searchStatus - Request status controlling loading and errors.
 */ const $ddf2324855bc67d4$var$InnerTable = ({ id: id, label: label, searchResults: searchResults, searchStatus: searchStatus })=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: searchStatus.requesting ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "my-2",
            children: [
                "Loading search results for ",
                label,
                "...",
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                    className: "mx-1",
                    animation: "border",
                    size: "sm",
                    variant: "dark"
                })
            ]
        }) : searchStatus.error ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
            className: "text-danger",
            children: searchStatus.errorText
        }) : searchResults.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
            children: [
                "No results for ",
                label
            ]
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
            style: {
                height: "400px"
            },
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6is3u.TlfItemTable), {
                id: id,
                label: label,
                searchResults: searchResults,
                showSearchResults: label === "Templates",
                showTocSearchResults: label === "ToC Items"
            })
        })
    });
$ddf2324855bc67d4$var$InnerTable.displayName = "InnerTable";
const $ddf2324855bc67d4$export$c7792cfc98406f09 = ({ searchText: searchText })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const [searchStatus, setSearchStatus] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [searchResults, setSearchResults] = (0, $spJKX.useState)([]);
    // Run search
    const search = (0, $spJKX.useEffectEvent)(async (searchText)=>{
        const response = await (0, $4dL47.loadWrapper)((0, $kqRFN.searchAllTlfs), searchText, {
            ...searchStatus,
            error: false,
            errorText: undefined
        }, setSearchStatus, appSettings.backEndUrl);
        /* istanbul ignore else */ if (response?.success) startTransition(()=>setSearchResults(response.data));
        else if (response && response.success === false) startTransition(()=>setSearchResults([]));
    });
    (0, $spJKX.useEffect)(()=>{
        search(searchText);
    }, [
        searchText
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)($ddf2324855bc67d4$var$InnerTable, {
                id: "searchResultsTemplates",
                label: "Templates",
                searchResults: searchResults.filter((r)=>r.primaryHierarchyLevel !== (0, $4lHS7.eHierarchyLevel).Report),
                searchStatus: {
                    ...searchStatus,
                    requesting: searchStatus.requesting || pending
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)($ddf2324855bc67d4$var$InnerTable, {
                id: "searchResultsTocItems",
                label: "ToC Items",
                searchResults: searchResults.filter((r)=>r.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report),
                searchStatus: {
                    ...searchStatus,
                    requesting: searchStatus.requesting || pending
                }
            })
        ]
    });
};
$ddf2324855bc67d4$export$c7792cfc98406f09.displayName = "SearchResultsTlf";

});
parcelRegister("kqRFN", function(module, exports) {

$parcel$export(module.exports, "searchAllTlfs", function () { return $9a148bd82b3747bd$export$edab17d62c0a241f; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $jM83L = parcelRequire("jM83L");

var $4xeqQ = parcelRequire("4xeqQ");
const $9a148bd82b3747bd$export$edab17d62c0a241f = async (backEndUrl, searchText, controller)=>{
    const url = new URL(`${backEndUrl}TlfItems/Search`);
    // Get data
    try {
        const searchTextParts = (0, $jM83L.getSearchTextParts)(searchText);
        searchTextParts.forEach((searchTextPart)=>{
            url.searchParams.append("searchText", searchTextPart);
        });
        const response = await (0, $lCyBC.default).get(url.href, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load search all Tlfs failed", error);
    }
};

});

parcelRegister("6is3u", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableContext", function () { return $495cbf1ce53ce13a$export$59677028152dedd0; });
$parcel$export(module.exports, "TlfItemTable", function () { return $495cbf1ce53ce13a$export$fead804da0b61a61; });

var $bR5nk = parcelRequire("bR5nk");

var $bvCZ6 = parcelRequire("bvCZ6");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $7lozc = parcelRequire("7lozc");

var $g6trE = parcelRequire("g6trE");

var $llbNs = parcelRequire("llbNs");

var $3tNrK = parcelRequire("3tNrK");

var $0eakK = parcelRequire("0eakK");

var $4lHS7 = parcelRequire("4lHS7");

var $jjv5Y = parcelRequire("jjv5Y");

var $cdDXi = parcelRequire("cdDXi");

var $bhMKI = parcelRequire("bhMKI");

var $i1j9w = parcelRequire("i1j9w");

var $spJKX = parcelRequire("spJKX");

var $jLfY5 = parcelRequire("jLfY5");
var $lYgW3 = parcelRequire("lYgW3");

var $dp2CC = parcelRequire("dp2CC");


var $69057 = parcelRequire("69057");

var $hal6R = parcelRequire("hal6R");
const $495cbf1ce53ce13a$export$59677028152dedd0 = /*#__PURE__*/ (0, $spJKX.createContext)({
    canDelete: false
});
const $495cbf1ce53ce13a$export$fead804da0b61a61 = ({ id: id, label: label, searchResults: searchResults = [], selectedItems: selectedItems, selectReportVariants: selectReportVariants = false, setSelectedItems: setSelectedItems, showDelete: showDelete = false, showExport: showExport = false, showSearchResults: showSearchResults = false, showTocSearchResults: showTocSearchResults = false })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hbc = (0, $spJKX.useContext)((0, $g6trE.HierarchyBrowserContext));
    // Get hierarchy from the correct context
    const currentSelection = hbc?.state.treeList.find((h)=>h.id === hbc.state.currentHierarchy)?.data;
    const currentHierarchy = (0, $jjv5Y.isHierarchyReadDto)(currentSelection) ? currentSelection : null;
    const hierarchy = currentHierarchy ?? hierarchyContext?.hierarchy;
    // Get TLF items from the correct context
    let tlfItems = hbc?.state.hierarchyTlfItemIndex?.find((i)=>i.hierarchyId === hbc.state.currentHierarchy)?.tlfItemIndex ?? hierarchyContext?.tlfItemIndex ?? [];
    // Remove ARS items if the hierarchy does not accept them
    if (hbc && !hierarchyContext?.hierarchy?.arsEnabled) tlfItems = tlfItems.filter((t)=>t.type !== (0, $4lHS7.eTlfItemType).arsListing && t.type !== (0, $4lHS7.eTlfItemType).arsTable);
    // #region DELETE
    // Delete request
    const [deleteRequest, setDeleteRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const deleteTlfItem = (0, $spJKX.useCallback)(async (removeId)=>{
        const request = await (0, $4dL47.loadWrapper)((0, $bhMKI.deleteTlf), removeId, {
            ...deleteRequest,
            requestedId: undefined,
            error: false
        }, setDeleteRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request && request.success && hierarchyContext && hierarchyContext.tlfItemIndex) {
            const newItems = hierarchyContext.tlfItemIndex.filter((i)=>removeId !== `${i.id}`);
            hierarchyContext.dispatch({
                operation: (0, $0eakK.UPDATE_TLF_ITEM_INDEX),
                tlfItemIndex: newItems
            });
        }
    }, [
        appSettings.backEndUrl,
        deleteRequest,
        hierarchyContext
    ]);
    // ID to remove
    const [removeId, setRemoveId] = (0, $spJKX.useState)("");
    const [removeName, setRemoveName] = (0, $spJKX.useState)("");
    // Show remove modal
    const [showRemoveModal, setShowRemoveModal] = (0, $spJKX.useState)(false);
    // Trigger modal when a delete button is pressed
    const checkDelete = (0, $spJKX.useCallback)((id, azsolId, version)=>{
        setRemoveName(`${azsolId}/${version}`);
        setRemoveId(id);
        setShowRemoveModal(true);
    }, []);
    // #endregion DELETE
    // #region REFRESH
    const [loadStatus, setLoadStatus] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    // Refresh TLF items call
    /**
   * Fetches TLF items for the specified hierarchy query parameters.
   *
   * @param hierarchyQueryParams - The parameters defining the hierarchy to fetch TLF items for
   * @param force - Optional flag to force reload, bypassing any cached data
   */ const getTlfItems = (0, $spJKX.useCallback)(async (hierarchyQueryParams, force)=>{
        const response = await (0, $4dL47.loadWrapper)((0, $cdDXi.loadHierarchyTlfs), hierarchyQueryParams, {
            ...loadStatus,
            error: false,
            requestedId: force ? undefined : loadStatus.requestedId
        }, setLoadStatus, appSettings.backEndUrl);
        if (response?.success) {
            // Refresh hierarchy browser
            if (hbc && hierarchyQueryParams.hierarchyId) hbc.dispatch({
                operation: (0, $llbNs.UPSERT_HIERARCHY_TLF_ITEM_INDEX),
                nodeId: hierarchyQueryParams.hierarchyId,
                tlfItemIndex: response.data
            });
            else hierarchyContext?.dispatch({
                operation: (0, $0eakK.UPDATE_TLF_ITEM_INDEX),
                tlfItemIndex: response.data
            });
        }
    }, [
        appSettings.backEndUrl,
        hbc,
        hierarchyContext,
        loadStatus
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (hbc) {
            const currentHierarchy = hbc.state.treeList.find((h)=>h.id === hbc.state.currentHierarchy)?.data;
            const hierarchyQueryParams = {
                hierarchyId: currentHierarchy?.id,
                parentTag: currentHierarchy?.parentTag
            };
            if (loadStatus.requestingId?.hierarchyId !== hbc.state.currentHierarchy && loadStatus.requestedId?.hierarchyId !== hbc.state.currentHierarchy && !loadStatus.error && hierarchyQueryParams.hierarchyId && hierarchyQueryParams.parentTag) getTlfItems(hierarchyQueryParams);
        } else if (hierarchy && loadStatus.requestingId?.hierarchyId !== hierarchy.id && loadStatus.requestedId?.hierarchyId !== hierarchy.id && !loadStatus.error && hierarchyContext && hierarchyContext.tlfItemIndex === null) getTlfItems({
            hierarchyId: hierarchy.id,
            parentTag: hierarchy.parentTag
        });
    }, [
        getTlfItems,
        hbc,
        hierarchy,
        hierarchyContext,
        loadStatus.error,
        loadStatus.requestedId?.hierarchyId,
        loadStatus.requestingId?.hierarchyId
    ]);
    // #endregion REFRESH
    const tableHeader = (0, $spJKX.useMemo)(()=>{
        if (label) return label;
        else if (hierarchy) return `${hierarchy.name} ${![
            (0, $4lHS7.eHierarchy).TopLevel,
            (0, $4lHS7.eHierarchy).Report
        ].includes(hierarchy.type) && hierarchy.level !== (0, $4lHS7.eHierarchyLevel).Corporate ? `${hierarchy.level} ` : ""}${hierarchy.type === (0, $4lHS7.eHierarchy).Report ? "ToC items" : "templates"}`;
        return "";
    }, [
        hierarchy,
        label
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)($495cbf1ce53ce13a$export$59677028152dedd0, {
        value: {
            canDelete: showDelete && hierarchy !== undefined && hierarchy !== null && [
                (0, $4lHS7.eHierarchy).Directory
            ].includes(hierarchy.type),
            deleteClick: checkDelete
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    loadStatus.requesting && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                        text: "Loading TLF items..."
                    }),
                    deleteRequest.requesting && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                        text: "Deleting TLF item..."
                    }),
                    loadStatus.error ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lYgW3.default), {}),
                            " Error loading items; you may not have access. Please",
                            " ",
                            /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
                                className: "button-link",
                                onClick: (0, $i1j9w.doReload),
                                children: "refresh"
                            }),
                            ", or contact the relevant Lead."
                        ]
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            style: {
                                position: "relative"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jLfY5.default), {
                                "aria-label": "Refresh TLF items",
                                id: `${id}-refresh`,
                                onClick: ()=>{
                                    setLoadStatus({
                                        requesting: false,
                                        error: false
                                    });
                                    /* istanbul ignore else */ if (hierarchy) {
                                        const hierarchyQueryParams = {
                                            hierarchyId: hierarchy?.id,
                                            parentTag: hierarchy?.parentTag
                                        };
                                        getTlfItems(hierarchyQueryParams, true);
                                    }
                                },
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    right: "4px",
                                    zIndex: 3
                                }
                            })
                        })
                    }),
                    loadStatus.requesting ? null : tlfItems.length === 0 && !(showSearchResults || showTocSearchResults) ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("h4", {
                                children: tableHeader
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                children: "No items in this hierarchy"
                            })
                        ]
                    }) : selectReportVariants ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7lozc.ReportVariantSelections), {
                        items: tlfItems
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bvCZ6.SimpleTable), {
                        id: id,
                        headerLabel: tableHeader,
                        tableClassName: `tlf-item-table `.trim(),
                        currentSelection: selectedItems,
                        data: (showSearchResults || showTocSearchResults ? searchResults : tlfItems).map((0, $hal6R.mapTlfItemTableRow)),
                        fields: (0, $69057.getTemplateHeaders)(showSearchResults, showTocSearchResults, hierarchy?.level ?? (0, $4lHS7.eHierarchyLevel).Corporate, showExport),
                        filterLabel: "Hide retired/decommissioned",
                        initialFilterSelected: true,
                        keyField: "id",
                        selectable: setSelectedItems !== undefined,
                        selectedBackgroundColor: "rgba(0, 0, 0, 0.2)",
                        setCurrentSelection: (ret)=>{
                            /* istanbul ignore else */ if (setSelectedItems) setSelectedItems(ret.filter((r)=>typeof r === "string"));
                        },
                        showFilter: true,
                        showSearch: showSearchResults || showTocSearchResults ? false : true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dp2CC.RemoveModal), {
                beingRemovedName: removeName,
                beingRemovedType: "Template",
                id: "remove-template-modal",
                onCancel: ()=>{
                    setShowRemoveModal(false);
                },
                onOk: async ()=>{
                    const rid = removeId;
                    setRemoveId("Deleting...");
                    await deleteTlfItem(rid);
                    setShowRemoveModal(false);
                    setRemoveId("");
                    setRemoveName("");
                },
                show: showRemoveModal
            })
        ]
    });
};
$495cbf1ce53ce13a$export$fead804da0b61a61.displayName = "TlfItemTable";

});
parcelRegister("bvCZ6", function(module, exports) {

$parcel$export(module.exports, "SimpleTable", function () { return $8610d47387f4c16e$export$3fe48f9151d0ecc2; });
$parcel$export(module.exports, "simpleTableSortFn", function () { return $8610d47387f4c16e$export$6cbd403afa8090eb; });


var $1JqPC = parcelRequire("1JqPC");

var $2q24i = parcelRequire("2q24i");

var $9i6Y9 = parcelRequire("9i6Y9");

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $eBlbF = parcelRequire("eBlbF");

var $oS63j = parcelRequire("oS63j");
function $8610d47387f4c16e$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $8610d47387f4c16e$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $8610d47387f4c16e$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $8610d47387f4c16e$var$$b65191f6d0a0a991$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$b65191f6d0a0a991$exports, "SimpleTable", function() {
    return $8610d47387f4c16e$export$3fe48f9151d0ecc2;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$b65191f6d0a0a991$exports, "SimpleTableNullDate", function() {
    return $8610d47387f4c16e$export$eaad410fa83c9417;
});
var $8610d47387f4c16e$var$$2d0562c3236da942$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$2d0562c3236da942$exports, "columnFilterValue", function() {
    return $8610d47387f4c16e$export$5813a5ff74a5f299;
});
var $8610d47387f4c16e$var$$2121208b4d86b049$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$2121208b4d86b049$exports, "convertDateToLocaleString", function() {
    return $8610d47387f4c16e$export$886dc98a901f1d4f;
});
const $8610d47387f4c16e$export$886dc98a901f1d4f = (s)=>{
    const d = s instanceof Date ? s : new Date(s);
    return !isNaN(d.getTime()) ? `${new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16).replace(/[T]/, " ")}` : "Invalid date";
};
const $8610d47387f4c16e$export$5813a5ff74a5f299 = (dataItem, showBlank = true, customFilterValueFn)=>{
    if (customFilterValueFn) return customFilterValueFn(dataItem);
    if (!showBlank && (dataItem === null || dataItem === undefined || typeof dataItem === "string" && dataItem.trim() === "")) return [
        ""
    ];
    switch(typeof dataItem){
        case "number":
        case "boolean":
        case "bigint":
            return [
                `${dataItem}`
            ];
        case "string":
            return dataItem.trim() === "" ? [
                "<blank>"
            ] : dataItem.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/) ? [
                $8610d47387f4c16e$export$886dc98a901f1d4f(new Date(dataItem))
            ] : [
                dataItem
            ];
        case "object":
            if (dataItem === null) return [
                "<blank>"
            ];
            if (Array.isArray(dataItem)) return dataItem.flatMap((item)=>$8610d47387f4c16e$export$5813a5ff74a5f299(item, showBlank));
            if (dataItem instanceof Date) return [
                $8610d47387f4c16e$export$886dc98a901f1d4f(dataItem)
            ];
            return Object.values(dataItem).flatMap((item)=>$8610d47387f4c16e$export$5813a5ff74a5f299(item, showBlank));
        case "function":
            return [
                "\uD83D\uDEE0\uFE0F\uD83D\uDEE0\uFE0F"
            ];
        // Only undefined and Symbol are left
        default:
            return dataItem === undefined ? [
                "<blank>"
            ] : [
                "\u2049\uFE0F\u2049\uFE0F"
            ];
    }
};
var $8610d47387f4c16e$var$$9a300121ef89926b$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "footerHolder", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$b203872abf836b30;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$b203872abf836b30 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "holder", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$f57c6e831b0d072a;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$f57c6e831b0d072a = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "main", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$f22da7240b7add18;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$f22da7240b7add18 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "scroll", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$209876d7b1ac8f3;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$209876d7b1ac8f3 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "table", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$9852986a3ec5f6a0;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$9852986a3ec5f6a0 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "title", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$fb184b623420d9be;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$fb184b623420d9be = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$9a300121ef89926b$exports, "titleHolder", function() {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$9835d85acf04d22e;
}, function(v) {
    return $8610d47387f4c16e$var$$9a300121ef89926b$export$9835d85acf04d22e = v;
});
var $8610d47387f4c16e$var$$9a300121ef89926b$export$b203872abf836b30;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$f57c6e831b0d072a;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$f22da7240b7add18;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$209876d7b1ac8f3;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$9852986a3ec5f6a0;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$fb184b623420d9be;
var $8610d47387f4c16e$var$$9a300121ef89926b$export$9835d85acf04d22e;
$8610d47387f4c16e$var$$9a300121ef89926b$export$b203872abf836b30 = `ast-SimpleTable-module-byZixa-footerHolder`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$f57c6e831b0d072a = `ast-SimpleTable-module-byZixa-holder`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$f22da7240b7add18 = `ast-SimpleTable-module-byZixa-main`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$209876d7b1ac8f3 = `ast-SimpleTable-module-byZixa-scroll`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$9852986a3ec5f6a0 = `ast-SimpleTable-module-byZixa-table`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$fb184b623420d9be = `ast-SimpleTable-module-byZixa-title`;
$8610d47387f4c16e$var$$9a300121ef89926b$export$9835d85acf04d22e = `ast-SimpleTable-module-byZixa-titleHolder`;
var $8610d47387f4c16e$var$$54193bdb0fc035ea$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$54193bdb0fc035ea$exports, "noKeyField", function() {
    return $8610d47387f4c16e$var$$54193bdb0fc035ea$export$32cccc561cbc974b;
}, function(v) {
    return $8610d47387f4c16e$var$$54193bdb0fc035ea$export$32cccc561cbc974b = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$54193bdb0fc035ea$exports, "tbody", function() {
    return $8610d47387f4c16e$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c;
}, function(v) {
    return $8610d47387f4c16e$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c = v;
});
var $8610d47387f4c16e$var$$54193bdb0fc035ea$export$32cccc561cbc974b;
var $8610d47387f4c16e$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c;
$8610d47387f4c16e$var$$54193bdb0fc035ea$export$32cccc561cbc974b = `ast-SimpleTableBody-module-Y-lNqW-noKeyField`;
$8610d47387f4c16e$var$$54193bdb0fc035ea$export$7cdd536eaa8f163c = `ast-SimpleTableBody-module-Y-lNqW-tbody`;
// istanbul ignore next
const $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn = ()=>{};
const $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fba198b5b2e37fa = {
    id: "simple-table",
    fields: [],
    keyField: "",
    viewData: [],
    totalRows: 0,
    setTableData: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setFilterData: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setSearchText: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    updateSortBy: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    currentSelection: [],
    toggleAllCurrentSelection: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    toggleSelection: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setColumnWidth: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    pageRows: 50,
    setPageRows: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    firstRow: 0,
    setFirstRow: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    columnWidths: [],
    currentColumnItems: [],
    currentColumnFilter: null,
    currentColumnFilters: [],
    setCurrentColumnFilter: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn,
    setCurrentColumnFilters: $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$var$defaultFn
};
const $8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554 = (0, $spJKX.createContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fba198b5b2e37fa);
var $8610d47387f4c16e$var$$e344397c31793d24$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e344397c31793d24$exports, "cell", function() {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$e2e1361cdc35271d;
}, function(v) {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$e2e1361cdc35271d = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e344397c31793d24$exports, "overflowHidden", function() {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$2d30eef276ffb91a;
}, function(v) {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$2d30eef276ffb91a = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e344397c31793d24$exports, "textLeft", function() {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$354e346024ee0461;
}, function(v) {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$354e346024ee0461 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e344397c31793d24$exports, "textRight", function() {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$19e1b6471a572b37;
}, function(v) {
    return $8610d47387f4c16e$var$$e344397c31793d24$export$19e1b6471a572b37 = v;
});
var $8610d47387f4c16e$var$$e344397c31793d24$export$e2e1361cdc35271d;
var $8610d47387f4c16e$var$$e344397c31793d24$export$2d30eef276ffb91a;
var $8610d47387f4c16e$var$$e344397c31793d24$export$354e346024ee0461;
var $8610d47387f4c16e$var$$e344397c31793d24$export$19e1b6471a572b37;
$8610d47387f4c16e$var$$e344397c31793d24$export$e2e1361cdc35271d = `ast-SimpleTableCell-module-KqO2pa-cell`;
$8610d47387f4c16e$var$$e344397c31793d24$export$2d30eef276ffb91a = `ast-SimpleTableCell-module-KqO2pa-overflowHidden`;
$8610d47387f4c16e$var$$e344397c31793d24$export$354e346024ee0461 = `ast-SimpleTableCell-module-KqO2pa-textLeft`;
$8610d47387f4c16e$var$$e344397c31793d24$export$19e1b6471a572b37 = `ast-SimpleTableCell-module-KqO2pa-textRight`;
const $8610d47387f4c16e$export$eaad410fa83c9417 = ({ cellField: cellField, field: field, rowData: rowData })=>(0, $bR5nk.jsx)("div", {
        className: [
            `simple-table-null-date-cell`,
            /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$e344397c31793d24$exports).overflowHidden,
            typeof rowData[cellField] === "number" ? /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$e344397c31793d24$exports).textRight : /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$e344397c31793d24$exports).textLeft
        ].join(" "),
        children: (0, $bR5nk.jsx)("span", {
            children: $8610d47387f4c16e$export$5813a5ff74a5f299(rowData[cellField], false, field.columnFilterValueFn)
        })
    });
$8610d47387f4c16e$export$eaad410fa83c9417.displayName = "SimpleTableNullDate";
const $8610d47387f4c16e$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221 = ({ rowId: rowId, cellField: cellField, columnNumber: columnNumber, rowNumber: rowNumber })=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const field = simpleTableContext.fields.find((f)=>f.name === cellField);
    const rowData = simpleTableContext.viewData.find((d)=>d[simpleTableContext.keyField] === rowId);
    var _field_name, _field_renderFn;
    return (0, $bR5nk.jsx)("td", {
        id: `${simpleTableContext.id}-row-${String(rowId).toLowerCase().trim()}-cell-${(_field_name = field === null || field === void 0 ? void 0 : field.name) !== null && _field_name !== void 0 ? _field_name : columnNumber}`,
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$e344397c31793d24$exports).cell,
        children: !field || !rowData ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
            children: `${!rowData ? "Row data" : ""}${!rowData && !field ? ", " : ""}${!field ? "Field" : ""} not found`
        }) : (0, $spJKX.createElement)((_field_renderFn = field.renderFn) !== null && _field_renderFn !== void 0 ? _field_renderFn : $8610d47387f4c16e$export$eaad410fa83c9417, {
            rowData: rowData,
            columnNumber: columnNumber,
            field: field,
            cellField: field.name,
            rowNumber: rowNumber
        })
    }, cellField);
};
$8610d47387f4c16e$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221.displayName = "SimpleTableCell";
var $8610d47387f4c16e$var$$3d4c690f3daa4ef7$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$3d4c690f3daa4ef7$exports, "firstcol", function() {
    return $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$209b552db59e98b8;
}, function(v) {
    return $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$209b552db59e98b8 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$3d4c690f3daa4ef7$exports, "selected", function() {
    return $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7;
}, function(v) {
    return $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7 = v;
});
var $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$209b552db59e98b8;
var $8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7;
$8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$209b552db59e98b8 = `ast-SimpleTableRow-module-KPelGa-firstcol`;
$8610d47387f4c16e$var$$3d4c690f3daa4ef7$export$d90250155de6d7e7 = `ast-SimpleTableRow-module-KPelGa-selected`;
const $8610d47387f4c16e$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3 = ({ rowId: rowId, rowNumber: rowNumber })=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bR5nk.jsxs)("tr", {
        id: `${simpleTableContext.id}-row-${rowId}`,
        className: simpleTableContext.currentSelection.findIndex((s)=>s === rowId) > -1 ? /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$3d4c690f3daa4ef7$exports).selected : undefined,
        children: [
            simpleTableContext.selectable && (0, $bR5nk.jsx)("td", {
                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$3d4c690f3daa4ef7$exports).firstcol,
                children: (0, $bR5nk.jsx)("div", {
                    children: (0, $bR5nk.jsx)("input", {
                        id: `${simpleTableContext.id}-check-row-${rowId}`,
                        role: "checkbox",
                        type: "checkbox",
                        className: simpleTableContext.filterCheckClassName,
                        checked: simpleTableContext.currentSelection.findIndex((s)=>s === rowId) > -1,
                        onChange: ()=>simpleTableContext.toggleSelection && simpleTableContext.toggleSelection(rowId)
                    })
                })
            }),
            simpleTableContext.fields.filter((f)=>!f.hidden).map((field, ci)=>(0, $bR5nk.jsx)($8610d47387f4c16e$var$$6fafd1e93a2ba7ab$export$48b23f1dbb795221, {
                    rowId: rowId,
                    rowNumber: rowNumber,
                    columnNumber: ci,
                    cellField: field.name
                }, ci))
        ]
    });
};
$8610d47387f4c16e$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3.displayName = "SimpleTableRow";
const $8610d47387f4c16e$var$$688bd579c4247c44$export$166eb73abdd0a383 = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bR5nk.jsx)("tbody", {
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$54193bdb0fc035ea$exports).tbody,
        children: simpleTableContext.viewData.slice(simpleTableContext.firstRow, simpleTableContext.firstRow + simpleTableContext.pageRows).map((row, ri)=>{
            const chk = typeof row[simpleTableContext.keyField] === "string" || typeof row[simpleTableContext.keyField] === "number";
            return chk ? (0, $bR5nk.jsx)($8610d47387f4c16e$var$$3b4572511bdc4efe$export$31fe1c7fa47941f3, {
                rowId: row[simpleTableContext.keyField],
                rowNumber: ri + simpleTableContext.firstRow
            }, row[simpleTableContext.keyField]) : (0, $bR5nk.jsx)("tr", {
                children: (0, $bR5nk.jsx)("td", {
                    colSpan: simpleTableContext.fields.filter((f)=>!f.hidden).length,
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$54193bdb0fc035ea$exports).noKeyField,
                    children: "keyField has not been found"
                })
            }, ri);
        })
    });
};
$8610d47387f4c16e$var$$688bd579c4247c44$export$166eb73abdd0a383.displayName = "SimpleTableBody";
var $8610d47387f4c16e$var$$33dfa4f31432acb8$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$33dfa4f31432acb8$exports, "checkboxContainer", function() {
    return $8610d47387f4c16e$var$$33dfa4f31432acb8$export$be69ea624d82a314;
}, function(v) {
    return $8610d47387f4c16e$var$$33dfa4f31432acb8$export$be69ea624d82a314 = v;
});
var $8610d47387f4c16e$var$$33dfa4f31432acb8$export$be69ea624d82a314;
$8610d47387f4c16e$var$$33dfa4f31432acb8$export$be69ea624d82a314 = `ast-SimpleTableCheckBox-module-rhSufG-checkboxContainer`;
var $8610d47387f4c16e$var$$6121304767059332$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6121304767059332$exports, "holder", function() {
    return $8610d47387f4c16e$var$$6121304767059332$export$f57c6e831b0d072a;
}, function(v) {
    return $8610d47387f4c16e$var$$6121304767059332$export$f57c6e831b0d072a = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6121304767059332$exports, "label", function() {
    return $8610d47387f4c16e$var$$6121304767059332$export$1237798dc640739a;
}, function(v) {
    return $8610d47387f4c16e$var$$6121304767059332$export$1237798dc640739a = v;
});
var $8610d47387f4c16e$var$$6121304767059332$export$f57c6e831b0d072a;
var $8610d47387f4c16e$var$$6121304767059332$export$1237798dc640739a;
$8610d47387f4c16e$var$$6121304767059332$export$f57c6e831b0d072a = `ast-SimpleTableFilter-module-Q8L8jW-holder`;
$8610d47387f4c16e$var$$6121304767059332$export$1237798dc640739a = `ast-SimpleTableFilter-module-Q8L8jW-label`;
const $8610d47387f4c16e$var$$37494a5c2c819927$export$3a5aecd8506640b7 = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    var _simpleTableContext_filterLabel;
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6121304767059332$exports).holder,
        onClick: ()=>simpleTableContext.setFilterData && simpleTableContext.setFilterData(!simpleTableContext.filterData),
        children: [
            (0, $bR5nk.jsx)("div", {
                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$33dfa4f31432acb8$exports).checkboxContainer,
                children: (0, $bR5nk.jsx)("input", {
                    id: `${simpleTableContext.id}-filter`,
                    type: "checkbox",
                    role: "checkbox",
                    className: simpleTableContext.filterCheckClassName,
                    checked: simpleTableContext.filterData !== undefined ? simpleTableContext.filterData : false,
                    onChange: ()=>true,
                    "aria-labelledby": `${simpleTableContext.id}-filter-label`
                })
            }),
            (0, $bR5nk.jsx)("span", {
                id: `${simpleTableContext.id}-filter-label`,
                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6121304767059332$exports).label,
                children: (_simpleTableContext_filterLabel = simpleTableContext.filterLabel) !== null && _simpleTableContext_filterLabel !== void 0 ? _simpleTableContext_filterLabel : "Filter"
            })
        ]
    });
};
$8610d47387f4c16e$var$$37494a5c2c819927$export$3a5aecd8506640b7.displayName = "SimpleTableFilter";
var $8610d47387f4c16e$var$$3b8de475d255db9f$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$3b8de475d255db9f$exports, "cell", function() {
    return $8610d47387f4c16e$var$$3b8de475d255db9f$export$e2e1361cdc35271d;
}, function(v) {
    return $8610d47387f4c16e$var$$3b8de475d255db9f$export$e2e1361cdc35271d = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$3b8de475d255db9f$exports, "resizeHandle", function() {
    return $8610d47387f4c16e$var$$3b8de475d255db9f$export$8e36b812ea421d73;
}, function(v) {
    return $8610d47387f4c16e$var$$3b8de475d255db9f$export$8e36b812ea421d73 = v;
});
var $8610d47387f4c16e$var$$3b8de475d255db9f$export$e2e1361cdc35271d;
var $8610d47387f4c16e$var$$3b8de475d255db9f$export$8e36b812ea421d73;
$8610d47387f4c16e$var$$3b8de475d255db9f$export$e2e1361cdc35271d = `ast-SimpleTableHeader-module-rCOiMq-cell`;
$8610d47387f4c16e$var$$3b8de475d255db9f$export$8e36b812ea421d73 = `ast-SimpleTableHeader-module-rCOiMq-resizeHandle`;
var $8610d47387f4c16e$var$$a9a06f824c5a210d$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$a9a06f824c5a210d$exports, "boxHeader", function() {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$67350385bd9f1355;
}, function(v) {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$67350385bd9f1355 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$a9a06f824c5a210d$exports, "close", function() {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$8360e631d277ea4d;
}, function(v) {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$8360e631d277ea4d = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$a9a06f824c5a210d$exports, "scroll", function() {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$209876d7b1ac8f3;
}, function(v) {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$209876d7b1ac8f3 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$a9a06f824c5a210d$exports, "search", function() {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$d76128d007d19019;
}, function(v) {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$d76128d007d19019 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$a9a06f824c5a210d$exports, "table", function() {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0;
}, function(v) {
    return $8610d47387f4c16e$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0 = v;
});
var $8610d47387f4c16e$var$$a9a06f824c5a210d$export$67350385bd9f1355;
var $8610d47387f4c16e$var$$a9a06f824c5a210d$export$8360e631d277ea4d;
var $8610d47387f4c16e$var$$a9a06f824c5a210d$export$209876d7b1ac8f3;
var $8610d47387f4c16e$var$$a9a06f824c5a210d$export$d76128d007d19019;
var $8610d47387f4c16e$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0;
$8610d47387f4c16e$var$$a9a06f824c5a210d$export$67350385bd9f1355 = `ast-SimpleTableColumnFilter-module-us4d8a-boxHeader`;
$8610d47387f4c16e$var$$a9a06f824c5a210d$export$8360e631d277ea4d = `ast-SimpleTableColumnFilter-module-us4d8a-close`;
$8610d47387f4c16e$var$$a9a06f824c5a210d$export$209876d7b1ac8f3 = `ast-SimpleTableColumnFilter-module-us4d8a-scroll`;
$8610d47387f4c16e$var$$a9a06f824c5a210d$export$d76128d007d19019 = `ast-SimpleTableColumnFilter-module-us4d8a-search`;
$8610d47387f4c16e$var$$a9a06f824c5a210d$export$9852986a3ec5f6a0 = `ast-SimpleTableColumnFilter-module-us4d8a-table`;
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$efd2611dc765ff3f = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        "aria-label": "Close filter",
        children: (0, $bR5nk.jsx)("path", {
            d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$efd2611dc765ff3f.displayName = "SimpleTableClose";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$f9f275e56b491797 = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-1.999.007-.007a.498.498 0 0 1 .7.006l2 2a.5.5 0 1 1-.707.708L3.5 3.707V12.5zm3.5-9a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$f9f275e56b491797.displayName = "SimpleTableSortAsc";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$d6e14943d35dcd63 = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293V2.5zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zM7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$d6e14943d35dcd63.displayName = "SimpleTableSortDesc";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$4c49c2f0ba062656 = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2h-11z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$4c49c2f0ba062656.displayName = "SimpleTableFilterInactive";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$b72ac73842ff2e5f = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "var(--st-select-active)",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5v-2z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$b72ac73842ff2e5f.displayName = "SimpleTableFilterActive";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$6d7b1be640d775 = (props)=>(0, $bR5nk.jsxs)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: [
            (0, $bR5nk.jsx)("path", {
                d: "M8.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L8.404 7.304Z"
            }),
            (0, $bR5nk.jsx)("path", {
                d: "M.404 7.304a.802.802 0 0 0 0 1.392l6.363 3.692c.52.302 1.233-.043 1.233-.696V4.308c0-.653-.713-.998-1.233-.696L.404 7.304Z"
            })
        ]
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$6d7b1be640d775.displayName = "SimpleTablePagerStart";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$5843adf024675d72 = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$5843adf024675d72.displayName = "SimpleTablePagerPrev";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$384c7abeb3a2ff53 = (props)=>(0, $bR5nk.jsx)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: (0, $bR5nk.jsx)("path", {
            d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
        })
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$384c7abeb3a2ff53.displayName = "SimpleTablePagerNext";
const $8610d47387f4c16e$var$$67fa7036c02790e7$export$f8b8c716218840a = (props)=>(0, $bR5nk.jsxs)("svg", (0, $2q24i._)((0, $1JqPC._)({}, props), {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "12",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        children: [
            (0, $bR5nk.jsx)("path", {
                d: "M7.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
            }),
            (0, $bR5nk.jsx)("path", {
                d: "M15.596 7.304a.802.802 0 0 1 0 1.392l-6.363 3.692C8.713 12.69 8 12.345 8 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692Z"
            })
        ]
    }));
$8610d47387f4c16e$var$$67fa7036c02790e7$export$f8b8c716218840a.displayName = "SimpleTablePagerEnd";
const $8610d47387f4c16e$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9 = ({ columnName: columnName })=>{
    var _simpleTableContext_currentColumnItems_find, _simpleTableContext_currentColumnFilters_find, _simpleTableContext_currentColumnFilters;
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const allCheck = (0, $spJKX.useRef)(null);
    const searchCheck = (0, $spJKX.useRef)(null);
    const inputRef = (0, $spJKX.useRef)(null);
    const [localFilter, setLocalFilter] = (0, $spJKX.useState)("");
    const matchCheck = (0, $spJKX.useRef)(null);
    const [matchSearch, setMatchSearch] = (0, $spJKX.useState)(false);
    var _simpleTableContext_currentColumnItems_find_values_sort;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const availableList = (_simpleTableContext_currentColumnItems_find_values_sort = (_simpleTableContext_currentColumnItems_find = simpleTableContext.currentColumnItems.find((cf)=>cf.columnName === columnName)) === null || _simpleTableContext_currentColumnItems_find === void 0 ? void 0 : _simpleTableContext_currentColumnItems_find.values.sort((a, b)=>a.localeCompare(b))) !== null && _simpleTableContext_currentColumnItems_find_values_sort !== void 0 ? _simpleTableContext_currentColumnItems_find_values_sort : [];
    var _simpleTableContext_currentColumnFilters_find_values;
    const [currentFilter, setCurrentFilter] = (0, $spJKX.useState)((_simpleTableContext_currentColumnFilters_find_values = (_simpleTableContext_currentColumnFilters = simpleTableContext.currentColumnFilters) === null || _simpleTableContext_currentColumnFilters === void 0 ? void 0 : (_simpleTableContext_currentColumnFilters_find = _simpleTableContext_currentColumnFilters.find((cf)=>cf.columnName === columnName)) === null || _simpleTableContext_currentColumnFilters_find === void 0 ? void 0 : _simpleTableContext_currentColumnFilters_find.values) !== null && _simpleTableContext_currentColumnFilters_find_values !== void 0 ? _simpleTableContext_currentColumnFilters_find_values : availableList);
    const filteredItems = availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
    const filteredOutItems = availableList.filter((v)=>!v.toLowerCase().includes(localFilter.toLowerCase()));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onClose = (values)=>{
        // istanbul ignore else
        if (simpleTableContext.setCurrentColumnFilters) {
            const newColumnFilters = [
                ...simpleTableContext.currentColumnFilters
            ];
            const newColumnFilter = {
                columnName: columnName,
                values: values !== null && values !== void 0 ? values : currentFilter
            };
            const ix = simpleTableContext.currentColumnFilters.findIndex((cf)=>cf.columnName === columnName);
            // If the current filter is the same as the available list, remove it
            if ((0, $eBlbF.isEqual)(availableList, currentFilter)) {
                if (ix > -1) newColumnFilters.splice(ix, 1);
            } else if (ix > -1) newColumnFilters.splice(ix, 1, newColumnFilter);
            else newColumnFilters.push(newColumnFilter);
            simpleTableContext.setCurrentColumnFilters(newColumnFilters);
        }
        setLocalFilter("");
        setCurrentFilter([]);
        simpleTableContext.setCurrentColumnFilter(null);
    };
    // Handle typing into the filter box
    const handleFilterChange = (e)=>{
        const newFilter = e.currentTarget.value;
        const newMatchSearch = localFilter.trim().length === 0 && newFilter.trim().length > 0 ? true : localFilter.trim().length > 0 && newFilter.trim().length === 0 ? false : matchSearch;
        setLocalFilter(newFilter);
        setMatchSearch(newMatchSearch);
        setCurrentFilter(newMatchSearch ? availableList.filter((v)=>v.toLowerCase().includes(newFilter.toLowerCase())) : availableList);
    };
    // Toggle all viewed rows
    const toggleCurrentColumnFilter = ()=>{
        // Add all items if they are not already in the current filter
        if (currentFilter.length < availableList.length) setCurrentFilter(availableList);
        else setCurrentFilter([]);
    };
    // Toggle all viewed rows
    const toggleCurrentColumnSearchFilter = ()=>{
        // istanbul ignore else
        if (availableList) {
            const searchedItems = availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
            // Add selection if any are not included
            if (searchedItems.some((item)=>!currentFilter.includes(item))) {
                setCurrentFilter([
                    ...searchedItems,
                    ...currentFilter.filter((v)=>!searchedItems.includes(v))
                ]);
                setMatchSearch(true);
            } else {
                setCurrentFilter(currentFilter.filter((v)=>!searchedItems.includes(v)));
                setMatchSearch(false);
            }
        }
    };
    const selectBodyRow = (e, v)=>{
        e.stopPropagation();
        e.preventDefault();
        const newFilter = [
            ...currentFilter
        ];
        const ix = newFilter.findIndex((cf)=>cf === v);
        if (ix > -1) newFilter.splice(ix, 1);
        else newFilter.push(v);
        setCurrentFilter(newFilter);
    };
    const bodyRow = (v, i)=>(0, $bR5nk.jsxs)("tr", {
            children: [
                (0, $bR5nk.jsx)("td", {
                    children: (0, $bR5nk.jsx)("div", {
                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$33dfa4f31432acb8$exports).checkboxContainer,
                        onClick: (e)=>selectBodyRow(e, v),
                        children: (0, $bR5nk.jsx)("input", {
                            "aria-label": v,
                            id: `${simpleTableContext.id}-columnfilter-${columnName}-check-${i}`,
                            type: "checkbox",
                            role: "checkbox",
                            className: simpleTableContext.filterCheckClassName,
                            checked: currentFilter.includes(v),
                            onChange: (e)=>selectBodyRow(e, v)
                        })
                    })
                }),
                (0, $bR5nk.jsx)("td", {
                    children: v
                })
            ]
        }, i);
    (0, $spJKX.useEffect)(()=>{
        const attemptFocus = ()=>{
            if (inputRef.current && document.activeElement !== inputRef.current) inputRef.current.focus();
        };
        attemptFocus();
        const timer1 = setTimeout(attemptFocus, 50);
        const timer2 = setTimeout(attemptFocus, 150);
        return ()=>{
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, []);
    (0, $spJKX.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            if (e.key === "Enter") onClose();
        };
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onClose
    ]);
    (0, $spJKX.useEffect)(()=>{
        // istanbul ignore else
        if (matchCheck.current) matchCheck.current.checked = matchSearch;
    }, [
        matchSearch
    ]);
    (0, $spJKX.useEffect)(()=>{
        // istanbul ignore else
        if (allCheck.current) {
            if ((currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.length) === (availableList === null || availableList === void 0 ? void 0 : availableList.length)) {
                allCheck.current.checked = true;
                allCheck.current.indeterminate = false;
            } else if (currentFilter.length === 0) {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = false;
            } else {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = true;
            }
        }
        // istanbul ignore else
        if (searchCheck.current) {
            const searchResults = availableList === null || availableList === void 0 ? void 0 : availableList.filter((v)=>v.toLowerCase().includes(localFilter.toLowerCase()));
            if (localFilter.trim().length === 0 || (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) === 0 || !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.some((v)=>currentFilter.includes(v)))) {
                searchCheck.current.checked = false;
                searchCheck.current.indeterminate = false;
            } else if (searchResults === null || searchResults === void 0 ? void 0 : searchResults.every((v)=>currentFilter.includes(v))) {
                searchCheck.current.checked = true;
                searchCheck.current.indeterminate = false;
            } else {
                searchCheck.current.checked = false;
                searchCheck.current.indeterminate = true;
            }
        }
    }, [
        availableList,
        availableList === null || availableList === void 0 ? void 0 : availableList.length,
        currentFilter,
        currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.length,
        localFilter
    ]);
    return (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: (0, $bR5nk.jsxs)("table", {
            className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).table,
            children: [
                (0, $bR5nk.jsxs)("thead", {
                    children: [
                        (0, $bR5nk.jsxs)("tr", {
                            children: [
                                (0, $bR5nk.jsx)("th", {
                                    children: "\xa0"
                                }),
                                (0, $bR5nk.jsx)("th", {
                                    children: (0, $bR5nk.jsxs)("div", {
                                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).search,
                                        children: [
                                            (0, $bR5nk.jsx)("input", {
                                                ref: inputRef,
                                                id: `${simpleTableContext.id}-columnfilter-${columnName}-filter`,
                                                "aria-label": "Column filter search",
                                                value: localFilter,
                                                onChange: handleFilterChange
                                            }),
                                            (0, $bR5nk.jsx)("div", {
                                                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).close,
                                                children: (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$efd2611dc765ff3f, {
                                                    onClick: ()=>onClose()
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $bR5nk.jsxs)("tr", {
                            children: [
                                (0, $bR5nk.jsx)("th", {
                                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bR5nk.jsx)("div", {
                                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>setMatchSearch(!matchSearch),
                                        children: (0, $bR5nk.jsx)("input", {
                                            ref: matchCheck,
                                            id: `${simpleTableContext.id}-columnfilter-${columnName}-match-search`,
                                            "aria-label": "Match search filter",
                                            className: simpleTableContext.filterCheckClassName,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bR5nk.jsx)("th", {
                                    children: "Match search filter"
                                })
                            ]
                        }),
                        (0, $bR5nk.jsxs)("tr", {
                            children: [
                                (0, $bR5nk.jsx)("th", {
                                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bR5nk.jsx)("div", {
                                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>{
                                            if (localFilter.trim().length > 0) toggleCurrentColumnSearchFilter();
                                        },
                                        children: (0, $bR5nk.jsx)("input", {
                                            id: `${simpleTableContext.id}-columnsearchfilter-${columnName}-check-all`,
                                            "aria-label": "Column search filter toggle",
                                            className: simpleTableContext.filterCheckClassName,
                                            ref: searchCheck,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bR5nk.jsx)("th", {
                                    children: "Toggle search values"
                                })
                            ]
                        }),
                        (0, $bR5nk.jsxs)("tr", {
                            children: [
                                (0, $bR5nk.jsx)("th", {
                                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).boxHeader,
                                    children: (0, $bR5nk.jsx)("div", {
                                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$33dfa4f31432acb8$exports).checkboxContainer,
                                        onClick: ()=>toggleCurrentColumnFilter(),
                                        children: (0, $bR5nk.jsx)("input", {
                                            id: `${simpleTableContext.id}-columnfilter-${columnName}-check-all`,
                                            "aria-label": "Column filter toggle",
                                            className: simpleTableContext.filterCheckClassName,
                                            ref: allCheck,
                                            type: "checkbox",
                                            role: "checkbox"
                                        })
                                    })
                                }),
                                (0, $bR5nk.jsx)("th", {
                                    children: "Select all"
                                })
                            ]
                        })
                    ]
                }),
                (0, $bR5nk.jsxs)("tbody", {
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$a9a06f824c5a210d$exports).scroll,
                    children: [
                        filteredItems.length === 0 ? (0, $bR5nk.jsx)("tr", {
                            children: (0, $bR5nk.jsx)("td", {
                                colSpan: 2,
                                style: {
                                    textAlign: "center"
                                },
                                children: "No matching items"
                            })
                        }) : filteredItems.map(bodyRow),
                        filteredOutItems.length > 0 && (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                (0, $bR5nk.jsx)("tr", {
                                    children: (0, $bR5nk.jsx)("th", {
                                        colSpan: 2,
                                        style: {
                                            backgroundColor: "grey"
                                        }
                                    })
                                }),
                                filteredOutItems.map(bodyRow)
                            ]
                        })
                    ]
                }),
                (0, $bR5nk.jsx)("tfoot", {
                    children: (0, $bR5nk.jsx)("tr", {
                        children: (0, $bR5nk.jsx)("td", {
                            colSpan: 2,
                            children: (0, $bR5nk.jsx)("small", {
                                children: `${currentFilter.length} item${currentFilter.length !== 1 ? "s" : ""} selected`
                            })
                        })
                    })
                })
            ]
        })
    });
};
$8610d47387f4c16e$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9.displayName = "SimpleTableColumnFilter";
var $8610d47387f4c16e$var$$6778322675caae03$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6778322675caae03$exports, "clickable", function() {
    return $8610d47387f4c16e$var$$6778322675caae03$export$60d5655c6babb2a0;
}, function(v) {
    return $8610d47387f4c16e$var$$6778322675caae03$export$60d5655c6babb2a0 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6778322675caae03$exports, "clickableDisabled", function() {
    return $8610d47387f4c16e$var$$6778322675caae03$export$b81be63c99ce521;
}, function(v) {
    return $8610d47387f4c16e$var$$6778322675caae03$export$b81be63c99ce521 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6778322675caae03$exports, "filterHolder", function() {
    return $8610d47387f4c16e$var$$6778322675caae03$export$f8ca79fc2b1d5fa9;
}, function(v) {
    return $8610d47387f4c16e$var$$6778322675caae03$export$f8ca79fc2b1d5fa9 = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6778322675caae03$exports, "iconHolder", function() {
    return $8610d47387f4c16e$var$$6778322675caae03$export$8826a4de072b82bd;
}, function(v) {
    return $8610d47387f4c16e$var$$6778322675caae03$export$8826a4de072b82bd = v;
});
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$6778322675caae03$exports, "text", function() {
    return $8610d47387f4c16e$var$$6778322675caae03$export$6f093cfa640b7166;
}, function(v) {
    return $8610d47387f4c16e$var$$6778322675caae03$export$6f093cfa640b7166 = v;
});
var $8610d47387f4c16e$var$$6778322675caae03$export$60d5655c6babb2a0;
var $8610d47387f4c16e$var$$6778322675caae03$export$b81be63c99ce521;
var $8610d47387f4c16e$var$$6778322675caae03$export$f8ca79fc2b1d5fa9;
var $8610d47387f4c16e$var$$6778322675caae03$export$8826a4de072b82bd;
var $8610d47387f4c16e$var$$6778322675caae03$export$6f093cfa640b7166;
$8610d47387f4c16e$var$$6778322675caae03$export$60d5655c6babb2a0 = `ast-SimpleTableHeaderContents-module-hte7-q-clickable`;
$8610d47387f4c16e$var$$6778322675caae03$export$b81be63c99ce521 = `ast-SimpleTableHeaderContents-module-hte7-q-clickableDisabled`;
$8610d47387f4c16e$var$$6778322675caae03$export$f8ca79fc2b1d5fa9 = `ast-SimpleTableHeaderContents-module-hte7-q-filterHolder`;
$8610d47387f4c16e$var$$6778322675caae03$export$8826a4de072b82bd = `ast-SimpleTableHeaderContents-module-hte7-q-iconHolder`;
$8610d47387f4c16e$var$$6778322675caae03$export$6f093cfa640b7166 = `ast-SimpleTableHeaderContents-module-hte7-q-text`;
const $8610d47387f4c16e$var$$4c31c909a3b65e1b$export$54be34308c33172a = (_param)=>{
    var { children: children, isVisible: isVisible, anchorElementRef: anchorElementRef, onClose: onClose } = _param, rest = (0, $9i6Y9._)(_param, [
        "children",
        "isVisible",
        "anchorElementRef",
        "onClose"
    ]);
    const [position, setPosition] = (0, $spJKX.useState)({
        top: undefined,
        left: undefined,
        right: undefined
    });
    const [alignment, setAlignment] = (0, $spJKX.useState)("left");
    const popoverRef = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        const anchorElement = anchorElementRef.current;
        const updatePosition = ()=>{
            if (!anchorElement || !popoverRef.current) return;
            const anchorRect = anchorElement.getBoundingClientRect();
            const popoverRect = popoverRef.current.getBoundingClientRect();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            // Close if the anchor is not visible
            if (anchorRect.bottom < 8 || anchorRect.right < 8 || anchorRect.top > windowHeight || anchorRect.right > windowWidth) {
                onClose();
                return;
            }
            // Default position below the anchor
            const top = anchorRect.bottom;
            const left = anchorRect.left;
            const right = anchorRect.right;
            // Check horizontal boundaries
            if (alignment === "right") {
                // Close if there is no room
                if (right - popoverRect.width <= 0 && left + popoverRect.width >= windowWidth) {
                    onClose();
                    return;
                }
                // If right alignment goes out of bounds, switch to left alignment
                if (left + popoverRect.width < windowWidth - 8) setAlignment("left");
            } else {
                // Close if there is no room
                if (left + popoverRect.width >= windowWidth - 8 && right - popoverRect.width <= 0) {
                    onClose();
                    return;
                }
                // If left alignment goes out of bounds, switch to right alignment
                if (left + popoverRect.width >= windowWidth - 8 && right - popoverRect.width > 0) setAlignment("right");
            }
            // Check vertical boundaries
            if (top + popoverRect.height > windowHeight) {
                const newHeight = windowHeight - top - 24;
                if (newHeight < 100) {
                    onClose();
                    return;
                }
                popoverRef.current.style.height = `${newHeight}px`;
            }
            const newPosition = {
                top: top,
                left: alignment === "left" ? left : undefined,
                right: alignment === "right" ? windowWidth - right : undefined
            };
            setPosition(newPosition);
        };
        // Initial position update
        updatePosition();
        // Set up observers and event listeners
        const handleScroll = ()=>updatePosition();
        const handleResize = ()=>updatePosition();
        // Handle escape key press
        const handleKeyDown = (event)=>{
            // istanbul ignore else
            if (event.key === "Escape") {
                window.removeEventListener("keydown", handleKeyDown);
                onClose();
            }
        };
        const resizeObserver = new ResizeObserver(updatePosition);
        // Observe the popover and anchor element for resizing
        if (popoverRef.current) {
            resizeObserver.observe(popoverRef.current);
            // Observe the parent elements up to the body to detect layout changes
            let el = anchorElement;
            while(el && el !== document.body){
                resizeObserver.observe(el);
                el = el.parentElement;
            }
        }
        // Listen for scroll and resize events
        window.addEventListener("scroll", handleScroll, true);
        window.addEventListener("resize", handleResize);
        window.addEventListener("keydown", handleKeyDown);
        // Clean up all event listeners and observers
        return ()=>{
            resizeObserver.disconnect();
            window.removeEventListener("scroll", handleScroll, true);
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        alignment,
        anchorElementRef,
        isVisible,
        onClose
    ]);
    if (!isVisible) return null;
    return (0, $oS63j.createPortal)((0, $bR5nk.jsx)("div", (0, $2q24i._)((0, $1JqPC._)({}, rest), {
        ref: popoverRef,
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6778322675caae03$exports).filterHolder,
        style: {
            visibility: position.top !== undefined ? "visible" : "hidden",
            top: position.top !== undefined ? `${position.top}px` : "auto",
            bottom: "auto",
            left: position.left !== undefined ? `${position.left}px` : "auto",
            right: position.right !== undefined ? `${position.right}px` : "auto",
            resize: alignment === "right" ? "vertical" : undefined
        },
        children: children
    })), document.body);
};
const $8610d47387f4c16e$var$$995a7ed18b2c70d1$export$623e74e451244509 = ({ field: field, columnNumber: columnNumber })=>{
    var _simpleTableContext_currentColumnFilters_find, _simpleTableContext_currentColumnItems_find, _simpleTableContext_sortBy, _simpleTableContext_sortBy1, _simpleTableContext_sortBy2;
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const filterIconRef = (0, $spJKX.useRef)(null);
    const isFilterActive = simpleTableContext.currentColumnFilter === columnNumber;
    const thisColumnFilter = (_simpleTableContext_currentColumnFilters_find = simpleTableContext.currentColumnFilters.find((cf)=>cf.columnName === field.name)) === null || _simpleTableContext_currentColumnFilters_find === void 0 ? void 0 : _simpleTableContext_currentColumnFilters_find.values;
    const thisColumnItems = (_simpleTableContext_currentColumnItems_find = simpleTableContext.currentColumnItems.find((cf)=>cf.columnName === field.name)) === null || _simpleTableContext_currentColumnItems_find === void 0 ? void 0 : _simpleTableContext_currentColumnItems_find.values;
    const toggleFilter = async (e)=>{
        var _simpleTableContext_setCurrentColumnFilter;
        e.stopPropagation();
        e.preventDefault();
        (_simpleTableContext_setCurrentColumnFilter = simpleTableContext.setCurrentColumnFilter) === null || _simpleTableContext_setCurrentColumnFilter === void 0 || _simpleTableContext_setCurrentColumnFilter.call(simpleTableContext, simpleTableContext.currentColumnFilter !== columnNumber ? columnNumber : null);
    };
    return (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            field.canColumnFilter && (0, $bR5nk.jsx)($8610d47387f4c16e$var$$4c31c909a3b65e1b$export$54be34308c33172a, {
                isVisible: isFilterActive,
                anchorElementRef: filterIconRef,
                onClose: ()=>simpleTableContext.setCurrentColumnFilter(null),
                children: (0, $bR5nk.jsx)($8610d47387f4c16e$var$$b8a87bcd44c7ea21$export$bdb6d3fce58542c9, {
                    columnName: field.name
                })
            }),
            (0, $bR5nk.jsxs)("div", {
                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6778322675caae03$exports).text,
                children: [
                    (0, $bR5nk.jsx)("span", {
                        className: field.sortFn ? /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6778322675caae03$exports).clickable : /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6778322675caae03$exports).clickableDisabled,
                        onClick: ()=>{
                            if (field.sortFn) simpleTableContext.updateSortBy(field);
                        },
                        children: (0, $bR5nk.jsx)("span", {
                            className: ((_simpleTableContext_sortBy = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy === void 0 ? void 0 : _simpleTableContext_sortBy.name) === field.name ? "sorted" : "unsorted",
                            children: field.headerRenderFn ? (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                                children: field.headerRenderFn({
                                    field: field,
                                    columnNumber: columnNumber
                                })
                            }) : (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                                children: field.label
                            })
                        })
                    }),
                    (0, $bR5nk.jsxs)("div", {
                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$6778322675caae03$exports).iconHolder,
                        children: [
                            ((_simpleTableContext_sortBy1 = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy1 === void 0 ? void 0 : _simpleTableContext_sortBy1.name) === field.name ? ((_simpleTableContext_sortBy2 = simpleTableContext.sortBy) === null || _simpleTableContext_sortBy2 === void 0 ? void 0 : _simpleTableContext_sortBy2.asc) ? (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$f9f275e56b491797, {}) : (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$d6e14943d35dcd63, {}) : undefined,
                            field.canColumnFilter && (0, $bR5nk.jsx)("span", {
                                ref: filterIconRef,
                                children: thisColumnFilter && thisColumnFilter.length !== (thisColumnItems === null || thisColumnItems === void 0 ? void 0 : thisColumnItems.length) ? (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$b72ac73842ff2e5f, {
                                    "aria-label": "Column filter (Active)",
                                    onClick: toggleFilter
                                }) : (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$4c49c2f0ba062656, {
                                    "aria-label": "Column filter",
                                    onClick: toggleFilter
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$8610d47387f4c16e$var$$995a7ed18b2c70d1$export$623e74e451244509.displayName = "SimpleTableHeaderContents";
const $8610d47387f4c16e$var$$01515f53c0c8c9ec$export$91068a7395f62723 = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const targetCell = (0, $spJKX.useRef)(null);
    const mouseUpRef = (0, $spJKX.useRef)(null);
    const mouseMove = (e)=>{
        // istanbul ignore else
        if (targetCell.current !== null) {
            const t = targetCell.current;
            const width = e.clientX - window.scrollX - t.getBoundingClientRect().x;
            if (width > 16) t.style.width = `${width}px`;
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const mouseUp = ()=>{
        // istanbul ignore else
        if (targetCell.current) {
            const name = targetCell.current.dataset.columnName;
            const width = targetCell.current.style.width;
            // istanbul ignore else
            if (simpleTableContext.setColumnWidth && name && width) simpleTableContext.setColumnWidth(name, targetCell.current.style.width);
            targetCell.current = null;
            window.removeEventListener("mousemove", mouseMove);
            // istanbul ignore else
            if (mouseUpRef.current) window.removeEventListener("mouseup", mouseUpRef.current);
        }
    };
    (0, $spJKX.useEffect)(()=>{
        mouseUpRef.current = mouseUp;
    }, [
        mouseUp
    ]);
    const mouseDown = (e)=>{
        e.preventDefault();
        targetCell.current = e.currentTarget.parentElement;
        // istanbul ignore else
        if (targetCell.current) {
            window.addEventListener("mousemove", mouseMove);
            window.addEventListener("mouseup", mouseUp);
        }
    };
    return (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: simpleTableContext.fields.filter((f)=>!f.hidden).map((field, columnNumber)=>{
            var _simpleTableContext_columnWidths_find;
            var _simpleTableContext_columnWidths_find_width;
            return (0, $bR5nk.jsxs)("th", {
                id: `${simpleTableContext.id}-header-${field.name}`,
                "data-column-name": field.name,
                className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$3b8de475d255db9f$exports).cell,
                style: {
                    width: (_simpleTableContext_columnWidths_find_width = (_simpleTableContext_columnWidths_find = simpleTableContext.columnWidths.find((w)=>w.name === field.name)) === null || _simpleTableContext_columnWidths_find === void 0 ? void 0 : _simpleTableContext_columnWidths_find.width) !== null && _simpleTableContext_columnWidths_find_width !== void 0 ? _simpleTableContext_columnWidths_find_width : "100px"
                },
                children: [
                    (0, $bR5nk.jsx)($8610d47387f4c16e$var$$995a7ed18b2c70d1$export$623e74e451244509, {
                        field: field,
                        columnNumber: columnNumber
                    }),
                    (0, $bR5nk.jsx)("div", {
                        "aria-orientation": "vertical",
                        tabIndex: columnNumber,
                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$3b8de475d255db9f$exports).resizeHandle,
                        role: "separator",
                        onMouseDown: mouseDown
                    })
                ]
            }, field.name);
        })
    });
};
$8610d47387f4c16e$var$$01515f53c0c8c9ec$export$91068a7395f62723.displayName = "SimpleTableHeader";
var $8610d47387f4c16e$var$$35a5bc35282fd524$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$35a5bc35282fd524$exports, "baseSelect", function() {
    return $8610d47387f4c16e$var$$35a5bc35282fd524$export$a332407e56744979;
}, function(v) {
    return $8610d47387f4c16e$var$$35a5bc35282fd524$export$a332407e56744979 = v;
});
var $8610d47387f4c16e$var$$35a5bc35282fd524$export$a332407e56744979;
$8610d47387f4c16e$var$$35a5bc35282fd524$export$a332407e56744979 = `ast-Select-module-SkswYq-baseSelect`;
var $8610d47387f4c16e$var$$107c82067973eee5$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$107c82067973eee5$exports, "footer", function() {
    return $8610d47387f4c16e$var$$107c82067973eee5$export$adb608be33961c98;
}, function(v) {
    return $8610d47387f4c16e$var$$107c82067973eee5$export$adb608be33961c98 = v;
});
var $8610d47387f4c16e$var$$107c82067973eee5$export$adb608be33961c98;
$8610d47387f4c16e$var$$107c82067973eee5$export$adb608be33961c98 = `ast-SimpleTablePager-module-P9pQIa-footer`;
const $8610d47387f4c16e$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    return (0, $bR5nk.jsx)("div", {
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$107c82067973eee5$exports).footer,
        children: (0, $bR5nk.jsxs)("span", {
            children: [
                "Showing\xa0",
                (0, $bR5nk.jsxs)("select", {
                    id: `${simpleTableContext.id}-pager-visible-rows`,
                    "aria-label": "Visible rows",
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$35a5bc35282fd524$exports).baseSelect,
                    value: `${simpleTableContext.pageRows === Infinity ? "All" : simpleTableContext.pageRows}`,
                    onChange: (e)=>simpleTableContext.setPageRows && simpleTableContext.setPageRows(e.currentTarget.value === "All" ? Infinity : parseInt(e.currentTarget.value)),
                    children: [
                        (0, $bR5nk.jsx)("option", {
                            children: "10"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "25"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "50"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "100"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "250"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "500"
                        }),
                        (0, $bR5nk.jsx)("option", {
                            children: "All"
                        })
                    ]
                }),
                "\xa0of\xa0",
                simpleTableContext.viewData.length,
                "\xa0rows",
                simpleTableContext.viewData.length !== simpleTableContext.totalRows && ` (${simpleTableContext.totalRows} unfiltered)`,
                "\xa0from\xa0",
                (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$6d7b1be640d775, {
                    "aria-label": "Go to first page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.setFirstRow(0)
                }),
                (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$5843adf024675d72, {
                    "aria-label": "Go to previous page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.setFirstRow(Math.max(0, simpleTableContext.firstRow - simpleTableContext.pageRows))
                }),
                "row\xa0",
                (0, $bR5nk.jsx)("select", {
                    id: `${simpleTableContext.id}-pager-first-row`,
                    "aria-label": "First row",
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$35a5bc35282fd524$exports).baseSelect,
                    value: simpleTableContext.firstRow,
                    onChange: (e)=>{
                        simpleTableContext.setFirstRow(parseInt(e.currentTarget.value));
                    },
                    children: simpleTableContext.pageRows === Infinity ? (0, $bR5nk.jsx)("option", {
                        children: "1"
                    }) : Array.from({
                        length: Math.ceil(simpleTableContext.viewData.length / simpleTableContext.pageRows)
                    }, (_, i)=>i * simpleTableContext.pageRows).map((rn)=>(0, $bR5nk.jsx)("option", {
                            value: rn,
                            children: rn + 1
                        }, rn))
                }),
                (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$384c7abeb3a2ff53, {
                    "aria-label": "Go to next page",
                    onClick: ()=>simpleTableContext.setFirstRow && simpleTableContext.firstRow + simpleTableContext.pageRows < simpleTableContext.viewData.length && simpleTableContext.setFirstRow(simpleTableContext.firstRow + simpleTableContext.pageRows)
                }),
                (0, $bR5nk.jsx)($8610d47387f4c16e$var$$67fa7036c02790e7$export$f8b8c716218840a, {
                    "aria-label": "Go to last page",
                    onClick: ()=>{
                        simpleTableContext.setFirstRow(Math.floor((simpleTableContext.viewData.length - 1) / simpleTableContext.pageRows) * simpleTableContext.pageRows);
                    }
                })
            ]
        })
    });
};
$8610d47387f4c16e$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c.displayName = "SimpleTablePager";
var $8610d47387f4c16e$var$$e901f27a85018fde$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e901f27a85018fde$exports, "holder", function() {
    return $8610d47387f4c16e$var$$e901f27a85018fde$export$f57c6e831b0d072a;
}, function(v) {
    return $8610d47387f4c16e$var$$e901f27a85018fde$export$f57c6e831b0d072a = v;
});
var $8610d47387f4c16e$var$$e901f27a85018fde$export$f57c6e831b0d072a;
$8610d47387f4c16e$var$$e901f27a85018fde$export$f57c6e831b0d072a = `ast-SimpleTableSearch-module-xBXwEq-holder`;
const $8610d47387f4c16e$var$$47fed6d59054ee6e$export$66026d92cfdafe91 = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    var _simpleTableContext_searchLabel, _simpleTableContext_searchText;
    return (0, $bR5nk.jsxs)("div", {
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$e901f27a85018fde$exports).holder,
        children: [
            (0, $bR5nk.jsx)("label", {
                id: `${simpleTableContext.id}-search-label`,
                htmlFor: `${simpleTableContext.id}-search`,
                className: simpleTableContext.searchLabelClassName,
                children: (_simpleTableContext_searchLabel = simpleTableContext.searchLabel) !== null && _simpleTableContext_searchLabel !== void 0 ? _simpleTableContext_searchLabel : "Search"
            }),
            (0, $bR5nk.jsx)("div", {
                children: (0, $bR5nk.jsx)("input", {
                    id: `${simpleTableContext.id}-search`,
                    className: simpleTableContext.searchInputClassName,
                    role: "searchbox",
                    type: "string",
                    value: (_simpleTableContext_searchText = simpleTableContext.searchText) !== null && _simpleTableContext_searchText !== void 0 ? _simpleTableContext_searchText : "",
                    disabled: !simpleTableContext.setSearchText,
                    onChange: (e)=>{
                        simpleTableContext.setSearchText(e.currentTarget.value);
                    }
                })
            })
        ]
    });
};
$8610d47387f4c16e$var$$47fed6d59054ee6e$export$66026d92cfdafe91.displayName = "SimpleTableSearch";
var $8610d47387f4c16e$var$$20518f3fca73c5aa$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$20518f3fca73c5aa$exports, "cell", function() {
    return $8610d47387f4c16e$var$$20518f3fca73c5aa$export$e2e1361cdc35271d;
}, function(v) {
    return $8610d47387f4c16e$var$$20518f3fca73c5aa$export$e2e1361cdc35271d = v;
});
var $8610d47387f4c16e$var$$20518f3fca73c5aa$export$e2e1361cdc35271d;
$8610d47387f4c16e$var$$20518f3fca73c5aa$export$e2e1361cdc35271d = `ast-SimpleTableSelectHeader-module-pMQ3rq-cell`;
const $8610d47387f4c16e$var$$06184096f9fd7746$export$fe2caba3b87edbe3 = ()=>{
    const simpleTableContext = (0, $spJKX.useContext)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554);
    const allCheck = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        // istanbul ignore else
        if (allCheck.current) {
            var _simpleTableContext_currentSelection;
            if (((_simpleTableContext_currentSelection = simpleTableContext.currentSelection) === null || _simpleTableContext_currentSelection === void 0 ? void 0 : _simpleTableContext_currentSelection.length) === simpleTableContext.totalRows) {
                allCheck.current.checked = true;
                allCheck.current.indeterminate = false;
            } else if (simpleTableContext.currentSelection.length === 0) {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = false;
            } else {
                allCheck.current.checked = false;
                allCheck.current.indeterminate = true;
            }
        }
    }, [
        simpleTableContext.currentSelection.length,
        simpleTableContext.totalRows
    ]);
    return (0, $bR5nk.jsx)("th", {
        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$20518f3fca73c5aa$exports).cell,
        children: (0, $bR5nk.jsx)("div", {
            children: (0, $bR5nk.jsx)("input", {
                id: `${simpleTableContext.id}-check-all`,
                type: "checkbox",
                role: "checkbox",
                className: simpleTableContext.filterCheckClassName,
                ref: allCheck,
                onChange: simpleTableContext.toggleAllCurrentSelection
            })
        })
    });
};
$8610d47387f4c16e$var$$06184096f9fd7746$export$fe2caba3b87edbe3.displayName = "SimpleTableSelectHeader";
// Type guard for SimpleTableLocalSettings
const $8610d47387f4c16e$var$$8bf0d84dcf2ec6e7$var$isSimpleTableLocalSettings = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    const settings = obj;
    if (settings.pageRows !== undefined) {
        if (typeof settings.pageRows !== "number" && typeof settings.pageRows !== "string") return false;
    }
    if (settings.headerWidths !== undefined) {
        if (!Array.isArray(settings.headerWidths)) return false;
    }
    return true;
};
const $8610d47387f4c16e$export$3fe48f9151d0ecc2 = (_param)=>{
    var { id: id, currentSelection: currentSelection = [], data: data, fields: fields, filterCheckClassName: filterCheckClassName = "form-check-input", filterLabel: filterLabel = "Filter", filterLabelClassName: filterLabelClassName = "form-check-label", headerBackgroundColor: headerBackgroundColor = "white", headerLabel: headerLabel, initialFilterSelected: initialFilterSelected = false, inputGroupClassName: inputGroupClassName = "form-group", keyField: keyField, mainBackgroundColor: mainBackgroundColor = "white", onPagerChange: onPagerChange, onWidthChange: onWidthChange, searchInputClassName: searchInputClassName = "form-control form-control-sm", searchLabel: searchLabel = "Search", searchLabelClassName: searchLabelClassName = "form-label", selectActiveColor: selectActiveColor = "rgb(255, 153, 0)", selectInactiveColor: selectInactiveColor = "rgb(0, 0, 0, 0.2)", selectable: selectable = false, selectedBackgroundColor: selectedBackgroundColor = "rgba(0, 0, 0, 0.8)", setCurrentSelection: setCurrentSelection, showFilter: showFilter = false, showHeader: showHeader = true, showPager: showPager = true, showSearch: showSearch = true, tableClassName: tableClassName = "" } = _param, rest = (0, $9i6Y9._)(_param, [
        "id",
        "currentSelection",
        "data",
        "fields",
        "filterCheckClassName",
        "filterLabel",
        "filterLabelClassName",
        "headerBackgroundColor",
        "headerLabel",
        "initialFilterSelected",
        "inputGroupClassName",
        "keyField",
        "mainBackgroundColor",
        "onPagerChange",
        "onWidthChange",
        "searchInputClassName",
        "searchLabel",
        "searchLabelClassName",
        "selectActiveColor",
        "selectInactiveColor",
        "selectable",
        "selectedBackgroundColor",
        "setCurrentSelection",
        "showFilter",
        "showHeader",
        "showPager",
        "showSearch",
        "tableClassName"
    ]);
    // Load local settings once on mount
    const localSettingsText = typeof window !== "undefined" ? window.localStorage.getItem(`asup.simple-table.${id}.settings`) : null;
    const parsedSettings = localSettingsText ? JSON.parse(localSettingsText) : null;
    const localSettings = $8610d47387f4c16e$var$$8bf0d84dcf2ec6e7$var$isSimpleTableLocalSettings(parsedSettings) ? parsedSettings : null;
    const columnFilterValueFns = fields.filter((f)=>f.columnFilterValueFn).reduce((acc, f)=>{
        acc[f.name] = f.columnFilterValueFn;
        return acc;
    }, {});
    // Sync external data prop changes
    const [tableData, setTableData] = (0, $spJKX.useState)(data);
    (0, $spJKX.useEffect)(()=>{
        (0, $spJKX.startTransition)(()=>setTableData(data));
    }, [
        data
    ]);
    const [filterData, setFilterData] = (0, $spJKX.useState)(initialFilterSelected);
    const [sortBy, setSortBy] = (0, $spJKX.useState)(null);
    const [searchText, setSearchText] = (0, $spJKX.useState)("");
    // Initialize columnWidths from localStorage or fields
    const [columnWidths, setColumnWidths] = (0, $spJKX.useState)(()=>{
        if ((localSettings === null || localSettings === void 0 ? void 0 : localSettings.headerWidths) && Array.isArray(localSettings.headerWidths)) {
            // Check if it's the old format (string[]) or new format ({ name, width }[])
            if (localSettings.headerWidths.length > 0 && !localSettings.headerWidths.every((c)=>typeof c === "string" || c === null)) return localSettings.headerWidths;
        }
        return fields.filter((f)=>f.width !== undefined).map((f)=>({
                name: f.name,
                width: f.width
            }));
    });
    // Initialize pageRows from localStorage or props
    const [firstRow, setFirstRow] = (0, $spJKX.useState)(showPager === false ? 0 : 0);
    const [pageRows, setPageRows] = (0, $spJKX.useState)(()=>{
        if (showPager === false) return Infinity;
        if ((localSettings === null || localSettings === void 0 ? void 0 : localSettings.pageRows) && showPager) {
            if (localSettings.pageRows === "Infinity") return Infinity;
            return typeof localSettings.pageRows === "string" ? parseInt(localSettings.pageRows, 10) : localSettings.pageRows;
        }
        return 25;
    });
    (0, $spJKX.useEffect)(()=>{
        if (showPager === false) (0, $spJKX.startTransition)(()=>{
            setFirstRow(0);
            setPageRows(Infinity);
        });
    }, [
        showPager
    ]);
    const [currentColumnFilter, setCurrentColumnFilter] = (0, $spJKX.useState)(null);
    const [currentColumnFilters, setCurrentColumnFilters] = (0, $spJKX.useState)([]);
    const filterFn = (row)=>{
        if (showFilter && filterData) {
            const filterFns = fields.filter((f)=>f.filterOutFn).map((f)=>f.filterOutFn);
            return !filterFns.some((fn)=>fn(row));
        } else return true;
    };
    const searchFn = (row)=>{
        if (showSearch && searchText.trim().length > 0) {
            const searchFns = fields.filter((f)=>f.searchFn).map((f)=>f.searchFn);
            return searchFns.some((fn)=>fn(row, searchText));
        } else return true;
    };
    const sortFn = (rowa, rowb)=>{
        try {
            var _fields_find;
            const sortFn = (_fields_find = fields.find((f)=>f.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name))) === null || _fields_find === void 0 ? void 0 : _fields_find.sortFn;
            if (sortFn && sortBy) return sortBy.asc ? sortFn(rowa, rowb, sortBy) : -sortFn(rowa, rowb, sortBy);
            else return 0;
        } catch (error) {
            console.warn(`Sort failed because ${error}`);
            return 0;
        }
    };
    // Get view data
    const viewData = tableData.filter(filterFn).filter(searchFn).filter((row)=>{
        return currentColumnFilters.map((cf)=>{
            const columnValue = $8610d47387f4c16e$export$5813a5ff74a5f299(row[cf.columnName], true, columnFilterValueFns[cf.columnName]);
            return cf.values.some((v)=>columnValue.includes(v));
        }).reduce((prev, cur)=>prev && cur, true);
    }).sort(sortFn);
    (0, $spJKX.useEffect)(()=>{
        if (viewData.length <= firstRow && viewData.length > 0) (0, $spJKX.startTransition)(()=>setFirstRow(0));
    }, [
        viewData.length,
        firstRow
    ]);
    // Update sort order
    const updateSortBy = (field)=>{
        if (field.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name) && (sortBy === null || sortBy === void 0 ? void 0 : sortBy.asc) === false) setSortBy(null);
        else setSortBy({
            name: field.name,
            asc: field.name === (sortBy === null || sortBy === void 0 ? void 0 : sortBy.name) ? !sortBy.asc : true,
            columnFilterValueFn: columnFilterValueFns[field.name]
        });
    };
    // Get current column items
    // For each column, show values that exist after applying OTHER column filters (Excel-like behavior)
    const currentColumnItems = fields.filter((f)=>f.canColumnFilter).map((f)=>({
            columnName: f.name,
            values: Array.from(new Set(tableData.filter((row)=>{
                // Apply all column filters EXCEPT the one for this column
                return currentColumnFilters.filter((cf)=>cf.columnName !== f.name).map((cf)=>{
                    const columnValue = $8610d47387f4c16e$export$5813a5ff74a5f299(row[cf.columnName], true, columnFilterValueFns[cf.columnName]);
                    return cf.values.some((v)=>columnValue.includes(v));
                }).reduce((prev, cur)=>prev && cur, true);
            }).flatMap((t)=>$8610d47387f4c16e$export$5813a5ff74a5f299(t[f.name], true, columnFilterValueFns[f.name]))))
        }));
    // Toggle all viewed rows
    const toggleAllCurrentSelection = ()=>{
        // Select available if some are not selected
        const viewedKeys = viewData.filter((rowData)=>typeof rowData[keyField] === "string" || typeof rowData[keyField] === "number").map((rowData)=>rowData[keyField]);
        // Add if any of the current selection are not selected
        if (viewedKeys.some((v)=>!(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(v)))) setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection([
            ...currentSelection,
            ...viewedKeys.filter((v)=>!(currentSelection === null || currentSelection === void 0 ? void 0 : currentSelection.includes(v)))
        ]);
        else setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection(currentSelection.filter((s)=>!viewedKeys.includes(s)));
    };
    // Toggle individual row
    const toggleSelection = (rowId)=>{
        // Check key exists
        // istanbul ignore else
        if (tableData.findIndex((row)=>row[keyField] === rowId) > -1) {
            // Create new selection
            const newSelection = [
                ...currentSelection
            ];
            const ix = newSelection.findIndex((s)=>s === rowId);
            if (ix > -1) newSelection.splice(ix, 1);
            else newSelection.push(rowId);
            setCurrentSelection === null || setCurrentSelection === void 0 || setCurrentSelection(newSelection);
        }
    };
    // Save local settings
    const updateLocalSettings = (setting, value)=>{
        const localSettingsText = window.localStorage.getItem(`asup.simple-table.${id}.settings`);
        const localSettings = JSON.parse(localSettingsText !== null && localSettingsText !== void 0 ? localSettingsText : "{}");
        // istanbul ignore else
        if (setting === "pageRows" && value && !Array.isArray(value)) localSettings.pageRows = value === Infinity ? "Infinity" : value;
        else if (setting === "headerWidths" && value && Array.isArray(value)) localSettings.headerWidths = value;
        window.localStorage.setItem(`asup.simple-table.${id}.settings`, JSON.stringify(localSettings));
    };
    (0, $spJKX.useEffect)(()=>{
        // istanbul ignore else
        if (mainBackgroundColor) document.documentElement.style.setProperty("--st-main-background-color", mainBackgroundColor);
        // istanbul ignore else
        if (headerBackgroundColor) document.documentElement.style.setProperty("--st-header-background-color", headerBackgroundColor);
        // istanbul ignore else
        if (selectedBackgroundColor) document.documentElement.style.setProperty("--st-selected-background-color", selectedBackgroundColor);
        // istanbul ignore else
        if (selectActiveColor) document.documentElement.style.setProperty("--st-select-active", selectActiveColor);
        // istanbul ignore else
        if (selectInactiveColor) document.documentElement.style.setProperty("--st-select-inactive", selectInactiveColor);
        return ()=>{
            // Reset to defaults when component unmounts
            document.documentElement.style.removeProperty("--st-main-background-color");
            document.documentElement.style.removeProperty("--st-header-background-color");
            document.documentElement.style.removeProperty("--st-selected-background-color");
            document.documentElement.style.removeProperty("--st-select-active");
            document.documentElement.style.removeProperty("--st-select-inactive");
        };
    }, [
        mainBackgroundColor,
        headerBackgroundColor,
        selectedBackgroundColor,
        selectActiveColor,
        selectInactiveColor
    ]);
    return (0, $bR5nk.jsx)($8610d47387f4c16e$var$$29b1c1a3e3f50a4f$export$2fa61d0504f4f554.Provider, {
        value: {
            id: id,
            fields: fields,
            keyField: keyField,
            viewData: viewData,
            totalRows: tableData.length,
            setTableData: setTableData,
            selectable: selectable,
            showSearch: showSearch,
            showFilter: showFilter,
            filterLabel: filterLabel,
            filterData: filterData,
            setFilterData: setFilterData,
            searchLabel: searchLabel,
            searchText: searchText,
            setSearchText: setSearchText,
            sortBy: sortBy,
            updateSortBy: updateSortBy,
            currentSelection: currentSelection,
            toggleAllCurrentSelection: toggleAllCurrentSelection,
            toggleSelection: toggleSelection,
            columnWidths: columnWidths,
            setColumnWidth: (name, width)=>{
                const newColumnWidths = [
                    ...columnWidths
                ];
                // istanbul ignore else
                if (fields.map((f)=>f.name).includes(name)) {
                    const ix = newColumnWidths.findIndex((c)=>c.name === name);
                    if (ix === -1) newColumnWidths.push({
                        name: name,
                        width: width
                    });
                    else newColumnWidths[ix] = {
                        name: name,
                        width: width
                    };
                }
                setColumnWidths(newColumnWidths);
                updateLocalSettings("headerWidths", newColumnWidths);
                onWidthChange === null || onWidthChange === void 0 || onWidthChange(newColumnWidths);
            },
            pageRows: pageRows,
            setPageRows: (ret)=>{
                setPageRows(ret);
                updateLocalSettings("pageRows", ret);
                onPagerChange === null || onPagerChange === void 0 || onPagerChange({
                    firstRow: firstRow,
                    pageRows: ret
                });
            },
            firstRow: firstRow,
            setFirstRow: (ret)=>{
                setFirstRow(ret);
                onPagerChange === null || onPagerChange === void 0 || onPagerChange({
                    firstRow: ret,
                    pageRows: pageRows
                });
            },
            currentColumnItems: currentColumnItems,
            currentColumnFilter: currentColumnFilter,
            setCurrentColumnFilter: setCurrentColumnFilter,
            currentColumnFilters: currentColumnFilters,
            setCurrentColumnFilters: setCurrentColumnFilters,
            inputGroupClassName: inputGroupClassName,
            filterLabelClassName: filterLabelClassName,
            filterCheckClassName: filterCheckClassName,
            searchLabelClassName: searchLabelClassName,
            searchInputClassName: searchInputClassName,
            headerBackgroundColor: headerBackgroundColor
        },
        children: (0, $bR5nk.jsxs)("div", {
            className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).main,
            children: [
                (showHeader || showSearch || showFilter) && (0, $bR5nk.jsxs)("div", {
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).titleHolder,
                    children: [
                        (0, $bR5nk.jsx)("h5", {
                            className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).title,
                            children: showHeader && (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                children: [
                                    headerLabel,
                                    selectable && currentSelection.length > 0 && (0, $bR5nk.jsxs)("small", {
                                        children: [
                                            currentSelection.length,
                                            " selected"
                                        ]
                                    })
                                ]
                            })
                        }),
                        showSearch && fields.filter((f)=>f.searchFn).length > 0 && (0, $bR5nk.jsx)($8610d47387f4c16e$var$$47fed6d59054ee6e$export$66026d92cfdafe91, {}),
                        showFilter && fields.filter((f)=>f.filterOutFn).length > 0 && (0, $bR5nk.jsx)($8610d47387f4c16e$var$$37494a5c2c819927$export$3a5aecd8506640b7, {})
                    ]
                }),
                (0, $bR5nk.jsx)("div", {
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).scroll,
                    style: {
                        height: `calc(100% ${showHeader || showSearch || showFilter ? "- 46px" : ""} ${showPager ? " - 1.75rem" : ""}`
                    },
                    children: (0, $bR5nk.jsx)("div", {
                        className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).holder,
                        children: (0, $bR5nk.jsxs)("table", (0, $2q24i._)((0, $1JqPC._)({}, rest), {
                            id: id,
                            className: [
                                /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).table,
                                tableClassName
                            ].join(" "),
                            children: [
                                (0, $bR5nk.jsx)("thead", {
                                    children: (0, $bR5nk.jsxs)("tr", {
                                        children: [
                                            selectable && (0, $bR5nk.jsx)($8610d47387f4c16e$var$$06184096f9fd7746$export$fe2caba3b87edbe3, {}),
                                            (0, $bR5nk.jsx)($8610d47387f4c16e$var$$01515f53c0c8c9ec$export$91068a7395f62723, {})
                                        ]
                                    })
                                }),
                                (0, $bR5nk.jsx)($8610d47387f4c16e$var$$688bd579c4247c44$export$166eb73abdd0a383, {})
                            ]
                        }))
                    })
                }),
                showPager && (0, $bR5nk.jsx)("div", {
                    className: /*@__PURE__*/ $8610d47387f4c16e$var$$parcel$interopDefault($8610d47387f4c16e$var$$9a300121ef89926b$exports).footerHolder,
                    children: (0, $bR5nk.jsx)($8610d47387f4c16e$var$$3b94566e8ce64411$export$4b6ad0e8a3e0376c, {})
                })
            ]
        })
    });
};
$8610d47387f4c16e$export$3fe48f9151d0ecc2.displayName = "SimpleTable";
var $8610d47387f4c16e$var$$bed788c620775009$exports = {};
$8610d47387f4c16e$var$$parcel$exportWildcard($8610d47387f4c16e$var$$b65191f6d0a0a991$exports, $8610d47387f4c16e$var$$bed788c620775009$exports);
var $8610d47387f4c16e$var$$3d005c8713d7dfb7$exports = {};
var $8610d47387f4c16e$var$$b5ad5f5c6daca351$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$b5ad5f5c6daca351$exports, "convertLocaleDateToUTCString", function() {
    return $8610d47387f4c16e$export$e50c52e1a45b9cde;
});
const $8610d47387f4c16e$export$e50c52e1a45b9cde = (s)=>{
    const d = new Date(s);
    return d instanceof Date && !isNaN(d.getTime()) ? `${new Date(d.getTime()).toISOString()}` : "Invalid date";
};
var $8610d47387f4c16e$var$$e186acb03c99a462$exports = {};
$8610d47387f4c16e$var$$parcel$export($8610d47387f4c16e$var$$e186acb03c99a462$exports, "simpleTableSortFn", function() {
    return $8610d47387f4c16e$export$6cbd403afa8090eb;
});
function $8610d47387f4c16e$export$6cbd403afa8090eb(a, b, sortBy) {
    var _columnFilterValue_, _columnFilterValue_1, _columnFilterValue_2, _columnFilterValue_3;
    const ret = sortBy.columnFilterValueFn ? ((_columnFilterValue_ = $8610d47387f4c16e$export$5813a5ff74a5f299(a[sortBy.name], false, sortBy.columnFilterValueFn)[0]) !== null && _columnFilterValue_ !== void 0 ? _columnFilterValue_ : "").localeCompare((_columnFilterValue_1 = $8610d47387f4c16e$export$5813a5ff74a5f299(b[sortBy.name], false, sortBy.columnFilterValueFn)[0]) !== null && _columnFilterValue_1 !== void 0 ? _columnFilterValue_1 : "") : typeof a[sortBy.name] === "number" || typeof b[sortBy.name] === "number" ? (typeof a[sortBy.name] === "number" ? a[sortBy.name] : -Infinity) - (typeof b[sortBy.name] === "number" ? b[sortBy.name] : -Infinity) : a[sortBy.name] instanceof Date && b[sortBy.name] instanceof Date ? a[sortBy.name].getTime() - b[sortBy.name].getTime() : ((_columnFilterValue_2 = $8610d47387f4c16e$export$5813a5ff74a5f299(a[sortBy.name], false)[0]) !== null && _columnFilterValue_2 !== void 0 ? _columnFilterValue_2 : "").localeCompare((_columnFilterValue_3 = $8610d47387f4c16e$export$5813a5ff74a5f299(b[sortBy.name], false)[0]) !== null && _columnFilterValue_3 !== void 0 ? _columnFilterValue_3 : "");
    return ret;
}
$8610d47387f4c16e$var$$parcel$exportWildcard($8610d47387f4c16e$var$$3d005c8713d7dfb7$exports, $8610d47387f4c16e$var$$2d0562c3236da942$exports);
$8610d47387f4c16e$var$$parcel$exportWildcard($8610d47387f4c16e$var$$3d005c8713d7dfb7$exports, $8610d47387f4c16e$var$$2121208b4d86b049$exports);
$8610d47387f4c16e$var$$parcel$exportWildcard($8610d47387f4c16e$var$$3d005c8713d7dfb7$exports, $8610d47387f4c16e$var$$b5ad5f5c6daca351$exports);
$8610d47387f4c16e$var$$parcel$exportWildcard($8610d47387f4c16e$var$$3d005c8713d7dfb7$exports, $8610d47387f4c16e$var$$e186acb03c99a462$exports);

});
parcelRegister("1JqPC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $142ece94f4a876e2$export$71511d61b312f219; });

var $fXF7W = parcelRequire("fXF7W");
function $142ece94f4a876e2$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $fXF7W._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("fXF7W", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b9ec44b421f5f324$export$71511d61b312f219; });
function $b9ec44b421f5f324$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("2q24i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1c2f9d35f0448547$export$71511d61b312f219; });
function $1c2f9d35f0448547$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c2f9d35f0448547$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c2f9d35f0448547$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("9i6Y9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6c3b336b1a1b204b$export$71511d61b312f219; });

var $h8DHM = parcelRequire("h8DHM");
function $6c3b336b1a1b204b$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $h8DHM._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("h8DHM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c7a1fba29292b784$export$71511d61b312f219; });
function $c7a1fba29292b784$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});



parcelRegister("7lozc", function(module, exports) {

$parcel$export(module.exports, "ReportVariantSelections", function () { return $06eb4eea125bb171$export$cee53cdc9fc94174; });

var $bR5nk = parcelRequire("bR5nk");

var $bvCZ6 = parcelRequire("bvCZ6");

var $69057 = parcelRequire("69057");

var $hal6R = parcelRequire("hal6R");

var $4lHS7 = parcelRequire("4lHS7");

var $bHoqH = parcelRequire("bHoqH");

var $5r1Zf = parcelRequire("5r1Zf");

var $llbNs = parcelRequire("llbNs");

const $06eb4eea125bb171$export$cee53cdc9fc94174 = ({ disabled: disabled = false, items: items })=>{
    const { state: state, dispatch: dispatch } = (0, $5r1Zf.useHBC)();
    if (!state || !dispatch) return null;
    const rows = items.flatMap((item)=>[
            undefined,
            ...(item.variantTemplates ?? []).map((variant)=>variant.name)
        ].map((name)=>({
                ...(0, $hal6R.mapTlfItemTableRow)({
                    ...item,
                    domain: item.variantTemplates?.find((variant)=>variant.name === name)?.domain ?? item.domain
                }),
                selectionKey: JSON.stringify([
                    item.id,
                    name
                ]),
                variantName: name ?? ((item.variantTemplates ?? []).length > 0 ? "Master" : ""),
                selectedVariantName: name
            })));
    const selected = rows.filter((row)=>{
        const selection = state.selections.find((entry)=>entry.id === row.id);
        return row.selectedVariantName === undefined ? selection?.includeMaster === true : (selection?.variantNames ?? []).includes(row.selectedVariantName);
    }).map((row)=>row.selectionKey);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bvCZ6.SimpleTable), {
        currentSelection: selected,
        data: rows,
        fields: (0, $69057.getTemplateHeaders)(false, false, items[0]?.primaryHierarchyLevel ?? (0, $4lHS7.eHierarchyLevel).Corporate, false, true),
        filterLabel: "Hide retired/decommissioned",
        id: "report-variant-selections",
        initialFilterSelected: true,
        keyField: "selectionKey",
        selectable: !disabled,
        selectedBackgroundColor: "rgba(0, 0, 0, 0.2)",
        setCurrentSelection: (keys)=>{
            const selectedRows = rows.filter((row)=>keys.includes(row.selectionKey));
            dispatch({
                operation: (0, $llbNs.SET_SELECTIONS),
                selections: [
                    ...state.selections.filter((entry)=>!items.some((item)=>item.id === entry.id)),
                    ...items.flatMap((item)=>{
                        const outputs = selectedRows.filter((row)=>row.id === item.id);
                        return (0, $bHoqH.getReportTlfSelection)(item, outputs.some((row)=>row.selectedVariantName === undefined), outputs.flatMap((row)=>row.selectedVariantName === undefined ? [] : [
                                row.selectedVariantName
                            ]));
                    })
                ]
            });
        },
        showFilter: true,
        showSearch: true,
        tableClassName: "tlf-item-table"
    });
};
$06eb4eea125bb171$export$cee53cdc9fc94174.displayName = "ReportVariantSelections";

});
parcelRegister("69057", function(module, exports) {

$parcel$export(module.exports, "getTemplateHeaders", function () { return $579a670f22bc1e8f$export$e84f728d34e83276; });

var $bvCZ6 = parcelRequire("bvCZ6");

var $4lHS7 = parcelRequire("4lHS7");

var $28ICw = parcelRequire("28ICw");

var $8Z0Lf = parcelRequire("8Z0Lf");

var $gWOPW = parcelRequire("gWOPW");
const $579a670f22bc1e8f$export$e84f728d34e83276 = (showSearchResults, showTocSearchResults, hierarchyLevel, showExport = false, showVariantName = false)=>{
    const headers = showExport ? (0, $28ICw.SearchResultsHeaders).filter((field)=>field.name !== "tlfTagValues" && field.name !== "additionalInformation") : showSearchResults ? (0, $28ICw.SearchResultsHeaders) : showTocSearchResults ? (0, $28ICw.SearchTocHeaders) : hierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report ? (0, $gWOPW.TocHeaders) : (0, $8Z0Lf.templateHeaders)(hierarchyLevel);
    return showVariantName ? [
        ...headers.slice(0, 1),
        {
            canColumnFilter: true,
            label: "Variant",
            name: "variantName",
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        ...headers.slice(1)
    ] : headers;
};

});
parcelRegister("28ICw", function(module, exports) {

$parcel$export(module.exports, "SearchResultsHeaders", function () { return $87b8d3e98322511c$export$647afdd8d6828a96; });
$parcel$export(module.exports, "SearchTocHeaders", function () { return $87b8d3e98322511c$export$3505d8dcc63ab819; });

var $bvCZ6 = parcelRequire("bvCZ6");

var $79NLw = parcelRequire("79NLw");

var $ispSl = parcelRequire("ispSl");

var $3EVAi = parcelRequire("3EVAi");

var $enV6S = parcelRequire("enV6S");

var $fI18F = parcelRequire("fI18F");
const $87b8d3e98322511c$export$647afdd8d6828a96 = [
    {
        name: "azsolIdVersion",
        label: "AZSOL ID/Version",
        width: "130px",
        sortFn: (0, $bvCZ6.simpleTableSortFn),
        searchFn: (0, $fI18F.searchTemplatesWithText),
        filterOutFn: (0, $enV6S.filterTemplates),
        renderFn: (0, $ispSl.TlfItemTableLinkCell),
        canColumnFilter: true
    },
    {
        name: "releaseStatus",
        label: "Status",
        width: "80px",
        sortFn: (0, $bvCZ6.simpleTableSortFn),
        canColumnFilter: true,
        renderFn: (0, $79NLw.RenderReleaseStatus)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $3EVAi.TlfItemTableTagsCell)
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "additionalInformation",
        label: "Additional information",
        width: "800px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    }
];
const $87b8d3e98322511c$export$3505d8dcc63ab819 = [
    {
        name: "taPrefix",
        label: "TA",
        width: "100px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "projectCode",
        label: "Project",
        width: "100px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "dNumber",
        label: "D Number",
        width: "100px",
        sortFn: (0, $bvCZ6.simpleTableSortFn),
        canColumnFilter: true,
        searchFn: (0, $fI18F.searchTemplatesWithText)
    },
    {
        name: "primaryHierarchyName",
        label: "Report",
        width: "200px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $3EVAi.TlfItemTableTagsCell)
    },
    {
        name: "tocNumber",
        label: "ToC Number",
        width: "100px",
        sortFn: (0, $bvCZ6.simpleTableSortFn),
        renderFn: (0, $ispSl.TlfItemTableLinkCell),
        canColumnFilter: true
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "additionalInformation",
        label: "Additional information",
        width: "800px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    },
    {
        name: "lastUpdatedFromHistory",
        label: "Last updated",
        width: "120px",
        canColumnFilter: true,
        sortFn: (0, $bvCZ6.simpleTableSortFn)
    }
];

});
parcelRegister("79NLw", function(module, exports) {

$parcel$export(module.exports, "RenderReleaseStatus", function () { return $6bfed3302d6ac30e$export$bac764dd5a399843; });

var $bR5nk = parcelRequire("bR5nk");

var $4lHS7 = parcelRequire("4lHS7");
const $6bfed3302d6ac30e$export$bac764dd5a399843 = ({ rowData: rowData })=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "overflow-hidden",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            children: rowData.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report ? "" : rowData.releaseStatus === (0, $4lHS7.eReleaseStatus).ReleasePending ? (0, $4lHS7.eReleaseStatus).Draft : [
                (0, $4lHS7.eReleaseStatus).DecommissingPending,
                (0, $4lHS7.eReleaseStatus).RetirePending
            ].includes(rowData.releaseStatus) ? (0, $4lHS7.eReleaseStatus).Valid : rowData.releaseStatus
        })
    });
$6bfed3302d6ac30e$export$bac764dd5a399843.displayName = "RenderReleaseStatus";

});

parcelRegister("ispSl", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableLinkCell", function () { return $5420fc8705914eed$export$1a7099def93c1d51; });

var $bR5nk = parcelRequire("bR5nk");

var $4lHS7 = parcelRequire("4lHS7");

var $iBbNa = parcelRequire("iBbNa");
const $5420fc8705914eed$export$1a7099def93c1d51 = ({ rowData: rowData })=>{
    const searchParams = rowData.searchParams;
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
        id: `tlfitemtable-link-${rowData.id}`,
        to: rowData.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report ? `/TlfDesigner/${rowData.id}${searchParams ? `?${searchParams.toString()}` : ""}` : `/TlfDesigner/${rowData.azsolId}/${rowData.version}${searchParams ? `?${searchParams.toString()}` : ""}`,
        children: rowData.primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report ? `${rowData.tocNumber ?? "!!toc!! not set"}` : `${rowData.azsolId}/${rowData.version}`
    });
};
$5420fc8705914eed$export$1a7099def93c1d51.displayName = "TlfItemTableLinkCell";

});

parcelRegister("3EVAi", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableTagsCell", function () { return $ae092ac8af4a96da$export$2979fe2b0cabb035; });

var $bR5nk = parcelRequire("bR5nk");

var $1EdOx = parcelRequire("1EdOx");
const $ae092ac8af4a96da$export$2979fe2b0cabb035 = ({ rowData: rowData })=>{
    const tags = Array.isArray(rowData.tlfTags) ? rowData.tlfTags : [];
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "tlf-tags-cell",
        children: tags.map((tag)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $1EdOx.default), {
                bg: "secondary",
                className: "me-1",
                children: tag.tagValue
            }, tag.tagId || tag.tagValue))
    });
};
$ae092ac8af4a96da$export$2979fe2b0cabb035.displayName = "TlfItemTableTagsCell";

});

parcelRegister("enV6S", function(module, exports) {

$parcel$export(module.exports, "filterTemplates", function () { return $25d77102d124f2da$export$883cc5315f212021; });

var $4lHS7 = parcelRequire("4lHS7");
const $25d77102d124f2da$export$883cc5315f212021 = (row)=>[
        (0, $4lHS7.eReleaseStatus).Retired,
        (0, $4lHS7.eReleaseStatus).Decommissioned
    ].includes(row.releaseStatus);

});

parcelRegister("fI18F", function(module, exports) {

$parcel$export(module.exports, "searchTemplatesWithText", function () { return $b8860043529cc138$export$6a11aa7c47593815; });
const $b8860043529cc138$export$6a11aa7c47593815 = (row, searchText)=>{
    const needle = searchText.toLowerCase().trim();
    return `${row.azsolIdVersion ?? ""}`.toLowerCase().includes(needle) || `${row.title ?? ""}`.toLowerCase().includes(needle) || `${row.tocLabel ?? ""}`.toLowerCase().includes(needle) || Array.isArray(row.tlfTags) && row.tlfTags.some((tag)=>tag.tagValue.toLowerCase().includes(needle));
};

});


parcelRegister("8Z0Lf", function(module, exports) {

$parcel$export(module.exports, "templateHeaders", function () { return $1f68a586e7c49385$export$c3aa695d49f838b0; });

var $bvCZ6 = parcelRequire("bvCZ6");

var $4lHS7 = parcelRequire("4lHS7");

var $j6HtQ = parcelRequire("j6HtQ");

var $79NLw = parcelRequire("79NLw");

var $8UdqM = parcelRequire("8UdqM");

var $ispSl = parcelRequire("ispSl");

var $3EVAi = parcelRequire("3EVAi");

var $4G8PP = parcelRequire("4G8PP");

var $enV6S = parcelRequire("enV6S");

var $fI18F = parcelRequire("fI18F");
/** Hierarchy levels that show the parent template column. */ const $1f68a586e7c49385$var$parentTemplateLevels = [
    (0, $4lHS7.eHierarchyLevel).TA,
    (0, $4lHS7.eHierarchyLevel).Project
];
/** Hierarchy levels that show the versions available column. */ const $1f68a586e7c49385$var$versionsLevels = [
    (0, $4lHS7.eHierarchyLevel).Corporate
];
const $1f68a586e7c49385$export$c3aa695d49f838b0 = (hierarchyLevel)=>[
        {
            name: "azsolIdVersion",
            label: "AZSOL ID/Version",
            width: "110px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn),
            searchFn: (0, $fI18F.searchTemplatesWithText),
            filterOutFn: (0, $enV6S.filterTemplates),
            renderFn: (0, $ispSl.TlfItemTableLinkCell)
        },
        {
            name: "tlfTagValues",
            label: "Tags",
            width: "200px",
            canColumnFilter: true,
            renderFn: (0, $3EVAi.TlfItemTableTagsCell)
        },
        {
            name: "flags",
            label: "",
            width: "50px",
            renderFn: (0, $8UdqM.TlfItemTableFlags)
        },
        {
            name: "domain",
            label: "Domain",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        ...$1f68a586e7c49385$var$parentTemplateLevels.includes(hierarchyLevel) ? [
            {
                name: "parentTemplate",
                label: "Parent Template",
                width: "100px",
                canColumnFilter: true,
                renderFn: (0, $j6HtQ.ParentTemplateLink),
                sortFn: (0, $bvCZ6.simpleTableSortFn)
            }
        ] : [],
        ...$1f68a586e7c49385$var$versionsLevels.includes(hierarchyLevel) ? [
            {
                name: "taVersionsAvailable",
                label: "TA Versions Available",
                width: "200px",
                canColumnFilter: true,
                renderFn: (0, $4G8PP.TlfItemTaVersionsLinks)
            }
        ] : [],
        {
            name: "tocLabel",
            label: "Title",
            width: "550px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        {
            name: "type",
            label: "Type",
            width: "80px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        {
            name: "releaseStatus",
            label: "Status",
            width: "80px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn),
            renderFn: (0, $79NLw.RenderReleaseStatus)
        },
        {
            name: "releaseDate",
            label: "Release date",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        {
            name: "decommissionDate",
            label: "Decommission date",
            width: "100px",
            canColumnFilter: true,
            sortFn: (0, $bvCZ6.simpleTableSortFn)
        },
        {
            name: "additionalInformation",
            label: "Additional information",
            width: "150px",
            canColumnFilter: true
        }
    ];

});
parcelRegister("j6HtQ", function(module, exports) {

$parcel$export(module.exports, "ParentTemplateLink", function () { return $dbb677d75e0b9b85$export$4ae481549536e242; });

var $bR5nk = parcelRequire("bR5nk");

var $4lHS7 = parcelRequire("4lHS7");

var $ispSl = parcelRequire("ispSl");
const $dbb677d75e0b9b85$export$4ae481549536e242 = (props)=>{
    const relationships = props.rowData["relationships"];
    const basedOnLink = relationships?.findLast((r)=>r.linkType === (0, $4lHS7.eLinkType).BasedOn);
    return basedOnLink ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ispSl.TlfItemTableLinkCell), {
        ...props,
        rowData: {
            ...basedOnLink,
            primaryHierarchyLevel: basedOnLink.linkLocation?.linkLevel
        }
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
};
$dbb677d75e0b9b85$export$4ae481549536e242.displayName = "ParentTemplateLink";

});

parcelRegister("8UdqM", function(module, exports) {

$parcel$export(module.exports, "TlfItemTableFlags", function () { return $2509751dd68efc76$export$972db95c9f1ccfe1; });

var $bR5nk = parcelRequire("bR5nk");

var $4lHS7 = parcelRequire("4lHS7");

var $aYj2Y = parcelRequire("aYj2Y");

var $spJKX = parcelRequire("spJKX");

var $30fnR = parcelRequire("30fnR");
var $6L34z = parcelRequire("6L34z");
var $3FPRy = parcelRequire("3FPRy");

var $6is3u = parcelRequire("6is3u");
const $2509751dd68efc76$export$972db95c9f1ccfe1 = ({ rowData: rowData })=>{
    const tlfItemTableContext = (0, $spJKX.useContext)((0, $6is3u.TlfItemTableContext));
    const [, startTransition] = (0, $spJKX.useTransition)();
    const thisRowData = (0, $aYj2Y.isTlfItemIndexReadDto)(rowData) ? rowData : null;
    const [renderTime, setRenderTime] = (0, $spJKX.useState)(0);
    (0, $spJKX.useEffect)(()=>{
        // Set current time after mount to avoid calling an impure function during render.
        // Added as useEffect to statisfy React v19's rules of hooks.
        startTransition(()=>setRenderTime(Date.now()));
    }, []);
    return !thisRowData ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        style: {
            width: "100%"
        },
        className: "d-flex justify-content-center",
        children: [
            thisRowData.releaseStatus === (0, $4lHS7.eReleaseStatus).Valid && thisRowData.releaseDate && new Date(thisRowData.releaseDate).getTime() >= renderTime - 2419200000 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6L34z.default), {
                title: "New",
                "aria-label": "New item"
            }),
            [
                (0, $4lHS7.eReleaseStatus).Valid,
                (0, $4lHS7.eReleaseStatus).DecommissingPending
            ].includes(thisRowData.releaseStatus) && thisRowData.relationships.filter((r)=>r.linkType === (0, $4lHS7.eLinkType).Successor).length > 0 && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $30fnR.default), {
                title: "New draft exists",
                "aria-label": "New draft exists"
            }),
            tlfItemTableContext.canDelete && tlfItemTableContext.deleteClick && [
                (0, $4lHS7.eReleaseStatus).Draft,
                (0, $4lHS7.eReleaseStatus).ReleasePending
            ].includes(thisRowData.releaseStatus) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3FPRy.default), {
                title: "Delete",
                "aria-label": "Delete item",
                color: "var(--bs-danger)",
                onClick: ()=>tlfItemTableContext.deleteClick && tlfItemTableContext.deleteClick(rowData.id, rowData.azsolId, rowData.version)
            })
        ]
    });
};
$2509751dd68efc76$export$972db95c9f1ccfe1.displayName = "TlfItemTableFlags";

});
parcelRegister("30fnR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22fd4e1ded78b361$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $22fd4e1ded78b361$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $22fd4e1ded78b361$var$_extends() {
    return $22fd4e1ded78b361$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $22fd4e1ded78b361$var$_extends.apply(null, arguments);
}
function $22fd4e1ded78b361$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $22fd4e1ded78b361$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $22fd4e1ded78b361$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $22fd4e1ded78b361$var$HourglassSplit = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $22fd4e1ded78b361$var$_objectWithoutProperties(_ref, $22fd4e1ded78b361$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $22fd4e1ded78b361$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-hourglass-split',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"
    }));
});
$22fd4e1ded78b361$var$HourglassSplit.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $22fd4e1ded78b361$export$2e2bcd8739ae039 = $22fd4e1ded78b361$var$HourglassSplit;

});

parcelRegister("6L34z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb984052a5b516e$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $4eb984052a5b516e$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $4eb984052a5b516e$var$_extends() {
    return $4eb984052a5b516e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4eb984052a5b516e$var$_extends.apply(null, arguments);
}
function $4eb984052a5b516e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $4eb984052a5b516e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $4eb984052a5b516e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $4eb984052a5b516e$var$Star = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $4eb984052a5b516e$var$_objectWithoutProperties(_ref, $4eb984052a5b516e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $4eb984052a5b516e$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-star',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"
    }));
});
$4eb984052a5b516e$var$Star.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $4eb984052a5b516e$export$2e2bcd8739ae039 = $4eb984052a5b516e$var$Star;

});


parcelRegister("4G8PP", function(module, exports) {

$parcel$export(module.exports, "TlfItemTaVersionsLinks", function () { return $0f4e88e1f6b5515c$export$80f06044444f0845; });

var $bR5nk = parcelRequire("bR5nk");

var $4lHS7 = parcelRequire("4lHS7");

var $ispSl = parcelRequire("ispSl");
const $0f4e88e1f6b5515c$export$80f06044444f0845 = (props)=>{
    const links = props.rowData["relationships"]?.filter((r)=>r.linkType === (0, $4lHS7.eLinkType).HasVersion && r.linkLocation?.linkLevel === (0, $4lHS7.eHierarchyLevel).TA).sort((a, b)=>`${a.azsolId}/${a.version}`.localeCompare(`${b.azsolId}/${b.version}`));
    return links && links.length > 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
        className: "d-inline-flex flex-wrap align-items-center",
        children: links.map((link, index)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                className: "d-inline-flex align-items-center",
                children: [
                    index > 0 && ", ",
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ispSl.TlfItemTableLinkCell), {
                        ...props,
                        rowData: {
                            ...link,
                            id: `${props.rowData.id}-${link.linkId}`,
                            primaryHierarchyLevel: link.linkLocation?.linkLevel
                        }
                    })
                ]
            }, link.linkId))
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {});
};
$0f4e88e1f6b5515c$export$80f06044444f0845.displayName = "TlfItemVersionsLinks";

});


parcelRegister("gWOPW", function(module, exports) {

$parcel$export(module.exports, "TocHeaders", function () { return $bc306732af7d29bc$export$aa09c984a793627c; });

var $bvCZ6 = parcelRequire("bvCZ6");

var $d76ZD = parcelRequire("d76ZD");

var $ispSl = parcelRequire("ispSl");

var $3EVAi = parcelRequire("3EVAi");
const $bc306732af7d29bc$export$aa09c984a793627c = [
    {
        name: "tocNumber",
        label: "Number",
        width: "110px",
        // Sort TOC items by number using custom sort function.
        sortFn: (a, b)=>(0, $d76ZD.tocSort)(a.tocNumber, b.tocNumber),
        // Search TOC items by number, label, copied-from template ID, or tags.
        searchFn: (row, searchText)=>{
            const normalised = searchText.toLowerCase().trim();
            const matchesTextFields = row.tocNumber?.toLowerCase().includes(normalised) || row.tocLabel?.toLowerCase().includes(normalised) || row.tlfCopiedFromLink?.azsolId?.toLowerCase().includes(normalised);
            const matchesTags = Array.isArray(row.tlfTags) && row.tlfTags.some((tag)=>tag.tagValue.toLowerCase().includes(normalised));
            return (matchesTextFields ?? false) || matchesTags;
        },
        canColumnFilter: true,
        renderFn: (0, $ispSl.TlfItemTableLinkCell)
    },
    {
        name: "tlfTagValues",
        label: "Tags",
        width: "200px",
        canColumnFilter: true,
        renderFn: (0, $3EVAi.TlfItemTableTagsCell)
    },
    {
        name: "tocLabel",
        label: "Title",
        width: "600px",
        sortFn: (0, $bvCZ6.simpleTableSortFn),
        canColumnFilter: true
    }
];

});


parcelRegister("hal6R", function(module, exports) {

$parcel$export(module.exports, "mapTlfItemTableRow", function () { return $b640fa878bb3afcf$export$e94ec2ae64671f9c; });

var $4lHS7 = parcelRequire("4lHS7");

var $8uW66 = parcelRequire("8uW66");
const $b640fa878bb3afcf$export$e94ec2ae64671f9c = (row)=>{
    const basedOnTemplate = (0, $8uW66.getBasedOnRelationship)(row);
    return {
        ...row,
        azsolIdVersion: `${row.azsolId}/${row.version}`,
        tlfTagValues: row.tlfTags?.map((tag)=>tag.tagValue) ?? [],
        parentTemplate: basedOnTemplate ? `${basedOnTemplate.azsolId}/${basedOnTemplate.version}` : "",
        taVersionsAvailable: row.relationships.filter((r)=>r.linkType === (0, $4lHS7.eLinkType).HasVersion).map((r)=>`${r.azsolId}/${r.version}`)
    };
};

});
parcelRegister("8uW66", function(module, exports) {

$parcel$export(module.exports, "getBasedOnRelationship", function () { return $4dcb8e3c075a8d30$export$131767e367a48189; });

var $4lHS7 = parcelRequire("4lHS7");
const $4dcb8e3c075a8d30$export$131767e367a48189 = (tlfItem)=>{
    const basedOnLinks = tlfItem?.relationships?.filter((r)=>r.linkType === (0, $4lHS7.eLinkType).BasedOn) ?? [];
    if (basedOnLinks.length === 0) return undefined;
    return basedOnLinks.at(-1);
};

});


parcelRegister("bHoqH", function(module, exports) {

$parcel$export(module.exports, "getReportTlfSelection", function () { return $4413bfc75474304e$export$9b1ee38de347cdd9; });
const $4413bfc75474304e$export$9b1ee38de347cdd9 = (item, includeMaster, variantNames)=>{
    const variants = (item.variantTemplates ?? []).filter((variant)=>variantNames.includes(variant.name));
    const domains = [
        ...includeMaster ? [
            item.domain
        ] : [],
        ...variants.map((variant)=>variant.domain ?? item.domain)
    ];
    return domains.length === 0 ? [] : [
        {
            azsolId: item.azsolId,
            // TODO: Can domain be removed from HierarchyTlfSelection
            // Retain any invalid selected domain so group validation cannot hide an invalid output.
            domain: domains.find((domain)=>!domain || domain === "BL") ?? domains[0],
            id: item.id,
            includeMaster: includeMaster,
            variantNames: variants.map((variant)=>variant.name),
            version: item.version
        }
    ];
};

});

parcelRegister("5r1Zf", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserContextProvider", function () { return $79cdfae5783dd717$export$70151fc5312f6f84; });
$parcel$export(module.exports, "useHBC", function () { return $79cdfae5783dd717$export$2ccd25337205a8d; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $jjv5Y = parcelRequire("jjv5Y");

var $cHpYl = parcelRequire("cHpYl");

var $h1k0x = parcelRequire("h1k0x");

var $spJKX = parcelRequire("spJKX");

var $g6trE = parcelRequire("g6trE");

var $5iS1Y = parcelRequire("5iS1Y");

var $c7083 = parcelRequire("c7083");

var $llbNs = parcelRequire("llbNs");
const $79cdfae5783dd717$export$cf131ad2cb2b8ec1 = {
    id: "hierarchy-browser",
    root: "",
    treeList: [],
    currentHierarchy: "",
    currentHierarchyType: null,
    currentAccessRights: [],
    showTableLinks: false,
    canSelect: false,
    selections: [],
    hierarchyTlfItemIndex: []
};
const $79cdfae5783dd717$export$70151fc5312f6f84 = ({ initialState: initialState, children: children })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const [state, dispatch] = (0, $spJKX.useReducer)((0, $5iS1Y.hierarchyBrowserReducer), {
        id: initialState?.id ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.id,
        root: initialState?.root ?? hierarchyContext?.hierarchyNodes.find((h)=>h.level === (0, $4lHS7.eHierarchyLevel).Corporate)?.id ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.root,
        treeList: initialState?.treeList ?? (hierarchyContext !== null ? (0, $c7083.hierarchyToNodes)(hierarchyContext.hierarchyNodes) : $79cdfae5783dd717$export$cf131ad2cb2b8ec1.treeList),
        currentHierarchy: initialState?.currentHierarchy ?? hierarchyContext?.hierarchy?.id ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.currentHierarchy,
        currentHierarchyType: hierarchyContext?.hierarchyNodes.find((h)=>h.id === (initialState?.currentHierarchy ?? hierarchyContext?.hierarchy?.id ?? // istanbul ignore next
            $79cdfae5783dd717$export$cf131ad2cb2b8ec1.currentHierarchy))?.type ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.currentHierarchyType,
        currentAccessRights: $79cdfae5783dd717$export$cf131ad2cb2b8ec1.currentAccessRights,
        showTableLinks: initialState?.showTableLinks ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.showTableLinks,
        canSelect: initialState?.canSelect ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.canSelect,
        selections: initialState?.selections ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.selections,
        hierarchyTlfItemIndex: initialState?.hierarchyTlfItemIndex ?? $79cdfae5783dd717$export$cf131ad2cb2b8ec1.hierarchyTlfItemIndex
    });
    const [corpRequest, setCorpRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const getCorporate = (0, $spJKX.useEffectEvent)(async ()=>{
        const request = await (0, $4dL47.loadWrapper)((0, $cHpYl.loadHierarchy), {
            hierarchyName: "Corporate"
        }, corpRequest, setCorpRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) dispatch({
            operation: (0, $llbNs.SET_CORPORATE_HIERARCHY),
            hierarchyNode: request.data
        });
    });
    (0, $spJKX.useEffect)(()=>{
        if (!hierarchyContext?.hierarchy) getCorporate();
    }, [
        hierarchyContext?.hierarchy
    ]);
    // Update current if an unknown item is selected
    const [loadCurrent, setLoadCurrent] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const getHierarchyAsync = (0, $spJKX.useCallback)(async (hierarchyId)=>{
        /* istanbul ignore else */ if (hierarchyContext) {
            const response = await (0, $4dL47.loadWrapper)((0, $cHpYl.loadHierarchy), {
                hierarchyId: hierarchyId
            }, {
                ...loadCurrent,
                error: false,
                errorText: undefined
            }, setLoadCurrent, appSettings.backEndUrl);
            if (response?.success) {
                dispatch({
                    operation: (0, $llbNs.ADD_HIERARCHY_NODES),
                    treeListData: (0, $c7083.hierarchyToNodes)([
                        response.data
                    ])
                });
                hierarchyContext.dispatch({
                    operation: (0, $llbNs.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        response.data
                    ]
                });
            }
        }
    }, [
        appSettings.backEndUrl,
        hierarchyContext,
        loadCurrent
    ]);
    (0, $spJKX.useEffect)(()=>{
        const currentNode = state.treeList.find((n)=>n.id === state.currentHierarchy);
        if (state.currentHierarchy && (!currentNode || !(0, $jjv5Y.isHierarchyReadDto)(currentNode.data))) getHierarchyAsync(state.currentHierarchy);
    }, [
        getHierarchyAsync,
        state
    ]);
    // Get current access rights
    const [arRequest, setArRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const updateAccessRights = (0, $spJKX.useCallback)(async (hierarchyId)=>{
        if (hierarchyId !== "") {
            const request = await (0, $4dL47.loadWrapper)((0, $h1k0x.getMyAccess), hierarchyId, arRequest, setArRequest, appSettings.backEndUrl);
            if (request?.success) dispatch({
                operation: (0, $llbNs.SET_CURRENT_ACCESS_RIGHTS),
                accessRights: request.data
            });
            else if (request?.success === false) dispatch({
                operation: (0, $llbNs.SET_CURRENT_ACCESS_RIGHTS),
                accessRights: []
            });
        } else dispatch({
            operation: (0, $llbNs.SET_CURRENT_ACCESS_RIGHTS),
            accessRights: []
        });
    }, [
        appSettings.backEndUrl,
        arRequest
    ]);
    (0, $spJKX.useEffect)(()=>{
        updateAccessRights(state.currentHierarchy);
    }, [
        state.currentHierarchy,
        updateAccessRights
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $g6trE.HierarchyBrowserContext).Provider, {
        value: {
            state: state,
            dispatch: dispatch,
            arRequest: arRequest,
            loadCurrent: loadCurrent
        },
        children: children
    });
};
$79cdfae5783dd717$export$70151fc5312f6f84.displayName = "HierarchyBrowserContextProvider";
const $79cdfae5783dd717$export$2ccd25337205a8d = ()=>{
    const context = (0, $spJKX.useContext)((0, $g6trE.HierarchyBrowserContext));
    return !context ? {
        state: null,
        dispatch: null,
        loadCurrent: {
            error: false,
            requesting: false
        },
        arRequest: {
            error: false,
            requesting: false
        }
    } : context;
};

});
parcelRegister("jjv5Y", function(module, exports) {

$parcel$export(module.exports, "isHierarchyReadDto", function () { return $287f6ec44a8833ab$export$104ac68fec1129b0; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $2Rhsi = parcelRequire("2Rhsi");
var $aVRpe = parcelRequire("aVRpe");
var $ghR9g = parcelRequire("ghR9g");

var $jek0L = parcelRequire("jek0L");

var $4lHS7 = parcelRequire("4lHS7");

var $dZtit = parcelRequire("dZtit");

var $aYj2Y = parcelRequire("aYj2Y");

var $dfXc9 = parcelRequire("dfXc9");

var $iTJ5e = parcelRequire("iTJ5e");

var $Vi820 = parcelRequire("Vi820");

var $kNsCs = parcelRequire("kNsCs");

var $dkJAo = parcelRequire("dkJAo");
const $287f6ec44a8833ab$export$104ac68fec1129b0 = (obj)=>{
    // Check object
    if (!obj || typeof obj !== "object") return false;
    // Check basic properties
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.lastUpdatedAt !== "string") return false;
    if (typeof chkObj.parentTag !== "string") return false;
    if (typeof chkObj.name !== "string") return false;
    if (typeof chkObj.parentId !== "string") return false;
    if (typeof chkObj.taPrefix !== "string") return false;
    if (typeof chkObj.projectCode !== "string") return false;
    if (typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.description !== "string") return false;
    if (chkObj.phase && typeof chkObj.phase !== "string") return false;
    if (typeof chkObj.hierarchyTag !== "string") return false;
    if (chkObj.reportType && typeof chkObj.reportType !== "string") return false;
    if (chkObj.status && typeof chkObj.status !== "string") return false;
    if (chkObj.studyStandardsDate && typeof chkObj.studyStandardsDate !== "string") return false;
    if (chkObj.tocMajorVersion && typeof chkObj.tocMajorVersion !== "number") return false;
    if (chkObj.tocMinorVersion && typeof chkObj.tocMinorVersion !== "number") return false;
    if (typeof chkObj.isBackupVersion !== "boolean") return false;
    if (chkObj.originHierarchyId && typeof chkObj.originHierarchyId !== "string") return false;
    if (typeof chkObj.hasClinicalLibrary !== "boolean") return false;
    if (chkObj.analysisMethods !== undefined && (!Array.isArray(chkObj.analysisMethods) || chkObj.analysisMethods.some((x)=>!(0, $ghR9g.isAnalysisMethod)(x)))) return false;
    // Check enums
    if (!Object.values((0, $4lHS7.eHierarchy)).includes(chkObj.type)) return false;
    if (!Object.values((0, $4lHS7.eHierarchyLevel)).includes(chkObj.level)) return false;
    // Check arrays
    if (!Array.isArray(chkObj.lists) || chkObj.lists.some((x)=>!(0, $2Rhsi.isAioExternalReplacements)(x, (0, $bX0x9.isIEditorV3)))) return false;
    if (!Array.isArray(chkObj.domainReplacements) || chkObj.domainReplacements.some((x)=>!(0, $dfXc9.isDomainReplacements)(x))) return false;
    if (!Array.isArray(chkObj.rowGroups) || chkObj.rowGroups.some((x)=>!(0, $aVRpe.isAitRowGroupData)(x, (0, $bX0x9.isIEditorV3), true))) return false;
    if (!Array.isArray(chkObj.sections) || chkObj.sections.some((x)=>!(0, $kNsCs.isITocSection)(x))) return false;
    if (!Array.isArray(chkObj.singles) || chkObj.singles.some((x)=>!(0, $2Rhsi.isAioExternalSingle)(x, (0, $bX0x9.isIEditorV3)))) return false;
    if (!Array.isArray(chkObj.domainList) || chkObj.domainList.some((x)=>typeof x !== "string")) return false;
    if (!Array.isArray(chkObj.children) || chkObj.children.some((x)=>!(0, $iTJ5e.isHierarchyChildReadDto)(x))) return false;
    if (!Array.isArray(chkObj.history) || chkObj.history.some((x)=>!(0, $Vi820.isHierarchyHistoryDto)(x))) return false;
    if (chkObj.tocMajorVersionDescriptions && (!Array.isArray(chkObj.tocMajorVersionDescriptions) || chkObj.tocMajorVersionDescriptions.some((x)=>!(0, $dkJAo.isTocMajorVersionDescription)(x)))) return false;
    if (!Array.isArray(chkObj.comments) || chkObj.comments.some((x)=>!(0, $jek0L.isCommentReadDto)(x))) return false;
    if (!Array.isArray(chkObj.hierarchyLinks) || chkObj.hierarchyLinks.some((x)=>!(0, $aYj2Y.isHierarchyLink)(x))) return false;
    // Check optional objects
    if (chkObj.clinicalLibrary && !(0, $dZtit.isClinicalLibraryReadDto)(chkObj.clinicalLibrary)) return false;
    if (chkObj.tlfTags !== undefined && (!Array.isArray(chkObj.tlfTags) || chkObj.tlfTags.some((x)=>!(0, $aYj2Y.isTlfTag)(x)))) return false;
    // Everything is good
    return true;
};

});
parcelRegister("dZtit", function(module, exports) {

$parcel$export(module.exports, "isClinicalLibraryReadDto", function () { return $c06595cc11984571$export$7d89a111a4e504ab; });

var $4lHS7 = parcelRequire("4lHS7");
const $c06595cc11984571$export$7d89a111a4e504ab = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.id !== "number") return false;
    if (typeof chkObj.hierarchyId !== "string") return false;
    if (!Object.values((0, $4lHS7.eHierarchyLevel)).includes(chkObj.hierarchyLevel)) return false;
    if (typeof chkObj.corporateId !== "string") return false;
    if (typeof chkObj.taId !== "undefined" && typeof chkObj.taId !== "string") return false;
    if (typeof chkObj.projectId !== "undefined" && typeof chkObj.projectId !== "string") return false;
    if (typeof chkObj.studyId !== "undefined" && typeof chkObj.studyId !== "string") return false;
    if (typeof chkObj.version !== "number") return false;
    // Check arrays (basic check only)
    if (!Array.isArray(chkObj.clinicalDatasets)) return false;
    if (!Array.isArray(chkObj.clinicalCodeLists)) return false;
    if (!Array.isArray(chkObj.clinicalValueLists)) return false;
    if (!Array.isArray(chkObj.clinicalComments)) return false;
    if (!Array.isArray(chkObj.clinicalMethods)) return false;
    if (!Array.isArray(chkObj.clinicalWhereClauses)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("dfXc9", function(module, exports) {

$parcel$export(module.exports, "isDomainReplacements", function () { return $88211b0058dab940$export$232af6082ec77c87; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $2Rhsi = parcelRequire("2Rhsi");
const $88211b0058dab940$export$232af6082ec77c87 = (obj)=>{
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    // Check lower interface
    if (!(0, $2Rhsi.isAioExternalSingle)(chkObj, (0, $bX0x9.isIEditorV3))) return false;
    if (typeof chkObj.domain !== "string") return false;
    return true;
};

});

parcelRegister("iTJ5e", function(module, exports) {

$parcel$export(module.exports, "isHierarchyChildReadDto", function () { return $ece96d819e50b505$export$20b938e0d0df0cff; });

var $4lHS7 = parcelRequire("4lHS7");
const $ece96d819e50b505$export$20b938e0d0df0cff = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist and types
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.name !== "string") return false;
    if (typeof chkObj.hierarchyTag !== "string") return false;
    if (typeof chkObj.parentTag !== "string") return false;
    // taPrefix, projectCode and dNumber are optional
    if (chkObj.taPrefix !== undefined && typeof chkObj.taPrefix !== "string") return false;
    if (chkObj.projectCode !== undefined && typeof chkObj.projectCode !== "string") return false;
    if (chkObj.dNumber !== undefined && typeof chkObj.dNumber !== "string") return false;
    if (typeof chkObj.tocMajorVersion !== "undefined" && typeof chkObj.tocMajorVersion !== "number") return false;
    if (typeof chkObj.tocMinorVersion !== "undefined" && typeof chkObj.tocMinorVersion !== "number") return false;
    // Check enums
    if (!Object.values((0, $4lHS7.eHierarchyLevel)).includes(chkObj.level)) return false;
    if (!Object.values((0, $4lHS7.eHierarchy)).includes(chkObj.type)) return false;
    // Everything is good
    return true;
};

});

parcelRegister("Vi820", function(module, exports) {

$parcel$export(module.exports, "isHierarchyHistoryDto", function () { return $1eb93ee29e2a907d$export$d854e2c508ca373; });
const $1eb93ee29e2a907d$export$d854e2c508ca373 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist and types
    const chkObj = obj;
    if (typeof chkObj.id !== "number") return false;
    if (typeof chkObj.date !== "string") return false;
    if (typeof chkObj.action !== "string") return false;
    if (typeof chkObj.comment !== "string") return false;
    if (typeof chkObj.userId !== "number") return false;
    if (typeof chkObj.userName !== "string") return false;
    // Everything is good
    return true;
};

});

parcelRegister("kNsCs", function(module, exports) {

$parcel$export(module.exports, "isITocSection", function () { return $f4a771f318d3c162$export$49229f7b5bd6f832; });
const $f4a771f318d3c162$export$49229f7b5bd6f832 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.id !== "string") return false;
    if (typeof chkObj.sectionNumber !== "string") return false;
    if (typeof chkObj.sectionLabel !== "string") return false;
    if (typeof chkObj.order !== "number") return false;
    // Everything is good
    return true;
};

});

parcelRegister("dkJAo", function(module, exports) {

$parcel$export(module.exports, "isTocMajorVersionDescription", function () { return $bad6fbbc3328c94d$export$81848127fef549a3; });
const $bad6fbbc3328c94d$export$81848127fef549a3 = (obj)=>{
    // Check object
    if (typeof obj !== "object" || obj === null) return false;
    // Check properties exist
    const chkObj = obj;
    if (typeof chkObj.tocMajorVersion !== "number") return false;
    if (typeof chkObj.description !== "string") return false;
    // Everything is good
    return true;
};

});


parcelRegister("h1k0x", function(module, exports) {

$parcel$export(module.exports, "getMyAccess", function () { return $5dbe46f123d5755c$export$defb43a444190f21; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $5dbe46f123d5755c$export$defb43a444190f21 = async (backEndUrl, hierarchyId, controller)=>{
    const url = `${backEndUrl}UserAccess/UserPermissions/Me/Hierarchies/${hierarchyId}`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, {
            signal: controller.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load my access failed", error);
    }
};

});

parcelRegister("g6trE", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserContext", function () { return $9daecd798a95b539$export$23f42ade2fafade; });

var $spJKX = parcelRequire("spJKX");
const $9daecd798a95b539$export$23f42ade2fafade = /*#__PURE__*/ (0, $spJKX.createContext)(null);

});

parcelRegister("5iS1Y", function(module, exports) {

$parcel$export(module.exports, "hierarchyBrowserReducer", function () { return $160424933aa55075$export$b72ff9b49dc01c40; });

var $bHoqH = parcelRequire("bHoqH");

var $c7083 = parcelRequire("c7083");

var $llbNs = parcelRequire("llbNs");
const $160424933aa55075$export$b72ff9b49dc01c40 = (state, action)=>{
    switch(action.operation){
        case 0, $llbNs.ADD_HIERARCHY_NODES:
            {
                const newTreeList = [
                    ...state.treeList.filter((hn)=>!action.treeListData.find((h)=>h.id === hn.id)),
                    ...action.treeListData
                ].sort((a, b)=>a.label.localeCompare(b.label));
                return {
                    ...state,
                    treeList: newTreeList
                };
            }
        case 0, $llbNs.ADD_SELECTION:
            {
                const newSelections = [
                    ...state.selections.filter((s)=>s.id !== action.selection.id),
                    action.selection
                ].sort((a, b)=>a.id.localeCompare(b.id));
                return {
                    ...state,
                    selections: newSelections
                };
            }
        case 0, $llbNs.REMOVE_SELECTION:
            {
                const newSelections = state.selections.filter((s)=>s.id !== action.selection.id);
                return {
                    ...state,
                    selections: newSelections
                };
            }
        case 0, $llbNs.SET_CORPORATE_HIERARCHY:
            {
                const treeList = (0, $c7083.hierarchyToNodes)([
                    action.hierarchyNode
                ]);
                return {
                    ...state,
                    root: action.hierarchyNode.id,
                    treeList: treeList,
                    currentHierarchy: action.hierarchyNode.id,
                    currentHierarchyType: action.hierarchyNode.type
                };
            }
        case 0, $llbNs.SET_CURRENT_ACCESS_RIGHTS:
            return {
                ...state,
                currentAccessRights: action.accessRights
            };
        case 0, $llbNs.SET_CURRENT_HIERARCHY:
            {
                const data = state.treeList.find((h)=>h.id === action.nodeId)?.data;
                return {
                    ...state,
                    currentHierarchy: action.nodeId,
                    currentHierarchyType: data ? data.type : state.currentHierarchyType
                };
            }
        case 0, $llbNs.SET_NEW_REPORT_DETAILS:
            return {
                ...state,
                newReportDescription: action.newReportDescription,
                newReportName: action.newReportName,
                newReportType: action.newReportType,
                newReportValid: action.newReportValid
            };
        case 0, $llbNs.SET_NEW_TLF_ITEM_DETAILS:
            return {
                ...state,
                newTlfItemDetails: action.tlfItemDetails
            };
        case 0, $llbNs.SET_NEW_TLF_ITEM_DETAILS_VALID:
            return {
                ...state,
                newTlfItemDetailsValid: action.tlfItemDetailsValid
            };
        case 0, $llbNs.SET_SELECTIONS:
            return {
                ...state,
                selections: action.selections
            };
        case 0, $llbNs.UPSERT_HIERARCHY_TLF_ITEM_INDEX:
            {
                const previousItems = state.hierarchyTlfItemIndex.find((item)=>item.hierarchyId === action.nodeId)?.tlfItemIndex ?? [];
                const selections = state.selections.flatMap((selection)=>{
                    const item = action.tlfItemIndex.find((source)=>source.id === selection.id);
                    if (item) return (0, $bHoqH.getReportTlfSelection)(item, selection.includeMaster ?? selection.variantNames === undefined, selection.variantNames ?? []).map((updated)=>({
                            ...selection,
                            ...updated
                        }));
                    return previousItems.some((source)=>source.id === selection.id) ? [] : [
                        selection
                    ];
                });
                const index = state.hierarchyTlfItemIndex.findIndex((i)=>i.hierarchyId === action.nodeId);
                if (index !== -1) {
                    const newHierarchyTlfItemIndex = state.hierarchyTlfItemIndex.map((item, idx)=>idx === index ? {
                            ...item,
                            tlfItemIndex: action.tlfItemIndex
                        } : item);
                    return {
                        ...state,
                        hierarchyTlfItemIndex: newHierarchyTlfItemIndex,
                        selections: selections
                    };
                } else {
                    const newHierarchyTlfItemIndex = [
                        ...state.hierarchyTlfItemIndex,
                        {
                            hierarchyId: action.nodeId,
                            tlfItemIndex: action.tlfItemIndex
                        }
                    ];
                    return {
                        ...state,
                        hierarchyTlfItemIndex: newHierarchyTlfItemIndex,
                        selections: selections
                    };
                }
            }
    }
};

});
parcelRegister("c7083", function(module, exports) {

$parcel$export(module.exports, "hierarchyToNodes", function () { return $ffcbd8c9224242b7$export$8abf8519cf7cc467; });

var $K53Ru = parcelRequire("K53Ru");
const $ffcbd8c9224242b7$export$8abf8519cf7cc467 = (hierarchyNodes)=>{
    const treeNodes = [];
    hierarchyNodes.forEach((h)=>{
        treeNodes.push({
            id: h.id,
            label: h.name,
            parentId: h.parentId,
            data: {
                ...h,
                url: (0, $K53Ru.getHierarchyBaseUrl)(h)
            }
        });
    });
    hierarchyNodes.forEach((h)=>{
        if (h.children && h.children.length > 0) h.children.forEach((c)=>{
            if (treeNodes.findIndex((t)=>t.id === c.id) === -1) treeNodes.push({
                id: c.id,
                label: c.name,
                parentId: h.id,
                data: {
                    ...c,
                    url: (0, $K53Ru.getHierarchyBaseUrl)(c)
                }
            });
        });
    });
    treeNodes.sort((a, b)=>a.label.localeCompare(b.label));
    return treeNodes;
};

});

parcelRegister("llbNs", function(module, exports) {

$parcel$export(module.exports, "ADD_HIERARCHY_NODES", function () { return $06904a1a644f3304$export$af63543297d305d3; });
$parcel$export(module.exports, "ADD_SELECTION", function () { return $06904a1a644f3304$export$6ba84af01431fe0; });
$parcel$export(module.exports, "REMOVE_SELECTION", function () { return $06904a1a644f3304$export$a8fed2245b9507b5; });
$parcel$export(module.exports, "SET_CORPORATE_HIERARCHY", function () { return $06904a1a644f3304$export$b00dbe3808fef36f; });
$parcel$export(module.exports, "SET_CURRENT_ACCESS_RIGHTS", function () { return $06904a1a644f3304$export$d411c4e5fe6c5871; });
$parcel$export(module.exports, "SET_CURRENT_HIERARCHY", function () { return $06904a1a644f3304$export$b96e71bcd0964407; });
$parcel$export(module.exports, "SET_NEW_REPORT_DETAILS", function () { return $06904a1a644f3304$export$e847a50d934a402d; });
$parcel$export(module.exports, "SET_NEW_TLF_ITEM_DETAILS", function () { return $06904a1a644f3304$export$3f901f85ef0e0322; });
$parcel$export(module.exports, "SET_NEW_TLF_ITEM_DETAILS_VALID", function () { return $06904a1a644f3304$export$58d3c4e185e84e9; });
$parcel$export(module.exports, "SET_SELECTIONS", function () { return $06904a1a644f3304$export$38e8e7a6c9f10add; });
$parcel$export(module.exports, "UPSERT_HIERARCHY_TLF_ITEM_INDEX", function () { return $06904a1a644f3304$export$f7b70b86cfb27269; });
const $06904a1a644f3304$export$af63543297d305d3 = "ADD_HIERARCHY_NODES";
const $06904a1a644f3304$export$6ba84af01431fe0 = "ADD_SELECTION";
const $06904a1a644f3304$export$a8fed2245b9507b5 = "REMOVE_SELECTION";
const $06904a1a644f3304$export$b00dbe3808fef36f = "SET_CORPORATE_HIERARCHY";
const $06904a1a644f3304$export$d411c4e5fe6c5871 = "SET_CURRENT_ACCESS_RIGHTS";
const $06904a1a644f3304$export$b96e71bcd0964407 = "SET_CURRENT_HIERARCHY";
const $06904a1a644f3304$export$e847a50d934a402d = "SET_NEW_REPORT_DETAILS";
const $06904a1a644f3304$export$3f901f85ef0e0322 = "SET_NEW_TLF_ITEM_DETAILS";
const $06904a1a644f3304$export$58d3c4e185e84e9 = "SET_NEW_TLF_ITEM_DETAILS_VALID";
const $06904a1a644f3304$export$38e8e7a6c9f10add = "SET_SELECTIONS";
const $06904a1a644f3304$export$f7b70b86cfb27269 = "UPSERT_HIERARCHY_TLF_ITEM_INDEX";

});




parcelRegister("cdDXi", function(module, exports) {

$parcel$export(module.exports, "loadHierarchyTlfs", function () { return $3a1c1b5517521440$export$3ad0469119ed0599; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $3a1c1b5517521440$export$3ad0469119ed0599 = async (backEndUrl, hierarchy, controller)=>{
    let url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}`;
    if (hierarchy.parentTag) url += `?parentTag=${hierarchy.parentTag}`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load hierarchy tlfs failed", error);
    }
};

});

parcelRegister("bhMKI", function(module, exports) {

$parcel$export(module.exports, "deleteTlf", function () { return $200291b9c279dd95$export$e7f0fa1c6d367608; });

var $k2cZm = parcelRequire("k2cZm");
const $200291b9c279dd95$export$e7f0fa1c6d367608 = async (backEndUrl, id)=>{
    return await (0, $k2cZm.deleteData)(`${backEndUrl}TlfItems/${id}`);
};

});
parcelRegister("k2cZm", function(module, exports) {

$parcel$export(module.exports, "deleteData", function () { return $d4e8946bb941a5d7$export$759f93bbe12f0fab; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $d4e8946bb941a5d7$export$759f93bbe12f0fab = async (url)=>{
    // Get data
    try {
        await (0, $lCyBC.default).delete(url);
        // Return successful result
        return {
            success: true
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Delete failed", error);
    }
};

});


parcelRegister("jLfY5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e62ecb11b7499727$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $e62ecb11b7499727$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $e62ecb11b7499727$var$_extends() {
    return $e62ecb11b7499727$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e62ecb11b7499727$var$_extends.apply(null, arguments);
}
function $e62ecb11b7499727$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $e62ecb11b7499727$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $e62ecb11b7499727$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $e62ecb11b7499727$var$ArrowRepeat = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $e62ecb11b7499727$var$_objectWithoutProperties(_ref, $e62ecb11b7499727$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $e62ecb11b7499727$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-repeat',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
    }));
});
$e62ecb11b7499727$var$ArrowRepeat.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $e62ecb11b7499727$export$2e2bcd8739ae039 = $e62ecb11b7499727$var$ArrowRepeat;

});

parcelRegister("dp2CC", function(module, exports) {

$parcel$export(module.exports, "RemoveModal", function () { return $3a5c7e72543a253f$export$5a5d118b9e96c9dd; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $27W8h = parcelRequire("27W8h");
var $31g00 = parcelRequire("31g00");
const $3a5c7e72543a253f$export$5a5d118b9e96c9dd = ({ id: id, show: show, beingRemovedType: beingRemovedType, beingRemovedName: beingRemovedName, onOk: onOk, onCancel: onCancel })=>{
    // Render modal
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
            id: id,
            show: show,
            onHide: onCancel,
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                            children: [
                                "Remove ",
                                beingRemovedType
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                                        children: "Are you sure you want to remove"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                        className: "d-flex justify-content-center",
                                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("h4", {
                                            children: [
                                                beingRemovedName,
                                                "?"
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                                    className: "d-flex justify-content-center",
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                        id: `${id}-ok`,
                                        variant: "danger",
                                        "aria-label": `Remove ${beingRemovedName}`,
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onOk();
                                        },
                                        children: "Remove"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Footer, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: `${id}-cancel`,
                        "aria-label": "Cancel",
                        variant: "secondary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onCancel();
                        },
                        children: "Cancel"
                    })
                })
            ]
        })
    });
};
$3a5c7e72543a253f$export$5a5d118b9e96c9dd.displayName = "RemoveModal";

});




parcelRegister("hHepi", function(module, exports) {

$parcel$export(module.exports, "HierarchyLinks", function () { return $1263e29bf39ecf1c$export$e5a43fec3653b666; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $4qN3X = parcelRequire("4qN3X");

var $2uw77 = parcelRequire("2uw77");

var $83HXv = parcelRequire("83HXv");

var $98W6k = parcelRequire("98W6k");

var $1MRDb = parcelRequire("1MRDb");

var $6w4A0 = parcelRequire("6w4A0");
const $1263e29bf39ecf1c$export$e5a43fec3653b666 = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const showStudyTree = hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report;
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6w4A0.TypeLinks), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4qN3X.ArsLinks), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {
                className: "mt-3"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $83HXv.ParentLink), {}),
            showStudyTree ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1MRDb.StudyTree), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2uw77.ChildLinks), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $98W6k.RecentLinks), {})
        ]
    });
};
$1263e29bf39ecf1c$export$e5a43fec3653b666.displayName = "HierarchyLinks";

});
parcelRegister("4qN3X", function(module, exports) {

$parcel$export(module.exports, "ArsLinks", function () { return $cd1357abebef2701$export$8df58c370553035e; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $iBbNa = parcelRequire("iBbNa");
const $cd1357abebef2701$export$8df58c370553035e = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    // Only show ARS links when arsEnabled is true
    const arsEnabled = hierarchyContext?.hierarchy?.arsEnabled;
    return !hierarchyContext?.hierarchy || !arsEnabled ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                    id: "hierarchylinks-analysis-methods",
                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/AnalysisMethods`,
                    children: "Analysis methods"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                    id: "hierarchylinks-analysis-sets",
                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/AnalysisSets`,
                    children: "Analysis sets"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                    id: "hierarchylinks-data-subsets",
                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/DataSubsets`,
                    children: "Data subsets"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                    id: "hierarchylinks-grouping-factors",
                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/GroupingFactors`,
                    children: "Grouping factors"
                })
            })
        ]
    });
};
$cd1357abebef2701$export$8df58c370553035e.displayName = "ArsLinks";

});

parcelRegister("2uw77", function(module, exports) {

$parcel$export(module.exports, "ChildLinks", function () { return $bc5f296da4bd670a$export$438f839f575eb05a; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $cHpYl = parcelRequire("cHpYl");

var $jzf4s = parcelRequire("jzf4s");

var $spJKX = parcelRequire("spJKX");

var $5u70B = parcelRequire("5u70B");

var $aER1N = parcelRequire("aER1N");
const $bc5f296da4bd670a$export$438f839f575eb05a = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const [pending, startTransition] = (0, $spJKX.useTransition)();
    const [corpRequest, setCorpRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [corp, setCorp] = (0, $spJKX.useState)(null);
    const getCorporate = (0, $spJKX.useEffectEvent)(async ()=>{
        const request = await (0, $4dL47.loadWrapper)((0, $cHpYl.loadHierarchy), {
            hierarchyName: "Corporate"
        }, corpRequest, setCorpRequest, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) startTransition(()=>setCorp(request.data));
    });
    (0, $spJKX.useEffect)(()=>{
        if (!hierarchyContext?.hierarchy) getCorporate();
    }, [
        hierarchyContext?.hierarchy
    ]);
    const children = hierarchyContext && hierarchyContext.hierarchy ? hierarchyContext.hierarchy.children : corp?.children;
    const nlevel = hierarchyContext?.hierarchy ? (0, $jzf4s.childHierarchyLevel)(hierarchyContext.hierarchy) : (0, $4lHS7.eHierarchyLevel).TA;
    return hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            (corpRequest.requesting || pending) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {}),
            !children || children.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                children: [
                    "No",
                    nlevel === (0, $4lHS7.eHierarchyLevel).Study ? " Studies" : ` ${nlevel}s`
                ]
            }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                        children: nlevel
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "small-scrollbar",
                        style: {
                            maxHeight: "400px"
                        },
                        children: children.sort((a, b)=>a.name.localeCompare(b.name)).map((h, i)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $aER1N.ChildLink), {
                                hierarchy: h
                            }, i))
                    })
                ]
            }),
            hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5u70B.AddHierarchyButton), {}, hierarchyContext.hierarchy?.id),
            /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {})
        ]
    });
};
$bc5f296da4bd670a$export$438f839f575eb05a.displayName = "ChildLinks";

});
parcelRegister("jzf4s", function(module, exports) {

$parcel$export(module.exports, "childHierarchyLevel", function () { return $8b42766579a009bd$export$4c246000a1b0489b; });

var $4lHS7 = parcelRequire("4lHS7");
const $8b42766579a009bd$export$4c246000a1b0489b = (hierarchy)=>{
    switch(hierarchy.level){
        case (0, $4lHS7.eHierarchyLevel).TopLevel:
            return (0, $4lHS7.eHierarchyLevel).Corporate;
        case (0, $4lHS7.eHierarchyLevel).Corporate:
            return (0, $4lHS7.eHierarchyLevel).TA;
        case (0, $4lHS7.eHierarchyLevel).TA:
            return (0, $4lHS7.eHierarchyLevel).Project;
        case (0, $4lHS7.eHierarchyLevel).Project:
            return (0, $4lHS7.eHierarchyLevel).Study;
        case (0, $4lHS7.eHierarchyLevel).Study:
            return (0, $4lHS7.eHierarchyLevel).Report;
        case (0, $4lHS7.eHierarchyLevel).Report:
            return null;
    }
};

});

parcelRegister("5u70B", function(module, exports) {

$parcel$export(module.exports, "AddHierarchyButton", function () { return $35c8cf24c1222ae1$export$9eb3c1ed3eac6f97; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");
var $1wSYE = parcelRequire("1wSYE");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $9dTwm = parcelRequire("9dTwm");

var $jzf4s = parcelRequire("jzf4s");

var $cnGER = parcelRequire("cnGER");

var $spJKX = parcelRequire("spJKX");

var $lYgW3 = parcelRequire("lYgW3");
var $gCZ2V = parcelRequire("gCZ2V");

var $jvxvZ = parcelRequire("jvxvZ");

var $88HUr = parcelRequire("88HUr");
const $35c8cf24c1222ae1$export$9eb3c1ed3eac6f97 = ()=>{
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("add-hierarchy-button");
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const [showAddModal, setShowAddModal] = (0, $spJKX.useState)(false);
    // Current hierarchy information
    const nLevel = hierarchyContext?.hierarchy && (0, $jzf4s.childHierarchyLevel)(hierarchyContext.hierarchy);
    const isReportLevel = nLevel === (0, $4lHS7.eHierarchyLevel).Report;
    // Modal inputs
    const modalInputs = hierarchyContext && nLevel ? [
        {
            inputLabel: "Name",
            inputName: "Name",
            validCondition: (0, $cnGER.hierarchyNameValidator),
            validationRequestUrl: appSettings.backEndUrl,
            validationOptions: {
                existingValues: hierarchyContext.hierarchy?.children.map((c)=>c.name) ?? // istanbul ignore next
                [],
                otherValues: {
                    level: nLevel,
                    parentTag: hierarchyContext.hierarchy?.hierarchyTag ?? // istanbul ignore next
                    ""
                }
            }
        },
        ...appSettings.defaultLevelProperties[nLevel].filter((h)=>h.mandatory).map((p)=>{
            // Always pass the parent hierarchy tag and sibling tags to scope uniqueness
            const parentTag = hierarchyContext.hierarchy?.hierarchyTag ?? // istanbul ignore next
            "";
            return {
                inputLabel: p.label,
                inputName: p.key,
                validCondition: p.validCondition,
                validationOptions: {
                    existingValues: hierarchyContext.hierarchy?.children.map((c)=>c.hierarchyTag) ?? // istanbul ignore next
                    [],
                    otherValues: {
                        parentTag: parentTag
                    }
                },
                validationRequestUrl: appSettings.backEndUrl
            };
        })
    ] : null;
    // Save request state
    const [saveRequest, setSaveRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Add a new child hierarchy beneath the current hierarchy.
   *
   * @param newChildData - Keyed data for the new child hierarchy
   */ const addChild = async (newChildData)=>{
        /* istanbul ignore else */ if (hierarchyContext && hierarchyContext.hierarchy && nLevel) {
            setShowAddModal(false);
            // Create new hierarchy
            const newChild = {
                parentId: hierarchyContext.hierarchy.id,
                parentParentTag: hierarchyContext.hierarchy.parentTag,
                name: newChildData.Name.trim(),
                hierarchyTag: isReportLevel ? `${hierarchyContext.hierarchy.hierarchyTag}/Report/${newChildData.Name.trim()}` : newChildData[appSettings.defaultLevelProperties[nLevel]?.find((p)=>p.type === "hierarchyTag")?.key ?? // istanbul ignore next
                ""] ?? // istanbul ignore next
                crypto.randomUUID(),
                description: isReportLevel && newChildData.Description ? newChildData.Description.trim() : "",
                reportType: isReportLevel && newChildData["ReportType"] ? newChildData["ReportType"].trim() : ""
            };
            // Create new node
            const response = await (0, $4dL47.loadWrapper)((0, $9dTwm.saveHierarchyData), newChild, saveRequest, setSaveRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (response?.success) {
                hierarchyContext.dispatch({
                    operation: (0, $0eakK.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        response.data
                    ]
                });
                hierarchyContext.dispatch({
                    operation: (0, $0eakK.SET_HIERARCHY_ID),
                    hierarchyId: response.data.id
                });
                navigate(`${(0, $K53Ru.getHierarchyBaseUrl)(response.data)}`);
            }
        }
    };
    return !hierarchyContext || !modalInputs ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: hierarchyContext.accessRights?.includes((0, $4lHS7.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "position-relative",
            children: [
                saveRequest.requesting && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1wSYE.PauseCover), {
                    text: "Saving..."
                }),
                saveRequest.error && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lYgW3.default), {
                            className: "pr-1"
                        }),
                        saveRequest.errorText ?? // istanbul ignore next
                        "Error adding hierarchy"
                    ]
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    id: "hierarchylinks-add",
                    onClick: ()=>{
                        setShowAddModal(true);
                    },
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
                            id: "hierarchylinks-add-icon",
                            "aria-label": `Add new ${nLevel}`
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                            style: {
                                marginLeft: "0.5rem"
                            },
                            children: [
                                "Add ",
                                nLevel
                            ]
                        })
                    ]
                }),
                showAddModal && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                    children: isReportLevel ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $88HUr.NewReportModal), {
                        show: showAddModal,
                        onOk: addChild,
                        onCancel: ()=>{
                            setShowAddModal(false);
                        }
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jvxvZ.WordModal), {
                        id: "hierarchylinks-add-modal",
                        show: showAddModal,
                        title: `Add new ${nLevel}`,
                        buttonLabel: "Add",
                        onOk: addChild,
                        onCancel: ()=>{
                            setShowAddModal(false);
                        },
                        inputs: modalInputs
                    })
                })
            ]
        })
    });
};
$35c8cf24c1222ae1$export$9eb3c1ed3eac6f97.displayName = "AddHierarchyButton";

});
parcelRegister("9dTwm", function(module, exports) {

$parcel$export(module.exports, "saveHierarchyData", function () { return $9364f1b90764b243$export$6c3d826539cabf49; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $9364f1b90764b243$export$6c3d826539cabf49 = async (backEndUrl, hierarchy, controller)=>{
    let url;
    let method;
    if ((hierarchy.id ?? "") !== "") {
        url = `${backEndUrl}Hierarchy/${hierarchy.id}`;
        method = "PUT";
    } else {
        url = `${backEndUrl}Hierarchy`;
        method = "POST";
    }
    // Set headers, send method
    const headers = {
        "Content-Type": "application/json;charset=utf-8"
    };
    // Send data
    try {
        const response = await (0, $lCyBC.default).request({
            method: method,
            url: url,
            data: hierarchy,
            headers: headers,
            signal: controller?.signal
        });
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("cnGER", function(module, exports) {

$parcel$export(module.exports, "allowedHierarchyNamePattern", function () { return $9c2bd428a64dabba$export$60628da97efcdfce; });
$parcel$export(module.exports, "hierarchyNameValidator", function () { return $9c2bd428a64dabba$export$5ea5d8d7cdb7f353; });

var $jzTej = parcelRequire("jzTej");
const $9c2bd428a64dabba$export$60628da97efcdfce = /^[A-Za-z0-9_ -]+$/;
const $9c2bd428a64dabba$export$5ea5d8d7cdb7f353 = async (_backEndUrl, target, _controller)=>{
    const hierarchyNameNormalized = target.value.trim().toLowerCase();
    const level = target.options?.otherValues?.level;
    if (hierarchyNameNormalized === "") return {
        success: true,
        data: {
            valid: false,
            validationText: "Name cannot be empty"
        }
    };
    if (!$9c2bd428a64dabba$export$60628da97efcdfce.test(hierarchyNameNormalized)) return {
        success: true,
        data: {
            valid: false,
            validationText: "Name may only contain letters, numbers, spaces, hyphens, and underscores"
        }
    };
    const existingValues = target.options?.existingValues ?? [];
    const isDuplicate = existingValues.some((v)=>v.trim().toLowerCase() === hierarchyNameNormalized);
    if (isDuplicate) return {
        success: true,
        data: {
            valid: false,
            validationText: !level ? "Hierarchy name is already used within current parent hierarchy" : `${level} name is already used within current ${(0, $jzTej.parentHierarchyLevel)(level)}`
        }
    };
    return {
        success: true,
        data: {
            valid: true,
            validationText: ""
        }
    };
};

});
parcelRegister("jzTej", function(module, exports) {

$parcel$export(module.exports, "parentHierarchyLevel", function () { return $eb41ff10c5e97494$export$48ae3920b2fddddf; });

var $4lHS7 = parcelRequire("4lHS7");
const $eb41ff10c5e97494$export$48ae3920b2fddddf = (hierarchyLevel)=>{
    switch(hierarchyLevel){
        case (0, $4lHS7.eHierarchyLevel).TopLevel:
        case (0, $4lHS7.eHierarchyLevel).Corporate:
            return (0, $4lHS7.eHierarchyLevel).TopLevel;
        case (0, $4lHS7.eHierarchyLevel).TA:
            return (0, $4lHS7.eHierarchyLevel).Corporate;
        case (0, $4lHS7.eHierarchyLevel).Project:
            return (0, $4lHS7.eHierarchyLevel).TA;
        case (0, $4lHS7.eHierarchyLevel).Study:
            return (0, $4lHS7.eHierarchyLevel).Project;
        case (0, $4lHS7.eHierarchyLevel).Report:
            return (0, $4lHS7.eHierarchyLevel).Study;
    }
};

});


parcelRegister("jvxvZ", function(module, exports) {

$parcel$export(module.exports, "WordModal", function () { return $ff0748dee9317cc1$export$b57c1d984f6ab8a3; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $lUxHn = parcelRequire("lUxHn");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
var $eZYX7 = parcelRequire("eZYX7");
var $27W8h = parcelRequire("27W8h");
const $ff0748dee9317cc1$export$b57c1d984f6ab8a3 = ({ id: id, buttonLabel: buttonLabel = "OK", clearOnClose: clearOnClose = true, externalValues: externalValues, inputs: inputs, message: message, onCancel: onCancel, onFieldChange: onFieldChange, onOk: onOk, requestStatus: requestStatus, show: show, spellCheck: spellCheck = true, title: title, ...rest })=>{
    const [currentValues, setCurrentValues] = (0, $spJKX.useState)(Object.fromEntries(inputs.filter((inp)=>!inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.initialValue ?? ""
        ])));
    const [textValid, setTextValid] = (0, $spJKX.useState)(inputs.map((inp)=>{
        const isHidden = typeof inp.hidden === "function" ? inp.hidden(currentValues) : false;
        return isHidden || !inp.validCondition;
    }));
    /**
   * Clears the input fields if clearOnClose is true
   */ const clearFields = ()=>clearOnClose && setCurrentValues(Object.fromEntries(inputs.filter((inp)=>!inp.computeValue).map((inp)=>[
                inp.inputName,
                inp.initialValue ?? // istanbul ignore next
                ""
            ])));
    /**
   * Cancel button click handler
   */ const onCancelClick = ()=>{
        clearFields();
        onCancel();
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default), {
        ...rest,
        id: id,
        show: show,
        onHide: ()=>{
            onCancelClick();
            rest.onHide?.();
        },
        onExited: (n)=>{
            rest.onExited?.(n);
            clearFields();
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default), {
            id: `${id}-form`,
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                        children: [
                            message,
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lUxHn.ControlsGroup), {
                                baseId: `${id}-form`,
                                currentValues: {
                                    ...currentValues,
                                    ...externalValues
                                },
                                inputs: inputs,
                                onFieldChange: onFieldChange,
                                setCurrentValues: (vals)=>setCurrentValues(vals),
                                setTextValid: setTextValid,
                                spellCheck: spellCheck
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: `${id}-ok`,
                            variant: "primary",
                            disabled: textValid.some((value, ix)=>{
                                const isHidden = typeof inputs[ix].hidden === "function" ? inputs[ix].hidden(currentValues) : false;
                                return !isHidden && !value;
                            }),
                            onClick: ()=>onOk(currentValues),
                            requestStatus: requestStatus,
                            children: buttonLabel
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: `${id}-cancel`,
                            variant: "secondary",
                            onClick: onCancelClick,
                            children: "Cancel"
                        })
                    ]
                })
            ]
        })
    });
};
$ff0748dee9317cc1$export$b57c1d984f6ab8a3.displayName = "WordModal";

});

parcelRegister("88HUr", function(module, exports) {

$parcel$export(module.exports, "NewReportModal", function () { return $352880a920467de5$export$77ffd4341c3bbdd6; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $bHe0S = parcelRequire("bHe0S");

var $spJKX = parcelRequire("spJKX");

var $jvxvZ = parcelRequire("jvxvZ");

var $05cML = parcelRequire("05cML");
const $352880a920467de5$export$77ffd4341c3bbdd6 = ({ show: show, onOk: onOk, onCancel: onCancel })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const [reportSuffixes, setReportSuffixes] = (0, $spJKX.useState)([]);
    const [requestSuffixes, setRequestSuffixes] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const getReportSuffixesData = (0, $spJKX.useEffectEvent)(async ()=>{
        const response = await (0, $4dL47.loadWrapper)((0, $bHe0S.getReportSuffixes), null, requestSuffixes, setRequestSuffixes, appSettings.backEndUrl);
        if (response?.success) (0, $spJKX.startTransition)(()=>setReportSuffixes(response.data));
    });
    (0, $spJKX.useEffect)(()=>{
        getReportSuffixesData();
    }, []);
    return !hierarchy ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jvxvZ.WordModal), {
        id: "hierarchylinks-add-modal",
        show: show,
        title: "Add new Report",
        buttonLabel: "Add",
        onOk: onOk,
        onCancel: onCancel,
        message: requestSuffixes.error ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            className: "text-danger",
            children: "Error loading report suffixes"
        }) : undefined,
        inputs: (0, $05cML.newReportInputs)(hierarchy.children.map((r)=>r.name.toLowerCase()), appSettings.allowedReportTypes, reportSuffixes),
        spellCheck: false
    });
};
$352880a920467de5$export$77ffd4341c3bbdd6.displayName = "NewReportModal";

});
parcelRegister("bHe0S", function(module, exports) {

$parcel$export(module.exports, "getReportSuffixes", function () { return $140bc856ea3f6367$export$3c1a8fcc0319ca60; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $140bc856ea3f6367$export$3c1a8fcc0319ca60 = async (backEndUrl, _, controller)=>{
    try {
        const response = await (0, $lCyBC.default).get(`${backEndUrl}Hierarchy/ReportSuffixes`, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Failed to retrieve report suffixes", error);
    }
};

});

parcelRegister("05cML", function(module, exports) {

$parcel$export(module.exports, "newReportInputs", function () { return $5ccc90951e41c1d8$export$323cf9afa6c029ea; });
const $5ccc90951e41c1d8$export$323cf9afa6c029ea = (existingNames, reportTypes, reportSuffixes)=>[
        {
            inputLabel: "Report type",
            inputName: "ReportType",
            dropdownOptions: reportTypes,
            validCondition: async (_backEndUrl, target)=>{
                const reportType = target.value;
                const isValid = reportType !== "";
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Report type is required"
                    }
                };
            }
        },
        {
            inputLabel: "Report number",
            inputName: "Report number",
            validCondition: async (_, target)=>{
                const reportNumber = target.value;
                const isValid = reportNumber === "" || /^\d{2}$/.test(reportNumber);
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Report number must be exactly two digits (e.g., 01) or blank"
                    }
                };
            },
            placeholder: "00",
            hidden: (values)=>values["ReportType"] === ""
        },
        {
            inputLabel: "Report suffix",
            inputName: "Report suffix",
            dropdownOptions: [
                "",
                ...reportSuffixes
            ],
            hidden: (values)=>values["ReportType"] === ""
        },
        {
            inputLabel: "Custom suffix",
            inputName: "Custom suffix",
            hidden: (values)=>values["Report suffix"] !== "<<other>>" && values["Report suffix"] !== "<<country>>",
            validCondition: async (_backEndUrl, target)=>{
                const customSuffix = target.value.trim();
                const validationText = customSuffix.length === 0 ? "Custom suffix is required" : !/^[A-Za-z0-9]+$/.test(customSuffix) ? "Custom suffix can only contain letters and numbers" : "";
                return {
                    success: true,
                    data: {
                        valid: validationText === "",
                        validationText: validationText
                    }
                };
            }
        },
        {
            inputLabel: "Suffix number",
            inputName: "Suffix number",
            validCondition: async (_, target)=>{
                const suffixNumber = target.value;
                const isValid = suffixNumber === "" || /^\d{2}$/.test(suffixNumber);
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Suffix number must be exactly two digits (e.g., 01) or blank"
                    }
                };
            },
            hidden: (values)=>values["Report suffix"] === "",
            placeholder: "00"
        },
        {
            inputLabel: "Name",
            inputName: "Name",
            computeValue: (values)=>{
                const suffix = values["Report suffix"] ?? // istanbul ignore next
                "";
                const customSuffix = values["Custom suffix"] ?? // istanbul ignore next
                "";
                const suffixNumber = values["Suffix number"] ?? // istanbul ignore next
                "";
                if (suffix === "") return `${values["ReportType"] ?? // istanbul ignore next
                ""}${values["Report number"] ?? // istanbul ignore next
                ""}`;
                const actualSuffix = suffix === "<<other>>" || suffix === "<<country>>" ? customSuffix : suffix;
                return `${values["ReportType"] ?? // istanbul ignore next
                ""}${values["Report number"] ?? // istanbul ignore next
                ""}_${actualSuffix}${suffixNumber}`;
            },
            readonly: true,
            validCondition: async (_, target)=>{
                const reportName = target.value.trim();
                const isDuplicate = existingNames.includes(reportName.toLowerCase());
                return {
                    success: true,
                    data: {
                        valid: !isDuplicate,
                        validationText: isDuplicate ? "This name is taken" : ""
                    }
                };
            }
        },
        {
            inputLabel: "Description",
            inputName: "Description",
            validCondition: async (_, target)=>{
                const description = target.value.trim();
                const isValid = description.length > 0;
                return {
                    success: true,
                    data: {
                        valid: isValid,
                        validationText: isValid ? "" : "Description is required"
                    }
                };
            }
        }
    ];

});



parcelRegister("aER1N", function(module, exports) {

$parcel$export(module.exports, "ChildLink", function () { return $9b95c4efa90f8b49$export$33b860458c4a8e93; });

var $bR5nk = parcelRequire("bR5nk");

var $iBbNa = parcelRequire("iBbNa");

var $K53Ru = parcelRequire("K53Ru");
const $9b95c4efa90f8b49$export$33b860458c4a8e93 = ({ hierarchy: hierarchy })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
            id: `hierarchylinks-child-${name}`,
            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchy)}`,
            style: {
                paddingLeft: "0.75rem",
                textIndent: "-0.75rem"
            },
            children: hierarchy.name
        })
    });
};
$9b95c4efa90f8b49$export$33b860458c4a8e93.displayName = "ChildLink";

});


parcelRegister("83HXv", function(module, exports) {

$parcel$export(module.exports, "ParentLink", function () { return $ee9b2aca974b736c$export$eaf30ed8fd9c8e09; });

var $bR5nk = parcelRequire("bR5nk");

var $iBbNa = parcelRequire("iBbNa");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");
const $ee9b2aca974b736c$export$eaf30ed8fd9c8e09 = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    // Current hierarchy information
    const parent = hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchyNodes.find((h)=>h.hierarchyTag === hierarchyContext.hierarchy.parentTag);
    return parent && hierarchyContext?.hierarchy?.level !== "Corporate" ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                children: parent.level
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "mb-2",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                        id: "hierarchylinks-parent-link",
                        to: `${(0, $K53Ru.getHierarchyBaseUrl)(parent)}`,
                        children: parent.name
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {
                        className: "mt-3"
                    })
                ]
            })
        ]
    }) : hierarchyContext?.hierarchy?.level === "Corporate" ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                id: "hierarchylinks-corporate",
                to: "/Corporate",
                children: "Corporate"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {
                className: "mt-3"
            })
        ]
    });
};
$ee9b2aca974b736c$export$eaf30ed8fd9c8e09.displayName = "ParentLink";

});

parcelRegister("98W6k", function(module, exports) {

$parcel$export(module.exports, "RecentLinks", function () { return $c9c3f9f18e11e8b8$export$f44baf4f1214e7bf; });

var $bR5nk = parcelRequire("bR5nk");

var $iBbNa = parcelRequire("iBbNa");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $spJKX = parcelRequire("spJKX");

var $kyGOj = parcelRequire("kyGOj");
const $c9c3f9f18e11e8b8$export$d2934f991c6d2dc2 = (obj)=>{
    return typeof obj === "object" && obj !== null && typeof obj.id === "string" && typeof obj.name === "string" && typeof obj.type === "string" && typeof obj.path === "string";
};
const $c9c3f9f18e11e8b8$export$f44baf4f1214e7bf = ()=>{
    const [_isPending, startTransition] = (0, $spJKX.useTransition)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    // Get current links
    const [recentLinks, setRecentLinks] = (0, $spJKX.useState)(null);
    (0, $spJKX.useLayoutEffect)(()=>{
        const storedLinks = window.localStorage.getItem("recentHierarchies") ?? "";
        try {
            const parsedLinks = JSON.parse(storedLinks);
            if (Array.isArray(parsedLinks)) {
                const validLinks = parsedLinks.filter($c9c3f9f18e11e8b8$export$d2934f991c6d2dc2);
                startTransition(()=>setRecentLinks(validLinks));
            } else startTransition(()=>setRecentLinks([]));
        } catch  {
            startTransition(()=>setRecentLinks([]));
        }
    }, []);
    // Function for minus button press
    const removeRecent = (0, $spJKX.useCallback)((id)=>{
        // Cannot be called while recentLinks is null due to button not rendering
        const rl = recentLinks.filter((rl)=>rl.id !== id);
        window.localStorage.setItem("recentHierarchies", JSON.stringify(rl));
        setRecentLinks(rl);
    }, [
        recentLinks
    ]);
    // Update links list
    (0, $spJKX.useEffect)(()=>{
        // Add most recent value
        if (hierarchyContext && hierarchyContext.hierarchy && hierarchyContext.hierarchy.id && hierarchyContext.hierarchy.name && hierarchyContext.hierarchy.type && !hierarchyContext.hierarchy.isBackupVersion && recentLinks && (recentLinks.length === 0 || recentLinks.length > 0 && (hierarchyContext.hierarchy.id !== recentLinks[0].id || hierarchyContext.hierarchy.name !== recentLinks[0].name))) {
            const newPath = (0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy);
            const newRecentLinks = [
                {
                    id: hierarchyContext.hierarchy.id,
                    name: hierarchyContext.hierarchy.name,
                    type: hierarchyContext.hierarchy.type,
                    path: newPath
                },
                ...recentLinks.filter((h)=>h.id !== hierarchyContext.hierarchy.id && h.path !== newPath).map((h)=>{
                    // Check for name updates
                    const hnchk = hierarchyContext.hierarchyNodes.find((hn)=>hn.id === h.id);
                    if (hnchk && hnchk.name !== h.name) return {
                        ...h,
                        name: hnchk.name,
                        path: (0, $K53Ru.getHierarchyBaseUrl)(hnchk)
                    };
                    else return h;
                })
            ];
            // Save back to storage
            window.localStorage.setItem("recentHierarchies", JSON.stringify(newRecentLinks));
            startTransition(()=>setRecentLinks(newRecentLinks.slice(0, 9)));
        }
    }, [
        hierarchyContext,
        recentLinks
    ]);
    // Return header and links
    return !recentLinks || recentLinks.length === 0 ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                children: "Recently viewed"
            }),
            recentLinks.map((h, i)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "nowrap"
                    },
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            style: {
                                marginRight: "4px",
                                width: "16px"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kyGOj.default), {
                                "aria-label": `Remove recent link to ${h.name}`,
                                id: `recentlinks-remove-${h.name}`,
                                onClick: ()=>removeRecent(h.id),
                                style: {
                                    color: "var(--bs-danger)"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: `recentlinks-link-${h.name}`,
                            to: h.path,
                            style: {
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            },
                            children: h.name
                        })
                    ]
                }, `${i}-${h.id}`))
        ]
    });
};
$c9c3f9f18e11e8b8$export$f44baf4f1214e7bf.displayName = "RecentLinks";

});

parcelRegister("1MRDb", function(module, exports) {

$parcel$export(module.exports, "StudyTree", function () { return $1bfe73bedd465de1$export$ff3bc663dbc9bf12; });

var $bR5nk = parcelRequire("bR5nk");

var $2AsrT = parcelRequire("2AsrT");

var $c7083 = parcelRequire("c7083");

var $3tNrK = parcelRequire("3tNrK");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $5u70B = parcelRequire("5u70B");
const $1bfe73bedd465de1$export$ff3bc663dbc9bf12 = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const navigate = (0, $6iYEs.useUnsavedChanges)("study-tree").navigate;
    const showStudyTree = hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report;
    const studyHierarchy = hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report ? hierarchyContext?.hierarchyNodes.find((h)=>h.id === hierarchyContext?.hierarchy?.parentId) : hierarchyContext?.hierarchy;
    const nodeList = studyHierarchy ? (0, $c7083.hierarchyToNodes)([
        studyHierarchy
    ]) : null;
    /**
   * Handle click on a node in the study tree.
   *
   * @param ret - The selected node ID(s)
   */ const handleSelect = (ret)=>{
        const node = nodeList?.find((n)=>n.id === ret);
        /* istanbul ignore else */ if (node?.data) navigate(node.data.url);
    };
    return !studyHierarchy || !showStudyTree || !nodeList ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2AsrT.TreeOfNodes), {
                id: "study-tree",
                handleSelect: handleSelect,
                initiallyExpandedNodes: [
                    studyHierarchy.id
                ],
                nodeHighlight: "rgb(0,0,0)",
                nodeList: nodeList,
                roots: [
                    studyHierarchy.id
                ],
                selected: hierarchyContext.hierarchy.id,
                textHighlight: "rgba(33,35,211,0.1)"
            }),
            hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).CreateHierarchy) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5u70B.AddHierarchyButton), {}, studyHierarchy.id),
            /*#__PURE__*/ (0, $bR5nk.jsx)("hr", {})
        ]
    });
};
$1bfe73bedd465de1$export$ff3bc663dbc9bf12.displayName = "StudyTree";

});
parcelRegister("2AsrT", function(module, exports) {

$parcel$export(module.exports, "TreeOfNodes", function () { return $1e2502e80b21ab73$export$5580fff3e08a8be5; });


var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $spJKX = parcelRequire("spJKX");

var $3k3cS = parcelRequire("3k3cS");
var $a2te5 = parcelRequire("a2te5");
var $1KKKv = parcelRequire("1KKKv");
var $9ppuK = parcelRequire("9ppuK");

var $5dhsh = parcelRequire("5dhsh");
function $1e2502e80b21ab73$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $1e2502e80b21ab73$var$$b65191f6d0a0a991$exports = {};
$1e2502e80b21ab73$var$$parcel$export($1e2502e80b21ab73$var$$b65191f6d0a0a991$exports, "TreeNode", function() {
    return $1e2502e80b21ab73$export$2eba8ec3a333fdbb;
});
$1e2502e80b21ab73$var$$parcel$export($1e2502e80b21ab73$var$$b65191f6d0a0a991$exports, "TreeOfNodes", function() {
    return $1e2502e80b21ab73$export$5580fff3e08a8be5;
});
$1e2502e80b21ab73$var$$parcel$export($1e2502e80b21ab73$var$$b65191f6d0a0a991$exports, "WordEntry", function() {
    return $1e2502e80b21ab73$export$14f190ac910bde69;
});
const $1e2502e80b21ab73$export$c6fd3ab3f44300d0 = (id, included, hierarchyNodes)=>{
    const processIds = Array.isArray(id) ? id : [
        id
    ];
    const current = processIds.map((i)=>hierarchyNodes.find((h)=>h.id === i)).filter((h)=>h !== undefined);
    if (current.length === 0) return included;
    const parents = current.map((h)=>h.parentId).map((pid)=>hierarchyNodes.find((h)=>pid === h.id)).filter((p)=>p !== undefined);
    if (parents.length === 0) return included;
    else return $1e2502e80b21ab73$export$c6fd3ab3f44300d0(parents.map((p)=>p.id), [
        ...included,
        ...parents.filter((p)=>!included.includes(p))
    ], hierarchyNodes);
};
const $1e2502e80b21ab73$var$$33abc00b1ca5c55c$export$bd923365b402cb04 = (id, hierarchyNodes)=>{
    const processIds = Array.isArray(id) ? id : [
        id
    ];
    const newChildren = hierarchyNodes.filter((h)=>h.parentId !== undefined && processIds.includes(h.parentId) && !processIds.includes(h.id)).map((h)=>h.id);
    return newChildren.length === 0 ? processIds : $1e2502e80b21ab73$var$$33abc00b1ca5c55c$export$bd923365b402cb04([
        ...processIds,
        ...newChildren
    ], hierarchyNodes);
};
const $1e2502e80b21ab73$var$$886f402bccb0fd30$export$29ec378200e05207 = (0, $spJKX.createContext)(undefined);
const $1e2502e80b21ab73$export$14f190ac910bde69 = (0, $spJKX.forwardRef)(({ id: id, className: className, value: value, editing: editing, saving: saving, setValue: setValue, sendEscape: sendEscape, style: style, spellCheck: spellCheck = "true" }, ref)=>{
    const [currentValue, setCurrentValue] = (0, $spJKX.useState)(value ?? "");
    (0, $spJKX.useEffect)(()=>{
        setCurrentValue(value ?? "");
    }, [
        value
    ]);
    const keyPress = (e)=>{
        if (e.code === "Escape") {
            setCurrentValue(value ?? "");
            sendEscape?.();
        } else if (e.code === "Enter") setValue?.(currentValue);
    };
    (0, $spJKX.useEffect)(()=>{
        const handleMouseDown = (e)=>{
            const target = e.target;
            if (editing && target.id !== `${id}` && target.id !== `${id}-holder` && target.id !== `${id}-spinner` && target.className !== "ton-rename") {
                e.preventDefault();
                e.stopPropagation();
                setValue?.(currentValue);
            }
        };
        window.addEventListener("mousedown", handleMouseDown);
        return ()=>{
            window.removeEventListener("mousedown", handleMouseDown);
        };
    }, [
        currentValue,
        editing,
        id,
        setValue
    ]);
    return !editing ? (0, $bR5nk.jsx)("span", {
        className: "ton-label-span",
        style: style,
        id: `${id}`,
        children: value ? value : (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
            children: "\xa0"
        })
    }) : (0, $bR5nk.jsxs)("div", {
        style: style,
        id: `${id}-holder`,
        className: "ton-rename-holder",
        children: [
            saving && (0, $bR5nk.jsx)((0, $5dhsh.default), {
                id: `${id}-spinner`,
                size: "sm",
                animation: "border"
            }),
            (0, $bR5nk.jsx)("input", {
                autoFocus: true,
                spellCheck: spellCheck,
                id: String(id),
                ref: ref,
                type: "text",
                className: [
                    "ton-rename",
                    className
                ].filter(Boolean).join(" "),
                value: currentValue,
                disabled: saving,
                onChange: (e)=>setCurrentValue(e.currentTarget.value),
                onBlur: (e)=>setValue?.(e.currentTarget.value),
                onKeyDownCapture: keyPress
            })
        ]
    });
});
$1e2502e80b21ab73$export$14f190ac910bde69.displayName = "WordEntry";
const $1e2502e80b21ab73$export$2eba8ec3a333fdbb = ({ id: id, canRemove: canRemove, canRename: canRename, canAddChildren: canAddChildren, canRemoveChildren: canRemoveChildren, canRenameChildren: canRenameChildren })=>{
    // Contexts
    const treeContext = (0, $spJKX.useContext)($1e2502e80b21ab73$var$$886f402bccb0fd30$export$29ec378200e05207);
    // Node information
    const thisNode = treeContext?.nodeList.find((n)=>n.id === id);
    const childNodes = treeContext?.nodeList.filter((n)=>n.parentId === id);
    const descendents = $1e2502e80b21ab73$var$$33abc00b1ca5c55c$export$bd923365b402cb04(id, treeContext?.nodeList ?? []);
    // State
    const [error, setError] = (0, $spJKX.useState)(false);
    const [errorText, setErrorText] = (0, $spJKX.useState)("");
    const expanded = (treeContext?.expandedNodes.findIndex((e)=>e === id) ?? -1) > -1;
    // Checkbox
    const checkRef = (0, $spJKX.useRef)(null);
    (0, $spJKX.useEffect)(()=>{
        if (checkRef.current) {
            if (treeContext?.selected.includes(id)) {
                checkRef.current.checked = true;
                checkRef.current.indeterminate = false;
            } else if (descendents.some((d)=>treeContext?.selected.includes(d))) {
                checkRef.current.checked = false;
                checkRef.current.indeterminate = true;
            } else {
                checkRef.current.checked = false;
                checkRef.current.indeterminate = false;
            }
        }
    }, [
        descendents,
        id,
        treeContext?.selected
    ]);
    // Apply selected border
    const currentBorder = treeContext?.selected.includes(id) ? "1px solid black" : "";
    const nodeColour = (()=>{
        if (treeContext && treeContext.selected) {
            const anc = $1e2502e80b21ab73$export$c6fd3ab3f44300d0(treeContext.selected, [], treeContext?.nodeList).map((n)=>n.id);
            if ([
                ...anc,
                treeContext.selected
            ].includes(id)) return treeContext.nodeHighlight;
        }
        return;
    })();
    // New node parameters
    const newNameRef = (0, $spJKX.useRef)(null);
    const [showNewNode, setShowNewNode] = (0, $spJKX.useState)(false);
    const [savingNewNode, setSavingNewNode] = (0, $spJKX.useState)(false);
    // Rename parameters
    const currentNameRef = (0, $spJKX.useRef)(null);
    const [renaming, setRenaming] = (0, $spJKX.useState)(false);
    const [updatingNode, setUpdatingNode] = (0, $spJKX.useState)(false);
    // Context functions
    const handleReturn = (ret)=>{
        if (!ret.success) {
            setError(true);
            setErrorText(ret.ErrorText ?? "An unknown error has occured");
        } else {
            setError(false);
            setErrorText("");
        }
    };
    const confirmNewNode = async (label)=>{
        setSavingNewNode(true);
        if (treeContext?.onAddChild) handleReturn(await treeContext.onAddChild(id, label));
        setSavingNewNode(false);
        setShowNewNode(false);
    };
    const renameNode = async (newLabel)=>{
        setRenaming(false);
        if (treeContext?.onRename) {
            setUpdatingNode(true);
            handleReturn(await treeContext.onRename(id, newLabel));
            setUpdatingNode(false);
        }
    };
    const deleteThis = async ()=>{
        if (treeContext?.onRemove) {
            setUpdatingNode(true);
            handleReturn(await treeContext.onRemove(id));
            setUpdatingNode(false);
        }
    };
    // Context actions
    const addChild = ()=>{
        setShowNewNode(true);
        treeContext?.handleExpandClick?.(id, true);
    };
    const renameThis = ()=>{
        setRenaming(true);
        treeContext?.handleSelect?.(id);
    };
    // Context menu
    const menuItems = [];
    if (canAddChildren) menuItems.push({
        label: "Add",
        action: addChild
    });
    if (canRename) menuItems.push({
        label: "Rename",
        action: renameThis
    });
    if (canRemove && (childNodes === undefined || childNodes.length === 0)) menuItems.push({
        label: "Delete",
        action: deleteThis
    });
    (0, $spJKX.useEffect)(()=>{
        if (showNewNode === true && newNameRef.current) newNameRef.current.focus();
    }, [
        showNewNode
    ]);
    // Return node
    return !treeContext ? null : (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            (0, $bR5nk.jsx)((0, $5EkSD.ContextMenuHandler), {
                menuItems: menuItems,
                style: {
                    display: "inline-block",
                    width: "100%"
                },
                children: (0, $bR5nk.jsx)("div", {
                    id: `${treeContext.id}-treenode-${id}`,
                    className: "treenode",
                    children: error ? (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            (0, $bR5nk.jsx)((0, $9ppuK.default), {
                                color: "var(--bs-danger)"
                            }),
                            " ",
                            errorText
                        ]
                    }) : (0, $bR5nk.jsxs)("div", {
                        className: "ton-node",
                        children: [
                            treeContext.showCheckBox && (0, $bR5nk.jsx)("input", {
                                ref: checkRef,
                                type: "checkbox",
                                role: "checkbox",
                                className: "ton-checkbox",
                                id: `${treeContext.id}-treenode-checkbox-${id}`,
                                onClick: ()=>treeContext.handleSelect?.(descendents)
                            }),
                            childNodes && childNodes.length > 0 ? !expanded ? (0, $bR5nk.jsx)((0, $1KKKv.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                style: {
                                    width: "16px",
                                    height: "16px"
                                },
                                className: "ton-expander",
                                role: "button",
                                color: nodeColour,
                                "aria-expanded": false,
                                "aria-label": "Expander",
                                onClick: ()=>treeContext.handleExpandClick(id)
                            }) : (0, $bR5nk.jsx)((0, $3k3cS.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                className: "ton-expander",
                                role: "button",
                                "aria-expanded": true,
                                "aria-label": "Expander",
                                color: nodeColour,
                                onClick: ()=>treeContext.handleExpandClick(id)
                            }) : (0, $bR5nk.jsx)((0, $a2te5.default), {
                                id: `${treeContext.id}-treenode-caret-${id}`,
                                className: "ton-expander",
                                role: "button",
                                color: nodeColour,
                                "aria-expanded": false,
                                "aria-label": "Disabled expander",
                                onClick: ()=>treeContext.handleSelect?.(id)
                            }),
                            thisNode && (0, $bR5nk.jsx)("div", {
                                className: "ton-label",
                                style: {
                                    width: `calc(100% - ${treeContext.showCheckBox ? "32px" : "16px"})`
                                },
                                onContextMenuCapture: ()=>treeContext.handleSelect?.(id),
                                onClickCapture: ()=>{
                                    if (!treeContext.expandedNodes.includes(id)) treeContext.handleExpandClick(id);
                                    treeContext.handleSelect?.(id);
                                },
                                onFocusCapture: ()=>treeContext.handleSelect?.(id),
                                children: (0, $bR5nk.jsx)($1e2502e80b21ab73$export$14f190ac910bde69, {
                                    id: `${treeContext.id}-treenode-entry-${id}`,
                                    className: currentBorder ? "selected" : "",
                                    ref: currentNameRef,
                                    value: thisNode.label,
                                    editing: renaming,
                                    saving: updatingNode,
                                    setValue: (ret)=>renameNode(ret),
                                    sendEscape: ()=>setRenaming(false),
                                    style: {
                                        border: currentBorder,
                                        margin: currentBorder === "" ? "1px" : "",
                                        backgroundColor: currentBorder === "" ? "" : treeContext.textHighlight
                                    },
                                    spellCheck: treeContext.spellCheck
                                })
                            })
                        ]
                    })
                })
            }),
            childNodes && (0, $bR5nk.jsx)("div", {
                className: `ton-collapsible-wrapper ${expanded && childNodes.length > 0 ? "" : "collapsed"}`,
                children: childNodes.length > 0 && (0, $bR5nk.jsx)("div", {
                    className: "ton-collapsible",
                    children: childNodes.map((h)=>(0, $bR5nk.jsx)("span", {
                            id: `${treeContext.id}-treenode-child-${h.id}`,
                            className: "ton-child",
                            children: (0, $bR5nk.jsx)($1e2502e80b21ab73$export$2eba8ec3a333fdbb, {
                                id: h.id,
                                canRemove: canRemoveChildren,
                                canRename: canRenameChildren,
                                canAddChildren: canAddChildren,
                                canRemoveChildren: canRemoveChildren,
                                canRenameChildren: canRenameChildren
                            })
                        }, h.id))
                })
            }),
            showNewNode && (0, $bR5nk.jsx)($1e2502e80b21ab73$export$14f190ac910bde69, {
                style: {
                    marginLeft: "14px"
                },
                id: `treenode-new-${id}`,
                ref: newNameRef,
                editing: true,
                setValue: (ret)=>confirmNewNode(ret),
                saving: savingNewNode,
                sendEscape: ()=>setShowNewNode(false),
                spellCheck: treeContext.spellCheck
            })
        ]
    });
};
$1e2502e80b21ab73$export$2eba8ec3a333fdbb.displayName = "TreeNode";
const $1e2502e80b21ab73$var$$c7008d808d3e1c7a$export$40c47a7ac5f85aba = (nodeList, selected, expandedNodes)=>{
    return [
        ...expandedNodes,
        ...$1e2502e80b21ab73$export$c6fd3ab3f44300d0(selected, [], nodeList).map((n)=>n.id).filter((k)=>!expandedNodes.includes(k))
    ].sort((a, b)=>`${a}`.localeCompare(`${b}`));
};
const $1e2502e80b21ab73$export$5580fff3e08a8be5 = ({ alwaysShowSelected: alwaysShowSelected = "first", canAddChildren: canAddChildren = false, canRemoveChildren: canRemoveChildren = false, canRemoveRoot: canRemoveRoot = false, canRenameChildren: canRenameChildren = false, canRenameRoot: canRenameRoot = false, handleSelect: handleSelect, id: id, initiallyExpandedNodes: initiallyExpandedNodes = [], nodeHighlight: nodeHighlight = "red", nodeList: nodeList, onAdd: onAdd, onRemove: onRemove, onRename: onRename, roots: roots, selected: selected = [], showCheckBox: showCheckBox = false, spellCheck: spellCheck = "true", textHighlight: textHighlight = "rgba(255, 0, 0, 0.2)" })=>{
    const [firstRender, setFirstRender] = (0, $spJKX.useState)(alwaysShowSelected === "first");
    const [expandedNodes, setExpandedNodes] = (0, $spJKX.useState)(initiallyExpandedNodes);
    (0, $spJKX.useEffect)(()=>{
        const selectedArray = Array.isArray(selected) ? selected : [
            selected
        ];
        if ((alwaysShowSelected === "always" || firstRender) && selectedArray.length > 0) {
            // Check all nodes are showing that should be
            const shouldExpand = $1e2502e80b21ab73$var$$c7008d808d3e1c7a$export$40c47a7ac5f85aba(nodeList, selectedArray, expandedNodes);
            if (shouldExpand.filter((n)=>!expandedNodes.includes(n)).length > 0) setExpandedNodes(shouldExpand);
            setFirstRender(false);
        }
    }, [
        alwaysShowSelected,
        firstRender,
        expandedNodes,
        nodeList,
        selected
    ]);
    // Change expansion and update contexts
    const changeExpand = (eKey, force)=>{
        const newExpandedNodes = [
            ...expandedNodes
        ];
        const ix = newExpandedNodes.findIndex((nKey)=>nKey === eKey);
        if (ix === -1 && force === undefined || force === true) newExpandedNodes.push(eKey);
        else newExpandedNodes.splice(ix, 1);
        setExpandedNodes(newExpandedNodes);
    };
    return (0, $bR5nk.jsx)("div", {
        id: id,
        className: "tree-of-nodes",
        children: (0, $bR5nk.jsx)($1e2502e80b21ab73$var$$886f402bccb0fd30$export$29ec378200e05207, {
            value: {
                id: id,
                expandedNodes: expandedNodes,
                handleExpandClick: (r, f)=>changeExpand(r, f),
                handleSelect: handleSelect,
                nodeHighlight: nodeHighlight,
                nodeList: nodeList,
                onAddChild: onAdd,
                onRemove: onRemove,
                onRename: onRename,
                selected: Array.isArray(selected) ? selected : [
                    selected
                ],
                showCheckBox: showCheckBox,
                spellCheck: spellCheck,
                textHighlight: textHighlight
            },
            children: roots.map((r)=>(0, $bR5nk.jsx)($1e2502e80b21ab73$export$2eba8ec3a333fdbb, {
                    id: r,
                    canRemove: canRemoveRoot,
                    canAddChildren: canAddChildren,
                    canRename: canRenameRoot,
                    canRemoveChildren: canRemoveChildren,
                    canRenameChildren: canRenameChildren
                }, r))
        })
    });
};
$1e2502e80b21ab73$export$5580fff3e08a8be5.displayName = "TreeOfNodes";
var $1e2502e80b21ab73$var$$3d005c8713d7dfb7$exports = {};
$1e2502e80b21ab73$var$$parcel$export($1e2502e80b21ab73$var$$3d005c8713d7dfb7$exports, "getParents", function() {
    return $1e2502e80b21ab73$export$c6fd3ab3f44300d0;
});

});
parcelRegister("3k3cS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b5ba291323e887$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $26b5ba291323e887$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $26b5ba291323e887$var$_extends() {
    return $26b5ba291323e887$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $26b5ba291323e887$var$_extends.apply(null, arguments);
}
function $26b5ba291323e887$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $26b5ba291323e887$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $26b5ba291323e887$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $26b5ba291323e887$var$CaretDownFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $26b5ba291323e887$var$_objectWithoutProperties(_ref, $26b5ba291323e887$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $26b5ba291323e887$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-down-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
    }));
});
$26b5ba291323e887$var$CaretDownFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $26b5ba291323e887$export$2e2bcd8739ae039 = $26b5ba291323e887$var$CaretDownFill;

});

parcelRegister("a2te5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f0c3054258f517$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $74f0c3054258f517$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $74f0c3054258f517$var$_extends() {
    return $74f0c3054258f517$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $74f0c3054258f517$var$_extends.apply(null, arguments);
}
function $74f0c3054258f517$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $74f0c3054258f517$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $74f0c3054258f517$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $74f0c3054258f517$var$CaretRight = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $74f0c3054258f517$var$_objectWithoutProperties(_ref, $74f0c3054258f517$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $74f0c3054258f517$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-right',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753"
    }));
});
$74f0c3054258f517$var$CaretRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $74f0c3054258f517$export$2e2bcd8739ae039 = $74f0c3054258f517$var$CaretRight;

});

parcelRegister("1KKKv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $146e59b9cb80096c$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $146e59b9cb80096c$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $146e59b9cb80096c$var$_extends() {
    return $146e59b9cb80096c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $146e59b9cb80096c$var$_extends.apply(null, arguments);
}
function $146e59b9cb80096c$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $146e59b9cb80096c$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $146e59b9cb80096c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $146e59b9cb80096c$var$CaretRightFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $146e59b9cb80096c$var$_objectWithoutProperties(_ref, $146e59b9cb80096c$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $146e59b9cb80096c$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-caret-right-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"
    }));
});
$146e59b9cb80096c$var$CaretRightFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $146e59b9cb80096c$export$2e2bcd8739ae039 = $146e59b9cb80096c$var$CaretRightFill;

});

parcelRegister("9ppuK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d9a399e9862e3c9$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $6d9a399e9862e3c9$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $6d9a399e9862e3c9$var$_extends() {
    return $6d9a399e9862e3c9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d9a399e9862e3c9$var$_extends.apply(null, arguments);
}
function $6d9a399e9862e3c9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6d9a399e9862e3c9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $6d9a399e9862e3c9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $6d9a399e9862e3c9$var$ExclamationCircleFill = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $6d9a399e9862e3c9$var$_objectWithoutProperties(_ref, $6d9a399e9862e3c9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $6d9a399e9862e3c9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-exclamation-circle-fill',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
    }));
});
$6d9a399e9862e3c9$var$ExclamationCircleFill.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $6d9a399e9862e3c9$export$2e2bcd8739ae039 = $6d9a399e9862e3c9$var$ExclamationCircleFill;

});



parcelRegister("6w4A0", function(module, exports) {

$parcel$export(module.exports, "TypeLinks", function () { return $c41d79c166ed32cd$export$621d3e5937244948; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $4lHS7 = parcelRequire("4lHS7");

var $iBbNa = parcelRequire("iBbNa");
const $c41d79c166ed32cd$export$621d3e5937244948 = ()=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    return !hierarchyContext || hierarchyContext.hierarchy?.type !== (0, $4lHS7.eHierarchy).Report && hierarchyContext.hierarchy?.type !== (0, $4lHS7.eHierarchy).Directory && hierarchyContext.hierarchy?.type !== (0, $4lHS7.eHierarchy).StudyDirectory ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                className: "mt-1",
                id: "hierarchylinks-current-hierarchy",
                children: hierarchyContext.title
            }),
            hierarchyContext.hierarchy?.type === (0, $4lHS7.eHierarchy).Report ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            end: true,
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}`,
                            children: "Table of contents"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            end: true,
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Review`,
                            children: "Review"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Properties`,
                                    children: "Properties"
                                })
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                                    end: true,
                                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Versions`,
                                    children: "Report Versions"
                                })
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                    id: "hierarchylinks-properties",
                    end: true,
                    to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}`,
                    children: "Properties"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-access-rights",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Access`,
                            children: "Access rights"
                        })
                    }),
                    hierarchyContext.hierarchy?.hasClinicalLibrary && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "clinical-library",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/ClinicalLibrary`,
                            children: "Clinical library"
                        })
                    }),
                    ![
                        (0, $4lHS7.eHierarchyLevel).Study,
                        (0, $4lHS7.eHierarchy).Report
                    ].includes(hierarchyContext.hierarchy.level) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-domain-replacements",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/DomainReplacements`,
                            children: "Domain replacements"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-group-replacements",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Lists`,
                            children: "Group replacement lists"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-row-group-templates",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/RowGroups`,
                            children: "Row group templates"
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-single-replacements",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Replacements`,
                            children: "Single replacements"
                        })
                    }),
                    ![
                        (0, $4lHS7.eHierarchyLevel).Study,
                        (0, $4lHS7.eHierarchyLevel).Report
                    ].includes(hierarchyContext.hierarchy.level) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-tags",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Tags`,
                            children: "Tags"
                        })
                    }),
                    (hierarchyContext.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Project || hierarchyContext.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study) && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iBbNa.ActiveNavLink), {
                            id: "hierarchylinks-version-history",
                            to: `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy)}/Versions`,
                            children: "Version History"
                        })
                    })
                ]
            })
        ]
    });
};
$c41d79c166ed32cd$export$621d3e5937244948.displayName = "TypeLinks";

});


parcelRegister("4QLXA", function(module, exports) {

$parcel$export(module.exports, "downloadStats", function () { return $c3ae88a8f0b275e3$export$427c3c36ecfcdaf7; });

var $9m34G = parcelRequire("9m34G");
const $c3ae88a8f0b275e3$export$427c3c36ecfcdaf7 = async (backEndUrl)=>{
    const fileName = "OriginTrafficLight.json";
    const response = await (0, $9m34G.downloadFile)({
        url: `${backEndUrl}Hierarchy/StatsReport`,
        fileName: fileName,
        fileType: "application/json",
        blob: true,
        successMessage: "File successfully downloaded",
        errorMessage: "An error has occurred downloading the file",
        controller: new AbortController()
    });
    return response;
};

});
parcelRegister("9m34G", function(module, exports) {

$parcel$export(module.exports, "downloadFile", function () { return $1a36ae0b131fd716$export$bb3b75778e3e272; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");
const $1a36ae0b131fd716$export$bb3b75778e3e272 = async ({ url: url, fileName: fileName, fileType: fileType, successMessage: successMessage, errorMessage: errorMessage, blob: blob, controller: controller })=>{
    try {
        const response = await (0, $lCyBC.default).get(url, blob ? {
            responseType: "blob",
            signal: controller.signal
        } : {
            signal: controller.signal
        });
        const fileContents = !blob ? JSON.stringify(response.data) : response.data;
        const downloadBlob = new Blob([
            fileContents
        ], {
            type: fileType
        });
        // Create object URL and download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(downloadBlob);
        link.download = fileName;
        link.target = "_blank";
        document.body.appendChild(link); // Append to DOM for Firefox compatibility
        link.click();
        link.remove();
        URL.revokeObjectURL(link.href);
        return {
            success: true,
            data: successMessage
        };
    } catch (error) {
        /**
     * Processes an Axios error to extract a meaningful message
     *
     * @param error - The error object from the failed download attempt
     * @returns A string containing an extracted or default error message.
     */ const processError = async (error)=>{
            console.warn("DOWNLOAD FILE ERROR");
            let message = errorMessage;
            if (blob && error.response?.data) message = JSON.parse(await new Response(error.response?.data).text())?.message;
            else {
                const data = error.response?.data;
                message = (typeof data === "string" ? data : data?.message) ?? errorMessage;
            }
            return message;
        };
        return {
            success: false,
            errorText: await processError(error)
        };
    }
};

});


parcelRegister("kZ50A", function(module, exports) {

$parcel$export(module.exports, "useDocumentTitle", function () { return $ce764ed6cb23c7ef$export$4b208edda918084f; });

var $spJKX = parcelRequire("spJKX");
const $ce764ed6cb23c7ef$export$4b208edda918084f = (title)=>{
    (0, $spJKX.useEffect)(()=>{
        document.title = title;
    }, [
        title
    ]);
};

});


parcelRegister("hXN68", function(module, exports) {

$parcel$export(module.exports, "TlfReviewRHS", function () { return $01517650b9a0b796$export$693ebee4d3097e72; });
$parcel$export(module.exports, "default", function () { return $01517650b9a0b796$export$2e2bcd8739ae039; });

var $bR5nk = parcelRequire("bR5nk");

var $gBCr8 = parcelRequire("gBCr8");

var $jHdQm = parcelRequire("jHdQm");

var $7gpLT = parcelRequire("7gpLT");

var $eTFJ7 = parcelRequire("eTFJ7");

var $7TX7i = parcelRequire("7TX7i");

var $g5yF4 = parcelRequire("g5yF4");

var $dVR7M = parcelRequire("dVR7M");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $40ZPd = parcelRequire("40ZPd");

var $7VqtI = parcelRequire("7VqtI");

var $iP0ms = parcelRequire("iP0ms");

var $iPQyT = parcelRequire("iPQyT");

var $4Q81F = parcelRequire("4Q81F");
const $01517650b9a0b796$export$249422c74d329dcd = ()=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $7gpLT.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $40ZPd.HierarchyContextProvider), {
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iP0ms.TocContextProvider), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eTFJ7.HierarchyTopBar), {}),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "col-between-top-and-bottom",
                        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $gBCr8.Allotment), {
                            defaultSizes: [
                                1,
                                5
                            ],
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gBCr8.Allotment).Pane, {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        className: "small-scrollbar col-between-top-and-bottom",
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $g5yF4.TocTree), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gBCr8.Allotment).Pane, {
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4Q81F.Outlet), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dVR7M.BottomNav), {})
                ]
            })
        })
    });
$01517650b9a0b796$export$249422c74d329dcd.displayName = "TlfReview";
const $01517650b9a0b796$export$693ebee4d3097e72 = ()=>{
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7VqtI.TlfContextProvider), {
        readOnly: true,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)($01517650b9a0b796$var$TlfReviewContent, {})
    });
};
/**
 * Renders the active review TLF, or an empty state when the route has no selected item.
 */ const $01517650b9a0b796$var$TlfReviewContent = ()=>{
    const { tlfData: tlfData } = (0, $9Q1dr.useTlfContext)();
    return !tlfData ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        className: "w-100 d-flex align-items-center justify-content-center",
        children: "No Tlf loaded"
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $gBCr8.Allotment), {
        defaultSizes: [
            4,
            1
        ],
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gBCr8.Allotment).Pane, {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "small-scrollbar col-between-top-and-bottom",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7TX7i.TlfInner), {})
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gBCr8.Allotment).Pane, {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "small-scrollbar col-between-top-and-bottom",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jHdQm.CommentPanelInner), {
                        activeContext: "TlfItem"
                    })
                })
            })
        ]
    });
};
$01517650b9a0b796$var$TlfReviewContent.displayName = "TlfReviewContent";
$01517650b9a0b796$export$693ebee4d3097e72.displayName = "TlfReviewRHS";
var $01517650b9a0b796$export$2e2bcd8739ae039 = $01517650b9a0b796$export$249422c74d329dcd;

});
parcelRegister("gBCr8", function(module, exports) {

$parcel$export(module.exports, "Allotment", function () { return $c16deac18fcc4372$export$7250f71dae467feb; });

var $spJKX = parcelRequire("spJKX");
function $c16deac18fcc4372$var$_extends() {
    return $c16deac18fcc4372$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c16deac18fcc4372$var$_extends.apply(null, arguments);
}
var $c16deac18fcc4372$var$l = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $c16deac18fcc4372$var$u(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $c16deac18fcc4372$var$c, $c16deac18fcc4372$var$m = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ var $c16deac18fcc4372$var$d, $c16deac18fcc4372$var$f, $c16deac18fcc4372$var$p, $c16deac18fcc4372$var$v = ($c16deac18fcc4372$var$c || ($c16deac18fcc4372$var$c = 1, $c16deac18fcc4372$var$d = $c16deac18fcc4372$var$m, function() {
    var e = {}.hasOwnProperty;
    function t() {
        for(var e = "", t = 0; t < arguments.length; t++){
            var n = arguments[t];
            n && (e = s(e, i(n)));
        }
        return e;
    }
    function i(i) {
        if ("string" == typeof i || "number" == typeof i) return i;
        if ("object" != typeof i) return "";
        if (Array.isArray(i)) return t.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) return i.toString();
        var n = "";
        for(var r in i)e.call(i, r) && i[r] && (n = s(n, r));
        return n;
    }
    function s(e, t) {
        return t ? e ? e + " " + t : e + t : e;
    }
    $c16deac18fcc4372$var$d.exports ? (t.default = t, $c16deac18fcc4372$var$d.exports = t) : window.classNames = t;
}()), $c16deac18fcc4372$var$m.exports), $c16deac18fcc4372$var$S = $c16deac18fcc4372$var$u($c16deac18fcc4372$var$v);
var $c16deac18fcc4372$var$z, $c16deac18fcc4372$var$g, $c16deac18fcc4372$var$w = ($c16deac18fcc4372$var$p || ($c16deac18fcc4372$var$p = 1, $c16deac18fcc4372$var$f = function e(t, i) {
    if (t === i) return !0;
    if (t && i && "object" == typeof t && "object" == typeof i) {
        if (t.constructor !== i.constructor) return !1;
        var s, n, r;
        if (Array.isArray(t)) {
            if ((s = t.length) != i.length) return !1;
            for(n = s; 0 !== n--;)if (!e(t[n], i[n])) return !1;
            return !0;
        }
        if (t instanceof Map && i instanceof Map) {
            if (t.size !== i.size) return !1;
            for (n of t.entries())if (!i.has(n[0])) return !1;
            for (n of t.entries())if (!e(n[1], i.get(n[0]))) return !1;
            return !0;
        }
        if (t instanceof Set && i instanceof Set) {
            if (t.size !== i.size) return !1;
            for (n of t.entries())if (!i.has(n[0])) return !1;
            return !0;
        }
        if (ArrayBuffer.isView(t) && ArrayBuffer.isView(i)) {
            if ((s = t.length) != i.length) return !1;
            for(n = s; 0 !== n--;)if (t[n] !== i[n]) return !1;
            return !0;
        }
        if (t.constructor === RegExp) return t.source === i.source && t.flags === i.flags;
        if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === i.valueOf();
        if (t.toString !== Object.prototype.toString) return t.toString() === i.toString();
        if ((s = (r = Object.keys(t)).length) !== Object.keys(i).length) return !1;
        for(n = s; 0 !== n--;)if (!Object.prototype.hasOwnProperty.call(i, r[n])) return !1;
        for(n = s; 0 !== n--;){
            var o = r[n];
            if (!e(t[o], i[o])) return !1;
        }
        return !0;
    }
    return t != t && i != i;
}), $c16deac18fcc4372$var$f), $c16deac18fcc4372$var$y = $c16deac18fcc4372$var$u($c16deac18fcc4372$var$w);
var $c16deac18fcc4372$var$b, $c16deac18fcc4372$var$I, $c16deac18fcc4372$var$x = $c16deac18fcc4372$var$u(function() {
    if ($c16deac18fcc4372$var$g) return $c16deac18fcc4372$var$z;
    $c16deac18fcc4372$var$g = 1;
    var e = /^\s+|\s+$/g, t = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, n = parseInt, r = Object.prototype.toString;
    function o(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function a(a) {
        if ("number" == typeof a) return a;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == r.call(e);
        }(a)) return NaN;
        if (o(a)) {
            var h = "function" == typeof a.valueOf ? a.valueOf() : a;
            a = o(h) ? h + "" : h;
        }
        if ("string" != typeof a) return 0 === a ? a : +a;
        a = a.replace(e, "");
        var l = i.test(a);
        return l || s.test(a) ? n(a.slice(2), l ? 2 : 8) : t.test(a) ? NaN : +a;
    }
    return $c16deac18fcc4372$var$z = function z(e, t, i) {
        return void 0 === i && (i = t, t = void 0), void 0 !== i && (i = (i = a(i)) == i ? i : 0), void 0 !== t && (t = (t = a(t)) == t ? t : 0), function(e, t, i) {
            return e == e && (void 0 !== i && (e = e <= i ? e : i), void 0 !== t && (e = e >= t ? e : t)), e;
        }(a(e), t, i);
    };
}());
var $c16deac18fcc4372$var$_ = $c16deac18fcc4372$var$u(function() {
    if ($c16deac18fcc4372$var$I) return $c16deac18fcc4372$var$b;
    $c16deac18fcc4372$var$I = 1;
    var e = /^\s+|\s+$/g, t = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, n = parseInt, r = "object" == typeof $c16deac18fcc4372$var$l && $c16deac18fcc4372$var$l && $c16deac18fcc4372$var$l.Object === Object && $c16deac18fcc4372$var$l, o = "object" == typeof self && self && self.Object === Object && self, a = r || o || Function("return this")(), h = Object.prototype.toString, u = Math.max, c = Math.min, m = function m() {
        return a.Date.now();
    };
    function d(e) {
        var t = typeof e;
        return !!e && ("object" == t || "function" == t);
    }
    function f(r) {
        if ("number" == typeof r) return r;
        if (function(e) {
            return "symbol" == typeof e || function(e) {
                return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == h.call(e);
        }(r)) return NaN;
        if (d(r)) {
            var o = "function" == typeof r.valueOf ? r.valueOf() : r;
            r = d(o) ? o + "" : o;
        }
        if ("string" != typeof r) return 0 === r ? r : +r;
        r = r.replace(e, "");
        var a = i.test(r);
        return a || s.test(r) ? n(r.slice(2), a ? 2 : 8) : t.test(r) ? NaN : +r;
    }
    return $c16deac18fcc4372$var$b = function b(e, t, i) {
        var s, n, r, o, a, h, l = 0, p = !1, v = !1, S = !0;
        if ("function" != typeof e) throw new TypeError("Expected a function");
        function z(t) {
            var i = s, r = n;
            return s = n = void 0, l = t, o = e.apply(r, i);
        }
        function g(e) {
            var i = e - h;
            return void 0 === h || i >= t || i < 0 || v && e - l >= r;
        }
        function w() {
            var e = m();
            if (g(e)) return y(e);
            a = setTimeout(w, function(e) {
                var i = t - (e - h);
                return v ? c(i, r - (e - l)) : i;
            }(e));
        }
        function y(e) {
            return a = void 0, S && s ? z(e) : (s = n = void 0, o);
        }
        function b() {
            var e = m(), i = g(e);
            if (s = arguments, n = this, h = e, i) {
                if (void 0 === a) return function(e) {
                    return l = e, a = setTimeout(w, t), p ? z(e) : o;
                }(h);
                if (v) return a = setTimeout(w, t), z(h);
            }
            return void 0 === a && (a = setTimeout(w, t)), o;
        }
        return t = f(t) || 0, d(i) && (p = !!i.leading, r = (v = "maxWait" in i) ? u(f(i.maxWait) || 0, t) : r, S = "trailing" in i ? !!i.trailing : S), b.cancel = function() {
            void 0 !== a && clearTimeout(a), l = 0, s = h = n = a = void 0;
        }, b.flush = function() {
            return void 0 === a ? o : y(m());
        }, b;
    };
}());
var $c16deac18fcc4372$var$V = {
    width: void 0,
    height: void 0
};
function $c16deac18fcc4372$var$E(e) {
    var r = e.ref, _e$box = e.box, o = _e$box === void 0 ? "content-box" : _e$box, _t = (0, $spJKX.useState)($c16deac18fcc4372$var$V), _t$ = _t[0], a = _t$.width, h = _t$.height, l = _t[1], u = function() {
        var e = (0, $spJKX.useRef)(!1);
        return (0, $spJKX.useEffect)(()=>(e.current = !0, ()=>{
                e.current = !1;
            }), []), (0, $spJKX.useCallback)(()=>e.current, []);
    }(), c = (0, $spJKX.useRef)($c16deac18fcc4372$var$_extends({}, $c16deac18fcc4372$var$V)), m = (0, $spJKX.useRef)(void 0);
    return m.current = e.onResize, (0, $spJKX.useEffect)(()=>{
        if (!r.current) return;
        if ("undefined" == typeof window || !("ResizeObserver" in window)) return;
        var e = new ResizeObserver((_ref)=>{
            var e = _ref[0];
            var t = "border-box" === o ? "borderBoxSize" : "device-pixel-content-box" === o ? "devicePixelContentBoxSize" : "contentBoxSize", i = $c16deac18fcc4372$var$D(e, t, "inlineSize"), s = $c16deac18fcc4372$var$D(e, t, "blockSize");
            if (c.current.width !== i || c.current.height !== s) {
                var _e2 = {
                    width: i,
                    height: s
                };
                c.current.width = i, c.current.height = s, m.current ? m.current(_e2) : u() && l(_e2);
            }
        });
        return e.observe(r.current, {
            box: o
        }), ()=>{
            e.disconnect();
        };
    }, [
        o,
        r,
        u
    ]), {
        width: a,
        height: h
    };
}
function $c16deac18fcc4372$var$D(e, t, i) {
    return e[t] ? Array.isArray(e[t]) ? e[t][0][i] : e[t][i] : "contentBoxSize" === t ? e.contentRect["inlineSize" === i ? "width" : "height"] : void 0;
}
var $c16deac18fcc4372$var$N = "allotment-module_splitView__L-yRc", $c16deac18fcc4372$var$L = "allotment-module_sashContainer__fzwJF", $c16deac18fcc4372$var$M = "allotment-module_splitViewContainer__rQnVa", $c16deac18fcc4372$var$O = "allotment-module_splitViewView__MGZ6O", $c16deac18fcc4372$var$P = "allotment-module_vertical__WSwwa", $c16deac18fcc4372$var$C = "allotment-module_horizontal__7doS8", $c16deac18fcc4372$var$T = "allotment-module_separatorBorder__x-rDS";
var $c16deac18fcc4372$var$A, $c16deac18fcc4372$var$j = !1, $c16deac18fcc4372$var$F = !1;
"object" == typeof navigator && ($c16deac18fcc4372$var$A = navigator.userAgent, $c16deac18fcc4372$var$F = $c16deac18fcc4372$var$A.indexOf("Macintosh") >= 0, $c16deac18fcc4372$var$j = ($c16deac18fcc4372$var$A.indexOf("Macintosh") >= 0 || $c16deac18fcc4372$var$A.indexOf("iPad") >= 0 || $c16deac18fcc4372$var$A.indexOf("iPhone") >= 0) && !!navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
var $c16deac18fcc4372$var$H = $c16deac18fcc4372$var$j, $c16deac18fcc4372$var$Y = $c16deac18fcc4372$var$F, $c16deac18fcc4372$var$k = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? (0, $spJKX.useLayoutEffect) : (0, $spJKX.useEffect);
class $c16deac18fcc4372$var$$ {
    constructor(){
        this._size = void 0;
    }
    getSize() {
        return this._size;
    }
    setSize(e) {
        this._size = e;
    }
}
function $c16deac18fcc4372$var$B(e, t) {
    var i = e.length, s = i - t.length;
    return s >= 0 && e.slice(s, i) === t;
}
var $c16deac18fcc4372$var$G, $c16deac18fcc4372$var$R = {
    exports: {}
};
var $c16deac18fcc4372$var$W = ($c16deac18fcc4372$var$G || ($c16deac18fcc4372$var$G = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, i = "~";
    function s() {}
    function n(e, t, i) {
        this.fn = e, this.context = t, this.once = i || !1;
    }
    function r(e, t, s, r, o) {
        if ("function" != typeof s) throw new TypeError("The listener must be a function");
        var a = new n(s, r || e, o), h = i ? i + t : t;
        return e._events[h] ? e._events[h].fn ? e._events[h] = [
            e._events[h],
            a
        ] : e._events[h].push(a) : (e._events[h] = a, e._eventsCount++), e;
    }
    function o(e, t) {
        0 === --e._eventsCount ? e._events = new s() : delete e._events[t];
    }
    function a() {
        this._events = new s(), this._eventsCount = 0;
    }
    Object.create && (s.prototype = Object.create(null), new s().__proto__ || (i = !1)), a.prototype.eventNames = function() {
        var e, s, n = [];
        if (0 === this._eventsCount) return n;
        for(s in e = this._events)t.call(e, s) && n.push(i ? s.slice(1) : s);
        return Object.getOwnPropertySymbols ? n.concat(Object.getOwnPropertySymbols(e)) : n;
    }, a.prototype.listeners = function(e) {
        var t = i ? i + e : e, s = this._events[t];
        if (!s) return [];
        if (s.fn) return [
            s.fn
        ];
        for(var n = 0, r = s.length, o = new Array(r); n < r; n++)o[n] = s[n].fn;
        return o;
    }, a.prototype.listenerCount = function(e) {
        var t = i ? i + e : e, s = this._events[t];
        return s ? s.fn ? 1 : s.length : 0;
    }, a.prototype.emit = function(e, t, s, n, r, o) {
        var a = i ? i + e : e;
        if (!this._events[a]) return !1;
        var h, l, u = this._events[a], c = arguments.length;
        if (u.fn) {
            switch(u.once && this.removeListener(e, u.fn, void 0, !0), c){
                case 1:
                    return u.fn.call(u.context), !0;
                case 2:
                    return u.fn.call(u.context, t), !0;
                case 3:
                    return u.fn.call(u.context, t, s), !0;
                case 4:
                    return u.fn.call(u.context, t, s, n), !0;
                case 5:
                    return u.fn.call(u.context, t, s, n, r), !0;
                case 6:
                    return u.fn.call(u.context, t, s, n, r, o), !0;
            }
            for(l = 1, h = new Array(c - 1); l < c; l++)h[l - 1] = arguments[l];
            u.fn.apply(u.context, h);
        } else {
            var m, d = u.length;
            for(l = 0; l < d; l++)switch(u[l].once && this.removeListener(e, u[l].fn, void 0, !0), c){
                case 1:
                    u[l].fn.call(u[l].context);
                    break;
                case 2:
                    u[l].fn.call(u[l].context, t);
                    break;
                case 3:
                    u[l].fn.call(u[l].context, t, s);
                    break;
                case 4:
                    u[l].fn.call(u[l].context, t, s, n);
                    break;
                default:
                    if (!h) for(m = 1, h = new Array(c - 1); m < c; m++)h[m - 1] = arguments[m];
                    u[l].fn.apply(u[l].context, h);
            }
        }
        return !0;
    }, a.prototype.on = function(e, t, i) {
        return r(this, e, t, i, !1);
    }, a.prototype.once = function(e, t, i) {
        return r(this, e, t, i, !0);
    }, a.prototype.removeListener = function(e, t, s, n) {
        var r = i ? i + e : e;
        if (!this._events[r]) return this;
        if (!t) return o(this, r), this;
        var a = this._events[r];
        if (a.fn) a.fn !== t || n && !a.once || s && a.context !== s || o(this, r);
        else {
            for(var h = 0, l = [], u = a.length; h < u; h++)(a[h].fn !== t || n && !a[h].once || s && a[h].context !== s) && l.push(a[h]);
            l.length ? this._events[r] = 1 === l.length ? l[0] : l : o(this, r);
        }
        return this;
    }, a.prototype.removeAllListeners = function(e) {
        var t;
        return e ? (t = i ? i + e : e, this._events[t] && o(this, t)) : (this._events = new s(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = i, a.EventEmitter = a, e.exports = a;
}($c16deac18fcc4372$var$R)), $c16deac18fcc4372$var$R.exports), $c16deac18fcc4372$var$X = $c16deac18fcc4372$var$u($c16deac18fcc4372$var$W);
function $c16deac18fcc4372$var$J(e, t) {
    var i = e.indexOf(t);
    i > -1 && (e.splice(i, 1), e.unshift(t));
}
function $c16deac18fcc4372$var$U(e, t) {
    var i = e.indexOf(t);
    i > -1 && (e.splice(i, 1), e.push(t));
}
function $c16deac18fcc4372$var$K(e, t, i) {
    if (i === void 0) i = 1;
    var s = Math.max(0, Math.ceil((t - e) / i)), n = new Array(s);
    var r = -1;
    for(; ++r < s;)n[r] = e + r * i;
    return n;
}
var $c16deac18fcc4372$var$Z = "sash-module_sash__K-9lB", $c16deac18fcc4372$var$Q = "sash-module_disabled__Hm-wx", $c16deac18fcc4372$var$q = "sash-module_mac__Jf6OJ", $c16deac18fcc4372$var$ee = "sash-module_vertical__pB-rs", $c16deac18fcc4372$var$te = "sash-module_minimum__-UKxp", $c16deac18fcc4372$var$ie = "sash-module_maximum__TCWxD", $c16deac18fcc4372$var$se = "sash-module_horizontal__kFbiw", $c16deac18fcc4372$var$ne = "sash-module_hover__80W6I", $c16deac18fcc4372$var$re = "sash-module_active__bJspD";
var $c16deac18fcc4372$var$oe = function(e) {
    return e.Vertical = "VERTICAL", e.Horizontal = "HORIZONTAL", e;
}({}), $c16deac18fcc4372$var$ae = function(e) {
    return e.Disabled = "DISABLED", e.Minimum = "MINIMUM", e.Maximum = "MAXIMUM", e.Enabled = "ENABLED", e;
}({}), $c16deac18fcc4372$var$he = $c16deac18fcc4372$var$H ? 20 : 8;
var $c16deac18fcc4372$var$le = new $c16deac18fcc4372$var$X();
class $c16deac18fcc4372$var$ue extends $c16deac18fcc4372$var$X {
    get state() {
        return this._state;
    }
    set state(e) {
        this._state !== e && (this.el.classList.toggle($c16deac18fcc4372$var$Q, e === $c16deac18fcc4372$var$ae.Disabled), this.el.classList.toggle("sash-disabled", e === $c16deac18fcc4372$var$ae.Disabled), this.el.classList.toggle($c16deac18fcc4372$var$te, e === $c16deac18fcc4372$var$ae.Minimum), this.el.classList.toggle("sash-minimum", e === $c16deac18fcc4372$var$ae.Minimum), this.el.classList.toggle($c16deac18fcc4372$var$ie, e === $c16deac18fcc4372$var$ae.Maximum), this.el.classList.toggle("sash-maximum", e === $c16deac18fcc4372$var$ae.Maximum), this._state = e, this.emit("enablementChange", e));
    }
    constructor(e, t, i){
        var _i$orientation;
        super(), this.el = void 0, this.layoutProvider = void 0, this.orientation = void 0, this.size = void 0, this.hoverDelay = 300, this.hoverDelayer = $c16deac18fcc4372$var$_((e)=>e.classList.add("sash-hover", $c16deac18fcc4372$var$ne), this.hoverDelay), this.finishDrag = void 0, this._state = $c16deac18fcc4372$var$ae.Enabled, this.onDidChangeGlobalSize = (e)=>{
            this.size = e, this.layout();
        }, this.onPointerStart = (e)=>{
            this.endDrag();
            var t = e.pageX, i = e.pageY, s = {
                startX: t,
                currentX: t,
                startY: i,
                currentY: i
            };
            this.el.classList.add("sash-active", $c16deac18fcc4372$var$re), this.emit("start", s);
            var n = e.pointerId;
            this.el.setPointerCapture(n);
            var r = (e)=>{
                e.preventDefault();
                var s = {
                    startX: t,
                    currentX: e.pageX,
                    startY: i,
                    currentY: e.pageY
                };
                this.emit("change", s);
            }, o = (e)=>{
                e.preventDefault(), a();
            }, a = ()=>{
                var _this$el$hasPointerCa, _this$el;
                window.removeEventListener("pointermove", r), window.removeEventListener("pointerup", o), window.removeEventListener("pointercancel", a), (_this$el$hasPointerCa = (_this$el = this.el).hasPointerCapture) != null && _this$el$hasPointerCa.call(_this$el, n) && this.el.releasePointerCapture(n), this.el.classList.remove("sash-active", $c16deac18fcc4372$var$re), this.hoverDelayer.cancel(), this.finishDrag = void 0, this.emit("end");
            };
            this.finishDrag = a, window.addEventListener("pointermove", r), window.addEventListener("pointerup", o), window.addEventListener("pointercancel", a);
        }, this.onPointerDoublePress = ()=>{
            this.emit("reset");
        }, this.onMouseEnter = ()=>{
            this.el.classList.contains($c16deac18fcc4372$var$re) ? (this.hoverDelayer.cancel(), this.el.classList.add("sash-hover", $c16deac18fcc4372$var$ne)) : this.hoverDelayer(this.el);
        }, this.onMouseLeave = ()=>{
            this.hoverDelayer.cancel(), this.el.classList.remove("sash-hover", $c16deac18fcc4372$var$ne);
        }, this.el = document.createElement("div"), this.el.classList.add("sash", $c16deac18fcc4372$var$Z), this.el.dataset.testid = "sash", e.append(this.el), $c16deac18fcc4372$var$Y && this.el.classList.add("sash-mac", $c16deac18fcc4372$var$q), this.el.addEventListener("pointerdown", this.onPointerStart), this.el.addEventListener("dblclick", this.onPointerDoublePress), this.el.addEventListener("mouseenter", this.onMouseEnter), this.el.addEventListener("mouseleave", this.onMouseLeave), "number" == typeof i.size ? (this.size = i.size, i.orientation === $c16deac18fcc4372$var$oe.Vertical ? this.el.style.width = this.size + "px" : this.el.style.height = this.size + "px") : (this.size = $c16deac18fcc4372$var$he, $c16deac18fcc4372$var$le.on("onDidChangeGlobalSize", this.onDidChangeGlobalSize)), this.layoutProvider = t, this.orientation = (_i$orientation = i.orientation) != null ? _i$orientation : $c16deac18fcc4372$var$oe.Vertical, this.orientation === $c16deac18fcc4372$var$oe.Horizontal ? (this.el.classList.add("sash-horizontal", $c16deac18fcc4372$var$se), this.el.classList.remove("sash-vertical", $c16deac18fcc4372$var$ee)) : (this.el.classList.remove("sash-horizontal", $c16deac18fcc4372$var$se), this.el.classList.add("sash-vertical", $c16deac18fcc4372$var$ee)), this.layout();
    }
    endDrag() {
        var _this$finishDrag;
        (_this$finishDrag = this.finishDrag) == null || _this$finishDrag.call(this);
    }
    layout() {
        if (this.orientation === $c16deac18fcc4372$var$oe.Vertical) {
            var _e3 = this.layoutProvider;
            this.el.style.left = _e3.getVerticalSashLeft(this) - this.size / 2 + "px", _e3.getVerticalSashTop && (this.el.style.top = _e3.getVerticalSashTop(this) + "px"), _e3.getVerticalSashHeight && (this.el.style.height = _e3.getVerticalSashHeight(this) + "px");
        } else {
            var _e4 = this.layoutProvider;
            this.el.style.top = _e4.getHorizontalSashTop(this) - this.size / 2 + "px", _e4.getHorizontalSashLeft && (this.el.style.left = _e4.getHorizontalSashLeft(this) + "px"), _e4.getHorizontalSashWidth && (this.el.style.width = _e4.getHorizontalSashWidth(this) + "px");
        }
    }
    dispose() {
        this.endDrag(), this.el.removeEventListener("pointerdown", this.onPointerStart), this.el.removeEventListener("dblclick", this.onPointerDoublePress), this.el.removeEventListener("mouseenter", this.onMouseEnter), this.el.removeEventListener("mouseleave", this.onMouseLeave), $c16deac18fcc4372$var$le.off("onDidChangeGlobalSize", this.onDidChangeGlobalSize), this.hoverDelayer.cancel(), this.removeAllListeners(), this.el.remove();
    }
}
var $c16deac18fcc4372$var$ce;
var $c16deac18fcc4372$var$me;
($c16deac18fcc4372$var$me = $c16deac18fcc4372$var$ce || ($c16deac18fcc4372$var$ce = {})).Distribute = {
    type: "distribute"
}, $c16deac18fcc4372$var$me.Split = function(e) {
    return {
        type: "split",
        index: e
    };
}, $c16deac18fcc4372$var$me.Invisible = function(e) {
    return {
        type: "invisible",
        cachedVisibleSize: e
    };
};
var $c16deac18fcc4372$export$56807b11ea7db5ce = function(e) {
    return e.Normal = "NORMAL", e.Low = "LOW", e.High = "HIGH", e;
}({});
class $c16deac18fcc4372$var$fe {
    constructor(e, t, i){
        this.container = void 0, this.view = void 0, this._size = void 0, this._cachedVisibleSize = void 0, this.container = e, this.view = t, this.container.classList.add("split-view-view", $c16deac18fcc4372$var$O), this.container.dataset.testid = "split-view-view", "number" == typeof i ? (this._size = i, this._cachedVisibleSize = void 0, e.classList.add("split-view-view-visible")) : (this._size = 0, this._cachedVisibleSize = i.cachedVisibleSize);
    }
    set size(e) {
        this._size = e;
    }
    get size() {
        return this._size;
    }
    get priority() {
        return this.view.priority;
    }
    get snap() {
        return !!this.view.snap;
    }
    get cachedVisibleSize() {
        return this._cachedVisibleSize;
    }
    get visible() {
        return void 0 === this._cachedVisibleSize;
    }
    setVisible(e, t) {
        e !== this.visible && (e ? (this.size = $c16deac18fcc4372$var$x(this._cachedVisibleSize, this.viewMinimumSize, this.viewMaximumSize), this._cachedVisibleSize = void 0) : (this._cachedVisibleSize = "number" == typeof t ? t : this.size, this.size = 0), this.container.classList.toggle("split-view-view-visible", e), this.view.setVisible && this.view.setVisible(e));
    }
    get minimumSize() {
        return this.visible ? this.view.minimumSize : 0;
    }
    get viewMinimumSize() {
        return this.view.minimumSize;
    }
    get maximumSize() {
        return this.visible ? this.view.maximumSize : 0;
    }
    get viewMaximumSize() {
        return this.view.maximumSize;
    }
    set enabled(e) {
        this.container.style.pointerEvents = e ? "" : "none";
    }
    layout(e) {
        this.layoutContainer(e), this.view.layout(this.size, e);
    }
}
class $c16deac18fcc4372$var$pe extends $c16deac18fcc4372$var$fe {
    layoutContainer(e) {
        this.container.style.left = e + "px", this.container.style.width = this.size + "px";
    }
}
class $c16deac18fcc4372$var$ve extends $c16deac18fcc4372$var$fe {
    layoutContainer(e) {
        this.container.style.top = e + "px", this.container.style.height = this.size + "px";
    }
}
class $c16deac18fcc4372$var$Se extends $c16deac18fcc4372$var$X {
    get startSnappingEnabled() {
        return this._startSnappingEnabled;
    }
    set startSnappingEnabled(e) {
        this._startSnappingEnabled !== e && (this._startSnappingEnabled = e, this.updateSashEnablement());
    }
    get endSnappingEnabled() {
        return this._endSnappingEnabled;
    }
    set endSnappingEnabled(e) {
        this._endSnappingEnabled !== e && (this._endSnappingEnabled = e, this.updateSashEnablement());
    }
    constructor(e, t, i, s, n){
        var _t$orientation, _t$proportionalLayout;
        if (t === void 0) t = {};
        if (super(), this.onDidChange = void 0, this.onDidDragStart = void 0, this.onDidDragEnd = void 0, this.orientation = void 0, this.sashContainer = void 0, this.size = 0, this.contentSize = 0, this.proportions = void 0, this.viewItems = [], this.sashItems = [], this.sashDragState = void 0, this.proportionalLayout = void 0, this.getSashOrthogonalSize = void 0, this._startSnappingEnabled = !0, this._endSnappingEnabled = !0, this.onSashEnd = (e)=>{
            this.sashDragState = void 0, this.emit("sashchange", e), this.saveProportions();
            for (var _e5 of this.viewItems)_e5.enabled = !0;
        }, this.orientation = (_t$orientation = t.orientation) != null ? _t$orientation : $c16deac18fcc4372$var$oe.Vertical, this.proportionalLayout = (_t$proportionalLayout = t.proportionalLayout) != null ? _t$proportionalLayout : !0, this.getSashOrthogonalSize = t.getSashOrthogonalSize, i && (this.onDidChange = i), s && (this.onDidDragStart = s), n && (this.onDidDragEnd = n), this.sashContainer = document.createElement("div"), this.sashContainer.classList.add("sash-container", $c16deac18fcc4372$var$L), e.prepend(this.sashContainer), t.descriptor) {
            this.size = t.descriptor.size;
            for (var _ref3 of t.descriptor.views.entries()){
                var _e6 = _ref3[0];
                var _i = _ref3[1];
                var _t2 = _i.size, _s = _i.container, _n = _i.view;
                this.addView(_s, _n, _t2, _e6, !0);
            }
            this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0), this.saveProportions();
        }
    }
    addView(e, t, i, s, n) {
        if (s === void 0) s = this.viewItems.length;
        var r;
        this.endSashDrag(), r = "number" == typeof i ? i : "split" === i.type ? this.getViewSize(i.index) / 2 : "invisible" === i.type ? {
            cachedVisibleSize: i.cachedVisibleSize
        } : t.minimumSize;
        var o = this.orientation === $c16deac18fcc4372$var$oe.Vertical ? new $c16deac18fcc4372$var$ve(e, t, r) : new $c16deac18fcc4372$var$pe(e, t, r);
        if (this.viewItems.splice(s, 0, o), this.viewItems.length > 1) {
            var _e7 = this.orientation === $c16deac18fcc4372$var$oe.Vertical ? new $c16deac18fcc4372$var$ue(this.sashContainer, {
                getHorizontalSashTop: (e)=>this.getSashPosition(e),
                getHorizontalSashWidth: this.getSashOrthogonalSize
            }, {
                orientation: $c16deac18fcc4372$var$oe.Horizontal
            }) : new $c16deac18fcc4372$var$ue(this.sashContainer, {
                getVerticalSashLeft: (e)=>this.getSashPosition(e),
                getVerticalSashHeight: this.getSashOrthogonalSize
            }, {
                orientation: $c16deac18fcc4372$var$oe.Vertical
            }), _t3 = this.orientation === $c16deac18fcc4372$var$oe.Vertical ? (t)=>({
                    sash: _e7,
                    start: t.startY,
                    current: t.currentY
                }) : (t)=>({
                    sash: _e7,
                    start: t.startX,
                    current: t.currentX
                });
            _e7.on("start", (e)=>{
                var _this$onDidDragStart;
                this.emit("sashDragStart"), this.onSashStart(_t3(e));
                var i = this.viewItems.map((e)=>e.size);
                (_this$onDidDragStart = this.onDidDragStart) == null || _this$onDidDragStart.call(this, i);
            }), _e7.on("change", (e)=>this.onSashChange(_t3(e))), _e7.on("end", ()=>{
                var _this$onDidDragEnd;
                this.emit("sashDragEnd"), this.onSashEnd(this.sashItems.findIndex((t)=>t.sash === _e7));
                var t = this.viewItems.map((e)=>e.size);
                (_this$onDidDragEnd = this.onDidDragEnd) == null || _this$onDidDragEnd.call(this, t);
            }), _e7.on("reset", ()=>{
                var t = this.sashItems.findIndex((t)=>t.sash === _e7), i = $c16deac18fcc4372$var$K(t, -1, -1), s = $c16deac18fcc4372$var$K(t + 1, this.viewItems.length), n = this.findFirstSnapIndex(i), r = this.findFirstSnapIndex(s);
                ("number" != typeof n || this.viewItems[n].visible) && ("number" != typeof r || this.viewItems[r].visible) && this.emit("sashreset", t);
            });
            var _i2 = {
                sash: _e7
            };
            this.sashItems.splice(s - 1, 0, _i2);
        }
        n || this.relayout(), n || "number" == typeof i || "distribute" !== i.type || this.distributeViewSizes();
    }
    removeView(e, t) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        this.endSashDrag();
        var i = this.viewItems.splice(e, 1)[0].view;
        if (this.viewItems.length >= 1) {
            var _t4 = Math.max(e - 1, 0);
            this.sashItems.splice(_t4, 1)[0].sash.dispose();
        }
        return this.relayout(), t && "distribute" === t.type && this.distributeViewSizes(), i;
    }
    moveView(e, t, i) {
        var s = this.getViewCachedVisibleSize(t), n = void 0 === s ? this.getViewSize(t) : $c16deac18fcc4372$var$ce.Invisible(s), r = this.removeView(t);
        this.addView(e, r, n, i);
    }
    getViewCachedVisibleSize(e) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        return this.viewItems[e].cachedVisibleSize;
    }
    layout(e) {
        if (e === void 0) e = this.size;
        var t = Math.max(this.size, this.contentSize);
        if (this.size = e, this.proportions) for(var _t5 = 0; _t5 < this.viewItems.length; _t5++){
            var _i3 = this.viewItems[_t5];
            _i3.size = $c16deac18fcc4372$var$x(Math.round(this.proportions[_t5] * e), _i3.minimumSize, _i3.maximumSize);
        }
        else {
            var _i4 = $c16deac18fcc4372$var$K(0, this.viewItems.length), _s2 = _i4.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.Low), _n2 = _i4.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.High);
            this.resize(this.viewItems.length - 1, e - t, void 0, _s2, _n2);
        }
        this.distributeEmptySpace(), this.layoutViews();
    }
    resizeView(e, t) {
        if (e < 0 || e >= this.viewItems.length) return;
        var i = $c16deac18fcc4372$var$K(0, this.viewItems.length).filter((t)=>t !== e), s = [
            ...i.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.Low),
            e
        ], n = i.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.High), r = this.viewItems[e];
        t = Math.round(t), t = $c16deac18fcc4372$var$x(t, r.minimumSize, Math.min(r.maximumSize, this.size)), r.size = t, this.relayout(s, n);
    }
    resizeViews(e) {
        var t = Math.min(e.length, this.viewItems.length);
        for(var _i5 = 0; _i5 < t; _i5++){
            var _t6 = this.viewItems[_i5];
            var _s3 = e[_i5];
            _s3 = Math.round(_s3), _s3 = $c16deac18fcc4372$var$x(_s3, _t6.minimumSize, Math.min(_t6.maximumSize, this.size)), _t6.size = _s3;
        }
        this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0), this.saveProportions(), this.layout(this.size);
    }
    getViewSize(e) {
        return e < 0 || e >= this.viewItems.length ? -1 : this.viewItems[e].size;
    }
    isViewVisible(e) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        return this.viewItems[e].visible;
    }
    setViewVisible(e, t) {
        if (e < 0 || e >= this.viewItems.length) throw new Error("Index out of bounds");
        this.viewItems[e].setVisible(t), this.distributeEmptySpace(e), this.layoutViews(), this.saveProportions();
    }
    distributeViewSizes() {
        var e = [];
        var t = 0;
        for (var _i6 of this.viewItems)_i6.maximumSize - _i6.minimumSize > 0 && (e.push(_i6), t += _i6.size);
        var i = Math.floor(t / e.length);
        for (var _t7 of e)_t7.size = $c16deac18fcc4372$var$x(i, _t7.minimumSize, _t7.maximumSize);
        var s = $c16deac18fcc4372$var$K(0, this.viewItems.length), n = s.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.Low), r = s.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.High);
        this.relayout(n, r);
    }
    dispose() {
        this.sashItems.forEach((e)=>e.sash.dispose()), this.sashItems = [], this.sashContainer.remove();
    }
    relayout(e, t) {
        var i = this.viewItems.reduce((e, t)=>e + t.size, 0);
        this.resize(this.viewItems.length - 1, this.size - i, void 0, e, t), this.distributeEmptySpace(), this.layoutViews(), this.saveProportions();
    }
    onSashStart(_ref4) {
        var e = _ref4.sash, t = _ref4.start;
        var i = this.sashItems.findIndex((t)=>t.sash === e);
        ((e)=>{
            var t = this.viewItems.map((e)=>e.size);
            var s, n, r = Number.NEGATIVE_INFINITY, o = Number.POSITIVE_INFINITY;
            var a = $c16deac18fcc4372$var$K(i, -1, -1), h = $c16deac18fcc4372$var$K(i + 1, this.viewItems.length), l = a.reduce((e, i)=>e + (this.viewItems[i].minimumSize - t[i]), 0), u = a.reduce((e, i)=>e + (this.viewItems[i].viewMaximumSize - t[i]), 0), c = 0 === h.length ? Number.POSITIVE_INFINITY : h.reduce((e, i)=>e + (t[i] - this.viewItems[i].minimumSize), 0), m = 0 === h.length ? Number.NEGATIVE_INFINITY : h.reduce((e, i)=>e + (t[i] - this.viewItems[i].viewMaximumSize), 0);
            r = Math.max(l, m), o = Math.min(c, u);
            var d = this.findFirstSnapIndex(a), f = this.findFirstSnapIndex(h);
            if ("number" == typeof d) {
                var _e8 = this.viewItems[d], _t8 = Math.floor(_e8.viewMinimumSize / 2);
                s = {
                    index: d,
                    limitDelta: _e8.visible ? r - _t8 : r + _t8,
                    size: _e8.size
                };
            }
            if ("number" == typeof f) {
                var _e9 = this.viewItems[f], _t9 = Math.floor(_e9.viewMinimumSize / 2);
                n = {
                    index: f,
                    limitDelta: _e9.visible ? o + _t9 : o - _t9,
                    size: _e9.size
                };
            }
            this.sashDragState = {
                start: e,
                current: e,
                index: i,
                sizes: t,
                minDelta: r,
                maxDelta: o,
                snapBefore: s,
                snapAfter: n
            };
        })(t);
    }
    onSashChange(_ref5) {
        var e = _ref5.current;
        if (!this.sashDragState) return;
        var _this$sashDragState = this.sashDragState, t = _this$sashDragState.index, i = _this$sashDragState.start, s = _this$sashDragState.sizes, n = _this$sashDragState.minDelta, r = _this$sashDragState.maxDelta, o = _this$sashDragState.snapBefore, a = _this$sashDragState.snapAfter;
        this.sashDragState.current = e;
        var h = e - i;
        this.resize(t, h, s, void 0, void 0, n, r, o, a), this.distributeEmptySpace(), this.layoutViews();
    }
    endSashDrag() {
        for (var _e0 of this.sashItems)_e0.sash.endDrag();
    }
    getSashPosition(e) {
        var t = 0;
        for(var _i7 = 0; _i7 < this.sashItems.length; _i7++)if (t += this.viewItems[_i7].size, this.sashItems[_i7].sash === e) return t;
        return 0;
    }
    resize(e, t, i, s, n, r, o, a, h) {
        if (i === void 0) i = this.viewItems.map((e)=>e.size);
        if (r === void 0) r = Number.NEGATIVE_INFINITY;
        if (o === void 0) o = Number.POSITIVE_INFINITY;
        if (e < 0 || e >= this.viewItems.length) return 0;
        var l = $c16deac18fcc4372$var$K(e, -1, -1), u = $c16deac18fcc4372$var$K(e + 1, this.viewItems.length);
        if (n) for (var _e1 of n)$c16deac18fcc4372$var$J(l, _e1), $c16deac18fcc4372$var$J(u, _e1);
        if (s) for (var _e10 of s)$c16deac18fcc4372$var$U(l, _e10), $c16deac18fcc4372$var$U(u, _e10);
        var c = l.map((e)=>this.viewItems[e]), m = l.map((e)=>i[e]), d = u.map((e)=>this.viewItems[e]), f = u.map((e)=>i[e]), p = l.reduce((e, t)=>e + (this.viewItems[t].minimumSize - i[t]), 0), v = l.reduce((e, t)=>e + (this.viewItems[t].maximumSize - i[t]), 0), S = 0 === u.length ? Number.POSITIVE_INFINITY : u.reduce((e, t)=>e + (i[t] - this.viewItems[t].minimumSize), 0), z = 0 === u.length ? Number.NEGATIVE_INFINITY : u.reduce((e, t)=>e + (i[t] - this.viewItems[t].maximumSize), 0), g = Math.max(p, z, r), w = Math.min(S, v, o);
        var y = !1;
        if (a) {
            var _e11 = this.viewItems[a.index], _i8 = t >= a.limitDelta;
            y = _i8 !== _e11.visible, _e11.setVisible(_i8, a.size);
        }
        if (!y && h) {
            var _e12 = this.viewItems[h.index], _i9 = t < h.limitDelta;
            y = _i9 !== _e12.visible, _e12.setVisible(_i9, h.size);
        }
        if (y) return this.resize(e, t, i, s, n, r, o);
        for(var _e13 = 0, _i0 = t = $c16deac18fcc4372$var$x(t, g, w); _e13 < c.length; _e13++){
            var _t0 = c[_e13], _s4 = $c16deac18fcc4372$var$x(m[_e13] + _i0, _t0.minimumSize, _t0.maximumSize);
            _i0 -= _s4 - m[_e13], _t0.size = _s4;
        }
        for(var _e14 = 0, _i1 = t; _e14 < d.length; _e14++){
            var _t1 = d[_e14], _s5 = $c16deac18fcc4372$var$x(f[_e14] - _i1, _t1.minimumSize, _t1.maximumSize);
            _i1 += _s5 - f[_e14], _t1.size = _s5;
        }
        return t;
    }
    distributeEmptySpace(e) {
        var t = this.viewItems.reduce((e, t)=>e + t.size, 0);
        var i = this.size - t;
        var s = $c16deac18fcc4372$var$K(0, this.viewItems.length), n = [], r = s.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.Low), o = s.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.Normal), a = s.filter((e)=>this.viewItems[e].priority === $c16deac18fcc4372$export$56807b11ea7db5ce.High);
        n.push(...a, ...o, ...r), "number" == typeof e && $c16deac18fcc4372$var$U(n, e);
        for(var _e15 = 0; 0 !== i && _e15 < n.length; _e15++){
            var _t10 = this.viewItems[n[_e15]], _s6 = $c16deac18fcc4372$var$x(_t10.size + i, _t10.minimumSize, _t10.maximumSize);
            i -= _s6 - _t10.size, _t10.size = _s6;
        }
    }
    layoutViews() {
        var _this$onDidChange;
        this.contentSize = this.viewItems.reduce((e, t)=>e + t.size, 0);
        var e = 0;
        for (var _t11 of this.viewItems)_t11.layout(e), e += _t11.size;
        (_this$onDidChange = this.onDidChange) != null && _this$onDidChange.call(this, this.viewItems.map((e)=>e.size)), this.sashItems.forEach((e)=>e.sash.layout()), this.updateSashEnablement();
    }
    saveProportions() {
        this.proportionalLayout && this.contentSize > 0 && (this.proportions = this.viewItems.map((e)=>e.size / this.contentSize));
    }
    updateSashEnablement() {
        var e = !1;
        var t = this.viewItems.map((t)=>e = t.size - t.minimumSize > 0 || e);
        e = !1;
        var i = this.viewItems.map((t)=>e = t.maximumSize - t.size > 0 || e), s = [
            ...this.viewItems
        ].reverse();
        e = !1;
        var n = s.map((t)=>e = t.size - t.minimumSize > 0 || e).reverse();
        e = !1;
        var r = s.map((t)=>e = t.maximumSize - t.size > 0 || e).reverse();
        var o = 0;
        for(var _e16 = 0; _e16 < this.sashItems.length; _e16++){
            var _s7 = this.sashItems[_e16].sash;
            o += this.viewItems[_e16].size;
            var _a = !(t[_e16] && r[_e16 + 1]), _h = !(i[_e16] && n[_e16 + 1]);
            if (_a && _h) {
                var _i10 = $c16deac18fcc4372$var$K(_e16, -1, -1), _r = $c16deac18fcc4372$var$K(_e16 + 1, this.viewItems.length), _a2 = this.findFirstSnapIndex(_i10), _h2 = this.findFirstSnapIndex(_r), _l = "number" == typeof _a2 && !this.viewItems[_a2].visible, _u = "number" == typeof _h2 && !this.viewItems[_h2].visible;
                _l && n[_e16] && (o > 0 || this.startSnappingEnabled) ? _s7.state = $c16deac18fcc4372$var$ae.Minimum : _u && t[_e16] && (o < this.contentSize || this.endSnappingEnabled) ? _s7.state = $c16deac18fcc4372$var$ae.Maximum : _s7.state = $c16deac18fcc4372$var$ae.Disabled;
            } else _s7.state = _a && !_h ? $c16deac18fcc4372$var$ae.Minimum : !_a && _h ? $c16deac18fcc4372$var$ae.Maximum : $c16deac18fcc4372$var$ae.Enabled;
        }
    }
    findFirstSnapIndex(e) {
        for (var _t12 of e){
            var _e17 = this.viewItems[_t12];
            if (_e17.visible && _e17.snap) return _t12;
        }
        for (var _t13 of e){
            var _e18 = this.viewItems[_t13];
            if (_e18.visible && _e18.maximumSize - _e18.minimumSize > 0) return;
            if (!_e18.visible && _e18.snap) return _t13;
        }
    }
}
class $c16deac18fcc4372$var$ze {
    constructor(e){
        this.size = void 0, this.size = e;
    }
    getPreferredSize() {
        return this.size;
    }
}
class $c16deac18fcc4372$var$ge {
    constructor(e, t){
        this.proportion = void 0, this.layoutService = void 0, this.proportion = e, this.layoutService = t;
    }
    getPreferredSize() {
        return this.proportion * this.layoutService.getSize();
    }
}
class $c16deac18fcc4372$var$we {
    getPreferredSize() {}
}
class $c16deac18fcc4372$var$ye {
    get preferredSize() {
        return this.layoutStrategy.getPreferredSize();
    }
    set preferredSize(e) {
        if ("number" == typeof e) this.layoutStrategy = new $c16deac18fcc4372$var$ze(e);
        else if ("string" == typeof e) {
            var _t14 = e.trim();
            if ($c16deac18fcc4372$var$B(_t14, "%")) {
                var _e19 = Number(_t14.slice(0, -1)) / 100;
                this.layoutStrategy = new $c16deac18fcc4372$var$ge(_e19, this.layoutService);
            } else if ($c16deac18fcc4372$var$B(_t14, "px")) {
                var _e20 = Number(_t14.slice(0, -2)) / 100;
                this.layoutStrategy = new $c16deac18fcc4372$var$ze(_e20);
            } else if ("number" == typeof Number.parseFloat(_t14)) {
                var _e21 = Number.parseFloat(_t14);
                this.layoutStrategy = new $c16deac18fcc4372$var$ze(_e21);
            } else this.layoutStrategy = new $c16deac18fcc4372$var$we();
        } else this.layoutStrategy = new $c16deac18fcc4372$var$we();
    }
    constructor(e, t){
        var _t$priority;
        if (this.minimumSize = 0, this.maximumSize = Number.POSITIVE_INFINITY, this.element = void 0, this.priority = void 0, this.snap = void 0, this.layoutService = void 0, this.layoutStrategy = void 0, this.layoutService = e, this.element = t.element, this.minimumSize = "number" == typeof t.minimumSize ? t.minimumSize : 30, this.maximumSize = "number" == typeof t.maximumSize ? t.maximumSize : Number.POSITIVE_INFINITY, "number" == typeof t.preferredSize) this.layoutStrategy = new $c16deac18fcc4372$var$ze(t.preferredSize);
        else if ("string" == typeof t.preferredSize) {
            var _e22 = t.preferredSize.trim();
            if ($c16deac18fcc4372$var$B(_e22, "%")) {
                var _t15 = Number(_e22.slice(0, -1)) / 100;
                this.layoutStrategy = new $c16deac18fcc4372$var$ge(_t15, this.layoutService);
            } else if ($c16deac18fcc4372$var$B(_e22, "px")) {
                var _t16 = Number(_e22.slice(0, -2));
                this.layoutStrategy = new $c16deac18fcc4372$var$ze(_t16);
            } else if ("number" == typeof Number.parseFloat(_e22)) {
                var _t17 = Number.parseFloat(_e22);
                this.layoutStrategy = new $c16deac18fcc4372$var$ze(_t17);
            } else this.layoutStrategy = new $c16deac18fcc4372$var$we();
        } else this.layoutStrategy = new $c16deac18fcc4372$var$we();
        this.priority = (_t$priority = t.priority) != null ? _t$priority : $c16deac18fcc4372$export$56807b11ea7db5ce.Normal, this.snap = "boolean" == typeof t.snap && t.snap;
    }
    layout(e) {}
}
function $c16deac18fcc4372$var$be(e) {
    return void 0 !== e.minSize || void 0 !== e.maxSize || void 0 !== e.preferredSize || void 0 !== e.priority || void 0 !== e.visible;
}
var $c16deac18fcc4372$var$Ie = (0, $spJKX.forwardRef)((_ref6, s)=>{
    var t = _ref6.className, i = _ref6.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("div", {
        ref: s,
        className: $c16deac18fcc4372$var$S("split-view-view", $c16deac18fcc4372$var$O, t)
    }, i);
});
$c16deac18fcc4372$var$Ie.displayName = "Allotment.Pane";
var $c16deac18fcc4372$var$xe = (0, $spJKX.forwardRef)((_ref7, _)=>{
    var r = _ref7.children, o = _ref7.className, l = _ref7.id, _ref7$maxSize = _ref7.maxSize, u = _ref7$maxSize === void 0 ? 1 / 0 : _ref7$maxSize, _ref7$minSize = _ref7.minSize, c = _ref7$minSize === void 0 ? 30 : _ref7$minSize, _ref7$proportionalLay = _ref7.proportionalLayout, m = _ref7$proportionalLay === void 0 ? !0 : _ref7$proportionalLay, _ref7$separator = _ref7.separator, d = _ref7$separator === void 0 ? !0 : _ref7$separator, f = _ref7.sizes, _ref7$defaultSizes = _ref7.defaultSizes, p = _ref7$defaultSizes === void 0 ? f : _ref7$defaultSizes, _ref7$snap = _ref7.snap, v = _ref7$snap === void 0 ? !1 : _ref7$snap, _ref7$vertical = _ref7.vertical, z = _ref7$vertical === void 0 ? !1 : _ref7$vertical, g = _ref7.onChange, w = _ref7.onReset, b = _ref7.onVisibleChange, I = _ref7.onDragStart, x = _ref7.onDragEnd;
    var V = (0, $spJKX.useRef)(null), D = (0, $spJKX.useRef)([]), L = (0, $spJKX.useRef)(new Map()), O = (0, $spJKX.useRef)(null), A = (0, $spJKX.useRef)(new Map()), j = (0, $spJKX.useRef)(new $c16deac18fcc4372$var$$()), F = (0, $spJKX.useRef)([]), Y = (0, $spJKX.useRef)(w), _t18 = (0, $spJKX.useState)(!1), B = _t18[0], G = _t18[1];
    f && console.warn("Prop sizes is deprecated. Please use defaultSizes instead.");
    var R = (0, $spJKX.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Children.toArray(r).filter((0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).isValidElement), [
        r
    ]), W = (0, $spJKX.useCallback)((e)=>{
        var _F$current, _O$current;
        var t = (_F$current = F.current) == null ? void 0 : _F$current[e];
        return "number" == typeof (t == null ? void 0 : t.preferredSize) && ((_O$current = O.current) != null && _O$current.resizeView(e, Math.round(t.preferredSize)), !0);
    }, []);
    return (0, $spJKX.useImperativeHandle)(_, ()=>({
            reset: ()=>{
                if (w) w();
                else {
                    var _O$current2;
                    (_O$current2 = O.current) == null || _O$current2.distributeViewSizes();
                    for(var _e23 = 0; _e23 < F.current.length; _e23++)W(_e23);
                }
            },
            resize: (e)=>{
                var _O$current3;
                (_O$current3 = O.current) == null || _O$current3.resizeViews(e);
            }
        })), $c16deac18fcc4372$var$k(()=>{
        var e = !0;
        p && A.current.size !== p.length && (e = !1, console.warn("Expected " + p.length + " children based on defaultSizes but found " + A.current.size)), e && p && (D.current = R.map((e)=>e.key));
        var t = $c16deac18fcc4372$var$_extends({
            orientation: z ? $c16deac18fcc4372$var$oe.Vertical : $c16deac18fcc4372$var$oe.Horizontal,
            proportionalLayout: m
        }, e && p && {
            descriptor: {
                size: p.reduce((e, t)=>e + t, 0),
                views: p.map((e, t)=>{
                    var _i$minSize, _i$maxSize, _i$priority, _i$snap;
                    var i = L.current.get(D.current[t]), s = new $c16deac18fcc4372$var$ye(j.current, $c16deac18fcc4372$var$_extends({
                        element: document.createElement("div"),
                        minimumSize: (_i$minSize = i == null ? void 0 : i.minSize) != null ? _i$minSize : c,
                        maximumSize: (_i$maxSize = i == null ? void 0 : i.maxSize) != null ? _i$maxSize : u,
                        priority: (_i$priority = i == null ? void 0 : i.priority) != null ? _i$priority : $c16deac18fcc4372$export$56807b11ea7db5ce.Normal
                    }, (i == null ? void 0 : i.preferredSize) && {
                        preferredSize: i == null ? void 0 : i.preferredSize
                    }, {
                        snap: (_i$snap = i == null ? void 0 : i.snap) != null ? _i$snap : v
                    }));
                    return F.current.push(s), {
                        container: [
                            ...A.current.values()
                        ][t],
                        size: e,
                        view: s
                    };
                })
            }
        });
        O.current = new $c16deac18fcc4372$var$Se(V.current, t, g, I, x), O.current.on("sashDragStart", ()=>{
            var _V$current;
            (_V$current = V.current) == null || _V$current.classList.add("split-view-sash-dragging");
        }), O.current.on("sashDragEnd", ()=>{
            var _V$current2;
            (_V$current2 = V.current) == null || _V$current2.classList.remove("split-view-sash-dragging");
        }), O.current.on("sashchange", (e)=>{
            if (b && O.current) {
                var _e24 = R.map((e)=>e.key);
                for(var _t19 = 0; _t19 < _e24.length; _t19++){
                    var _i11 = L.current.get(_e24[_t19]);
                    void 0 !== (_i11 == null ? void 0 : _i11.visible) && _i11.visible !== O.current.isViewVisible(_t19) && b(_t19, O.current.isViewVisible(_t19));
                }
            }
        }), O.current.on("sashreset", (e)=>{
            if (Y.current) Y.current();
            else {
                var _O$current4;
                if (W(e)) return;
                if (W(e + 1)) return;
                (_O$current4 = O.current) == null || _O$current4.distributeViewSizes();
            }
        });
        var i = O.current;
        return ()=>{
            i.dispose();
        };
    }, []), $c16deac18fcc4372$var$k(()=>{
        if (B) {
            var _e25 = R.map((e)=>e.key), _t20 = [
                ...D.current
            ], _i12 = _e25.filter((e)=>!D.current.includes(e)), _s8 = _e25.filter((e)=>D.current.includes(e)), _n3 = D.current.map((t)=>!_e25.includes(t));
            for(var _e26 = _n3.length - 1; _e26 >= 0; _e26--){
                var _O$current5;
                _n3[_e26] && ((_O$current5 = O.current) != null && _O$current5.removeView(_e26), _t20.splice(_e26, 1), F.current.splice(_e26, 1));
            }
            var _loop = function _loop(_s9) {
                var _i$minSize2, _i$maxSize2, _i$priority2, _i$snap2, _O$current7;
                var i = L.current.get(_s9), n = new $c16deac18fcc4372$var$ye(j.current, $c16deac18fcc4372$var$_extends({
                    element: document.createElement("div"),
                    minimumSize: (_i$minSize2 = i == null ? void 0 : i.minSize) != null ? _i$minSize2 : c,
                    maximumSize: (_i$maxSize2 = i == null ? void 0 : i.maxSize) != null ? _i$maxSize2 : u,
                    priority: (_i$priority2 = i == null ? void 0 : i.priority) != null ? _i$priority2 : $c16deac18fcc4372$export$56807b11ea7db5ce.Normal
                }, (i == null ? void 0 : i.preferredSize) && {
                    preferredSize: i == null ? void 0 : i.preferredSize
                }, {
                    snap: (_i$snap2 = i == null ? void 0 : i.snap) != null ? _i$snap2 : v
                }));
                (_O$current7 = O.current) != null && _O$current7.addView(A.current.get(_s9), n, $c16deac18fcc4372$var$ce.Distribute, _e25.findIndex((e)=>e === _s9)), _t20.splice(_e25.findIndex((e)=>e === _s9), 0, _s9), F.current.splice(_e25.findIndex((e)=>e === _s9), 0, n);
            };
            for (var _s9 of _i12)_loop(_s9);
            for(; !$c16deac18fcc4372$var$y(_e25, _t20);){
                var _loop2 = function _loop2() {
                    var i = _ref9[0];
                    var s = _ref9[1];
                    var _e27 = _t20.findIndex((e)=>e === s);
                    if (_e27 !== i) {
                        var _O$current6;
                        (_O$current6 = O.current) == null || _O$current6.moveView(A.current.get(s), _e27, i);
                        var _n4 = _t20[_e27];
                        _t20.splice(_e27, 1), _t20.splice(i, 0, _n4);
                        return 1; // break
                    }
                };
                for (var _ref9 of _e25.entries()){
                    if (_loop2()) break;
                }
            }
            var _loop3 = function _loop3(_t21) {
                var _O$current8;
                var i = _e25.findIndex((e)=>e === _t21), s = F.current[i].preferredSize;
                void 0 !== s && ((_O$current8 = O.current) == null || _O$current8.resizeView(i, s));
            };
            for (var _t21 of _i12)_loop3(_t21);
            var _loop4 = function _loop4(_t22) {
                var _O$current9, _O$current0;
                var i = L.current.get(_t22), s = _e25.findIndex((e)=>e === _t22);
                i && $c16deac18fcc4372$var$be(i) && void 0 !== i.visible && ((_O$current9 = O.current) == null ? void 0 : _O$current9.isViewVisible(s)) !== i.visible && ((_O$current0 = O.current) == null || _O$current0.setViewVisible(s, i.visible));
            };
            for (var _t22 of [
                ..._i12,
                ..._s8
            ])_loop4(_t22);
            var _loop5 = function _loop5(_t23) {
                var i = L.current.get(_t23), s = _e25.findIndex((e)=>e === _t23);
                if (i && $c16deac18fcc4372$var$be(i)) {
                    var _O$current1;
                    void 0 !== i.preferredSize && F.current[s].preferredSize !== i.preferredSize && (F.current[s].preferredSize = i.preferredSize);
                    var _e28 = !1;
                    void 0 !== i.minSize && F.current[s].minimumSize !== i.minSize && (F.current[s].minimumSize = i.minSize, _e28 = !0), void 0 !== i.maxSize && F.current[s].maximumSize !== i.maxSize && (F.current[s].maximumSize = i.maxSize, _e28 = !0), _e28 && ((_O$current1 = O.current) == null || _O$current1.layout());
                }
            };
            for (var _t23 of _s8)_loop5(_t23);
            (_i12.length > 0 || _n3.length > 0) && (D.current = _e25);
        }
    }, [
        R,
        B,
        u,
        c,
        v
    ]), (0, $spJKX.useEffect)(()=>{
        O.current && (O.current.onDidChange = g);
    }, [
        g
    ]), (0, $spJKX.useEffect)(()=>{
        O.current && (O.current.onDidDragStart = I);
    }, [
        I
    ]), (0, $spJKX.useEffect)(()=>{
        O.current && (O.current.onDidDragEnd = x);
    }, [
        x
    ]), (0, $spJKX.useEffect)(()=>{
        Y.current = w;
    }, [
        w
    ]), $c16deac18fcc4372$var$E({
        ref: V,
        onResize: (_ref0)=>{
            var _O$current10;
            var e = _ref0.width, t = _ref0.height;
            e && t && ((_O$current10 = O.current) != null && _O$current10.layout(z ? t : e), j.current.setSize(z ? t : e), G(!0));
        }
    }), (0, $spJKX.useEffect)(()=>{
        $c16deac18fcc4372$var$H && $c16deac18fcc4372$export$aed1c99c50218917(20);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("div", {
        ref: V,
        className: $c16deac18fcc4372$var$S("split-view", z ? "split-view-vertical" : "split-view-horizontal", {
            "split-view-separator-border": d
        }, $c16deac18fcc4372$var$N, z ? $c16deac18fcc4372$var$P : $c16deac18fcc4372$var$C, {
            [$c16deac18fcc4372$var$T]: d
        }, o),
        id: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("div", {
        className: $c16deac18fcc4372$var$S("split-view-container", $c16deac18fcc4372$var$M)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Children.toArray(r).map((t)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).isValidElement(t)) return null;
        var i = t.key;
        return "Allotment.Pane" === t.type.displayName ? (L.current.set(i, t.props), (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).cloneElement(t, {
            key: i,
            ref: (e)=>{
                var s = t.ref;
                s && (s.current = e), e ? A.current.set(i, e) : A.current.delete(i);
            }
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($c16deac18fcc4372$var$Ie, {
            key: i,
            ref: (e)=>{
                e ? A.current.set(i, e) : A.current.delete(i);
            }
        }, t);
    })));
});
function $c16deac18fcc4372$export$aed1c99c50218917(e) {
    var t = $c16deac18fcc4372$var$x(e, 4, 20), i = $c16deac18fcc4372$var$x(e, 1, 8);
    document.documentElement.style.setProperty("--sash-size", t + "px"), document.documentElement.style.setProperty("--sash-hover-size", i + "px"), function(e) {
        $c16deac18fcc4372$var$he = e, $c16deac18fcc4372$var$le.emit("onDidChangeGlobalSize", e);
    }(t);
}
$c16deac18fcc4372$var$xe.displayName = "Allotment";
var $c16deac18fcc4372$export$7250f71dae467feb = Object.assign($c16deac18fcc4372$var$xe, {
    Pane: $c16deac18fcc4372$var$Ie
});

});

parcelRegister("eTFJ7", function(module, exports) {

$parcel$export(module.exports, "HierarchyTopBar", function () { return $19f57799c814fc50$export$10e6861c7889bdb3; });

var $bR5nk = parcelRequire("bR5nk");

var $aAXCH = parcelRequire("aAXCH");

var $e9fGk = parcelRequire("e9fGk");

var $oKzk0 = parcelRequire("oKzk0");

var $iZi5j = parcelRequire("iZi5j");

var $ftPLN = parcelRequire("ftPLN");

var $3degO = parcelRequire("3degO");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $a41A8 = parcelRequire("a41A8");

var $4lHS7 = parcelRequire("4lHS7");

var $feOPT = parcelRequire("feOPT");

var $iFBNq = parcelRequire("iFBNq");

var $kZ50A = parcelRequire("kZ50A");

var $spJKX = parcelRequire("spJKX");

var $5FU7L = parcelRequire("5FU7L");

var $4Q81F = parcelRequire("4Q81F");

var $lE7gc = parcelRequire("lE7gc");

var $8F6kk = parcelRequire("8F6kk");

var $789ri = parcelRequire("789ri");

var $2sTa7 = parcelRequire("2sTa7");
const $19f57799c814fc50$export$10e6861c7889bdb3 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const { save: save } = (0, $3degO.useSave)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const location = (0, $4Q81F.useLocation)();
    const urlParams = (0, $4Q81F.useParams)();
    const [showCopyModal, setShowCopyModal] = (0, $spJKX.useState)(false);
    const [showLoadModal, setShowLoadModal] = (0, $spJKX.useState)(false);
    const [showExportTlfBundleModal, setShowExportTlfBundleModal] = (0, $spJKX.useState)(false);
    const [showImportTlfBundleModal, setShowImportTlfBundleModal] = (0, $spJKX.useState)(false);
    const [showRemoveStylesModal, setShowRemoveStylesModal] = (0, $spJKX.useState)(null);
    const [arsErrorText, setArsErrorText] = (0, $spJKX.useState)(null);
    (0, $spJKX.useEffect)(()=>{
        if (hierarchyContext && urlParams.hierarchyId !== undefined && hierarchyContext.id !== urlParams.hierarchyId) hierarchyContext.dispatch({
            operation: (0, $0eakK.SET_HIERARCHY_ID),
            hierarchyId: urlParams.hierarchyId
        });
    }, [
        hierarchyContext,
        urlParams
    ]);
    (0, $kZ50A.useDocumentTitle)(hierarchyContext?.title ?? "Loading hierarchy...");
    const tocVersion = ` (${(0, $a41A8.tocVersionString)(hierarchyContext?.hierarchy?.tocMajorVersion, hierarchyContext?.hierarchy?.tocMinorVersion, hierarchyContext?.hierarchy?.isBackupVersion)})`;
    // Determine if we should show Remove Styles option based on current route
    const shouldShowRemoveStyles = (hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report) && (location?.pathname?.includes("/Lists") || location?.pathname?.includes("/Replacements")) && hierarchyContext?.accessRights?.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy);
    const replacementLevelFromPath = location?.pathname?.includes("/Lists") ? "HierarchyLists" : "HierarchySingles";
    /**
   * Check if there are styles to remove in the current hierarchy context.
   * Calculated inline to determine if the menu option should be disabled.
   */ const hasStylesToRemove = hierarchyContext?.hierarchy && (replacementLevelFromPath === "HierarchyLists" ? (0, $e9fGk.hasStylesToRemoveInLists)(hierarchyContext.hierarchy.lists) : (0, $oKzk0.hasStylesToRemoveInSingles)(hierarchyContext.hierarchy.singles));
    const bundleHierarchyLevel = hierarchyContext?.hierarchy?.level;
    const isArsBulkBundleLevel = bundleHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Corporate || bundleHierarchyLevel === (0, $4lHS7.eHierarchyLevel).TA || bundleHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Project;
    const supportsBundleTransfer = isArsBulkBundleLevel || bundleHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Study || bundleHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report;
    const hasArsBulkExportImportPermission = appSettings.applicationPermissions.includes((0, $4lHS7.eApplicationPermission).AllowArsBulkExportImport);
    const canExportTlfBundle = appSettings.isAdmin && supportsBundleTransfer && (appSettings.applicationPermissions.includes((0, $4lHS7.eApplicationPermission).AllowJsonDownload) || isArsBulkBundleLevel && hasArsBulkExportImportPermission);
    const canImportTlfBundle = appSettings.isAdmin && supportsBundleTransfer && (appSettings.applicationPermissions.includes((0, $4lHS7.eApplicationPermission).AllowJsonUpload) || isArsBulkBundleLevel && hasArsBulkExportImportPermission);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lE7gc.TopBar), {
                title: `${!hierarchyContext?.title ? "MOSAIC Biometrics" : hierarchyContext.title}${hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report ? tocVersion : ""}${hierarchyContext?.changed ? "*" : ""}`,
                fileEntry: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                            id: "topbar-load-link",
                            as: (0, $4Q81F.Link),
                            to: `${hierarchyContext && hierarchyContext.hierarchy ? (0, $K53Ru.getHierarchyBaseUrl)(hierarchyContext.hierarchy) : "Corporate"}/Load`,
                            children: "Load TLF"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Divider, {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                            id: "hierarchypage-topbar-save-link",
                            disabled: !hierarchyContext?.accessRights?.includes((0, $4lHS7.eAccessRights).MaintainHierarchy),
                            onClick: ()=>save(),
                            children: "Save"
                        }),
                        (hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                            id: "hierarchypage-topbar-download-ars-json",
                            disabled: hierarchyContext.changed,
                            onClick: async ()=>{
                                const response = await (0, $iFBNq.downloadArsReport)(appSettings.backEndUrl, hierarchyContext.id, hierarchyContext.hierarchy.name);
                                if (!response.success) setArsErrorText(response.errorText);
                            },
                            children: "Export ARS document"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Divider, {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                            id: "hierarchypage-topbar-remove-styles",
                            onClick: ()=>{
                                setShowRemoveStylesModal(replacementLevelFromPath);
                            },
                            disabled: !shouldShowRemoveStyles || !hasStylesToRemove,
                            children: "Remove styles"
                        }),
                        (hierarchyContext?.accessRights?.includes((0, $4lHS7.eAccessRights).CreateHierarchy) || appSettings.applicationPermissions.includes((0, $4lHS7.eApplicationPermission).AllowDefineXmlUpload)) && (hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Corporate || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).TA || hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study) && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    onClick: ()=>{
                                        setShowLoadModal(true);
                                    },
                                    children: "Upload XML"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2sTa7.LoadXmlLibraryModal), {
                                    onClose: ()=>{
                                        setShowLoadModal(false);
                                    },
                                    show: showLoadModal
                                })
                            ]
                        }),
                        hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    id: "reportpage-topbar-download-annotations-csv",
                                    disabled: hierarchyContext.changed,
                                    onClick: ()=>{
                                        const dNumber = hierarchyContext?.hierarchyNodes.find((h)=>h.id === hierarchyContext.hierarchy?.parentId)?.dNumber ?? // istanbul ignore next
                                        "Report";
                                        (0, $feOPT.downloadAnnotationsCSV)(`${appSettings?.backEndUrl}Reports/${hierarchyContext.id}/AnnotatedVariables`, `Annotations_${dNumber}_${hierarchyContext.hierarchy.name}.csv`);
                                    },
                                    children: "Download annotations CSV"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    id: "reportpage-topbar-copy-link",
                                    disabled: hierarchyContext.changed,
                                    onClick: ()=>{
                                        setShowCopyModal(true);
                                    },
                                    children: "Copy report"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ftPLN.CopyReportModal), {
                                    onClose: ()=>{
                                        setShowCopyModal(false);
                                    },
                                    show: showCopyModal
                                })
                            ]
                        }),
                        canExportTlfBundle && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    id: "hierarchypage-topbar-export-tlf-bundle",
                                    disabled: hierarchyContext?.changed,
                                    onClick: ()=>setShowExportTlfBundleModal(true),
                                    children: "Export TLF bundle"
                                }),
                                showExportTlfBundleModal && !hierarchyContext?.changed && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8F6kk.ExportTlfBundleModal), {
                                    onClose: ()=>setShowExportTlfBundleModal(false)
                                })
                            ]
                        }),
                        canImportTlfBundle && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5FU7L.default).Item, {
                                    id: "hierarchypage-topbar-import-tlf-bundle",
                                    disabled: hierarchyContext?.changed,
                                    onClick: ()=>setShowImportTlfBundleModal(true),
                                    children: "Import TLF bundle"
                                }),
                                showImportTlfBundleModal && !hierarchyContext?.changed && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $789ri.ImportTlfBundleModal), {
                                    onClose: ()=>setShowImportTlfBundleModal(false)
                                })
                            ]
                        })
                    ]
                })
            }),
            showRemoveStylesModal && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iZi5j.RemoveStylesModal), {
                styleRemovalLevel: showRemoveStylesModal,
                onClose: ()=>{
                    setShowRemoveStylesModal(null);
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aAXCH.PopupAlertModal), {
                id: "hierarchypage-ars-export-error",
                show: arsErrorText !== null,
                title: "ARS export failed",
                message: arsErrorText ?? "",
                preformatted: true,
                onClose: ()=>{
                    setArsErrorText(null);
                }
            })
        ]
    });
};
$19f57799c814fc50$export$10e6861c7889bdb3.displayName = "HierarchyTopBar";

});
parcelRegister("aAXCH", function(module, exports) {

$parcel$export(module.exports, "PopupAlertModal", function () { return $0414397da8f12888$export$b2a56dfff857ab63; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $27W8h = parcelRequire("27W8h");
const $0414397da8f12888$export$b2a56dfff857ab63 = ({ id: id, show: show, title: title, message: message, onClose: onClose, preformatted: preformatted = false })=>{
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        id: id,
        show: show,
        onHide: onClose,
        size: preformatted ? "lg" : undefined,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                children: preformatted ? /*#__PURE__*/ (0, $bR5nk.jsx)("pre", {
                    className: "m-2 p-4 border border-primary rounded bg-primary bg-opacity-50",
                    style: {
                        maxHeight: "600px",
                        overflow: "auto",
                        whiteSpace: "pre-wrap",
                        overflowWrap: "anywhere"
                    },
                    children: message
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    children: message
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Footer, {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                    id: `${id}-close`,
                    name: "close",
                    variant: "secondary",
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        onClose();
                    },
                    children: "Close"
                })
            })
        ]
    });
};
$0414397da8f12888$export$b2a56dfff857ab63.displayName = "PopupAlertModal";

});

parcelRegister("e9fGk", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInLists", function () { return $d78e279d734316a0$export$dc1e6cf611122cea; });

var $57qn6 = parcelRequire("57qn6");
const $d78e279d734316a0$export$dc1e6cf611122cea = (lists)=>{
    return lists.some((list)=>(0, $57qn6.hasStylesInReplacementValues)(list.newTexts));
};

});
parcelRegister("57qn6", function(module, exports) {

$parcel$export(module.exports, "hasStylesInReplacementValues", function () { return $2c0724f496e24130$export$cb2aae72774353a2; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $2c0724f496e24130$export$cb2aae72774353a2 = (newTexts)=>{
    return newTexts.some((newText)=>{
        // Check texts in this level
        const hasStylesInTexts = newText.texts.some((text)=>(0, $bX0x9.hasStylesToRemove)(text, [
                ...(0, $kK73x.STYLES_TO_DELETE),
                ...(0, $kK73x.STYLES_TO_CLEAN)
            ]));
        // Recursively check sublists if they exist
        const hasStylesInSubLists = newText.subLists?.some((subList)=>$2c0724f496e24130$export$cb2aae72774353a2(subList.newTexts)) ?? false;
        return hasStylesInTexts || hasStylesInSubLists;
    });
};

});


parcelRegister("oKzk0", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInSingles", function () { return $c944927ef0ea66e9$export$c08aa94bd65bbf4f; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $c944927ef0ea66e9$export$c08aa94bd65bbf4f = (singles)=>{
    return singles.some((single)=>(0, $bX0x9.hasStylesToRemove)(single.newText, [
            ...(0, $kK73x.STYLES_TO_DELETE),
            ...(0, $kK73x.STYLES_TO_CLEAN)
        ]));
};

});

parcelRegister("iZi5j", function(module, exports) {

$parcel$export(module.exports, "RemoveStylesModal", function () { return $fd45891d2a82bb28$export$cde5a31d43c9ce66; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $4hgF7 = parcelRequire("4hgF7");

var $eR8uH = parcelRequire("eR8uH");

var $aAXCH = parcelRequire("aAXCH");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $0eakK = parcelRequire("0eakK");

var $bJXPZ = parcelRequire("bJXPZ");

var $4swop = parcelRequire("4swop");

var $2Mlm8 = parcelRequire("2Mlm8");

var $3Avah = parcelRequire("3Avah");

var $spJKX = parcelRequire("spJKX");

var $kK73x = parcelRequire("kK73x");

var $b0lGM = parcelRequire("b0lGM");

var $57qn6 = parcelRequire("57qn6");

var $e9fGk = parcelRequire("e9fGk");

var $oKzk0 = parcelRequire("oKzk0");

var $g3gRn = parcelRequire("g3gRn");

var $g8W8h = parcelRequire("g8W8h");

var $ddurQ = parcelRequire("ddurQ");

var $hADJ3 = parcelRequire("hADJ3");
const $fd45891d2a82bb28$export$cde5a31d43c9ce66 = ({ styleRemovalLevel: styleRemovalLevel, onClose: onClose })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: ars } = (0, $4hgF7.useArsContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const [isPending, startTransition] = (0, $spJKX.useTransition)();
    const tlfData = (0, $3Avah.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData : null;
    // TLF-level data (only needed for TlfLevel)
    const externalSinglesForTiFo = styleRemovalLevel === "Tlf" && tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $4swop.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements) : [];
    const externalLists = styleRemovalLevel === "Tlf" && tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $bJXPZ.getExternalLists)(tlfData.primaryHierarchyId, tlfData.primaryHierarchyLevel, tlfData.releaseStatus, hierarchyContext.hierarchy.lists, hierarchyContext.parentTemplates.lists) : [];
    // Collect arrays of external items with styles for detailed warning
    const externalSinglesWithStyles = externalSinglesForTiFo.filter((single)=>single.source !== (0, $0eakK.eSingleSource).tlfItem && (0, $bX0x9.hasStylesToRemove)(single.newText, [
            ...(0, $kK73x.STYLES_TO_DELETE),
            ...(0, $kK73x.STYLES_TO_CLEAN)
        ]));
    const externalListsWithStyles = externalLists.filter((list)=>(0, $57qn6.hasStylesInReplacementValues)(list.newTexts));
    /**
   * Handles closing the RemoveStylesModal.
   * - For TlfContext: dispatches CLOSE_MODAL_WINDOW to close modal via context.
   * - For HierarchyContext: relies on the onClose prop from parent to close modal.
   */ const handleClose = ()=>{
        if (styleRemovalLevel === "Tlf") tlfContext.dispatch({
            operation: (0, $2Mlm8.CLOSE_MODAL_WINDOW),
            calledFrom: "RemoveStylesModal:onClose"
        });
        else onClose?.();
    };
    /**
   * Processes TLF content to remove Optional and Notes styles from titles, footnotes, page by,
   * body content, and singles. Promotes external singles with styles to TLF-level singles.
   */ const handleRemoveStylesFromTlf = ()=>{
        /* istanbul ignore else */ if (tlfData) {
            const styleRemovedData = (0, $hADJ3.removeStylesFromTlf)(tlfData, externalSinglesForTiFo, externalLists);
            // Standards Notes and Programmer Notes are intentionally not processed
            tlfContext.dispatch({
                operation: (0, $2Mlm8.UPDATE_TLF),
                tlfData: styleRemovedData,
                calledFrom: "RemoveStylesModal:RemoveStyles"
            });
        }
    };
    /**
   * Handles style removal for hierarchy-level singles
   */ const handleRemoveStylesFromHierarchySingles = ()=>{
        /* istanbul ignore else */ if (hierarchyContext?.hierarchy) {
            const newSingles = (0, $ddurQ.removeStylesFromSingles)(hierarchyContext.hierarchy.singles);
            hierarchyContext.dispatch({
                operation: (0, $0eakK.UPDATE_HIERARCHY),
                hierarchy: {
                    singles: newSingles
                }
            });
        }
    };
    /**
   * Handles style removal for hierarchy-level lists
   */ const handleRemoveStylesFromHierarchyLists = ()=>{
        /* istanbul ignore else */ if (hierarchyContext?.hierarchy) {
            const newLists = (0, $g8W8h.removeStylesFromExternalLists)(hierarchyContext.hierarchy.lists);
            hierarchyContext.dispatch({
                operation: (0, $0eakK.UPDATE_HIERARCHY),
                hierarchy: {
                    lists: newLists
                }
            });
        }
    };
    /**
   * Main handler that delegates to the appropriate function based on replacement level.
   * Uses startTransition to mark the operation as a non-urgent update, allowing React
   * to keep the UI responsive during potentially long-running style removal operations.
   * The modal will automatically close when the transition completes via requestStatus.
   */ const handleRemoveStyles = ()=>{
        startTransition(()=>{
            switch(styleRemovalLevel){
                case "Tlf":
                    handleRemoveStylesFromTlf();
                    break;
                case "HierarchySingles":
                    handleRemoveStylesFromHierarchySingles();
                    break;
                case "HierarchyLists":
                    handleRemoveStylesFromHierarchyLists();
                    break;
            }
        });
    };
    /**
   * Determines whether styles exist that need to be removed.
   * Uses lazy initialization to calculate only once at mount time,
   * preventing recalculation after styles are removed.
   */ const [hasStylesToRemoveInData] = (0, $spJKX.useState)(()=>styleRemovalLevel === "Tlf" ? (0, $g3gRn.hasStylesToRemoveInTlf)(tlfData, externalSinglesForTiFo, externalLists) : styleRemovalLevel === "HierarchySingles" ? !!hierarchyContext?.hierarchy && (0, $oKzk0.hasStylesToRemoveInSingles)(hierarchyContext.hierarchy.singles) : !!hierarchyContext?.hierarchy && (0, $e9fGk.hasStylesToRemoveInLists)(hierarchyContext.hierarchy.lists));
    /**
   * Generates the appropriate message based on replacement level
   */ const getMessage = ()=>{
        switch(styleRemovalLevel){
            case "Tlf":
                return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                            children: "This will convert Optional (green) to black and remove Notes (blue) from Titles, Page by, Body and Footnotes"
                        }),
                        (externalSinglesWithStyles.length > 0 || externalListsWithStyles.length > 0) && hierarchyContext?.hierarchy && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            className: "fw-bold",
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                    className: "mb-1",
                                    children: "Warning: This will also embed styled replacements into the TLF. It is strongly recommended to remove the styles from the hierarchy replacements before proceeding."
                                }),
                                (0, $b0lGM.getHierarchyLinksDescriptorsForStyledReplacements)({
                                    hierarchy: hierarchyContext.hierarchy,
                                    parentTemplates: hierarchyContext.parentTemplates,
                                    hierarchyNodes: hierarchyContext.hierarchyNodes,
                                    externalSinglesWithStyles: externalSinglesWithStyles,
                                    externalListsWithStyles: externalListsWithStyles
                                }).map((desc, idx)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $bR5nk.jsx)("a", {
                                            href: desc.type === "singles" ? `${desc.baseUrl}/Replacements` : `${desc.baseUrl}/Lists`,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: `View ${desc.hierarchyName} ${desc.type}`
                                        })
                                    }, idx))
                            ]
                        })
                    ]
                });
            case "HierarchySingles":
                return /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    children: "This action will convert Optional (green) to black text and remove Notes (blue) text from all single replacements in this hierarchy level."
                });
            case "HierarchyLists":
                return /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    children: "This action will convert Optional (green) to black text and remove Notes (blue) text from all replacement lists in this hierarchy level."
                });
        }
    };
    return !hasStylesToRemoveInData ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aAXCH.PopupAlertModal), {
        id: "no-styles-to-remove-modal",
        show: true,
        title: "No styles to remove",
        message: "There are no Optional (green) or Notes (blue) styles present in this content.",
        onClose: handleClose
    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eR8uH.AreYouSureModal), {
        id: "remove-styles-modal",
        show: true,
        title: "Remove styles",
        message: getMessage(),
        onOk: handleRemoveStyles,
        onClose: handleClose,
        requestStatus: {
            requesting: isPending,
            error: false
        }
    });
};
$fd45891d2a82bb28$export$cde5a31d43c9ce66.displayName = "RemoveStylesModal";

});
parcelRegister("eR8uH", function(module, exports) {

$parcel$export(module.exports, "AreYouSureModal", function () { return $b484ed793e287a85$export$9d984f3cf29e7f51; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $spJKX = parcelRequire("spJKX");

var $27W8h = parcelRequire("27W8h");
const $b484ed793e287a85$export$9d984f3cf29e7f51 = ({ id: id, show: show, title: title = "Are you sure?", message: message, onOk: onOk, onClose: onClose, requestStatus: requestStatus })=>{
    // Track previous requesting state
    const prevRequesting = (0, $spJKX.useRef)(false);
    const requesting = requestStatus?.requesting ?? false;
    /**
   * Closes the modal automatically when the async request completes.
   * Detects when requestStatus transitions from requesting=true to requesting=false,
   * and calls onClose to close the modal. This ensures the spinner is visible during
   * the async operation and the modal closes only after completion.
   *
   * @param requesting - Current request status (true if async operation is in progress)
   * @param onClose - Callback to close the modal
   */ (0, $spJKX.useEffect)(()=>{
        // If previously requesting and now not requesting, close modal
        if (prevRequesting.current && !requesting) onClose?.();
        prevRequesting.current = requesting;
    }, [
        requesting,
        onClose
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        id: id,
        show: show,
        onHide: onClose,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                children: typeof message === "string" ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                    children: message
                }) : message
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: `${id}-ok`,
                        variant: "primary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onOk();
                        },
                        requestStatus: requestStatus,
                        children: "OK"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: `${id}-close`,
                        variant: "secondary",
                        onClick: (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            onClose?.();
                        },
                        children: "Close"
                    })
                ]
            })
        ]
    });
};
$b484ed793e287a85$export$9d984f3cf29e7f51.displayName = "AreYouSureModal";

});

parcelRegister("bJXPZ", function(module, exports) {

$parcel$export(module.exports, "getExternalLists", function () { return $7364a3ff654a89d0$export$61c0246df4799355; });

var $4lHS7 = parcelRequire("4lHS7");
const $7364a3ff654a89d0$export$61c0246df4799355 = (primaryHierarchyId, primaryHierarchyLevel, releaseStatus, lists, parentLists)=>{
    if ([
        (0, $4lHS7.eReleaseStatus).Draft,
        (0, $4lHS7.eReleaseStatus).ReleasePending
    ].includes(releaseStatus) || primaryHierarchyLevel === (0, $4lHS7.eHierarchyLevel).Report) {
        const el = [
            ...parentLists.filter((list)=>!lists.some((l)=>list.givenName === l.givenName)),
            ...lists.map((list)=>({
                    ...list,
                    fromHierarchyId: primaryHierarchyId
                }))
        ];
        return el;
    } else return [];
};

});

parcelRegister("4swop", function(module, exports) {

$parcel$export(module.exports, "getExternalSingles", function () { return $ee2ac878f033b9a2$export$7ad85b6a62430903; });

var $bX0x9 = parcelRequire("bX0x9");

var $0eakK = parcelRequire("0eakK");

var $4lHS7 = parcelRequire("4lHS7");
const $ee2ac878f033b9a2$export$7ad85b6a62430903 = (tocNumber = "", analysisSetLabel = "", releaseStatus = (0, $4lHS7.eReleaseStatus).Draft, domain = "", tlfSingles = [], level = (0, $4lHS7.eHierarchyLevel).Corporate, hierarchySingles = [], domainReplacements = [], parentSingles = [], parentDomainReplacements = [])=>{
    const es = [
        // Add ToC replacement for reports
        ...level === (0, $4lHS7.eHierarchyLevel).Report && tocNumber ? [
            {
                airid: "toc",
                oldText: "!!toc!!",
                newText: (0, $bX0x9.stringToV3)(tocNumber),
                source: (0, $0eakK.eSingleSource).tlfItem
            }
        ] : [],
        // Add analysis set label replacement for reports
        ...level === (0, $4lHS7.eHierarchyLevel).Report && analysisSetLabel ? [
            {
                airid: "analysisSetLabel",
                oldText: "[[Analysis set]]",
                newText: (0, $bX0x9.stringToV3)(analysisSetLabel),
                source: (0, $0eakK.eSingleSource).tlfItem
            }
        ] : [],
        // Add TLF-specific singles
        ...tlfSingles,
        // Add domain replacements for draft templates (release pending should have had them applied)
        ...level !== (0, $4lHS7.eHierarchyLevel).Report && [
            (0, $4lHS7.eReleaseStatus).Draft
        ].includes(releaseStatus) ? [
            ...domainReplacements.filter((dr)=>dr.domain === domain).map((dr)=>({
                    airid: dr.airid,
                    oldText: dr.oldText,
                    newText: dr.newText,
                    source: (0, $0eakK.eSingleSource).domain
                })),
            ...parentDomainReplacements.filter((dr)=>dr.domain === domain).map((dr)=>({
                    airid: dr.airid,
                    oldText: dr.oldText,
                    newText: dr.newText,
                    source: (0, $0eakK.eSingleSource).domain
                }))
        ] : [],
        // Add normal singles for reports or drafts
        ...level === (0, $4lHS7.eHierarchyLevel).Report || [
            (0, $4lHS7.eReleaseStatus).ReleasePending,
            (0, $4lHS7.eReleaseStatus).Draft
        ].includes(releaseStatus) ? [
            ...hierarchySingles,
            ...parentSingles
        ] : []
    ];
    return es;
};

});

parcelRegister("b0lGM", function(module, exports) {

$parcel$export(module.exports, "getHierarchyLinksDescriptorsForStyledReplacements", function () { return $c3e5b59045f564be$export$19f295ed9ec3a690; });

var $bX0x9 = parcelRequire("bX0x9");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $kK73x = parcelRequire("kK73x");

var $57qn6 = parcelRequire("57qn6");
/**
 * Push a hierarchy replacement link descriptor into `links` when `condition` is true.
 *
 * @param links - Accumulator array for link descriptors
 * @param condition - Whether to push the link
 * @param baseUrl - Base URL for the hierarchy
 * @param hierarchyName - Display name of the hierarchy
 * @param type - 'singles' or 'lists'
 * @param keyPrefix - Prefix used to form React keys
 */ const $c3e5b59045f564be$var$pushLinkIf = (links, condition, baseUrl, hierarchyName, type, keyPrefix)=>{
    if (condition) links.push({
        baseUrl: baseUrl,
        hierarchyName: hierarchyName,
        type: type,
        keyPrefix: keyPrefix
    });
};
const $c3e5b59045f564be$export$19f295ed9ec3a690 = ({ hierarchy: hierarchy, parentTemplates: parentTemplates, hierarchyNodes: hierarchyNodes, externalSinglesWithStyles: externalSinglesWithStyles, externalListsWithStyles: externalListsWithStyles })=>{
    const links = [];
    // Current hierarchy
    const currentHasStyledSingles = hierarchy.singles.some((single)=>(0, $bX0x9.hasStylesToRemove)(single.newText, [
            ...(0, $kK73x.STYLES_TO_DELETE),
            ...(0, $kK73x.STYLES_TO_CLEAN)
        ]));
    const currentHasStyledLists = hierarchy.lists.some((list)=>(0, $57qn6.hasStylesInReplacementValues)(list.newTexts));
    const hasExternalSinglesFromCurrent = externalSinglesWithStyles.some((single)=>single.source === (0, $0eakK.eSingleSource).hierarchy);
    const hasExternalListsFromCurrent = externalListsWithStyles.length > 0;
    const currentBaseUrl = (0, $K53Ru.getHierarchyBaseUrl)(hierarchy);
    $c3e5b59045f564be$var$pushLinkIf(links, currentHasStyledSingles && hasExternalSinglesFromCurrent, currentBaseUrl, hierarchy.name, "singles", "current");
    $c3e5b59045f564be$var$pushLinkIf(links, currentHasStyledLists && hasExternalListsFromCurrent, currentBaseUrl, hierarchy.name, "lists", "current");
    // Parent hierarchy - group by fromHierarchyId to find which parent hierarchies have styled content
    if (hierarchyNodes) {
        // Collect unique hierarchy IDs from parent templates with styles
        const parentHierarchyIds = new Set();
        parentTemplates.singles.forEach((single)=>{
            /* istanbul ignore else */ if ((0, $bX0x9.hasStylesToRemove)(single.newText, [
                ...(0, $kK73x.STYLES_TO_DELETE),
                ...(0, $kK73x.STYLES_TO_CLEAN)
            ])) parentHierarchyIds.add(single.fromHierarchyId);
        });
        parentTemplates.lists.forEach((list)=>{
            /* istanbul ignore else */ if ((0, $57qn6.hasStylesInReplacementValues)(list.newTexts)) parentHierarchyIds.add(list.fromHierarchyId);
        });
        // Generate links for each parent hierarchy with styled content
        parentHierarchyIds.forEach((hierarchyId)=>{
            const parentNode = hierarchyNodes.find((node)=>node.id === hierarchyId);
            if (parentNode) {
                const parentBaseUrl = (0, $K53Ru.getHierarchyBaseUrl)(parentNode);
                $c3e5b59045f564be$var$pushLinkIf(links, parentTemplates.singles.some((s)=>s.fromHierarchyId === hierarchyId && (0, $bX0x9.hasStylesToRemove)(s.newText, [
                        ...(0, $kK73x.STYLES_TO_DELETE),
                        ...(0, $kK73x.STYLES_TO_CLEAN)
                    ])), parentBaseUrl, parentNode.name, "singles", "parent");
                $c3e5b59045f564be$var$pushLinkIf(links, parentTemplates.lists.some((l)=>l.fromHierarchyId === hierarchyId && (0, $57qn6.hasStylesInReplacementValues)(l.newTexts)), parentBaseUrl, parentNode.name, "lists", "parent");
            }
        });
    }
    return links;
};

});

parcelRegister("g3gRn", function(module, exports) {

$parcel$export(module.exports, "hasStylesToRemoveInTlf", function () { return $fab5ed57f98513f8$export$596f2f2ff891a47d; });

var $bX0x9 = parcelRequire("bX0x9");

var $0eakK = parcelRequire("0eakK");

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $kK73x = parcelRequire("kK73x");

var $lBaty = parcelRequire("lBaty");

var $57qn6 = parcelRequire("57qn6");

var $amN20 = parcelRequire("amN20");

var $oKzk0 = parcelRequire("oKzk0");
const $fab5ed57f98513f8$export$596f2f2ff891a47d = (tlfData, externalSinglesForTiFo, externalLists)=>{
    if (!tlfData) return false;
    const stylesToCheck = [
        ...(0, $kK73x.STYLES_TO_DELETE),
        ...(0, $kK73x.STYLES_TO_CLEAN)
    ];
    // Check titles (left, center, right positions)
    if (tlfData.titles.some((line)=>(0, $lBaty.hasStylesInBlockLine)(line))) return true;
    // Check footnotes (left, center, right positions)
    if (tlfData.footnotes.some((line)=>(0, $lBaty.hasStylesInBlockLine)(line))) return true;
    // Check page by
    if ((0, $3Avah.isEditorPageBy)(tlfData.pageBy) && (0, $bX0x9.hasStylesToRemove)(tlfData.pageBy.content, stylesToCheck)) return true;
    if (Array.isArray(tlfData.pageBy) && tlfData.pageBy.some((pageByItem)=>pageByItem.label !== undefined && (0, $bX0x9.hasStylesToRemove)(pageByItem.label, stylesToCheck))) return true;
    // Check body (only for tables and listings)
    if (tlfData.type === (0, $4lHS7.eTlfItemType).table || tlfData.type === (0, $4lHS7.eTlfItemType).listing) {
        if ((0, $amN20.hasStylesInTableData)(tlfData.body)) return true;
    }
    // Check TLF singles
    if ((0, $oKzk0.hasStylesToRemoveInSingles)(tlfData.singles)) return true;
    // Check if any external singles would be promoted (have styles and not already in TLF singles)
    const hasExternalSinglesToPromote = externalSinglesForTiFo.some((single)=>single.source !== (0, $0eakK.eSingleSource).tlfItem && (0, $bX0x9.hasStylesToRemove)(single.newText, stylesToCheck) && !tlfData.singles.some((tlfSingle)=>tlfSingle.oldText === single.oldText));
    if (hasExternalSinglesToPromote) return true;
    // Check if any external lists have styles that would be merged into table replacements
    // This is only relevant for tables/listings which can have replacements in their body
    if (tlfData.type === (0, $4lHS7.eTlfItemType).table || tlfData.type === (0, $4lHS7.eTlfItemType).listing) {
        const hasExternalListsWithStyles = externalLists.some((externalList)=>(0, $57qn6.hasStylesInReplacementValues)(externalList.newTexts));
        if (hasExternalListsWithStyles) return true;
    }
    return false;
};

});
parcelRegister("lBaty", function(module, exports) {

$parcel$export(module.exports, "hasStylesInBlockLine", function () { return $0484a74f069737a2$export$500d193e1775c66d; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $0484a74f069737a2$export$500d193e1775c66d = (line)=>{
    const stylesToCheck = [
        ...(0, $kK73x.STYLES_TO_DELETE),
        ...(0, $kK73x.STYLES_TO_CLEAN)
    ];
    return (0, $bX0x9.hasStylesToRemove)(line.left, stylesToCheck) || (0, $bX0x9.hasStylesToRemove)(line.center, stylesToCheck) || (0, $bX0x9.hasStylesToRemove)(line.right, stylesToCheck);
};

});

parcelRegister("amN20", function(module, exports) {

$parcel$export(module.exports, "hasStylesInTableData", function () { return $fe926511624bb143$export$808e13e471447668; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");

var $h1rf1 = parcelRequire("h1rf1");
const $fe926511624bb143$export$808e13e471447668 = (tableData)=>{
    const stylesToCheck = [
        ...(0, $kK73x.STYLES_TO_DELETE),
        ...(0, $kK73x.STYLES_TO_CLEAN)
    ];
    // Check table comments
    if ((0, $bX0x9.hasStylesToRemove)(tableData.comments, stylesToCheck)) return true;
    // Check header data if it exists
    if (tableData.headerData && (0, $h1rf1.hasStylesInRowGroup)(tableData.headerData)) return true;
    // Check body data row groups
    return tableData.bodyData.some((rowGroup)=>(0, $h1rf1.hasStylesInRowGroup)(rowGroup));
};

});
parcelRegister("h1rf1", function(module, exports) {

$parcel$export(module.exports, "hasStylesInRowGroup", function () { return $6ad43899ce2d5e63$export$cd385cd0e465ec5b; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");

var $57qn6 = parcelRequire("57qn6");

var $43UVF = parcelRequire("43UVF");
const $6ad43899ce2d5e63$export$cd385cd0e465ec5b = (rowGroup)=>{
    const hasStylesInRows = rowGroup.rows.some((row)=>(0, $43UVF.hasStylesInRow)(row));
    const hasStylesInComments = (0, $bX0x9.hasStylesToRemove)(rowGroup.comments, [
        ...(0, $kK73x.STYLES_TO_CLEAN),
        ...(0, $kK73x.STYLES_TO_DELETE)
    ]);
    const hasStylesInReplacements = (rowGroup.replacements ?? []).some((replacement)=>(0, $57qn6.hasStylesInReplacementValues)(replacement.newTexts ?? []));
    return hasStylesInRows || hasStylesInComments || hasStylesInReplacements;
};

});
parcelRegister("43UVF", function(module, exports) {

$parcel$export(module.exports, "hasStylesInRow", function () { return $685cfeb2bfaf3412$export$27f8697e61313413; });

var $7xGWF = parcelRequire("7xGWF");
const $685cfeb2bfaf3412$export$27f8697e61313413 = (row)=>{
    return row.cells.some((cell)=>(0, $7xGWF.hasStylesInCell)(cell));
};

});
parcelRegister("7xGWF", function(module, exports) {

$parcel$export(module.exports, "hasStylesInCell", function () { return $8c3efbd2594710d1$export$299a2dd7a2d92b5e; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $8c3efbd2594710d1$export$299a2dd7a2d92b5e = (cell)=>{
    const stylesToCheck = [
        ...(0, $kK73x.STYLES_TO_DELETE),
        ...(0, $kK73x.STYLES_TO_CLEAN)
    ];
    const hasStylesInText = (0, $bX0x9.hasStylesToRemove)(cell.text, stylesToCheck);
    const hasStylesInComments = (0, $bX0x9.hasStylesToRemove)(cell.comments, stylesToCheck);
    return hasStylesInText || hasStylesInComments;
};

});





parcelRegister("g8W8h", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromExternalLists", function () { return $1cd7ee183cf506b1$export$8224a05f6104d036; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");

var $iczg6 = parcelRequire("iczg6");
const $1cd7ee183cf506b1$export$8224a05f6104d036 = (lists)=>{
    return lists.map((list)=>({
            ...list,
            newTexts: list.newTexts.map((newText)=>({
                    ...newText,
                    texts: newText.texts.map((text)=>(0, $bX0x9.removeStylesFromEditorV3)(text, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))),
                    subLists: (0, $iczg6.removeStylesFromSubLists)(newText.subLists)
                }))
        }));
};

});
parcelRegister("iczg6", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromSubLists", function () { return $87c45b48b9be04dc$export$e19e566c25e266f5; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $87c45b48b9be04dc$export$e19e566c25e266f5 = (subLists)=>{
    if (!subLists) return undefined;
    return subLists.map((subList)=>({
            ...subList,
            newTexts: subList.newTexts.map((newText)=>({
                    ...newText,
                    texts: newText.texts.map((text)=>(0, $bX0x9.removeStylesFromEditorV3)(text, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))),
                    subLists: $87c45b48b9be04dc$export$e19e566c25e266f5(newText.subLists)
                }))
        }));
};

});


parcelRegister("ddurQ", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromSingles", function () { return $1c213ab4ca860717$export$b3a0f36878bc8703; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $1c213ab4ca860717$export$b3a0f36878bc8703 = (singles)=>{
    return singles.map((single)=>({
            ...single,
            newText: (0, $bX0x9.removeStylesFromEditorV3)(single.newText, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
        }));
};

});

parcelRegister("hADJ3", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromTlf", function () { return $0bff9d6a3c8a2483$export$ab8091d94bdbd067; });

var $bX0x9 = parcelRequire("bX0x9");

var $0eakK = parcelRequire("0eakK");

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $kK73x = parcelRequire("kK73x");

var $6Vbb4 = parcelRequire("6Vbb4");

var $ddurQ = parcelRequire("ddurQ");

var $i9Hze = parcelRequire("i9Hze");
const $0bff9d6a3c8a2483$export$ab8091d94bdbd067 = (tlfData, externalSinglesForTiFo, externalLists)=>{
    const newTitles = tlfData.titles.map((line)=>(0, $6Vbb4.removeStylesFromBlockLine)(line));
    const newFootnotes = tlfData.footnotes.map((line)=>(0, $6Vbb4.removeStylesFromBlockLine)(line));
    // Only tables/listings have AitTableData bodies with styled text
    const newBody = tlfData.type === (0, $4lHS7.eTlfItemType).table || tlfData.type === (0, $4lHS7.eTlfItemType).listing ? (0, $i9Hze.removeStylesFromTableData)(tlfData.body, externalLists) : undefined;
    // Promote external singles with styles to TLF-level singles, but only if their oldText is not already present in TLF-level singles (after style removal)
    const externalSinglesWithStylesToPromote = externalSinglesForTiFo.filter((single)=>single.source !== (0, $0eakK.eSingleSource).tlfItem && (0, $bX0x9.hasStylesToRemove)(single.newText, [
            ...(0, $kK73x.STYLES_TO_DELETE),
            ...(0, $kK73x.STYLES_TO_CLEAN)
        ]) && !tlfData.singles.some((tlfSingle)=>tlfSingle.oldText === single.oldText)).map((single)=>({
            ...single,
            source: (0, $0eakK.eSingleSource).tlfItem
        }));
    const newSingles = (0, $ddurQ.removeStylesFromSingles)([
        ...tlfData.singles,
        ...externalSinglesWithStylesToPromote
    ]);
    if ((0, $3Avah.isEditorPageBy)(tlfData.pageBy)) {
        const newTlfData = {
            titles: newTitles,
            footnotes: newFootnotes,
            pageBy: {
                ...tlfData.pageBy,
                content: (0, $bX0x9.removeStylesFromEditorV3)(tlfData.pageBy.content, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
            },
            singles: newSingles
        };
        if (newBody !== undefined) newTlfData.body = newBody;
        return newTlfData;
    }
    const newTlfData = {
        titles: newTitles,
        footnotes: newFootnotes,
        pageBy: tlfData.pageBy.map((pageByItem)=>({
                ...pageByItem,
                label: pageByItem.label === undefined ? undefined : (0, $bX0x9.removeStylesFromEditorV3)(pageByItem.label, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
            })),
        singles: newSingles
    };
    return newTlfData;
};

});
parcelRegister("6Vbb4", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromBlockLine", function () { return $a0edba5e3659d806$export$19140abdbd9cddc1; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $a0edba5e3659d806$export$19140abdbd9cddc1 = (line)=>{
    return {
        ...line,
        left: (0, $bX0x9.removeStylesFromEditorV3)(line.left, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN)),
        center: (0, $bX0x9.removeStylesFromEditorV3)(line.center, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN)),
        right: (0, $bX0x9.removeStylesFromEditorV3)(line.right, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
    };
};

});

parcelRegister("i9Hze", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromTableData", function () { return $9eac0bfdd675567f$export$8805fc971e822318; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");

var $kqNp1 = parcelRequire("kqNp1");
const $9eac0bfdd675567f$export$8805fc971e822318 = (tableData, externalLists)=>{
    return {
        ...tableData,
        headerData: tableData.headerData ? (0, $kqNp1.removeStylesFromRowGroup)(tableData.headerData, externalLists) : tableData.headerData,
        bodyData: tableData.bodyData.map((rowGroup)=>(0, $kqNp1.removeStylesFromRowGroup)(rowGroup, externalLists)),
        comments: (0, $bX0x9.removeStylesFromEditorV3)(tableData.comments, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
    };
};

});
parcelRegister("kqNp1", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromRowGroup", function () { return $9f6d51a4abacd902$export$940ab79ef60d1210; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");

var $in4c9 = parcelRequire("in4c9");

var $1fBFT = parcelRequire("1fBFT");
const $9f6d51a4abacd902$export$940ab79ef60d1210 = (rowGroup, externalLists)=>{
    const { processedReplacements: processedReplacements } = (0, $in4c9.removeStylesFromReplacementLists)(rowGroup.replacements, externalLists);
    return {
        ...rowGroup,
        rows: rowGroup.rows.map((row)=>(0, $1fBFT.removeStylesFromRow)(row)),
        comments: (0, $bX0x9.removeStylesFromEditorV3)(rowGroup.comments, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN)),
        replacements: processedReplacements
    };
};

});
parcelRegister("in4c9", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromReplacementLists", function () { return $175d3d7a4cd9d7b1$export$578d8c46ae474a37; });

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $vby9F = parcelRequire("vby9F");

var $kK73x = parcelRequire("kK73x");

var $5yPjq = parcelRequire("5yPjq");
const $175d3d7a4cd9d7b1$export$578d8c46ae474a37 = (replacements, externalLists)=>{
    if (!replacements) return {
        processedReplacements: undefined,
        hadStyles: false
    };
    let replacementHadStyles = false;
    const processedReplacements = replacements.map((replacement)=>{
        // Use external list if it has styles, otherwise keep internal replacement
        const mergedReplacement = (0, $5yPjq.shouldMergeExternal)(replacement, externalLists) ? (0, $vby9F.updateExternal)(replacement, externalLists) : replacement;
        // Remove styles from all texts in the replacement and recursively process subLists.
        let hadStylesToRemove = false;
        const processedTexts = mergedReplacement.newTexts.map((newText)=>{
            const processedInnerTexts = newText.texts.map((text)=>{
                if ((0, $bX0x9.hasStylesToRemove)(text, [
                    ...(0, $kK73x.STYLES_TO_DELETE),
                    ...(0, $kK73x.STYLES_TO_CLEAN)
                ])) hadStylesToRemove = true;
                return (0, $bX0x9.removeStylesFromEditorV3)(text, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN));
            });
            // Recursively process subLists if they exist
            const { processedReplacements: processedSubLists, hadStyles: subListsHadStyles } = $175d3d7a4cd9d7b1$export$578d8c46ae474a37(newText.subLists, externalLists);
            // Track if nested subLists had styles
            if (subListsHadStyles) hadStylesToRemove = true;
            return {
                ...newText,
                texts: processedInnerTexts,
                subLists: processedSubLists
            };
        });
        // Track if any replacement in the array had styles
        replacementHadStyles ||= hadStylesToRemove;
        return {
            ...mergedReplacement,
            newTexts: processedTexts,
            externalName: hadStylesToRemove ? undefined : mergedReplacement.externalName
        };
    });
    return {
        processedReplacements: processedReplacements,
        hadStyles: replacementHadStyles
    };
};

});
parcelRegister("5yPjq", function(module, exports) {

$parcel$export(module.exports, "shouldMergeExternal", function () { return $0df5c42f6d060a5b$export$902c8157d2574bb1; });

var $57qn6 = parcelRequire("57qn6");
const $0df5c42f6d060a5b$export$902c8157d2574bb1 = (replacement, externalLists)=>{
    // Find matching external list if this replacement references one
    const externalList = externalLists?.find((ext)=>replacement.externalName && ext.givenName === replacement.externalName);
    // Check if external list contains styles that need removal (recursively checks sublists)
    return externalList ? (0, $57qn6.hasStylesInReplacementValues)(externalList.newTexts) : false;
};

});


parcelRegister("1fBFT", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromRow", function () { return $aab2597cd4a8e37b$export$1861605d95197c30; });

var $7R7KL = parcelRequire("7R7KL");
const $aab2597cd4a8e37b$export$1861605d95197c30 = (row)=>{
    return {
        ...row,
        cells: row.cells.map((cell)=>(0, $7R7KL.removeStylesFromCell)(cell))
    };
};

});
parcelRegister("7R7KL", function(module, exports) {

$parcel$export(module.exports, "removeStylesFromCell", function () { return $deed9116fa3a1ae2$export$dbc6b57b896d5479; });

var $bX0x9 = parcelRequire("bX0x9");

var $kK73x = parcelRequire("kK73x");
const $deed9116fa3a1ae2$export$dbc6b57b896d5479 = (cell)=>{
    return {
        ...cell,
        text: (0, $bX0x9.removeStylesFromEditorV3)(cell.text, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN)),
        comments: (0, $bX0x9.removeStylesFromEditorV3)(cell.comments, (0, $kK73x.STYLES_TO_DELETE), (0, $kK73x.STYLES_TO_CLEAN))
    };
};

});






parcelRegister("ftPLN", function(module, exports) {

$parcel$export(module.exports, "CopyReportModal", function () { return $a701ed3d72e92c90$export$d5c21f22ac41750d; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $5r1Zf = parcelRequire("5r1Zf");

var $iPQyT = parcelRequire("iPQyT");
var $27W8h = parcelRequire("27W8h");

var $cBupR = parcelRequire("cBupR");

var $4LOIa = parcelRequire("4LOIa");

var $c5UXn = parcelRequire("c5UXn");
const $a701ed3d72e92c90$export$d5c21f22ac41750d = ({ show: show, onClose: onCancel })=>{
    /**
   * Handles modal close action.
   */ const cx = ()=>onCancel();
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default), {
        enforceFocus: false,
        fullscreen: "xl-down",
        onHide: cx,
        show: show,
        size: "xl",
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5r1Zf.HierarchyBrowserContextProvider), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                    closeButton: true,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                            children: "Copy report"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cBupR.HierarchyBrowser), {
                                heightPx: 450
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4LOIa.CopyReportModalName), {})
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: "copyreportmodal-cancel",
                            variant: "secondary",
                            onClick: cx,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c5UXn.CopyReportModalOk), {
                            onClick: cx
                        })
                    ]
                })
            ]
        })
    });
};
$a701ed3d72e92c90$export$d5c21f22ac41750d.displayName = "CopyReportModal";

});
parcelRegister("cBupR", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowser", function () { return $7228422f242302f7$export$ef322457c1fb71bb; });

var $bR5nk = parcelRequire("bR5nk");

var $6is3u = parcelRequire("6is3u");


var $5r1Zf = parcelRequire("5r1Zf");

var $5j8Iw = parcelRequire("5j8Iw");

var $llbNs = parcelRequire("llbNs");
const $7228422f242302f7$export$ef322457c1fb71bb = ({ heightPx: heightPx = 400, selectReportVariants: selectReportVariants = false, width: width = "100%" })=>{
    const { state: state, dispatch: dispatch } = (0, $5r1Zf.useHBC)();
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "hierarchy-browser",
        id: `${state?.id}`,
        style: {
            position: "relative",
            minHeight: `${heightPx}px`,
            height: `${heightPx}px`,
            maxHeight: `${heightPx}px`,
            minWidth: width,
            width: width,
            maxWidth: width
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5j8Iw.HierarchyBrowserLhs), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "hb-right",
                id: `${state.id}-right`,
                style: {
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    className: "hb-container",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6is3u.TlfItemTable), {
                        id: `tlfitemtable-${state.currentHierarchyType}`,
                        selectedItems: state.canSelect ? state.selections?.map((s)=>s.id) : undefined,
                        selectReportVariants: selectReportVariants,
                        setSelectedItems: state.canSelect ? (ret)=>{
                            const thisHierarchyIndex = state.hierarchyTlfItemIndex.find((ix)=>ix.hierarchyId === state.currentHierarchy)?.tlfItemIndex;
                            /* istanbul ignore else */ if (thisHierarchyIndex) dispatch({
                                operation: (0, $llbNs.SET_SELECTIONS),
                                selections: ret.map((id)=>thisHierarchyIndex.find((tlf)=>tlf.id === id)).filter((tlf)=>tlf !== undefined).map((tlf)=>({
                                        id: tlf.id,
                                        azsolId: tlf.azsolId,
                                        domain: tlf.domain
                                    }))
                            });
                        } : undefined
                    })
                })
            })
        ]
    });
};
$7228422f242302f7$export$ef322457c1fb71bb.displayName = "HierarchyBrowser";

});
parcelRegister("5j8Iw", function(module, exports) {

$parcel$export(module.exports, "HierarchyBrowserLhs", function () { return $25ec2e6672fc27ef$export$1fdc21900c94165d; });

var $bR5nk = parcelRequire("bR5nk");

var $2AsrT = parcelRequire("2AsrT");

var $spJKX = parcelRequire("spJKX");

var $g6trE = parcelRequire("g6trE");

var $llbNs = parcelRequire("llbNs");
const $25ec2e6672fc27ef$export$1fdc21900c94165d = ()=>{
    const hbc = (0, $spJKX.useContext)((0, $g6trE.HierarchyBrowserContext));
    return hbc && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        id: `${hbc.state.id}-left`,
        className: "hb-left",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                children: "Directory"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "hb-container small-scrollbar",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2AsrT.TreeOfNodes), {
                    id: "hierarchy-tree",
                    roots: [
                        hbc.state.root
                    ],
                    selected: hbc.state.currentHierarchy,
                    nodeList: hbc.state.treeList,
                    canRemoveRoot: false,
                    canAddChildren: false,
                    canRenameRoot: false,
                    canRemoveChildren: false,
                    canRenameChildren: false,
                    nodeHighlight: "rgb(33,35,241)",
                    textHighlight: "rgba(33,35,211,0.1)",
                    handleSelect: (ret)=>{
                        /* istanbul ignore else */ if (!Array.isArray(ret) && typeof ret === "string") hbc.dispatch({
                            operation: (0, $llbNs.SET_CURRENT_HIERARCHY),
                            nodeId: ret
                        });
                    }
                })
            })
        ]
    });
};
$25ec2e6672fc27ef$export$1fdc21900c94165d.displayName = "HierarchyBrowserLhs";

});


parcelRegister("4LOIa", function(module, exports) {

$parcel$export(module.exports, "CopyReportModalName", function () { return $5250ddf9dd0ce59b$export$b24bc63375e601fc; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $lUxHn = parcelRequire("lUxHn");
var $4dL47 = parcelRequire("4dL47");

var $5r1Zf = parcelRequire("5r1Zf");

var $llbNs = parcelRequire("llbNs");

var $05cML = parcelRequire("05cML");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $bHe0S = parcelRequire("bHe0S");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $eZYX7 = parcelRequire("eZYX7");
var $31g00 = parcelRequire("31g00");
const $5250ddf9dd0ce59b$export$b24bc63375e601fc = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: state, dispatch: dispatch } = (0, $5r1Zf.useHBC)();
    const [reportSuffixes, setReportSuffixes] = (0, $spJKX.useState)([]);
    const [requestSuffixes, setRequestSuffixes] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const getReportSuffixesData = (0, $spJKX.useEffectEvent)(async ()=>{
        const response = await (0, $4dL47.loadWrapper)((0, $bHe0S.getReportSuffixes), null, requestSuffixes, setRequestSuffixes, appSettings.backEndUrl);
        if (response?.success) (0, $spJKX.startTransition)(()=>setReportSuffixes(response.data));
    });
    (0, $spJKX.useEffect)(()=>{
        getReportSuffixesData();
    }, []);
    const currentHierarchy = hierarchyContext?.hierarchyNodes.find((h)=>h.id === state?.currentHierarchy);
    const thisHierarchyNewReportInputs = (0, $05cML.newReportInputs)(currentHierarchy?.children.map((r)=>r.name.toLowerCase()) ?? [], appSettings.allowedReportTypes, reportSuffixes);
    const [currentValues, setCurrentValues] = (0, $spJKX.useState)(Object.fromEntries(thisHierarchyNewReportInputs.filter((inp)=>!inp.computeValue).map((inp)=>[
            inp.inputName,
            inp.initialValue ?? ""
        ])));
    const [textValid, setTextValid] = (0, $spJKX.useState)(thisHierarchyNewReportInputs.map((inp)=>{
        const isHidden = typeof inp.hidden === "function" ? inp.hidden(currentValues) : inp.hidden ?? false;
        return !inp.validCondition || isHidden;
    }));
    /**
   * Effect to dispatch when names change
   */ (0, $spJKX.useEffect)(()=>{
        dispatch?.({
            operation: (0, $llbNs.SET_NEW_REPORT_DETAILS),
            newReportName: (currentValues["Name"] ?? "").trim(),
            newReportDescription: (currentValues["Description"] ?? // istanbul ignore next
            "").trim(),
            newReportType: (currentValues["ReportType"] ?? // istanbul ignore next
            "").trim(),
            newReportValid: (currentValues["Name"] ?? // istanbul ignore next
            "").trim() !== "" && (currentValues["Description"] ?? // istanbul ignore next
            "").trim() !== "" && (currentValues["ReportType"] ?? // istanbul ignore next
            "").trim() !== "" && !textValid.some((v)=>v === false)
        });
    }, [
        currentValues,
        dispatch,
        textValid
    ]);
    return !state ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default), {
        className: "mt-3",
        children: state.currentHierarchyType !== (0, $4lHS7.eHierarchy).StudyDirectory ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
            className: "my-1",
            style: {
                height: "55px"
            },
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                className: "d-flex justify-content-center",
                children: "Reports have to be saved to studies"
            })
        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lUxHn.ControlsGroup), {
            baseId: `copy-report-new-name-form`,
            currentValues: currentValues,
            inputs: (0, $05cML.newReportInputs)(currentHierarchy?.children.map((r)=>r.name.toLowerCase()) ?? // istanbul ignore next
            [], appSettings.allowedReportTypes, reportSuffixes),
            setCurrentValues: (vals)=>setCurrentValues(vals),
            setTextValid: setTextValid,
            spellCheck: false
        })
    });
};
$5250ddf9dd0ce59b$export$b24bc63375e601fc.displayName = "CopyReportModalName";

});

parcelRegister("c5UXn", function(module, exports) {

$parcel$export(module.exports, "CopyReportModalOk", function () { return $ec565b6be340d663$export$a217f00d7854ef73; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $5r1Zf = parcelRequire("5r1Zf");

var $3tNrK = parcelRequire("3tNrK");

var $0eakK = parcelRequire("0eakK");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $gHAiV = parcelRequire("gHAiV");

var $spJKX = parcelRequire("spJKX");
const $ec565b6be340d663$export$a217f00d7854ef73 = ({ onClick: onClick })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: state, arRequest: arRequest } = (0, $5r1Zf.useHBC)();
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("copy-report-modal-ok");
    const [copyRequest, setCopyRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    if (!state || !hierarchyContext || !hierarchyContext.hierarchy) return null;
    /**
   * Calls the API to copy the report and handles the response.
   */ const callCopyReport = async ()=>{
        /* istanbul ignore else */ if (state.currentHierarchyType === (0, $4lHS7.eHierarchy).StudyDirectory && state.newReportName) {
            const request = await (0, $4dL47.loadWrapper)((0, $gHAiV.copyReport), {
                reportId: hierarchyContext.hierarchy.id,
                hierarchyId: state.currentHierarchy,
                newReportName: state.newReportName,
                parentTag: hierarchyContext.hierarchyNodes.find((h)=>h.id === state.currentHierarchy)?.parentTag ?? // istanbul ignore next
                "",
                description: state?.newReportDescription ?? "",
                reportType: state?.newReportType ?? ""
            }, copyRequest, setCopyRequest, appSettings.backEndUrl);
            /* istanbul ignore else */ if (request?.success) {
                hierarchyContext.dispatch({
                    operation: (0, $0eakK.ADD_HIERARCHY_NODES),
                    hierarchyNodes: [
                        request.data
                    ]
                });
                navigate(`/R/${request.data.id}`);
                onClick();
            }
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        id: "copyreportmodal-save",
        style: {
            minWidth: "120px",
            minHeight: "32px",
            position: "relative"
        },
        variant: arRequest.error || copyRequest.error ? "danger" : state.currentAccessRights?.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) ? "primary" : "secondary",
        disabled: !state.newReportValid || !state.currentHierarchy || arRequest.error || arRequest.requesting || !state.currentAccessRights || !state.currentAccessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) || copyRequest.requesting || state.currentHierarchyType !== (0, $4lHS7.eHierarchy).StudyDirectory,
        onClick: ()=>{
            callCopyReport();
        },
        title: arRequest.errorText ?? copyRequest.errorText,
        requestStatus: [
            {
                ...arRequest,
                errorText: "Error getting rights"
            },
            {
                ...copyRequest,
                errorText: "Error copying, please refresh the page"
            }
        ],
        pauseCoverText: arRequest.requesting ? "Loading rights..." : "Copying...",
        children: state.currentAccessRights && state.currentAccessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) ? "Copy" : "No write access to this level"
    });
};
$ec565b6be340d663$export$a217f00d7854ef73.displayName = "CopyReportModalOk";

});
parcelRegister("gHAiV", function(module, exports) {

$parcel$export(module.exports, "copyReport", function () { return $3183d65b704122ce$export$2e68418460eeee93; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $3183d65b704122ce$export$2e68418460eeee93 = async (backEndUrl, params, controller)=>{
    const url = `${backEndUrl}Reports/CopyReport/${params.reportId}`;
    const { reportId: _reportId, ...body } = params;
    try {
        const response = await (0, $lCyBC.default).post(url, body, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Copy report failed", error);
    }
};

});



parcelRegister("3degO", function(module, exports) {

$parcel$export(module.exports, "useSave", function () { return $0efda7c9ee9effb3$export$b18f7695cd4e48b5; });

var $h9eE2 = parcelRequire("h9eE2");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $irvto = parcelRequire("irvto");

var $6iYEs = parcelRequire("6iYEs");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $4CKH9 = parcelRequire("4CKH9");

var $2Mlm8 = parcelRequire("2Mlm8");

var $9M7bn = parcelRequire("9M7bn");

var $9pAhZ = parcelRequire("9pAhZ");

var $f2M6x = parcelRequire("f2M6x");

var $4lHS7 = parcelRequire("4lHS7");

var $cHpYl = parcelRequire("cHpYl");

var $laNFL = parcelRequire("laNFL");

var $9dTwm = parcelRequire("9dTwm");

var $hnK3q = parcelRequire("hnK3q");

var $3Avah = parcelRequire("3Avah");

var $6qVHU = parcelRequire("6qVHU");

var $5zQwU = parcelRequire("5zQwU");

var $dzmeu = parcelRequire("dzmeu");

var $6bANQ = parcelRequire("6bANQ");

var $bqgf7 = parcelRequire("bqgf7");

var $i1j9w = parcelRequire("i1j9w");

var $jr7XA = parcelRequire("jr7XA");

var $spJKX = parcelRequire("spJKX");

var $ctrWF = parcelRequire("ctrWF");
/** Labels describing the current TLF Save permission or validation outcome. */ var $0efda7c9ee9effb3$var$SaveLabels = /*#__PURE__*/ function(SaveLabels) {
    SaveLabels["Save"] = "Save";
    SaveLabels["TlfCannotSaveBlDomain"] = "Cannot save with BL domain";
    SaveLabels["TlfCannotSaveCrystalReference"] = "Cannot save with invalid CRYSTAL reference";
    SaveLabels["TlfCannotSaveNew"] = "Use save as for new TLF items";
    SaveLabels["TlfCannotSaveReleased"] = "Use Save As for released TLFs";
    SaveLabels["TlfSaveAndRevert"] = "Save and revert to draft";
    SaveLabels["TlfUpdateTemplate"] = "Update new TLF item template";
    return SaveLabels;
}($0efda7c9ee9effb3$var$SaveLabels || {});
const $0efda7c9ee9effb3$export$b18f7695cd4e48b5 = ()=>{
    const { state: state, dispatch: dispatch } = (0, $spJKX.useContext)((0, $3tNrK.AppSettingsContext));
    const { hierarchyState: hierarchyState, tlfState: tlfState, tocState: tocState, saveRequest: saveRequest, backEndUrl: backEndUrl } = state;
    const hierarchy = hierarchyState.hierarchy;
    const tlf = (0, $3Avah.isTlfItemReadDto)(tlfState.tlfData) ? tlfState.tlfData : null;
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const { navigateAfterSave: navigateAfterSave } = (0, $6iYEs.useUnsavedChanges)("app-save");
    /**
   * Updates the single request status used by every save control.
   *
   * @param status - Request lifecycle information supplied by loadWrapper.
   */ const setSaveRequest = (status)=>dispatch({
            operation: (0, $ctrWF.SET_SAVE_REQUEST),
            saveRequest: status
        });
    /**
   * Saves TOC edits or refreshes the hierarchy version using the shared save request.
   *
   * @param tocItemsToUpdate - Changed TOC entries and an optional deleted item.
   * @returns Sent collaboration metadata for the route's SignalR echo tracking, when sent.
   */ const saveTocItems = async (tocItemsToUpdate)=>{
        let sentMessage;
        if (hierarchy && !saveRequest.requesting) {
            const changeList = tocState.tocItems.filter((item)=>item.changed).map((item)=>item.id);
            const response = await (0, $4dL47.loadWrapper)((0, $bqgf7.updateTocItems), tocItemsToUpdate, {
                ...saveRequest,
                error: false,
                requestedId: undefined
            }, setSaveRequest, backEndUrl);
            if (response?.success) {
                const newHierarchy = {
                    ...hierarchy,
                    tocMajorVersion: response.data.tocMajorVersion,
                    tocMinorVersion: response.data.tocMinorVersion,
                    sections: response.data.sections
                };
                dispatch({
                    operation: (0, $0eakK.UPDATE_HIERARCHY),
                    hierarchy: newHierarchy,
                    isSynchronisation: true
                });
                dispatch({
                    operation: (0, $f2M6x.SAVE_SUCCESS),
                    itemsUpdate: tocItemsToUpdate,
                    saveTimeStamp: Date.now()
                });
                if (signalR) {
                    const signalRUpdate = {
                        hierarchy: newHierarchy,
                        items: [
                            ...response.data.sections.filter((item)=>changeList.includes(item.id)).map((section)=>({
                                    id: section.id,
                                    primaryHierarchyId: newHierarchy.id,
                                    tocNumber: section.sectionNumber,
                                    tocLabel: section.sectionLabel,
                                    type: (0, $4lHS7.eTlfItemType).section,
                                    tocOrder: section.order,
                                    changed: false,
                                    inError: false
                                })),
                            ...response.data.shells.filter((item)=>changeList.includes(item.id)).map((item)=>({
                                    ...item,
                                    changedTitles: item.changedTitles ?? [],
                                    changed: false,
                                    inError: false
                                }))
                        ],
                        deletedItemId: tocItemsToUpdate.deletedItemId
                    };
                    const message = await signalR.sendTocUpdateToGroup(signalRUpdate, `toc${hierarchy.id}`);
                    sentMessage = {
                        messageId: message.messageId,
                        updatedIds: [
                            "sentMessage"
                        ],
                        updateTS: new Date(message.timeStamp)
                    };
                }
            } else {
                if (response === null) setSaveRequest({
                    requesting: false,
                    error: false
                });
                else console.warn("Save failed", response.errorText);
                dispatch({
                    operation: (0, $f2M6x.SAVE_FAIL)
                });
            }
        }
        return sentMessage;
    };
    /**
   * Persists one TLF field while sharing the application save request lifecycle.
   *
   * @param id - Identifier of the TLF to patch.
   * @param azsolId - AZSOL identifier used to locate the TLF.
   * @param key - Persisted TLF field being edited.
   * @param newValue - Replacement value for the selected field.
   */ const patchTlf = async (id, azsolId, key, newValue)=>{
        if (!saveRequest.requesting) {
            const response = await (0, $4dL47.loadWrapper)((0, $5zQwU.patchTlfItem), {
                id: id,
                azsolId: azsolId,
                key: key,
                newValue: newValue
            }, {
                ...saveRequest,
                error: false,
                requestedId: undefined
            }, setSaveRequest, backEndUrl);
            if (response?.success) {
                if (tlfState.tlfData && response.data.id === tlfState.tlfData.id) dispatch({
                    operation: (0, $2Mlm8.UPDATE_TLF),
                    calledFrom: "useSave:PatchResponse",
                    tlfData: response.data,
                    newSavePoint: true
                });
                dispatch({
                    operation: (0, $f2M6x.UPDATE_ENTRY),
                    update: response.data
                });
                await (0, $9pAhZ.sendSignalRPatch)(tlfState.savedTlfData, response.data, signalR, dispatch);
            } else if (response === null) setSaveRequest({
                requesting: false,
                error: false
            });
        }
    };
    /**
   * Saves changed hierarchy data, or TLF data with an optional hierarchy update.
   *
   * @param azsolId - AZSOL identifier when copying the TLF with Save As.
   * @param version - Version assigned to the copied TLF.
   * @param domain - Domain assigned to the copied TLF.
   * @param primaryHierarchyId - Destination hierarchy for Save As.
   * @param additionalInformation - Description assigned to the copied TLF.
   * @param copiedFromHierarchyLevel - Source level recorded for Save As.
   * @param tocNumber - Optional TOC number for the copied TLF.
   * @param sapReference - Optional SAP reference for the copied TLF.
   */ const save = async (azsolId, version, domain, primaryHierarchyId, additionalInformation, copiedFromHierarchyLevel, tocNumber, sapReference)=>{
        const saveAs = azsolId !== undefined;
        if (hierarchy && !saveRequest.requesting && (saveAs || !hierarchy.isBackupVersion) && !(saveAs && hierarchyState.changed)) {
            const submittedHierarchy = (0, $hnK3q.toHierarchyUpdateDto)(hierarchy);
            const submittedPath = window.location.pathname;
            if (tlf && (saveAs || tlfState.changed)) {
                const prepared = (0, $9M7bn.prepareTlfSave)(tlfState, tlf);
                if (prepared) {
                    const isNewTlf = azsolId !== undefined && azsolId !== "" && version !== undefined && additionalInformation !== undefined && primaryHierarchyId !== undefined && primaryHierarchyId !== "";
                    const saveDetailsWithoutHierarchy = {
                        tlfItem: {
                            ...prepared.tlfItem,
                            tocNumber: tocNumber ?? prepared.tlfItem.tocNumber,
                            sapReference: sapReference ?? prepared.tlfItem.sapReference
                        },
                        newDetails: isNewTlf ? {
                            azsolId: azsolId,
                            version: version,
                            domain: domain ?? "",
                            additionalInformation: additionalInformation ?? // istanbul ignore next
                            "",
                            primaryHierarchyId: primaryHierarchyId
                        } : undefined,
                        copiedFromHierarchyLevel: copiedFromHierarchyLevel
                    };
                    const saveDetails = !isNewTlf && hierarchyState.changed ? {
                        ...saveDetailsWithoutHierarchy,
                        hierarchy: submittedHierarchy,
                        expectedHierarchyLastUpdatedAt: hierarchy.lastUpdatedAt
                    } : saveDetailsWithoutHierarchy;
                    const response = await (0, $4dL47.loadWrapper)((0, $6bANQ.saveTlfItem), saveDetails, {
                        ...saveRequest,
                        error: false,
                        requestedId: undefined
                    }, setSaveRequest, backEndUrl);
                    if (response?.success) {
                        dispatch({
                            operation: (0, $ctrWF.SAVE_COMPLETED),
                            result: response.data,
                            isNewTlf: isNewTlf,
                            submittedTlfId: tlf.id,
                            submittedTlf: tlf,
                            submittedHierarchy: submittedHierarchy,
                            submittedVariantView: prepared.variantView
                        });
                        await (0, $9pAhZ.sendSignalRPatch)(tlfState.savedTlfData, response.data.tlfItem, signalR, dispatch);
                        const savedTlf = response.data.tlfItem;
                        const targetHierarchy = response.data.hierarchy ?? hierarchyState.hierarchyNodes.find((item)=>item.id === savedTlf.primaryHierarchyId);
                        const newUrl = targetHierarchy ? (0, $4CKH9.getTlfUrl)(targetHierarchy, savedTlf) : `/TlfDesigner/${savedTlf.azsolId}/${savedTlf.version}`;
                        if (window.location.pathname === submittedPath && newUrl !== submittedPath) navigateAfterSave(newUrl);
                    } else if (response?.errorText?.startsWith("Save conflict:") === true) {
                        // TODO: Handle this some other way
                        const [latestTlf, latestHierarchy] = await Promise.all([
                            (0, $6qVHU.loadTlfItemById)(backEndUrl, {
                                id: tlf.id,
                                azsolId: tlf.azsolId
                            }, new AbortController()),
                            (0, $cHpYl.loadHierarchy)(backEndUrl, {
                                hierarchyId: hierarchy.id
                            }, new AbortController())
                        ]);
                        if (latestTlf.success && latestHierarchy.success) {
                            const savedTlf = (0, $3Avah.isTlfItemReadDto)(tlfState.savedTlfData) ? tlfState.savedTlfData : tlf;
                            const savedHierarchy = hierarchyState.savedHierarchy ?? hierarchy;
                            dispatch({
                                operation: (0, $ctrWF.SAVE_COMPLETED),
                                result: {
                                    tlfItem: latestTlf.data,
                                    hierarchy: latestHierarchy.data
                                },
                                isNewTlf: false,
                                submittedTlfId: tlf.id,
                                submittedTlf: savedTlf,
                                submittedHierarchy: (0, $hnK3q.toHierarchyUpdateDto)(savedHierarchy)
                            });
                        } else setSaveRequest({
                            requesting: false,
                            error: true,
                            errorText: `${response.errorText} Unable to refresh both documents.`
                        });
                    } else if (response === null) setSaveRequest({
                        requesting: false,
                        error: false
                    });
                }
            } else if (hierarchyState.changed) {
                const response = await (0, $4dL47.loadWrapper)((0, $9dTwm.saveHierarchyData), submittedHierarchy, {
                    ...saveRequest,
                    error: false,
                    requestedId: undefined
                }, setSaveRequest, backEndUrl);
                if (response?.success) {
                    dispatch({
                        operation: (0, $ctrWF.SAVE_COMPLETED),
                        result: {
                            hierarchy: response.data
                        },
                        isNewTlf: false,
                        submittedTlfId: tlfState.tlfData?.id,
                        submittedHierarchy: submittedHierarchy
                    });
                    const oldBase = (0, $K53Ru.getHierarchyBaseUrl)(hierarchyState.hierarchyNodes.find((item)=>item.id === hierarchy.id) ?? hierarchy);
                    const newBase = (0, $K53Ru.getHierarchyBaseUrl)(response.data);
                    if (!tlf && window.location.pathname === submittedPath && (oldBase !== newBase || hierarchy.id !== response.data.id)) {
                        const path = decodeURIComponent(window.location.pathname);
                        const subpage = path.startsWith(`${oldBase}/`) ? path.slice(oldBase.length) : "";
                        navigateAfterSave(`${newBase}${subpage}`);
                    }
                } else if (response === null) setSaveRequest({
                    requesting: false,
                    error: false
                });
            }
        }
    };
    /**
   * Restores the selected backup Report using the application save request status.
   */ const restore = async ()=>{
        if (hierarchy?.isBackupVersion && hierarchy.type === (0, $4lHS7.eHierarchy).Report && !saveRequest.requesting) {
            const submittedHierarchy = (0, $hnK3q.toHierarchyUpdateDto)(hierarchy);
            const response = await (0, $4dL47.loadWrapper)((0, $laNFL.restoreBackupReport), submittedHierarchy, {
                ...saveRequest,
                error: false,
                requestedId: undefined
            }, setSaveRequest, backEndUrl);
            if (response?.success) {
                dispatch({
                    operation: (0, $ctrWF.SAVE_COMPLETED),
                    result: {
                        hierarchy: response.data
                    },
                    isNewTlf: false,
                    submittedTlfId: tlfState.tlfData?.id,
                    submittedHierarchy: submittedHierarchy
                });
                if (hierarchy.originHierarchyId && signalR?.connection?.state === (0, $h9eE2.HubConnectionState).Connected) await signalR.sendTocSaveToGroup({
                    oldHierarchyId: hierarchy.originHierarchyId,
                    newHierarchy: response.data
                }, `toc${hierarchy.originHierarchyId}`);
                navigateAfterSave((0, $K53Ru.getHierarchyBaseUrl)(response.data));
            } else if (response === null) setSaveRequest({
                requesting: false,
                error: false
            });
        }
    };
    /**
   * Updates the new-TLF template and reloads the application after success.
   */ const saveTemplate = async ()=>{
        if (tlf && !saveRequest.requesting) {
            const response = await (0, $4dL47.loadWrapper)((0, $dzmeu.SaveNewTlfItem), {
                tlfItem: {
                    ...tlf,
                    domain: ""
                }
            }, {
                ...saveRequest,
                error: false,
                requestedId: undefined
            }, setSaveRequest, backEndUrl);
            if (response?.success) (0, $i1j9w.doReload)();
            else if (response === null) setSaveRequest({
                requesting: false,
                error: false
            });
        }
    };
    const saveBlocked = state.saveBlockers.size > 0;
    const canSaveHierarchy = hierarchyState.accessRights.includes(hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report ? (0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy : (0, $4lHS7.eAccessRights).MaintainHierarchy);
    const warningTexts = Array.from(new Set(Array.from(state.saveBlockers).map((blocker)=>blocker.warningText).filter((text)=>text !== undefined)));
    const title = warningTexts.length > 0 ? [
        "Cannot save while there are validation errors",
        ...warningTexts
    ].join("\n") : !canSaveHierarchy ? "You don't have sufficient permission" : undefined;
    let buttonState = null;
    if (hierarchy && !hierarchy.isBackupVersion) {
        if (!tlf || hierarchyState.changed && (!tlfState.changed || saveBlocked)) buttonState = {
            action: "save",
            label: saveBlocked ? "Fix errors before saving" : `Save ${hierarchy.name}`,
            show: saveBlocked || hierarchyState.changed,
            disabled: saveBlocked || !canSaveHierarchy,
            title: title
        };
        else {
            const canWriteTlf = hierarchyState.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy);
            let label = null;
            if (tlfState.changed) {
                if (tlf.id.startsWith("new") && state.applicationPermissions.includes((0, $4lHS7.eApplicationPermission).UpdateStandardsSettings) && hierarchy.level === (0, $4lHS7.eHierarchyLevel).Corporate) label = "Update new TLF item template";
                else if (tlf.domain === "BL" && hierarchy.level === (0, $4lHS7.eHierarchyLevel).Report) label = "Cannot save with BL domain";
                else if (tlf.id.startsWith("new")) label = "Use save as for new TLF items";
                else if (!(0, $jr7XA.isCrystalReferenceValid)(tlf.crystalReference)) label = "Cannot save with invalid CRYSTAL reference";
                else if (canWriteTlf && (tlf.releaseStatus === (0, $4lHS7.eReleaseStatus).Draft || hierarchy.level === (0, $4lHS7.eHierarchyLevel).Report)) label = "Save";
                else if (canWriteTlf && tlf.releaseStatus === (0, $4lHS7.eReleaseStatus).ReleasePending) label = "Save and revert to draft";
                else if (canWriteTlf) label = "Use Save As for released TLFs";
            }
            if (label !== null) buttonState = {
                action: label === "Update new TLF item template" ? "template" : "save",
                label: label,
                show: true,
                disabled: [
                    "Use save as for new TLF items",
                    "Use Save As for released TLFs",
                    "Cannot save with BL domain",
                    "Cannot save with invalid CRYSTAL reference"
                ].includes(label),
                variant: [
                    "Save and revert to draft",
                    "Update new TLF item template"
                ].includes(label) ? "warning" : label === "Save" ? "primary" : "default"
            };
        }
    }
    return {
        buttonState: buttonState,
        patchTlf: patchTlf,
        save: save,
        restore: restore,
        saveTemplate: saveTemplate,
        saveTocItems: saveTocItems,
        saveRequest: saveRequest
    };
};

});
parcelRegister("9M7bn", function(module, exports) {

$parcel$export(module.exports, "prepareTlfSave", function () { return $d9740f30c1e2797d$export$b799549446ec1f73; });

var $3JMQg = parcelRequire("3JMQg");

var $5Cujf = parcelRequire("5Cujf");

var $6RNmK = parcelRequire("6RNmK");
const $d9740f30c1e2797d$export$b799549446ec1f73 = (state, tlf)=>{
    if (!state.variantCreationView && state.appliedVariantPatches.length === 0) return {
        tlfItem: tlf
    };
    const { currentMaster: currentMaster, master: master } = (0, $6RNmK.getVariantPatchContext)(state);
    if (!currentMaster || !master) return null;
    const patchCatalog = {
        ...currentMaster.allVariantPatches
    };
    const masterToSave = {
        ...master,
        allVariantPatches: patchCatalog,
        variantTemplates: currentMaster.variantTemplates
    };
    if (state.activeVariantPatchName !== null) {
        const base = (0, $3JMQg.applyVariantPatches)(masterToSave, masterToSave, state.appliedVariantPatches.filter((name)=>name !== state.activeVariantPatchName));
        if (!base.success) return null;
        patchCatalog[state.activeVariantPatchName] = (0, $5Cujf.buildVariantPatch)(base.data, currentMaster).patch;
    }
    const currentView = (0, $3JMQg.applyVariantPatches)(masterToSave, masterToSave, state.appliedVariantPatches);
    return currentView.success ? {
        tlfItem: masterToSave,
        variantView: currentView.data
    } : null;
};

});

parcelRegister("9pAhZ", function(module, exports) {

$parcel$export(module.exports, "sendSignalRPatch", function () { return $bdf3ac98ee84799b$export$8a3519c9c899eeab; });

var $h9eE2 = parcelRequire("h9eE2");

var $3ew5o = parcelRequire("3ew5o");

var $2Mlm8 = parcelRequire("2Mlm8");
const $bdf3ac98ee84799b$export$8a3519c9c899eeab = async (lastSave, newTlfData, signalR, dispatch)=>{
    if (lastSave && signalR?.connection?.state === (0, $h9eE2.HubConnectionState).Connected) {
        const allowedKeys = Object.keys(lastSave).filter((key)=>![
                "saved",
                "changed",
                "inError",
                "history"
            ].includes(key));
        const sentMessage = await signalR.sendTlfUpdateToGroup({
            updatedItemId: lastSave.id,
            patch: (0, $3ew5o.createPatch)(Object.fromEntries(allowedKeys.map((key)=>[
                    key,
                    lastSave[key]
                ])), Object.fromEntries(allowedKeys.map((key)=>[
                    key,
                    newTlfData[key]
                ])))
        }, `tlf${lastSave.id}`);
        dispatch({
            operation: (0, $2Mlm8.ADD_RECEIVED_MESSAGE),
            calledFrom: "sendSignalRPatch",
            receivedMessage: sentMessage
        });
    }
};

});

parcelRegister("laNFL", function(module, exports) {

$parcel$export(module.exports, "restoreBackupReport", function () { return $0ac9ab5508f98475$export$e08e6890a7240833; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $0ac9ab5508f98475$export$e08e6890a7240833 = async (backEndUrl, hierarchy)=>{
    const url = new URL(`${backEndUrl}Reports/${hierarchy.id}/RestoreBackupVersion?parentTag=${hierarchy.parentTag}`);
    try {
        const response = await (0, $lCyBC.default).post(url.href);
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Restore Backup report failed", error);
    }
};

});

parcelRegister("6qVHU", function(module, exports) {

$parcel$export(module.exports, "loadTlfItemById", function () { return $b417432b5491e0e5$export$4111f8e599a11b62; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");

var $8Shut = parcelRequire("8Shut");
const $b417432b5491e0e5$export$4111f8e599a11b62 = async (backEndUrl, tlfItemVersion, controller)=>{
    const url = `${backEndUrl}TlfItems/ById/${tlfItemVersion.id}${tlfItemVersion.azsolId ? `/${tlfItemVersion.azsolId}` : ""}`;
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        return {
            success: true,
            data: (0, $8Shut.tlfPreProcess)(response.data)
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Get tlfItem failed", error);
    }
};

});

parcelRegister("5zQwU", function(module, exports) {

$parcel$export(module.exports, "patchTlfItem", function () { return $04549149c0fd4a84$export$94d36c67b5728e69; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $i3pdF = parcelRequire("i3pdF");

var $4xeqQ = parcelRequire("4xeqQ");

var $8Shut = parcelRequire("8Shut");
const $04549149c0fd4a84$export$94d36c67b5728e69 = async (backEndUrl, patchDetails, controller)=>{
    try {
        const patch = {
            op: "replace",
            path: `/${patchDetails.key}`,
            value: patchDetails.newValue
        };
        let url = `${backEndUrl}TlfItems/${patchDetails.id}`;
        if (patchDetails.azsolId && (0, $i3pdF.isValidUriString)(patchDetails.azsolId)) url += `/${patchDetails.azsolId}`;
        const response = await (0, $lCyBC.default).patch(url, [
            patch
        ], {
            headers: {
                "Content-Type": "application/json-patch+json"
            },
            signal: controller.signal
        });
        return {
            success: true,
            data: (0, $8Shut.tlfPreProcess)(response.data)
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Patch TLF item failed", error);
    }
};

});

parcelRegister("dzmeu", function(module, exports) {

$parcel$export(module.exports, "SaveNewTlfItem", function () { return $8cbc7685dfd92e36$export$a4f7f00f32399dda; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");

var $8Shut = parcelRequire("8Shut");
const $8cbc7685dfd92e36$export$a4f7f00f32399dda = async (backEndUrl, saveDetails, controller)=>{
    try {
        const tlfKey = saveDetails.tlfItem.id.charAt(0).toUpperCase() + saveDetails.tlfItem.id.slice(1);
        if (!tlfKey.startsWith("New")) throw new Error("The item was not New");
        const res = await (0, $lCyBC.default).put(`${backEndUrl}Settings/${tlfKey}`, {
            value: JSON.stringify(saveDetails.tlfItem)
        }, controller ? {
            signal: controller.signal
        } : undefined);
        return {
            success: true,
            data: (0, $8Shut.tlfPreProcess)(JSON.parse(res.data.value))
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Save new TLF template failed", error);
    }
};

});

parcelRegister("6bANQ", function(module, exports) {

$parcel$export(module.exports, "saveTlfItem", function () { return $ffaf913e06421b92$export$c617bed2b10fc78d; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");
var $ae9tk = parcelRequire("ae9tk");

var $i3pdF = parcelRequire("i3pdF");

var $4lHS7 = parcelRequire("4lHS7");

var $4xeqQ = parcelRequire("4xeqQ");

var $3Avah = parcelRequire("3Avah");

var $8Shut = parcelRequire("8Shut");
const $ffaf913e06421b92$export$160e1d9267c45e1b = "Save conflict: the TLF item or hierarchy changed on the server. Refreshed data is loaded; review the unsaved draft before saving again.";
const $ffaf913e06421b92$export$c617bed2b10fc78d = async (backEndUrl, saveDetails, controller)=>{
    try {
        const tlfItem = saveDetails.tlfItem;
        const basedOnTlfLookup = {
            id: "",
            azsolId: "",
            version: -1
        };
        // Only ARS masters carry variant data
        const variantDetails = (0, $3Avah.isArsMasterReadDto)(tlfItem) ? {
            allVariantPatches: tlfItem.allVariantPatches,
            variantTemplates: tlfItem.variantTemplates
        } : {};
        if (saveDetails.tlfItem.relationships.some((r)=>r.linkType === (0, $4lHS7.eLinkType).BasedOn)) {
            const basedOnLink = saveDetails.tlfItem.relationships.filter((r)=>r.linkType === (0, $4lHS7.eLinkType).BasedOn)[0];
            basedOnTlfLookup.azsolId = basedOnLink.azsolId;
            basedOnTlfLookup.version = basedOnLink.version;
            basedOnTlfLookup.id = basedOnLink.linkId;
        }
        // Create
        if (saveDetails.newDetails) {
            const newDetails = saveDetails.newDetails;
            // Get template reference
            const newRels = [];
            const copiedFromTlfLookup = {
                id: "",
                azsolId: "",
                version: -1
            };
            copiedFromTlfLookup.id = saveDetails.tlfItem.id;
            copiedFromTlfLookup.azsolId = saveDetails.tlfItem.azsolId;
            copiedFromTlfLookup.version = saveDetails.tlfItem.version;
            const newTlfItem = {
                azsolId: newDetails.azsolId,
                additionalInformation: newDetails.additionalInformation,
                type: tlfItem.type,
                domain: newDetails.domain,
                crystalReference: tlfItem.crystalReference ?? "",
                programName: tlfItem.programName ?? "",
                suffix: tlfItem.suffix ?? "",
                outputName: tlfItem.outputName ?? "",
                outputType: tlfItem.outputType ?? (0, $4lHS7.eTlfOutputType).Rtf,
                sapReference: tlfItem.sapReference,
                standardsNotes: tlfItem.standardsNotes,
                programmerNotes: tlfItem.programmerNotes,
                titles: tlfItem.titles,
                pageBy: tlfItem.pageBy,
                body: tlfItem.body,
                footnotes: tlfItem.footnotes,
                singles: tlfItem.singles,
                primaryHierarchyId: newDetails.primaryHierarchyId,
                relationships: newRels,
                tocOrder: tlfItem.tocOrder,
                tocNumber: tlfItem.tocNumber,
                copiedFromTlfLookup: copiedFromTlfLookup,
                basedOnTlfLookup: basedOnTlfLookup,
                copiedFromHierarchyLevel: saveDetails.copiedFromHierarchyLevel,
                tlfTags: tlfItem.tlfTags?.map((tag)=>({
                        ...tag,
                        tagId: tag.tagId ? tag.tagId : crypto.randomUUID()
                    })),
                analysisSetId: tlfItem.analysisSetId,
                ...variantDetails
            };
            const res = await (0, $lCyBC.default).post(`${backEndUrl}TlfItems`, newTlfItem, {
                signal: controller.signal
            });
            return {
                success: true,
                data: {
                    tlfItem: (0, $8Shut.tlfPreProcess)(res.data)
                }
            };
        } else {
            // Update body depending on type
            const newBody = {
                ...tlfItem.body
            };
            if (tlfItem.type === (0, $4lHS7.eTlfItemType).table || tlfItem.type === (0, $4lHS7.eTlfItemType).listing) {
                newBody.changedColumns = [];
                newBody.changedRowGroups = [];
            }
            const updateTlfItem = {
                additionalInformation: tlfItem.additionalInformation,
                type: tlfItem.type,
                domain: tlfItem.domain,
                crystalReference: tlfItem.crystalReference ?? "",
                coreTrafficLightSwitch: tlfItem.coreTrafficLightSwitch,
                programName: tlfItem.programName ?? "",
                suffix: tlfItem.suffix ?? "",
                outputName: tlfItem.outputName ?? "",
                outputType: tlfItem.outputType ?? (0, $4lHS7.eTlfOutputType).Rtf,
                sapReference: tlfItem.sapReference,
                standardsNotes: tlfItem.standardsNotes,
                programmerNotes: tlfItem.programmerNotes,
                titles: tlfItem.titles,
                pageBy: tlfItem.pageBy,
                body: newBody,
                footnotes: tlfItem.footnotes,
                singles: tlfItem.singles,
                shellMinorVersion: tlfItem.primaryHierarchyType === (0, $4lHS7.eHierarchy).Report && tlfItem.shellMinorVersion !== undefined ? tlfItem.shellMinorVersion + 1 : tlfItem.shellMinorVersion,
                analysisSetId: tlfItem.analysisSetId,
                ...variantDetails
            };
            const update = saveDetails.hierarchy ? {
                tlfItem: updateTlfItem,
                hierarchy: saveDetails.hierarchy,
                expectedTlfItemLastUpdatedAt: tlfItem.lastUpdatedFromHistory,
                expectedHierarchyLastUpdatedAt: saveDetails.expectedHierarchyLastUpdatedAt
            } : {
                tlfItem: updateTlfItem,
                expectedTlfItemLastUpdatedAt: tlfItem.lastUpdatedFromHistory
            };
            const res = await (0, $lCyBC.default).put(`${backEndUrl}TlfItems/${tlfItem.id}${(0, $i3pdF.isValidUriString)(tlfItem.azsolId) ? `/${tlfItem.azsolId}` : ""}`, update, {
                signal: controller.signal
            });
            return {
                success: true,
                data: {
                    tlfItem: (0, $8Shut.tlfPreProcess)(res.data.tlfItem),
                    hierarchy: res.data.hierarchy
                }
            };
        }
    } catch (error) {
        if (error.response?.status === (0, $ae9tk.HttpStatusCode).Conflict) {
            const conflict = {
                success: false,
                errorText: $ffaf913e06421b92$export$160e1d9267c45e1b
            };
            return conflict;
        }
        return (0, $4xeqQ.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("bqgf7", function(module, exports) {

$parcel$export(module.exports, "updateTocItems", function () { return $ffb94652e93309f3$export$5f1ade7139d02a99; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ffb94652e93309f3$export$5f1ade7139d02a99 = async (backEndUrl, tocItemsUpdate, controller)=>{
    let url = `${backEndUrl}Reports/${tocItemsUpdate.hierarchyId}/UpdateTocItems`;
    /* istanbul ignore else */ if (tocItemsUpdate.deletedItemId) url += `?deletedItemId=${tocItemsUpdate.deletedItemId}`;
    try {
        const response = await (0, $lCyBC.default).put(url, tocItemsUpdate.items, {
            signal: controller.signal
        });
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Create new Version failed", error);
    }
};

});

parcelRegister("jr7XA", function(module, exports) {

$parcel$export(module.exports, "isCrystalReferenceValid", function () { return $44d52aa22e48e772$export$fa3a4c478e76b219; });
$parcel$export(module.exports, "validateCrystalTicketNumber", function () { return $44d52aa22e48e772$export$a9574b567263710e; });
const $44d52aa22e48e772$var$CRYSTAL_TICKET_REGEX = /^cr-\d{6}$/i;
const $44d52aa22e48e772$var$CRYSTAL_VALIDATION_ERROR = "Invalid format. Expected: cr-XXXXXX (6 digits), separated by commas";
const $44d52aa22e48e772$export$fa3a4c478e76b219 = (value)=>{
    const normalised = (value ?? "").trim();
    if (normalised === "") return true;
    const tickets = normalised.split(",").map((v)=>v.trim());
    if (tickets.some((t)=>t === "")) return false;
    return tickets.every((t)=>$44d52aa22e48e772$var$CRYSTAL_TICKET_REGEX.test(t));
};
const $44d52aa22e48e772$export$a9574b567263710e = async (_backEndUrl, target)=>{
    const valid = $44d52aa22e48e772$export$fa3a4c478e76b219(target.value);
    return {
        success: true,
        data: {
            valid: valid,
            validationText: valid ? "" : $44d52aa22e48e772$var$CRYSTAL_VALIDATION_ERROR
        }
    };
};

});


parcelRegister("a41A8", function(module, exports) {

$parcel$export(module.exports, "tocVersionString", function () { return $d54c0d10e7c87b85$export$fe862cde0b06443c; });
/**
 * Build a human-readable TOC version string from major/minor numbers.
 *
 * @param tocMajorVersion - Major version number for the TOC.
 * @param tocMinorVersion - Minor version number for the TOC (zero-padded to 4 digits).
 * @param isBackupVersion - When true, append a backup indicator to the string.
 * @returns A formatted version string like `1.0001` or `1.0001 - backup version`.
 */ const $d54c0d10e7c87b85$export$fe862cde0b06443c = (tocMajorVersion = 0, tocMinorVersion = 0, isBackupVersion = false)=>{
    let version = `${tocMajorVersion}.${tocMinorVersion.toString().padStart(4, "0")}`;
    if (isBackupVersion) version += " - backup version";
    return version;
};

});

parcelRegister("feOPT", function(module, exports) {

$parcel$export(module.exports, "downloadAnnotationsCSV", function () { return $fe6c8b9f3e1a2396$export$b6d6d5a2ff359cfd; });

var $9m34G = parcelRequire("9m34G");
const $fe6c8b9f3e1a2396$export$b6d6d5a2ff359cfd = async (url, fileName)=>{
    const response = await (0, $9m34G.downloadFile)({
        url: url,
        fileName: fileName,
        fileType: "text/csv",
        blob: true,
        successMessage: "File successfully downloaded",
        errorMessage: "An error has occurred downloading the file",
        controller: new AbortController()
    });
    return response;
};

});

parcelRegister("iFBNq", function(module, exports) {

$parcel$export(module.exports, "downloadArsReport", function () { return $865df398aaef07ee$export$ee82a6af634d7224; });

var $9m34G = parcelRequire("9m34G");
const $865df398aaef07ee$export$ee82a6af634d7224 = async (backEndUrl, hierarchyId, reportName)=>{
    const fileName = `${reportName}_ars.json`;
    const response = await (0, $9m34G.downloadFile)({
        url: `${backEndUrl}Ars/Hierarchy/${hierarchyId}`,
        fileName: fileName,
        fileType: "application/json",
        blob: false,
        successMessage: "ARS document successfully downloaded",
        errorMessage: "An error has occurred downloading the ARS document",
        controller: new AbortController()
    });
    return response;
};

});

parcelRegister("8F6kk", function(module, exports) {

$parcel$export(module.exports, "ExportTlfBundleModal", function () { return $fbdad13ed9789818$export$60a6ad1bde9f00b7; });

var $bR5nk = parcelRequire("bR5nk");

var $6is3u = parcelRequire("6is3u");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $cdDXi = parcelRequire("cdDXi");

var $ao0mf = parcelRequire("ao0mf");

var $cYIEV = parcelRequire("cYIEV");

var $5l2x3 = parcelRequire("5l2x3");

var $spJKX = parcelRequire("spJKX");

var $kP8DJ = parcelRequire("kP8DJ");
var $c28Y1 = parcelRequire("c28Y1");
var $eZYX7 = parcelRequire("eZYX7");
var $27W8h = parcelRequire("27W8h");
var $5YKF4 = parcelRequire("5YKF4");
var $5dhsh = parcelRequire("5dhsh");
const $fbdad13ed9789818$export$60a6ad1bde9f00b7 = ({ onClose: onClose })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const isStudy = hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Study;
    const [groups, setGroups] = (0, $spJKX.useState)([]);
    const [selectedItemIds, setSelectedItemIds] = (0, $spJKX.useState)([]);
    const [searchText, setSearchText] = (0, $spJKX.useState)("");
    const [includeDescendants, setIncludeDescendants] = (0, $spJKX.useState)(isStudy);
    const [includeComments, setIncludeComments] = (0, $spJKX.useState)(false);
    const [exportOnlyReferencedMetadata, setExportOnlyReferencedMetadata] = (0, $spJKX.useState)(true);
    const [ignoreRetiredAndDecommissioned, setIgnoreRetiredAndDecommissioned] = (0, $spJKX.useState)(true);
    const [includeParentHierarchyArsMetadata, setIncludeParentHierarchyArsMetadata] = (0, $spJKX.useState)(false);
    const [step, setStep] = (0, $spJKX.useState)("select");
    const [loadingItems, setLoadingItems] = (0, $spJKX.useState)(true);
    const [loadingError, setLoadingError] = (0, $spJKX.useState)(null);
    const [exporting, setExporting] = (0, $spJKX.useState)(false);
    const [exportError, setExportError] = (0, $spJKX.useState)(null);
    const [progress, setProgress] = (0, $spJKX.useState)(null);
    const activeController = (0, $spJKX.useRef)(null);
    const loadItems = (0, $spJKX.useCallback)(async (withDescendants)=>{
        if (!hierarchy) {
            setLoadingError("The current hierarchy is unavailable");
            setLoadingItems(false);
            return;
        }
        activeController.current?.abort();
        const controller = new AbortController();
        activeController.current = controller;
        setLoadingItems(true);
        setLoadingError(null);
        setSelectedItemIds([]);
        const sources = [
            {
                id: hierarchy.id,
                name: hierarchy.name,
                parentTag: hierarchy.parentTag
            },
            ...withDescendants && isStudy ? hierarchy.children.filter((child)=>child.level === (0, $4lHS7.eHierarchyLevel).Report).map((child)=>({
                    id: child.id,
                    name: child.name,
                    parentTag: child.parentTag
                })) : []
        ];
        try {
            const loadedSources = await Promise.all(sources.map(async (source)=>({
                    source: source,
                    response: await (0, $cdDXi.loadHierarchyTlfs)(appSettings.backEndUrl, {
                        hierarchyId: source.id,
                        parentTag: source.parentTag
                    }, controller)
                })));
            if (controller.signal.aborted) return;
            const nextGroups = [];
            for (const { source: source, response: response } of loadedSources){
                if (!response.success) {
                    setLoadingError(response.errorText);
                    return;
                }
                nextGroups.push({
                    id: source.id,
                    name: source.name,
                    items: response.data.filter((item)=>item.primaryHierarchyId === source.id)
                });
            }
            const nonEmptyGroups = nextGroups.filter((group)=>group.items.length > 0);
            setGroups(nonEmptyGroups);
            setSelectedItemIds([
                ...new Set(nonEmptyGroups.flatMap((group)=>group.items.map((item)=>item.id)))
            ]);
        } catch (error) {
            if (!controller.signal.aborted) setLoadingError(error instanceof Error ? error.message : "Unable to load TLF items");
        } finally{
            if (!controller.signal.aborted) setLoadingItems(false);
        }
    }, [
        appSettings.backEndUrl,
        hierarchy,
        isStudy
    ]);
    (0, $spJKX.useEffect)(()=>{
        let active = true;
        Promise.resolve().then(()=>{
            /* istanbul ignore else */ // Cleanup invalidates the scheduled load before the modal can use its result.
            if (active) return loadItems(isStudy);
        });
        return ()=>{
            active = false;
            activeController.current?.abort();
        };
    }, [
        isStudy,
        loadItems
    ]);
    const allItems = groups.flatMap((group)=>group.items);
    const allItemIds = [
        ...new Set(allItems.map((item)=>item.id))
    ];
    const availableIds = new Set(allItemIds);
    const selectedIds = [
        ...new Set(selectedItemIds.filter((id)=>availableIds.has(id)))
    ];
    const selectedCount = selectedIds.length;
    const search = searchText.trim().toLowerCase();
    /**
   * Select all available items or clear the current selection.
   *
   * @param selectAll - Whether every available item should be selected
   */ const toggleAllItems = (selectAll)=>{
        setSelectedItemIds(selectAll ? allItemIds : []);
    };
    /**
   * Update the descendant option and reload the matching hierarchy indexes.
   *
   * @param enabled - Whether child Report indexes should be included
   */ const toggleDescendants = (enabled)=>{
        setIncludeDescendants(enabled);
        loadItems(enabled);
    };
    /**
   * Advance to export options when at least one TLF item is selected.
   */ const goToDownload = ()=>{
        /* istanbul ignore else */ if (selectedCount > 0) {
            setExportError(null);
            setStep("download");
        }
    };
    /**
   * Create and download the selected TLF bundle using the current export options.
   *
   * @returns A promise that resolves after the export attempt completes
   */ const startExport = async ()=>{
        /* istanbul ignore else */ if (hierarchy && selectedCount > 0) {
            const controller = new AbortController();
            activeController.current = controller;
            setExporting(true);
            setExportError(null);
            setProgress(null);
            const request = (0, $ao0mf.buildTlfBundleExportRequest)({
                hierarchyId: hierarchy.id,
                items: allItems,
                selectedItemIds: selectedIds,
                includeComments: includeComments,
                includeDescendants: includeDescendants,
                includeParentHierarchyArsMetadata: includeParentHierarchyArsMetadata,
                exportOnlyReferencedMetadata: exportOnlyReferencedMetadata,
                ignoreRetiredAndDecommissioned: ignoreRetiredAndDecommissioned
            });
            try {
                const response = await (0, $cYIEV.exportTlfBundle)(appSettings.backEndUrl, request, controller, setProgress);
                if (response.success) {
                    (0, $5l2x3.saveTlfBundle)(response.data, hierarchy.name);
                    onClose();
                } else setExportError(response.errorText);
            } catch (error) {
                setExportError(error instanceof Error ? error.message : "Unable to export TLF bundle");
            } finally{
                setExporting(false);
                /* istanbul ignore else */ // Export controls stay disabled while this request owns the controller.
                if (activeController.current === controller) activeController.current = null;
            }
        }
    };
    /**
   * Abort the active item load or export request and close the modal.
   */ const cancelWorkflow = ()=>{
        activeController.current?.abort();
        onClose();
    };
    const content = step === "select" ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-grid gap-3",
        style: {
            minWidth: 0
        },
        children: [
            isStudy && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                className: "border rounded-2 p-3",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                        className: "h6 mb-2",
                        children: "Hierarchy scope"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                        className: "text-muted mb-3",
                        children: "Choose whether to include report-level items."
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                        id: "tlf-bundle-include-descendants",
                        type: "checkbox",
                        label: "Include descendant reports",
                        checked: includeDescendants,
                        disabled: loadingItems,
                        onChange: (event)=>toggleDescendants(event.target.checked)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                className: "border rounded-2 p-3",
                style: {
                    minWidth: 0
                },
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-1",
                                        children: "Select TLF items"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                                        className: "text-muted",
                                        "aria-live": "polite",
                                        children: [
                                            selectedCount,
                                            " of ",
                                            allItemIds.length,
                                            " selected"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                className: "d-flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                        variant: "outline-secondary",
                                        size: "sm",
                                        onClick: ()=>toggleAllItems(true),
                                        disabled: loadingItems || selectedCount === allItemIds.length,
                                        children: "Select all"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                        variant: "outline-secondary",
                                        size: "sm",
                                        onClick: ()=>toggleAllItems(false),
                                        disabled: loadingItems || selectedCount === 0,
                                        children: "Deselect all"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                                htmlFor: "tlf-bundle-search",
                                children: "Search by name or AZSOL ID"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                id: "tlf-bundle-search",
                                type: "search",
                                value: searchText,
                                onChange: (event)=>setSearchText(event.target.value)
                            })
                        ]
                    }),
                    loadingItems && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                        animation: "border",
                        "aria-label": "Loading TLF items"
                    }),
                    loadingError && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                        variant: "danger",
                        role: "alert",
                        children: [
                            loadingError,
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                variant: "link",
                                onClick: ()=>void loadItems(includeDescendants),
                                children: "Try again"
                            })
                        ]
                    }),
                    !loadingItems && !loadingError && allItemIds.length === 0 && /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                        className: "mb-0",
                        children: "No TLF items found in this hierarchy."
                    }),
                    !loadingItems && !loadingError && groups.map((group)=>{
                        const groupIds = new Set(group.items.map((item)=>item.id));
                        const groupSelectedCount = group.items.filter((item)=>selectedIds.includes(item.id)).length;
                        const groupSelected = group.items.length > 0 && groupSelectedCount === group.items.length;
                        const groupPartiallySelected = groupSelectedCount > 0 && !groupSelected;
                        const visibleItems = group.items.filter((item)=>[
                                group.name,
                                item.azsolId,
                                item.additionalInformation,
                                item.tocLabel,
                                item.tocNumber
                            ].some((value)=>value?.toLowerCase().includes(search)));
                        return /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                            className: "border-top pt-3 mt-3",
                            children: [
                                !(isStudy && includeDescendants) && /*#__PURE__*/ (0, $bR5nk.jsx)("h4", {
                                    className: "h6 mb-2",
                                    children: group.name
                                }),
                                isStudy && includeDescendants && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                    id: `tlf-bundle-report-${group.id}`,
                                    type: "checkbox",
                                    label: group.name,
                                    checked: groupSelected,
                                    "aria-checked": groupPartiallySelected ? "mixed" : groupSelected,
                                    ref: (input)=>{
                                        if (input) input.indeterminate = groupPartiallySelected;
                                    },
                                    onChange: ()=>{
                                        setSelectedItemIds((current)=>{
                                            const withoutGroup = current.filter((id)=>!groupIds.has(id));
                                            return groupSelected ? withoutGroup : [
                                                ...withoutGroup,
                                                ...groupIds
                                            ];
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                    className: "overflow-auto",
                                    style: {
                                        maxHeight: "28vh",
                                        width: "100%",
                                        maxWidth: "100%",
                                        minWidth: 0
                                    },
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6is3u.TlfItemTable), {
                                        id: `tlf-bundle-items-${group.id}`,
                                        label: isStudy && includeDescendants ? undefined : group.name,
                                        showExport: true,
                                        tableClassName: "tlf-item-table-export",
                                        selectedItems: selectedIds,
                                        setSelectedItems: (updatedIds)=>{
                                            const visibleIds = new Set(visibleItems.map((item)=>item.id));
                                            setSelectedItemIds((current)=>[
                                                    ...current.filter((id)=>!visibleIds.has(id)),
                                                    ...updatedIds.filter((id)=>groupIds.has(id) && visibleIds.has(id))
                                                ]);
                                        },
                                        searchResults: visibleItems,
                                        showSearchResults: true
                                    })
                                })
                            ]
                        }, group.id);
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: "d-grid gap-3",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                className: "border rounded-2 p-3",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                        className: "h6 mb-2",
                        children: "Selection summary"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                        className: "mb-0",
                        children: [
                            selectedCount,
                            " items from",
                            " ",
                            /*#__PURE__*/ (0, $bR5nk.jsx)("strong", {
                                children: hierarchy?.name ?? // istanbul ignore next -- The download step requires a loaded hierarchy.
                                "this hierarchy"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                className: "border rounded-2 p-3",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                        className: "h6 mb-2",
                        children: "Bundle options"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "d-grid gap-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                id: "tlf-bundle-include-comments",
                                type: "checkbox",
                                label: "Include comments",
                                checked: includeComments,
                                onChange: (event)=>setIncludeComments(event.target.checked)
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                id: "tlf-bundle-export-only-referenced-metadata",
                                type: "checkbox",
                                label: "Export only referenced ARS metadata",
                                checked: exportOnlyReferencedMetadata,
                                onChange: (event)=>setExportOnlyReferencedMetadata(event.target.checked)
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                id: "tlf-bundle-ignore-retired-and-decommissioned",
                                type: "checkbox",
                                label: "Ignore retired and decommissioned items",
                                checked: ignoreRetiredAndDecommissioned,
                                onChange: (event)=>setIgnoreRetiredAndDecommissioned(event.target.checked)
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Check, {
                                id: "tlf-bundle-include-parent-hierarchy-ars-metadata",
                                type: "checkbox",
                                label: "Include parent hierarchy ARS metadata",
                                checked: includeParentHierarchyArsMetadata,
                                onChange: (event)=>setIncludeParentHierarchyArsMetadata(event.target.checked)
                            })
                        ]
                    })
                ]
            }),
            exportError && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                variant: "danger",
                role: "alert",
                children: exportError
            }),
            progress && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                className: "border rounded-2 p-3",
                "aria-live": "polite",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                        className: "h6 mb-2",
                        children: "Download progress"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                        children: [
                            "Downloaded ",
                            progress.transferredBytes.toLocaleString(),
                            " of",
                            " ",
                            progress.totalBytes.toLocaleString(),
                            " bytes"
                        ]
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5YKF4.default), {
                        now: progress.totalBytes === 0 ? 0 : progress.transferredBytes / progress.totalBytes * 100,
                        "aria-label": "Export progress"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        show: true,
        size: "xl",
        onHide: cancelWorkflow,
        "aria-labelledby": "tlf-bundle-export-title",
        centered: true,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    id: "tlf-bundle-export-title",
                    children: "Export TLF bundle"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Body, {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h2", {
                        className: "h5",
                        children: step === "select" ? "Select items" : "Download"
                    }),
                    content
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "secondary",
                        onClick: cancelWorkflow,
                        children: "Cancel"
                    }),
                    step === "download" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "secondary",
                        onClick: ()=>setStep("select"),
                        disabled: exporting,
                        children: "Back to item selection"
                    }),
                    step === "select" ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "primary",
                        onClick: goToDownload,
                        disabled: loadingItems || Boolean(loadingError) || selectedCount === 0,
                        children: "Next"
                    }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "primary",
                        onClick: ()=>void startExport(),
                        disabled: exporting || selectedCount === 0,
                        children: exporting ? "Exporting" : "Export TLF bundle"
                    }),
                    exporting && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "outline-danger",
                        onClick: ()=>activeController.current?.abort(),
                        children: "Cancel download"
                    })
                ]
            })
        ]
    });
};
$fbdad13ed9789818$export$60a6ad1bde9f00b7.displayName = "ExportTlfBundleModal";

});
parcelRegister("ao0mf", function(module, exports) {

$parcel$export(module.exports, "buildTlfBundleExportRequest", function () { return $f19789730be7c265$export$2b7c61ddde54ad68; });
const $f19789730be7c265$export$2b7c61ddde54ad68 = ({ hierarchyId: hierarchyId, items: items, selectedItemIds: selectedItemIds, includeComments: includeComments, includeDescendants: includeDescendants, includeParentHierarchyArsMetadata: includeParentHierarchyArsMetadata, exportOnlyReferencedMetadata: exportOnlyReferencedMetadata, ignoreRetiredAndDecommissioned: ignoreRetiredAndDecommissioned })=>{
    const selectedIds = new Set(selectedItemIds);
    const selected = items.filter((item)=>selectedIds.has(item.id));
    const deselected = items.filter((item)=>!selectedIds.has(item.id));
    if (selected.length === items.length) return {
        hierarchyId: hierarchyId,
        mode: "All",
        items: [],
        includeComments: includeComments,
        includeDescendants: includeDescendants,
        includeParentHierarchyArsMetadata: includeParentHierarchyArsMetadata,
        exportOnlyReferencedMetadata: exportOnlyReferencedMetadata,
        ignoreRetiredAndDecommissioned: ignoreRetiredAndDecommissioned
    };
    const useOnly = selected.length <= deselected.length;
    return {
        hierarchyId: hierarchyId,
        mode: useOnly ? "Only" : "AllExcept",
        items: (useOnly ? selected : deselected).map((item)=>item.id),
        includeComments: includeComments,
        includeDescendants: includeDescendants,
        includeParentHierarchyArsMetadata: includeParentHierarchyArsMetadata,
        exportOnlyReferencedMetadata: exportOnlyReferencedMetadata,
        ignoreRetiredAndDecommissioned: ignoreRetiredAndDecommissioned
    };
};

});

parcelRegister("cYIEV", function(module, exports) {

$parcel$export(module.exports, "exportTlfBundle", function () { return $4353693ac320924a$export$d24fbfda2e9ad189; });

var $4Nrhl = parcelRequire("4Nrhl");
const $4353693ac320924a$export$d24fbfda2e9ad189 = async (backEndUrl, request, controller, onProgress)=>{
    const exportResponse = await (0, $4Nrhl.tlfBundleApi).createExport(backEndUrl, request, controller, (transferredBytes, reportedTotalBytes)=>{
        onProgress?.({
            completedChunks: 0,
            totalChunks: 1,
            transferredBytes: transferredBytes,
            totalBytes: reportedTotalBytes
        });
    });
    if (!exportResponse.success) return exportResponse;
    if (controller.signal.aborted) return {
        success: false,
        errorText: "Download TLF bundle failed, request cancelled"
    };
    const bundle = exportResponse.data;
    if (bundle.size === 0) return {
        success: false,
        errorText: "The exported TLF bundle is empty"
    };
    onProgress?.({
        completedChunks: 1,
        totalChunks: 1,
        transferredBytes: bundle.size,
        totalBytes: bundle.size
    });
    return {
        success: true,
        data: bundle
    };
};

});
parcelRegister("4Nrhl", function(module, exports) {

$parcel$export(module.exports, "tlfBundleApi", function () { return $c66d5ad9db4090cf$export$56db36f09073cab1; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");

var $LEzzg = parcelRequire("LEzzg");

var $dTUhh = parcelRequire("dTUhh");
/**
 * Build the route prefix for TLF bundle operations on one hierarchy.
 *
 * @param backEndUrl - Backend base URL
 * @param hierarchyId - Hierarchy identifier to encode into the route
 * @returns TLF bundle route prefix
 */ const $c66d5ad9db4090cf$var$hierarchyUrl = (backEndUrl, hierarchyId)=>`${backEndUrl.replace(/\/+$/, "")}/Hierarchies/${encodeURIComponent(hierarchyId)}/TlfBundle`;
/**
 * Run a response-producing request and normalise Axios failures.
 *
 * @param message - Error prefix returned when the request fails
 * @param request - Axios request that returns response data
 * @returns Standardised success or failure response
 */ const $c66d5ad9db4090cf$var$requestData = async (message, request)=>{
    try {
        const response = await request();
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        if ((0, $lCyBC.default).isAxiosError(error) && error.response?.data instanceof Blob) try {
            const text = await new Response(error.response.data).text();
            let data;
            try {
                data = JSON.parse(text);
            } catch  {
                // Some endpoints return plain-text error details rather than JSON.
                data = text;
            }
            error.response.data = typeof data === "string" ? {
                message: data
            } : data;
        } catch  {
        // Preserve the original error if its response body cannot be read.
        }
        return (0, $4xeqQ.processAxiosError)(message, error);
    }
};
/**
 * Run a no-content request and normalise Axios failures.
 *
 * @param message - Error prefix returned when the request fails
 * @param request - Axios request that has no response body
 * @returns Standardised success or failure response
 */ const $c66d5ad9db4090cf$var$requestBlank = async (message, request)=>{
    try {
        await request();
        return {
            success: true
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)(message, error);
    }
};
/**
 * Create and download a complete compressed TLF bundle file.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and selected items to export
 * @param controller - Request cancellation controller
 * @param onProgress - Optional callback with downloaded and total byte counts
 * @returns Compressed bundle file or a standardised failure
 */ const $c66d5ad9db4090cf$var$createExport = async (backEndUrl, params, controller, onProgress)=>{
    const { hierarchyId: hierarchyId, ...body } = params;
    return $c66d5ad9db4090cf$var$requestData("Create TLF bundle export failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, hierarchyId)}/Export`, body, {
            signal: controller.signal,
            responseType: "blob",
            onDownloadProgress: (event)=>{
                onProgress?.(event.loaded, event.total ?? 0);
            }
        }));
};
/**
 * Download one export chunk with bounded retries for transient failures.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Export and chunk identifiers
 * @param controller - Request cancellation controller
 * @returns Binary chunk data or a standardised failure
 */ const $c66d5ad9db4090cf$var$downloadExportChunk = async (backEndUrl, params, controller)=>{
    const url = `${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Export/${encodeURIComponent(params.exportId)}/Chunk/${params.sequenceNumber}`;
    try {
        const response = await (0, $dTUhh.retryWithBackoff)(()=>(0, $lCyBC.default).get(url, {
                responseType: "arraybuffer",
                signal: controller.signal
            }), controller.signal);
        return {
            success: true,
            data: new Uint8Array(response.data)
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Download TLF bundle chunk failed", error);
    }
};
/**
 * Delete a prepared export after its chunks have been consumed.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and export identifiers
 * @param controller - Request cancellation controller
 * @returns Standardised deletion result
 */ const $c66d5ad9db4090cf$var$deleteExport = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestBlank("Delete TLF bundle export failed", ()=>(0, $lCyBC.default).delete(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Export/${encodeURIComponent(params.exportId)}`, {
            signal: controller.signal
        }));
/**
 * Upload one compressed bundle chunk and report its request progress.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Upload metadata and chunk bytes
 * @param controller - Request cancellation controller
 * @param onProgress - Optional request progress callback
 * @returns Standardised upload result
 */ const $c66d5ad9db4090cf$var$uploadChunk = async (backEndUrl, params, controller, onProgress)=>{
    if (params.chunk.size > (0, $LEzzg.TLF_BUNDLE_CHUNK_SIZE_BYTES)) return {
        success: false,
        errorText: "TLF bundle chunks must not exceed 2 MB"
    };
    const formData = new FormData();
    formData.append("uploadId", params.uploadId);
    formData.append("sequenceNumber", params.sequenceNumber.toString());
    formData.append("totalChunks", params.totalChunks.toString());
    formData.append("chunk", params.chunk, `chunk_${params.sequenceNumber}.tlfbundle.gz`);
    const config = {
        signal: controller.signal,
        ...onProgress ? {
            onUploadProgress: (event)=>{
                if (event.total) onProgress(Math.round(event.loaded / event.total * 100));
            }
        } : {}
    };
    try {
        await (0, $dTUhh.retryWithBackoff)(()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Upload/Chunk`, formData, config), controller.signal);
        return {
            success: true
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Upload TLF bundle chunk failed", error);
    }
};
/**
 * Finalise a chunked bundle upload and receive its content metadata.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Upload identifiers, byte count, and digest
 * @param controller - Request cancellation controller
 * @returns Completed upload metadata or a standardised failure
 */ const $c66d5ad9db4090cf$var$completeUpload = async (backEndUrl, params, controller)=>{
    const { hierarchyId: hierarchyId, ...body } = params;
    return $c66d5ad9db4090cf$var$requestData("Complete TLF bundle upload failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, hierarchyId)}/Upload/Complete`, body, {
            signal: controller.signal
        }));
};
/**
 * Analyse an uploaded bundle against the target hierarchy.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and upload identifiers
 * @param controller - Request cancellation controller
 * @returns Bundle analysis summary or a standardised failure
 */ const $c66d5ad9db4090cf$var$analyzeUpload = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestData("Analyse TLF bundle failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Analyze`, {
            uploadId: params.uploadId
        }, {
            signal: controller.signal
        }));
/**
 * Load one page of conflicts for an analysis.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy, analysis, and page identifiers
 * @param controller - Request cancellation controller
 * @returns Conflict page or a standardised failure
 */ const $c66d5ad9db4090cf$var$listConflicts = async (backEndUrl, params, controller)=>{
    const query = new URLSearchParams({
        pageNumber: params.pageNumber.toString(),
        pageSize: params.pageSize.toString()
    });
    return $c66d5ad9db4090cf$var$requestData("Load TLF bundle conflicts failed", ()=>(0, $lCyBC.default).get(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Analysis/${encodeURIComponent(params.analysisId)}/Conflicts?${query.toString()}`, {
            signal: controller.signal
        }));
};
/**
 * Load field-level differences for one conflict.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy, analysis, and conflict identifiers
 * @param controller - Request cancellation controller
 * @returns Field differences or a standardised failure
 */ const $c66d5ad9db4090cf$var$getConflictDiff = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestData("Load TLF bundle conflict differences failed", ()=>(0, $lCyBC.default).get(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Analysis/${encodeURIComponent(params.analysisId)}/Conflicts/${encodeURIComponent(params.conflictId)}/Diff`, {
            signal: controller.signal
        }));
/**
 * Start an import using an analysed upload and its conflict resolutions.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy, upload, analysis, and resolution identifiers
 * @param controller - Request cancellation controller
 * @returns Accepted import job identifier or a standardised failure
 */ const $c66d5ad9db4090cf$var$startImport = async (backEndUrl, params, controller)=>{
    const { hierarchyId: hierarchyId, ...body } = params;
    return $c66d5ad9db4090cf$var$requestData("Start TLF bundle import failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, hierarchyId)}/Import`, body, {
            signal: controller.signal
        }));
};
/**
 * Load the current state of a background import job.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and job identifiers
 * @param controller - Request cancellation controller
 * @returns Import job status or a standardised failure
 */ const $c66d5ad9db4090cf$var$getImportStatus = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestData("Load TLF bundle import status failed", ()=>(0, $lCyBC.default).get(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Import/${encodeURIComponent(params.jobId)}`, {
            signal: controller.signal
        }));
/**
 * Cancel a queued or running background import job.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and job identifiers
 * @param controller - Request cancellation controller
 * @returns Standardised cancellation result
 */ const $c66d5ad9db4090cf$var$cancelImport = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestBlank("Cancel TLF bundle import failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Import/${encodeURIComponent(params.jobId)}/Cancel`, undefined, {
            signal: controller.signal
        }));
/**
 * Load a page of item failures for a background import job.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy, job, and paging identifiers
 * @param controller - Request cancellation controller
 * @returns Failure page or a standardised failure
 */ const $c66d5ad9db4090cf$var$listImportFailures = async (backEndUrl, params, controller)=>{
    const query = new URLSearchParams({
        skip: params.skip.toString(),
        take: params.take.toString()
    });
    return $c66d5ad9db4090cf$var$requestData("Load TLF bundle import failures failed", ()=>(0, $lCyBC.default).get(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Import/${encodeURIComponent(params.jobId)}/Failures?${query.toString()}`, {
            signal: controller.signal
        }));
};
/**
 * Retry the failed items from an eligible import job.
 *
 * @param backEndUrl - Backend base URL
 * @param params - Hierarchy and job identifiers
 * @param controller - Request cancellation controller
 * @returns Standardised retry result
 */ const $c66d5ad9db4090cf$var$retryFailedImport = async (backEndUrl, params, controller)=>$c66d5ad9db4090cf$var$requestBlank("Retry failed TLF bundle import items failed", ()=>(0, $lCyBC.default).post(`${$c66d5ad9db4090cf$var$hierarchyUrl(backEndUrl, params.hierarchyId)}/Import/${encodeURIComponent(params.jobId)}/RetryFailed`, undefined, {
            signal: controller.signal
        }));
const $c66d5ad9db4090cf$export$56db36f09073cab1 = {
    analyzeUpload: $c66d5ad9db4090cf$var$analyzeUpload,
    completeUpload: $c66d5ad9db4090cf$var$completeUpload,
    createExport: $c66d5ad9db4090cf$var$createExport,
    deleteExport: $c66d5ad9db4090cf$var$deleteExport,
    downloadExportChunk: $c66d5ad9db4090cf$var$downloadExportChunk,
    getConflictDiff: $c66d5ad9db4090cf$var$getConflictDiff,
    getImportStatus: $c66d5ad9db4090cf$var$getImportStatus,
    listConflicts: $c66d5ad9db4090cf$var$listConflicts,
    listImportFailures: $c66d5ad9db4090cf$var$listImportFailures,
    cancelImport: $c66d5ad9db4090cf$var$cancelImport,
    retryFailedImport: $c66d5ad9db4090cf$var$retryFailedImport,
    startImport: $c66d5ad9db4090cf$var$startImport,
    uploadChunk: $c66d5ad9db4090cf$var$uploadChunk
};

});
parcelRegister("LEzzg", function(module, exports) {

$parcel$export(module.exports, "TLF_BUNDLE_CHUNK_SIZE_BYTES", function () { return $41d9e62316537fe5$export$f2a47539cf8431a2; });
$parcel$export(module.exports, "TLF_BUNDLE_UPLOAD_BATCH_SIZE", function () { return $41d9e62316537fe5$export$b087c7f47b27e782; });
/**
 * Selection strategy accepted by the TLF bundle export endpoint.
 */ const $41d9e62316537fe5$export$f2a47539cf8431a2 = 1500000;
const $41d9e62316537fe5$export$b087c7f47b27e782 = 3;

});

parcelRegister("dTUhh", function(module, exports) {

$parcel$export(module.exports, "retryWithBackoff", function () { return $85fa1b934645e22d$export$8b43f56a596041d0; });

var $ae9tk = parcelRequire("ae9tk");
const $85fa1b934645e22d$export$8b43f56a596041d0 = async (operation, signal, options = {})=>{
    const maxRetries = Math.max(0, Math.min(options.maxRetries ?? 3, 3));
    const baseDelayMs = Math.max(0, options.baseDelayMs ?? 250);
    for(let attempt = 0;; attempt += 1){
        if (signal?.aborted) throw new DOMException("The request was cancelled", "AbortError");
        try {
            return await operation();
        } catch (error) {
            const status = (0, $ae9tk.isAxiosError)(error) ? error.response?.status : undefined;
            const transient = (0, $ae9tk.isAxiosError)(error) && error.code !== "ERR_CANCELED" && (status === undefined || status === 408 || status === 429 || status >= 500 && status < 600);
            if (!transient || attempt >= maxRetries) throw error;
            await new Promise((resolve, reject)=>{
                if (signal?.aborted) {
                    reject(new DOMException("The request was cancelled", "AbortError"));
                    return;
                }
                const timer = setTimeout(()=>{
                    signal?.removeEventListener("abort", abortDelay);
                    resolve();
                }, baseDelayMs * 2 ** attempt);
                /**
         * Reject the active delay when cancellation arrives.
         */ const abortDelay = ()=>{
                    clearTimeout(timer);
                    signal?.removeEventListener("abort", abortDelay);
                    reject(new DOMException("The request was cancelled", "AbortError"));
                };
                signal?.addEventListener("abort", abortDelay, {
                    once: true
                });
            });
        }
    }
};

});



parcelRegister("5l2x3", function(module, exports) {

$parcel$export(module.exports, "saveTlfBundle", function () { return $d4457ffc55e2ec8d$export$1879373ee3542797; });
const $d4457ffc55e2ec8d$var$downloadCounts = new Map();
const $d4457ffc55e2ec8d$export$1879373ee3542797 = (bundle, hierarchyName)=>{
    const safeHierarchyName = hierarchyName.replace(/[\\/:*?"<>|]/g, "_");
    const nameKey = safeHierarchyName.toLowerCase();
    const downloadCount = $d4457ffc55e2ec8d$var$downloadCounts.get(nameKey) ?? 0;
    $d4457ffc55e2ec8d$var$downloadCounts.set(nameKey, downloadCount + 1);
    const duplicateSuffix = downloadCount > 0 ? ` (${downloadCount})` : "";
    const objectUrl = URL.createObjectURL(bundle);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = `${safeHierarchyName}${duplicateSuffix}-tlfbundle.gz`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
};

});

parcelRegister("5YKF4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $45a6c05083b12992$export$2e2bcd8739ae039; });

var $gr2Ty = parcelRequire("gr2Ty");

var $spJKX = parcelRequire("spJKX");

var $dz672 = parcelRequire("dz672");

var $bMrPt = parcelRequire("bMrPt");

var $bR5nk = parcelRequire("bR5nk");
"use client";
const $45a6c05083b12992$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $45a6c05083b12992$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $spJKX.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, $bR5nk.jsx)($45a6c05083b12992$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $spJKX.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $45a6c05083b12992$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $45a6c05083b12992$var$ROUND_PRECISION) / $45a6c05083b12992$var$ROUND_PRECISION;
}
function $45a6c05083b12992$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$45a6c05083b12992$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $45a6c05083b12992$var$ProgressBar = /*#__PURE__*/ $spJKX.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $dz672.useBootstrapPrefix)(props.bsPrefix, 'progress');
    if (isChild) return $45a6c05083b12992$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($gr2Ty)))(className, bsPrefix),
        children: children ? (0, $bMrPt.map)(children, (child)=>/*#__PURE__*/ (0, $spJKX.cloneElement)(child, {
                isChild: true
            })) : $45a6c05083b12992$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$45a6c05083b12992$var$ProgressBar.displayName = 'ProgressBar';
var $45a6c05083b12992$export$2e2bcd8739ae039 = $45a6c05083b12992$var$ProgressBar;

});


parcelRegister("789ri", function(module, exports) {

$parcel$export(module.exports, "ImportTlfBundleModal", function () { return $1c34a1258ae9b888$export$8dc5bb9a42215dc6; });

var $bR5nk = parcelRequire("bR5nk");

var $3tNrK = parcelRequire("3tNrK");

var $irvto = parcelRequire("irvto");

var $6iYEs = parcelRequire("6iYEs");

var $0eakK = parcelRequire("0eakK");

var $f2M6x = parcelRequire("f2M6x");

var $4DmML = parcelRequire("4DmML");

var $4lHS7 = parcelRequire("4lHS7");

var $cdDXi = parcelRequire("cdDXi");

var $4Nrhl = parcelRequire("4Nrhl");

var $5aQkO = parcelRequire("5aQkO");

var $spJKX = parcelRequire("spJKX");

var $kP8DJ = parcelRequire("kP8DJ");
var $c28Y1 = parcelRequire("c28Y1");
var $eZYX7 = parcelRequire("eZYX7");
var $27W8h = parcelRequire("27W8h");
var $5YKF4 = parcelRequire("5YKF4");
var $5dhsh = parcelRequire("5dhsh");

var $4Q81F = parcelRequire("4Q81F");
const $1c34a1258ae9b888$export$8dc5bb9a42215dc6 = ({ onClose: onClose })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const unsavedChanges = (0, $6iYEs.useUnsavedChanges)("tlf-bundle-import-modal");
    const revalidator = (0, $4Q81F.useRevalidator)();
    const routeLoaderData = (0, $4Q81F.useLoaderData)();
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const backEndUrl = appSettings.backEndUrl;
    const dispatch = appSettings.dispatch;
    const tocState = appSettings.tocState;
    const hierarchy = hierarchyContext?.hierarchy;
    const hasUnsavedDraft = unsavedChanges.hasUnsavedChanges || Boolean(hierarchyContext?.changed) || appSettings.tocState.changed || appSettings.tlfState.changed;
    const [file, setFile] = (0, $spJKX.useState)(null);
    const [stage, setStage] = (0, $spJKX.useState)("upload");
    const [uploading, setUploading] = (0, $spJKX.useState)(false);
    const [uploadError, setUploadError] = (0, $spJKX.useState)(null);
    const [progress, setProgress] = (0, $spJKX.useState)(null);
    const [uploadAnalysis, setUploadAnalysis] = (0, $spJKX.useState)(null);
    const [defaultResolutionByKind, setDefaultResolutionByKind] = (0, $spJKX.useState)({});
    const [overrides, setOverrides] = (0, $spJKX.useState)({});
    const [conflictPage, setConflictPage] = (0, $spJKX.useState)(null);
    const [conflictPageNumber, setConflictPageNumber] = (0, $spJKX.useState)(1);
    const [conflictPageLoading, setConflictPageLoading] = (0, $spJKX.useState)(false);
    const [conflictPageError, setConflictPageError] = (0, $spJKX.useState)(null);
    const [conflictSearch, setConflictSearch] = (0, $spJKX.useState)("");
    const [conflictDiffs, setConflictDiffs] = (0, $spJKX.useState)({});
    const [loadingDiffIds, setLoadingDiffIds] = (0, $spJKX.useState)(new Set());
    const [diffErrors, setDiffErrors] = (0, $spJKX.useState)({});
    const [startingImport, setStartingImport] = (0, $spJKX.useState)(false);
    const [jobId, setJobId] = (0, $spJKX.useState)(null);
    const [jobStatus, setJobStatus] = (0, $spJKX.useState)(null);
    const [jobError, setJobError] = (0, $spJKX.useState)(null);
    const [jobPollVersion, setJobPollVersion] = (0, $spJKX.useState)(0);
    const [failurePage, setFailurePage] = (0, $spJKX.useState)(null);
    const [failureSkip, setFailureSkip] = (0, $spJKX.useState)(0);
    const [failureLoading, setFailureLoading] = (0, $spJKX.useState)(false);
    const [contextRefreshError, setContextRefreshError] = (0, $spJKX.useState)(null);
    const importJobIsTerminal = jobStatus !== null && [
        "Cancelled",
        "Completed",
        "CompletedWithFailures",
        "Failed"
    ].includes(jobStatus.status);
    const activeUploadController = (0, $spJKX.useRef)(null);
    const activeConflictController = (0, $spJKX.useRef)(null);
    const activeDiffControllers = (0, $spJKX.useRef)(new Map());
    const activeJobActionController = (0, $spJKX.useRef)(null);
    const activeContextRefreshController = (0, $spJKX.useRef)(null);
    const terminalJobIdRef = (0, $spJKX.useRef)(null);
    const hierarchyBeforeRefreshRef = (0, $spJKX.useRef)(null);
    const mounted = (0, $spJKX.useRef)(true);
    const loadConflictPage = (0, $spJKX.useCallback)(async (analysisId, pageNumber)=>{
        /* istanbul ignore else */ if (hierarchy) {
            activeConflictController.current?.abort();
            const controller = new AbortController();
            activeConflictController.current = controller;
            setConflictPageLoading(true);
            setConflictPageError(null);
            setConflictPageNumber(pageNumber);
            try {
                const response = await (0, $4Nrhl.tlfBundleApi).listConflicts(appSettings.backEndUrl, {
                    hierarchyId: hierarchy.id,
                    analysisId: analysisId,
                    pageNumber: pageNumber,
                    pageSize: 25
                }, controller);
                if (controller.signal.aborted) return;
                if (response.success) {
                    setConflictPage(response.data);
                    setConflictPageNumber(response.data.pageNumber);
                } else setConflictPageError(response.errorText);
            } catch (error) {
                if (!controller.signal.aborted) setConflictPageError(error instanceof Error ? error.message : "Unable to load conflict summaries");
            } finally{
                if (!controller.signal.aborted) {
                    setConflictPageLoading(false);
                    // A replacement request aborts this controller before it can replace the reference.
                    /* istanbul ignore else */ if (activeConflictController.current === controller) activeConflictController.current = null;
                }
            }
        }
    }, [
        appSettings.backEndUrl,
        hierarchy
    ]);
    /**
   * Load field-level differences for a selected conflict.
   *
   * @param conflict - Conflict whose source and target values should be compared
   */ const loadConflictDiff = async (conflict)=>{
        if (!hierarchy || !uploadAnalysis || conflictDiffs[conflict.conflictId]) return;
        const controller = new AbortController();
        activeDiffControllers.current.set(conflict.conflictId, controller);
        setLoadingDiffIds((current)=>new Set(current).add(conflict.conflictId));
        setDiffErrors((current)=>{
            const next = {
                ...current
            };
            delete next[conflict.conflictId];
            return next;
        });
        const response = await (0, $4Nrhl.tlfBundleApi).getConflictDiff(appSettings.backEndUrl, {
            hierarchyId: hierarchy.id,
            analysisId: uploadAnalysis.analysis.analysisId,
            conflictId: conflict.conflictId
        }, controller);
        if (mounted.current && !controller.signal.aborted) {
            if (response.success) setConflictDiffs((current)=>({
                    ...current,
                    [conflict.conflictId]: response.data
                }));
            else setDiffErrors((current)=>({
                    ...current,
                    [conflict.conflictId]: response.errorText
                }));
            setLoadingDiffIds((current)=>{
                const next = new Set(current);
                next.delete(conflict.conflictId);
                return next;
            });
        }
        if (activeDiffControllers.current.get(conflict.conflictId) === controller) activeDiffControllers.current.delete(conflict.conflictId);
    };
    /**
   * Load one page of failures for the current import job.
   *
   * @param currentJobId - Import job whose failed items should be loaded
   * @param skip - Number of failures to skip
   */ const loadImportFailures = (0, $spJKX.useCallback)(async (currentJobId, skip)=>{
        /* istanbul ignore else */ if (hierarchy) {
            const controller = new AbortController();
            setFailureLoading(true);
            const response = await (0, $4Nrhl.tlfBundleApi).listImportFailures(appSettings.backEndUrl, {
                hierarchyId: hierarchy.id,
                jobId: currentJobId,
                skip: skip,
                take: 25
            }, controller);
            if (mounted.current) {
                if (response.success) {
                    setFailurePage(response.data);
                    setFailureSkip(response.data.skip);
                } else setJobError(response.errorText);
                setFailureLoading(false);
            }
        }
    }, [
        appSettings.backEndUrl,
        hierarchy
    ]);
    /**
   * Submit the analysed upload with the selected conflict resolutions.
   */ const startImportJob = async ()=>{
        /* istanbul ignore else */ if (hierarchy && uploadAnalysis && !startingImport && !hasUnsavedDraft) {
            const controller = new AbortController();
            activeJobActionController.current = controller;
            setStartingImport(true);
            setJobError(null);
            const response = await (0, $4Nrhl.tlfBundleApi).startImport(appSettings.backEndUrl, {
                hierarchyId: hierarchy.id,
                uploadId: uploadAnalysis.uploadId,
                analysisId: uploadAnalysis.analysis.analysisId,
                defaultResolutionByKind: defaultResolutionByKind,
                overrides: overrides
            }, controller);
            if (mounted.current) {
                if (response.success) {
                    setJobId(response.data.jobId);
                    setJobStatus(null);
                    setFailurePage(null);
                    setFailureSkip(0);
                    setStage("job");
                    setJobPollVersion((version)=>version + 1);
                } else setJobError(response.errorText);
                setStartingImport(false);
            }
            // The start button is disabled until this request completes.
            /* istanbul ignore else */ if (activeJobActionController.current === controller) activeJobActionController.current = null;
        }
    };
    /**
   * Cancel the active import job on the backend.
   */ const cancelImportJob = async ()=>{
        /* istanbul ignore else */ if (hierarchy && jobId) {
            const controller = new AbortController();
            activeJobActionController.current = controller;
            const response = await (0, $4Nrhl.tlfBundleApi).cancelImport(appSettings.backEndUrl, {
                hierarchyId: hierarchy.id,
                jobId: jobId
            }, controller);
            if (mounted.current) {
                if (response.success) {
                    setJobError(null);
                    setJobPollVersion((version)=>version + 1);
                } else setJobError(response.errorText);
            }
            if (activeJobActionController.current === controller) activeJobActionController.current = null;
        }
    };
    /**
   * Retry failed items from an eligible import job.
   */ const retryFailedItems = async ()=>{
        /* istanbul ignore else */ if (hierarchy && jobId) {
            const controller = new AbortController();
            activeJobActionController.current = controller;
            const response = await (0, $4Nrhl.tlfBundleApi).retryFailedImport(appSettings.backEndUrl, {
                hierarchyId: hierarchy.id,
                jobId: jobId
            }, controller);
            if (mounted.current) {
                if (response.success) {
                    terminalJobIdRef.current = null;
                    setJobError(null);
                    setJobStatus(null);
                    setFailurePage(null);
                    setJobPollVersion((version)=>version + 1);
                } else setJobError(response.errorText);
            }
            if (activeJobActionController.current === controller) activeJobActionController.current = null;
        }
    };
    (0, $spJKX.useEffect)(()=>{
        mounted.current = true;
        const diffControllers = activeDiffControllers.current;
        return ()=>{
            mounted.current = false;
            activeUploadController.current?.abort();
            activeConflictController.current?.abort();
            activeJobActionController.current?.abort();
            activeContextRefreshController.current?.abort();
            diffControllers.forEach((controller)=>controller.abort());
        };
    }, []);
    (0, $spJKX.useEffect)(()=>{
        if (jobId && importJobIsTerminal && terminalJobIdRef.current !== jobId) {
            terminalJobIdRef.current = jobId;
            if (hasUnsavedDraft) // The terminal state is the event that surfaces this required save-before-import warning.
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setContextRefreshError("Context refresh was skipped because local changes are unsaved");
            else {
                hierarchyBeforeRefreshRef.current = hierarchy;
                setContextRefreshError(null);
                revalidator.revalidate();
            }
        }
    }, [
        hasUnsavedDraft,
        hierarchy,
        importJobIsTerminal,
        jobId,
        revalidator
    ]);
    (0, $spJKX.useEffect)(()=>{
        const previousHierarchy = hierarchyBeforeRefreshRef.current;
        const refreshedHierarchy = routeLoaderData.hierarchy;
        if (previousHierarchy && refreshedHierarchy.id === previousHierarchy.id && refreshedHierarchy !== previousHierarchy && revalidator.state === "idle") {
            hierarchyBeforeRefreshRef.current = null;
            const controller = new AbortController();
            activeContextRefreshController.current?.abort();
            activeContextRefreshController.current = controller;
            (0, $cdDXi.loadHierarchyTlfs)(backEndUrl, {
                hierarchyId: refreshedHierarchy.id,
                parentTag: refreshedHierarchy.parentTag
            }, controller).then((response)=>{
                if (mounted.current && !controller.signal.aborted) {
                    if (response.success) dispatch({
                        operation: (0, $0eakK.UPDATE_TLF_ITEM_INDEX),
                        tlfItemIndex: response.data,
                        tocMinorVersion: refreshedHierarchy.tocMinorVersion
                    });
                    else setContextRefreshError(response.errorText);
                    // A replacement controller aborts this request before its callback runs.
                    /* istanbul ignore else */ if (activeContextRefreshController.current === controller) activeContextRefreshController.current = null;
                }
            });
            if (refreshedHierarchy.level === (0, $4lHS7.eHierarchyLevel).Report && !tocState.changed) (0, $4DmML.refreshToc)(tocState.tocRequestStatus, (tocRequestStatus)=>dispatch({
                    operation: (0, $f2M6x.SET_TOC_REQUEST_STATUS),
                    tocRequestStatus: tocRequestStatus
                }), backEndUrl, refreshedHierarchy, dispatch, true);
        }
    }, [
        backEndUrl,
        dispatch,
        tocState.changed,
        tocState.tocRequestStatus,
        revalidator.state,
        routeLoaderData.hierarchy
    ]);
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (jobId && stage === "job" && hierarchy) {
            let active = true;
            let timeout;
            const controller = new AbortController();
            /**
       * Fetch the latest job state and schedule a fallback poll while the job is active.
       */ const loadStatus = async ()=>{
                const response = await (0, $4Nrhl.tlfBundleApi).getImportStatus(appSettings.backEndUrl, {
                    hierarchyId: hierarchy.id,
                    jobId: jobId
                }, controller);
                if (!active || controller.signal.aborted) return;
                if (response.success) {
                    const status = response.data;
                    setJobStatus(status);
                    setJobError(null);
                    const isActive = status.status === "Queued" || status.status === "Running" || status.status === "CancelRequested";
                    if (isActive) timeout = window.setTimeout(()=>void loadStatus(), 2000);
                    else if (status.failed > 0) loadImportFailures(jobId, 0);
                } else {
                    setJobError(response.errorText);
                    timeout = window.setTimeout(()=>void loadStatus(), 5000);
                }
            };
            loadStatus();
            return ()=>{
                active = false;
                controller.abort();
                if (timeout !== undefined) window.clearTimeout(timeout);
            };
        }
    }, [
        appSettings.backEndUrl,
        hierarchy,
        jobId,
        jobPollVersion,
        stage,
        loadImportFailures
    ]);
    const signalRConnection = signalR?.connection;
    const connectToGroup = signalR?.connectToGroup;
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (jobId && signalRConnection) {
            /**
       * Process an incoming progress message if it belongs to this import job.
       *
       * @param serializedMessage - Serialized SignalR group message
       */ const processImportProgress = (serializedMessage)=>{
                let message;
                try {
                    message = JSON.parse(serializedMessage);
                } catch  {
                    return;
                }
                if (message.operation !== "tlfBundleImportProgress" || typeof message.jsonPayload !== "string") return;
                try {
                    const status = JSON.parse(message.jsonPayload);
                    if (status.jobId === jobId) setJobStatus(status);
                } catch  {
                    setJobError("Unable to read live import progress; checking job status instead.");
                }
            };
            signalRConnection.on("SendMessageToGroup", processImportProgress);
            if (appSettings.prid && connectToGroup) connectToGroup(`user-${appSettings.prid}`).catch(()=>undefined);
            return ()=>signalRConnection.off("SendMessageToGroup", processImportProgress);
        }
    }, [
        appSettings.prid,
        connectToGroup,
        jobId,
        signalRConnection
    ]);
    /**
   * Upload the selected file, complete it on the backend, and request analysis.
   */ const uploadAndAnalyse = async ()=>{
        /* istanbul ignore else */ if (file && hierarchy && !uploading) {
            const controller = new AbortController();
            activeUploadController.current = controller;
            setUploading(true);
            setUploadError(null);
            setProgress(null);
            try {
                const response = await (0, $5aQkO.uploadAndAnalyzeTlfBundle)(appSettings.backEndUrl, {
                    hierarchyId: hierarchy.id,
                    file: file
                }, controller, (nextProgress)=>setProgress(nextProgress));
                if (controller.signal.aborted) {
                    if (mounted.current) setUploadError("Upload cancelled");
                    return;
                }
                if (!response.success) {
                    setUploadError(response.errorText);
                    return;
                }
                setUploadAnalysis(response.data);
                setStage("review");
                setUploading(false);
                // The upload action stays disabled until this request returns.
                /* istanbul ignore else */ if (activeUploadController.current === controller) activeUploadController.current = null;
                if (response.data.analysis.conflictCount > 0) loadConflictPage(response.data.analysis.analysisId, 1);
            } catch (error) {
                if (controller.signal.aborted) {
                    if (mounted.current) setUploadError("Upload cancelled");
                } else setUploadError(error instanceof Error ? error.message : "Unable to upload TLF bundle");
            } finally{
                if (mounted.current) setUploading(false);
                if (activeUploadController.current === controller) activeUploadController.current = null;
            }
        }
    };
    /**
   * Return to file selection and discard the current local review state.
   */ const chooseAnotherFile = ()=>{
        activeUploadController.current?.abort();
        activeConflictController.current?.abort();
        activeDiffControllers.current.forEach((controller)=>controller.abort());
        activeDiffControllers.current.clear();
        setDefaultResolutionByKind({});
        setOverrides({});
        setConflictDiffs({});
        setLoadingDiffIds(new Set());
        setDiffErrors({});
        setJobError(null);
        setFile(null);
        setProgress(null);
        setUploadAnalysis(null);
        setConflictPage(null);
        setConflictPageNumber(1);
        setConflictPageError(null);
        setConflictPageLoading(false);
        setConflictSearch("");
        setUploadError(null);
        setStage("upload");
    };
    /**
   * Close the dialog and cancel any active upload or conflict-page request.
   */ const cancelWorkflow = ()=>{
        activeUploadController.current?.abort();
        activeConflictController.current?.abort();
        onClose();
    };
    const filteredConflicts = (conflictPage?.items ?? []).flatMap((item, index)=>{
        let description;
        try {
            description = JSON.stringify(item, null, 2) ?? String(item);
        } catch  {
            description = "Conflict details could not be displayed";
        }
        return description.toLowerCase().includes(conflictSearch.trim().toLowerCase()) ? [
            {
                index: index,
                description: description
            }
        ] : [];
    });
    const progressLabel = {
        compressing: "Compressing bundle",
        uploading: "Uploading bundle",
        completing: "Completing upload",
        analysing: "Analysing bundle"
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        show: true,
        size: "xl",
        centered: true,
        onHide: cancelWorkflow,
        "aria-labelledby": "tlf-bundle-import-title",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    id: "tlf-bundle-import-title",
                    children: "Import TLF bundle"
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Body, {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h2", {
                        className: "h5",
                        children: stage === "upload" ? "Upload bundle" : stage === "review" ? "Review differences" : "Import progress"
                    }),
                    stage === "upload" ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "d-grid gap-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Bundle file"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                        className: "text-muted",
                                        children: "Choose a compressed TLF bundle or a JSON file."
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                                        controlId: "tlf-bundle-import-file",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                                                children: "Select a TLF bundle or JSON file"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                                type: "file",
                                                accept: ".tlfbundle.gz,.gz,.json,application/gzip,application/json",
                                                disabled: uploading,
                                                onChange: (event)=>{
                                                    const input = event.currentTarget;
                                                    /* istanbul ignore else */ // This change handler is attached directly to the file input.
                                                    if (input instanceof HTMLInputElement) setFile(input.files?.[0] ?? null);
                                                    setUploadError(null);
                                                }
                                            })
                                        ]
                                    }),
                                    file && /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                        className: "mt-2",
                                        children: [
                                            file.name,
                                            " (",
                                            file.size.toLocaleString(),
                                            " bytes)"
                                        ]
                                    }),
                                    uploadError && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                                        variant: "danger",
                                        role: "alert",
                                        children: uploadError
                                    })
                                ]
                            }),
                            uploading && progress && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3",
                                "aria-live": "polite",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Upload progress"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                        children: [
                                            progressLabel[progress.stage],
                                            progress.stage === "uploading" && `: ${progress.completedChunks} of ${progress.totalChunks} chunks complete`
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                        children: [
                                            progress.transferredBytes.toLocaleString(),
                                            " of",
                                            " ",
                                            progress.totalBytes.toLocaleString(),
                                            " bytes"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5YKF4.default), {
                                        now: progress.totalBytes === 0 ? 0 : progress.transferredBytes / progress.totalBytes * 100,
                                        "aria-label": "Upload progress"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                                        className: "mt-3",
                                        animation: "border",
                                        "aria-label": "Uploading and analysing bundle"
                                    })
                                ]
                            })
                        ]
                    }) : stage === "review" && uploadAnalysis && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Analysis summary"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                        children: [
                                            hierarchy?.name ?? // istanbul ignore next -- Upload analysis requires a selected target hierarchy.
                                            "The target hierarchy",
                                            " ",
                                            "contains ",
                                            uploadAnalysis.analysis.itemCount.toLocaleString(),
                                            " uploaded items."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("dl", {
                                        className: "d-flex flex-wrap gap-4 mb-0",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                        children: "New"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                        children: uploadAnalysis.analysis.newItemCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                        children: "Identical"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                        children: uploadAnalysis.analysis.identicalItemCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                        children: "Conflicts"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                        children: uploadAnalysis.analysis.conflictCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                        children: "Item conflicts"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                        children: uploadAnalysis.analysis.itemConflictCount
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                        children: "Dependency conflicts"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                        children: uploadAnalysis.analysis.dependencyConflictCount
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            uploadAnalysis.analysis.reportsToCreate.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Reports to create"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                        children: "These source-study reports are not present in the target hierarchy."
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("ul", {
                                        className: "mb-0",
                                        children: uploadAnalysis.analysis.reportsToCreate.map((report, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)("li", {
                                                children: report
                                            }, `${report}-${index}`))
                                    })
                                ]
                            }),
                            uploadAnalysis.analysis.conflictCount === 0 ? /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Conflict review"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                        className: "mb-0",
                                        children: "No conflicts were found."
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3 mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-3",
                                        children: "Conflict review"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                                        className: "mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                                                htmlFor: "tlf-bundle-conflict-search",
                                                children: "Search current conflict page"
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                                id: "tlf-bundle-conflict-search",
                                                type: "search",
                                                value: conflictSearch,
                                                onChange: (event)=>setConflictSearch(event.target.value)
                                            })
                                        ]
                                    }),
                                    conflictPageLoading && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                                        animation: "border",
                                        "aria-label": "Loading conflicts"
                                    }),
                                    conflictPageError && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                                        variant: "danger",
                                        role: "alert",
                                        children: [
                                            conflictPageError,
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                variant: "link",
                                                onClick: ()=>void loadConflictPage(uploadAnalysis.analysis.analysisId, conflictPageNumber),
                                                children: "Try again"
                                            })
                                        ]
                                    }),
                                    conflictPage && !conflictPageLoading && !conflictPageError && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                "aria-live": "polite",
                                                children: [
                                                    "Page ",
                                                    conflictPage.pageNumber,
                                                    " of ",
                                                    conflictPage.totalPages,
                                                    ";",
                                                    " ",
                                                    conflictPage.totalCount,
                                                    " conflicts"
                                                ]
                                            }),
                                            [
                                                ...new Set(conflictPage.items.map((conflict)=>conflict.kind))
                                            ].map((kind)=>{
                                                const example = conflictPage.items.find((conflict)=>conflict.kind === kind);
                                                let defaultExample = "";
                                                /* istanbul ignore else */ // Each kind is derived from these same conflict items.
                                                if (example) defaultExample = ` (${example.defaultResolution})`;
                                                return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                                                    className: "mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Label, {
                                                            htmlFor: `default-resolution-${kind}`,
                                                            children: [
                                                                "Default for ",
                                                                kind
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Select, {
                                                            id: `default-resolution-${kind}`,
                                                            value: defaultResolutionByKind[kind] ?? "",
                                                            onChange: (event)=>setDefaultResolutionByKind((current)=>{
                                                                    const next = {
                                                                        ...current
                                                                    };
                                                                    if (event.target.value) next[kind] = event.target.value;
                                                                    else delete next[kind];
                                                                    return next;
                                                                }),
                                                            children: [
                                                                /*#__PURE__*/ (0, $bR5nk.jsxs)("option", {
                                                                    value: "",
                                                                    children: [
                                                                        "Use each conflict's backend default",
                                                                        defaultExample
                                                                    ]
                                                                }),
                                                                example?.allowedResolutions.map((resolution)=>/*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                                                                        value: resolution,
                                                                        children: resolution
                                                                    }, resolution))
                                                            ]
                                                        })
                                                    ]
                                                }, kind);
                                            }),
                                            filteredConflicts.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                                className: "mb-0",
                                                children: "No conflicts match this search."
                                            }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                                className: "overflow-auto",
                                                style: {
                                                    maxHeight: "42vh"
                                                },
                                                children: filteredConflicts.map(({ index: index })=>{
                                                    const conflict = conflictPage.items[index];
                                                    const diff = conflictDiffs[conflict.conflictId];
                                                    return /*#__PURE__*/ (0, $bR5nk.jsxs)("details", {
                                                        className: "border rounded-2 p-3 mb-2",
                                                        onToggle: (event)=>{
                                                            if (event.currentTarget.open && conflict.hasDiff) loadConflictDiff(conflict);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("summary", {
                                                                children: [
                                                                    "Conflict",
                                                                    " ",
                                                                    (conflictPage.pageNumber - 1) * conflictPage.pageSize + index + 1,
                                                                    ": ",
                                                                    conflict.kind
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                children: [
                                                                    "Conflict ID: ",
                                                                    conflict.conflictId
                                                                ]
                                                            }),
                                                            conflict.source.azsolId !== undefined && /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                children: [
                                                                    "Source AZSOL ID: ",
                                                                    String(conflict.source.azsolId)
                                                                ]
                                                            }),
                                                            conflict.target.azsolId !== undefined && /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                children: [
                                                                    "Target AZSOL ID: ",
                                                                    String(conflict.target.azsolId)
                                                                ]
                                                            }),
                                                            conflict.componentKind && /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                children: [
                                                                    "Component: ",
                                                                    conflict.componentKind
                                                                ]
                                                            }),
                                                            conflict.affectedItems.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                children: [
                                                                    "Affected items: ",
                                                                    conflict.affectedItems.length
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Group, {
                                                                className: "my-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Label, {
                                                                        htmlFor: `resolution-${conflict.conflictId}`,
                                                                        children: "Resolution"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $eZYX7.default).Select, {
                                                                        id: `resolution-${conflict.conflictId}`,
                                                                        value: overrides[conflict.conflictId] ?? "",
                                                                        onChange: (event)=>setOverrides((current)=>{
                                                                                const next = {
                                                                                    ...current
                                                                                };
                                                                                if (event.target.value) next[conflict.conflictId] = event.target.value;
                                                                                else delete next[conflict.conflictId];
                                                                                return next;
                                                                            }),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("option", {
                                                                                value: "",
                                                                                children: [
                                                                                    "Use kind default (",
                                                                                    defaultResolutionByKind[conflict.kind] ?? conflict.defaultResolution,
                                                                                    ")"
                                                                                ]
                                                                            }),
                                                                            conflict.allowedResolutions.map((resolution)=>/*#__PURE__*/ (0, $bR5nk.jsx)("option", {
                                                                                    value: resolution,
                                                                                    children: resolution
                                                                                }, resolution))
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                className: "row g-2",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                        className: "col-md-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                                                                className: "h6",
                                                                                children: "Source"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("pre", {
                                                                                className: "text-wrap",
                                                                                children: JSON.stringify(conflict.source, null, 2)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                        className: "col-md-6",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                                                                className: "h6",
                                                                                children: "Target"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("pre", {
                                                                                className: "text-wrap",
                                                                                children: JSON.stringify(conflict.target, null, 2)
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            conflict.hasDiff && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                                                "aria-label": `Field differences for ${conflict.kind}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                                                        className: "h6",
                                                                        children: "Field differences"
                                                                    }),
                                                                    loadingDiffIds.has(conflict.conflictId) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                                                                        animation: "border",
                                                                        "aria-label": "Loading field differences"
                                                                    }),
                                                                    diffErrors[conflict.conflictId] && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                                                                        variant: "danger",
                                                                        role: "alert",
                                                                        children: [
                                                                            diffErrors[conflict.conflictId],
                                                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                                                variant: "link",
                                                                                onClick: ()=>void loadConflictDiff(conflict),
                                                                                children: "Try again"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    diff?.map((fieldDiff)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                            className: "border-top py-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("strong", {
                                                                                    children: fieldDiff.path
                                                                                }),
                                                                                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                                    className: "row g-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                                            className: "col-md-6",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                                                                    children: "Source: "
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("code", {
                                                                                                    children: JSON.stringify(fieldDiff.sourceValue)
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                                                            className: "col-md-6",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                                                                                    children: "Target: "
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("code", {
                                                                                                    children: JSON.stringify(fieldDiff.targetValue)
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }, fieldDiff.path))
                                                                ]
                                                            })
                                                        ]
                                                    }, conflict.conflictId);
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                className: "d-flex justify-content-between mt-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                        variant: "secondary",
                                                        disabled: conflictPageLoading || conflictPage.pageNumber <= 1,
                                                        onClick: ()=>void loadConflictPage(uploadAnalysis.analysis.analysisId, conflictPage.pageNumber - 1),
                                                        children: "Previous page"
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                        variant: "secondary",
                                                        disabled: conflictPageLoading || conflictPage.pageNumber >= conflictPage.totalPages,
                                                        onClick: ()=>void loadConflictPage(uploadAnalysis.analysis.analysisId, conflictPage.pageNumber + 1),
                                                        children: "Next page"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            jobError && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                                variant: "danger",
                                role: "alert",
                                children: jobError
                            }),
                            hasUnsavedDraft && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                                variant: "warning",
                                role: "alert",
                                children: "Save or discard local changes before importing a bundle."
                            })
                        ]
                    }),
                    stage === "job" && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                        children: [
                            jobError && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                                variant: "danger",
                                role: "alert",
                                children: jobError
                            }),
                            contextRefreshError && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                                variant: "danger",
                                role: "alert",
                                children: [
                                    contextRefreshError,
                                    ". Reload the page before editing or saving this hierarchy."
                                ]
                            }),
                            jobStatus ? /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                        className: "border rounded-2 p-3 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                className: "d-flex flex-wrap align-items-start justify-content-between gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                                                className: "h6 mb-1",
                                                                children: "Import progress"
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("p", {
                                                                className: "text-muted mb-0",
                                                                "aria-live": "polite",
                                                                children: [
                                                                    jobStatus.status,
                                                                    jobStatus.phase ? ` \xb7 ${jobStatus.phase}` : ""
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                                                        className: "text-muted small",
                                                        children: [
                                                            "Job ",
                                                            jobStatus.jobId
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("dl", {
                                                className: "d-flex flex-wrap gap-4 mb-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                                children: "TLF items"
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("dd", {
                                                                children: [
                                                                    jobStatus.processedTlfItems.toLocaleString(),
                                                                    " of",
                                                                    " ",
                                                                    jobStatus.totalTlfItems.toLocaleString(),
                                                                    " processed"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                                children: "Hierarchy metadata"
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsxs)("dd", {
                                                                children: [
                                                                    jobStatus.processedHierarchyMetadata.toLocaleString(),
                                                                    " of",
                                                                    " ",
                                                                    jobStatus.totalHierarchyMetadata.toLocaleString(),
                                                                    " processed"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("dt", {
                                                                children: "Remaining"
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)("dd", {
                                                                children: jobStatus.remaining.toLocaleString()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5YKF4.default), {
                                                now: jobStatus.total === 0 ? 0 : jobStatus.processed / jobStatus.total * 100,
                                                "aria-label": "Overall import progress"
                                            }),
                                            jobStatus.error && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                                                variant: "danger",
                                                role: "alert",
                                                children: jobStatus.error
                                            })
                                        ]
                                    }),
                                    jobStatus.failed > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                        className: "border rounded-2 p-3",
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                                className: "h6 mb-2",
                                                children: "Failed items"
                                            }),
                                            failureLoading ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                                                animation: "border",
                                                "aria-label": "Loading failed items"
                                            }) : !failurePage ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                variant: "link",
                                                onClick: ()=>void loadImportFailures(jobId ?? // istanbul ignore next -- Failure controls only render for an active job.
                                                    "", failureSkip),
                                                children: "Try again"
                                            }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                                children: [
                                                    failurePage.items.map((failure)=>/*#__PURE__*/ (0, $bR5nk.jsxs)("details", {
                                                            className: "border-top py-2",
                                                            children: [
                                                                /*#__PURE__*/ (0, $bR5nk.jsxs)("summary", {
                                                                    children: [
                                                                        failure.kind,
                                                                        ": ",
                                                                        failure.sourceKey
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                                                                    className: "mt-2",
                                                                    children: failure.error
                                                                })
                                                            ]
                                                        }, `${failure.sequenceNumber}-${failure.sourceKey}`)),
                                                    /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                                        className: "d-flex justify-content-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                                variant: "secondary",
                                                                disabled: failureLoading || failureSkip === 0,
                                                                onClick: ()=>void loadImportFailures(jobId ?? // istanbul ignore next -- Failure controls only render for an active job.
                                                                    "", Math.max(0, failureSkip - 25)),
                                                                children: "Previous failures"
                                                            }),
                                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                                variant: "secondary",
                                                                disabled: failureLoading || failureSkip + failurePage.take >= failurePage.totalCount,
                                                                onClick: ()=>void loadImportFailures(jobId ?? // istanbul ignore next -- Failure controls only render for an active job.
                                                                    "", failureSkip + failurePage.take),
                                                                children: "Next failures"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("section", {
                                className: "border rounded-2 p-3",
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)("h3", {
                                        className: "h6 mb-2",
                                        children: "Import progress"
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
                                        animation: "border",
                                        "aria-label": "Loading import status"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "secondary",
                        onClick: cancelWorkflow,
                        children: stage === "job" && importJobIsTerminal ? "Close" : "Cancel"
                    }),
                    stage === "review" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "secondary",
                        disabled: startingImport,
                        onClick: chooseAnotherFile,
                        children: "Choose another file"
                    }),
                    uploading && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "outline-danger",
                        onClick: ()=>activeUploadController.current?.abort(),
                        children: "Cancel upload"
                    }),
                    stage === "upload" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "primary",
                        disabled: !file || !hierarchy || uploading,
                        onClick: ()=>void uploadAndAnalyse(),
                        children: uploading ? "Uploading" : "Upload and analyse"
                    }),
                    stage === "review" && uploadAnalysis && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "primary",
                        disabled: startingImport || hasUnsavedDraft,
                        onClick: ()=>void startImportJob(),
                        children: startingImport ? "Starting import" : "Start import"
                    }),
                    stage === "job" && jobStatus && [
                        "Queued",
                        "Running",
                        "CancelRequested"
                    ].includes(jobStatus.status) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "outline-danger",
                        onClick: ()=>void cancelImportJob(),
                        children: "Cancel import"
                    }),
                    stage === "job" && jobStatus && jobStatus.failed > 0 && [
                        "Failed",
                        "CompletedWithFailures"
                    ].includes(jobStatus.status) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                        variant: "primary",
                        onClick: ()=>void retryFailedItems(),
                        children: "Retry failed items"
                    })
                ]
            })
        ]
    });
};
$1c34a1258ae9b888$export$8dc5bb9a42215dc6.displayName = "ImportTlfBundleModal";

});
parcelRegister("4DmML", function(module, exports) {

$parcel$export(module.exports, "refreshToc", function () { return $2a8789f168aba5ed$export$f2e4f3b130330184; });
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $h2E3D = parcelRequire("h2E3D");

var $f2M6x = parcelRequire("f2M6x");

var $lp5N7 = parcelRequire("lp5N7");
const $2a8789f168aba5ed$export$f2e4f3b130330184 = async (tocRequest, setTocRequest, backEndUrl, hierarchy, dispatch, force)=>{
    if (!tocRequest.requesting) {
        // Get links
        const tocItems = await (0, $4dL47.loadWrapper)((0, $h2E3D.loadHierarchyTlfTifos), {
            hierarchyId: hierarchy.id,
            parentTag: hierarchy.parentTag
        }, {
            ...tocRequest,
            requestedId: force ? undefined : tocRequest.requestedId,
            error: false
        }, setTocRequest, backEndUrl);
        // Process successful return
        if (tocItems?.success) {
            const tlfItems = tocItems.data.map((e)=>{
                const tlfItem = {
                    ...e,
                    tocNumber: e.tocNumber,
                    tocLabel: e.tocLabel,
                    tocOrder: e.tocOrder,
                    changed: false,
                    inError: false,
                    changedTitles: e.changedTitles ?? []
                };
                return tlfItem;
            });
            const sections = hierarchy.sections.map((section)=>new (0, $lp5N7.MosaicTocSectionClass)({
                    primaryHierarchyId: hierarchy.id,
                    ...section
                }));
            const returnedItems = [
                ...tlfItems,
                ...sections
            ].sort((a, b)=>(a.tocOrder ?? // istanbul ignore next
                0) - (b.tocOrder ?? // istanbul ignore next
                0));
            dispatch({
                operation: (0, $f2M6x.REFRESH),
                hierarchyId: hierarchy.id,
                items: returnedItems
            });
            return returnedItems;
        }
    }
};

});
parcelRegister("h2E3D", function(module, exports) {

$parcel$export(module.exports, "loadHierarchyTlfTifos", function () { return $e055263f9c71ad94$export$d5d149c494d12cbc; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $e055263f9c71ad94$export$d5d149c494d12cbc = async (backEndUrl, hierarchy, controller)=>{
    const url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}/TitlesFootnotes`;
    // Get data
    try {
        const response = await (0, $lCyBC.default).get(url, controller !== undefined ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load hierarchy tifos failed", error);
    }
};

});


parcelRegister("5aQkO", function(module, exports) {

$parcel$export(module.exports, "uploadAndAnalyzeTlfBundle", function () { return $165a4535d6032fea$export$78c7b55776bd77f1; });

var $gwCMk = parcelRequire("gwCMk");

var $lfYCO = parcelRequire("lfYCO");

var $LEzzg = parcelRequire("LEzzg");

var $6Q8gA = parcelRequire("6Q8gA");

var $4Nrhl = parcelRequire("4Nrhl");
const $165a4535d6032fea$export$78c7b55776bd77f1 = async (backEndUrl, target, controller, onProgress)=>{
    try {
        onProgress?.({
            stage: "compressing",
            completedChunks: 0,
            totalChunks: 0,
            transferredBytes: 0,
            totalBytes: target.file.size,
            currentChunkPercent: 0
        });
        const bundle = await (0, $gwCMk.compressBundleFile)(target.file);
        if (controller.signal.aborted) return {
            success: false,
            errorText: "Upload TLF bundle failed, request cancelled"
        };
        const chunks = (0, $6Q8gA.splitBundleChunks)(bundle);
        if (chunks.length === 0) return {
            success: false,
            errorText: "The selected bundle is empty"
        };
        const uploadId = crypto.randomUUID();
        const sha256 = await (0, $lfYCO.hashBundle)(bundle);
        if (controller.signal.aborted) return {
            success: false,
            errorText: "Upload TLF bundle failed, request cancelled"
        };
        let transferredBytes = 0;
        onProgress?.({
            stage: "uploading",
            completedChunks: 0,
            totalChunks: chunks.length,
            transferredBytes: transferredBytes,
            totalBytes: bundle.size,
            currentChunkPercent: 0
        });
        for(let batchStart = 0; batchStart < chunks.length; batchStart += (0, $LEzzg.TLF_BUNDLE_UPLOAD_BATCH_SIZE)){
            if (controller.signal.aborted) return {
                success: false,
                errorText: "Upload TLF bundle failed, request cancelled"
            };
            const batch = chunks.slice(batchStart, batchStart + (0, $LEzzg.TLF_BUNDLE_UPLOAD_BATCH_SIZE));
            const progressByChunk = new Map();
            const batchResponses = await Promise.all(batch.map((chunk, batchIndex)=>{
                const sequenceNumber = batchStart + batchIndex;
                return (0, $4Nrhl.tlfBundleApi).uploadChunk(backEndUrl, {
                    hierarchyId: target.hierarchyId,
                    uploadId: uploadId,
                    sequenceNumber: sequenceNumber,
                    totalChunks: chunks.length,
                    chunk: chunk
                }, controller, (currentChunkPercent)=>{
                    progressByChunk.set(sequenceNumber, currentChunkPercent);
                    const batchTransferredBytes = batch.reduce((total, batchChunk, index)=>total + Math.round(batchChunk.size * (progressByChunk.get(batchStart + index) ?? 0) / 100), 0);
                    const averageChunkPercent = Math.round([
                        ...progressByChunk.values()
                    ].reduce((total, percent)=>total + percent, 0) / batch.length);
                    onProgress?.({
                        stage: "uploading",
                        completedChunks: batchStart,
                        totalChunks: chunks.length,
                        transferredBytes: transferredBytes + batchTransferredBytes,
                        totalBytes: bundle.size,
                        currentChunkPercent: averageChunkPercent
                    });
                });
            }));
            const failedResponse = batchResponses.find((response)=>!response.success);
            if (failedResponse) return failedResponse;
            transferredBytes += batch.reduce((total, chunk)=>total + chunk.size, 0);
            onProgress?.({
                stage: "uploading",
                completedChunks: batchStart + batch.length,
                totalChunks: chunks.length,
                transferredBytes: transferredBytes,
                totalBytes: bundle.size,
                currentChunkPercent: 100
            });
        }
        if (controller.signal.aborted) return {
            success: false,
            errorText: "Upload TLF bundle failed, request cancelled"
        };
        onProgress?.({
            stage: "completing",
            completedChunks: chunks.length,
            totalChunks: chunks.length,
            transferredBytes: bundle.size,
            totalBytes: bundle.size,
            currentChunkPercent: 100
        });
        const completeResponse = await (0, $4Nrhl.tlfBundleApi).completeUpload(backEndUrl, {
            hierarchyId: target.hierarchyId,
            uploadId: uploadId,
            totalBytes: bundle.size,
            sha256: sha256
        }, controller);
        if (!completeResponse.success) return completeResponse;
        if (controller.signal.aborted) return {
            success: false,
            errorText: "Upload TLF bundle failed, request cancelled"
        };
        onProgress?.({
            stage: "analysing",
            completedChunks: chunks.length,
            totalChunks: chunks.length,
            transferredBytes: bundle.size,
            totalBytes: bundle.size,
            currentChunkPercent: 100
        });
        const analysisResponse = await (0, $4Nrhl.tlfBundleApi).analyzeUpload(backEndUrl, {
            hierarchyId: target.hierarchyId,
            uploadId: completeResponse.data.uploadId
        }, controller);
        if (!analysisResponse.success) return analysisResponse;
        return {
            success: true,
            data: {
                uploadId: completeResponse.data.uploadId,
                compressedBytes: bundle.size,
                analysis: analysisResponse.data
            }
        };
    } catch (error) {
        return {
            success: false,
            errorText: error instanceof Error ? `Upload TLF bundle failed, ${error.message}` : "Upload TLF bundle failed"
        };
    }
};

});
parcelRegister("gwCMk", function(module, exports) {

$parcel$export(module.exports, "compressBundleFile", function () { return $833ca599ba1edbcc$export$1fe1af4b2eb5ff48; });
/**
 * Gzip a raw JSON bundle while preserving an already-compressed bundle unchanged.
 *
 * @param file - User-selected `.json` or compressed TLF bundle file
 * @returns Compressed bundle Blob
 */ const $833ca599ba1edbcc$export$1fe1af4b2eb5ff48 = async (file)=>{
    const fileName = file.name.toLowerCase();
    if (/(?:\.tlfbundle|-tlfbundle)(?: \(\d+\))?\.gz$/.test(fileName)) return file;
    if (!fileName.endsWith(".json")) throw new Error("Select a -tlfbundle.gz, .tlfbundle.gz, or .json file");
    if (typeof CompressionStream === "undefined") throw new Error("Gzip compression is not supported by this browser");
    const stream = file.stream().pipeThrough(new CompressionStream("gzip"));
    const compressed = await new Response(stream).blob();
    return new Blob([
        compressed
    ], {
        type: "application/gzip"
    });
};

});

parcelRegister("lfYCO", function(module, exports) {

$parcel$export(module.exports, "hashBundle", function () { return $522e76e2095ab2f0$export$bf60b87aace5ce98; });
/**
 * Calculate the lowercase hexadecimal SHA-256 digest of compressed bundle bytes.
 *
 * @param bundle - Compressed bundle contents
 * @returns SHA-256 digest in lowercase hexadecimal
 */ const $522e76e2095ab2f0$export$bf60b87aace5ce98 = async (bundle)=>{
    const digest = await crypto.subtle.digest("SHA-256", await bundle.arrayBuffer());
    return Array.from(new Uint8Array(digest), (byte)=>byte.toString(16).padStart(2, "0")).join("");
};

});

parcelRegister("6Q8gA", function(module, exports) {

$parcel$export(module.exports, "splitBundleChunks", function () { return $ca2d0c96ec82eedd$export$1364871eaa07dad3; });

var $LEzzg = parcelRequire("LEzzg");
const $ca2d0c96ec82eedd$export$1364871eaa07dad3 = (bundle)=>{
    const chunks = [];
    for(let offset = 0; offset < bundle.size; offset += (0, $LEzzg.TLF_BUNDLE_CHUNK_SIZE_BYTES))chunks.push(bundle.slice(offset, offset + (0, $LEzzg.TLF_BUNDLE_CHUNK_SIZE_BYTES)));
    return chunks;
};

});



parcelRegister("2sTa7", function(module, exports) {

$parcel$export(module.exports, "LoadXmlLibraryModal", function () { return $6c8915bd2d39266d$export$fc53bd89838d8f4b; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $4dL47 = parcelRequire("4dL47");

var $3tNrK = parcelRequire("3tNrK");

var $lMasD = parcelRequire("lMasD");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
var $eZYX7 = parcelRequire("eZYX7");
var $27W8h = parcelRequire("27W8h");
var $31g00 = parcelRequire("31g00");
const $6c8915bd2d39266d$export$fc53bd89838d8f4b = ({ show: show, onClose: onClose })=>{
    const [xmlFile, setXmlFile] = (0, $spJKX.useState)(null);
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchyId = hierarchyContext?.hierarchy?.id;
    const [loadRequest, setLoadRequest] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    /**
   * Closes the modal and resets state.
   */ const cx = ()=>{
        setXmlFile(null);
        setLoadRequest({
            requesting: false,
            error: false
        });
        onClose();
    };
    /**
   * Handles loading the XML file: reads the file, validates it, and if valid,
   *
   * @param xmlFile - The XML file to be processed.
   */ const onLoad = async (xmlFile)=>{
        const text = await xmlFile.text();
        /* istanbul ignore else */ if (hierarchyId && text.length > 0) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(text, "text/xml");
            const parseError = xmlDoc.querySelector("parsererror");
            if (parseError) setLoadRequest({
                requesting: false,
                error: true,
                errorText: "Invalid XML file. Please upload a well-formed XML."
            });
            else await (0, $4dL47.loadWrapper)((0, $lMasD.loadClinicalLibrary), {
                hierarchyId: hierarchyId,
                xmlText: text
            }, loadRequest, setLoadRequest, appSettings.backEndUrl);
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default), {
        show: show,
        size: "lg",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Header, {
                closeButton: true,
                onHide: cx,
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Title, {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                        children: "Upload clinical library XML file"
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $27W8h.default).Body, {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $31g00.default), {
                        className: "m-2",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("h5", {
                                className: "mb-2",
                                children: "Select a file"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Group, {
                                controlId: "upload-xml",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $eZYX7.default).Control, {
                                    "aria-label": "XML file upload",
                                    className: "mb-2",
                                    type: "file",
                                    accept: ".xml",
                                    onChange: (e)=>{
                                        const files = e.target.files;
                                        /* istanbul ignore else */ if (files && files.length > 0) setXmlFile(files[0]);
                                    }
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $27W8h.default).Footer, {
                children: [
                    loadRequest.requestedId?.hierarchyId === hierarchyId && /*#__PURE__*/ (0, $bR5nk.jsx)("h6", {
                        className: "text-success",
                        children: "File processed successfully"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: "load-xml-button",
                        className: "mt-2",
                        disabled: !xmlFile,
                        requestStatus: loadRequest,
                        onClick: ()=>onLoad(xmlFile),
                        children: "Load"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                        id: "loadxmllibrarymodal-cancel",
                        variant: "secondary",
                        onClick: cx,
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};
$6c8915bd2d39266d$export$fc53bd89838d8f4b.displayName = "LoadXmlLibraryModal";

});
parcelRegister("lMasD", function(module, exports) {

$parcel$export(module.exports, "loadClinicalLibrary", function () { return $b8f6e4e97603d91f$export$e05e15be8fb7128f; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
// Get CHUNK_SIZE from environment variable or default to 2MB
const $b8f6e4e97603d91f$var$CHUNK_SIZE_MB = parseInt(undefined ?? "2");
const $b8f6e4e97603d91f$var$CHUNK_SIZE = 1048576 * $b8f6e4e97603d91f$var$CHUNK_SIZE_MB; // Convert MB to bytes
const $b8f6e4e97603d91f$var$MAX_PARALLEL_UPLOADS = parseInt(undefined ?? "3");
const $b8f6e4e97603d91f$export$e05e15be8fb7128f = async (backEndUrl, params, controller, onProgress)=>{
    /* Endpoint accepting chunked uploads (FormData with fileId, sequenceNumber, totalChunks, chunk). */ const uploadChunkUrl = `${backEndUrl}ClinicalLibrary/UploadChunks`;
    /* Endpoint to signal completion of all chunk uploads (FormData with fileId, hierarchyId). */ const completeUploadUrl = `${backEndUrl}ClinicalLibrary/CompleteUpload`;
    try {
        // Convert XML string to Uint8Array for chunking
        const encoder = new TextEncoder();
        /* UTF-8 encoded byte representation of the XML text.*/ const xmlData = encoder.encode(params.xmlText);
        // Calculate chunks
        const totalChunks = Math.ceil(xmlData.length / $b8f6e4e97603d91f$var$CHUNK_SIZE);
        /**
     * Unique identifier used to associate all chunks and the completion request.
     * This must be stable across all requests in a single upload.
     */ const fileId = crypto.randomUUID();
        let uploadedChunks = 0;
        // Upload chunks in small parallel batches
        for(let i = 0; i < totalChunks; i += $b8f6e4e97603d91f$var$MAX_PARALLEL_UPLOADS){
            const batch = Array.from({
                length: Math.min($b8f6e4e97603d91f$var$MAX_PARALLEL_UPLOADS, totalChunks - i)
            }, (_, j)=>i + j);
            await Promise.all(batch.map(async (sequenceNumber)=>{
                const start = sequenceNumber * $b8f6e4e97603d91f$var$CHUNK_SIZE;
                const end = Math.min((sequenceNumber + 1) * $b8f6e4e97603d91f$var$CHUNK_SIZE, xmlData.length);
                const chunkData = xmlData.slice(start, end);
                const chunkBlob = new Blob([
                    chunkData
                ], {
                    type: "application/xml"
                });
                const formData = new FormData();
                formData.append("fileId", fileId);
                formData.append("sequenceNumber", sequenceNumber.toString());
                formData.append("totalChunks", totalChunks.toString());
                formData.append("hierarchyId", params.hierarchyId);
                formData.append("chunk", chunkBlob, `chunk_${sequenceNumber}.xml`);
                await (0, $lCyBC.default).post(uploadChunkUrl, formData, {
                    signal: controller.signal
                });
                uploadedChunks++;
                onProgress?.(Math.round(uploadedChunks / totalChunks * 100));
            }));
        }
        // Notify backend all chunks are uploaded
        const completeForm = new FormData();
        completeForm.append("fileId", fileId);
        completeForm.append("hierarchyId", params.hierarchyId);
        await (0, $lCyBC.default).post(completeUploadUrl, completeForm, {
            signal: controller.signal
        });
        onProgress?.(100);
        return {
            success: true
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Load clinical library in chunks failed", error);
    }
};

});



parcelRegister("7TX7i", function(module, exports) {

$parcel$export(module.exports, "TlfInner", function () { return $82010424416818f4$export$451f3024d6ddacc9; });
$parcel$export(module.exports, "Tlf", function () { return $82010424416818f4$export$26ac70fba7792550; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $iOTZL = parcelRequire("iOTZL");
var $31g00 = parcelRequire("31g00");

var $cPGKJ = parcelRequire("cPGKJ");

var $37PAJ = parcelRequire("37PAJ");

var $bh4yZ = parcelRequire("bh4yZ");

var $2Fpsl = parcelRequire("2Fpsl");

var $2rjXU = parcelRequire("2rjXU");

var $65onm = parcelRequire("65onm");

var $keQNA = parcelRequire("keQNA");

var $6rGVX = parcelRequire("6rGVX");

var $2aS8D = parcelRequire("2aS8D");

var $cH7dl = parcelRequire("cH7dl");

var $4Ys7v = parcelRequire("4Ys7v");

var $ekurq = parcelRequire("ekurq");

var $lwTQ1 = parcelRequire("lwTQ1");
const $82010424416818f4$export$451f3024d6ddacc9 = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    return !tlfContext || tlfData?.id === undefined ? null : !(0, $3Avah.isTlfItemReadDto)(tlfData) ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
            className: "d-flex justify-content-center mt-4 ",
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    className: "text-danger",
                    children: "The TLF data for this item is corrupdated/incorrect. Please contact support quoting id:"
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    className: "ms-1",
                    children: tlfData.id
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                className: "mt-4",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    className: "d-flex justify-content-center",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2aS8D.Titles), {})
                })
            }),
            tlfData.type === (0, $4lHS7.eTlfItemType).arsListing || tlfData.type === (0, $4lHS7.eTlfItemType).arsTable ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cPGKJ.ArsPageBy), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2rjXU.PageBy), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ekurq.TlfUndoButtons), {}),
            tlfData.type === (0, $4lHS7.eTlfItemType).v1figure ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar",
                    style: {
                        display: "grid",
                        placeItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $lwTQ1.V1Figure), {})
                })
            }) : tlfData.type === (0, $4lHS7.eTlfItemType).figure ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                id: "tlf-body-holder-row",
                className: "mb-3 w-100",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    id: "tlf-body-holder-col",
                    className: "w-100",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bh4yZ.InteractiveFigure), {})
                })
            }) : tlfData.type === (0, $4lHS7.eTlfItemType).arsListing ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar position-relative",
                    style: {
                        display: "grid",
                        placeItems: "center",
                        height: "calc(100% + 1em)"
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cH7dl.TlfArsListing), {})
                })
            }) : tlfData.type === (0, $4lHS7.eTlfItemType).arsTable ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar position-relative",
                    style: {
                        display: "grid",
                        placeItems: "center",
                        height: "calc(100% + 1em)"
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $4Ys7v.TlfArsTable), {})
                })
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                id: "tlf-body-holder-row",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    id: "tlf-body-holder-col",
                    className: "small-scrollbar",
                    style: {
                        display: "grid",
                        placeItems: "center"
                    },
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $6rGVX.TableListing), {})
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                className: "my-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    className: "mt-4",
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $37PAJ.Footnotes), {
                        canAddFirstRow: true
                    })
                })
            })
        ]
    });
};
$82010424416818f4$export$451f3024d6ddacc9.displayName = "TlfInner";
const $82010424416818f4$export$26ac70fba7792550 = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    return !tlfData ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
        id: "tlf-row",
        className: "mt-4 flex-grow-1 small-scrollbar w-100",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
            className: "d-flex justify-content-center",
            style: {
                position: "relative"
            },
            children: /*#__PURE__*/ (0, $bR5nk.jsx)("p", {
                children: "No TLF loaded, go to File -> Load TLF"
            })
        })
    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)($82010424416818f4$export$451f3024d6ddacc9, {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $65onm.ProgrammerNotes), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2Fpsl.NotesTable), {}),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $keQNA.StandardsNotes), {})
        ]
    });
};
$82010424416818f4$export$26ac70fba7792550.displayName = "Tlf";

});
parcelRegister("cPGKJ", function(module, exports) {

$parcel$export(module.exports, "ArsPageBy", function () { return $2cd20b7d635314e1$export$d5a278c5d83793d; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $jPvQk = parcelRequire("jPvQk");

var $jYQZd = parcelRequire("jYQZd");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $3Avah = parcelRequire("3Avah");

var $iOTZL = parcelRequire("iOTZL");
var $31g00 = parcelRequire("31g00");
const $2cd20b7d635314e1$var$dropText = {
    lines: [
        {
            textBlocks: [
                {
                    text: "Drop grouping factors here",
                    style: "OptionalLocked",
                    type: "text"
                }
            ]
        }
    ]
};
const $2cd20b7d635314e1$export$d5a278c5d83793d = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    if (!tlfContext || !(0, $3Avah.isTlfItemReadDto)(tlfData) || tlfData.type !== (0, $4lHS7.eTlfItemType).arsListing && tlfData.type !== (0, $4lHS7.eTlfItemType).arsTable) return null;
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
        className: "my-4",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jPvQk.ArsBlock), {
                disabled: tlfContext.readOnly,
                dropText: $2cd20b7d635314e1$var$dropText,
                editorDefns: (0, $jYQZd.v3EditorProps),
                id: `ars-page-by-${tlfData.id}`,
                setValue: (pageBy)=>tlfContext.dispatch({
                        operation: (0, $2Mlm8.UPDATE_TLF),
                        tlfData: {
                            pageBy: pageBy
                        },
                        calledFrom: "ArsPageBy onChange"
                    }),
                style: appSettings.defaultTableStyle,
                value: tlfData.pageBy
            })
        })
    });
};
$2cd20b7d635314e1$export$d5a278c5d83793d.displayName = "ArsPageBy";

});
parcelRegister("jYQZd", function(module, exports) {

$parcel$export(module.exports, "v3EditorProps", function () { return $b06330b6b0638ec5$export$12fbebec3959af1b; });

var $bX0x9 = parcelRequire("bX0x9");

var $j1l29 = parcelRequire("j1l29");
const $b06330b6b0638ec5$export$12fbebec3959af1b = {
    Editor: (0, $j1l29.EditorV3Wrapper),
    blankT: (0, $bX0x9.stringToV3)(""),
    getTextFromT: (0, $bX0x9.getTextFromEditorV3),
    isT: (0, $bX0x9.isIEditorV3),
    joinTintoBlock: (0, $bX0x9.joinV3intoBlock),
    replaceTextInT: (0, $bX0x9.replaceTextInEditorV3),
    splitTintoLines: (0, $bX0x9.splitV3intoLines),
    textToT: (0, $bX0x9.stringToV3)
};

});
parcelRegister("j1l29", function(module, exports) {

$parcel$export(module.exports, "EditorV3Wrapper", function () { return $945be80c61d0aa40$export$1948bd376c6a2ec2; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");

var $3tNrK = parcelRequire("3tNrK");

var $4lHS7 = parcelRequire("4lHS7");

var $8VrYk = parcelRequire("8VrYk");

var $h24Ud = parcelRequire("h24Ud");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $hr2Fn = parcelRequire("hr2Fn");

var $6Wub1 = parcelRequire("6Wub1");
const $945be80c61d0aa40$export$1948bd376c6a2ec2 = ({ id: id, value: value, setValue: setValue, editable: editable, preReplacedText: preReplacedText, textAlignment: textAlignment, allowNewLine: allowNewLine, commentConfig: commentConfig, ...rest })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    // Timestamp when pre-replaced text was shown (null means not showing)
    const [showPreReplacedText, setShowPreReplacedText] = (0, $spJKX.useState)(null);
    const wrapperRef = (0, $spJKX.useRef)(null);
    // Request animation frame ref
    const rafRef = (0, $spJKX.useRef)(null);
    // Mouse and focus state ref
    const stateRef = (0, $spJKX.useRef)({
        focused: false,
        mouse: {
            x: 0,
            y: 0
        }
    });
    (0, $spJKX.useEffect)(()=>{
        if (showPreReplacedText === null) return;
        /**
     * Tracks mouse position for pre-replacement text preview positioning.
     *
     * @param e - The mouse event containing cursor coordinates
     */ const handleMouseMove = (e)=>{
            stateRef.current.mouse = {
                x: e.clientX,
                y: e.clientY
            };
        };
        document.addEventListener("mousemove", handleMouseMove);
        return ()=>document.removeEventListener("mousemove", handleMouseMove);
    }, [
        showPreReplacedText
    ]);
    /**
   * Memoized replacement text check
   */ const replacement = (0, $spJKX.useMemo)(()=>editable && preReplacedText && !(0, $eBlbF.isEqual)((0, $bX0x9.getTextFromEditorV3)(value), (0, $bX0x9.getTextFromEditorV3)(preReplacedText)), [
        editable,
        preReplacedText,
        value
    ]);
    /**
   * Comprehensive check function that verifies mouse position and focus
   */ const performComprehensiveCheck = (0, $spJKX.useEffectEvent)(()=>{
        // Look for table cell if there is one, otherwise use the wrapper
        const el = wrapperRef.current?.closest("td") ?? wrapperRef.current;
        const EXTRA_MOUSE_COVER_PX = 8;
        const MIN_SHOW_TIME_MS = 500;
        /**
     * Performs the comprehensive check for hiding pre-replaced text
     */ const check = ()=>{
            /* istanbul ignore else */ if (el && replacement) {
                const hasFocus = el.contains(document.activeElement) || stateRef.current.focused;
                const rect = el.getBoundingClientRect();
                const { x: x, y: y } = stateRef.current.mouse;
                const mouseOver = x >= rect.left - EXTRA_MOUSE_COVER_PX && x <= rect.right + EXTRA_MOUSE_COVER_PX && y >= rect.top - EXTRA_MOUSE_COVER_PX && y <= rect.bottom + EXTRA_MOUSE_COVER_PX;
                const now = Date.now();
                const elapsed = now - (showPreReplacedText ?? // istanbul ignore next
                0);
                if (elapsed > MIN_SHOW_TIME_MS && !(hasFocus || mouseOver)) {
                    // Only hide if at least 500ms has passed
                    setShowPreReplacedText(null);
                    rafRef.current = null;
                    return;
                }
                rafRef.current = window.requestAnimationFrame(check);
            }
        };
        check();
    });
    /**
   * Stop comprehensive checking and clean up when pre-replaced text is hidden
   */ (0, $spJKX.useEffect)(()=>{
        if (showPreReplacedText !== null && replacement && rafRef.current === null) rafRef.current = window.requestAnimationFrame(performComprehensiveCheck);
        return ()=>{
            if (rafRef.current !== null) {
                window.cancelAnimationFrame(rafRef.current);
                rafRef.current = null;
            }
        };
    }, [
        showPreReplacedText,
        replacement
    ]);
    /**
   * Handle mouse enter
   */ const handleMouseEnter = ()=>{
        if (replacement && showPreReplacedText === null) setShowPreReplacedText(Date.now());
    };
    /**
   * Handle focus event
   */ const handleFocus = ()=>{
        stateRef.current.focused = true;
        if (replacement && showPreReplacedText === null) setShowPreReplacedText(Date.now());
    };
    /**
   * Handle blur event
   */ const handleBlur = ()=>{
        stateRef.current.focused = false;
    };
    /**
   * Determine custom style map based on hierarchy level
   */ const thisCustomStyleMap = (0, $6Wub1.stylesToV3)(appSettings.styles, hierarchyContext?.hierarchy?.level === (0, $4lHS7.eHierarchyLevel).Report ? (0, $8VrYk.eTlfType).Shell : (0, $8VrYk.eTlfType).Template);
    /**
   * Determine if window view and markdown are allowed
   */ const allowWindowViewMarkdown = (0, $spJKX.useMemo)(()=>editable && hierarchyContext?.hierarchy?.level !== (0, $4lHS7.eHierarchyLevel).Report, [
        editable,
        hierarchyContext?.hierarchy?.level
    ]);
    const editorElement = /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bX0x9.EditorV3), {
        ...rest,
        id: id,
        className: [
            rest.className ?? "",
            replacement && showPreReplacedText === null ? "has-replaced-text" : ""
        ].filter((s)=>s.trim() !== "").join(" "),
        allowMarkdown: allowWindowViewMarkdown,
        allowNewLine: allowNewLine ?? true,
        allowWindowView: allowWindowViewMarkdown,
        customStyleMap: thisCustomStyleMap,
        debounceMilliseconds: -1,
        editable: editable,
        input: showPreReplacedText !== null && preReplacedText ? preReplacedText : value,
        noBorder: true,
        onBlur: handleBlur,
        onFocus: handleFocus,
        resize: false,
        /**
       * Ensure that only line differences are returned/processed
       *
       * @param obj - Object containing `lines` property produced by the editor.
       */ setObject: (obj)=>{
            const ret = {
                lines: obj.lines
            };
            const diff = (0, $bX0x9.getObjectDiff)((0, $h24Ud.omitDeep)(preReplacedText ?? value, [
                "isLocked"
            ]), (0, $h24Ud.omitDeep)(ret, [
                "isLocked"
            ]));
            if (diff) setValue(ret);
        },
        spellCheck: false,
        textAlignment: textAlignment
    });
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        ref: wrapperRef,
        className: "editor-wrapper",
        onMouseEnter: handleMouseEnter,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: commentConfig ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
            id: commentConfig.id,
            activeContext: commentConfig.activeContext,
            commentLabel: commentConfig.label,
            disabled: commentConfig.disabled,
            iconPosition: commentConfig.iconPosition,
            noIcon: commentConfig.noIcon,
            children: editorElement
        }) : editorElement
    });
};
$945be80c61d0aa40$export$1948bd376c6a2ec2.displayName = "EditorV3Wrapper";

});
parcelRegister("hr2Fn", function(module, exports) {

$parcel$export(module.exports, "CommentScope", function () { return $eb15b2a3abedd837$export$e81cb27db2f9c16f; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $spJKX = parcelRequire("spJKX");

var $9HDOe = parcelRequire("9HDOe");


var $e5pGr = parcelRequire("e5pGr");

var $joohN = parcelRequire("joohN");
const $eb15b2a3abedd837$export$e81cb27db2f9c16f = ({ id: id, activeContext: activeContext, children: children, className: className = "", commentLabel: commentLabel, disabled: disabled = false, iconPosition: iconPosition = {
    top: "-6px",
    left: "20px"
}, noIcon: noIcon = false, style: style, wrap: wrap = false })=>{
    // Get contexts
    const { comments: comments, commentPanelStatus: commentPanelStatus, setCommentPanelStatus: setCommentPanelStatus, createComment: createComment } = (0, $joohN.useComments)(activeContext);
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    // isTlfNew is set by the TLF loader (tlfLoader vs newTlfLoader), not derived from azsolId here
    const isTlfNew = activeContext === "TlfItem" && tlfContext.isTlfNew;
    // Handle border
    const activeBorder = (0, $spJKX.useMemo)(()=>commentPanelStatus?.showComments && commentPanelStatus?.activeRelatedTo === id, [
        commentPanelStatus?.activeRelatedTo,
        id,
        commentPanelStatus?.showComments
    ]);
    const targetComment = (0, $spJKX.useMemo)(()=>comments?.find((c)=>c.relatedTo === id), [
        comments,
        id
    ]);
    /**
   * Create a new comment and open the comment panel for the related target.
   *
   * @param relatedTo - The id of the element the comment relates to.
   */ const addNewComment = (relatedTo)=>{
        /* istanbul ignore else */ if (commentPanelStatus && setCommentPanelStatus) {
            const comment = createComment(undefined, relatedTo);
            /* istanbul ignore else */ if (comment) {
                // Focus if the comments panel is open, otherwise it will be focused by the CommentPanel event
                /* istanbul ignore else */ if (commentPanelStatus.showComments === true) {
                    /**
           * Focus the newly created comment editor element if present.
           */ const doFocus = ()=>{
                        // Get element
                        const el = document.getElementById(`comment-${comment.id}-editable`);
                        // Check if element exists and is focused
                        /* istanbul ignore else */ if (el && document.activeElement !== el) el.focus();
                    };
                    // Run focus in timeout to ensure the comment is visible
                    setTimeout(doFocus, 100);
                }
                setCommentPanelStatus({
                    ...commentPanelStatus,
                    activeRelatedTo: comment.relatedTo ?? "",
                    highlightCommentId: comment.id,
                    showComments: true
                });
            }
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $5EkSD.ContextMenuHandler), {
        menuItems: !disabled ? [
            {
                label: isTlfNew ? /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    "aria-label": commentLabel,
                    "aria-disabled": isTlfNew,
                    className: "contextMenuItemLabel",
                    title: (0, $e5pGr.NEW_TLF_COMMENT_TOOLTIP),
                    children: commentLabel
                }) : commentLabel,
                disabled: isTlfNew,
                action: ()=>addNewComment(id)
            }
        ] : [],
        style: wrap ? {
            width: "fit-content",
            height: "fit-content"
        } : {
            width: "100%",
            height: "100%"
        },
        children: [
            !noIcon && !disabled && setCommentPanelStatus && commentPanelStatus && comments && comments.findIndex((c)=>c.relatedTo === id) !== -1 && targetComment && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "position-relative",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9HDOe.default), {
                    size: "12",
                    "aria-label": "Show comments",
                    style: {
                        ...iconPosition,
                        position: "absolute",
                        zIndex: 1
                    },
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        setCommentPanelStatus({
                            ...commentPanelStatus,
                            activeRelatedTo: targetComment.relatedTo,
                            highlightCommentId: targetComment.id,
                            showComments: true
                        });
                        // Focus on the comment in timeout, ensure it is visible
                        setTimeout(()=>{
                            document.getElementById(`comment-${targetComment.id}-box`)?.focus();
                        }, 250);
                    }
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: `comment-limit-border ${!disabled && activeBorder ? "active" : ""} ${className}`,
                style: style,
                children: children
            })
        ]
    });
};
$eb15b2a3abedd837$export$e81cb27db2f9c16f.displayName = "CommentScope";

});

parcelRegister("6Wub1", function(module, exports) {

$parcel$export(module.exports, "stylesToV3", function () { return $5e208eed915e8afa$export$f9582f333a7b6c17; });
const $5e208eed915e8afa$export$f9582f333a7b6c17 = (styles, type)=>{
    const customStyleMap = {};
    const filteredStyles = styles.filter((s)=>s.tlfItemType === type && s.name !== "NoStyle");
    filteredStyles.forEach((s)=>{
        customStyleMap[s.name] = {};
        const thisStyle = customStyleMap[s.name];
        s.styleAttributes.forEach((a)=>{
            thisStyle[a.key] = a.value;
        });
    });
    return customStyleMap;
};

});




parcelRegister("37PAJ", function(module, exports) {

$parcel$export(module.exports, "Footnotes", function () { return $7ca0f0aeebc16891$export$adb5ddffcfa29b3; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1ol4Z = parcelRequire("1ol4Z");
var $cCgYJ = parcelRequire("cCgYJ");
var $4hgF7 = parcelRequire("4hgF7");

var $jYQZd = parcelRequire("jYQZd");

var $3degO = parcelRequire("3degO");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4swop = parcelRequire("4swop");

var $2Mlm8 = parcelRequire("2Mlm8");

var $kdlCe = parcelRequire("kdlCe");

var $hr2Fn = parcelRequire("hr2Fn");
const $7ca0f0aeebc16891$export$adb5ddffcfa29b3 = ({ canAddFirstRow: canAddFirstRow = false, noComments: noComments = false, patch: patch = false, tocId: tocId })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: tocState } = (0, $3tNrK.useTocContext)();
    const { state: ars } = (0, $4hgF7.useArsContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { patchTlf: patchTlf, saveRequest: saveRequest } = (0, $3degO.useSave)();
    const tlfData = tocId ? tocState.tocItems.find((tlf)=>tlf.id === tocId && (0, $kdlCe.isTitlesFootnotesReadDto)(tlf)) : tlfContext.tlfData;
    if (!hierarchyContext?.hierarchy || !tlfData || !tlfContext) return null;
    const externalSingles = (0, $4swop.getExternalSingles)(undefined, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
        id: "footnotes-comment",
        activeContext: "TlfItem",
        commentLabel: "New footnotes comment",
        disabled: noComments,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cCgYJ.AsupInternalBlock), {
            id: "footnotes",
            canAddFirstRow: canAddFirstRow,
            lineStyle: {
                ...appSettings.defaultTableStyle
            },
            lines: tlfData.footnotes,
            disabled: tlfContext.readOnly || patch && saveRequest.requesting,
            onChange: (ret)=>{
                if (patch) patchTlf(tlfData.id, tlfData.azsolId, "footnotes", ret);
                else tlfContext.dispatch({
                    operation: (0, $2Mlm8.UPDATE_TLF),
                    tlfData: {
                        footnotes: ret
                    },
                    calledFrom: "Footnotes:Update"
                });
            },
            externalSingles: externalSingles,
            defaultType: (0, $1ol4Z.AibLineType).leftOnly,
            editorProps: (0, $jYQZd.v3EditorProps),
            noComments: noComments,
            noTrafficLights: true
        })
    });
};
$7ca0f0aeebc16891$export$adb5ddffcfa29b3.displayName = "Footnotes";

});

parcelRegister("bh4yZ", function(module, exports) {

$parcel$export(module.exports, "InteractiveFigure", function () { return $8d58f8c2633e16ea$export$8137e822eaf7457c; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $fVgC1 = parcelRequire("fVgC1");
var $hFJlN = parcelRequire("hFJlN");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $2frel = parcelRequire("2frel");

var $3Avah = parcelRequire("3Avah");
parcelRequire("spJKX");
const $8d58f8c2633e16ea$export$8137e822eaf7457c = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const body = (0, $3Avah.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData.body : undefined;
    const clinicalLibrary = hierarchyContext?.hierarchy?.clinicalLibrary;
    const varNames = clinicalLibrary?.clinicalDatasets.flatMap((ds)=>{
        const vars = ds.clinicalVariables.map((v)=>v.name);
        return vars.map((v)=>({
                value: `${ds.name}.${v}`
            }));
    }) ?? [
        {
            value: "No variables available"
        }
    ];
    const figureInput = tlfContext.tlfData?.type === (0, $4lHS7.eTlfItemType).figure ? (0, $hFJlN.preProcessFigureInput)(appSettings.figureSettings, body) : undefined;
    return !figureInput || !tlfContext ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fVgC1.BeFigure), {
        backEndUrl: appSettings.backEndUrl,
        externalFigureRequest: (0, $2frel.getFigure),
        figureSettings: appSettings.figureSettings,
        figureInput: figureInput,
        varNames: varNames,
        updateFigureInput: (newBody)=>{
            tlfContext.dispatch({
                operation: (0, $2Mlm8.UPDATE_TLF),
                tlfData: {
                    body: newBody
                },
                calledFrom: "BeFigureOptions:updateFigureInput"
            });
        }
    });
};
$8d58f8c2633e16ea$export$8137e822eaf7457c.displayName = "InteractiveFigure";

});
parcelRegister("2frel", function(module, exports) {

$parcel$export(module.exports, "getFigure", function () { return $ad69d1ed54c4139a$export$7821d24ab666bc1c; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ad69d1ed54c4139a$export$7821d24ab666bc1c = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Figure/generate`;
        const response = await (0, $lCyBC.default).post(url, params, {
            headers: {
                "Content-Type": "application/json"
            },
            responseType: "blob",
            signal: controller.signal
        });
        // Convert blob to base64 data URL
        const blob = new Blob([
            response.data
        ], {
            type: "image/png"
        });
        const reader = new FileReader();
        return new Promise((resolve)=>{
            reader.onload = ()=>{
                resolve({
                    success: true,
                    data: reader.result
                });
            };
            reader.onerror = ()=>{
                resolve({
                    success: false,
                    errorText: "Failed to process image data"
                });
            };
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Generate BE figure failed", error);
    }
};

});


parcelRegister("2Fpsl", function(module, exports) {

$parcel$export(module.exports, "NotesTable", function () { return $c3e32279f74b7ee9$export$86076345fd01ba79; });

var $bR5nk = parcelRequire("bR5nk");

var $bvCZ6 = parcelRequire("bvCZ6");

var $bX0x9 = parcelRequire("bX0x9");

var $6Wub1 = parcelRequire("6Wub1");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $8VrYk = parcelRequire("8VrYk");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");

/**
 * Inline editor wrapper used by the notes table to render V3 editor content.
 *
 * @param props - Table cell render props containing `rowData` and indexing info.
 */ const $c3e32279f74b7ee9$var$EditorV3SimpleTable = (props)=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bX0x9.EditorV3), {
        id: `notes-cell-${props.rowNumber}-${props.columnNumber}`,
        input: props.rowData.notesContent,
        noBorder: true,
        customStyleMap: (0, $6Wub1.stylesToV3)(appSettings.styles, (0, $8VrYk.eTlfType).Template),
        setObject: // istanbul ignore next
        ()=>{},
        editable: false
    });
};
$c3e32279f74b7ee9$var$EditorV3SimpleTable.displayName = "EditorV3SimpleTable";
const $c3e32279f74b7ee9$var$headers = [
    {
        name: "optionType",
        label: "Option Type",
        width: "180px"
    },
    {
        name: "notesText",
        label: "Notes Text",
        width: "600px",
        renderFn: $c3e32279f74b7ee9$var$EditorV3SimpleTable
    },
    {
        name: "notesAt",
        label: "Notes at",
        width: "300px",
        /**
     * Renders the 'Notes at' cell for the notes table, showing a location string.
     *
     * @param props - Table cell render props containing `rowData`.
     */ renderFn: (props)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                style: {
                    textAlign: "center",
                    width: "100%"
                },
                children: props.rowData.notesAt
            })
    }
];
const $c3e32279f74b7ee9$export$86076345fd01ba79 = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const notes = (0, $spJKX.useMemo)(()=>{
        const currentNotes = [];
        if (tlfContext && tlfContext.tlfData && "body" in tlfContext.tlfData && tlfContext.tlfData.type !== "V1Figure") {
            const tableData = tlfContext.tlfData.body;
            currentNotes.push({
                optionType: "Table",
                notesContent: tableData.comments,
                notesAt: "Table"
            });
            /* istanbul ignore else */ if (tableData.headerData) {
                currentNotes.push({
                    optionType: "Header",
                    notesContent: tableData.headerData.comments,
                    notesAt: "Header"
                });
                tableData.headerData.rows.forEach((row, ri)=>{
                    row.cells.forEach((cell, ci)=>{
                        /* istanbul ignore else */ if (cell.comments) currentNotes.push({
                            optionType: "Cell",
                            notesContent: cell.comments,
                            notesAt: `Header, Row-${ri + 1}, Cell-${ci + 1}`
                        });
                    });
                });
            }
            tableData.bodyData?.forEach((rowGroup, rgi)=>{
                currentNotes.push({
                    optionType: "RowGroup",
                    notesContent: rowGroup.comments,
                    notesAt: `Body, RowGroup-${rgi + 1}`
                });
                rowGroup.rows.forEach((row, ri)=>{
                    row.cells.forEach((cell, ci)=>{
                        /* istanbul ignore else */ if (cell.comments) currentNotes.push({
                            optionType: "Cell",
                            notesContent: cell.comments,
                            notesAt: `Body, RowGroup-${rgi + 1}, Row-${ri + 1}, Cell-${ci + 1}`
                        });
                    });
                });
            });
        }
        const transposed = currentNotes.map((a)=>({
                ...a,
                notesContent: new (0, $bX0x9.EditorV3Content)(a.notesContent)
            }));
        const filtered = transposed.filter((notes)=>notes.notesContent.text.trim() !== "");
        return filtered;
    }, [
        tlfContext
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
            className: "mb-4 annotations-table-holder",
            children: !notes || notes.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
                children: "No legacy annotations or notes."
            }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bvCZ6.SimpleTable), {
                id: "notes-table",
                fields: $c3e32279f74b7ee9$var$headers,
                keyField: "notesAt",
                data: notes,
                headerLabel: "Legacy annotations and notes",
                showPager: false,
                tableClassName: "notes-table"
            })
        })
    });
};
$c3e32279f74b7ee9$export$86076345fd01ba79.displayName = "NotesTable";

});

parcelRegister("2rjXU", function(module, exports) {

$parcel$export(module.exports, "PageBy", function () { return $71af7d624cdedafc$export$8311119bbe60fe92; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $1ol4Z = parcelRequire("1ol4Z");
var $cCgYJ = parcelRequire("cCgYJ");
var $4hgF7 = parcelRequire("4hgF7");

var $8xj55 = parcelRequire("8xj55");

var $jYQZd = parcelRequire("jYQZd");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4swop = parcelRequire("4swop");

var $2Mlm8 = parcelRequire("2Mlm8");

var $3Avah = parcelRequire("3Avah");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");
const $71af7d624cdedafc$export$8311119bbe60fe92 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: ars } = (0, $4hgF7.useArsContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = (0, $3Avah.isTlfItemReadDto)(tlfContext.tlfData) ? tlfContext.tlfData : undefined;
    const pageByData = tlfData && !Array.isArray(tlfData.pageBy) ? tlfData.pageBy : undefined;
    const externalSingles = (0, $4swop.getExternalSingles)(undefined, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData?.releaseStatus, tlfData?.domain, tlfData?.singles, hierarchyContext?.hierarchy?.level, hierarchyContext?.hierarchy?.singles, hierarchyContext?.hierarchy?.domainReplacements, hierarchyContext?.parentTemplates.singles, hierarchyContext?.parentTemplates.domainReplacements);
    const pageBy = (0, $spJKX.useMemo)(()=>{
        return [
            {
                aifid: "page-by",
                left: pageByData?.content ?? (0, $bX0x9.stringToV3)(""),
                lineType: (0, $1ol4Z.AibLineType).leftOnly,
                addBelow: false,
                canChangeType: false,
                canEdit: true,
                canRemove: false,
                canMove: false,
                center: null,
                right: null,
                coreTrafficLight: "BlankNotEvaluated"
            }
        ];
    }, [
        pageByData
    ]);
    /**
   * Handle updates to the Page By block lines, sending changes to TLF context as an IEditorV3.
   *
   * @param ret - Updated array of AibBlockLine items.
   */ const setPageBy = (ret)=>{
        // Update TLF context if content has changed
        /* istanbul ignore else */ if (pageByData && !(0, $eBlbF.isEqual)(ret[0].left, pageByData.content)) tlfContext.dispatch({
            operation: (0, $2Mlm8.UPDATE_TLF),
            tlfData: {
                pageBy: {
                    content: ret[0].left ?? // istanbul ignore next
                    (0, $bX0x9.stringToV3)(""),
                    annotation: pageByData.annotation
                }
            },
            calledFrom: "PageBy:setLines"
        });
    };
    return !tlfContext || !tlfData || !pageByData ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
            className: "mt-4",
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8xj55.AnnotationButton), {
                        buttonId: "pageby-annotation",
                        annotationType: "PageBy",
                        existingAnnotation: pageByData.annotation,
                        hidden: tlfContext.tlfViewMode.value !== "ANNOTATIONS",
                        showPreview: tlfContext.tlfViewMode.value === "ANNOTATIONS"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cCgYJ.AsupInternalBlock), {
                        id: "pageby",
                        lineStyle: appSettings.defaultTableStyle,
                        lines: pageBy,
                        disabled: tlfContext.readOnly,
                        onChange: setPageBy,
                        externalSingles: externalSingles,
                        minLines: 1,
                        maxLines: 1,
                        defaultType: (0, $1ol4Z.AibLineType).leftOnly,
                        editorProps: (0, $jYQZd.v3EditorProps),
                        noTrafficLights: true
                    })
                ]
            })
        })
    });
};
$71af7d624cdedafc$export$8311119bbe60fe92.displayName = "PageBy";

});

parcelRegister("65onm", function(module, exports) {

$parcel$export(module.exports, "ProgrammerNotes", function () { return $159ab16c90709e6a$export$f771ac3bae608de8; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");

var $6Wub1 = parcelRequire("6Wub1");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $8VrYk = parcelRequire("8VrYk");

var $eBlbF = parcelRequire("eBlbF");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");
const $159ab16c90709e6a$export$f771ac3bae608de8 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext && tlfContext.tlfData && "programmerNotes" in tlfContext.tlfData ? tlfContext.tlfData : null;
    return !tlfContext || !tlfData ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {}) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h4", {
                        children: "Programmer notes"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "notes-box",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bX0x9.EditorV3), {
                            id: "programmernotes",
                            allowNewLine: true,
                            customStyleMap: (0, $6Wub1.stylesToV3)(appSettings.styles, (0, $8VrYk.eTlfType).Template),
                            debounceMilliseconds: -1,
                            editable: !tlfContext.readOnly,
                            input: tlfData.programmerNotes,
                            setObject: (ret)=>{
                                /* istanbul ignore else */ if (!(0, $eBlbF.isEqual)(ret, tlfData.programmerNotes)) tlfContext.dispatch({
                                    operation: (0, $2Mlm8.UPDATE_TLF),
                                    tlfData: {
                                        programmerNotes: ret ?? // istanbul ignore next
                                        tlfData.programmerNotes
                                    },
                                    calledFrom: "ProgrammerNotes:Update"
                                });
                            },
                            style: {
                                ...appSettings.defaultTableStyle,
                                minHeight: "120px",
                                height: "120px",
                                border: "none"
                            }
                        })
                    })
                ]
            })
        })
    });
};
$159ab16c90709e6a$export$f771ac3bae608de8.displayName = "ProgrammerNotes";

});

parcelRegister("keQNA", function(module, exports) {

$parcel$export(module.exports, "StandardsNotes", function () { return $4bfbbab5873c2d42$export$6c0b870ee57f0a35; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");

var $6Wub1 = parcelRequire("6Wub1");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $8VrYk = parcelRequire("8VrYk");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");
const $4bfbbab5873c2d42$export$6c0b870ee57f0a35 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext && tlfContext.tlfData && "standardsNotes" in tlfContext.tlfData ? tlfContext.tlfData : null;
    const standardNotes = tlfContext.tlfData?.standardsNotes ?? // istanbul ignore next
    (0, $bX0x9.stringToV3)("");
    return !hierarchyContext || !hierarchyContext.hierarchy || !tlfContext || !tlfData ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("h4", {
                        children: "Standards notes"
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "notes-box",
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bX0x9.EditorV3), {
                            id: "standardsnotes",
                            allowNewLine: true,
                            customStyleMap: (0, $6Wub1.stylesToV3)(appSettings.styles, (0, $8VrYk.eTlfType).Template),
                            debounceMilliseconds: -1,
                            editable: !tlfContext.readOnly && [
                                (0, $4lHS7.eHierarchyLevel).Corporate,
                                (0, $4lHS7.eHierarchyLevel).TA,
                                (0, $4lHS7.eHierarchyLevel).Project
                            ].includes(hierarchyContext.hierarchy.level),
                            input: standardNotes,
                            setObject: (ret)=>{
                                tlfContext.dispatch({
                                    operation: (0, $2Mlm8.UPDATE_TLF),
                                    tlfData: {
                                        standardsNotes: ret
                                    },
                                    calledFrom: "StandardsNotes:setValue"
                                });
                            },
                            style: {
                                ...appSettings.defaultTableStyle,
                                minHeight: "120px",
                                height: "120px",
                                border: "none",
                                backgroundColor: !tlfContext.readOnly && [
                                    (0, $4lHS7.eHierarchyLevel).Corporate,
                                    (0, $4lHS7.eHierarchyLevel).TA,
                                    (0, $4lHS7.eHierarchyLevel).Project
                                ].includes(hierarchyContext?.hierarchy?.level) ? undefined : "rgba(211, 211, 211, 0.16)"
                            }
                        })
                    })
                ]
            })
        })
    });
};
$4bfbbab5873c2d42$export$6c0b870ee57f0a35.displayName = "StandardsNotes";

});

parcelRegister("6rGVX", function(module, exports) {

$parcel$export(module.exports, "TableListing", function () { return $89c4442ba51194f0$export$92027266d92ba953; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1cgCo = parcelRequire("1cgCo");
var $4hgF7 = parcelRequire("4hgF7");

var $hr2Fn = parcelRequire("hr2Fn");

var $jYQZd = parcelRequire("jYQZd");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $bJXPZ = parcelRequire("bJXPZ");

var $4swop = parcelRequire("4swop");

var $f38Yn = parcelRequire("f38Yn");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");
const $89c4442ba51194f0$export$92027266d92ba953 = ()=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: ars } = (0, $4hgF7.useArsContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const externalSingles = tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $4swop.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData?.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements) : [];
    const externalLsts = tlfData && hierarchyContext && hierarchyContext.hierarchy ? (0, $bJXPZ.getExternalLists)(tlfData.primaryHierarchyId, tlfData.primaryHierarchyLevel, tlfData.releaseStatus, hierarchyContext.hierarchy.lists, hierarchyContext.parentTemplates.lists) : [];
    const groupTemplates = (0, $f38Yn.getGroupTemplates)(hierarchyContext?.hierarchy?.rowGroups, hierarchyContext?.parentTemplates.rowGroups);
    return !hierarchyContext || !tlfData ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
        id: "tlf-table-comment",
        activeContext: "TlfItem",
        wrap: true,
        iconPosition: {
            top: "16px",
            left: "38px"
        },
        commentLabel: "New table comment",
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1cgCo.AsupInternalTable), {
            id: "tlf-table",
            tableData: tlfData.body,
            isEditable: !tlfContext.readOnly,
            onChange: (ret)=>tlfContext.dispatch({
                    operation: (0, $2Mlm8.UPDATE_TLF),
                    tlfData: {
                        body: ret
                    },
                    calledFrom: "TableListing:setTableData"
                }),
            noTrafficLights: !tlfContext.showTrafficLights || tlfData.primaryHierarchyLevel !== (0, $4lHS7.eHierarchyLevel).Report || tlfData.coreTrafficLightSwitch === "DoNotCalculate",
            style: {
                ...appSettings.defaultTableStyle,
                margin: "1rem"
            },
            showCellBorders: true,
            externalLists: externalLsts,
            externalSingles: externalSingles,
            groupTemplates: groupTemplates,
            colWidthMod: appSettings.colWidthMod,
            defaultCellWidth: appSettings.defaultColumnWidth,
            editorProps: (0, $jYQZd.v3EditorProps),
            tlfViewMode: tlfContext.tlfViewMode
        })
    });
};
$89c4442ba51194f0$export$92027266d92ba953.displayName = "TableListing";

});
parcelRegister("f38Yn", function(module, exports) {

$parcel$export(module.exports, "getGroupTemplates", function () { return $455bbf61becb2213$export$44460f30febb3d04; });
const $455bbf61becb2213$export$44460f30febb3d04 = (rowGroups = [], parentRowGroups = [])=>{
    return [
        ...parentRowGroups.filter((group)=>!rowGroups.some((g)=>g.name === group.name)),
        ...rowGroups
    ];
};

});


parcelRegister("2aS8D", function(module, exports) {

$parcel$export(module.exports, "Titles", function () { return $b52b203e784409d2$export$67b504e93d0b2f2b; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $1ol4Z = parcelRequire("1ol4Z");
var $cCgYJ = parcelRequire("cCgYJ");
var $4hgF7 = parcelRequire("4hgF7");

var $jYQZd = parcelRequire("jYQZd");

var $3degO = parcelRequire("3degO");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4swop = parcelRequire("4swop");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $kdlCe = parcelRequire("kdlCe");

var $hr2Fn = parcelRequire("hr2Fn");
const $b52b203e784409d2$export$67b504e93d0b2f2b = ({ firstLine: firstLine = 1, lastLine: lastLine = 10, noComments: noComments = false, patch: patch = false, tocId: tocId })=>{
    const appSettings = (0, $3tNrK.useAppSettings)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const { state: tocState } = (0, $3tNrK.useTocContext)();
    const { state: ars } = (0, $4hgF7.useArsContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { patchTlf: patchTlf, saveRequest: saveRequest } = (0, $3degO.useSave)();
    const tlfData = tocId ? tocState.tocItems.find((tlf)=>tlf.id === tocId && (0, $kdlCe.isTitlesFootnotesReadDto)(tlf)) : tlfContext.tlfData;
    if (!hierarchyContext?.hierarchy || !tlfData || !tlfContext) return null;
    const externalSingles = (0, $4swop.getExternalSingles)(tlfData.tocNumber, ars.analysisSets[tlfData.analysisSetId ?? ""]?.label ?? "", tlfData.releaseStatus, tlfData.domain, tlfData.singles, hierarchyContext.hierarchy.level, hierarchyContext.hierarchy.singles, hierarchyContext.hierarchy.domainReplacements, hierarchyContext.parentTemplates.singles, hierarchyContext.parentTemplates.domainReplacements);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
        id: "titles-comment",
        activeContext: "TlfItem",
        commentLabel: "New titles comment",
        disabled: noComments,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cCgYJ.AsupInternalBlock), {
            id: "titles",
            lineStyle: appSettings.defaultTableStyle,
            lines: tlfData.titles.slice(firstLine - 1, lastLine),
            disabled: tlfContext.readOnly || patch && saveRequest.requesting,
            onChange: (ret)=>{
                const newTitles = [
                    ...tlfData.titles.slice(0, firstLine - 1),
                    ...ret,
                    ...tlfData.titles.slice(lastLine)
                ];
                if (patch) patchTlf(tlfData.id, tlfData.azsolId, "titles", newTitles);
                else tlfContext.dispatch({
                    operation: (0, $2Mlm8.UPDATE_TLF),
                    tlfData: {
                        titles: newTitles
                    },
                    calledFrom: "Titles:Update"
                });
            },
            externalSingles: externalSingles,
            minLines: 5 - firstLine,
            defaultType: (0, $1ol4Z.AibLineType).centerOnly,
            editorProps: (0, $jYQZd.v3EditorProps),
            noComments: noComments,
            noTrafficLights: !tlfContext.showTrafficLights || tlfData.primaryHierarchyLevel !== (0, $4lHS7.eHierarchyLevel).Report || tlfData.coreTrafficLightSwitch === "DoNotCalculate",
            changedBlocks: tlfData.changedTitles
        })
    });
};
$b52b203e784409d2$export$67b504e93d0b2f2b.displayName = "Titles";

});

parcelRegister("cH7dl", function(module, exports) {

$parcel$export(module.exports, "TlfArsListing", function () { return $9f9613642a28e181$export$ac30f6468f253a3d; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $5V1m5 = parcelRequire("5V1m5");
var $2N5BV = parcelRequire("2N5BV");
var $4dL47 = parcelRequire("4dL47");
var $7G3Xj = parcelRequire("7G3Xj");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $hr2Fn = parcelRequire("hr2Fn");

var $jYQZd = parcelRequire("jYQZd");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $40w3b = parcelRequire("40w3b");

var $3Avah = parcelRequire("3Avah");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");

var $jeRmB = parcelRequire("jeRmB");

var $1JPnm = parcelRequire("1JPnm");

var $9mX8u = parcelRequire("9mX8u");

var $3jKY2 = parcelRequire("3jKY2");
const $9f9613642a28e181$export$ac30f6468f253a3d = ()=>{
    // Contexts
    const appSettings = (0, $3tNrK.useAppSettings)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const arsContext = (0, $4hgF7.useArsContext)();
    const isClinicalLibraryLoading = appSettings.hierarchyState.isClinicalLibraryLoading;
    const body = tlfContext && (0, $3Avah.isTlfItemReadDto)(tlfData) && (0, $2N5BV.isArsListingBody)(tlfData.body, (0, $bX0x9.isIEditorV3)) ? tlfData.body : null;
    const disabled = tlfContext.readOnly;
    // Component state items
    const [calculatedTableRows, setCalculatedTableRows] = (0, $spJKX.useState)([]);
    const [requestingCalculation, setRequestingCalculation] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [errorText, setErrorText] = (0, $spJKX.useState)(null);
    const getCalculatedRows = (0, $spJKX.useEffectEvent)(async (body)=>{
        const analysisSet = tlfData?.analysisSetId ? arsContext.state.analysisSets[tlfData.analysisSetId] : undefined;
        const dataSubset = body.dataSubsetId && Object.keys(arsContext.state.dataSubsets).includes(body.dataSubsetId) ? arsContext.state.dataSubsets[body.dataSubsetId] : undefined;
        const arsListingCalculationDto = {
            arsListingBody: body,
            analysisSet: analysisSet,
            dataSubset: dataSubset
        };
        const request = await (0, $4dL47.loadWrapper)((0, $40w3b.getArsListingCalculation), arsListingCalculationDto, requestingCalculation, setRequestingCalculation, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            arsContext.dispatch({
                operation: (0, $cJd2i.SET_VARIABLES_IN_USE),
                variablesInUse: request.data.variables
            });
            (0, $spJKX.startTransition)(()=>{
                setCalculatedTableRows(request.data.rows);
                setErrorText(null);
            });
        } else if (request?.success === false) (0, $spJKX.startTransition)(()=>setErrorText(request.errorText));
    });
    (0, $spJKX.useEffect)(()=>{
        if (body && !isClinicalLibraryLoading) getCalculatedRows(body);
    }, [
        body,
        isClinicalLibraryLoading
    ]);
    return !tlfContext || !body ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iPQyT.default), {
        fluid: true,
        style: {
            minHeight: "400px"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                        className: "d-flex align-items-start flex-row gap-1 py-3",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1JPnm.ArsSetPicker), {
                                type: "analysisSet",
                                itemId: tlfData?.analysisSetId ?? "",
                                disabled: disabled,
                                onChange: (newId)=>{
                                    tlfContext.dispatch({
                                        operation: (0, $2Mlm8.UPDATE_TLF),
                                        tlfData: {
                                            analysisSetId: newId
                                        },
                                        calledFrom: "ArsListing onChange:AnalysisSet"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1JPnm.ArsSetPicker), {
                                type: "dataSubset",
                                itemId: body.dataSubsetId ?? "",
                                disabled: disabled,
                                onChange: (newId)=>{
                                    tlfContext.dispatch({
                                        operation: (0, $2Mlm8.UPDATE_TLF),
                                        tlfData: {
                                            body: {
                                                ...body,
                                                dataSubsetId: newId
                                            }
                                        },
                                        calledFrom: "ArsListing onChange:DataSubset"
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7G3Xj.MultipleDatasetCheck), {})
                        ]
                    })
                }),
                errorText && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                        className: "text-danger m-3",
                        children: errorText
                    })
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                        className: "d-flex position-relative",
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jeRmB.ArsItemRequestingSpinner), {
                                requestingCalculation: requestingCalculation,
                                requestingLabel: "Recalculating"
                            }),
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                className: "m-auto px-3",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
                                    id: "ars-listing-comment",
                                    activeContext: "TlfItem",
                                    wrap: true,
                                    iconPosition: {
                                        top: "-16px",
                                        left: "-16px"
                                    },
                                    commentLabel: "New table comment",
                                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5V1m5.ArsListing), {
                                        arsListingBody: body,
                                        calculatedTableRows: calculatedTableRows,
                                        disabled: disabled,
                                        editorProps: (0, $jYQZd.v3EditorProps),
                                        justification: "center",
                                        sidebarStyle: {
                                            paddingBottom: "40px"
                                        },
                                        style: appSettings.defaultTableStyle,
                                        tlfViewMode: tlfContext.tlfViewMode,
                                        updateArsListingBody: (newBody)=>tlfContext.dispatch({
                                                operation: (0, $2Mlm8.UPDATE_TLF),
                                                tlfData: {
                                                    body: newBody
                                                },
                                                calledFrom: "TlfArsListing onChange"
                                            })
                                    })
                                })
                            }),
                            !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9mX8u.TlfArsPatchSidebar), {}),
                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3jKY2.TlfVariantSidebar), {})
                        ]
                    })
                })
            ]
        })
    });
};
$9f9613642a28e181$export$ac30f6468f253a3d.displayName = "TlfArsListing";

});
parcelRegister("40w3b", function(module, exports) {

$parcel$export(module.exports, "getArsListingCalculation", function () { return $ca1b8475dadf5418$export$42c68949b0874b17; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $ca1b8475dadf5418$export$42c68949b0874b17 = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Ars/ArsListingCalculation`;
        const response = await (0, $lCyBC.default).post(url, params, {
            signal: controller.signal
        });
        return {
            success: true,
            data: {
                rows: response.data.rows,
                variables: new Set(response.data.variables)
            }
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Get ARS listing calculation failed - please refresh the page and try again", error);
    }
};

});

parcelRegister("jeRmB", function(module, exports) {

$parcel$export(module.exports, "ArsItemRequestingSpinner", function () { return $f4c68e373d09fa36$export$e9ee708a0312426; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");

var $3tNrK = parcelRequire("3tNrK");

var $5dhsh = parcelRequire("5dhsh");
const $f4c68e373d09fa36$export$e9ee708a0312426 = ({ requestingCalculation: requestingCalculation, requestingLabel: requestingLabel })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    return (requestingCalculation.requesting || hierarchyContext?.isClinicalLibraryLoading) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5dhsh.default), {
        variant: "primary",
        size: "sm",
        animation: "border",
        role: "status",
        "aria-label": `${(0, $3tKzd.classMerge)([
            requestingCalculation.requesting ? requestingLabel : "",
            hierarchyContext?.isClinicalLibraryLoading ? "Loading clinical library" : ""
        ])}`,
        style: {
            position: "absolute",
            top: "0",
            left: "0",
            zIndex: 1000
        }
    });
};
$f4c68e373d09fa36$export$e9ee708a0312426.displayName = "ArsItemRequestingSpinner";

});

parcelRegister("1JPnm", function(module, exports) {

$parcel$export(module.exports, "ArsSetPicker", function () { return $d5bbabf5c9041876$export$522ae4fc4efd905d; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $3tKzd = parcelRequire("3tKzd");
var $2N5BV = parcelRequire("2N5BV");
var $gwArU = parcelRequire("gwArU");
var $4hgF7 = parcelRequire("4hgF7");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $b9tE1 = parcelRequire("b9tE1");
var $gCZ2V = parcelRequire("gCZ2V");

var $cMhqQ = parcelRequire("cMhqQ");

var $3OTGT = parcelRequire("3OTGT");

var $cQYve = parcelRequire("cQYve");
const $d5bbabf5c9041876$export$522ae4fc4efd905d = ({ type: type, itemId: itemId, disabled: disabled, onChange: onChange, ...rest })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const ars = (0, $4hgF7.useArsContext)();
    const [showWindow, setShowWindow] = (0, $spJKX.useState)(false);
    const canEdit = !disabled && (hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) ?? false);
    const body = (0, $2N5BV.isArsListingBody)(tlfContext.tlfData?.body, (0, $bX0x9.isIEditorV3)) || (0, $gwArU.isArsTableBody)(tlfContext.tlfData?.body, (0, $bX0x9.isIEditorV3)) ? tlfContext.tlfData.body : null;
    const hasSelection = type === "analysisMethod" ? ars.state.analysisMethods[itemId] !== undefined : type === "analysisSet" ? ars.state.analysisSets[itemId] !== undefined : type === "dataSubset" ? ars.state.dataSubsets[itemId] !== undefined : ars.state.groupingFactors[itemId] !== undefined;
    const selectLabel = (0, $cQYve.ARS_SET_TYPES)[type].selectLabel;
    const glyphText = (0, $cQYve.ARS_SET_TYPES)[type].glyphText;
    return !hierarchyContext?.hierarchy || !body ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("button", {
                ...rest,
                id: itemId,
                title: selectLabel,
                type: "button",
                "aria-label": selectLabel,
                onClick: ()=>setShowWindow((prev)=>!prev),
                className: (0, $3tKzd.classMerge)([
                    (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).annotationBtn,
                    !hasSelection && [
                        "analysisMethod",
                        "analysisSet"
                    ].includes(type) ? (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).badEmpty : !hasSelection ? (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).empty : undefined,
                    "position-relative"
                ]),
                children: /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).glyph,
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: (0, $3tKzd.classMerge)([
                            (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).icon,
                            (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).wide
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).letter,
                                children: glyphText
                            }),
                            canEdit && /*#__PURE__*/ (0, $bR5nk.jsx)("span", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($cMhqQ))).hoverIcon,
                                children: hasSelection ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $b9tE1.default), {
                                    size: 12
                                }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gCZ2V.default), {
                                    size: 12
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3OTGT.ArsSetWindow), {
                itemId: itemId,
                type: type,
                disabled: !canEdit,
                visible: showWindow,
                onClose: (newItemId)=>{
                    setShowWindow(false);
                    // Undefined returned on cancel.
                    // Empty string returned on delete.
                    if (newItemId !== undefined) onChange(newItemId !== "" ? newItemId : undefined);
                }
            })
        ]
    });
};
$d5bbabf5c9041876$export$522ae4fc4efd905d.displayName = "ArsSetPicker";

});
parcelRegister("3OTGT", function(module, exports) {

$parcel$export(module.exports, "ArsSetWindow", function () { return $64a98e1550e40284$export$72bfa98672dbebf; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("6jtLO");
var $321H1 = parcelRequire("321H1");
var $36pkg = parcelRequire("36pkg");
var $iuDOI = parcelRequire("iuDOI");
var $aUt9N = parcelRequire("aUt9N");
var $7byiZ = parcelRequire("7byiZ");
var $dMUCw = parcelRequire("dMUCw");
var $51n1k = parcelRequire("51n1k");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $4lHS7 = parcelRequire("4lHS7");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
const $64a98e1550e40284$export$72bfa98672dbebf = ({ type: type, itemId: itemId, onClose: onClose, visible: visible, disabled: disabled })=>{
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const canEdit = !disabled && (hierarchyContext?.accessRights.includes((0, $4lHS7.eAccessRights).WriteToTlfItemsInHierarchy) ?? false);
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { state: state, dispatch: dispatch } = (0, $4hgF7.useArsContext)();
    const [selectedId, setSelectedId] = (0, $spJKX.useState)(itemId);
    if (!hierarchyContext || !tlfContext) return null;
    const selectedEntity = (()=>{
        switch(type){
            case "analysisMethod":
                return state.analysisMethods[selectedId];
            case "analysisSet":
                return state.analysisSets[selectedId];
            case "dataSubset":
                return state.dataSubsets[selectedId];
            case "groupingFactor":
                return state.groupingFactors[selectedId];
        }
    })();
    /**
   * Creates a new entity for the active type in hierarchy context.
   */ const handleCreateNew = ()=>{
        let newId;
        switch(type){
            case "analysisSet":
                {
                    const newLength = Object.values(state.analysisSets).length + 1;
                    const newSet = (0, $7byiZ.createNewAnalysisSet)(`AnalysisSet_${newLength}`);
                    newId = newSet.id;
                    dispatch({
                        operation: (0, $cJd2i.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/analysisSets/${newId}`,
                                value: newSet
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            case "dataSubset":
                {
                    const newLength = Object.values(state.dataSubsets).length + 1;
                    const newSubset = (0, $7byiZ.createNewDataSubset)(`DataSubset_${newLength}`);
                    newId = newSubset.id;
                    dispatch({
                        operation: (0, $cJd2i.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/dataSubsets/${newId}`,
                                value: newSubset
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            case "groupingFactor":
                {
                    const newLength = Object.values(state.groupingFactors).length + 1;
                    const newGroupingFactor = {
                        ...(0, $7byiZ.createNewGroupingFactor)(`GroupingFactor_${newLength}`)
                    };
                    newId = newGroupingFactor.id;
                    dispatch({
                        operation: (0, $cJd2i.PATCH_ARS_STATE),
                        updates: [
                            {
                                dataPath: `/groupingFactors/${newId}`,
                                value: newGroupingFactor
                            }
                        ]
                    });
                    setSelectedId(newId);
                    break;
                }
            // istanbul ignore next
            default:
                break;
        }
    };
    /**
   * Creates a copy of the selected entity for the active type in hierarchy context.
   */ const handleCopyAndEdit = ()=>{
        /* istanbul ignore else -- copy actions are only reachable when a selectable entity exists with edit access */ if (selectedEntity) {
            const copyId = crypto.randomUUID();
            switch(type){
                case "analysisSet":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`,
                            order: Object.values(state.analysisSets).length + 1
                        };
                        dispatch({
                            operation: (0, $cJd2i.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/analysisSets/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                case "dataSubset":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`,
                            order: Object.values(state.dataSubsets).length + 1
                        };
                        dispatch({
                            operation: (0, $cJd2i.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/dataSubsets/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                case "groupingFactor":
                    {
                        const copy = {
                            ...selectedEntity,
                            id: copyId,
                            name: `Copy of ${selectedEntity.name}`
                        };
                        dispatch({
                            operation: (0, $cJd2i.PATCH_ARS_STATE),
                            updates: [
                                {
                                    dataPath: `/groupingFactors/${copyId}`,
                                    value: copy
                                }
                            ]
                        });
                        setSelectedId(copyId);
                        break;
                    }
                // istanbul ignore next
                default:
                    break;
            }
        }
    };
    /**
   * Closes the window or shows discard confirmation if there are pending changes.
   */ const title = type.replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase().replace(/^\w/, (c)=>c.toUpperCase());
    const modalIdPrefix = type.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    const options = (()=>{
        switch(type){
            case "analysisMethod":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select an analysis method ---"
                        }
                    ] : [],
                    ...Object.values(state.analysisMethods).map((method)=>({
                            value: method.id,
                            label: method.name
                        }))
                ];
            case "analysisSet":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select an analysis set ---"
                        }
                    ] : [],
                    ...Object.values(state.analysisSets).map((set)=>({
                            value: set.id,
                            label: set.name
                        }))
                ];
            case "dataSubset":
                return [
                    {
                        value: "",
                        label: "--- No data subset ---"
                    },
                    ...Object.values(state.dataSubsets).map((subset)=>({
                            value: subset.id,
                            label: subset.name
                        }))
                ];
            case "groupingFactor":
                return [
                    ...selectedId === "" ? [
                        {
                            value: "",
                            label: "--- Select a grouping factor ---"
                        }
                    ] : [],
                    ...Object.values(state.groupingFactors).map((factor)=>({
                            value: factor.id,
                            label: factor.name
                        }))
                ];
        }
    })();
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: `${modalIdPrefix}-picker-modal`,
        title: title,
        visible: visible,
        style: {
            minWidth: "800px"
        },
        onOpen: ()=>{
            // Reset state on open
            setSelectedId(itemId);
        },
        onClose: ()=>onClose(selectedId),
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                    id: `${modalIdPrefix}-select`,
                    label: title,
                    disabled: !canEdit,
                    options: options,
                    value: selectedId,
                    setValue: setSelectedId
                }),
                type === "analysisMethod" && selectedEntity && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $321H1.AnalysisMethodControl), {
                    dataPath: `/analysisMethods/${selectedId}`,
                    canRename: false,
                    disabled: true
                }),
                type === "analysisSet" && selectedEntity && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $36pkg.AnalysisSetControl), {
                    dataPath: `/analysisSets/${selectedId}`,
                    canRename: canEdit,
                    disabled: !canEdit
                }),
                type === "dataSubset" && selectedId && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dMUCw.DataSubsetControl), {
                    dataPath: `/dataSubsets/${selectedId}`,
                    canRename: canEdit,
                    disabled: !canEdit
                }),
                type === "groupingFactor" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $51n1k.GroupingFactorControl), {
                    dataPath: `/groupingFactors/${selectedId}`,
                    canRename: canEdit,
                    disabled: !canEdit
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: "d-flex justify-content-end gap-2 mb-3",
                    style: {
                        bottom: 0
                    },
                    children: [
                        canEdit && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                    id: `create-new-${modalIdPrefix}-button`,
                                    variant: "outline-secondary",
                                    onClick: handleCreateNew,
                                    "aria-label": "Create new",
                                    disabled: type === "analysisMethod",
                                    children: "New"
                                }),
                                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                    id: `edit-existing-${modalIdPrefix}-button`,
                                    variant: "primary",
                                    onClick: handleCopyAndEdit,
                                    "aria-label": `Create a copy of the ${title.toLowerCase()} for editing`,
                                    disabled: !selectedId || type === "analysisMethod",
                                    children: "Copy"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: `close-${modalIdPrefix}-picker-button`,
                            variant: "secondary",
                            onClick: ()=>onClose(selectedId),
                            children: "Close"
                        })
                    ]
                })
            ]
        })
    });
};
$64a98e1550e40284$export$72bfa98672dbebf.displayName = "ArsSetWindow";

});

parcelRegister("cQYve", function(module, exports) {

$parcel$export(module.exports, "ARS_SET_TYPES", function () { return $55a196a1b5281b24$export$d3bfaacefda794e2; });
/**
 * Supported ARS set types for the shared picker/window components.
 */ const $55a196a1b5281b24$export$d3bfaacefda794e2 = {
    analysisMethod: {
        value: "analysisMethod",
        selectLabel: "Select analysis method",
        glyphText: "AM"
    },
    analysisSet: {
        value: "analysisSet",
        selectLabel: "Select analysis set",
        glyphText: "AS"
    },
    dataSubset: {
        value: "dataSubset",
        selectLabel: "Select data subset",
        glyphText: "DS"
    },
    groupingFactor: {
        value: "groupingFactor",
        selectLabel: "Select grouping factor",
        glyphText: "GF"
    }
};

});


parcelRegister("9mX8u", function(module, exports) {

$parcel$export(module.exports, "TlfArsPatchSidebar", function () { return $96c9893b977314a1$export$a7e643dcba3a0184; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $61YDR = parcelRequire("61YDR");

var $fwbcv = parcelRequire("fwbcv");

var $spJKX = parcelRequire("spJKX");

var $kP8DJ = parcelRequire("kP8DJ");
var $iPQyT = parcelRequire("iPQyT");

var $HaKWh = parcelRequire("HaKWh");

var $3VtUe = parcelRequire("3VtUe");
const $96c9893b977314a1$export$a7e643dcba3a0184 = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { hierarchyState: hierarchyState } = (0, $3tNrK.useAppSettings)();
    const canManagePatches = hierarchyState.hierarchy?.level !== (0, $4lHS7.eHierarchyLevel).Report;
    const { activeVariantPatchName: activeVariantPatchName, activeVariantPatchInvalidOps: activeVariantPatchInvalidOps, appliedVariantPatches: appliedVariantPatches, dispatch: dispatch, readOnly: readOnly, variantCreationView: variantCreationView } = tlfContext;
    const { master: master, currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(tlfContext);
    const patchGroups = master === null || currentMaster === null ? [] : (0, $fwbcv.groupVariantPatches)(currentMaster).map((patchNames)=>({
            patchNames: patchNames,
            name: (0, $61YDR.getVariantPatchGroupName)(currentMaster, patchNames)
        }));
    (0, $spJKX.useEffect)(()=>{
        if (canManagePatches && !readOnly) dispatch({
            operation: (0, $2Mlm8.TRACK_ACTIVE_VARIANT_PATCH),
            calledFrom: "TlfArsPatchSidebar:trackActivePatch"
        });
    }, [
        activeVariantPatchName,
        appliedVariantPatches,
        canManagePatches,
        dispatch,
        readOnly,
        tlfContext.masterTlfData,
        tlfContext.tlfData
    ]);
    return !canManagePatches ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
                id: "tlf-ars-patches-window",
                title: "Template patches",
                visible: patchGroups.length > 0,
                initialDockEdge: "right",
                style: {
                    width: "360px",
                    maxWidth: "90vw",
                    maxHeight: "80vh"
                },
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
                    className: "p-3 d-flex flex-column gap-2",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                            className: "d-flex flex-wrap gap-2",
                            children: [
                                !readOnly && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                    id: "tlf-create-new-patch",
                                    size: "sm",
                                    variant: "primary",
                                    onClick: ()=>dispatch({
                                            operation: (0, $2Mlm8.SET_CREATE_VARIANT_PATCH_WINDOW),
                                            show: true,
                                            calledFrom: "TlfArsPatchSidebar:openCreatePatch"
                                        }),
                                    children: "Create new patch"
                                }),
                                !readOnly && (variantCreationView || appliedVariantPatches.length > 0) && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                                    id: "tlf-revert-to-master",
                                    size: "sm",
                                    variant: "outline-secondary",
                                    disabled: activeVariantPatchInvalidOps.length > 0,
                                    onClick: ()=>dispatch({
                                            operation: (0, $2Mlm8.REVERT_TO_VARIANT_MASTER),
                                            calledFrom: "TlfArsPatchSidebar:revertToMaster"
                                        }),
                                    children: "Revert to master"
                                })
                            ]
                        }),
                        patchGroups.length === 0 ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "text-muted",
                            children: "No patches have been created"
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "d-flex flex-column gap-2",
                            children: patchGroups.map(({ patchNames: group, name: name })=>/*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                                    role: "group",
                                    "aria-label": name,
                                    className: "d-flex flex-column gap-2 border-bottom pb-2",
                                    children: [
                                        /*#__PURE__*/ (0, $bR5nk.jsx)("h6", {
                                            className: "mb-0 text-break",
                                            children: name
                                        }),
                                        group.map((patchId)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $3VtUe.TlfVariantPatchRow), {
                                                patchId: patchId,
                                                onToggleApplied: (applied)=>dispatch({
                                                        operation: (0, $2Mlm8.TOGGLE_VARIANT_PATCH),
                                                        patchName: patchId,
                                                        applied: applied,
                                                        calledFrom: "TlfArsPatchSidebar:togglePatch"
                                                    }),
                                                onActivate: ()=>dispatch({
                                                        operation: (0, $2Mlm8.ACTIVATE_VARIANT_PATCH),
                                                        patchName: patchId,
                                                        calledFrom: "TlfArsPatchSidebar:activatePatch"
                                                    })
                                            }, patchId))
                                    ]
                                }, group[0]))
                        }),
                        activeVariantPatchInvalidOps.length > 0 && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                            variant: "danger",
                            className: "mb-0",
                            children: [
                                "Patch changes must use remove or replace operations:",
                                " ",
                                activeVariantPatchInvalidOps.map((op)=>`${op.op} ${op.path}`).join(", ")
                            ]
                        })
                    ]
                })
            }),
            !readOnly && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $HaKWh.CreatePatchWindow), {})
        ]
    });
};
$96c9893b977314a1$export$a7e643dcba3a0184.displayName = "TlfArsPatchSidebar";

});
parcelRegister("61YDR", function(module, exports) {

$parcel$export(module.exports, "getVariantPatchGroupName", function () { return $49654470d44d09bf$export$e2df584012cdb311; });

var $eBlbF = parcelRequire("eBlbF");

var $2gZen = parcelRequire("2gZen");
const $49654470d44d09bf$export$e2df584012cdb311 = (information, patchNames)=>{
    const conflicts = (0, $2gZen.findVariantPatchConflicts)(information, patchNames);
    const paths = conflicts.length > 0 ? conflicts.map((conflict)=>conflict.firstPath.split("/").length <= conflict.secondPath.split("/").length ? conflict.firstPath : conflict.secondPath) : patchNames.flatMap((name)=>(information.allVariantPatches[name] ?? []).map((operation)=>operation.path));
    const properties = paths.map((path)=>{
        const tokens = path.split("/").slice(1);
        const property = tokens[0] === "body" ? tokens[1] ?? "body" : tokens[0] ?? "TLF";
        return (0, $eBlbF.startCase)(property.replace(/~1/g, "/").replace(/~0/g, "~"));
    });
    const names = [
        ...new Set(properties)
    ];
    return names.length > 0 ? `${new Intl.ListFormat("en-GB", {
        type: "conjunction"
    }).format(names)} changes` : "No changes";
};

});

parcelRegister("HaKWh", function(module, exports) {

$parcel$export(module.exports, "CreatePatchWindow", function () { return $b8a20ab7a138f926$export$612b880d5fb76402; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");
var $klm8J = parcelRequire("klm8J");
var $8Uc5S = parcelRequire("8Uc5S");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");
const $b8a20ab7a138f926$export$612b880d5fb76402 = ()=>{
    const docking = (0, $5EkSD.useDocking)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const [name, setName] = (0, $spJKX.useState)("");
    const [isValidated, setIsValidated] = (0, $spJKX.useState)(false);
    const { currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(tlfContext);
    const existingNames = Object.keys(currentMaster?.allVariantPatches ?? {});
    const visible = tlfContext.showCreateVariantPatchWindow || tlfContext.variantCreationView && tlfContext.activeVariantPatchName === null;
    const disabledReason = tlfContext.readOnly ? "You do not have permission to edit this TLF" : undefined;
    const options = (0, $spJKX.useMemo)(()=>existingNames.map((value)=>({
                value: value
            })), [
        existingNames
    ]);
    const trimmedName = name.trim();
    const reason = (trimmedName === "" ? "Enter a patch name" : undefined) ?? (existingNames.includes(trimmedName) ? "This patch name already exists" : undefined);
    /**
   * Closes patch creation through the TLF reducer.
   */ const closeWindow = ()=>{
        tlfContext.dispatch({
            operation: (0, $2Mlm8.CANCEL_VARIANT_PATCH_CREATION),
            calledFrom: "CreatePatchWindow:cancel"
        });
    };
    /**
   * Dispatches patch creation and clears the local name-validation input.
   */ const createPatch = ()=>{
        tlfContext.dispatch({
            operation: (0, $2Mlm8.CREATE_VARIANT_PATCH),
            patchName: trimmedName,
            calledFrom: "CreatePatchWindow:create"
        });
        setName("");
        setIsValidated(false);
        // Show the patch window and push it to the top
        docking.showWindowById("tlf-ars-patches-window");
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: "create-ars-patch-window",
        onClose: closeWindow,
        title: "Create new patch",
        visible: visible,
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
            className: "p-3",
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Uc5S.ControlTypeAhead), {
                    id: "create-ars-patch-name",
                    label: "Patch name",
                    labelWidth: 3,
                    value: name,
                    setValue: setName,
                    availableList: options,
                    validCondition: (0, $klm8J.checkName),
                    validationReturn: setIsValidated,
                    placeHolder: "Enter a unique patch name"
                }),
                /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    className: "d-flex justify-content-end gap-2",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: "create-ars-patch-cancel",
                            onClick: closeWindow,
                            variant: "secondary",
                            children: "Cancel"
                        }),
                        disabledReason === undefined && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                            id: "create-ars-patch-confirm",
                            disabled: !isValidated,
                            onClick: createPatch,
                            title: reason,
                            variant: "primary",
                            children: "Create patch"
                        })
                    ]
                })
            ]
        })
    });
};
$b8a20ab7a138f926$export$612b880d5fb76402.displayName = "CreatePatchWindow";

});

parcelRegister("3VtUe", function(module, exports) {

$parcel$export(module.exports, "TlfVariantPatchRow", function () { return $1a24083a30f58376$export$3e9aa882f572002f; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $klm8J = parcelRequire("klm8J");
var $iNEej = parcelRequire("iNEej");
var $i4t1Y = parcelRequire("i4t1Y");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $spJKX = parcelRequire("spJKX");
const $1a24083a30f58376$export$3e9aa882f572002f = ({ patchId: patchId, onToggleApplied: onToggleApplied, onActivate: onActivate })=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { activeVariantPatchName: activeVariantPatchName, appliedVariantPatches: appliedVariantPatches, dispatch: dispatch, readOnly: readOnly } = tlfContext;
    const { currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(tlfContext);
    const patchCatalog = currentMaster?.allVariantPatches ?? {};
    const [isEditingName, setIsEditingName] = (0, $spJKX.useState)(false);
    const [editName, setEditName] = (0, $spJKX.useState)(patchId);
    const [nameValidation, setNameValidation] = (0, $spJKX.useState)({
        name: patchId,
        valid: false
    });
    const nameInputId = `tlf-patch-name-${encodeURIComponent(patchId)}`;
    const nameValue = isEditingName ? editName : patchId;
    const isNameValid = nameValidation.name === nameValue && nameValidation.valid;
    const patchOperations = patchCatalog[patchId] ?? [];
    const applied = appliedVariantPatches.includes(patchId);
    const active = activeVariantPatchName === patchId;
    const rowClassName = active ? "bg-primary-subtle" : applied ? "bg-secondary-subtle" : "";
    const operationTooltip = patchOperations.length === 0 ? "No operations in this patch" : patchOperations.map((operation)=>`${operation.op} ${operation.path}${"value" in operation ? `: ${JSON.stringify(operation.value)}` : ""}`).join("\n");
    (0, $spJKX.useEffect)(()=>{
        const controller = new AbortController();
        (0, $klm8J.checkName)("", {
            value: nameValue.trim(),
            options: {
                existingValues: Object.keys(currentMaster?.allVariantPatches ?? {}).filter((name)=>name !== patchId)
            }
        }, controller).then((result)=>{
            if (!controller.signal.aborted) setNameValidation({
                name: nameValue,
                valid: result.success && result.data.valid
            });
        });
        return ()=>controller.abort();
    }, [
        currentMaster,
        nameValue,
        patchId
    ]);
    /**
   * Saves a changed patch name after the shared inline control commits a validated draft.
   *
   * @param name - Current input value, trimmed before updating the patch catalogue
   */ const saveName = (name)=>{
        if (name !== patchId) dispatch({
            operation: (0, $2Mlm8.RENAME_VARIANT_PATCH),
            patchName: patchId,
            newPatchName: name,
            calledFrom: "TlfVariantPatchRow:renamePatch"
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        className: `rounded p-2 ms-2 border border-primary ${rowClassName}`,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "fw-semibold text-break flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i4t1Y.ControlInlineEdit), {
                            id: nameInputId,
                            "aria-label": "Patch name",
                            className: "fw-semibold",
                            style: {
                                backgroundColor: "transparent"
                            },
                            value: patchId,
                            setValue: saveName,
                            disabled: readOnly,
                            isInvalid: !isNameValid,
                            spellCheck: false,
                            editLabel: "Edit name",
                            deleteLabel: "Remove patch",
                            showEditButtonWhileEditing: true,
                            onDraftChange: setEditName,
                            onEditChange: setIsEditingName,
                            whiteSpaceFix: true,
                            onDelete: ()=>dispatch({
                                    operation: (0, $2Mlm8.REMOVE_VARIANT_PATCH),
                                    patchName: patchId,
                                    calledFrom: "TlfVariantPatchRow:removePatch"
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $bR5nk.jsxs)("span", {
                        className: "small text-muted text-nowrap",
                        tabIndex: 0,
                        "aria-label": `${patchId}: ${patchOperations.length} operations`,
                        title: operationTooltip,
                        children: [
                            patchOperations.length,
                            " ops"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iNEej.Control213), {
                id: `tlf-patch-apply-${encodeURIComponent(patchId)}`,
                label: `Apply ${patchId}`,
                checked: applied,
                disabled: readOnly,
                setChecked: onToggleApplied
            }),
            !readOnly && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iNEej.Control213), {
                id: `tlf-patch-active-${encodeURIComponent(patchId)}`,
                type: "radio",
                name: "tlf-active-patch",
                label: `Edit ${patchId}`,
                checked: active,
                disabled: !applied,
                setChecked: onActivate
            })
        ]
    });
};
$1a24083a30f58376$export$3e9aa882f572002f.displayName = "TlfVariantPatchRow";

});


parcelRegister("3jKY2", function(module, exports) {

$parcel$export(module.exports, "TlfVariantSidebar", function () { return $da532e5e4eab2f0c$export$163e132d7bf84b5d; });

var $bR5nk = parcelRequire("bR5nk");

var $5EkSD = parcelRequire("5EkSD");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $60M0D = parcelRequire("60M0D");

var $4lHS7 = parcelRequire("4lHS7");

var $3JMQg = parcelRequire("3JMQg");

var $2kvJR = parcelRequire("2kvJR");

var $61YDR = parcelRequire("61YDR");

var $fwbcv = parcelRequire("fwbcv");

var $spJKX = parcelRequire("spJKX");

var $cINsr = parcelRequire("cINsr");

var $8dNnr = parcelRequire("8dNnr");
const $da532e5e4eab2f0c$export$163e132d7bf84b5d = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { hierarchyState: hierarchyState } = (0, $3tNrK.useAppSettings)();
    const { currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(tlfContext);
    const level = hierarchyState.hierarchy?.level;
    const report = level === (0, $4lHS7.eHierarchyLevel).Report;
    const readOnly = tlfContext.readOnly;
    const design = !report && !readOnly;
    const templateLevel = level !== undefined && [
        (0, $4lHS7.eHierarchyLevel).Corporate,
        (0, $4lHS7.eHierarchyLevel).TA,
        (0, $4lHS7.eHierarchyLevel).Project
    ].includes(level);
    const appliedPatchKey = JSON.stringify([
        ...tlfContext.appliedVariantPatches
    ].sort());
    const initialName = currentMaster === null ? "" : (0, $2kvJR.getDuplicateVariantName)(currentMaster.variantTemplates, tlfContext.appliedVariantPatches, "") ?? "";
    const [selectedVariant, setSelectedVariant] = (0, $spJKX.useState)({
        masterId: currentMaster?.id ?? null,
        name: initialName
    });
    const [draft, setDraft] = (0, $spJKX.useState)(null);
    const [appliedSelection, setAppliedSelection] = (0, $spJKX.useState)({
        masterId: currentMaster?.id,
        patchKey: appliedPatchKey
    });
    if (appliedSelection.masterId !== currentMaster?.id || appliedSelection.patchKey !== appliedPatchKey) {
        setAppliedSelection({
            masterId: currentMaster?.id,
            patchKey: appliedPatchKey
        });
        setSelectedVariant({
            masterId: currentMaster?.id ?? null,
            name: initialName
        });
        setDraft(null);
    }
    if (currentMaster === null || !tlfContext.variantCreationView && Object.keys(currentMaster.allVariantPatches).length === 0 && currentMaster.variantTemplates.length === 0 || !report && !templateLevel) return null;
    const selectedName = selectedVariant.masterId === currentMaster.id ? selectedVariant.name : initialName;
    const selectedTemplate = currentMaster.variantTemplates.find((template)=>template.name === selectedName);
    const patchNames = draft !== null && draft.masterId === currentMaster.id && draft.template === selectedTemplate ? draft.patchNames : selectedTemplate?.variantPatches ?? tlfContext.appliedVariantPatches;
    const groups = (0, $fwbcv.groupVariantPatches)(currentMaster);
    const baseline = tlfContext.appliedVariantPatches.length === 0 ? (0, $60M0D.toArsTlfSnapshot)(currentMaster) : tlfContext.masterTlfData;
    const compositionValid = baseline !== null && patchNames.every((name)=>Object.hasOwn(currentMaster.allVariantPatches, name)) && groups.every((group)=>group.filter((name)=>patchNames.includes(name)).length <= 1) && (0, $3JMQg.applyVariantPatches)(baseline, currentMaster, patchNames).success;
    const radiosDisabled = readOnly || design && selectedTemplate === undefined;
    /**
   * Replaces the changed group's choice while retaining independent selections.
   *
   * @param group - Mutually exclusive patch names in the changed group
   * @param patchName - Selected patch name, or empty string for None
   */ const selectPatch = (group, patchName)=>{
        const nextNames = patchNames.filter((name)=>!group.includes(name));
        if (patchName !== "") nextNames.push(patchName);
        setDraft({
            masterId: currentMaster.id,
            template: selectedTemplate,
            patchNames: nextNames
        });
        if (design && selectedTemplate !== undefined && (0, $2kvJR.getDuplicateVariantName)(currentMaster.variantTemplates, nextNames, selectedTemplate.name) === undefined) tlfContext.dispatch({
            operation: (0, $2Mlm8.UPSERT_VARIANT_TEMPLATE),
            template: {
                ...selectedTemplate,
                variantPatches: nextNames
            },
            calledFrom: "TlfVariantSidebar:selectPatch"
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $5EkSD.ContextWindow), {
        id: "tlf-variants-window",
        title: "Variants",
        visible: true,
        initialDockEdge: "left",
        style: {
            width: "360px",
            maxWidth: "90vw",
            maxHeight: "80vh"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            className: "p-3 d-flex flex-column gap-3",
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $cINsr.TlfVariantNameSelector), {
                    compositionValid: compositionValid,
                    patchNames: patchNames,
                    selectedName: selectedName,
                    onSelectVariant: (name)=>{
                        setSelectedVariant({
                            masterId: currentMaster.id,
                            name: name
                        });
                        setDraft(null);
                    }
                }),
                groups.map((group, index)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $8dNnr.TlfVariantPatchGroupRadio), {
                        patchNames: group,
                        name: (0, $61YDR.getVariantPatchGroupName)(currentMaster, group),
                        selectedPatchNames: patchNames,
                        disabled: radiosDisabled,
                        warning: !compositionValid && index === 0 ? "Selected patches cannot be applied to this master" : undefined,
                        onSelectPatch: (patchName)=>selectPatch(group, patchName)
                    }, group[0]))
            ]
        })
    });
};
$da532e5e4eab2f0c$export$163e132d7bf84b5d.displayName = "TlfVariantSidebar";

});
parcelRegister("cINsr", function(module, exports) {

$parcel$export(module.exports, "TlfVariantNameSelector", function () { return $eae75f87889c4cfd$export$f0267a680ddf670c; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $klm8J = parcelRequire("klm8J");
var $aUt9N = parcelRequire("aUt9N");
var $i4t1Y = parcelRequire("i4t1Y");
var $8Uc5S = parcelRequire("8Uc5S");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $6RNmK = parcelRequire("6RNmK");

var $2Mlm8 = parcelRequire("2Mlm8");

var $4lHS7 = parcelRequire("4lHS7");

var $2kvJR = parcelRequire("2kvJR");

var $fwbcv = parcelRequire("fwbcv");

var $spJKX = parcelRequire("spJKX");

var $kP8DJ = parcelRequire("kP8DJ");
var $c28Y1 = parcelRequire("c28Y1");

var $gKsnO = parcelRequire("gKsnO");
var $av9bi = parcelRequire("av9bi");
var $dOCtl = parcelRequire("dOCtl");
var $8r65I = parcelRequire("8r65I");

var $enrtP = parcelRequire("enrtP");
const $eae75f87889c4cfd$export$f0267a680ddf670c = ({ compositionValid: compositionValid, onSelectVariant: onSelectVariant, patchNames: patchNames, selectedName: selectedName })=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { hierarchyState: hierarchyState } = (0, $3tNrK.useAppSettings)();
    const { currentMaster: currentMaster } = (0, $6RNmK.getVariantPatchContext)(tlfContext);
    const [namingMode, setNamingMode] = (0, $spJKX.useState)(null);
    const adding = namingMode === "add";
    const renaming = namingMode === "rename";
    const [newName, setNewName] = (0, $spJKX.useState)("");
    const [nameValidated, setNameValidated] = (0, $spJKX.useState)(false);
    if (tlfContext.readOnly && namingMode !== null) setNamingMode(null);
    if (currentMaster === null) return null;
    const design = hierarchyState.hierarchy?.level !== (0, $4lHS7.eHierarchyLevel).Report;
    const selectedTemplate = currentMaster.variantTemplates.find((template)=>template.name === selectedName);
    const duplicateVariantName = !design || selectedTemplate === undefined ? undefined : (0, $2kvJR.getDuplicateVariantName)(currentMaster.variantTemplates, patchNames, selectedTemplate.name);
    const resetToMaster = selectedTemplate === undefined && tlfContext.appliedVariantPatches.length > 0;
    const resetAvailable = resetToMaster;
    const createAvailable = resetToMaster && (0, $2kvJR.getDuplicateVariantName)(currentMaster.variantTemplates, tlfContext.appliedVariantPatches, "") === undefined;
    const selectionApplied = JSON.stringify([
        ...patchNames
    ].sort()) === JSON.stringify([
        ...tlfContext.appliedVariantPatches
    ].sort());
    const action = selectedTemplate === undefined ? design ? createAvailable ? "create" : null : selectionApplied ? null : "apply" : selectionApplied ? null : "apply";
    const actionDisabled = tlfContext.readOnly || !compositionValid || duplicateVariantName !== undefined || tlfContext.activeVariantPatchInvalidOps.length > 0;
    const compositionWarning = !compositionValid && (0, $fwbcv.groupVariantPatches)(currentMaster).length === 0 ? "Selected patches cannot be applied to this master" : undefined;
    const trimmedName = newName.trim();
    const nameInvalid = !nameValidated || trimmedName.length === 0 || currentMaster.variantTemplates.some((template)=>(!renaming || template.name !== selectedTemplate?.name) && template.name.toLowerCase() === trimmedName.toLowerCase());
    /**
   * Confirms a validated name through the owning sidebar.
   *
   * @param name - Candidate variant name from the input
   */ const confirmNaming = async (name)=>{
        const result = await (0, $klm8J.checkName)("", {
            value: name,
            options: {
                existingValues: currentMaster.variantTemplates.filter((template)=>!renaming || template.name !== selectedTemplate?.name).map((template)=>template.name)
            }
        }, new AbortController());
        if (result.success && result.data.valid) {
            if (renaming && selectedTemplate !== undefined) tlfContext.dispatch({
                operation: (0, $2Mlm8.RENAME_VARIANT_TEMPLATE),
                variantName: selectedTemplate.name,
                newVariantName: name.trim(),
                calledFrom: "TlfVariantSidebar:renameVariant"
            });
            else tlfContext.dispatch({
                operation: (0, $2Mlm8.UPSERT_VARIANT_TEMPLATE),
                template: {
                    name: name.trim(),
                    variantPatches: [
                        ...tlfContext.appliedVariantPatches
                    ]
                },
                calledFrom: "TlfVariantSidebar:addVariant"
            });
            onSelectVariant(name.trim());
            setNamingMode(null);
            setNewName("");
            setNameValidated(false);
        }
    };
    /**
   * Cancels naming without changing the selected variant.
   */ const cancelNaming = ()=>{
        setNamingMode(null);
        setNewName("");
        setNameValidated(false);
    };
    /**
   * Activates an unboxed icon from the keyboard.
   *
   * @param event - Keyboard event received by the icon
   * @param action - Command run for Enter or Space
   */ const activateIcon = (event, action)=>{
        if ([
            "Enter",
            " "
        ].includes(event.key)) {
            event.preventDefault();
            action();
        }
    };
    /**
   * Starts renaming a selected definition with its current name as the draft.
   *
   * @param template - Selected definition to prefill in the rename control
   */ const beginRename = (template)=>{
        setNewName(template.name);
        setNameValidated(false);
        setNamingMode("rename");
    };
    /**
   * Removes a definition and notifies the sidebar of the next remaining selection.
   *
   * @param variantName - Selected definition to remove from the current master
   */ const removeVariant = (variantName)=>{
        tlfContext.dispatch({
            operation: (0, $2Mlm8.REMOVE_VARIANT_TEMPLATE),
            variantName: variantName,
            calledFrom: "TlfVariantSidebar:removeVariant"
        });
        onSelectVariant(currentMaster.variantTemplates.find((template)=>template.name !== variantName)?.name ?? "");
    };
    /**
   * Applies the pending composition or restores the master for an unnamed selection.
   *
   * @param revertToMaster - Whether to restore the master instead of applying the pending patches
   */ const applySelection = (revertToMaster)=>{
        if (revertToMaster) tlfContext.dispatch({
            operation: (0, $2Mlm8.REVERT_TO_VARIANT_MASTER),
            calledFrom: "TlfVariantSidebar:apply"
        });
        else tlfContext.dispatch({
            operation: (0, $2Mlm8.APPLY_VARIANT_TEMPLATE),
            patchNames: patchNames,
            calledFrom: "TlfVariantSidebar:apply"
        });
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                className: "d-flex align-items-start gap-2",
                children: [
                    /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        className: "flex-grow-1",
                        style: {
                            minWidth: 0
                        },
                        children: namingMode !== null ? /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8Uc5S.ControlTypeAhead), {
                            id: "tlf-new-variant-name",
                            label: "Variant name",
                            labelWidth: 3,
                            value: newName,
                            setValue: setNewName,
                            availableList: currentMaster.variantTemplates.filter((template)=>!renaming || template.name !== selectedTemplate?.name).map((template)=>({
                                    value: template.name
                                })),
                            validCondition: (0, $klm8J.checkName),
                            validationReturn: setNameValidated,
                            onEnter: (name)=>void confirmNaming(name),
                            onEscape: cancelNaming
                        }) : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aUt9N.Control211), {
                            id: "tlf-variant-name",
                            label: "Variant",
                            labelWidth: 3,
                            value: selectedTemplate?.name ?? "",
                            setValue: onSelectVariant,
                            options: [
                                {
                                    value: "",
                                    label: "No variant"
                                },
                                ...currentMaster.variantTemplates.map((template)=>({
                                        value: template.name,
                                        label: template.name
                                    }))
                            ]
                        })
                    }),
                    !tlfContext.readOnly && (design || action !== null || resetAvailable) && /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        className: "d-flex align-items-center gap-2 mt-1 flex-shrink-0",
                        style: {
                            height: "calc(1.8125rem + 2px)"
                        },
                        children: [
                            namingMode === null && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                children: [
                                    action === "apply" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $enrtP.TlfVariantApplyButton), {
                                        action: "apply",
                                        disabled: actionDisabled,
                                        onApply: ()=>applySelection(false)
                                    }),
                                    resetAvailable && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $enrtP.TlfVariantApplyButton), {
                                        action: "reset",
                                        disabled: actionDisabled,
                                        onApply: ()=>applySelection(true)
                                    }),
                                    design && selectedTemplate !== undefined && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                id: "tlf-rename-variant",
                                                variant: "link",
                                                className: "p-0 text-primary flex-shrink-0",
                                                disabled: tlfContext.readOnly,
                                                "aria-label": "Rename variant",
                                                title: "Rename variant",
                                                onClick: ()=>beginRename(selectedTemplate),
                                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dOCtl.default), {
                                                    size: 16
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c28Y1.default), {
                                                id: "tlf-remove-variant",
                                                variant: "link",
                                                className: "p-0 text-danger flex-shrink-0",
                                                disabled: tlfContext.readOnly,
                                                "aria-label": "Remove variant",
                                                title: "Remove variant",
                                                onClick: ()=>removeVariant(selectedTemplate.name),
                                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $av9bi.default), {
                                                    size: 16
                                                })
                                            })
                                        ]
                                    }),
                                    action === "create" && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $enrtP.TlfVariantApplyButton), {
                                        action: "create",
                                        disabled: actionDisabled,
                                        onApply: ()=>{
                                            setNewName("");
                                            setNameValidated(false);
                                            setNamingMode("add");
                                        }
                                    })
                                ]
                            }),
                            namingMode !== null && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gKsnO.default), {
                                        id: "tlf-add-variant-confirm",
                                        role: "button",
                                        tabIndex: nameInvalid ? -1 : 0,
                                        "aria-disabled": nameInvalid,
                                        size: 16,
                                        className: `${nameInvalid ? "text-muted" : "text-primary"} flex-shrink-0`,
                                        style: {
                                            cursor: nameInvalid ? "not-allowed" : "pointer"
                                        },
                                        "aria-label": "Confirm variant",
                                        title: "Confirm variant",
                                        onClick: ()=>void confirmNaming(newName),
                                        onKeyDown: (event)=>activateIcon(event, ()=>void confirmNaming(newName))
                                    }),
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8r65I.default), {
                                        id: "tlf-add-variant-cancel",
                                        role: "button",
                                        tabIndex: 0,
                                        size: 16,
                                        className: "text-primary flex-shrink-0",
                                        style: {
                                            cursor: "pointer"
                                        },
                                        "aria-label": "Cancel",
                                        title: "Cancel",
                                        onClick: cancelNaming,
                                        onKeyDown: (event)=>activateIcon(event, cancelNaming)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            selectedTemplate !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $i4t1Y.ControlInlineEdit), {
                    id: "tlf-variant-description",
                    "aria-label": "Variant description",
                    placeholder: "Variant description",
                    value: selectedTemplate.description ?? "",
                    disabled: tlfContext.readOnly || !design,
                    editLabel: "Edit description",
                    type: "textarea",
                    rows: 2,
                    allowCarriageReturn: true,
                    setValue: tlfContext.readOnly ? undefined : (description)=>tlfContext.dispatch({
                            operation: (0, $2Mlm8.UPSERT_VARIANT_TEMPLATE),
                            template: {
                                ...selectedTemplate,
                                description: description
                            },
                            calledFrom: "TlfVariantNameSelector:editDescription"
                        })
                }, selectedTemplate.name)
            }),
            !adding && !renaming && duplicateVariantName !== undefined && /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $kP8DJ.default), {
                variant: "warning",
                className: "mt-2 mb-0",
                children: [
                    "This variant has the same patches as ",
                    duplicateVariantName
                ]
            }),
            compositionWarning !== undefined && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                variant: "danger",
                className: "mt-2 mb-0",
                children: compositionWarning
            })
        ]
    });
};
$eae75f87889c4cfd$export$f0267a680ddf670c.displayName = "TlfVariantNameSelector";

});
parcelRegister("gKsnO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c316f581b4a8d91a$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $c316f581b4a8d91a$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $c316f581b4a8d91a$var$_extends() {
    return $c316f581b4a8d91a$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c316f581b4a8d91a$var$_extends.apply(null, arguments);
}
function $c316f581b4a8d91a$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c316f581b4a8d91a$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $c316f581b4a8d91a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $c316f581b4a8d91a$var$Check2 = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $c316f581b4a8d91a$var$_objectWithoutProperties(_ref, $c316f581b4a8d91a$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $c316f581b4a8d91a$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-check2',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"
    }));
});
$c316f581b4a8d91a$var$Check2.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $c316f581b4a8d91a$export$2e2bcd8739ae039 = $c316f581b4a8d91a$var$Check2;

});

parcelRegister("dOCtl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0edc9b00335ddb9$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $a0edc9b00335ddb9$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $a0edc9b00335ddb9$var$_extends() {
    return $a0edc9b00335ddb9$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0edc9b00335ddb9$var$_extends.apply(null, arguments);
}
function $a0edc9b00335ddb9$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a0edc9b00335ddb9$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a0edc9b00335ddb9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a0edc9b00335ddb9$var$Pencil = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $a0edc9b00335ddb9$var$_objectWithoutProperties(_ref, $a0edc9b00335ddb9$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $a0edc9b00335ddb9$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-pencil',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325"
    }));
});
$a0edc9b00335ddb9$var$Pencil.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $a0edc9b00335ddb9$export$2e2bcd8739ae039 = $a0edc9b00335ddb9$var$Pencil;

});

parcelRegister("8r65I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $624591eeb90164b2$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $624591eeb90164b2$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $624591eeb90164b2$var$_extends() {
    return $624591eeb90164b2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $624591eeb90164b2$var$_extends.apply(null, arguments);
}
function $624591eeb90164b2$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $624591eeb90164b2$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $624591eeb90164b2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $624591eeb90164b2$var$XCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $624591eeb90164b2$var$_objectWithoutProperties(_ref, $624591eeb90164b2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $624591eeb90164b2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
    }));
});
$624591eeb90164b2$var$XCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $624591eeb90164b2$export$2e2bcd8739ae039 = $624591eeb90164b2$var$XCircle;

});

parcelRegister("enrtP", function(module, exports) {

$parcel$export(module.exports, "TlfVariantApplyButton", function () { return $45fe79895b2d4e42$export$1515f349075721c; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $ejS45 = parcelRequire("ejS45");
var $dO7sp = parcelRequire("dO7sp");
var $gCZ2V = parcelRequire("gCZ2V");
const $45fe79895b2d4e42$export$1515f349075721c = ({ action: action, disabled: disabled, onApply: onApply })=>{
    const labels = {
        apply: "Apply",
        create: "Create variant",
        reset: "Reset to master"
    };
    const icons = {
        apply: (0, $dO7sp.default),
        create: (0, $gCZ2V.default),
        reset: (0, $ejS45.default)
    };
    const Icon = icons[action];
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
        id: `tlf-variant-${action}`,
        "aria-label": labels[action],
        title: labels[action],
        className: "p-0 d-flex align-items-center",
        style: {
            width: 20,
            height: 20
        },
        variant: "link",
        disabled: disabled,
        onClick: onApply,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)(Icon, {
            size: 16
        })
    });
};
$45fe79895b2d4e42$export$1515f349075721c.displayName = "TlfVariantApplyButton";

});
parcelRegister("ejS45", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6ccc72e3b36e148$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $a6ccc72e3b36e148$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $a6ccc72e3b36e148$var$_extends() {
    return $a6ccc72e3b36e148$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a6ccc72e3b36e148$var$_extends.apply(null, arguments);
}
function $a6ccc72e3b36e148$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a6ccc72e3b36e148$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a6ccc72e3b36e148$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a6ccc72e3b36e148$var$ArrowCounterclockwise = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $a6ccc72e3b36e148$var$_objectWithoutProperties(_ref, $a6ccc72e3b36e148$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $a6ccc72e3b36e148$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-counterclockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466"
    }));
});
$a6ccc72e3b36e148$var$ArrowCounterclockwise.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $a6ccc72e3b36e148$export$2e2bcd8739ae039 = $a6ccc72e3b36e148$var$ArrowCounterclockwise;

});

parcelRegister("dO7sp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0d5baba2cb93d1b$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $a0d5baba2cb93d1b$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $a0d5baba2cb93d1b$var$_extends() {
    return $a0d5baba2cb93d1b$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a0d5baba2cb93d1b$var$_extends.apply(null, arguments);
}
function $a0d5baba2cb93d1b$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $a0d5baba2cb93d1b$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $a0d5baba2cb93d1b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $a0d5baba2cb93d1b$var$PlayCircle = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $a0d5baba2cb93d1b$var$_objectWithoutProperties(_ref, $a0d5baba2cb93d1b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $a0d5baba2cb93d1b$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-play-circle',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445"
    }));
});
$a0d5baba2cb93d1b$var$PlayCircle.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $a0d5baba2cb93d1b$export$2e2bcd8739ae039 = $a0d5baba2cb93d1b$var$PlayCircle;

});



parcelRegister("8dNnr", function(module, exports) {

$parcel$export(module.exports, "TlfVariantPatchGroupRadio", function () { return $4bd82919a6d8f7d4$export$87a79d9e78811b13; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iNEej = parcelRequire("iNEej");

var $kP8DJ = parcelRequire("kP8DJ");
const $4bd82919a6d8f7d4$export$87a79d9e78811b13 = ({ patchNames: patchNames, name: name, selectedPatchNames: selectedPatchNames, disabled: disabled, warning: warning, onSelectPatch: onSelectPatch })=>{
    const groupId = encodeURIComponent(name);
    return /*#__PURE__*/ (0, $bR5nk.jsxs)("fieldset", {
        className: "border-bottom pb-2",
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("legend", {
                className: "fs-6 fw-semibold text-break",
                children: name
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iNEej.Control213), {
                type: "radio",
                id: `variant-none-${groupId}`,
                name: `variant-group-${groupId}`,
                label: "None",
                checked: !patchNames.some((patchName)=>selectedPatchNames.includes(patchName)),
                setChecked: ()=>onSelectPatch(""),
                disabled: disabled,
                labelWidth: 0
            }),
            patchNames.map((patchName)=>/*#__PURE__*/ (0, $bR5nk.jsx)((0, $iNEej.Control213), {
                    type: "radio",
                    id: `variant-patch-${encodeURIComponent(patchName)}`,
                    name: `variant-group-${groupId}`,
                    label: patchName,
                    checked: selectedPatchNames.includes(patchName),
                    setChecked: ()=>onSelectPatch(patchName),
                    disabled: disabled,
                    labelWidth: 0
                }, patchName)),
            warning && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kP8DJ.default), {
                variant: "danger",
                className: "mb-2",
                children: warning
            })
        ]
    });
};
$4bd82919a6d8f7d4$export$87a79d9e78811b13.displayName = "TlfVariantPatchGroupRadio";

});



parcelRegister("4Ys7v", function(module, exports) {

$parcel$export(module.exports, "TlfArsTable", function () { return $952c73a9a7c8e7f9$export$deb136cfa686642b; });

var $bR5nk = parcelRequire("bR5nk");

var $bX0x9 = parcelRequire("bX0x9");
parcelRequire("6jtLO");
var $jKF9Q = parcelRequire("jKF9Q");
var $gwArU = parcelRequire("gwArU");
var $4dL47 = parcelRequire("4dL47");
var $7G3Xj = parcelRequire("7G3Xj");
var $cJd2i = parcelRequire("cJd2i");
var $4hgF7 = parcelRequire("4hgF7");

var $hr2Fn = parcelRequire("hr2Fn");

var $jYQZd = parcelRequire("jYQZd");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $ladMI = parcelRequire("ladMI");

var $3Avah = parcelRequire("3Avah");

var $spJKX = parcelRequire("spJKX");

var $iOTZL = parcelRequire("iOTZL");
var $iPQyT = parcelRequire("iPQyT");
var $31g00 = parcelRequire("31g00");

var $jeRmB = parcelRequire("jeRmB");

var $1JPnm = parcelRequire("1JPnm");

var $9mX8u = parcelRequire("9mX8u");

var $3jKY2 = parcelRequire("3jKY2");
const $952c73a9a7c8e7f9$export$deb136cfa686642b = ()=>{
    // Contexts
    const appSettings = (0, $3tNrK.useAppSettings)();
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const arsContext = (0, $4hgF7.useArsContext)();
    const hierarchyId = appSettings.hierarchyState.hierarchy?.id;
    const primaryHierarchyId = tlfData?.primaryHierarchyId;
    // Derived from contexts
    const body = tlfContext && (0, $3Avah.isTlfItemReadDto)(tlfData) && (0, $gwArU.isArsTableBody)(tlfData.body, (0, $bX0x9.isIEditorV3)) ? tlfData.body : null;
    const disabled = tlfContext.readOnly;
    // Component state items
    const [calculatedTableRows, setCalculatedTableRows] = (0, $spJKX.useState)([]);
    const [requestingCalculation, setRequestingCalculation] = (0, $spJKX.useState)({
        requesting: false,
        error: false
    });
    const [errorText, setErrorText] = (0, $spJKX.useState)(null);
    const getCalculatedRows = (0, $spJKX.useEffectEvent)(async (body)=>{
        const analysisSet = tlfData?.analysisSetId ? arsContext.state.analysisSets[tlfData.analysisSetId] : undefined;
        const dataSubset = body.dataSubsetId && Object.keys(arsContext.state.dataSubsets).includes(body.dataSubsetId) ? arsContext.state.dataSubsets[body.dataSubsetId] : undefined;
        const arsCalculationDto = {
            arsTableBody: body,
            analysisSet: analysisSet,
            dataSubset: dataSubset
        };
        const request = await (0, $4dL47.loadWrapper)((0, $ladMI.getArsTableCalculation), arsCalculationDto, {
            ...requestingCalculation,
            error: false
        }, setRequestingCalculation, appSettings.backEndUrl);
        /* istanbul ignore else */ if (request?.success) {
            arsContext.dispatch({
                operation: (0, $cJd2i.SET_VARIABLES_IN_USE),
                variablesInUse: request.data.variables
            });
            (0, $spJKX.startTransition)(()=>{
                setCalculatedTableRows(request.data.rows);
                setErrorText(null);
            });
        } else if (request?.success === false) (0, $spJKX.startTransition)(()=>setErrorText(request.errorText));
    });
    const checkAnalysisMethod = (0, $spJKX.useEffectEvent)(async (body)=>{
        /* istanbul ignore else */ if (body.analysisMethodId !== arsContext.state.currentSidebar.analysisMethodId) arsContext.dispatch({
            operation: (0, $cJd2i.SET_SIDEBAR_ANALYSIS_METHOD_ID),
            analysisMethodId: body.analysisMethodId
        });
    });
    (0, $spJKX.useEffect)(()=>{
        if (body && !appSettings.saveRequest.requesting && primaryHierarchyId === hierarchyId) {
            getCalculatedRows(body);
            checkAnalysisMethod(body);
        }
    }, [
        body,
        hierarchyId,
        primaryHierarchyId,
        appSettings.saveRequest.requesting
    ]);
    return !tlfContext || !body || primaryHierarchyId !== hierarchyId ? null : /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
        fluid: true,
        style: {
            minHeight: "400px"
        },
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                    className: "d-flex align-items-start flex-row gap-1 py-3",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1JPnm.ArsSetPicker), {
                            type: "analysisSet",
                            itemId: tlfData?.analysisSetId ?? "",
                            disabled: disabled,
                            onChange: (newId)=>{
                                tlfContext.dispatch({
                                    operation: (0, $2Mlm8.UPDATE_TLF),
                                    tlfData: {
                                        analysisSetId: newId
                                    },
                                    calledFrom: "TlfArsTable onChange:AnalysisSet"
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $1JPnm.ArsSetPicker), {
                            type: "dataSubset",
                            itemId: body.dataSubsetId ?? "",
                            disabled: disabled,
                            onChange: (newId)=>{
                                tlfContext.dispatch({
                                    operation: (0, $2Mlm8.UPDATE_TLF),
                                    tlfData: {
                                        body: {
                                            ...body,
                                            dataSubsetId: newId
                                        }
                                    },
                                    calledFrom: "TlfArsTable onChange:DataSubset"
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $7G3Xj.MultipleDatasetCheck), {})
                    ]
                })
            }),
            errorText && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iOTZL.default), {
                    className: "text-danger m-3",
                    children: errorText
                })
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $31g00.default), {
                children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iOTZL.default), {
                    className: "d-flex position-relative",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jeRmB.ArsItemRequestingSpinner), {
                            requestingCalculation: requestingCalculation,
                            requestingLabel: "Recalculating"
                        }),
                        /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "m-auto px-3",
                            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
                                id: "ars-table-comment",
                                activeContext: "TlfItem",
                                wrap: true,
                                iconPosition: {
                                    top: "-16px",
                                    left: "-16px"
                                },
                                commentLabel: "New table comment",
                                children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $jKF9Q.ArsTable), {
                                    arsTableBody: body,
                                    calculatedTableRows: calculatedTableRows,
                                    disabled: disabled,
                                    editorProps: (0, $jYQZd.v3EditorProps),
                                    sidebarStyle: {
                                        paddingBottom: "40px"
                                    },
                                    style: appSettings.defaultTableStyle,
                                    tlfViewMode: tlfContext.tlfViewMode,
                                    updateArsTableBody: (newBody, calculatedTableRows)=>{
                                        setCalculatedTableRows(calculatedTableRows);
                                        tlfContext.dispatch({
                                            operation: (0, $2Mlm8.UPDATE_TLF),
                                            tlfData: {
                                                body: newBody
                                            },
                                            calledFrom: "TlfArsTable onChange"
                                        });
                                    }
                                })
                            })
                        }),
                        !disabled && /*#__PURE__*/ (0, $bR5nk.jsx)((0, $9mX8u.TlfArsPatchSidebar), {}),
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $3jKY2.TlfVariantSidebar), {})
                    ]
                })
            })
        ]
    });
};
$952c73a9a7c8e7f9$export$deb136cfa686642b.displayName = "TlfArsTable";

});
parcelRegister("ladMI", function(module, exports) {

$parcel$export(module.exports, "getArsTableCalculation", function () { return $cf619a022f65c112$export$73a831d39d310941; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $cf619a022f65c112$export$73a831d39d310941 = async (backEndUrl, params, controller)=>{
    try {
        const url = `${backEndUrl}Ars/ArsTableCalculation`;
        const response = await (0, $lCyBC.default).post(url, params, {
            signal: controller.signal
        });
        return {
            success: true,
            data: {
                rows: response.data.rows,
                variables: new Set(response.data.variables)
            }
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Get ARS table calculation failed - please refresh the page and try again", error);
    }
};

});


parcelRegister("ekurq", function(module, exports) {

$parcel$export(module.exports, "TlfUndoButtons", function () { return $ff2b50bb09302c1c$export$b3dce601057c91be; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $ctrWF = parcelRequire("ctrWF");

var $3tNrK = parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2QWCq = parcelRequire("2QWCq");

var $hxOHZ = parcelRequire("hxOHZ");
var $ejS45 = parcelRequire("ejS45");
const $ff2b50bb09302c1c$export$b3dce601057c91be = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const { undoHistory: undoHistory, undoIndex: undoIndex, dispatch: dispatch } = (0, $3tNrK.useAppSettings)();
    return !tlfContext.tlfData || tlfContext.readOnly ? null : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        style: {
            position: "relative",
            width: "100%"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $2QWCq.default), {
            style: {
                position: "absolute",
                top: "-16px",
                right: 0,
                zIndex: 2
            },
            children: [
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                    id: "tlf-undo-button",
                    className: "border border-dark",
                    variant: "warning",
                    size: "sm",
                    "aria-label": "Undo",
                    onClick: ()=>dispatch({
                            operation: (0, $ctrWF.UNDO),
                            calledFrom: "TlfUndoButtons:Undo"
                        }),
                    disabled: undoIndex === 0,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $ejS45.default), {})
                }),
                /*#__PURE__*/ (0, $bR5nk.jsx)((0, $iuDOI.AsyncButton), {
                    id: "tlf-redo-button",
                    className: "border border-dark",
                    variant: "warning",
                    size: "sm",
                    "aria-label": "Redo",
                    onClick: ()=>dispatch({
                            operation: (0, $ctrWF.REDO),
                            calledFrom: "TlfUndoButtons:Redo"
                        }),
                    disabled: undoIndex >= undoHistory.length,
                    children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hxOHZ.default), {})
                })
            ]
        })
    });
};
$ff2b50bb09302c1c$export$b3dce601057c91be.displayName = "TlfUndoButtons";

});
parcelRegister("hxOHZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc5cda614ea32b18$export$2e2bcd8739ae039; });

var $spJKX = parcelRequire("spJKX");

var $fGs19 = parcelRequire("fGs19");
var $cc5cda614ea32b18$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $cc5cda614ea32b18$var$_extends() {
    return $cc5cda614ea32b18$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $cc5cda614ea32b18$var$_extends.apply(null, arguments);
}
function $cc5cda614ea32b18$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $cc5cda614ea32b18$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $cc5cda614ea32b18$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $cc5cda614ea32b18$var$ArrowClockwise = /*#__PURE__*/ (0, $spJKX.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $cc5cda614ea32b18$var$_objectWithoutProperties(_ref, $cc5cda614ea32b18$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("svg", $cc5cda614ea32b18$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-arrow-clockwise',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("path", {
        d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
    }));
});
$cc5cda614ea32b18$var$ArrowClockwise.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($fGs19))).string
};
var $cc5cda614ea32b18$export$2e2bcd8739ae039 = $cc5cda614ea32b18$var$ArrowClockwise;

});


parcelRegister("lwTQ1", function(module, exports) {

$parcel$export(module.exports, "V1Figure", function () { return $200490cddb594aad$export$621458e076b060e; });

var $bR5nk = parcelRequire("bR5nk");
parcelRequire("6jtLO");
var $iuDOI = parcelRequire("iuDOI");

var $hr2Fn = parcelRequire("hr2Fn");
parcelRequire("3tNrK");
var $9Q1dr = parcelRequire("9Q1dr");

var $2Mlm8 = parcelRequire("2Mlm8");

var $spJKX = parcelRequire("spJKX");

var $gm3sK = parcelRequire("gm3sK");

var $8r65I = parcelRequire("8r65I");
const $200490cddb594aad$export$621458e076b060e = ()=>{
    const tlfContext = (0, $9Q1dr.useTlfContext)();
    const tlfData = tlfContext.tlfData;
    const figureData = tlfData && tlfData.body ? tlfData.body : {
        figureString: "",
        coreTrafficLight: "BlankNotEvaluated"
    };
    const [message, setMessage] = (0, $spJKX.useState)([]);
    const [isDragActive, setIsDragActive] = (0, $spJKX.useState)(false);
    const inputRef = (0, $spJKX.useRef)(null);
    const handleFiles = (0, $spJKX.useCallback)(async (files)=>{
        /* istanbul ignore else */ if (tlfContext && !tlfContext.readOnly && files) {
            // Set up check message
            const acceptedFiles = Array.from(files);
            const newMessage = [];
            // Check one image file has been loaded
            if (acceptedFiles.length !== 1) newMessage.push("Only one file can be added.");
            const newImage = acceptedFiles[0];
            if ([
                "image/png",
                "image/jpeg"
            ].indexOf(newImage.type) === -1) newMessage.push("Only PNG and JPG images are accepted.");
            if (newImage.size > 160000) newMessage.push("Image must be 150K or less in size.");
            // Update message here
            setMessage(newMessage);
            // Process if everything is ok
            if (newMessage.length === 0) {
                // Set up to convert to base64
                const fileReader = new FileReader();
                fileReader.onload = (fileLoadedEvent)=>{
                    /* istanbul ignore else */ if (fileLoadedEvent.target) {
                        const base64 = fileLoadedEvent.target.result;
                        /* istanbul ignore else */ if (typeof base64 === "string") tlfContext.dispatch({
                            operation: (0, $2Mlm8.UPDATE_TLF),
                            tlfData: {
                                body: {
                                    figureString: base64,
                                    coreTrafficLight: "BlankNotEvaluated"
                                }
                            },
                            calledFrom: "V1Figure:setFigureData"
                        });
                    }
                };
                // Read image
                fileReader.readAsDataURL(newImage);
            }
        }
    }, [
        tlfContext
    ]);
    return !tlfData ? null : /*#__PURE__*/ (0, $bR5nk.jsx)((0, $hr2Fn.CommentScope), {
        id: `tlf-legacy-figure-${tlfData.id}`,
        activeContext: "TlfItem",
        commentLabel: "New figure comment",
        iconPosition: {
            top: "0",
            left: "24px"
        },
        children: /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
            "aria-label": "Drop JPG or PNG image",
            style: {
                border: "1px blue dashed",
                borderRadius: "10px",
                padding: "1px",
                margin: "1rem",
                height: "603px"
            },
            onDragOver: (e)=>{
                e.preventDefault();
                setIsDragActive(true);
            },
            onDragLeave: ()=>setIsDragActive(false),
            onDrop: (e)=>{
                e.preventDefault();
                setIsDragActive(false);
                handleFiles(e.dataTransfer.files);
            },
            onClick: ()=>inputRef.current?.click(),
            children: [
                !tlfContext.readOnly && /*#__PURE__*/ (0, $bR5nk.jsx)("input", {
                    ref: inputRef,
                    type: "file",
                    id: "dropzoneinput",
                    "aria-label": "Dropzone input for image upload",
                    accept: "image/jpeg,image/png",
                    onChange: (e)=>void handleFiles(e.target.files),
                    style: {
                        display: "none"
                    }
                }),
                figureData.figureString && figureData.figureString.startsWith("data:image") ? /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                    style: {
                        position: "relative"
                    },
                    className: "d-flex justify-content-center",
                    children: [
                        /*#__PURE__*/ (0, $bR5nk.jsx)((0, $gm3sK.default), {
                            src: figureData.figureString,
                            style: {
                                objectFit: "contain",
                                objectPosition: "0%",
                                height: "600px",
                                maxWidth: "100%"
                            }
                        }),
                        !tlfContext.readOnly && /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                            className: "position-absolute",
                            style: {
                                top: "0",
                                right: "0"
                            },
                            children: /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iuDOI.AsyncButton), {
                                id: "tlf-figure-remove-button",
                                "aria-label": "Remove image",
                                variant: "danger",
                                onClick: (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                    tlfContext.dispatch({
                                        operation: (0, $2Mlm8.UPDATE_TLF),
                                        tlfData: {
                                            body: {
                                                figureString: "",
                                                coreTrafficLight: "BlankNotEvaluated"
                                            }
                                        },
                                        calledFrom: "V1Figure:newFigure"
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bR5nk.jsx)((0, $8r65I.default), {}),
                                    " Remove"
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                    style: {
                        height: "600px",
                        position: "relative"
                    },
                    className: "d-flex justify-content-center align-items-center",
                    children: isDragActive ? /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                        children: "Drop the file here ..."
                    }) : /*#__PURE__*/ (0, $bR5nk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                children: "Drag and drop a file here, or click to select file"
                            }),
                            message.map((m, mi)=>/*#__PURE__*/ (0, $bR5nk.jsx)("div", {
                                    children: m
                                }, mi))
                        ]
                    })
                })
            ]
        })
    });
};
$200490cddb594aad$export$621458e076b060e.displayName = "V1Figure";

});


parcelRegister("g5yF4", function(module, exports) {

$parcel$export(module.exports, "TocTree", function () { return $915a63527a562065$export$f75ce8d70daf068e; });

var $bR5nk = parcelRequire("bR5nk");

var $2AsrT = parcelRequire("2AsrT");
parcelRequire("6jtLO");
var $kUTy1 = parcelRequire("kUTy1");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $nmaP3 = parcelRequire("nmaP3");

var $6iYEs = parcelRequire("6iYEs");

var $spJKX = parcelRequire("spJKX");

var $iPQyT = parcelRequire("iPQyT");

var $4Q81F = parcelRequire("4Q81F");

const $915a63527a562065$export$f75ce8d70daf068e = ()=>{
    const location = (0, $4Q81F.useLocation)();
    const params = (0, $4Q81F.useParams)();
    const hierarchyContext = (0, $3tNrK.useHierarchyContext)();
    const hierarchy = hierarchyContext?.hierarchy;
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("toc-tree");
    const { state: state } = (0, $3tNrK.useTocContext)();
    const [filter, setFilter] = (0, $spJKX.useState)("");
    const tocList = (0, $nmaP3.getTreeListFromTocItems)(state.tocItems, filter);
    const selectedId = params.tocNumber ? tocList.find((n)=>n.data === params.tocNumber)?.id : undefined;
    /**
   * Handles selection of a ToC tree node by navigating to its review URL.
   *
   * @param id - The identifier of the selected tree node.
   */ const handleSelect = (id)=>{
        /* istanbul ignore else */ if (hierarchy) {
            const node = tocList.find((n)=>n.id === id);
            /* istanbul ignore else */ if (node?.data) {
                const newUrl = `${(0, $K53Ru.getHierarchyBaseUrl)(hierarchy)}/Review/${node.data}`;
                /* istanbul ignore else */ if (newUrl !== location.pathname) navigate(newUrl);
            }
        }
    };
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $iPQyT.default), {
        id: "toc-tree-container",
        className: "w-100 ml-2 mt-2",
        children: [
            /*#__PURE__*/ (0, $bR5nk.jsx)("h4", {
                className: "text-lg",
                children: "Table of contents"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $kUTy1.Control210), {
                value: filter,
                setValue: setFilter,
                label: "Filter",
                id: "toc-tree-filter",
                labelWidth: "auto"
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $2AsrT.TreeOfNodes), {
                id: "toc-tree",
                nodeList: tocList,
                roots: tocList.filter((n)=>!n.parentId).map((n)=>n.id),
                handleSelect: handleSelect,
                selected: selectedId ? [
                    selectedId
                ] : [],
                nodeHighlight: "rgb(33,35,241)",
                textHighlight: "rgba(33,35,211,0.1)"
            })
        ]
    });
};
$915a63527a562065$export$f75ce8d70daf068e.displayName = "TocTree";

});
parcelRegister("nmaP3", function(module, exports) {

$parcel$export(module.exports, "getTreeListFromTocItems", function () { return $4de91ef0d1414579$export$5dd4be79322012bb; });

var $lp5N7 = parcelRequire("lp5N7");

var $d76ZD = parcelRequire("d76ZD");
const $4de91ef0d1414579$export$5dd4be79322012bb = (tocItems, filter = "")=>{
    let ret = [];
    // Get all sections
    let lastSection = "__NOPE!!__";
    let lastSectionTocNumber = "__NOPE!!__";
    const sections = tocItems.filter((n)=>n instanceof (0, $lp5N7.MosaicTocSectionClass));
    const sectionNodes = sections.sort((a, b)=>(0, $d76ZD.tocSort)(a.tocNumber, b.tocNumber)).map((n)=>{
        const node = {
            id: n.id,
            label: `${n.tocNumber} ${n.tocLabel}`,
            parentId: n.tocNumber.startsWith(lastSectionTocNumber) ? lastSection : undefined,
            data: null
        };
        lastSection = n.id;
        lastSectionTocNumber = n.tocNumber;
        return node;
    });
    // Assign entry to the section that matches the most characters at the start of tocNumber
    const entryNodes = tocItems.filter((n)=>!(n instanceof (0, $lp5N7.MosaicTocSectionClass))).map((n)=>{
        const parentSection = sections.filter((s)=>(n.tocNumber ?? // istanbul ignore next
            "").startsWith(s.tocNumber ?? // istanbul ignore next
            "")).sort((a, b)=>(0, $d76ZD.tocSort)(a.tocNumber ?? // istanbul ignore next
            "", b.tocNumber ?? // istanbul ignore next
            "")).pop();
        const node = {
            id: n.id,
            label: `${n.tocNumber} ${n.tocLabel}`,
            data: n.tocNumber ?? // istanbul ignore next
            "",
            parentId: parentSection ? parentSection.id : undefined
        };
        return node;
    });
    // Filter entries based on the provided filter
    if (filter) {
        const filterLower = filter.toLowerCase();
        const filteredEntries = entryNodes.filter((n)=>n.label.toLowerCase().includes(filterLower));
        // Add sections for the filtered entries recursively for parentIds
        const filteredSections = sectionNodes.filter((s)=>filteredEntries.some((e)=>e.parentId === s.id) || s.label.toLowerCase().includes(filterLower));
        while(filteredSections.some((s)=>s.parentId && !filteredSections.map((fs)=>fs.id).includes(s.parentId))){
            const missingNodes = sectionNodes.filter((s)=>filteredSections.map((fs)=>fs.parentId).includes(s.id));
            filteredSections.push(...missingNodes);
        }
        // Combine filtered sections and entries
        ret = [
            ...filteredSections,
            ...filteredEntries
        ];
    } else ret = [
        ...sectionNodes,
        ...entryNodes
    ];
    return ret.sort((a, b)=>{
        return (0, $d76ZD.tocSort)(a.label.split(" ")[0], b.label.split(" ")[0]);
    });
};

});


parcelRegister("40ZPd", function(module, exports) {

$parcel$export(module.exports, "HierarchyContextProvider", function () { return $4aa5cc3793e45c81$export$c7a55eb27c9fa62a; });

var $bR5nk = parcelRequire("bR5nk");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");

var $3tNrK = parcelRequire("3tNrK");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $11RML = parcelRequire("11RML");
const $4aa5cc3793e45c81$export$c7a55eb27c9fa62a = ({ children: children })=>{
    const { hierarchyState: state, dispatch: dispatch } = (0, $3tNrK.useAppSettings)();
    const hierarchyLoaderData = (0, $4Q81F.useLoaderData)();
    const { setCurrentBaseUrl: setCurrentBaseUrl } = (0, $11RML.useHierarchyEffects)({
        clinicalLibraryPromise: hierarchyLoaderData?.clinicalLibraryPromise
    });
    /**
   * Add loader data into context
   * Check if the loader data is valid and if the hierarchy has changed
   */ (0, $spJKX.useEffect)(()=>{
        if (hierarchyLoaderData && hierarchyLoaderData.hierarchy && hierarchyLoaderData.accessRights && hierarchyLoaderData.parentHierarchies && // Reload if the Hierarchy is changed even if the name change is not saved
        (!state.isNameChanged || !state.hierarchy || state.hierarchy.id !== hierarchyLoaderData.hierarchy.id) && (!state.hierarchy || (0, $K53Ru.getHierarchyBaseUrl)(state.hierarchy) !== (0, $K53Ru.getHierarchyBaseUrl)(hierarchyLoaderData.hierarchy))) {
            dispatch({
                operation: (0, $0eakK.LOAD_HIERARCHY),
                hierarchy: hierarchyLoaderData.hierarchy,
                hierarchyNodes: hierarchyLoaderData.parentHierarchies,
                accessRights: hierarchyLoaderData.accessRights,
                isSubscribed: hierarchyLoaderData.isHierarchySubscribed
            });
            setCurrentBaseUrl((0, $K53Ru.getHierarchyBaseUrl)(hierarchyLoaderData.hierarchy));
        }
    }, [
        dispatch,
        hierarchyLoaderData,
        setCurrentBaseUrl,
        state.hierarchy,
        state.id,
        state.isNameChanged
    ]);
    return /*#__PURE__*/ (0, $bR5nk.jsx)("div", {
        id: "hierarchyContextProvider",
        style: {
            position: "relative",
            width: "100%",
            height: "100%"
        },
        children: children
    });
};
$4aa5cc3793e45c81$export$c7a55eb27c9fa62a.displayName = "HierarchyContextProvider";

});
parcelRegister("11RML", function(module, exports) {

$parcel$export(module.exports, "useHierarchyEffects", function () { return $3b1f86519c5eac73$export$a403c608a5c01552; });

var $h9eE2 = parcelRequire("h9eE2");
parcelRequire("6jtLO");
var $4dL47 = parcelRequire("4dL47");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $0hyY4 = parcelRequire("0hyY4");

var $hnK3q = parcelRequire("hnK3q");

var $kZ50A = parcelRequire("kZ50A");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $3degO = parcelRequire("3degO");

var $3tNrK = parcelRequire("3tNrK");

var $irvto = parcelRequire("irvto");

var $f2M6x = parcelRequire("f2M6x");

var $aY7pP = parcelRequire("aY7pP");

var $4DmML = parcelRequire("4DmML");

var $b7a1u = parcelRequire("b7a1u");

var $K53Ru = parcelRequire("K53Ru");

var $0eakK = parcelRequire("0eakK");

var $cBxZT = parcelRequire("cBxZT");
const $3b1f86519c5eac73$export$a403c608a5c01552 = ({ clinicalLibraryPromise: clinicalLibraryPromise })=>{
    const { state: appSettings, dispatch: dispatch } = (0, $spJKX.useContext)((0, $3tNrK.AppSettingsContext));
    const state = appSettings.hierarchyState;
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const { navigateAfterSave: navigateAfterSave, registerUnsavedChanges: registerUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("hierarchy-context-provider");
    (0, $cBxZT.useClinicalLibraryLoaderEffect)({
        clinicalLibraryPromise: clinicalLibraryPromise,
        dispatch: dispatch
    });
    const saveRequestStatus = state.saveRequestStatus;
    const saveTocRequestStatus = state.saveTocRequestStatus;
    const setSaveTocRequestStatus = (0, $spJKX.useCallback)((status)=>dispatch({
            operation: (0, $0eakK.SET_HIERARCHY_SAVE_TOC_REQUEST_STATUS),
            saveTocRequestStatus: status
        }), [
        dispatch
    ]);
    const [, startTransition] = (0, $spJKX.useTransition)();
    const tocState = appSettings.tocState;
    const { saveRequest: saveRequest, saveTocItems: saveTocItems } = (0, $3degO.useSave)();
    const setTocRequestStatus = (0, $spJKX.useCallback)((status)=>dispatch({
            operation: (0, $f2M6x.SET_TOC_REQUEST_STATUS),
            tocRequestStatus: status
        }), [
        dispatch
    ]);
    // Messages already processed or sent by this client, used to de-duplicate SignalR echoes
    const [receivedMessages, setReceivedMessages] = (0, $spJKX.useState)([]);
    const currentBaseUrlRef = (0, $spJKX.useRef)("");
    /**
   * Update the tracked current base URL used to detect hierarchy/report navigation after a save.
   * Called by {@link HierarchyContextProvider} when new loader data is applied.
   *
   * @param baseUrl - The base URL of the hierarchy currently loaded into context
   */ const setCurrentBaseUrl = (0, $spJKX.useCallback)((baseUrl)=>{
        currentBaseUrlRef.current = baseUrl;
    }, []);
    /**
   * Send a SignalR update to the group when the hierarchyId is changed because of a save major version
   * @param oldHierarchyId Old hierarchy ID
   * @param newHierarchy New hierarchy data
   */ const sendSignalRHierarchyUpdate = (0, $spJKX.useCallback)(async (oldHierarchyId, newHierarchy)=>{
        if (signalR && signalR.connection?.state === (0, $h9eE2.HubConnectionState).Connected) signalR.sendTocSaveToGroup({
            oldHierarchyId: oldHierarchyId,
            newHierarchy: newHierarchy
        }, `toc${oldHierarchyId}`);
    }, [
        signalR
    ]);
    /**
   * Save the current hierarchy as a new major version
   * This will send a SignalR update to the group to indicate that the hierarchyId has changed
   * TODL: Move this to useSave
   * @param saveTocDescription Description for the save
   */ const saveTocMajor = (0, $spJKX.useEffectEvent)(async (saveTocDescription)=>{
        /* istanbul ignore else */ if (state.hierarchy) {
            const updateDto = (0, $hnK3q.toHierarchyUpdateDto)(state.hierarchy);
            const response = await (0, $4dL47.loadWrapper)((0, $0hyY4.saveTocAsMajorVersion), {
                hierarchy: updateDto,
                hierarchyId: updateDto.id,
                parentTag: updateDto.parentTag,
                saveTocDescription: saveTocDescription
            }, {
                ...saveTocRequestStatus,
                error: false,
                requestedId: undefined,
                errorText: undefined
            }, setSaveTocRequestStatus, appSettings.backEndUrl);
            /* istanbul ignore else */ if (response?.success) {
                dispatch({
                    operation: (0, $0eakK.SAVE_HIERARCHY_COMPLETED),
                    hierarchy: {
                        ...response.data,
                        clinicalLibrary: state.hierarchy.clinicalLibrary
                    },
                    oldHierarchyId: state.hierarchy.id
                });
                // Always send signalR update
                await sendSignalRHierarchyUpdate(state.hierarchy.id, response.data);
                /* istanbul ignore else */ if (response.data.id !== state.hierarchy.id) {
                    const newBaseUrl = (0, $K53Ru.getHierarchyBaseUrl)(response.data);
                    currentBaseUrlRef.current = newBaseUrl;
                    navigateAfterSave(newBaseUrl);
                }
            } else if (response?.success === false) {
                console.warn(`Save failed for hierarchy: ${saveRequestStatus.errorText}`);
                dispatch({
                    operation: (0, $0eakK.SAVE_HIERARCHY_FAILED)
                });
            }
        }
    });
    /**
   * Effect to save the ToC as a major version when the state.doTocSave is true
   */ (0, $spJKX.useEffect)(()=>{
        if (state.doTocSave && !saveTocRequestStatus.requesting && state.saveTocDescription) saveTocMajor(state.saveTocDescription);
    }, [
        saveTocRequestStatus.requesting,
        state.doTocSave,
        state.saveTocDescription
    ]);
    /**
   * Join signalR group for the hierarchy
   * This is done to receive comment updates for the hierarchy
   */ const [sendGroupRequest, setSendGroupRequest] = (0, $spJKX.useState)("\u2744\uFE0F");
    (0, $spJKX.useEffect)(()=>{
        if (signalR && signalR.connection?.state === (0, $h9eE2.HubConnectionState).Connected && state.hierarchy && sendGroupRequest !== `hie${state.hierarchy.id}`) {
            signalR.connectToGroup(`hie${state.hierarchy.id}`);
            startTransition(()=>{
                setSendGroupRequest(`hie${state.hierarchy.id}`);
            });
        }
    }, [
        sendGroupRequest,
        signalR,
        signalR?.connection?.state,
        state.hierarchy
    ]);
    // ToC SignalR group, based on the current hierarchy
    const tocSignalRGroup = state.hierarchy ? `toc${state.hierarchy.id}` : null;
    /**
   * Load ToC view mode filter from localStorage on initialisation
   */ (0, $spJKX.useEffect)(()=>{
        const savedFilter = (0, $b7a1u.loadTocTlfItemFilterFromStorage)();
        if (!(0, $eBlbF.isEqual)(savedFilter, tocState.showTypes)) dispatch({
            operation: (0, $f2M6x.SET_TYPE_FILTER),
            showTypes: savedFilter
        });
    }, [
        dispatch,
        tocState.showTypes
    ]);
    /**
   * Join signalR group for the ToC
   * This is done to receive tocSave and tocUpdate messages
   */ const [tocSendGroupRequest, setTocSendGroupRequest] = (0, $spJKX.useState)("\u2744\uFE0F");
    (0, $spJKX.useEffect)(()=>{
        if (signalR && signalR.connection?.state === (0, $h9eE2.HubConnectionState).Connected && tocSignalRGroup && tocSendGroupRequest !== tocSignalRGroup) {
            signalR.connectToGroup(tocSignalRGroup);
            startTransition(()=>{
                setTocSendGroupRequest(tocSignalRGroup);
            });
        }
    }, [
        tocSendGroupRequest,
        signalR,
        tocSignalRGroup,
        signalR?.connection?.state
    ]);
    const saveTocItemsAndTrackMessage = (0, $spJKX.useEffectEvent)(async (items)=>{
        const sentMessage = await saveTocItems(items);
        if (sentMessage) setReceivedMessages((messages)=>[
                ...messages,
                sentMessage
            ]);
    });
    /**
   * Save effect for ToC items
   */ (0, $spJKX.useEffect)(()=>{
        if (tocState.saving && !saveRequest.requesting && state.hierarchy) {
            const tocItemsToUpdate = {
                hierarchyId: tocState.hierarchyId,
                items: tocState.tocItems.filter((i)=>i.changed).map((n)=>({
                        tocId: n.id,
                        tocNumber: n.tocNumber ?? // istanbul ignore next
                        "",
                        tocLabel: n.tocLabel ?? // istanbul ignore next
                        "",
                        tlfType: n.type,
                        order: n.tocOrder ?? // istanbul ignore next
                        0
                    })),
                deletedItemId: tocState.removedItems?.findLast((i)=>i.changed)?.id
            };
            startTransition(()=>{
                saveTocItemsAndTrackMessage(tocItemsToUpdate);
            });
        }
    }, [
        state.hierarchy,
        saveRequest.requesting,
        tocState.hierarchyId,
        tocState.removedItems,
        tocState.saving,
        tocState.tocItems
    ]);
    /**
   * Send update to get the current hierarchy version
   */ (0, $spJKX.useEffect)(()=>{
        if (tocState.blocked === "getNewVersion" && !saveRequest.requesting && state.hierarchy) {
            const tocItemsToUpdate = {
                hierarchyId: tocState.hierarchyId,
                items: []
            };
            startTransition(()=>{
                saveTocItemsAndTrackMessage(tocItemsToUpdate);
            });
        }
    }, [
        state.hierarchy,
        saveRequest.requesting,
        tocState.blocked,
        tocState.hierarchyId
    ]);
    /**
   * Initial load of ToC items
   */ (0, $spJKX.useEffect)(()=>{
        if (state.hierarchy && state.hierarchy.level === (0, $4lHS7.eHierarchyLevel).Report) // Check if there are zero items loaded
        {
            if (tocState.tocItems.length === 0 || tocState.hierarchyId !== state.hierarchy.id) (0, $4DmML.refreshToc)(tocState.tocRequestStatus, setTocRequestStatus, appSettings.backEndUrl, state.hierarchy, dispatch, false);
        }
    }, [
        appSettings.backEndUrl,
        dispatch,
        setTocRequestStatus,
        state.hierarchy,
        tocState.hierarchyId,
        tocState.tocItems.length,
        tocState.tocRequestStatus
    ]);
    /**
   * Create the combined hierarchy/ToC signalR group listener
   */ (0, $spJKX.useEffect)(()=>{
        /**
     * Handle incoming SignalR group messages for both hierarchy and ToC updates.
     *
     * @param message - Raw JSON string containing the group message payload.
     */ const processSignalRMessage = (message)=>{
            const groupUpdate = JSON.parse(message);
            // Hierarchy comment updates
            if (groupUpdate.groupName === `hie${state.hierarchy?.id}` && groupUpdate.displayName !== signalR?.connection?.connectionId && groupUpdate.displayName !== "Backend" && groupUpdate.text && state.hierarchy?.comments) switch(groupUpdate.messageType){
                case "deleteComment":
                    try {
                        const hieDelCommentId = JSON.parse(groupUpdate.text[0]).id;
                        /* istanbul ignore else */ if (hieDelCommentId) dispatch({
                            operation: (0, $0eakK.REMOVE_HIERARCHY_COMMENT),
                            commentId: hieDelCommentId
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing delete comment update:", error);
                    }
                    break;
                case "comment":
                    try {
                        const hieUpdateMessage = JSON.parse(groupUpdate.text[0]);
                        /* istanbul ignore else */ if (hieUpdateMessage) dispatch({
                            operation: (0, $0eakK.UPDATE_HIERARCHY_COMMENT),
                            comment: hieUpdateMessage
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing comment update:", error);
                    }
                    break;
                case "commentsPatch":
                    try {
                        const commentsPatch = JSON.parse(groupUpdate.text[0]);
                        /* istanbul ignore else */ if (commentsPatch) dispatch({
                            operation: (0, $0eakK.PATCH_HIERARCHY_COMMENTS),
                            patch: commentsPatch
                        });
                    } catch (error) {
                        // istanbul ignore next
                        console.warn("Error processing comments patch update:", error);
                    }
                    break;
            }
            // ToC updates
            const tocItemsToUpdate = groupUpdate.text && groupUpdate.text[0].startsWith("{") ? JSON.parse(groupUpdate.text[0]) : undefined;
            if (groupUpdate.messageType === "tooBig" && groupUpdate.displayName !== signalR?.connection?.connectionId) {
                dispatch({
                    operation: (0, $f2M6x.SHOW_TOC_NEED_REFRESH)
                });
                return;
            }
            if (state.hierarchy && groupUpdate.displayName !== signalR?.connection?.connectionId && groupUpdate.displayName !== "Backend" && [
                "tocUpdate",
                "tocSave"
            ].includes(groupUpdate.messageType) && tocItemsToUpdate && !receivedMessages.find((r)=>r.messageId === groupUpdate.messageId)) {
                // Update processing
                const newAction = (0, $aY7pP.processActionFromSignal)(groupUpdate.messageId, tocItemsToUpdate);
                setReceivedMessages([
                    ...receivedMessages,
                    newAction.receivedMessage
                ]);
                /* istanbul ignore else */ if (tocItemsToUpdate.hierarchy.id === state.hierarchy.id && groupUpdate.messageType === "tocUpdate") {
                    dispatch(newAction);
                    dispatch({
                        operation: (0, $f2M6x.SAVE_SUCCESS),
                        saveTimeStamp: Date.now()
                    });
                    dispatch({
                        operation: (0, $0eakK.SAVE_HIERARCHY_COMPLETED),
                        hierarchy: tocItemsToUpdate.hierarchy
                    });
                } else if (tocItemsToUpdate.hierarchy.id !== state.hierarchy.id && groupUpdate.messageType === "tocSave") {
                    dispatch({
                        operation: (0, $f2M6x.SHOW_TOC_SAVE_ALERT),
                        tocIdFromMessage: tocItemsToUpdate.hierarchy.id
                    });
                    dispatch({
                        operation: (0, $0eakK.SET_HIERARCHY_ID),
                        hierarchyId: tocItemsToUpdate.hierarchy.id
                    });
                }
            }
        };
        signalR?.connection?.on("SendMessageToGroup", processSignalRMessage);
    // return () => {
    //   signalR?.connection?.off("SendMessageToGroup", processSignalRMessage);
    // };
    }, [
        dispatch,
        receivedMessages,
        signalR?.connection,
        state.hierarchy
    ]);
    /**
   * Page title based on hierarchy state
   */ const title = state.hierarchy ? `${state.hierarchy.name}` : `Loading hierarchy... ${state.id}`;
    (0, $kZ50A.useDocumentTitle)(title);
    /**
   * Effect to register unsaved changes when the hierarchy state changes
   */ (0, $spJKX.useEffect)(()=>{
        registerUnsavedChanges("Hierarchy", state.changed);
    }, [
        registerUnsavedChanges,
        state.changed
    ]);
    return {
        title: title,
        saveRequestStatus: saveRequestStatus,
        saveTocRequestStatus: saveTocRequestStatus,
        setCurrentBaseUrl: setCurrentBaseUrl
    };
};

});
parcelRegister("0hyY4", function(module, exports) {

$parcel$export(module.exports, "saveTocAsMajorVersion", function () { return $72e282c53060f3c9$export$77a8386cbfe89eba; });
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $4xeqQ = parcelRequire("4xeqQ");
const $72e282c53060f3c9$export$77a8386cbfe89eba = async (backEndUrl, update, controller)=>{
    // Send data
    try {
        const url = `${backEndUrl}Reports/${update.hierarchyId}/SaveTocAsMajorVersion?parentTag=${update.parentTag}`;
        const data = {
            description: update.saveTocDescription,
            hierarchy: update.hierarchy
        };
        const response = await (0, $lCyBC.default).put(url, data, controller ? {
            signal: controller.signal
        } : undefined);
        // Return successful result
        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return (0, $4xeqQ.processAxiosError)("Save failed", error);
    }
};

});

parcelRegister("aY7pP", function(module, exports) {

$parcel$export(module.exports, "processActionFromSignal", function () { return $7dbdabfe0b22e267$export$61c43e37ca87fe32; });

var $f2M6x = parcelRequire("f2M6x");
const $7dbdabfe0b22e267$export$61c43e37ca87fe32 = (messageId, actionSignal)=>{
    const updatedIds = [
        actionSignal.deletedItemId,
        ...actionSignal.items.map((x)=>x.id)
    ].filter((x)=>x !== undefined);
    return {
        operation: (0, $f2M6x.FROM_SIGNALR),
        items: actionSignal.items,
        deletedItemId: actionSignal.deletedItemId,
        receivedMessage: {
            messageId: messageId,
            updateTS: new Date(),
            updatedIds: updatedIds
        }
    };
};

});

parcelRegister("b7a1u", function(module, exports) {

$parcel$export(module.exports, "TOC_TLF_ITEM_FILTER", function () { return $c9b1abc250a410cb$export$6c1a7d5fdedfef9c; });
$parcel$export(module.exports, "loadTocTlfItemFilterFromStorage", function () { return $c9b1abc250a410cb$export$2290e9bbd395f9c8; });
$parcel$export(module.exports, "saveTocTlfItemFilterToStorage", function () { return $c9b1abc250a410cb$export$6d1b83c60218a085; });

var $4lHS7 = parcelRequire("4lHS7");
const $c9b1abc250a410cb$export$6c1a7d5fdedfef9c = [
    {
        type: (0, $4lHS7.eTlfItemType).arsTable,
        label: "ARS tables",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).arsListing,
        label: "ARS listings",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).figure,
        label: "Interactive figures",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).table,
        label: "Tables",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).listing,
        label: "Listings",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).v1figure,
        label: "Legacy figures",
        show: true
    },
    {
        type: (0, $4lHS7.eTlfItemType).section,
        label: "Sections",
        show: true
    }
];
// Helper functions for localStorage
const $c9b1abc250a410cb$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY = "tocTlfItemFilter";
const $c9b1abc250a410cb$export$2290e9bbd395f9c8 = ()=>{
    const stored = localStorage.getItem($c9b1abc250a410cb$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY);
    // Use stored as a filter if it exists
    if (stored) {
        const storedTypes = stored.split(",");
        return storedTypes;
    }
    // Default to all shown
    return $c9b1abc250a410cb$export$6c1a7d5fdedfef9c.filter((i)=>i.show).map((i)=>i.type);
};
const $c9b1abc250a410cb$export$6d1b83c60218a085 = (filter)=>{
    try {
        localStorage.setItem($c9b1abc250a410cb$var$TOC_TLF_ITEM_FILTER_STORAGE_KEY, filter.join(","));
    } catch  {
    // Ignore localStorage errors
    }
};

});

parcelRegister("cBxZT", function(module, exports) {

$parcel$export(module.exports, "useClinicalLibraryLoaderEffect", function () { return $1896ffe798a7c6f6$export$f4c78e9aab663b0e; });

var $spJKX = parcelRequire("spJKX");

var $0eakK = parcelRequire("0eakK");
const $1896ffe798a7c6f6$export$f4c78e9aab663b0e = ({ clinicalLibraryPromise: clinicalLibraryPromise, dispatch: dispatch })=>{
    (0, $spJKX.useEffect)(()=>{
        let isActive = true;
        if (!clinicalLibraryPromise) {
            dispatch({
                operation: (0, $0eakK.SET_CLINICAL_LIBRARY_LOADING),
                isClinicalLibraryLoading: false
            });
            return;
        }
        // The loader has started the deferred CL request,
        // so show the loading state until it completes.
        dispatch({
            operation: (0, $0eakK.SET_CLINICAL_LIBRARY_LOADING),
            isClinicalLibraryLoading: true
        });
        clinicalLibraryPromise.then((response)=>{
            if (isActive) {
                if (response.success) {
                    dispatch({
                        operation: (0, $0eakK.LOAD_CLINICAL_LIBRARY),
                        clinicalLibrary: response.data
                    });
                    return;
                }
                dispatch({
                    operation: (0, $0eakK.SET_CLINICAL_LIBRARY_LOADING),
                    isClinicalLibraryLoading: false
                });
            }
        }).catch((error)=>{
            /* istanbul ignore next */ if (isActive) {
                console.warn("Clinical Library loading failed:", error);
                dispatch({
                    operation: (0, $0eakK.SET_CLINICAL_LIBRARY_LOADING),
                    isClinicalLibraryLoading: false
                });
            }
        });
        return ()=>{
            isActive = false;
        };
    }, [
        clinicalLibraryPromise,
        dispatch
    ]);
};

});



parcelRegister("7VqtI", function(module, exports) {

$parcel$export(module.exports, "TlfContextProvider", function () { return $59af68cdbaa41b8f$export$680e0d87d8e0479e; });

var $bR5nk = parcelRequire("bR5nk");

var $4HknJ = parcelRequire("4HknJ");
const $59af68cdbaa41b8f$export$680e0d87d8e0479e = ({ children: children, readOnly: readOnly = false })=>{
    (0, $4HknJ.useTlfEffects)(readOnly);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children
    });
};
$59af68cdbaa41b8f$export$680e0d87d8e0479e.displayName = "TlfContextProvider";

});
parcelRegister("4HknJ", function(module, exports) {

$parcel$export(module.exports, "useTlfEffects", function () { return $e3be42e250586e31$export$197746ee55933210; });

var $h9eE2 = parcelRequire("h9eE2");

var $6iYEs = parcelRequire("6iYEs");

var $4lHS7 = parcelRequire("4lHS7");

var $eBlbF = parcelRequire("eBlbF");

var $spJKX = parcelRequire("spJKX");

var $4Q81F = parcelRequire("4Q81F");

var $3tNrK = parcelRequire("3tNrK");

var $irvto = parcelRequire("irvto");

var $4CKH9 = parcelRequire("4CKH9");

var $2Mlm8 = parcelRequire("2Mlm8");

var $ie0LA = parcelRequire("ie0LA");
const $e3be42e250586e31$export$197746ee55933210 = (readOnly = false)=>{
    const loaderData = (0, $4Q81F.useLoaderData)();
    const tlfData = loaderData?.tlfItem;
    const isSubscribed = loaderData?.isTlfSubscribed ?? false;
    const isTlfNew = loaderData?.isTlfNew ?? false;
    const [searchParams] = (0, $4Q81F.useSearchParams)();
    const { tlfState: tlfState, hierarchyState: hierarchyState, dispatch: dispatch } = (0, $3tNrK.useAppSettings)();
    const hierarchy = hierarchyState.hierarchy;
    const signalR = (0, $spJKX.useContext)((0, $irvto.SignalRContext));
    const { navigate: navigate, registerUnsavedChanges: registerUnsavedChanges } = (0, $6iYEs.useUnsavedChanges)("tlf-context");
    (0, $spJKX.useEffect)(()=>{
        const savedViewMode = (0, $ie0LA.loadTlfViewModeFromStorage)();
        if (savedViewMode.value !== tlfState.tlfViewMode?.value) dispatch({
            operation: (0, $2Mlm8.SET_VIEW_MODE),
            calledFrom: "useTlfEffects:InitializeViewMode",
            tlfViewMode: savedViewMode
        });
    }, [
        dispatch,
        tlfState.tlfViewMode?.value
    ]);
    (0, $spJKX.useEffect)(()=>{
        // Route effects run only when loader data differs from the current TLF state.
        /* istanbul ignore else */ if (tlfData && !(0, $eBlbF.isEqual)(tlfData, tlfState.tlfData)) /* istanbul ignore else */ {
            if (tlfData.id !== tlfState.tlfData?.id || !tlfState.changed && !tlfState.forcePushToParent && !(0, $eBlbF.isEqual)(tlfData, tlfState.savedTlfData)) dispatch({
                operation: (0, $2Mlm8.LOAD_TLF),
                calledFrom: "useTlfEffects:Initial",
                tlfData: tlfData,
                isSubscribed: isSubscribed,
                isTlfNew: isTlfNew,
                readOnly: readOnly
            });
        }
    }, [
        dispatch,
        isSubscribed,
        isTlfNew,
        readOnly,
        tlfState,
        tlfData
    ]);
    (0, $spJKX.useEffect)(()=>{
        if (tlfState.readOnly !== readOnly) dispatch({
            operation: (0, $2Mlm8.SET_TLF_READ_ONLY),
            calledFrom: "useTlfEffects:ReadOnly",
            readOnly: readOnly
        });
    }, [
        dispatch,
        readOnly,
        tlfState.readOnly
    ]);
    const signalRGroup = (0, $spJKX.useMemo)(()=>tlfState.tlfData ? `tlf${tlfState.tlfData.id}` : null, [
        tlfState.tlfData
    ]);
    const [lastSignalRGroupRequest, setLastSignalRGroupRequest] = (0, $spJKX.useState)("");
    const sendGroupRequest = (0, $spJKX.useEffectEvent)(async (group)=>{
        signalR?.connectToGroup(group);
        (0, $spJKX.startTransition)(()=>setLastSignalRGroupRequest(group));
    });
    (0, $spJKX.useEffect)(()=>{
        // SignalR group requests are made only after the provider reports a connected group.
        /* istanbul ignore else */ if (signalR?.connection?.state === (0, $h9eE2.HubConnectionState).Connected && signalRGroup && lastSignalRGroupRequest !== signalRGroup) sendGroupRequest(signalRGroup);
    }, [
        lastSignalRGroupRequest,
        signalR?.connection?.state,
        signalRGroup
    ]);
    (0, $spJKX.useEffect)(()=>{
        /* istanbul ignore else */ if (hierarchy && tlfState.tlfData && searchParams.has("searchText") && searchParams.has("blocksToSearch")) {
            const searchText = searchParams.get("searchText");
            const blocksToSearch = searchParams.getAll("blocksToSearch").filter((label)=>Object.values((0, $4lHS7.SearchableEditorBlocks)).includes(label)).map((label)=>label);
            const editorBlocksSearchPanelStatus = {
                searchText: searchText,
                blocksToSearch: blocksToSearch,
                showSearchPanel: true
            };
            if (!(0, $eBlbF.isEqual)(editorBlocksSearchPanelStatus, tlfState.editorBlocksSearchPanelStatus)) {
                dispatch({
                    operation: (0, $2Mlm8.SET_EDITOR_BLOCKS_SEARCH_PANEL),
                    calledFrom: "useTlfEffects:UrlSearchEditorText",
                    editorBlocksSearchPanelStatus: editorBlocksSearchPanelStatus
                });
                navigate((0, $4CKH9.getTlfUrl)(hierarchy, tlfState.tlfData), {
                    replace: true
                });
            }
        }
    }, [
        dispatch,
        hierarchy,
        navigate,
        searchParams,
        tlfState.editorBlocksSearchPanelStatus,
        tlfState.tlfData
    ]);
    (0, $spJKX.useEffect)(()=>{
        /**
     * Processes a SignalR group message for the current TLF.
     *
     * @param message - Serialised SignalR message containing a TLF update or comment event.
     */ const updateFromSignalR = (message)=>{
            const tlfUpdate = JSON.parse(message);
            const tlfUpdatePatch = tlfUpdate.text && tlfUpdate.text[0].startsWith("{") ? JSON.parse(tlfUpdate.text[0]) : undefined;
            /* istanbul ignore else */ if (tlfUpdatePatch && tlfState.tlfData?.id === tlfUpdatePatch.updatedItemId && tlfUpdate.displayName !== signalR?.connection?.connectionId && tlfUpdate.displayName !== "Backend" && tlfUpdate.messageType === "tlfUpdate" && !tlfState.receivedMessages.some((message)=>message.messageId === tlfUpdate.messageId)) {
                dispatch({
                    operation: (0, $2Mlm8.ADD_RECEIVED_MESSAGE),
                    calledFrom: "SignalR:TlfUpdate",
                    receivedMessage: tlfUpdate
                });
                dispatch({
                    operation: (0, $2Mlm8.PROCESS_SIGNALR_NOTIFICATION),
                    calledFrom: "SignalR",
                    patch: tlfUpdatePatch.patch
                });
            // Comment updates are only received for the active TLF and its comment collection.
            /* istanbul ignore else */ } else if (tlfUpdate.groupName === `tlf${tlfState.tlfData?.id}` && tlfUpdate.displayName !== signalR?.connection?.connectionId && tlfUpdate.displayName !== "Backend" && tlfUpdate.text && tlfState.tlfData?.comments) switch(tlfUpdate.messageType){
                case "deleteComment":
                    try {
                        const commentId = JSON.parse(tlfUpdate.text[0]).id;
                        /* istanbul ignore else -- valid delete-comment payloads always include an ID. */ if (commentId) dispatch({
                            operation: (0, $2Mlm8.REMOVE_TLF_COMMENT),
                            commentId: commentId,
                            calledFrom: "SignalR:DeleteComment"
                        });
                    } catch (error) {
                        console.warn("Error processing delete comment update:", error);
                    }
                    break;
                case "comment":
                    try {
                        const comment = JSON.parse(tlfUpdate.text[0]);
                        /* istanbul ignore else -- valid comment payloads always contain a comment object. */ if (comment) dispatch({
                            operation: (0, $2Mlm8.UPDATE_TLF_COMMENT),
                            comment: comment,
                            calledFrom: "SignalR:Comment"
                        });
                    } catch (error) {
                        console.warn("Error processing comment update:", error);
                    }
                    break;
                case "commentsPatch":
                    try {
                        const patch = JSON.parse(tlfUpdate.text[0]);
                        /* istanbul ignore else -- valid patch payloads always contain a patch value. */ if (patch) dispatch({
                            operation: (0, $2Mlm8.PATCH_TLF_COMMENTS),
                            calledFrom: "SignalR:CommentsPatch",
                            patch: patch
                        });
                    } catch (error) {
                        console.warn("Error processing comments patch update:", error);
                    }
                    break;
            }
        };
        // The listener is registered only while a TLF item is active.
        /* istanbul ignore else */ if (tlfState.tlfData) {
            signalR?.connection?.on("SendMessageToGroup", updateFromSignalR);
            return ()=>signalR?.connection?.off("SendMessageToGroup");
        }
    }, [
        dispatch,
        signalR?.connection,
        tlfState.receivedMessages,
        tlfState.tlfData
    ]);
    (0, $spJKX.useEffect)(()=>{
        registerUnsavedChanges("TLF", tlfState.changed);
        return ()=>{
            registerUnsavedChanges("TLF", false);
        };
    }, [
        dispatch,
        registerUnsavedChanges,
        tlfState.changed
    ]);
    /** Unmount if the component is being removed from the DOM. */ (0, $spJKX.useEffect)(()=>{
        return ()=>{
            dispatch({
                operation: (0, $2Mlm8.CLEAR_TLF),
                calledFrom: "useTlfEffects:Unmount"
            });
        };
    }, [
        dispatch
    ]);
};

});
parcelRegister("ie0LA", function(module, exports) {

$parcel$export(module.exports, "loadTlfViewModeFromStorage", function () { return $d878159c8e51540a$export$a51b555dcf7204b9; });
$parcel$export(module.exports, "saveTlfViewModeToStorage", function () { return $d878159c8e51540a$export$2db8bdcfdf50c331; });
parcelRequire("6jtLO");
var $dbVjd = parcelRequire("dbVjd");
// Helper functions for localStorage
const $d878159c8e51540a$var$TLF_VIEW_MODE_STORAGE_KEY = "tlfViewMode";
const $d878159c8e51540a$export$a51b555dcf7204b9 = ()=>{
    try {
        const stored = localStorage.getItem($d878159c8e51540a$var$TLF_VIEW_MODE_STORAGE_KEY);
        if (stored && (0, $dbVjd.TLF_VIEW_MODES).map((mode)=>mode.value).includes(stored)) return (0, $dbVjd.TLF_VIEW_MODES).find((mode)=>mode.value === stored);
    } catch  {
    // Fall back to default if localStorage is not available or contains invalid data
    }
    return (0, $dbVjd.TLF_VIEW_MODES)[0];
};
const $d878159c8e51540a$export$2db8bdcfdf50c331 = (viewMode)=>{
    try {
        localStorage.setItem($d878159c8e51540a$var$TLF_VIEW_MODE_STORAGE_KEY, viewMode.value);
    } catch  {
    // Ignore localStorage errors
    }
};

});



parcelRegister("iP0ms", function(module, exports) {

$parcel$export(module.exports, "TocContextProvider", function () { return $833a38f78031245b$export$610cc28fd797e14f; });

var $bR5nk = parcelRequire("bR5nk");

var $aAXCH = parcelRequire("aAXCH");

var $6iYEs = parcelRequire("6iYEs");

var $i1j9w = parcelRequire("i1j9w");

var $3tNrK = parcelRequire("3tNrK");

var $f2M6x = parcelRequire("f2M6x");
const $833a38f78031245b$export$610cc28fd797e14f = ({ children: children })=>{
    const { state: state, dispatch: dispatch } = (0, $3tNrK.useTocContext)();
    const { navigate: navigate } = (0, $6iYEs.useUnsavedChanges)("toc-context-provider");
    // TODO: This should be moved to the signal-R provider
    return /*#__PURE__*/ (0, $bR5nk.jsxs)((0, $bR5nk.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aAXCH.PopupAlertModal), {
                id: "toc-save-alert",
                show: state.showSaveAlert,
                title: "New Major Version Available",
                message: "The ToC has been updated and saved as a new version. Please close this Popup to redirect.",
                onClose: ()=>{
                    dispatch({
                        operation: (0, $f2M6x.CLOSE_TOC_SAVE_ALERT)
                    });
                    navigate(`/R/${state.tocIdFromMessage}`);
                }
            }),
            /*#__PURE__*/ (0, $bR5nk.jsx)((0, $aAXCH.PopupAlertModal), {
                id: "toc-need-refresh",
                show: state.showNeedRefresh,
                title: "Large change made",
                message: "The ToC has been updated by someone else/in another browser tab, and needs to be refreshed.",
                onClose: ()=>{
                    dispatch({
                        operation: (0, $f2M6x.CLOSE_TOC_NEED_REFRESH)
                    });
                    (0, $i1j9w.doReload)();
                }
            })
        ]
    });
};
$833a38f78031245b$export$610cc28fd797e14f.displayName = "TocContextProvider";
var $833a38f78031245b$export$2e2bcd8739ae039 = $833a38f78031245b$export$610cc28fd797e14f;

});


parcelRegister("9kv6K", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("2ozoK")),
    $parcel$import("6k6xX")
]).then(()=>parcelRequire('bGm3y'));

});
parcelRegister("7Q9b8", function(module, exports) {
"use strict";

var $cdY4t = parcelRequire("cdY4t");
module.exports = $cdY4t(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("cdY4t", function(module, exports) {
"use strict";
var $8e654bcda228b36a$var$cachedBundles = {};
var $8e654bcda228b36a$var$cachedPreloads = {};
var $8e654bcda228b36a$var$cachedPrefetches = {};
function $8e654bcda228b36a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $8e654bcda228b36a$var$cachedPreloads;
        case 'prefetch':
            return $8e654bcda228b36a$var$cachedPrefetches;
        default:
            return $8e654bcda228b36a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $8e654bcda228b36a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("j8yNh", function(module, exports) {
module.exports = $parcel$import("jmkQI").then(()=>parcelRequire('iAlxQ'));

});

parcelRegister("gc9wr", function(module, exports) {
module.exports = $parcel$import("1uqGP").then(()=>parcelRequire('lWgad'));

});

parcelRegister("jyTqa", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("dukmp")),
    $parcel$import("8QSxB"),
    $parcel$import("dkgLa")
]).then(()=>parcelRequire('8iCNj'));

});

parcelRegister("ds3GY", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("dxAxE")),
    $parcel$import("ek73m")
]).then(()=>parcelRequire('houYN'));

});

parcelRegister("hYWVp", function(module, exports) {
module.exports = $parcel$import("lYn3c").then(()=>parcelRequire('1GSwd'));

});

parcelRegister("bEAkI", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("etjZG")),
    $parcel$import("jIv7C")
]).then(()=>parcelRequire('kD6tK'));

});

parcelRegister("bvOm4", function(module, exports) {
module.exports = $parcel$import("8WNad").then(()=>parcelRequire('hEvTy'));

});

parcelRegister("32h2z", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("JaBQK")),
    $parcel$import("2hqp9")
]).then(()=>parcelRequire('fQiGE'));

});

parcelRegister("8g2sn", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("ehL27")),
    $parcel$import("dyjRI")
]).then(()=>parcelRequire('heP92'));

});

parcelRegister("722us", function(module, exports) {
module.exports = $parcel$import("5hAP6").then(()=>parcelRequire('6UxQr'));

});

parcelRegister("iDMqC", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("2u06E")),
    $parcel$import("eldry")
]).then(()=>parcelRequire('cnTAi'));

});

parcelRegister("f07ct", function(module, exports) {
module.exports = $parcel$import("32wMy").then(()=>parcelRequire('7UifU'));

});

parcelRegister("gw1l7", function(module, exports) {
module.exports = $parcel$import("3QHOP").then(()=>parcelRequire('6H0BZ'));

});

parcelRegister("glWJI", function(module, exports) {
module.exports = $parcel$import("3oJpm").then(()=>parcelRequire('bLYUO'));

});

parcelRegister("4IOu9", function(module, exports) {
module.exports = $parcel$import("1dIVA").then(()=>parcelRequire('chz5H'));

});

parcelRegister("2A5OV", function(module, exports) {
module.exports = $parcel$import("bAbn8").then(()=>parcelRequire('9mG3k'));

});

parcelRegister("enwL1", function(module, exports) {
module.exports = $parcel$import("7kIOR").then(()=>parcelRequire('6WQq8'));

});

parcelRegister("6QJfg", function(module, exports) {
module.exports = $parcel$import("k21Uh").then(()=>parcelRequire('bbCel'));

});

parcelRegister("hnIFa", function(module, exports) {
module.exports = $parcel$import("fehCz").then(()=>parcelRequire('6XzGJ'));

});

parcelRegister("gGvWF", function(module, exports) {
module.exports = $parcel$import("cJNtn").then(()=>parcelRequire('2MNwE'));

});

parcelRegister("f7yUK", function(module, exports) {
module.exports = $parcel$import("fiolw").then(()=>parcelRequire('g2yef'));

});

parcelRegister("7ooId", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("7Q9b8"))($parcel$resolve("8vOVG")),
    $parcel$import("8QSxB"),
    (parcelRequire("7Q9b8"))($parcel$resolve("2u06E")),
    $parcel$import("eldry"),
    $parcel$import("icjkQ")
]).then(()=>parcelRequire('9Wc2j'));

});





var $277c6afafd714445$exports = {};
$parcel$extendImportMap({
    "fv4oe": "Mosaic.11531866.png",
    "y8LML": "error-cassette.ddf1a09a.png",
    "6k6xX": "AdminPage.12464df2.js",
    "2ozoK": "AdminPage.44eb2a7e.css",
    "jmkQI": "MaintenancePage.fd6537f2.js",
    "1uqGP": "NotAllowedPage.6a9a3917.js",
    "dkgLa": "HierarchyPage.160058f8.js",
    "8QSxB": "HierarchyPage.af9d8cd8.js",
    "dukmp": "HierarchyPage.fb9f5807.css",
    "ek73m": "TOC.062d43cd.js",
    "dxAxE": "TOC.381a0b55.css",
    "lYn3c": "HierarchyProperties.b3d6c6a9.js",
    "jIv7C": "AccessRights.baa68504.js",
    "etjZG": "AccessRights.a8a0a338.css",
    "8WNad": "LibraryNavigation.51f65a35.js",
    "2hqp9": "LibraryTable.e521ad0f.js",
    "JaBQK": "LibraryTable.d4f5e3af.css",
    "dyjRI": "HierarchyDomainReplacements.db36e81e.js",
    "ehL27": "HierarchyDomainReplacements.c1694bf1.css",
    "5hAP6": "HierarchyLists.fa187dc8.js",
    "eldry": "ExternalSinglesTable.44e82e1c.js",
    "2u06E": "ExternalSinglesTable.620515d3.css",
    "32wMy": "HierarchyTags.09f951c7.js",
    "3QHOP": "HierarchyRowGroups.8b02d0e1.js",
    "3oJpm": "HierarchyAnalysisMethods.a2030bca.js",
    "1dIVA": "HierarchyAnalysisSets.a244a322.js",
    "bAbn8": "HierarchyDataSubsets.68e2b031.js",
    "7kIOR": "HierarchyGroupingFactors.29008114.js",
    "k21Uh": "NotFound.a947c4a2.js",
    "fehCz": "ReportVersions.2d796c64.js",
    "cJNtn": "HierarchyHistoryTable.345d109c.js",
    "fiolw": "EditorBlocksSearchControls.75d2277b.js",
    "icjkQ": "TlfPage.9ff03bae.js",
    "8vOVG": "TlfPage.e4b4f233.css"
});


var $bR5nk = parcelRequire("bR5nk");

var $884tT = parcelRequire("884tT");

var $dbTcY = parcelRequire("dbTcY");


var $bR5nk = parcelRequire("bR5nk");

var $dbTcY = parcelRequire("dbTcY");
parcelRequire("ae9tk");
var $lCyBC = parcelRequire("lCyBC");

var $kK73x = parcelRequire("kK73x");
const $683397ca2eb032d7$export$f6d610d2730cbf1a = {
    auth: {
        clientId: `${(0, $kK73x.REACT_APP_AUTH_CLIENTID)}`,
        authority: `${(0, $kK73x.REACT_APP_AUTH_AUTHORITY)}`,
        redirectUri: `${(0, $kK73x.REACT_APP_AUTH_REDIRECT_URI)}`
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};
const $683397ca2eb032d7$export$be6c432b2463c5eb = {
    scopes: [
        `${(0, $kK73x.REACT_APP_AUTH_SCOPE)}`
    ]
};
const $683397ca2eb032d7$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};


function $fa8ed12783a12027$export$777ddc80de65caa7(instance, account, stage) {
    return async function intercept(config) {
        if (stage !== "local") {
            if (!account) throw Error("No active account! Verify a user has been signed in.");
            const response = await instance.acquireTokenSilent({
                ...(0, $683397ca2eb032d7$export$be6c432b2463c5eb),
                account: account
            });
            const bearer = `Bearer ${response.accessToken}`;
            if (config && config.headers) config.headers.Authorization = bearer;
        }
        return config;
    };
}
/**
 * Axios request interceptor that adds authentication tokens to outgoing requests.
 *
 * @param props - The component props
 * @param props.children - Child components to render
 */ const $fa8ed12783a12027$var$RequestInterceptor = ({ children: children })=>{
    const { instance: instance, accounts: accounts } = (0, $dbTcY.useMsal)();
    const account = (0, $dbTcY.useAccount)(accounts[0]);
    const interceptor = $fa8ed12783a12027$export$777ddc80de65caa7(instance, account, undefined);
    (0, $lCyBC.default).interceptors.request.use(interceptor);
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $bR5nk.Fragment), {
        children: children
    });
};
$fa8ed12783a12027$var$RequestInterceptor.displayName = "RequestInterceptor";
var $fa8ed12783a12027$export$2e2bcd8739ae039 = $fa8ed12783a12027$var$RequestInterceptor;


parcelRequire("spJKX");
var $7ed58da2cf540b72$exports = {};
'use strict';
function $7ed58da2cf540b72$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$7ed58da2cf540b72$exports = (parcelRequire("9cA6s"));



var $4Q81F = parcelRequire("4Q81F");/**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.18.5
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4Q81F = parcelRequire("4Q81F");

var $spJKX = parcelRequire("spJKX");
var $81b5554ec8b8f259$exports = {};
"use strict";
Object.defineProperty($81b5554ec8b8f259$exports, "__esModule", {
    value: true
});
$81b5554ec8b8f259$exports.parseCookie = $81b5554ec8b8f259$var$parseCookie;
$81b5554ec8b8f259$exports.parse = $81b5554ec8b8f259$var$parseCookie;
$81b5554ec8b8f259$exports.stringifyCookie = $81b5554ec8b8f259$var$stringifyCookie;
$81b5554ec8b8f259$exports.stringifySetCookie = $81b5554ec8b8f259$var$stringifySetCookie;
$81b5554ec8b8f259$exports.serialize = $81b5554ec8b8f259$var$stringifySetCookie;
$81b5554ec8b8f259$exports.parseSetCookie = $81b5554ec8b8f259$var$parseSetCookie;
$81b5554ec8b8f259$exports.stringifySetCookie = $81b5554ec8b8f259$var$stringifySetCookie;
$81b5554ec8b8f259$exports.serialize = $81b5554ec8b8f259$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $81b5554ec8b8f259$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $81b5554ec8b8f259$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $81b5554ec8b8f259$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $81b5554ec8b8f259$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $81b5554ec8b8f259$var$maxAgeRegExp = /^-?\d+$/;
const $81b5554ec8b8f259$var$__toString = Object.prototype.toString;
const $81b5554ec8b8f259$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $81b5554ec8b8f259$var$parseCookie(str, options) {
    const obj = new $81b5554ec8b8f259$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $81b5554ec8b8f259$var$decode;
    let index = 0;
    do {
        const eqIdx = $81b5554ec8b8f259$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $81b5554ec8b8f259$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $81b5554ec8b8f259$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($81b5554ec8b8f259$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $81b5554ec8b8f259$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$81b5554ec8b8f259$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$81b5554ec8b8f259$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $81b5554ec8b8f259$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$81b5554ec8b8f259$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$81b5554ec8b8f259$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$81b5554ec8b8f259$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$81b5554ec8b8f259$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$81b5554ec8b8f259$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $81b5554ec8b8f259$var$parseSetCookie(str, options) {
    const dec = options?.decode || $81b5554ec8b8f259$var$decode;
    const len = str.length;
    const endIdx = $81b5554ec8b8f259$var$endIndex(str, 0, len);
    const eqIdx = $81b5554ec8b8f259$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($81b5554ec8b8f259$var$valueSlice(str, 0, endIdx))
    } : {
        name: $81b5554ec8b8f259$var$valueSlice(str, 0, eqIdx),
        value: dec($81b5554ec8b8f259$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $81b5554ec8b8f259$var$endIndex(str, index, len);
        const eqIdx = $81b5554ec8b8f259$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $81b5554ec8b8f259$var$valueSlice(str, index, endIdx) : $81b5554ec8b8f259$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $81b5554ec8b8f259$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $81b5554ec8b8f259$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $81b5554ec8b8f259$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $81b5554ec8b8f259$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $81b5554ec8b8f259$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $81b5554ec8b8f259$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $81b5554ec8b8f259$var$isDate(val) {
    return $81b5554ec8b8f259$var$__toString.call(val) === "[object Date]";
}


var $4065e79d745a319a$exports = {};
"use strict";
var $4065e79d745a319a$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $4065e79d745a319a$var$isForbiddenKey(key) {
    return typeof key !== "string" || key in {};
}
function $4065e79d745a319a$var$createNullObj() {
    return Object.create(null);
}
function $4065e79d745a319a$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $4065e79d745a319a$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($4065e79d745a319a$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $4065e79d745a319a$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $4065e79d745a319a$var$defaultParseOptions, options) : $4065e79d745a319a$var$defaultParseOptions;
    if ($4065e79d745a319a$var$isForbiddenKey(name)) return null;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser: failed to decode cookie value. Set options.decodeValues=false to disable decoding.", e);
    }
    var cookie = $4065e79d745a319a$var$createNullObj();
    cookie.name = name;
    cookie.value = value;
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        if ($4065e79d745a319a$var$isForbiddenKey(key) || key === "name" || key === "value") return;
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") {
            var n = parseInt(value, 10);
            if (!Number.isNaN(n)) cookie.maxAge = n;
        } else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else if (key) cookie[key] = value;
    });
    return cookie;
}
function $4065e79d745a319a$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $4065e79d745a319a$var$parse(input, options) {
    options = options ? Object.assign({}, $4065e79d745a319a$var$defaultParseOptions, options) : $4065e79d745a319a$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return $4065e79d745a319a$var$createNullObj();
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case)
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($4065e79d745a319a$var$isNonEmptyString).map(function(str) {
        return $4065e79d745a319a$var$parseString(str, options);
    }).filter(Boolean);
    else {
        var cookies = $4065e79d745a319a$var$createNullObj();
        return input.filter($4065e79d745a319a$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $4065e79d745a319a$var$parseString(str, options);
            if (cookie && !$4065e79d745a319a$var$isForbiddenKey(cookie.name)) cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $4065e79d745a319a$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$4065e79d745a319a$exports = $4065e79d745a319a$var$parse;
$4065e79d745a319a$exports.parse = $4065e79d745a319a$var$parse;
$4065e79d745a319a$exports.parseString = $4065e79d745a319a$var$parseString;
$4065e79d745a319a$exports.splitCookiesString = $4065e79d745a319a$var$splitCookiesString;


function $7722d4aa67f314a3$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = (0, $4Q81F.createServerRoutes)(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && (0, $4Q81F.shouldHydrateRouteLoader)(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = (0, $4Q81F.createStaticRouter)(routes, context.staticHandlerContext, {
        branches: context.branches
    });
    return /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.FrameworkContext).Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            nonce: nonce,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RemixErrorBoundary), {
        location: router.state.location
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.StaticRouterProvider), {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $spJKX.createElement($spJKX.Suspense, null, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.StreamTransfer), {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $7722d4aa67f314a3$export$bea31554c7dfd2ad(routes, _context) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $spJKX.useRef();
        let frameworkContextRef = $spJKX.useRef();
        if (routerRef.current == null) {
            frameworkContextRef.current = {
                future: {
                    v8_passThroughRequests: future?.v8_passThroughRequests === true,
                    v8_middleware: future?.v8_middleware === true,
                    v8_trailingSlashAwareDataRequests: future?.v8_trailingSlashAwareDataRequests === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $7722d4aa67f314a3$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `RouteObject`
            (0, $4Q81F.convertRoutesToDataRoutes)(routes, (r)=>r), _context !== void 0 ? _context : future?.v8_middleware ? new (0, $4Q81F.RouterContextProvider)() : {}, frameworkContextRef.current.manifest, frameworkContextRef.current.routeModules);
            routerRef.current = (0, $4Q81F.createMemoryRouter)(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.FrameworkContext).Provider, {
            value: frameworkContextRef.current
        }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RouterProvider), {
            router: routerRef.current
        }));
    };
}
function $7722d4aa67f314a3$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in react-router processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? (0, $4Q81F.withComponentProps)(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? (0, $4Q81F.withHydrateFallbackProps)(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? (0, $4Q81F.withErrorBoundaryProps)(route.ErrorBoundary) : void 0,
            action: route.action ? (args)=>route.action({
                    ...args,
                    context: context
                }) : void 0,
            loader: route.loader ? (args)=>route.loader({
                    ...args,
                    context: context
                }) : void 0,
            middleware: route.middleware ? route.middleware.map((mw)=>(...args)=>mw({
                        ...args[0],
                        context: context
                    }, args[1])) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || (0, $4Q81F.Outlet),
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $7722d4aa67f314a3$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $7722d4aa67f314a3$var$encoder = /* @__PURE__ */ new TextEncoder();
var $7722d4aa67f314a3$var$sign = async (value, secret)=>{
    let data2 = $7722d4aa67f314a3$var$encoder.encode(value);
    let key = await $7722d4aa67f314a3$var$createKey(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $7722d4aa67f314a3$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $7722d4aa67f314a3$var$encoder.encode(value);
    let key = await $7722d4aa67f314a3$var$createKey(secret, [
        "verify"
    ]);
    try {
        let signature = $7722d4aa67f314a3$var$byteStringToUint8Array(atob(hash));
        let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
        return valid ? value : false;
    } catch (e) {
        return false;
    }
};
var $7722d4aa67f314a3$var$createKey = async (secret, usages)=>crypto.subtle.importKey("raw", $7722d4aa67f314a3$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $7722d4aa67f314a3$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $7722d4aa67f314a3$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $7722d4aa67f314a3$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $81b5554ec8b8f259$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $7722d4aa67f314a3$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $81b5554ec8b8f259$exports.serialize)(name, value === "" ? "" : await $7722d4aa67f314a3$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $7722d4aa67f314a3$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $7722d4aa67f314a3$var$encodeCookieValue(value, secrets) {
    let encoded = $7722d4aa67f314a3$var$encodeData(value);
    if (secrets.length > 0) encoded = await $7722d4aa67f314a3$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $7722d4aa67f314a3$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $7722d4aa67f314a3$var$unsign(value, secret);
            if (unsignedValue !== false) return $7722d4aa67f314a3$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $7722d4aa67f314a3$var$decodeData(value);
}
function $7722d4aa67f314a3$var$encodeData(value) {
    return btoa($7722d4aa67f314a3$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $7722d4aa67f314a3$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($7722d4aa67f314a3$var$myEscape(atob(value))));
    } catch (e) {
        return {};
    }
}
function $7722d4aa67f314a3$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $7722d4aa67f314a3$var$hex(code, 2);
            else result += "%u" + $7722d4aa67f314a3$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $7722d4aa67f314a3$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $7722d4aa67f314a3$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $7722d4aa67f314a3$var$warnOnceAboutExpiresCookie(name, expires) {
    (0, $4Q81F.warnOnce)(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $7722d4aa67f314a3$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo, routeId)=>{
        let route = manifest[routeId];
        if (route) memo[routeId] = route.module;
        return memo;
    }, {});
}
// lib/server-runtime/mode.ts
var $7722d4aa67f314a3$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($7722d4aa67f314a3$export$e7973f87fd96e4f2 || {});
function $7722d4aa67f314a3$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $7722d4aa67f314a3$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $7722d4aa67f314a3$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $7722d4aa67f314a3$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $7722d4aa67f314a3$var$serializeError(error, serverMode) {
    let sanitized = $7722d4aa67f314a3$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
// lib/server-runtime/invariant.ts
function $7722d4aa67f314a3$var$invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/routeMatching.ts
function $7722d4aa67f314a3$var$matchServerRoutes(manifest, dataRoutes, branches, pathname, basename) {
    let matches = (0, $4Q81F.matchRoutesImpl)(dataRoutes, pathname, basename ?? "/", false, branches);
    if (!matches) return null;
    return matches.map((match)=>{
        let route = manifest[match.route.id];
        $7722d4aa67f314a3$var$invariant(route, `Route with id "${match.route.id}" not found in manifest.`);
        return {
            params: match.params,
            pathname: match.pathname,
            route: route
        };
    });
}
// lib/server-runtime/data.ts
async function $7722d4aa67f314a3$var$callRouteHandler(handler, args, future) {
    let result = await handler({
        request: future.v8_passThroughRequests ? args.request : $7722d4aa67f314a3$var$stripRoutesParam($7722d4aa67f314a3$var$stripIndexParam(args.request)),
        url: args.url,
        params: args.params,
        context: args.context,
        pattern: args.pattern
    });
    if ((0, $4Q81F.isDataWithResponseInit)(result) && result.init && result.init.status && (0, $4Q81F.isRedirectStatusCode)(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $7722d4aa67f314a3$var$stripIndexParam(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $7722d4aa67f314a3$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/dev.ts
var $7722d4aa67f314a3$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $7722d4aa67f314a3$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$7722d4aa67f314a3$var$globalDevServerHooksKey] = devServerHooks;
}
function $7722d4aa67f314a3$var$getDevServerHooks() {
    return globalThis[$7722d4aa67f314a3$var$globalDevServerHooksKey];
}
function $7722d4aa67f314a3$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $7722d4aa67f314a3$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $7722d4aa67f314a3$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $7722d4aa67f314a3$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            middleware: route.module.middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $7722d4aa67f314a3$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $7722d4aa67f314a3$var$invariant(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await (0, $4Q81F.decodeViaTurboStream)(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && (0, $4Q81F.SingleFetchRedirectSymbol) in data2) {
                        let result = data2[0, $4Q81F.SingleFetchRedirectSymbol];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw (0, $4Q81F.redirectDocument)(result.redirect, init);
                        else if (result.replace) throw (0, $4Q81F.replace)(result.redirect, init);
                        else throw (0, $4Q81F.redirect)(result.redirect, init);
                    } else {
                        $7722d4aa67f314a3$var$invariant(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $7722d4aa67f314a3$var$invariant("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $7722d4aa67f314a3$var$callRouteHandler(route.module.loader, args, future);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$7722d4aa67f314a3$var$callRouteHandler(route.module.action, args, future) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $7722d4aa67f314a3$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/serverHandoff.ts
function $7722d4aa67f314a3$var$createServerHandoffString(serverHandoff) {
    return (0, $4Q81F.escapeHtml)(JSON.stringify(serverHandoff));
}
function $7722d4aa67f314a3$var$getDocumentHeaders(context, build) {
    return $7722d4aa67f314a3$var$getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        $7722d4aa67f314a3$var$invariant(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function $7722d4aa67f314a3$var$getDocumentHeadersImpl(context, getRouteHeadersFn, _defaultHeaders) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    const defaultHeaders = new Headers(_defaultHeaders);
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $7722d4aa67f314a3$var$prependCookies(errorHeaders, headers2);
            $7722d4aa67f314a3$var$prependCookies(actionHeaders, headers2);
            $7722d4aa67f314a3$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) $7722d4aa67f314a3$var$prependCookies(errorHeaders, headers);
        $7722d4aa67f314a3$var$prependCookies(actionHeaders, headers);
        $7722d4aa67f314a3$var$prependCookies(loaderHeaders, headers);
        $7722d4aa67f314a3$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers(defaultHeaders));
}
function $7722d4aa67f314a3$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $4065e79d745a319a$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/actions.ts
function $7722d4aa67f314a3$var$throwIfPotentialCSRFAttack(request, allowedActionOrigins) {
    let originHeader = request.headers.get("origin");
    let originDomain = null;
    let originUrl = null;
    try {
        if (typeof originHeader === "string" && originHeader !== "null") {
            originUrl = new URL(originHeader);
            originDomain = originUrl.host;
        } else originDomain = originHeader;
    } catch  {
        throw new Error(`\`origin\` header is not a valid URL. Aborting the action.`);
    }
    let requestUrl = new URL(request.url);
    let originMatchesRequest = originUrl ? originUrl.origin === requestUrl.origin : originDomain === requestUrl.host;
    if (originDomain && !originMatchesRequest) {
        if (!$7722d4aa67f314a3$var$isAllowedOrigin(originDomain, allowedActionOrigins)) throw new Error("The `request.url` origin does not match `origin` header from a forwarded action request. Aborting the action.");
    }
}
function $7722d4aa67f314a3$var$matchWildcardDomain(domain, pattern) {
    const domainParts = domain.split(".");
    const patternParts = pattern.split(".");
    if (patternParts.length < 1) return false;
    if (domainParts.length < patternParts.length) return false;
    while(patternParts.length){
        const patternPart = patternParts.pop();
        const domainPart = domainParts.pop();
        switch(patternPart){
            case "":
                return false;
            case "*":
                if (domainPart) continue;
                else return false;
            case "**":
                if (patternParts.length > 0) return false;
                return domainPart !== void 0;
            case void 0:
            default:
                if (domainPart !== patternPart) return false;
        }
    }
    return domainParts.length === 0;
}
function $7722d4aa67f314a3$var$isAllowedOrigin(originDomain, allowedActionOrigins = []) {
    return allowedActionOrigins.some((allowedOrigin)=>allowedOrigin && (allowedOrigin === originDomain || $7722d4aa67f314a3$var$matchWildcardDomain(originDomain, allowedOrigin)));
}
// lib/server-runtime/urls.ts
function $7722d4aa67f314a3$var$getNormalizedPath(request, basename, future) {
    basename = basename || "/";
    let url = new URL(request.url);
    let pathname = url.pathname;
    if (future?.v8_trailingSlashAwareDataRequests) {
        if (pathname.endsWith("/_.data")) pathname = pathname.replace(/_\.data$/, "");
        else pathname = pathname.replace(/\.data$/, "");
    } else {
        if ((0, $4Q81F.stripBasename)(pathname, basename) === "/_root.data") pathname = basename;
        else if (pathname.endsWith(".data")) pathname = pathname.replace(/\.data$/, "");
        if ((0, $4Q81F.stripBasename)(pathname, basename) !== "/" && pathname.endsWith("/")) pathname = pathname.slice(0, -1);
    }
    let searchParams = new URLSearchParams(url.search);
    searchParams.delete("_routes");
    let search = searchParams.toString();
    if (search) search = `?${search}`;
    return {
        pathname: pathname,
        search: search,
        // No hashes on the server
        hash: ""
    };
}
// lib/server-runtime/single-fetch.ts
var $7722d4aa67f314a3$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...(0, $4Q81F.NO_BODY_STATUS_CODES),
    304
]);
async function $7722d4aa67f314a3$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        try {
            $7722d4aa67f314a3$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            return handleQueryError(new Error("Bad Request"), 400);
        }
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$7722d4aa67f314a3$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $4Q81F.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error, status = 500) {
        handleError(error);
        return $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: status
        });
    }
    function staticContextToResponse(context) {
        let headers = $7722d4aa67f314a3$var$getDocumentHeaders(context, build);
        if ((0, $4Q81F.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $4Q81F.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $7722d4aa67f314a3$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        });
    }
}
async function $7722d4aa67f314a3$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    let routesParam = new URL(request.url).searchParams.get("_routes");
    let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
    try {
        let handlerRequest = build.future.v8_passThroughRequests ? request : new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0,
            normalizePath: (r)=>$7722d4aa67f314a3$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $4Q81F.isResponse)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $7722d4aa67f314a3$var$getDocumentHeaders(context, build);
        if ((0, $4Q81F.isRedirectStatusCode)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $4Q81F.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $7722d4aa67f314a3$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
        if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
            error: error
        };
        for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
            data: data2
        };
        return $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, {
            result: results,
            headers: headers,
            status: context.statusCode
        });
    }
}
function $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($7722d4aa67f314a3$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    resultHeaders.delete("Content-Length");
    return new Response($7722d4aa67f314a3$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $7722d4aa67f314a3$var$generateSingleFetchRedirectResponse(redirectResponse, request, build, serverMode) {
    let redirect2 = $7722d4aa67f314a3$var$getSingleFetchRedirect(redirectResponse.status, redirectResponse.headers, build.basename);
    let headers = new Headers(redirectResponse.headers);
    headers.delete("Location");
    headers.set("Content-Type", "text/x-script");
    return $7722d4aa67f314a3$var$generateSingleFetchResponse(request, build, serverMode, {
        result: request.method === "GET" ? {
            [(0, $4Q81F.SingleFetchRedirectSymbol)]: redirect2
        } : redirect2,
        headers: headers,
        status: (0, $4Q81F.SINGLE_FETCH_REDIRECT_STATUS)
    });
}
function $7722d4aa67f314a3$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = (0, $4Q81F.stripBasename)(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $7722d4aa67f314a3$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>{
        controller.abort(new Error("Server Timeout"));
        cleanupCallbacks();
    }, typeof streamTimeout === "number" ? streamTimeout : 4950);
    let abortControllerOnRequestAbort = ()=>{
        controller.abort(requestSignal.reason);
        cleanupCallbacks();
    };
    requestSignal.addEventListener("abort", abortControllerOnRequestAbort);
    let cleanupCallbacks = ()=>{
        clearTimeout(timeoutId);
        requestSignal.removeEventListener("abort", abortControllerOnRequestAbort);
    };
    return (0, $4Q81F.encode)(data2, {
        signal: controller.signal,
        onComplete: cleanupCallbacks,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $7722d4aa67f314a3$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof (0, $4Q81F.ErrorResponseImpl)) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && (0, $4Q81F.SingleFetchRedirectSymbol) in value) return [
                    "SingleFetchRedirect",
                    value[0, $4Q81F.SingleFetchRedirectSymbol]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $7722d4aa67f314a3$var$derive(build, mode) {
    let dataRoutes = $7722d4aa67f314a3$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $7722d4aa67f314a3$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = (0, $4Q81F.createStaticHandler)(dataRoutes, {
        basename: build.basename,
        instrumentations: build.entry.module.instrumentations,
        future: build.future
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        (0, $4Q81F.isRouteErrorResponse)(error) && error.error ? error.error : error);
    });
    let requestHandler = async (request, initialContext)=>{
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $7722d4aa67f314a3$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (build.future.v8_middleware) {
            if (initialContext && !(initialContext instanceof (0, $4Q81F.RouterContextProvider))) {
                let error = new Error("Invalid `context` value provided to `handleRequest`. When middleware is enabled you must return an instance of `RouterContextProvider` from your `getLoadContext` function.");
                handleError(error);
                return $7722d4aa67f314a3$var$returnLastResortErrorResponse(error, serverMode);
            }
            loadContext = initialContext || new (0, $4Q81F.RouterContextProvider)();
        } else loadContext = initialContext || {};
        let requestUrl = new URL(request.url);
        let normalizedPathname = $7722d4aa67f314a3$var$getNormalizedPath(request, build.basename, build.future).pathname;
        let isSpaMode = $7722d4aa67f314a3$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!build.ssr) {
            let decodedPath = decodeURI(normalizedPathname);
            if (build.basename && build.basename !== "/") {
                let strippedPath = (0, $4Q81F.stripBasename)(decodedPath, build.basename);
                if (strippedPath == null) {
                    errorHandler(new (0, $4Q81F.ErrorResponseImpl)(404, "Not Found", `Refusing to prerender the \`${decodedPath}\` path because it does not start with the basename \`${build.basename}\``), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                }
                decodedPath = strippedPath;
            }
            if (build.prerender.length === 0) isSpaMode = true;
            else if (!build.prerender.includes(decodedPath.replace(/\/$/, "")) && !build.prerender.includes(decodedPath.replace(/[^/]$/, "/"))) {
                if (requestUrl.pathname.endsWith(".data")) {
                    errorHandler(new (0, $4Q81F.ErrorResponseImpl)(404, "Not Found", `Refusing to SSR the path \`${decodedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = (0, $4Q81F.getManifestPath)(build.routeDiscovery.manifestPath, build.basename);
        if (build.routeDiscovery.mode === "lazy" && requestUrl.pathname === manifestUrl) try {
            let res = await $7722d4aa67f314a3$var$handleManifestRequest(build, staticHandler.dataRoutes, staticHandler._internalRouteBranches, requestUrl);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $7722d4aa67f314a3$var$matchServerRoutes(build.routes, staticHandler.dataRoutes, staticHandler._internalRouteBranches, normalizedPathname, build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (requestUrl.pathname.endsWith(".data")) {
            response = await $7722d4aa67f314a3$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPathname, loadContext, handleError);
            if ((0, $4Q81F.isRedirectResponse)(response)) response = $7722d4aa67f314a3$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            if (build.entry.module.handleDataRequest) {
                response = await build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: matches ? matches[0].params : {},
                    request: request
                });
                if ((0, $4Q81F.isRedirectResponse)(response)) response = $7722d4aa67f314a3$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $7722d4aa67f314a3$var$handleResourceRequest(serverMode, build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = requestUrl;
            let criticalCss = void 0;
            if (build.unstable_getCriticalCss) criticalCss = await build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $7722d4aa67f314a3$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $7722d4aa67f314a3$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $7722d4aa67f314a3$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
    if (build.entry.module.instrumentations) requestHandler = (0, $4Q81F.instrumentHandler)(requestHandler, build.entry.module.instrumentations.map((i)=>i.handler).filter(Boolean));
    return {
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler,
        requestHandler: requestHandler
    };
}
var $7722d4aa67f314a3$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let serverMode;
    let staticHandler;
    let errorHandler;
    let _requestHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $7722d4aa67f314a3$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        } else if (!serverMode || !staticHandler || !errorHandler || !_requestHandler) {
            let derived = $7722d4aa67f314a3$var$derive(_build, mode);
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        }
        return _requestHandler(request, initialContext);
    };
};
async function $7722d4aa67f314a3$var$handleManifestRequest(build, dataRoutes, branches, url) {
    if (url.toString().length > (0, $4Q81F.URL_LIMIT)) return new Response(null, {
        statusText: "Bad Request",
        status: 400
    });
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("paths")) {
        let pathParam = url.searchParams.get("paths") || "";
        let paths = new Set(pathParam.split(",").filter(Boolean));
        for (let path of paths){
            if (!path.startsWith("/")) path = `/${path}`;
            let matches = $7722d4aa67f314a3$var$matchServerRoutes(build.routes, dataRoutes, branches, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $7722d4aa67f314a3$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, normalizedPath, loadContext, handleError) {
    let handlerUrl = new URL(request.url);
    handlerUrl.pathname = normalizedPath;
    let response = (0, $4Q81F.isMutationMethod)(request.method) ? await $7722d4aa67f314a3$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $7722d4aa67f314a3$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $7722d4aa67f314a3$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        if ((0, $4Q81F.isMutationMethod)(request.method)) try {
            $7722d4aa67f314a3$var$throwIfPotentialCSRFAttack(request, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        } catch (e) {
            handleError(e);
            return new Response("Bad Request", {
                status: 400
            });
        }
        let result = await staticHandler.query(request, {
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(request);
                    if (!(0, $4Q81F.isResponse)(innerResult)) innerResult = await renderHtml(innerResult, isSpaMode);
                    return innerResult;
                } catch (error) {
                    handleError(error);
                    return new Response(null, {
                        status: 500
                    });
                }
            } : void 0,
            normalizePath: (r)=>$7722d4aa67f314a3$var$getNormalizedPath(r, build.basename, build.future)
        });
        if (!(0, $4Q81F.isResponse)(result)) result = await renderHtml(result, isSpaMode);
        return result;
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        let headers = $7722d4aa67f314a3$var$getDocumentHeaders(context, build);
        if ($7722d4aa67f314a3$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $4Q81F.isRouteErrorResponse)(err) || err.error) handleError(err);
            });
            context.errors = $7722d4aa67f314a3$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: context.errors
        };
        let routeDiscovery = build.routeDiscovery;
        if ((0, $4Q81F.isFogOfWarEnabled)(routeDiscovery, build.ssr) && (0, $4Q81F.shouldUseInitialRouteDiscovery)(context.location.pathname, staticHandler._matchCost)) routeDiscovery = {
            ...routeDiscovery,
            mode: "initial"
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            branches: staticHandler._internalRouteBranches,
            routeModules: $7722d4aa67f314a3$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $7722d4aa67f314a3$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $7722d4aa67f314a3$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$7722d4aa67f314a3$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ((0, $4Q81F.isResponse)(error)) try {
                let data2 = await $7722d4aa67f314a3$var$unwrapResponse(error);
                errorForSecondRender = new (0, $4Q81F.ErrorResponseImpl)(error.status, error.statusText, data2);
            } catch (e) {}
            context = (0, $4Q81F.getStaticContextFromError)(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $7722d4aa67f314a3$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $7722d4aa67f314a3$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $7722d4aa67f314a3$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $7722d4aa67f314a3$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $7722d4aa67f314a3$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let result = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (queryRoute)=>{
                try {
                    let innerResult = await queryRoute(request);
                    return handleQueryRouteResult(innerResult);
                } catch (error) {
                    return handleQueryRouteError(error);
                }
            } : void 0,
            normalizePath: (r)=>$7722d4aa67f314a3$var$getNormalizedPath(r, build.basename, build.future)
        });
        return handleQueryRouteResult(result);
    } catch (error) {
        return handleQueryRouteError(error);
    }
    function handleQueryRouteResult(result) {
        if ((0, $4Q81F.isResponse)(result)) return result;
        if (typeof result === "string") return new Response(result);
        return Response.json(result);
    }
    function handleQueryRouteError(error) {
        if ((0, $4Q81F.isResponse)(error)) return error;
        if ((0, $4Q81F.isRouteErrorResponse)(error)) {
            handleError(error);
            return $7722d4aa67f314a3$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $7722d4aa67f314a3$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $7722d4aa67f314a3$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $7722d4aa67f314a3$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($7722d4aa67f314a3$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText
    });
}
function $7722d4aa67f314a3$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $7722d4aa67f314a3$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $7722d4aa67f314a3$var$flash(name) {
    return `__flash_${name}__`;
}
var $7722d4aa67f314a3$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($7722d4aa67f314a3$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $7722d4aa67f314a3$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($7722d4aa67f314a3$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $7722d4aa67f314a3$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $7722d4aa67f314a3$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $7722d4aa67f314a3$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $7722d4aa67f314a3$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $7722d4aa67f314a3$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $7722d4aa67f314a3$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $7722d4aa67f314a3$var$warnOnceAboutSigningSessionCookie(cookie) {
    (0, $4Q81F.warnOnce)(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $7722d4aa67f314a3$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $7722d4aa67f314a3$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $7722d4aa67f314a3$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $7722d4aa67f314a3$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $7722d4aa67f314a3$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $7722d4aa67f314a3$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $7722d4aa67f314a3$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $7722d4aa67f314a3$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    let result = $7722d4aa67f314a3$var$trimTrailingSplat(path).replace(/\/:([\w-]+)(\?)?/g, // same regex as in .\router\utils.ts: compilePath().
    (_, param, questionMark)=>{
        const isRequired = questionMark === void 0;
        const value = params?.[param];
        if (isRequired && value === void 0) throw new Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value === void 0 ? "" : "/" + value;
    });
    if (path.endsWith("*")) {
        const value = params?.["*"];
        if (value !== void 0) result += "/" + value;
    }
    return result || "/";
}
function $7722d4aa67f314a3$var$trimTrailingSplat(path) {
    let i = path.length - 1;
    let char = path[i];
    if (char !== "*" && char !== "/") return path;
    i--;
    for(; i >= 0; i--){
        if (path[i] !== "/") break;
    }
    return path.slice(0, i + 1);
}
// lib/rsc/html-stream/server.ts
var $7722d4aa67f314a3$var$encoder2 = new TextEncoder();
var $7722d4aa67f314a3$var$trailer = "</body></html>";
function $7722d4aa67f314a3$var$injectRSCPayload(rscStream) {
    let decoder = new TextDecoder();
    let resolveFlightDataPromise;
    let flightDataPromise = new Promise((resolve)=>resolveFlightDataPromise = resolve);
    let startedRSC = false;
    let buffered = [];
    let timeout = null;
    function flushBufferedChunks(controller) {
        for (let chunk of buffered){
            let buf = decoder.decode(chunk, {
                stream: true
            });
            if (buf.endsWith($7722d4aa67f314a3$var$trailer)) buf = buf.slice(0, -$7722d4aa67f314a3$var$trailer.length);
            controller.enqueue($7722d4aa67f314a3$var$encoder2.encode(buf));
        }
        buffered.length = 0;
        timeout = null;
    }
    return new TransformStream({
        transform (chunk, controller) {
            buffered.push(chunk);
            if (timeout) return;
            timeout = setTimeout(async ()=>{
                flushBufferedChunks(controller);
                if (!startedRSC) {
                    startedRSC = true;
                    $7722d4aa67f314a3$var$writeRSCStream(rscStream, controller).catch((err)=>controller.error(err)).then(resolveFlightDataPromise);
                }
            }, 0);
        },
        async flush (controller) {
            await flightDataPromise;
            if (timeout) {
                clearTimeout(timeout);
                flushBufferedChunks(controller);
            }
            controller.enqueue($7722d4aa67f314a3$var$encoder2.encode("</body></html>"));
        }
    });
}
async function $7722d4aa67f314a3$var$writeRSCStream(rscStream, controller) {
    let decoder = new TextDecoder("utf-8", {
        fatal: true
    });
    const reader = rscStream.getReader();
    try {
        let read;
        while((read = await reader.read()) && !read.done){
            const chunk = read.value;
            try {
                $7722d4aa67f314a3$var$writeChunk(JSON.stringify(decoder.decode(chunk, {
                    stream: true
                })), controller);
            } catch (e) {
                let base64 = JSON.stringify(btoa(String.fromCodePoint(...chunk)));
                $7722d4aa67f314a3$var$writeChunk(`Uint8Array.from(atob(${base64}), m => m.codePointAt(0))`, controller);
            }
        }
    } finally{
        reader.releaseLock();
    }
    let remaining = decoder.decode();
    if (remaining.length) $7722d4aa67f314a3$var$writeChunk(JSON.stringify(remaining), controller);
}
function $7722d4aa67f314a3$var$writeChunk(chunk, controller) {
    controller.enqueue($7722d4aa67f314a3$var$encoder2.encode(`<script>${$7722d4aa67f314a3$var$escapeScript(`(self.__FLIGHT_DATA||=[]).push(${chunk})`)}</script>`));
}
function $7722d4aa67f314a3$var$escapeScript(script) {
    return script.replace(/<!--/g, "<\\!--").replace(/<\/(script)/gi, "</\\$1");
}
var $7722d4aa67f314a3$export$ea608ff93320d416 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: null,
            location: props.location
        };
        return {
            error: state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($7722d4aa67f314a3$var$RSCDefaultRootErrorBoundaryImpl, {
            error: this.state.error,
            renderAppShell: true
        });
        else return this.props.children;
    }
};
function $7722d4aa67f314a3$var$ErrorWrapper({ renderAppShell: renderAppShell, title: title, children: children }) {
    if (!renderAppShell) return children;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("head", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("title", null, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("body", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children)));
}
function $7722d4aa67f314a3$var$RSCDefaultRootErrorBoundaryImpl({ error: error, renderAppShell: renderAppShell }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $4Q81F.isRouteErrorResponse)(error)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($7722d4aa67f314a3$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), (0, $4Q81F.ENABLE_DEV_WARNINGS) ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($7722d4aa67f314a3$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Application Error!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $7722d4aa67f314a3$export$a55eecbda762d267({ hasRootLayout: hasRootLayout }) {
    let error = (0, $4Q81F.useRouteError)();
    if (hasRootLayout === void 0) throw new Error("Missing 'hasRootLayout' prop");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($spJKX))).createElement($7722d4aa67f314a3$var$RSCDefaultRootErrorBoundaryImpl, {
        renderAppShell: !hasRootLayout,
        error: error
    });
}
// lib/rsc/route-modules.ts
function $7722d4aa67f314a3$var$createRSCRouteModules(payload) {
    const routeModules = {};
    for (const match of payload.matches)$7722d4aa67f314a3$export$93a6ee970ac9d016(routeModules, match);
    return routeModules;
}
function $7722d4aa67f314a3$export$93a6ee970ac9d016(routeModules, matches) {
    matches = Array.isArray(matches) ? matches : [
        matches
    ];
    for (const match of matches)routeModules[match.id] = {
        links: match.links,
        meta: match.meta,
        default: $7722d4aa67f314a3$var$noopComponent
    };
}
var $7722d4aa67f314a3$var$noopComponent = ()=>null;
// lib/rsc/server.ssr.tsx
var $7722d4aa67f314a3$var$defaultManifestPath = "/__manifest";
var $7722d4aa67f314a3$var$REACT_USE = "use";
var $7722d4aa67f314a3$var$useImpl = $spJKX[$7722d4aa67f314a3$var$REACT_USE];
function $7722d4aa67f314a3$var$useSafe(promise) {
    if ($7722d4aa67f314a3$var$useImpl) return $7722d4aa67f314a3$var$useImpl(promise);
    throw new Error("React Router v7 requires React 19+ for RSC features.");
}
async function $7722d4aa67f314a3$export$144ccff01a5655fc({ request: request, serverResponse: serverResponse, createFromReadableStream: createFromReadableStream, renderHTML: renderHTML, hydrate: hydrate = true }) {
    const url = new URL(request.url);
    const isDataRequest = $7722d4aa67f314a3$var$isReactServerRequest(url);
    const respondWithRSCPayload = isDataRequest || $7722d4aa67f314a3$var$isManifestRequest(url) || request.headers.has("rsc-action-id");
    if (respondWithRSCPayload || serverResponse.headers.get("React-Router-Resource") === "true") return serverResponse;
    if (!serverResponse.body) throw new Error("Missing body in server response");
    const detectRedirectResponse = serverResponse.clone();
    let serverResponseB = null;
    if (hydrate) serverResponseB = serverResponse.clone();
    const body = serverResponse.body;
    let buffer;
    let streamControllers = [];
    const createStream = ()=>{
        if (!buffer) {
            buffer = [];
            return body.pipeThrough(new TransformStream({
                transform (chunk, controller) {
                    buffer.push(chunk);
                    controller.enqueue(chunk);
                    streamControllers.forEach((c)=>c.enqueue(chunk));
                },
                flush () {
                    streamControllers.forEach((c)=>c.close());
                    streamControllers = [];
                }
            }));
        }
        return new ReadableStream({
            start (controller) {
                buffer.forEach((chunk)=>controller.enqueue(chunk));
                streamControllers.push(controller);
            }
        });
    };
    let deepestRenderedBoundaryId = null;
    const getPayload = ()=>{
        const payloadPromise = Promise.resolve(createFromReadableStream(createStream()));
        return Object.defineProperties(payloadPromise, {
            _deepestRenderedBoundaryId: {
                get () {
                    return deepestRenderedBoundaryId;
                },
                set (boundaryId1) {
                    deepestRenderedBoundaryId = boundaryId1;
                }
            },
            formState: {
                get () {
                    return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                }
            }
        });
    };
    let renderRedirect;
    let renderError;
    try {
        if (!detectRedirectResponse.body) throw new Error("Failed to clone server response");
        const payload = await createFromReadableStream(detectRedirectResponse.body);
        if (serverResponse.status === (0, $4Q81F.SINGLE_FETCH_REDIRECT_STATUS) && payload.type === "redirect") {
            if ((0, $4Q81F.hasInvalidProtocol)(payload.location)) throw new Error("Invalid redirect location");
            const headers2 = new Headers(serverResponse.headers);
            headers2.delete("Content-Encoding");
            headers2.delete("Content-Length");
            headers2.delete("Content-Type");
            headers2.delete("X-Remix-Response");
            headers2.set("Location", payload.location);
            return new Response(serverResponseB?.body || "", {
                headers: headers2,
                status: payload.status,
                statusText: serverResponse.statusText
            });
        }
        let reactHeaders = new Headers();
        let status = serverResponse.status;
        let statusText = serverResponse.statusText;
        let html = await renderHTML(getPayload, {
            onError (error) {
                if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
                    renderRedirect = (0, $4Q81F.decodeRedirectErrorDigest)(error.digest);
                    if (renderRedirect) return error.digest;
                    let routeErrorResponse = (0, $4Q81F.decodeRouteErrorResponseDigest)(error.digest);
                    if (routeErrorResponse) {
                        renderError = routeErrorResponse;
                        status = routeErrorResponse.status;
                        statusText = routeErrorResponse.statusText;
                        return error.digest;
                    }
                }
            },
            onHeaders (headers2) {
                for (const [key, value] of headers2)reactHeaders.append(key, value);
            }
        });
        const headers = new Headers(reactHeaders);
        for (const [key, value] of serverResponse.headers)headers.append(key, value);
        headers.set("Content-Type", "text/html; charset=utf-8");
        if (renderRedirect) {
            if ((0, $4Q81F.hasInvalidProtocol)(renderRedirect.location)) throw new Error("Invalid redirect location");
            headers.set("Location", renderRedirect.location);
            return new Response(html, {
                status: renderRedirect.status,
                headers: headers
            });
        }
        const redirectTransform = new TransformStream({
            flush (controller) {
                if (renderRedirect) {
                    if ((0, $4Q81F.hasInvalidProtocol)(renderRedirect.location)) return;
                    controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $4Q81F.escapeAttribute)(renderRedirect.location)}"/>`));
                }
            }
        });
        if (!hydrate) return new Response(html.pipeThrough(redirectTransform), {
            status: status,
            statusText: statusText,
            headers: headers
        });
        if (!serverResponseB?.body) throw new Error("Failed to clone server response");
        const body2 = html.pipeThrough($7722d4aa67f314a3$var$injectRSCPayload(serverResponseB.body)).pipeThrough(redirectTransform);
        return new Response(body2, {
            status: status,
            statusText: statusText,
            headers: headers
        });
    } catch (error) {
        if (error instanceof Response) return error;
        if (renderRedirect) {
            if ((0, $4Q81F.hasInvalidProtocol)(renderRedirect.location)) throw new Error("Invalid redirect location");
            return new Response(`Redirect: ${renderRedirect.location}`, {
                status: renderRedirect.status,
                headers: {
                    Location: renderRedirect.location
                }
            });
        }
        try {
            let normalizedError = renderError ?? error;
            let [status, statusText] = (0, $4Q81F.isRouteErrorResponse)(normalizedError) ? [
                normalizedError.status,
                normalizedError.statusText
            ] : [
                500,
                ""
            ];
            let retryRedirect;
            let reactHeaders = new Headers();
            const html = await renderHTML(()=>{
                const decoded = Promise.resolve(createFromReadableStream(createStream()));
                const payloadPromise = decoded.then((payload)=>Object.assign(payload, {
                        status: status,
                        errors: deepestRenderedBoundaryId ? {
                            [deepestRenderedBoundaryId]: normalizedError
                        } : {}
                    }));
                return Object.defineProperties(payloadPromise, {
                    _deepestRenderedBoundaryId: {
                        get () {
                            return deepestRenderedBoundaryId;
                        },
                        set (boundaryId1) {
                            deepestRenderedBoundaryId = boundaryId1;
                        }
                    },
                    formState: {
                        get () {
                            return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                        }
                    }
                });
            }, {
                onError (error2) {
                    if (typeof error2 === "object" && error2 && "digest" in error2 && typeof error2.digest === "string") {
                        retryRedirect = (0, $4Q81F.decodeRedirectErrorDigest)(error2.digest);
                        if (retryRedirect) return error2.digest;
                        let routeErrorResponse = (0, $4Q81F.decodeRouteErrorResponseDigest)(error2.digest);
                        if (routeErrorResponse) {
                            status = routeErrorResponse.status;
                            statusText = routeErrorResponse.statusText;
                            return error2.digest;
                        }
                    }
                },
                onHeaders (headers2) {
                    for (const [key, value] of headers2)reactHeaders.append(key, value);
                }
            });
            const headers = new Headers(reactHeaders);
            for (const [key, value] of serverResponse.headers)headers.append(key, value);
            headers.set("Content-Type", "text/html; charset=utf-8");
            if (retryRedirect) {
                if ((0, $4Q81F.hasInvalidProtocol)(retryRedirect.location)) throw new Error("Invalid redirect location");
                headers.set("Location", retryRedirect.location);
                return new Response(html, {
                    status: retryRedirect.status,
                    headers: headers
                });
            }
            const retryRedirectTransform = new TransformStream({
                flush (controller) {
                    if (retryRedirect) {
                        if ((0, $4Q81F.hasInvalidProtocol)(retryRedirect.location)) return;
                        controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $4Q81F.escapeAttribute)(retryRedirect.location)}"/>`));
                    }
                }
            });
            if (!hydrate) return new Response(html.pipeThrough(retryRedirectTransform), {
                status: status,
                statusText: statusText,
                headers: headers
            });
            if (!serverResponseB?.body) throw new Error("Failed to clone server response");
            const body2 = html.pipeThrough($7722d4aa67f314a3$var$injectRSCPayload(serverResponseB.body)).pipeThrough(retryRedirectTransform);
            return new Response(body2, {
                status: status,
                statusText: statusText,
                headers: headers
            });
        } catch (error2) {}
        throw error;
    }
}
function $7722d4aa67f314a3$export$7f2da8ab5e593830({ getPayload: getPayload }) {
    const decoded = getPayload();
    const payload = $7722d4aa67f314a3$var$useSafe(decoded);
    if (payload.type === "redirect") {
        if ((0, $4Q81F.hasInvalidProtocol)(payload.location)) throw new Error("Invalid redirect location");
        throw new Response(null, {
            status: payload.status,
            headers: {
                Location: payload.location
            }
        });
    }
    if (payload.type !== "render") return null;
    let patchedLoaderData = {
        ...payload.loaderData
    };
    for (const match of payload.matches)if ((0, $4Q81F.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false) && (match.hydrateFallbackElement || !match.hasLoader)) delete patchedLoaderData[match.id];
    const context = {
        get _deepestRenderedBoundaryId () {
            return decoded._deepestRenderedBoundaryId ?? null;
        },
        set _deepestRenderedBoundaryId (boundaryId){
            decoded._deepestRenderedBoundaryId = boundaryId;
        },
        actionData: payload.actionData,
        actionHeaders: {},
        basename: payload.basename,
        errors: payload.errors,
        loaderData: patchedLoaderData,
        loaderHeaders: {},
        location: payload.location,
        statusCode: 200,
        matches: payload.matches.map((match)=>({
                params: match.params,
                pathname: match.pathname,
                pathnameBase: match.pathnameBase,
                route: {
                    id: match.id,
                    action: match.hasAction || !!match.clientAction,
                    handle: match.handle,
                    hasErrorBoundary: match.hasErrorBoundary,
                    loader: match.hasLoader || !!match.clientLoader,
                    index: match.index,
                    path: match.path,
                    shouldRevalidate: match.shouldRevalidate
                }
            }))
    };
    const router = (0, $4Q81F.createStaticRouter)(payload.matches.reduceRight((previous, match)=>{
        const route = {
            id: match.id,
            action: match.hasAction || !!match.clientAction,
            element: match.element,
            errorElement: match.errorElement,
            handle: match.handle,
            hasErrorBoundary: !!match.errorElement,
            hydrateFallbackElement: match.hydrateFallbackElement,
            index: match.index,
            loader: match.hasLoader || !!match.clientLoader,
            path: match.path,
            shouldRevalidate: match.shouldRevalidate
        };
        if (previous.length > 0) route.children = previous;
        return [
            route
        ];
    }, []), context);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $7722d4aa67f314a3$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $7722d4aa67f314a3$var$defaultManifestPath
        },
        routeModules: $7722d4aa67f314a3$var$createRSCRouteModules(payload)
    };
    return /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $spJKX.createElement($7722d4aa67f314a3$export$ea608ff93320d416, {
        location: payload.location
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.StaticRouterProvider), {
        context: context,
        router: router,
        hydrate: false,
        nonce: payload.nonce
    }))));
}
function $7722d4aa67f314a3$var$isReactServerRequest(url) {
    return url.pathname.endsWith(".rsc");
}
function $7722d4aa67f314a3$var$isManifestRequest(url) {
    return url.pathname.endsWith(".manifest");
}
// lib/dom/ssr/hydration.tsx
function $7722d4aa67f314a3$export$6fa8d910d97963ad({ state: state, routes: routes, getRouteInfo: getRouteInfo, location: location, basename: basename, isSpaMode: isSpaMode }) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = (0, $4Q81F.matchRoutes)(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ((0, $4Q81F.shouldHydrateRouteLoader)(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}



var $4Q81F = parcelRequire("4Q81F");

var $spJKX = parcelRequire("spJKX");

var $oS63j = parcelRequire("oS63j");
"use client";
function $c65fa4b5e940c52b$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RouterProvider), {
        flushSync: $oS63j.flushSync,
        ...props
    });
}
var $c65fa4b5e940c52b$var$ssrInfo = null;
var $c65fa4b5e940c52b$var$router = null;
function $c65fa4b5e940c52b$var$initSsrInfo() {
    if (!$c65fa4b5e940c52b$var$ssrInfo && window.__reactRouterContext && window.__reactRouterManifest && window.__reactRouterRouteModules) {
        if (window.__reactRouterManifest.sri === true) {
            const importMap = document.querySelector("script[rr-importmap]");
            if (importMap?.textContent) try {
                window.__reactRouterManifest.sri = JSON.parse(importMap.textContent).integrity;
            } catch (err) {
                console.error("Failed to parse import map", err);
            }
        }
        $c65fa4b5e940c52b$var$ssrInfo = {
            context: window.__reactRouterContext,
            manifest: window.__reactRouterManifest,
            routeModules: window.__reactRouterRouteModules,
            stateDecodingPromise: void 0,
            router: void 0,
            routerInitialized: false
        };
    }
}
function $c65fa4b5e940c52b$var$createHydratedRouter({ getContext: getContext, instrumentations: instrumentations }) {
    $c65fa4b5e940c52b$var$initSsrInfo();
    if (!$c65fa4b5e940c52b$var$ssrInfo) throw new Error("You must be using the SSR features of React Router in order to skip passing a `router` prop to `<RouterProvider>`");
    let localSsrInfo = $c65fa4b5e940c52b$var$ssrInfo;
    if (!$c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise) {
        let stream = $c65fa4b5e940c52b$var$ssrInfo.context.stream;
        (0, $4Q81F.invariant)(stream, "No stream found for single fetch decoding");
        $c65fa4b5e940c52b$var$ssrInfo.context.stream = void 0;
        $c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise = (0, $4Q81F.decodeViaTurboStream)(stream, window).then((value)=>{
            $c65fa4b5e940c52b$var$ssrInfo.context.state = value.value;
            localSsrInfo.stateDecodingPromise.value = true;
        }).catch((e)=>{
            localSsrInfo.stateDecodingPromise.error = e;
        });
    }
    if ($c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise.error) throw $c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise.error;
    if (!$c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise.value) throw $c65fa4b5e940c52b$var$ssrInfo.stateDecodingPromise;
    let routes = (0, $4Q81F.createClientRoutes)($c65fa4b5e940c52b$var$ssrInfo.manifest.routes, $c65fa4b5e940c52b$var$ssrInfo.routeModules, $c65fa4b5e940c52b$var$ssrInfo.context.state, $c65fa4b5e940c52b$var$ssrInfo.context.ssr, $c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode);
    let hydrationData = void 0;
    if ($c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode) {
        let { loaderData: loaderData } = $c65fa4b5e940c52b$var$ssrInfo.context.state;
        if ($c65fa4b5e940c52b$var$ssrInfo.manifest.routes.root?.hasLoader && loaderData && "root" in loaderData) hydrationData = {
            loaderData: {
                root: loaderData.root
            }
        };
    } else hydrationData = (0, $7722d4aa67f314a3$export$6fa8d910d97963ad)({
        state: $c65fa4b5e940c52b$var$ssrInfo.context.state,
        routes: routes,
        getRouteInfo: (routeId)=>({
                clientLoader: $c65fa4b5e940c52b$var$ssrInfo.routeModules[routeId]?.clientLoader,
                hasLoader: $c65fa4b5e940c52b$var$ssrInfo.manifest.routes[routeId]?.hasLoader === true,
                hasHydrateFallback: $c65fa4b5e940c52b$var$ssrInfo.routeModules[routeId]?.HydrateFallback != null
            }),
        location: window.location,
        basename: window.__reactRouterContext?.basename,
        isSpaMode: $c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode
    });
    if (window.history.state && window.history.state.masked) window.history.replaceState({
        ...window.history.state,
        masked: void 0
    }, "");
    let router2 = (0, $4Q81F.createRouter)({
        routes: routes,
        history: (0, $4Q81F.createBrowserHistory)(),
        basename: $c65fa4b5e940c52b$var$ssrInfo.context.basename,
        getContext: getContext,
        hydrationData: hydrationData,
        hydrationRouteProperties: $4Q81F.hydrationRouteProperties,
        instrumentations: instrumentations,
        mapRouteProperties: $4Q81F.mapRouteProperties,
        future: {
            v8_passThroughRequests: $c65fa4b5e940c52b$var$ssrInfo.context.future.v8_passThroughRequests
        },
        dataStrategy: (0, $4Q81F.getTurboStreamSingleFetchDataStrategy)(()=>router2, $c65fa4b5e940c52b$var$ssrInfo.manifest, $c65fa4b5e940c52b$var$ssrInfo.routeModules, $c65fa4b5e940c52b$var$ssrInfo.context.ssr, $c65fa4b5e940c52b$var$ssrInfo.context.basename, $c65fa4b5e940c52b$var$ssrInfo.context.future.v8_trailingSlashAwareDataRequests),
        patchRoutesOnNavigation: (0, $4Q81F.getPatchRoutesOnNavigationFunction)(()=>router2, $c65fa4b5e940c52b$var$ssrInfo.manifest, $c65fa4b5e940c52b$var$ssrInfo.routeModules, $c65fa4b5e940c52b$var$ssrInfo.context.ssr, $c65fa4b5e940c52b$var$ssrInfo.context.routeDiscovery, $c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode, $c65fa4b5e940c52b$var$ssrInfo.context.basename)
    });
    $c65fa4b5e940c52b$var$ssrInfo.router = router2;
    if (router2.state.initialized) {
        $c65fa4b5e940c52b$var$ssrInfo.routerInitialized = true;
        router2.initialize();
    }
    router2.createRoutesForHMR = /* spacer so ts-ignore does not affect the right hand of the assignment */ (0, $4Q81F.createClientRoutesWithHMRRevalidationOptOut);
    window.__reactRouterDataRouter = router2;
    return router2;
}
function $c65fa4b5e940c52b$export$63ce90781bf4d238(props) {
    if (!$c65fa4b5e940c52b$var$router) $c65fa4b5e940c52b$var$router = $c65fa4b5e940c52b$var$createHydratedRouter({
        getContext: props.getContext,
        instrumentations: props.instrumentations
    });
    let [criticalCss, setCriticalCss] = $spJKX.useState(void 0);
    $spJKX.useEffect(()=>{}, []);
    $spJKX.useEffect(()=>{
        var element;
    }, [
        criticalCss
    ]);
    let [location2, setLocation] = $spJKX.useState($c65fa4b5e940c52b$var$router.state.location);
    $spJKX.useLayoutEffect(()=>{
        if ($c65fa4b5e940c52b$var$ssrInfo && $c65fa4b5e940c52b$var$ssrInfo.router && !$c65fa4b5e940c52b$var$ssrInfo.routerInitialized) {
            $c65fa4b5e940c52b$var$ssrInfo.routerInitialized = true;
            $c65fa4b5e940c52b$var$ssrInfo.router.initialize();
        }
    }, []);
    $spJKX.useLayoutEffect(()=>{
        if ($c65fa4b5e940c52b$var$ssrInfo && $c65fa4b5e940c52b$var$ssrInfo.router) return $c65fa4b5e940c52b$var$ssrInfo.router.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        });
    }, [
        location2
    ]);
    (0, $4Q81F.invariant)($c65fa4b5e940c52b$var$ssrInfo, "ssrInfo unavailable for HydratedRouter");
    (0, $4Q81F.useFogOFWarDiscovery)($c65fa4b5e940c52b$var$router, $c65fa4b5e940c52b$var$ssrInfo.manifest, $c65fa4b5e940c52b$var$ssrInfo.routeModules, $c65fa4b5e940c52b$var$ssrInfo.context.ssr, $c65fa4b5e940c52b$var$ssrInfo.context.routeDiscovery, $c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode);
    return(// This fragment is important to ensure we match the <ServerRouter> JSX
    // structure so that useId values hydrate correctly
    /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.FrameworkContext).Provider, {
        value: {
            manifest: $c65fa4b5e940c52b$var$ssrInfo.manifest,
            routeModules: $c65fa4b5e940c52b$var$ssrInfo.routeModules,
            future: $c65fa4b5e940c52b$var$ssrInfo.context.future,
            criticalCss: criticalCss,
            ssr: $c65fa4b5e940c52b$var$ssrInfo.context.ssr,
            isSpaMode: $c65fa4b5e940c52b$var$ssrInfo.context.isSpaMode,
            routeDiscovery: $c65fa4b5e940c52b$var$ssrInfo.context.routeDiscovery
        }
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RemixErrorBoundary), {
        location: location2
    }, /* @__PURE__ */ $spJKX.createElement($c65fa4b5e940c52b$export$323e4fc2fa4753fb, {
        router: $c65fa4b5e940c52b$var$router,
        useTransitions: props.useTransitions,
        onError: props.onError
    }))), /* @__PURE__ */ $spJKX.createElement($spJKX.Fragment, null)));
}
var $c65fa4b5e940c52b$var$defaultManifestPath = "/__manifest";
function $c65fa4b5e940c52b$export$e5e8f3607b669df({ createFromReadableStream: createFromReadableStream, createTemporaryReferenceSet: createTemporaryReferenceSet, encodeReply: encodeReply, fetch: fetchImplementation = fetch }) {
    const globalVar = window;
    let landedActionId = 0;
    return async (id, args)=>{
        let actionId = globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
        const temporaryReferences = createTemporaryReferenceSet();
        const payloadPromise = fetchImplementation(new Request(location.href, {
            body: await encodeReply(args, {
                temporaryReferences: temporaryReferences
            }),
            method: "POST",
            headers: {
                Accept: "text/x-component",
                "rsc-action-id": id
            }
        })).then((response)=>{
            if (!response.body) throw new Error("No response body");
            return createFromReadableStream(response.body, {
                temporaryReferences: temporaryReferences
            });
        });
        $spJKX.startTransition(()=>// @ts-expect-error - Needs React 19 types
            Promise.resolve(payloadPromise).then(async (payload)=>{
                if (payload.type === "redirect") {
                    let location2 = $c65fa4b5e940c52b$var$normalizeRedirectLocation(payload.location);
                    (0, $4Q81F.validateNavigationTarget)(payload.location, location2, new URL(window.location.href), "allow-explicit");
                    if (payload.reload || $c65fa4b5e940c52b$var$isExternalLocation(location2)) {
                        if ((0, $4Q81F.hasInvalidProtocol)(location2)) throw new Error("Invalid redirect location");
                        window.location.href = location2;
                        return;
                    }
                    $spJKX.startTransition(()=>{
                        globalVar.__reactRouterDataRouter.navigate(location2, {
                            replace: payload.replace
                        });
                    });
                    return;
                }
                if (payload.type !== "action") throw new Error("Unexpected payload type");
                const rerender = await payload.rerender;
                if (rerender && landedActionId < actionId && globalVar.__routerActionID <= actionId) {
                    if (rerender.type === "redirect") {
                        let location2 = $c65fa4b5e940c52b$var$normalizeRedirectLocation(rerender.location);
                        (0, $4Q81F.validateNavigationTarget)(rerender.location, location2, new URL(window.location.href), "allow-explicit");
                        if (rerender.reload || $c65fa4b5e940c52b$var$isExternalLocation(location2)) {
                            if ((0, $4Q81F.hasInvalidProtocol)(location2)) throw new Error("Invalid redirect location");
                            window.location.href = location2;
                            return;
                        }
                        $spJKX.startTransition(()=>{
                            globalVar.__reactRouterDataRouter.navigate(location2, {
                                replace: rerender.replace
                            });
                        });
                        return;
                    }
                    $spJKX.startTransition(()=>{
                        let lastMatch;
                        for (const match of rerender.matches){
                            globalVar.__reactRouterDataRouter.patchRoutes(lastMatch?.id ?? null, [
                                $c65fa4b5e940c52b$var$createRouteFromServerManifest(match)
                            ], true);
                            lastMatch = match;
                        }
                        window.__reactRouterDataRouter._internalSetStateDoNotUseOrYouWillBreakYourApp({
                            loaderData: Object.assign({}, globalVar.__reactRouterDataRouter.state.loaderData, rerender.loaderData),
                            errors: rerender.errors ? Object.assign({}, globalVar.__reactRouterDataRouter.state.errors, rerender.errors) : null
                        });
                    });
                }
            }).catch(()=>{}));
        return payloadPromise.then((payload)=>{
            if (payload.type !== "action" && payload.type !== "redirect") throw new Error("Unexpected payload type");
            return payload.actionResult;
        });
    };
}
function $c65fa4b5e940c52b$var$createRouterFromPayload({ fetchImplementation: fetchImplementation, createFromReadableStream: createFromReadableStream, getContext: getContext, payload: payload }) {
    const globalVar = window;
    if (globalVar.__reactRouterDataRouter && globalVar.__reactRouterRouteModules) return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
    if (payload.type !== "render") throw new Error("Invalid payload type");
    globalVar.__reactRouterRouteModules = globalVar.__reactRouterRouteModules ?? {};
    (0, $7722d4aa67f314a3$export$93a6ee970ac9d016)(globalVar.__reactRouterRouteModules, payload.matches);
    let routes = payload.matches.reduceRight((previous, match)=>{
        const route = $c65fa4b5e940c52b$var$createRouteFromServerManifest(match, payload);
        if (previous.length > 0) route.children = previous;
        else if (!route.index) route.children = [];
        return [
            route
        ];
    }, []);
    let applyPatchesPromise;
    globalVar.__reactRouterDataRouter = (0, $4Q81F.createRouter)({
        routes: routes,
        getContext: getContext,
        basename: payload.basename,
        history: (0, $4Q81F.createBrowserHistory)(),
        hydrationData: (0, $7722d4aa67f314a3$export$6fa8d910d97963ad)({
            state: {
                loaderData: payload.loaderData,
                actionData: payload.actionData,
                errors: payload.errors
            },
            routes: routes,
            getRouteInfo: (routeId)=>{
                let match = payload.matches.find((m)=>m.id === routeId);
                (0, $4Q81F.invariant)(match, "Route not found in payload");
                return {
                    clientLoader: match.clientLoader,
                    hasLoader: match.hasLoader,
                    hasHydrateFallback: match.hydrateFallbackElement != null
                };
            },
            location: payload.location,
            basename: payload.basename,
            isSpaMode: false
        }),
        async patchRoutesOnNavigation ({ path: path, signal: signal }) {
            if (payload.routeDiscovery.mode === "initial") {
                if (!applyPatchesPromise) applyPatchesPromise = (async ()=>{
                    if (!payload.patches) return;
                    let patches = await payload.patches;
                    $spJKX.startTransition(()=>{
                        patches.forEach((p)=>{
                            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                                $c65fa4b5e940c52b$var$createRouteFromServerManifest(p)
                            ]);
                        });
                    });
                })();
                await applyPatchesPromise;
                return;
            }
            if ($c65fa4b5e940c52b$var$discoveredPaths.has(path)) return;
            await $c65fa4b5e940c52b$var$fetchAndApplyManifestPatches([
                path
            ], createFromReadableStream, fetchImplementation, signal);
        },
        // FIXME: Pass `build.ssr` into this function
        dataStrategy: $c65fa4b5e940c52b$var$getRSCSingleFetchDataStrategy(()=>globalVar.__reactRouterDataRouter, true, payload.basename, createFromReadableStream, fetchImplementation)
    });
    if (globalVar.__reactRouterDataRouter.state.initialized) {
        globalVar.__routerInitialized = true;
        globalVar.__reactRouterDataRouter.initialize();
    } else globalVar.__routerInitialized = false;
    let lastLoaderData = void 0;
    globalVar.__reactRouterDataRouter.subscribe(({ loaderData: loaderData, actionData: actionData })=>{
        if (lastLoaderData !== loaderData) globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
    });
    globalVar.__reactRouterDataRouter._updateRoutesForHMR = (routeUpdateByRouteId)=>{
        const oldRoutes = window.__reactRouterDataRouter.routes;
        const newRoutes = [];
        function walkRoutes(routes2, parentId) {
            return routes2.map((route)=>{
                const routeUpdate = routeUpdateByRouteId.get(route.id);
                if (routeUpdate) {
                    const { routeModule: routeModule, hasAction: hasAction, hasComponent: hasComponent, hasErrorBoundary: hasErrorBoundary, hasLoader: hasLoader } = routeUpdate;
                    const newRoute = $c65fa4b5e940c52b$var$createRouteFromServerManifest({
                        clientAction: routeModule.clientAction,
                        clientLoader: routeModule.clientLoader,
                        element: route.element,
                        errorElement: route.errorElement,
                        handle: route.handle,
                        hasAction: hasAction,
                        hasComponent: hasComponent,
                        hasErrorBoundary: hasErrorBoundary,
                        hasLoader: hasLoader,
                        hydrateFallbackElement: route.hydrateFallbackElement,
                        id: route.id,
                        index: route.index,
                        links: routeModule.links,
                        meta: routeModule.meta,
                        parentId: parentId,
                        path: route.path,
                        shouldRevalidate: routeModule.shouldRevalidate
                    });
                    if (route.children) newRoute.children = walkRoutes(route.children, route.id);
                    return newRoute;
                }
                const updatedRoute = {
                    ...route
                };
                if (route.children) updatedRoute.children = walkRoutes(route.children, route.id);
                return updatedRoute;
            });
        }
        newRoutes.push(...walkRoutes(oldRoutes, void 0));
        window.__reactRouterDataRouter._internalSetRoutes(newRoutes);
    };
    return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
}
var $c65fa4b5e940c52b$var$renderedRoutesContext = (0, $4Q81F.createContext)();
function $c65fa4b5e940c52b$var$getRSCSingleFetchDataStrategy(getRouter, ssr, basename, createFromReadableStream, fetchImplementation) {
    let dataStrategy = (0, $4Q81F.getSingleFetchDataStrategyImpl)(getRouter, (match)=>{
        let M = match;
        return {
            hasLoader: M.route.hasLoader,
            hasClientLoader: M.route.hasClientLoader,
            hasComponent: M.route.hasComponent,
            hasAction: M.route.hasAction,
            hasClientAction: M.route.hasClientAction
        };
    }, // pass map into fetchAndDecode so it can add payloads
    $c65fa4b5e940c52b$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation), ssr, basename, // .rsc requests are always trailing slash aware
    true, // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    (match)=>{
        let M = match;
        return M.route.hasComponent && !M.route.element;
    });
    return async (args)=>args.runClientMiddleware(async ()=>{
            let context = args.context;
            context.set($c65fa4b5e940c52b$var$renderedRoutesContext, []);
            let results = await dataStrategy(args);
            const renderedRoutesById = /* @__PURE__ */ new Map();
            for (const route of context.get($c65fa4b5e940c52b$var$renderedRoutesContext)){
                if (!renderedRoutesById.has(route.id)) renderedRoutesById.set(route.id, []);
                renderedRoutesById.get(route.id).push(route);
            }
            $spJKX.startTransition(()=>{
                for (const match of args.matches){
                    const renderedRoutes = renderedRoutesById.get(match.route.id);
                    if (renderedRoutes) for (const rendered of renderedRoutes)window.__reactRouterDataRouter.patchRoutes(rendered.parentId ?? null, [
                        $c65fa4b5e940c52b$var$createRouteFromServerManifest(rendered)
                    ], true);
                }
            });
            return results;
        });
}
function $c65fa4b5e940c52b$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation) {
    return async (args, basename, trailingSlashAware, targetRoutes)=>{
        let { request: request, context: context } = args;
        let url = (0, $4Q81F.singleFetchUrl)(request.url, basename, trailingSlashAware, "rsc");
        if (request.method === "GET") {
            url = (0, $4Q81F.stripIndexParam)(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let res = await fetchImplementation(new Request(url, await (0, $4Q81F.createRequestInit)(request)));
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $4Q81F.ErrorResponseImpl)(res.status, res.statusText, await res.text());
        (0, $4Q81F.invariant)(res.body, "No response body to decode");
        try {
            const payload = await createFromReadableStream(res.body, {
                temporaryReferences: void 0
            });
            if (payload.type === "redirect") return {
                status: res.status,
                data: {
                    redirect: {
                        redirect: payload.location,
                        reload: payload.reload,
                        replace: payload.replace,
                        revalidate: false,
                        status: payload.status
                    }
                }
            };
            if (payload.type !== "render") throw new Error("Unexpected payload type");
            context.get($c65fa4b5e940c52b$var$renderedRoutesContext).push(...payload.matches);
            let results = {
                routes: {}
            };
            const dataKey = (0, $4Q81F.isMutationMethod)(request.method) ? "actionData" : "loaderData";
            for (let [routeId, data] of Object.entries(payload[dataKey] || {}))results.routes[routeId] = {
                data: data
            };
            if (payload.errors) for (let [routeId, error] of Object.entries(payload.errors))results.routes[routeId] = {
                error: error
            };
            return {
                status: res.status,
                data: results
            };
        } catch (cause) {
            throw new Error("Unable to decode RSC response", {
                cause: cause
            });
        }
    };
}
function $c65fa4b5e940c52b$export$af9dbdb90aaefbae({ createFromReadableStream: createFromReadableStream, fetch: fetchImplementation = fetch, payload: payload, getContext: getContext }) {
    if (payload.type !== "render") throw new Error("Invalid payload type");
    let { routeDiscovery: routeDiscovery } = payload;
    let { router: router2, routeModules: routeModules } = $spJKX.useMemo(()=>$c65fa4b5e940c52b$var$createRouterFromPayload({
            payload: payload,
            fetchImplementation: fetchImplementation,
            getContext: getContext,
            createFromReadableStream: createFromReadableStream
        }), [
        createFromReadableStream,
        payload,
        fetchImplementation,
        getContext
    ]);
    $spJKX.useEffect(()=>{
        (0, $4Q81F.setIsHydrated)();
    }, []);
    $spJKX.useLayoutEffect(()=>{
        const globalVar = window;
        if (!globalVar.__routerInitialized) {
            globalVar.__routerInitialized = true;
            globalVar.__reactRouterDataRouter.initialize();
        }
    }, []);
    let [{ routes: routes, state: state }, setState] = $spJKX.useState(()=>({
            routes: $c65fa4b5e940c52b$var$cloneRoutes(router2.routes),
            state: router2.state
        }));
    $spJKX.useLayoutEffect(()=>router2.subscribe((newState)=>{
            if ($c65fa4b5e940c52b$var$diffRoutes(router2.routes, routes)) $spJKX.startTransition(()=>{
                setState({
                    routes: $c65fa4b5e940c52b$var$cloneRoutes(router2.routes),
                    state: newState
                });
            });
        }), [
        router2.subscribe,
        routes,
        router2
    ]);
    const transitionEnabledRouter = $spJKX.useMemo(()=>({
            ...router2,
            state: state,
            routes: routes
        }), [
        router2,
        routes,
        state
    ]);
    $spJKX.useEffect(()=>{
        if (routeDiscovery.mode === "initial" || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c65fa4b5e940c52b$var$discoveredPaths.has(pathname)) $c65fa4b5e940c52b$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let paths = Array.from($c65fa4b5e940c52b$var$nextPaths.keys()).filter((path)=>{
                if ($c65fa4b5e940c52b$var$discoveredPaths.has(path)) {
                    $c65fa4b5e940c52b$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (paths.length === 0) return;
            try {
                await $c65fa4b5e940c52b$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c65fa4b5e940c52b$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
    }, [
        routeDiscovery,
        createFromReadableStream,
        fetchImplementation
    ]);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            v8_trailingSlashAwareDataRequests: true,
            // always on for RSC
            v8_passThroughRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: payload.routeDiscovery.mode === "initial" ? {
            mode: "initial",
            manifestPath: $c65fa4b5e940c52b$var$defaultManifestPath
        } : {
            mode: "lazy",
            manifestPath: payload.routeDiscovery.manifestPath || $c65fa4b5e940c52b$var$defaultManifestPath
        },
        routeModules: routeModules
    };
    return /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RSCRouterContext).Provider, {
        value: true
    }, /* @__PURE__ */ $spJKX.createElement((0, $7722d4aa67f314a3$export$ea608ff93320d416), {
        location: state.location
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.FrameworkContext).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $spJKX.createElement((0, $4Q81F.RouterProvider), {
        router: transitionEnabledRouter,
        flushSync: $oS63j.flushSync
    }))));
}
function $c65fa4b5e940c52b$var$createRouteFromServerManifest(match, payload) {
    let hasInitialData = payload && match.id in payload.loaderData;
    let initialData = payload?.loaderData[match.id];
    let hasInitialError = payload?.errors && match.id in payload.errors;
    let initialError = payload?.errors?.[match.id];
    let isHydrationRequest = match.clientLoader?.hydrate === true || !match.hasLoader || // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    match.hasComponent && !match.element;
    (0, $4Q81F.invariant)(window.__reactRouterRouteModules);
    (0, $7722d4aa67f314a3$export$93a6ee970ac9d016)(window.__reactRouterRouteModules, match);
    let dataRoute = {
        id: match.id,
        element: match.element,
        errorElement: match.errorElement,
        handle: match.handle,
        hasErrorBoundary: match.hasErrorBoundary,
        hydrateFallbackElement: match.hydrateFallbackElement,
        index: match.index,
        loader: match.clientLoader ? async (args, singleFetch)=>{
            let _isHydrationRequest = isHydrationRequest;
            isHydrationRequest = false;
            let result = await match.clientLoader({
                ...args,
                serverLoader: ()=>{
                    $c65fa4b5e940c52b$var$preventInvalidServerHandlerCall("loader", match.id, match.hasLoader);
                    if (_isHydrationRequest) {
                        if (hasInitialData) return initialData;
                        if (hasInitialError) throw initialError;
                    }
                    return $c65fa4b5e940c52b$var$callSingleFetch(singleFetch);
                }
            });
            return result;
        } : // We always make the call in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        (_, singleFetch)=>$c65fa4b5e940c52b$var$callSingleFetch(singleFetch),
        action: match.clientAction ? (args, singleFetch)=>match.clientAction({
                ...args,
                serverAction: async ()=>{
                    $c65fa4b5e940c52b$var$preventInvalidServerHandlerCall("action", match.id, match.hasLoader);
                    return await $c65fa4b5e940c52b$var$callSingleFetch(singleFetch);
                }
            }) : match.hasAction ? (_, singleFetch)=>$c65fa4b5e940c52b$var$callSingleFetch(singleFetch) : ()=>{
            throw (0, $4Q81F.noActionDefinedError)("action", match.id);
        },
        path: match.path,
        shouldRevalidate: match.shouldRevalidate,
        // We always have a "loader" in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        hasLoader: true,
        hasClientLoader: match.clientLoader != null,
        hasAction: match.hasAction,
        hasClientAction: match.clientAction != null
    };
    if (typeof dataRoute.loader === "function") dataRoute.loader.hydrate = (0, $4Q81F.shouldHydrateRouteLoader)(match.id, match.clientLoader, match.hasLoader, false);
    return dataRoute;
}
function $c65fa4b5e940c52b$var$callSingleFetch(singleFetch) {
    (0, $4Q81F.invariant)(typeof singleFetch === "function", "Invalid singleFetch parameter");
    return singleFetch();
}
function $c65fa4b5e940c52b$var$preventInvalidServerHandlerCall(type, routeId, hasHandler) {
    if (!hasHandler) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${routeId}")`;
        console.error(msg);
        throw new (0, $4Q81F.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
var $c65fa4b5e940c52b$var$nextPaths = /* @__PURE__ */ new Set();
var $c65fa4b5e940c52b$var$discoveredPathsMaxSize = 1e3;
var $c65fa4b5e940c52b$var$discoveredPaths = /* @__PURE__ */ new Set();
function $c65fa4b5e940c52b$var$getManifestUrl(paths) {
    if (paths.length === 0) return null;
    if (paths.length === 1) return new URL(`${paths[0]}.manifest`, window.location.origin);
    const globalVar = window;
    let basename = (globalVar.__reactRouterDataRouter.basename ?? "").replace(/^\/|\/$/g, "");
    let url = new URL(`${basename}/.manifest`, window.location.origin);
    url.searchParams.set("paths", paths.sort().join(","));
    return url;
}
async function $c65fa4b5e940c52b$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation, signal) {
    paths = (0, $4Q81F.getPathsWithAncestors)(paths);
    let url = $c65fa4b5e940c52b$var$getManifestUrl(paths);
    if (url == null) return;
    if (url.toString().length > (0, $4Q81F.URL_LIMIT)) {
        $c65fa4b5e940c52b$var$nextPaths.clear();
        return;
    }
    let response = await fetchImplementation(new Request(url, {
        signal: signal
    }));
    if (!response.body || response.status < 200 || response.status >= 300) throw new Error("Unable to fetch new route matches from the server");
    let payload = await createFromReadableStream(response.body, {
        temporaryReferences: void 0
    });
    if (payload.type !== "manifest") throw new Error("Failed to patch routes");
    paths.forEach((p)=>$c65fa4b5e940c52b$var$addToFifoQueue(p, $c65fa4b5e940c52b$var$discoveredPaths));
    let patches = await payload.patches;
    $spJKX.startTransition(()=>{
        patches.forEach((p)=>{
            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                $c65fa4b5e940c52b$var$createRouteFromServerManifest(p)
            ]);
        });
    });
}
function $c65fa4b5e940c52b$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c65fa4b5e940c52b$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (typeof first === "string") queue.delete(first);
    }
    queue.add(path);
}
function $c65fa4b5e940c52b$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
function $c65fa4b5e940c52b$var$isExternalLocation(location2) {
    const newLocation = new URL(location2, window.location.href);
    return newLocation.origin !== window.location.origin;
}
function $c65fa4b5e940c52b$var$normalizeRedirectLocation(location2) {
    if ((0, $4Q81F.PROTOCOL_RELATIVE_URL_REGEX).test(location2)) {
        let path = (0, $4Q81F.resolvePath)(location2);
        return path.pathname + path.search + path.hash;
    }
    return location2;
}
function $c65fa4b5e940c52b$var$cloneRoutes(routes) {
    if (!routes) return void 0;
    return routes.map((route)=>({
            ...route,
            children: $c65fa4b5e940c52b$var$cloneRoutes(route.children)
        }));
}
function $c65fa4b5e940c52b$var$diffRoutes(a, b) {
    if (a.length !== b.length) return true;
    return a.some((route, index)=>{
        if (route.element !== b[index].element) return true;
        if (route.errorElement !== b[index].errorElement) return true;
        if (route.hydrateFallbackElement !== b[index].hydrateFallbackElement) return true;
        if (route.hasErrorBoundary !== b[index].hasErrorBoundary) return true;
        if (route.hasLoader !== b[index].hasLoader) return true;
        if (route.hasClientLoader !== b[index].hasClientLoader) return true;
        if (route.hasAction !== b[index].hasAction) return true;
        if (route.hasClientAction !== b[index].hasClientAction) return true;
        return $c65fa4b5e940c52b$var$diffRoutes(route.children || [], b[index].children || []);
    });
}
// lib/rsc/html-stream/browser.ts
function $c65fa4b5e940c52b$export$f4bb6b48866e43b() {
    let encoder = new TextEncoder();
    let streamController = null;
    let rscStream = new ReadableStream({
        start (controller) {
            if (typeof window === "undefined") return;
            let handleChunk = (chunk)=>{
                if (typeof chunk === "string") controller.enqueue(encoder.encode(chunk));
                else controller.enqueue(chunk);
            };
            window.__FLIGHT_DATA || (window.__FLIGHT_DATA = []);
            window.__FLIGHT_DATA.forEach(handleChunk);
            window.__FLIGHT_DATA.push = (chunk)=>{
                handleChunk(chunk);
                return 0;
            };
            streamController = controller;
        }
    });
    if (typeof document !== "undefined" && document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        streamController?.close();
    });
    else streamController?.close();
    return rscStream;
}






var $5Khvr = parcelRequire("5Khvr");
const $b2e5071b25a02cc1$var$msalInstance = new (0, $884tT.PublicClientApplication)((0, $683397ca2eb032d7$export$f6d610d2730cbf1a));
const $b2e5071b25a02cc1$var$container = document.getElementById("root");
/**
 * The Base App component
 */ const $b2e5071b25a02cc1$var$App = ()=>{
    const router = (0, $4Q81F.createBrowserRouter)((0, $5Khvr.routes));
    return /*#__PURE__*/ (0, $bR5nk.jsx)((0, $c65fa4b5e940c52b$export$323e4fc2fa4753fb), {
        router: router
    });
};
$b2e5071b25a02cc1$var$App.displayName = "App";
if ($b2e5071b25a02cc1$var$container) {
    const root = (0, $7ed58da2cf540b72$exports.createRoot)($b2e5071b25a02cc1$var$container);
    root.render(/*#__PURE__*/ (0, $bR5nk.jsx)((0, $dbTcY.MsalProvider), {
        instance: $b2e5071b25a02cc1$var$msalInstance,
        children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $dbTcY.MsalAuthenticationTemplate), {
            interactionType: (0, $884tT.InteractionType).Redirect,
            authenticationRequest: (0, $683397ca2eb032d7$export$be6c432b2463c5eb),
            children: /*#__PURE__*/ (0, $bR5nk.jsx)((0, $fa8ed12783a12027$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $bR5nk.jsx)($b2e5071b25a02cc1$var$App, {})
            })
        })
    }));
}


//# sourceMappingURL=public.9bc58003.js.map
